import * as React from 'react';
import React__default, { createContext, useContext, createElement, useState, useEffect, Fragment, useRef, useCallback, useMemo, forwardRef, useImperativeHandle, useSyncExternalStore, cloneElement, PureComponent, Children, useReducer, useLayoutEffect, useId, isValidElement, version as version$j, Component } from 'react';
import require$$1$1, { EventEmitter as EventEmitter$2 } from 'events';
import { createPortal } from 'react-dom';
import { i18nFactory, Signal } from '@devprotocol/clubs-core';
import { BrowserProvider } from 'ethers';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
  if (Object.prototype.hasOwnProperty.call(n, '__esModule')) return n;
  var f = n.default;
	if (typeof f == "function") {
		var a = function a () {
			if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
			}
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production = {};

/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_production;

function requireReactJsxRuntime_production () {
	if (hasRequiredReactJsxRuntime_production) return reactJsxRuntime_production;
	hasRequiredReactJsxRuntime_production = 1;
	var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
	  REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
	function jsxProd(type, config, maybeKey) {
	  var key = null;
	  void 0 !== maybeKey && (key = "" + maybeKey);
	  void 0 !== config.key && (key = "" + config.key);
	  if ("key" in config) {
	    maybeKey = {};
	    for (var propName in config)
	      "key" !== propName && (maybeKey[propName] = config[propName]);
	  } else maybeKey = config;
	  config = maybeKey.ref;
	  return {
	    $$typeof: REACT_ELEMENT_TYPE,
	    type: type,
	    key: key,
	    ref: void 0 !== config ? config : null,
	    props: maybeKey
	  };
	}
	reactJsxRuntime_production.Fragment = REACT_FRAGMENT_TYPE;
	reactJsxRuntime_production.jsx = jsxProd;
	reactJsxRuntime_production.jsxs = jsxProd;
	return reactJsxRuntime_production;
}

var reactJsxRuntime_development = {};

/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactJsxRuntime_development;

function requireReactJsxRuntime_development () {
	if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
	hasRequiredReactJsxRuntime_development = 1;
	"production" !== process.env.NODE_ENV &&
	  (function () {
	    function getComponentNameFromType(type) {
	      if (null == type) return null;
	      if ("function" === typeof type)
	        return type.$$typeof === REACT_CLIENT_REFERENCE
	          ? null
	          : type.displayName || type.name || null;
	      if ("string" === typeof type) return type;
	      switch (type) {
	        case REACT_FRAGMENT_TYPE:
	          return "Fragment";
	        case REACT_PROFILER_TYPE:
	          return "Profiler";
	        case REACT_STRICT_MODE_TYPE:
	          return "StrictMode";
	        case REACT_SUSPENSE_TYPE:
	          return "Suspense";
	        case REACT_SUSPENSE_LIST_TYPE:
	          return "SuspenseList";
	        case REACT_ACTIVITY_TYPE:
	          return "Activity";
	      }
	      if ("object" === typeof type)
	        switch (
	          ("number" === typeof type.tag &&
	            console.error(
	              "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
	            ),
	          type.$$typeof)
	        ) {
	          case REACT_PORTAL_TYPE:
	            return "Portal";
	          case REACT_CONTEXT_TYPE:
	            return (type.displayName || "Context") + ".Provider";
	          case REACT_CONSUMER_TYPE:
	            return (type._context.displayName || "Context") + ".Consumer";
	          case REACT_FORWARD_REF_TYPE:
	            var innerType = type.render;
	            type = type.displayName;
	            type ||
	              ((type = innerType.displayName || innerType.name || ""),
	              (type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef"));
	            return type;
	          case REACT_MEMO_TYPE:
	            return (
	              (innerType = type.displayName || null),
	              null !== innerType
	                ? innerType
	                : getComponentNameFromType(type.type) || "Memo"
	            );
	          case REACT_LAZY_TYPE:
	            innerType = type._payload;
	            type = type._init;
	            try {
	              return getComponentNameFromType(type(innerType));
	            } catch (x) {}
	        }
	      return null;
	    }
	    function testStringCoercion(value) {
	      return "" + value;
	    }
	    function checkKeyStringCoercion(value) {
	      try {
	        testStringCoercion(value);
	        var JSCompiler_inline_result = !1;
	      } catch (e) {
	        JSCompiler_inline_result = true;
	      }
	      if (JSCompiler_inline_result) {
	        JSCompiler_inline_result = console;
	        var JSCompiler_temp_const = JSCompiler_inline_result.error;
	        var JSCompiler_inline_result$jscomp$0 =
	          ("function" === typeof Symbol &&
	            Symbol.toStringTag &&
	            value[Symbol.toStringTag]) ||
	          value.constructor.name ||
	          "Object";
	        JSCompiler_temp_const.call(
	          JSCompiler_inline_result,
	          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
	          JSCompiler_inline_result$jscomp$0
	        );
	        return testStringCoercion(value);
	      }
	    }
	    function getTaskName(type) {
	      if (type === REACT_FRAGMENT_TYPE) return "<>";
	      if (
	        "object" === typeof type &&
	        null !== type &&
	        type.$$typeof === REACT_LAZY_TYPE
	      )
	        return "<...>";
	      try {
	        var name = getComponentNameFromType(type);
	        return name ? "<" + name + ">" : "<...>";
	      } catch (x) {
	        return "<...>";
	      }
	    }
	    function getOwner() {
	      var dispatcher = ReactSharedInternals.A;
	      return null === dispatcher ? null : dispatcher.getOwner();
	    }
	    function UnknownOwner() {
	      return Error("react-stack-top-frame");
	    }
	    function hasValidKey(config) {
	      if (hasOwnProperty.call(config, "key")) {
	        var getter = Object.getOwnPropertyDescriptor(config, "key").get;
	        if (getter && getter.isReactWarning) return false;
	      }
	      return void 0 !== config.key;
	    }
	    function defineKeyPropWarningGetter(props, displayName) {
	      function warnAboutAccessingKey() {
	        specialPropKeyWarningShown ||
	          ((specialPropKeyWarningShown = true),
	          console.error(
	            "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
	            displayName
	          ));
	      }
	      warnAboutAccessingKey.isReactWarning = true;
	      Object.defineProperty(props, "key", {
	        get: warnAboutAccessingKey,
	        configurable: true
	      });
	    }
	    function elementRefGetterWithDeprecationWarning() {
	      var componentName = getComponentNameFromType(this.type);
	      didWarnAboutElementRef[componentName] ||
	        ((didWarnAboutElementRef[componentName] = true),
	        console.error(
	          "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
	        ));
	      componentName = this.props.ref;
	      return void 0 !== componentName ? componentName : null;
	    }
	    function ReactElement(
	      type,
	      key,
	      self,
	      source,
	      owner,
	      props,
	      debugStack,
	      debugTask
	    ) {
	      self = props.ref;
	      type = {
	        $$typeof: REACT_ELEMENT_TYPE,
	        type: type,
	        key: key,
	        props: props,
	        _owner: owner
	      };
	      null !== (void 0 !== self ? self : null)
	        ? Object.defineProperty(type, "ref", {
	            enumerable: false,
	            get: elementRefGetterWithDeprecationWarning
	          })
	        : Object.defineProperty(type, "ref", { enumerable: false, value: null });
	      type._store = {};
	      Object.defineProperty(type._store, "validated", {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: 0
	      });
	      Object.defineProperty(type, "_debugInfo", {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: null
	      });
	      Object.defineProperty(type, "_debugStack", {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: debugStack
	      });
	      Object.defineProperty(type, "_debugTask", {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: debugTask
	      });
	      Object.freeze && (Object.freeze(type.props), Object.freeze(type));
	      return type;
	    }
	    function jsxDEVImpl(
	      type,
	      config,
	      maybeKey,
	      isStaticChildren,
	      source,
	      self,
	      debugStack,
	      debugTask
	    ) {
	      var children = config.children;
	      if (void 0 !== children)
	        if (isStaticChildren)
	          if (isArrayImpl(children)) {
	            for (
	              isStaticChildren = 0;
	              isStaticChildren < children.length;
	              isStaticChildren++
	            )
	              validateChildKeys(children[isStaticChildren]);
	            Object.freeze && Object.freeze(children);
	          } else
	            console.error(
	              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
	            );
	        else validateChildKeys(children);
	      if (hasOwnProperty.call(config, "key")) {
	        children = getComponentNameFromType(type);
	        var keys = Object.keys(config).filter(function (k) {
	          return "key" !== k;
	        });
	        isStaticChildren =
	          0 < keys.length
	            ? "{key: someKey, " + keys.join(": ..., ") + ": ...}"
	            : "{key: someKey}";
	        didWarnAboutKeySpread[children + isStaticChildren] ||
	          ((keys =
	            0 < keys.length ? "{" + keys.join(": ..., ") + ": ...}" : "{}"),
	          console.error(
	            'A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />',
	            isStaticChildren,
	            children,
	            keys,
	            children
	          ),
	          (didWarnAboutKeySpread[children + isStaticChildren] = true));
	      }
	      children = null;
	      void 0 !== maybeKey &&
	        (checkKeyStringCoercion(maybeKey), (children = "" + maybeKey));
	      hasValidKey(config) &&
	        (checkKeyStringCoercion(config.key), (children = "" + config.key));
	      if ("key" in config) {
	        maybeKey = {};
	        for (var propName in config)
	          "key" !== propName && (maybeKey[propName] = config[propName]);
	      } else maybeKey = config;
	      children &&
	        defineKeyPropWarningGetter(
	          maybeKey,
	          "function" === typeof type
	            ? type.displayName || type.name || "Unknown"
	            : type
	        );
	      return ReactElement(
	        type,
	        children,
	        self,
	        source,
	        getOwner(),
	        maybeKey,
	        debugStack,
	        debugTask
	      );
	    }
	    function validateChildKeys(node) {
	      "object" === typeof node &&
	        null !== node &&
	        node.$$typeof === REACT_ELEMENT_TYPE &&
	        node._store &&
	        (node._store.validated = 1);
	    }
	    var React = React__default,
	      REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"),
	      REACT_PORTAL_TYPE = Symbol.for("react.portal"),
	      REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"),
	      REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"),
	      REACT_PROFILER_TYPE = Symbol.for("react.profiler");
	    var REACT_CONSUMER_TYPE = Symbol.for("react.consumer"),
	      REACT_CONTEXT_TYPE = Symbol.for("react.context"),
	      REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"),
	      REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"),
	      REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"),
	      REACT_MEMO_TYPE = Symbol.for("react.memo"),
	      REACT_LAZY_TYPE = Symbol.for("react.lazy"),
	      REACT_ACTIVITY_TYPE = Symbol.for("react.activity"),
	      REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"),
	      ReactSharedInternals =
	        React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE,
	      hasOwnProperty = Object.prototype.hasOwnProperty,
	      isArrayImpl = Array.isArray,
	      createTask = console.createTask
	        ? console.createTask
	        : function () {
	            return null;
	          };
	    React = {
	      "react-stack-bottom-frame": function (callStackForError) {
	        return callStackForError();
	      }
	    };
	    var specialPropKeyWarningShown;
	    var didWarnAboutElementRef = {};
	    var unknownOwnerDebugStack = React["react-stack-bottom-frame"].bind(
	      React,
	      UnknownOwner
	    )();
	    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
	    var didWarnAboutKeySpread = {};
	    reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
	    reactJsxRuntime_development.jsx = function (type, config, maybeKey, source, self) {
	      var trackActualOwner =
	        1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
	      return jsxDEVImpl(
	        type,
	        config,
	        maybeKey,
	        false,
	        source,
	        self,
	        trackActualOwner
	          ? Error("react-stack-top-frame")
	          : unknownOwnerDebugStack,
	        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
	      );
	    };
	    reactJsxRuntime_development.jsxs = function (type, config, maybeKey, source, self) {
	      var trackActualOwner =
	        1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
	      return jsxDEVImpl(
	        type,
	        config,
	        maybeKey,
	        true,
	        source,
	        self,
	        trackActualOwner
	          ? Error("react-stack-top-frame")
	          : unknownOwnerDebugStack,
	        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
	      );
	    };
	  })();
	return reactJsxRuntime_development;
}

var hasRequiredJsxRuntime;

function requireJsxRuntime () {
	if (hasRequiredJsxRuntime) return jsxRuntime.exports;
	hasRequiredJsxRuntime = 1;

	if (process.env.NODE_ENV === 'production') {
	  jsxRuntime.exports = requireReactJsxRuntime_production();
	} else {
	  jsxRuntime.exports = requireReactJsxRuntime_development();
	}
	return jsxRuntime.exports;
}

var jsxRuntimeExports = requireJsxRuntime();

// @dynamic-labs/iconic, a package what @dynamic-labs/sdk-react-core is required, is requiring `process` on the frontend.
// eslint-disable-next-line functional/no-conditional-statements
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
    window.process = { env: {} };
}

/**
 * A function that always returns `true`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.F
 * @example
 *
 *      R.T(); //=> true
 */
var T$3 = function () {
  return true;
};

function _isPlaceholder$1(a) {
  return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry1$1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder$1(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}

/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry2$1(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;

      case 1:
        return _isPlaceholder$1(a) ? f2 : _curry1$1(function (_b) {
          return fn(a, _b);
        });

      default:
        return _isPlaceholder$1(a) && _isPlaceholder$1(b) ? f2 : _isPlaceholder$1(a) ? _curry1$1(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder$1(b) ? _curry1$1(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}

/**
 * Private `concat` function to merge two array-like objects.
 *
 * @private
 * @param {Array|Arguments} [set1=[]] An array-like object.
 * @param {Array|Arguments} [set2=[]] An array-like object.
 * @return {Array} A new, merged array.
 * @example
 *
 *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
 */
function _concat(set1, set2) {
  set1 = set1 || [];
  set2 = set2 || [];
  var idx;
  var len1 = set1.length;
  var len2 = set2.length;
  var result = [];
  idx = 0;

  while (idx < len1) {
    result[result.length] = set1[idx];
    idx += 1;
  }

  idx = 0;

  while (idx < len2) {
    result[result.length] = set2[idx];
    idx += 1;
  }

  return result;
}

function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };

    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };

    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };

    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };

    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };

    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };

    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };

    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };

    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };

    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };

    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };

    default:
      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
}

/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curryN(length, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    var hasPlaceholder = false;

    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;

      if (combinedIdx < received.length && (!_isPlaceholder$1(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }

      combined[combinedIdx] = result;

      if (!_isPlaceholder$1(result)) {
        left -= 1;
      } else {
        hasPlaceholder = true;
      }

      combinedIdx += 1;
    }

    return !hasPlaceholder && left <= 0 ? fn.apply(this, combined) : _arity(Math.max(0, left), _curryN(length, combined, fn));
  };
}

/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */

var curryN =
/*#__PURE__*/
_curry2$1(function curryN(length, fn) {
  if (length === 1) {
    return _curry1$1(fn);
  }

  return _arity(length, _curryN(length, [], fn));
});

/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;

      case 1:
        return _isPlaceholder$1(a) ? f3 : _curry2$1(function (_b, _c) {
          return fn(a, _b, _c);
        });

      case 2:
        return _isPlaceholder$1(a) && _isPlaceholder$1(b) ? f3 : _isPlaceholder$1(a) ? _curry2$1(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder$1(b) ? _curry2$1(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _curry1$1(function (_c) {
          return fn(a, b, _c);
        });

      default:
        return _isPlaceholder$1(a) && _isPlaceholder$1(b) && _isPlaceholder$1(c) ? f3 : _isPlaceholder$1(a) && _isPlaceholder$1(b) ? _curry2$1(function (_a, _b) {
          return fn(_a, _b, c);
        }) : _isPlaceholder$1(a) && _isPlaceholder$1(c) ? _curry2$1(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder$1(b) && _isPlaceholder$1(c) ? _curry2$1(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _isPlaceholder$1(a) ? _curry1$1(function (_a) {
          return fn(_a, b, c);
        }) : _isPlaceholder$1(b) ? _curry1$1(function (_b) {
          return fn(a, _b, c);
        }) : _isPlaceholder$1(c) ? _curry1$1(function (_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
var _isArray = Array.isArray || function _isArray(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};

function _isTransformer(obj) {
  return obj != null && typeof obj['@@transducer/step'] === 'function';
}

/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer created by [transducerCreator] to return a new transformer
 * (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} transducerCreator transducer factory if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */

function _dispatchable(methodNames, transducerCreator, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }

    var obj = arguments[arguments.length - 1];

    if (!_isArray(obj)) {
      var idx = 0;

      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
        }

        idx += 1;
      }

      if (_isTransformer(obj)) {
        var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return transducer(obj);
      }
    }

    return fn.apply(this, arguments);
  };
}

var _xfBase = {
  init: function () {
    return this.xf['@@transducer/init']();
  },
  result: function (result) {
    return this.xf['@@transducer/result'](result);
  }
};

function _arrayFromIterator$1(iter) {
  var list = [];
  var next;

  while (!(next = iter.next()).done) {
    list.push(next.value);
  }

  return list;
}

function _includesWith$1(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }

    idx += 1;
  }

  return false;
}

function _functionName$1(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}

function _has$1(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function _objectIs$2(a, b) {
  // SameValue algorithm
  if (a === b) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
}

var _objectIs$3 = typeof Object.is === 'function' ? Object.is : _objectIs$2;

var toString$6 = Object.prototype.toString;

var _isArguments$1 =
/*#__PURE__*/
function () {
  return toString$6.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString$6.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return _has$1('callee', x);
  };
}();

var hasEnumBug$1 = !
/*#__PURE__*/
{
  toString: null
}.propertyIsEnumerable('toString');
var nonEnumerableProps$1 = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString']; // Safari bug

var hasArgsEnumBug$1 =
/*#__PURE__*/
function () {

  return arguments.propertyIsEnumerable('length');
}();

var contains$2 = function contains(list, item) {
  var idx = 0;

  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }

    idx += 1;
  }

  return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */


var keys$3 = typeof Object.keys === 'function' && !hasArgsEnumBug$1 ?
/*#__PURE__*/
_curry1$1(function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
}) :
/*#__PURE__*/
_curry1$1(function keys(obj) {
  if (Object(obj) !== obj) {
    return [];
  }

  var prop, nIdx;
  var ks = [];

  var checkArgsLength = hasArgsEnumBug$1 && _isArguments$1(obj);

  for (prop in obj) {
    if (_has$1(prop, obj) && (!checkArgsLength || prop !== 'length')) {
      ks[ks.length] = prop;
    }
  }

  if (hasEnumBug$1) {
    nIdx = nonEnumerableProps$1.length - 1;

    while (nIdx >= 0) {
      prop = nonEnumerableProps$1[nIdx];

      if (_has$1(prop, obj) && !contains$2(ks, prop)) {
        ks[ks.length] = prop;
      }

      nIdx -= 1;
    }
  }

  return ks;
});

/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig * -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(async () => {}); //=> "AsyncFunction"
 *      R.type(undefined); //=> "Undefined"
 */

var type$1 =
/*#__PURE__*/
_curry1$1(function type(val) {
  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});

/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparison of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */

function _uniqContentEquals$1(aIterator, bIterator, stackA, stackB) {
  var a = _arrayFromIterator$1(aIterator);

  var b = _arrayFromIterator$1(bIterator);

  function eq(_a, _b) {
    return _equals$1(_a, _b, stackA.slice(), stackB.slice());
  } // if *a* array contains any element that is not included in *b*


  return !_includesWith$1(function (b, aItem) {
    return !_includesWith$1(eq, aItem, b);
  }, b, a);
}

function _equals$1(a, b, stackA, stackB) {
  if (_objectIs$3(a, b)) {
    return true;
  }

  var typeA = type$1(a);

  if (typeA !== type$1(b)) {
    return false;
  }

  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }

  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
  }

  switch (typeA) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' && _functionName$1(a.constructor) === 'Promise') {
        return a === b;
      }

      break;

    case 'Boolean':
    case 'Number':
    case 'String':
      if (!(typeof a === typeof b && _objectIs$3(a.valueOf(), b.valueOf()))) {
        return false;
      }

      break;

    case 'Date':
      if (!_objectIs$3(a.valueOf(), b.valueOf())) {
        return false;
      }

      break;

    case 'Error':
      return a.name === b.name && a.message === b.message;

    case 'RegExp':
      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
        return false;
      }

      break;
  }

  var idx = stackA.length - 1;

  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }

    idx -= 1;
  }

  switch (typeA) {
    case 'Map':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals$1(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));

    case 'Set':
      if (a.size !== b.size) {
        return false;
      }

      return _uniqContentEquals$1(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));

    case 'Arguments':
    case 'Array':
    case 'Object':
    case 'Boolean':
    case 'Number':
    case 'String':
    case 'Date':
    case 'Error':
    case 'RegExp':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'ArrayBuffer':
      break;

    default:
      // Values of other types are only equal if identical.
      return false;
  }

  var keysA = keys$3(a);

  if (keysA.length !== keys$3(b).length) {
    return false;
  }

  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b]);
  idx = keysA.length - 1;

  while (idx >= 0) {
    var key = keysA[idx];

    if (!(_has$1(key, b) && _equals$1(b[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }

    idx -= 1;
  }

  return true;
}

/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */

var equals$1 =
/*#__PURE__*/
_curry2$1(function equals(a, b) {
  return _equals$1(a, b, [], []);
});

function _indexOf(list, a, idx) {
  var inf, item; // Array.prototype.indexOf doesn't exist below IE9

  if (typeof list.indexOf === 'function') {
    switch (typeof a) {
      case 'number':
        if (a === 0) {
          // manually crawl the list to distinguish between +0 and -0
          inf = 1 / a;

          while (idx < list.length) {
            item = list[idx];

            if (item === 0 && 1 / item === inf) {
              return idx;
            }

            idx += 1;
          }

          return -1;
        } else if (a !== a) {
          // NaN
          while (idx < list.length) {
            item = list[idx];

            if (typeof item === 'number' && item !== item) {
              return idx;
            }

            idx += 1;
          }

          return -1;
        } // non-zero numbers can utilise Set


        return list.indexOf(a, idx);
      // all these types can utilise Set

      case 'string':
      case 'boolean':
      case 'function':
      case 'undefined':
        return list.indexOf(a, idx);

      case 'object':
        if (a === null) {
          // null can utilise Set
          return list.indexOf(a, idx);
        }

    }
  } // anything else not covered above, defer to R.equals


  while (idx < list.length) {
    if (equals$1(list[idx], a)) {
      return idx;
    }

    idx += 1;
  }

  return -1;
}

function _includes(a, list) {
  return _indexOf(list, a, 0) >= 0;
}

function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);

  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }

  return result;
}

function _quote(s) {
  var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
  .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
  return '"' + escaped.replace(/"/g, '\\"') + '"';
}

/**
 * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
 */
var pad$2 = function pad(n) {
  return (n < 10 ? '0' : '') + n;
};

var _toISOString = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
  return d.toISOString();
} : function _toISOString(d) {
  return d.getUTCFullYear() + '-' + pad$2(d.getUTCMonth() + 1) + '-' + pad$2(d.getUTCDate()) + 'T' + pad$2(d.getUTCHours()) + ':' + pad$2(d.getUTCMinutes()) + ':' + pad$2(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
};

function _complement(f) {
  return function () {
    return !f.apply(this, arguments);
  };
}

function _arrayReduce$1(reducer, acc, list) {
  var index = 0;
  var length = list.length;

  while (index < length) {
    acc = reducer(acc, list[index]);
    index += 1;
  }

  return acc;
}

function _filter(fn, list) {
  var idx = 0;
  var len = list.length;
  var result = [];

  while (idx < len) {
    if (fn(list[idx])) {
      result[result.length] = list[idx];
    }

    idx += 1;
  }

  return result;
}

function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}

var XFilter =
/*#__PURE__*/
function () {
  function XFilter(f, xf) {
    this.xf = xf;
    this.f = f;
  }

  XFilter.prototype['@@transducer/init'] = _xfBase.init;
  XFilter.prototype['@@transducer/result'] = _xfBase.result;

  XFilter.prototype['@@transducer/step'] = function (result, input) {
    return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
  };

  return XFilter;
}();

function _xfilter(f) {
  return function (xf) {
    return new XFilter(f, xf);
  };
}

/**
 * Takes a predicate and a `Filterable`, and returns a new filterable of the
 * same type containing the members of the given filterable which satisfy the
 * given predicate. Filterable objects include plain objects or any object
 * that has a filter method such as `Array`.
 *
 * Dispatches to the `filter` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @category Object
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array} Filterable
 * @see R.reject, R.transduce, R.addIndex
 * @example
 *
 *      const isEven = n => n % 2 === 0;
 *
 *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */

var filter =
/*#__PURE__*/
_curry2$1(
/*#__PURE__*/
_dispatchable(['fantasy-land/filter', 'filter'], _xfilter, function (pred, filterable) {
  return _isObject(filterable) ? _arrayReduce$1(function (acc, key) {
    if (pred(filterable[key])) {
      acc[key] = filterable[key];
    }

    return acc;
  }, {}, keys$3(filterable)) : // else
  _filter(pred, filterable);
}));

/**
 * The complement of [`filter`](#filter).
 *
 * Acts as a transducer if a transformer is given in list position. Filterable
 * objects include plain objects or any object that has a filter method such
 * as `Array`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Filterable f => (a -> Boolean) -> f a -> f a
 * @param {Function} pred
 * @param {Array} filterable
 * @return {Array}
 * @see R.filter, R.transduce, R.addIndex
 * @example
 *
 *      const isOdd = (n) => n % 2 !== 0;
 *
 *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
 *
 *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
 */

var reject =
/*#__PURE__*/
_curry2$1(function reject(pred, filterable) {
  return filter(_complement(pred), filterable);
});

function _toString(x, seen) {
  var recur = function recur(y) {
    var xs = seen.concat([x]);
    return _includes(y, xs) ? '<Circular>' : _toString(y, xs);
  }; //  mapPairs :: (Object, [String]) -> [String]


  var mapPairs = function (obj, keys) {
    return _map(function (k) {
      return _quote(k) + ': ' + recur(obj[k]);
    }, keys.slice().sort());
  };

  switch (Object.prototype.toString.call(x)) {
    case '[object Arguments]':
      return '(function() { return arguments; }(' + _map(recur, x).join(', ') + '))';

    case '[object Array]':
      return '[' + _map(recur, x).concat(mapPairs(x, reject(function (k) {
        return /^\d+$/.test(k);
      }, keys$3(x)))).join(', ') + ']';

    case '[object Boolean]':
      return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();

    case '[object Date]':
      return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';

    case '[object Map]':
      return 'new Map(' + recur(Array.from(x)) + ')';

    case '[object Null]':
      return 'null';

    case '[object Number]':
      return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);

    case '[object Set]':
      return 'new Set(' + recur(Array.from(x).sort()) + ')';

    case '[object String]':
      return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);

    case '[object Undefined]':
      return 'undefined';

    default:
      if (typeof x.toString === 'function') {
        var repr = x.toString();

        if (repr !== '[object Object]') {
          return repr;
        }
      }

      return '{' + mapPairs(x, keys$3(x)).join(', ') + '}';
  }
}

/**
 * Returns the string representation of the given value. `eval`'ing the output
 * should result in a value equivalent to the input value. Many of the built-in
 * `toString` methods do not satisfy this requirement.
 *
 * If the given value is an `[object Object]` with a `toString` method other
 * than `Object.prototype.toString`, this method is invoked with no arguments
 * to produce the return value. This means user-defined constructor functions
 * can provide a suitable `toString` method. For example:
 *
 *     function Point(x, y) {
 *       this.x = x;
 *       this.y = y;
 *     }
 *
 *     Point.prototype.toString = function() {
 *       return 'new Point(' + this.x + ', ' + this.y + ')';
 *     };
 *
 *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category String
 * @sig * -> String
 * @param {*} val
 * @return {String}
 * @example
 *
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> '"abc"'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */

var toString$5 =
/*#__PURE__*/
_curry1$1(function toString(val) {
  return _toString(val, []);
});

/**
 * Returns the larger of its two arguments.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig Ord a => a -> a -> a
 * @param {*} a
 * @param {*} b
 * @return {*}
 * @see R.maxBy, R.min
 * @example
 *
 *      R.max(789, 123); //=> 789
 *      R.max('a', 'b'); //=> 'b'
 */

var max =
/*#__PURE__*/
_curry2$1(function max(a, b) {
  if (a === b) {
    return b;
  }

  function safeMax(x, y) {
    if (x > y !== y > x) {
      return y > x ? y : x;
    }

    return undefined;
  }

  var maxByValue = safeMax(a, b);

  if (maxByValue !== undefined) {
    return maxByValue;
  }

  var maxByType = safeMax(typeof a, typeof b);

  if (maxByType !== undefined) {
    return maxByType === typeof a ? a : b;
  }

  var stringA = toString$5(a);
  var maxByStringValue = safeMax(stringA, toString$5(b));

  if (maxByStringValue !== undefined) {
    return maxByStringValue === stringA ? a : b;
  }

  return b;
});

var XMap =
/*#__PURE__*/
function () {
  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }

  XMap.prototype['@@transducer/init'] = _xfBase.init;
  XMap.prototype['@@transducer/result'] = _xfBase.result;

  XMap.prototype['@@transducer/step'] = function (result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };

  return XMap;
}();

var _xmap = function _xmap(f) {
  return function (xf) {
    return new XMap(f, xf);
  };
};

/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */

var map$1 =
/*#__PURE__*/
_curry2$1(
/*#__PURE__*/
_dispatchable(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return curryN(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });

    case '[object Object]':
      return _arrayReduce$1(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, keys$3(functor));

    default:
      return _map(fn, functor);
  }
}));

function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}

/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */

var _isArrayLike =
/*#__PURE__*/
_curry1$1(function isArrayLike(x) {
  if (_isArray(x)) {
    return true;
  }

  if (!x) {
    return false;
  }

  if (typeof x !== 'object') {
    return false;
  }

  if (_isString(x)) {
    return false;
  }

  if (x.length === 0) {
    return true;
  }

  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }

  return false;
});

var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
function _createReduce(arrayReduce, methodReduce, iterableReduce) {
  return function _reduce(xf, acc, list) {
    if (_isArrayLike(list)) {
      return arrayReduce(xf, acc, list);
    }

    if (list == null) {
      return acc;
    }

    if (typeof list['fantasy-land/reduce'] === 'function') {
      return methodReduce(xf, acc, list, 'fantasy-land/reduce');
    }

    if (list[symIterator] != null) {
      return iterableReduce(xf, acc, list[symIterator]());
    }

    if (typeof list.next === 'function') {
      return iterableReduce(xf, acc, list);
    }

    if (typeof list.reduce === 'function') {
      return methodReduce(xf, acc, list, 'reduce');
    }

    throw new TypeError('reduce: list must be array or iterable');
  };
}

function _xArrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    acc = xf['@@transducer/step'](acc, list[idx]);

    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }

    idx += 1;
  }

  return xf['@@transducer/result'](acc);
}

/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */

var bind =
/*#__PURE__*/
_curry2$1(function bind(fn, thisObj) {
  return _arity(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});

function _xIterableReduce(xf, acc, iter) {
  var step = iter.next();

  while (!step.done) {
    acc = xf['@@transducer/step'](acc, step.value);

    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }

    step = iter.next();
  }

  return xf['@@transducer/result'](acc);
}

function _xMethodReduce(xf, acc, obj, methodName) {
  return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
}

var _xReduce =
/*#__PURE__*/
_createReduce(_xArrayReduce, _xMethodReduce, _xIterableReduce);

var XWrap =
/*#__PURE__*/
function () {
  function XWrap(fn) {
    this.f = fn;
  }

  XWrap.prototype['@@transducer/init'] = function () {
    throw new Error('init not implemented on XWrap');
  };

  XWrap.prototype['@@transducer/result'] = function (acc) {
    return acc;
  };

  XWrap.prototype['@@transducer/step'] = function (acc, x) {
    return this.f(acc, x);
  };

  return XWrap;
}();

function _xwrap(fn) {
  return new XWrap(fn);
}

/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Be cautious of mutating and returning the accumulator. If you reuse it across
 * invocations, it will continue to accumulate onto the same value. The general
 * recommendation is to always return a new value. If you can't do so for
 * performance reasons, then be sure to reinitialize the accumulator on each
 * invocation.
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */

var reduce =
/*#__PURE__*/
_curry3(function (xf, acc, list) {
  return _xReduce(typeof xf === 'function' ? _xwrap(xf) : xf, acc, list);
});

/**
 * Returns a function that always returns the given value. Note that for
 * non-primitives the value returned is a reference to the original value.
 *
 * This function is known as `const`, `constant`, or `K` (for K combinator) in
 * other languages and libraries.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig a -> (* -> a)
 * @param {*} val The value to wrap in a function
 * @return {Function} A Function :: * -> val.
 * @example
 *
 *      const t = R.always('Tee');
 *      t(); //=> 'Tee'
 */

var always =
/*#__PURE__*/
_curry1$1(function always(val) {
  return function () {
    return val;
  };
});

function _iterableReduce(reducer, acc, iter) {
  var step = iter.next();

  while (!step.done) {
    acc = reducer(acc, step.value);
    step = iter.next();
  }

  return acc;
}

function _methodReduce(reducer, acc, obj, methodName) {
  return obj[methodName](reducer, acc);
}

var _reduce =
/*#__PURE__*/
_createReduce(_arrayReduce$1, _methodReduce, _iterableReduce);

/**
 * ap applies a list of functions to a list of values.
 *
 * Dispatches to the `ap` method of the first argument, if present. Also
 * treats curried functions as applicatives.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig [a -> b] -> [a] -> [b]
 * @sig Apply f => f (a -> b) -> f a -> f b
 * @sig (r -> a -> b) -> (r -> a) -> (r -> b)
 * @param {*} applyF
 * @param {*} applyX
 * @return {*}
 * @example
 *
 *      R.ap([R.multiply(2), R.add(3)], [1,2,3]); //=> [2, 4, 6, 4, 5, 6]
 *      R.ap([R.concat('tasty '), R.toUpper], ['pizza', 'salad']); //=> ["tasty pizza", "tasty salad", "PIZZA", "SALAD"]
 *
 *      // R.ap can also be used as S combinator
 *      // when only two functions are passed
 *      R.ap(R.concat, R.toUpper)('Ramda') //=> 'RamdaRAMDA'
 * @symb R.ap([f, g], [a, b]) = [f(a), f(b), g(a), g(b)]
 */

var ap =
/*#__PURE__*/
_curry2$1(function ap(applyF, applyX) {
  return typeof applyX['fantasy-land/ap'] === 'function' ? applyX['fantasy-land/ap'](applyF) : typeof applyF.ap === 'function' ? applyF.ap(applyX) : typeof applyF === 'function' ? function (x) {
    return applyF(x)(applyX(x));
  } : _reduce(function (acc, f) {
    return _concat(acc, map$1(f, applyX));
  }, [], applyF);
});

/**
 * Checks if the input value is `null` or `undefined`.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Type
 * @sig * -> Boolean
 * @param {*} x The value to test.
 * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
 * @example
 *
 *      R.isNil(null); //=> true
 *      R.isNil(undefined); //=> true
 *      R.isNil(0); //=> false
 *      R.isNil([]); //=> false
 */

var isNil =
/*#__PURE__*/
_curry1$1(function isNil(x) {
  return x == null;
});

/**
 * "lifts" a function to be the specified arity, so that it may "map over" that
 * many lists, Functions or other objects that satisfy the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig Number -> (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.lift, R.ap
 * @example
 *
 *      const madd3 = R.liftN(3, (...args) => R.sum(args));
 *      madd3([1,2,3], [1,2,3], [1]); //=> [3, 4, 5, 4, 5, 6, 5, 6, 7]
 */

var liftN =
/*#__PURE__*/
_curry2$1(function liftN(arity, fn) {
  var lifted = curryN(arity, fn);
  return curryN(arity, function () {
    return _arrayReduce$1(ap, map$1(lifted, arguments[0]), Array.prototype.slice.call(arguments, 1));
  });
});

/**
 * "lifts" a function of arity >= 1 so that it may "map over" a list, Function or other
 * object that satisfies the [FantasyLand Apply spec](https://github.com/fantasyland/fantasy-land#apply).
 *
 * @func
 * @memberOf R
 * @since v0.7.0
 * @category Function
 * @sig (*... -> *) -> ([*]... -> [*])
 * @param {Function} fn The function to lift into higher context
 * @return {Function} The lifted function.
 * @see R.liftN
 * @example
 *
 *      const madd3 = R.lift((a, b, c) => a + b + c);
 *
 *      madd3([100, 200], [30, 40], [5, 6, 7]); //=> [135, 136, 137, 145, 146, 147, 235, 236, 237, 245, 246, 247]
 *
 *      const madd5 = R.lift((a, b, c, d, e) => a + b + c + d + e);
 *
 *      madd5([10, 20], [1], [2, 3], [4], [100, 200]); //=> [117, 217, 118, 218, 127, 227, 128, 228]
 */

var lift =
/*#__PURE__*/
_curry1$1(function lift(fn) {
  return liftN(fn.length, fn);
});

/**
 * A function that returns the `!` of its argument. It will return `true` when
 * passed false-y value, and `false` when passed a truth-y one.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig * -> Boolean
 * @param {*} a any value
 * @return {Boolean} the logical inverse of passed argument.
 * @see R.complement
 * @example
 *
 *      R.not(true); //=> false
 *      R.not(false); //=> true
 *      R.not(0); //=> true
 *      R.not(1); //=> false
 */

var not =
/*#__PURE__*/
_curry1$1(function not(a) {
  return !a;
});

/**
 * Takes a function `f` and returns a function `g` such that if called with the same arguments
 * when `f` returns a "truthy" value, `g` returns `false` and when `f` returns a "falsy" value `g` returns `true`.
 *
 * `R.complement` may be applied to any functor
 *
 * @func
 * @memberOf R
 * @since v0.12.0
 * @category Logic
 * @sig (*... -> *) -> (*... -> Boolean)
 * @param {Function} f
 * @return {Function}
 * @see R.not
 * @example
 *
 *      const isNotNil = R.complement(R.isNil);
 *      R.isNil(null); //=> true
 *      isNotNil(null); //=> false
 *      R.isNil(7); //=> false
 *      isNotNil(7); //=> true
 */

var complement =
/*#__PURE__*/
lift(not);

/**
 * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
 * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
 * to `fn` are applied to each of the predicates in turn until one returns a
 * "truthy" value, at which point `fn` returns the result of applying its
 * arguments to the corresponding transformer. If none of the predicates
 * matches, `fn` returns undefined.
 *
 * **Please note**: This is not a direct substitute for a `switch` statement.
 * Remember that both elements of every pair passed to `cond` are *functions*,
 * and `cond` returns a function.
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Logic
 * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
 * @param {Array} pairs A list of [predicate, transformer]
 * @return {Function}
 * @see R.ifElse, R.unless, R.when
 * @example
 *
 *      const fn = R.cond([
 *        [R.equals(0),   R.always('water freezes at 0°C')],
 *        [R.equals(100), R.always('water boils at 100°C')],
 *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
 *      ]);
 *      fn(0); //=> 'water freezes at 0°C'
 *      fn(50); //=> 'nothing special happens at 50°C'
 *      fn(100); //=> 'water boils at 100°C'
 */

var cond =
/*#__PURE__*/
_curry1$1(function cond(pairs) {
  var arity = reduce(max, 0, map$1(function (pair) {
    return pair[0].length;
  }, pairs));
  return _arity(arity, function () {
    var idx = 0;

    while (idx < pairs.length) {
      if (pairs[idx][0].apply(this, arguments)) {
        return pairs[idx][1].apply(this, arguments);
      }

      idx += 1;
    }
  });
});

const isNotNil = (t) => complement(isNil)(t);

const whenDefined = (depends, fn) => cond([
    [isNil, always(undefined)],
    [T$3, (deps) => fn(deps)],
])(depends);

const passAll$1 = (depends) => depends instanceof Array ? depends.every(isNotNil) : isNotNil(depends);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function whenDefinedAll(depends, fn) {
    return whenDefined(depends, cond([
        [passAll$1, (deps) => fn(deps)],
        [T$3, always(undefined)],
    ]));
}

var buffer$1 = {};

var base64Js = {};

var hasRequiredBase64Js;

function requireBase64Js () {
	if (hasRequiredBase64Js) return base64Js;
	hasRequiredBase64Js = 1;

	base64Js.byteLength = byteLength;
	base64Js.toByteArray = toByteArray;
	base64Js.fromByteArray = fromByteArray;

	var lookup = [];
	var revLookup = [];
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;

	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i];
	  revLookup[code.charCodeAt(i)] = i;
	}

	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62;
	revLookup['_'.charCodeAt(0)] = 63;

	function getLens (b64) {
	  var len = b64.length;

	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }

	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=');
	  if (validLen === -1) validLen = len;

	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4);

	  return [validLen, placeHoldersLen]
	}

	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64);
	  var validLen = lens[0];
	  var placeHoldersLen = lens[1];
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}

	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}

	function toByteArray (b64) {
	  var tmp;
	  var lens = getLens(b64);
	  var validLen = lens[0];
	  var placeHoldersLen = lens[1];

	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));

	  var curByte = 0;

	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen;

	  var i;
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)];
	    arr[curByte++] = (tmp >> 16) & 0xFF;
	    arr[curByte++] = (tmp >> 8) & 0xFF;
	    arr[curByte++] = tmp & 0xFF;
	  }

	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4);
	    arr[curByte++] = tmp & 0xFF;
	  }

	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2);
	    arr[curByte++] = (tmp >> 8) & 0xFF;
	    arr[curByte++] = tmp & 0xFF;
	  }

	  return arr
	}

	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}

	function encodeChunk (uint8, start, end) {
	  var tmp;
	  var output = [];
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF);
	    output.push(tripletToBase64(tmp));
	  }
	  return output.join('')
	}

	function fromByteArray (uint8) {
	  var tmp;
	  var len = uint8.length;
	  var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
	  var parts = [];
	  var maxChunkLength = 16383; // must be multiple of 3

	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)));
	  }

	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1];
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    );
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    );
	  }

	  return parts.join('')
	}
	return base64Js;
}

var ieee754 = {};

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */

var hasRequiredIeee754;

function requireIeee754 () {
	if (hasRequiredIeee754) return ieee754;
	hasRequiredIeee754 = 1;
	ieee754.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m;
	  var eLen = (nBytes * 8) - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = -7;
	  var i = isLE ? (nBytes - 1) : 0;
	  var d = isLE ? -1 : 1;
	  var s = buffer[offset + i];

	  i += d;

	  e = s & ((1 << (-nBits)) - 1);
	  s >>= (-nBits);
	  nBits += eLen;
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

	  m = e & ((1 << (-nBits)) - 1);
	  e >>= (-nBits);
	  nBits += mLen;
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen);
	    e = e - eBias;
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	};

	ieee754.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c;
	  var eLen = (nBytes * 8) - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0);
	  var i = isLE ? 0 : (nBytes - 1);
	  var d = isLE ? 1 : -1;
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;

	  value = Math.abs(value);

	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0;
	    e = eMax;
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2);
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * Math.pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }

	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
	      e = 0;
	    }
	  }

	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

	  e = (e << mLen) | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

	  buffer[offset + i - d] |= s * 128;
	};
	return ieee754;
}

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

var hasRequiredBuffer;

function requireBuffer () {
	if (hasRequiredBuffer) return buffer$1;
	hasRequiredBuffer = 1;
	(function (exports) {

		const base64 = requireBase64Js();
		const ieee754 = requireIeee754();
		const customInspectSymbol =
		  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
		    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
		    : null;

		exports.Buffer = Buffer;
		exports.SlowBuffer = SlowBuffer;
		exports.INSPECT_MAX_BYTES = 50;

		const K_MAX_LENGTH = 0x7fffffff;
		exports.kMaxLength = K_MAX_LENGTH;

		/**
		 * If `Buffer.TYPED_ARRAY_SUPPORT`:
		 *   === true    Use Uint8Array implementation (fastest)
		 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
		 *               implementation (most compatible, even IE6)
		 *
		 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
		 * Opera 11.6+, iOS 4.2+.
		 *
		 * We report that the browser does not support typed arrays if the are not subclassable
		 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
		 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
		 * for __proto__ and has a buggy typed array implementation.
		 */
		Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();

		if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
		    typeof console.error === 'function') {
		  console.error(
		    'This browser lacks typed array (Uint8Array) support which is required by ' +
		    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
		  );
		}

		function typedArraySupport () {
		  // Can typed array instances can be augmented?
		  try {
		    const arr = new Uint8Array(1);
		    const proto = { foo: function () { return 42 } };
		    Object.setPrototypeOf(proto, Uint8Array.prototype);
		    Object.setPrototypeOf(arr, proto);
		    return arr.foo() === 42
		  } catch (e) {
		    return false
		  }
		}

		Object.defineProperty(Buffer.prototype, 'parent', {
		  enumerable: true,
		  get: function () {
		    if (!Buffer.isBuffer(this)) return undefined
		    return this.buffer
		  }
		});

		Object.defineProperty(Buffer.prototype, 'offset', {
		  enumerable: true,
		  get: function () {
		    if (!Buffer.isBuffer(this)) return undefined
		    return this.byteOffset
		  }
		});

		function createBuffer (length) {
		  if (length > K_MAX_LENGTH) {
		    throw new RangeError('The value "' + length + '" is invalid for option "size"')
		  }
		  // Return an augmented `Uint8Array` instance
		  const buf = new Uint8Array(length);
		  Object.setPrototypeOf(buf, Buffer.prototype);
		  return buf
		}

		/**
		 * The Buffer constructor returns instances of `Uint8Array` that have their
		 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
		 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
		 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
		 * returns a single octet.
		 *
		 * The `Uint8Array` prototype remains unmodified.
		 */

		function Buffer (arg, encodingOrOffset, length) {
		  // Common case.
		  if (typeof arg === 'number') {
		    if (typeof encodingOrOffset === 'string') {
		      throw new TypeError(
		        'The "string" argument must be of type string. Received type number'
		      )
		    }
		    return allocUnsafe(arg)
		  }
		  return from(arg, encodingOrOffset, length)
		}

		Buffer.poolSize = 8192; // not used by this implementation

		function from (value, encodingOrOffset, length) {
		  if (typeof value === 'string') {
		    return fromString(value, encodingOrOffset)
		  }

		  if (ArrayBuffer.isView(value)) {
		    return fromArrayView(value)
		  }

		  if (value == null) {
		    throw new TypeError(
		      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
		      'or Array-like Object. Received type ' + (typeof value)
		    )
		  }

		  if (isInstance(value, ArrayBuffer) ||
		      (value && isInstance(value.buffer, ArrayBuffer))) {
		    return fromArrayBuffer(value, encodingOrOffset, length)
		  }

		  if (typeof SharedArrayBuffer !== 'undefined' &&
		      (isInstance(value, SharedArrayBuffer) ||
		      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
		    return fromArrayBuffer(value, encodingOrOffset, length)
		  }

		  if (typeof value === 'number') {
		    throw new TypeError(
		      'The "value" argument must not be of type number. Received type number'
		    )
		  }

		  const valueOf = value.valueOf && value.valueOf();
		  if (valueOf != null && valueOf !== value) {
		    return Buffer.from(valueOf, encodingOrOffset, length)
		  }

		  const b = fromObject(value);
		  if (b) return b

		  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
		      typeof value[Symbol.toPrimitive] === 'function') {
		    return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length)
		  }

		  throw new TypeError(
		    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
		    'or Array-like Object. Received type ' + (typeof value)
		  )
		}

		/**
		 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
		 * if value is a number.
		 * Buffer.from(str[, encoding])
		 * Buffer.from(array)
		 * Buffer.from(buffer)
		 * Buffer.from(arrayBuffer[, byteOffset[, length]])
		 **/
		Buffer.from = function (value, encodingOrOffset, length) {
		  return from(value, encodingOrOffset, length)
		};

		// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
		// https://github.com/feross/buffer/pull/148
		Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
		Object.setPrototypeOf(Buffer, Uint8Array);

		function assertSize (size) {
		  if (typeof size !== 'number') {
		    throw new TypeError('"size" argument must be of type number')
		  } else if (size < 0) {
		    throw new RangeError('The value "' + size + '" is invalid for option "size"')
		  }
		}

		function alloc (size, fill, encoding) {
		  assertSize(size);
		  if (size <= 0) {
		    return createBuffer(size)
		  }
		  if (fill !== undefined) {
		    // Only pay attention to encoding if it's a string. This
		    // prevents accidentally sending in a number that would
		    // be interpreted as a start offset.
		    return typeof encoding === 'string'
		      ? createBuffer(size).fill(fill, encoding)
		      : createBuffer(size).fill(fill)
		  }
		  return createBuffer(size)
		}

		/**
		 * Creates a new filled Buffer instance.
		 * alloc(size[, fill[, encoding]])
		 **/
		Buffer.alloc = function (size, fill, encoding) {
		  return alloc(size, fill, encoding)
		};

		function allocUnsafe (size) {
		  assertSize(size);
		  return createBuffer(size < 0 ? 0 : checked(size) | 0)
		}

		/**
		 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
		 * */
		Buffer.allocUnsafe = function (size) {
		  return allocUnsafe(size)
		};
		/**
		 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
		 */
		Buffer.allocUnsafeSlow = function (size) {
		  return allocUnsafe(size)
		};

		function fromString (string, encoding) {
		  if (typeof encoding !== 'string' || encoding === '') {
		    encoding = 'utf8';
		  }

		  if (!Buffer.isEncoding(encoding)) {
		    throw new TypeError('Unknown encoding: ' + encoding)
		  }

		  const length = byteLength(string, encoding) | 0;
		  let buf = createBuffer(length);

		  const actual = buf.write(string, encoding);

		  if (actual !== length) {
		    // Writing a hex string, for example, that contains invalid characters will
		    // cause everything after the first invalid character to be ignored. (e.g.
		    // 'abxxcd' will be treated as 'ab')
		    buf = buf.slice(0, actual);
		  }

		  return buf
		}

		function fromArrayLike (array) {
		  const length = array.length < 0 ? 0 : checked(array.length) | 0;
		  const buf = createBuffer(length);
		  for (let i = 0; i < length; i += 1) {
		    buf[i] = array[i] & 255;
		  }
		  return buf
		}

		function fromArrayView (arrayView) {
		  if (isInstance(arrayView, Uint8Array)) {
		    const copy = new Uint8Array(arrayView);
		    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
		  }
		  return fromArrayLike(arrayView)
		}

		function fromArrayBuffer (array, byteOffset, length) {
		  if (byteOffset < 0 || array.byteLength < byteOffset) {
		    throw new RangeError('"offset" is outside of buffer bounds')
		  }

		  if (array.byteLength < byteOffset + (length || 0)) {
		    throw new RangeError('"length" is outside of buffer bounds')
		  }

		  let buf;
		  if (byteOffset === undefined && length === undefined) {
		    buf = new Uint8Array(array);
		  } else if (length === undefined) {
		    buf = new Uint8Array(array, byteOffset);
		  } else {
		    buf = new Uint8Array(array, byteOffset, length);
		  }

		  // Return an augmented `Uint8Array` instance
		  Object.setPrototypeOf(buf, Buffer.prototype);

		  return buf
		}

		function fromObject (obj) {
		  if (Buffer.isBuffer(obj)) {
		    const len = checked(obj.length) | 0;
		    const buf = createBuffer(len);

		    if (buf.length === 0) {
		      return buf
		    }

		    obj.copy(buf, 0, 0, len);
		    return buf
		  }

		  if (obj.length !== undefined) {
		    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
		      return createBuffer(0)
		    }
		    return fromArrayLike(obj)
		  }

		  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
		    return fromArrayLike(obj.data)
		  }
		}

		function checked (length) {
		  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
		  // length is NaN (which is otherwise coerced to zero.)
		  if (length >= K_MAX_LENGTH) {
		    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
		                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
		  }
		  return length | 0
		}

		function SlowBuffer (length) {
		  if (+length != length) { // eslint-disable-line eqeqeq
		    length = 0;
		  }
		  return Buffer.alloc(+length)
		}

		Buffer.isBuffer = function isBuffer (b) {
		  return b != null && b._isBuffer === true &&
		    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
		};

		Buffer.compare = function compare (a, b) {
		  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
		  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
		  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
		    throw new TypeError(
		      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
		    )
		  }

		  if (a === b) return 0

		  let x = a.length;
		  let y = b.length;

		  for (let i = 0, len = Math.min(x, y); i < len; ++i) {
		    if (a[i] !== b[i]) {
		      x = a[i];
		      y = b[i];
		      break
		    }
		  }

		  if (x < y) return -1
		  if (y < x) return 1
		  return 0
		};

		Buffer.isEncoding = function isEncoding (encoding) {
		  switch (String(encoding).toLowerCase()) {
		    case 'hex':
		    case 'utf8':
		    case 'utf-8':
		    case 'ascii':
		    case 'latin1':
		    case 'binary':
		    case 'base64':
		    case 'ucs2':
		    case 'ucs-2':
		    case 'utf16le':
		    case 'utf-16le':
		      return true
		    default:
		      return false
		  }
		};

		Buffer.concat = function concat (list, length) {
		  if (!Array.isArray(list)) {
		    throw new TypeError('"list" argument must be an Array of Buffers')
		  }

		  if (list.length === 0) {
		    return Buffer.alloc(0)
		  }

		  let i;
		  if (length === undefined) {
		    length = 0;
		    for (i = 0; i < list.length; ++i) {
		      length += list[i].length;
		    }
		  }

		  const buffer = Buffer.allocUnsafe(length);
		  let pos = 0;
		  for (i = 0; i < list.length; ++i) {
		    let buf = list[i];
		    if (isInstance(buf, Uint8Array)) {
		      if (pos + buf.length > buffer.length) {
		        if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
		        buf.copy(buffer, pos);
		      } else {
		        Uint8Array.prototype.set.call(
		          buffer,
		          buf,
		          pos
		        );
		      }
		    } else if (!Buffer.isBuffer(buf)) {
		      throw new TypeError('"list" argument must be an Array of Buffers')
		    } else {
		      buf.copy(buffer, pos);
		    }
		    pos += buf.length;
		  }
		  return buffer
		};

		function byteLength (string, encoding) {
		  if (Buffer.isBuffer(string)) {
		    return string.length
		  }
		  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
		    return string.byteLength
		  }
		  if (typeof string !== 'string') {
		    throw new TypeError(
		      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
		      'Received type ' + typeof string
		    )
		  }

		  const len = string.length;
		  const mustMatch = (arguments.length > 2 && arguments[2] === true);
		  if (!mustMatch && len === 0) return 0

		  // Use a for loop to avoid recursion
		  let loweredCase = false;
		  for (;;) {
		    switch (encoding) {
		      case 'ascii':
		      case 'latin1':
		      case 'binary':
		        return len
		      case 'utf8':
		      case 'utf-8':
		        return utf8ToBytes(string).length
		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return len * 2
		      case 'hex':
		        return len >>> 1
		      case 'base64':
		        return base64ToBytes(string).length
		      default:
		        if (loweredCase) {
		          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
		        }
		        encoding = ('' + encoding).toLowerCase();
		        loweredCase = true;
		    }
		  }
		}
		Buffer.byteLength = byteLength;

		function slowToString (encoding, start, end) {
		  let loweredCase = false;

		  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
		  // property of a typed array.

		  // This behaves neither like String nor Uint8Array in that we set start/end
		  // to their upper/lower bounds if the value passed is out of range.
		  // undefined is handled specially as per ECMA-262 6th Edition,
		  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
		  if (start === undefined || start < 0) {
		    start = 0;
		  }
		  // Return early if start > this.length. Done here to prevent potential uint32
		  // coercion fail below.
		  if (start > this.length) {
		    return ''
		  }

		  if (end === undefined || end > this.length) {
		    end = this.length;
		  }

		  if (end <= 0) {
		    return ''
		  }

		  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
		  end >>>= 0;
		  start >>>= 0;

		  if (end <= start) {
		    return ''
		  }

		  if (!encoding) encoding = 'utf8';

		  while (true) {
		    switch (encoding) {
		      case 'hex':
		        return hexSlice(this, start, end)

		      case 'utf8':
		      case 'utf-8':
		        return utf8Slice(this, start, end)

		      case 'ascii':
		        return asciiSlice(this, start, end)

		      case 'latin1':
		      case 'binary':
		        return latin1Slice(this, start, end)

		      case 'base64':
		        return base64Slice(this, start, end)

		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return utf16leSlice(this, start, end)

		      default:
		        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
		        encoding = (encoding + '').toLowerCase();
		        loweredCase = true;
		    }
		  }
		}

		// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
		// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
		// reliably in a browserify context because there could be multiple different
		// copies of the 'buffer' package in use. This method works even for Buffer
		// instances that were created from another copy of the `buffer` package.
		// See: https://github.com/feross/buffer/issues/154
		Buffer.prototype._isBuffer = true;

		function swap (b, n, m) {
		  const i = b[n];
		  b[n] = b[m];
		  b[m] = i;
		}

		Buffer.prototype.swap16 = function swap16 () {
		  const len = this.length;
		  if (len % 2 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 16-bits')
		  }
		  for (let i = 0; i < len; i += 2) {
		    swap(this, i, i + 1);
		  }
		  return this
		};

		Buffer.prototype.swap32 = function swap32 () {
		  const len = this.length;
		  if (len % 4 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 32-bits')
		  }
		  for (let i = 0; i < len; i += 4) {
		    swap(this, i, i + 3);
		    swap(this, i + 1, i + 2);
		  }
		  return this
		};

		Buffer.prototype.swap64 = function swap64 () {
		  const len = this.length;
		  if (len % 8 !== 0) {
		    throw new RangeError('Buffer size must be a multiple of 64-bits')
		  }
		  for (let i = 0; i < len; i += 8) {
		    swap(this, i, i + 7);
		    swap(this, i + 1, i + 6);
		    swap(this, i + 2, i + 5);
		    swap(this, i + 3, i + 4);
		  }
		  return this
		};

		Buffer.prototype.toString = function toString () {
		  const length = this.length;
		  if (length === 0) return ''
		  if (arguments.length === 0) return utf8Slice(this, 0, length)
		  return slowToString.apply(this, arguments)
		};

		Buffer.prototype.toLocaleString = Buffer.prototype.toString;

		Buffer.prototype.equals = function equals (b) {
		  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
		  if (this === b) return true
		  return Buffer.compare(this, b) === 0
		};

		Buffer.prototype.inspect = function inspect () {
		  let str = '';
		  const max = exports.INSPECT_MAX_BYTES;
		  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
		  if (this.length > max) str += ' ... ';
		  return '<Buffer ' + str + '>'
		};
		if (customInspectSymbol) {
		  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
		}

		Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
		  if (isInstance(target, Uint8Array)) {
		    target = Buffer.from(target, target.offset, target.byteLength);
		  }
		  if (!Buffer.isBuffer(target)) {
		    throw new TypeError(
		      'The "target" argument must be one of type Buffer or Uint8Array. ' +
		      'Received type ' + (typeof target)
		    )
		  }

		  if (start === undefined) {
		    start = 0;
		  }
		  if (end === undefined) {
		    end = target ? target.length : 0;
		  }
		  if (thisStart === undefined) {
		    thisStart = 0;
		  }
		  if (thisEnd === undefined) {
		    thisEnd = this.length;
		  }

		  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
		    throw new RangeError('out of range index')
		  }

		  if (thisStart >= thisEnd && start >= end) {
		    return 0
		  }
		  if (thisStart >= thisEnd) {
		    return -1
		  }
		  if (start >= end) {
		    return 1
		  }

		  start >>>= 0;
		  end >>>= 0;
		  thisStart >>>= 0;
		  thisEnd >>>= 0;

		  if (this === target) return 0

		  let x = thisEnd - thisStart;
		  let y = end - start;
		  const len = Math.min(x, y);

		  const thisCopy = this.slice(thisStart, thisEnd);
		  const targetCopy = target.slice(start, end);

		  for (let i = 0; i < len; ++i) {
		    if (thisCopy[i] !== targetCopy[i]) {
		      x = thisCopy[i];
		      y = targetCopy[i];
		      break
		    }
		  }

		  if (x < y) return -1
		  if (y < x) return 1
		  return 0
		};

		// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
		// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
		//
		// Arguments:
		// - buffer - a Buffer to search
		// - val - a string, Buffer, or number
		// - byteOffset - an index into `buffer`; will be clamped to an int32
		// - encoding - an optional encoding, relevant is val is a string
		// - dir - true for indexOf, false for lastIndexOf
		function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
		  // Empty buffer means no match
		  if (buffer.length === 0) return -1

		  // Normalize byteOffset
		  if (typeof byteOffset === 'string') {
		    encoding = byteOffset;
		    byteOffset = 0;
		  } else if (byteOffset > 0x7fffffff) {
		    byteOffset = 0x7fffffff;
		  } else if (byteOffset < -2147483648) {
		    byteOffset = -2147483648;
		  }
		  byteOffset = +byteOffset; // Coerce to Number.
		  if (numberIsNaN(byteOffset)) {
		    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
		    byteOffset = dir ? 0 : (buffer.length - 1);
		  }

		  // Normalize byteOffset: negative offsets start from the end of the buffer
		  if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
		  if (byteOffset >= buffer.length) {
		    if (dir) return -1
		    else byteOffset = buffer.length - 1;
		  } else if (byteOffset < 0) {
		    if (dir) byteOffset = 0;
		    else return -1
		  }

		  // Normalize val
		  if (typeof val === 'string') {
		    val = Buffer.from(val, encoding);
		  }

		  // Finally, search either indexOf (if dir is true) or lastIndexOf
		  if (Buffer.isBuffer(val)) {
		    // Special case: looking for empty string/buffer always fails
		    if (val.length === 0) {
		      return -1
		    }
		    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
		  } else if (typeof val === 'number') {
		    val = val & 0xFF; // Search for a byte value [0-255]
		    if (typeof Uint8Array.prototype.indexOf === 'function') {
		      if (dir) {
		        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
		      } else {
		        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
		      }
		    }
		    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
		  }

		  throw new TypeError('val must be string, number or Buffer')
		}

		function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
		  let indexSize = 1;
		  let arrLength = arr.length;
		  let valLength = val.length;

		  if (encoding !== undefined) {
		    encoding = String(encoding).toLowerCase();
		    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
		        encoding === 'utf16le' || encoding === 'utf-16le') {
		      if (arr.length < 2 || val.length < 2) {
		        return -1
		      }
		      indexSize = 2;
		      arrLength /= 2;
		      valLength /= 2;
		      byteOffset /= 2;
		    }
		  }

		  function read (buf, i) {
		    if (indexSize === 1) {
		      return buf[i]
		    } else {
		      return buf.readUInt16BE(i * indexSize)
		    }
		  }

		  let i;
		  if (dir) {
		    let foundIndex = -1;
		    for (i = byteOffset; i < arrLength; i++) {
		      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
		        if (foundIndex === -1) foundIndex = i;
		        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
		      } else {
		        if (foundIndex !== -1) i -= i - foundIndex;
		        foundIndex = -1;
		      }
		    }
		  } else {
		    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
		    for (i = byteOffset; i >= 0; i--) {
		      let found = true;
		      for (let j = 0; j < valLength; j++) {
		        if (read(arr, i + j) !== read(val, j)) {
		          found = false;
		          break
		        }
		      }
		      if (found) return i
		    }
		  }

		  return -1
		}

		Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
		  return this.indexOf(val, byteOffset, encoding) !== -1
		};

		Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
		  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
		};

		Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
		  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
		};

		function hexWrite (buf, string, offset, length) {
		  offset = Number(offset) || 0;
		  const remaining = buf.length - offset;
		  if (!length) {
		    length = remaining;
		  } else {
		    length = Number(length);
		    if (length > remaining) {
		      length = remaining;
		    }
		  }

		  const strLen = string.length;

		  if (length > strLen / 2) {
		    length = strLen / 2;
		  }
		  let i;
		  for (i = 0; i < length; ++i) {
		    const parsed = parseInt(string.substr(i * 2, 2), 16);
		    if (numberIsNaN(parsed)) return i
		    buf[offset + i] = parsed;
		  }
		  return i
		}

		function utf8Write (buf, string, offset, length) {
		  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
		}

		function asciiWrite (buf, string, offset, length) {
		  return blitBuffer(asciiToBytes(string), buf, offset, length)
		}

		function base64Write (buf, string, offset, length) {
		  return blitBuffer(base64ToBytes(string), buf, offset, length)
		}

		function ucs2Write (buf, string, offset, length) {
		  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
		}

		Buffer.prototype.write = function write (string, offset, length, encoding) {
		  // Buffer#write(string)
		  if (offset === undefined) {
		    encoding = 'utf8';
		    length = this.length;
		    offset = 0;
		  // Buffer#write(string, encoding)
		  } else if (length === undefined && typeof offset === 'string') {
		    encoding = offset;
		    length = this.length;
		    offset = 0;
		  // Buffer#write(string, offset[, length][, encoding])
		  } else if (isFinite(offset)) {
		    offset = offset >>> 0;
		    if (isFinite(length)) {
		      length = length >>> 0;
		      if (encoding === undefined) encoding = 'utf8';
		    } else {
		      encoding = length;
		      length = undefined;
		    }
		  } else {
		    throw new Error(
		      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
		    )
		  }

		  const remaining = this.length - offset;
		  if (length === undefined || length > remaining) length = remaining;

		  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
		    throw new RangeError('Attempt to write outside buffer bounds')
		  }

		  if (!encoding) encoding = 'utf8';

		  let loweredCase = false;
		  for (;;) {
		    switch (encoding) {
		      case 'hex':
		        return hexWrite(this, string, offset, length)

		      case 'utf8':
		      case 'utf-8':
		        return utf8Write(this, string, offset, length)

		      case 'ascii':
		      case 'latin1':
		      case 'binary':
		        return asciiWrite(this, string, offset, length)

		      case 'base64':
		        // Warning: maxLength not taken into account in base64Write
		        return base64Write(this, string, offset, length)

		      case 'ucs2':
		      case 'ucs-2':
		      case 'utf16le':
		      case 'utf-16le':
		        return ucs2Write(this, string, offset, length)

		      default:
		        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
		        encoding = ('' + encoding).toLowerCase();
		        loweredCase = true;
		    }
		  }
		};

		Buffer.prototype.toJSON = function toJSON () {
		  return {
		    type: 'Buffer',
		    data: Array.prototype.slice.call(this._arr || this, 0)
		  }
		};

		function base64Slice (buf, start, end) {
		  if (start === 0 && end === buf.length) {
		    return base64.fromByteArray(buf)
		  } else {
		    return base64.fromByteArray(buf.slice(start, end))
		  }
		}

		function utf8Slice (buf, start, end) {
		  end = Math.min(buf.length, end);
		  const res = [];

		  let i = start;
		  while (i < end) {
		    const firstByte = buf[i];
		    let codePoint = null;
		    let bytesPerSequence = (firstByte > 0xEF)
		      ? 4
		      : (firstByte > 0xDF)
		          ? 3
		          : (firstByte > 0xBF)
		              ? 2
		              : 1;

		    if (i + bytesPerSequence <= end) {
		      let secondByte, thirdByte, fourthByte, tempCodePoint;

		      switch (bytesPerSequence) {
		        case 1:
		          if (firstByte < 0x80) {
		            codePoint = firstByte;
		          }
		          break
		        case 2:
		          secondByte = buf[i + 1];
		          if ((secondByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F);
		            if (tempCodePoint > 0x7F) {
		              codePoint = tempCodePoint;
		            }
		          }
		          break
		        case 3:
		          secondByte = buf[i + 1];
		          thirdByte = buf[i + 2];
		          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F);
		            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
		              codePoint = tempCodePoint;
		            }
		          }
		          break
		        case 4:
		          secondByte = buf[i + 1];
		          thirdByte = buf[i + 2];
		          fourthByte = buf[i + 3];
		          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
		            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F);
		            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
		              codePoint = tempCodePoint;
		            }
		          }
		      }
		    }

		    if (codePoint === null) {
		      // we did not generate a valid codePoint so insert a
		      // replacement char (U+FFFD) and advance only 1 byte
		      codePoint = 0xFFFD;
		      bytesPerSequence = 1;
		    } else if (codePoint > 0xFFFF) {
		      // encode to utf16 (surrogate pair dance)
		      codePoint -= 0x10000;
		      res.push(codePoint >>> 10 & 0x3FF | 0xD800);
		      codePoint = 0xDC00 | codePoint & 0x3FF;
		    }

		    res.push(codePoint);
		    i += bytesPerSequence;
		  }

		  return decodeCodePointsArray(res)
		}

		// Based on http://stackoverflow.com/a/22747272/680742, the browser with
		// the lowest limit is Chrome, with 0x10000 args.
		// We go 1 magnitude less, for safety
		const MAX_ARGUMENTS_LENGTH = 0x1000;

		function decodeCodePointsArray (codePoints) {
		  const len = codePoints.length;
		  if (len <= MAX_ARGUMENTS_LENGTH) {
		    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
		  }

		  // Decode in chunks to avoid "call stack size exceeded".
		  let res = '';
		  let i = 0;
		  while (i < len) {
		    res += String.fromCharCode.apply(
		      String,
		      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
		    );
		  }
		  return res
		}

		function asciiSlice (buf, start, end) {
		  let ret = '';
		  end = Math.min(buf.length, end);

		  for (let i = start; i < end; ++i) {
		    ret += String.fromCharCode(buf[i] & 0x7F);
		  }
		  return ret
		}

		function latin1Slice (buf, start, end) {
		  let ret = '';
		  end = Math.min(buf.length, end);

		  for (let i = start; i < end; ++i) {
		    ret += String.fromCharCode(buf[i]);
		  }
		  return ret
		}

		function hexSlice (buf, start, end) {
		  const len = buf.length;

		  if (!start || start < 0) start = 0;
		  if (!end || end < 0 || end > len) end = len;

		  let out = '';
		  for (let i = start; i < end; ++i) {
		    out += hexSliceLookupTable[buf[i]];
		  }
		  return out
		}

		function utf16leSlice (buf, start, end) {
		  const bytes = buf.slice(start, end);
		  let res = '';
		  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
		  for (let i = 0; i < bytes.length - 1; i += 2) {
		    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256));
		  }
		  return res
		}

		Buffer.prototype.slice = function slice (start, end) {
		  const len = this.length;
		  start = ~~start;
		  end = end === undefined ? len : ~~end;

		  if (start < 0) {
		    start += len;
		    if (start < 0) start = 0;
		  } else if (start > len) {
		    start = len;
		  }

		  if (end < 0) {
		    end += len;
		    if (end < 0) end = 0;
		  } else if (end > len) {
		    end = len;
		  }

		  if (end < start) end = start;

		  const newBuf = this.subarray(start, end);
		  // Return an augmented `Uint8Array` instance
		  Object.setPrototypeOf(newBuf, Buffer.prototype);

		  return newBuf
		};

		/*
		 * Need to make sure that buffer isn't trying to write out of bounds.
		 */
		function checkOffset (offset, ext, length) {
		  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
		  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
		}

		Buffer.prototype.readUintLE =
		Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) checkOffset(offset, byteLength, this.length);

		  let val = this[offset];
		  let mul = 1;
		  let i = 0;
		  while (++i < byteLength && (mul *= 0x100)) {
		    val += this[offset + i] * mul;
		  }

		  return val
		};

		Buffer.prototype.readUintBE =
		Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) {
		    checkOffset(offset, byteLength, this.length);
		  }

		  let val = this[offset + --byteLength];
		  let mul = 1;
		  while (byteLength > 0 && (mul *= 0x100)) {
		    val += this[offset + --byteLength] * mul;
		  }

		  return val
		};

		Buffer.prototype.readUint8 =
		Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 1, this.length);
		  return this[offset]
		};

		Buffer.prototype.readUint16LE =
		Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  return this[offset] | (this[offset + 1] << 8)
		};

		Buffer.prototype.readUint16BE =
		Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  return (this[offset] << 8) | this[offset + 1]
		};

		Buffer.prototype.readUint32LE =
		Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);

		  return ((this[offset]) |
		      (this[offset + 1] << 8) |
		      (this[offset + 2] << 16)) +
		      (this[offset + 3] * 0x1000000)
		};

		Buffer.prototype.readUint32BE =
		Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);

		  return (this[offset] * 0x1000000) +
		    ((this[offset + 1] << 16) |
		    (this[offset + 2] << 8) |
		    this[offset + 3])
		};

		Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE (offset) {
		  offset = offset >>> 0;
		  validateNumber(offset, 'offset');
		  const first = this[offset];
		  const last = this[offset + 7];
		  if (first === undefined || last === undefined) {
		    boundsError(offset, this.length - 8);
		  }

		  const lo = first +
		    this[++offset] * 2 ** 8 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 24;

		  const hi = this[++offset] +
		    this[++offset] * 2 ** 8 +
		    this[++offset] * 2 ** 16 +
		    last * 2 ** 24;

		  return BigInt(lo) + (BigInt(hi) << BigInt(32))
		});

		Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE (offset) {
		  offset = offset >>> 0;
		  validateNumber(offset, 'offset');
		  const first = this[offset];
		  const last = this[offset + 7];
		  if (first === undefined || last === undefined) {
		    boundsError(offset, this.length - 8);
		  }

		  const hi = first * 2 ** 24 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 8 +
		    this[++offset];

		  const lo = this[++offset] * 2 ** 24 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 8 +
		    last;

		  return (BigInt(hi) << BigInt(32)) + BigInt(lo)
		});

		Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) checkOffset(offset, byteLength, this.length);

		  let val = this[offset];
		  let mul = 1;
		  let i = 0;
		  while (++i < byteLength && (mul *= 0x100)) {
		    val += this[offset + i] * mul;
		  }
		  mul *= 0x80;

		  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

		  return val
		};

		Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) checkOffset(offset, byteLength, this.length);

		  let i = byteLength;
		  let mul = 1;
		  let val = this[offset + --i];
		  while (i > 0 && (mul *= 0x100)) {
		    val += this[offset + --i] * mul;
		  }
		  mul *= 0x80;

		  if (val >= mul) val -= Math.pow(2, 8 * byteLength);

		  return val
		};

		Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 1, this.length);
		  if (!(this[offset] & 0x80)) return (this[offset])
		  return ((0xff - this[offset] + 1) * -1)
		};

		Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  const val = this[offset] | (this[offset + 1] << 8);
		  return (val & 0x8000) ? val | 0xFFFF0000 : val
		};

		Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 2, this.length);
		  const val = this[offset + 1] | (this[offset] << 8);
		  return (val & 0x8000) ? val | 0xFFFF0000 : val
		};

		Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);

		  return (this[offset]) |
		    (this[offset + 1] << 8) |
		    (this[offset + 2] << 16) |
		    (this[offset + 3] << 24)
		};

		Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);

		  return (this[offset] << 24) |
		    (this[offset + 1] << 16) |
		    (this[offset + 2] << 8) |
		    (this[offset + 3])
		};

		Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE (offset) {
		  offset = offset >>> 0;
		  validateNumber(offset, 'offset');
		  const first = this[offset];
		  const last = this[offset + 7];
		  if (first === undefined || last === undefined) {
		    boundsError(offset, this.length - 8);
		  }

		  const val = this[offset + 4] +
		    this[offset + 5] * 2 ** 8 +
		    this[offset + 6] * 2 ** 16 +
		    (last << 24); // Overflow

		  return (BigInt(val) << BigInt(32)) +
		    BigInt(first +
		    this[++offset] * 2 ** 8 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 24)
		});

		Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE (offset) {
		  offset = offset >>> 0;
		  validateNumber(offset, 'offset');
		  const first = this[offset];
		  const last = this[offset + 7];
		  if (first === undefined || last === undefined) {
		    boundsError(offset, this.length - 8);
		  }

		  const val = (first << 24) + // Overflow
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 8 +
		    this[++offset];

		  return (BigInt(val) << BigInt(32)) +
		    BigInt(this[++offset] * 2 ** 24 +
		    this[++offset] * 2 ** 16 +
		    this[++offset] * 2 ** 8 +
		    last)
		});

		Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);
		  return ieee754.read(this, offset, true, 23, 4)
		};

		Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 4, this.length);
		  return ieee754.read(this, offset, false, 23, 4)
		};

		Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 8, this.length);
		  return ieee754.read(this, offset, true, 52, 8)
		};

		Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
		  offset = offset >>> 0;
		  if (!noAssert) checkOffset(offset, 8, this.length);
		  return ieee754.read(this, offset, false, 52, 8)
		};

		function checkInt (buf, value, offset, ext, max, min) {
		  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
		  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
		  if (offset + ext > buf.length) throw new RangeError('Index out of range')
		}

		Buffer.prototype.writeUintLE =
		Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) {
		    const maxBytes = Math.pow(2, 8 * byteLength) - 1;
		    checkInt(this, value, offset, byteLength, maxBytes, 0);
		  }

		  let mul = 1;
		  let i = 0;
		  this[offset] = value & 0xFF;
		  while (++i < byteLength && (mul *= 0x100)) {
		    this[offset + i] = (value / mul) & 0xFF;
		  }

		  return offset + byteLength
		};

		Buffer.prototype.writeUintBE =
		Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  byteLength = byteLength >>> 0;
		  if (!noAssert) {
		    const maxBytes = Math.pow(2, 8 * byteLength) - 1;
		    checkInt(this, value, offset, byteLength, maxBytes, 0);
		  }

		  let i = byteLength - 1;
		  let mul = 1;
		  this[offset + i] = value & 0xFF;
		  while (--i >= 0 && (mul *= 0x100)) {
		    this[offset + i] = (value / mul) & 0xFF;
		  }

		  return offset + byteLength
		};

		Buffer.prototype.writeUint8 =
		Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
		  this[offset] = (value & 0xff);
		  return offset + 1
		};

		Buffer.prototype.writeUint16LE =
		Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
		  this[offset] = (value & 0xff);
		  this[offset + 1] = (value >>> 8);
		  return offset + 2
		};

		Buffer.prototype.writeUint16BE =
		Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
		  this[offset] = (value >>> 8);
		  this[offset + 1] = (value & 0xff);
		  return offset + 2
		};

		Buffer.prototype.writeUint32LE =
		Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
		  this[offset + 3] = (value >>> 24);
		  this[offset + 2] = (value >>> 16);
		  this[offset + 1] = (value >>> 8);
		  this[offset] = (value & 0xff);
		  return offset + 4
		};

		Buffer.prototype.writeUint32BE =
		Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
		  this[offset] = (value >>> 24);
		  this[offset + 1] = (value >>> 16);
		  this[offset + 2] = (value >>> 8);
		  this[offset + 3] = (value & 0xff);
		  return offset + 4
		};

		function wrtBigUInt64LE (buf, value, offset, min, max) {
		  checkIntBI(value, min, max, buf, offset, 7);

		  let lo = Number(value & BigInt(0xffffffff));
		  buf[offset++] = lo;
		  lo = lo >> 8;
		  buf[offset++] = lo;
		  lo = lo >> 8;
		  buf[offset++] = lo;
		  lo = lo >> 8;
		  buf[offset++] = lo;
		  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
		  buf[offset++] = hi;
		  hi = hi >> 8;
		  buf[offset++] = hi;
		  hi = hi >> 8;
		  buf[offset++] = hi;
		  hi = hi >> 8;
		  buf[offset++] = hi;
		  return offset
		}

		function wrtBigUInt64BE (buf, value, offset, min, max) {
		  checkIntBI(value, min, max, buf, offset, 7);

		  let lo = Number(value & BigInt(0xffffffff));
		  buf[offset + 7] = lo;
		  lo = lo >> 8;
		  buf[offset + 6] = lo;
		  lo = lo >> 8;
		  buf[offset + 5] = lo;
		  lo = lo >> 8;
		  buf[offset + 4] = lo;
		  let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
		  buf[offset + 3] = hi;
		  hi = hi >> 8;
		  buf[offset + 2] = hi;
		  hi = hi >> 8;
		  buf[offset + 1] = hi;
		  hi = hi >> 8;
		  buf[offset] = hi;
		  return offset + 8
		}

		Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE (value, offset = 0) {
		  return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
		});

		Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE (value, offset = 0) {
		  return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'))
		});

		Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) {
		    const limit = Math.pow(2, (8 * byteLength) - 1);

		    checkInt(this, value, offset, byteLength, limit - 1, -limit);
		  }

		  let i = 0;
		  let mul = 1;
		  let sub = 0;
		  this[offset] = value & 0xFF;
		  while (++i < byteLength && (mul *= 0x100)) {
		    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
		      sub = 1;
		    }
		    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
		  }

		  return offset + byteLength
		};

		Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) {
		    const limit = Math.pow(2, (8 * byteLength) - 1);

		    checkInt(this, value, offset, byteLength, limit - 1, -limit);
		  }

		  let i = byteLength - 1;
		  let mul = 1;
		  let sub = 0;
		  this[offset + i] = value & 0xFF;
		  while (--i >= 0 && (mul *= 0x100)) {
		    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
		      sub = 1;
		    }
		    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF;
		  }

		  return offset + byteLength
		};

		Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
		  if (value < 0) value = 0xff + value + 1;
		  this[offset] = (value & 0xff);
		  return offset + 1
		};

		Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
		  this[offset] = (value & 0xff);
		  this[offset + 1] = (value >>> 8);
		  return offset + 2
		};

		Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
		  this[offset] = (value >>> 8);
		  this[offset + 1] = (value & 0xff);
		  return offset + 2
		};

		Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
		  this[offset] = (value & 0xff);
		  this[offset + 1] = (value >>> 8);
		  this[offset + 2] = (value >>> 16);
		  this[offset + 3] = (value >>> 24);
		  return offset + 4
		};

		Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
		  if (value < 0) value = 0xffffffff + value + 1;
		  this[offset] = (value >>> 24);
		  this[offset + 1] = (value >>> 16);
		  this[offset + 2] = (value >>> 8);
		  this[offset + 3] = (value & 0xff);
		  return offset + 4
		};

		Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE (value, offset = 0) {
		  return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
		});

		Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE (value, offset = 0) {
		  return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'))
		});

		function checkIEEE754 (buf, value, offset, ext, max, min) {
		  if (offset + ext > buf.length) throw new RangeError('Index out of range')
		  if (offset < 0) throw new RangeError('Index out of range')
		}

		function writeFloat (buf, value, offset, littleEndian, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) {
		    checkIEEE754(buf, value, offset, 4);
		  }
		  ieee754.write(buf, value, offset, littleEndian, 23, 4);
		  return offset + 4
		}

		Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
		  return writeFloat(this, value, offset, true, noAssert)
		};

		Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
		  return writeFloat(this, value, offset, false, noAssert)
		};

		function writeDouble (buf, value, offset, littleEndian, noAssert) {
		  value = +value;
		  offset = offset >>> 0;
		  if (!noAssert) {
		    checkIEEE754(buf, value, offset, 8);
		  }
		  ieee754.write(buf, value, offset, littleEndian, 52, 8);
		  return offset + 8
		}

		Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
		  return writeDouble(this, value, offset, true, noAssert)
		};

		Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
		  return writeDouble(this, value, offset, false, noAssert)
		};

		// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
		Buffer.prototype.copy = function copy (target, targetStart, start, end) {
		  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
		  if (!start) start = 0;
		  if (!end && end !== 0) end = this.length;
		  if (targetStart >= target.length) targetStart = target.length;
		  if (!targetStart) targetStart = 0;
		  if (end > 0 && end < start) end = start;

		  // Copy 0 bytes; we're done
		  if (end === start) return 0
		  if (target.length === 0 || this.length === 0) return 0

		  // Fatal error conditions
		  if (targetStart < 0) {
		    throw new RangeError('targetStart out of bounds')
		  }
		  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
		  if (end < 0) throw new RangeError('sourceEnd out of bounds')

		  // Are we oob?
		  if (end > this.length) end = this.length;
		  if (target.length - targetStart < end - start) {
		    end = target.length - targetStart + start;
		  }

		  const len = end - start;

		  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
		    // Use built-in when available, missing from IE11
		    this.copyWithin(targetStart, start, end);
		  } else {
		    Uint8Array.prototype.set.call(
		      target,
		      this.subarray(start, end),
		      targetStart
		    );
		  }

		  return len
		};

		// Usage:
		//    buffer.fill(number[, offset[, end]])
		//    buffer.fill(buffer[, offset[, end]])
		//    buffer.fill(string[, offset[, end]][, encoding])
		Buffer.prototype.fill = function fill (val, start, end, encoding) {
		  // Handle string cases:
		  if (typeof val === 'string') {
		    if (typeof start === 'string') {
		      encoding = start;
		      start = 0;
		      end = this.length;
		    } else if (typeof end === 'string') {
		      encoding = end;
		      end = this.length;
		    }
		    if (encoding !== undefined && typeof encoding !== 'string') {
		      throw new TypeError('encoding must be a string')
		    }
		    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
		      throw new TypeError('Unknown encoding: ' + encoding)
		    }
		    if (val.length === 1) {
		      const code = val.charCodeAt(0);
		      if ((encoding === 'utf8' && code < 128) ||
		          encoding === 'latin1') {
		        // Fast path: If `val` fits into a single byte, use that numeric value.
		        val = code;
		      }
		    }
		  } else if (typeof val === 'number') {
		    val = val & 255;
		  } else if (typeof val === 'boolean') {
		    val = Number(val);
		  }

		  // Invalid ranges are not set to a default, so can range check early.
		  if (start < 0 || this.length < start || this.length < end) {
		    throw new RangeError('Out of range index')
		  }

		  if (end <= start) {
		    return this
		  }

		  start = start >>> 0;
		  end = end === undefined ? this.length : end >>> 0;

		  if (!val) val = 0;

		  let i;
		  if (typeof val === 'number') {
		    for (i = start; i < end; ++i) {
		      this[i] = val;
		    }
		  } else {
		    const bytes = Buffer.isBuffer(val)
		      ? val
		      : Buffer.from(val, encoding);
		    const len = bytes.length;
		    if (len === 0) {
		      throw new TypeError('The value "' + val +
		        '" is invalid for argument "value"')
		    }
		    for (i = 0; i < end - start; ++i) {
		      this[i + start] = bytes[i % len];
		    }
		  }

		  return this
		};

		// CUSTOM ERRORS
		// =============

		// Simplified versions from Node, changed for Buffer-only usage
		const errors = {};
		function E (sym, getMessage, Base) {
		  errors[sym] = class NodeError extends Base {
		    constructor () {
		      super();

		      Object.defineProperty(this, 'message', {
		        value: getMessage.apply(this, arguments),
		        writable: true,
		        configurable: true
		      });

		      // Add the error code to the name to include it in the stack trace.
		      this.name = `${this.name} [${sym}]`;
		      // Access the stack to generate the error message including the error code
		      // from the name.
		      this.stack; // eslint-disable-line no-unused-expressions
		      // Reset the name to the actual name.
		      delete this.name;
		    }

		    get code () {
		      return sym
		    }

		    set code (value) {
		      Object.defineProperty(this, 'code', {
		        configurable: true,
		        enumerable: true,
		        value,
		        writable: true
		      });
		    }

		    toString () {
		      return `${this.name} [${sym}]: ${this.message}`
		    }
		  };
		}

		E('ERR_BUFFER_OUT_OF_BOUNDS',
		  function (name) {
		    if (name) {
		      return `${name} is outside of buffer bounds`
		    }

		    return 'Attempt to access memory outside buffer bounds'
		  }, RangeError);
		E('ERR_INVALID_ARG_TYPE',
		  function (name, actual) {
		    return `The "${name}" argument must be of type number. Received type ${typeof actual}`
		  }, TypeError);
		E('ERR_OUT_OF_RANGE',
		  function (str, range, input) {
		    let msg = `The value of "${str}" is out of range.`;
		    let received = input;
		    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
		      received = addNumericalSeparator(String(input));
		    } else if (typeof input === 'bigint') {
		      received = String(input);
		      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
		        received = addNumericalSeparator(received);
		      }
		      received += 'n';
		    }
		    msg += ` It must be ${range}. Received ${received}`;
		    return msg
		  }, RangeError);

		function addNumericalSeparator (val) {
		  let res = '';
		  let i = val.length;
		  const start = val[0] === '-' ? 1 : 0;
		  for (; i >= start + 4; i -= 3) {
		    res = `_${val.slice(i - 3, i)}${res}`;
		  }
		  return `${val.slice(0, i)}${res}`
		}

		// CHECK FUNCTIONS
		// ===============

		function checkBounds (buf, offset, byteLength) {
		  validateNumber(offset, 'offset');
		  if (buf[offset] === undefined || buf[offset + byteLength] === undefined) {
		    boundsError(offset, buf.length - (byteLength + 1));
		  }
		}

		function checkIntBI (value, min, max, buf, offset, byteLength) {
		  if (value > max || value < min) {
		    const n = typeof min === 'bigint' ? 'n' : '';
		    let range;
		    {
		      if (min === 0 || min === BigInt(0)) {
		        range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
		      } else {
		        range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` +
		                `${(byteLength + 1) * 8 - 1}${n}`;
		      }
		    }
		    throw new errors.ERR_OUT_OF_RANGE('value', range, value)
		  }
		  checkBounds(buf, offset, byteLength);
		}

		function validateNumber (value, name) {
		  if (typeof value !== 'number') {
		    throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value)
		  }
		}

		function boundsError (value, length, type) {
		  if (Math.floor(value) !== value) {
		    validateNumber(value, type);
		    throw new errors.ERR_OUT_OF_RANGE('offset', 'an integer', value)
		  }

		  if (length < 0) {
		    throw new errors.ERR_BUFFER_OUT_OF_BOUNDS()
		  }

		  throw new errors.ERR_OUT_OF_RANGE('offset',
		                                    `>= ${0} and <= ${length}`,
		                                    value)
		}

		// HELPER FUNCTIONS
		// ================

		const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;

		function base64clean (str) {
		  // Node takes equal signs as end of the Base64 encoding
		  str = str.split('=')[0];
		  // Node strips out invalid characters like \n and \t from the string, base64-js does not
		  str = str.trim().replace(INVALID_BASE64_RE, '');
		  // Node converts strings with length < 2 to ''
		  if (str.length < 2) return ''
		  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
		  while (str.length % 4 !== 0) {
		    str = str + '=';
		  }
		  return str
		}

		function utf8ToBytes (string, units) {
		  units = units || Infinity;
		  let codePoint;
		  const length = string.length;
		  let leadSurrogate = null;
		  const bytes = [];

		  for (let i = 0; i < length; ++i) {
		    codePoint = string.charCodeAt(i);

		    // is surrogate component
		    if (codePoint > 0xD7FF && codePoint < 0xE000) {
		      // last char was a lead
		      if (!leadSurrogate) {
		        // no lead yet
		        if (codePoint > 0xDBFF) {
		          // unexpected trail
		          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		          continue
		        } else if (i + 1 === length) {
		          // unpaired lead
		          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		          continue
		        }

		        // valid lead
		        leadSurrogate = codePoint;

		        continue
		      }

		      // 2 leads in a row
		      if (codePoint < 0xDC00) {
		        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		        leadSurrogate = codePoint;
		        continue
		      }

		      // valid surrogate pair
		      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
		    } else if (leadSurrogate) {
		      // valid bmp char, but last char was a lead
		      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
		    }

		    leadSurrogate = null;

		    // encode utf8
		    if (codePoint < 0x80) {
		      if ((units -= 1) < 0) break
		      bytes.push(codePoint);
		    } else if (codePoint < 0x800) {
		      if ((units -= 2) < 0) break
		      bytes.push(
		        codePoint >> 0x6 | 0xC0,
		        codePoint & 0x3F | 0x80
		      );
		    } else if (codePoint < 0x10000) {
		      if ((units -= 3) < 0) break
		      bytes.push(
		        codePoint >> 0xC | 0xE0,
		        codePoint >> 0x6 & 0x3F | 0x80,
		        codePoint & 0x3F | 0x80
		      );
		    } else if (codePoint < 0x110000) {
		      if ((units -= 4) < 0) break
		      bytes.push(
		        codePoint >> 0x12 | 0xF0,
		        codePoint >> 0xC & 0x3F | 0x80,
		        codePoint >> 0x6 & 0x3F | 0x80,
		        codePoint & 0x3F | 0x80
		      );
		    } else {
		      throw new Error('Invalid code point')
		    }
		  }

		  return bytes
		}

		function asciiToBytes (str) {
		  const byteArray = [];
		  for (let i = 0; i < str.length; ++i) {
		    // Node's code seems to be doing this and not & 0x7F..
		    byteArray.push(str.charCodeAt(i) & 0xFF);
		  }
		  return byteArray
		}

		function utf16leToBytes (str, units) {
		  let c, hi, lo;
		  const byteArray = [];
		  for (let i = 0; i < str.length; ++i) {
		    if ((units -= 2) < 0) break

		    c = str.charCodeAt(i);
		    hi = c >> 8;
		    lo = c % 256;
		    byteArray.push(lo);
		    byteArray.push(hi);
		  }

		  return byteArray
		}

		function base64ToBytes (str) {
		  return base64.toByteArray(base64clean(str))
		}

		function blitBuffer (src, dst, offset, length) {
		  let i;
		  for (i = 0; i < length; ++i) {
		    if ((i + offset >= dst.length) || (i >= src.length)) break
		    dst[i + offset] = src[i];
		  }
		  return i
		}

		// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
		// the `instanceof` check but they should be treated as of that type.
		// See: https://github.com/feross/buffer/issues/166
		function isInstance (obj, type) {
		  return obj instanceof type ||
		    (obj != null && obj.constructor != null && obj.constructor.name != null &&
		      obj.constructor.name === type.name)
		}
		function numberIsNaN (obj) {
		  // For IE11 support
		  return obj !== obj // eslint-disable-line no-self-compare
		}

		// Create lookup table for `toString('hex')`
		// See: https://github.com/feross/buffer/issues/219
		const hexSliceLookupTable = (function () {
		  const alphabet = '0123456789abcdef';
		  const table = new Array(256);
		  for (let i = 0; i < 16; ++i) {
		    const i16 = i * 16;
		    for (let j = 0; j < 16; ++j) {
		      table[i16 + j] = alphabet[i] + alphabet[j];
		    }
		  }
		  return table
		})();

		// Return not function with Error if BigInt not supported
		function defineBigIntMethod (fn) {
		  return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn
		}

		function BufferBigIntNotDefined () {
		  throw new Error('BigInt not supported')
		} 
	} (buffer$1));
	return buffer$1;
}

var bufferExports = requireBuffer();

/* eslint-disable */
/**
 * @walletconnect/client and @walletconnect/qrcode-modal use `global` and `Buffer`, respectively.
 * This issue is captured here: https://github.com/WalletConnect/walletconnect-monorepo/issues/341
 * Here are some GH issues of others facing the same problem:
 *   * https://github.com/WalletConnect/walletconnect-monorepo/issues/734
 *   * https://github.com/WalletConnect/walletconnect-monorepo/issues/748
 */
if (typeof window !== 'undefined') {
    window.global = globalThis;
    Object.assign(window, { Buffer: bufferExports.Buffer });
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter$f(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var eventemitter3 = {exports: {}};

var hasRequiredEventemitter3;

function requireEventemitter3 () {
	if (hasRequiredEventemitter3) return eventemitter3.exports;
	hasRequiredEventemitter3 = 1;
	(function (module) {

		var has = Object.prototype.hasOwnProperty
		  , prefix = '~';

		/**
		 * Constructor to create a storage for our `EE` objects.
		 * An `Events` instance is a plain object whose properties are event names.
		 *
		 * @constructor
		 * @private
		 */
		function Events() {}

		//
		// We try to not inherit from `Object.prototype`. In some engines creating an
		// instance in this way is faster than calling `Object.create(null)` directly.
		// If `Object.create(null)` is not supported we prefix the event names with a
		// character to make sure that the built-in object properties are not
		// overridden or used as an attack vector.
		//
		if (Object.create) {
		  Events.prototype = Object.create(null);

		  //
		  // This hack is needed because the `__proto__` property is still inherited in
		  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
		  //
		  if (!new Events().__proto__) prefix = false;
		}

		/**
		 * Representation of a single event listener.
		 *
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
		 * @constructor
		 * @private
		 */
		function EE(fn, context, once) {
		  this.fn = fn;
		  this.context = context;
		  this.once = once || false;
		}

		/**
		 * Add a listener for a given event.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} once Specify if the listener is a one-time listener.
		 * @returns {EventEmitter}
		 * @private
		 */
		function addListener(emitter, event, fn, context, once) {
		  if (typeof fn !== 'function') {
		    throw new TypeError('The listener must be a function');
		  }

		  var listener = new EE(fn, context || emitter, once)
		    , evt = prefix ? prefix + event : event;

		  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
		  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
		  else emitter._events[evt] = [emitter._events[evt], listener];

		  return emitter;
		}

		/**
		 * Clear event by name.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} evt The Event name.
		 * @private
		 */
		function clearEvent(emitter, evt) {
		  if (--emitter._eventsCount === 0) emitter._events = new Events();
		  else delete emitter._events[evt];
		}

		/**
		 * Minimal `EventEmitter` interface that is molded against the Node.js
		 * `EventEmitter` interface.
		 *
		 * @constructor
		 * @public
		 */
		function EventEmitter() {
		  this._events = new Events();
		  this._eventsCount = 0;
		}

		/**
		 * Return an array listing the events for which the emitter has registered
		 * listeners.
		 *
		 * @returns {Array}
		 * @public
		 */
		EventEmitter.prototype.eventNames = function eventNames() {
		  var names = []
		    , events
		    , name;

		  if (this._eventsCount === 0) return names;

		  for (name in (events = this._events)) {
		    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
		  }

		  if (Object.getOwnPropertySymbols) {
		    return names.concat(Object.getOwnPropertySymbols(events));
		  }

		  return names;
		};

		/**
		 * Return the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Array} The registered listeners.
		 * @public
		 */
		EventEmitter.prototype.listeners = function listeners(event) {
		  var evt = prefix ? prefix + event : event
		    , handlers = this._events[evt];

		  if (!handlers) return [];
		  if (handlers.fn) return [handlers.fn];

		  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
		    ee[i] = handlers[i].fn;
		  }

		  return ee;
		};

		/**
		 * Return the number of listeners listening to a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Number} The number of listeners.
		 * @public
		 */
		EventEmitter.prototype.listenerCount = function listenerCount(event) {
		  var evt = prefix ? prefix + event : event
		    , listeners = this._events[evt];

		  if (!listeners) return 0;
		  if (listeners.fn) return 1;
		  return listeners.length;
		};

		/**
		 * Calls each of the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Boolean} `true` if the event had listeners, else `false`.
		 * @public
		 */
		EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
		  var evt = prefix ? prefix + event : event;

		  if (!this._events[evt]) return false;

		  var listeners = this._events[evt]
		    , len = arguments.length
		    , args
		    , i;

		  if (listeners.fn) {
		    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

		    switch (len) {
		      case 1: return listeners.fn.call(listeners.context), true;
		      case 2: return listeners.fn.call(listeners.context, a1), true;
		      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
		      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
		      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
		      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
		    }

		    for (i = 1, args = new Array(len -1); i < len; i++) {
		      args[i - 1] = arguments[i];
		    }

		    listeners.fn.apply(listeners.context, args);
		  } else {
		    var length = listeners.length
		      , j;

		    for (i = 0; i < length; i++) {
		      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

		      switch (len) {
		        case 1: listeners[i].fn.call(listeners[i].context); break;
		        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
		        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
		        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
		        default:
		          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
		            args[j - 1] = arguments[j];
		          }

		          listeners[i].fn.apply(listeners[i].context, args);
		      }
		    }
		  }

		  return true;
		};

		/**
		 * Add a listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.on = function on(event, fn, context) {
		  return addListener(this, event, fn, context, false);
		};

		/**
		 * Add a one-time listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.once = function once(event, fn, context) {
		  return addListener(this, event, fn, context, true);
		};

		/**
		 * Remove the listeners of a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn Only remove the listeners that match this function.
		 * @param {*} context Only remove the listeners that have this context.
		 * @param {Boolean} once Only remove one-time listeners.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
		  var evt = prefix ? prefix + event : event;

		  if (!this._events[evt]) return this;
		  if (!fn) {
		    clearEvent(this, evt);
		    return this;
		  }

		  var listeners = this._events[evt];

		  if (listeners.fn) {
		    if (
		      listeners.fn === fn &&
		      (!once || listeners.once) &&
		      (!context || listeners.context === context)
		    ) {
		      clearEvent(this, evt);
		    }
		  } else {
		    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
		      if (
		        listeners[i].fn !== fn ||
		        (once && !listeners[i].once) ||
		        (context && listeners[i].context !== context)
		      ) {
		        events.push(listeners[i]);
		      }
		    }

		    //
		    // Reset the array, or remove it completely if we have no more listeners.
		    //
		    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
		    else clearEvent(this, evt);
		  }

		  return this;
		};

		/**
		 * Remove all listeners, or those of the specified event.
		 *
		 * @param {(String|Symbol)} [event] The event name.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */
		EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
		  var evt;

		  if (event) {
		    evt = prefix ? prefix + event : event;
		    if (this._events[evt]) clearEvent(this, evt);
		  } else {
		    this._events = new Events();
		    this._eventsCount = 0;
		  }

		  return this;
		};

		//
		// Alias methods names because people roll like that.
		//
		EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
		EventEmitter.prototype.addListener = EventEmitter.prototype.on;

		//
		// Expose the prefix.
		//
		EventEmitter.prefixed = prefix;

		//
		// Allow `EventEmitter` to be imported as module namespace.
		//
		EventEmitter.EventEmitter = EventEmitter;

		//
		// Expose the module.
		//
		{
		  module.exports = EventEmitter;
		} 
	} (eventemitter3));
	return eventemitter3.exports;
}

var eventemitter3Exports = requireEventemitter3();
var EventEmitter$1 = /*@__PURE__*/getDefaultExportFromCjs(eventemitter3Exports);

var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 1] = "INFO";
    LogLevel[LogLevel["WARN"] = 2] = "WARN";
    LogLevel[LogLevel["ERROR"] = 3] = "ERROR";
    LogLevel[LogLevel["MUTE"] = 99] = "MUTE";
})(LogLevel || (LogLevel = {}));

const deepMerge$1 = (obj1, obj2) => {
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
        // If either obj1 or obj2 is not an object, return obj1
        return obj2;
    }
    // Create a new object to store the merged result
    const result = Object.assign({}, obj1);
    for (const key in obj2) {
        if (Object.prototype.hasOwnProperty.call(obj2, key)) {
            if (typeof obj2[key] === 'object' &&
                Object.prototype.hasOwnProperty.call(obj1, key) &&
                typeof obj1[key] === 'object') {
                // If both obj1 and obj2 have objects with the same key, recursively merge them
                result[key] = deepMerge$1(obj1[key], obj2[key]);
            }
            else {
                // Otherwise, simply assign the value from obj2 to the result
                result[key] = obj2[key];
            }
        }
    }
    return result;
};

/**
 * Class representing metadata with support for nested keys and deep merging.
 */
class MetaData {
    constructor(meta = {}) {
        this.meta = {};
        this.meta = meta;
    }
    /**
     * Sets a value in the metadata using dot notation for nested keys.
     * @param {string} key - The key in dot notation (e.g., "a.b.c").
     * @param {unknown} value - The value to set.
     */
    set(key, value) {
        const data = {};
        key.split('.').reduce((acc, k, i, arr) => {
            if (i === arr.length - 1) {
                acc[k] = value;
            }
            else {
                if (!acc[k]) {
                    acc[k] = {};
                }
                return acc[k];
            }
        }, data);
        this.meta = deepMerge$1(this.meta, data);
    }
    /**
     * Retrieves the current metadata.
     * @returns {TMetaData} The metadata.
     */
    get() {
        return this.meta;
    }
    /**
     * Clears the metadata.
     */
    clear() {
        this.meta = {};
    }
    /**
     * Merges another MetaData instance into another MetaData instance.
     * @param {MetaData} meta - The MetaData instance to merge.
     * @returns {MetaData} A new MetaData instance with merged metadata.
     */
    merge(meta) {
        return new MetaData(deepMerge$1(this.get(), meta.get()));
    }
}

/**
 * Split args into object and non-object args
 * @param message
 * @returns
 */
const processArgs = (message) => {
    // Apply object args to body
    const objectArgs = message.args.filter((arg) => typeof arg === 'object');
    // Capture remaining non-object args
    const remainingArgs = message.args
        .filter((arg) => typeof arg !== 'object' || arg instanceof Error)
        .map((arg) => arg.toString());
    return { objectArgs, remainingArgs };
};

/* eslint-disable @typescript-eslint/no-explicit-any, no-console */
const IGNORE_MESSAGES = ['Failed to send logs to server'];
const messageQueue = [];
let Logger$1 = class Logger {
    constructor(name, level) {
        var _a;
        this.name = name;
        this.metaData = new MetaData();
        if (level === undefined &&
            typeof process !== 'undefined' &&
            ((_a = process.env) === null || _a === void 0 ? void 0 : _a['NODE_ENV']) !== 'production') {
            this.level = LogLevel.DEBUG;
        }
        else if (level === undefined) {
            this.level = LogLevel.WARN;
        }
        else {
            this.level = level;
        }
    }
    static setEmitErrors(emit) {
        if (emit !== undefined) {
            Logger.globalKeys.emitErrors = emit;
        }
    }
    static setEnvironmentId(environmentId) {
        if (environmentId !== undefined) {
            Logger.globalKeys.environmentId = environmentId;
        }
    }
    getNameArray(name) {
        return Array.isArray(name) ? name : [name];
    }
    createLogger(name, level) {
        return new Logger([...this.getNameArray(this.name), ...this.getNameArray(name)], level !== null && level !== void 0 ? level : this.level);
    }
    get logLevel() {
        return LogLevel[this.level];
    }
    setLogLevel(level) {
        if (level in LogLevel && typeof level === 'string') {
            this.level = LogLevel[level];
        }
        else if (level in LogLevel && typeof level === 'number') {
            this.level = level;
        }
        else {
            throw new Error(`Invalid log level: ${level}`);
        }
    }
    formatMessage(level, message) {
        var _a;
        if (message instanceof Error) {
            message = message.stack;
        }
        else if (
        // Handle Error-Like Objects
        message instanceof Object &&
            Object.prototype.hasOwnProperty.call(message, 'stack')) {
            message = message.stack;
        }
        else if (message instanceof Object) {
            message = JSON.stringify(message);
        }
        const names = (Array.isArray(this.name) ? this.name : [this.name]).map((name) => `[${name}]`);
        return `${names.join('')} [${(_a = LogLevel[level]) !== null && _a !== void 0 ? _a : 'TROUBLESHOOTING'}]: ${message}`;
    }
    captureAndSend(level, message, ...args) {
        return __awaiter$f(this, void 0, void 0, function* () {
            if (Logger.globalKeys.emitErrors &&
                !IGNORE_MESSAGES.includes(message === null || message === void 0 ? void 0 : message.toString()) &&
                typeof window !== 'undefined') {
                this.emitHttpLogs(level, message, { args });
            }
        });
    }
    emitHttpLogs(level, message, { args = [], transformMeta = (meta) => meta }) {
        messageQueue.push({ args, level, message });
        if (messageQueue.length === 1) {
            /**
             * Batching the logs to send them in a single request
             * https://developer.mozilla.org/en-US/docs/Web/API/HTML_DOM_API/Microtask_guide#batching_operations
             *
             * Essentially, multiple calls to log in the same event loop will be batched into a single request
             */
            queueMicrotask(() => __awaiter$f(this, void 0, void 0, function* () {
                var _a, _b;
                const messages = [];
                messageQueue.forEach((msg) => {
                    var _a, _b, _c, _d, _e, _f;
                    const body = {};
                    const { objectArgs, remainingArgs } = processArgs(msg);
                    Object.assign(body, ...objectArgs);
                    Object.assign(body, {
                        level: LogLevel[msg.level],
                        message: [msg.message, ...remainingArgs].join(' '),
                        meta: transformMeta(Logger.globalMetaData.merge(this.metaData).get()),
                        url: {
                            hostname: (_a = window.location) === null || _a === void 0 ? void 0 : _a.hostname,
                            origin: (_b = window.location) === null || _b === void 0 ? void 0 : _b.origin,
                            pathname: (_c = window.location) === null || _c === void 0 ? void 0 : _c.pathname,
                            port: (_d = window.location) === null || _d === void 0 ? void 0 : _d.port,
                            protocol: (_e = window.location) === null || _e === void 0 ? void 0 : _e.protocol,
                        },
                        userAgent: (_f = window.navigator) === null || _f === void 0 ? void 0 : _f.userAgent,
                    });
                    messages.push(body);
                });
                try {
                    if (!((_a = Logger.globalKeys) === null || _a === void 0 ? void 0 : _a.environmentId)) {
                        throw new Error('Environment ID not set');
                    }
                    yield fetch(`https://logs.dynamicauth.com/api/v1/${(_b = Logger.globalKeys) === null || _b === void 0 ? void 0 : _b.environmentId}`, {
                        body: JSON.stringify(messages),
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        method: 'POST',
                        mode: 'cors',
                        referrerPolicy: 'origin-when-cross-origin',
                    });
                }
                catch (error) {
                    this.debug('Failed to send logs to server', error);
                }
                messageQueue.length = 0;
            }));
        }
    }
    /**
     * Emits an INFO type message to the backend for analysis and debugging
     */
    instrument(message, options) {
        return this.emitHttpLogs(LogLevel.INFO, message, {
            args: [options],
            // Don't send any meta to avoid storing PII
            transformMeta: () => undefined,
        });
    }
    log(level, message, ...args) {
        const enableTroubleshootMode = typeof window !== 'undefined' &&
            (window === null || window === void 0 ? void 0 : window.dynamic_enableTroubleshootMode) === true;
        if (!enableTroubleshootMode &&
            (level < this.level || level === LogLevel.MUTE)) {
            return;
        }
        const fmtMsg = this.formatMessage(level, message);
        switch (level) {
            case LogLevel.WARN:
                console.warn(fmtMsg, ...args);
                break;
            case LogLevel.ERROR:
                console.error(fmtMsg, ...args);
                break;
            default:
                console.log(fmtMsg, ...args);
        }
        if (level === LogLevel.ERROR) {
            this.captureAndSend(level, message, ...args);
        }
    }
    logVerboseTroubleshootingMessage(message, ...args) {
        this.log(-1, message, ...args);
    }
    debug(message, ...args) {
        this.log(LogLevel.DEBUG, message, ...args);
    }
    info(message, ...args) {
        this.log(LogLevel.INFO, message, ...args);
    }
    warn(message, ...args) {
        this.log(LogLevel.WARN, message, ...args);
    }
    error(message, ...args) {
        Logger.events.emit('error', message, ...args);
        this.log(LogLevel.ERROR, message, ...args);
    }
};
Logger$1.globalKeys = {
    emitErrors: true,
};
Logger$1.globalMetaData = new MetaData();
Logger$1.events = new EventEmitter$1();

/**
 * A mapping of package names to their versions.
 */
let packageVersions = {};
const logger$a = new Logger$1('@dynamic-labs/assert-package-version');
/**
 * Timeout ID for batching version checks.
 */
let versionCheckTimeout = null;
/**
 * Asserts that all `@dynamic-labs` packages are on the same version.
 * Throws an error with instructions if versions mismatch.
 *
 * @param {string} packageName - The name of the package to assert.
 * @param {string} version - The version of the package.
 */
const assertPackageVersion = (packageName, version) => {
    // Update the package version mapping
    packageVersions[packageName] = version;
    // Clear any existing timeout
    if (versionCheckTimeout) {
        clearTimeout(versionCheckTimeout);
        versionCheckTimeout = null;
    }
    /**
     * Timeout is set to 100ms to ensure the following:
     * - All package versions have been imported and registered.
     * - The environmentId is set in the logger so the error can be captured in DD
     */
    const timeout = 100;
    /**
     * Set a timeout to batch the version check.
     * This ensures that the check is executed after all package versions have been imported
     * and registered.
     */
    versionCheckTimeout = setTimeout(() => {
        const versions = Object.values(packageVersions);
        const [firstVersion] = versions;
        const allSameVersion = versions.every((v) => v === firstVersion);
        if (!allSameVersion) {
            // Determine the required (target) version
            const targetVersion = packageVersions['@dynamic-labs/sdk-react-core'] || firstVersion;
            const errorMessage = getErrorMessage(targetVersion);
            logger$a.error(new Error(errorMessage));
        }
        versionCheckTimeout = null;
    }, timeout);
};
const getErrorMessage = (targetVersion) => {
    // Identify packages with mismatched versions
    const affectedPackages = Object.entries(packageVersions)
        .filter(([, v]) => v !== targetVersion)
        .map(([pkgName, installedVersion]) => `- \`${pkgName}\` (installed: **${installedVersion}**, required: **${targetVersion}**)`)
        .join('\n');
    // Error message template
    const errorMessage = `
🚨 Version Mismatch Error

One or more \`@dynamic-labs\` packages are installed with mismatched versions. All \`@dynamic-labs\` packages must be on the same version to work correctly.

Affected Packages:
${affectedPackages}

💡 To fix this issue, update all @dynamic-labs/* packages to version \`${targetVersion}\` in your package.json
💡 Tip: You can use the \`npx dynamic-doctor run\` command to check for other issues with your project setup.
`;
    return errorMessage.trim();
};

var version$i = "4.6.1";

var version$h = "4.6.1";

function __awaiter$e(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const version$g = '1.0.8';

let BaseError$2 = class BaseError extends Error {
    constructor(shortMessage, args = {}) {
        const details = args.cause instanceof BaseError
            ? args.cause.details
            : args.cause?.message
                ? args.cause.message
                : args.details;
        const docsPath = args.cause instanceof BaseError
            ? args.cause.docsPath || args.docsPath
            : args.docsPath;
        const message = [
            shortMessage || 'An error occurred.',
            '',
            ...(args.metaMessages ? [...args.metaMessages, ''] : []),
            ...(docsPath ? [`Docs: https://abitype.dev${docsPath}`] : []),
            ...(details ? [`Details: ${details}`] : []),
            `Version: abitype@${version$g}`,
        ].join('\n');
        super(message);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'AbiTypeError'
        });
        if (args.cause)
            this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
};

// TODO: This looks cool. Need to check the performance of `new RegExp` versus defined inline though.
// https://twitter.com/GabrielVergnaud/status/1622906834343366657
function execTyped(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
}
// `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
// https://regexr.com/6va55
const bytesRegex$1 = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
// `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
// https://regexr.com/6v8hp
const integerRegex$1 = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const isTupleRegex = /^\(.+?\).*?$/;

// https://regexr.com/7f7rv
const tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
/**
 * Formats {@link AbiParameter} to human-readable ABI parameter.
 *
 * @param abiParameter - ABI parameter
 * @returns Human-readable ABI parameter
 *
 * @example
 * const result = formatAbiParameter({ type: 'address', name: 'from' })
 * //    ^? const result: 'address from'
 */
function formatAbiParameter(abiParameter) {
    let type = abiParameter.type;
    if (tupleRegex.test(abiParameter.type) && 'components' in abiParameter) {
        type = '(';
        const length = abiParameter.components.length;
        for (let i = 0; i < length; i++) {
            const component = abiParameter.components[i];
            type += formatAbiParameter(component);
            if (i < length - 1)
                type += ', ';
        }
        const result = execTyped(tupleRegex, abiParameter.type);
        type += `)${result?.array ?? ''}`;
        return formatAbiParameter({
            ...abiParameter,
            type,
        });
    }
    // Add `indexed` to type if in `abiParameter`
    if ('indexed' in abiParameter && abiParameter.indexed)
        type = `${type} indexed`;
    // Return human-readable ABI parameter
    if (abiParameter.name)
        return `${type} ${abiParameter.name}`;
    return type;
}

/**
 * Formats {@link AbiParameter}s to human-readable ABI parameters.
 *
 * @param abiParameters - ABI parameters
 * @returns Human-readable ABI parameters
 *
 * @example
 * const result = formatAbiParameters([
 *   //  ^? const result: 'address from, uint256 tokenId'
 *   { type: 'address', name: 'from' },
 *   { type: 'uint256', name: 'tokenId' },
 * ])
 */
function formatAbiParameters(abiParameters) {
    let params = '';
    const length = abiParameters.length;
    for (let i = 0; i < length; i++) {
        const abiParameter = abiParameters[i];
        params += formatAbiParameter(abiParameter);
        if (i !== length - 1)
            params += ', ';
    }
    return params;
}

/**
 * Formats ABI item (e.g. error, event, function) into human-readable ABI item
 *
 * @param abiItem - ABI item
 * @returns Human-readable ABI item
 */
function formatAbiItem$1(abiItem) {
    if (abiItem.type === 'function')
        return `function ${abiItem.name}(${formatAbiParameters(abiItem.inputs)})${abiItem.stateMutability && abiItem.stateMutability !== 'nonpayable'
            ? ` ${abiItem.stateMutability}`
            : ''}${abiItem.outputs?.length
            ? ` returns (${formatAbiParameters(abiItem.outputs)})`
            : ''}`;
    if (abiItem.type === 'event')
        return `event ${abiItem.name}(${formatAbiParameters(abiItem.inputs)})`;
    if (abiItem.type === 'error')
        return `error ${abiItem.name}(${formatAbiParameters(abiItem.inputs)})`;
    if (abiItem.type === 'constructor')
        return `constructor(${formatAbiParameters(abiItem.inputs)})${abiItem.stateMutability === 'payable' ? ' payable' : ''}`;
    if (abiItem.type === 'fallback')
        return `fallback() external${abiItem.stateMutability === 'payable' ? ' payable' : ''}`;
    return 'receive() external payable';
}

// https://regexr.com/7gmok
const errorSignatureRegex = /^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function isErrorSignature(signature) {
    return errorSignatureRegex.test(signature);
}
function execErrorSignature(signature) {
    return execTyped(errorSignatureRegex, signature);
}
// https://regexr.com/7gmoq
const eventSignatureRegex = /^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function isEventSignature(signature) {
    return eventSignatureRegex.test(signature);
}
function execEventSignature(signature) {
    return execTyped(eventSignatureRegex, signature);
}
// https://regexr.com/7gmot
const functionSignatureRegex = /^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\s?\((?<returns>.*?)\))?$/;
function isFunctionSignature(signature) {
    return functionSignatureRegex.test(signature);
}
function execFunctionSignature(signature) {
    return execTyped(functionSignatureRegex, signature);
}
// https://regexr.com/7gmp3
const structSignatureRegex = /^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \{(?<properties>.*?)\}$/;
function isStructSignature(signature) {
    return structSignatureRegex.test(signature);
}
function execStructSignature(signature) {
    return execTyped(structSignatureRegex, signature);
}
// https://regexr.com/78u01
const constructorSignatureRegex = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function isConstructorSignature(signature) {
    return constructorSignatureRegex.test(signature);
}
function execConstructorSignature(signature) {
    return execTyped(constructorSignatureRegex, signature);
}
// https://regexr.com/7srtn
const fallbackSignatureRegex = /^fallback\(\) external(?:\s(?<stateMutability>payable{1}))?$/;
function isFallbackSignature(signature) {
    return fallbackSignatureRegex.test(signature);
}
function execFallbackSignature(signature) {
    return execTyped(fallbackSignatureRegex, signature);
}
// https://regexr.com/78u1k
const receiveSignatureRegex = /^receive\(\) external payable$/;
function isReceiveSignature(signature) {
    return receiveSignatureRegex.test(signature);
}
const eventModifiers = new Set(['indexed']);
const functionModifiers = new Set([
    'calldata',
    'memory',
    'storage',
]);

class UnknownTypeError extends BaseError$2 {
    constructor({ type }) {
        super('Unknown type.', {
            metaMessages: [
                `Type "${type}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`,
            ],
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UnknownTypeError'
        });
    }
}
class UnknownSolidityTypeError extends BaseError$2 {
    constructor({ type }) {
        super('Unknown type.', {
            metaMessages: [`Type "${type}" is not a valid ABI type.`],
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UnknownSolidityTypeError'
        });
    }
}

class InvalidParameterError extends BaseError$2 {
    constructor({ param }) {
        super('Invalid ABI parameter.', {
            details: param,
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidParameterError'
        });
    }
}
class SolidityProtectedKeywordError extends BaseError$2 {
    constructor({ param, name }) {
        super('Invalid ABI parameter.', {
            details: param,
            metaMessages: [
                `"${name}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`,
            ],
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'SolidityProtectedKeywordError'
        });
    }
}
class InvalidModifierError extends BaseError$2 {
    constructor({ param, type, modifier, }) {
        super('Invalid ABI parameter.', {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ''}.`,
            ],
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidModifierError'
        });
    }
}
class InvalidFunctionModifierError extends BaseError$2 {
    constructor({ param, type, modifier, }) {
        super('Invalid ABI parameter.', {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ''}.`,
                `Data location can only be specified for array, struct, or mapping types, but "${modifier}" was given.`,
            ],
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidFunctionModifierError'
        });
    }
}
class InvalidAbiTypeParameterError extends BaseError$2 {
    constructor({ abiParameter, }) {
        super('Invalid ABI parameter.', {
            details: JSON.stringify(abiParameter, null, 2),
            metaMessages: ['ABI parameter type is invalid.'],
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidAbiTypeParameterError'
        });
    }
}

class InvalidSignatureError extends BaseError$2 {
    constructor({ signature, type, }) {
        super(`Invalid ${type} signature.`, {
            details: signature,
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidSignatureError'
        });
    }
}
class UnknownSignatureError extends BaseError$2 {
    constructor({ signature }) {
        super('Unknown signature.', {
            details: signature,
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'UnknownSignatureError'
        });
    }
}
class InvalidStructSignatureError extends BaseError$2 {
    constructor({ signature }) {
        super('Invalid struct signature.', {
            details: signature,
            metaMessages: ['No properties exist.'],
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidStructSignatureError'
        });
    }
}

class CircularReferenceError extends BaseError$2 {
    constructor({ type }) {
        super('Circular reference detected.', {
            metaMessages: [`Struct "${type}" is a circular reference.`],
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'CircularReferenceError'
        });
    }
}

class InvalidParenthesisError extends BaseError$2 {
    constructor({ current, depth }) {
        super('Unbalanced parentheses.', {
            metaMessages: [
                `"${current.trim()}" has too many ${depth > 0 ? 'opening' : 'closing'} parentheses.`,
            ],
            details: `Depth "${depth}"`,
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'InvalidParenthesisError'
        });
    }
}

/**
 * Gets {@link parameterCache} cache key namespaced by {@link type}. This prevents parameters from being accessible to types that don't allow them (e.g. `string indexed foo` not allowed outside of `type: 'event'`).
 * @param param ABI parameter string
 * @param type ABI parameter type
 * @returns Cache key for {@link parameterCache}
 */
function getParameterCacheKey(param, type, structs) {
    let structKey = '';
    if (structs)
        for (const struct of Object.entries(structs)) {
            if (!struct)
                continue;
            let propertyKey = '';
            for (const property of struct[1]) {
                propertyKey += `[${property.type}${property.name ? `:${property.name}` : ''}]`;
            }
            structKey += `(${struct[0]}{${propertyKey}})`;
        }
    if (type)
        return `${type}:${param}${structKey}`;
    return param;
}
/**
 * Basic cache seeded with common ABI parameter strings.
 *
 * **Note: When seeding more parameters, make sure you benchmark performance. The current number is the ideal balance between performance and having an already existing cache.**
 */
const parameterCache = new Map([
    // Unnamed
    ['address', { type: 'address' }],
    ['bool', { type: 'bool' }],
    ['bytes', { type: 'bytes' }],
    ['bytes32', { type: 'bytes32' }],
    ['int', { type: 'int256' }],
    ['int256', { type: 'int256' }],
    ['string', { type: 'string' }],
    ['uint', { type: 'uint256' }],
    ['uint8', { type: 'uint8' }],
    ['uint16', { type: 'uint16' }],
    ['uint24', { type: 'uint24' }],
    ['uint32', { type: 'uint32' }],
    ['uint64', { type: 'uint64' }],
    ['uint96', { type: 'uint96' }],
    ['uint112', { type: 'uint112' }],
    ['uint160', { type: 'uint160' }],
    ['uint192', { type: 'uint192' }],
    ['uint256', { type: 'uint256' }],
    // Named
    ['address owner', { type: 'address', name: 'owner' }],
    ['address to', { type: 'address', name: 'to' }],
    ['bool approved', { type: 'bool', name: 'approved' }],
    ['bytes _data', { type: 'bytes', name: '_data' }],
    ['bytes data', { type: 'bytes', name: 'data' }],
    ['bytes signature', { type: 'bytes', name: 'signature' }],
    ['bytes32 hash', { type: 'bytes32', name: 'hash' }],
    ['bytes32 r', { type: 'bytes32', name: 'r' }],
    ['bytes32 root', { type: 'bytes32', name: 'root' }],
    ['bytes32 s', { type: 'bytes32', name: 's' }],
    ['string name', { type: 'string', name: 'name' }],
    ['string symbol', { type: 'string', name: 'symbol' }],
    ['string tokenURI', { type: 'string', name: 'tokenURI' }],
    ['uint tokenId', { type: 'uint256', name: 'tokenId' }],
    ['uint8 v', { type: 'uint8', name: 'v' }],
    ['uint256 balance', { type: 'uint256', name: 'balance' }],
    ['uint256 tokenId', { type: 'uint256', name: 'tokenId' }],
    ['uint256 value', { type: 'uint256', name: 'value' }],
    // Indexed
    [
        'event:address indexed from',
        { type: 'address', name: 'from', indexed: true },
    ],
    ['event:address indexed to', { type: 'address', name: 'to', indexed: true }],
    [
        'event:uint indexed tokenId',
        { type: 'uint256', name: 'tokenId', indexed: true },
    ],
    [
        'event:uint256 indexed tokenId',
        { type: 'uint256', name: 'tokenId', indexed: true },
    ],
]);

function parseSignature(signature, structs = {}) {
    if (isFunctionSignature(signature))
        return parseFunctionSignature(signature, structs);
    if (isEventSignature(signature))
        return parseEventSignature(signature, structs);
    if (isErrorSignature(signature))
        return parseErrorSignature(signature, structs);
    if (isConstructorSignature(signature))
        return parseConstructorSignature(signature, structs);
    if (isFallbackSignature(signature))
        return parseFallbackSignature(signature);
    if (isReceiveSignature(signature))
        return {
            type: 'receive',
            stateMutability: 'payable',
        };
    throw new UnknownSignatureError({ signature });
}
function parseFunctionSignature(signature, structs = {}) {
    const match = execFunctionSignature(signature);
    if (!match)
        throw new InvalidSignatureError({ signature, type: 'function' });
    const inputParams = splitParameters(match.parameters);
    const inputs = [];
    const inputLength = inputParams.length;
    for (let i = 0; i < inputLength; i++) {
        inputs.push(parseAbiParameter(inputParams[i], {
            modifiers: functionModifiers,
            structs,
            type: 'function',
        }));
    }
    const outputs = [];
    if (match.returns) {
        const outputParams = splitParameters(match.returns);
        const outputLength = outputParams.length;
        for (let i = 0; i < outputLength; i++) {
            outputs.push(parseAbiParameter(outputParams[i], {
                modifiers: functionModifiers,
                structs,
                type: 'function',
            }));
        }
    }
    return {
        name: match.name,
        type: 'function',
        stateMutability: match.stateMutability ?? 'nonpayable',
        inputs,
        outputs,
    };
}
function parseEventSignature(signature, structs = {}) {
    const match = execEventSignature(signature);
    if (!match)
        throw new InvalidSignatureError({ signature, type: 'event' });
    const params = splitParameters(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for (let i = 0; i < length; i++)
        abiParameters.push(parseAbiParameter(params[i], {
            modifiers: eventModifiers,
            structs,
            type: 'event',
        }));
    return { name: match.name, type: 'event', inputs: abiParameters };
}
function parseErrorSignature(signature, structs = {}) {
    const match = execErrorSignature(signature);
    if (!match)
        throw new InvalidSignatureError({ signature, type: 'error' });
    const params = splitParameters(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for (let i = 0; i < length; i++)
        abiParameters.push(parseAbiParameter(params[i], { structs, type: 'error' }));
    return { name: match.name, type: 'error', inputs: abiParameters };
}
function parseConstructorSignature(signature, structs = {}) {
    const match = execConstructorSignature(signature);
    if (!match)
        throw new InvalidSignatureError({ signature, type: 'constructor' });
    const params = splitParameters(match.parameters);
    const abiParameters = [];
    const length = params.length;
    for (let i = 0; i < length; i++)
        abiParameters.push(parseAbiParameter(params[i], { structs, type: 'constructor' }));
    return {
        type: 'constructor',
        stateMutability: match.stateMutability ?? 'nonpayable',
        inputs: abiParameters,
    };
}
function parseFallbackSignature(signature) {
    const match = execFallbackSignature(signature);
    if (!match)
        throw new InvalidSignatureError({ signature, type: 'fallback' });
    return {
        type: 'fallback',
        stateMutability: match.stateMutability ?? 'nonpayable',
    };
}
const abiParameterWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const abiParameterWithTupleRegex = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const dynamicIntegerRegex = /^u?int$/;
function parseAbiParameter(param, options) {
    // optional namespace cache by `type`
    const parameterCacheKey = getParameterCacheKey(param, options?.type, options?.structs);
    if (parameterCache.has(parameterCacheKey))
        return parameterCache.get(parameterCacheKey);
    const isTuple = isTupleRegex.test(param);
    const match = execTyped(isTuple ? abiParameterWithTupleRegex : abiParameterWithoutTupleRegex, param);
    if (!match)
        throw new InvalidParameterError({ param });
    if (match.name && isSolidityKeyword(match.name))
        throw new SolidityProtectedKeywordError({ param, name: match.name });
    const name = match.name ? { name: match.name } : {};
    const indexed = match.modifier === 'indexed' ? { indexed: true } : {};
    const structs = options?.structs ?? {};
    let type;
    let components = {};
    if (isTuple) {
        type = 'tuple';
        const params = splitParameters(match.type);
        const components_ = [];
        const length = params.length;
        for (let i = 0; i < length; i++) {
            // remove `modifiers` from `options` to prevent from being added to tuple components
            components_.push(parseAbiParameter(params[i], { structs }));
        }
        components = { components: components_ };
    }
    else if (match.type in structs) {
        type = 'tuple';
        components = { components: structs[match.type] };
    }
    else if (dynamicIntegerRegex.test(match.type)) {
        type = `${match.type}256`;
    }
    else {
        type = match.type;
        if (!(options?.type === 'struct') && !isSolidityType(type))
            throw new UnknownSolidityTypeError({ type });
    }
    if (match.modifier) {
        // Check if modifier exists, but is not allowed (e.g. `indexed` in `functionModifiers`)
        if (!options?.modifiers?.has?.(match.modifier))
            throw new InvalidModifierError({
                param,
                type: options?.type,
                modifier: match.modifier,
            });
        // Check if resolved `type` is valid if there is a function modifier
        if (functionModifiers.has(match.modifier) &&
            !isValidDataLocation(type, !!match.array))
            throw new InvalidFunctionModifierError({
                param,
                type: options?.type,
                modifier: match.modifier,
            });
    }
    const abiParameter = {
        type: `${type}${match.array ?? ''}`,
        ...name,
        ...indexed,
        ...components,
    };
    parameterCache.set(parameterCacheKey, abiParameter);
    return abiParameter;
}
// s/o latika for this
function splitParameters(params, result = [], current = '', depth = 0) {
    const length = params.trim().length;
    // biome-ignore lint/correctness/noUnreachable: recursive
    for (let i = 0; i < length; i++) {
        const char = params[i];
        const tail = params.slice(i + 1);
        switch (char) {
            case ',':
                return depth === 0
                    ? splitParameters(tail, [...result, current.trim()])
                    : splitParameters(tail, result, `${current}${char}`, depth);
            case '(':
                return splitParameters(tail, result, `${current}${char}`, depth + 1);
            case ')':
                return splitParameters(tail, result, `${current}${char}`, depth - 1);
            default:
                return splitParameters(tail, result, `${current}${char}`, depth);
        }
    }
    if (current === '')
        return result;
    if (depth !== 0)
        throw new InvalidParenthesisError({ current, depth });
    result.push(current.trim());
    return result;
}
function isSolidityType(type) {
    return (type === 'address' ||
        type === 'bool' ||
        type === 'function' ||
        type === 'string' ||
        bytesRegex$1.test(type) ||
        integerRegex$1.test(type));
}
const protectedKeywordsRegex = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
/** @internal */
function isSolidityKeyword(name) {
    return (name === 'address' ||
        name === 'bool' ||
        name === 'function' ||
        name === 'string' ||
        name === 'tuple' ||
        bytesRegex$1.test(name) ||
        integerRegex$1.test(name) ||
        protectedKeywordsRegex.test(name));
}
/** @internal */
function isValidDataLocation(type, isArray) {
    return isArray || type === 'bytes' || type === 'string' || type === 'tuple';
}

function parseStructs(signatures) {
    // Create "shallow" version of each struct (and filter out non-structs or invalid structs)
    const shallowStructs = {};
    const signaturesLength = signatures.length;
    for (let i = 0; i < signaturesLength; i++) {
        const signature = signatures[i];
        if (!isStructSignature(signature))
            continue;
        const match = execStructSignature(signature);
        if (!match)
            throw new InvalidSignatureError({ signature, type: 'struct' });
        const properties = match.properties.split(';');
        const components = [];
        const propertiesLength = properties.length;
        for (let k = 0; k < propertiesLength; k++) {
            const property = properties[k];
            const trimmed = property.trim();
            if (!trimmed)
                continue;
            const abiParameter = parseAbiParameter(trimmed, {
                type: 'struct',
            });
            components.push(abiParameter);
        }
        if (!components.length)
            throw new InvalidStructSignatureError({ signature });
        shallowStructs[match.name] = components;
    }
    // Resolve nested structs inside each parameter
    const resolvedStructs = {};
    const entries = Object.entries(shallowStructs);
    const entriesLength = entries.length;
    for (let i = 0; i < entriesLength; i++) {
        const [name, parameters] = entries[i];
        resolvedStructs[name] = resolveStructs(parameters, shallowStructs);
    }
    return resolvedStructs;
}
const typeWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?$/;
function resolveStructs(abiParameters, structs, ancestors = new Set()) {
    const components = [];
    const length = abiParameters.length;
    for (let i = 0; i < length; i++) {
        const abiParameter = abiParameters[i];
        const isTuple = isTupleRegex.test(abiParameter.type);
        if (isTuple)
            components.push(abiParameter);
        else {
            const match = execTyped(typeWithoutTupleRegex, abiParameter.type);
            if (!match?.type)
                throw new InvalidAbiTypeParameterError({ abiParameter });
            const { array, type } = match;
            if (type in structs) {
                if (ancestors.has(type))
                    throw new CircularReferenceError({ type });
                components.push({
                    ...abiParameter,
                    type: `tuple${array ?? ''}`,
                    components: resolveStructs(structs[type] ?? [], structs, new Set([...ancestors, type])),
                });
            }
            else {
                if (isSolidityType(type))
                    components.push(abiParameter);
                else
                    throw new UnknownTypeError({ type });
            }
        }
    }
    return components;
}

/**
 * Parses human-readable ABI into JSON {@link Abi}
 *
 * @param signatures - Human-Readable ABI
 * @returns Parsed {@link Abi}
 *
 * @example
 * const abi = parseAbi([
 *   //  ^? const abi: readonly [{ name: "balanceOf"; type: "function"; stateMutability:...
 *   'function balanceOf(address owner) view returns (uint256)',
 *   'event Transfer(address indexed from, address indexed to, uint256 amount)',
 * ])
 */
function parseAbi(signatures) {
    const structs = parseStructs(signatures);
    const abi = [];
    const length = signatures.length;
    for (let i = 0; i < length; i++) {
        const signature = signatures[i];
        if (isStructSignature(signature))
            continue;
        abi.push(parseSignature(signature, structs));
    }
    return abi;
}

/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */
function getAction(client, actionFn, 
// Some minifiers drop `Function.prototype.name`, or replace it with short letters,
// meaning that `actionFn.name` will not always work. For that case, the consumer
// needs to pass the name explicitly.
name) {
    const action_implicit = client[actionFn.name];
    if (typeof action_implicit === 'function')
        return action_implicit;
    const action_explicit = client[name];
    if (typeof action_explicit === 'function')
        return action_explicit;
    return (params) => actionFn(client, params);
}

function formatAbiItem(abiItem, { includeName = false } = {}) {
    if (abiItem.type !== 'function' &&
        abiItem.type !== 'event' &&
        abiItem.type !== 'error')
        throw new InvalidDefinitionTypeError(abiItem.type);
    return `${abiItem.name}(${formatAbiParams(abiItem.inputs, { includeName })})`;
}
function formatAbiParams(params, { includeName = false } = {}) {
    if (!params)
        return '';
    return params
        .map((param) => formatAbiParam(param, { includeName }))
        .join(includeName ? ', ' : ',');
}
function formatAbiParam(param, { includeName }) {
    if (param.type.startsWith('tuple')) {
        return `(${formatAbiParams(param.components, { includeName })})${param.type.slice('tuple'.length)}`;
    }
    return param.type + (includeName && param.name ? ` ${param.name}` : '');
}

function isHex$2(value, { strict = true } = {}) {
    if (!value)
        return false;
    if (typeof value !== 'string')
        return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith('0x');
}

/**
 * @description Retrieves the size of the value (in bytes).
 *
 * @param value The value (hex or byte array) to retrieve the size of.
 * @returns The size of the value (in bytes).
 */
function size$1(value) {
    if (isHex$2(value, { strict: false }))
        return Math.ceil((value.length - 2) / 2);
    return value.length;
}

const version$f = '2.22.22';

let errorConfig = {
    getDocsUrl: ({ docsBaseUrl, docsPath = '', docsSlug, }) => docsPath
        ? `${docsBaseUrl ?? 'https://viem.sh'}${docsPath}${docsSlug ? `#${docsSlug}` : ''}`
        : undefined,
    version: `viem@${version$f}`,
};
let BaseError$1 = class BaseError extends Error {
    constructor(shortMessage, args = {}) {
        const details = (() => {
            if (args.cause instanceof BaseError)
                return args.cause.details;
            if (args.cause?.message)
                return args.cause.message;
            return args.details;
        })();
        const docsPath = (() => {
            if (args.cause instanceof BaseError)
                return args.cause.docsPath || args.docsPath;
            return args.docsPath;
        })();
        const docsUrl = errorConfig.getDocsUrl?.({ ...args, docsPath });
        const message = [
            shortMessage || 'An error occurred.',
            '',
            ...(args.metaMessages ? [...args.metaMessages, ''] : []),
            ...(docsUrl ? [`Docs: ${docsUrl}`] : []),
            ...(details ? [`Details: ${details}`] : []),
            ...(errorConfig.version ? [`Version: ${errorConfig.version}`] : []),
        ].join('\n');
        super(message, args.cause ? { cause: args.cause } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'BaseError'
        });
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.name = args.name ?? this.name;
        this.shortMessage = shortMessage;
        this.version = version$f;
    }
    walk(fn) {
        return walk$1(this, fn);
    }
};
function walk$1(err, fn) {
    if (fn?.(err))
        return err;
    if (err &&
        typeof err === 'object' &&
        'cause' in err &&
        err.cause !== undefined)
        return walk$1(err.cause, fn);
    return fn ? null : err;
}

class AbiConstructorNotFoundError extends BaseError$1 {
    constructor({ docsPath }) {
        super([
            'A constructor was not found on the ABI.',
            'Make sure you are using the correct ABI and that the constructor exists on it.',
        ].join('\n'), {
            docsPath,
            name: 'AbiConstructorNotFoundError',
        });
    }
}
class AbiConstructorParamsNotFoundError extends BaseError$1 {
    constructor({ docsPath }) {
        super([
            'Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.',
            'Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists.',
        ].join('\n'), {
            docsPath,
            name: 'AbiConstructorParamsNotFoundError',
        });
    }
}
class AbiDecodingDataSizeTooSmallError extends BaseError$1 {
    constructor({ data, params, size, }) {
        super([`Data size of ${size} bytes is too small for given parameters.`].join('\n'), {
            metaMessages: [
                `Params: (${formatAbiParams(params, { includeName: true })})`,
                `Data:   ${data} (${size} bytes)`,
            ],
            name: 'AbiDecodingDataSizeTooSmallError',
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class AbiDecodingZeroDataError extends BaseError$1 {
    constructor() {
        super('Cannot decode zero data ("0x") with ABI parameters.', {
            name: 'AbiDecodingZeroDataError',
        });
    }
}
class AbiEncodingArrayLengthMismatchError extends BaseError$1 {
    constructor({ expectedLength, givenLength, type, }) {
        super([
            `ABI encoding array length mismatch for type ${type}.`,
            `Expected length: ${expectedLength}`,
            `Given length: ${givenLength}`,
        ].join('\n'), { name: 'AbiEncodingArrayLengthMismatchError' });
    }
}
class AbiEncodingBytesSizeMismatchError extends BaseError$1 {
    constructor({ expectedSize, value }) {
        super(`Size of bytes "${value}" (bytes${size$1(value)}) does not match expected size (bytes${expectedSize}).`, { name: 'AbiEncodingBytesSizeMismatchError' });
    }
}
class AbiEncodingLengthMismatchError extends BaseError$1 {
    constructor({ expectedLength, givenLength, }) {
        super([
            'ABI encoding params/values length mismatch.',
            `Expected length (params): ${expectedLength}`,
            `Given length (values): ${givenLength}`,
        ].join('\n'), { name: 'AbiEncodingLengthMismatchError' });
    }
}
class AbiErrorSignatureNotFoundError extends BaseError$1 {
    constructor(signature, { docsPath }) {
        super([
            `Encoded error signature "${signature}" not found on ABI.`,
            'Make sure you are using the correct ABI and that the error exists on it.',
            `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`,
        ].join('\n'), {
            docsPath,
            name: 'AbiErrorSignatureNotFoundError',
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signature = signature;
    }
}
class AbiEventSignatureEmptyTopicsError extends BaseError$1 {
    constructor({ docsPath }) {
        super('Cannot extract event signature from empty topics.', {
            docsPath,
            name: 'AbiEventSignatureEmptyTopicsError',
        });
    }
}
class AbiEventSignatureNotFoundError extends BaseError$1 {
    constructor(signature, { docsPath }) {
        super([
            `Encoded event signature "${signature}" not found on ABI.`,
            'Make sure you are using the correct ABI and that the event exists on it.',
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`,
        ].join('\n'), {
            docsPath,
            name: 'AbiEventSignatureNotFoundError',
        });
    }
}
class AbiEventNotFoundError extends BaseError$1 {
    constructor(eventName, { docsPath } = {}) {
        super([
            `Event ${eventName ? `"${eventName}" ` : ''}not found on ABI.`,
            'Make sure you are using the correct ABI and that the event exists on it.',
        ].join('\n'), {
            docsPath,
            name: 'AbiEventNotFoundError',
        });
    }
}
class AbiFunctionNotFoundError extends BaseError$1 {
    constructor(functionName, { docsPath } = {}) {
        super([
            `Function ${functionName ? `"${functionName}" ` : ''}not found on ABI.`,
            'Make sure you are using the correct ABI and that the function exists on it.',
        ].join('\n'), {
            docsPath,
            name: 'AbiFunctionNotFoundError',
        });
    }
}
class AbiFunctionOutputsNotFoundError extends BaseError$1 {
    constructor(functionName, { docsPath }) {
        super([
            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
            'Cannot decode function result without knowing what the parameter types are.',
            'Make sure you are using the correct ABI and that the function exists on it.',
        ].join('\n'), {
            docsPath,
            name: 'AbiFunctionOutputsNotFoundError',
        });
    }
}
class AbiItemAmbiguityError extends BaseError$1 {
    constructor(x, y) {
        super('Found ambiguous types in overloaded ABI items.', {
            metaMessages: [
                `\`${x.type}\` in \`${formatAbiItem(x.abiItem)}\`, and`,
                `\`${y.type}\` in \`${formatAbiItem(y.abiItem)}\``,
                '',
                'These types encode differently and cannot be distinguished at runtime.',
                'Remove one of the ambiguous items in the ABI.',
            ],
            name: 'AbiItemAmbiguityError',
        });
    }
}
class BytesSizeMismatchError extends BaseError$1 {
    constructor({ expectedSize, givenSize, }) {
        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`, {
            name: 'BytesSizeMismatchError',
        });
    }
}
class DecodeLogDataMismatch extends BaseError$1 {
    constructor({ abiItem, data, params, size, }) {
        super([
            `Data size of ${size} bytes is too small for non-indexed event parameters.`,
        ].join('\n'), {
            metaMessages: [
                `Params: (${formatAbiParams(params, { includeName: true })})`,
                `Data:   ${data} (${size} bytes)`,
            ],
            name: 'DecodeLogDataMismatch',
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class DecodeLogTopicsMismatch extends BaseError$1 {
    constructor({ abiItem, param, }) {
        super([
            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ''} on event "${formatAbiItem(abiItem, { includeName: true })}".`,
        ].join('\n'), { name: 'DecodeLogTopicsMismatch' });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
    }
}
class InvalidAbiEncodingTypeError extends BaseError$1 {
    constructor(type, { docsPath }) {
        super([
            `Type "${type}" is not a valid encoding type.`,
            'Please provide a valid ABI type.',
        ].join('\n'), { docsPath, name: 'InvalidAbiEncodingType' });
    }
}
class InvalidAbiDecodingTypeError extends BaseError$1 {
    constructor(type, { docsPath }) {
        super([
            `Type "${type}" is not a valid decoding type.`,
            'Please provide a valid ABI type.',
        ].join('\n'), { docsPath, name: 'InvalidAbiDecodingType' });
    }
}
class InvalidArrayError extends BaseError$1 {
    constructor(value) {
        super([`Value "${value}" is not a valid array.`].join('\n'), {
            name: 'InvalidArrayError',
        });
    }
}
class InvalidDefinitionTypeError extends BaseError$1 {
    constructor(type) {
        super([
            `"${type}" is not a valid definition type.`,
            'Valid types: "function", "event", "error"',
        ].join('\n'), { name: 'InvalidDefinitionTypeError' });
    }
}
class UnsupportedPackedAbiType extends BaseError$1 {
    constructor(type) {
        super(`Type "${type}" is not supported for packed encoding.`, {
            name: 'UnsupportedPackedAbiType',
        });
    }
}

class FilterTypeNotSupportedError extends BaseError$1 {
    constructor(type) {
        super(`Filter type "${type}" is not supported.`, {
            name: 'FilterTypeNotSupportedError',
        });
    }
}

class SliceOffsetOutOfBoundsError extends BaseError$1 {
    constructor({ offset, position, size, }) {
        super(`Slice ${position === 'start' ? 'starting' : 'ending'} at offset "${offset}" is out-of-bounds (size: ${size}).`, { name: 'SliceOffsetOutOfBoundsError' });
    }
}
let SizeExceedsPaddingSizeError$1 = class SizeExceedsPaddingSizeError extends BaseError$1 {
    constructor({ size, targetSize, type, }) {
        super(`${type.charAt(0).toUpperCase()}${type
            .slice(1)
            .toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`, { name: 'SizeExceedsPaddingSizeError' });
    }
};
class InvalidBytesLengthError extends BaseError$1 {
    constructor({ size, targetSize, type, }) {
        super(`${type.charAt(0).toUpperCase()}${type
            .slice(1)
            .toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`, { name: 'InvalidBytesLengthError' });
    }
}

function pad$1(hexOrBytes, { dir, size = 32 } = {}) {
    if (typeof hexOrBytes === 'string')
        return padHex(hexOrBytes, { dir, size });
    return padBytes(hexOrBytes, { dir, size });
}
function padHex(hex_, { dir, size = 32 } = {}) {
    if (size === null)
        return hex_;
    const hex = hex_.replace('0x', '');
    if (hex.length > size * 2)
        throw new SizeExceedsPaddingSizeError$1({
            size: Math.ceil(hex.length / 2),
            targetSize: size,
            type: 'hex',
        });
    return `0x${hex[dir === 'right' ? 'padEnd' : 'padStart'](size * 2, '0')}`;
}
function padBytes(bytes, { dir, size = 32 } = {}) {
    if (size === null)
        return bytes;
    if (bytes.length > size)
        throw new SizeExceedsPaddingSizeError$1({
            size: bytes.length,
            targetSize: size,
            type: 'bytes',
        });
    const paddedBytes = new Uint8Array(size);
    for (let i = 0; i < size; i++) {
        const padEnd = dir === 'right';
        paddedBytes[padEnd ? i : size - i - 1] =
            bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

let IntegerOutOfRangeError$1 = class IntegerOutOfRangeError extends BaseError$1 {
    constructor({ max, min, signed, size, value, }) {
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? 'signed' : 'unsigned'} ` : ''}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`, { name: 'IntegerOutOfRangeError' });
    }
};
class InvalidBytesBooleanError extends BaseError$1 {
    constructor(bytes) {
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
            name: 'InvalidBytesBooleanError',
        });
    }
}
class InvalidHexBooleanError extends BaseError$1 {
    constructor(hex) {
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`, { name: 'InvalidHexBooleanError' });
    }
}
class SizeOverflowError extends BaseError$1 {
    constructor({ givenSize, maxSize }) {
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`, { name: 'SizeOverflowError' });
    }
}

function trim$1(hexOrBytes, { dir = 'left' } = {}) {
    let data = typeof hexOrBytes === 'string' ? hexOrBytes.replace('0x', '') : hexOrBytes;
    let sliceLength = 0;
    for (let i = 0; i < data.length - 1; i++) {
        if (data[dir === 'left' ? i : data.length - i - 1].toString() === '0')
            sliceLength++;
        else
            break;
    }
    data =
        dir === 'left'
            ? data.slice(sliceLength)
            : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === 'string') {
        if (data.length === 1 && dir === 'right')
            data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

function assertSize(hexOrBytes, { size }) {
    if (size$1(hexOrBytes) > size)
        throw new SizeOverflowError({
            givenSize: size$1(hexOrBytes),
            maxSize: size,
        });
}
/**
 * Decodes a hex value into a bigint.
 *
 * - Docs: https://viem.sh/docs/utilities/fromHex#hextobigint
 *
 * @param hex Hex value to decode.
 * @param opts Options.
 * @returns BigInt value.
 *
 * @example
 * import { hexToBigInt } from 'viem'
 * const data = hexToBigInt('0x1a4', { signed: true })
 * // 420n
 *
 * @example
 * import { hexToBigInt } from 'viem'
 * const data = hexToBigInt('0x00000000000000000000000000000000000000000000000000000000000001a4', { size: 32 })
 * // 420n
 */
function hexToBigInt(hex, opts = {}) {
    const { signed } = opts;
    if (opts.size)
        assertSize(hex, { size: opts.size });
    const value = BigInt(hex);
    if (!signed)
        return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << (BigInt(size) * 8n - 1n)) - 1n;
    if (value <= max)
        return value;
    return value - BigInt(`0x${'f'.padStart(size * 2, 'f')}`) - 1n;
}
/**
 * Decodes a hex value into a boolean.
 *
 * - Docs: https://viem.sh/docs/utilities/fromHex#hextobool
 *
 * @param hex Hex value to decode.
 * @param opts Options.
 * @returns Boolean value.
 *
 * @example
 * import { hexToBool } from 'viem'
 * const data = hexToBool('0x01')
 * // true
 *
 * @example
 * import { hexToBool } from 'viem'
 * const data = hexToBool('0x0000000000000000000000000000000000000000000000000000000000000001', { size: 32 })
 * // true
 */
function hexToBool(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        assertSize(hex, { size: opts.size });
        hex = trim$1(hex);
    }
    if (trim$1(hex) === '0x00')
        return false;
    if (trim$1(hex) === '0x01')
        return true;
    throw new InvalidHexBooleanError(hex);
}
/**
 * Decodes a hex string into a number.
 *
 * - Docs: https://viem.sh/docs/utilities/fromHex#hextonumber
 *
 * @param hex Hex value to decode.
 * @param opts Options.
 * @returns Number value.
 *
 * @example
 * import { hexToNumber } from 'viem'
 * const data = hexToNumber('0x1a4')
 * // 420
 *
 * @example
 * import { hexToNumber } from 'viem'
 * const data = hexToBigInt('0x00000000000000000000000000000000000000000000000000000000000001a4', { size: 32 })
 * // 420
 */
function hexToNumber$1(hex, opts = {}) {
    return Number(hexToBigInt(hex, opts));
}

const hexes$2 = /*#__PURE__*/ Array.from({ length: 256 }, (_v, i) => i.toString(16).padStart(2, '0'));
/**
 * Encodes a string, number, bigint, or ByteArray into a hex string
 *
 * - Docs: https://viem.sh/docs/utilities/toHex
 * - Example: https://viem.sh/docs/utilities/toHex#usage
 *
 * @param value Value to encode.
 * @param opts Options.
 * @returns Hex value.
 *
 * @example
 * import { toHex } from 'viem'
 * const data = toHex('Hello world')
 * // '0x48656c6c6f20776f726c6421'
 *
 * @example
 * import { toHex } from 'viem'
 * const data = toHex(420)
 * // '0x1a4'
 *
 * @example
 * import { toHex } from 'viem'
 * const data = toHex('Hello world', { size: 32 })
 * // '0x48656c6c6f20776f726c64210000000000000000000000000000000000000000'
 */
function toHex(value, opts = {}) {
    if (typeof value === 'number' || typeof value === 'bigint')
        return numberToHex(value, opts);
    if (typeof value === 'string') {
        return stringToHex(value, opts);
    }
    if (typeof value === 'boolean')
        return boolToHex(value, opts);
    return bytesToHex$2(value, opts);
}
/**
 * Encodes a boolean into a hex string
 *
 * - Docs: https://viem.sh/docs/utilities/toHex#booltohex
 *
 * @param value Value to encode.
 * @param opts Options.
 * @returns Hex value.
 *
 * @example
 * import { boolToHex } from 'viem'
 * const data = boolToHex(true)
 * // '0x1'
 *
 * @example
 * import { boolToHex } from 'viem'
 * const data = boolToHex(false)
 * // '0x0'
 *
 * @example
 * import { boolToHex } from 'viem'
 * const data = boolToHex(true, { size: 32 })
 * // '0x0000000000000000000000000000000000000000000000000000000000000001'
 */
function boolToHex(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === 'number') {
        assertSize(hex, { size: opts.size });
        return pad$1(hex, { size: opts.size });
    }
    return hex;
}
/**
 * Encodes a bytes array into a hex string
 *
 * - Docs: https://viem.sh/docs/utilities/toHex#bytestohex
 *
 * @param value Value to encode.
 * @param opts Options.
 * @returns Hex value.
 *
 * @example
 * import { bytesToHex } from 'viem'
 * const data = bytesToHex(Uint8Array.from([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33])
 * // '0x48656c6c6f20576f726c6421'
 *
 * @example
 * import { bytesToHex } from 'viem'
 * const data = bytesToHex(Uint8Array.from([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33]), { size: 32 })
 * // '0x48656c6c6f20576f726c64210000000000000000000000000000000000000000'
 */
function bytesToHex$2(value, opts = {}) {
    let string = '';
    for (let i = 0; i < value.length; i++) {
        string += hexes$2[value[i]];
    }
    const hex = `0x${string}`;
    if (typeof opts.size === 'number') {
        assertSize(hex, { size: opts.size });
        return pad$1(hex, { dir: 'right', size: opts.size });
    }
    return hex;
}
/**
 * Encodes a number or bigint into a hex string
 *
 * - Docs: https://viem.sh/docs/utilities/toHex#numbertohex
 *
 * @param value Value to encode.
 * @param opts Options.
 * @returns Hex value.
 *
 * @example
 * import { numberToHex } from 'viem'
 * const data = numberToHex(420)
 * // '0x1a4'
 *
 * @example
 * import { numberToHex } from 'viem'
 * const data = numberToHex(420, { size: 32 })
 * // '0x00000000000000000000000000000000000000000000000000000000000001a4'
 */
function numberToHex(value_, opts = {}) {
    const { signed, size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed)
            maxValue = (1n << (BigInt(size) * 8n - 1n)) - 1n;
        else
            maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    }
    else if (typeof value_ === 'number') {
        maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    }
    const minValue = typeof maxValue === 'bigint' && signed ? -maxValue - 1n : 0;
    if ((maxValue && value > maxValue) || value < minValue) {
        const suffix = typeof value_ === 'bigint' ? 'n' : '';
        throw new IntegerOutOfRangeError$1({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed,
            size,
            value: `${value_}${suffix}`,
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size)
        return pad$1(hex, { size });
    return hex;
}
const encoder$1 = /*#__PURE__*/ new TextEncoder();
/**
 * Encodes a UTF-8 string into a hex string
 *
 * - Docs: https://viem.sh/docs/utilities/toHex#stringtohex
 *
 * @param value Value to encode.
 * @param opts Options.
 * @returns Hex value.
 *
 * @example
 * import { stringToHex } from 'viem'
 * const data = stringToHex('Hello World!')
 * // '0x48656c6c6f20576f726c6421'
 *
 * @example
 * import { stringToHex } from 'viem'
 * const data = stringToHex('Hello World!', { size: 32 })
 * // '0x48656c6c6f20576f726c64210000000000000000000000000000000000000000'
 */
function stringToHex(value_, opts = {}) {
    const value = encoder$1.encode(value_);
    return bytesToHex$2(value, opts);
}

const encoder = /*#__PURE__*/ new TextEncoder();
/**
 * Encodes a UTF-8 string, hex value, bigint, number or boolean to a byte array.
 *
 * - Docs: https://viem.sh/docs/utilities/toBytes
 * - Example: https://viem.sh/docs/utilities/toBytes#usage
 *
 * @param value Value to encode.
 * @param opts Options.
 * @returns Byte array value.
 *
 * @example
 * import { toBytes } from 'viem'
 * const data = toBytes('Hello world')
 * // Uint8Array([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33])
 *
 * @example
 * import { toBytes } from 'viem'
 * const data = toBytes(420)
 * // Uint8Array([1, 164])
 *
 * @example
 * import { toBytes } from 'viem'
 * const data = toBytes(420, { size: 4 })
 * // Uint8Array([0, 0, 1, 164])
 */
function toBytes$1(value, opts = {}) {
    if (typeof value === 'number' || typeof value === 'bigint')
        return numberToBytes(value, opts);
    if (typeof value === 'boolean')
        return boolToBytes(value, opts);
    if (isHex$2(value))
        return hexToBytes$1(value, opts);
    return stringToBytes(value, opts);
}
/**
 * Encodes a boolean into a byte array.
 *
 * - Docs: https://viem.sh/docs/utilities/toBytes#booltobytes
 *
 * @param value Boolean value to encode.
 * @param opts Options.
 * @returns Byte array value.
 *
 * @example
 * import { boolToBytes } from 'viem'
 * const data = boolToBytes(true)
 * // Uint8Array([1])
 *
 * @example
 * import { boolToBytes } from 'viem'
 * const data = boolToBytes(true, { size: 32 })
 * // Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1])
 */
function boolToBytes(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === 'number') {
        assertSize(bytes, { size: opts.size });
        return pad$1(bytes, { size: opts.size });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102,
};
function charCodeToBase16(char) {
    if (char >= charCodeMap.zero && char <= charCodeMap.nine)
        return char - charCodeMap.zero;
    if (char >= charCodeMap.A && char <= charCodeMap.F)
        return char - (charCodeMap.A - 10);
    if (char >= charCodeMap.a && char <= charCodeMap.f)
        return char - (charCodeMap.a - 10);
    return undefined;
}
/**
 * Encodes a hex string into a byte array.
 *
 * - Docs: https://viem.sh/docs/utilities/toBytes#hextobytes
 *
 * @param hex Hex string to encode.
 * @param opts Options.
 * @returns Byte array value.
 *
 * @example
 * import { hexToBytes } from 'viem'
 * const data = hexToBytes('0x48656c6c6f20776f726c6421')
 * // Uint8Array([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33])
 *
 * @example
 * import { hexToBytes } from 'viem'
 * const data = hexToBytes('0x48656c6c6f20776f726c6421', { size: 32 })
 * // Uint8Array([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
 */
function hexToBytes$1(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        assertSize(hex, { size: opts.size });
        hex = pad$1(hex, { dir: 'right', size: opts.size });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2)
        hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for (let index = 0, j = 0; index < length; index++) {
        const nibbleLeft = charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) {
            throw new BaseError$1(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        }
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
/**
 * Encodes a number into a byte array.
 *
 * - Docs: https://viem.sh/docs/utilities/toBytes#numbertobytes
 *
 * @param value Number to encode.
 * @param opts Options.
 * @returns Byte array value.
 *
 * @example
 * import { numberToBytes } from 'viem'
 * const data = numberToBytes(420)
 * // Uint8Array([1, 164])
 *
 * @example
 * import { numberToBytes } from 'viem'
 * const data = numberToBytes(420, { size: 4 })
 * // Uint8Array([0, 0, 1, 164])
 */
function numberToBytes(value, opts) {
    const hex = numberToHex(value, opts);
    return hexToBytes$1(hex);
}
/**
 * Encodes a UTF-8 string into a byte array.
 *
 * - Docs: https://viem.sh/docs/utilities/toBytes#stringtobytes
 *
 * @param value String to encode.
 * @param opts Options.
 * @returns Byte array value.
 *
 * @example
 * import { stringToBytes } from 'viem'
 * const data = stringToBytes('Hello world!')
 * // Uint8Array([72, 101, 108, 108, 111, 32, 119, 111, 114, 108, 100, 33])
 *
 * @example
 * import { stringToBytes } from 'viem'
 * const data = stringToBytes('Hello world!', { size: 32 })
 * // Uint8Array([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
 */
function stringToBytes(value, opts = {}) {
    const bytes = encoder.encode(value);
    if (typeof opts.size === 'number') {
        assertSize(bytes, { size: opts.size });
        return pad$1(bytes, { dir: 'right', size: opts.size });
    }
    return bytes;
}

/**
 * Internal assertion helpers.
 * @module
 */
/** Asserts something is positive integer. */
function anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0)
        throw new Error('positive integer expected, got ' + n);
}
/** Is number an Uint8Array? Copied from utils for perf. */
function isBytes$1(a) {
    return a instanceof Uint8Array || (ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array');
}
/** Asserts something is Uint8Array. */
function abytes$1(b, ...lengths) {
    if (!isBytes$1(b))
        throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length))
        throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
/** Asserts something is hash */
function ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function')
        throw new Error('Hash should be wrapped by utils.wrapConstructor');
    anumber(h.outputLen);
    anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */
function aexists(instance, checkFinished = true) {
    if (instance.destroyed)
        throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished)
        throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */
function aoutput(out, instance) {
    abytes$1(out);
    const min = instance.outputLen;
    if (out.length < min) {
        throw new Error('digestInto() expects output buffer of length at least ' + min);
    }
}

/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n = /* @__PURE__ */ BigInt(32);
function fromBig(n, le = false) {
    if (le)
        return { h: Number(n & U32_MASK64), l: Number((n >> _32n) & U32_MASK64) };
    return { h: Number((n >> _32n) & U32_MASK64) | 0, l: Number(n & U32_MASK64) | 0 };
}
function split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for (let i = 0; i < lst.length; i++) {
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [h, l];
    }
    return [Ah, Al];
}
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s) => (h << s) | (l >>> (32 - s));
const rotlSL = (h, l, s) => (l << s) | (h >>> (32 - s));
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s) => (l << (s - 32)) | (h >>> (64 - s));
const rotlBL = (h, l, s) => (h << (s - 32)) | (l >>> (64 - s));

const crypto$3 = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
function u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
// Cast array to view
function createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */
function rotr(word, shift) {
    return (word << (32 - shift)) | (word >>> shift);
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */
const isLE = /* @__PURE__ */ (() => new Uint8Array(new Uint32Array([0x11223344]).buffer)[0] === 0x44)();
// The byte swap operation for uint32
function byteSwap(word) {
    return (((word << 24) & 0xff000000) |
        ((word << 8) & 0xff0000) |
        ((word >>> 8) & 0xff00) |
        ((word >>> 24) & 0xff));
}
/** In place byte swap for Uint32Array */
function byteSwap32(arr) {
    for (let i = 0; i < arr.length; i++) {
        arr[i] = byteSwap(arr[i]);
    }
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes$1 = /* @__PURE__ */ Array.from({ length: 256 }, (_, i) => i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */
function bytesToHex$1(bytes) {
    abytes$1(bytes);
    // pre-caching improves the speed 6x
    let hex = '';
    for (let i = 0; i < bytes.length; i++) {
        hex += hexes$1[bytes[i]];
    }
    return hex;
}
/**
 * Convert JS string to byte array.
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */
function utf8ToBytes$1(str) {
    if (typeof str !== 'string')
        throw new Error('utf8ToBytes expected string, got ' + typeof str);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */
function toBytes(data) {
    if (typeof data === 'string')
        data = utf8ToBytes$1(data);
    abytes$1(data);
    return data;
}
/**
 * Copies several Uint8Arrays into one.
 */
function concatBytes$2(...arrays) {
    let sum = 0;
    for (let i = 0; i < arrays.length; i++) {
        const a = arrays[i];
        abytes$1(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for (let i = 0, pad = 0; i < arrays.length; i++) {
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
/** For runtime check if class implements interface */
let Hash$2 = class Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
};
/** Wraps hash function, creating an interface on top of it */
function wrapConstructor(hashCons) {
    const hashC = (msg) => hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = () => hashCons();
    return hashC;
}
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */
function randomBytes(bytesLength = 32) {
    if (crypto$3 && typeof crypto$3.getRandomValues === 'function') {
        return crypto$3.getRandomValues(new Uint8Array(bytesLength));
    }
    // Legacy Node.js compatibility
    if (crypto$3 && typeof crypto$3.randomBytes === 'function') {
        return crypto$3.randomBytes(bytesLength);
    }
    throw new Error('crypto.getRandomValues must be defined');
}

/**
 * SHA3 (keccak) hash function, based on a new "Sponge function" design.
 * Different from older hashes, the internal state is bigger than output size.
 *
 * Check out [FIPS-202](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.202.pdf),
 * [Website](https://keccak.team/keccak.html),
 * [the differences between SHA-3 and Keccak](https://crypto.stackexchange.com/questions/15727/what-are-the-key-differences-between-the-draft-sha-3-standard-and-the-keccak-sub).
 *
 * Check out `sha3-addons` module for cSHAKE, k12, and others.
 * @module
 */
// Various per round constants calculations
const SHA3_PI = [];
const SHA3_ROTL = [];
const _SHA3_IOTA = [];
const _0n$4 = /* @__PURE__ */ BigInt(0);
const _1n$5 = /* @__PURE__ */ BigInt(1);
const _2n$3 = /* @__PURE__ */ BigInt(2);
const _7n = /* @__PURE__ */ BigInt(7);
const _256n = /* @__PURE__ */ BigInt(256);
const _0x71n = /* @__PURE__ */ BigInt(0x71);
for (let round = 0, R = _1n$5, x = 1, y = 0; round < 24; round++) {
    // Pi
    [x, y] = [y, (2 * x + 3 * y) % 5];
    SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    SHA3_ROTL.push((((round + 1) * (round + 2)) / 2) % 64);
    // Iota
    let t = _0n$4;
    for (let j = 0; j < 7; j++) {
        R = ((R << _1n$5) ^ ((R >> _7n) * _0x71n)) % _256n;
        if (R & _2n$3)
            t ^= _1n$5 << ((_1n$5 << /* @__PURE__ */ BigInt(j)) - _1n$5);
    }
    _SHA3_IOTA.push(t);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ split(_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const rotlH = (h, l, s) => (s > 32 ? rotlBH(h, l, s) : rotlSH(h, l, s));
const rotlL = (h, l, s) => (s > 32 ? rotlBL(h, l, s) : rotlSL(h, l, s));
/** `keccakf1600` internal function, additionally allows to adjust round count. */
function keccakP(s, rounds = 24) {
    const B = new Uint32Array(5 * 2);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for (let round = 24 - rounds; round < 24; round++) {
        // Theta θ
        for (let x = 0; x < 10; x++)
            B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for (let x = 0; x < 10; x += 2) {
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for (let y = 0; y < 50; y += 10) {
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for (let t = 0; t < 24; t++) {
            const shift = SHA3_ROTL[t];
            const Th = rotlH(curH, curL, shift);
            const Tl = rotlL(curH, curL, shift);
            const PI = SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for (let y = 0; y < 50; y += 10) {
            for (let x = 0; x < 10; x++)
                B[x] = s[y + x];
            for (let x = 0; x < 10; x++)
                s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= SHA3_IOTA_H[round];
        s[1] ^= SHA3_IOTA_L[round];
    }
    B.fill(0);
}
/** Keccak sponge function. */
class Keccak extends Hash$2 {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24) {
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        anumber(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        // 0 < blockLen < 200
        if (0 >= this.blockLen || this.blockLen >= 200)
            throw new Error('Sha3 supports only keccak-f1600 function');
        this.state = new Uint8Array(200);
        this.state32 = u32(this.state);
    }
    keccak() {
        if (!isLE)
            byteSwap32(this.state32);
        keccakP(this.state32, this.rounds);
        if (!isLE)
            byteSwap32(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        aexists(this);
        const { blockLen, state } = this;
        data = toBytes(data);
        const len = data.length;
        for (let pos = 0; pos < len;) {
            const take = Math.min(blockLen - this.pos, len - pos);
            for (let i = 0; i < take; i++)
                state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen)
                this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished)
            return;
        this.finished = true;
        const { state, suffix, pos, blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1)
            this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        aexists(this, false);
        abytes$1(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen } = this;
        for (let pos = 0, len = out.length; pos < len;) {
            if (this.posOut >= blockLen)
                this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF)
            throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    }
    xof(bytes) {
        anumber(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        aoutput(out, this);
        if (this.finished)
            throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const gen = (suffix, blockLen, outputLen) => wrapConstructor(() => new Keccak(blockLen, suffix, outputLen));
/** keccak-256 hash function. Different from SHA3-256. */
const keccak_256 = /* @__PURE__ */ gen(0x01, 136, 256 / 8);

function keccak256(value, to_) {
    const to = to_ || 'hex';
    const bytes = keccak_256(isHex$2(value, { strict: false }) ? toBytes$1(value) : value);
    if (to === 'bytes')
        return bytes;
    return toHex(bytes);
}

const hash$1 = (value) => keccak256(toBytes$1(value));
function hashSignature(sig) {
    return hash$1(sig);
}

function normalizeSignature(signature) {
    let active = true;
    let current = '';
    let level = 0;
    let result = '';
    let valid = false;
    for (let i = 0; i < signature.length; i++) {
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if (['(', ')', ','].includes(char))
            active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === '(')
            level++;
        if (char === ')')
            level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active)
            continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === ' ' && ['event', 'function', ''].includes(result))
                result = '';
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ')') {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === ' ') {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== ',' && current !== ',' && current !== ',(') {
                current = '';
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid)
        throw new BaseError$1('Unable to normalize signature.');
    return result;
}

/**
 * Returns the signature for a given function or event definition.
 *
 * @example
 * const signature = toSignature('function ownerOf(uint256 tokenId)')
 * // 'ownerOf(uint256)'
 *
 * @example
 * const signature_3 = toSignature({
 *   name: 'ownerOf',
 *   type: 'function',
 *   inputs: [{ name: 'tokenId', type: 'uint256' }],
 *   outputs: [],
 *   stateMutability: 'view',
 * })
 * // 'ownerOf(uint256)'
 */
const toSignature = (def) => {
    const def_ = (() => {
        if (typeof def === 'string')
            return def;
        return formatAbiItem$1(def);
    })();
    return normalizeSignature(def_);
};

/**
 * Returns the hash (of the function/event signature) for a given event or function definition.
 */
function toSignatureHash(fn) {
    return hashSignature(toSignature(fn));
}

/**
 * Returns the event selector for a given event definition.
 *
 * @example
 * const selector = toEventSelector('Transfer(address indexed from, address indexed to, uint256 amount)')
 * // 0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef
 */
const toEventSelector = toSignatureHash;

class InvalidAddressError extends BaseError$1 {
    constructor({ address }) {
        super(`Address "${address}" is invalid.`, {
            metaMessages: [
                '- Address must be a hex value of 20 bytes (40 hex characters).',
                '- Address must match its checksum counterpart.',
            ],
            name: 'InvalidAddressError',
        });
    }
}

/**
 * Map with a LRU (Least recently used) policy.
 *
 * @link https://en.wikipedia.org/wiki/Cache_replacement_policies#LRU
 */
class LruMap extends Map {
    constructor(size) {
        super();
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxSize = size;
    }
    get(key) {
        const value = super.get(key);
        if (super.has(key) && value !== undefined) {
            this.delete(key);
            super.set(key, value);
        }
        return value;
    }
    set(key, value) {
        super.set(key, value);
        if (this.maxSize && this.size > this.maxSize) {
            const firstKey = this.keys().next().value;
            if (firstKey)
                this.delete(firstKey);
        }
        return this;
    }
}

const checksumAddressCache = /*#__PURE__*/ new LruMap(8192);
function checksumAddress(address_, 
/**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */
chainId) {
    if (checksumAddressCache.has(`${address_}.${chainId}`))
        return checksumAddressCache.get(`${address_}.${chainId}`);
    const hexAddress = address_.substring(2).toLowerCase();
    const hash = keccak256(stringToBytes(hexAddress), 'bytes');
    const address = (hexAddress).split('');
    for (let i = 0; i < 40; i += 2) {
        if (hash[i >> 1] >> 4 >= 8 && address[i]) {
            address[i] = address[i].toUpperCase();
        }
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) {
            address[i + 1] = address[i + 1].toUpperCase();
        }
    }
    const result = `0x${address.join('')}`;
    checksumAddressCache.set(`${address_}.${chainId}`, result);
    return result;
}
function getAddress(address, 
/**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */
chainId) {
    if (!isAddress(address, { strict: false }))
        throw new InvalidAddressError({ address });
    return checksumAddress(address, chainId);
}

const addressRegex = /^0x[a-fA-F0-9]{40}$/;
/** @internal */
const isAddressCache = /*#__PURE__*/ new LruMap(8192);
function isAddress(address, options) {
    const { strict = true } = options ?? {};
    const cacheKey = `${address}.${strict}`;
    if (isAddressCache.has(cacheKey))
        return isAddressCache.get(cacheKey);
    const result = (() => {
        if (!addressRegex.test(address))
            return false;
        if (address.toLowerCase() === address)
            return true;
        if (strict)
            return checksumAddress(address) === address;
        return true;
    })();
    isAddressCache.set(cacheKey, result);
    return result;
}

function concat$1(values) {
    if (typeof values[0] === 'string')
        return concatHex(values);
    return concatBytes$1(values);
}
function concatBytes$1(values) {
    let length = 0;
    for (const arr of values) {
        length += arr.length;
    }
    const result = new Uint8Array(length);
    let offset = 0;
    for (const arr of values) {
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
function concatHex(values) {
    return `0x${values.reduce((acc, x) => acc + x.replace('0x', ''), '')}`;
}

/**
 * @description Returns a section of the hex or byte array given a start/end bytes offset.
 *
 * @param value The hex or byte array to slice.
 * @param start The start offset (in bytes).
 * @param end The end offset (in bytes).
 */
function slice(value, start, end, { strict } = {}) {
    if (isHex$2(value, { strict: false }))
        return sliceHex(value, start, end, {
            strict,
        });
    return sliceBytes(value, start, end, {
        strict,
    });
}
function assertStartOffset(value, start) {
    if (typeof start === 'number' && start > 0 && start > size$1(value) - 1)
        throw new SliceOffsetOutOfBoundsError({
            offset: start,
            position: 'start',
            size: size$1(value),
        });
}
function assertEndOffset(value, start, end) {
    if (typeof start === 'number' &&
        typeof end === 'number' &&
        size$1(value) !== end - start) {
        throw new SliceOffsetOutOfBoundsError({
            offset: end,
            position: 'end',
            size: size$1(value),
        });
    }
}
/**
 * @description Returns a section of the byte array given a start/end bytes offset.
 *
 * @param value The byte array to slice.
 * @param start The start offset (in bytes).
 * @param end The end offset (in bytes).
 */
function sliceBytes(value_, start, end, { strict } = {}) {
    assertStartOffset(value_, start);
    const value = value_.slice(start, end);
    if (strict)
        assertEndOffset(value, start, end);
    return value;
}
/**
 * @description Returns a section of the hex value given a start/end bytes offset.
 *
 * @param value The hex value to slice.
 * @param start The start offset (in bytes).
 * @param end The end offset (in bytes).
 */
function sliceHex(value_, start, end, { strict } = {}) {
    assertStartOffset(value_, start);
    const value = `0x${value_
        .replace('0x', '')
        .slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
    if (strict)
        assertEndOffset(value, start, end);
    return value;
}

const arrayRegex = /^(.*)\[([0-9]*)\]$/;
// `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
// https://regexr.com/6va55
const bytesRegex = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
// `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
// https://regexr.com/6v8hp
const integerRegex = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;

/**
 * @description Encodes a list of primitive values into an ABI-encoded hex value.
 *
 * - Docs: https://viem.sh/docs/abi/encodeAbiParameters#encodeabiparameters
 *
 *   Generates ABI encoded data using the [ABI specification](https://docs.soliditylang.org/en/latest/abi-spec), given a set of ABI parameters (inputs/outputs) and their corresponding values.
 *
 * @param params - a set of ABI Parameters (params), that can be in the shape of the inputs or outputs attribute of an ABI Item.
 * @param values - a set of values (values) that correspond to the given params.
 * @example
 * ```typescript
 * import { encodeAbiParameters } from 'viem'
 *
 * const encodedData = encodeAbiParameters(
 *   [
 *     { name: 'x', type: 'string' },
 *     { name: 'y', type: 'uint' },
 *     { name: 'z', type: 'bool' }
 *   ],
 *   ['wagmi', 420n, true]
 * )
 * ```
 *
 * You can also pass in Human Readable parameters with the parseAbiParameters utility.
 *
 * @example
 * ```typescript
 * import { encodeAbiParameters, parseAbiParameters } from 'viem'
 *
 * const encodedData = encodeAbiParameters(
 *   parseAbiParameters('string x, uint y, bool z'),
 *   ['wagmi', 420n, true]
 * )
 * ```
 */
function encodeAbiParameters(params, values) {
    if (params.length !== values.length)
        throw new AbiEncodingLengthMismatchError({
            expectedLength: params.length,
            givenLength: values.length,
        });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParams = prepareParams({
        params: params,
        values: values,
    });
    const data = encodeParams(preparedParams);
    if (data.length === 0)
        return '0x';
    return data;
}
function prepareParams({ params, values, }) {
    const preparedParams = [];
    for (let i = 0; i < params.length; i++) {
        preparedParams.push(prepareParam({ param: params[i], value: values[i] }));
    }
    return preparedParams;
}
function prepareParam({ param, value, }) {
    const arrayComponents = getArrayComponents(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return encodeArray(value, { length, param: { ...param, type } });
    }
    if (param.type === 'tuple') {
        return encodeTuple(value, {
            param: param,
        });
    }
    if (param.type === 'address') {
        return encodeAddress(value);
    }
    if (param.type === 'bool') {
        return encodeBool(value);
    }
    if (param.type.startsWith('uint') || param.type.startsWith('int')) {
        const signed = param.type.startsWith('int');
        const [, , size = '256'] = integerRegex.exec(param.type) ?? [];
        return encodeNumber(value, {
            signed,
            size: Number(size),
        });
    }
    if (param.type.startsWith('bytes')) {
        return encodeBytes(value, { param });
    }
    if (param.type === 'string') {
        return encodeString(value);
    }
    throw new InvalidAbiEncodingTypeError(param.type, {
        docsPath: '/docs/contract/encodeAbiParameters',
    });
}
function encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for (let i = 0; i < preparedParams.length; i++) {
        const { dynamic, encoded } = preparedParams[i];
        if (dynamic)
            staticSize += 32;
        else
            staticSize += size$1(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParams = [];
    const dynamicParams = [];
    let dynamicSize = 0;
    for (let i = 0; i < preparedParams.length; i++) {
        const { dynamic, encoded } = preparedParams[i];
        if (dynamic) {
            staticParams.push(numberToHex(staticSize + dynamicSize, { size: 32 }));
            dynamicParams.push(encoded);
            dynamicSize += size$1(encoded);
        }
        else {
            staticParams.push(encoded);
        }
    }
    // 3. Concatenate static and dynamic parts.
    return concat$1([...staticParams, ...dynamicParams]);
}
function encodeAddress(value) {
    if (!isAddress(value))
        throw new InvalidAddressError({ address: value });
    return { dynamic: false, encoded: padHex(value.toLowerCase()) };
}
function encodeArray(value, { length, param, }) {
    const dynamic = length === null;
    if (!Array.isArray(value))
        throw new InvalidArrayError(value);
    if (!dynamic && value.length !== length)
        throw new AbiEncodingArrayLengthMismatchError({
            expectedLength: length,
            givenLength: value.length,
            type: `${param.type}[${length}]`,
        });
    let dynamicChild = false;
    const preparedParams = [];
    for (let i = 0; i < value.length; i++) {
        const preparedParam = prepareParam({ param, value: value[i] });
        if (preparedParam.dynamic)
            dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = encodeParams(preparedParams);
        if (dynamic) {
            const length = numberToHex(preparedParams.length, { size: 32 });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? concat$1([length, data]) : length,
            };
        }
        if (dynamicChild)
            return { dynamic: true, encoded: data };
    }
    return {
        dynamic: false,
        encoded: concat$1(preparedParams.map(({ encoded }) => encoded)),
    };
}
function encodeBytes(value, { param }) {
    const [, paramSize] = param.type.split('bytes');
    const bytesSize = size$1(value);
    if (!paramSize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0)
            value_ = padHex(value_, {
                dir: 'right',
                size: Math.ceil((value.length - 2) / 2 / 32) * 32,
            });
        return {
            dynamic: true,
            encoded: concat$1([padHex(numberToHex(bytesSize, { size: 32 })), value_]),
        };
    }
    if (bytesSize !== Number.parseInt(paramSize))
        throw new AbiEncodingBytesSizeMismatchError({
            expectedSize: Number.parseInt(paramSize),
            value,
        });
    return { dynamic: false, encoded: padHex(value, { dir: 'right' }) };
}
function encodeBool(value) {
    if (typeof value !== 'boolean')
        throw new BaseError$1(`Invalid boolean value: "${value}" (type: ${typeof value}). Expected: \`true\` or \`false\`.`);
    return { dynamic: false, encoded: padHex(boolToHex(value)) };
}
function encodeNumber(value, { signed, size = 256 }) {
    if (typeof size === 'number') {
        const max = 2n ** (BigInt(size) - (signed ? 1n : 0n)) - 1n;
        const min = signed ? -max - 1n : 0n;
        if (value > max || value < min)
            throw new IntegerOutOfRangeError$1({
                max: max.toString(),
                min: min.toString(),
                signed,
                size: size / 8,
                value: value.toString(),
            });
    }
    return {
        dynamic: false,
        encoded: numberToHex(value, {
            size: 32,
            signed,
        }),
    };
}
function encodeString(value) {
    const hexValue = stringToHex(value);
    const partsLength = Math.ceil(size$1(hexValue) / 32);
    const parts = [];
    for (let i = 0; i < partsLength; i++) {
        parts.push(padHex(slice(hexValue, i * 32, (i + 1) * 32), {
            dir: 'right',
        }));
    }
    return {
        dynamic: true,
        encoded: concat$1([
            padHex(numberToHex(size$1(hexValue), { size: 32 })),
            ...parts,
        ]),
    };
}
function encodeTuple(value, { param }) {
    let dynamic = false;
    const preparedParams = [];
    for (let i = 0; i < param.components.length; i++) {
        const param_ = param.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = prepareParam({
            param: param_,
            value: value[index],
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic)
            dynamic = true;
    }
    return {
        dynamic,
        encoded: dynamic
            ? encodeParams(preparedParams)
            : concat$1(preparedParams.map(({ encoded }) => encoded)),
    };
}
function getArrayComponents(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches
        ? // Return `null` if the array is dynamic.
            [matches[2] ? Number(matches[2]) : null, matches[1]]
        : undefined;
}

/**
 * Returns the function selector for a given function definition.
 *
 * @example
 * const selector = toFunctionSelector('function ownerOf(uint256 tokenId)')
 * // 0x6352211e
 */
const toFunctionSelector = (fn) => slice(toSignatureHash(fn), 0, 4);

function getAbiItem(parameters) {
    const { abi, args = [], name } = parameters;
    const isSelector = isHex$2(name, { strict: false });
    const abiItems = abi.filter((abiItem) => {
        if (isSelector) {
            if (abiItem.type === 'function')
                return toFunctionSelector(abiItem) === name;
            if (abiItem.type === 'event')
                return toEventSelector(abiItem) === name;
            return false;
        }
        return 'name' in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0)
        return undefined;
    if (abiItems.length === 1)
        return abiItems[0];
    let matchedAbiItem = undefined;
    for (const abiItem of abiItems) {
        if (!('inputs' in abiItem))
            continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0)
                return abiItem;
            continue;
        }
        if (!abiItem.inputs)
            continue;
        if (abiItem.inputs.length === 0)
            continue;
        if (abiItem.inputs.length !== args.length)
            continue;
        const matched = args.every((arg, index) => {
            const abiParameter = 'inputs' in abiItem && abiItem.inputs[index];
            if (!abiParameter)
                return false;
            return isArgOfType(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem &&
                'inputs' in matchedAbiItem &&
                matchedAbiItem.inputs) {
                const ambiguousTypes = getAmbiguousTypes(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes)
                    throw new AbiItemAmbiguityError({
                        abiItem,
                        type: ambiguousTypes[0],
                    }, {
                        abiItem: matchedAbiItem,
                        type: ambiguousTypes[1],
                    });
            }
            matchedAbiItem = abiItem;
        }
    }
    if (matchedAbiItem)
        return matchedAbiItem;
    return abiItems[0];
}
/** @internal */
function isArgOfType(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch (abiParameterType) {
        case 'address':
            return isAddress(arg, { strict: false });
        case 'bool':
            return argType === 'boolean';
        case 'function':
            return argType === 'string';
        case 'string':
            return argType === 'string';
        default: {
            if (abiParameterType === 'tuple' && 'components' in abiParameter)
                return Object.values(abiParameter.components).every((component, index) => {
                    return isArgOfType(Object.values(arg)[index], component);
                });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType))
                return argType === 'number' || argType === 'bigint';
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType))
                return argType === 'string' || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) {
                return (Array.isArray(arg) &&
                    arg.every((x) => isArgOfType(x, {
                        ...abiParameter,
                        // Pop off `[]` or `[M]` from end of type
                        type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, ''),
                    })));
            }
            return false;
        }
    }
}
/** @internal */
function getAmbiguousTypes(sourceParameters, targetParameters, args) {
    for (const parameterIndex in sourceParameters) {
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === 'tuple' &&
            targetParameter.type === 'tuple' &&
            'components' in sourceParameter &&
            'components' in targetParameter)
            return getAmbiguousTypes(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [sourceParameter.type, targetParameter.type];
        const ambiguous = (() => {
            if (types.includes('address') && types.includes('bytes20'))
                return true;
            if (types.includes('address') && types.includes('string'))
                return isAddress(args[parameterIndex], { strict: false });
            if (types.includes('address') && types.includes('bytes'))
                return isAddress(args[parameterIndex], { strict: false });
            return false;
        })();
        if (ambiguous)
            return types;
    }
    return;
}

const docsPath$4 = '/docs/contract/encodeEventTopics';
function encodeEventTopics(parameters) {
    const { abi, eventName, args } = parameters;
    let abiItem = abi[0];
    if (eventName) {
        const item = getAbiItem({ abi, name: eventName });
        if (!item)
            throw new AbiEventNotFoundError(eventName, { docsPath: docsPath$4 });
        abiItem = item;
    }
    if (abiItem.type !== 'event')
        throw new AbiEventNotFoundError(undefined, { docsPath: docsPath$4 });
    const definition = formatAbiItem(abiItem);
    const signature = toEventSelector(definition);
    let topics = [];
    if (args && 'inputs' in abiItem) {
        const indexedInputs = abiItem.inputs?.filter((param) => 'indexed' in param && param.indexed);
        const args_ = Array.isArray(args)
            ? args
            : Object.values(args).length > 0
                ? (indexedInputs?.map((x) => args[x.name]) ?? [])
                : [];
        if (args_.length > 0) {
            topics =
                indexedInputs?.map((param, i) => {
                    if (Array.isArray(args_[i]))
                        return args_[i].map((_, j) => encodeArg({ param, value: args_[i][j] }));
                    return typeof args_[i] !== 'undefined' && args_[i] !== null
                        ? encodeArg({ param, value: args_[i] })
                        : null;
                }) ?? [];
        }
    }
    return [signature, ...topics];
}
function encodeArg({ param, value, }) {
    if (param.type === 'string' || param.type === 'bytes')
        return keccak256(toBytes$1(value));
    if (param.type === 'tuple' || param.type.match(/^(.*)\[(\d+)?\]$/))
        throw new FilterTypeNotSupportedError(param.type);
    return encodeAbiParameters([param], [value]);
}

/**
 * Scopes `request` to the filter ID. If the client is a fallback, it will
 * listen for responses and scope the child transport `request` function
 * to the successful filter ID.
 */
function createFilterRequestScope(client, { method }) {
    const requestMap = {};
    if (client.transport.type === 'fallback')
        client.transport.onResponse?.(({ method: method_, response: id, status, transport, }) => {
            if (status === 'success' && method === method_)
                requestMap[id] = transport.request;
        });
    return ((id) => requestMap[id] || client.request);
}

/**
 * Creates a Filter to retrieve event logs that can be used with [`getFilterChanges`](https://viem.sh/docs/actions/public/getFilterChanges) or [`getFilterLogs`](https://viem.sh/docs/actions/public/getFilterLogs).
 *
 * - Docs: https://viem.sh/docs/contract/createContractEventFilter
 *
 * @param client - Client to use
 * @param parameters - {@link CreateContractEventFilterParameters}
 * @returns [`Filter`](https://viem.sh/docs/glossary/types#filter). {@link CreateContractEventFilterReturnType}
 *
 * @example
 * import { createPublicClient, http, parseAbi } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createContractEventFilter } from 'viem/contract'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const filter = await createContractEventFilter(client, {
 *   abi: parseAbi(['event Transfer(address indexed, address indexed, uint256)']),
 * })
 */
async function createContractEventFilter(client, parameters) {
    const { address, abi, args, eventName, fromBlock, strict, toBlock } = parameters;
    const getRequest = createFilterRequestScope(client, {
        method: 'eth_newFilter',
    });
    const topics = eventName
        ? encodeEventTopics({
            abi,
            args,
            eventName,
        })
        : undefined;
    const id = await client.request({
        method: 'eth_newFilter',
        params: [
            {
                address,
                fromBlock: typeof fromBlock === 'bigint' ? numberToHex(fromBlock) : fromBlock,
                toBlock: typeof toBlock === 'bigint' ? numberToHex(toBlock) : toBlock,
                topics,
            },
        ],
    });
    return {
        abi,
        args,
        eventName,
        id,
        request: getRequest(id),
        strict: Boolean(strict),
        type: 'event',
    };
}

function parseAccount(account) {
    if (typeof account === 'string')
        return { address: account, type: 'json-rpc' };
    return account;
}

const docsPath$3 = '/docs/contract/encodeFunctionData';
function prepareEncodeFunctionData(parameters) {
    const { abi, args, functionName } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = getAbiItem({
            abi,
            args,
            name: functionName,
        });
        if (!item)
            throw new AbiFunctionNotFoundError(functionName, { docsPath: docsPath$3 });
        abiItem = item;
    }
    if (abiItem.type !== 'function')
        throw new AbiFunctionNotFoundError(undefined, { docsPath: docsPath$3 });
    return {
        abi: [abiItem],
        functionName: toFunctionSelector(formatAbiItem(abiItem)),
    };
}

function encodeFunctionData(parameters) {
    const { args } = parameters;
    const { abi, functionName } = (() => {
        if (parameters.abi.length === 1 &&
            parameters.functionName?.startsWith('0x'))
            return parameters;
        return prepareEncodeFunctionData(parameters);
    })();
    const abiItem = abi[0];
    const signature = functionName;
    const data = 'inputs' in abiItem && abiItem.inputs
        ? encodeAbiParameters(abiItem.inputs, args ?? [])
        : undefined;
    return concatHex([signature, data ?? '0x']);
}

// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#panic-via-assert-and-error-via-require
const panicReasons = {
    1: 'An `assert` condition failed.',
    17: 'Arithmetic operation resulted in underflow or overflow.',
    18: 'Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).',
    33: 'Attempted to convert to an invalid type.',
    34: 'Attempted to access a storage byte array that is incorrectly encoded.',
    49: 'Performed `.pop()` on an empty array',
    50: 'Array index is out of bounds.',
    65: 'Allocated too much memory or created an array which is too large.',
    81: 'Attempted to call a zero-initialized variable of internal function type.',
};
const solidityError = {
    inputs: [
        {
            name: 'message',
            type: 'string',
        },
    ],
    name: 'Error',
    type: 'error',
};
const solidityPanic = {
    inputs: [
        {
            name: 'reason',
            type: 'uint256',
        },
    ],
    name: 'Panic',
    type: 'error',
};

class NegativeOffsetError extends BaseError$1 {
    constructor({ offset }) {
        super(`Offset \`${offset}\` cannot be negative.`, {
            name: 'NegativeOffsetError',
        });
    }
}
class PositionOutOfBoundsError extends BaseError$1 {
    constructor({ length, position }) {
        super(`Position \`${position}\` is out of bounds (\`0 < position < ${length}\`).`, { name: 'PositionOutOfBoundsError' });
    }
}
class RecursiveReadLimitExceededError extends BaseError$1 {
    constructor({ count, limit }) {
        super(`Recursive read limit of \`${limit}\` exceeded (recursive read count: \`${count}\`).`, { name: 'RecursiveReadLimitExceededError' });
    }
}

const staticCursor = {
    bytes: new Uint8Array(),
    dataView: new DataView(new ArrayBuffer(0)),
    position: 0,
    positionReadCount: new Map(),
    recursiveReadCount: 0,
    recursiveReadLimit: Number.POSITIVE_INFINITY,
    assertReadLimit() {
        if (this.recursiveReadCount >= this.recursiveReadLimit)
            throw new RecursiveReadLimitExceededError({
                count: this.recursiveReadCount + 1,
                limit: this.recursiveReadLimit,
            });
    },
    assertPosition(position) {
        if (position < 0 || position > this.bytes.length - 1)
            throw new PositionOutOfBoundsError({
                length: this.bytes.length,
                position,
            });
    },
    decrementPosition(offset) {
        if (offset < 0)
            throw new NegativeOffsetError({ offset });
        const position = this.position - offset;
        this.assertPosition(position);
        this.position = position;
    },
    getReadCount(position) {
        return this.positionReadCount.get(position || this.position) || 0;
    },
    incrementPosition(offset) {
        if (offset < 0)
            throw new NegativeOffsetError({ offset });
        const position = this.position + offset;
        this.assertPosition(position);
        this.position = position;
    },
    inspectByte(position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectBytes(length, position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + length - 1);
        return this.bytes.subarray(position, position + length);
    },
    inspectUint8(position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectUint16(position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 1);
        return this.dataView.getUint16(position);
    },
    inspectUint24(position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 2);
        return ((this.dataView.getUint16(position) << 8) +
            this.dataView.getUint8(position + 2));
    },
    inspectUint32(position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 3);
        return this.dataView.getUint32(position);
    },
    pushByte(byte) {
        this.assertPosition(this.position);
        this.bytes[this.position] = byte;
        this.position++;
    },
    pushBytes(bytes) {
        this.assertPosition(this.position + bytes.length - 1);
        this.bytes.set(bytes, this.position);
        this.position += bytes.length;
    },
    pushUint8(value) {
        this.assertPosition(this.position);
        this.bytes[this.position] = value;
        this.position++;
    },
    pushUint16(value) {
        this.assertPosition(this.position + 1);
        this.dataView.setUint16(this.position, value);
        this.position += 2;
    },
    pushUint24(value) {
        this.assertPosition(this.position + 2);
        this.dataView.setUint16(this.position, value >> 8);
        this.dataView.setUint8(this.position + 2, value & 255);
        this.position += 3;
    },
    pushUint32(value) {
        this.assertPosition(this.position + 3);
        this.dataView.setUint32(this.position, value);
        this.position += 4;
    },
    readByte() {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectByte();
        this.position++;
        return value;
    },
    readBytes(length, size) {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectBytes(length);
        this.position += size ?? length;
        return value;
    },
    readUint8() {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint8();
        this.position += 1;
        return value;
    },
    readUint16() {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint16();
        this.position += 2;
        return value;
    },
    readUint24() {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint24();
        this.position += 3;
        return value;
    },
    readUint32() {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint32();
        this.position += 4;
        return value;
    },
    get remaining() {
        return this.bytes.length - this.position;
    },
    setPosition(position) {
        const oldPosition = this.position;
        this.assertPosition(position);
        this.position = position;
        return () => (this.position = oldPosition);
    },
    _touch() {
        if (this.recursiveReadLimit === Number.POSITIVE_INFINITY)
            return;
        const count = this.getReadCount();
        this.positionReadCount.set(this.position, count + 1);
        if (count > 0)
            this.recursiveReadCount++;
    },
};
function createCursor(bytes, { recursiveReadLimit = 8_192 } = {}) {
    const cursor = Object.create(staticCursor);
    cursor.bytes = bytes;
    cursor.dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    cursor.positionReadCount = new Map();
    cursor.recursiveReadLimit = recursiveReadLimit;
    return cursor;
}

/**
 * Decodes a byte array into a bigint.
 *
 * - Docs: https://viem.sh/docs/utilities/fromBytes#bytestobigint
 *
 * @param bytes Byte array to decode.
 * @param opts Options.
 * @returns BigInt value.
 *
 * @example
 * import { bytesToBigInt } from 'viem'
 * const data = bytesToBigInt(new Uint8Array([1, 164]))
 * // 420n
 */
function bytesToBigInt(bytes, opts = {}) {
    if (typeof opts.size !== 'undefined')
        assertSize(bytes, { size: opts.size });
    const hex = bytesToHex$2(bytes, opts);
    return hexToBigInt(hex, opts);
}
/**
 * Decodes a byte array into a boolean.
 *
 * - Docs: https://viem.sh/docs/utilities/fromBytes#bytestobool
 *
 * @param bytes Byte array to decode.
 * @param opts Options.
 * @returns Boolean value.
 *
 * @example
 * import { bytesToBool } from 'viem'
 * const data = bytesToBool(new Uint8Array([1]))
 * // true
 */
function bytesToBool(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== 'undefined') {
        assertSize(bytes, { size: opts.size });
        bytes = trim$1(bytes);
    }
    if (bytes.length > 1 || bytes[0] > 1)
        throw new InvalidBytesBooleanError(bytes);
    return Boolean(bytes[0]);
}
/**
 * Decodes a byte array into a number.
 *
 * - Docs: https://viem.sh/docs/utilities/fromBytes#bytestonumber
 *
 * @param bytes Byte array to decode.
 * @param opts Options.
 * @returns Number value.
 *
 * @example
 * import { bytesToNumber } from 'viem'
 * const data = bytesToNumber(new Uint8Array([1, 164]))
 * // 420
 */
function bytesToNumber(bytes, opts = {}) {
    if (typeof opts.size !== 'undefined')
        assertSize(bytes, { size: opts.size });
    const hex = bytesToHex$2(bytes, opts);
    return hexToNumber$1(hex, opts);
}
/**
 * Decodes a byte array into a UTF-8 string.
 *
 * - Docs: https://viem.sh/docs/utilities/fromBytes#bytestostring
 *
 * @param bytes Byte array to decode.
 * @param opts Options.
 * @returns String value.
 *
 * @example
 * import { bytesToString } from 'viem'
 * const data = bytesToString(new Uint8Array([72, 101, 108, 108, 111, 32, 87, 111, 114, 108, 100, 33]))
 * // 'Hello world'
 */
function bytesToString(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== 'undefined') {
        assertSize(bytes, { size: opts.size });
        bytes = trim$1(bytes, { dir: 'right' });
    }
    return new TextDecoder().decode(bytes);
}

function decodeAbiParameters(params, data) {
    const bytes = typeof data === 'string' ? hexToBytes$1(data) : data;
    const cursor = createCursor(bytes);
    if (size$1(bytes) === 0 && params.length > 0)
        throw new AbiDecodingZeroDataError();
    if (size$1(data) && size$1(data) < 32)
        throw new AbiDecodingDataSizeTooSmallError({
            data: typeof data === 'string' ? data : bytesToHex$2(data),
            params: params,
            size: size$1(data),
        });
    let consumed = 0;
    const values = [];
    for (let i = 0; i < params.length; ++i) {
        const param = params[i];
        cursor.setPosition(consumed);
        const [data, consumed_] = decodeParameter(cursor, param, {
            staticPosition: 0,
        });
        consumed += consumed_;
        values.push(data);
    }
    return values;
}
function decodeParameter(cursor, param, { staticPosition }) {
    const arrayComponents = getArrayComponents(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return decodeArray(cursor, { ...param, type }, { length, staticPosition });
    }
    if (param.type === 'tuple')
        return decodeTuple(cursor, param, { staticPosition });
    if (param.type === 'address')
        return decodeAddress(cursor);
    if (param.type === 'bool')
        return decodeBool(cursor);
    if (param.type.startsWith('bytes'))
        return decodeBytes(cursor, param, { staticPosition });
    if (param.type.startsWith('uint') || param.type.startsWith('int'))
        return decodeNumber(cursor, param);
    if (param.type === 'string')
        return decodeString(cursor, { staticPosition });
    throw new InvalidAbiDecodingTypeError(param.type, {
        docsPath: '/docs/contract/decodeAbiParameters',
    });
}
////////////////////////////////////////////////////////////////////
// Type Decoders
const sizeOfLength = 32;
const sizeOfOffset = 32;
function decodeAddress(cursor) {
    const value = cursor.readBytes(32);
    return [checksumAddress(bytesToHex$2(sliceBytes(value, -20))), 32];
}
function decodeArray(cursor, param, { length, staticPosition }) {
    // If the length of the array is not known in advance (dynamic array),
    // this means we will need to wonder off to the pointer and decode.
    if (!length) {
        // Dealing with a dynamic type, so get the offset of the array data.
        const offset = bytesToNumber(cursor.readBytes(sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const startOfData = start + sizeOfLength;
        // Get the length of the array from the offset.
        cursor.setPosition(start);
        const length = bytesToNumber(cursor.readBytes(sizeOfLength));
        // Check if the array has any dynamic children.
        const dynamicChild = hasDynamicChild(param);
        let consumed = 0;
        const value = [];
        for (let i = 0; i < length; ++i) {
            // If any of the children is dynamic, then all elements will be offset pointer, thus size of one slot (32 bytes).
            // Otherwise, elements will be the size of their encoding (consumed bytes).
            cursor.setPosition(startOfData + (dynamicChild ? i * 32 : consumed));
            const [data, consumed_] = decodeParameter(cursor, param, {
                staticPosition: startOfData,
            });
            consumed += consumed_;
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [value, 32];
    }
    // If the length of the array is known in advance,
    // and the length of an element deeply nested in the array is not known,
    // we need to decode the offset of the array data.
    if (hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the array data.
        const offset = bytesToNumber(cursor.readBytes(sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const value = [];
        for (let i = 0; i < length; ++i) {
            // Move cursor along to the next slot (next offset pointer).
            cursor.setPosition(start + i * 32);
            const [data] = decodeParameter(cursor, param, {
                staticPosition: start,
            });
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [value, 32];
    }
    // If the length of the array is known in advance and the array is deeply static,
    // then we can just decode each element in sequence.
    let consumed = 0;
    const value = [];
    for (let i = 0; i < length; ++i) {
        const [data, consumed_] = decodeParameter(cursor, param, {
            staticPosition: staticPosition + consumed,
        });
        consumed += consumed_;
        value.push(data);
    }
    return [value, consumed];
}
function decodeBool(cursor) {
    return [bytesToBool(cursor.readBytes(32), { size: 32 }), 32];
}
function decodeBytes(cursor, param, { staticPosition }) {
    const [_, size] = param.type.split('bytes');
    if (!size) {
        // Dealing with dynamic types, so get the offset of the bytes data.
        const offset = bytesToNumber(cursor.readBytes(32));
        // Set position of the cursor to start of bytes data.
        cursor.setPosition(staticPosition + offset);
        const length = bytesToNumber(cursor.readBytes(32));
        // If there is no length, we have zero data.
        if (length === 0) {
            // As we have gone wondering, restore to the original position + next slot.
            cursor.setPosition(staticPosition + 32);
            return ['0x', 32];
        }
        const data = cursor.readBytes(length);
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [bytesToHex$2(data), 32];
    }
    const value = bytesToHex$2(cursor.readBytes(Number.parseInt(size), 32));
    return [value, 32];
}
function decodeNumber(cursor, param) {
    const signed = param.type.startsWith('int');
    const size = Number.parseInt(param.type.split('int')[1] || '256');
    const value = cursor.readBytes(32);
    return [
        size > 48
            ? bytesToBigInt(value, { signed })
            : bytesToNumber(value, { signed }),
        32,
    ];
}
function decodeTuple(cursor, param, { staticPosition }) {
    // Tuples can have unnamed components (i.e. they are arrays), so we must
    // determine whether the tuple is named or unnamed. In the case of a named
    // tuple, the value will be an object where each property is the name of the
    // component. In the case of an unnamed tuple, the value will be an array.
    const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name }) => !name);
    // Initialize the value to an object or an array, depending on whether the
    // tuple is named or unnamed.
    const value = hasUnnamedChild ? [] : {};
    let consumed = 0;
    // If the tuple has a dynamic child, we must first decode the offset to the
    // tuple data.
    if (hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the tuple data.
        const offset = bytesToNumber(cursor.readBytes(sizeOfOffset));
        // Start is the static position of referencing slot + offset.
        const start = staticPosition + offset;
        for (let i = 0; i < param.components.length; ++i) {
            const component = param.components[i];
            cursor.setPosition(start + consumed);
            const [data, consumed_] = decodeParameter(cursor, component, {
                staticPosition: start,
            });
            consumed += consumed_;
            value[hasUnnamedChild ? i : component?.name] = data;
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [value, 32];
    }
    // If the tuple has static children, we can just decode each component
    // in sequence.
    for (let i = 0; i < param.components.length; ++i) {
        const component = param.components[i];
        const [data, consumed_] = decodeParameter(cursor, component, {
            staticPosition,
        });
        value[hasUnnamedChild ? i : component?.name] = data;
        consumed += consumed_;
    }
    return [value, consumed];
}
function decodeString(cursor, { staticPosition }) {
    // Get offset to start of string data.
    const offset = bytesToNumber(cursor.readBytes(32));
    // Start is the static position of current slot + offset.
    const start = staticPosition + offset;
    cursor.setPosition(start);
    const length = bytesToNumber(cursor.readBytes(32));
    // If there is no length, we have zero data (empty string).
    if (length === 0) {
        cursor.setPosition(staticPosition + 32);
        return ['', 32];
    }
    const data = cursor.readBytes(length, 32);
    const value = bytesToString(trim$1(data));
    // As we have gone wondering, restore to the original position + next slot.
    cursor.setPosition(staticPosition + 32);
    return [value, 32];
}
function hasDynamicChild(param) {
    const { type } = param;
    if (type === 'string')
        return true;
    if (type === 'bytes')
        return true;
    if (type.endsWith('[]'))
        return true;
    if (type === 'tuple')
        return param.components?.some(hasDynamicChild);
    const arrayComponents = getArrayComponents(param.type);
    if (arrayComponents &&
        hasDynamicChild({ ...param, type: arrayComponents[1] }))
        return true;
    return false;
}

function decodeErrorResult(parameters) {
    const { abi, data } = parameters;
    const signature = slice(data, 0, 4);
    if (signature === '0x')
        throw new AbiDecodingZeroDataError();
    const abi_ = [...(abi || []), solidityError, solidityPanic];
    const abiItem = abi_.find((x) => x.type === 'error' && signature === toFunctionSelector(formatAbiItem(x)));
    if (!abiItem)
        throw new AbiErrorSignatureNotFoundError(signature, {
            docsPath: '/docs/contract/decodeErrorResult',
        });
    return {
        abiItem,
        args: 'inputs' in abiItem && abiItem.inputs && abiItem.inputs.length > 0
            ? decodeAbiParameters(abiItem.inputs, slice(data, 4))
            : undefined,
        errorName: abiItem.name,
    };
}

const stringify$1 = (value, replacer, space) => JSON.stringify(value, (key, value_) => {
    const value = typeof value_ === 'bigint' ? value_.toString() : value_;
    return value;
}, space);

function formatAbiItemWithArgs({ abiItem, args, includeFunctionName = true, includeName = false, }) {
    if (!('name' in abiItem))
        return;
    if (!('inputs' in abiItem))
        return;
    if (!abiItem.inputs)
        return;
    return `${includeFunctionName ? abiItem.name : ''}(${abiItem.inputs
        .map((input, i) => `${includeName && input.name ? `${input.name}: ` : ''}${typeof args[i] === 'object' ? stringify$1(args[i]) : args[i]}`)
        .join(', ')})`;
}

const etherUnits = {
    gwei: 9,
    wei: 18,
};
const gweiUnits = {
    ether: -9,
    wei: 9,
};

/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */
function formatUnits(value, decimals) {
    let display = value.toString();
    const negative = display.startsWith('-');
    if (negative)
        display = display.slice(1);
    display = display.padStart(decimals, '0');
    let [integer, fraction] = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals),
    ];
    fraction = fraction.replace(/(0+)$/, '');
    return `${negative ? '-' : ''}${integer || '0'}${fraction ? `.${fraction}` : ''}`;
}

/**
 * Converts numerical wei to a string representation of ether.
 *
 * - Docs: https://viem.sh/docs/utilities/formatEther
 *
 * @example
 * import { formatEther } from 'viem'
 *
 * formatEther(1000000000000000000n)
 * // '1'
 */
function formatEther$1(wei, unit = 'wei') {
    return formatUnits(wei, etherUnits[unit]);
}

/**
 * Converts numerical wei to a string representation of gwei.
 *
 * - Docs: https://viem.sh/docs/utilities/formatGwei
 *
 * @example
 * import { formatGwei } from 'viem'
 *
 * formatGwei(1000000000n)
 * // '1'
 */
function formatGwei(wei, unit = 'wei') {
    return formatUnits(wei, gweiUnits[unit]);
}

class AccountStateConflictError extends BaseError$1 {
    constructor({ address }) {
        super(`State for account "${address}" is set multiple times.`, {
            name: 'AccountStateConflictError',
        });
    }
}
class StateAssignmentConflictError extends BaseError$1 {
    constructor() {
        super('state and stateDiff are set on the same account.', {
            name: 'StateAssignmentConflictError',
        });
    }
}
/** @internal */
function prettyStateMapping(stateMapping) {
    return stateMapping.reduce((pretty, { slot, value }) => {
        return `${pretty}        ${slot}: ${value}\n`;
    }, '');
}
function prettyStateOverride(stateOverride) {
    return stateOverride
        .reduce((pretty, { address, ...state }) => {
        let val = `${pretty}    ${address}:\n`;
        if (state.nonce)
            val += `      nonce: ${state.nonce}\n`;
        if (state.balance)
            val += `      balance: ${state.balance}\n`;
        if (state.code)
            val += `      code: ${state.code}\n`;
        if (state.state) {
            val += '      state:\n';
            val += prettyStateMapping(state.state);
        }
        if (state.stateDiff) {
            val += '      stateDiff:\n';
            val += prettyStateMapping(state.stateDiff);
        }
        return val;
    }, '  State Override:\n')
        .slice(0, -1);
}

function prettyPrint(args) {
    const entries = Object.entries(args)
        .map(([key, value]) => {
        if (value === undefined || value === false)
            return null;
        return [key, value];
    })
        .filter(Boolean);
    const maxLength = entries.reduce((acc, [key]) => Math.max(acc, key.length), 0);
    return entries
        .map(([key, value]) => `  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`)
        .join('\n');
}
class FeeConflictError extends BaseError$1 {
    constructor() {
        super([
            'Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.',
            'Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others.',
        ].join('\n'), { name: 'FeeConflictError' });
    }
}
class InvalidLegacyVError extends BaseError$1 {
    constructor({ v }) {
        super(`Invalid \`v\` value "${v}". Expected 27 or 28.`, {
            name: 'InvalidLegacyVError',
        });
    }
}
class InvalidSerializableTransactionError extends BaseError$1 {
    constructor({ transaction }) {
        super('Cannot infer a transaction type from provided transaction.', {
            metaMessages: [
                'Provided Transaction:',
                '{',
                prettyPrint(transaction),
                '}',
                '',
                'To infer the type, either provide:',
                '- a `type` to the Transaction, or',
                '- an EIP-1559 Transaction with `maxFeePerGas`, or',
                '- an EIP-2930 Transaction with `gasPrice` & `accessList`, or',
                '- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or',
                '- an EIP-7702 Transaction with `authorizationList`, or',
                '- a Legacy Transaction with `gasPrice`',
            ],
            name: 'InvalidSerializableTransactionError',
        });
    }
}
class InvalidStorageKeySizeError extends BaseError$1 {
    constructor({ storageKey }) {
        super(`Size for storage key "${storageKey}" is invalid. Expected 32 bytes. Got ${Math.floor((storageKey.length - 2) / 2)} bytes.`, { name: 'InvalidStorageKeySizeError' });
    }
}
class TransactionExecutionError extends BaseError$1 {
    constructor(cause, { account, docsPath, chain, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to, value, }) {
        const prettyArgs = prettyPrint({
            chain: chain && `${chain?.name} (id: ${chain?.id})`,
            from: account?.address,
            to,
            value: typeof value !== 'undefined' &&
                `${formatEther$1(value)} ${chain?.nativeCurrency?.symbol || 'ETH'}`,
            data,
            gas,
            gasPrice: typeof gasPrice !== 'undefined' && `${formatGwei(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== 'undefined' &&
                `${formatGwei(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== 'undefined' &&
                `${formatGwei(maxPriorityFeePerGas)} gwei`,
            nonce,
        });
        super(cause.shortMessage, {
            cause,
            docsPath,
            metaMessages: [
                ...(cause.metaMessages ? [...cause.metaMessages, ' '] : []),
                'Request Arguments:',
                prettyArgs,
            ].filter(Boolean),
            name: 'TransactionExecutionError',
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}
class TransactionNotFoundError extends BaseError$1 {
    constructor({ blockHash, blockNumber, blockTag, hash, index, }) {
        let identifier = 'Transaction';
        if (blockTag && index !== undefined)
            identifier = `Transaction at block time "${blockTag}" at index "${index}"`;
        if (blockHash && index !== undefined)
            identifier = `Transaction at block hash "${blockHash}" at index "${index}"`;
        if (blockNumber && index !== undefined)
            identifier = `Transaction at block number "${blockNumber}" at index "${index}"`;
        if (hash)
            identifier = `Transaction with hash "${hash}"`;
        super(`${identifier} could not be found.`, {
            name: 'TransactionNotFoundError',
        });
    }
}
class TransactionReceiptNotFoundError extends BaseError$1 {
    constructor({ hash }) {
        super(`Transaction receipt with hash "${hash}" could not be found. The Transaction may not be processed on a block yet.`, {
            name: 'TransactionReceiptNotFoundError',
        });
    }
}
class WaitForTransactionReceiptTimeoutError extends BaseError$1 {
    constructor({ hash }) {
        super(`Timed out while waiting for transaction with hash "${hash}" to be confirmed.`, { name: 'WaitForTransactionReceiptTimeoutError' });
    }
}

const getContractAddress = (address) => address;
const getUrl = (url) => url;

class CallExecutionError extends BaseError$1 {
    constructor(cause, { account: account_, docsPath, chain, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to, value, stateOverride, }) {
        const account = account_ ? parseAccount(account_) : undefined;
        let prettyArgs = prettyPrint({
            from: account?.address,
            to,
            value: typeof value !== 'undefined' &&
                `${formatEther$1(value)} ${chain?.nativeCurrency?.symbol || 'ETH'}`,
            data,
            gas,
            gasPrice: typeof gasPrice !== 'undefined' && `${formatGwei(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== 'undefined' &&
                `${formatGwei(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== 'undefined' &&
                `${formatGwei(maxPriorityFeePerGas)} gwei`,
            nonce,
        });
        if (stateOverride) {
            prettyArgs += `\n${prettyStateOverride(stateOverride)}`;
        }
        super(cause.shortMessage, {
            cause,
            docsPath,
            metaMessages: [
                ...(cause.metaMessages ? [...cause.metaMessages, ' '] : []),
                'Raw Call Arguments:',
                prettyArgs,
            ].filter(Boolean),
            name: 'CallExecutionError',
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}
class ContractFunctionExecutionError extends BaseError$1 {
    constructor(cause, { abi, args, contractAddress, docsPath, functionName, sender, }) {
        const abiItem = getAbiItem({ abi, args, name: functionName });
        const formattedArgs = abiItem
            ? formatAbiItemWithArgs({
                abiItem,
                args,
                includeFunctionName: false,
                includeName: false,
            })
            : undefined;
        const functionWithParams = abiItem
            ? formatAbiItem(abiItem, { includeName: true })
            : undefined;
        const prettyArgs = prettyPrint({
            address: contractAddress && getContractAddress(contractAddress),
            function: functionWithParams,
            args: formattedArgs &&
                formattedArgs !== '()' &&
                `${[...Array(functionName?.length ?? 0).keys()]
                    .map(() => ' ')
                    .join('')}${formattedArgs}`,
            sender,
        });
        super(cause.shortMessage ||
            `An unknown error occurred while executing the contract function "${functionName}".`, {
            cause,
            docsPath,
            metaMessages: [
                ...(cause.metaMessages ? [...cause.metaMessages, ' '] : []),
                prettyArgs && 'Contract Call:',
                prettyArgs,
            ].filter(Boolean),
            name: 'ContractFunctionExecutionError',
        });
        Object.defineProperty(this, "abi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formattedArgs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "functionName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abi = abi;
        this.args = args;
        this.cause = cause;
        this.contractAddress = contractAddress;
        this.functionName = functionName;
        this.sender = sender;
    }
}
class ContractFunctionRevertedError extends BaseError$1 {
    constructor({ abi, data, functionName, message, }) {
        let cause;
        let decodedData = undefined;
        let metaMessages;
        let reason;
        if (data && data !== '0x') {
            try {
                decodedData = decodeErrorResult({ abi, data });
                const { abiItem, errorName, args: errorArgs } = decodedData;
                if (errorName === 'Error') {
                    reason = errorArgs[0];
                }
                else if (errorName === 'Panic') {
                    const [firstArg] = errorArgs;
                    reason = panicReasons[firstArg];
                }
                else {
                    const errorWithParams = abiItem
                        ? formatAbiItem(abiItem, { includeName: true })
                        : undefined;
                    const formattedArgs = abiItem && errorArgs
                        ? formatAbiItemWithArgs({
                            abiItem,
                            args: errorArgs,
                            includeFunctionName: false,
                            includeName: false,
                        })
                        : undefined;
                    metaMessages = [
                        errorWithParams ? `Error: ${errorWithParams}` : '',
                        formattedArgs && formattedArgs !== '()'
                            ? `       ${[...Array(errorName?.length ?? 0).keys()]
                                .map(() => ' ')
                                .join('')}${formattedArgs}`
                            : '',
                    ];
                }
            }
            catch (err) {
                cause = err;
            }
        }
        else if (message)
            reason = message;
        let signature;
        if (cause instanceof AbiErrorSignatureNotFoundError) {
            signature = cause.signature;
            metaMessages = [
                `Unable to decode signature "${signature}" as it was not found on the provided ABI.`,
                'Make sure you are using the correct ABI and that the error exists on it.',
                `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`,
            ];
        }
        super((reason && reason !== 'execution reverted') || signature
            ? [
                `The contract function "${functionName}" reverted with the following ${signature ? 'signature' : 'reason'}:`,
                reason || signature,
            ].join('\n')
            : `The contract function "${functionName}" reverted.`, {
            cause,
            metaMessages,
            name: 'ContractFunctionRevertedError',
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "raw", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = decodedData;
        this.raw = data;
        this.reason = reason;
        this.signature = signature;
    }
}
class ContractFunctionZeroDataError extends BaseError$1 {
    constructor({ functionName }) {
        super(`The contract function "${functionName}" returned no data ("0x").`, {
            metaMessages: [
                'This could be due to any of the following:',
                `  - The contract does not have the function "${functionName}",`,
                '  - The parameters passed to the contract function may be invalid, or',
                '  - The address is not a contract.',
            ],
            name: 'ContractFunctionZeroDataError',
        });
    }
}
class CounterfactualDeploymentFailedError extends BaseError$1 {
    constructor({ factory }) {
        super(`Deployment for counterfactual contract call failed${factory ? ` for factory "${factory}".` : ''}`, {
            metaMessages: [
                'Please ensure:',
                '- The `factory` is a valid contract deployment factory (ie. Create2 Factory, ERC-4337 Factory, etc).',
                '- The `factoryData` is a valid encoded function call for contract deployment function on the factory.',
            ],
            name: 'CounterfactualDeploymentFailedError',
        });
    }
}
class RawContractError extends BaseError$1 {
    constructor({ data, message, }) {
        super(message || '', { name: 'RawContractError' });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
    }
}

class HttpRequestError extends BaseError$1 {
    constructor({ body, cause, details, headers, status, url, }) {
        super('HTTP request failed.', {
            cause,
            details,
            metaMessages: [
                status && `Status: ${status}`,
                `URL: ${getUrl(url)}`,
                body && `Request body: ${stringify$1(body)}`,
            ].filter(Boolean),
            name: 'HttpRequestError',
        });
        Object.defineProperty(this, "body", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.body = body;
        this.headers = headers;
        this.status = status;
        this.url = url;
    }
}
class RpcRequestError extends BaseError$1 {
    constructor({ body, error, url, }) {
        super('RPC Request failed.', {
            cause: error,
            details: error.message,
            metaMessages: [`URL: ${getUrl(url)}`, `Request body: ${stringify$1(body)}`],
            name: 'RpcRequestError',
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = error.code;
        this.data = error.data;
    }
}
class TimeoutError extends BaseError$1 {
    constructor({ body, url, }) {
        super('The request took too long to respond.', {
            details: 'The request timed out.',
            metaMessages: [`URL: ${getUrl(url)}`, `Request body: ${stringify$1(body)}`],
            name: 'TimeoutError',
        });
    }
}

const unknownErrorCode = -1;
class RpcError extends BaseError$1 {
    constructor(cause, { code, docsPath, metaMessages, name, shortMessage, }) {
        super(shortMessage, {
            cause,
            docsPath,
            metaMessages: metaMessages || cause?.metaMessages,
            name: name || 'RpcError',
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name || cause.name;
        this.code = (cause instanceof RpcRequestError ? cause.code : (code ?? unknownErrorCode));
    }
}
class ProviderRpcError extends RpcError {
    constructor(cause, options) {
        super(cause, options);
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = options.data;
    }
}
class ParseRpcError extends RpcError {
    constructor(cause) {
        super(cause, {
            code: ParseRpcError.code,
            name: 'ParseRpcError',
            shortMessage: 'Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text.',
        });
    }
}
Object.defineProperty(ParseRpcError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32700
});
class InvalidRequestRpcError extends RpcError {
    constructor(cause) {
        super(cause, {
            code: InvalidRequestRpcError.code,
            name: 'InvalidRequestRpcError',
            shortMessage: 'JSON is not a valid request object.',
        });
    }
}
Object.defineProperty(InvalidRequestRpcError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32600
});
class MethodNotFoundRpcError extends RpcError {
    constructor(cause, { method } = {}) {
        super(cause, {
            code: MethodNotFoundRpcError.code,
            name: 'MethodNotFoundRpcError',
            shortMessage: `The method${method ? ` "${method}"` : ''} does not exist / is not available.`,
        });
    }
}
Object.defineProperty(MethodNotFoundRpcError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32601
});
class InvalidParamsRpcError extends RpcError {
    constructor(cause) {
        super(cause, {
            code: InvalidParamsRpcError.code,
            name: 'InvalidParamsRpcError',
            shortMessage: [
                'Invalid parameters were provided to the RPC method.',
                'Double check you have provided the correct parameters.',
            ].join('\n'),
        });
    }
}
Object.defineProperty(InvalidParamsRpcError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32602
});
class InternalRpcError extends RpcError {
    constructor(cause) {
        super(cause, {
            code: InternalRpcError.code,
            name: 'InternalRpcError',
            shortMessage: 'An internal error was received.',
        });
    }
}
Object.defineProperty(InternalRpcError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32603
});
class InvalidInputRpcError extends RpcError {
    constructor(cause) {
        super(cause, {
            code: InvalidInputRpcError.code,
            name: 'InvalidInputRpcError',
            shortMessage: [
                'Missing or invalid parameters.',
                'Double check you have provided the correct parameters.',
            ].join('\n'),
        });
    }
}
Object.defineProperty(InvalidInputRpcError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32e3
});
class ResourceNotFoundRpcError extends RpcError {
    constructor(cause) {
        super(cause, {
            code: ResourceNotFoundRpcError.code,
            name: 'ResourceNotFoundRpcError',
            shortMessage: 'Requested resource not found.',
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'ResourceNotFoundRpcError'
        });
    }
}
Object.defineProperty(ResourceNotFoundRpcError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32001
});
class ResourceUnavailableRpcError extends RpcError {
    constructor(cause) {
        super(cause, {
            code: ResourceUnavailableRpcError.code,
            name: 'ResourceUnavailableRpcError',
            shortMessage: 'Requested resource not available.',
        });
    }
}
Object.defineProperty(ResourceUnavailableRpcError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32002
});
class TransactionRejectedRpcError extends RpcError {
    constructor(cause) {
        super(cause, {
            code: TransactionRejectedRpcError.code,
            name: 'TransactionRejectedRpcError',
            shortMessage: 'Transaction creation failed.',
        });
    }
}
Object.defineProperty(TransactionRejectedRpcError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32003
});
class MethodNotSupportedRpcError extends RpcError {
    constructor(cause, { method } = {}) {
        super(cause, {
            code: MethodNotSupportedRpcError.code,
            name: 'MethodNotSupportedRpcError',
            shortMessage: `Method${method ? ` "${method}"` : ''} is not supported.`,
        });
    }
}
Object.defineProperty(MethodNotSupportedRpcError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32004
});
class LimitExceededRpcError extends RpcError {
    constructor(cause) {
        super(cause, {
            code: LimitExceededRpcError.code,
            name: 'LimitExceededRpcError',
            shortMessage: 'Request exceeds defined limit.',
        });
    }
}
Object.defineProperty(LimitExceededRpcError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32005
});
class JsonRpcVersionUnsupportedError extends RpcError {
    constructor(cause) {
        super(cause, {
            code: JsonRpcVersionUnsupportedError.code,
            name: 'JsonRpcVersionUnsupportedError',
            shortMessage: 'Version of JSON-RPC protocol is not supported.',
        });
    }
}
Object.defineProperty(JsonRpcVersionUnsupportedError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32006
});
let UserRejectedRequestError$1 = class UserRejectedRequestError extends ProviderRpcError {
    constructor(cause) {
        super(cause, {
            code: UserRejectedRequestError.code,
            name: 'UserRejectedRequestError',
            shortMessage: 'User rejected the request.',
        });
    }
};
Object.defineProperty(UserRejectedRequestError$1, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4001
});
class UnauthorizedProviderError extends ProviderRpcError {
    constructor(cause) {
        super(cause, {
            code: UnauthorizedProviderError.code,
            name: 'UnauthorizedProviderError',
            shortMessage: 'The requested method and/or account has not been authorized by the user.',
        });
    }
}
Object.defineProperty(UnauthorizedProviderError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4100
});
class UnsupportedProviderMethodError extends ProviderRpcError {
    constructor(cause, { method } = {}) {
        super(cause, {
            code: UnsupportedProviderMethodError.code,
            name: 'UnsupportedProviderMethodError',
            shortMessage: `The Provider does not support the requested method${method ? ` " ${method}"` : ''}.`,
        });
    }
}
Object.defineProperty(UnsupportedProviderMethodError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4200
});
class ProviderDisconnectedError extends ProviderRpcError {
    constructor(cause) {
        super(cause, {
            code: ProviderDisconnectedError.code,
            name: 'ProviderDisconnectedError',
            shortMessage: 'The Provider is disconnected from all chains.',
        });
    }
}
Object.defineProperty(ProviderDisconnectedError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4900
});
class ChainDisconnectedError extends ProviderRpcError {
    constructor(cause) {
        super(cause, {
            code: ChainDisconnectedError.code,
            name: 'ChainDisconnectedError',
            shortMessage: 'The Provider is not connected to the requested chain.',
        });
    }
}
Object.defineProperty(ChainDisconnectedError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4901
});
class SwitchChainError extends ProviderRpcError {
    constructor(cause) {
        super(cause, {
            code: SwitchChainError.code,
            name: 'SwitchChainError',
            shortMessage: 'An error occurred when attempting to switch chain.',
        });
    }
}
Object.defineProperty(SwitchChainError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4902
});
class UnknownRpcError extends RpcError {
    constructor(cause) {
        super(cause, {
            name: 'UnknownRpcError',
            shortMessage: 'An unknown RPC error occurred.',
        });
    }
}

const EXECUTION_REVERTED_ERROR_CODE = 3;
function getContractError(err, { abi, address, args, docsPath, functionName, sender, }) {
    const error = (err instanceof RawContractError
        ? err
        : err instanceof BaseError$1
            ? err.walk((err) => 'data' in err) || err.walk()
            : {});
    const { code, data, details, message, shortMessage } = error;
    const cause = (() => {
        if (err instanceof AbiDecodingZeroDataError)
            return new ContractFunctionZeroDataError({ functionName });
        if ([EXECUTION_REVERTED_ERROR_CODE, InternalRpcError.code].includes(code) &&
            (data || details || message || shortMessage)) {
            return new ContractFunctionRevertedError({
                abi,
                data: typeof data === 'object' ? data.data : data,
                functionName,
                message: error instanceof RpcRequestError
                    ? details
                    : (shortMessage ?? message),
            });
        }
        return err;
    })();
    return new ContractFunctionExecutionError(cause, {
        abi,
        args,
        contractAddress: address,
        docsPath,
        functionName,
        sender,
    });
}

/**
 * @description Converts an ECDSA public key to an address.
 *
 * @param publicKey The public key to convert.
 *
 * @returns The address.
 */
function publicKeyToAddress(publicKey) {
    const address = keccak256(`0x${publicKey.substring(4)}`).substring(26);
    return checksumAddress(`0x${address}`);
}

async function recoverPublicKey({ hash, signature, }) {
    const hashHex = isHex$2(hash) ? hash : toHex(hash);
    const { secp256k1 } = await Promise.resolve().then(function () { return secp256k1$1; });
    const signature_ = (() => {
        // typeof signature: `Signature`
        if (typeof signature === 'object' && 'r' in signature && 's' in signature) {
            const { r, s, v, yParity } = signature;
            const yParityOrV = Number(yParity ?? v);
            const recoveryBit = toRecoveryBit(yParityOrV);
            return new secp256k1.Signature(hexToBigInt(r), hexToBigInt(s)).addRecoveryBit(recoveryBit);
        }
        // typeof signature: `Hex | ByteArray`
        const signatureHex = isHex$2(signature) ? signature : toHex(signature);
        const yParityOrV = hexToNumber$1(`0x${signatureHex.slice(130)}`);
        const recoveryBit = toRecoveryBit(yParityOrV);
        return secp256k1.Signature.fromCompact(signatureHex.substring(2, 130)).addRecoveryBit(recoveryBit);
    })();
    const publicKey = signature_
        .recoverPublicKey(hashHex.substring(2))
        .toHex(false);
    return `0x${publicKey}`;
}
function toRecoveryBit(yParityOrV) {
    if (yParityOrV === 0 || yParityOrV === 1)
        return yParityOrV;
    if (yParityOrV === 27)
        return 0;
    if (yParityOrV === 28)
        return 1;
    throw new Error('Invalid yParityOrV value');
}

async function recoverAddress({ hash, signature, }) {
    return publicKeyToAddress(await recoverPublicKey({ hash: hash, signature }));
}

function toRlp(bytes, to = 'hex') {
    const encodable = getEncodable(bytes);
    const cursor = createCursor(new Uint8Array(encodable.length));
    encodable.encode(cursor);
    if (to === 'hex')
        return bytesToHex$2(cursor.bytes);
    return cursor.bytes;
}
function getEncodable(bytes) {
    if (Array.isArray(bytes))
        return getEncodableList(bytes.map((x) => getEncodable(x)));
    return getEncodableBytes(bytes);
}
function getEncodableList(list) {
    const bodyLength = list.reduce((acc, x) => acc + x.length, 0);
    const sizeOfBodyLength = getSizeOfLength(bodyLength);
    const length = (() => {
        if (bodyLength <= 55)
            return 1 + bodyLength;
        return 1 + sizeOfBodyLength + bodyLength;
    })();
    return {
        length,
        encode(cursor) {
            if (bodyLength <= 55) {
                cursor.pushByte(0xc0 + bodyLength);
            }
            else {
                cursor.pushByte(0xc0 + 55 + sizeOfBodyLength);
                if (sizeOfBodyLength === 1)
                    cursor.pushUint8(bodyLength);
                else if (sizeOfBodyLength === 2)
                    cursor.pushUint16(bodyLength);
                else if (sizeOfBodyLength === 3)
                    cursor.pushUint24(bodyLength);
                else
                    cursor.pushUint32(bodyLength);
            }
            for (const { encode } of list) {
                encode(cursor);
            }
        },
    };
}
function getEncodableBytes(bytesOrHex) {
    const bytes = typeof bytesOrHex === 'string' ? hexToBytes$1(bytesOrHex) : bytesOrHex;
    const sizeOfBytesLength = getSizeOfLength(bytes.length);
    const length = (() => {
        if (bytes.length === 1 && bytes[0] < 0x80)
            return 1;
        if (bytes.length <= 55)
            return 1 + bytes.length;
        return 1 + sizeOfBytesLength + bytes.length;
    })();
    return {
        length,
        encode(cursor) {
            if (bytes.length === 1 && bytes[0] < 0x80) {
                cursor.pushBytes(bytes);
            }
            else if (bytes.length <= 55) {
                cursor.pushByte(0x80 + bytes.length);
                cursor.pushBytes(bytes);
            }
            else {
                cursor.pushByte(0x80 + 55 + sizeOfBytesLength);
                if (sizeOfBytesLength === 1)
                    cursor.pushUint8(bytes.length);
                else if (sizeOfBytesLength === 2)
                    cursor.pushUint16(bytes.length);
                else if (sizeOfBytesLength === 3)
                    cursor.pushUint24(bytes.length);
                else
                    cursor.pushUint32(bytes.length);
                cursor.pushBytes(bytes);
            }
        },
    };
}
function getSizeOfLength(length) {
    if (length < 2 ** 8)
        return 1;
    if (length < 2 ** 16)
        return 2;
    if (length < 2 ** 24)
        return 3;
    if (length < 2 ** 32)
        return 4;
    throw new BaseError$1('Length is too large.');
}

/**
 * Computes an Authorization hash in [EIP-7702 format](https://eips.ethereum.org/EIPS/eip-7702): `keccak256('0x05' || rlp([chain_id, address, nonce]))`.
 */
function hashAuthorization(parameters) {
    const { chainId, contractAddress, nonce, to } = parameters;
    const hash = keccak256(concatHex([
        '0x05',
        toRlp([
            chainId ? numberToHex(chainId) : '0x',
            contractAddress,
            nonce ? numberToHex(nonce) : '0x',
        ]),
    ]));
    if (to === 'bytes')
        return hexToBytes$1(hash);
    return hash;
}

async function recoverAuthorizationAddress(parameters) {
    const { authorization, signature } = parameters;
    return recoverAddress({
        hash: hashAuthorization(authorization),
        signature: (signature ?? authorization),
    });
}

class EstimateGasExecutionError extends BaseError$1 {
    constructor(cause, { account, docsPath, chain, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to, value, }) {
        const prettyArgs = prettyPrint({
            from: account?.address,
            to,
            value: typeof value !== 'undefined' &&
                `${formatEther$1(value)} ${chain?.nativeCurrency?.symbol || 'ETH'}`,
            data,
            gas,
            gasPrice: typeof gasPrice !== 'undefined' && `${formatGwei(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== 'undefined' &&
                `${formatGwei(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== 'undefined' &&
                `${formatGwei(maxPriorityFeePerGas)} gwei`,
            nonce,
        });
        super(cause.shortMessage, {
            cause,
            docsPath,
            metaMessages: [
                ...(cause.metaMessages ? [...cause.metaMessages, ' '] : []),
                'Estimate Gas Arguments:',
                prettyArgs,
            ].filter(Boolean),
            name: 'EstimateGasExecutionError',
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}

class ExecutionRevertedError extends BaseError$1 {
    constructor({ cause, message, } = {}) {
        const reason = message
            ?.replace('execution reverted: ', '')
            ?.replace('execution reverted', '');
        super(`Execution reverted ${reason ? `with reason: ${reason}` : 'for an unknown reason'}.`, {
            cause,
            name: 'ExecutionRevertedError',
        });
    }
}
Object.defineProperty(ExecutionRevertedError, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 3
});
Object.defineProperty(ExecutionRevertedError, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /execution reverted/
});
class FeeCapTooHighError extends BaseError$1 {
    constructor({ cause, maxFeePerGas, } = {}) {
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${formatGwei(maxFeePerGas)} gwei` : ''}) cannot be higher than the maximum allowed value (2^256-1).`, {
            cause,
            name: 'FeeCapTooHighError',
        });
    }
}
Object.defineProperty(FeeCapTooHighError, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class FeeCapTooLowError extends BaseError$1 {
    constructor({ cause, maxFeePerGas, } = {}) {
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${formatGwei(maxFeePerGas)}` : ''} gwei) cannot be lower than the block base fee.`, {
            cause,
            name: 'FeeCapTooLowError',
        });
    }
}
Object.defineProperty(FeeCapTooLowError, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class NonceTooHighError extends BaseError$1 {
    constructor({ cause, nonce, } = {}) {
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ''}is higher than the next one expected.`, { cause, name: 'NonceTooHighError' });
    }
}
Object.defineProperty(NonceTooHighError, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too high/
});
class NonceTooLowError extends BaseError$1 {
    constructor({ cause, nonce, } = {}) {
        super([
            `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ''}is lower than the current nonce of the account.`,
            'Try increasing the nonce or find the latest nonce with `getTransactionCount`.',
        ].join('\n'), { cause, name: 'NonceTooLowError' });
    }
}
Object.defineProperty(NonceTooLowError, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too low|transaction already imported|already known/
});
class NonceMaxValueError extends BaseError$1 {
    constructor({ cause, nonce, } = {}) {
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ''}exceeds the maximum allowed nonce.`, { cause, name: 'NonceMaxValueError' });
    }
}
Object.defineProperty(NonceMaxValueError, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce has max value/
});
let InsufficientFundsError$1 = class InsufficientFundsError extends BaseError$1 {
    constructor({ cause } = {}) {
        super([
            'The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account.',
        ].join('\n'), {
            cause,
            metaMessages: [
                'This error could arise when the account does not have enough funds to:',
                ' - pay for the total gas fee,',
                ' - pay for the value to send.',
                ' ',
                'The cost of the transaction is calculated as `gas * gas fee + value`, where:',
                ' - `gas` is the amount of gas needed for transaction to execute,',
                ' - `gas fee` is the gas fee,',
                ' - `value` is the amount of ether to send to the recipient.',
            ],
            name: 'InsufficientFundsError',
        });
    }
};
Object.defineProperty(InsufficientFundsError$1, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /insufficient funds|exceeds transaction sender account balance/
});
class IntrinsicGasTooHighError extends BaseError$1 {
    constructor({ cause, gas, } = {}) {
        super(`The amount of gas ${gas ? `(${gas}) ` : ''}provided for the transaction exceeds the limit allowed for the block.`, {
            cause,
            name: 'IntrinsicGasTooHighError',
        });
    }
}
Object.defineProperty(IntrinsicGasTooHighError, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too high|gas limit reached/
});
class IntrinsicGasTooLowError extends BaseError$1 {
    constructor({ cause, gas, } = {}) {
        super(`The amount of gas ${gas ? `(${gas}) ` : ''}provided for the transaction is too low.`, {
            cause,
            name: 'IntrinsicGasTooLowError',
        });
    }
}
Object.defineProperty(IntrinsicGasTooLowError, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too low/
});
class TransactionTypeNotSupportedError extends BaseError$1 {
    constructor({ cause }) {
        super('The transaction type is not supported for this chain.', {
            cause,
            name: 'TransactionTypeNotSupportedError',
        });
    }
}
Object.defineProperty(TransactionTypeNotSupportedError, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /transaction type not valid/
});
class TipAboveFeeCapError extends BaseError$1 {
    constructor({ cause, maxPriorityFeePerGas, maxFeePerGas, } = {}) {
        super([
            `The provided tip (\`maxPriorityFeePerGas\`${maxPriorityFeePerGas
                ? ` = ${formatGwei(maxPriorityFeePerGas)} gwei`
                : ''}) cannot be higher than the fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${formatGwei(maxFeePerGas)} gwei` : ''}).`,
        ].join('\n'), {
            cause,
            name: 'TipAboveFeeCapError',
        });
    }
}
Object.defineProperty(TipAboveFeeCapError, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class UnknownNodeError extends BaseError$1 {
    constructor({ cause }) {
        super(`An error occurred while executing: ${cause?.shortMessage}`, {
            cause,
            name: 'UnknownNodeError',
        });
    }
}

function getNodeError(err, args) {
    const message = (err.details || '').toLowerCase();
    const executionRevertedError = err instanceof BaseError$1
        ? err.walk((e) => e?.code ===
            ExecutionRevertedError.code)
        : err;
    if (executionRevertedError instanceof BaseError$1)
        return new ExecutionRevertedError({
            cause: err,
            message: executionRevertedError.details,
        });
    if (ExecutionRevertedError.nodeMessage.test(message))
        return new ExecutionRevertedError({
            cause: err,
            message: err.details,
        });
    if (FeeCapTooHighError.nodeMessage.test(message))
        return new FeeCapTooHighError({
            cause: err,
            maxFeePerGas: args?.maxFeePerGas,
        });
    if (FeeCapTooLowError.nodeMessage.test(message))
        return new FeeCapTooLowError({
            cause: err,
            maxFeePerGas: args?.maxFeePerGas,
        });
    if (NonceTooHighError.nodeMessage.test(message))
        return new NonceTooHighError({ cause: err, nonce: args?.nonce });
    if (NonceTooLowError.nodeMessage.test(message))
        return new NonceTooLowError({ cause: err, nonce: args?.nonce });
    if (NonceMaxValueError.nodeMessage.test(message))
        return new NonceMaxValueError({ cause: err, nonce: args?.nonce });
    if (InsufficientFundsError$1.nodeMessage.test(message))
        return new InsufficientFundsError$1({ cause: err });
    if (IntrinsicGasTooHighError.nodeMessage.test(message))
        return new IntrinsicGasTooHighError({ cause: err, gas: args?.gas });
    if (IntrinsicGasTooLowError.nodeMessage.test(message))
        return new IntrinsicGasTooLowError({ cause: err, gas: args?.gas });
    if (TransactionTypeNotSupportedError.nodeMessage.test(message))
        return new TransactionTypeNotSupportedError({ cause: err });
    if (TipAboveFeeCapError.nodeMessage.test(message))
        return new TipAboveFeeCapError({
            cause: err,
            maxFeePerGas: args?.maxFeePerGas,
            maxPriorityFeePerGas: args?.maxPriorityFeePerGas,
        });
    return new UnknownNodeError({
        cause: err,
    });
}

function getEstimateGasError(err, { docsPath, ...args }) {
    const cause = (() => {
        const cause = getNodeError(err, args);
        if (cause instanceof UnknownNodeError)
            return err;
        return cause;
    })();
    return new EstimateGasExecutionError(cause, {
        docsPath,
        ...args,
    });
}

/**
 * @description Picks out the keys from `value` that exist in the formatter..
 */
function extract(value_, { format }) {
    if (!format)
        return {};
    const value = {};
    function extract_(formatted) {
        const keys = Object.keys(formatted);
        for (const key of keys) {
            if (key in value_)
                value[key] = value_[key];
            if (formatted[key] &&
                typeof formatted[key] === 'object' &&
                !Array.isArray(formatted[key]))
                extract_(formatted[key]);
        }
    }
    const formatted = format(value_ || {});
    extract_(formatted);
    return value;
}

function defineFormatter(type, format) {
    return ({ exclude, format: overrides, }) => {
        return {
            exclude,
            format: (args) => {
                const formatted = format(args);
                if (exclude) {
                    for (const key of exclude) {
                        delete formatted[key];
                    }
                }
                return {
                    ...formatted,
                    ...overrides(args),
                };
            },
            type,
        };
    };
}

const rpcTransactionType = {
    legacy: '0x0',
    eip2930: '0x1',
    eip1559: '0x2',
    eip4844: '0x3',
    eip7702: '0x4',
};
function formatTransactionRequest(request) {
    const rpcRequest = {};
    if (typeof request.authorizationList !== 'undefined')
        rpcRequest.authorizationList = formatAuthorizationList$1(request.authorizationList);
    if (typeof request.accessList !== 'undefined')
        rpcRequest.accessList = request.accessList;
    if (typeof request.blobVersionedHashes !== 'undefined')
        rpcRequest.blobVersionedHashes = request.blobVersionedHashes;
    if (typeof request.blobs !== 'undefined') {
        if (typeof request.blobs[0] !== 'string')
            rpcRequest.blobs = request.blobs.map((x) => bytesToHex$2(x));
        else
            rpcRequest.blobs = request.blobs;
    }
    if (typeof request.data !== 'undefined')
        rpcRequest.data = request.data;
    if (typeof request.from !== 'undefined')
        rpcRequest.from = request.from;
    if (typeof request.gas !== 'undefined')
        rpcRequest.gas = numberToHex(request.gas);
    if (typeof request.gasPrice !== 'undefined')
        rpcRequest.gasPrice = numberToHex(request.gasPrice);
    if (typeof request.maxFeePerBlobGas !== 'undefined')
        rpcRequest.maxFeePerBlobGas = numberToHex(request.maxFeePerBlobGas);
    if (typeof request.maxFeePerGas !== 'undefined')
        rpcRequest.maxFeePerGas = numberToHex(request.maxFeePerGas);
    if (typeof request.maxPriorityFeePerGas !== 'undefined')
        rpcRequest.maxPriorityFeePerGas = numberToHex(request.maxPriorityFeePerGas);
    if (typeof request.nonce !== 'undefined')
        rpcRequest.nonce = numberToHex(request.nonce);
    if (typeof request.to !== 'undefined')
        rpcRequest.to = request.to;
    if (typeof request.type !== 'undefined')
        rpcRequest.type = rpcTransactionType[request.type];
    if (typeof request.value !== 'undefined')
        rpcRequest.value = numberToHex(request.value);
    return rpcRequest;
}
const defineTransactionRequest = /*#__PURE__*/ defineFormatter('transactionRequest', formatTransactionRequest);
//////////////////////////////////////////////////////////////////////////////
function formatAuthorizationList$1(authorizationList) {
    return authorizationList.map((authorization) => ({
        address: authorization.contractAddress,
        r: authorization.r,
        s: authorization.s,
        chainId: numberToHex(authorization.chainId),
        nonce: numberToHex(authorization.nonce),
        ...(typeof authorization.yParity !== 'undefined'
            ? { yParity: numberToHex(authorization.yParity) }
            : {}),
        ...(typeof authorization.v !== 'undefined' &&
            typeof authorization.yParity === 'undefined'
            ? { v: numberToHex(authorization.v) }
            : {}),
    }));
}

/** @internal */
function serializeStateMapping(stateMapping) {
    if (!stateMapping || stateMapping.length === 0)
        return undefined;
    return stateMapping.reduce((acc, { slot, value }) => {
        if (slot.length !== 66)
            throw new InvalidBytesLengthError({
                size: slot.length,
                targetSize: 66,
                type: 'hex',
            });
        if (value.length !== 66)
            throw new InvalidBytesLengthError({
                size: value.length,
                targetSize: 66,
                type: 'hex',
            });
        acc[slot] = value;
        return acc;
    }, {});
}
/** @internal */
function serializeAccountStateOverride(parameters) {
    const { balance, nonce, state, stateDiff, code } = parameters;
    const rpcAccountStateOverride = {};
    if (code !== undefined)
        rpcAccountStateOverride.code = code;
    if (balance !== undefined)
        rpcAccountStateOverride.balance = numberToHex(balance);
    if (nonce !== undefined)
        rpcAccountStateOverride.nonce = numberToHex(nonce);
    if (state !== undefined)
        rpcAccountStateOverride.state = serializeStateMapping(state);
    if (stateDiff !== undefined) {
        if (rpcAccountStateOverride.state)
            throw new StateAssignmentConflictError();
        rpcAccountStateOverride.stateDiff = serializeStateMapping(stateDiff);
    }
    return rpcAccountStateOverride;
}
/** @internal */
function serializeStateOverride(parameters) {
    if (!parameters)
        return undefined;
    const rpcStateOverride = {};
    for (const { address, ...accountState } of parameters) {
        if (!isAddress(address, { strict: false }))
            throw new InvalidAddressError({ address });
        if (rpcStateOverride[address])
            throw new AccountStateConflictError({ address: address });
        rpcStateOverride[address] = serializeAccountStateOverride(accountState);
    }
    return rpcStateOverride;
}

const maxUint16 = 2n ** 16n - 1n;
const maxUint256 = 2n ** 256n - 1n;

function assertRequest(args) {
    const { account: account_, gasPrice, maxFeePerGas, maxPriorityFeePerGas, to, } = args;
    const account = account_ ? parseAccount(account_) : undefined;
    if (account && !isAddress(account.address))
        throw new InvalidAddressError({ address: account.address });
    if (to && !isAddress(to))
        throw new InvalidAddressError({ address: to });
    if (typeof gasPrice !== 'undefined' &&
        (typeof maxFeePerGas !== 'undefined' ||
            typeof maxPriorityFeePerGas !== 'undefined'))
        throw new FeeConflictError();
    if (maxFeePerGas && maxFeePerGas > maxUint256)
        throw new FeeCapTooHighError({ maxFeePerGas });
    if (maxPriorityFeePerGas &&
        maxFeePerGas &&
        maxPriorityFeePerGas > maxFeePerGas)
        throw new TipAboveFeeCapError({ maxFeePerGas, maxPriorityFeePerGas });
}

class BaseFeeScalarError extends BaseError$1 {
    constructor() {
        super('`baseFeeMultiplier` must be greater than 1.', {
            name: 'BaseFeeScalarError',
        });
    }
}
class Eip1559FeesNotSupportedError extends BaseError$1 {
    constructor() {
        super('Chain does not support EIP-1559 fees.', {
            name: 'Eip1559FeesNotSupportedError',
        });
    }
}
class MaxFeePerGasTooLowError extends BaseError$1 {
    constructor({ maxPriorityFeePerGas }) {
        super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${formatGwei(maxPriorityFeePerGas)} gwei).`, { name: 'MaxFeePerGasTooLowError' });
    }
}

class BlockNotFoundError extends BaseError$1 {
    constructor({ blockHash, blockNumber, }) {
        let identifier = 'Block';
        if (blockHash)
            identifier = `Block at hash "${blockHash}"`;
        if (blockNumber)
            identifier = `Block at number "${blockNumber}"`;
        super(`${identifier} could not be found.`, { name: 'BlockNotFoundError' });
    }
}

const transactionType = {
    '0x0': 'legacy',
    '0x1': 'eip2930',
    '0x2': 'eip1559',
    '0x3': 'eip4844',
    '0x4': 'eip7702',
};
function formatTransaction(transaction) {
    const transaction_ = {
        ...transaction,
        blockHash: transaction.blockHash ? transaction.blockHash : null,
        blockNumber: transaction.blockNumber
            ? BigInt(transaction.blockNumber)
            : null,
        chainId: transaction.chainId ? hexToNumber$1(transaction.chainId) : undefined,
        gas: transaction.gas ? BigInt(transaction.gas) : undefined,
        gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : undefined,
        maxFeePerBlobGas: transaction.maxFeePerBlobGas
            ? BigInt(transaction.maxFeePerBlobGas)
            : undefined,
        maxFeePerGas: transaction.maxFeePerGas
            ? BigInt(transaction.maxFeePerGas)
            : undefined,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas
            ? BigInt(transaction.maxPriorityFeePerGas)
            : undefined,
        nonce: transaction.nonce ? hexToNumber$1(transaction.nonce) : undefined,
        to: transaction.to ? transaction.to : null,
        transactionIndex: transaction.transactionIndex
            ? Number(transaction.transactionIndex)
            : null,
        type: transaction.type
            ? transactionType[transaction.type]
            : undefined,
        typeHex: transaction.type ? transaction.type : undefined,
        value: transaction.value ? BigInt(transaction.value) : undefined,
        v: transaction.v ? BigInt(transaction.v) : undefined,
    };
    if (transaction.authorizationList)
        transaction_.authorizationList = formatAuthorizationList(transaction.authorizationList);
    transaction_.yParity = (() => {
        // If `yParity` is provided, we will use it.
        if (transaction.yParity)
            return Number(transaction.yParity);
        // If no `yParity` provided, try derive from `v`.
        if (typeof transaction_.v === 'bigint') {
            if (transaction_.v === 0n || transaction_.v === 27n)
                return 0;
            if (transaction_.v === 1n || transaction_.v === 28n)
                return 1;
            if (transaction_.v >= 35n)
                return transaction_.v % 2n === 0n ? 1 : 0;
        }
        return undefined;
    })();
    if (transaction_.type === 'legacy') {
        delete transaction_.accessList;
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
        delete transaction_.yParity;
    }
    if (transaction_.type === 'eip2930') {
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
    }
    if (transaction_.type === 'eip1559') {
        delete transaction_.maxFeePerBlobGas;
    }
    return transaction_;
}
const defineTransaction = /*#__PURE__*/ defineFormatter('transaction', formatTransaction);
//////////////////////////////////////////////////////////////////////////////
function formatAuthorizationList(authorizationList) {
    return authorizationList.map((authorization) => ({
        contractAddress: authorization.address,
        chainId: Number(authorization.chainId),
        nonce: Number(authorization.nonce),
        r: authorization.r,
        s: authorization.s,
        yParity: Number(authorization.yParity),
    }));
}

function formatBlock(block) {
    const transactions = (block.transactions ?? []).map((transaction) => {
        if (typeof transaction === 'string')
            return transaction;
        return formatTransaction(transaction);
    });
    return {
        ...block,
        baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
        blobGasUsed: block.blobGasUsed ? BigInt(block.blobGasUsed) : undefined,
        difficulty: block.difficulty ? BigInt(block.difficulty) : undefined,
        excessBlobGas: block.excessBlobGas
            ? BigInt(block.excessBlobGas)
            : undefined,
        gasLimit: block.gasLimit ? BigInt(block.gasLimit) : undefined,
        gasUsed: block.gasUsed ? BigInt(block.gasUsed) : undefined,
        hash: block.hash ? block.hash : null,
        logsBloom: block.logsBloom ? block.logsBloom : null,
        nonce: block.nonce ? block.nonce : null,
        number: block.number ? BigInt(block.number) : null,
        size: block.size ? BigInt(block.size) : undefined,
        timestamp: block.timestamp ? BigInt(block.timestamp) : undefined,
        transactions,
        totalDifficulty: block.totalDifficulty
            ? BigInt(block.totalDifficulty)
            : null,
    };
}
const defineBlock = /*#__PURE__*/ defineFormatter('block', formatBlock);

/**
 * Returns information about a block at a block number, hash, or tag.
 *
 * - Docs: https://viem.sh/docs/actions/public/getBlock
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/blocks_fetching-blocks
 * - JSON-RPC Methods:
 *   - Calls [`eth_getBlockByNumber`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getblockbynumber) for `blockNumber` & `blockTag`.
 *   - Calls [`eth_getBlockByHash`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getblockbyhash) for `blockHash`.
 *
 * @param client - Client to use
 * @param parameters - {@link GetBlockParameters}
 * @returns Information about the block. {@link GetBlockReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getBlock } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const block = await getBlock(client)
 */
async function getBlock(client, { blockHash, blockNumber, blockTag: blockTag_, includeTransactions: includeTransactions_, } = {}) {
    const blockTag = blockTag_ ?? 'latest';
    const includeTransactions = includeTransactions_ ?? false;
    const blockNumberHex = blockNumber !== undefined ? numberToHex(blockNumber) : undefined;
    let block = null;
    if (blockHash) {
        block = await client.request({
            method: 'eth_getBlockByHash',
            params: [blockHash, includeTransactions],
        }, { dedupe: true });
    }
    else {
        block = await client.request({
            method: 'eth_getBlockByNumber',
            params: [blockNumberHex || blockTag, includeTransactions],
        }, { dedupe: Boolean(blockNumberHex) });
    }
    if (!block)
        throw new BlockNotFoundError({ blockHash, blockNumber });
    const format = client.chain?.formatters?.block?.format || formatBlock;
    return format(block);
}

/**
 * Returns the current price of gas (in wei).
 *
 * - Docs: https://viem.sh/docs/actions/public/getGasPrice
 * - JSON-RPC Methods: [`eth_gasPrice`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gasprice)
 *
 * @param client - Client to use
 * @returns The gas price (in wei). {@link GetGasPriceReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getGasPrice } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const gasPrice = await getGasPrice(client)
 */
async function getGasPrice(client) {
    const gasPrice = await client.request({
        method: 'eth_gasPrice',
    });
    return BigInt(gasPrice);
}

/**
 * Returns an estimate for the max priority fee per gas (in wei) for a
 * transaction to be likely included in the next block.
 * Defaults to [`chain.fees.defaultPriorityFee`](/docs/clients/chains#fees-defaultpriorityfee) if set.
 *
 * - Docs: https://viem.sh/docs/actions/public/estimateMaxPriorityFeePerGas
 *
 * @param client - Client to use
 * @returns An estimate (in wei) for the max priority fee per gas. {@link EstimateMaxPriorityFeePerGasReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { estimateMaxPriorityFeePerGas } from 'viem/actions'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const maxPriorityFeePerGas = await estimateMaxPriorityFeePerGas(client)
 * // 10000000n
 */
async function estimateMaxPriorityFeePerGas(client, args) {
    return internal_estimateMaxPriorityFeePerGas(client, args);
}
async function internal_estimateMaxPriorityFeePerGas(client, args) {
    const { block: block_, chain = client.chain, request } = args || {};
    try {
        const maxPriorityFeePerGas = chain?.fees?.maxPriorityFeePerGas ?? chain?.fees?.defaultPriorityFee;
        if (typeof maxPriorityFeePerGas === 'function') {
            const block = block_ || (await getAction(client, getBlock, 'getBlock')({}));
            const maxPriorityFeePerGas_ = await maxPriorityFeePerGas({
                block,
                client,
                request,
            });
            if (maxPriorityFeePerGas_ === null)
                throw new Error();
            return maxPriorityFeePerGas_;
        }
        if (typeof maxPriorityFeePerGas !== 'undefined')
            return maxPriorityFeePerGas;
        const maxPriorityFeePerGasHex = await client.request({
            method: 'eth_maxPriorityFeePerGas',
        });
        return hexToBigInt(maxPriorityFeePerGasHex);
    }
    catch {
        // If the RPC Provider does not support `eth_maxPriorityFeePerGas`
        // fall back to calculating it manually via `gasPrice - baseFeePerGas`.
        // See: https://github.com/ethereum/pm/issues/328#:~:text=eth_maxPriorityFeePerGas%20after%20London%20will%20effectively%20return%20eth_gasPrice%20%2D%20baseFee
        const [block, gasPrice] = await Promise.all([
            block_
                ? Promise.resolve(block_)
                : getAction(client, getBlock, 'getBlock')({}),
            getAction(client, getGasPrice, 'getGasPrice')({}),
        ]);
        if (typeof block.baseFeePerGas !== 'bigint')
            throw new Eip1559FeesNotSupportedError();
        const maxPriorityFeePerGas = gasPrice - block.baseFeePerGas;
        if (maxPriorityFeePerGas < 0n)
            return 0n;
        return maxPriorityFeePerGas;
    }
}

/**
 * Returns an estimate for the fees per gas (in wei) for a
 * transaction to be likely included in the next block.
 * Defaults to [`chain.fees.estimateFeesPerGas`](/docs/clients/chains#fees-estimatefeespergas) if set.
 *
 * - Docs: https://viem.sh/docs/actions/public/estimateFeesPerGas
 *
 * @param client - Client to use
 * @param parameters - {@link EstimateFeesPerGasParameters}
 * @returns An estimate (in wei) for the fees per gas. {@link EstimateFeesPerGasReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { estimateFeesPerGas } from 'viem/actions'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const maxPriorityFeePerGas = await estimateFeesPerGas(client)
 * // { maxFeePerGas: ..., maxPriorityFeePerGas: ... }
 */
async function estimateFeesPerGas$1(client, args) {
    return internal_estimateFeesPerGas(client, args);
}
async function internal_estimateFeesPerGas(client, args) {
    const { block: block_, chain = client.chain, request, type = 'eip1559', } = args || {};
    const baseFeeMultiplier = await (async () => {
        if (typeof chain?.fees?.baseFeeMultiplier === 'function')
            return chain.fees.baseFeeMultiplier({
                block: block_,
                client,
                request,
            });
        return chain?.fees?.baseFeeMultiplier ?? 1.2;
    })();
    if (baseFeeMultiplier < 1)
        throw new BaseFeeScalarError();
    const decimals = baseFeeMultiplier.toString().split('.')[1]?.length ?? 0;
    const denominator = 10 ** decimals;
    const multiply = (base) => (base * BigInt(Math.ceil(baseFeeMultiplier * denominator))) /
        BigInt(denominator);
    const block = block_
        ? block_
        : await getAction(client, getBlock, 'getBlock')({});
    if (typeof chain?.fees?.estimateFeesPerGas === 'function') {
        const fees = (await chain.fees.estimateFeesPerGas({
            block: block_,
            client,
            multiply,
            request,
            type,
        }));
        if (fees !== null)
            return fees;
    }
    if (type === 'eip1559') {
        if (typeof block.baseFeePerGas !== 'bigint')
            throw new Eip1559FeesNotSupportedError();
        const maxPriorityFeePerGas = typeof request?.maxPriorityFeePerGas === 'bigint'
            ? request.maxPriorityFeePerGas
            : await internal_estimateMaxPriorityFeePerGas(client, {
                block: block,
                chain,
                request,
            });
        const baseFeePerGas = multiply(block.baseFeePerGas);
        const maxFeePerGas = request?.maxFeePerGas ?? baseFeePerGas + maxPriorityFeePerGas;
        return {
            maxFeePerGas,
            maxPriorityFeePerGas,
        };
    }
    const gasPrice = request?.gasPrice ??
        multiply(await getAction(client, getGasPrice, 'getGasPrice')({}));
    return {
        gasPrice,
    };
}

/**
 * Returns the number of [Transactions](https://viem.sh/docs/glossary/terms#transaction) an Account has sent.
 *
 * - Docs: https://viem.sh/docs/actions/public/getTransactionCount
 * - JSON-RPC Methods: [`eth_getTransactionCount`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gettransactioncount)
 *
 * @param client - Client to use
 * @param parameters - {@link GetTransactionCountParameters}
 * @returns The number of transactions an account has sent. {@link GetTransactionCountReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getTransactionCount } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const transactionCount = await getTransactionCount(client, {
 *   address: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
 * })
 */
async function getTransactionCount(client, { address, blockTag = 'latest', blockNumber }) {
    const count = await client.request({
        method: 'eth_getTransactionCount',
        params: [address, blockNumber ? numberToHex(blockNumber) : blockTag],
    }, { dedupe: Boolean(blockNumber) });
    return hexToNumber$1(count);
}

/**
 * Compute commitments from a list of blobs.
 *
 * @example
 * ```ts
 * import { blobsToCommitments, toBlobs } from 'viem'
 * import { kzg } from './kzg'
 *
 * const blobs = toBlobs({ data: '0x1234' })
 * const commitments = blobsToCommitments({ blobs, kzg })
 * ```
 */
function blobsToCommitments(parameters) {
    const { kzg } = parameters;
    const to = parameters.to ?? (typeof parameters.blobs[0] === 'string' ? 'hex' : 'bytes');
    const blobs = (typeof parameters.blobs[0] === 'string'
        ? parameters.blobs.map((x) => hexToBytes$1(x))
        : parameters.blobs);
    const commitments = [];
    for (const blob of blobs)
        commitments.push(Uint8Array.from(kzg.blobToKzgCommitment(blob)));
    return (to === 'bytes'
        ? commitments
        : commitments.map((x) => bytesToHex$2(x)));
}

/**
 * Compute the proofs for a list of blobs and their commitments.
 *
 * @example
 * ```ts
 * import {
 *   blobsToCommitments,
 *   toBlobs
 * } from 'viem'
 * import { kzg } from './kzg'
 *
 * const blobs = toBlobs({ data: '0x1234' })
 * const commitments = blobsToCommitments({ blobs, kzg })
 * const proofs = blobsToProofs({ blobs, commitments, kzg })
 * ```
 */
function blobsToProofs(parameters) {
    const { kzg } = parameters;
    const to = parameters.to ?? (typeof parameters.blobs[0] === 'string' ? 'hex' : 'bytes');
    const blobs = (typeof parameters.blobs[0] === 'string'
        ? parameters.blobs.map((x) => hexToBytes$1(x))
        : parameters.blobs);
    const commitments = (typeof parameters.commitments[0] === 'string'
        ? parameters.commitments.map((x) => hexToBytes$1(x))
        : parameters.commitments);
    const proofs = [];
    for (let i = 0; i < blobs.length; i++) {
        const blob = blobs[i];
        const commitment = commitments[i];
        proofs.push(Uint8Array.from(kzg.computeBlobKzgProof(blob, commitment)));
    }
    return (to === 'bytes'
        ? proofs
        : proofs.map((x) => bytesToHex$2(x)));
}

/**
 * Internal Merkle-Damgard hash utils.
 * @module
 */
/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */
function setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function')
        return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number((value >> _32n) & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */
function Chi(a, b, c) {
    return (a & b) ^ (~a & c);
}
/** Majority function, true if any two inputs is true. */
function Maj(a, b, c) {
    return (a & b) ^ (a & c) ^ (b & c);
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */
class HashMD extends Hash$2 {
    constructor(blockLen, outputLen, padOffset, isLE) {
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = createView(this.buffer);
    }
    update(data) {
        aexists(this);
        const { view, buffer, blockLen } = this;
        data = toBytes(data);
        const len = data.length;
        for (let pos = 0; pos < len;) {
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = createView(data);
                for (; blockLen <= len - pos; pos += blockLen)
                    this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        aexists(this);
        aoutput(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer, view, blockLen, isLE } = this;
        let { pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 0b10000000;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for (let i = pos; i < blockLen; i++)
            buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = createView(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4)
            throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length)
            throw new Error('_sha2: outputLen bigger than state');
        for (let i = 0; i < outLen; i++)
            oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer, outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen, buffer, length, finished, destroyed, pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen)
            to.buffer.set(buffer);
        return to;
    }
}

/**
 * SHA2-256 a.k.a. sha256. In JS, it is the fastest hash, even faster than Blake3.
 *
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 *
 * Check out [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */
/** Round constants: first 32 bits of fractional parts of the cube roots of the first 64 primes 2..311). */
// prettier-ignore
const SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
    0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
    0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
    0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
    0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
    0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
    0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
]);
/** Initial state: first 32 bits of fractional parts of the square roots of the first 8 primes 2..19. */
// prettier-ignore
const SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
]);
/**
 * Temporary buffer, not used to store anything between runs.
 * Named this way because it matches specification.
 */
const SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends HashMD {
    constructor() {
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = SHA256_IV[0] | 0;
        this.B = SHA256_IV[1] | 0;
        this.C = SHA256_IV[2] | 0;
        this.D = SHA256_IV[3] | 0;
        this.E = SHA256_IV[4] | 0;
        this.F = SHA256_IV[5] | 0;
        this.G = SHA256_IV[6] | 0;
        this.H = SHA256_IV[7] | 0;
    }
    get() {
        const { A, B, C, D, E, F, G, H } = this;
        return [A, B, C, D, E, F, G, H];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for (let i = 0; i < 16; i++, offset += 4)
            SHA256_W[i] = view.getUint32(offset, false);
        for (let i = 16; i < 64; i++) {
            const W15 = SHA256_W[i - 15];
            const W2 = SHA256_W[i - 2];
            const s0 = rotr(W15, 7) ^ rotr(W15, 18) ^ (W15 >>> 3);
            const s1 = rotr(W2, 17) ^ rotr(W2, 19) ^ (W2 >>> 10);
            SHA256_W[i] = (s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16]) | 0;
        }
        // Compression function main loop, 64 rounds
        let { A, B, C, D, E, F, G, H } = this;
        for (let i = 0; i < 64; i++) {
            const sigma1 = rotr(E, 6) ^ rotr(E, 11) ^ rotr(E, 25);
            const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const sigma0 = rotr(A, 2) ^ rotr(A, 13) ^ rotr(A, 22);
            const T2 = (sigma0 + Maj(A, B, C)) | 0;
            H = G;
            G = F;
            F = E;
            E = (D + T1) | 0;
            D = C;
            C = B;
            B = A;
            A = (T1 + T2) | 0;
        }
        // Add the compressed chunk to the current hash value
        A = (A + this.A) | 0;
        B = (B + this.B) | 0;
        C = (C + this.C) | 0;
        D = (D + this.D) | 0;
        E = (E + this.E) | 0;
        F = (F + this.F) | 0;
        G = (G + this.G) | 0;
        H = (H + this.H) | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
/** SHA2-256 hash function */
const sha256$2 = /* @__PURE__ */ wrapConstructor(() => new SHA256());

function sha256$1(value, to_) {
    const to = to_ || 'hex';
    const bytes = sha256$2(isHex$2(value, { strict: false }) ? toBytes$1(value) : value);
    if (to === 'bytes')
        return bytes;
    return toHex(bytes);
}

/**
 * Transform a commitment to it's versioned hash.
 *
 * @example
 * ```ts
 * import {
 *   blobsToCommitments,
 *   commitmentToVersionedHash,
 *   toBlobs
 * } from 'viem'
 * import { kzg } from './kzg'
 *
 * const blobs = toBlobs({ data: '0x1234' })
 * const [commitment] = blobsToCommitments({ blobs, kzg })
 * const versionedHash = commitmentToVersionedHash({ commitment })
 * ```
 */
function commitmentToVersionedHash(parameters) {
    const { commitment, version = 1 } = parameters;
    const to = parameters.to ?? (typeof commitment === 'string' ? 'hex' : 'bytes');
    const versionedHash = sha256$1(commitment, 'bytes');
    versionedHash.set([version], 0);
    return (to === 'bytes' ? versionedHash : bytesToHex$2(versionedHash));
}

/**
 * Transform a list of commitments to their versioned hashes.
 *
 * @example
 * ```ts
 * import {
 *   blobsToCommitments,
 *   commitmentsToVersionedHashes,
 *   toBlobs
 * } from 'viem'
 * import { kzg } from './kzg'
 *
 * const blobs = toBlobs({ data: '0x1234' })
 * const commitments = blobsToCommitments({ blobs, kzg })
 * const versionedHashes = commitmentsToVersionedHashes({ commitments })
 * ```
 */
function commitmentsToVersionedHashes(parameters) {
    const { commitments, version } = parameters;
    const to = parameters.to ?? (typeof commitments[0] === 'string' ? 'hex' : 'bytes');
    const hashes = [];
    for (const commitment of commitments) {
        hashes.push(commitmentToVersionedHash({
            commitment,
            to,
            version,
        }));
    }
    return hashes;
}

// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
/** Blob limit per transaction. */
const blobsPerTransaction = 6;
/** The number of bytes in a BLS scalar field element. */
const bytesPerFieldElement = 32;
/** The number of field elements in a blob. */
const fieldElementsPerBlob = 4096;
/** The number of bytes in a blob. */
const bytesPerBlob = bytesPerFieldElement * fieldElementsPerBlob;
/** Blob bytes limit per transaction. */
const maxBytesPerTransaction = bytesPerBlob * blobsPerTransaction -
    // terminator byte (0x80).
    1 -
    // zero byte (0x00) appended to each field element.
    1 * fieldElementsPerBlob * blobsPerTransaction;

// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
const versionedHashVersionKzg = 1;

class BlobSizeTooLargeError extends BaseError$1 {
    constructor({ maxSize, size }) {
        super('Blob size is too large.', {
            metaMessages: [`Max: ${maxSize} bytes`, `Given: ${size} bytes`],
            name: 'BlobSizeTooLargeError',
        });
    }
}
class EmptyBlobError extends BaseError$1 {
    constructor() {
        super('Blob data must not be empty.', { name: 'EmptyBlobError' });
    }
}
class InvalidVersionedHashSizeError extends BaseError$1 {
    constructor({ hash, size, }) {
        super(`Versioned hash "${hash}" size is invalid.`, {
            metaMessages: ['Expected: 32', `Received: ${size}`],
            name: 'InvalidVersionedHashSizeError',
        });
    }
}
class InvalidVersionedHashVersionError extends BaseError$1 {
    constructor({ hash, version, }) {
        super(`Versioned hash "${hash}" version is invalid.`, {
            metaMessages: [
                `Expected: ${versionedHashVersionKzg}`,
                `Received: ${version}`,
            ],
            name: 'InvalidVersionedHashVersionError',
        });
    }
}

/**
 * Transforms arbitrary data to blobs.
 *
 * @example
 * ```ts
 * import { toBlobs, stringToHex } from 'viem'
 *
 * const blobs = toBlobs({ data: stringToHex('hello world') })
 * ```
 */
function toBlobs(parameters) {
    const to = parameters.to ?? (typeof parameters.data === 'string' ? 'hex' : 'bytes');
    const data = (typeof parameters.data === 'string'
        ? hexToBytes$1(parameters.data)
        : parameters.data);
    const size_ = size$1(data);
    if (!size_)
        throw new EmptyBlobError();
    if (size_ > maxBytesPerTransaction)
        throw new BlobSizeTooLargeError({
            maxSize: maxBytesPerTransaction,
            size: size_,
        });
    const blobs = [];
    let active = true;
    let position = 0;
    while (active) {
        const blob = createCursor(new Uint8Array(bytesPerBlob));
        let size = 0;
        while (size < fieldElementsPerBlob) {
            const bytes = data.slice(position, position + (bytesPerFieldElement - 1));
            // Push a zero byte so the field element doesn't overflow the BLS modulus.
            blob.pushByte(0x00);
            // Push the current segment of data bytes.
            blob.pushBytes(bytes);
            // If we detect that the current segment of data bytes is less than 31 bytes,
            // we can stop processing and push a terminator byte to indicate the end of the blob.
            if (bytes.length < 31) {
                blob.pushByte(0x80);
                active = false;
                break;
            }
            size++;
            position += 31;
        }
        blobs.push(blob);
    }
    return (to === 'bytes'
        ? blobs.map((x) => x.bytes)
        : blobs.map((x) => bytesToHex$2(x.bytes)));
}

/**
 * Transforms arbitrary data (or blobs, commitments, & proofs) into a sidecar array.
 *
 * @example
 * ```ts
 * import { toBlobSidecars, stringToHex } from 'viem'
 *
 * const sidecars = toBlobSidecars({ data: stringToHex('hello world') })
 * ```
 *
 * @example
 * ```ts
 * import {
 *   blobsToCommitments,
 *   toBlobs,
 *   blobsToProofs,
 *   toBlobSidecars,
 *   stringToHex
 * } from 'viem'
 *
 * const blobs = toBlobs({ data: stringToHex('hello world') })
 * const commitments = blobsToCommitments({ blobs, kzg })
 * const proofs = blobsToProofs({ blobs, commitments, kzg })
 *
 * const sidecars = toBlobSidecars({ blobs, commitments, proofs })
 * ```
 */
function toBlobSidecars(parameters) {
    const { data, kzg, to } = parameters;
    const blobs = parameters.blobs ?? toBlobs({ data: data, to });
    const commitments = parameters.commitments ?? blobsToCommitments({ blobs, kzg: kzg, to });
    const proofs = parameters.proofs ?? blobsToProofs({ blobs, commitments, kzg: kzg, to });
    const sidecars = [];
    for (let i = 0; i < blobs.length; i++)
        sidecars.push({
            blob: blobs[i],
            commitment: commitments[i],
            proof: proofs[i],
        });
    return sidecars;
}

function getTransactionType(transaction) {
    if (transaction.type)
        return transaction.type;
    if (typeof transaction.authorizationList !== 'undefined')
        return 'eip7702';
    if (typeof transaction.blobs !== 'undefined' ||
        typeof transaction.blobVersionedHashes !== 'undefined' ||
        typeof transaction.maxFeePerBlobGas !== 'undefined' ||
        typeof transaction.sidecars !== 'undefined')
        return 'eip4844';
    if (typeof transaction.maxFeePerGas !== 'undefined' ||
        typeof transaction.maxPriorityFeePerGas !== 'undefined') {
        return 'eip1559';
    }
    if (typeof transaction.gasPrice !== 'undefined') {
        if (typeof transaction.accessList !== 'undefined')
            return 'eip2930';
        return 'legacy';
    }
    throw new InvalidSerializableTransactionError({ transaction });
}

/**
 * Returns the chain ID associated with the current network.
 *
 * - Docs: https://viem.sh/docs/actions/public/getChainId
 * - JSON-RPC Methods: [`eth_chainId`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_chainid)
 *
 * @param client - Client to use
 * @returns The current chain ID. {@link GetChainIdReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getChainId } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const chainId = await getChainId(client)
 * // 1
 */
async function getChainId(client) {
    const chainIdHex = await client.request({
        method: 'eth_chainId',
    }, { dedupe: true });
    return hexToNumber$1(chainIdHex);
}

const defaultParameters = [
    'blobVersionedHashes',
    'chainId',
    'fees',
    'gas',
    'nonce',
    'type',
];
/** @internal */
const eip1559NetworkCache = /*#__PURE__*/ new Map();
/**
 * Prepares a transaction request for signing.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/prepareTransactionRequest
 *
 * @param args - {@link PrepareTransactionRequestParameters}
 * @returns The transaction request. {@link PrepareTransactionRequestReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { prepareTransactionRequest } from 'viem/actions'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const request = await prepareTransactionRequest(client, {
 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
 *   to: '0x0000000000000000000000000000000000000000',
 *   value: 1n,
 * })
 *
 * @example
 * // Account Hoisting
 * import { createWalletClient, http } from 'viem'
 * import { privateKeyToAccount } from 'viem/accounts'
 * import { mainnet } from 'viem/chains'
 * import { prepareTransactionRequest } from 'viem/actions'
 *
 * const client = createWalletClient({
 *   account: privateKeyToAccount('0x…'),
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const request = await prepareTransactionRequest(client, {
 *   to: '0x0000000000000000000000000000000000000000',
 *   value: 1n,
 * })
 */
async function prepareTransactionRequest(client, args) {
    const { account: account_ = client.account, blobs, chain, gas, kzg, nonce, nonceManager, parameters = defaultParameters, type, } = args;
    const account = account_ ? parseAccount(account_) : account_;
    const request = { ...args, ...(account ? { from: account?.address } : {}) };
    let block;
    async function getBlock$1() {
        if (block)
            return block;
        block = await getAction(client, getBlock, 'getBlock')({ blockTag: 'latest' });
        return block;
    }
    let chainId;
    async function getChainId$1() {
        if (chainId)
            return chainId;
        if (chain)
            return chain.id;
        if (typeof args.chainId !== 'undefined')
            return args.chainId;
        const chainId_ = await getAction(client, getChainId, 'getChainId')({});
        chainId = chainId_;
        return chainId;
    }
    if ((parameters.includes('blobVersionedHashes') ||
        parameters.includes('sidecars')) &&
        blobs &&
        kzg) {
        const commitments = blobsToCommitments({ blobs, kzg });
        if (parameters.includes('blobVersionedHashes')) {
            const versionedHashes = commitmentsToVersionedHashes({
                commitments,
                to: 'hex',
            });
            request.blobVersionedHashes = versionedHashes;
        }
        if (parameters.includes('sidecars')) {
            const proofs = blobsToProofs({ blobs, commitments, kzg });
            const sidecars = toBlobSidecars({
                blobs,
                commitments,
                proofs,
                to: 'hex',
            });
            request.sidecars = sidecars;
        }
    }
    if (parameters.includes('chainId'))
        request.chainId = await getChainId$1();
    if ((parameters.includes('fees') || parameters.includes('type')) &&
        typeof type === 'undefined') {
        try {
            request.type = getTransactionType(request);
        }
        catch {
            let isEip1559Network = eip1559NetworkCache.get(client.uid);
            if (typeof isEip1559Network === 'undefined') {
                const block = await getBlock$1();
                isEip1559Network = typeof block?.baseFeePerGas === 'bigint';
                eip1559NetworkCache.set(client.uid, isEip1559Network);
            }
            request.type = isEip1559Network ? 'eip1559' : 'legacy';
        }
    }
    if (parameters.includes('fees')) {
        // TODO(4844): derive blob base fees once https://github.com/ethereum/execution-apis/pull/486 is merged.
        if (request.type !== 'legacy' && request.type !== 'eip2930') {
            // EIP-1559 fees
            if (typeof request.maxFeePerGas === 'undefined' ||
                typeof request.maxPriorityFeePerGas === 'undefined') {
                const block = await getBlock$1();
                const { maxFeePerGas, maxPriorityFeePerGas } = await internal_estimateFeesPerGas(client, {
                    block: block,
                    chain,
                    request: request,
                });
                if (typeof args.maxPriorityFeePerGas === 'undefined' &&
                    args.maxFeePerGas &&
                    args.maxFeePerGas < maxPriorityFeePerGas)
                    throw new MaxFeePerGasTooLowError({
                        maxPriorityFeePerGas,
                    });
                request.maxPriorityFeePerGas = maxPriorityFeePerGas;
                request.maxFeePerGas = maxFeePerGas;
            }
        }
        else {
            // Legacy fees
            if (typeof args.maxFeePerGas !== 'undefined' ||
                typeof args.maxPriorityFeePerGas !== 'undefined')
                throw new Eip1559FeesNotSupportedError();
            if (typeof args.gasPrice === 'undefined') {
                const block = await getBlock$1();
                const { gasPrice: gasPrice_ } = await internal_estimateFeesPerGas(client, {
                    block: block,
                    chain,
                    request: request,
                    type: 'legacy',
                });
                request.gasPrice = gasPrice_;
            }
        }
    }
    if (parameters.includes('gas') && typeof gas === 'undefined')
        request.gas = await getAction(client, estimateGas$1, 'estimateGas')({
            ...request,
            account: account
                ? { address: account.address, type: 'json-rpc' }
                : account,
        });
    if (parameters.includes('nonce') && typeof nonce === 'undefined' && account) {
        if (nonceManager) {
            const chainId = await getChainId$1();
            request.nonce = await nonceManager.consume({
                address: account.address,
                chainId,
                client,
            });
        }
        else {
            request.nonce = await getAction(client, getTransactionCount, 'getTransactionCount')({
                address: account.address,
                blockTag: 'pending',
            });
        }
    }
    assertRequest(request);
    delete request.parameters;
    return request;
}

/**
 * Returns the balance of an address in wei.
 *
 * - Docs: https://viem.sh/docs/actions/public/getBalance
 * - JSON-RPC Methods: [`eth_getBalance`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getbalance)
 *
 * You can convert the balance to ether units with [`formatEther`](https://viem.sh/docs/utilities/formatEther).
 *
 * ```ts
 * const balance = await getBalance(client, {
 *   address: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
 *   blockTag: 'safe'
 * })
 * const balanceAsEther = formatEther(balance)
 * // "6.942"
 * ```
 *
 * @param client - Client to use
 * @param parameters - {@link GetBalanceParameters}
 * @returns The balance of the address in wei. {@link GetBalanceReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getBalance } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const balance = await getBalance(client, {
 *   address: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
 * })
 * // 10000000000000000000000n (wei)
 */
async function getBalance(client, { address, blockNumber, blockTag = 'latest' }) {
    const blockNumberHex = blockNumber ? numberToHex(blockNumber) : undefined;
    const balance = await client.request({
        method: 'eth_getBalance',
        params: [address, blockNumberHex || blockTag],
    });
    return BigInt(balance);
}

/**
 * Estimates the gas necessary to complete a transaction without submitting it to the network.
 *
 * - Docs: https://viem.sh/docs/actions/public/estimateGas
 * - JSON-RPC Methods: [`eth_estimateGas`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_estimategas)
 *
 * @param client - Client to use
 * @param parameters - {@link EstimateGasParameters}
 * @returns The gas estimate (in wei). {@link EstimateGasReturnType}
 *
 * @example
 * import { createPublicClient, http, parseEther } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { estimateGas } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const gasEstimate = await estimateGas(client, {
 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
 *   to: '0x70997970c51812dc3a010c7d01b50e0d17dc79c8',
 *   value: parseEther('1'),
 * })
 */
async function estimateGas$1(client, args) {
    const { account: account_ = client.account } = args;
    const account = account_ ? parseAccount(account_) : undefined;
    try {
        const { accessList, authorizationList, blobs, blobVersionedHashes, blockNumber, blockTag, data, gas, gasPrice, maxFeePerBlobGas, maxFeePerGas, maxPriorityFeePerGas, nonce, value, stateOverride, ...rest } = (await prepareTransactionRequest(client, {
            ...args,
            parameters: 
            // Some RPC Providers do not compute versioned hashes from blobs. We will need
            // to compute them.
            account?.type === 'local' ? undefined : ['blobVersionedHashes'],
        }));
        const blockNumberHex = blockNumber ? numberToHex(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const rpcStateOverride = serializeStateOverride(stateOverride);
        const to = await (async () => {
            // If `to` exists on the parameters, use that.
            if (rest.to)
                return rest.to;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (authorizationList && authorizationList.length > 0)
                return await recoverAuthorizationAddress({
                    authorization: authorizationList[0],
                }).catch(() => {
                    throw new BaseError$1('`to` is required. Could not infer from `authorizationList`');
                });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        assertRequest(args);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || formatTransactionRequest;
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...extract(rest, { format: chainFormat }),
            from: account?.address,
            accessList,
            authorizationList,
            blobs,
            blobVersionedHashes,
            data,
            gas,
            gasPrice,
            maxFeePerBlobGas,
            maxFeePerGas,
            maxPriorityFeePerGas,
            nonce,
            to,
            value,
        });
        function estimateGas_rpc(parameters) {
            const { block, request, rpcStateOverride } = parameters;
            return client.request({
                method: 'eth_estimateGas',
                params: rpcStateOverride
                    ? [request, block ?? 'latest', rpcStateOverride]
                    : block
                        ? [request, block]
                        : [request],
            });
        }
        let estimate = BigInt(await estimateGas_rpc({ block, request, rpcStateOverride }));
        // TODO(7702): Remove this once https://github.com/ethereum/execution-apis/issues/561 is resolved.
        //       Authorization list schema is not implemented on JSON-RPC spec yet, so we need to
        //       manually estimate the gas.
        if (authorizationList) {
            const value = await getBalance(client, { address: request.from });
            const estimates = await Promise.all(authorizationList.map(async (authorization) => {
                const { contractAddress } = authorization;
                const estimate = await estimateGas_rpc({
                    block,
                    request: {
                        authorizationList: undefined,
                        data,
                        from: account?.address,
                        to: contractAddress,
                        value: numberToHex(value),
                    },
                    rpcStateOverride,
                }).catch(() => 100000n);
                return 2n * BigInt(estimate);
            }));
            estimate += estimates.reduce((acc, curr) => acc + curr, 0n);
        }
        return estimate;
    }
    catch (err) {
        throw getEstimateGasError(err, {
            ...args,
            account,
            chain: client.chain,
        });
    }
}

/**
 * Estimates the gas required to successfully execute a contract write function call.
 *
 * - Docs: https://viem.sh/docs/contract/estimateContractGas
 *
 * Internally, uses a [Public Client](https://viem.sh/docs/clients/public) to call the [`estimateGas` action](https://viem.sh/docs/actions/public/estimateGas) with [ABI-encoded `data`](https://viem.sh/docs/contract/encodeFunctionData).
 *
 * @param client - Client to use
 * @param parameters - {@link EstimateContractGasParameters}
 * @returns The gas estimate (in wei). {@link EstimateContractGasReturnType}
 *
 * @example
 * import { createPublicClient, http, parseAbi } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { estimateContractGas } from 'viem/contract'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const gas = await estimateContractGas(client, {
 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
 *   abi: parseAbi(['function mint() public']),
 *   functionName: 'mint',
 *   account: '0xf39fd6e51aad88f6f4ce6ab8827279cfffb92266',
 * })
 */
async function estimateContractGas(client, parameters) {
    const { abi, address, args, functionName, dataSuffix, ...request } = parameters;
    const data = encodeFunctionData({
        abi,
        args,
        functionName,
    });
    try {
        const gas = await getAction(client, estimateGas$1, 'estimateGas')({
            data: `${data}${dataSuffix ? dataSuffix.replace('0x', '') : ''}`,
            to: address,
            ...request,
        });
        return gas;
    }
    catch (error) {
        const account = request.account ? parseAccount(request.account) : undefined;
        throw getContractError(error, {
            abi,
            address,
            args,
            docsPath: '/docs/contract/estimateContractGas',
            functionName,
            sender: account?.address,
        });
    }
}

function isAddressEqual(a, b) {
    if (!isAddress(a, { strict: false }))
        throw new InvalidAddressError({ address: a });
    if (!isAddress(b, { strict: false }))
        throw new InvalidAddressError({ address: b });
    return a.toLowerCase() === b.toLowerCase();
}

const docsPath$2 = '/docs/contract/decodeEventLog';
function decodeEventLog(parameters) {
    const { abi, data, strict: strict_, topics, } = parameters;
    const strict = strict_ ?? true;
    const [signature, ...argTopics] = topics;
    if (!signature)
        throw new AbiEventSignatureEmptyTopicsError({ docsPath: docsPath$2 });
    const abiItem = (() => {
        if (abi.length === 1)
            return abi[0];
        return abi.find((x) => x.type === 'event' &&
            signature === toEventSelector(formatAbiItem(x)));
    })();
    if (!(abiItem && 'name' in abiItem) || abiItem.type !== 'event')
        throw new AbiEventSignatureNotFoundError(signature, { docsPath: docsPath$2 });
    const { name, inputs } = abiItem;
    const isUnnamed = inputs?.some((x) => !('name' in x && x.name));
    let args = isUnnamed ? [] : {};
    // Decode topics (indexed args).
    const indexedInputs = inputs.filter((x) => 'indexed' in x && x.indexed);
    for (let i = 0; i < indexedInputs.length; i++) {
        const param = indexedInputs[i];
        const topic = argTopics[i];
        if (!topic)
            throw new DecodeLogTopicsMismatch({
                abiItem,
                param: param,
            });
        args[isUnnamed ? i : param.name || i] = decodeTopic({ param, value: topic });
    }
    // Decode data (non-indexed args).
    const nonIndexedInputs = inputs.filter((x) => !('indexed' in x && x.indexed));
    if (nonIndexedInputs.length > 0) {
        if (data && data !== '0x') {
            try {
                const decodedData = decodeAbiParameters(nonIndexedInputs, data);
                if (decodedData) {
                    if (isUnnamed)
                        args = [...args, ...decodedData];
                    else {
                        for (let i = 0; i < nonIndexedInputs.length; i++) {
                            args[nonIndexedInputs[i].name] = decodedData[i];
                        }
                    }
                }
            }
            catch (err) {
                if (strict) {
                    if (err instanceof AbiDecodingDataSizeTooSmallError ||
                        err instanceof PositionOutOfBoundsError)
                        throw new DecodeLogDataMismatch({
                            abiItem,
                            data: data,
                            params: nonIndexedInputs,
                            size: size$1(data),
                        });
                    throw err;
                }
            }
        }
        else if (strict) {
            throw new DecodeLogDataMismatch({
                abiItem,
                data: '0x',
                params: nonIndexedInputs,
                size: 0,
            });
        }
    }
    return {
        eventName: name,
        args: Object.values(args).length > 0 ? args : undefined,
    };
}
function decodeTopic({ param, value }) {
    if (param.type === 'string' ||
        param.type === 'bytes' ||
        param.type === 'tuple' ||
        param.type.match(/^(.*)\[(\d+)?\]$/))
        return value;
    const decodedArg = decodeAbiParameters([param], value) || [];
    return decodedArg[0];
}

// TODO(v3): checksum address.
/**
 * Extracts & decodes logs matching the provided signature(s) (`abi` + optional `eventName`)
 * from a set of opaque logs.
 *
 * @param parameters - {@link ParseEventLogsParameters}
 * @returns The logs. {@link ParseEventLogsReturnType}
 *
 * @example
 * import { createClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { parseEventLogs } from 'viem/op-stack'
 *
 * const client = createClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 *
 * const receipt = await getTransactionReceipt(client, {
 *   hash: '0xec23b2ba4bc59ba61554507c1b1bc91649e6586eb2dd00c728e8ed0db8bb37ea',
 * })
 *
 * const logs = parseEventLogs({ logs: receipt.logs })
 * // [{ args: { ... }, eventName: 'TransactionDeposited', ... }, ...]
 */
function parseEventLogs(parameters) {
    const { abi, args, logs, strict = true } = parameters;
    const eventName = (() => {
        if (!parameters.eventName)
            return undefined;
        if (Array.isArray(parameters.eventName))
            return parameters.eventName;
        return [parameters.eventName];
    })();
    return logs
        .map((log) => {
        try {
            const abiItem = abi.find((abiItem) => abiItem.type === 'event' &&
                log.topics[0] === toEventSelector(abiItem));
            if (!abiItem)
                return null;
            const event = decodeEventLog({
                ...log,
                abi: [abiItem],
                strict,
            });
            // Check that the decoded event name matches the provided event name.
            if (eventName && !eventName.includes(event.eventName))
                return null;
            // Check that the decoded event args match the provided args.
            if (!includesArgs({
                args: event.args,
                inputs: abiItem.inputs,
                matchArgs: args,
            }))
                return null;
            return { ...event, ...log };
        }
        catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof AbiEventSignatureNotFoundError)
                return null;
            if (err instanceof DecodeLogDataMismatch ||
                err instanceof DecodeLogTopicsMismatch) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if (strict)
                    return null;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x) => !('name' in x && x.name));
            }
            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return { ...log, args: isUnnamed ? [] : {}, eventName };
        }
    })
        .filter(Boolean);
}
function includesArgs(parameters) {
    const { args, inputs, matchArgs } = parameters;
    if (!matchArgs)
        return true;
    if (!args)
        return false;
    function isEqual(input, value, arg) {
        try {
            if (input.type === 'address')
                return isAddressEqual(value, arg);
            if (input.type === 'string' || input.type === 'bytes')
                return keccak256(toBytes$1(value)) === arg;
            return value === arg;
        }
        catch {
            return false;
        }
    }
    if (Array.isArray(args) && Array.isArray(matchArgs)) {
        return matchArgs.every((value, index) => {
            if (value === null || value === undefined)
                return true;
            const input = inputs[index];
            if (!input)
                return false;
            const value_ = Array.isArray(value) ? value : [value];
            return value_.some((value) => isEqual(input, value, args[index]));
        });
    }
    if (typeof args === 'object' &&
        !Array.isArray(args) &&
        typeof matchArgs === 'object' &&
        !Array.isArray(matchArgs))
        return Object.entries(matchArgs).every(([key, value]) => {
            if (value === null || value === undefined)
                return true;
            const input = inputs.find((input) => input.name === key);
            if (!input)
                return false;
            const value_ = Array.isArray(value) ? value : [value];
            return value_.some((value) => isEqual(input, value, args[key]));
        });
    return false;
}

function formatLog(log, { args, eventName, } = {}) {
    return {
        ...log,
        blockHash: log.blockHash ? log.blockHash : null,
        blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
        logIndex: log.logIndex ? Number(log.logIndex) : null,
        transactionHash: log.transactionHash ? log.transactionHash : null,
        transactionIndex: log.transactionIndex
            ? Number(log.transactionIndex)
            : null,
        ...(eventName ? { args, eventName } : {}),
    };
}

/**
 * Returns a list of event logs matching the provided parameters.
 *
 * - Docs: https://viem.sh/docs/actions/public/getLogs
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/logs_event-logs
 * - JSON-RPC Methods: [`eth_getLogs`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getlogs)
 *
 * @param client - Client to use
 * @param parameters - {@link GetLogsParameters}
 * @returns A list of event logs. {@link GetLogsReturnType}
 *
 * @example
 * import { createPublicClient, http, parseAbiItem } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getLogs } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const logs = await getLogs(client)
 */
async function getLogs(client, { address, blockHash, fromBlock, toBlock, event, events: events_, args, strict: strict_, } = {}) {
    const strict = strict_ ?? false;
    const events = events_ ?? (event ? [event] : undefined);
    let topics = [];
    if (events) {
        const encoded = events.flatMap((event) => encodeEventTopics({
            abi: [event],
            eventName: event.name,
            args: events_ ? undefined : args,
        }));
        // TODO: Clean up type casting
        topics = [encoded];
        if (event)
            topics = topics[0];
    }
    let logs;
    if (blockHash) {
        logs = await client.request({
            method: 'eth_getLogs',
            params: [{ address, topics, blockHash }],
        });
    }
    else {
        logs = await client.request({
            method: 'eth_getLogs',
            params: [
                {
                    address,
                    topics,
                    fromBlock: typeof fromBlock === 'bigint' ? numberToHex(fromBlock) : fromBlock,
                    toBlock: typeof toBlock === 'bigint' ? numberToHex(toBlock) : toBlock,
                },
            ],
        });
    }
    const formattedLogs = logs.map((log) => formatLog(log));
    if (!events)
        return formattedLogs;
    return parseEventLogs({
        abi: events,
        args: args,
        logs: formattedLogs,
        strict,
    });
}

/**
 * Returns a list of event logs emitted by a contract.
 *
 * - Docs: https://viem.sh/docs/contract/getContractEvents#getcontractevents
 * - JSON-RPC Methods: [`eth_getLogs`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getlogs)
 *
 * @param client - Client to use
 * @param parameters - {@link GetContractEventsParameters}
 * @returns A list of event logs. {@link GetContractEventsReturnType}
 *
 * @example
 * import { createClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getContractEvents } from 'viem/public'
 * import { wagmiAbi } from './abi'
 *
 * const client = createClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const logs = await getContractEvents(client, {
 *  address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
 *  abi: wagmiAbi,
 *  eventName: 'Transfer'
 * })
 */
async function getContractEvents(client, parameters) {
    const { abi, address, args, blockHash, eventName, fromBlock, toBlock, strict, } = parameters;
    const event = eventName
        ? getAbiItem({ abi, name: eventName })
        : undefined;
    const events = !event
        ? abi.filter((x) => x.type === 'event')
        : undefined;
    return getAction(client, getLogs, 'getLogs')({
        address,
        args,
        blockHash,
        event,
        events,
        fromBlock,
        toBlock,
        strict,
    });
}

const docsPath$1 = '/docs/contract/decodeFunctionResult';
function decodeFunctionResult(parameters) {
    const { abi, args, functionName, data } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = getAbiItem({ abi, args, name: functionName });
        if (!item)
            throw new AbiFunctionNotFoundError(functionName, { docsPath: docsPath$1 });
        abiItem = item;
    }
    if (abiItem.type !== 'function')
        throw new AbiFunctionNotFoundError(undefined, { docsPath: docsPath$1 });
    if (!abiItem.outputs)
        throw new AbiFunctionOutputsNotFoundError(abiItem.name, { docsPath: docsPath$1 });
    const values = decodeAbiParameters(abiItem.outputs, data);
    if (values && values.length > 1)
        return values;
    if (values && values.length === 1)
        return values[0];
    return undefined;
}

/* [Multicall3](https://github.com/mds1/multicall) */
const multicall3Abi = [
    {
        inputs: [
            {
                components: [
                    {
                        name: 'target',
                        type: 'address',
                    },
                    {
                        name: 'allowFailure',
                        type: 'bool',
                    },
                    {
                        name: 'callData',
                        type: 'bytes',
                    },
                ],
                name: 'calls',
                type: 'tuple[]',
            },
        ],
        name: 'aggregate3',
        outputs: [
            {
                components: [
                    {
                        name: 'success',
                        type: 'bool',
                    },
                    {
                        name: 'returnData',
                        type: 'bytes',
                    },
                ],
                name: 'returnData',
                type: 'tuple[]',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
const universalResolverErrors = [
    {
        inputs: [],
        name: 'ResolverNotFound',
        type: 'error',
    },
    {
        inputs: [],
        name: 'ResolverWildcardNotSupported',
        type: 'error',
    },
    {
        inputs: [],
        name: 'ResolverNotContract',
        type: 'error',
    },
    {
        inputs: [
            {
                name: 'returnData',
                type: 'bytes',
            },
        ],
        name: 'ResolverError',
        type: 'error',
    },
    {
        inputs: [
            {
                components: [
                    {
                        name: 'status',
                        type: 'uint16',
                    },
                    {
                        name: 'message',
                        type: 'string',
                    },
                ],
                name: 'errors',
                type: 'tuple[]',
            },
        ],
        name: 'HttpError',
        type: 'error',
    },
];
const universalResolverResolveAbi = [
    ...universalResolverErrors,
    {
        name: 'resolve',
        type: 'function',
        stateMutability: 'view',
        inputs: [
            { name: 'name', type: 'bytes' },
            { name: 'data', type: 'bytes' },
        ],
        outputs: [
            { name: '', type: 'bytes' },
            { name: 'address', type: 'address' },
        ],
    },
    {
        name: 'resolve',
        type: 'function',
        stateMutability: 'view',
        inputs: [
            { name: 'name', type: 'bytes' },
            { name: 'data', type: 'bytes' },
            { name: 'gateways', type: 'string[]' },
        ],
        outputs: [
            { name: '', type: 'bytes' },
            { name: 'address', type: 'address' },
        ],
    },
];
const universalResolverReverseAbi = [
    ...universalResolverErrors,
    {
        name: 'reverse',
        type: 'function',
        stateMutability: 'view',
        inputs: [{ type: 'bytes', name: 'reverseName' }],
        outputs: [
            { type: 'string', name: 'resolvedName' },
            { type: 'address', name: 'resolvedAddress' },
            { type: 'address', name: 'reverseResolver' },
            { type: 'address', name: 'resolver' },
        ],
    },
    {
        name: 'reverse',
        type: 'function',
        stateMutability: 'view',
        inputs: [
            { type: 'bytes', name: 'reverseName' },
            { type: 'string[]', name: 'gateways' },
        ],
        outputs: [
            { type: 'string', name: 'resolvedName' },
            { type: 'address', name: 'resolvedAddress' },
            { type: 'address', name: 'reverseResolver' },
            { type: 'address', name: 'resolver' },
        ],
    },
];
const textResolverAbi = [
    {
        name: 'text',
        type: 'function',
        stateMutability: 'view',
        inputs: [
            { name: 'name', type: 'bytes32' },
            { name: 'key', type: 'string' },
        ],
        outputs: [{ name: '', type: 'string' }],
    },
];
const addressResolverAbi = [
    {
        name: 'addr',
        type: 'function',
        stateMutability: 'view',
        inputs: [{ name: 'name', type: 'bytes32' }],
        outputs: [{ name: '', type: 'address' }],
    },
    {
        name: 'addr',
        type: 'function',
        stateMutability: 'view',
        inputs: [
            { name: 'name', type: 'bytes32' },
            { name: 'coinType', type: 'uint256' },
        ],
        outputs: [{ name: '', type: 'bytes' }],
    },
];
// ERC-6492 - universal deployless signature validator contract
// constructor(address _signer, bytes32 _hash, bytes _signature) → bytes4 returnValue
// returnValue is either 0x1 (valid) or 0x0 (invalid)
const universalSignatureValidatorAbi = [
    {
        inputs: [
            {
                name: '_signer',
                type: 'address',
            },
            {
                name: '_hash',
                type: 'bytes32',
            },
            {
                name: '_signature',
                type: 'bytes',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [
            {
                name: '_signer',
                type: 'address',
            },
            {
                name: '_hash',
                type: 'bytes32',
            },
            {
                name: '_signature',
                type: 'bytes',
            },
        ],
        outputs: [
            {
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
        name: 'isValidSig',
    },
];

const aggregate3Signature = '0x82ad56cb';

const deploylessCallViaBytecodeBytecode = '0x608060405234801561001057600080fd5b5060405161018e38038061018e83398101604081905261002f91610124565b6000808351602085016000f59050803b61004857600080fd5b6000808351602085016000855af16040513d6000823e81610067573d81fd5b3d81f35b634e487b7160e01b600052604160045260246000fd5b600082601f83011261009257600080fd5b81516001600160401b038111156100ab576100ab61006b565b604051601f8201601f19908116603f011681016001600160401b03811182821017156100d9576100d961006b565b6040528181528382016020018510156100f157600080fd5b60005b82811015610110576020818601810151838301820152016100f4565b506000918101602001919091529392505050565b6000806040838503121561013757600080fd5b82516001600160401b0381111561014d57600080fd5b61015985828601610081565b602085015190935090506001600160401b0381111561017757600080fd5b61018385828601610081565b915050925092905056fe';
const deploylessCallViaFactoryBytecode = '0x608060405234801561001057600080fd5b506040516102c03803806102c083398101604081905261002f916101e6565b836001600160a01b03163b6000036100e457600080836001600160a01b03168360405161005c9190610270565b6000604051808303816000865af19150503d8060008114610099576040519150601f19603f3d011682016040523d82523d6000602084013e61009e565b606091505b50915091508115806100b857506001600160a01b0386163b155b156100e1578060405163101bb98d60e01b81526004016100d8919061028c565b60405180910390fd5b50505b6000808451602086016000885af16040513d6000823e81610103573d81fd5b3d81f35b80516001600160a01b038116811461011e57600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b8381101561015457818101518382015260200161013c565b50506000910152565b600082601f83011261016e57600080fd5b81516001600160401b0381111561018757610187610123565b604051601f8201601f19908116603f011681016001600160401b03811182821017156101b5576101b5610123565b6040528181528382016020018510156101cd57600080fd5b6101de826020830160208701610139565b949350505050565b600080600080608085870312156101fc57600080fd5b61020585610107565b60208601519094506001600160401b0381111561022157600080fd5b61022d8782880161015d565b93505061023c60408601610107565b60608601519092506001600160401b0381111561025857600080fd5b6102648782880161015d565b91505092959194509250565b60008251610282818460208701610139565b9190910192915050565b60208152600082518060208401526102ab816040850160208701610139565b601f01601f1916919091016040019291505056fe';
const universalSignatureValidatorByteCode = '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';

class ChainDoesNotSupportContract extends BaseError$1 {
    constructor({ blockNumber, chain, contract, }) {
        super(`Chain "${chain.name}" does not support contract "${contract.name}".`, {
            metaMessages: [
                'This could be due to any of the following:',
                ...(blockNumber &&
                    contract.blockCreated &&
                    contract.blockCreated > blockNumber
                    ? [
                        `- The contract "${contract.name}" was not deployed until block ${contract.blockCreated} (current block ${blockNumber}).`,
                    ]
                    : [
                        `- The chain does not have the contract "${contract.name}" configured.`,
                    ]),
            ],
            name: 'ChainDoesNotSupportContract',
        });
    }
}
class ChainMismatchError extends BaseError$1 {
    constructor({ chain, currentChainId, }) {
        super(`The current chain of the wallet (id: ${currentChainId}) does not match the target chain for the transaction (id: ${chain.id} – ${chain.name}).`, {
            metaMessages: [
                `Current Chain ID:  ${currentChainId}`,
                `Expected Chain ID: ${chain.id} – ${chain.name}`,
            ],
            name: 'ChainMismatchError',
        });
    }
}
class ChainNotFoundError extends BaseError$1 {
    constructor() {
        super([
            'No chain was provided to the request.',
            'Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient.',
        ].join('\n'), {
            name: 'ChainNotFoundError',
        });
    }
}
class ClientChainNotConfiguredError extends BaseError$1 {
    constructor() {
        super('No chain was provided to the Client.', {
            name: 'ClientChainNotConfiguredError',
        });
    }
}
class InvalidChainIdError extends BaseError$1 {
    constructor({ chainId }) {
        super(typeof chainId === 'number'
            ? `Chain ID "${chainId}" is invalid.`
            : 'Chain ID is invalid.', { name: 'InvalidChainIdError' });
    }
}

const docsPath = '/docs/contract/encodeDeployData';
function encodeDeployData(parameters) {
    const { abi, args, bytecode } = parameters;
    if (!args || args.length === 0)
        return bytecode;
    const description = abi.find((x) => 'type' in x && x.type === 'constructor');
    if (!description)
        throw new AbiConstructorNotFoundError({ docsPath });
    if (!('inputs' in description))
        throw new AbiConstructorParamsNotFoundError({ docsPath });
    if (!description.inputs || description.inputs.length === 0)
        throw new AbiConstructorParamsNotFoundError({ docsPath });
    const data = encodeAbiParameters(description.inputs, args);
    return concatHex([bytecode, data]);
}

function getChainContractAddress({ blockNumber, chain, contract: name, }) {
    const contract = chain?.contracts?.[name];
    if (!contract)
        throw new ChainDoesNotSupportContract({
            chain,
            contract: { name },
        });
    if (blockNumber &&
        contract.blockCreated &&
        contract.blockCreated > blockNumber)
        throw new ChainDoesNotSupportContract({
            blockNumber,
            chain,
            contract: {
                name,
                blockCreated: contract.blockCreated,
            },
        });
    return contract.address;
}

function getCallError(err, { docsPath, ...args }) {
    const cause = (() => {
        const cause = getNodeError(err, args);
        if (cause instanceof UnknownNodeError)
            return err;
        return cause;
    })();
    return new CallExecutionError(cause, {
        docsPath,
        ...args,
    });
}

/** @internal */
function withResolvers() {
    let resolve = () => undefined;
    let reject = () => undefined;
    const promise = new Promise((resolve_, reject_) => {
        resolve = resolve_;
        reject = reject_;
    });
    return { promise, resolve, reject };
}

const schedulerCache = /*#__PURE__*/ new Map();
/** @internal */
function createBatchScheduler({ fn, id, shouldSplitBatch, wait = 0, sort, }) {
    const exec = async () => {
        const scheduler = getScheduler();
        flush();
        const args = scheduler.map(({ args }) => args);
        if (args.length === 0)
            return;
        fn(args)
            .then((data) => {
            if (sort && Array.isArray(data))
                data.sort(sort);
            for (let i = 0; i < scheduler.length; i++) {
                const { resolve } = scheduler[i];
                resolve?.([data[i], data]);
            }
        })
            .catch((err) => {
            for (let i = 0; i < scheduler.length; i++) {
                const { reject } = scheduler[i];
                reject?.(err);
            }
        });
    };
    const flush = () => schedulerCache.delete(id);
    const getBatchedArgs = () => getScheduler().map(({ args }) => args);
    const getScheduler = () => schedulerCache.get(id) || [];
    const setScheduler = (item) => schedulerCache.set(id, [...getScheduler(), item]);
    return {
        flush,
        async schedule(args) {
            const { promise, resolve, reject } = withResolvers();
            const split = shouldSplitBatch?.([...getBatchedArgs(), args]);
            if (split)
                exec();
            const hasActiveScheduler = getScheduler().length > 0;
            if (hasActiveScheduler) {
                setScheduler({ args, resolve, reject });
                return promise;
            }
            setScheduler({ args, resolve, reject });
            setTimeout(exec, wait);
            return promise;
        },
    };
}

/**
 * Executes a new message call immediately without submitting a transaction to the network.
 *
 * - Docs: https://viem.sh/docs/actions/public/call
 * - JSON-RPC Methods: [`eth_call`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_call)
 *
 * @param client - Client to use
 * @param parameters - {@link CallParameters}
 * @returns The call data. {@link CallReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { call } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const data = await call(client, {
 *   account: '0xf39fd6e51aad88f6f4ce6ab8827279cfffb92266',
 *   data: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
 *   to: '0x70997970c51812dc3a010c7d01b50e0d17dc79c8',
 * })
 */
async function call(client, args) {
    const { account: account_ = client.account, batch = Boolean(client.batch?.multicall), blockNumber, blockTag = 'latest', accessList, blobs, code, data: data_, factory, factoryData, gas, gasPrice, maxFeePerBlobGas, maxFeePerGas, maxPriorityFeePerGas, nonce, to, value, stateOverride, ...rest } = args;
    const account = account_ ? parseAccount(account_) : undefined;
    if (code && (factory || factoryData))
        throw new BaseError$1('Cannot provide both `code` & `factory`/`factoryData` as parameters.');
    if (code && to)
        throw new BaseError$1('Cannot provide both `code` & `to` as parameters.');
    // Check if the call is deployless via bytecode.
    const deploylessCallViaBytecode = code && data_;
    // Check if the call is deployless via a factory.
    const deploylessCallViaFactory = factory && factoryData && to && data_;
    const deploylessCall = deploylessCallViaBytecode || deploylessCallViaFactory;
    const data = (() => {
        if (deploylessCallViaBytecode)
            return toDeploylessCallViaBytecodeData({
                code,
                data: data_,
            });
        if (deploylessCallViaFactory)
            return toDeploylessCallViaFactoryData({
                data: data_,
                factory,
                factoryData,
                to,
            });
        return data_;
    })();
    try {
        assertRequest(args);
        const blockNumberHex = blockNumber ? numberToHex(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const rpcStateOverride = serializeStateOverride(stateOverride);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || formatTransactionRequest;
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...extract(rest, { format: chainFormat }),
            from: account?.address,
            accessList,
            blobs,
            data,
            gas,
            gasPrice,
            maxFeePerBlobGas,
            maxFeePerGas,
            maxPriorityFeePerGas,
            nonce,
            to: deploylessCall ? undefined : to,
            value,
        });
        if (batch && shouldPerformMulticall({ request }) && !rpcStateOverride) {
            try {
                return await scheduleMulticall(client, {
                    ...request,
                    blockNumber,
                    blockTag,
                });
            }
            catch (err) {
                if (!(err instanceof ClientChainNotConfiguredError) &&
                    !(err instanceof ChainDoesNotSupportContract))
                    throw err;
            }
        }
        const response = await client.request({
            method: 'eth_call',
            params: rpcStateOverride
                ? [
                    request,
                    block,
                    rpcStateOverride,
                ]
                : [request, block],
        });
        if (response === '0x')
            return { data: undefined };
        return { data: response };
    }
    catch (err) {
        const data = getRevertErrorData(err);
        // Check for CCIP-Read offchain lookup signature.
        const { offchainLookup, offchainLookupSignature } = await import('./ccip-DucFnYug.js');
        if (client.ccipRead !== false &&
            data?.slice(0, 10) === offchainLookupSignature &&
            to)
            return { data: await offchainLookup(client, { data, to }) };
        // Check for counterfactual deployment error.
        if (deploylessCall && data?.slice(0, 10) === '0x101bb98d')
            throw new CounterfactualDeploymentFailedError({ factory });
        throw getCallError(err, {
            ...args,
            account,
            chain: client.chain,
        });
    }
}
// We only want to perform a scheduled multicall if:
// - The request has calldata,
// - The request has a target address,
// - The target address is not already the aggregate3 signature,
// - The request has no other properties (`nonce`, `gas`, etc cannot be sent with a multicall).
function shouldPerformMulticall({ request }) {
    const { data, to, ...request_ } = request;
    if (!data)
        return false;
    if (data.startsWith(aggregate3Signature))
        return false;
    if (!to)
        return false;
    if (Object.values(request_).filter((x) => typeof x !== 'undefined').length > 0)
        return false;
    return true;
}
async function scheduleMulticall(client, args) {
    const { batchSize = 1024, wait = 0 } = typeof client.batch?.multicall === 'object' ? client.batch.multicall : {};
    const { blockNumber, blockTag = 'latest', data, multicallAddress: multicallAddress_, to, } = args;
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain)
            throw new ClientChainNotConfiguredError();
        multicallAddress = getChainContractAddress({
            blockNumber,
            chain: client.chain,
            contract: 'multicall3',
        });
    }
    const blockNumberHex = blockNumber ? numberToHex(blockNumber) : undefined;
    const block = blockNumberHex || blockTag;
    const { schedule } = createBatchScheduler({
        id: `${client.uid}.${block}`,
        wait,
        shouldSplitBatch(args) {
            const size = args.reduce((size, { data }) => size + (data.length - 2), 0);
            return size > batchSize * 2;
        },
        fn: async (requests) => {
            const calls = requests.map((request) => ({
                allowFailure: true,
                callData: request.data,
                target: request.to,
            }));
            const calldata = encodeFunctionData({
                abi: multicall3Abi,
                args: [calls],
                functionName: 'aggregate3',
            });
            const data = await client.request({
                method: 'eth_call',
                params: [
                    {
                        data: calldata,
                        to: multicallAddress,
                    },
                    block,
                ],
            });
            return decodeFunctionResult({
                abi: multicall3Abi,
                args: [calls],
                functionName: 'aggregate3',
                data: data || '0x',
            });
        },
    });
    const [{ returnData, success }] = await schedule({ data, to });
    if (!success)
        throw new RawContractError({ data: returnData });
    if (returnData === '0x')
        return { data: undefined };
    return { data: returnData };
}
function toDeploylessCallViaBytecodeData(parameters) {
    const { code, data } = parameters;
    return encodeDeployData({
        abi: parseAbi(['constructor(bytes, bytes)']),
        bytecode: deploylessCallViaBytecodeBytecode,
        args: [code, data],
    });
}
function toDeploylessCallViaFactoryData(parameters) {
    const { data, factory, factoryData, to } = parameters;
    return encodeDeployData({
        abi: parseAbi(['constructor(address, bytes, address, bytes)']),
        bytecode: deploylessCallViaFactoryBytecode,
        args: [to, data, factory, factoryData],
    });
}
/** @internal */
function getRevertErrorData(err) {
    if (!(err instanceof BaseError$1))
        return undefined;
    const error = err.walk();
    return typeof error?.data === 'object' ? error.data?.data : error.data;
}

/**
 * Calls a read-only function on a contract, and returns the response.
 *
 * - Docs: https://viem.sh/docs/contract/readContract
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/contracts_reading-contracts
 *
 * A "read-only" function (constant function) on a Solidity contract is denoted by a `view` or `pure` keyword. They can only read the state of the contract, and cannot make any changes to it. Since read-only methods do not change the state of the contract, they do not require any gas to be executed, and can be called by any user without the need to pay for gas.
 *
 * Internally, uses a [Public Client](https://viem.sh/docs/clients/public) to call the [`call` action](https://viem.sh/docs/actions/public/call) with [ABI-encoded `data`](https://viem.sh/docs/contract/encodeFunctionData).
 *
 * @param client - Client to use
 * @param parameters - {@link ReadContractParameters}
 * @returns The response from the contract. Type is inferred. {@link ReadContractReturnType}
 *
 * @example
 * import { createPublicClient, http, parseAbi } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { readContract } from 'viem/contract'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const result = await readContract(client, {
 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
 *   abi: parseAbi(['function balanceOf(address) view returns (uint256)']),
 *   functionName: 'balanceOf',
 *   args: ['0xA0Cf798816D4b9b9866b5330EEa46a18382f251e'],
 * })
 * // 424122n
 */
async function readContract(client, parameters) {
    const { abi, address, args, functionName, ...rest } = parameters;
    const calldata = encodeFunctionData({
        abi,
        args,
        functionName,
    });
    try {
        const { data } = await getAction(client, call, 'call')({
            ...rest,
            data: calldata,
            to: address,
        });
        return decodeFunctionResult({
            abi,
            args,
            functionName,
            data: data || '0x',
        });
    }
    catch (error) {
        throw getContractError(error, {
            abi,
            address,
            args,
            docsPath: '/docs/contract/readContract',
            functionName,
        });
    }
}

/**
 * Simulates/validates a contract interaction. This is useful for retrieving **return data** and **revert reasons** of contract write functions.
 *
 * - Docs: https://viem.sh/docs/contract/simulateContract
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/contracts_writing-to-contracts
 *
 * This function does not require gas to execute and _**does not**_ change the state of the blockchain. It is almost identical to [`readContract`](https://viem.sh/docs/contract/readContract), but also supports contract write functions.
 *
 * Internally, uses a [Public Client](https://viem.sh/docs/clients/public) to call the [`call` action](https://viem.sh/docs/actions/public/call) with [ABI-encoded `data`](https://viem.sh/docs/contract/encodeFunctionData).
 *
 * @param client - Client to use
 * @param parameters - {@link SimulateContractParameters}
 * @returns The simulation result and write request. {@link SimulateContractReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { simulateContract } from 'viem/contract'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const result = await simulateContract(client, {
 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
 *   abi: parseAbi(['function mint(uint32) view returns (uint32)']),
 *   functionName: 'mint',
 *   args: ['69420'],
 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
 * })
 */
async function simulateContract(client, parameters) {
    const { abi, address, args, dataSuffix, functionName, ...callRequest } = parameters;
    const account = callRequest.account
        ? parseAccount(callRequest.account)
        : client.account;
    const calldata = encodeFunctionData({ abi, args, functionName });
    try {
        const { data } = await getAction(client, call, 'call')({
            batch: false,
            data: `${calldata}${dataSuffix ? dataSuffix.replace('0x', '') : ''}`,
            to: address,
            ...callRequest,
            account,
        });
        const result = decodeFunctionResult({
            abi,
            args,
            functionName,
            data: data || '0x',
        });
        const minimizedAbi = abi.filter((abiItem) => 'name' in abiItem && abiItem.name === parameters.functionName);
        return {
            result,
            request: {
                abi: minimizedAbi,
                address,
                args,
                dataSuffix,
                functionName,
                ...callRequest,
                account,
            },
        };
    }
    catch (error) {
        throw getContractError(error, {
            abi,
            address,
            args,
            docsPath: '/docs/contract/simulateContract',
            functionName,
            sender: account?.address,
        });
    }
}

/** @internal */
const listenersCache = /*#__PURE__*/ new Map();
/** @internal */
const cleanupCache = /*#__PURE__*/ new Map();
let callbackCount = 0;
/**
 * @description Sets up an observer for a given function. If another function
 * is set up under the same observer id, the function will only be called once
 * for both instances of the observer.
 */
function observe(observerId, callbacks, fn) {
    const callbackId = ++callbackCount;
    const getListeners = () => listenersCache.get(observerId) || [];
    const unsubscribe = () => {
        const listeners = getListeners();
        listenersCache.set(observerId, listeners.filter((cb) => cb.id !== callbackId));
    };
    const unwatch = () => {
        const listeners = getListeners();
        if (!listeners.some((cb) => cb.id === callbackId))
            return;
        const cleanup = cleanupCache.get(observerId);
        if (listeners.length === 1 && cleanup)
            cleanup();
        unsubscribe();
    };
    const listeners = getListeners();
    listenersCache.set(observerId, [
        ...listeners,
        { id: callbackId, fns: callbacks },
    ]);
    if (listeners && listeners.length > 0)
        return unwatch;
    const emit = {};
    for (const key in callbacks) {
        emit[key] = ((...args) => {
            const listeners = getListeners();
            if (listeners.length === 0)
                return;
            for (const listener of listeners)
                listener.fns[key]?.(...args);
        });
    }
    const cleanup = fn(emit);
    if (typeof cleanup === 'function')
        cleanupCache.set(observerId, cleanup);
    return unwatch;
}

async function wait(time) {
    return new Promise((res) => setTimeout(res, time));
}

/**
 * @description Polls a function at a specified interval.
 */
function poll(fn, { emitOnBegin, initialWaitTime, interval }) {
    let active = true;
    const unwatch = () => (active = false);
    const watch = async () => {
        let data = undefined;
        if (emitOnBegin)
            data = await fn({ unpoll: unwatch });
        const initialWait = (await initialWaitTime?.(data)) ?? interval;
        await wait(initialWait);
        const poll = async () => {
            if (!active)
                return;
            await fn({ unpoll: unwatch });
            await wait(interval);
            poll();
        };
        poll();
    };
    watch();
    return unwatch;
}

/** @internal */
const promiseCache$1 = /*#__PURE__*/ new Map();
/** @internal */
const responseCache = /*#__PURE__*/ new Map();
function getCache(cacheKey) {
    const buildCache = (cacheKey, cache) => ({
        clear: () => cache.delete(cacheKey),
        get: () => cache.get(cacheKey),
        set: (data) => cache.set(cacheKey, data),
    });
    const promise = buildCache(cacheKey, promiseCache$1);
    const response = buildCache(cacheKey, responseCache);
    return {
        clear: () => {
            promise.clear();
            response.clear();
        },
        promise,
        response,
    };
}
/**
 * @description Returns the result of a given promise, and caches the result for
 * subsequent invocations against a provided cache key.
 */
async function withCache(fn, { cacheKey, cacheTime = Number.POSITIVE_INFINITY }) {
    const cache = getCache(cacheKey);
    // If a response exists in the cache, and it's not expired, return it
    // and do not invoke the promise.
    // If the max age is 0, the cache is disabled.
    const response = cache.response.get();
    if (response && cacheTime > 0) {
        const age = new Date().getTime() - response.created.getTime();
        if (age < cacheTime)
            return response.data;
    }
    let promise = cache.promise.get();
    if (!promise) {
        promise = fn();
        // Store the promise in the cache so that subsequent invocations
        // will wait for the same promise to resolve (deduping).
        cache.promise.set(promise);
    }
    try {
        const data = await promise;
        // Store the response in the cache so that subsequent invocations
        // will return the same response.
        cache.response.set({ created: new Date(), data });
        return data;
    }
    finally {
        // Clear the promise cache so that subsequent invocations will
        // invoke the promise again.
        cache.promise.clear();
    }
}

const cacheKey = (id) => `blockNumber.${id}`;
/**
 * Returns the number of the most recent block seen.
 *
 * - Docs: https://viem.sh/docs/actions/public/getBlockNumber
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/blocks_fetching-blocks
 * - JSON-RPC Methods: [`eth_blockNumber`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_blocknumber)
 *
 * @param client - Client to use
 * @param parameters - {@link GetBlockNumberParameters}
 * @returns The number of the block. {@link GetBlockNumberReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getBlockNumber } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const blockNumber = await getBlockNumber(client)
 * // 69420n
 */
async function getBlockNumber(client, { cacheTime = client.cacheTime } = {}) {
    const blockNumberHex = await withCache(() => client.request({
        method: 'eth_blockNumber',
    }), { cacheKey: cacheKey(client.uid), cacheTime });
    return BigInt(blockNumberHex);
}

/**
 * Returns a list of logs or hashes based on a [Filter](/docs/glossary/terms#filter) since the last time it was called.
 *
 * - Docs: https://viem.sh/docs/actions/public/getFilterChanges
 * - JSON-RPC Methods: [`eth_getFilterChanges`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getfilterchanges)
 *
 * A Filter can be created from the following actions:
 *
 * - [`createBlockFilter`](https://viem.sh/docs/actions/public/createBlockFilter)
 * - [`createContractEventFilter`](https://viem.sh/docs/contract/createContractEventFilter)
 * - [`createEventFilter`](https://viem.sh/docs/actions/public/createEventFilter)
 * - [`createPendingTransactionFilter`](https://viem.sh/docs/actions/public/createPendingTransactionFilter)
 *
 * Depending on the type of filter, the return value will be different:
 *
 * - If the filter was created with `createContractEventFilter` or `createEventFilter`, it returns a list of logs.
 * - If the filter was created with `createPendingTransactionFilter`, it returns a list of transaction hashes.
 * - If the filter was created with `createBlockFilter`, it returns a list of block hashes.
 *
 * @param client - Client to use
 * @param parameters - {@link GetFilterChangesParameters}
 * @returns Logs or hashes. {@link GetFilterChangesReturnType}
 *
 * @example
 * // Blocks
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createBlockFilter, getFilterChanges } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const filter = await createBlockFilter(client)
 * const hashes = await getFilterChanges(client, { filter })
 *
 * @example
 * // Contract Events
 * import { createPublicClient, http, parseAbi } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createContractEventFilter, getFilterChanges } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const filter = await createContractEventFilter(client, {
 *   address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
 *   abi: parseAbi(['event Transfer(address indexed, address indexed, uint256)']),
 *   eventName: 'Transfer',
 * })
 * const logs = await getFilterChanges(client, { filter })
 *
 * @example
 * // Raw Events
 * import { createPublicClient, http, parseAbiItem } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createEventFilter, getFilterChanges } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const filter = await createEventFilter(client, {
 *   address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
 *   event: parseAbiItem('event Transfer(address indexed, address indexed, uint256)'),
 * })
 * const logs = await getFilterChanges(client, { filter })
 *
 * @example
 * // Transactions
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createPendingTransactionFilter, getFilterChanges } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const filter = await createPendingTransactionFilter(client)
 * const hashes = await getFilterChanges(client, { filter })
 */
async function getFilterChanges(_client, { filter, }) {
    const strict = 'strict' in filter && filter.strict;
    const logs = await filter.request({
        method: 'eth_getFilterChanges',
        params: [filter.id],
    });
    if (typeof logs[0] === 'string')
        return logs;
    const formattedLogs = logs.map((log) => formatLog(log));
    if (!('abi' in filter) || !filter.abi)
        return formattedLogs;
    return parseEventLogs({
        abi: filter.abi,
        logs: formattedLogs,
        strict,
    });
}

/**
 * Destroys a [`Filter`](https://viem.sh/docs/glossary/types#filter).
 *
 * - Docs: https://viem.sh/docs/actions/public/uninstallFilter
 * - JSON-RPC Methods: [`eth_uninstallFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_uninstallFilter)
 *
 * Destroys a Filter that was created from one of the following Actions:
 * - [`createBlockFilter`](https://viem.sh/docs/actions/public/createBlockFilter)
 * - [`createEventFilter`](https://viem.sh/docs/actions/public/createEventFilter)
 * - [`createPendingTransactionFilter`](https://viem.sh/docs/actions/public/createPendingTransactionFilter)
 *
 * @param client - Client to use
 * @param parameters - {@link UninstallFilterParameters}
 * @returns A boolean indicating if the Filter was successfully uninstalled. {@link UninstallFilterReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createPendingTransactionFilter, uninstallFilter } from 'viem/public'
 *
 * const filter = await createPendingTransactionFilter(client)
 * const uninstalled = await uninstallFilter(client, { filter })
 * // true
 */
async function uninstallFilter(_client, { filter }) {
    return filter.request({
        method: 'eth_uninstallFilter',
        params: [filter.id],
    });
}

/**
 * Watches and returns emitted contract event logs.
 *
 * - Docs: https://viem.sh/docs/contract/watchContractEvent
 *
 * This Action will batch up all the event logs found within the [`pollingInterval`](https://viem.sh/docs/contract/watchContractEvent#pollinginterval-optional), and invoke them via [`onLogs`](https://viem.sh/docs/contract/watchContractEvent#onLogs).
 *
 * `watchContractEvent` will attempt to create an [Event Filter](https://viem.sh/docs/contract/createContractEventFilter) and listen to changes to the Filter per polling interval, however, if the RPC Provider does not support Filters (e.g. `eth_newFilter`), then `watchContractEvent` will fall back to using [`getLogs`](https://viem.sh/docs/actions/public/getLogs) instead.
 *
 * @param client - Client to use
 * @param parameters - {@link WatchContractEventParameters}
 * @returns A function that can be invoked to stop watching for new event logs. {@link WatchContractEventReturnType}
 *
 * @example
 * import { createPublicClient, http, parseAbi } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { watchContractEvent } from 'viem/contract'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const unwatch = watchContractEvent(client, {
 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
 *   abi: parseAbi(['event Transfer(address indexed from, address indexed to, uint256 value)']),
 *   eventName: 'Transfer',
 *   args: { from: '0xc961145a54C96E3aE9bAA048c4F4D6b04C13916b' },
 *   onLogs: (logs) => console.log(logs),
 * })
 */
function watchContractEvent(client, parameters) {
    const { abi, address, args, batch = true, eventName, fromBlock, onError, onLogs, poll: poll_, pollingInterval = client.pollingInterval, strict: strict_, } = parameters;
    const enablePolling = (() => {
        if (typeof poll_ !== 'undefined')
            return poll_;
        if (typeof fromBlock === 'bigint')
            return true;
        if (client.transport.type === 'webSocket')
            return false;
        if (client.transport.type === 'fallback' &&
            client.transport.transports[0].config.type === 'webSocket')
            return false;
        return true;
    })();
    const pollContractEvent = () => {
        const strict = strict_ ?? false;
        const observerId = stringify$1([
            'watchContractEvent',
            address,
            args,
            batch,
            client.uid,
            eventName,
            pollingInterval,
            strict,
            fromBlock,
        ]);
        return observe(observerId, { onLogs, onError }, (emit) => {
            let previousBlockNumber;
            if (fromBlock !== undefined)
                previousBlockNumber = fromBlock - 1n;
            let filter;
            let initialized = false;
            const unwatch = poll(async () => {
                if (!initialized) {
                    try {
                        filter = (await getAction(client, createContractEventFilter, 'createContractEventFilter')({
                            abi,
                            address,
                            args: args,
                            eventName: eventName,
                            strict: strict,
                            fromBlock,
                        }));
                    }
                    catch { }
                    initialized = true;
                    return;
                }
                try {
                    let logs;
                    if (filter) {
                        logs = await getAction(client, getFilterChanges, 'getFilterChanges')({ filter });
                    }
                    else {
                        // If the filter doesn't exist, we will fall back to use `getLogs`.
                        // The fall back exists because some RPC Providers do not support filters.
                        // Fetch the block number to use for `getLogs`.
                        const blockNumber = await getAction(client, getBlockNumber, 'getBlockNumber')({});
                        // If the block number has changed, we will need to fetch the logs.
                        // If the block number doesn't exist, we are yet to reach the first poll interval,
                        // so do not emit any logs.
                        if (previousBlockNumber && previousBlockNumber < blockNumber) {
                            logs = await getAction(client, getContractEvents, 'getContractEvents')({
                                abi,
                                address,
                                args,
                                eventName,
                                fromBlock: previousBlockNumber + 1n,
                                toBlock: blockNumber,
                                strict,
                            });
                        }
                        else {
                            logs = [];
                        }
                        previousBlockNumber = blockNumber;
                    }
                    if (logs.length === 0)
                        return;
                    if (batch)
                        emit.onLogs(logs);
                    else
                        for (const log of logs)
                            emit.onLogs([log]);
                }
                catch (err) {
                    // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                    // Reinitialize the filter when this occurs
                    if (filter && err instanceof InvalidInputRpcError)
                        initialized = false;
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval,
            });
            return async () => {
                if (filter)
                    await getAction(client, uninstallFilter, 'uninstallFilter')({ filter });
                unwatch();
            };
        });
    };
    const subscribeContractEvent = () => {
        const strict = strict_ ?? false;
        const observerId = stringify$1([
            'watchContractEvent',
            address,
            args,
            batch,
            client.uid,
            eventName,
            pollingInterval,
            strict,
        ]);
        let active = true;
        let unsubscribe = () => (active = false);
        return observe(observerId, { onLogs, onError }, (emit) => {
            (async () => {
                try {
                    const transport = (() => {
                        if (client.transport.type === 'fallback') {
                            const transport = client.transport.transports.find((transport) => transport.config.type === 'webSocket');
                            if (!transport)
                                return client.transport;
                            return transport.value;
                        }
                        return client.transport;
                    })();
                    const topics = eventName
                        ? encodeEventTopics({
                            abi: abi,
                            eventName: eventName,
                            args,
                        })
                        : [];
                    const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                        params: ['logs', { address, topics }],
                        onData(data) {
                            if (!active)
                                return;
                            const log = data.result;
                            try {
                                const { eventName, args } = decodeEventLog({
                                    abi: abi,
                                    data: log.data,
                                    topics: log.topics,
                                    strict: strict_,
                                });
                                const formatted = formatLog(log, {
                                    args,
                                    eventName: eventName,
                                });
                                emit.onLogs([formatted]);
                            }
                            catch (err) {
                                let eventName;
                                let isUnnamed;
                                if (err instanceof DecodeLogDataMismatch ||
                                    err instanceof DecodeLogTopicsMismatch) {
                                    // If strict mode is on, and log data/topics do not match event definition, skip.
                                    if (strict_)
                                        return;
                                    eventName = err.abiItem.name;
                                    isUnnamed = err.abiItem.inputs?.some((x) => !('name' in x && x.name));
                                }
                                // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                                const formatted = formatLog(log, {
                                    args: isUnnamed ? [] : {},
                                    eventName,
                                });
                                emit.onLogs([formatted]);
                            }
                        },
                        onError(error) {
                            emit.onError?.(error);
                        },
                    });
                    unsubscribe = unsubscribe_;
                    if (!active)
                        unsubscribe();
                }
                catch (err) {
                    onError?.(err);
                }
            })();
            return () => unsubscribe();
        });
    };
    return enablePolling ? pollContractEvent() : subscribeContractEvent();
}

class AccountNotFoundError extends BaseError$1 {
    constructor({ docsPath } = {}) {
        super([
            'Could not find an Account to execute with this Action.',
            'Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the Client.',
        ].join('\n'), {
            docsPath,
            docsSlug: 'account',
            name: 'AccountNotFoundError',
        });
    }
}
class AccountTypeNotSupportedError extends BaseError$1 {
    constructor({ docsPath, metaMessages, type, }) {
        super(`Account type "${type}" is not supported.`, {
            docsPath,
            metaMessages,
            name: 'AccountTypeNotSupportedError',
        });
    }
}

function assertCurrentChain({ chain, currentChainId, }) {
    if (!chain)
        throw new ChainNotFoundError();
    if (currentChainId !== chain.id)
        throw new ChainMismatchError({ chain, currentChainId });
}

function getTransactionError(err, { docsPath, ...args }) {
    const cause = (() => {
        const cause = getNodeError(err, args);
        if (cause instanceof UnknownNodeError)
            return err;
        return cause;
    })();
    return new TransactionExecutionError(cause, {
        docsPath,
        ...args,
    });
}

/**
 * Sends a **signed** transaction to the network
 *
 * - Docs: https://viem.sh/docs/actions/wallet/sendRawTransaction
 * - JSON-RPC Method: [`eth_sendRawTransaction`](https://ethereum.github.io/execution-apis/api-documentation/)
 *
 * @param client - Client to use
 * @param parameters - {@link SendRawTransactionParameters}
 * @returns The transaction hash. {@link SendRawTransactionReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { sendRawTransaction } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 *
 * const hash = await sendRawTransaction(client, {
 *   serializedTransaction: '0x02f850018203118080825208808080c080a04012522854168b27e5dc3d5839bab5e6b39e1a0ffd343901ce1622e3d64b48f1a04e00902ae0502c4728cbf12156290df99c3ed7de85b1dbfe20b5c36931733a33'
 * })
 */
async function sendRawTransaction(client, { serializedTransaction }) {
    return client.request({
        method: 'eth_sendRawTransaction',
        params: [serializedTransaction],
    }, { retryCount: 0 });
}

const supportsWalletNamespace = new LruMap(128);
/**
 * Creates, signs, and sends a new transaction to the network.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/sendTransaction
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/transactions_sending-transactions
 * - JSON-RPC Methods:
 *   - JSON-RPC Accounts: [`eth_sendTransaction`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_sendtransaction)
 *   - Local Accounts: [`eth_sendRawTransaction`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_sendrawtransaction)
 *
 * @param client - Client to use
 * @param parameters - {@link SendTransactionParameters}
 * @returns The [Transaction](https://viem.sh/docs/glossary/terms#transaction) hash. {@link SendTransactionReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { sendTransaction } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const hash = await sendTransaction(client, {
 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
 *   to: '0x70997970c51812dc3a010c7d01b50e0d17dc79c8',
 *   value: 1000000000000000000n,
 * })
 *
 * @example
 * // Account Hoisting
 * import { createWalletClient, http } from 'viem'
 * import { privateKeyToAccount } from 'viem/accounts'
 * import { mainnet } from 'viem/chains'
 * import { sendTransaction } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   account: privateKeyToAccount('0x…'),
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const hash = await sendTransaction(client, {
 *   to: '0x70997970c51812dc3a010c7d01b50e0d17dc79c8',
 *   value: 1000000000000000000n,
 * })
 */
async function sendTransaction(client, parameters) {
    const { account: account_ = client.account, chain = client.chain, accessList, authorizationList, blobs, data, gas, gasPrice, maxFeePerBlobGas, maxFeePerGas, maxPriorityFeePerGas, nonce, value, ...rest } = parameters;
    if (typeof account_ === 'undefined')
        throw new AccountNotFoundError({
            docsPath: '/docs/actions/wallet/sendTransaction',
        });
    const account = account_ ? parseAccount(account_) : null;
    try {
        assertRequest(parameters);
        const to = await (async () => {
            // If `to` exists on the parameters, use that.
            if (parameters.to)
                return parameters.to;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (authorizationList && authorizationList.length > 0)
                return await recoverAuthorizationAddress({
                    authorization: authorizationList[0],
                }).catch(() => {
                    throw new BaseError$1('`to` is required. Could not infer from `authorizationList`.');
                });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        if (account?.type === 'json-rpc' || account === null) {
            let chainId;
            if (chain !== null) {
                chainId = await getAction(client, getChainId, 'getChainId')({});
                assertCurrentChain({
                    currentChainId: chainId,
                    chain,
                });
            }
            const chainFormat = client.chain?.formatters?.transactionRequest?.format;
            const format = chainFormat || formatTransactionRequest;
            const request = format({
                // Pick out extra data that might exist on the chain's transaction request type.
                ...extract(rest, { format: chainFormat }),
                accessList,
                authorizationList,
                blobs,
                chainId,
                data,
                from: account?.address,
                gas,
                gasPrice,
                maxFeePerBlobGas,
                maxFeePerGas,
                maxPriorityFeePerGas,
                nonce,
                to,
                value,
            });
            const isWalletNamespaceSupported = supportsWalletNamespace.get(client.uid);
            const method = isWalletNamespaceSupported
                ? 'wallet_sendTransaction'
                : 'eth_sendTransaction';
            try {
                return await client.request({
                    method,
                    params: [request],
                }, { retryCount: 0 });
            }
            catch (e) {
                if (isWalletNamespaceSupported === false)
                    throw e;
                const error = e;
                // If the transport does not support the method or input, attempt to use the
                // `wallet_sendTransaction` method.
                if (error.name === 'InvalidInputRpcError' ||
                    error.name === 'InvalidParamsRpcError' ||
                    error.name === 'MethodNotFoundRpcError' ||
                    error.name === 'MethodNotSupportedRpcError') {
                    return await client
                        .request({
                        method: 'wallet_sendTransaction',
                        params: [request],
                    }, { retryCount: 0 })
                        .then((hash) => {
                        supportsWalletNamespace.set(client.uid, true);
                        return hash;
                    })
                        .catch((e) => {
                        const walletNamespaceError = e;
                        if (walletNamespaceError.name === 'MethodNotFoundRpcError' ||
                            walletNamespaceError.name === 'MethodNotSupportedRpcError') {
                            supportsWalletNamespace.set(client.uid, false);
                            throw error;
                        }
                        throw walletNamespaceError;
                    });
                }
                throw error;
            }
        }
        if (account?.type === 'local') {
            // Prepare the request for signing (assign appropriate fees, etc.)
            const request = await getAction(client, prepareTransactionRequest, 'prepareTransactionRequest')({
                account,
                accessList,
                authorizationList,
                blobs,
                chain,
                data,
                gas,
                gasPrice,
                maxFeePerBlobGas,
                maxFeePerGas,
                maxPriorityFeePerGas,
                nonce,
                nonceManager: account.nonceManager,
                parameters: [...defaultParameters, 'sidecars'],
                value,
                ...rest,
                to,
            });
            const serializer = chain?.serializers?.transaction;
            const serializedTransaction = (await account.signTransaction(request, {
                serializer,
            }));
            return await getAction(client, sendRawTransaction, 'sendRawTransaction')({
                serializedTransaction,
            });
        }
        if (account?.type === 'smart')
            throw new AccountTypeNotSupportedError({
                metaMessages: [
                    'Consider using the `sendUserOperation` Action instead.',
                ],
                docsPath: '/docs/actions/bundler/sendUserOperation',
                type: 'smart',
            });
        throw new AccountTypeNotSupportedError({
            docsPath: '/docs/actions/wallet/sendTransaction',
            type: account?.type,
        });
    }
    catch (err) {
        if (err instanceof AccountTypeNotSupportedError)
            throw err;
        throw getTransactionError(err, {
            ...parameters,
            account,
            chain: parameters.chain || undefined,
        });
    }
}

/**
 * Executes a write function on a contract.
 *
 * - Docs: https://viem.sh/docs/contract/writeContract
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/contracts_writing-to-contracts
 *
 * A "write" function on a Solidity contract modifies the state of the blockchain. These types of functions require gas to be executed, and hence a [Transaction](https://viem.sh/docs/glossary/terms) is needed to be broadcast in order to change the state.
 *
 * Internally, uses a [Wallet Client](https://viem.sh/docs/clients/wallet) to call the [`sendTransaction` action](https://viem.sh/docs/actions/wallet/sendTransaction) with [ABI-encoded `data`](https://viem.sh/docs/contract/encodeFunctionData).
 *
 * __Warning: The `write` internally sends a transaction – it does not validate if the contract write will succeed (the contract may throw an error). It is highly recommended to [simulate the contract write with `contract.simulate`](https://viem.sh/docs/contract/writeContract#usage) before you execute it.__
 *
 * @param client - Client to use
 * @param parameters - {@link WriteContractParameters}
 * @returns A [Transaction Hash](https://viem.sh/docs/glossary/terms#hash). {@link WriteContractReturnType}
 *
 * @example
 * import { createWalletClient, custom, parseAbi } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { writeContract } from 'viem/contract'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const hash = await writeContract(client, {
 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
 *   abi: parseAbi(['function mint(uint32 tokenId) nonpayable']),
 *   functionName: 'mint',
 *   args: [69420],
 * })
 *
 * @example
 * // With Validation
 * import { createWalletClient, http, parseAbi } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { simulateContract, writeContract } from 'viem/contract'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const { request } = await simulateContract(client, {
 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
 *   abi: parseAbi(['function mint(uint32 tokenId) nonpayable']),
 *   functionName: 'mint',
 *   args: [69420],
 * }
 * const hash = await writeContract(client, request)
 */
async function writeContract(client, parameters) {
    const { abi, account: account_ = client.account, address, args, dataSuffix, functionName, ...request } = parameters;
    if (typeof account_ === 'undefined')
        throw new AccountNotFoundError({
            docsPath: '/docs/contract/writeContract',
        });
    const account = account_ ? parseAccount(account_) : null;
    const data = encodeFunctionData({
        abi,
        args,
        functionName,
    });
    try {
        return await getAction(client, sendTransaction, 'sendTransaction')({
            data: `${data}${dataSuffix ? dataSuffix.replace('0x', '') : ''}`,
            to: address,
            account,
            ...request,
        });
    }
    catch (error) {
        throw getContractError(error, {
            abi,
            address,
            args,
            docsPath: '/docs/contract/writeContract',
            functionName,
            sender: account?.address,
        });
    }
}

/**
 * Gets type-safe interface for performing contract-related actions with a specific `abi` and `address`.
 *
 * - Docs https://viem.sh/docs/contract/getContract
 *
 * Using Contract Instances can make it easier to work with contracts if you don't want to pass the `abi` and `address` properties every time you perform contract actions, e.g. [`readContract`](https://viem.sh/docs/contract/readContract), [`writeContract`](https://viem.sh/docs/contract/writeContract), [`estimateContractGas`](https://viem.sh/docs/contract/estimateContractGas), etc.
 *
 * @example
 * import { createPublicClient, getContract, http, parseAbi } from 'viem'
 * import { mainnet } from 'viem/chains'
 *
 * const publicClient = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const contract = getContract({
 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
 *   abi: parseAbi([
 *     'function balanceOf(address owner) view returns (uint256)',
 *     'function ownerOf(uint256 tokenId) view returns (address)',
 *     'function totalSupply() view returns (uint256)',
 *   ]),
 *   client: publicClient,
 * })
 */
function getContract({ abi, address, client: client_, }) {
    const client = client_;
    const [publicClient, walletClient] = (() => {
        if (!client)
            return [undefined, undefined];
        if ('public' in client && 'wallet' in client)
            return [client.public, client.wallet];
        if ('public' in client)
            return [client.public, undefined];
        if ('wallet' in client)
            return [undefined, client.wallet];
        return [client, client];
    })();
    const hasPublicClient = publicClient !== undefined && publicClient !== null;
    const hasWalletClient = walletClient !== undefined && walletClient !== null;
    const contract = {};
    let hasReadFunction = false;
    let hasWriteFunction = false;
    let hasEvent = false;
    for (const item of abi) {
        if (item.type === 'function')
            if (item.stateMutability === 'view' || item.stateMutability === 'pure')
                hasReadFunction = true;
            else
                hasWriteFunction = true;
        else if (item.type === 'event')
            hasEvent = true;
        // Exit early if all flags are `true`
        if (hasReadFunction && hasWriteFunction && hasEvent)
            break;
    }
    if (hasPublicClient) {
        if (hasReadFunction)
            contract.read = new Proxy({}, {
                get(_, functionName) {
                    return (...parameters) => {
                        const { args, options } = getFunctionParameters(parameters);
                        return getAction(publicClient, readContract, 'readContract')({
                            abi,
                            address,
                            functionName,
                            args,
                            ...options,
                        });
                    };
                },
            });
        if (hasWriteFunction)
            contract.simulate = new Proxy({}, {
                get(_, functionName) {
                    return (...parameters) => {
                        const { args, options } = getFunctionParameters(parameters);
                        return getAction(publicClient, simulateContract, 'simulateContract')({
                            abi,
                            address,
                            functionName,
                            args,
                            ...options,
                        });
                    };
                },
            });
        if (hasEvent) {
            contract.createEventFilter = new Proxy({}, {
                get(_, eventName) {
                    return (...parameters) => {
                        const abiEvent = abi.find((x) => x.type === 'event' && x.name === eventName);
                        const { args, options } = getEventParameters(parameters, abiEvent);
                        return getAction(publicClient, createContractEventFilter, 'createContractEventFilter')({
                            abi,
                            address,
                            eventName,
                            args,
                            ...options,
                        });
                    };
                },
            });
            contract.getEvents = new Proxy({}, {
                get(_, eventName) {
                    return (...parameters) => {
                        const abiEvent = abi.find((x) => x.type === 'event' && x.name === eventName);
                        const { args, options } = getEventParameters(parameters, abiEvent);
                        return getAction(publicClient, getContractEvents, 'getContractEvents')({
                            abi,
                            address,
                            eventName,
                            args,
                            ...options,
                        });
                    };
                },
            });
            contract.watchEvent = new Proxy({}, {
                get(_, eventName) {
                    return (...parameters) => {
                        const abiEvent = abi.find((x) => x.type === 'event' && x.name === eventName);
                        const { args, options } = getEventParameters(parameters, abiEvent);
                        return getAction(publicClient, watchContractEvent, 'watchContractEvent')({
                            abi,
                            address,
                            eventName,
                            args,
                            ...options,
                        });
                    };
                },
            });
        }
    }
    if (hasWalletClient) {
        if (hasWriteFunction)
            contract.write = new Proxy({}, {
                get(_, functionName) {
                    return (...parameters) => {
                        const { args, options } = getFunctionParameters(parameters);
                        return getAction(walletClient, writeContract, 'writeContract')({
                            abi,
                            address,
                            functionName,
                            args,
                            ...options,
                        });
                    };
                },
            });
    }
    if (hasPublicClient || hasWalletClient)
        if (hasWriteFunction)
            contract.estimateGas = new Proxy({}, {
                get(_, functionName) {
                    return (...parameters) => {
                        const { args, options } = getFunctionParameters(parameters);
                        const client = (publicClient ?? walletClient);
                        return getAction(client, estimateContractGas, 'estimateContractGas')({
                            abi,
                            address,
                            functionName,
                            args,
                            ...options,
                            account: options.account ??
                                walletClient.account,
                        });
                    };
                },
            });
    contract.address = address;
    contract.abi = abi;
    return contract;
}
/**
 * @internal exporting for testing only
 */
function getFunctionParameters(values) {
    const hasArgs = values.length && Array.isArray(values[0]);
    const args = hasArgs ? values[0] : [];
    const options = (hasArgs ? values[1] : values[0]) ?? {};
    return { args, options };
}
/**
 * @internal exporting for testing only
 */
function getEventParameters(values, abiEvent) {
    let hasArgs = false;
    // If first item is array, must be `args`
    if (Array.isArray(values[0]))
        hasArgs = true;
    // Check if first item is `args` or `options`
    else if (values.length === 1) {
        // if event has indexed inputs, must have `args`
        hasArgs = abiEvent.inputs.some((x) => x.indexed);
        // If there are two items in array, must have `args`
    }
    else if (values.length === 2) {
        hasArgs = true;
    }
    const args = hasArgs ? values[0] : undefined;
    const options = (hasArgs ? values[1] : values[0]) ?? {};
    return { args, options };
}

class Eip712DomainNotFoundError extends BaseError$1 {
    constructor({ address }) {
        super(`No EIP-712 domain found on contract "${address}".`, {
            metaMessages: [
                'Ensure that:',
                `- The contract is deployed at the address "${address}".`,
                '- `eip712Domain()` function exists on the contract.',
                '- `eip712Domain()` function matches signature to ERC-5267 specification.',
            ],
            name: 'Eip712DomainNotFoundError',
        });
    }
}

/**
 * Reads the EIP-712 domain from a contract, based on the ERC-5267 specification.
 *
 * @param client - A {@link Client} instance.
 * @param parameters - The parameters of the action. {@link GetEip712DomainParameters}
 * @returns The EIP-712 domain, fields, and extensions. {@link GetEip712DomainReturnType}
 *
 * @example
 * ```ts
 * import { createPublicClient, http, getEip712Domain } from 'viem'
 * import { mainnet } from 'viem/chains'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 *
 * const domain = await getEip712Domain(client, {
 *   address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
 * })
 * // {
 * //   domain: {
 * //     name: 'ExampleContract',
 * //     version: '1',
 * //     chainId: 1,
 * //     verifyingContract: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
 * //   },
 * //   fields: '0x0f',
 * //   extensions: [],
 * // }
 * ```
 */
async function getEip712Domain$1(client, parameters) {
    const { address, factory, factoryData } = parameters;
    try {
        const [fields, name, version, chainId, verifyingContract, salt, extensions,] = await getAction(client, readContract, 'readContract')({
            abi: abi$1,
            address,
            functionName: 'eip712Domain',
            factory,
            factoryData,
        });
        return {
            domain: {
                name,
                version,
                chainId: Number(chainId),
                verifyingContract,
                salt,
            },
            extensions,
            fields,
        };
    }
    catch (e) {
        const error = e;
        if (error.name === 'ContractFunctionExecutionError' &&
            error.cause.name === 'ContractFunctionZeroDataError') {
            throw new Eip712DomainNotFoundError({ address });
        }
        throw error;
    }
}
const abi$1 = [
    {
        inputs: [],
        name: 'eip712Domain',
        outputs: [
            { name: 'fields', type: 'bytes1' },
            { name: 'name', type: 'string' },
            { name: 'version', type: 'string' },
            { name: 'chainId', type: 'uint256' },
            { name: 'verifyingContract', type: 'address' },
            { name: 'salt', type: 'bytes32' },
            { name: 'extensions', type: 'uint256[]' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];

/**
 * Adds an EVM chain to the wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/addChain
 * - JSON-RPC Methods: [`eth_addEthereumChain`](https://eips.ethereum.org/EIPS/eip-3085)
 *
 * @param client - Client to use
 * @param parameters - {@link AddChainParameters}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { optimism } from 'viem/chains'
 * import { addChain } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   transport: custom(window.ethereum),
 * })
 * await addChain(client, { chain: optimism })
 */
async function addChain(client, { chain }) {
    const { id, name, nativeCurrency, rpcUrls, blockExplorers } = chain;
    await client.request({
        method: 'wallet_addEthereumChain',
        params: [
            {
                chainId: numberToHex(id),
                chainName: name,
                nativeCurrency,
                rpcUrls: rpcUrls.default.http,
                blockExplorerUrls: blockExplorers
                    ? Object.values(blockExplorers).map(({ url }) => url)
                    : undefined,
            },
        ],
    }, { dedupe: true, retryCount: 0 });
}

const size = 256;
let index$1 = size;
let buffer;
function uid(length = 11) {
    if (!buffer || index$1 + length > size * 2) {
        buffer = '';
        index$1 = 0;
        for (let i = 0; i < size; i++) {
            buffer += ((256 + Math.random() * 256) | 0).toString(16).substring(1);
        }
    }
    return buffer.substring(index$1, index$1++ + length);
}

function createClient(parameters) {
    const { batch, cacheTime = parameters.pollingInterval ?? 4_000, ccipRead, key = 'base', name = 'Base Client', pollingInterval = 4_000, type = 'base', } = parameters;
    const chain = parameters.chain;
    const account = parameters.account
        ? parseAccount(parameters.account)
        : undefined;
    const { config, request, value } = parameters.transport({
        chain,
        pollingInterval,
    });
    const transport = { ...config, ...value };
    const client = {
        account,
        batch,
        cacheTime,
        ccipRead,
        chain,
        key,
        name,
        pollingInterval,
        request,
        transport,
        type,
        uid: uid(),
    };
    function extend(base) {
        return (extendFn) => {
            const extended = extendFn(base);
            for (const key in client)
                delete extended[key];
            const combined = { ...base, ...extended };
            return Object.assign(combined, { extend: extend(combined) });
        };
    }
    return Object.assign(client, { extend: extend(client) });
}

/** @internal */
const promiseCache = /*#__PURE__*/ new LruMap(8192);
/** Deduplicates in-flight promises. */
function withDedupe(fn, { enabled = true, id }) {
    if (!enabled || !id)
        return fn();
    if (promiseCache.get(id))
        return promiseCache.get(id);
    const promise = fn().finally(() => promiseCache.delete(id));
    promiseCache.set(id, promise);
    return promise;
}

function withRetry(fn, { delay: delay_ = 100, retryCount = 2, shouldRetry = () => true, } = {}) {
    return new Promise((resolve, reject) => {
        const attemptRetry = async ({ count = 0 } = {}) => {
            const retry = async ({ error }) => {
                const delay = typeof delay_ === 'function' ? delay_({ count, error }) : delay_;
                if (delay)
                    await wait(delay);
                attemptRetry({ count: count + 1 });
            };
            try {
                const data = await fn();
                resolve(data);
            }
            catch (err) {
                if (count < retryCount &&
                    (await shouldRetry({ count, error: err })))
                    return retry({ error: err });
                reject(err);
            }
        };
        attemptRetry();
    });
}

function buildRequest(request, options = {}) {
    return async (args, overrideOptions = {}) => {
        const { dedupe = false, methods, retryDelay = 150, retryCount = 3, uid, } = {
            ...options,
            ...overrideOptions,
        };
        const { method } = args;
        if (methods?.exclude?.includes(method))
            throw new MethodNotSupportedRpcError(new Error('method not supported'), {
                method,
            });
        if (methods?.include && !methods.include.includes(method))
            throw new MethodNotSupportedRpcError(new Error('method not supported'), {
                method,
            });
        const requestId = dedupe
            ? stringToHex(`${uid}.${stringify$1(args)}`)
            : undefined;
        return withDedupe(() => withRetry(async () => {
            try {
                return await request(args);
            }
            catch (err_) {
                const err = err_;
                switch (err.code) {
                    // -32700
                    case ParseRpcError.code:
                        throw new ParseRpcError(err);
                    // -32600
                    case InvalidRequestRpcError.code:
                        throw new InvalidRequestRpcError(err);
                    // -32601
                    case MethodNotFoundRpcError.code:
                        throw new MethodNotFoundRpcError(err, { method: args.method });
                    // -32602
                    case InvalidParamsRpcError.code:
                        throw new InvalidParamsRpcError(err);
                    // -32603
                    case InternalRpcError.code:
                        throw new InternalRpcError(err);
                    // -32000
                    case InvalidInputRpcError.code:
                        throw new InvalidInputRpcError(err);
                    // -32001
                    case ResourceNotFoundRpcError.code:
                        throw new ResourceNotFoundRpcError(err);
                    // -32002
                    case ResourceUnavailableRpcError.code:
                        throw new ResourceUnavailableRpcError(err);
                    // -32003
                    case TransactionRejectedRpcError.code:
                        throw new TransactionRejectedRpcError(err);
                    // -32004
                    case MethodNotSupportedRpcError.code:
                        throw new MethodNotSupportedRpcError(err, {
                            method: args.method,
                        });
                    // -32005
                    case LimitExceededRpcError.code:
                        throw new LimitExceededRpcError(err);
                    // -32006
                    case JsonRpcVersionUnsupportedError.code:
                        throw new JsonRpcVersionUnsupportedError(err);
                    // 4001
                    case UserRejectedRequestError$1.code:
                        throw new UserRejectedRequestError$1(err);
                    // 4100
                    case UnauthorizedProviderError.code:
                        throw new UnauthorizedProviderError(err);
                    // 4200
                    case UnsupportedProviderMethodError.code:
                        throw new UnsupportedProviderMethodError(err);
                    // 4900
                    case ProviderDisconnectedError.code:
                        throw new ProviderDisconnectedError(err);
                    // 4901
                    case ChainDisconnectedError.code:
                        throw new ChainDisconnectedError(err);
                    // 4902
                    case SwitchChainError.code:
                        throw new SwitchChainError(err);
                    // CAIP-25: User Rejected Error
                    // https://docs.walletconnect.com/2.0/specs/clients/sign/error-codes#rejected-caip-25
                    case 5000:
                        throw new UserRejectedRequestError$1(err);
                    default:
                        if (err_ instanceof BaseError$1)
                            throw err_;
                        throw new UnknownRpcError(err);
                }
            }
        }, {
            delay: ({ count, error }) => {
                // If we find a Retry-After header, let's retry after the given time.
                if (error && error instanceof HttpRequestError) {
                    const retryAfter = error?.headers?.get('Retry-After');
                    if (retryAfter?.match(/\d/))
                        return Number.parseInt(retryAfter) * 1000;
                }
                // Otherwise, let's retry with an exponential backoff.
                return ~~(1 << count) * retryDelay;
            },
            retryCount,
            shouldRetry: ({ error }) => shouldRetry(error),
        }), { enabled: dedupe, id: requestId });
    };
}
/** @internal */
function shouldRetry(error) {
    if ('code' in error && typeof error.code === 'number') {
        if (error.code === -1)
            return true; // Unknown error
        if (error.code === LimitExceededRpcError.code)
            return true;
        if (error.code === InternalRpcError.code)
            return true;
        return false;
    }
    if (error instanceof HttpRequestError && error.status) {
        // Forbidden
        if (error.status === 403)
            return true;
        // Request Timeout
        if (error.status === 408)
            return true;
        // Request Entity Too Large
        if (error.status === 413)
            return true;
        // Too Many Requests
        if (error.status === 429)
            return true;
        // Internal Server Error
        if (error.status === 500)
            return true;
        // Bad Gateway
        if (error.status === 502)
            return true;
        // Service Unavailable
        if (error.status === 503)
            return true;
        // Gateway Timeout
        if (error.status === 504)
            return true;
        return false;
    }
    return true;
}

/**
 * @description Creates an transport intended to be used with a client.
 */
function createTransport({ key, methods, name, request, retryCount = 3, retryDelay = 150, timeout, type, }, value) {
    const uid$1 = uid();
    return {
        config: {
            key,
            name,
            request,
            retryCount,
            retryDelay,
            timeout,
            type,
        },
        request: buildRequest(request, { methods, retryCount, retryDelay, uid: uid$1 }),
        value,
    };
}

/**
 * @description Creates a custom transport given an EIP-1193 compliant `request` attribute.
 */
function custom$1(provider, config = {}) {
    const { key = 'custom', methods, name = 'Custom Provider', retryDelay, } = config;
    return ({ retryCount: defaultRetryCount }) => createTransport({
        key,
        methods,
        name,
        request: provider.request.bind(provider),
        retryCount: config.retryCount ?? defaultRetryCount,
        retryDelay,
        type: 'custom',
    });
}

class UrlRequiredError extends BaseError$1 {
    constructor() {
        super('No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.', {
            docsPath: '/docs/clients/intro',
            name: 'UrlRequiredError',
        });
    }
}

function withTimeout(fn, { errorInstance = new Error('timed out'), timeout, signal, }) {
    return new Promise((resolve, reject) => {
        (async () => {
            let timeoutId;
            try {
                const controller = new AbortController();
                if (timeout > 0) {
                    timeoutId = setTimeout(() => {
                        if (signal) {
                            controller.abort();
                        }
                    }, timeout); // need to cast because bun globals.d.ts overrides @types/node
                }
                resolve(await fn({ signal: controller?.signal || null }));
            }
            catch (err) {
                if (err?.name === 'AbortError')
                    reject(errorInstance);
                reject(err);
            }
            finally {
                clearTimeout(timeoutId);
            }
        })();
    });
}

function createIdStore() {
    return {
        current: 0,
        take() {
            return this.current++;
        },
        reset() {
            this.current = 0;
        },
    };
}
const idCache = /*#__PURE__*/ createIdStore();

function getHttpRpcClient(url, options = {}) {
    return {
        async request(params) {
            const { body, onRequest = options.onRequest, onResponse = options.onResponse, timeout = options.timeout ?? 10_000, } = params;
            const fetchOptions = {
                ...(options.fetchOptions ?? {}),
                ...(params.fetchOptions ?? {}),
            };
            const { headers, method, signal: signal_ } = fetchOptions;
            try {
                const response = await withTimeout(async ({ signal }) => {
                    const init = {
                        ...fetchOptions,
                        body: Array.isArray(body)
                            ? stringify$1(body.map((body) => ({
                                jsonrpc: '2.0',
                                id: body.id ?? idCache.take(),
                                ...body,
                            })))
                            : stringify$1({
                                jsonrpc: '2.0',
                                id: body.id ?? idCache.take(),
                                ...body,
                            }),
                        headers: {
                            'Content-Type': 'application/json',
                            ...headers,
                        },
                        method: method || 'POST',
                        signal: signal_ || (timeout > 0 ? signal : null),
                    };
                    const request = new Request(url, init);
                    const args = (await onRequest?.(request, init)) ?? { ...init, url };
                    const response = await fetch(args.url ?? url, args);
                    return response;
                }, {
                    errorInstance: new TimeoutError({ body, url }),
                    timeout,
                    signal: true,
                });
                if (onResponse)
                    await onResponse(response);
                let data;
                if (response.headers.get('Content-Type')?.startsWith('application/json'))
                    data = await response.json();
                else {
                    data = await response.text();
                    try {
                        data = JSON.parse(data || '{}');
                    }
                    catch (err) {
                        if (response.ok)
                            throw err;
                        data = { error: data };
                    }
                }
                if (!response.ok) {
                    throw new HttpRequestError({
                        body,
                        details: stringify$1(data.error) || response.statusText,
                        headers: response.headers,
                        status: response.status,
                        url,
                    });
                }
                return data;
            }
            catch (err) {
                if (err instanceof HttpRequestError)
                    throw err;
                if (err instanceof TimeoutError)
                    throw err;
                throw new HttpRequestError({
                    body,
                    cause: err,
                    url,
                });
            }
        },
    };
}

/**
 * @description Creates a HTTP transport that connects to a JSON-RPC API.
 */
function http(
/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */
url, config = {}) {
    const { batch, fetchOptions, key = 'http', methods, name = 'HTTP JSON-RPC', onFetchRequest, onFetchResponse, retryDelay, } = config;
    return ({ chain, retryCount: retryCount_, timeout: timeout_ }) => {
        const { batchSize = 1000, wait = 0 } = typeof batch === 'object' ? batch : {};
        const retryCount = config.retryCount ?? retryCount_;
        const timeout = timeout_ ?? config.timeout ?? 10_000;
        const url_ = url || chain?.rpcUrls.default.http[0];
        if (!url_)
            throw new UrlRequiredError();
        const rpcClient = getHttpRpcClient(url_, {
            fetchOptions,
            onRequest: onFetchRequest,
            onResponse: onFetchResponse,
            timeout,
        });
        return createTransport({
            key,
            methods,
            name,
            async request({ method, params }) {
                const body = { method, params };
                const { schedule } = createBatchScheduler({
                    id: url_,
                    wait,
                    shouldSplitBatch(requests) {
                        return requests.length > batchSize;
                    },
                    fn: (body) => rpcClient.request({
                        body,
                    }),
                    sort: (a, b) => a.id - b.id,
                });
                const fn = async (body) => batch
                    ? schedule(body)
                    : [
                        await rpcClient.request({
                            body,
                        }),
                    ];
                const [{ error, result }] = await fn(body);
                if (error)
                    throw new RpcRequestError({
                        body,
                        error,
                        url: url_,
                    });
                return result;
            },
            retryCount,
            retryDelay,
            timeout,
            type: 'http',
        }, {
            fetchOptions,
            url: url_,
        });
    };
}

/*
 * @description Checks if error is a valid null result UniversalResolver error
 */
function isNullUniversalResolverError(err, callType) {
    if (!(err instanceof BaseError$1))
        return false;
    const cause = err.walk((e) => e instanceof ContractFunctionRevertedError);
    if (!(cause instanceof ContractFunctionRevertedError))
        return false;
    if (cause.data?.errorName === 'ResolverNotFound')
        return true;
    if (cause.data?.errorName === 'ResolverWildcardNotSupported')
        return true;
    if (cause.data?.errorName === 'ResolverNotContract')
        return true;
    if (cause.data?.errorName === 'ResolverError')
        return true;
    if (cause.data?.errorName === 'HttpError')
        return true;
    // Backwards compatibility for older UniversalResolver contracts
    if (cause.reason?.includes('Wildcard on non-extended resolvers is not supported'))
        return true;
    // No primary name set for address.
    if (callType === 'reverse' && cause.reason === panicReasons[50])
        return true;
    return false;
}

function encodedLabelToLabelhash(label) {
    if (label.length !== 66)
        return null;
    if (label.indexOf('[') !== 0)
        return null;
    if (label.indexOf(']') !== 65)
        return null;
    const hash = `0x${label.slice(1, 65)}`;
    if (!isHex$2(hash))
        return null;
    return hash;
}

/**
 * @description Hashes ENS name
 *
 * - Since ENS names prohibit certain forbidden characters (e.g. underscore) and have other validation rules, you likely want to [normalize ENS names](https://docs.ens.domains/contract-api-reference/name-processing#normalising-names) with [UTS-46 normalization](https://unicode.org/reports/tr46) before passing them to `namehash`. You can use the built-in [`normalize`](https://viem.sh/docs/ens/utilities/normalize) function for this.
 *
 * @example
 * namehash('wevm.eth')
 * '0xf246651c1b9a6b141d19c2604e9a58f567973833990f830d882534a747801359'
 *
 * @link https://eips.ethereum.org/EIPS/eip-137
 */
function namehash(name) {
    let result = new Uint8Array(32).fill(0);
    if (!name)
        return bytesToHex$2(result);
    const labels = name.split('.');
    // Iterate in reverse order building up hash
    for (let i = labels.length - 1; i >= 0; i -= 1) {
        const hashFromEncodedLabel = encodedLabelToLabelhash(labels[i]);
        const hashed = hashFromEncodedLabel
            ? toBytes$1(hashFromEncodedLabel)
            : keccak256(stringToBytes(labels[i]), 'bytes');
        result = keccak256(concat$1([result, hashed]), 'bytes');
    }
    return bytesToHex$2(result);
}

function encodeLabelhash(hash) {
    return `[${hash.slice(2)}]`;
}

/**
 * @description Hashes ENS label
 *
 * - Since ENS labels prohibit certain forbidden characters (e.g. underscore) and have other validation rules, you likely want to [normalize ENS labels](https://docs.ens.domains/contract-api-reference/name-processing#normalising-names) with [UTS-46 normalization](https://unicode.org/reports/tr46) before passing them to `labelhash`. You can use the built-in [`normalize`](https://viem.sh/docs/ens/utilities/normalize) function for this.
 *
 * @example
 * labelhash('eth')
 * '0x4f5b812789fc606be1b3b16908db13fc7a9adf7ca72641f84d75b47069d3d7f0'
 */
function labelhash(label) {
    const result = new Uint8Array(32).fill(0);
    if (!label)
        return bytesToHex$2(result);
    return encodedLabelToLabelhash(label) || keccak256(stringToBytes(label));
}

/*
 * @description Encodes a DNS packet into a ByteArray containing a UDP payload.
 *
 * @example
 * packetToBytes('awkweb.eth')
 * '0x0661776b7765620365746800'
 *
 * @see https://docs.ens.domains/resolution/names#dns
 *
 */
function packetToBytes(packet) {
    // strip leading and trailing `.`
    const value = packet.replace(/^\.|\.$/gm, '');
    if (value.length === 0)
        return new Uint8Array(1);
    const bytes = new Uint8Array(stringToBytes(value).byteLength + 2);
    let offset = 0;
    const list = value.split('.');
    for (let i = 0; i < list.length; i++) {
        let encoded = stringToBytes(list[i]);
        // if the length is > 255, make the encoded label value a labelhash
        // this is compatible with the universal resolver
        if (encoded.byteLength > 255)
            encoded = stringToBytes(encodeLabelhash(labelhash(list[i])));
        bytes[offset] = encoded.length;
        bytes.set(encoded, offset + 1);
        offset += encoded.length + 1;
    }
    if (bytes.byteLength !== offset + 1)
        return bytes.slice(0, offset + 1);
    return bytes;
}

/**
 * Gets address for ENS name.
 *
 * - Docs: https://viem.sh/docs/ens/actions/getEnsAddress
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/ens
 *
 * Calls `resolve(bytes, bytes)` on ENS Universal Resolver Contract.
 *
 * Since ENS names prohibit certain forbidden characters (e.g. underscore) and have other validation rules, you likely want to [normalize ENS names](https://docs.ens.domains/contract-api-reference/name-processing#normalising-names) with [UTS-46 normalization](https://unicode.org/reports/tr46) before passing them to `getEnsAddress`. You can use the built-in [`normalize`](https://viem.sh/docs/ens/utilities/normalize) function for this.
 *
 * @param client - Client to use
 * @param parameters - {@link GetEnsAddressParameters}
 * @returns Address for ENS name or `null` if not found. {@link GetEnsAddressReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getEnsAddress, normalize } from 'viem/ens'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const ensAddress = await getEnsAddress(client, {
 *   name: normalize('wevm.eth'),
 * })
 * // '0xd2135CfB216b74109775236E36d4b433F1DF507B'
 */
async function getEnsAddress(client, { blockNumber, blockTag, coinType, name, gatewayUrls, strict, universalResolverAddress: universalResolverAddress_, }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain)
            throw new Error('client chain not configured. universalResolverAddress is required.');
        universalResolverAddress = getChainContractAddress({
            blockNumber,
            chain: client.chain,
            contract: 'ensUniversalResolver',
        });
    }
    try {
        const functionData = encodeFunctionData({
            abi: addressResolverAbi,
            functionName: 'addr',
            ...(coinType != null
                ? { args: [namehash(name), BigInt(coinType)] }
                : { args: [namehash(name)] }),
        });
        const readContractParameters = {
            address: universalResolverAddress,
            abi: universalResolverResolveAbi,
            functionName: 'resolve',
            args: [toHex(packetToBytes(name)), functionData],
            blockNumber,
            blockTag,
        };
        const readContractAction = getAction(client, readContract, 'readContract');
        const res = gatewayUrls
            ? await readContractAction({
                ...readContractParameters,
                args: [...readContractParameters.args, gatewayUrls],
            })
            : await readContractAction(readContractParameters);
        if (res[0] === '0x')
            return null;
        const address = decodeFunctionResult({
            abi: addressResolverAbi,
            args: coinType != null ? [namehash(name), BigInt(coinType)] : undefined,
            functionName: 'addr',
            data: res[0],
        });
        if (address === '0x')
            return null;
        if (trim$1(address) === '0x00')
            return null;
        return address;
    }
    catch (err) {
        if (strict)
            throw err;
        if (isNullUniversalResolverError(err, 'resolve'))
            return null;
        throw err;
    }
}

class EnsAvatarInvalidMetadataError extends BaseError$1 {
    constructor({ data }) {
        super('Unable to extract image from metadata. The metadata may be malformed or invalid.', {
            metaMessages: [
                '- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.',
                '',
                `Provided data: ${JSON.stringify(data)}`,
            ],
            name: 'EnsAvatarInvalidMetadataError',
        });
    }
}
class EnsAvatarInvalidNftUriError extends BaseError$1 {
    constructor({ reason }) {
        super(`ENS NFT avatar URI is invalid. ${reason}`, {
            name: 'EnsAvatarInvalidNftUriError',
        });
    }
}
class EnsAvatarUriResolutionError extends BaseError$1 {
    constructor({ uri }) {
        super(`Unable to resolve ENS avatar URI "${uri}". The URI may be malformed, invalid, or does not respond with a valid image.`, { name: 'EnsAvatarUriResolutionError' });
    }
}
class EnsAvatarUnsupportedNamespaceError extends BaseError$1 {
    constructor({ namespace }) {
        super(`ENS NFT avatar namespace "${namespace}" is not supported. Must be "erc721" or "erc1155".`, { name: 'EnsAvatarUnsupportedNamespaceError' });
    }
}

const networkRegex = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/;
const ipfsHashRegex = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/;
const base64Regex = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/;
const dataURIRegex = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
/** @internal */
async function isImageUri(uri) {
    try {
        const res = await fetch(uri, { method: 'HEAD' });
        // retrieve content type header to check if content is image
        if (res.status === 200) {
            const contentType = res.headers.get('content-type');
            return contentType?.startsWith('image/');
        }
        return false;
    }
    catch (error) {
        // if error is not cors related then fail
        if (typeof error === 'object' && typeof error.response !== 'undefined') {
            return false;
        }
        // fail in NodeJS, since the error is not cors but any other network issue
        // biome-ignore lint/suspicious/noPrototypeBuiltins:
        if (!globalThis.hasOwnProperty('Image'))
            return false;
        // in case of cors, use image api to validate if given url is an actual image
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                resolve(true);
            };
            img.onerror = () => {
                resolve(false);
            };
            img.src = uri;
        });
    }
}
/** @internal */
function getGateway(custom, defaultGateway) {
    if (!custom)
        return defaultGateway;
    if (custom.endsWith('/'))
        return custom.slice(0, -1);
    return custom;
}
function resolveAvatarUri({ uri, gatewayUrls, }) {
    const isEncoded = base64Regex.test(uri);
    if (isEncoded)
        return { uri, isOnChain: true, isEncoded };
    const ipfsGateway = getGateway(gatewayUrls?.ipfs, 'https://ipfs.io');
    const arweaveGateway = getGateway(gatewayUrls?.arweave, 'https://arweave.net');
    const networkRegexMatch = uri.match(networkRegex);
    const { protocol, subpath, target, subtarget = '', } = networkRegexMatch?.groups || {};
    const isIPNS = protocol === 'ipns:/' || subpath === 'ipns/';
    const isIPFS = protocol === 'ipfs:/' || subpath === 'ipfs/' || ipfsHashRegex.test(uri);
    if (uri.startsWith('http') && !isIPNS && !isIPFS) {
        let replacedUri = uri;
        if (gatewayUrls?.arweave)
            replacedUri = uri.replace(/https:\/\/arweave.net/g, gatewayUrls?.arweave);
        return { uri: replacedUri, isOnChain: false, isEncoded: false };
    }
    if ((isIPNS || isIPFS) && target) {
        return {
            uri: `${ipfsGateway}/${isIPNS ? 'ipns' : 'ipfs'}/${target}${subtarget}`,
            isOnChain: false,
            isEncoded: false,
        };
    }
    if (protocol === 'ar:/' && target) {
        return {
            uri: `${arweaveGateway}/${target}${subtarget || ''}`,
            isOnChain: false,
            isEncoded: false,
        };
    }
    let parsedUri = uri.replace(dataURIRegex, '');
    if (parsedUri.startsWith('<svg')) {
        // if svg, base64 encode
        parsedUri = `data:image/svg+xml;base64,${btoa(parsedUri)}`;
    }
    if (parsedUri.startsWith('data:') || parsedUri.startsWith('{')) {
        return {
            uri: parsedUri,
            isOnChain: true,
            isEncoded: false,
        };
    }
    throw new EnsAvatarUriResolutionError({ uri });
}
function getJsonImage(data) {
    // validation check for json data, must include one of theses properties
    if (typeof data !== 'object' ||
        (!('image' in data) && !('image_url' in data) && !('image_data' in data))) {
        throw new EnsAvatarInvalidMetadataError({ data });
    }
    return data.image || data.image_url || data.image_data;
}
async function getMetadataAvatarUri({ gatewayUrls, uri, }) {
    try {
        const res = await fetch(uri).then((res) => res.json());
        const image = await parseAvatarUri({
            gatewayUrls,
            uri: getJsonImage(res),
        });
        return image;
    }
    catch {
        throw new EnsAvatarUriResolutionError({ uri });
    }
}
async function parseAvatarUri({ gatewayUrls, uri, }) {
    const { uri: resolvedURI, isOnChain } = resolveAvatarUri({ uri, gatewayUrls });
    if (isOnChain)
        return resolvedURI;
    // check if resolvedURI is an image, if it is return the url
    const isImage = await isImageUri(resolvedURI);
    if (isImage)
        return resolvedURI;
    throw new EnsAvatarUriResolutionError({ uri });
}
function parseNftUri(uri_) {
    let uri = uri_;
    // parse valid nft spec (CAIP-22/CAIP-29)
    // @see: https://github.com/ChainAgnostic/CAIPs/tree/master/CAIPs
    if (uri.startsWith('did:nft:')) {
        // convert DID to CAIP
        uri = uri.replace('did:nft:', '').replace(/_/g, '/');
    }
    const [reference, asset_namespace, tokenID] = uri.split('/');
    const [eip_namespace, chainID] = reference.split(':');
    const [erc_namespace, contractAddress] = asset_namespace.split(':');
    if (!eip_namespace || eip_namespace.toLowerCase() !== 'eip155')
        throw new EnsAvatarInvalidNftUriError({ reason: 'Only EIP-155 supported' });
    if (!chainID)
        throw new EnsAvatarInvalidNftUriError({ reason: 'Chain ID not found' });
    if (!contractAddress)
        throw new EnsAvatarInvalidNftUriError({
            reason: 'Contract address not found',
        });
    if (!tokenID)
        throw new EnsAvatarInvalidNftUriError({ reason: 'Token ID not found' });
    if (!erc_namespace)
        throw new EnsAvatarInvalidNftUriError({ reason: 'ERC namespace not found' });
    return {
        chainID: Number.parseInt(chainID),
        namespace: erc_namespace.toLowerCase(),
        contractAddress: contractAddress,
        tokenID,
    };
}
async function getNftTokenUri(client, { nft }) {
    if (nft.namespace === 'erc721') {
        return readContract(client, {
            address: nft.contractAddress,
            abi: [
                {
                    name: 'tokenURI',
                    type: 'function',
                    stateMutability: 'view',
                    inputs: [{ name: 'tokenId', type: 'uint256' }],
                    outputs: [{ name: '', type: 'string' }],
                },
            ],
            functionName: 'tokenURI',
            args: [BigInt(nft.tokenID)],
        });
    }
    if (nft.namespace === 'erc1155') {
        return readContract(client, {
            address: nft.contractAddress,
            abi: [
                {
                    name: 'uri',
                    type: 'function',
                    stateMutability: 'view',
                    inputs: [{ name: '_id', type: 'uint256' }],
                    outputs: [{ name: '', type: 'string' }],
                },
            ],
            functionName: 'uri',
            args: [BigInt(nft.tokenID)],
        });
    }
    throw new EnsAvatarUnsupportedNamespaceError({ namespace: nft.namespace });
}

/*
 * @description Parses an ENS avatar record.
 *
 * @example
 * parseAvatarRecord('eip155:1/erc1155:0xb32979486938aa9694bfc898f35dbed459f44424/10063')
 * 'https://ipfs.io/ipfs/QmSP4nq9fnN9dAiCj42ug9Wa79rqmQerZXZch82VqpiH7U/image.gif'
 *
 * @see https://docs.ens.domains/web/avatars
 *
 */
async function parseAvatarRecord(client, { gatewayUrls, record, }) {
    if (/eip155:/i.test(record))
        return parseNftAvatarUri(client, { gatewayUrls, record });
    return parseAvatarUri({ uri: record, gatewayUrls });
}
async function parseNftAvatarUri(client, { gatewayUrls, record, }) {
    // parse NFT URI into properties
    const nft = parseNftUri(record);
    // fetch tokenURI from the NFT contract
    const nftUri = await getNftTokenUri(client, { nft });
    // resolve the URI from the fetched tokenURI
    const { uri: resolvedNftUri, isOnChain, isEncoded, } = resolveAvatarUri({ uri: nftUri, gatewayUrls });
    // if the resolved URI is on chain, return the data
    if (isOnChain &&
        (resolvedNftUri.includes('data:application/json;base64,') ||
            resolvedNftUri.startsWith('{'))) {
        const encodedJson = isEncoded
            ? // if it is encoded, decode it
                atob(resolvedNftUri.replace('data:application/json;base64,', ''))
            : // if it isn't encoded assume it is a JSON string, but it could be anything (it will error if it is)
                resolvedNftUri;
        const decoded = JSON.parse(encodedJson);
        return parseAvatarUri({ uri: getJsonImage(decoded), gatewayUrls });
    }
    let uriTokenId = nft.tokenID;
    if (nft.namespace === 'erc1155')
        uriTokenId = uriTokenId.replace('0x', '').padStart(64, '0');
    return getMetadataAvatarUri({
        gatewayUrls,
        uri: resolvedNftUri.replace(/(?:0x)?{id}/, uriTokenId),
    });
}

/**
 * Gets a text record for specified ENS name.
 *
 * - Docs: https://viem.sh/docs/ens/actions/getEnsResolver
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/ens
 *
 * Calls `resolve(bytes, bytes)` on ENS Universal Resolver Contract.
 *
 * Since ENS names prohibit certain forbidden characters (e.g. underscore) and have other validation rules, you likely want to [normalize ENS names](https://docs.ens.domains/contract-api-reference/name-processing#normalising-names) with [UTS-46 normalization](https://unicode.org/reports/tr46) before passing them to `getEnsAddress`. You can use the built-in [`normalize`](https://viem.sh/docs/ens/utilities/normalize) function for this.
 *
 * @param client - Client to use
 * @param parameters - {@link GetEnsTextParameters}
 * @returns Address for ENS resolver. {@link GetEnsTextReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getEnsText, normalize } from 'viem/ens'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const twitterRecord = await getEnsText(client, {
 *   name: normalize('wevm.eth'),
 *   key: 'com.twitter',
 * })
 * // 'wevm_dev'
 */
async function getEnsText(client, { blockNumber, blockTag, name, key, gatewayUrls, strict, universalResolverAddress: universalResolverAddress_, }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain)
            throw new Error('client chain not configured. universalResolverAddress is required.');
        universalResolverAddress = getChainContractAddress({
            blockNumber,
            chain: client.chain,
            contract: 'ensUniversalResolver',
        });
    }
    try {
        const readContractParameters = {
            address: universalResolverAddress,
            abi: universalResolverResolveAbi,
            functionName: 'resolve',
            args: [
                toHex(packetToBytes(name)),
                encodeFunctionData({
                    abi: textResolverAbi,
                    functionName: 'text',
                    args: [namehash(name), key],
                }),
            ],
            blockNumber,
            blockTag,
        };
        const readContractAction = getAction(client, readContract, 'readContract');
        const res = gatewayUrls
            ? await readContractAction({
                ...readContractParameters,
                args: [...readContractParameters.args, gatewayUrls],
            })
            : await readContractAction(readContractParameters);
        if (res[0] === '0x')
            return null;
        const record = decodeFunctionResult({
            abi: textResolverAbi,
            functionName: 'text',
            data: res[0],
        });
        return record === '' ? null : record;
    }
    catch (err) {
        if (strict)
            throw err;
        if (isNullUniversalResolverError(err, 'resolve'))
            return null;
        throw err;
    }
}

/**
 * Gets the avatar of an ENS name.
 *
 * - Docs: https://viem.sh/docs/ens/actions/getEnsAvatar
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/ens
 *
 * Calls [`getEnsText`](https://viem.sh/docs/ens/actions/getEnsText) with `key` set to `'avatar'`.
 *
 * Since ENS names prohibit certain forbidden characters (e.g. underscore) and have other validation rules, you likely want to [normalize ENS names](https://docs.ens.domains/contract-api-reference/name-processing#normalising-names) with [UTS-46 normalization](https://unicode.org/reports/tr46) before passing them to `getEnsAddress`. You can use the built-in [`normalize`](https://viem.sh/docs/ens/utilities/normalize) function for this.
 *
 * @param client - Client to use
 * @param parameters - {@link GetEnsAvatarParameters}
 * @returns Avatar URI or `null` if not found. {@link GetEnsAvatarReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getEnsAvatar, normalize } from 'viem/ens'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const ensAvatar = await getEnsAvatar(client, {
 *   name: normalize('wevm.eth'),
 * })
 * // 'https://ipfs.io/ipfs/Qma8mnp6xV3J2cRNf3mTth5C8nV11CAnceVinc3y8jSbio'
 */
async function getEnsAvatar(client, { blockNumber, blockTag, assetGatewayUrls, name, gatewayUrls, strict, universalResolverAddress, }) {
    const record = await getAction(client, getEnsText, 'getEnsText')({
        blockNumber,
        blockTag,
        key: 'avatar',
        name,
        universalResolverAddress,
        gatewayUrls,
        strict,
    });
    if (!record)
        return null;
    try {
        return await parseAvatarRecord(client, {
            record,
            gatewayUrls: assetGatewayUrls,
        });
    }
    catch {
        return null;
    }
}

/**
 * Gets primary name for specified address.
 *
 * - Docs: https://viem.sh/docs/ens/actions/getEnsName
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/ens
 *
 * Calls `reverse(bytes)` on ENS Universal Resolver Contract to "reverse resolve" the address to the primary ENS name.
 *
 * @param client - Client to use
 * @param parameters - {@link GetEnsNameParameters}
 * @returns Name or `null` if not found. {@link GetEnsNameReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getEnsName } from 'viem/ens'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const ensName = await getEnsName(client, {
 *   address: '0xd2135CfB216b74109775236E36d4b433F1DF507B',
 * })
 * // 'wevm.eth'
 */
async function getEnsName(client, { address, blockNumber, blockTag, gatewayUrls, strict, universalResolverAddress: universalResolverAddress_, }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain)
            throw new Error('client chain not configured. universalResolverAddress is required.');
        universalResolverAddress = getChainContractAddress({
            blockNumber,
            chain: client.chain,
            contract: 'ensUniversalResolver',
        });
    }
    const reverseNode = `${address.toLowerCase().substring(2)}.addr.reverse`;
    try {
        const readContractParameters = {
            address: universalResolverAddress,
            abi: universalResolverReverseAbi,
            functionName: 'reverse',
            args: [toHex(packetToBytes(reverseNode))],
            blockNumber,
            blockTag,
        };
        const readContractAction = getAction(client, readContract, 'readContract');
        const [name, resolvedAddress] = gatewayUrls
            ? await readContractAction({
                ...readContractParameters,
                args: [...readContractParameters.args, gatewayUrls],
            })
            : await readContractAction(readContractParameters);
        if (address.toLowerCase() !== resolvedAddress.toLowerCase())
            return null;
        return name;
    }
    catch (err) {
        if (strict)
            throw err;
        if (isNullUniversalResolverError(err, 'reverse'))
            return null;
        throw err;
    }
}

/**
 * Gets resolver for ENS name.
 *
 * - Docs: https://viem.sh/docs/ens/actions/getEnsResolver
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/ens
 *
 * Calls `findResolver(bytes)` on ENS Universal Resolver Contract to retrieve the resolver of an ENS name.
 *
 * Since ENS names prohibit certain forbidden characters (e.g. underscore) and have other validation rules, you likely want to [normalize ENS names](https://docs.ens.domains/contract-api-reference/name-processing#normalising-names) with [UTS-46 normalization](https://unicode.org/reports/tr46) before passing them to `getEnsAddress`. You can use the built-in [`normalize`](https://viem.sh/docs/ens/utilities/normalize) function for this.
 *
 * @param client - Client to use
 * @param parameters - {@link GetEnsResolverParameters}
 * @returns Address for ENS resolver. {@link GetEnsResolverReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getEnsResolver, normalize } from 'viem/ens'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const resolverAddress = await getEnsResolver(client, {
 *   name: normalize('wevm.eth'),
 * })
 * // '0x4976fb03C32e5B8cfe2b6cCB31c09Ba78EBaBa41'
 */
async function getEnsResolver(client, { blockNumber, blockTag, name, universalResolverAddress: universalResolverAddress_, }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain)
            throw new Error('client chain not configured. universalResolverAddress is required.');
        universalResolverAddress = getChainContractAddress({
            blockNumber,
            chain: client.chain,
            contract: 'ensUniversalResolver',
        });
    }
    const [resolverAddress] = await getAction(client, readContract, 'readContract')({
        address: universalResolverAddress,
        abi: [
            {
                inputs: [{ type: 'bytes' }],
                name: 'findResolver',
                outputs: [{ type: 'address' }, { type: 'bytes32' }],
                stateMutability: 'view',
                type: 'function',
            },
        ],
        functionName: 'findResolver',
        args: [toHex(packetToBytes(name))],
        blockNumber,
        blockTag,
    });
    return resolverAddress;
}

/**
 * Creates an EIP-2930 access list.
 *
 * - Docs: https://viem.sh/docs/actions/public/createAccessList
 * - JSON-RPC Methods: `eth_createAccessList`
 *
 * @param client - Client to use
 * @param parameters - {@link CreateAccessListParameters}
 * @returns The access list. {@link CreateAccessListReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createAccessList } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const data = await createAccessList(client, {
 *   account: '0xf39fd6e51aad88f6f4ce6ab8827279cfffb92266',
 *   data: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
 *   to: '0x70997970c51812dc3a010c7d01b50e0d17dc79c8',
 * })
 */
async function createAccessList(client, args) {
    const { account: account_ = client.account, blockNumber, blockTag = 'latest', blobs, data, gas, gasPrice, maxFeePerBlobGas, maxFeePerGas, maxPriorityFeePerGas, to, value, ...rest } = args;
    const account = account_ ? parseAccount(account_) : undefined;
    try {
        assertRequest(args);
        const blockNumberHex = blockNumber ? numberToHex(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || formatTransactionRequest;
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...extract(rest, { format: chainFormat }),
            from: account?.address,
            blobs,
            data,
            gas,
            gasPrice,
            maxFeePerBlobGas,
            maxFeePerGas,
            maxPriorityFeePerGas,
            to,
            value,
        });
        const response = await client.request({
            method: 'eth_createAccessList',
            params: [request, block],
        });
        return {
            accessList: response.accessList,
            gasUsed: BigInt(response.gasUsed),
        };
    }
    catch (err) {
        throw getCallError(err, {
            ...args,
            account,
            chain: client.chain,
        });
    }
}

/**
 * Creates a [`Filter`](https://viem.sh/docs/glossary/types#filter) to listen for new block hashes that can be used with [`getFilterChanges`](https://viem.sh/docs/actions/public/getFilterChanges).
 *
 * - Docs: https://viem.sh/docs/actions/public/createBlockFilter
 * - JSON-RPC Methods: [`eth_newBlockFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_newBlockFilter)
 *
 * @param client - Client to use
 * @returns [`Filter`](https://viem.sh/docs/glossary/types#filter). {@link CreateBlockFilterReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createBlockFilter } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const filter = await createBlockFilter(client)
 * // { id: "0x345a6572337856574a76364e457a4366", type: 'block' }
 */
async function createBlockFilter(client) {
    const getRequest = createFilterRequestScope(client, {
        method: 'eth_newBlockFilter',
    });
    const id = await client.request({
        method: 'eth_newBlockFilter',
    });
    return { id, request: getRequest(id), type: 'block' };
}

/**
 * Creates a [`Filter`](https://viem.sh/docs/glossary/types#filter) to listen for new events that can be used with [`getFilterChanges`](https://viem.sh/docs/actions/public/getFilterChanges).
 *
 * - Docs: https://viem.sh/docs/actions/public/createEventFilter
 * - JSON-RPC Methods: [`eth_newFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_newfilter)
 *
 * @param client - Client to use
 * @param parameters - {@link CreateEventFilterParameters}
 * @returns [`Filter`](https://viem.sh/docs/glossary/types#filter). {@link CreateEventFilterReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createEventFilter } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const filter = await createEventFilter(client, {
 *   address: '0xfba3912ca04dd458c843e2ee08967fc04f3579c2',
 * })
 */
async function createEventFilter(client, { address, args, event, events: events_, fromBlock, strict, toBlock, } = {}) {
    const events = events_ ?? (event ? [event] : undefined);
    const getRequest = createFilterRequestScope(client, {
        method: 'eth_newFilter',
    });
    let topics = [];
    if (events) {
        const encoded = events.flatMap((event) => encodeEventTopics({
            abi: [event],
            eventName: event.name,
            args,
        }));
        // TODO: Clean up type casting
        topics = [encoded];
        if (event)
            topics = topics[0];
    }
    const id = await client.request({
        method: 'eth_newFilter',
        params: [
            {
                address,
                fromBlock: typeof fromBlock === 'bigint' ? numberToHex(fromBlock) : fromBlock,
                toBlock: typeof toBlock === 'bigint' ? numberToHex(toBlock) : toBlock,
                ...(topics.length ? { topics } : {}),
            },
        ],
    });
    return {
        abi: events,
        args,
        eventName: event ? event.name : undefined,
        fromBlock,
        id,
        request: getRequest(id),
        strict: Boolean(strict),
        toBlock,
        type: 'event',
    };
}

/**
 * Creates a Filter to listen for new pending transaction hashes that can be used with [`getFilterChanges`](https://viem.sh/docs/actions/public/getFilterChanges).
 *
 * - Docs: https://viem.sh/docs/actions/public/createPendingTransactionFilter
 * - JSON-RPC Methods: [`eth_newPendingTransactionFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_newpendingtransactionfilter)
 *
 * @param client - Client to use
 * @returns [`Filter`](https://viem.sh/docs/glossary/types#filter). {@link CreateBlockFilterReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createPendingTransactionFilter } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const filter = await createPendingTransactionFilter(client)
 * // { id: "0x345a6572337856574a76364e457a4366", type: 'transaction' }
 */
async function createPendingTransactionFilter(client) {
    const getRequest = createFilterRequestScope(client, {
        method: 'eth_newPendingTransactionFilter',
    });
    const id = await client.request({
        method: 'eth_newPendingTransactionFilter',
    });
    return { id, request: getRequest(id), type: 'transaction' };
}

/**
 * Returns the base fee per blob gas in wei.
 *
 * - Docs: https://viem.sh/docs/actions/public/getBlobBaseFee
 * - JSON-RPC Methods: [`eth_blobBaseFee`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_blobBaseFee)
 *
 * @param client - Client to use
 * @returns The blob base fee (in wei). {@link GetBlobBaseFeeReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getBlobBaseFee } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const blobBaseFee = await getBlobBaseFee(client)
 */
async function getBlobBaseFee(client) {
    const baseFee = await client.request({
        method: 'eth_blobBaseFee',
    });
    return BigInt(baseFee);
}

/**
 * Returns the number of Transactions at a block number, hash, or tag.
 *
 * - Docs: https://viem.sh/docs/actions/public/getBlockTransactionCount
 * - JSON-RPC Methods:
 *   - Calls [`eth_getBlockTransactionCountByNumber`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getblocktransactioncountbynumber) for `blockNumber` & `blockTag`.
 *   - Calls [`eth_getBlockTransactionCountByHash`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getblocktransactioncountbyhash) for `blockHash`.
 *
 * @param client - Client to use
 * @param parameters - {@link GetBlockTransactionCountParameters}
 * @returns The block transaction count. {@link GetBlockTransactionCountReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getBlockTransactionCount } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const count = await getBlockTransactionCount(client)
 */
async function getBlockTransactionCount(client, { blockHash, blockNumber, blockTag = 'latest', } = {}) {
    const blockNumberHex = blockNumber !== undefined ? numberToHex(blockNumber) : undefined;
    let count;
    if (blockHash) {
        count = await client.request({
            method: 'eth_getBlockTransactionCountByHash',
            params: [blockHash],
        }, { dedupe: true });
    }
    else {
        count = await client.request({
            method: 'eth_getBlockTransactionCountByNumber',
            params: [blockNumberHex || blockTag],
        }, { dedupe: Boolean(blockNumberHex) });
    }
    return hexToNumber$1(count);
}

/**
 * Retrieves the bytecode at an address.
 *
 * - Docs: https://viem.sh/docs/contract/getCode
 * - JSON-RPC Methods: [`eth_getCode`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getcode)
 *
 * @param client - Client to use
 * @param parameters - {@link GetCodeParameters}
 * @returns The contract's bytecode. {@link GetCodeReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getCode } from 'viem/contract'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const code = await getCode(client, {
 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
 * })
 */
async function getCode$1(client, { address, blockNumber, blockTag = 'latest' }) {
    const blockNumberHex = blockNumber !== undefined ? numberToHex(blockNumber) : undefined;
    const hex = await client.request({
        method: 'eth_getCode',
        params: [address, blockNumberHex || blockTag],
    }, { dedupe: Boolean(blockNumberHex) });
    if (hex === '0x')
        return undefined;
    return hex;
}

function formatFeeHistory(feeHistory) {
    return {
        baseFeePerGas: feeHistory.baseFeePerGas.map((value) => BigInt(value)),
        gasUsedRatio: feeHistory.gasUsedRatio,
        oldestBlock: BigInt(feeHistory.oldestBlock),
        reward: feeHistory.reward?.map((reward) => reward.map((value) => BigInt(value))),
    };
}

/**
 * Returns a collection of historical gas information.
 *
 * - Docs: https://viem.sh/docs/actions/public/getFeeHistory
 * - JSON-RPC Methods: [`eth_feeHistory`](https://docs.alchemy.com/reference/eth-feehistory)
 *
 * @param client - Client to use
 * @param parameters - {@link GetFeeHistoryParameters}
 * @returns The gas estimate (in wei). {@link GetFeeHistoryReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getFeeHistory } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const feeHistory = await getFeeHistory(client, {
 *   blockCount: 4,
 *   rewardPercentiles: [25, 75],
 * })
 */
async function getFeeHistory(client, { blockCount, blockNumber, blockTag = 'latest', rewardPercentiles, }) {
    const blockNumberHex = blockNumber ? numberToHex(blockNumber) : undefined;
    const feeHistory = await client.request({
        method: 'eth_feeHistory',
        params: [
            numberToHex(blockCount),
            blockNumberHex || blockTag,
            rewardPercentiles,
        ],
    }, { dedupe: Boolean(blockNumberHex) });
    return formatFeeHistory(feeHistory);
}

/**
 * Returns a list of event logs since the filter was created.
 *
 * - Docs: https://viem.sh/docs/actions/public/getFilterLogs
 * - JSON-RPC Methods: [`eth_getFilterLogs`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getfilterlogs)
 *
 * `getFilterLogs` is only compatible with **event filters**.
 *
 * @param client - Client to use
 * @param parameters - {@link GetFilterLogsParameters}
 * @returns A list of event logs. {@link GetFilterLogsReturnType}
 *
 * @example
 * import { createPublicClient, http, parseAbiItem } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createEventFilter, getFilterLogs } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const filter = await createEventFilter(client, {
 *   address: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
 *   event: parseAbiItem('event Transfer(address indexed, address indexed, uint256)'),
 * })
 * const logs = await getFilterLogs(client, { filter })
 */
async function getFilterLogs(_client, { filter, }) {
    const strict = filter.strict ?? false;
    const logs = await filter.request({
        method: 'eth_getFilterLogs',
        params: [filter.id],
    });
    const formattedLogs = logs.map((log) => formatLog(log));
    if (!filter.abi)
        return formattedLogs;
    return parseEventLogs({
        abi: filter.abi,
        logs: formattedLogs,
        strict,
    });
}

function defineChain(chain) {
    return {
        formatters: undefined,
        fees: undefined,
        serializers: undefined,
        ...chain,
    };
}

class InvalidDomainError extends BaseError$1 {
    constructor({ domain }) {
        super(`Invalid domain "${stringify$1(domain)}".`, {
            metaMessages: ['Must be a valid EIP-712 domain.'],
        });
    }
}
class InvalidPrimaryTypeError extends BaseError$1 {
    constructor({ primaryType, types, }) {
        super(`Invalid primary type \`${primaryType}\` must be one of \`${JSON.stringify(Object.keys(types))}\`.`, {
            docsPath: '/api/glossary/Errors#typeddatainvalidprimarytypeerror',
            metaMessages: ['Check that the primary type is a key in `types`.'],
        });
    }
}
class InvalidStructTypeError extends BaseError$1 {
    constructor({ type }) {
        super(`Struct type "${type}" is invalid.`, {
            metaMessages: ['Struct type must not be a Solidity type.'],
            name: 'InvalidStructTypeError',
        });
    }
}

// Implementation forked and adapted from https://github.com/MetaMask/eth-sig-util/blob/main/src/sign-typed-data.ts
function hashTypedData(parameters) {
    const { domain = {}, message, primaryType, } = parameters;
    const types = {
        EIP712Domain: getTypesForEIP712Domain({ domain }),
        ...parameters.types,
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    validateTypedData({
        domain,
        message,
        primaryType,
        types,
    });
    const parts = ['0x1901'];
    if (domain)
        parts.push(hashDomain({
            domain,
            types: types,
        }));
    if (primaryType !== 'EIP712Domain')
        parts.push(hashStruct({
            data: message,
            primaryType,
            types: types,
        }));
    return keccak256(concat$1(parts));
}
function hashDomain({ domain, types, }) {
    return hashStruct({
        data: domain,
        primaryType: 'EIP712Domain',
        types,
    });
}
function hashStruct({ data, primaryType, types, }) {
    const encoded = encodeData({
        data,
        primaryType,
        types,
    });
    return keccak256(encoded);
}
function encodeData({ data, primaryType, types, }) {
    const encodedTypes = [{ type: 'bytes32' }];
    const encodedValues = [hashType({ primaryType, types })];
    for (const field of types[primaryType]) {
        const [type, value] = encodeField({
            types,
            name: field.name,
            type: field.type,
            value: data[field.name],
        });
        encodedTypes.push(type);
        encodedValues.push(value);
    }
    return encodeAbiParameters(encodedTypes, encodedValues);
}
function hashType({ primaryType, types, }) {
    const encodedHashType = toHex(encodeType({ primaryType, types }));
    return keccak256(encodedHashType);
}
function encodeType({ primaryType, types, }) {
    let result = '';
    const unsortedDeps = findTypeDependencies({ primaryType, types });
    unsortedDeps.delete(primaryType);
    const deps = [primaryType, ...Array.from(unsortedDeps).sort()];
    for (const type of deps) {
        result += `${type}(${types[type]
            .map(({ name, type: t }) => `${t} ${name}`)
            .join(',')})`;
    }
    return result;
}
function findTypeDependencies({ primaryType: primaryType_, types, }, results = new Set()) {
    const match = primaryType_.match(/^\w*/u);
    const primaryType = match?.[0];
    if (results.has(primaryType) || types[primaryType] === undefined) {
        return results;
    }
    results.add(primaryType);
    for (const field of types[primaryType]) {
        findTypeDependencies({ primaryType: field.type, types }, results);
    }
    return results;
}
function encodeField({ types, name, type, value, }) {
    if (types[type] !== undefined) {
        return [
            { type: 'bytes32' },
            keccak256(encodeData({ data: value, primaryType: type, types })),
        ];
    }
    if (type === 'bytes') {
        const prepend = value.length % 2 ? '0' : '';
        value = `0x${prepend + value.slice(2)}`;
        return [{ type: 'bytes32' }, keccak256(value)];
    }
    if (type === 'string')
        return [{ type: 'bytes32' }, keccak256(toHex(value))];
    if (type.lastIndexOf(']') === type.length - 1) {
        const parsedType = type.slice(0, type.lastIndexOf('['));
        const typeValuePairs = value.map((item) => encodeField({
            name,
            type: parsedType,
            types,
            value: item,
        }));
        return [
            { type: 'bytes32' },
            keccak256(encodeAbiParameters(typeValuePairs.map(([t]) => t), typeValuePairs.map(([, v]) => v))),
        ];
    }
    return [{ type }, value];
}

function serializeTypedData(parameters) {
    const { domain: domain_, message: message_, primaryType, types, } = parameters;
    const normalizeData = (struct, data_) => {
        const data = { ...data_ };
        for (const param of struct) {
            const { name, type } = param;
            if (type === 'address')
                data[name] = data[name].toLowerCase();
        }
        return data;
    };
    const domain = (() => {
        if (!types.EIP712Domain)
            return {};
        if (!domain_)
            return {};
        return normalizeData(types.EIP712Domain, domain_);
    })();
    const message = (() => {
        if (primaryType === 'EIP712Domain')
            return undefined;
        return normalizeData(types[primaryType], message_);
    })();
    return stringify$1({ domain, message, primaryType, types });
}
function validateTypedData(parameters) {
    const { domain, message, primaryType, types } = parameters;
    const validateData = (struct, data) => {
        for (const param of struct) {
            const { name, type } = param;
            const value = data[name];
            const integerMatch = type.match(integerRegex);
            if (integerMatch &&
                (typeof value === 'number' || typeof value === 'bigint')) {
                const [_type, base, size_] = integerMatch;
                // If number cannot be cast to a sized hex value, it is out of range
                // and will throw.
                numberToHex(value, {
                    signed: base === 'int',
                    size: Number.parseInt(size_) / 8,
                });
            }
            if (type === 'address' && typeof value === 'string' && !isAddress(value))
                throw new InvalidAddressError({ address: value });
            const bytesMatch = type.match(bytesRegex);
            if (bytesMatch) {
                const [_type, size_] = bytesMatch;
                if (size_ && size$1(value) !== Number.parseInt(size_))
                    throw new BytesSizeMismatchError({
                        expectedSize: Number.parseInt(size_),
                        givenSize: size$1(value),
                    });
            }
            const struct = types[type];
            if (struct) {
                validateReference(type);
                validateData(struct, value);
            }
        }
    };
    // Validate domain types.
    if (types.EIP712Domain && domain) {
        if (typeof domain !== 'object')
            throw new InvalidDomainError({ domain });
        validateData(types.EIP712Domain, domain);
    }
    // Validate message types.
    if (primaryType !== 'EIP712Domain') {
        if (types[primaryType])
            validateData(types[primaryType], message);
        else
            throw new InvalidPrimaryTypeError({ primaryType, types });
    }
}
function getTypesForEIP712Domain({ domain, }) {
    return [
        typeof domain?.name === 'string' && { name: 'name', type: 'string' },
        domain?.version && { name: 'version', type: 'string' },
        (typeof domain?.chainId === 'number' ||
            typeof domain?.chainId === 'bigint') && {
            name: 'chainId',
            type: 'uint256',
        },
        domain?.verifyingContract && {
            name: 'verifyingContract',
            type: 'address',
        },
        domain?.salt && { name: 'salt', type: 'bytes32' },
    ].filter(Boolean);
}
/** @internal */
function validateReference(type) {
    // Struct type must not be a Solidity type.
    if (type === 'address' ||
        type === 'bool' ||
        type === 'string' ||
        type.startsWith('bytes') ||
        type.startsWith('uint') ||
        type.startsWith('int'))
        throw new InvalidStructTypeError({ type });
}

function encodePacked(types, values) {
    if (types.length !== values.length)
        throw new AbiEncodingLengthMismatchError({
            expectedLength: types.length,
            givenLength: values.length,
        });
    const data = [];
    for (let i = 0; i < types.length; i++) {
        const type = types[i];
        const value = values[i];
        data.push(encode$2(type, value));
    }
    return concatHex(data);
}
function encode$2(type, value, isArray = false) {
    if (type === 'address') {
        const address = value;
        if (!isAddress(address))
            throw new InvalidAddressError({ address });
        return pad$1(address.toLowerCase(), {
            size: isArray ? 32 : null,
        });
    }
    if (type === 'string')
        return stringToHex(value);
    if (type === 'bytes')
        return value;
    if (type === 'bool')
        return pad$1(boolToHex(value), { size: isArray ? 32 : 1 });
    const intMatch = type.match(integerRegex);
    if (intMatch) {
        const [_type, baseType, bits = '256'] = intMatch;
        const size = Number.parseInt(bits) / 8;
        return numberToHex(value, {
            size: isArray ? 32 : size,
            signed: baseType === 'int',
        });
    }
    const bytesMatch = type.match(bytesRegex);
    if (bytesMatch) {
        const [_type, size] = bytesMatch;
        if (Number.parseInt(size) !== (value.length - 2) / 2)
            throw new BytesSizeMismatchError({
                expectedSize: Number.parseInt(size),
                givenSize: (value.length - 2) / 2,
            });
        return pad$1(value, { dir: 'right', size: isArray ? 32 : null });
    }
    const arrayMatch = type.match(arrayRegex);
    if (arrayMatch && Array.isArray(value)) {
        const [_type, childType] = arrayMatch;
        const data = [];
        for (let i = 0; i < value.length; i++) {
            data.push(encode$2(childType, value[i], true));
        }
        if (data.length === 0)
            return '0x';
        return concatHex(data);
    }
    throw new UnsupportedPackedAbiType(type);
}

const receiptStatuses = {
    '0x0': 'reverted',
    '0x1': 'success',
};
function formatTransactionReceipt(transactionReceipt) {
    const receipt = {
        ...transactionReceipt,
        blockNumber: transactionReceipt.blockNumber
            ? BigInt(transactionReceipt.blockNumber)
            : null,
        contractAddress: transactionReceipt.contractAddress
            ? transactionReceipt.contractAddress
            : null,
        cumulativeGasUsed: transactionReceipt.cumulativeGasUsed
            ? BigInt(transactionReceipt.cumulativeGasUsed)
            : null,
        effectiveGasPrice: transactionReceipt.effectiveGasPrice
            ? BigInt(transactionReceipt.effectiveGasPrice)
            : null,
        gasUsed: transactionReceipt.gasUsed
            ? BigInt(transactionReceipt.gasUsed)
            : null,
        logs: transactionReceipt.logs
            ? transactionReceipt.logs.map((log) => formatLog(log))
            : null,
        to: transactionReceipt.to ? transactionReceipt.to : null,
        transactionIndex: transactionReceipt.transactionIndex
            ? hexToNumber$1(transactionReceipt.transactionIndex)
            : null,
        status: transactionReceipt.status
            ? receiptStatuses[transactionReceipt.status]
            : null,
        type: transactionReceipt.type
            ? transactionType[transactionReceipt.type] || transactionReceipt.type
            : null,
    };
    if (transactionReceipt.blobGasPrice)
        receipt.blobGasPrice = BigInt(transactionReceipt.blobGasPrice);
    if (transactionReceipt.blobGasUsed)
        receipt.blobGasUsed = BigInt(transactionReceipt.blobGasUsed);
    return receipt;
}
const defineTransactionReceipt = /*#__PURE__*/ defineFormatter('transactionReceipt', formatTransactionReceipt);

const presignMessagePrefix = '\x19Ethereum Signed Message:\n';

function toPrefixedMessage(message_) {
    const message = (() => {
        if (typeof message_ === 'string')
            return stringToHex(message_);
        if (typeof message_.raw === 'string')
            return message_.raw;
        return bytesToHex$2(message_.raw);
    })();
    const prefix = stringToHex(`${presignMessagePrefix}${size$1(message)}`);
    return concat$1([prefix, message]);
}

function hashMessage(message, to_) {
    return keccak256(toPrefixedMessage(message), to_);
}

const erc6492MagicBytes = '0x6492649264926492649264926492649264926492649264926492649264926492';

/** Whether or not the signature is an ERC-6492 formatted signature. */
function isErc6492Signature(signature) {
    return sliceHex(signature, -32) === erc6492MagicBytes;
}

/**
 * @description Serializes a ERC-6492 flavoured signature into hex format.
 *
 * @param signature ERC-6492 signature in object format.
 * @returns ERC-6492 signature in hex format.
 *
 * @example
 * serializeSignature({ address: '0x...', data: '0x...', signature: '0x...' })
 * // '0x000000000000000000000000cafebabecafebabecafebabecafebabecafebabe000000000000000000000000000000000000000000000000000000000000006000000000000000000000000000000000000000000000000000000000000000a00000000000000000000000000000000000000000000000000000000000000004deadbeef000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000041a461f509887bd19e312c0c58467ce8ff8e300d3c1a90b608a760c5b80318eaf15fe57c96f9175d6cd4daad4663763baa7e78836e067d0163e9a2ccf2ff753f5b1b000000000000000000000000000000000000000000000000000000000000006492649264926492649264926492649264926492649264926492649264926492'
 */
function serializeErc6492Signature(parameters) {
    const { address, data, signature, to = 'hex' } = parameters;
    const signature_ = concatHex([
        encodeAbiParameters([{ type: 'address' }, { type: 'bytes' }, { type: 'bytes' }], [address, data, signature]),
        erc6492MagicBytes,
    ]);
    if (to === 'hex')
        return signature_;
    return hexToBytes$1(signature_);
}

function assertTransactionEIP7702(transaction) {
    const { authorizationList } = transaction;
    if (authorizationList) {
        for (const authorization of authorizationList) {
            const { contractAddress, chainId } = authorization;
            if (!isAddress(contractAddress))
                throw new InvalidAddressError({ address: contractAddress });
            if (chainId < 0)
                throw new InvalidChainIdError({ chainId });
        }
    }
    assertTransactionEIP1559(transaction);
}
function assertTransactionEIP4844(transaction) {
    const { blobVersionedHashes } = transaction;
    if (blobVersionedHashes) {
        if (blobVersionedHashes.length === 0)
            throw new EmptyBlobError();
        for (const hash of blobVersionedHashes) {
            const size_ = size$1(hash);
            const version = hexToNumber$1(slice(hash, 0, 1));
            if (size_ !== 32)
                throw new InvalidVersionedHashSizeError({ hash, size: size_ });
            if (version !== versionedHashVersionKzg)
                throw new InvalidVersionedHashVersionError({
                    hash,
                    version,
                });
        }
    }
    assertTransactionEIP1559(transaction);
}
function assertTransactionEIP1559(transaction) {
    const { chainId, maxPriorityFeePerGas, maxFeePerGas, to } = transaction;
    if (chainId <= 0)
        throw new InvalidChainIdError({ chainId });
    if (to && !isAddress(to))
        throw new InvalidAddressError({ address: to });
    if (maxFeePerGas && maxFeePerGas > maxUint256)
        throw new FeeCapTooHighError({ maxFeePerGas });
    if (maxPriorityFeePerGas &&
        maxFeePerGas &&
        maxPriorityFeePerGas > maxFeePerGas)
        throw new TipAboveFeeCapError({ maxFeePerGas, maxPriorityFeePerGas });
}
function assertTransactionEIP2930(transaction) {
    const { chainId, maxPriorityFeePerGas, gasPrice, maxFeePerGas, to } = transaction;
    if (chainId <= 0)
        throw new InvalidChainIdError({ chainId });
    if (to && !isAddress(to))
        throw new InvalidAddressError({ address: to });
    if (maxPriorityFeePerGas || maxFeePerGas)
        throw new BaseError$1('`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.');
    if (gasPrice && gasPrice > maxUint256)
        throw new FeeCapTooHighError({ maxFeePerGas: gasPrice });
}
function assertTransactionLegacy(transaction) {
    const { chainId, maxPriorityFeePerGas, gasPrice, maxFeePerGas, to } = transaction;
    if (to && !isAddress(to))
        throw new InvalidAddressError({ address: to });
    if (typeof chainId !== 'undefined' && chainId <= 0)
        throw new InvalidChainIdError({ chainId });
    if (maxPriorityFeePerGas || maxFeePerGas)
        throw new BaseError$1('`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.');
    if (gasPrice && gasPrice > maxUint256)
        throw new FeeCapTooHighError({ maxFeePerGas: gasPrice });
}

/*
 * Serializes an EIP-7702 authorization list.
 */
function serializeAuthorizationList(authorizationList) {
    if (!authorizationList || authorizationList.length === 0)
        return [];
    const serializedAuthorizationList = [];
    for (const authorization of authorizationList) {
        const { contractAddress, chainId, nonce, ...signature } = authorization;
        serializedAuthorizationList.push([
            chainId ? toHex(chainId) : '0x',
            contractAddress,
            nonce ? toHex(nonce) : '0x',
            ...toYParitySignatureArray({}, signature),
        ]);
    }
    return serializedAuthorizationList;
}

/*
 * Serialize an  EIP-2930 access list
 * @remarks
 * Use to create a transaction serializer with support for EIP-2930 access lists
 *
 * @param accessList - Array of objects of address and arrays of Storage Keys
 * @throws InvalidAddressError, InvalidStorageKeySizeError
 * @returns Array of hex strings
 */
function serializeAccessList(accessList) {
    if (!accessList || accessList.length === 0)
        return [];
    const serializedAccessList = [];
    for (let i = 0; i < accessList.length; i++) {
        const { address, storageKeys } = accessList[i];
        for (let j = 0; j < storageKeys.length; j++) {
            if (storageKeys[j].length - 2 !== 64) {
                throw new InvalidStorageKeySizeError({ storageKey: storageKeys[j] });
            }
        }
        if (!isAddress(address, { strict: false })) {
            throw new InvalidAddressError({ address });
        }
        serializedAccessList.push([address, storageKeys]);
    }
    return serializedAccessList;
}

function serializeTransaction$3(transaction, signature) {
    const type = getTransactionType(transaction);
    if (type === 'eip1559')
        return serializeTransactionEIP1559(transaction, signature);
    if (type === 'eip2930')
        return serializeTransactionEIP2930(transaction, signature);
    if (type === 'eip4844')
        return serializeTransactionEIP4844(transaction, signature);
    if (type === 'eip7702')
        return serializeTransactionEIP7702(transaction, signature);
    return serializeTransactionLegacy(transaction, signature);
}
function serializeTransactionEIP7702(transaction, signature) {
    const { authorizationList, chainId, gas, nonce, to, value, maxFeePerGas, maxPriorityFeePerGas, accessList, data, } = transaction;
    assertTransactionEIP7702(transaction);
    const serializedAccessList = serializeAccessList(accessList);
    const serializedAuthorizationList = serializeAuthorizationList(authorizationList);
    return concatHex([
        '0x04',
        toRlp([
            toHex(chainId),
            nonce ? toHex(nonce) : '0x',
            maxPriorityFeePerGas ? toHex(maxPriorityFeePerGas) : '0x',
            maxFeePerGas ? toHex(maxFeePerGas) : '0x',
            gas ? toHex(gas) : '0x',
            to ?? '0x',
            value ? toHex(value) : '0x',
            data ?? '0x',
            serializedAccessList,
            serializedAuthorizationList,
            ...toYParitySignatureArray(transaction, signature),
        ]),
    ]);
}
function serializeTransactionEIP4844(transaction, signature) {
    const { chainId, gas, nonce, to, value, maxFeePerBlobGas, maxFeePerGas, maxPriorityFeePerGas, accessList, data, } = transaction;
    assertTransactionEIP4844(transaction);
    let blobVersionedHashes = transaction.blobVersionedHashes;
    let sidecars = transaction.sidecars;
    // If `blobs` are passed, we will need to compute the KZG commitments & proofs.
    if (transaction.blobs &&
        (typeof blobVersionedHashes === 'undefined' ||
            typeof sidecars === 'undefined')) {
        const blobs = (typeof transaction.blobs[0] === 'string'
            ? transaction.blobs
            : transaction.blobs.map((x) => bytesToHex$2(x)));
        const kzg = transaction.kzg;
        const commitments = blobsToCommitments({
            blobs,
            kzg,
        });
        if (typeof blobVersionedHashes === 'undefined')
            blobVersionedHashes = commitmentsToVersionedHashes({
                commitments,
            });
        if (typeof sidecars === 'undefined') {
            const proofs = blobsToProofs({ blobs, commitments, kzg });
            sidecars = toBlobSidecars({ blobs, commitments, proofs });
        }
    }
    const serializedAccessList = serializeAccessList(accessList);
    const serializedTransaction = [
        toHex(chainId),
        nonce ? toHex(nonce) : '0x',
        maxPriorityFeePerGas ? toHex(maxPriorityFeePerGas) : '0x',
        maxFeePerGas ? toHex(maxFeePerGas) : '0x',
        gas ? toHex(gas) : '0x',
        to ?? '0x',
        value ? toHex(value) : '0x',
        data ?? '0x',
        serializedAccessList,
        maxFeePerBlobGas ? toHex(maxFeePerBlobGas) : '0x',
        blobVersionedHashes ?? [],
        ...toYParitySignatureArray(transaction, signature),
    ];
    const blobs = [];
    const commitments = [];
    const proofs = [];
    if (sidecars)
        for (let i = 0; i < sidecars.length; i++) {
            const { blob, commitment, proof } = sidecars[i];
            blobs.push(blob);
            commitments.push(commitment);
            proofs.push(proof);
        }
    return concatHex([
        '0x03',
        sidecars
            ? // If sidecars are enabled, envelope turns into a "wrapper":
                toRlp([serializedTransaction, blobs, commitments, proofs])
            : // If sidecars are disabled, standard envelope is used:
                toRlp(serializedTransaction),
    ]);
}
function serializeTransactionEIP1559(transaction, signature) {
    const { chainId, gas, nonce, to, value, maxFeePerGas, maxPriorityFeePerGas, accessList, data, } = transaction;
    assertTransactionEIP1559(transaction);
    const serializedAccessList = serializeAccessList(accessList);
    const serializedTransaction = [
        toHex(chainId),
        nonce ? toHex(nonce) : '0x',
        maxPriorityFeePerGas ? toHex(maxPriorityFeePerGas) : '0x',
        maxFeePerGas ? toHex(maxFeePerGas) : '0x',
        gas ? toHex(gas) : '0x',
        to ?? '0x',
        value ? toHex(value) : '0x',
        data ?? '0x',
        serializedAccessList,
        ...toYParitySignatureArray(transaction, signature),
    ];
    return concatHex([
        '0x02',
        toRlp(serializedTransaction),
    ]);
}
function serializeTransactionEIP2930(transaction, signature) {
    const { chainId, gas, data, nonce, to, value, accessList, gasPrice } = transaction;
    assertTransactionEIP2930(transaction);
    const serializedAccessList = serializeAccessList(accessList);
    const serializedTransaction = [
        toHex(chainId),
        nonce ? toHex(nonce) : '0x',
        gasPrice ? toHex(gasPrice) : '0x',
        gas ? toHex(gas) : '0x',
        to ?? '0x',
        value ? toHex(value) : '0x',
        data ?? '0x',
        serializedAccessList,
        ...toYParitySignatureArray(transaction, signature),
    ];
    return concatHex([
        '0x01',
        toRlp(serializedTransaction),
    ]);
}
function serializeTransactionLegacy(transaction, signature) {
    const { chainId = 0, gas, data, nonce, to, value, gasPrice } = transaction;
    assertTransactionLegacy(transaction);
    let serializedTransaction = [
        nonce ? toHex(nonce) : '0x',
        gasPrice ? toHex(gasPrice) : '0x',
        gas ? toHex(gas) : '0x',
        to ?? '0x',
        value ? toHex(value) : '0x',
        data ?? '0x',
    ];
    if (signature) {
        const v = (() => {
            // EIP-155 (inferred chainId)
            if (signature.v >= 35n) {
                const inferredChainId = (signature.v - 35n) / 2n;
                if (inferredChainId > 0)
                    return signature.v;
                return 27n + (signature.v === 35n ? 0n : 1n);
            }
            // EIP-155 (explicit chainId)
            if (chainId > 0)
                return BigInt(chainId * 2) + BigInt(35n + signature.v - 27n);
            // Pre-EIP-155 (no chainId)
            const v = 27n + (signature.v === 27n ? 0n : 1n);
            if (signature.v !== v)
                throw new InvalidLegacyVError({ v: signature.v });
            return v;
        })();
        const r = trim$1(signature.r);
        const s = trim$1(signature.s);
        serializedTransaction = [
            ...serializedTransaction,
            toHex(v),
            r === '0x00' ? '0x' : r,
            s === '0x00' ? '0x' : s,
        ];
    }
    else if (chainId > 0) {
        serializedTransaction = [
            ...serializedTransaction,
            toHex(chainId),
            '0x',
            '0x',
        ];
    }
    return toRlp(serializedTransaction);
}
function toYParitySignatureArray(transaction, signature_) {
    const signature = signature_ ?? transaction;
    const { v, yParity } = signature;
    if (typeof signature.r === 'undefined')
        return [];
    if (typeof signature.s === 'undefined')
        return [];
    if (typeof v === 'undefined' && typeof yParity === 'undefined')
        return [];
    const r = trim$1(signature.r);
    const s = trim$1(signature.s);
    const yParity_ = (() => {
        if (typeof yParity === 'number')
            return yParity ? toHex(1) : '0x';
        if (v === 0n)
            return '0x';
        if (v === 1n)
            return toHex(1);
        return v === 27n ? '0x' : toHex(1);
    })();
    return [yParity_, r === '0x00' ? '0x' : r, s === '0x00' ? '0x' : s];
}

class InvalidDecimalNumberError extends BaseError$1 {
    constructor({ value }) {
        super(`Number \`${value}\` is not a valid decimal number.`, {
            name: 'InvalidDecimalNumberError',
        });
    }
}

/**
 * Multiplies a string representation of a number by a given exponent of base 10 (10exponent).
 *
 * - Docs: https://viem.sh/docs/utilities/parseUnits
 *
 * @example
 * import { parseUnits } from 'viem'
 *
 * parseUnits('420', 9)
 * // 420000000000n
 */
function parseUnits(value, decimals) {
    if (!/^(-?)([0-9]*)\.?([0-9]*)$/.test(value))
        throw new InvalidDecimalNumberError({ value });
    let [integer, fraction = '0'] = value.split('.');
    const negative = integer.startsWith('-');
    if (negative)
        integer = integer.slice(1);
    // trim trailing zeros.
    fraction = fraction.replace(/(0+)$/, '');
    // round off if the fraction is larger than the number of decimals.
    if (decimals === 0) {
        if (Math.round(Number(`.${fraction}`)) === 1)
            integer = `${BigInt(integer) + 1n}`;
        fraction = '';
    }
    else if (fraction.length > decimals) {
        const [left, unit, right] = [
            fraction.slice(0, decimals - 1),
            fraction.slice(decimals - 1, decimals),
            fraction.slice(decimals),
        ];
        const rounded = Math.round(Number(`${unit}.${right}`));
        if (rounded > 9)
            fraction = `${BigInt(left) + BigInt(1)}0`.padStart(left.length + 1, '0');
        else
            fraction = `${left}${rounded}`;
        if (fraction.length > decimals) {
            fraction = fraction.slice(1);
            integer = `${BigInt(integer) + 1n}`;
        }
        fraction = fraction.slice(0, decimals);
    }
    else {
        fraction = fraction.padEnd(decimals, '0');
    }
    return BigInt(`${negative ? '-' : ''}${integer}${fraction}`);
}

/**
 * Converts a string representation of ether to numerical wei.
 *
 * - Docs: https://viem.sh/docs/utilities/parseEther
 *
 * @example
 * import { parseEther } from 'viem'
 *
 * parseEther('420')
 * // 420000000000000000000n
 */
function parseEther$1(ether, unit = 'wei') {
    return parseUnits(ether, etherUnits[unit]);
}

function formatStorageProof(storageProof) {
    return storageProof.map((proof) => ({
        ...proof,
        value: BigInt(proof.value),
    }));
}
function formatProof(proof) {
    return {
        ...proof,
        balance: proof.balance ? BigInt(proof.balance) : undefined,
        nonce: proof.nonce ? hexToNumber$1(proof.nonce) : undefined,
        storageProof: proof.storageProof
            ? formatStorageProof(proof.storageProof)
            : undefined,
    };
}

/**
 * Returns the account and storage values of the specified account including the Merkle-proof.
 *
 * - Docs: https://viem.sh/docs/actions/public/getProof
 * - JSON-RPC Methods:
 *   - Calls [`eth_getProof`](https://eips.ethereum.org/EIPS/eip-1186)
 *
 * @param client - Client to use
 * @param parameters - {@link GetProofParameters}
 * @returns Proof data. {@link GetProofReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getProof } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const block = await getProof(client, {
 *  address: '0x...',
 *  storageKeys: ['0x...'],
 * })
 */
async function getProof(client, { address, blockNumber, blockTag: blockTag_, storageKeys, }) {
    const blockTag = blockTag_ ?? 'latest';
    const blockNumberHex = blockNumber !== undefined ? numberToHex(blockNumber) : undefined;
    const proof = await client.request({
        method: 'eth_getProof',
        params: [address, storageKeys, blockNumberHex || blockTag],
    });
    return formatProof(proof);
}

/**
 * Returns the value from a storage slot at a given address.
 *
 * - Docs: https://viem.sh/docs/contract/getStorageAt
 * - JSON-RPC Methods: [`eth_getStorageAt`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getstorageat)
 *
 * @param client - Client to use
 * @param parameters - {@link GetStorageAtParameters}
 * @returns The value of the storage slot. {@link GetStorageAtReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getStorageAt } from 'viem/contract'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const code = await getStorageAt(client, {
 *   address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
 *   slot: toHex(0),
 * })
 */
async function getStorageAt(client, { address, blockNumber, blockTag = 'latest', slot }) {
    const blockNumberHex = blockNumber !== undefined ? numberToHex(blockNumber) : undefined;
    const data = await client.request({
        method: 'eth_getStorageAt',
        params: [address, slot, blockNumberHex || blockTag],
    });
    return data;
}

/**
 * Returns information about a [Transaction](https://viem.sh/docs/glossary/terms#transaction) given a hash or block identifier.
 *
 * - Docs: https://viem.sh/docs/actions/public/getTransaction
 * - Example: https://stackblitz.com/github/wevm/viem/tree/main/examples/transactions_fetching-transactions
 * - JSON-RPC Methods: [`eth_getTransactionByHash`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getTransactionByHash)
 *
 * @param client - Client to use
 * @param parameters - {@link GetTransactionParameters}
 * @returns The transaction information. {@link GetTransactionReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getTransaction } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const transaction = await getTransaction(client, {
 *   hash: '0x4ca7ee652d57678f26e887c149ab0735f41de37bcad58c9f6d3ed5824f15b74d',
 * })
 */
async function getTransaction(client, { blockHash, blockNumber, blockTag: blockTag_, hash, index, }) {
    const blockTag = blockTag_ || 'latest';
    const blockNumberHex = blockNumber !== undefined ? numberToHex(blockNumber) : undefined;
    let transaction = null;
    if (hash) {
        transaction = await client.request({
            method: 'eth_getTransactionByHash',
            params: [hash],
        }, { dedupe: true });
    }
    else if (blockHash) {
        transaction = await client.request({
            method: 'eth_getTransactionByBlockHashAndIndex',
            params: [blockHash, numberToHex(index)],
        }, { dedupe: true });
    }
    else {
        transaction = await client.request({
            method: 'eth_getTransactionByBlockNumberAndIndex',
            params: [blockNumberHex || blockTag, numberToHex(index)],
        }, { dedupe: Boolean(blockNumberHex) });
    }
    if (!transaction)
        throw new TransactionNotFoundError({
            blockHash,
            blockNumber,
            blockTag,
            hash,
            index,
        });
    const format = client.chain?.formatters?.transaction?.format || formatTransaction;
    return format(transaction);
}

/**
 * Returns the number of blocks passed (confirmations) since the transaction was processed on a block.
 *
 * - Docs: https://viem.sh/docs/actions/public/getTransactionConfirmations
 * - Example: https://stackblitz.com/github/wevm/viem/tree/main/examples/transactions_fetching-transactions
 * - JSON-RPC Methods: [`eth_getTransactionConfirmations`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getTransactionConfirmations)
 *
 * @param client - Client to use
 * @param parameters - {@link GetTransactionConfirmationsParameters}
 * @returns The number of blocks passed since the transaction was processed. If confirmations is 0, then the Transaction has not been confirmed & processed yet. {@link GetTransactionConfirmationsReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getTransactionConfirmations } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const confirmations = await getTransactionConfirmations(client, {
 *   hash: '0x4ca7ee652d57678f26e887c149ab0735f41de37bcad58c9f6d3ed5824f15b74d',
 * })
 */
async function getTransactionConfirmations(client, { hash, transactionReceipt }) {
    const [blockNumber, transaction] = await Promise.all([
        getAction(client, getBlockNumber, 'getBlockNumber')({}),
        hash
            ? getAction(client, getTransaction, 'getTransaction')({ hash })
            : undefined,
    ]);
    const transactionBlockNumber = transactionReceipt?.blockNumber || transaction?.blockNumber;
    if (!transactionBlockNumber)
        return 0n;
    return blockNumber - transactionBlockNumber + 1n;
}

/**
 * Returns the [Transaction Receipt](https://viem.sh/docs/glossary/terms#transaction-receipt) given a [Transaction](https://viem.sh/docs/glossary/terms#transaction) hash.
 *
 * - Docs: https://viem.sh/docs/actions/public/getTransactionReceipt
 * - Example: https://stackblitz.com/github/wevm/viem/tree/main/examples/transactions_fetching-transactions
 * - JSON-RPC Methods: [`eth_getTransactionReceipt`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gettransactionreceipt)
 *
 * @param client - Client to use
 * @param parameters - {@link GetTransactionReceiptParameters}
 * @returns The transaction receipt. {@link GetTransactionReceiptReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getTransactionReceipt } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const transactionReceipt = await getTransactionReceipt(client, {
 *   hash: '0x4ca7ee652d57678f26e887c149ab0735f41de37bcad58c9f6d3ed5824f15b74d',
 * })
 */
async function getTransactionReceipt(client, { hash }) {
    const receipt = await client.request({
        method: 'eth_getTransactionReceipt',
        params: [hash],
    }, { dedupe: true });
    if (!receipt)
        throw new TransactionReceiptNotFoundError({ hash });
    const format = client.chain?.formatters?.transactionReceipt?.format ||
        formatTransactionReceipt;
    return format(receipt);
}

/**
 * Similar to [`readContract`](https://viem.sh/docs/contract/readContract), but batches up multiple functions on a contract in a single RPC call via the [`multicall3` contract](https://github.com/mds1/multicall).
 *
 * - Docs: https://viem.sh/docs/contract/multicall
 *
 * @param client - Client to use
 * @param parameters - {@link MulticallParameters}
 * @returns An array of results with accompanying status. {@link MulticallReturnType}
 *
 * @example
 * import { createPublicClient, http, parseAbi } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { multicall } from 'viem/contract'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const abi = parseAbi([
 *   'function balanceOf(address) view returns (uint256)',
 *   'function totalSupply() view returns (uint256)',
 * ])
 * const results = await multicall(client, {
 *   contracts: [
 *     {
 *       address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
 *       abi,
 *       functionName: 'balanceOf',
 *       args: ['0xA0Cf798816D4b9b9866b5330EEa46a18382f251e'],
 *     },
 *     {
 *       address: '0xFBA3912Ca04dd458c843e2EE08967fC04f3579c2',
 *       abi,
 *       functionName: 'totalSupply',
 *     },
 *   ],
 * })
 * // [{ result: 424122n, status: 'success' }, { result: 1000000n, status: 'success' }]
 */
async function multicall(client, parameters) {
    const { allowFailure = true, batchSize: batchSize_, blockNumber, blockTag, multicallAddress: multicallAddress_, stateOverride, } = parameters;
    const contracts = parameters.contracts;
    const batchSize = batchSize_ ??
        ((typeof client.batch?.multicall === 'object' &&
            client.batch.multicall.batchSize) ||
            1_024);
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain)
            throw new Error('client chain not configured. multicallAddress is required.');
        multicallAddress = getChainContractAddress({
            blockNumber,
            chain: client.chain,
            contract: 'multicall3',
        });
    }
    const chunkedCalls = [[]];
    let currentChunk = 0;
    let currentChunkSize = 0;
    for (let i = 0; i < contracts.length; i++) {
        const { abi, address, args, functionName } = contracts[i];
        try {
            const callData = encodeFunctionData({ abi, args, functionName });
            currentChunkSize += (callData.length - 2) / 2;
            // Check to see if we need to create a new chunk.
            if (
            // Check if batching is enabled.
            batchSize > 0 &&
                // Check if the current size of the batch exceeds the size limit.
                currentChunkSize > batchSize &&
                // Check if the current chunk is not already empty.
                chunkedCalls[currentChunk].length > 0) {
                currentChunk++;
                currentChunkSize = (callData.length - 2) / 2;
                chunkedCalls[currentChunk] = [];
            }
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData,
                    target: address,
                },
            ];
        }
        catch (err) {
            const error = getContractError(err, {
                abi,
                address,
                args,
                docsPath: '/docs/contract/multicall',
                functionName,
            });
            if (!allowFailure)
                throw error;
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: '0x',
                    target: address,
                },
            ];
        }
    }
    const aggregate3Results = await Promise.allSettled(chunkedCalls.map((calls) => getAction(client, readContract, 'readContract')({
        abi: multicall3Abi,
        address: multicallAddress,
        args: [calls],
        blockNumber,
        blockTag,
        functionName: 'aggregate3',
        stateOverride,
    })));
    const results = [];
    for (let i = 0; i < aggregate3Results.length; i++) {
        const result = aggregate3Results[i];
        // If an error occurred in a `readContract` invocation (ie. network error),
        // then append the failure reason to each contract result.
        if (result.status === 'rejected') {
            if (!allowFailure)
                throw result.reason;
            for (let j = 0; j < chunkedCalls[i].length; j++) {
                results.push({
                    status: 'failure',
                    error: result.reason,
                    result: undefined,
                });
            }
            continue;
        }
        // If the `readContract` call was successful, then decode the results.
        const aggregate3Result = result.value;
        for (let j = 0; j < aggregate3Result.length; j++) {
            // Extract the response from `readContract`
            const { returnData, success } = aggregate3Result[j];
            // Extract the request call data from the original call.
            const { callData } = chunkedCalls[i][j];
            // Extract the contract config for this call from the `contracts` argument
            // for decoding.
            const { abi, address, functionName, args } = contracts[results.length];
            try {
                if (callData === '0x')
                    throw new AbiDecodingZeroDataError();
                if (!success)
                    throw new RawContractError({ data: returnData });
                const result = decodeFunctionResult({
                    abi,
                    args,
                    data: returnData,
                    functionName,
                });
                results.push(allowFailure ? { result, status: 'success' } : result);
            }
            catch (err) {
                const error = getContractError(err, {
                    abi,
                    address,
                    args,
                    docsPath: '/docs/contract/multicall',
                    functionName,
                });
                if (!allowFailure)
                    throw error;
                results.push({ error, result: undefined, status: 'failure' });
            }
        }
    }
    if (results.length !== contracts.length)
        throw new BaseError$1('multicall results mismatch');
    return results;
}

/**
 * Hex, bytes and number utilities.
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const _0n$3 = /* @__PURE__ */ BigInt(0);
const _1n$4 = /* @__PURE__ */ BigInt(1);
const _2n$2 = /* @__PURE__ */ BigInt(2);
function isBytes(a) {
    return a instanceof Uint8Array || (ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array');
}
function abytes(item) {
    if (!isBytes(item))
        throw new Error('Uint8Array expected');
}
function abool(title, value) {
    if (typeof value !== 'boolean')
        throw new Error(title + ' boolean expected, got ' + value);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({ length: 256 }, (_, i) => i.toString(16).padStart(2, '0'));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */
function bytesToHex(bytes) {
    abytes(bytes);
    // pre-caching improves the speed 6x
    let hex = '';
    for (let i = 0; i < bytes.length; i++) {
        hex += hexes[bytes[i]];
    }
    return hex;
}
function numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? '0' + hex : hex;
}
function hexToNumber(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    return hex === '' ? _0n$3 : BigInt('0x' + hex); // Big Endian
}
// We use optimized technique to convert hex string to byte array
const asciis = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function asciiToBase16(ch) {
    if (ch >= asciis._0 && ch <= asciis._9)
        return ch - asciis._0; // '2' => 50-48
    if (ch >= asciis.A && ch <= asciis.F)
        return ch - (asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= asciis.a && ch <= asciis.f)
        return ch - (asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */
function hexToBytes(hex) {
    if (typeof hex !== 'string')
        throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2)
        throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for (let ai = 0, hi = 0; ai < al; ai++, hi += 2) {
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
// BE: Big Endian, LE: Little Endian
function bytesToNumberBE(bytes) {
    return hexToNumber(bytesToHex(bytes));
}
function bytesToNumberLE(bytes) {
    abytes(bytes);
    return hexToNumber(bytesToHex(Uint8Array.from(bytes).reverse()));
}
function numberToBytesBE(n, len) {
    return hexToBytes(n.toString(16).padStart(len * 2, '0'));
}
function numberToBytesLE(n, len) {
    return numberToBytesBE(n, len).reverse();
}
// Unpadded, rarely used
function numberToVarBytesBE(n) {
    return hexToBytes(numberToHexUnpadded(n));
}
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */
function ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === 'string') {
        try {
            res = hexToBytes(hex);
        }
        catch (e) {
            throw new Error(title + ' must be hex string or Uint8Array, cause: ' + e);
        }
    }
    else if (isBytes(hex)) {
        // Uint8Array.from() instead of hash.slice() because node.js Buffer
        // is instance of Uint8Array, and its slice() creates **mutable** copy
        res = Uint8Array.from(hex);
    }
    else {
        throw new Error(title + ' must be hex string or Uint8Array');
    }
    const len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength)
        throw new Error(title + ' of length ' + expectedLength + ' expected, got ' + len);
    return res;
}
/**
 * Copies several Uint8Arrays into one.
 */
function concatBytes(...arrays) {
    let sum = 0;
    for (let i = 0; i < arrays.length; i++) {
        const a = arrays[i];
        abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for (let i = 0, pad = 0; i < arrays.length; i++) {
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
// Compares 2 u8a-s in kinda constant time
function equalBytes(a, b) {
    if (a.length !== b.length)
        return false;
    let diff = 0;
    for (let i = 0; i < a.length; i++)
        diff |= a[i] ^ b[i];
    return diff === 0;
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */
function utf8ToBytes(str) {
    if (typeof str !== 'string')
        throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
const isPosBig = (n) => typeof n === 'bigint' && _0n$3 <= n;
function inRange(n, min, max) {
    return isPosBig(n) && isPosBig(min) && isPosBig(max) && min <= n && n < max;
}
/**
 * Asserts min <= n < max. NOTE: It's < max and not <= max.
 * @example
 * aInRange('x', x, 1n, 256n); // would assume x is in (1n..255n)
 */
function aInRange(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!inRange(n, min, max))
        throw new Error('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */
function bitLen(n) {
    let len;
    for (len = 0; n > _0n$3; n >>= _1n$4, len += 1)
        ;
    return len;
}
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */
function bitGet(n, pos) {
    return (n >> BigInt(pos)) & _1n$4;
}
/**
 * Sets single bit at position.
 */
function bitSet(n, pos, value) {
    return n | ((value ? _1n$4 : _0n$3) << BigInt(pos));
}
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */
const bitMask = (n) => (_2n$2 << BigInt(n - 1)) - _1n$4;
// DRBG
const u8n = (data) => new Uint8Array(data); // creates Uint8Array
const u8fr = (arr) => Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */
function createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2)
        throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2)
        throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function')
        throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = () => {
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b) => hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = u8n()) => {
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8fr([0x00]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0)
            return;
        k = h(u8fr([0x01]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = () => {
        // HMAC-DRBG generate() function
        if (i++ >= 1000)
            throw new Error('drbg: tried 1000 values');
        let len = 0;
        const out = [];
        while (len < qByteLen) {
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return concatBytes(...out);
    };
    const genUntil = (seed, pred) => {
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while (!(res = pred(gen())))
            reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const validatorFns = {
    bigint: (val) => typeof val === 'bigint',
    function: (val) => typeof val === 'function',
    boolean: (val) => typeof val === 'boolean',
    string: (val) => typeof val === 'string',
    stringOrUint8Array: (val) => typeof val === 'string' || isBytes(val),
    isSafeInteger: (val) => Number.isSafeInteger(val),
    array: (val) => Array.isArray(val),
    field: (val, object) => object.Fp.isValid(val),
    hash: (val) => typeof val === 'function' && Number.isSafeInteger(val.outputLen),
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional) => {
        const checkVal = validatorFns[type];
        if (typeof checkVal !== 'function')
            throw new Error('invalid validator function');
        const val = object[fieldName];
        if (isOptional && val === undefined)
            return;
        if (!checkVal(val, object)) {
            throw new Error('param ' + String(fieldName) + ' is invalid. Expected ' + type + ', got ' + val);
        }
    };
    for (const [fieldName, type] of Object.entries(validators))
        checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))
        checkField(fieldName, type, true);
    return object;
}
// validate type tests
// const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
// const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
// // Should fail type-check
// const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
// const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
// const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
// const z4 = validateObject(o, { a: 'boolean', z: 'bug' });
/**
 * throws not implemented error
 */
const notImplemented = () => {
    throw new Error('not implemented');
};
/**
 * Memoizes (caches) computation result.
 * Uses WeakMap: the value is going auto-cleaned by GC after last reference is removed.
 */
function memoized(fn) {
    const map = new WeakMap();
    return (arg, ...args) => {
        const val = map.get(arg);
        if (val !== undefined)
            return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

var ut$3 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	aInRange: aInRange,
	abool: abool,
	abytes: abytes,
	bitGet: bitGet,
	bitLen: bitLen,
	bitMask: bitMask,
	bitSet: bitSet,
	bytesToHex: bytesToHex,
	bytesToNumberBE: bytesToNumberBE,
	bytesToNumberLE: bytesToNumberLE,
	concatBytes: concatBytes,
	createHmacDrbg: createHmacDrbg,
	ensureBytes: ensureBytes,
	equalBytes: equalBytes,
	hexToBytes: hexToBytes,
	hexToNumber: hexToNumber,
	inRange: inRange,
	isBytes: isBytes,
	memoized: memoized,
	notImplemented: notImplemented,
	numberToBytesBE: numberToBytesBE,
	numberToBytesLE: numberToBytesLE,
	numberToHexUnpadded: numberToHexUnpadded,
	numberToVarBytesBE: numberToVarBytesBE,
	utf8ToBytes: utf8ToBytes,
	validateObject: validateObject
});

/** @internal */
const version$e = '0.1.1';

/** @internal */
function getVersion() {
    return version$e;
}

/**
 * Base error class inherited by all errors thrown by ox.
 *
 * @example
 * ```ts
 * import { Errors } from 'ox'
 * throw new Errors.BaseError('An error occurred')
 * ```
 */
class BaseError extends Error {
    constructor(shortMessage, options = {}) {
        const details = (() => {
            if (options.cause instanceof BaseError) {
                if (options.cause.details)
                    return options.cause.details;
                if (options.cause.shortMessage)
                    return options.cause.shortMessage;
            }
            if (options.cause?.message)
                return options.cause.message;
            return options.details;
        })();
        const docsPath = (() => {
            if (options.cause instanceof BaseError)
                return options.cause.docsPath || options.docsPath;
            return options.docsPath;
        })();
        const docsBaseUrl = 'https://oxlib.sh';
        const docs = `${docsBaseUrl}${docsPath ?? ''}`;
        const message = [
            shortMessage || 'An error occurred.',
            ...(options.metaMessages ? ['', ...options.metaMessages] : []),
            ...(details || docsPath
                ? [
                    '',
                    details ? `Details: ${details}` : undefined,
                    docsPath ? `See: ${docs}` : undefined,
                ]
                : []),
        ]
            .filter((x) => typeof x === 'string')
            .join('\n');
        super(message, options.cause ? { cause: options.cause } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'BaseError'
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: `ox@${getVersion()}`
        });
        this.cause = options.cause;
        this.details = details;
        this.docs = docs;
        this.docsPath = docsPath;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return walk(this, fn);
    }
}
/** @internal */
function walk(err, fn) {
    if (fn?.(err))
        return err;
    if (err && typeof err === 'object' && 'cause' in err && err.cause)
        return walk(err.cause, fn);
    return fn ? null : err;
}

/** @internal */
function pad(hex_, options = {}) {
    const { dir, size = 32 } = options;
    if (size === 0)
        return hex_;
    const hex = hex_.replace('0x', '');
    if (hex.length > size * 2)
        throw new SizeExceedsPaddingSizeError({
            size: Math.ceil(hex.length / 2),
            targetSize: size,
            type: 'Hex',
        });
    return `0x${hex[dir === 'right' ? 'padEnd' : 'padStart'](size * 2, '0')}`;
}

/**
 * Encodes a number or bigint into a {@link ox#Hex.Hex} value.
 *
 * @example
 * ```ts twoslash
 * import { Hex } from 'ox'
 *
 * Hex.fromNumber(420)
 * // @log: '0x1a4'
 *
 * Hex.fromNumber(420, { size: 32 })
 * // @log: '0x00000000000000000000000000000000000000000000000000000000000001a4'
 * ```
 *
 * @param value - The number or bigint value to encode.
 * @param options - Options.
 * @returns The encoded {@link ox#Hex.Hex} value.
 */
function fromNumber(value, options = {}) {
    const { signed, size } = options;
    const value_ = BigInt(value);
    let maxValue;
    if (size) {
        if (signed)
            maxValue = (1n << (BigInt(size) * 8n - 1n)) - 1n;
        else
            maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    }
    else if (typeof value === 'number') {
        maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    }
    const minValue = typeof maxValue === 'bigint' && signed ? -maxValue - 1n : 0;
    if ((maxValue && value_ > maxValue) || value_ < minValue) {
        const suffix = typeof value === 'bigint' ? 'n' : '';
        throw new IntegerOutOfRangeError({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed,
            size,
            value: `${value}${suffix}`,
        });
    }
    const stringValue = (signed && value_ < 0 ? (1n << BigInt(size * 8)) + BigInt(value_) : value_).toString(16);
    const hex = `0x${stringValue}`;
    if (size)
        return padLeft(hex, size);
    return hex;
}
/**
 * Pads a {@link ox#Hex.Hex} value to the left with zero bytes until it reaches the given `size` (default: 32 bytes).
 *
 * @example
 * ```ts twoslash
 * import { Hex } from 'ox'
 *
 * Hex.padLeft('0x1234', 4)
 * // @log: '0x00001234'
 * ```
 *
 * @param value - The {@link ox#Hex.Hex} value to pad.
 * @param size - The size (in bytes) of the output hex value.
 * @returns The padded {@link ox#Hex.Hex} value.
 */
function padLeft(value, size) {
    return pad(value, { dir: 'left', size });
}
/**
 * Thrown when the provided integer is out of range, and cannot be represented as a hex value.
 *
 * @example
 * ```ts twoslash
 * import { Hex } from 'ox'
 *
 * Hex.fromNumber(420182738912731283712937129)
 * // @error: Hex.IntegerOutOfRangeError: Number \`4.2018273891273126e+26\` is not in safe unsigned integer range (`0` to `9007199254740991`)
 * ```
 */
class IntegerOutOfRangeError extends BaseError {
    constructor({ max, min, signed, size, value, }) {
        super(`Number \`${value}\` is not in safe${size ? ` ${size * 8}-bit` : ''}${signed ? ' signed' : ' unsigned'} integer range ${max ? `(\`${min}\` to \`${max}\`)` : `(above \`${min}\`)`}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'Hex.IntegerOutOfRangeError'
        });
    }
}
/**
 * Thrown when the size of the value exceeds the pad size.
 *
 * @example
 * ```ts twoslash
 * import { Hex } from 'ox'
 *
 * Hex.padLeft('0x1a4e12a45a21323123aaa87a897a897a898a6567a578a867a98778a667a85a875a87a6a787a65a675a6a9', 32)
 * // @error: Hex.SizeExceedsPaddingSizeError: Hex size (`43`) exceeds padding size (`32`).
 * ```
 */
class SizeExceedsPaddingSizeError extends BaseError {
    constructor({ size, targetSize, type, }) {
        super(`${type.charAt(0).toUpperCase()}${type
            .slice(1)
            .toLowerCase()} size (\`${size}\`) exceeds padding size (\`${targetSize}\`).`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'Hex.SizeExceedsPaddingSizeError'
        });
    }
}

/**
 * Converts a {@link ox#Withdrawal.Withdrawal} to an {@link ox#Withdrawal.Rpc}.
 *
 * @example
 * ```ts twoslash
 * import { Withdrawal } from 'ox'
 *
 * const withdrawal = Withdrawal.toRpc({
 *   address: '0x00000000219ab540356cBB839Cbe05303d7705Fa',
 *   amount: 6423331n,
 *   index: 0,
 *   validatorIndex: 1,
 * })
 * // @log: {
 * // @log:   address: '0x00000000219ab540356cBB839Cbe05303d7705Fa',
 * // @log:   amount: '0x620323',
 * // @log:   index: '0x0',
 * // @log:   validatorIndex: '0x1',
 * // @log: }
 * ```
 *
 * @param withdrawal - The Withdrawal to convert.
 * @returns An RPC Withdrawal.
 */
function toRpc$1(withdrawal) {
    return {
        address: withdrawal.address,
        amount: fromNumber(withdrawal.amount),
        index: fromNumber(withdrawal.index),
        validatorIndex: fromNumber(withdrawal.validatorIndex),
    };
}

/**
 * Converts an {@link ox#BlockOverrides.BlockOverrides} to an {@link ox#BlockOverrides.Rpc}.
 *
 * @example
 * ```ts twoslash
 * import { BlockOverrides } from 'ox'
 *
 * const blockOverrides = BlockOverrides.toRpc({
 *   baseFeePerGas: 1n,
 *   blobBaseFee: 2n,
 *   feeRecipient: '0x0000000000000000000000000000000000000000',
 *   gasLimit: 4n,
 *   number: 5n,
 *   prevRandao: 6n,
 *   time: 78187493520n,
 *   withdrawals: [
 *     {
 *       address: '0x0000000000000000000000000000000000000000',
 *       amount: 1n,
 *       index: 0,
 *       validatorIndex: 1,
 *     },
 *   ],
 * })
 * ```
 *
 * @param blockOverrides - The block overrides to convert.
 * @returns An instantiated {@link ox#BlockOverrides.Rpc}.
 */
function toRpc(blockOverrides) {
    return {
        ...(typeof blockOverrides.baseFeePerGas === 'bigint' && {
            baseFeePerGas: fromNumber(blockOverrides.baseFeePerGas),
        }),
        ...(typeof blockOverrides.blobBaseFee === 'bigint' && {
            blobBaseFee: fromNumber(blockOverrides.blobBaseFee),
        }),
        ...(typeof blockOverrides.feeRecipient === 'string' && {
            feeRecipient: blockOverrides.feeRecipient,
        }),
        ...(typeof blockOverrides.gasLimit === 'bigint' && {
            gasLimit: fromNumber(blockOverrides.gasLimit),
        }),
        ...(typeof blockOverrides.number === 'bigint' && {
            number: fromNumber(blockOverrides.number),
        }),
        ...(typeof blockOverrides.prevRandao === 'bigint' && {
            prevRandao: fromNumber(blockOverrides.prevRandao),
        }),
        ...(typeof blockOverrides.time === 'bigint' && {
            time: fromNumber(blockOverrides.time),
        }),
        ...(blockOverrides.withdrawals && {
            withdrawals: blockOverrides.withdrawals.map(toRpc$1),
        }),
    };
}

/**
 * Simulates a set of calls on block(s) with optional block and state overrides.
 *
 * @example
 * ```ts
 * import { createClient, http, parseEther } from 'viem'
 * import { simulate } from 'viem/actions'
 * import { mainnet } from 'viem/chains'
 *
 * const client = createClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 *
 * const result = await simulate(client, {
 *   blocks: [{
 *     blockOverrides: {
 *       number: 69420n,
 *     },
 *     calls: [{
 *       {
 *         account: '0x5a0b54d5dc17e482fe8b0bdca5320161b95fb929',
 *         data: '0xdeadbeef',
 *         to: '0x70997970c51812dc3a010c7d01b50e0d17dc79c8',
 *       },
 *       {
 *         account: '0x5a0b54d5dc17e482fe8b0bdca5320161b95fb929',
 *         to: '0x70997970c51812dc3a010c7d01b50e0d17dc79c8',
 *         value: parseEther('1'),
 *       },
 *     }],
 *     stateOverrides: [{
 *       address: '0x5a0b54d5dc17e482fe8b0bdca5320161b95fb929',
 *       balance: parseEther('10'),
 *     }],
 *   }]
 * })
 * ```
 *
 * @param client - Client to use.
 * @param parameters - {@link SimulateParameters}
 * @returns Simulated blocks. {@link SimulateReturnType}
 */
async function simulate(client, parameters) {
    const { blockNumber, blockTag = 'latest', blocks, returnFullTransactions, traceTransfers, validation, } = parameters;
    try {
        const blockStateCalls = [];
        for (const block of blocks) {
            const blockOverrides = block.blockOverrides
                ? toRpc(block.blockOverrides)
                : undefined;
            const calls = block.calls.map((call_) => {
                const call = call_;
                const account = call.account ? parseAccount(call.account) : undefined;
                const request = {
                    ...call,
                    data: call.abi ? encodeFunctionData(call) : call.data,
                    from: call.from ?? account?.address,
                };
                assertRequest(request);
                return formatTransactionRequest(request);
            });
            const stateOverrides = block.stateOverrides
                ? serializeStateOverride(block.stateOverrides)
                : undefined;
            blockStateCalls.push({
                blockOverrides,
                calls,
                stateOverrides,
            });
        }
        const blockNumberHex = blockNumber ? numberToHex(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const result = await client.request({
            method: 'eth_simulateV1',
            params: [
                { blockStateCalls, returnFullTransactions, traceTransfers, validation },
                block,
            ],
        });
        return result.map((block, i) => ({
            ...formatBlock(block),
            calls: block.calls.map((call, j) => {
                const { abi, args, functionName, to } = blocks[i].calls[j];
                const data = call.error?.data ?? call.returnData;
                const gasUsed = BigInt(call.gasUsed);
                const logs = call.logs?.map((log) => formatLog(log));
                const status = call.status === '0x1' ? 'success' : 'failure';
                const result = abi && status === 'success'
                    ? decodeFunctionResult({
                        abi,
                        data,
                        functionName,
                    })
                    : null;
                const error = (() => {
                    if (status === 'success')
                        return undefined;
                    let error = undefined;
                    if (call.error?.data === '0x')
                        error = new AbiDecodingZeroDataError();
                    else if (call.error)
                        error = new RawContractError(call.error);
                    if (!error)
                        return undefined;
                    return getContractError(error, {
                        abi: (abi ?? []),
                        address: to,
                        args,
                        functionName: functionName ?? '<unknown>',
                    });
                })();
                return {
                    data,
                    gasUsed,
                    logs,
                    status,
                    ...(status === 'success'
                        ? {
                            result,
                        }
                        : {
                            error,
                        }),
                };
            }),
        }));
    }
    catch (e) {
        const cause = e;
        const error = getNodeError(cause, {});
        if (error instanceof UnknownNodeError)
            throw cause;
        throw error;
    }
}

/**
 * HMAC: RFC2104 message authentication code.
 * @module
 */
class HMAC extends Hash$2 {
    constructor(hash, _key) {
        super();
        this.finished = false;
        this.destroyed = false;
        ahash(hash);
        const key = toBytes(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function')
            throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for (let i = 0; i < pad.length; i++)
            pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for (let i = 0; i < pad.length; i++)
            pad[i] ^= 0x36 ^ 0x5c;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        aexists(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        aexists(this);
        abytes$1(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
        to = to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 * @example
 * import { hmac } from '@noble/hashes/hmac';
 * import { sha256 } from '@noble/hashes/sha2';
 * const mac1 = hmac(sha256, 'key', 'message');
 */
const hmac$1 = (hash, key, message) => new HMAC(hash, key).update(message).digest();
hmac$1.create = (hash, key) => new HMAC(hash, key);

/**
 * Utils for modular division and finite fields.
 * A finite field over 11 is integer number operations `mod 11`.
 * There is no division: it is replaced by modular multiplicative inverse.
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
// prettier-ignore
const _0n$2 = BigInt(0), _1n$3 = BigInt(1), _2n$1 = /* @__PURE__ */ BigInt(2), _3n$1 = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const _4n = /* @__PURE__ */ BigInt(4), _5n = /* @__PURE__ */ BigInt(5), _8n = /* @__PURE__ */ BigInt(8);
// Calculates a modulo b
function mod(a, b) {
    const result = a % b;
    return result >= _0n$2 ? result : b + result;
}
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @todo use field version && remove
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */
function pow(num, power, modulo) {
    if (power < _0n$2)
        throw new Error('invalid exponent, negatives unsupported');
    if (modulo <= _0n$2)
        throw new Error('invalid modulus');
    if (modulo === _1n$3)
        return _0n$2;
    let res = _1n$3;
    while (power > _0n$2) {
        if (power & _1n$3)
            res = (res * num) % modulo;
        num = (num * num) % modulo;
        power >>= _1n$3;
    }
    return res;
}
/** Does `x^(2^power)` mod p. `pow2(30, 4)` == `30^(2^4)` */
function pow2(x, power, modulo) {
    let res = x;
    while (power-- > _0n$2) {
        res *= res;
        res %= modulo;
    }
    return res;
}
/**
 * Inverses number over modulo.
 * Implemented using [Euclidean GCD](https://brilliant.org/wiki/extended-euclidean-algorithm/).
 */
function invert(number, modulo) {
    if (number === _0n$2)
        throw new Error('invert: expected non-zero number');
    if (modulo <= _0n$2)
        throw new Error('invert: expected positive modulus, got ' + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = _0n$2, u = _1n$3;
    while (a !== _0n$2) {
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        // prettier-ignore
        b = a, a = r, x = u, u = m;
    }
    const gcd = b;
    if (gcd !== _1n$3)
        throw new Error('invert: does not exist');
    return mod(x, modulo);
}
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */
function tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - _1n$3) / _2n$1;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for (Q = P - _1n$3, S = 0; Q % _2n$1 === _0n$2; Q /= _2n$1, S++)
        ;
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for (Z = _2n$1; Z < P && pow(Z, legendreC, P) !== P - _1n$3; Z++) {
        // Crash instead of infinity loop, we cannot reasonable count until P.
        if (Z > 1000)
            throw new Error('Cannot find square root: likely non-prime P');
    }
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + _1n$3) / _4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n))
                throw new Error('Cannot find square root');
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + _1n$3) / _2n$1;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE))
            throw new Error('Cannot find square root');
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while (!Fp.eql(b, Fp.ONE)) {
            if (Fp.eql(b, Fp.ZERO))
                return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for (let t2 = Fp.sqr(b); m < r; m++) {
                if (Fp.eql(t2, Fp.ONE))
                    break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, _1n$3 << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
/**
 * Square root for a finite field. It will try to check if optimizations are applicable and fall back to 4:
 *
 * 1. P ≡ 3 (mod 4)
 * 2. P ≡ 5 (mod 8)
 * 3. P ≡ 9 (mod 16)
 * 4. Tonelli-Shanks algorithm
 *
 * Different algorithms can give different roots, it is up to user to decide which one they want.
 * For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
 */
function FpSqrt(P) {
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % _4n === _3n$1) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + _1n$3) / _4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n))
                throw new Error('Cannot find square root');
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % _8n === _5n) {
        const c1 = (P - _5n) / _8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, _2n$1);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, _2n$1), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n))
                throw new Error('Cannot find square root');
            return root;
        };
    }
    // Other cases: Tonelli-Shanks algorithm
    return tonelliShanks(P);
}
// prettier-ignore
const FIELD_FIELDS = [
    'create', 'isValid', 'is0', 'neg', 'inv', 'sqrt', 'sqr',
    'eql', 'add', 'sub', 'mul', 'pow', 'div',
    'addN', 'subN', 'mulN', 'sqrN'
];
function validateField(field) {
    const initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'isSafeInteger',
        BITS: 'isSafeInteger',
    };
    const opts = FIELD_FIELDS.reduce((map, val) => {
        map[val] = 'function';
        return map;
    }, initial);
    return validateObject(field, opts);
}
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */
function FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < _0n$2)
        throw new Error('invalid exponent, negatives unsupported');
    if (power === _0n$2)
        return f.ONE;
    if (power === _1n$3)
        return num;
    let p = f.ONE;
    let d = num;
    while (power > _0n$2) {
        if (power & _1n$3)
            p = f.mul(p, d);
        d = f.sqr(d);
        power >>= _1n$3;
    }
    return p;
}
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */
function FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i) => {
        if (f.is0(num))
            return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i) => {
        if (f.is0(num))
            return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
// CURVE.n lengths
function nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return { nBitLength: _nBitLength, nByteLength };
}
/**
 * Initializes a finite field over prime.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * Fragile: always run a benchmark on a change.
 * Security note: operations don't check 'isValid' for all elements for performance reasons,
 * it is caller responsibility to check this.
 * This is low-level code, please make sure you know what you're doing.
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */
function Field$1(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= _0n$2)
        throw new Error('invalid field: expected ORDER > 0, got ' + ORDER);
    const { nBitLength: BITS, nByteLength: BYTES } = nLength(ORDER, bitLen);
    if (BYTES > 2048)
        throw new Error('invalid field: expected ORDER of <= 2048 bytes');
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER,
        isLE,
        BITS,
        BYTES,
        MASK: bitMask(BITS),
        ZERO: _0n$2,
        ONE: _1n$3,
        create: (num) => mod(num, ORDER),
        isValid: (num) => {
            if (typeof num !== 'bigint')
                throw new Error('invalid field element: expected bigint, got ' + typeof num);
            return _0n$2 <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num) => num === _0n$2,
        isOdd: (num) => (num & _1n$3) === _1n$3,
        neg: (num) => mod(-num, ORDER),
        eql: (lhs, rhs) => lhs === rhs,
        sqr: (num) => mod(num * num, ORDER),
        add: (lhs, rhs) => mod(lhs + rhs, ORDER),
        sub: (lhs, rhs) => mod(lhs - rhs, ORDER),
        mul: (lhs, rhs) => mod(lhs * rhs, ORDER),
        pow: (num, power) => FpPow(f, num, power),
        div: (lhs, rhs) => mod(lhs * invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num) => num * num,
        addN: (lhs, rhs) => lhs + rhs,
        subN: (lhs, rhs) => lhs - rhs,
        mulN: (lhs, rhs) => lhs * rhs,
        inv: (num) => invert(num, ORDER),
        sqrt: redef.sqrt ||
            ((n) => {
                if (!sqrtP)
                    sqrtP = FpSqrt(ORDER);
                return sqrtP(f, n);
            }),
        invertBatch: (lst) => FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c) => (c ? b : a),
        toBytes: (num) => (isLE ? numberToBytesLE(num, BYTES) : numberToBytesBE(num, BYTES)),
        fromBytes: (bytes) => {
            if (bytes.length !== BYTES)
                throw new Error('Field.fromBytes: expected ' + BYTES + ' bytes, got ' + bytes.length);
            return isLE ? bytesToNumberLE(bytes) : bytesToNumberBE(bytes);
        },
    });
    return Object.freeze(f);
}
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */
function getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== 'bigint')
        throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */
function getMinHashLength(fieldOrder) {
    const length = getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */
function mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = getFieldBytesLength(fieldOrder);
    const minLen = getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024)
        throw new Error('expected ' + minLen + '-1024 bytes of input, got ' + len);
    const num = isLE ? bytesToNumberLE(key) : bytesToNumberBE(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = mod(num, fieldOrder - _1n$3) + _1n$3;
    return isLE ? numberToBytesLE(reduced, fieldLen) : numberToBytesBE(reduced, fieldLen);
}

/**
 * Methods for elliptic curve multiplication by scalars.
 * Contains wNAF, pippenger
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const _0n$1 = BigInt(0);
const _1n$2 = BigInt(1);
function constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits)
        throw new Error('invalid window size, expected [1..' + bits + '], got W=' + W);
}
function calcWOpts(W, bits) {
    validateW(W, bits);
    const windows = Math.ceil(bits / W) + 1; // +1, because
    const windowSize = 2 ** (W - 1); // -1 because we skip zero
    return { windows, windowSize };
}
function validateMSMPoints(points, c) {
    if (!Array.isArray(points))
        throw new Error('array expected');
    points.forEach((p, i) => {
        if (!(p instanceof c))
            throw new Error('invalid point at index ' + i);
    });
}
function validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars))
        throw new Error('array of scalars expected');
    scalars.forEach((s, i) => {
        if (!field.isValid(s))
            throw new Error('invalid scalar at index ' + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap(); // This allows use make points immutable (nothing changes inside)
function getW(P) {
    return pointWindowSizes.get(P) || 1;
}
/**
 * Elliptic curve multiplication of Point by scalar. Fragile.
 * Scalars should always be less than curve order: this should be checked inside of a curve itself.
 * Creates precomputation tables for fast multiplication:
 * - private scalar is split by fixed size windows of W bits
 * - every window point is collected from window's table & added to accumulator
 * - since windows are different, same point inside tables won't be accessed more than once per calc
 * - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
 * - +1 window is neccessary for wNAF
 * - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
 *
 * @todo Research returning 2d JS array of windows, instead of a single window.
 * This would allow windows to be in different memory locations
 */
function wNAF(c, bits) {
    return {
        constTimeNegate,
        hasPrecomputes(elm) {
            return getW(elm) !== 1;
        },
        // non-const time multiplication ladder
        unsafeLadder(elm, n, p = c.ZERO) {
            let d = elm;
            while (n > _0n$1) {
                if (n & _1n$2)
                    p = p.add(d);
                d = d.double();
                n >>= _1n$2;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @param elm Point instance
         * @param W window size
         * @returns precomputed point tables flattened to a single array
         */
        precomputeWindow(elm, W) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const points = [];
            let p = elm;
            let base = p;
            for (let window = 0; window < windows; window++) {
                base = p;
                points.push(base);
                // =1, because we skip zero
                for (let i = 1; i < windowSize; i++) {
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */
        wNAF(W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = calcWOpts(W, bits);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for (let window = 0; window < windows; window++) {
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n$2;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) {
                    // The most important part for const-time getPublicKey
                    f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                }
                else {
                    p = p.add(constTimeNegate(cond2, precomputes[offset2]));
                }
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return { p, f };
        },
        /**
         * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @param acc accumulator point to add result of multiplication
         * @returns point
         */
        wNAFUnsafe(W, precomputes, n, acc = c.ZERO) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for (let window = 0; window < windows; window++) {
                const offset = window * windowSize;
                if (n === _0n$1)
                    break; // No need to go over empty scalar
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n$2;
                }
                if (wbits === 0)
                    continue;
                let curr = precomputes[offset + Math.abs(wbits) - 1]; // -1 because we skip zero
                if (wbits < 0)
                    curr = curr.negate();
                // NOTE: by re-using acc, we can save a lot of additions in case of MSM
                acc = acc.add(curr);
            }
            return acc;
        },
        getPrecomputes(W, P, transform) {
            // Calculate precomputes on a first run, reuse them after
            let comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1)
                    pointPrecomputes.set(P, transform(comp));
            }
            return comp;
        },
        wNAFCached(P, n, transform) {
            const W = getW(P);
            return this.wNAF(W, this.getPrecomputes(W, P, transform), n);
        },
        wNAFCachedUnsafe(P, n, transform, prev) {
            const W = getW(P);
            if (W === 1)
                return this.unsafeLadder(P, n, prev); // For W=1 ladder is ~x2 faster
            return this.wNAFUnsafe(W, this.getPrecomputes(W, P, transform), n, prev);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize(P, W) {
            validateW(W, bits);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        },
    };
}
/**
 * Pippenger algorithm for multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * 30x faster vs naive addition on L=4096, 10x faster with precomputes.
 * For N=254bit, L=1, it does: 1024 ADD + 254 DBL. For L=5: 1536 ADD + 254 DBL.
 * Algorithmically constant-time (for same L), even when 1 point + scalar, or when scalar = 0.
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @param scalars array of L scalars (aka private keys / bigints)
 */
function pippenger(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    validateMSMPoints(points, c);
    validateMSMScalars(scalars, fieldN);
    if (points.length !== scalars.length)
        throw new Error('arrays of points and scalars must have equal length');
    const zero = c.ZERO;
    const wbits = bitLen(BigInt(points.length));
    const windowSize = wbits > 12 ? wbits - 3 : wbits > 4 ? wbits - 2 : wbits ? 2 : 1; // in bits
    const MASK = (1 << windowSize) - 1;
    const buckets = new Array(MASK + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for (let i = lastBits; i >= 0; i -= windowSize) {
        buckets.fill(zero);
        for (let j = 0; j < scalars.length; j++) {
            const scalar = scalars[j];
            const wbits = Number((scalar >> BigInt(i)) & BigInt(MASK));
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for (let j = buckets.length - 1, sumI = zero; j > 0; j--) {
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0)
            for (let j = 0; j < windowSize; j++)
                sum = sum.double();
    }
    return sum;
}
function validateBasic(curve) {
    validateField(curve.Fp);
    validateObject(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field',
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger',
    });
    // Set defaults
    return Object.freeze({
        ...nLength(curve.n, curve.nBitLength),
        ...curve,
        ...{ p: curve.Fp.ORDER },
    });
}

/**
 * Short Weierstrass curve methods. The formula is: y² = x³ + ax + b.
 *
 * ### Design rationale for types
 *
 * * Interaction between classes from different curves should fail:
 *   `k256.Point.BASE.add(p256.Point.BASE)`
 * * For this purpose we want to use `instanceof` operator, which is fast and works during runtime
 * * Different calls of `curve()` would return different classes -
 *   `curve(params) !== curve(params)`: if somebody decided to monkey-patch their curve,
 *   it won't affect others
 *
 * TypeScript can't infer types for classes created inside a function. Classes is one instance
 * of nominative types in TypeScript and interfaces only check for shape, so it's hard to create
 * unique type for every function call.
 *
 * We can use generic types via some param, like curve opts, but that would:
 *     1. Enable interaction between `curve(params)` and `curve(params)` (curves of same params)
 *     which is hard to debug.
 *     2. Params can be generic and we can't enforce them to be constant value:
 *     if somebody creates curve from non-constant params,
 *     it would be allowed to interact with other curves with non-constant params
 *
 * @todo https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-7.html#unique-symbol
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function validateSigVerOpts(opts) {
    if (opts.lowS !== undefined)
        abool('lowS', opts.lowS);
    if (opts.prehash !== undefined)
        abool('prehash', opts.prehash);
}
function validatePointOpts(curve) {
    const opts = validateBasic(curve);
    validateObject(opts, {
        a: 'field',
        b: 'field',
    }, {
        allowedPrivateKeyLengths: 'array',
        wrapPrivateKey: 'boolean',
        isTorsionFree: 'function',
        clearCofactor: 'function',
        allowInfinityPoint: 'boolean',
        fromBytes: 'function',
        toBytes: 'function',
    });
    const { endo, Fp, a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) {
            throw new Error('invalid endomorphism, can only be defined for Koblitz curves that have a=0');
        }
        if (typeof endo !== 'object' ||
            typeof endo.beta !== 'bigint' ||
            typeof endo.splitScalar !== 'function') {
            throw new Error('invalid endomorphism, expected beta: bigint and splitScalar: function');
        }
    }
    return Object.freeze({ ...opts });
}
const { bytesToNumberBE: b2n, hexToBytes: h2b } = ut$3;
class DERErr extends Error {
    constructor(m = '') {
        super(m);
    }
}
/**
 * ASN.1 DER encoding utilities. ASN is very complex & fragile. Format:
 *
 *     [0x30 (SEQUENCE), bytelength, 0x02 (INTEGER), intLength, R, 0x02 (INTEGER), intLength, S]
 *
 * Docs: https://letsencrypt.org/docs/a-warm-welcome-to-asn1-and-der/, https://luca.ntop.org/Teaching/Appunti/asn1.html
 */
const DER = {
    // asn.1 DER encoding utils
    Err: DERErr,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data) => {
            const { Err: E } = DER;
            if (tag < 0 || tag > 256)
                throw new E('tlv.encode: wrong tag');
            if (data.length & 1)
                throw new E('tlv.encode: unpadded data');
            const dataLen = data.length / 2;
            const len = numberToHexUnpadded(dataLen);
            if ((len.length / 2) & 128)
                throw new E('tlv.encode: long form length too big');
            // length of length with long form flag
            const lenLen = dataLen > 127 ? numberToHexUnpadded((len.length / 2) | 128) : '';
            const t = numberToHexUnpadded(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode(tag, data) {
            const { Err: E } = DER;
            let pos = 0;
            if (tag < 0 || tag > 256)
                throw new E('tlv.encode: wrong tag');
            if (data.length < 2 || data[pos++] !== tag)
                throw new E('tlv.decode: wrong tlv');
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong)
                length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen)
                    throw new E('tlv.decode(long): indefinite length not supported');
                if (lenLen > 4)
                    throw new E('tlv.decode(long): byte length is too big'); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen)
                    throw new E('tlv.decode: length bytes not complete');
                if (lengthBytes[0] === 0)
                    throw new E('tlv.decode(long): zero leftmost byte');
                for (const b of lengthBytes)
                    length = (length << 8) | b;
                pos += lenLen;
                if (length < 128)
                    throw new E('tlv.decode(long): not minimal encoding');
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length)
                throw new E('tlv.decode: wrong value length');
            return { v, l: data.subarray(pos + length) };
        },
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode(num) {
            const { Err: E } = DER;
            if (num < _0n)
                throw new E('integer: negative integers are not allowed');
            let hex = numberToHexUnpadded(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 0b1000)
                hex = '00' + hex;
            if (hex.length & 1)
                throw new E('unexpected DER parsing assertion: unpadded hex');
            return hex;
        },
        decode(data) {
            const { Err: E } = DER;
            if (data[0] & 128)
                throw new E('invalid signature integer: negative');
            if (data[0] === 0x00 && !(data[1] & 128))
                throw new E('invalid signature integer: unnecessary leading zero');
            return b2n(data);
        },
    },
    toSig(hex) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = DER;
        const data = typeof hex === 'string' ? h2b(hex) : hex;
        abytes(data);
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length)
            throw new E('invalid signature: left bytes after parsing');
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length)
            throw new E('invalid signature: left bytes after parsing');
        return { r: int.decode(rBytes), s: int.decode(sBytes) };
    },
    hexFromSig(sig) {
        const { _tlv: tlv, _int: int } = DER;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    },
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const _0n = BigInt(0), _1n$1 = BigInt(1); BigInt(2); const _3n = BigInt(3); BigInt(4);
function weierstrassPoints(opts) {
    const CURVE = validatePointOpts(opts);
    const { Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const Fn = Field$1(CURVE.n, CURVE.nBitLength);
    const toBytes = CURVE.toBytes ||
        ((_c, point, _isCompressed) => {
            const a = point.toAffine();
            return concatBytes(Uint8Array.from([0x04]), Fp.toBytes(a.x), Fp.toBytes(a.y));
        });
    const fromBytes = CURVE.fromBytes ||
        ((bytes) => {
            // const head = bytes[0];
            const tail = bytes.subarray(1);
            // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
            const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
            const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
            return { x, y };
        });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */
    function weierstrassEquation(x) {
        const { a, b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx)))
        throw new Error('bad generator point: equation left != right');
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return inRange(num, _1n$1, CURVE.n);
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength, wrapPrivateKey, n: N } = CURVE;
        if (lengths && typeof key !== 'bigint') {
            if (isBytes(key))
                key = bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== 'string' || !lengths.includes(key.length))
                throw new Error('invalid private key');
            key = key.padStart(nByteLength * 2, '0');
        }
        let num;
        try {
            num =
                typeof key === 'bigint'
                    ? key
                    : bytesToNumberBE(ensureBytes('private key', key, nByteLength));
        }
        catch (error) {
            throw new Error('invalid private key, expected hex or ' + nByteLength + ' bytes, got ' + typeof key);
        }
        if (wrapPrivateKey)
            num = mod(num, N); // disabled by default, enabled for BLS
        aInRange('private key', num, _1n$1, N); // num in range [1..N-1]
        return num;
    }
    function assertPrjPoint(other) {
        if (!(other instanceof Point))
            throw new Error('ProjectivePoint expected');
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    const toAffineMemo = memoized((p, iz) => {
        const { px: x, py: y, pz: z } = p;
        // Fast-path for normalized points
        if (Fp.eql(z, Fp.ONE))
            return { x, y };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null)
            iz = is0 ? Fp.ONE : Fp.inv(z);
        const ax = Fp.mul(x, iz);
        const ay = Fp.mul(y, iz);
        const zz = Fp.mul(z, iz);
        if (is0)
            return { x: Fp.ZERO, y: Fp.ZERO };
        if (!Fp.eql(zz, Fp.ONE))
            throw new Error('invZ was invalid');
        return { x: ax, y: ay };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = memoized((p) => {
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (CURVE.allowInfinityPoint && !Fp.is0(p.py))
                return;
            throw new Error('bad point: ZERO');
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x, y } = p.toAffine();
        // Check if x, y are valid field elements
        if (!Fp.isValid(x) || !Fp.isValid(y))
            throw new Error('bad point: x or y not FE');
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        if (!Fp.eql(left, right))
            throw new Error('bad point: equation left != right');
        if (!p.isTorsionFree())
            throw new Error('bad point: not in prime-order subgroup');
        return true;
    });
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */
    class Point {
        constructor(px, py, pz) {
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px))
                throw new Error('x required');
            if (py == null || !Fp.isValid(py))
                throw new Error('y required');
            if (pz == null || !Fp.isValid(pz))
                throw new Error('z required');
            Object.freeze(this);
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x, y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y))
                throw new Error('invalid affine point');
            if (p instanceof Point)
                throw new Error('projective point not allowed');
            const is0 = (i) => Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y))
                return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p) => p.pz));
            return points.map((p, i) => p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */
        static fromHex(hex) {
            const P = Point.fromAffine(fromBytes(ensureBytes('pointHex', hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // Multiscalar Multiplication
        static msm(points, scalars) {
            return pippenger(Point, Fn, points, scalars);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y } = this.toAffine();
            if (Fp.isOdd)
                return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */
        equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */
        negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a, b } = CURVE;
            const b3 = Fp.mul(b, _3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, _3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */
        multiplyUnsafe(sc) {
            const { endo, n: N } = CURVE;
            aInRange('scalar', sc, _0n, N);
            const I = Point.ZERO;
            if (sc === _0n)
                return I;
            if (this.is0() || sc === _1n$1)
                return this;
            // Case a: no endomorphism. Case b: has precomputes.
            if (!endo || wnaf.hasPrecomputes(this))
                return wnaf.wNAFCachedUnsafe(this, sc, Point.normalizeZ);
            // Case c: endomorphism
            let { k1neg, k1, k2neg, k2 } = endo.splitScalar(sc);
            let k1p = I;
            let k2p = I;
            let d = this;
            while (k1 > _0n || k2 > _0n) {
                if (k1 & _1n$1)
                    k1p = k1p.add(d);
                if (k2 & _1n$1)
                    k2p = k2p.add(d);
                d = d.double();
                k1 >>= _1n$1;
                k2 >>= _1n$1;
            }
            if (k1neg)
                k1p = k1p.negate();
            if (k2neg)
                k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */
        multiply(scalar) {
            const { endo, n: N } = CURVE;
            aInRange('scalar', scalar, _1n$1, N);
            let point, fake; // Fake point is used to const-time mult
            if (endo) {
                const { k1neg, k1, k2neg, k2 } = endo.splitScalar(scalar);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            }
            else {
                const { p, f } = this.wNAF(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([point, fake])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */
        multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            ) => (a === _0n || a === _1n$1 || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a));
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree } = CURVE;
            if (cofactor === _1n$1)
                return true; // No subgroups, always torsion-free
            if (isTorsionFree)
                return isTorsionFree(Point, this);
            throw new Error('isTorsionFree() has not been declared for the elliptic curve');
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor } = CURVE;
            if (cofactor === _1n$1)
                return this; // Fast-path
            if (clearCofactor)
                return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            abool('isCompressed', isCompressed);
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            abool('isCompressed', isCompressed);
            return bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = wNAF(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar,
        weierstrassEquation,
        isWithinCurveOrder,
    };
}
function validateOpts(curve) {
    const opts = validateBasic(curve);
    validateObject(opts, {
        hash: 'hash',
        hmac: 'function',
        randomBytes: 'function',
    }, {
        bits2int: 'function',
        bits2int_modN: 'function',
        lowS: 'boolean',
    });
    return Object.freeze({ lowS: true, ...opts });
}
/**
 * Creates short weierstrass curve and ECDSA signature methods for it.
 * @example
 * import { Field } from '@noble/curves/abstract/modular';
 * // Before that, define BigInt-s: a, b, p, n, Gx, Gy
 * const curve = weierstrass({ a, b, Fp: Field(p), n, Gx, Gy, h: 1n })
 */
function weierstrass(curveDef) {
    const CURVE = validateOpts(curveDef);
    const { Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function modN(a) {
        return mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar, weierstrassEquation, isWithinCurveOrder, } = weierstrassPoints({
        ...CURVE,
        toBytes(_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = concatBytes;
            abool('isCompressed', isCompressed);
            if (isCompressed) {
                return cat(Uint8Array.from([point.hasEvenY() ? 0x02 : 0x03]), x);
            }
            else {
                return cat(Uint8Array.from([0x04]), x, Fp.toBytes(a.y));
            }
        },
        fromBytes(bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = bytesToNumberBE(tail);
                if (!inRange(x, _1n$1, Fp.ORDER))
                    throw new Error('Point is not on curve');
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                }
                catch (sqrtError) {
                    const suffix = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                    throw new Error('Point is not on curve' + suffix);
                }
                const isYOdd = (y & _1n$1) === _1n$1;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd)
                    y = Fp.neg(y);
                return { x, y };
            }
            else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return { x, y };
            }
            else {
                const cl = compressedLen;
                const ul = uncompressedLen;
                throw new Error('invalid Point, expected length of ' + cl + ', or uncompressed ' + ul + ', got ' + len);
            }
        },
    });
    const numToNByteStr = (num) => bytesToHex(numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> _1n$1;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to) => bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */
    class Signature {
        constructor(r, s, recovery) {
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = ensureBytes('compactSignature', hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r, s } = DER.toSig(ensureBytes('DER', hex));
            return new Signature(r, s);
        }
        assertValidity() {
            aInRange('r', this.r, _1n$1, CURVE_ORDER); // r in [1..N]
            aInRange('s', this.s, _1n$1, CURVE_ORDER); // s in [1..N]
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r, s, recovery: rec } = this;
            const h = bits2int_modN(ensureBytes('msgHash', msgHash)); // Truncate hash
            if (rec == null || ![0, 1, 2, 3].includes(rec))
                throw new Error('recovery id invalid');
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER)
                throw new Error('recovery id 2 or 3 invalid');
            const prefix = (rec & 1) === 0 ? '02' : '03';
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q)
                throw new Error('point at infinify'); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return DER.hexFromSig({ r: this.r, s: this.s });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey(privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            }
            catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */
        randomPrivateKey: () => {
            const length = getMinHashLength(CURVE.n);
            return mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */
        precompute(windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        },
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */
    function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */
    function isProbPub(item) {
        const arr = isBytes(item);
        const str = typeof item === 'string';
        const len = (arr || str) && item.length;
        if (arr)
            return len === compressedLen || len === uncompressedLen;
        if (str)
            return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point)
            return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */
    function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA))
            throw new Error('first arg must be private key');
        if (!isProbPub(publicB))
            throw new Error('second arg must be public key');
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int ||
        function (bytes) {
            // Our custom check "just in case"
            if (bytes.length > 8192)
                throw new Error('input is too large');
            // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
            // for some cases, since bytes.length * 8 is not actual bitLength.
            const num = bytesToNumberBE(bytes); // check for == u8 done here
            const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
            return delta > 0 ? num >> BigInt(delta) : num;
        };
    const bits2int_modN = CURVE.bits2int_modN ||
        function (bytes) {
            return modN(bits2int(bytes)); // can't use bytesToNumberBE here
        };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */
    function int2octets(num) {
        aInRange('num < 2^' + CURVE.nBitLength, num, _0n, ORDER_MASK);
        // works with order, can have different size than numToField!
        return numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order,
    // this will be invalid at least for P521. Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if (['recovered', 'canonical'].some((k) => k in opts))
            throw new Error('sign() legacy options not supported');
        const { hash, randomBytes } = CURVE;
        let { lowS, prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null)
            lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = ensureBytes('msgHash', msgHash);
        validateSigVerOpts(opts);
        if (prehash)
            msgHash = ensureBytes('prehashed msgHash', hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [int2octets(d), int2octets(h1int)];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push(ensureBytes('extraEntropy', e)); // check for being bytes
        }
        const seed = concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k))
                return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === _0n)
                return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === _0n)
                return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & _1n$1); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return { seed, k2sig };
    }
    const defaultSigOpts = { lowS: CURVE.lowS, prehash: false };
    const defaultVerOpts = { lowS: CURVE.lowS, prehash: false };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */
    function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed, k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */
    function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = ensureBytes('msgHash', msgHash);
        publicKey = ensureBytes('publicKey', publicKey);
        const { lowS, prehash, format } = opts;
        // Verify opts, deduce signature format
        validateSigVerOpts(opts);
        if ('strict' in opts)
            throw new Error('options.strict was renamed to lowS');
        if (format !== undefined && format !== 'compact' && format !== 'der')
            throw new Error('format must be compact or der');
        const isHex = typeof sg === 'string' || isBytes(sg);
        const isObj = !isHex &&
            !format &&
            typeof sg === 'object' &&
            sg !== null &&
            typeof sg.r === 'bigint' &&
            typeof sg.s === 'bigint';
        if (!isHex && !isObj)
            throw new Error('invalid signature, expected Uint8Array, hex string or Signature instance');
        let _sig = undefined;
        let P;
        try {
            if (isObj)
                _sig = new Signature(sg.r, sg.s);
            if (isHex) {
                // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
                // Since DER can also be 2*nByteLength bytes, we check for it first.
                try {
                    if (format !== 'compact')
                        _sig = Signature.fromDER(sg);
                }
                catch (derError) {
                    if (!(derError instanceof DER.Err))
                        throw derError;
                }
                if (!_sig && format !== 'der')
                    _sig = Signature.fromCompact(sg);
            }
            P = Point.fromHex(publicKey);
        }
        catch (error) {
            return false;
        }
        if (!_sig)
            return false;
        if (lowS && _sig.hasHighS())
            return false;
        if (prehash)
            msgHash = CURVE.hash(msgHash);
        const { r, s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R)
            return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE,
        getPublicKey,
        getSharedSecret,
        sign,
        verify,
        ProjectivePoint: Point,
        Signature,
        utils,
    };
}

/**
 * Utilities for short weierstrass curves, combined with noble-hashes.
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
/** connects noble-curves to noble-hashes */
function getHash(hash) {
    return {
        hash,
        hmac: (key, ...msgs) => hmac$1(hash, key, concatBytes$2(...msgs)),
        randomBytes,
    };
}
function createCurve(curveDef, defHash) {
    const create = (hash) => weierstrass({ ...curveDef, ...getHash(hash) });
    return { ...create(defHash), create };
}

/**
 * NIST secp256k1. See [pdf](https://www.secg.org/sec2-v2.pdf).
 *
 * Seems to be rigid (not backdoored)
 * [as per discussion](https://bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975).
 *
 * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
 * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
 * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
 * [See explanation](https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066).
 * @module
 */
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const secp256k1P = BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f');
const secp256k1N = BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141');
const _1n = BigInt(1);
const _2n = BigInt(2);
const divNearest = (a, b) => (a + b / _2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */
function sqrtMod(y) {
    const P = secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = (y * y * y) % P; // x^3, 11
    const b3 = (b2 * b2 * y) % P; // x^7
    const b6 = (pow2(b3, _3n, P) * b3) % P;
    const b9 = (pow2(b6, _3n, P) * b3) % P;
    const b11 = (pow2(b9, _2n, P) * b2) % P;
    const b22 = (pow2(b11, _11n, P) * b11) % P;
    const b44 = (pow2(b22, _22n, P) * b22) % P;
    const b88 = (pow2(b44, _44n, P) * b44) % P;
    const b176 = (pow2(b88, _88n, P) * b88) % P;
    const b220 = (pow2(b176, _44n, P) * b44) % P;
    const b223 = (pow2(b220, _3n, P) * b3) % P;
    const t1 = (pow2(b223, _23n, P) * b22) % P;
    const t2 = (pow2(t1, _6n, P) * b2) % P;
    const root = pow2(t2, _2n, P);
    if (!Fpk1.eql(Fpk1.sqr(root), y))
        throw new Error('Cannot find square root');
    return root;
}
const Fpk1 = Field$1(secp256k1P, undefined, undefined, { sqrt: sqrtMod });
/**
 * secp256k1 short weierstrass curve and ECDSA signatures over it.
 *
 * @example
 * import { secp256k1 } from '@noble/curves/secp256k1';
 *
 * const priv = secp256k1.utils.randomPrivateKey();
 * const pub = secp256k1.getPublicKey(priv);
 * const msg = new Uint8Array(32).fill(1); // message hash (not message) in ecdsa
 * const sig = secp256k1.sign(msg, priv); // `{prehash: true}` option is available
 * const isValid = secp256k1.verify(sig, msg, pub) === true;
 */
const secp256k1 = createCurve({
    a: BigInt(0), // equation params: a, b
    b: BigInt(7),
    Fp: Fpk1, // Field's prime: 2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n
    n: secp256k1N, // Curve order, total count of valid points in the field
    // Base point (x, y) aka generator point
    Gx: BigInt('55066263022277343669578718895168534326250603453777594175500187360389116729240'),
    Gy: BigInt('32670510020758816978083085130507043184471273380659243275938904335757337482424'),
    h: BigInt(1), // Cofactor
    lowS: true, // Allow only low-S signatures by default in sign() and verify()
    endo: {
        // Endomorphism, see above
        beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
        splitScalar: (k) => {
            const n = secp256k1N;
            const a1 = BigInt('0x3086d221a7d46bcde86c90e49284eb15');
            const b1 = -_1n * BigInt('0xe4437ed6010e88286f547fa90abfe4c3');
            const a2 = BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8');
            const b2 = a1;
            const POW_2_128 = BigInt('0x100000000000000000000000000000000'); // (2n**128n).toString(16)
            const c1 = divNearest(b2 * k, n);
            const c2 = divNearest(-b1 * k, n);
            let k1 = mod(k - c1 * a1 - c2 * a2, n);
            let k2 = mod(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg)
                k1 = n - k1;
            if (k2neg)
                k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) {
                throw new Error('splitScalar: Endomorphism failed, k=' + k);
            }
            return { k1neg, k1, k2neg, k2 };
        },
    },
}, sha256$2);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
BigInt(0);
secp256k1.ProjectivePoint;

var secp256k1$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	secp256k1: secp256k1
});

/**
 * @description Converts a signature into hex format.
 *
 * @param signature The signature to convert.
 * @returns The signature in hex format.
 *
 * @example
 * serializeSignature({
 *   r: '0x6e100a352ec6ad1b70802290e18aeed190704973570f3b8ed42cb9808e2ea6bf',
 *   s: '0x4a90a229a244495b41890987806fcbd2d5d23fc0dbe5f5256c2613c039d76db8',
 *   yParity: 1
 * })
 * // "0x6e100a352ec6ad1b70802290e18aeed190704973570f3b8ed42cb9808e2ea6bf4a90a229a244495b41890987806fcbd2d5d23fc0dbe5f5256c2613c039d76db81c"
 */
function serializeSignature$1({ r, s, to = 'hex', v, yParity, }) {
    const yParity_ = (() => {
        if (yParity === 0 || yParity === 1)
            return yParity;
        if (v && (v === 27n || v === 28n || v >= 35n))
            return v % 2n === 0n ? 1 : 0;
        throw new Error('Invalid `v` or `yParity` value');
    })();
    const signature = `0x${new secp256k1.Signature(hexToBigInt(r), hexToBigInt(s)).toCompactHex()}${yParity_ === 0 ? '1b' : '1c'}`;
    if (to === 'hex')
        return signature;
    return hexToBytes$1(signature);
}

/**
 * Verifies a message hash onchain using ERC-6492.
 *
 * @param client - Client to use.
 * @param parameters - {@link VerifyHashParameters}
 * @returns Whether or not the signature is valid. {@link VerifyHashReturnType}
 */
async function verifyHash(client, parameters) {
    const { address, factory, factoryData, hash, signature, universalSignatureVerifierAddress = client.chain?.contracts
        ?.universalSignatureVerifier?.address, ...rest } = parameters;
    const signatureHex = (() => {
        if (isHex$2(signature))
            return signature;
        if (typeof signature === 'object' && 'r' in signature && 's' in signature)
            return serializeSignature$1(signature);
        return bytesToHex$2(signature);
    })();
    const wrappedSignature = await (async () => {
        // If no `factory` or `factoryData` is provided, it is assumed that the
        // address is not a Smart Account, or the Smart Account is already deployed.
        if (!factory && !factoryData)
            return signatureHex;
        // If the signature is already wrapped, return the signature.
        if (isErc6492Signature(signatureHex))
            return signatureHex;
        // If the Smart Account is not deployed, wrap the signature with a 6492 wrapper
        // to perform counterfactual validation.
        return serializeErc6492Signature({
            address: factory,
            data: factoryData,
            signature: signatureHex,
        });
    })();
    try {
        const args = universalSignatureVerifierAddress
            ? {
                to: universalSignatureVerifierAddress,
                data: encodeFunctionData({
                    abi: universalSignatureValidatorAbi,
                    functionName: 'isValidSig',
                    args: [address, hash, wrappedSignature],
                }),
                ...rest,
            }
            : {
                data: encodeDeployData({
                    abi: universalSignatureValidatorAbi,
                    args: [address, hash, wrappedSignature],
                    bytecode: universalSignatureValidatorByteCode,
                }),
                ...rest,
            };
        const { data } = await getAction(client, call, 'call')(args);
        return hexToBool(data ?? '0x0');
    }
    catch (error) {
        // Fallback attempt to verify the signature via ECDSA recovery.
        try {
            const verified = isAddressEqual(getAddress(address), await recoverAddress({ hash, signature }));
            if (verified)
                return true;
        }
        catch { }
        if (error instanceof CallExecutionError) {
            // if the execution fails, the signature was not valid and an internal method inside of the validator reverted
            // this can happen for many reasons, for example if signer can not be recovered from the signature
            // or if the signature has no valid format
            return false;
        }
        throw error;
    }
}

/**
 * Verify that a message was signed by the provided address.
 *
 * Compatible with Smart Contract Accounts & Externally Owned Accounts via [ERC-6492](https://eips.ethereum.org/EIPS/eip-6492).
 *
 * - Docs {@link https://viem.sh/docs/actions/public/verifyMessage}
 *
 * @param client - Client to use.
 * @param parameters - {@link VerifyMessageParameters}
 * @returns Whether or not the signature is valid. {@link VerifyMessageReturnType}
 */
async function verifyMessage(client, { address, message, factory, factoryData, signature, ...callRequest }) {
    const hash = hashMessage(message);
    return verifyHash(client, {
        address,
        factory: factory,
        factoryData: factoryData,
        hash,
        signature,
        ...callRequest,
    });
}

/**
 * Verify that typed data was signed by the provided address.
 *
 * - Docs {@link https://viem.sh/docs/actions/public/verifyTypedData}
 *
 * @param client - Client to use.
 * @param parameters - {@link VerifyTypedDataParameters}
 * @returns Whether or not the signature is valid. {@link VerifyTypedDataReturnType}
 */
async function verifyTypedData(client, parameters) {
    const { address, factory, factoryData, signature, message, primaryType, types, domain, ...callRequest } = parameters;
    const hash = hashTypedData({ message, primaryType, types, domain });
    return verifyHash(client, {
        address,
        factory: factory,
        factoryData: factoryData,
        hash,
        signature,
        ...callRequest,
    });
}

/**
 * Watches and returns incoming block numbers.
 *
 * - Docs: https://viem.sh/docs/actions/public/watchBlockNumber
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/blocks_watching-blocks
 * - JSON-RPC Methods:
 *   - When `poll: true`, calls [`eth_blockNumber`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_blocknumber) on a polling interval.
 *   - When `poll: false` & WebSocket Transport, uses a WebSocket subscription via [`eth_subscribe`](https://docs.alchemy.com/reference/eth-subscribe-polygon) and the `"newHeads"` event.
 *
 * @param client - Client to use
 * @param parameters - {@link WatchBlockNumberParameters}
 * @returns A function that can be invoked to stop watching for new block numbers. {@link WatchBlockNumberReturnType}
 *
 * @example
 * import { createPublicClient, watchBlockNumber, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const unwatch = watchBlockNumber(client, {
 *   onBlockNumber: (blockNumber) => console.log(blockNumber),
 * })
 */
function watchBlockNumber(client, { emitOnBegin = false, emitMissed = false, onBlockNumber, onError, poll: poll_, pollingInterval = client.pollingInterval, }) {
    const enablePolling = (() => {
        if (typeof poll_ !== 'undefined')
            return poll_;
        if (client.transport.type === 'webSocket')
            return false;
        if (client.transport.type === 'fallback' &&
            client.transport.transports[0].config.type === 'webSocket')
            return false;
        return true;
    })();
    let prevBlockNumber;
    const pollBlockNumber = () => {
        const observerId = stringify$1([
            'watchBlockNumber',
            client.uid,
            emitOnBegin,
            emitMissed,
            pollingInterval,
        ]);
        return observe(observerId, { onBlockNumber, onError }, (emit) => poll(async () => {
            try {
                const blockNumber = await getAction(client, getBlockNumber, 'getBlockNumber')({ cacheTime: 0 });
                if (prevBlockNumber) {
                    // If the current block number is the same as the previous,
                    // we can skip.
                    if (blockNumber === prevBlockNumber)
                        return;
                    // If we have missed out on some previous blocks, and the
                    // `emitMissed` flag is truthy, let's emit those blocks.
                    if (blockNumber - prevBlockNumber > 1 && emitMissed) {
                        for (let i = prevBlockNumber + 1n; i < blockNumber; i++) {
                            emit.onBlockNumber(i, prevBlockNumber);
                            prevBlockNumber = i;
                        }
                    }
                }
                // If the next block number is greater than the previous,
                // it is not in the past, and we can emit the new block number.
                if (!prevBlockNumber || blockNumber > prevBlockNumber) {
                    emit.onBlockNumber(blockNumber, prevBlockNumber);
                    prevBlockNumber = blockNumber;
                }
            }
            catch (err) {
                emit.onError?.(err);
            }
        }, {
            emitOnBegin,
            interval: pollingInterval,
        }));
    };
    const subscribeBlockNumber = () => {
        const observerId = stringify$1([
            'watchBlockNumber',
            client.uid,
            emitOnBegin,
            emitMissed,
        ]);
        return observe(observerId, { onBlockNumber, onError }, (emit) => {
            let active = true;
            let unsubscribe = () => (active = false);
            (async () => {
                try {
                    const transport = (() => {
                        if (client.transport.type === 'fallback') {
                            const transport = client.transport.transports.find((transport) => transport.config.type === 'webSocket');
                            if (!transport)
                                return client.transport;
                            return transport.value;
                        }
                        return client.transport;
                    })();
                    const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                        params: ['newHeads'],
                        onData(data) {
                            if (!active)
                                return;
                            const blockNumber = hexToBigInt(data.result?.number);
                            emit.onBlockNumber(blockNumber, prevBlockNumber);
                            prevBlockNumber = blockNumber;
                        },
                        onError(error) {
                            emit.onError?.(error);
                        },
                    });
                    unsubscribe = unsubscribe_;
                    if (!active)
                        unsubscribe();
                }
                catch (err) {
                    onError?.(err);
                }
            })();
            return () => unsubscribe();
        });
    };
    return enablePolling ? pollBlockNumber() : subscribeBlockNumber();
}

/**
 * Waits for the [Transaction](https://viem.sh/docs/glossary/terms#transaction) to be included on a [Block](https://viem.sh/docs/glossary/terms#block) (one confirmation), and then returns the [Transaction Receipt](https://viem.sh/docs/glossary/terms#transaction-receipt).
 *
 * - Docs: https://viem.sh/docs/actions/public/waitForTransactionReceipt
 * - Example: https://stackblitz.com/github/wevm/viem/tree/main/examples/transactions_sending-transactions
 * - JSON-RPC Methods:
 *   - Polls [`eth_getTransactionReceipt`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getTransactionReceipt) on each block until it has been processed.
 *   - If a Transaction has been replaced:
 *     - Calls [`eth_getBlockByNumber`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getblockbynumber) and extracts the transactions
 *     - Checks if one of the Transactions is a replacement
 *     - If so, calls [`eth_getTransactionReceipt`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getTransactionReceipt).
 *
 * The `waitForTransactionReceipt` action additionally supports Replacement detection (e.g. sped up Transactions).
 *
 * Transactions can be replaced when a user modifies their transaction in their wallet (to speed up or cancel). Transactions are replaced when they are sent from the same nonce.
 *
 * There are 3 types of Transaction Replacement reasons:
 *
 * - `repriced`: The gas price has been modified (e.g. different `maxFeePerGas`)
 * - `cancelled`: The Transaction has been cancelled (e.g. `value === 0n`)
 * - `replaced`: The Transaction has been replaced (e.g. different `value` or `data`)
 *
 * @param client - Client to use
 * @param parameters - {@link WaitForTransactionReceiptParameters}
 * @returns The transaction receipt. {@link WaitForTransactionReceiptReturnType}
 *
 * @example
 * import { createPublicClient, waitForTransactionReceipt, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const transactionReceipt = await waitForTransactionReceipt(client, {
 *   hash: '0x4ca7ee652d57678f26e887c149ab0735f41de37bcad58c9f6d3ed5824f15b74d',
 * })
 */
async function waitForTransactionReceipt(client, { confirmations = 1, hash, onReplaced, pollingInterval = client.pollingInterval, retryCount = 6, retryDelay = ({ count }) => ~~(1 << count) * 200, // exponential backoff
timeout = 180_000, }) {
    const observerId = stringify$1(['waitForTransactionReceipt', client.uid, hash]);
    let transaction;
    let replacedTransaction;
    let receipt;
    let retrying = false;
    const { promise, resolve, reject } = withResolvers();
    const timer = timeout
        ? setTimeout(() => reject(new WaitForTransactionReceiptTimeoutError({ hash })), timeout)
        : undefined;
    const _unobserve = observe(observerId, { onReplaced, resolve, reject }, (emit) => {
        const _unwatch = getAction(client, watchBlockNumber, 'watchBlockNumber')({
            emitMissed: true,
            emitOnBegin: true,
            poll: true,
            pollingInterval,
            async onBlockNumber(blockNumber_) {
                const done = (fn) => {
                    clearTimeout(timer);
                    _unwatch();
                    fn();
                    _unobserve();
                };
                let blockNumber = blockNumber_;
                if (retrying)
                    return;
                try {
                    // If we already have a valid receipt, let's check if we have enough
                    // confirmations. If we do, then we can resolve.
                    if (receipt) {
                        if (confirmations > 1 &&
                            (!receipt.blockNumber ||
                                blockNumber - receipt.blockNumber + 1n < confirmations))
                            return;
                        done(() => emit.resolve(receipt));
                        return;
                    }
                    // Get the transaction to check if it's been replaced.
                    // We need to retry as some RPC Providers may be slow to sync
                    // up mined transactions.
                    if (!transaction) {
                        retrying = true;
                        await withRetry(async () => {
                            transaction = (await getAction(client, getTransaction, 'getTransaction')({ hash }));
                            if (transaction.blockNumber)
                                blockNumber = transaction.blockNumber;
                        }, {
                            delay: retryDelay,
                            retryCount,
                        });
                        retrying = false;
                    }
                    // Get the receipt to check if it's been processed.
                    receipt = await getAction(client, getTransactionReceipt, 'getTransactionReceipt')({ hash });
                    // Check if we have enough confirmations. If not, continue polling.
                    if (confirmations > 1 &&
                        (!receipt.blockNumber ||
                            blockNumber - receipt.blockNumber + 1n < confirmations))
                        return;
                    done(() => emit.resolve(receipt));
                }
                catch (err) {
                    // If the receipt is not found, the transaction will be pending.
                    // We need to check if it has potentially been replaced.
                    if (err instanceof TransactionNotFoundError ||
                        err instanceof TransactionReceiptNotFoundError) {
                        if (!transaction) {
                            retrying = false;
                            return;
                        }
                        try {
                            replacedTransaction = transaction;
                            // Let's retrieve the transactions from the current block.
                            // We need to retry as some RPC Providers may be slow to sync
                            // up mined blocks.
                            retrying = true;
                            const block = await withRetry(() => getAction(client, getBlock, 'getBlock')({
                                blockNumber,
                                includeTransactions: true,
                            }), {
                                delay: retryDelay,
                                retryCount,
                                shouldRetry: ({ error }) => error instanceof BlockNotFoundError,
                            });
                            retrying = false;
                            const replacementTransaction = block.transactions.find(({ from, nonce }) => from === replacedTransaction.from &&
                                nonce === replacedTransaction.nonce);
                            // If we couldn't find a replacement transaction, continue polling.
                            if (!replacementTransaction)
                                return;
                            // If we found a replacement transaction, return it's receipt.
                            receipt = await getAction(client, getTransactionReceipt, 'getTransactionReceipt')({
                                hash: replacementTransaction.hash,
                            });
                            // Check if we have enough confirmations. If not, continue polling.
                            if (confirmations > 1 &&
                                (!receipt.blockNumber ||
                                    blockNumber - receipt.blockNumber + 1n < confirmations))
                                return;
                            let reason = 'replaced';
                            if (replacementTransaction.to === replacedTransaction.to &&
                                replacementTransaction.value === replacedTransaction.value &&
                                replacementTransaction.input === replacedTransaction.input) {
                                reason = 'repriced';
                            }
                            else if (replacementTransaction.from === replacementTransaction.to &&
                                replacementTransaction.value === 0n) {
                                reason = 'cancelled';
                            }
                            done(() => {
                                emit.onReplaced?.({
                                    reason,
                                    replacedTransaction: replacedTransaction,
                                    transaction: replacementTransaction,
                                    transactionReceipt: receipt,
                                });
                                emit.resolve(receipt);
                            });
                        }
                        catch (err_) {
                            done(() => emit.reject(err_));
                        }
                    }
                    else {
                        done(() => emit.reject(err));
                    }
                }
            },
        });
    });
    return promise;
}

/**
 * Watches and returns information for incoming blocks.
 *
 * - Docs: https://viem.sh/docs/actions/public/watchBlocks
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/blocks_watching-blocks
 * - JSON-RPC Methods:
 *   - When `poll: true`, calls [`eth_getBlockByNumber`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getBlockByNumber) on a polling interval.
 *   - When `poll: false` & WebSocket Transport, uses a WebSocket subscription via [`eth_subscribe`](https://docs.alchemy.com/reference/eth-subscribe-polygon) and the `"newHeads"` event.
 *
 * @param client - Client to use
 * @param parameters - {@link WatchBlocksParameters}
 * @returns A function that can be invoked to stop watching for new block numbers. {@link WatchBlocksReturnType}
 *
 * @example
 * import { createPublicClient, watchBlocks, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const unwatch = watchBlocks(client, {
 *   onBlock: (block) => console.log(block),
 * })
 */
function watchBlocks(client, { blockTag = 'latest', emitMissed = false, emitOnBegin = false, onBlock, onError, includeTransactions: includeTransactions_, poll: poll_, pollingInterval = client.pollingInterval, }) {
    const enablePolling = (() => {
        if (typeof poll_ !== 'undefined')
            return poll_;
        if (client.transport.type === 'webSocket')
            return false;
        if (client.transport.type === 'fallback' &&
            client.transport.transports[0].config.type === 'webSocket')
            return false;
        return true;
    })();
    const includeTransactions = includeTransactions_ ?? false;
    let prevBlock;
    const pollBlocks = () => {
        const observerId = stringify$1([
            'watchBlocks',
            client.uid,
            blockTag,
            emitMissed,
            emitOnBegin,
            includeTransactions,
            pollingInterval,
        ]);
        return observe(observerId, { onBlock, onError }, (emit) => poll(async () => {
            try {
                const block = await getAction(client, getBlock, 'getBlock')({
                    blockTag,
                    includeTransactions,
                });
                if (block.number && prevBlock?.number) {
                    // If the current block number is the same as the previous,
                    // we can skip.
                    if (block.number === prevBlock.number)
                        return;
                    // If we have missed out on some previous blocks, and the
                    // `emitMissed` flag is truthy, let's emit those blocks.
                    if (block.number - prevBlock.number > 1 && emitMissed) {
                        for (let i = prevBlock?.number + 1n; i < block.number; i++) {
                            const block = (await getAction(client, getBlock, 'getBlock')({
                                blockNumber: i,
                                includeTransactions,
                            }));
                            emit.onBlock(block, prevBlock);
                            prevBlock = block;
                        }
                    }
                }
                if (
                // If no previous block exists, emit.
                !prevBlock?.number ||
                    // If the block tag is "pending" with no block number, emit.
                    (blockTag === 'pending' && !block?.number) ||
                    // If the next block number is greater than the previous block number, emit.
                    // We don't want to emit blocks in the past.
                    (block.number && block.number > prevBlock.number)) {
                    emit.onBlock(block, prevBlock);
                    prevBlock = block;
                }
            }
            catch (err) {
                emit.onError?.(err);
            }
        }, {
            emitOnBegin,
            interval: pollingInterval,
        }));
    };
    const subscribeBlocks = () => {
        let active = true;
        let emitFetched = true;
        let unsubscribe = () => (active = false);
        (async () => {
            try {
                if (emitOnBegin) {
                    getAction(client, getBlock, 'getBlock')({
                        blockTag,
                        includeTransactions,
                    }).then((block) => {
                        if (!active)
                            return;
                        if (!emitFetched)
                            return;
                        onBlock(block, undefined);
                        emitFetched = false;
                    });
                }
                const transport = (() => {
                    if (client.transport.type === 'fallback') {
                        const transport = client.transport.transports.find((transport) => transport.config.type === 'webSocket');
                        if (!transport)
                            return client.transport;
                        return transport.value;
                    }
                    return client.transport;
                })();
                const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                    params: ['newHeads'],
                    async onData(data) {
                        if (!active)
                            return;
                        const block = (await getAction(client, getBlock, 'getBlock')({
                            blockNumber: data.blockNumber,
                            includeTransactions,
                        }).catch(() => { }));
                        if (!active)
                            return;
                        onBlock(block, prevBlock);
                        emitFetched = false;
                        prevBlock = block;
                    },
                    onError(error) {
                        onError?.(error);
                    },
                });
                unsubscribe = unsubscribe_;
                if (!active)
                    unsubscribe();
            }
            catch (err) {
                onError?.(err);
            }
        })();
        return () => unsubscribe();
    };
    return enablePolling ? pollBlocks() : subscribeBlocks();
}

/**
 * Watches and returns emitted [Event Logs](https://viem.sh/docs/glossary/terms#event-log).
 *
 * - Docs: https://viem.sh/docs/actions/public/watchEvent
 * - JSON-RPC Methods:
 *   - **RPC Provider supports `eth_newFilter`:**
 *     - Calls [`eth_newFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_newfilter) to create a filter (called on initialize).
 *     - On a polling interval, it will call [`eth_getFilterChanges`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getfilterchanges).
 *   - **RPC Provider does not support `eth_newFilter`:**
 *     - Calls [`eth_getLogs`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getlogs) for each block between the polling interval.
 *
 * This Action will batch up all the Event Logs found within the [`pollingInterval`](https://viem.sh/docs/actions/public/watchEvent#pollinginterval-optional), and invoke them via [`onLogs`](https://viem.sh/docs/actions/public/watchEvent#onLogs).
 *
 * `watchEvent` will attempt to create an [Event Filter](https://viem.sh/docs/actions/public/createEventFilter) and listen to changes to the Filter per polling interval, however, if the RPC Provider does not support Filters (e.g. `eth_newFilter`), then `watchEvent` will fall back to using [`getLogs`](https://viem.sh/docs/actions/public/getLogs) instead.
 *
 * @param client - Client to use
 * @param parameters - {@link WatchEventParameters}
 * @returns A function that can be invoked to stop watching for new Event Logs. {@link WatchEventReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { watchEvent } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const unwatch = watchEvent(client, {
 *   onLogs: (logs) => console.log(logs),
 * })
 */
function watchEvent(client, { address, args, batch = true, event, events, fromBlock, onError, onLogs, poll: poll_, pollingInterval = client.pollingInterval, strict: strict_, }) {
    const enablePolling = (() => {
        if (typeof poll_ !== 'undefined')
            return poll_;
        if (typeof fromBlock === 'bigint')
            return true;
        if (client.transport.type === 'webSocket')
            return false;
        if (client.transport.type === 'fallback' &&
            client.transport.transports[0].config.type === 'webSocket')
            return false;
        return true;
    })();
    const strict = strict_ ?? false;
    const pollEvent = () => {
        const observerId = stringify$1([
            'watchEvent',
            address,
            args,
            batch,
            client.uid,
            event,
            pollingInterval,
            fromBlock,
        ]);
        return observe(observerId, { onLogs, onError }, (emit) => {
            let previousBlockNumber;
            if (fromBlock !== undefined)
                previousBlockNumber = fromBlock - 1n;
            let filter;
            let initialized = false;
            const unwatch = poll(async () => {
                if (!initialized) {
                    try {
                        filter = (await getAction(client, createEventFilter, 'createEventFilter')({
                            address,
                            args,
                            event: event,
                            events,
                            strict,
                            fromBlock,
                        }));
                    }
                    catch { }
                    initialized = true;
                    return;
                }
                try {
                    let logs;
                    if (filter) {
                        logs = await getAction(client, getFilterChanges, 'getFilterChanges')({ filter });
                    }
                    else {
                        // If the filter doesn't exist, we will fall back to use `getLogs`.
                        // The fall back exists because some RPC Providers do not support filters.
                        // Fetch the block number to use for `getLogs`.
                        const blockNumber = await getAction(client, getBlockNumber, 'getBlockNumber')({});
                        // If the block number has changed, we will need to fetch the logs.
                        // If the block number doesn't exist, we are yet to reach the first poll interval,
                        // so do not emit any logs.
                        if (previousBlockNumber && previousBlockNumber !== blockNumber) {
                            logs = await getAction(client, getLogs, 'getLogs')({
                                address,
                                args,
                                event: event,
                                events,
                                fromBlock: previousBlockNumber + 1n,
                                toBlock: blockNumber,
                            });
                        }
                        else {
                            logs = [];
                        }
                        previousBlockNumber = blockNumber;
                    }
                    if (logs.length === 0)
                        return;
                    if (batch)
                        emit.onLogs(logs);
                    else
                        for (const log of logs)
                            emit.onLogs([log]);
                }
                catch (err) {
                    // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                    // Reinitialize the filter when this occurs
                    if (filter && err instanceof InvalidInputRpcError)
                        initialized = false;
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval,
            });
            return async () => {
                if (filter)
                    await getAction(client, uninstallFilter, 'uninstallFilter')({ filter });
                unwatch();
            };
        });
    };
    const subscribeEvent = () => {
        let active = true;
        let unsubscribe = () => (active = false);
        (async () => {
            try {
                const transport = (() => {
                    if (client.transport.type === 'fallback') {
                        const transport = client.transport.transports.find((transport) => transport.config.type === 'webSocket');
                        if (!transport)
                            return client.transport;
                        return transport.value;
                    }
                    return client.transport;
                })();
                const events_ = events ?? (event ? [event] : undefined);
                let topics = [];
                if (events_) {
                    const encoded = events_.flatMap((event) => encodeEventTopics({
                        abi: [event],
                        eventName: event.name,
                        args,
                    }));
                    // TODO: Clean up type casting
                    topics = [encoded];
                    if (event)
                        topics = topics[0];
                }
                const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                    params: ['logs', { address, topics }],
                    onData(data) {
                        if (!active)
                            return;
                        const log = data.result;
                        try {
                            const { eventName, args } = decodeEventLog({
                                abi: events_ ?? [],
                                data: log.data,
                                topics: log.topics,
                                strict,
                            });
                            const formatted = formatLog(log, { args, eventName });
                            onLogs([formatted]);
                        }
                        catch (err) {
                            let eventName;
                            let isUnnamed;
                            if (err instanceof DecodeLogDataMismatch ||
                                err instanceof DecodeLogTopicsMismatch) {
                                // If strict mode is on, and log data/topics do not match event definition, skip.
                                if (strict_)
                                    return;
                                eventName = err.abiItem.name;
                                isUnnamed = err.abiItem.inputs?.some((x) => !('name' in x && x.name));
                            }
                            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                            const formatted = formatLog(log, {
                                args: isUnnamed ? [] : {},
                                eventName,
                            });
                            onLogs([formatted]);
                        }
                    },
                    onError(error) {
                        onError?.(error);
                    },
                });
                unsubscribe = unsubscribe_;
                if (!active)
                    unsubscribe();
            }
            catch (err) {
                onError?.(err);
            }
        })();
        return () => unsubscribe();
    };
    return enablePolling ? pollEvent() : subscribeEvent();
}

/**
 * Watches and returns pending transaction hashes.
 *
 * - Docs: https://viem.sh/docs/actions/public/watchPendingTransactions
 * - JSON-RPC Methods:
 *   - When `poll: true`
 *     - Calls [`eth_newPendingTransactionFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_newpendingtransactionfilter) to initialize the filter.
 *     - Calls [`eth_getFilterChanges`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_getFilterChanges) on a polling interval.
 *   - When `poll: false` & WebSocket Transport, uses a WebSocket subscription via [`eth_subscribe`](https://docs.alchemy.com/reference/eth-subscribe-polygon) and the `"newPendingTransactions"` event.
 *
 * This Action will batch up all the pending transactions found within the [`pollingInterval`](https://viem.sh/docs/actions/public/watchPendingTransactions#pollinginterval-optional), and invoke them via [`onTransactions`](https://viem.sh/docs/actions/public/watchPendingTransactions#ontransactions).
 *
 * @param client - Client to use
 * @param parameters - {@link WatchPendingTransactionsParameters}
 * @returns A function that can be invoked to stop watching for new pending transaction hashes. {@link WatchPendingTransactionsReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { watchPendingTransactions } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const unwatch = await watchPendingTransactions(client, {
 *   onTransactions: (hashes) => console.log(hashes),
 * })
 */
function watchPendingTransactions(client, { batch = true, onError, onTransactions, poll: poll_, pollingInterval = client.pollingInterval, }) {
    const enablePolling = typeof poll_ !== 'undefined' ? poll_ : client.transport.type !== 'webSocket';
    const pollPendingTransactions = () => {
        const observerId = stringify$1([
            'watchPendingTransactions',
            client.uid,
            batch,
            pollingInterval,
        ]);
        return observe(observerId, { onTransactions, onError }, (emit) => {
            let filter;
            const unwatch = poll(async () => {
                try {
                    if (!filter) {
                        try {
                            filter = await getAction(client, createPendingTransactionFilter, 'createPendingTransactionFilter')({});
                            return;
                        }
                        catch (err) {
                            unwatch();
                            throw err;
                        }
                    }
                    const hashes = await getAction(client, getFilterChanges, 'getFilterChanges')({ filter });
                    if (hashes.length === 0)
                        return;
                    if (batch)
                        emit.onTransactions(hashes);
                    else
                        for (const hash of hashes)
                            emit.onTransactions([hash]);
                }
                catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval,
            });
            return async () => {
                if (filter)
                    await getAction(client, uninstallFilter, 'uninstallFilter')({ filter });
                unwatch();
            };
        });
    };
    const subscribePendingTransactions = () => {
        let active = true;
        let unsubscribe = () => (active = false);
        (async () => {
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: ['newPendingTransactions'],
                    onData(data) {
                        if (!active)
                            return;
                        const transaction = data.result;
                        onTransactions([transaction]);
                    },
                    onError(error) {
                        onError?.(error);
                    },
                });
                unsubscribe = unsubscribe_;
                if (!active)
                    unsubscribe();
            }
            catch (err) {
                onError?.(err);
            }
        })();
        return () => unsubscribe();
    };
    return enablePolling
        ? pollPendingTransactions()
        : subscribePendingTransactions();
}

/**
 * @description Parses EIP-4361 formatted message into message fields object.
 *
 * @see https://eips.ethereum.org/EIPS/eip-4361
 *
 * @returns EIP-4361 fields object
 */
function parseSiweMessage(message) {
    const { scheme, statement, ...prefix } = (message.match(prefixRegex)
        ?.groups ?? {});
    const { chainId, expirationTime, issuedAt, notBefore, requestId, ...suffix } = (message.match(suffixRegex)?.groups ?? {});
    const resources = message.split('Resources:')[1]?.split('\n- ').slice(1);
    return {
        ...prefix,
        ...suffix,
        ...(chainId ? { chainId: Number(chainId) } : {}),
        ...(expirationTime ? { expirationTime: new Date(expirationTime) } : {}),
        ...(issuedAt ? { issuedAt: new Date(issuedAt) } : {}),
        ...(notBefore ? { notBefore: new Date(notBefore) } : {}),
        ...(requestId ? { requestId } : {}),
        ...(resources ? { resources } : {}),
        ...(scheme ? { scheme } : {}),
        ...(statement ? { statement } : {}),
    };
}
// https://regexr.com/80gdj
const prefixRegex = /^(?:(?<scheme>[a-zA-Z][a-zA-Z0-9+-.]*):\/\/)?(?<domain>[a-zA-Z0-9+-.]*(?::[0-9]{1,5})?) (?:wants you to sign in with your Ethereum account:\n)(?<address>0x[a-fA-F0-9]{40})\n\n(?:(?<statement>.*)\n\n)?/;
// https://regexr.com/80gf9
const suffixRegex = /(?:URI: (?<uri>.+))\n(?:Version: (?<version>.+))\n(?:Chain ID: (?<chainId>\d+))\n(?:Nonce: (?<nonce>[a-zA-Z0-9]+))\n(?:Issued At: (?<issuedAt>.+))(?:\nExpiration Time: (?<expirationTime>.+))?(?:\nNot Before: (?<notBefore>.+))?(?:\nRequest ID: (?<requestId>.+))?/;

/**
 * @description Validates EIP-4361 message.
 *
 * @see https://eips.ethereum.org/EIPS/eip-4361
 */
function validateSiweMessage(parameters) {
    const { address, domain, message, nonce, scheme, time = new Date(), } = parameters;
    if (domain && message.domain !== domain)
        return false;
    if (nonce && message.nonce !== nonce)
        return false;
    if (scheme && message.scheme !== scheme)
        return false;
    if (message.expirationTime && time >= message.expirationTime)
        return false;
    if (message.notBefore && time < message.notBefore)
        return false;
    try {
        if (!message.address)
            return false;
        if (address && !isAddressEqual(message.address, address))
            return false;
    }
    catch {
        return false;
    }
    return true;
}

/**
 * Verifies [EIP-4361](https://eips.ethereum.org/EIPS/eip-4361) formatted message was signed.
 *
 * Compatible with Smart Contract Accounts & Externally Owned Accounts via [ERC-6492](https://eips.ethereum.org/EIPS/eip-6492).
 *
 * - Docs {@link https://viem.sh/docs/siwe/actions/verifySiweMessage}
 *
 * @param client - Client to use.
 * @param parameters - {@link VerifySiweMessageParameters}
 * @returns Whether or not the signature is valid. {@link VerifySiweMessageReturnType}
 */
async function verifySiweMessage(client, parameters) {
    const { address, domain, message, nonce, scheme, signature, time = new Date(), ...callRequest } = parameters;
    const parsed = parseSiweMessage(message);
    if (!parsed.address)
        return false;
    const isValid = validateSiweMessage({
        address,
        domain,
        message: parsed,
        nonce,
        scheme,
        time,
    });
    if (!isValid)
        return false;
    const hash = hashMessage(message);
    return verifyHash(client, {
        address: parsed.address,
        hash,
        signature,
        ...callRequest,
    });
}

function publicActions(client) {
    return {
        call: (args) => call(client, args),
        createAccessList: (args) => createAccessList(client, args),
        createBlockFilter: () => createBlockFilter(client),
        createContractEventFilter: (args) => createContractEventFilter(client, args),
        createEventFilter: (args) => createEventFilter(client, args),
        createPendingTransactionFilter: () => createPendingTransactionFilter(client),
        estimateContractGas: (args) => estimateContractGas(client, args),
        estimateGas: (args) => estimateGas$1(client, args),
        getBalance: (args) => getBalance(client, args),
        getBlobBaseFee: () => getBlobBaseFee(client),
        getBlock: (args) => getBlock(client, args),
        getBlockNumber: (args) => getBlockNumber(client, args),
        getBlockTransactionCount: (args) => getBlockTransactionCount(client, args),
        getBytecode: (args) => getCode$1(client, args),
        getChainId: () => getChainId(client),
        getCode: (args) => getCode$1(client, args),
        getContractEvents: (args) => getContractEvents(client, args),
        getEip712Domain: (args) => getEip712Domain$1(client, args),
        getEnsAddress: (args) => getEnsAddress(client, args),
        getEnsAvatar: (args) => getEnsAvatar(client, args),
        getEnsName: (args) => getEnsName(client, args),
        getEnsResolver: (args) => getEnsResolver(client, args),
        getEnsText: (args) => getEnsText(client, args),
        getFeeHistory: (args) => getFeeHistory(client, args),
        estimateFeesPerGas: (args) => estimateFeesPerGas$1(client, args),
        getFilterChanges: (args) => getFilterChanges(client, args),
        getFilterLogs: (args) => getFilterLogs(client, args),
        getGasPrice: () => getGasPrice(client),
        getLogs: (args) => getLogs(client, args),
        getProof: (args) => getProof(client, args),
        estimateMaxPriorityFeePerGas: (args) => estimateMaxPriorityFeePerGas(client, args),
        getStorageAt: (args) => getStorageAt(client, args),
        getTransaction: (args) => getTransaction(client, args),
        getTransactionConfirmations: (args) => getTransactionConfirmations(client, args),
        getTransactionCount: (args) => getTransactionCount(client, args),
        getTransactionReceipt: (args) => getTransactionReceipt(client, args),
        multicall: (args) => multicall(client, args),
        prepareTransactionRequest: (args) => prepareTransactionRequest(client, args),
        readContract: (args) => readContract(client, args),
        sendRawTransaction: (args) => sendRawTransaction(client, args),
        simulate: (args) => simulate(client, args),
        simulateContract: (args) => simulateContract(client, args),
        verifyMessage: (args) => verifyMessage(client, args),
        verifySiweMessage: (args) => verifySiweMessage(client, args),
        verifyTypedData: (args) => verifyTypedData(client, args),
        uninstallFilter: (args) => uninstallFilter(client, args),
        waitForTransactionReceipt: (args) => waitForTransactionReceipt(client, args),
        watchBlocks: (args) => watchBlocks(client, args),
        watchBlockNumber: (args) => watchBlockNumber(client, args),
        watchContractEvent: (args) => watchContractEvent(client, args),
        watchEvent: (args) => watchEvent(client, args),
        watchPendingTransactions: (args) => watchPendingTransactions(client, args),
    };
}

/**
 * Creates a Public Client with a given [Transport](https://viem.sh/docs/clients/intro) configured for a [Chain](https://viem.sh/docs/clients/chains).
 *
 * - Docs: https://viem.sh/docs/clients/public
 *
 * A Public Client is an interface to "public" [JSON-RPC API](https://ethereum.org/en/developers/docs/apis/json-rpc/) methods such as retrieving block numbers, transactions, reading from smart contracts, etc through [Public Actions](/docs/actions/public/introduction).
 *
 * @param config - {@link PublicClientConfig}
 * @returns A Public Client. {@link PublicClient}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 */
function createPublicClient(parameters) {
    const { key = 'public', name = 'Public Client' } = parameters;
    const client = createClient({
        ...parameters,
        key,
        name,
        type: 'publicClient',
    });
    return client.extend(publicActions);
}

/**
 * Deploys a contract to the network, given bytecode and constructor arguments.
 *
 * - Docs: https://viem.sh/docs/contract/deployContract
 * - Examples: https://stackblitz.com/github/wevm/viem/tree/main/examples/contracts_deploying-contracts
 *
 * @param client - Client to use
 * @param parameters - {@link DeployContractParameters}
 * @returns The [Transaction](https://viem.sh/docs/glossary/terms#transaction) hash. {@link DeployContractReturnType}
 *
 * @example
 * import { createWalletClient, http } from 'viem'
 * import { privateKeyToAccount } from 'viem/accounts'
 * import { mainnet } from 'viem/chains'
 * import { deployContract } from 'viem/contract'
 *
 * const client = createWalletClient({
 *   account: privateKeyToAccount('0x…'),
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const hash = await deployContract(client, {
 *   abi: [],
 *   account: '0x…,
 *   bytecode: '0x608060405260405161083e38038061083e833981016040819052610...',
 * })
 */
function deployContract(walletClient, parameters) {
    const { abi, args, bytecode, ...request } = parameters;
    const calldata = encodeDeployData({ abi, args, bytecode });
    return sendTransaction(walletClient, {
        ...request,
        data: calldata,
    });
}

/**
 * Returns a list of account addresses owned by the wallet or client.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/getAddresses
 * - JSON-RPC Methods: [`eth_accounts`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_accounts)
 *
 * @param client - Client to use
 * @returns List of account addresses owned by the wallet or client. {@link GetAddressesReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getAddresses } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const accounts = await getAddresses(client)
 */
async function getAddresses(client) {
    if (client.account?.type === 'local')
        return [client.account.address];
    const addresses = await client.request({ method: 'eth_accounts' }, { dedupe: true });
    return addresses.map((address) => checksumAddress(address));
}

/**
 * Gets the wallets current permissions.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/getPermissions
 * - JSON-RPC Methods: [`wallet_getPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @returns The wallet permissions. {@link GetPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await getPermissions(client)
 */
async function getPermissions(client) {
    const permissions = await client.request({ method: 'wallet_getPermissions' }, { dedupe: true });
    return permissions;
}

/**
 * Requests a list of accounts managed by a wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/requestAddresses
 * - JSON-RPC Methods: [`eth_requestAccounts`](https://eips.ethereum.org/EIPS/eip-1102)
 *
 * Sends a request to the wallet, asking for permission to access the user's accounts. After the user accepts the request, it will return a list of accounts (addresses).
 *
 * This API can be useful for dapps that need to access the user's accounts in order to execute transactions or interact with smart contracts.
 *
 * @param client - Client to use
 * @returns List of accounts managed by a wallet {@link RequestAddressesReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { requestAddresses } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const accounts = await requestAddresses(client)
 */
async function requestAddresses(client) {
    const addresses = await client.request({ method: 'eth_requestAccounts' }, { dedupe: true, retryCount: 0 });
    return addresses.map((address) => getAddress(address));
}

/**
 * Requests permissions for a wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/requestPermissions
 * - JSON-RPC Methods: [`wallet_requestPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @param parameters - {@link RequestPermissionsParameters}
 * @returns The wallet permissions. {@link RequestPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { requestPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await requestPermissions(client, {
 *   eth_accounts: {}
 * })
 */
async function requestPermissions(client, permissions) {
    return client.request({
        method: 'wallet_requestPermissions',
        params: [permissions],
    }, { retryCount: 0 });
}

/**
 * Calculates an Ethereum-specific signature in [EIP-191 format](https://eips.ethereum.org/EIPS/eip-191): `keccak256("\x19Ethereum Signed Message:\n" + len(message) + message))`.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/signMessage
 * - JSON-RPC Methods:
 *   - JSON-RPC Accounts: [`personal_sign`](https://docs.metamask.io/guide/signing-data#personal-sign)
 *   - Local Accounts: Signs locally. No JSON-RPC request.
 *
 * With the calculated signature, you can:
 * - use [`verifyMessage`](https://viem.sh/docs/utilities/verifyMessage) to verify the signature,
 * - use [`recoverMessageAddress`](https://viem.sh/docs/utilities/recoverMessageAddress) to recover the signing address from a signature.
 *
 * @param client - Client to use
 * @param parameters - {@link SignMessageParameters}
 * @returns The signed message. {@link SignMessageReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { signMessage } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const signature = await signMessage(client, {
 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
 *   message: 'hello world',
 * })
 *
 * @example
 * // Account Hoisting
 * import { createWalletClient, custom } from 'viem'
 * import { privateKeyToAccount } from 'viem/accounts'
 * import { mainnet } from 'viem/chains'
 * import { signMessage } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   account: privateKeyToAccount('0x…'),
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const signature = await signMessage(client, {
 *   message: 'hello world',
 * })
 */
async function signMessage$1(client, { account: account_ = client.account, message, }) {
    if (!account_)
        throw new AccountNotFoundError({
            docsPath: '/docs/actions/wallet/signMessage',
        });
    const account = parseAccount(account_);
    if (account.signMessage)
        return account.signMessage({ message });
    const message_ = (() => {
        if (typeof message === 'string')
            return stringToHex(message);
        if (message.raw instanceof Uint8Array)
            return toHex(message.raw);
        return message.raw;
    })();
    return client.request({
        method: 'personal_sign',
        params: [message_, account.address],
    }, { retryCount: 0 });
}

/**
 * Signs a transaction.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/signTransaction
 * - JSON-RPC Methods:
 *   - JSON-RPC Accounts: [`eth_signTransaction`](https://ethereum.github.io/execution-apis/api-documentation/)
 *   - Local Accounts: Signs locally. No JSON-RPC request.
 *
 * @param args - {@link SignTransactionParameters}
 * @returns The signed serialized transaction. {@link SignTransactionReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { signTransaction } from 'viem/actions'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const signature = await signTransaction(client, {
 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
 *   to: '0x0000000000000000000000000000000000000000',
 *   value: 1n,
 * })
 *
 * @example
 * // Account Hoisting
 * import { createWalletClient, http } from 'viem'
 * import { privateKeyToAccount } from 'viem/accounts'
 * import { mainnet } from 'viem/chains'
 * import { signTransaction } from 'viem/actions'
 *
 * const client = createWalletClient({
 *   account: privateKeyToAccount('0x…'),
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const signature = await signTransaction(client, {
 *   to: '0x0000000000000000000000000000000000000000',
 *   value: 1n,
 * })
 */
async function signTransaction$1(client, parameters) {
    const { account: account_ = client.account, chain = client.chain, ...transaction } = parameters;
    if (!account_)
        throw new AccountNotFoundError({
            docsPath: '/docs/actions/wallet/signTransaction',
        });
    const account = parseAccount(account_);
    assertRequest({
        account,
        ...parameters,
    });
    const chainId = await getAction(client, getChainId, 'getChainId')({});
    if (chain !== null)
        assertCurrentChain({
            currentChainId: chainId,
            chain,
        });
    const formatters = chain?.formatters || client.chain?.formatters;
    const format = formatters?.transactionRequest?.format || formatTransactionRequest;
    if (account.signTransaction)
        return account.signTransaction({
            ...transaction,
            chainId,
        }, { serializer: client.chain?.serializers?.transaction });
    return await client.request({
        method: 'eth_signTransaction',
        params: [
            {
                ...format(transaction),
                chainId: numberToHex(chainId),
                from: account.address,
            },
        ],
    }, { retryCount: 0 });
}

/**
 * Signs typed data and calculates an Ethereum-specific signature in [https://eips.ethereum.org/EIPS/eip-712](https://eips.ethereum.org/EIPS/eip-712): `sign(keccak256("\x19\x01" ‖ domainSeparator ‖ hashStruct(message)))`
 *
 * - Docs: https://viem.sh/docs/actions/wallet/signTypedData
 * - JSON-RPC Methods:
 *   - JSON-RPC Accounts: [`eth_signTypedData_v4`](https://docs.metamask.io/guide/signing-data#signtypeddata-v4)
 *   - Local Accounts: Signs locally. No JSON-RPC request.
 *
 * @param client - Client to use
 * @param parameters - {@link SignTypedDataParameters}
 * @returns The signed data. {@link SignTypedDataReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { signTypedData } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const signature = await signTypedData(client, {
 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
 *   domain: {
 *     name: 'Ether Mail',
 *     version: '1',
 *     chainId: 1,
 *     verifyingContract: '0xCcCCccccCCCCcCCCCCCcCcCccCcCCCcCcccccccC',
 *   },
 *   types: {
 *     Person: [
 *       { name: 'name', type: 'string' },
 *       { name: 'wallet', type: 'address' },
 *     ],
 *     Mail: [
 *       { name: 'from', type: 'Person' },
 *       { name: 'to', type: 'Person' },
 *       { name: 'contents', type: 'string' },
 *     ],
 *   },
 *   primaryType: 'Mail',
 *   message: {
 *     from: {
 *       name: 'Cow',
 *       wallet: '0xCD2a3d9F938E13CD947Ec05AbC7FE734Df8DD826',
 *     },
 *     to: {
 *       name: 'Bob',
 *       wallet: '0xbBbBBBBbbBBBbbbBbbBbbbbBBbBbbbbBbBbbBBbB',
 *     },
 *     contents: 'Hello, Bob!',
 *   },
 * })
 *
 * @example
 * // Account Hoisting
 * import { createWalletClient, http } from 'viem'
 * import { privateKeyToAccount } from 'viem/accounts'
 * import { mainnet } from 'viem/chains'
 * import { signTypedData } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   account: privateKeyToAccount('0x…'),
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const signature = await signTypedData(client, {
 *   domain: {
 *     name: 'Ether Mail',
 *     version: '1',
 *     chainId: 1,
 *     verifyingContract: '0xCcCCccccCCCCcCCCCCCcCcCccCcCCCcCcccccccC',
 *   },
 *   types: {
 *     Person: [
 *       { name: 'name', type: 'string' },
 *       { name: 'wallet', type: 'address' },
 *     ],
 *     Mail: [
 *       { name: 'from', type: 'Person' },
 *       { name: 'to', type: 'Person' },
 *       { name: 'contents', type: 'string' },
 *     ],
 *   },
 *   primaryType: 'Mail',
 *   message: {
 *     from: {
 *       name: 'Cow',
 *       wallet: '0xCD2a3d9F938E13CD947Ec05AbC7FE734Df8DD826',
 *     },
 *     to: {
 *       name: 'Bob',
 *       wallet: '0xbBbBBBBbbBBBbbbBbbBbbbbBBbBbbbbBbBbbBBbB',
 *     },
 *     contents: 'Hello, Bob!',
 *   },
 * })
 */
async function signTypedData$1(client, parameters) {
    const { account: account_ = client.account, domain, message, primaryType, } = parameters;
    if (!account_)
        throw new AccountNotFoundError({
            docsPath: '/docs/actions/wallet/signTypedData',
        });
    const account = parseAccount(account_);
    const types = {
        EIP712Domain: getTypesForEIP712Domain({ domain }),
        ...parameters.types,
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    validateTypedData({ domain, message, primaryType, types });
    if (account.signTypedData)
        return account.signTypedData({ domain, message, primaryType, types });
    const typedData = serializeTypedData({ domain, message, primaryType, types });
    return client.request({
        method: 'eth_signTypedData_v4',
        params: [account.address, typedData],
    }, { retryCount: 0 });
}

/**
 * Switch the target chain in a wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/switchChain
 * - JSON-RPC Methods: [`eth_switchEthereumChain`](https://eips.ethereum.org/EIPS/eip-3326)
 *
 * @param client - Client to use
 * @param parameters - {@link SwitchChainParameters}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet, optimism } from 'viem/chains'
 * import { switchChain } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * await switchChain(client, { id: optimism.id })
 */
async function switchChain(client, { id }) {
    await client.request({
        method: 'wallet_switchEthereumChain',
        params: [
            {
                chainId: numberToHex(id),
            },
        ],
    }, { retryCount: 0 });
}

/**
 * Adds an EVM chain to the wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/watchAsset
 * - JSON-RPC Methods: [`eth_switchEthereumChain`](https://eips.ethereum.org/EIPS/eip-747)
 *
 * @param client - Client to use
 * @param parameters - {@link WatchAssetParameters}
 * @returns Boolean indicating if the token was successfully added. {@link WatchAssetReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { watchAsset } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const success = await watchAsset(client, {
 *   type: 'ERC20',
 *   options: {
 *     address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
 *     decimals: 18,
 *     symbol: 'WETH',
 *   },
 * })
 */
async function watchAsset(client, params) {
    const added = await client.request({
        method: 'wallet_watchAsset',
        params,
    }, { retryCount: 0 });
    return added;
}

function walletActions(client) {
    return {
        addChain: (args) => addChain(client, args),
        deployContract: (args) => deployContract(client, args),
        getAddresses: () => getAddresses(client),
        getChainId: () => getChainId(client),
        getPermissions: () => getPermissions(client),
        prepareTransactionRequest: (args) => prepareTransactionRequest(client, args),
        requestAddresses: () => requestAddresses(client),
        requestPermissions: (args) => requestPermissions(client, args),
        sendRawTransaction: (args) => sendRawTransaction(client, args),
        sendTransaction: (args) => sendTransaction(client, args),
        signMessage: (args) => signMessage$1(client, args),
        signTransaction: (args) => signTransaction$1(client, args),
        signTypedData: (args) => signTypedData$1(client, args),
        switchChain: (args) => switchChain(client, args),
        watchAsset: (args) => watchAsset(client, args),
        writeContract: (args) => writeContract(client, args),
    };
}

function createWalletClient(parameters) {
    const { key = 'wallet', name = 'Wallet Client', transport } = parameters;
    const client = createClient({
        ...parameters,
        key,
        name,
        transport,
        type: 'walletClient',
    });
    return client.extend(walletActions);
}

// TODO(v3): Rename to `toLocalAccount` + add `source` property to define source (privateKey, mnemonic, hdKey, etc).
/**
 * @description Creates an Account from a custom signing implementation.
 *
 * @returns A Local Account.
 */
function toAccount(source) {
    if (typeof source === 'string') {
        if (!isAddress(source, { strict: false }))
            throw new InvalidAddressError({ address: source });
        return {
            address: source,
            type: 'json-rpc',
        };
    }
    if (!isAddress(source.address, { strict: false }))
        throw new InvalidAddressError({ address: source.address });
    return {
        address: source.address,
        nonceManager: source.nonceManager,
        sign: source.sign,
        experimental_signAuthorization: source.experimental_signAuthorization,
        signMessage: source.signMessage,
        signTransaction: source.signTransaction,
        signTypedData: source.signTypedData,
        source: 'custom',
        type: 'local',
    };
}

var version$d = "4.6.1";

/* eslint-disable */
/**
 * This is needed for the browser to work with buffer
 */
if (typeof window !== 'undefined') {
    window.global = globalThis;
    if (!window.Buffer && typeof window.Buffer === 'undefined') {
        Object.assign(window, { Buffer: bufferExports.Buffer });
    }
}

const logger$9 = new Logger$1('utils');

const ceil = (value, precision = 0) => {
    const multiplier = Math.pow(10, precision);
    return Math.ceil(value * multiplier) / multiplier;
};

/**
 * A DeferredPromise provides methods to manually resolve or reject a Promise.
 * This is useful in scenarios where you need to resolve or reject a Promise
 * outside of the executor function.
 *
 * @template T The type of the value with which the promise will be resolved.
 */
class DeferredPromise {
    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}

const isEip9693Event = (event) => event.type === 'eip6963:announceProvider' &&
    event.detail !== undefined;
const listenToEip6963Events = (handler) => {
    const eventHandler = (event) => {
        if (!isEip9693Event(event)) {
            return;
        }
        handler(event);
    };
    window.addEventListener('eip6963:announceProvider', eventHandler);
    return () => {
        window.removeEventListener('eip6963:announceProvider', eventHandler);
    };
};
class Eip6963Provider {
    constructor() {
        this.providers = [];
    }
    registerProviders() {
        if (typeof window === 'undefined') {
            return;
        }
        listenToEip6963Events((event) => {
            this.providers.push(event.detail);
        });
        window.dispatchEvent(new Event('eip6963:requestProvider'));
    }
}
class Eip6963ProviderSingleton {
    constructor() {
        this.eip6963Provider = new Eip6963Provider();
    }
    static get() {
        var _a;
        if (!((_a = Eip6963ProviderSingleton.instance) === null || _a === void 0 ? void 0 : _a.eip6963Provider)) {
            Eip6963ProviderSingleton.instance = new Eip6963ProviderSingleton();
            Eip6963ProviderSingleton.instance.eip6963Provider.registerProviders();
        }
        return Eip6963ProviderSingleton.instance.eip6963Provider;
    }
}

/**
 * Extend this class to allow usage of instanceof
 */
class CustomError extends Error {
    constructor(message, code) {
        super(message);
        this.code = undefined;
        this.code = code;
        Object.setPrototypeOf(this, this.constructor.prototype);
    }
    toJSON() {
        return {
            code: this.code,
            error: this.message,
        };
    }
}

class DynamicError extends CustomError {
}

class AccountExistsError extends DynamicError {
    constructor(errorMessage, errorPayload) {
        super(errorMessage);
        this.errorMessage = errorMessage;
        this.errorPayload = errorPayload;
    }
}

class ChainalysisError extends DynamicError {
    constructor(walletPublicKey) {
        super('This address is not approved for access');
        this.walletPublicKey = walletPublicKey;
    }
}

class SandboxMaximumThresholdReachedError extends DynamicError {
    constructor(errorMessage) {
        super(errorMessage);
        this.errorMessage = errorMessage;
    }
}

class EmailAlreadyExistsError extends DynamicError {
    constructor() {
        super('Email already exists');
    }
}

class EmailProviderError extends DynamicError {
    constructor(code) {
        super('EmailProviderError', code);
    }
}

class EmailVerificationError extends DynamicError {
    constructor(code) {
        super('EmailVerificationError', code);
    }
}

class GateBlockedError extends DynamicError {
    constructor(walletPublicKey) {
        super('This address is blocked by the gate');
        this.walletPublicKey = walletPublicKey;
    }
}

class InsufficientFundsError extends DynamicError {
    constructor() {
        super(InsufficientFundsError.message);
    }
    static isInstance(err) {
        var _a;
        const error = ((_a = err === null || err === void 0 ? void 0 : err.walk) === null || _a === void 0 ? void 0 : _a.call(err)) || err;
        return error instanceof InsufficientFundsError;
    }
    static isErrorMessage(err) {
        var _a;
        const errorWithMessage = err;
        return (((_a = errorWithMessage === null || errorWithMessage === void 0 ? void 0 : errorWithMessage.message) === null || _a === void 0 ? void 0 : _a.includes("AA21 didn't pay prefund")) || false);
    }
}
InsufficientFundsError.message = 'Insufficient funds.';

class MissingEnvironmentIdError extends DynamicError {
    constructor() {
        super('You are missing the environmentId field in yours DynamicContextProvider settings prop');
    }
}

class MissingPublicAddressError extends DynamicError {
    constructor() {
        super('Missing public address', 'missing-public-address');
    }
}

class NoAccessError extends DynamicError {
    constructor({ walletPublicKey, email, phoneNumber, socialProvider, socialUsername, }) {
        super('User does not have access');
        this.email = email;
        this.walletPublicKey = walletPublicKey;
        this.phoneNumber = phoneNumber;
        this.socialProvider = socialProvider;
        this.socialUsername = socialUsername;
    }
}

class SmsVerificationError extends DynamicError {
}

class SocialAccountAlreadyExistsError extends DynamicError {
    constructor() {
        super('Social account already exists');
    }
}

class TransactionGasCannotBeSponsoredError extends DynamicError {
    constructor() {
        super(TransactionGasCannotBeSponsoredError.message);
    }
    static isInstance(err) {
        var _a;
        const error = ((_a = err === null || err === void 0 ? void 0 : err.walk) === null || _a === void 0 ? void 0 : _a.call(err)) || err;
        return error instanceof TransactionGasCannotBeSponsoredError;
    }
    static isErrorMessage(err) {
        var _a;
        const errorWithMessage = err;
        return (((_a = errorWithMessage === null || errorWithMessage === void 0 ? void 0 : errorWithMessage.message) === null || _a === void 0 ? void 0 : _a.includes('userOp did not match any gas sponsoring policies')) || false);
    }
}
TransactionGasCannotBeSponsoredError.message = 'Transaction gas cannot be sponsored.';

class UserHasAccountWithEmailError extends DynamicError {
    constructor(error) {
        super(error);
        this.error = error;
    }
}

class UsernameAlreadyExistsError extends DynamicError {
    constructor() {
        super('Username already exists');
    }
}

class WalletNotDeployedError extends DynamicError {
    constructor() {
        super('Wallet has not been deployed', 'wallet_not_deployed');
    }
}

class WalletUsedError extends DynamicError {
    constructor(code) {
        super('WalletUsedError', code);
    }
}

class UserRejectedTransactionError extends DynamicError {
    constructor() {
        super('user rejected transaction');
    }
}

class TooManyEmailVerificationsError extends DynamicError {
    constructor() {
        super('Too many email verification attempts.');
    }
}

/** Used when trying to get necessary data for verification OTPs */
class VerificationDataCollectionError extends DynamicError {
    constructor(message) {
        super('Failed to get verification data: ' + message);
    }
}

class InvalidPhoneNumberError extends DynamicError {
    constructor(error) {
        super(error !== null && error !== void 0 ? error : 'Invalid phone number.');
    }
}

class MergeAccountsConfirmationError extends DynamicError {
    constructor({ code, mergeConflicts, walletAddress, }) {
        super('MergeAccountsConfirmationError', code);
        this.mergeConflicts = mergeConflicts;
        this.walletAddress = walletAddress;
    }
}

class CustomFieldNotUniqueError extends DynamicError {
    constructor() {
        super('Custom Field for user must be unique within the environment', 'custom_field_data_not_unique');
    }
}

class CookieInvalidError extends DynamicError {
    constructor() {
        super('The cookie is invalid or expired');
    }
}

class AccessBlockedError extends DynamicError {
}

class EmbeddedWalletException extends DynamicError {
    constructor(message) {
        super(message);
    }
}

class MfaInvalidOtpError extends DynamicError {
    constructor() {
        super('Invalid code');
    }
}

class MfaRateLimitedError extends DynamicError {
    constructor() {
        super('Rate limit reached');
    }
}

class WalletAddressMismatchError extends DynamicError {
    constructor(message, { activeAddress, expectedAddress, walletName, }) {
        super(message, 'wallet_address_mismatch_error');
        this.expectedAddress = expectedAddress;
        this.activeAddress = activeAddress;
        this.walletName = walletName;
    }
}

class UserRejectedRequestError extends DynamicError {
    constructor() {
        super('User rejected request', 'user_rejected_request');
    }
}

class InvalidEmbeddedWalletSessionKeyError extends DynamicError {
    constructor(error) {
        super(error !== null && error !== void 0 ? error : 'Invalid embedded wallet session key.');
    }
}

class EmbeddedWalletExistsError extends DynamicError {
    constructor(code) {
        super('EmbeddedWalletExistsError', code);
    }
}

/**
 * The EventTimeline is a utility that allows you to track the timeline of events
 * that occur in your application. It is useful to post events and query when
 * some event was last fired.
 */
const createEventTimeline = () => {
    // Map to store event names and their corresponding timestamps
    const eventTimelines = new Map();
    return {
        clear: () => {
            eventTimelines.clear();
        },
        isEventRecent: (eventName, timeSince) => {
            const now = Date.now();
            let timestamps = eventTimelines.get(eventName);
            if (!timestamps) {
                return false;
            }
            const cutoff = now - timeSince;
            // Remove timestamps older than the cutoff time
            timestamps = timestamps.filter((timestamp) => timestamp >= cutoff);
            // Check if there are any timestamps within the timeframe
            return timestamps.length > 0;
        },
        postEvent: (event) => {
            var _a;
            const now = Date.now();
            if (!eventTimelines.has(event)) {
                eventTimelines.set(event, []);
            }
            (_a = eventTimelines.get(event)) === null || _a === void 0 ? void 0 : _a.push(now);
        },
    };
};

const trimEnd = (text, char = '') => {
    let endIndex = text.length - 1;
    while (endIndex >= 0 && text[endIndex] === char) {
        endIndex--;
    }
    return text.slice(0, endIndex + 1);
};

const formatNumberText = (value, { precision = 0 } = {}) => {
    if (!precision) {
        return value;
    }
    const floatValue = parseFloat(value);
    const formattedAtPrecision = ceil(floatValue, precision).toFixed(precision);
    const [integerPart, decimalPart] = formattedAtPrecision.split('.');
    const decimalPartTrimmed = trimEnd(decimalPart, '0');
    return `${integerPart}.${decimalPartTrimmed || '0'}`;
};

/**
 * return the destination (value)
 *
 * @param {string} path - path in the obj to the item
 * @returns {T[]} - array of found items
 */
const getProvidersFromWindow = (path) => {
    const splitPath = path.split('.');
    let result = window;
    const foundProviders = [];
    for (const [index, p] of Object.entries(splitPath)) {
        result = result[p];
        if (typeof result !== 'object' || result === null) {
            return [];
        }
        // we need to check if we have hit the end of the requested path
        if (Number(index) === splitPath.length - 1) {
            if (Array.isArray(result)) {
                result.forEach((p) => foundProviders.push(p));
            }
            else {
                if (result.providers) {
                    result.providers.forEach((p) => foundProviders.push(p));
                }
                else {
                    foundProviders.push(result);
                }
            }
        }
    }
    return foundProviders;
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter$d(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __classPrivateFieldGet$5(receiver, state, kind, f) {
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet$4(receiver, state, value, kind, f) {
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (f ? f.value = value : state.set(receiver, value)), value;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Check if `vhost` is a valid suffix of `hostname` (top-domain)
 *
 * It means that `vhost` needs to be a suffix of `hostname` and we then need to
 * make sure that: either they are equal, or the character preceding `vhost` in
 * `hostname` is a '.' (it should not be a partial label).
 *
 * * hostname = 'not.evil.com' and vhost = 'vil.com'      => not ok
 * * hostname = 'not.evil.com' and vhost = 'evil.com'     => ok
 * * hostname = 'not.evil.com' and vhost = 'not.evil.com' => ok
 */
function shareSameDomainSuffix(hostname, vhost) {
    if (hostname.endsWith(vhost)) {
        return (hostname.length === vhost.length ||
            hostname[hostname.length - vhost.length - 1] === '.');
    }
    return false;
}
/**
 * Given a hostname and its public suffix, extract the general domain.
 */
function extractDomainWithSuffix(hostname, publicSuffix) {
    // Locate the index of the last '.' in the part of the `hostname` preceding
    // the public suffix.
    //
    // examples:
    //   1. not.evil.co.uk  => evil.co.uk
    //         ^    ^
    //         |    | start of public suffix
    //         | index of the last dot
    //
    //   2. example.co.uk   => example.co.uk
    //     ^       ^
    //     |       | start of public suffix
    //     |
    //     | (-1) no dot found before the public suffix
    const publicSuffixIndex = hostname.length - publicSuffix.length - 2;
    const lastDotBeforeSuffixIndex = hostname.lastIndexOf('.', publicSuffixIndex);
    // No '.' found, then `hostname` is the general domain (no sub-domain)
    if (lastDotBeforeSuffixIndex === -1) {
        return hostname;
    }
    // Extract the part between the last '.'
    return hostname.slice(lastDotBeforeSuffixIndex + 1);
}
/**
 * Detects the domain based on rules and upon and a host string
 */
function getDomain(suffix, hostname, options) {
    // Check if `hostname` ends with a member of `validHosts`.
    if (options.validHosts !== null) {
        const validHosts = options.validHosts;
        for (const vhost of validHosts) {
            if ( /*@__INLINE__*/shareSameDomainSuffix(hostname, vhost)) {
                return vhost;
            }
        }
    }
    let numberOfLeadingDots = 0;
    if (hostname.startsWith('.')) {
        while (numberOfLeadingDots < hostname.length &&
            hostname[numberOfLeadingDots] === '.') {
            numberOfLeadingDots += 1;
        }
    }
    // If `hostname` is a valid public suffix, then there is no domain to return.
    // Since we already know that `getPublicSuffix` returns a suffix of `hostname`
    // there is no need to perform a string comparison and we only compare the
    // size.
    if (suffix.length === hostname.length - numberOfLeadingDots) {
        return null;
    }
    // To extract the general domain, we start by identifying the public suffix
    // (if any), then consider the domain to be the public suffix with one added
    // level of depth. (e.g.: if hostname is `not.evil.co.uk` and public suffix:
    // `co.uk`, then we take one more level: `evil`, giving the final result:
    // `evil.co.uk`).
    return /*@__INLINE__*/ extractDomainWithSuffix(hostname, suffix);
}

/**
 * Return the part of domain without suffix.
 *
 * Example: for domain 'foo.com', the result would be 'foo'.
 */
function getDomainWithoutSuffix(domain, suffix) {
    // Note: here `domain` and `suffix` cannot have the same length because in
    // this case we set `domain` to `null` instead. It is thus safe to assume
    // that `suffix` is shorter than `domain`.
    return domain.slice(0, -suffix.length - 1);
}

/**
 * @param url - URL we want to extract a hostname from.
 * @param urlIsValidHostname - hint from caller; true if `url` is already a valid hostname.
 */
function extractHostname(url, urlIsValidHostname) {
    let start = 0;
    let end = url.length;
    let hasUpper = false;
    // If url is not already a valid hostname, then try to extract hostname.
    if (!urlIsValidHostname) {
        // Special handling of data URLs
        if (url.startsWith('data:')) {
            return null;
        }
        // Trim leading spaces
        while (start < url.length && url.charCodeAt(start) <= 32) {
            start += 1;
        }
        // Trim trailing spaces
        while (end > start + 1 && url.charCodeAt(end - 1) <= 32) {
            end -= 1;
        }
        // Skip scheme.
        if (url.charCodeAt(start) === 47 /* '/' */ &&
            url.charCodeAt(start + 1) === 47 /* '/' */) {
            start += 2;
        }
        else {
            const indexOfProtocol = url.indexOf(':/', start);
            if (indexOfProtocol !== -1) {
                // Implement fast-path for common protocols. We expect most protocols
                // should be one of these 4 and thus we will not need to perform the
                // more expansive validity check most of the time.
                const protocolSize = indexOfProtocol - start;
                const c0 = url.charCodeAt(start);
                const c1 = url.charCodeAt(start + 1);
                const c2 = url.charCodeAt(start + 2);
                const c3 = url.charCodeAt(start + 3);
                const c4 = url.charCodeAt(start + 4);
                if (protocolSize === 5 &&
                    c0 === 104 /* 'h' */ &&
                    c1 === 116 /* 't' */ &&
                    c2 === 116 /* 't' */ &&
                    c3 === 112 /* 'p' */ &&
                    c4 === 115 /* 's' */) ;
                else if (protocolSize === 4 &&
                    c0 === 104 /* 'h' */ &&
                    c1 === 116 /* 't' */ &&
                    c2 === 116 /* 't' */ &&
                    c3 === 112 /* 'p' */) ;
                else if (protocolSize === 3 &&
                    c0 === 119 /* 'w' */ &&
                    c1 === 115 /* 's' */ &&
                    c2 === 115 /* 's' */) ;
                else if (protocolSize === 2 &&
                    c0 === 119 /* 'w' */ &&
                    c1 === 115 /* 's' */) ;
                else {
                    // Check that scheme is valid
                    for (let i = start; i < indexOfProtocol; i += 1) {
                        const lowerCaseCode = url.charCodeAt(i) | 32;
                        if (!(((lowerCaseCode >= 97 && lowerCaseCode <= 122) || // [a, z]
                            (lowerCaseCode >= 48 && lowerCaseCode <= 57) || // [0, 9]
                            lowerCaseCode === 46 || // '.'
                            lowerCaseCode === 45 || // '-'
                            lowerCaseCode === 43) // '+'
                        )) {
                            return null;
                        }
                    }
                }
                // Skip 0, 1 or more '/' after ':/'
                start = indexOfProtocol + 2;
                while (url.charCodeAt(start) === 47 /* '/' */) {
                    start += 1;
                }
            }
        }
        // Detect first occurrence of '/', '?' or '#'. We also keep track of the
        // last occurrence of '@', ']' or ':' to speed-up subsequent parsing of
        // (respectively), identifier, ipv6 or port.
        let indexOfIdentifier = -1;
        let indexOfClosingBracket = -1;
        let indexOfPort = -1;
        for (let i = start; i < end; i += 1) {
            const code = url.charCodeAt(i);
            if (code === 35 || // '#'
                code === 47 || // '/'
                code === 63 // '?'
            ) {
                end = i;
                break;
            }
            else if (code === 64) {
                // '@'
                indexOfIdentifier = i;
            }
            else if (code === 93) {
                // ']'
                indexOfClosingBracket = i;
            }
            else if (code === 58) {
                // ':'
                indexOfPort = i;
            }
            else if (code >= 65 && code <= 90) {
                hasUpper = true;
            }
        }
        // Detect identifier: '@'
        if (indexOfIdentifier !== -1 &&
            indexOfIdentifier > start &&
            indexOfIdentifier < end) {
            start = indexOfIdentifier + 1;
        }
        // Handle ipv6 addresses
        if (url.charCodeAt(start) === 91 /* '[' */) {
            if (indexOfClosingBracket !== -1) {
                return url.slice(start + 1, indexOfClosingBracket).toLowerCase();
            }
            return null;
        }
        else if (indexOfPort !== -1 && indexOfPort > start && indexOfPort < end) {
            // Detect port: ':'
            end = indexOfPort;
        }
    }
    // Trim trailing dots
    while (end > start + 1 && url.charCodeAt(end - 1) === 46 /* '.' */) {
        end -= 1;
    }
    const hostname = start !== 0 || end !== url.length ? url.slice(start, end) : url;
    if (hasUpper) {
        return hostname.toLowerCase();
    }
    return hostname;
}

/**
 * Check if a hostname is an IP. You should be aware that this only works
 * because `hostname` is already garanteed to be a valid hostname!
 */
function isProbablyIpv4(hostname) {
    // Cannot be shorted than 1.1.1.1
    if (hostname.length < 7) {
        return false;
    }
    // Cannot be longer than: 255.255.255.255
    if (hostname.length > 15) {
        return false;
    }
    let numberOfDots = 0;
    for (let i = 0; i < hostname.length; i += 1) {
        const code = hostname.charCodeAt(i);
        if (code === 46 /* '.' */) {
            numberOfDots += 1;
        }
        else if (code < 48 /* '0' */ || code > 57 /* '9' */) {
            return false;
        }
    }
    return (numberOfDots === 3 &&
        hostname.charCodeAt(0) !== 46 /* '.' */ &&
        hostname.charCodeAt(hostname.length - 1) !== 46 /* '.' */);
}
/**
 * Similar to isProbablyIpv4.
 */
function isProbablyIpv6(hostname) {
    if (hostname.length < 3) {
        return false;
    }
    let start = hostname.startsWith('[') ? 1 : 0;
    let end = hostname.length;
    if (hostname[end - 1] === ']') {
        end -= 1;
    }
    // We only consider the maximum size of a normal IPV6. Note that this will
    // fail on so-called "IPv4 mapped IPv6 addresses" but this is a corner-case
    // and a proper validation library should be used for these.
    if (end - start > 39) {
        return false;
    }
    let hasColon = false;
    for (; start < end; start += 1) {
        const code = hostname.charCodeAt(start);
        if (code === 58 /* ':' */) {
            hasColon = true;
        }
        else if (!(((code >= 48 && code <= 57) || // 0-9
            (code >= 97 && code <= 102) || // a-f
            (code >= 65 && code <= 90)) // A-F
        )) {
            return false;
        }
    }
    return hasColon;
}
/**
 * Check if `hostname` is *probably* a valid ip addr (either ipv6 or ipv4).
 * This *will not* work on any string. We need `hostname` to be a valid
 * hostname.
 */
function isIp(hostname) {
    return isProbablyIpv6(hostname) || isProbablyIpv4(hostname);
}

/**
 * Implements fast shallow verification of hostnames. This does not perform a
 * struct check on the content of labels (classes of Unicode characters, etc.)
 * but instead check that the structure is valid (number of labels, length of
 * labels, etc.).
 *
 * If you need stricter validation, consider using an external library.
 */
function isValidAscii(code) {
    return ((code >= 97 && code <= 122) || (code >= 48 && code <= 57) || code > 127);
}
/**
 * Check if a hostname string is valid. It's usually a preliminary check before
 * trying to use getDomain or anything else.
 *
 * Beware: it does not check if the TLD exists.
 */
function isValidHostname (hostname) {
    if (hostname.length > 255) {
        return false;
    }
    if (hostname.length === 0) {
        return false;
    }
    if (
    /*@__INLINE__*/ !isValidAscii(hostname.charCodeAt(0)) &&
        hostname.charCodeAt(0) !== 46 && // '.' (dot)
        hostname.charCodeAt(0) !== 95 // '_' (underscore)
    ) {
        return false;
    }
    // Validate hostname according to RFC
    let lastDotIndex = -1;
    let lastCharCode = -1;
    const len = hostname.length;
    for (let i = 0; i < len; i += 1) {
        const code = hostname.charCodeAt(i);
        if (code === 46 /* '.' */) {
            if (
            // Check that previous label is < 63 bytes long (64 = 63 + '.')
            i - lastDotIndex > 64 ||
                // Check that previous character was not already a '.'
                lastCharCode === 46 ||
                // Check that the previous label does not end with a '-' (dash)
                lastCharCode === 45 ||
                // Check that the previous label does not end with a '_' (underscore)
                lastCharCode === 95) {
                return false;
            }
            lastDotIndex = i;
        }
        else if (!( /*@__INLINE__*/(isValidAscii(code) || code === 45 || code === 95))) {
            // Check if there is a forbidden character in the label
            return false;
        }
        lastCharCode = code;
    }
    return (
    // Check that last label is shorter than 63 chars
    len - lastDotIndex - 1 <= 63 &&
        // Check that the last character is an allowed trailing label character.
        // Since we already checked that the char is a valid hostname character,
        // we only need to check that it's different from '-'.
        lastCharCode !== 45);
}

function setDefaultsImpl({ allowIcannDomains = true, allowPrivateDomains = false, detectIp = true, extractHostname = true, mixedInputs = true, validHosts = null, validateHostname = true, }) {
    return {
        allowIcannDomains,
        allowPrivateDomains,
        detectIp,
        extractHostname,
        mixedInputs,
        validHosts,
        validateHostname,
    };
}
const DEFAULT_OPTIONS = /*@__INLINE__*/ setDefaultsImpl({});
function setDefaults$1(options) {
    if (options === undefined) {
        return DEFAULT_OPTIONS;
    }
    return /*@__INLINE__*/ setDefaultsImpl(options);
}

/**
 * Returns the subdomain of a hostname string
 */
function getSubdomain(hostname, domain) {
    // If `hostname` and `domain` are the same, then there is no sub-domain
    if (domain.length === hostname.length) {
        return '';
    }
    return hostname.slice(0, -domain.length - 1);
}

/**
 * Implement a factory allowing to plug different implementations of suffix
 * lookup (e.g.: using a trie or the packed hashes datastructures). This is used
 * and exposed in `tldts.ts` and `tldts-experimental.ts` bundle entrypoints.
 */
function getEmptyResult() {
    return {
        domain: null,
        domainWithoutSuffix: null,
        hostname: null,
        isIcann: null,
        isIp: null,
        isPrivate: null,
        publicSuffix: null,
        subdomain: null,
    };
}
function parseImpl(url, step, suffixLookup, partialOptions, result) {
    const options = /*@__INLINE__*/ setDefaults$1(partialOptions);
    // Very fast approximate check to make sure `url` is a string. This is needed
    // because the library will not necessarily be used in a typed setup and
    // values of arbitrary types might be given as argument.
    if (typeof url !== 'string') {
        return result;
    }
    // Extract hostname from `url` only if needed. This can be made optional
    // using `options.extractHostname`. This option will typically be used
    // whenever we are sure the inputs to `parse` are already hostnames and not
    // arbitrary URLs.
    //
    // `mixedInput` allows to specify if we expect a mix of URLs and hostnames
    // as input. If only hostnames are expected then `extractHostname` can be
    // set to `false` to speed-up parsing. If only URLs are expected then
    // `mixedInputs` can be set to `false`. The `mixedInputs` is only a hint
    // and will not change the behavior of the library.
    if (!options.extractHostname) {
        result.hostname = url;
    }
    else if (options.mixedInputs) {
        result.hostname = extractHostname(url, isValidHostname(url));
    }
    else {
        result.hostname = extractHostname(url, false);
    }
    if (result.hostname === null) {
        return result;
    }
    // Check if `hostname` is a valid ip address
    if (options.detectIp) {
        result.isIp = isIp(result.hostname);
        if (result.isIp) {
            return result;
        }
    }
    // Perform optional hostname validation. If hostname is not valid, no need to
    // go further as there will be no valid domain or sub-domain.
    if (options.validateHostname &&
        options.extractHostname &&
        !isValidHostname(result.hostname)) {
        result.hostname = null;
        return result;
    }
    // Extract public suffix
    suffixLookup(result.hostname, options, result);
    if (result.publicSuffix === null) {
        return result;
    }
    // Extract domain
    result.domain = getDomain(result.publicSuffix, result.hostname, options);
    if (result.domain === null) {
        return result;
    }
    // Extract subdomain
    result.subdomain = getSubdomain(result.hostname, result.domain);
    // Extract domain without suffix
    result.domainWithoutSuffix = getDomainWithoutSuffix(result.domain, result.publicSuffix);
    return result;
}

function fastPathLookup (hostname, options, out) {
    // Fast path for very popular suffixes; this allows to by-pass lookup
    // completely as well as any extra allocation or string manipulation.
    if (!options.allowPrivateDomains && hostname.length > 3) {
        const last = hostname.length - 1;
        const c3 = hostname.charCodeAt(last);
        const c2 = hostname.charCodeAt(last - 1);
        const c1 = hostname.charCodeAt(last - 2);
        const c0 = hostname.charCodeAt(last - 3);
        if (c3 === 109 /* 'm' */ &&
            c2 === 111 /* 'o' */ &&
            c1 === 99 /* 'c' */ &&
            c0 === 46 /* '.' */) {
            out.isIcann = true;
            out.isPrivate = false;
            out.publicSuffix = 'com';
            return true;
        }
        else if (c3 === 103 /* 'g' */ &&
            c2 === 114 /* 'r' */ &&
            c1 === 111 /* 'o' */ &&
            c0 === 46 /* '.' */) {
            out.isIcann = true;
            out.isPrivate = false;
            out.publicSuffix = 'org';
            return true;
        }
        else if (c3 === 117 /* 'u' */ &&
            c2 === 100 /* 'd' */ &&
            c1 === 101 /* 'e' */ &&
            c0 === 46 /* '.' */) {
            out.isIcann = true;
            out.isPrivate = false;
            out.publicSuffix = 'edu';
            return true;
        }
        else if (c3 === 118 /* 'v' */ &&
            c2 === 111 /* 'o' */ &&
            c1 === 103 /* 'g' */ &&
            c0 === 46 /* '.' */) {
            out.isIcann = true;
            out.isPrivate = false;
            out.publicSuffix = 'gov';
            return true;
        }
        else if (c3 === 116 /* 't' */ &&
            c2 === 101 /* 'e' */ &&
            c1 === 110 /* 'n' */ &&
            c0 === 46 /* '.' */) {
            out.isIcann = true;
            out.isPrivate = false;
            out.publicSuffix = 'net';
            return true;
        }
        else if (c3 === 101 /* 'e' */ &&
            c2 === 100 /* 'd' */ &&
            c1 === 46 /* '.' */) {
            out.isIcann = true;
            out.isPrivate = false;
            out.publicSuffix = 'de';
            return true;
        }
    }
    return false;
}

const exceptions = (function () {
    const _0 = [1, {}], _1 = [0, { "city": _0 }];
    const exceptions = [0, { "ck": [0, { "www": _0 }], "jp": [0, { "kawasaki": _1, "kitakyushu": _1, "kobe": _1, "nagoya": _1, "sapporo": _1, "sendai": _1, "yokohama": _1 }] }];
    return exceptions;
})();
const rules = (function () {
    const _2 = [1, {}], _3 = [2, {}], _4 = [1, { "gov": _2, "com": _2, "org": _2, "net": _2, "edu": _2 }], _5 = [0, { "*": _3 }], _6 = [1, { "blogspot": _3 }], _7 = [1, { "gov": _2 }], _8 = [0, { "*": _2 }], _9 = [0, { "cloud": _3 }], _10 = [1, { "co": _3 }], _11 = [2, { "nodes": _3 }], _12 = [0, { "s3": _3 }], _13 = [0, { "direct": _3 }], _14 = [2, { "id": _3 }], _15 = [0, { "webview-assets": _3 }], _16 = [0, { "vfs": _3, "webview-assets": _3 }], _17 = [0, { "aws-cloud9": _15, "cloud9": _16 }], _18 = [0, { "dualstack": _12, "analytics-gateway": _3, "aws-cloud9": _15, "cloud9": _16 }], _19 = [0, { "dualstack": _12, "s3": _3, "s3-website": _3, "aws-cloud9": _15, "cloud9": _16 }], _20 = [0, { "dualstack": _12, "aws-cloud9": _15, "cloud9": _16 }], _21 = [0, { "apps": _3 }], _22 = [0, { "paas": _3 }], _23 = [0, { "app": _3 }], _24 = [2, { "eu": _3 }], _25 = [0, { "site": _3 }], _26 = [0, { "pages": _3 }], _27 = [1, { "com": _2, "edu": _2, "net": _2, "org": _2 }], _28 = [0, { "j": _3 }], _29 = [0, { "jelastic": _3 }], _30 = [0, { "user": _3 }], _31 = [1, { "ybo": _3 }], _32 = [0, { "cust": _3, "reservd": _3 }], _33 = [0, { "cust": _3 }], _34 = [1, { "gov": _2, "edu": _2, "mil": _2, "com": _2, "org": _2, "net": _2 }], _35 = [1, { "edu": _2, "biz": _2, "net": _2, "org": _2, "gov": _2, "info": _2, "com": _2 }], _36 = [1, { "gov": _2, "blogspot": _3 }], _37 = [1, { "framer": _3 }], _38 = [1, { "barsy": _3 }], _39 = [0, { "forgot": _3 }], _40 = [1, { "gs": _2 }], _41 = [0, { "nes": _2 }], _42 = [1, { "k12": _2, "cc": _2, "lib": _2 }], _43 = [1, { "cc": _2, "lib": _2 }];
    const rules = [0, { "ac": [1, { "com": _2, "edu": _2, "gov": _2, "net": _2, "mil": _2, "org": _2, "drr": _3 }], "ad": [1, { "nom": _2 }], "ae": [1, { "co": _2, "net": _2, "org": _2, "sch": _2, "ac": _2, "gov": _2, "mil": _2, "blogspot": _3 }], "aero": [1, { "accident-investigation": _2, "accident-prevention": _2, "aerobatic": _2, "aeroclub": _2, "aerodrome": _2, "agents": _2, "aircraft": _2, "airline": _2, "airport": _2, "air-surveillance": _2, "airtraffic": _2, "air-traffic-control": _2, "ambulance": _2, "amusement": _2, "association": _2, "author": _2, "ballooning": _2, "broker": _2, "caa": _2, "cargo": _2, "catering": _2, "certification": _2, "championship": _2, "charter": _2, "civilaviation": _2, "club": _2, "conference": _2, "consultant": _2, "consulting": _2, "control": _2, "council": _2, "crew": _2, "design": _2, "dgca": _2, "educator": _2, "emergency": _2, "engine": _2, "engineer": _2, "entertainment": _2, "equipment": _2, "exchange": _2, "express": _2, "federation": _2, "flight": _2, "fuel": _2, "gliding": _2, "government": _2, "groundhandling": _2, "group": _2, "hanggliding": _2, "homebuilt": _2, "insurance": _2, "journal": _2, "journalist": _2, "leasing": _2, "logistics": _2, "magazine": _2, "maintenance": _2, "media": _2, "microlight": _2, "modelling": _2, "navigation": _2, "parachuting": _2, "paragliding": _2, "passenger-association": _2, "pilot": _2, "press": _2, "production": _2, "recreation": _2, "repbody": _2, "res": _2, "research": _2, "rotorcraft": _2, "safety": _2, "scientist": _2, "services": _2, "show": _2, "skydiving": _2, "software": _2, "student": _2, "trader": _2, "trading": _2, "trainer": _2, "union": _2, "workinggroup": _2, "works": _2 }], "af": _4, "ag": [1, { "com": _2, "org": _2, "net": _2, "co": _2, "nom": _2 }], "ai": [1, { "off": _2, "com": _2, "net": _2, "org": _2, "uwu": _3 }], "al": [1, { "com": _2, "edu": _2, "gov": _2, "mil": _2, "net": _2, "org": _2, "blogspot": _3 }], "am": [1, { "co": _2, "com": _2, "commune": _2, "net": _2, "org": _2, "radio": _3, "blogspot": _3, "neko": _3, "nyaa": _3 }], "ao": [1, { "ed": _2, "gv": _2, "og": _2, "co": _2, "pb": _2, "it": _2 }], "aq": _2, "ar": [1, { "bet": _2, "com": _6, "coop": _2, "edu": _2, "gob": _2, "gov": _2, "int": _2, "mil": _2, "musica": _2, "mutual": _2, "net": _2, "org": _2, "senasa": _2, "tur": _2 }], "arpa": [1, { "e164": _2, "in-addr": _2, "ip6": _2, "iris": _2, "uri": _2, "urn": _2 }], "as": _7, "asia": [1, { "cloudns": _3 }], "at": [1, { "ac": [1, { "sth": _2 }], "co": _6, "gv": _2, "or": _2, "funkfeuer": [0, { "wien": _3 }], "futurecms": [0, { "*": _3, "ex": _5, "in": _5 }], "futurehosting": _3, "futuremailing": _3, "ortsinfo": [0, { "ex": _5, "kunden": _5 }], "biz": _3, "info": _3, "123webseite": _3, "priv": _3, "myspreadshop": _3, "12hp": _3, "2ix": _3, "4lima": _3, "lima-city": _3 }], "au": [1, { "com": [1, { "blogspot": _3, "cloudlets": [0, { "mel": _3 }], "myspreadshop": _3 }], "net": _2, "org": _2, "edu": [1, { "act": _2, "catholic": _2, "nsw": [1, { "schools": _2 }], "nt": _2, "qld": _2, "sa": _2, "tas": _2, "vic": _2, "wa": _2 }], "gov": [1, { "qld": _2, "sa": _2, "tas": _2, "vic": _2, "wa": _2 }], "asn": _2, "id": _2, "info": _2, "conf": _2, "oz": _2, "act": _2, "nsw": _2, "nt": _2, "qld": _2, "sa": _2, "tas": _2, "vic": _2, "wa": _2 }], "aw": [1, { "com": _2 }], "ax": [1, { "be": _3, "cat": _3, "es": _3, "eu": _3, "gg": _3, "mc": _3, "us": _3, "xy": _3 }], "az": [1, { "com": _2, "net": _2, "int": _2, "gov": _2, "org": _2, "edu": _2, "info": _2, "pp": _2, "mil": _2, "name": _2, "pro": _2, "biz": _2 }], "ba": [1, { "com": _2, "edu": _2, "gov": _2, "mil": _2, "net": _2, "org": _2, "rs": _3, "blogspot": _3 }], "bb": [1, { "biz": _2, "co": _2, "com": _2, "edu": _2, "gov": _2, "info": _2, "net": _2, "org": _2, "store": _2, "tv": _2 }], "bd": _8, "be": [1, { "ac": _2, "webhosting": _3, "blogspot": _3, "interhostsolutions": _9, "kuleuven": [0, { "ezproxy": _3 }], "123website": _3, "myspreadshop": _3, "transurl": _5 }], "bf": _7, "bg": [1, { "0": _2, "1": _2, "2": _2, "3": _2, "4": _2, "5": _2, "6": _2, "7": _2, "8": _2, "9": _2, "a": _2, "b": _2, "c": _2, "d": _2, "e": _2, "f": _2, "g": _2, "h": _2, "i": _2, "j": _2, "k": _2, "l": _2, "m": _2, "n": _2, "o": _2, "p": _2, "q": _2, "r": _2, "s": _2, "t": _2, "u": _2, "v": _2, "w": _2, "x": _2, "y": _2, "z": _2, "blogspot": _3, "barsy": _3 }], "bh": _4, "bi": [1, { "co": _2, "com": _2, "edu": _2, "or": _2, "org": _2 }], "biz": [1, { "activetrail": _3, "cloudns": _3, "jozi": _3, "dyndns": _3, "for-better": _3, "for-more": _3, "for-some": _3, "for-the": _3, "selfip": _3, "webhop": _3, "orx": _3, "mmafan": _3, "myftp": _3, "no-ip": _3, "dscloud": _3 }], "bj": [1, { "africa": _2, "agro": _2, "architectes": _2, "assur": _2, "avocats": _2, "co": _2, "com": _2, "eco": _2, "econo": _2, "edu": _2, "info": _2, "loisirs": _2, "money": _2, "net": _2, "org": _2, "ote": _2, "resto": _2, "restaurant": _2, "tourism": _2, "univ": _2, "blogspot": _3 }], "bm": _4, "bn": [1, { "com": _2, "edu": _2, "gov": _2, "net": _2, "org": _2, "co": _3 }], "bo": [1, { "com": _2, "edu": _2, "gob": _2, "int": _2, "org": _2, "net": _2, "mil": _2, "tv": _2, "web": _2, "academia": _2, "agro": _2, "arte": _2, "blog": _2, "bolivia": _2, "ciencia": _2, "cooperativa": _2, "democracia": _2, "deporte": _2, "ecologia": _2, "economia": _2, "empresa": _2, "indigena": _2, "industria": _2, "info": _2, "medicina": _2, "movimiento": _2, "musica": _2, "natural": _2, "nombre": _2, "noticias": _2, "patria": _2, "politica": _2, "profesional": _2, "plurinacional": _2, "pueblo": _2, "revista": _2, "salud": _2, "tecnologia": _2, "tksat": _2, "transporte": _2, "wiki": _2 }], "br": [1, { "9guacu": _2, "abc": _2, "adm": _2, "adv": _2, "agr": _2, "aju": _2, "am": _2, "anani": _2, "aparecida": _2, "app": _2, "arq": _2, "art": _2, "ato": _2, "b": _2, "barueri": _2, "belem": _2, "bhz": _2, "bib": _2, "bio": _2, "blog": _2, "bmd": _2, "boavista": _2, "bsb": _2, "campinagrande": _2, "campinas": _2, "caxias": _2, "cim": _2, "cng": _2, "cnt": _2, "com": [1, { "blogspot": _3, "simplesite": _3 }], "contagem": _2, "coop": _2, "coz": _2, "cri": _2, "cuiaba": _2, "curitiba": _2, "def": _2, "des": _2, "det": _2, "dev": _2, "ecn": _2, "eco": _2, "edu": _2, "emp": _2, "enf": _2, "eng": _2, "esp": _2, "etc": _2, "eti": _2, "far": _2, "feira": _2, "flog": _2, "floripa": _2, "fm": _2, "fnd": _2, "fortal": _2, "fot": _2, "foz": _2, "fst": _2, "g12": _2, "geo": _2, "ggf": _2, "goiania": _2, "gov": [1, { "ac": _2, "al": _2, "am": _2, "ap": _2, "ba": _2, "ce": _2, "df": _2, "es": _2, "go": _2, "ma": _2, "mg": _2, "ms": _2, "mt": _2, "pa": _2, "pb": _2, "pe": _2, "pi": _2, "pr": _2, "rj": _2, "rn": _2, "ro": _2, "rr": _2, "rs": _2, "sc": _2, "se": _2, "sp": _2, "to": _2 }], "gru": _2, "imb": _2, "ind": _2, "inf": _2, "jab": _2, "jampa": _2, "jdf": _2, "joinville": _2, "jor": _2, "jus": _2, "leg": [1, { "ac": _3, "al": _3, "am": _3, "ap": _3, "ba": _3, "ce": _3, "df": _3, "es": _3, "go": _3, "ma": _3, "mg": _3, "ms": _3, "mt": _3, "pa": _3, "pb": _3, "pe": _3, "pi": _3, "pr": _3, "rj": _3, "rn": _3, "ro": _3, "rr": _3, "rs": _3, "sc": _3, "se": _3, "sp": _3, "to": _3 }], "lel": _2, "log": _2, "londrina": _2, "macapa": _2, "maceio": _2, "manaus": _2, "maringa": _2, "mat": _2, "med": _2, "mil": _2, "morena": _2, "mp": _2, "mus": _2, "natal": _2, "net": _2, "niteroi": _2, "nom": _8, "not": _2, "ntr": _2, "odo": _2, "ong": _2, "org": _2, "osasco": _2, "palmas": _2, "poa": _2, "ppg": _2, "pro": _2, "psc": _2, "psi": _2, "pvh": _2, "qsl": _2, "radio": _2, "rec": _2, "recife": _2, "rep": _2, "ribeirao": _2, "rio": _2, "riobranco": _2, "riopreto": _2, "salvador": _2, "sampa": _2, "santamaria": _2, "santoandre": _2, "saobernardo": _2, "saogonca": _2, "seg": _2, "sjc": _2, "slg": _2, "slz": _2, "sorocaba": _2, "srv": _2, "taxi": _2, "tc": _2, "tec": _2, "teo": _2, "the": _2, "tmp": _2, "trd": _2, "tur": _2, "tv": _2, "udi": _2, "vet": _2, "vix": _2, "vlog": _2, "wiki": _2, "zlg": _2 }], "bs": [1, { "com": _2, "net": _2, "org": _2, "edu": _2, "gov": _2, "we": _3 }], "bt": _4, "bv": _2, "bw": [1, { "co": _2, "org": _2 }], "by": [1, { "gov": _2, "mil": _2, "com": _6, "of": _2, "mycloud": _3, "mediatech": _3 }], "bz": [1, { "com": _2, "net": _2, "org": _2, "edu": _2, "gov": _2, "za": _3, "gsj": _3 }], "ca": [1, { "ab": _2, "bc": _2, "mb": _2, "nb": _2, "nf": _2, "nl": _2, "ns": _2, "nt": _2, "nu": _2, "on": _2, "pe": _2, "qc": _2, "sk": _2, "yk": _2, "gc": _2, "barsy": _3, "awdev": _5, "co": _3, "blogspot": _3, "no-ip": _3, "myspreadshop": _3 }], "cat": _2, "cc": [1, { "cloudns": _3, "ftpaccess": _3, "game-server": _3, "myphotos": _3, "scrapping": _3, "twmail": _3, "csx": _3, "fantasyleague": _3, "spawn": [0, { "instances": _3 }] }], "cd": _7, "cf": _6, "cg": _2, "ch": [1, { "square7": _3, "blogspot": _3, "flow": [0, { "ae": [0, { "alp1": _3 }], "appengine": _3 }], "linkyard-cloud": _3, "dnsking": _3, "gotdns": _3, "123website": _3, "myspreadshop": _3, "firenet": [0, { "*": _3, "svc": _5 }], "12hp": _3, "2ix": _3, "4lima": _3, "lima-city": _3 }], "ci": [1, { "org": _2, "or": _2, "com": _2, "co": _2, "edu": _2, "ed": _2, "ac": _2, "net": _2, "go": _2, "asso": _2, "xn--aroport-bya": _2, "aéroport": _2, "int": _2, "presse": _2, "md": _2, "gouv": _2, "fin": _3, "nl": _3 }], "ck": _8, "cl": [1, { "co": _2, "gob": _2, "gov": _2, "mil": _2, "blogspot": _3 }], "cm": [1, { "co": _2, "com": _2, "gov": _2, "net": _2 }], "cn": [1, { "ac": _2, "com": [1, { "amazonaws": [0, { "compute": _5, "cn-north-1": _12, "eb": [0, { "cn-north-1": _3, "cn-northwest-1": _3 }], "elb": _5 }] }], "edu": _2, "gov": _2, "net": _2, "org": _2, "mil": _2, "xn--55qx5d": _2, "公司": _2, "xn--io0a7i": _2, "网络": _2, "xn--od0alg": _2, "網絡": _2, "ah": _2, "bj": _2, "cq": _2, "fj": _2, "gd": _2, "gs": _2, "gz": _2, "gx": _2, "ha": _2, "hb": _2, "he": _2, "hi": _2, "hl": _2, "hn": _2, "jl": _2, "js": _2, "jx": _2, "ln": _2, "nm": _2, "nx": _2, "qh": _2, "sc": _2, "sd": _2, "sh": _2, "sn": _2, "sx": _2, "tj": _2, "xj": _2, "xz": _2, "yn": _2, "zj": _2, "hk": _2, "mo": _2, "tw": _2, "canva-apps": _3, "instantcloud": _3, "quickconnect": _13 }], "co": [1, { "arts": _2, "com": _6, "edu": _2, "firm": _2, "gov": _2, "info": _2, "int": _2, "mil": _2, "net": _2, "nom": _2, "org": _2, "rec": _2, "web": _2, "carrd": _3, "crd": _3, "otap": _5, "leadpages": _3, "lpages": _3, "mypi": _3, "n4t": _3, "firewalledreplit": _14, "repl": _14, "supabase": _3 }], "com": [1, { "devcdnaccesso": _5, "adobeaemcloud": [2, { "dev": _5 }], "airkitapps": _3, "airkitapps-au": _3, "aivencloud": _3, "kasserver": _3, "amazonaws": [0, { "compute": _5, "compute-1": _5, "us-east-1": [2, { "dualstack": _12, "analytics-gateway": _3, "aws-cloud9": _15, "cloud9": _16 }], "ap-northeast-1": _18, "ap-northeast-2": _19, "ap-south-1": _19, "ap-southeast-1": _20, "ap-southeast-2": _20, "ca-central-1": _19, "eu-central-1": _19, "eu-west-1": _18, "eu-west-2": _19, "eu-west-3": _19, "s3": _3, "s3-ap-northeast-1": _3, "s3-ap-northeast-2": _3, "s3-ap-south-1": _3, "s3-ap-southeast-1": _3, "s3-ap-southeast-2": _3, "s3-ca-central-1": _3, "s3-eu-central-1": _3, "s3-eu-west-1": _3, "s3-eu-west-2": _3, "s3-eu-west-3": _3, "s3-external-1": _3, "s3-fips-us-gov-west-1": _3, "s3-sa-east-1": _3, "s3-us-east-2": _3, "s3-us-gov-west-1": _3, "s3-us-west-1": _3, "s3-us-west-2": _3, "s3-website-ap-northeast-1": _3, "s3-website-ap-southeast-1": _3, "s3-website-ap-southeast-2": _3, "s3-website-eu-west-1": _3, "s3-website-sa-east-1": _3, "s3-website-us-east-1": _3, "s3-website-us-west-1": _3, "s3-website-us-west-2": _3, "sa-east-1": _20, "us-east-2": [0, { "dualstack": _12, "s3": _3, "s3-website": _3, "analytics-gateway": _3, "aws-cloud9": _15, "cloud9": _16 }], "us-west-2": [0, { "analytics-gateway": _3, "aws-cloud9": _15, "cloud9": _16 }], "af-south-1": _17, "ap-east-1": _17, "ap-northeast-3": _17, "eu-north-1": _17, "eu-south-1": _17, "me-south-1": _17, "us-west-1": _17, "elb": _5 }], "elasticbeanstalk": [2, { "ap-northeast-1": _3, "ap-northeast-2": _3, "ap-northeast-3": _3, "ap-south-1": _3, "ap-southeast-1": _3, "ap-southeast-2": _3, "ca-central-1": _3, "eu-central-1": _3, "eu-west-1": _3, "eu-west-2": _3, "eu-west-3": _3, "sa-east-1": _3, "us-east-1": _3, "us-east-2": _3, "us-gov-west-1": _3, "us-west-1": _3, "us-west-2": _3 }], "awsglobalaccelerator": _3, "siiites": _3, "appspacehosted": _3, "appspaceusercontent": _3, "on-aptible": _3, "myasustor": _3, "balena-devices": _3, "betainabox": _3, "boutir": _3, "bplaced": _3, "cafjs": _3, "canva-apps": _3, "br": _3, "cn": _3, "de": _3, "eu": _3, "jpn": _3, "mex": _3, "ru": _3, "sa": _3, "uk": _3, "us": _3, "za": _3, "ar": _3, "hu": _3, "kr": _3, "no": _3, "qc": _3, "uy": _3, "africa": _3, "gr": _3, "co": _3, "jdevcloud": _3, "wpdevcloud": _3, "cloudcontrolled": _3, "cloudcontrolapp": _3, "cf-ipfs": _3, "cloudflare-ipfs": _3, "trycloudflare": _3, "customer-oci": [0, { "*": _3, "oci": _5, "ocp": _5, "ocs": _5 }], "dattolocal": _3, "dattorelay": _3, "dattoweb": _3, "mydatto": _3, "builtwithdark": _3, "datadetect": [0, { "demo": _3, "instance": _3 }], "ddns5": _3, "discordsays": _3, "discordsez": _3, "drayddns": _3, "dreamhosters": _3, "mydrobo": _3, "dyndns-at-home": _3, "dyndns-at-work": _3, "dyndns-blog": _3, "dyndns-free": _3, "dyndns-home": _3, "dyndns-ip": _3, "dyndns-mail": _3, "dyndns-office": _3, "dyndns-pics": _3, "dyndns-remote": _3, "dyndns-server": _3, "dyndns-web": _3, "dyndns-wiki": _3, "dyndns-work": _3, "blogdns": _3, "cechire": _3, "dnsalias": _3, "dnsdojo": _3, "doesntexist": _3, "dontexist": _3, "doomdns": _3, "dyn-o-saur": _3, "dynalias": _3, "est-a-la-maison": _3, "est-a-la-masion": _3, "est-le-patron": _3, "est-mon-blogueur": _3, "from-ak": _3, "from-al": _3, "from-ar": _3, "from-ca": _3, "from-ct": _3, "from-dc": _3, "from-de": _3, "from-fl": _3, "from-ga": _3, "from-hi": _3, "from-ia": _3, "from-id": _3, "from-il": _3, "from-in": _3, "from-ks": _3, "from-ky": _3, "from-ma": _3, "from-md": _3, "from-mi": _3, "from-mn": _3, "from-mo": _3, "from-ms": _3, "from-mt": _3, "from-nc": _3, "from-nd": _3, "from-ne": _3, "from-nh": _3, "from-nj": _3, "from-nm": _3, "from-nv": _3, "from-oh": _3, "from-ok": _3, "from-or": _3, "from-pa": _3, "from-pr": _3, "from-ri": _3, "from-sc": _3, "from-sd": _3, "from-tn": _3, "from-tx": _3, "from-ut": _3, "from-va": _3, "from-vt": _3, "from-wa": _3, "from-wi": _3, "from-wv": _3, "from-wy": _3, "getmyip": _3, "gotdns": _3, "hobby-site": _3, "homelinux": _3, "homeunix": _3, "iamallama": _3, "is-a-anarchist": _3, "is-a-blogger": _3, "is-a-bookkeeper": _3, "is-a-bulls-fan": _3, "is-a-caterer": _3, "is-a-chef": _3, "is-a-conservative": _3, "is-a-cpa": _3, "is-a-cubicle-slave": _3, "is-a-democrat": _3, "is-a-designer": _3, "is-a-doctor": _3, "is-a-financialadvisor": _3, "is-a-geek": _3, "is-a-green": _3, "is-a-guru": _3, "is-a-hard-worker": _3, "is-a-hunter": _3, "is-a-landscaper": _3, "is-a-lawyer": _3, "is-a-liberal": _3, "is-a-libertarian": _3, "is-a-llama": _3, "is-a-musician": _3, "is-a-nascarfan": _3, "is-a-nurse": _3, "is-a-painter": _3, "is-a-personaltrainer": _3, "is-a-photographer": _3, "is-a-player": _3, "is-a-republican": _3, "is-a-rockstar": _3, "is-a-socialist": _3, "is-a-student": _3, "is-a-teacher": _3, "is-a-techie": _3, "is-a-therapist": _3, "is-an-accountant": _3, "is-an-actor": _3, "is-an-actress": _3, "is-an-anarchist": _3, "is-an-artist": _3, "is-an-engineer": _3, "is-an-entertainer": _3, "is-certified": _3, "is-gone": _3, "is-into-anime": _3, "is-into-cars": _3, "is-into-cartoons": _3, "is-into-games": _3, "is-leet": _3, "is-not-certified": _3, "is-slick": _3, "is-uberleet": _3, "is-with-theband": _3, "isa-geek": _3, "isa-hockeynut": _3, "issmarterthanyou": _3, "likes-pie": _3, "likescandy": _3, "neat-url": _3, "saves-the-whales": _3, "selfip": _3, "sells-for-less": _3, "sells-for-u": _3, "servebbs": _3, "simple-url": _3, "space-to-rent": _3, "teaches-yoga": _3, "writesthisblog": _3, "digitaloceanspaces": _5, "ddnsfree": _3, "ddnsgeek": _3, "giize": _3, "gleeze": _3, "kozow": _3, "loseyourip": _3, "ooguy": _3, "theworkpc": _3, "mytuleap": _3, "tuleap-partners": _3, "encoreapi": _3, "evennode": [0, { "eu-1": _3, "eu-2": _3, "eu-3": _3, "eu-4": _3, "us-1": _3, "us-2": _3, "us-3": _3, "us-4": _3 }], "onfabrica": _3, "fbsbx": _21, "fastly-edge": _3, "fastly-terrarium": _3, "fastvps-server": _3, "mydobiss": _3, "firebaseapp": _3, "fldrv": _3, "forgeblocks": _3, "framercanvas": _3, "freebox-os": _3, "freeboxos": _3, "freemyip": _3, "gentapps": _3, "gentlentapis": _3, "githubusercontent": _3, "0emm": _5, "appspot": [2, { "r": _5 }], "codespot": _3, "googleapis": _3, "googlecode": _3, "pagespeedmobilizer": _3, "publishproxy": _3, "withgoogle": _3, "withyoutube": _3, "blogspot": _3, "awsmppl": _3, "herokuapp": _3, "herokussl": _3, "impertrixcdn": _3, "impertrix": _3, "smushcdn": _3, "wphostedmail": _3, "wpmucdn": _3, "pixolino": _3, "amscompute": _3, "dopaas": _3, "hosted-by-previder": _22, "hosteur": [0, { "rag-cloud": _3, "rag-cloud-ch": _3 }], "ik-server": [0, { "jcloud": _3, "jcloud-ver-jpc": _3 }], "jelastic": [0, { "demo": _3 }], "kilatiron": _3, "massivegrid": _22, "wafaicloud": [0, { "jed": _3, "lon": _3, "ryd": _3 }], "joyent": [0, { "cns": _5 }], "ktistory": _3, "lpusercontent": _3, "lmpm": _23, "linode": [0, { "members": _3, "nodebalancer": _5 }], "linodeobjects": _5, "linodeusercontent": [0, { "ip": _3 }], "barsycenter": _3, "barsyonline": _3, "mazeplay": _3, "miniserver": _3, "meteorapp": _24, "hostedpi": _3, "mythic-beasts": [0, { "customer": _3, "caracal": _3, "fentiger": _3, "lynx": _3, "ocelot": _3, "oncilla": _3, "onza": _3, "sphinx": _3, "vs": _3, "x": _3, "yali": _3 }], "nospamproxy": _9, "4u": _3, "nfshost": _3, "001www": _3, "ddnslive": _3, "myiphost": _3, "blogsyte": _3, "ciscofreak": _3, "damnserver": _3, "ditchyourip": _3, "dnsiskinky": _3, "dynns": _3, "geekgalaxy": _3, "health-carereform": _3, "homesecuritymac": _3, "homesecuritypc": _3, "myactivedirectory": _3, "mysecuritycamera": _3, "net-freaks": _3, "onthewifi": _3, "point2this": _3, "quicksytes": _3, "securitytactics": _3, "serveexchange": _3, "servehumour": _3, "servep2p": _3, "servesarcasm": _3, "stufftoread": _3, "unusualperson": _3, "workisboring": _3, "3utilities": _3, "ddnsking": _3, "myvnc": _3, "servebeer": _3, "servecounterstrike": _3, "serveftp": _3, "servegame": _3, "servehalflife": _3, "servehttp": _3, "serveirc": _3, "servemp3": _3, "servepics": _3, "servequake": _3, "observableusercontent": [0, { "static": _3 }], "simplesite": _3, "orsites": _3, "operaunite": _3, "authgear-staging": _3, "authgearapps": _3, "skygearapp": _3, "outsystemscloud": _3, "ownprovider": _3, "pgfog": _3, "pagefrontapp": _3, "pagexl": _3, "paywhirl": _5, "gotpantheon": _3, "platter-app": _3, "pleskns": _3, "postman-echo": _3, "prgmr": [0, { "xen": _3 }], "pythonanywhere": _24, "qualifioapp": _3, "ladesk": _3, "qbuser": _3, "qa2": _3, "dev-myqnapcloud": _3, "alpha-myqnapcloud": _3, "myqnapcloud": _3, "quipelements": _5, "rackmaze": _3, "rhcloud": _3, "render": _23, "onrender": _3, "180r": _3, "dojin": _3, "sakuratan": _3, "sakuraweb": _3, "x0": _3, "code": [0, { "builder": _5, "dev-builder": _5, "stg-builder": _5 }], "logoip": _3, "scrysec": _3, "firewall-gateway": _3, "myshopblocks": _3, "myshopify": _3, "shopitsite": _3, "1kapp": _3, "appchizi": _3, "applinzi": _3, "sinaapp": _3, "vipsinaapp": _3, "bounty-full": [2, { "alpha": _3, "beta": _3 }], "streamlitapp": _3, "try-snowplow": _3, "stackhero-network": _3, "playstation-cloud": _3, "myspreadshop": _3, "stdlib": [0, { "api": _3 }], "temp-dns": _3, "dsmynas": _3, "familyds": _3, "mytabit": _3, "tb-hosting": _25, "reservd": _3, "thingdustdata": _3, "bloxcms": _3, "townnews-staging": _3, "typeform": [0, { "pro": _3 }], "hk": _3, "it": _3, "vultrobjects": _5, "wafflecell": _3, "reserve-online": _3, "hotelwithflight": _3, "remotewd": _3, "wiardweb": _26, "messwithdns": _3, "woltlab-demo": _3, "wpenginepowered": [2, { "js": _3 }], "wixsite": _3, "xnbay": [2, { "u2": _3, "u2-local": _3 }], "yolasite": _3 }], "coop": _2, "cr": [1, { "ac": _2, "co": _2, "ed": _2, "fi": _2, "go": _2, "or": _2, "sa": _2 }], "cu": [1, { "com": _2, "edu": _2, "org": _2, "net": _2, "gov": _2, "inf": _2 }], "cv": [1, { "com": _2, "edu": _2, "int": _2, "nome": _2, "org": _2, "blogspot": _3 }], "cw": _27, "cx": [1, { "gov": _2, "ath": _3, "info": _3 }], "cy": [1, { "ac": _2, "biz": _2, "com": [1, { "blogspot": _3, "scaleforce": _28 }], "ekloges": _2, "gov": _2, "ltd": _2, "mil": _2, "net": _2, "org": _2, "press": _2, "pro": _2, "tm": _2 }], "cz": [1, { "co": _3, "realm": _3, "e4": _3, "blogspot": _3, "metacentrum": [0, { "cloud": _5, "custom": _3 }], "muni": [0, { "cloud": [0, { "flt": _3, "usr": _3 }] }] }], "de": [1, { "bplaced": _3, "square7": _3, "com": _3, "cosidns": [0, { "dyn": _3 }], "dynamisches-dns": _3, "dnsupdater": _3, "internet-dns": _3, "l-o-g-i-n": _3, "dnshome": _3, "fuettertdasnetz": _3, "isteingeek": _3, "istmein": _3, "lebtimnetz": _3, "leitungsen": _3, "traeumtgerade": _3, "ddnss": [2, { "dyn": _3, "dyndns": _3 }], "dyndns1": _3, "dyn-ip24": _3, "home-webserver": [2, { "dyn": _3 }], "myhome-server": _3, "frusky": _5, "goip": _3, "blogspot": _3, "xn--gnstigbestellen-zvb": _3, "günstigbestellen": _3, "xn--gnstigliefern-wob": _3, "günstigliefern": _3, "hs-heilbronn": [0, { "it": _26 }], "dyn-berlin": _3, "in-berlin": _3, "in-brb": _3, "in-butter": _3, "in-dsl": _3, "in-vpn": _3, "iservschule": _3, "mein-iserv": _3, "schulplattform": _3, "schulserver": _3, "test-iserv": _3, "keymachine": _3, "git-repos": _3, "lcube-server": _3, "svn-repos": _3, "barsy": _3, "123webseite": _3, "logoip": _3, "firewall-gateway": _3, "my-gateway": _3, "my-router": _3, "spdns": _3, "speedpartner": [0, { "customer": _3 }], "myspreadshop": _3, "taifun-dns": _3, "12hp": _3, "2ix": _3, "4lima": _3, "lima-city": _3, "dd-dns": _3, "dray-dns": _3, "draydns": _3, "dyn-vpn": _3, "dynvpn": _3, "mein-vigor": _3, "my-vigor": _3, "my-wan": _3, "syno-ds": _3, "synology-diskstation": _3, "synology-ds": _3, "uberspace": _5, "virtualuser": _3, "virtual-user": _3, "community-pro": _3, "diskussionsbereich": _3 }], "dj": _2, "dk": [1, { "biz": _3, "co": _3, "firm": _3, "reg": _3, "store": _3, "blogspot": _3, "123hjemmeside": _3, "myspreadshop": _3 }], "dm": _4, "do": [1, { "art": _2, "com": _2, "edu": _2, "gob": _2, "gov": _2, "mil": _2, "net": _2, "org": _2, "sld": _2, "web": _2 }], "dz": [1, { "art": _2, "asso": _2, "com": _2, "edu": _2, "gov": _2, "org": _2, "net": _2, "pol": _2, "soc": _2, "tm": _2 }], "ec": [1, { "com": _2, "info": _2, "net": _2, "fin": _2, "k12": _2, "med": _2, "pro": _2, "org": _2, "edu": _2, "gov": _2, "gob": _2, "mil": _2, "base": _3, "official": _3 }], "edu": [1, { "rit": [0, { "git-pages": _3 }] }], "ee": [1, { "edu": _2, "gov": _2, "riik": _2, "lib": _2, "med": _2, "com": _6, "pri": _2, "aip": _2, "org": _2, "fie": _2 }], "eg": [1, { "com": _6, "edu": _2, "eun": _2, "gov": _2, "mil": _2, "name": _2, "net": _2, "org": _2, "sci": _2 }], "er": _8, "es": [1, { "com": _6, "nom": _2, "org": _2, "gob": _2, "edu": _2, "123miweb": _3, "myspreadshop": _3 }], "et": [1, { "com": _2, "gov": _2, "org": _2, "edu": _2, "biz": _2, "name": _2, "info": _2, "net": _2 }], "eu": [1, { "airkitapps": _3, "mycd": _3, "cloudns": _3, "dogado": _29, "barsy": _3, "wellbeingzone": _3, "spdns": _3, "transurl": _5, "diskstation": _3 }], "fi": [1, { "aland": _2, "dy": _3, "blogspot": _3, "xn--hkkinen-5wa": _3, "häkkinen": _3, "iki": _3, "cloudplatform": [0, { "fi": _3 }], "datacenter": [0, { "demo": _3, "paas": _3 }], "kapsi": _3, "123kotisivu": _3, "myspreadshop": _3 }], "fj": [1, { "ac": _2, "biz": _2, "com": _2, "gov": _2, "info": _2, "mil": _2, "name": _2, "net": _2, "org": _2, "pro": _2 }], "fk": _8, "fm": [1, { "com": _2, "edu": _2, "net": _2, "org": _2, "radio": _3, "user": _5 }], "fo": _2, "fr": [1, { "asso": _2, "com": _2, "gouv": _2, "nom": _2, "prd": _2, "tm": _2, "avoues": _2, "cci": _2, "greta": _2, "huissier-justice": _2, "en-root": _3, "fbx-os": _3, "fbxos": _3, "freebox-os": _3, "freeboxos": _3, "blogspot": _3, "goupile": _3, "123siteweb": _3, "on-web": _3, "chirurgiens-dentistes-en-france": _3, "dedibox": _3, "aeroport": _3, "avocat": _3, "chambagri": _3, "chirurgiens-dentistes": _3, "experts-comptables": _3, "medecin": _3, "notaires": _3, "pharmacien": _3, "port": _3, "veterinaire": _3, "myspreadshop": _3, "ynh": _3 }], "ga": _2, "gb": _2, "gd": [1, { "edu": _2, "gov": _2 }], "ge": [1, { "com": _2, "edu": _2, "gov": _2, "org": _2, "mil": _2, "net": _2, "pvt": _2 }], "gf": _2, "gg": [1, { "co": _2, "net": _2, "org": _2, "kaas": _3, "cya": _3, "panel": [2, { "daemon": _3 }] }], "gh": [1, { "com": _2, "edu": _2, "gov": _2, "org": _2, "mil": _2 }], "gi": [1, { "com": _2, "ltd": _2, "gov": _2, "mod": _2, "edu": _2, "org": _2 }], "gl": [1, { "co": _2, "com": _2, "edu": _2, "net": _2, "org": _2, "biz": _3, "xx": _3 }], "gm": _2, "gn": [1, { "ac": _2, "com": _2, "edu": _2, "gov": _2, "org": _2, "net": _2 }], "gov": _2, "gp": [1, { "com": _2, "net": _2, "mobi": _2, "edu": _2, "org": _2, "asso": _2, "app": _3 }], "gq": _2, "gr": [1, { "com": _2, "edu": _2, "net": _2, "org": _2, "gov": _2, "blogspot": _3, "simplesite": _3 }], "gs": _2, "gt": [1, { "com": _2, "edu": _2, "gob": _2, "ind": _2, "mil": _2, "net": _2, "org": _2, "blog": _3, "de": _3, "to": _3 }], "gu": [1, { "com": _2, "edu": _2, "gov": _2, "guam": _2, "info": _2, "net": _2, "org": _2, "web": _2 }], "gw": _2, "gy": [1, { "co": _2, "com": _2, "edu": _2, "gov": _2, "net": _2, "org": _2, "be": _3 }], "hk": [1, { "com": _2, "edu": _2, "gov": _2, "idv": _2, "net": _2, "org": _2, "xn--55qx5d": _2, "公司": _2, "xn--wcvs22d": _2, "教育": _2, "xn--lcvr32d": _2, "敎育": _2, "xn--mxtq1m": _2, "政府": _2, "xn--gmqw5a": _2, "個人": _2, "xn--ciqpn": _2, "个人": _2, "xn--gmq050i": _2, "箇人": _2, "xn--zf0avx": _2, "網络": _2, "xn--io0a7i": _2, "网络": _2, "xn--mk0axi": _2, "组織": _2, "xn--od0alg": _2, "網絡": _2, "xn--od0aq3b": _2, "网絡": _2, "xn--tn0ag": _2, "组织": _2, "xn--uc0atv": _2, "組織": _2, "xn--uc0ay4a": _2, "組织": _2, "blogspot": _3, "secaas": _3, "ltd": _3, "inc": _3 }], "hm": _2, "hn": [1, { "com": _2, "edu": _2, "org": _2, "net": _2, "mil": _2, "gob": _2, "cc": _3 }], "hr": [1, { "iz": _2, "from": _2, "name": _2, "com": _2, "blogspot": _3, "free": _3 }], "ht": [1, { "com": _2, "shop": _2, "firm": _2, "info": _2, "adult": _2, "net": _2, "pro": _2, "org": _2, "med": _2, "art": _2, "coop": _2, "pol": _2, "asso": _2, "edu": _2, "rel": _2, "gouv": _2, "perso": _2 }], "hu": [1, { "2000": _2, "co": _2, "info": _2, "org": _2, "priv": _2, "sport": _2, "tm": _2, "agrar": _2, "bolt": _2, "casino": _2, "city": _2, "erotica": _2, "erotika": _2, "film": _2, "forum": _2, "games": _2, "hotel": _2, "ingatlan": _2, "jogasz": _2, "konyvelo": _2, "lakas": _2, "media": _2, "news": _2, "reklam": _2, "sex": _2, "shop": _2, "suli": _2, "szex": _2, "tozsde": _2, "utazas": _2, "video": _2, "blogspot": _3 }], "id": [1, { "ac": _2, "biz": _2, "co": _6, "desa": _2, "go": _2, "mil": _2, "my": [1, { "rss": _5 }], "net": _2, "or": _2, "ponpes": _2, "sch": _2, "web": _2, "flap": _3, "forte": _3 }], "ie": [1, { "gov": _2, "blogspot": _3, "myspreadshop": _3 }], "il": [1, { "ac": _2, "co": [1, { "ravpage": _3, "blogspot": _3, "tabitorder": _3, "mytabit": _3 }], "gov": _2, "idf": _2, "k12": _2, "muni": _2, "net": _2, "org": _2 }], "xn--4dbrk0ce": [1, { "xn--4dbgdty6c": _2, "xn--5dbhl8d": _2, "xn--8dbq2a": _2, "xn--hebda8b": _2 }], "ישראל": [1, { "אקדמיה": _2, "ישוב": _2, "צהל": _2, "ממשל": _2 }], "im": [1, { "ac": _2, "co": [1, { "ltd": _2, "plc": _2 }], "com": _2, "net": _2, "org": _2, "tt": _2, "tv": _2, "ro": _3 }], "in": [1, { "5g": _2, "6g": _2, "ac": _2, "ai": _2, "am": _2, "bihar": _2, "biz": _2, "business": _2, "ca": _2, "cn": _2, "co": _2, "com": _2, "coop": _2, "cs": _2, "delhi": _2, "dr": _2, "edu": _2, "er": _2, "firm": _2, "gen": _2, "gov": _2, "gujarat": _2, "ind": _2, "info": _2, "int": _2, "internet": _2, "io": _2, "me": _2, "mil": _2, "net": _2, "nic": _2, "org": _2, "pg": _2, "post": _2, "pro": _2, "res": _2, "travel": _2, "tv": _2, "uk": _2, "up": _2, "us": _2, "web": _3, "cloudns": _3, "blogspot": _3, "barsy": _3, "supabase": _3 }], "info": [1, { "cloudns": _3, "dynamic-dns": _3, "dyndns": _3, "barrel-of-knowledge": _3, "barrell-of-knowledge": _3, "for-our": _3, "groks-the": _3, "groks-this": _3, "here-for-more": _3, "knowsitall": _3, "selfip": _3, "webhop": _3, "barsy": _3, "mayfirst": _3, "forumz": _3, "nsupdate": _3, "dvrcam": _3, "ilovecollege": _3, "no-ip": _3, "dnsupdate": _3, "v-info": _3 }], "int": [1, { "eu": _2 }], "io": [1, { "2038": _3, "com": _2, "on-acorn": _5, "apigee": _3, "b-data": _3, "backplaneapp": _3, "banzaicloud": [0, { "app": _3, "backyards": _5 }], "beagleboard": _3, "bitbucket": _3, "bluebite": _3, "boxfuse": _3, "browsersafetymark": _3, "bigv": [0, { "uk0": _3 }], "cleverapps": _3, "dappnode": [0, { "dyndns": _3 }], "dedyn": _3, "drud": _3, "definima": _3, "fh-muenster": _3, "shw": _3, "forgerock": [0, { "id": _3 }], "ghost": _3, "github": _3, "gitlab": _3, "lolipop": _3, "hasura-app": _3, "hostyhosting": _3, "moonscale": _5, "beebyte": _22, "beebyteapp": [0, { "sekd1": _3 }], "jele": _3, "unispace": [0, { "cloud-fr1": _3 }], "webthings": _3, "loginline": _3, "barsy": _3, "azurecontainer": _5, "ngrok": [2, { "ap": _3, "au": _3, "eu": _3, "in": _3, "jp": _3, "sa": _3, "us": _3 }], "nodeart": [0, { "stage": _3 }], "nid": _3, "pantheonsite": _3, "dyn53": _3, "pstmn": [2, { "mock": _3 }], "protonet": _3, "qoto": _3, "qcx": [2, { "sys": _5 }], "vaporcloud": _3, "vbrplsbx": [0, { "g": _3 }], "on-k3s": _5, "on-rio": _5, "readthedocs": _3, "resindevice": _3, "resinstaging": [0, { "devices": _3 }], "hzc": _3, "sandcats": _3, "shiftcrypto": _3, "shiftedit": _3, "mo-siemens": _3, "musician": _3, "lair": _21, "stolos": _5, "spacekit": _3, "utwente": _3, "s5y": _5, "edugit": _3, "telebit": _3, "thingdust": [0, { "dev": _32, "disrec": _32, "prod": _33, "testing": _32 }], "tickets": _3, "upli": _3, "wedeploy": _3, "editorx": _3, "wixstudio": _3, "basicserver": _3, "virtualserver": _3 }], "iq": _34, "ir": [1, { "ac": _2, "co": _2, "gov": _2, "id": _2, "net": _2, "org": _2, "sch": _2, "xn--mgba3a4f16a": _2, "ایران": _2, "xn--mgba3a4fra": _2, "ايران": _2 }], "is": [1, { "net": _2, "com": _2, "edu": _2, "gov": _2, "org": _2, "int": _2, "cupcake": _3, "blogspot": _3 }], "it": [1, { "gov": _2, "edu": _2, "abr": _2, "abruzzo": _2, "aosta-valley": _2, "aostavalley": _2, "bas": _2, "basilicata": _2, "cal": _2, "calabria": _2, "cam": _2, "campania": _2, "emilia-romagna": _2, "emiliaromagna": _2, "emr": _2, "friuli-v-giulia": _2, "friuli-ve-giulia": _2, "friuli-vegiulia": _2, "friuli-venezia-giulia": _2, "friuli-veneziagiulia": _2, "friuli-vgiulia": _2, "friuliv-giulia": _2, "friulive-giulia": _2, "friulivegiulia": _2, "friulivenezia-giulia": _2, "friuliveneziagiulia": _2, "friulivgiulia": _2, "fvg": _2, "laz": _2, "lazio": _2, "lig": _2, "liguria": _2, "lom": _2, "lombardia": _2, "lombardy": _2, "lucania": _2, "mar": _2, "marche": _2, "mol": _2, "molise": _2, "piedmont": _2, "piemonte": _2, "pmn": _2, "pug": _2, "puglia": _2, "sar": _2, "sardegna": _2, "sardinia": _2, "sic": _2, "sicilia": _2, "sicily": _2, "taa": _2, "tos": _2, "toscana": _2, "trentin-sud-tirol": _2, "xn--trentin-sd-tirol-rzb": _2, "trentin-süd-tirol": _2, "trentin-sudtirol": _2, "xn--trentin-sdtirol-7vb": _2, "trentin-südtirol": _2, "trentin-sued-tirol": _2, "trentin-suedtirol": _2, "trentino-a-adige": _2, "trentino-aadige": _2, "trentino-alto-adige": _2, "trentino-altoadige": _2, "trentino-s-tirol": _2, "trentino-stirol": _2, "trentino-sud-tirol": _2, "xn--trentino-sd-tirol-c3b": _2, "trentino-süd-tirol": _2, "trentino-sudtirol": _2, "xn--trentino-sdtirol-szb": _2, "trentino-südtirol": _2, "trentino-sued-tirol": _2, "trentino-suedtirol": _2, "trentino": _2, "trentinoa-adige": _2, "trentinoaadige": _2, "trentinoalto-adige": _2, "trentinoaltoadige": _2, "trentinos-tirol": _2, "trentinostirol": _2, "trentinosud-tirol": _2, "xn--trentinosd-tirol-rzb": _2, "trentinosüd-tirol": _2, "trentinosudtirol": _2, "xn--trentinosdtirol-7vb": _2, "trentinosüdtirol": _2, "trentinosued-tirol": _2, "trentinosuedtirol": _2, "trentinsud-tirol": _2, "xn--trentinsd-tirol-6vb": _2, "trentinsüd-tirol": _2, "trentinsudtirol": _2, "xn--trentinsdtirol-nsb": _2, "trentinsüdtirol": _2, "trentinsued-tirol": _2, "trentinsuedtirol": _2, "tuscany": _2, "umb": _2, "umbria": _2, "val-d-aosta": _2, "val-daosta": _2, "vald-aosta": _2, "valdaosta": _2, "valle-aosta": _2, "valle-d-aosta": _2, "valle-daosta": _2, "valleaosta": _2, "valled-aosta": _2, "valledaosta": _2, "vallee-aoste": _2, "xn--valle-aoste-ebb": _2, "vallée-aoste": _2, "vallee-d-aoste": _2, "xn--valle-d-aoste-ehb": _2, "vallée-d-aoste": _2, "valleeaoste": _2, "xn--valleaoste-e7a": _2, "valléeaoste": _2, "valleedaoste": _2, "xn--valledaoste-ebb": _2, "valléedaoste": _2, "vao": _2, "vda": _2, "ven": _2, "veneto": _2, "ag": _2, "agrigento": _2, "al": _2, "alessandria": _2, "alto-adige": _2, "altoadige": _2, "an": _2, "ancona": _2, "andria-barletta-trani": _2, "andria-trani-barletta": _2, "andriabarlettatrani": _2, "andriatranibarletta": _2, "ao": _2, "aosta": _2, "aoste": _2, "ap": _2, "aq": _2, "aquila": _2, "ar": _2, "arezzo": _2, "ascoli-piceno": _2, "ascolipiceno": _2, "asti": _2, "at": _2, "av": _2, "avellino": _2, "ba": _2, "balsan-sudtirol": _2, "xn--balsan-sdtirol-nsb": _2, "balsan-südtirol": _2, "balsan-suedtirol": _2, "balsan": _2, "bari": _2, "barletta-trani-andria": _2, "barlettatraniandria": _2, "belluno": _2, "benevento": _2, "bergamo": _2, "bg": _2, "bi": _2, "biella": _2, "bl": _2, "bn": _2, "bo": _2, "bologna": _2, "bolzano-altoadige": _2, "bolzano": _2, "bozen-sudtirol": _2, "xn--bozen-sdtirol-2ob": _2, "bozen-südtirol": _2, "bozen-suedtirol": _2, "bozen": _2, "br": _2, "brescia": _2, "brindisi": _2, "bs": _2, "bt": _2, "bulsan-sudtirol": _2, "xn--bulsan-sdtirol-nsb": _2, "bulsan-südtirol": _2, "bulsan-suedtirol": _2, "bulsan": _2, "bz": _2, "ca": _2, "cagliari": _2, "caltanissetta": _2, "campidano-medio": _2, "campidanomedio": _2, "campobasso": _2, "carbonia-iglesias": _2, "carboniaiglesias": _2, "carrara-massa": _2, "carraramassa": _2, "caserta": _2, "catania": _2, "catanzaro": _2, "cb": _2, "ce": _2, "cesena-forli": _2, "xn--cesena-forl-mcb": _2, "cesena-forlì": _2, "cesenaforli": _2, "xn--cesenaforl-i8a": _2, "cesenaforlì": _2, "ch": _2, "chieti": _2, "ci": _2, "cl": _2, "cn": _2, "co": _2, "como": _2, "cosenza": _2, "cr": _2, "cremona": _2, "crotone": _2, "cs": _2, "ct": _2, "cuneo": _2, "cz": _2, "dell-ogliastra": _2, "dellogliastra": _2, "en": _2, "enna": _2, "fc": _2, "fe": _2, "fermo": _2, "ferrara": _2, "fg": _2, "fi": _2, "firenze": _2, "florence": _2, "fm": _2, "foggia": _2, "forli-cesena": _2, "xn--forl-cesena-fcb": _2, "forlì-cesena": _2, "forlicesena": _2, "xn--forlcesena-c8a": _2, "forlìcesena": _2, "fr": _2, "frosinone": _2, "ge": _2, "genoa": _2, "genova": _2, "go": _2, "gorizia": _2, "gr": _2, "grosseto": _2, "iglesias-carbonia": _2, "iglesiascarbonia": _2, "im": _2, "imperia": _2, "is": _2, "isernia": _2, "kr": _2, "la-spezia": _2, "laquila": _2, "laspezia": _2, "latina": _2, "lc": _2, "le": _2, "lecce": _2, "lecco": _2, "li": _2, "livorno": _2, "lo": _2, "lodi": _2, "lt": _2, "lu": _2, "lucca": _2, "macerata": _2, "mantova": _2, "massa-carrara": _2, "massacarrara": _2, "matera": _2, "mb": _2, "mc": _2, "me": _2, "medio-campidano": _2, "mediocampidano": _2, "messina": _2, "mi": _2, "milan": _2, "milano": _2, "mn": _2, "mo": _2, "modena": _2, "monza-brianza": _2, "monza-e-della-brianza": _2, "monza": _2, "monzabrianza": _2, "monzaebrianza": _2, "monzaedellabrianza": _2, "ms": _2, "mt": _2, "na": _2, "naples": _2, "napoli": _2, "no": _2, "novara": _2, "nu": _2, "nuoro": _2, "og": _2, "ogliastra": _2, "olbia-tempio": _2, "olbiatempio": _2, "or": _2, "oristano": _2, "ot": _2, "pa": _2, "padova": _2, "padua": _2, "palermo": _2, "parma": _2, "pavia": _2, "pc": _2, "pd": _2, "pe": _2, "perugia": _2, "pesaro-urbino": _2, "pesarourbino": _2, "pescara": _2, "pg": _2, "pi": _2, "piacenza": _2, "pisa": _2, "pistoia": _2, "pn": _2, "po": _2, "pordenone": _2, "potenza": _2, "pr": _2, "prato": _2, "pt": _2, "pu": _2, "pv": _2, "pz": _2, "ra": _2, "ragusa": _2, "ravenna": _2, "rc": _2, "re": _2, "reggio-calabria": _2, "reggio-emilia": _2, "reggiocalabria": _2, "reggioemilia": _2, "rg": _2, "ri": _2, "rieti": _2, "rimini": _2, "rm": _2, "rn": _2, "ro": _2, "roma": _2, "rome": _2, "rovigo": _2, "sa": _2, "salerno": _2, "sassari": _2, "savona": _2, "si": _2, "siena": _2, "siracusa": _2, "so": _2, "sondrio": _2, "sp": _2, "sr": _2, "ss": _2, "suedtirol": _2, "xn--sdtirol-n2a": _2, "südtirol": _2, "sv": _2, "ta": _2, "taranto": _2, "te": _2, "tempio-olbia": _2, "tempioolbia": _2, "teramo": _2, "terni": _2, "tn": _2, "to": _2, "torino": _2, "tp": _2, "tr": _2, "trani-andria-barletta": _2, "trani-barletta-andria": _2, "traniandriabarletta": _2, "tranibarlettaandria": _2, "trapani": _2, "trento": _2, "treviso": _2, "trieste": _2, "ts": _2, "turin": _2, "tv": _2, "ud": _2, "udine": _2, "urbino-pesaro": _2, "urbinopesaro": _2, "va": _2, "varese": _2, "vb": _2, "vc": _2, "ve": _2, "venezia": _2, "venice": _2, "verbania": _2, "vercelli": _2, "verona": _2, "vi": _2, "vibo-valentia": _2, "vibovalentia": _2, "vicenza": _2, "viterbo": _2, "vr": _2, "vs": _2, "vt": _2, "vv": _2, "blogspot": _3, "ibxos": _3, "iliadboxos": _3, "neen": [0, { "jc": _3 }], "tim": [0, { "open": [0, { "jelastic": _9 }] }], "16-b": _3, "32-b": _3, "64-b": _3, "123homepage": _3, "myspreadshop": _3, "syncloud": _3 }], "je": [1, { "co": _2, "net": _2, "org": _2, "of": _3 }], "jm": _8, "jo": [1, { "com": _2, "org": _2, "net": _2, "edu": _2, "sch": _2, "gov": _2, "mil": _2, "name": _2 }], "jobs": _2, "jp": [1, { "ac": _2, "ad": _2, "co": _2, "ed": _2, "go": _2, "gr": _2, "lg": _2, "ne": [1, { "aseinet": _30, "gehirn": _3, "ivory": _3, "mail-box": _3, "mints": _3, "mokuren": _3, "opal": _3, "sakura": _3, "sumomo": _3, "topaz": _3 }], "or": _2, "aichi": [1, { "aisai": _2, "ama": _2, "anjo": _2, "asuke": _2, "chiryu": _2, "chita": _2, "fuso": _2, "gamagori": _2, "handa": _2, "hazu": _2, "hekinan": _2, "higashiura": _2, "ichinomiya": _2, "inazawa": _2, "inuyama": _2, "isshiki": _2, "iwakura": _2, "kanie": _2, "kariya": _2, "kasugai": _2, "kira": _2, "kiyosu": _2, "komaki": _2, "konan": _2, "kota": _2, "mihama": _2, "miyoshi": _2, "nishio": _2, "nisshin": _2, "obu": _2, "oguchi": _2, "oharu": _2, "okazaki": _2, "owariasahi": _2, "seto": _2, "shikatsu": _2, "shinshiro": _2, "shitara": _2, "tahara": _2, "takahama": _2, "tobishima": _2, "toei": _2, "togo": _2, "tokai": _2, "tokoname": _2, "toyoake": _2, "toyohashi": _2, "toyokawa": _2, "toyone": _2, "toyota": _2, "tsushima": _2, "yatomi": _2 }], "akita": [1, { "akita": _2, "daisen": _2, "fujisato": _2, "gojome": _2, "hachirogata": _2, "happou": _2, "higashinaruse": _2, "honjo": _2, "honjyo": _2, "ikawa": _2, "kamikoani": _2, "kamioka": _2, "katagami": _2, "kazuno": _2, "kitaakita": _2, "kosaka": _2, "kyowa": _2, "misato": _2, "mitane": _2, "moriyoshi": _2, "nikaho": _2, "noshiro": _2, "odate": _2, "oga": _2, "ogata": _2, "semboku": _2, "yokote": _2, "yurihonjo": _2 }], "aomori": [1, { "aomori": _2, "gonohe": _2, "hachinohe": _2, "hashikami": _2, "hiranai": _2, "hirosaki": _2, "itayanagi": _2, "kuroishi": _2, "misawa": _2, "mutsu": _2, "nakadomari": _2, "noheji": _2, "oirase": _2, "owani": _2, "rokunohe": _2, "sannohe": _2, "shichinohe": _2, "shingo": _2, "takko": _2, "towada": _2, "tsugaru": _2, "tsuruta": _2 }], "chiba": [1, { "abiko": _2, "asahi": _2, "chonan": _2, "chosei": _2, "choshi": _2, "chuo": _2, "funabashi": _2, "futtsu": _2, "hanamigawa": _2, "ichihara": _2, "ichikawa": _2, "ichinomiya": _2, "inzai": _2, "isumi": _2, "kamagaya": _2, "kamogawa": _2, "kashiwa": _2, "katori": _2, "katsuura": _2, "kimitsu": _2, "kisarazu": _2, "kozaki": _2, "kujukuri": _2, "kyonan": _2, "matsudo": _2, "midori": _2, "mihama": _2, "minamiboso": _2, "mobara": _2, "mutsuzawa": _2, "nagara": _2, "nagareyama": _2, "narashino": _2, "narita": _2, "noda": _2, "oamishirasato": _2, "omigawa": _2, "onjuku": _2, "otaki": _2, "sakae": _2, "sakura": _2, "shimofusa": _2, "shirako": _2, "shiroi": _2, "shisui": _2, "sodegaura": _2, "sosa": _2, "tako": _2, "tateyama": _2, "togane": _2, "tohnosho": _2, "tomisato": _2, "urayasu": _2, "yachimata": _2, "yachiyo": _2, "yokaichiba": _2, "yokoshibahikari": _2, "yotsukaido": _2 }], "ehime": [1, { "ainan": _2, "honai": _2, "ikata": _2, "imabari": _2, "iyo": _2, "kamijima": _2, "kihoku": _2, "kumakogen": _2, "masaki": _2, "matsuno": _2, "matsuyama": _2, "namikata": _2, "niihama": _2, "ozu": _2, "saijo": _2, "seiyo": _2, "shikokuchuo": _2, "tobe": _2, "toon": _2, "uchiko": _2, "uwajima": _2, "yawatahama": _2 }], "fukui": [1, { "echizen": _2, "eiheiji": _2, "fukui": _2, "ikeda": _2, "katsuyama": _2, "mihama": _2, "minamiechizen": _2, "obama": _2, "ohi": _2, "ono": _2, "sabae": _2, "sakai": _2, "takahama": _2, "tsuruga": _2, "wakasa": _2 }], "fukuoka": [1, { "ashiya": _2, "buzen": _2, "chikugo": _2, "chikuho": _2, "chikujo": _2, "chikushino": _2, "chikuzen": _2, "chuo": _2, "dazaifu": _2, "fukuchi": _2, "hakata": _2, "higashi": _2, "hirokawa": _2, "hisayama": _2, "iizuka": _2, "inatsuki": _2, "kaho": _2, "kasuga": _2, "kasuya": _2, "kawara": _2, "keisen": _2, "koga": _2, "kurate": _2, "kurogi": _2, "kurume": _2, "minami": _2, "miyako": _2, "miyama": _2, "miyawaka": _2, "mizumaki": _2, "munakata": _2, "nakagawa": _2, "nakama": _2, "nishi": _2, "nogata": _2, "ogori": _2, "okagaki": _2, "okawa": _2, "oki": _2, "omuta": _2, "onga": _2, "onojo": _2, "oto": _2, "saigawa": _2, "sasaguri": _2, "shingu": _2, "shinyoshitomi": _2, "shonai": _2, "soeda": _2, "sue": _2, "tachiarai": _2, "tagawa": _2, "takata": _2, "toho": _2, "toyotsu": _2, "tsuiki": _2, "ukiha": _2, "umi": _2, "usui": _2, "yamada": _2, "yame": _2, "yanagawa": _2, "yukuhashi": _2 }], "fukushima": [1, { "aizubange": _2, "aizumisato": _2, "aizuwakamatsu": _2, "asakawa": _2, "bandai": _2, "date": _2, "fukushima": _2, "furudono": _2, "futaba": _2, "hanawa": _2, "higashi": _2, "hirata": _2, "hirono": _2, "iitate": _2, "inawashiro": _2, "ishikawa": _2, "iwaki": _2, "izumizaki": _2, "kagamiishi": _2, "kaneyama": _2, "kawamata": _2, "kitakata": _2, "kitashiobara": _2, "koori": _2, "koriyama": _2, "kunimi": _2, "miharu": _2, "mishima": _2, "namie": _2, "nango": _2, "nishiaizu": _2, "nishigo": _2, "okuma": _2, "omotego": _2, "ono": _2, "otama": _2, "samegawa": _2, "shimogo": _2, "shirakawa": _2, "showa": _2, "soma": _2, "sukagawa": _2, "taishin": _2, "tamakawa": _2, "tanagura": _2, "tenei": _2, "yabuki": _2, "yamato": _2, "yamatsuri": _2, "yanaizu": _2, "yugawa": _2 }], "gifu": [1, { "anpachi": _2, "ena": _2, "gifu": _2, "ginan": _2, "godo": _2, "gujo": _2, "hashima": _2, "hichiso": _2, "hida": _2, "higashishirakawa": _2, "ibigawa": _2, "ikeda": _2, "kakamigahara": _2, "kani": _2, "kasahara": _2, "kasamatsu": _2, "kawaue": _2, "kitagata": _2, "mino": _2, "minokamo": _2, "mitake": _2, "mizunami": _2, "motosu": _2, "nakatsugawa": _2, "ogaki": _2, "sakahogi": _2, "seki": _2, "sekigahara": _2, "shirakawa": _2, "tajimi": _2, "takayama": _2, "tarui": _2, "toki": _2, "tomika": _2, "wanouchi": _2, "yamagata": _2, "yaotsu": _2, "yoro": _2 }], "gunma": [1, { "annaka": _2, "chiyoda": _2, "fujioka": _2, "higashiagatsuma": _2, "isesaki": _2, "itakura": _2, "kanna": _2, "kanra": _2, "katashina": _2, "kawaba": _2, "kiryu": _2, "kusatsu": _2, "maebashi": _2, "meiwa": _2, "midori": _2, "minakami": _2, "naganohara": _2, "nakanojo": _2, "nanmoku": _2, "numata": _2, "oizumi": _2, "ora": _2, "ota": _2, "shibukawa": _2, "shimonita": _2, "shinto": _2, "showa": _2, "takasaki": _2, "takayama": _2, "tamamura": _2, "tatebayashi": _2, "tomioka": _2, "tsukiyono": _2, "tsumagoi": _2, "ueno": _2, "yoshioka": _2 }], "hiroshima": [1, { "asaminami": _2, "daiwa": _2, "etajima": _2, "fuchu": _2, "fukuyama": _2, "hatsukaichi": _2, "higashihiroshima": _2, "hongo": _2, "jinsekikogen": _2, "kaita": _2, "kui": _2, "kumano": _2, "kure": _2, "mihara": _2, "miyoshi": _2, "naka": _2, "onomichi": _2, "osakikamijima": _2, "otake": _2, "saka": _2, "sera": _2, "seranishi": _2, "shinichi": _2, "shobara": _2, "takehara": _2 }], "hokkaido": [1, { "abashiri": _2, "abira": _2, "aibetsu": _2, "akabira": _2, "akkeshi": _2, "asahikawa": _2, "ashibetsu": _2, "ashoro": _2, "assabu": _2, "atsuma": _2, "bibai": _2, "biei": _2, "bifuka": _2, "bihoro": _2, "biratori": _2, "chippubetsu": _2, "chitose": _2, "date": _2, "ebetsu": _2, "embetsu": _2, "eniwa": _2, "erimo": _2, "esan": _2, "esashi": _2, "fukagawa": _2, "fukushima": _2, "furano": _2, "furubira": _2, "haboro": _2, "hakodate": _2, "hamatonbetsu": _2, "hidaka": _2, "higashikagura": _2, "higashikawa": _2, "hiroo": _2, "hokuryu": _2, "hokuto": _2, "honbetsu": _2, "horokanai": _2, "horonobe": _2, "ikeda": _2, "imakane": _2, "ishikari": _2, "iwamizawa": _2, "iwanai": _2, "kamifurano": _2, "kamikawa": _2, "kamishihoro": _2, "kamisunagawa": _2, "kamoenai": _2, "kayabe": _2, "kembuchi": _2, "kikonai": _2, "kimobetsu": _2, "kitahiroshima": _2, "kitami": _2, "kiyosato": _2, "koshimizu": _2, "kunneppu": _2, "kuriyama": _2, "kuromatsunai": _2, "kushiro": _2, "kutchan": _2, "kyowa": _2, "mashike": _2, "matsumae": _2, "mikasa": _2, "minamifurano": _2, "mombetsu": _2, "moseushi": _2, "mukawa": _2, "muroran": _2, "naie": _2, "nakagawa": _2, "nakasatsunai": _2, "nakatombetsu": _2, "nanae": _2, "nanporo": _2, "nayoro": _2, "nemuro": _2, "niikappu": _2, "niki": _2, "nishiokoppe": _2, "noboribetsu": _2, "numata": _2, "obihiro": _2, "obira": _2, "oketo": _2, "okoppe": _2, "otaru": _2, "otobe": _2, "otofuke": _2, "otoineppu": _2, "oumu": _2, "ozora": _2, "pippu": _2, "rankoshi": _2, "rebun": _2, "rikubetsu": _2, "rishiri": _2, "rishirifuji": _2, "saroma": _2, "sarufutsu": _2, "shakotan": _2, "shari": _2, "shibecha": _2, "shibetsu": _2, "shikabe": _2, "shikaoi": _2, "shimamaki": _2, "shimizu": _2, "shimokawa": _2, "shinshinotsu": _2, "shintoku": _2, "shiranuka": _2, "shiraoi": _2, "shiriuchi": _2, "sobetsu": _2, "sunagawa": _2, "taiki": _2, "takasu": _2, "takikawa": _2, "takinoue": _2, "teshikaga": _2, "tobetsu": _2, "tohma": _2, "tomakomai": _2, "tomari": _2, "toya": _2, "toyako": _2, "toyotomi": _2, "toyoura": _2, "tsubetsu": _2, "tsukigata": _2, "urakawa": _2, "urausu": _2, "uryu": _2, "utashinai": _2, "wakkanai": _2, "wassamu": _2, "yakumo": _2, "yoichi": _2 }], "hyogo": [1, { "aioi": _2, "akashi": _2, "ako": _2, "amagasaki": _2, "aogaki": _2, "asago": _2, "ashiya": _2, "awaji": _2, "fukusaki": _2, "goshiki": _2, "harima": _2, "himeji": _2, "ichikawa": _2, "inagawa": _2, "itami": _2, "kakogawa": _2, "kamigori": _2, "kamikawa": _2, "kasai": _2, "kasuga": _2, "kawanishi": _2, "miki": _2, "minamiawaji": _2, "nishinomiya": _2, "nishiwaki": _2, "ono": _2, "sanda": _2, "sannan": _2, "sasayama": _2, "sayo": _2, "shingu": _2, "shinonsen": _2, "shiso": _2, "sumoto": _2, "taishi": _2, "taka": _2, "takarazuka": _2, "takasago": _2, "takino": _2, "tamba": _2, "tatsuno": _2, "toyooka": _2, "yabu": _2, "yashiro": _2, "yoka": _2, "yokawa": _2 }], "ibaraki": [1, { "ami": _2, "asahi": _2, "bando": _2, "chikusei": _2, "daigo": _2, "fujishiro": _2, "hitachi": _2, "hitachinaka": _2, "hitachiomiya": _2, "hitachiota": _2, "ibaraki": _2, "ina": _2, "inashiki": _2, "itako": _2, "iwama": _2, "joso": _2, "kamisu": _2, "kasama": _2, "kashima": _2, "kasumigaura": _2, "koga": _2, "miho": _2, "mito": _2, "moriya": _2, "naka": _2, "namegata": _2, "oarai": _2, "ogawa": _2, "omitama": _2, "ryugasaki": _2, "sakai": _2, "sakuragawa": _2, "shimodate": _2, "shimotsuma": _2, "shirosato": _2, "sowa": _2, "suifu": _2, "takahagi": _2, "tamatsukuri": _2, "tokai": _2, "tomobe": _2, "tone": _2, "toride": _2, "tsuchiura": _2, "tsukuba": _2, "uchihara": _2, "ushiku": _2, "yachiyo": _2, "yamagata": _2, "yawara": _2, "yuki": _2 }], "ishikawa": [1, { "anamizu": _2, "hakui": _2, "hakusan": _2, "kaga": _2, "kahoku": _2, "kanazawa": _2, "kawakita": _2, "komatsu": _2, "nakanoto": _2, "nanao": _2, "nomi": _2, "nonoichi": _2, "noto": _2, "shika": _2, "suzu": _2, "tsubata": _2, "tsurugi": _2, "uchinada": _2, "wajima": _2 }], "iwate": [1, { "fudai": _2, "fujisawa": _2, "hanamaki": _2, "hiraizumi": _2, "hirono": _2, "ichinohe": _2, "ichinoseki": _2, "iwaizumi": _2, "iwate": _2, "joboji": _2, "kamaishi": _2, "kanegasaki": _2, "karumai": _2, "kawai": _2, "kitakami": _2, "kuji": _2, "kunohe": _2, "kuzumaki": _2, "miyako": _2, "mizusawa": _2, "morioka": _2, "ninohe": _2, "noda": _2, "ofunato": _2, "oshu": _2, "otsuchi": _2, "rikuzentakata": _2, "shiwa": _2, "shizukuishi": _2, "sumita": _2, "tanohata": _2, "tono": _2, "yahaba": _2, "yamada": _2 }], "kagawa": [1, { "ayagawa": _2, "higashikagawa": _2, "kanonji": _2, "kotohira": _2, "manno": _2, "marugame": _2, "mitoyo": _2, "naoshima": _2, "sanuki": _2, "tadotsu": _2, "takamatsu": _2, "tonosho": _2, "uchinomi": _2, "utazu": _2, "zentsuji": _2 }], "kagoshima": [1, { "akune": _2, "amami": _2, "hioki": _2, "isa": _2, "isen": _2, "izumi": _2, "kagoshima": _2, "kanoya": _2, "kawanabe": _2, "kinko": _2, "kouyama": _2, "makurazaki": _2, "matsumoto": _2, "minamitane": _2, "nakatane": _2, "nishinoomote": _2, "satsumasendai": _2, "soo": _2, "tarumizu": _2, "yusui": _2 }], "kanagawa": [1, { "aikawa": _2, "atsugi": _2, "ayase": _2, "chigasaki": _2, "ebina": _2, "fujisawa": _2, "hadano": _2, "hakone": _2, "hiratsuka": _2, "isehara": _2, "kaisei": _2, "kamakura": _2, "kiyokawa": _2, "matsuda": _2, "minamiashigara": _2, "miura": _2, "nakai": _2, "ninomiya": _2, "odawara": _2, "oi": _2, "oiso": _2, "sagamihara": _2, "samukawa": _2, "tsukui": _2, "yamakita": _2, "yamato": _2, "yokosuka": _2, "yugawara": _2, "zama": _2, "zushi": _2 }], "kochi": [1, { "aki": _2, "geisei": _2, "hidaka": _2, "higashitsuno": _2, "ino": _2, "kagami": _2, "kami": _2, "kitagawa": _2, "kochi": _2, "mihara": _2, "motoyama": _2, "muroto": _2, "nahari": _2, "nakamura": _2, "nankoku": _2, "nishitosa": _2, "niyodogawa": _2, "ochi": _2, "okawa": _2, "otoyo": _2, "otsuki": _2, "sakawa": _2, "sukumo": _2, "susaki": _2, "tosa": _2, "tosashimizu": _2, "toyo": _2, "tsuno": _2, "umaji": _2, "yasuda": _2, "yusuhara": _2 }], "kumamoto": [1, { "amakusa": _2, "arao": _2, "aso": _2, "choyo": _2, "gyokuto": _2, "kamiamakusa": _2, "kikuchi": _2, "kumamoto": _2, "mashiki": _2, "mifune": _2, "minamata": _2, "minamioguni": _2, "nagasu": _2, "nishihara": _2, "oguni": _2, "ozu": _2, "sumoto": _2, "takamori": _2, "uki": _2, "uto": _2, "yamaga": _2, "yamato": _2, "yatsushiro": _2 }], "kyoto": [1, { "ayabe": _2, "fukuchiyama": _2, "higashiyama": _2, "ide": _2, "ine": _2, "joyo": _2, "kameoka": _2, "kamo": _2, "kita": _2, "kizu": _2, "kumiyama": _2, "kyotamba": _2, "kyotanabe": _2, "kyotango": _2, "maizuru": _2, "minami": _2, "minamiyamashiro": _2, "miyazu": _2, "muko": _2, "nagaokakyo": _2, "nakagyo": _2, "nantan": _2, "oyamazaki": _2, "sakyo": _2, "seika": _2, "tanabe": _2, "uji": _2, "ujitawara": _2, "wazuka": _2, "yamashina": _2, "yawata": _2 }], "mie": [1, { "asahi": _2, "inabe": _2, "ise": _2, "kameyama": _2, "kawagoe": _2, "kiho": _2, "kisosaki": _2, "kiwa": _2, "komono": _2, "kumano": _2, "kuwana": _2, "matsusaka": _2, "meiwa": _2, "mihama": _2, "minamiise": _2, "misugi": _2, "miyama": _2, "nabari": _2, "shima": _2, "suzuka": _2, "tado": _2, "taiki": _2, "taki": _2, "tamaki": _2, "toba": _2, "tsu": _2, "udono": _2, "ureshino": _2, "watarai": _2, "yokkaichi": _2 }], "miyagi": [1, { "furukawa": _2, "higashimatsushima": _2, "ishinomaki": _2, "iwanuma": _2, "kakuda": _2, "kami": _2, "kawasaki": _2, "marumori": _2, "matsushima": _2, "minamisanriku": _2, "misato": _2, "murata": _2, "natori": _2, "ogawara": _2, "ohira": _2, "onagawa": _2, "osaki": _2, "rifu": _2, "semine": _2, "shibata": _2, "shichikashuku": _2, "shikama": _2, "shiogama": _2, "shiroishi": _2, "tagajo": _2, "taiwa": _2, "tome": _2, "tomiya": _2, "wakuya": _2, "watari": _2, "yamamoto": _2, "zao": _2 }], "miyazaki": [1, { "aya": _2, "ebino": _2, "gokase": _2, "hyuga": _2, "kadogawa": _2, "kawaminami": _2, "kijo": _2, "kitagawa": _2, "kitakata": _2, "kitaura": _2, "kobayashi": _2, "kunitomi": _2, "kushima": _2, "mimata": _2, "miyakonojo": _2, "miyazaki": _2, "morotsuka": _2, "nichinan": _2, "nishimera": _2, "nobeoka": _2, "saito": _2, "shiiba": _2, "shintomi": _2, "takaharu": _2, "takanabe": _2, "takazaki": _2, "tsuno": _2 }], "nagano": [1, { "achi": _2, "agematsu": _2, "anan": _2, "aoki": _2, "asahi": _2, "azumino": _2, "chikuhoku": _2, "chikuma": _2, "chino": _2, "fujimi": _2, "hakuba": _2, "hara": _2, "hiraya": _2, "iida": _2, "iijima": _2, "iiyama": _2, "iizuna": _2, "ikeda": _2, "ikusaka": _2, "ina": _2, "karuizawa": _2, "kawakami": _2, "kiso": _2, "kisofukushima": _2, "kitaaiki": _2, "komagane": _2, "komoro": _2, "matsukawa": _2, "matsumoto": _2, "miasa": _2, "minamiaiki": _2, "minamimaki": _2, "minamiminowa": _2, "minowa": _2, "miyada": _2, "miyota": _2, "mochizuki": _2, "nagano": _2, "nagawa": _2, "nagiso": _2, "nakagawa": _2, "nakano": _2, "nozawaonsen": _2, "obuse": _2, "ogawa": _2, "okaya": _2, "omachi": _2, "omi": _2, "ookuwa": _2, "ooshika": _2, "otaki": _2, "otari": _2, "sakae": _2, "sakaki": _2, "saku": _2, "sakuho": _2, "shimosuwa": _2, "shinanomachi": _2, "shiojiri": _2, "suwa": _2, "suzaka": _2, "takagi": _2, "takamori": _2, "takayama": _2, "tateshina": _2, "tatsuno": _2, "togakushi": _2, "togura": _2, "tomi": _2, "ueda": _2, "wada": _2, "yamagata": _2, "yamanouchi": _2, "yasaka": _2, "yasuoka": _2 }], "nagasaki": [1, { "chijiwa": _2, "futsu": _2, "goto": _2, "hasami": _2, "hirado": _2, "iki": _2, "isahaya": _2, "kawatana": _2, "kuchinotsu": _2, "matsuura": _2, "nagasaki": _2, "obama": _2, "omura": _2, "oseto": _2, "saikai": _2, "sasebo": _2, "seihi": _2, "shimabara": _2, "shinkamigoto": _2, "togitsu": _2, "tsushima": _2, "unzen": _2 }], "nara": [1, { "ando": _2, "gose": _2, "heguri": _2, "higashiyoshino": _2, "ikaruga": _2, "ikoma": _2, "kamikitayama": _2, "kanmaki": _2, "kashiba": _2, "kashihara": _2, "katsuragi": _2, "kawai": _2, "kawakami": _2, "kawanishi": _2, "koryo": _2, "kurotaki": _2, "mitsue": _2, "miyake": _2, "nara": _2, "nosegawa": _2, "oji": _2, "ouda": _2, "oyodo": _2, "sakurai": _2, "sango": _2, "shimoichi": _2, "shimokitayama": _2, "shinjo": _2, "soni": _2, "takatori": _2, "tawaramoto": _2, "tenkawa": _2, "tenri": _2, "uda": _2, "yamatokoriyama": _2, "yamatotakada": _2, "yamazoe": _2, "yoshino": _2 }], "niigata": [1, { "aga": _2, "agano": _2, "gosen": _2, "itoigawa": _2, "izumozaki": _2, "joetsu": _2, "kamo": _2, "kariwa": _2, "kashiwazaki": _2, "minamiuonuma": _2, "mitsuke": _2, "muika": _2, "murakami": _2, "myoko": _2, "nagaoka": _2, "niigata": _2, "ojiya": _2, "omi": _2, "sado": _2, "sanjo": _2, "seiro": _2, "seirou": _2, "sekikawa": _2, "shibata": _2, "tagami": _2, "tainai": _2, "tochio": _2, "tokamachi": _2, "tsubame": _2, "tsunan": _2, "uonuma": _2, "yahiko": _2, "yoita": _2, "yuzawa": _2 }], "oita": [1, { "beppu": _2, "bungoono": _2, "bungotakada": _2, "hasama": _2, "hiji": _2, "himeshima": _2, "hita": _2, "kamitsue": _2, "kokonoe": _2, "kuju": _2, "kunisaki": _2, "kusu": _2, "oita": _2, "saiki": _2, "taketa": _2, "tsukumi": _2, "usa": _2, "usuki": _2, "yufu": _2 }], "okayama": [1, { "akaiwa": _2, "asakuchi": _2, "bizen": _2, "hayashima": _2, "ibara": _2, "kagamino": _2, "kasaoka": _2, "kibichuo": _2, "kumenan": _2, "kurashiki": _2, "maniwa": _2, "misaki": _2, "nagi": _2, "niimi": _2, "nishiawakura": _2, "okayama": _2, "satosho": _2, "setouchi": _2, "shinjo": _2, "shoo": _2, "soja": _2, "takahashi": _2, "tamano": _2, "tsuyama": _2, "wake": _2, "yakage": _2 }], "okinawa": [1, { "aguni": _2, "ginowan": _2, "ginoza": _2, "gushikami": _2, "haebaru": _2, "higashi": _2, "hirara": _2, "iheya": _2, "ishigaki": _2, "ishikawa": _2, "itoman": _2, "izena": _2, "kadena": _2, "kin": _2, "kitadaito": _2, "kitanakagusuku": _2, "kumejima": _2, "kunigami": _2, "minamidaito": _2, "motobu": _2, "nago": _2, "naha": _2, "nakagusuku": _2, "nakijin": _2, "nanjo": _2, "nishihara": _2, "ogimi": _2, "okinawa": _2, "onna": _2, "shimoji": _2, "taketomi": _2, "tarama": _2, "tokashiki": _2, "tomigusuku": _2, "tonaki": _2, "urasoe": _2, "uruma": _2, "yaese": _2, "yomitan": _2, "yonabaru": _2, "yonaguni": _2, "zamami": _2 }], "osaka": [1, { "abeno": _2, "chihayaakasaka": _2, "chuo": _2, "daito": _2, "fujiidera": _2, "habikino": _2, "hannan": _2, "higashiosaka": _2, "higashisumiyoshi": _2, "higashiyodogawa": _2, "hirakata": _2, "ibaraki": _2, "ikeda": _2, "izumi": _2, "izumiotsu": _2, "izumisano": _2, "kadoma": _2, "kaizuka": _2, "kanan": _2, "kashiwara": _2, "katano": _2, "kawachinagano": _2, "kishiwada": _2, "kita": _2, "kumatori": _2, "matsubara": _2, "minato": _2, "minoh": _2, "misaki": _2, "moriguchi": _2, "neyagawa": _2, "nishi": _2, "nose": _2, "osakasayama": _2, "sakai": _2, "sayama": _2, "sennan": _2, "settsu": _2, "shijonawate": _2, "shimamoto": _2, "suita": _2, "tadaoka": _2, "taishi": _2, "tajiri": _2, "takaishi": _2, "takatsuki": _2, "tondabayashi": _2, "toyonaka": _2, "toyono": _2, "yao": _2 }], "saga": [1, { "ariake": _2, "arita": _2, "fukudomi": _2, "genkai": _2, "hamatama": _2, "hizen": _2, "imari": _2, "kamimine": _2, "kanzaki": _2, "karatsu": _2, "kashima": _2, "kitagata": _2, "kitahata": _2, "kiyama": _2, "kouhoku": _2, "kyuragi": _2, "nishiarita": _2, "ogi": _2, "omachi": _2, "ouchi": _2, "saga": _2, "shiroishi": _2, "taku": _2, "tara": _2, "tosu": _2, "yoshinogari": _2 }], "saitama": [1, { "arakawa": _2, "asaka": _2, "chichibu": _2, "fujimi": _2, "fujimino": _2, "fukaya": _2, "hanno": _2, "hanyu": _2, "hasuda": _2, "hatogaya": _2, "hatoyama": _2, "hidaka": _2, "higashichichibu": _2, "higashimatsuyama": _2, "honjo": _2, "ina": _2, "iruma": _2, "iwatsuki": _2, "kamiizumi": _2, "kamikawa": _2, "kamisato": _2, "kasukabe": _2, "kawagoe": _2, "kawaguchi": _2, "kawajima": _2, "kazo": _2, "kitamoto": _2, "koshigaya": _2, "kounosu": _2, "kuki": _2, "kumagaya": _2, "matsubushi": _2, "minano": _2, "misato": _2, "miyashiro": _2, "miyoshi": _2, "moroyama": _2, "nagatoro": _2, "namegawa": _2, "niiza": _2, "ogano": _2, "ogawa": _2, "ogose": _2, "okegawa": _2, "omiya": _2, "otaki": _2, "ranzan": _2, "ryokami": _2, "saitama": _2, "sakado": _2, "satte": _2, "sayama": _2, "shiki": _2, "shiraoka": _2, "soka": _2, "sugito": _2, "toda": _2, "tokigawa": _2, "tokorozawa": _2, "tsurugashima": _2, "urawa": _2, "warabi": _2, "yashio": _2, "yokoze": _2, "yono": _2, "yorii": _2, "yoshida": _2, "yoshikawa": _2, "yoshimi": _2 }], "shiga": [1, { "aisho": _2, "gamo": _2, "higashiomi": _2, "hikone": _2, "koka": _2, "konan": _2, "kosei": _2, "koto": _2, "kusatsu": _2, "maibara": _2, "moriyama": _2, "nagahama": _2, "nishiazai": _2, "notogawa": _2, "omihachiman": _2, "otsu": _2, "ritto": _2, "ryuoh": _2, "takashima": _2, "takatsuki": _2, "torahime": _2, "toyosato": _2, "yasu": _2 }], "shimane": [1, { "akagi": _2, "ama": _2, "gotsu": _2, "hamada": _2, "higashiizumo": _2, "hikawa": _2, "hikimi": _2, "izumo": _2, "kakinoki": _2, "masuda": _2, "matsue": _2, "misato": _2, "nishinoshima": _2, "ohda": _2, "okinoshima": _2, "okuizumo": _2, "shimane": _2, "tamayu": _2, "tsuwano": _2, "unnan": _2, "yakumo": _2, "yasugi": _2, "yatsuka": _2 }], "shizuoka": [1, { "arai": _2, "atami": _2, "fuji": _2, "fujieda": _2, "fujikawa": _2, "fujinomiya": _2, "fukuroi": _2, "gotemba": _2, "haibara": _2, "hamamatsu": _2, "higashiizu": _2, "ito": _2, "iwata": _2, "izu": _2, "izunokuni": _2, "kakegawa": _2, "kannami": _2, "kawanehon": _2, "kawazu": _2, "kikugawa": _2, "kosai": _2, "makinohara": _2, "matsuzaki": _2, "minamiizu": _2, "mishima": _2, "morimachi": _2, "nishiizu": _2, "numazu": _2, "omaezaki": _2, "shimada": _2, "shimizu": _2, "shimoda": _2, "shizuoka": _2, "susono": _2, "yaizu": _2, "yoshida": _2 }], "tochigi": [1, { "ashikaga": _2, "bato": _2, "haga": _2, "ichikai": _2, "iwafune": _2, "kaminokawa": _2, "kanuma": _2, "karasuyama": _2, "kuroiso": _2, "mashiko": _2, "mibu": _2, "moka": _2, "motegi": _2, "nasu": _2, "nasushiobara": _2, "nikko": _2, "nishikata": _2, "nogi": _2, "ohira": _2, "ohtawara": _2, "oyama": _2, "sakura": _2, "sano": _2, "shimotsuke": _2, "shioya": _2, "takanezawa": _2, "tochigi": _2, "tsuga": _2, "ujiie": _2, "utsunomiya": _2, "yaita": _2 }], "tokushima": [1, { "aizumi": _2, "anan": _2, "ichiba": _2, "itano": _2, "kainan": _2, "komatsushima": _2, "matsushige": _2, "mima": _2, "minami": _2, "miyoshi": _2, "mugi": _2, "nakagawa": _2, "naruto": _2, "sanagochi": _2, "shishikui": _2, "tokushima": _2, "wajiki": _2 }], "tokyo": [1, { "adachi": _2, "akiruno": _2, "akishima": _2, "aogashima": _2, "arakawa": _2, "bunkyo": _2, "chiyoda": _2, "chofu": _2, "chuo": _2, "edogawa": _2, "fuchu": _2, "fussa": _2, "hachijo": _2, "hachioji": _2, "hamura": _2, "higashikurume": _2, "higashimurayama": _2, "higashiyamato": _2, "hino": _2, "hinode": _2, "hinohara": _2, "inagi": _2, "itabashi": _2, "katsushika": _2, "kita": _2, "kiyose": _2, "kodaira": _2, "koganei": _2, "kokubunji": _2, "komae": _2, "koto": _2, "kouzushima": _2, "kunitachi": _2, "machida": _2, "meguro": _2, "minato": _2, "mitaka": _2, "mizuho": _2, "musashimurayama": _2, "musashino": _2, "nakano": _2, "nerima": _2, "ogasawara": _2, "okutama": _2, "ome": _2, "oshima": _2, "ota": _2, "setagaya": _2, "shibuya": _2, "shinagawa": _2, "shinjuku": _2, "suginami": _2, "sumida": _2, "tachikawa": _2, "taito": _2, "tama": _2, "toshima": _2 }], "tottori": [1, { "chizu": _2, "hino": _2, "kawahara": _2, "koge": _2, "kotoura": _2, "misasa": _2, "nanbu": _2, "nichinan": _2, "sakaiminato": _2, "tottori": _2, "wakasa": _2, "yazu": _2, "yonago": _2 }], "toyama": [1, { "asahi": _2, "fuchu": _2, "fukumitsu": _2, "funahashi": _2, "himi": _2, "imizu": _2, "inami": _2, "johana": _2, "kamiichi": _2, "kurobe": _2, "nakaniikawa": _2, "namerikawa": _2, "nanto": _2, "nyuzen": _2, "oyabe": _2, "taira": _2, "takaoka": _2, "tateyama": _2, "toga": _2, "tonami": _2, "toyama": _2, "unazuki": _2, "uozu": _2, "yamada": _2 }], "wakayama": [1, { "arida": _2, "aridagawa": _2, "gobo": _2, "hashimoto": _2, "hidaka": _2, "hirogawa": _2, "inami": _2, "iwade": _2, "kainan": _2, "kamitonda": _2, "katsuragi": _2, "kimino": _2, "kinokawa": _2, "kitayama": _2, "koya": _2, "koza": _2, "kozagawa": _2, "kudoyama": _2, "kushimoto": _2, "mihama": _2, "misato": _2, "nachikatsuura": _2, "shingu": _2, "shirahama": _2, "taiji": _2, "tanabe": _2, "wakayama": _2, "yuasa": _2, "yura": _2 }], "yamagata": [1, { "asahi": _2, "funagata": _2, "higashine": _2, "iide": _2, "kahoku": _2, "kaminoyama": _2, "kaneyama": _2, "kawanishi": _2, "mamurogawa": _2, "mikawa": _2, "murayama": _2, "nagai": _2, "nakayama": _2, "nanyo": _2, "nishikawa": _2, "obanazawa": _2, "oe": _2, "oguni": _2, "ohkura": _2, "oishida": _2, "sagae": _2, "sakata": _2, "sakegawa": _2, "shinjo": _2, "shirataka": _2, "shonai": _2, "takahata": _2, "tendo": _2, "tozawa": _2, "tsuruoka": _2, "yamagata": _2, "yamanobe": _2, "yonezawa": _2, "yuza": _2 }], "yamaguchi": [1, { "abu": _2, "hagi": _2, "hikari": _2, "hofu": _2, "iwakuni": _2, "kudamatsu": _2, "mitou": _2, "nagato": _2, "oshima": _2, "shimonoseki": _2, "shunan": _2, "tabuse": _2, "tokuyama": _2, "toyota": _2, "ube": _2, "yuu": _2 }], "yamanashi": [1, { "chuo": _2, "doshi": _2, "fuefuki": _2, "fujikawa": _2, "fujikawaguchiko": _2, "fujiyoshida": _2, "hayakawa": _2, "hokuto": _2, "ichikawamisato": _2, "kai": _2, "kofu": _2, "koshu": _2, "kosuge": _2, "minami-alps": _2, "minobu": _2, "nakamichi": _2, "nanbu": _2, "narusawa": _2, "nirasaki": _2, "nishikatsura": _2, "oshino": _2, "otsuki": _2, "showa": _2, "tabayama": _2, "tsuru": _2, "uenohara": _2, "yamanakako": _2, "yamanashi": _2 }], "xn--4pvxs": _2, "栃木": _2, "xn--vgu402c": _2, "愛知": _2, "xn--c3s14m": _2, "愛媛": _2, "xn--f6qx53a": _2, "兵庫": _2, "xn--8pvr4u": _2, "熊本": _2, "xn--uist22h": _2, "茨城": _2, "xn--djrs72d6uy": _2, "北海道": _2, "xn--mkru45i": _2, "千葉": _2, "xn--0trq7p7nn": _2, "和歌山": _2, "xn--8ltr62k": _2, "長崎": _2, "xn--2m4a15e": _2, "長野": _2, "xn--efvn9s": _2, "新潟": _2, "xn--32vp30h": _2, "青森": _2, "xn--4it797k": _2, "静岡": _2, "xn--1lqs71d": _2, "東京": _2, "xn--5rtp49c": _2, "石川": _2, "xn--5js045d": _2, "埼玉": _2, "xn--ehqz56n": _2, "三重": _2, "xn--1lqs03n": _2, "京都": _2, "xn--qqqt11m": _2, "佐賀": _2, "xn--kbrq7o": _2, "大分": _2, "xn--pssu33l": _2, "大阪": _2, "xn--ntsq17g": _2, "奈良": _2, "xn--uisz3g": _2, "宮城": _2, "xn--6btw5a": _2, "宮崎": _2, "xn--1ctwo": _2, "富山": _2, "xn--6orx2r": _2, "山口": _2, "xn--rht61e": _2, "山形": _2, "xn--rht27z": _2, "山梨": _2, "xn--djty4k": _2, "岩手": _2, "xn--nit225k": _2, "岐阜": _2, "xn--rht3d": _2, "岡山": _2, "xn--klty5x": _2, "島根": _2, "xn--kltx9a": _2, "広島": _2, "xn--kltp7d": _2, "徳島": _2, "xn--uuwu58a": _2, "沖縄": _2, "xn--zbx025d": _2, "滋賀": _2, "xn--ntso0iqx3a": _2, "神奈川": _2, "xn--elqq16h": _2, "福井": _2, "xn--4it168d": _2, "福岡": _2, "xn--klt787d": _2, "福島": _2, "xn--rny31h": _2, "秋田": _2, "xn--7t0a264c": _2, "群馬": _2, "xn--5rtq34k": _2, "香川": _2, "xn--k7yn95e": _2, "高知": _2, "xn--tor131o": _2, "鳥取": _2, "xn--d5qv7z876c": _2, "鹿児島": _2, "kawasaki": _8, "kitakyushu": _8, "kobe": _8, "nagoya": _8, "sapporo": _8, "sendai": _8, "yokohama": _8, "buyshop": _3, "fashionstore": _3, "handcrafted": _3, "kawaiishop": _3, "supersale": _3, "theshop": _3, "usercontent": _3, "angry": _3, "babyblue": _3, "babymilk": _3, "backdrop": _3, "bambina": _3, "bitter": _3, "blush": _3, "boo": _3, "boy": _3, "boyfriend": _3, "but": _3, "candypop": _3, "capoo": _3, "catfood": _3, "cheap": _3, "chicappa": _3, "chillout": _3, "chips": _3, "chowder": _3, "chu": _3, "ciao": _3, "cocotte": _3, "coolblog": _3, "cranky": _3, "cutegirl": _3, "daa": _3, "deca": _3, "deci": _3, "digick": _3, "egoism": _3, "fakefur": _3, "fem": _3, "flier": _3, "floppy": _3, "fool": _3, "frenchkiss": _3, "girlfriend": _3, "girly": _3, "gloomy": _3, "gonna": _3, "greater": _3, "hacca": _3, "heavy": _3, "her": _3, "hiho": _3, "hippy": _3, "holy": _3, "hungry": _3, "icurus": _3, "itigo": _3, "jellybean": _3, "kikirara": _3, "kill": _3, "kilo": _3, "kuron": _3, "littlestar": _3, "lolipopmc": _3, "lolitapunk": _3, "lomo": _3, "lovepop": _3, "lovesick": _3, "main": _3, "mods": _3, "mond": _3, "mongolian": _3, "moo": _3, "namaste": _3, "nikita": _3, "nobushi": _3, "noor": _3, "oops": _3, "parallel": _3, "parasite": _3, "pecori": _3, "peewee": _3, "penne": _3, "pepper": _3, "perma": _3, "pigboat": _3, "pinoko": _3, "punyu": _3, "pupu": _3, "pussycat": _3, "pya": _3, "raindrop": _3, "readymade": _3, "sadist": _3, "schoolbus": _3, "secret": _3, "staba": _3, "stripper": _3, "sub": _3, "sunnyday": _3, "thick": _3, "tonkotsu": _3, "under": _3, "upper": _3, "velvet": _3, "verse": _3, "versus": _3, "vivian": _3, "watson": _3, "weblike": _3, "whitesnow": _3, "zombie": _3, "blogspot": _3, "2-d": _3, "bona": _3, "crap": _3, "daynight": _3, "eek": _3, "flop": _3, "halfmoon": _3, "jeez": _3, "matrix": _3, "mimoza": _3, "netgamers": _3, "nyanta": _3, "o0o0": _3, "rdy": _3, "rgr": _3, "rulez": _3, "sakurastorage": [0, { "isk01": _12, "isk02": _12 }], "saloon": _3, "sblo": _3, "skr": _3, "tank": _3, "uh-oh": _3, "undo": _3, "webaccel": [0, { "rs": _3, "user": _3 }], "websozai": _3, "xii": _3 }], "ke": [1, { "ac": _2, "co": _6, "go": _2, "info": _2, "me": _2, "mobi": _2, "ne": _2, "or": _2, "sc": _2 }], "kg": [1, { "org": _2, "net": _2, "com": _2, "edu": _2, "gov": _2, "mil": _2, "blog": _3, "io": _3, "jp": _3, "tv": _3, "uk": _3, "us": _3 }], "kh": _8, "ki": _35, "km": [1, { "org": _2, "nom": _2, "gov": _2, "prd": _2, "tm": _2, "edu": _2, "mil": _2, "ass": _2, "com": _2, "coop": _2, "asso": _2, "presse": _2, "medecin": _2, "notaires": _2, "pharmaciens": _2, "veterinaire": _2, "gouv": _2 }], "kn": [1, { "net": _2, "org": _2, "edu": _2, "gov": _2 }], "kp": [1, { "com": _2, "edu": _2, "gov": _2, "org": _2, "rep": _2, "tra": _2 }], "kr": [1, { "ac": _2, "co": _2, "es": _2, "go": _2, "hs": _2, "kg": _2, "mil": _2, "ms": _2, "ne": _2, "or": _2, "pe": _2, "re": _2, "sc": _2, "busan": _2, "chungbuk": _2, "chungnam": _2, "daegu": _2, "daejeon": _2, "gangwon": _2, "gwangju": _2, "gyeongbuk": _2, "gyeonggi": _2, "gyeongnam": _2, "incheon": _2, "jeju": _2, "jeonbuk": _2, "jeonnam": _2, "seoul": _2, "ulsan": _2, "blogspot": _3 }], "kw": [1, { "com": _2, "edu": _2, "emb": _2, "gov": _2, "ind": _2, "net": _2, "org": _2 }], "ky": _27, "kz": [1, { "org": _2, "edu": _2, "net": _2, "gov": _2, "mil": _2, "com": _2, "jcloud": _3, "kazteleport": [0, { "upaas": _3 }] }], "la": [1, { "int": _2, "net": _2, "info": _2, "edu": _2, "gov": _2, "per": _2, "com": _2, "org": _2, "bnr": _3, "c": _3 }], "lb": _4, "lc": [1, { "com": _2, "net": _2, "co": _2, "org": _2, "edu": _2, "gov": _2, "oy": _3 }], "li": [1, { "blogspot": _3, "caa": _3 }], "lk": [1, { "gov": _2, "sch": _2, "net": _2, "int": _2, "com": _2, "org": _2, "edu": _2, "ngo": _2, "soc": _2, "web": _2, "ltd": _2, "assn": _2, "grp": _2, "hotel": _2, "ac": _2 }], "lr": _4, "ls": [1, { "ac": _2, "biz": _2, "co": _2, "edu": _2, "gov": _2, "info": _2, "net": _2, "org": _2, "sc": _2, "de": _3 }], "lt": _36, "lu": [1, { "blogspot": _3, "123website": _3 }], "lv": [1, { "com": _2, "edu": _2, "gov": _2, "org": _2, "mil": _2, "id": _2, "net": _2, "asn": _2, "conf": _2 }], "ly": [1, { "com": _2, "net": _2, "gov": _2, "plc": _2, "edu": _2, "sch": _2, "med": _2, "org": _2, "id": _2 }], "ma": [1, { "co": _2, "net": _2, "gov": _2, "org": _2, "ac": _2, "press": _2 }], "mc": [1, { "tm": _2, "asso": _2 }], "md": [1, { "blogspot": _3, "at": _3, "de": _3, "jp": _3, "to": _3 }], "me": [1, { "co": _2, "net": _2, "org": _2, "edu": _2, "ac": _2, "gov": _2, "its": _2, "priv": _2, "c66": _3, "daplie": [2, { "localhost": _3 }], "edgestack": _3, "filegear": _3, "filegear-au": _3, "filegear-de": _3, "filegear-gb": _3, "filegear-ie": _3, "filegear-jp": _3, "filegear-sg": _3, "glitch": _3, "ravendb": _3, "lohmus": _3, "barsy": _3, "mcpe": _3, "mcdir": _3, "soundcast": _3, "tcp4": _3, "brasilia": _3, "ddns": _3, "dnsfor": _3, "hopto": _3, "loginto": _3, "noip": _3, "webhop": _3, "vp4": _3, "diskstation": _3, "dscloud": _3, "i234": _3, "myds": _3, "synology": _3, "transip": _25, "wedeploy": _3, "yombo": _3, "nohost": _3 }], "mg": [1, { "org": _2, "nom": _2, "gov": _2, "prd": _2, "tm": _2, "edu": _2, "mil": _2, "com": _2, "co": _2 }], "mh": _2, "mil": _2, "mk": [1, { "com": _2, "org": _2, "net": _2, "edu": _2, "gov": _2, "inf": _2, "name": _2, "blogspot": _3 }], "ml": [1, { "com": _2, "edu": _2, "gouv": _2, "gov": _2, "net": _2, "org": _2, "presse": _2 }], "mm": _8, "mn": [1, { "gov": _2, "edu": _2, "org": _2, "nyc": _3 }], "mo": _4, "mobi": [1, { "barsy": _3, "dscloud": _3 }], "mp": [1, { "ju": _3 }], "mq": _2, "mr": _36, "ms": [1, { "com": _2, "edu": _2, "gov": _2, "net": _2, "org": _2, "lab": _3, "minisite": _3 }], "mt": [1, { "com": _6, "edu": _2, "net": _2, "org": _2 }], "mu": [1, { "com": _2, "net": _2, "org": _2, "gov": _2, "ac": _2, "co": _2, "or": _2 }], "museum": _2, "mv": [1, { "aero": _2, "biz": _2, "com": _2, "coop": _2, "edu": _2, "gov": _2, "info": _2, "int": _2, "mil": _2, "museum": _2, "name": _2, "net": _2, "org": _2, "pro": _2 }], "mw": [1, { "ac": _2, "biz": _2, "co": _2, "com": _2, "coop": _2, "edu": _2, "gov": _2, "int": _2, "museum": _2, "net": _2, "org": _2 }], "mx": [1, { "com": _2, "org": _2, "gob": _2, "edu": _2, "net": _2, "blogspot": _3 }], "my": [1, { "biz": _2, "com": _2, "edu": _2, "gov": _2, "mil": _2, "name": _2, "net": _2, "org": _2, "blogspot": _3 }], "mz": [1, { "ac": _2, "adv": _2, "co": _2, "edu": _2, "gov": _2, "mil": _2, "net": _2, "org": _2 }], "na": [1, { "info": _2, "pro": _2, "name": _2, "school": _2, "or": _2, "dr": _2, "us": _2, "mx": _2, "ca": _2, "in": _2, "cc": _2, "tv": _2, "ws": _2, "mobi": _2, "co": _2, "com": _2, "org": _2 }], "name": [1, { "her": _39, "his": _39 }], "nc": [1, { "asso": _2, "nom": _2 }], "ne": _2, "net": [1, { "adobeaemcloud": _3, "adobeio-static": _3, "adobeioruntime": _3, "akadns": _3, "akamai": _3, "akamai-staging": _3, "akamaiedge": _3, "akamaiedge-staging": _3, "akamaihd": _3, "akamaihd-staging": _3, "akamaiorigin": _3, "akamaiorigin-staging": _3, "akamaized": _3, "akamaized-staging": _3, "edgekey": _3, "edgekey-staging": _3, "edgesuite": _3, "edgesuite-staging": _3, "alwaysdata": _3, "myamaze": _3, "cloudfront": _3, "t3l3p0rt": _3, "appudo": _3, "atlassian-dev": [0, { "prod": [0, { "cdn": _3 }] }], "myfritz": _3, "onavstack": _3, "shopselect": _3, "blackbaudcdn": _3, "boomla": _3, "bplaced": _3, "square7": _3, "gb": _3, "hu": _3, "jp": _3, "se": _3, "uk": _3, "in": _3, "clickrising": _3, "cloudaccess": _3, "cdn77-ssl": _3, "cdn77": [0, { "r": _3 }], "feste-ip": _3, "knx-server": _3, "static-access": _3, "cryptonomic": _5, "dattolocal": _3, "mydatto": _3, "debian": _3, "bitbridge": _3, "at-band-camp": _3, "blogdns": _3, "broke-it": _3, "buyshouses": _3, "dnsalias": _3, "dnsdojo": _3, "does-it": _3, "dontexist": _3, "dynalias": _3, "dynathome": _3, "endofinternet": _3, "from-az": _3, "from-co": _3, "from-la": _3, "from-ny": _3, "gets-it": _3, "ham-radio-op": _3, "homeftp": _3, "homeip": _3, "homelinux": _3, "homeunix": _3, "in-the-band": _3, "is-a-chef": _3, "is-a-geek": _3, "isa-geek": _3, "kicks-ass": _3, "office-on-the": _3, "podzone": _3, "scrapper-site": _3, "selfip": _3, "sells-it": _3, "servebbs": _3, "serveftp": _3, "thruhere": _3, "webhop": _3, "definima": _3, "casacam": _3, "dynu": _3, "dynv6": _3, "twmail": _3, "ru": _3, "channelsdvr": [2, { "u": _3 }], "fastlylb": [2, { "map": _3 }], "fastly": [0, { "freetls": _3, "map": _3, "prod": [0, { "a": _3, "global": _3 }], "ssl": [0, { "a": _3, "b": _3, "global": _3 }] }], "edgeapp": _3, "flynnhosting": _3, "cdn-edges": _3, "heteml": _3, "cloudfunctions": _3, "moonscale": _3, "in-dsl": _3, "in-vpn": _3, "ipifony": _3, "iobb": _3, "cloudjiffy": [2, { "fra1-de": _3, "west1-us": _3 }], "elastx": [0, { "jls-sto1": _3, "jls-sto2": _3, "jls-sto3": _3 }], "faststacks": _3, "massivegrid": [0, { "paas": [0, { "fr-1": _3, "lon-1": _3, "lon-2": _3, "ny-1": _3, "ny-2": _3, "sg-1": _3 }] }], "saveincloud": [0, { "jelastic": _3, "nordeste-idc": _3 }], "scaleforce": _28, "tsukaeru": _29, "kinghost": _3, "uni5": _3, "krellian": _3, "barsy": _3, "memset": _3, "azurewebsites": _3, "azure-mobile": _3, "cloudapp": _3, "azurestaticapps": [2, { "1": _3, "2": _3, "3": _3, "centralus": _3, "eastasia": _3, "eastus2": _3, "westeurope": _3, "westus2": _3 }], "dnsup": _3, "hicam": _3, "now-dns": _3, "ownip": _3, "vpndns": _3, "eating-organic": _3, "mydissent": _3, "myeffect": _3, "mymediapc": _3, "mypsx": _3, "mysecuritycamera": _3, "nhlfan": _3, "no-ip": _3, "pgafan": _3, "privatizehealthinsurance": _3, "bounceme": _3, "ddns": _3, "redirectme": _3, "serveblog": _3, "serveminecraft": _3, "sytes": _3, "cloudycluster": _3, "ovh": [0, { "webpaas": _5, "hosting": _5 }], "bar0": _3, "bar1": _3, "bar2": _3, "rackmaze": _3, "squares": _3, "schokokeks": _3, "firewall-gateway": _3, "seidat": _3, "senseering": _3, "siteleaf": _3, "vps-host": [2, { "jelastic": [0, { "atl": _3, "njs": _3, "ric": _3 }] }], "myspreadshop": _3, "srcf": [0, { "soc": _3, "user": _3 }], "supabase": _3, "dsmynas": _3, "familyds": _3, "tailscale": [0, { "beta": _3 }], "ts": _3, "torproject": [2, { "pages": _3 }], "reserve-online": _3, "community-pro": _3, "meinforum": _3, "yandexcloud": [2, { "storage": _3, "website": _3 }], "za": _3 }], "nf": [1, { "com": _2, "net": _2, "per": _2, "rec": _2, "web": _2, "arts": _2, "firm": _2, "info": _2, "other": _2, "store": _2 }], "ng": [1, { "com": _6, "edu": _2, "gov": _2, "i": _2, "mil": _2, "mobi": _2, "name": _2, "net": _2, "org": _2, "sch": _2, "col": _3, "firm": _3, "gen": _3, "ltd": _3, "ngo": _3 }], "ni": [1, { "ac": _2, "biz": _2, "co": _2, "com": _2, "edu": _2, "gob": _2, "in": _2, "info": _2, "int": _2, "mil": _2, "net": _2, "nom": _2, "org": _2, "web": _2 }], "nl": [1, { "co": _3, "hosting-cluster": _3, "blogspot": _3, "gov": _3, "khplay": _3, "123website": _3, "myspreadshop": _3, "transurl": _5, "cistron": _3, "demon": _3 }], "no": [1, { "fhs": _2, "vgs": _2, "fylkesbibl": _2, "folkebibl": _2, "museum": _2, "idrett": _2, "priv": _2, "mil": _2, "stat": _2, "dep": _2, "kommune": _2, "herad": _2, "aa": _40, "ah": _40, "bu": _40, "fm": _40, "hl": _40, "hm": _40, "jan-mayen": _40, "mr": _40, "nl": _40, "nt": _40, "of": _40, "ol": _40, "oslo": _40, "rl": _40, "sf": _40, "st": _40, "svalbard": _40, "tm": _40, "tr": _40, "va": _40, "vf": _40, "akrehamn": _2, "xn--krehamn-dxa": _2, "åkrehamn": _2, "algard": _2, "xn--lgrd-poac": _2, "ålgård": _2, "arna": _2, "brumunddal": _2, "bryne": _2, "bronnoysund": _2, "xn--brnnysund-m8ac": _2, "brønnøysund": _2, "drobak": _2, "xn--drbak-wua": _2, "drøbak": _2, "egersund": _2, "fetsund": _2, "floro": _2, "xn--flor-jra": _2, "florø": _2, "fredrikstad": _2, "hokksund": _2, "honefoss": _2, "xn--hnefoss-q1a": _2, "hønefoss": _2, "jessheim": _2, "jorpeland": _2, "xn--jrpeland-54a": _2, "jørpeland": _2, "kirkenes": _2, "kopervik": _2, "krokstadelva": _2, "langevag": _2, "xn--langevg-jxa": _2, "langevåg": _2, "leirvik": _2, "mjondalen": _2, "xn--mjndalen-64a": _2, "mjøndalen": _2, "mo-i-rana": _2, "mosjoen": _2, "xn--mosjen-eya": _2, "mosjøen": _2, "nesoddtangen": _2, "orkanger": _2, "osoyro": _2, "xn--osyro-wua": _2, "osøyro": _2, "raholt": _2, "xn--rholt-mra": _2, "råholt": _2, "sandnessjoen": _2, "xn--sandnessjen-ogb": _2, "sandnessjøen": _2, "skedsmokorset": _2, "slattum": _2, "spjelkavik": _2, "stathelle": _2, "stavern": _2, "stjordalshalsen": _2, "xn--stjrdalshalsen-sqb": _2, "stjørdalshalsen": _2, "tananger": _2, "tranby": _2, "vossevangen": _2, "afjord": _2, "xn--fjord-lra": _2, "åfjord": _2, "agdenes": _2, "al": _2, "xn--l-1fa": _2, "ål": _2, "alesund": _2, "xn--lesund-hua": _2, "ålesund": _2, "alstahaug": _2, "alta": _2, "xn--lt-liac": _2, "áltá": _2, "alaheadju": _2, "xn--laheadju-7ya": _2, "álaheadju": _2, "alvdal": _2, "amli": _2, "xn--mli-tla": _2, "åmli": _2, "amot": _2, "xn--mot-tla": _2, "åmot": _2, "andebu": _2, "andoy": _2, "xn--andy-ira": _2, "andøy": _2, "andasuolo": _2, "ardal": _2, "xn--rdal-poa": _2, "årdal": _2, "aremark": _2, "arendal": _2, "xn--s-1fa": _2, "ås": _2, "aseral": _2, "xn--seral-lra": _2, "åseral": _2, "asker": _2, "askim": _2, "askvoll": _2, "askoy": _2, "xn--asky-ira": _2, "askøy": _2, "asnes": _2, "xn--snes-poa": _2, "åsnes": _2, "audnedaln": _2, "aukra": _2, "aure": _2, "aurland": _2, "aurskog-holand": _2, "xn--aurskog-hland-jnb": _2, "aurskog-høland": _2, "austevoll": _2, "austrheim": _2, "averoy": _2, "xn--avery-yua": _2, "averøy": _2, "balestrand": _2, "ballangen": _2, "balat": _2, "xn--blt-elab": _2, "bálát": _2, "balsfjord": _2, "bahccavuotna": _2, "xn--bhccavuotna-k7a": _2, "báhccavuotna": _2, "bamble": _2, "bardu": _2, "beardu": _2, "beiarn": _2, "bajddar": _2, "xn--bjddar-pta": _2, "bájddar": _2, "baidar": _2, "xn--bidr-5nac": _2, "báidár": _2, "berg": _2, "bergen": _2, "berlevag": _2, "xn--berlevg-jxa": _2, "berlevåg": _2, "bearalvahki": _2, "xn--bearalvhki-y4a": _2, "bearalváhki": _2, "bindal": _2, "birkenes": _2, "bjarkoy": _2, "xn--bjarky-fya": _2, "bjarkøy": _2, "bjerkreim": _2, "bjugn": _2, "bodo": _2, "xn--bod-2na": _2, "bodø": _2, "badaddja": _2, "xn--bdddj-mrabd": _2, "bådåddjå": _2, "budejju": _2, "bokn": _2, "bremanger": _2, "bronnoy": _2, "xn--brnny-wuac": _2, "brønnøy": _2, "bygland": _2, "bykle": _2, "barum": _2, "xn--brum-voa": _2, "bærum": _2, "telemark": [0, { "bo": _2, "xn--b-5ga": _2, "bø": _2 }], "nordland": [0, { "bo": _2, "xn--b-5ga": _2, "bø": _2, "heroy": _2, "xn--hery-ira": _2, "herøy": _2 }], "bievat": _2, "xn--bievt-0qa": _2, "bievát": _2, "bomlo": _2, "xn--bmlo-gra": _2, "bømlo": _2, "batsfjord": _2, "xn--btsfjord-9za": _2, "båtsfjord": _2, "bahcavuotna": _2, "xn--bhcavuotna-s4a": _2, "báhcavuotna": _2, "dovre": _2, "drammen": _2, "drangedal": _2, "dyroy": _2, "xn--dyry-ira": _2, "dyrøy": _2, "donna": _2, "xn--dnna-gra": _2, "dønna": _2, "eid": _2, "eidfjord": _2, "eidsberg": _2, "eidskog": _2, "eidsvoll": _2, "eigersund": _2, "elverum": _2, "enebakk": _2, "engerdal": _2, "etne": _2, "etnedal": _2, "evenes": _2, "evenassi": _2, "xn--eveni-0qa01ga": _2, "evenášši": _2, "evje-og-hornnes": _2, "farsund": _2, "fauske": _2, "fuossko": _2, "fuoisku": _2, "fedje": _2, "fet": _2, "finnoy": _2, "xn--finny-yua": _2, "finnøy": _2, "fitjar": _2, "fjaler": _2, "fjell": _2, "flakstad": _2, "flatanger": _2, "flekkefjord": _2, "flesberg": _2, "flora": _2, "fla": _2, "xn--fl-zia": _2, "flå": _2, "folldal": _2, "forsand": _2, "fosnes": _2, "frei": _2, "frogn": _2, "froland": _2, "frosta": _2, "frana": _2, "xn--frna-woa": _2, "fræna": _2, "froya": _2, "xn--frya-hra": _2, "frøya": _2, "fusa": _2, "fyresdal": _2, "forde": _2, "xn--frde-gra": _2, "førde": _2, "gamvik": _2, "gangaviika": _2, "xn--ggaviika-8ya47h": _2, "gáŋgaviika": _2, "gaular": _2, "gausdal": _2, "gildeskal": _2, "xn--gildeskl-g0a": _2, "gildeskål": _2, "giske": _2, "gjemnes": _2, "gjerdrum": _2, "gjerstad": _2, "gjesdal": _2, "gjovik": _2, "xn--gjvik-wua": _2, "gjøvik": _2, "gloppen": _2, "gol": _2, "gran": _2, "grane": _2, "granvin": _2, "gratangen": _2, "grimstad": _2, "grong": _2, "kraanghke": _2, "xn--kranghke-b0a": _2, "kråanghke": _2, "grue": _2, "gulen": _2, "hadsel": _2, "halden": _2, "halsa": _2, "hamar": _2, "hamaroy": _2, "habmer": _2, "xn--hbmer-xqa": _2, "hábmer": _2, "hapmir": _2, "xn--hpmir-xqa": _2, "hápmir": _2, "hammerfest": _2, "hammarfeasta": _2, "xn--hmmrfeasta-s4ac": _2, "hámmárfeasta": _2, "haram": _2, "hareid": _2, "harstad": _2, "hasvik": _2, "aknoluokta": _2, "xn--koluokta-7ya57h": _2, "ákŋoluokta": _2, "hattfjelldal": _2, "aarborte": _2, "haugesund": _2, "hemne": _2, "hemnes": _2, "hemsedal": _2, "more-og-romsdal": [0, { "heroy": _2, "sande": _2 }], "xn--mre-og-romsdal-qqb": [0, { "xn--hery-ira": _2, "sande": _2 }], "møre-og-romsdal": [0, { "herøy": _2, "sande": _2 }], "hitra": _2, "hjartdal": _2, "hjelmeland": _2, "hobol": _2, "xn--hobl-ira": _2, "hobøl": _2, "hof": _2, "hol": _2, "hole": _2, "holmestrand": _2, "holtalen": _2, "xn--holtlen-hxa": _2, "holtålen": _2, "hornindal": _2, "horten": _2, "hurdal": _2, "hurum": _2, "hvaler": _2, "hyllestad": _2, "hagebostad": _2, "xn--hgebostad-g3a": _2, "hægebostad": _2, "hoyanger": _2, "xn--hyanger-q1a": _2, "høyanger": _2, "hoylandet": _2, "xn--hylandet-54a": _2, "høylandet": _2, "ha": _2, "xn--h-2fa": _2, "hå": _2, "ibestad": _2, "inderoy": _2, "xn--indery-fya": _2, "inderøy": _2, "iveland": _2, "jevnaker": _2, "jondal": _2, "jolster": _2, "xn--jlster-bya": _2, "jølster": _2, "karasjok": _2, "karasjohka": _2, "xn--krjohka-hwab49j": _2, "kárášjohka": _2, "karlsoy": _2, "galsa": _2, "xn--gls-elac": _2, "gálsá": _2, "karmoy": _2, "xn--karmy-yua": _2, "karmøy": _2, "kautokeino": _2, "guovdageaidnu": _2, "klepp": _2, "klabu": _2, "xn--klbu-woa": _2, "klæbu": _2, "kongsberg": _2, "kongsvinger": _2, "kragero": _2, "xn--krager-gya": _2, "kragerø": _2, "kristiansand": _2, "kristiansund": _2, "krodsherad": _2, "xn--krdsherad-m8a": _2, "krødsherad": _2, "kvalsund": _2, "rahkkeravju": _2, "xn--rhkkervju-01af": _2, "ráhkkerávju": _2, "kvam": _2, "kvinesdal": _2, "kvinnherad": _2, "kviteseid": _2, "kvitsoy": _2, "xn--kvitsy-fya": _2, "kvitsøy": _2, "kvafjord": _2, "xn--kvfjord-nxa": _2, "kvæfjord": _2, "giehtavuoatna": _2, "kvanangen": _2, "xn--kvnangen-k0a": _2, "kvænangen": _2, "navuotna": _2, "xn--nvuotna-hwa": _2, "návuotna": _2, "kafjord": _2, "xn--kfjord-iua": _2, "kåfjord": _2, "gaivuotna": _2, "xn--givuotna-8ya": _2, "gáivuotna": _2, "larvik": _2, "lavangen": _2, "lavagis": _2, "loabat": _2, "xn--loabt-0qa": _2, "loabát": _2, "lebesby": _2, "davvesiida": _2, "leikanger": _2, "leirfjord": _2, "leka": _2, "leksvik": _2, "lenvik": _2, "leangaviika": _2, "xn--leagaviika-52b": _2, "leaŋgaviika": _2, "lesja": _2, "levanger": _2, "lier": _2, "lierne": _2, "lillehammer": _2, "lillesand": _2, "lindesnes": _2, "lindas": _2, "xn--linds-pra": _2, "lindås": _2, "lom": _2, "loppa": _2, "lahppi": _2, "xn--lhppi-xqa": _2, "láhppi": _2, "lund": _2, "lunner": _2, "luroy": _2, "xn--lury-ira": _2, "lurøy": _2, "luster": _2, "lyngdal": _2, "lyngen": _2, "ivgu": _2, "lardal": _2, "lerdal": _2, "xn--lrdal-sra": _2, "lærdal": _2, "lodingen": _2, "xn--ldingen-q1a": _2, "lødingen": _2, "lorenskog": _2, "xn--lrenskog-54a": _2, "lørenskog": _2, "loten": _2, "xn--lten-gra": _2, "løten": _2, "malvik": _2, "masoy": _2, "xn--msy-ula0h": _2, "måsøy": _2, "muosat": _2, "xn--muost-0qa": _2, "muosát": _2, "mandal": _2, "marker": _2, "marnardal": _2, "masfjorden": _2, "meland": _2, "meldal": _2, "melhus": _2, "meloy": _2, "xn--mely-ira": _2, "meløy": _2, "meraker": _2, "xn--merker-kua": _2, "meråker": _2, "moareke": _2, "xn--moreke-jua": _2, "moåreke": _2, "midsund": _2, "midtre-gauldal": _2, "modalen": _2, "modum": _2, "molde": _2, "moskenes": _2, "moss": _2, "mosvik": _2, "malselv": _2, "xn--mlselv-iua": _2, "målselv": _2, "malatvuopmi": _2, "xn--mlatvuopmi-s4a": _2, "málatvuopmi": _2, "namdalseid": _2, "aejrie": _2, "namsos": _2, "namsskogan": _2, "naamesjevuemie": _2, "xn--nmesjevuemie-tcba": _2, "nååmesjevuemie": _2, "laakesvuemie": _2, "nannestad": _2, "narvik": _2, "narviika": _2, "naustdal": _2, "nedre-eiker": _2, "akershus": _41, "buskerud": _41, "nesna": _2, "nesodden": _2, "nesseby": _2, "unjarga": _2, "xn--unjrga-rta": _2, "unjárga": _2, "nesset": _2, "nissedal": _2, "nittedal": _2, "nord-aurdal": _2, "nord-fron": _2, "nord-odal": _2, "norddal": _2, "nordkapp": _2, "davvenjarga": _2, "xn--davvenjrga-y4a": _2, "davvenjárga": _2, "nordre-land": _2, "nordreisa": _2, "raisa": _2, "xn--risa-5na": _2, "ráisa": _2, "nore-og-uvdal": _2, "notodden": _2, "naroy": _2, "xn--nry-yla5g": _2, "nærøy": _2, "notteroy": _2, "xn--nttery-byae": _2, "nøtterøy": _2, "odda": _2, "oksnes": _2, "xn--ksnes-uua": _2, "øksnes": _2, "oppdal": _2, "oppegard": _2, "xn--oppegrd-ixa": _2, "oppegård": _2, "orkdal": _2, "orland": _2, "xn--rland-uua": _2, "ørland": _2, "orskog": _2, "xn--rskog-uua": _2, "ørskog": _2, "orsta": _2, "xn--rsta-fra": _2, "ørsta": _2, "hedmark": [0, { "os": _2, "valer": _2, "xn--vler-qoa": _2, "våler": _2 }], "hordaland": [0, { "os": _2 }], "osen": _2, "osteroy": _2, "xn--ostery-fya": _2, "osterøy": _2, "ostre-toten": _2, "xn--stre-toten-zcb": _2, "østre-toten": _2, "overhalla": _2, "ovre-eiker": _2, "xn--vre-eiker-k8a": _2, "øvre-eiker": _2, "oyer": _2, "xn--yer-zna": _2, "øyer": _2, "oygarden": _2, "xn--ygarden-p1a": _2, "øygarden": _2, "oystre-slidre": _2, "xn--ystre-slidre-ujb": _2, "øystre-slidre": _2, "porsanger": _2, "porsangu": _2, "xn--porsgu-sta26f": _2, "porsáŋgu": _2, "porsgrunn": _2, "radoy": _2, "xn--rady-ira": _2, "radøy": _2, "rakkestad": _2, "rana": _2, "ruovat": _2, "randaberg": _2, "rauma": _2, "rendalen": _2, "rennebu": _2, "rennesoy": _2, "xn--rennesy-v1a": _2, "rennesøy": _2, "rindal": _2, "ringebu": _2, "ringerike": _2, "ringsaker": _2, "rissa": _2, "risor": _2, "xn--risr-ira": _2, "risør": _2, "roan": _2, "rollag": _2, "rygge": _2, "ralingen": _2, "xn--rlingen-mxa": _2, "rælingen": _2, "rodoy": _2, "xn--rdy-0nab": _2, "rødøy": _2, "romskog": _2, "xn--rmskog-bya": _2, "rømskog": _2, "roros": _2, "xn--rros-gra": _2, "røros": _2, "rost": _2, "xn--rst-0na": _2, "røst": _2, "royken": _2, "xn--ryken-vua": _2, "røyken": _2, "royrvik": _2, "xn--ryrvik-bya": _2, "røyrvik": _2, "rade": _2, "xn--rde-ula": _2, "råde": _2, "salangen": _2, "siellak": _2, "saltdal": _2, "salat": _2, "xn--slt-elab": _2, "sálát": _2, "xn--slat-5na": _2, "sálat": _2, "samnanger": _2, "vestfold": [0, { "sande": _2 }], "sandefjord": _2, "sandnes": _2, "sandoy": _2, "xn--sandy-yua": _2, "sandøy": _2, "sarpsborg": _2, "sauda": _2, "sauherad": _2, "sel": _2, "selbu": _2, "selje": _2, "seljord": _2, "sigdal": _2, "siljan": _2, "sirdal": _2, "skaun": _2, "skedsmo": _2, "ski": _2, "skien": _2, "skiptvet": _2, "skjervoy": _2, "xn--skjervy-v1a": _2, "skjervøy": _2, "skierva": _2, "xn--skierv-uta": _2, "skiervá": _2, "skjak": _2, "xn--skjk-soa": _2, "skjåk": _2, "skodje": _2, "skanland": _2, "xn--sknland-fxa": _2, "skånland": _2, "skanit": _2, "xn--sknit-yqa": _2, "skánit": _2, "smola": _2, "xn--smla-hra": _2, "smøla": _2, "snillfjord": _2, "snasa": _2, "xn--snsa-roa": _2, "snåsa": _2, "snoasa": _2, "snaase": _2, "xn--snase-nra": _2, "snåase": _2, "sogndal": _2, "sokndal": _2, "sola": _2, "solund": _2, "songdalen": _2, "sortland": _2, "spydeberg": _2, "stange": _2, "stavanger": _2, "steigen": _2, "steinkjer": _2, "stjordal": _2, "xn--stjrdal-s1a": _2, "stjørdal": _2, "stokke": _2, "stor-elvdal": _2, "stord": _2, "stordal": _2, "storfjord": _2, "omasvuotna": _2, "strand": _2, "stranda": _2, "stryn": _2, "sula": _2, "suldal": _2, "sund": _2, "sunndal": _2, "surnadal": _2, "sveio": _2, "svelvik": _2, "sykkylven": _2, "sogne": _2, "xn--sgne-gra": _2, "søgne": _2, "somna": _2, "xn--smna-gra": _2, "sømna": _2, "sondre-land": _2, "xn--sndre-land-0cb": _2, "søndre-land": _2, "sor-aurdal": _2, "xn--sr-aurdal-l8a": _2, "sør-aurdal": _2, "sor-fron": _2, "xn--sr-fron-q1a": _2, "sør-fron": _2, "sor-odal": _2, "xn--sr-odal-q1a": _2, "sør-odal": _2, "sor-varanger": _2, "xn--sr-varanger-ggb": _2, "sør-varanger": _2, "matta-varjjat": _2, "xn--mtta-vrjjat-k7af": _2, "mátta-várjjat": _2, "sorfold": _2, "xn--srfold-bya": _2, "sørfold": _2, "sorreisa": _2, "xn--srreisa-q1a": _2, "sørreisa": _2, "sorum": _2, "xn--srum-gra": _2, "sørum": _2, "tana": _2, "deatnu": _2, "time": _2, "tingvoll": _2, "tinn": _2, "tjeldsund": _2, "dielddanuorri": _2, "tjome": _2, "xn--tjme-hra": _2, "tjøme": _2, "tokke": _2, "tolga": _2, "torsken": _2, "tranoy": _2, "xn--trany-yua": _2, "tranøy": _2, "tromso": _2, "xn--troms-zua": _2, "tromsø": _2, "tromsa": _2, "romsa": _2, "trondheim": _2, "troandin": _2, "trysil": _2, "trana": _2, "xn--trna-woa": _2, "træna": _2, "trogstad": _2, "xn--trgstad-r1a": _2, "trøgstad": _2, "tvedestrand": _2, "tydal": _2, "tynset": _2, "tysfjord": _2, "divtasvuodna": _2, "divttasvuotna": _2, "tysnes": _2, "tysvar": _2, "xn--tysvr-vra": _2, "tysvær": _2, "tonsberg": _2, "xn--tnsberg-q1a": _2, "tønsberg": _2, "ullensaker": _2, "ullensvang": _2, "ulvik": _2, "utsira": _2, "vadso": _2, "xn--vads-jra": _2, "vadsø": _2, "cahcesuolo": _2, "xn--hcesuolo-7ya35b": _2, "čáhcesuolo": _2, "vaksdal": _2, "valle": _2, "vang": _2, "vanylven": _2, "vardo": _2, "xn--vard-jra": _2, "vardø": _2, "varggat": _2, "xn--vrggt-xqad": _2, "várggát": _2, "vefsn": _2, "vaapste": _2, "vega": _2, "vegarshei": _2, "xn--vegrshei-c0a": _2, "vegårshei": _2, "vennesla": _2, "verdal": _2, "verran": _2, "vestby": _2, "vestnes": _2, "vestre-slidre": _2, "vestre-toten": _2, "vestvagoy": _2, "xn--vestvgy-ixa6o": _2, "vestvågøy": _2, "vevelstad": _2, "vik": _2, "vikna": _2, "vindafjord": _2, "volda": _2, "voss": _2, "varoy": _2, "xn--vry-yla5g": _2, "værøy": _2, "vagan": _2, "xn--vgan-qoa": _2, "vågan": _2, "voagat": _2, "vagsoy": _2, "xn--vgsy-qoa0j": _2, "vågsøy": _2, "vaga": _2, "xn--vg-yiab": _2, "vågå": _2, "ostfold": [0, { "valer": _2 }], "xn--stfold-9xa": [0, { "xn--vler-qoa": _2 }], "østfold": [0, { "våler": _2 }], "co": _3, "blogspot": _3, "123hjemmeside": _3, "myspreadshop": _3 }], "np": _8, "nr": _35, "nu": [1, { "merseine": _3, "mine": _3, "shacknet": _3, "enterprisecloud": _3 }], "nz": [1, { "ac": _2, "co": _6, "cri": _2, "geek": _2, "gen": _2, "govt": _2, "health": _2, "iwi": _2, "kiwi": _2, "maori": _2, "mil": _2, "xn--mori-qsa": _2, "māori": _2, "net": _2, "org": _2, "parliament": _2, "school": _2 }], "om": [1, { "co": _2, "com": _2, "edu": _2, "gov": _2, "med": _2, "museum": _2, "net": _2, "org": _2, "pro": _2 }], "onion": _2, "org": [1, { "altervista": _3, "amune": [0, { "tele": _3 }], "pimienta": _3, "poivron": _3, "potager": _3, "sweetpepper": _3, "ae": _3, "us": _3, "certmgr": _3, "cdn77": [0, { "c": _3, "rsc": _3 }], "cdn77-secure": [0, { "origin": [0, { "ssl": _3 }] }], "cloudns": _3, "duckdns": _3, "tunk": _3, "dyndns": [2, { "go": _3, "home": _3 }], "blogdns": _3, "blogsite": _3, "boldlygoingnowhere": _3, "dnsalias": _3, "dnsdojo": _3, "doesntexist": _3, "dontexist": _3, "doomdns": _3, "dvrdns": _3, "dynalias": _3, "endofinternet": _3, "endoftheinternet": _3, "from-me": _3, "game-host": _3, "gotdns": _3, "hobby-site": _3, "homedns": _3, "homeftp": _3, "homelinux": _3, "homeunix": _3, "is-a-bruinsfan": _3, "is-a-candidate": _3, "is-a-celticsfan": _3, "is-a-chef": _3, "is-a-geek": _3, "is-a-knight": _3, "is-a-linux-user": _3, "is-a-patsfan": _3, "is-a-soxfan": _3, "is-found": _3, "is-lost": _3, "is-saved": _3, "is-very-bad": _3, "is-very-evil": _3, "is-very-good": _3, "is-very-nice": _3, "is-very-sweet": _3, "isa-geek": _3, "kicks-ass": _3, "misconfused": _3, "podzone": _3, "readmyblog": _3, "selfip": _3, "sellsyourhome": _3, "servebbs": _3, "serveftp": _3, "servegame": _3, "stuff-4-sale": _3, "webhop": _3, "ddnss": _3, "accesscam": _3, "camdvr": _3, "freeddns": _3, "mywire": _3, "webredirect": _3, "eu": [2, { "al": _3, "asso": _3, "at": _3, "au": _3, "be": _3, "bg": _3, "ca": _3, "cd": _3, "ch": _3, "cn": _3, "cy": _3, "cz": _3, "de": _3, "dk": _3, "edu": _3, "ee": _3, "es": _3, "fi": _3, "fr": _3, "gr": _3, "hr": _3, "hu": _3, "ie": _3, "il": _3, "in": _3, "int": _3, "is": _3, "it": _3, "jp": _3, "kr": _3, "lt": _3, "lu": _3, "lv": _3, "mc": _3, "me": _3, "mk": _3, "mt": _3, "my": _3, "net": _3, "ng": _3, "nl": _3, "no": _3, "nz": _3, "paris": _3, "pl": _3, "pt": _3, "q-a": _3, "ro": _3, "ru": _3, "se": _3, "si": _3, "sk": _3, "tr": _3, "uk": _3, "us": _3 }], "twmail": _3, "fedorainfracloud": _3, "fedorapeople": _3, "fedoraproject": [0, { "cloud": _3, "os": _23, "stg": [0, { "os": _23 }] }], "freedesktop": _3, "hepforge": _3, "in-dsl": _3, "in-vpn": _3, "js": _3, "barsy": _3, "mayfirst": _3, "mozilla-iot": _3, "bmoattachments": _3, "dynserv": _3, "now-dns": _3, "cable-modem": _3, "collegefan": _3, "couchpotatofries": _3, "mlbfan": _3, "mysecuritycamera": _3, "nflfan": _3, "read-books": _3, "ufcfan": _3, "hopto": _3, "myftp": _3, "no-ip": _3, "zapto": _3, "httpbin": _3, "pubtls": _3, "jpn": _3, "my-firewall": _3, "myfirewall": _3, "spdns": _3, "small-web": _3, "dsmynas": _3, "familyds": _3, "teckids": _12, "tuxfamily": _3, "diskstation": _3, "hk": _3, "wmflabs": _3, "toolforge": _3, "wmcloud": _3, "za": _3 }], "pa": [1, { "ac": _2, "gob": _2, "com": _2, "org": _2, "sld": _2, "edu": _2, "net": _2, "ing": _2, "abo": _2, "med": _2, "nom": _2 }], "pe": [1, { "edu": _2, "gob": _2, "nom": _2, "mil": _2, "org": _2, "com": _2, "net": _2, "blogspot": _3 }], "pf": [1, { "com": _2, "org": _2, "edu": _2 }], "pg": _8, "ph": [1, { "com": _2, "net": _2, "org": _2, "gov": _2, "edu": _2, "ngo": _2, "mil": _2, "i": _2 }], "pk": [1, { "com": _2, "net": _2, "edu": _2, "org": _2, "fam": _2, "biz": _2, "web": _2, "gov": _2, "gob": _2, "gok": _2, "gon": _2, "gop": _2, "gos": _2, "info": _2 }], "pl": [1, { "com": _2, "net": _2, "org": _2, "aid": _2, "agro": _2, "atm": _2, "auto": _2, "biz": _2, "edu": _2, "gmina": _2, "gsm": _2, "info": _2, "mail": _2, "miasta": _2, "media": _2, "mil": _2, "nieruchomosci": _2, "nom": _2, "pc": _2, "powiat": _2, "priv": _2, "realestate": _2, "rel": _2, "sex": _2, "shop": _2, "sklep": _2, "sos": _2, "szkola": _2, "targi": _2, "tm": _2, "tourism": _2, "travel": _2, "turystyka": _2, "gov": [1, { "ap": _2, "griw": _2, "ic": _2, "is": _2, "kmpsp": _2, "konsulat": _2, "kppsp": _2, "kwp": _2, "kwpsp": _2, "mup": _2, "mw": _2, "oia": _2, "oirm": _2, "oke": _2, "oow": _2, "oschr": _2, "oum": _2, "pa": _2, "pinb": _2, "piw": _2, "po": _2, "pr": _2, "psp": _2, "psse": _2, "pup": _2, "rzgw": _2, "sa": _2, "sdn": _2, "sko": _2, "so": _2, "sr": _2, "starostwo": _2, "ug": _2, "ugim": _2, "um": _2, "umig": _2, "upow": _2, "uppo": _2, "us": _2, "uw": _2, "uzs": _2, "wif": _2, "wiih": _2, "winb": _2, "wios": _2, "witd": _2, "wiw": _2, "wkz": _2, "wsa": _2, "wskr": _2, "wsse": _2, "wuoz": _2, "wzmiuw": _2, "zp": _2, "zpisdn": _2 }], "augustow": _2, "babia-gora": _2, "bedzin": _2, "beskidy": _2, "bialowieza": _2, "bialystok": _2, "bielawa": _2, "bieszczady": _2, "boleslawiec": _2, "bydgoszcz": _2, "bytom": _2, "cieszyn": _2, "czeladz": _2, "czest": _2, "dlugoleka": _2, "elblag": _2, "elk": _2, "glogow": _2, "gniezno": _2, "gorlice": _2, "grajewo": _2, "ilawa": _2, "jaworzno": _2, "jelenia-gora": _2, "jgora": _2, "kalisz": _2, "kazimierz-dolny": _2, "karpacz": _2, "kartuzy": _2, "kaszuby": _2, "katowice": _2, "kepno": _2, "ketrzyn": _2, "klodzko": _2, "kobierzyce": _2, "kolobrzeg": _2, "konin": _2, "konskowola": _2, "kutno": _2, "lapy": _2, "lebork": _2, "legnica": _2, "lezajsk": _2, "limanowa": _2, "lomza": _2, "lowicz": _2, "lubin": _2, "lukow": _2, "malbork": _2, "malopolska": _2, "mazowsze": _2, "mazury": _2, "mielec": _2, "mielno": _2, "mragowo": _2, "naklo": _2, "nowaruda": _2, "nysa": _2, "olawa": _2, "olecko": _2, "olkusz": _2, "olsztyn": _2, "opoczno": _2, "opole": _2, "ostroda": _2, "ostroleka": _2, "ostrowiec": _2, "ostrowwlkp": _2, "pila": _2, "pisz": _2, "podhale": _2, "podlasie": _2, "polkowice": _2, "pomorze": _2, "pomorskie": _2, "prochowice": _2, "pruszkow": _2, "przeworsk": _2, "pulawy": _2, "radom": _2, "rawa-maz": _2, "rybnik": _2, "rzeszow": _2, "sanok": _2, "sejny": _2, "slask": _2, "slupsk": _2, "sosnowiec": _2, "stalowa-wola": _2, "skoczow": _2, "starachowice": _2, "stargard": _2, "suwalki": _2, "swidnica": _2, "swiebodzin": _2, "swinoujscie": _2, "szczecin": _2, "szczytno": _2, "tarnobrzeg": _2, "tgory": _2, "turek": _2, "tychy": _2, "ustka": _2, "walbrzych": _2, "warmia": _2, "warszawa": _2, "waw": _2, "wegrow": _2, "wielun": _2, "wlocl": _2, "wloclawek": _2, "wodzislaw": _2, "wolomin": _2, "wroclaw": _2, "zachpomor": _2, "zagan": _2, "zarow": _2, "zgora": _2, "zgorzelec": _2, "beep": _3, "ecommerce-shop": _3, "shoparena": _3, "homesklep": _3, "sdscloud": _3, "unicloud": _3, "krasnik": _3, "leczna": _3, "lubartow": _3, "lublin": _3, "poniatowa": _3, "swidnik": _3, "co": _3, "simplesite": _3, "art": _3, "gliwice": _3, "krakow": _3, "poznan": _3, "wroc": _3, "zakopane": _3, "myspreadshop": _3, "gda": _3, "gdansk": _3, "gdynia": _3, "med": _3, "sopot": _3 }], "pm": [1, { "own": _3, "name": _3 }], "pn": [1, { "gov": _2, "co": _2, "org": _2, "edu": _2, "net": _2 }], "post": _2, "pr": [1, { "com": _2, "net": _2, "org": _2, "gov": _2, "edu": _2, "isla": _2, "pro": _2, "biz": _2, "info": _2, "name": _2, "est": _2, "prof": _2, "ac": _2 }], "pro": [1, { "aaa": _2, "aca": _2, "acct": _2, "avocat": _2, "bar": _2, "cpa": _2, "eng": _2, "jur": _2, "law": _2, "med": _2, "recht": _2, "cloudns": _3, "dnstrace": [0, { "bci": _3 }], "barsy": _3 }], "ps": [1, { "edu": _2, "gov": _2, "sec": _2, "plo": _2, "com": _2, "org": _2, "net": _2 }], "pt": [1, { "net": _2, "gov": _2, "org": _2, "edu": _2, "int": _2, "publ": _2, "com": _2, "nome": _2, "blogspot": _3, "123paginaweb": _3 }], "pw": [1, { "co": _2, "ne": _2, "or": _2, "ed": _2, "go": _2, "belau": _2, "cloudns": _3, "x443": _3 }], "py": [1, { "com": _2, "coop": _2, "edu": _2, "gov": _2, "mil": _2, "net": _2, "org": _2 }], "qa": [1, { "com": _2, "edu": _2, "gov": _2, "mil": _2, "name": _2, "net": _2, "org": _2, "sch": _2, "blogspot": _3 }], "re": [1, { "asso": _2, "com": _2, "nom": _2, "blogspot": _3 }], "ro": [1, { "arts": _2, "com": _2, "firm": _2, "info": _2, "nom": _2, "nt": _2, "org": _2, "rec": _2, "store": _2, "tm": _2, "www": _2, "co": _3, "shop": _3, "blogspot": _3, "barsy": _3 }], "rs": [1, { "ac": _2, "co": _2, "edu": _2, "gov": _2, "in": _2, "org": _2, "brendly": [0, { "shop": _3 }], "blogspot": _3, "ua": _3, "ox": _3 }], "ru": [1, { "ac": _3, "edu": _3, "gov": _3, "int": _3, "mil": _3, "test": _3, "eurodir": _3, "adygeya": _3, "bashkiria": _3, "bir": _3, "cbg": _3, "com": _3, "dagestan": _3, "grozny": _3, "kalmykia": _3, "kustanai": _3, "marine": _3, "mordovia": _3, "msk": _3, "mytis": _3, "nalchik": _3, "nov": _3, "pyatigorsk": _3, "spb": _3, "vladikavkaz": _3, "vladimir": _3, "blogspot": _3, "na4u": _3, "mircloud": _3, "regruhosting": _29, "myjino": [2, { "hosting": _5, "landing": _5, "spectrum": _5, "vps": _5 }], "cldmail": [0, { "hb": _3 }], "mcdir": [2, { "vps": _3 }], "mcpre": _3, "net": _3, "org": _3, "pp": _3, "123sait": _3, "lk3": _3, "ras": _3 }], "rw": [1, { "ac": _2, "co": _2, "coop": _2, "gov": _2, "mil": _2, "net": _2, "org": _2 }], "sa": [1, { "com": _2, "net": _2, "org": _2, "gov": _2, "med": _2, "pub": _2, "edu": _2, "sch": _2 }], "sb": _4, "sc": _4, "sd": [1, { "com": _2, "net": _2, "org": _2, "edu": _2, "med": _2, "tv": _2, "gov": _2, "info": _2 }], "se": [1, { "a": _2, "ac": _2, "b": _2, "bd": _2, "brand": _2, "c": _2, "d": _2, "e": _2, "f": _2, "fh": _2, "fhsk": _2, "fhv": _2, "g": _2, "h": _2, "i": _2, "k": _2, "komforb": _2, "kommunalforbund": _2, "komvux": _2, "l": _2, "lanbib": _2, "m": _2, "n": _2, "naturbruksgymn": _2, "o": _2, "org": _2, "p": _2, "parti": _2, "pp": _2, "press": _2, "r": _2, "s": _2, "t": _2, "tm": _2, "u": _2, "w": _2, "x": _2, "y": _2, "z": _2, "com": _3, "blogspot": _3, "conf": _3, "iopsys": _3, "123minsida": _3, "itcouldbewor": _3, "myspreadshop": _3, "paba": [0, { "su": _3 }] }], "sg": [1, { "com": _2, "net": _2, "org": _2, "gov": _2, "edu": _2, "per": _2, "blogspot": _3, "enscaled": _3 }], "sh": [1, { "com": _2, "net": _2, "gov": _2, "org": _2, "mil": _2, "bip": _3, "hashbang": _3, "platform": [0, { "bc": _3, "ent": _3, "eu": _3, "us": _3 }], "now": _3, "vxl": _3, "wedeploy": _3 }], "si": [1, { "gitapp": _3, "gitpage": _3, "blogspot": _3 }], "sj": _2, "sk": _6, "sl": _4, "sm": _2, "sn": [1, { "art": _2, "com": _2, "edu": _2, "gouv": _2, "org": _2, "perso": _2, "univ": _2, "blogspot": _3 }], "so": [1, { "com": _2, "edu": _2, "gov": _2, "me": _2, "net": _2, "org": _2, "sch": _3 }], "sr": _2, "ss": [1, { "biz": _2, "com": _2, "edu": _2, "gov": _2, "me": _2, "net": _2, "org": _2, "sch": _2 }], "st": [1, { "co": _2, "com": _2, "consulado": _2, "edu": _2, "embaixada": _2, "mil": _2, "net": _2, "org": _2, "principe": _2, "saotome": _2, "store": _2, "kirara": _3, "noho": _3 }], "su": [1, { "abkhazia": _3, "adygeya": _3, "aktyubinsk": _3, "arkhangelsk": _3, "armenia": _3, "ashgabad": _3, "azerbaijan": _3, "balashov": _3, "bashkiria": _3, "bryansk": _3, "bukhara": _3, "chimkent": _3, "dagestan": _3, "east-kazakhstan": _3, "exnet": _3, "georgia": _3, "grozny": _3, "ivanovo": _3, "jambyl": _3, "kalmykia": _3, "kaluga": _3, "karacol": _3, "karaganda": _3, "karelia": _3, "khakassia": _3, "krasnodar": _3, "kurgan": _3, "kustanai": _3, "lenug": _3, "mangyshlak": _3, "mordovia": _3, "msk": _3, "murmansk": _3, "nalchik": _3, "navoi": _3, "north-kazakhstan": _3, "nov": _3, "obninsk": _3, "penza": _3, "pokrovsk": _3, "sochi": _3, "spb": _3, "tashkent": _3, "termez": _3, "togliatti": _3, "troitsk": _3, "tselinograd": _3, "tula": _3, "tuva": _3, "vladikavkaz": _3, "vladimir": _3, "vologda": _3 }], "sv": [1, { "com": _2, "edu": _2, "gob": _2, "org": _2, "red": _2 }], "sx": _7, "sy": _34, "sz": [1, { "co": _2, "ac": _2, "org": _2 }], "tc": [1, { "ch": _3, "me": _3, "we": _3 }], "td": _6, "tel": _2, "tf": [1, { "sch": _3 }], "tg": _2, "th": [1, { "ac": _2, "co": _2, "go": _2, "in": _2, "mi": _2, "net": _2, "or": _2, "online": _3, "shop": _3 }], "tj": [1, { "ac": _2, "biz": _2, "co": _2, "com": _2, "edu": _2, "go": _2, "gov": _2, "int": _2, "mil": _2, "name": _2, "net": _2, "nic": _2, "org": _2, "test": _2, "web": _2 }], "tk": _2, "tl": _7, "tm": [1, { "com": _2, "co": _2, "org": _2, "net": _2, "nom": _2, "gov": _2, "mil": _2, "edu": _2 }], "tn": [1, { "com": _2, "ens": _2, "fin": _2, "gov": _2, "ind": _2, "info": _2, "intl": _2, "mincom": _2, "nat": _2, "net": _2, "org": _2, "perso": _2, "tourism": _2, "orangecloud": _3 }], "to": [1, { "611": _3, "com": _2, "gov": _2, "net": _2, "org": _2, "edu": _2, "mil": _2, "oya": _3, "rdv": _3, "x0": _3, "vpnplus": _3, "quickconnect": _13, "nyan": _3 }], "tr": [1, { "av": _2, "bbs": _2, "bel": _2, "biz": _2, "com": _6, "dr": _2, "edu": _2, "gen": _2, "gov": _2, "info": _2, "mil": _2, "k12": _2, "kep": _2, "name": _2, "net": _2, "org": _2, "pol": _2, "tel": _2, "tsk": _2, "tv": _2, "web": _2, "nc": _7 }], "tt": [1, { "co": _2, "com": _2, "org": _2, "net": _2, "biz": _2, "info": _2, "pro": _2, "int": _2, "coop": _2, "jobs": _2, "mobi": _2, "travel": _2, "museum": _2, "aero": _2, "name": _2, "gov": _2, "edu": _2 }], "tv": [1, { "dyndns": _3, "better-than": _3, "on-the-web": _3, "worse-than": _3, "from": _3, "sakura": _3 }], "tw": [1, { "edu": _2, "gov": _2, "mil": _2, "com": [1, { "mymailer": _3 }], "net": _2, "org": _2, "idv": _2, "game": _2, "ebiz": _2, "club": _2, "xn--zf0ao64a": _2, "網路": _2, "xn--uc0atv": _2, "組織": _2, "xn--czrw28b": _2, "商業": _2, "url": _3, "blogspot": _3 }], "tz": [1, { "ac": _2, "co": _2, "go": _2, "hotel": _2, "info": _2, "me": _2, "mil": _2, "mobi": _2, "ne": _2, "or": _2, "sc": _2, "tv": _2 }], "ua": [1, { "com": _2, "edu": _2, "gov": _2, "in": _2, "net": _2, "org": _2, "cherkassy": _2, "cherkasy": _2, "chernigov": _2, "chernihiv": _2, "chernivtsi": _2, "chernovtsy": _2, "ck": _2, "cn": _2, "cr": _2, "crimea": _2, "cv": _2, "dn": _2, "dnepropetrovsk": _2, "dnipropetrovsk": _2, "donetsk": _2, "dp": _2, "if": _2, "ivano-frankivsk": _2, "kh": _2, "kharkiv": _2, "kharkov": _2, "kherson": _2, "khmelnitskiy": _2, "khmelnytskyi": _2, "kiev": _2, "kirovograd": _2, "km": _2, "kr": _2, "kropyvnytskyi": _2, "krym": _2, "ks": _2, "kv": _2, "kyiv": _2, "lg": _2, "lt": _2, "lugansk": _2, "luhansk": _2, "lutsk": _2, "lv": _2, "lviv": _2, "mk": _2, "mykolaiv": _2, "nikolaev": _2, "od": _2, "odesa": _2, "odessa": _2, "pl": _2, "poltava": _2, "rivne": _2, "rovno": _2, "rv": _2, "sb": _2, "sebastopol": _2, "sevastopol": _2, "sm": _2, "sumy": _2, "te": _2, "ternopil": _2, "uz": _2, "uzhgorod": _2, "uzhhorod": _2, "vinnica": _2, "vinnytsia": _2, "vn": _2, "volyn": _2, "yalta": _2, "zakarpattia": _2, "zaporizhzhe": _2, "zaporizhzhia": _2, "zhitomir": _2, "zhytomyr": _2, "zp": _2, "zt": _2, "cc": _3, "inf": _3, "ltd": _3, "cx": _3, "ie": _3, "biz": _3, "co": _3, "pp": _3, "v": _3 }], "ug": [1, { "co": _2, "or": _2, "ac": _2, "sc": _2, "go": _2, "ne": _2, "com": _2, "org": _2, "blogspot": _3 }], "uk": [1, { "ac": _2, "co": [1, { "bytemark": [0, { "dh": _3, "vm": _3 }], "blogspot": _3, "layershift": _28, "barsy": _3, "barsyonline": _3, "retrosnub": _33, "nh-serv": _3, "no-ip": _3, "wellbeingzone": _3, "adimo": _3, "myspreadshop": _3 }], "gov": [1, { "campaign": _3, "service": _3, "api": _3, "homeoffice": _3 }], "ltd": _2, "me": _2, "net": _2, "nhs": _2, "org": [1, { "glug": _3, "lug": _3, "lugs": _3, "affinitylottery": _3, "raffleentry": _3, "weeklylottery": _3 }], "plc": _2, "police": _2, "sch": _8, "conn": _3, "copro": _3, "hosp": _3, "independent-commission": _3, "independent-inquest": _3, "independent-inquiry": _3, "independent-panel": _3, "independent-review": _3, "public-inquiry": _3, "royal-commission": _3, "pymnt": _3, "barsy": _3 }], "us": [1, { "dni": _2, "fed": _2, "isa": _2, "kids": _2, "nsn": _2, "ak": _42, "al": _42, "ar": _42, "as": _42, "az": _42, "ca": _42, "co": _42, "ct": _42, "dc": _42, "de": [1, { "cc": _2, "lib": _3 }], "fl": _42, "ga": _42, "gu": _42, "hi": _43, "ia": _42, "id": _42, "il": _42, "in": _42, "ks": _42, "ky": _42, "la": _42, "ma": [1, { "k12": [1, { "pvt": _2, "chtr": _2, "paroch": _2 }], "cc": _2, "lib": _2 }], "md": _42, "me": _42, "mi": [1, { "k12": _2, "cc": _2, "lib": _2, "ann-arbor": _2, "cog": _2, "dst": _2, "eaton": _2, "gen": _2, "mus": _2, "tec": _2, "washtenaw": _2 }], "mn": _42, "mo": _42, "ms": _42, "mt": _42, "nc": _42, "nd": _43, "ne": _42, "nh": _42, "nj": _42, "nm": _42, "nv": _42, "ny": _42, "oh": _42, "ok": _42, "or": _42, "pa": _42, "pr": _42, "ri": _43, "sc": _42, "sd": _43, "tn": _42, "tx": _42, "ut": _42, "vi": _42, "vt": _42, "va": _42, "wa": _42, "wi": _42, "wv": [1, { "cc": _2 }], "wy": _42, "graphox": _3, "cloudns": _3, "drud": _3, "is-by": _3, "land-4-sale": _3, "stuff-4-sale": _3, "enscaled": [0, { "phx": _3 }], "mircloud": _3, "freeddns": _3, "golffan": _3, "noip": _3, "pointto": _3, "platterp": _3 }], "uy": [1, { "com": _6, "edu": _2, "gub": _2, "mil": _2, "net": _2, "org": _2 }], "uz": [1, { "co": _2, "com": _2, "net": _2, "org": _2 }], "va": _2, "vc": [1, { "com": _2, "net": _2, "org": _2, "gov": _2, "mil": _2, "edu": _2, "gv": [2, { "d": _3 }], "0e": _3 }], "ve": [1, { "arts": _2, "bib": _2, "co": _2, "com": _2, "e12": _2, "edu": _2, "firm": _2, "gob": _2, "gov": _2, "info": _2, "int": _2, "mil": _2, "net": _2, "nom": _2, "org": _2, "rar": _2, "rec": _2, "store": _2, "tec": _2, "web": _2 }], "vg": [1, { "at": _3 }], "vi": [1, { "co": _2, "com": _2, "k12": _2, "net": _2, "org": _2 }], "vn": [1, { "ac": _2, "ai": _2, "biz": _2, "com": _2, "edu": _2, "gov": _2, "health": _2, "id": _2, "info": _2, "int": _2, "io": _2, "name": _2, "net": _2, "org": _2, "pro": _2, "angiang": _2, "bacgiang": _2, "backan": _2, "baclieu": _2, "bacninh": _2, "baria-vungtau": _2, "bentre": _2, "binhdinh": _2, "binhduong": _2, "binhphuoc": _2, "binhthuan": _2, "camau": _2, "cantho": _2, "caobang": _2, "daklak": _2, "daknong": _2, "danang": _2, "dienbien": _2, "dongnai": _2, "dongthap": _2, "gialai": _2, "hagiang": _2, "haiduong": _2, "haiphong": _2, "hanam": _2, "hanoi": _2, "hatinh": _2, "haugiang": _2, "hoabinh": _2, "hungyen": _2, "khanhhoa": _2, "kiengiang": _2, "kontum": _2, "laichau": _2, "lamdong": _2, "langson": _2, "laocai": _2, "longan": _2, "namdinh": _2, "nghean": _2, "ninhbinh": _2, "ninhthuan": _2, "phutho": _2, "phuyen": _2, "quangbinh": _2, "quangnam": _2, "quangngai": _2, "quangninh": _2, "quangtri": _2, "soctrang": _2, "sonla": _2, "tayninh": _2, "thaibinh": _2, "thainguyen": _2, "thanhhoa": _2, "thanhphohochiminh": _2, "thuathienhue": _2, "tiengiang": _2, "travinh": _2, "tuyenquang": _2, "vinhlong": _2, "vinhphuc": _2, "yenbai": _2, "blogspot": _3 }], "vu": [1, { "com": _2, "edu": _2, "net": _2, "org": _2, "cn": _3, "blog": _3, "dev": _3, "me": _3 }], "wf": [1, { "biz": _3, "sch": _3 }], "ws": [1, { "com": _2, "net": _2, "org": _2, "gov": _2, "edu": _2, "advisor": _5, "cloud66": _3, "dyndns": _3, "mypets": _3 }], "yt": [1, { "org": _3 }], "xn--mgbaam7a8h": _2, "امارات": _2, "xn--y9a3aq": _2, "հայ": _2, "xn--54b7fta0cc": _2, "বাংলা": _2, "xn--90ae": _2, "бг": _2, "xn--mgbcpq6gpa1a": _2, "البحرين": _2, "xn--90ais": _2, "бел": _2, "xn--fiqs8s": _2, "中国": _2, "xn--fiqz9s": _2, "中國": _2, "xn--lgbbat1ad8j": _2, "الجزائر": _2, "xn--wgbh1c": _2, "مصر": _2, "xn--e1a4c": _2, "ею": _2, "xn--qxa6a": _2, "ευ": _2, "xn--mgbah1a3hjkrd": _2, "موريتانيا": _2, "xn--node": _2, "გე": _2, "xn--qxam": _2, "ελ": _2, "xn--j6w193g": [1, { "xn--55qx5d": _2, "xn--wcvs22d": _2, "xn--mxtq1m": _2, "xn--gmqw5a": _2, "xn--od0alg": _2, "xn--uc0atv": _2 }], "香港": [1, { "公司": _2, "教育": _2, "政府": _2, "個人": _2, "網絡": _2, "組織": _2 }], "xn--2scrj9c": _2, "ಭಾರತ": _2, "xn--3hcrj9c": _2, "ଭାରତ": _2, "xn--45br5cyl": _2, "ভাৰত": _2, "xn--h2breg3eve": _2, "भारतम्": _2, "xn--h2brj9c8c": _2, "भारोत": _2, "xn--mgbgu82a": _2, "ڀارت": _2, "xn--rvc1e0am3e": _2, "ഭാരതം": _2, "xn--h2brj9c": _2, "भारत": _2, "xn--mgbbh1a": _2, "بارت": _2, "xn--mgbbh1a71e": _2, "بھارت": _2, "xn--fpcrj9c3d": _2, "భారత్": _2, "xn--gecrj9c": _2, "ભારત": _2, "xn--s9brj9c": _2, "ਭਾਰਤ": _2, "xn--45brj9c": _2, "ভারত": _2, "xn--xkc2dl3a5ee0h": _2, "இந்தியா": _2, "xn--mgba3a4f16a": _2, "ایران": _2, "xn--mgba3a4fra": _2, "ايران": _2, "xn--mgbtx2b": _2, "عراق": _2, "xn--mgbayh7gpa": _2, "الاردن": _2, "xn--3e0b707e": _2, "한국": _2, "xn--80ao21a": _2, "қаз": _2, "xn--q7ce6a": _2, "ລາວ": _2, "xn--fzc2c9e2c": _2, "ලංකා": _2, "xn--xkc2al3hye2a": _2, "இலங்கை": _2, "xn--mgbc0a9azcg": _2, "المغرب": _2, "xn--d1alf": _2, "мкд": _2, "xn--l1acc": _2, "мон": _2, "xn--mix891f": _2, "澳門": _2, "xn--mix082f": _2, "澳门": _2, "xn--mgbx4cd0ab": _2, "مليسيا": _2, "xn--mgb9awbf": _2, "عمان": _2, "xn--mgbai9azgqp6j": _2, "پاکستان": _2, "xn--mgbai9a5eva00b": _2, "پاكستان": _2, "xn--ygbi2ammx": _2, "فلسطين": _2, "xn--90a3ac": [1, { "xn--o1ac": _2, "xn--c1avg": _2, "xn--90azh": _2, "xn--d1at": _2, "xn--o1ach": _2, "xn--80au": _2 }], "срб": [1, { "пр": _2, "орг": _2, "обр": _2, "од": _2, "упр": _2, "ак": _2 }], "xn--p1ai": _2, "рф": _2, "xn--wgbl6a": _2, "قطر": _2, "xn--mgberp4a5d4ar": _2, "السعودية": _2, "xn--mgberp4a5d4a87g": _2, "السعودیة": _2, "xn--mgbqly7c0a67fbc": _2, "السعودیۃ": _2, "xn--mgbqly7cvafr": _2, "السعوديه": _2, "xn--mgbpl2fh": _2, "سودان": _2, "xn--yfro4i67o": _2, "新加坡": _2, "xn--clchc0ea0b2g2a9gcd": _2, "சிங்கப்பூர்": _2, "xn--ogbpf8fl": _2, "سورية": _2, "xn--mgbtf8fl": _2, "سوريا": _2, "xn--o3cw4h": [1, { "xn--12c1fe0br": _2, "xn--12co0c3b4eva": _2, "xn--h3cuzk1di": _2, "xn--o3cyx2a": _2, "xn--m3ch0j3a": _2, "xn--12cfi8ixb8l": _2 }], "ไทย": [1, { "ศึกษา": _2, "ธุรกิจ": _2, "รัฐบาล": _2, "ทหาร": _2, "เน็ต": _2, "องค์กร": _2 }], "xn--pgbs0dh": _2, "تونس": _2, "xn--kpry57d": _2, "台灣": _2, "xn--kprw13d": _2, "台湾": _2, "xn--nnx388a": _2, "臺灣": _2, "xn--j1amh": _2, "укр": _2, "xn--mgb2ddes": _2, "اليمن": _2, "xxx": _2, "ye": _34, "za": [0, { "ac": _2, "agric": _2, "alt": _2, "co": _6, "edu": _2, "gov": _2, "grondar": _2, "law": _2, "mil": _2, "net": _2, "ngo": _2, "nic": _2, "nis": _2, "nom": _2, "org": _2, "school": _2, "tm": _2, "web": _2 }], "zm": [1, { "ac": _2, "biz": _2, "co": _2, "com": _2, "edu": _2, "gov": _2, "info": _2, "mil": _2, "net": _2, "org": _2, "sch": _2 }], "zw": [1, { "ac": _2, "co": _2, "gov": _2, "mil": _2, "org": _2 }], "aaa": _2, "aarp": _2, "abb": _2, "abbott": _2, "abbvie": _2, "abc": _2, "able": _2, "abogado": _2, "abudhabi": _2, "academy": [1, { "official": _3 }], "accenture": _2, "accountant": _2, "accountants": _2, "aco": _2, "actor": _2, "ads": _2, "adult": _2, "aeg": _2, "aetna": _2, "afl": _2, "africa": _2, "agakhan": _2, "agency": _2, "aig": _2, "airbus": _2, "airforce": _2, "airtel": _2, "akdn": _2, "alibaba": _2, "alipay": _2, "allfinanz": _2, "allstate": _2, "ally": _2, "alsace": _2, "alstom": _2, "amazon": _2, "americanexpress": _2, "americanfamily": _2, "amex": _2, "amfam": _2, "amica": _2, "amsterdam": _2, "analytics": _2, "android": _2, "anquan": _2, "anz": _2, "aol": _2, "apartments": _2, "app": [1, { "beget": _5, "clerk": _3, "clerkstage": _3, "wnext": _3, "platform0": _3, "deta": _3, "ondigitalocean": _3, "easypanel": _3, "encr": _3, "edgecompute": _3, "fireweb": _3, "onflashdrive": _3, "framer": _3, "run": [2, { "a": _3 }], "web": _3, "hasura": _3, "loginline": _3, "messerli": _3, "netlify": _3, "ngrok": _3, "ngrok-free": _3, "developer": _5, "noop": _3, "northflank": _5, "snowflake": [2, { "privatelink": _3 }], "streamlit": _3, "storipress": _3, "telebit": _3, "typedream": _3, "vercel": _3, "bookonline": _3 }], "apple": _2, "aquarelle": _2, "arab": _2, "aramco": _2, "archi": _2, "army": _2, "art": _2, "arte": _2, "asda": _2, "associates": _2, "athleta": _2, "attorney": _2, "auction": _2, "audi": _2, "audible": _2, "audio": _2, "auspost": _2, "author": _2, "auto": _2, "autos": _2, "avianca": _2, "aws": _2, "axa": _2, "azure": _2, "baby": _2, "baidu": _2, "banamex": _2, "bananarepublic": _2, "band": _2, "bank": _2, "bar": _2, "barcelona": _2, "barclaycard": _2, "barclays": _2, "barefoot": _2, "bargains": _2, "baseball": _2, "basketball": [1, { "aus": _3, "nz": _3 }], "bauhaus": _2, "bayern": _2, "bbc": _2, "bbt": _2, "bbva": _2, "bcg": _2, "bcn": _2, "beats": _2, "beauty": _2, "beer": _2, "bentley": _2, "berlin": _2, "best": _2, "bestbuy": _2, "bet": _2, "bharti": _2, "bible": _2, "bid": _2, "bike": _2, "bing": _2, "bingo": _2, "bio": _2, "black": _2, "blackfriday": _2, "blockbuster": _2, "blog": _2, "bloomberg": _2, "blue": _2, "bms": _2, "bmw": _2, "bnpparibas": _2, "boats": _2, "boehringer": _2, "bofa": _2, "bom": _2, "bond": _2, "boo": _2, "book": _2, "booking": _2, "bosch": _2, "bostik": _2, "boston": _2, "bot": _2, "boutique": _2, "box": _2, "bradesco": _2, "bridgestone": _2, "broadway": _2, "broker": _2, "brother": _2, "brussels": _2, "build": _2, "builders": [1, { "cloudsite": _3 }], "business": _10, "buy": _2, "buzz": _2, "bzh": _2, "cab": _2, "cafe": _2, "cal": _2, "call": _2, "calvinklein": _2, "cam": _2, "camera": _2, "camp": _2, "canon": _2, "capetown": _2, "capital": _2, "capitalone": _2, "car": _2, "caravan": _2, "cards": _2, "care": _2, "career": _2, "careers": _2, "cars": _2, "casa": [1, { "nabu": [0, { "ui": _3 }] }], "case": _2, "cash": _2, "casino": _2, "catering": _2, "catholic": _2, "cba": _2, "cbn": _2, "cbre": _2, "cbs": _2, "center": _2, "ceo": _2, "cern": _2, "cfa": _2, "cfd": _2, "chanel": _2, "channel": _2, "charity": _2, "chase": _2, "chat": _2, "cheap": _2, "chintai": _2, "christmas": _2, "chrome": _2, "church": _2, "cipriani": _2, "circle": _2, "cisco": _2, "citadel": _2, "citi": _2, "citic": _2, "city": _2, "cityeats": _2, "claims": _2, "cleaning": _2, "click": _2, "clinic": _2, "clinique": _2, "clothing": _2, "cloud": [1, { "banzai": _5, "elementor": _3, "encoway": [0, { "eu": _3 }], "statics": _5, "ravendb": _3, "axarnet": [0, { "es-1": _3 }], "diadem": _3, "jelastic": [0, { "vip": _3 }], "jele": _3, "jenv-aruba": [0, { "aruba": [0, { "eur": [0, { "it1": _3 }] }], "it1": _3 }], "keliweb": [2, { "cs": _3 }], "oxa": [2, { "tn": _3, "uk": _3 }], "primetel": [2, { "uk": _3 }], "reclaim": [0, { "ca": _3, "uk": _3, "us": _3 }], "trendhosting": [0, { "ch": _3, "de": _3 }], "jotelulu": _3, "kuleuven": _3, "linkyard": _3, "magentosite": _5, "perspecta": _3, "vapor": _3, "on-rancher": _5, "scw": [0, { "baremetal": [0, { "fr-par-1": _3, "fr-par-2": _3, "nl-ams-1": _3 }], "fr-par": [0, { "fnc": [2, { "functions": _3 }], "k8s": _11, "s3": _3, "s3-website": _3, "whm": _3 }], "instances": [0, { "priv": _3, "pub": _3 }], "k8s": _3, "nl-ams": [0, { "k8s": _11, "s3": _3, "s3-website": _3, "whm": _3 }], "pl-waw": [0, { "k8s": _11, "s3": _3, "s3-website": _3 }], "scalebook": _3, "smartlabeling": _3 }], "sensiosite": _5, "trafficplex": _3, "urown": _3, "voorloper": _3 }], "club": [1, { "cloudns": _3, "jele": _3, "barsy": _3 }], "clubmed": _2, "coach": _2, "codes": [1, { "owo": _5 }], "coffee": _2, "college": _2, "cologne": _2, "comcast": _2, "commbank": _2, "community": [1, { "nog": _3, "ravendb": _3, "myforum": _3 }], "company": _2, "compare": _2, "computer": _2, "comsec": _2, "condos": _2, "construction": _2, "consulting": _2, "contact": _2, "contractors": _2, "cooking": _2, "cool": [1, { "elementor": _3, "de": _3 }], "corsica": _2, "country": _2, "coupon": _2, "coupons": _2, "courses": _2, "cpa": _2, "credit": _2, "creditcard": _2, "creditunion": _2, "cricket": _2, "crown": _2, "crs": _2, "cruise": _2, "cruises": _2, "cuisinella": _2, "cymru": _2, "cyou": _2, "dabur": _2, "dad": _2, "dance": _2, "data": _2, "date": _2, "dating": _2, "datsun": _2, "day": _2, "dclk": _2, "dds": _2, "deal": _2, "dealer": _2, "deals": _2, "degree": _2, "delivery": _2, "dell": _2, "deloitte": _2, "delta": _2, "democrat": _2, "dental": _2, "dentist": _2, "desi": _2, "design": [1, { "bss": _3 }], "dev": [1, { "autocode": _3, "lcl": _5, "lclstage": _5, "stg": _5, "stgstage": _5, "pages": _3, "r2": _3, "workers": _3, "curv": _3, "deno": _3, "deno-staging": _3, "deta": _3, "fly": _3, "githubpreview": _3, "gateway": _5, "iserv": _3, "localcert": [0, { "user": _5 }], "loginline": _3, "mediatech": _3, "ngrok": _3, "ngrok-free": _3, "platter-app": _3, "shiftcrypto": _3, "vercel": _3, "webhare": _5 }], "dhl": _2, "diamonds": _2, "diet": _2, "digital": [1, { "cloudapps": [2, { "london": _3 }] }], "direct": _2, "directory": _2, "discount": _2, "discover": _2, "dish": _2, "diy": _2, "dnp": _2, "docs": _2, "doctor": _2, "dog": _2, "domains": _2, "dot": _2, "download": _2, "drive": _2, "dtv": _2, "dubai": _2, "dunlop": _2, "dupont": _2, "durban": _2, "dvag": _2, "dvr": _2, "earth": [1, { "dapps": [0, { "*": _3, "bzz": _5 }] }], "eat": _2, "eco": _2, "edeka": _2, "education": _10, "email": _2, "emerck": _2, "energy": _2, "engineer": _2, "engineering": _2, "enterprises": _2, "epson": _2, "equipment": _2, "ericsson": _2, "erni": _2, "esq": _2, "estate": [1, { "compute": _5 }], "etisalat": _2, "eurovision": _2, "eus": [1, { "party": _30 }], "events": [1, { "koobin": _3, "co": _3 }], "exchange": _2, "expert": _2, "exposed": _2, "express": _2, "extraspace": _2, "fage": _2, "fail": _2, "fairwinds": _2, "faith": _31, "family": _2, "fan": _2, "fans": _2, "farm": [1, { "storj": _3 }], "farmers": _2, "fashion": _2, "fast": _2, "fedex": _2, "feedback": _2, "ferrari": _2, "ferrero": _2, "fidelity": _2, "fido": _2, "film": _2, "final": _2, "finance": _2, "financial": _10, "fire": _2, "firestone": _2, "firmdale": _2, "fish": _2, "fishing": _2, "fit": _2, "fitness": _2, "flickr": _2, "flights": _2, "flir": _2, "florist": _2, "flowers": _2, "fly": _2, "foo": _2, "food": _2, "football": _2, "ford": _2, "forex": _2, "forsale": _2, "forum": _2, "foundation": _2, "fox": _2, "free": _2, "fresenius": _2, "frl": _2, "frogans": _2, "frontdoor": _2, "frontier": _2, "ftr": _2, "fujitsu": _2, "fun": _2, "fund": _2, "furniture": _2, "futbol": _2, "fyi": _2, "gal": _2, "gallery": _2, "gallo": _2, "gallup": _2, "game": _2, "games": _2, "gap": _2, "garden": _2, "gay": _2, "gbiz": _2, "gdn": [1, { "cnpy": _3 }], "gea": _2, "gent": _2, "genting": _2, "george": _2, "ggee": _2, "gift": _2, "gifts": _2, "gives": _2, "giving": _2, "glass": _2, "gle": _2, "global": _2, "globo": _2, "gmail": _2, "gmbh": _2, "gmo": _2, "gmx": _2, "godaddy": _2, "gold": _2, "goldpoint": _2, "golf": _2, "goo": _2, "goodyear": _2, "goog": [1, { "cloud": _3, "translate": _3, "usercontent": _5 }], "google": _2, "gop": _2, "got": _2, "grainger": _2, "graphics": _2, "gratis": _2, "green": _2, "gripe": _2, "grocery": _2, "group": [1, { "discourse": _3 }], "guardian": _2, "gucci": _2, "guge": _2, "guide": _2, "guitars": _2, "guru": _2, "hair": _2, "hamburg": _2, "hangout": _2, "haus": _2, "hbo": _2, "hdfc": _2, "hdfcbank": _2, "health": [1, { "hra": _3 }], "healthcare": _2, "help": _2, "helsinki": _2, "here": _2, "hermes": _2, "hiphop": _2, "hisamitsu": _2, "hitachi": _2, "hiv": _2, "hkt": _2, "hockey": _2, "holdings": _2, "holiday": _2, "homedepot": _2, "homegoods": _2, "homes": _2, "homesense": _2, "honda": _2, "horse": _2, "hospital": _2, "host": [1, { "cloudaccess": _3, "freesite": _3, "easypanel": _3, "fastvps": _3, "myfast": _3, "tempurl": _3, "wpmudev": _3, "jele": _3, "mircloud": _3, "pcloud": _3, "half": _3 }], "hosting": [1, { "opencraft": _3 }], "hot": _2, "hotels": _2, "hotmail": _2, "house": _2, "how": _2, "hsbc": _2, "hughes": _2, "hyatt": _2, "hyundai": _2, "ibm": _2, "icbc": _2, "ice": _2, "icu": _2, "ieee": _2, "ifm": _2, "ikano": _2, "imamat": _2, "imdb": _2, "immo": _2, "immobilien": _2, "inc": _2, "industries": _2, "infiniti": _2, "ing": _2, "ink": _2, "institute": _2, "insurance": _2, "insure": _2, "international": _2, "intuit": _2, "investments": _2, "ipiranga": _2, "irish": _2, "ismaili": _2, "ist": _2, "istanbul": _2, "itau": _2, "itv": _2, "jaguar": _2, "java": _2, "jcb": _2, "jeep": _2, "jetzt": _2, "jewelry": _2, "jio": _2, "jll": _2, "jmp": _2, "jnj": _2, "joburg": _2, "jot": _2, "joy": _2, "jpmorgan": _2, "jprs": _2, "juegos": _2, "juniper": _2, "kaufen": _2, "kddi": _2, "kerryhotels": _2, "kerrylogistics": _2, "kerryproperties": _2, "kfh": _2, "kia": _2, "kids": _2, "kim": _2, "kinder": _2, "kindle": _2, "kitchen": _2, "kiwi": _2, "koeln": _2, "komatsu": _2, "kosher": _2, "kpmg": _2, "kpn": _2, "krd": [1, { "co": _3, "edu": _3 }], "kred": _2, "kuokgroup": _2, "kyoto": _2, "lacaixa": _2, "lamborghini": _2, "lamer": _2, "lancaster": _2, "land": [1, { "static": [2, { "dev": _3, "sites": _3 }] }], "landrover": _2, "lanxess": _2, "lasalle": _2, "lat": _2, "latino": _2, "latrobe": _2, "law": _2, "lawyer": _2, "lds": _2, "lease": _2, "leclerc": _2, "lefrak": _2, "legal": _2, "lego": _2, "lexus": _2, "lgbt": _2, "lidl": _2, "life": _2, "lifeinsurance": _2, "lifestyle": _2, "lighting": _2, "like": _2, "lilly": _2, "limited": _2, "limo": _2, "lincoln": _2, "link": [1, { "cyon": _3, "mypep": _3, "dweb": _5 }], "lipsy": _2, "live": [1, { "hlx": _3 }], "living": _2, "llc": _2, "llp": _2, "loan": _2, "loans": _2, "locker": _2, "locus": _2, "lol": [1, { "omg": _3 }], "london": _2, "lotte": _2, "lotto": _2, "love": _2, "lpl": _2, "lplfinancial": _2, "ltd": _2, "ltda": _2, "lundbeck": _2, "luxe": _2, "luxury": _2, "madrid": _2, "maif": _2, "maison": _2, "makeup": _2, "man": _2, "management": [1, { "router": _3 }], "mango": _2, "map": _2, "market": _2, "marketing": _2, "markets": _2, "marriott": _2, "marshalls": _2, "mattel": _2, "mba": _2, "mckinsey": _2, "med": _2, "media": _37, "meet": _2, "melbourne": _2, "meme": _2, "memorial": _2, "men": _2, "menu": _38, "merckmsd": _2, "miami": _2, "microsoft": _2, "mini": _2, "mint": _2, "mit": _2, "mitsubishi": _2, "mlb": _2, "mls": _2, "mma": _2, "mobile": _2, "moda": _2, "moe": _2, "moi": _2, "mom": _2, "monash": _2, "money": _2, "monster": _2, "mormon": _2, "mortgage": _2, "moscow": _2, "moto": _2, "motorcycles": _2, "mov": _2, "movie": _2, "msd": _2, "mtn": _2, "mtr": _2, "music": _2, "nab": _2, "nagoya": _2, "natura": _2, "navy": _2, "nba": _2, "nec": _2, "netbank": _2, "netflix": _2, "network": [1, { "alces": _5, "co": _3, "arvo": _3, "azimuth": _3, "tlon": _3 }], "neustar": _2, "new": _2, "news": [1, { "noticeable": _3 }], "next": _2, "nextdirect": _2, "nexus": _2, "nfl": _2, "ngo": _2, "nhk": _2, "nico": _2, "nike": _2, "nikon": _2, "ninja": _2, "nissan": _2, "nissay": _2, "nokia": _2, "norton": _2, "now": _2, "nowruz": _2, "nowtv": _2, "nra": _2, "nrw": _2, "ntt": _2, "nyc": _2, "obi": _2, "observer": _2, "office": _2, "okinawa": _2, "olayan": _2, "olayangroup": _2, "oldnavy": _2, "ollo": _2, "omega": _2, "one": [1, { "onred": [2, { "staging": _3 }], "service": _3, "homelink": _3 }], "ong": _2, "onl": _2, "online": [1, { "eero": _3, "eero-stage": _3, "barsy": _3 }], "ooo": _2, "open": _2, "oracle": _2, "orange": [1, { "tech": _3 }], "organic": _2, "origins": _2, "osaka": _2, "otsuka": _2, "ott": _2, "ovh": [1, { "nerdpol": _3 }], "page": [1, { "hlx": _3, "hlx3": _3, "translated": _3, "codeberg": _3, "pdns": _3, "plesk": _3, "prvcy": _3, "rocky": _3, "magnet": _3 }], "panasonic": _2, "paris": _2, "pars": _2, "partners": _2, "parts": _2, "party": _31, "pay": _2, "pccw": _2, "pet": _2, "pfizer": _2, "pharmacy": _2, "phd": _2, "philips": _2, "phone": _2, "photo": _2, "photography": _2, "photos": _37, "physio": _2, "pics": _2, "pictet": _2, "pictures": [1, { "1337": _3 }], "pid": _2, "pin": _2, "ping": _2, "pink": _2, "pioneer": _2, "pizza": [1, { "ngrok": _3 }], "place": _10, "play": _2, "playstation": _2, "plumbing": _2, "plus": _2, "pnc": _2, "pohl": _2, "poker": _2, "politie": _2, "porn": [1, { "indie": _3 }], "pramerica": _2, "praxi": _2, "press": _2, "prime": _2, "prod": _2, "productions": _2, "prof": _2, "progressive": _2, "promo": _2, "properties": _2, "property": _2, "protection": _2, "pru": _2, "prudential": _2, "pub": _38, "pwc": _2, "qpon": _2, "quebec": _2, "quest": _2, "racing": _2, "radio": _2, "read": _2, "realestate": _2, "realtor": _2, "realty": _2, "recipes": _2, "red": _2, "redstone": _2, "redumbrella": _2, "rehab": _2, "reise": _2, "reisen": _2, "reit": _2, "reliance": _2, "ren": _2, "rent": _2, "rentals": _2, "repair": _2, "report": _2, "republican": _2, "rest": _2, "restaurant": _2, "review": _31, "reviews": _2, "rexroth": _2, "rich": _2, "richardli": _2, "ricoh": _2, "ril": _2, "rio": _2, "rip": [1, { "clan": _3 }], "rocher": _2, "rocks": [1, { "myddns": _3, "lima-city": _3, "webspace": _3 }], "rodeo": _2, "rogers": _2, "room": _2, "rsvp": _2, "rugby": _2, "ruhr": _2, "run": [1, { "hs": _3, "development": _3, "ravendb": _3, "servers": _3, "build": _5, "code": _5, "database": _5, "migration": _5, "onporter": _3, "repl": _3, "wix": _3 }], "rwe": _2, "ryukyu": _2, "saarland": _2, "safe": _2, "safety": _2, "sakura": _2, "sale": _2, "salon": _2, "samsclub": _2, "samsung": _2, "sandvik": _2, "sandvikcoromant": _2, "sanofi": _2, "sap": _2, "sarl": _2, "sas": _2, "save": _2, "saxo": _2, "sbi": _2, "sbs": _2, "sca": _2, "scb": _2, "schaeffler": _2, "schmidt": _2, "scholarships": _2, "school": _2, "schule": _2, "schwarz": _2, "science": _31, "scot": [1, { "edu": _3, "gov": [2, { "service": _3 }] }], "search": _2, "seat": _2, "secure": _2, "security": _2, "seek": _2, "select": _2, "sener": _2, "services": [1, { "loginline": _3 }], "seven": _2, "sew": _2, "sex": _2, "sexy": _2, "sfr": _2, "shangrila": _2, "sharp": _2, "shaw": _2, "shell": _2, "shia": _2, "shiksha": _2, "shoes": _2, "shop": [1, { "base": _3, "hoplix": _3, "barsy": _3 }], "shopping": _2, "shouji": _2, "show": _2, "showtime": _2, "silk": _2, "sina": _2, "singles": _2, "site": [1, { "cloudera": _5, "cyon": _3, "fnwk": _3, "folionetwork": _3, "fastvps": _3, "jele": _3, "lelux": _3, "loginline": _3, "barsy": _3, "mintere": _3, "omniwe": _3, "opensocial": _3, "platformsh": _5, "tst": _5, "byen": _3, "srht": _3, "novecore": _3 }], "ski": _2, "skin": _2, "sky": _2, "skype": _2, "sling": _2, "smart": _2, "smile": _2, "sncf": _2, "soccer": _2, "social": _2, "softbank": _2, "software": _2, "sohu": _2, "solar": _2, "solutions": [1, { "diher": _5 }], "song": _2, "sony": _2, "soy": _2, "spa": _2, "space": [1, { "myfast": _3, "uber": _3, "xs4all": _3 }], "sport": _2, "spot": _2, "srl": _2, "stada": _2, "staples": _2, "star": _2, "statebank": _2, "statefarm": _2, "stc": _2, "stcgroup": _2, "stockholm": _2, "storage": _2, "store": [1, { "sellfy": _3, "shopware": _3, "storebase": _3 }], "stream": _2, "studio": _2, "study": _2, "style": _2, "sucks": _2, "supplies": _2, "supply": _2, "support": _38, "surf": _2, "surgery": _2, "suzuki": _2, "swatch": _2, "swiss": _2, "sydney": _2, "systems": [1, { "knightpoint": _3 }], "tab": _2, "taipei": _2, "talk": _2, "taobao": _2, "target": _2, "tatamotors": _2, "tatar": _2, "tattoo": _2, "tax": _2, "taxi": _2, "tci": _2, "tdk": _2, "team": [1, { "discourse": _3, "jelastic": _3 }], "tech": _2, "technology": _10, "temasek": _2, "tennis": _2, "teva": _2, "thd": _2, "theater": _2, "theatre": _2, "tiaa": _2, "tickets": _2, "tienda": _2, "tips": _2, "tires": _2, "tirol": _2, "tjmaxx": _2, "tjx": _2, "tkmaxx": _2, "tmall": _2, "today": [1, { "prequalifyme": _3 }], "tokyo": _2, "tools": _2, "top": [1, { "now-dns": _3, "ntdll": _3 }], "toray": _2, "toshiba": _2, "total": _2, "tours": _2, "town": _2, "toyota": _2, "toys": _2, "trade": _31, "trading": _2, "training": _2, "travel": _2, "travelers": _2, "travelersinsurance": _2, "trust": _2, "trv": _2, "tube": _2, "tui": _2, "tunes": _2, "tushu": _2, "tvs": _2, "ubank": _2, "ubs": _2, "unicom": _2, "university": _2, "uno": _2, "uol": _2, "ups": _2, "vacations": _2, "vana": _2, "vanguard": _2, "vegas": _2, "ventures": _2, "verisign": _2, "versicherung": _2, "vet": _2, "viajes": _2, "video": _2, "vig": _2, "viking": _2, "villas": _2, "vin": _2, "vip": _2, "virgin": _2, "visa": _2, "vision": _2, "viva": _2, "vivo": _2, "vlaanderen": _2, "vodka": _2, "volkswagen": _2, "volvo": _2, "vote": _2, "voting": _2, "voto": _2, "voyage": _2, "wales": _2, "walmart": _2, "walter": _2, "wang": _2, "wanggou": _2, "watch": _2, "watches": _2, "weather": _2, "weatherchannel": _2, "webcam": _2, "weber": _2, "website": _37, "wedding": _2, "weibo": _2, "weir": _2, "whoswho": _2, "wien": _2, "wiki": _37, "williamhill": _2, "win": _2, "windows": _2, "wine": _2, "winners": _2, "wme": _2, "wolterskluwer": _2, "woodside": _2, "work": _2, "works": _2, "world": _2, "wow": _2, "wtc": _2, "wtf": _2, "xbox": _2, "xerox": _2, "xfinity": _2, "xihuan": _2, "xin": _2, "xn--11b4c3d": _2, "कॉम": _2, "xn--1ck2e1b": _2, "セール": _2, "xn--1qqw23a": _2, "佛山": _2, "xn--30rr7y": _2, "慈善": _2, "xn--3bst00m": _2, "集团": _2, "xn--3ds443g": _2, "在线": _2, "xn--3pxu8k": _2, "点看": _2, "xn--42c2d9a": _2, "คอม": _2, "xn--45q11c": _2, "八卦": _2, "xn--4gbrim": _2, "موقع": _2, "xn--55qw42g": _2, "公益": _2, "xn--55qx5d": _2, "公司": _2, "xn--5su34j936bgsg": _2, "香格里拉": _2, "xn--5tzm5g": _2, "网站": _2, "xn--6frz82g": _2, "移动": _2, "xn--6qq986b3xl": _2, "我爱你": _2, "xn--80adxhks": _2, "москва": _2, "xn--80aqecdr1a": _2, "католик": _2, "xn--80asehdb": _2, "онлайн": _2, "xn--80aswg": _2, "сайт": _2, "xn--8y0a063a": _2, "联通": _2, "xn--9dbq2a": _2, "קום": _2, "xn--9et52u": _2, "时尚": _2, "xn--9krt00a": _2, "微博": _2, "xn--b4w605ferd": _2, "淡马锡": _2, "xn--bck1b9a5dre4c": _2, "ファッション": _2, "xn--c1avg": _2, "орг": _2, "xn--c2br7g": _2, "नेट": _2, "xn--cck2b3b": _2, "ストア": _2, "xn--cckwcxetd": _2, "アマゾン": _2, "xn--cg4bki": _2, "삼성": _2, "xn--czr694b": _2, "商标": _2, "xn--czrs0t": _2, "商店": _2, "xn--czru2d": _2, "商城": _2, "xn--d1acj3b": _2, "дети": _2, "xn--eckvdtc9d": _2, "ポイント": _2, "xn--efvy88h": _2, "新闻": _2, "xn--fct429k": _2, "家電": _2, "xn--fhbei": _2, "كوم": _2, "xn--fiq228c5hs": _2, "中文网": _2, "xn--fiq64b": _2, "中信": _2, "xn--fjq720a": _2, "娱乐": _2, "xn--flw351e": _2, "谷歌": _2, "xn--fzys8d69uvgm": _2, "電訊盈科": _2, "xn--g2xx48c": _2, "购物": _2, "xn--gckr3f0f": _2, "クラウド": _2, "xn--gk3at1e": _2, "通販": _2, "xn--hxt814e": _2, "网店": _2, "xn--i1b6b1a6a2e": _2, "संगठन": _2, "xn--imr513n": _2, "餐厅": _2, "xn--io0a7i": _2, "网络": _2, "xn--j1aef": _2, "ком": _2, "xn--jlq480n2rg": _2, "亚马逊": _2, "xn--jvr189m": _2, "食品": _2, "xn--kcrx77d1x4a": _2, "飞利浦": _2, "xn--kput3i": _2, "手机": _2, "xn--mgba3a3ejt": _2, "ارامكو": _2, "xn--mgba7c0bbn0a": _2, "العليان": _2, "xn--mgbaakc7dvf": _2, "اتصالات": _2, "xn--mgbab2bd": _2, "بازار": _2, "xn--mgbca7dzdo": _2, "ابوظبي": _2, "xn--mgbi4ecexp": _2, "كاثوليك": _2, "xn--mgbt3dhd": _2, "همراه": _2, "xn--mk1bu44c": _2, "닷컴": _2, "xn--mxtq1m": _2, "政府": _2, "xn--ngbc5azd": _2, "شبكة": _2, "xn--ngbe9e0a": _2, "بيتك": _2, "xn--ngbrx": _2, "عرب": _2, "xn--nqv7f": _2, "机构": _2, "xn--nqv7fs00ema": _2, "组织机构": _2, "xn--nyqy26a": _2, "健康": _2, "xn--otu796d": _2, "招聘": _2, "xn--p1acf": [1, { "xn--90amc": _3, "xn--j1aef": _3, "xn--j1ael8b": _3, "xn--h1ahn": _3, "xn--j1adp": _3, "xn--c1avg": _3, "xn--80aaa0cvac": _3, "xn--h1aliz": _3, "xn--90a1af": _3, "xn--41a": _3 }], "рус": [1, { "биз": _3, "ком": _3, "крым": _3, "мир": _3, "мск": _3, "орг": _3, "самара": _3, "сочи": _3, "спб": _3, "я": _3 }], "xn--pssy2u": _2, "大拿": _2, "xn--q9jyb4c": _2, "みんな": _2, "xn--qcka1pmc": _2, "グーグル": _2, "xn--rhqv96g": _2, "世界": _2, "xn--rovu88b": _2, "書籍": _2, "xn--ses554g": _2, "网址": _2, "xn--t60b56a": _2, "닷넷": _2, "xn--tckwe": _2, "コム": _2, "xn--tiq49xqyj": _2, "天主教": _2, "xn--unup4y": _2, "游戏": _2, "xn--vermgensberater-ctb": _2, "vermögensberater": _2, "xn--vermgensberatung-pwb": _2, "vermögensberatung": _2, "xn--vhquv": _2, "企业": _2, "xn--vuq861b": _2, "信息": _2, "xn--w4r85el8fhu5dnra": _2, "嘉里大酒店": _2, "xn--w4rs40l": _2, "嘉里": _2, "xn--xhq521b": _2, "广东": _2, "xn--zfr164b": _2, "政务": _2, "xyz": [1, { "blogsite": _3, "localzone": _3, "crafting": _3, "zapto": _3, "telebit": _5 }], "yachts": _2, "yahoo": _2, "yamaxun": _2, "yandex": _2, "yodobashi": _2, "yoga": _2, "yokohama": _2, "you": _2, "youtube": _2, "yun": _2, "zappos": _2, "zara": _2, "zero": _2, "zip": _2, "zone": [1, { "cloud66": _3, "hs": _3, "triton": _5, "lima": _3 }], "zuerich": _2 }];
    return rules;
})();

/**
 * Lookup parts of domain in Trie
 */
function lookupInTrie(parts, trie, index, allowedMask) {
    let result = null;
    let node = trie;
    while (node !== undefined) {
        // We have a match!
        if ((node[0] & allowedMask) !== 0) {
            result = {
                index: index + 1,
                isIcann: node[0] === 1 /* RULE_TYPE.ICANN */,
                isPrivate: node[0] === 2 /* RULE_TYPE.PRIVATE */,
            };
        }
        // No more `parts` to look for
        if (index === -1) {
            break;
        }
        const succ = node[1];
        node = Object.prototype.hasOwnProperty.call(succ, parts[index])
            ? succ[parts[index]]
            : succ['*'];
        index -= 1;
    }
    return result;
}
/**
 * Check if `hostname` has a valid public suffix in `trie`.
 */
function suffixLookup(hostname, options, out) {
    var _a;
    if (fastPathLookup(hostname, options, out)) {
        return;
    }
    const hostnameParts = hostname.split('.');
    const allowedMask = (options.allowPrivateDomains ? 2 /* RULE_TYPE.PRIVATE */ : 0) |
        (options.allowIcannDomains ? 1 /* RULE_TYPE.ICANN */ : 0);
    // Look for exceptions
    const exceptionMatch = lookupInTrie(hostnameParts, exceptions, hostnameParts.length - 1, allowedMask);
    if (exceptionMatch !== null) {
        out.isIcann = exceptionMatch.isIcann;
        out.isPrivate = exceptionMatch.isPrivate;
        out.publicSuffix = hostnameParts.slice(exceptionMatch.index + 1).join('.');
        return;
    }
    // Look for a match in rules
    const rulesMatch = lookupInTrie(hostnameParts, rules, hostnameParts.length - 1, allowedMask);
    if (rulesMatch !== null) {
        out.isIcann = rulesMatch.isIcann;
        out.isPrivate = rulesMatch.isPrivate;
        out.publicSuffix = hostnameParts.slice(rulesMatch.index).join('.');
        return;
    }
    // No match found...
    // Prevailing rule is '*' so we consider the top-level domain to be the
    // public suffix of `hostname` (e.g.: 'example.org' => 'org').
    out.isIcann = false;
    out.isPrivate = false;
    out.publicSuffix = (_a = hostnameParts[hostnameParts.length - 1]) !== null && _a !== void 0 ? _a : null;
}

function parse(url, options = {}) {
    return parseImpl(url, 5 /* FLAG.ALL */, suffixLookup, options, getEmptyResult());
}

const createBrowserPlatformService = (window) => ({
    getDisplayOrigin: () => window.location.origin,
    getHost: () => window.location.host,
    getHostname: () => window.location.hostname,
    getOrigin: () => window.location.origin,
    getTLD: () => {
        // Passing the allowPrivateDomains option prevents returning the actual TLD
        // for domains that have delegated subdomains like herokuapp.com or s3.amazonaws.com
        // full list is contained here https://publicsuffix.org/list/effective_tld_names.dat
        // separated by ICANN DOMAINS and PRIVATE DOMAINS
        // so for instance parse('someapp.herokuapp.com') will return 'someapp.herokuapp.com' as the domain
        // whereas parse('app.dynamic.xyz') will return 'dynamic.xyz'
        const data = parse(window.location.hostname, {
            allowPrivateDomains: true,
        });
        return data.domain || undefined;
    },
    isNativeMobile: false,
    openURL: (url) => __awaiter$d(void 0, void 0, void 0, function* () {
        window.location.assign(url);
    }),
});

var _a$3, _PlatformService_implementation;
class PlatformService {
    static get implementation() {
        if (!__classPrivateFieldGet$5(_a$3, _a$3, "f", _PlatformService_implementation)) {
            return createBrowserPlatformService(window);
        }
        return __classPrivateFieldGet$5(_a$3, _a$3, "f", _PlatformService_implementation);
    }
    static set implementation(implementation) {
        __classPrivateFieldSet$4(_a$3, _a$3, implementation, "f", _PlatformService_implementation);
    }
    /**
     * Indicates if the current platform is a native mobile app
     * like react-native or flutter.
     */
    static get isNativeMobile() {
        return _a$3.implementation.isNativeMobile;
    }
    /**
     * Gets the origin of the current location.
     *
     * @example window.location.origin
     */
    static get getOrigin() {
        return _a$3.implementation.getOrigin;
    }
    /**
     * Gets the origin to be displayed in the UI.
     *
     * @example window.location.origin
     */
    static get getDisplayOrigin() {
        return _a$3.implementation.getDisplayOrigin;
    }
    /**
     * Gets the host of the current location.
     *
     * @example window.location.host
     */
    static get getHost() {
        return _a$3.implementation.getHost;
    }
    /**
     * Gets the hostname of the current location.
     *
     * @example window.location.hostname
     */
    static get getHostname() {
        return _a$3.implementation.getHostname;
    }
    static get getTLD() {
        return _a$3.implementation.getTLD;
    }
    /**
     * Opens a URL. If possible, should avoid new windows.
     */
    static get openURL() {
        return _a$3.implementation.openURL;
    }
}
_a$3 = PlatformService;
_PlatformService_implementation = { value: void 0 };

const getTLD = () => PlatformService.getTLD();

/**
 * Sourced from http://detectmobilebrowsers.com/
 */
/* eslint-disable max-len, no-useless-escape */
const userAgentRegex1 = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i;
const userAgentRegex2 = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
// This is a regex that covers both iphone, android and any other mobile device.
const isMobile = (maxTouchPointsOverride) => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }
    return (userAgentRegex1.test(navigator.userAgent) ||
        userAgentRegex2.test(navigator.userAgent.substring(0, 4)) ||
        isIPad() ||
        isIPhone());
};
const isIPhone = () => typeof window === 'undefined' || typeof navigator === 'undefined'
    ? false
    : /iPhone/.test(navigator.userAgent);
const isIPhone8OrEarlier = () => typeof window === 'undefined' || typeof navigator === 'undefined'
    ? false
    : iPhoneLegacyRegex.some(({ regex }) => regex.test(navigator.userAgent));
/**
 * @param [optional] maxTouchPointsOverride - this is used for testing since
 * it seems that JSDOM doesn't support maxTouchPoints, so it was impossible
 * to mock it
 */
const isIPad = (maxTouchPointsOverride) => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }
    const maxTouchPoints = navigator.maxTouchPoints;
    return (/iPad/.test(navigator.userAgent) ||
        (/Mac/.test(navigator.userAgent) && maxTouchPoints === 5));
};
const isIOS = (maxTouchPointsOverride) => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }
    return isIPhone() || isIPad();
};
const isAndroid = () => isMobile() && !isIOS();
const isLegacySafari = () => {
    // We need to check if window.CSS exists and if it has supports function.
    // We can use it only in browsers. This prevents customer tests from failing because of that.
    if (typeof window === 'undefined' ||
        !window.CSS ||
        typeof window.CSS.supports !== 'function') {
        return false;
    }
    // Older versions of Safari <15 are not supporting aspect-ratio css property.
    // We can use that to check if user is on older browser.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/aspect-ratio
    const cssValue = 'aspect-ratio: 1 / 1';
    return !CSS.supports(cssValue);
};
const isSamsungBrowser = () => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }
    return navigator.userAgent.includes('SamsungBrowser');
};
const isSafariBrowser = () => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }
    const { userAgent } = navigator;
    const isSafari = userAgent.includes('Safari') &&
        !userAgent.includes('Chrome') &&
        !userAgent.includes('Chromium');
    return isSafari;
};
// regex from: https://github.com/matomo-org/device-detector/blob/master/regexes/device/mobiles.yml
const iPhoneLegacyRegex = [
    {
        model: 'iPhone 5',
        regex: /(?:MDCR_|ICRU_|Apple-)?(?:iPh(?:one)?5[C,_]12|5)$/,
    },
    {
        model: 'iPhone 5C',
        regex: /(?:MDCR_|ICRU_|Apple-)?(?:iPh(?:one)?5[C,_]34)$/,
    },
    {
        model: 'iPhone 5S',
        regex: /(?:MDCR_|ICRU_|Apple-)?(?:iPh(?:one)?6[C,_]12|5S)$/,
    },
    {
        model: 'iPhone 6 Plus',
        regex: /(?:MDCR_|ICRU_|Apple-)?(?:iPh(?:one)?7[C,_]1|1C2%257enohPi|6PLUS)$/,
    },
    {
        model: 'iPhone 6',
        regex: /(?:MDCR_|ICRU_|Apple-)?(?:iPh(?:one)?7[C,_]2|6)$/,
    },
    {
        model: 'iPhone 6s Plus',
        regex: /(?:MDCR_|ICRU_|Apple-)?(?:iPh(?:one)?8[C,_]2|6SPLUS)$/,
    },
    {
        model: 'iPhone 6s',
        regex: /(?:MDCR_|ICRU_|Apple-)?(?:iPh(?:one)?8[C,_]1|iPhone[ /]6s|6S)$/,
    },
    {
        model: 'iPhone SE',
        regex: /(?:MDCR_|ICRU_|Apple-)?(?:iPh(?:one)?8[C,_]4|SE)$/,
    },
    {
        model: 'iPhone 7',
        regex: /(?:MDCR_|ICRU_|Apple-)?(?:iPh(?:one)?9[C,_]13|iphone7|7)$/,
    },
    {
        model: 'iPhone 7 Plus',
        regex: /(?:MDCR_|ICRU_|Apple-)?(?:iPh(?:one)?9[C,_]24|7PLUS)$/,
    },
    {
        model: 'iPhone 8',
        regex: /(?:MDCR_|ICRU_|Apple-)?(?:iPh(?:one)?10[C,_]14|8)$/,
    },
    {
        model: 'iPhone 8 Plus',
        regex: /(?:MDCR_|ICRU_|Apple-)?(?:iPh(?:one)?10[C,_]25|8PLUS)$/,
    },
];
const getAndroidVersion = () => {
    if (typeof navigator === 'undefined') {
        return;
    }
    const androidVersionMatch = navigator.userAgent.match(/Android (\d+(\.\d+)?)/);
    if (!androidVersionMatch) {
        return;
    }
    const androidVersion = parseFloat(androidVersionMatch[1]);
    return androidVersion;
};

const handleMobileWalletRedirect = ({ nativeLink, universalLink, }) => {
    const url = encodeURIComponent(window.location.toString());
    const ref = encodeURIComponent(window.location.origin);
    // samsung browser only supports native links, not universal links
    if (isSamsungBrowser()) {
        window.location.assign(`${nativeLink}/${url}?ref=${ref}`);
    }
    else {
        window.location.assign(`${universalLink}/${url}?ref=${ref}`);
    }
};

const isString$1 = (value) => typeof value === 'string';

const parseChainId = (chainId) => parseInt(chainId.toString());

const parseIntSafe = (value, radix = 10) => {
    try {
        const int = parseInt(String(value), radix);
        if (isNaN(int)) {
            logger$9.error(`Error parsing ${value}`);
            return undefined;
        }
        return int;
    }
    catch (e) {
        logger$9.error(`Error parsing ${value} to int: ${e}`);
    }
    return undefined;
};

const parseEvmNetworks = (networks) => {
    const clone = networks.slice();
    return clone.map((network) => {
        network.chainId = parseChainId(network.chainId);
        network.networkId = parseChainId(network.networkId);
        return network;
    });
};

/**
 * Creates a chainable function that allows adding additional transformations
 * or operations via the `pipe` method, where each function in the chain
 * can operate on the output type of the previous function.
 * @param initialFunc The initial function to start the chain.
 *  @returns An object representing the chain of functions. The returned object
 * has a `pipe` method to add more functions to the chain and can be invoked
 * directly to execute the chain of functions with an input.
 * @example
 * ```
 * // Define a function that increments its input
 * const increment = (x: number) => x + 1;
 * // Create a function chain starting with the increment function
 * const chain = createFnPipe(increment)
 *   .pipe(x => x * 2) // After incrementing, multiply the result by 2
 *   .pipe(x => `Result: ${x}`); // Then, convert the number to a string with a prefix
 *
 * console.log(chain(3)); // Output: "Result: 8"
 * ```
 */
const pipe = (initialFunc) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const funcs = [initialFunc];
    const executeFn = (input) => funcs.reduce((acc, func) => func(acc), input);
    const pipe = (newFunc) => {
        funcs.push(newFunc);
        // The type assertion to Func<T, V> is necessary to align with the evolving return type.
        return Object.assign((input) => executeFn(input), {
            pipe,
        });
    };
    return Object.assign(executeFn, { pipe });
};

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function sleep(timeoutMs, valueToResolve) {
    return new Promise((resolve) => {
        setTimeout(() => resolve(valueToResolve), timeoutMs);
    });
}

const FALLBACK_UNDEFINED = 'FALLBACK_UNDEFINED';
const retryableFn = (fn_1, ...args_1) => __awaiter$d(void 0, [fn_1, ...args_1], void 0, function* (fn, options = {}) {
    const { maxRetries = 3, currentRetry = 0, timeoutMs = 100, fallbackValue = new Error('Max retries reached'), retryStrategy = 'timeout-only', retryIntervalMs = 0, } = options;
    const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
            reject(new Error('Timeout'));
        }, timeoutMs);
    });
    try {
        const result = yield Promise.race([fn(), timeoutPromise]);
        return result;
    }
    catch (err) {
        if (currentRetry >= maxRetries) {
            if (fallbackValue instanceof Error) {
                throw fallbackValue;
            }
            else if (fallbackValue === FALLBACK_UNDEFINED) {
                return undefined;
            }
            return fallbackValue;
        }
        const isTimeout = (err === null || err === void 0 ? void 0 : err.message) === 'Timeout';
        const shouldRetry = retryStrategy === 'timeout-and-rejection' ||
            (retryStrategy === 'timeout-only' && isTimeout) ||
            (retryStrategy === 'rejection-only' && !isTimeout);
        if (!shouldRetry) {
            if (fallbackValue instanceof Error) {
                throw err;
            }
            else if (fallbackValue === FALLBACK_UNDEFINED) {
                return undefined;
            }
            return fallbackValue;
        }
        if (retryIntervalMs)
            yield sleep(retryIntervalMs);
        return retryableFn(fn, {
            currentRetry: currentRetry + 1,
            fallbackValue,
            maxRetries,
            retryIntervalMs,
            retryStrategy,
            timeoutMs,
        });
    }
});

const sanitizeName = (name) => name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

/**
 * Formats a version string according to the specified format pattern.
 *
 * @param version - The version string in the format "x.y.z" (e.g., "1.2.3")
 * @param format - The desired output format using combinations of "major", "minor", and "patch"
 * @returns The formatted version string
 *
 * @example
 * formatVersion("1.2.3", "major.minor") // returns "1.2"
 * formatVersion("1.2.3", "major") // returns "1"
 * formatVersion("1.2.3", "major.minor.patch") // returns "1.2.3"
 */
const formatVersion = (version, format) => {
    const versionMap = Object.fromEntries(['major', 'minor', 'patch'].map((unit, index) => [
        unit,
        version.split('.')[index],
    ]));
    return format
        .split('.')
        .map((unit) => versionMap[unit])
        .join('.');
};

/**
 * Type guard assertion function that throws an error if the condition is false.
 * @param value The condition to check
 * @param message The error message to display if assertion fails
 * @throws {Error} If the assertion condition is false
 */
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function assertDefined(value, message) {
    if (!value) {
        throw new Error(message);
    }
}

/**
 * Converts a hexadecimal string to a regular string by interpreting each pair of characters in the
 * hexadecimal string as a byte in ASCII. It automatically handles hex strings prefixed with '0x'.
 *
 * @param {string} hexString - The hexadecimal string to convert. It can optionally start with '0x'.
 * @returns {string} The decoded ASCII string.
 *
 * @example
 * hexToString('68656c6c6f'); // returns 'hello'
 * hexToString('0x68656c6c6f'); // also returns 'hello'
 */
const hexToString = (hexString) => {
    const normalizedHexString = hexString.startsWith('0x')
        ? hexString.substring(2)
        : hexString;
    let text = '';
    // Ensure we only process complete pairs by rounding down to the nearest even length
    const length = normalizedHexString.length - (normalizedHexString.length % 2);
    for (let i = 0; i < length; i += 2) {
        const hexCode = normalizedHexString.substring(i, i + 2);
        const decimal = parseInt(hexCode, 16);
        text += String.fromCharCode(decimal);
    }
    return text;
};

/**
 * Checks if the provided string is a valid hexadecimal string.
 * @param str The string to check.
 * @returns `true` if the string is a valid hexadecimal string, `false` otherwise.
 */
const isHex$1 = (str) => {
    if (typeof str !== 'string') {
        throw new Error('Input must be a string');
    }
    const normalizedStr = str.startsWith('0x') ? str.substring(2) : str;
    const regex = /^[0-9a-fA-F]+$/;
    return regex.test(normalizedStr);
};

/**
 * Safely executes a callback function.
 * @template T The type of the callback's return value.
 * @template E The type of the error.
 * @param {() => Promise<T> | T} callback A function that might throw an error.
 * @returns {Promise<[T | undefined, E | undefined]>} A tuple with either the result or the error.
 */
const runSafe = (callback) => __awaiter$d(void 0, void 0, void 0, function* () {
    try {
        const resolved = yield callback();
        return [resolved, undefined];
    }
    catch (error) {
        return [undefined, error];
    }
});

const PHANTOM_REDIRECT_CONNECTION_TYPE_KEY = 'phantom-redirect-connection-type';

var _a$2, _FetchService_implementation;
/**
 * Class implementing the fetch service with a configurable fetch implementation.
 */
class FetchService {
    static get implementation() {
        if (!__classPrivateFieldGet$5(_a$2, _a$2, "f", _FetchService_implementation)) {
            return { fetch: window.fetch.bind(window) };
        }
        return __classPrivateFieldGet$5(_a$2, _a$2, "f", _FetchService_implementation);
    }
    static set implementation(implementation) {
        __classPrivateFieldSet$4(_a$2, _a$2, implementation, "f", _FetchService_implementation);
    }
    static get fetch() {
        return _a$2.implementation.fetch;
    }
}
_a$2 = FetchService;
_FetchService_implementation = { value: void 0 };

var version$c = "4.6.1";

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter$c(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/* tslint:disable */
const BASE_PATH = "https://app.dynamicauth.com/api/v0".replace(/\/+$/, "");
const isBlob = (value) => typeof Blob !== 'undefined' && value instanceof Blob;
/**
 * This is the base class for all generated API classes.
 */
class BaseAPI {
    constructor(configuration = new Configuration()) {
        this.configuration = configuration;
        this.fetchApi = (url, init) => __awaiter$c(this, void 0, void 0, function* () {
            let fetchParams = { url, init };
            for (const middleware of this.middleware) {
                if (middleware.pre) {
                    fetchParams = (yield middleware.pre(Object.assign({ fetch: this.fetchApi }, fetchParams))) || fetchParams;
                }
            }
            let response = yield (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
            for (const middleware of this.middleware) {
                if (middleware.post) {
                    response = (yield middleware.post({
                        fetch: this.fetchApi,
                        url: fetchParams.url,
                        init: fetchParams.init,
                        response: response.clone(),
                    })) || response;
                }
            }
            return response;
        });
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre) => ({ pre }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post) => ({ post }));
        return this.withMiddleware(...middlewares);
    }
    request(context, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const { url, init } = this.createFetchParams(context, initOverrides);
            const response = yield this.fetchApi(url, init);
            if (response.status >= 200 && response.status < 300) {
                return response;
            }
            throw response;
        });
    }
    createFetchParams(context, initOverrides) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) {
            // only add the querystring to the URL if there are query parameters.
            // this is done to avoid urls ending with a "?" character which buggy webservers
            // do not handle correctly sometimes.
            url += '?' + this.configuration.queryParamsStringify(context.query);
        }
        const body = ((typeof FormData !== "undefined" && context.body instanceof FormData) || context.body instanceof URLSearchParams || isBlob(context.body))
            ? context.body
            : JSON.stringify(context.body);
        const headers = Object.assign({}, this.configuration.headers, context.headers);
        const init = Object.assign({ method: context.method, headers: headers, body, credentials: this.configuration.credentials }, initOverrides);
        return { url, init };
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */
    clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
class Configuration {
    constructor(configuration = {}) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || querystring;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) {
            return typeof apiKey === 'function' ? apiKey : () => apiKey;
        }
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) {
            return typeof accessToken === 'function' ? accessToken : () => __awaiter$c(this, void 0, void 0, function* () { return accessToken; });
        }
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
function exists(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function querystring(params, prefix = '') {
    return Object.keys(params)
        .map((key) => {
        const fullKey = prefix + (prefix.length ? `[${key}]` : key);
        const value = params[key];
        if (value instanceof Array) {
            const multiValue = value.map(singleValue => encodeURIComponent(String(singleValue)))
                .join(`&${encodeURIComponent(fullKey)}=`);
            return `${encodeURIComponent(fullKey)}=${multiValue}`;
        }
        if (value instanceof Date) {
            return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
        }
        if (value instanceof Object) {
            return querystring(value, fullKey);
        }
        return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
    })
        .filter(part => part.length > 0)
        .join('&');
}
function mapValues$1(data, fn) {
    return Object.keys(data).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: fn(data[key]) })), {});
}
function canConsumeForm(consumes) {
    for (const consume of consumes) {
        if ('multipart/form-data' === consume.contentType) {
            return true;
        }
    }
    return false;
}
class JSONApiResponse {
    constructor(raw, transformer = (jsonValue) => jsonValue) {
        this.raw = raw;
        this.transformer = transformer;
    }
    value() {
        return __awaiter$c(this, void 0, void 0, function* () {
            return this.transformer(yield this.raw.json());
        });
    }
}
class VoidApiResponse {
    constructor(raw) {
        this.raw = raw;
    }
    value() {
        return __awaiter$c(this, void 0, void 0, function* () {
            return undefined;
        });
    }
}
class TextApiResponse {
    constructor(raw) {
        this.raw = raw;
    }
    value() {
        return __awaiter$c(this, void 0, void 0, function* () {
            return yield this.raw.text();
        });
    }
    ;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var AttestationConveyancePreference;
(function (AttestationConveyancePreference) {
    AttestationConveyancePreference["Direct"] = "direct";
    AttestationConveyancePreference["Enterprise"] = "enterprise";
    AttestationConveyancePreference["Indirect"] = "indirect";
    AttestationConveyancePreference["None"] = "none";
})(AttestationConveyancePreference || (AttestationConveyancePreference = {}));
function AttestationConveyancePreferenceFromJSON(json) {
    return AttestationConveyancePreferenceFromJSONTyped(json);
}
function AttestationConveyancePreferenceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var AuthModeEnum;
(function (AuthModeEnum) {
    AuthModeEnum["Only"] = "connect-only";
    AuthModeEnum["AndSign"] = "connect-and-sign";
})(AuthModeEnum || (AuthModeEnum = {}));
function AuthModeEnumToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Location in the browser where Dynamic will attempt to store the JWT token.
 * @export
 * @enum {string}
 */
var AuthStorageEnum;
(function (AuthStorageEnum) {
    AuthStorageEnum["Localstorage"] = "localstorage";
    AuthStorageEnum["Cookie"] = "cookie";
})(AuthStorageEnum || (AuthStorageEnum = {}));
function AuthStorageEnumFromJSON(json) {
    return AuthStorageEnumFromJSONTyped(json);
}
function AuthStorageEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var AuthenticatorAttachment;
(function (AuthenticatorAttachment) {
    AuthenticatorAttachment["CrossPlatform"] = "cross-platform";
    AuthenticatorAttachment["Platform"] = "platform";
})(AuthenticatorAttachment || (AuthenticatorAttachment = {}));
function AuthenticatorAttachmentFromJSON(json) {
    return AuthenticatorAttachmentFromJSONTyped(json);
}
function AuthenticatorAttachmentFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function AuthenticatorAttachmentToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ResidentKeyRequirement;
(function (ResidentKeyRequirement) {
    ResidentKeyRequirement["Discouraged"] = "discouraged";
    ResidentKeyRequirement["Preferred"] = "preferred";
    ResidentKeyRequirement["Required"] = "required";
})(ResidentKeyRequirement || (ResidentKeyRequirement = {}));
function ResidentKeyRequirementFromJSON(json) {
    return ResidentKeyRequirementFromJSONTyped(json);
}
function ResidentKeyRequirementFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var UserVerificationRequirement;
(function (UserVerificationRequirement) {
    UserVerificationRequirement["Discouraged"] = "discouraged";
    UserVerificationRequirement["Preferred"] = "preferred";
    UserVerificationRequirement["Required"] = "required";
})(UserVerificationRequirement || (UserVerificationRequirement = {}));
function UserVerificationRequirementFromJSON(json) {
    return UserVerificationRequirementFromJSONTyped(json);
}
function UserVerificationRequirementFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var AuthenticatorTransportProtocol;
(function (AuthenticatorTransportProtocol) {
    AuthenticatorTransportProtocol["Internal"] = "AUTHENTICATOR_TRANSPORT_INTERNAL";
    AuthenticatorTransportProtocol["Usb"] = "AUTHENTICATOR_TRANSPORT_USB";
    AuthenticatorTransportProtocol["Nfc"] = "AUTHENTICATOR_TRANSPORT_NFC";
    AuthenticatorTransportProtocol["Ble"] = "AUTHENTICATOR_TRANSPORT_BLE";
    AuthenticatorTransportProtocol["Hybrid"] = "AUTHENTICATOR_TRANSPORT_HYBRID";
})(AuthenticatorTransportProtocol || (AuthenticatorTransportProtocol = {}));
function AuthenticatorTransportProtocolToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function BackupMultipleClientKeySharesRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'encryptedAccountCredentials': value.encryptedAccountCredentials,
        'passwordEncrypted': value.passwordEncrypted,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function WalletKeyShareInfoFromJSON(json) {
    return WalletKeyShareInfoFromJSONTyped(json);
}
function WalletKeyShareInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'backupLocation': json['backupLocation'],
        'passwordEncrypted': json['passwordEncrypted'],
    };
}

/* tslint:disable */
function BackupMultipleClientKeySharesResponseFromJSON(json) {
    return BackupMultipleClientKeySharesResponseFromJSONTyped(json);
}
function BackupMultipleClientKeySharesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'keyShares': (json['keyShares'].map(WalletKeyShareInfoFromJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var JwtVerifiedCredentialFormatEnum;
(function (JwtVerifiedCredentialFormatEnum) {
    JwtVerifiedCredentialFormatEnum["Blockchain"] = "blockchain";
    JwtVerifiedCredentialFormatEnum["Email"] = "email";
    JwtVerifiedCredentialFormatEnum["Oauth"] = "oauth";
    JwtVerifiedCredentialFormatEnum["Passkey"] = "passkey";
    JwtVerifiedCredentialFormatEnum["PhoneNumber"] = "phoneNumber";
    JwtVerifiedCredentialFormatEnum["ExternalUser"] = "externalUser";
})(JwtVerifiedCredentialFormatEnum || (JwtVerifiedCredentialFormatEnum = {}));
function JwtVerifiedCredentialFormatEnumFromJSON(json) {
    return JwtVerifiedCredentialFormatEnumFromJSONTyped(json);
}
function JwtVerifiedCredentialFormatEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ProviderEnum;
(function (ProviderEnum) {
    ProviderEnum["EmailOnly"] = "emailOnly";
    ProviderEnum["MagicLink"] = "magicLink";
    ProviderEnum["Apple"] = "apple";
    ProviderEnum["Bitbucket"] = "bitbucket";
    ProviderEnum["Coinbasesocial"] = "coinbasesocial";
    ProviderEnum["Discord"] = "discord";
    ProviderEnum["Epicgames"] = "epicgames";
    ProviderEnum["Facebook"] = "facebook";
    ProviderEnum["Farcaster"] = "farcaster";
    ProviderEnum["Github"] = "github";
    ProviderEnum["Gitlab"] = "gitlab";
    ProviderEnum["Google"] = "google";
    ProviderEnum["Instagram"] = "instagram";
    ProviderEnum["Linkedin"] = "linkedin";
    ProviderEnum["Microsoft"] = "microsoft";
    ProviderEnum["Twitch"] = "twitch";
    ProviderEnum["Twitter"] = "twitter";
    ProviderEnum["Blocto"] = "blocto";
    ProviderEnum["Banxa"] = "banxa";
    ProviderEnum["Dynamic"] = "dynamic";
    ProviderEnum["Alchemy"] = "alchemy";
    ProviderEnum["Zerodev"] = "zerodev";
    ProviderEnum["Telegram"] = "telegram";
    ProviderEnum["Turnkey"] = "turnkey";
    ProviderEnum["CoinbaseWaas"] = "coinbaseWaas";
    ProviderEnum["Sms"] = "sms";
    ProviderEnum["Spotify"] = "spotify";
    ProviderEnum["Tiktok"] = "tiktok";
    ProviderEnum["Line"] = "line";
    ProviderEnum["Steam"] = "steam";
    ProviderEnum["Shopify"] = "shopify";
})(ProviderEnum || (ProviderEnum = {}));
function ProviderEnumFromJSON(json) {
    return ProviderEnumFromJSONTyped(json);
}
function ProviderEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ProviderEnumToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var WalletAddressType;
(function (WalletAddressType) {
    WalletAddressType["Ordinals"] = "ordinals";
    WalletAddressType["Payment"] = "payment";
    WalletAddressType["Cosmos"] = "cosmos";
    WalletAddressType["Evm"] = "evm";
})(WalletAddressType || (WalletAddressType = {}));
function WalletAddressTypeFromJSON(json) {
    return WalletAddressTypeFromJSONTyped(json);
}
function WalletAddressTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function WalletAddressTypeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var EcdsaValidatorOptions;
(function (EcdsaValidatorOptions) {
    EcdsaValidatorOptions["SignerToEcdsa"] = "zerodev_signer_to_ecdsa";
    EcdsaValidatorOptions["MultiChain"] = "zerodev_multi_chain";
})(EcdsaValidatorOptions || (EcdsaValidatorOptions = {}));
function EcdsaValidatorOptionsFromJSON(json) {
    return EcdsaValidatorOptionsFromJSONTyped(json);
}
function EcdsaValidatorOptionsFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var EmbeddedWalletVersionEnum;
(function (EmbeddedWalletVersionEnum) {
    EmbeddedWalletVersionEnum["V1"] = "V1";
    EmbeddedWalletVersionEnum["V2"] = "V2";
    EmbeddedWalletVersionEnum["V3"] = "V3";
})(EmbeddedWalletVersionEnum || (EmbeddedWalletVersionEnum = {}));
function EmbeddedWalletVersionEnumFromJSON(json) {
    return EmbeddedWalletVersionEnumFromJSONTyped(json);
}
function EmbeddedWalletVersionEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var HardwareWalletEnum;
(function (HardwareWalletEnum) {
    HardwareWalletEnum["Ledger"] = "ledger";
})(HardwareWalletEnum || (HardwareWalletEnum = {}));
function HardwareWalletEnumFromJSON(json) {
    return HardwareWalletEnumFromJSONTyped(json);
}
function HardwareWalletEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var PasswordSourceTypeEnum;
(function (PasswordSourceTypeEnum) {
    PasswordSourceTypeEnum["Dynamic"] = "dynamic";
    PasswordSourceTypeEnum["User"] = "user";
})(PasswordSourceTypeEnum || (PasswordSourceTypeEnum = {}));
function PasswordSourceTypeEnumFromJSON(json) {
    return PasswordSourceTypeEnumFromJSONTyped(json);
}
function PasswordSourceTypeEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PasswordSourceTypeEnumToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ProviderEntryPointVersionEnum;
(function (ProviderEntryPointVersionEnum) {
    ProviderEntryPointVersionEnum["V6"] = "v6";
    ProviderEntryPointVersionEnum["V7"] = "v7";
})(ProviderEntryPointVersionEnum || (ProviderEntryPointVersionEnum = {}));
function ProviderEntryPointVersionEnumFromJSON(json) {
    return ProviderEntryPointVersionEnumFromJSONTyped(json);
}
function ProviderEntryPointVersionEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ProviderKernelVersionEnum;
(function (ProviderKernelVersionEnum) {
    ProviderKernelVersionEnum["V24"] = "v2_4";
    ProviderKernelVersionEnum["V30"] = "v3_0";
    ProviderKernelVersionEnum["V31"] = "v3_1";
})(ProviderKernelVersionEnum || (ProviderKernelVersionEnum = {}));
function ProviderKernelVersionEnumFromJSON(json) {
    return ProviderKernelVersionEnumFromJSONTyped(json);
}
function ProviderKernelVersionEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var WalletProviderEnum;
(function (WalletProviderEnum) {
    WalletProviderEnum["BrowserExtension"] = "browserExtension";
    WalletProviderEnum["CustodialService"] = "custodialService";
    WalletProviderEnum["WalletConnect"] = "walletConnect";
    WalletProviderEnum["QrCode"] = "qrCode";
    WalletProviderEnum["DeepLink"] = "deepLink";
    WalletProviderEnum["EmbeddedWallet"] = "embeddedWallet";
    WalletProviderEnum["SmartContractWallet"] = "smartContractWallet";
})(WalletProviderEnum || (WalletProviderEnum = {}));
function WalletProviderEnumFromJSON(json) {
    return WalletProviderEnumFromJSONTyped(json);
}
function WalletProviderEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function WalletProviderEnumToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var MfaBackupCodeAcknowledgement;
(function (MfaBackupCodeAcknowledgement) {
    MfaBackupCodeAcknowledgement["Pending"] = "pending";
    MfaBackupCodeAcknowledgement["Complete"] = "complete";
})(MfaBackupCodeAcknowledgement || (MfaBackupCodeAcknowledgement = {}));
function MfaBackupCodeAcknowledgementFromJSON(json) {
    return MfaBackupCodeAcknowledgementFromJSONTyped(json);
}
function MfaBackupCodeAcknowledgementFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function MfaBackupCodeAcknowledgementToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var CustomFieldType;
(function (CustomFieldType) {
    CustomFieldType["Text"] = "text";
    CustomFieldType["Checkbox"] = "checkbox";
    CustomFieldType["Select"] = "select";
})(CustomFieldType || (CustomFieldType = {}));
function CustomFieldTypeFromJSON(json) {
    return CustomFieldTypeFromJSONTyped(json);
}
function CustomFieldTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var KycFieldType;
(function (KycFieldType) {
    KycFieldType["Standard"] = "standard";
    KycFieldType["Custom"] = "custom";
})(KycFieldType || (KycFieldType = {}));
function KycFieldTypeFromJSON(json) {
    return KycFieldTypeFromJSONTyped(json);
}
function KycFieldTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function KycFieldTypeToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ChainEnum;
(function (ChainEnum) {
    ChainEnum["Eth"] = "ETH";
    ChainEnum["Evm"] = "EVM";
    ChainEnum["Flow"] = "FLOW";
    ChainEnum["Sol"] = "SOL";
    ChainEnum["Algo"] = "ALGO";
    ChainEnum["Stark"] = "STARK";
    ChainEnum["Cosmos"] = "COSMOS";
    ChainEnum["Btc"] = "BTC";
    ChainEnum["Eclipse"] = "ECLIPSE";
})(ChainEnum || (ChainEnum = {}));
function ChainEnumFromJSON(json) {
    return ChainEnumFromJSONTyped(json);
}
function ChainEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ChainEnumToJSON(value) {
    return value;
}

function PasskeyRegistrationCredentialToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attestationObject': value.attestationObject,
        'clientDataJson': value.clientDataJson,
        'credentialId': value.credentialId,
        'transports': (value.transports.map(AuthenticatorTransportProtocolToJSON)),
    };
}

function CompletePasskeyRecoveryRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'walletId': value.walletId,
        'attestation': PasskeyRegistrationCredentialToJSON(value.attestation),
        'challenge': value.challenge,
    };
}

function ConnectRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': value.address,
        'chain': ChainEnumToJSON(value.chain),
        'provider': WalletProviderEnumToJSON(value.provider),
        'walletName': value.walletName,
        'authMode': AuthModeEnumToJSON(value.authMode),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var EmbeddedWalletChainEnum;
(function (EmbeddedWalletChainEnum) {
    EmbeddedWalletChainEnum["Evm"] = "EVM";
    EmbeddedWalletChainEnum["Sol"] = "SOL";
})(EmbeddedWalletChainEnum || (EmbeddedWalletChainEnum = {}));
function EmbeddedWalletChainEnumToJSON(value) {
    return value;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var EmbeddedWalletProviderEnum;
(function (EmbeddedWalletProviderEnum) {
    EmbeddedWalletProviderEnum["Turnkey"] = "turnkey";
    EmbeddedWalletProviderEnum["Turnkeyhd"] = "turnkeyhd";
    EmbeddedWalletProviderEnum["DynamicWaas"] = "dynamicWaas";
})(EmbeddedWalletProviderEnum || (EmbeddedWalletProviderEnum = {}));
function EmbeddedWalletProviderEnumToJSON(value) {
    return value;
}

function CreateTurnkeyEmbeddedWalletSpecificOptsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'attestation': PasskeyRegistrationCredentialToJSON(value.attestation),
        'challenge': value.challenge,
    };
}

function CreateEmbeddedWalletSpecificOptsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return Object.assign({}, CreateTurnkeyEmbeddedWalletSpecificOptsToJSON(value));
}

function CreateEmbeddedWalletParamsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chains': value.chains === undefined ? undefined : (value.chains.map(EmbeddedWalletChainEnumToJSON)),
        'chain': EmbeddedWalletChainEnumToJSON(value.chain),
        'embeddedWalletProvider': EmbeddedWalletProviderEnumToJSON(value.embeddedWalletProvider),
        'embeddedWalletSpecificOpts': CreateEmbeddedWalletSpecificOptsToJSON(value.embeddedWalletSpecificOpts),
        'isAuthenticatorAttached': value.isAuthenticatorAttached,
        'passkeyAlias': value.passkeyAlias,
        'sessionPublicKey': value.sessionPublicKey,
    };
}

function CreateEmbeddedWalletsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'embeddedWallets': (value.embeddedWallets.map(CreateEmbeddedWalletParamsToJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var UserIdentifierTypeEnum;
(function (UserIdentifierTypeEnum) {
    UserIdentifierTypeEnum["Email"] = "email";
    UserIdentifierTypeEnum["Id"] = "id";
    UserIdentifierTypeEnum["ExternalUserId"] = "externalUserId";
    UserIdentifierTypeEnum["PhoneNumber"] = "phoneNumber";
    UserIdentifierTypeEnum["SocialUsername"] = "socialUsername";
})(UserIdentifierTypeEnum || (UserIdentifierTypeEnum = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ThresholdSignatureScheme;
(function (ThresholdSignatureScheme) {
    ThresholdSignatureScheme["TwoOfTwo"] = "TWO_OF_TWO";
    ThresholdSignatureScheme["TwoOfThree"] = "TWO_OF_THREE";
    ThresholdSignatureScheme["ThreeOfFive"] = "THREE_OF_FIVE";
})(ThresholdSignatureScheme || (ThresholdSignatureScheme = {}));
function ThresholdSignatureSchemeToJSON(value) {
    return value;
}

function CreateWaasAccountRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chain': ChainEnumToJSON(value.chain),
        'clientKeygenIds': value.clientKeygenIds,
        'thresholdSignatureScheme': ThresholdSignatureSchemeToJSON(value.thresholdSignatureScheme),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function TurnkeyStampToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'stampHeaderName': value.stampHeaderName,
        'stampHeaderValue': value.stampHeaderValue,
    };
}

function TurnkeySignedRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'body': value.body,
        'stamp': TurnkeyStampToJSON(value.stamp),
        'url': value.url,
    };
}

function CreateWalletAccountRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'turnkeySignedRequest': TurnkeySignedRequestToJSON(value.turnkeySignedRequest),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var CurrencyType;
(function (CurrencyType) {
    CurrencyType["Fiat"] = "fiat";
    CurrencyType["Crypto"] = "crypto";
})(CurrencyType || (CurrencyType = {}));
function CurrencyTypeFromJSON(json) {
    return CurrencyTypeFromJSONTyped(json);
}
function CurrencyTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
function CurrencyFromJSON(json) {
    return CurrencyFromJSONTyped(json);
}
function CurrencyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'symbol': json['symbol'],
        'type': CurrencyTypeFromJSON(json['type']),
        'code': json['code'],
        'value': json['value'],
    };
}

function DeleteEmbeddedWalletsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'turnkeySignedRequest': TurnkeySignedRequestToJSON(value.turnkeySignedRequest),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var TimeUnitEnum;
(function (TimeUnitEnum) {
    TimeUnitEnum["Days"] = "days";
    TimeUnitEnum["Hours"] = "hours";
    TimeUnitEnum["Minutes"] = "minutes";
})(TimeUnitEnum || (TimeUnitEnum = {}));
function TimeUnitEnumFromJSON(json) {
    return TimeUnitEnumFromJSONTyped(json);
}
function TimeUnitEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
function EmailProviderResponseFromJSON(json) {
    return EmailProviderResponseFromJSONTyped(json);
}
function EmailProviderResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'emailProvider': ProviderEnumFromJSON(json['emailProvider']),
    };
}

function EmailVerificationCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'captchaToken': value.captchaToken,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function EmailVerificationCreateResponseFromJSON(json) {
    return EmailVerificationCreateResponseFromJSONTyped(json);
}
function EmailVerificationCreateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'verificationUUID': json['verificationUUID'],
        'email': json['email'],
    };
}

function EmailVerificationRetryRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'verificationUUID': value.verificationUUID,
        'email': value.email,
        'captchaToken': value.captchaToken,
    };
}

function EmailVerificationVerifyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'verificationUUID': value.verificationUUID,
        'verificationToken': value.verificationToken,
        'captchaToken': value.captchaToken,
        'sessionPublicKey': value.sessionPublicKey,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function EmbeddedWalletAuthTokenFromJSON(json) {
    return EmbeddedWalletAuthTokenFromJSONTyped(json);
}
function EmbeddedWalletAuthTokenFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'token': json['token'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var EmbeddedWalletAuthType;
(function (EmbeddedWalletAuthType) {
    EmbeddedWalletAuthType["Mpc"] = "mpc";
})(EmbeddedWalletAuthType || (EmbeddedWalletAuthType = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function EmbeddedWalletPasscodeClaimRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'walletId': value.walletId,
    };
}

/* tslint:disable */
function EmbeddedWalletSecretFromJSON(json) {
    return EmbeddedWalletSecretFromJSONTyped(json);
}
function EmbeddedWalletSecretFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'walletId': json['walletId'],
        'secret': json['secret'],
        'source': !exists(json, 'source') ? undefined : PasswordSourceTypeEnumFromJSON(json['source']),
    };
}

/* tslint:disable */
function NameServiceDataFromJSON(json) {
    return NameServiceDataFromJSONTyped(json);
}
function NameServiceDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'avatar': !exists(json, 'avatar') ? undefined : json['avatar'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

/* tslint:disable */
function WalletAdditionalAddressFromJSON(json) {
    return WalletAdditionalAddressFromJSONTyped(json);
}
function WalletAdditionalAddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': json['address'],
        'publicKey': !exists(json, 'publicKey') ? undefined : json['publicKey'],
        'type': WalletAddressTypeFromJSON(json['type']),
    };
}
function WalletAdditionalAddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': value.address,
        'publicKey': value.publicKey,
        'type': WalletAddressTypeToJSON(value.type),
    };
}

/* tslint:disable */
function WalletPropertiesFromJSON(json) {
    return WalletPropertiesFromJSONTyped(json);
}
function WalletPropertiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'turnkeySubOrganizationId': !exists(json, 'turnkeySubOrganizationId') ? undefined : json['turnkeySubOrganizationId'],
        'turnkeyPrivateKeyId': !exists(json, 'turnkeyPrivateKeyId') ? undefined : json['turnkeyPrivateKeyId'],
        'turnkeyHDWalletId': !exists(json, 'turnkeyHDWalletId') ? undefined : json['turnkeyHDWalletId'],
        'isAuthenticatorAttached': !exists(json, 'isAuthenticatorAttached') ? undefined : json['isAuthenticatorAttached'],
        'turnkeyUserId': !exists(json, 'turnkeyUserId') ? undefined : json['turnkeyUserId'],
        'isSessionKeyCompatible': !exists(json, 'isSessionKeyCompatible') ? undefined : json['isSessionKeyCompatible'],
        'version': !exists(json, 'version') ? undefined : EmbeddedWalletVersionEnumFromJSON(json['version']),
        'ecdsaProviderType': !exists(json, 'ecdsaProviderType') ? undefined : EcdsaValidatorOptionsFromJSON(json['ecdsaProviderType']),
        'entryPointVersion': !exists(json, 'entryPointVersion') ? undefined : ProviderEntryPointVersionEnumFromJSON(json['entryPointVersion']),
        'kernelVersion': !exists(json, 'kernelVersion') ? undefined : ProviderKernelVersionEnumFromJSON(json['kernelVersion']),
        'hardwareWallet': !exists(json, 'hardwareWallet') ? undefined : HardwareWalletEnumFromJSON(json['hardwareWallet']),
        'claimed': !exists(json, 'claimed') ? undefined : json['claimed'],
        'source': !exists(json, 'source') ? undefined : PasswordSourceTypeEnumFromJSON(json['source']),
        'keyShares': !exists(json, 'keyShares') ? undefined : (json['keyShares'].map(WalletKeyShareInfoFromJSON)),
    };
}

/* tslint:disable */
function JwtVerifiedCredentialFromJSON(json) {
    return JwtVerifiedCredentialFromJSONTyped(json);
}
function JwtVerifiedCredentialFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': !exists(json, 'address') ? undefined : json['address'],
        'chain': !exists(json, 'chain') ? undefined : json['chain'],
        'refId': !exists(json, 'refId') ? undefined : json['refId'],
        'signerRefId': !exists(json, 'signerRefId') ? undefined : json['signerRefId'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'id': json['id'],
        'nameService': !exists(json, 'name_service') ? undefined : NameServiceDataFromJSON(json['name_service']),
        'publicIdentifier': !exists(json, 'public_identifier') ? undefined : json['public_identifier'],
        'walletName': !exists(json, 'wallet_name') ? undefined : json['wallet_name'],
        'walletProvider': !exists(json, 'wallet_provider') ? undefined : WalletProviderEnumFromJSON(json['wallet_provider']),
        'walletProperties': !exists(json, 'wallet_properties') ? undefined : WalletPropertiesFromJSON(json['wallet_properties']),
        'format': JwtVerifiedCredentialFormatEnumFromJSON(json['format']),
        'oauthProvider': !exists(json, 'oauth_provider') ? undefined : ProviderEnumFromJSON(json['oauth_provider']),
        'oauthUsername': !exists(json, 'oauth_username') ? undefined : json['oauth_username'],
        'oauthDisplayName': !exists(json, 'oauth_display_name') ? undefined : json['oauth_display_name'],
        'oauthAccountId': !exists(json, 'oauth_account_id') ? undefined : json['oauth_account_id'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'phoneCountryCode': !exists(json, 'phoneCountryCode') ? undefined : json['phoneCountryCode'],
        'isoCountryCode': !exists(json, 'isoCountryCode') ? undefined : json['isoCountryCode'],
        'oauthAccountPhotos': !exists(json, 'oauth_account_photos') ? undefined : json['oauth_account_photos'],
        'oauthEmails': !exists(json, 'oauth_emails') ? undefined : json['oauth_emails'],
        'oauthMetadata': !exists(json, 'oauth_metadata') ? undefined : json['oauth_metadata'],
        'previousUsers': !exists(json, 'previous_users') ? undefined : json['previous_users'],
        'embeddedWalletId': !exists(json, 'embedded_wallet_id') ? undefined : json['embedded_wallet_id'],
        'walletAdditionalAddresses': !exists(json, 'wallet_additional_addresses') ? undefined : (json['wallet_additional_addresses'].map(WalletAdditionalAddressFromJSON)),
        'lastSelectedAt': !exists(json, 'lastSelectedAt') ? undefined : (new Date(json['lastSelectedAt'])),
        'signInEnabled': json['signInEnabled'],
    };
}

/* tslint:disable */
function CustomFieldValidValueFromJSON(json) {
    return CustomFieldValidValueFromJSONTyped(json);
}
function CustomFieldValidValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'label': json['label'],
        'key': !exists(json, 'key') ? undefined : json['key'],
    };
}

/* tslint:disable */
function CustomFieldValidationRulesFromJSON(json) {
    return CustomFieldValidationRulesFromJSONTyped(json);
}
function CustomFieldValidationRulesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'unique': !exists(json, 'unique') ? undefined : json['unique'],
        'regex': !exists(json, 'regex') ? undefined : json['regex'],
        'validOptions': !exists(json, 'validOptions') ? undefined : (json['validOptions'].map(CustomFieldValidValueFromJSON)),
        'checkboxText': !exists(json, 'checkboxText') ? undefined : json['checkboxText'],
    };
}

/* tslint:disable */
function ProjectSettingsKycFromJSON(json) {
    return ProjectSettingsKycFromJSONTyped(json);
}
function ProjectSettingsKycFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'required': json['required'],
        'enabled': json['enabled'],
        'unique': json['unique'],
        'verify': json['verify'],
        'type': !exists(json, 'type') ? undefined : KycFieldTypeFromJSON(json['type']),
        'validationRules': !exists(json, 'validationRules') ? undefined : CustomFieldValidationRulesFromJSON(json['validationRules']),
        'validationType': !exists(json, 'validationType') ? undefined : CustomFieldTypeFromJSON(json['validationType']),
        'label': !exists(json, 'label') ? undefined : json['label'],
        'position': !exists(json, 'position') ? undefined : json['position'],
    };
}

/* tslint:disable */
function SdkUserFromJSON(json) {
    return SdkUserFromJSONTyped(json);
}
function SdkUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'projectEnvironmentId': json['projectEnvironmentId'],
        'verifiedCredentials': (json['verifiedCredentials'].map(JwtVerifiedCredentialFromJSON)),
        'lastVerifiedCredentialId': !exists(json, 'lastVerifiedCredentialId') ? undefined : json['lastVerifiedCredentialId'],
        'sessionId': !exists(json, 'sessionId') ? undefined : json['sessionId'],
        'alias': !exists(json, 'alias') ? undefined : json['alias'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'jobTitle': !exists(json, 'jobTitle') ? undefined : json['jobTitle'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'policiesConsent': !exists(json, 'policiesConsent') ? undefined : json['policiesConsent'],
        'tShirtSize': !exists(json, 'tShirtSize') ? undefined : json['tShirtSize'],
        'team': !exists(json, 'team') ? undefined : json['team'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'firstVisit': !exists(json, 'firstVisit') ? undefined : (new Date(json['firstVisit'])),
        'lastVisit': !exists(json, 'lastVisit') ? undefined : (new Date(json['lastVisit'])),
        'newUser': !exists(json, 'newUser') ? undefined : json['newUser'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'mfaBackupCodeAcknowledgement': !exists(json, 'mfaBackupCodeAcknowledgement') ? undefined : MfaBackupCodeAcknowledgementFromJSON(json['mfaBackupCodeAcknowledgement']),
        'btcWallet': !exists(json, 'btcWallet') ? undefined : json['btcWallet'],
        'kdaWallet': !exists(json, 'kdaWallet') ? undefined : json['kdaWallet'],
        'ltcWallet': !exists(json, 'ltcWallet') ? undefined : json['ltcWallet'],
        'ckbWallet': !exists(json, 'ckbWallet') ? undefined : json['ckbWallet'],
        'kasWallet': !exists(json, 'kasWallet') ? undefined : json['kasWallet'],
        'dogeWallet': !exists(json, 'dogeWallet') ? undefined : json['dogeWallet'],
        'emailNotification': !exists(json, 'emailNotification') ? undefined : json['emailNotification'],
        'discordNotification': !exists(json, 'discordNotification') ? undefined : json['discordNotification'],
        'newsletterNotification': !exists(json, 'newsletterNotification') ? undefined : json['newsletterNotification'],
        'lists': !exists(json, 'lists') ? undefined : json['lists'],
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
        'missingFields': !exists(json, 'missingFields') ? undefined : (json['missingFields'].map(ProjectSettingsKycFromJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var EmbeddedWalletSecurityMethod;
(function (EmbeddedWalletSecurityMethod) {
    EmbeddedWalletSecurityMethod["Passkey"] = "passkey";
    EmbeddedWalletSecurityMethod["Passphrase"] = "passphrase";
})(EmbeddedWalletSecurityMethod || (EmbeddedWalletSecurityMethod = {}));
function EmbeddedWalletSecurityMethodFromJSON(json) {
    return EmbeddedWalletSecurityMethodFromJSONTyped(json);
}
function EmbeddedWalletSecurityMethodFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var EnvironmentEnum;
(function (EnvironmentEnum) {
    EnvironmentEnum["Sandbox"] = "sandbox";
    EnvironmentEnum["Live"] = "live";
})(EnvironmentEnum || (EnvironmentEnum = {}));
function EnvironmentEnumFromJSON(json) {
    return EnvironmentEnumFromJSONTyped(json);
}
function EnvironmentEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ExportEmbeddedWalletResponseFromJSON(json) {
    return ExportEmbeddedWalletResponseFromJSONTyped(json);
}
function ExportEmbeddedWalletResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'exportBundle': json['exportBundle'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ExportWaasWalletPrivateKeyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'exportId': value.exportId,
    };
}

function ExternalAuthSigninRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'jwt': value.jwt,
        'sessionPublicKey': value.sessionPublicKey,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ExternalWalletFundingDefaultChain;
(function (ExternalWalletFundingDefaultChain) {
    ExternalWalletFundingDefaultChain["Ethereum"] = "ethereum";
    ExternalWalletFundingDefaultChain["Solana"] = "solana";
})(ExternalWalletFundingDefaultChain || (ExternalWalletFundingDefaultChain = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ExternalWalletFundingTokenRule;
(function (ExternalWalletFundingTokenRule) {
    ExternalWalletFundingTokenRule["Recommended"] = "recommended";
    ExternalWalletFundingTokenRule["Exact"] = "exact";
})(ExternalWalletFundingTokenRule || (ExternalWalletFundingTokenRule = {}));
function ExternalWalletFundingTokenRuleFromJSON(json) {
    return ExternalWalletFundingTokenRuleFromJSONTyped(json);
}
function ExternalWalletFundingTokenRuleFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

function FarcasterSignInRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': value.address,
        'domain': value.domain,
        'nonce': value.nonce,
        'message': value.message,
        'signature': value.signature,
        'captchaToken': value.captchaToken,
        'sessionPublicKey': value.sessionPublicKey,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var OnrampProviders;
(function (OnrampProviders) {
    OnrampProviders["Banxa"] = "banxa";
})(OnrampProviders || (OnrampProviders = {}));
function OnrampProvidersFromJSON(json) {
    return OnrampProvidersFromJSONTyped(json);
}
function OnrampProvidersFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var GetAccountBalancesNetworkIdEnum;
(function (GetAccountBalancesNetworkIdEnum) {
    GetAccountBalancesNetworkIdEnum[GetAccountBalancesNetworkIdEnum["NUMBER_0"] = 0] = "NUMBER_0";
    GetAccountBalancesNetworkIdEnum[GetAccountBalancesNetworkIdEnum["NUMBER_1"] = 1] = "NUMBER_1";
    GetAccountBalancesNetworkIdEnum[GetAccountBalancesNetworkIdEnum["NUMBER_10"] = 10] = "NUMBER_10";
    GetAccountBalancesNetworkIdEnum[GetAccountBalancesNetworkIdEnum["NUMBER_101"] = 101] = "NUMBER_101";
    GetAccountBalancesNetworkIdEnum[GetAccountBalancesNetworkIdEnum["NUMBER_103"] = 103] = "NUMBER_103";
    GetAccountBalancesNetworkIdEnum[GetAccountBalancesNetworkIdEnum["NUMBER_137"] = 137] = "NUMBER_137";
    GetAccountBalancesNetworkIdEnum[GetAccountBalancesNetworkIdEnum["NUMBER_42161"] = 42161] = "NUMBER_42161";
    GetAccountBalancesNetworkIdEnum[GetAccountBalancesNetworkIdEnum["NUMBER_8453"] = 8453] = "NUMBER_8453";
})(GetAccountBalancesNetworkIdEnum || (GetAccountBalancesNetworkIdEnum = {}));

/* tslint:disable */
function PasskeyStorageFromJSON(json) {
    return PasskeyStorageFromJSONTyped(json);
}
function PasskeyStorageFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'icon': json['icon'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}

/* tslint:disable */
function UserPasskeyFromJSON(json) {
    return UserPasskeyFromJSONTyped(json);
}
function UserPasskeyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'alias': !exists(json, 'alias') ? undefined : json['alias'],
        'userAgent': !exists(json, 'userAgent') ? undefined : json['userAgent'],
        'origin': !exists(json, 'origin') ? undefined : json['origin'],
        'credentialId': json['credentialId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'storage': !exists(json, 'storage') ? undefined : PasskeyStorageFromJSON(json['storage']),
    };
}

/* tslint:disable */
function GetUserPasskeysResponseFromJSON(json) {
    return GetUserPasskeysResponseFromJSONTyped(json);
}
function GetUserPasskeysResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'passkeys': (json['passkeys'].map(UserPasskeyFromJSON)),
        'count': json['count'],
    };
}

/* tslint:disable */
function GlobalWalletSettingsFromJSON(json) {
    return GlobalWalletSettingsFromJSONTyped(json);
}
function GlobalWalletSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'walletName': json['walletName'],
        'popupPageTitle': !exists(json, 'popupPageTitle') ? undefined : json['popupPageTitle'],
        'walletIconUrl': !exists(json, 'walletIconUrl') ? undefined : json['walletIconUrl'],
        'customCssUrl': !exists(json, 'customCssUrl') ? undefined : json['customCssUrl'],
        'enabledAt': !exists(json, 'enabledAt') ? undefined : (json['enabledAt'] === null ? null : new Date(json['enabledAt'])),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var HealthcheckStatus;
(function (HealthcheckStatus) {
    HealthcheckStatus["Healthy"] = "healthy";
    HealthcheckStatus["Unhealthy"] = "unhealthy";
})(HealthcheckStatus || (HealthcheckStatus = {}));
function HealthcheckStatusFromJSON(json) {
    return HealthcheckStatusFromJSONTyped(json);
}
function HealthcheckStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
function HealthcheckResponseFromJSON(json) {
    return HealthcheckResponseFromJSONTyped(json);
}
function HealthcheckResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': HealthcheckStatusFromJSON(json['status']),
    };
}

function ImportWaasPrivateKeyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chain': ChainEnumToJSON(value.chain),
        'clientKeygenIds': value.clientKeygenIds,
        'thresholdSignatureScheme': ThresholdSignatureSchemeToJSON(value.thresholdSignatureScheme),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function InitEmailAuthRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'walletId': value.walletId,
        'turnkeyEmailAuthTargetPublicKey': value.turnkeyEmailAuthTargetPublicKey,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function InitEmailAuthResponseFromJSON(json) {
    return InitEmailAuthResponseFromJSONTyped(json);
}
function InitEmailAuthResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'turnkeyUserId': json['turnkeyUserId'],
        'turnkeyApiKeyId': json['turnkeyApiKeyId'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function InitPasskeyRecoveryRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'walletId': value.walletId,
        'turnkeyRecoveryTargetPublicKey': value.turnkeyRecoveryTargetPublicKey,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function InitPasskeyRecoveryResponseFromJSON(json) {
    return InitPasskeyRecoveryResponseFromJSONTyped(json);
}
function InitPasskeyRecoveryResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'turnkeyRecoveryUserId': json['turnkeyRecoveryUserId'],
    };
}

/* tslint:disable */
function JwksKeyFromJSON(json) {
    return JwksKeyFromJSONTyped(json);
}
function JwksKeyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'kid': !exists(json, 'kid') ? undefined : json['kid'],
        'alg': !exists(json, 'alg') ? undefined : json['alg'],
        'kty': !exists(json, 'kty') ? undefined : json['kty'],
        'use': !exists(json, 'use') ? undefined : json['use'],
        'e': !exists(json, 'e') ? undefined : json['e'],
        'n': !exists(json, 'n') ? undefined : json['n'],
    };
}

/* tslint:disable */
function JwksResponseFromJSON(json) {
    return JwksResponseFromJSONTyped(json);
}
function JwksResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'keys': (json['keys'].map(JwksKeyFromJSON)),
    };
}

/* tslint:disable */
function AuthenticationExtensionsClientInputsFromJSON(json) {
    return AuthenticationExtensionsClientInputsFromJSONTyped(json);
}
function AuthenticationExtensionsClientInputsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'appid': !exists(json, 'appid') ? undefined : json['appid'],
        'credProps': !exists(json, 'credProps') ? undefined : json['credProps'],
        'hmacCreateSecret': !exists(json, 'hmacCreateSecret') ? undefined : json['hmacCreateSecret'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var PublicKeyCredentialType;
(function (PublicKeyCredentialType) {
    PublicKeyCredentialType["PublicKey"] = "public-key";
})(PublicKeyCredentialType || (PublicKeyCredentialType = {}));
function PublicKeyCredentialTypeFromJSON(json) {
    return PublicKeyCredentialTypeFromJSONTyped(json);
}
function PublicKeyCredentialTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PublicKeyCredentialTypeToJSON(value) {
    return value;
}

/* tslint:disable */
function PublicKeyCredentialDescriptorFromJSON(json) {
    return PublicKeyCredentialDescriptorFromJSONTyped(json);
}
function PublicKeyCredentialDescriptorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'type': PublicKeyCredentialTypeFromJSON(json['type']),
    };
}

/* tslint:disable */
function MFAAuthPasskeyDeviceGetResponseAssertionFromJSON(json) {
    return MFAAuthPasskeyDeviceGetResponseAssertionFromJSONTyped(json);
}
function MFAAuthPasskeyDeviceGetResponseAssertionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rpId': !exists(json, 'rpId') ? undefined : json['rpId'],
        'challenge': json['challenge'],
        'timeout': !exists(json, 'timeout') ? undefined : json['timeout'],
        'userVerification': !exists(json, 'userVerification') ? undefined : UserVerificationRequirementFromJSON(json['userVerification']),
        'allowCredentials': !exists(json, 'allowCredentials') ? undefined : (json['allowCredentials'].map(PublicKeyCredentialDescriptorFromJSON)),
        'extensions': !exists(json, 'extensions') ? undefined : AuthenticationExtensionsClientInputsFromJSON(json['extensions']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var MFADeviceType;
(function (MFADeviceType) {
    MFADeviceType["Totp"] = "totp";
    MFADeviceType["Passkey"] = "passkey";
})(MFADeviceType || (MFADeviceType = {}));
function MFADeviceTypeFromJSON(json) {
    return MFADeviceTypeFromJSONTyped(json);
}
function MFADeviceTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function MFADeviceTypeToJSON(value) {
    return value;
}

/* tslint:disable */
function MFAAuthPasskeyDeviceGetResponseFromJSON(json) {
    return MFAAuthPasskeyDeviceGetResponseFromJSONTyped(json);
}
function MFAAuthPasskeyDeviceGetResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'type': MFADeviceTypeFromJSON(json['type']),
        'assertion': MFAAuthPasskeyDeviceGetResponseAssertionFromJSON(json['assertion']),
    };
}

function AuthenticationExtensionsClientOutputsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'appid': value.appid,
        'credProps': value.credProps,
        'hmacCreateSecret': value.hmacCreateSecret,
    };
}

function AuthenticatorAssertionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'clientDataJSON': value.clientDataJSON,
        'authenticatorData': value.authenticatorData,
        'signature': value.signature,
        'userHandle': value.userHandle,
    };
}

function PasskeyAuthRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'rawId': value.rawId,
        'response': AuthenticatorAssertionResponseToJSON(value.response),
        'authenticatorAttachment': AuthenticatorAttachmentToJSON(value.authenticatorAttachment),
        'clientExtensionResults': AuthenticationExtensionsClientOutputsToJSON(value.clientExtensionResults),
        'type': PublicKeyCredentialTypeToJSON(value.type),
    };
}

function MFAAuthPasskeyDevicePostRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'assertion': PasskeyAuthRequestToJSON(value.assertion),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function CreateMfaTokenToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'singleUse': value.singleUse,
    };
}

function MFAAuthRecoveryDevicePostRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createMfaToken': CreateMfaTokenToJSON(value.createMfaToken),
        'code': value.code,
    };
}

function MFAAuthTotpDevicePostRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createMfaToken': CreateMfaTokenToJSON(value.createMfaToken),
        'code': value.code,
    };
}

/* tslint:disable */
function MFADeviceFromJSON(json) {
    return MFADeviceFromJSONTyped(json);
}
function MFADeviceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !exists(json, 'type') ? undefined : MFADeviceTypeFromJSON(json['type']),
        'verified': !exists(json, 'verified') ? undefined : json['verified'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'verifiedAt': !exists(json, 'verifiedAt') ? undefined : (json['verifiedAt'] === null ? null : new Date(json['verifiedAt'])),
        '_default': !exists(json, 'default') ? undefined : json['default'],
        'alias': !exists(json, 'alias') ? undefined : json['alias'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function MFAGetRecoveryCodesResponseFromJSON(json) {
    return MFAGetRecoveryCodesResponseFromJSONTyped(json);
}
function MFAGetRecoveryCodesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': json['count'],
        'recoveryCodes': json['recoveryCodes'],
    };
}

/* tslint:disable */
function MFAListDevicesResponseFromJSON(json) {
    return MFAListDevicesResponseFromJSONTyped(json);
}
function MFAListDevicesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': json['count'],
        'devices': (json['devices'].map(MFADeviceFromJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function MFARegenRecoveryCodesResponseFromJSON(json) {
    return MFARegenRecoveryCodesResponseFromJSONTyped(json);
}
function MFARegenRecoveryCodesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': json['count'],
        'recoveryCodes': json['recoveryCodes'],
    };
}

/* tslint:disable */
function AuthenticatorSelectionCriteriaFromJSON(json) {
    return AuthenticatorSelectionCriteriaFromJSONTyped(json);
}
function AuthenticatorSelectionCriteriaFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'authenticatorAttachment': !exists(json, 'authenticatorAttachment') ? undefined : AuthenticatorAttachmentFromJSON(json['authenticatorAttachment']),
        'requireResidentKey': !exists(json, 'requireResidentKey') ? undefined : json['requireResidentKey'],
        'residentKey': !exists(json, 'residentKey') ? undefined : ResidentKeyRequirementFromJSON(json['residentKey']),
        'userVerification': !exists(json, 'userVerification') ? undefined : UserVerificationRequirementFromJSON(json['userVerification']),
    };
}

/* tslint:disable */
function PublicKeyCredentialParametersFromJSON(json) {
    return PublicKeyCredentialParametersFromJSONTyped(json);
}
function PublicKeyCredentialParametersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'alg': json['alg'],
        'type': PublicKeyCredentialTypeFromJSON(json['type']),
    };
}

/* tslint:disable */
function PublicKeyCredentialRpEntityFromJSON(json) {
    return PublicKeyCredentialRpEntityFromJSONTyped(json);
}
function PublicKeyCredentialRpEntityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PublicKeyCredentialUserEntityFromJSON(json) {
    return PublicKeyCredentialUserEntityFromJSONTyped(json);
}
function PublicKeyCredentialUserEntityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'displayName': json['displayName'],
    };
}

/* tslint:disable */
function MFARegisterPasskeyDeviceGetResponseRegistrationFromJSON(json) {
    return MFARegisterPasskeyDeviceGetResponseRegistrationFromJSONTyped(json);
}
function MFARegisterPasskeyDeviceGetResponseRegistrationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'attestation': !exists(json, 'attestation') ? undefined : AttestationConveyancePreferenceFromJSON(json['attestation']),
        'rp': PublicKeyCredentialRpEntityFromJSON(json['rp']),
        'user': PublicKeyCredentialUserEntityFromJSON(json['user']),
        'challenge': json['challenge'],
        'pubKeyCredParams': (json['pubKeyCredParams'].map(PublicKeyCredentialParametersFromJSON)),
        'timeout': !exists(json, 'timeout') ? undefined : json['timeout'],
        'authenticatorSelection': !exists(json, 'authenticatorSelection') ? undefined : AuthenticatorSelectionCriteriaFromJSON(json['authenticatorSelection']),
        'excludeCredentials': !exists(json, 'excludeCredentials') ? undefined : (json['excludeCredentials'].map(PublicKeyCredentialDescriptorFromJSON)),
        'extensions': !exists(json, 'extensions') ? undefined : AuthenticationExtensionsClientInputsFromJSON(json['extensions']),
    };
}

/* tslint:disable */
function MFARegisterPasskeyDeviceGetResponseFromJSON(json) {
    return MFARegisterPasskeyDeviceGetResponseFromJSONTyped(json);
}
function MFARegisterPasskeyDeviceGetResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'type': MFADeviceTypeFromJSON(json['type']),
        'registration': MFARegisterPasskeyDeviceGetResponseRegistrationFromJSON(json['registration']),
    };
}

function AuthenticatorAttestationResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'clientDataJSON': value.clientDataJSON,
        'attestationObject': value.attestationObject,
        'authenticatorData': value.authenticatorData,
        'publicKeyAlgorithm': value.publicKeyAlgorithm,
        'publicKey': value.publicKey,
    };
}

function PasskeyRegisterVerifyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'rawId': value.rawId,
        'response': AuthenticatorAttestationResponseToJSON(value.response),
        'authenticatorAttachment': AuthenticatorAttachmentToJSON(value.authenticatorAttachment),
        'clientExtensionResults': AuthenticationExtensionsClientOutputsToJSON(value.clientExtensionResults),
        'type': PublicKeyCredentialTypeToJSON(value.type),
    };
}

function MFARegisterPasskeyDevicePostRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'attestation': PasskeyRegisterVerifyRequestToJSON(value.attestation),
    };
}

/* tslint:disable */
function MFARegisterTotpDeviceGetResponseFromJSON(json) {
    return MFARegisterTotpDeviceGetResponseFromJSONTyped(json);
}
function MFARegisterTotpDeviceGetResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'type': MFADeviceTypeFromJSON(json['type']),
        'secret': json['secret'],
        'uri': json['uri'],
    };
}

function MFARegisterTotpDevicePostRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': MFADeviceTypeToJSON(value.type),
        'code': value.code,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function MFAUpdateDeviceRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'default': value._default,
    };
}

function MergeUserConflictResolutionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'fieldKey': value.fieldKey,
        'type': KycFieldTypeToJSON(value.type),
    };
}

function MergeUserConflictResolutionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mergeUserResolutions': value.mergeUserResolutions === undefined ? undefined : (value.mergeUserResolutions.map(MergeUserConflictResolutionToJSON)),
    };
}

/* tslint:disable */
/**
* @export
* @enum {string}
*/
var NetworkTypeEnum;
(function (NetworkTypeEnum) {
    NetworkTypeEnum["Custom"] = "custom";
    NetworkTypeEnum["Default"] = "default";
})(NetworkTypeEnum || (NetworkTypeEnum = {}));
function NetworkFromJSON(json) {
    return NetworkFromJSONTyped(json);
}
function NetworkFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'networkId': json['networkId'],
        'chainName': json['chainName'],
        'enabled': json['enabled'],
        'rpcUrl': !exists(json, 'rpcUrl') ? undefined : json['rpcUrl'],
        'iconUrl': !exists(json, 'iconUrl') ? undefined : json['iconUrl'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

/* tslint:disable */
function NameServiceFromJSON(json) {
    return NameServiceFromJSONTyped(json);
}
function NameServiceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'registry': !exists(json, 'registry') ? undefined : json['registry'],
    };
}

/* tslint:disable */
function NativeCurrencyFromJSON(json) {
    return NativeCurrencyFromJSONTyped(json);
}
function NativeCurrencyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'decimals': json['decimals'],
        'name': json['name'],
        'symbol': json['symbol'],
        'denom': !exists(json, 'denom') ? undefined : json['denom'],
        'iconUrl': !exists(json, 'iconUrl') ? undefined : json['iconUrl'],
        'pricingProviderTokenId': !exists(json, 'pricingProviderTokenId') ? undefined : json['pricingProviderTokenId'],
    };
}

/* tslint:disable */
function NetworkConfigurationFromJSON(json) {
    return NetworkConfigurationFromJSONTyped(json);
}
function NetworkConfigurationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'lcdUrl': !exists(json, 'lcdUrl') ? undefined : json['lcdUrl'],
        'chainName': !exists(json, 'chainName') ? undefined : json['chainName'],
        'name': json['name'],
        'shortName': json['shortName'],
        'chain': json['chain'],
        'chainId': json['chainId'],
        'nameService': !exists(json, 'nameService') ? undefined : NameServiceFromJSON(json['nameService']),
        'networkId': json['networkId'],
        'iconUrls': json['iconUrls'],
        'nativeCurrency': NativeCurrencyFromJSON(json['nativeCurrency']),
        'rpcUrls': json['rpcUrls'],
        'privateCustomerRpcUrls': !exists(json, 'privateCustomerRpcUrls') ? undefined : json['privateCustomerRpcUrls'],
        'blockExplorerUrls': json['blockExplorerUrls'],
        'vanityName': !exists(json, 'vanityName') ? undefined : json['vanityName'],
        'bech32Prefix': !exists(json, 'bech32Prefix') ? undefined : json['bech32Prefix'],
        'genesisHash': !exists(json, 'genesisHash') ? undefined : json['genesisHash'],
    };
}

/* tslint:disable */
function NetworkConfigurationResponseFromJSON(json) {
    return NetworkConfigurationResponseFromJSONTyped(json);
}
function NetworkConfigurationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chainName': !exists(json, 'chainName') ? undefined : json['chainName'],
        'networks': !exists(json, 'networks') ? undefined : (json['networks'].map(NetworkConfigurationFromJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var NextViewEnum;
(function (NextViewEnum) {
    NextViewEnum["Done"] = "done";
    NextViewEnum["VerifyEmail"] = "verify-email";
    NextViewEnum["VerifiedAndTransferred"] = "verified-and-transferred";
    NextViewEnum["VerifySms"] = "verify-sms";
})(NextViewEnum || (NextViewEnum = {}));
function NextViewEnumFromJSON(json) {
    return NextViewEnumFromJSONTyped(json);
}
function NextViewEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
function NonceResponseFromJSON(json) {
    return NonceResponseFromJSONTyped(json);
}
function NonceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nonce': !exists(json, 'nonce') ? undefined : json['nonce'],
    };
}

function OauthInitAuthRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'state': value.state,
        'redirectUrl': value.redirectUrl,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function OauthProviderLoginUrlFromJSON(json) {
    return OauthProviderLoginUrlFromJSONTyped(json);
}
function OauthProviderLoginUrlFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': json['url'],
    };
}

function OauthRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'codeVerifier': value.codeVerifier,
        'state': value.state,
        'captchaToken': value.captchaToken,
        'sessionPublicKey': value.sessionPublicKey,
    };
}

function OauthResultRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'state': value.state,
        'telegramAuthToken': value.telegramAuthToken,
        'forceCreateUser': value.forceCreateUser,
        'code': value.code,
        'sessionPublicKey': value.sessionPublicKey,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var OauthResultStatus;
(function (OauthResultStatus) {
    OauthResultStatus["Pending"] = "pending";
    OauthResultStatus["Completed"] = "completed";
})(OauthResultStatus || (OauthResultStatus = {}));
function OauthResultStatusFromJSON(json) {
    return OauthResultStatusFromJSONTyped(json);
}
function OauthResultStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
function OauthResultResponseFromJSON(json) {
    return OauthResultResponseFromJSONTyped(json);
}
function OauthResultResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !exists(json, 'code') ? undefined : json['code'],
        'error': !exists(json, 'error') ? undefined : json['error'],
        'status': OauthResultStatusFromJSON(json['status']),
    };
}

/* tslint:disable */
function OpenRoomResponseFromJSON(json) {
    return OpenRoomResponseFromJSONTyped(json);
}
function OpenRoomResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomId': json['roomId'],
        'serverKeygenIds': !exists(json, 'serverKeygenIds') ? undefined : json['serverKeygenIds'],
        'walletId': !exists(json, 'walletId') ? undefined : json['walletId'],
    };
}

/* tslint:disable */
function OpenRoomResponseWithServerKeygenIdsFromJSON(json) {
    return OpenRoomResponseWithServerKeygenIdsFromJSONTyped(json);
}
function OpenRoomResponseWithServerKeygenIdsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomId': json['roomId'],
        'serverKeygenIds': json['serverKeygenIds'],
        'walletId': !exists(json, 'walletId') ? undefined : json['walletId'],
    };
}

function PrefetchRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chain': ChainEnumToJSON(value.chain),
        'publicWalletAddress': value.publicWalletAddress,
    };
}

/* tslint:disable */
function ProjectSettingsChainsFromJSON(json) {
    return ProjectSettingsChainsFromJSONTyped(json);
}
function ProjectSettingsChainsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'enabled': json['enabled'],
        'networks': !exists(json, 'networks') ? undefined : (json['networks'].map(NetworkFromJSON)),
    };
}

/* tslint:disable */
function ProjectSettingsDesignButtonFromJSON(json) {
    return ProjectSettingsDesignButtonFromJSONTyped(json);
}
function ProjectSettingsDesignButtonFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'background': !exists(json, 'background') ? undefined : json['background'],
        'fontColor': !exists(json, 'fontColor') ? undefined : json['fontColor'],
        'paddingHeight': !exists(json, 'paddingHeight') ? undefined : json['paddingHeight'],
        'paddingWidth': !exists(json, 'paddingWidth') ? undefined : json['paddingWidth'],
        'radius': !exists(json, 'radius') ? undefined : json['radius'],
    };
}

/* tslint:disable */
function ProjectSettingsDesignModalFromJSON(json) {
    return ProjectSettingsDesignModalFromJSONTyped(json);
}
function ProjectSettingsDesignModalFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'border': !exists(json, 'border') ? undefined : json['border'],
        'brand': !exists(json, 'brand') ? undefined : json['brand'],
        'primaryColor': !exists(json, 'primaryColor') ? undefined : json['primaryColor'],
        'radius': !exists(json, 'radius') ? undefined : json['radius'],
        'theme': !exists(json, 'theme') ? undefined : json['theme'],
        'view': !exists(json, 'view') ? undefined : json['view'],
        'template': !exists(json, 'template') ? undefined : json['template'],
        'displayOrder': !exists(json, 'displayOrder') ? undefined : json['displayOrder'],
        'emailOnly': !exists(json, 'emailOnly') ? undefined : json['emailOnly'],
        'showWalletsButton': !exists(json, 'showWalletsButton') ? undefined : json['showWalletsButton'],
        'emailSubmitButtonInsideInput': !exists(json, 'emailSubmitButtonInsideInput') ? undefined : json['emailSubmitButtonInsideInput'],
        'splitEmailAndSocial': !exists(json, 'splitEmailAndSocial') ? undefined : json['splitEmailAndSocial'],
        'socialAboveEmail': !exists(json, 'socialAboveEmail') ? undefined : json['socialAboveEmail'],
    };
}

/* tslint:disable */
function ProjectSettingsDesignWidgetFromJSON(json) {
    return ProjectSettingsDesignWidgetFromJSONTyped(json);
}
function ProjectSettingsDesignWidgetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'border': !exists(json, 'border') ? undefined : json['border'],
        'radius': !exists(json, 'radius') ? undefined : json['radius'],
        'textColor': !exists(json, 'textColor') ? undefined : json['textColor'],
        'theme': !exists(json, 'theme') ? undefined : json['theme'],
    };
}

/* tslint:disable */
function ProjectSettingsDesignFromJSON(json) {
    return ProjectSettingsDesignFromJSONTyped(json);
}
function ProjectSettingsDesignFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'modal': !exists(json, 'modal') ? undefined : ProjectSettingsDesignModalFromJSON(json['modal']),
        'button': !exists(json, 'button') ? undefined : ProjectSettingsDesignButtonFromJSON(json['button']),
        'widget': !exists(json, 'widget') ? undefined : ProjectSettingsDesignWidgetFromJSON(json['widget']),
    };
}

/* tslint:disable */
function ProjectSettingsGeneralFromJSON(json) {
    return ProjectSettingsGeneralFromJSONTyped(json);
}
function ProjectSettingsGeneralFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'supportEmail': !exists(json, 'supportEmail') ? undefined : json['supportEmail'],
        'supportText': !exists(json, 'supportText') ? undefined : json['supportText'],
        'appLogo': !exists(json, 'appLogo') ? undefined : json['appLogo'],
        'imageUserNotInAccessList': !exists(json, 'imageUserNotInAccessList') ? undefined : json['imageUserNotInAccessList'],
        'imageUserInAccessList': !exists(json, 'imageUserInAccessList') ? undefined : json['imageUserInAccessList'],
        'supportUrls': !exists(json, 'supportUrls') ? undefined : json['supportUrls'],
        'collectUserDataWelcomeHeader': !exists(json, 'collectUserDataWelcomeHeader') ? undefined : json['collectUserDataWelcomeHeader'],
        'collectUserDataWelcomeMessage': !exists(json, 'collectUserDataWelcomeMessage') ? undefined : json['collectUserDataWelcomeMessage'],
        'skipOptionalKYCFieldDuringOnboarding': !exists(json, 'skipOptionalKYCFieldDuringOnboarding') ? undefined : json['skipOptionalKYCFieldDuringOnboarding'],
        'emailCompanyName': !exists(json, 'emailCompanyName') ? undefined : json['emailCompanyName'],
    };
}

/* tslint:disable */
function ProjectSettingsPrivacyFromJSON(json) {
    return ProjectSettingsPrivacyFromJSONTyped(json);
}
function ProjectSettingsPrivacyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'collectIp': !exists(json, 'collectIp') ? undefined : json['collectIp'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function FeatureFlagsFromJSON(json) {
    return FeatureFlagsFromJSONTyped(json);
}
function FeatureFlagsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'connectOnlyMultiAsset': json['connectOnlyMultiAsset'],
    };
}

/* tslint:disable */
function ExternalWalletFundingDefaultSettingsTokenFromJSON(json) {
    return ExternalWalletFundingDefaultSettingsTokenFromJSONTyped(json);
}
function ExternalWalletFundingDefaultSettingsTokenFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'value': !exists(json, 'value') ? undefined : json['value'],
        'rule': !exists(json, 'rule') ? undefined : ExternalWalletFundingTokenRuleFromJSON(json['rule']),
    };
}

/* tslint:disable */
function ExternalWalletFundingDefaultSettingsFromJSON(json) {
    return ExternalWalletFundingDefaultSettingsFromJSONTyped(json);
}
function ExternalWalletFundingDefaultSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chain': !exists(json, 'chain') ? undefined : ChainEnumFromJSON(json['chain']),
        'token': !exists(json, 'token') ? undefined : ExternalWalletFundingDefaultSettingsTokenFromJSON(json['token']),
    };
}

/* tslint:disable */
function FundingExternalWalletsDefaultSettingsFromJSON(json) {
    return FundingExternalWalletsDefaultSettingsFromJSONTyped(json);
}
function FundingExternalWalletsDefaultSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chainSettings': !exists(json, 'chainSettings') ? undefined : (json['chainSettings'].map(ExternalWalletFundingDefaultSettingsFromJSON)),
    };
}

/* tslint:disable */
function FundingExternalWalletsMinAmountFromJSON(json) {
    return FundingExternalWalletsMinAmountFromJSONTyped(json);
}
function FundingExternalWalletsMinAmountFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
    };
}

/* tslint:disable */
function FundingExternalWalletsFromJSON(json) {
    return FundingExternalWalletsFromJSONTyped(json);
}
function FundingExternalWalletsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enabled': json['enabled'],
        'minAmount': !exists(json, 'minAmount') ? undefined : FundingExternalWalletsMinAmountFromJSON(json['minAmount']),
        'defaultSettings': !exists(json, 'defaultSettings') ? undefined : FundingExternalWalletsDefaultSettingsFromJSON(json['defaultSettings']),
    };
}

/* tslint:disable */
function FundingFromJSON(json) {
    return FundingFromJSONTyped(json);
}
function FundingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'onramps': (json['onramps'].map(OnrampProvidersFromJSON)),
        'externalWallets': !exists(json, 'externalWallets') ? undefined : FundingExternalWalletsFromJSON(json['externalWallets']),
    };
}

/* tslint:disable */
function MobileSettingsFromJSON(json) {
    return MobileSettingsFromJSONTyped(json);
}
function MobileSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'deeplinkUrlsEnabled': !exists(json, 'deeplinkUrlsEnabled') ? undefined : json['deeplinkUrlsEnabled'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function NameServiceSdkSettingsEvmFromJSON(json) {
    return NameServiceSdkSettingsEvmFromJSONTyped(json);
}
function NameServiceSdkSettingsEvmFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'domain': json['domain'],
    };
}

/* tslint:disable */
function NameServiceSdkSettingsFromJSON(json) {
    return NameServiceSdkSettingsFromJSONTyped(json);
}
function NameServiceSdkSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'evm': NameServiceSdkSettingsEvmFromJSON(json['evm']),
    };
}

/* tslint:disable */
function ProjectSettingsSdkAccountAbstractionFromJSON(json) {
    return ProjectSettingsSdkAccountAbstractionFromJSONTyped(json);
}
function ProjectSettingsSdkAccountAbstractionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'allWallets': !exists(json, 'allWallets') ? undefined : json['allWallets'],
        'allUsers': !exists(json, 'allUsers') ? undefined : json['allUsers'],
        'separateSmartWalletAndSigner': !exists(json, 'separateSmartWalletAndSigner') ? undefined : json['separateSmartWalletAndSigner'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var SignInProviderEnum;
(function (SignInProviderEnum) {
    SignInProviderEnum["Dynamic"] = "dynamic";
    SignInProviderEnum["MagicLink"] = "magicLink";
    SignInProviderEnum["Blocto"] = "blocto";
    SignInProviderEnum["Turnkey"] = "turnkey";
    SignInProviderEnum["CoinbaseWaas"] = "coinbaseWaas";
})(SignInProviderEnum || (SignInProviderEnum = {}));
function SignInProviderEnumFromJSON(json) {
    return SignInProviderEnumFromJSONTyped(json);
}
function SignInProviderEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
function ProjectSettingsSdkEmailSignInFromJSON(json) {
    return ProjectSettingsSdkEmailSignInFromJSONTyped(json);
}
function ProjectSettingsSdkEmailSignInFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'signInProvider': !exists(json, 'signInProvider') ? undefined : SignInProviderEnumFromJSON(json['signInProvider']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ChainConfigurationFromJSON(json) {
    return ChainConfigurationFromJSONTyped(json);
}
function ChainConfigurationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'enabled': json['enabled'],
        'primary': json['primary'],
    };
}

/* tslint:disable */
function DurationFromJSON(json) {
    return DurationFromJSONTyped(json);
}
function DurationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'amount': json['amount'],
        'unit': TimeUnitEnumFromJSON(json['unit']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function SupportedSecurityMethodFromJSON(json) {
    return SupportedSecurityMethodFromJSONTyped(json);
}
function SupportedSecurityMethodFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isDefault': json['isDefault'],
        'isEnabled': json['isEnabled'],
        'isPermanentAuthenticator': json['isPermanentAuthenticator'],
        'listPosition': json['listPosition'],
    };
}

/* tslint:disable */
function SupportedSecurityMethodsFromJSON(json) {
    return SupportedSecurityMethodsFromJSONTyped(json);
}
function SupportedSecurityMethodsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'passkey': !exists(json, 'passkey') ? undefined : SupportedSecurityMethodFromJSON(json['passkey']),
        'email': !exists(json, 'email') ? undefined : SupportedSecurityMethodFromJSON(json['email']),
        'password': !exists(json, 'password') ? undefined : SupportedSecurityMethodFromJSON(json['password']),
    };
}

/* tslint:disable */
function ProjectSettingsSdkEmbeddedWalletsFromJSON(json) {
    return ProjectSettingsSdkEmbeddedWalletsFromJSONTyped(json);
}
function ProjectSettingsSdkEmbeddedWalletsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'automaticEmbeddedWalletCreation': !exists(json, 'automaticEmbeddedWalletCreation') ? undefined : json['automaticEmbeddedWalletCreation'],
        'automaticEmbeddedWalletCreationForExternal': !exists(json, 'automaticEmbeddedWalletCreationForExternal') ? undefined : json['automaticEmbeddedWalletCreationForExternal'],
        'showEmbeddedWalletActionsUI': !exists(json, 'showEmbeddedWalletActionsUI') ? undefined : json['showEmbeddedWalletActionsUI'],
        'emailRecoveryEnabled': !exists(json, 'emailRecoveryEnabled') ? undefined : json['emailRecoveryEnabled'],
        'forceAuthenticatorAtSignup': !exists(json, 'forceAuthenticatorAtSignup') ? undefined : json['forceAuthenticatorAtSignup'],
        'allowSkippingAuthenticatorAtSignup': !exists(json, 'allowSkippingAuthenticatorAtSignup') ? undefined : json['allowSkippingAuthenticatorAtSignup'],
        'sessionKeyDuration': !exists(json, 'sessionKeyDuration') ? undefined : DurationFromJSON(json['sessionKeyDuration']),
        'supportedSecurityMethods': !exists(json, 'supportedSecurityMethods') ? undefined : SupportedSecurityMethodsFromJSON(json['supportedSecurityMethods']),
        'chainConfigurations': !exists(json, 'chainConfigurations') ? undefined : (json['chainConfigurations'].map(ChainConfigurationFromJSON)),
        'domainEnabledByProvider': !exists(json, 'domainEnabledByProvider') ? undefined : json['domainEnabledByProvider'],
        'defaultWalletVersion': !exists(json, 'defaultWalletVersion') ? undefined : EmbeddedWalletVersionEnumFromJSON(json['defaultWalletVersion']),
        'promptForKeyExport': !exists(json, 'promptForKeyExport') ? undefined : json['promptForKeyExport'],
        'transactionSimulation': !exists(json, 'transactionSimulation') ? undefined : json['transactionSimulation'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var SocialSignInProviderEnum;
(function (SocialSignInProviderEnum) {
    SocialSignInProviderEnum["Apple"] = "apple";
    SocialSignInProviderEnum["Bitbucket"] = "bitbucket";
    SocialSignInProviderEnum["Coinbasesocial"] = "coinbasesocial";
    SocialSignInProviderEnum["Discord"] = "discord";
    SocialSignInProviderEnum["Epicgames"] = "epicgames";
    SocialSignInProviderEnum["Facebook"] = "facebook";
    SocialSignInProviderEnum["Farcaster"] = "farcaster";
    SocialSignInProviderEnum["Github"] = "github";
    SocialSignInProviderEnum["Gitlab"] = "gitlab";
    SocialSignInProviderEnum["Google"] = "google";
    SocialSignInProviderEnum["Instagram"] = "instagram";
    SocialSignInProviderEnum["Linkedin"] = "linkedin";
    SocialSignInProviderEnum["Microsoft"] = "microsoft";
    SocialSignInProviderEnum["Twitch"] = "twitch";
    SocialSignInProviderEnum["Twitter"] = "twitter";
    SocialSignInProviderEnum["Telegram"] = "telegram";
    SocialSignInProviderEnum["Spotify"] = "spotify";
    SocialSignInProviderEnum["Tiktok"] = "tiktok";
    SocialSignInProviderEnum["Line"] = "line";
    SocialSignInProviderEnum["Steam"] = "steam";
    SocialSignInProviderEnum["Shopify"] = "shopify";
})(SocialSignInProviderEnum || (SocialSignInProviderEnum = {}));
function SocialSignInProviderEnumFromJSON(json) {
    return SocialSignInProviderEnumFromJSONTyped(json);
}
function SocialSignInProviderEnumFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
function SocialSignInProviderFromJSON(json) {
    return SocialSignInProviderFromJSONTyped(json);
}
function SocialSignInProviderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'provider': SocialSignInProviderEnumFromJSON(json['provider']),
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

/* tslint:disable */
function ProjectSettingsSdkSocialSignInFromJSON(json) {
    return ProjectSettingsSdkSocialSignInFromJSONTyped(json);
}
function ProjectSettingsSdkSocialSignInFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'signInProvider': !exists(json, 'signInProvider') ? undefined : SignInProviderEnumFromJSON(json['signInProvider']),
        'providers': !exists(json, 'providers') ? undefined : (json['providers'].map(SocialSignInProviderFromJSON)),
    };
}

/* tslint:disable */
function ProjectSettingsSdkWalletConnectFromJSON(json) {
    return ProjectSettingsSdkWalletConnectFromJSONTyped(json);
}
function ProjectSettingsSdkWalletConnectFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'v2Enabled': !exists(json, 'v2Enabled') ? undefined : json['v2Enabled'],
        'walletProjectId': !exists(json, 'walletProjectId') ? undefined : json['walletProjectId'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var SdkViewSectionAlignment;
(function (SdkViewSectionAlignment) {
    SdkViewSectionAlignment["Center"] = "center";
    SdkViewSectionAlignment["Left"] = "left";
    SdkViewSectionAlignment["Right"] = "right";
})(SdkViewSectionAlignment || (SdkViewSectionAlignment = {}));
function SdkViewSectionAlignmentFromJSON(json) {
    return SdkViewSectionAlignmentFromJSONTyped(json);
}
function SdkViewSectionAlignmentFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var SdkViewSectionType;
(function (SdkViewSectionType) {
    SdkViewSectionType["Email"] = "email";
    SdkViewSectionType["EmailAndPhone"] = "emailAndPhone";
    SdkViewSectionType["Phone"] = "phone";
    SdkViewSectionType["Separator"] = "separator";
    SdkViewSectionType["Social"] = "social";
    SdkViewSectionType["Text"] = "text";
    SdkViewSectionType["Wallet"] = "wallet";
})(SdkViewSectionType || (SdkViewSectionType = {}));
function SdkViewSectionTypeFromJSON(json) {
    return SdkViewSectionTypeFromJSONTyped(json);
}
function SdkViewSectionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
function SdkViewSectionFromJSON(json) {
    return SdkViewSectionFromJSONTyped(json);
}
function SdkViewSectionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': SdkViewSectionTypeFromJSON(json['type']),
        'label': !exists(json, 'label') ? undefined : json['label'],
        'numOfItemsToDisplay': !exists(json, 'numOfItemsToDisplay') ? undefined : json['numOfItemsToDisplay'],
        'defaultItem': !exists(json, 'defaultItem') ? undefined : json['defaultItem'],
        'alignment': !exists(json, 'alignment') ? undefined : SdkViewSectionAlignmentFromJSON(json['alignment']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var SdkViewType;
(function (SdkViewType) {
    SdkViewType["Login"] = "login";
})(SdkViewType || (SdkViewType = {}));
function SdkViewTypeFromJSON(json) {
    return SdkViewTypeFromJSONTyped(json);
}
function SdkViewTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}

/* tslint:disable */
function SdkViewFromJSON(json) {
    return SdkViewFromJSONTyped(json);
}
function SdkViewFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': SdkViewTypeFromJSON(json['type']),
        'sections': !exists(json, 'sections') ? undefined : (json['sections'].map(SdkViewSectionFromJSON)),
    };
}

/* tslint:disable */
function ProjectSettingsSdkFromJSON(json) {
    return ProjectSettingsSdkFromJSONTyped(json);
}
function ProjectSettingsSdkFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nameService': !exists(json, 'nameService') ? undefined : NameServiceSdkSettingsFromJSON(json['nameService']),
        'featureFlags': !exists(json, 'featureFlags') ? undefined : FeatureFlagsFromJSON(json['featureFlags']),
        'emailSignIn': !exists(json, 'emailSignIn') ? undefined : ProjectSettingsSdkEmailSignInFromJSON(json['emailSignIn']),
        'socialSignIn': !exists(json, 'socialSignIn') ? undefined : ProjectSettingsSdkSocialSignInFromJSON(json['socialSignIn']),
        'multiWallet': !exists(json, 'multiWallet') ? undefined : json['multiWallet'],
        'multiWalletUnlinkDisabled': !exists(json, 'multiWalletUnlinkDisabled') ? undefined : json['multiWalletUnlinkDisabled'],
        'mobile': !exists(json, 'mobile') ? undefined : MobileSettingsFromJSON(json['mobile']),
        'confirmWalletTransfers': !exists(json, 'confirmWalletTransfers') ? undefined : json['confirmWalletTransfers'],
        'onrampFunding': !exists(json, 'onrampFunding') ? undefined : json['onrampFunding'],
        'passkeyEmbeddedWalletEnabled': !exists(json, 'passkeyEmbeddedWalletEnabled') ? undefined : json['passkeyEmbeddedWalletEnabled'],
        'automaticEmbeddedWalletCreation': !exists(json, 'automaticEmbeddedWalletCreation') ? undefined : json['automaticEmbeddedWalletCreation'],
        'passkeyEmbeddedWalletRecoveryEnabled': !exists(json, 'passkeyEmbeddedWalletRecoveryEnabled') ? undefined : json['passkeyEmbeddedWalletRecoveryEnabled'],
        'embeddedWalletSecurityMethods': !exists(json, 'embeddedWalletSecurityMethods') ? undefined : (json['embeddedWalletSecurityMethods'].map(EmbeddedWalletSecurityMethodFromJSON)),
        'embeddedWallets': !exists(json, 'embeddedWallets') ? undefined : ProjectSettingsSdkEmbeddedWalletsFromJSON(json['embeddedWallets']),
        'walletConnect': !exists(json, 'walletConnect') ? undefined : ProjectSettingsSdkWalletConnectFromJSON(json['walletConnect']),
        'confirmEmailProviderForVerify': !exists(json, 'confirmEmailProviderForVerify') ? undefined : json['confirmEmailProviderForVerify'],
        'displayDynamicMessaging': !exists(json, 'displayDynamicMessaging') ? undefined : json['displayDynamicMessaging'],
        'hideNetworkInDynamicWidget': !exists(json, 'hideNetworkInDynamicWidget') ? undefined : json['hideNetworkInDynamicWidget'],
        'preventOrphanedAccounts': !exists(json, 'preventOrphanedAccounts') ? undefined : json['preventOrphanedAccounts'],
        'views': !exists(json, 'views') ? undefined : (json['views'].map(SdkViewFromJSON)),
        'accountAbstraction': !exists(json, 'accountAbstraction') ? undefined : ProjectSettingsSdkAccountAbstractionFromJSON(json['accountAbstraction']),
        'blockEmailSubaddresses': !exists(json, 'blockEmailSubaddresses') ? undefined : json['blockEmailSubaddresses'],
        'enableMultiAsset': !exists(json, 'enableMultiAsset') ? undefined : json['enableMultiAsset'],
        'showFiat': !exists(json, 'showFiat') ? undefined : json['showFiat'],
        'disabledWalletConnectors': !exists(json, 'disabledWalletConnectors') ? undefined : json['disabledWalletConnectors'],
        'funding': !exists(json, 'funding') ? undefined : FundingFromJSON(json['funding']),
    };
}

/* tslint:disable */
function AuthSettingsFromJSON(json) {
    return AuthSettingsFromJSONTyped(json);
}
function AuthSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'storage': (json['storage'].map(AuthStorageEnumFromJSON)),
    };
}

/* tslint:disable */
function ExternalAuthFromJSON(json) {
    return ExternalAuthFromJSONTyped(json);
}
function ExternalAuthFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'iss': !exists(json, 'iss') ? undefined : json['iss'],
        'aud': !exists(json, 'aud') ? undefined : json['aud'],
        'jwksUrl': !exists(json, 'jwksUrl') ? undefined : json['jwksUrl'],
        'cookieName': !exists(json, 'cookieName') ? undefined : json['cookieName'],
    };
}

/* tslint:disable */
function HCaptchaSettingsFromJSON(json) {
    return HCaptchaSettingsFromJSONTyped(json);
}
function HCaptchaSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'secretKey': !exists(json, 'secretKey') ? undefined : json['secretKey'],
        'siteKey': !exists(json, 'siteKey') ? undefined : json['siteKey'],
    };
}

/* tslint:disable */
function MFASettingsFromJSON(json) {
    return MFASettingsFromJSONTyped(json);
}
function MFASettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'required': !exists(json, 'required') ? undefined : json['required'],
        'availableMethods': !exists(json, 'availableMethods') ? undefined : (json['availableMethods'].map(MFADeviceTypeFromJSON)),
    };
}

/* tslint:disable */
function ProjectSettingsSecurityFromJSON(json) {
    return ProjectSettingsSecurityFromJSONTyped(json);
}
function ProjectSettingsSecurityFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'jwtDuration': !exists(json, 'jwtDuration') ? undefined : DurationFromJSON(json['jwtDuration']),
        'hCaptcha': !exists(json, 'hCaptcha') ? undefined : HCaptchaSettingsFromJSON(json['hCaptcha']),
        'mfa': !exists(json, 'mfa') ? undefined : MFASettingsFromJSON(json['mfa']),
        'auth': !exists(json, 'auth') ? undefined : AuthSettingsFromJSON(json['auth']),
        'externalAuth': !exists(json, 'externalAuth') ? undefined : ExternalAuthFromJSON(json['externalAuth']),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ProviderAgreementFromJSON(json) {
    return ProviderAgreementFromJSONTyped(json);
}
function ProviderAgreementFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'termsUrl': json['termsUrl'],
        'email': json['email'],
        'userId': json['userId'],
        'createdAt': (new Date(json['createdAt'])),
    };
}

/* tslint:disable */
function ProviderMultichainAccountAbstractionProvidersFromJSON(json) {
    return ProviderMultichainAccountAbstractionProvidersFromJSONTyped(json);
}
function ProviderMultichainAccountAbstractionProvidersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'clientId': json['clientId'],
        'chain': json['chain'],
        '_default': !exists(json, 'default') ? undefined : json['default'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function SmsCountryCodeFromJSON(json) {
    return SmsCountryCodeFromJSONTyped(json);
}
function SmsCountryCodeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isoCountryCode': json['isoCountryCode'],
        'phoneCountryCode': json['phoneCountryCode'],
    };
}

/* tslint:disable */
function ProviderFromJSON(json) {
    return ProviderFromJSONTyped(json);
}
function ProviderFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'provider': ProviderEnumFromJSON(json['provider']),
        'enabledAt': !exists(json, 'enabledAt') ? undefined : (json['enabledAt'] === null ? null : new Date(json['enabledAt'])),
        'clientId': !exists(json, 'clientId') ? undefined : json['clientId'],
        'clientSecret': !exists(json, 'clientSecret') ? undefined : json['clientSecret'],
        'providerProjectId': !exists(json, 'providerProjectId') ? undefined : json['providerProjectId'],
        'authorizationUrl': !exists(json, 'authorizationUrl') ? undefined : json['authorizationUrl'],
        'redirectUrl': !exists(json, 'redirectUrl') ? undefined : json['redirectUrl'],
        'defaultChainId': !exists(json, 'defaultChainId') ? undefined : json['defaultChainId'],
        'defaultChain': !exists(json, 'defaultChain') ? undefined : json['defaultChain'],
        'keyExportUrl': !exists(json, 'keyExportUrl') ? undefined : json['keyExportUrl'],
        'termsAcceptedByUser': !exists(json, 'termsAcceptedByUser') ? undefined : ProviderAgreementFromJSON(json['termsAcceptedByUser']),
        'scopes': !exists(json, 'scopes') ? undefined : json['scopes'],
        'baseAuthUrl': !exists(json, 'baseAuthUrl') ? undefined : json['baseAuthUrl'],
        'appleKeyId': !exists(json, 'appleKeyId') ? undefined : json['appleKeyId'],
        'appleTeamId': !exists(json, 'appleTeamId') ? undefined : json['appleTeamId'],
        'shopifyStore': !exists(json, 'shopifyStore') ? undefined : json['shopifyStore'],
        'accountSid': !exists(json, 'accountSid') ? undefined : json['accountSid'],
        'twilioNumber': !exists(json, 'twilioNumber') ? undefined : json['twilioNumber'],
        'enabledCountries': !exists(json, 'enabledCountries') ? undefined : (json['enabledCountries'].map(SmsCountryCodeFromJSON)),
        'entryPointVersion': !exists(json, 'entryPointVersion') ? undefined : ProviderEntryPointVersionEnumFromJSON(json['entryPointVersion']),
        'kernelVersion': !exists(json, 'kernelVersion') ? undefined : ProviderKernelVersionEnumFromJSON(json['kernelVersion']),
        'multichainAccountAbstractionProviders': !exists(json, 'multichainAccountAbstractionProviders') ? undefined : (json['multichainAccountAbstractionProviders'].map(ProviderMultichainAccountAbstractionProvidersFromJSON)),
        'ecdsaProviderType': !exists(json, 'ecdsaProviderType') ? undefined : EcdsaValidatorOptionsFromJSON(json['ecdsaProviderType']),
        'createNewAccounts': !exists(json, 'createNewAccounts') ? undefined : json['createNewAccounts'],
        'enableKernelV3Migration': !exists(json, 'enableKernelV3Migration') ? undefined : json['enableKernelV3Migration'],
        'enableEIP7702': !exists(json, 'enableEIP7702') ? undefined : json['enableEIP7702'],
    };
}

/* tslint:disable */
function ProjectSettingsFromJSON(json) {
    return ProjectSettingsFromJSONTyped(json);
}
function ProjectSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'environmentName': !exists(json, 'environmentName') ? undefined : EnvironmentEnumFromJSON(json['environmentName']),
        'chains': (json['chains'].map(ProjectSettingsChainsFromJSON)),
        'customFields': !exists(json, 'customFields') ? undefined : (json['customFields'].map(ProjectSettingsKycFromJSON)),
        'kyc': (json['kyc'].map(ProjectSettingsKycFromJSON)),
        'design': ProjectSettingsDesignFromJSON(json['design']),
        'general': ProjectSettingsGeneralFromJSON(json['general']),
        'privacy': ProjectSettingsPrivacyFromJSON(json['privacy']),
        'providers': !exists(json, 'providers') ? undefined : (json['providers'].map(ProviderFromJSON)),
        'sdk': ProjectSettingsSdkFromJSON(json['sdk']),
        'security': ProjectSettingsSecurityFromJSON(json['security']),
        'networks': !exists(json, 'networks') ? undefined : (json['networks'].map(NetworkConfigurationResponseFromJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
* @export
* @enum {string}
*/
var PublishEventsEventsTypeEnum;
(function (PublishEventsEventsTypeEnum) {
    PublishEventsEventsTypeEnum["Track"] = "track";
})(PublishEventsEventsTypeEnum || (PublishEventsEventsTypeEnum = {}));
function PublishEventsEventsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'anonymousId': value.anonymousId,
        'event': value.event,
        'properties': value.properties,
        'type': value.type,
    };
}

function PublishEventsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'events': (value.events.map(PublishEventsEventsToJSON)),
    };
}

function RecoverMultipleClientKeySharesRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'keyShareIds': value.keyShareIds,
    };
}

/* tslint:disable */
function WalletKeyShareInfoWithEncryptedAccountCredentialFromJSON(json) {
    return WalletKeyShareInfoWithEncryptedAccountCredentialFromJSONTyped(json);
}
function WalletKeyShareInfoWithEncryptedAccountCredentialFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'backupLocation': json['backupLocation'],
        'passwordEncrypted': json['passwordEncrypted'],
        'encryptedAccountCredential': !exists(json, 'encryptedAccountCredential') ? undefined : json['encryptedAccountCredential'],
    };
}

/* tslint:disable */
function RecoverMultipleClientKeySharesResponseFromJSON(json) {
    return RecoverMultipleClientKeySharesResponseFromJSONTyped(json);
}
function RecoverMultipleClientKeySharesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'keyShares': (json['keyShares'].map(WalletKeyShareInfoWithEncryptedAccountCredentialFromJSON)),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function RefreshKeySharesRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'clientKeygenIds': value.clientKeygenIds,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function RegisterEmbeddedWalletSessionKeyResponseFromJSON(json) {
    return RegisterEmbeddedWalletSessionKeyResponseFromJSONTyped(json);
}
function RegisterEmbeddedWalletSessionKeyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'publicKey': json['publicKey'],
        'expiresAt': json['expiresAt'],
    };
}

function RegisterSessionKeyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'publicKey': value.publicKey,
        'prevSessionKeySignature': value.prevSessionKeySignature,
    };
}

function ReshareRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'clientKeygenIds': value.clientKeygenIds,
        'thresholdSignatureScheme': ThresholdSignatureSchemeToJSON(value.thresholdSignatureScheme),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ScanWebsiteUrlRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ScanWebsiteUrlResponseFromJSON(json) {
    return ScanWebsiteUrlResponseFromJSONTyped(json);
}
function ScanWebsiteUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isMalicious': json['isMalicious'],
    };
}

function NextJsSettingsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'version': value.version,
    };
}

function ReactSettingsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'version': value.version,
    };
}

function FrameworkSettingsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'react': ReactSettingsToJSON(value.react),
        'nextjs': NextJsSettingsToJSON(value.nextjs),
    };
}

function SdkSettingsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dynamicContextProps': value.dynamicContextProps,
        'dynamicWagmiSettings': value.dynamicWagmiSettings,
        'frameworkSettings': FrameworkSettingsToJSON(value.frameworkSettings),
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function SignMessageWithWaasRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'message': value.message,
    };
}

function SimulateEVMTransactionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chainId': value.chainId,
        'data': value.data,
        'from': value.from,
        'to': value.to,
        'value': value.value,
        'domain': value.domain,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var SolanaChainType;
(function (SolanaChainType) {
    SolanaChainType["Mainnet"] = "mainnet";
    SolanaChainType["Devnet"] = "devnet";
})(SolanaChainType || (SolanaChainType = {}));
function SolanaChainTypeToJSON(value) {
    return value;
}

function SimulateSVMTransactionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chain': SolanaChainTypeToJSON(value.chain),
        'transactions': value.transactions,
        'accountAddress': value.accountAddress,
        'domain': value.domain,
        'method': value.method,
    };
}

/* tslint:disable */
function AssetFromJSON(json) {
    return AssetFromJSONTyped(json);
}
function AssetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': json['address'],
        'chainId': !exists(json, 'chainId') ? undefined : json['chainId'],
        'chainName': json['chainName'],
        'decimals': json['decimals'],
        'logoUrl': json['logoUrl'],
        'name': json['name'],
        'symbol': json['symbol'],
        'type': json['type'],
    };
}

/* tslint:disable */
function AssetTransferFromJSON(json) {
    return AssetTransferFromJSONTyped(json);
}
function AssetTransferFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rawValue': !exists(json, 'rawValue') ? undefined : json['rawValue'],
        'summary': !exists(json, 'summary') ? undefined : json['summary'],
        'usdPrice': !exists(json, 'usdPrice') ? undefined : json['usdPrice'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

/* tslint:disable */
function AssetDiffFromJSON(json) {
    return AssetDiffFromJSONTyped(json);
}
function AssetDiffFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'asset': AssetFromJSON(json['asset']),
        'transferIn': (json['transferIn'].map(AssetTransferFromJSON)),
        'transferOut': (json['transferOut'].map(AssetTransferFromJSON)),
    };
}

/* tslint:disable */
function AssetExposureSpenderToInfoFromJSON(json) {
    return AssetExposureSpenderToInfoFromJSONTyped(json);
}
function AssetExposureSpenderToInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'amount': json['amount'],
        'spenderAlias': !exists(json, 'spenderAlias') ? undefined : json['spenderAlias'],
        'usdValue': !exists(json, 'usdValue') ? undefined : json['usdValue'],
    };
}

/* tslint:disable */
function AssetExposureFromJSON(json) {
    return AssetExposureFromJSONTyped(json);
}
function AssetExposureFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'asset': AssetFromJSON(json['asset']),
        'spenderToInfo': (mapValues$1(json['spenderToInfo'], AssetExposureSpenderToInfoFromJSON)),
    };
}

/* tslint:disable */
function BlockaidValidationFromJSON(json) {
    return BlockaidValidationFromJSONTyped(json);
}
function BlockaidValidationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'result': json['result'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'reason': json['reason'],
        'classification': !exists(json, 'classification') ? undefined : json['classification'],
    };
}

/* tslint:disable */
function PriceDataFromJSON(json) {
    return PriceDataFromJSONTyped(json);
}
function PriceDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'nativeTokenUsdPrice': !exists(json, 'nativeTokenUsdPrice') ? undefined : json['nativeTokenUsdPrice'],
    };
}

/* tslint:disable */
function SimulateTransactionResponseFromJSON(json) {
    return SimulateTransactionResponseFromJSONTyped(json);
}
function SimulateTransactionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'inAssets': (json['inAssets'].map(AssetDiffFromJSON)),
        'outAssets': (json['outAssets'].map(AssetDiffFromJSON)),
        'counterparties': !exists(json, 'counterparties') ? undefined : json['counterparties'],
        'priceData': PriceDataFromJSON(json['priceData']),
        'showTotalFiat': json['showTotalFiat'],
        'validation': !exists(json, 'validation') ? undefined : BlockaidValidationFromJSON(json['validation']),
        'assetExposures': !exists(json, 'assetExposures') ? undefined : (json['assetExposures'].map(AssetExposureFromJSON)),
    };
}

function SimulateUserOpRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chainId': value.chainId,
        'operation': value.operation,
        'entryPoint': value.entryPoint,
        'domain': value.domain,
        'value': value.value,
    };
}

function SmsVerificationCreateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'phoneCountryCode': value.phoneCountryCode,
        'phoneNumber': value.phoneNumber,
        'isoCountryCode': value.isoCountryCode,
        'captchaToken': value.captchaToken,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function SmsVerificationCreateResponseFromJSON(json) {
    return SmsVerificationCreateResponseFromJSONTyped(json);
}
function SmsVerificationCreateResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'verificationUUID': json['verificationUUID'],
        'phoneNumber': json['phoneNumber'],
        'phoneCountryCode': json['phoneCountryCode'],
        'isoCountryCode': json['isoCountryCode'],
    };
}

function SmsVerificationRetryRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'verificationUUID': value.verificationUUID,
        'phoneCountryCode': value.phoneCountryCode,
        'phoneNumber': value.phoneNumber,
        'isoCountryCode': value.isoCountryCode,
        'captchaToken': value.captchaToken,
    };
}

function SmsVerificationVerifyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'verificationUUID': value.verificationUUID,
        'verificationToken': value.verificationToken,
        'captchaToken': value.captchaToken,
        'sessionPublicKey': value.sessionPublicKey,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function SolanaTransactionOptimizationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'transaction': value.transaction,
        'address': value.address,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function SolanaTransactionOptimizationResponseFromJSON(json) {
    return SolanaTransactionOptimizationResponseFromJSONTyped(json);
}
function SolanaTransactionOptimizationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'transaction': json['transaction'],
    };
}

/* tslint:disable */
function OnrampConfigurationFromJSON(json) {
    return OnrampConfigurationFromJSONTyped(json);
}
function OnrampConfigurationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'provider': !exists(json, 'provider') ? undefined : ProviderEnumFromJSON(json['provider']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'iconUrl': !exists(json, 'iconUrl') ? undefined : json['iconUrl'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

/* tslint:disable */
function SupportedOnrampsResponseFromJSON(json) {
    return SupportedOnrampsResponseFromJSONTyped(json);
}
function SupportedOnrampsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'onramps': !exists(json, 'onramps') ? undefined : (json['onramps'].map(OnrampConfigurationFromJSON)),
    };
}

function TelegramUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'hash': value.hash,
        'photoURL': value.photoURL,
        'username': value.username,
        'authDate': value.authDate,
    };
}

function TelegramPostRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'state': value.state,
        'telegramUser': TelegramUserToJSON(value.telegramUser),
    };
}

/* tslint:disable */
function TokenBalanceFromJSON(json) {
    return TokenBalanceFromJSONTyped(json);
}
function TokenBalanceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'networkId': !exists(json, 'networkId') ? undefined : json['networkId'],
        'address': json['address'],
        'name': json['name'],
        'symbol': json['symbol'],
        'decimals': json['decimals'],
        'logoURI': json['logoURI'],
        'balance': json['balance'],
        'rawBalance': json['rawBalance'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'marketValue': !exists(json, 'marketValue') ? undefined : json['marketValue'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function TurnkeyWalletAccountFromJSON(json) {
    return TurnkeyWalletAccountFromJSONTyped(json);
}
function TurnkeyWalletAccountFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'curve': json['curve'],
        'pathFormat': json['pathFormat'],
        'path': json['path'],
        'addressFormat': json['addressFormat'],
    };
}

/* tslint:disable */
function TurnkeyCreateWalletAccountsRequestBodyParametersFromJSON(json) {
    return TurnkeyCreateWalletAccountsRequestBodyParametersFromJSONTyped(json);
}
function TurnkeyCreateWalletAccountsRequestBodyParametersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'walletId': json['walletId'],
        'accounts': (json['accounts'].map(TurnkeyWalletAccountFromJSON)),
    };
}

/* tslint:disable */
function TurnkeyCreateWalletAccountsRequestBodyFromJSON(json) {
    return TurnkeyCreateWalletAccountsRequestBodyFromJSONTyped(json);
}
function TurnkeyCreateWalletAccountsRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'organizationId': json['organizationId'],
        'parameters': TurnkeyCreateWalletAccountsRequestBodyParametersFromJSON(json['parameters']),
        'timestampMs': json['timestampMs'],
        'type': json['type'],
    };
}

/* tslint:disable */
function TurnkeyDeleteEmbeddedWalletsRequestBodyParametersFromJSON(json) {
    return TurnkeyDeleteEmbeddedWalletsRequestBodyParametersFromJSONTyped(json);
}
function TurnkeyDeleteEmbeddedWalletsRequestBodyParametersFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'walletIds': json['walletIds'],
        'deleteWithoutExport': !exists(json, 'deleteWithoutExport') ? undefined : json['deleteWithoutExport'],
    };
}

/* tslint:disable */
function TurnkeyDeleteEmbeddedWalletsRequestBodyFromJSON(json) {
    return TurnkeyDeleteEmbeddedWalletsRequestBodyFromJSONTyped(json);
}
function TurnkeyDeleteEmbeddedWalletsRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'organizationId': json['organizationId'],
        'parameters': TurnkeyDeleteEmbeddedWalletsRequestBodyParametersFromJSON(json['parameters']),
        'timestampMs': json['timestampMs'],
        'type': json['type'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var UnprocessableEntityErrorCode;
(function (UnprocessableEntityErrorCode) {
    UnprocessableEntityErrorCode["EmailAlreadyExists"] = "email_already_exists";
    UnprocessableEntityErrorCode["AllowlistAlreadyExists"] = "allowlist_already_exists";
    UnprocessableEntityErrorCode["AllowlistEntryAlreadyExists"] = "allowlist_entry_already_exists";
    UnprocessableEntityErrorCode["ReassignWalletError"] = "reassign_wallet_error";
    UnprocessableEntityErrorCode["ReassignWalletConfirm"] = "reassign_wallet_confirm";
    UnprocessableEntityErrorCode["MembersCannotDeleteThemself"] = "members_cannot_delete_themself";
    UnprocessableEntityErrorCode["UsernameAlreadyExists"] = "username_already_exists";
    UnprocessableEntityErrorCode["WrongEmailVerificationToken"] = "wrong_email_verification_token";
    UnprocessableEntityErrorCode["WrongSmsVerificationToken"] = "wrong_sms_verification_token";
    UnprocessableEntityErrorCode["InvalidEmailVerification"] = "invalid_email_verification";
    UnprocessableEntityErrorCode["InvalidSmsVerification"] = "invalid_sms_verification";
    UnprocessableEntityErrorCode["InvalidVerification"] = "invalid_verification";
    UnprocessableEntityErrorCode["InvalidPosition"] = "invalid_position";
    UnprocessableEntityErrorCode["TooManySmsVerificationAttempts"] = "too_many_sms_verification_attempts";
    UnprocessableEntityErrorCode["TooManyEmailVerificationAttempts"] = "too_many_email_verification_attempts";
    UnprocessableEntityErrorCode["TooManyVerificationAttempts"] = "too_many_verification_attempts";
    UnprocessableEntityErrorCode["OrganizationNameAlreadyExists"] = "organization_name_already_exists";
    UnprocessableEntityErrorCode["ProjectNameAlreadyExists"] = "project_name_already_exists";
    UnprocessableEntityErrorCode["WalletNotDeployed"] = "wallet_not_deployed";
    UnprocessableEntityErrorCode["EmailVerificationRequired"] = "email_verification_required";
    UnprocessableEntityErrorCode["PhoneVerificationRequired"] = "phone_verification_required";
    UnprocessableEntityErrorCode["InviteAddressRequired"] = "invite_address_required";
    UnprocessableEntityErrorCode["ProviderNotAvailable"] = "provider_not_available";
    UnprocessableEntityErrorCode["ForbiddenUnlinkRequest"] = "forbidden_unlink_request";
    UnprocessableEntityErrorCode["InvalidUnlinkRequest"] = "invalid_unlink_request";
    UnprocessableEntityErrorCode["TooManyApiTokens"] = "too_many_api_tokens";
    UnprocessableEntityErrorCode["LockTimeout"] = "lock_timeout";
    UnprocessableEntityErrorCode["LockTooManyAttempts"] = "lock_too_many_attempts";
    UnprocessableEntityErrorCode["NftTokenGatingNotSupportedForChain"] = "nft_token_gating_not_supported_for_chain";
    UnprocessableEntityErrorCode["EmptyChainName"] = "empty_chain_name";
    UnprocessableEntityErrorCode["NoEnabledEmailProvider"] = "no_enabled_email_provider";
    UnprocessableEntityErrorCode["NoEnabledSmsProvider"] = "no_enabled_sms_provider";
    UnprocessableEntityErrorCode["InvalidKeyExportUrl"] = "invalid_key_export_url";
    UnprocessableEntityErrorCode["InvalidDynamicProps"] = "invalid_dynamic_props";
    UnprocessableEntityErrorCode["TooManyRequests"] = "too_many_requests";
    UnprocessableEntityErrorCode["TooManyOrganizationsForUser"] = "too_many_organizations_for_user";
    UnprocessableEntityErrorCode["TooManyProjectsForOrganization"] = "too_many_projects_for_organization";
    UnprocessableEntityErrorCode["EmailAssociatedWithDifferentProvider"] = "email_associated_with_different_provider";
    UnprocessableEntityErrorCode["UserHasAlreadyAccountWithEmail"] = "user_has_already_account_with_email";
    UnprocessableEntityErrorCode["UserHasAlreadyAccountWithPhoneNumber"] = "user_has_already_account_with_phone_number";
    UnprocessableEntityErrorCode["OtherVerifyFailure"] = "other_verify_failure";
    UnprocessableEntityErrorCode["EmailTiedToEmbeddedWallet"] = "email_tied_to_embedded_wallet";
    UnprocessableEntityErrorCode["InvalidInvite"] = "invalid_invite";
    UnprocessableEntityErrorCode["SocialAccountAlreadyExists"] = "social_account_already_exists";
    UnprocessableEntityErrorCode["InvalidEmailAddress"] = "invalid_email_address";
    UnprocessableEntityErrorCode["InvalidGate"] = "invalid_gate";
    UnprocessableEntityErrorCode["ConflictingEmbeddedWalletProviders"] = "conflicting_embedded_wallet_providers";
    UnprocessableEntityErrorCode["InvalidUser"] = "invalid_user";
    UnprocessableEntityErrorCode["InvalidCorsOrigins"] = "invalid_cors_origins";
    UnprocessableEntityErrorCode["InvalidMobileDeeplinkUrls"] = "invalid_mobile_deeplink_urls";
    UnprocessableEntityErrorCode["UnauthorizedMobileDeeplinkUrl"] = "unauthorized_mobile_deeplink_url";
    UnprocessableEntityErrorCode["InvalidPrivateKeyFormat"] = "invalid_private_key_format";
    UnprocessableEntityErrorCode["InvalidEmbeddedWalletSettings"] = "invalid_embedded_wallet_settings";
    UnprocessableEntityErrorCode["WalletNotSupportPasskey"] = "wallet_not_support_passkey";
    UnprocessableEntityErrorCode["RecoveryEmailUnavailableOrInvalid"] = "recovery_email_unavailable_or_invalid";
    UnprocessableEntityErrorCode["ConnectError"] = "connect_error";
    UnprocessableEntityErrorCode["InvalidWalletName"] = "invalid_wallet_name";
    UnprocessableEntityErrorCode["InvalidWalletAddress"] = "invalid_wallet_address";
    UnprocessableEntityErrorCode["EmailRecoveryDisabled"] = "email_recovery_disabled";
    UnprocessableEntityErrorCode["NoCompatibleWalletServiceEnabled"] = "no_compatible_wallet_service_enabled";
    UnprocessableEntityErrorCode["MissingAaProjectId"] = "missing_aa_project_id";
    UnprocessableEntityErrorCode["LinkedEmbeddedWallet"] = "linked_embedded_wallet";
    UnprocessableEntityErrorCode["InvalidMpcEnvironment"] = "invalid_mpc_environment";
    UnprocessableEntityErrorCode["InvalidRegex"] = "invalid_regex";
    UnprocessableEntityErrorCode["RepeatedOptions"] = "repeated_options";
    UnprocessableEntityErrorCode["MissingPhoneNumberOrEmail"] = "missing_phone_number_or_email";
    UnprocessableEntityErrorCode["DuplicateExists"] = "duplicate_exists";
    UnprocessableEntityErrorCode["MfaDeviceNotFound"] = "mfa_device_not_found";
    UnprocessableEntityErrorCode["MfaInvalidCode"] = "mfa_invalid_code";
    UnprocessableEntityErrorCode["MfaInvalidRequest"] = "mfa_invalid_request";
    UnprocessableEntityErrorCode["InvalidPhone"] = "invalid_phone";
    UnprocessableEntityErrorCode["GateExists"] = "gate_exists";
    UnprocessableEntityErrorCode["InvalidEmbeddedWalletChainsConfiguration"] = "invalid_embedded_wallet_chains_configuration";
    UnprocessableEntityErrorCode["MergeAccountsConfirmation"] = "merge_accounts_confirmation";
    UnprocessableEntityErrorCode["MergeAccountsInvalid"] = "merge_accounts_invalid";
    UnprocessableEntityErrorCode["InvalidWalletId"] = "invalid_wallet_id";
    UnprocessableEntityErrorCode["UnableToFetchBalances"] = "unable_to_fetch_balances";
    UnprocessableEntityErrorCode["CannotSwitchToUnique"] = "cannot_switch_to_unique";
    UnprocessableEntityErrorCode["CustomFieldDataNotUnique"] = "custom_field_data_not_unique";
    UnprocessableEntityErrorCode["MetadataSizeExceeded"] = "metadata_size_exceeded";
    UnprocessableEntityErrorCode["InvalidCustomHostname"] = "invalid_custom_hostname";
    UnprocessableEntityErrorCode["BlockedUserCannotTransferWallet"] = "blocked_user_cannot_transfer_wallet";
    UnprocessableEntityErrorCode["FeatureNotEnabledInSuborg"] = "feature_not_enabled_in_suborg";
    UnprocessableEntityErrorCode["InvalidUsername"] = "invalid_username";
    UnprocessableEntityErrorCode["InvalidExternalAuth"] = "invalid_external_auth";
    UnprocessableEntityErrorCode["InvalidChainAddressMatch"] = "invalid_chain_address_match";
    UnprocessableEntityErrorCode["InvalidUpdate"] = "invalid_update";
    UnprocessableEntityErrorCode["CannotDeleteLastProject"] = "cannot_delete_last_project";
    UnprocessableEntityErrorCode["NoHdWalletFound"] = "no_hd_wallet_found";
    UnprocessableEntityErrorCode["WalletAccountExistsForChain"] = "wallet_account_exists_for_chain";
    UnprocessableEntityErrorCode["TooManyEmbeddedWalletsForUser"] = "too_many_embedded_wallets_for_user";
    UnprocessableEntityErrorCode["TooManyEmbeddedWalletsPerChainForUser"] = "too_many_embedded_wallets_per_chain_for_user";
    UnprocessableEntityErrorCode["InvalidSessionPublicKey"] = "invalid_session_public_key";
    UnprocessableEntityErrorCode["CustomFieldNotUnique"] = "custom_field_not_unique";
    UnprocessableEntityErrorCode["InvalidAaProjectConfiguration"] = "invalid_aa_project_configuration";
    UnprocessableEntityErrorCode["NoV1EmbeddedWalletFound"] = "no_v1_embedded_wallet_found";
    UnprocessableEntityErrorCode["EmbeddedWalletAddressAlreadyLinked"] = "embedded_wallet_address_already_linked";
    UnprocessableEntityErrorCode["KeyShareAlreadyBackedUp"] = "key_share_already_backed_up";
    UnprocessableEntityErrorCode["InvalidKeySharesLength"] = "invalid_key_shares_length";
})(UnprocessableEntityErrorCode || (UnprocessableEntityErrorCode = {}));

function UpdateRecoveryEmailRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'turnkeySignedRequest': TurnkeySignedRequestToJSON(value.turnkeySignedRequest),
    };
}

/* tslint:disable */
function UpdateSelfResponseFromJSON(json) {
    return UpdateSelfResponseFromJSONTyped(json);
}
function UpdateSelfResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mfaToken': !exists(json, 'mfaToken') ? undefined : json['mfaToken'],
        'jwt': !exists(json, 'jwt') ? undefined : json['jwt'],
        'user': SdkUserFromJSON(json['user']),
        'minifiedJwt': !exists(json, 'minifiedJwt') ? undefined : json['minifiedJwt'],
        'expiresAt': json['expiresAt'],
        'nextView': NextViewEnumFromJSON(json['nextView']),
        'emailVerification': !exists(json, 'emailVerification') ? undefined : EmailVerificationCreateResponseFromJSON(json['emailVerification']),
        'smsVerification': !exists(json, 'smsVerification') ? undefined : SmsVerificationCreateResponseFromJSON(json['smsVerification']),
    };
}

function UpdateUserPasskeyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'alias': value.alias,
    };
}

function UpgradeEmbeddedWalletToV2RequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sessionPublicKey': value.sessionPublicKey,
    };
}

function UserFieldsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
        'alias': value.alias,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'jobTitle': value.jobTitle,
        'phoneNumber': value.phoneNumber,
        'tShirtSize': value.tShirtSize,
        'team': value.team,
        'policiesConsent': value.policiesConsent,
        'country': value.country,
        'username': value.username,
        'captchaToken': value.captchaToken,
        'metadata': value.metadata,
        'mfaBackupCodeAcknowledgement': MfaBackupCodeAcknowledgementToJSON(value.mfaBackupCodeAcknowledgement),
        'btcWallet': value.btcWallet,
        'kdaWallet': value.kdaWallet,
        'ltcWallet': value.ltcWallet,
        'ckbWallet': value.ckbWallet,
        'kasWallet': value.kasWallet,
        'dogeWallet': value.dogeWallet,
        'emailNotification': value.emailNotification,
        'discordNotification': value.discordNotification,
        'newsletterNotification': value.newsletterNotification,
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var UserFieldsCheckEnum;
(function (UserFieldsCheckEnum) {
    UserFieldsCheckEnum["Email"] = "email";
    UserFieldsCheckEnum["Username"] = "username";
    UserFieldsCheckEnum["NameServiceSubdomainHandle"] = "name-service-subdomain-handle";
})(UserFieldsCheckEnum || (UserFieldsCheckEnum = {}));

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function UserFieldsCheckResponseFromJSON(json) {
    return UserFieldsCheckResponseFromJSONTyped(json);
}
function UserFieldsCheckResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'field': json['field'],
        'value': json['value'],
        'available': json['available'],
    };
}

/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * Dashboard API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function UserWalletSelectionRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'walletId': value.walletId,
    };
}

/* tslint:disable */
function OauthProviderRequestFromJSON(json) {
    return OauthProviderRequestFromJSONTyped(json);
}
function OauthProviderRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'provider': !exists(json, 'provider') ? undefined : ProviderEnumFromJSON(json['provider']),
        'accessToken': !exists(json, 'accessToken') ? undefined : json['accessToken'],
        'didToken': !exists(json, 'didToken') ? undefined : json['didToken'],
    };
}
function OauthProviderRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'provider': ProviderEnumToJSON(value.provider),
        'accessToken': value.accessToken,
        'didToken': value.didToken,
    };
}

/* tslint:disable */
function VerifyRequestFromJSON(json) {
    return VerifyRequestFromJSONTyped(json);
}
function VerifyRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'oauth': !exists(json, 'oauth') ? undefined : OauthProviderRequestFromJSON(json['oauth']),
        'signedMessage': json['signedMessage'],
        'messageToSign': json['messageToSign'],
        'publicWalletAddress': json['publicWalletAddress'],
        'chain': ChainEnumFromJSON(json['chain']),
        'walletName': json['walletName'],
        'walletProvider': WalletProviderEnumFromJSON(json['walletProvider']),
        'skipEmptyAccountCheck': !exists(json, 'skipEmptyAccountCheck') ? undefined : json['skipEmptyAccountCheck'],
        'captchaToken': !exists(json, 'captchaToken') ? undefined : json['captchaToken'],
        'network': !exists(json, 'network') ? undefined : json['network'],
        'additionalWalletAddresses': !exists(json, 'additionalWalletAddresses') ? undefined : (json['additionalWalletAddresses'].map(WalletAdditionalAddressFromJSON)),
        'backup': !exists(json, 'backup') ? undefined : json['backup'],
        'password': !exists(json, 'password') ? undefined : json['password'],
        'passwordSource': !exists(json, 'passwordSource') ? undefined : PasswordSourceTypeEnumFromJSON(json['passwordSource']),
        'sessionPublicKey': !exists(json, 'sessionPublicKey') ? undefined : json['sessionPublicKey'],
    };
}
function VerifyRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'oauth': OauthProviderRequestToJSON(value.oauth),
        'signedMessage': value.signedMessage,
        'messageToSign': value.messageToSign,
        'publicWalletAddress': value.publicWalletAddress,
        'chain': ChainEnumToJSON(value.chain),
        'walletName': value.walletName,
        'walletProvider': WalletProviderEnumToJSON(value.walletProvider),
        'skipEmptyAccountCheck': value.skipEmptyAccountCheck,
        'captchaToken': value.captchaToken,
        'network': value.network,
        'additionalWalletAddresses': value.additionalWalletAddresses === undefined ? undefined : (value.additionalWalletAddresses.map(WalletAdditionalAddressToJSON)),
        'backup': value.backup,
        'password': value.password,
        'passwordSource': PasswordSourceTypeEnumToJSON(value.passwordSource),
        'sessionPublicKey': value.sessionPublicKey,
    };
}

/* tslint:disable */
function VerifyResponseFromJSON(json) {
    return VerifyResponseFromJSONTyped(json);
}
function VerifyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mfaToken': !exists(json, 'mfaToken') ? undefined : json['mfaToken'],
        'jwt': !exists(json, 'jwt') ? undefined : json['jwt'],
        'user': SdkUserFromJSON(json['user']),
        'minifiedJwt': !exists(json, 'minifiedJwt') ? undefined : json['minifiedJwt'],
        'expiresAt': json['expiresAt'],
    };
}

function VerifyUnlinkRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'walletId': value.walletId,
        'verifiedCrentialId': value.verifiedCrentialId,
        'primaryWalletId': value.primaryWalletId,
    };
}

/* tslint:disable */
/**
 *
 */
class SDKApi extends BaseAPI {
    /**
     * Upgrade JWT scope with valid MFA session
     */
    authMfaPasskeyDeviceRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling authMfaPasskeyDevice.');
            }
            if (requestParameters.mFAAuthPasskeyDevicePostRequest === null || requestParameters.mFAAuthPasskeyDevicePostRequest === undefined) {
                throw new RequiredError('mFAAuthPasskeyDevicePostRequest', 'Required parameter requestParameters.mFAAuthPasskeyDevicePostRequest was null or undefined when calling authMfaPasskeyDevice.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/auth/passkey`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MFAAuthPasskeyDevicePostRequestToJSON(requestParameters.mFAAuthPasskeyDevicePostRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Upgrade JWT scope with valid MFA session
     */
    authMfaPasskeyDevice(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.authMfaPasskeyDeviceRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Auth Passkey MFA device
     */
    authMfaPasskeyDeviceChallengeRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling authMfaPasskeyDeviceChallenge.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/auth/passkey`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MFAAuthPasskeyDeviceGetResponseFromJSON(jsonValue));
        });
    }
    /**
     * Auth Passkey MFA device
     */
    authMfaPasskeyDeviceChallenge(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.authMfaPasskeyDeviceChallengeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    authMfaPasskeyDeviceOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling authMfaPasskeyDeviceOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/auth/passkey`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    authMfaPasskeyDeviceOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.authMfaPasskeyDeviceOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Upgrade JWT scope with valid MFA session
     */
    authMfaRecoveryRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling authMfaRecovery.');
            }
            if (requestParameters.mFAAuthRecoveryDevicePostRequest === null || requestParameters.mFAAuthRecoveryDevicePostRequest === undefined) {
                throw new RequiredError('mFAAuthRecoveryDevicePostRequest', 'Required parameter requestParameters.mFAAuthRecoveryDevicePostRequest was null or undefined when calling authMfaRecovery.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/auth/recovery`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MFAAuthRecoveryDevicePostRequestToJSON(requestParameters.mFAAuthRecoveryDevicePostRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Upgrade JWT scope with valid MFA session
     */
    authMfaRecovery(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.authMfaRecoveryRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    authMfaRecoveryOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling authMfaRecoveryOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/auth/recovery`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    authMfaRecoveryOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.authMfaRecoveryOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Upgrade JWT scope with valid MFA session
     */
    authMfaTotpDeviceRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling authMfaTotpDevice.');
            }
            if (requestParameters.mFAAuthTotpDevicePostRequest === null || requestParameters.mFAAuthTotpDevicePostRequest === undefined) {
                throw new RequiredError('mFAAuthTotpDevicePostRequest', 'Required parameter requestParameters.mFAAuthTotpDevicePostRequest was null or undefined when calling authMfaTotpDevice.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/auth/totp`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MFAAuthTotpDevicePostRequestToJSON(requestParameters.mFAAuthTotpDevicePostRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Upgrade JWT scope with valid MFA session
     */
    authMfaTotpDevice(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.authMfaTotpDeviceRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    authMfaTotpDeviceOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling authMfaTotpDeviceOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/auth/totp`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    authMfaTotpDeviceOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.authMfaTotpDeviceOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Backup multiple keyShares for a waaS wallet
     */
    backupKeySharesRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling backupKeyShares.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling backupKeyShares.');
            }
            if (requestParameters.backupMultipleClientKeySharesRequest === null || requestParameters.backupMultipleClientKeySharesRequest === undefined) {
                throw new RequiredError('backupMultipleClientKeySharesRequest', 'Required parameter requestParameters.backupMultipleClientKeySharesRequest was null or undefined when calling backupKeyShares.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/{walletId}/keyShares/backup`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: BackupMultipleClientKeySharesRequestToJSON(requestParameters.backupMultipleClientKeySharesRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => BackupMultipleClientKeySharesResponseFromJSON(jsonValue));
        });
    }
    /**
     * Backup multiple keyShares for a waaS wallet
     */
    backupKeyShares(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.backupKeySharesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    backupKeySharesOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling backupKeySharesOptions.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling backupKeySharesOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/{walletId}/keyShares/backup`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    backupKeySharesOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.backupKeySharesOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Claim a pregenerated embedded wallet
     */
    claimEmbeddedWalletRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling claimEmbeddedWallet.');
            }
            if (requestParameters.embeddedWalletPasscodeClaimRequest === null || requestParameters.embeddedWalletPasscodeClaimRequest === undefined) {
                throw new RequiredError('embeddedWalletPasscodeClaimRequest', 'Required parameter requestParameters.embeddedWalletPasscodeClaimRequest was null or undefined when calling claimEmbeddedWallet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/passcode/claim`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: EmbeddedWalletPasscodeClaimRequestToJSON(requestParameters.embeddedWalletPasscodeClaimRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Claim a pregenerated embedded wallet
     */
    claimEmbeddedWallet(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.claimEmbeddedWalletRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    claimEmbeddedWalletOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling claimEmbeddedWalletOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/passcode/claim`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    claimEmbeddedWalletOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.claimEmbeddedWalletOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Completes the passkey recovery process for a user\'s passkey embedded wallet
     * Completes the passkey recovery process for a user\'s passkey embedded wallet
     */
    completePasskeyRecoveryRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling completePasskeyRecovery.');
            }
            if (requestParameters.completePasskeyRecoveryRequest === null || requestParameters.completePasskeyRecoveryRequest === undefined) {
                throw new RequiredError('completePasskeyRecoveryRequest', 'Required parameter requestParameters.completePasskeyRecoveryRequest was null or undefined when calling completePasskeyRecovery.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/passkeyRecovery`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: CompletePasskeyRecoveryRequestToJSON(requestParameters.completePasskeyRecoveryRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Completes the passkey recovery process for a user\'s passkey embedded wallet
     * Completes the passkey recovery process for a user\'s passkey embedded wallet
     */
    completePasskeyRecovery(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.completePasskeyRecoveryRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Initialize email verification process
     */
    createEmailVerificationRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling createEmailVerification.');
            }
            if (requestParameters.emailVerificationCreateRequest === null || requestParameters.emailVerificationCreateRequest === undefined) {
                throw new RequiredError('emailVerificationCreateRequest', 'Required parameter requestParameters.emailVerificationCreateRequest was null or undefined when calling createEmailVerification.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/emailVerifications/create`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: EmailVerificationCreateRequestToJSON(requestParameters.emailVerificationCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => EmailVerificationCreateResponseFromJSON(jsonValue));
        });
    }
    /**
     * Initialize email verification process
     */
    createEmailVerification(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.createEmailVerificationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    createEmailVerificationOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling createEmailVerificationOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/emailVerifications/create`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    createEmailVerificationOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.createEmailVerificationOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Create one or more embedded wallets for a user
     * Create one or more new embedded wallets for a user
     */
    createEmbeddedWalletsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling createEmbeddedWallets.');
            }
            if (requestParameters.createEmbeddedWalletsRequest === null || requestParameters.createEmbeddedWalletsRequest === undefined) {
                throw new RequiredError('createEmbeddedWalletsRequest', 'Required parameter requestParameters.createEmbeddedWalletsRequest was null or undefined when calling createEmbeddedWallets.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateEmbeddedWalletsRequestToJSON(requestParameters.createEmbeddedWalletsRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Create one or more embedded wallets for a user
     * Create one or more new embedded wallets for a user
     */
    createEmbeddedWallets(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.createEmbeddedWalletsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    createEmbeddedWalletsOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling createEmbeddedWalletsOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    createEmbeddedWalletsOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.createEmbeddedWalletsOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Generate new recovery codes for user
     */
    createNewRecoveryCodesRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling createNewRecoveryCodes.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/recovery`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MFARegenRecoveryCodesResponseFromJSON(jsonValue));
        });
    }
    /**
     * Generate new recovery codes for user
     */
    createNewRecoveryCodes(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.createNewRecoveryCodesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Initialize sms verification process
     */
    createSmsVerificationRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling createSmsVerification.');
            }
            if (requestParameters.smsVerificationCreateRequest === null || requestParameters.smsVerificationCreateRequest === undefined) {
                throw new RequiredError('smsVerificationCreateRequest', 'Required parameter requestParameters.smsVerificationCreateRequest was null or undefined when calling createSmsVerification.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/smsVerifications/create`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SmsVerificationCreateRequestToJSON(requestParameters.smsVerificationCreateRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SmsVerificationCreateResponseFromJSON(jsonValue));
        });
    }
    /**
     * Initialize sms verification process
     */
    createSmsVerification(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.createSmsVerificationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    createSmsVerificationOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling createSmsVerificationOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/smsVerifications/create`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    createSmsVerificationOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.createSmsVerificationOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Endpoint to send minimal wallet information for a connect-only or connect-first visitor.
     * Create a visit
     */
    createVisitRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling createVisit.');
            }
            if (requestParameters.connectRequest === null || requestParameters.connectRequest === undefined) {
                throw new RequiredError('connectRequest', 'Required parameter requestParameters.connectRequest was null or undefined when calling createVisit.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/connect`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ConnectRequestToJSON(requestParameters.connectRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Endpoint to send minimal wallet information for a connect-only or connect-first visitor.
     * Create a visit
     */
    createVisit(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.createVisitRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Create a new waas account
     * Create a new waas account
     */
    createWaasAccountRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling createWaasAccount.');
            }
            if (requestParameters.createWaasAccountRequest === null || requestParameters.createWaasAccountRequest === undefined) {
                throw new RequiredError('createWaasAccountRequest', 'Required parameter requestParameters.createWaasAccountRequest was null or undefined when calling createWaasAccount.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/create`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateWaasAccountRequestToJSON(requestParameters.createWaasAccountRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OpenRoomResponseWithServerKeygenIdsFromJSON(jsonValue));
        });
    }
    /**
     * Create a new waas account
     * Create a new waas account
     */
    createWaasAccount(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.createWaasAccountRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    createWaasAccountOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling createWaasAccountOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/create`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    createWaasAccountOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.createWaasAccountOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Add a wallet account to a user\'s existing Turnkey HD wallet
     * Add a wallet account to a user\'s existing Turnkey HD wallet
     */
    createWalletAccountRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling createWalletAccount.');
            }
            if (requestParameters.createWalletAccountRequest === null || requestParameters.createWalletAccountRequest === undefined) {
                throw new RequiredError('createWalletAccountRequest', 'Required parameter requestParameters.createWalletAccountRequest was null or undefined when calling createWalletAccount.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/walletAccounts`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateWalletAccountRequestToJSON(requestParameters.createWalletAccountRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Add a wallet account to a user\'s existing Turnkey HD wallet
     * Add a wallet account to a user\'s existing Turnkey HD wallet
     */
    createWalletAccount(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.createWalletAccountRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Deletes the embedded wallets for a user
     * Deletes the embedded wallets for a user
     */
    deleteEmbeddedWalletsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling deleteEmbeddedWallets.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
                body: DeleteEmbeddedWalletsRequestToJSON(requestParameters.deleteEmbeddedWalletsRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Deletes the embedded wallets for a user
     * Deletes the embedded wallets for a user
     */
    deleteEmbeddedWallets(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.deleteEmbeddedWalletsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Delete a device (if not default device)
     */
    deleteMfaDeviceRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling deleteMfaDevice.');
            }
            if (requestParameters.mfaDeviceId === null || requestParameters.mfaDeviceId === undefined) {
                throw new RequiredError('mfaDeviceId', 'Required parameter requestParameters.mfaDeviceId was null or undefined when calling deleteMfaDevice.');
            }
            if (requestParameters.xMfaAuthToken === null || requestParameters.xMfaAuthToken === undefined) {
                throw new RequiredError('xMfaAuthToken', 'Required parameter requestParameters.xMfaAuthToken was null or undefined when calling deleteMfaDevice.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xMfaAuthToken !== undefined && requestParameters.xMfaAuthToken !== null) {
                headerParameters['x-mfa-auth-token'] = String(requestParameters.xMfaAuthToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/{mfaDeviceId}`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"mfaDeviceId"}}`, encodeURIComponent(String(requestParameters.mfaDeviceId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Delete a device (if not default device)
     */
    deleteMfaDevice(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.deleteMfaDeviceRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    emailAuthOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling emailAuthOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/emailAuth`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    emailAuthOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.emailAuthOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    emailProviderOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling emailProviderOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/emailProvider`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    emailProviderOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.emailProviderOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    embeddedWalletDeleteRequestOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling embeddedWalletDeleteRequestOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/deleteRequest`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    embeddedWalletDeleteRequestOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.embeddedWalletDeleteRequestOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Requests an export of an embedded wallet
     * Requests an export of an embedded wallet
     */
    embeddedWalletExportRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling embeddedWalletExport.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling embeddedWalletExport.');
            }
            if (requestParameters.activityId === null || requestParameters.activityId === undefined) {
                throw new RequiredError('activityId', 'Required parameter requestParameters.activityId was null or undefined when calling embeddedWalletExport.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/{walletId}/activities/{activityId}/export`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))).replace(`{${"activityId"}}`, encodeURIComponent(String(requestParameters.activityId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ExportEmbeddedWalletResponseFromJSON(jsonValue));
        });
    }
    /**
     * Requests an export of an embedded wallet
     * Requests an export of an embedded wallet
     */
    embeddedWalletExport(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.embeddedWalletExportRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    embeddedWalletExportOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling embeddedWalletExportOptions.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling embeddedWalletExportOptions.');
            }
            if (requestParameters.activityId === null || requestParameters.activityId === undefined) {
                throw new RequiredError('activityId', 'Required parameter requestParameters.activityId was null or undefined when calling embeddedWalletExportOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/{walletId}/activities/{activityId}/export`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))).replace(`{${"activityId"}}`, encodeURIComponent(String(requestParameters.activityId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    embeddedWalletExportOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.embeddedWalletExportOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    eventsOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling eventsOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/events`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    eventsOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.eventsOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Export private Key of a waas account
     */
    exportPrivateKeyRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling exportPrivateKey.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling exportPrivateKey.');
            }
            if (requestParameters.exportWaasWalletPrivateKeyRequest === null || requestParameters.exportWaasWalletPrivateKeyRequest === undefined) {
                throw new RequiredError('exportWaasWalletPrivateKeyRequest', 'Required parameter requestParameters.exportWaasWalletPrivateKeyRequest was null or undefined when calling exportPrivateKey.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/{walletId}/privateKey/export`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ExportWaasWalletPrivateKeyRequestToJSON(requestParameters.exportWaasWalletPrivateKeyRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OpenRoomResponseWithServerKeygenIdsFromJSON(jsonValue));
        });
    }
    /**
     * Export private Key of a waas account
     */
    exportPrivateKey(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.exportPrivateKeyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    exportPrivateKeyOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling exportPrivateKeyOptions.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling exportPrivateKeyOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/{walletId}/privateKey/export`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    exportPrivateKeyOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.exportPrivateKeyOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Endpoint to sign-in using a token issued by an external auth provider
     */
    externalAuthSigninRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling externalAuthSignin.');
            }
            if (requestParameters.externalAuthSigninRequest === null || requestParameters.externalAuthSigninRequest === undefined) {
                throw new RequiredError('externalAuthSigninRequest', 'Required parameter requestParameters.externalAuthSigninRequest was null or undefined when calling externalAuthSignin.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/externalAuth/signin`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ExternalAuthSigninRequestToJSON(requestParameters.externalAuthSigninRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Endpoint to sign-in using a token issued by an external auth provider
     */
    externalAuthSignin(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.externalAuthSigninRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    externalAuthSigninOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling externalAuthSigninOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/externalAuth/signin`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    externalAuthSigninOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.externalAuthSigninOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * [DEPRECATED] Please use /externalAuth/signin instead
     */
    externalAuthVerifyRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling externalAuthVerify.');
            }
            if (requestParameters.externalAuthSigninRequest === null || requestParameters.externalAuthSigninRequest === undefined) {
                throw new RequiredError('externalAuthSigninRequest', 'Required parameter requestParameters.externalAuthSigninRequest was null or undefined when calling externalAuthVerify.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/externalAuth/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ExternalAuthSigninRequestToJSON(requestParameters.externalAuthSigninRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * [DEPRECATED] Please use /externalAuth/signin instead
     */
    externalAuthVerify(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.externalAuthVerifyRaw(requestParameters, initOverrides);
        });
    }
    /**
     * [DEPRECATED] Options call for this endpoint
     */
    externalAuthVerifyOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling externalAuthVerifyOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/externalAuth/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * [DEPRECATED] Options call for this endpoint
     */
    externalAuthVerifyOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.externalAuthVerifyOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Farcaster SignIn endpoint to exchange SIWF data
     * Farcaster provider SignIn endpoint
     */
    farcasterSignInRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling farcasterSignIn.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/farcaster/signin`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FarcasterSignInRequestToJSON(requestParameters.farcasterSignInRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Farcaster SignIn endpoint to exchange SIWF data
     * Farcaster provider SignIn endpoint
     */
    farcasterSignIn(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.farcasterSignInRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    farcasterSignInOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling farcasterSignInOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/farcaster/signin`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    farcasterSignInOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.farcasterSignInOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Farcaster Verify endpoint to exchange SIWF data
     * Farcaster provider Verify endpoint
     */
    farcasterVerifyRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling farcasterVerify.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/farcaster/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FarcasterSignInRequestToJSON(requestParameters.farcasterSignInRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Farcaster Verify endpoint to exchange SIWF data
     * Farcaster provider Verify endpoint
     */
    farcasterVerify(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.farcasterVerifyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    farcasterVerifyOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling farcasterVerifyOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/farcaster/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    farcasterVerifyOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.farcasterVerifyOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Get the token balances for an account
     */
    getAccountBalancesRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getAccountBalances.');
            }
            if (requestParameters.chainName === null || requestParameters.chainName === undefined) {
                throw new RequiredError('chainName', 'Required parameter requestParameters.chainName was null or undefined when calling getAccountBalances.');
            }
            if (requestParameters.accountAddress === null || requestParameters.accountAddress === undefined) {
                throw new RequiredError('accountAddress', 'Required parameter requestParameters.accountAddress was null or undefined when calling getAccountBalances.');
            }
            const queryParameters = {};
            if (requestParameters.networkId !== undefined) {
                queryParameters['networkId'] = requestParameters.networkId;
            }
            if (requestParameters.accountAddress !== undefined) {
                queryParameters['accountAddress'] = requestParameters.accountAddress;
            }
            if (requestParameters.includePrices !== undefined) {
                queryParameters['includePrices'] = requestParameters.includePrices;
            }
            if (requestParameters.includeNative !== undefined) {
                queryParameters['includeNative'] = requestParameters.includeNative;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/chains/{chainName}/balances`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"chainName"}}`, encodeURIComponent(String(requestParameters.chainName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(TokenBalanceFromJSON));
        });
    }
    /**
     * Get the token balances for an account
     */
    getAccountBalances(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getAccountBalancesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    getAccountBalancesOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getAccountBalancesOptions.');
            }
            if (requestParameters.chainName === null || requestParameters.chainName === undefined) {
                throw new RequiredError('chainName', 'Required parameter requestParameters.chainName was null or undefined when calling getAccountBalancesOptions.');
            }
            if (requestParameters.networkId === null || requestParameters.networkId === undefined) {
                throw new RequiredError('networkId', 'Required parameter requestParameters.networkId was null or undefined when calling getAccountBalancesOptions.');
            }
            if (requestParameters.accountAddress === null || requestParameters.accountAddress === undefined) {
                throw new RequiredError('accountAddress', 'Required parameter requestParameters.accountAddress was null or undefined when calling getAccountBalancesOptions.');
            }
            const queryParameters = {};
            if (requestParameters.networkId !== undefined) {
                queryParameters['networkId'] = requestParameters.networkId;
            }
            if (requestParameters.accountAddress !== undefined) {
                queryParameters['accountAddress'] = requestParameters.accountAddress;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/chains/{chainName}/balances`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"chainName"}}`, encodeURIComponent(String(requestParameters.chainName))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    getAccountBalancesOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.getAccountBalancesOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Get auth token for given embedded wallet type
     */
    getAuthTokenRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getAuthToken.');
            }
            const queryParameters = {};
            if (requestParameters.type !== undefined) {
                queryParameters['type'] = requestParameters.type;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/authToken`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => EmbeddedWalletAuthTokenFromJSON(jsonValue));
        });
    }
    /**
     * Get auth token for given embedded wallet type
     */
    getAuthToken(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getAuthTokenRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    getAuthTokenOptsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getAuthTokenOpts.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/authToken`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    getAuthTokenOpts(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.getAuthTokenOptsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Fetch user profile for the current authenticated user
     */
    getAuthenticatedUserRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getAuthenticatedUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SdkUserFromJSON(jsonValue));
        });
    }
    /**
     * Fetch user profile for the current authenticated user
     */
    getAuthenticatedUser(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getAuthenticatedUserRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Generates the turnkey request body for a user\'s create wallet account request
     * Generates the turnkey request body for a user\'s create wallet account request
     */
    getCreateWalletAccountRequestRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getCreateWalletAccountRequest.');
            }
            if (requestParameters.chain === null || requestParameters.chain === undefined) {
                throw new RequiredError('chain', 'Required parameter requestParameters.chain was null or undefined when calling getCreateWalletAccountRequest.');
            }
            const queryParameters = {};
            if (requestParameters.chain !== undefined) {
                queryParameters['chain'] = requestParameters.chain;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/walletAccounts/createRequest`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => TurnkeyCreateWalletAccountsRequestBodyFromJSON(jsonValue));
        });
    }
    /**
     * Generates the turnkey request body for a user\'s create wallet account request
     * Generates the turnkey request body for a user\'s create wallet account request
     */
    getCreateWalletAccountRequest(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getCreateWalletAccountRequestRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Exchange rates for the given currency
     */
    getCurrencyExchangeRatesRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getCurrencyExchangeRates.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/exchangeRates`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(CurrencyFromJSON));
        });
    }
    /**
     * Exchange rates for the given currency
     */
    getCurrencyExchangeRates(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getCurrencyExchangeRatesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    getCurrencyExchangeRatesOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getCurrencyExchangeRatesOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/exchangeRates`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    getCurrencyExchangeRatesOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.getCurrencyExchangeRatesOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Return the email provider to be used for signing in with a given email. If an external provider such as magicLink is disabled, this endpoint would return emailOnly. If an external provider such as magicLink is enabled, it will return emailOnly when the email already exists in Dynamic and it is associated with a wallet, otherwise it will return magicLink.
     * Get signin email provider
     */
    getEmailProviderRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getEmailProvider.');
            }
            if (requestParameters.email === null || requestParameters.email === undefined) {
                throw new RequiredError('email', 'Required parameter requestParameters.email was null or undefined when calling getEmailProvider.');
            }
            const queryParameters = {};
            if (requestParameters.email !== undefined) {
                queryParameters['email'] = requestParameters.email;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/emailProvider`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => EmailProviderResponseFromJSON(jsonValue));
        });
    }
    /**
     * Return the email provider to be used for signing in with a given email. If an external provider such as magicLink is disabled, this endpoint would return emailOnly. If an external provider such as magicLink is enabled, it will return emailOnly when the email already exists in Dynamic and it is associated with a wallet, otherwise it will return magicLink.
     * Get signin email provider
     */
    getEmailProvider(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getEmailProviderRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    getEmbeddedWalletBackupOptionRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getEmbeddedWalletBackupOption.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/backup`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    getEmbeddedWalletBackupOption(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.getEmbeddedWalletBackupOptionRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Return the backup key for the embedded wallet of the authenticated user
     */
    getEmbeddedWalletBackupsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getEmbeddedWalletBackups.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/backup`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => EmbeddedWalletSecretFromJSON(jsonValue));
        });
    }
    /**
     * Return the backup key for the embedded wallet of the authenticated user
     */
    getEmbeddedWalletBackups(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getEmbeddedWalletBackupsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Return the passcode for the pregenerated embedded wallet of the authenticated user
     */
    getEmbeddedWalletPasscodeRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getEmbeddedWalletPasscode.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/passcode`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => EmbeddedWalletSecretFromJSON(jsonValue));
        });
    }
    /**
     * Return the passcode for the pregenerated embedded wallet of the authenticated user
     */
    getEmbeddedWalletPasscode(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getEmbeddedWalletPasscodeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    getEmbeddedWalletPasscodeOptionRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getEmbeddedWalletPasscodeOption.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/passcode`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    getEmbeddedWalletPasscodeOption(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.getEmbeddedWalletPasscodeOptionRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Generates the turnkey request body for a user\'s delete wallets request
     * Generates the turnkey request body for a user\'s delete wallets request
     */
    getEmbeddedWalletsDeleteRequestRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getEmbeddedWalletsDeleteRequest.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/deleteRequest`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => TurnkeyDeleteEmbeddedWalletsRequestBodyFromJSON(jsonValue));
        });
    }
    /**
     * Generates the turnkey request body for a user\'s delete wallets request
     * Generates the turnkey request body for a user\'s delete wallets request
     */
    getEmbeddedWalletsDeleteRequest(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getEmbeddedWalletsDeleteRequestRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the environment\'s settings
     */
    getEnvironmentSettingsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getEnvironmentSettings.');
            }
            const queryParameters = {};
            if (requestParameters.sdkVersion !== undefined) {
                queryParameters['sdkVersion'] = requestParameters.sdkVersion;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/settings`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ProjectSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Get the environment\'s settings
     */
    getEnvironmentSettings(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getEnvironmentSettingsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the global wallet settings for the environment
     */
    getGlobalWalletsSettingsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getGlobalWalletsSettings.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/globalWallets/settings`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => GlobalWalletSettingsFromJSON(jsonValue));
        });
    }
    /**
     * Get the global wallet settings for the environment
     */
    getGlobalWalletsSettings(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getGlobalWalletsSettingsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Health check endpoint to check for uptime of API.
     */
    getHealthcheckRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getHealthcheck.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/healthcheck`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => HealthcheckResponseFromJSON(jsonValue));
        });
    }
    /**
     * Health check endpoint to check for uptime of API.
     */
    getHealthcheck(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getHealthcheckRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    getHealthcheckOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getHealthcheckOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/healthcheck`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    getHealthcheckOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.getHealthcheckOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Find jwks for public key
     */
    getJwksByEnvironmentIdRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getJwksByEnvironmentId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/.well-known/jwks`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => JwksResponseFromJSON(jsonValue));
        });
    }
    /**
     * Find jwks for public key
     */
    getJwksByEnvironmentId(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getJwksByEnvironmentIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get the current user\'s MFA by device id
     */
    getMfaDeviceRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getMfaDevice.');
            }
            if (requestParameters.mfaDeviceId === null || requestParameters.mfaDeviceId === undefined) {
                throw new RequiredError('mfaDeviceId', 'Required parameter requestParameters.mfaDeviceId was null or undefined when calling getMfaDevice.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/{mfaDeviceId}`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"mfaDeviceId"}}`, encodeURIComponent(String(requestParameters.mfaDeviceId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MFADeviceFromJSON(jsonValue));
        });
    }
    /**
     * Get the current user\'s MFA by device id
     */
    getMfaDevice(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getMfaDeviceRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    getMfaDeviceOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getMfaDeviceOptions.');
            }
            if (requestParameters.mfaDeviceId === null || requestParameters.mfaDeviceId === undefined) {
                throw new RequiredError('mfaDeviceId', 'Required parameter requestParameters.mfaDeviceId was null or undefined when calling getMfaDeviceOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/{mfaDeviceId}`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"mfaDeviceId"}}`, encodeURIComponent(String(requestParameters.mfaDeviceId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    getMfaDeviceOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.getMfaDeviceOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Find the configuration for the enabled networks associated to an environment
     */
    getNetworksConfigurationByEnvIdRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getNetworksConfigurationByEnvId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/networks`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => jsonValue.map(NetworkConfigurationResponseFromJSON));
        });
    }
    /**
     * Find the configuration for the enabled networks associated to an environment
     */
    getNetworksConfigurationByEnvId(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getNetworksConfigurationByEnvIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create nonce for authentication flow
     */
    getNonceRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getNonce.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/nonce`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => NonceResponseFromJSON(jsonValue));
        });
    }
    /**
     * Create nonce for authentication flow
     */
    getNonce(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getNonceRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get recovery codes
     */
    getRecoveryCodesRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getRecoveryCodes.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/recovery`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MFAGetRecoveryCodesResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get recovery codes
     */
    getRecoveryCodes(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getRecoveryCodesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Find the configuration for the enabled onramps associated to an environment
     * Configuration for enabled onramps
     */
    getSupportedOnrampsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getSupportedOnramps.');
            }
            if (requestParameters.walletAddress === null || requestParameters.walletAddress === undefined) {
                throw new RequiredError('walletAddress', 'Required parameter requestParameters.walletAddress was null or undefined when calling getSupportedOnramps.');
            }
            if (requestParameters.chain === null || requestParameters.chain === undefined) {
                throw new RequiredError('chain', 'Required parameter requestParameters.chain was null or undefined when calling getSupportedOnramps.');
            }
            const queryParameters = {};
            if (requestParameters.walletAddress !== undefined) {
                queryParameters['walletAddress'] = requestParameters.walletAddress;
            }
            if (requestParameters.chain !== undefined) {
                queryParameters['chain'] = requestParameters.chain;
            }
            if (requestParameters.networkId !== undefined) {
                queryParameters['networkId'] = requestParameters.networkId;
            }
            if (requestParameters.token !== undefined) {
                queryParameters['token'] = requestParameters.token;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/onramps`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SupportedOnrampsResponseFromJSON(jsonValue));
        });
    }
    /**
     * Find the configuration for the enabled onramps associated to an environment
     * Configuration for enabled onramps
     */
    getSupportedOnramps(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getSupportedOnrampsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get HTML with rendered Telegram login widget
     */
    getTelegramAuthRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getTelegramAuth.');
            }
            if (requestParameters.state === null || requestParameters.state === undefined) {
                throw new RequiredError('state', 'Required parameter requestParameters.state was null or undefined when calling getTelegramAuth.');
            }
            const queryParameters = {};
            if (requestParameters.state !== undefined) {
                queryParameters['state'] = requestParameters.state;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/telegram/auth`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new TextApiResponse(response);
        });
    }
    /**
     * Get HTML with rendered Telegram login widget
     */
    getTelegramAuth(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getTelegramAuthRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Check if the unique field value is already taken. For example, an enabled unique username or unique email. This also works with enabled unique custom fields.
     * Check user field uniqueness
     */
    getUserFieldsCheckRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getUserFieldsCheck.');
            }
            const queryParameters = {};
            if (requestParameters.filter !== undefined) {
                queryParameters['filter'] = requestParameters.filter;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/check`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => UserFieldsCheckResponseFromJSON(jsonValue));
        });
    }
    /**
     * Check if the unique field value is already taken. For example, an enabled unique username or unique email. This also works with enabled unique custom fields.
     * Check user field uniqueness
     */
    getUserFieldsCheck(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getUserFieldsCheckRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    getUserFieldsCheckOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getUserFieldsCheckOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/check`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    getUserFieldsCheckOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.getUserFieldsCheckOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Get the current user\'s MFA Devices
     */
    getUserMfaDevicesRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getUserMfaDevices.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MFAListDevicesResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get the current user\'s MFA Devices
     */
    getUserMfaDevices(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getUserMfaDevicesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Gets passkey data associated with a user
     */
    getUserPasskeysRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling getUserPasskeys.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/passkeys`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => GetUserPasskeysResponseFromJSON(jsonValue));
        });
    }
    /**
     * Gets passkey data associated with a user
     */
    getUserPasskeys(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.getUserPasskeysRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    globalWalletsSettingsOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling globalWalletsSettingsOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/globalWallets/settings`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    globalWalletsSettingsOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.globalWalletsSettingsOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Hard delete the authenticated user
     * Hard delete a user
     */
    hardDeleteUserRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling hardDeleteUser.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Hard delete the authenticated user
     * Hard delete a user
     */
    hardDeleteUser(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.hardDeleteUserRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Import a private key to create a waas account
     * Import an existing private key to create a waas account
     */
    importPrivateKeyRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling importPrivateKey.');
            }
            if (requestParameters.importWaasPrivateKeyRequest === null || requestParameters.importWaasPrivateKeyRequest === undefined) {
                throw new RequiredError('importWaasPrivateKeyRequest', 'Required parameter requestParameters.importWaasPrivateKeyRequest was null or undefined when calling importPrivateKey.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/privateKey/import`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ImportWaasPrivateKeyRequestToJSON(requestParameters.importWaasPrivateKeyRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OpenRoomResponseWithServerKeygenIdsFromJSON(jsonValue));
        });
    }
    /**
     * Import a private key to create a waas account
     * Import an existing private key to create a waas account
     */
    importPrivateKey(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.importPrivateKeyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    importPrivateKeyOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling importPrivateKeyOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/privateKey/import`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    importPrivateKeyOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.importPrivateKeyOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * This endpoint initializes a secure oauth authentication sequence by providing the state and current url path to the API.
     * Initialize oauth auth sequence
     */
    initAuthRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling initAuth.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling initAuth.');
            }
            if (requestParameters.oauthInitAuthRequest === null || requestParameters.oauthInitAuthRequest === undefined) {
                throw new RequiredError('oauthInitAuthRequest', 'Required parameter requestParameters.oauthInitAuthRequest was null or undefined when calling initAuth.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/initAuth`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: OauthInitAuthRequestToJSON(requestParameters.oauthInitAuthRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * This endpoint initializes a secure oauth authentication sequence by providing the state and current url path to the API.
     * Initialize oauth auth sequence
     */
    initAuth(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.initAuthRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    initAuthOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling initAuthOptions.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling initAuthOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/initAuth`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    initAuthOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.initAuthOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Initialize the email authentication process for a user\'s embedded wallet
     * Initialize the email authentication process for a user\'s embedded wallet
     */
    initEmailAuthRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling initEmailAuth.');
            }
            if (requestParameters.initEmailAuthRequest === null || requestParameters.initEmailAuthRequest === undefined) {
                throw new RequiredError('initEmailAuthRequest', 'Required parameter requestParameters.initEmailAuthRequest was null or undefined when calling initEmailAuth.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/emailAuth`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InitEmailAuthRequestToJSON(requestParameters.initEmailAuthRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => InitEmailAuthResponseFromJSON(jsonValue));
        });
    }
    /**
     * Initialize the email authentication process for a user\'s embedded wallet
     * Initialize the email authentication process for a user\'s embedded wallet
     */
    initEmailAuth(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.initEmailAuthRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Initialize the passkey recovery process for a user\'s passkey embedded wallet
     * Initialize the passkey recovery process for a user\'s passkey embedded wallet
     */
    initPasskeyRecoveryRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling initPasskeyRecovery.');
            }
            if (requestParameters.initPasskeyRecoveryRequest === null || requestParameters.initPasskeyRecoveryRequest === undefined) {
                throw new RequiredError('initPasskeyRecoveryRequest', 'Required parameter requestParameters.initPasskeyRecoveryRequest was null or undefined when calling initPasskeyRecovery.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/passkeyRecovery`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: InitPasskeyRecoveryRequestToJSON(requestParameters.initPasskeyRecoveryRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => InitPasskeyRecoveryResponseFromJSON(jsonValue));
        });
    }
    /**
     * Initialize the passkey recovery process for a user\'s passkey embedded wallet
     * Initialize the passkey recovery process for a user\'s passkey embedded wallet
     */
    initPasskeyRecovery(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.initPasskeyRecoveryRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    jwksOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling jwksOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/.well-known/jwks`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    jwksOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.jwksOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    listMfaDevicesOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling listMfaDevicesOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    listMfaDevicesOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.listMfaDevicesOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Update SDK settings for a specific environment
     */
    logDynamicSdkSettingsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling logDynamicSdkSettings.');
            }
            if (requestParameters.sdkSettingsRequest === null || requestParameters.sdkSettingsRequest === undefined) {
                throw new RequiredError('sdkSettingsRequest', 'Required parameter requestParameters.sdkSettingsRequest was null or undefined when calling logDynamicSdkSettings.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/sdkSettings`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SdkSettingsRequestToJSON(requestParameters.sdkSettingsRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Update SDK settings for a specific environment
     */
    logDynamicSdkSettings(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.logDynamicSdkSettingsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Used to merge two owned accounts connected by email address
     * After successful verification allow to merge two owned accounts
     */
    mergeUsersRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling mergeUsers.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/merge`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Used to merge two owned accounts connected by email address
     * After successful verification allow to merge two owned accounts
     */
    mergeUsers(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.mergeUsersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    mergeUsersOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling mergeUsersOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/merge`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    mergeUsersOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.mergeUsersOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    networksOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling networksOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/networks`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    networksOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.networksOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    nonceOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling nonceOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/nonce`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    nonceOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.nonceOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Endpoint where an oauth provider would return authorization HTML used for mobile-friendly login, such as Apple ID with Touch ID on enabled devices.
     * Oauth provider authorization endpoint
     */
    oauthAuthorizeHtmlRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthAuthorizeHtml.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthAuthorizeHtml.');
            }
            const queryParameters = {};
            if (requestParameters.scope !== undefined) {
                queryParameters['scope'] = requestParameters.scope;
            }
            if (requestParameters.state !== undefined) {
                queryParameters['state'] = requestParameters.state;
            }
            if (requestParameters.redirectUri !== undefined) {
                queryParameters['redirect_uri'] = requestParameters.redirectUri;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/authorizeHtml`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new TextApiResponse(response);
        });
    }
    /**
     * Endpoint where an oauth provider would return authorization HTML used for mobile-friendly login, such as Apple ID with Touch ID on enabled devices.
     * Oauth provider authorization endpoint
     */
    oauthAuthorizeHtml(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.oauthAuthorizeHtmlRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthAuthorizeHtmlOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthAuthorizeHtmlOptions.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthAuthorizeHtmlOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/authorizeHtml`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthAuthorizeHtmlOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.oauthAuthorizeHtmlOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Get redirect URL for Oauth provider login
     */
    oauthLoginRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthLogin.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthLogin.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/login`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Get redirect URL for Oauth provider login
     */
    oauthLogin(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.oauthLoginRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthLoginOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthLoginOptions.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthLoginOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/login`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthLoginOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.oauthLoginOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Get redirect URL for Oauth provider login. This will return a string that the SDK can manipulate before redirecting the browser to.
     */
    oauthLoginUrlRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthLoginUrl.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthLoginUrl.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/loginUrl`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OauthProviderLoginUrlFromJSON(jsonValue));
        });
    }
    /**
     * Get redirect URL for Oauth provider login. This will return a string that the SDK can manipulate before redirecting the browser to.
     */
    oauthLoginUrl(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.oauthLoginUrlRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthLoginUrlOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthLoginUrlOptions.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthLoginUrlOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/loginUrl`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthLoginUrlOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.oauthLoginUrlOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Endpoint where an oauth provider would redirect after a successful user authorizing the oauth application.
     * Oauth provider redirect endpoint for apple ID
     */
    oauthRedirectAppleRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthRedirectApple.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const consumes = [
                { contentType: 'application/x-www-form-urlencoded' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            canConsumeForm(consumes);
            let formParams;
            {
                formParams = new URLSearchParams();
            }
            if (requestParameters.code !== undefined) {
                formParams.append('code', requestParameters.code);
            }
            if (requestParameters.state !== undefined) {
                formParams.append('state', requestParameters.state);
            }
            if (requestParameters.idToken !== undefined) {
                formParams.append('id_token', requestParameters.idToken);
            }
            if (requestParameters.error !== undefined) {
                formParams.append('error', requestParameters.error);
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/apple/redirect`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new TextApiResponse(response);
        });
    }
    /**
     * Endpoint where an oauth provider would redirect after a successful user authorizing the oauth application.
     * Oauth provider redirect endpoint for apple ID
     */
    oauthRedirectApple(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.oauthRedirectAppleRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthRedirectAppleOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthRedirectAppleOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/apple/redirect`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthRedirectAppleOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.oauthRedirectAppleOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Endpoint where an oauth provider would redirect after a successful user authorizing the oauth application.
     * Oauth provider redirect endpoint
     */
    oauthRedirectCodeRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthRedirectCode.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthRedirectCode.');
            }
            const queryParameters = {};
            if (requestParameters.code !== undefined) {
                queryParameters['code'] = requestParameters.code;
            }
            if (requestParameters.scope !== undefined) {
                queryParameters['scope'] = requestParameters.scope;
            }
            if (requestParameters.state !== undefined) {
                queryParameters['state'] = requestParameters.state;
            }
            if (requestParameters.authuser !== undefined) {
                queryParameters['authuser'] = requestParameters.authuser;
            }
            if (requestParameters.prompt !== undefined) {
                queryParameters['prompt'] = requestParameters.prompt;
            }
            if (requestParameters.error !== undefined) {
                queryParameters['error'] = requestParameters.error;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/redirect`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new TextApiResponse(response);
        });
    }
    /**
     * Endpoint where an oauth provider would redirect after a successful user authorizing the oauth application.
     * Oauth provider redirect endpoint
     */
    oauthRedirectCode(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.oauthRedirectCodeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthRedirectOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthRedirectOptions.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthRedirectOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/redirect`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthRedirectOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.oauthRedirectOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Returns the authorization code or error retuned by oauth provider
     */
    oauthResultRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthResult.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthResult.');
            }
            if (requestParameters.oauthResultRequest === null || requestParameters.oauthResultRequest === undefined) {
                throw new RequiredError('oauthResultRequest', 'Required parameter requestParameters.oauthResultRequest was null or undefined when calling oauthResult.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/oauthResult`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: OauthResultRequestToJSON(requestParameters.oauthResultRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OauthResultResponseFromJSON(jsonValue));
        });
    }
    /**
     * Returns the authorization code or error retuned by oauth provider
     */
    oauthResult(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.oauthResultRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthResultOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthResultOptions.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthResultOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/oauthResult`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthResultOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.oauthResultOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Standard OAuth SignIn callback to exchange temproary code for oauth access and return a valid Dynamic JWT and user
     * Oauth provider SignIn endpoint
     */
    oauthSignInRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthSignIn.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthSignIn.');
            }
            if (requestParameters.oauthRequest === null || requestParameters.oauthRequest === undefined) {
                throw new RequiredError('oauthRequest', 'Required parameter requestParameters.oauthRequest was null or undefined when calling oauthSignIn.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/signIn`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: OauthRequestToJSON(requestParameters.oauthRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Standard OAuth SignIn callback to exchange temproary code for oauth access and return a valid Dynamic JWT and user
     * Oauth provider SignIn endpoint
     */
    oauthSignIn(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.oauthSignInRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthSignInOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthSignInOptions.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthSignInOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/signIn`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthSignInOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.oauthSignInOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Standard OAuth verify callback to exchange temproary code for oauth access
     * Oauth provider verify endpoint
     */
    oauthVerifyRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthVerify.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthVerify.');
            }
            if (requestParameters.oauthRequest === null || requestParameters.oauthRequest === undefined) {
                throw new RequiredError('oauthRequest', 'Required parameter requestParameters.oauthRequest was null or undefined when calling oauthVerify.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: OauthRequestToJSON(requestParameters.oauthRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Standard OAuth verify callback to exchange temproary code for oauth access
     * Oauth provider verify endpoint
     */
    oauthVerify(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.oauthVerifyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthVerifyOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling oauthVerifyOptions.');
            }
            if (requestParameters.providerType === null || requestParameters.providerType === undefined) {
                throw new RequiredError('providerType', 'Required parameter requestParameters.providerType was null or undefined when calling oauthVerifyOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/providers/{providerType}/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"providerType"}}`, encodeURIComponent(String(requestParameters.providerType))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    oauthVerifyOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.oauthVerifyOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    onrampsOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling onrampsOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/onramps`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    onrampsOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.onrampsOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Add fees to a Solana transaction
     */
    optimizeTransactionRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling optimizeTransaction.');
            }
            if (requestParameters.solanaTransactionOptimizationRequest === null || requestParameters.solanaTransactionOptimizationRequest === undefined) {
                throw new RequiredError('solanaTransactionOptimizationRequest', 'Required parameter requestParameters.solanaTransactionOptimizationRequest was null or undefined when calling optimizeTransaction.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/solana/optimizeTransaction`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SolanaTransactionOptimizationRequestToJSON(requestParameters.solanaTransactionOptimizationRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SolanaTransactionOptimizationResponseFromJSON(jsonValue));
        });
    }
    /**
     * Add fees to a Solana transaction
     */
    optimizeTransaction(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.optimizeTransactionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    optimizeTransactionOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling optimizeTransactionOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/solana/optimizeTransaction`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    optimizeTransactionOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.optimizeTransactionOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    optionsConnectRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling optionsConnect.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/connect`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    optionsConnect(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.optionsConnectRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    passkeyRecoveryOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling passkeyRecoveryOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/passkeyRecovery`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    passkeyRecoveryOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.passkeyRecoveryOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Handle Telegram authentication
     */
    postTelegramAuthRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling postTelegramAuth.');
            }
            if (requestParameters.telegramPostRequest === null || requestParameters.telegramPostRequest === undefined) {
                throw new RequiredError('telegramPostRequest', 'Required parameter requestParameters.telegramPostRequest was null or undefined when calling postTelegramAuth.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/telegram/auth`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: TelegramPostRequestToJSON(requestParameters.telegramPostRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Handle Telegram authentication
     */
    postTelegramAuth(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.postTelegramAuthRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Endpoint to send minimal wallet information to the API to prefetch name service information for an address.
     * prefetch information for wallet address
     */
    prefetchRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling prefetch.');
            }
            if (requestParameters.prefetchRequest === null || requestParameters.prefetchRequest === undefined) {
                throw new RequiredError('prefetchRequest', 'Required parameter requestParameters.prefetchRequest was null or undefined when calling prefetch.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/prefetch`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PrefetchRequestToJSON(requestParameters.prefetchRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Endpoint to send minimal wallet information to the API to prefetch name service information for an address.
     * prefetch information for wallet address
     */
    prefetch(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.prefetchRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Publish events for SDK
     */
    publishEventRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling publishEvent.');
            }
            if (requestParameters.publishEvents === null || requestParameters.publishEvents === undefined) {
                throw new RequiredError('publishEvents', 'Required parameter requestParameters.publishEvents was null or undefined when calling publishEvent.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/events`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PublishEventsToJSON(requestParameters.publishEvents),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Publish events for SDK
     */
    publishEvent(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.publishEventRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Recover multiple keyShares
     */
    recoverKeySharesRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling recoverKeyShares.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling recoverKeyShares.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/{walletId}/keyShares/recover`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RecoverMultipleClientKeySharesRequestToJSON(requestParameters.recoverMultipleClientKeySharesRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RecoverMultipleClientKeySharesResponseFromJSON(jsonValue));
        });
    }
    /**
     * Recover multiple keyShares
     */
    recoverKeyShares(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.recoverKeySharesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    recoverKeySharesOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling recoverKeySharesOptions.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling recoverKeySharesOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/{walletId}/keyShares/recover`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    recoverKeySharesOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.recoverKeySharesOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    recoveryCodesOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling recoveryCodesOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/recovery`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    recoveryCodesOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.recoveryCodesOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    recoveryEmailOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling recoveryEmailOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/recoveryEmail`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    recoveryEmailOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.recoveryEmailOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Endpoint to refresh the JWT auth token using the current valid JWT auth token in the authorization header
     */
    refreshAuthRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling refreshAuth.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/refresh`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Endpoint to refresh the JWT auth token using the current valid JWT auth token in the authorization header
     */
    refreshAuth(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.refreshAuthRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Refresh keyshares
     */
    refreshKeySharesRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling refreshKeyShares.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling refreshKeyShares.');
            }
            if (requestParameters.refreshKeySharesRequest === null || requestParameters.refreshKeySharesRequest === undefined) {
                throw new RequiredError('refreshKeySharesRequest', 'Required parameter requestParameters.refreshKeySharesRequest was null or undefined when calling refreshKeyShares.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/{walletId}/refresh`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RefreshKeySharesRequestToJSON(requestParameters.refreshKeySharesRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OpenRoomResponseWithServerKeygenIdsFromJSON(jsonValue));
        });
    }
    /**
     * Refresh keyshares
     */
    refreshKeyShares(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.refreshKeySharesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    refreshKeySharesOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling refreshKeySharesOptions.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling refreshKeySharesOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/{walletId}/refresh`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    refreshKeySharesOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.refreshKeySharesOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    refreshOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling refreshOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/refresh`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    refreshOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.refreshOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Register a new Passkey MFA device
     */
    registerPasskeyMfaDeviceRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling registerPasskeyMfaDevice.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/register/passkey`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MFARegisterPasskeyDeviceGetResponseFromJSON(jsonValue));
        });
    }
    /**
     * Register a new Passkey MFA device
     */
    registerPasskeyMfaDevice(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.registerPasskeyMfaDeviceRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    registerPasskeyMfaDeviceOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling registerPasskeyMfaDeviceOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/register/passkey`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    registerPasskeyMfaDeviceOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.registerPasskeyMfaDeviceOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Verify Passkey MFA device
     */
    registerPasskeyMfaDeviceVerifyRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling registerPasskeyMfaDeviceVerify.');
            }
            if (requestParameters.mFARegisterPasskeyDevicePostRequest === null || requestParameters.mFARegisterPasskeyDevicePostRequest === undefined) {
                throw new RequiredError('mFARegisterPasskeyDevicePostRequest', 'Required parameter requestParameters.mFARegisterPasskeyDevicePostRequest was null or undefined when calling registerPasskeyMfaDeviceVerify.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/register/passkey`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MFARegisterPasskeyDevicePostRequestToJSON(requestParameters.mFARegisterPasskeyDevicePostRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Verify Passkey MFA device
     */
    registerPasskeyMfaDeviceVerify(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.registerPasskeyMfaDeviceVerifyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Registers a session key for an embedded wallet
     * Registers a session key for an embedded wallet
     */
    registerSessionKeyRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling registerSessionKey.');
            }
            if (requestParameters.registerSessionKeyRequest === null || requestParameters.registerSessionKeyRequest === undefined) {
                throw new RequiredError('registerSessionKeyRequest', 'Required parameter requestParameters.registerSessionKeyRequest was null or undefined when calling registerSessionKey.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/sessionKey`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RegisterSessionKeyRequestToJSON(requestParameters.registerSessionKeyRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => RegisterEmbeddedWalletSessionKeyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Registers a session key for an embedded wallet
     * Registers a session key for an embedded wallet
     */
    registerSessionKey(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.registerSessionKeyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Register a new TOTP MFA device and get Totp Secret
     */
    registerTotpMfaDeviceRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling registerTotpMfaDevice.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/register/totp`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MFARegisterTotpDeviceGetResponseFromJSON(jsonValue));
        });
    }
    /**
     * Register a new TOTP MFA device and get Totp Secret
     */
    registerTotpMfaDevice(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.registerTotpMfaDeviceRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    registerTotpMfaDeviceOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling registerTotpMfaDeviceOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/register/totp`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    registerTotpMfaDeviceOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.registerTotpMfaDeviceOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Verify TOTP MFA device
     */
    registerTotpMfaDeviceVerifyRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling registerTotpMfaDeviceVerify.');
            }
            if (requestParameters.mFARegisterTotpDevicePostRequest === null || requestParameters.mFARegisterTotpDevicePostRequest === undefined) {
                throw new RequiredError('mFARegisterTotpDevicePostRequest', 'Required parameter requestParameters.mFARegisterTotpDevicePostRequest was null or undefined when calling registerTotpMfaDeviceVerify.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/register/totp`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MFARegisterTotpDevicePostRequestToJSON(requestParameters.mFARegisterTotpDevicePostRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => MFADeviceFromJSON(jsonValue));
        });
    }
    /**
     * Verify TOTP MFA device
     */
    registerTotpMfaDeviceVerify(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.registerTotpMfaDeviceVerifyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Reshare secret shares and update the threshold
     */
    reshareRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling reshare.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling reshare.');
            }
            if (requestParameters.reshareRequest === null || requestParameters.reshareRequest === undefined) {
                throw new RequiredError('reshareRequest', 'Required parameter requestParameters.reshareRequest was null or undefined when calling reshare.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/{walletId}/reshare`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ReshareRequestToJSON(requestParameters.reshareRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OpenRoomResponseWithServerKeygenIdsFromJSON(jsonValue));
        });
    }
    /**
     * Reshare secret shares and update the threshold
     */
    reshare(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.reshareRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    reshareOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling reshareOptions.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling reshareOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/{walletId}/reshare`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    reshareOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.reshareOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Send new code for email verification
     */
    retryEmailVerificationRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling retryEmailVerification.');
            }
            if (requestParameters.emailVerificationRetryRequest === null || requestParameters.emailVerificationRetryRequest === undefined) {
                throw new RequiredError('emailVerificationRetryRequest', 'Required parameter requestParameters.emailVerificationRetryRequest was null or undefined when calling retryEmailVerification.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/emailVerifications/retry`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: EmailVerificationRetryRequestToJSON(requestParameters.emailVerificationRetryRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => EmailVerificationCreateResponseFromJSON(jsonValue));
        });
    }
    /**
     * Send new code for email verification
     */
    retryEmailVerification(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.retryEmailVerificationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    retryEmailVerificationOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling retryEmailVerificationOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/emailVerifications/retry`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    retryEmailVerificationOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.retryEmailVerificationOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Send new code for sms verification
     */
    retrySmsVerificationRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling retrySmsVerification.');
            }
            if (requestParameters.smsVerificationRetryRequest === null || requestParameters.smsVerificationRetryRequest === undefined) {
                throw new RequiredError('smsVerificationRetryRequest', 'Required parameter requestParameters.smsVerificationRetryRequest was null or undefined when calling retrySmsVerification.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/smsVerifications/retry`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SmsVerificationRetryRequestToJSON(requestParameters.smsVerificationRetryRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SmsVerificationCreateResponseFromJSON(jsonValue));
        });
    }
    /**
     * Send new code for sms verification
     */
    retrySmsVerification(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.retrySmsVerificationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    retrySmsVerificationOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling retrySmsVerificationOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/smsVerifications/retry`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    retrySmsVerificationOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.retrySmsVerificationOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Revoke a session
     */
    revokeSessionRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling revokeSession.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/revoke`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Revoke a session
     */
    revokeSession(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.revokeSessionRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    revokeSessionOptionRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling revokeSessionOption.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/revoke`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    revokeSessionOption(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.revokeSessionOptionRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Scan a URL for potential malicious activity
     */
    scanUrlRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling scanUrl.');
            }
            if (requestParameters.scanWebsiteUrlRequest === null || requestParameters.scanWebsiteUrlRequest === undefined) {
                throw new RequiredError('scanWebsiteUrlRequest', 'Required parameter requestParameters.scanWebsiteUrlRequest was null or undefined when calling scanUrl.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/scan/websiteUrl`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ScanWebsiteUrlRequestToJSON(requestParameters.scanWebsiteUrlRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => ScanWebsiteUrlResponseFromJSON(jsonValue));
        });
    }
    /**
     * Scan a URL for potential malicious activity
     */
    scanUrl(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.scanUrlRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    scanUrlOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling scanUrlOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/scan/websiteUrl`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    scanUrlOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.scanUrlOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    sdkSettingsOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling sdkSettingsOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/sdkSettings`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    sdkSettingsOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.sdkSettingsOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * When a user selects a wallet to be the primary wallet in a multi-wallet enabled environment, this endpoint is called to record this on the backend.
     * Update wallet in a multi-wallet selection
     */
    selectUserWalletRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling selectUserWallet.');
            }
            if (requestParameters.userWalletSelectionRequest === null || requestParameters.userWalletSelectionRequest === undefined) {
                throw new RequiredError('userWalletSelectionRequest', 'Required parameter requestParameters.userWalletSelectionRequest was null or undefined when calling selectUserWallet.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/wallets/selection`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UserWalletSelectionRequestToJSON(requestParameters.userWalletSelectionRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * When a user selects a wallet to be the primary wallet in a multi-wallet enabled environment, this endpoint is called to record this on the backend.
     * Update wallet in a multi-wallet selection
     */
    selectUserWallet(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.selectUserWalletRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    selectUserWalletOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling selectUserWalletOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/wallets/selection`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    selectUserWalletOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.selectUserWalletOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Check that session is valid
     */
    sessionCheckRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling sessionCheck.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/session`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Check that session is valid
     */
    sessionCheck(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.sessionCheckRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    sessionCheckOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling sessionCheckOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/session`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    sessionCheckOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.sessionCheckOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    sessionKeyOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling sessionKeyOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/sessionKey`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    sessionKeyOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.sessionKeyOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    settingsOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling settingsOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/settings`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    settingsOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.settingsOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Verify an email and sign in user
     */
    signInWithEmailVerificationRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling signInWithEmailVerification.');
            }
            if (requestParameters.emailVerificationVerifyRequest === null || requestParameters.emailVerificationVerifyRequest === undefined) {
                throw new RequiredError('emailVerificationVerifyRequest', 'Required parameter requestParameters.emailVerificationVerifyRequest was null or undefined when calling signInWithEmailVerification.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/emailVerifications/signin`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: EmailVerificationVerifyRequestToJSON(requestParameters.emailVerificationVerifyRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Verify an email and sign in user
     */
    signInWithEmailVerification(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.signInWithEmailVerificationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    signInWithEmailVerificationOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling signInWithEmailVerificationOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/emailVerifications/signin`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    signInWithEmailVerificationOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.signInWithEmailVerificationOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Verify an sms and sign in user
     */
    signInWithSmsVerificationRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling signInWithSmsVerification.');
            }
            if (requestParameters.smsVerificationVerifyRequest === null || requestParameters.smsVerificationVerifyRequest === undefined) {
                throw new RequiredError('smsVerificationVerifyRequest', 'Required parameter requestParameters.smsVerificationVerifyRequest was null or undefined when calling signInWithSmsVerification.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/smsVerifications/signin`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SmsVerificationVerifyRequestToJSON(requestParameters.smsVerificationVerifyRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Verify an sms and sign in user
     */
    signInWithSmsVerification(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.signInWithSmsVerificationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    signInWithSmsVerificationOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling signInWithSmsVerificationOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/smsVerifications/signin`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    signInWithSmsVerificationOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.signInWithSmsVerificationOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Sign a message with a waas account
     */
    signMessageRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling signMessage.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling signMessage.');
            }
            if (requestParameters.signMessageWithWaasRequest === null || requestParameters.signMessageWithWaasRequest === undefined) {
                throw new RequiredError('signMessageWithWaasRequest', 'Required parameter requestParameters.signMessageWithWaasRequest was null or undefined when calling signMessage.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/{walletId}/signMessage`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SignMessageWithWaasRequestToJSON(requestParameters.signMessageWithWaasRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => OpenRoomResponseFromJSON(jsonValue));
        });
    }
    /**
     * Sign a message with a waas account
     */
    signMessage(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.signMessageRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    signMessageOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling signMessageOptions.');
            }
            if (requestParameters.walletId === null || requestParameters.walletId === undefined) {
                throw new RequiredError('walletId', 'Required parameter requestParameters.walletId was null or undefined when calling signMessageOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/waas/{walletId}/signMessage`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"walletId"}}`, encodeURIComponent(String(requestParameters.walletId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    signMessageOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.signMessageOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Simulate an EVM transaction
     */
    simulateEVMTransactionRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling simulateEVMTransaction.');
            }
            if (requestParameters.simulateEVMTransactionRequest === null || requestParameters.simulateEVMTransactionRequest === undefined) {
                throw new RequiredError('simulateEVMTransactionRequest', 'Required parameter requestParameters.simulateEVMTransactionRequest was null or undefined when calling simulateEVMTransaction.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/evm/simulateTransaction`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SimulateEVMTransactionRequestToJSON(requestParameters.simulateEVMTransactionRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SimulateTransactionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Simulate an EVM transaction
     */
    simulateEVMTransaction(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.simulateEVMTransactionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    simulateEVMTransactionOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling simulateEVMTransactionOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/evm/simulateTransaction`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    simulateEVMTransactionOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.simulateEVMTransactionOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Simulate a Solana transaction
     */
    simulateSVMTransactionRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling simulateSVMTransaction.');
            }
            if (requestParameters.simulateSVMTransactionRequest === null || requestParameters.simulateSVMTransactionRequest === undefined) {
                throw new RequiredError('simulateSVMTransactionRequest', 'Required parameter requestParameters.simulateSVMTransactionRequest was null or undefined when calling simulateSVMTransaction.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/solana/simulateTransaction`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SimulateSVMTransactionRequestToJSON(requestParameters.simulateSVMTransactionRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SimulateTransactionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Simulate a Solana transaction
     */
    simulateSVMTransaction(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.simulateSVMTransactionRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    simulateSVMTransactionOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling simulateSVMTransactionOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/solana/simulateTransaction`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    simulateSVMTransactionOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.simulateSVMTransactionOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Simulate an EVM AA UserOp
     */
    simulateUserOpRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling simulateUserOp.');
            }
            if (requestParameters.simulateUserOpRequest === null || requestParameters.simulateUserOpRequest === undefined) {
                throw new RequiredError('simulateUserOpRequest', 'Required parameter requestParameters.simulateUserOpRequest was null or undefined when calling simulateUserOp.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/evm/simulateUserOp`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SimulateUserOpRequestToJSON(requestParameters.simulateUserOpRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => SimulateTransactionResponseFromJSON(jsonValue));
        });
    }
    /**
     * Simulate an EVM AA UserOp
     */
    simulateUserOp(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.simulateUserOpRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    simulateUserOpOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling simulateUserOpOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/evm/simulateUserOp`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    simulateUserOpOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.simulateUserOpOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    telegramAuthOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling telegramAuthOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/telegram/auth`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    telegramAuthOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.telegramAuthOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Telegram provider check auth
     */
    telegramCheckAuthRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling telegramCheckAuth.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/checkTelegramAuth`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: OauthResultRequestToJSON(requestParameters.oauthResultRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Telegram provider check auth
     */
    telegramCheckAuth(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.telegramCheckAuthRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    telegramCheckAuthOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling telegramCheckAuthOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/checkTelegramAuth`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    telegramCheckAuthOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.telegramCheckAuthOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Telegram provider SignIn endpoint
     */
    telegramSignInRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling telegramSignIn.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/telegram/signin`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: OauthResultRequestToJSON(requestParameters.oauthResultRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Telegram provider SignIn endpoint
     */
    telegramSignIn(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.telegramSignInRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    telegramSignInOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling telegramSignInOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/telegram/signin`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    telegramSignInOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.telegramSignInOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Telegram provider Verify endpoint
     */
    telegramVerifyRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling telegramVerify.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/telegram/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: OauthResultRequestToJSON(requestParameters.oauthResultRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Telegram provider Verify endpoint
     */
    telegramVerify(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.telegramVerifyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    telegramVerifyOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling telegramVerifyOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/telegram/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    telegramVerifyOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.telegramVerifyOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Update a user\'s Turnkey recovery email
     */
    updateEmbeddedWalletRecoveryEmailRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling updateEmbeddedWalletRecoveryEmail.');
            }
            if (requestParameters.updateRecoveryEmailRequest === null || requestParameters.updateRecoveryEmailRequest === undefined) {
                throw new RequiredError('updateRecoveryEmailRequest', 'Required parameter requestParameters.updateRecoveryEmailRequest was null or undefined when calling updateEmbeddedWalletRecoveryEmail.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/recoveryEmail`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateRecoveryEmailRequestToJSON(requestParameters.updateRecoveryEmailRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Update a user\'s Turnkey recovery email
     */
    updateEmbeddedWalletRecoveryEmail(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.updateEmbeddedWalletRecoveryEmailRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Update a passkey\'s info
     */
    updatePasskeyRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling updatePasskey.');
            }
            if (requestParameters.updateUserPasskeyRequest === null || requestParameters.updateUserPasskeyRequest === undefined) {
                throw new RequiredError('updateUserPasskeyRequest', 'Required parameter requestParameters.updateUserPasskeyRequest was null or undefined when calling updatePasskey.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/passkeys`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateUserPasskeyRequestToJSON(requestParameters.updateUserPasskeyRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => UserPasskeyFromJSON(jsonValue));
        });
    }
    /**
     * Update a passkey\'s info
     */
    updatePasskey(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.updatePasskeyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update a user\'s fields
     */
    updateSelfRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling updateSelf.');
            }
            if (requestParameters.userFields === null || requestParameters.userFields === undefined) {
                throw new RequiredError('userFields', 'Required parameter requestParameters.userFields was null or undefined when calling updateSelf.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UserFieldsToJSON(requestParameters.userFields),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => UpdateSelfResponseFromJSON(jsonValue));
        });
    }
    /**
     * Update a user\'s fields
     */
    updateSelf(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.updateSelfRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update a device
     */
    updateUserMfaDeviceRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling updateUserMfaDevice.');
            }
            if (requestParameters.mfaDeviceId === null || requestParameters.mfaDeviceId === undefined) {
                throw new RequiredError('mfaDeviceId', 'Required parameter requestParameters.mfaDeviceId was null or undefined when calling updateUserMfaDevice.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/mfa/{mfaDeviceId}`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))).replace(`{${"mfaDeviceId"}}`, encodeURIComponent(String(requestParameters.mfaDeviceId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: MFAUpdateDeviceRequestToJSON(requestParameters.mFAUpdateDeviceRequest),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Update a device
     */
    updateUserMfaDevice(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.updateUserMfaDeviceRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Update V1 embedded wallet to V2
     */
    upgradeEmbeddedWalletToV2Raw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling upgradeEmbeddedWalletToV2.');
            }
            if (requestParameters.upgradeEmbeddedWalletToV2Request === null || requestParameters.upgradeEmbeddedWalletToV2Request === undefined) {
                throw new RequiredError('upgradeEmbeddedWalletToV2Request', 'Required parameter requestParameters.upgradeEmbeddedWalletToV2Request was null or undefined when calling upgradeEmbeddedWalletToV2.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/upgradeToV2`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UpgradeEmbeddedWalletToV2RequestToJSON(requestParameters.upgradeEmbeddedWalletToV2Request),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Update V1 embedded wallet to V2
     */
    upgradeEmbeddedWalletToV2(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.upgradeEmbeddedWalletToV2Raw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    upgradeEmbeddedWalletToV2OptionRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling upgradeEmbeddedWalletToV2Option.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/upgradeToV2`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    upgradeEmbeddedWalletToV2Option(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.upgradeEmbeddedWalletToV2OptionRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    userPasskeysOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling userPasskeysOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/passkeys`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    userPasskeysOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.userPasskeysOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    usersOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling usersOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    usersOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.usersOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Verify payload and return JWT
     */
    verifyRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verify.');
            }
            if (requestParameters.verifyRequest === null || requestParameters.verifyRequest === undefined) {
                throw new RequiredError('verifyRequest', 'Required parameter requestParameters.verifyRequest was null or undefined when calling verify.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/sdk/{environmentId}/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: VerifyRequestToJSON(requestParameters.verifyRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Verify payload and return JWT
     */
    verify(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.verifyRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Verify email verification request
     */
    verifyEmailVerificationRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifyEmailVerification.');
            }
            if (requestParameters.emailVerificationVerifyRequest === null || requestParameters.emailVerificationVerifyRequest === undefined) {
                throw new RequiredError('emailVerificationVerifyRequest', 'Required parameter requestParameters.emailVerificationVerifyRequest was null or undefined when calling verifyEmailVerification.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/emailVerifications/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: EmailVerificationVerifyRequestToJSON(requestParameters.emailVerificationVerifyRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => UpdateSelfResponseFromJSON(jsonValue));
        });
    }
    /**
     * Verify email verification request
     */
    verifyEmailVerification(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.verifyEmailVerificationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyEmailVerificationOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifyEmailVerificationOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/emailVerifications/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyEmailVerificationOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.verifyEmailVerificationOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Link a wallet to a valid environment user, and return an updated JWT
     * Link wallet to user
     */
    verifyLinkRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifyLink.');
            }
            if (requestParameters.verifyRequest === null || requestParameters.verifyRequest === undefined) {
                throw new RequiredError('verifyRequest', 'Required parameter requestParameters.verifyRequest was null or undefined when calling verifyLink.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/verify/link`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: VerifyRequestToJSON(requestParameters.verifyRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Link a wallet to a valid environment user, and return an updated JWT
     * Link wallet to user
     */
    verifyLink(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.verifyLinkRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyLinkOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifyLinkOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/verify/link`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyLinkOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.verifyLinkOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Used to merge two users with user-chosen resolutions to conflicting data between the two users to be merged
     * Merge users with conflict resolutions
     */
    verifyMergeUsersRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifyMergeUsers.');
            }
            if (requestParameters.mergeUserConflictResolutions === null || requestParameters.mergeUserConflictResolutions === undefined) {
                throw new RequiredError('mergeUserConflictResolutions', 'Required parameter requestParameters.mergeUserConflictResolutions was null or undefined when calling verifyMergeUsers.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/verify/merge`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MergeUserConflictResolutionsToJSON(requestParameters.mergeUserConflictResolutions),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Used to merge two users with user-chosen resolutions to conflicting data between the two users to be merged
     * Merge users with conflict resolutions
     */
    verifyMergeUsers(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.verifyMergeUsersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyMergeUsersOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifyMergeUsersOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/verify/merge`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyMergeUsersOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.verifyMergeUsersOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifyOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.verifyOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyPrefetchRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifyPrefetch.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/prefetch`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyPrefetch(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.verifyPrefetchRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Verify sms verification request
     */
    verifySmsVerificationRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifySmsVerification.');
            }
            if (requestParameters.smsVerificationVerifyRequest === null || requestParameters.smsVerificationVerifyRequest === undefined) {
                throw new RequiredError('smsVerificationVerifyRequest', 'Required parameter requestParameters.smsVerificationVerifyRequest was null or undefined when calling verifySmsVerification.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/smsVerifications/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SmsVerificationVerifyRequestToJSON(requestParameters.smsVerificationVerifyRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => UpdateSelfResponseFromJSON(jsonValue));
        });
    }
    /**
     * Verify sms verification request
     */
    verifySmsVerification(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.verifySmsVerificationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    verifySmsVerificationOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifySmsVerificationOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/smsVerifications/verify`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    verifySmsVerificationOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.verifySmsVerificationOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Used to link a wallet after user has confirmed transfer to the new account
     * Verify wallet transfer
     */
    verifyTransferRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifyTransfer.');
            }
            if (requestParameters.verifyRequest === null || requestParameters.verifyRequest === undefined) {
                throw new RequiredError('verifyRequest', 'Required parameter requestParameters.verifyRequest was null or undefined when calling verifyTransfer.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/verify/transfer`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: VerifyRequestToJSON(requestParameters.verifyRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Used to link a wallet after user has confirmed transfer to the new account
     * Verify wallet transfer
     */
    verifyTransfer(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.verifyTransferRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyTransferOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifyTransferOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/verify/transfer`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyTransferOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.verifyTransferOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Remove a link from to a valid environment user, and return an updated JWT
     * unlink wallet from user
     */
    verifyUnlinkRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifyUnlink.');
            }
            if (requestParameters.verifyUnlinkRequest === null || requestParameters.verifyUnlinkRequest === undefined) {
                throw new RequiredError('verifyUnlinkRequest', 'Required parameter requestParameters.verifyUnlinkRequest was null or undefined when calling verifyUnlink.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("bearerAuth", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/sdk/{environmentId}/verify/unlink`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: VerifyUnlinkRequestToJSON(requestParameters.verifyUnlinkRequest),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => VerifyResponseFromJSON(jsonValue));
        });
    }
    /**
     * Remove a link from to a valid environment user, and return an updated JWT
     * unlink wallet from user
     */
    verifyUnlink(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            const response = yield this.verifyUnlinkRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyUnlinkOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling verifyUnlinkOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/verify/unlink`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    verifyUnlinkOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.verifyUnlinkOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    walletAccountOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling walletAccountOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/walletAccounts`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    walletAccountOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.walletAccountOptionsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Options call for this endpoint
     */
    walletAccountRequestOptionsRaw(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            if (requestParameters.environmentId === null || requestParameters.environmentId === undefined) {
                throw new RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling walletAccountRequestOptions.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/sdk/{environmentId}/users/embeddedWallets/walletAccounts/createRequest`.replace(`{${"environmentId"}}`, encodeURIComponent(String(requestParameters.environmentId))),
                method: 'OPTIONS',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     * Options call for this endpoint
     */
    walletAccountRequestOptions(requestParameters, initOverrides) {
        return __awaiter$c(this, void 0, void 0, function* () {
            yield this.walletAccountRequestOptionsRaw(requestParameters, initOverrides);
        });
    }
}
/**
    * @export
    * @enum {string}
    */
var GetAccountBalancesChainNameEnum;
(function (GetAccountBalancesChainNameEnum) {
    GetAccountBalancesChainNameEnum["Evm"] = "EVM";
    GetAccountBalancesChainNameEnum["Sol"] = "SOL";
})(GetAccountBalancesChainNameEnum || (GetAccountBalancesChainNameEnum = {}));
/**
    * @export
    * @enum {string}
    */
var GetAccountBalancesOptionsChainNameEnum;
(function (GetAccountBalancesOptionsChainNameEnum) {
    GetAccountBalancesOptionsChainNameEnum["Evm"] = "EVM";
    GetAccountBalancesOptionsChainNameEnum["Sol"] = "SOL";
})(GetAccountBalancesOptionsChainNameEnum || (GetAccountBalancesOptionsChainNameEnum = {}));

/* tslint:disable */
function JwtBlockchainAccountFromJSON(json) {
    return JwtBlockchainAccountFromJSONTyped(json);
}
function JwtBlockchainAccountFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': json['address'],
        'chain': json['chain'],
        'id': json['id'],
        'nameService': !exists(json, 'name_service') ? undefined : NameServiceDataFromJSON(json['name_service']),
        'walletName': json['wallet_name'],
        'walletProvider': WalletProviderEnumFromJSON(json['wallet_provider']),
    };
}

/* tslint:disable */
function JwtPayloadDeprecatedInfoFromJSON(json) {
    return JwtPayloadDeprecatedInfoFromJSONTyped(json);
}
function JwtPayloadDeprecatedInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'alias': !exists(json, 'alias') ? undefined : json['alias'],
        'chain': !exists(json, 'chain') ? undefined : ChainEnumFromJSON(json['chain']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'ens': !exists(json, 'ens') ? undefined : NameServiceDataFromJSON(json['ens']),
        'environmentId': json['environmentId'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'jobTitle': !exists(json, 'jobTitle') ? undefined : json['jobTitle'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'lists': !exists(json, 'lists') ? undefined : json['lists'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'tShirtSize': !exists(json, 'tShirtSize') ? undefined : json['tShirtSize'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'wallet': !exists(json, 'wallet') ? undefined : json['wallet'],
        'walletPublicKey': !exists(json, 'walletPublicKey') ? undefined : json['walletPublicKey'],
    };
}

/* tslint:disable */
function JwtVerifiedCredentialHashesFromJSON(json) {
    return JwtVerifiedCredentialHashesFromJSONTyped(json);
}
function JwtVerifiedCredentialHashesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'blockchain': !exists(json, 'blockchain') ? undefined : json['blockchain'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'oauth': !exists(json, 'oauth') ? undefined : json['oauth'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'externalUser': !exists(json, 'externalUser') ? undefined : json['externalUser'],
    };
}

/* tslint:disable */
function DynamicJwtFromJSON(json) {
    return DynamicJwtFromJSONTyped(json);
}
function DynamicJwtFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'kid': json['kid'],
        'aud': json['aud'],
        'iss': json['iss'],
        'sub': json['sub'],
        'exp': !exists(json, 'exp') ? undefined : json['exp'],
        'iat': !exists(json, 'iat') ? undefined : json['iat'],
        'sid': json['sid'],
        'alias': !exists(json, 'alias') ? undefined : json['alias'],
        'blockchainAccounts': !exists(json, 'blockchain_accounts') ? undefined : (json['blockchain_accounts'].map(JwtBlockchainAccountFromJSON)),
        'country': !exists(json, 'country') ? undefined : json['country'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'environmentId': json['environment_id'],
        'familyName': !exists(json, 'family_name') ? undefined : json['family_name'],
        'givenName': !exists(json, 'given_name') ? undefined : json['given_name'],
        'jobTitle': !exists(json, 'job_title') ? undefined : json['job_title'],
        'lastAuthenticatedAccountId': !exists(json, 'last_authenticated_account_id') ? undefined : json['last_authenticated_account_id'],
        'lists': !exists(json, 'lists') ? undefined : json['lists'],
        'phoneNumber': !exists(json, 'phone_number') ? undefined : json['phone_number'],
        'missingFields': (json['missing_fields'].map(ProjectSettingsKycFromJSON)),
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
        'tShirtSize': !exists(json, 't_shirt_size') ? undefined : json['t_shirt_size'],
        'team': !exists(json, 'team') ? undefined : json['team'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'policiesConsent': !exists(json, 'policies_consent') ? undefined : json['policies_consent'],
        'verifiedAccount': !exists(json, 'verified_account') ? undefined : JwtBlockchainAccountFromJSON(json['verified_account']),
        'verifiedCredentials': (json['verified_credentials'].map(JwtVerifiedCredentialFromJSON)),
        'lastVerifiedCredentialId': json['last_verified_credential_id'],
        'firstVisit': !exists(json, 'first_visit') ? undefined : (new Date(json['first_visit'])),
        'lastVisit': !exists(json, 'last_visit') ? undefined : (new Date(json['last_visit'])),
        'newUser': !exists(json, 'new_user') ? undefined : json['new_user'],
        'btcWallet': !exists(json, 'btc_wallet') ? undefined : json['btc_wallet'],
        'kdaWallet': !exists(json, 'kda_wallet') ? undefined : json['kda_wallet'],
        'ltcWallet': !exists(json, 'ltc_wallet') ? undefined : json['ltc_wallet'],
        'ckbWallet': !exists(json, 'ckb_wallet') ? undefined : json['ckb_wallet'],
        'kasWallet': !exists(json, 'kas_wallet') ? undefined : json['kas_wallet'],
        'dogeWallet': !exists(json, 'doge_wallet') ? undefined : json['doge_wallet'],
        'emailNotification': !exists(json, 'email_notification') ? undefined : json['email_notification'],
        'discordNotification': !exists(json, 'discord_notification') ? undefined : json['discord_notification'],
        'newsletterNotification': !exists(json, 'newsletter_notification') ? undefined : json['newsletter_notification'],
        'metadata': !exists(json, 'metadata') ? undefined : json['metadata'],
        'verifiedCredentialsHashes': !exists(json, 'verifiedCredentialsHashes') ? undefined : JwtVerifiedCredentialHashesFromJSON(json['verifiedCredentialsHashes']),
        'info': !exists(json, 'info') ? undefined : JwtPayloadDeprecatedInfoFromJSON(json['info']),
    };
}

/* tslint:disable */
function MinifiedDynamicJwtFromJSON(json) {
    return MinifiedDynamicJwtFromJSONTyped(json);
}
function MinifiedDynamicJwtFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'kid': json['kid'],
        'aud': json['aud'],
        'iss': json['iss'],
        'sub': json['sub'],
        'sid': json['sid'],
        'exp': !exists(json, 'exp') ? undefined : json['exp'],
        'iat': !exists(json, 'iat') ? undefined : json['iat'],
        'environmentId': json['environment_id'],
        'lastVerifiedCredentialId': json['last_verified_credential_id'],
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
        'verifiedCredentialsHashes': !exists(json, 'verifiedCredentialsHashes') ? undefined : JwtVerifiedCredentialHashesFromJSON(json['verifiedCredentialsHashes']),
        'email': !exists(json, 'email') ? undefined : json['email'],
        'username': !exists(json, 'username') ? undefined : json['username'],
    };
}

var SocialOAuthErrorCode;
(function (SocialOAuthErrorCode) {
    SocialOAuthErrorCode["ACCOUNT_ALREADY_LINKED"] = "account_already_linked";
    SocialOAuthErrorCode["ACCOUNT_ALREADY_LINKED_TO_DIFFERENT_PROFILE"] = "account_already_linked_to_different_profile";
    SocialOAuthErrorCode["INVALID_PROVIDER"] = "invalid_provider";
    SocialOAuthErrorCode["NO_ACCOUNT_LINKED"] = "no_account_linked";
    SocialOAuthErrorCode["NO_AUTH_CODE"] = "no_auth_code";
    SocialOAuthErrorCode["NO_OAUTH_URL"] = "no_oauth_url";
    SocialOAuthErrorCode["NO_PROVIDER"] = "no_provider";
    SocialOAuthErrorCode["OAUTH_ERROR"] = "oauth_error";
    SocialOAuthErrorCode["OAUTH_WINDOW_BLOCKED"] = "oauth_window_blocked";
    SocialOAuthErrorCode["OAUTH_WINDOW_CLOSED"] = "oauth_window_closed";
    SocialOAuthErrorCode["OAUTH_WINDOW_TIMEOUT"] = "oauth_window_timeout";
    SocialOAuthErrorCode["PROVIDER_NOT_ENABLED"] = "provider_not_enabled";
    SocialOAuthErrorCode["SESSION_TIMEOUT"] = "session_timeout";
    SocialOAuthErrorCode["SIGNIN_ERROR"] = "signin_error";
    SocialOAuthErrorCode["SOCIAL_LINKING_NOT_ENABLED"] = "social_linking_not_enabled";
    SocialOAuthErrorCode["UNLINK_ERROR"] = "unlink_error";
    SocialOAuthErrorCode["VERIFICATION_ERROR"] = "verification_error";
    SocialOAuthErrorCode["GENERAL_ERROR"] = "general_error";
    SocialOAuthErrorCode["USER_CANCELLED"] = "user_cancelled";
})(SocialOAuthErrorCode || (SocialOAuthErrorCode = {}));

class BaseWallet {
    constructor({ id, key, address, additionalAddresses = [], chain, isAuthenticated, }) {
        this.id = id;
        this.key = key;
        this.address = address;
        this.additionalAddresses = additionalAddresses;
        this.chain = chain;
        this.isAuthenticated = isAuthenticated;
    }
}

assertPackageVersion('@dynamic-labs/types', version$c);

const appleIdScriptSrc = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
const loadAppleId = () => new Promise((resolve, reject) => {
    const script = document.querySelector('script[data-apple-sdk]');
    if (script) {
        // Script already exists, attach event listeners
        if (script.hasAttribute('data-loaded')) {
            resolve();
        }
        else {
            script.addEventListener('load', () => resolve());
            script.addEventListener('error', () => reject(new Error('Failed to load Apple SDK')));
        }
    }
    else {
        // If the script does not exist, create and add it
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = appleIdScriptSrc;
        script.setAttribute('data-apple-sdk', 'true');
        script.onload = () => {
            script === null || script === void 0 ? void 0 : script.setAttribute('data-loaded', 'true');
            resolve();
        };
        script.onerror = () => reject(new Error('Failed to load Apple SDK'));
        window.document.head.appendChild(script);
    }
});

const connectWithAppleId = (_a) => __awaiter$d(void 0, [_a], void 0, function* ({ clientId, oauthLoginUrl, state, }) {
    yield loadAppleId();
    // Because the AppleID is loaded from a script tag, there is not type for it
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    AppleID.auth.init({
        clientId,
        redirectURI: oauthLoginUrl.searchParams.get('redirect_uri'),
        scope: 'name email',
        state,
        usePopup: false,
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    AppleID.auth.signIn();
});

let authWindowInterval;
const createWindowOauth2Service = () => ({
    getOauthCode: ({ apiProvider, provider, redirectUrl, setIsProcessing, state, oauthLoginUrl, initWebAuth, strategy, }) => new Promise((resolve, _reject) => {
        /**
         * Use AppleID SDK for Apple provider on mobile
         * It should use the strategy setting, but on ios or safari
         * it should use the appleId always as it is the best experience
         */
        if (provider === ProviderEnum.Apple &&
            (isSafariBrowser() || isIOS() || strategy === 'redirect')) {
            initWebAuth({
                redirectUrl: redirectUrl || window.location.href,
            }).then(() => connectWithAppleId({
                clientId: apiProvider === null || apiProvider === void 0 ? void 0 : apiProvider.clientId,
                oauthLoginUrl,
                state,
            }).catch(_reject));
            return;
        }
        /**
         * Use redirect flow on mobile for all providers except Telegram
         */
        if (strategy === 'redirect' && provider !== ProviderEnum.Telegram) {
            initWebAuth({
                redirectUrl: redirectUrl || window.location.href,
            }).then(() => {
                window.location.assign(oauthLoginUrl);
            });
            return;
        }
        // When we catch this error we assume it follows this type, so we must enforce it
        // here to ensure the assumption is correct
        const typedReject = (params) => _reject(params);
        // Clear any potential pending timeouts and intervals
        clearInterval(authWindowInterval);
        const providersWaitingOauthMessage = {};
        const authWindow = window.open('', '_blank', 'width=500,height=600');
        if (authWindow === null || typeof authWindow === 'undefined') {
            // Pop-ups are blocked
            typedReject({
                code: SocialOAuthErrorCode.OAUTH_WINDOW_BLOCKED,
                message: 'Please allow popups and try again.',
            });
            return;
        }
        const clearListeners = () => {
            window.removeEventListener('message', handleWindowMessage);
            providersWaitingOauthMessage[provider] = false;
        };
        const handleWindowMessage = (event) => __awaiter$d(void 0, void 0, void 0, function* () {
            const message = event.data;
            const expectedOrigin = getExpectedOrigin(apiProvider);
            if (!expectedOrigin) {
                return;
            }
            if ((message === null || message === void 0 ? void 0 : message.type) === 'origin_check' && authWindow) {
                logger$9.debug('Origin check message received. Sending response now.', {
                    data: message,
                    expectedOrigin,
                });
                authWindow.postMessage('origin_check_response', expectedOrigin);
                return;
            }
            const isTelegramCompletedMessage = (message === null || message === void 0 ? void 0 : message.type) === 'telegram_completed';
            const isAuthorizationMessage = (message === null || message === void 0 ? void 0 : message.type) === 'authorization_response';
            if (isAuthorizationMessage || isTelegramCompletedMessage) {
                logger$9.debug('Message received', { data: message });
            }
            const isExpectedOrigin = event.origin === expectedOrigin;
            const isValidMessage = ((isAuthorizationMessage && (message === null || message === void 0 ? void 0 : message.provider) === provider) ||
                isTelegramCompletedMessage) &&
                isExpectedOrigin;
            // don't process invalid messages for provider
            if (!isValidMessage) {
                return;
            }
            setIsProcessing(true);
            if (!providersWaitingOauthMessage[provider]) {
                typedReject({
                    code: SocialOAuthErrorCode.SESSION_TIMEOUT,
                    message: `Connecting ${provider} account session timeout.`,
                });
                return;
            }
            clearListeners();
            if (isTelegramCompletedMessage) {
                handleTelegramCompletionMessage(message, state);
                return;
            }
            handleAuthorizationMessage(message, provider, state);
        });
        const getExpectedOrigin = (apiProvider) => {
            if (!(apiProvider === null || apiProvider === void 0 ? void 0 : apiProvider.redirectUrl)) {
                return;
            }
            try {
                const redirectUri = new URL(apiProvider.redirectUrl);
                return redirectUri.origin;
            }
            catch (e) {
                logger$9.error('Failed to parse social provider redirect url', {
                    error: e,
                });
                return;
            }
        };
        const handleTelegramCompletionMessage = (message, state) => {
            logger$9.debug('Telegram completion message received', {
                data: message,
            });
            const { code, state: authState } = message;
            // check that the state we receive from message is the same state we calculated earlier
            // this could be an attack
            if (state !== authState) {
                typedReject({
                    code: SocialOAuthErrorCode.OAUTH_ERROR,
                    message: 'Failed to connect telegram account: Invalid random state',
                });
                return;
            }
            resolve(code);
            setIsProcessing(false);
        };
        const handleAuthorizationMessage = (message, provider, state) => {
            const { code, error, state: authState } = message;
            if (error && error !== 'undefined') {
                typedReject({
                    code: SocialOAuthErrorCode.OAUTH_ERROR,
                    message: `Failed to connect ${provider} social account: ${error}`,
                });
                return;
            }
            // check that the state we receive from message is the same state we calculated earlier
            // this could be an attack
            // this state check is used only by providers with an open window opener reference (eg, not twitter)
            if (state !== authState) {
                typedReject({
                    code: SocialOAuthErrorCode.OAUTH_ERROR,
                    message: `Failed to connect ${provider} social account: Invalid random state`,
                });
                return;
            }
            if (!code) {
                typedReject({
                    code: SocialOAuthErrorCode.NO_AUTH_CODE,
                    message: `Failed to connect ${provider} social account: no authorization code`,
                });
                return;
            }
            resolve(code);
            setIsProcessing(false);
        };
        if (!providersWaitingOauthMessage[provider]) {
            window.addEventListener('message', handleWindowMessage);
            providersWaitingOauthMessage[provider] = true;
        }
        // First we store the state in backend
        initWebAuth().then(() => {
            authWindow === null || authWindow === void 0 ? void 0 : authWindow.location.assign(oauthLoginUrl);
            authWindowInterval = setInterval(() => {
                if (!(authWindow === null || authWindow === void 0 ? void 0 : authWindow.closed))
                    return;
                clearInterval(authWindowInterval);
                setIsProcessing(false);
                // user didn't complete oauth
                if (providersWaitingOauthMessage[provider])
                    typedReject({
                        code: SocialOAuthErrorCode.USER_CANCELLED,
                        message: 'User cancelled connection',
                    });
            }, 2000);
        });
    }),
});

var _a$1, _Oauth2Service_implementation;
/**
 * Class implementing the fetch service with a configurable fetch implementation.
 */
class Oauth2Service {
    static get implementation() {
        if (!__classPrivateFieldGet$5(_a$1, _a$1, "f", _Oauth2Service_implementation)) {
            return createWindowOauth2Service();
        }
        return __classPrivateFieldGet$5(_a$1, _a$1, "f", _Oauth2Service_implementation);
    }
    static set implementation(implementation) {
        __classPrivateFieldSet$4(_a$1, _a$1, implementation, "f", _Oauth2Service_implementation);
    }
    static get getOauthCode() {
        return _a$1.implementation.getOauthCode;
    }
}
_a$1 = Oauth2Service;
_Oauth2Service_implementation = { value: void 0 };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
Oauth2Service.isGetOauthCodeError = (error) => typeof error === 'object' &&
    'code' in error &&
    Object.values(SocialOAuthErrorCode).includes(error.code) &&
    'message' in error &&
    typeof error.message === 'string';

class StorageService {
    static clearRegistry() {
        StorageService.registry = {
            localStorage: undefined,
            secureStorage: undefined,
            sessionStorage: undefined,
        };
    }
    static registerSourceStorage(source, implementation) {
        StorageService.registry[source] = implementation;
    }
    static getSourceStorage(source) {
        return StorageService.registry[source];
    }
    static resolveStorage(options) {
        const priority = (options === null || options === void 0 ? void 0 : options.priority) || ['localStorage'];
        for (const source of priority) {
            const storage = StorageService.getSourceStorage(source);
            if (storage) {
                return storage;
            }
        }
        throw new Error('No available storage found based on the specified priority');
    }
    static getItem(key, options) {
        const storage = StorageService.resolveStorage(options);
        return storage.getItem(key);
    }
    static setItem(key, value, options) {
        const storage = StorageService.resolveStorage(options);
        storage.setItem(key, value);
    }
    static removeItem(key, options) {
        const storage = StorageService.resolveStorage(options);
        storage.removeItem(key);
    }
    static getKeys(options) {
        return StorageService.resolveStorage(options).getKeys();
    }
}
StorageService.registry = {
    localStorage: undefined,
    secureStorage: undefined,
    sessionStorage: undefined,
};
StorageService.events = new EventEmitter$1();

const createStorageService = ({ storage, }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const packValue = (value) => JSON.stringify(value);
    const unpackValue = (value) => JSON.parse(value);
    const getItem = (key) => {
        const value = storage.getItem(key);
        if (!value) {
            return undefined;
        }
        try {
            return unpackValue(value);
        }
        catch (error) {
            logger$9.error(`Error while parsing ${key} from local storage`, {
                value,
            });
            removeItem(key);
            StorageService.events.emit('parseFailure', error, key);
        }
        return undefined;
    };
    const setItem = (key, value) => {
        storage.setItem(key, packValue(value));
    };
    const removeItem = (key) => {
        storage.removeItem(key);
    };
    const getKeys = () => Object.keys(storage);
    return {
        getItem,
        getKeys,
        removeItem,
        setItem,
    };
};

const applyPostfixToStorageService = ({ storage, postfix, }) => {
    const getKeyWithPostfix = (key) => postfix ? `${key}_${postfix}` : key;
    return Object.assign(Object.assign({}, storage), { getItem: (key) => storage.getItem(getKeyWithPostfix(key)), removeItem: (key) => storage.removeItem(getKeyWithPostfix(key)), setItem: (key, data) => storage.setItem(getKeyWithPostfix(key), data) });
};

/**
 * Safely gets an environment variable with a required fallback value
 * @param keys Single key or array of keys to try in order
 * @param defaultValue Required default value if none of the keys are found
 * @returns The first found environment variable value or the default value
 */
const getEnvVarWithFallback = (keys, defaultValue) => {
    if (typeof process === 'undefined' || !process.env) {
        return defaultValue;
    }
    const keysToTry = Array.isArray(keys) ? keys : [keys];
    for (const key of keysToTry) {
        const value = process.env[key];
        if (value !== undefined) {
            return value;
        }
    }
    return defaultValue;
};

assertPackageVersion('@dynamic-labs/utils', version$d);

var version$b = "4.6.1";

const walletConnectorEvents = new EventEmitter$1();

const logger$8 = new Logger$1('WalletConnector');

const ProviderLookup = (installedProviders, extensionLocators) => {
    if (extensionLocators.length === 0) {
        return undefined;
    }
    return installedProviders.find((provider) => {
        const extensionLocatorMatch = extensionLocators.every((condition) => {
            const flagValue = (provider === null || provider === void 0 ? void 0 : provider[condition.flag]) || false;
            return flagValue === condition.value;
        });
        return extensionLocatorMatch === true;
    });
};

const chainsInfo = [
    {
        blockchainName: 'Algorand',
        displayName: 'Algorand',
        name: 'algorand',
        symbol: 'ALGO',
    },
    {
        blockchainName: 'Bitcoin',
        displayName: 'Bitcoin',
        name: 'bitcoin',
        symbol: 'BTC',
    },
    {
        blockchainName: 'Ethereum',
        displayName: 'EVM',
        name: 'evm',
        symbol: 'ETH',
    },
    {
        blockchainName: 'Flow',
        displayName: 'Flow',
        name: 'flow',
        symbol: 'FLOW',
    },
    {
        blockchainName: 'Solana',
        displayName: 'Solana',
        name: 'solana',
        symbol: 'SOL',
    },
    {
        blockchainName: 'Starknet',
        displayName: 'Starknet',
        name: 'starknet',
        symbol: 'ETH',
    },
    {
        blockchainName: 'Cosmos',
        displayName: 'Cosmos',
        name: 'cosmos',
        symbol: 'COSMOS',
    },
    {
        blockchainName: 'Eclipse',
        displayName: 'Eclipse',
        name: 'eclipse',
        symbol: 'ECLIPSE',
    },
];
const chainOverrides = {
    algo: 'algorand',
    bip122: 'bitcoin',
    btc: 'bitcoin',
    eip155: 'evm',
    eth: 'evm',
    sol: 'solana',
    stark: 'starknet',
};
let chainInfoOverrides$1;
const setChainInfoOverrides = (overrides) => {
    chainInfoOverrides$1 = overrides;
};
const getChainInfo = (chain) => {
    var _a;
    const lowerCasedChain = chain.toLowerCase();
    const normalizedChain = (_a = chainOverrides[lowerCasedChain]) !== null && _a !== void 0 ? _a : lowerCasedChain;
    const chainInfo = chainsInfo.find((info) => info.name === normalizedChain ||
        info.symbol.toLocaleLowerCase() === normalizedChain);
    if (!chainInfo) {
        return;
    }
    return chainInfo;
};
const getChainInfoWithOverrides = (chain) => {
    var _a, _b;
    const chainInfo = getChainInfo(chain);
    if (!chainInfo) {
        return;
    }
    const overrides = chainInfoOverrides$1 === null || chainInfoOverrides$1 === void 0 ? void 0 : chainInfoOverrides$1[chainInfo.name];
    const chainInfoClone = Object.assign({}, chainInfo);
    if (overrides) {
        chainInfoClone.blockchainName =
            (_a = overrides.displayName) !== null && _a !== void 0 ? _a : chainInfo.blockchainName;
        chainInfoClone.displayName = (_b = overrides.displayName) !== null && _b !== void 0 ? _b : chainInfo.displayName;
    }
    return chainInfoClone;
};

const isEmailOTPWalletConnector = (walletConnector) => Boolean(walletConnector.verifyOneTimePassword);

const isEmailWalletConnector = (walletConnector) => Boolean(walletConnector.clearEmail);

const isTurnkeyWalletConnector = (walletConnector) => {
    const turnkeyWalletConnector = walletConnector;
    return Boolean(turnkeyWalletConnector &&
        turnkeyWalletConnector.key === 'turnkeyhd' &&
        typeof turnkeyWalletConnector.getWebAuthnAttestation === 'function' &&
        typeof turnkeyWalletConnector.getAuthenticatorHandler === 'function' &&
        typeof turnkeyWalletConnector.getExportHandler === 'function' &&
        typeof turnkeyWalletConnector.isSessionKeyCompatible === 'function' &&
        typeof turnkeyWalletConnector.createOrRestoreSession === 'function');
};

const shouldLowercaseAddress = (chain) => 
// these are standard from CAIP-2: https://github.com/ChainAgnostic/CAIPs/blob/master/CAIPs/caip-2.md
// see also: https://github.com/ChainAgnostic/namespaces
// note: no standard namespace currently exists for flow
['eip155', 'flow', 'evm', 'eth', 'avax', 'matic'].includes(chain.toLowerCase());

const normalizeAddress = (rawAddress, chain) => {
    let address = rawAddress;
    if (address === null || address === void 0 ? void 0 : address.startsWith('0x')) {
        address = address.slice(2);
    }
    address = shouldLowercaseAddress(chain) ? address === null || address === void 0 ? void 0 : address.toLowerCase() : address;
    return address;
};

const isSameAddress = (left, right, chain) => normalizeAddress(left, chain) === normalizeAddress(right, chain);

const isSocialWalletConnector = (walletConnector) => Boolean(walletConnector.canConnectViaSocial);

const filterWalletsByKey = (wallets, keys) => keys
    .flatMap((key) => wallets.find((w) => walletHasKey(w, key)))
    .filter(isWalletConnector);
const walletHasKey = (wallet, key) => wallet.key === key;
const isWalletConnector = (item) => Boolean(item);
const getWalletConnectorByKey = (wallets, key) => filterWalletsByKey(wallets, [key]).length > 0
    ? filterWalletsByKey(wallets, [key])[0]
    : null;

const getConnectionDeepLink = (uri, deepLinks, preference) => {
    // on android, the connection deeplink is simply the uri
    // see: https://docs.walletconnect.com/mobile-linking#for-android
    if (isAndroid()) {
        return uri;
    }
    const deepLink = getRegularDeepLink(uri, deepLinks, preference);
    if (!deepLink) {
        return `${deepLink}?uri=${encodeURIComponent(uri)}`;
    }
    const deepLinkUrl = new URL(deepLink);
    const deepLinkParams = new URLSearchParams(deepLinkUrl.search);
    deepLinkParams.set('uri', uri);
    deepLinkUrl.search = deepLinkParams.toString();
    return deepLinkUrl.toString();
};
const getRegularDeepLink = (uri, deepLinks, preference) => {
    var _a, _b, _c, _d;
    if (isAndroid()) {
        // on android, the deeplink is simply the uri, without the query params
        // see: https://docs.walletconnect.com/mobile-linking#for-android
        return uri.split('?')[0];
    }
    const index = isMobile() ? 'mobile' : 'desktop';
    let origin;
    if (preference === 'native') {
        origin = ((_a = deepLinks[index]) === null || _a === void 0 ? void 0 : _a.native) || ((_b = deepLinks[index]) === null || _b === void 0 ? void 0 : _b.universal);
    }
    else {
        origin = ((_c = deepLinks[index]) === null || _c === void 0 ? void 0 : _c.universal) || ((_d = deepLinks[index]) === null || _d === void 0 ? void 0 : _d.native);
    }
    return origin || '';
};
const getDeepLink = ({ mode, uri = '', deepLinks, preference, }) => {
    if (!deepLinks) {
        return '';
    }
    switch (mode) {
        case 'connection':
            return getConnectionDeepLink(uri, deepLinks, preference);
        case 'regular':
            return getRegularDeepLink(uri, deepLinks, preference);
    }
};

const performPlatformSpecificConnectionMethod = (uri, deepLinks, opts, preference) => {
    var _a, _b, _c;
    const deepLink = getDeepLink({
        deepLinks,
        mode: 'connection',
        preference,
        uri,
    });
    if (isMobile()) {
        window.location.href = deepLink;
    }
    else {
        if ((_a = deepLinks === null || deepLinks === void 0 ? void 0 : deepLinks.desktop) === null || _a === void 0 ? void 0 : _a.native) {
            (_b = opts.onDesktopUri) === null || _b === void 0 ? void 0 : _b.call(opts, deepLink);
        }
        (_c = opts.onDisplayUri) === null || _c === void 0 ? void 0 : _c.call(opts, uri);
    }
};

const isEmbeddedConnector = (connector) => Boolean(connector.isEmbeddedWallet);

const isMagicConnector = (connector) => ['magicemailotp', 'magicsocial'].includes(connector.key);

const isBloctoConnector = (connector) => ['bloctoemail', 'bloctoevm', 'Blocto'].includes(connector.key);

const isPasskeyWalletConnector = (walletConnector) => Boolean(walletConnector.getWebAuthnAttestation);

const isAccountAbstractionConnector = (walletConnector) => walletConnector !== undefined &&
    walletConnector !== null &&
    typeof walletConnector === 'object' &&
    'canSponsorTransactionGas' in walletConnector;

const isBitcoinConnector = (connector) => Boolean(connector === null || connector === void 0 ? void 0 : connector.sendBitcoin);

const isHardwareWalletConnector = (connector) => 'canConnectWithHardwareWallet' in connector;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest$8(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter$b(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __classPrivateFieldGet$4(receiver, state, kind, f) {
    if (typeof state === "function" ? receiver !== state || true : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const isHex = (value) => {
    if (!value)
        return false;
    if (typeof value !== 'string')
        return false;
    return /^0x[0-9a-fA-F]*$/.test(value);
};

const eventListenerHandlers = (walletConnector) => {
    const handleAccountChange = (accounts) => __awaiter$b(void 0, void 0, void 0, function* () {
        logger$8.debug(`${walletConnector.name} - accountChange`, accounts);
        if (accounts.length === 0) {
            walletConnector.emit('disconnect');
            return;
        }
        walletConnector.emit('accountChange', { accounts });
    });
    const handleChainChange = (chain) => __awaiter$b(void 0, void 0, void 0, function* () {
        logger$8.debug(`${walletConnector.name} - chainChange`, chain);
        const chainStr = isHex(chain)
            ? parseInt(chain, 16).toString()
            : chain.toString();
        walletConnector.emit('chainChange', {
            chain: chainStr,
        });
    });
    const handleDisconnect = (error) => __awaiter$b(void 0, void 0, void 0, function* () {
        logger$8.debug(`${walletConnector.name} - disconnect`, error);
        if ((error === null || error === void 0 ? void 0 : error.code) === 1013) {
            return;
        }
        walletConnector.emit('disconnect');
    });
    return {
        handleAccountChange,
        handleChainChange,
        handleDisconnect,
    };
};

const isPhantomRedirectConnector = (connector) => connector.key === 'phantom' &&
    connector.extractSignature !==
        undefined;

const getRpcUrlForChain = ({ networks, chainId, }) => {
    var _a;
    const network = networks.find((network) => network.chainId === chainId);
    if (!network) {
        return undefined;
    }
    return ((_a = network.privateCustomerRpcUrls) === null || _a === void 0 ? void 0 : _a[0]) || network.rpcUrls[0];
};

const isWalletConnectConnector = (connector) => Boolean(connector === null || connector === void 0 ? void 0 : connector.isWalletConnect);

const isSendBalanceWalletConnector = (walletConnector) => 'createUiTransaction' in walletConnector &&
    typeof walletConnector.createUiTransaction === 'function' &&
    walletConnector.isAvailable;

const isSessionKeyCompatibleWalletConnector = (walletConnector) => {
    const connector = walletConnector;
    return Boolean(typeof (connector === null || connector === void 0 ? void 0 : connector.isSessionKeyCompatible) === 'function' &&
        connector.isSessionKeyCompatible());
};

const isSessionKeyCompatibleWallet = (wallet) => isSessionKeyCompatibleWalletConnector(wallet.connector);

var version$a = "4.6.1";

const WalletBookContext = createContext(undefined);
const useWalletBookContext = () => {
    const context = useContext(WalletBookContext);
    if (context === undefined) {
        throw new Error('useWalletBookContext must be used within a WalletBookContextProvider');
    }
    return context;
};

const getWalletBookWallet = (walletBook, walletKey, walletFallback) => {
    var _a, _b, _c;
    if (!walletKey)
        throw new Error('Wallet key is required. Please pass in a wallet key to getWalletBookWallet');
    const walletData = (_b = (_a = walletBook === null || walletBook === void 0 ? void 0 : walletBook.wallets) === null || _a === void 0 ? void 0 : _a[walletKey]) !== null && _b !== void 0 ? _b : walletFallback;
    if (!walletData) {
        throw new Error(`Wallet ${walletKey} not found in wallet book (${Object.keys((_c = walletBook === null || walletBook === void 0 ? void 0 : walletBook.wallets) !== null && _c !== void 0 ? _c : {}).length} wallets found)`);
    }
    return walletData;
};

var version$9 = "4.6.1";

/* eslint-disable arrow-body-style */
// This method needs to be wrapped correctly to avoid bundler issues
// that may update process.env variable via custom configs in customers apps
const DEFAULT_ICONIC_SPRITE_URL = 'https://iconic.dynamic-static-assets.com/icons/sprite.svg';
const getIconicSpriteUrl = () => {
    var _a, _b, _c;
    if (typeof process !== 'undefined' && process.env) {
        return ((_c = (_b = (_a = process.env['ICONIC_SPRITE_CDN_URL']) !== null && _a !== void 0 ? _a : process.env['NEXT_PUBLIC_ICONIC_SPRITE_CDN_URL']) !== null && _b !== void 0 ? _b : process.env['REACT_APP_ICONIC_SPRITE_CDN_URL']) !== null && _c !== void 0 ? _c : DEFAULT_ICONIC_SPRITE_URL);
    }
    return DEFAULT_ICONIC_SPRITE_URL;
};

const ICONIC_SPRITE_URL = getIconicSpriteUrl();
const createIconic = (props) => {
    const Icon = Object.assign(Object.assign({}, props), { function: (props) => {
            const url = `${ICONIC_SPRITE_URL}#${Icon.iconName}`;
            return createElement('img', Object.assign(Object.assign({ 'data-testid': `iconic-${Icon.iconName}` }, props), { alt: Icon.alt, src: url }));
        } });
    const IconicComponent = Icon.function.bind(Icon);
    Object.assign(IconicComponent, {
        iconName: Icon.iconName,
        sourcePath: Icon.sourcePath,
    });
    return IconicComponent;
};

const BraveIcon = createIconic({
    alt: 'Brave Browser',
    iconName: 'brave',
    sourcePath: 'icons/browsers/brave.svg',
});
const ChromeIcon = createIconic({
    alt: 'Chrome Browser',
    iconName: 'chrome',
    sourcePath: 'icons/browsers/chrome.svg',
});
const EdgeIcon = createIconic({
    alt: 'Edge Browser',
    iconName: 'edge',
    sourcePath: 'icons/browsers/edge.svg',
});
const FirefoxIcon = createIconic({
    alt: 'Firefox Browser',
    iconName: 'firefox',
    sourcePath: 'icons/browsers/firefox.svg',
});
const OperaIcon = createIconic({
    alt: 'Opera Browser',
    iconName: 'opera',
    sourcePath: 'icons/browsers/opera.svg',
});
const SafariIcon = createIconic({
    alt: 'Opera Browser',
    iconName: 'safari',
    sourcePath: 'icons/browsers/safari.svg',
});

const AlgorandIcon = createIconic({
    alt: 'Algorand Chain',
    iconName: 'algorand',
    sourcePath: 'icons/chains/algorand.svg',
});
createIconic({
    alt: 'Arbitrum Chain',
    iconName: 'arbitrum',
    sourcePath: 'icons/chains/arbitrum.svg',
});
createIconic({
    alt: 'Aurora Chain',
    iconName: 'aurora',
    sourcePath: 'icons/chains/aurora.svg',
});
createIconic({
    alt: 'Base Chain',
    iconName: 'base',
    sourcePath: 'icons/chains/base.svg',
});
createIconic({
    alt: 'Berachain Chain',
    iconName: 'berachain',
    sourcePath: 'icons/chains/berachain.svg',
});
const BitcoinIcon = createIconic({
    alt: 'Bitcoin Chain',
    iconName: 'bitcoin',
    sourcePath: 'icons/chains/bitcoin.svg',
});
createIconic({
    alt: 'BNB Chain',
    iconName: 'bnb',
    sourcePath: 'icons/chains/bnb.svg',
});
const CosmosIcon = createIconic({
    alt: 'Cosmos Chain',
    iconName: 'cosmos',
    sourcePath: 'icons/chains/cosmos.svg',
});
const EclipseIcon = createIconic({
    alt: 'Eclipse',
    iconName: 'eclipse',
    sourcePath: 'icons/chains/eclipse.svg',
});
createIconic({
    alt: 'Osmosis Chain',
    iconName: 'osmosis',
    sourcePath: 'icons/chains/osmosis.svg',
});
createIconic({
    alt: 'Axelar Chain',
    iconName: 'axelar',
    sourcePath: 'icons/chains/axelar.svg',
});
createIconic({
    alt: 'Sei Chain',
    iconName: 'sei',
    sourcePath: 'icons/chains/sei.svg',
});
const EthereumIcon = createIconic({
    alt: 'Ethereum Chain',
    iconName: 'ethereum',
    sourcePath: 'icons/chains/ethereum.svg',
});
createIconic({
    alt: 'Goerli Chain',
    iconName: 'goerli',
    sourcePath: 'icons/chains/goerli.svg',
});
createIconic({
    alt: 'zkSync Era Chain',
    iconName: 'zkSync',
    sourcePath: 'icons/chains/zkSync.svg',
});
const FlowIcon = createIconic({
    alt: 'Flow Chain',
    iconName: 'flow',
    sourcePath: 'icons/chains/flow.svg',
});
createIconic({
    alt: 'Gnosis Chain',
    iconName: 'gnosis',
    sourcePath: 'icons/chains/gnosis.svg',
});
createIconic({
    alt: 'Optimism Chain',
    iconName: 'optimism',
    sourcePath: 'icons/chains/optimism.svg',
});
createIconic({
    alt: 'Palm Chain',
    iconName: 'palm',
    sourcePath: 'icons/chains/palm.svg',
});
createIconic({
    alt: 'Polygon Chain',
    iconName: 'polygon',
    sourcePath: 'icons/chains/polygon.svg',
});
const SolanaIcon = createIconic({
    alt: 'Solana Chain',
    iconName: 'solana',
    sourcePath: 'icons/chains/solana.svg',
});
const StarknetIcon = createIconic({
    alt: 'Starknet Chain',
    iconName: 'starknet',
    sourcePath: 'icons/chains/starknet.svg',
});

createIconic({
    alt: 'Banxa',
    iconName: 'banxa',
    sourcePath: 'icons/onramps/banxa.svg',
});
createIconic({
    alt: 'Coinbase Pay',
    iconName: 'coinbase-pay',
    sourcePath: 'icons/onramps/coinbase-pay.svg',
});

const BitbucketIcon = createIconic({
    alt: 'Bitbucket',
    iconName: 'bitbucket',
    sourcePath: 'icons/social/bitbucket.svg',
});
const DiscordIcon = createIconic({
    alt: 'Discord',
    iconName: 'discord',
    sourcePath: 'icons/social/discord.svg',
});
const FacebookIcon = createIconic({
    alt: 'Facebook',
    iconName: 'facebook',
    sourcePath: 'icons/social/facebook.svg',
});
const FarcasterIcon = createIconic({
    alt: 'Farcaster',
    iconName: 'farcaster',
    sourcePath: 'icons/social/farcaster.svg',
});
const GithubIcon = createIconic({
    alt: 'Github',
    iconName: 'github',
    sourcePath: 'icons/social/github.svg',
});
const GithubDarkIcon = createIconic({
    alt: 'Github',
    iconName: 'github-dark',
    sourcePath: 'icons/social/github-dark.svg',
});
const GitlabIcon = createIconic({
    alt: 'Gitlab',
    iconName: 'gitlab',
    sourcePath: 'icons/social/gitlab.svg',
});
const GoogleIcon = createIconic({
    alt: 'Google',
    iconName: 'google',
    sourcePath: 'icons/social/google.svg',
});
const HelpdeskIcon = createIconic({
    alt: 'Helpdesk',
    iconName: 'helpdesk',
    sourcePath: 'icons/social/helpdesk.svg',
});
const LinkedinIcon = createIconic({
    alt: 'Linkedin',
    iconName: 'linkedin',
    sourcePath: 'icons/social/linkedin.svg',
});
const MicrosoftIcon = createIconic({
    alt: 'Microsoft',
    iconName: 'microsoft',
    sourcePath: 'icons/social/microsoft.svg',
});
const SlackIcon = createIconic({
    alt: 'Slack',
    iconName: 'slack',
    sourcePath: 'icons/social/slack.svg',
});
const TelegramIcon = createIconic({
    alt: 'Telegram',
    iconName: 'telegram',
    sourcePath: 'icons/social/telegram.svg',
});
const TwitchIcon = createIconic({
    alt: 'Twitch',
    iconName: 'twitch',
    sourcePath: 'icons/social/twitch.svg',
});
const TwitchDarkIcon = createIconic({
    alt: 'Twitch',
    iconName: 'twitch-dark',
    sourcePath: 'icons/social/twitch-dark.svg',
});
const TwitterIcon = createIconic({
    alt: 'Twitter',
    iconName: 'twitter',
    sourcePath: 'icons/social/twitter.svg',
});
const TwitterDarkIcon = createIconic({
    alt: 'Twitter',
    iconName: 'twitter-dark',
    sourcePath: 'icons/social/twitter-dark.svg',
});
const AppleSocialIcon = createIconic({
    alt: 'Apple',
    iconName: 'apple',
    sourcePath: 'icons/social/apple.svg',
});
const AppleDarkSocialIcon = createIconic({
    alt: 'Apple',
    iconName: 'apple-dark',
    sourcePath: 'icons/social/apple-dark.svg',
});
const CoinbaseSocialIcon = createIconic({
    alt: 'Coinbase',
    iconName: 'coinbasesocial',
    sourcePath: 'icons/social/coinbasesocial.svg',
});
const CoinbaseSocialDarkIcon = createIconic({
    alt: 'Coinbase',
    iconName: 'coinbasesocial-dark',
    sourcePath: 'icons/social/coinbasesocial-dark.svg',
});
const InstagramIcon = createIconic({
    alt: 'Instagram',
    iconName: 'instagram',
    sourcePath: 'icons/social/instagram.svg',
});
const YouTubeIcon = createIconic({
    alt: 'YouTube',
    iconName: 'youtube',
    sourcePath: 'icons/social/youtube.svg',
});
const OnePasswordIcon = createIconic({
    alt: 'onePassword',
    iconName: 'one-password',
    sourcePath: 'icons/social/onePassword.svg',
});
const OnePasswordDarkIcon = createIconic({
    alt: 'onePassword-dark',
    iconName: 'one-password-dark',
    sourcePath: 'icons/social/onePassword-dark.svg',
});
const EpicGamesIcon = createIconic({
    alt: 'epicGames',
    iconName: 'epicgames',
    sourcePath: 'icons/social/epicgames.svg',
});
const EpicGamesDarkIcon = createIconic({
    alt: 'epicGames-dark',
    iconName: 'epicgames-dark',
    sourcePath: 'icons/social/epicgames-dark.svg',
});
const SpotifyIcon = createIconic({
    alt: 'spotify',
    iconName: 'spotify',
    sourcePath: 'icons/social/spotify.svg',
});
const SpotifyDarkIcon = createIconic({
    alt: 'spotify-dark',
    iconName: 'spotify-dark',
    sourcePath: 'icons/social/spotify-dark.svg',
});
const SteamIcon = createIconic({
    alt: 'steam',
    iconName: 'steam',
    sourcePath: 'icons/social/steam.svg',
});
const SteamDarkIcon = createIconic({
    alt: 'steam-dark',
    iconName: 'steam-dark',
    sourcePath: 'icons/social/steam-dark.svg',
});
const TikTokIcon = createIconic({
    alt: 'tiktok',
    iconName: 'tiktok',
    sourcePath: 'icons/social/tiktok.svg',
});
const TikTokDarkIcon = createIconic({
    alt: 'tiktok-dark',
    iconName: 'tiktok-dark',
    sourcePath: 'icons/social/tiktok-dark.svg',
});
const LineIcon = createIconic({
    alt: 'line',
    iconName: 'line',
    sourcePath: 'icons/social/line.svg',
});
const ShopifyIcon = createIconic({
    alt: 'shopify',
    iconName: 'shopify',
    sourcePath: 'icons/social/shopify.svg',
});

var index = /*#__PURE__*/Object.freeze({
	__proto__: null,
	AppleDarkSocialIcon: AppleDarkSocialIcon,
	AppleSocialIcon: AppleSocialIcon,
	BitbucketIcon: BitbucketIcon,
	CoinbaseSocialDarkIcon: CoinbaseSocialDarkIcon,
	CoinbaseSocialIcon: CoinbaseSocialIcon,
	DiscordIcon: DiscordIcon,
	EpicGamesDarkIcon: EpicGamesDarkIcon,
	EpicGamesIcon: EpicGamesIcon,
	FacebookIcon: FacebookIcon,
	FarcasterIcon: FarcasterIcon,
	GithubDarkIcon: GithubDarkIcon,
	GithubIcon: GithubIcon,
	GitlabIcon: GitlabIcon,
	GoogleIcon: GoogleIcon,
	HelpdeskIcon: HelpdeskIcon,
	InstagramIcon: InstagramIcon,
	LineIcon: LineIcon,
	LinkedinIcon: LinkedinIcon,
	MicrosoftIcon: MicrosoftIcon,
	OnePasswordDarkIcon: OnePasswordDarkIcon,
	OnePasswordIcon: OnePasswordIcon,
	ShopifyIcon: ShopifyIcon,
	SlackIcon: SlackIcon,
	SpotifyDarkIcon: SpotifyDarkIcon,
	SpotifyIcon: SpotifyIcon,
	SteamDarkIcon: SteamDarkIcon,
	SteamIcon: SteamIcon,
	TelegramIcon: TelegramIcon,
	TikTokDarkIcon: TikTokDarkIcon,
	TikTokIcon: TikTokIcon,
	TwitchDarkIcon: TwitchDarkIcon,
	TwitchIcon: TwitchIcon,
	TwitterDarkIcon: TwitterDarkIcon,
	TwitterIcon: TwitterIcon,
	YouTubeIcon: YouTubeIcon
});

createIconic({
    alt: '1inch Wallet',
    iconName: '1inch.svg',
    sourcePath: 'icons/wallets/1inch.svg',
});
createIconic({
    alt: 'Argent X Wallet',
    iconName: 'argentx',
    sourcePath: 'icons/wallets/argentx.svg',
});
createIconic({
    alt: 'Argent Mobile',
    iconName: 'argentmobile',
    sourcePath: 'icons/wallets/argent-mobile.svg',
});
createIconic({
    alt: 'Argent Web Wallet',
    iconName: 'argentwebwallet',
    sourcePath: 'icons/wallets/argent-web-wallet.svg',
});
createIconic({
    alt: 'Backpack Wallet',
    iconName: 'backpack',
    sourcePath: 'icons/wallets/backpack.svg',
});
createIconic({
    alt: 'Binance Wallet',
    iconName: 'binance.svg',
    sourcePath: 'icons/wallets/binance.svg',
});
createIconic({
    alt: 'BitPay Wallet',
    iconName: 'bitpay.svg',
    sourcePath: 'icons/wallets/bitpay.svg',
});
createIconic({
    alt: 'Blocto Wallet',
    iconName: 'blocto',
    sourcePath: 'icons/wallets/blocto.svg',
});
createIconic({
    alt: 'Braavos Wallet',
    iconName: 'braavos',
    sourcePath: 'icons/wallets/braavos.svg',
});
createIconic({
    alt: 'Coin98 Wallet',
    iconName: 'coin98',
    sourcePath: 'icons/wallets/coin98.svg',
});
createIconic({
    alt: 'Coinbase Wallet',
    iconName: 'coinbase',
    sourcePath: 'icons/wallets/coinbase.svg',
});
createIconic({
    alt: 'Crypto Wallet',
    iconName: 'crypto.svg',
    sourcePath: 'icons/wallets/crypto.svg',
});
createIconic({
    alt: 'Dapper Wallet',
    iconName: 'dapper',
    sourcePath: 'icons/wallets/dapper.svg',
});
createIconic({
    alt: 'Dawn Wallet',
    iconName: 'dawn',
    sourcePath: 'icons/wallets/dawn.svg',
});
createIconic({
    alt: 'Default Wallet',
    iconName: 'defaultwallet',
    sourcePath: 'icons/wallets/default.svg',
});
createIconic({
    alt: 'Dapper Wallet',
    iconName: 'emailsign.svg',
    sourcePath: 'icons/wallets/emailsign.svg',
});
const SignInWithEmailIcon = createIconic({
    alt: 'Sign in with Email',
    iconName: 'signinwithemail',
    sourcePath: 'icons/wallets/signinwithemail.svg',
});
createIconic({
    alt: 'Exodus Wallet',
    iconName: 'exodus',
    sourcePath: 'icons/wallets/exodus.svg',
});
createIconic({
    alt: 'Fireblocks Wallet',
    iconName: 'fireblocks',
    sourcePath: 'icons/wallets/fireblocks.svg',
});
createIconic({
    alt: 'Flow Wallet',
    iconName: 'flowwallet',
    sourcePath: 'icons/wallets/flowwallet.svg',
});
createIconic({
    alt: 'Fordefi Wallet',
    iconName: 'fordefi',
    sourcePath: 'icons/wallets/fordefi.svg',
});
createIconic({
    alt: 'Fortmatic Wallet',
    iconName: 'fortmatic',
    sourcePath: 'icons/wallets/fortmatic.svg',
});
createIconic({
    alt: 'Frame Wallet',
    iconName: 'frame',
    sourcePath: 'icons/wallets/frame.svg',
});
createIconic({
    alt: 'Gamestop Wallet',
    iconName: 'gamestop',
    sourcePath: 'icons/wallets/gamestop.svg',
});
createIconic({
    alt: 'Glow Wallet',
    iconName: 'glow',
    sourcePath: 'icons/wallets/glow.svg',
});
createIconic({
    alt: 'ImToken Wallet',
    iconName: 'imtoken.svg',
    sourcePath: 'icons/wallets/imtoken.svg',
});
createIconic({
    alt: 'Injected Wallet',
    iconName: 'injectedwallet',
    sourcePath: 'icons/wallets/injectedwallet.svg',
});
createIconic({
    alt: 'Keplr Wallet',
    iconName: 'keplr',
    sourcePath: 'icons/wallets/keplr.svg',
});
createIconic({
    alt: 'Ledger Wallet',
    iconName: 'ledger',
    sourcePath: 'icons/wallets/ledger.svg',
});
createIconic({
    alt: 'Lilico Wallet',
    iconName: 'lilico',
    sourcePath: 'icons/wallets/lilico.svg',
});
createIconic({
    alt: 'Linen Wallet',
    iconName: 'linen.svg',
    sourcePath: 'icons/wallets/linen.svg',
});
createIconic({
    alt: 'Matic Wallet',
    iconName: 'matic',
    sourcePath: 'icons/wallets/matic.svg',
});
createIconic({
    alt: 'MetaMask Wallet',
    iconName: 'metamask',
    sourcePath: 'icons/wallets/metamask.svg',
});
createIconic({
    alt: 'Missing Wallet',
    iconName: 'missing',
    sourcePath: 'icons/wallets/missing.svg',
});
createIconic({
    alt: 'MyAlgo Wallet',
    iconName: 'myalgo',
    sourcePath: 'icons/wallets/myalgo.svg',
});
createIconic({
    alt: 'Omni Wallet',
    iconName: 'omni',
    sourcePath: 'icons/wallets/omni.svg',
});
createIconic({
    alt: 'OpeanSea Wallet',
    iconName: 'opeansea',
    sourcePath: 'icons/wallets/opensea.svg',
});
createIconic({
    alt: 'Oyl Wallet',
    iconName: 'oyl',
    sourcePath: 'icons/wallets/oyl.svg',
});
createIconic({
    alt: 'Passkeys Wallet',
    iconName: 'passkeys',
    sourcePath: 'icons/wallets/passkeys.svg',
});
createIconic({
    alt: 'Pera Wallet',
    iconName: 'pera',
    sourcePath: 'icons/wallets/pera.svg',
});
createIconic({
    alt: 'Phantom Wallet',
    iconName: 'phantom',
    sourcePath: 'icons/wallets/phantom.svg',
});
createIconic({
    alt: 'Rabby Wallet',
    iconName: 'rabby',
    sourcePath: 'icons/wallets/rabby.svg',
});
createIconic({
    alt: 'Rainbow Wallet',
    iconName: 'rainbow',
    sourcePath: 'icons/wallets/rainbow.svg',
});
createIconic({
    alt: 'Safe Wallet',
    iconName: 'safe',
    sourcePath: 'icons/wallets/safe.svg',
});
createIconic({
    alt: 'Sequence Wallet',
    iconName: 'sequence',
    sourcePath: 'icons/wallets/sequence.svg',
});
createIconic({
    alt: 'Solflare Wallet',
    iconName: 'solflare',
    sourcePath: 'icons/wallets/solflare.svg',
});
createIconic({
    alt: 'Spot Wallet',
    iconName: 'spot',
    sourcePath: 'icons/wallets/spot.svg',
});
createIconic({
    alt: 'Stroke Wallet',
    iconName: 'stroke',
    sourcePath: 'icons/wallets/stroke.svg',
});
createIconic({
    alt: 'Taho Wallet',
    iconName: 'tallycash',
    sourcePath: 'icons/wallets/tallycash.svg',
});
createIconic({
    alt: 'Terra Wallet',
    iconName: 'terra',
    sourcePath: 'icons/wallets/terra.svg',
});
createIconic({
    alt: 'Torus Wallet',
    iconName: 'torus',
    sourcePath: 'icons/wallets/torus.svg',
});
createIconic({
    alt: 'Trust Wallet',
    iconName: 'trust',
    sourcePath: 'icons/wallets/trust.svg',
});
createIconic({
    alt: 'Unstoppable Wallet',
    iconName: 'unstoppable',
    sourcePath: 'icons/wallets/unstoppable.svg',
});
createIconic({
    alt: 'Venly Wallet',
    iconName: 'venly',
    sourcePath: 'icons/wallets/venly.svg',
});
const WalletConnectIcon = createIconic({
    alt: 'Wallet Connect Wallet',
    iconName: 'walletconnect',
    sourcePath: 'icons/wallets/walletconnect.svg',
});
createIconic({
    alt: 'Magic Link Wallet',
    iconName: 'magiclink',
    sourcePath: 'icons/wallets/magic-link.svg',
});
createIconic({
    alt: 'Turnkey',
    iconName: 'turnkey',
    sourcePath: 'icons/wallets/embedded-wallet.svg',
});
createIconic({
    alt: 'Dynamic Waas',
    iconName: 'dynamicwaas',
    sourcePath: 'icons/wallets/embedded-wallet.svg',
});
createIconic({
    alt: 'Zengo Wallet',
    iconName: 'zengo',
    sourcePath: 'icons/wallets/zengo.svg',
});
createIconic({
    alt: 'Superb Wallet',
    iconName: 'superb',
    sourcePath: 'icons/wallets/superb.svg',
});
createIconic({
    alt: 'ZeroDev',
    iconName: 'zerodev',
    sourcePath: 'icons/wallets/embedded-wallet.svg',
});
createIconic({
    alt: 'Smart Wallet',
    iconName: 'smartwallet',
    sourcePath: 'icons/wallets/smart-wallet.svg',
});
createIconic({
    alt: 'Magic Eden',
    iconName: 'magiceden',
    sourcePath: 'icons/wallets/magiceden.svg',
});
createIconic({
    alt: 'Xverse',
    iconName: 'xverse',
    sourcePath: 'icons/wallets/xverse.svg',
});
createIconic({
    alt: 'Unisat',
    iconName: 'unisat',
    sourcePath: 'icons/wallets/unisat.svg',
});
createIconic({
    alt: 'Leather',
    iconName: 'leather',
    sourcePath: 'icons/wallets/leather.svg',
});
createIconic({
    alt: 'OKX',
    iconName: 'okx',
    sourcePath: 'icons/wallets/okx.svg',
});
createIconic({
    alt: 'Coinbase WaaS',
    iconName: 'coinbasewaas',
    sourcePath: 'icons/wallets/embedded-wallet.svg',
});
createIconic({
    alt: 'MetaMask Starknet Snap',
    iconName: 'metamaskstarknetsnap',
    sourcePath: 'icons/wallets/metamask-starknet.svg',
});
createIconic({
    alt: 'Nightly',
    iconName: 'nightly',
    sourcePath: 'icons/wallets/nightly.svg',
});
createIconic({
    alt: 'OneKey',
    iconName: 'onekey',
    sourcePath: 'icons/wallets/onekey.svg',
});
createIconic({
    alt: 'Ambire',
    iconName: 'ambire',
    sourcePath: 'icons/wallets/ambire.svg',
});
createIconic({
    alt: 'Bitget Wallet',
    iconName: 'bitgetwallet',
    sourcePath: 'icons/wallets/bitgetwallet.svg',
});
createIconic({
    alt: 'Math Wallet',
    iconName: 'coin98',
    sourcePath: 'icons/wallets/coin98.svg',
});
createIconic({
    alt: 'Clover Wallet',
    iconName: 'clover',
    sourcePath: 'icons/wallets/clover.svg',
});
createIconic({
    alt: 'Unknown Wallet',
    iconName: 'unknown-wallet',
    sourcePath: 'icons/wallets/unknown.svg',
});
createIconic({
    alt: 'Abstract',
    iconName: 'abstract',
    sourcePath: 'icons/wallets/abstract.svg',
});
createIconic({
    alt: 'Eden Online',
    iconName: 'edenonline',
    sourcePath: 'icons/wallets/edenonline.svg',
});
createIconic({
    alt: 'Intersend',
    iconName: 'intersend',
    sourcePath: 'icons/wallets/intersend.svg',
});

const AppleIcon = createIconic({
    alt: 'Apple',
    iconName: 'apple',
    sourcePath: 'icons/mobile/apple.svg',
});
const AndroidIcon = createIconic({
    alt: 'Android',
    iconName: 'android',
    sourcePath: 'icons/mobile/android.svg',
});

const CaptchaWaveIcon = createIconic({
    alt: 'Captcha Wave',
    iconName: 'captcha-wave',
    sourcePath: 'icons/misc/captcha-wave.svg',
});
const UserProfileIcon = createIconic({
    alt: 'User Profile',
    iconName: 'user-profile',
    sourcePath: 'icons/misc/user-profile.svg',
});
createIconic({
    alt: 'Arrow Send',
    iconName: 'arrow-send',
    sourcePath: 'icons/misc/arrow-send.svg',
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest$7(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const logger$7 = new Logger$1('iconic');

const getSocialIcon = (name, variant = 'light') => {
    const map = Object.fromEntries(Object.values(index).map((icon) => [icon.iconName, icon]));
    if (variant === 'dark') {
        const darkIcon = map[`${name.toLowerCase()}-dark`];
        if (darkIcon)
            return darkIcon;
    }
    const icon = map[name.toLowerCase()];
    if (icon)
        return icon;
    throw new Error(`Icon ${name}, not found`);
};

const findSocialIcon = (name, variant = 'light') => {
    try {
        return getSocialIcon(name, variant);
    }
    catch (e) {
        logger$7.error(e);
        return null;
    }
};

const SocialIcon = (_a) => {
    var { name, variant } = _a, props = __rest$7(_a, ["name", "variant"]);
    const Icon = findSocialIcon(name, variant);
    if (!Icon)
        return null;
    return createElement(Icon, props, null);
};

assertPackageVersion('@dynamic-labs/iconic', version$9);

const TEMPLATES = {
    androidUrl: 'https://play.google.com/store/apps/details?id={{id}}',
    chromeUrl: 'https://chrome.google.com/webstore/detail/{{id}}',
    edgeUrl: 'https://microsoftedge.microsoft.com/addons/detail/{{id}}',
    firefoxUrl: 'https://addons.mozilla.org/en-US/firefox/addon/{{id}}',
    iconicUrl: `${getIconicSpriteUrl()}#{{id}}`,
    iosUrl: 'https://apps.apple.com/app/apple-store/{{id}}',
    walletConnectUrl: 'https://registry.walletconnect.org/v2/logo/sm/{{id}}',
};
const renderTemplate = (templateName, data) => {
    if (!data)
        return undefined;
    return TEMPLATES[templateName].replace('{{id}}', data);
};

const getBrandIconUrl = (brand) => {
    if (brand.spriteId) {
        return renderTemplate('iconicUrl', brand.spriteId);
    }
    return '';
};

const logger$6 = new Logger$1('WalletBook');

const getDefaultWalletIconUrl = () => {
    try {
        return renderTemplate('iconicUrl', 'defaultwallet');
    }
    catch (err) {
        logger$6.error(err);
    }
    return '';
};

const findWalletBookWallet = (walletBook, walletKey) => {
    try {
        const walletData = getWalletBookWallet(walletBook, walletKey);
        return walletData;
    }
    catch (err) {
        return undefined;
    }
};

const getWalletGroup = (walletBook, key) => {
    const group = walletBook.groups[key];
    if (!group)
        throw new Error(`Group ${key} not found in wallet book`);
    return group;
};

const findWalletGroup = (walletBook, walletGroup) => {
    try {
        return getWalletGroup(walletBook, walletGroup);
    }
    catch (err) {
        logger$6.error(err);
        return undefined;
    }
};

const DEFAULT_WALLET_BOOK_CDN_URL = 'https://dynamic-static-assets.com/wallet-book/v1/stable/wallet-book.json';
const getWalletBookCdnUrl = () => getEnvVarWithFallback([
    'WALLET_BOOK_CDN_URL',
    'NEXT_PUBLIC_WALLET_BOOK_CDN_URL',
    'REACT_APP_WALLET_BOOK_CDN_URL',
], DEFAULT_WALLET_BOOK_CDN_URL);

const findWalletGroupOverride = (walletBook, groupKey, walletKey) => {
    var _a;
    const group = findWalletGroup(walletBook, groupKey);
    return (_a = group === null || group === void 0 ? void 0 : group.walletOverrides) === null || _a === void 0 ? void 0 : _a[walletKey];
};

const isWalletBookPopulated = (walletBook) => { var _a; return Object.keys((_a = walletBook === null || walletBook === void 0 ? void 0 : walletBook.wallets) !== null && _a !== void 0 ? _a : {}).length > 0; };

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest$6(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter$a(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var groups = {
	argentx: {
		brand: {
			alt: "ArgentX",
			primaryColor: "#FF875B",
			spriteId: "argentx"
		},
		key: "argentx",
		name: "ArgentX"
	},
	backpack: {
		brand: {
			alt: "Backpack",
			spriteId: "backpack"
		},
		key: "backpack",
		name: "Backpack"
	},
	bitgetwallet: {
		brand: {
			alt: "Bitget Wallet",
			spriteId: "bitget"
		},
		key: "bitgetwallet",
		name: "Bitget"
	},
	blocto: {
		brand: {
			alt: "Blocto",
			primaryColor: "#5E678A",
			spriteId: "blocto"
		},
		key: "blocto",
		name: "Blocto"
	},
	brave: {
		brand: {
			alt: "Brave Browser",
			primaryColor: "#4B49C6",
			spriteId: "brave"
		},
		key: "brave",
		name: "Brave"
	},
	coin98: {
		brand: {
			alt: "Coin98 Wallet",
			primaryColor: "#CDA349",
			spriteId: "fc460647-ea95-447a-99f0-1bff8fa4be00"
		},
		key: "coin98",
		name: "Coin98"
	},
	coinbase: {
		brand: {
			alt: "Coinbase Wallet",
			primaryColor: "#1648F9",
			spriteId: "coinbase"
		},
		key: "coinbase",
		name: "Coinbase"
	},
	compasswallet: {
		brand: {
			alt: "Compass",
			primaryColor: "#4B49C6",
			spriteId: "1d7dea00-96be-4ce8-ca15-d14bddbb5000"
		},
		key: "compasswallet",
		name: "Compass"
	},
	exodus: {
		brand: {
			alt: "Exodus Wallet",
			spriteId: "exodus"
		},
		key: "exodus",
		name: "Exodus"
	},
	fireblocks: {
		brand: {
			alt: "Fireblocks",
			spriteId: "fireblocks"
		},
		key: "fireblocks",
		name: "Fireblocks"
	},
	flowwallet: {
		brand: {
			alt: "Flow Wallet",
			primaryColor: "#2BE829",
			spriteId: "flowwallet"
		},
		key: "flowwallet",
		name: "Flow Wallet"
	},
	keplr: {
		brand: {
			alt: "Keplr",
			spriteId: "keplr"
		},
		key: "keplr",
		name: "Keplr"
	},
	magiceden: {
		brand: {
			alt: "Magic Eden",
			spriteId: "magiceden"
		},
		key: "magiceden",
		name: "Magic Eden"
	},
	mathwallet: {
		brand: {
			alt: "MathWallet Wallet",
			spriteId: "26a8f588-3231-4411-60ce-5bb6b805a700"
		},
		key: "mathwallet",
		name: "Math Wallet"
	},
	metamask: {
		brand: {
			alt: "MetaMask",
			primaryColor: "#E2761B",
			spriteId: "metamask"
		},
		key: "metamask",
		name: "MetaMask"
	},
	nightly: {
		brand: {
			alt: "Nightly Wallet",
			spriteId: "nightly"
		},
		key: "nightly",
		name: "Nightly"
	},
	okxwallet: {
		brand: {
			alt: "OKX Wallet",
			spriteId: "okx"
		},
		key: "okxwallet",
		name: "OKX Wallet"
	},
	onekey: {
		brand: {
			alt: "OneKey Wallet",
			spriteId: "onekey"
		},
		key: "onekey",
		name: "OneKey"
	},
	phantom: {
		brand: {
			alt: "Phantom",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		key: "phantom",
		name: "Phantom"
	}
};
var wallets = {
	metamask: {
		brand: {
			alt: "MetaMask Wallet",
			primaryColor: "#E8831D",
			spriteId: "metamask"
		},
		chainGroup: "metamask",
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:42161",
			"eip155:42170",
			"eip155:7777777",
			"eip155:80084",
			"eip155:80085",
			"eip155:8453"
		],
		desktop: {
			chromeId: "nkbihfbeogaeaoehlefnkodbefgpgknn",
			edgeId: "ejbalbakoplchlghecdalmeeeajnimhm",
			firefoxId: "ether-metamask"
		},
		eip6963Config: {
			rdns: "io.metamask"
		},
		filterFromWalletConnect: true,
		group: "metamask",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isMetaMask",
						value: true
					},
					{
						flag: "isDawn",
						value: false
					},
					{
						flag: "isBraveWallet",
						value: false
					},
					{
						flag: "isTrustWallet",
						value: false
					},
					{
						flag: "isExodus",
						value: false
					},
					{
						flag: "isZerion",
						value: false
					},
					{
						flag: "isSuperb",
						value: false
					},
					{
						flag: "isRabby",
						value: false
					},
					{
						flag: "isOKExWallet",
						value: false
					},
					{
						flag: "isOkxWallet",
						value: false
					},
					{
						flag: "isRainbow",
						value: false
					},
					{
						flag: "isAvalanche",
						value: false
					},
					{
						flag: "isMagicEden",
						value: false
					},
					{
						flag: "isZerion",
						value: false
					},
					{
						flag: "isOneKey",
						value: false
					},
					{
						flag: "isPhantom",
						value: false
					},
					{
						flag: "isCoin98",
						value: false
					},
					{
						flag: "isBinance",
						value: false
					}
				]
			}
		],
		mobile: {
			androidId: "io.metamask",
			inAppBrowser: "https://metamask.app.link/dapp",
			iosId: "id1438144202",
			native: "metamask://wc",
			universal: "https://metamask.app.link/wc"
		},
		mobileExperience: "in-app-browser",
		name: "MetaMask",
		shortName: "MetaMask",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	coinbase: {
		brand: {
			alt: "Coinbase Wallet",
			primaryColor: "#1648F9",
			spriteId: "coinbase"
		},
		chainGroup: "coinbase",
		desktop: {
			chromeId: "hnfanknocfeofbddgcijnmhnfnkdnaad"
		},
		eip6963Config: {
			rdns: "com.coinbase.wallet"
		},
		group: "coinbase",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isCoinbaseWallet",
						value: true
					}
				],
				windowLocations: [
					"coinbaseWalletExtension"
				]
			}
		],
		mobile: {
			androidId: "org.toshi",
			iosId: "id1278383455"
		},
		name: "Coinbase",
		shortName: "Coinbase Wallet"
	},
	coinbasesolana: {
		brand: {
			alt: "Coinbase Wallet",
			primaryColor: "#1648F9",
			spriteId: "coinbase"
		},
		chainGroup: "coinbase",
		desktop: {
			chromeId: "hnfanknocfeofbddgcijnmhnfnkdnaad"
		},
		group: "coinbase",
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
				],
				windowLocations: [
					"coinbaseSolana"
				]
			}
		],
		name: "Coinbase",
		shortName: "Coinbase Wallet (Solana)",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	phantom: {
		brand: {
			alt: "Phantom Wallet",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		chainGroup: "phantom",
		desktop: {
			chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
			firefoxId: "phantom-app"
		},
		group: "phantom",
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
					{
						flag: "isPhantom",
						value: true
					},
					{
						flag: "isBraveWallet",
						value: false
					},
					{
						flag: "isExodus",
						value: false
					},
					{
						flag: "isMagicEden",
						value: false
					},
					{
						flag: "isGlow",
						value: false
					},
					{
						flag: "isOKExWallet",
						value: false
					},
					{
						flag: "isOkxWallet",
						value: false
					}
				],
				walletStandardLocators: [
					{
						locator: "features.phantom:.phantom",
						name: "Phantom"
					}
				],
				windowLocations: [
					"phantom.solana"
				]
			}
		],
		mobile: {
			androidId: "app.phantom",
			iosId: "id1598432977"
		},
		name: "Phantom"
	},
	phantombtc: {
		brand: {
			alt: "Phantom Wallet",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		chainGroup: "phantom",
		desktop: {
			chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
			firefoxId: "phantom-app"
		},
		group: "phantom",
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
					{
						flag: "isPhantom",
						value: true
					}
				],
				walletStandard: {
					features: [
						"bitcoin:connect"
					],
					name: "Phantom"
				},
				windowLocations: [
					"phantom.bitcoin"
				]
			}
		],
		mobile: {
			androidId: "app.phantom",
			iosId: "id1598432977"
		},
		name: "Phantom",
		shortName: "Phantom (Bitcoin)"
	},
	phantomevm: {
		brand: {
			alt: "Phantom Wallet",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		chainGroup: "phantom",
		desktop: {
			chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
			firefoxId: "phantom-app"
		},
		group: "phantom",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isPhantom",
						value: true
					}
				],
				windowLocations: [
					"phantom.ethereum"
				]
			}
		],
		mobile: {
			androidId: "app.phantom",
			iosId: "id1598432977"
		},
		name: "Phantom",
		shortName: "Phantom (EVM)"
	},
	phantomledger: {
		brand: {
			alt: "Phantom Wallet",
			primaryColor: "#4B49C6",
			spriteId: "phantom"
		},
		chainGroup: "phantom",
		desktop: {
			chromeId: "bfnaelmomeimhlpmgjnjophhpkkoljpa",
			firefoxId: "phantom-app"
		},
		group: "phantom",
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
					{
						flag: "isPhantom",
						value: true
					},
					{
						flag: "isBraveWallet",
						value: false
					},
					{
						flag: "isExodus",
						value: false
					},
					{
						flag: "isMagicEden",
						value: false
					},
					{
						flag: "isGlow",
						value: false
					},
					{
						flag: "isOKExWallet",
						value: false
					},
					{
						flag: "isOkxWallet",
						value: false
					}
				],
				walletStandardLocators: [
					{
						locator: "features.phantom:.phantom",
						name: "Phantom"
					}
				],
				windowLocations: [
					"phantom.solana"
				]
			}
		],
		mobile: {
			androidId: "app.phantom",
			iosId: "id1598432977"
		},
		name: "Phantom",
		shortName: "Phantom (Ledger)"
	},
	walletconnect: {
		brand: {
			alt: "WalletConnect",
			primaryColor: "#3182CE",
			spriteId: "walletconnect"
		},
		mobile: {
			androidId: "enable-android",
			iosId: "id1438144202"
		},
		name: "WalletConnect",
		shortName: "WalletConnect"
	},
	argentx: {
		brand: {
			alt: "Argent X Wallet",
			primaryColor: "#FF875B",
			spriteId: "argentx"
		},
		desktop: {
			chromeId: "dlcobpjiigpikoobohmabehhmhfoodbb",
			edgeId: "ajcicjlkibolbeaaagejfhnofogocgcj",
			firefoxId: "argent-x"
		},
		name: "Argent X"
	},
	perawallet: {
		brand: {
			alt: "Pera Wallet",
			spriteId: "pera"
		},
		mobile: {
			androidId: "com.algorand.android",
			iosId: "id1459898525"
		},
		name: "Pera Wallet"
	},
	blocto: {
		brand: {
			alt: "Blocto Wallet",
			primaryColor: "#5E678A",
			spriteId: "blocto"
		},
		chainGroup: "blocto",
		group: "blocto",
		mobile: {
			androidId: "com.portto.blocto",
			iosId: "id1481181682"
		},
		name: "Blocto",
		shortName: "Blocto (Flow)"
	},
	solflare: {
		brand: {
			alt: "Solflare Wallet",
			primaryColor: "#FC7227",
			spriteId: "solflare"
		},
		chains: [
			"solana:4uhcVJyU9pJkvQyS88uRDiswHXSCkY3z",
			"solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp",
			"solana:EtWTRABZaYq6iMfeYKouRu166VU2xqa1"
		],
		desktop: {
			chromeId: "bhhhlbepdkbapadjdnnojkbgioiodbic"
		},
		filterFromWalletConnect: true,
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
					{
						flag: "isSolflare",
						value: true
					}
				],
				windowLocations: [
					"solflare"
				]
			}
		],
		mobile: {
			androidId: "com.solflare.mobile",
			iosId: "id1580902717"
		},
		name: "Solflare",
		walletConnect: {
			sdks: [
				"sign_v1"
			]
		},
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	braavos: {
		brand: {
			alt: "Braavos Wallet",
			primaryColor: "#FABB38",
			spriteId: "braavos"
		},
		desktop: {
			chromeId: "jnlgamecbpmbajjfhmmmlhejkemejdma",
			edgeId: "hkkpjehhcnhgefhbdcgfkeegglpjchdc",
			firefoxId: "braavos-wallet"
		},
		injectedConfig: [
			{
				chain: "starknet",
				extensionLocators: [
				],
				windowLocations: [
					"braavos"
				]
			}
		],
		mobile: {
			androidId: "app.braavos.wallet",
			inAppBrowser: "https://link.braavos.app/dapp/{{encodedDappURI}}",
			iosId: "id1636013523"
		},
		name: "Braavos"
	},
	trust: {
		brand: {
			alt: "Trust Wallet",
			primaryColor: "#0500FF",
			spriteId: "7677b54f-3486-46e2-4e37-bf8747814f00"
		},
		chains: [
			"cosmos:cosmoshub-4",
			"cosmos:kava-4",
			"cosmos:thorchain-mainnet-v1",
			"eip155:1",
			"eip155:10",
			"eip155:100",
			"eip155:108",
			"eip155:1101",
			"eip155:128",
			"eip155:137",
			"eip155:2020",
			"eip155:288",
			"eip155:321",
			"eip155:324",
			"eip155:361",
			"eip155:42161",
			"eip155:42220",
			"eip155:43114",
			"eip155:4689",
			"eip155:56",
			"eip155:56288",
			"eip155:59144",
			"eip155:60",
			"eip155:80084",
			"eip155:80085",
			"eip155:820",
			"eip155:88",
			"eip155:9001",
			"solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp"
		],
		desktop: {
			chromeId: "egjidjbpglichdcondbcbdnbeeppgdph"
		},
		eip6963Config: {
			rdns: "com.trustwallet.app"
		},
		filterFromWalletConnect: true,
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isTrustWallet",
						value: true
					}
				],
				windowLocations: [
					"trustWallet"
				]
			}
		],
		mobile: {
			androidId: "com.wallet.crypto.trustapp",
			iosId: "id1288339409",
			native: "trust://wc",
			universal: "https://link.trustwallet.com/wc"
		},
		name: "Trust",
		shortName: "Trust",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	rainbow: {
		brand: {
			alt: "Rainbow Wallet",
			primaryColor: "#001e59",
			spriteId: "rainbow"
		},
		chains: [
			"eip155:1",
			"eip155:10",
			"eip155:137",
			"eip155:42161",
			"eip155:56",
			"eip155:7777777",
			"eip155:80084",
			"eip155:80085",
			"eip155:8453"
		],
		desktop: {
			chromeId: "opfgelmcmbiajamepnmloijbpoleiama",
			edgeId: "cpojfbodiccabbabgimdeohkkpjfpbnf",
			firefoxId: "rainbow-extension"
		},
		eip6963Config: {
			rdns: "me.rainbow"
		},
		filterFromWalletConnect: true,
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isRainbow",
						value: true
					}
				],
				windowLocations: [
					"rainbow"
				]
			}
		],
		mobile: {
			androidId: "me.rainbow",
			iosId: "id1457119021",
			native: "rainbow://wc",
			universal: "https://rnbwapp.com/wc"
		},
		name: "Rainbow",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	dapper: {
		brand: {
			alt: "Dapper Wallet",
			primaryColor: "#762FBE",
			spriteId: "dapper"
		},
		mobile: {
			android: "fake-to-get-dapper-to-appear",
			ios: "fake-to-get-dapper-to-appear"
		},
		name: "Dapper"
	},
	glow: {
		brand: {
			alt: "Glow Wallet",
			spriteId: "glow"
		},
		desktop: {
			chromeId: "ojbcfhjmpigfobfclfflafhblgemeidi",
			edgeId: "niihfokdlimbddhfmngnplgfcgpmlido",
			firefoxId: "glow-solana-wallet"
		},
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
					{
						flag: "isGlow",
						value: true
					}
				],
				windowLocations: [
					"glowSolana"
				]
			}
		],
		name: "Glow"
	},
	lilico: {
		brand: {
			alt: "Lilico Wallet",
			spriteId: "lilico"
		},
		desktop: {
			chromeId: "hpclkefagolihohboafpheddmmgdffjm"
		},
		filterFromWalletConnect: true,
		name: "Lilico"
	},
	flowwalletflow: {
		brand: {
			alt: "Flow Wallet",
			spriteId: "flowwallet"
		},
		chainGroup: "flowwallet",
		desktop: {
			chromeId: "hpclkefagolihohboafpheddmmgdffjm"
		},
		filterFromWalletConnect: true,
		group: "flowwallet",
		name: "Flow Wallet"
	},
	magicemailotp: {
		brand: {
			alt: "Magic Email OTP",
			spriteId: "magiclink"
		},
		name: "Magic Email OTP"
	},
	magiclink: {
		brand: {
			alt: "Magic Link",
			spriteId: "magiclink"
		},
		name: "Magic Link"
	},
	magicsocial: {
		brand: {
			alt: "Magic Social",
			spriteId: "magiclink"
		},
		name: "Magic Social"
	},
	magiceden: {
		brand: {
			alt: "Magic Eden",
			spriteId: "magiceden"
		},
		chainGroup: "magiceden",
		chains: [
			"bip122:000000000019d6689c085ae165831e93",
			"bip122:000000000933ea01ad0ee984209779ba",
			"eip155:1",
			"eip155:137",
			"eip155:80084",
			"eip155:80085",
			"eip155:8453",
			"solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp"
		],
		desktop: {
			chromeId: "mkpegjkblkkefacfnmkajcjmabijhclg"
		},
		eip6963Config: {
			rdns: "io.magiceden.wallet"
		},
		filterFromWalletConnect: true,
		group: "magiceden",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isMagicEden",
						value: true
					}
				],
				windowLocations: [
					"magicEden.ethereum"
				]
			}
		],
		mobile: {
			androidId: "com.magiceden.wallet",
			inAppBrowser: "magiceden://browser",
			iosId: "id6478631482",
			native: "magiceden://wc",
			universal: "https://magiceden.io/browser"
		},
		name: "Magic Eden"
	},
	magicedenbtc: {
		brand: {
			alt: "Magic Eden",
			spriteId: "magiceden"
		},
		chainGroup: "magiceden",
		desktop: {
			chromeId: "mkpegjkblkkefacfnmkajcjmabijhclg"
		},
		group: "magiceden",
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				walletStandard: {
					features: [
						"sats-connect:"
					],
					name: "Magic Eden"
				},
				windowLocations: [
					"magicEden.bitcoin"
				]
			}
		],
		mobile: {
			androidId: "com.magiceden.wallet",
			inAppBrowser: "magiceden://browser/{{encodedDappURI}}",
			iosId: "id6478631482",
			universal: "https://magiceden.io/browser/{{encodedDappURI}}"
		},
		name: "Magic Eden",
		shortName: "Magic Eden (Bitcoin)",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	magicedensol: {
		brand: {
			alt: "Magic Eden",
			spriteId: "magiceden"
		},
		chainGroup: "magiceden",
		desktop: {
			chromeId: "mkpegjkblkkefacfnmkajcjmabijhclg"
		},
		group: "magiceden",
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
					{
						flag: "isMagicEden",
						value: true
					}
				],
				windowLocations: [
					"magicEden.solana"
				]
			}
		],
		mobile: {
			androidId: "com.magiceden.wallet",
			inAppBrowser: "magiceden://browser/{{encodedDappURI}}",
			iosId: "id6478631482",
			universal: "https://magiceden.io/browser/{{encodedDappURI}}"
		},
		name: "Magic Eden",
		shortName: "Magic Eden (Solana)",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	exodus: {
		brand: {
			alt: "Exodus Wallet",
			spriteId: "4c16cad4-cac9-4643-6726-c696efaf5200"
		},
		chainGroup: "exodus",
		chains: [
			"bip122:000000000019d6689c085ae165831e93",
			"bip122:000000000933ea01ad0ee984209779ba",
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56",
			"eip155:80084",
			"eip155:80085",
			"solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp"
		],
		desktop: {
			chromeId: "aholpfdialjgjfhomihkjbmgjidlcdno"
		},
		filterFromWalletConnect: true,
		group: "exodus",
		mobile: {
			androidId: "exodusmovement.exodus",
			iosId: "id1414384820",
			native: "exodus://wc",
			universal: "https://exodus.com/m/wc"
		},
		name: "Exodus",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2",
				"auth_v1"
			]
		}
	},
	exodusevm: {
		brand: {
			alt: "Exodus Wallet",
			spriteId: "exodus"
		},
		chainGroup: "exodus",
		chains: [
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56"
		],
		desktop: {
			chromeId: "aholpfdialjgjfhomihkjbmgjidlcdno"
		},
		eip6963Config: {
			rdns: "com.exodus.web3-wallet"
		},
		filterFromWalletConnect: true,
		group: "exodus",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isExodus",
						value: true
					}
				]
			}
		],
		mobile: {
			androidId: "exodusmovement.exodus",
			iosId: "id1414384820",
			native: "exodus://wc"
		},
		name: "Exodus",
		shortName: "Exodus Wallet (EVM)",
		walletConnect: {
			sdks: [
				"sign_v2",
				"auth_v1"
			]
		}
	},
	exodussol: {
		brand: {
			alt: "Exodus Wallet",
			spriteId: "exodus"
		},
		chainGroup: "exodus",
		desktop: {
			chromeId: "aholpfdialjgjfhomihkjbmgjidlcdno"
		},
		group: "exodus",
		injectedConfig: [
			{
				chain: "sol",
				extensionLocators: [
					{
						flag: "isPhantom",
						value: true
					},
					{
						flag: "isExodus",
						value: true
					}
				],
				windowLocations: [
					"exodus.solana"
				]
			}
		],
		mobile: {
			androidId: "exodusmovement.exodus",
			iosId: "id1414384820"
		},
		name: "Exodus",
		shortName: "Exodus Wallet (Solana)"
	},
	okxwallet: {
		brand: {
			alt: "OKX Wallet",
			spriteId: "okx"
		},
		chainGroup: "okxwallet",
		chains: [
			"bip122:000000000019d6689c085ae165831e93",
			"bip122:000000000933ea01ad0ee984209779ba",
			"eip155:1",
			"eip155:137",
			"eip155:43114",
			"eip155:56",
			"eip155:66",
			"eip155:80084",
			"eip155:80085",
			"solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp"
		],
		desktop: {
			chromeId: "mcohilncbfahbmgdjkbpemcciiolgcge"
		},
		eip6963Config: {
			rdns: "com.okex.wallet"
		},
		filterFromWalletConnect: true,
		group: "okxwallet",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isOKExWallet",
						value: true
					},
					{
						flag: "isOkxWallet",
						value: true
					}
				],
				windowLocations: [
					"okxwallet"
				]
			}
		],
		mobile: {
			androidId: "com.okinc.okex.gp",
			iosId: "id1327268470",
			native: "okex://main/wc"
		},
		name: "OKX Wallet",
		shortName: "OKX Wallet",
		walletConnect: {
			sdks: [
				"sign_v2"
			]
		}
	},
	backpack: {
		brand: {
			alt: "Backpack",
			primaryColor: "#e43c3c",
			spriteId: "backpack"
		},
		chainGroup: "backpack",
		chains: [
			"eip155:1",
			"eip155:80084",
			"eip155:80085",
			"solana:5eykt4UsFv8P8NJdTREpY1vzqKqZKvdp"
		],
		desktop: {
			chromeId: "aflkmfhebedbjioipglgcbcmnbpgliof"
		},
		eip6963Config: {
			rdns: "app.backpack"
		},
		filterFromWalletConnect: true,
		group: "backpack",
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
					{
						flag: "isBackpack",
						value: true
					}
				],
				windowLocations: [
				]
			}
		],
		mobile: {
			androidId: "app.backpack.mobile",
			iosId: "id6445964121",
			native: "backpack://wc"
		},
		name: "Backpack",
		walletConnect: {
			sdks: [
				"sign_v1",
				"sign_v2"
			]
		}
	},
	okxwalletbtc: {
		brand: {
			alt: "OKX Wallet",
			spriteId: "okx"
		},
		chainGroup: "okxwallet",
		desktop: {
			chromeId: "mcohilncbfahbmgdjkbpemcciiolgcge"
		},
		group: "okxwallet",
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				windowLocations: [
					"okxwallet.bitcoin"
				]
			}
		],
		mobile: {
			androidId: "com.okinc.okex.gp",
			inAppBrowser: "okx://wallet/dapp/url?dappUrl={{encodedDappURI}}",
			iosId: "id1327268470"
		},
		name: "OKX Wallet",
		shortName: "OKX Wallet (Bitcoin)",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	unisat: {
		brand: {
			alt: "UniSat",
			spriteId: "unisat"
		},
		desktop: {
			chromeId: "ppbibelpcjmhbdihakflkdcoccbgbkpo"
		},
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				windowLocations: [
					"unisat"
				]
			}
		],
		name: "UniSat"
	},
	unknown: {
		brand: {
			spriteId: "unknown-wallet"
		},
		mobile: {
			androidId: "enable-android",
			iosId: "id1234567890"
		},
		name: "Unknown Wallet",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	xverse: {
		brand: {
			alt: "Xverse Wallet",
			spriteId: "xverse"
		},
		desktop: {
			chromeId: "idnnbdplmphpflfnlkomgpfbpcgelopg"
		},
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				walletStandard: {
					features: [
						"sats-connect:"
					],
					name: "Xverse",
					providerId: "XverseProviders.BitcoinProvider"
				},
				windowLocations: [
					"XverseProviders.BitcoinProvider"
				]
			}
		],
		mobile: {
			androidId: "com.secretkeylabs.xverse",
			inAppBrowser: "xverse://browser?url={{encodedDappURI}}",
			iosId: "id1552272513"
		},
		name: "Xverse",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	fallbackconnector: {
		brand: {
			spriteId: "unknown-wallet"
		},
		mobile: {
			androidId: "enable-android",
			iosId: "id1234567890"
		},
		name: "Fallback Connector",
		walletLimitations: {
			browserExtension: {
				unsupportedMethods: [
					"getConnectedAccounts"
				]
			}
		}
	},
	oylwallet: {
		brand: {
			alt: "Oyl Wallet",
			spriteId: "oyl"
		},
		desktop: {
			chromeId: "ilolmnhjbbggkmopnemiphomhaojndmb"
		},
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				windowLocations: [
					"oyl"
				]
			}
		],
		name: "Oyl Wallet"
	},
	abstract: {
		brand: {
			alt: "Abstract",
			spriteId: "abstract"
		},
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
				]
			}
		],
		name: "Abstract"
	},
	edenonline: {
		brand: {
			alt: "Eden Online",
			spriteId: "edenonline"
		},
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
				]
			}
		],
		name: "Eden Online"
	},
	onekeybtc: {
		brand: {
			alt: "OneKey Wallet",
			spriteId: "onekey"
		},
		chainGroup: "onekey",
		desktop: {
			chromeId: "jnmbobjmhlngoefaiojfljckilhhlhcj"
		},
		group: "onekey",
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				windowLocations: [
					"$onekey.btc"
				]
			}
		],
		mobile: {
			androidId: "so.onekey.app.wallet",
			iosId: "id1609559473"
		},
		name: "OneKey"
	},
	intersend: {
		brand: {
			alt: "Intersend",
			spriteId: "intersend"
		},
		injectedConfig: [
			{
				chain: "evm",
				extensionLocators: [
				]
			}
		],
		name: "Intersend"
	},
	okxeclipse: {
		brand: {
			alt: "OKX Wallet",
			primaryColor: "#FABB38",
			spriteId: "okx"
		},
		chainGroup: "okxwallet",
		desktop: {
			chromeId: "mcohilncbfahbmgdjkbpemcciiolgcge"
		},
		group: "okxwallet",
		injectedConfig: [
			{
				chain: "eclipse",
				extensionLocators: [
					{
						flag: "isOKExWallet",
						value: true
					},
					{
						flag: "isOkxWallet",
						value: true
					}
				],
				windowLocations: [
					"okxwallet.solana"
				]
			}
		],
		mobile: {
			androidId: "com.okinc.okex.gp",
			inAppBrowser: "okx://wallet/dapp/url?dappUrl={{encodedDappURI}}",
			iosId: "id1327268470"
		},
		name: "OKX Wallet"
	},
	dynamicwaas: {
		brand: {
			alt: "Dynamic Waas",
			primaryColor: "#4779ff",
			spriteId: "dynamicwaas"
		},
		name: "Dynamic Waas"
	},
	nightlyeclipse: {
		brand: {
			alt: "Nightly Wallet",
			spriteId: "nightly"
		},
		chainGroup: "nightly",
		desktop: {
			chromeId: "fiikommddbeccaoicoejoniammnalkfa",
			edgeId: "fiikommddbeccaoicoejoniammnalkfa",
			operaId: "fiikommddbeccaoicoejoniammnalkfa"
		},
		group: "nightly",
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "eclipse",
				extensionLocators: [
				],
				walletStandard: {
					features: [
						"standard:connect",
						"standard:disconnect",
						"solana:signMessage",
						"solana:signTransaction",
						"solana:signAndSendTransaction"
					],
					name: "Nightly"
				}
			}
		],
		name: "Nightly"
	},
	bitgetwalletbtc: {
		brand: {
			alt: "Bitget Wallet",
			spriteId: "bitgetwallet"
		},
		chainGroup: "bitgetwallet",
		group: "bitgetwallet",
		injectedConfig: [
			{
				chain: "btc",
				extensionLocators: [
				],
				windowLocations: [
					"bitkeep.unisat"
				]
			}
		],
		name: "Bitget Wallet"
	},
	backpackeclipse: {
		brand: {
			alt: "Backpack",
			primaryColor: "#e43c3c",
			spriteId: "backpack"
		},
		chainGroup: "backpack",
		desktop: {
			chromeId: "aflkmfhebedbjioipglgcbcmnbpgliof"
		},
		group: "backpack",
		hardwareWallets: [
			"ledger"
		],
		injectedConfig: [
			{
				chain: "eclipse",
				extensionLocators: [
					{
						flag: "isBackpack",
						value: true
					}
				],
				windowLocations: [
					"backpack"
				]
			}
		],
		name: "Backpack"
	}
};
var walletBookFallbacks = {
	groups: groups,
	wallets: wallets
};

var util$1;
(function (util) {
    util.assertEqual = (val) => val;
    function assertIs(_arg) { }
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
            obj[item] = item;
        }
        return obj;
    };
    util.getValidEnumValues = (obj) => {
        const validKeys = util.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys) {
            filtered[k] = obj[k];
        }
        return util.objectValues(filtered);
    };
    util.objectValues = (obj) => {
        return util.objectKeys(obj).map(function (e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
        ? (obj) => Object.keys(obj) // eslint-disable-line ban/ban
        : (object) => {
            const keys = [];
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    keys.push(key);
                }
            }
            return keys;
        };
    util.find = (arr, checker) => {
        for (const item of arr) {
            if (checker(item))
                return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function"
        ? (val) => Number.isInteger(val) // eslint-disable-line ban/ban
        : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array
            .map((val) => (typeof val === "string" ? `'${val}'` : val))
            .join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
            return value.toString();
        }
        return value;
    };
})(util$1 || (util$1 = {}));
var objectUtil;
(function (objectUtil) {
    objectUtil.mergeShapes = (first, second) => {
        return {
            ...first,
            ...second, // second overwrites first
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util$1.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set",
]);
const getParsedType = (data) => {
    const t = typeof data;
    switch (t) {
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) {
                return ZodParsedType.array;
            }
            if (data === null) {
                return ZodParsedType.null;
            }
            if (data.then &&
                typeof data.then === "function" &&
                data.catch &&
                typeof data.catch === "function") {
                return ZodParsedType.promise;
            }
            if (typeof Map !== "undefined" && data instanceof Map) {
                return ZodParsedType.map;
            }
            if (typeof Set !== "undefined" && data instanceof Set) {
                return ZodParsedType.set;
            }
            if (typeof Date !== "undefined" && data instanceof Date) {
                return ZodParsedType.date;
            }
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

const ZodIssueCode = util$1.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite",
]);
const quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub) => {
            this.issues = [...this.issues, sub];
        };
        this.addIssues = (subs = []) => {
            this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            // eslint-disable-next-line ban/ban
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper ||
            function (issue) {
                return issue.message;
            };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
            for (const issue of error.issues) {
                if (issue.code === "invalid_union") {
                    issue.unionErrors.map(processError);
                }
                else if (issue.code === "invalid_return_type") {
                    processError(issue.returnTypeError);
                }
                else if (issue.code === "invalid_arguments") {
                    processError(issue.argumentsError);
                }
                else if (issue.path.length === 0) {
                    fieldErrors._errors.push(mapper(issue));
                }
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while (i < issue.path.length) {
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) {
                            curr[el] = curr[el] || { _errors: [] };
                            // if (typeof el === "string") {
                            //   curr[el] = curr[el] || { _errors: [] };
                            // } else if (typeof el === "number") {
                            //   const errorArray: any = [];
                            //   errorArray._errors = [];
                            //   curr[el] = curr[el] || errorArray;
                            // }
                        }
                        else {
                            curr[el] = curr[el] || { _errors: [] };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util$1.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues) {
            if (sub.path.length > 0) {
                fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                fieldErrors[sub.path[0]].push(mapper(sub));
            }
            else {
                formErrors.push(mapper(sub));
            }
        }
        return { formErrors, fieldErrors };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
};

const errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) {
                message = "Required";
            }
            else {
                message = `Expected ${issue.expected}, received ${issue.received}`;
            }
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util$1.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util$1.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util$1.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util$1.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") {
                        message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                    }
                }
                else if ("startsWith" in issue.validation) {
                    message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                }
                else if ("endsWith" in issue.validation) {
                    message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                }
                else {
                    util$1.assertNever(issue.validation);
                }
            }
            else if (issue.validation !== "regex") {
                message = `Invalid ${issue.validation}`;
            }
            else {
                message = "Invalid";
            }
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${issue.minimum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${new Date(Number(issue.minimum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint")
                message = `BigInt must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `smaller than or equal to`
                        : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util$1.assertNever(issue);
    }
    return { message };
};

let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

const makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...(issueData.path || [])];
    const fullIssue = {
        ...issueData,
        path: fullPath,
    };
    let errorMessage = "";
    const maps = errorMaps
        .filter((m) => !!m)
        .slice()
        .reverse();
    for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage,
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap, // then global default map
        ].filter((x) => !!x),
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor() {
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid")
            this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted")
            this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results) {
            if (s.status === "aborted")
                return INVALID;
            if (s.status === "dirty")
                status.dirty();
            arrayValue.push(s.value);
        }
        return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
            syncPairs.push({
                key: await pair.key,
                value: await pair.value,
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
            const { key, value } = pair;
            if (key.status === "aborted")
                return INVALID;
            if (value.status === "aborted")
                return INVALID;
            if (key.status === "dirty")
                status.dirty();
            if (value.status === "dirty")
                status.dirty();
            if (key.value !== "__proto__" &&
                (typeof value.value !== "undefined" || pair.alwaysSet)) {
                finalObject[key.value] = value.value;
            }
        }
        return { status: status.value, value: finalObject };
    }
}
const INVALID = Object.freeze({
    status: "aborted",
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;

var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));

class ParseInputLazyPath {
    constructor(parent, value, path, key) {
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) {
                this._cachedPath.push(...this._path, ...this._key);
            }
            else {
                this._cachedPath.push(...this._path, this._key);
            }
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result) => {
    if (isValid(result)) {
        return { success: true, data: result.value };
    }
    else {
        if (!ctx.common.issues.length) {
            throw new Error("Validation failed but no issues detected.");
        }
        return {
            success: false,
            get error() {
                if (this._error)
                    return this._error;
                const error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            },
        };
    }
};
function processCreateParams(params) {
    if (!params)
        return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap)
        return { errorMap: errorMap, description };
    const customMap = (iss, ctx) => {
        if (iss.code !== "invalid_type")
            return { message: ctx.defaultError };
        if (typeof ctx.data === "undefined") {
            return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
        }
        return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
    };
    return { errorMap: customMap, description };
}
class ZodType {
    constructor(def) {
        /** Alias of safeParseAsync */
        this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return (ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent,
        });
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent,
            },
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) {
            throw new Error("Synchronous parse encountered promise.");
        }
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
        const result = await (isAsync(maybeAsyncResult)
            ? maybeAsyncResult
            : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val) => {
            if (typeof message === "string" || typeof message === "undefined") {
                return { message };
            }
            else if (typeof message === "function") {
                return message(val);
            }
            else {
                return message;
            }
        };
        return this._refinement((val, ctx) => {
            const result = check(val);
            const setError = () => ctx.addIssue({
                code: ZodIssueCode.custom,
                ...getIssueProperties(val),
            });
            if (typeof Promise !== "undefined" && result instanceof Promise) {
                return result.then((data) => {
                    if (!data) {
                        setError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!result) {
                setError();
                return false;
            }
            else {
                return true;
            }
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx) => {
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function"
                    ? refinementData(val, ctx)
                    : refinementData);
                return false;
            }
            else {
                return true;
            }
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "refinement", refinement },
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this, this._def);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([this, option], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "transform", transform },
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault,
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def),
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : () => def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch,
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description,
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[a-z][a-z0-9]*$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
const ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const datetimeRegex = (args) => {
    if (args.precision) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
        }
    }
    else if (args.precision === 0) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
        }
    }
    else {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
        }
    }
};
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
        return true;
    }
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
        return true;
    }
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = String(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType,
            }
            //
            );
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    else if (tooSmall) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    status.dirty();
                }
            }
            else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "emoji") {
                if (!emojiRegex) {
                    emojiRegex = new RegExp(_emojiRegex, "u");
                }
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "emoji",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid2",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ulid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "url") {
                try {
                    new URL(input.data);
                }
                catch (_a) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "url",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "trim") {
                input.data = input.data.trim();
            }
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { includes: check.value, position: check.position },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "toLowerCase") {
                input.data = input.data.toLowerCase();
            }
            else if (check.kind === "toUpperCase") {
                input.data = input.data.toUpperCase();
            }
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { startsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { endsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ip",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util$1.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _regex(regex, validation, message) {
        return this.refinement((data) => regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message),
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    email(message) {
        return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
        return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    emoji(message) {
        return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    cuid2(message) {
        return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
    }
    ulid(message) {
        return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
    }
    ip(options) {
        return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") {
            return this._addCheck({
                kind: "datetime",
                precision: null,
                offset: false,
                message: options,
            });
        }
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message),
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message),
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message),
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil.errToObj(message),
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */
    nonempty(message) {
        return this.min(1, errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "trim" }],
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toLowerCase" }],
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toUpperCase" }],
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params) => {
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return (valInt % stepInt) / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = Number(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "int") {
                if (!util$1.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_finite,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util$1.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message),
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message),
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil.toString(message),
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil.toString(message),
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int" ||
            (ch.kind === "multipleOf" && util$1.isInteger(ch.value)));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "finite" ||
                ch.kind === "int" ||
                ch.kind === "multipleOf") {
                return true;
            }
            else if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
            else if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params) => {
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodBigInt extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = BigInt(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.bigint,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util$1.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params) => {
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = Boolean(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params) => {
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = new Date(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else {
                util$1.assertNever(check);
            }
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime()),
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params) => {
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params),
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.symbol,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodSymbol.create = (params) => {
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params),
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params) => {
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params),
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params) => {
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params),
    });
};
class ZodAny extends ZodType {
    constructor() {
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params) => {
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params),
    });
};
class ZodUnknown extends ZodType {
    constructor() {
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params) => {
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params),
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType,
        });
        return INVALID;
    }
}
ZodNever.create = (params) => {
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params),
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params) => {
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params),
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                addIssueToContext(ctx, {
                    code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                    minimum: (tooSmall ? def.exactLength.value : undefined),
                    maximum: (tooBig ? def.exactLength.value : undefined),
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message,
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message,
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message,
                });
                status.dirty();
            }
        }
        if (ctx.common.async) {
            return Promise.all([...ctx.data].map((item, i) => {
                return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
            })).then((result) => {
                return ParseStatus.mergeArray(status, result);
            });
        }
        const result = [...ctx.data].map((item, i) => {
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: { value: minLength, message: errorUtil.toString(message) },
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: { value: maxLength, message: errorUtil.toString(message) },
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: { value: len, message: errorUtil.toString(message) },
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params) => {
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params),
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: () => newShape,
        });
    }
    else if (schema instanceof ZodArray) {
        return new ZodArray({
            ...schema._def,
            type: deepPartialify(schema.element),
        });
    }
    else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    }
    else {
        return schema;
    }
}
class ZodObject extends ZodType {
    constructor() {
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */
        this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */
        this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null)
            return this._cached;
        const shape = this._def.shape();
        const keys = util$1.objectKeys(shape);
        return (this._cached = { shape, keys });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever &&
            this._def.unknownKeys === "strip")) {
            for (const key in ctx.data) {
                if (!shapeKeys.includes(key)) {
                    extraKeys.push(key);
                }
            }
        }
        const pairs = [];
        for (const key of shapeKeys) {
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: { status: "valid", value: key },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") {
                for (const key of extraKeys) {
                    pairs.push({
                        key: { status: "valid", value: key },
                        value: { status: "valid", value: ctx.data[key] },
                    });
                }
            }
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys,
                    });
                    status.dirty();
                }
            }
            else if (unknownKeys === "strip") ;
            else {
                throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
            }
        }
        else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys) {
                const value = ctx.data[key];
                pairs.push({
                    key: { status: "valid", value: key },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data,
                });
            }
        }
        if (ctx.common.async) {
            return Promise.resolve()
                .then(async () => {
                const syncPairs = [];
                for (const pair of pairs) {
                    const key = await pair.key;
                    syncPairs.push({
                        key,
                        value: await pair.value,
                        alwaysSet: pair.alwaysSet,
                    });
                }
                return syncPairs;
            })
                .then((syncPairs) => {
                return ParseStatus.mergeObjectSync(status, syncPairs);
            });
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...(message !== undefined
                ? {
                    errorMap: (issue, ctx) => {
                        var _a, _b, _c, _d;
                        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys")
                            return {
                                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError,
                            };
                        return {
                            message: defaultError,
                        };
                    },
                }
                : {}),
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip",
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough",
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: () => ({
                ...this._def.shape(),
                ...augmentation,
            }),
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: () => ({
                ...this._def.shape(),
                ...merging._def.shape(),
            }),
            typeName: ZodFirstPartyTypeKind.ZodObject,
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index,
        });
    }
    pick(mask) {
        const shape = {};
        util$1.objectKeys(mask).forEach((key) => {
            if (mask[key] && this.shape[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    omit(mask) {
        const shape = {};
        util$1.objectKeys(this.shape).forEach((key) => {
            if (!mask[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    /**
     * @deprecated
     */
    deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util$1.objectKeys(this.shape).forEach((key) => {
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) {
                newShape[key] = fieldSchema;
            }
            else {
                newShape[key] = fieldSchema.optional();
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    required(mask) {
        const newShape = {};
        util$1.objectKeys(this.shape).forEach((key) => {
            if (mask && !mask[key]) {
                newShape[key] = this.shape[key];
            }
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while (newField instanceof ZodOptional) {
                    newField = newField._def.innerType;
                }
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    keyof() {
        return createZodEnum(util$1.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results) {
                if (result.result.status === "valid") {
                    return result.result;
                }
            }
            for (const result of results) {
                if (result.result.status === "dirty") {
                    // add issues from dirty option
                    ctx.common.issues.push(...result.ctx.common.issues);
                    return result.result;
                }
            }
            // return invalid
            const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return Promise.all(options.map(async (option) => {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                return {
                    result: await option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx,
                    }),
                    ctx: childCtx,
                };
            })).then(handleResults);
        }
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options) {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx,
                });
                if (result.status === "valid") {
                    return result;
                }
                else if (result.status === "dirty" && !dirty) {
                    dirty = { result, ctx: childCtx };
                }
                if (childCtx.common.issues.length) {
                    issues.push(childCtx.common.issues);
                }
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues) => new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params) => {
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params),
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
        return getDiscriminator(type.schema);
    }
    else if (type instanceof ZodEffects) {
        return getDiscriminator(type.innerType());
    }
    else if (type instanceof ZodLiteral) {
        return [type.value];
    }
    else if (type instanceof ZodEnum) {
        return type.options;
    }
    else if (type instanceof ZodNativeEnum) {
        // eslint-disable-next-line ban/ban
        return Object.keys(type.enum);
    }
    else if (type instanceof ZodDefault) {
        return getDiscriminator(type._def.innerType);
    }
    else if (type instanceof ZodUndefined) {
        return [undefined];
    }
    else if (type instanceof ZodNull) {
        return [null];
    }
    else {
        return null;
    }
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [discriminator],
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
        else {
            return option._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options) {
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) {
                throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            }
            for (const value of discriminatorValues) {
                if (optionsMap.has(value)) {
                    throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                }
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params),
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
        return { valid: true, data: a };
    }
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util$1.objectKeys(b);
        const sharedKeys = util$1
            .objectKeys(a)
            .filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
    }
    else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) {
            return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
    }
    else if (aType === ZodParsedType.date &&
        bType === ZodParsedType.date &&
        +a === +b) {
        return { valid: true, data: a };
    }
    else {
        return { valid: false };
    }
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
            if (isAborted(parsedLeft) || isAborted(parsedRight)) {
                return INVALID;
            }
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types,
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) {
                status.dirty();
            }
            return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
            return Promise.all([
                this._def.left._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
                this._def.right._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
            ]).then(([left, right]) => handleParsed(left, right));
        }
        else {
            return handleParsed(this._def.left._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }), this._def.right._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }));
        }
    }
}
ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params),
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            status.dirty();
        }
        const items = [...ctx.data]
            .map((item, itemIndex) => {
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema)
                return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        })
            .filter((x) => !!x); // filter nulls
        if (ctx.common.async) {
            return Promise.all(items).then((results) => {
                return ParseStatus.mergeArray(status, results);
            });
        }
        else {
            return ParseStatus.mergeArray(status, items);
        }
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest,
        });
    }
}
ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params),
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
            pairs.push({
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            });
        }
        if (ctx.common.async) {
            return ParseStatus.mergeObjectAsync(status, pairs);
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) {
            return new ZodRecord({
                keyType: first,
                valueType: second,
                typeName: ZodFirstPartyTypeKind.ZodRecord,
                ...processCreateParams(third),
            });
        }
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second),
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"])),
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async () => {
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") {
                        return INVALID;
                    }
                    if (key.status === "dirty" || value.status === "dirty") {
                        status.dirty();
                    }
                    finalMap.set(key.value, value.value);
                }
                return { status: status.value, value: finalMap };
            });
        }
        else {
            const finalMap = new Map();
            for (const pair of pairs) {
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") {
                    return INVALID;
                }
                if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                }
                finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
        }
    }
}
ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params),
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message,
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message,
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements) {
                if (element.status === "aborted")
                    return INVALID;
                if (element.status === "dirty")
                    status.dirty();
                parsedSet.add(element.value);
            }
            return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) {
            return Promise.all(elements).then((elements) => finalizeSet(elements));
        }
        else {
            return finalizeSet(elements);
        }
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: { value: minSize, message: errorUtil.toString(message) },
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: { value: maxSize, message: errorUtil.toString(message) },
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params) => {
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params),
    });
};
class ZodFunction extends ZodType {
    constructor() {
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error,
                },
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error,
                },
            });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(async function (...args) {
                const error = new ZodError([]);
                const parsedArgs = await me._def.args
                    .parseAsync(args, params)
                    .catch((e) => {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type
                    .parseAsync(result, params)
                    .catch((e) => {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        }
        else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(function (...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) {
                    throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
                }
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) {
                    throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
                }
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create()),
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType,
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: (args
                ? args
                : ZodTuple.create([]).rest(ZodUnknown.create())),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params),
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
}
ZodLazy.create = (getter, params) => {
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params),
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params),
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params),
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util$1.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    extract(values) {
        return ZodEnum.create(values);
    }
    exclude(values) {
        return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
    }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util$1.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string &&
            ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util$1.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util$1.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = util$1.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params),
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise &&
            ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise
            ? ctx.data
            : Promise.resolve(ctx.data);
        return OK(promisified.then((data) => {
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap,
            });
        }));
    }
}
ZodPromise.create = (schema, params) => {
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params),
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects
            ? this._def.schema.sourceType()
            : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg) => {
                addIssueToContext(ctx, arg);
                if (arg.fatal) {
                    status.abort();
                }
                else {
                    status.dirty();
                }
            },
            get path() {
                return ctx.path;
            },
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) {
                return {
                    status: "dirty",
                    value: ctx.data,
                };
            }
            if (ctx.common.async) {
                return Promise.resolve(processed).then((processed) => {
                    return this._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx,
                    });
                });
            }
            else {
                return this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc
            // effect: RefinementEffect<any>
            ) => {
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) {
                    return Promise.resolve(result);
                }
                if (result instanceof Promise) {
                    throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                }
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inner.status === "aborted")
                    return INVALID;
                if (inner.status === "dirty")
                    status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return { status: status.value, value: inner.value };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((inner) => {
                    if (inner.status === "aborted")
                        return INVALID;
                    if (inner.status === "dirty")
                        status.dirty();
                    return executeRefinement(inner.value).then(() => {
                        return { status: status.value, value: inner.value };
                    });
                });
            }
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (!isValid(base))
                    return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) {
                    throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                }
                return { status: status.value, value: result };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((base) => {
                    if (!isValid(base))
                        return base;
                    return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
                });
            }
        }
        util$1.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params),
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params),
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) {
            return OK(undefined);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) {
            return OK(null);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params) => {
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params),
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) {
            data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params) => {
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function"
            ? params.default
            : () => params.default,
        ...processCreateParams(params),
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: [],
            },
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx,
            },
        });
        if (isAsync(result)) {
            return result.then((result) => {
                return {
                    status: "valid",
                    value: result.status === "valid"
                        ? result.value
                        : this._def.catchValue({
                            get error() {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data,
                        }),
                };
            });
        }
        else {
            return {
                status: "valid",
                value: result.status === "valid"
                    ? result.value
                    : this._def.catchValue({
                        get error() {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data,
                    }),
            };
        }
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params) => {
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
        ...processCreateParams(params),
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
}
ZodNaN.create = (params) => {
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params),
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async () => {
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inResult.status === "aborted")
                    return INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return DIRTY(inResult.value);
                }
                else {
                    return this._def.out._parseAsync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx,
                    });
                }
            };
            return handleAsync();
        }
        else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
            if (inResult.status === "aborted")
                return INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value,
                };
            }
            else {
                return this._def.out._parseSync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline,
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if (isValid(result)) {
            result.value = Object.freeze(result.value);
        }
        return result;
    }
}
ZodReadonly.create = (type, params) => {
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params),
    });
};
const custom = (check, params = {}, 
/**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */
fatal) => {
    if (check)
        return ZodAny.create().superRefine((data, ctx) => {
            var _a, _b;
            if (!check(data)) {
                const p = typeof params === "function"
                    ? params(data)
                    : typeof params === "string"
                        ? { message: params }
                        : params;
                const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                const p2 = typeof p === "string" ? { message: p } : p;
                ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
            }
        });
    return ZodAny.create();
};
const late = {
    object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (
// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`,
}) => custom((data) => data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce$1 = {
    string: ((arg) => ZodString.create({ ...arg, coerce: true })),
    number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
    boolean: ((arg) => ZodBoolean.create({
        ...arg,
        coerce: true,
    })),
    bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
    date: ((arg) => ZodDate.create({ ...arg, coerce: true })),
};
const NEVER = INVALID;

var z$6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () { return util$1; },
    get objectUtil () { return objectUtil; },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () { return ZodFirstPartyTypeKind; },
    coerce: coerce$1,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});

/**
 * A zod type to ensure a string is not empty
 */
const nonEmptyString = z$6.preprocess((val) => (val ? val : undefined), z$6.string().optional());

const transformChromeExtensionId = (url) => {
    if (url === null || url === void 0 ? void 0 : url.match(/^[a-z]{32}$/))
        return url;
    if (url === null || url === void 0 ? void 0 : url.includes('chrome.google.com/webstore/detail/')) {
        try {
            const urlObject = new URL(url);
            return urlObject.pathname.split('/').at(-1);
        }
        catch (_a) {
            // ignore
        }
    }
    return;
};

const transformEdgeExtensionId = (url) => {
    if (url === null || url === void 0 ? void 0 : url.match(/^[a-z]{32}$/))
        return url;
    if (url === null || url === void 0 ? void 0 : url.includes('microsoftedge.microsoft.com/addons/detail/')) {
        try {
            const urlObject = new URL(url);
            return urlObject.pathname.split('/').at(-1);
        }
        catch (_a) {
            // ignore
        }
    }
    return;
};

const transformFirefoxExtensionId = (url) => {
    if (!(url === null || url === void 0 ? void 0 : url.match(/^https?:\/\//)))
        return url;
    if (url === null || url === void 0 ? void 0 : url.includes('addons.mozilla.org')) {
        try {
            const urlObject = new URL(url);
            return urlObject.pathname.replace(/\/$/, '').split('/').at(-1);
        }
        catch (_a) {
            // ignore
        }
    }
    return;
};

const idRegex = /^id[0-9]{1,36}$/;
const transformIosId = (url) => {
    if (url === null || url === void 0 ? void 0 : url.match(idRegex))
        return url;
    if (url === null || url === void 0 ? void 0 : url.match(/^https:\/\/[a-zA-Z0-9-]+\.apple\.com/)) {
        try {
            const urlObject = new URL(url);
            const expectedId = urlObject.pathname
                .replace(/\/$/, '')
                .split('/')
                .at(-1);
            if (expectedId === null || expectedId === void 0 ? void 0 : expectedId.match(idRegex)) {
                return expectedId;
            }
        }
        catch (_a) {
            // ignore
        }
    }
    return;
};

const transformAndroidId = (url) => {
    if (!(url === null || url === void 0 ? void 0 : url.match(/^https?:\/\//)))
        return url;
    if (!url)
        return;
    try {
        const urlObject = new URL(url);
        const id = urlObject.searchParams.get('id');
        if (id) {
            return id;
        }
    }
    catch (_a) {
        // ignore
    }
    return;
};

/**
 * A zod type to ensure an array is not empty
 */
const nonEmptyStringArray = z$6.preprocess((val) => (Array.isArray(val) && val.length > 0 ? val : undefined), z$6.array(z$6.string()).optional());

/**
 * Returns undefined if an object values are all nullish
 * @param val object
 * @returns
 */
const filterEmptyObject = (val) => val && Object.values(val).some((x) => Boolean(x)) ? val : undefined;

const injectedConfigSchema = z$6.object({
    chain: z$6.string(),
    extensionLocators: z$6.array(z$6.object({
        flag: z$6.string(),
        value: z$6.boolean().optional().default(true),
    })),
    /**
     * Allows declaring which interface, if any, this wallet's implementation follows
     * ex. Leather with https://btckit.org/
     */
    providerInterface: z$6.string().optional(),
    /**
     * Allows declaring that this wallet is discoverable through the the Wallet Standard
     * See https://github.com/wallet-standard/wallet-standard
     * Also allows ignoring wallets that don't support the provided features
     */
    walletStandard: z$6
        .object({
        features: z$6.array(z$6.string()),
        name: z$6.string(),
        providerId: z$6.string().optional(),
    })
        .optional(),
    walletStandardLocators: z$6
        .array(z$6.object({ locator: z$6.string(), name: z$6.string() }))
        .optional(),
    windowLocations: z$6
        .array(z$6.string())
        .optional()
        .refine((val) => {
        if (!val)
            return true;
        if (!val.some((v) => ['ethereum', 'ethereum.providers'].includes(v)))
            return true;
        return false;
    }, {
        message: 'windowLocations cannot include ethereum or ethereum.providers as they are included by default',
        path: ['config'],
    }),
});
const brandSchema = z$6.object({
    alt: nonEmptyString,
    primaryColor: nonEmptyString,
    spriteId: nonEmptyString,
});
const walletSchema = z$6
    .preprocess((val) => val, z$6.object({
    brand: brandSchema.optional(),
    chainGroup: z$6.string().optional(),
    chains: z$6.array(z$6.string()).optional(),
    desktop: z$6
        .object({
        chromeId: nonEmptyString.transform(transformChromeExtensionId),
        edgeId: nonEmptyString.transform(transformEdgeExtensionId),
        firefoxId: nonEmptyString.transform(transformFirefoxExtensionId),
        native: nonEmptyString,
        operaId: nonEmptyString,
        safariId: nonEmptyString,
        universal: nonEmptyString,
    })
        .optional()
        .transform(filterEmptyObject),
    eip6963Config: z$6.object({ rdns: z$6.string() }).optional(),
    filterFromWalletConnect: z$6.boolean().optional(),
    group: z$6.string().optional(),
    /**
     * Indicates which hardware wallets are enabled for this wallet
     */
    hardwareWallets: z$6.array(z$6.string()).optional(),
    injectedConfig: z$6.array(injectedConfigSchema).optional(),
    mobile: z$6
        .object({
        android: stringType().nullish(),
        androidId: nonEmptyString.transform(transformAndroidId),
        inAppBrowser: stringType().nullish(),
        ios: stringType().nullish(),
        iosId: nonEmptyString.transform(transformIosId),
        native: nonEmptyString,
        universal: nonEmptyString,
    })
        .optional()
        .transform(filterEmptyObject),
    mobileExperience: z$6.enum(['in-app-browser', 'redirect']).optional(),
    name: z$6.string(),
    shortName: nonEmptyString,
    showOnlyIfInstalled: z$6.boolean().optional(),
    switchNetworkOnlyFromWallet: z$6.boolean().optional(),
    walletConnect: z$6
        .object({
        sdks: nonEmptyStringArray,
    })
        .optional()
        .transform(filterEmptyObject),
    walletGroup: z$6.string().optional(),
    /**
     * Indicates which connector methods/events are not supported, keyed by wallet type
     */
    walletLimitations: z$6
        .object({
        browserExtension: z$6
            .object({
            unsupportedEvents: z$6.array(z$6.string()).optional(),
            unsupportedMethods: z$6.array(z$6.string()).optional(),
        })
            .optional(),
        mobile: z$6
            .object({
            unsupportedEvents: z$6.array(z$6.string()).optional(),
            unsupportedMethods: z$6.array(z$6.string()).optional(),
        })
            .optional(),
    })
        .optional(),
}))
    .transform((val) => {
    var _a, _b, _c, _d, _e, _f;
    if (val.group) {
        val.chainGroup = val.group;
    }
    if (((_a = val.mobile) === null || _a === void 0 ? void 0 : _a.iosId) || ((_b = val.mobile) === null || _b === void 0 ? void 0 : _b.ios) === null) {
        (_c = val.mobile) === null || _c === void 0 ? true : delete _c.ios;
    }
    if (((_d = val.mobile) === null || _d === void 0 ? void 0 : _d.androidId) || ((_e = val.mobile) === null || _e === void 0 ? void 0 : _e.android) === null) {
        (_f = val.mobile) === null || _f === void 0 ? true : delete _f.android;
    }
    return val;
});

const WalletOverrideEntrySchema = z$6.object({
    brand: brandSchema.optional(),
    name: nonEmptyString,
});
const walletGroupSchema = z$6.object({
    brand: z$6
        .object({
        alt: nonEmptyString,
        primaryColor: nonEmptyString,
        spriteId: nonEmptyString,
    })
        .optional(),
    key: z$6.string(),
    name: z$6.string(),
    walletOverrides: z$6.record(WalletOverrideEntrySchema).optional(),
});

z$6.record(z$6.string(), walletSchema);
const walletBookSchema = z$6.preprocess((val) => val, z$6.object({
    groups: z$6.record(z$6.string(), walletGroupSchema),
    wallets: z$6.record(z$6.string(), walletSchema),
}));
z$6.record(z$6.string(), walletGroupSchema);

const walletBookCache = { current: {} };
const walletBookEmitter = new EventEmitter$1();
const fetchWalletBook = () => __awaiter$a(void 0, void 0, void 0, function* () {
    const url = getWalletBookCdnUrl();
    const fn = () => __awaiter$a(void 0, void 0, void 0, function* () {
        const res = yield fetch(url, { mode: 'cors' });
        if (!res.ok) {
            throw new Error(`Failed to fetch wallet book data from ${url} with status code ${res.status}`);
        }
        const json = yield res.json();
        try {
            const parsedData = walletBookSchema.parse(json);
            return parsedData;
        }
        catch (e) {
            logger$6.error('Error parsing wallet book data', e, json);
            throw e;
        }
    });
    walletBookCache.current = yield retryableFn(fn, {
        fallbackValue: walletBookSchema.parse(walletBookFallbacks),
        maxRetries: 3,
        retryStrategy: 'timeout-and-rejection',
        timeoutMs: 30000,
    });
    walletBookEmitter.emit('walletBookLoaded', walletBookCache.current);
});

// Initiate wallet book fetch immediately
fetchWalletBook();
const useWalletBookCdn = () => {
    const [walletBookState, setWalletBookState] = useState(walletBookCache.current);
    useEffect(() => {
        walletBookEmitter.on('walletBookLoaded', setWalletBookState);
        /**
         * Justification for this setWalletBookState call — imagine the following scenario:
         *
         * 1. fetchWalletBook() is called — the wallet book is not yet loaded
         * 2. useState(walletBookCache.current) is called, and therefore initializes walletBookState to {}
         * 3. Before this effect runs — wallet book is loaded, and the walletBookLoaded event is emitted
         * 4. This effect finally runs and only then subscribes to the walletBookLoaded event
         *
         * In this case, walletBookState would be initialized to {}, and would never be updated to the actual wallet book
         * Therefore, we need to call setWalletBookState(walletBookCache.current)
         * to ensure that walletBookState is initialized to the correct value in this edge case
         */
        setWalletBookState(walletBookCache.current);
        return () => {
            walletBookEmitter.off('walletBookLoaded', setWalletBookState);
        };
    }, []);
    return walletBookState;
};

const getWalletIconData = (walletBook, walletKey, isGroup) => {
    if (!walletKey) {
        return {
            walletIconAlt: '',
            walletIconUrl: '',
        };
    }
    try {
        const walletData = isGroup
            ? findWalletGroup(walletBook, walletKey)
            : getWalletBookWallet(walletBook, walletKey);
        const iconData = walletData === null || walletData === void 0 ? void 0 : walletData.brand;
        if (iconData) {
            return {
                walletIconAlt: iconData.alt,
                walletIconUrl: getBrandIconUrl(iconData),
            };
        }
    }
    catch (err) {
        logger$6.error(err);
    }
    return {
        walletIconAlt: '',
        walletIconUrl: '',
    };
};

const WalletBookWalletIcon = (_a) => {
    var { walletKey, isGroup, children } = _a, props = __rest$6(_a, ["walletKey", "isGroup", "children"]);
    const { walletBook } = useWalletBookContext();
    const [imgError, setImgError] = useState(false);
    const { walletIconUrl, walletIconAlt } = getWalletIconData(walletBook, walletKey, isGroup);
    const defaultWalletIconUrl = getDefaultWalletIconUrl();
    if (!walletIconUrl) {
        return createElement(Fragment, {}, children);
    }
    const onError = () => {
        setImgError(true);
    };
    return createElement('img', Object.assign(Object.assign({ 'data-testid': `wallet-icon-${walletKey}` }, props), { alt: walletIconAlt, onError: onError, src: imgError ? defaultWalletIconUrl : walletIconUrl }), children);
};
const WalletIcon = (_a) => {
    var { icon, walletKey, isGroup, children } = _a, props = __rest$6(_a, ["icon", "walletKey", "isGroup", "children"]);
    if (!icon) {
        return createElement(WalletBookWalletIcon, Object.assign({ children,
            isGroup,
            walletKey }, props));
    }
    return createElement('img', Object.assign(Object.assign({ 'data-testid': `wallet-icon-${walletKey}` }, props), { alt: walletKey, src: icon }), children);
};

const WalletBookContextProvider = ({ walletBook, children, }) => createElement(WalletBookContext.Provider, {
    value: { walletBook },
}, children);

const BrandIcon = (_a) => {
    var { brand, walletKey } = _a, props = __rest$6(_a, ["brand", "walletKey"]);
    const [imgError, setImgError] = useState(false);
    const walletIconUrl = getBrandIconUrl(brand);
    const defaultWalletIconUrl = getDefaultWalletIconUrl();
    if (!walletIconUrl) {
        return createElement(Fragment, {});
    }
    const onError = () => {
        setImgError(true);
    };
    return createElement('img', Object.assign(Object.assign({ 'data-testid': `wallet-icon-${walletKey}` }, props), { alt: brand.alt, onError: onError, src: imgError ? defaultWalletIconUrl : walletIconUrl }));
};

assertPackageVersion('@dynamic-labs/wallet-book', version$a);

const getMobileExperience = ({ mobileExperienceProp, walletBook, walletKey, }) => {
    // if the legacy prop is set, use that
    if (mobileExperienceProp && typeof mobileExperienceProp === 'string')
        return mobileExperienceProp;
    // if the wallet has a deeplink preference set from the DynamicContext, use that
    if (mobileExperienceProp === null || mobileExperienceProp === void 0 ? void 0 : mobileExperienceProp[walletKey])
        return mobileExperienceProp[walletKey];
    // if the wallet has a deeplink preference set in the wallet book, use that
    const walletRecord = findWalletBookWallet(walletBook, walletKey);
    if (walletRecord === null || walletRecord === void 0 ? void 0 : walletRecord.mobileExperience)
        return walletRecord.mobileExperience;
    if (mobileExperienceProp === null || mobileExperienceProp === void 0 ? void 0 : mobileExperienceProp.default)
        return mobileExperienceProp.default;
    return 'in-app-browser';
};

const getIconUrl = (spriteId) => {
    if (!spriteId) {
        return renderTemplate('iconicUrl', 'defaultwallet');
    }
    return renderTemplate('iconicUrl', spriteId);
};

const getValidHexColor = (color) => {
    if (!color) {
        return;
    }
    // Check if string starts with # and is followed by either 3 or 6 valid hex characters
    const hexColorRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    return hexColorRegex.test(color) ? color : undefined;
};

const getMobileDeepLinks = (mobile) => {
    if (!mobile) {
        return;
    }
    return {
        native: mobile.native,
        universal: mobile.universal,
    };
};
const getDesktopDeepLinks = (desktop) => {
    if (!desktop) {
        return;
    }
    return {
        native: desktop.native,
        universal: desktop.universal,
    };
};
const getDeepLinks = ({ mobile, desktop, }) => {
    const mobileDeepLinks = getMobileDeepLinks(mobile);
    const desktopDeepLinks = getDesktopDeepLinks(desktop);
    if (!mobileDeepLinks && !desktopDeepLinks) {
        return;
    }
    return {
        desktop: desktopDeepLinks,
        mobile: mobileDeepLinks,
    };
};

const getMobileDownloadLinks = (mobile) => {
    if (!mobile) {
        return;
    }
    return {
        androidId: mobile.androidId,
        iosId: mobile.iosId,
    };
};
const getDesktopDownloadLinks = (desktop) => {
    if (!desktop) {
        return;
    }
    return {
        chromeId: desktop.chromeId,
        edgeId: desktop.edgeId,
        firefoxId: desktop.firefoxId,
        operaId: desktop.operaId,
        safariId: desktop.safariId,
    };
};
const getDownloadLinks = (wallet) => {
    const mobileLinks = getMobileDownloadLinks(wallet.mobile);
    const desktopLinks = getDesktopDownloadLinks(wallet.desktop);
    if (!mobileLinks && !desktopLinks) {
        return;
    }
    return Object.assign(Object.assign({}, mobileLinks), desktopLinks);
};

const getWalletLimitations = (walletLimitations) => {
    if (!(walletLimitations === null || walletLimitations === void 0 ? void 0 : walletLimitations.browserExtension)) {
        return;
    }
    const { unsupportedEvents, unsupportedMethods } = walletLimitations.browserExtension;
    return {
        desktop: {
            unsupportedEvents: unsupportedEvents,
            unsupportedMethods: unsupportedMethods,
        },
    };
};

const getWalletMetadataFromWalletBook = ({ walletKey, walletBookWallet, walletBook, walletFallback, }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!isWalletBookPopulated(walletBook) && !walletFallback) {
        logger$8.warn('Wallet book is required');
        return;
    }
    try {
        const wallet = walletBookWallet !== null && walletBookWallet !== void 0 ? walletBookWallet : getWalletBookWallet(walletBook, walletKey, walletFallback);
        // if no walletBookWallet is provided and no wallet is found in the wallet book, throw an error
        if (!wallet) {
            logger$8.warn('Wallet not found in wallet book');
            return;
        }
        return {
            brandColor: getValidHexColor((_a = wallet === null || wallet === void 0 ? void 0 : wallet.brand) === null || _a === void 0 ? void 0 : _a.primaryColor),
            deepLinks: getDeepLinks({
                desktop: wallet === null || wallet === void 0 ? void 0 : wallet.desktop,
                mobile: wallet === null || wallet === void 0 ? void 0 : wallet.mobile,
            }),
            downloadLinks: getDownloadLinks(wallet),
            groupKey: (_b = wallet === null || wallet === void 0 ? void 0 : wallet.chainGroup) !== null && _b !== void 0 ? _b : wallet === null || wallet === void 0 ? void 0 : wallet.walletGroup,
            icon: (_d = getIconUrl((_c = wallet === null || wallet === void 0 ? void 0 : wallet.brand) === null || _c === void 0 ? void 0 : _c.spriteId)) !== null && _d !== void 0 ? _d : '',
            id: walletKey,
            inAppBrowserUrl: (_f = (_e = wallet.mobile) === null || _e === void 0 ? void 0 : _e.inAppBrowser) !== null && _f !== void 0 ? _f : undefined,
            name: wallet.name,
            rdns: (_g = wallet.eip6963Config) === null || _g === void 0 ? void 0 : _g.rdns,
            supportedHardwareWallets: wallet.hardwareWallets,
            walletLimitations: getWalletLimitations(wallet.walletLimitations),
        };
    }
    catch (e) {
        logger$8.warn('Error getting wallet metadata from wallet book', {
            error: e,
        });
        return;
    }
};

const isConnectorMethodSupported = (connector, method, platform) => {
    var _a, _b, _c;
    return !((_c = (_b = (_a = connector.metadata.walletLimitations) === null || _a === void 0 ? void 0 : _a[platform]) === null || _b === void 0 ? void 0 : _b.unsupportedMethods) === null || _c === void 0 ? void 0 : _c.includes(method));
};

const isConnectorEventSupported = (connector, event, platform) => {
    var _a, _b, _c;
    return !((_c = (_b = (_a = connector.metadata.walletLimitations) === null || _a === void 0 ? void 0 : _a[platform]) === null || _b === void 0 ? void 0 : _b.unsupportedEvents) === null || _c === void 0 ? void 0 : _c.includes(event));
};

const getWalletLinks = (downloadLinks) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const links = {
        android: '',
        brave: '',
        chrome: '',
        edge: '',
        firefox: '',
        ios: '',
    };
    if (!downloadLinks) {
        return links;
    }
    links.brave = (_a = renderTemplate('chromeUrl', downloadLinks.chromeId)) !== null && _a !== void 0 ? _a : '';
    links.chrome = (_b = renderTemplate('chromeUrl', downloadLinks.chromeId)) !== null && _b !== void 0 ? _b : '';
    links.edge = (_c = renderTemplate('edgeUrl', downloadLinks.edgeId)) !== null && _c !== void 0 ? _c : '';
    links.firefox = (_d = renderTemplate('firefoxUrl', downloadLinks.firefoxId)) !== null && _d !== void 0 ? _d : '';
    links.ios =
        (_f = (_e = renderTemplate('iosUrl', downloadLinks.iosId)) !== null && _e !== void 0 ? _e : downloadLinks.iosUrl) !== null && _f !== void 0 ? _f : '';
    links.android =
        (_h = (_g = renderTemplate('androidUrl', downloadLinks.androidId)) !== null && _g !== void 0 ? _g : downloadLinks.androidUrl) !== null && _h !== void 0 ? _h : '';
    return links;
};

let Wallet$1 = class Wallet extends BaseWallet {
    constructor(_a) {
        var { connector } = _a, props = __rest$8(_a, ["connector"]);
        super(props);
        this._connector = connector;
    }
    /**
     * Gets the wallet connector.
     */
    get connector() {
        return this._connector;
    }
    /**
     * Retrieves the balance of the wallet.
     * @returns A promise that resolves to the balance of the wallet as a string,
     * or undefined if the balance cannot be retrieved.
     */
    getBalance() {
        return __awaiter$b(this, void 0, void 0, function* () {
            return this._connector.getBalance(this.address);
        });
    }
    /**
     * Retrieves the name service data associated with the wallet.
     * @returns A promise that resolves to the name service data of the wallet,
     * or undefined if the data cannot be retrieved.
     */
    getNameService() {
        return __awaiter$b(this, void 0, void 0, function* () {
            return this._connector.getNameService(this.address);
        });
    }
    /**
     * Retrieves the network that the wallet is connected to.
     * @returns A promise that resolves to the network value as a string or number,
     * or undefined if the network cannot be retrieved.
     */
    getNetwork() {
        return __awaiter$b(this, void 0, void 0, function* () {
            return this._connector.getNetwork();
        });
    }
    /**
     * If the wallet is connected.
     * @returns A promise that resolves to true the wallet is connected or false if it's not connected.
     */
    isConnected() {
        return __awaiter$b(this, void 0, void 0, function* () {
            try {
                const connectedAccounts = yield this._connector.getConnectedAccounts();
                return connectedAccounts
                    .map((address) => normalizeAddress(address, this.chain))
                    .includes(normalizeAddress(this.address, this.chain));
            }
            catch (error) {
                logger$8.error('[Wallet] isConnected - Error detecting if wallet is connected', error);
                return false;
            }
        });
    }
    /**
     * Proves ownership of the wallet by signing a message.
     * @param messageToSign - The message to sign.
     * @returns A promise that resolves to the signature of the message as a string,
     *  or undefined if the message cannot be signed.
     */
    proveOwnership(messageToSign) {
        return __awaiter$b(this, void 0, void 0, function* () {
            return this._connector.proveOwnership(this.address, messageToSign);
        });
    }
    /**
     * Signs a message using the wallet.
     * @param messageToSign - The message to sign.
     * @returns A promise that resolves to the signature of the message as a string,
     * or undefined if the message cannot be signed.
     */
    signMessage(messageToSign) {
        return __awaiter$b(this, void 0, void 0, function* () {
            yield this.sync();
            return this._connector.signMessage(messageToSign, {
                address: this.address,
            });
        });
    }
    /**
     * Switches the network that the wallet is connected to.
     * @param networkChainId - The chain id of the network to switch to.
     * @returns A promise that resolves when the network is switched.
     */
    switchNetwork(networkChainId) {
        return __awaiter$b(this, void 0, void 0, function* () {
            return this._connector.switchNetwork({
                networkChainId,
            });
        });
    }
    /**
     * Synchronizes the wallet with the connector.
     * @returns A promise that resolves when the wallet is connected and active.
     */
    sync() {
        return __awaiter$b(this, void 0, void 0, function* () {
            return this._connector.validateActiveWallet(this.address);
        });
    }
};

class WalletBookSingleton {
    constructor(walletBook) {
        this.walletBook = walletBook;
    }
    static getOrCreate(walletBook) {
        var _a;
        if (!((_a = WalletBookSingleton.instance) === null || _a === void 0 ? void 0 : _a.walletBook)) {
            WalletBookSingleton.instance = new WalletBookSingleton(walletBook);
        }
        return WalletBookSingleton.instance;
    }
    static reset() {
        WalletBookSingleton.instance = undefined;
    }
}

/* eslint-disable @typescript-eslint/triple-slash-reference */
/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/no-unused-vars */
var _WalletConnectorBase_registeredExtensions;
class WalletConnectorBase extends EventEmitter$1 {
    createWallet(props) {
        const wallet = new this.ChainWallet(props);
        return wallet;
    }
    /**
     * We store the constructor props so that we can use them later on
     * in getMobileOrInstalledWallet which may fall back to a different class
     * but will need the original constructor props.
     * @param props - constructor props
     */
    constructor(props) {
        super();
        this.chainRpcProviders = undefined;
        this.isGlobalTransaction = false;
        _WalletConnectorBase_registeredExtensions.set(this, []);
        this.didSetup = false;
        /**
         * This flag corresponds to whether this wallet connector also requires its own email otp outside dynamic
         * @default false
         */
        this.requiresNonDynamicEmailOtp = false;
        /**
         * IF the wallet needs to be connected via a custodial service
         * such as Blocto, this will be true.
         * @default false
         */
        this.canConnectViaCustodialService = false;
        /**
         * If the wallet is not installed, and can be connected via a QR code,
         * this will be true.
         * @default false
         */
        this.canConnectViaQrCode = false;
        /**
         * Whether this connector can be connected via social login.
         * @default false
         */
        this.canConnectViaSocial = false;
        /**
         * Flag if connector/provider is available
         *
         * @default true
         */
        this.isAvailable = true;
        /**
         * If the wallet generated by a valid embedded wallet provider
         * For example: magic wallets
         * @default false
         */
        this.isEmbeddedWallet = false;
        /**
         * Flag if it is wallet Connect
         *
         * @default false
         */
        this.isWalletConnect = false;
        /**
         * Override key for the wallet (used for injected wallet linking)
         */
        this.overrideKey = undefined;
        /**
         * Additional resources to add to the message to be signed
         *
         * @default undefined
         */
        this.providerResources = undefined;
        /**
         * Requires switching network in the wallet itself
         * @default undefined
         */
        this.switchNetworkOnlyFromWallet = undefined;
        /**
         * Whether the connector has been initialized
         * @default true
         */
        this.isInitialized = true;
        this.constructorProps = props;
        this._walletBookInstance = WalletBookSingleton.getOrCreate(props.walletBook);
        this._metadata = props.metadata;
        this.walletConnectorEventsEmitter =
            this.constructorProps.walletConnectorEventsEmitter ||
                walletConnectorEvents;
        if (this.walletBook === undefined) {
            throw new Error('WalletConnectorBase was not called with super(props) and is missing wallet-book');
        }
    }
    extend(extension, settings) {
        if (__classPrivateFieldGet$4(this, _WalletConnectorBase_registeredExtensions, "f").includes(extension.name)) {
            throw new Error(`You can only register a single extension of: ${extension.name}`);
        }
        if (extension.name === 'global-wallet-extension') {
            // only allow global wallet extension for evm embedded wallets
            if (!this.isEmbeddedWallet || !this.supportedChains.includes('EVM'))
                return;
        }
        __classPrivateFieldGet$4(this, _WalletConnectorBase_registeredExtensions, "f").push(extension.name);
        extension.extend(this, settings !== null && settings !== void 0 ? settings : {});
    }
    /**
     * Add the event listeners for the wallet and connect
     * with event emitter.
     */
    initEventListener() {
        if (this.didSetup)
            return;
        this.didSetup = true;
        this.setupEventListeners();
    }
    get walletBook() {
        return this._walletBookInstance.walletBook;
    }
    filter() {
        return true;
    }
    get mobileExperience() {
        return getMobileExperience({
            mobileExperienceProp: this.constructorProps.mobileExperience,
            walletBook: this.walletBook,
            walletKey: this.key,
        });
    }
    /**
     * Prompt the user to choose accounts to connect (see behavior in MM)
     * @default Promise<[]>
     */
    chooseAccountsToConnect() {
        return Promise.resolve([]);
    }
    connect() {
        return __awaiter$b(this, void 0, void 0, function* () {
            yield this.getAddress();
        });
    }
    /**
     * Generic function to close the wallet connection
     * Originally implemented for WalletConnect, but it is used
     * for anything that needs to be "logged out" or cleaned up
     *
     * @default Promise<undefined>
     */
    endSession() {
        return Promise.resolve();
    }
    /**
     * Gets the public address of the wallet
     *
     * @default Promise<undefined>
     */
    getAddress(opts) {
        return Promise.resolve(undefined);
    }
    /**
     * Parses a public address to ensure it follows a correct format.
     *
     * For instance, with EVM wallets, this might ensure it follows the EIP 55 format.
     *
     * @default string
     */
    parseAddress(address) {
        return address;
    }
    /**
     * Whether this wallet connector is targeting a testnet.
     * So far only supported for EVM connectors.
     *
     * @default Promise<false>
     */
    isTestnet() {
        return Promise.resolve(false);
    }
    /**
     * Gets the additional addresses of the wallet, given the main address
     *
     * @default Promise<[]>
     */
    getAdditionalAddresses(mainAddress) {
        return Promise.resolve([]);
    }
    /**
     * Sets the additional addresses of the wallet, given the main address
     *
     * @default Promise<void>
     */
    setAdditionalAddresses(mainAddress, additionalAddresses) {
        return Promise.resolve();
    }
    /**
     * Gets the balance of the wallet
     *
     * @default Promise<undefined>
     */
    getBalance(address) {
        return Promise.resolve(undefined);
    }
    /**
     * Get the address silently
     *
     * @default Promise<[]>
     */
    getConnectedAccounts() {
        return Promise.resolve([]);
    }
    /**
     * Gets the deep link of the wallet
     *
     * @default undefined
     */
    getDeepLink() {
        return undefined;
    }
    getNetwork() {
        return Promise.resolve(undefined);
    }
    /**
     * Gets current network of connected wallet
     *
     * @default Promise<undefined>
     */
    getNameService(address) {
        return Promise.resolve(undefined);
    }
    getPublicClient() {
        return Promise.resolve(undefined);
    }
    getSession() {
        return __awaiter$b(this, void 0, void 0, function* () {
            return Promise.resolve();
        });
    }
    getSigner() {
        return Promise.resolve(undefined);
    }
    getWalletClient(chainId) {
        return undefined;
    }
    /**
     * Initialize the wallet connector with any async operations
     *
     * @default Promise<void>
     */
    init() {
        return Promise.resolve();
    }
    /**
     * Check if the wallet is installed on the browser
     *
     * @default false
     */
    isInstalledOnBrowser() {
        return false;
    }
    /**
     * Override key or the normalized wallet name if needed
     */
    get key() {
        return this.overrideKey || this.name.replace(/\W/g, '').toLowerCase();
    }
    get metadata() {
        var _a;
        if (!this._metadata) {
            this._metadata = getWalletMetadataFromWalletBook({
                walletBook: this.walletBook,
                walletKey: this.key,
            });
        }
        return (_a = this._metadata) !== null && _a !== void 0 ? _a : { icon: '', id: this.key, name: this.name };
    }
    /**
     * Whether the wallet connector should fall back to a different wallet connector
     * This is called after the object is instantiated, so it can't be a static property
     * and will return the appropriate instance of the wallet connector
     * @returns WalletConnector
     * @default this
     */
    getMobileOrInstalledWallet() {
        return this;
    }
    /**
     * In most cases this is an alias for `signMessage`
     *
     * @default Promise<undefined>
     */
    proveOwnership(address, messageToSign) {
        return __awaiter$b(this, void 0, void 0, function* () {
            yield this.validateActiveWallet(address);
            return this.signMessage(messageToSign);
        });
    }
    /**
     * Set up event listeners for the wallet
     *
     * @default void
     */
    setupEventListeners() {
        return;
    }
    /**
     * Sign a message
     *
     * @default Promise<undefined>
     */
    signMessage(messageToSign, options) {
        return Promise.resolve(undefined);
    }
    /**
     * Returns the array of block explorer URLs available for the current network
     */
    getBlockExplorerUrlsForCurrentNetwork() {
        return __awaiter$b(this, void 0, void 0, function* () {
            return [];
        });
    }
    /**
     * Whether the wallet supports network switching
     *
     * @default false
     */
    supportsNetworkSwitching() {
        return false;
    }
    switchNetwork({ networkName, networkChainId, }) {
        return Promise.resolve(undefined);
    }
    /**
     * Tear down event listeners for the wallet
     * @default void
     */
    teardownEventListeners() {
        return;
    }
    /**
     * Receive the user verified credentials
     */
    setVerifiedCredentials(verifiedCredentials) {
        return;
    }
    /**
     * Whether the wallet allow for getting the address in the
     * current chain.
     * This is used for multi chain wallets.
     * @default true
     */
    canGetChainAddress() {
        return true;
    }
    /**
     * Prompts the user to make expected wallet active
     *
     * @throws {WalletAddressMismatchError} If the active address does not match the expected address.
     * @returns {Promise<void>} A promise that resolves when the active address matches the expected address,
     * otherwise rejects with an error.
     */
    handleWalletNotActive(_a) {
        return __awaiter$b(this, arguments, void 0, function* ({ activeAddress, expectedAddress, reconnectedAddress, }) {
            logger$8.debug('validateActiveWallet - wallet is not active', {
                activeAddress,
                expectedAddress,
                reconnectedAddress,
            });
            const currentActiveAddress = activeAddress || reconnectedAddress || '';
            const walletUiUtils = this.constructorProps
                .walletUiUtils;
            if (!walletUiUtils) {
                throw new WalletAddressMismatchError(`Wallet ${expectedAddress !== null && expectedAddress !== void 0 ? expectedAddress : ''} is not currently active in ${this.name || this.key}.`, {
                    activeAddress: currentActiveAddress,
                    expectedAddress,
                    walletName: this.name || this.key,
                });
            }
            return walletUiUtils.syncWallet({
                activeAddress: currentActiveAddress,
                expectedAddress,
                walletConnector: this,
            });
        });
    }
    /**
     * Validates if the address is connected and active in the wallet app
     *
     * @throws {WalletAddressMismatchError} If the active address does not match the expected address.
     * @returns {Promise<void>} A promise that resolves if the active address matches the expected address,
     * otherwise rejects with an error.
     */
    validateActiveWallet(expectedAddress) {
        return __awaiter$b(this, void 0, void 0, function* () {
            logger$8.debug('validateActiveWallet - validating wallet', expectedAddress);
            const canFetchConnectedAccounts = isConnectorMethodSupported(this, 'getConnectedAccounts', 'desktop');
            logger$8.debug('validateActiveWallet - getting connected accounts', {
                canFetchConnectedAccounts,
            });
            const [activeAddress] = canFetchConnectedAccounts
                ? yield this.getConnectedAccounts()
                : [];
            const isWalletActive = activeAddress &&
                isSameAddress(activeAddress, expectedAddress, this.connectedChain);
            if (isWalletActive) {
                logger$8.debug('validateActiveWallet - wallet is active');
                return;
            }
            logger$8.debug('validateActiveWallet - trying to reconnect wallet...');
            const getReconnectedAddress = () => __awaiter$b(this, void 0, void 0, function* () {
                if (this.isWalletConnect || !this.canGetChainAddress()) {
                    return undefined;
                }
                return this.getAddress().catch((err) => {
                    logger$8.debug('validateActiveWallet - error getting address', err);
                    return undefined;
                });
            });
            //  not possible to auto-reconnect walletconnect
            const reconnectedAddress = yield getReconnectedAddress();
            if (reconnectedAddress &&
                isSameAddress(reconnectedAddress, expectedAddress, this.connectedChain)) {
                logger$8.debug('validateActiveWallet - wallet reconnected successfuly');
                return;
            }
            return this.handleWalletNotActive({
                activeAddress,
                expectedAddress,
                reconnectedAddress,
            });
        });
    }
    /**
     * Get the enabled networks for the wallet
     * @returns {GenericNetwork[]} The enabled networks
     */
    getEnabledNetworks() {
        return [];
    }
}
_WalletConnectorBase_registeredExtensions = new WeakMap();

assertPackageVersion('@dynamic-labs/wallet-connector-core', version$b);

const logger$5 = new Logger$1('ethereum-core');

const abey = /*#__PURE__*/ defineChain({
    id: 179,
    name: 'ABEY Mainnet',
    nativeCurrency: { name: 'ABEY', symbol: 'ABEY', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.abeychain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Abey Scan',
            url: 'https://abeyscan.com',
        },
    },
    testnet: false,
});

const gasPerPubdataDefault = 50000n;
const maxBytecodeSize = maxUint16 * 32n;

const formatters$2 = {
    block: /*#__PURE__*/ defineBlock({
        format(args) {
            const transactions = args.transactions?.map((transaction) => {
                if (typeof transaction === 'string')
                    return transaction;
                const formatted = formatters$2.transaction?.format(transaction);
                if (formatted.typeHex === '0x71')
                    formatted.type = 'eip712';
                else if (formatted.typeHex === '0xff')
                    formatted.type = 'priority';
                return formatted;
            });
            return {
                l1BatchNumber: args.l1BatchNumber
                    ? hexToBigInt(args.l1BatchNumber)
                    : null,
                l1BatchTimestamp: args.l1BatchTimestamp
                    ? hexToBigInt(args.l1BatchTimestamp)
                    : null,
                transactions,
            };
        },
    }),
    transaction: /*#__PURE__*/ defineTransaction({
        format(args) {
            const transaction = {};
            if (args.type === '0x71')
                transaction.type = 'eip712';
            else if (args.type === '0xff')
                transaction.type = 'priority';
            return {
                ...transaction,
                l1BatchNumber: args.l1BatchNumber
                    ? hexToBigInt(args.l1BatchNumber)
                    : null,
                l1BatchTxIndex: args.l1BatchTxIndex
                    ? hexToBigInt(args.l1BatchTxIndex)
                    : null,
            };
        },
    }),
    transactionReceipt: /*#__PURE__*/ defineTransactionReceipt({
        format(args) {
            return {
                l1BatchNumber: args.l1BatchNumber
                    ? hexToBigInt(args.l1BatchNumber)
                    : null,
                l1BatchTxIndex: args.l1BatchTxIndex
                    ? hexToBigInt(args.l1BatchTxIndex)
                    : null,
                logs: args.logs.map((log) => {
                    return {
                        ...formatLog(log),
                        l1BatchNumber: log.l1BatchNumber
                            ? hexToBigInt(log.l1BatchNumber)
                            : null,
                        transactionLogIndex: hexToNumber$1(log.transactionLogIndex),
                        logType: log.logType,
                    };
                }),
                l2ToL1Logs: args.l2ToL1Logs.map((l2ToL1Log) => {
                    return {
                        blockNumber: hexToBigInt(l2ToL1Log.blockHash),
                        blockHash: l2ToL1Log.blockHash,
                        l1BatchNumber: l2ToL1Log.l1BatchNumber
                            ? hexToBigInt(l2ToL1Log.l1BatchNumber)
                            : null,
                        transactionIndex: hexToBigInt(l2ToL1Log.transactionIndex),
                        shardId: hexToBigInt(l2ToL1Log.shardId),
                        isService: l2ToL1Log.isService,
                        sender: l2ToL1Log.sender,
                        key: l2ToL1Log.key,
                        value: l2ToL1Log.value,
                        transactionHash: l2ToL1Log.transactionHash,
                        logIndex: hexToBigInt(l2ToL1Log.logIndex),
                    };
                }),
            };
        },
    }),
    transactionRequest: /*#__PURE__*/ defineTransactionRequest({
        exclude: [
            'customSignature',
            'factoryDeps',
            'gasPerPubdata',
            'paymaster',
            'paymasterInput',
        ],
        format(args) {
            if (args.gasPerPubdata ||
                (args.paymaster && args.paymasterInput) ||
                args.factoryDeps ||
                args.customSignature)
                return {
                    eip712Meta: {
                        ...(args.gasPerPubdata
                            ? { gasPerPubdata: toHex(args.gasPerPubdata) }
                            : { gasPerPubdata: toHex(gasPerPubdataDefault) }),
                        ...(args.paymaster && args.paymasterInput
                            ? {
                                paymasterParams: {
                                    paymaster: args.paymaster,
                                    paymasterInput: Array.from(hexToBytes$1(args.paymasterInput)),
                                },
                            }
                            : {}),
                        ...(args.factoryDeps
                            ? {
                                factoryDeps: args.factoryDeps.map((dep) => Array.from(hexToBytes$1(dep))),
                            }
                            : {}),
                        ...(args.customSignature
                            ? {
                                customSignature: Array.from(hexToBytes$1(args.customSignature)),
                            }
                            : {}),
                    },
                    type: '0x71',
                };
            return {};
        },
    }),
};

class InvalidEip712TransactionError extends BaseError$1 {
    constructor() {
        super([
            'Transaction is not an EIP712 transaction.',
            '',
            'Transaction must:',
            '  - include `type: "eip712"`',
            '  - include one of the following: `customSignature`, `paymaster`, `paymasterInput`, `gasPerPubdata`, `factoryDeps`',
        ].join('\n'), { name: 'InvalidEip712TransactionError' });
    }
}

function isEIP712Transaction(transaction) {
    if (transaction.type === 'eip712')
        return true;
    if (('customSignature' in transaction && transaction.customSignature) ||
        ('paymaster' in transaction && transaction.paymaster) ||
        ('paymasterInput' in transaction && transaction.paymasterInput) ||
        ('gasPerPubdata' in transaction &&
            typeof transaction.gasPerPubdata === 'bigint') ||
        ('factoryDeps' in transaction && transaction.factoryDeps))
        return true;
    return false;
}

function assertEip712Transaction(transaction) {
    const { chainId, to, from, paymaster, paymasterInput } = transaction;
    if (!isEIP712Transaction(transaction))
        throw new InvalidEip712TransactionError();
    if (!chainId || chainId <= 0)
        throw new InvalidChainIdError({ chainId });
    if (to && !isAddress(to))
        throw new InvalidAddressError({ address: to });
    if (from && !isAddress(from))
        throw new InvalidAddressError({ address: from });
    if (paymaster && !isAddress(paymaster))
        throw new InvalidAddressError({ address: paymaster });
    if (paymaster && !paymasterInput) {
        throw new BaseError$1('`paymasterInput` must be provided when `paymaster` is defined');
    }
    if (!paymaster && paymasterInput) {
        throw new BaseError$1('`paymaster` must be provided when `paymasterInput` is defined');
    }
}

function serializeTransaction$2(transaction, signature) {
    if (isEIP712Transaction(transaction))
        return serializeTransactionEIP712(transaction);
    return serializeTransaction$3(transaction, signature);
}
const serializers$2 = {
    transaction: serializeTransaction$2,
};
function serializeTransactionEIP712(transaction) {
    const { chainId, gas, nonce, to, from, value, maxFeePerGas, maxPriorityFeePerGas, customSignature, factoryDeps, paymaster, paymasterInput, gasPerPubdata, data, } = transaction;
    assertEip712Transaction(transaction);
    const serializedTransaction = [
        nonce ? toHex(nonce) : '0x',
        maxPriorityFeePerGas ? toHex(maxPriorityFeePerGas) : '0x',
        maxFeePerGas ? toHex(maxFeePerGas) : '0x',
        gas ? toHex(gas) : '0x',
        to ?? '0x',
        value ? toHex(value) : '0x',
        data ?? '0x0',
        toHex(chainId),
        toHex(''),
        toHex(''),
        toHex(chainId),
        from ?? '0x',
        gasPerPubdata ? toHex(gasPerPubdata) : toHex(gasPerPubdataDefault),
        factoryDeps ?? [],
        customSignature ?? '0x', // EIP712 signature
        paymaster && paymasterInput ? [paymaster, paymasterInput] : [],
    ];
    return concatHex([
        '0x71',
        toRlp(serializedTransaction),
    ]);
}

class BytecodeLengthExceedsMaxSizeError extends BaseError$1 {
    constructor({ givenLength, maxBytecodeSize, }) {
        super(`Bytecode cannot be longer than ${maxBytecodeSize} bytes. Given length: ${givenLength}`, { name: 'BytecodeLengthExceedsMaxSizeError' });
    }
}
class BytecodeLengthInWordsMustBeOddError extends BaseError$1 {
    constructor({ givenLengthInWords }) {
        super(`Bytecode length in 32-byte words must be odd. Given length in words: ${givenLengthInWords}`, { name: 'BytecodeLengthInWordsMustBeOddError' });
    }
}
class BytecodeLengthMustBeDivisibleBy32Error extends BaseError$1 {
    constructor({ givenLength }) {
        super(`The bytecode length in bytes must be divisible by 32. Given length: ${givenLength}`, { name: 'BytecodeLengthMustBeDivisibleBy32Error' });
    }
}

function hashBytecode(bytecode) {
    const bytecodeBytes = toBytes$1(bytecode);
    if (bytecodeBytes.length % 32 !== 0)
        throw new BytecodeLengthMustBeDivisibleBy32Error({
            givenLength: bytecodeBytes.length,
        });
    if (bytecodeBytes.length > maxBytecodeSize)
        throw new BytecodeLengthExceedsMaxSizeError({
            givenLength: bytecodeBytes.length,
            maxBytecodeSize,
        });
    const hashStr = sha256$1(bytecodeBytes);
    const hash = toBytes$1(hashStr);
    // Note that the length of the bytecode
    // should be provided in 32-byte words.
    const bytecodeLengthInWords = bytecodeBytes.length / 32;
    if (bytecodeLengthInWords % 2 === 0) {
        throw new BytecodeLengthInWordsMustBeOddError({
            givenLengthInWords: bytecodeLengthInWords,
        });
    }
    const bytecodeLength = toBytes$1(bytecodeLengthInWords);
    // The bytecode should always take the first 2 bytes of the bytecode hash,
    // so we pad it from the left in case the length is smaller than 2 bytes.
    const bytecodeLengthPadded = pad$1(bytecodeLength, { size: 2 });
    const codeHashVersion = new Uint8Array([1, 0]);
    hash.set(codeHashVersion, 0);
    hash.set(bytecodeLengthPadded, 2);
    return hash;
}

const getEip712Domain = (transaction) => {
    assertEip712Transaction(transaction);
    const message = transactionToMessage(transaction);
    return {
        domain: {
            name: 'zkSync',
            version: '2',
            chainId: transaction.chainId,
        },
        types: {
            Transaction: [
                { name: 'txType', type: 'uint256' },
                { name: 'from', type: 'uint256' },
                { name: 'to', type: 'uint256' },
                { name: 'gasLimit', type: 'uint256' },
                { name: 'gasPerPubdataByteLimit', type: 'uint256' },
                { name: 'maxFeePerGas', type: 'uint256' },
                { name: 'maxPriorityFeePerGas', type: 'uint256' },
                { name: 'paymaster', type: 'uint256' },
                { name: 'nonce', type: 'uint256' },
                { name: 'value', type: 'uint256' },
                { name: 'data', type: 'bytes' },
                { name: 'factoryDeps', type: 'bytes32[]' },
                { name: 'paymasterInput', type: 'bytes' },
            ],
        },
        primaryType: 'Transaction',
        message: message,
    };
};
//////////////////////////////////////////////////////////////////////////////
// Utilities
function transactionToMessage(transaction) {
    const { gas, nonce, to, from, value, maxFeePerGas, maxPriorityFeePerGas, factoryDeps, paymaster, paymasterInput, gasPerPubdata, data, } = transaction;
    return {
        txType: 113n,
        from: BigInt(from),
        to: to ? BigInt(to) : 0n,
        gasLimit: gas ?? 0n,
        gasPerPubdataByteLimit: gasPerPubdata ?? gasPerPubdataDefault,
        maxFeePerGas: maxFeePerGas ?? 0n,
        maxPriorityFeePerGas: maxPriorityFeePerGas ?? 0n,
        paymaster: paymaster ? BigInt(paymaster) : 0n,
        nonce: nonce ? BigInt(nonce) : 0n,
        value: value ?? 0n,
        data: data ? data : '0x0',
        factoryDeps: factoryDeps?.map((dep) => toHex(hashBytecode(dep))) ?? [],
        paymasterInput: paymasterInput ? paymasterInput : '0x',
    };
}

const chainConfig$3 = {
    formatters: formatters$2,
    serializers: serializers$2,
    custom: {
        getEip712Domain,
    },
};

const abstract = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 2_741,
    name: 'Abstract',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://api.mainnet.abs.xyz'],
            webSocket: ['wss://api.mainnet.abs.xyz/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://abscan.org',
        },
        native: {
            name: 'Abstract Explorer',
            url: 'https://explorer.mainnet.abs.xyz',
        },
    },
    contracts: {
        multicall3: {
            address: '0xAa4De41dba0Ca5dCBb288b7cC6b708F3aaC759E7',
            blockCreated: 5288,
        },
        universalSignatureVerifier: {
            address: '0xfB688330379976DA81eB64Fe4BF50d7401763B9C',
            blockCreated: 5263,
        },
    },
});

const abstractTestnet = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 11_124,
    name: 'Abstract Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['https://api.testnet.abs.xyz'] },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://sepolia.abscan.org',
        },
        native: {
            name: 'Abstract Explorer',
            url: 'https://explorer.testnet.abs.xyz',
        },
    },
    testnet: true,
    contracts: {
        multicall3: {
            address: '0xF9cda624FBC7e059355ce98a31693d299FACd963',
            blockCreated: 358349,
        },
        universalSignatureVerifier: {
            address: '0xfB688330379976DA81eB64Fe4BF50d7401763B9C',
            blockCreated: 431682,
        },
    },
});

const acala = /*#__PURE__*/ defineChain({
    id: 787,
    name: 'Acala',
    network: 'acala',
    nativeCurrency: {
        name: 'Acala',
        symbol: 'ACA',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://eth-rpc-acala.aca-api.network'],
            webSocket: ['wss://eth-rpc-acala.aca-api.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Acala Blockscout',
            url: 'https://blockscout.acala.network',
            apiUrl: 'https://blockscout.acala.network/api',
        },
    },
    testnet: false,
});

const acria = /*#__PURE__*/ defineChain({
    id: 47,
    name: 'Acria IntelliChain',
    nativeCurrency: {
        decimals: 18,
        name: 'ACRIA',
        symbol: 'ACRIA',
    },
    rpcUrls: {
        default: {
            http: ['https://aic.acria.ai'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Acria Explorer',
            url: 'https://explorer.acria.ai',
        },
    },
    testnet: false,
});

const adf = /*#__PURE__*/ defineChain({
    id: 1215,
    name: 'ADF Chain',
    nativeCurrency: { name: 'ADDFILL', symbol: 'ADF', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.adftechnology.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'ADF Mainnet Explorer',
            url: 'https://explorer.adftechnology.com',
        },
    },
    testnet: false,
});

const aioz = /*#__PURE__*/ defineChain({
    id: 168,
    name: 'AIOZ Network',
    nativeCurrency: {
        decimals: 18,
        name: 'AIOZ',
        symbol: 'AIOZ',
    },
    rpcUrls: {
        default: {
            http: ['https://eth-dataseed.aioz.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'AIOZ Explorer',
            url: 'https://explorer.aioz.network',
        },
    },
    testnet: false,
});

const alephZero = /*#__PURE__*/ defineChain({
    id: 41_455,
    name: 'Aleph Zero',
    nativeCurrency: { name: 'Aleph Zero', symbol: 'AZERO', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.alephzero.raas.gelato.cloud'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Aleph Zero EVM Explorer',
            url: 'https://evm-explorer.alephzero.org',
            apiUrl: 'https://evm-explorer.alephzero.org/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 4603377,
        },
    },
});

const alephZeroTestnet = /*#__PURE__*/ defineChain({
    id: 2039,
    name: 'Aleph Zero Testnet',
    nativeCurrency: { name: 'TZERO', symbol: 'TZERO', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.alephzero-testnet.gelato.digital'],
            webSocket: ['wss://ws.alephzero-testnet.gelato.digital'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Aleph Zero EVM Testnet explorer',
            url: 'https://evm-explorer-testnet.alephzero.org',
            apiUrl: 'https://evm-explorer-testnet.alephzero.org/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 2861745,
        },
    },
    testnet: true,
});

const alienx = /*#__PURE__*/ defineChain({
    id: 10241024,
    name: 'AlienX Mainnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc.alienxchain.io/http'] },
    },
    blockExplorers: {
        default: {
            name: 'AlienX Explorer',
            url: 'https://explorer.alienxchain.io',
        },
    },
    testnet: false,
});

const alienxHalTestnet = /*#__PURE__*/ defineChain({
    id: 10241025,
    name: 'ALIENX Hal Testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://hal-rpc.alienxchain.io/http'] },
    },
    blockExplorers: {
        default: {
            name: 'AlienX Explorer',
            url: 'https://hal-explorer.alienxchain.io',
        },
    },
    testnet: true,
});

/**
 * Predeploy contracts for OP Stack.
 * @see https://github.com/ethereum-optimism/optimism/blob/develop/specs/predeploys.md
 */
const contracts = {
    gasPriceOracle: { address: '0x420000000000000000000000000000000000000F' },
    l1Block: { address: '0x4200000000000000000000000000000000000015' },
    l2CrossDomainMessenger: {
        address: '0x4200000000000000000000000000000000000007',
    },
    l2Erc721Bridge: { address: '0x4200000000000000000000000000000000000014' },
    l2StandardBridge: { address: '0x4200000000000000000000000000000000000010' },
    l2ToL1MessagePasser: {
        address: '0x4200000000000000000000000000000000000016',
    },
};

const formatters$1 = {
    block: /*#__PURE__*/ defineBlock({
        format(args) {
            const transactions = args.transactions?.map((transaction) => {
                if (typeof transaction === 'string')
                    return transaction;
                const formatted = formatTransaction(transaction);
                if (formatted.typeHex === '0x7e') {
                    formatted.isSystemTx = transaction.isSystemTx;
                    formatted.mint = transaction.mint
                        ? hexToBigInt(transaction.mint)
                        : undefined;
                    formatted.sourceHash = transaction.sourceHash;
                    formatted.type = 'deposit';
                }
                return formatted;
            });
            return {
                transactions,
                stateRoot: args.stateRoot,
            };
        },
    }),
    transaction: /*#__PURE__*/ defineTransaction({
        format(args) {
            const transaction = {};
            if (args.type === '0x7e') {
                transaction.isSystemTx = args.isSystemTx;
                transaction.mint = args.mint ? hexToBigInt(args.mint) : undefined;
                transaction.sourceHash = args.sourceHash;
                transaction.type = 'deposit';
            }
            return transaction;
        },
    }),
    transactionReceipt: /*#__PURE__*/ defineTransactionReceipt({
        format(args) {
            return {
                l1GasPrice: args.l1GasPrice ? hexToBigInt(args.l1GasPrice) : null,
                l1GasUsed: args.l1GasUsed ? hexToBigInt(args.l1GasUsed) : null,
                l1Fee: args.l1Fee ? hexToBigInt(args.l1Fee) : null,
                l1FeeScalar: args.l1FeeScalar ? Number(args.l1FeeScalar) : null,
            };
        },
    }),
};

function serializeTransaction$1(transaction, signature) {
    if (isDeposit(transaction))
        return serializeTransactionDeposit(transaction);
    return serializeTransaction$3(transaction, signature);
}
const serializers$1 = {
    transaction: serializeTransaction$1,
};
function serializeTransactionDeposit(transaction) {
    assertTransactionDeposit(transaction);
    const { sourceHash, data, from, gas, isSystemTx, mint, to, value } = transaction;
    const serializedTransaction = [
        sourceHash,
        from,
        to ?? '0x',
        mint ? toHex(mint) : '0x',
        value ? toHex(value) : '0x',
        gas ? toHex(gas) : '0x',
        isSystemTx ? '0x1' : '0x',
        data ?? '0x',
    ];
    return concatHex([
        '0x7e',
        toRlp(serializedTransaction),
    ]);
}
function isDeposit(transaction) {
    if (transaction.type === 'deposit')
        return true;
    if (typeof transaction.sourceHash !== 'undefined')
        return true;
    return false;
}
function assertTransactionDeposit(transaction) {
    const { from, to } = transaction;
    if (from && !isAddress(from))
        throw new InvalidAddressError({ address: from });
    if (to && !isAddress(to))
        throw new InvalidAddressError({ address: to });
}

const chainConfig$2 = {
    contracts,
    formatters: formatters$1,
    serializers: serializers$1,
};

const sourceId$V = 1; // mainnet
const ancient8 = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 888888888,
    name: 'Ancient8',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.ancient8.gg'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Ancient8 explorer',
            url: 'https://scan.ancient8.gg',
            apiUrl: 'https://scan.ancient8.gg/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$V]: {
                address: '0xB09DC08428C8b4EFB4ff9C0827386CDF34277996',
            },
        },
        portal: {
            [sourceId$V]: {
                address: '0x639F2AECE398Aa76b07e59eF6abe2cFe32bacb68',
                blockCreated: 19070571,
            },
        },
        l1StandardBridge: {
            [sourceId$V]: {
                address: '0xd5e3eDf5b68135D559D572E26bF863FBC1950033',
                blockCreated: 19070571,
            },
        },
    },
    sourceId: sourceId$V,
});

const sourceId$U = 11_155_111; // sepolia
const ancient8Sepolia = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 28122024,
    name: 'Ancient8 Testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpcv2-testnet.ancient8.gg'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Ancient8 Celestia Testnet explorer',
            url: 'https://scanv2-testnet.ancient8.gg',
            apiUrl: 'https://scanv2-testnet.ancient8.gg/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$U]: {
                address: '0x942fD5017c0F60575930D8574Eaca13BEcD6e1bB',
            },
        },
        portal: {
            [sourceId$U]: {
                address: '0xfa1d9E26A6aCD7b22115D27572c1221B9803c960',
                blockCreated: 4972908,
            },
        },
        l1StandardBridge: {
            [sourceId$U]: {
                address: '0xF6Bc0146d3c74D48306e79Ae134A260E418C9335',
                blockCreated: 4972908,
            },
        },
    },
    sourceId: sourceId$U,
});

const anvil = /*#__PURE__*/ defineChain({
    id: 31_337,
    name: 'Anvil',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['http://127.0.0.1:8545'],
            webSocket: ['ws://127.0.0.1:8545'],
        },
    },
});

const sourceId$T = 42_161; // Arbitrum One
const apeChain = /*#__PURE__*/ defineChain({
    id: 33139,
    name: 'Ape Chain',
    nativeCurrency: {
        name: 'ApeCoin',
        symbol: 'APE',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.apechain.com/http'],
            webSocket: ['wss://rpc.apechain.com/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Apescan',
            url: 'https://apescan.io',
            apiUrl: 'https://api.apescan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 20889,
        },
    },
    sourceId: sourceId$T,
});

const apexTestnet = /*#__PURE__*/ defineChain({
    id: 3993,
    name: 'APEX Testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-testnet.apexlayer.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://exp-testnet.apexlayer.xyz',
            apiUrl: 'https://exp-testnet.apexlayer.xyz/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xf7642be33a6b18D16a995657adb5a68CD0438aE2',
            blockCreated: 283775,
        },
    },
    testnet: true,
});

const arbitrum = /*#__PURE__*/ defineChain({
    id: 42_161,
    name: 'Arbitrum One',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://arb1.arbitrum.io/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Arbiscan',
            url: 'https://arbiscan.io',
            apiUrl: 'https://api.arbiscan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 7654707,
        },
    },
});

const arbitrumGoerli = /*#__PURE__*/ defineChain({
    id: 421_613,
    name: 'Arbitrum Goerli',
    nativeCurrency: {
        name: 'Arbitrum Goerli Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://goerli-rollup.arbitrum.io/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Arbiscan',
            url: 'https://goerli.arbiscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 88114,
        },
    },
    testnet: true,
});

const arbitrumNova = /*#__PURE__*/ defineChain({
    id: 42_170,
    name: 'Arbitrum Nova',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://nova.arbitrum.io/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Arbiscan',
            url: 'https://nova.arbiscan.io',
            apiUrl: 'https://api-nova.arbiscan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 1746963,
        },
    },
});

const arbitrumSepolia = /*#__PURE__*/ defineChain({
    id: 421_614,
    name: 'Arbitrum Sepolia',
    nativeCurrency: {
        name: 'Arbitrum Sepolia Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://sepolia-rollup.arbitrum.io/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Arbiscan',
            url: 'https://sepolia.arbiscan.io',
            apiUrl: 'https://api-sepolia.arbiscan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 81930,
        },
    },
    testnet: true,
});

const areonNetwork = /*#__PURE__*/ defineChain({
    id: 463,
    name: 'Areon Network',
    nativeCurrency: { decimals: 18, name: 'AREA', symbol: 'AREA' },
    rpcUrls: {
        default: {
            http: ['https://mainnet-rpc.areon.network'],
            webSocket: ['wss://mainnet-ws.areon.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Areonscan',
            url: 'https://areonscan.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 353286,
        },
    },
    testnet: false,
});

const areonNetworkTestnet = /*#__PURE__*/ defineChain({
    id: 462,
    name: 'Areon Network Testnet',
    nativeCurrency: { decimals: 18, name: 'TAREA', symbol: 'TAREA' },
    rpcUrls: {
        default: {
            http: ['https://testnet-rpc.areon.network'],
            webSocket: ['wss://testnet-ws.areon.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Areonscan',
            url: 'https://areonscan.com',
        },
    },
    testnet: true,
});

const artelaTestnet = /*#__PURE__*/ defineChain({
    id: 11822,
    name: 'Artela Testnet',
    nativeCurrency: { name: 'ART', symbol: 'ART', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://betanet-rpc1.artela.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Artela',
            url: 'https://betanet-scan.artela.network',
            apiUrl: 'https://betanet-scan.artela.network/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xd07c8635f76e8745Ee7092fbb6e8fbc5FeF09DD7',
            blockCreated: 7001871,
        },
    },
    testnet: true,
});

const arthera = /*#__PURE__*/ defineChain({
    id: 10242,
    name: 'Arthera',
    nativeCurrency: { name: 'Arthera', symbol: 'AA', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.arthera.net'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Arthera EVM Explorer',
            url: 'https://explorer.arthera.net',
            apiUrl: 'https://explorer.arthera.net/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 4502791,
        },
    },
});

const artheraTestnet = /*#__PURE__*/ defineChain({
    id: 10243,
    name: 'Arthera Testnet',
    nativeCurrency: { name: 'Arthera', symbol: 'AA', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-test.arthera.net'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Arthera EVM Explorer',
            url: 'https://explorer-test.arthera.net',
            apiUrl: 'https://explorer-test.arthera.net/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 22051,
        },
    },
});

const assetChain = /*#__PURE__*/ defineChain({
    id: 42_420,
    name: 'AssetChain Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Real World Asset',
        symbol: 'RWA',
    },
    rpcUrls: {
        default: { http: ['https://mainnet-rpc.assetchain.org'] },
    },
    blockExplorers: {
        default: {
            name: 'Asset Chain Explorer',
            url: 'https://scan.assetchain.org',
            apiUrl: 'https://scan.assetchain.org/api',
        },
    },
    testnet: false,
    contracts: {},
});

const assetChainTestnet = /*#__PURE__*/ defineChain({
    id: 42_421,
    name: 'AssetChain Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Real World Asset',
        symbol: 'RWA',
    },
    rpcUrls: {
        default: { http: ['https://enugu-rpc.assetchain.org'] },
    },
    blockExplorers: {
        default: {
            name: 'Asset Chain Testnet Explorer',
            url: 'https://scan-testnet.assetchain.org',
            apiUrl: 'https://scan-testnet.assetchain.org/api',
        },
    },
    testnet: true,
    contracts: {
        multicall3: {
            address: '0x989F832D35988cb5e3eB001Fa2Fe789469EC31Ea',
            blockCreated: 17177,
        },
    },
});

const astar = /*#__PURE__*/ defineChain({
    id: 592,
    name: 'Astar',
    network: 'astar-mainnet',
    nativeCurrency: {
        name: 'Astar',
        symbol: 'ASTR',
        decimals: 18,
    },
    rpcUrls: {
        default: { http: ['https://astar.api.onfinality.io/public'] },
    },
    blockExplorers: {
        default: {
            name: 'Astar Subscan',
            url: 'https://astar.subscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 761794,
        },
    },
    testnet: false,
});

const astarZkEVM = /*#__PURE__*/ defineChain({
    id: 3_776,
    name: 'Astar zkEVM',
    network: 'AstarZkEVM',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-zkevm.astar.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Astar zkEVM Explorer',
            url: 'https://astar-zkevm.explorer.startale.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 93528,
        },
    },
    testnet: false,
});

const astarZkyoto = /*#__PURE__*/ defineChain({
    id: 6_038_361,
    name: 'Astar zkEVM Testnet zKyoto',
    network: 'zKyoto',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.startale.com/zkyoto'],
        },
    },
    blockExplorers: {
        default: {
            name: 'zKyoto Explorer',
            url: 'https://zkyoto.explorer.startale.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 196153,
        },
    },
    testnet: true,
});

const atletaOlympia = /*#__PURE__*/ defineChain({
    id: 2340,
    name: 'Atleta Olympia',
    nativeCurrency: { decimals: 18, name: 'Atla', symbol: 'ATLA' },
    rpcUrls: {
        default: {
            http: [
                'https://testnet-rpc.atleta.network:9944',
                'https://testnet-rpc.atleta.network',
            ],
            ws: ['wss://testnet-rpc.atleta.network:9944'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Atleta Olympia Explorer',
            url: 'https://blockscout.atleta.network',
            apiUrl: 'https://blockscout.atleta.network/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0x1472ec6392180fb84F345d2455bCC75B26577115',
            blockCreated: 1076473,
        },
    },
    testnet: true,
});

const aurora = /*#__PURE__*/ defineChain({
    id: 1313161554,
    name: 'Aurora',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['https://mainnet.aurora.dev'] },
    },
    blockExplorers: {
        default: {
            name: 'Aurorascan',
            url: 'https://aurorascan.dev',
            apiUrl: 'https://aurorascan.dev/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 62907816,
        },
    },
});

const auroraTestnet = /*#__PURE__*/ defineChain({
    id: 1313161555,
    name: 'Aurora Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['https://testnet.aurora.dev'] },
    },
    blockExplorers: {
        default: {
            name: 'Aurorascan',
            url: 'https://testnet.aurorascan.dev',
            apiUrl: 'https://testnet.aurorascan.dev/api',
        },
    },
    testnet: true,
});

const auroria = /*#__PURE__*/ defineChain({
    id: 205205,
    name: 'Auroria Testnet',
    network: 'auroria',
    nativeCurrency: {
        name: 'Auroria Stratis',
        symbol: 'tSTRAX',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://auroria.rpc.stratisevm.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Auroria Testnet Explorer',
            url: 'https://auroria.explorer.stratisevm.com',
        },
    },
    testnet: true,
});

const avalanche = /*#__PURE__*/ defineChain({
    id: 43_114,
    name: 'Avalanche',
    nativeCurrency: {
        decimals: 18,
        name: 'Avalanche',
        symbol: 'AVAX',
    },
    rpcUrls: {
        default: { http: ['https://api.avax.network/ext/bc/C/rpc'] },
    },
    blockExplorers: {
        default: {
            name: 'SnowTrace',
            url: 'https://snowtrace.io',
            apiUrl: 'https://api.snowtrace.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 11907934,
        },
    },
});

const avalancheFuji = /*#__PURE__*/ defineChain({
    id: 43_113,
    name: 'Avalanche Fuji',
    nativeCurrency: {
        decimals: 18,
        name: 'Avalanche Fuji',
        symbol: 'AVAX',
    },
    rpcUrls: {
        default: { http: ['https://api.avax-test.network/ext/bc/C/rpc'] },
    },
    blockExplorers: {
        default: {
            name: 'SnowTrace',
            url: 'https://testnet.snowtrace.io',
            apiUrl: 'https://api-testnet.snowtrace.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 7096959,
        },
    },
    testnet: true,
});

const sourceId$S = 8453; // base
const b3 = /*#__PURE__*/ defineChain({
    id: 8333,
    name: 'B3',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://mainnet-rpc.b3.fun/http'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://explorer.b3.fun',
        },
    },
    sourceId: sourceId$S,
});

const sourceId$R = 168_587_773; // base-sepolia
const b3Sepolia = /*#__PURE__*/ defineChain({
    id: 1993,
    name: 'B3 Sepolia',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://sepolia.b3.fun/http'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://sepolia.explorer.b3.fun',
        },
    },
    testnet: true,
    sourceId: sourceId$R,
});

const bahamut = /*#__PURE__*/ defineChain({
    id: 5165,
    network: 'bahamut',
    name: 'Bahamut',
    nativeCurrency: { name: 'Fasttoken', symbol: 'FTN', decimals: 18 },
    rpcUrls: {
        default: {
            http: [
                'https://rpc1.bahamut.io',
                'https://bahamut-rpc.publicnode.com',
                'https://rpc2.bahamut.io',
            ],
            webSocket: [
                'wss://ws1.sahara.bahamutchain.com',
                'wss://bahamut-rpc.publicnode.com',
                'wss://ws2.sahara.bahamutchain.com',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'Ftnscan',
            url: 'https://www.ftnscan.com',
            apiUrl: 'https://www.ftnscan.com/api',
        },
    },
});

const sourceId$Q = 1; // mainnet
const base$1 = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 8453,
    name: 'Base',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.base.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Basescan',
            url: 'https://basescan.org',
            apiUrl: 'https://api.basescan.org/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        disputeGameFactory: {
            [sourceId$Q]: {
                address: '0x43edB88C4B80fDD2AdFF2412A7BebF9dF42cB40e',
            },
        },
        l2OutputOracle: {
            [sourceId$Q]: {
                address: '0x56315b90c40730925ec5485cf004d835058518A0',
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 5022,
        },
        portal: {
            [sourceId$Q]: {
                address: '0x49048044D57e1C92A77f79988d21Fa8fAF74E97e',
                blockCreated: 17482143,
            },
        },
        l1StandardBridge: {
            [sourceId$Q]: {
                address: '0x3154Cf16ccdb4C6d922629664174b904d80F2C35',
                blockCreated: 17482143,
            },
        },
    },
    sourceId: sourceId$Q,
});

const sourceId$P = 5; // goerli
const baseGoerli = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 84531,
    name: 'Base Goerli',
    nativeCurrency: { name: 'Goerli Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://goerli.base.org'] },
    },
    blockExplorers: {
        default: {
            name: 'Basescan',
            url: 'https://goerli.basescan.org',
            apiUrl: 'https://goerli.basescan.org/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$P]: {
                address: '0x2A35891ff30313CcFa6CE88dcf3858bb075A2298',
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 1376988,
        },
        portal: {
            [sourceId$P]: {
                address: '0xe93c8cD0D409341205A592f8c4Ac1A5fe5585cfA',
            },
        },
        l1StandardBridge: {
            [sourceId$P]: {
                address: '0xfA6D8Ee5BE770F84FC001D098C4bD604Fe01284a',
            },
        },
    },
    testnet: true,
    sourceId: sourceId$P,
});

const sourceId$O = 11_155_111; // sepolia
const baseSepolia$1 = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 84532,
    network: 'base-sepolia',
    name: 'Base Sepolia',
    nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://sepolia.base.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Basescan',
            url: 'https://sepolia.basescan.org',
            apiUrl: 'https://api-sepolia.basescan.org/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        disputeGameFactory: {
            [sourceId$O]: {
                address: '0xd6E6dBf4F7EA0ac412fD8b65ED297e64BB7a06E1',
            },
        },
        l2OutputOracle: {
            [sourceId$O]: {
                address: '0x84457ca9D0163FbC4bbfe4Dfbb20ba46e48DF254',
            },
        },
        portal: {
            [sourceId$O]: {
                address: '0x49f53e41452c74589e85ca1677426ba426459e85',
                blockCreated: 4446677,
            },
        },
        l1StandardBridge: {
            [sourceId$O]: {
                address: '0xfd0Bf71F60660E2f608ed56e1659C450eB113120',
                blockCreated: 4446677,
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 1059647,
        },
    },
    testnet: true,
    sourceId: sourceId$O,
});

const beam = /*#__PURE__*/ defineChain({
    id: 4337,
    name: 'Beam',
    network: 'beam',
    nativeCurrency: {
        decimals: 18,
        name: 'Beam',
        symbol: 'BEAM',
    },
    rpcUrls: {
        default: {
            http: ['https://build.onbeam.com/rpc'],
            webSocket: ['wss://build.onbeam.com/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Beam Explorer',
            url: 'https://subnets.avax.network/beam',
        },
    },
    contracts: {
        multicall3: {
            address: '0x4956f15efdc3dc16645e90cc356eafa65ffc65ec',
            blockCreated: 1,
        },
    },
});

const beamTestnet = /*#__PURE__*/ defineChain({
    id: 13337,
    name: 'Beam Testnet',
    network: 'beam',
    nativeCurrency: {
        decimals: 18,
        name: 'Beam',
        symbol: 'BEAM',
    },
    rpcUrls: {
        default: {
            http: ['https://build.onbeam.com/rpc/testnet'],
            webSocket: ['wss://build.onbeam.com/ws/testnet'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Beam Explorer',
            url: 'https://subnets-test.avax.network/beam',
        },
    },
    contracts: {
        multicall3: {
            address: '0x9bf49b704ee2a095b95c1f2d4eb9010510c41c9e',
            blockCreated: 3,
        },
    },
    testnet: true,
});

const bearNetworkChainMainnet = /*#__PURE__*/ defineChain({
    id: 641230,
    name: 'Bear Network Chain Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'BearNetworkChain',
        symbol: 'BRNKC',
    },
    rpcUrls: {
        default: { http: ['https://brnkc-mainnet.bearnetwork.net'] },
    },
    blockExplorers: {
        default: {
            name: 'BrnkScan',
            url: 'https://brnkscan.bearnetwork.net',
            apiUrl: 'https://brnkscan.bearnetwork.net/api',
        },
    },
});

const bearNetworkChainTestnet = /*#__PURE__*/ defineChain({
    id: 751230,
    name: 'Bear Network Chain Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'tBRNKC',
        symbol: 'tBRNKC',
    },
    rpcUrls: {
        default: { http: ['https://brnkc-test.bearnetwork.net'] },
    },
    blockExplorers: {
        default: {
            name: 'BrnkTestScan',
            url: 'https://brnktest-scan.bearnetwork.net',
            apiUrl: 'https://brnktest-scan.bearnetwork.net/api',
        },
    },
    testnet: true,
});

const berachain = /*#__PURE__*/ defineChain({
    id: 80094,
    name: 'Berachain',
    nativeCurrency: {
        decimals: 18,
        name: 'BERA Token',
        symbol: 'BERA',
    },
    rpcUrls: {
        default: { http: ['https://rpc.berachain.com'] },
    },
    blockExplorers: {
        default: {
            name: 'Berascan',
            url: 'https://berascan.com',
        },
    },
    testnet: false,
});

const berachainTestnet = /*#__PURE__*/ defineChain({
    id: 80085,
    name: 'Berachain Artio',
    nativeCurrency: {
        decimals: 18,
        name: 'BERA Token',
        symbol: 'BERA',
    },
    rpcUrls: {
        default: { http: ['https://artio.rpc.berachain.com'] },
    },
    blockExplorers: {
        default: {
            name: 'Berachain',
            url: 'https://artio.beratrail.io',
        },
    },
    testnet: true,
});

const berachainTestnetbArtio = /*#__PURE__*/ defineChain({
    id: 80084,
    name: 'Berachain bArtio',
    nativeCurrency: {
        decimals: 18,
        name: 'BERA Token',
        symbol: 'BERA',
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 109269,
        },
        ensRegistry: {
            address: '0xB0eef18971290b333450586D33dcA6cE122651D2',
            blockCreated: 7736794,
        },
        ensUniversalResolver: {
            address: '0x41692Ef1EA0C79E6b73077E4A67572D2BDbD7057',
            blockCreated: 7736795,
        },
    },
    rpcUrls: {
        default: { http: ['https://bartio.rpc.berachain.com'] },
    },
    blockExplorers: {
        default: {
            name: 'Berachain bArtio Beratrail',
            url: 'https://bartio.beratrail.io',
        },
    },
    testnet: true,
});

const bevmMainnet = /*#__PURE__*/ defineChain({
    id: 11501,
    name: 'BEVM Mainnet',
    nativeCurrency: { name: 'Bitcoin', symbol: 'BTC', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc-mainnet-1.bevm.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Bevmscan',
            url: 'https://scan-mainnet.bevm.io',
            apiUrl: 'https://scan-mainnet-api.bevm.io/api',
        },
    },
});

const bifrost = /*#__PURE__*/ defineChain({
    id: 3068,
    name: 'Bifrost Mainnet',
    nativeCurrency: { name: 'BFC', symbol: 'BFC', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://public-01.mainnet.bifrostnetwork.com/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Bifrost Blockscout',
            url: 'https://explorer.mainnet.bifrostnetwork.com',
        },
    },
    testnet: false,
});

const bitgert = /*#__PURE__*/ defineChain({
    id: 32520,
    name: 'Bitgert Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Brise',
        symbol: 'Brise',
    },
    rpcUrls: {
        default: { http: ['https://rpc-bitgert.icecreamswap.com'] },
    },
    blockExplorers: {
        default: {
            name: 'Bitgert Scan',
            url: 'https://brisescan.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 2118034,
        },
    },
    testnet: false,
});

const bitkub = /*#__PURE__*/ defineChain({
    id: 96,
    name: 'Bitkub',
    nativeCurrency: { name: 'Bitkub', symbol: 'KUB', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.bitkubchain.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Bitkub Chain Mainnet Explorer',
            url: 'https://www.bkcscan.com',
            apiUrl: 'https://www.bkcscan.com/api',
        },
    },
});

const bitkubTestnet = /*#__PURE__*/ defineChain({
    id: 25925,
    name: 'Bitkub Testnet',
    network: 'Bitkub Testnet',
    nativeCurrency: { name: 'Bitkub Test', symbol: 'tKUB', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-testnet.bitkubchain.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Bitkub Chain Testnet Explorer',
            url: 'https://testnet.bkcscan.com',
            apiUrl: 'https://testnet.bkcscan.com/api',
        },
    },
    testnet: true,
});

const bitlayer = /*#__PURE__*/ defineChain({
    id: 200901,
    name: 'Bitlayer Mainnet',
    nativeCurrency: {
        name: 'BTC',
        symbol: 'BTC',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.bitlayer.org'],
            webSocket: ['wss://ws.bitlayer.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'bitlayer mainnet scan',
            url: 'https://www.btrscan.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0x5B256fE9e993902eCe49D138a5b1162cBb529474',
            blockCreated: 2421963,
        },
    },
});

const bitlayerTestnet = /*#__PURE__*/ defineChain({
    id: 200810,
    name: 'Bitlayer Testnet',
    nativeCurrency: {
        name: 'BTC',
        symbol: 'BTC',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://testnet-rpc.bitlayer.org'],
            webSocket: ['wss://testnet-ws.bitlayer.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'bitlayer testnet scan',
            url: 'https://testnet.btrscan.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0x5B256fE9e993902eCe49D138a5b1162cBb529474',
            blockCreated: 4135671,
        },
    },
    testnet: true,
});

const bitrock = /*#__PURE__*/ defineChain({
    id: 7171,
    name: 'Bitrock Mainnet',
    nativeCurrency: { name: 'BROCK', symbol: 'BROCK', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://brockrpc.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Bitrock Explorer',
            url: 'https://explorer.bit-rock.io',
        },
    },
    testnet: false,
});

const bitTorrent = /*#__PURE__*/ defineChain({
    id: 199,
    name: 'BitTorrent',
    network: 'bittorrent-chain-mainnet',
    nativeCurrency: { name: 'BitTorrent', symbol: 'BTT', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc.bittorrentchain.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Bttcscan',
            url: 'https://bttcscan.com',
            apiUrl: 'https://api.bttcscan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 31078552,
        },
    },
});

const bitTorrentTestnet = /*#__PURE__*/ defineChain({
    id: 1028,
    name: 'BitTorrent Chain Testnet',
    network: 'bittorrent-chain-testnet',
    nativeCurrency: { name: 'BitTorrent', symbol: 'BTT', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://testrpc.bittorrentchain.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Bttcscan',
            url: 'https://testnet.bttcscan.com',
            apiUrl: 'https://testnet.bttcscan.com/api',
        },
    },
    testnet: true,
});

const sourceId$N = 1; // mainnet
const blast = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 81457,
    name: 'Blast',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['https://rpc.blast.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Blastscan',
            url: 'https://blastscan.io',
            apiUrl: 'https://api.blastscan.io/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 212929,
        },
    },
    sourceId: sourceId$N,
});

const sourceId$M = 11_155_111; // sepolia
const blastSepolia = /*#__PURE__*/ defineChain({
    id: 168_587_773,
    name: 'Blast Sepolia',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://sepolia.blast.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blastscan',
            url: 'https://sepolia.blastscan.io',
            apiUrl: 'https://api-sepolia.blastscan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 756690,
        },
    },
    testnet: true,
    sourceId: sourceId$M,
});

const sourceId$L = 1; // mainnet
const bob = defineChain({
    ...chainConfig$2,
    id: 60808,
    name: 'BOB',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.gobob.xyz'],
            webSocket: ['wss://rpc.gobob.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'BOB Explorer',
            url: 'https://explorer.gobob.xyz',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 23131,
        },
        l2OutputOracle: {
            [sourceId$L]: {
                address: '0xdDa53E23f8a32640b04D7256e651C1db98dB11C1',
                blockCreated: 4462615,
            },
        },
        portal: {
            [sourceId$L]: {
                address: '0x8AdeE124447435fE03e3CD24dF3f4cAE32E65a3E',
                blockCreated: 4462615,
            },
        },
    },
    sourceId: sourceId$L,
});

const boba = /*#__PURE__*/ defineChain({
    id: 288,
    name: 'Boba Network',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['https://mainnet.boba.network'] },
    },
    blockExplorers: {
        default: {
            name: 'BOBAScan',
            url: 'https://bobascan.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 446859,
        },
    },
});

const bobaSepolia = /*#__PURE__*/ defineChain({
    id: 28882,
    name: 'Boba Sepolia',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: { http: ['https://sepolia.boba.network'] },
    },
    blockExplorers: {
        default: {
            name: 'BOBAScan',
            url: 'https://testnet.bobascan.com',
        },
    },
    testnet: true,
});

const sourceId$K = 11_155_111; // sepolia
const bobSepolia = defineChain({
    ...chainConfig$2,
    id: 808813,
    name: 'BOB Sepolia',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://bob-sepolia.rpc.gobob.xyz'],
            webSocket: ['wss://bob-sepolia.rpc.gobob.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'BOB Sepolia Explorer',
            url: 'https://bob-sepolia.explorer.gobob.xyz',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 35677,
        },
        l2OutputOracle: {
            [sourceId$K]: {
                address: '0x14D0069452b4AE2b250B395b8adAb771E4267d2f',
                blockCreated: 4462615,
            },
        },
        portal: {
            [sourceId$K]: {
                address: '0x867B1Aa872b9C8cB5E9F7755feDC45BB24Ad0ae4',
                blockCreated: 4462615,
            },
        },
    },
    testnet: true,
    sourceId: sourceId$K,
});

const boolBetaMainnet = /*#__PURE__*/ defineChain({
    id: 11100,
    name: 'Bool Beta Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'BOL',
        symbol: 'BOL',
    },
    rpcUrls: {
        default: { http: ['https://beta-rpc-node-http.bool.network'] },
    },
    blockExplorers: {
        default: {
            name: 'BoolScan',
            url: 'https://beta-mainnet.boolscan.com/',
        },
    },
    testnet: false,
});

const botanixTestnet = /*#__PURE__*/ defineChain({
    id: 3636,
    name: 'Botanix Testnet',
    nativeCurrency: { name: 'Botanix', symbol: 'BTC', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://node.botanixlabs.dev'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Botanix Testnet Explorer',
            url: 'https://testnet.botanixscan.io',
        },
    },
    testnet: true,
});

const bounceBit = /*#__PURE__*/ defineChain({
    id: 6001,
    name: 'BounceBit Mainnet',
    nativeCurrency: { name: 'BounceBit', symbol: 'BB', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://fullnode-mainnet.bouncebitapi.com'] },
    },
    blockExplorers: {
        default: {
            name: 'BB Scan',
            url: 'https://bbscan.io',
        },
    },
    testnet: false,
});

const bounceBitTestnet = /*#__PURE__*/ defineChain({
    id: 6000,
    name: 'BounceBit Testnet',
    nativeCurrency: { name: 'BounceBit', symbol: 'BB', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://fullnode-testnet.bouncebitapi.com'] },
    },
    blockExplorers: {
        default: {
            name: 'BB Scan',
            url: 'https://testnet.bbscan.io',
        },
    },
    testnet: true,
});

const bronos = /*#__PURE__*/ defineChain({
    id: 1039,
    name: 'Bronos',
    nativeCurrency: {
        decimals: 18,
        name: 'BRO',
        symbol: 'BRO',
    },
    rpcUrls: {
        default: { http: ['https://evm.bronos.org'] },
    },
    blockExplorers: {
        default: {
            name: 'BronoScan',
            url: 'https://broscan.bronos.org',
        },
    },
});

const bronosTestnet = /*#__PURE__*/ defineChain({
    id: 1038,
    name: 'Bronos Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Bronos Coin',
        symbol: 'tBRO',
    },
    rpcUrls: {
        default: { http: ['https://evm-testnet.bronos.org'] },
    },
    blockExplorers: {
        default: {
            name: 'BronoScan',
            url: 'https://tbroscan.bronos.org',
        },
    },
    testnet: true,
});

const bsc = /*#__PURE__*/ defineChain({
    id: 56,
    name: 'BNB Smart Chain',
    nativeCurrency: {
        decimals: 18,
        name: 'BNB',
        symbol: 'BNB',
    },
    rpcUrls: {
        default: { http: ['https://rpc.ankr.com/bsc'] },
    },
    blockExplorers: {
        default: {
            name: 'BscScan',
            url: 'https://bscscan.com',
            apiUrl: 'https://api.bscscan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 15921452,
        },
    },
});

const bscGreenfield = /*#__PURE__*/ defineChain({
    id: 1017,
    name: 'BNB Greenfield Chain',
    nativeCurrency: {
        decimals: 18,
        name: 'BNB',
        symbol: 'BNB',
    },
    rpcUrls: {
        default: { http: ['https://greenfield-chain.bnbchain.org'] },
    },
    blockExplorers: {
        default: {
            name: 'BNB Greenfield Mainnet Scan',
            url: 'https://greenfieldscan.com',
        },
    },
    testnet: false,
});

const bscTestnet = /*#__PURE__*/ defineChain({
    id: 97,
    name: 'Binance Smart Chain Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'BNB',
        symbol: 'tBNB',
    },
    rpcUrls: {
        default: { http: ['https://data-seed-prebsc-1-s1.bnbchain.org:8545'] },
    },
    blockExplorers: {
        default: {
            name: 'BscScan',
            url: 'https://testnet.bscscan.com',
            apiUrl: 'https://api-testnet.bscscan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 17422483,
        },
    },
    testnet: true,
});

const bsquared = /*#__PURE__*/ defineChain({
    id: 223,
    name: 'B2',
    nativeCurrency: {
        name: 'Bitcoin',
        symbol: 'BTC',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.bsquared.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'blockscout',
            url: 'https://explorer.bsquared.network',
        },
    },
});

const bsquaredTestnet = /*#__PURE__*/ defineChain({
    id: 1123,
    name: 'B2 Testnet',
    nativeCurrency: {
        name: 'Bitcoin',
        symbol: 'BTC',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://testnet-rpc.bsquared.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'blockscout',
            url: 'https://testnet-explorer.bsquared.network',
        },
    },
    testnet: true,
});

const btr = /*#__PURE__*/ defineChain({
    id: 200901,
    name: 'Bitlayer',
    nativeCurrency: {
        name: 'Bitcoin',
        symbol: 'BTC',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: [
                'https://rpc.bitlayer.org',
                'https://rpc.bitlayer-rpc.com',
                'https://rpc.ankr.com/bitlayer',
            ],
            webSocket: ['wss://ws.bitlayer.org', 'wss://ws.bitlayer-rpc.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Bitlayer(BTR) Scan',
            url: 'https://www.btrscan.com',
        },
    },
});

const btrTestnet = /*#__PURE__*/ defineChain({
    id: 200810,
    name: 'Bitlayer Testnet',
    nativeCurrency: {
        name: 'Bitcoin',
        symbol: 'BTC',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://testnet-rpc.bitlayer.org'],
            webSocket: [
                'wss://testnet-ws.bitlayer.org',
                'wss://testnet-ws.bitlayer-rpc.com',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'Bitlayer(BTR) Scan',
            url: 'https://testnet.btrscan.com',
        },
    },
    testnet: true,
});

const bxn = /*#__PURE__*/ defineChain({
    id: 4999,
    name: 'BlackFort Exchange Network',
    nativeCurrency: { name: 'BlackFort Token', symbol: 'BXN', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.blackfort.network/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://explorer.blackfort.network',
            apiUrl: 'https://explorer.blackfort.network/api',
        },
    },
});

const bxnTestnet = /*#__PURE__*/ defineChain({
    id: 4777,
    name: 'BlackFort Exchange Network Testnet',
    nativeCurrency: {
        name: 'BlackFort Testnet Token',
        symbol: 'TBXN',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://testnet.blackfort.network/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://testnet-explorer.blackfort.network',
            apiUrl: 'https://testnet-explorer.blackfort.network/api',
        },
    },
    testnet: true,
});

const cannon = /*#__PURE__*/ defineChain({
    id: 13_370,
    name: 'Cannon',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['http://127.0.0.1:8545'] },
    },
});

const canto = /*#__PURE__*/ defineChain({
    id: 7_700,
    name: 'Canto',
    nativeCurrency: {
        decimals: 18,
        name: 'Canto',
        symbol: 'CANTO',
    },
    rpcUrls: {
        default: { http: ['https://canto.gravitychain.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Tuber.Build (Blockscout)',
            url: 'https://tuber.build',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 2905789,
        },
    },
});

const fees = {
    /*
     * Estimates the fees per gas for a transaction.
  
     * If the transaction is to be paid in a token (feeCurrency is present) then the fees
     * are estimated in the value of the token. Otherwise falls back to the default
     * estimation by returning null.
     *
     * @param params fee estimation function parameters
     */
    estimateFeesPerGas: async (params) => {
        if (!params.request?.feeCurrency)
            return null;
        const [gasPrice, maxPriorityFeePerGas, cel2] = await Promise.all([
            estimateFeePerGasInFeeCurrency(params.client, params.request.feeCurrency),
            estimateMaxPriorityFeePerGasInFeeCurrency(params.client, params.request.feeCurrency),
            isCel2(params.client),
        ]);
        const maxFeePerGas = cel2
            ? // eth_gasPrice for cel2 returns baseFeePerGas + maxPriorityFeePerGas
                params.multiply(gasPrice - maxPriorityFeePerGas) + maxPriorityFeePerGas
            : // eth_gasPrice for Celo L1 returns (baseFeePerGas * multiplier), where the multiplier is 2 by default.
                gasPrice + maxPriorityFeePerGas;
        return {
            maxFeePerGas,
            maxPriorityFeePerGas,
        };
    },
};
/*
 * Estimate the fee per gas in the value of the fee token

 *
 * @param client - Client to use
 * @param feeCurrency -  Address of a whitelisted fee token
 * @returns The fee per gas in wei in the value of the  fee token
 *
 */
async function estimateFeePerGasInFeeCurrency(client, feeCurrency) {
    const fee = await client.request({
        method: 'eth_gasPrice',
        params: [feeCurrency],
    });
    return BigInt(fee);
}
/*
 * Estimate the max priority fee per gas in the value of the fee token

 *
 * @param client - Client to use
 * @param feeCurrency -  Address of a whitelisted fee token
 * @returns The fee per gas in wei in the value of the  fee token
 *
 */
async function estimateMaxPriorityFeePerGasInFeeCurrency(client, feeCurrency) {
    const feesPerGas = await client.request({
        method: 'eth_maxPriorityFeePerGas',
        params: [feeCurrency],
    });
    return BigInt(feesPerGas);
}
async function isCel2(client) {
    const proxyAdminAddress = '0x4200000000000000000000000000000000000018';
    const code = await getCode$1(client, { address: proxyAdminAddress });
    return Boolean(code);
}

function isEmpty(value) {
    return (value === 0 ||
        value === 0n ||
        value === undefined ||
        value === null ||
        value === '0' ||
        value === '' ||
        (typeof value === 'string' &&
            (trim$1(value).toLowerCase() === '0x' ||
                trim$1(value).toLowerCase() === '0x00')));
}
function isPresent(value) {
    return !isEmpty(value);
}
/** @internal */
function isEIP1559(transaction) {
    return (typeof transaction.maxFeePerGas !== 'undefined' &&
        typeof transaction.maxPriorityFeePerGas !== 'undefined');
}
function isCIP64(transaction) {
    /*
     * Enable end user to force the tx to be considered as a CIP-64.
     *
     * The preliminary type will be determined as "eip1559" by src/utils/transaction/getTransactionType.ts
     * and so we need the logic below to check for the specific value instead of checking if just any
     * transaction type is provided. If that's anything else than "cip64" then we need to reevaluate the
     * type based on the transaction fields.
     *
     * Modify with caution and according to https://github.com/celo-org/celo-proposals/blob/master/CIPs/cip-0064.md
     */
    if (transaction.type === 'cip64') {
        return true;
    }
    return isEIP1559(transaction) && isPresent(transaction.feeCurrency);
}

const formatters = {
    block: /*#__PURE__*/ defineBlock({
        format(args) {
            const transactions = args.transactions?.map((transaction) => {
                if (typeof transaction === 'string')
                    return transaction;
                const formatted = formatTransaction(transaction);
                return {
                    ...formatted,
                    ...(transaction.gatewayFee
                        ? {
                            gatewayFee: hexToBigInt(transaction.gatewayFee),
                            gatewayFeeRecipient: transaction.gatewayFeeRecipient,
                        }
                        : {}),
                    feeCurrency: transaction.feeCurrency,
                };
            });
            return {
                transactions,
                ...(args.randomness ? { randomness: args.randomness } : {}),
            };
        },
    }),
    transaction: /*#__PURE__*/ defineTransaction({
        format(args) {
            if (args.type === '0x7e')
                return {
                    isSystemTx: args.isSystemTx,
                    mint: args.mint ? hexToBigInt(args.mint) : undefined,
                    sourceHash: args.sourceHash,
                    type: 'deposit',
                };
            const transaction = { feeCurrency: args.feeCurrency };
            if (args.type === '0x7b')
                transaction.type = 'cip64';
            else {
                if (args.type === '0x7c')
                    transaction.type = 'cip42';
                transaction.gatewayFee = args.gatewayFee
                    ? hexToBigInt(args.gatewayFee)
                    : null;
                transaction.gatewayFeeRecipient = args.gatewayFeeRecipient;
            }
            return transaction;
        },
    }),
    transactionRequest: /*#__PURE__*/ defineTransactionRequest({
        format(args) {
            const request = {};
            if (args.feeCurrency)
                request.feeCurrency = args.feeCurrency;
            if (isCIP64(args))
                request.type = '0x7b';
            return request;
        },
    }),
};

function serializeTransaction(transaction, signature) {
    if (isCIP64(transaction))
        return serializeTransactionCIP64(transaction, signature);
    return serializeTransaction$1(transaction, signature);
}
const serializers = {
    transaction: serializeTransaction,
};
function serializeTransactionCIP64(transaction, signature) {
    assertTransactionCIP64(transaction);
    const { chainId, gas, nonce, to, value, maxFeePerGas, maxPriorityFeePerGas, accessList, feeCurrency, data, } = transaction;
    const serializedTransaction = [
        toHex(chainId),
        nonce ? toHex(nonce) : '0x',
        maxPriorityFeePerGas ? toHex(maxPriorityFeePerGas) : '0x',
        maxFeePerGas ? toHex(maxFeePerGas) : '0x',
        gas ? toHex(gas) : '0x',
        to ?? '0x',
        value ? toHex(value) : '0x',
        data ?? '0x',
        serializeAccessList(accessList),
        feeCurrency,
        ...toYParitySignatureArray(transaction, signature),
    ];
    return concatHex([
        '0x7b',
        toRlp(serializedTransaction),
    ]);
}
// maxFeePerGas must be less than maxUint256
const MAX_MAX_FEE_PER_GAS = maxUint256;
function assertTransactionCIP64(transaction) {
    const { chainId, maxPriorityFeePerGas, gasPrice, maxFeePerGas, to, feeCurrency, } = transaction;
    if (chainId <= 0)
        throw new InvalidChainIdError({ chainId });
    if (to && !isAddress(to))
        throw new InvalidAddressError({ address: to });
    if (gasPrice)
        throw new BaseError$1('`gasPrice` is not a valid CIP-64 Transaction attribute.');
    if (isPresent(maxFeePerGas) && maxFeePerGas > MAX_MAX_FEE_PER_GAS)
        throw new FeeCapTooHighError({ maxFeePerGas });
    if (isPresent(maxPriorityFeePerGas) &&
        isPresent(maxFeePerGas) &&
        maxPriorityFeePerGas > maxFeePerGas)
        throw new TipAboveFeeCapError({ maxFeePerGas, maxPriorityFeePerGas });
    if (isPresent(feeCurrency) && !isAddress(feeCurrency)) {
        throw new BaseError$1('`feeCurrency` MUST be a token address for CIP-64 transactions.');
    }
    if (isEmpty(feeCurrency)) {
        throw new BaseError$1('`feeCurrency` must be provided for CIP-64 transactions.');
    }
}

const chainConfig$1 = {
    contracts,
    formatters,
    serializers,
    fees,
};

const celo = /*#__PURE__*/ defineChain({
    ...chainConfig$1,
    id: 42_220,
    name: 'Celo',
    nativeCurrency: {
        decimals: 18,
        name: 'CELO',
        symbol: 'CELO',
    },
    rpcUrls: {
        default: { http: ['https://forno.celo.org'] },
    },
    blockExplorers: {
        default: {
            name: 'Celo Explorer',
            url: 'https://celoscan.io',
            apiUrl: 'https://api.celoscan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 13112599,
        },
    },
    testnet: false,
});

const sourceId$J = 17000; // holsky
// source https://storage.googleapis.com/cel2-rollup-files/alfajores/deployment-l1.json
const celoAlfajores = /*#__PURE__*/ defineChain({
    ...chainConfig$1,
    id: 44_787,
    name: 'Alfajores',
    nativeCurrency: {
        decimals: 18,
        name: 'CELO',
        symbol: 'A-CELO',
    },
    rpcUrls: {
        default: {
            http: ['https://alfajores-forno.celo-testnet.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Celo Alfajores Explorer',
            url: 'https://celo-alfajores.blockscout.com',
            apiUrl: 'https://celo-alfajores.blockscout.com/api',
        },
    },
    contracts: {
        ...chainConfig$1.contracts,
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 14569001,
        },
        portal: {
            [sourceId$J]: {
                address: '0x82527353927d8D069b3B452904c942dA149BA381',
                blockCreated: 2411324,
            },
        },
        disputeGameFactory: {
            [sourceId$J]: {
                address: '0xE28AAdcd9883746c0e5068F58f9ea06027b214cb',
                blockCreated: 2411324,
            },
        },
        l2OutputOracle: {
            [sourceId$J]: {
                address: '0x4a2635e9e4f6e45817b1D402ac4904c1d1752438',
                blockCreated: 2411324,
            },
        },
        l1StandardBridge: {
            [sourceId$J]: {
                address: '0xD1B0E0581973c9eB7f886967A606b9441A897037',
                blockCreated: 2411324,
            },
        },
    },
    testnet: true,
});

const chang = /*#__PURE__*/ defineChain({
    id: 5858,
    name: 'Chang Chain Foundation Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'CTH',
        symbol: 'CTH',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.cthscan.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Chang Chain explorer',
            url: 'https://cthscan.com',
        },
    },
});

const chiliz = /*#__PURE__*/ defineChain({
    id: 88_888,
    name: 'Chiliz Chain',
    network: 'chiliz-chain',
    nativeCurrency: {
        decimals: 18,
        name: 'CHZ',
        symbol: 'CHZ',
    },
    rpcUrls: {
        default: {
            http: [
                'https://rpc.ankr.com/chiliz',
                'https://chiliz-rpc.publicnode.com',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'Chiliz Explorer',
            url: 'https://scan.chiliz.com',
            apiUrl: 'https://scan.chiliz.com/api',
        },
    },
});

const chips = /*#__PURE__*/ defineChain({
    id: 2882,
    name: 'Chips Network',
    network: 'CHIPS',
    nativeCurrency: {
        decimals: 18,
        name: 'IOTA',
        symbol: 'IOTA',
    },
    rpcUrls: {
        default: {
            http: [
                'https://node.chips.ooo/wasp/api/v1/chains/iota1pp3d3mnap3ufmgqnjsnw344sqmf5svjh26y2khnmc89sv6788y3r207a8fn/evm',
            ],
        },
    },
});

const citreaTestnet = /*#__PURE__*/ defineChain({
    id: 5115,
    name: 'Citrea Testnet',
    nativeCurrency: { name: 'cBTC', symbol: 'cBTC', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.citrea.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Citrea Explorer',
            url: 'https://explorer.testnet.citrea.xyz',
            apiUrl: 'https://explorer.testnet.citrea.xyz/api',
        },
    },
    testnet: true,
});

const classic = /*#__PURE__*/ defineChain({
    id: 61,
    name: 'Ethereum Classic',
    nativeCurrency: {
        decimals: 18,
        name: 'ETC',
        symbol: 'ETC',
    },
    rpcUrls: {
        default: { http: ['https://etc.rivet.link'] },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://blockscout.com/etc/mainnet',
        },
    },
});

const coinbit = /*#__PURE__*/ defineChain({
    id: 112,
    name: 'Coinbit Mainnet',
    nativeCurrency: { name: 'GIDR', symbol: 'GIDR', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://coinbit-rpc-mainnet.chain.sbcrypto.app'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Coinbit Explorer',
            url: 'https://coinbit-explorer.chain.sbcrypto.app',
        },
    },
    testnet: false,
});

const coinex = /*#__PURE__*/ defineChain({
    id: 52,
    name: 'CoinEx Mainnet',
    nativeCurrency: { name: 'cet', symbol: 'cet', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.coinex.net'],
        },
    },
    blockExplorers: {
        default: {
            name: 'CoinEx Explorer',
            url: 'https://www.coinex.net',
        },
    },
    testnet: false,
});

const confluxESpace = /*#__PURE__*/ defineChain({
    id: 1_030,
    name: 'Conflux eSpace',
    nativeCurrency: { name: 'Conflux', symbol: 'CFX', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://evm.confluxrpc.com'],
            webSocket: ['wss://evm.confluxrpc.com/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'ConfluxScan',
            url: 'https://evm.confluxscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xEFf0078910f638cd81996cc117bccD3eDf2B072F',
            blockCreated: 68602935,
        },
    },
});

const confluxESpaceTestnet = /*#__PURE__*/ defineChain({
    id: 71,
    name: 'Conflux eSpace Testnet',
    network: 'cfx-espace-testnet',
    testnet: true,
    nativeCurrency: { name: 'Conflux', symbol: 'CFX', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://evmtestnet.confluxrpc.com'],
            webSocket: ['wss://evmtestnet.confluxrpc.com/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'ConfluxScan',
            url: 'https://evmtestnet.confluxscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xEFf0078910f638cd81996cc117bccD3eDf2B072F',
            blockCreated: 117499050,
        },
    },
});

const coreDao = /*#__PURE__*/ defineChain({
    id: 1116,
    name: 'Core Dao',
    nativeCurrency: {
        decimals: 18,
        name: 'Core',
        symbol: 'CORE',
    },
    rpcUrls: {
        default: { http: ['https://rpc.coredao.org'] },
    },
    blockExplorers: {
        default: {
            name: 'CoreDao',
            url: 'https://scan.coredao.org',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 11_907_934,
        },
    },
    testnet: false,
});

const sourceId$I = 1; // mainnet
const corn = /*#__PURE__*/ defineChain({
    id: 21_000_000,
    name: 'Corn',
    nativeCurrency: {
        decimals: 18,
        name: 'Bitcorn',
        symbol: 'BTCN',
    },
    rpcUrls: {
        default: { http: ['https://rpc.ankr.com/corn_maizenet'] },
    },
    blockExplorers: {
        default: {
            name: 'Corn Explorer',
            url: 'https://cornscan.io',
            apiUrl: 'https://api.routescan.io/v2/network/mainnet/evm/21000000/etherscan/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 3228,
        },
    },
    sourceId: sourceId$I,
});

const sourceId$H = 11_155_111; // sepolia
const cornTestnet = /*#__PURE__*/ defineChain({
    id: 21_000_001,
    name: 'Corn Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Bitcorn',
        symbol: 'BTCN',
    },
    rpcUrls: {
        default: { http: ['https://rpc.ankr.com/corn_testnet'] },
    },
    blockExplorers: {
        default: {
            name: 'Corn Testnet Explorer',
            url: 'https://testnet.cornscan.io',
            apiUrl: 'https://api.routescan.io/v2/network/testnet/evm/21000001/etherscan/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 4886,
        },
    },
    testnet: true,
    sourceId: sourceId$H,
});

const crab = defineChain({
    id: 44,
    name: 'Crab Network',
    nativeCurrency: {
        decimals: 18,
        name: 'Crab Network Native Token',
        symbol: 'CRAB',
    },
    rpcUrls: {
        default: {
            http: ['https://crab-rpc.darwinia.network'],
            webSocket: ['wss://crab-rpc.darwinia.network'],
        },
    },
    blockExplorers: {
        default: { name: 'Blockscout', url: 'https://crab-scan.darwinia.network' },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 3032593,
        },
    },
});

const creatorTestnet = defineChain({
    id: 66665,
    name: 'Creator',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.creatorchain.io'],
        },
    },
    blockExplorers: {
        default: { name: 'Explorer', url: 'https://explorer.creatorchain.io' },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
        },
    },
    testnet: true,
});

const creditCoin3Mainnet = /*#__PURE__*/ defineChain({
    id: 102030,
    name: 'Creditcoin3 Mainnet',
    nativeCurrency: { name: 'Creditcoin3 Mainnet', symbol: 'CTC', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet3.creditcoin.network'],
            webSocket: ['wss://mainnet3.creditcoin.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://creditcoin.blockscout.com',
            apiUrl: 'https://creditcoin.blockscout.com/api',
        },
    },
    testnet: false,
});

const creditCoin3Testnet = /*#__PURE__*/ defineChain({
    id: 102031,
    name: 'Creditcoin3 Testnet',
    nativeCurrency: { name: 'Creditcoin3 Testnet', symbol: 'TCTC', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.cc3-testnet.creditcoin.network'],
            webSocket: ['wss://rpc.cc3-testnet.creditcoin.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://creditcoin-testnet.blockscout.com',
            apiUrl: 'https://creditcoin-testnet.blockscout.com/api',
        },
    },
    testnet: true,
});

const cronos = /*#__PURE__*/ defineChain({
    id: 25,
    name: 'Cronos Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Cronos',
        symbol: 'CRO',
    },
    rpcUrls: {
        default: { http: ['https://evm.cronos.org'] },
    },
    blockExplorers: {
        default: {
            name: 'Cronos Explorer',
            url: 'https://explorer.cronos.org',
            apiUrl: 'https://explorer-api.cronos.org/mainnet/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 1963112,
        },
    },
});

const cronosTestnet = /*#__PURE__*/ defineChain({
    id: 338,
    name: 'Cronos Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'CRO',
        symbol: 'tCRO',
    },
    rpcUrls: {
        default: { http: ['https://evm-t3.cronos.org'] },
    },
    blockExplorers: {
        default: {
            name: 'Cronos Explorer',
            url: 'https://cronos.org/explorer/testnet3',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 10191251,
        },
    },
    testnet: true,
});

const cronoszkEVM = /*#__PURE__*/ defineChain({
    id: 388,
    name: 'Cronos zkEVM Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Cronos zkEVM CRO',
        symbol: 'zkCRO',
    },
    rpcUrls: {
        default: { http: ['https://mainnet.zkevm.cronos.org'] },
    },
    blockExplorers: {
        default: {
            name: 'Cronos zkEVM (Mainnet) Chain Explorer',
            url: 'https://explorer.zkevm.cronos.org',
        },
    },
    contracts: {
        multicall3: {
            address: '0x06f4487d7c4a5983d2660db965cc6d2565e4cfaa',
            blockCreated: 72,
        },
    },
});

const cronoszkEVMTestnet = /*#__PURE__*/ defineChain({
    id: 282,
    name: 'Cronos zkEVM Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Cronos zkEVM Test Coin',
        symbol: 'zkTCRO',
    },
    rpcUrls: {
        default: { http: ['https://testnet.zkevm.cronos.org'] },
    },
    blockExplorers: {
        default: {
            name: 'Cronos zkEVM Testnet Explorer',
            url: 'https://explorer.zkevm.cronos.org/testnet',
        },
    },
    testnet: true,
});

const crossbell = /*#__PURE__*/ defineChain({
    id: 3_737,
    name: 'Crossbell',
    nativeCurrency: {
        decimals: 18,
        name: 'CSB',
        symbol: 'CSB',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.crossbell.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'CrossScan',
            url: 'https://scan.crossbell.io',
            apiUrl: 'https://scan.crossbell.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 38_246_031,
        },
    },
});

const curtis = /*#__PURE__*/ defineChain({
    id: 33_111,
    name: 'Curtis',
    nativeCurrency: { name: 'ApeCoin', symbol: 'APE', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.curtis.apechain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Curtis Explorer',
            url: 'https://explorer.curtis.apechain.com',
        },
    },
    testnet: true,
});

const cyber = /*#__PURE__*/ defineChain({
    id: 7_560,
    name: 'Cyber',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://cyber.alt.technology'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://cyberscan.co',
            apiUrl: 'https://cyberscan.co/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 0,
        },
    },
});

const cyberTestnet = /*#__PURE__*/ defineChain({
    id: 111_557_560,
    name: 'Cyber Testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://cyber-testnet.alt.technology'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://testnet.cyberscan.co',
            apiUrl: 'https://testnet.cyberscan.co/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xffc391F0018269d4758AEA1a144772E8FB99545E',
            blockCreated: 304545,
        },
    },
    testnet: true,
});

const dailyNetwork = /*#__PURE__*/ defineChain({
    id: 824,
    name: 'Daily Network Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Daily',
        symbol: 'DLY',
    },
    rpcUrls: {
        default: { http: ['https://rpc.mainnet.dailycrypto.net'] },
    },
    blockExplorers: {
        default: {
            name: 'Daily Mainnet Explorer',
            url: 'https://explorer.mainnet.dailycrypto.net',
        },
    },
    testnet: false,
});

const dailyNetworkTestnet = /*#__PURE__*/ defineChain({
    id: 825,
    name: 'Daily Network Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Daily',
        symbol: 'DLY',
    },
    rpcUrls: {
        default: { http: ['https://rpc.testnet.dailycrypto.net'] },
    },
    blockExplorers: {
        default: {
            name: 'Daily Testnet Explorer',
            url: 'https://explorer.testnet.dailycrypto.net',
        },
    },
    testnet: true,
});

const darwinia = /*#__PURE__*/ defineChain({
    id: 46,
    name: 'Darwinia Network',
    nativeCurrency: {
        decimals: 18,
        name: 'RING',
        symbol: 'RING',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.darwinia.network'],
            webSocket: ['wss://rpc.darwinia.network'],
        },
    },
    blockExplorers: {
        default: { name: 'Explorer', url: 'https://explorer.darwinia.network' },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 69420,
        },
    },
});

const dchain = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 2716446429837000,
    name: 'Dchain',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://dchain-2716446429837000-1.jsonrpc.sagarpc.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Dchain Explorer',
            url: 'https://dchain-2716446429837000-1.sagaexplorer.io',
            apiUrl: 'https://api-dchain-2716446429837000-1.sagaexplorer.io/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
    },
});

const dchainTestnet = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 2713017997578000,
    name: 'Dchain Testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: [
                'https://dchaintestnet-2713017997578000-1.jsonrpc.testnet.sagarpc.io',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'Dchain Explorer',
            url: 'https://dchaintestnet-2713017997578000-1.testnet.sagaexplorer.io',
            apiUrl: 'https://api-dchaintestnet-2713017997578000-1.testnet.sagaexplorer.io/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
    },
});

const defichainEvm = /*#__PURE__*/ defineChain({
    id: 1130,
    network: 'defichain-evm',
    name: 'DeFiChain EVM Mainnet',
    nativeCurrency: {
        name: 'DeFiChain',
        symbol: 'DFI',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://eth.mainnet.ocean.jellyfishsdk.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'DeFiScan',
            url: 'https://meta.defiscan.live',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 137852,
        },
    },
});

const defichainEvmTestnet = /*#__PURE__*/ defineChain({
    id: 1131,
    network: 'defichain-evm-testnet',
    name: 'DeFiChain EVM Testnet',
    nativeCurrency: {
        name: 'DeFiChain',
        symbol: 'DFI',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://eth.testnet.ocean.jellyfishsdk.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'DeFiScan',
            url: 'https://meta.defiscan.live/?network=TestNet',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 156462,
        },
    },
    testnet: true,
});

const degen = /*#__PURE__*/ defineChain({
    id: 666666666,
    name: 'Degen',
    nativeCurrency: {
        decimals: 18,
        name: 'Degen',
        symbol: 'DEGEN',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.degen.tips'],
            webSocket: ['wss://rpc.degen.tips'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Degen Chain Explorer',
            url: 'https://explorer.degen.tips',
            apiUrl: 'https://explorer.degen.tips/api/v2',
        },
    },
});

const dfk = /*#__PURE__*/ defineChain({
    id: 53_935,
    name: 'DFK Chain',
    nativeCurrency: {
        decimals: 18,
        name: 'Jewel',
        symbol: 'JEWEL',
    },
    rpcUrls: {
        default: {
            http: ['https://subnets.avax.network/defi-kingdoms/dfk-chain/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'DFKSubnetScan',
            url: 'https://subnets.avax.network/defi-kingdoms',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 14790551,
        },
    },
});

const diode = /*#__PURE__*/ defineChain({
    id: 15,
    name: 'Diode Prenet',
    nativeCurrency: {
        decimals: 18,
        name: 'DIODE',
        symbol: 'DIODE',
    },
    rpcUrls: {
        default: {
            http: ['https://prenet.diode.io:8443'],
            webSocket: ['wss://prenet.diode.io:8443/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Diode Explorer',
            url: 'https://diode.io/prenet',
        },
    },
    testnet: false,
});

const disChain = /*#__PURE__*/ defineChain({
    id: 513100,
    name: 'DisChain',
    nativeCurrency: {
        decimals: 18,
        name: 'DIS',
        symbol: 'DIS',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.dischain.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'DisChain Explorer',
            url: 'https://www.oklink.com/dis',
        },
    },
});

const dodochainTestnet = defineChain({
    id: 53457,
    name: 'DODOchain Testnet',
    nativeCurrency: { decimals: 18, name: 'DODO', symbol: 'DODO' },
    rpcUrls: {
        default: {
            http: ['https://dodochain-testnet.alt.technology'],
            webSocket: ['wss://dodochain-testnet.alt.technology/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'DODOchain Testnet (Sepolia) Explorer',
            url: 'https://testnet-scan.dodochain.com',
        },
    },
    testnet: true,
});

const dogechain = /*#__PURE__*/ defineChain({
    id: 2_000,
    name: 'Dogechain',
    nativeCurrency: {
        decimals: 18,
        name: 'Wrapped Dogecoin',
        symbol: 'WDOGE',
    },
    rpcUrls: {
        default: { http: ['https://rpc.dogechain.dog'] },
    },
    blockExplorers: {
        default: {
            name: 'DogeChainExplorer',
            url: 'https://explorer.dogechain.dog',
            apiUrl: 'https://explorer.dogechain.dog/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0x68a8609a60a008EFA633dfdec592c03B030cC508',
            blockCreated: 25384031,
        },
    },
});

const donatuz = /*#__PURE__*/ defineChain({
    id: 42_026,
    name: 'Donatuz',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['ttps://rpc.donatuz.com'] },
    },
    blockExplorers: {
        default: {
            name: 'Donatuz Explorer',
            url: 'https://explorer.donatuz.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 0,
        },
    },
});

const dosChain = /*#__PURE__*/ defineChain({
    id: 7979,
    name: 'DOS Chain',
    nativeCurrency: {
        decimals: 18,
        name: 'DOS Chain',
        symbol: 'DOS',
    },
    rpcUrls: {
        default: { http: ['https://main.doschain.com'] },
    },
    blockExplorers: {
        default: {
            name: 'DOS Chain Explorer',
            url: 'https://doscan.io',
            apiUrl: 'https://api.doscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 161908,
        },
    },
});

const dosChainTestnet = /*#__PURE__*/ defineChain({
    id: 3939,
    name: 'DOS Chain Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'DOS Chain Testnet',
        symbol: 'DOS',
    },
    rpcUrls: {
        default: { http: ['https://test.doschain.com'] },
    },
    blockExplorers: {
        default: {
            name: 'DOS Chain Testnet Explorer',
            url: 'https://test.doscan.io',
            apiUrl: 'https://api-test.doscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 69623,
        },
    },
    testnet: true,
});

const dreyerxMainnet = /*#__PURE__*/ defineChain({
    id: 23451,
    name: 'DreyerX Mainnet',
    nativeCurrency: {
        name: 'DreyerX',
        symbol: 'DRX',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.dreyerx.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'DreyerX Scan',
            url: 'https://scan.dreyerx.com',
        },
    },
});

const dreyerxTestnet = /*#__PURE__*/ defineChain({
    id: 23452,
    name: 'DreyerX Testnet',
    nativeCurrency: {
        name: 'DreyerX',
        symbol: 'DRX',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['http://testnet-rpc.dreyerx.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'DreyerX Testnet Scan',
            url: 'https://testnet-scan.dreyerx.com',
        },
    },
    testnet: true,
});

const dustboyIoT = /*#__PURE__*/ defineChain({
    id: 555888,
    name: 'DustBoy IoT',
    nativeCurrency: { name: 'Ether', symbol: 'DST', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://dustboy-rpc.jibl2.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://dustboy.jibl2.com',
            apiUrl: 'https://dustboy.jibl2.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xFFD34aa2C62B2D52E00A361e466C229788f4eD6a',
            blockCreated: 526569,
        },
    },
    testnet: false,
});

const dymension = /*#__PURE__*/ defineChain({
    id: 1100,
    name: 'Dymension',
    nativeCurrency: {
        name: 'DYM',
        symbol: 'DYM',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://dymension-evm-rpc.publicnode.com'],
            webSocket: ['wss://dymension-evm-rpc.publicnode.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Dym FYI',
            url: 'https://dym.fyi',
        },
    },
    testnet: false,
});

const edgeless = /*#__PURE__*/ defineChain({
    id: 2_026,
    name: 'Edgeless Network',
    nativeCurrency: {
        name: 'Edgeless Wrapped ETH',
        symbol: 'EwETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.edgeless.network/http'],
            webSocket: ['wss://rpc.edgeless.network/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Edgeless Explorer',
            url: 'https://explorer.edgeless.network',
        },
    },
});

const edgelessTestnet = /*#__PURE__*/ defineChain({
    id: 202,
    name: 'Edgeless Testnet',
    nativeCurrency: {
        name: 'Edgeless Wrapped ETH',
        symbol: 'EwETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://edgeless-testnet.rpc.caldera.xyz/http'],
            webSocket: ['wss://edgeless-testnet.rpc.caldera.xyz/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Edgeless Testnet Explorer',
            url: 'https://testnet.explorer.edgeless.network',
        },
    },
});

const edgeware = /*#__PURE__*/ defineChain({
    id: 2021,
    name: 'Edgeware EdgeEVM Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Edgeware',
        symbol: 'EDG',
    },
    rpcUrls: {
        default: { http: ['https://edgeware-evm.jelliedowl.net'] },
    },
    blockExplorers: {
        default: {
            name: 'Edgscan by Bharathcoorg',
            url: 'https://edgscan.live',
            apiUrl: 'https://edgscan.live/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 18117872,
        },
    },
});

const edgewareTestnet = /*#__PURE__*/ defineChain({
    id: 2022,
    name: 'Beresheet BereEVM Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Testnet EDG',
        symbol: 'tEDG',
    },
    rpcUrls: {
        default: { http: ['https://beresheet-evm.jelliedowl.net'] },
    },
    blockExplorers: {
        default: {
            name: 'Edgscan by Bharathcoorg',
            url: 'https://testnet.edgscan.live',
            apiUrl: 'https://testnet.edgscan.live/api',
        },
    },
});

const ekta = /*#__PURE__*/ defineChain({
    id: 1994,
    name: 'Ekta',
    nativeCurrency: {
        decimals: 18,
        name: 'EKTA',
        symbol: 'EKTA',
    },
    rpcUrls: {
        default: { http: ['https://main.ekta.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Ektascan',
            url: 'https://ektascan.io',
            apiUrl: 'https://ektascan.io/api',
        },
    },
});

const ektaTestnet = /*#__PURE__*/ defineChain({
    id: 1004,
    name: 'Ekta Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'EKTA',
        symbol: 'EKTA',
    },
    rpcUrls: {
        default: { http: ['https://test.ekta.io:8545'] },
    },
    blockExplorers: {
        default: {
            name: 'Test Ektascan',
            url: 'https://test.ektascan.io',
            apiUrl: 'https://test.ektascan.io/api',
        },
    },
    testnet: true,
});

const elastos = /*#__PURE__*/ defineChain({
    id: 20,
    name: 'Elastos Smart Chain',
    nativeCurrency: { name: 'ELA', symbol: 'ELA', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://api2.elastos.io/eth'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Elastos Explorer',
            url: 'https://esc.elastos.io',
        },
    },
    testnet: false,
});

const elastosTestnet = /*#__PURE__*/ defineChain({
    id: 21,
    name: 'Elastos Smart Chain Testnet',
    nativeCurrency: { name: 'tELA', symbol: 'tELA', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://api-testnet.elastos.io/eth'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Elastos Explorer',
            url: 'https://esc-testnet.elastos.io',
        },
    },
    testnet: true,
});

const electroneum = /*#__PURE__*/ defineChain({
    id: 52014,
    name: 'Electroneum Mainnet',
    nativeCurrency: {
        name: 'ETN',
        symbol: 'ETN',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.electroneum.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Electroneum Block Explorer',
            url: 'https://blockexplorer.electroneum.com',
        },
    },
    testnet: false,
});

const electroneumTestnet = /*#__PURE__*/ defineChain({
    id: 5201420,
    name: 'Electroneum Testnet',
    nativeCurrency: {
        name: 'ETN',
        symbol: 'ETN',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://testnet-rpc.electroneum.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Electroneum Block Explorer',
            url: 'https://blockexplorer.thesecurityteam.rocks',
        },
    },
    testnet: true,
});

const elysiumTestnet = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 1338,
    name: 'Elysium Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'LAVA',
        symbol: 'LAVA',
    },
    rpcUrls: {
        default: {
            http: ['https://elysium-test-rpc.vulcanforged.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Elysium testnet explorer',
            url: 'https://elysium-explorer.vulcanforged.com',
        },
    },
    testnet: true,
});

const energy = /*#__PURE__*/ defineChain({
    id: 246,
    name: 'Energy Mainnet',
    nativeCurrency: { name: 'EWT', symbol: 'EWT', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.energyweb.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'EnergyWeb Explorer',
            url: 'https://explorer.energyweb.org',
        },
    },
    testnet: false,
});

const enuls = /*#__PURE__*/ defineChain({
    id: 119,
    name: 'ENULS Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'NULS',
        symbol: 'NULS',
    },
    rpcUrls: {
        default: { http: ['https://evmapi2.nuls.io'] },
    },
    blockExplorers: {
        default: {
            name: 'ENULS Explorer',
            url: 'https://evmscan.nuls.io',
        },
    },
    testnet: false,
});

const eon = /*#__PURE__*/ defineChain({
    id: 7_332,
    name: 'Horizen EON',
    nativeCurrency: {
        decimals: 18,
        name: 'ZEN',
        symbol: 'ZEN',
    },
    rpcUrls: {
        default: { http: ['https://eon-rpc.horizenlabs.io/ethv1'] },
    },
    blockExplorers: {
        default: {
            name: 'EON Explorer',
            url: 'https://eon-explorer.horizenlabs.io',
        },
    },
    contracts: {},
});

const eos = /*#__PURE__*/ defineChain({
    id: 17777,
    name: 'EOS EVM',
    nativeCurrency: {
        decimals: 18,
        name: 'EOS',
        symbol: 'EOS',
    },
    rpcUrls: {
        default: { http: ['https://api.evm.eosnetwork.com'] },
    },
    blockExplorers: {
        default: {
            name: 'EOS EVM Explorer',
            url: 'https://explorer.evm.eosnetwork.com',
            apiUrl: 'https://explorer.evm.eosnetwork.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 7943933,
        },
    },
});

const eosTestnet = /*#__PURE__*/ defineChain({
    id: 15557,
    name: 'EOS EVM Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'EOS',
        symbol: 'EOS',
    },
    rpcUrls: {
        default: { http: ['https://api.testnet.evm.eosnetwork.com'] },
    },
    blockExplorers: {
        default: {
            name: 'EOS EVM Testnet Explorer',
            url: 'https://explorer.testnet.evm.eosnetwork.com',
            apiUrl: 'https://explorer.testnet.evm.eosnetwork.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 9067940,
        },
    },
    testnet: true,
});

const etherlink = /*#__PURE__*/ defineChain({
    id: 42793,
    name: 'Etherlink',
    nativeCurrency: {
        decimals: 18,
        name: 'Tez',
        symbol: 'XTZ',
    },
    rpcUrls: {
        default: { http: ['https://node.mainnet.etherlink.com'] },
    },
    blockExplorers: {
        default: {
            name: 'Etherlink',
            url: 'https://explorer.etherlink.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 33899,
        },
    },
});

const etherlinkTestnet = /*#__PURE__*/ defineChain({
    id: 128123,
    name: 'Etherlink Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Tez',
        symbol: 'XTZ',
    },
    rpcUrls: {
        default: { http: ['https://node.ghostnet.etherlink.com'] },
    },
    blockExplorers: {
        default: {
            name: 'Etherlink Testnet',
            url: 'https://testnet-explorer.etherlink.com',
        },
    },
    testnet: true,
});

const etp = /*#__PURE__*/ defineChain({
    id: 20_256_789,
    name: 'ETP Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'ETP Chain Native Token',
        symbol: 'ETP',
    },
    rpcUrls: {
        default: { http: ['https://rpc.etpscan.xyz'] },
    },
    blockExplorers: {
        default: {
            name: 'ETP Scan',
            url: 'https://etpscan.xyz',
        },
    },
});

const evmos = /*#__PURE__*/ defineChain({
    id: 9_001,
    name: 'Evmos',
    nativeCurrency: {
        decimals: 18,
        name: 'Evmos',
        symbol: 'EVMOS',
    },
    rpcUrls: {
        default: { http: ['https://eth.bd.evmos.org:8545'] },
    },
    blockExplorers: {
        default: {
            name: 'Evmos Block Explorer',
            url: 'https://escan.live',
        },
    },
});

const evmosTestnet = /*#__PURE__*/ defineChain({
    id: 9_000,
    name: 'Evmos Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Evmos',
        symbol: 'EVMOS',
    },
    rpcUrls: {
        default: { http: ['https://eth.bd.evmos.dev:8545'] },
    },
    blockExplorers: {
        default: {
            name: 'Evmos Testnet Block Explorer',
            url: 'https://evm.evmos.dev/',
        },
    },
});

const excelonMainnet = /*#__PURE__*/ defineChain({
    id: 22052002,
    name: 'Excelon Mainnet',
    network: 'XLON',
    nativeCurrency: {
        decimals: 18,
        name: 'Excelon',
        symbol: 'xlon',
    },
    rpcUrls: {
        default: {
            http: ['https://edgewallet1.xlon.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Excelon explorer',
            url: 'https://explorer.excelon.io',
        },
    },
});

const expanse = /*#__PURE__*/ defineChain({
    id: 2,
    name: 'Expanse Network',
    nativeCurrency: {
        decimals: 18,
        name: 'EXP',
        symbol: 'EXP',
    },
    rpcUrls: {
        default: { http: ['https://node.expanse.tech'] },
    },
    blockExplorers: {
        default: {
            name: 'Expanse Explorer',
            url: 'https://explorer.expanse.tech',
        },
    },
    testnet: false,
});

const exsat = /*#__PURE__*/ defineChain({
    id: 7200,
    name: 'exSat Network',
    nativeCurrency: {
        decimals: 18,
        name: 'BTC',
        symbol: 'BTC',
    },
    rpcUrls: {
        default: { http: ['https://evm.exsat.network'] },
    },
    blockExplorers: {
        default: {
            name: 'exSat Explorer',
            url: 'https://scan.exsat.network',
            apiUrl: 'https://scan.exsat.network/api',
        },
    },
});

const exsatTestnet = /*#__PURE__*/ defineChain({
    id: 839999,
    name: 'exSat Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'BTC',
        symbol: 'BTC',
    },
    rpcUrls: {
        default: { http: ['https://evm-tst3.exsat.network'] },
    },
    blockExplorers: {
        default: {
            name: 'exSat Explorer',
            url: 'https://scan-testnet.exsat.network',
            apiUrl: 'https://scan-testnet.exsat.network/api',
        },
    },
});

const fantom = /*#__PURE__*/ defineChain({
    id: 250,
    name: 'Fantom',
    nativeCurrency: {
        decimals: 18,
        name: 'Fantom',
        symbol: 'FTM',
    },
    rpcUrls: {
        default: { http: ['https://rpc.ankr.com/fantom'] },
    },
    blockExplorers: {
        default: {
            name: 'FTMScan',
            url: 'https://ftmscan.com',
            apiUrl: 'https://api.ftmscan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 33001987,
        },
    },
});

const fantomSonicTestnet = /*#__PURE__*/ defineChain({
    id: 64_240,
    name: 'Fantom Sonic Open Testnet',
    network: 'fantom-sonic-testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Fantom',
        symbol: 'FTM',
    },
    rpcUrls: {
        default: { http: ['https://rpcapi.sonic.fantom.network'] },
    },
    blockExplorers: {
        default: {
            name: 'Fantom Sonic Open Testnet Explorer',
            url: 'https://public-sonic.fantom.network',
        },
    },
    testnet: true,
});

const fantomTestnet = /*#__PURE__*/ defineChain({
    id: 4_002,
    name: 'Fantom Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Fantom',
        symbol: 'FTM',
    },
    rpcUrls: {
        default: { http: ['https://rpc.testnet.fantom.network'] },
    },
    blockExplorers: {
        default: {
            name: 'FTMScan',
            url: 'https://testnet.ftmscan.com',
            apiUrl: 'https://testnet.ftmscan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 8328688,
        },
    },
    testnet: true,
});

const fibo = /*#__PURE__*/ defineChain({
    id: 12306,
    name: 'Fibo Chain',
    nativeCurrency: {
        decimals: 18,
        name: 'fibo',
        symbol: 'FIBO',
    },
    rpcUrls: {
        default: { http: ['https://network.hzroc.art'] },
    },
    blockExplorers: {
        default: {
            name: 'FiboScan',
            url: 'https://scan.fibochain.org',
        },
    },
});

const filecoin = /*#__PURE__*/ defineChain({
    id: 314,
    name: 'Filecoin Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'filecoin',
        symbol: 'FIL',
    },
    rpcUrls: {
        default: { http: ['https://api.node.glif.io/rpc/v1'] },
    },
    blockExplorers: {
        default: {
            name: 'Filfox',
            url: 'https://filfox.info/en',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 3328594,
        },
    },
});

const filecoinCalibration = /*#__PURE__*/ defineChain({
    id: 314_159,
    name: 'Filecoin Calibration',
    nativeCurrency: {
        decimals: 18,
        name: 'testnet filecoin',
        symbol: 'tFIL',
    },
    rpcUrls: {
        default: { http: ['https://api.calibration.node.glif.io/rpc/v1'] },
    },
    blockExplorers: {
        default: {
            name: 'Filscan',
            url: 'https://calibration.filscan.io',
        },
    },
    testnet: true,
});

const filecoinHyperspace = /*#__PURE__*/ defineChain({
    id: 314_1,
    name: 'Filecoin Hyperspace',
    nativeCurrency: {
        decimals: 18,
        name: 'testnet filecoin',
        symbol: 'tFIL',
    },
    rpcUrls: {
        default: { http: ['https://api.hyperspace.node.glif.io/rpc/v1'] },
    },
    blockExplorers: {
        default: {
            name: 'Filfox',
            url: 'https://hyperspace.filfox.info/en',
        },
    },
    testnet: true,
});

const fireChain = /*#__PURE__*/ defineChain({
    id: 995,
    name: '5ireChain',
    nativeCurrency: { name: '5ire Token', symbol: '5IRE', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.5ire.network'],
        },
    },
    blockExplorers: {
        default: {
            name: '5ireChain Mainnet Explorer',
            url: 'https://5irescan.io/',
        },
    },
    testnet: false,
});

const flare = /*#__PURE__*/ defineChain({
    id: 14,
    name: 'Flare Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Flare',
        symbol: 'FLR',
    },
    rpcUrls: {
        default: { http: ['https://flare-api.flare.network/ext/C/rpc'] },
    },
    blockExplorers: {
        default: {
            name: 'Flare Explorer',
            url: 'https://flare-explorer.flare.network',
            apiUrl: 'https://flare-explorer.flare.network/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 3002461,
        },
    },
});

const flareTestnet = /*#__PURE__*/ defineChain({
    id: 114,
    name: 'Flare Testnet Coston2',
    nativeCurrency: {
        decimals: 18,
        name: 'Coston2 Flare',
        symbol: 'C2FLR',
    },
    rpcUrls: {
        default: { http: ['https://coston2-api.flare.network/ext/C/rpc'] },
    },
    blockExplorers: {
        default: {
            name: 'Coston2 Explorer',
            url: 'https://coston2-explorer.flare.network',
            apiUrl: 'https://coston2-explorer.flare.network/api',
        },
    },
    testnet: true,
});

const flowMainnet = /*#__PURE__*/ defineChain({
    id: 747,
    name: 'Flow EVM Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Flow',
        symbol: 'FLOW',
    },
    rpcUrls: {
        default: {
            http: ['https://mainnet.evm.nodes.onflow.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Mainnet Explorer',
            url: 'https://evm.flowscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 6205,
        },
    },
});

const flowPreviewnet = /*#__PURE__*/ defineChain({
    id: 646,
    name: 'Flow EVM Previewnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Flow',
        symbol: 'FLOW',
    },
    rpcUrls: {
        default: {
            http: ['https://previewnet.evm.nodes.onflow.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Previewnet Explorer',
            url: 'https://previewnet.flowdiver.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 6205,
        },
    },
});

const flowTestnet = /*#__PURE__*/ defineChain({
    id: 545,
    name: 'Flow EVM Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Flow',
        symbol: 'FLOW',
    },
    rpcUrls: {
        default: {
            http: ['https://testnet.evm.nodes.onflow.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Flow Diver',
            url: 'https://evm-testnet.flowscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 137518,
        },
    },
    testnet: true,
});

const fluence = /*#__PURE__*/ defineChain({
    id: 9_999_999,
    name: 'Fluence',
    nativeCurrency: { name: 'FLT', symbol: 'FLT', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.mainnet.fluence.dev'],
            webSocket: ['wss://ws.mainnet.fluence.dev'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://blockscout.mainnet.fluence.dev',
            apiUrl: 'https://blockscout.mainnet.fluence.dev/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 207583,
        },
    },
});

const fluenceStage = /*#__PURE__*/ defineChain({
    id: 123_420_000_220,
    name: 'Fluence Stage',
    nativeCurrency: { name: 'tFLT', symbol: 'tFLT', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.stage.fluence.dev'],
            webSocket: ['wss://ws.stage.fluence.dev'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://blockscout.stage.fluence.dev',
            apiUrl: 'https://blockscout.stage.fluence.dev/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 83227,
        },
    },
    testnet: true,
});

const fluenceTestnet = /*#__PURE__*/ defineChain({
    id: 52_164_803,
    name: 'Fluence Testnet',
    nativeCurrency: { name: 'tFLT', symbol: 'tFLT', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.fluence.dev'],
            webSocket: ['wss://ws.testnet.fluence.dev'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://blockscout.testnet.fluence.dev',
            apiUrl: 'https://blockscout.testnet.fluence.dev/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 96424,
        },
    },
    testnet: true,
});

const forma = /*#__PURE__*/ defineChain({
    id: 984122,
    name: 'Forma',
    network: 'forma',
    nativeCurrency: {
        symbol: 'TIA',
        name: 'TIA',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.forma.art'],
            webSocket: ['wss://ws.forma.art'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Forma Explorer',
            url: 'https://explorer.forma.art',
        },
    },
    contracts: {
        multicall3: {
            address: '0xd53C6FFB123F7349A32980F87faeD8FfDc9ef079',
            blockCreated: 252705,
        },
    },
});

const forta = /*#__PURE__*/ defineChain({
    id: 80_931,
    name: 'Forta Chain',
    nativeCurrency: {
        symbol: 'FORT',
        name: 'FORT',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc-forta-chain-8gj1qndmfc.t.conduit.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Forta Explorer',
            url: 'https://explorer.forta.org',
        },
    },
});

const foundry = /*#__PURE__*/ defineChain({
    id: 31_337,
    name: 'Foundry',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['http://127.0.0.1:8545'],
            webSocket: ['ws://127.0.0.1:8545'],
        },
    },
});

const sourceId$G = 1; // mainnet
const fraxtal = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 252,
    name: 'Fraxtal',
    nativeCurrency: { name: 'Frax Ether', symbol: 'frxETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.frax.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'fraxscan',
            url: 'https://fraxscan.com',
            apiUrl: 'https://api.fraxscan.com/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$G]: {
                address: '0x66CC916Ed5C6C2FA97014f7D1cD141528Ae171e4',
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
        },
        portal: {
            [sourceId$G]: {
                address: '0x36cb65c1967A0Fb0EEE11569C51C2f2aA1Ca6f6D',
                blockCreated: 19135323,
            },
        },
        l1StandardBridge: {
            [sourceId$G]: {
                address: '0x34C0bD5877A5Ee7099D0f5688D65F4bB9158BDE2',
                blockCreated: 19135323,
            },
        },
    },
    sourceId: sourceId$G,
});

const sourceId$F = 17000; // holesky
const fraxtalTestnet = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 2522,
    name: 'Fraxtal Testnet',
    nativeCurrency: { name: 'Frax Ether', symbol: 'frxETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.frax.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'fraxscan testnet',
            url: 'https://holesky.fraxscan.com',
            apiUrl: 'https://api-holesky.fraxscan.com/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$F]: {
                address: '0x715EA64DA13F4d0831ece4Ad3E8c1aa013167F32',
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
        },
        portal: {
            [sourceId$F]: {
                address: '0xB9c64BfA498d5b9a8398Ed6f46eb76d90dE5505d',
                blockCreated: 318416,
            },
        },
        l1StandardBridge: {
            [sourceId$F]: {
                address: '0x0BaafC217162f64930909aD9f2B27125121d6332',
                blockCreated: 318416,
            },
        },
    },
    sourceId: sourceId$F,
});

const sourceId$E = 1; // mainnet
const funkiMainnet = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 33979,
    name: 'Funki',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-mainnet.funkichain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Funki Mainnet Explorer',
            url: 'https://funkiscan.io',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
    },
    sourceId: sourceId$E,
});

const sourceId$D = 11_155_111; // sepolia
const funkiSepolia = defineChain({
    ...chainConfig$2,
    id: 3397901,
    network: 'funkiSepolia',
    name: 'Funki Sepolia Sandbox',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://funki-testnet.alt.technology'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Funki Sepolia Sandbox Explorer',
            url: 'https://sepolia-sandbox.funkichain.com/',
        },
    },
    testnet: true,
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 1620204,
        },
    },
    sourceId: sourceId$D,
});

const fuse = /*#__PURE__*/ defineChain({
    id: 122,
    name: 'Fuse',
    nativeCurrency: { name: 'Fuse', symbol: 'FUSE', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc.fuse.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Fuse Explorer',
            url: 'https://explorer.fuse.io',
            apiUrl: 'https://explorer.fuse.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 16146628,
        },
    },
});

const fuseSparknet = /*#__PURE__*/ defineChain({
    id: 123,
    name: 'Fuse Sparknet',
    nativeCurrency: { name: 'Spark', symbol: 'SPARK', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc.fusespark.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Sparkent Explorer',
            url: 'https://explorer.fusespark.io',
            apiUrl: 'https://explorer.fusespark.io/api',
        },
    },
});

const fusion = /*#__PURE__*/ defineChain({
    id: 32659,
    name: 'Fusion Mainnet',
    nativeCurrency: { name: 'Fusion', symbol: 'FSN', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.fusionnetwork.io'],
            webSocket: ['wss://mainnet.fusionnetwork.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'FSNscan',
            url: 'https://fsnscan.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 10441605,
        },
    },
    testnet: false,
});

const fusionTestnet = /*#__PURE__*/ defineChain({
    id: 46688,
    name: 'Fusion Testnet',
    nativeCurrency: { name: 'Fusion', symbol: 'FSN', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://testnet.fusionnetwork.io'],
            webSocket: ['wss://testnet.fusionnetwork.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'FSNscan',
            url: 'https://testnet.fsnscan.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 10428309,
        },
    },
    testnet: true,
});

const sourceId$C = 17000; // Holesky testnet
const garnet = defineChain({
    ...chainConfig$2,
    name: 'Garnet Testnet',
    testnet: true,
    id: 17069,
    sourceId: sourceId$C,
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.garnetchain.com'],
            webSocket: ['wss://rpc.garnetchain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://explorer.garnetchain.com',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
        },
        portal: {
            [sourceId$C]: {
                address: '0x57ee40586fbE286AfC75E67cb69511A6D9aF5909',
                blockCreated: 1274684,
            },
        },
        l2OutputOracle: {
            [sourceId$C]: {
                address: '0xCb8E7AC561b8EF04F2a15865e9fbc0766FEF569B',
                blockCreated: 1274684,
            },
        },
        l1StandardBridge: {
            [sourceId$C]: {
                address: '0x09bcDd311FE398F80a78BE37E489f5D440DB95DE',
                blockCreated: 1274684,
            },
        },
    },
});

const geist = /*#__PURE__*/ defineChain({
    id: 63157,
    name: 'Geist Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Aavegotchi GHST Token',
        symbol: 'GHST',
    },
    rpcUrls: {
        default: {
            http: ['https://geist-mainnet.g.alchemy.com/public'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://geist-mainnet.explorer.alchemy.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 660735,
        },
    },
});

const genesys = /*#__PURE__*/ defineChain({
    id: 16507,
    name: 'Genesys Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'GSYS',
        symbol: 'GSYS',
    },
    rpcUrls: {
        default: { http: ['https://rpc.genesys.network'] },
    },
    blockExplorers: {
        default: {
            name: 'Genesys Explorer',
            url: 'https://gchainexplorer.genesys.network',
        },
    },
    testnet: false,
});

const glideL1Protocol = /*#__PURE__*/ defineChain({
    id: 251,
    name: 'Glide L1 Protocol XP',
    nativeCurrency: { name: 'GLXP', symbol: 'GLXP', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-api.glideprotocol.xyz/l1-rpc'],
            webSocket: ['wss://rpc-api.glideprotocol.xyz/l1-rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Glide Protocol Explore',
            url: 'https://blockchain-explorer.glideprotocol.xyz',
        },
    },
    testnet: false,
});

const glideL2Protocol = /*#__PURE__*/ defineChain({
    id: 253,
    name: 'Glide L2 Protocol XP',
    nativeCurrency: { name: 'GLXP', symbol: 'GLXP', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-api.glideprotocol.xyz/l2-rpc'],
            webSocket: ['wss://rpc-api.glideprotocol.xyz/l2-rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Glide Protocol Explore',
            url: 'https://blockchain-explorer.glideprotocol.xyz',
        },
    },
    testnet: false,
});

const gnosis = /*#__PURE__*/ defineChain({
    id: 100,
    name: 'Gnosis',
    nativeCurrency: {
        decimals: 18,
        name: 'xDAI',
        symbol: 'XDAI',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.gnosischain.com'],
            webSocket: ['wss://rpc.gnosischain.com/wss'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Gnosisscan',
            url: 'https://gnosisscan.io',
            apiUrl: 'https://api.gnosisscan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 21022491,
        },
    },
});

const gnosisChiado = /*#__PURE__*/ defineChain({
    id: 10_200,
    name: 'Gnosis Chiado',
    nativeCurrency: {
        decimals: 18,
        name: 'Gnosis',
        symbol: 'xDAI',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.chiadochain.net'],
            webSocket: ['wss://rpc.chiadochain.net/wss'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://blockscout.chiadochain.net',
            apiUrl: 'https://blockscout.chiadochain.net/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 4967313,
        },
    },
    testnet: true,
});

const goat = /*#__PURE__*/ defineChain({
    id: 2345,
    name: 'GOAT',
    nativeCurrency: {
        decimals: 18,
        name: 'Bitcoin',
        symbol: 'BTC',
    },
    rpcUrls: {
        default: { http: ['https://rpc.goat.network'] },
    },
    blockExplorers: {
        default: {
            name: 'Goat Explorer',
            url: 'https://explorer.goat.network',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 0,
        },
    },
});

const gobi = /*#__PURE__*/ defineChain({
    id: 1_663,
    name: 'Horizen Gobi Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Test ZEN',
        symbol: 'tZEN',
    },
    rpcUrls: {
        default: { http: ['https://gobi-testnet.horizenlabs.io/ethv1'] },
    },
    blockExplorers: {
        default: {
            name: 'Gobi Explorer',
            url: 'https://gobi-explorer.horizen.io',
        },
    },
    contracts: {},
    testnet: true,
});

const goChain = /*#__PURE__*/ defineChain({
    id: 60,
    name: 'GoChain',
    nativeCurrency: {
        decimals: 18,
        name: 'GO',
        symbol: 'GO',
    },
    rpcUrls: {
        default: { http: ['https://rpc.gochain.io'] },
    },
    blockExplorers: {
        default: {
            name: 'GoChain Explorer',
            url: 'https://explorer.gochain.io',
        },
    },
    testnet: false,
});

const godwoken = /*#__PURE__*/ defineChain({
    id: 71402,
    name: 'Godwoken Mainnet',
    nativeCurrency: { decimals: 18, name: 'pCKB', symbol: 'pCKB' },
    rpcUrls: {
        default: {
            http: ['https://v1.mainnet.godwoken.io/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'GW Scan',
            url: 'https://v1.gwscan.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 15034,
        },
    },
    testnet: false,
});

const goerli = /*#__PURE__*/ defineChain({
    id: 5,
    name: 'Goerli',
    nativeCurrency: { name: 'Goerli Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.ankr.com/eth_goerli'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://goerli.etherscan.io',
            apiUrl: 'https://api-goerli.etherscan.io/api',
        },
    },
    contracts: {
        ensRegistry: {
            address: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
        },
        ensUniversalResolver: {
            address: '0xfc4AC75C46C914aF5892d6d3eFFcebD7917293F1',
            blockCreated: 10_339_206,
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 6507670,
        },
    },
    testnet: true,
});

const gravity = /*#__PURE__*/ defineChain({
    id: 1625,
    name: 'Gravity Alpha Mainnet',
    nativeCurrency: { name: 'G', symbol: 'G', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.gravity.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Gravity Explorer',
            url: 'https://explorer.gravity.xyz',
            apiUrl: 'https://explorer.gravity.xyz/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xf8ac4BEB2F75d2cFFb588c63251347fdD629B92c',
            blockCreated: 16851,
        },
    },
});

const guruNetwork = /*#__PURE__*/ defineChain({
    id: 260,
    name: 'Guru Network Mainnet',
    nativeCurrency: {
        name: 'GURU Token',
        symbol: 'GURU',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.gurunetwork.ai/archive/260'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Guruscan',
            url: 'https://scan.gurunetwork.ai',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 271691,
        },
    },
    testnet: false,
});

const guruTestnet = /*#__PURE__*/ defineChain({
    id: 261,
    name: 'Guru Network Testnet',
    nativeCurrency: {
        name: 'tGURU Token',
        symbol: 'tGURU',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.gurunetwork.ai/archive/261'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Guruscan',
            url: 'https://sepolia.gurunetwork.ai',
        },
    },
    testnet: true,
});

const ham = /*#__PURE__*/ defineChain({
    id: 5112,
    name: 'Ham',
    nativeCurrency: {
        decimals: 18,
        name: 'Ham',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.ham.fun'],
            webSocket: ['wss://rpc.ham.fun'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Ham Chain Explorer',
            url: 'https://explorer.ham.fun',
            apiUrl: 'https://explorer.ham.fun/api/v2',
        },
    },
});

const happychainTestnet = /*#__PURE__*/ defineChain({
    id: 216,
    name: 'Happychain Testnet',
    nativeCurrency: {
        symbol: 'HAPPY',
        name: 'HAPPY',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://happy-testnet-sepolia.rpc.caldera.xyz/http'],
            webSocket: ['wss://happy-testnet-sepolia.rpc.caldera.xyz/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Happy Chain Testnet Explorer',
            url: 'https://happy-testnet-sepolia.explorer.caldera.xyz/',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 1,
        },
    },
    testnet: true,
});

const haqqMainnet = /*#__PURE__*/ defineChain({
    id: 11235,
    name: 'HAQQ Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Islamic Coin',
        symbol: 'ISLM',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.eth.haqq.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'HAQQ Explorer',
            url: 'https://explorer.haqq.network',
            apiUrl: 'https://explorer.haqq.network/api',
        },
    },
});

const haqqTestedge2 = /*#__PURE__*/ defineChain({
    id: 54211,
    name: 'HAQQ Testedge 2',
    nativeCurrency: {
        decimals: 18,
        name: 'Islamic Coin',
        symbol: 'ISLMT',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.eth.testedge2.haqq.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'HAQQ Explorer',
            url: 'https://explorer.testedge2.haqq.network',
            apiUrl: 'https://explorer.testedge2.haqq.network/api',
        },
    },
});

const hardhat = /*#__PURE__*/ defineChain({
    id: 31_337,
    name: 'Hardhat',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['http://127.0.0.1:8545'] },
    },
});

const harmonyOne = /*#__PURE__*/ defineChain({
    id: 1_666_600_000,
    name: 'Harmony One',
    nativeCurrency: {
        name: 'Harmony',
        symbol: 'ONE',
        decimals: 18,
    },
    rpcUrls: {
        default: { http: ['https://rpc.ankr.com/harmony'] },
    },
    blockExplorers: {
        default: {
            name: 'Harmony Explorer',
            url: 'https://explorer.harmony.one',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 24185753,
        },
    },
});

const hashkeyTestnet = /*#__PURE__*/ defineChain({
    id: 133,
    name: 'HashKey Chain Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'HashKey EcoPoints',
        symbol: 'HSK',
    },
    rpcUrls: {
        default: {
            http: ['https://hashkeychain-testnet.alt.technology'],
        },
    },
    blockExplorers: {
        default: {
            name: 'HashKey Chain Explorer',
            url: 'https://hashkeychain-testnet-explorer.alt.technology',
        },
    },
});

const hedera = /*#__PURE__*/ defineChain({
    id: 295,
    name: 'Hedera Mainnet',
    network: 'hedera-mainnet',
    nativeCurrency: {
        symbol: 'HBAR',
        name: 'HBAR',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://mainnet.hashio.io/api'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Hashscan',
            url: 'https://hashscan.io/mainnet',
        },
    },
    testnet: false,
});

const hederaPreviewnet = /*#__PURE__*/ defineChain({
    id: 297,
    name: 'Hedera Previewnet',
    network: 'hedera-previewnet',
    nativeCurrency: {
        symbol: 'HBAR',
        name: 'HBAR',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://previewnet.hashio.io/api'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Hashscan',
            url: 'https://hashscan.io/previewnet',
        },
    },
    testnet: true,
});

const hederaTestnet = /*#__PURE__*/ defineChain({
    id: 296,
    name: 'Hedera Testnet',
    network: 'hedera-testnet',
    nativeCurrency: {
        symbol: 'HBAR',
        name: 'HBAR',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://testnet.hashio.io/api'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Hashscan',
            url: 'https://hashscan.io/testnet',
        },
    },
    testnet: true,
});

const hela = /*#__PURE__*/ defineChain({
    id: 8668,
    name: 'Hela Mainnet',
    nativeCurrency: {
        name: 'HLUSD',
        symbol: 'HLUSD',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://mainnet-rpc.helachain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Hela explorer',
            url: 'https://mainnet-blockexplorer.helachain.com',
        },
    },
    testnet: false,
});

const hemi = /*#__PURE__*/ defineChain({
    id: 43111,
    name: 'Hemi',
    network: 'Hemi',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.hemi.network/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'blockscout',
            url: 'https://explorer.hemi.xyz',
        },
    },
    testnet: false,
});

const hemiSepolia = /*#__PURE__*/ defineChain({
    id: 743111,
    name: 'Hemi Sepolia',
    network: 'Hemi Sepolia',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://testnet.rpc.hemi.network/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Hemi Sepolia explorer',
            url: 'https://testnet.explorer.hemi.xyz',
        },
    },
    testnet: true,
});

const holesky = /*#__PURE__*/ defineChain({
    id: 17000,
    name: 'Holesky',
    nativeCurrency: { name: 'Holesky Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://ethereum-holesky-rpc.publicnode.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://holesky.etherscan.io',
            apiUrl: 'https://api-holesky.etherscan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 77,
        },
        ensRegistry: {
            address: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
            blockCreated: 801613,
        },
        ensUniversalResolver: {
            address: '0xa6AC935D4971E3CD133b950aE053bECD16fE7f3b',
            blockCreated: 973484,
        },
    },
    testnet: true,
});

const hpb = /*#__PURE__*/ defineChain({
    id: 269,
    name: 'High Performance Blockchain',
    nativeCurrency: { name: 'HPB', symbol: 'HPB', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://hpbnode.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'hpbScan',
            url: 'https://hscan.org',
        },
    },
    testnet: false,
});

const sourceId$B = 42_161; // Arbitrum One
const huddle01Mainnet = /*#__PURE__*/ defineChain({
    id: 12323,
    name: 'Huddle01 dRTC Chain',
    nativeCurrency: {
        name: 'Ethereum',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://huddle01.calderachain.xyz/http'],
            webSocket: ['wss://huddle01.calderachain.xyz/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Huddle01 Caldera Explorer',
            url: 'https://huddle01.calderaexplorer.xyz',
            apiUrl: 'https://huddle01.calderaexplorer.xyz/api',
        },
    },
    sourceId: sourceId$B,
});

const sourceId$A = 421_614; // Arbitrum Sepolia
const huddle01Testnet = /*#__PURE__*/ defineChain({
    id: 2524852,
    name: 'Huddle01 dRTC Chain Testnet',
    nativeCurrency: {
        name: 'Ethereum',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://huddle-testnet.rpc.caldera.xyz/http'],
            webSocket: ['wss://huddle-testnet.rpc.caldera.xyz/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Huddle01 Caldera Explorer',
            url: 'https://huddle-testnet.explorer.caldera.xyz',
            apiUrl: 'https://huddle-testnet.explorer.caldera.xyz/api',
        },
    },
    sourceId: sourceId$A,
});

const humanode = /*#__PURE__*/ defineChain({
    id: 5234,
    name: 'Humanode',
    nativeCurrency: { name: 'HMND', symbol: 'HMND', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://explorer-rpc-http.mainnet.stages.humanode.io'],
            webSocket: ['wss://explorer-rpc-ws.mainnet.stages.humanode.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Subscan',
            url: 'https://humanode.subscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 4_413_097,
        },
    },
});

const humanodeTestnet5 = /*#__PURE__*/ defineChain({
    id: 14853,
    name: 'Humanode Testnet 5',
    nativeCurrency: { name: 'HMND', symbol: 'HMND', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://explorer-rpc-http.testnet5.stages.humanode.io'],
            webSocket: ['wss://explorer-rpc-ws.testnet5.stages.humanode.io'],
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
        },
    },
});

const hychain = /*#__PURE__*/ defineChain({
    id: 2911,
    name: 'HYCHAIN',
    nativeCurrency: { name: 'HYTOPIA', symbol: 'TOPIA', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc.hychain.com/http'] },
    },
    blockExplorers: {
        default: {
            name: 'HYCHAIN Explorer',
            url: 'https://explorer.hychain.com',
        },
    },
    testnet: false,
});

const hychainTestnet = /*#__PURE__*/ defineChain({
    id: 29112,
    name: 'HYCHAIN Testnet',
    nativeCurrency: { name: 'HYTOPIA', symbol: 'TOPIA', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc.hychain.com/http'] },
    },
    blockExplorers: {
        default: {
            name: 'HYCHAIN Explorer',
            url: 'https://testnet-rpc.hychain.com/http',
        },
    },
    testnet: true,
});

const idchain = /*#__PURE__*/ defineChain({
    id: 74,
    name: 'IDChain Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'EIDI',
        symbol: 'EIDI',
    },
    rpcUrls: {
        default: {
            http: ['https://idchain.one/rpc'],
            webSocket: ['wss://idchain.one/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'IDChain Explorer',
            url: 'https://explorer.idchain.one',
        },
    },
    testnet: false,
});

const immutableZkEvm = /*#__PURE__*/ defineChain({
    id: 13371,
    name: 'Immutable zkEVM',
    nativeCurrency: {
        decimals: 18,
        name: 'Immutable Coin',
        symbol: 'IMX',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.immutable.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Immutable Explorer',
            url: 'https://explorer.immutable.com',
            apiUrl: 'https://explorer.immutable.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0x236bdA4589e44e6850f5aC6a74BfCa398a86c6c0',
            blockCreated: 4335972,
        },
    },
});

const immutableZkEvmTestnet = /*#__PURE__*/ defineChain({
    id: 13473,
    name: 'Immutable zkEVM Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Immutable Coin',
        symbol: 'IMX',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.immutable.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Immutable Testnet Explorer',
            url: 'https://explorer.testnet.immutable.com/',
        },
    },
    contracts: {
        multicall3: {
            address: '0x2CC787Ed364600B0222361C4188308Fa8E68bA60',
            blockCreated: 5977391,
        },
    },
    testnet: true,
});

const inEVM = /*#__PURE__*/ defineChain({
    id: 2525,
    name: 'inEVM Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Injective',
        symbol: 'INJ',
    },
    rpcUrls: {
        default: { http: ['https://mainnet.rpc.inevm.com/http'] },
    },
    blockExplorers: {
        default: {
            name: 'inEVM Explorer',
            url: 'https://inevm.calderaexplorer.xyz',
            apiUrl: 'https://inevm.calderaexplorer.xyz/api/v2',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 118606,
        },
    },
});

const initVerse = /*#__PURE__*/ defineChain({
    id: 7_233,
    name: 'InitVerse Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'InitVerse',
        symbol: 'INI',
    },
    rpcUrls: {
        default: { http: ['https://rpc-mainnet.inichain.com'] },
    },
    blockExplorers: {
        default: {
            name: 'InitVerseScan',
            url: 'https://www.iniscan.com',
            apiUrl: 'https://explorer-api.inichain.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0x83466BE48A067115FFF91f7b892Ed1726d032e47',
            blockCreated: 2318,
        },
    },
});

const initVerseGenesis = /*#__PURE__*/ defineChain({
    id: 7_234,
    name: 'InitVerse Genesis Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'InitVerse',
        symbol: 'INI',
    },
    rpcUrls: {
        default: { http: ['https://rpc-testnet.inichain.com'] },
    },
    blockExplorers: {
        default: {
            name: 'InitVerseGenesisScan',
            url: 'https://genesis-testnet.iniscan.com',
            apiUrl: 'https://explorer-testnet-api.inichain.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0x0cF32CBDd6c437331EA4f85ed2d881A5379B5a6F',
            blockCreated: 16361,
        },
    },
    testnet: true,
});

const sourceId$z = 1; // mainnet
const ink = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 57073,
    name: 'Ink',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: [
                'https://rpc-gel.inkonchain.com',
                'https://rpc-qnd.inkonchain.com',
            ],
            webSocket: [
                'wss://rpc-gel.inkonchain.com',
                'wss://rpc-qnd.inkonchain.com',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://explorer.inkonchain.com',
            apiUrl: 'https://explorer.inkonchain.com/api/v2',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        disputeGameFactory: {
            [sourceId$z]: {
                address: '0x10d7b35078d3baabb96dd45a9143b94be65b12cd',
            },
        },
        portal: {
            [sourceId$z]: {
                address: '0x5d66c1782664115999c47c9fa5cd031f495d3e4f',
            },
        },
        l1StandardBridge: {
            [sourceId$z]: {
                address: '0x88ff1e5b602916615391f55854588efcbb7663f0',
            },
        },
    },
    testnet: false,
    sourceId: sourceId$z,
});

const sourceId$y = 11_155_111; // sepolia
const inkSepolia = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 763373,
    name: 'Ink Sepolia',
    nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-gel-sepolia.inkonchain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://explorer-sepolia.inkonchain.com/',
            apiUrl: 'https://explorer-sepolia.inkonchain.com/api/v2',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        disputeGameFactory: {
            [sourceId$y]: {
                address: '0x860e626c700af381133d9f4af31412a2d1db3d5d',
            },
        },
        portal: {
            [sourceId$y]: {
                address: '0x5c1d29c6c9c8b0800692acc95d700bcb4966a1d7',
            },
        },
        l1StandardBridge: {
            [sourceId$y]: {
                address: '0x33f60714bbd74d62b66d79213c348614de51901c',
            },
        },
    },
    testnet: true,
    sourceId: sourceId$y,
});

const iota = /*#__PURE__*/ defineChain({
    id: 8822,
    name: 'IOTA EVM',
    network: 'iotaevm',
    nativeCurrency: {
        decimals: 18,
        name: 'IOTA',
        symbol: 'IOTA',
    },
    rpcUrls: {
        default: {
            http: ['https://json-rpc.evm.iotaledger.net'],
            webSocket: ['wss://ws.json-rpc.evm.iotaledger.net'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Explorer',
            url: 'https://explorer.evm.iota.org',
            apiUrl: 'https://explorer.evm.iota.org/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 25022,
        },
    },
});

const iotaTestnet = /*#__PURE__*/ defineChain({
    id: 1075,
    name: 'IOTA EVM Testnet',
    network: 'iotaevm-testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'IOTA',
        symbol: 'IOTA',
    },
    rpcUrls: {
        default: {
            http: ['https://json-rpc.evm.testnet.iotaledger.net'],
            webSocket: ['wss://ws.json-rpc.evm.testnet.iotaledger.net'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Explorer',
            url: 'https://explorer.evm.testnet.iotaledger.net',
            apiUrl: 'https://explorer.evm.testnet.iotaledger.net/api',
        },
    },
    testnet: true,
});

const iotex = /*#__PURE__*/ defineChain({
    id: 4_689,
    name: 'IoTeX',
    nativeCurrency: {
        decimals: 18,
        name: 'IoTeX',
        symbol: 'IOTX',
    },
    rpcUrls: {
        default: {
            http: ['https://babel-api.mainnet.iotex.io'],
            webSocket: ['wss://babel-api.mainnet.iotex.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'IoTeXScan',
            url: 'https://iotexscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 22163670,
        },
    },
});

const iotexTestnet = /*#__PURE__*/ defineChain({
    id: 4_690,
    name: 'IoTeX Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'IoTeX',
        symbol: 'IOTX',
    },
    rpcUrls: {
        default: {
            http: ['https://babel-api.testnet.iotex.io'],
            webSocket: ['wss://babel-api.testnet.iotex.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'IoTeXScan',
            url: 'https://testnet.iotexscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xb5cecD6894c6f473Ec726A176f1512399A2e355d',
            blockCreated: 24347592,
        },
    },
    testnet: true,
});

const iSunCoin = /*#__PURE__*/ defineChain({
    id: 8017,
    name: 'iSunCoin Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'ISC',
        symbol: 'ISC',
    },
    rpcUrls: {
        default: {
            http: ['https://mainnet.isuncoin.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'iSunCoin Explorer',
            url: 'https://baifa.io/app/chains/8017',
        },
    },
});

const jbc = /*#__PURE__*/ defineChain({
    id: 8899,
    name: 'JIBCHAIN L1',
    network: 'jbc',
    nativeCurrency: { name: 'JBC', symbol: 'JBC', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-l1.jibchain.net'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://exp-l1.jibchain.net',
            apiUrl: 'https://exp-l1.jibchain.net/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xc0C8C486D1466C57Efe13C2bf000d4c56F47CBdC',
            blockCreated: 2299048,
        },
    },
    testnet: false,
});

const jbcTestnet = /*#__PURE__*/ defineChain({
    id: 88991,
    name: 'Jibchain Testnet',
    nativeCurrency: { name: 'tJBC', symbol: 'tJBC', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.jibchain.net'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://exp.testnet.jibchain.net',
            apiUrl: 'https://exp.testnet.jibchain.net/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xa1a858ad9041B4741e620355a3F96B3c78e70ecE',
            blockCreated: 32848,
        },
    },
    testnet: true,
});

const karura = /*#__PURE__*/ defineChain({
    id: 686,
    name: 'Karura',
    network: 'karura',
    nativeCurrency: {
        name: 'Karura',
        symbol: 'KAR',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://eth-rpc-karura.aca-api.network'],
            webSocket: ['wss://eth-rpc-karura.aca-api.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Karura Blockscout',
            url: 'https://blockscout.karura.network',
            apiUrl: 'https://blockscout.karura.network/api',
        },
    },
    testnet: false,
});

const kakarotSepolia = /*#__PURE__*/ defineChain({
    id: 1802203764,
    name: 'Kakarot Sepolia',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://sepolia-rpc.kakarot.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Kakarot Scan',
            url: 'https://sepolia.kakarotscan.org',
        },
    },
    testnet: true,
});

const kakarotStarknetSepolia = /*#__PURE__*/ defineChain({
    id: 920637907288165,
    name: 'Kakarot Starknet Sepolia',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://sepolia-rpc.kakarot.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Kakarot Scan',
            url: 'https://sepolia.kakarotscan.org',
        },
    },
    testnet: true,
});

const kardiaChain = /*#__PURE__*/ defineChain({
    id: 24,
    name: 'KardiaChain Mainnet',
    nativeCurrency: { name: 'KAI', symbol: 'KAI', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.kardiachain.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'KardiaChain Explorer',
            url: 'https://explorer.kardiachain.io',
        },
    },
    testnet: false,
});

const kava = /*#__PURE__*/ defineChain({
    id: 2222,
    name: 'Kava EVM',
    network: 'kava-mainnet',
    nativeCurrency: {
        name: 'Kava',
        symbol: 'KAVA',
        decimals: 18,
    },
    rpcUrls: {
        default: { http: ['https://evm.kava.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Kava EVM Explorer',
            url: 'https://kavascan.com',
            apiUrl: 'https://kavascan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 3661165,
        },
    },
    testnet: false,
});

const kavaTestnet = /*#__PURE__*/ defineChain({
    id: 2221,
    name: 'Kava EVM Testnet',
    network: 'kava-testnet',
    nativeCurrency: {
        name: 'Kava',
        symbol: 'KAVA',
        decimals: 18,
    },
    rpcUrls: {
        default: { http: ['https://evm.testnet.kava.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Kava EVM Testnet Explorer',
            url: 'https://testnet.kavascan.com/',
            apiUrl: 'https://testnet.kavascan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xDf1D724A7166261eEB015418fe8c7679BBEa7fd6',
            blockCreated: 7242179,
        },
    },
    testnet: true,
});

const kcc = /*#__PURE__*/ defineChain({
    id: 321,
    name: 'KCC Mainnet',
    network: 'KCC Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'KCS',
        symbol: 'KCS',
    },
    rpcUrls: {
        default: {
            http: ['https://kcc-rpc.com'],
        },
    },
    blockExplorers: {
        default: { name: 'KCC Explorer', url: 'https://explorer.kcc.io' },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 11760430,
        },
    },
    testnet: false,
});

const kinto = /*#__PURE__*/ defineChain({
    id: 7887,
    name: 'Kinto Mainnet',
    network: 'Kinto Mainnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc.kinto.xyz/http'] },
    },
    blockExplorers: {
        default: {
            name: 'Kinto Explorer',
            url: 'https://explorer.kinto.xyz',
        },
    },
    testnet: false,
});

const klaytn = /*#__PURE__*/ defineChain({
    id: 8_217,
    name: 'Klaytn',
    nativeCurrency: {
        decimals: 18,
        name: 'Klaytn',
        symbol: 'KLAY',
    },
    rpcUrls: {
        default: { http: ['https://public-en-cypress.klaytn.net'] },
    },
    blockExplorers: {
        default: {
            name: 'KlaytnScope',
            url: 'https://scope.klaytn.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 96002415,
        },
    },
});

const kaia = /*#__PURE__*/ defineChain({
    id: 8_217,
    name: 'Kaia',
    nativeCurrency: {
        decimals: 18,
        name: 'Kaia',
        symbol: 'KAIA',
    },
    rpcUrls: {
        default: { http: ['https://public-en.node.kaia.io'] },
    },
    blockExplorers: {
        default: {
            name: 'KaiaScan',
            url: 'https://kaiascan.io',
            apiUrl: 'https://api-cypress.klaytnscope.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 96002415,
        },
    },
});

const kairos = /*#__PURE__*/ defineChain({
    id: 1_001,
    name: 'Kairos Testnet',
    network: 'kairos',
    nativeCurrency: {
        decimals: 18,
        name: 'Kairos KAIA',
        symbol: 'KAIA',
    },
    rpcUrls: {
        default: { http: ['https://public-en-kairos.node.kaia.io'] },
    },
    blockExplorers: {
        default: {
            name: 'KaiaScan',
            url: 'https://kairos.kaiascan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 123390593,
        },
    },
    testnet: true,
});

const klaytnBaobab = /*#__PURE__*/ defineChain({
    id: 1_001,
    name: 'Klaytn Baobab Testnet',
    network: 'klaytn-baobab',
    nativeCurrency: {
        decimals: 18,
        name: 'Baobab Klaytn',
        symbol: 'KLAY',
    },
    rpcUrls: {
        default: { http: ['https://public-en-baobab.klaytn.net'] },
    },
    blockExplorers: {
        default: {
            name: 'KlaytnScope',
            url: 'https://baobab.klaytnscope.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 123390593,
        },
    },
    testnet: true,
});

const koi = defineChain({
    id: 701,
    name: 'Koi Network',
    nativeCurrency: {
        decimals: 18,
        name: 'Koi Network Native Token',
        symbol: 'KRING',
    },
    rpcUrls: {
        default: {
            http: ['https://koi-rpc.darwinia.network'],
            webSocket: ['wss://koi-rpc.darwinia.network'],
        },
    },
    blockExplorers: {
        default: { name: 'Blockscout', url: 'https://koi-scan.darwinia.network' },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 180001,
        },
    },
    testnet: true,
});

const kroma = /*#__PURE__*/ defineChain({
    id: 255,
    name: 'Kroma',
    nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://api.kroma.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Kroma Explorer',
            url: 'https://blockscout.kroma.network',
            apiUrl: 'https://blockscout.kroma.network/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 16054868,
        },
    },
    testnet: false,
});

const kromaSepolia = /*#__PURE__*/ defineChain({
    id: 2358,
    name: 'Kroma Sepolia',
    nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://api.sepolia.kroma.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Kroma Sepolia Explorer',
            url: 'https://blockscout.sepolia.kroma.network',
            apiUrl: 'https://blockscout.sepolia.kroma.network/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 8900914,
        },
    },
    testnet: true,
});

const l3x = /*#__PURE__*/ defineChain({
    id: 12324,
    name: 'L3X Protocol',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-mainnet.l3x.com'],
            webSocket: ['wss://rpc-mainnet.l3x.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'L3X Mainnet Explorer',
            url: 'https://explorer.l3x.com',
            apiUrl: 'https://explorer.l3x.com/api/v2',
        },
    },
    testnet: false,
});

const l3xTestnet = /*#__PURE__*/ defineChain({
    id: 12325,
    name: 'L3X Protocol Testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-testnet.l3x.com'],
            webSocket: ['wss://rpc-testnet.l3x.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'L3X Testnet Explorer',
            url: 'https://explorer-testnet.l3x.com',
            apiUrl: 'https://explorer-testnet.l3x.com/api/v2',
        },
    },
    testnet: true,
});

const lavita = /*#__PURE__*/ defineChain({
    id: 360890,
    name: 'LAVITA Mainnet',
    nativeCurrency: { name: 'vTFUEL', symbol: 'vTFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://tsub360890-eth-rpc.thetatoken.org/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'LAVITA Explorer',
            url: 'https://tsub360890-explorer.thetatoken.org',
        },
    },
    testnet: false,
});

const lensTestnet = /*#__PURE__*/ defineChain({
    id: 37_111,
    name: 'Lens Testnet',
    nativeCurrency: { name: 'GRASS', symbol: 'GRASS', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.lens.dev'],
            webSocket: ['wss://rpc.testnet.lens.dev/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Lens Block Explorer',
            url: 'https://block-explorer.testnet.lens.dev',
            apiUrl: 'https://block-explorer-api.staging.lens.dev/api',
        },
    },
    testnet: true,
});

const lightlinkPegasus = /*#__PURE__*/ defineChain({
    id: 1_891,
    name: 'LightLink Pegasus Testnet',
    network: 'lightlink-pegasus',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://replicator.pegasus.lightlink.io/rpc/v1'],
        },
    },
    blockExplorers: {
        default: {
            name: 'LightLink Pegasus Explorer',
            url: 'https://pegasus.lightlink.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 127_188_532,
        },
    },
    testnet: true,
});

const lightlinkPhoenix = /*#__PURE__*/ defineChain({
    id: 1_890,
    name: 'LightLink Phoenix Mainnet',
    network: 'lightlink-phoenix',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://replicator.phoenix.lightlink.io/rpc/v1'],
        },
    },
    blockExplorers: {
        default: {
            name: 'LightLink Phoenix Explorer',
            url: 'https://phoenix.lightlink.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 125_499_184,
        },
    },
    testnet: false,
});

/**
 * Estimates the gas and fees per gas necessary to complete a transaction without submitting it to the network.
 *
 * @param client - Client to use
 * @param parameters - {@link EstimateGasParameters}
 * @returns A gas estimate and fees per gas (in wei). {@link EstimateGasReturnType}
 *
 * @example
 * import { createPublicClient, http, parseEther } from 'viem'
 * import { linea } from 'viem/chains'
 * import { estimateGas } from 'viem/linea'
 *
 * const client = createPublicClient({
 *   chain: linea,
 *   transport: http(),
 * })
 * const gasEstimate = await estimateGas(client, {
 *   account: '0xA0Cf798816D4b9b9866b5330EEa46a18382f251e',
 *   to: '0x70997970c51812dc3a010c7d01b50e0d17dc79c8',
 *   value: 0n,
 * })
 */
async function estimateGas(client, args) {
    const { account: account_ = client.account } = args;
    if (!account_)
        throw new AccountNotFoundError();
    const account = parseAccount(account_);
    try {
        const { accessList, blockNumber, blockTag, data, gas, gasPrice, maxFeePerGas, maxPriorityFeePerGas, nonce, to, value, ...rest } = args;
        const blockNumberHex = blockNumber ? numberToHex(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        assertRequest(args);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || formatTransactionRequest;
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...extract(rest, { format: chainFormat }),
            from: account?.address,
            accessList,
            data,
            gas,
            gasPrice,
            maxFeePerGas,
            maxPriorityFeePerGas,
            nonce,
            to,
            value,
        });
        const { baseFeePerGas, gasLimit, priorityFeePerGas } = await client.request({
            method: 'linea_estimateGas',
            params: block ? [request, block] : [request],
        });
        return {
            baseFeePerGas: BigInt(baseFeePerGas),
            gasLimit: BigInt(gasLimit),
            priorityFeePerGas: BigInt(priorityFeePerGas),
        };
    }
    catch (err) {
        throw getCallError(err, {
            ...args,
            account,
            chain: client.chain,
        });
    }
}

const chainConfig = {
    fees: {
        estimateFeesPerGas,
        async maxPriorityFeePerGas({ block, client, request }) {
            const response = await estimateFeesPerGas({
                block,
                client,
                multiply: (x) => x,
                request,
                type: 'eip1559',
            });
            // Returning `null` will trigger the base `estimateMaxPriorityFeePerGas` to perform
            // fallback mechanisms to estimate priority fee.
            if (!response?.maxPriorityFeePerGas)
                return null;
            return response.maxPriorityFeePerGas;
        },
    },
};
///////////////////////////////////////////////////////////////////////////
// Internal
///////////////////////////////////////////////////////////////////////////
async function estimateFeesPerGas({ client, multiply, request, type, }) {
    try {
        const response = await estimateGas(client, {
            ...request,
            account: request?.account,
        });
        const { priorityFeePerGas: maxPriorityFeePerGas } = response;
        const baseFeePerGas = multiply(BigInt(response.baseFeePerGas));
        const maxFeePerGas = baseFeePerGas + maxPriorityFeePerGas;
        if (type === 'legacy')
            return { gasPrice: maxFeePerGas };
        return {
            maxFeePerGas,
            maxPriorityFeePerGas,
        };
    }
    catch {
        // Returning `null` will trigger the base `estimateFeesPerGas` to perform
        // fallback mechanisms to estimate fees.
        return null;
    }
}

const linea = /*#__PURE__*/ defineChain({
    ...chainConfig,
    id: 59_144,
    name: 'Linea Mainnet',
    nativeCurrency: { name: 'Linea Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.linea.build'],
            webSocket: ['wss://rpc.linea.build'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://lineascan.build',
            apiUrl: 'https://api.lineascan.build/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 42,
        },
    },
    testnet: false,
});

const lineaGoerli = /*#__PURE__*/ defineChain({
    id: 59_140,
    name: 'Linea Goerli Testnet',
    nativeCurrency: { name: 'Linea Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.goerli.linea.build'],
            webSocket: ['wss://rpc.goerli.linea.build'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://goerli.lineascan.build',
            apiUrl: 'https://api-goerli.lineascan.build/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 498623,
        },
    },
    testnet: true,
});

const lineaSepolia = /*#__PURE__*/ defineChain({
    ...chainConfig,
    id: 59_141,
    name: 'Linea Sepolia Testnet',
    nativeCurrency: { name: 'Linea Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.sepolia.linea.build'],
            webSocket: ['wss://rpc.sepolia.linea.build'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://sepolia.lineascan.build',
            apiUrl: 'https://api-sepolia.lineascan.build/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 227427,
        },
    },
    testnet: true,
});

const lineaTestnet = /*#__PURE__*/ defineChain({
    id: 59_140,
    name: 'Linea Goerli Testnet',
    nativeCurrency: { name: 'Linea Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.goerli.linea.build'],
            webSocket: ['wss://rpc.goerli.linea.build'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://goerli.lineascan.build',
            apiUrl: 'https://goerli.lineascan.build/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 498623,
        },
    },
    testnet: true,
});

const sourceId$x = 1; // mainnet
const lisk = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 1135,
    name: 'Lisk',
    network: 'lisk',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.api.lisk.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://blockscout.lisk.com',
            apiUrl: 'https://blockscout.lisk.com/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xA9d71E1dd7ca26F26e656E66d6AA81ed7f745bf0',
        },
        l2OutputOracle: {
            [sourceId$x]: {
                address: '0x113cB99283AF242Da0A0C54347667edF531Aa7d6',
            },
        },
        portal: {
            [sourceId$x]: {
                address: '0x26dB93F8b8b4f7016240af62F7730979d353f9A7',
            },
        },
        l1StandardBridge: {
            [sourceId$x]: {
                address: '0x2658723Bf70c7667De6B25F99fcce13A16D25d08',
            },
        },
    },
    sourceId: sourceId$x,
});

const sourceId$w = 11_155_111; // sepolia
const liskSepolia = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 4202,
    network: 'lisk-sepolia',
    name: 'Lisk Sepolia',
    nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.sepolia-api.lisk.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://sepolia-blockscout.lisk.com',
            apiUrl: 'https://sepolia-blockscout.lisk.com/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$w]: {
                address: '0xA0E35F56C318DE1bD5D9ca6A94Fe7e37C5663348',
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
        },
        portal: {
            [sourceId$w]: {
                address: '0xe3d90F21490686Ec7eF37BE788E02dfC12787264',
            },
        },
        l1StandardBridge: {
            [sourceId$w]: {
                address: '0x1Fb30e446eA791cd1f011675E5F3f5311b70faF5',
            },
        },
    },
    testnet: true,
    sourceId: sourceId$w,
});

const localhost = /*#__PURE__*/ defineChain({
    id: 1_337,
    name: 'Localhost',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['http://127.0.0.1:8545'] },
    },
});

const loop = /*#__PURE__*/ defineChain({
    id: 15551,
    name: 'LoopNetwork Mainnet',
    nativeCurrency: {
        name: 'LOOP',
        symbol: 'LOOP',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://api.mainnetloop.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'LoopNetwork Blockchain Explorer',
            url: 'https://explorer.mainnetloop.com/',
        },
    },
    testnet: false,
});

const lukso = /*#__PURE__*/ defineChain({
    id: 42,
    network: 'lukso',
    name: 'LUKSO',
    nativeCurrency: {
        name: 'LUKSO',
        symbol: 'LYX',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.mainnet.lukso.network'],
            webSocket: ['wss://ws-rpc.mainnet.lukso.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'LUKSO Mainnet Explorer',
            url: 'https://explorer.execution.mainnet.lukso.network',
            apiUrl: 'https://api.explorer.execution.mainnet.lukso.network/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 468183,
        },
    },
});

const luksoTestnet = /*#__PURE__*/ defineChain({
    id: 4201,
    name: 'LUKSO Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'LUKSO Testnet',
        symbol: 'LYXt',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.lukso.network'],
            webSocket: ['wss://ws-rpc.testnet.lukso.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'LUKSO Testnet Explorer',
            url: 'https://explorer.execution.testnet.lukso.network',
            apiUrl: 'https://api.explorer.execution.testnet.lukso.network/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 605348,
        },
    },
    testnet: true,
});

const lumiaMainnet = /*#__PURE__*/ defineChain({
    id: 994873017,
    name: 'Lumia Mainnet',
    network: 'LumiaMainnet',
    nativeCurrency: { name: 'Lumia', symbol: 'LUMIA', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet-rpc.lumia.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Lumia Explorer',
            url: 'https://explorer.lumia.org/',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 3975939,
        },
    },
    testnet: false,
});

const lumiaTestnet = /*#__PURE__*/ defineChain({
    id: 1952959480,
    name: 'Lumia Testnet',
    network: 'LumiaTestnet',
    nativeCurrency: {
        name: 'Lumia',
        symbol: 'LUMIA',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://testnet-rpc.lumia.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Lumia Testnet Explorer',
            url: 'https://testnet-explorer.lumia.org/',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 2235063,
        },
    },
    testnet: true,
});

const lycan = /*#__PURE__*/ defineChain({
    id: 721,
    name: 'Lycan',
    nativeCurrency: {
        decimals: 18,
        name: 'Lycan',
        symbol: 'LYC',
    },
    rpcUrls: {
        default: {
            http: [
                'https://rpc.lycanchain.com',
                'https://us-east.lycanchain.com',
                'https://us-west.lycanchain.com',
                'https://eu-north.lycanchain.com',
                'https://eu-west.lycanchain.com',
                'https://asia-southeast.lycanchain.com',
            ],
            webSocket: [
                'wss://rpc.lycanchain.com',
                'wss://us-east.lycanchain.com',
                'wss://us-west.lycanchain.com',
                'wss://eu-north.lycanchain.com',
                'wss://eu-west.lycanchain.com',
                'wss://asia-southeast.lycanchain.com',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'Lycan Explorer',
            url: 'https://explorer.lycanchain.com',
        },
    },
});

const lyra = /*#__PURE__*/ defineChain({
    id: 957,
    name: 'Lyra Chain',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.lyra.finance'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Lyra Explorer',
            url: 'https://explorer.lyra.finance',
            apiUrl: 'https://explorer.lyra.finance/api/v2',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 1935198,
        },
    },
});

const mainnet = /*#__PURE__*/ defineChain({
    id: 1,
    name: 'Ethereum',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://eth.merkle.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://etherscan.io',
            apiUrl: 'https://api.etherscan.io/api',
        },
    },
    contracts: {
        ensRegistry: {
            address: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
        },
        ensUniversalResolver: {
            address: '0xce01f8eee7E479C928F8919abD53E553a36CeF67',
            blockCreated: 19_258_213,
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 14_353_601,
        },
    },
});

const mandala = /*#__PURE__*/ defineChain({
    id: 595,
    name: 'Mandala TC9',
    network: 'mandala',
    nativeCurrency: {
        name: 'Mandala',
        symbol: 'mACA',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://eth-rpc-tc9.aca-staging.network'],
            webSocket: ['wss://eth-rpc-tc9.aca-staging.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Mandala Blockscout',
            url: 'https://blockscout.mandala.aca-staging.network',
            apiUrl: 'https://blockscout.mandala.aca-staging.network/api',
        },
    },
    testnet: true,
});

const manta = /*#__PURE__*/ defineChain({
    id: 169,
    name: 'Manta Pacific Mainnet',
    network: 'manta',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['https://pacific-rpc.manta.network/http'] },
    },
    blockExplorers: {
        default: {
            name: 'Manta Explorer',
            url: 'https://pacific-explorer.manta.network',
            apiUrl: 'https://pacific-explorer.manta.network/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 332890,
        },
    },
});

const mantaSepoliaTestnet = /*#__PURE__*/ defineChain({
    id: 3_441_006,
    name: 'Manta Pacific Sepolia Testnet',
    network: 'manta-sepolia',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://pacific-rpc.sepolia-testnet.manta.network/http'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Manta Sepolia Testnet Explorer',
            url: 'https://pacific-explorer.sepolia-testnet.manta.network',
            apiUrl: 'https://pacific-explorer.sepolia-testnet.manta.network/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca54918f7B525C8df894668846506767412b53E3',
            blockCreated: 479584,
        },
    },
    testnet: true,
});

const mantaTestnet = /*#__PURE__*/ defineChain({
    id: 3_441_005,
    name: 'Manta Pacific Testnet',
    network: 'manta-testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['https://manta-testnet.calderachain.xyz/http'] },
    },
    blockExplorers: {
        default: {
            name: 'Manta Testnet Explorer',
            url: 'https://pacific-explorer.testnet.manta.network',
            apiUrl: 'https://pacific-explorer.testnet.manta.network/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0x211B1643b95Fe76f11eD8880EE810ABD9A4cf56C',
            blockCreated: 419915,
        },
    },
    testnet: true,
});

const mantle = /*#__PURE__*/ defineChain({
    id: 5000,
    name: 'Mantle',
    nativeCurrency: {
        decimals: 18,
        name: 'MNT',
        symbol: 'MNT',
    },
    rpcUrls: {
        default: { http: ['https://rpc.mantle.xyz'] },
    },
    blockExplorers: {
        default: {
            name: 'Mantle Explorer',
            url: 'https://mantlescan.xyz/',
            apiUrl: 'https://api.mantlescan.xyz/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 304717,
        },
    },
});

const mantleSepoliaTestnet = /*#__PURE__*/ defineChain({
    id: 5003,
    name: 'Mantle Sepolia Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'MNT',
        symbol: 'MNT',
    },
    rpcUrls: {
        default: { http: ['https://rpc.sepolia.mantle.xyz'] },
    },
    blockExplorers: {
        default: {
            name: 'Mantle Testnet Explorer',
            url: 'https://explorer.sepolia.mantle.xyz/',
            apiUrl: 'https://explorer.sepolia.mantle.xyz/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 4584012,
        },
    },
    testnet: true,
});

const mantleTestnet = /*#__PURE__*/ defineChain({
    id: 5001,
    name: 'Mantle Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'MNT',
        symbol: 'MNT',
    },
    rpcUrls: {
        default: { http: ['https://rpc.testnet.mantle.xyz'] },
    },
    blockExplorers: {
        default: {
            name: 'Mantle Testnet Explorer',
            url: 'https://explorer.testnet.mantle.xyz',
            apiUrl: 'https://explorer.testnet.mantle.xyz/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 561333,
        },
    },
    testnet: true,
});

const mapProtocol = /*#__PURE__*/ defineChain({
    id: 22776,
    name: 'MAP Protocol',
    nativeCurrency: {
        decimals: 18,
        name: 'MAPO',
        symbol: 'MAPO',
    },
    rpcUrls: {
        default: { http: ['https://rpc.maplabs.io'] },
    },
    blockExplorers: {
        default: {
            name: 'MAPO Scan',
            url: 'https://maposcan.io',
        },
    },
    testnet: false,
});

const matchain = /*#__PURE__*/ defineChain({
    id: 698,
    name: 'Matchain',
    nativeCurrency: {
        name: 'BNB',
        symbol: 'BNB',
        decimals: 18,
    },
    rpcUrls: {
        default: { http: ['https://rpc.matchain.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Matchain Scan',
            url: 'https://matchscan.io',
        },
    },
});

const matchainTestnet = /*#__PURE__*/ defineChain({
    id: 699,
    name: 'Matchain Testnet',
    nativeCurrency: {
        name: 'BNB',
        symbol: 'BNB',
        decimals: 18,
    },
    rpcUrls: {
        default: { http: ['https://testnet-rpc.matchain.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Matchain Scan',
            url: 'https://testnet.matchscan.io',
        },
    },
    testnet: true,
});

const mchVerse = /*#__PURE__*/ defineChain({
    id: 29548,
    name: 'MCH Verse',
    nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.oasys.mycryptoheroes.net'],
        },
    },
    blockExplorers: {
        default: {
            name: 'MCH Verse Explorer',
            url: 'https://explorer.oasys.mycryptoheroes.net',
            apiUrl: 'https://explorer.oasys.mycryptoheroes.net/api',
        },
    },
    testnet: false,
});

const mekong = /*#__PURE__*/ defineChain({
    id: 7078815900,
    name: 'Mekong Pectra Devnet',
    nativeCurrency: { name: 'eth', symbol: 'eth', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.mekong.ethpandaops.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Block Explorer',
            url: 'https://explorer.mekong.ethpandaops.io',
        },
    },
    testnet: true,
});

const meld = /*#__PURE__*/ defineChain({
    id: 333000333,
    name: 'Meld',
    nativeCurrency: {
        decimals: 18,
        name: 'Meld',
        symbol: 'MELD',
    },
    rpcUrls: {
        default: { http: ['https://rpc-1.meld.com'] },
    },
    blockExplorers: {
        default: { name: 'MELDscan', url: 'https://meldscan.io' },
    },
    contracts: {
        multicall3: {
            address: '0x769ee5a8e82c15c1b6e358f62ac8eb6e3abe8dc5',
            blockCreated: 360069,
        },
    },
});

const merlin = /*#__PURE__*/ defineChain({
    id: 4200,
    name: 'Merlin',
    nativeCurrency: {
        name: 'BTC',
        symbol: 'BTC',
        decimals: 18,
    },
    rpcUrls: {
        default: { http: ['https://rpc.merlinchain.io'] },
    },
    blockExplorers: {
        default: {
            name: 'blockscout',
            url: 'https://scan.merlinchain.io',
            apiUrl: 'https://scan.merlinchain.io/api',
        },
    },
});

const metachain = /*#__PURE__*/ defineChain({
    id: 571,
    name: 'MetaChain Mainnet',
    nativeCurrency: { name: 'Metatime Coin', symbol: 'MTC', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.metatime.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'MetaExplorer',
            url: 'https://explorer.metatime.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0x0000000000000000000000000000000000003001',
            blockCreated: 0,
        },
    },
});

const metachainIstanbul = /*#__PURE__*/ defineChain({
    id: 1_453,
    name: 'MetaChain Istanbul',
    nativeCurrency: { name: 'Metatime Coin', symbol: 'MTC', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://istanbul-rpc.metachain.dev'],
        },
    },
    blockExplorers: {
        default: {
            name: 'MetaExplorer',
            url: 'https://istanbul-explorer.metachain.dev',
        },
    },
    contracts: {
        multicall3: {
            address: '0x0000000000000000000000000000000000003001',
            blockCreated: 0,
        },
    },
    testnet: true,
});

const metadium = /*#__PURE__*/ defineChain({
    id: 11,
    name: 'Metadium Network',
    nativeCurrency: {
        decimals: 18,
        name: 'META',
        symbol: 'META',
    },
    rpcUrls: {
        default: { http: ['https://api.metadium.com/prod'] },
    },
    blockExplorers: {
        default: {
            name: 'Metadium Explorer',
            url: 'https://explorer.metadium.com',
        },
    },
    testnet: false,
});

const sourceId$v = 1; // mainnet
const metalL2 = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 1750,
    name: 'Metal L2',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.metall2.com'],
            webSocket: ['wss://rpc.metall2.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Explorer',
            url: 'https://explorer.metall2.com',
            apiUrl: 'https://explorer.metall2.com/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$v]: {
                address: '0x3B1F7aDa0Fcc26B13515af752Dd07fB1CAc11426',
            },
        },
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 0,
        },
        portal: {
            [sourceId$v]: {
                address: '0x3F37aBdE2C6b5B2ed6F8045787Df1ED1E3753956',
            },
        },
        l1StandardBridge: {
            [sourceId$v]: {
                address: '0x6d0f65D59b55B0FEC5d2d15365154DcADC140BF3',
            },
        },
    },
    sourceId: sourceId$v,
});

const meter = /*#__PURE__*/ defineChain({
    id: 82,
    name: 'Meter',
    nativeCurrency: {
        decimals: 18,
        name: 'MTR',
        symbol: 'MTR',
    },
    rpcUrls: {
        default: { http: ['https://rpc.meter.io'] },
    },
    blockExplorers: {
        default: {
            name: 'MeterScan',
            url: 'https://scan.meter.io',
        },
    },
});

const meterTestnet = /*#__PURE__*/ defineChain({
    id: 83,
    name: 'Meter Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'MTR',
        symbol: 'MTR',
    },
    rpcUrls: {
        default: { http: ['https://rpctest.meter.io'] },
    },
    blockExplorers: {
        default: {
            name: 'MeterTestnetScan',
            url: 'https://scan-warringstakes.meter.io',
        },
    },
});

const metis = /*#__PURE__*/ defineChain({
    id: 1_088,
    name: 'Metis',
    nativeCurrency: {
        decimals: 18,
        name: 'Metis',
        symbol: 'METIS',
    },
    rpcUrls: {
        default: { http: ['https://andromeda.metis.io/?owner=1088'] },
    },
    blockExplorers: {
        default: {
            name: 'Metis Explorer',
            url: 'https://explorer.metis.io',
            apiUrl: 'https://api.routescan.io/v2/network/mainnet/evm/1088/etherscan/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 2338552,
        },
    },
});

const metisGoerli = /*#__PURE__*/ defineChain({
    id: 599,
    name: 'Metis Goerli',
    nativeCurrency: {
        decimals: 18,
        name: 'Metis Goerli',
        symbol: 'METIS',
    },
    rpcUrls: {
        default: { http: ['https://goerli.gateway.metisdevops.link'] },
    },
    blockExplorers: {
        default: {
            name: 'Metis Goerli Explorer',
            url: 'https://goerli.explorer.metisdevops.link',
            apiUrl: 'https://goerli.explorer.metisdevops.link/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 1006207,
        },
    },
});

const mev = /*#__PURE__*/ defineChain({
    id: 7518,
    name: 'MEVerse Chain Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'MEVerse',
        symbol: 'MEV',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.meversemainnet.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Explorer',
            url: 'https://www.meversescan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 86881340,
        },
    },
});

const mevTestnet = /*#__PURE__*/ defineChain({
    id: 4759,
    name: 'MEVerse Chain Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'MEVerse',
        symbol: 'MEV',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.meversetestnet.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Explorer',
            url: 'https://testnet.meversescan.io/',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 64371115,
        },
    },
    testnet: true,
});

const mint = /*#__PURE__*/ defineChain({
    id: 185,
    name: 'Mint Mainnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.mintchain.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Mintchain explorer',
            url: 'https://explorer.mintchain.io',
        },
    },
    testnet: false,
});

const mintSepoliaTestnet = /*#__PURE__*/ defineChain({
    id: 1686,
    name: 'Mint Sepolia Testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://testnet-rpc.mintchain.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Mintchain Testnet explorer',
            url: 'https://testnet-explorer.mintchain.io',
        },
    },
    testnet: true,
});

const mitosisTestnet = /*#__PURE__*/ defineChain({
    id: 124_832,
    name: 'Mitosis Testnet',
    nativeCurrency: { name: 'MITO', symbol: 'MITO', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.mitosis.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Mitosis testnet explorer',
            url: 'https://testnet.mitosiscan.xyz',
        },
    },
    testnet: true,
});

const sourceId$u = 1; // mainnet
const mode$1 = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 34443,
    name: 'Mode Mainnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.mode.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Modescan',
            url: 'https://modescan.io',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 2465882,
        },
        l2OutputOracle: {
            [sourceId$u]: {
                address: '0x4317ba146D4933D889518a3e5E11Fe7a53199b04',
            },
        },
        portal: {
            [sourceId$u]: {
                address: '0x8B34b14c7c7123459Cf3076b8Cb929BE097d0C07',
            },
        },
        l1StandardBridge: {
            [sourceId$u]: {
                address: '0x735aDBbE72226BD52e818E7181953f42E3b0FF21',
            },
        },
    },
    sourceId: sourceId$u,
});

const sourceId$t = 11_155_111; // sepolia
const modeTestnet = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 919,
    name: 'Mode Testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://sepolia.mode.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://sepolia.explorer.mode.network',
            apiUrl: 'https://sepolia.explorer.mode.network/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$t]: {
                address: '0x2634BD65ba27AB63811c74A63118ACb312701Bfa',
                blockCreated: 3778393,
            },
        },
        portal: {
            [sourceId$t]: {
                address: '0x320e1580effF37E008F1C92700d1eBa47c1B23fD',
                blockCreated: 3778395,
            },
        },
        l1StandardBridge: {
            [sourceId$t]: {
                address: '0xbC5C679879B2965296756CD959C3C739769995E2',
                blockCreated: 3778392,
            },
        },
        multicall3: {
            address: '0xBAba8373113Fb7a68f195deF18732e01aF8eDfCF',
            blockCreated: 3019007,
        },
    },
    testnet: true,
    sourceId: sourceId$t,
});

const monadTestnet = /*#__PURE__*/ defineChain({
    id: 10_143,
    name: 'Monad Testnet',
    nativeCurrency: {
        name: 'Testnet MON Token',
        symbol: 'MON',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://testnet-rpc.monad.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Monad Testnet explorer',
            url: 'https://testnet.monadexplorer.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 251449,
        },
    },
    testnet: true,
});

const moonbaseAlpha = /*#__PURE__*/ defineChain({
    id: 1287,
    name: 'Moonbase Alpha',
    nativeCurrency: {
        decimals: 18,
        name: 'DEV',
        symbol: 'DEV',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.api.moonbase.moonbeam.network'],
            webSocket: ['wss://wss.api.moonbase.moonbeam.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Moonscan',
            url: 'https://moonbase.moonscan.io',
            apiUrl: 'https://moonbase.moonscan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 1850686,
        },
    },
    testnet: true,
});

const moonbeam = /*#__PURE__*/ defineChain({
    id: 1284,
    name: 'Moonbeam',
    nativeCurrency: {
        decimals: 18,
        name: 'GLMR',
        symbol: 'GLMR',
    },
    rpcUrls: {
        default: {
            http: ['https://moonbeam.public.blastapi.io'],
            webSocket: ['wss://moonbeam.public.blastapi.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Moonscan',
            url: 'https://moonscan.io',
            apiUrl: 'https://api-moonbeam.moonscan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 609002,
        },
    },
    testnet: false,
});

const moonbeamDev = /*#__PURE__*/ defineChain({
    id: 1281,
    name: 'Moonbeam Development Node',
    nativeCurrency: {
        decimals: 18,
        name: 'DEV',
        symbol: 'DEV',
    },
    rpcUrls: {
        default: {
            http: ['http://127.0.0.1:9944'],
            webSocket: ['wss://127.0.0.1:9944'],
        },
    },
});

const moonriver = /*#__PURE__*/ defineChain({
    id: 1285,
    name: 'Moonriver',
    nativeCurrency: {
        decimals: 18,
        name: 'MOVR',
        symbol: 'MOVR',
    },
    rpcUrls: {
        default: {
            http: ['https://moonriver.public.blastapi.io'],
            webSocket: ['wss://moonriver.public.blastapi.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Moonscan',
            url: 'https://moonriver.moonscan.io',
            apiUrl: 'https://api-moonriver.moonscan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 1597904,
        },
    },
    testnet: false,
});

const morph = /*#__PURE__*/ defineChain({
    id: 2818,
    name: 'Morph',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.morphl2.io'],
            webSocket: ['wss://rpc.morphl2.io:8443'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Morph Explorer',
            url: 'https://explorer.morphl2.io',
        },
    },
    testnet: false,
});

const morphHolesky = /*#__PURE__*/ defineChain({
    id: 2810,
    name: 'Morph Holesky',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-quicknode-holesky.morphl2.io'],
            webSocket: ['wss://rpc-quicknode-holesky.morphl2.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Morph Holesky Explorer',
            url: 'https://explorer-holesky.morphl2.io',
            apiUrl: 'https://explorer-api-holesky.morphl2.io/api?',
        },
    },
    testnet: true,
});

const morphSepolia = /*#__PURE__*/ defineChain({
    id: 2710,
    name: 'Morph Sepolia',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-testnet.morphl2.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Morph Testnet Explorer',
            url: 'https://explorer-testnet.morphl2.io',
            apiUrl: 'https://explorer-api-testnet.morphl2.io/api',
        },
    },
    testnet: true,
});

const nahmii = /*#__PURE__*/ defineChain({
    id: 5551,
    name: 'Nahmii 2 Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['https://l2.nahmii.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Nahmii 2 Explorer',
            url: 'https://explorer.n2.nahmii.io',
        },
    },
    testnet: false,
});

const nautilus = /*#__PURE__*/ defineChain({
    id: 22222,
    name: 'Nautilus Mainnet',
    nativeCurrency: { name: 'ZBC', symbol: 'ZBC', decimals: 9 },
    rpcUrls: {
        default: {
            http: ['https://api.nautilus.nautchain.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'NautScan',
            url: 'https://nautscan.com',
        },
    },
});

const near = /*#__PURE__*/ defineChain({
    id: 397,
    name: 'NEAR Protocol',
    nativeCurrency: {
        decimals: 18,
        name: 'NEAR',
        symbol: 'NEAR',
    },
    rpcUrls: {
        default: { http: ['https://eth-rpc.mainnet.near.org'] },
    },
    blockExplorers: {
        default: {
            name: 'NEAR Explorer',
            url: 'https://eth-explorer.near.org',
        },
    },
    testnet: false,
});

const nearTestnet = /*#__PURE__*/ defineChain({
    id: 398,
    name: 'NEAR Protocol Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'NEAR',
        symbol: 'NEAR',
    },
    rpcUrls: {
        default: { http: ['https://eth-rpc.testnet.near.org'] },
    },
    blockExplorers: {
        default: {
            name: 'NEAR Explorer',
            url: 'https://eth-explorer-testnet.near.org',
        },
    },
    testnet: true,
});

const neonDevnet = /*#__PURE__*/ defineChain({
    id: 245_022_926,
    name: 'Neon EVM DevNet',
    nativeCurrency: { name: 'NEON', symbol: 'NEON', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://devnet.neonevm.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Neonscan',
            url: 'https://devnet.neonscan.org',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 205206112,
        },
    },
    testnet: true,
});

const neonMainnet = /*#__PURE__*/ defineChain({
    id: 245_022_934,
    network: 'neonMainnet',
    name: 'Neon EVM MainNet',
    nativeCurrency: { name: 'NEON', symbol: 'NEON', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://neon-proxy-mainnet.solana.p2p.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Neonscan',
            url: 'https://neonscan.org',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 206545524,
        },
    },
    testnet: false,
});

const neoxMainnet = /*#__PURE__*/ defineChain({
    id: 47763,
    name: 'Neo X Mainnet',
    nativeCurrency: { name: 'Gas', symbol: 'GAS', decimals: 18 },
    rpcUrls: {
        default: {
            http: [
                'https://mainnet-1.rpc.banelabs.org',
                'https://mainnet-2.rpc.banelabs.org',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'Neo X - Explorer',
            url: 'https://xexplorer.neo.org',
        },
    },
    testnet: false,
});

const neoxT4 = /*#__PURE__*/ defineChain({
    id: 12227332,
    name: 'Neo X Testnet T4',
    nativeCurrency: { name: 'Gas', symbol: 'GAS', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://testnet.rpc.banelabs.org/'],
        },
    },
    blockExplorers: {
        default: {
            name: 'neox-scan',
            url: 'https://xt4scan.ngd.network',
        },
    },
    testnet: true,
});

const nexi = /*#__PURE__*/ defineChain({
    id: 4242,
    name: 'Nexi',
    nativeCurrency: { name: 'Nexi', symbol: 'NEXI', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.chain.nexi.technology'],
        },
    },
    blockExplorers: {
        default: {
            name: 'NexiScan',
            url: 'https://www.nexiscan.com',
            apiUrl: 'https://www.nexiscan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0x0277A46Cc69A57eE3A6C8c158bA874832F718B8E',
            blockCreated: 25770160,
        },
    },
});

const nexilix = /*#__PURE__*/ defineChain({
    id: 240,
    name: 'Nexilix Smart Chain',
    nativeCurrency: {
        decimals: 18,
        name: 'Nexilix',
        symbol: 'NEXILIX',
    },
    rpcUrls: {
        default: { http: ['https://rpcurl.pos.nexilix.com'] },
    },
    blockExplorers: {
        default: {
            name: 'NexilixScan',
            url: 'https://scan.nexilix.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0x58381c8e2BF9d0C2C4259cA14BdA9Afe02831244',
            blockCreated: 74448,
        },
    },
});

const oasisTestnet = /*#__PURE__*/ defineChain({
    id: 4090,
    network: 'oasis-testnet',
    name: 'Oasis Testnet',
    nativeCurrency: { name: 'Fasttoken', symbol: 'FTN', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc1.oasis.bahamutchain.com'] },
    },
    blockExplorers: {
        default: {
            name: 'Ftnscan',
            url: 'https://oasis.ftnscan.com',
            apiUrl: 'https://oasis.ftnscan.com/api',
        },
    },
    testnet: true,
});

const oasys = /*#__PURE__*/ defineChain({
    id: 248,
    name: 'Oasys',
    nativeCurrency: { name: 'Oasys', symbol: 'OAS', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.mainnet.oasys.games'],
        },
    },
    blockExplorers: {
        default: {
            name: 'OasysScan',
            url: 'https://scan.oasys.games',
            apiUrl: 'https://scan.oasys.games/api',
        },
    },
});

const odysseyTestnet = /*#__PURE__*/ defineChain({
    id: 911867,
    name: 'Odyssey Testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://odyssey.ithaca.xyz'] },
    },
    blockExplorers: {
        default: {
            name: 'Odyssey Explorer',
            url: 'https://odyssey-explorer.ithaca.xyz',
            apiUrl: 'https://odyssey-explorer.ithaca.xyz/api',
        },
    },
    testnet: true,
});

const okc = /*#__PURE__*/ defineChain({
    id: 66,
    name: 'OKC',
    nativeCurrency: {
        decimals: 18,
        name: 'OKT',
        symbol: 'OKT',
    },
    rpcUrls: {
        default: { http: ['https://exchainrpc.okex.org'] },
    },
    blockExplorers: {
        default: {
            name: 'oklink',
            url: 'https://www.oklink.com/okc',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 10364792,
        },
    },
});

const omax = /*#__PURE__*/ defineChain({
    id: 311,
    name: 'Omax Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'OMAX',
        symbol: 'OMAX',
    },
    rpcUrls: {
        default: { http: ['https://mainapi.omaxray.com'] },
    },
    blockExplorers: {
        default: {
            name: 'Omax Explorer',
            url: 'https://omaxscan.com',
        },
    },
    testnet: false,
});

const oneWorld = /*#__PURE__*/ defineChain({
    id: 309075,
    name: 'One World Chain Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'OWCT',
        symbol: 'OWCT',
    },
    rpcUrls: {
        default: { http: ['https://mainnet-rpc.oneworldchain.org'] },
    },
    blockExplorers: {
        default: {
            name: 'One World Explorer',
            url: 'https://mainnet.oneworldchain.org',
        },
    },
    testnet: false,
});

const oortMainnetDev = /*#__PURE__*/ defineChain({
    id: 9700,
    name: 'OORT MainnetDev',
    nativeCurrency: {
        decimals: 18,
        name: 'OORT',
        symbol: 'OORT',
    },
    rpcUrls: {
        default: { http: ['https://dev-rpc.oortech.com'] },
    },
    blockExplorers: {
        default: {
            name: 'OORT MainnetDev Explorer',
            url: 'https://dev-scan.oortech.com',
        },
    },
});

const sourceId$s = 56; // bsc mainnet
const opBNB = /*#__PURE__*/ defineChain({
    id: 204,
    name: 'opBNB',
    nativeCurrency: {
        name: 'BNB',
        symbol: 'BNB',
        decimals: 18,
    },
    rpcUrls: {
        default: { http: ['https://opbnb-mainnet-rpc.bnbchain.org'] },
    },
    blockExplorers: {
        default: {
            name: 'opBNB (BSCScan)',
            url: 'https://opbnb.bscscan.com',
            apiUrl: 'https://api-opbnb.bscscan.com/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 512881,
        },
        l2OutputOracle: {
            [sourceId$s]: {
                address: '0x153CAB79f4767E2ff862C94aa49573294B13D169',
            },
        },
        portal: {
            [sourceId$s]: {
                address: '0x1876EA7702C0ad0C6A2ae6036DE7733edfBca519',
            },
        },
        l1StandardBridge: {
            [sourceId$s]: {
                address: '0xF05F0e4362859c3331Cb9395CBC201E3Fa6757Ea',
            },
        },
    },
    sourceId: sourceId$s,
});

const sourceId$r = 97; // bsc testnet
const opBNBTestnet = /*#__PURE__*/ defineChain({
    id: 5611,
    name: 'opBNB Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'tBNB',
        symbol: 'tBNB',
    },
    rpcUrls: {
        default: { http: ['https://opbnb-testnet-rpc.bnbchain.org'] },
    },
    blockExplorers: {
        default: {
            name: 'opbnbscan',
            url: 'https://testnet.opbnbscan.com',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 3705108,
        },
        l2OutputOracle: {
            [sourceId$r]: {
                address: '0xFf2394Bb843012562f4349C6632a0EcB92fC8810',
            },
        },
        portal: {
            [sourceId$r]: {
                address: '0x4386C8ABf2009aC0c263462Da568DD9d46e52a31',
            },
        },
        l1StandardBridge: {
            [sourceId$r]: {
                address: '0x677311Fd2cCc511Bbc0f581E8d9a07B033D5E840',
            },
        },
    },
    testnet: true,
    sourceId: sourceId$r,
});

const sourceId$q = 1; // mainnet
const optimism = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 10,
    name: 'OP Mainnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.optimism.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Optimism Explorer',
            url: 'https://optimistic.etherscan.io',
            apiUrl: 'https://api-optimistic.etherscan.io/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        disputeGameFactory: {
            [sourceId$q]: {
                address: '0xe5965Ab5962eDc7477C8520243A95517CD252fA9',
            },
        },
        l2OutputOracle: {
            [sourceId$q]: {
                address: '0xdfe97868233d1aa22e815a266982f2cf17685a27',
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 4286263,
        },
        portal: {
            [sourceId$q]: {
                address: '0xbEb5Fc579115071764c7423A4f12eDde41f106Ed',
            },
        },
        l1StandardBridge: {
            [sourceId$q]: {
                address: '0x99C9fc46f92E8a1c0deC1b1747d010903E884bE1',
            },
        },
    },
    sourceId: sourceId$q,
});

const sourceId$p = 5; // goerli
const optimismGoerli = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 420,
    name: 'Optimism Goerli',
    nativeCurrency: { name: 'Goerli Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://goerli.optimism.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://goerli-optimism.etherscan.io',
            apiUrl: 'https://goerli-optimism.etherscan.io/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$p]: {
                address: '0xE6Dfba0953616Bacab0c9A8ecb3a9BBa77FC15c0',
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 49461,
        },
        portal: {
            [sourceId$p]: {
                address: '0x5b47E1A08Ea6d985D6649300584e6722Ec4B1383',
            },
        },
        l1StandardBridge: {
            [sourceId$p]: {
                address: '0x636Af16bf2f682dD3109e60102b8E1A089FedAa8',
            },
        },
    },
    testnet: true,
    sourceId: sourceId$p,
});

const sourceId$o = 11_155_111; // sepolia
const optimismSepolia = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 11155420,
    name: 'OP Sepolia',
    nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://sepolia.optimism.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://optimism-sepolia.blockscout.com',
            apiUrl: 'https://optimism-sepolia.blockscout.com/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        disputeGameFactory: {
            [sourceId$o]: {
                address: '0x05F9613aDB30026FFd634f38e5C4dFd30a197Fa1',
            },
        },
        l2OutputOracle: {
            [sourceId$o]: {
                address: '0x90E9c4f8a994a250F6aEfd61CAFb4F2e895D458F',
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 1620204,
        },
        portal: {
            [sourceId$o]: {
                address: '0x16Fc5058F25648194471939df75CF27A2fdC48BC',
            },
        },
        l1StandardBridge: {
            [sourceId$o]: {
                address: '0xFBb0621E0B23b5478B630BD55a5f21f67730B0F1',
            },
        },
    },
    testnet: true,
    sourceId: sourceId$o,
});

const optopia = /*#__PURE__*/ defineChain({
    id: 62050,
    name: 'Optopia',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc-mainnet.optopia.ai'] },
    },
    blockExplorers: {
        default: {
            name: 'Optopia Explorer',
            url: 'https://scan.optopia.ai',
        },
    },
    testnet: false,
});

const optopiaTestnet = /*#__PURE__*/ defineChain({
    id: 62049,
    name: 'Optopia Testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc-testnet.optopia.ai'] },
    },
    blockExplorers: {
        default: {
            name: 'Optopia Explorer',
            url: 'https://scan-testnet.optopia.ai',
        },
    },
    testnet: true,
});

const orderly = /*#__PURE__*/ defineChain({
    id: 291,
    name: 'Orderly',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc.orderly.network'] },
    },
    blockExplorers: {
        default: {
            name: 'Orderly Explorer',
            url: 'https://explorer.orderly.network',
        },
    },
    testnet: false,
});

const orderlySepolia = /*#__PURE__*/ defineChain({
    id: 4460,
    name: 'Orderly Sepolia',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://l2-orderly-l2-4460-sepolia-8tc3sd7dvy.t.conduit.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Orderly Explorer',
            url: 'https://explorerl2new-orderly-l2-4460-sepolia-8tc3sd7dvy.t.conduit.xyz',
        },
    },
    testnet: true,
});

const otimDevnet = /*#__PURE__*/ defineChain({
    id: 41144114,
    name: 'Otim Devnet',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['http://devnet.otim.xyz'],
        },
    },
    contracts: {
        batchInvoker: {
            address: '0x5FbDB2315678afecb367f032d93F642f64180aa3',
        },
    },
});

const palm = /*#__PURE__*/ defineChain({
    id: 11_297_108_109,
    name: 'Palm',
    nativeCurrency: {
        decimals: 18,
        name: 'PALM',
        symbol: 'PALM',
    },
    rpcUrls: {
        default: {
            http: ['https://palm-mainnet.public.blastapi.io'],
            webSocket: ['wss://palm-mainnet.public.blastapi.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Chainlens',
            url: 'https://palm.chainlens.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 15429248,
        },
    },
});

const palmTestnet = /*#__PURE__*/ defineChain({
    id: 11_297_108_099,
    name: 'Palm Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'PALM',
        symbol: 'PALM',
    },
    rpcUrls: {
        default: {
            http: ['https://palm-mainnet.public.blastapi.io'],
            webSocket: ['wss://palm-mainnet.public.blastapi.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Chainlens',
            url: 'https://palm.chainlens.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 15429248,
        },
    },
    testnet: true,
});

const sourceId$n = 1; // mainnet
const pgn = /*#__PURE__*/ defineChain({
    id: 424,
    network: 'pgn',
    name: 'PGN',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.publicgoods.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'PGN Explorer',
            url: 'https://explorer.publicgoods.network',
            apiUrl: 'https://explorer.publicgoods.network/api',
        },
    },
    contracts: {
        l2OutputOracle: {
            [sourceId$n]: {
                address: '0x9E6204F750cD866b299594e2aC9eA824E2e5f95c',
            },
        },
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 3380209,
        },
        portal: {
            [sourceId$n]: {
                address: '0xb26Fd985c5959bBB382BAFdD0b879E149e48116c',
            },
        },
        l1StandardBridge: {
            [sourceId$n]: {
                address: '0xD0204B9527C1bA7bD765Fa5CCD9355d38338272b',
            },
        },
    },
    formatters: formatters$1,
    sourceId: sourceId$n,
});

const sourceId$m = 11_155_111; // sepolia
const pgnTestnet = /*#__PURE__*/ defineChain({
    id: 58008,
    network: 'pgn-testnet',
    name: 'PGN ',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://sepolia.publicgoods.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'PGN Testnet Explorer',
            url: 'https://explorer.sepolia.publicgoods.network',
            apiUrl: 'https://explorer.sepolia.publicgoods.network/api',
        },
    },
    contracts: {
        l2OutputOracle: {
            [sourceId$m]: {
                address: '0xD5bAc3152ffC25318F848B3DD5dA6C85171BaEEe',
            },
        },
        portal: {
            [sourceId$m]: {
                address: '0xF04BdD5353Bb0EFF6CA60CfcC78594278eBfE179',
            },
        },
        l1StandardBridge: {
            [sourceId$m]: {
                address: '0xFaE6abCAF30D23e233AC7faF747F2fC3a5a6Bfa3',
            },
        },
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 3754925,
        },
    },
    formatters: formatters$1,
    sourceId: sourceId$m,
    testnet: true,
});

// src/chains/definitions/phoenix.ts
const phoenix = /*#__PURE__*/ defineChain({
    id: 13381,
    name: 'Phoenix Blockchain',
    nativeCurrency: { name: 'Phoenix', symbol: 'PHX', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.phoenixplorer.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Phoenixplorer',
            url: 'https://phoenixplorer.com',
            apiUrl: 'https://phoenixplorer.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0x498cF757a575cFF2c2Ed9f532f56Efa797f86442',
            blockCreated: 5620192,
        },
    },
});

const planq = /*#__PURE__*/ defineChain({
    id: 7070,
    name: 'Planq Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'PLQ',
        symbol: 'PLQ',
    },
    rpcUrls: {
        default: { http: ['https://evm-rpc.planq.network'] },
    },
    blockExplorers: {
        default: {
            name: 'Planq Explorer',
            url: 'https://evm.planq.network',
        },
    },
    testnet: false,
});

const playfiAlbireo = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 1_612_127,
    name: 'PlayFi Albireo Testnet',
    network: 'albireo',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://albireo-rpc.playfi.ai'],
            webSocket: ['wss://albireo-rpc-ws.playfi.ai/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'PlayFi Albireo Explorer',
            url: 'https://albireo-explorer.playfi.ai',
        },
    },
    contracts: {
        multicall3: {
            address: '0xF9cda624FBC7e059355ce98a31693d299FACd963',
        },
    },
    testnet: true,
});

const plinga = /*#__PURE__*/ defineChain({
    id: 242,
    name: 'Plinga',
    nativeCurrency: { name: 'Plinga', symbol: 'PLINGA', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpcurl.mainnet.plgchain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Plgscan',
            url: 'https://www.plgscan.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0x0989576160f2e7092908BB9479631b901060b6e4',
            blockCreated: 204489,
        },
    },
});

const sourceId$l = 1; // ethereum
const plume = /*#__PURE__*/ defineChain({
    id: 98_865,
    name: 'Plume Mainnet',
    nativeCurrency: {
        name: 'Plume Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.plumenetwork.xyz'],
            webSocket: ['wss://rpc.plumenetwork.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://explorer.plumenetwork.xyz',
            apiUrl: 'https://explorer.plumenetwork.xyz/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 48_577,
        },
    },
    sourceId: sourceId$l,
});

const sourceId$k = 11_155_111; // sepolia
const plumeDevnet = /*#__PURE__*/ defineChain({
    id: 98_864,
    name: 'Plume Devnet',
    nativeCurrency: {
        name: 'Plume Sepolia Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://test-rpc.plumenetwork.xyz'],
            webSocket: ['wss://test-rpc.plumenetwork.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://test-explorer.plumenetwork.xyz',
            apiUrl: 'https://test-explorer.plumenetwork.xyz/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 481_948,
        },
    },
    testnet: true,
    sourceId: sourceId$k,
});

const sourceId$j = 11_155_111; // sepolia
const plumeTestnet = /*#__PURE__*/ defineChain({
    id: 161_221_135,
    name: 'Plume Testnet',
    nativeCurrency: {
        name: 'Plume Sepolia Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://testnet-rpc.plumenetwork.xyz/http'],
            webSocket: ['wss://testnet-rpc.plumenetwork.xyz/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://testnet-explorer.plumenetwork.xyz',
            apiUrl: 'https://testnet-explorer.plumenetwork.xyz/api',
        },
    },
    testnet: true,
    sourceId: sourceId$j,
});

const polterTestnet = /*#__PURE__*/ defineChain({
    id: 631571,
    name: 'Polter Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Polter GHST',
        symbol: 'GHST',
    },
    rpcUrls: {
        default: {
            http: ['https://geist-polter.g.alchemy.com/public'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://polter-testnet.explorer.alchemy.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 11245,
        },
    },
    testnet: true,
});

const polygon = /*#__PURE__*/ defineChain({
    id: 137,
    name: 'Polygon',
    nativeCurrency: { name: 'POL', symbol: 'POL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://polygon-rpc.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'PolygonScan',
            url: 'https://polygonscan.com',
            apiUrl: 'https://api.polygonscan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 25770160,
        },
    },
});

const polygonAmoy = /*#__PURE__*/ defineChain({
    id: 80_002,
    name: 'Polygon Amoy',
    nativeCurrency: { name: 'POL', symbol: 'POL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-amoy.polygon.technology'],
        },
    },
    blockExplorers: {
        default: {
            name: 'PolygonScan',
            url: 'https://amoy.polygonscan.com',
            apiUrl: 'https://api-amoy.polygonscan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 3127388,
        },
    },
    testnet: true,
});

const polygonMumbai = /*#__PURE__*/ defineChain({
    id: 80_001,
    name: 'Polygon Mumbai',
    nativeCurrency: { name: 'MATIC', symbol: 'MATIC', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.ankr.com/polygon_mumbai'],
        },
    },
    blockExplorers: {
        default: {
            name: 'PolygonScan',
            url: 'https://mumbai.polygonscan.com',
            apiUrl: 'https://api-testnet.polygonscan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 25770160,
        },
    },
    testnet: true,
});

const polygonZkEvm = /*#__PURE__*/ defineChain({
    id: 1101,
    name: 'Polygon zkEVM',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://zkevm-rpc.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'PolygonScan',
            url: 'https://zkevm.polygonscan.com',
            apiUrl: 'https://api-zkevm.polygonscan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 57746,
        },
    },
});

const polygonZkEvmCardona = /*#__PURE__*/ defineChain({
    id: 2442,
    name: 'Polygon zkEVM Cardona',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.cardona.zkevm-rpc.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'PolygonScan',
            url: 'https://cardona-zkevm.polygonscan.com',
            apiUrl: 'https://cardona-zkevm.polygonscan.com/api',
        },
    },
    testnet: true,
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 114091,
        },
    },
});

const polygonZkEvmTestnet = /*#__PURE__*/ defineChain({
    id: 1442,
    name: 'Polygon zkEVM Testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.public.zkevm-test.net'],
        },
    },
    blockExplorers: {
        default: {
            name: 'PolygonScan',
            url: 'https://testnet-zkevm.polygonscan.com',
            apiUrl: 'https://testnet-zkevm.polygonscan.com/api',
        },
    },
    testnet: true,
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 525686,
        },
    },
});

const premiumBlockTestnet = /*#__PURE__*/ defineChain({
    id: 23_023,
    name: 'PremiumBlock Testnet',
    nativeCurrency: { name: 'Premium Block', symbol: 'PBLK', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.premiumblock.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'PremiumBlocks Explorer',
            url: 'https://scan.premiumblock.org',
        },
    },
    testnet: true,
});

const pulsechain = /*#__PURE__*/ defineChain({
    id: 369,
    name: 'PulseChain',
    nativeCurrency: { name: 'Pulse', symbol: 'PLS', decimals: 18 },
    testnet: false,
    rpcUrls: {
        default: {
            http: ['https://rpc.pulsechain.com'],
            webSocket: ['wss://ws.pulsechain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'PulseScan',
            url: 'https://scan.pulsechain.com',
            apiUrl: 'https://api.scan.pulsechain.com/api',
        },
    },
    contracts: {
        ensRegistry: {
            address: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 14353601,
        },
    },
});

const pulsechainV4 = /*#__PURE__*/ defineChain({
    id: 943,
    name: 'PulseChain V4',
    testnet: true,
    nativeCurrency: { name: 'V4 Pulse', symbol: 'v4PLS', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.v4.testnet.pulsechain.com'],
            webSocket: ['wss://ws.v4.testnet.pulsechain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'PulseScan',
            url: 'https://scan.v4.testnet.pulsechain.com',
            apiUrl: 'https://scan.v4.testnet.pulsechain.com/api',
        },
    },
    contracts: {
        ensRegistry: {
            address: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 14353601,
        },
    },
});

const ql1 = /*#__PURE__*/ defineChain({
    id: 766,
    name: 'QL1',
    nativeCurrency: {
        decimals: 18,
        name: 'QOM',
        symbol: 'QOM',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.qom.one'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Ql1 Explorer',
            url: 'https://scan.qom.one',
        },
    },
    contracts: {
        multicall3: {
            address: '0x7A52370716ea730585884F5BDB0f6E60C39b8C64',
        },
    },
    testnet: false,
});

const qMainnet = /*#__PURE__*/ defineChain({
    id: 35441,
    name: 'Q Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Q',
        symbol: 'Q',
    },
    rpcUrls: {
        default: { http: ['https://rpc.q.org'] },
    },
    blockExplorers: {
        default: {
            name: 'Q Mainnet Explorer',
            url: 'https://explorer.q.org',
            apiUrl: 'https://explorer.q.org/api',
        },
    },
});

const qTestnet = /*#__PURE__*/ defineChain({
    id: 35443,
    name: 'Q Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Q',
        symbol: 'Q',
    },
    rpcUrls: {
        default: { http: ['https://rpc.qtestnet.org'] },
    },
    blockExplorers: {
        default: {
            name: 'Q Testnet Explorer',
            url: 'https://explorer.qtestnet.org',
            apiUrl: 'https://explorer.qtestnet.org/api',
        },
    },
    testnet: true,
});

const real = /*#__PURE__*/ defineChain({
    id: 111188,
    name: 're.al',
    nativeCurrency: {
        name: 'reETH',
        decimals: 18,
        symbol: 'reETH',
    },
    rpcUrls: {
        default: { http: ['https://real.drpc.org'] },
    },
    blockExplorers: {
        default: {
            name: 're.al Explorer',
            url: 'https://explorer.re.al',
            apiUrl: 'https://explorer.re.al/api/v2',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 695,
        },
    },
});

const redbellyMainnet = /*#__PURE__*/ defineChain({
    id: 151,
    name: 'Redbelly Network Mainnet',
    nativeCurrency: {
        name: 'Redbelly Native Coin',
        symbol: 'RBNT',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://governors.mainnet.redbelly.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Routescan',
            url: 'https://redbelly.routescan.io',
            apiUrl: 'https://api.routescan.io/v2/network/mainnet/evm/151/etherscan/api',
        },
    },
    testnet: false,
});

const redbellyTestnet = /*#__PURE__*/ defineChain({
    id: 153,
    name: 'Redbelly Network Testnet',
    nativeCurrency: {
        name: 'Redbelly Native Coin',
        symbol: 'RBNT',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://governors.testnet.redbelly.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Routescan',
            url: 'https://redbelly.testnet.routescan.io',
            apiUrl: 'https://api.routescan.io/v2/network/testnet/evm/153_2/etherscan/api',
        },
    },
    testnet: true,
});

const sourceId$i = 1; // Ethereum mainnet
const redstone = defineChain({
    ...chainConfig$2,
    name: 'Redstone',
    id: 690,
    sourceId: sourceId$i,
    nativeCurrency: { decimals: 18, name: 'Ether', symbol: 'ETH' },
    rpcUrls: {
        default: {
            http: ['https://rpc.redstonechain.com'],
            webSocket: ['wss://rpc.redstonechain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://explorer.redstone.xyz',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
        },
        portal: {
            [sourceId$i]: {
                address: '0xC7bCb0e8839a28A1cFadd1CF716de9016CdA51ae',
                blockCreated: 19578329,
            },
        },
        l2OutputOracle: {
            [sourceId$i]: {
                address: '0xa426A052f657AEEefc298b3B5c35a470e4739d69',
                blockCreated: 19578337,
            },
        },
        l1StandardBridge: {
            [sourceId$i]: {
                address: '0xc473ca7E02af24c129c2eEf51F2aDf0411c1Df69',
                blockCreated: 19578331,
            },
        },
    },
});

const rei = /*#__PURE__*/ defineChain({
    id: 47805,
    name: 'REI Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'REI',
        symbol: 'REI',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.rei.network'],
            webSocket: ['wss://rpc.rei.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'REI Scan',
            url: 'https://scan.rei.network',
        },
    },
    testnet: false,
});

const reyaNetwork = /*#__PURE__*/ defineChain({
    id: 1729,
    name: 'Reya Network',
    nativeCurrency: { decimals: 18, name: 'Ether', symbol: 'ETH' },
    rpcUrls: {
        default: {
            http: ['https://rpc.reya.network'],
            webSocket: ['wss://ws.reya.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Reya Network Explorer',
            url: 'https://explorer.reya.network',
        },
    },
    testnet: false,
});

const reddioSepolia = /*#__PURE__*/ defineChain({
    id: 50341,
    name: 'Reddio Sepolia',
    nativeCurrency: { name: 'Reddio', symbol: 'RED', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://reddio-dev.reddio.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Reddioscan',
            url: 'https://reddio-devnet.l2scan.co',
            apiUrl: 'https://reddio-devnet.l2scan.co/api',
        },
    },
    testnet: true,
});

const rivalz = /*#__PURE__*/ defineChain({
    id: 753,
    name: 'Rivalz',
    nativeCurrency: { decimals: 18, name: 'Ether', symbol: 'ETH' },
    rpcUrls: {
        default: {
            http: ['https://rivalz.calderachain.xyz/http'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Rivalz Caldera Explorer',
            url: 'https://rivalz.calderaexplorer.xyz',
        },
    },
    testnet: false,
});

const rollux = /*#__PURE__*/ defineChain({
    id: 570,
    name: 'Rollux Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Syscoin',
        symbol: 'SYS',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.rollux.com'],
            webSocket: ['wss://rpc.rollux.com/wss'],
        },
    },
    blockExplorers: {
        default: {
            name: 'RolluxExplorer',
            url: 'https://explorer.rollux.com',
            apiUrl: 'https://explorer.rollux.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 119222,
        },
    },
});

const rolluxTestnet = /*#__PURE__*/ defineChain({
    id: 57000,
    name: 'Rollux Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Syscoin',
        symbol: 'SYS',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc-tanenbaum.rollux.com/'],
            webSocket: ['wss://rpc-tanenbaum.rollux.com/wss'],
        },
    },
    blockExplorers: {
        default: {
            name: 'RolluxTestnetExplorer',
            url: 'https://rollux.tanenbaum.io',
            apiUrl: 'https://rollux.tanenbaum.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 1813675,
        },
    },
});

const ronin = /*#__PURE__*/ defineChain({
    id: 2020,
    name: 'Ronin',
    nativeCurrency: { name: 'RON', symbol: 'RON', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://api.roninchain.com/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Ronin Explorer',
            url: 'https://app.roninchain.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 26023535,
        },
    },
});

const root$1 = /*#__PURE__*/ defineChain({
    id: 7668,
    name: 'The Root Network',
    nativeCurrency: {
        decimals: 18,
        name: 'XRP',
        symbol: 'XRP',
    },
    rpcUrls: {
        default: {
            http: ['https://root.rootnet.live/archive'],
            webSocket: ['wss://root.rootnet.live/archive/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Rootscan',
            url: 'https://rootscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xc9C2E2429AeC354916c476B30d729deDdC94988d',
            blockCreated: 9218338,
        },
    },
});

const rootPorcini = /*#__PURE__*/ defineChain({
    id: 7672,
    name: 'The Root Network - Porcini',
    nativeCurrency: {
        decimals: 18,
        name: 'XRP',
        symbol: 'XRP',
    },
    rpcUrls: {
        default: {
            http: ['https://porcini.rootnet.app/archive'],
            webSocket: ['wss://porcini.rootnet.app/archive/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Rootscan',
            url: 'https://porcini.rootscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xc9C2E2429AeC354916c476B30d729deDdC94988d',
            blockCreated: 10555692,
        },
    },
    testnet: true,
});

const rootstock = /*#__PURE__*/ defineChain({
    id: 30,
    name: 'Rootstock Mainnet',
    network: 'rootstock',
    nativeCurrency: {
        decimals: 18,
        name: 'Rootstock Bitcoin',
        symbol: 'RBTC',
    },
    rpcUrls: {
        default: { http: ['https://public-node.rsk.co'] },
    },
    blockExplorers: {
        default: {
            name: 'RSK Explorer',
            url: 'https://explorer.rsk.co',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 4249540,
        },
    },
});

const rootstockTestnet = /*#__PURE__*/ defineChain({
    id: 31,
    name: 'Rootstock Testnet',
    network: 'rootstock',
    nativeCurrency: {
        decimals: 18,
        name: 'Rootstock Bitcoin',
        symbol: 'tRBTC',
    },
    rpcUrls: {
        default: { http: ['https://public-node.testnet.rsk.co'] },
    },
    blockExplorers: {
        default: {
            name: 'RSK Explorer',
            url: 'https://explorer.testnet.rootstock.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 2771150,
        },
    },
    testnet: true,
});

const sourceId$h = 1; // mainnet
const rss3 = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 12_553,
    name: 'RSS3 VSL Mainnet',
    nativeCurrency: { name: 'RSS3', symbol: 'RSS3', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.rss3.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'RSS3 VSL Mainnet Scan',
            url: 'https://scan.rss3.io',
            apiUrl: 'https://scan.rss3.io/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$h]: {
                address: '0xE6f24d2C32B3109B18ed33cF08eFb490b1e09C10',
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 14193,
        },
        portal: {
            [sourceId$h]: {
                address: '0x6A12432491bbbE8d3babf75F759766774C778Db4',
                blockCreated: 19387057,
            },
        },
        l1StandardBridge: {
            [sourceId$h]: {
                address: '0x4cbab69108Aa72151EDa5A3c164eA86845f18438',
            },
        },
    },
    sourceId: sourceId$h,
});

const sourceId$g = 11_155_111; // sepolia
const rss3Sepolia = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 2_331,
    name: 'RSS3 VSL Sepolia Testnet',
    nativeCurrency: { name: 'RSS3', symbol: 'RSS3', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.rss3.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'RSS3 VSL Sepolia Testnet Scan',
            url: 'https://scan.testnet.rss3.io',
            apiUrl: 'https://scan.testnet.rss3.io/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$g]: {
                address: '0xDb5c46C3Eaa6Ed6aE8b2379785DF7dd029C0dC81',
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 55697,
        },
        portal: {
            [sourceId$g]: {
                address: '0xcBD77E8E1E7F06B25baDe67142cdE82652Da7b57',
                blockCreated: 5345035,
            },
        },
        l1StandardBridge: {
            [sourceId$g]: {
                address: '0xdDD29bb63B0839FB1cE0eE439Ff027738595D07B',
            },
        },
    },
    testnet: true,
    sourceId: sourceId$g,
});

const saakuru = /*#__PURE__*/ defineChain({
    id: 7225878,
    name: 'Saakuru Mainnet',
    nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.saakuru.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Saakuru Explorer',
            url: 'https://explorer.saakuru.network',
        },
    },
    testnet: false,
});

const saga = /*#__PURE__*/ defineChain({
    id: 5464,
    name: 'Saga',
    network: 'saga',
    nativeCurrency: {
        decimals: 18,
        name: 'gas',
        symbol: 'GAS',
    },
    rpcUrls: {
        default: { http: ['http://sagaevm-5464-1.jsonrpc.sagarpc.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Saga Explorer',
            url: 'https://sagaevm-5464-1.sagaexplorer.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0x864DDc9B50B9A0dF676d826c9B9EDe9F8913a160',
            blockCreated: 467530,
        },
    },
});

const saigon = /*#__PURE__*/ defineChain({
    id: 2021,
    name: 'Saigon Testnet',
    nativeCurrency: { name: 'RON', symbol: 'RON', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://saigon-testnet.roninchain.com/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Saigon Explorer',
            url: 'https://saigon-app.roninchain.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 18736871,
        },
    },
    testnet: true,
});

const sanko = /*#__PURE__*/ defineChain({
    id: 1996,
    name: 'Sanko',
    nativeCurrency: { name: 'DMT', symbol: 'DMT', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.sanko.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Sanko Explorer',
            url: 'https://explorer.sanko.xyz',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 37,
        },
    },
    testnet: false,
});

const sapphire = /*#__PURE__*/ defineChain({
    id: 23294,
    name: 'Oasis Sapphire',
    network: 'sapphire',
    nativeCurrency: { name: 'Sapphire Rose', symbol: 'ROSE', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://sapphire.oasis.io'],
            webSocket: ['wss://sapphire.oasis.io/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Oasis Explorer',
            url: 'https://explorer.oasis.io/mainnet/sapphire',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 734531,
        },
    },
});

const sapphireTestnet = /*#__PURE__*/ defineChain({
    id: 23295,
    name: 'Oasis Sapphire Testnet',
    network: 'sapphire-testnet',
    nativeCurrency: { name: 'Sapphire Test Rose', symbol: 'TEST', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://testnet.sapphire.oasis.dev'],
            webSocket: ['wss://testnet.sapphire.oasis.dev/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Oasis Explorer',
            url: 'https://explorer.oasis.io/testnet/sapphire',
        },
    },
    testnet: true,
});

const satoshiVM = /*#__PURE__*/ defineChain({
    id: 3109,
    name: 'SatoshiVM Alpha Mainnet',
    nativeCurrency: {
        name: 'BTC',
        symbol: 'BTC',
        decimals: 18,
    },
    rpcUrls: {
        default: { http: ['https://alpha-rpc-node-http.svmscan.io'] },
    },
    blockExplorers: {
        default: {
            name: 'blockscout',
            url: 'https://svmscan.io',
            apiUrl: 'https://svmscan.io/api',
        },
    },
});

const satoshiVMTestnet = /*#__PURE__*/ defineChain({
    id: 3110,
    name: 'SatoshiVM Testnet',
    nativeCurrency: {
        name: 'BTC',
        symbol: 'BTC',
        decimals: 18,
    },
    rpcUrls: {
        default: { http: ['https://test-rpc-node-http.svmscan.io'] },
    },
    blockExplorers: {
        default: {
            name: 'blockscout',
            url: 'https://testnet.svmscan.io',
            apiUrl: 'https://testnet.svmscan.io/api',
        },
    },
    testnet: true,
});

const scroll = /*#__PURE__*/ defineChain({
    id: 534_352,
    name: 'Scroll',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.scroll.io'],
            webSocket: ['wss://wss-rpc.scroll.io/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Scrollscan',
            url: 'https://scrollscan.com',
            apiUrl: 'https://api.scrollscan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 14,
        },
    },
    testnet: false,
});

const scrollSepolia = /*#__PURE__*/ defineChain({
    id: 534_351,
    name: 'Scroll Sepolia',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://sepolia-rpc.scroll.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Scrollscan',
            url: 'https://sepolia.scrollscan.com',
            apiUrl: 'https://api-sepolia.scrollscan.com/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 9473,
        },
    },
    testnet: true,
});

const sei = /*#__PURE__*/ defineChain({
    id: 1329,
    name: 'Sei Network',
    nativeCurrency: { name: 'Sei', symbol: 'SEI', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://evm-rpc.sei-apis.com/'],
            webSocket: ['wss://evm-ws.sei-apis.com/'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Seitrace',
            url: 'https://seitrace.com',
            apiUrl: 'https://seitrace.com/pacific-1/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
        },
    },
});

const seiDevnet = /*#__PURE__*/ defineChain({
    id: 713_715,
    name: 'Sei Devnet',
    nativeCurrency: { name: 'Sei', symbol: 'SEI', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://evm-rpc-arctic-1.sei-apis.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Seitrace',
            url: 'https://seitrace.com',
        },
    },
    testnet: true,
});

const seiTestnet = /*#__PURE__*/ defineChain({
    id: 1328,
    name: 'Sei Testnet',
    nativeCurrency: { name: 'Sei', symbol: 'SEI', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://evm-rpc-testnet.sei-apis.com'],
            webSocket: ['wss://evm-ws-testnet.sei-apis.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Seitrace',
            url: 'https://seitrace.com',
        },
    },
    testnet: true,
});

const sepolia = /*#__PURE__*/ defineChain({
    id: 11_155_111,
    name: 'Sepolia',
    nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://sepolia.drpc.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://sepolia.etherscan.io',
            apiUrl: 'https://api-sepolia.etherscan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 751532,
        },
        ensRegistry: { address: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e' },
        ensUniversalResolver: {
            address: '0xc8Af999e38273D658BE1b921b88A9Ddf005769cC',
            blockCreated: 5_317_080,
        },
    },
    testnet: true,
});

const sourceId$f = 1; // mainnet
const shape = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 360,
    name: 'Shape',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.shape.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'shapescan',
            url: 'https://shapescan.xyz',
            apiUrl: 'https://shapescan.xyz/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$f]: {
                address: '0x6Ef8c69CfE4635d866e3E02732068022c06e724D',
                blockCreated: 20369940,
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 1,
        },
        portal: {
            [sourceId$f]: {
                address: '0xEB06fFa16011B5628BaB98E29776361c83741dd3',
                blockCreated: 20369933,
            },
        },
        l1StandardBridge: {
            [sourceId$f]: {
                address: '0x62Edd5f4930Ea92dCa3fB81689bDD9b9d076b57B',
                blockCreated: 20369935,
            },
        },
    },
    sourceId: sourceId$f,
});

const sourceId$e = 11_155_111; // sepolia
const shapeSepolia = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 11_011,
    name: 'Shape Sepolia Testnet',
    nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://sepolia.shape.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'blockscout',
            url: 'https://explorer-sepolia.shape.network/',
            apiUrl: 'https://explorer-sepolia.shape.network/api/v2',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 1,
        },
    },
    testnet: true,
    sourceId: sourceId$e,
});

const shardeumSphinx = /*#__PURE__*/ defineChain({
    id: 8082,
    name: 'Shardeum Sphinx',
    nativeCurrency: { name: 'SHARDEUM', symbol: 'SHM', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://sphinx.shardeum.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Shardeum Explorer',
            url: 'https://explorer-sphinx.shardeum.org',
        },
    },
    testnet: true,
});

const shibarium = /*#__PURE__*/ defineChain({
    id: 109,
    name: 'Shibarium',
    network: 'shibarium',
    nativeCurrency: { name: 'Bone', symbol: 'BONE', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.shibrpc.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://shibariumscan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0x864Bf681ADD6052395188A89101A1B37d3B4C961',
            blockCreated: 265900,
        },
    },
});

const shibariumTestnet = /*#__PURE__*/ defineChain({
    id: 157,
    name: 'Puppynet Shibarium',
    nativeCurrency: {
        decimals: 18,
        name: 'Bone',
        symbol: 'BONE',
    },
    rpcUrls: {
        default: { http: ['https://puppynet.shibrpc.com'] },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://puppyscan.shib.io',
            apiUrl: 'https://puppyscan.shib.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xA4029b74FBA366c926eDFA7Dd10B21C621170a4c',
            blockCreated: 3035769,
        },
    },
    testnet: true,
});

const shiden = /*#__PURE__*/ defineChain({
    id: 336,
    name: 'Shiden',
    nativeCurrency: {
        decimals: 18,
        name: 'SDN',
        symbol: 'SDN',
    },
    rpcUrls: {
        default: {
            http: ['https://shiden.public.blastapi.io'],
            webSocket: ['wss://shiden-rpc.dwellir.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Shiden Scan',
            url: 'https://shiden.subscan.io',
        },
    },
    testnet: false,
});

const shimmer = /*#__PURE__*/ defineChain({
    id: 148,
    name: 'Shimmer',
    network: 'shimmer',
    nativeCurrency: {
        decimals: 18,
        name: 'Shimmer',
        symbol: 'SMR',
    },
    rpcUrls: {
        default: {
            http: ['https://json-rpc.evm.shimmer.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Shimmer Network Explorer',
            url: 'https://explorer.evm.shimmer.network',
            apiUrl: 'https://explorer.evm.shimmer.network/api',
        },
    },
});

const shimmerTestnet = /*#__PURE__*/ defineChain({
    id: 1073,
    name: 'Shimmer Testnet',
    network: 'shimmer-testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Shimmer',
        symbol: 'SMR',
    },
    rpcUrls: {
        default: {
            http: ['https://json-rpc.evm.testnet.shimmer.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Shimmer Network Explorer',
            url: 'https://explorer.evm.testnet.shimmer.network',
            apiUrl: 'https://explorer.evm.testnet.shimmer.network/api',
        },
    },
    testnet: true,
});

const sidraChain = /*#__PURE__*/ defineChain({
    id: 97_453,
    name: 'Sidra Chain',
    nativeCurrency: {
        decimals: 18,
        name: 'Sidra Digital Asset',
        symbol: 'SDA',
    },
    rpcUrls: {
        default: {
            http: ['https://node.sidrachain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Sidra Chain Explorer',
            url: 'https://ledger.sidrachain.com',
        },
    },
});

const silicon = /*#__PURE__*/ defineChain({
    id: 2355,
    name: 'Silicon zkEVM',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: [
                'https://rpc.silicon.network',
                'https://silicon-mainnet.nodeinfra.com',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'SiliconScope',
            url: 'https://scope.silicon.network',
        },
    },
});

const siliconSepolia = /*#__PURE__*/ defineChain({
    id: 1722641160,
    name: 'Silicon Sepolia zkEVM',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: [
                'https://rpc-sepolia.silicon.network',
                'https://silicon-testnet.nodeinfra.com',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'SiliconSepoliaScope',
            url: 'https://scope-sepolia.silicon.network',
        },
    },
    testnet: true,
});

const sixProtocol = /*#__PURE__*/ defineChain({
    id: 98,
    name: 'Six Protocol',
    nativeCurrency: {
        decimals: 18,
        name: 'SIX',
        symbol: 'SIX',
    },
    rpcUrls: {
        default: {
            http: ['https://sixnet-rpc-evm.sixprotocol.net'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Six Protocol Scan',
            url: 'https://sixscan.io/sixnet',
        },
    },
    testnet: false,
});

const skaleBlockBrawlers = /*#__PURE__*/ defineChain({
    id: 391_845_894,
    name: 'SKALE | Block Brawlers',
    nativeCurrency: { name: 'BRAWL', symbol: 'BRAWL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.skalenodes.com/v1/frayed-decent-antares'],
            webSocket: ['wss://mainnet.skalenodes.com/v1/ws/frayed-decent-antares'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://frayed-decent-antares.explorer.mainnet.skalenodes.com',
        },
    },
    contracts: {},
});

const skaleCalypso = /*#__PURE__*/ defineChain({
    id: 1_564_830_818,
    name: 'SKALE | Calypso NFT Hub',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.skalenodes.com/v1/honorable-steel-rasalhague'],
            webSocket: [
                'wss://mainnet.skalenodes.com/v1/ws/honorable-steel-rasalhague',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://honorable-steel-rasalhague.explorer.mainnet.skalenodes.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 3107626,
        },
    },
});

const skaleCalypsoTestnet = /*#__PURE__*/ defineChain({
    id: 974_399_131,
    name: 'SKALE Calypso Testnet',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://testnet.skalenodes.com/v1/giant-half-dual-testnet'],
            webSocket: ['wss://testnet.skalenodes.com/v1/ws/giant-half-dual-testnet'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://giant-half-dual-testnet.explorer.testnet.skalenodes.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 103_220,
        },
    },
    testnet: true,
});

const skaleCryptoBlades = /*#__PURE__*/ defineChain({
    id: 1_026_062_157,
    name: 'SKALE | CryptoBlades',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.skalenodes.com/v1/affectionate-immediate-pollux'],
            webSocket: [
                'wss://mainnet.skalenodes.com/v1/ws/affectionate-immediate-pollux',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://affectionate-immediate-pollux.explorer.mainnet.skalenodes.com',
        },
    },
    contracts: {},
});

const skaleCryptoColosseum = /*#__PURE__*/ defineChain({
    id: 1_032_942_172,
    name: 'SKALE | Crypto Colosseum',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.skalenodes.com/v1/haunting-devoted-deneb'],
            webSocket: ['wss://mainnet.skalenodes.com/v1/ws/haunting-devoted-deneb'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://haunting-devoted-deneb.explorer.mainnet.skalenodes.com',
        },
    },
    contracts: {},
});

const skaleEuropa = /*#__PURE__*/ defineChain({
    id: 2_046_399_126,
    name: 'SKALE | Europa Liquidity Hub',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.skalenodes.com/v1/elated-tan-skat'],
            webSocket: ['wss://mainnet.skalenodes.com/v1/ws/elated-tan-skat'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://elated-tan-skat.explorer.mainnet.skalenodes.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 3113495,
        },
    },
});

const skaleEuropaTestnet = /*#__PURE__*/ defineChain({
    id: 1_444_673_419,
    name: 'SKALE Europa Testnet',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://testnet.skalenodes.com/v1/juicy-low-small-testnet'],
            webSocket: ['wss://testnet.skalenodes.com/v1/ws/juicy-low-small-testnet'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://juicy-low-small-testnet.explorer.testnet.skalenodes.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 110_858,
        },
    },
    testnet: true,
});

const skaleExorde = /*#__PURE__*/ defineChain({
    id: 2_139_927_552,
    name: 'SKALE | Exorde',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.skalenodes.com/v1/light-vast-diphda'],
            webSocket: ['wss://mainnet.skalenodes.com/v1/ws/light-vast-diphda'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://light-vast-diphda.explorer.mainnet.skalenodes.com',
        },
    },
    contracts: {},
});

const skaleHumanProtocol = /*#__PURE__*/ defineChain({
    id: 1_273_227_453,
    name: 'SKALE | Human Protocol',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.skalenodes.com/v1/wan-red-ain'],
            webSocket: ['wss://mainnet.skalenodes.com/v1/ws/wan-red-ain'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://wan-red-ain.explorer.mainnet.skalenodes.com',
        },
    },
    contracts: {},
});

const skaleNebula = /*#__PURE__*/ defineChain({
    id: 1_482_601_649,
    name: 'SKALE | Nebula Gaming Hub',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.skalenodes.com/v1/green-giddy-denebola'],
            webSocket: ['wss://mainnet.skalenodes.com/v1/ws/green-giddy-denebola'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://green-giddy-denebola.explorer.mainnet.skalenodes.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 2372986,
        },
    },
});

const skaleNebulaTestnet = /*#__PURE__*/ defineChain({
    id: 37_084_624,
    name: 'SKALE Nebula Testnet',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://testnet.skalenodes.com/v1/lanky-ill-funny-testnet'],
            webSocket: ['wss://testnet.skalenodes.com/v1/ws/lanky-ill-funny-testnet'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://lanky-ill-funny-testnet.explorer.testnet.skalenodes.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 105_141,
        },
    },
    testnet: true,
});

const skaleRazor = /*#__PURE__*/ defineChain({
    id: 278_611_351,
    name: 'SKALE | Razor Network',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.skalenodes.com/v1/turbulent-unique-scheat'],
            webSocket: ['wss://mainnet.skalenodes.com/v1/ws/turbulent-unique-scheat'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://turbulent-unique-scheat.explorer.mainnet.skalenodes.com',
        },
    },
    contracts: {},
});

const skaleTitan = /*#__PURE__*/ defineChain({
    id: 1_350_216_234,
    name: 'SKALE | Titan Community Hub',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.skalenodes.com/v1/parallel-stormy-spica'],
            webSocket: ['wss://mainnet.skalenodes.com/v1/ws/parallel-stormy-spica'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://parallel-stormy-spica.explorer.mainnet.skalenodes.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 2076458,
        },
    },
});

const skaleTitanTestnet = /*#__PURE__*/ defineChain({
    id: 1_020_352_220,
    name: 'SKALE Titan Hub',
    nativeCurrency: { name: 'sFUEL', symbol: 'sFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://testnet.skalenodes.com/v1/aware-fake-trim-testnet'],
            webSocket: ['wss://testnet.skalenodes.com/v1/ws/aware-fake-trim-testnet'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SKALE Explorer',
            url: 'https://aware-fake-trim-testnet.explorer.testnet.skalenodes.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 104_072,
        },
    },
    testnet: true,
});

const sketchpad = /*#__PURE__*/ defineChain({
    id: 984123,
    name: 'Forma Sketchpad',
    network: 'sketchpad',
    nativeCurrency: {
        symbol: 'TIA',
        name: 'TIA',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.sketchpad-1.forma.art'],
            webSocket: ['wss://ws.sketchpad-1.forma.art'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Sketchpad Explorer',
            url: 'https://explorer.sketchpad-1.forma.art',
        },
    },
    testnet: true,
});

const sourceId$d = 1; // mainnet
const snax = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 2192,
    network: 'snaxchain-mainnet',
    name: 'SnaxChain',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.snaxchain.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Snax Explorer',
            url: 'https://explorer.snaxchain.io',
            apiUrl: 'https://explorer.snaxchain.io/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        disputeGameFactory: {
            [sourceId$d]: {
                address: '0x472562Fcf26D6b2793f8E0b0fB660ba0E5e08A46',
            },
        },
        l2OutputOracle: {
            [sourceId$d]: {
                address: '0x2172e492Fc807F5d5645D0E3543f139ECF539294',
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
        },
        portal: {
            [sourceId$d]: {
                address: '0x79f446D024d74D0Bb6E699C131c703463c5D65E9',
            },
        },
        l1StandardBridge: {
            [sourceId$d]: {
                address: '0x6534Bdb6b5c060d3e6aa833433333135eFE8E0aA',
            },
        },
    },
    sourceId: sourceId$d,
});

const sourceId$c = 11_155_111; // sepolia
const snaxTestnet = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 13001,
    network: 'snaxchain-testnet',
    name: 'SnaxChain Testnet',
    nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://testnet.snaxchain.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Snax Explorer',
            url: 'https://testnet-explorer.snaxchain.io',
            apiUrl: 'https://testnet-explorer.snaxchain.io/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        disputeGameFactory: {
            [sourceId$c]: {
                address: '0x206a75d89d45F146C54020F132FF93bEDD09f55E',
            },
        },
        l2OutputOracle: {
            [sourceId$c]: {
                address: '0x60e3A368a4cdCEf85ffB964e372726F56A46221e',
            },
        },
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
        },
        portal: {
            [sourceId$c]: {
                address: '0xb5afdd0E8dDF081Ef90e8A3e0c7b5798e66E954E',
            },
        },
        l1StandardBridge: {
            [sourceId$c]: {
                address: '0xbd37E1a59D4C00C9A46F75018dffd84061bC5f74',
            },
        },
    },
    testnet: true,
    sourceId: sourceId$c,
});

const sourceId$b = 1; // mainnet
const soneium = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 1868,
    name: 'Soneium Mainnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.soneium.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://soneium.blockscout.com',
            apiUrl: 'https://soneium.blockscout.com/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        disputeGameFactory: {
            [sourceId$b]: {
                address: '0x512a3d2c7a43bd9261d2b8e8c9c70d4bd4d503c0',
            },
        },
        l2OutputOracle: {
            [sourceId$b]: {
                address: '0x0000000000000000000000000000000000000000',
            },
        },
        portal: {
            [sourceId$b]: {
                address: '0x88e529a6ccd302c948689cd5156c83d4614fae92',
                blockCreated: 7061266,
            },
        },
        l1StandardBridge: {
            [sourceId$b]: {
                address: '0xeb9bf100225c214efc3e7c651ebbadcf85177607',
                blockCreated: 7061266,
            },
        },
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 1,
        },
    },
    sourceId: sourceId$b,
});

const sourceId$a = 11_155_111; // sepolia
const soneiumMinato = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 1946,
    name: 'Soneium Minato Testnet',
    nativeCurrency: { name: 'Sepolia Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.minato.soneium.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://soneium-minato.blockscout.com',
            apiUrl: 'https://soneium-minato.blockscout.com/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        disputeGameFactory: {
            [sourceId$a]: {
                address: '0xB3Ad2c38E6e0640d7ce6aA952AB3A60E81bf7a01',
            },
        },
        l2OutputOracle: {
            [sourceId$a]: {
                address: '0x710e5286C746eC38beeB7538d0146f60D27be343',
            },
        },
        portal: {
            [sourceId$a]: {
                address: '0x65ea1489741A5D72fFdD8e6485B216bBdcC15Af3',
                blockCreated: 6466136,
            },
        },
        l1StandardBridge: {
            [sourceId$a]: {
                address: '0x5f5a404A5edabcDD80DB05E8e54A78c9EBF000C2',
                blockCreated: 6466136,
            },
        },
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 1,
        },
    },
    testnet: true,
    sourceId: sourceId$a,
});

const sonic = /*#__PURE__*/ defineChain({
    id: 146,
    name: 'Sonic',
    nativeCurrency: {
        decimals: 18,
        name: 'Sonic',
        symbol: 'S',
    },
    rpcUrls: {
        default: { http: ['https://rpc.soniclabs.com'] },
    },
    blockExplorers: {
        default: {
            name: 'Sonic Explorer',
            url: 'https://sonicscan.org/',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 60,
        },
    },
    testnet: false,
});

const sonicTestnet = /*#__PURE__*/ defineChain({
    id: 64_165,
    name: 'Sonic Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Sonic',
        symbol: 'S',
    },
    rpcUrls: {
        default: { http: ['https://rpc.testnet.soniclabs.com'] },
    },
    blockExplorers: {
        default: {
            name: 'Sonic Testnet Explorer',
            url: 'https://testnet.soniclabs.com/',
        },
    },
    testnet: true,
});

const songbird = /*#__PURE__*/ defineChain({
    id: 19,
    name: 'Songbird Canary-Network',
    nativeCurrency: {
        decimals: 18,
        name: 'Songbird',
        symbol: 'SGB',
    },
    rpcUrls: {
        default: { http: ['https://songbird-api.flare.network/ext/C/rpc'] },
    },
    blockExplorers: {
        default: {
            name: 'Songbird Explorer',
            url: 'https://songbird-explorer.flare.network',
            apiUrl: 'https://songbird-explorer.flare.network/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 13382504,
        },
    },
});

const songbirdTestnet = /*#__PURE__*/ defineChain({
    id: 16,
    name: 'Songbird Testnet Coston',
    nativeCurrency: {
        decimals: 18,
        name: 'Coston Flare',
        symbol: 'CFLR',
    },
    rpcUrls: {
        default: { http: ['https://coston-api.flare.network/ext/C/rpc'] },
    },
    blockExplorers: {
        default: {
            name: 'Coston Explorer',
            url: 'https://coston-explorer.flare.network',
            apiUrl: 'https://coston-explorer.flare.network/api',
        },
    },
    testnet: true,
});

const sophon = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 50104,
    name: 'Sophon',
    nativeCurrency: {
        decimals: 18,
        name: 'Sophon',
        symbol: 'SOPH',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.sophon.xyz'],
            webSocket: ['wss://rpc.sophon.xyz/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Sophon Block Explorer',
            url: 'https://explorer.sophon.xyz',
        },
    },
    contracts: {
        multicall3: {
            address: '0x5f4867441d2416cA88B1b3fd38f21811680CD2C8',
            blockCreated: 116,
        },
    },
    testnet: false,
});

const sophonTestnet = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 531_050_104,
    name: 'Sophon Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Sophon',
        symbol: 'SOPH',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.sophon.xyz'],
            webSocket: ['wss://rpc.testnet.sophon.xyz/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Sophon Block Explorer',
            url: 'https://explorer.testnet.sophon.xyz',
        },
    },
    contracts: {
        multicall3: {
            address: '0x83c04d112adedA2C6D9037bb6ecb42E7f0b108Af',
            blockCreated: 15_642,
        },
    },
    testnet: true,
});

const spicy = /*#__PURE__*/ defineChain({
    id: 88_882,
    name: 'Chiliz Spicy Testnet',
    network: 'chiliz-spicy-Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'CHZ',
        symbol: 'CHZ',
    },
    rpcUrls: {
        default: {
            http: [
                'https://spicy-rpc.chiliz.com',
                'https://chiliz-spicy-rpc.publicnode.com',
            ],
            webSocket: [
                'wss://spicy-rpc-ws.chiliz.com',
                'wss://chiliz-spicy-rpc.publicnode.com',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'Chiliz Explorer',
            url: 'http://spicy-explorer.chiliz.com',
            apiUrl: 'http://spicy-explorer.chiliz.com/api',
        },
    },
    testnet: true,
});

const step = /*#__PURE__*/ defineChain({
    id: 1234,
    name: 'Step Network',
    nativeCurrency: { name: 'FITFI', symbol: 'FITFI', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.step.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Step Scan',
            url: 'https://stepscan.io',
        },
    },
    testnet: false,
});

const storyOdyssey = /*#__PURE__*/ defineChain({
    id: 1516,
    name: 'Story Odyssey',
    nativeCurrency: {
        decimals: 18,
        name: 'IP',
        symbol: 'IP',
    },
    rpcUrls: {
        default: { http: ['https://rpc.odyssey.storyrpc.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Story Odyssey Explorer',
            url: 'https://odyssey.storyscan.xyz',
        },
    },
    testnet: true,
});

const storyTestnet = /*#__PURE__*/ defineChain({
    id: 1513,
    name: 'Story Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'IP',
        symbol: 'IP',
    },
    rpcUrls: {
        default: { http: ['https://testnet.storyrpc.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Story Testnet Explorer',
            url: 'https://testnet.storyscan.xyz',
        },
    },
    testnet: true,
});

const stratis = /*#__PURE__*/ defineChain({
    id: 105105,
    name: 'Stratis Mainnet',
    network: 'stratis',
    nativeCurrency: {
        name: 'Stratis',
        symbol: 'STRAX',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.stratisevm.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Stratis Explorer',
            url: 'https://explorer.stratisevm.com',
        },
    },
});

const superlumio = /*#__PURE__*/ defineChain({
    id: 8866,
    name: 'SuperLumio',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.lumio.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Lumio explorer',
            url: 'https://explorer.lumio.io',
        },
    },
    testnet: false,
});

const superposition = /*#__PURE__*/ defineChain({
    id: 55244,
    name: 'Superposition',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc.superposition.so'] },
    },
    blockExplorers: {
        default: {
            name: 'Superposition Explorer',
            url: 'https://explorer.superposition.so',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 39,
        },
    },
    testnet: false,
});

const sourceId$9 = 1; // mainnet
const superseed = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 5330,
    name: 'Superseed',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.superseed.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Superseed Explorer',
            url: 'https://explorer.superseed.xyz',
            apiUrl: 'https://explorer.superseed.xyz/api/v2',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        disputeGameFactory: {
            [sourceId$9]: {
                address: '0x8b097CF1f9BbD9cbFD0DD561858a1FCbC8857Be0',
                blockCreated: 20737481,
            },
        },
        l2OutputOracle: {
            [sourceId$9]: {
                address: '0x693A0F8854F458D282DE3C5b69E8eE5EEE8aA949',
                blockCreated: 20737481,
            },
        },
        portal: {
            [sourceId$9]: {
                address: '0x2c2150aa5c75A24fB93d4fD2F2a895D618054f07',
                blockCreated: 20737481,
            },
        },
        l1StandardBridge: {
            [sourceId$9]: {
                address: '0x8b0576E39F1233679109F9b40cFcC2a7E0901Ede',
                blockCreated: 20737481,
            },
        },
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
        },
    },
    sourceId: sourceId$9,
});

const sourceId$8 = 11155111; // sepolia
const superseedSepolia = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 53302,
    name: 'Superseed Sepolia',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://sepolia.superseed.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Superseed Sepolia Explorer',
            url: 'https://sepolia-explorer.superseed.xyz',
            apiUrl: 'https://sepolia-explorer.superseed.xyz/api/v2',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
        },
        portal: {
            [sourceId$8]: {
                address: '0x7A0db8C51432d2C3eb4e8f360a2EeB26FF2809fB',
                blockCreated: 5523438,
            },
        },
        l1StandardBridge: {
            [sourceId$8]: {
                address: '0x2B227A603fAAdB3De0ED050b63ADD232B5f2c28C',
                blockCreated: 5523442,
            },
        },
    },
    testnet: true,
    sourceId: sourceId$8,
});

const swan = /*#__PURE__*/ defineChain({
    id: 254,
    name: 'Swan Chain Mainnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://mainnet-rpc.swanchain.org'] },
    },
    blockExplorers: {
        default: {
            name: 'Swan Explorer',
            url: 'https://swanscan.io',
        },
    },
    testnet: false,
});

const swanProximaTestnet = /*#__PURE__*/ defineChain({
    id: 20241133,
    name: 'Swan Proxima Testnet',
    nativeCurrency: { name: 'Swan Ether', symbol: 'sETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://rpc-proxima.swanchain.io	'] },
    },
    blockExplorers: {
        default: {
            name: 'Swan Explorer',
            url: 'https://proxima-explorer.swanchain.io',
        },
    },
    testnet: true,
});

const swanSaturnTestnet = /*#__PURE__*/ defineChain({
    id: 2024,
    name: 'Swan Saturn Testnet',
    nativeCurrency: { name: 'Swan Ether', symbol: 'sETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://saturn-rpc.swanchain.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Swan Explorer',
            url: 'https://saturn-explorer.swanchain.io',
        },
    },
    testnet: true,
});

const swellchain = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 1923,
    name: 'Swellchain',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: [
                'https://swell-mainnet.alt.technology',
                'https://rpc.ankr.com/swell',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'Swell Explorer',
            url: 'https://explorer.swellnetwork.io',
            apiUrl: 'https://explorer.swellnetwork.io/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 1,
        },
    },
});

const swissdlt = /*#__PURE__*/ defineChain({
    id: 94,
    name: 'SwissDLT Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'BCTS',
        symbol: 'BCTS',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.swissdlt.ch'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SwissDLT Explorer',
            url: 'https://explorer.swissdlt.ch',
        },
    },
    testnet: false,
});

const syscoin = /*#__PURE__*/ defineChain({
    id: 57,
    name: 'Syscoin Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Syscoin',
        symbol: 'SYS',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.syscoin.org'],
            webSocket: ['wss://rpc.syscoin.org/wss'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SyscoinExplorer',
            url: 'https://explorer.syscoin.org',
            apiUrl: 'https://explorer.syscoin.org/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 287139,
        },
    },
});

const syscoinTestnet = /*#__PURE__*/ defineChain({
    id: 5700,
    name: 'Syscoin Tanenbaum Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Syscoin',
        symbol: 'SYS',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.tanenbaum.io'],
            webSocket: ['wss://rpc.tanenbaum.io/wss'],
        },
    },
    blockExplorers: {
        default: {
            name: 'SyscoinTestnetExplorer',
            url: 'https://tanenbaum.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 271288,
        },
    },
});

const taiko = /*#__PURE__*/ defineChain({
    id: 167000,
    name: 'Taiko Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.mainnet.taiko.xyz'],
            webSocket: ['wss://ws.mainnet.taiko.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Taikoscan',
            url: 'https://taikoscan.io',
            apiUrl: 'https://api.taikoscan.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcb2436774C3e191c85056d248EF4260ce5f27A9D',
        },
    },
});

const taikoHekla = /*#__PURE__*/ defineChain({
    id: 167_009,
    name: 'Taiko Hekla L2',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.hekla.taiko.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Taikoscan',
            url: 'https://hekla.taikoscan.network',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 59757,
        },
    },
    testnet: true,
});

const taikoJolnir = /*#__PURE__*/ defineChain({
    id: 167007,
    name: 'Taiko Jolnir (Alpha-5 Testnet)',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.jolnir.taiko.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'blockscout',
            url: 'https://explorer.jolnir.taiko.xyz',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 732706,
        },
    },
    testnet: true,
});

const taikoKatla = /*#__PURE__*/ defineChain({
    id: 167008,
    name: 'Taiko Katla (Alpha-6 Testnet)',
    network: 'tko-katla',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.katla.taiko.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'blockscout',
            url: 'https://explorer.katla.taiko.xyz',
        },
    },
});

const taikoTestnetSepolia = /*#__PURE__*/ defineChain({
    id: 167005,
    name: 'Taiko (Alpha-3 Testnet)',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.test.taiko.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'blockscout',
            url: 'https://explorer.test.taiko.xyz',
        },
    },
});

const taraxa = /*#__PURE__*/ defineChain({
    id: 841,
    name: 'Taraxa Mainnet',
    nativeCurrency: { name: 'Tara', symbol: 'TARA', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.mainnet.taraxa.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Taraxa Explorer',
            url: 'https://explorer.mainnet.taraxa.io',
        },
    },
});

const taraxaTestnet = /*#__PURE__*/ defineChain({
    id: 842,
    name: 'Taraxa Testnet',
    nativeCurrency: { name: 'Tara', symbol: 'TARA', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.taraxa.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Taraxa Explorer',
            url: 'https://explorer.testnet.taraxa.io',
        },
    },
    testnet: true,
});

const telcoinTestnet = /*#__PURE__*/ defineChain({
    id: 2017,
    name: 'Telcoin Adiri Testnet',
    nativeCurrency: { name: 'Telcoin', symbol: 'TEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.telcoin.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'telscan',
            url: 'https://telscan.io',
        },
    },
    testnet: true,
});

const telos = /*#__PURE__*/ defineChain({
    id: 40,
    name: 'Telos',
    nativeCurrency: {
        decimals: 18,
        name: 'Telos',
        symbol: 'TLOS',
    },
    rpcUrls: {
        default: { http: ['https://mainnet.telos.net/evm'] },
    },
    blockExplorers: {
        default: {
            name: 'Teloscan',
            url: 'https://www.teloscan.io/',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 246530709,
        },
    },
});

const telosTestnet = /*#__PURE__*/ defineChain({
    id: 41,
    name: 'Telos',
    nativeCurrency: {
        decimals: 18,
        name: 'Telos',
        symbol: 'TLOS',
    },
    rpcUrls: {
        default: { http: ['https://testnet.telos.net/evm'] },
    },
    blockExplorers: {
        default: {
            name: 'Teloscan (testnet)',
            url: 'https://testnet.teloscan.io/',
        },
    },
    testnet: true,
});

const tenet = /*#__PURE__*/ defineChain({
    id: 1559,
    name: 'Tenet',
    network: 'tenet-mainnet',
    nativeCurrency: {
        name: 'TENET',
        symbol: 'TENET',
        decimals: 18,
    },
    rpcUrls: {
        default: { http: ['https://rpc.tenet.org'] },
    },
    blockExplorers: {
        default: {
            name: 'TenetScan Mainnet',
            url: 'https://tenetscan.io',
            apiUrl: 'https://tenetscan.io/api',
        },
    },
    testnet: false,
});

const ternoa = /*#__PURE__*/ defineChain({
    id: 752025,
    name: 'Ternoa',
    nativeCurrency: { name: 'Capsule Coin', symbol: 'CAPS', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-mainnet.zkevm.ternoa.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Ternoa Explorer',
            url: 'https://explorer-mainnet.zkevm.ternoa.network',
        },
    },
    testnet: false,
});

const thaiChain = /*#__PURE__*/ defineChain({
    id: 7,
    name: 'ThaiChain',
    nativeCurrency: { name: 'TCH', symbol: 'TCH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.thaichain.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://exp.thaichain.org',
            apiUrl: 'https://exp.thaichain.org/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0x0DaD6130e832c21719C5CE3bae93454E16A84826',
            blockCreated: 4806386,
        },
    },
    testnet: false,
});

const that = /*#__PURE__*/ defineChain({
    id: 8428,
    name: 'THAT Mainnet',
    nativeCurrency: { name: 'THAT', symbol: 'THAT', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://api.thatchain.io/mainnet'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://that.blockscout.com',
        },
    },
    testnet: false,
});

const theta = /*#__PURE__*/ defineChain({
    id: 361,
    name: 'Theta Mainnet',
    nativeCurrency: { name: 'TFUEL', symbol: 'TFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://eth-rpc-api.thetatoken.org/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Theta Explorer',
            url: 'https://explorer.thetatoken.org',
        },
    },
    testnet: false,
});

const thetaTestnet = /*#__PURE__*/ defineChain({
    id: 365,
    name: 'Theta Testnet',
    nativeCurrency: { name: 'TFUEL', symbol: 'TFUEL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://eth-rpc-api-testnet.thetatoken.org/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Theta Explorer',
            url: 'https://testnet-explorer.thetatoken.org',
        },
    },
    testnet: true,
});

const thunderCore = /*#__PURE__*/ defineChain({
    id: 108,
    name: 'ThunderCore Mainnet',
    nativeCurrency: { name: 'TT', symbol: 'TT', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet-rpc.thundercore.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'ThunderCore Explorer',
            url: 'https://explorer-mainnet.thundercore.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 0,
        },
    },
    testnet: false,
});

const thunderTestnet = /*#__PURE__*/ defineChain({
    id: 997,
    name: '5ireChain Thunder Testnet',
    nativeCurrency: { name: '5ire Token', symbol: '5IRE', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.5ire.network'],
        },
    },
    blockExplorers: {
        default: {
            name: '5ireChain Thunder Explorer',
            url: 'https://testnet.5irescan.io/',
        },
    },
    testnet: true,
});

const tiktrixTestnet = /*#__PURE__*/ defineChain({
    id: 62092,
    name: 'TikTrix Testnet',
    nativeCurrency: {
        name: 'tTTX',
        symbol: 'tTTX',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://tiktrix-rpc.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'TikTrix Testnet Explorer',
            url: 'https://tiktrix.xyz',
        },
    },
    testnet: true,
});

const tomb = /*#__PURE__*/ defineChain({
    id: 6969,
    name: 'Tomb Mainnet',
    nativeCurrency: { name: 'TOMB', symbol: 'TOMB', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.tombchain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Tomb Explorer',
            url: 'https://tombscout.com',
        },
    },
    testnet: false,
});

const treasure = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 61_166,
    name: 'Treasure',
    nativeCurrency: {
        decimals: 18,
        name: 'MAGIC',
        symbol: 'MAGIC',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.treasure.lol'],
            webSocket: ['wss://rpc.treasure.lol/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Treasure Block Explorer',
            url: 'https://treasurescan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0x2e29fe39496a56856D8698bD43e1dF4D0CE6266a',
            blockCreated: 101,
        },
    },
    testnet: false,
});

const treasureTopaz = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 978_658,
    name: 'Treasure Topaz Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'MAGIC',
        symbol: 'MAGIC',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.topaz.treasure.lol'],
            webSocket: ['wss://rpc.topaz.treasure.lol/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Treasure Topaz Block Explorer',
            url: 'https://topaz.treasurescan.io',
        },
    },
    contracts: {
        multicall3: {
            address: '0xF9cda624FBC7e059355ce98a31693d299FACd963',
            blockCreated: 108112,
        },
    },
    testnet: true,
});

const tron = /*#__PURE__*/ defineChain({
    id: 728126428,
    name: 'Tron',
    nativeCurrency: { name: 'TRON', symbol: 'TRX', decimals: 6 },
    rpcUrls: {
        default: {
            http: ['https://api.trongrid.io/jsonrpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Tronscan',
            url: 'https://tronscan.org',
            apiUrl: 'https://apilist.tronscanapi.com/api',
        },
    },
});

const ubiq = /*#__PURE__*/ defineChain({
    id: 8,
    name: 'Ubiq Mainnet',
    nativeCurrency: { name: 'UBQ', symbol: 'UBQ', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://pyrus2.ubiqscan.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Ubiq Scan',
            url: 'https://ubiqscan.io',
        },
    },
    testnet: false,
});

const ultra = /*#__PURE__*/ defineChain({
    id: 19991,
    name: 'Ultra EVM',
    nativeCurrency: {
        decimals: 18,
        name: 'Ultra Token',
        symbol: 'UOS',
    },
    rpcUrls: {
        default: { http: ['https://evm.ultra.eosusa.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Ultra EVM Explorer',
            url: 'https://evmexplorer.ultra.io',
        },
    },
});

const ultraTestnet = /*#__PURE__*/ defineChain({
    id: 18881,
    name: 'Ultra EVM Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Ultra Token',
        symbol: 'UOS',
    },
    rpcUrls: {
        default: { http: ['https://evm.test.ultra.eosusa.io'] },
    },
    blockExplorers: {
        default: {
            name: 'Ultra EVM Testnet Explorer',
            url: 'https://evmexplorer.testnet.ultra.io',
        },
    },
    testnet: true,
});

const ultron = /*#__PURE__*/ defineChain({
    id: 1231,
    name: 'Ultron Mainnet',
    nativeCurrency: { name: 'ULX', symbol: 'ULX', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://ultron-rpc.net'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Ultron Scan',
            url: 'https://ulxscan.com',
        },
    },
    testnet: false,
});

const ultronTestnet = /*#__PURE__*/ defineChain({
    id: 1230,
    name: 'Ultron Testnet',
    nativeCurrency: { name: 'ULX', symbol: 'ULX', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://ultron-dev.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Ultron Scan',
            url: 'https://explorer.ultron-dev.io',
        },
    },
    testnet: true,
});

const sourceId$7 = 11_155_111; // sepolia
const unichainSepolia = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 1301,
    name: 'Unichain Sepolia',
    nativeCurrency: {
        name: 'Ether',
        symbol: 'ETH',
        decimals: 18,
    },
    rpcUrls: {
        default: {
            http: ['https://sepolia.unichain.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Uniscan',
            url: 'https://sepolia.uniscan.xyz',
            apiUrl: 'https://api-sepolia.uniscan.xyz/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 0,
        },
        portal: {
            [sourceId$7]: {
                address: '0x0d83dab629f0e0F9d36c0Cbc89B69a489f0751bD',
            },
        },
        l1StandardBridge: {
            [sourceId$7]: {
                address: '0xea58fcA6849d79EAd1f26608855c2D6407d54Ce2',
            },
        },
        disputeGameFactory: {
            [sourceId$7]: {
                address: '0xeff73e5aa3B9AEC32c659Aa3E00444d20a84394b',
            },
        },
    },
    testnet: true,
    sourceId: sourceId$7,
});

const unique = /*#__PURE__*/ defineChain({
    id: 8880,
    name: 'Unique Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'UNQ',
        symbol: 'UNQ',
    },
    rpcUrls: {
        default: { http: ['https://rpc.unique.network'] },
    },
    blockExplorers: {
        default: {
            name: 'Unique Subscan',
            url: 'https://unique.subscan.io/',
        },
    },
});

const uniqueOpal = /*#__PURE__*/ defineChain({
    id: 8882,
    name: 'Opal Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'OPL',
        symbol: 'OPL',
    },
    rpcUrls: {
        default: { http: ['https://rpc-opal.unique.network'] },
    },
    blockExplorers: {
        default: {
            name: 'Opal Subscan',
            url: 'https://opal.subscan.io/',
        },
    },
    testnet: true,
});

const uniqueQuartz = /*#__PURE__*/ defineChain({
    id: 8881,
    name: 'Quartz Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'QTZ',
        symbol: 'QTZ',
    },
    rpcUrls: {
        default: { http: ['https://rpc-quartz.unique.network'] },
    },
    blockExplorers: {
        default: {
            name: 'Quartz Subscan',
            url: 'https://quartz.subscan.io/',
        },
    },
});

const unreal = /*#__PURE__*/ defineChain({
    id: 18233,
    name: 'Unreal',
    nativeCurrency: {
        name: 'reETH',
        decimals: 18,
        symbol: 'reETH',
    },
    rpcUrls: {
        default: { http: ['https://rpc.unreal-orbit.gelato.digital'] },
    },
    blockExplorers: {
        default: {
            name: 'Unreal Explorer',
            url: 'https://unreal.blockscout.com',
            apiUrl: 'https://unreal.blockscout.com/api/v2',
        },
    },
    testnet: true,
    contracts: {
        multicall3: {
            address: '0x8b6B0e60D8CD84898Ea8b981065A12F876eA5677',
            blockCreated: 1745,
        },
    },
});

const vanar = /*#__PURE__*/ defineChain({
    id: 2040,
    name: 'Vanar Mainnet',
    nativeCurrency: { name: 'VANRY', symbol: 'VANRY', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.vanarchain.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Vanar Mainnet Explorer',
            url: 'https://explorer.vanarchain.com/',
        },
    },
    testnet: false,
});

const vechain = /*#__PURE__*/ defineChain({
    id: 100009,
    name: 'Vechain',
    nativeCurrency: { name: 'VeChain', symbol: 'VET', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://mainnet.vechain.org'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Vechain Explorer',
            url: 'https://explore.vechain.org',
        },
        vechainStats: {
            name: 'Vechain Stats',
            url: 'https://vechainstats.com',
        },
    },
});

const velas = /*#__PURE__*/ defineChain({
    id: 106,
    name: 'Velas EVM Mainnet',
    nativeCurrency: { name: 'VLX', symbol: 'VLX', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://evmexplorer.velas.com/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Velas Explorer',
            url: 'https://evmexplorer.velas.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 55883577,
        },
    },
    testnet: false,
});

const viction = /*#__PURE__*/ defineChain({
    id: 88,
    name: 'Viction',
    nativeCurrency: { name: 'Viction', symbol: 'VIC', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.viction.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'VIC Scan',
            url: 'https://vicscan.xyz',
        },
    },
    testnet: false,
});

const victionTestnet = /*#__PURE__*/ defineChain({
    id: 89,
    name: 'Viction Testnet',
    nativeCurrency: { name: 'Viction', symbol: 'VIC', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-testnet.viction.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'VIC Scan',
            url: 'https://testnet.vicscan.xyz',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 12170179,
        },
    },
    testnet: true,
});

const vision = /*#__PURE__*/ defineChain({
    id: 888888,
    name: 'Vision',
    nativeCurrency: { name: 'VISION', symbol: 'VS', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://infragrid.v.network/ethereum/compatible'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Vision Scan',
            url: 'https://visionscan.org',
        },
    },
    testnet: false,
});

const visionTestnet = /*#__PURE__*/ defineChain({
    id: 666666,
    name: 'Vision Testnet',
    nativeCurrency: { name: 'VISION', symbol: 'VS', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://vpioneer.infragrid.v.network/ethereum/compatible'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Vision Scan',
            url: 'https://visionscan.org/?chain=vpioneer',
        },
    },
    testnet: true,
});

const wanchain = /*#__PURE__*/ defineChain({
    id: 888,
    name: 'Wanchain',
    nativeCurrency: { name: 'WANCHAIN', symbol: 'WAN', decimals: 18 },
    rpcUrls: {
        default: {
            http: [
                'https://gwan-ssl.wandevs.org:56891',
                'https://gwan2-ssl.wandevs.org',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'WanScan',
            url: 'https://wanscan.org',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcDF6A1566e78EB4594c86Fe73Fcdc82429e97fbB',
            blockCreated: 25312390,
        },
    },
});

const wanchainTestnet = /*#__PURE__*/ defineChain({
    id: 999,
    name: 'Wanchain Testnet',
    nativeCurrency: { name: 'WANCHAIN', symbol: 'WANt', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://gwan-ssl.wandevs.org:46891'],
        },
    },
    blockExplorers: {
        default: {
            name: 'WanScanTest',
            url: 'https://wanscan.org',
        },
    },
    contracts: {
        multicall3: {
            address: '0x11c89bF4496c39FB80535Ffb4c92715839CC5324',
            blockCreated: 24743448,
        },
    },
    testnet: true,
});

const weaveVMAlphanet = /*#__PURE__*/ defineChain({
    id: 9496,
    name: 'WeaveVM Alphanet',
    nativeCurrency: { name: 'Testnet WeaveVM', symbol: 'tWVM', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://testnet-rpc.wvm.dev'] },
    },
    blockExplorers: {
        default: {
            name: 'WeaveVM Alphanet Explorer',
            url: 'https://explorer.wvm.dev',
        },
    },
    testnet: true,
});

const wemix = /*#__PURE__*/ defineChain({
    id: 1111,
    name: 'WEMIX',
    network: 'wemix-mainnet',
    nativeCurrency: { name: 'WEMIX', symbol: 'WEMIX', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://api.wemix.com'] },
    },
    blockExplorers: {
        default: {
            name: 'wemixExplorer',
            url: 'https://explorer.wemix.com',
        },
    },
});

const wemixTestnet = /*#__PURE__*/ defineChain({
    id: 1112,
    name: 'WEMIX Testnet',
    network: 'wemix-testnet',
    nativeCurrency: { name: 'WEMIX', symbol: 'tWEMIX', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://api.test.wemix.com'] },
    },
    blockExplorers: {
        default: {
            name: 'wemixExplorer',
            url: 'https://testnet.wemixscan.com',
            apiUrl: 'https://testnet.wemixscan.com/api',
        },
    },
    testnet: true,
});

const wmcTestnet = /*#__PURE__*/ defineChain({
    id: 42070,
    name: 'WMC Testnet',
    nativeCurrency: { name: 'WMTx', symbol: 'WMTx', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc-testnet-base.worldmobile.net'],
        },
    },
    blockExplorers: {
        default: {
            name: 'WMC Explorer',
            url: 'https://explorer2-base-testnet.worldmobile.net',
        },
    },
    testnet: true,
});

const sourceId$6 = 1; // mainnet
const worldchain = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 480,
    name: 'World Chain',
    network: 'worldchain',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://worldchain-mainnet.g.alchemy.com/public'] },
    },
    blockExplorers: {
        default: {
            name: 'Worldscan',
            url: 'https://worldscan.org',
            apiUrl: 'https://api.worldscan.org/api',
        },
        blockscout: {
            name: 'Blockscout',
            url: 'https://worldchain-mainnet.explorer.alchemy.com',
            apiUrl: 'https://worldchain-mainnet.explorer.alchemy.com/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 0,
        },
        disputeGameFactory: {
            [sourceId$6]: {
                address: '0x0E90dCAFBC242D2C861A20Bb20EC8E7182965a52',
            },
        },
        l2OutputOracle: {
            [sourceId$6]: {
                address: '0x19A6d1E9034596196295CF148509796978343c5D',
            },
        },
        portal: {
            [sourceId$6]: {
                address: '0xd5ec14a83B7d95BE1E2Ac12523e2dEE12Cbeea6C',
            },
        },
        l1StandardBridge: {
            [sourceId$6]: {
                address: '0x470458C91978D2d929704489Ad730DC3E3001113',
            },
        },
    },
    testnet: false,
    sourceId: sourceId$6,
});

const sourceId$5 = 11_155_111; // sepolia
const worldchainSepolia = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 4801,
    name: 'World Chain Sepolia',
    network: 'worldchain-sepolia',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: { http: ['https://worldchain-sepolia.g.alchemy.com/public'] },
        public: { http: ['https://worldchain-sepolia.g.alchemy.com/public'] },
    },
    blockExplorers: {
        default: {
            name: 'Worldscan Sepolia',
            url: 'https://sepolia.worldscan.org',
        },
        blockscout: {
            name: 'Blockscout',
            url: 'https://worldchain-sepolia.explorer.alchemy.com',
            apiUrl: 'https://worldchain-sepolia.explorer.alchemy.com/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 0,
        },
        disputeGameFactory: {
            [sourceId$5]: {
                address: '0x8cF97Ee616C986a070F5020d973b456D0120C253',
            },
        },
        l2OutputOracle: {
            [sourceId$5]: {
                address: '0xc8886f8BAb6Eaeb215aDB5f1c686BF699248300e',
            },
        },
        portal: {
            [sourceId$5]: {
                address: '0xFf6EBa109271fe6d4237EeeD4bAb1dD9A77dD1A4',
            },
        },
        l1StandardBridge: {
            [sourceId$5]: {
                address: '0xd7DF54b3989855eb66497301a4aAEc33Dbb3F8DE',
            },
        },
    },
    testnet: true,
    sourceId: sourceId$5,
});

const worldLand = /*#__PURE__*/ defineChain({
    id: 103,
    name: 'WorldLand Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'WLC',
        symbol: 'WLC',
    },
    rpcUrls: {
        default: {
            http: ['https://seoul.worldland.foundation'],
        },
    },
    blockExplorers: {
        default: {
            name: 'WorldLand Scan',
            url: 'https://scan.worldland.foundation',
        },
    },
    testnet: false,
});

const xai = /*#__PURE__*/ defineChain({
    id: 660279,
    name: 'Xai Mainnet',
    nativeCurrency: { name: 'Xai', symbol: 'XAI', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://xai-chain.net/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://explorer.xai-chain.net',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 222549,
        },
    },
    testnet: false,
});

const xaiTestnet = /*#__PURE__*/ defineChain({
    id: 37714555429,
    name: 'Xai Testnet',
    nativeCurrency: { name: 'sXai', symbol: 'sXAI', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://testnet-v2.xai-chain.net/rpc'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://testnet-explorer-v2.xai-chain.net',
        },
    },
    testnet: true,
});

const xdc = /*#__PURE__*/ defineChain({
    id: 50,
    name: 'XinFin Network',
    nativeCurrency: {
        decimals: 18,
        name: 'XDC',
        symbol: 'XDC',
    },
    rpcUrls: {
        default: { http: ['https://rpc.xdcrpc.com'] },
    },
    blockExplorers: {
        default: {
            name: 'XDCScan',
            url: 'https://xdcscan.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0x0B1795ccA8E4eC4df02346a082df54D437F8D9aF',
            blockCreated: 75884020,
        },
    },
});

const xdcTestnet = /*#__PURE__*/ defineChain({
    id: 51,
    name: 'Apothem Network',
    nativeCurrency: {
        decimals: 18,
        name: 'TXDC',
        symbol: 'TXDC',
    },
    rpcUrls: {
        default: { http: ['https://erpc.apothem.network'] },
    },
    blockExplorers: {
        default: {
            name: 'XDCScan',
            url: 'https://testnet.xdcscan.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 59765389,
        },
    },
});

const xLayer = /*#__PURE__*/ defineChain({
    id: 196,
    name: 'X Layer Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'OKB',
        symbol: 'OKB',
    },
    rpcUrls: {
        default: { http: ['https://rpc.xlayer.tech'] },
    },
    blockExplorers: {
        default: {
            name: 'OKLink',
            url: 'https://www.oklink.com/xlayer',
            apiUrl: 'https://www.oklink.com/api/v5/explorer/xlayer/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 47416,
        },
    },
});

const xLayerTestnet = /*#__PURE__*/ defineChain({
    id: 195,
    name: 'X1 Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'OKB',
        symbol: 'OKB',
    },
    rpcUrls: {
        default: { http: ['https://xlayertestrpc.okx.com'] },
    },
    blockExplorers: {
        default: {
            name: 'OKLink',
            url: 'https://www.oklink.com/xlayer-test',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 624344,
        },
    },
    testnet: true,
});

const xrOne = /*#__PURE__*/ defineChain({
    id: 273,
    name: 'XR One',
    nativeCurrency: {
        decimals: 18,
        name: 'XR1',
        symbol: 'XR1',
    },
    rpcUrls: {
        default: {
            http: ['https://xr1.calderachain.xyz/http'],
            webSocket: ['wss://xr1.calderachain.xyz/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://xr1.calderaexplorer.xyz',
        },
    },
    testnet: false,
});

const xrSepolia = /*#__PURE__*/ defineChain({
    id: 2730,
    name: 'XR Sepolia',
    nativeCurrency: {
        decimals: 18,
        name: 'tXR',
        symbol: 'tXR',
    },
    rpcUrls: {
        default: { http: ['https://xr-sepolia-testnet.rpc.caldera.xyz/http'] },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://xr-sepolia-testnet.explorer.caldera.xyz',
        },
    },
    testnet: true,
});

const yooldoVerse = /*#__PURE__*/ defineChain({
    id: 50_005,
    name: 'Yooldo Verse',
    nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.yooldo-verse.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Yooldo Verse Explorer',
            url: 'https://explorer.yooldo-verse.xyz',
        },
    },
});

const yooldoVerseTestnet = /*#__PURE__*/ defineChain({
    id: 50_006,
    name: 'Yooldo Verse Testnet',
    nativeCurrency: { name: 'OAS', symbol: 'OAS', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.testnet.yooldo-verse.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Yooldo Verse Testnet Explorer',
            url: 'https://explorer.testnet.yooldo-verse.xyz',
        },
    },
    testnet: true,
});

const zenchainTestnet = /*#__PURE__*/ defineChain({
    id: 8408,
    name: 'Zenchain Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'ZCX',
        symbol: 'ZCX',
    },
    rpcUrls: {
        default: {
            http: ['https://zenchain-testnet.api.onfinality.io/public'],
            webSocket: ['wss://zenchain-testnet.api.onfinality.io/public-ws'],
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 230019,
        },
    },
    blockExplorers: {
        default: {
            name: 'Zentrace',
            url: 'https://zentrace.io',
        },
    },
    testnet: true,
});

const zeniq = /*#__PURE__*/ defineChain({
    id: 383414847825,
    name: 'Zeniq Mainnet',
    nativeCurrency: { name: 'ZENIQ', symbol: 'ZENIQ', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://api.zeniq.network'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Zeniq Explorer',
            url: 'https://zeniqscan.com',
        },
    },
    testnet: false,
});

const zetachain = /*#__PURE__*/ defineChain({
    id: 7000,
    name: 'ZetaChain',
    nativeCurrency: {
        decimals: 18,
        name: 'Zeta',
        symbol: 'ZETA',
    },
    rpcUrls: {
        default: {
            http: ['https://zetachain-evm.blockpi.network/v1/rpc/public'],
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 1632781,
        },
    },
    blockExplorers: {
        default: {
            name: 'ZetaScan',
            url: 'https://explorer.zetachain.com',
        },
    },
    testnet: false,
});

const zetachainAthensTestnet = /*#__PURE__*/ defineChain({
    id: 7001,
    name: 'ZetaChain Athens Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Zeta',
        symbol: 'aZETA',
    },
    rpcUrls: {
        default: {
            http: ['https://zetachain-athens-evm.blockpi.network/v1/rpc/public'],
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 2715217,
        },
    },
    blockExplorers: {
        default: {
            name: 'ZetaScan',
            url: 'https://athens.explorer.zetachain.com',
        },
    },
    testnet: true,
});

const zhejiang = /*#__PURE__*/ defineChain({
    id: 1_337_803,
    name: 'Zhejiang',
    nativeCurrency: { name: 'Zhejiang Ether', symbol: 'ZhejETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://rpc.zhejiang.ethpandaops.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Beaconchain',
            url: 'https://zhejiang.beaconcha.in',
        },
    },
    testnet: true,
});

const zilliqa = /*#__PURE__*/ defineChain({
    id: 32769,
    name: 'Zilliqa',
    network: 'zilliqa',
    nativeCurrency: { name: 'Zilliqa', symbol: 'ZIL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://api.zilliqa.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Ethernal',
            url: 'https://evmx.zilliqa.com',
        },
    },
    testnet: false,
});

const zilliqaTestnet = /*#__PURE__*/ defineChain({
    id: 33101,
    name: 'Zilliqa Testnet',
    network: 'zilliqa-testnet',
    nativeCurrency: { name: 'Zilliqa', symbol: 'ZIL', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://dev-api.zilliqa.com'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Ethernal',
            url: 'https://evmx.testnet.zilliqa.com',
        },
    },
    testnet: true,
});

const sourceId$4 = 1; // ethereum mainnet
const zircuit = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 48900,
    name: 'Zircuit Mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: [
                'https://zircuit1-mainnet.p2pify.com',
                'https://zircuit1-mainnet.liquify.com',
                'https://zircuit-mainnet.drpc.org',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'Zircuit Explorer',
            url: 'https://explorer.zircuit.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
        },
        l2OutputOracle: {
            [sourceId$4]: {
                address: '0x92Ef6Af472b39F1b363da45E35530c24619245A4',
            },
        },
        portal: {
            [sourceId$4]: {
                address: '0x17bfAfA932d2e23Bd9B909Fd5B4D2e2a27043fb1',
            },
        },
        l1StandardBridge: {
            [sourceId$4]: {
                address: '0x386B76D9cA5F5Fb150B6BFB35CF5379B22B26dd8',
            },
        },
    },
    testnet: false,
});

const sourceId$3 = 11_155_111; // sepolia
const zircuitTestnet = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 48899,
    name: 'Zircuit Testnet',
    nativeCurrency: { name: 'ETH', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: [
                'https://zircuit1-testnet.p2pify.com',
                'https://zircuit1-testnet.liquify.com',
            ],
        },
    },
    blockExplorers: {
        default: {
            name: 'Zircuit Testnet Explorer',
            url: 'https://explorer.testnet.zircuit.com',
        },
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 6040287,
        },
        l2OutputOracle: {
            [sourceId$3]: {
                address: '0x740C2dac453aEf7140809F80b72bf0e647af8148',
            },
        },
        portal: {
            [sourceId$3]: {
                address: '0x787f1C8c5924178689E0560a43D848bF8E54b23e',
            },
        },
        l1StandardBridge: {
            [sourceId$3]: {
                address: '0x0545c5fe980098C16fcD0eCB5E79753afa6d9af9',
            },
        },
    },
    testnet: true,
});

const zkFair = /*#__PURE__*/ defineChain({
    id: 42766,
    name: 'ZKFair Mainnet',
    network: 'zkfair-mainnet',
    nativeCurrency: {
        decimals: 18,
        name: 'USD Coin',
        symbol: 'USDC',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.zkfair.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'zkFair Explorer',
            url: 'https://scan.zkfair.io',
            apiUrl: 'https://scan.zkfair.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 6090959,
        },
    },
    testnet: false,
});

const zkFairTestnet = /*#__PURE__*/ defineChain({
    id: 43851,
    name: 'ZKFair Testnet',
    network: 'zkfair-testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'USD Coin',
        symbol: 'USDC',
    },
    rpcUrls: {
        default: {
            http: ['https://testnet-rpc.zkfair.io'],
        },
    },
    blockExplorers: {
        default: {
            name: 'zkFair Explorer',
            url: 'https://testnet-scan.zkfair.io',
        },
    },
    testnet: true,
});

const zkLinkNova = /*#__PURE__*/ defineChain({
    id: 810180,
    name: 'zkLink Nova',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['https://rpc.zklink.io'] },
    },
    blockExplorers: {
        default: {
            name: 'zkLink Nova Block Explorer',
            url: 'https://explorer.zklink.io',
        },
    },
});

const zkLinkNovaSepoliaTestnet = /*#__PURE__*/ defineChain({
    id: 810181,
    name: 'zkLink Nova Sepolia Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: { http: ['https://sepolia.rpc.zklink.io'] },
    },
    blockExplorers: {
        default: {
            name: 'zkLink Nova Block Explorer',
            url: 'https://sepolia.explorer.zklink.io',
        },
    },
});

const zksync = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 324,
    name: 'ZKsync Era',
    network: 'zksync-era',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://mainnet.era.zksync.io'],
            webSocket: ['wss://mainnet.era.zksync.io/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://era.zksync.network/',
            apiUrl: 'https://api-era.zksync.network/api',
        },
        native: {
            name: 'ZKsync Explorer',
            url: 'https://explorer.zksync.io/',
            apiUrl: 'https://block-explorer-api.mainnet.zksync.io/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xF9cda624FBC7e059355ce98a31693d299FACd963',
        },
        universalSignatureVerifier: {
            address: '0xfB688330379976DA81eB64Fe4BF50d7401763B9C',
            blockCreated: 45659388,
        },
    },
});

const zksyncInMemoryNode = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 260,
    name: 'ZKsync InMemory Node',
    network: 'zksync-in-memory-node',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['http://localhost:8011'],
        },
    },
    testnet: true,
});

// The local hyperchain setup: https://github.com/matter-labs/local-setup/blob/main/zk-chains-docker-compose.yml
const zksyncLocalCustomHyperchain = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 272,
    name: 'ZKsync CLI Local Custom Hyperchain',
    nativeCurrency: { name: 'BAT', symbol: 'BAT', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['http://localhost:15200'],
            webSocket: ['ws://localhost:15201'],
        },
    },
    blockExplorers: {
        default: {
            name: 'ZKsync explorer',
            url: 'http://localhost:15005/',
            apiUrl: 'http://localhost:15005/api',
        },
    },
    testnet: true,
});

// The local hyperchain setup: https://github.com/matter-labs/local-setup/blob/main/zk-chains-docker-compose.yml
const zksyncLocalHyperchain = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 270,
    name: 'ZKsync CLI Local Hyperchain',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['http://localhost:15100'],
            webSocket: ['ws://localhost:15101'],
        },
    },
    blockExplorers: {
        default: {
            name: 'ZKsync explorer',
            url: 'http://localhost:15005/',
            apiUrl: 'http://localhost:15005/api',
        },
    },
    testnet: true,
});

// The local hyperchain setup: https://github.com/matter-labs/local-setup/blob/main/zk-chains-docker-compose.yml
const zksyncLocalHyperchainL1 = /*#__PURE__*/ defineChain({
    id: 9,
    name: 'ZKsync CLI Local Hyperchain L1',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['http://localhost:15045'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'http://localhost:15001/',
            apiUrl: 'http://localhost:15001/api/v2',
        },
    },
    testnet: true,
});

const zksyncLocalNode = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 270,
    name: 'ZKsync CLI Local Node',
    network: 'zksync-cli-local-node',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['http://localhost:3050'],
        },
    },
    testnet: true,
});

const zksyncSepoliaTestnet = /*#__PURE__*/ defineChain({
    ...chainConfig$3,
    id: 300,
    name: 'ZKsync Sepolia Testnet',
    network: 'zksync-sepolia-testnet',
    nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
    rpcUrls: {
        default: {
            http: ['https://sepolia.era.zksync.dev'],
            webSocket: ['wss://sepolia.era.zksync.dev/ws'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://sepolia-era.zksync.network/',
            apiUrl: 'https://api-sepolia-era.zksync.network/api',
        },
        native: {
            name: 'ZKsync Explorer',
            url: 'https://sepolia.explorer.zksync.io/',
            blockExplorerApi: 'https://block-explorer-api.sepolia.zksync.dev/api',
        },
    },
    contracts: {
        multicall3: {
            address: '0xF9cda624FBC7e059355ce98a31693d299FACd963',
        },
        universalSignatureVerifier: {
            address: '0xfB688330379976DA81eB64Fe4BF50d7401763B9C',
            blockCreated: 3855712,
        },
    },
    testnet: true,
});

const sourceId$2 = 1; // mainnet
const zora = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 7777777,
    name: 'Zora',
    nativeCurrency: {
        decimals: 18,
        name: 'Ether',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.zora.energy'],
            webSocket: ['wss://rpc.zora.energy'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Explorer',
            url: 'https://explorer.zora.energy',
            apiUrl: 'https://explorer.zora.energy/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$2]: {
                address: '0x9E6204F750cD866b299594e2aC9eA824E2e5f95c',
            },
        },
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 5882,
        },
        portal: {
            [sourceId$2]: {
                address: '0x1a0ad011913A150f69f6A19DF447A0CfD9551054',
            },
        },
        l1StandardBridge: {
            [sourceId$2]: {
                address: '0x3e2Ea9B92B7E48A52296fD261dc26fd995284631',
            },
        },
    },
    sourceId: sourceId$2,
});

const sourceId$1 = 11_155_111; // sepolia
const zoraSepolia = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 999999999,
    name: 'Zora Sepolia',
    network: 'zora-sepolia',
    nativeCurrency: {
        decimals: 18,
        name: 'Zora Sepolia',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://sepolia.rpc.zora.energy'],
            webSocket: ['wss://sepolia.rpc.zora.energy'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Zora Sepolia Explorer',
            url: 'https://sepolia.explorer.zora.energy/',
            apiUrl: 'https://sepolia.explorer.zora.energy/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        l2OutputOracle: {
            [sourceId$1]: {
                address: '0x2615B481Bd3E5A1C0C7Ca3Da1bdc663E8615Ade9',
            },
        },
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 83160,
        },
        portal: {
            [sourceId$1]: {
                address: '0xeffE2C6cA9Ab797D418f0D91eA60807713f3536f',
            },
        },
        l1StandardBridge: {
            [sourceId$1]: {
                address: '0x5376f1D543dcbB5BD416c56C189e4cB7399fCcCB',
            },
        },
    },
    sourceId: sourceId$1,
    testnet: true,
});

const sourceId = 5; // goerli
const zoraTestnet = /*#__PURE__*/ defineChain({
    ...chainConfig$2,
    id: 999,
    name: 'Zora Goerli Testnet',
    nativeCurrency: {
        decimals: 18,
        name: 'Zora Goerli',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://testnet.rpc.zora.energy'],
            webSocket: ['wss://testnet.rpc.zora.energy'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Explorer',
            url: 'https://testnet.explorer.zora.energy',
            apiUrl: 'https://testnet.explorer.zora.energy/api',
        },
    },
    contracts: {
        ...chainConfig$2.contracts,
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 189123,
        },
        portal: {
            [sourceId]: {
                address: '0xDb9F51790365e7dc196e7D072728df39Be958ACe',
            },
        },
    },
    sourceId,
    testnet: true,
});

// biome-ignore lint/performance/noBarrelFile: entrypoint module

var viemChains = /*#__PURE__*/Object.freeze({
	__proto__: null,
	abey: abey,
	abstract: abstract,
	abstractTestnet: abstractTestnet,
	acala: acala,
	acria: acria,
	adf: adf,
	aioz: aioz,
	alephZero: alephZero,
	alephZeroTestnet: alephZeroTestnet,
	alienx: alienx,
	alienxHalTestnet: alienxHalTestnet,
	ancient8: ancient8,
	ancient8Sepolia: ancient8Sepolia,
	anvil: anvil,
	apeChain: apeChain,
	apexTestnet: apexTestnet,
	arbitrum: arbitrum,
	arbitrumGoerli: arbitrumGoerli,
	arbitrumNova: arbitrumNova,
	arbitrumSepolia: arbitrumSepolia,
	areonNetwork: areonNetwork,
	areonNetworkTestnet: areonNetworkTestnet,
	artelaTestnet: artelaTestnet,
	arthera: arthera,
	artheraTestnet: artheraTestnet,
	assetChain: assetChain,
	assetChainTestnet: assetChainTestnet,
	astar: astar,
	astarZkEVM: astarZkEVM,
	astarZkyoto: astarZkyoto,
	atletaOlympia: atletaOlympia,
	aurora: aurora,
	auroraTestnet: auroraTestnet,
	auroria: auroria,
	avalanche: avalanche,
	avalancheFuji: avalancheFuji,
	b3: b3,
	b3Sepolia: b3Sepolia,
	bahamut: bahamut,
	base: base$1,
	baseGoerli: baseGoerli,
	baseSepolia: baseSepolia$1,
	beam: beam,
	beamTestnet: beamTestnet,
	bearNetworkChainMainnet: bearNetworkChainMainnet,
	bearNetworkChainTestnet: bearNetworkChainTestnet,
	berachain: berachain,
	berachainTestnet: berachainTestnet,
	berachainTestnetbArtio: berachainTestnetbArtio,
	bevmMainnet: bevmMainnet,
	bifrost: bifrost,
	bitTorrent: bitTorrent,
	bitTorrentTestnet: bitTorrentTestnet,
	bitgert: bitgert,
	bitkub: bitkub,
	bitkubTestnet: bitkubTestnet,
	bitlayer: bitlayer,
	bitlayerTestnet: bitlayerTestnet,
	bitrock: bitrock,
	blast: blast,
	blastSepolia: blastSepolia,
	bob: bob,
	bobSepolia: bobSepolia,
	boba: boba,
	bobaSepolia: bobaSepolia,
	boolBetaMainnet: boolBetaMainnet,
	botanixTestnet: botanixTestnet,
	bounceBit: bounceBit,
	bounceBitTestnet: bounceBitTestnet,
	bronos: bronos,
	bronosTestnet: bronosTestnet,
	bsc: bsc,
	bscGreenfield: bscGreenfield,
	bscTestnet: bscTestnet,
	bsquared: bsquared,
	bsquaredTestnet: bsquaredTestnet,
	btr: btr,
	btrTestnet: btrTestnet,
	bxn: bxn,
	bxnTestnet: bxnTestnet,
	cannon: cannon,
	canto: canto,
	celo: celo,
	celoAlfajores: celoAlfajores,
	chang: chang,
	chiliz: chiliz,
	chips: chips,
	citreaTestnet: citreaTestnet,
	classic: classic,
	coinbit: coinbit,
	coinex: coinex,
	confluxESpace: confluxESpace,
	confluxESpaceTestnet: confluxESpaceTestnet,
	coreDao: coreDao,
	corn: corn,
	cornTestnet: cornTestnet,
	crab: crab,
	creatorTestnet: creatorTestnet,
	creditCoin3Mainnet: creditCoin3Mainnet,
	creditCoin3Testnet: creditCoin3Testnet,
	cronos: cronos,
	cronosTestnet: cronosTestnet,
	cronoszkEVM: cronoszkEVM,
	cronoszkEVMTestnet: cronoszkEVMTestnet,
	crossbell: crossbell,
	curtis: curtis,
	cyber: cyber,
	cyberTestnet: cyberTestnet,
	dailyNetwork: dailyNetwork,
	dailyNetworkTestnet: dailyNetworkTestnet,
	darwinia: darwinia,
	dchain: dchain,
	dchainTestnet: dchainTestnet,
	defichainEvm: defichainEvm,
	defichainEvmTestnet: defichainEvmTestnet,
	degen: degen,
	dfk: dfk,
	diode: diode,
	disChain: disChain,
	dodochainTestnet: dodochainTestnet,
	dogechain: dogechain,
	donatuz: donatuz,
	dosChain: dosChain,
	dosChainTestnet: dosChainTestnet,
	dreyerxMainnet: dreyerxMainnet,
	dreyerxTestnet: dreyerxTestnet,
	dustboyIoT: dustboyIoT,
	dymension: dymension,
	edgeless: edgeless,
	edgelessTestnet: edgelessTestnet,
	edgeware: edgeware,
	edgewareTestnet: edgewareTestnet,
	ekta: ekta,
	ektaTestnet: ektaTestnet,
	elastos: elastos,
	elastosTestnet: elastosTestnet,
	electroneum: electroneum,
	electroneumTestnet: electroneumTestnet,
	elysiumTestnet: elysiumTestnet,
	energy: energy,
	enuls: enuls,
	eon: eon,
	eos: eos,
	eosTestnet: eosTestnet,
	etherlink: etherlink,
	etherlinkTestnet: etherlinkTestnet,
	etp: etp,
	evmos: evmos,
	evmosTestnet: evmosTestnet,
	excelonMainnet: excelonMainnet,
	expanse: expanse,
	exsat: exsat,
	exsatTestnet: exsatTestnet,
	fantom: fantom,
	fantomSonicTestnet: fantomSonicTestnet,
	fantomTestnet: fantomTestnet,
	fibo: fibo,
	filecoin: filecoin,
	filecoinCalibration: filecoinCalibration,
	filecoinHyperspace: filecoinHyperspace,
	fireChain: fireChain,
	flare: flare,
	flareTestnet: flareTestnet,
	flowMainnet: flowMainnet,
	flowPreviewnet: flowPreviewnet,
	flowTestnet: flowTestnet,
	fluence: fluence,
	fluenceStage: fluenceStage,
	fluenceTestnet: fluenceTestnet,
	forma: forma,
	forta: forta,
	foundry: foundry,
	fraxtal: fraxtal,
	fraxtalTestnet: fraxtalTestnet,
	funkiMainnet: funkiMainnet,
	funkiSepolia: funkiSepolia,
	fuse: fuse,
	fuseSparknet: fuseSparknet,
	fusion: fusion,
	fusionTestnet: fusionTestnet,
	garnet: garnet,
	geist: geist,
	genesys: genesys,
	glideL1Protocol: glideL1Protocol,
	glideL2Protocol: glideL2Protocol,
	gnosis: gnosis,
	gnosisChiado: gnosisChiado,
	goChain: goChain,
	goat: goat,
	gobi: gobi,
	godwoken: godwoken,
	goerli: goerli,
	gravity: gravity,
	guruNetwork: guruNetwork,
	guruTestnet: guruTestnet,
	ham: ham,
	happychainTestnet: happychainTestnet,
	haqqMainnet: haqqMainnet,
	haqqTestedge2: haqqTestedge2,
	hardhat: hardhat,
	harmonyOne: harmonyOne,
	hashkeyTestnet: hashkeyTestnet,
	hedera: hedera,
	hederaPreviewnet: hederaPreviewnet,
	hederaTestnet: hederaTestnet,
	hela: hela,
	hemi: hemi,
	hemiSepolia: hemiSepolia,
	holesky: holesky,
	hpb: hpb,
	huddle01Mainnet: huddle01Mainnet,
	huddle01Testnet: huddle01Testnet,
	humanode: humanode,
	humanodeTestnet5: humanodeTestnet5,
	hychain: hychain,
	hychainTestnet: hychainTestnet,
	iSunCoin: iSunCoin,
	idchain: idchain,
	immutableZkEvm: immutableZkEvm,
	immutableZkEvmTestnet: immutableZkEvmTestnet,
	inEVM: inEVM,
	initVerse: initVerse,
	initVerseGenesis: initVerseGenesis,
	ink: ink,
	inkSepolia: inkSepolia,
	iota: iota,
	iotaTestnet: iotaTestnet,
	iotex: iotex,
	iotexTestnet: iotexTestnet,
	jbc: jbc,
	jbcTestnet: jbcTestnet,
	kaia: kaia,
	kairos: kairos,
	kakarotSepolia: kakarotSepolia,
	kakarotStarknetSepolia: kakarotStarknetSepolia,
	kardiaChain: kardiaChain,
	karura: karura,
	kava: kava,
	kavaTestnet: kavaTestnet,
	kcc: kcc,
	kinto: kinto,
	klaytn: klaytn,
	klaytnBaobab: klaytnBaobab,
	koi: koi,
	kroma: kroma,
	kromaSepolia: kromaSepolia,
	l3x: l3x,
	l3xTestnet: l3xTestnet,
	lavita: lavita,
	lensTestnet: lensTestnet,
	lightlinkPegasus: lightlinkPegasus,
	lightlinkPhoenix: lightlinkPhoenix,
	linea: linea,
	lineaGoerli: lineaGoerli,
	lineaSepolia: lineaSepolia,
	lineaTestnet: lineaTestnet,
	lisk: lisk,
	liskSepolia: liskSepolia,
	localhost: localhost,
	loop: loop,
	lukso: lukso,
	luksoTestnet: luksoTestnet,
	lumiaMainnet: lumiaMainnet,
	lumiaTestnet: lumiaTestnet,
	lycan: lycan,
	lyra: lyra,
	mainnet: mainnet,
	mandala: mandala,
	manta: manta,
	mantaSepoliaTestnet: mantaSepoliaTestnet,
	mantaTestnet: mantaTestnet,
	mantle: mantle,
	mantleSepoliaTestnet: mantleSepoliaTestnet,
	mantleTestnet: mantleTestnet,
	mapProtocol: mapProtocol,
	matchain: matchain,
	matchainTestnet: matchainTestnet,
	mchVerse: mchVerse,
	mekong: mekong,
	meld: meld,
	merlin: merlin,
	metachain: metachain,
	metachainIstanbul: metachainIstanbul,
	metadium: metadium,
	metalL2: metalL2,
	meter: meter,
	meterTestnet: meterTestnet,
	metis: metis,
	metisGoerli: metisGoerli,
	mev: mev,
	mevTestnet: mevTestnet,
	mint: mint,
	mintSepoliaTestnet: mintSepoliaTestnet,
	mitosisTestnet: mitosisTestnet,
	mode: mode$1,
	modeTestnet: modeTestnet,
	monadTestnet: monadTestnet,
	moonbaseAlpha: moonbaseAlpha,
	moonbeam: moonbeam,
	moonbeamDev: moonbeamDev,
	moonriver: moonriver,
	morph: morph,
	morphHolesky: morphHolesky,
	morphSepolia: morphSepolia,
	nahmii: nahmii,
	nautilus: nautilus,
	near: near,
	nearTestnet: nearTestnet,
	neonDevnet: neonDevnet,
	neonMainnet: neonMainnet,
	neoxMainnet: neoxMainnet,
	neoxT4: neoxT4,
	nexi: nexi,
	nexilix: nexilix,
	oasisTestnet: oasisTestnet,
	oasys: oasys,
	odysseyTestnet: odysseyTestnet,
	okc: okc,
	omax: omax,
	oneWorld: oneWorld,
	oortMainnetDev: oortMainnetDev,
	opBNB: opBNB,
	opBNBTestnet: opBNBTestnet,
	optimism: optimism,
	optimismGoerli: optimismGoerli,
	optimismSepolia: optimismSepolia,
	optopia: optopia,
	optopiaTestnet: optopiaTestnet,
	orderly: orderly,
	orderlySepolia: orderlySepolia,
	otimDevnet: otimDevnet,
	palm: palm,
	palmTestnet: palmTestnet,
	pgn: pgn,
	pgnTestnet: pgnTestnet,
	phoenix: phoenix,
	planq: planq,
	playfiAlbireo: playfiAlbireo,
	plinga: plinga,
	plume: plume,
	plumeDevnet: plumeDevnet,
	plumeTestnet: plumeTestnet,
	polterTestnet: polterTestnet,
	polygon: polygon,
	polygonAmoy: polygonAmoy,
	polygonMumbai: polygonMumbai,
	polygonZkEvm: polygonZkEvm,
	polygonZkEvmCardona: polygonZkEvmCardona,
	polygonZkEvmTestnet: polygonZkEvmTestnet,
	premiumBlockTestnet: premiumBlockTestnet,
	pulsechain: pulsechain,
	pulsechainV4: pulsechainV4,
	qMainnet: qMainnet,
	qTestnet: qTestnet,
	ql1: ql1,
	real: real,
	redbellyMainnet: redbellyMainnet,
	redbellyTestnet: redbellyTestnet,
	reddioSepolia: reddioSepolia,
	redstone: redstone,
	rei: rei,
	reyaNetwork: reyaNetwork,
	rivalz: rivalz,
	rollux: rollux,
	rolluxTestnet: rolluxTestnet,
	ronin: ronin,
	root: root$1,
	rootPorcini: rootPorcini,
	rootstock: rootstock,
	rootstockTestnet: rootstockTestnet,
	rss3: rss3,
	rss3Sepolia: rss3Sepolia,
	saakuru: saakuru,
	saga: saga,
	saigon: saigon,
	sanko: sanko,
	sapphire: sapphire,
	sapphireTestnet: sapphireTestnet,
	satoshiVM: satoshiVM,
	satoshiVMTestnet: satoshiVMTestnet,
	scroll: scroll,
	scrollSepolia: scrollSepolia,
	sei: sei,
	seiDevnet: seiDevnet,
	seiTestnet: seiTestnet,
	sepolia: sepolia,
	shape: shape,
	shapeSepolia: shapeSepolia,
	shardeumSphinx: shardeumSphinx,
	shibarium: shibarium,
	shibariumTestnet: shibariumTestnet,
	shiden: shiden,
	shimmer: shimmer,
	shimmerTestnet: shimmerTestnet,
	sidraChain: sidraChain,
	silicon: silicon,
	siliconSepolia: siliconSepolia,
	sixProtocol: sixProtocol,
	skaleBlockBrawlers: skaleBlockBrawlers,
	skaleCalypso: skaleCalypso,
	skaleCalypsoTestnet: skaleCalypsoTestnet,
	skaleCryptoBlades: skaleCryptoBlades,
	skaleCryptoColosseum: skaleCryptoColosseum,
	skaleEuropa: skaleEuropa,
	skaleEuropaTestnet: skaleEuropaTestnet,
	skaleExorde: skaleExorde,
	skaleHumanProtocol: skaleHumanProtocol,
	skaleNebula: skaleNebula,
	skaleNebulaTestnet: skaleNebulaTestnet,
	skaleRazor: skaleRazor,
	skaleTitan: skaleTitan,
	skaleTitanTestnet: skaleTitanTestnet,
	sketchpad: sketchpad,
	snax: snax,
	snaxTestnet: snaxTestnet,
	soneium: soneium,
	soneiumMinato: soneiumMinato,
	songbird: songbird,
	songbirdTestnet: songbirdTestnet,
	sonic: sonic,
	sonicTestnet: sonicTestnet,
	sophon: sophon,
	sophonTestnet: sophonTestnet,
	spicy: spicy,
	step: step,
	storyOdyssey: storyOdyssey,
	storyTestnet: storyTestnet,
	stratis: stratis,
	superlumio: superlumio,
	superposition: superposition,
	superseed: superseed,
	superseedSepolia: superseedSepolia,
	swan: swan,
	swanProximaTestnet: swanProximaTestnet,
	swanSaturnTestnet: swanSaturnTestnet,
	swellchain: swellchain,
	swissdlt: swissdlt,
	syscoin: syscoin,
	syscoinTestnet: syscoinTestnet,
	taiko: taiko,
	taikoHekla: taikoHekla,
	taikoJolnir: taikoJolnir,
	taikoKatla: taikoKatla,
	taikoTestnetSepolia: taikoTestnetSepolia,
	taraxa: taraxa,
	taraxaTestnet: taraxaTestnet,
	telcoinTestnet: telcoinTestnet,
	telos: telos,
	telosTestnet: telosTestnet,
	tenet: tenet,
	ternoa: ternoa,
	thaiChain: thaiChain,
	that: that,
	theta: theta,
	thetaTestnet: thetaTestnet,
	thunderCore: thunderCore,
	thunderTestnet: thunderTestnet,
	tiktrixTestnet: tiktrixTestnet,
	tomb: tomb,
	treasure: treasure,
	treasureTopaz: treasureTopaz,
	tron: tron,
	ubiq: ubiq,
	ultra: ultra,
	ultraTestnet: ultraTestnet,
	ultron: ultron,
	ultronTestnet: ultronTestnet,
	unichainSepolia: unichainSepolia,
	unique: unique,
	uniqueOpal: uniqueOpal,
	uniqueQuartz: uniqueQuartz,
	unreal: unreal,
	vanar: vanar,
	vechain: vechain,
	velas: velas,
	viction: viction,
	victionTestnet: victionTestnet,
	vision: vision,
	visionTestnet: visionTestnet,
	wanchain: wanchain,
	wanchainTestnet: wanchainTestnet,
	weaveVMAlphanet: weaveVMAlphanet,
	wemix: wemix,
	wemixTestnet: wemixTestnet,
	wmcTestnet: wmcTestnet,
	worldLand: worldLand,
	worldchain: worldchain,
	worldchainSepolia: worldchainSepolia,
	x1Testnet: xLayerTestnet,
	xLayer: xLayer,
	xLayerTestnet: xLayerTestnet,
	xai: xai,
	xaiTestnet: xaiTestnet,
	xdc: xdc,
	xdcTestnet: xdcTestnet,
	xrOne: xrOne,
	xrSepolia: xrSepolia,
	yooldoVerse: yooldoVerse,
	yooldoVerseTestnet: yooldoVerseTestnet,
	zenchainTestnet: zenchainTestnet,
	zeniq: zeniq,
	zetachain: zetachain,
	zetachainAthensTestnet: zetachainAthensTestnet,
	zhejiang: zhejiang,
	zilliqa: zilliqa,
	zilliqaTestnet: zilliqaTestnet,
	zircuit: zircuit,
	zircuitTestnet: zircuitTestnet,
	zkFair: zkFair,
	zkFairTestnet: zkFairTestnet,
	zkLinkNova: zkLinkNova,
	zkLinkNovaSepoliaTestnet: zkLinkNovaSepoliaTestnet,
	zkSync: zksync,
	zkSyncInMemoryNode: zksyncInMemoryNode,
	zkSyncLocalNode: zksyncLocalNode,
	zkSyncSepoliaTestnet: zksyncSepoliaTestnet,
	zksync: zksync,
	zksyncInMemoryNode: zksyncInMemoryNode,
	zksyncLocalCustomHyperchain: zksyncLocalCustomHyperchain,
	zksyncLocalHyperchain: zksyncLocalHyperchain,
	zksyncLocalHyperchainL1: zksyncLocalHyperchainL1,
	zksyncLocalNode: zksyncLocalNode,
	zksyncSepoliaTestnet: zksyncSepoliaTestnet,
	zora: zora,
	zoraSepolia: zoraSepolia,
	zoraTestnet: zoraTestnet
});

/* eslint-disable max-len */
const gasPriceOracleAbiAddress = '0x420000000000000000000000000000000000000F';
/**
 * ABI for the OP Stack [`GasPriceOracle` contract](https://github.com/ethereum-optimism/optimism/blob/develop/packages/contracts-bedrock/src/L2/GasPriceOracle.sol).
 * @see https://optimistic.etherscan.io/address/0x420000000000000000000000000000000000000f
 */
const gasPriceOracleAbi = [
    {
        inputs: [{ internalType: 'bytes', name: '_data', type: 'bytes' }],
        name: 'getL1Fee',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
];

const estimateL1Fee$1 = (publicClient, transaction) => __awaiter$e(void 0, void 0, void 0, function* () {
    const serializedTransaction = serializeTransaction$3(Object.assign(Object.assign({ chainId: publicClient.chain.id }, transaction), { type: transaction.type ? transaction.type : 'eip1559' }));
    return publicClient.readContract({
        abi: gasPriceOracleAbi,
        address: gasPriceOracleAbiAddress,
        args: [serializedTransaction],
        functionName: 'getL1Fee',
    });
});
const opStackSupportedChains = [
    optimism.id,
    optimismGoerli.id,
    optimismSepolia.id,
    base$1.id,
    baseGoerli.id,
    baseSepolia$1.id,
];

// eslint-disable-next-line import/no-namespace
const chainsMap = Object.values(viemChains).reduce((acc, chain) => (Object.assign(Object.assign({}, acc), { [chain.id]: chain })), {});

/* eslint-disable max-len */
const erc20Abi$1 = [
    {
        constant: true,
        inputs: [],
        name: 'name',
        outputs: [
            {
                name: '',
                type: 'string',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            {
                name: '_spender',
                type: 'address',
            },
            {
                name: '_value',
                type: 'uint256',
            },
        ],
        name: 'approve',
        outputs: [
            {
                name: '',
                type: 'bool',
            },
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'totalSupply',
        outputs: [
            {
                name: '',
                type: 'uint256',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            {
                name: '_from',
                type: 'address',
            },
            {
                name: '_to',
                type: 'address',
            },
            {
                name: '_value',
                type: 'uint256',
            },
        ],
        name: 'transferFrom',
        outputs: [
            {
                name: '',
                type: 'bool',
            },
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'decimals',
        outputs: [
            {
                name: '',
                type: 'uint8',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            {
                name: '_owner',
                type: 'address',
            },
        ],
        name: 'balanceOf',
        outputs: [
            {
                name: 'balance',
                type: 'uint256',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'symbol',
        outputs: [
            {
                name: '',
                type: 'string',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            {
                name: '_to',
                type: 'address',
            },
            {
                name: '_value',
                type: 'uint256',
            },
        ],
        name: 'transfer',
        outputs: [
            {
                name: '',
                type: 'bool',
            },
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            {
                name: '_owner',
                type: 'address',
            },
            {
                name: '_spender',
                type: 'address',
            },
        ],
        name: 'allowance',
        outputs: [
            {
                name: '',
                type: 'uint256',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        payable: true,
        stateMutability: 'payable',
        type: 'fallback',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                name: 'spender',
                type: 'address',
            },
            {
                indexed: false,
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
];

class Eip1559FeeFeed {
    constructor({ publicClient, initialGasLimit, initialMaxFeePerGas, }) {
        this.fee = {
            gas: BigInt(0),
        };
        this.publicClient = publicClient;
        this.initialGasLimit = initialGasLimit;
        this.initialMaxFeePerGas = initialMaxFeePerGas;
    }
    fetchFee() {
        return __awaiter$e(this, void 0, void 0, function* () {
            try {
                const l1Fee = yield this.estimateL1Fee();
                // Original transaction already defined the gas limit and max fee per gas
                if (this.initialGasLimit && this.initialMaxFeePerGas) {
                    this.fee.gas = this.initialGasLimit * this.initialMaxFeePerGas + l1Fee;
                    return;
                }
                // Estimate the gas limit
                const gasLimit = yield this.estimateGas();
                // Original transaction defined the max fee per gas
                if (this.initialMaxFeePerGas) {
                    this.fee.gas = gasLimit * this.initialMaxFeePerGas + l1Fee;
                    return;
                }
                // Estimate max fee per gas
                const estimatedFeesPerGas = yield this.publicClient.estimateFeesPerGas();
                if (!estimatedFeesPerGas || !estimatedFeesPerGas.maxFeePerGas) {
                    return;
                }
                this.fee.gas = gasLimit * estimatedFeesPerGas.maxFeePerGas + l1Fee;
                this.maxFeePerGas = estimatedFeesPerGas.maxFeePerGas;
                this.maxPriorityFeePerGas = estimatedFeesPerGas.maxPriorityFeePerGas;
            }
            catch (error) {
                logger$5.debug(error);
                return undefined;
            }
        });
    }
}

/**
 * Estimates the L1 fee for the transaction.
 * Currently only supports opStack.
 */
const estimateL1Fee = (publicClient, transaction) => __awaiter$e(void 0, void 0, void 0, function* () {
    const { chain } = publicClient;
    if (!chain) {
        throw new Error('Chain is not defined');
    }
    const publicClientWithChain = publicClient;
    if (opStackSupportedChains.includes(chain.id)) {
        return estimateL1Fee$1(publicClientWithChain, transaction);
    }
    throw new Error('Chain is not supported');
});
const estimateL1FeeSupportedChains = [...opStackSupportedChains];
/**
 * Checks if the chain supports L1 fee estimation.
 */
const isL1FeeSupportedByChain = (chainId) => estimateL1FeeSupportedChains.includes(chainId);

const validateAddressFormat = (address) => /^0x[0-9a-fA-F]{40}$/.test(address);

const parseEther = (input) => parseEther$1(input, 'wei');

const formatEther = (value, { precision } = {}) => formatNumberText(formatEther$1(value), { precision });

const getTransactionRecipient = (data, to) => {
    // 0xa9059cbb is the function selector for the transfer function
    // so we can use it to check if the transaction is a transfer
    // then decode the transaction data to get the recipient
    if (data === null || data === void 0 ? void 0 : data.startsWith('0xa9059cbb')) {
        return decodeAbiParameters([
            { name: 'x', type: 'address' },
            { name: 'x', type: 'uint256' },
        ], ('0x' + (data === null || data === void 0 ? void 0 : data.slice(10))))[0];
    }
    // if the data is 0x or undefined, then the recipient is the "to" address
    if (!data || data === '0x') {
        return to !== null && to !== void 0 ? to : undefined;
    }
    return undefined;
};

class ViemUiTransaction extends Eip1559FeeFeed {
    constructor({ transaction, onSubmit, publicClient, account, }) {
        super({
            initialGasLimit: transaction.gas,
            initialMaxFeePerGas: transaction.maxFeePerGas,
            publicClient,
        });
        this.chain = 'EVM';
        this.validateAddressFormat = validateAddressFormat;
        this.parse = parseEther;
        this.parseNonNativeToken = (amount, decimals) => parseUnits(amount, decimals);
        this.format = formatEther;
        this.formatNonNativeToken = (value, decimals) => formatUnits(value, decimals);
        this.transaction = transaction;
        this.onSubmit = onSubmit;
        this.publicClient = publicClient;
        this.address = account;
    }
    get to() {
        return this.transaction.to || undefined;
    }
    set to(toAddress) {
        this.transaction.to = toAddress;
    }
    get from() {
        return this.address;
    }
    get value() {
        return this.transaction.value;
    }
    set value(value) {
        this.transaction.value = value;
    }
    get nonNativeValue() {
        return this.transaction.nonNativeValue;
    }
    set nonNativeValue(value) {
        this.transaction.nonNativeValue = value;
    }
    get nonNativeAddress() {
        return this.transaction.nonNativeAddress;
    }
    set nonNativeAddress(value) {
        this.transaction.nonNativeAddress = value;
    }
    get nonNativeDecimal() {
        return this.transaction.nonNativeDecimal;
    }
    set nonNativeDecimal(value) {
        this.transaction.nonNativeDecimal = value;
    }
    get data() {
        return this.transaction.data;
    }
    submit() {
        return __awaiter$e(this, void 0, void 0, function* () {
            return this.onSubmit(this.transaction).catch((error) => {
                if (error instanceof UserRejectedTransactionError) {
                    throw new TransactionExecutionError(new BaseError$1(error.message), this.transaction);
                }
                throw error;
            });
        });
    }
    getBalance() {
        return this.publicClient.getBalance({ address: this.address });
    }
    estimateGas() {
        return __awaiter$e(this, void 0, void 0, function* () {
            const hexResult = (yield this.publicClient.transport.request({
                method: 'eth_estimateGas',
                params: [
                    {
                        data: this.data,
                        to: this.to,
                        value: this.convertBigIntToHex(this.value),
                    },
                ],
            }));
            return hexToBigInt(hexResult);
        });
    }
    convertBigIntToHex(value) {
        return value ? toHex(value) : undefined;
    }
    getTransactionRecipient() {
        var _a;
        return getTransactionRecipient(this.transaction.data, (_a = this.transaction.to) !== null && _a !== void 0 ? _a : undefined);
    }
    estimateL1Fee() {
        return __awaiter$e(this, void 0, void 0, function* () {
            var _a;
            if (!isL1FeeSupportedByChain(((_a = this.publicClient.chain) === null || _a === void 0 ? void 0 : _a.id) || 0)) {
                return BigInt(0);
            }
            return estimateL1Fee(this.publicClient, {
                data: this.transaction.data,
                to: this.transaction.to,
                value: this.transaction.value,
            });
        });
    }
    set maxFeePerGas(value) {
        this.transaction.maxFeePerGas = value;
    }
    set maxPriorityFeePerGas(value) {
        this.transaction.maxPriorityFeePerGas = value;
    }
}

const createViemUiTransaction = (_a) => __awaiter$e(void 0, [_a], void 0, function* ({ from, publicClient, walletClient, }) {
    return new ViemUiTransaction({
        account: from,
        onSubmit: (transaction) => __awaiter$e(void 0, void 0, void 0, function* () {
            // Non native token
            if (transaction.nonNativeAddress) {
                return walletClient.writeContract({
                    abi: erc20Abi$1,
                    account: from,
                    address: transaction.nonNativeAddress,
                    args: [transaction.to, transaction.nonNativeValue],
                    functionName: 'transfer',
                    maxFeePerGas: transaction.maxFeePerGas,
                    maxPriorityFeePerGas: transaction.maxPriorityFeePerGas,
                });
            }
            // Native token
            return walletClient.sendTransaction({
                account: from,
                data: '0x',
                maxFeePerGas: transaction.maxFeePerGas,
                maxPriorityFeePerGas: transaction.maxPriorityFeePerGas,
                to: transaction.to,
                value: transaction.value,
            });
        }),
        publicClient,
        transaction: {},
    });
});

// eslint-disable-next-line import/no-namespace
/**
 * Gets the chain object for the given chain id.
 * @param chainId - Chain id of the target EVM chain.
 * @returns Viem's chain object.
 */
const getChain = (chainId) => {
    for (const chain of Object.values(viemChains)) {
        if ('id' in chain) {
            if (chain.id === chainId) {
                return chain;
            }
        }
    }
    throw new Error(`Chain with id ${chainId} not found`);
};
const mapChain = (network) => {
    var _a;
    return ({
        blockExplorers: ((_a = network.blockExplorerUrls) === null || _a === void 0 ? void 0 : _a[0])
            ? {
                default: {
                    name: network.blockExplorerUrls[0],
                    url: network.blockExplorerUrls[0],
                },
            }
            : undefined,
        id: network.chainId,
        name: network.vanityName || network.name || network.chainName,
        nativeCurrency: network.nativeCurrency,
        rpcUrls: {
            default: { http: network.rpcUrls },
            public: { http: network.rpcUrls },
        },
    });
};
const getOrMapViemChain = (network) => {
    let viemChain;
    try {
        viemChain = getChain(network.chainId);
    }
    catch (_a) {
        logger$5.debug(`Chain with id ${network.chainId} not found in viem's chains`);
    }
    const mappedChain = mapChain(network);
    if (!viemChain) {
        return mappedChain;
    }
    // even if a chain is found in viem's chains, we still want to overwrite some values
    return Object.assign(Object.assign({}, viemChain), mappedChain);
};

const findEvmNetwork = ({ chainId, name, networks, }) => {
    if (!chainId && !name) {
        return undefined;
    }
    if (chainId && name) {
        return networks.find((network) => network.chainId === chainId && network.name === name);
    }
    else if (chainId) {
        return networks.find((network) => network.chainId === chainId);
    }
    else {
        return networks.find((network) => network.name === name);
    }
};

var L2ResolverAbi = [
    {
        inputs: [
            {
                internalType: 'contract ENS',
                name: 'ens_',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'registrarController_',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'reverseRegistrar_',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'owner_',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        inputs: [],
        name: 'AlreadyInitialized',
        type: 'error',
    },
    {
        inputs: [],
        name: 'CantSetSelfAsDelegate',
        type: 'error',
    },
    {
        inputs: [],
        name: 'CantSetSelfAsOperator',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NewOwnerIsZeroAddress',
        type: 'error',
    },
    {
        inputs: [],
        name: 'NoHandoverRequest',
        type: 'error',
    },
    {
        inputs: [],
        name: 'Unauthorized',
        type: 'error',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'uint256',
                name: 'contentType',
                type: 'uint256',
            },
        ],
        name: 'ABIChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'a',
                type: 'address',
            },
        ],
        name: 'AddrChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'coinType',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'newAddress',
                type: 'bytes',
            },
        ],
        name: 'AddressChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'ApprovalForAll',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'delegate',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'Approved',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'hash',
                type: 'bytes',
            },
        ],
        name: 'ContenthashChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'name',
                type: 'bytes',
            },
            {
                indexed: false,
                internalType: 'uint16',
                name: 'resource',
                type: 'uint16',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'record',
                type: 'bytes',
            },
        ],
        name: 'DNSRecordChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'name',
                type: 'bytes',
            },
            {
                indexed: false,
                internalType: 'uint16',
                name: 'resource',
                type: 'uint16',
            },
        ],
        name: 'DNSRecordDeleted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'lastzonehash',
                type: 'bytes',
            },
            {
                indexed: false,
                internalType: 'bytes',
                name: 'zonehash',
                type: 'bytes',
            },
        ],
        name: 'DNSZonehashChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'bytes4',
                name: 'interfaceID',
                type: 'bytes4',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'implementer',
                type: 'address',
            },
        ],
        name: 'InterfaceChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'name',
                type: 'string',
            },
        ],
        name: 'NameChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'pendingOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipHandoverCanceled',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'pendingOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipHandoverRequested',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'oldOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'bytes32',
                name: 'x',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'bytes32',
                name: 'y',
                type: 'bytes32',
            },
        ],
        name: 'PubkeyChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'newRegistrarController',
                type: 'address',
            },
        ],
        name: 'RegistrarControllerUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'newReverseRegistrar',
                type: 'address',
            },
        ],
        name: 'ReverseRegistrarUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: true,
                internalType: 'string',
                name: 'indexedKey',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'key',
                type: 'string',
            },
            {
                indexed: false,
                internalType: 'string',
                name: 'value',
                type: 'string',
            },
        ],
        name: 'TextChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                indexed: false,
                internalType: 'uint64',
                name: 'newVersion',
                type: 'uint64',
            },
        ],
        name: 'VersionChanged',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'uint256',
                name: 'contentTypes',
                type: 'uint256',
            },
        ],
        name: 'ABI',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
        ],
        name: 'addr',
        outputs: [
            {
                internalType: 'address payable',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'uint256',
                name: 'coinType',
                type: 'uint256',
            },
        ],
        name: 'addr',
        outputs: [
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'delegate',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'approve',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'cancelOwnershipHandover',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
        ],
        name: 'clearRecords',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'pendingOwner',
                type: 'address',
            },
        ],
        name: 'completeOwnershipHandover',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
        ],
        name: 'contenthash',
        outputs: [
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: 'name',
                type: 'bytes32',
            },
            {
                internalType: 'uint16',
                name: 'resource',
                type: 'uint16',
            },
        ],
        name: 'dnsRecord',
        outputs: [
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'ens',
        outputs: [
            {
                internalType: 'contract ENS',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: 'name',
                type: 'bytes32',
            },
        ],
        name: 'hasDNSRecords',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'bytes4',
                name: 'interfaceID',
                type: 'bytes4',
            },
        ],
        name: 'interfaceImplementer',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'delegate',
                type: 'address',
            },
        ],
        name: 'isApprovedFor',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'account',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
        ],
        name: 'isApprovedForAll',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes[]',
                name: 'data',
                type: 'bytes[]',
            },
        ],
        name: 'multicall',
        outputs: [
            {
                internalType: 'bytes[]',
                name: 'results',
                type: 'bytes[]',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'nodehash',
                type: 'bytes32',
            },
            {
                internalType: 'bytes[]',
                name: 'data',
                type: 'bytes[]',
            },
        ],
        name: 'multicallWithNodeCheck',
        outputs: [
            {
                internalType: 'bytes[]',
                name: 'results',
                type: 'bytes[]',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
        ],
        name: 'name',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: 'result',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'pendingOwner',
                type: 'address',
            },
        ],
        name: 'ownershipHandoverExpiresAt',
        outputs: [
            {
                internalType: 'uint256',
                name: 'result',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
        ],
        name: 'pubkey',
        outputs: [
            {
                internalType: 'bytes32',
                name: 'x',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: 'y',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        name: 'recordVersions',
        outputs: [
            {
                internalType: 'uint64',
                name: '',
                type: 'uint64',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'registrarController',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'renounceOwnership',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'requestOwnershipHandover',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'resolve',
        outputs: [
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'reverseRegistrar',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'uint256',
                name: 'contentType',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'setABI',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'uint256',
                name: 'coinType',
                type: 'uint256',
            },
            {
                internalType: 'bytes',
                name: 'a',
                type: 'bytes',
            },
        ],
        name: 'setAddr',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'address',
                name: 'a',
                type: 'address',
            },
        ],
        name: 'setAddr',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'operator',
                type: 'address',
            },
            {
                internalType: 'bool',
                name: 'approved',
                type: 'bool',
            },
        ],
        name: 'setApprovalForAll',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'bytes',
                name: 'hash',
                type: 'bytes',
            },
        ],
        name: 'setContenthash',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'bytes',
                name: 'data',
                type: 'bytes',
            },
        ],
        name: 'setDNSRecords',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'bytes4',
                name: 'interfaceID',
                type: 'bytes4',
            },
            {
                internalType: 'address',
                name: 'implementer',
                type: 'address',
            },
        ],
        name: 'setInterface',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'string',
                name: 'newName',
                type: 'string',
            },
        ],
        name: 'setName',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: 'x',
                type: 'bytes32',
            },
            {
                internalType: 'bytes32',
                name: 'y',
                type: 'bytes32',
            },
        ],
        name: 'setPubkey',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'registrarController_',
                type: 'address',
            },
        ],
        name: 'setRegistrarController',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'reverseRegistrar_',
                type: 'address',
            },
        ],
        name: 'setReverseRegistrar',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'string',
                name: 'key',
                type: 'string',
            },
            {
                internalType: 'string',
                name: 'value',
                type: 'string',
            },
        ],
        name: 'setText',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'bytes',
                name: 'hash',
                type: 'bytes',
            },
        ],
        name: 'setZonehash',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes4',
                name: 'interfaceID',
                type: 'bytes4',
            },
        ],
        name: 'supportsInterface',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
            {
                internalType: 'string',
                name: 'key',
                type: 'string',
            },
        ],
        name: 'text',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: 'node',
                type: 'bytes32',
            },
        ],
        name: 'zonehash',
        outputs: [
            {
                internalType: 'bytes',
                name: '',
                type: 'bytes',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];

const getNameservice = (_a) => __awaiter$e(void 0, [_a], void 0, function* ({ rpcProvider, address, }) {
    const nsData = {
        avatar: undefined,
        name: undefined,
    };
    const network = yield rpcProvider.getChainId();
    if (!network) {
        return nsData;
    }
    // per CB team they recommended using the code
    // from: https://github.com/coinbase/onchainkit/blob/main/src/identity/utils/getName.ts
    // Once they will have proper resolver for the ens names we can remove this code
    const convertReverseNodeToBytes = (address, chainId) => {
        const addressFormatted = address.toLocaleLowerCase();
        const addressNode = keccak256(addressFormatted.substring(2));
        const chainCoinType = convertChainIdToCoinType(chainId);
        const baseReverseNode = namehash(`${chainCoinType.toLocaleUpperCase()}.reverse`);
        const addressReverseNode = keccak256(encodePacked(['bytes32', 'bytes32'], [baseReverseNode, addressNode]));
        return addressReverseNode;
    };
    const convertChainIdToCoinType = (chainId) => {
        const cointype = (0x80000000 | chainId) >>> 0;
        return cointype.toString(16).toLocaleUpperCase();
    };
    if (network === 8453) {
        const addressReverseNode = convertReverseNodeToBytes(address, 8453);
        try {
            const baseName = yield rpcProvider.readContract({
                abi: L2ResolverAbi,
                address: '0xC6d566A56A1aFf6508b41f6c90ff131615583BCD',
                args: [addressReverseNode],
                functionName: 'name',
            });
            if (baseName) {
                nsData.name = baseName;
                return nsData;
            }
        }
        catch (_error) {
            // This is a best effort attempt, so we don't need to do anything here.
            return nsData;
        }
    }
    else {
        nsData.name = (yield rpcProvider.getEnsName({
            address: address,
        }));
        nsData.avatar = nsData.name
            ? (yield rpcProvider.getEnsAvatar({
                name: nsData.name,
            }))
            : undefined;
    }
    return nsData;
});

/**
 * @description
 * Checks if the error has a `walk` method
 */
const isTransactionExecutionError$1 = (error) => error !== undefined &&
    error !== null &&
    typeof error === 'object' &&
    'walk' in error &&
    typeof error['walk'] === 'function';

const interceptTransport = ({ getAccounts, onPersonalSign, onSendTransaction, onSignTypedData, transport, }) => (props) => {
    const provider = transport(props);
    return custom$1({
        request: (args) => __awaiter$e(void 0, void 0, void 0, function* () {
            var _a;
            const { method, params } = args;
            if (getAccounts && method === 'eth_accounts') {
                return getAccounts({ provider });
            }
            if (onPersonalSign && method === 'personal_sign') {
                const [message] = params;
                return onPersonalSign({ args, message, provider }).catch((error) => {
                    if (error instanceof UserRejectedRequestError) {
                        throw new UserRejectedRequestError$1(error);
                    }
                    throw error;
                });
            }
            if (onSendTransaction && method === 'eth_sendTransaction') {
                const [transaction] = params;
                return onSendTransaction({ args, provider, transaction }).catch((error) => {
                    if (isTransactionExecutionError$1(error) &&
                        error.walk() instanceof UserRejectedTransactionError) {
                        throw new UserRejectedRequestError$1(error.walk());
                    }
                    if (error instanceof UserRejectedTransactionError) {
                        throw new UserRejectedRequestError$1(error);
                    }
                    if (error instanceof UserRejectedRequestError) {
                        throw new UserRejectedRequestError$1(error);
                    }
                    throw error;
                });
            }
            if (onSignTypedData && method === 'eth_signTypedData_v4') {
                const [, message] = (_a = params) !== null && _a !== void 0 ? _a : [];
                return onSignTypedData({ args, message, provider }).catch((error) => {
                    if (error instanceof UserRejectedRequestError) {
                        throw new UserRejectedRequestError$1(error);
                    }
                    throw error;
                });
            }
            return provider.request(args);
        }),
    })(props);
};

const parseAddress = (address) => {
    try {
        return getAddress(address);
    }
    catch (error) {
        return address;
    }
};

class EthereumWallet extends Wallet$1 {
    constructor(props) {
        super(Object.assign(Object.assign({}, props), { address: parseAddress(props.address) }));
    }
    /**
     * Sends the native balance of the wallet to the given address.
     * @param amount - The amount of balance to send (in ETH).
     * @param toAddress - The address to send the balance to.
     * @param token - The token to send (optional) — for example, an ERC20 token.
     *   @param token.address - The address of the token contract.
     *   @param token.decimals - The decimals of the token (defaults to 18).
     * @returns The transaction hash of the sent transaction.
     */
    sendBalance(_a) {
        return __awaiter$e(this, arguments, void 0, function* ({ amount, toAddress, token, }) {
            const provider = yield this.getWalletClient();
            if (token && token.address) {
                const erc20Contract = getContract({
                    abi: erc20Abi$1,
                    address: token.address,
                    client: provider,
                });
                const transfer = yield erc20Contract.write['transfer']([
                    toAddress,
                    parseUnits(amount, token.decimals || 18),
                ]);
                return transfer;
            }
            const transaction = {
                account: this.address,
                chain: getChain(yield provider.getChainId()),
                to: toAddress,
                value: amount ? parseEther$1(amount) : undefined,
            };
            const transactionHash = yield provider.sendTransaction(transaction);
            return transactionHash;
        });
    }
    /**
     * Retrieves the public client.
     * @returns A promise that resolves to the public client,
     * or throws if the client cannot be retrieved.
     */
    getPublicClient() {
        return __awaiter$e(this, void 0, void 0, function* () {
            const client = yield this._connector.getPublicClient();
            if (!client) {
                throw new Error('Unable to retrieve PublicClient');
            }
            return client;
        });
    }
    /**
     * Retrieves the wallet client.
     * @param chainId - (optional) Chain id to be used by the wallet client.
     * @returns A promise that resolves to the wallet client,
     * or throws if the client cannot be retrieved.
     */
    getWalletClient(chainId) {
        return __awaiter$e(this, void 0, void 0, function* () {
            const walletClient = this._connector.getWalletClient(chainId);
            if (!walletClient) {
                throw new Error('Unable to retrieve WalletClient');
            }
            return createWalletClient({
                account: this.address,
                chain: walletClient.chain,
                transport: interceptTransport({
                    onPersonalSign: (_a) => __awaiter$e(this, [_a], void 0, function* ({ provider, args }) {
                        yield this.sync();
                        return provider.request(args);
                    }),
                    onSendTransaction: (_b) => __awaiter$e(this, [_b], void 0, function* ({ provider, args }) {
                        yield this.sync();
                        return provider.request(args);
                    }),
                    onSignTypedData: (_c) => __awaiter$e(this, [_c], void 0, function* ({ provider, args }) {
                        yield this.sync();
                        return provider.request(args);
                    }),
                    transport: custom$1(walletClient.transport),
                }),
            });
        });
    }
}

class EthereumWalletConnector extends WalletConnectorBase {
    constructor(props) {
        var _a, _b;
        super(props);
        this.supportedChains = ['EVM', 'ETH'];
        this.connectedChain = 'EVM';
        this.ChainWallet = EthereumWallet;
        this.evmNetworkRpcMap = () => this.evmNetworks.reduce((acc, network) => {
            var _a;
            [acc[network.chainId]] = ((_a = network === null || network === void 0 ? void 0 : network.privateCustomerRpcUrls) === null || _a === void 0 ? void 0 : _a.length)
                ? network.privateCustomerRpcUrls
                : network.rpcUrls;
            return acc;
        }, {});
        this.walletUiUtils = props.walletUiUtils;
        this.evmNetworks = parseEvmNetworks(props.evmNetworks);
        this.chainRpcProviders = props.chainRpcProviders;
        (_a = this.chainRpcProviders) === null || _a === void 0 ? void 0 : _a.registerEvmProviders((_b = props.providersConfig) !== null && _b !== void 0 ? _b : {});
    }
    getPublicClient() {
        return __awaiter$e(this, void 0, void 0, function* () {
            var _a, _b;
            const networkId = (_a = (yield this.getNetwork())) !== null && _a !== void 0 ? _a : 1;
            if (this.evmNetworks.length === 0) {
                return undefined;
            }
            const configurations = {
                cosmos: [],
                evm: this.evmNetworks,
                solana: [],
                starknet: undefined,
            };
            if (!this.chainRpcProviders)
                return undefined;
            const providers = this.chainRpcProviders.getProviders(configurations);
            return (_b = this.chainRpcProviders.getEvmProviderByChainId(providers, networkId)) === null || _b === void 0 ? void 0 : _b.provider;
        });
    }
    getNetwork() {
        return __awaiter$e(this, void 0, void 0, function* () {
            const provider = this.getWalletClient();
            if (!this.supportsNetworkSwitching || !provider) {
                return Promise.resolve(undefined);
            }
            const chainId = yield retryableFn(provider.getChainId, {
                fallbackValue: FALLBACK_UNDEFINED,
                /**
                 * The timeout is set to 1 second because the getChainId method
                 * takes around 500ms to resolve on Brave. If the timeout is not set
                 * it will use 100ms by default and the method will fail.
                 * QNTM-815
                 */
                timeoutMs: 1000,
            });
            this.setActiveChain(chainsMap[chainId]);
            return chainId;
        });
    }
    getNameService(address) {
        return __awaiter$e(this, void 0, void 0, function* () {
            const rpcProvider = yield this.getPublicClient();
            if (!rpcProvider) {
                return;
            }
            return getNameservice({ address, rpcProvider });
        });
    }
    isTestnet() {
        return __awaiter$e(this, void 0, void 0, function* () {
            var _a, _b, _c;
            return (_c = (_b = (_a = (yield this.getPublicClient())) === null || _a === void 0 ? void 0 : _a.chain) === null || _b === void 0 ? void 0 : _b.testnet) !== null && _c !== void 0 ? _c : false;
        });
    }
    parseAddress(address) {
        try {
            // Ensures the address follows the EIP55 format.
            // see: https://eips.ethereum.org/EIPS/eip-55
            return getAddress(address);
        }
        catch (err) {
            logger$8.debug(`Failed to parse EVM address into EIP55 format: error getting checksum, returning default ${address}`, err);
        }
        return address;
    }
    getSigner() {
        return __awaiter$e(this, void 0, void 0, function* () {
            return this.getWalletClient();
        });
    }
    getBalance(address) {
        return __awaiter$e(this, void 0, void 0, function* () {
            const client = yield this.getPublicClient();
            const result = yield (client === null || client === void 0 ? void 0 : client.getBalance({
                address: address,
            }));
            if (!result && result !== BigInt(0))
                return;
            return formatEther$1(result);
        });
    }
    supportsNetworkSwitching() {
        return true;
    }
    switchNetwork(_a) {
        return __awaiter$e(this, arguments, void 0, function* ({ networkName, networkChainId, }) {
            const network = findEvmNetwork({
                chainId: networkChainId,
                name: networkName,
                networks: this.evmNetworks,
            });
            if (!network) {
                throw new DynamicError(`Could not find network mapping for chain ${networkName ? networkName : networkChainId}`);
            }
            if (!this.supportsNetworkSwitching()) {
                throw new DynamicError('Network switching is not supported');
            }
            const provider = this.getWalletClient();
            if (!provider) {
                throw new DynamicError('Provider not found');
            }
            return this.providerSwitchNetwork({ network, provider });
        });
    }
    chooseAccountsToConnect() {
        return __awaiter$e(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const provider = this.getWalletClient();
            if (!provider)
                return [];
            try {
                const result = yield provider.requestPermissions({ eth_accounts: {} });
                logger$8.debug('chooseAccountsToConnect - requestPermissions result', result);
                // this should return the connected addresses for MM
                const addresses = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.find((r) => r.parentCapability === 'eth_accounts')) === null || _a === void 0 ? void 0 : _a.caveats) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value;
                if (typeof addresses === 'string') {
                    return [addresses];
                }
                if (Array.isArray(addresses)) {
                    return addresses;
                }
                return [];
            }
            catch (error) {
                logger$8.debug('chooseAccountsToConnect - error', error);
                // might fail if method is not supported, but just throw if user rejected
                if (error.code === 4001) {
                    throw new UserRejectedRequestError();
                }
            }
            return [];
        });
    }
    getConnectedAccounts() {
        return __awaiter$e(this, void 0, void 0, function* () {
            const provider = this.getWalletClient();
            if (!provider)
                return [];
            const addresses = yield retryableFn(provider.getAddresses, {
                fallbackValue: [],
                timeoutMs: 500,
            });
            if (addresses.length) {
                this.setActiveAccount(addresses[0]);
            }
            return addresses;
        });
    }
    providerSwitchNetwork(_a) {
        return __awaiter$e(this, arguments, void 0, function* ({ network, provider, }) {
            var _b, _c, _d, _e, _f;
            const { chainId } = network;
            const currentNetworkId = yield this.getNetwork();
            if (currentNetworkId && currentNetworkId === chainId) {
                return;
            }
            try {
                if (!this.supportsNetworkSwitching()) {
                    throw new DynamicError('Network switching is not supported');
                }
                const viemChain = getOrMapViemChain(network);
                yield provider.switchChain({ id: viemChain.id });
                if (this.key === 'magiceden') {
                    const newChainId = yield provider.getChainId();
                    this.emit('chainChange', { chain: newChainId.toString() });
                }
                else {
                    this.setActiveChain(viemChain);
                }
            }
            catch (error) {
                if ((_b = error.details) === null || _b === void 0 ? void 0 : _b.includes('"wallet_switchEthereumChain" not implemented')) {
                    throw new DynamicError('Network switching is not available at this time. The user should manually switch network in their wallet');
                }
                // we need to check for unrecognized chain error first because it also contains 'rejected' in message
                if (error.code === 4902 ||
                    ((_c = error.message) === null || _c === void 0 ? void 0 : _c.includes('Unrecognized chain')) ||
                    // https://github.com/MetaMask/metamask-mobile/issues/3312#issuecomment-1065923294
                    ((_e = (_d = error.data) === null || _d === void 0 ? void 0 : _d.orginalError) === null || _e === void 0 ? void 0 : _e.code) === 4902) {
                    // error code indicates the chain has not been added yet
                    // https://docs.metamask.io/guide/rpc-api.html#usage-with-wallet-switchethereumchain
                    return this.providerAddNetwork({ network, provider });
                }
                else if (((_f = error.message) === null || _f === void 0 ? void 0 : _f.includes('rejected')) ||
                    (typeof error === 'string' && error.includes('rejected'))) {
                    throw new DynamicError("User rejected the wallet's request to switch network");
                }
                else {
                    throw error;
                }
            }
        });
    }
    providerAddNetwork(_a) {
        return __awaiter$e(this, arguments, void 0, function* ({ network, provider, }) {
            var _b;
            try {
                if (isMobile()) {
                    yield this.walletUiUtils.addNetwork({
                        handler: () => provider.addChain({ chain: getOrMapViemChain(network) }),
                        network,
                        walletConnector: this,
                    });
                }
                else {
                    yield provider.addChain({ chain: getOrMapViemChain(network) });
                }
            }
            catch (error) {
                if (((_b = error.message) === null || _b === void 0 ? void 0 : _b.includes('rejected')) ||
                    (typeof error === 'string' && error.includes('rejected'))) {
                    throw new DynamicError("User rejected the wallet's request to add network");
                }
                else {
                    throw error;
                }
            }
        });
    }
    setActiveAccount(account) {
        this.activeAccount = account ? toAccount(account) : undefined;
    }
    getActiveAccount() {
        return this.activeAccount;
    }
    setActiveChain(chain) {
        this.activeChain = chain;
    }
    getActiveChain() {
        return this.activeChain;
    }
    createUiTransaction(from) {
        return __awaiter$e(this, void 0, void 0, function* () {
            yield this.validateActiveWallet(from);
            const walletClient = yield this.getWalletClient();
            const publicClient = yield this.getPublicClient();
            if (!publicClient || !walletClient) {
                throw new DynamicError('No public client available');
            }
            return createViemUiTransaction({
                from,
                publicClient,
                walletClient,
            });
        });
    }
    confirmTransactionStatus(txHash) {
        return __awaiter$e(this, void 0, void 0, function* () {
            const publicClient = yield this.getPublicClient();
            if (!publicClient) {
                throw new DynamicError('No public client available');
            }
            // The number of confirmations (blocks that have passed) to wait before resolving.
            const confirmations = 3;
            return publicClient.waitForTransactionReceipt({
                confirmations,
                hash: txHash,
            });
        });
    }
    getBlockExplorerUrlsForCurrentNetwork() {
        return __awaiter$e(this, void 0, void 0, function* () {
            var _a, _b;
            const currentNetwork = yield this.getNetwork();
            return ((_b = (_a = this.evmNetworks.find((network) => network.chainId.toString() === (currentNetwork === null || currentNetwork === void 0 ? void 0 : currentNetwork.toString()))) === null || _a === void 0 ? void 0 : _a.blockExplorerUrls) !== null && _b !== void 0 ? _b : []);
        });
    }
    getEnabledNetworks() {
        return this.evmNetworks;
    }
}

var version$8 = "4.6.1";

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-namespace */
var ProviderChain;
(function (ProviderChain) {
    ProviderChain["ECLIPSE"] = "eclipse";
    ProviderChain["EVM"] = "evm";
    ProviderChain["SOLANA"] = "solana";
    ProviderChain["STARKNET"] = "starknet";
})(ProviderChain || (ProviderChain = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter$9(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

class ChainRpcProvidersClass {
    static get client() {
        if (!ChainRpcProvidersClass.instance) {
            ChainRpcProvidersClass.instance = new ChainRpcProvidersClass();
        }
        return ChainRpcProvidersClass.instance;
    }
    constructor() {
        this.getProvidersMethods = {};
    }
    static getProviders(configurations) {
        Object.values(ProviderChain).forEach((chain) => {
            var _a, _b;
            if (!ChainRpcProvidersClass.providers[chain]) {
                const providers = (_b = (_a = ChainRpcProvidersClass.client.getProvidersMethods)[chain]) === null || _b === void 0 ? void 0 : _b.call(_a, configurations);
                if (providers) {
                    Object.assign(ChainRpcProvidersClass.providers, {
                        [chain]: providers,
                    });
                }
            }
        });
        return ChainRpcProvidersClass.providers;
    }
    static registerChainProviders(providerChain, fn) {
        return __awaiter$9(this, void 0, void 0, function* () {
            if (!ChainRpcProvidersClass.client.getProvidersMethods[providerChain]) {
                Object.assign(ChainRpcProvidersClass.client.getProvidersMethods, {
                    [providerChain]: fn,
                });
            }
        });
    }
}
ChainRpcProvidersClass.providers = {};
ChainRpcProvidersClass.wipeInstance = () => {
    ChainRpcProvidersClass.instance = undefined;
    ChainRpcProvidersClass.providers = {};
};
//@ts-ignore
const ChainRpcProviders = ChainRpcProvidersClass;

assertPackageVersion('@dynamic-labs/rpc-providers', version$8);

ChainRpcProviders.getEvmProviderByChainId = (rpcProviders, chainId) => {
    var _a;
    const provider = (_a = rpcProviders['evm']) === null || _a === void 0 ? void 0 : _a.find((provider) => provider.chainId === chainId);
    return provider;
};
ChainRpcProviders.registerEvmProviders = (providersConfig) => {
    if (!providersConfig) {
        throw new Error('providersConfig is required');
    }
    ChainRpcProviders.registerChainProviders(ProviderChain.EVM, (config) => {
        const rpcProviders = {};
        if (config === null || config === void 0 ? void 0 : config['evm']) {
            rpcProviders.evm = parseEvmNetworks(config['evm']).map((network) => {
                var _a;
                const rpcUrl = ((_a = network.privateCustomerRpcUrls) === null || _a === void 0 ? void 0 : _a[0]) || network.rpcUrls[0];
                const provider = createPublicClient({
                    chain: getOrMapViemChain(network),
                    transport: http(rpcUrl, providersConfig === null || providersConfig === void 0 ? void 0 : providersConfig.publicClientHttpTransportConfig),
                });
                return {
                    chainId: network.chainId,
                    chainName: network.name,
                    provider,
                };
            });
        }
        return rpcProviders.evm;
    });
};

/* eslint-disable max-len */
/**
 * Unformat a transaction request
 * This is used to convert the transaction the RPC transporter receives from
 * an eth_sendTransaction call to a format that viem account accepts.
 * This reverts what viem is doing internally with the format function.
 * https://github.com/wagmi-dev/viem/blob/0977829160effbe7dac5a69f43d263605544fa19/src/actions/wallet/sendTransaction.ts#L206
 */
const unFormatTransaction = (transactionRequest) => (Object.assign(Object.assign({}, transactionRequest), { gas: typeof transactionRequest.gas !== 'undefined'
        ? hexToBigInt(transactionRequest.gas)
        : undefined, gasPrice: typeof transactionRequest.gasPrice !== 'undefined'
        ? hexToBigInt(transactionRequest.gasPrice)
        : undefined, maxFeePerGas: typeof transactionRequest.maxFeePerGas !== 'undefined'
        ? hexToBigInt(transactionRequest.maxFeePerGas)
        : undefined, maxPriorityFeePerGas: typeof transactionRequest.maxPriorityFeePerGas !== 'undefined'
        ? hexToBigInt(transactionRequest.maxPriorityFeePerGas)
        : undefined, nonce: typeof transactionRequest.nonce !== 'undefined'
        ? hexToBigInt(transactionRequest.nonce)
        : undefined, value: typeof transactionRequest.value !== 'undefined'
        ? hexToBigInt(transactionRequest.value)
        : undefined }));

const createAccountWithUiConfirmation = ({ address, account, provider, walletConnector, walletUiUtils, }) => toAccount({
    address,
    signMessage: (...args) => __awaiter$e(void 0, void 0, void 0, function* () {
        return walletUiUtils.signMessage({
            handler: () => __awaiter$e(void 0, void 0, void 0, function* () { return (yield account()).signMessage(...args); }),
            message: (() => {
                var _a;
                const msg = (_a = args[0]) === null || _a === void 0 ? void 0 : _a.message;
                return msg && !(typeof msg === 'string' && Array.isArray(msg))
                    ? JSON.stringify(msg)
                    : msg === null || msg === void 0 ? void 0 : msg.toString();
            })(),
            walletConnector,
        });
    }),
    signTransaction: (...args) => __awaiter$e(void 0, void 0, void 0, function* () {
        const uiTransaction = new ViemUiTransaction({
            account: address,
            onSubmit: (transaction) => __awaiter$e(void 0, void 0, void 0, function* () { return (yield account()).signTransaction(transaction); }),
            publicClient: provider,
            transaction: args[0],
        });
        return walletUiUtils.sendTransaction(walletConnector, uiTransaction);
    }),
    signTypedData: (...args) => walletUiUtils.signMessage({
        handler: () => __awaiter$e(void 0, void 0, void 0, function* () { return (yield account()).signTypedData(...args); }),
        message: JSON.stringify(args[0]),
        walletConnector,
    }),
});

/**
 * Creates a WalletClient with UI confirmation for sensitive actions.
 *
 * This function initializes a WalletClient instance that integrates with a UI
 * for user confirmations. It wraps the provided transport with additional functionality
 * to handle personal sign requests, transaction sending, and signing typed data by
 * injecting UI confirmation steps before proceeding with the actual wallet actions.
 *
 * @param {Props} props - The properties required to create a WalletClient with UI confirmation.
 * @param {LocalAccount} props.account - The local account to be used with the WalletClient.
 * @param {Chain} props.chain - The blockchain chain to which the WalletClient will connect.
 * @param {Transport} props.transport - The transport layer responsible for communication with the blockchain.
 * @param {WalletUiUtils} props.walletUiUtils - The UI utility functions for the InternalWalletConnector.
 *
 * @returns {WalletClient<Transport, Chain, Account>} An instance of WalletClient equipped with UI confirmation logic.
 */
const createWalletClientWithUiConfirmation = ({ address, account, chain, transport, walletConnector, walletUiUtils, }) => {
    let client = null;
    const provider = createPublicClient({
        chain,
        transport,
    });
    const gatedAccount = createAccountWithUiConfirmation({
        account,
        address,
        provider,
        walletConnector,
        walletUiUtils: walletUiUtils,
    });
    const customTransport = interceptTransport({
        getAccounts: () => __awaiter$e(void 0, void 0, void 0, function* () { return [address]; }),
        onPersonalSign: (_a) => __awaiter$e(void 0, [_a], void 0, function* ({ message }) {
            if (!client)
                throw new Error('Client not initialized');
            return client.signMessage({
                message: {
                    raw: message,
                },
            });
        }),
        onSendTransaction: (_b) => __awaiter$e(void 0, [_b], void 0, function* ({ transaction }) {
            if (!client)
                throw new Error('Client not initialized');
            const unFormattedTransaction = unFormatTransaction(transaction);
            return client.sendTransaction(unFormattedTransaction);
        }),
        onSignTypedData: (_c) => __awaiter$e(void 0, [_c], void 0, function* ({ message }) {
            if (!client)
                throw new Error('Client not initialized');
            return client.signTypedData(JSON.parse(message));
        }),
        transport,
    });
    client = createWalletClient({
        account: gatedAccount,
        chain,
        transport: customTransport,
    });
    return client;
};

const isEthereumWallet = (wallet) => wallet.chain === 'EVM';

assertPackageVersion('@dynamic-labs/ethereum-core', version$h);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest$5(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter$8(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Some wallets may not reject some operations following the EIP-1193 standard.
 * This function normalizes the errors to follow the EIP-1193 standard.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const normalizeRpcError = (err) => {
    /**
     * When the error already comply with the EIP-1193 standard, we don't need to normalize it
     */
    if (err.code === 4001) {
        throw err;
    }
    let mappedError = null;
    try {
        mappedError = mapRpcError(err);
    }
    catch (e) {
        // ignore errors when mapping
    }
    if (mappedError) {
        throw mappedError;
    }
    /**
     * If no error is mapped, we rethrow the original error
     */
    throw err;
};
const mapRpcError = (err) => {
    /**
     * Checks for user rejection error message
     * Rainbow Extension will return a message like "User rejected the request"
     * BitGet will return a message like "user reject this request"
     * Keplr will return a message that matches "Request rejected"
     */
    if (typeof err.message === 'string' &&
        (err.message.includes('User rejected the request') ||
            err.message.includes('user reject this request') ||
            err.message === 'Request rejected')) {
        return new UserRejectedRequestError$1(err);
    }
    return null;
};

class EthProviderHelper {
    constructor(connector) {
        this.walletBookWallet = findWalletBookWallet(connector.walletBook, connector.key);
        this.connector = connector;
    }
    getInstalledProvider() {
        const eip6963Provider = this.getEip6963Provider();
        if (eip6963Provider) {
            return eip6963Provider;
        }
        return this.getInjectedProvider();
    }
    getInjectedProvider() {
        const config = this.getInjectedConfig();
        if (!config ||
            !config.extensionLocators ||
            !config.extensionLocators.length)
            return undefined;
        return this.installedProviderLookup(config.extensionLocators);
    }
    getEip6963Provider() {
        const { rdns } = this.connector.metadata;
        if (!rdns) {
            return undefined;
        }
        return this.eip6963ProviderLookup(rdns);
    }
    getInjectedConfig() {
        var _a;
        const injectedConfig = (_a = this.walletBookWallet) === null || _a === void 0 ? void 0 : _a.injectedConfig;
        return injectedConfig === null || injectedConfig === void 0 ? void 0 : injectedConfig.find((c) => c.chain === 'evm');
    }
    installedProviders() {
        const config = this.getInjectedConfig();
        if (!config)
            return [];
        const providers = [];
        if (config.windowLocations) {
            for (const windowLocation of config.windowLocations) {
                const foundProviders = getProvidersFromWindow(windowLocation);
                if (foundProviders && foundProviders.length)
                    providers.push(...foundProviders);
            }
        }
        if (window.ethereum) {
            if (!window.ethereum.providers || !window.ethereum.providers.length) {
                providers.push(window.ethereum);
            }
            else {
                window.ethereum.providers.forEach((p) => providers.push(p));
            }
        }
        return providers;
    }
    installedProviderLookup(extensionLocators) {
        const allInstalledProviders = this.installedProviders();
        return ProviderLookup(allInstalledProviders, extensionLocators);
    }
    eip6963ProviderLookup(rdns) {
        var _a;
        const { providers } = Eip6963ProviderSingleton.get();
        return (_a = providers.find((provider) => { var _a; return ((_a = provider === null || provider === void 0 ? void 0 : provider.info) === null || _a === void 0 ? void 0 : _a.rdns) === rdns; })) === null || _a === void 0 ? void 0 : _a.provider;
    }
    isInstalledHelper() {
        return this.findProvider() !== undefined;
    }
    findProvider() {
        return this.connector.findProvider();
    }
    findWalletClient(chainId) {
        const provider = this.findProvider();
        if (!provider) {
            return undefined;
        }
        return createWalletClient({
            account: this.connector.getActiveAccount(),
            chain: chainId ? chainsMap[chainId] : this.connector.getActiveChain(),
            transport: custom$1({
                request: (args) => provider.request(args).catch(normalizeRpcError),
            }),
        });
    }
    getAddress() {
        return __awaiter$8(this, void 0, void 0, function* () {
            const client = this.findWalletClient();
            if (!client) {
                return Promise.resolve(undefined);
            }
            return this.getAddressWithProvider(client);
        });
    }
    getAddressWithProvider(client) {
        return __awaiter$8(this, void 0, void 0, function* () {
            try {
                const [lowercaseAddress] = yield client.requestAddresses();
                const publicAddress = getAddress(lowercaseAddress);
                this.connector.setActiveAccount(publicAddress);
                return publicAddress;
            }
            catch (err) {
                logger$8.error(err);
                return Promise.reject(err);
            }
        });
    }
    signMessage(messageToSign) {
        return __awaiter$8(this, void 0, void 0, function* () {
            const walletAddress = yield this.getAddress();
            if (!walletAddress) {
                return Promise.resolve(undefined);
            }
            const client = this.findWalletClient();
            if (!client) {
                return Promise.resolve(undefined);
            }
            const signedMessage = yield client.signMessage({
                account: walletAddress,
                message: messageToSign,
            });
            return signedMessage;
        });
    }
    _setupEventListeners(walletConnector) {
        const web3Provider = this.findProvider();
        if (!web3Provider) {
            logger$8.warn('Provider not found', {
                connector: walletConnector,
            });
            return {
                tearDownEventListeners: () => { },
            };
        }
        if (!web3Provider.on) {
            logger$8.warn('Provider does not support event listeners', {
                connector: walletConnector,
                provider: web3Provider,
            });
            return {
                tearDownEventListeners: () => { },
            };
        }
        const { handleAccountChange, handleChainChange, handleDisconnect } = eventListenerHandlers(walletConnector);
        web3Provider.on('accountsChanged', handleAccountChange);
        web3Provider.on('chainChanged', handleChainChange);
        web3Provider.on('disconnect', handleDisconnect);
        const tearDownEventListeners = () => {
            const web3Provider = this.findProvider();
            if (!web3Provider) {
                return;
            }
            if (handleAccountChange) {
                web3Provider.removeListener('accountsChanged', handleAccountChange);
            }
            if (handleChainChange) {
                web3Provider.removeListener('chainChanged', handleChainChange);
            }
            if (handleDisconnect) {
                web3Provider.removeListener('disconnect', handleDisconnect);
            }
        };
        return {
            tearDownEventListeners,
        };
    }
}

var chacha20poly1305 = {};

var chacha = {};

var binary = {};

var int = {};

var hasRequiredInt;

function requireInt () {
	if (hasRequiredInt) return int;
	hasRequiredInt = 1;
	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		/**
		 * Package int provides helper functions for integerss.
		 */
		// Shim using 16-bit pieces.
		function imulShim(a, b) {
		    var ah = (a >>> 16) & 0xffff, al = a & 0xffff;
		    var bh = (b >>> 16) & 0xffff, bl = b & 0xffff;
		    return ((al * bl) + (((ah * bl + al * bh) << 16) >>> 0) | 0);
		}
		/** 32-bit integer multiplication.  */
		// Use system Math.imul if available, otherwise use our shim.
		exports.mul = Math.imul || imulShim;
		/** 32-bit integer addition.  */
		function add(a, b) {
		    return (a + b) | 0;
		}
		exports.add = add;
		/**  32-bit integer subtraction.  */
		function sub(a, b) {
		    return (a - b) | 0;
		}
		exports.sub = sub;
		/** 32-bit integer left rotation */
		function rotl(x, n) {
		    return x << n | x >>> (32 - n);
		}
		exports.rotl = rotl;
		/** 32-bit integer left rotation */
		function rotr(x, n) {
		    return x << (32 - n) | x >>> n;
		}
		exports.rotr = rotr;
		function isIntegerShim(n) {
		    return typeof n === "number" && isFinite(n) && Math.floor(n) === n;
		}
		/**
		 * Returns true if the argument is an integer number.
		 *
		 * In ES2015, Number.isInteger.
		 */
		exports.isInteger = Number.isInteger || isIntegerShim;
		/**
		 *  Math.pow(2, 53) - 1
		 *
		 *  In ES2015 Number.MAX_SAFE_INTEGER.
		 */
		exports.MAX_SAFE_INTEGER = 9007199254740991;
		/**
		 * Returns true if the argument is a safe integer number
		 * (-MIN_SAFE_INTEGER < number <= MAX_SAFE_INTEGER)
		 *
		 * In ES2015, Number.isSafeInteger.
		 */
		exports.isSafeInteger = function (n) {
		    return exports.isInteger(n) && (n >= -exports.MAX_SAFE_INTEGER && n <= exports.MAX_SAFE_INTEGER);
		};
		
	} (int));
	return int;
}

var hasRequiredBinary;

function requireBinary () {
	if (hasRequiredBinary) return binary;
	hasRequiredBinary = 1;
	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(binary, "__esModule", { value: true });
	/**
	 * Package binary provides functions for encoding and decoding numbers in byte arrays.
	 */
	var int_1 = requireInt();
	// TODO(dchest): add asserts for correct value ranges and array offsets.
	/**
	 * Reads 2 bytes from array starting at offset as big-endian
	 * signed 16-bit integer and returns it.
	 */
	function readInt16BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return (((array[offset + 0] << 8) | array[offset + 1]) << 16) >> 16;
	}
	binary.readInt16BE = readInt16BE;
	/**
	 * Reads 2 bytes from array starting at offset as big-endian
	 * unsigned 16-bit integer and returns it.
	 */
	function readUint16BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return ((array[offset + 0] << 8) | array[offset + 1]) >>> 0;
	}
	binary.readUint16BE = readUint16BE;
	/**
	 * Reads 2 bytes from array starting at offset as little-endian
	 * signed 16-bit integer and returns it.
	 */
	function readInt16LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return (((array[offset + 1] << 8) | array[offset]) << 16) >> 16;
	}
	binary.readInt16LE = readInt16LE;
	/**
	 * Reads 2 bytes from array starting at offset as little-endian
	 * unsigned 16-bit integer and returns it.
	 */
	function readUint16LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return ((array[offset + 1] << 8) | array[offset]) >>> 0;
	}
	binary.readUint16LE = readUint16LE;
	/**
	 * Writes 2-byte big-endian representation of 16-bit unsigned
	 * value to byte array starting at offset.
	 *
	 * If byte array is not given, creates a new 2-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeUint16BE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(2); }
	    if (offset === void 0) { offset = 0; }
	    out[offset + 0] = value >>> 8;
	    out[offset + 1] = value >>> 0;
	    return out;
	}
	binary.writeUint16BE = writeUint16BE;
	binary.writeInt16BE = writeUint16BE;
	/**
	 * Writes 2-byte little-endian representation of 16-bit unsigned
	 * value to array starting at offset.
	 *
	 * If byte array is not given, creates a new 2-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeUint16LE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(2); }
	    if (offset === void 0) { offset = 0; }
	    out[offset + 0] = value >>> 0;
	    out[offset + 1] = value >>> 8;
	    return out;
	}
	binary.writeUint16LE = writeUint16LE;
	binary.writeInt16LE = writeUint16LE;
	/**
	 * Reads 4 bytes from array starting at offset as big-endian
	 * signed 32-bit integer and returns it.
	 */
	function readInt32BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return (array[offset] << 24) |
	        (array[offset + 1] << 16) |
	        (array[offset + 2] << 8) |
	        array[offset + 3];
	}
	binary.readInt32BE = readInt32BE;
	/**
	 * Reads 4 bytes from array starting at offset as big-endian
	 * unsigned 32-bit integer and returns it.
	 */
	function readUint32BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return ((array[offset] << 24) |
	        (array[offset + 1] << 16) |
	        (array[offset + 2] << 8) |
	        array[offset + 3]) >>> 0;
	}
	binary.readUint32BE = readUint32BE;
	/**
	 * Reads 4 bytes from array starting at offset as little-endian
	 * signed 32-bit integer and returns it.
	 */
	function readInt32LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return (array[offset + 3] << 24) |
	        (array[offset + 2] << 16) |
	        (array[offset + 1] << 8) |
	        array[offset];
	}
	binary.readInt32LE = readInt32LE;
	/**
	 * Reads 4 bytes from array starting at offset as little-endian
	 * unsigned 32-bit integer and returns it.
	 */
	function readUint32LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    return ((array[offset + 3] << 24) |
	        (array[offset + 2] << 16) |
	        (array[offset + 1] << 8) |
	        array[offset]) >>> 0;
	}
	binary.readUint32LE = readUint32LE;
	/**
	 * Writes 4-byte big-endian representation of 32-bit unsigned
	 * value to byte array starting at offset.
	 *
	 * If byte array is not given, creates a new 4-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeUint32BE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(4); }
	    if (offset === void 0) { offset = 0; }
	    out[offset + 0] = value >>> 24;
	    out[offset + 1] = value >>> 16;
	    out[offset + 2] = value >>> 8;
	    out[offset + 3] = value >>> 0;
	    return out;
	}
	binary.writeUint32BE = writeUint32BE;
	binary.writeInt32BE = writeUint32BE;
	/**
	 * Writes 4-byte little-endian representation of 32-bit unsigned
	 * value to array starting at offset.
	 *
	 * If byte array is not given, creates a new 4-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeUint32LE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(4); }
	    if (offset === void 0) { offset = 0; }
	    out[offset + 0] = value >>> 0;
	    out[offset + 1] = value >>> 8;
	    out[offset + 2] = value >>> 16;
	    out[offset + 3] = value >>> 24;
	    return out;
	}
	binary.writeUint32LE = writeUint32LE;
	binary.writeInt32LE = writeUint32LE;
	/**
	 * Reads 8 bytes from array starting at offset as big-endian
	 * signed 64-bit integer and returns it.
	 *
	 * IMPORTANT: due to JavaScript limitation, supports exact
	 * numbers in range -9007199254740991 to 9007199254740991.
	 * If the number stored in the byte array is outside this range,
	 * the result is not exact.
	 */
	function readInt64BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var hi = readInt32BE(array, offset);
	    var lo = readInt32BE(array, offset + 4);
	    return hi * 0x100000000 + lo - ((lo >> 31) * 0x100000000);
	}
	binary.readInt64BE = readInt64BE;
	/**
	 * Reads 8 bytes from array starting at offset as big-endian
	 * unsigned 64-bit integer and returns it.
	 *
	 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
	 */
	function readUint64BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var hi = readUint32BE(array, offset);
	    var lo = readUint32BE(array, offset + 4);
	    return hi * 0x100000000 + lo;
	}
	binary.readUint64BE = readUint64BE;
	/**
	 * Reads 8 bytes from array starting at offset as little-endian
	 * signed 64-bit integer and returns it.
	 *
	 * IMPORTANT: due to JavaScript limitation, supports exact
	 * numbers in range -9007199254740991 to 9007199254740991.
	 * If the number stored in the byte array is outside this range,
	 * the result is not exact.
	 */
	function readInt64LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var lo = readInt32LE(array, offset);
	    var hi = readInt32LE(array, offset + 4);
	    return hi * 0x100000000 + lo - ((lo >> 31) * 0x100000000);
	}
	binary.readInt64LE = readInt64LE;
	/**
	 * Reads 8 bytes from array starting at offset as little-endian
	 * unsigned 64-bit integer and returns it.
	 *
	 * IMPORTANT: due to JavaScript limitation, supports values up to 2^53-1.
	 */
	function readUint64LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var lo = readUint32LE(array, offset);
	    var hi = readUint32LE(array, offset + 4);
	    return hi * 0x100000000 + lo;
	}
	binary.readUint64LE = readUint64LE;
	/**
	 * Writes 8-byte big-endian representation of 64-bit unsigned
	 * value to byte array starting at offset.
	 *
	 * Due to JavaScript limitation, supports values up to 2^53-1.
	 *
	 * If byte array is not given, creates a new 8-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeUint64BE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(8); }
	    if (offset === void 0) { offset = 0; }
	    writeUint32BE(value / 0x100000000 >>> 0, out, offset);
	    writeUint32BE(value >>> 0, out, offset + 4);
	    return out;
	}
	binary.writeUint64BE = writeUint64BE;
	binary.writeInt64BE = writeUint64BE;
	/**
	 * Writes 8-byte little-endian representation of 64-bit unsigned
	 * value to byte array starting at offset.
	 *
	 * Due to JavaScript limitation, supports values up to 2^53-1.
	 *
	 * If byte array is not given, creates a new 8-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeUint64LE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(8); }
	    if (offset === void 0) { offset = 0; }
	    writeUint32LE(value >>> 0, out, offset);
	    writeUint32LE(value / 0x100000000 >>> 0, out, offset + 4);
	    return out;
	}
	binary.writeUint64LE = writeUint64LE;
	binary.writeInt64LE = writeUint64LE;
	/**
	 * Reads bytes from array starting at offset as big-endian
	 * unsigned bitLen-bit integer and returns it.
	 *
	 * Supports bit lengths divisible by 8, up to 48.
	 */
	function readUintBE(bitLength, array, offset) {
	    if (offset === void 0) { offset = 0; }
	    // TODO(dchest): implement support for bitLengths non-divisible by 8
	    if (bitLength % 8 !== 0) {
	        throw new Error("readUintBE supports only bitLengths divisible by 8");
	    }
	    if (bitLength / 8 > array.length - offset) {
	        throw new Error("readUintBE: array is too short for the given bitLength");
	    }
	    var result = 0;
	    var mul = 1;
	    for (var i = bitLength / 8 + offset - 1; i >= offset; i--) {
	        result += array[i] * mul;
	        mul *= 256;
	    }
	    return result;
	}
	binary.readUintBE = readUintBE;
	/**
	 * Reads bytes from array starting at offset as little-endian
	 * unsigned bitLen-bit integer and returns it.
	 *
	 * Supports bit lengths divisible by 8, up to 48.
	 */
	function readUintLE(bitLength, array, offset) {
	    if (offset === void 0) { offset = 0; }
	    // TODO(dchest): implement support for bitLengths non-divisible by 8
	    if (bitLength % 8 !== 0) {
	        throw new Error("readUintLE supports only bitLengths divisible by 8");
	    }
	    if (bitLength / 8 > array.length - offset) {
	        throw new Error("readUintLE: array is too short for the given bitLength");
	    }
	    var result = 0;
	    var mul = 1;
	    for (var i = offset; i < offset + bitLength / 8; i++) {
	        result += array[i] * mul;
	        mul *= 256;
	    }
	    return result;
	}
	binary.readUintLE = readUintLE;
	/**
	 * Writes a big-endian representation of bitLen-bit unsigned
	 * value to array starting at offset.
	 *
	 * Supports bit lengths divisible by 8, up to 48.
	 *
	 * If byte array is not given, creates a new one.
	 *
	 * Returns the output byte array.
	 */
	function writeUintBE(bitLength, value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(bitLength / 8); }
	    if (offset === void 0) { offset = 0; }
	    // TODO(dchest): implement support for bitLengths non-divisible by 8
	    if (bitLength % 8 !== 0) {
	        throw new Error("writeUintBE supports only bitLengths divisible by 8");
	    }
	    if (!int_1.isSafeInteger(value)) {
	        throw new Error("writeUintBE value must be an integer");
	    }
	    var div = 1;
	    for (var i = bitLength / 8 + offset - 1; i >= offset; i--) {
	        out[i] = (value / div) & 0xff;
	        div *= 256;
	    }
	    return out;
	}
	binary.writeUintBE = writeUintBE;
	/**
	 * Writes a little-endian representation of bitLen-bit unsigned
	 * value to array starting at offset.
	 *
	 * Supports bit lengths divisible by 8, up to 48.
	 *
	 * If byte array is not given, creates a new one.
	 *
	 * Returns the output byte array.
	 */
	function writeUintLE(bitLength, value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(bitLength / 8); }
	    if (offset === void 0) { offset = 0; }
	    // TODO(dchest): implement support for bitLengths non-divisible by 8
	    if (bitLength % 8 !== 0) {
	        throw new Error("writeUintLE supports only bitLengths divisible by 8");
	    }
	    if (!int_1.isSafeInteger(value)) {
	        throw new Error("writeUintLE value must be an integer");
	    }
	    var div = 1;
	    for (var i = offset; i < offset + bitLength / 8; i++) {
	        out[i] = (value / div) & 0xff;
	        div *= 256;
	    }
	    return out;
	}
	binary.writeUintLE = writeUintLE;
	/**
	 * Reads 4 bytes from array starting at offset as big-endian
	 * 32-bit floating-point number and returns it.
	 */
	function readFloat32BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
	    return view.getFloat32(offset);
	}
	binary.readFloat32BE = readFloat32BE;
	/**
	 * Reads 4 bytes from array starting at offset as little-endian
	 * 32-bit floating-point number and returns it.
	 */
	function readFloat32LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
	    return view.getFloat32(offset, true);
	}
	binary.readFloat32LE = readFloat32LE;
	/**
	 * Reads 8 bytes from array starting at offset as big-endian
	 * 64-bit floating-point number ("double") and returns it.
	 */
	function readFloat64BE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
	    return view.getFloat64(offset);
	}
	binary.readFloat64BE = readFloat64BE;
	/**
	 * Reads 8 bytes from array starting at offset as little-endian
	 * 64-bit floating-point number ("double") and returns it.
	 */
	function readFloat64LE(array, offset) {
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(array.buffer, array.byteOffset, array.byteLength);
	    return view.getFloat64(offset, true);
	}
	binary.readFloat64LE = readFloat64LE;
	/**
	 * Writes 4-byte big-endian floating-point representation of value
	 * to byte array starting at offset.
	 *
	 * If byte array is not given, creates a new 4-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeFloat32BE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(4); }
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
	    view.setFloat32(offset, value);
	    return out;
	}
	binary.writeFloat32BE = writeFloat32BE;
	/**
	 * Writes 4-byte little-endian floating-point representation of value
	 * to byte array starting at offset.
	 *
	 * If byte array is not given, creates a new 4-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeFloat32LE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(4); }
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
	    view.setFloat32(offset, value, true);
	    return out;
	}
	binary.writeFloat32LE = writeFloat32LE;
	/**
	 * Writes 8-byte big-endian floating-point representation of value
	 * to byte array starting at offset.
	 *
	 * If byte array is not given, creates a new 8-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeFloat64BE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(8); }
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
	    view.setFloat64(offset, value);
	    return out;
	}
	binary.writeFloat64BE = writeFloat64BE;
	/**
	 * Writes 8-byte little-endian floating-point representation of value
	 * to byte array starting at offset.
	 *
	 * If byte array is not given, creates a new 8-byte one.
	 *
	 * Returns the output byte array.
	 */
	function writeFloat64LE(value, out, offset) {
	    if (out === void 0) { out = new Uint8Array(8); }
	    if (offset === void 0) { offset = 0; }
	    var view = new DataView(out.buffer, out.byteOffset, out.byteLength);
	    view.setFloat64(offset, value, true);
	    return out;
	}
	binary.writeFloat64LE = writeFloat64LE;
	
	return binary;
}

var wipe = {};

var hasRequiredWipe;

function requireWipe () {
	if (hasRequiredWipe) return wipe;
	hasRequiredWipe = 1;
	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(wipe, "__esModule", { value: true });
	/**
	 * Sets all values in the given array to zero and returns it.
	 *
	 * The fact that it sets bytes to zero can be relied on.
	 *
	 * There is no guarantee that this function makes data disappear from memory,
	 * as runtime implementation can, for example, have copying garbage collector
	 * that will make copies of sensitive data before we wipe it. Or that an
	 * operating system will write our data to swap or sleep image. Another thing
	 * is that an optimizing compiler can remove calls to this function or make it
	 * no-op. There's nothing we can do with it, so we just do our best and hope
	 * that everything will be okay and good will triumph over evil.
	 */
	function wipe$1(array) {
	    // Right now it's similar to array.fill(0). If it turns
	    // out that runtimes optimize this call away, maybe
	    // we can try something else.
	    for (var i = 0; i < array.length; i++) {
	        array[i] = 0;
	    }
	    return array;
	}
	wipe.wipe = wipe$1;
	
	return wipe;
}

var hasRequiredChacha;

function requireChacha () {
	if (hasRequiredChacha) return chacha;
	hasRequiredChacha = 1;
	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(chacha, "__esModule", { value: true });
	/**
	 * Package chacha implements ChaCha stream cipher.
	 */
	var binary_1 = requireBinary();
	var wipe_1 = requireWipe();
	// Number of ChaCha rounds (ChaCha20).
	var ROUNDS = 20;
	// Applies the ChaCha core function to 16-byte input,
	// 32-byte key key, and puts the result into 64-byte array out.
	function core(out, input, key) {
	    var j0 = 0x61707865; // "expa"  -- ChaCha's "sigma" constant
	    var j1 = 0x3320646E; // "nd 3"     for 32-byte keys
	    var j2 = 0x79622D32; // "2-by"
	    var j3 = 0x6B206574; // "te k"
	    var j4 = (key[3] << 24) | (key[2] << 16) | (key[1] << 8) | key[0];
	    var j5 = (key[7] << 24) | (key[6] << 16) | (key[5] << 8) | key[4];
	    var j6 = (key[11] << 24) | (key[10] << 16) | (key[9] << 8) | key[8];
	    var j7 = (key[15] << 24) | (key[14] << 16) | (key[13] << 8) | key[12];
	    var j8 = (key[19] << 24) | (key[18] << 16) | (key[17] << 8) | key[16];
	    var j9 = (key[23] << 24) | (key[22] << 16) | (key[21] << 8) | key[20];
	    var j10 = (key[27] << 24) | (key[26] << 16) | (key[25] << 8) | key[24];
	    var j11 = (key[31] << 24) | (key[30] << 16) | (key[29] << 8) | key[28];
	    var j12 = (input[3] << 24) | (input[2] << 16) | (input[1] << 8) | input[0];
	    var j13 = (input[7] << 24) | (input[6] << 16) | (input[5] << 8) | input[4];
	    var j14 = (input[11] << 24) | (input[10] << 16) | (input[9] << 8) | input[8];
	    var j15 = (input[15] << 24) | (input[14] << 16) | (input[13] << 8) | input[12];
	    var x0 = j0;
	    var x1 = j1;
	    var x2 = j2;
	    var x3 = j3;
	    var x4 = j4;
	    var x5 = j5;
	    var x6 = j6;
	    var x7 = j7;
	    var x8 = j8;
	    var x9 = j9;
	    var x10 = j10;
	    var x11 = j11;
	    var x12 = j12;
	    var x13 = j13;
	    var x14 = j14;
	    var x15 = j15;
	    for (var i = 0; i < ROUNDS; i += 2) {
	        x0 = x0 + x4 | 0;
	        x12 ^= x0;
	        x12 = x12 >>> (32 - 16) | x12 << 16;
	        x8 = x8 + x12 | 0;
	        x4 ^= x8;
	        x4 = x4 >>> (32 - 12) | x4 << 12;
	        x1 = x1 + x5 | 0;
	        x13 ^= x1;
	        x13 = x13 >>> (32 - 16) | x13 << 16;
	        x9 = x9 + x13 | 0;
	        x5 ^= x9;
	        x5 = x5 >>> (32 - 12) | x5 << 12;
	        x2 = x2 + x6 | 0;
	        x14 ^= x2;
	        x14 = x14 >>> (32 - 16) | x14 << 16;
	        x10 = x10 + x14 | 0;
	        x6 ^= x10;
	        x6 = x6 >>> (32 - 12) | x6 << 12;
	        x3 = x3 + x7 | 0;
	        x15 ^= x3;
	        x15 = x15 >>> (32 - 16) | x15 << 16;
	        x11 = x11 + x15 | 0;
	        x7 ^= x11;
	        x7 = x7 >>> (32 - 12) | x7 << 12;
	        x2 = x2 + x6 | 0;
	        x14 ^= x2;
	        x14 = x14 >>> (32 - 8) | x14 << 8;
	        x10 = x10 + x14 | 0;
	        x6 ^= x10;
	        x6 = x6 >>> (32 - 7) | x6 << 7;
	        x3 = x3 + x7 | 0;
	        x15 ^= x3;
	        x15 = x15 >>> (32 - 8) | x15 << 8;
	        x11 = x11 + x15 | 0;
	        x7 ^= x11;
	        x7 = x7 >>> (32 - 7) | x7 << 7;
	        x1 = x1 + x5 | 0;
	        x13 ^= x1;
	        x13 = x13 >>> (32 - 8) | x13 << 8;
	        x9 = x9 + x13 | 0;
	        x5 ^= x9;
	        x5 = x5 >>> (32 - 7) | x5 << 7;
	        x0 = x0 + x4 | 0;
	        x12 ^= x0;
	        x12 = x12 >>> (32 - 8) | x12 << 8;
	        x8 = x8 + x12 | 0;
	        x4 ^= x8;
	        x4 = x4 >>> (32 - 7) | x4 << 7;
	        x0 = x0 + x5 | 0;
	        x15 ^= x0;
	        x15 = x15 >>> (32 - 16) | x15 << 16;
	        x10 = x10 + x15 | 0;
	        x5 ^= x10;
	        x5 = x5 >>> (32 - 12) | x5 << 12;
	        x1 = x1 + x6 | 0;
	        x12 ^= x1;
	        x12 = x12 >>> (32 - 16) | x12 << 16;
	        x11 = x11 + x12 | 0;
	        x6 ^= x11;
	        x6 = x6 >>> (32 - 12) | x6 << 12;
	        x2 = x2 + x7 | 0;
	        x13 ^= x2;
	        x13 = x13 >>> (32 - 16) | x13 << 16;
	        x8 = x8 + x13 | 0;
	        x7 ^= x8;
	        x7 = x7 >>> (32 - 12) | x7 << 12;
	        x3 = x3 + x4 | 0;
	        x14 ^= x3;
	        x14 = x14 >>> (32 - 16) | x14 << 16;
	        x9 = x9 + x14 | 0;
	        x4 ^= x9;
	        x4 = x4 >>> (32 - 12) | x4 << 12;
	        x2 = x2 + x7 | 0;
	        x13 ^= x2;
	        x13 = x13 >>> (32 - 8) | x13 << 8;
	        x8 = x8 + x13 | 0;
	        x7 ^= x8;
	        x7 = x7 >>> (32 - 7) | x7 << 7;
	        x3 = x3 + x4 | 0;
	        x14 ^= x3;
	        x14 = x14 >>> (32 - 8) | x14 << 8;
	        x9 = x9 + x14 | 0;
	        x4 ^= x9;
	        x4 = x4 >>> (32 - 7) | x4 << 7;
	        x1 = x1 + x6 | 0;
	        x12 ^= x1;
	        x12 = x12 >>> (32 - 8) | x12 << 8;
	        x11 = x11 + x12 | 0;
	        x6 ^= x11;
	        x6 = x6 >>> (32 - 7) | x6 << 7;
	        x0 = x0 + x5 | 0;
	        x15 ^= x0;
	        x15 = x15 >>> (32 - 8) | x15 << 8;
	        x10 = x10 + x15 | 0;
	        x5 ^= x10;
	        x5 = x5 >>> (32 - 7) | x5 << 7;
	    }
	    binary_1.writeUint32LE(x0 + j0 | 0, out, 0);
	    binary_1.writeUint32LE(x1 + j1 | 0, out, 4);
	    binary_1.writeUint32LE(x2 + j2 | 0, out, 8);
	    binary_1.writeUint32LE(x3 + j3 | 0, out, 12);
	    binary_1.writeUint32LE(x4 + j4 | 0, out, 16);
	    binary_1.writeUint32LE(x5 + j5 | 0, out, 20);
	    binary_1.writeUint32LE(x6 + j6 | 0, out, 24);
	    binary_1.writeUint32LE(x7 + j7 | 0, out, 28);
	    binary_1.writeUint32LE(x8 + j8 | 0, out, 32);
	    binary_1.writeUint32LE(x9 + j9 | 0, out, 36);
	    binary_1.writeUint32LE(x10 + j10 | 0, out, 40);
	    binary_1.writeUint32LE(x11 + j11 | 0, out, 44);
	    binary_1.writeUint32LE(x12 + j12 | 0, out, 48);
	    binary_1.writeUint32LE(x13 + j13 | 0, out, 52);
	    binary_1.writeUint32LE(x14 + j14 | 0, out, 56);
	    binary_1.writeUint32LE(x15 + j15 | 0, out, 60);
	}
	/**
	 * Encrypt src with ChaCha20 stream generated for the given 32-byte key and
	 * 8-byte (as in original implementation) or 12-byte (as in RFC7539) nonce and
	 * write the result into dst and return it.
	 *
	 * dst and src may be the same, but otherwise must not overlap.
	 *
	 * If nonce is 12 bytes, users should not encrypt more than 256 GiB with the
	 * same key and nonce, otherwise the stream will repeat. The function will
	 * throw error if counter overflows to prevent this.
	 *
	 * If nonce is 8 bytes, the output is practically unlimited (2^70 bytes, which
	 * is more than a million petabytes). However, it is not recommended to
	 * generate 8-byte nonces randomly, as the chance of collision is high.
	 *
	 * Never use the same key and nonce to encrypt more than one message.
	 *
	 * If nonceInplaceCounterLength is not 0, the nonce is assumed to be a 16-byte
	 * array with stream counter in first nonceInplaceCounterLength bytes and nonce
	 * in the last remaining bytes. The counter will be incremented inplace for
	 * each ChaCha block. This is useful if you need to encrypt one stream of data
	 * in chunks.
	 */
	function streamXOR(key, nonce, src, dst, nonceInplaceCounterLength) {
	    if (nonceInplaceCounterLength === void 0) { nonceInplaceCounterLength = 0; }
	    // We only support 256-bit keys.
	    if (key.length !== 32) {
	        throw new Error("ChaCha: key size must be 32 bytes");
	    }
	    if (dst.length < src.length) {
	        throw new Error("ChaCha: destination is shorter than source");
	    }
	    var nc;
	    var counterLength;
	    if (nonceInplaceCounterLength === 0) {
	        if (nonce.length !== 8 && nonce.length !== 12) {
	            throw new Error("ChaCha nonce must be 8 or 12 bytes");
	        }
	        nc = new Uint8Array(16);
	        // First counterLength bytes of nc are counter, starting with zero.
	        counterLength = nc.length - nonce.length;
	        // Last bytes of nc after counterLength are nonce, set them.
	        nc.set(nonce, counterLength);
	    }
	    else {
	        if (nonce.length !== 16) {
	            throw new Error("ChaCha nonce with counter must be 16 bytes");
	        }
	        // This will update passed nonce with counter inplace.
	        nc = nonce;
	        counterLength = nonceInplaceCounterLength;
	    }
	    // Allocate temporary space for ChaCha block.
	    var block = new Uint8Array(64);
	    for (var i = 0; i < src.length; i += 64) {
	        // Generate a block.
	        core(block, nc, key);
	        // XOR block bytes with src into dst.
	        for (var j = i; j < i + 64 && j < src.length; j++) {
	            dst[j] = src[j] ^ block[j - i];
	        }
	        // Increment counter.
	        incrementCounter(nc, 0, counterLength);
	    }
	    // Cleanup temporary space.
	    wipe_1.wipe(block);
	    if (nonceInplaceCounterLength === 0) {
	        // Cleanup counter.
	        wipe_1.wipe(nc);
	    }
	    return dst;
	}
	chacha.streamXOR = streamXOR;
	/**
	 * Generate ChaCha20 stream for the given 32-byte key and 8-byte or 12-byte
	 * nonce and write it into dst and return it.
	 *
	 * Never use the same key and nonce to generate more than one stream.
	 *
	 * If nonceInplaceCounterLength is not 0, it behaves the same with respect to
	 * the nonce as described in the streamXOR documentation.
	 *
	 * stream is like streamXOR with all-zero src.
	 */
	function stream(key, nonce, dst, nonceInplaceCounterLength) {
	    if (nonceInplaceCounterLength === void 0) { nonceInplaceCounterLength = 0; }
	    wipe_1.wipe(dst);
	    return streamXOR(key, nonce, dst, dst, nonceInplaceCounterLength);
	}
	chacha.stream = stream;
	function incrementCounter(counter, pos, len) {
	    var carry = 1;
	    while (len--) {
	        carry = carry + (counter[pos] & 0xff) | 0;
	        counter[pos] = carry & 0xff;
	        carry >>>= 8;
	        pos++;
	    }
	    if (carry > 0) {
	        throw new Error("ChaCha: counter overflow");
	    }
	}
	
	return chacha;
}

var poly1305 = {};

var constantTime = {};

var hasRequiredConstantTime;

function requireConstantTime () {
	if (hasRequiredConstantTime) return constantTime;
	hasRequiredConstantTime = 1;
	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(constantTime, "__esModule", { value: true });
	/**
	 * Package constant-time provides functions for performing algorithmically constant-time operations.
	 */
	/**
	 * NOTE! Due to the inability to guarantee real constant time evaluation of
	 * anything in JavaScript VM, this is module is the best effort.
	 */
	/**
	 * Returns resultIfOne if subject is 1, or resultIfZero if subject is 0.
	 *
	 * Supports only 32-bit integers, so resultIfOne or resultIfZero are not
	 * integers, they'll be converted to them with bitwise operations.
	 */
	function select(subject, resultIfOne, resultIfZero) {
	    return (~(subject - 1) & resultIfOne) | ((subject - 1) & resultIfZero);
	}
	constantTime.select = select;
	/**
	 * Returns 1 if a <= b, or 0 if not.
	 * Arguments must be positive 32-bit integers less than or equal to 2^31 - 1.
	 */
	function lessOrEqual(a, b) {
	    return (((a | 0) - (b | 0) - 1) >>> 31) & 1;
	}
	constantTime.lessOrEqual = lessOrEqual;
	/**
	 * Returns 1 if a and b are of equal length and their contents
	 * are equal, or 0 otherwise.
	 *
	 * Note that unlike in equal(), zero-length inputs are considered
	 * the same, so this function will return 1.
	 */
	function compare(a, b) {
	    if (a.length !== b.length) {
	        return 0;
	    }
	    var result = 0;
	    for (var i = 0; i < a.length; i++) {
	        result |= a[i] ^ b[i];
	    }
	    return (1 & ((result - 1) >>> 8));
	}
	constantTime.compare = compare;
	/**
	 * Returns true if a and b are of equal non-zero length,
	 * and their contents are equal, or false otherwise.
	 *
	 * Note that unlike in compare() zero-length inputs are considered
	 * _not_ equal, so this function will return false.
	 */
	function equal(a, b) {
	    if (a.length === 0 || b.length === 0) {
	        return false;
	    }
	    return compare(a, b) !== 0;
	}
	constantTime.equal = equal;
	
	return constantTime;
}

var hasRequiredPoly1305;

function requirePoly1305 () {
	if (hasRequiredPoly1305) return poly1305;
	hasRequiredPoly1305 = 1;
	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		/**
		 * Package poly1305 implements Poly1305 one-time message authentication algorithm.
		 */
		var constant_time_1 = requireConstantTime();
		var wipe_1 = requireWipe();
		exports.DIGEST_LENGTH = 16;
		// Port of Andrew Moon's Poly1305-donna-16. Public domain.
		// https://github.com/floodyberry/poly1305-donna
		/**
		 * Poly1305 computes 16-byte authenticator of message using
		 * a one-time 32-byte key.
		 *
		 * Important: key should be used for only one message,
		 * it should never repeat.
		 */
		var Poly1305 = /** @class */ (function () {
		    function Poly1305(key) {
		        this.digestLength = exports.DIGEST_LENGTH;
		        this._buffer = new Uint8Array(16);
		        this._r = new Uint16Array(10);
		        this._h = new Uint16Array(10);
		        this._pad = new Uint16Array(8);
		        this._leftover = 0;
		        this._fin = 0;
		        this._finished = false;
		        var t0 = key[0] | key[1] << 8;
		        this._r[0] = (t0) & 0x1fff;
		        var t1 = key[2] | key[3] << 8;
		        this._r[1] = ((t0 >>> 13) | (t1 << 3)) & 0x1fff;
		        var t2 = key[4] | key[5] << 8;
		        this._r[2] = ((t1 >>> 10) | (t2 << 6)) & 0x1f03;
		        var t3 = key[6] | key[7] << 8;
		        this._r[3] = ((t2 >>> 7) | (t3 << 9)) & 0x1fff;
		        var t4 = key[8] | key[9] << 8;
		        this._r[4] = ((t3 >>> 4) | (t4 << 12)) & 0x00ff;
		        this._r[5] = ((t4 >>> 1)) & 0x1ffe;
		        var t5 = key[10] | key[11] << 8;
		        this._r[6] = ((t4 >>> 14) | (t5 << 2)) & 0x1fff;
		        var t6 = key[12] | key[13] << 8;
		        this._r[7] = ((t5 >>> 11) | (t6 << 5)) & 0x1f81;
		        var t7 = key[14] | key[15] << 8;
		        this._r[8] = ((t6 >>> 8) | (t7 << 8)) & 0x1fff;
		        this._r[9] = ((t7 >>> 5)) & 0x007f;
		        this._pad[0] = key[16] | key[17] << 8;
		        this._pad[1] = key[18] | key[19] << 8;
		        this._pad[2] = key[20] | key[21] << 8;
		        this._pad[3] = key[22] | key[23] << 8;
		        this._pad[4] = key[24] | key[25] << 8;
		        this._pad[5] = key[26] | key[27] << 8;
		        this._pad[6] = key[28] | key[29] << 8;
		        this._pad[7] = key[30] | key[31] << 8;
		    }
		    Poly1305.prototype._blocks = function (m, mpos, bytes) {
		        var hibit = this._fin ? 0 : 1 << 11;
		        var h0 = this._h[0], h1 = this._h[1], h2 = this._h[2], h3 = this._h[3], h4 = this._h[4], h5 = this._h[5], h6 = this._h[6], h7 = this._h[7], h8 = this._h[8], h9 = this._h[9];
		        var r0 = this._r[0], r1 = this._r[1], r2 = this._r[2], r3 = this._r[3], r4 = this._r[4], r5 = this._r[5], r6 = this._r[6], r7 = this._r[7], r8 = this._r[8], r9 = this._r[9];
		        while (bytes >= 16) {
		            var t0 = m[mpos + 0] | m[mpos + 1] << 8;
		            h0 += (t0) & 0x1fff;
		            var t1 = m[mpos + 2] | m[mpos + 3] << 8;
		            h1 += ((t0 >>> 13) | (t1 << 3)) & 0x1fff;
		            var t2 = m[mpos + 4] | m[mpos + 5] << 8;
		            h2 += ((t1 >>> 10) | (t2 << 6)) & 0x1fff;
		            var t3 = m[mpos + 6] | m[mpos + 7] << 8;
		            h3 += ((t2 >>> 7) | (t3 << 9)) & 0x1fff;
		            var t4 = m[mpos + 8] | m[mpos + 9] << 8;
		            h4 += ((t3 >>> 4) | (t4 << 12)) & 0x1fff;
		            h5 += ((t4 >>> 1)) & 0x1fff;
		            var t5 = m[mpos + 10] | m[mpos + 11] << 8;
		            h6 += ((t4 >>> 14) | (t5 << 2)) & 0x1fff;
		            var t6 = m[mpos + 12] | m[mpos + 13] << 8;
		            h7 += ((t5 >>> 11) | (t6 << 5)) & 0x1fff;
		            var t7 = m[mpos + 14] | m[mpos + 15] << 8;
		            h8 += ((t6 >>> 8) | (t7 << 8)) & 0x1fff;
		            h9 += ((t7 >>> 5)) | hibit;
		            var c = 0;
		            var d0 = c;
		            d0 += h0 * r0;
		            d0 += h1 * (5 * r9);
		            d0 += h2 * (5 * r8);
		            d0 += h3 * (5 * r7);
		            d0 += h4 * (5 * r6);
		            c = (d0 >>> 13);
		            d0 &= 0x1fff;
		            d0 += h5 * (5 * r5);
		            d0 += h6 * (5 * r4);
		            d0 += h7 * (5 * r3);
		            d0 += h8 * (5 * r2);
		            d0 += h9 * (5 * r1);
		            c += (d0 >>> 13);
		            d0 &= 0x1fff;
		            var d1 = c;
		            d1 += h0 * r1;
		            d1 += h1 * r0;
		            d1 += h2 * (5 * r9);
		            d1 += h3 * (5 * r8);
		            d1 += h4 * (5 * r7);
		            c = (d1 >>> 13);
		            d1 &= 0x1fff;
		            d1 += h5 * (5 * r6);
		            d1 += h6 * (5 * r5);
		            d1 += h7 * (5 * r4);
		            d1 += h8 * (5 * r3);
		            d1 += h9 * (5 * r2);
		            c += (d1 >>> 13);
		            d1 &= 0x1fff;
		            var d2 = c;
		            d2 += h0 * r2;
		            d2 += h1 * r1;
		            d2 += h2 * r0;
		            d2 += h3 * (5 * r9);
		            d2 += h4 * (5 * r8);
		            c = (d2 >>> 13);
		            d2 &= 0x1fff;
		            d2 += h5 * (5 * r7);
		            d2 += h6 * (5 * r6);
		            d2 += h7 * (5 * r5);
		            d2 += h8 * (5 * r4);
		            d2 += h9 * (5 * r3);
		            c += (d2 >>> 13);
		            d2 &= 0x1fff;
		            var d3 = c;
		            d3 += h0 * r3;
		            d3 += h1 * r2;
		            d3 += h2 * r1;
		            d3 += h3 * r0;
		            d3 += h4 * (5 * r9);
		            c = (d3 >>> 13);
		            d3 &= 0x1fff;
		            d3 += h5 * (5 * r8);
		            d3 += h6 * (5 * r7);
		            d3 += h7 * (5 * r6);
		            d3 += h8 * (5 * r5);
		            d3 += h9 * (5 * r4);
		            c += (d3 >>> 13);
		            d3 &= 0x1fff;
		            var d4 = c;
		            d4 += h0 * r4;
		            d4 += h1 * r3;
		            d4 += h2 * r2;
		            d4 += h3 * r1;
		            d4 += h4 * r0;
		            c = (d4 >>> 13);
		            d4 &= 0x1fff;
		            d4 += h5 * (5 * r9);
		            d4 += h6 * (5 * r8);
		            d4 += h7 * (5 * r7);
		            d4 += h8 * (5 * r6);
		            d4 += h9 * (5 * r5);
		            c += (d4 >>> 13);
		            d4 &= 0x1fff;
		            var d5 = c;
		            d5 += h0 * r5;
		            d5 += h1 * r4;
		            d5 += h2 * r3;
		            d5 += h3 * r2;
		            d5 += h4 * r1;
		            c = (d5 >>> 13);
		            d5 &= 0x1fff;
		            d5 += h5 * r0;
		            d5 += h6 * (5 * r9);
		            d5 += h7 * (5 * r8);
		            d5 += h8 * (5 * r7);
		            d5 += h9 * (5 * r6);
		            c += (d5 >>> 13);
		            d5 &= 0x1fff;
		            var d6 = c;
		            d6 += h0 * r6;
		            d6 += h1 * r5;
		            d6 += h2 * r4;
		            d6 += h3 * r3;
		            d6 += h4 * r2;
		            c = (d6 >>> 13);
		            d6 &= 0x1fff;
		            d6 += h5 * r1;
		            d6 += h6 * r0;
		            d6 += h7 * (5 * r9);
		            d6 += h8 * (5 * r8);
		            d6 += h9 * (5 * r7);
		            c += (d6 >>> 13);
		            d6 &= 0x1fff;
		            var d7 = c;
		            d7 += h0 * r7;
		            d7 += h1 * r6;
		            d7 += h2 * r5;
		            d7 += h3 * r4;
		            d7 += h4 * r3;
		            c = (d7 >>> 13);
		            d7 &= 0x1fff;
		            d7 += h5 * r2;
		            d7 += h6 * r1;
		            d7 += h7 * r0;
		            d7 += h8 * (5 * r9);
		            d7 += h9 * (5 * r8);
		            c += (d7 >>> 13);
		            d7 &= 0x1fff;
		            var d8 = c;
		            d8 += h0 * r8;
		            d8 += h1 * r7;
		            d8 += h2 * r6;
		            d8 += h3 * r5;
		            d8 += h4 * r4;
		            c = (d8 >>> 13);
		            d8 &= 0x1fff;
		            d8 += h5 * r3;
		            d8 += h6 * r2;
		            d8 += h7 * r1;
		            d8 += h8 * r0;
		            d8 += h9 * (5 * r9);
		            c += (d8 >>> 13);
		            d8 &= 0x1fff;
		            var d9 = c;
		            d9 += h0 * r9;
		            d9 += h1 * r8;
		            d9 += h2 * r7;
		            d9 += h3 * r6;
		            d9 += h4 * r5;
		            c = (d9 >>> 13);
		            d9 &= 0x1fff;
		            d9 += h5 * r4;
		            d9 += h6 * r3;
		            d9 += h7 * r2;
		            d9 += h8 * r1;
		            d9 += h9 * r0;
		            c += (d9 >>> 13);
		            d9 &= 0x1fff;
		            c = (((c << 2) + c)) | 0;
		            c = (c + d0) | 0;
		            d0 = c & 0x1fff;
		            c = (c >>> 13);
		            d1 += c;
		            h0 = d0;
		            h1 = d1;
		            h2 = d2;
		            h3 = d3;
		            h4 = d4;
		            h5 = d5;
		            h6 = d6;
		            h7 = d7;
		            h8 = d8;
		            h9 = d9;
		            mpos += 16;
		            bytes -= 16;
		        }
		        this._h[0] = h0;
		        this._h[1] = h1;
		        this._h[2] = h2;
		        this._h[3] = h3;
		        this._h[4] = h4;
		        this._h[5] = h5;
		        this._h[6] = h6;
		        this._h[7] = h7;
		        this._h[8] = h8;
		        this._h[9] = h9;
		    };
		    Poly1305.prototype.finish = function (mac, macpos) {
		        if (macpos === void 0) { macpos = 0; }
		        var g = new Uint16Array(10);
		        var c;
		        var mask;
		        var f;
		        var i;
		        if (this._leftover) {
		            i = this._leftover;
		            this._buffer[i++] = 1;
		            for (; i < 16; i++) {
		                this._buffer[i] = 0;
		            }
		            this._fin = 1;
		            this._blocks(this._buffer, 0, 16);
		        }
		        c = this._h[1] >>> 13;
		        this._h[1] &= 0x1fff;
		        for (i = 2; i < 10; i++) {
		            this._h[i] += c;
		            c = this._h[i] >>> 13;
		            this._h[i] &= 0x1fff;
		        }
		        this._h[0] += (c * 5);
		        c = this._h[0] >>> 13;
		        this._h[0] &= 0x1fff;
		        this._h[1] += c;
		        c = this._h[1] >>> 13;
		        this._h[1] &= 0x1fff;
		        this._h[2] += c;
		        g[0] = this._h[0] + 5;
		        c = g[0] >>> 13;
		        g[0] &= 0x1fff;
		        for (i = 1; i < 10; i++) {
		            g[i] = this._h[i] + c;
		            c = g[i] >>> 13;
		            g[i] &= 0x1fff;
		        }
		        g[9] -= (1 << 13);
		        mask = (c ^ 1) - 1;
		        for (i = 0; i < 10; i++) {
		            g[i] &= mask;
		        }
		        mask = ~mask;
		        for (i = 0; i < 10; i++) {
		            this._h[i] = (this._h[i] & mask) | g[i];
		        }
		        this._h[0] = ((this._h[0]) | (this._h[1] << 13)) & 0xffff;
		        this._h[1] = ((this._h[1] >>> 3) | (this._h[2] << 10)) & 0xffff;
		        this._h[2] = ((this._h[2] >>> 6) | (this._h[3] << 7)) & 0xffff;
		        this._h[3] = ((this._h[3] >>> 9) | (this._h[4] << 4)) & 0xffff;
		        this._h[4] = ((this._h[4] >>> 12) | (this._h[5] << 1) | (this._h[6] << 14)) & 0xffff;
		        this._h[5] = ((this._h[6] >>> 2) | (this._h[7] << 11)) & 0xffff;
		        this._h[6] = ((this._h[7] >>> 5) | (this._h[8] << 8)) & 0xffff;
		        this._h[7] = ((this._h[8] >>> 8) | (this._h[9] << 5)) & 0xffff;
		        f = this._h[0] + this._pad[0];
		        this._h[0] = f & 0xffff;
		        for (i = 1; i < 8; i++) {
		            f = (((this._h[i] + this._pad[i]) | 0) + (f >>> 16)) | 0;
		            this._h[i] = f & 0xffff;
		        }
		        mac[macpos + 0] = this._h[0] >>> 0;
		        mac[macpos + 1] = this._h[0] >>> 8;
		        mac[macpos + 2] = this._h[1] >>> 0;
		        mac[macpos + 3] = this._h[1] >>> 8;
		        mac[macpos + 4] = this._h[2] >>> 0;
		        mac[macpos + 5] = this._h[2] >>> 8;
		        mac[macpos + 6] = this._h[3] >>> 0;
		        mac[macpos + 7] = this._h[3] >>> 8;
		        mac[macpos + 8] = this._h[4] >>> 0;
		        mac[macpos + 9] = this._h[4] >>> 8;
		        mac[macpos + 10] = this._h[5] >>> 0;
		        mac[macpos + 11] = this._h[5] >>> 8;
		        mac[macpos + 12] = this._h[6] >>> 0;
		        mac[macpos + 13] = this._h[6] >>> 8;
		        mac[macpos + 14] = this._h[7] >>> 0;
		        mac[macpos + 15] = this._h[7] >>> 8;
		        this._finished = true;
		        return this;
		    };
		    Poly1305.prototype.update = function (m) {
		        var mpos = 0;
		        var bytes = m.length;
		        var want;
		        if (this._leftover) {
		            want = (16 - this._leftover);
		            if (want > bytes) {
		                want = bytes;
		            }
		            for (var i = 0; i < want; i++) {
		                this._buffer[this._leftover + i] = m[mpos + i];
		            }
		            bytes -= want;
		            mpos += want;
		            this._leftover += want;
		            if (this._leftover < 16) {
		                return this;
		            }
		            this._blocks(this._buffer, 0, 16);
		            this._leftover = 0;
		        }
		        if (bytes >= 16) {
		            want = bytes - (bytes % 16);
		            this._blocks(m, mpos, want);
		            mpos += want;
		            bytes -= want;
		        }
		        if (bytes) {
		            for (var i = 0; i < bytes; i++) {
		                this._buffer[this._leftover + i] = m[mpos + i];
		            }
		            this._leftover += bytes;
		        }
		        return this;
		    };
		    Poly1305.prototype.digest = function () {
		        // TODO(dchest): it behaves differently than other hashes/HMAC,
		        // because it throws when finished — others just return saved result.
		        if (this._finished) {
		            throw new Error("Poly1305 was finished");
		        }
		        var mac = new Uint8Array(16);
		        this.finish(mac);
		        return mac;
		    };
		    Poly1305.prototype.clean = function () {
		        wipe_1.wipe(this._buffer);
		        wipe_1.wipe(this._r);
		        wipe_1.wipe(this._h);
		        wipe_1.wipe(this._pad);
		        this._leftover = 0;
		        this._fin = 0;
		        this._finished = true; // mark as finished even if not
		        return this;
		    };
		    return Poly1305;
		}());
		exports.Poly1305 = Poly1305;
		/**
		 * Returns 16-byte authenticator of data using a one-time 32-byte key.
		 *
		 * Important: key should be used for only one message, it should never repeat.
		 */
		function oneTimeAuth(key, data) {
		    var h = new Poly1305(key);
		    h.update(data);
		    var digest = h.digest();
		    h.clean();
		    return digest;
		}
		exports.oneTimeAuth = oneTimeAuth;
		/**
		 * Returns true if two authenticators are 16-byte long and equal.
		 * Uses contant-time comparison to avoid leaking timing information.
		 */
		function equal(a, b) {
		    if (a.length !== exports.DIGEST_LENGTH || b.length !== exports.DIGEST_LENGTH) {
		        return false;
		    }
		    return constant_time_1.equal(a, b);
		}
		exports.equal = equal;
		
	} (poly1305));
	return poly1305;
}

var hasRequiredChacha20poly1305;

function requireChacha20poly1305 () {
	if (hasRequiredChacha20poly1305) return chacha20poly1305;
	hasRequiredChacha20poly1305 = 1;
	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		var chacha_1 = requireChacha();
		var poly1305_1 = requirePoly1305();
		var wipe_1 = requireWipe();
		var binary_1 = requireBinary();
		var constant_time_1 = requireConstantTime();
		exports.KEY_LENGTH = 32;
		exports.NONCE_LENGTH = 12;
		exports.TAG_LENGTH = 16;
		var ZEROS = new Uint8Array(16);
		/**
		 * ChaCha20-Poly1305 Authenticated Encryption with Associated Data.
		 *
		 * Defined in RFC7539.
		 */
		var ChaCha20Poly1305 = /** @class */ (function () {
		    /**
		     * Creates a new instance with the given 32-byte key.
		     */
		    function ChaCha20Poly1305(key) {
		        this.nonceLength = exports.NONCE_LENGTH;
		        this.tagLength = exports.TAG_LENGTH;
		        if (key.length !== exports.KEY_LENGTH) {
		            throw new Error("ChaCha20Poly1305 needs 32-byte key");
		        }
		        // Copy key.
		        this._key = new Uint8Array(key);
		    }
		    /**
		     * Encrypts and authenticates plaintext, authenticates associated data,
		     * and returns sealed ciphertext, which includes authentication tag.
		     *
		     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
		     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
		     * and nonce.
		     *
		     * If dst is given (it must be the size of plaintext + the size of tag
		     * length) the result will be put into it. Dst and plaintext must not
		     * overlap.
		     */
		    ChaCha20Poly1305.prototype.seal = function (nonce, plaintext, associatedData, dst) {
		        if (nonce.length > 16) {
		            throw new Error("ChaCha20Poly1305: incorrect nonce length");
		        }
		        // Allocate space for counter, and set nonce as last bytes of it.
		        var counter = new Uint8Array(16);
		        counter.set(nonce, counter.length - nonce.length);
		        // Generate authentication key by taking first 32-bytes of stream.
		        // We pass full counter, which has 12-byte nonce and 4-byte block counter,
		        // and it will get incremented after generating the block, which is
		        // exactly what we need: we only use the first 32 bytes of 64-byte
		        // ChaCha block and discard the next 32 bytes.
		        var authKey = new Uint8Array(32);
		        chacha_1.stream(this._key, counter, authKey, 4);
		        // Allocate space for sealed ciphertext.
		        var resultLength = plaintext.length + this.tagLength;
		        var result;
		        if (dst) {
		            if (dst.length !== resultLength) {
		                throw new Error("ChaCha20Poly1305: incorrect destination length");
		            }
		            result = dst;
		        }
		        else {
		            result = new Uint8Array(resultLength);
		        }
		        // Encrypt plaintext.
		        chacha_1.streamXOR(this._key, counter, plaintext, result, 4);
		        // Authenticate.
		        // XXX: can "simplify" here: pass full result (which is already padded
		        // due to zeroes prepared for tag), and ciphertext length instead of
		        // subarray of result.
		        this._authenticate(result.subarray(result.length - this.tagLength, result.length), authKey, result.subarray(0, result.length - this.tagLength), associatedData);
		        // Cleanup.
		        wipe_1.wipe(counter);
		        return result;
		    };
		    /**
		     * Authenticates sealed ciphertext (which includes authentication tag) and
		     * associated data, decrypts ciphertext and returns decrypted plaintext.
		     *
		     * RFC7539 specifies 12 bytes for nonce. It may be this 12-byte nonce
		     * ("IV"), or full 16-byte counter (called "32-bit fixed-common part")
		     * and nonce.
		     *
		     * If authentication fails, it returns null.
		     *
		     * If dst is given (it must be of ciphertext length minus tag length),
		     * the result will be put into it. Dst and plaintext must not overlap.
		     */
		    ChaCha20Poly1305.prototype.open = function (nonce, sealed, associatedData, dst) {
		        if (nonce.length > 16) {
		            throw new Error("ChaCha20Poly1305: incorrect nonce length");
		        }
		        // Sealed ciphertext should at least contain tag.
		        if (sealed.length < this.tagLength) {
		            // TODO(dchest): should we throw here instead?
		            return null;
		        }
		        // Allocate space for counter, and set nonce as last bytes of it.
		        var counter = new Uint8Array(16);
		        counter.set(nonce, counter.length - nonce.length);
		        // Generate authentication key by taking first 32-bytes of stream.
		        var authKey = new Uint8Array(32);
		        chacha_1.stream(this._key, counter, authKey, 4);
		        // Authenticate.
		        // XXX: can simplify and avoid allocation: since authenticate()
		        // already allocates tag (from Poly1305.digest(), it can return)
		        // it instead of copying to calculatedTag. But then in seal()
		        // we'll need to copy it.
		        var calculatedTag = new Uint8Array(this.tagLength);
		        this._authenticate(calculatedTag, authKey, sealed.subarray(0, sealed.length - this.tagLength), associatedData);
		        // Constant-time compare tags and return null if they differ.
		        if (!constant_time_1.equal(calculatedTag, sealed.subarray(sealed.length - this.tagLength, sealed.length))) {
		            return null;
		        }
		        // Allocate space for decrypted plaintext.
		        var resultLength = sealed.length - this.tagLength;
		        var result;
		        if (dst) {
		            if (dst.length !== resultLength) {
		                throw new Error("ChaCha20Poly1305: incorrect destination length");
		            }
		            result = dst;
		        }
		        else {
		            result = new Uint8Array(resultLength);
		        }
		        // Decrypt.
		        chacha_1.streamXOR(this._key, counter, sealed.subarray(0, sealed.length - this.tagLength), result, 4);
		        // Cleanup.
		        wipe_1.wipe(counter);
		        return result;
		    };
		    ChaCha20Poly1305.prototype.clean = function () {
		        wipe_1.wipe(this._key);
		        return this;
		    };
		    ChaCha20Poly1305.prototype._authenticate = function (tagOut, authKey, ciphertext, associatedData) {
		        // Initialize Poly1305 with authKey.
		        var h = new poly1305_1.Poly1305(authKey);
		        // Authenticate padded associated data.
		        if (associatedData) {
		            h.update(associatedData);
		            if (associatedData.length % 16 > 0) {
		                h.update(ZEROS.subarray(associatedData.length % 16));
		            }
		        }
		        // Authenticate padded ciphertext.
		        h.update(ciphertext);
		        if (ciphertext.length % 16 > 0) {
		            h.update(ZEROS.subarray(ciphertext.length % 16));
		        }
		        // Authenticate length of associated data.
		        // XXX: can avoid allocation here?
		        var length = new Uint8Array(8);
		        if (associatedData) {
		            binary_1.writeUint64LE(associatedData.length, length);
		        }
		        h.update(length);
		        // Authenticate length of ciphertext.
		        binary_1.writeUint64LE(ciphertext.length, length);
		        h.update(length);
		        // Get tag and copy it into tagOut.
		        var tag = h.digest();
		        for (var i = 0; i < tag.length; i++) {
		            tagOut[i] = tag[i];
		        }
		        // Cleanup.
		        h.clean();
		        wipe_1.wipe(tag);
		        wipe_1.wipe(length);
		    };
		    return ChaCha20Poly1305;
		}());
		exports.ChaCha20Poly1305 = ChaCha20Poly1305;
		
	} (chacha20poly1305));
	return chacha20poly1305;
}

var chacha20poly1305Exports = requireChacha20poly1305();

var hkdf = {};

var hmac = {};

var hash = {};

var hasRequiredHash;

function requireHash () {
	if (hasRequiredHash) return hash;
	hasRequiredHash = 1;
	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(hash, "__esModule", { value: true });
	function isSerializableHash(h) {
	    return (typeof h.saveState !== "undefined" &&
	        typeof h.restoreState !== "undefined" &&
	        typeof h.cleanSavedState !== "undefined");
	}
	hash.isSerializableHash = isSerializableHash;
	// TODO(dchest): figure out the standardized interface for XOF such as
	// SHAKE and BLAKE2X.
	
	return hash;
}

var hasRequiredHmac;

function requireHmac () {
	if (hasRequiredHmac) return hmac;
	hasRequiredHmac = 1;
	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(hmac, "__esModule", { value: true });
	/**
	 * Package hmac implements HMAC algorithm.
	 */
	var hash_1 = requireHash();
	var constant_time_1 = requireConstantTime();
	var wipe_1 = requireWipe();
	/**
	 *  HMAC implements hash-based message authentication algorithm.
	 */
	var HMAC = /** @class */ (function () {
	    /**
	     * Constructs a new HMAC with the given Hash and secret key.
	     */
	    function HMAC(hash, key) {
	        this._finished = false; // true if HMAC was finalized
	        // Initialize inner and outer hashes.
	        this._inner = new hash();
	        this._outer = new hash();
	        // Set block and digest sizes for this HMAC
	        // instance to values from the hash.
	        this.blockSize = this._outer.blockSize;
	        this.digestLength = this._outer.digestLength;
	        // Pad temporary stores a key (or its hash) padded with zeroes.
	        var pad = new Uint8Array(this.blockSize);
	        if (key.length > this.blockSize) {
	            // If key is bigger than hash block size, it must be
	            // hashed and this hash is used as a key instead.
	            this._inner.update(key).finish(pad).clean();
	        }
	        else {
	            // Otherwise, copy the key into pad.
	            pad.set(key);
	        }
	        // Now two different keys are derived from padded key
	        // by xoring a different byte value to each.
	        // To make inner hash key, xor byte 0x36 into pad.
	        for (var i = 0; i < pad.length; i++) {
	            pad[i] ^= 0x36;
	        }
	        // Update inner hash with the result.
	        this._inner.update(pad);
	        // To make outer hash key, xor byte 0x5c into pad.
	        // But since we already xored 0x36 there, we must
	        // first undo this by xoring it again.
	        for (var i = 0; i < pad.length; i++) {
	            pad[i] ^= 0x36 ^ 0x5c;
	        }
	        // Update outer hash with the result.
	        this._outer.update(pad);
	        // Save states of both hashes, so that we can quickly restore
	        // them later in reset() without the need to remember the actual
	        // key and perform this initialization again.
	        if (hash_1.isSerializableHash(this._inner) && hash_1.isSerializableHash(this._outer)) {
	            this._innerKeyedState = this._inner.saveState();
	            this._outerKeyedState = this._outer.saveState();
	        }
	        // Clean pad.
	        wipe_1.wipe(pad);
	    }
	    /**
	     * Returns HMAC state to the state initialized with key
	     * to make it possible to run HMAC over the other data with the same
	     * key without creating a new instance.
	     */
	    HMAC.prototype.reset = function () {
	        if (!hash_1.isSerializableHash(this._inner) || !hash_1.isSerializableHash(this._outer)) {
	            throw new Error("hmac: can't reset() because hash doesn't implement restoreState()");
	        }
	        // Restore keyed states of inner and outer hashes.
	        this._inner.restoreState(this._innerKeyedState);
	        this._outer.restoreState(this._outerKeyedState);
	        this._finished = false;
	        return this;
	    };
	    /**
	     * Cleans HMAC state.
	     */
	    HMAC.prototype.clean = function () {
	        if (hash_1.isSerializableHash(this._inner)) {
	            this._inner.cleanSavedState(this._innerKeyedState);
	        }
	        if (hash_1.isSerializableHash(this._outer)) {
	            this._outer.cleanSavedState(this._outerKeyedState);
	        }
	        this._inner.clean();
	        this._outer.clean();
	    };
	    /**
	     * Updates state with provided data.
	     */
	    HMAC.prototype.update = function (data) {
	        this._inner.update(data);
	        return this;
	    };
	    /**
	     * Finalizes HMAC and puts the result in out.
	     */
	    HMAC.prototype.finish = function (out) {
	        if (this._finished) {
	            // If HMAC was finalized, outer hash is also finalized,
	            // so it produces the same digest it produced when it
	            // was finalized.
	            this._outer.finish(out);
	            return this;
	        }
	        // Finalize inner hash and store the result temporarily.
	        this._inner.finish(out);
	        // Update outer hash with digest of inner hash and and finalize it.
	        this._outer.update(out.subarray(0, this.digestLength)).finish(out);
	        this._finished = true;
	        return this;
	    };
	    /**
	     * Returns the computed message authentication code.
	     */
	    HMAC.prototype.digest = function () {
	        var out = new Uint8Array(this.digestLength);
	        this.finish(out);
	        return out;
	    };
	    /**
	     * Saves HMAC state.
	     * This function is needed for PBKDF2 optimization.
	     */
	    HMAC.prototype.saveState = function () {
	        if (!hash_1.isSerializableHash(this._inner)) {
	            throw new Error("hmac: can't saveState() because hash doesn't implement it");
	        }
	        return this._inner.saveState();
	    };
	    HMAC.prototype.restoreState = function (savedState) {
	        if (!hash_1.isSerializableHash(this._inner) || !hash_1.isSerializableHash(this._outer)) {
	            throw new Error("hmac: can't restoreState() because hash doesn't implement it");
	        }
	        this._inner.restoreState(savedState);
	        this._outer.restoreState(this._outerKeyedState);
	        this._finished = false;
	        return this;
	    };
	    HMAC.prototype.cleanSavedState = function (savedState) {
	        if (!hash_1.isSerializableHash(this._inner)) {
	            throw new Error("hmac: can't cleanSavedState() because hash doesn't implement it");
	        }
	        this._inner.cleanSavedState(savedState);
	    };
	    return HMAC;
	}());
	hmac.HMAC = HMAC;
	/**
	 * Returns HMAC using the given hash constructor for the key over data.
	 */
	function hmac$1(hash, key, data) {
	    var h = new HMAC(hash, key);
	    h.update(data);
	    var digest = h.digest();
	    h.clean();
	    return digest;
	}
	hmac.hmac = hmac$1;
	/**
	 * Returns true if two HMAC digests are equal.
	 * Uses constant-time comparison to avoid leaking timing information.
	 *
	 * Example:
	 *
	 *    const receivedDigest = ...
	 *    const realDigest = hmac(SHA256, key, data);
	 *    if (!equal(receivedDigest, realDigest)) {
	 *        throw new Error("Authentication error");
	 *    }
	 */
	hmac.equal = constant_time_1.equal;
	
	return hmac;
}

var hasRequiredHkdf;

function requireHkdf () {
	if (hasRequiredHkdf) return hkdf;
	hasRequiredHkdf = 1;
	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(hkdf, "__esModule", { value: true });
	var hmac_1 = requireHmac();
	var wipe_1 = requireWipe();
	/**
	 * HMAC-based Extract-and-Expand Key Derivation Function.
	 *
	 * Implements HKDF from RFC5869.
	 *
	 * Expands the given master key with salt and info into
	 * a limited stream of key material.
	 */
	var HKDF = /** @class */ (function () {
	    /**
	     * Create a new HKDF instance for the given hash function
	     * with the master key, optional salt, and info.
	     *
	     * - Master key is a high-entropy secret key (not a password).
	     * - Salt is a non-secret random value.
	     * - Info is application- and/or context-specific information.
	     */
	    function HKDF(hash, key, salt, info) {
	        if (salt === void 0) { salt = new Uint8Array(0); }
	        this._counter = new Uint8Array(1); // starts with zero
	        this._hash = hash;
	        this._info = info;
	        // HKDF-Extract uses salt as HMAC key, and key as data.
	        var okm = hmac_1.hmac(this._hash, salt, key);
	        // Initialize HMAC for expanding with extracted key.
	        this._hmac = new hmac_1.HMAC(hash, okm);
	        // Allocate buffer.
	        this._buffer = new Uint8Array(this._hmac.digestLength);
	        this._bufpos = this._buffer.length;
	    }
	    // Fill buffer with new block of HKDF-Extract output.
	    HKDF.prototype._fillBuffer = function () {
	        // Increment counter.
	        this._counter[0]++;
	        var ctr = this._counter[0];
	        // Check if counter overflowed.
	        if (ctr === 0) {
	            throw new Error("hkdf: cannot expand more");
	        }
	        // Prepare HMAC instance for new data with old key.
	        this._hmac.reset();
	        // Hash in previous output if it was generated
	        // (i.e. counter is greater than 1).
	        if (ctr > 1) {
	            this._hmac.update(this._buffer);
	        }
	        // Hash in info if it exists.
	        if (this._info) {
	            this._hmac.update(this._info);
	        }
	        // Hash in the counter.
	        this._hmac.update(this._counter);
	        // Output result to buffer and clean HMAC instance.
	        this._hmac.finish(this._buffer);
	        // Reset buffer position.
	        this._bufpos = 0;
	    };
	    /**
	     * Expand returns next key material of the given length.
	     *
	     * It throws if expansion limit is reached (which is
	     * 254 digests of the underlying HMAC function).
	     */
	    HKDF.prototype.expand = function (length) {
	        var out = new Uint8Array(length);
	        for (var i = 0; i < out.length; i++) {
	            if (this._bufpos === this._buffer.length) {
	                this._fillBuffer();
	            }
	            out[i] = this._buffer[this._bufpos++];
	        }
	        return out;
	    };
	    HKDF.prototype.clean = function () {
	        this._hmac.clean();
	        wipe_1.wipe(this._buffer);
	        wipe_1.wipe(this._counter);
	        this._bufpos = 0;
	    };
	    return HKDF;
	}());
	hkdf.HKDF = HKDF;
	// TODO(dchest): maybe implement deriveKey?
	
	return hkdf;
}

var hkdfExports = requireHkdf();

var random = {};

var system = {};

var browser$3 = {};

var hasRequiredBrowser$3;

function requireBrowser$3 () {
	if (hasRequiredBrowser$3) return browser$3;
	hasRequiredBrowser$3 = 1;
	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(browser$3, "__esModule", { value: true });
	browser$3.BrowserRandomSource = void 0;
	const QUOTA = 65536;
	class BrowserRandomSource {
	    constructor() {
	        this.isAvailable = false;
	        this.isInstantiated = false;
	        const browserCrypto = typeof self !== 'undefined'
	            ? (self.crypto || self.msCrypto) // IE11 has msCrypto
	            : null;
	        if (browserCrypto && browserCrypto.getRandomValues !== undefined) {
	            this._crypto = browserCrypto;
	            this.isAvailable = true;
	            this.isInstantiated = true;
	        }
	    }
	    randomBytes(length) {
	        if (!this.isAvailable || !this._crypto) {
	            throw new Error("Browser random byte generator is not available.");
	        }
	        const out = new Uint8Array(length);
	        for (let i = 0; i < out.length; i += QUOTA) {
	            this._crypto.getRandomValues(out.subarray(i, i + Math.min(out.length - i, QUOTA)));
	        }
	        return out;
	    }
	}
	browser$3.BrowserRandomSource = BrowserRandomSource;
	
	return browser$3;
}

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var node = {};

var _nodeResolve_empty = {};

var _nodeResolve_empty$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	default: _nodeResolve_empty
});

var require$$1 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);

var hasRequiredNode;

function requireNode () {
	if (hasRequiredNode) return node;
	hasRequiredNode = 1;
	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(node, "__esModule", { value: true });
	node.NodeRandomSource = void 0;
	const wipe_1 = requireWipe();
	class NodeRandomSource {
	    constructor() {
	        this.isAvailable = false;
	        this.isInstantiated = false;
	        if (typeof commonjsRequire !== "undefined") {
	            const nodeCrypto = require$$1;
	            if (nodeCrypto && nodeCrypto.randomBytes) {
	                this._crypto = nodeCrypto;
	                this.isAvailable = true;
	                this.isInstantiated = true;
	            }
	        }
	    }
	    randomBytes(length) {
	        if (!this.isAvailable || !this._crypto) {
	            throw new Error("Node.js random byte generator is not available.");
	        }
	        // Get random bytes (result is Buffer).
	        let buffer = this._crypto.randomBytes(length);
	        // Make sure we got the length that we requested.
	        if (buffer.length !== length) {
	            throw new Error("NodeRandomSource: got fewer bytes than requested");
	        }
	        // Allocate output array.
	        const out = new Uint8Array(length);
	        // Copy bytes from buffer to output.
	        for (let i = 0; i < out.length; i++) {
	            out[i] = buffer[i];
	        }
	        // Cleanup.
	        (0, wipe_1.wipe)(buffer);
	        return out;
	    }
	}
	node.NodeRandomSource = NodeRandomSource;
	
	return node;
}

var hasRequiredSystem;

function requireSystem () {
	if (hasRequiredSystem) return system;
	hasRequiredSystem = 1;
	// Copyright (C) 2016 Dmitry Chestnykh
	// MIT License. See LICENSE file for details.
	Object.defineProperty(system, "__esModule", { value: true });
	system.SystemRandomSource = void 0;
	const browser_1 = requireBrowser$3();
	const node_1 = requireNode();
	class SystemRandomSource {
	    constructor() {
	        this.isAvailable = false;
	        this.name = "";
	        // Try browser.
	        this._source = new browser_1.BrowserRandomSource();
	        if (this._source.isAvailable) {
	            this.isAvailable = true;
	            this.name = "Browser";
	            return;
	        }
	        // If no browser source, try Node.
	        this._source = new node_1.NodeRandomSource();
	        if (this._source.isAvailable) {
	            this.isAvailable = true;
	            this.name = "Node";
	            return;
	        }
	        // No sources, we're out of options.
	    }
	    randomBytes(length) {
	        if (!this.isAvailable) {
	            throw new Error("System random byte generator is not available.");
	        }
	        return this._source.randomBytes(length);
	    }
	}
	system.SystemRandomSource = SystemRandomSource;
	
	return system;
}

var hasRequiredRandom;

function requireRandom () {
	if (hasRequiredRandom) return random;
	hasRequiredRandom = 1;
	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.randomStringForEntropy = exports.randomString = exports.randomUint32 = exports.randomBytes = exports.defaultRandomSource = void 0;
		const system_1 = requireSystem();
		const binary_1 = requireBinary();
		const wipe_1 = requireWipe();
		exports.defaultRandomSource = new system_1.SystemRandomSource();
		function randomBytes(length, prng = exports.defaultRandomSource) {
		    return prng.randomBytes(length);
		}
		exports.randomBytes = randomBytes;
		/**
		 * Returns a uniformly random unsigned 32-bit integer.
		 */
		function randomUint32(prng = exports.defaultRandomSource) {
		    // Generate 4-byte random buffer.
		    const buf = randomBytes(4, prng);
		    // Convert bytes from buffer into a 32-bit integer.
		    // It's not important which byte order to use, since
		    // the result is random.
		    const result = (0, binary_1.readUint32LE)(buf);
		    // Clean the buffer.
		    (0, wipe_1.wipe)(buf);
		    return result;
		}
		exports.randomUint32 = randomUint32;
		/** 62 alphanumeric characters for default charset of randomString() */
		const ALPHANUMERIC = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
		/**
		 * Returns a uniform random string of the given length
		 * with characters from the given charset.
		 *
		 * Charset must not have more than 256 characters.
		 *
		 * Default charset generates case-sensitive alphanumeric
		 * strings (0-9, A-Z, a-z).
		 */
		function randomString(length, charset = ALPHANUMERIC, prng = exports.defaultRandomSource) {
		    if (charset.length < 2) {
		        throw new Error("randomString charset is too short");
		    }
		    if (charset.length > 256) {
		        throw new Error("randomString charset is too long");
		    }
		    let out = '';
		    const charsLen = charset.length;
		    const maxByte = 256 - (256 % charsLen);
		    while (length > 0) {
		        const buf = randomBytes(Math.ceil(length * 256 / maxByte), prng);
		        for (let i = 0; i < buf.length && length > 0; i++) {
		            const randomByte = buf[i];
		            if (randomByte < maxByte) {
		                out += charset.charAt(randomByte % charsLen);
		                length--;
		            }
		        }
		        (0, wipe_1.wipe)(buf);
		    }
		    return out;
		}
		exports.randomString = randomString;
		/**
		 * Returns uniform random string containing at least the given
		 * number of bits of entropy.
		 *
		 * For example, randomStringForEntropy(128) will return a 22-character
		 * alphanumeric string, while randomStringForEntropy(128, "0123456789")
		 * will return a 39-character numeric string, both will contain at
		 * least 128 bits of entropy.
		 *
		 * Default charset generates case-sensitive alphanumeric
		 * strings (0-9, A-Z, a-z).
		 */
		function randomStringForEntropy(bits, charset = ALPHANUMERIC, prng = exports.defaultRandomSource) {
		    const length = Math.ceil(bits / (Math.log(charset.length) / Math.LN2));
		    return randomString(length, charset, prng);
		}
		exports.randomStringForEntropy = randomStringForEntropy;
		
	} (random));
	return random;
}

var randomExports = requireRandom();

var sha256 = {};

var hasRequiredSha256;

function requireSha256 () {
	if (hasRequiredSha256) return sha256;
	hasRequiredSha256 = 1;
	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		var binary_1 = requireBinary();
		var wipe_1 = requireWipe();
		exports.DIGEST_LENGTH = 32;
		exports.BLOCK_SIZE = 64;
		/**
		 * SHA2-256 cryptographic hash algorithm.
		 */
		var SHA256 = /** @class */ (function () {
		    function SHA256() {
		        /** Length of hash output */
		        this.digestLength = exports.DIGEST_LENGTH;
		        /** Block size */
		        this.blockSize = exports.BLOCK_SIZE;
		        // Note: Int32Array is used instead of Uint32Array for performance reasons.
		        this._state = new Int32Array(8); // hash state
		        this._temp = new Int32Array(64); // temporary state
		        this._buffer = new Uint8Array(128); // buffer for data to hash
		        this._bufferLength = 0; // number of bytes in buffer
		        this._bytesHashed = 0; // number of total bytes hashed
		        this._finished = false; // indicates whether the hash was finalized
		        this.reset();
		    }
		    SHA256.prototype._initState = function () {
		        this._state[0] = 0x6a09e667;
		        this._state[1] = 0xbb67ae85;
		        this._state[2] = 0x3c6ef372;
		        this._state[3] = 0xa54ff53a;
		        this._state[4] = 0x510e527f;
		        this._state[5] = 0x9b05688c;
		        this._state[6] = 0x1f83d9ab;
		        this._state[7] = 0x5be0cd19;
		    };
		    /**
		     * Resets hash state making it possible
		     * to re-use this instance to hash other data.
		     */
		    SHA256.prototype.reset = function () {
		        this._initState();
		        this._bufferLength = 0;
		        this._bytesHashed = 0;
		        this._finished = false;
		        return this;
		    };
		    /**
		     * Cleans internal buffers and resets hash state.
		     */
		    SHA256.prototype.clean = function () {
		        wipe_1.wipe(this._buffer);
		        wipe_1.wipe(this._temp);
		        this.reset();
		    };
		    /**
		     * Updates hash state with the given data.
		     *
		     * Throws error when trying to update already finalized hash:
		     * instance must be reset to update it again.
		     */
		    SHA256.prototype.update = function (data, dataLength) {
		        if (dataLength === void 0) { dataLength = data.length; }
		        if (this._finished) {
		            throw new Error("SHA256: can't update because hash was finished.");
		        }
		        var dataPos = 0;
		        this._bytesHashed += dataLength;
		        if (this._bufferLength > 0) {
		            while (this._bufferLength < this.blockSize && dataLength > 0) {
		                this._buffer[this._bufferLength++] = data[dataPos++];
		                dataLength--;
		            }
		            if (this._bufferLength === this.blockSize) {
		                hashBlocks(this._temp, this._state, this._buffer, 0, this.blockSize);
		                this._bufferLength = 0;
		            }
		        }
		        if (dataLength >= this.blockSize) {
		            dataPos = hashBlocks(this._temp, this._state, data, dataPos, dataLength);
		            dataLength %= this.blockSize;
		        }
		        while (dataLength > 0) {
		            this._buffer[this._bufferLength++] = data[dataPos++];
		            dataLength--;
		        }
		        return this;
		    };
		    /**
		     * Finalizes hash state and puts hash into out.
		     * If hash was already finalized, puts the same value.
		     */
		    SHA256.prototype.finish = function (out) {
		        if (!this._finished) {
		            var bytesHashed = this._bytesHashed;
		            var left = this._bufferLength;
		            var bitLenHi = (bytesHashed / 0x20000000) | 0;
		            var bitLenLo = bytesHashed << 3;
		            var padLength = (bytesHashed % 64 < 56) ? 64 : 128;
		            this._buffer[left] = 0x80;
		            for (var i = left + 1; i < padLength - 8; i++) {
		                this._buffer[i] = 0;
		            }
		            binary_1.writeUint32BE(bitLenHi, this._buffer, padLength - 8);
		            binary_1.writeUint32BE(bitLenLo, this._buffer, padLength - 4);
		            hashBlocks(this._temp, this._state, this._buffer, 0, padLength);
		            this._finished = true;
		        }
		        for (var i = 0; i < this.digestLength / 4; i++) {
		            binary_1.writeUint32BE(this._state[i], out, i * 4);
		        }
		        return this;
		    };
		    /**
		     * Returns the final hash digest.
		     */
		    SHA256.prototype.digest = function () {
		        var out = new Uint8Array(this.digestLength);
		        this.finish(out);
		        return out;
		    };
		    /**
		     * Function useful for HMAC/PBKDF2 optimization.
		     * Returns hash state to be used with restoreState().
		     * Only chain value is saved, not buffers or other
		     * state variables.
		     */
		    SHA256.prototype.saveState = function () {
		        if (this._finished) {
		            throw new Error("SHA256: cannot save finished state");
		        }
		        return {
		            state: new Int32Array(this._state),
		            buffer: this._bufferLength > 0 ? new Uint8Array(this._buffer) : undefined,
		            bufferLength: this._bufferLength,
		            bytesHashed: this._bytesHashed
		        };
		    };
		    /**
		     * Function useful for HMAC/PBKDF2 optimization.
		     * Restores state saved by saveState() and sets bytesHashed
		     * to the given value.
		     */
		    SHA256.prototype.restoreState = function (savedState) {
		        this._state.set(savedState.state);
		        this._bufferLength = savedState.bufferLength;
		        if (savedState.buffer) {
		            this._buffer.set(savedState.buffer);
		        }
		        this._bytesHashed = savedState.bytesHashed;
		        this._finished = false;
		        return this;
		    };
		    /**
		     * Cleans state returned by saveState().
		     */
		    SHA256.prototype.cleanSavedState = function (savedState) {
		        wipe_1.wipe(savedState.state);
		        if (savedState.buffer) {
		            wipe_1.wipe(savedState.buffer);
		        }
		        savedState.bufferLength = 0;
		        savedState.bytesHashed = 0;
		    };
		    return SHA256;
		}());
		exports.SHA256 = SHA256;
		// Constants
		var K = new Int32Array([
		    0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b,
		    0x59f111f1, 0x923f82a4, 0xab1c5ed5, 0xd807aa98, 0x12835b01,
		    0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7,
		    0xc19bf174, 0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
		    0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da, 0x983e5152,
		    0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147,
		    0x06ca6351, 0x14292967, 0x27b70a85, 0x2e1b2138, 0x4d2c6dfc,
		    0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
		    0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819,
		    0xd6990624, 0xf40e3585, 0x106aa070, 0x19a4c116, 0x1e376c08,
		    0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f,
		    0x682e6ff3, 0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
		    0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
		]);
		function hashBlocks(w, v, p, pos, len) {
		    while (len >= 64) {
		        var a = v[0];
		        var b = v[1];
		        var c = v[2];
		        var d = v[3];
		        var e = v[4];
		        var f = v[5];
		        var g = v[6];
		        var h = v[7];
		        for (var i = 0; i < 16; i++) {
		            var j = pos + i * 4;
		            w[i] = binary_1.readUint32BE(p, j);
		        }
		        for (var i = 16; i < 64; i++) {
		            var u = w[i - 2];
		            var t1 = (u >>> 17 | u << (32 - 17)) ^ (u >>> 19 | u << (32 - 19)) ^ (u >>> 10);
		            u = w[i - 15];
		            var t2 = (u >>> 7 | u << (32 - 7)) ^ (u >>> 18 | u << (32 - 18)) ^ (u >>> 3);
		            w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0);
		        }
		        for (var i = 0; i < 64; i++) {
		            var t1 = (((((e >>> 6 | e << (32 - 6)) ^ (e >>> 11 | e << (32 - 11)) ^
		                (e >>> 25 | e << (32 - 25))) + ((e & f) ^ (~e & g))) | 0) +
		                ((h + ((K[i] + w[i]) | 0)) | 0)) | 0;
		            var t2 = (((a >>> 2 | a << (32 - 2)) ^ (a >>> 13 | a << (32 - 13)) ^
		                (a >>> 22 | a << (32 - 22))) + ((a & b) ^ (a & c) ^ (b & c))) | 0;
		            h = g;
		            g = f;
		            f = e;
		            e = (d + t1) | 0;
		            d = c;
		            c = b;
		            b = a;
		            a = (t1 + t2) | 0;
		        }
		        v[0] += a;
		        v[1] += b;
		        v[2] += c;
		        v[3] += d;
		        v[4] += e;
		        v[5] += f;
		        v[6] += g;
		        v[7] += h;
		        pos += 64;
		        len -= 64;
		    }
		    return pos;
		}
		function hash(data) {
		    var h = new SHA256();
		    h.update(data);
		    var digest = h.digest();
		    h.clean();
		    return digest;
		}
		exports.hash = hash;
		
	} (sha256));
	return sha256;
}

var sha256Exports = requireSha256();

var x25519 = {};

var hasRequiredX25519;

function requireX25519 () {
	if (hasRequiredX25519) return x25519;
	hasRequiredX25519 = 1;
	(function (exports) {
		// Copyright (C) 2016 Dmitry Chestnykh
		// MIT License. See LICENSE file for details.
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.sharedKey = exports.generateKeyPair = exports.generateKeyPairFromSeed = exports.scalarMultBase = exports.scalarMult = exports.SHARED_KEY_LENGTH = exports.SECRET_KEY_LENGTH = exports.PUBLIC_KEY_LENGTH = void 0;
		/**
		 * Package x25519 implements X25519 key agreement.
		 */
		const random_1 = requireRandom();
		const wipe_1 = requireWipe();
		exports.PUBLIC_KEY_LENGTH = 32;
		exports.SECRET_KEY_LENGTH = 32;
		exports.SHARED_KEY_LENGTH = 32;
		// Returns new zero-filled 16-element GF (Float64Array).
		// If passed an array of numbers, prefills the returned
		// array with them.
		//
		// We use Float64Array, because we need 48-bit numbers
		// for this implementation.
		function gf(init) {
		    const r = new Float64Array(16);
		    if (init) {
		        for (let i = 0; i < init.length; i++) {
		            r[i] = init[i];
		        }
		    }
		    return r;
		}
		// Base point.
		const _9 = new Uint8Array(32);
		_9[0] = 9;
		const _121665 = gf([0xdb41, 1]);
		function car25519(o) {
		    let c = 1;
		    for (let i = 0; i < 16; i++) {
		        let v = o[i] + c + 65535;
		        c = Math.floor(v / 65536);
		        o[i] = v - c * 65536;
		    }
		    o[0] += c - 1 + 37 * (c - 1);
		}
		function sel25519(p, q, b) {
		    const c = ~(b - 1);
		    for (let i = 0; i < 16; i++) {
		        const t = c & (p[i] ^ q[i]);
		        p[i] ^= t;
		        q[i] ^= t;
		    }
		}
		function pack25519(o, n) {
		    const m = gf();
		    const t = gf();
		    for (let i = 0; i < 16; i++) {
		        t[i] = n[i];
		    }
		    car25519(t);
		    car25519(t);
		    car25519(t);
		    for (let j = 0; j < 2; j++) {
		        m[0] = t[0] - 0xffed;
		        for (let i = 1; i < 15; i++) {
		            m[i] = t[i] - 0xffff - ((m[i - 1] >> 16) & 1);
		            m[i - 1] &= 0xffff;
		        }
		        m[15] = t[15] - 0x7fff - ((m[14] >> 16) & 1);
		        const b = (m[15] >> 16) & 1;
		        m[14] &= 0xffff;
		        sel25519(t, m, 1 - b);
		    }
		    for (let i = 0; i < 16; i++) {
		        o[2 * i] = t[i] & 0xff;
		        o[2 * i + 1] = t[i] >> 8;
		    }
		}
		function unpack25519(o, n) {
		    for (let i = 0; i < 16; i++) {
		        o[i] = n[2 * i] + (n[2 * i + 1] << 8);
		    }
		    o[15] &= 0x7fff;
		}
		function add(o, a, b) {
		    for (let i = 0; i < 16; i++) {
		        o[i] = a[i] + b[i];
		    }
		}
		function sub(o, a, b) {
		    for (let i = 0; i < 16; i++) {
		        o[i] = a[i] - b[i];
		    }
		}
		function mul(o, a, b) {
		    let v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
		    v = a[0];
		    t0 += v * b0;
		    t1 += v * b1;
		    t2 += v * b2;
		    t3 += v * b3;
		    t4 += v * b4;
		    t5 += v * b5;
		    t6 += v * b6;
		    t7 += v * b7;
		    t8 += v * b8;
		    t9 += v * b9;
		    t10 += v * b10;
		    t11 += v * b11;
		    t12 += v * b12;
		    t13 += v * b13;
		    t14 += v * b14;
		    t15 += v * b15;
		    v = a[1];
		    t1 += v * b0;
		    t2 += v * b1;
		    t3 += v * b2;
		    t4 += v * b3;
		    t5 += v * b4;
		    t6 += v * b5;
		    t7 += v * b6;
		    t8 += v * b7;
		    t9 += v * b8;
		    t10 += v * b9;
		    t11 += v * b10;
		    t12 += v * b11;
		    t13 += v * b12;
		    t14 += v * b13;
		    t15 += v * b14;
		    t16 += v * b15;
		    v = a[2];
		    t2 += v * b0;
		    t3 += v * b1;
		    t4 += v * b2;
		    t5 += v * b3;
		    t6 += v * b4;
		    t7 += v * b5;
		    t8 += v * b6;
		    t9 += v * b7;
		    t10 += v * b8;
		    t11 += v * b9;
		    t12 += v * b10;
		    t13 += v * b11;
		    t14 += v * b12;
		    t15 += v * b13;
		    t16 += v * b14;
		    t17 += v * b15;
		    v = a[3];
		    t3 += v * b0;
		    t4 += v * b1;
		    t5 += v * b2;
		    t6 += v * b3;
		    t7 += v * b4;
		    t8 += v * b5;
		    t9 += v * b6;
		    t10 += v * b7;
		    t11 += v * b8;
		    t12 += v * b9;
		    t13 += v * b10;
		    t14 += v * b11;
		    t15 += v * b12;
		    t16 += v * b13;
		    t17 += v * b14;
		    t18 += v * b15;
		    v = a[4];
		    t4 += v * b0;
		    t5 += v * b1;
		    t6 += v * b2;
		    t7 += v * b3;
		    t8 += v * b4;
		    t9 += v * b5;
		    t10 += v * b6;
		    t11 += v * b7;
		    t12 += v * b8;
		    t13 += v * b9;
		    t14 += v * b10;
		    t15 += v * b11;
		    t16 += v * b12;
		    t17 += v * b13;
		    t18 += v * b14;
		    t19 += v * b15;
		    v = a[5];
		    t5 += v * b0;
		    t6 += v * b1;
		    t7 += v * b2;
		    t8 += v * b3;
		    t9 += v * b4;
		    t10 += v * b5;
		    t11 += v * b6;
		    t12 += v * b7;
		    t13 += v * b8;
		    t14 += v * b9;
		    t15 += v * b10;
		    t16 += v * b11;
		    t17 += v * b12;
		    t18 += v * b13;
		    t19 += v * b14;
		    t20 += v * b15;
		    v = a[6];
		    t6 += v * b0;
		    t7 += v * b1;
		    t8 += v * b2;
		    t9 += v * b3;
		    t10 += v * b4;
		    t11 += v * b5;
		    t12 += v * b6;
		    t13 += v * b7;
		    t14 += v * b8;
		    t15 += v * b9;
		    t16 += v * b10;
		    t17 += v * b11;
		    t18 += v * b12;
		    t19 += v * b13;
		    t20 += v * b14;
		    t21 += v * b15;
		    v = a[7];
		    t7 += v * b0;
		    t8 += v * b1;
		    t9 += v * b2;
		    t10 += v * b3;
		    t11 += v * b4;
		    t12 += v * b5;
		    t13 += v * b6;
		    t14 += v * b7;
		    t15 += v * b8;
		    t16 += v * b9;
		    t17 += v * b10;
		    t18 += v * b11;
		    t19 += v * b12;
		    t20 += v * b13;
		    t21 += v * b14;
		    t22 += v * b15;
		    v = a[8];
		    t8 += v * b0;
		    t9 += v * b1;
		    t10 += v * b2;
		    t11 += v * b3;
		    t12 += v * b4;
		    t13 += v * b5;
		    t14 += v * b6;
		    t15 += v * b7;
		    t16 += v * b8;
		    t17 += v * b9;
		    t18 += v * b10;
		    t19 += v * b11;
		    t20 += v * b12;
		    t21 += v * b13;
		    t22 += v * b14;
		    t23 += v * b15;
		    v = a[9];
		    t9 += v * b0;
		    t10 += v * b1;
		    t11 += v * b2;
		    t12 += v * b3;
		    t13 += v * b4;
		    t14 += v * b5;
		    t15 += v * b6;
		    t16 += v * b7;
		    t17 += v * b8;
		    t18 += v * b9;
		    t19 += v * b10;
		    t20 += v * b11;
		    t21 += v * b12;
		    t22 += v * b13;
		    t23 += v * b14;
		    t24 += v * b15;
		    v = a[10];
		    t10 += v * b0;
		    t11 += v * b1;
		    t12 += v * b2;
		    t13 += v * b3;
		    t14 += v * b4;
		    t15 += v * b5;
		    t16 += v * b6;
		    t17 += v * b7;
		    t18 += v * b8;
		    t19 += v * b9;
		    t20 += v * b10;
		    t21 += v * b11;
		    t22 += v * b12;
		    t23 += v * b13;
		    t24 += v * b14;
		    t25 += v * b15;
		    v = a[11];
		    t11 += v * b0;
		    t12 += v * b1;
		    t13 += v * b2;
		    t14 += v * b3;
		    t15 += v * b4;
		    t16 += v * b5;
		    t17 += v * b6;
		    t18 += v * b7;
		    t19 += v * b8;
		    t20 += v * b9;
		    t21 += v * b10;
		    t22 += v * b11;
		    t23 += v * b12;
		    t24 += v * b13;
		    t25 += v * b14;
		    t26 += v * b15;
		    v = a[12];
		    t12 += v * b0;
		    t13 += v * b1;
		    t14 += v * b2;
		    t15 += v * b3;
		    t16 += v * b4;
		    t17 += v * b5;
		    t18 += v * b6;
		    t19 += v * b7;
		    t20 += v * b8;
		    t21 += v * b9;
		    t22 += v * b10;
		    t23 += v * b11;
		    t24 += v * b12;
		    t25 += v * b13;
		    t26 += v * b14;
		    t27 += v * b15;
		    v = a[13];
		    t13 += v * b0;
		    t14 += v * b1;
		    t15 += v * b2;
		    t16 += v * b3;
		    t17 += v * b4;
		    t18 += v * b5;
		    t19 += v * b6;
		    t20 += v * b7;
		    t21 += v * b8;
		    t22 += v * b9;
		    t23 += v * b10;
		    t24 += v * b11;
		    t25 += v * b12;
		    t26 += v * b13;
		    t27 += v * b14;
		    t28 += v * b15;
		    v = a[14];
		    t14 += v * b0;
		    t15 += v * b1;
		    t16 += v * b2;
		    t17 += v * b3;
		    t18 += v * b4;
		    t19 += v * b5;
		    t20 += v * b6;
		    t21 += v * b7;
		    t22 += v * b8;
		    t23 += v * b9;
		    t24 += v * b10;
		    t25 += v * b11;
		    t26 += v * b12;
		    t27 += v * b13;
		    t28 += v * b14;
		    t29 += v * b15;
		    v = a[15];
		    t15 += v * b0;
		    t16 += v * b1;
		    t17 += v * b2;
		    t18 += v * b3;
		    t19 += v * b4;
		    t20 += v * b5;
		    t21 += v * b6;
		    t22 += v * b7;
		    t23 += v * b8;
		    t24 += v * b9;
		    t25 += v * b10;
		    t26 += v * b11;
		    t27 += v * b12;
		    t28 += v * b13;
		    t29 += v * b14;
		    t30 += v * b15;
		    t0 += 38 * t16;
		    t1 += 38 * t17;
		    t2 += 38 * t18;
		    t3 += 38 * t19;
		    t4 += 38 * t20;
		    t5 += 38 * t21;
		    t6 += 38 * t22;
		    t7 += 38 * t23;
		    t8 += 38 * t24;
		    t9 += 38 * t25;
		    t10 += 38 * t26;
		    t11 += 38 * t27;
		    t12 += 38 * t28;
		    t13 += 38 * t29;
		    t14 += 38 * t30;
		    // t15 left as is
		    // first car
		    c = 1;
		    v = t0 + c + 65535;
		    c = Math.floor(v / 65536);
		    t0 = v - c * 65536;
		    v = t1 + c + 65535;
		    c = Math.floor(v / 65536);
		    t1 = v - c * 65536;
		    v = t2 + c + 65535;
		    c = Math.floor(v / 65536);
		    t2 = v - c * 65536;
		    v = t3 + c + 65535;
		    c = Math.floor(v / 65536);
		    t3 = v - c * 65536;
		    v = t4 + c + 65535;
		    c = Math.floor(v / 65536);
		    t4 = v - c * 65536;
		    v = t5 + c + 65535;
		    c = Math.floor(v / 65536);
		    t5 = v - c * 65536;
		    v = t6 + c + 65535;
		    c = Math.floor(v / 65536);
		    t6 = v - c * 65536;
		    v = t7 + c + 65535;
		    c = Math.floor(v / 65536);
		    t7 = v - c * 65536;
		    v = t8 + c + 65535;
		    c = Math.floor(v / 65536);
		    t8 = v - c * 65536;
		    v = t9 + c + 65535;
		    c = Math.floor(v / 65536);
		    t9 = v - c * 65536;
		    v = t10 + c + 65535;
		    c = Math.floor(v / 65536);
		    t10 = v - c * 65536;
		    v = t11 + c + 65535;
		    c = Math.floor(v / 65536);
		    t11 = v - c * 65536;
		    v = t12 + c + 65535;
		    c = Math.floor(v / 65536);
		    t12 = v - c * 65536;
		    v = t13 + c + 65535;
		    c = Math.floor(v / 65536);
		    t13 = v - c * 65536;
		    v = t14 + c + 65535;
		    c = Math.floor(v / 65536);
		    t14 = v - c * 65536;
		    v = t15 + c + 65535;
		    c = Math.floor(v / 65536);
		    t15 = v - c * 65536;
		    t0 += c - 1 + 37 * (c - 1);
		    // second car
		    c = 1;
		    v = t0 + c + 65535;
		    c = Math.floor(v / 65536);
		    t0 = v - c * 65536;
		    v = t1 + c + 65535;
		    c = Math.floor(v / 65536);
		    t1 = v - c * 65536;
		    v = t2 + c + 65535;
		    c = Math.floor(v / 65536);
		    t2 = v - c * 65536;
		    v = t3 + c + 65535;
		    c = Math.floor(v / 65536);
		    t3 = v - c * 65536;
		    v = t4 + c + 65535;
		    c = Math.floor(v / 65536);
		    t4 = v - c * 65536;
		    v = t5 + c + 65535;
		    c = Math.floor(v / 65536);
		    t5 = v - c * 65536;
		    v = t6 + c + 65535;
		    c = Math.floor(v / 65536);
		    t6 = v - c * 65536;
		    v = t7 + c + 65535;
		    c = Math.floor(v / 65536);
		    t7 = v - c * 65536;
		    v = t8 + c + 65535;
		    c = Math.floor(v / 65536);
		    t8 = v - c * 65536;
		    v = t9 + c + 65535;
		    c = Math.floor(v / 65536);
		    t9 = v - c * 65536;
		    v = t10 + c + 65535;
		    c = Math.floor(v / 65536);
		    t10 = v - c * 65536;
		    v = t11 + c + 65535;
		    c = Math.floor(v / 65536);
		    t11 = v - c * 65536;
		    v = t12 + c + 65535;
		    c = Math.floor(v / 65536);
		    t12 = v - c * 65536;
		    v = t13 + c + 65535;
		    c = Math.floor(v / 65536);
		    t13 = v - c * 65536;
		    v = t14 + c + 65535;
		    c = Math.floor(v / 65536);
		    t14 = v - c * 65536;
		    v = t15 + c + 65535;
		    c = Math.floor(v / 65536);
		    t15 = v - c * 65536;
		    t0 += c - 1 + 37 * (c - 1);
		    o[0] = t0;
		    o[1] = t1;
		    o[2] = t2;
		    o[3] = t3;
		    o[4] = t4;
		    o[5] = t5;
		    o[6] = t6;
		    o[7] = t7;
		    o[8] = t8;
		    o[9] = t9;
		    o[10] = t10;
		    o[11] = t11;
		    o[12] = t12;
		    o[13] = t13;
		    o[14] = t14;
		    o[15] = t15;
		}
		function square(o, a) {
		    mul(o, a, a);
		}
		function inv25519(o, inp) {
		    const c = gf();
		    for (let i = 0; i < 16; i++) {
		        c[i] = inp[i];
		    }
		    for (let i = 253; i >= 0; i--) {
		        square(c, c);
		        if (i !== 2 && i !== 4) {
		            mul(c, c, inp);
		        }
		    }
		    for (let i = 0; i < 16; i++) {
		        o[i] = c[i];
		    }
		}
		function scalarMult(n, p) {
		    const z = new Uint8Array(32);
		    const x = new Float64Array(80);
		    const a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
		    for (let i = 0; i < 31; i++) {
		        z[i] = n[i];
		    }
		    z[31] = (n[31] & 127) | 64;
		    z[0] &= 248;
		    unpack25519(x, p);
		    for (let i = 0; i < 16; i++) {
		        b[i] = x[i];
		    }
		    a[0] = d[0] = 1;
		    for (let i = 254; i >= 0; --i) {
		        const r = (z[i >>> 3] >>> (i & 7)) & 1;
		        sel25519(a, b, r);
		        sel25519(c, d, r);
		        add(e, a, c);
		        sub(a, a, c);
		        add(c, b, d);
		        sub(b, b, d);
		        square(d, e);
		        square(f, a);
		        mul(a, c, a);
		        mul(c, b, e);
		        add(e, a, c);
		        sub(a, a, c);
		        square(b, a);
		        sub(c, d, f);
		        mul(a, c, _121665);
		        add(a, a, d);
		        mul(c, c, a);
		        mul(a, d, f);
		        mul(d, b, x);
		        square(b, e);
		        sel25519(a, b, r);
		        sel25519(c, d, r);
		    }
		    for (let i = 0; i < 16; i++) {
		        x[i + 16] = a[i];
		        x[i + 32] = c[i];
		        x[i + 48] = b[i];
		        x[i + 64] = d[i];
		    }
		    const x32 = x.subarray(32);
		    const x16 = x.subarray(16);
		    inv25519(x32, x32);
		    mul(x16, x16, x32);
		    const q = new Uint8Array(32);
		    pack25519(q, x16);
		    return q;
		}
		exports.scalarMult = scalarMult;
		function scalarMultBase(n) {
		    return scalarMult(n, _9);
		}
		exports.scalarMultBase = scalarMultBase;
		function generateKeyPairFromSeed(seed) {
		    if (seed.length !== exports.SECRET_KEY_LENGTH) {
		        throw new Error(`x25519: seed must be ${exports.SECRET_KEY_LENGTH} bytes`);
		    }
		    const secretKey = new Uint8Array(seed);
		    const publicKey = scalarMultBase(secretKey);
		    return {
		        publicKey,
		        secretKey
		    };
		}
		exports.generateKeyPairFromSeed = generateKeyPairFromSeed;
		function generateKeyPair(prng) {
		    const seed = (0, random_1.randomBytes)(32, prng);
		    const result = generateKeyPairFromSeed(seed);
		    (0, wipe_1.wipe)(seed);
		    return result;
		}
		exports.generateKeyPair = generateKeyPair;
		/**
		 * Returns a shared key between our secret key and a peer's public key.
		 *
		 * Throws an error if the given keys are of wrong length.
		 *
		 * If rejectZero is true throws if the calculated shared key is all-zero.
		 * From RFC 7748:
		 *
		 * > Protocol designers using Diffie-Hellman over the curves defined in
		 * > this document must not assume "contributory behavior".  Specially,
		 * > contributory behavior means that both parties' private keys
		 * > contribute to the resulting shared key.  Since curve25519 and
		 * > curve448 have cofactors of 8 and 4 (respectively), an input point of
		 * > small order will eliminate any contribution from the other party's
		 * > private key.  This situation can be detected by checking for the all-
		 * > zero output, which implementations MAY do, as specified in Section 6.
		 * > However, a large number of existing implementations do not do this.
		 *
		 * IMPORTANT: the returned key is a raw result of scalar multiplication.
		 * To use it as a key material, hash it with a cryptographic hash function.
		 */
		function sharedKey(mySecretKey, theirPublicKey, rejectZero = false) {
		    if (mySecretKey.length !== exports.PUBLIC_KEY_LENGTH) {
		        throw new Error("X25519: incorrect secret key length");
		    }
		    if (theirPublicKey.length !== exports.PUBLIC_KEY_LENGTH) {
		        throw new Error("X25519: incorrect public key length");
		    }
		    const result = scalarMult(mySecretKey, theirPublicKey);
		    if (rejectZero) {
		        let zeros = 0;
		        for (let i = 0; i < result.length; i++) {
		            zeros |= result[i];
		        }
		        if (zeros === 0) {
		            throw new Error("X25519: invalid shared key");
		        }
		    }
		    return result;
		}
		exports.sharedKey = sharedKey;
		
	} (x25519));
	return x25519;
}

var x25519Exports = requireX25519();

function asUint8Array(buf) {
  if (globalThis.Buffer != null) {
    return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
  }
  return buf;
}

function allocUnsafe$1(size = 0) {
  if (globalThis.Buffer != null && globalThis.Buffer.allocUnsafe != null) {
    return asUint8Array(globalThis.Buffer.allocUnsafe(size));
  }
  return new Uint8Array(size);
}

function concat(arrays, length) {
  if (!length) {
    length = arrays.reduce((acc, curr) => acc + curr.length, 0);
  }
  const output = allocUnsafe$1(length);
  let offset = 0;
  for (const arr of arrays) {
    output.set(arr, offset);
    offset += arr.length;
  }
  return asUint8Array(output);
}

function base(ALPHABET, name) {
  if (ALPHABET.length >= 255) {
    throw new TypeError('Alphabet too long');
  }
  var BASE_MAP = new Uint8Array(256);
  for (var j = 0; j < BASE_MAP.length; j++) {
    BASE_MAP[j] = 255;
  }
  for (var i = 0; i < ALPHABET.length; i++) {
    var x = ALPHABET.charAt(i);
    var xc = x.charCodeAt(0);
    if (BASE_MAP[xc] !== 255) {
      throw new TypeError(x + ' is ambiguous');
    }
    BASE_MAP[xc] = i;
  }
  var BASE = ALPHABET.length;
  var LEADER = ALPHABET.charAt(0);
  var FACTOR = Math.log(BASE) / Math.log(256);
  var iFACTOR = Math.log(256) / Math.log(BASE);
  function encode(source) {
    if (source instanceof Uint8Array);
    else if (ArrayBuffer.isView(source)) {
      source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
    } else if (Array.isArray(source)) {
      source = Uint8Array.from(source);
    }
    if (!(source instanceof Uint8Array)) {
      throw new TypeError('Expected Uint8Array');
    }
    if (source.length === 0) {
      return '';
    }
    var zeroes = 0;
    var length = 0;
    var pbegin = 0;
    var pend = source.length;
    while (pbegin !== pend && source[pbegin] === 0) {
      pbegin++;
      zeroes++;
    }
    var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
    var b58 = new Uint8Array(size);
    while (pbegin !== pend) {
      var carry = source[pbegin];
      var i = 0;
      for (var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++) {
        carry += 256 * b58[it1] >>> 0;
        b58[it1] = carry % BASE >>> 0;
        carry = carry / BASE >>> 0;
      }
      if (carry !== 0) {
        throw new Error('Non-zero carry');
      }
      length = i;
      pbegin++;
    }
    var it2 = size - length;
    while (it2 !== size && b58[it2] === 0) {
      it2++;
    }
    var str = LEADER.repeat(zeroes);
    for (; it2 < size; ++it2) {
      str += ALPHABET.charAt(b58[it2]);
    }
    return str;
  }
  function decodeUnsafe(source) {
    if (typeof source !== 'string') {
      throw new TypeError('Expected String');
    }
    if (source.length === 0) {
      return new Uint8Array();
    }
    var psz = 0;
    if (source[psz] === ' ') {
      return;
    }
    var zeroes = 0;
    var length = 0;
    while (source[psz] === LEADER) {
      zeroes++;
      psz++;
    }
    var size = (source.length - psz) * FACTOR + 1 >>> 0;
    var b256 = new Uint8Array(size);
    while (source[psz]) {
      var carry = BASE_MAP[source.charCodeAt(psz)];
      if (carry === 255) {
        return;
      }
      var i = 0;
      for (var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++) {
        carry += BASE * b256[it3] >>> 0;
        b256[it3] = carry % 256 >>> 0;
        carry = carry / 256 >>> 0;
      }
      if (carry !== 0) {
        throw new Error('Non-zero carry');
      }
      length = i;
      psz++;
    }
    if (source[psz] === ' ') {
      return;
    }
    var it4 = size - length;
    while (it4 !== size && b256[it4] === 0) {
      it4++;
    }
    var vch = new Uint8Array(zeroes + (size - it4));
    var j = zeroes;
    while (it4 !== size) {
      vch[j++] = b256[it4++];
    }
    return vch;
  }
  function decode(string) {
    var buffer = decodeUnsafe(string);
    if (buffer) {
      return buffer;
    }
    throw new Error(`Non-${ name } character`);
  }
  return {
    encode: encode,
    decodeUnsafe: decodeUnsafe,
    decode: decode
  };
}
var src$1 = base;
var _brrp__multiformats_scope_baseX = src$1;

const coerce = o => {
  if (o instanceof Uint8Array && o.constructor.name === 'Uint8Array')
    return o;
  if (o instanceof ArrayBuffer)
    return new Uint8Array(o);
  if (ArrayBuffer.isView(o)) {
    return new Uint8Array(o.buffer, o.byteOffset, o.byteLength);
  }
  throw new Error('Unknown type, must be binary type');
};
const fromString$1 = str => new TextEncoder().encode(str);
const toString$4 = b => new TextDecoder().decode(b);

class Encoder {
  constructor(name, prefix, baseEncode) {
    this.name = name;
    this.prefix = prefix;
    this.baseEncode = baseEncode;
  }
  encode(bytes) {
    if (bytes instanceof Uint8Array) {
      return `${ this.prefix }${ this.baseEncode(bytes) }`;
    } else {
      throw Error('Unknown type, must be binary type');
    }
  }
}
class Decoder {
  constructor(name, prefix, baseDecode) {
    this.name = name;
    this.prefix = prefix;
    if (prefix.codePointAt(0) === undefined) {
      throw new Error('Invalid prefix character');
    }
    this.prefixCodePoint = prefix.codePointAt(0);
    this.baseDecode = baseDecode;
  }
  decode(text) {
    if (typeof text === 'string') {
      if (text.codePointAt(0) !== this.prefixCodePoint) {
        throw Error(`Unable to decode multibase string ${ JSON.stringify(text) }, ${ this.name } decoder only supports inputs prefixed with ${ this.prefix }`);
      }
      return this.baseDecode(text.slice(this.prefix.length));
    } else {
      throw Error('Can only multibase decode strings');
    }
  }
  or(decoder) {
    return or$3(this, decoder);
  }
}
class ComposedDecoder {
  constructor(decoders) {
    this.decoders = decoders;
  }
  or(decoder) {
    return or$3(this, decoder);
  }
  decode(input) {
    const prefix = input[0];
    const decoder = this.decoders[prefix];
    if (decoder) {
      return decoder.decode(input);
    } else {
      throw RangeError(`Unable to decode multibase string ${ JSON.stringify(input) }, only inputs prefixed with ${ Object.keys(this.decoders) } are supported`);
    }
  }
}
const or$3 = (left, right) => new ComposedDecoder({
  ...left.decoders || { [left.prefix]: left },
  ...right.decoders || { [right.prefix]: right }
});
class Codec {
  constructor(name, prefix, baseEncode, baseDecode) {
    this.name = name;
    this.prefix = prefix;
    this.baseEncode = baseEncode;
    this.baseDecode = baseDecode;
    this.encoder = new Encoder(name, prefix, baseEncode);
    this.decoder = new Decoder(name, prefix, baseDecode);
  }
  encode(input) {
    return this.encoder.encode(input);
  }
  decode(input) {
    return this.decoder.decode(input);
  }
}
const from = ({name, prefix, encode, decode}) => new Codec(name, prefix, encode, decode);
const baseX = ({prefix, name, alphabet}) => {
  const {encode, decode} = _brrp__multiformats_scope_baseX(alphabet, name);
  return from({
    prefix,
    name,
    encode,
    decode: text => coerce(decode(text))
  });
};
const decode$1 = (string, alphabet, bitsPerChar, name) => {
  const codes = {};
  for (let i = 0; i < alphabet.length; ++i) {
    codes[alphabet[i]] = i;
  }
  let end = string.length;
  while (string[end - 1] === '=') {
    --end;
  }
  const out = new Uint8Array(end * bitsPerChar / 8 | 0);
  let bits = 0;
  let buffer = 0;
  let written = 0;
  for (let i = 0; i < end; ++i) {
    const value = codes[string[i]];
    if (value === undefined) {
      throw new SyntaxError(`Non-${ name } character`);
    }
    buffer = buffer << bitsPerChar | value;
    bits += bitsPerChar;
    if (bits >= 8) {
      bits -= 8;
      out[written++] = 255 & buffer >> bits;
    }
  }
  if (bits >= bitsPerChar || 255 & buffer << 8 - bits) {
    throw new SyntaxError('Unexpected end of data');
  }
  return out;
};
const encode$1 = (data, alphabet, bitsPerChar) => {
  const pad = alphabet[alphabet.length - 1] === '=';
  const mask = (1 << bitsPerChar) - 1;
  let out = '';
  let bits = 0;
  let buffer = 0;
  for (let i = 0; i < data.length; ++i) {
    buffer = buffer << 8 | data[i];
    bits += 8;
    while (bits > bitsPerChar) {
      bits -= bitsPerChar;
      out += alphabet[mask & buffer >> bits];
    }
  }
  if (bits) {
    out += alphabet[mask & buffer << bitsPerChar - bits];
  }
  if (pad) {
    while (out.length * bitsPerChar & 7) {
      out += '=';
    }
  }
  return out;
};
const rfc4648 = ({name, prefix, bitsPerChar, alphabet}) => {
  return from({
    prefix,
    name,
    encode(input) {
      return encode$1(input, alphabet, bitsPerChar);
    },
    decode(input) {
      return decode$1(input, alphabet, bitsPerChar, name);
    }
  });
};

const identity = from({
  prefix: '\0',
  name: 'identity',
  encode: buf => toString$4(buf),
  decode: str => fromString$1(str)
});

var identityBase = /*#__PURE__*/Object.freeze({
	__proto__: null,
	identity: identity
});

const base2 = rfc4648({
  prefix: '0',
  name: 'base2',
  alphabet: '01',
  bitsPerChar: 1
});

var base2$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	base2: base2
});

const base8 = rfc4648({
  prefix: '7',
  name: 'base8',
  alphabet: '01234567',
  bitsPerChar: 3
});

var base8$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	base8: base8
});

const base10 = baseX({
  prefix: '9',
  name: 'base10',
  alphabet: '0123456789'
});

var base10$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	base10: base10
});

const base16 = rfc4648({
  prefix: 'f',
  name: 'base16',
  alphabet: '0123456789abcdef',
  bitsPerChar: 4
});
const base16upper = rfc4648({
  prefix: 'F',
  name: 'base16upper',
  alphabet: '0123456789ABCDEF',
  bitsPerChar: 4
});

var base16$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	base16: base16,
	base16upper: base16upper
});

const base32 = rfc4648({
  prefix: 'b',
  name: 'base32',
  alphabet: 'abcdefghijklmnopqrstuvwxyz234567',
  bitsPerChar: 5
});
const base32upper = rfc4648({
  prefix: 'B',
  name: 'base32upper',
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567',
  bitsPerChar: 5
});
const base32pad = rfc4648({
  prefix: 'c',
  name: 'base32pad',
  alphabet: 'abcdefghijklmnopqrstuvwxyz234567=',
  bitsPerChar: 5
});
const base32padupper = rfc4648({
  prefix: 'C',
  name: 'base32padupper',
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=',
  bitsPerChar: 5
});
const base32hex = rfc4648({
  prefix: 'v',
  name: 'base32hex',
  alphabet: '0123456789abcdefghijklmnopqrstuv',
  bitsPerChar: 5
});
const base32hexupper = rfc4648({
  prefix: 'V',
  name: 'base32hexupper',
  alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV',
  bitsPerChar: 5
});
const base32hexpad = rfc4648({
  prefix: 't',
  name: 'base32hexpad',
  alphabet: '0123456789abcdefghijklmnopqrstuv=',
  bitsPerChar: 5
});
const base32hexpadupper = rfc4648({
  prefix: 'T',
  name: 'base32hexpadupper',
  alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUV=',
  bitsPerChar: 5
});
const base32z = rfc4648({
  prefix: 'h',
  name: 'base32z',
  alphabet: 'ybndrfg8ejkmcpqxot1uwisza345h769',
  bitsPerChar: 5
});

var base32$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	base32: base32,
	base32hex: base32hex,
	base32hexpad: base32hexpad,
	base32hexpadupper: base32hexpadupper,
	base32hexupper: base32hexupper,
	base32pad: base32pad,
	base32padupper: base32padupper,
	base32upper: base32upper,
	base32z: base32z
});

const base36 = baseX({
  prefix: 'k',
  name: 'base36',
  alphabet: '0123456789abcdefghijklmnopqrstuvwxyz'
});
const base36upper = baseX({
  prefix: 'K',
  name: 'base36upper',
  alphabet: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ'
});

var base36$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	base36: base36,
	base36upper: base36upper
});

const base58btc = baseX({
  name: 'base58btc',
  prefix: 'z',
  alphabet: '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz'
});
const base58flickr = baseX({
  name: 'base58flickr',
  prefix: 'Z',
  alphabet: '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'
});

var base58 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	base58btc: base58btc,
	base58flickr: base58flickr
});

const base64 = rfc4648({
  prefix: 'm',
  name: 'base64',
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
  bitsPerChar: 6
});
const base64pad = rfc4648({
  prefix: 'M',
  name: 'base64pad',
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
  bitsPerChar: 6
});
const base64url = rfc4648({
  prefix: 'u',
  name: 'base64url',
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_',
  bitsPerChar: 6
});
const base64urlpad = rfc4648({
  prefix: 'U',
  name: 'base64urlpad',
  alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=',
  bitsPerChar: 6
});

var base64$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	base64: base64,
	base64pad: base64pad,
	base64url: base64url,
	base64urlpad: base64urlpad
});

const alphabet = Array.from('\uD83D\uDE80\uD83E\uDE90\u2604\uD83D\uDEF0\uD83C\uDF0C\uD83C\uDF11\uD83C\uDF12\uD83C\uDF13\uD83C\uDF14\uD83C\uDF15\uD83C\uDF16\uD83C\uDF17\uD83C\uDF18\uD83C\uDF0D\uD83C\uDF0F\uD83C\uDF0E\uD83D\uDC09\u2600\uD83D\uDCBB\uD83D\uDDA5\uD83D\uDCBE\uD83D\uDCBF\uD83D\uDE02\u2764\uD83D\uDE0D\uD83E\uDD23\uD83D\uDE0A\uD83D\uDE4F\uD83D\uDC95\uD83D\uDE2D\uD83D\uDE18\uD83D\uDC4D\uD83D\uDE05\uD83D\uDC4F\uD83D\uDE01\uD83D\uDD25\uD83E\uDD70\uD83D\uDC94\uD83D\uDC96\uD83D\uDC99\uD83D\uDE22\uD83E\uDD14\uD83D\uDE06\uD83D\uDE44\uD83D\uDCAA\uD83D\uDE09\u263A\uD83D\uDC4C\uD83E\uDD17\uD83D\uDC9C\uD83D\uDE14\uD83D\uDE0E\uD83D\uDE07\uD83C\uDF39\uD83E\uDD26\uD83C\uDF89\uD83D\uDC9E\u270C\u2728\uD83E\uDD37\uD83D\uDE31\uD83D\uDE0C\uD83C\uDF38\uD83D\uDE4C\uD83D\uDE0B\uD83D\uDC97\uD83D\uDC9A\uD83D\uDE0F\uD83D\uDC9B\uD83D\uDE42\uD83D\uDC93\uD83E\uDD29\uD83D\uDE04\uD83D\uDE00\uD83D\uDDA4\uD83D\uDE03\uD83D\uDCAF\uD83D\uDE48\uD83D\uDC47\uD83C\uDFB6\uD83D\uDE12\uD83E\uDD2D\u2763\uD83D\uDE1C\uD83D\uDC8B\uD83D\uDC40\uD83D\uDE2A\uD83D\uDE11\uD83D\uDCA5\uD83D\uDE4B\uD83D\uDE1E\uD83D\uDE29\uD83D\uDE21\uD83E\uDD2A\uD83D\uDC4A\uD83E\uDD73\uD83D\uDE25\uD83E\uDD24\uD83D\uDC49\uD83D\uDC83\uD83D\uDE33\u270B\uD83D\uDE1A\uD83D\uDE1D\uD83D\uDE34\uD83C\uDF1F\uD83D\uDE2C\uD83D\uDE43\uD83C\uDF40\uD83C\uDF37\uD83D\uDE3B\uD83D\uDE13\u2B50\u2705\uD83E\uDD7A\uD83C\uDF08\uD83D\uDE08\uD83E\uDD18\uD83D\uDCA6\u2714\uD83D\uDE23\uD83C\uDFC3\uD83D\uDC90\u2639\uD83C\uDF8A\uD83D\uDC98\uD83D\uDE20\u261D\uD83D\uDE15\uD83C\uDF3A\uD83C\uDF82\uD83C\uDF3B\uD83D\uDE10\uD83D\uDD95\uD83D\uDC9D\uD83D\uDE4A\uD83D\uDE39\uD83D\uDDE3\uD83D\uDCAB\uD83D\uDC80\uD83D\uDC51\uD83C\uDFB5\uD83E\uDD1E\uD83D\uDE1B\uD83D\uDD34\uD83D\uDE24\uD83C\uDF3C\uD83D\uDE2B\u26BD\uD83E\uDD19\u2615\uD83C\uDFC6\uD83E\uDD2B\uD83D\uDC48\uD83D\uDE2E\uD83D\uDE46\uD83C\uDF7B\uD83C\uDF43\uD83D\uDC36\uD83D\uDC81\uD83D\uDE32\uD83C\uDF3F\uD83E\uDDE1\uD83C\uDF81\u26A1\uD83C\uDF1E\uD83C\uDF88\u274C\u270A\uD83D\uDC4B\uD83D\uDE30\uD83E\uDD28\uD83D\uDE36\uD83E\uDD1D\uD83D\uDEB6\uD83D\uDCB0\uD83C\uDF53\uD83D\uDCA2\uD83E\uDD1F\uD83D\uDE41\uD83D\uDEA8\uD83D\uDCA8\uD83E\uDD2C\u2708\uD83C\uDF80\uD83C\uDF7A\uD83E\uDD13\uD83D\uDE19\uD83D\uDC9F\uD83C\uDF31\uD83D\uDE16\uD83D\uDC76\uD83E\uDD74\u25B6\u27A1\u2753\uD83D\uDC8E\uD83D\uDCB8\u2B07\uD83D\uDE28\uD83C\uDF1A\uD83E\uDD8B\uD83D\uDE37\uD83D\uDD7A\u26A0\uD83D\uDE45\uD83D\uDE1F\uD83D\uDE35\uD83D\uDC4E\uD83E\uDD32\uD83E\uDD20\uD83E\uDD27\uD83D\uDCCC\uD83D\uDD35\uD83D\uDC85\uD83E\uDDD0\uD83D\uDC3E\uD83C\uDF52\uD83D\uDE17\uD83E\uDD11\uD83C\uDF0A\uD83E\uDD2F\uD83D\uDC37\u260E\uD83D\uDCA7\uD83D\uDE2F\uD83D\uDC86\uD83D\uDC46\uD83C\uDFA4\uD83D\uDE47\uD83C\uDF51\u2744\uD83C\uDF34\uD83D\uDCA3\uD83D\uDC38\uD83D\uDC8C\uD83D\uDCCD\uD83E\uDD40\uD83E\uDD22\uD83D\uDC45\uD83D\uDCA1\uD83D\uDCA9\uD83D\uDC50\uD83D\uDCF8\uD83D\uDC7B\uD83E\uDD10\uD83E\uDD2E\uD83C\uDFBC\uD83E\uDD75\uD83D\uDEA9\uD83C\uDF4E\uD83C\uDF4A\uD83D\uDC7C\uD83D\uDC8D\uD83D\uDCE3\uD83E\uDD42');
const alphabetBytesToChars = alphabet.reduce((p, c, i) => {
  p[i] = c;
  return p;
}, []);
const alphabetCharsToBytes = alphabet.reduce((p, c, i) => {
  p[c.codePointAt(0)] = i;
  return p;
}, []);
function encode(data) {
  return data.reduce((p, c) => {
    p += alphabetBytesToChars[c];
    return p;
  }, '');
}
function decode(str) {
  const byts = [];
  for (const char of str) {
    const byt = alphabetCharsToBytes[char.codePointAt(0)];
    if (byt === undefined) {
      throw new Error(`Non-base256emoji character: ${ char }`);
    }
    byts.push(byt);
  }
  return new Uint8Array(byts);
}
const base256emoji = from({
  prefix: '\uD83D\uDE80',
  name: 'base256emoji',
  encode,
  decode
});

var base256emoji$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	base256emoji: base256emoji
});

new TextEncoder();
new TextDecoder();

const bases = {
  ...identityBase,
  ...base2$1,
  ...base8$1,
  ...base10$1,
  ...base16$1,
  ...base32$1,
  ...base36$1,
  ...base58,
  ...base64$1,
  ...base256emoji$1
};

function createCodec(name, prefix, encode, decode) {
  return {
    name,
    prefix,
    encoder: {
      name,
      prefix,
      encode
    },
    decoder: { decode }
  };
}
const string$1 = createCodec('utf8', 'u', buf => {
  const decoder = new TextDecoder('utf8');
  return 'u' + decoder.decode(buf);
}, str => {
  const encoder = new TextEncoder();
  return encoder.encode(str.substring(1));
});
const ascii = createCodec('ascii', 'a', buf => {
  let string = 'a';
  for (let i = 0; i < buf.length; i++) {
    string += String.fromCharCode(buf[i]);
  }
  return string;
}, str => {
  str = str.substring(1);
  const buf = allocUnsafe$1(str.length);
  for (let i = 0; i < str.length; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
});
const BASES = {
  utf8: string$1,
  'utf-8': string$1,
  hex: bases.base16,
  latin1: ascii,
  ascii: ascii,
  binary: ascii,
  ...bases
};

function fromString(string, encoding = 'utf8') {
  const base = BASES[encoding];
  if (!base) {
    throw new Error(`Unsupported encoding "${ encoding }"`);
  }
  if ((encoding === 'utf8' || encoding === 'utf-8') && globalThis.Buffer != null && globalThis.Buffer.from != null) {
    return asUint8Array(globalThis.Buffer.from(string, 'utf-8'));
  }
  return base.decoder.decode(`${ base.prefix }${ string }`);
}

function toString$3(array, encoding = 'utf8') {
  const base = BASES[encoding];
  if (!base) {
    throw new Error(`Unsupported encoding "${ encoding }"`);
  }
  if ((encoding === 'utf8' || encoding === 'utf-8') && globalThis.Buffer != null && globalThis.Buffer.from != null) {
    return globalThis.Buffer.from(array.buffer, array.byteOffset, array.byteLength).toString('utf8');
  }
  return base.encoder.encode(array).substring(1);
}

var __spreadArray$1 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var BrowserInfo = /** @class */ (function () {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = 'browser';
    }
    return BrowserInfo;
}());
var NodeInfo = /** @class */ (function () {
    function NodeInfo(version) {
        this.version = version;
        this.type = 'node';
        this.name = 'node';
        this.os = process.platform;
    }
    return NodeInfo;
}());
var SearchBotDeviceInfo = /** @class */ (function () {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = 'bot-device';
    }
    return SearchBotDeviceInfo;
}());
var BotInfo = /** @class */ (function () {
    function BotInfo() {
        this.type = 'bot';
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}());
var ReactNativeInfo = /** @class */ (function () {
    function ReactNativeInfo() {
        this.type = 'react-native';
        this.name = 'react-native';
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}());
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    ['aol', /AOLShield\/([0-9\._]+)/],
    ['edge', /Edge\/([0-9\._]+)/],
    ['edge-ios', /EdgiOS\/([0-9\._]+)/],
    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
    ['silk', /\bSilk\/([0-9._-]+)\b/],
    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
    ['edge-chromium', /EdgA?\/([0-9\.]+)/],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
    ],
    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
    ['fxios', /FxiOS\/([0-9\.]+)/],
    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
    ['pie', /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/],
    ['pie', /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/],
    ['netfront', /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/],
    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
    ['ie', /MSIE\s(7\.0)/],
    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
    ['android', /Android\s([0-9\.]+)/],
    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
    ['safari', /Version\/([0-9\._]+).*Safari/],
    ['facebook', /FB[AS]V\/([0-9\.]+)/],
    ['instagram', /Instagram\s([0-9\.]+)/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
    ['curl', /^curl\/([0-9\.]+)$/],
    ['searchbot', SEARCHBOX_UA_REGEX],
];
var operatingSystemRules = [
    ['iOS', /iP(hone|od|ad)/],
    ['Android OS', /Android/],
    ['BlackBerry OS', /BlackBerry|BB10/],
    ['Windows Mobile', /IEMobile/],
    ['Amazon OS', /Kindle/],
    ['Windows 3.11', /Win16/],
    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
    ['Windows 98', /(Windows 98)|(Win98)/],
    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
    ['Windows Server 2003', /(Windows NT 5.2)/],
    ['Windows Vista', /(Windows NT 6.0)/],
    ['Windows 7', /(Windows NT 6.1)/],
    ['Windows 8', /(Windows NT 6.2)/],
    ['Windows 8.1', /(Windows NT 6.3)/],
    ['Windows 10', /(Windows NT 10.0)/],
    ['Windows ME', /Windows ME/],
    ['Windows CE', /Windows CE|WinCE|Microsoft Pocket Internet Explorer/],
    ['Open BSD', /OpenBSD/],
    ['Sun OS', /SunOS/],
    ['Chrome OS', /CrOS/],
    ['Linux', /(Linux)|(X11)/],
    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
    ['QNX', /QNX/],
    ['BeOS', /BeOS/],
    ['OS/2', /OS\/2/],
];
function detect(userAgent) {
    if (typeof document === 'undefined' &&
        typeof navigator !== 'undefined' &&
        navigator.product === 'ReactNative') {
        return new ReactNativeInfo();
    }
    if (typeof navigator !== 'undefined') {
        return parseUserAgent(navigator.userAgent);
    }
    return getNodeVersion();
}
function matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return (ua !== '' &&
        userAgentRules.reduce(function (matched, _a) {
            var browser = _a[0], regex = _a[1];
            if (matched) {
                return matched;
            }
            var uaMatch = regex.exec(ua);
            return !!uaMatch && [browser, uaMatch];
        }, false));
}
function parseUserAgent(ua) {
    var matchedRule = matchUserAgent(ua);
    if (!matchedRule) {
        return null;
    }
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') {
        return new BotInfo();
    }
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split('.').join('_').split('_').slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) {
            versionParts = __spreadArray$1(__spreadArray$1([], versionParts, true), createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length), true);
        }
    }
    else {
        versionParts = [];
    }
    var version = versionParts.join('.');
    var os = detectOS(ua);
    var searchBotMatch = SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) {
        return new SearchBotDeviceInfo(name, version, os, searchBotMatch[1]);
    }
    return new BrowserInfo(name, version, os);
}
function detectOS(ua) {
    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) {
            return os;
        }
    }
    return null;
}
function getNodeVersion() {
    var isNode = typeof process !== 'undefined' && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
function createVersionParts(count) {
    var output = [];
    for (var ii = 0; ii < count; ii++) {
        output.push('0');
    }
    return output;
}

var cjs$4 = {};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$3 = function(d, b) {
    extendStatics$3 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$3(d, b);
};

function __extends$3(d, b) {
    extendStatics$3(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$3 = function() {
    __assign$3 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$3.apply(this, arguments);
};

function __rest$4(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate$2(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param$2(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata$2(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter$7(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator$2(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding$2(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar$2(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values$3(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read$3(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread$2() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read$3(arguments[i]));
    return ar;
}

function __spreadArrays$2() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}
function __await$2(v) {
    return this instanceof __await$2 ? (this.v = v, this) : new __await$2(v);
}

function __asyncGenerator$2(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await$2 ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator$2(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await$2(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues$2(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values$3 === "function" ? __values$3(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject$2(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
function __importStar$2(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault$2(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet$3(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet$3(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

var tslib_es6$2 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	get __assign () { return __assign$3; },
	__asyncDelegator: __asyncDelegator$2,
	__asyncGenerator: __asyncGenerator$2,
	__asyncValues: __asyncValues$2,
	__await: __await$2,
	__awaiter: __awaiter$7,
	__classPrivateFieldGet: __classPrivateFieldGet$3,
	__classPrivateFieldSet: __classPrivateFieldSet$3,
	__createBinding: __createBinding$2,
	__decorate: __decorate$2,
	__exportStar: __exportStar$2,
	__extends: __extends$3,
	__generator: __generator$2,
	__importDefault: __importDefault$2,
	__importStar: __importStar$2,
	__makeTemplateObject: __makeTemplateObject$2,
	__metadata: __metadata$2,
	__param: __param$2,
	__read: __read$3,
	__rest: __rest$4,
	__spread: __spread$2,
	__spreadArrays: __spreadArrays$2,
	__values: __values$3
});

var require$$0$5 = /*@__PURE__*/getAugmentedNamespace(tslib_es6$2);

var utils$3 = {};

var delay = {};

var hasRequiredDelay;

function requireDelay () {
	if (hasRequiredDelay) return delay;
	hasRequiredDelay = 1;
	Object.defineProperty(delay, "__esModule", { value: true });
	delay.delay = void 0;
	function delay$1(timeout) {
	    return new Promise(resolve => {
	        setTimeout(() => {
	            resolve(true);
	        }, timeout);
	    });
	}
	delay.delay = delay$1;
	
	return delay;
}

var convert$1 = {};

var constants$1 = {};

var misc = {};

var hasRequiredMisc;

function requireMisc () {
	if (hasRequiredMisc) return misc;
	hasRequiredMisc = 1;
	Object.defineProperty(misc, "__esModule", { value: true });
	misc.ONE_THOUSAND = misc.ONE_HUNDRED = void 0;
	misc.ONE_HUNDRED = 100;
	misc.ONE_THOUSAND = 1000;
	
	return misc;
}

var time = {};

var hasRequiredTime;

function requireTime () {
	if (hasRequiredTime) return time;
	hasRequiredTime = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.ONE_YEAR = exports.FOUR_WEEKS = exports.THREE_WEEKS = exports.TWO_WEEKS = exports.ONE_WEEK = exports.THIRTY_DAYS = exports.SEVEN_DAYS = exports.FIVE_DAYS = exports.THREE_DAYS = exports.ONE_DAY = exports.TWENTY_FOUR_HOURS = exports.TWELVE_HOURS = exports.SIX_HOURS = exports.THREE_HOURS = exports.ONE_HOUR = exports.SIXTY_MINUTES = exports.THIRTY_MINUTES = exports.TEN_MINUTES = exports.FIVE_MINUTES = exports.ONE_MINUTE = exports.SIXTY_SECONDS = exports.THIRTY_SECONDS = exports.TEN_SECONDS = exports.FIVE_SECONDS = exports.ONE_SECOND = void 0;
		exports.ONE_SECOND = 1;
		exports.FIVE_SECONDS = 5;
		exports.TEN_SECONDS = 10;
		exports.THIRTY_SECONDS = 30;
		exports.SIXTY_SECONDS = 60;
		exports.ONE_MINUTE = exports.SIXTY_SECONDS;
		exports.FIVE_MINUTES = exports.ONE_MINUTE * 5;
		exports.TEN_MINUTES = exports.ONE_MINUTE * 10;
		exports.THIRTY_MINUTES = exports.ONE_MINUTE * 30;
		exports.SIXTY_MINUTES = exports.ONE_MINUTE * 60;
		exports.ONE_HOUR = exports.SIXTY_MINUTES;
		exports.THREE_HOURS = exports.ONE_HOUR * 3;
		exports.SIX_HOURS = exports.ONE_HOUR * 6;
		exports.TWELVE_HOURS = exports.ONE_HOUR * 12;
		exports.TWENTY_FOUR_HOURS = exports.ONE_HOUR * 24;
		exports.ONE_DAY = exports.TWENTY_FOUR_HOURS;
		exports.THREE_DAYS = exports.ONE_DAY * 3;
		exports.FIVE_DAYS = exports.ONE_DAY * 5;
		exports.SEVEN_DAYS = exports.ONE_DAY * 7;
		exports.THIRTY_DAYS = exports.ONE_DAY * 30;
		exports.ONE_WEEK = exports.SEVEN_DAYS;
		exports.TWO_WEEKS = exports.ONE_WEEK * 2;
		exports.THREE_WEEKS = exports.ONE_WEEK * 3;
		exports.FOUR_WEEKS = exports.ONE_WEEK * 4;
		exports.ONE_YEAR = exports.ONE_DAY * 365;
		
	} (time));
	return time;
}

var hasRequiredConstants$1;

function requireConstants$1 () {
	if (hasRequiredConstants$1) return constants$1;
	hasRequiredConstants$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		const tslib_1 = require$$0$5;
		tslib_1.__exportStar(requireMisc(), exports);
		tslib_1.__exportStar(requireTime(), exports);
		
	} (constants$1));
	return constants$1;
}

var hasRequiredConvert;

function requireConvert () {
	if (hasRequiredConvert) return convert$1;
	hasRequiredConvert = 1;
	Object.defineProperty(convert$1, "__esModule", { value: true });
	convert$1.fromMiliseconds = convert$1.toMiliseconds = void 0;
	const constants_1 = requireConstants$1();
	function toMiliseconds(seconds) {
	    return seconds * constants_1.ONE_THOUSAND;
	}
	convert$1.toMiliseconds = toMiliseconds;
	function fromMiliseconds(miliseconds) {
	    return Math.floor(miliseconds / constants_1.ONE_THOUSAND);
	}
	convert$1.fromMiliseconds = fromMiliseconds;
	
	return convert$1;
}

var hasRequiredUtils$3;

function requireUtils$3 () {
	if (hasRequiredUtils$3) return utils$3;
	hasRequiredUtils$3 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		const tslib_1 = require$$0$5;
		tslib_1.__exportStar(requireDelay(), exports);
		tslib_1.__exportStar(requireConvert(), exports);
		
	} (utils$3));
	return utils$3;
}

var watch$2 = {};

var hasRequiredWatch$1;

function requireWatch$1 () {
	if (hasRequiredWatch$1) return watch$2;
	hasRequiredWatch$1 = 1;
	Object.defineProperty(watch$2, "__esModule", { value: true });
	watch$2.Watch = void 0;
	class Watch {
	    constructor() {
	        this.timestamps = new Map();
	    }
	    start(label) {
	        if (this.timestamps.has(label)) {
	            throw new Error(`Watch already started for label: ${label}`);
	        }
	        this.timestamps.set(label, { started: Date.now() });
	    }
	    stop(label) {
	        const timestamp = this.get(label);
	        if (typeof timestamp.elapsed !== "undefined") {
	            throw new Error(`Watch already stopped for label: ${label}`);
	        }
	        const elapsed = Date.now() - timestamp.started;
	        this.timestamps.set(label, { started: timestamp.started, elapsed });
	    }
	    get(label) {
	        const timestamp = this.timestamps.get(label);
	        if (typeof timestamp === "undefined") {
	            throw new Error(`No timestamp found for label: ${label}`);
	        }
	        return timestamp;
	    }
	    elapsed(label) {
	        const timestamp = this.get(label);
	        const elapsed = timestamp.elapsed || Date.now() - timestamp.started;
	        return elapsed;
	    }
	}
	watch$2.Watch = Watch;
	watch$2.default = Watch;
	
	return watch$2;
}

var types$1 = {};

var watch$1 = {};

var hasRequiredWatch;

function requireWatch () {
	if (hasRequiredWatch) return watch$1;
	hasRequiredWatch = 1;
	Object.defineProperty(watch$1, "__esModule", { value: true });
	watch$1.IWatch = void 0;
	class IWatch {
	}
	watch$1.IWatch = IWatch;
	
	return watch$1;
}

var hasRequiredTypes$1;

function requireTypes$1 () {
	if (hasRequiredTypes$1) return types$1;
	hasRequiredTypes$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		const tslib_1 = require$$0$5;
		tslib_1.__exportStar(requireWatch(), exports);
		
	} (types$1));
	return types$1;
}

var hasRequiredCjs$4;

function requireCjs$4 () {
	if (hasRequiredCjs$4) return cjs$4;
	hasRequiredCjs$4 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		const tslib_1 = require$$0$5;
		tslib_1.__exportStar(requireUtils$3(), exports);
		tslib_1.__exportStar(requireWatch$1(), exports);
		tslib_1.__exportStar(requireTypes$1(), exports);
		tslib_1.__exportStar(requireConstants$1(), exports);
		
	} (cjs$4));
	return cjs$4;
}

var cjsExports$4 = requireCjs$4();

var cjs$3 = {};

var hasRequiredCjs$3;

function requireCjs$3 () {
	if (hasRequiredCjs$3) return cjs$3;
	hasRequiredCjs$3 = 1;
	Object.defineProperty(cjs$3, "__esModule", { value: true });
	cjs$3.getLocalStorage = cjs$3.getLocalStorageOrThrow = cjs$3.getCrypto = cjs$3.getCryptoOrThrow = cjs$3.getLocation = cjs$3.getLocationOrThrow = cjs$3.getNavigator = cjs$3.getNavigatorOrThrow = cjs$3.getDocument = cjs$3.getDocumentOrThrow = cjs$3.getFromWindowOrThrow = cjs$3.getFromWindow = void 0;
	function getFromWindow(name) {
	    let res = undefined;
	    if (typeof window !== "undefined" && typeof window[name] !== "undefined") {
	        res = window[name];
	    }
	    return res;
	}
	cjs$3.getFromWindow = getFromWindow;
	function getFromWindowOrThrow(name) {
	    const res = getFromWindow(name);
	    if (!res) {
	        throw new Error(`${name} is not defined in Window`);
	    }
	    return res;
	}
	cjs$3.getFromWindowOrThrow = getFromWindowOrThrow;
	function getDocumentOrThrow() {
	    return getFromWindowOrThrow("document");
	}
	cjs$3.getDocumentOrThrow = getDocumentOrThrow;
	function getDocument() {
	    return getFromWindow("document");
	}
	cjs$3.getDocument = getDocument;
	function getNavigatorOrThrow() {
	    return getFromWindowOrThrow("navigator");
	}
	cjs$3.getNavigatorOrThrow = getNavigatorOrThrow;
	function getNavigator() {
	    return getFromWindow("navigator");
	}
	cjs$3.getNavigator = getNavigator;
	function getLocationOrThrow() {
	    return getFromWindowOrThrow("location");
	}
	cjs$3.getLocationOrThrow = getLocationOrThrow;
	function getLocation() {
	    return getFromWindow("location");
	}
	cjs$3.getLocation = getLocation;
	function getCryptoOrThrow() {
	    return getFromWindowOrThrow("crypto");
	}
	cjs$3.getCryptoOrThrow = getCryptoOrThrow;
	function getCrypto() {
	    return getFromWindow("crypto");
	}
	cjs$3.getCrypto = getCrypto;
	function getLocalStorageOrThrow() {
	    return getFromWindowOrThrow("localStorage");
	}
	cjs$3.getLocalStorageOrThrow = getLocalStorageOrThrow;
	function getLocalStorage() {
	    return getFromWindow("localStorage");
	}
	cjs$3.getLocalStorage = getLocalStorage;
	
	return cjs$3;
}

var cjsExports$3 = requireCjs$3();

var cjs$2 = {};

var hasRequiredCjs$2;

function requireCjs$2 () {
	if (hasRequiredCjs$2) return cjs$2;
	hasRequiredCjs$2 = 1;
	Object.defineProperty(cjs$2, "__esModule", { value: true });
	cjs$2.getWindowMetadata = void 0;
	const window_getters_1 = requireCjs$3();
	function getWindowMetadata() {
	    let doc;
	    let loc;
	    try {
	        doc = window_getters_1.getDocumentOrThrow();
	        loc = window_getters_1.getLocationOrThrow();
	    }
	    catch (e) {
	        return null;
	    }
	    function getIcons() {
	        const links = doc.getElementsByTagName("link");
	        const icons = [];
	        for (let i = 0; i < links.length; i++) {
	            const link = links[i];
	            const rel = link.getAttribute("rel");
	            if (rel) {
	                if (rel.toLowerCase().indexOf("icon") > -1) {
	                    const href = link.getAttribute("href");
	                    if (href) {
	                        if (href.toLowerCase().indexOf("https:") === -1 &&
	                            href.toLowerCase().indexOf("http:") === -1 &&
	                            href.indexOf("//") !== 0) {
	                            let absoluteHref = loc.protocol + "//" + loc.host;
	                            if (href.indexOf("/") === 0) {
	                                absoluteHref += href;
	                            }
	                            else {
	                                const path = loc.pathname.split("/");
	                                path.pop();
	                                const finalPath = path.join("/");
	                                absoluteHref += finalPath + "/" + href;
	                            }
	                            icons.push(absoluteHref);
	                        }
	                        else if (href.indexOf("//") === 0) {
	                            const absoluteUrl = loc.protocol + href;
	                            icons.push(absoluteUrl);
	                        }
	                        else {
	                            icons.push(href);
	                        }
	                    }
	                }
	            }
	        }
	        return icons;
	    }
	    function getWindowMetadataOfAny(...args) {
	        const metaTags = doc.getElementsByTagName("meta");
	        for (let i = 0; i < metaTags.length; i++) {
	            const tag = metaTags[i];
	            const attributes = ["itemprop", "property", "name"]
	                .map((target) => tag.getAttribute(target))
	                .filter((attr) => {
	                if (attr) {
	                    return args.includes(attr);
	                }
	                return false;
	            });
	            if (attributes.length && attributes) {
	                const content = tag.getAttribute("content");
	                if (content) {
	                    return content;
	                }
	            }
	        }
	        return "";
	    }
	    function getName() {
	        let name = getWindowMetadataOfAny("name", "og:site_name", "og:title", "twitter:title");
	        if (!name) {
	            name = doc.title;
	        }
	        return name;
	    }
	    function getDescription() {
	        const description = getWindowMetadataOfAny("description", "og:description", "twitter:description", "keywords");
	        return description;
	    }
	    const name = getName();
	    const description = getDescription();
	    const url = loc.origin;
	    const icons = getIcons();
	    const meta = {
	        description,
	        url,
	        icons,
	        name,
	    };
	    return meta;
	}
	cjs$2.getWindowMetadata = getWindowMetadata;
	
	return cjs$2;
}

var cjsExports$2 = requireCjs$2();

var queryString = {};

var strictUriEncode;
var hasRequiredStrictUriEncode;

function requireStrictUriEncode () {
	if (hasRequiredStrictUriEncode) return strictUriEncode;
	hasRequiredStrictUriEncode = 1;
	strictUriEncode = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);
	return strictUriEncode;
}

var decodeUriComponent;
var hasRequiredDecodeUriComponent;

function requireDecodeUriComponent () {
	if (hasRequiredDecodeUriComponent) return decodeUriComponent;
	hasRequiredDecodeUriComponent = 1;
	var token = '%[a-f0-9]{2}';
	var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
	var multiMatcher = new RegExp('(' + token + ')+', 'gi');

	function decodeComponents(components, split) {
		try {
			// Try to decode the entire string first
			return [decodeURIComponent(components.join(''))];
		} catch (err) {
			// Do nothing
		}

		if (components.length === 1) {
			return components;
		}

		split = split || 1;

		// Split the array in 2 parts
		var left = components.slice(0, split);
		var right = components.slice(split);

		return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
	}

	function decode(input) {
		try {
			return decodeURIComponent(input);
		} catch (err) {
			var tokens = input.match(singleMatcher) || [];

			for (var i = 1; i < tokens.length; i++) {
				input = decodeComponents(tokens, i).join('');

				tokens = input.match(singleMatcher) || [];
			}

			return input;
		}
	}

	function customDecodeURIComponent(input) {
		// Keep track of all the replacements and prefill the map with the `BOM`
		var replaceMap = {
			'%FE%FF': '\uFFFD\uFFFD',
			'%FF%FE': '\uFFFD\uFFFD'
		};

		var match = multiMatcher.exec(input);
		while (match) {
			try {
				// Decode as big chunks as possible
				replaceMap[match[0]] = decodeURIComponent(match[0]);
			} catch (err) {
				var result = decode(match[0]);

				if (result !== match[0]) {
					replaceMap[match[0]] = result;
				}
			}

			match = multiMatcher.exec(input);
		}

		// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
		replaceMap['%C2'] = '\uFFFD';

		var entries = Object.keys(replaceMap);

		for (var i = 0; i < entries.length; i++) {
			// Replace all decoded components
			var key = entries[i];
			input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
		}

		return input;
	}

	decodeUriComponent = function (encodedURI) {
		if (typeof encodedURI !== 'string') {
			throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
		}

		try {
			encodedURI = encodedURI.replace(/\+/g, ' ');

			// Try the built in decoder first
			return decodeURIComponent(encodedURI);
		} catch (err) {
			// Fallback to a more advanced decoder
			return customDecodeURIComponent(encodedURI);
		}
	};
	return decodeUriComponent;
}

var splitOnFirst;
var hasRequiredSplitOnFirst;

function requireSplitOnFirst () {
	if (hasRequiredSplitOnFirst) return splitOnFirst;
	hasRequiredSplitOnFirst = 1;

	splitOnFirst = (string, separator) => {
		if (!(typeof string === 'string' && typeof separator === 'string')) {
			throw new TypeError('Expected the arguments to be of type `string`');
		}

		if (separator === '') {
			return [string];
		}

		const separatorIndex = string.indexOf(separator);

		if (separatorIndex === -1) {
			return [string];
		}

		return [
			string.slice(0, separatorIndex),
			string.slice(separatorIndex + separator.length)
		];
	};
	return splitOnFirst;
}

var filterObj;
var hasRequiredFilterObj;

function requireFilterObj () {
	if (hasRequiredFilterObj) return filterObj;
	hasRequiredFilterObj = 1;
	filterObj = function (obj, predicate) {
		var ret = {};
		var keys = Object.keys(obj);
		var isArr = Array.isArray(predicate);

		for (var i = 0; i < keys.length; i++) {
			var key = keys[i];
			var val = obj[key];

			if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
				ret[key] = val;
			}
		}

		return ret;
	};
	return filterObj;
}

var hasRequiredQueryString;

function requireQueryString () {
	if (hasRequiredQueryString) return queryString;
	hasRequiredQueryString = 1;
	(function (exports) {
		const strictUriEncode = requireStrictUriEncode();
		const decodeComponent = requireDecodeUriComponent();
		const splitOnFirst = requireSplitOnFirst();
		const filterObject = requireFilterObj();

		const isNullOrUndefined = value => value === null || value === undefined;

		const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

		function encoderForArrayFormat(options) {
			switch (options.arrayFormat) {
				case 'index':
					return key => (result, value) => {
						const index = result.length;

						if (
							value === undefined ||
							(options.skipNull && value === null) ||
							(options.skipEmptyString && value === '')
						) {
							return result;
						}

						if (value === null) {
							return [...result, [encode(key, options), '[', index, ']'].join('')];
						}

						return [
							...result,
							[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
						];
					};

				case 'bracket':
					return key => (result, value) => {
						if (
							value === undefined ||
							(options.skipNull && value === null) ||
							(options.skipEmptyString && value === '')
						) {
							return result;
						}

						if (value === null) {
							return [...result, [encode(key, options), '[]'].join('')];
						}

						return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
					};

				case 'colon-list-separator':
					return key => (result, value) => {
						if (
							value === undefined ||
							(options.skipNull && value === null) ||
							(options.skipEmptyString && value === '')
						) {
							return result;
						}

						if (value === null) {
							return [...result, [encode(key, options), ':list='].join('')];
						}

						return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
					};

				case 'comma':
				case 'separator':
				case 'bracket-separator': {
					const keyValueSep = options.arrayFormat === 'bracket-separator' ?
						'[]=' :
						'=';

					return key => (result, value) => {
						if (
							value === undefined ||
							(options.skipNull && value === null) ||
							(options.skipEmptyString && value === '')
						) {
							return result;
						}

						// Translate null to an empty string so that it doesn't serialize as 'null'
						value = value === null ? '' : value;

						if (result.length === 0) {
							return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
						}

						return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
					};
				}

				default:
					return key => (result, value) => {
						if (
							value === undefined ||
							(options.skipNull && value === null) ||
							(options.skipEmptyString && value === '')
						) {
							return result;
						}

						if (value === null) {
							return [...result, encode(key, options)];
						}

						return [...result, [encode(key, options), '=', encode(value, options)].join('')];
					};
			}
		}

		function parserForArrayFormat(options) {
			let result;

			switch (options.arrayFormat) {
				case 'index':
					return (key, value, accumulator) => {
						result = /\[(\d*)\]$/.exec(key);

						key = key.replace(/\[\d*\]$/, '');

						if (!result) {
							accumulator[key] = value;
							return;
						}

						if (accumulator[key] === undefined) {
							accumulator[key] = {};
						}

						accumulator[key][result[1]] = value;
					};

				case 'bracket':
					return (key, value, accumulator) => {
						result = /(\[\])$/.exec(key);
						key = key.replace(/\[\]$/, '');

						if (!result) {
							accumulator[key] = value;
							return;
						}

						if (accumulator[key] === undefined) {
							accumulator[key] = [value];
							return;
						}

						accumulator[key] = [].concat(accumulator[key], value);
					};

				case 'colon-list-separator':
					return (key, value, accumulator) => {
						result = /(:list)$/.exec(key);
						key = key.replace(/:list$/, '');

						if (!result) {
							accumulator[key] = value;
							return;
						}

						if (accumulator[key] === undefined) {
							accumulator[key] = [value];
							return;
						}

						accumulator[key] = [].concat(accumulator[key], value);
					};

				case 'comma':
				case 'separator':
					return (key, value, accumulator) => {
						const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
						const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
						value = isEncodedArray ? decode(value, options) : value;
						const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
						accumulator[key] = newValue;
					};

				case 'bracket-separator':
					return (key, value, accumulator) => {
						const isArray = /(\[\])$/.test(key);
						key = key.replace(/\[\]$/, '');

						if (!isArray) {
							accumulator[key] = value ? decode(value, options) : value;
							return;
						}

						const arrayValue = value === null ?
							[] :
							value.split(options.arrayFormatSeparator).map(item => decode(item, options));

						if (accumulator[key] === undefined) {
							accumulator[key] = arrayValue;
							return;
						}

						accumulator[key] = [].concat(accumulator[key], arrayValue);
					};

				default:
					return (key, value, accumulator) => {
						if (accumulator[key] === undefined) {
							accumulator[key] = value;
							return;
						}

						accumulator[key] = [].concat(accumulator[key], value);
					};
			}
		}

		function validateArrayFormatSeparator(value) {
			if (typeof value !== 'string' || value.length !== 1) {
				throw new TypeError('arrayFormatSeparator must be single character string');
			}
		}

		function encode(value, options) {
			if (options.encode) {
				return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
			}

			return value;
		}

		function decode(value, options) {
			if (options.decode) {
				return decodeComponent(value);
			}

			return value;
		}

		function keysSorter(input) {
			if (Array.isArray(input)) {
				return input.sort();
			}

			if (typeof input === 'object') {
				return keysSorter(Object.keys(input))
					.sort((a, b) => Number(a) - Number(b))
					.map(key => input[key]);
			}

			return input;
		}

		function removeHash(input) {
			const hashStart = input.indexOf('#');
			if (hashStart !== -1) {
				input = input.slice(0, hashStart);
			}

			return input;
		}

		function getHash(url) {
			let hash = '';
			const hashStart = url.indexOf('#');
			if (hashStart !== -1) {
				hash = url.slice(hashStart);
			}

			return hash;
		}

		function extract(input) {
			input = removeHash(input);
			const queryStart = input.indexOf('?');
			if (queryStart === -1) {
				return '';
			}

			return input.slice(queryStart + 1);
		}

		function parseValue(value, options) {
			if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
				value = Number(value);
			} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
				value = value.toLowerCase() === 'true';
			}

			return value;
		}

		function parse(query, options) {
			options = Object.assign({
				decode: true,
				sort: true,
				arrayFormat: 'none',
				arrayFormatSeparator: ',',
				parseNumbers: false,
				parseBooleans: false
			}, options);

			validateArrayFormatSeparator(options.arrayFormatSeparator);

			const formatter = parserForArrayFormat(options);

			// Create an object with no prototype
			const ret = Object.create(null);

			if (typeof query !== 'string') {
				return ret;
			}

			query = query.trim().replace(/^[?#&]/, '');

			if (!query) {
				return ret;
			}

			for (const param of query.split('&')) {
				if (param === '') {
					continue;
				}

				let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

				// Missing `=` should be `null`:
				// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
				value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
				formatter(decode(key, options), value, ret);
			}

			for (const key of Object.keys(ret)) {
				const value = ret[key];
				if (typeof value === 'object' && value !== null) {
					for (const k of Object.keys(value)) {
						value[k] = parseValue(value[k], options);
					}
				} else {
					ret[key] = parseValue(value, options);
				}
			}

			if (options.sort === false) {
				return ret;
			}

			return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
				const value = ret[key];
				if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
					// Sort object keys, not values
					result[key] = keysSorter(value);
				} else {
					result[key] = value;
				}

				return result;
			}, Object.create(null));
		}

		exports.extract = extract;
		exports.parse = parse;

		exports.stringify = (object, options) => {
			if (!object) {
				return '';
			}

			options = Object.assign({
				encode: true,
				strict: true,
				arrayFormat: 'none',
				arrayFormatSeparator: ','
			}, options);

			validateArrayFormatSeparator(options.arrayFormatSeparator);

			const shouldFilter = key => (
				(options.skipNull && isNullOrUndefined(object[key])) ||
				(options.skipEmptyString && object[key] === '')
			);

			const formatter = encoderForArrayFormat(options);

			const objectCopy = {};

			for (const key of Object.keys(object)) {
				if (!shouldFilter(key)) {
					objectCopy[key] = object[key];
				}
			}

			const keys = Object.keys(objectCopy);

			if (options.sort !== false) {
				keys.sort(options.sort);
			}

			return keys.map(key => {
				const value = object[key];

				if (value === undefined) {
					return '';
				}

				if (value === null) {
					return encode(key, options);
				}

				if (Array.isArray(value)) {
					if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
						return encode(key, options) + '[]';
					}

					return value
						.reduce(formatter(key), [])
						.join('&');
				}

				return encode(key, options) + '=' + encode(value, options);
			}).filter(x => x.length > 0).join('&');
		};

		exports.parseUrl = (url, options) => {
			options = Object.assign({
				decode: true
			}, options);

			const [url_, hash] = splitOnFirst(url, '#');

			return Object.assign(
				{
					url: url_.split('?')[0] || '',
					query: parse(extract(url), options)
				},
				options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
			);
		};

		exports.stringifyUrl = (object, options) => {
			options = Object.assign({
				encode: true,
				strict: true,
				[encodeFragmentIdentifier]: true
			}, options);

			const url = removeHash(object.url).split('?')[0] || '';
			const queryFromUrl = exports.extract(object.url);
			const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

			const query = Object.assign(parsedQueryFromUrl, object.query);
			let queryString = exports.stringify(query, options);
			if (queryString) {
				queryString = `?${queryString}`;
			}

			let hash = getHash(object.url);
			if (object.fragmentIdentifier) {
				hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
			}

			return `${url}${queryString}${hash}`;
		};

		exports.pick = (input, filter, options) => {
			options = Object.assign({
				parseFragmentIdentifier: true,
				[encodeFragmentIdentifier]: false
			}, options);

			const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
			return exports.stringifyUrl({
				url,
				query: filterObject(query, filter),
				fragmentIdentifier
			}, options);
		};

		exports.exclude = (input, filter, options) => {
			const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

			return exports.pick(input, exclusionFilter, options);
		}; 
	} (queryString));
	return queryString;
}

var queryStringExports = requireQueryString();

const C$2={waku:{publish:"waku_publish",batchPublish:"waku_batchPublish",subscribe:"waku_subscribe",batchSubscribe:"waku_batchSubscribe",subscription:"waku_subscription",unsubscribe:"waku_unsubscribe",batchUnsubscribe:"waku_batchUnsubscribe",batchFetchMessages:"waku_batchFetchMessages"},irn:{publish:"irn_publish",batchPublish:"irn_batchPublish",subscribe:"irn_subscribe",batchSubscribe:"irn_batchSubscribe",subscription:"irn_subscription",unsubscribe:"irn_unsubscribe",batchUnsubscribe:"irn_batchUnsubscribe",batchFetchMessages:"irn_batchFetchMessages"},iridium:{publish:"iridium_publish",batchPublish:"iridium_batchPublish",subscribe:"iridium_subscribe",batchSubscribe:"iridium_batchSubscribe",subscription:"iridium_subscription",unsubscribe:"iridium_unsubscribe",batchUnsubscribe:"iridium_batchUnsubscribe",batchFetchMessages:"iridium_batchFetchMessages"}};

const K$3=":";function ve$2(e){const[n,t]=e.split(K$3);return {namespace:n,reference:t}}function Un$1(e,n=[]){const t=[];return Object.keys(e).forEach(r=>{if(n.length&&!n.includes(r))return;const o=e[r];t.push(...o.accounts);}),t}function L$4(e,n){return e.includes(":")?[e]:n.chains||[]}const J$3="base10",p$6="base16",F$4="base64pad",H$2="utf8",Q$5=0,_$4=1,Dn=0,Te$2=1,Z$1=12,X$2=32;function kn$1(){const e=x25519Exports.generateKeyPair();return {privateKey:toString$3(e.secretKey,p$6),publicKey:toString$3(e.publicKey,p$6)}}function Vn$2(){const e=randomExports.randomBytes(X$2);return toString$3(e,p$6)}function Mn$1(e,n){const t=x25519Exports.sharedKey(fromString(e,p$6),fromString(n,p$6),true),r=new hkdfExports.HKDF(sha256Exports.SHA256,t).expand(X$2);return toString$3(r,p$6)}function Kn$1(e){const n=sha256Exports.hash(fromString(e,p$6));return toString$3(n,p$6)}function Ln$1(e){const n=sha256Exports.hash(fromString(e,H$2));return toString$3(n,p$6)}function Pe$1(e){return fromString(`${e}`,J$3)}function j$6(e){return Number(toString$3(e,J$3))}function xn$1(e){const n=Pe$1(typeof e.type<"u"?e.type:Q$5);if(j$6(n)===_$4&&typeof e.senderPublicKey>"u")throw new Error("Missing sender public key for type 1 envelope");const t=typeof e.senderPublicKey<"u"?fromString(e.senderPublicKey,p$6):void 0,r=typeof e.iv<"u"?fromString(e.iv,p$6):randomExports.randomBytes(Z$1),o=new chacha20poly1305Exports.ChaCha20Poly1305(fromString(e.symKey,p$6)).seal(r,fromString(e.message,H$2));return Re$1({type:n,sealed:o,iv:r,senderPublicKey:t})}function Fn$1(e){const n=new chacha20poly1305Exports.ChaCha20Poly1305(fromString(e.symKey,p$6)),{sealed:t,iv:r}=ee$3(e.encoded),o=n.open(r,t);if(o===null)throw new Error("Failed to decrypt");return toString$3(o,H$2)}function Re$1(e){if(j$6(e.type)===_$4){if(typeof e.senderPublicKey>"u")throw new Error("Missing sender public key for type 1 envelope");return toString$3(concat([e.type,e.senderPublicKey,e.iv,e.sealed]),F$4)}return toString$3(concat([e.type,e.iv,e.sealed]),F$4)}function ee$3(e){const n=fromString(e,F$4),t=n.slice(Dn,Te$2),r=Te$2;if(j$6(t)===_$4){const d=r+X$2,l=d+Z$1,c=n.slice(r,d),u=n.slice(d,l),a=n.slice(l);return {type:t,sealed:a,iv:u,senderPublicKey:c}}const o=r+Z$1,s=n.slice(r,o),i=n.slice(o);return {type:t,sealed:i,iv:s}}function Hn$1(e,n){const t=ee$3(e);return Ae$2({type:j$6(t.type),senderPublicKey:typeof t.senderPublicKey<"u"?toString$3(t.senderPublicKey,p$6):void 0,receiverPublicKey:n?.receiverPublicKey})}function Ae$2(e){const n=e?.type||Q$5;if(n===_$4){if(typeof e?.senderPublicKey>"u")throw new Error("missing sender public key");if(typeof e?.receiverPublicKey>"u")throw new Error("missing receiver public key")}return {type:n,senderPublicKey:e?.senderPublicKey,receiverPublicKey:e?.receiverPublicKey}}function qn$1(e){return e.type===_$4&&typeof e.senderPublicKey=="string"&&typeof e.receiverPublicKey=="string"}var Bn$1=Object.defineProperty,Ue$2=Object.getOwnPropertySymbols,Gn$1=Object.prototype.hasOwnProperty,Wn$1=Object.prototype.propertyIsEnumerable,_e$2=(e,n,t)=>n in e?Bn$1(e,n,{enumerable:true,configurable:true,writable:true,value:t}):e[n]=t,$e$2=(e,n)=>{for(var t in n||(n={}))Gn$1.call(n,t)&&_e$2(e,t,n[t]);if(Ue$2)for(var t of Ue$2(n))Wn$1.call(n,t)&&_e$2(e,t,n[t]);return e};const Ce$2="ReactNative",m$3={reactNative:"react-native",node:"node",browser:"browser",unknown:"unknown"},De$3="js";function te$2(){return typeof process<"u"&&typeof process.versions<"u"&&typeof process.versions.node<"u"}function $$4(){return !cjsExports$3.getDocument()&&!!cjsExports$3.getNavigator()&&navigator.product===Ce$2}function D$6(){return !te$2()&&!!cjsExports$3.getNavigator()&&!!cjsExports$3.getDocument()}function R$3(){return $$4()?m$3.reactNative:te$2()?m$3.node:D$6()?m$3.browser:m$3.unknown}function Jn$1(){var e;try{return $$4()&&typeof global<"u"&&typeof(global==null?void 0:global.Application)<"u"?(e=global.Application)==null?void 0:e.applicationId:void 0}catch{return}}function ke$3(e,n){let t=queryStringExports.parse(e);return t=$e$2($e$2({},t),n),e=queryStringExports.stringify(t),e}function Qn$1(){return cjsExports$2.getWindowMetadata()||{name:"",description:"",url:"",icons:[""]}}function Ve$2(){if(R$3()===m$3.reactNative&&typeof global<"u"&&typeof(global==null?void 0:global.Platform)<"u"){const{OS:t,Version:r}=global.Platform;return [t,r].join("-")}const e=detect();if(e===null)return "unknown";const n=e.os?e.os.replace(" ","").toLowerCase():"unknown";return e.type==="browser"?[n,e.name,e.version].join("-"):[n,e.version].join("-")}function Me$2(){var e;const n=R$3();return n===m$3.browser?[n,((e=cjsExports$3.getLocation())==null?void 0:e.host)||"unknown"].join(":"):n}function Ke$2(e,n,t){const r=Ve$2(),o=Me$2();return [[e,n].join("-"),[De$3,t].join("-"),r,o].join("/")}function Xn$1({protocol:e,version:n,relayUrl:t,sdkVersion:r,auth:o,projectId:s,useOnCloseEvent:i,bundleId:d}){const l=t.split("?"),c=Ke$2(e,n,r),u={auth:o,ua:c,projectId:s,useOnCloseEvent:i,origin:d||void 0},a=ke$3(l[1]||"",u);return l[0]+"?"+a}function O$5(e,n){return e.filter(t=>n.includes(t)).length===e.length}function rt$2(e){return Object.fromEntries(e.entries())}function ot$1(e){return new Map(Object.entries(e))}function at$1(e=cjsExports$4.FIVE_MINUTES,n){const t=cjsExports$4.toMiliseconds(e||cjsExports$4.FIVE_MINUTES);let r,o,s;return {resolve:i=>{s&&r&&(clearTimeout(s),r(i));},reject:i=>{s&&o&&(clearTimeout(s),o(i));},done:()=>new Promise((i,d)=>{s=setTimeout(()=>{d(new Error(n));},t),r=i,o=d;})}}function ut$2(e,n,t){return new Promise(async(r,o)=>{const s=setTimeout(()=>o(new Error(t)),n);try{const i=await e;r(i);}catch(i){o(i);}clearTimeout(s);})}function re(e,n){if(typeof n=="string"&&n.startsWith(`${e}:`))return n;if(e.toLowerCase()==="topic"){if(typeof n!="string")throw new Error('Value must be "string" for expirer target type: topic');return `topic:${n}`}else if(e.toLowerCase()==="id"){if(typeof n!="number")throw new Error('Value must be "number" for expirer target type: id');return `id:${n}`}throw new Error(`Unknown expirer target type: ${e}`)}function lt$1(e){return re("topic",e)}function dt$2(e){return re("id",e)}function ft$3(e){const[n,t]=e.split(":"),r={id:void 0,topic:void 0};if(n==="topic"&&typeof t=="string")r.topic=t;else if(n==="id"&&Number.isInteger(Number(t)))r.id=Number(t);else throw new Error(`Invalid target, expected id:number or topic:string, got ${n}:${t}`);return r}function pt$1(e,n){return cjsExports$4.fromMiliseconds((Date.now())+cjsExports$4.toMiliseconds(e))}function mt$1(e){return Date.now()>=cjsExports$4.toMiliseconds(e)}function yt$2(e,n){return `${e}${n?`:${n}`:""}`}function S$4(e=[],n=[]){return [...new Set([...e,...n])]}async function gt$2({id:e,topic:n,wcDeepLink:t}){try{if(!t)return;const r=typeof t=="string"?JSON.parse(t):t;let o=r?.href;if(typeof o!="string")return;o.endsWith("/")&&(o=o.slice(0,-1));const s=`${o}/wc?requestId=${e}&sessionTopic=${n}`,i=R$3();i===m$3.browser?s.startsWith("https://")?window.open(s,"_blank","noreferrer noopener"):window.open(s,"_self","noreferrer noopener"):i===m$3.reactNative&&typeof(global==null?void 0:global.Linking)<"u"&&await global.Linking.openURL(s);}catch(r){console.error(r);}}async function ht$2(e,n){try{return await e.getItem(n)||(D$6()?localStorage.getItem(n):void 0)}catch(t){console.error(t);}}const He$2="irn";function vt$2(e){return e?.relay||{protocol:He$2}}function Et$2(e){const n=C$2[e];if(typeof n>"u")throw new Error(`Relay Protocol not supported: ${e}`);return n}var bt$2=Object.defineProperty,Nt$2=Object.defineProperties,Ot$2=Object.getOwnPropertyDescriptors,qe$2=Object.getOwnPropertySymbols,St$2=Object.prototype.hasOwnProperty,wt$2=Object.prototype.propertyIsEnumerable,Be$2=(e,n,t)=>n in e?bt$2(e,n,{enumerable:true,configurable:true,writable:true,value:t}):e[n]=t,It$2=(e,n)=>{for(var t in n||(n={}))St$2.call(n,t)&&Be$2(e,t,n[t]);if(qe$2)for(var t of qe$2(n))wt$2.call(n,t)&&Be$2(e,t,n[t]);return e},Tt$2=(e,n)=>Nt$2(e,Ot$2(n));function Ge$2(e,n="-"){const t={},r="relay"+n;return Object.keys(e).forEach(o=>{if(o.startsWith(r)){const s=o.replace(r,""),i=e[o];t[s]=i;}}),t}function Pt$2(e){e=e.includes("wc://")?e.replace("wc://",""):e,e=e.includes("wc:")?e.replace("wc:",""):e;const n=e.indexOf(":"),t=e.indexOf("?")!==-1?e.indexOf("?"):void 0,r=e.substring(0,n),o=e.substring(n+1,t).split("@"),s=typeof t<"u"?e.substring(t):"",i=queryStringExports.parse(s);return {protocol:r,topic:We$2(o[0]),version:parseInt(o[1],10),symKey:i.symKey,relay:Ge$2(i),expiryTimestamp:i.expiryTimestamp?parseInt(i.expiryTimestamp,10):void 0}}function We$2(e){return e.startsWith("//")?e.substring(2):e}function ze$2(e,n="-"){const t="relay",r={};return Object.keys(e).forEach(o=>{const s=t+n+o;e[o]&&(r[s]=e[o]);}),r}function Rt$2(e){return `${e.protocol}:${e.topic}@${e.version}?`+queryStringExports.stringify(Tt$2(It$2({symKey:e.symKey},ze$2(e.relay)),{expiryTimestamp:e.expiryTimestamp}))}function A$1(e){const n=[];return e.forEach(t=>{const[r,o]=t.split(":");n.push(`${r}:${o}`);}),n}function Qe$2(e){const n=[];return Object.values(e).forEach(t=>{n.push(...A$1(t.accounts));}),n}function Ze$2(e,n){const t=[];return Object.values(e).forEach(r=>{A$1(r.accounts).includes(n)&&t.push(...r.methods);}),t}function Xe$2(e,n){const t=[];return Object.values(e).forEach(r=>{A$1(r.accounts).includes(n)&&t.push(...r.events);}),t}function oe$1(e){return e.includes(":")}function en$2(e){return oe$1(e)?e.split(":")[0]:e}const nn={INVALID_METHOD:{message:"Invalid method.",code:1001},INVALID_EVENT:{message:"Invalid event.",code:1002},INVALID_UPDATE_REQUEST:{message:"Invalid update request.",code:1003},INVALID_EXTEND_REQUEST:{message:"Invalid extend request.",code:1004},INVALID_SESSION_SETTLE_REQUEST:{message:"Invalid session settle request.",code:1005},UNAUTHORIZED_METHOD:{message:"Unauthorized method.",code:3001},UNAUTHORIZED_EVENT:{message:"Unauthorized event.",code:3002},UNAUTHORIZED_UPDATE_REQUEST:{message:"Unauthorized update request.",code:3003},UNAUTHORIZED_EXTEND_REQUEST:{message:"Unauthorized extend request.",code:3004},USER_REJECTED:{message:"User rejected.",code:5e3},USER_REJECTED_CHAINS:{message:"User rejected chains.",code:5001},USER_REJECTED_METHODS:{message:"User rejected methods.",code:5002},USER_REJECTED_EVENTS:{message:"User rejected events.",code:5003},UNSUPPORTED_CHAINS:{message:"Unsupported chains.",code:5100},UNSUPPORTED_METHODS:{message:"Unsupported methods.",code:5101},UNSUPPORTED_EVENTS:{message:"Unsupported events.",code:5102},UNSUPPORTED_ACCOUNTS:{message:"Unsupported accounts.",code:5103},UNSUPPORTED_NAMESPACE_KEY:{message:"Unsupported namespace key.",code:5104},USER_DISCONNECTED:{message:"User disconnected.",code:6e3},SESSION_SETTLEMENT_FAILED:{message:"Session settlement failed.",code:7e3},WC_METHOD_UNSUPPORTED:{message:"Unsupported wc_ method.",code:10001}},tn={NOT_INITIALIZED:{message:"Not initialized.",code:1},NO_MATCHING_KEY:{message:"No matching key.",code:2},RESTORE_WILL_OVERRIDE:{message:"Restore will override.",code:3},RESUBSCRIBED:{message:"Resubscribed.",code:4},MISSING_OR_INVALID:{message:"Missing or invalid.",code:5},EXPIRED:{message:"Expired.",code:6},UNKNOWN_TYPE:{message:"Unknown type.",code:7},MISMATCHED_TOPIC:{message:"Mismatched topic.",code:8},NON_CONFORMING_NAMESPACES:{message:"Non conforming namespaces.",code:9}};function N$4(e,n){const{message:t,code:r}=tn[e];return {message:n?`${t} ${n}`:t,code:r}}function U$2(e,n){const{message:t,code:r}=nn[e];return {message:n?`${t} ${n}`:t,code:r}}function k$5(e,n){return Array.isArray(e)?true:false}function B$4(e){return Object.getPrototypeOf(e)===Object.prototype&&Object.keys(e).length}function w$7(e){return typeof e>"u"}function g$7(e,n){return n&&w$7(e)?true:typeof e=="string"&&!!e.trim().length}function G$2(e,n){return n&&w$7(e)?true:typeof e=="number"&&!isNaN(e)}function Mt$2(e,n){const{requiredNamespaces:t}=n,r=Object.keys(e.namespaces),o=Object.keys(t);let s=true;return O$5(o,r)?(r.forEach(i=>{const{accounts:d,methods:l,events:c}=e.namespaces[i],u=A$1(d),a=t[i];(!O$5(L$4(i,a),u)||!O$5(a.methods,l)||!O$5(a.events,c))&&(s=false);}),s):false}function V$2(e){return g$7(e,false)&&e.includes(":")?e.split(":").length===2:false}function rn$1(e){if(g$7(e,false)&&e.includes(":")){const n=e.split(":");if(n.length===3){const t=n[0]+":"+n[1];return !!n[2]&&V$2(t)}}return  false}function Kt$2(e){if(g$7(e,false))try{return typeof new URL(e)<"u"}catch{return  false}return  false}function Lt$2(e){var n;return (n=e?.proposer)==null?void 0:n.publicKey}function xt$2(e){return e?.topic}function Ft$2(e,n){let t=null;return g$7(e?.publicKey,false)||(t=N$4("MISSING_OR_INVALID",`${n} controller public key should be a string`)),t}function ie$1(e){let n=true;return k$5(e)?e.length&&(n=e.every(t=>g$7(t,false))):n=false,n}function on$1(e,n,t){let r=null;return k$5(n)&&n.length?n.forEach(o=>{r||V$2(o)||(r=U$2("UNSUPPORTED_CHAINS",`${t}, chain ${o} should be a string and conform to "namespace:chainId" format`));}):V$2(e)||(r=U$2("UNSUPPORTED_CHAINS",`${t}, chains must be defined as "namespace:chainId" e.g. "eip155:1": {...} in the namespace key OR as an array of CAIP-2 chainIds e.g. eip155: { chains: ["eip155:1", "eip155:5"] }`)),r}function sn(e,n,t){let r=null;return Object.entries(e).forEach(([o,s])=>{if(r)return;const i=on$1(o,L$4(o,s),`${n} ${t}`);i&&(r=i);}),r}function cn(e,n){let t=null;return k$5(e)?e.forEach(r=>{t||rn$1(r)||(t=U$2("UNSUPPORTED_ACCOUNTS",`${n}, account ${r} should be a string and conform to "namespace:chainId:address" format`));}):t=U$2("UNSUPPORTED_ACCOUNTS",`${n}, accounts should be an array of strings conforming to "namespace:chainId:address" format`),t}function an(e,n){let t=null;return Object.values(e).forEach(r=>{if(t)return;const o=cn(r?.accounts,`${n} namespace`);o&&(t=o);}),t}function un(e,n){let t=null;return ie$1(e?.methods)?ie$1(e?.events)||(t=U$2("UNSUPPORTED_EVENTS",`${n}, events should be an array of strings or empty array for no events`)):t=U$2("UNSUPPORTED_METHODS",`${n}, methods should be an array of strings or empty array for no methods`),t}function ce$3(e,n){let t=null;return Object.values(e).forEach(r=>{if(t)return;const o=un(r,`${n}, namespace`);o&&(t=o);}),t}function Ht$2(e,n,t){let r=null;if(e&&B$4(e)){const o=ce$3(e,n);o&&(r=o);const s=sn(e,n,t);s&&(r=s);}else r=N$4("MISSING_OR_INVALID",`${n}, ${t} should be an object with data`);return r}function ln(e,n){let t=null;if(e&&B$4(e)){const r=ce$3(e,n);r&&(t=r);const o=an(e,n);o&&(t=o);}else t=N$4("MISSING_OR_INVALID",`${n}, namespaces should be an object with data`);return t}function dn(e){return g$7(e.protocol,true)}function qt$2(e,n){let t=false;return !e?t=true:e&&k$5(e)&&e.length&&e.forEach(r=>{t=dn(r);}),t}function Bt$2(e){return typeof e=="number"}function Gt$2(e){return typeof e<"u"&&typeof e!==null}function Wt$1(e){return !(!e||typeof e!="object"||!e.code||!G$2(e.code,false)||!e.message||!g$7(e.message,false))}function zt$2(e){return !(w$7(e)||!g$7(e.method,false))}function Yt$2(e){return !(w$7(e)||w$7(e.result)&&w$7(e.error)||!G$2(e.id,false)||!g$7(e.jsonrpc,false))}function Jt$2(e){return !(w$7(e)||!g$7(e.name,false))}function Qt$1(e,n){return !(!V$2(n)||!Qe$2(e).includes(n))}function Zt$1(e,n,t){return g$7(t,false)?Ze$2(e,n).includes(t):false}function Xt$1(e,n,t){return g$7(t,false)?Xe$2(e,n).includes(t):false}function fn(e,n,t){let r=null;const o=er$2(e),s=nr$2(n),i=Object.keys(o),d=Object.keys(s),l=pn(Object.keys(e)),c=pn(Object.keys(n)),u=l.filter(a=>!c.includes(a));return u.length&&(r=N$4("NON_CONFORMING_NAMESPACES",`${t} namespaces keys don't satisfy requiredNamespaces.
      Required: ${u.toString()}
      Received: ${Object.keys(n).toString()}`)),O$5(i,d)||(r=N$4("NON_CONFORMING_NAMESPACES",`${t} namespaces chains don't satisfy required namespaces.
      Required: ${i.toString()}
      Approved: ${d.toString()}`)),Object.keys(n).forEach(a=>{if(!a.includes(":")||r)return;const b=A$1(n[a].accounts);b.includes(a)||(r=N$4("NON_CONFORMING_NAMESPACES",`${t} namespaces accounts don't satisfy namespace accounts for ${a}
        Required: ${a}
        Approved: ${b.toString()}`));}),i.forEach(a=>{r||(O$5(o[a].methods,s[a].methods)?O$5(o[a].events,s[a].events)||(r=N$4("NON_CONFORMING_NAMESPACES",`${t} namespaces events don't satisfy namespace events for ${a}`)):r=N$4("NON_CONFORMING_NAMESPACES",`${t} namespaces methods don't satisfy namespace methods for ${a}`));}),r}function er$2(e){const n={};return Object.keys(e).forEach(t=>{var r;t.includes(":")?n[t]=e[t]:(r=e[t].chains)==null||r.forEach(o=>{n[o]={methods:e[t].methods,events:e[t].events};});}),n}function pn(e){return [...new Set(e.map(n=>n.includes(":")?n.split(":")[0]:n))]}function nr$2(e){const n={};return Object.keys(e).forEach(t=>{if(t.includes(":"))n[t]=e[t];else {const r=A$1(e[t].accounts);r?.forEach(o=>{n[o]={accounts:e[t].accounts.filter(s=>s.includes(`${o}:`)),methods:e[t].methods,events:e[t].events};});}}),n}function tr$2(e,n){return G$2(e,false)&&e<=n.max&&e>=n.min}function rr$2(){const e=R$3();return new Promise(n=>{switch(e){case m$3.browser:n(mn$1());break;case m$3.reactNative:n(yn$1());break;case m$3.node:n(gn$1());break;default:n(true);}})}function mn$1(){return D$6()&&navigator?.onLine}async function yn$1(){if($$4()&&typeof global<"u"&&global!=null&&global.NetInfo){const e=await(global==null?void 0:global.NetInfo.fetch());return e?.isConnected}return  true}function gn$1(){return  true}function or$2(e){switch(R$3()){case m$3.browser:hn(e);break;case m$3.reactNative:vn$1(e);break;}}function hn(e){!$$4()&&D$6()&&(window.addEventListener("online",()=>e(true)),window.addEventListener("offline",()=>e(false)));}function vn$1(e){$$4()&&typeof global<"u"&&global!=null&&global.NetInfo&&global?.NetInfo.addEventListener(n=>e(n?.isConnected));}const ae$2={};let sr$2 = class sr{static get(n){return ae$2[n]}static set(n,t){ae$2[n]=t;}static delete(n){delete ae$2[n];}};

const suspectProtoRx = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/;
const suspectConstructorRx = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/;
const JsonSigRx = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function jsonParseTransform(key, value) {
  if (key === "__proto__" || key === "constructor" && value && typeof value === "object" && "prototype" in value) {
    warnKeyDropped(key);
    return;
  }
  return value;
}
function warnKeyDropped(key) {
  console.warn(`[destr] Dropping "${key}" key to prevent prototype pollution.`);
}
function destr(value, options = {}) {
  if (typeof value !== "string") {
    return value;
  }
  const _value = value.trim();
  if (
    // eslint-disable-next-line unicorn/prefer-at
    value[0] === '"' && value.endsWith('"') && !value.includes("\\")
  ) {
    return _value.slice(1, -1);
  }
  if (_value.length <= 9) {
    const _lval = _value.toLowerCase();
    if (_lval === "true") {
      return true;
    }
    if (_lval === "false") {
      return false;
    }
    if (_lval === "undefined") {
      return void 0;
    }
    if (_lval === "null") {
      return null;
    }
    if (_lval === "nan") {
      return Number.NaN;
    }
    if (_lval === "infinity") {
      return Number.POSITIVE_INFINITY;
    }
    if (_lval === "-infinity") {
      return Number.NEGATIVE_INFINITY;
    }
  }
  if (!JsonSigRx.test(value)) {
    if (options.strict) {
      throw new SyntaxError("[destr] Invalid JSON");
    }
    return value;
  }
  try {
    if (suspectProtoRx.test(value) || suspectConstructorRx.test(value)) {
      if (options.strict) {
        throw new Error("[destr] Possible prototype pollution");
      }
      return JSON.parse(value, jsonParseTransform);
    }
    return JSON.parse(value);
  } catch (error) {
    if (options.strict) {
      throw error;
    }
    return value;
  }
}

function wrapToPromise(value) {
  if (!value || typeof value.then !== "function") {
    return Promise.resolve(value);
  }
  return value;
}
function asyncCall(function_, ...arguments_) {
  try {
    return wrapToPromise(function_(...arguments_));
  } catch (error) {
    return Promise.reject(error);
  }
}
function isPrimitive(value) {
  const type = typeof value;
  return value === null || type !== "object" && type !== "function";
}
function isPureObject(value) {
  const proto = Object.getPrototypeOf(value);
  return !proto || proto.isPrototypeOf(Object);
}
function stringify(value) {
  if (isPrimitive(value)) {
    return String(value);
  }
  if (isPureObject(value) || Array.isArray(value)) {
    return JSON.stringify(value);
  }
  if (typeof value.toJSON === "function") {
    return stringify(value.toJSON());
  }
  throw new Error("[unstorage] Cannot stringify value!");
}
const BASE64_PREFIX = "base64:";
function serializeRaw(value) {
  if (typeof value === "string") {
    return value;
  }
  return BASE64_PREFIX + base64Encode(value);
}
function deserializeRaw(value) {
  if (typeof value !== "string") {
    return value;
  }
  if (!value.startsWith(BASE64_PREFIX)) {
    return value;
  }
  return base64Decode(value.slice(BASE64_PREFIX.length));
}
function base64Decode(input) {
  if (globalThis.Buffer) {
    return Buffer.from(input, "base64");
  }
  return Uint8Array.from(
    globalThis.atob(input),
    (c) => c.codePointAt(0)
  );
}
function base64Encode(input) {
  if (globalThis.Buffer) {
    return Buffer.from(input).toString("base64");
  }
  return globalThis.btoa(String.fromCodePoint(...input));
}
function normalizeKey(key) {
  if (!key) {
    return "";
  }
  return key.split("?")[0]?.replace(/[/\\]/g, ":").replace(/:+/g, ":").replace(/^:|:$/g, "") || "";
}
function joinKeys(...keys) {
  return normalizeKey(keys.join(":"));
}
function normalizeBaseKey(base) {
  base = normalizeKey(base);
  return base ? base + ":" : "";
}

function defineDriver(factory) {
  return factory;
}

const DRIVER_NAME = "memory";
const memory = defineDriver(() => {
  const data = /* @__PURE__ */ new Map();
  return {
    name: DRIVER_NAME,
    getInstance: () => data,
    hasItem(key) {
      return data.has(key);
    },
    getItem(key) {
      return data.get(key) ?? null;
    },
    getItemRaw(key) {
      return data.get(key) ?? null;
    },
    setItem(key, value) {
      data.set(key, value);
    },
    setItemRaw(key, value) {
      data.set(key, value);
    },
    removeItem(key) {
      data.delete(key);
    },
    getKeys() {
      return [...data.keys()];
    },
    clear() {
      data.clear();
    },
    dispose() {
      data.clear();
    }
  };
});

function createStorage(options = {}) {
  const context = {
    mounts: { "": options.driver || memory() },
    mountpoints: [""],
    watching: false,
    watchListeners: [],
    unwatch: {}
  };
  const getMount = (key) => {
    for (const base of context.mountpoints) {
      if (key.startsWith(base)) {
        return {
          base,
          relativeKey: key.slice(base.length),
          driver: context.mounts[base]
        };
      }
    }
    return {
      base: "",
      relativeKey: key,
      driver: context.mounts[""]
    };
  };
  const getMounts = (base, includeParent) => {
    return context.mountpoints.filter(
      (mountpoint) => mountpoint.startsWith(base) || includeParent && base.startsWith(mountpoint)
    ).map((mountpoint) => ({
      relativeBase: base.length > mountpoint.length ? base.slice(mountpoint.length) : void 0,
      mountpoint,
      driver: context.mounts[mountpoint]
    }));
  };
  const onChange = (event, key) => {
    if (!context.watching) {
      return;
    }
    key = normalizeKey(key);
    for (const listener of context.watchListeners) {
      listener(event, key);
    }
  };
  const startWatch = async () => {
    if (context.watching) {
      return;
    }
    context.watching = true;
    for (const mountpoint in context.mounts) {
      context.unwatch[mountpoint] = await watch(
        context.mounts[mountpoint],
        onChange,
        mountpoint
      );
    }
  };
  const stopWatch = async () => {
    if (!context.watching) {
      return;
    }
    for (const mountpoint in context.unwatch) {
      await context.unwatch[mountpoint]();
    }
    context.unwatch = {};
    context.watching = false;
  };
  const runBatch = (items, commonOptions, cb) => {
    const batches = /* @__PURE__ */ new Map();
    const getBatch = (mount) => {
      let batch = batches.get(mount.base);
      if (!batch) {
        batch = {
          driver: mount.driver,
          base: mount.base,
          items: []
        };
        batches.set(mount.base, batch);
      }
      return batch;
    };
    for (const item of items) {
      const isStringItem = typeof item === "string";
      const key = normalizeKey(isStringItem ? item : item.key);
      const value = isStringItem ? void 0 : item.value;
      const options2 = isStringItem || !item.options ? commonOptions : { ...commonOptions, ...item.options };
      const mount = getMount(key);
      getBatch(mount).items.push({
        key,
        value,
        relativeKey: mount.relativeKey,
        options: options2
      });
    }
    return Promise.all([...batches.values()].map((batch) => cb(batch))).then(
      (r) => r.flat()
    );
  };
  const storage = {
    // Item
    hasItem(key, opts = {}) {
      key = normalizeKey(key);
      const { relativeKey, driver } = getMount(key);
      return asyncCall(driver.hasItem, relativeKey, opts);
    },
    getItem(key, opts = {}) {
      key = normalizeKey(key);
      const { relativeKey, driver } = getMount(key);
      return asyncCall(driver.getItem, relativeKey, opts).then(
        (value) => destr(value)
      );
    },
    getItems(items, commonOptions = {}) {
      return runBatch(items, commonOptions, (batch) => {
        if (batch.driver.getItems) {
          return asyncCall(
            batch.driver.getItems,
            batch.items.map((item) => ({
              key: item.relativeKey,
              options: item.options
            })),
            commonOptions
          ).then(
            (r) => r.map((item) => ({
              key: joinKeys(batch.base, item.key),
              value: destr(item.value)
            }))
          );
        }
        return Promise.all(
          batch.items.map((item) => {
            return asyncCall(
              batch.driver.getItem,
              item.relativeKey,
              item.options
            ).then((value) => ({
              key: item.key,
              value: destr(value)
            }));
          })
        );
      });
    },
    getItemRaw(key, opts = {}) {
      key = normalizeKey(key);
      const { relativeKey, driver } = getMount(key);
      if (driver.getItemRaw) {
        return asyncCall(driver.getItemRaw, relativeKey, opts);
      }
      return asyncCall(driver.getItem, relativeKey, opts).then(
        (value) => deserializeRaw(value)
      );
    },
    async setItem(key, value, opts = {}) {
      if (value === void 0) {
        return storage.removeItem(key);
      }
      key = normalizeKey(key);
      const { relativeKey, driver } = getMount(key);
      if (!driver.setItem) {
        return;
      }
      await asyncCall(driver.setItem, relativeKey, stringify(value), opts);
      if (!driver.watch) {
        onChange("update", key);
      }
    },
    async setItems(items, commonOptions) {
      await runBatch(items, commonOptions, async (batch) => {
        if (batch.driver.setItems) {
          return asyncCall(
            batch.driver.setItems,
            batch.items.map((item) => ({
              key: item.relativeKey,
              value: stringify(item.value),
              options: item.options
            })),
            commonOptions
          );
        }
        if (!batch.driver.setItem) {
          return;
        }
        await Promise.all(
          batch.items.map((item) => {
            return asyncCall(
              batch.driver.setItem,
              item.relativeKey,
              stringify(item.value),
              item.options
            );
          })
        );
      });
    },
    async setItemRaw(key, value, opts = {}) {
      if (value === void 0) {
        return storage.removeItem(key, opts);
      }
      key = normalizeKey(key);
      const { relativeKey, driver } = getMount(key);
      if (driver.setItemRaw) {
        await asyncCall(driver.setItemRaw, relativeKey, value, opts);
      } else if (driver.setItem) {
        await asyncCall(driver.setItem, relativeKey, serializeRaw(value), opts);
      } else {
        return;
      }
      if (!driver.watch) {
        onChange("update", key);
      }
    },
    async removeItem(key, opts = {}) {
      if (typeof opts === "boolean") {
        opts = { removeMeta: opts };
      }
      key = normalizeKey(key);
      const { relativeKey, driver } = getMount(key);
      if (!driver.removeItem) {
        return;
      }
      await asyncCall(driver.removeItem, relativeKey, opts);
      if (opts.removeMeta || opts.removeMata) {
        await asyncCall(driver.removeItem, relativeKey + "$", opts);
      }
      if (!driver.watch) {
        onChange("remove", key);
      }
    },
    // Meta
    async getMeta(key, opts = {}) {
      if (typeof opts === "boolean") {
        opts = { nativeOnly: opts };
      }
      key = normalizeKey(key);
      const { relativeKey, driver } = getMount(key);
      const meta = /* @__PURE__ */ Object.create(null);
      if (driver.getMeta) {
        Object.assign(meta, await asyncCall(driver.getMeta, relativeKey, opts));
      }
      if (!opts.nativeOnly) {
        const value = await asyncCall(
          driver.getItem,
          relativeKey + "$",
          opts
        ).then((value_) => destr(value_));
        if (value && typeof value === "object") {
          if (typeof value.atime === "string") {
            value.atime = new Date(value.atime);
          }
          if (typeof value.mtime === "string") {
            value.mtime = new Date(value.mtime);
          }
          Object.assign(meta, value);
        }
      }
      return meta;
    },
    setMeta(key, value, opts = {}) {
      return this.setItem(key + "$", value, opts);
    },
    removeMeta(key, opts = {}) {
      return this.removeItem(key + "$", opts);
    },
    // Keys
    async getKeys(base, opts = {}) {
      base = normalizeBaseKey(base);
      const mounts = getMounts(base, true);
      let maskedMounts = [];
      const allKeys = [];
      for (const mount of mounts) {
        const rawKeys = await asyncCall(
          mount.driver.getKeys,
          mount.relativeBase,
          opts
        );
        for (const key of rawKeys) {
          const fullKey = mount.mountpoint + normalizeKey(key);
          if (!maskedMounts.some((p) => fullKey.startsWith(p))) {
            allKeys.push(fullKey);
          }
        }
        maskedMounts = [
          mount.mountpoint,
          ...maskedMounts.filter((p) => !p.startsWith(mount.mountpoint))
        ];
      }
      return base ? allKeys.filter(
        (key) => key.startsWith(base) && key[key.length - 1] !== "$"
      ) : allKeys.filter((key) => key[key.length - 1] !== "$");
    },
    // Utils
    async clear(base, opts = {}) {
      base = normalizeBaseKey(base);
      await Promise.all(
        getMounts(base, false).map(async (m) => {
          if (m.driver.clear) {
            return asyncCall(m.driver.clear, m.relativeBase, opts);
          }
          if (m.driver.removeItem) {
            const keys = await m.driver.getKeys(m.relativeBase || "", opts);
            return Promise.all(
              keys.map((key) => m.driver.removeItem(key, opts))
            );
          }
        })
      );
    },
    async dispose() {
      await Promise.all(
        Object.values(context.mounts).map((driver) => dispose(driver))
      );
    },
    async watch(callback) {
      await startWatch();
      context.watchListeners.push(callback);
      return async () => {
        context.watchListeners = context.watchListeners.filter(
          (listener) => listener !== callback
        );
        if (context.watchListeners.length === 0) {
          await stopWatch();
        }
      };
    },
    async unwatch() {
      context.watchListeners = [];
      await stopWatch();
    },
    // Mount
    mount(base, driver) {
      base = normalizeBaseKey(base);
      if (base && context.mounts[base]) {
        throw new Error(`already mounted at ${base}`);
      }
      if (base) {
        context.mountpoints.push(base);
        context.mountpoints.sort((a, b) => b.length - a.length);
      }
      context.mounts[base] = driver;
      if (context.watching) {
        Promise.resolve(watch(driver, onChange, base)).then((unwatcher) => {
          context.unwatch[base] = unwatcher;
        }).catch(console.error);
      }
      return storage;
    },
    async unmount(base, _dispose = true) {
      base = normalizeBaseKey(base);
      if (!base || !context.mounts[base]) {
        return;
      }
      if (context.watching && base in context.unwatch) {
        context.unwatch[base]?.();
        delete context.unwatch[base];
      }
      if (_dispose) {
        await dispose(context.mounts[base]);
      }
      context.mountpoints = context.mountpoints.filter((key) => key !== base);
      delete context.mounts[base];
    },
    getMount(key = "") {
      key = normalizeKey(key) + ":";
      const m = getMount(key);
      return {
        driver: m.driver,
        base: m.base
      };
    },
    getMounts(base = "", opts = {}) {
      base = normalizeKey(base);
      const mounts = getMounts(base, opts.parents);
      return mounts.map((m) => ({
        driver: m.driver,
        base: m.mountpoint
      }));
    },
    // Aliases
    keys: (base, opts = {}) => storage.getKeys(base, opts),
    get: (key, opts = {}) => storage.getItem(key, opts),
    set: (key, value, opts = {}) => storage.setItem(key, value, opts),
    has: (key, opts = {}) => storage.hasItem(key, opts),
    del: (key, opts = {}) => storage.removeItem(key, opts),
    remove: (key, opts = {}) => storage.removeItem(key, opts)
  };
  return storage;
}
function watch(driver, onChange, base) {
  return driver.watch ? driver.watch((event, key) => onChange(event, base + key)) : () => {
  };
}
async function dispose(driver) {
  if (typeof driver.dispose === "function") {
    await asyncCall(driver.dispose);
  }
}

function promisifyRequest(request) {
    return new Promise((resolve, reject) => {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = () => resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = () => reject(request.error);
    });
}
function createStore$1(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = () => request.result.createObjectStore(storeName);
    const dbp = promisifyRequest(request);
    return (txMode, callback) => dbp.then((db) => callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let defaultGetStoreFunc;
function defaultGetStore() {
    if (!defaultGetStoreFunc) {
        defaultGetStoreFunc = createStore$1('keyval-store', 'keyval');
    }
    return defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function get$2(key, customStore = defaultGetStore()) {
    return customStore('readonly', (store) => promisifyRequest(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function set$1(key, value, customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        store.put(value, key);
        return promisifyRequest(store.transaction);
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function del(key, customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        store.delete(key);
        return promisifyRequest(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function clear(customStore = defaultGetStore()) {
    return customStore('readwrite', (store) => {
        store.clear();
        return promisifyRequest(store.transaction);
    });
}
function eachCursor(store, callback) {
    store.openCursor().onsuccess = function () {
        if (!this.result)
            return;
        callback(this.result);
        this.result.continue();
    };
    return promisifyRequest(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */
function keys$2(customStore = defaultGetStore()) {
    return customStore('readonly', (store) => {
        // Fast path for modern browsers
        if (store.getAllKeys) {
            return promisifyRequest(store.getAllKeys());
        }
        const items = [];
        return eachCursor(store, (cursor) => items.push(cursor.key)).then(() => items);
    });
}

const JSONStringify = data => JSON.stringify(data, (_, value) => typeof value === "bigint" ? value.toString() + "n" : value);
const JSONParse = json => {
    const numbersBiggerThanMaxInt = /([\[:])?(\d{17,}|(?:[9](?:[1-9]07199254740991|0[1-9]7199254740991|00[8-9]199254740991|007[2-9]99254740991|007199[3-9]54740991|0071992[6-9]4740991|00719925[5-9]740991|007199254[8-9]40991|0071992547[5-9]0991|00719925474[1-9]991|00719925474099[2-9])))([,\}\]])/g;
    const serializedData = json.replace(numbersBiggerThanMaxInt, "$1\"$2n\"$3");
    return JSON.parse(serializedData, (_, value) => {
        const isCustomFormatBigInt = typeof value === "string" && value.match(/^\d+n$/);
        if (isCustomFormatBigInt)
            return BigInt(value.substring(0, value.length - 1));
        return value;
    });
};
function safeJsonParse$1(value) {
    if (typeof value !== "string") {
        throw new Error(`Cannot safe json parse value of type ${typeof value}`);
    }
    try {
        return JSONParse(value);
    }
    catch (_a) {
        return value;
    }
}
function safeJsonStringify(value) {
    return typeof value === "string" ? value : JSONStringify(value) || "";
}

const x$3="idb-keyval";var z$5=(i={})=>{const t=i.base&&i.base.length>0?`${i.base}:`:"",e=s=>t+s;let n;return i.dbName&&i.storeName&&(n=createStore$1(i.dbName,i.storeName)),{name:x$3,options:i,async hasItem(s){return !(typeof await get$2(e(s),n)>"u")},async getItem(s){return await get$2(e(s),n)??null},setItem(s,a){return set$1(e(s),a,n)},removeItem(s){return del(e(s),n)},getKeys(){return keys$2(n)},clear(){return clear(n)}}};const D$5="WALLET_CONNECT_V2_INDEXED_DB",E$5="keyvaluestorage";let _$3 = class _{constructor(){this.indexedDb=createStorage({driver:z$5({dbName:D$5,storeName:E$5})});}async getKeys(){return this.indexedDb.getKeys()}async getEntries(){return (await this.indexedDb.getItems(await this.indexedDb.getKeys())).map(t=>[t.key,t.value])}async getItem(t){const e=await this.indexedDb.getItem(t);if(e!==null)return e}async setItem(t,e){await this.indexedDb.setItem(t,safeJsonStringify(e));}async removeItem(t){await this.indexedDb.removeItem(t);}};var l$3=typeof globalThis<"u"?globalThis:typeof window<"u"?window:typeof global<"u"?global:typeof self<"u"?self:{},c$4={exports:{}};(function(){let i;function t(){}i=t,i.prototype.getItem=function(e){return this.hasOwnProperty(e)?String(this[e]):null},i.prototype.setItem=function(e,n){this[e]=String(n);},i.prototype.removeItem=function(e){delete this[e];},i.prototype.clear=function(){const e=this;Object.keys(e).forEach(function(n){e[n]=void 0,delete e[n];});},i.prototype.key=function(e){return e=e||0,Object.keys(this)[e]},i.prototype.__defineGetter__("length",function(){return Object.keys(this).length}),typeof l$3<"u"&&l$3.localStorage?c$4.exports=l$3.localStorage:typeof window<"u"&&window.localStorage?c$4.exports=window.localStorage:c$4.exports=new t;})();function k$4(i){var t;return [i[0],safeJsonParse$1((t=i[1])!=null?t:"")]}let K$2 = class K{constructor(){this.localStorage=c$4.exports;}async getKeys(){return Object.keys(this.localStorage)}async getEntries(){return Object.entries(this.localStorage).map(k$4)}async getItem(t){const e=this.localStorage.getItem(t);if(e!==null)return safeJsonParse$1(e)}async setItem(t,e){this.localStorage.setItem(t,safeJsonStringify(e));}async removeItem(t){this.localStorage.removeItem(t);}};const N$3="wc_storage_version",y$5=1,O$4=async(i,t,e)=>{const n=N$3,s=await t.getItem(n);if(s&&s>=y$5){e(t);return}const a=await i.getKeys();if(!a.length){e(t);return}const m=[];for(;a.length;){const r=a.shift();if(!r)continue;const o=r.toLowerCase();if(o.includes("wc@")||o.includes("walletconnect")||o.includes("wc_")||o.includes("wallet_connect")){const f=await i.getItem(r);await t.setItem(r,f),m.push(r);}}await t.setItem(n,y$5),e(t),j$5(i,m);},j$5=async(i,t)=>{t.length&&t.forEach(async e=>{await i.removeItem(e);});};let h$3 = class h{constructor(){this.initialized=false,this.setInitialized=e=>{this.storage=e,this.initialized=true;};const t=new K$2;this.storage=t;try{const e=new _$3;O$4(t,e,this.setInitialized);}catch{this.initialized=true;}}async getKeys(){return await this.initialize(),this.storage.getKeys()}async getEntries(){return await this.initialize(),this.storage.getEntries()}async getItem(t){return await this.initialize(),this.storage.getItem(t)}async setItem(t,e){return await this.initialize(),this.storage.setItem(t,e)}async removeItem(t){return await this.initialize(),this.storage.removeItem(t)}async initialize(){this.initialized||await new Promise(t=>{const e=setInterval(()=>{this.initialized&&(clearInterval(e),t());},20);});}};

var cjs$1 = {};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$2 = function(d, b) {
    extendStatics$2 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$2(d, b);
};

function __extends$2(d, b) {
    extendStatics$2(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __rest$3(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate$1(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param$1(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata$1(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter$6(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator$1(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding$1(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar$1(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values$2(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read$2(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread$1() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read$2(arguments[i]));
    return ar;
}

function __spreadArrays$1() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}
function __await$1(v) {
    return this instanceof __await$1 ? (this.v = v, this) : new __await$1(v);
}

function __asyncGenerator$1(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await$1 ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator$1(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await$1(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues$1(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values$2 === "function" ? __values$2(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject$1(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
function __importStar$1(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault$1(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet$2(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet$2(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

var tslib_es6$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	get __assign () { return __assign$2; },
	__asyncDelegator: __asyncDelegator$1,
	__asyncGenerator: __asyncGenerator$1,
	__asyncValues: __asyncValues$1,
	__await: __await$1,
	__awaiter: __awaiter$6,
	__classPrivateFieldGet: __classPrivateFieldGet$2,
	__classPrivateFieldSet: __classPrivateFieldSet$2,
	__createBinding: __createBinding$1,
	__decorate: __decorate$1,
	__exportStar: __exportStar$1,
	__extends: __extends$2,
	__generator: __generator$1,
	__importDefault: __importDefault$1,
	__importStar: __importStar$1,
	__makeTemplateObject: __makeTemplateObject$1,
	__metadata: __metadata$1,
	__param: __param$1,
	__read: __read$2,
	__rest: __rest$3,
	__spread: __spread$1,
	__spreadArrays: __spreadArrays$1,
	__values: __values$2
});

var require$$0$4 = /*@__PURE__*/getAugmentedNamespace(tslib_es6$1);

var heartbeat$2 = {};

var types = {};

var heartbeat$1 = {};

class IEvents {
}

var esm = /*#__PURE__*/Object.freeze({
	__proto__: null,
	IEvents: IEvents
});

var require$$0$3 = /*@__PURE__*/getAugmentedNamespace(esm);

var hasRequiredHeartbeat$2;

function requireHeartbeat$2 () {
	if (hasRequiredHeartbeat$2) return heartbeat$1;
	hasRequiredHeartbeat$2 = 1;
	Object.defineProperty(heartbeat$1, "__esModule", { value: true });
	heartbeat$1.IHeartBeat = void 0;
	const events_1 = require$$0$3;
	class IHeartBeat extends events_1.IEvents {
	    constructor(opts) {
	        super();
	    }
	}
	heartbeat$1.IHeartBeat = IHeartBeat;
	
	return heartbeat$1;
}

var hasRequiredTypes;

function requireTypes () {
	if (hasRequiredTypes) return types;
	hasRequiredTypes = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		const tslib_1 = require$$0$4;
		tslib_1.__exportStar(requireHeartbeat$2(), exports);
		
	} (types));
	return types;
}

var constants = {};

var heartbeat = {};

var hasRequiredHeartbeat$1;

function requireHeartbeat$1 () {
	if (hasRequiredHeartbeat$1) return heartbeat;
	hasRequiredHeartbeat$1 = 1;
	Object.defineProperty(heartbeat, "__esModule", { value: true });
	heartbeat.HEARTBEAT_EVENTS = heartbeat.HEARTBEAT_INTERVAL = void 0;
	const time_1 = requireCjs$4();
	heartbeat.HEARTBEAT_INTERVAL = time_1.FIVE_SECONDS;
	heartbeat.HEARTBEAT_EVENTS = {
	    pulse: "heartbeat_pulse",
	};
	
	return heartbeat;
}

var hasRequiredConstants;

function requireConstants () {
	if (hasRequiredConstants) return constants;
	hasRequiredConstants = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		const tslib_1 = require$$0$4;
		tslib_1.__exportStar(requireHeartbeat$1(), exports);
		
	} (constants));
	return constants;
}

var hasRequiredHeartbeat;

function requireHeartbeat () {
	if (hasRequiredHeartbeat) return heartbeat$2;
	hasRequiredHeartbeat = 1;
	Object.defineProperty(heartbeat$2, "__esModule", { value: true });
	heartbeat$2.HeartBeat = void 0;
	const tslib_1 = require$$0$4;
	const events_1 = require$$1$1;
	const time_1 = requireCjs$4();
	const types_1 = requireTypes();
	const constants_1 = requireConstants();
	class HeartBeat extends types_1.IHeartBeat {
	    constructor(opts) {
	        super(opts);
	        this.events = new events_1.EventEmitter();
	        this.interval = constants_1.HEARTBEAT_INTERVAL;
	        this.interval = (opts === null || opts === void 0 ? void 0 : opts.interval) || constants_1.HEARTBEAT_INTERVAL;
	    }
	    static init(opts) {
	        return tslib_1.__awaiter(this, void 0, void 0, function* () {
	            const heartbeat = new HeartBeat(opts);
	            yield heartbeat.init();
	            return heartbeat;
	        });
	    }
	    init() {
	        return tslib_1.__awaiter(this, void 0, void 0, function* () {
	            yield this.initialize();
	        });
	    }
	    stop() {
	        clearInterval(this.intervalRef);
	    }
	    on(event, listener) {
	        this.events.on(event, listener);
	    }
	    once(event, listener) {
	        this.events.once(event, listener);
	    }
	    off(event, listener) {
	        this.events.off(event, listener);
	    }
	    removeListener(event, listener) {
	        this.events.removeListener(event, listener);
	    }
	    initialize() {
	        return tslib_1.__awaiter(this, void 0, void 0, function* () {
	            this.intervalRef = setInterval(() => this.pulse(), time_1.toMiliseconds(this.interval));
	        });
	    }
	    pulse() {
	        this.events.emit(constants_1.HEARTBEAT_EVENTS.pulse);
	    }
	}
	heartbeat$2.HeartBeat = HeartBeat;
	
	return heartbeat$2;
}

var hasRequiredCjs$1;

function requireCjs$1 () {
	if (hasRequiredCjs$1) return cjs$1;
	hasRequiredCjs$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		const tslib_1 = require$$0$4;
		tslib_1.__exportStar(requireHeartbeat(), exports);
		tslib_1.__exportStar(requireTypes(), exports);
		tslib_1.__exportStar(requireConstants(), exports);
		
	} (cjs$1));
	return cjs$1;
}

var cjsExports$1 = requireCjs$1();

var quickFormatUnescaped;
var hasRequiredQuickFormatUnescaped;

function requireQuickFormatUnescaped () {
	if (hasRequiredQuickFormatUnescaped) return quickFormatUnescaped;
	hasRequiredQuickFormatUnescaped = 1;
	function tryStringify (o) {
	  try { return JSON.stringify(o) } catch(e) { return '"[Circular]"' }
	}

	quickFormatUnescaped = format;

	function format(f, args, opts) {
	  var ss = (opts && opts.stringify) || tryStringify;
	  var offset = 1;
	  if (typeof f === 'object' && f !== null) {
	    var len = args.length + offset;
	    if (len === 1) return f
	    var objects = new Array(len);
	    objects[0] = ss(f);
	    for (var index = 1; index < len; index++) {
	      objects[index] = ss(args[index]);
	    }
	    return objects.join(' ')
	  }
	  if (typeof f !== 'string') {
	    return f
	  }
	  var argLen = args.length;
	  if (argLen === 0) return f
	  var str = '';
	  var a = 1 - offset;
	  var lastPos = -1;
	  var flen = (f && f.length) || 0;
	  for (var i = 0; i < flen;) {
	    if (f.charCodeAt(i) === 37 && i + 1 < flen) {
	      lastPos = lastPos > -1 ? lastPos : 0;
	      switch (f.charCodeAt(i + 1)) {
	        case 100: // 'd'
	        case 102: // 'f'
	          if (a >= argLen)
	            break
	          if (args[a] == null)  break
	          if (lastPos < i)
	            str += f.slice(lastPos, i);
	          str += Number(args[a]);
	          lastPos = i + 2;
	          i++;
	          break
	        case 105: // 'i'
	          if (a >= argLen)
	            break
	          if (args[a] == null)  break
	          if (lastPos < i)
	            str += f.slice(lastPos, i);
	          str += Math.floor(Number(args[a]));
	          lastPos = i + 2;
	          i++;
	          break
	        case 79: // 'O'
	        case 111: // 'o'
	        case 106: // 'j'
	          if (a >= argLen)
	            break
	          if (args[a] === undefined) break
	          if (lastPos < i)
	            str += f.slice(lastPos, i);
	          var type = typeof args[a];
	          if (type === 'string') {
	            str += '\'' + args[a] + '\'';
	            lastPos = i + 2;
	            i++;
	            break
	          }
	          if (type === 'function') {
	            str += args[a].name || '<anonymous>';
	            lastPos = i + 2;
	            i++;
	            break
	          }
	          str += ss(args[a]);
	          lastPos = i + 2;
	          i++;
	          break
	        case 115: // 's'
	          if (a >= argLen)
	            break
	          if (lastPos < i)
	            str += f.slice(lastPos, i);
	          str += String(args[a]);
	          lastPos = i + 2;
	          i++;
	          break
	        case 37: // '%'
	          if (lastPos < i)
	            str += f.slice(lastPos, i);
	          str += '%';
	          lastPos = i + 2;
	          i++;
	          a--;
	          break
	      }
	      ++a;
	    }
	    ++i;
	  }
	  if (lastPos === -1)
	    return f
	  else if (lastPos < flen) {
	    str += f.slice(lastPos);
	  }

	  return str
	}
	return quickFormatUnescaped;
}

var browser$2;
var hasRequiredBrowser$2;

function requireBrowser$2 () {
	if (hasRequiredBrowser$2) return browser$2;
	hasRequiredBrowser$2 = 1;

	const format = requireQuickFormatUnescaped();

	browser$2 = pino;

	const _console = pfGlobalThisOrFallback().console || {};
	const stdSerializers = {
	  mapHttpRequest: mock,
	  mapHttpResponse: mock,
	  wrapRequestSerializer: passthrough,
	  wrapResponseSerializer: passthrough,
	  wrapErrorSerializer: passthrough,
	  req: mock,
	  res: mock,
	  err: asErrValue
	};

	function shouldSerialize (serialize, serializers) {
	  if (Array.isArray(serialize)) {
	    const hasToFilter = serialize.filter(function (k) {
	      return k !== '!stdSerializers.err'
	    });
	    return hasToFilter
	  } else if (serialize === true) {
	    return Object.keys(serializers)
	  }

	  return false
	}

	function pino (opts) {
	  opts = opts || {};
	  opts.browser = opts.browser || {};

	  const transmit = opts.browser.transmit;
	  if (transmit && typeof transmit.send !== 'function') { throw Error('pino: transmit option must have a send function') }

	  const proto = opts.browser.write || _console;
	  if (opts.browser.write) opts.browser.asObject = true;
	  const serializers = opts.serializers || {};
	  const serialize = shouldSerialize(opts.browser.serialize, serializers);
	  let stdErrSerialize = opts.browser.serialize;

	  if (
	    Array.isArray(opts.browser.serialize) &&
	    opts.browser.serialize.indexOf('!stdSerializers.err') > -1
	  ) stdErrSerialize = false;

	  const levels = ['error', 'fatal', 'warn', 'info', 'debug', 'trace'];

	  if (typeof proto === 'function') {
	    proto.error = proto.fatal = proto.warn =
	    proto.info = proto.debug = proto.trace = proto;
	  }
	  if (opts.enabled === false) opts.level = 'silent';
	  const level = opts.level || 'info';
	  const logger = Object.create(proto);
	  if (!logger.log) logger.log = noop;

	  Object.defineProperty(logger, 'levelVal', {
	    get: getLevelVal
	  });
	  Object.defineProperty(logger, 'level', {
	    get: getLevel,
	    set: setLevel
	  });

	  const setOpts = {
	    transmit,
	    serialize,
	    asObject: opts.browser.asObject,
	    levels,
	    timestamp: getTimeFunction(opts)
	  };
	  logger.levels = pino.levels;
	  logger.level = level;

	  logger.setMaxListeners = logger.getMaxListeners =
	  logger.emit = logger.addListener = logger.on =
	  logger.prependListener = logger.once =
	  logger.prependOnceListener = logger.removeListener =
	  logger.removeAllListeners = logger.listeners =
	  logger.listenerCount = logger.eventNames =
	  logger.write = logger.flush = noop;
	  logger.serializers = serializers;
	  logger._serialize = serialize;
	  logger._stdErrSerialize = stdErrSerialize;
	  logger.child = child;

	  if (transmit) logger._logEvent = createLogEventShape();

	  function getLevelVal () {
	    return this.level === 'silent'
	      ? Infinity
	      : this.levels.values[this.level]
	  }

	  function getLevel () {
	    return this._level
	  }
	  function setLevel (level) {
	    if (level !== 'silent' && !this.levels.values[level]) {
	      throw Error('unknown level ' + level)
	    }
	    this._level = level;

	    set(setOpts, logger, 'error', 'log'); // <-- must stay first
	    set(setOpts, logger, 'fatal', 'error');
	    set(setOpts, logger, 'warn', 'error');
	    set(setOpts, logger, 'info', 'log');
	    set(setOpts, logger, 'debug', 'log');
	    set(setOpts, logger, 'trace', 'log');
	  }

	  function child (bindings, childOptions) {
	    if (!bindings) {
	      throw new Error('missing bindings for child Pino')
	    }
	    childOptions = childOptions || {};
	    if (serialize && bindings.serializers) {
	      childOptions.serializers = bindings.serializers;
	    }
	    const childOptionsSerializers = childOptions.serializers;
	    if (serialize && childOptionsSerializers) {
	      var childSerializers = Object.assign({}, serializers, childOptionsSerializers);
	      var childSerialize = opts.browser.serialize === true
	        ? Object.keys(childSerializers)
	        : serialize;
	      delete bindings.serializers;
	      applySerializers([bindings], childSerialize, childSerializers, this._stdErrSerialize);
	    }
	    function Child (parent) {
	      this._childLevel = (parent._childLevel | 0) + 1;
	      this.error = bind(parent, bindings, 'error');
	      this.fatal = bind(parent, bindings, 'fatal');
	      this.warn = bind(parent, bindings, 'warn');
	      this.info = bind(parent, bindings, 'info');
	      this.debug = bind(parent, bindings, 'debug');
	      this.trace = bind(parent, bindings, 'trace');
	      if (childSerializers) {
	        this.serializers = childSerializers;
	        this._serialize = childSerialize;
	      }
	      if (transmit) {
	        this._logEvent = createLogEventShape(
	          [].concat(parent._logEvent.bindings, bindings)
	        );
	      }
	    }
	    Child.prototype = this;
	    return new Child(this)
	  }
	  return logger
	}

	pino.levels = {
	  values: {
	    fatal: 60,
	    error: 50,
	    warn: 40,
	    info: 30,
	    debug: 20,
	    trace: 10
	  },
	  labels: {
	    10: 'trace',
	    20: 'debug',
	    30: 'info',
	    40: 'warn',
	    50: 'error',
	    60: 'fatal'
	  }
	};

	pino.stdSerializers = stdSerializers;
	pino.stdTimeFunctions = Object.assign({}, { nullTime, epochTime, unixTime, isoTime });

	function set (opts, logger, level, fallback) {
	  const proto = Object.getPrototypeOf(logger);
	  logger[level] = logger.levelVal > logger.levels.values[level]
	    ? noop
	    : (proto[level] ? proto[level] : (_console[level] || _console[fallback] || noop));

	  wrap(opts, logger, level);
	}

	function wrap (opts, logger, level) {
	  if (!opts.transmit && logger[level] === noop) return

	  logger[level] = (function (write) {
	    return function LOG () {
	      const ts = opts.timestamp();
	      const args = new Array(arguments.length);
	      const proto = (Object.getPrototypeOf && Object.getPrototypeOf(this) === _console) ? _console : this;
	      for (var i = 0; i < args.length; i++) args[i] = arguments[i];

	      if (opts.serialize && !opts.asObject) {
	        applySerializers(args, this._serialize, this.serializers, this._stdErrSerialize);
	      }
	      if (opts.asObject) write.call(proto, asObject(this, level, args, ts));
	      else write.apply(proto, args);

	      if (opts.transmit) {
	        const transmitLevel = opts.transmit.level || logger.level;
	        const transmitValue = pino.levels.values[transmitLevel];
	        const methodValue = pino.levels.values[level];
	        if (methodValue < transmitValue) return
	        transmit(this, {
	          ts,
	          methodLevel: level,
	          methodValue,
	          transmitValue: pino.levels.values[opts.transmit.level || logger.level],
	          send: opts.transmit.send,
	          val: logger.levelVal
	        }, args);
	      }
	    }
	  })(logger[level]);
	}

	function asObject (logger, level, args, ts) {
	  if (logger._serialize) applySerializers(args, logger._serialize, logger.serializers, logger._stdErrSerialize);
	  const argsCloned = args.slice();
	  let msg = argsCloned[0];
	  const o = {};
	  if (ts) {
	    o.time = ts;
	  }
	  o.level = pino.levels.values[level];
	  let lvl = (logger._childLevel | 0) + 1;
	  if (lvl < 1) lvl = 1;
	  // deliberate, catching objects, arrays
	  if (msg !== null && typeof msg === 'object') {
	    while (lvl-- && typeof argsCloned[0] === 'object') {
	      Object.assign(o, argsCloned.shift());
	    }
	    msg = argsCloned.length ? format(argsCloned.shift(), argsCloned) : undefined;
	  } else if (typeof msg === 'string') msg = format(argsCloned.shift(), argsCloned);
	  if (msg !== undefined) o.msg = msg;
	  return o
	}

	function applySerializers (args, serialize, serializers, stdErrSerialize) {
	  for (const i in args) {
	    if (stdErrSerialize && args[i] instanceof Error) {
	      args[i] = pino.stdSerializers.err(args[i]);
	    } else if (typeof args[i] === 'object' && !Array.isArray(args[i])) {
	      for (const k in args[i]) {
	        if (serialize && serialize.indexOf(k) > -1 && k in serializers) {
	          args[i][k] = serializers[k](args[i][k]);
	        }
	      }
	    }
	  }
	}

	function bind (parent, bindings, level) {
	  return function () {
	    const args = new Array(1 + arguments.length);
	    args[0] = bindings;
	    for (var i = 1; i < args.length; i++) {
	      args[i] = arguments[i - 1];
	    }
	    return parent[level].apply(this, args)
	  }
	}

	function transmit (logger, opts, args) {
	  const send = opts.send;
	  const ts = opts.ts;
	  const methodLevel = opts.methodLevel;
	  const methodValue = opts.methodValue;
	  const val = opts.val;
	  const bindings = logger._logEvent.bindings;

	  applySerializers(
	    args,
	    logger._serialize || Object.keys(logger.serializers),
	    logger.serializers,
	    logger._stdErrSerialize === undefined ? true : logger._stdErrSerialize
	  );
	  logger._logEvent.ts = ts;
	  logger._logEvent.messages = args.filter(function (arg) {
	    // bindings can only be objects, so reference equality check via indexOf is fine
	    return bindings.indexOf(arg) === -1
	  });

	  logger._logEvent.level.label = methodLevel;
	  logger._logEvent.level.value = methodValue;

	  send(methodLevel, logger._logEvent, val);

	  logger._logEvent = createLogEventShape(bindings);
	}

	function createLogEventShape (bindings) {
	  return {
	    ts: 0,
	    messages: [],
	    bindings: bindings || [],
	    level: { label: '', value: 0 }
	  }
	}

	function asErrValue (err) {
	  const obj = {
	    type: err.constructor.name,
	    msg: err.message,
	    stack: err.stack
	  };
	  for (const key in err) {
	    if (obj[key] === undefined) {
	      obj[key] = err[key];
	    }
	  }
	  return obj
	}

	function getTimeFunction (opts) {
	  if (typeof opts.timestamp === 'function') {
	    return opts.timestamp
	  }
	  if (opts.timestamp === false) {
	    return nullTime
	  }
	  return epochTime
	}

	function mock () { return {} }
	function passthrough (a) { return a }
	function noop () {}

	function nullTime () { return false }
	function epochTime () { return Date.now() }
	function unixTime () { return Math.round(Date.now() / 1000.0) }
	function isoTime () { return new Date(Date.now()).toISOString() } // using Date.now() for testability

	/* eslint-disable */
	/* istanbul ignore next */
	function pfGlobalThisOrFallback () {
	  function defd (o) { return typeof o !== 'undefined' && o }
	  try {
	    if (typeof globalThis !== 'undefined') return globalThis
	    Object.defineProperty(Object.prototype, 'globalThis', {
	      get: function () {
	        delete Object.prototype.globalThis;
	        return (this.globalThis = this)
	      },
	      configurable: true
	    });
	    return globalThis
	  } catch (e) {
	    return defd(self) || defd(window) || defd(this) || {}
	  }
	}
	/* eslint-enable */
	return browser$2;
}

var browserExports$2 = requireBrowser$2();
var Hg = /*@__PURE__*/getDefaultExportFromCjs(browserExports$2);

const c$3={level:"info"},n$3="custom_context";var x$2=Object.defineProperty,S$3=Object.defineProperties,_$2=Object.getOwnPropertyDescriptors,p$5=Object.getOwnPropertySymbols,T$2=Object.prototype.hasOwnProperty,z$4=Object.prototype.propertyIsEnumerable,f$5=(r,e,t)=>e in r?x$2(r,e,{enumerable:true,configurable:true,writable:true,value:t}):r[e]=t,i$2=(r,e)=>{for(var t in e||(e={}))T$2.call(e,t)&&f$5(r,t,e[t]);if(p$5)for(var t of p$5(e))z$4.call(e,t)&&f$5(r,t,e[t]);return r},g$6=(r,e)=>S$3(r,_$2(e));function k$3(r){return g$6(i$2({},r),{level:r?.level||c$3.level})}function v$6(r,e=n$3){return r[e]||""}function b$2(r,e,t=n$3){return r[t]=e,r}function y$4(r,e=n$3){let t="";return typeof r.bindings>"u"?t=v$6(r,e):t=r.bindings().context||"",t}function w$6(r,e,t=n$3){const o=y$4(r,t);return o.trim()?`${o}/${e}`:e}function E$4(r,e,t=n$3){const o=w$6(r,e,t),a=r.child({context:o});return b$2(a,o,t)}

let n$2 = class n extends IEvents{constructor(s){super(),this.opts=s,this.protocol="wc",this.version=2;}};let h$2 = class h extends IEvents{constructor(s,t){super(),this.core=s,this.logger=t,this.records=new Map;}};let a$3 = class a{constructor(s,t){this.logger=s,this.core=t;}};let u$3 = class u extends IEvents{constructor(s,t){super(),this.relayer=s,this.logger=t;}};let g$5 = class g extends IEvents{constructor(s){super();}};let p$4 = class p{constructor(s,t,o,M){this.core=s,this.logger=t,this.name=o;}};let d$3 = class d extends IEvents{constructor(s,t){super(),this.relayer=s,this.logger=t;}};let E$3 = class E extends IEvents{constructor(s,t){super(),this.core=s,this.logger=t;}};let y$3 = class y{constructor(s,t){this.projectId=s,this.logger=t;}};let v$5 = class v{constructor(s,t){this.projectId=s,this.logger=t;}};let b$1 = class b{constructor(s){this.opts=s,this.protocol="wc",this.version=2;}};let w$5 = class w{constructor(s){this.client=s;}};

function En(t){return t instanceof Uint8Array||ArrayBuffer.isView(t)&&t.constructor.name==="Uint8Array"}function fe$1(t,...e){if(!En(t))throw new Error("Uint8Array expected");if(e.length>0&&!e.includes(t.length))throw new Error("Uint8Array expected of length "+e+", got length="+t.length)}function De$2(t,e=true){if(t.destroyed)throw new Error("Hash instance has been destroyed");if(e&&t.finished)throw new Error("Hash#digest() has already been called")}function gn(t,e){fe$1(t);const n=e.outputLen;if(t.length<n)throw new Error("digestInto() expects output buffer of length at least "+n)}const it$1=typeof globalThis=="object"&&"crypto"in globalThis?globalThis.crypto:void 0;/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */const _t$1=t=>new DataView(t.buffer,t.byteOffset,t.byteLength);function yn(t){if(typeof t!="string")throw new Error("utf8ToBytes expected string, got "+typeof t);return new Uint8Array(new TextEncoder().encode(t))}function de$3(t){return typeof t=="string"&&(t=yn(t)),fe$1(t),t}class xn{clone(){return this._cloneInto()}}function Bn(t){const e=r=>t().update(de$3(r)).digest(),n=t();return e.outputLen=n.outputLen,e.blockLen=n.blockLen,e.create=()=>t(),e}function he$2(t=32){if(it$1&&typeof it$1.getRandomValues=="function")return it$1.getRandomValues(new Uint8Array(t));if(it$1&&typeof it$1.randomBytes=="function")return it$1.randomBytes(t);throw new Error("crypto.getRandomValues must be defined")}function Cn(t,e,n,r){if(typeof t.setBigUint64=="function")return t.setBigUint64(e,n,r);const o=BigInt(32),s=BigInt(4294967295),a=Number(n>>o&s),u=Number(n&s),i=r?4:0,D=r?0:4;t.setUint32(e+i,a,r),t.setUint32(e+D,u,r);}class An extends xn{constructor(e,n,r,o){super(),this.blockLen=e,this.outputLen=n,this.padOffset=r,this.isLE=o,this.finished=false,this.length=0,this.pos=0,this.destroyed=false,this.buffer=new Uint8Array(e),this.view=_t$1(this.buffer);}update(e){De$2(this);const{view:n,buffer:r,blockLen:o}=this;e=de$3(e);const s=e.length;for(let a=0;a<s;){const u=Math.min(o-this.pos,s-a);if(u===o){const i=_t$1(e);for(;o<=s-a;a+=o)this.process(i,a);continue}r.set(e.subarray(a,a+u),this.pos),this.pos+=u,a+=u,this.pos===o&&(this.process(n,0),this.pos=0);}return this.length+=e.length,this.roundClean(),this}digestInto(e){De$2(this),gn(e,this),this.finished=true;const{buffer:n,view:r,blockLen:o,isLE:s}=this;let{pos:a}=this;n[a++]=128,this.buffer.subarray(a).fill(0),this.padOffset>o-a&&(this.process(r,0),a=0);for(let l=a;l<o;l++)n[l]=0;Cn(r,o-8,BigInt(this.length*8),s),this.process(r,0);const u=_t$1(e),i=this.outputLen;if(i%4)throw new Error("_sha2: outputLen should be aligned to 32bit");const D=i/4,c=this.get();if(D>c.length)throw new Error("_sha2: outputLen bigger than state");for(let l=0;l<D;l++)u.setUint32(4*l,c[l],s);}digest(){const{buffer:e,outputLen:n}=this;this.digestInto(e);const r=e.slice(0,n);return this.destroy(),r}_cloneInto(e){e||(e=new this.constructor),e.set(...this.get());const{blockLen:n,buffer:r,length:o,finished:s,destroyed:a,pos:u}=this;return e.length=o,e.pos=u,e.finished=s,e.destroyed=a,o%n&&e.buffer.set(r),e}}const wt$1=BigInt(2**32-1),St$1=BigInt(32);function le$3(t,e=false){return e?{h:Number(t&wt$1),l:Number(t>>St$1&wt$1)}:{h:Number(t>>St$1&wt$1)|0,l:Number(t&wt$1)|0}}function mn(t,e=false){let n=new Uint32Array(t.length),r=new Uint32Array(t.length);for(let o=0;o<t.length;o++){const{h:s,l:a}=le$3(t[o],e);[n[o],r[o]]=[s,a];}return [n,r]}const _n=(t,e)=>BigInt(t>>>0)<<St$1|BigInt(e>>>0),Sn=(t,e,n)=>t>>>n,vn=(t,e,n)=>t<<32-n|e>>>n,In=(t,e,n)=>t>>>n|e<<32-n,Un=(t,e,n)=>t<<32-n|e>>>n,Tn=(t,e,n)=>t<<64-n|e>>>n-32,Fn=(t,e,n)=>t>>>n-32|e<<64-n,Nn=(t,e)=>e,Ln=(t,e)=>t,On=(t,e,n)=>t<<n|e>>>32-n,Hn=(t,e,n)=>e<<n|t>>>32-n,zn=(t,e,n)=>e<<n-32|t>>>64-n,Mn=(t,e,n)=>t<<n-32|e>>>64-n;function qn(t,e,n,r){const o=(e>>>0)+(r>>>0);return {h:t+n+(o/2**32|0)|0,l:o|0}}const $n=(t,e,n)=>(t>>>0)+(e>>>0)+(n>>>0),kn=(t,e,n,r)=>e+n+r+(t/2**32|0)|0,Rn=(t,e,n,r)=>(t>>>0)+(e>>>0)+(n>>>0)+(r>>>0),jn=(t,e,n,r,o)=>e+n+r+o+(t/2**32|0)|0,Zn=(t,e,n,r,o)=>(t>>>0)+(e>>>0)+(n>>>0)+(r>>>0)+(o>>>0),Gn=(t,e,n,r,o,s)=>e+n+r+o+s+(t/2**32|0)|0,x$1={fromBig:le$3,split:mn,toBig:_n,shrSH:Sn,shrSL:vn,rotrSH:In,rotrSL:Un,rotrBH:Tn,rotrBL:Fn,rotr32H:Nn,rotr32L:Ln,rotlSH:On,rotlSL:Hn,rotlBH:zn,rotlBL:Mn,add:qn,add3L:$n,add3H:kn,add4L:Rn,add4H:jn,add5H:Gn,add5L:Zn},[Vn$1,Yn]=(()=>x$1.split(["0x428a2f98d728ae22","0x7137449123ef65cd","0xb5c0fbcfec4d3b2f","0xe9b5dba58189dbbc","0x3956c25bf348b538","0x59f111f1b605d019","0x923f82a4af194f9b","0xab1c5ed5da6d8118","0xd807aa98a3030242","0x12835b0145706fbe","0x243185be4ee4b28c","0x550c7dc3d5ffb4e2","0x72be5d74f27b896f","0x80deb1fe3b1696b1","0x9bdc06a725c71235","0xc19bf174cf692694","0xe49b69c19ef14ad2","0xefbe4786384f25e3","0x0fc19dc68b8cd5b5","0x240ca1cc77ac9c65","0x2de92c6f592b0275","0x4a7484aa6ea6e483","0x5cb0a9dcbd41fbd4","0x76f988da831153b5","0x983e5152ee66dfab","0xa831c66d2db43210","0xb00327c898fb213f","0xbf597fc7beef0ee4","0xc6e00bf33da88fc2","0xd5a79147930aa725","0x06ca6351e003826f","0x142929670a0e6e70","0x27b70a8546d22ffc","0x2e1b21385c26c926","0x4d2c6dfc5ac42aed","0x53380d139d95b3df","0x650a73548baf63de","0x766a0abb3c77b2a8","0x81c2c92e47edaee6","0x92722c851482353b","0xa2bfe8a14cf10364","0xa81a664bbc423001","0xc24b8b70d0f89791","0xc76c51a30654be30","0xd192e819d6ef5218","0xd69906245565a910","0xf40e35855771202a","0x106aa07032bbd1b8","0x19a4c116b8d2d0c8","0x1e376c085141ab53","0x2748774cdf8eeb99","0x34b0bcb5e19b48a8","0x391c0cb3c5c95a63","0x4ed8aa4ae3418acb","0x5b9cca4f7763e373","0x682e6ff3d6b2b8a3","0x748f82ee5defb2fc","0x78a5636f43172f60","0x84c87814a1f0ab72","0x8cc702081a6439ec","0x90befffa23631e28","0xa4506cebde82bde9","0xbef9a3f7b2c67915","0xc67178f2e372532b","0xca273eceea26619c","0xd186b8c721c0c207","0xeada7dd6cde0eb1e","0xf57d4f7fee6ed178","0x06f067aa72176fba","0x0a637dc5a2c898a6","0x113f9804bef90dae","0x1b710b35131c471b","0x28db77f523047d84","0x32caab7b40c72493","0x3c9ebe0a15c9bebc","0x431d67c49c100d4c","0x4cc5d4becb3e42b6","0x597f299cfc657e2a","0x5fcb6fab3ad6faec","0x6c44198c4a475817"].map(t=>BigInt(t))))(),P$5=new Uint32Array(80),Q$4=new Uint32Array(80);class Jn extends An{constructor(){super(128,64,16,false),this.Ah=1779033703,this.Al=-205731576,this.Bh=-1150833019,this.Bl=-2067093701,this.Ch=1013904242,this.Cl=-23791573,this.Dh=-1521486534,this.Dl=1595750129,this.Eh=1359893119,this.El=-1377402159,this.Fh=-1694144372,this.Fl=725511199,this.Gh=528734635,this.Gl=-79577749,this.Hh=1541459225,this.Hl=327033209;}get(){const{Ah:e,Al:n,Bh:r,Bl:o,Ch:s,Cl:a,Dh:u,Dl:i,Eh:D,El:c,Fh:l,Fl:p,Gh:w,Gl:h,Hh:g,Hl:S}=this;return [e,n,r,o,s,a,u,i,D,c,l,p,w,h,g,S]}set(e,n,r,o,s,a,u,i,D,c,l,p,w,h,g,S){this.Ah=e|0,this.Al=n|0,this.Bh=r|0,this.Bl=o|0,this.Ch=s|0,this.Cl=a|0,this.Dh=u|0,this.Dl=i|0,this.Eh=D|0,this.El=c|0,this.Fh=l|0,this.Fl=p|0,this.Gh=w|0,this.Gl=h|0,this.Hh=g|0,this.Hl=S|0;}process(e,n){for(let d=0;d<16;d++,n+=4)P$5[d]=e.getUint32(n),Q$4[d]=e.getUint32(n+=4);for(let d=16;d<80;d++){const m=P$5[d-15]|0,F=Q$4[d-15]|0,q=x$1.rotrSH(m,F,1)^x$1.rotrSH(m,F,8)^x$1.shrSH(m,F,7),z=x$1.rotrSL(m,F,1)^x$1.rotrSL(m,F,8)^x$1.shrSL(m,F,7),I=P$5[d-2]|0,O=Q$4[d-2]|0,ot=x$1.rotrSH(I,O,19)^x$1.rotrBH(I,O,61)^x$1.shrSH(I,O,6),tt=x$1.rotrSL(I,O,19)^x$1.rotrBL(I,O,61)^x$1.shrSL(I,O,6),st=x$1.add4L(z,tt,Q$4[d-7],Q$4[d-16]),at=x$1.add4H(st,q,ot,P$5[d-7],P$5[d-16]);P$5[d]=at|0,Q$4[d]=st|0;}let{Ah:r,Al:o,Bh:s,Bl:a,Ch:u,Cl:i,Dh:D,Dl:c,Eh:l,El:p,Fh:w,Fl:h,Gh:g,Gl:S,Hh:v,Hl:L}=this;for(let d=0;d<80;d++){const m=x$1.rotrSH(l,p,14)^x$1.rotrSH(l,p,18)^x$1.rotrBH(l,p,41),F=x$1.rotrSL(l,p,14)^x$1.rotrSL(l,p,18)^x$1.rotrBL(l,p,41),q=l&w^~l&g,z=p&h^~p&S,I=x$1.add5L(L,F,z,Yn[d],Q$4[d]),O=x$1.add5H(I,v,m,q,Vn$1[d],P$5[d]),ot=I|0,tt=x$1.rotrSH(r,o,28)^x$1.rotrBH(r,o,34)^x$1.rotrBH(r,o,39),st=x$1.rotrSL(r,o,28)^x$1.rotrBL(r,o,34)^x$1.rotrBL(r,o,39),at=r&s^r&u^s&u,Ct=o&a^o&i^a&i;v=g|0,L=S|0,g=w|0,S=h|0,w=l|0,h=p|0,{h:l,l:p}=x$1.add(D|0,c|0,O|0,ot|0),D=u|0,c=i|0,u=s|0,i=a|0,s=r|0,a=o|0;const At=x$1.add3L(ot,st,Ct);r=x$1.add3H(At,O,tt,at),o=At|0;}(({h:r,l:o}=x$1.add(this.Ah|0,this.Al|0,r|0,o|0))),{h:s,l:a}=x$1.add(this.Bh|0,this.Bl|0,s|0,a|0),{h:u,l:i}=x$1.add(this.Ch|0,this.Cl|0,u|0,i|0),{h:D,l:c}=x$1.add(this.Dh|0,this.Dl|0,D|0,c|0),{h:l,l:p}=x$1.add(this.Eh|0,this.El|0,l|0,p|0),{h:w,l:h}=x$1.add(this.Fh|0,this.Fl|0,w|0,h|0),{h:g,l:S}=x$1.add(this.Gh|0,this.Gl|0,g|0,S|0),{h:v,l:L}=x$1.add(this.Hh|0,this.Hl|0,v|0,L|0),this.set(r,o,s,a,u,i,D,c,l,p,w,h,g,S,v,L);}roundClean(){P$5.fill(0),Q$4.fill(0);}destroy(){this.buffer.fill(0),this.set(0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0);}}const Kn=Bn(()=>new Jn);/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */const vt$1=BigInt(0),be=BigInt(1),Wn=BigInt(2);function It$1(t){return t instanceof Uint8Array||ArrayBuffer.isView(t)&&t.constructor.name==="Uint8Array"}function Ut$1(t){if(!It$1(t))throw new Error("Uint8Array expected")}function Tt$1(t,e){if(typeof e!="boolean")throw new Error(t+" boolean expected, got "+e)}const Xn=Array.from({length:256},(t,e)=>e.toString(16).padStart(2,"0"));function Ft$1(t){Ut$1(t);let e="";for(let n=0;n<t.length;n++)e+=Xn[t[n]];return e}function pe$3(t){if(typeof t!="string")throw new Error("hex string expected, got "+typeof t);return t===""?vt$1:BigInt("0x"+t)}const K$1={_0:48,_9:57,A:65,F:70,a:97,f:102};function we$1(t){if(t>=K$1._0&&t<=K$1._9)return t-K$1._0;if(t>=K$1.A&&t<=K$1.F)return t-(K$1.A-10);if(t>=K$1.a&&t<=K$1.f)return t-(K$1.a-10)}function Ee$1(t){if(typeof t!="string")throw new Error("hex string expected, got "+typeof t);const e=t.length,n=e/2;if(e%2)throw new Error("hex string expected, got unpadded hex of length "+e);const r=new Uint8Array(n);for(let o=0,s=0;o<n;o++,s+=2){const a=we$1(t.charCodeAt(s)),u=we$1(t.charCodeAt(s+1));if(a===void 0||u===void 0){const i=t[s]+t[s+1];throw new Error('hex string expected, got non-hex character "'+i+'" at index '+s)}r[o]=a*16+u;}return r}function Pn(t){return pe$3(Ft$1(t))}function Et$1(t){return Ut$1(t),pe$3(Ft$1(Uint8Array.from(t).reverse()))}function ge$3(t,e){return Ee$1(t.toString(16).padStart(e*2,"0"))}function Nt$1(t,e){return ge$3(t,e).reverse()}function W$3(t,e,n){let r;if(typeof e=="string")try{r=Ee$1(e);}catch(s){throw new Error(t+" must be hex string or Uint8Array, cause: "+s)}else if(It$1(e))r=Uint8Array.from(e);else throw new Error(t+" must be hex string or Uint8Array");const o=r.length;if(typeof n=="number"&&o!==n)throw new Error(t+" of length "+n+" expected, got "+o);return r}function ye$1(...t){let e=0;for(let r=0;r<t.length;r++){const o=t[r];Ut$1(o),e+=o.length;}const n=new Uint8Array(e);for(let r=0,o=0;r<t.length;r++){const s=t[r];n.set(s,o),o+=s.length;}return n}const Lt$1=t=>typeof t=="bigint"&&vt$1<=t;function Qn(t,e,n){return Lt$1(t)&&Lt$1(e)&&Lt$1(n)&&e<=t&&t<n}function ft$2(t,e,n,r){if(!Qn(e,n,r))throw new Error("expected valid "+t+": "+n+" <= n < "+r+", got "+e)}function tr$1(t){let e;for(e=0;t>vt$1;t>>=be,e+=1);return e}const er$1=t=>(Wn<<BigInt(t-1))-be,nr$1={bigint:t=>typeof t=="bigint",function:t=>typeof t=="function",boolean:t=>typeof t=="boolean",string:t=>typeof t=="string",stringOrUint8Array:t=>typeof t=="string"||It$1(t),isSafeInteger:t=>Number.isSafeInteger(t),array:t=>Array.isArray(t),field:(t,e)=>e.Fp.isValid(t),hash:t=>typeof t=="function"&&Number.isSafeInteger(t.outputLen)};function Ot$1(t,e,n={}){const r=(o,s,a)=>{const u=nr$1[s];if(typeof u!="function")throw new Error("invalid validator function");const i=t[o];if(!(a&&i===void 0)&&!u(i,t))throw new Error("param "+String(o)+" is invalid. Expected "+s+", got "+i)};for(const[o,s]of Object.entries(e))r(o,s,false);for(const[o,s]of Object.entries(n))r(o,s,true);return t}function xe$1(t){const e=new WeakMap;return (n,...r)=>{const o=e.get(n);if(o!==void 0)return o;const s=t(n,...r);return e.set(n,s),s}}const M$4=BigInt(0),N$2=BigInt(1),nt$1=BigInt(2),rr$1=BigInt(3),Ht$1=BigInt(4),Be$1=BigInt(5),Ce$1=BigInt(8);function H$1(t,e){const n=t%e;return n>=M$4?n:e+n}function or$1(t,e,n){if(e<M$4)throw new Error("invalid exponent, negatives unsupported");if(n<=M$4)throw new Error("invalid modulus");if(n===N$2)return M$4;let r=N$2;for(;e>M$4;)e&N$2&&(r=r*t%n),t=t*t%n,e>>=N$2;return r}function J$2(t,e,n){let r=t;for(;e-- >M$4;)r*=r,r%=n;return r}function Ae$1(t,e){if(t===M$4)throw new Error("invert: expected non-zero number");if(e<=M$4)throw new Error("invert: expected positive modulus, got "+e);let n=H$1(t,e),r=e,o=M$4,s=N$2;for(;n!==M$4;){const u=r/n,i=r%n,D=o-s*u;r=n,n=i,o=s,s=D;}if(r!==N$2)throw new Error("invert: does not exist");return H$1(o,e)}function sr$1(t){const e=(t-N$2)/nt$1;let n,r,o;for(n=t-N$2,r=0;n%nt$1===M$4;n/=nt$1,r++);for(o=nt$1;o<t&&or$1(o,e,t)!==t-N$2;o++)if(o>1e3)throw new Error("Cannot find square root: likely non-prime P");if(r===1){const a=(t+N$2)/Ht$1;return function(i,D){const c=i.pow(D,a);if(!i.eql(i.sqr(c),D))throw new Error("Cannot find square root");return c}}const s=(n+N$2)/nt$1;return function(u,i){if(u.pow(i,e)===u.neg(u.ONE))throw new Error("Cannot find square root");let D=r,c=u.pow(u.mul(u.ONE,o),n),l=u.pow(i,s),p=u.pow(i,n);for(;!u.eql(p,u.ONE);){if(u.eql(p,u.ZERO))return u.ZERO;let w=1;for(let g=u.sqr(p);w<D&&!u.eql(g,u.ONE);w++)g=u.sqr(g);const h=u.pow(c,N$2<<BigInt(D-w-1));c=u.sqr(h),l=u.mul(l,h),p=u.mul(p,c),D=w;}return l}}function ir$1(t){if(t%Ht$1===rr$1){const e=(t+N$2)/Ht$1;return function(r,o){const s=r.pow(o,e);if(!r.eql(r.sqr(s),o))throw new Error("Cannot find square root");return s}}if(t%Ce$1===Be$1){const e=(t-Be$1)/Ce$1;return function(r,o){const s=r.mul(o,nt$1),a=r.pow(s,e),u=r.mul(o,a),i=r.mul(r.mul(u,nt$1),a),D=r.mul(u,r.sub(i,r.ONE));if(!r.eql(r.sqr(D),o))throw new Error("Cannot find square root");return D}}return sr$1(t)}const ur$1=(t,e)=>(H$1(t,e)&N$2)===N$2,cr$2=["create","isValid","is0","neg","inv","sqrt","sqr","eql","add","sub","mul","pow","div","addN","subN","mulN","sqrN"];function ar$1(t){const e={ORDER:"bigint",MASK:"bigint",BYTES:"isSafeInteger",BITS:"isSafeInteger"},n=cr$2.reduce((r,o)=>(r[o]="function",r),e);return Ot$1(t,n)}function fr(t,e,n){if(n<M$4)throw new Error("invalid exponent, negatives unsupported");if(n===M$4)return t.ONE;if(n===N$2)return e;let r=t.ONE,o=e;for(;n>M$4;)n&N$2&&(r=t.mul(r,o)),o=t.sqr(o),n>>=N$2;return r}function Dr$1(t,e){const n=new Array(e.length),r=e.reduce((s,a,u)=>t.is0(a)?s:(n[u]=s,t.mul(s,a)),t.ONE),o=t.inv(r);return e.reduceRight((s,a,u)=>t.is0(a)?s:(n[u]=t.mul(s,n[u]),t.mul(s,a)),o),n}function me$1(t,e){const n=e!==void 0?e:t.toString(2).length,r=Math.ceil(n/8);return {nBitLength:n,nByteLength:r}}function _e$1(t,e,n=false,r={}){if(t<=M$4)throw new Error("invalid field: expected ORDER > 0, got "+t);const{nBitLength:o,nByteLength:s}=me$1(t,e);if(s>2048)throw new Error("invalid field: expected ORDER of <= 2048 bytes");let a;const u=Object.freeze({ORDER:t,isLE:n,BITS:o,BYTES:s,MASK:er$1(o),ZERO:M$4,ONE:N$2,create:i=>H$1(i,t),isValid:i=>{if(typeof i!="bigint")throw new Error("invalid field element: expected bigint, got "+typeof i);return M$4<=i&&i<t},is0:i=>i===M$4,isOdd:i=>(i&N$2)===N$2,neg:i=>H$1(-i,t),eql:(i,D)=>i===D,sqr:i=>H$1(i*i,t),add:(i,D)=>H$1(i+D,t),sub:(i,D)=>H$1(i-D,t),mul:(i,D)=>H$1(i*D,t),pow:(i,D)=>fr(u,i,D),div:(i,D)=>H$1(i*Ae$1(D,t),t),sqrN:i=>i*i,addN:(i,D)=>i+D,subN:(i,D)=>i-D,mulN:(i,D)=>i*D,inv:i=>Ae$1(i,t),sqrt:r.sqrt||(i=>(a||(a=ir$1(t)),a(u,i))),invertBatch:i=>Dr$1(u,i),cmov:(i,D,c)=>c?D:i,toBytes:i=>n?Nt$1(i,s):ge$3(i,s),fromBytes:i=>{if(i.length!==s)throw new Error("Field.fromBytes: expected "+s+" bytes, got "+i.length);return n?Et$1(i):Pn(i)}});return Object.freeze(u)}const Se$1=BigInt(0),gt$1=BigInt(1);function zt$1(t,e){const n=e.negate();return t?n:e}function ve$1(t,e){if(!Number.isSafeInteger(t)||t<=0||t>e)throw new Error("invalid window size, expected [1.."+e+"], got W="+t)}function Mt$1(t,e){ve$1(t,e);const n=Math.ceil(e/t)+1,r=2**(t-1);return {windows:n,windowSize:r}}function dr$1(t,e){if(!Array.isArray(t))throw new Error("array expected");t.forEach((n,r)=>{if(!(n instanceof e))throw new Error("invalid point at index "+r)});}function hr$2(t,e){if(!Array.isArray(t))throw new Error("array of scalars expected");t.forEach((n,r)=>{if(!e.isValid(n))throw new Error("invalid scalar at index "+r)});}const qt$1=new WeakMap,Ie=new WeakMap;function $t$1(t){return Ie.get(t)||1}function lr$2(t,e){return {constTimeNegate:zt$1,hasPrecomputes(n){return $t$1(n)!==1},unsafeLadder(n,r,o=t.ZERO){let s=n;for(;r>Se$1;)r&gt$1&&(o=o.add(s)),s=s.double(),r>>=gt$1;return o},precomputeWindow(n,r){const{windows:o,windowSize:s}=Mt$1(r,e),a=[];let u=n,i=u;for(let D=0;D<o;D++){i=u,a.push(i);for(let c=1;c<s;c++)i=i.add(u),a.push(i);u=i.double();}return a},wNAF(n,r,o){const{windows:s,windowSize:a}=Mt$1(n,e);let u=t.ZERO,i=t.BASE;const D=BigInt(2**n-1),c=2**n,l=BigInt(n);for(let p=0;p<s;p++){const w=p*a;let h=Number(o&D);o>>=l,h>a&&(h-=c,o+=gt$1);const g=w,S=w+Math.abs(h)-1,v=p%2!==0,L=h<0;h===0?i=i.add(zt$1(v,r[g])):u=u.add(zt$1(L,r[S]));}return {p:u,f:i}},wNAFUnsafe(n,r,o,s=t.ZERO){const{windows:a,windowSize:u}=Mt$1(n,e),i=BigInt(2**n-1),D=2**n,c=BigInt(n);for(let l=0;l<a;l++){const p=l*u;if(o===Se$1)break;let w=Number(o&i);if(o>>=c,w>u&&(w-=D,o+=gt$1),w===0)continue;let h=r[p+Math.abs(w)-1];w<0&&(h=h.negate()),s=s.add(h);}return s},getPrecomputes(n,r,o){let s=qt$1.get(r);return s||(s=this.precomputeWindow(r,n),n!==1&&qt$1.set(r,o(s))),s},wNAFCached(n,r,o){const s=$t$1(n);return this.wNAF(s,this.getPrecomputes(s,n,o),r)},wNAFCachedUnsafe(n,r,o,s){const a=$t$1(n);return a===1?this.unsafeLadder(n,r,s):this.wNAFUnsafe(a,this.getPrecomputes(a,n,o),r,s)},setWindowSize(n,r){ve$1(r,e),Ie.set(n,r),qt$1.delete(n);}}}function br(t,e,n,r){if(dr$1(n,t),hr$2(r,e),n.length!==r.length)throw new Error("arrays of points and scalars must have equal length");const o=t.ZERO,s=tr$1(BigInt(n.length)),a=s>12?s-3:s>4?s-2:s?2:1,u=(1<<a)-1,i=new Array(u+1).fill(o),D=Math.floor((e.BITS-1)/a)*a;let c=o;for(let l=D;l>=0;l-=a){i.fill(o);for(let w=0;w<r.length;w++){const h=r[w],g=Number(h>>BigInt(l)&BigInt(u));i[g]=i[g].add(n[w]);}let p=o;for(let w=i.length-1,h=o;w>0;w--)h=h.add(i[w]),p=p.add(h);if(c=c.add(p),l!==0)for(let w=0;w<a;w++)c=c.double();}return c}function pr$1(t){return ar$1(t.Fp),Ot$1(t,{n:"bigint",h:"bigint",Gx:"field",Gy:"field"},{nBitLength:"isSafeInteger",nByteLength:"isSafeInteger"}),Object.freeze({...me$1(t.n,t.nBitLength),...t,p:t.Fp.ORDER})}const G$1=BigInt(0),j$4=BigInt(1),yt$1=BigInt(2),wr=BigInt(8),Er={zip215:true};function gr$1(t){const e=pr$1(t);return Ot$1(t,{hash:"function",a:"bigint",d:"bigint",randomBytes:"function"},{adjustScalarBytes:"function",domain:"function",uvRatio:"function",mapToCurve:"function"}),Object.freeze({...e})}function yr$1(t){const e=gr$1(t),{Fp:n,n:r,prehash:o,hash:s,randomBytes:a,nByteLength:u,h:i}=e,D=yt$1<<BigInt(u*8)-j$4,c=n.create,l=_e$1(e.n,e.nBitLength),p=e.uvRatio||((y,f)=>{try{return {isValid:!0,value:n.sqrt(y*n.inv(f))}}catch{return {isValid:false,value:G$1}}}),w=e.adjustScalarBytes||(y=>y),h=e.domain||((y,f,b)=>{if(Tt$1("phflag",b),f.length||b)throw new Error("Contexts/pre-hash are not supported");return y});function g(y,f){ft$2("coordinate "+y,f,G$1,D);}function S(y){if(!(y instanceof d))throw new Error("ExtendedPoint expected")}const v=xe$1((y,f)=>{const{ex:b,ey:E,ez:B}=y,C=y.is0();f==null&&(f=C?wr:n.inv(B));const A=c(b*f),U=c(E*f),_=c(B*f);if(C)return {x:G$1,y:j$4};if(_!==j$4)throw new Error("invZ was invalid");return {x:A,y:U}}),L=xe$1(y=>{const{a:f,d:b}=e;if(y.is0())throw new Error("bad point: ZERO");const{ex:E,ey:B,ez:C,et:A}=y,U=c(E*E),_=c(B*B),T=c(C*C),$=c(T*T),R=c(U*f),V=c(T*c(R+_)),Y=c($+c(b*c(U*_)));if(V!==Y)throw new Error("bad point: equation left != right (1)");const Z=c(E*B),X=c(C*A);if(Z!==X)throw new Error("bad point: equation left != right (2)");return  true});class d{constructor(f,b,E,B){this.ex=f,this.ey=b,this.ez=E,this.et=B,g("x",f),g("y",b),g("z",E),g("t",B),Object.freeze(this);}get x(){return this.toAffine().x}get y(){return this.toAffine().y}static fromAffine(f){if(f instanceof d)throw new Error("extended point not allowed");const{x:b,y:E}=f||{};return g("x",b),g("y",E),new d(b,E,j$4,c(b*E))}static normalizeZ(f){const b=n.invertBatch(f.map(E=>E.ez));return f.map((E,B)=>E.toAffine(b[B])).map(d.fromAffine)}static msm(f,b){return br(d,l,f,b)}_setWindowSize(f){q.setWindowSize(this,f);}assertValidity(){L(this);}equals(f){S(f);const{ex:b,ey:E,ez:B}=this,{ex:C,ey:A,ez:U}=f,_=c(b*U),T=c(C*B),$=c(E*U),R=c(A*B);return _===T&&$===R}is0(){return this.equals(d.ZERO)}negate(){return new d(c(-this.ex),this.ey,this.ez,c(-this.et))}double(){const{a:f}=e,{ex:b,ey:E,ez:B}=this,C=c(b*b),A=c(E*E),U=c(yt$1*c(B*B)),_=c(f*C),T=b+E,$=c(c(T*T)-C-A),R=_+A,V=R-U,Y=_-A,Z=c($*V),X=c(R*Y),et=c($*Y),pt=c(V*R);return new d(Z,X,pt,et)}add(f){S(f);const{a:b,d:E}=e,{ex:B,ey:C,ez:A,et:U}=this,{ex:_,ey:T,ez:$,et:R}=f;if(b===BigInt(-1)){const re=c((C-B)*(T+_)),oe=c((C+B)*(T-_)),mt=c(oe-re);if(mt===G$1)return this.double();const se=c(A*yt$1*R),ie=c(U*yt$1*$),ue=ie+se,ce=oe+re,ae=ie-se,Dn=c(ue*mt),dn=c(ce*ae),hn=c(ue*ae),ln=c(mt*ce);return new d(Dn,dn,ln,hn)}const V=c(B*_),Y=c(C*T),Z=c(U*E*R),X=c(A*$),et=c((B+C)*(_+T)-V-Y),pt=X-Z,ee=X+Z,ne=c(Y-b*V),un=c(et*pt),cn=c(ee*ne),an=c(et*ne),fn=c(pt*ee);return new d(un,cn,fn,an)}subtract(f){return this.add(f.negate())}wNAF(f){return q.wNAFCached(this,f,d.normalizeZ)}multiply(f){const b=f;ft$2("scalar",b,j$4,r);const{p:E,f:B}=this.wNAF(b);return d.normalizeZ([E,B])[0]}multiplyUnsafe(f,b=d.ZERO){const E=f;return ft$2("scalar",E,G$1,r),E===G$1?F:this.is0()||E===j$4?this:q.wNAFCachedUnsafe(this,E,d.normalizeZ,b)}isSmallOrder(){return this.multiplyUnsafe(i).is0()}isTorsionFree(){return q.unsafeLadder(this,r).is0()}toAffine(f){return v(this,f)}clearCofactor(){const{h:f}=e;return f===j$4?this:this.multiplyUnsafe(f)}static fromHex(f,b=false){const{d:E,a:B}=e,C=n.BYTES;f=W$3("pointHex",f,C),Tt$1("zip215",b);const A=f.slice(),U=f[C-1];A[C-1]=U&-129;const _=Et$1(A),T=b?D:n.ORDER;ft$2("pointHex.y",_,G$1,T);const $=c(_*_),R=c($-j$4),V=c(E*$-B);let{isValid:Y,value:Z}=p(R,V);if(!Y)throw new Error("Point.fromHex: invalid y coordinate");const X=(Z&j$4)===j$4,et=(U&128)!==0;if(!b&&Z===G$1&&et)throw new Error("Point.fromHex: x=0 and x_0=1");return et!==X&&(Z=c(-Z)),d.fromAffine({x:Z,y:_})}static fromPrivateKey(f){return O(f).point}toRawBytes(){const{x:f,y:b}=this.toAffine(),E=Nt$1(b,n.BYTES);return E[E.length-1]|=f&j$4?128:0,E}toHex(){return Ft$1(this.toRawBytes())}}d.BASE=new d(e.Gx,e.Gy,j$4,c(e.Gx*e.Gy)),d.ZERO=new d(G$1,j$4,j$4,G$1);const{BASE:m,ZERO:F}=d,q=lr$2(d,u*8);function z(y){return H$1(y,r)}function I(y){return z(Et$1(y))}function O(y){const f=n.BYTES;y=W$3("private key",y,f);const b=W$3("hashed private key",s(y),2*f),E=w(b.slice(0,f)),B=b.slice(f,2*f),C=I(E),A=m.multiply(C),U=A.toRawBytes();return {head:E,prefix:B,scalar:C,point:A,pointBytes:U}}function ot(y){return O(y).pointBytes}function tt(y=new Uint8Array,...f){const b=ye$1(...f);return I(s(h(b,W$3("context",y),!!o)))}function st(y,f,b={}){y=W$3("message",y),o&&(y=o(y));const{prefix:E,scalar:B,pointBytes:C}=O(f),A=tt(b.context,E,y),U=m.multiply(A).toRawBytes(),_=tt(b.context,U,C,y),T=z(A+_*B);ft$2("signature.s",T,G$1,r);const $=ye$1(U,Nt$1(T,n.BYTES));return W$3("result",$,n.BYTES*2)}const at=Er;function Ct(y,f,b,E=at){const{context:B,zip215:C}=E,A=n.BYTES;y=W$3("signature",y,2*A),f=W$3("message",f),b=W$3("publicKey",b,A),C!==void 0&&Tt$1("zip215",C),o&&(f=o(f));const U=Et$1(y.slice(A,2*A));let _,T,$;try{_=d.fromHex(b,C),T=d.fromHex(y.slice(0,A),C),$=m.multiplyUnsafe(U);}catch{return  false}if(!C&&_.isSmallOrder())return  false;const R=tt(B,T.toRawBytes(),_.toRawBytes(),f);return T.add(_.multiplyUnsafe(R)).subtract($).clearCofactor().equals(d.ZERO)}return m._setWindowSize(8),{CURVE:e,getPublicKey:ot,sign:st,verify:Ct,ExtendedPoint:d,utils:{getExtendedPublicKey:O,randomPrivateKey:()=>a(n.BYTES),precompute(y=8,f=d.BASE){return f._setWindowSize(y),f.multiply(BigInt(3)),f}}}}BigInt(0),BigInt(1);const kt$1=BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949"),Ue$1=BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");BigInt(0);const xr$1=BigInt(1),Te$1=BigInt(2);BigInt(3);const Br=BigInt(5),Cr$1=BigInt(8);function Ar$1(t){const e=BigInt(10),n=BigInt(20),r=BigInt(40),o=BigInt(80),s=kt$1,u=t*t%s*t%s,i=J$2(u,Te$1,s)*u%s,D=J$2(i,xr$1,s)*t%s,c=J$2(D,Br,s)*D%s,l=J$2(c,e,s)*c%s,p=J$2(l,n,s)*l%s,w=J$2(p,r,s)*p%s,h=J$2(w,o,s)*w%s,g=J$2(h,o,s)*w%s,S=J$2(g,e,s)*c%s;return {pow_p_5_8:J$2(S,Te$1,s)*t%s,b2:u}}function mr$1(t){return t[0]&=248,t[31]&=127,t[31]|=64,t}function _r$1(t,e){const n=kt$1,r=H$1(e*e*e,n),o=H$1(r*r*e,n),s=Ar$1(t*o).pow_p_5_8;let a=H$1(t*r*s,n);const u=H$1(e*a*a,n),i=a,D=H$1(a*Ue$1,n),c=u===t,l=u===H$1(-t,n),p=u===H$1(-t*Ue$1,n);return c&&(a=i),(l||p)&&(a=D),ur$1(a,n)&&(a=H$1(-a,n)),{isValid:c||l,value:a}}const Sr$1=(()=>_e$1(kt$1,void 0,true))(),vr$1=(()=>({a:BigInt(-1),d:BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),Fp:Sr$1,n:BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),h:Cr$1,Gx:BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),Gy:BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),hash:Kn,randomBytes:he$2,adjustScalarBytes:mr$1,uvRatio:_r$1}))(),Rt$1=(()=>yr$1(vr$1))(),jt$1="EdDSA",Zt="JWT",ut$1=".",Dt$1="base64url",Gt$1="utf8",xt$1="utf8",Vt$1=":",Yt$1="did",Jt$1="key",dt$1="base58btc",Kt$1="z",Wt="K36",Ne$1=32;function Xt(t){return globalThis.Buffer!=null?new Uint8Array(t.buffer,t.byteOffset,t.byteLength):t}function Le$2(t=0){return globalThis.Buffer!=null&&globalThis.Buffer.allocUnsafe!=null?Xt(globalThis.Buffer.allocUnsafe(t)):new Uint8Array(t)}function Oe(t,e){e||(e=t.reduce((o,s)=>o+s.length,0));const n=Le$2(e);let r=0;for(const o of t)n.set(o,r),r+=o.length;return Xt(n)}function Ir$1(t,e){if(t.length>=255)throw new TypeError("Alphabet too long");for(var n=new Uint8Array(256),r=0;r<n.length;r++)n[r]=255;for(var o=0;o<t.length;o++){var s=t.charAt(o),a=s.charCodeAt(0);if(n[a]!==255)throw new TypeError(s+" is ambiguous");n[a]=o;}var u=t.length,i=t.charAt(0),D=Math.log(u)/Math.log(256),c=Math.log(256)/Math.log(u);function l(h){if(h instanceof Uint8Array||(ArrayBuffer.isView(h)?h=new Uint8Array(h.buffer,h.byteOffset,h.byteLength):Array.isArray(h)&&(h=Uint8Array.from(h))),!(h instanceof Uint8Array))throw new TypeError("Expected Uint8Array");if(h.length===0)return "";for(var g=0,S=0,v=0,L=h.length;v!==L&&h[v]===0;)v++,g++;for(var d=(L-v)*c+1>>>0,m=new Uint8Array(d);v!==L;){for(var F=h[v],q=0,z=d-1;(F!==0||q<S)&&z!==-1;z--,q++)F+=256*m[z]>>>0,m[z]=F%u>>>0,F=F/u>>>0;if(F!==0)throw new Error("Non-zero carry");S=q,v++;}for(var I=d-S;I!==d&&m[I]===0;)I++;for(var O=i.repeat(g);I<d;++I)O+=t.charAt(m[I]);return O}function p(h){if(typeof h!="string")throw new TypeError("Expected String");if(h.length===0)return new Uint8Array;var g=0;if(h[g]!==" "){for(var S=0,v=0;h[g]===i;)S++,g++;for(var L=(h.length-g)*D+1>>>0,d=new Uint8Array(L);h[g];){var m=n[h.charCodeAt(g)];if(m===255)return;for(var F=0,q=L-1;(m!==0||F<v)&&q!==-1;q--,F++)m+=u*d[q]>>>0,d[q]=m%256>>>0,m=m/256>>>0;if(m!==0)throw new Error("Non-zero carry");v=F,g++;}if(h[g]!==" "){for(var z=L-v;z!==L&&d[z]===0;)z++;for(var I=new Uint8Array(S+(L-z)),O=S;z!==L;)I[O++]=d[z++];return I}}}function w(h){var g=p(h);if(g)return g;throw new Error(`Non-${e} character`)}return {encode:l,decodeUnsafe:p,decode:w}}var Ur$1=Ir$1,Tr$1=Ur$1;const He$1=t=>{if(t instanceof Uint8Array&&t.constructor.name==="Uint8Array")return t;if(t instanceof ArrayBuffer)return new Uint8Array(t);if(ArrayBuffer.isView(t))return new Uint8Array(t.buffer,t.byteOffset,t.byteLength);throw new Error("Unknown type, must be binary type")},Fr$1=t=>new TextEncoder().encode(t),Nr$1=t=>new TextDecoder().decode(t);let Lr$1 = class Lr{constructor(e,n,r){this.name=e,this.prefix=n,this.baseEncode=r;}encode(e){if(e instanceof Uint8Array)return `${this.prefix}${this.baseEncode(e)}`;throw Error("Unknown type, must be binary type")}};let Or$1 = class Or{constructor(e,n,r){if(this.name=e,this.prefix=n,n.codePointAt(0)===void 0)throw new Error("Invalid prefix character");this.prefixCodePoint=n.codePointAt(0),this.baseDecode=r;}decode(e){if(typeof e=="string"){if(e.codePointAt(0)!==this.prefixCodePoint)throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);return this.baseDecode(e.slice(this.prefix.length))}else throw Error("Can only multibase decode strings")}or(e){return ze$1(this,e)}};class Hr{constructor(e){this.decoders=e;}or(e){return ze$1(this,e)}decode(e){const n=e[0],r=this.decoders[n];if(r)return r.decode(e);throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`)}}const ze$1=(t,e)=>new Hr({...t.decoders||{[t.prefix]:t},...e.decoders||{[e.prefix]:e}});let zr$1 = class zr{constructor(e,n,r,o){this.name=e,this.prefix=n,this.baseEncode=r,this.baseDecode=o,this.encoder=new Lr$1(e,n,r),this.decoder=new Or$1(e,n,o);}encode(e){return this.encoder.encode(e)}decode(e){return this.decoder.decode(e)}};const Bt$1=({name:t,prefix:e,encode:n,decode:r})=>new zr$1(t,e,n,r),ht$1=({prefix:t,name:e,alphabet:n})=>{const{encode:r,decode:o}=Tr$1(n,e);return Bt$1({prefix:t,name:e,encode:r,decode:s=>He$1(o(s))})},Mr$1=(t,e,n,r)=>{const o={};for(let c=0;c<e.length;++c)o[e[c]]=c;let s=t.length;for(;t[s-1]==="=";)--s;const a=new Uint8Array(s*n/8|0);let u=0,i=0,D=0;for(let c=0;c<s;++c){const l=o[t[c]];if(l===void 0)throw new SyntaxError(`Non-${r} character`);i=i<<n|l,u+=n,u>=8&&(u-=8,a[D++]=255&i>>u);}if(u>=n||255&i<<8-u)throw new SyntaxError("Unexpected end of data");return a},qr=(t,e,n)=>{const r=e[e.length-1]==="=",o=(1<<n)-1;let s="",a=0,u=0;for(let i=0;i<t.length;++i)for(u=u<<8|t[i],a+=8;a>n;)a-=n,s+=e[o&u>>a];if(a&&(s+=e[o&u<<n-a]),r)for(;s.length*n&7;)s+="=";return s},k$2=({name:t,prefix:e,bitsPerChar:n,alphabet:r})=>Bt$1({prefix:e,name:t,encode(o){return qr(o,r,n)},decode(o){return Mr$1(o,r,n,t)}}),$r$1=Bt$1({prefix:"\0",name:"identity",encode:t=>Nr$1(t),decode:t=>Fr$1(t)});var kr=Object.freeze({__proto__:null,identity:$r$1});const Rr$1=k$2({prefix:"0",name:"base2",alphabet:"01",bitsPerChar:1});var jr=Object.freeze({__proto__:null,base2:Rr$1});const Zr=k$2({prefix:"7",name:"base8",alphabet:"01234567",bitsPerChar:3});var Gr=Object.freeze({__proto__:null,base8:Zr});const Vr=ht$1({prefix:"9",name:"base10",alphabet:"0123456789"});var Yr=Object.freeze({__proto__:null,base10:Vr});const Jr=k$2({prefix:"f",name:"base16",alphabet:"0123456789abcdef",bitsPerChar:4}),Kr=k$2({prefix:"F",name:"base16upper",alphabet:"0123456789ABCDEF",bitsPerChar:4});var Wr=Object.freeze({__proto__:null,base16:Jr,base16upper:Kr});const Xr=k$2({prefix:"b",name:"base32",alphabet:"abcdefghijklmnopqrstuvwxyz234567",bitsPerChar:5}),Pr$1=k$2({prefix:"B",name:"base32upper",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",bitsPerChar:5}),Qr=k$2({prefix:"c",name:"base32pad",alphabet:"abcdefghijklmnopqrstuvwxyz234567=",bitsPerChar:5}),to=k$2({prefix:"C",name:"base32padupper",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",bitsPerChar:5}),eo=k$2({prefix:"v",name:"base32hex",alphabet:"0123456789abcdefghijklmnopqrstuv",bitsPerChar:5}),no=k$2({prefix:"V",name:"base32hexupper",alphabet:"0123456789ABCDEFGHIJKLMNOPQRSTUV",bitsPerChar:5}),ro=k$2({prefix:"t",name:"base32hexpad",alphabet:"0123456789abcdefghijklmnopqrstuv=",bitsPerChar:5}),oo=k$2({prefix:"T",name:"base32hexpadupper",alphabet:"0123456789ABCDEFGHIJKLMNOPQRSTUV=",bitsPerChar:5}),so=k$2({prefix:"h",name:"base32z",alphabet:"ybndrfg8ejkmcpqxot1uwisza345h769",bitsPerChar:5});var io=Object.freeze({__proto__:null,base32:Xr,base32upper:Pr$1,base32pad:Qr,base32padupper:to,base32hex:eo,base32hexupper:no,base32hexpad:ro,base32hexpadupper:oo,base32z:so});const uo=ht$1({prefix:"k",name:"base36",alphabet:"0123456789abcdefghijklmnopqrstuvwxyz"}),co=ht$1({prefix:"K",name:"base36upper",alphabet:"0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"});var ao=Object.freeze({__proto__:null,base36:uo,base36upper:co});const fo=ht$1({name:"base58btc",prefix:"z",alphabet:"123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"}),Do=ht$1({name:"base58flickr",prefix:"Z",alphabet:"123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"});var ho=Object.freeze({__proto__:null,base58btc:fo,base58flickr:Do});const lo=k$2({prefix:"m",name:"base64",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",bitsPerChar:6}),bo=k$2({prefix:"M",name:"base64pad",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",bitsPerChar:6}),po=k$2({prefix:"u",name:"base64url",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",bitsPerChar:6}),wo=k$2({prefix:"U",name:"base64urlpad",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",bitsPerChar:6});var Eo=Object.freeze({__proto__:null,base64:lo,base64pad:bo,base64url:po,base64urlpad:wo});const Me$1=Array.from("\u{1F680}\u{1FA90}\u2604\u{1F6F0}\u{1F30C}\u{1F311}\u{1F312}\u{1F313}\u{1F314}\u{1F315}\u{1F316}\u{1F317}\u{1F318}\u{1F30D}\u{1F30F}\u{1F30E}\u{1F409}\u2600\u{1F4BB}\u{1F5A5}\u{1F4BE}\u{1F4BF}\u{1F602}\u2764\u{1F60D}\u{1F923}\u{1F60A}\u{1F64F}\u{1F495}\u{1F62D}\u{1F618}\u{1F44D}\u{1F605}\u{1F44F}\u{1F601}\u{1F525}\u{1F970}\u{1F494}\u{1F496}\u{1F499}\u{1F622}\u{1F914}\u{1F606}\u{1F644}\u{1F4AA}\u{1F609}\u263A\u{1F44C}\u{1F917}\u{1F49C}\u{1F614}\u{1F60E}\u{1F607}\u{1F339}\u{1F926}\u{1F389}\u{1F49E}\u270C\u2728\u{1F937}\u{1F631}\u{1F60C}\u{1F338}\u{1F64C}\u{1F60B}\u{1F497}\u{1F49A}\u{1F60F}\u{1F49B}\u{1F642}\u{1F493}\u{1F929}\u{1F604}\u{1F600}\u{1F5A4}\u{1F603}\u{1F4AF}\u{1F648}\u{1F447}\u{1F3B6}\u{1F612}\u{1F92D}\u2763\u{1F61C}\u{1F48B}\u{1F440}\u{1F62A}\u{1F611}\u{1F4A5}\u{1F64B}\u{1F61E}\u{1F629}\u{1F621}\u{1F92A}\u{1F44A}\u{1F973}\u{1F625}\u{1F924}\u{1F449}\u{1F483}\u{1F633}\u270B\u{1F61A}\u{1F61D}\u{1F634}\u{1F31F}\u{1F62C}\u{1F643}\u{1F340}\u{1F337}\u{1F63B}\u{1F613}\u2B50\u2705\u{1F97A}\u{1F308}\u{1F608}\u{1F918}\u{1F4A6}\u2714\u{1F623}\u{1F3C3}\u{1F490}\u2639\u{1F38A}\u{1F498}\u{1F620}\u261D\u{1F615}\u{1F33A}\u{1F382}\u{1F33B}\u{1F610}\u{1F595}\u{1F49D}\u{1F64A}\u{1F639}\u{1F5E3}\u{1F4AB}\u{1F480}\u{1F451}\u{1F3B5}\u{1F91E}\u{1F61B}\u{1F534}\u{1F624}\u{1F33C}\u{1F62B}\u26BD\u{1F919}\u2615\u{1F3C6}\u{1F92B}\u{1F448}\u{1F62E}\u{1F646}\u{1F37B}\u{1F343}\u{1F436}\u{1F481}\u{1F632}\u{1F33F}\u{1F9E1}\u{1F381}\u26A1\u{1F31E}\u{1F388}\u274C\u270A\u{1F44B}\u{1F630}\u{1F928}\u{1F636}\u{1F91D}\u{1F6B6}\u{1F4B0}\u{1F353}\u{1F4A2}\u{1F91F}\u{1F641}\u{1F6A8}\u{1F4A8}\u{1F92C}\u2708\u{1F380}\u{1F37A}\u{1F913}\u{1F619}\u{1F49F}\u{1F331}\u{1F616}\u{1F476}\u{1F974}\u25B6\u27A1\u2753\u{1F48E}\u{1F4B8}\u2B07\u{1F628}\u{1F31A}\u{1F98B}\u{1F637}\u{1F57A}\u26A0\u{1F645}\u{1F61F}\u{1F635}\u{1F44E}\u{1F932}\u{1F920}\u{1F927}\u{1F4CC}\u{1F535}\u{1F485}\u{1F9D0}\u{1F43E}\u{1F352}\u{1F617}\u{1F911}\u{1F30A}\u{1F92F}\u{1F437}\u260E\u{1F4A7}\u{1F62F}\u{1F486}\u{1F446}\u{1F3A4}\u{1F647}\u{1F351}\u2744\u{1F334}\u{1F4A3}\u{1F438}\u{1F48C}\u{1F4CD}\u{1F940}\u{1F922}\u{1F445}\u{1F4A1}\u{1F4A9}\u{1F450}\u{1F4F8}\u{1F47B}\u{1F910}\u{1F92E}\u{1F3BC}\u{1F975}\u{1F6A9}\u{1F34E}\u{1F34A}\u{1F47C}\u{1F48D}\u{1F4E3}\u{1F942}"),go=Me$1.reduce((t,e,n)=>(t[n]=e,t),[]),yo=Me$1.reduce((t,e,n)=>(t[e.codePointAt(0)]=n,t),[]);function xo(t){return t.reduce((e,n)=>(e+=go[n],e),"")}function Bo(t){const e=[];for(const n of t){const r=yo[n.codePointAt(0)];if(r===void 0)throw new Error(`Non-base256emoji character: ${n}`);e.push(r);}return new Uint8Array(e)}const Co=Bt$1({prefix:"\u{1F680}",name:"base256emoji",encode:xo,decode:Bo});var Ao=Object.freeze({__proto__:null,base256emoji:Co}),mo=$e$1,qe$1=128,So=-128,vo=Math.pow(2,31);function $e$1(t,e,n){e=e||[],n=n||0;for(var r=n;t>=vo;)e[n++]=t&255|qe$1,t/=128;for(;t&So;)e[n++]=t&255|qe$1,t>>>=7;return e[n]=t|0,$e$1.bytes=n-r+1,e}var Io=Pt$1,Uo=128,ke$2=127;function Pt$1(t,r){var n=0,r=r||0,o=0,s=r,a,u=t.length;do{if(s>=u)throw Pt$1.bytes=0,new RangeError("Could not decode varint");a=t[s++],n+=o<28?(a&ke$2)<<o:(a&ke$2)*Math.pow(2,o),o+=7;}while(a>=Uo);return Pt$1.bytes=s-r,n}var To=Math.pow(2,7),Fo=Math.pow(2,14),No=Math.pow(2,21),Lo=Math.pow(2,28),Oo=Math.pow(2,35),Ho=Math.pow(2,42),zo=Math.pow(2,49),Mo=Math.pow(2,56),qo=Math.pow(2,63),$o=function(t){return t<To?1:t<Fo?2:t<No?3:t<Lo?4:t<Oo?5:t<Ho?6:t<zo?7:t<Mo?8:t<qo?9:10},ko={encode:mo,decode:Io,encodingLength:$o},Re=ko;const je$1=(t,e,n=0)=>(Re.encode(t,e,n),e),Ze$1=t=>Re.encodingLength(t),Qt=(t,e)=>{const n=e.byteLength,r=Ze$1(t),o=r+Ze$1(n),s=new Uint8Array(o+n);return je$1(t,s,0),je$1(n,s,r),s.set(e,o),new Ro(t,n,e,s)};class Ro{constructor(e,n,r,o){this.code=e,this.size=n,this.digest=r,this.bytes=o;}}const Ge$1=({name:t,code:e,encode:n})=>new jo(t,e,n);class jo{constructor(e,n,r){this.name=e,this.code=n,this.encode=r;}digest(e){if(e instanceof Uint8Array){const n=this.encode(e);return n instanceof Uint8Array?Qt(this.code,n):n.then(r=>Qt(this.code,r))}else throw Error("Unknown type, must be binary type")}}const Ve$1=t=>async e=>new Uint8Array(await crypto.subtle.digest(t,e)),Zo=Ge$1({name:"sha2-256",code:18,encode:Ve$1("SHA-256")}),Go=Ge$1({name:"sha2-512",code:19,encode:Ve$1("SHA-512")});var Vo=Object.freeze({__proto__:null,sha256:Zo,sha512:Go});const Ye$1=0,Yo="identity",Je$1=He$1,Jo=t=>Qt(Ye$1,Je$1(t)),Ko={code:Ye$1,name:Yo,encode:Je$1,digest:Jo};var Wo=Object.freeze({__proto__:null,identity:Ko});new TextEncoder,new TextDecoder;const Ke$1={...kr,...jr,...Gr,...Yr,...Wr,...io,...ao,...ho,...Eo,...Ao};({...Vo,...Wo});function We$1(t,e,n,r){return {name:t,prefix:e,encoder:{name:t,prefix:e,encode:n},decoder:{decode:r}}}const Xe$1=We$1("utf8","u",t=>"u"+new TextDecoder("utf8").decode(t),t=>new TextEncoder().encode(t.substring(1))),te$1=We$1("ascii","a",t=>{let e="a";for(let n=0;n<t.length;n++)e+=String.fromCharCode(t[n]);return e},t=>{t=t.substring(1);const e=Le$2(t.length);for(let n=0;n<t.length;n++)e[n]=t.charCodeAt(n);return e}),Pe={utf8:Xe$1,"utf-8":Xe$1,hex:Ke$1.base16,latin1:te$1,ascii:te$1,binary:te$1,...Ke$1};function ct$1(t,e="utf8"){const n=Pe[e];if(!n)throw new Error(`Unsupported encoding "${e}"`);return (e==="utf8"||e==="utf-8")&&globalThis.Buffer!=null&&globalThis.Buffer.from!=null?globalThis.Buffer.from(t.buffer,t.byteOffset,t.byteLength).toString("utf8"):n.encoder.encode(t).substring(1)}function rt$1(t,e="utf8"){const n=Pe[e];if(!n)throw new Error(`Unsupported encoding "${e}"`);return (e==="utf8"||e==="utf-8")&&globalThis.Buffer!=null&&globalThis.Buffer.from!=null?Xt(globalThis.Buffer.from(t,"utf-8")):n.decoder.decode(`${n.prefix}${t}`)}function bt$1(t){return ct$1(rt$1(safeJsonStringify(t),Gt$1),Dt$1)}function Qe$1(t){const e=rt$1(Wt,dt$1),n=Kt$1+ct$1(Oe([e,t]),dt$1);return [Yt$1,Jt$1,n].join(Vt$1)}function en$1(t){return ct$1(t,Dt$1)}function rn(t){return rt$1([bt$1(t.header),bt$1(t.payload)].join(ut$1),xt$1)}function on(t){return [bt$1(t.header),bt$1(t.payload),en$1(t.signature)].join(ut$1)}function Po(t=he$2(Ne$1)){const e=Rt$1.getPublicKey(t);return {secretKey:Oe([t,e]),publicKey:e}}async function Qo(t,e,n,r,o=cjsExports$4.fromMiliseconds(Date.now())){const s={alg:jt$1,typ:Zt},a=Qe$1(r.publicKey),u=o+n,i={iss:a,sub:t,aud:e,iat:o,exp:u},D=rn({header:s,payload:i}),c=Rt$1.sign(D,r.secretKey.slice(0,32));return on({header:s,payload:i,signature:c})}

const PARSE_ERROR = "PARSE_ERROR";
const INVALID_REQUEST$1 = "INVALID_REQUEST";
const METHOD_NOT_FOUND = "METHOD_NOT_FOUND";
const INVALID_PARAMS = "INVALID_PARAMS";
const INTERNAL_ERROR = "INTERNAL_ERROR";
const SERVER_ERROR = "SERVER_ERROR";
const RESERVED_ERROR_CODES = [-32700, -32600, -32601, -32602, -32603];
const STANDARD_ERROR_MAP = {
    [PARSE_ERROR]: { code: -32700, message: "Parse error" },
    [INVALID_REQUEST$1]: { code: -32600, message: "Invalid Request" },
    [METHOD_NOT_FOUND]: { code: -32601, message: "Method not found" },
    [INVALID_PARAMS]: { code: -32602, message: "Invalid params" },
    [INTERNAL_ERROR]: { code: -32603, message: "Internal error" },
    [SERVER_ERROR]: { code: -32e3, message: "Server error" },
};
const DEFAULT_ERROR = SERVER_ERROR;

function isReservedErrorCode(code) {
    return RESERVED_ERROR_CODES.includes(code);
}
function getError(type) {
    if (!Object.keys(STANDARD_ERROR_MAP).includes(type)) {
        return STANDARD_ERROR_MAP[DEFAULT_ERROR];
    }
    return STANDARD_ERROR_MAP[type];
}
function getErrorByCode(code) {
    const match = Object.values(STANDARD_ERROR_MAP).find(e => e.code === code);
    if (!match) {
        return STANDARD_ERROR_MAP[DEFAULT_ERROR];
    }
    return match;
}
function parseConnectionError(e, url, type) {
    return e.message.includes("getaddrinfo ENOTFOUND") || e.message.includes("connect ECONNREFUSED")
        ? new Error(`Unavailable ${type} RPC url at ${url}`)
        : e;
}

var cjs = {};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics$1 = function(d, b) {
    extendStatics$1 = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics$1(d, b);
};

function __extends$1(d, b) {
    extendStatics$1(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$2(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter$5(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values$1(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read$1(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read$1(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values$1 === "function" ? __values$1(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet$1(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet$1(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

var tslib_es6 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	get __assign () { return __assign$1; },
	__asyncDelegator: __asyncDelegator,
	__asyncGenerator: __asyncGenerator,
	__asyncValues: __asyncValues,
	__await: __await,
	__awaiter: __awaiter$5,
	__classPrivateFieldGet: __classPrivateFieldGet$1,
	__classPrivateFieldSet: __classPrivateFieldSet$1,
	__createBinding: __createBinding,
	__decorate: __decorate,
	__exportStar: __exportStar,
	__extends: __extends$1,
	__generator: __generator,
	__importDefault: __importDefault,
	__importStar: __importStar,
	__makeTemplateObject: __makeTemplateObject,
	__metadata: __metadata,
	__param: __param,
	__read: __read$1,
	__rest: __rest$2,
	__spread: __spread,
	__spreadArrays: __spreadArrays,
	__values: __values$1
});

var require$$0$2 = /*@__PURE__*/getAugmentedNamespace(tslib_es6);

var crypto$2 = {};

var hasRequiredCrypto$1;

function requireCrypto$1 () {
	if (hasRequiredCrypto$1) return crypto$2;
	hasRequiredCrypto$1 = 1;
	Object.defineProperty(crypto$2, "__esModule", { value: true });
	crypto$2.isBrowserCryptoAvailable = crypto$2.getSubtleCrypto = crypto$2.getBrowerCrypto = void 0;
	function getBrowerCrypto() {
	    return (commonjsGlobal === null || commonjsGlobal === void 0 ? void 0 : commonjsGlobal.crypto) || (commonjsGlobal === null || commonjsGlobal === void 0 ? void 0 : commonjsGlobal.msCrypto) || {};
	}
	crypto$2.getBrowerCrypto = getBrowerCrypto;
	function getSubtleCrypto() {
	    const browserCrypto = getBrowerCrypto();
	    return browserCrypto.subtle || browserCrypto.webkitSubtle;
	}
	crypto$2.getSubtleCrypto = getSubtleCrypto;
	function isBrowserCryptoAvailable() {
	    return !!getBrowerCrypto() && !!getSubtleCrypto();
	}
	crypto$2.isBrowserCryptoAvailable = isBrowserCryptoAvailable;
	
	return crypto$2;
}

var env = {};

var hasRequiredEnv;

function requireEnv () {
	if (hasRequiredEnv) return env;
	hasRequiredEnv = 1;
	Object.defineProperty(env, "__esModule", { value: true });
	env.isBrowser = env.isNode = env.isReactNative = void 0;
	function isReactNative() {
	    return (typeof document === "undefined" &&
	        typeof navigator !== "undefined" &&
	        navigator.product === "ReactNative");
	}
	env.isReactNative = isReactNative;
	function isNode() {
	    return (typeof process !== "undefined" &&
	        typeof process.versions !== "undefined" &&
	        typeof process.versions.node !== "undefined");
	}
	env.isNode = isNode;
	function isBrowser() {
	    return !isReactNative() && !isNode();
	}
	env.isBrowser = isBrowser;
	
	return env;
}

var hasRequiredCjs;

function requireCjs () {
	if (hasRequiredCjs) return cjs;
	hasRequiredCjs = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		const tslib_1 = require$$0$2;
		tslib_1.__exportStar(requireCrypto$1(), exports);
		tslib_1.__exportStar(requireEnv(), exports);
		
	} (cjs));
	return cjs;
}

var cjsExports = requireCjs();

function payloadId(entropy = 3) {
    const date = Date.now() * Math.pow(10, entropy);
    const extra = Math.floor(Math.random() * Math.pow(10, entropy));
    return date + extra;
}
function getBigIntRpcId(entropy = 6) {
    return BigInt(payloadId(entropy));
}
function formatJsonRpcRequest(method, params, id) {
    return {
        id: id || payloadId(),
        jsonrpc: "2.0",
        method,
        params,
    };
}
function formatJsonRpcResult(id, result) {
    return {
        id,
        jsonrpc: "2.0",
        result,
    };
}
function formatJsonRpcError(id, error, data) {
    return {
        id,
        jsonrpc: "2.0",
        error: formatErrorMessage(error),
    };
}
function formatErrorMessage(error, data) {
    if (typeof error === "undefined") {
        return getError(INTERNAL_ERROR);
    }
    if (typeof error === "string") {
        error = Object.assign(Object.assign({}, getError(SERVER_ERROR)), { message: error });
    }
    if (isReservedErrorCode(error.code)) {
        error = getErrorByCode(error.code);
    }
    return error;
}

let e$2 = class e{};let n$1 = class n extends e$2{constructor(){super();}};let r$3 = class r extends n$1{constructor(c){super();}};

const HTTP_REGEX = "^https?:";
const WS_REGEX = "^wss?:";
function getUrlProtocol(url) {
    const matches = url.match(new RegExp(/^\w+:/, "gi"));
    if (!matches || !matches.length)
        return;
    return matches[0];
}
function matchRegexProtocol(url, regex) {
    const protocol = getUrlProtocol(url);
    if (typeof protocol === "undefined")
        return false;
    return new RegExp(regex).test(protocol);
}
function isHttpUrl(url) {
    return matchRegexProtocol(url, HTTP_REGEX);
}
function isWsUrl(url) {
    return matchRegexProtocol(url, WS_REGEX);
}
function isLocalhostUrl(url) {
    return new RegExp("wss?://localhost(:d{2,5})?").test(url);
}

function isJsonRpcPayload(payload) {
    return (typeof payload === "object" &&
        "id" in payload &&
        "jsonrpc" in payload &&
        payload.jsonrpc === "2.0");
}
function isJsonRpcRequest(payload) {
    return isJsonRpcPayload(payload) && "method" in payload;
}
function isJsonRpcResponse(payload) {
    return isJsonRpcPayload(payload) && (isJsonRpcResult(payload) || isJsonRpcError(payload));
}
function isJsonRpcResult(payload) {
    return "result" in payload;
}
function isJsonRpcError(payload) {
    return "error" in payload;
}

class JsonRpcProvider extends r$3 {
    constructor(connection) {
        super(connection);
        this.events = new EventEmitter$2();
        this.hasRegisteredEventListeners = false;
        this.connection = this.setConnection(connection);
        if (this.connection.connected) {
            this.registerEventListeners();
        }
    }
    async connect(connection = this.connection) {
        await this.open(connection);
    }
    async disconnect() {
        await this.close();
    }
    on(event, listener) {
        this.events.on(event, listener);
    }
    once(event, listener) {
        this.events.once(event, listener);
    }
    off(event, listener) {
        this.events.off(event, listener);
    }
    removeListener(event, listener) {
        this.events.removeListener(event, listener);
    }
    async request(request, context) {
        return this.requestStrict(formatJsonRpcRequest(request.method, request.params || [], request.id || getBigIntRpcId().toString()), context);
    }
    async requestStrict(request, context) {
        return new Promise(async (resolve, reject) => {
            if (!this.connection.connected) {
                try {
                    await this.open();
                }
                catch (e) {
                    reject(e);
                }
            }
            this.events.on(`${request.id}`, response => {
                if (isJsonRpcError(response)) {
                    reject(response.error);
                }
                else {
                    resolve(response.result);
                }
            });
            try {
                await this.connection.send(request, context);
            }
            catch (e) {
                reject(e);
            }
        });
    }
    setConnection(connection = this.connection) {
        return connection;
    }
    onPayload(payload) {
        this.events.emit("payload", payload);
        if (isJsonRpcResponse(payload)) {
            this.events.emit(`${payload.id}`, payload);
        }
        else {
            this.events.emit("message", {
                type: payload.method,
                data: payload.params,
            });
        }
    }
    onClose(event) {
        if (event && event.code === 3000) {
            this.events.emit("error", new Error(`WebSocket connection closed abnormally with code: ${event.code} ${event.reason ? `(${event.reason})` : ""}`));
        }
        this.events.emit("disconnect");
    }
    async open(connection = this.connection) {
        if (this.connection === connection && this.connection.connected)
            return;
        if (this.connection.connected)
            this.close();
        if (typeof connection === "string") {
            await this.connection.open(connection);
            connection = this.connection;
        }
        this.connection = this.setConnection(connection);
        await this.connection.open();
        this.registerEventListeners();
        this.events.emit("connect");
    }
    async close() {
        await this.connection.close();
    }
    registerEventListeners() {
        if (this.hasRegisteredEventListeners)
            return;
        this.connection.on("payload", (payload) => this.onPayload(payload));
        this.connection.on("close", (event) => this.onClose(event));
        this.connection.on("error", (error) => this.events.emit("error", error));
        this.connection.on("register_error", (error) => this.onClose());
        this.hasRegisteredEventListeners = true;
    }
}

const w$4=()=>typeof WebSocket<"u"?WebSocket:typeof global<"u"&&typeof global.WebSocket<"u"?global.WebSocket:typeof window<"u"&&typeof window.WebSocket<"u"?window.WebSocket:typeof self<"u"&&typeof self.WebSocket<"u"?self.WebSocket:require("ws"),b=()=>typeof WebSocket<"u"||typeof global<"u"&&typeof global.WebSocket<"u"||typeof window<"u"&&typeof window.WebSocket<"u"||typeof self<"u"&&typeof self.WebSocket<"u",a$2=c=>c.split("?")[0],h$1=10,S$2=w$4();let f$4 = class f{constructor(e){if(this.url=e,this.events=new EventEmitter$2,this.registering=false,!isWsUrl(e))throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);this.url=e;}get connected(){return typeof this.socket<"u"}get connecting(){return this.registering}on(e,t){this.events.on(e,t);}once(e,t){this.events.once(e,t);}off(e,t){this.events.off(e,t);}removeListener(e,t){this.events.removeListener(e,t);}async open(e=this.url){await this.register(e);}async close(){return new Promise((e,t)=>{if(typeof this.socket>"u"){t(new Error("Connection already closed"));return}this.socket.onclose=n=>{this.onClose(n),e();},this.socket.close();})}async send(e){typeof this.socket>"u"&&(this.socket=await this.register());try{this.socket.send(safeJsonStringify(e));}catch(t){this.onError(e.id,t);}}register(e=this.url){if(!isWsUrl(e))throw new Error(`Provided URL is not compatible with WebSocket connection: ${e}`);if(this.registering){const t=this.events.getMaxListeners();return (this.events.listenerCount("register_error")>=t||this.events.listenerCount("open")>=t)&&this.events.setMaxListeners(t+1),new Promise((n,o)=>{this.events.once("register_error",s=>{this.resetMaxListeners(),o(s);}),this.events.once("open",()=>{if(this.resetMaxListeners(),typeof this.socket>"u")return o(new Error("WebSocket connection is missing or invalid"));n(this.socket);});})}return this.url=e,this.registering=true,new Promise((t,n)=>{const o=new URLSearchParams(e).get("origin"),s=cjsExports.isReactNative()?{headers:{origin:o}}:{rejectUnauthorized:!isLocalhostUrl(e)},i=new S$2(e,[],s);b()?i.onerror=r=>{const l=r;n(this.emitError(l.error));}:i.on("error",r=>{n(this.emitError(r));}),i.onopen=()=>{this.onOpen(i),t(i);};})}onOpen(e){e.onmessage=t=>this.onPayload(t),e.onclose=t=>this.onClose(t),this.socket=e,this.registering=false,this.events.emit("open");}onClose(e){this.socket=void 0,this.registering=false,this.events.emit("close",e);}onPayload(e){if(typeof e.data>"u")return;const t=typeof e.data=="string"?safeJsonParse$1(e.data):e.data;this.events.emit("payload",t);}onError(e,t){const n=this.parseError(t),o=n.message||n.toString(),s=formatJsonRpcError(e,o);this.events.emit("payload",s);}parseError(e,t=this.url){return parseConnectionError(e,a$2(t),"WS")}resetMaxListeners(){this.events.getMaxListeners()>h$1&&this.events.setMaxListeners(h$1);}emitError(e){const t=this.parseError(new Error(e?.message||`WebSocket connection failed for host: ${a$2(this.url)}`));return this.events.emit("register_error",t),t}};

var lodash_isequal = {exports: {}};

/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash_isequal.exports;

var hasRequiredLodash_isequal;

function requireLodash_isequal () {
	if (hasRequiredLodash_isequal) return lodash_isequal.exports;
	hasRequiredLodash_isequal = 1;
	(function (module, exports) {
		/** Used as the size to enable large array optimizations. */
		var LARGE_ARRAY_SIZE = 200;

		/** Used to stand-in for `undefined` hash values. */
		var HASH_UNDEFINED = '__lodash_hash_undefined__';

		/** Used to compose bitmasks for value comparisons. */
		var COMPARE_PARTIAL_FLAG = 1,
		    COMPARE_UNORDERED_FLAG = 2;

		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;

		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]',
		    arrayTag = '[object Array]',
		    asyncTag = '[object AsyncFunction]',
		    boolTag = '[object Boolean]',
		    dateTag = '[object Date]',
		    errorTag = '[object Error]',
		    funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]',
		    mapTag = '[object Map]',
		    numberTag = '[object Number]',
		    nullTag = '[object Null]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    proxyTag = '[object Proxy]',
		    regexpTag = '[object RegExp]',
		    setTag = '[object Set]',
		    stringTag = '[object String]',
		    symbolTag = '[object Symbol]',
		    undefinedTag = '[object Undefined]',
		    weakMapTag = '[object WeakMap]';

		var arrayBufferTag = '[object ArrayBuffer]',
		    dataViewTag = '[object DataView]',
		    float32Tag = '[object Float32Array]',
		    float64Tag = '[object Float64Array]',
		    int8Tag = '[object Int8Array]',
		    int16Tag = '[object Int16Array]',
		    int32Tag = '[object Int32Array]',
		    uint8Tag = '[object Uint8Array]',
		    uint8ClampedTag = '[object Uint8ClampedArray]',
		    uint16Tag = '[object Uint16Array]',
		    uint32Tag = '[object Uint32Array]';

		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;

		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;

		/** Used to identify `toStringTag` values of typed arrays. */
		var typedArrayTags = {};
		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
		typedArrayTags[uint32Tag] = true;
		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
		typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
		typedArrayTags[errorTag] = typedArrayTags[funcTag] =
		typedArrayTags[mapTag] = typedArrayTags[numberTag] =
		typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
		typedArrayTags[setTag] = typedArrayTags[stringTag] =
		typedArrayTags[weakMapTag] = false;

		/** Detect free variable `global` from Node.js. */
		var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

		/** Detect free variable `self`. */
		var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || Function('return this')();

		/** Detect free variable `exports`. */
		var freeExports = exports && !exports.nodeType && exports;

		/** Detect free variable `module`. */
		var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;

		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;

		/** Used to access faster Node.js helpers. */
		var nodeUtil = (function() {
		  try {
		    return freeProcess && freeProcess.binding && freeProcess.binding('util');
		  } catch (e) {}
		}());

		/* Node.js helper references. */
		var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

		/**
		 * A specialized version of `_.filter` for arrays without support for
		 * iteratee shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {Array} Returns the new filtered array.
		 */
		function arrayFilter(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length,
		      resIndex = 0,
		      result = [];

		  while (++index < length) {
		    var value = array[index];
		    if (predicate(value, index, array)) {
		      result[resIndex++] = value;
		    }
		  }
		  return result;
		}

		/**
		 * Appends the elements of `values` to `array`.
		 *
		 * @private
		 * @param {Array} array The array to modify.
		 * @param {Array} values The values to append.
		 * @returns {Array} Returns `array`.
		 */
		function arrayPush(array, values) {
		  var index = -1,
		      length = values.length,
		      offset = array.length;

		  while (++index < length) {
		    array[offset + index] = values[index];
		  }
		  return array;
		}

		/**
		 * A specialized version of `_.some` for arrays without support for iteratee
		 * shorthands.
		 *
		 * @private
		 * @param {Array} [array] The array to iterate over.
		 * @param {Function} predicate The function invoked per iteration.
		 * @returns {boolean} Returns `true` if any element passes the predicate check,
		 *  else `false`.
		 */
		function arraySome(array, predicate) {
		  var index = -1,
		      length = array == null ? 0 : array.length;

		  while (++index < length) {
		    if (predicate(array[index], index, array)) {
		      return true;
		    }
		  }
		  return false;
		}

		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);

		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}

		/**
		 * The base implementation of `_.unary` without support for storing metadata.
		 *
		 * @private
		 * @param {Function} func The function to cap arguments for.
		 * @returns {Function} Returns the new capped function.
		 */
		function baseUnary(func) {
		  return function(value) {
		    return func(value);
		  };
		}

		/**
		 * Checks if a `cache` value for `key` exists.
		 *
		 * @private
		 * @param {Object} cache The cache to query.
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function cacheHas(cache, key) {
		  return cache.has(key);
		}

		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}

		/**
		 * Converts `map` to its key-value pairs.
		 *
		 * @private
		 * @param {Object} map The map to convert.
		 * @returns {Array} Returns the key-value pairs.
		 */
		function mapToArray(map) {
		  var index = -1,
		      result = Array(map.size);

		  map.forEach(function(value, key) {
		    result[++index] = [key, value];
		  });
		  return result;
		}

		/**
		 * Creates a unary function that invokes `func` with its argument transformed.
		 *
		 * @private
		 * @param {Function} func The function to wrap.
		 * @param {Function} transform The argument transform.
		 * @returns {Function} Returns the new function.
		 */
		function overArg(func, transform) {
		  return function(arg) {
		    return func(transform(arg));
		  };
		}

		/**
		 * Converts `set` to an array of its values.
		 *
		 * @private
		 * @param {Object} set The set to convert.
		 * @returns {Array} Returns the values.
		 */
		function setToArray(set) {
		  var index = -1,
		      result = Array(set.size);

		  set.forEach(function(value) {
		    result[++index] = value;
		  });
		  return result;
		}

		/** Used for built-in method references. */
		var arrayProto = Array.prototype,
		    funcProto = Function.prototype,
		    objectProto = Object.prototype;

		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];

		/** Used to resolve the decompiled source of functions. */
		var funcToString = funcProto.toString;

		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;

		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());

		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var nativeObjectToString = objectProto.toString;

		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);

		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined,
		    Symbol = root.Symbol,
		    Uint8Array = root.Uint8Array,
		    propertyIsEnumerable = objectProto.propertyIsEnumerable,
		    splice = arrayProto.splice,
		    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetSymbols = Object.getOwnPropertySymbols,
		    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
		    nativeKeys = overArg(Object.keys, Object);

		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView'),
		    Map = getNative(root, 'Map'),
		    Promise = getNative(root, 'Promise'),
		    Set = getNative(root, 'Set'),
		    WeakMap = getNative(root, 'WeakMap'),
		    nativeCreate = getNative(Object, 'create');

		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);

		/** Used to convert symbols to primitives and strings. */
		var symbolProto = Symbol ? Symbol.prototype : undefined,
		    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

		/**
		 * Creates a hash object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Hash(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the hash.
		 *
		 * @private
		 * @name clear
		 * @memberOf Hash
		 */
		function hashClear() {
		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the hash.
		 *
		 * @private
		 * @name delete
		 * @memberOf Hash
		 * @param {Object} hash The hash to modify.
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function hashDelete(key) {
		  var result = this.has(key) && delete this.__data__[key];
		  this.size -= result ? 1 : 0;
		  return result;
		}

		/**
		 * Gets the hash value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Hash
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function hashGet(key) {
		  var data = this.__data__;
		  if (nativeCreate) {
		    var result = data[key];
		    return result === HASH_UNDEFINED ? undefined : result;
		  }
		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
		}

		/**
		 * Checks if a hash value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Hash
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function hashHas(key) {
		  var data = this.__data__;
		  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
		}

		/**
		 * Sets the hash `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Hash
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the hash instance.
		 */
		function hashSet(key, value) {
		  var data = this.__data__;
		  this.size += this.has(key) ? 0 : 1;
		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
		  return this;
		}

		// Add methods to `Hash`.
		Hash.prototype.clear = hashClear;
		Hash.prototype['delete'] = hashDelete;
		Hash.prototype.get = hashGet;
		Hash.prototype.has = hashHas;
		Hash.prototype.set = hashSet;

		/**
		 * Creates an list cache object.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function ListCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the list cache.
		 *
		 * @private
		 * @name clear
		 * @memberOf ListCache
		 */
		function listCacheClear() {
		  this.__data__ = [];
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the list cache.
		 *
		 * @private
		 * @name delete
		 * @memberOf ListCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function listCacheDelete(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  if (index < 0) {
		    return false;
		  }
		  var lastIndex = data.length - 1;
		  if (index == lastIndex) {
		    data.pop();
		  } else {
		    splice.call(data, index, 1);
		  }
		  --this.size;
		  return true;
		}

		/**
		 * Gets the list cache value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf ListCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function listCacheGet(key) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  return index < 0 ? undefined : data[index][1];
		}

		/**
		 * Checks if a list cache value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf ListCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function listCacheHas(key) {
		  return assocIndexOf(this.__data__, key) > -1;
		}

		/**
		 * Sets the list cache `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf ListCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the list cache instance.
		 */
		function listCacheSet(key, value) {
		  var data = this.__data__,
		      index = assocIndexOf(data, key);

		  if (index < 0) {
		    ++this.size;
		    data.push([key, value]);
		  } else {
		    data[index][1] = value;
		  }
		  return this;
		}

		// Add methods to `ListCache`.
		ListCache.prototype.clear = listCacheClear;
		ListCache.prototype['delete'] = listCacheDelete;
		ListCache.prototype.get = listCacheGet;
		ListCache.prototype.has = listCacheHas;
		ListCache.prototype.set = listCacheSet;

		/**
		 * Creates a map cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function MapCache(entries) {
		  var index = -1,
		      length = entries == null ? 0 : entries.length;

		  this.clear();
		  while (++index < length) {
		    var entry = entries[index];
		    this.set(entry[0], entry[1]);
		  }
		}

		/**
		 * Removes all key-value entries from the map.
		 *
		 * @private
		 * @name clear
		 * @memberOf MapCache
		 */
		function mapCacheClear() {
		  this.size = 0;
		  this.__data__ = {
		    'hash': new Hash,
		    'map': new (Map || ListCache),
		    'string': new Hash
		  };
		}

		/**
		 * Removes `key` and its value from the map.
		 *
		 * @private
		 * @name delete
		 * @memberOf MapCache
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function mapCacheDelete(key) {
		  var result = getMapData(this, key)['delete'](key);
		  this.size -= result ? 1 : 0;
		  return result;
		}

		/**
		 * Gets the map value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf MapCache
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function mapCacheGet(key) {
		  return getMapData(this, key).get(key);
		}

		/**
		 * Checks if a map value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf MapCache
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function mapCacheHas(key) {
		  return getMapData(this, key).has(key);
		}

		/**
		 * Sets the map `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf MapCache
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the map cache instance.
		 */
		function mapCacheSet(key, value) {
		  var data = getMapData(this, key),
		      size = data.size;

		  data.set(key, value);
		  this.size += data.size == size ? 0 : 1;
		  return this;
		}

		// Add methods to `MapCache`.
		MapCache.prototype.clear = mapCacheClear;
		MapCache.prototype['delete'] = mapCacheDelete;
		MapCache.prototype.get = mapCacheGet;
		MapCache.prototype.has = mapCacheHas;
		MapCache.prototype.set = mapCacheSet;

		/**
		 *
		 * Creates an array cache object to store unique values.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [values] The values to cache.
		 */
		function SetCache(values) {
		  var index = -1,
		      length = values == null ? 0 : values.length;

		  this.__data__ = new MapCache;
		  while (++index < length) {
		    this.add(values[index]);
		  }
		}

		/**
		 * Adds `value` to the array cache.
		 *
		 * @private
		 * @name add
		 * @memberOf SetCache
		 * @alias push
		 * @param {*} value The value to cache.
		 * @returns {Object} Returns the cache instance.
		 */
		function setCacheAdd(value) {
		  this.__data__.set(value, HASH_UNDEFINED);
		  return this;
		}

		/**
		 * Checks if `value` is in the array cache.
		 *
		 * @private
		 * @name has
		 * @memberOf SetCache
		 * @param {*} value The value to search for.
		 * @returns {number} Returns `true` if `value` is found, else `false`.
		 */
		function setCacheHas(value) {
		  return this.__data__.has(value);
		}

		// Add methods to `SetCache`.
		SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
		SetCache.prototype.has = setCacheHas;

		/**
		 * Creates a stack cache object to store key-value pairs.
		 *
		 * @private
		 * @constructor
		 * @param {Array} [entries] The key-value pairs to cache.
		 */
		function Stack(entries) {
		  var data = this.__data__ = new ListCache(entries);
		  this.size = data.size;
		}

		/**
		 * Removes all key-value entries from the stack.
		 *
		 * @private
		 * @name clear
		 * @memberOf Stack
		 */
		function stackClear() {
		  this.__data__ = new ListCache;
		  this.size = 0;
		}

		/**
		 * Removes `key` and its value from the stack.
		 *
		 * @private
		 * @name delete
		 * @memberOf Stack
		 * @param {string} key The key of the value to remove.
		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
		 */
		function stackDelete(key) {
		  var data = this.__data__,
		      result = data['delete'](key);

		  this.size = data.size;
		  return result;
		}

		/**
		 * Gets the stack value for `key`.
		 *
		 * @private
		 * @name get
		 * @memberOf Stack
		 * @param {string} key The key of the value to get.
		 * @returns {*} Returns the entry value.
		 */
		function stackGet(key) {
		  return this.__data__.get(key);
		}

		/**
		 * Checks if a stack value for `key` exists.
		 *
		 * @private
		 * @name has
		 * @memberOf Stack
		 * @param {string} key The key of the entry to check.
		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
		 */
		function stackHas(key) {
		  return this.__data__.has(key);
		}

		/**
		 * Sets the stack `key` to `value`.
		 *
		 * @private
		 * @name set
		 * @memberOf Stack
		 * @param {string} key The key of the value to set.
		 * @param {*} value The value to set.
		 * @returns {Object} Returns the stack cache instance.
		 */
		function stackSet(key, value) {
		  var data = this.__data__;
		  if (data instanceof ListCache) {
		    var pairs = data.__data__;
		    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
		      pairs.push([key, value]);
		      this.size = ++data.size;
		      return this;
		    }
		    data = this.__data__ = new MapCache(pairs);
		  }
		  data.set(key, value);
		  this.size = data.size;
		  return this;
		}

		// Add methods to `Stack`.
		Stack.prototype.clear = stackClear;
		Stack.prototype['delete'] = stackDelete;
		Stack.prototype.get = stackGet;
		Stack.prototype.has = stackHas;
		Stack.prototype.set = stackSet;

		/**
		 * Creates an array of the enumerable property names of the array-like `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @param {boolean} inherited Specify returning inherited property names.
		 * @returns {Array} Returns the array of property names.
		 */
		function arrayLikeKeys(value, inherited) {
		  var isArr = isArray(value),
		      isArg = !isArr && isArguments(value),
		      isBuff = !isArr && !isArg && isBuffer(value),
		      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
		      skipIndexes = isArr || isArg || isBuff || isType,
		      result = skipIndexes ? baseTimes(value.length, String) : [],
		      length = result.length;

		  for (var key in value) {
		    if ((hasOwnProperty.call(value, key)) &&
		        !(skipIndexes && (
		           // Safari 9 has enumerable `arguments.length` in strict mode.
		           key == 'length' ||
		           // Node.js 0.10 has enumerable non-index properties on buffers.
		           (isBuff && (key == 'offset' || key == 'parent')) ||
		           // PhantomJS 2 has enumerable non-index properties on typed arrays.
		           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
		           // Skip index properties.
		           isIndex(key, length)
		        ))) {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * Gets the index at which the `key` is found in `array` of key-value pairs.
		 *
		 * @private
		 * @param {Array} array The array to inspect.
		 * @param {*} key The key to search for.
		 * @returns {number} Returns the index of the matched value, else `-1`.
		 */
		function assocIndexOf(array, key) {
		  var length = array.length;
		  while (length--) {
		    if (eq(array[length][0], key)) {
		      return length;
		    }
		  }
		  return -1;
		}

		/**
		 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
		 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
		 * symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {Function} keysFunc The function to get the keys of `object`.
		 * @param {Function} symbolsFunc The function to get the symbols of `object`.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function baseGetAllKeys(object, keysFunc, symbolsFunc) {
		  var result = keysFunc(object);
		  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
		}

		/**
		 * The base implementation of `getTag` without fallbacks for buggy environments.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function baseGetTag(value) {
		  if (value == null) {
		    return value === undefined ? undefinedTag : nullTag;
		  }
		  return (symToStringTag && symToStringTag in Object(value))
		    ? getRawTag(value)
		    : objectToString(value);
		}

		/**
		 * The base implementation of `_.isArguments`.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 */
		function baseIsArguments(value) {
		  return isObjectLike(value) && baseGetTag(value) == argsTag;
		}

		/**
		 * The base implementation of `_.isEqual` which supports partial comparisons
		 * and tracks traversed objects.
		 *
		 * @private
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @param {boolean} bitmask The bitmask flags.
		 *  1 - Unordered comparison
		 *  2 - Partial comparison
		 * @param {Function} [customizer] The function to customize comparisons.
		 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 */
		function baseIsEqual(value, other, bitmask, customizer, stack) {
		  if (value === other) {
		    return true;
		  }
		  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
		    return value !== value && other !== other;
		  }
		  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
		}

		/**
		 * A specialized version of `baseIsEqual` for arrays and objects which performs
		 * deep comparisons and tracks traversed objects enabling objects with circular
		 * references to be compared.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
		  var objIsArr = isArray(object),
		      othIsArr = isArray(other),
		      objTag = objIsArr ? arrayTag : getTag(object),
		      othTag = othIsArr ? arrayTag : getTag(other);

		  objTag = objTag == argsTag ? objectTag : objTag;
		  othTag = othTag == argsTag ? objectTag : othTag;

		  var objIsObj = objTag == objectTag,
		      othIsObj = othTag == objectTag,
		      isSameTag = objTag == othTag;

		  if (isSameTag && isBuffer(object)) {
		    if (!isBuffer(other)) {
		      return false;
		    }
		    objIsArr = true;
		    objIsObj = false;
		  }
		  if (isSameTag && !objIsObj) {
		    stack || (stack = new Stack);
		    return (objIsArr || isTypedArray(object))
		      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
		      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
		  }
		  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
		    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
		        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

		    if (objIsWrapped || othIsWrapped) {
		      var objUnwrapped = objIsWrapped ? object.value() : object,
		          othUnwrapped = othIsWrapped ? other.value() : other;

		      stack || (stack = new Stack);
		      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
		    }
		  }
		  if (!isSameTag) {
		    return false;
		  }
		  stack || (stack = new Stack);
		  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
		}

		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}

		/**
		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 */
		function baseIsTypedArray(value) {
		  return isObjectLike(value) &&
		    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
		}

		/**
		 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeys(object) {
		  if (!isPrototype(object)) {
		    return nativeKeys(object);
		  }
		  var result = [];
		  for (var key in Object(object)) {
		    if (hasOwnProperty.call(object, key) && key != 'constructor') {
		      result.push(key);
		    }
		  }
		  return result;
		}

		/**
		 * A specialized version of `baseIsEqualDeep` for arrays with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Array} array The array to compare.
		 * @param {Array} other The other array to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `array` and `other` objects.
		 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
		 */
		function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      arrLength = array.length,
		      othLength = other.length;

		  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
		    return false;
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(array);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var index = -1,
		      result = true,
		      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

		  stack.set(array, other);
		  stack.set(other, array);

		  // Ignore non-index properties.
		  while (++index < arrLength) {
		    var arrValue = array[index],
		        othValue = other[index];

		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, arrValue, index, other, array, stack)
		        : customizer(arrValue, othValue, index, array, other, stack);
		    }
		    if (compared !== undefined) {
		      if (compared) {
		        continue;
		      }
		      result = false;
		      break;
		    }
		    // Recursively compare arrays (susceptible to call stack limits).
		    if (seen) {
		      if (!arraySome(other, function(othValue, othIndex) {
		            if (!cacheHas(seen, othIndex) &&
		                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
		              return seen.push(othIndex);
		            }
		          })) {
		        result = false;
		        break;
		      }
		    } else if (!(
		          arrValue === othValue ||
		            equalFunc(arrValue, othValue, bitmask, customizer, stack)
		        )) {
		      result = false;
		      break;
		    }
		  }
		  stack['delete'](array);
		  stack['delete'](other);
		  return result;
		}

		/**
		 * A specialized version of `baseIsEqualDeep` for comparing objects of
		 * the same `toStringTag`.
		 *
		 * **Note:** This function only supports comparing values with tags of
		 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {string} tag The `toStringTag` of the objects to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
		  switch (tag) {
		    case dataViewTag:
		      if ((object.byteLength != other.byteLength) ||
		          (object.byteOffset != other.byteOffset)) {
		        return false;
		      }
		      object = object.buffer;
		      other = other.buffer;

		    case arrayBufferTag:
		      if ((object.byteLength != other.byteLength) ||
		          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
		        return false;
		      }
		      return true;

		    case boolTag:
		    case dateTag:
		    case numberTag:
		      // Coerce booleans to `1` or `0` and dates to milliseconds.
		      // Invalid dates are coerced to `NaN`.
		      return eq(+object, +other);

		    case errorTag:
		      return object.name == other.name && object.message == other.message;

		    case regexpTag:
		    case stringTag:
		      // Coerce regexes to strings and treat strings, primitives and objects,
		      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
		      // for more details.
		      return object == (other + '');

		    case mapTag:
		      var convert = mapToArray;

		    case setTag:
		      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
		      convert || (convert = setToArray);

		      if (object.size != other.size && !isPartial) {
		        return false;
		      }
		      // Assume cyclic values are equal.
		      var stacked = stack.get(object);
		      if (stacked) {
		        return stacked == other;
		      }
		      bitmask |= COMPARE_UNORDERED_FLAG;

		      // Recursively compare objects (susceptible to call stack limits).
		      stack.set(object, other);
		      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
		      stack['delete'](object);
		      return result;

		    case symbolTag:
		      if (symbolValueOf) {
		        return symbolValueOf.call(object) == symbolValueOf.call(other);
		      }
		  }
		  return false;
		}

		/**
		 * A specialized version of `baseIsEqualDeep` for objects with support for
		 * partial deep comparisons.
		 *
		 * @private
		 * @param {Object} object The object to compare.
		 * @param {Object} other The other object to compare.
		 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
		 * @param {Function} customizer The function to customize comparisons.
		 * @param {Function} equalFunc The function to determine equivalents of values.
		 * @param {Object} stack Tracks traversed `object` and `other` objects.
		 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
		 */
		function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
		  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
		      objProps = getAllKeys(object),
		      objLength = objProps.length,
		      othProps = getAllKeys(other),
		      othLength = othProps.length;

		  if (objLength != othLength && !isPartial) {
		    return false;
		  }
		  var index = objLength;
		  while (index--) {
		    var key = objProps[index];
		    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
		      return false;
		    }
		  }
		  // Assume cyclic values are equal.
		  var stacked = stack.get(object);
		  if (stacked && stack.get(other)) {
		    return stacked == other;
		  }
		  var result = true;
		  stack.set(object, other);
		  stack.set(other, object);

		  var skipCtor = isPartial;
		  while (++index < objLength) {
		    key = objProps[index];
		    var objValue = object[key],
		        othValue = other[key];

		    if (customizer) {
		      var compared = isPartial
		        ? customizer(othValue, objValue, key, other, object, stack)
		        : customizer(objValue, othValue, key, object, other, stack);
		    }
		    // Recursively compare objects (susceptible to call stack limits).
		    if (!(compared === undefined
		          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
		          : compared
		        )) {
		      result = false;
		      break;
		    }
		    skipCtor || (skipCtor = key == 'constructor');
		  }
		  if (result && !skipCtor) {
		    var objCtor = object.constructor,
		        othCtor = other.constructor;

		    // Non `Object` object instances with different constructors are not equal.
		    if (objCtor != othCtor &&
		        ('constructor' in object && 'constructor' in other) &&
		        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
		          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
		      result = false;
		    }
		  }
		  stack['delete'](object);
		  stack['delete'](other);
		  return result;
		}

		/**
		 * Creates an array of own enumerable property names and symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names and symbols.
		 */
		function getAllKeys(object) {
		  return baseGetAllKeys(object, keys, getSymbols);
		}

		/**
		 * Gets the data for `map`.
		 *
		 * @private
		 * @param {Object} map The map to query.
		 * @param {string} key The reference key.
		 * @returns {*} Returns the map data.
		 */
		function getMapData(map, key) {
		  var data = map.__data__;
		  return isKeyable(key)
		    ? data[typeof key == 'string' ? 'string' : 'hash']
		    : data.map;
		}

		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}

		/**
		 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the raw `toStringTag`.
		 */
		function getRawTag(value) {
		  var isOwn = hasOwnProperty.call(value, symToStringTag),
		      tag = value[symToStringTag];

		  try {
		    value[symToStringTag] = undefined;
		    var unmasked = true;
		  } catch (e) {}

		  var result = nativeObjectToString.call(value);
		  if (unmasked) {
		    if (isOwn) {
		      value[symToStringTag] = tag;
		    } else {
		      delete value[symToStringTag];
		    }
		  }
		  return result;
		}

		/**
		 * Creates an array of the own enumerable symbols of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of symbols.
		 */
		var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
		  if (object == null) {
		    return [];
		  }
		  object = Object(object);
		  return arrayFilter(nativeGetSymbols(object), function(symbol) {
		    return propertyIsEnumerable.call(object, symbol);
		  });
		};

		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		var getTag = baseGetTag;

		// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
		if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
		    (Map && getTag(new Map) != mapTag) ||
		    (Promise && getTag(Promise.resolve()) != promiseTag) ||
		    (Set && getTag(new Set) != setTag) ||
		    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
		  getTag = function(value) {
		    var result = baseGetTag(value),
		        Ctor = result == objectTag ? value.constructor : undefined,
		        ctorString = Ctor ? toSource(Ctor) : '';

		    if (ctorString) {
		      switch (ctorString) {
		        case dataViewCtorString: return dataViewTag;
		        case mapCtorString: return mapTag;
		        case promiseCtorString: return promiseTag;
		        case setCtorString: return setTag;
		        case weakMapCtorString: return weakMapTag;
		      }
		    }
		    return result;
		  };
		}

		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length &&
		    (typeof value == 'number' || reIsUint.test(value)) &&
		    (value > -1 && value % 1 == 0 && value < length);
		}

		/**
		 * Checks if `value` is suitable for use as unique object key.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
		 */
		function isKeyable(value) {
		  var type = typeof value;
		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
		    ? (value !== '__proto__')
		    : (value === null);
		}

		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}

		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

		  return value === proto;
		}

		/**
		 * Converts `value` to a string using `Object.prototype.toString`.
		 *
		 * @private
		 * @param {*} value The value to convert.
		 * @returns {string} Returns the converted string.
		 */
		function objectToString(value) {
		  return nativeObjectToString.call(value);
		}

		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to convert.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}

		/**
		 * Performs a
		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
		 * comparison between two values to determine if they are equivalent.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.eq(object, object);
		 * // => true
		 *
		 * _.eq(object, other);
		 * // => false
		 *
		 * _.eq('a', 'a');
		 * // => true
		 *
		 * _.eq('a', Object('a'));
		 * // => false
		 *
		 * _.eq(NaN, NaN);
		 * // => true
		 */
		function eq(value, other) {
		  return value === other || (value !== value && other !== other);
		}

		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
		  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
		    !propertyIsEnumerable.call(value, 'callee');
		};

		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;

		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(value.length) && !isFunction(value);
		}

		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;

		/**
		 * Performs a deep comparison between two values to determine if they are
		 * equivalent.
		 *
		 * **Note:** This method supports comparing arrays, array buffers, booleans,
		 * date objects, error objects, maps, numbers, `Object` objects, regexes,
		 * sets, strings, symbols, and typed arrays. `Object` objects are compared
		 * by their own, not inherited, enumerable properties. Functions and DOM
		 * nodes are compared by strict equality, i.e. `===`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to compare.
		 * @param {*} other The other value to compare.
		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
		 * @example
		 *
		 * var object = { 'a': 1 };
		 * var other = { 'a': 1 };
		 *
		 * _.isEqual(object, other);
		 * // => true
		 *
		 * object === other;
		 * // => false
		 */
		function isEqual(value, other) {
		  return baseIsEqual(value, other);
		}

		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  if (!isObject(value)) {
		    return false;
		  }
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 9 which returns 'object' for typed arrays and other constructors.
		  var tag = baseGetTag(value);
		  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
		}

		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This method is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}

		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return value != null && (type == 'object' || type == 'function');
		}

		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return value != null && typeof value == 'object';
		}

		/**
		 * Checks if `value` is classified as a typed array.
		 *
		 * @static
		 * @memberOf _
		 * @since 3.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
		 * @example
		 *
		 * _.isTypedArray(new Uint8Array);
		 * // => true
		 *
		 * _.isTypedArray([]);
		 * // => false
		 */
		var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
		}

		/**
		 * This method returns a new empty array.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {Array} Returns the new empty array.
		 * @example
		 *
		 * var arrays = _.times(2, _.stubArray);
		 *
		 * console.log(arrays);
		 * // => [[], []]
		 *
		 * console.log(arrays[0] === arrays[1]);
		 * // => false
		 */
		function stubArray() {
		  return [];
		}

		/**
		 * This method returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}

		module.exports = isEqual; 
	} (lodash_isequal, lodash_isequal.exports));
	return lodash_isequal.exports;
}

var lodash_isequalExports = requireLodash_isequal();
var Gi = /*@__PURE__*/getDefaultExportFromCjs(lodash_isequalExports);

function unfetch_module(e,n){return n=n||{},new Promise(function(t,r){var s=new XMLHttpRequest,o=[],u=[],i={},a=function(){return {ok:2==(s.status/100|0),statusText:s.statusText,status:s.status,url:s.responseURL,text:function(){return Promise.resolve(s.responseText)},json:function(){return Promise.resolve(s.responseText).then(JSON.parse)},blob:function(){return Promise.resolve(new Blob([s.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var l in s.open(n.method||"get",e,true),s.onload=function(){s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t;}),t(a());},s.onerror=r,s.withCredentials="include"==n.credentials,n.headers)s.setRequestHeader(l,n.headers[l]);s.send(n.body||null);})}

var unfetch_module$1 = /*#__PURE__*/Object.freeze({
	__proto__: null,
	default: unfetch_module
});

var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(unfetch_module$1);

var browser$1;
var hasRequiredBrowser$1;

function requireBrowser$1 () {
	if (hasRequiredBrowser$1) return browser$1;
	hasRequiredBrowser$1 = 1;
	browser$1 = self.fetch || (self.fetch = require$$0$1.default || require$$0$1);
	return browser$1;
}

var browserExports$1 = requireBrowser$1();
var Yi = /*@__PURE__*/getDefaultExportFromCjs(browserExports$1);

function Hi(n,e){if(n.length>=255)throw new TypeError("Alphabet too long");for(var t=new Uint8Array(256),i=0;i<t.length;i++)t[i]=255;for(var s=0;s<n.length;s++){var r=n.charAt(s),o=r.charCodeAt(0);if(t[o]!==255)throw new TypeError(r+" is ambiguous");t[o]=s;}var a=n.length,h=n.charAt(0),l=Math.log(a)/Math.log(256),d=Math.log(256)/Math.log(a);function p(u){if(u instanceof Uint8Array||(ArrayBuffer.isView(u)?u=new Uint8Array(u.buffer,u.byteOffset,u.byteLength):Array.isArray(u)&&(u=Uint8Array.from(u))),!(u instanceof Uint8Array))throw new TypeError("Expected Uint8Array");if(u.length===0)return "";for(var m=0,z=0,I=0,_=u.length;I!==_&&u[I]===0;)I++,m++;for(var T=(_-I)*d+1>>>0,f=new Uint8Array(T);I!==_;){for(var S=u[I],A=0,C=T-1;(S!==0||A<z)&&C!==-1;C--,A++)S+=256*f[C]>>>0,f[C]=S%a>>>0,S=S/a>>>0;if(S!==0)throw new Error("Non-zero carry");z=A,I++;}for(var x=T-z;x!==T&&f[x]===0;)x++;for(var j=h.repeat(m);x<T;++x)j+=n.charAt(f[x]);return j}function y(u){if(typeof u!="string")throw new TypeError("Expected String");if(u.length===0)return new Uint8Array;var m=0;if(u[m]!==" "){for(var z=0,I=0;u[m]===h;)z++,m++;for(var _=(u.length-m)*l+1>>>0,T=new Uint8Array(_);u[m];){var f=t[u.charCodeAt(m)];if(f===255)return;for(var S=0,A=_-1;(f!==0||S<I)&&A!==-1;A--,S++)f+=a*T[A]>>>0,T[A]=f%256>>>0,f=f/256>>>0;if(f!==0)throw new Error("Non-zero carry");I=S,m++;}if(u[m]!==" "){for(var C=_-I;C!==_&&T[C]===0;)C++;for(var x=new Uint8Array(z+(_-C)),j=z;C!==_;)x[j++]=T[C++];return x}}}function M(u){var m=y(u);if(m)return m;throw new Error(`Non-${e} character`)}return {encode:p,decodeUnsafe:y,decode:M}}var Ji=Hi,Xi=Ji;const Ne=n=>{if(n instanceof Uint8Array&&n.constructor.name==="Uint8Array")return n;if(n instanceof ArrayBuffer)return new Uint8Array(n);if(ArrayBuffer.isView(n))return new Uint8Array(n.buffer,n.byteOffset,n.byteLength);throw new Error("Unknown type, must be binary type")},Wi$1=n=>new TextEncoder().encode(n),Qi=n=>new TextDecoder().decode(n);class Zi{constructor(e,t,i){this.name=e,this.prefix=t,this.baseEncode=i;}encode(e){if(e instanceof Uint8Array)return `${this.prefix}${this.baseEncode(e)}`;throw Error("Unknown type, must be binary type")}}class es{constructor(e,t,i){if(this.name=e,this.prefix=t,t.codePointAt(0)===void 0)throw new Error("Invalid prefix character");this.prefixCodePoint=t.codePointAt(0),this.baseDecode=i;}decode(e){if(typeof e=="string"){if(e.codePointAt(0)!==this.prefixCodePoint)throw Error(`Unable to decode multibase string ${JSON.stringify(e)}, ${this.name} decoder only supports inputs prefixed with ${this.prefix}`);return this.baseDecode(e.slice(this.prefix.length))}else throw Error("Can only multibase decode strings")}or(e){return Ue(this,e)}}class ts{constructor(e){this.decoders=e;}or(e){return Ue(this,e)}decode(e){const t=e[0],i=this.decoders[t];if(i)return i.decode(e);throw RangeError(`Unable to decode multibase string ${JSON.stringify(e)}, only inputs prefixed with ${Object.keys(this.decoders)} are supported`)}}const Ue=(n,e)=>new ts({...n.decoders||{[n.prefix]:n},...e.decoders||{[e.prefix]:e}});class is{constructor(e,t,i,s){this.name=e,this.prefix=t,this.baseEncode=i,this.baseDecode=s,this.encoder=new Zi(e,t,i),this.decoder=new es(e,t,s);}encode(e){return this.encoder.encode(e)}decode(e){return this.decoder.decode(e)}}const W$2=({name:n,prefix:e,encode:t,decode:i})=>new is(n,e,t,i),B$3=({prefix:n,name:e,alphabet:t})=>{const{encode:i,decode:s}=Xi(t,e);return W$2({prefix:n,name:e,encode:i,decode:r=>Ne(s(r))})},ss=(n,e,t,i)=>{const s={};for(let d=0;d<e.length;++d)s[e[d]]=d;let r=n.length;for(;n[r-1]==="=";)--r;const o=new Uint8Array(r*t/8|0);let a=0,h=0,l=0;for(let d=0;d<r;++d){const p=s[n[d]];if(p===void 0)throw new SyntaxError(`Non-${i} character`);h=h<<t|p,a+=t,a>=8&&(a-=8,o[l++]=255&h>>a);}if(a>=t||255&h<<8-a)throw new SyntaxError("Unexpected end of data");return o},rs=(n,e,t)=>{const i=e[e.length-1]==="=",s=(1<<t)-1;let r="",o=0,a=0;for(let h=0;h<n.length;++h)for(a=a<<8|n[h],o+=8;o>t;)o-=t,r+=e[s&a>>o];if(o&&(r+=e[s&a<<t-o]),i)for(;r.length*t&7;)r+="=";return r},g$4=({name:n,prefix:e,bitsPerChar:t,alphabet:i})=>W$2({prefix:e,name:n,encode(s){return rs(s,i,t)},decode(s){return ss(s,i,t,n)}}),ns=W$2({prefix:"\0",name:"identity",encode:n=>Qi(n),decode:n=>Wi$1(n)});var os=Object.freeze({__proto__:null,identity:ns});const as$1=g$4({prefix:"0",name:"base2",alphabet:"01",bitsPerChar:1});var hs$1=Object.freeze({__proto__:null,base2:as$1});const cs$1=g$4({prefix:"7",name:"base8",alphabet:"01234567",bitsPerChar:3});var us$1=Object.freeze({__proto__:null,base8:cs$1});const ls$1=B$3({prefix:"9",name:"base10",alphabet:"0123456789"});var ds$1=Object.freeze({__proto__:null,base10:ls$1});const gs$1=g$4({prefix:"f",name:"base16",alphabet:"0123456789abcdef",bitsPerChar:4}),ps$1=g$4({prefix:"F",name:"base16upper",alphabet:"0123456789ABCDEF",bitsPerChar:4});var Ds=Object.freeze({__proto__:null,base16:gs$1,base16upper:ps$1});const ys=g$4({prefix:"b",name:"base32",alphabet:"abcdefghijklmnopqrstuvwxyz234567",bitsPerChar:5}),ms=g$4({prefix:"B",name:"base32upper",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",bitsPerChar:5}),bs=g$4({prefix:"c",name:"base32pad",alphabet:"abcdefghijklmnopqrstuvwxyz234567=",bitsPerChar:5}),fs=g$4({prefix:"C",name:"base32padupper",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZ234567=",bitsPerChar:5}),Es=g$4({prefix:"v",name:"base32hex",alphabet:"0123456789abcdefghijklmnopqrstuv",bitsPerChar:5}),ws=g$4({prefix:"V",name:"base32hexupper",alphabet:"0123456789ABCDEFGHIJKLMNOPQRSTUV",bitsPerChar:5}),vs=g$4({prefix:"t",name:"base32hexpad",alphabet:"0123456789abcdefghijklmnopqrstuv=",bitsPerChar:5}),Is=g$4({prefix:"T",name:"base32hexpadupper",alphabet:"0123456789ABCDEFGHIJKLMNOPQRSTUV=",bitsPerChar:5}),Cs=g$4({prefix:"h",name:"base32z",alphabet:"ybndrfg8ejkmcpqxot1uwisza345h769",bitsPerChar:5});var Rs=Object.freeze({__proto__:null,base32:ys,base32upper:ms,base32pad:bs,base32padupper:fs,base32hex:Es,base32hexupper:ws,base32hexpad:vs,base32hexpadupper:Is,base32z:Cs});const _s=B$3({prefix:"k",name:"base36",alphabet:"0123456789abcdefghijklmnopqrstuvwxyz"}),Ts=B$3({prefix:"K",name:"base36upper",alphabet:"0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"});var Ss=Object.freeze({__proto__:null,base36:_s,base36upper:Ts});const Ps=B$3({name:"base58btc",prefix:"z",alphabet:"123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"}),xs=B$3({name:"base58flickr",prefix:"Z",alphabet:"123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"});var Os=Object.freeze({__proto__:null,base58btc:Ps,base58flickr:xs});const As=g$4({prefix:"m",name:"base64",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",bitsPerChar:6}),zs=g$4({prefix:"M",name:"base64pad",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",bitsPerChar:6}),Ns=g$4({prefix:"u",name:"base64url",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_",bitsPerChar:6}),Us=g$4({prefix:"U",name:"base64urlpad",alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_=",bitsPerChar:6});var Ls=Object.freeze({__proto__:null,base64:As,base64pad:zs,base64url:Ns,base64urlpad:Us});const Le$1=Array.from("\u{1F680}\u{1FA90}\u2604\u{1F6F0}\u{1F30C}\u{1F311}\u{1F312}\u{1F313}\u{1F314}\u{1F315}\u{1F316}\u{1F317}\u{1F318}\u{1F30D}\u{1F30F}\u{1F30E}\u{1F409}\u2600\u{1F4BB}\u{1F5A5}\u{1F4BE}\u{1F4BF}\u{1F602}\u2764\u{1F60D}\u{1F923}\u{1F60A}\u{1F64F}\u{1F495}\u{1F62D}\u{1F618}\u{1F44D}\u{1F605}\u{1F44F}\u{1F601}\u{1F525}\u{1F970}\u{1F494}\u{1F496}\u{1F499}\u{1F622}\u{1F914}\u{1F606}\u{1F644}\u{1F4AA}\u{1F609}\u263A\u{1F44C}\u{1F917}\u{1F49C}\u{1F614}\u{1F60E}\u{1F607}\u{1F339}\u{1F926}\u{1F389}\u{1F49E}\u270C\u2728\u{1F937}\u{1F631}\u{1F60C}\u{1F338}\u{1F64C}\u{1F60B}\u{1F497}\u{1F49A}\u{1F60F}\u{1F49B}\u{1F642}\u{1F493}\u{1F929}\u{1F604}\u{1F600}\u{1F5A4}\u{1F603}\u{1F4AF}\u{1F648}\u{1F447}\u{1F3B6}\u{1F612}\u{1F92D}\u2763\u{1F61C}\u{1F48B}\u{1F440}\u{1F62A}\u{1F611}\u{1F4A5}\u{1F64B}\u{1F61E}\u{1F629}\u{1F621}\u{1F92A}\u{1F44A}\u{1F973}\u{1F625}\u{1F924}\u{1F449}\u{1F483}\u{1F633}\u270B\u{1F61A}\u{1F61D}\u{1F634}\u{1F31F}\u{1F62C}\u{1F643}\u{1F340}\u{1F337}\u{1F63B}\u{1F613}\u2B50\u2705\u{1F97A}\u{1F308}\u{1F608}\u{1F918}\u{1F4A6}\u2714\u{1F623}\u{1F3C3}\u{1F490}\u2639\u{1F38A}\u{1F498}\u{1F620}\u261D\u{1F615}\u{1F33A}\u{1F382}\u{1F33B}\u{1F610}\u{1F595}\u{1F49D}\u{1F64A}\u{1F639}\u{1F5E3}\u{1F4AB}\u{1F480}\u{1F451}\u{1F3B5}\u{1F91E}\u{1F61B}\u{1F534}\u{1F624}\u{1F33C}\u{1F62B}\u26BD\u{1F919}\u2615\u{1F3C6}\u{1F92B}\u{1F448}\u{1F62E}\u{1F646}\u{1F37B}\u{1F343}\u{1F436}\u{1F481}\u{1F632}\u{1F33F}\u{1F9E1}\u{1F381}\u26A1\u{1F31E}\u{1F388}\u274C\u270A\u{1F44B}\u{1F630}\u{1F928}\u{1F636}\u{1F91D}\u{1F6B6}\u{1F4B0}\u{1F353}\u{1F4A2}\u{1F91F}\u{1F641}\u{1F6A8}\u{1F4A8}\u{1F92C}\u2708\u{1F380}\u{1F37A}\u{1F913}\u{1F619}\u{1F49F}\u{1F331}\u{1F616}\u{1F476}\u{1F974}\u25B6\u27A1\u2753\u{1F48E}\u{1F4B8}\u2B07\u{1F628}\u{1F31A}\u{1F98B}\u{1F637}\u{1F57A}\u26A0\u{1F645}\u{1F61F}\u{1F635}\u{1F44E}\u{1F932}\u{1F920}\u{1F927}\u{1F4CC}\u{1F535}\u{1F485}\u{1F9D0}\u{1F43E}\u{1F352}\u{1F617}\u{1F911}\u{1F30A}\u{1F92F}\u{1F437}\u260E\u{1F4A7}\u{1F62F}\u{1F486}\u{1F446}\u{1F3A4}\u{1F647}\u{1F351}\u2744\u{1F334}\u{1F4A3}\u{1F438}\u{1F48C}\u{1F4CD}\u{1F940}\u{1F922}\u{1F445}\u{1F4A1}\u{1F4A9}\u{1F450}\u{1F4F8}\u{1F47B}\u{1F910}\u{1F92E}\u{1F3BC}\u{1F975}\u{1F6A9}\u{1F34E}\u{1F34A}\u{1F47C}\u{1F48D}\u{1F4E3}\u{1F942}"),$s=Le$1.reduce((n,e,t)=>(n[t]=e,n),[]),Fs=Le$1.reduce((n,e,t)=>(n[e.codePointAt(0)]=t,n),[]);function Ms(n){return n.reduce((e,t)=>(e+=$s[t],e),"")}function ks(n){const e=[];for(const t of n){const i=Fs[t.codePointAt(0)];if(i===void 0)throw new Error(`Non-base256emoji character: ${t}`);e.push(i);}return new Uint8Array(e)}const Ks=W$2({prefix:"\u{1F680}",name:"base256emoji",encode:Ms,decode:ks});var Bs=Object.freeze({__proto__:null,base256emoji:Ks}),Vs=Fe,$e=128,js=-128,Gs=Math.pow(2,31);function Fe(n,e,t){e=e||[],t=t||0;for(var i=t;n>=Gs;)e[t++]=n&255|$e,n/=128;for(;n&js;)e[t++]=n&255|$e,n>>>=7;return e[t]=n|0,Fe.bytes=t-i+1,e}var Ys=he$1,Hs=128,Me=127;function he$1(n,i){var t=0,i=i||0,s=0,r=i,o,a=n.length;do{if(r>=a)throw he$1.bytes=0,new RangeError("Could not decode varint");o=n[r++],t+=s<28?(o&Me)<<s:(o&Me)*Math.pow(2,s),s+=7;}while(o>=Hs);return he$1.bytes=r-i,t}var Js=Math.pow(2,7),Xs=Math.pow(2,14),Ws=Math.pow(2,21),Qs=Math.pow(2,28),Zs=Math.pow(2,35),er=Math.pow(2,42),tr=Math.pow(2,49),ir=Math.pow(2,56),sr=Math.pow(2,63),rr=function(n){return n<Js?1:n<Xs?2:n<Ws?3:n<Qs?4:n<Zs?5:n<er?6:n<tr?7:n<ir?8:n<sr?9:10},nr={encode:Vs,decode:Ys,encodingLength:rr},ke$1=nr;const Ke=(n,e,t=0)=>(ke$1.encode(n,e,t),e),Be=n=>ke$1.encodingLength(n),ce$2=(n,e)=>{const t=e.byteLength,i=Be(n),s=i+Be(t),r=new Uint8Array(s+t);return Ke(n,r,0),Ke(t,r,i),r.set(e,s),new or(n,t,e,r)};class or{constructor(e,t,i,s){this.code=e,this.size=t,this.digest=i,this.bytes=s;}}const Ve=({name:n,code:e,encode:t})=>new ar(n,e,t);class ar{constructor(e,t,i){this.name=e,this.code=t,this.encode=i;}digest(e){if(e instanceof Uint8Array){const t=this.encode(e);return t instanceof Uint8Array?ce$2(this.code,t):t.then(i=>ce$2(this.code,i))}else throw Error("Unknown type, must be binary type")}}const qe=n=>async e=>new Uint8Array(await crypto.subtle.digest(n,e)),hr$1=Ve({name:"sha2-256",code:18,encode:qe("SHA-256")}),cr$1=Ve({name:"sha2-512",code:19,encode:qe("SHA-512")});var ur=Object.freeze({__proto__:null,sha256:hr$1,sha512:cr$1});const je=0,lr$1="identity",Ge=Ne,dr=n=>ce$2(je,Ge(n)),gr={code:je,name:lr$1,encode:Ge,digest:dr};var pr=Object.freeze({__proto__:null,identity:gr});new TextEncoder,new TextDecoder;const Ye={...os,...hs$1,...us$1,...ds$1,...Ds,...Rs,...Ss,...Os,...Ls,...Bs};({...ur,...pr});function He(n){return globalThis.Buffer!=null?new Uint8Array(n.buffer,n.byteOffset,n.byteLength):n}function Dr(n=0){return globalThis.Buffer!=null&&globalThis.Buffer.allocUnsafe!=null?He(globalThis.Buffer.allocUnsafe(n)):new Uint8Array(n)}function Je(n,e,t,i){return {name:n,prefix:e,encoder:{name:n,prefix:e,encode:t},decoder:{decode:i}}}const Xe=Je("utf8","u",n=>"u"+new TextDecoder("utf8").decode(n),n=>new TextEncoder().encode(n.substring(1))),ue$2=Je("ascii","a",n=>{let e="a";for(let t=0;t<n.length;t++)e+=String.fromCharCode(n[t]);return e},n=>{n=n.substring(1);const e=Dr(n.length);for(let t=0;t<n.length;t++)e[t]=n.charCodeAt(t);return e}),yr={utf8:Xe,"utf-8":Xe,hex:Ye.base16,latin1:ue$2,ascii:ue$2,binary:ue$2,...Ye};function mr(n,e="utf8"){const t=yr[e];if(!t)throw new Error(`Unsupported encoding "${e}"`);return (e==="utf8"||e==="utf-8")&&globalThis.Buffer!=null&&globalThis.Buffer.from!=null?He(globalThis.Buffer.from(n,"utf-8")):t.decoder.decode(`${t.prefix}${n}`)}const le$2="wc",We=2,Q$3="core",O$3=`${le$2}@2:${Q$3}:`,Qe={logger:"error"},Ze={database:":memory:"},et="crypto",de$2="client_ed25519_seed",tt=cjsExports$4.ONE_DAY,it="keychain",st="0.3",rt="messages",nt="0.3",ot=cjsExports$4.SIX_HOURS,at="publisher",ht="irn",ct="error",ge$2="wss://relay.walletconnect.com",pe$2="wss://relay.walletconnect.org",ut="relayer",D$4={message:"relayer_message",message_ack:"relayer_message_ack",connect:"relayer_connect",disconnect:"relayer_disconnect",error:"relayer_error",connection_stalled:"relayer_connection_stalled",transport_closed:"relayer_transport_closed",publish:"relayer_publish"},lt="_subscription",P$4={payload:"payload",connect:"connect",disconnect:"disconnect",error:"error"},dt=cjsExports$4.ONE_SECOND,gt="2.11.2",pt=1e4,Dt="0.3",yt="WALLETCONNECT_CLIENT_ID",w$3={created:"subscription_created",deleted:"subscription_deleted",expired:"subscription_expired",disabled:"subscription_disabled",sync:"subscription_sync",resubscribed:"subscription_resubscribed"},mt="subscription",bt="0.3",ft$1=cjsExports$4.FIVE_SECONDS*1e3,Et="pairing",wt="0.3",$$3={wc_pairingDelete:{req:{ttl:cjsExports$4.ONE_DAY,prompt:false,tag:1e3},res:{ttl:cjsExports$4.ONE_DAY,prompt:false,tag:1001}},wc_pairingPing:{req:{ttl:cjsExports$4.THIRTY_SECONDS,prompt:false,tag:1002},res:{ttl:cjsExports$4.THIRTY_SECONDS,prompt:false,tag:1003}},unregistered_method:{req:{ttl:cjsExports$4.ONE_DAY,prompt:false,tag:0},res:{ttl:cjsExports$4.ONE_DAY,prompt:false,tag:0}}},V$1={create:"pairing_create",expire:"pairing_expire",delete:"pairing_delete",ping:"pairing_ping"},R$2={created:"history_created",updated:"history_updated",deleted:"history_deleted",sync:"history_sync"},vt="history",It="0.3",Ct$1="expirer",v$4={created:"expirer_created",deleted:"expirer_deleted",expired:"expirer_expired",sync:"expirer_sync"},Rt="0.3",Z="verify-api",F$3="https://verify.walletconnect.com",ee$2="https://verify.walletconnect.org",_t=[F$3,ee$2],Tt="echo",St="https://echo.walletconnect.com";class Pt{constructor(e,t){this.core=e,this.logger=t,this.keychain=new Map,this.name=it,this.version=st,this.initialized=false,this.storagePrefix=O$3,this.init=async()=>{if(!this.initialized){const i=await this.getKeyChain();typeof i<"u"&&(this.keychain=i),this.initialized=true;}},this.has=i=>(this.isInitialized(),this.keychain.has(i)),this.set=async(i,s)=>{this.isInitialized(),this.keychain.set(i,s),await this.persist();},this.get=i=>{this.isInitialized();const s=this.keychain.get(i);if(typeof s>"u"){const{message:r}=N$4("NO_MATCHING_KEY",`${this.name}: ${i}`);throw new Error(r)}return s},this.del=async i=>{this.isInitialized(),this.keychain.delete(i),await this.persist();},this.core=e,this.logger=E$4(t,this.name);}get context(){return y$4(this.logger)}get storageKey(){return this.storagePrefix+this.version+this.core.customStoragePrefix+"//"+this.name}async setKeyChain(e){await this.core.storage.setItem(this.storageKey,rt$2(e));}async getKeyChain(){const e=await this.core.storage.getItem(this.storageKey);return typeof e<"u"?ot$1(e):void 0}async persist(){await this.setKeyChain(this.keychain);}isInitialized(){if(!this.initialized){const{message:e}=N$4("NOT_INITIALIZED",this.name);throw new Error(e)}}}class xt{constructor(e,t,i){this.core=e,this.logger=t,this.name=et,this.initialized=false,this.init=async()=>{this.initialized||(await this.keychain.init(),this.initialized=true);},this.hasKeys=s=>(this.isInitialized(),this.keychain.has(s)),this.getClientId=async()=>{this.isInitialized();const s=await this.getClientSeed(),r=Po(s);return Qe$1(r.publicKey)},this.generateKeyPair=()=>{this.isInitialized();const s=kn$1();return this.setPrivateKey(s.publicKey,s.privateKey)},this.signJWT=async s=>{this.isInitialized();const r=await this.getClientSeed(),o=Po(r),a=Vn$2(),h=tt;return await Qo(a,s,h,o)},this.generateSharedKey=(s,r,o)=>{this.isInitialized();const a=this.getPrivateKey(s),h=Mn$1(a,r);return this.setSymKey(h,o)},this.setSymKey=async(s,r)=>{this.isInitialized();const o=r||Kn$1(s);return await this.keychain.set(o,s),o},this.deleteKeyPair=async s=>{this.isInitialized(),await this.keychain.del(s);},this.deleteSymKey=async s=>{this.isInitialized(),await this.keychain.del(s);},this.encode=async(s,r,o)=>{this.isInitialized();const a=Ae$2(o),h=safeJsonStringify(r);if(qn$1(a)){const y=a.senderPublicKey,M=a.receiverPublicKey;s=await this.generateSharedKey(y,M);}const l=this.getSymKey(s),{type:d,senderPublicKey:p}=a;return xn$1({type:d,symKey:l,message:h,senderPublicKey:p})},this.decode=async(s,r,o)=>{this.isInitialized();const a=Hn$1(r,o);if(qn$1(a)){const h=a.receiverPublicKey,l=a.senderPublicKey;s=await this.generateSharedKey(h,l);}try{const h=this.getSymKey(s),l=Fn$1({symKey:h,encoded:r});return safeJsonParse$1(l)}catch(h){this.logger.error(`Failed to decode message from topic: '${s}', clientId: '${await this.getClientId()}'`),this.logger.error(h);}},this.getPayloadType=s=>{const r=ee$3(s);return j$6(r.type)},this.getPayloadSenderPublicKey=s=>{const r=ee$3(s);return r.senderPublicKey?toString$3(r.senderPublicKey,p$6):void 0},this.core=e,this.logger=E$4(t,this.name),this.keychain=i||new Pt(this.core,this.logger);}get context(){return y$4(this.logger)}async setPrivateKey(e,t){return await this.keychain.set(e,t),e}getPrivateKey(e){return this.keychain.get(e)}async getClientSeed(){let e="";try{e=this.keychain.get(de$2);}catch{e=Vn$2(),await this.keychain.set(de$2,e);}return mr(e,"base16")}getSymKey(e){return this.keychain.get(e)}isInitialized(){if(!this.initialized){const{message:e}=N$4("NOT_INITIALIZED",this.name);throw new Error(e)}}}class Ot extends a$3{constructor(e,t){super(e,t),this.logger=e,this.core=t,this.messages=new Map,this.name=rt,this.version=nt,this.initialized=false,this.storagePrefix=O$3,this.init=async()=>{if(!this.initialized){this.logger.trace("Initialized");try{const i=await this.getRelayerMessages();typeof i<"u"&&(this.messages=i),this.logger.debug(`Successfully Restored records for ${this.name}`),this.logger.trace({type:"method",method:"restore",size:this.messages.size});}catch(i){this.logger.debug(`Failed to Restore records for ${this.name}`),this.logger.error(i);}finally{this.initialized=true;}}},this.set=async(i,s)=>{this.isInitialized();const r=Ln$1(s);let o=this.messages.get(i);return typeof o>"u"&&(o={}),typeof o[r]<"u"||(o[r]=s,this.messages.set(i,o),await this.persist()),r},this.get=i=>{this.isInitialized();let s=this.messages.get(i);return typeof s>"u"&&(s={}),s},this.has=(i,s)=>{this.isInitialized();const r=this.get(i),o=Ln$1(s);return typeof r[o]<"u"},this.del=async i=>{this.isInitialized(),this.messages.delete(i),await this.persist();},this.logger=E$4(e,this.name),this.core=t;}get context(){return y$4(this.logger)}get storageKey(){return this.storagePrefix+this.version+this.core.customStoragePrefix+"//"+this.name}async setRelayerMessages(e){await this.core.storage.setItem(this.storageKey,rt$2(e));}async getRelayerMessages(){const e=await this.core.storage.getItem(this.storageKey);return typeof e<"u"?ot$1(e):void 0}async persist(){await this.setRelayerMessages(this.messages);}isInitialized(){if(!this.initialized){const{message:e}=N$4("NOT_INITIALIZED",this.name);throw new Error(e)}}}class vr extends u$3{constructor(e,t){super(e,t),this.relayer=e,this.logger=t,this.events=new EventEmitter$2,this.name=at,this.queue=new Map,this.publishTimeout=cjsExports$4.toMiliseconds(cjsExports$4.TEN_SECONDS*2),this.needsTransportRestart=false,this.publish=async(i,s,r)=>{var o;this.logger.debug("Publishing Payload"),this.logger.trace({type:"method",method:"publish",params:{topic:i,message:s,opts:r}});try{const a=r?.ttl||ot,h=vt$2(r),l=r?.prompt||!1,d=r?.tag||0,p=r?.id||getBigIntRpcId().toString(),y={topic:i,message:s,opts:{ttl:a,relay:h,prompt:l,tag:d,id:p}},M=setTimeout(()=>this.queue.set(p,y),this.publishTimeout);try{await await ut$2(this.rpcPublish(i,s,a,h,l,d,p),this.publishTimeout,`Failed to publish payload, please try again. id:${p} tag:${d}`),this.removeRequestFromQueue(p),this.relayer.events.emit(D$4.publish,y);}catch(u){if(this.logger.debug("Publishing Payload stalled"),this.needsTransportRestart=!0,(o=r?.internal)!=null&&o.throwOnFailedPublish)throw this.removeRequestFromQueue(p),u;return}finally{clearTimeout(M);}this.logger.debug("Successfully Published Payload"),this.logger.trace({type:"method",method:"publish",params:{topic:i,message:s,opts:r}});}catch(a){throw this.logger.debug("Failed to Publish Payload"),this.logger.error(a),a}},this.on=(i,s)=>{this.events.on(i,s);},this.once=(i,s)=>{this.events.once(i,s);},this.off=(i,s)=>{this.events.off(i,s);},this.removeListener=(i,s)=>{this.events.removeListener(i,s);},this.relayer=e,this.logger=E$4(t,this.name),this.registerEventListeners();}get context(){return y$4(this.logger)}rpcPublish(e,t,i,s,r,o,a){var h,l,d,p;const y={method:Et$2(s.protocol).publish,params:{topic:e,message:t,ttl:i,prompt:r,tag:o},id:a};return w$7((h=y.params)==null?void 0:h.prompt)&&((l=y.params)==null||delete l.prompt),w$7((d=y.params)==null?void 0:d.tag)&&((p=y.params)==null||delete p.tag),this.logger.debug("Outgoing Relay Payload"),this.logger.trace({type:"message",direction:"outgoing",request:y}),this.relayer.request(y)}removeRequestFromQueue(e){this.queue.delete(e);}checkQueue(){this.queue.forEach(async e=>{const{topic:t,message:i,opts:s}=e;await this.publish(t,i,s);});}registerEventListeners(){this.relayer.core.heartbeat.on(cjsExports$1.HEARTBEAT_EVENTS.pulse,()=>{if(this.needsTransportRestart){this.needsTransportRestart=false,this.relayer.events.emit(D$4.connection_stalled);return}this.checkQueue();}),this.relayer.on(D$4.message_ack,e=>{this.removeRequestFromQueue(e.id.toString());});}}class Ir{constructor(){this.map=new Map,this.set=(e,t)=>{const i=this.get(e);this.exists(e,t)||this.map.set(e,[...i,t]);},this.get=e=>this.map.get(e)||[],this.exists=(e,t)=>this.get(e).includes(t),this.delete=(e,t)=>{if(typeof t>"u"){this.map.delete(e);return}if(!this.map.has(e))return;const i=this.get(e);if(!this.exists(e,t))return;const s=i.filter(r=>r!==t);if(!s.length){this.map.delete(e);return}this.map.set(e,s);},this.clear=()=>{this.map.clear();};}get topics(){return Array.from(this.map.keys())}}var Cr=Object.defineProperty,Rr=Object.defineProperties,_r=Object.getOwnPropertyDescriptors,At=Object.getOwnPropertySymbols,Tr=Object.prototype.hasOwnProperty,Sr=Object.prototype.propertyIsEnumerable,zt=(n,e,t)=>e in n?Cr(n,e,{enumerable:true,configurable:true,writable:true,value:t}):n[e]=t,q$3=(n,e)=>{for(var t in e||(e={}))Tr.call(e,t)&&zt(n,t,e[t]);if(At)for(var t of At(e))Sr.call(e,t)&&zt(n,t,e[t]);return n},De$1=(n,e)=>Rr(n,_r(e));class Nt extends d$3{constructor(e,t){super(e,t),this.relayer=e,this.logger=t,this.subscriptions=new Map,this.topicMap=new Ir,this.events=new EventEmitter$2,this.name=mt,this.version=bt,this.pending=new Map,this.cached=[],this.initialized=false,this.pendingSubscriptionWatchLabel="pending_sub_watch_label",this.pollingInterval=20,this.storagePrefix=O$3,this.subscribeTimeout=1e4,this.restartInProgress=false,this.batchSubscribeTopicsLimit=500,this.init=async()=>{this.initialized||(this.logger.trace("Initialized"),this.registerEventListeners(),this.clientId=await this.relayer.core.crypto.getClientId());},this.subscribe=async(i,s)=>{await this.restartToComplete(),this.isInitialized(),this.logger.debug("Subscribing Topic"),this.logger.trace({type:"method",method:"subscribe",params:{topic:i,opts:s}});try{const r=vt$2(s),o={topic:i,relay:r};this.pending.set(i,o);const a=await this.rpcSubscribe(i,r);return this.onSubscribe(a,o),this.logger.debug("Successfully Subscribed Topic"),this.logger.trace({type:"method",method:"subscribe",params:{topic:i,opts:s}}),a}catch(r){throw this.logger.debug("Failed to Subscribe Topic"),this.logger.error(r),r}},this.unsubscribe=async(i,s)=>{await this.restartToComplete(),this.isInitialized(),typeof s?.id<"u"?await this.unsubscribeById(i,s.id,s):await this.unsubscribeByTopic(i,s);},this.isSubscribed=async i=>{if(this.topics.includes(i))return  true;const s=`${this.pendingSubscriptionWatchLabel}_${i}`;return await new Promise((r,o)=>{const a=new cjsExports$4.Watch;a.start(s);const h=setInterval(()=>{!this.pending.has(i)&&this.topics.includes(i)&&(clearInterval(h),a.stop(s),r(true)),a.elapsed(s)>=ft$1&&(clearInterval(h),a.stop(s),o(new Error("Subscription resolution timeout")));},this.pollingInterval);}).catch(()=>false)},this.on=(i,s)=>{this.events.on(i,s);},this.once=(i,s)=>{this.events.once(i,s);},this.off=(i,s)=>{this.events.off(i,s);},this.removeListener=(i,s)=>{this.events.removeListener(i,s);},this.restart=async()=>{this.restartInProgress=true,await this.restore(),await this.reset(),this.restartInProgress=false;},this.relayer=e,this.logger=E$4(t,this.name),this.clientId="";}get context(){return y$4(this.logger)}get storageKey(){return this.storagePrefix+this.version+this.relayer.core.customStoragePrefix+"//"+this.name}get length(){return this.subscriptions.size}get ids(){return Array.from(this.subscriptions.keys())}get values(){return Array.from(this.subscriptions.values())}get topics(){return this.topicMap.topics}hasSubscription(e,t){let i=false;try{i=this.getSubscription(e).topic===t;}catch{}return i}onEnable(){this.cached=[],this.initialized=true;}onDisable(){this.cached=this.values,this.subscriptions.clear(),this.topicMap.clear();}async unsubscribeByTopic(e,t){const i=this.topicMap.get(e);await Promise.all(i.map(async s=>await this.unsubscribeById(e,s,t)));}async unsubscribeById(e,t,i){this.logger.debug("Unsubscribing Topic"),this.logger.trace({type:"method",method:"unsubscribe",params:{topic:e,id:t,opts:i}});try{const s=vt$2(i);await this.rpcUnsubscribe(e,t,s);const r=U$2("USER_DISCONNECTED",`${this.name}, ${e}`);await this.onUnsubscribe(e,t,r),this.logger.debug("Successfully Unsubscribed Topic"),this.logger.trace({type:"method",method:"unsubscribe",params:{topic:e,id:t,opts:i}});}catch(s){throw this.logger.debug("Failed to Unsubscribe Topic"),this.logger.error(s),s}}async rpcSubscribe(e,t){const i={method:Et$2(t.protocol).subscribe,params:{topic:e}};this.logger.debug("Outgoing Relay Payload"),this.logger.trace({type:"payload",direction:"outgoing",request:i});try{await await ut$2(this.relayer.request(i),this.subscribeTimeout);}catch{this.logger.debug("Outgoing Relay Subscribe Payload stalled"),this.relayer.events.emit(D$4.connection_stalled);}return Ln$1(e+this.clientId)}async rpcBatchSubscribe(e){if(!e.length)return;const t=e[0].relay,i={method:Et$2(t.protocol).batchSubscribe,params:{topics:e.map(s=>s.topic)}};this.logger.debug("Outgoing Relay Payload"),this.logger.trace({type:"payload",direction:"outgoing",request:i});try{return await await ut$2(this.relayer.request(i),this.subscribeTimeout)}catch{this.logger.debug("Outgoing Relay Payload stalled"),this.relayer.events.emit(D$4.connection_stalled);}}rpcUnsubscribe(e,t,i){const s={method:Et$2(i.protocol).unsubscribe,params:{topic:e,id:t}};return this.logger.debug("Outgoing Relay Payload"),this.logger.trace({type:"payload",direction:"outgoing",request:s}),this.relayer.request(s)}onSubscribe(e,t){this.setSubscription(e,De$1(q$3({},t),{id:e})),this.pending.delete(t.topic);}onBatchSubscribe(e){e.length&&e.forEach(t=>{this.setSubscription(t.id,q$3({},t)),this.pending.delete(t.topic);});}async onUnsubscribe(e,t,i){this.events.removeAllListeners(t),this.hasSubscription(t,e)&&this.deleteSubscription(t,i),await this.relayer.messages.del(e);}async setRelayerSubscriptions(e){await this.relayer.core.storage.setItem(this.storageKey,e);}async getRelayerSubscriptions(){return await this.relayer.core.storage.getItem(this.storageKey)}setSubscription(e,t){this.subscriptions.has(e)||(this.logger.debug("Setting subscription"),this.logger.trace({type:"method",method:"setSubscription",id:e,subscription:t}),this.addSubscription(e,t));}addSubscription(e,t){this.subscriptions.set(e,q$3({},t)),this.topicMap.set(t.topic,e),this.events.emit(w$3.created,t);}getSubscription(e){this.logger.debug("Getting subscription"),this.logger.trace({type:"method",method:"getSubscription",id:e});const t=this.subscriptions.get(e);if(!t){const{message:i}=N$4("NO_MATCHING_KEY",`${this.name}: ${e}`);throw new Error(i)}return t}deleteSubscription(e,t){this.logger.debug("Deleting subscription"),this.logger.trace({type:"method",method:"deleteSubscription",id:e,reason:t});const i=this.getSubscription(e);this.subscriptions.delete(e),this.topicMap.delete(i.topic,e),this.events.emit(w$3.deleted,De$1(q$3({},i),{reason:t}));}async persist(){await this.setRelayerSubscriptions(this.values),this.events.emit(w$3.sync);}async reset(){if(this.cached.length){const e=Math.ceil(this.cached.length/this.batchSubscribeTopicsLimit);for(let t=0;t<e;t++){const i=this.cached.splice(0,this.batchSubscribeTopicsLimit);await this.batchSubscribe(i);}}this.events.emit(w$3.resubscribed);}async restore(){try{const e=await this.getRelayerSubscriptions();if(typeof e>"u"||!e.length)return;if(this.subscriptions.size){const{message:t}=N$4("RESTORE_WILL_OVERRIDE",this.name);throw this.logger.error(t),this.logger.error(`${this.name}: ${JSON.stringify(this.values)}`),new Error(t)}this.cached=e,this.logger.debug(`Successfully Restored subscriptions for ${this.name}`),this.logger.trace({type:"method",method:"restore",subscriptions:this.values});}catch(e){this.logger.debug(`Failed to Restore subscriptions for ${this.name}`),this.logger.error(e);}}async batchSubscribe(e){if(!e.length)return;const t=await this.rpcBatchSubscribe(e);k$5(t)&&this.onBatchSubscribe(t.map((i,s)=>De$1(q$3({},e[s]),{id:i})));}async onConnect(){this.restartInProgress||(await this.restart(),this.onEnable());}onDisconnect(){this.onDisable();}async checkPending(){if(!this.initialized||this.relayer.transportExplicitlyClosed)return;const e=[];this.pending.forEach(t=>{e.push(t);}),await this.batchSubscribe(e);}registerEventListeners(){this.relayer.core.heartbeat.on(cjsExports$1.HEARTBEAT_EVENTS.pulse,async()=>{await this.checkPending();}),this.relayer.on(D$4.connect,async()=>{await this.onConnect();}),this.relayer.on(D$4.disconnect,()=>{this.onDisconnect();}),this.events.on(w$3.created,async e=>{const t=w$3.created;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,data:e}),await this.persist();}),this.events.on(w$3.deleted,async e=>{const t=w$3.deleted;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,data:e}),await this.persist();});}isInitialized(){if(!this.initialized){const{message:e}=N$4("NOT_INITIALIZED",this.name);throw new Error(e)}}async restartToComplete(){this.restartInProgress&&await new Promise(e=>{const t=setInterval(()=>{this.restartInProgress||(clearInterval(t),e());},this.pollingInterval);});}}var Pr=Object.defineProperty,Ut=Object.getOwnPropertySymbols,xr=Object.prototype.hasOwnProperty,Or=Object.prototype.propertyIsEnumerable,Lt=(n,e,t)=>e in n?Pr(n,e,{enumerable:true,configurable:true,writable:true,value:t}):n[e]=t,Ar=(n,e)=>{for(var t in e||(e={}))xr.call(e,t)&&Lt(n,t,e[t]);if(Ut)for(var t of Ut(e))Or.call(e,t)&&Lt(n,t,e[t]);return n};class $t extends g$5{constructor(e){super(e),this.protocol="wc",this.version=2,this.events=new EventEmitter$2,this.name=ut,this.transportExplicitlyClosed=false,this.initialized=false,this.connectionAttemptInProgress=false,this.connectionStatusPollingInterval=20,this.staleConnectionErrors=["socket hang up","socket stalled"],this.hasExperiencedNetworkDisruption=false,this.requestsInFlight=new Map,this.request=async t=>{this.logger.debug("Publishing Request Payload");const i=t.id;try{await this.toEstablishConnection();const s=this.provider.request(t);return this.requestsInFlight.set(i,{promise:s,request:t}),await s}catch(s){throw this.logger.debug("Failed to Publish Request"),this.logger.error(s),s}finally{this.requestsInFlight.delete(i);}},this.onPayloadHandler=t=>{this.onProviderPayload(t);},this.onConnectHandler=()=>{this.events.emit(D$4.connect);},this.onDisconnectHandler=()=>{this.onProviderDisconnect();},this.onProviderErrorHandler=t=>{this.logger.error(t),this.events.emit(D$4.error,t),this.logger.info("Fatal socket error received, closing transport"),this.transportClose();},this.registerProviderListeners=()=>{this.provider.on(P$4.payload,this.onPayloadHandler),this.provider.on(P$4.connect,this.onConnectHandler),this.provider.on(P$4.disconnect,this.onDisconnectHandler),this.provider.on(P$4.error,this.onProviderErrorHandler);},this.core=e.core,this.logger=typeof e.logger<"u"&&typeof e.logger!="string"?E$4(e.logger,this.name):Hg(k$3({level:e.logger||ct})),this.messages=new Ot(this.logger,e.core),this.subscriber=new Nt(this,this.logger),this.publisher=new vr(this,this.logger),this.relayUrl=e?.relayUrl||ge$2,this.projectId=e.projectId,this.bundleId=Jn$1(),this.provider={};}async init(){this.logger.trace("Initialized"),this.registerEventListeners(),await this.createProvider(),await Promise.all([this.messages.init(),this.subscriber.init()]);try{await this.transportOpen();}catch{this.logger.warn(`Connection via ${this.relayUrl} failed, attempting to connect via failover domain ${pe$2}...`),await this.restartTransport(pe$2);}this.initialized=true,setTimeout(async()=>{this.subscriber.topics.length===0&&(this.logger.info("No topics subscribed to after init, closing transport"),await this.transportClose(),this.transportExplicitlyClosed=false);},pt);}get context(){return y$4(this.logger)}get connected(){return this.provider.connection.connected}get connecting(){return this.provider.connection.connecting}async publish(e,t,i){this.isInitialized(),await this.publisher.publish(e,t,i),await this.recordMessageEvent({topic:e,message:t,publishedAt:Date.now()});}async subscribe(e,t){var i;this.isInitialized();let s=((i=this.subscriber.topicMap.get(e))==null?void 0:i[0])||"";if(s)return s;let r;const o=a=>{a.topic===e&&(this.subscriber.off(w$3.created,o),r());};return await Promise.all([new Promise(a=>{r=a,this.subscriber.on(w$3.created,o);}),new Promise(async a=>{s=await this.subscriber.subscribe(e,t),a();})]),s}async unsubscribe(e,t){this.isInitialized(),await this.subscriber.unsubscribe(e,t);}on(e,t){this.events.on(e,t);}once(e,t){this.events.once(e,t);}off(e,t){this.events.off(e,t);}removeListener(e,t){this.events.removeListener(e,t);}async transportClose(){this.requestsInFlight.size>0&&(this.logger.debug("Waiting for all in-flight requests to finish before closing transport..."),this.requestsInFlight.forEach(async e=>{await e.promise;})),this.transportExplicitlyClosed=true,this.hasExperiencedNetworkDisruption&&this.connected?await ut$2(this.provider.disconnect(),1e3,"provider.disconnect()").catch(()=>this.onProviderDisconnect()):this.connected&&await this.provider.disconnect();}async transportOpen(e){if(this.transportExplicitlyClosed=false,await this.confirmOnlineStateOrThrow(),!this.connectionAttemptInProgress){e&&e!==this.relayUrl&&(this.relayUrl=e,await this.transportClose(),await this.createProvider()),this.connectionAttemptInProgress=true;try{await Promise.all([new Promise(t=>{if(!this.initialized)return t();this.subscriber.once(w$3.resubscribed,()=>{t();});}),new Promise(async(t,i)=>{try{await ut$2(this.provider.connect(),1e4,`Socket stalled when trying to connect to ${this.relayUrl}`);}catch(s){i(s);return}t();})]);}catch(t){this.logger.error(t);const i=t;if(!this.isConnectionStalled(i.message))throw t;this.provider.events.emit(P$4.disconnect);}finally{this.connectionAttemptInProgress=false,this.hasExperiencedNetworkDisruption=false;}}}async restartTransport(e){await this.confirmOnlineStateOrThrow(),!this.connectionAttemptInProgress&&(this.relayUrl=e||this.relayUrl,await this.transportClose(),await this.createProvider(),await this.transportOpen());}async confirmOnlineStateOrThrow(){if(!await rr$2())throw new Error("No internet connection detected. Please restart your network and try again.")}isConnectionStalled(e){return this.staleConnectionErrors.some(t=>e.includes(t))}async createProvider(){this.provider.connection&&this.unregisterProviderListeners();const e=await this.core.crypto.signJWT(this.relayUrl);this.provider=new JsonRpcProvider(new f$4(Xn$1({sdkVersion:gt,protocol:this.protocol,version:this.version,relayUrl:this.relayUrl,projectId:this.projectId,auth:e,useOnCloseEvent:true,bundleId:this.bundleId}))),this.registerProviderListeners();}async recordMessageEvent(e){const{topic:t,message:i}=e;await this.messages.set(t,i);}async shouldIgnoreMessageEvent(e){const{topic:t,message:i}=e;if(!i||i.length===0)return this.logger.debug(`Ignoring invalid/empty message: ${i}`),true;if(!await this.subscriber.isSubscribed(t))return this.logger.debug(`Ignoring message for non-subscribed topic ${t}`),true;const s=this.messages.has(t,i);return s&&this.logger.debug(`Ignoring duplicate message: ${i}`),s}async onProviderPayload(e){if(this.logger.debug("Incoming Relay Payload"),this.logger.trace({type:"payload",direction:"incoming",payload:e}),isJsonRpcRequest(e)){if(!e.method.endsWith(lt))return;const t=e.params,{topic:i,message:s,publishedAt:r}=t.data,o={topic:i,message:s,publishedAt:r};this.logger.debug("Emitting Relayer Payload"),this.logger.trace(Ar({type:"event",event:t.id},o)),this.events.emit(t.id,o),await this.acknowledgePayload(e),await this.onMessageEvent(o);}else isJsonRpcResponse(e)&&this.events.emit(D$4.message_ack,e);}async onMessageEvent(e){await this.shouldIgnoreMessageEvent(e)||(this.events.emit(D$4.message,e),await this.recordMessageEvent(e));}async acknowledgePayload(e){const t=formatJsonRpcResult(e.id,true);await this.provider.connection.send(t);}unregisterProviderListeners(){this.provider.off(P$4.payload,this.onPayloadHandler),this.provider.off(P$4.connect,this.onConnectHandler),this.provider.off(P$4.disconnect,this.onDisconnectHandler),this.provider.off(P$4.error,this.onProviderErrorHandler);}async registerEventListeners(){this.events.on(D$4.connection_stalled,()=>{this.restartTransport().catch(t=>this.logger.error(t));});let e=await rr$2();or$2(async t=>{this.initialized&&e!==t&&(e=t,t?await this.restartTransport().catch(i=>this.logger.error(i)):(this.hasExperiencedNetworkDisruption=true,await this.transportClose().catch(i=>this.logger.error(i))));});}onProviderDisconnect(){this.events.emit(D$4.disconnect),this.attemptToReconnect();}attemptToReconnect(){this.transportExplicitlyClosed||(this.logger.info("attemptToReconnect called. Connecting..."),setTimeout(async()=>{await this.restartTransport().catch(e=>this.logger.error(e));},cjsExports$4.toMiliseconds(dt)));}isInitialized(){if(!this.initialized){const{message:e}=N$4("NOT_INITIALIZED",this.name);throw new Error(e)}}async toEstablishConnection(){if(await this.confirmOnlineStateOrThrow(),!this.connected){if(this.connectionAttemptInProgress)return await new Promise(e=>{const t=setInterval(()=>{this.connected&&(clearInterval(t),e());},this.connectionStatusPollingInterval);});await this.restartTransport();}}}var zr=Object.defineProperty,Ft=Object.getOwnPropertySymbols,Nr=Object.prototype.hasOwnProperty,Ur=Object.prototype.propertyIsEnumerable,Mt=(n,e,t)=>e in n?zr(n,e,{enumerable:true,configurable:true,writable:true,value:t}):n[e]=t,kt=(n,e)=>{for(var t in e||(e={}))Nr.call(e,t)&&Mt(n,t,e[t]);if(Ft)for(var t of Ft(e))Ur.call(e,t)&&Mt(n,t,e[t]);return n};class Kt extends p$4{constructor(e,t,i,s=O$3,r=void 0){super(e,t,i,s),this.core=e,this.logger=t,this.name=i,this.map=new Map,this.version=Dt,this.cached=[],this.initialized=false,this.storagePrefix=O$3,this.init=async()=>{this.initialized||(this.logger.trace("Initialized"),await this.restore(),this.cached.forEach(o=>{this.getKey&&o!==null&&!w$7(o)?this.map.set(this.getKey(o),o):Lt$2(o)?this.map.set(o.id,o):xt$2(o)&&this.map.set(o.topic,o);}),this.cached=[],this.initialized=true);},this.set=async(o,a)=>{this.isInitialized(),this.map.has(o)?await this.update(o,a):(this.logger.debug("Setting value"),this.logger.trace({type:"method",method:"set",key:o,value:a}),this.map.set(o,a),await this.persist());},this.get=o=>(this.isInitialized(),this.logger.debug("Getting value"),this.logger.trace({type:"method",method:"get",key:o}),this.getData(o)),this.getAll=o=>(this.isInitialized(),o?this.values.filter(a=>Object.keys(o).every(h=>Gi(a[h],o[h]))):this.values),this.update=async(o,a)=>{this.isInitialized(),this.logger.debug("Updating value"),this.logger.trace({type:"method",method:"update",key:o,update:a});const h=kt(kt({},this.getData(o)),a);this.map.set(o,h),await this.persist();},this.delete=async(o,a)=>{this.isInitialized(),this.map.has(o)&&(this.logger.debug("Deleting value"),this.logger.trace({type:"method",method:"delete",key:o,reason:a}),this.map.delete(o),await this.persist());},this.logger=E$4(t,this.name),this.storagePrefix=s,this.getKey=r;}get context(){return y$4(this.logger)}get storageKey(){return this.storagePrefix+this.version+this.core.customStoragePrefix+"//"+this.name}get length(){return this.map.size}get keys(){return Array.from(this.map.keys())}get values(){return Array.from(this.map.values())}async setDataStore(e){await this.core.storage.setItem(this.storageKey,e);}async getDataStore(){return await this.core.storage.getItem(this.storageKey)}getData(e){const t=this.map.get(e);if(!t){const{message:i}=N$4("NO_MATCHING_KEY",`${this.name}: ${e}`);throw this.logger.error(i),new Error(i)}return t}async persist(){await this.setDataStore(this.values);}async restore(){try{const e=await this.getDataStore();if(typeof e>"u"||!e.length)return;if(this.map.size){const{message:t}=N$4("RESTORE_WILL_OVERRIDE",this.name);throw this.logger.error(t),new Error(t)}this.cached=e,this.logger.debug(`Successfully Restored value for ${this.name}`),this.logger.trace({type:"method",method:"restore",value:this.values});}catch(e){this.logger.debug(`Failed to Restore value for ${this.name}`),this.logger.error(e);}}isInitialized(){if(!this.initialized){const{message:e}=N$4("NOT_INITIALIZED",this.name);throw new Error(e)}}}class Bt{constructor(e,t){this.core=e,this.logger=t,this.name=Et,this.version=wt,this.events=new require$$1$1,this.initialized=false,this.storagePrefix=O$3,this.ignoredPayloadTypes=[_$4],this.registeredMethods=[],this.init=async()=>{this.initialized||(await this.pairings.init(),await this.cleanup(),this.registerRelayerEvents(),this.registerExpirerEvents(),this.initialized=true,this.logger.trace("Initialized"));},this.register=({methods:i})=>{this.isInitialized(),this.registeredMethods=[...new Set([...this.registeredMethods,...i])];},this.create=async()=>{this.isInitialized();const i=Vn$2(),s=await this.core.crypto.setSymKey(i),r=pt$1(cjsExports$4.FIVE_MINUTES),o={protocol:ht},a={topic:s,expiry:r,relay:o,active:false},h=Rt$2({protocol:this.core.protocol,version:this.core.version,topic:s,symKey:i,relay:o,expiryTimestamp:r});return await this.pairings.set(s,a),await this.core.relayer.subscribe(s),this.core.expirer.set(s,r),{topic:s,uri:h}},this.pair=async i=>{this.isInitialized(),this.isValidPair(i);const{topic:s,symKey:r,relay:o,expiryTimestamp:a}=Pt$2(i.uri);let h;if(this.pairings.keys.includes(s)&&(h=this.pairings.get(s),h.active))throw new Error(`Pairing already exists: ${s}. Please try again with a new connection URI.`);const l=a||pt$1(cjsExports$4.FIVE_MINUTES),d={topic:s,relay:o,expiry:l,active:false};return await this.pairings.set(s,d),this.core.expirer.set(s,l),i.activatePairing&&await this.activate({topic:s}),this.events.emit(V$1.create,d),this.core.crypto.keychain.has(s)||(await this.core.crypto.setSymKey(r,s),await this.core.relayer.subscribe(s,{relay:o})),d},this.activate=async({topic:i})=>{this.isInitialized();const s=pt$1(cjsExports$4.THIRTY_DAYS);await this.pairings.update(i,{active:true,expiry:s}),this.core.expirer.set(i,s);},this.ping=async i=>{this.isInitialized(),await this.isValidPing(i);const{topic:s}=i;if(this.pairings.keys.includes(s)){const r=await this.sendRequest(s,"wc_pairingPing",{}),{done:o,resolve:a,reject:h}=at$1();this.events.once(yt$2("pairing_ping",r),({error:l})=>{l?h(l):a();}),await o();}},this.updateExpiry=async({topic:i,expiry:s})=>{this.isInitialized(),await this.pairings.update(i,{expiry:s});},this.updateMetadata=async({topic:i,metadata:s})=>{this.isInitialized(),await this.pairings.update(i,{peerMetadata:s});},this.getPairings=()=>(this.isInitialized(),this.pairings.values),this.disconnect=async i=>{this.isInitialized(),await this.isValidDisconnect(i);const{topic:s}=i;this.pairings.keys.includes(s)&&(await this.sendRequest(s,"wc_pairingDelete",U$2("USER_DISCONNECTED")),await this.deletePairing(s));},this.sendRequest=async(i,s,r)=>{const o=formatJsonRpcRequest(s,r),a=await this.core.crypto.encode(i,o),h=$$3[s].req;return this.core.history.set(i,o),this.core.relayer.publish(i,a,h),o.id},this.sendResult=async(i,s,r)=>{const o=formatJsonRpcResult(i,r),a=await this.core.crypto.encode(s,o),h=await this.core.history.get(s,i),l=$$3[h.request.method].res;await this.core.relayer.publish(s,a,l),await this.core.history.resolve(o);},this.sendError=async(i,s,r)=>{const o=formatJsonRpcError(i,r),a=await this.core.crypto.encode(s,o),h=await this.core.history.get(s,i),l=$$3[h.request.method]?$$3[h.request.method].res:$$3.unregistered_method.res;await this.core.relayer.publish(s,a,l),await this.core.history.resolve(o);},this.deletePairing=async(i,s)=>{await this.core.relayer.unsubscribe(i),await Promise.all([this.pairings.delete(i,U$2("USER_DISCONNECTED")),this.core.crypto.deleteSymKey(i),s?Promise.resolve():this.core.expirer.del(i)]);},this.cleanup=async()=>{const i=this.pairings.getAll().filter(s=>mt$1(s.expiry));await Promise.all(i.map(s=>this.deletePairing(s.topic)));},this.onRelayEventRequest=i=>{const{topic:s,payload:r}=i;switch(r.method){case "wc_pairingPing":return this.onPairingPingRequest(s,r);case "wc_pairingDelete":return this.onPairingDeleteRequest(s,r);default:return this.onUnknownRpcMethodRequest(s,r)}},this.onRelayEventResponse=async i=>{const{topic:s,payload:r}=i,o=(await this.core.history.get(s,r.id)).request.method;switch(o){case "wc_pairingPing":return this.onPairingPingResponse(s,r);default:return this.onUnknownRpcMethodResponse(o)}},this.onPairingPingRequest=async(i,s)=>{const{id:r}=s;try{this.isValidPing({topic:i}),await this.sendResult(r,i,!0),this.events.emit(V$1.ping,{id:r,topic:i});}catch(o){await this.sendError(r,i,o),this.logger.error(o);}},this.onPairingPingResponse=(i,s)=>{const{id:r}=s;setTimeout(()=>{isJsonRpcResult(s)?this.events.emit(yt$2("pairing_ping",r),{}):isJsonRpcError(s)&&this.events.emit(yt$2("pairing_ping",r),{error:s.error});},500);},this.onPairingDeleteRequest=async(i,s)=>{const{id:r}=s;try{this.isValidDisconnect({topic:i}),await this.deletePairing(i),this.events.emit(V$1.delete,{id:r,topic:i});}catch(o){await this.sendError(r,i,o),this.logger.error(o);}},this.onUnknownRpcMethodRequest=async(i,s)=>{const{id:r,method:o}=s;try{if(this.registeredMethods.includes(o))return;const a=U$2("WC_METHOD_UNSUPPORTED",o);await this.sendError(r,i,a),this.logger.error(a);}catch(a){await this.sendError(r,i,a),this.logger.error(a);}},this.onUnknownRpcMethodResponse=i=>{this.registeredMethods.includes(i)||this.logger.error(U$2("WC_METHOD_UNSUPPORTED",i));},this.isValidPair=i=>{var s;if(!Gt$2(i)){const{message:o}=N$4("MISSING_OR_INVALID",`pair() params: ${i}`);throw new Error(o)}if(!Kt$2(i.uri)){const{message:o}=N$4("MISSING_OR_INVALID",`pair() uri: ${i.uri}`);throw new Error(o)}const r=Pt$2(i.uri);if(!((s=r?.relay)!=null&&s.protocol)){const{message:o}=N$4("MISSING_OR_INVALID","pair() uri#relay-protocol");throw new Error(o)}if(!(r!=null&&r.symKey)){const{message:o}=N$4("MISSING_OR_INVALID","pair() uri#symKey");throw new Error(o)}if(r!=null&&r.expiryTimestamp&&cjsExports$4.toMiliseconds(r?.expiryTimestamp)<Date.now()){const{message:o}=N$4("EXPIRED","pair() URI has expired. Please try again with a new connection URI.");throw new Error(o)}},this.isValidPing=async i=>{if(!Gt$2(i)){const{message:r}=N$4("MISSING_OR_INVALID",`ping() params: ${i}`);throw new Error(r)}const{topic:s}=i;await this.isValidPairingTopic(s);},this.isValidDisconnect=async i=>{if(!Gt$2(i)){const{message:r}=N$4("MISSING_OR_INVALID",`disconnect() params: ${i}`);throw new Error(r)}const{topic:s}=i;await this.isValidPairingTopic(s);},this.isValidPairingTopic=async i=>{if(!g$7(i,false)){const{message:s}=N$4("MISSING_OR_INVALID",`pairing topic should be a string: ${i}`);throw new Error(s)}if(!this.pairings.keys.includes(i)){const{message:s}=N$4("NO_MATCHING_KEY",`pairing topic doesn't exist: ${i}`);throw new Error(s)}if(mt$1(this.pairings.get(i).expiry)){await this.deletePairing(i);const{message:s}=N$4("EXPIRED",`pairing topic: ${i}`);throw new Error(s)}},this.core=e,this.logger=E$4(t,this.name),this.pairings=new Kt(this.core,this.logger,this.name,this.storagePrefix);}get context(){return y$4(this.logger)}isInitialized(){if(!this.initialized){const{message:e}=N$4("NOT_INITIALIZED",this.name);throw new Error(e)}}registerRelayerEvents(){this.core.relayer.on(D$4.message,async e=>{const{topic:t,message:i}=e;if(!this.pairings.keys.includes(t)||this.ignoredPayloadTypes.includes(this.core.crypto.getPayloadType(i)))return;const s=await this.core.crypto.decode(t,i);try{isJsonRpcRequest(s)?(this.core.history.set(t,s),this.onRelayEventRequest({topic:t,payload:s})):isJsonRpcResponse(s)&&(await this.core.history.resolve(s),await this.onRelayEventResponse({topic:t,payload:s}),this.core.history.delete(t,s.id));}catch(r){this.logger.error(r);}});}registerExpirerEvents(){this.core.expirer.on(v$4.expired,async e=>{const{topic:t}=ft$3(e.target);t&&this.pairings.keys.includes(t)&&(await this.deletePairing(t,true),this.events.emit(V$1.expire,{topic:t}));});}}class Vt extends h$2{constructor(e,t){super(e,t),this.core=e,this.logger=t,this.records=new Map,this.events=new EventEmitter$2,this.name=vt,this.version=It,this.cached=[],this.initialized=false,this.storagePrefix=O$3,this.init=async()=>{this.initialized||(this.logger.trace("Initialized"),await this.restore(),this.cached.forEach(i=>this.records.set(i.id,i)),this.cached=[],this.registerEventListeners(),this.initialized=true);},this.set=(i,s,r)=>{if(this.isInitialized(),this.logger.debug("Setting JSON-RPC request history record"),this.logger.trace({type:"method",method:"set",topic:i,request:s,chainId:r}),this.records.has(s.id))return;const o={id:s.id,topic:i,request:{method:s.method,params:s.params||null},chainId:r,expiry:pt$1(cjsExports$4.THIRTY_DAYS)};this.records.set(o.id,o),this.events.emit(R$2.created,o);},this.resolve=async i=>{if(this.isInitialized(),this.logger.debug("Updating JSON-RPC response history record"),this.logger.trace({type:"method",method:"update",response:i}),!this.records.has(i.id))return;const s=await this.getRecord(i.id);typeof s.response>"u"&&(s.response=isJsonRpcError(i)?{error:i.error}:{result:i.result},this.records.set(s.id,s),this.events.emit(R$2.updated,s));},this.get=async(i,s)=>(this.isInitialized(),this.logger.debug("Getting record"),this.logger.trace({type:"method",method:"get",topic:i,id:s}),await this.getRecord(s)),this.delete=(i,s)=>{this.isInitialized(),this.logger.debug("Deleting record"),this.logger.trace({type:"method",method:"delete",id:s}),this.values.forEach(r=>{if(r.topic===i){if(typeof s<"u"&&r.id!==s)return;this.records.delete(r.id),this.events.emit(R$2.deleted,r);}});},this.exists=async(i,s)=>(this.isInitialized(),this.records.has(s)?(await this.getRecord(s)).topic===i:false),this.on=(i,s)=>{this.events.on(i,s);},this.once=(i,s)=>{this.events.once(i,s);},this.off=(i,s)=>{this.events.off(i,s);},this.removeListener=(i,s)=>{this.events.removeListener(i,s);},this.logger=E$4(t,this.name);}get context(){return y$4(this.logger)}get storageKey(){return this.storagePrefix+this.version+this.core.customStoragePrefix+"//"+this.name}get size(){return this.records.size}get keys(){return Array.from(this.records.keys())}get values(){return Array.from(this.records.values())}get pending(){const e=[];return this.values.forEach(t=>{if(typeof t.response<"u")return;const i={topic:t.topic,request:formatJsonRpcRequest(t.request.method,t.request.params,t.id),chainId:t.chainId};return e.push(i)}),e}async setJsonRpcRecords(e){await this.core.storage.setItem(this.storageKey,e);}async getJsonRpcRecords(){return await this.core.storage.getItem(this.storageKey)}getRecord(e){this.isInitialized();const t=this.records.get(e);if(!t){const{message:i}=N$4("NO_MATCHING_KEY",`${this.name}: ${e}`);throw new Error(i)}return t}async persist(){await this.setJsonRpcRecords(this.values),this.events.emit(R$2.sync);}async restore(){try{const e=await this.getJsonRpcRecords();if(typeof e>"u"||!e.length)return;if(this.records.size){const{message:t}=N$4("RESTORE_WILL_OVERRIDE",this.name);throw this.logger.error(t),new Error(t)}this.cached=e,this.logger.debug(`Successfully Restored records for ${this.name}`),this.logger.trace({type:"method",method:"restore",records:this.values});}catch(e){this.logger.debug(`Failed to Restore records for ${this.name}`),this.logger.error(e);}}registerEventListeners(){this.events.on(R$2.created,e=>{const t=R$2.created;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,record:e}),this.persist();}),this.events.on(R$2.updated,e=>{const t=R$2.updated;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,record:e}),this.persist();}),this.events.on(R$2.deleted,e=>{const t=R$2.deleted;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,record:e}),this.persist();}),this.core.heartbeat.on(cjsExports$1.HEARTBEAT_EVENTS.pulse,()=>{this.cleanup();});}cleanup(){try{this.records.forEach(e=>{cjsExports$4.toMiliseconds(e.expiry||0)-Date.now()<=0&&(this.logger.info(`Deleting expired history log: ${e.id}`),this.delete(e.topic,e.id));});}catch(e){this.logger.warn(e);}}isInitialized(){if(!this.initialized){const{message:e}=N$4("NOT_INITIALIZED",this.name);throw new Error(e)}}}class qt extends E$3{constructor(e,t){super(e,t),this.core=e,this.logger=t,this.expirations=new Map,this.events=new EventEmitter$2,this.name=Ct$1,this.version=Rt,this.cached=[],this.initialized=false,this.storagePrefix=O$3,this.init=async()=>{this.initialized||(this.logger.trace("Initialized"),await this.restore(),this.cached.forEach(i=>this.expirations.set(i.target,i)),this.cached=[],this.registerEventListeners(),this.initialized=true);},this.has=i=>{try{const s=this.formatTarget(i);return typeof this.getExpiration(s)<"u"}catch{return  false}},this.set=(i,s)=>{this.isInitialized();const r=this.formatTarget(i),o={target:r,expiry:s};this.expirations.set(r,o),this.checkExpiry(r,o),this.events.emit(v$4.created,{target:r,expiration:o});},this.get=i=>{this.isInitialized();const s=this.formatTarget(i);return this.getExpiration(s)},this.del=i=>{if(this.isInitialized(),this.has(i)){const s=this.formatTarget(i),r=this.getExpiration(s);this.expirations.delete(s),this.events.emit(v$4.deleted,{target:s,expiration:r});}},this.on=(i,s)=>{this.events.on(i,s);},this.once=(i,s)=>{this.events.once(i,s);},this.off=(i,s)=>{this.events.off(i,s);},this.removeListener=(i,s)=>{this.events.removeListener(i,s);},this.logger=E$4(t,this.name);}get context(){return y$4(this.logger)}get storageKey(){return this.storagePrefix+this.version+this.core.customStoragePrefix+"//"+this.name}get length(){return this.expirations.size}get keys(){return Array.from(this.expirations.keys())}get values(){return Array.from(this.expirations.values())}formatTarget(e){if(typeof e=="string")return lt$1(e);if(typeof e=="number")return dt$2(e);const{message:t}=N$4("UNKNOWN_TYPE",`Target type: ${typeof e}`);throw new Error(t)}async setExpirations(e){await this.core.storage.setItem(this.storageKey,e);}async getExpirations(){return await this.core.storage.getItem(this.storageKey)}async persist(){await this.setExpirations(this.values),this.events.emit(v$4.sync);}async restore(){try{const e=await this.getExpirations();if(typeof e>"u"||!e.length)return;if(this.expirations.size){const{message:t}=N$4("RESTORE_WILL_OVERRIDE",this.name);throw this.logger.error(t),new Error(t)}this.cached=e,this.logger.debug(`Successfully Restored expirations for ${this.name}`),this.logger.trace({type:"method",method:"restore",expirations:this.values});}catch(e){this.logger.debug(`Failed to Restore expirations for ${this.name}`),this.logger.error(e);}}getExpiration(e){const t=this.expirations.get(e);if(!t){const{message:i}=N$4("NO_MATCHING_KEY",`${this.name}: ${e}`);throw this.logger.error(i),new Error(i)}return t}checkExpiry(e,t){const{expiry:i}=t;cjsExports$4.toMiliseconds(i)-Date.now()<=0&&this.expire(e,t);}expire(e,t){this.expirations.delete(e),this.events.emit(v$4.expired,{target:e,expiration:t});}checkExpirations(){this.core.relayer.connected&&this.expirations.forEach((e,t)=>this.checkExpiry(t,e));}registerEventListeners(){this.core.heartbeat.on(cjsExports$1.HEARTBEAT_EVENTS.pulse,()=>this.checkExpirations()),this.events.on(v$4.created,e=>{const t=v$4.created;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,data:e}),this.persist();}),this.events.on(v$4.expired,e=>{const t=v$4.expired;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,data:e}),this.persist();}),this.events.on(v$4.deleted,e=>{const t=v$4.deleted;this.logger.info(`Emitting ${t}`),this.logger.debug({type:"event",event:t,data:e}),this.persist();});}isInitialized(){if(!this.initialized){const{message:e}=N$4("NOT_INITIALIZED",this.name);throw new Error(e)}}}class jt extends y$3{constructor(e,t){super(e,t),this.projectId=e,this.logger=t,this.name=Z,this.initialized=false,this.queue=[],this.verifyDisabled=false,this.init=async i=>{if(this.verifyDisabled||$$4()||!D$6())return;const s=this.getVerifyUrl(i?.verifyUrl);this.verifyUrl!==s&&this.removeIframe(),this.verifyUrl=s;try{await this.createIframe();}catch(r){this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`),this.logger.info(r);}if(!this.initialized){this.removeIframe(),this.verifyUrl=ee$2;try{await this.createIframe();}catch(r){this.logger.info(`Verify iframe failed to load: ${this.verifyUrl}`),this.logger.info(r),this.verifyDisabled=true;}}},this.register=async i=>{this.initialized?this.sendPost(i.attestationId):(this.addToQueue(i.attestationId),await this.init());},this.resolve=async i=>{if(this.isDevEnv)return "";const s=this.getVerifyUrl(i?.verifyUrl);let r;try{r=await this.fetchAttestation(i.attestationId,s);}catch(o){this.logger.info(`failed to resolve attestation: ${i.attestationId} from url: ${s}`),this.logger.info(o),r=await this.fetchAttestation(i.attestationId,ee$2);}return r},this.fetchAttestation=async(i,s)=>{this.logger.info(`resolving attestation: ${i} from url: ${s}`);const r=this.startAbortTimer(cjsExports$4.ONE_SECOND*2),o=await fetch(`${s}/attestation/${i}`,{signal:this.abortController.signal});return clearTimeout(r),o.status===200?await o.json():void 0},this.addToQueue=i=>{this.queue.push(i);},this.processQueue=()=>{this.queue.length!==0&&(this.queue.forEach(i=>this.sendPost(i)),this.queue=[]);},this.sendPost=i=>{var s;try{if(!this.iframe)return;(s=this.iframe.contentWindow)==null||s.postMessage(i,"*"),this.logger.info(`postMessage sent: ${i} ${this.verifyUrl}`);}catch{}},this.createIframe=async()=>{let i;const s=r=>{r.data==="verify_ready"&&(this.initialized=true,this.processQueue(),window.removeEventListener("message",s),i());};await Promise.race([new Promise(r=>{if(document.getElementById(Z))return r();window.addEventListener("message",s);const o=document.createElement("iframe");o.id=Z,o.src=`${this.verifyUrl}/${this.projectId}`,o.style.display="none",document.body.append(o),this.iframe=o,i=r;}),new Promise((r,o)=>setTimeout(()=>{window.removeEventListener("message",s),o("verify iframe load timeout");},cjsExports$4.toMiliseconds(cjsExports$4.FIVE_SECONDS)))]);},this.removeIframe=()=>{this.iframe&&(this.iframe.remove(),this.iframe=void 0,this.initialized=false);},this.getVerifyUrl=i=>{let s=i||F$3;return _t.includes(s)||(this.logger.info(`verify url: ${s}, not included in trusted list, assigning default: ${F$3}`),s=F$3),s},this.logger=E$4(t,this.name),this.verifyUrl=F$3,this.abortController=new AbortController,this.isDevEnv=te$2()&&process.env.IS_VITEST;}get context(){return y$4(this.logger)}startAbortTimer(e){return this.abortController=new AbortController,setTimeout(()=>this.abortController.abort(),cjsExports$4.toMiliseconds(e))}}class Gt extends v$5{constructor(e,t){super(e,t),this.projectId=e,this.logger=t,this.context=Tt,this.registerDeviceToken=async i=>{const{clientId:s,token:r,notificationType:o,enableEncrypted:a=false}=i,h=`${St}/${this.projectId}/clients`;await Yi(h,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({client_id:s,type:o,token:r,always_raw:a})});},this.logger=E$4(t,this.context);}}var Lr=Object.defineProperty,Yt=Object.getOwnPropertySymbols,$r=Object.prototype.hasOwnProperty,Fr=Object.prototype.propertyIsEnumerable,Ht=(n,e,t)=>e in n?Lr(n,e,{enumerable:true,configurable:true,writable:true,value:t}):n[e]=t,Jt=(n,e)=>{for(var t in e||(e={}))$r.call(e,t)&&Ht(n,t,e[t]);if(Yt)for(var t of Yt(e))Fr.call(e,t)&&Ht(n,t,e[t]);return n};class te extends n$2{constructor(e){super(e),this.protocol=le$2,this.version=We,this.name=Q$3,this.events=new EventEmitter$2,this.initialized=false,this.on=(i,s)=>this.events.on(i,s),this.once=(i,s)=>this.events.once(i,s),this.off=(i,s)=>this.events.off(i,s),this.removeListener=(i,s)=>this.events.removeListener(i,s),this.projectId=e?.projectId,this.relayUrl=e?.relayUrl||ge$2,this.customStoragePrefix=e!=null&&e.customStoragePrefix?`:${e.customStoragePrefix}`:"";const t=typeof e?.logger<"u"&&typeof e?.logger!="string"?e.logger:Hg(k$3({level:e?.logger||Qe.logger}));this.logger=E$4(t,this.name),this.heartbeat=new cjsExports$1.HeartBeat,this.crypto=new xt(this,this.logger,e?.keychain),this.history=new Vt(this,this.logger),this.expirer=new qt(this,this.logger),this.storage=e!=null&&e.storage?e.storage:new h$3(Jt(Jt({},Ze),e?.storageOptions)),this.relayer=new $t({core:this,logger:this.logger,relayUrl:this.relayUrl,projectId:this.projectId}),this.pairing=new Bt(this,this.logger),this.verify=new jt(this.projectId||"",this.logger),this.echoClient=new Gt(this.projectId||"",this.logger);}static async init(e){const t=new te(e);await t.initialize();const i=await t.crypto.getClientId();return await t.storage.setItem(yt,i),t}get context(){return y$4(this.logger)}async start(){this.initialized||await this.initialize();}async initialize(){this.logger.trace("Initialized");try{await this.crypto.init(),await this.history.init(),await this.expirer.init(),await this.relayer.init(),await this.heartbeat.init(),await this.pairing.init(),this.initialized=!0,this.logger.info("Core Initialization Success");}catch(e){throw this.logger.warn(`Core Initialization Failure at epoch ${Date.now()}`,e),this.logger.error(e.message),e}}}const Mr=te;

const J$1="wc",F$2=2,X$1="client",G=`${J$1}@${F$2}:${X$1}:`,M$3={name:X$1,logger:"error"},H="WALLETCONNECT_DEEPLINK_CHOICE",oe="proposal",ae$1="Proposal expired",ce$1="session",L$3=cjsExports$4.SEVEN_DAYS,le$1="engine",R$1={wc_sessionPropose:{req:{ttl:cjsExports$4.FIVE_MINUTES,prompt:true,tag:1100},res:{ttl:cjsExports$4.FIVE_MINUTES,prompt:false,tag:1101}},wc_sessionSettle:{req:{ttl:cjsExports$4.FIVE_MINUTES,prompt:false,tag:1102},res:{ttl:cjsExports$4.FIVE_MINUTES,prompt:false,tag:1103}},wc_sessionUpdate:{req:{ttl:cjsExports$4.ONE_DAY,prompt:false,tag:1104},res:{ttl:cjsExports$4.ONE_DAY,prompt:false,tag:1105}},wc_sessionExtend:{req:{ttl:cjsExports$4.ONE_DAY,prompt:false,tag:1106},res:{ttl:cjsExports$4.ONE_DAY,prompt:false,tag:1107}},wc_sessionRequest:{req:{ttl:cjsExports$4.FIVE_MINUTES,prompt:true,tag:1108},res:{ttl:cjsExports$4.FIVE_MINUTES,prompt:false,tag:1109}},wc_sessionEvent:{req:{ttl:cjsExports$4.FIVE_MINUTES,prompt:true,tag:1110},res:{ttl:cjsExports$4.FIVE_MINUTES,prompt:false,tag:1111}},wc_sessionDelete:{req:{ttl:cjsExports$4.ONE_DAY,prompt:false,tag:1112},res:{ttl:cjsExports$4.ONE_DAY,prompt:false,tag:1113}},wc_sessionPing:{req:{ttl:cjsExports$4.THIRTY_SECONDS,prompt:false,tag:1114},res:{ttl:cjsExports$4.THIRTY_SECONDS,prompt:false,tag:1115}}},U$1={min:cjsExports$4.FIVE_MINUTES,max:cjsExports$4.SEVEN_DAYS},I$1={idle:"IDLE",active:"ACTIVE"},pe$1="request",he=["wc_sessionPropose","wc_sessionRequest","wc_authRequest"];var as=Object.defineProperty,cs=Object.defineProperties,ls=Object.getOwnPropertyDescriptors,de$1=Object.getOwnPropertySymbols,ps=Object.prototype.hasOwnProperty,hs=Object.prototype.propertyIsEnumerable,ue$1=(w,r,e)=>r in w?as(w,r,{enumerable:true,configurable:true,writable:true,value:e}):w[r]=e,g$3=(w,r)=>{for(var e in r||(r={}))ps.call(r,e)&&ue$1(w,e,r[e]);if(de$1)for(var e of de$1(r))hs.call(r,e)&&ue$1(w,e,r[e]);return w},D$3=(w,r)=>cs(w,ls(r));class ds extends w$5{constructor(r){super(r),this.name=le$1,this.events=new require$$1$1,this.initialized=false,this.ignoredPayloadTypes=[_$4],this.requestQueue={state:I$1.idle,queue:[]},this.sessionRequestQueue={state:I$1.idle,queue:[]},this.requestQueueDelay=cjsExports$4.ONE_SECOND,this.init=async()=>{this.initialized||(await this.cleanup(),this.registerRelayerEvents(),this.registerExpirerEvents(),this.registerPairingEvents(),this.client.core.pairing.register({methods:Object.keys(R$1)}),this.initialized=true,setTimeout(()=>{this.sessionRequestQueue.queue=this.getPendingSessionRequests(),this.processSessionRequestQueue();},cjsExports$4.toMiliseconds(this.requestQueueDelay)));},this.connect=async e=>{await this.isInitialized();const s=D$3(g$3({},e),{requiredNamespaces:e.requiredNamespaces||{},optionalNamespaces:e.optionalNamespaces||{}});await this.isValidConnect(s);const{pairingTopic:t,requiredNamespaces:i,optionalNamespaces:n,sessionProperties:o,relays:a}=s;let c=t,p,d=false;if(c&&(d=this.client.core.pairing.pairings.get(c).active),!c||!d){const{topic:T,uri:_}=await this.client.core.pairing.create();c=T,p=_;}const h=await this.client.core.crypto.generateKeyPair(),N=R$1.wc_sessionPropose.req.ttl||cjsExports$4.FIVE_MINUTES,m=pt$1(N),f=g$3({requiredNamespaces:i,optionalNamespaces:n,relays:a??[{protocol:ht}],proposer:{publicKey:h,metadata:this.client.metadata},expiryTimestamp:m},o&&{sessionProperties:o}),{reject:k,resolve:O,done:we}=at$1(N,ae$1);if(this.events.once(yt$2("session_connect"),async({error:T,session:_})=>{if(T)k(T);else if(_){_.self.publicKey=h;const B=D$3(g$3({},_),{requiredNamespaces:f.requiredNamespaces,optionalNamespaces:f.optionalNamespaces});await this.client.session.set(_.topic,B),await this.setExpiry(_.topic,_.expiry),c&&await this.client.core.pairing.updateMetadata({topic:c,metadata:_.peer.metadata}),O(B);}}),!c){const{message:T}=N$4("NO_MATCHING_KEY",`connect() pairing topic: ${c}`);throw new Error(T)}const W=await this.sendRequest({topic:c,method:"wc_sessionPropose",params:f,throwOnFailedPublish:true});return await this.setProposal(W,g$3({id:W},f)),{uri:p,approval:we}},this.pair=async e=>(await this.isInitialized(),await this.client.core.pairing.pair(e)),this.approve=async e=>{await this.isInitialized(),await this.isValidApprove(e);const{id:s,relayProtocol:t,namespaces:i,sessionProperties:n}=e,o=this.client.proposal.get(s);let{pairingTopic:a,proposer:c,requiredNamespaces:p,optionalNamespaces:d}=o;a=a||"";const h=await this.client.core.crypto.generateKeyPair(),N=c.publicKey,m=await this.client.core.crypto.generateSharedKey(h,N);a&&s&&(await this.client.core.pairing.updateMetadata({topic:a,metadata:c.metadata}),await this.sendResult({id:s,topic:a,result:{relay:{protocol:t??"irn"},responderPublicKey:h}}),await this.client.proposal.delete(s,U$2("USER_DISCONNECTED")),await this.client.core.pairing.activate({topic:a}));const f=g$3({relay:{protocol:t??"irn"},namespaces:i,pairingTopic:a,controller:{publicKey:h,metadata:this.client.metadata},expiry:pt$1(L$3)},n&&{sessionProperties:n});await this.client.core.relayer.subscribe(m);const k=D$3(g$3({},f),{topic:m,requiredNamespaces:p,optionalNamespaces:d,pairingTopic:a,acknowledged:false,self:f.controller,peer:{publicKey:c.publicKey,metadata:c.metadata},controller:h});await this.client.session.set(m,k);try{await this.sendRequest({topic:m,method:"wc_sessionSettle",params:f,throwOnFailedPublish:!0});}catch(O){throw this.client.logger.error(O),this.client.session.delete(m,U$2("USER_DISCONNECTED")),await this.client.core.relayer.unsubscribe(m),O}return await this.setExpiry(m,pt$1(L$3)),{topic:m,acknowledged:()=>new Promise(O=>setTimeout(()=>O(this.client.session.get(m)),500))}},this.reject=async e=>{await this.isInitialized(),await this.isValidReject(e);const{id:s,reason:t}=e,{pairingTopic:i}=this.client.proposal.get(s);i&&(await this.sendError(s,i,t),await this.client.proposal.delete(s,U$2("USER_DISCONNECTED")));},this.update=async e=>{await this.isInitialized(),await this.isValidUpdate(e);const{topic:s,namespaces:t}=e,i=await this.sendRequest({topic:s,method:"wc_sessionUpdate",params:{namespaces:t}}),{done:n,resolve:o,reject:a}=at$1();return this.events.once(yt$2("session_update",i),({error:c})=>{c?a(c):o();}),await this.client.session.update(s,{namespaces:t}),{acknowledged:n}},this.extend=async e=>{await this.isInitialized(),await this.isValidExtend(e);const{topic:s}=e,t=await this.sendRequest({topic:s,method:"wc_sessionExtend",params:{}}),{done:i,resolve:n,reject:o}=at$1();return this.events.once(yt$2("session_extend",t),({error:a})=>{a?o(a):n();}),await this.setExpiry(s,pt$1(L$3)),{acknowledged:i}},this.request=async e=>{await this.isInitialized(),await this.isValidRequest(e);const{chainId:s,request:t,topic:i,expiry:n=R$1.wc_sessionRequest.req.ttl}=e,o=payloadId(),{done:a,resolve:c,reject:p}=at$1(n,"Request expired. Please try again.");return this.events.once(yt$2("session_request",o),({error:d,result:h})=>{d?p(d):c(h);}),await Promise.all([new Promise(async d=>{await this.sendRequest({clientRpcId:o,topic:i,method:"wc_sessionRequest",params:{request:D$3(g$3({},t),{expiryTimestamp:pt$1(n)}),chainId:s},expiry:n,throwOnFailedPublish:true}).catch(h=>p(h)),this.client.events.emit("session_request_sent",{topic:i,request:t,chainId:s,id:o}),d();}),new Promise(async d=>{const h=await ht$2(this.client.core.storage,H);gt$2({id:o,topic:i,wcDeepLink:h}),d();}),a()]).then(d=>d[2])},this.respond=async e=>{await this.isInitialized(),await this.isValidRespond(e);const{topic:s,response:t}=e,{id:i}=t;isJsonRpcResult(t)?await this.sendResult({id:i,topic:s,result:t.result,throwOnFailedPublish:true}):isJsonRpcError(t)&&await this.sendError(i,s,t.error),this.cleanupAfterResponse(e);},this.ping=async e=>{await this.isInitialized(),await this.isValidPing(e);const{topic:s}=e;if(this.client.session.keys.includes(s)){const t=await this.sendRequest({topic:s,method:"wc_sessionPing",params:{}}),{done:i,resolve:n,reject:o}=at$1();this.events.once(yt$2("session_ping",t),({error:a})=>{a?o(a):n();}),await i();}else this.client.core.pairing.pairings.keys.includes(s)&&await this.client.core.pairing.ping({topic:s});},this.emit=async e=>{await this.isInitialized(),await this.isValidEmit(e);const{topic:s,event:t,chainId:i}=e;await this.sendRequest({topic:s,method:"wc_sessionEvent",params:{event:t,chainId:i}});},this.disconnect=async e=>{await this.isInitialized(),await this.isValidDisconnect(e);const{topic:s}=e;if(this.client.session.keys.includes(s))await this.sendRequest({topic:s,method:"wc_sessionDelete",params:U$2("USER_DISCONNECTED"),throwOnFailedPublish:true}),await this.deleteSession({topic:s,emitEvent:false});else if(this.client.core.pairing.pairings.keys.includes(s))await this.client.core.pairing.disconnect({topic:s});else {const{message:t}=N$4("MISMATCHED_TOPIC",`Session or pairing topic not found: ${s}`);throw new Error(t)}},this.find=e=>(this.isInitialized(),this.client.session.getAll().filter(s=>Mt$2(s,e))),this.getPendingSessionRequests=()=>this.client.pendingRequest.getAll(),this.cleanupDuplicatePairings=async e=>{if(e.pairingTopic)try{const s=this.client.core.pairing.pairings.get(e.pairingTopic),t=this.client.core.pairing.pairings.getAll().filter(i=>{var n,o;return ((n=i.peerMetadata)==null?void 0:n.url)&&((o=i.peerMetadata)==null?void 0:o.url)===e.peer.metadata.url&&i.topic&&i.topic!==s.topic});if(t.length===0)return;this.client.logger.info(`Cleaning up ${t.length} duplicate pairing(s)`),await Promise.all(t.map(i=>this.client.core.pairing.disconnect({topic:i.topic}))),this.client.logger.info("Duplicate pairings clean up finished");}catch(s){this.client.logger.error(s);}},this.deleteSession=async e=>{const{topic:s,expirerHasDeleted:t=false,emitEvent:i=true,id:n=0}=e,{self:o}=this.client.session.get(s);await this.client.core.relayer.unsubscribe(s),await this.client.session.delete(s,U$2("USER_DISCONNECTED")),this.client.core.crypto.keychain.has(o.publicKey)&&await this.client.core.crypto.deleteKeyPair(o.publicKey),this.client.core.crypto.keychain.has(s)&&await this.client.core.crypto.deleteSymKey(s),t||this.client.core.expirer.del(s),this.client.core.storage.removeItem(H).catch(a=>this.client.logger.warn(a)),this.getPendingSessionRequests().forEach(a=>{a.topic===s&&this.deletePendingSessionRequest(a.id,U$2("USER_DISCONNECTED"));}),i&&this.client.events.emit("session_delete",{id:n,topic:s});},this.deleteProposal=async(e,s)=>{await Promise.all([this.client.proposal.delete(e,U$2("USER_DISCONNECTED")),s?Promise.resolve():this.client.core.expirer.del(e)]);},this.deletePendingSessionRequest=async(e,s,t=false)=>{await Promise.all([this.client.pendingRequest.delete(e,s),t?Promise.resolve():this.client.core.expirer.del(e)]),this.sessionRequestQueue.queue=this.sessionRequestQueue.queue.filter(i=>i.id!==e),t&&(this.sessionRequestQueue.state=I$1.idle,this.client.events.emit("session_request_expire",{id:e}));},this.setExpiry=async(e,s)=>{this.client.session.keys.includes(e)&&await this.client.session.update(e,{expiry:s}),this.client.core.expirer.set(e,s);},this.setProposal=async(e,s)=>{await this.client.proposal.set(e,s),this.client.core.expirer.set(e,pt$1(R$1.wc_sessionPropose.req.ttl));},this.setPendingSessionRequest=async e=>{const{id:s,topic:t,params:i,verifyContext:n}=e,o=i.request.expiryTimestamp||pt$1(R$1.wc_sessionRequest.req.ttl);await this.client.pendingRequest.set(s,{id:s,topic:t,params:i,verifyContext:n}),o&&this.client.core.expirer.set(s,o);},this.sendRequest=async e=>{const{topic:s,method:t,params:i,expiry:n,relayRpcId:o,clientRpcId:a,throwOnFailedPublish:c}=e,p=formatJsonRpcRequest(t,i,a);if(D$6()&&he.includes(t)){const N=Ln$1(JSON.stringify(p));this.client.core.verify.register({attestationId:N});}const d=await this.client.core.crypto.encode(s,p),h=R$1[t].req;return n&&(h.ttl=n),o&&(h.id=o),this.client.core.history.set(s,p),c?(h.internal=D$3(g$3({},h.internal),{throwOnFailedPublish:true}),await this.client.core.relayer.publish(s,d,h)):this.client.core.relayer.publish(s,d,h).catch(N=>this.client.logger.error(N)),p.id},this.sendResult=async e=>{const{id:s,topic:t,result:i,throwOnFailedPublish:n}=e,o=formatJsonRpcResult(s,i),a=await this.client.core.crypto.encode(t,o),c=await this.client.core.history.get(t,s),p=R$1[c.request.method].res;n?(p.internal=D$3(g$3({},p.internal),{throwOnFailedPublish:true}),await this.client.core.relayer.publish(t,a,p)):this.client.core.relayer.publish(t,a,p).catch(d=>this.client.logger.error(d)),await this.client.core.history.resolve(o);},this.sendError=async(e,s,t)=>{const i=formatJsonRpcError(e,t),n=await this.client.core.crypto.encode(s,i),o=await this.client.core.history.get(s,e),a=R$1[o.request.method].res;this.client.core.relayer.publish(s,n,a),await this.client.core.history.resolve(i);},this.cleanup=async()=>{const e=[],s=[];this.client.session.getAll().forEach(t=>{let i=false;mt$1(t.expiry)&&(i=true),this.client.core.crypto.keychain.has(t.topic)||(i=true),i&&e.push(t.topic);}),this.client.proposal.getAll().forEach(t=>{mt$1(t.expiryTimestamp)&&s.push(t.id);}),await Promise.all([...e.map(t=>this.deleteSession({topic:t})),...s.map(t=>this.deleteProposal(t))]);},this.onRelayEventRequest=async e=>{this.requestQueue.queue.push(e),await this.processRequestsQueue();},this.processRequestsQueue=async()=>{if(this.requestQueue.state===I$1.active){this.client.logger.info("Request queue already active, skipping...");return}for(this.client.logger.info(`Request queue starting with ${this.requestQueue.queue.length} requests`);this.requestQueue.queue.length>0;){this.requestQueue.state=I$1.active;const e=this.requestQueue.queue.shift();if(e)try{this.processRequest(e),await new Promise(s=>setTimeout(s,300));}catch(s){this.client.logger.warn(s);}}this.requestQueue.state=I$1.idle;},this.processRequest=e=>{const{topic:s,payload:t}=e,i=t.method;switch(i){case "wc_sessionPropose":return this.onSessionProposeRequest(s,t);case "wc_sessionSettle":return this.onSessionSettleRequest(s,t);case "wc_sessionUpdate":return this.onSessionUpdateRequest(s,t);case "wc_sessionExtend":return this.onSessionExtendRequest(s,t);case "wc_sessionPing":return this.onSessionPingRequest(s,t);case "wc_sessionDelete":return this.onSessionDeleteRequest(s,t);case "wc_sessionRequest":return this.onSessionRequest(s,t);case "wc_sessionEvent":return this.onSessionEventRequest(s,t);default:return this.client.logger.info(`Unsupported request method ${i}`)}},this.onRelayEventResponse=async e=>{const{topic:s,payload:t}=e,i=(await this.client.core.history.get(s,t.id)).request.method;switch(i){case "wc_sessionPropose":return this.onSessionProposeResponse(s,t);case "wc_sessionSettle":return this.onSessionSettleResponse(s,t);case "wc_sessionUpdate":return this.onSessionUpdateResponse(s,t);case "wc_sessionExtend":return this.onSessionExtendResponse(s,t);case "wc_sessionPing":return this.onSessionPingResponse(s,t);case "wc_sessionRequest":return this.onSessionRequestResponse(s,t);default:return this.client.logger.info(`Unsupported response method ${i}`)}},this.onRelayEventUnknownPayload=e=>{const{topic:s}=e,{message:t}=N$4("MISSING_OR_INVALID",`Decoded payload on topic ${s} is not identifiable as a JSON-RPC request or a response.`);throw new Error(t)},this.onSessionProposeRequest=async(e,s)=>{const{params:t,id:i}=s;try{this.isValidConnect(g$3({},s.params));const n=t.expiryTimestamp||pt$1(R$1.wc_sessionPropose.req.ttl),o=g$3({id:i,pairingTopic:e,expiryTimestamp:n},t);await this.setProposal(i,o);const a=Ln$1(JSON.stringify(s)),c=await this.getVerifyContext(a,o.proposer.metadata);this.client.events.emit("session_proposal",{id:i,params:o,verifyContext:c});}catch(n){await this.sendError(i,e,n),this.client.logger.error(n);}},this.onSessionProposeResponse=async(e,s)=>{const{id:t}=s;if(isJsonRpcResult(s)){const{result:i}=s;this.client.logger.trace({type:"method",method:"onSessionProposeResponse",result:i});const n=this.client.proposal.get(t);this.client.logger.trace({type:"method",method:"onSessionProposeResponse",proposal:n});const o=n.proposer.publicKey;this.client.logger.trace({type:"method",method:"onSessionProposeResponse",selfPublicKey:o});const a=i.responderPublicKey;this.client.logger.trace({type:"method",method:"onSessionProposeResponse",peerPublicKey:a});const c=await this.client.core.crypto.generateSharedKey(o,a);this.client.logger.trace({type:"method",method:"onSessionProposeResponse",sessionTopic:c});const p=await this.client.core.relayer.subscribe(c);this.client.logger.trace({type:"method",method:"onSessionProposeResponse",subscriptionId:p}),await this.client.core.pairing.activate({topic:e});}else isJsonRpcError(s)&&(await this.client.proposal.delete(t,U$2("USER_DISCONNECTED")),this.events.emit(yt$2("session_connect"),{error:s.error}));},this.onSessionSettleRequest=async(e,s)=>{const{id:t,params:i}=s;try{this.isValidSessionSettleRequest(i);const{relay:n,controller:o,expiry:a,namespaces:c,sessionProperties:p,pairingTopic:d}=s.params,h=g$3({topic:e,relay:n,expiry:a,namespaces:c,acknowledged:!0,pairingTopic:d,requiredNamespaces:{},optionalNamespaces:{},controller:o.publicKey,self:{publicKey:"",metadata:this.client.metadata},peer:{publicKey:o.publicKey,metadata:o.metadata}},p&&{sessionProperties:p});await this.sendResult({id:s.id,topic:e,result:!0}),this.events.emit(yt$2("session_connect"),{session:h}),this.cleanupDuplicatePairings(h);}catch(n){await this.sendError(t,e,n),this.client.logger.error(n);}},this.onSessionSettleResponse=async(e,s)=>{const{id:t}=s;isJsonRpcResult(s)?(await this.client.session.update(e,{acknowledged:true}),this.events.emit(yt$2("session_approve",t),{})):isJsonRpcError(s)&&(await this.client.session.delete(e,U$2("USER_DISCONNECTED")),this.events.emit(yt$2("session_approve",t),{error:s.error}));},this.onSessionUpdateRequest=async(e,s)=>{const{params:t,id:i}=s;try{const n=`${e}_session_update`,o=sr$2.get(n);if(o&&this.isRequestOutOfSync(o,i)){this.client.logger.info(`Discarding out of sync request - ${i}`);return}this.isValidUpdate(g$3({topic:e},t)),await this.client.session.update(e,{namespaces:t.namespaces}),await this.sendResult({id:i,topic:e,result:!0}),this.client.events.emit("session_update",{id:i,topic:e,params:t}),sr$2.set(n,i);}catch(n){await this.sendError(i,e,n),this.client.logger.error(n);}},this.isRequestOutOfSync=(e,s)=>parseInt(s.toString().slice(0,-3))<=parseInt(e.toString().slice(0,-3)),this.onSessionUpdateResponse=(e,s)=>{const{id:t}=s;isJsonRpcResult(s)?this.events.emit(yt$2("session_update",t),{}):isJsonRpcError(s)&&this.events.emit(yt$2("session_update",t),{error:s.error});},this.onSessionExtendRequest=async(e,s)=>{const{id:t}=s;try{this.isValidExtend({topic:e}),await this.setExpiry(e,pt$1(L$3)),await this.sendResult({id:t,topic:e,result:!0}),this.client.events.emit("session_extend",{id:t,topic:e});}catch(i){await this.sendError(t,e,i),this.client.logger.error(i);}},this.onSessionExtendResponse=(e,s)=>{const{id:t}=s;isJsonRpcResult(s)?this.events.emit(yt$2("session_extend",t),{}):isJsonRpcError(s)&&this.events.emit(yt$2("session_extend",t),{error:s.error});},this.onSessionPingRequest=async(e,s)=>{const{id:t}=s;try{this.isValidPing({topic:e}),await this.sendResult({id:t,topic:e,result:!0}),this.client.events.emit("session_ping",{id:t,topic:e});}catch(i){await this.sendError(t,e,i),this.client.logger.error(i);}},this.onSessionPingResponse=(e,s)=>{const{id:t}=s;setTimeout(()=>{isJsonRpcResult(s)?this.events.emit(yt$2("session_ping",t),{}):isJsonRpcError(s)&&this.events.emit(yt$2("session_ping",t),{error:s.error});},500);},this.onSessionDeleteRequest=async(e,s)=>{const{id:t}=s;try{this.isValidDisconnect({topic:e,reason:s.params}),await Promise.all([new Promise(i=>{this.client.core.relayer.once(D$4.publish,async()=>{i(await this.deleteSession({topic:e,id:t}));});}),this.sendResult({id:t,topic:e,result:!0}),this.cleanupPendingSentRequestsForTopic({topic:e,error:U$2("USER_DISCONNECTED")})]);}catch(i){this.client.logger.error(i);}},this.onSessionRequest=async(e,s)=>{const{id:t,params:i}=s;try{this.isValidRequest(g$3({topic:e},i));const n=Ln$1(JSON.stringify(formatJsonRpcRequest("wc_sessionRequest",i,t))),o=this.client.session.get(e),a=await this.getVerifyContext(n,o.peer.metadata),c={id:t,topic:e,params:i,verifyContext:a};await this.setPendingSessionRequest(c),this.addSessionRequestToSessionRequestQueue(c),this.processSessionRequestQueue();}catch(n){await this.sendError(t,e,n),this.client.logger.error(n);}},this.onSessionRequestResponse=(e,s)=>{const{id:t}=s;isJsonRpcResult(s)?this.events.emit(yt$2("session_request",t),{result:s.result}):isJsonRpcError(s)&&this.events.emit(yt$2("session_request",t),{error:s.error});},this.onSessionEventRequest=async(e,s)=>{const{id:t,params:i}=s;try{const n=`${e}_session_event_${i.event.name}`,o=sr$2.get(n);if(o&&this.isRequestOutOfSync(o,t)){this.client.logger.info(`Discarding out of sync request - ${t}`);return}this.isValidEmit(g$3({topic:e},i)),this.client.events.emit("session_event",{id:t,topic:e,params:i}),sr$2.set(n,t);}catch(n){await this.sendError(t,e,n),this.client.logger.error(n);}},this.addSessionRequestToSessionRequestQueue=e=>{this.sessionRequestQueue.queue.push(e);},this.cleanupAfterResponse=e=>{this.deletePendingSessionRequest(e.response.id,{message:"fulfilled",code:0}),setTimeout(()=>{this.sessionRequestQueue.state=I$1.idle,this.processSessionRequestQueue();},cjsExports$4.toMiliseconds(this.requestQueueDelay));},this.cleanupPendingSentRequestsForTopic=({topic:e,error:s})=>{const t=this.client.core.history.pending;t.length>0&&t.filter(i=>i.topic===e&&i.request.method==="wc_sessionRequest").forEach(i=>{this.events.emit(yt$2("session_request",i.request.id),{error:s});});},this.processSessionRequestQueue=()=>{if(this.sessionRequestQueue.state===I$1.active){this.client.logger.info("session request queue is already active.");return}const e=this.sessionRequestQueue.queue[0];if(!e){this.client.logger.info("session request queue is empty.");return}try{this.sessionRequestQueue.state=I$1.active,this.client.events.emit("session_request",e);}catch(s){this.client.logger.error(s);}},this.onPairingCreated=e=>{if(e.active)return;const s=this.client.proposal.getAll().find(t=>t.pairingTopic===e.topic);s&&this.onSessionProposeRequest(e.topic,formatJsonRpcRequest("wc_sessionPropose",{requiredNamespaces:s.requiredNamespaces,optionalNamespaces:s.optionalNamespaces,relays:s.relays,proposer:s.proposer,sessionProperties:s.sessionProperties},s.id));},this.isValidConnect=async e=>{if(!Gt$2(e)){const{message:a}=N$4("MISSING_OR_INVALID",`connect() params: ${JSON.stringify(e)}`);throw new Error(a)}const{pairingTopic:s,requiredNamespaces:t,optionalNamespaces:i,sessionProperties:n,relays:o}=e;if(w$7(s)||await this.isValidPairingTopic(s),!qt$2(o)){const{message:a}=N$4("MISSING_OR_INVALID",`connect() relays: ${o}`);throw new Error(a)}!w$7(t)&&B$4(t)!==0&&this.validateNamespaces(t,"requiredNamespaces"),!w$7(i)&&B$4(i)!==0&&this.validateNamespaces(i,"optionalNamespaces"),w$7(n)||this.validateSessionProps(n,"sessionProperties");},this.validateNamespaces=(e,s)=>{const t=Ht$2(e,"connect()",s);if(t)throw new Error(t.message)},this.isValidApprove=async e=>{if(!Gt$2(e))throw new Error(N$4("MISSING_OR_INVALID",`approve() params: ${e}`).message);const{id:s,namespaces:t,relayProtocol:i,sessionProperties:n}=e;await this.isValidProposalId(s);const o=this.client.proposal.get(s),a=ln(t,"approve()");if(a)throw new Error(a.message);const c=fn(o.requiredNamespaces,t,"approve()");if(c)throw new Error(c.message);if(!g$7(i,true)){const{message:p}=N$4("MISSING_OR_INVALID",`approve() relayProtocol: ${i}`);throw new Error(p)}w$7(n)||this.validateSessionProps(n,"sessionProperties");},this.isValidReject=async e=>{if(!Gt$2(e)){const{message:i}=N$4("MISSING_OR_INVALID",`reject() params: ${e}`);throw new Error(i)}const{id:s,reason:t}=e;if(await this.isValidProposalId(s),!Wt$1(t)){const{message:i}=N$4("MISSING_OR_INVALID",`reject() reason: ${JSON.stringify(t)}`);throw new Error(i)}},this.isValidSessionSettleRequest=e=>{if(!Gt$2(e)){const{message:c}=N$4("MISSING_OR_INVALID",`onSessionSettleRequest() params: ${e}`);throw new Error(c)}const{relay:s,controller:t,namespaces:i,expiry:n}=e;if(!dn(s)){const{message:c}=N$4("MISSING_OR_INVALID","onSessionSettleRequest() relay protocol should be a string");throw new Error(c)}const o=Ft$2(t,"onSessionSettleRequest()");if(o)throw new Error(o.message);const a=ln(i,"onSessionSettleRequest()");if(a)throw new Error(a.message);if(mt$1(n)){const{message:c}=N$4("EXPIRED","onSessionSettleRequest()");throw new Error(c)}},this.isValidUpdate=async e=>{if(!Gt$2(e)){const{message:a}=N$4("MISSING_OR_INVALID",`update() params: ${e}`);throw new Error(a)}const{topic:s,namespaces:t}=e;await this.isValidSessionTopic(s);const i=this.client.session.get(s),n=ln(t,"update()");if(n)throw new Error(n.message);const o=fn(i.requiredNamespaces,t,"update()");if(o)throw new Error(o.message)},this.isValidExtend=async e=>{if(!Gt$2(e)){const{message:t}=N$4("MISSING_OR_INVALID",`extend() params: ${e}`);throw new Error(t)}const{topic:s}=e;await this.isValidSessionTopic(s);},this.isValidRequest=async e=>{if(!Gt$2(e)){const{message:a}=N$4("MISSING_OR_INVALID",`request() params: ${e}`);throw new Error(a)}const{topic:s,request:t,chainId:i,expiry:n}=e;await this.isValidSessionTopic(s);const{namespaces:o}=this.client.session.get(s);if(!Qt$1(o,i)){const{message:a}=N$4("MISSING_OR_INVALID",`request() chainId: ${i}`);throw new Error(a)}if(!zt$2(t)){const{message:a}=N$4("MISSING_OR_INVALID",`request() ${JSON.stringify(t)}`);throw new Error(a)}if(!Zt$1(o,i,t.method)){const{message:a}=N$4("MISSING_OR_INVALID",`request() method: ${t.method}`);throw new Error(a)}if(n&&!tr$2(n,U$1)){const{message:a}=N$4("MISSING_OR_INVALID",`request() expiry: ${n}. Expiry must be a number (in seconds) between ${U$1.min} and ${U$1.max}`);throw new Error(a)}},this.isValidRespond=async e=>{var s;if(!Gt$2(e)){const{message:n}=N$4("MISSING_OR_INVALID",`respond() params: ${e}`);throw new Error(n)}const{topic:t,response:i}=e;try{await this.isValidSessionTopic(t);}catch(n){throw (s=e?.response)!=null&&s.id&&this.cleanupAfterResponse(e),n}if(!Yt$2(i)){const{message:n}=N$4("MISSING_OR_INVALID",`respond() response: ${JSON.stringify(i)}`);throw new Error(n)}},this.isValidPing=async e=>{if(!Gt$2(e)){const{message:t}=N$4("MISSING_OR_INVALID",`ping() params: ${e}`);throw new Error(t)}const{topic:s}=e;await this.isValidSessionOrPairingTopic(s);},this.isValidEmit=async e=>{if(!Gt$2(e)){const{message:o}=N$4("MISSING_OR_INVALID",`emit() params: ${e}`);throw new Error(o)}const{topic:s,event:t,chainId:i}=e;await this.isValidSessionTopic(s);const{namespaces:n}=this.client.session.get(s);if(!Qt$1(n,i)){const{message:o}=N$4("MISSING_OR_INVALID",`emit() chainId: ${i}`);throw new Error(o)}if(!Jt$2(t)){const{message:o}=N$4("MISSING_OR_INVALID",`emit() event: ${JSON.stringify(t)}`);throw new Error(o)}if(!Xt$1(n,i,t.name)){const{message:o}=N$4("MISSING_OR_INVALID",`emit() event: ${JSON.stringify(t)}`);throw new Error(o)}},this.isValidDisconnect=async e=>{if(!Gt$2(e)){const{message:t}=N$4("MISSING_OR_INVALID",`disconnect() params: ${e}`);throw new Error(t)}const{topic:s}=e;await this.isValidSessionOrPairingTopic(s);},this.getVerifyContext=async(e,s)=>{const t={verified:{verifyUrl:s.verifyUrl||F$3,validation:"UNKNOWN",origin:s.url||""}};try{const i=await this.client.core.verify.resolve({attestationId:e,verifyUrl:s.verifyUrl});i&&(t.verified.origin=i.origin,t.verified.isScam=i.isScam,t.verified.validation=i.origin===new URL(s.url).origin?"VALID":"INVALID");}catch(i){this.client.logger.info(i);}return this.client.logger.info(`Verify context: ${JSON.stringify(t)}`),t},this.validateSessionProps=(e,s)=>{Object.values(e).forEach(t=>{if(!g$7(t,false)){const{message:i}=N$4("MISSING_OR_INVALID",`${s} must be in Record<string, string> format. Received: ${JSON.stringify(t)}`);throw new Error(i)}});};}async isInitialized(){if(!this.initialized){const{message:r}=N$4("NOT_INITIALIZED",this.name);throw new Error(r)}await this.client.core.relayer.confirmOnlineStateOrThrow();}registerRelayerEvents(){this.client.core.relayer.on(D$4.message,async r=>{const{topic:e,message:s}=r;if(this.ignoredPayloadTypes.includes(this.client.core.crypto.getPayloadType(s)))return;const t=await this.client.core.crypto.decode(e,s);try{isJsonRpcRequest(t)?(this.client.core.history.set(e,t),this.onRelayEventRequest({topic:e,payload:t})):isJsonRpcResponse(t)?(await this.client.core.history.resolve(t),await this.onRelayEventResponse({topic:e,payload:t}),this.client.core.history.delete(e,t.id)):this.onRelayEventUnknownPayload({topic:e,payload:t});}catch(i){this.client.logger.error(i);}});}registerExpirerEvents(){this.client.core.expirer.on(v$4.expired,async r=>{const{topic:e,id:s}=ft$3(r.target);if(s&&this.client.pendingRequest.keys.includes(s))return await this.deletePendingSessionRequest(s,N$4("EXPIRED"),true);e?this.client.session.keys.includes(e)&&(await this.deleteSession({topic:e,expirerHasDeleted:true}),this.client.events.emit("session_expire",{topic:e})):s&&(await this.deleteProposal(s,true),this.client.events.emit("proposal_expire",{id:s}));});}registerPairingEvents(){this.client.core.pairing.events.on(V$1.create,r=>this.onPairingCreated(r));}isValidPairingTopic(r){if(!g$7(r,false)){const{message:e}=N$4("MISSING_OR_INVALID",`pairing topic should be a string: ${r}`);throw new Error(e)}if(!this.client.core.pairing.pairings.keys.includes(r)){const{message:e}=N$4("NO_MATCHING_KEY",`pairing topic doesn't exist: ${r}`);throw new Error(e)}if(mt$1(this.client.core.pairing.pairings.get(r).expiry)){const{message:e}=N$4("EXPIRED",`pairing topic: ${r}`);throw new Error(e)}}async isValidSessionTopic(r){if(!g$7(r,false)){const{message:e}=N$4("MISSING_OR_INVALID",`session topic should be a string: ${r}`);throw new Error(e)}if(!this.client.session.keys.includes(r)){const{message:e}=N$4("NO_MATCHING_KEY",`session topic doesn't exist: ${r}`);throw new Error(e)}if(mt$1(this.client.session.get(r).expiry)){await this.deleteSession({topic:r});const{message:e}=N$4("EXPIRED",`session topic: ${r}`);throw new Error(e)}if(!this.client.core.crypto.keychain.has(r)){const{message:e}=N$4("MISSING_OR_INVALID",`session topic does not exist in keychain: ${r}`);throw await this.deleteSession({topic:r}),new Error(e)}}async isValidSessionOrPairingTopic(r){if(this.client.session.keys.includes(r))await this.isValidSessionTopic(r);else if(this.client.core.pairing.pairings.keys.includes(r))this.isValidPairingTopic(r);else if(g$7(r,false)){const{message:e}=N$4("NO_MATCHING_KEY",`session or pairing topic doesn't exist: ${r}`);throw new Error(e)}else {const{message:e}=N$4("MISSING_OR_INVALID",`session or pairing topic should be a string: ${r}`);throw new Error(e)}}async isValidProposalId(r){if(!Bt$2(r)){const{message:e}=N$4("MISSING_OR_INVALID",`proposal id should be a number: ${r}`);throw new Error(e)}if(!this.client.proposal.keys.includes(r)){const{message:e}=N$4("NO_MATCHING_KEY",`proposal id doesn't exist: ${r}`);throw new Error(e)}if(mt$1(this.client.proposal.get(r).expiryTimestamp)){await this.deleteProposal(r);const{message:e}=N$4("EXPIRED",`proposal id: ${r}`);throw new Error(e)}}}class us extends Kt{constructor(r,e){super(r,e,oe,G),this.core=r,this.logger=e;}}let ge$1 = class ge extends Kt{constructor(r,e){super(r,e,ce$1,G),this.core=r,this.logger=e;}};class gs extends Kt{constructor(r,e){super(r,e,pe$1,G,s=>s.id),this.core=r,this.logger=e;}}let Q$2 = class Q extends b$1{constructor(r){super(r),this.protocol=J$1,this.version=F$2,this.name=M$3.name,this.events=new EventEmitter$2,this.on=(s,t)=>this.events.on(s,t),this.once=(s,t)=>this.events.once(s,t),this.off=(s,t)=>this.events.off(s,t),this.removeListener=(s,t)=>this.events.removeListener(s,t),this.removeAllListeners=s=>this.events.removeAllListeners(s),this.connect=async s=>{try{return await this.engine.connect(s)}catch(t){throw this.logger.error(t.message),t}},this.pair=async s=>{try{return await this.engine.pair(s)}catch(t){throw this.logger.error(t.message),t}},this.approve=async s=>{try{return await this.engine.approve(s)}catch(t){throw this.logger.error(t.message),t}},this.reject=async s=>{try{return await this.engine.reject(s)}catch(t){throw this.logger.error(t.message),t}},this.update=async s=>{try{return await this.engine.update(s)}catch(t){throw this.logger.error(t.message),t}},this.extend=async s=>{try{return await this.engine.extend(s)}catch(t){throw this.logger.error(t.message),t}},this.request=async s=>{try{return await this.engine.request(s)}catch(t){throw this.logger.error(t.message),t}},this.respond=async s=>{try{return await this.engine.respond(s)}catch(t){throw this.logger.error(t.message),t}},this.ping=async s=>{try{return await this.engine.ping(s)}catch(t){throw this.logger.error(t.message),t}},this.emit=async s=>{try{return await this.engine.emit(s)}catch(t){throw this.logger.error(t.message),t}},this.disconnect=async s=>{try{return await this.engine.disconnect(s)}catch(t){throw this.logger.error(t.message),t}},this.find=s=>{try{return this.engine.find(s)}catch(t){throw this.logger.error(t.message),t}},this.getPendingSessionRequests=()=>{try{return this.engine.getPendingSessionRequests()}catch(s){throw this.logger.error(s.message),s}},this.name=r?.name||M$3.name,this.metadata=r?.metadata||Qn$1();const e=typeof r?.logger<"u"&&typeof r?.logger!="string"?r.logger:Hg(k$3({level:r?.logger||M$3.logger}));this.core=r?.core||new Mr(r),this.logger=E$4(e,this.name),this.session=new ge$1(this.core,this.logger),this.proposal=new us(this.core,this.logger),this.pendingRequest=new gs(this.core,this.logger),this.engine=new ds(this);}static async init(r){const e=new Q(r);return await e.initialize(),e}get context(){return y$4(this.logger)}get pairing(){return this.core.pairing.pairings}async initialize(){this.logger.trace("Initialized");try{await this.core.start(),await this.session.init(),await this.proposal.init(),await this.pendingRequest.init(),await this.engine.init(),this.core.verify.init({verifyUrl:this.metadata.verifyUrl}),this.logger.info("SignClient Initialization Success");}catch(r){throw this.logger.info("SignClient Initialization Failure"),this.logger.error(r.message),r}}};

var browserPonyfill = {exports: {}};

var hasRequiredBrowserPonyfill;

function requireBrowserPonyfill () {
	if (hasRequiredBrowserPonyfill) return browserPonyfill.exports;
	hasRequiredBrowserPonyfill = 1;
	(function (module, exports) {
		// Save global object in a variable
		var __global__ =
		(typeof globalThis !== 'undefined' && globalThis) ||
		(typeof self !== 'undefined' && self) ||
		(typeof commonjsGlobal !== 'undefined' && commonjsGlobal);
		// Create an object that extends from __global__ without the fetch function
		var __globalThis__ = (function () {
		function F() {
		this.fetch = false;
		this.DOMException = __global__.DOMException;
		}
		F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
		return new F();
		})();
		// Wraps whatwg-fetch with a function scope to hijack the global object
		// "globalThis" that's going to be patched
		(function(globalThis) {

		((function (exports) {

		  /* eslint-disable no-prototype-builtins */
		  var g =
		    (typeof globalThis !== 'undefined' && globalThis) ||
		    (typeof self !== 'undefined' && self) ||
		    // eslint-disable-next-line no-undef
		    (typeof commonjsGlobal !== 'undefined' && commonjsGlobal) ||
		    {};

		  var support = {
		    searchParams: 'URLSearchParams' in g,
		    iterable: 'Symbol' in g && 'iterator' in Symbol,
		    blob:
		      'FileReader' in g &&
		      'Blob' in g &&
		      (function() {
		        try {
		          new Blob();
		          return true
		        } catch (e) {
		          return false
		        }
		      })(),
		    formData: 'FormData' in g,
		    arrayBuffer: 'ArrayBuffer' in g
		  };

		  function isDataView(obj) {
		    return obj && DataView.prototype.isPrototypeOf(obj)
		  }

		  if (support.arrayBuffer) {
		    var viewClasses = [
		      '[object Int8Array]',
		      '[object Uint8Array]',
		      '[object Uint8ClampedArray]',
		      '[object Int16Array]',
		      '[object Uint16Array]',
		      '[object Int32Array]',
		      '[object Uint32Array]',
		      '[object Float32Array]',
		      '[object Float64Array]'
		    ];

		    var isArrayBufferView =
		      ArrayBuffer.isView ||
		      function(obj) {
		        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
		      };
		  }

		  function normalizeName(name) {
		    if (typeof name !== 'string') {
		      name = String(name);
		    }
		    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
		      throw new TypeError('Invalid character in header field name: "' + name + '"')
		    }
		    return name.toLowerCase()
		  }

		  function normalizeValue(value) {
		    if (typeof value !== 'string') {
		      value = String(value);
		    }
		    return value
		  }

		  // Build a destructive iterator for the value list
		  function iteratorFor(items) {
		    var iterator = {
		      next: function() {
		        var value = items.shift();
		        return {done: value === undefined, value: value}
		      }
		    };

		    if (support.iterable) {
		      iterator[Symbol.iterator] = function() {
		        return iterator
		      };
		    }

		    return iterator
		  }

		  function Headers(headers) {
		    this.map = {};

		    if (headers instanceof Headers) {
		      headers.forEach(function(value, name) {
		        this.append(name, value);
		      }, this);
		    } else if (Array.isArray(headers)) {
		      headers.forEach(function(header) {
		        if (header.length != 2) {
		          throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
		        }
		        this.append(header[0], header[1]);
		      }, this);
		    } else if (headers) {
		      Object.getOwnPropertyNames(headers).forEach(function(name) {
		        this.append(name, headers[name]);
		      }, this);
		    }
		  }

		  Headers.prototype.append = function(name, value) {
		    name = normalizeName(name);
		    value = normalizeValue(value);
		    var oldValue = this.map[name];
		    this.map[name] = oldValue ? oldValue + ', ' + value : value;
		  };

		  Headers.prototype['delete'] = function(name) {
		    delete this.map[normalizeName(name)];
		  };

		  Headers.prototype.get = function(name) {
		    name = normalizeName(name);
		    return this.has(name) ? this.map[name] : null
		  };

		  Headers.prototype.has = function(name) {
		    return this.map.hasOwnProperty(normalizeName(name))
		  };

		  Headers.prototype.set = function(name, value) {
		    this.map[normalizeName(name)] = normalizeValue(value);
		  };

		  Headers.prototype.forEach = function(callback, thisArg) {
		    for (var name in this.map) {
		      if (this.map.hasOwnProperty(name)) {
		        callback.call(thisArg, this.map[name], name, this);
		      }
		    }
		  };

		  Headers.prototype.keys = function() {
		    var items = [];
		    this.forEach(function(value, name) {
		      items.push(name);
		    });
		    return iteratorFor(items)
		  };

		  Headers.prototype.values = function() {
		    var items = [];
		    this.forEach(function(value) {
		      items.push(value);
		    });
		    return iteratorFor(items)
		  };

		  Headers.prototype.entries = function() {
		    var items = [];
		    this.forEach(function(value, name) {
		      items.push([name, value]);
		    });
		    return iteratorFor(items)
		  };

		  if (support.iterable) {
		    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
		  }

		  function consumed(body) {
		    if (body._noBody) return
		    if (body.bodyUsed) {
		      return Promise.reject(new TypeError('Already read'))
		    }
		    body.bodyUsed = true;
		  }

		  function fileReaderReady(reader) {
		    return new Promise(function(resolve, reject) {
		      reader.onload = function() {
		        resolve(reader.result);
		      };
		      reader.onerror = function() {
		        reject(reader.error);
		      };
		    })
		  }

		  function readBlobAsArrayBuffer(blob) {
		    var reader = new FileReader();
		    var promise = fileReaderReady(reader);
		    reader.readAsArrayBuffer(blob);
		    return promise
		  }

		  function readBlobAsText(blob) {
		    var reader = new FileReader();
		    var promise = fileReaderReady(reader);
		    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
		    var encoding = match ? match[1] : 'utf-8';
		    reader.readAsText(blob, encoding);
		    return promise
		  }

		  function readArrayBufferAsText(buf) {
		    var view = new Uint8Array(buf);
		    var chars = new Array(view.length);

		    for (var i = 0; i < view.length; i++) {
		      chars[i] = String.fromCharCode(view[i]);
		    }
		    return chars.join('')
		  }

		  function bufferClone(buf) {
		    if (buf.slice) {
		      return buf.slice(0)
		    } else {
		      var view = new Uint8Array(buf.byteLength);
		      view.set(new Uint8Array(buf));
		      return view.buffer
		    }
		  }

		  function Body() {
		    this.bodyUsed = false;

		    this._initBody = function(body) {
		      /*
		        fetch-mock wraps the Response object in an ES6 Proxy to
		        provide useful test harness features such as flush. However, on
		        ES5 browsers without fetch or Proxy support pollyfills must be used;
		        the proxy-pollyfill is unable to proxy an attribute unless it exists
		        on the object before the Proxy is created. This change ensures
		        Response.bodyUsed exists on the instance, while maintaining the
		        semantic of setting Request.bodyUsed in the constructor before
		        _initBody is called.
		      */
		      // eslint-disable-next-line no-self-assign
		      this.bodyUsed = this.bodyUsed;
		      this._bodyInit = body;
		      if (!body) {
		        this._noBody = true;
		        this._bodyText = '';
		      } else if (typeof body === 'string') {
		        this._bodyText = body;
		      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
		        this._bodyBlob = body;
		      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
		        this._bodyFormData = body;
		      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
		        this._bodyText = body.toString();
		      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
		        this._bodyArrayBuffer = bufferClone(body.buffer);
		        // IE 10-11 can't handle a DataView body.
		        this._bodyInit = new Blob([this._bodyArrayBuffer]);
		      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
		        this._bodyArrayBuffer = bufferClone(body);
		      } else {
		        this._bodyText = body = Object.prototype.toString.call(body);
		      }

		      if (!this.headers.get('content-type')) {
		        if (typeof body === 'string') {
		          this.headers.set('content-type', 'text/plain;charset=UTF-8');
		        } else if (this._bodyBlob && this._bodyBlob.type) {
		          this.headers.set('content-type', this._bodyBlob.type);
		        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
		          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
		        }
		      }
		    };

		    if (support.blob) {
		      this.blob = function() {
		        var rejected = consumed(this);
		        if (rejected) {
		          return rejected
		        }

		        if (this._bodyBlob) {
		          return Promise.resolve(this._bodyBlob)
		        } else if (this._bodyArrayBuffer) {
		          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
		        } else if (this._bodyFormData) {
		          throw new Error('could not read FormData body as blob')
		        } else {
		          return Promise.resolve(new Blob([this._bodyText]))
		        }
		      };
		    }

		    this.arrayBuffer = function() {
		      if (this._bodyArrayBuffer) {
		        var isConsumed = consumed(this);
		        if (isConsumed) {
		          return isConsumed
		        } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
		          return Promise.resolve(
		            this._bodyArrayBuffer.buffer.slice(
		              this._bodyArrayBuffer.byteOffset,
		              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
		            )
		          )
		        } else {
		          return Promise.resolve(this._bodyArrayBuffer)
		        }
		      } else if (support.blob) {
		        return this.blob().then(readBlobAsArrayBuffer)
		      } else {
		        throw new Error('could not read as ArrayBuffer')
		      }
		    };

		    this.text = function() {
		      var rejected = consumed(this);
		      if (rejected) {
		        return rejected
		      }

		      if (this._bodyBlob) {
		        return readBlobAsText(this._bodyBlob)
		      } else if (this._bodyArrayBuffer) {
		        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
		      } else if (this._bodyFormData) {
		        throw new Error('could not read FormData body as text')
		      } else {
		        return Promise.resolve(this._bodyText)
		      }
		    };

		    if (support.formData) {
		      this.formData = function() {
		        return this.text().then(decode)
		      };
		    }

		    this.json = function() {
		      return this.text().then(JSON.parse)
		    };

		    return this
		  }

		  // HTTP methods whose capitalization should be normalized
		  var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE'];

		  function normalizeMethod(method) {
		    var upcased = method.toUpperCase();
		    return methods.indexOf(upcased) > -1 ? upcased : method
		  }

		  function Request(input, options) {
		    if (!(this instanceof Request)) {
		      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
		    }

		    options = options || {};
		    var body = options.body;

		    if (input instanceof Request) {
		      if (input.bodyUsed) {
		        throw new TypeError('Already read')
		      }
		      this.url = input.url;
		      this.credentials = input.credentials;
		      if (!options.headers) {
		        this.headers = new Headers(input.headers);
		      }
		      this.method = input.method;
		      this.mode = input.mode;
		      this.signal = input.signal;
		      if (!body && input._bodyInit != null) {
		        body = input._bodyInit;
		        input.bodyUsed = true;
		      }
		    } else {
		      this.url = String(input);
		    }

		    this.credentials = options.credentials || this.credentials || 'same-origin';
		    if (options.headers || !this.headers) {
		      this.headers = new Headers(options.headers);
		    }
		    this.method = normalizeMethod(options.method || this.method || 'GET');
		    this.mode = options.mode || this.mode || null;
		    this.signal = options.signal || this.signal || (function () {
		      if ('AbortController' in g) {
		        var ctrl = new AbortController();
		        return ctrl.signal;
		      }
		    }());
		    this.referrer = null;

		    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
		      throw new TypeError('Body not allowed for GET or HEAD requests')
		    }
		    this._initBody(body);

		    if (this.method === 'GET' || this.method === 'HEAD') {
		      if (options.cache === 'no-store' || options.cache === 'no-cache') {
		        // Search for a '_' parameter in the query string
		        var reParamSearch = /([?&])_=[^&]*/;
		        if (reParamSearch.test(this.url)) {
		          // If it already exists then set the value with the current time
		          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
		        } else {
		          // Otherwise add a new '_' parameter to the end with the current time
		          var reQueryString = /\?/;
		          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
		        }
		      }
		    }
		  }

		  Request.prototype.clone = function() {
		    return new Request(this, {body: this._bodyInit})
		  };

		  function decode(body) {
		    var form = new FormData();
		    body
		      .trim()
		      .split('&')
		      .forEach(function(bytes) {
		        if (bytes) {
		          var split = bytes.split('=');
		          var name = split.shift().replace(/\+/g, ' ');
		          var value = split.join('=').replace(/\+/g, ' ');
		          form.append(decodeURIComponent(name), decodeURIComponent(value));
		        }
		      });
		    return form
		  }

		  function parseHeaders(rawHeaders) {
		    var headers = new Headers();
		    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
		    // https://tools.ietf.org/html/rfc7230#section-3.2
		    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
		    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
		    // https://github.com/github/fetch/issues/748
		    // https://github.com/zloirock/core-js/issues/751
		    preProcessedHeaders
		      .split('\r')
		      .map(function(header) {
		        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
		      })
		      .forEach(function(line) {
		        var parts = line.split(':');
		        var key = parts.shift().trim();
		        if (key) {
		          var value = parts.join(':').trim();
		          try {
		            headers.append(key, value);
		          } catch (error) {
		            console.warn('Response ' + error.message);
		          }
		        }
		      });
		    return headers
		  }

		  Body.call(Request.prototype);

		  function Response(bodyInit, options) {
		    if (!(this instanceof Response)) {
		      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
		    }
		    if (!options) {
		      options = {};
		    }

		    this.type = 'default';
		    this.status = options.status === undefined ? 200 : options.status;
		    if (this.status < 200 || this.status > 599) {
		      throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
		    }
		    this.ok = this.status >= 200 && this.status < 300;
		    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
		    this.headers = new Headers(options.headers);
		    this.url = options.url || '';
		    this._initBody(bodyInit);
		  }

		  Body.call(Response.prototype);

		  Response.prototype.clone = function() {
		    return new Response(this._bodyInit, {
		      status: this.status,
		      statusText: this.statusText,
		      headers: new Headers(this.headers),
		      url: this.url
		    })
		  };

		  Response.error = function() {
		    var response = new Response(null, {status: 200, statusText: ''});
		    response.ok = false;
		    response.status = 0;
		    response.type = 'error';
		    return response
		  };

		  var redirectStatuses = [301, 302, 303, 307, 308];

		  Response.redirect = function(url, status) {
		    if (redirectStatuses.indexOf(status) === -1) {
		      throw new RangeError('Invalid status code')
		    }

		    return new Response(null, {status: status, headers: {location: url}})
		  };

		  exports.DOMException = g.DOMException;
		  try {
		    new exports.DOMException();
		  } catch (err) {
		    exports.DOMException = function(message, name) {
		      this.message = message;
		      this.name = name;
		      var error = Error(message);
		      this.stack = error.stack;
		    };
		    exports.DOMException.prototype = Object.create(Error.prototype);
		    exports.DOMException.prototype.constructor = exports.DOMException;
		  }

		  function fetch(input, init) {
		    return new Promise(function(resolve, reject) {
		      var request = new Request(input, init);

		      if (request.signal && request.signal.aborted) {
		        return reject(new exports.DOMException('Aborted', 'AbortError'))
		      }

		      var xhr = new XMLHttpRequest();

		      function abortXhr() {
		        xhr.abort();
		      }

		      xhr.onload = function() {
		        var options = {
		          statusText: xhr.statusText,
		          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
		        };
		        // This check if specifically for when a user fetches a file locally from the file system
		        // Only if the status is out of a normal range
		        if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) {
		          options.status = 200;
		        } else {
		          options.status = xhr.status;
		        }
		        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
		        var body = 'response' in xhr ? xhr.response : xhr.responseText;
		        setTimeout(function() {
		          resolve(new Response(body, options));
		        }, 0);
		      };

		      xhr.onerror = function() {
		        setTimeout(function() {
		          reject(new TypeError('Network request failed'));
		        }, 0);
		      };

		      xhr.ontimeout = function() {
		        setTimeout(function() {
		          reject(new TypeError('Network request timed out'));
		        }, 0);
		      };

		      xhr.onabort = function() {
		        setTimeout(function() {
		          reject(new exports.DOMException('Aborted', 'AbortError'));
		        }, 0);
		      };

		      function fixUrl(url) {
		        try {
		          return url === '' && g.location.href ? g.location.href : url
		        } catch (e) {
		          return url
		        }
		      }

		      xhr.open(request.method, fixUrl(request.url), true);

		      if (request.credentials === 'include') {
		        xhr.withCredentials = true;
		      } else if (request.credentials === 'omit') {
		        xhr.withCredentials = false;
		      }

		      if ('responseType' in xhr) {
		        if (support.blob) {
		          xhr.responseType = 'blob';
		        } else if (
		          support.arrayBuffer
		        ) {
		          xhr.responseType = 'arraybuffer';
		        }
		      }

		      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
		        var names = [];
		        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
		          names.push(normalizeName(name));
		          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
		        });
		        request.headers.forEach(function(value, name) {
		          if (names.indexOf(name) === -1) {
		            xhr.setRequestHeader(name, value);
		          }
		        });
		      } else {
		        request.headers.forEach(function(value, name) {
		          xhr.setRequestHeader(name, value);
		        });
		      }

		      if (request.signal) {
		        request.signal.addEventListener('abort', abortXhr);

		        xhr.onreadystatechange = function() {
		          // DONE (success or failure)
		          if (xhr.readyState === 4) {
		            request.signal.removeEventListener('abort', abortXhr);
		          }
		        };
		      }

		      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
		    })
		  }

		  fetch.polyfill = true;

		  if (!g.fetch) {
		    g.fetch = fetch;
		    g.Headers = Headers;
		    g.Request = Request;
		    g.Response = Response;
		  }

		  exports.Headers = Headers;
		  exports.Request = Request;
		  exports.Response = Response;
		  exports.fetch = fetch;

		  Object.defineProperty(exports, '__esModule', { value: true });

		  return exports;

		}))({});
		})(__globalThis__);
		// This is a ponyfill, so...
		__globalThis__.fetch.ponyfill = true;
		delete __globalThis__.fetch.polyfill;
		// Choose between native implementation (__global__) or custom implementation (__globalThis__)
		var ctx = __global__.fetch ? __global__ : __globalThis__;
		exports = ctx.fetch; // To enable: import fetch from 'cross-fetch'
		exports.default = ctx.fetch; // For TypeScript consumers without esModuleInterop.
		exports.fetch = ctx.fetch; // To enable: import {fetch} from 'cross-fetch'
		exports.Headers = ctx.Headers;
		exports.Request = ctx.Request;
		exports.Response = ctx.Response;
		module.exports = exports; 
	} (browserPonyfill, browserPonyfill.exports));
	return browserPonyfill.exports;
}

var browserPonyfillExports = requireBrowserPonyfill();
var o$2 = /*@__PURE__*/getDefaultExportFromCjs(browserPonyfillExports);

var P$3=Object.defineProperty,w$2=Object.defineProperties,E$2=Object.getOwnPropertyDescriptors,c$2=Object.getOwnPropertySymbols,L$2=Object.prototype.hasOwnProperty,O$2=Object.prototype.propertyIsEnumerable,l$2=(r,t,e)=>t in r?P$3(r,t,{enumerable:true,configurable:true,writable:true,value:e}):r[t]=e,p$3=(r,t)=>{for(var e in t||(t={}))L$2.call(t,e)&&l$2(r,e,t[e]);if(c$2)for(var e of c$2(t))O$2.call(t,e)&&l$2(r,e,t[e]);return r},v$3=(r,t)=>w$2(r,E$2(t));const j$3={Accept:"application/json","Content-Type":"application/json"},T$1="POST",d$2={headers:j$3,method:T$1},g$2=10;let f$3 = class f{constructor(t,e=false){if(this.url=t,this.disableProviderPing=e,this.events=new EventEmitter$2,this.isAvailable=false,this.registering=false,!isHttpUrl(t))throw new Error(`Provided URL is not compatible with HTTP connection: ${t}`);this.url=t,this.disableProviderPing=e;}get connected(){return this.isAvailable}get connecting(){return this.registering}on(t,e){this.events.on(t,e);}once(t,e){this.events.once(t,e);}off(t,e){this.events.off(t,e);}removeListener(t,e){this.events.removeListener(t,e);}async open(t=this.url){await this.register(t);}async close(){if(!this.isAvailable)throw new Error("Connection already closed");this.onClose();}async send(t){this.isAvailable||await this.register();try{const e=safeJsonStringify(t),s=await(await o$2(this.url,v$3(p$3({},d$2),{body:e}))).json();this.onPayload({data:s});}catch(e){this.onError(t.id,e);}}async register(t=this.url){if(!isHttpUrl(t))throw new Error(`Provided URL is not compatible with HTTP connection: ${t}`);if(this.registering){const e=this.events.getMaxListeners();return (this.events.listenerCount("register_error")>=e||this.events.listenerCount("open")>=e)&&this.events.setMaxListeners(e+1),new Promise((s,i)=>{this.events.once("register_error",n=>{this.resetMaxListeners(),i(n);}),this.events.once("open",()=>{if(this.resetMaxListeners(),typeof this.isAvailable>"u")return i(new Error("HTTP connection is missing or invalid"));s();});})}this.url=t,this.registering=true;try{if(!this.disableProviderPing){const e=safeJsonStringify({id:1,jsonrpc:"2.0",method:"test",params:[]});await o$2(t,v$3(p$3({},d$2),{body:e}));}this.onOpen();}catch(e){const s=this.parseError(e);throw this.events.emit("register_error",s),this.onClose(),s}}onOpen(){this.isAvailable=true,this.registering=false,this.events.emit("open");}onClose(){this.isAvailable=false,this.registering=false,this.events.emit("close");}onPayload(t){if(typeof t.data>"u")return;const e=typeof t.data=="string"?safeJsonParse$1(t.data):t.data;this.events.emit("payload",e);}onError(t,e){const s=this.parseError(e),i=s.message||s.toString(),n=formatJsonRpcError(t,i);this.events.emit("payload",n);}parseError(t,e=this.url){return parseConnectionError(t,e,"HTTP")}resetMaxListeners(){this.events.getMaxListeners()>g$2&&this.events.setMaxListeners(g$2);}};

const Ia="error",Fg="wss://relay.walletconnect.com",Mg="wc",qg="universal_provider",xa=`${Mg}@2:${qg}:`,Bg="https://rpc.walletconnect.com/v1/",Vn={DEFAULT_CHAIN_CHANGED:"default_chain_changed"};var ge=typeof globalThis<"u"?globalThis:typeof window<"u"?window:typeof global<"u"?global:typeof self<"u"?self:{},Ui={exports:{}};/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */(function(A,u){(function(){var i,d="4.17.21",w=200,L="Unsupported core-js use. Try https://npms.io/search?q=ponyfill.",D="Expected a function",En="Invalid `variable` option passed into `_.template`",zt="__lodash_hash_undefined__",pr=500,It="__lodash_placeholder__",Ln=1,Fn=2,xt=4,Et=1,ve=2,vn=1,ct=2,qi=4,Dn=8,yt=16,Hn=32,St=64,Mn=128,Kt=256,dr=512,Da=30,Ha="...",Na=800,$a=16,Bi=1,Ua=2,Wa=3,ht=1/0,kn=9007199254740991,Fa=17976931348623157e292,_e=0/0,Nn=4294967295,Ma=Nn-1,qa=Nn>>>1,Ba=[["ary",Mn],["bind",vn],["bindKey",ct],["curry",Dn],["curryRight",yt],["flip",dr],["partial",Hn],["partialRight",St],["rearg",Kt]],Ot="[object Arguments]",me="[object Array]",Ga="[object AsyncFunction]",Yt="[object Boolean]",Zt="[object Date]",za="[object DOMException]",we="[object Error]",Pe="[object Function]",Gi="[object GeneratorFunction]",yn="[object Map]",Jt="[object Number]",Ka="[object Null]",qn="[object Object]",zi="[object Promise]",Ya="[object Proxy]",Xt="[object RegExp]",Sn="[object Set]",Qt="[object String]",Ae="[object Symbol]",Za="[object Undefined]",Vt="[object WeakMap]",Ja="[object WeakSet]",kt="[object ArrayBuffer]",Rt="[object DataView]",gr="[object Float32Array]",vr="[object Float64Array]",_r="[object Int8Array]",mr="[object Int16Array]",wr="[object Int32Array]",Pr="[object Uint8Array]",Ar="[object Uint8ClampedArray]",Cr="[object Uint16Array]",Ir="[object Uint32Array]",Xa=/\b__p \+= '';/g,Qa=/\b(__p \+=) '' \+/g,Va=/(__e\(.*?\)|\b__t\)) \+\n'';/g,Ki=/&(?:amp|lt|gt|quot|#39);/g,Yi=/[&<>"']/g,ka=RegExp(Ki.source),ja=RegExp(Yi.source),no=/<%-([\s\S]+?)%>/g,to=/<%([\s\S]+?)%>/g,Zi=/<%=([\s\S]+?)%>/g,eo=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,ro=/^\w*$/,io=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,xr=/[\\^$.*+?()[\]{}|]/g,so=RegExp(xr.source),Er=/^\s+/,uo=/\s/,ao=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,oo=/\{\n\/\* \[wrapped with (.+)\] \*/,fo=/,? & /,co=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,ho=/[()=,{}\[\]\/\s]/,lo=/\\(\\)?/g,po=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,Ji=/\w*$/,go=/^[-+]0x[0-9a-f]+$/i,vo=/^0b[01]+$/i,_o=/^\[object .+?Constructor\]$/,mo=/^0o[0-7]+$/i,wo=/^(?:0|[1-9]\d*)$/,Po=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,Ce=/($^)/,Ao=/['\n\r\u2028\u2029\\]/g,Ie="\\ud800-\\udfff",Co="\\u0300-\\u036f",Io="\\ufe20-\\ufe2f",xo="\\u20d0-\\u20ff",Xi=Co+Io+xo,Qi="\\u2700-\\u27bf",Vi="a-z\\xdf-\\xf6\\xf8-\\xff",Eo="\\xac\\xb1\\xd7\\xf7",yo="\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",So="\\u2000-\\u206f",Oo=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",ki="A-Z\\xc0-\\xd6\\xd8-\\xde",ji="\\ufe0e\\ufe0f",ns=Eo+yo+So+Oo,yr="['\u2019]",Ro="["+Ie+"]",ts="["+ns+"]",xe="["+Xi+"]",es="\\d+",bo="["+Qi+"]",rs="["+Vi+"]",is="[^"+Ie+ns+es+Qi+Vi+ki+"]",Sr="\\ud83c[\\udffb-\\udfff]",To="(?:"+xe+"|"+Sr+")",ss="[^"+Ie+"]",Or="(?:\\ud83c[\\udde6-\\uddff]){2}",Rr="[\\ud800-\\udbff][\\udc00-\\udfff]",bt="["+ki+"]",us="\\u200d",as="(?:"+rs+"|"+is+")",Lo="(?:"+bt+"|"+is+")",os="(?:"+yr+"(?:d|ll|m|re|s|t|ve))?",fs="(?:"+yr+"(?:D|LL|M|RE|S|T|VE))?",cs=To+"?",hs="["+ji+"]?",Do="(?:"+us+"(?:"+[ss,Or,Rr].join("|")+")"+hs+cs+")*",Ho="\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",No="\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",ls=hs+cs+Do,$o="(?:"+[bo,Or,Rr].join("|")+")"+ls,Uo="(?:"+[ss+xe+"?",xe,Or,Rr,Ro].join("|")+")",Wo=RegExp(yr,"g"),Fo=RegExp(xe,"g"),br=RegExp(Sr+"(?="+Sr+")|"+Uo+ls,"g"),Mo=RegExp([bt+"?"+rs+"+"+os+"(?="+[ts,bt,"$"].join("|")+")",Lo+"+"+fs+"(?="+[ts,bt+as,"$"].join("|")+")",bt+"?"+as+"+"+os,bt+"+"+fs,No,Ho,es,$o].join("|"),"g"),qo=RegExp("["+us+Ie+Xi+ji+"]"),Bo=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Go=["Array","Buffer","DataView","Date","Error","Float32Array","Float64Array","Function","Int8Array","Int16Array","Int32Array","Map","Math","Object","Promise","RegExp","Set","String","Symbol","TypeError","Uint8Array","Uint8ClampedArray","Uint16Array","Uint32Array","WeakMap","_","clearTimeout","isFinite","parseInt","setTimeout"],zo=-1,B={};B[gr]=B[vr]=B[_r]=B[mr]=B[wr]=B[Pr]=B[Ar]=B[Cr]=B[Ir]=true,B[Ot]=B[me]=B[kt]=B[Yt]=B[Rt]=B[Zt]=B[we]=B[Pe]=B[yn]=B[Jt]=B[qn]=B[Xt]=B[Sn]=B[Qt]=B[Vt]=false;var q={};q[Ot]=q[me]=q[kt]=q[Rt]=q[Yt]=q[Zt]=q[gr]=q[vr]=q[_r]=q[mr]=q[wr]=q[yn]=q[Jt]=q[qn]=q[Xt]=q[Sn]=q[Qt]=q[Ae]=q[Pr]=q[Ar]=q[Cr]=q[Ir]=true,q[we]=q[Pe]=q[Vt]=false;var Ko={\u00C0:"A",\u00C1:"A",\u00C2:"A",\u00C3:"A",\u00C4:"A",\u00C5:"A",\u00E0:"a",\u00E1:"a",\u00E2:"a",\u00E3:"a",\u00E4:"a",\u00E5:"a",\u00C7:"C",\u00E7:"c",\u00D0:"D",\u00F0:"d",\u00C8:"E",\u00C9:"E",\u00CA:"E",\u00CB:"E",\u00E8:"e",\u00E9:"e",\u00EA:"e",\u00EB:"e",\u00CC:"I",\u00CD:"I",\u00CE:"I",\u00CF:"I",\u00EC:"i",\u00ED:"i",\u00EE:"i",\u00EF:"i",\u00D1:"N",\u00F1:"n",\u00D2:"O",\u00D3:"O",\u00D4:"O",\u00D5:"O",\u00D6:"O",\u00D8:"O",\u00F2:"o",\u00F3:"o",\u00F4:"o",\u00F5:"o",\u00F6:"o",\u00F8:"o",\u00D9:"U",\u00DA:"U",\u00DB:"U",\u00DC:"U",\u00F9:"u",\u00FA:"u",\u00FB:"u",\u00FC:"u",\u00DD:"Y",\u00FD:"y",\u00FF:"y",\u00C6:"Ae",\u00E6:"ae",\u00DE:"Th",\u00FE:"th",\u00DF:"ss",\u0100:"A",\u0102:"A",\u0104:"A",\u0101:"a",\u0103:"a",\u0105:"a",\u0106:"C",\u0108:"C",\u010A:"C",\u010C:"C",\u0107:"c",\u0109:"c",\u010B:"c",\u010D:"c",\u010E:"D",\u0110:"D",\u010F:"d",\u0111:"d",\u0112:"E",\u0114:"E",\u0116:"E",\u0118:"E",\u011A:"E",\u0113:"e",\u0115:"e",\u0117:"e",\u0119:"e",\u011B:"e",\u011C:"G",\u011E:"G",\u0120:"G",\u0122:"G",\u011D:"g",\u011F:"g",\u0121:"g",\u0123:"g",\u0124:"H",\u0126:"H",\u0125:"h",\u0127:"h",\u0128:"I",\u012A:"I",\u012C:"I",\u012E:"I",\u0130:"I",\u0129:"i",\u012B:"i",\u012D:"i",\u012F:"i",\u0131:"i",\u0134:"J",\u0135:"j",\u0136:"K",\u0137:"k",\u0138:"k",\u0139:"L",\u013B:"L",\u013D:"L",\u013F:"L",\u0141:"L",\u013A:"l",\u013C:"l",\u013E:"l",\u0140:"l",\u0142:"l",\u0143:"N",\u0145:"N",\u0147:"N",\u014A:"N",\u0144:"n",\u0146:"n",\u0148:"n",\u014B:"n",\u014C:"O",\u014E:"O",\u0150:"O",\u014D:"o",\u014F:"o",\u0151:"o",\u0154:"R",\u0156:"R",\u0158:"R",\u0155:"r",\u0157:"r",\u0159:"r",\u015A:"S",\u015C:"S",\u015E:"S",\u0160:"S",\u015B:"s",\u015D:"s",\u015F:"s",\u0161:"s",\u0162:"T",\u0164:"T",\u0166:"T",\u0163:"t",\u0165:"t",\u0167:"t",\u0168:"U",\u016A:"U",\u016C:"U",\u016E:"U",\u0170:"U",\u0172:"U",\u0169:"u",\u016B:"u",\u016D:"u",\u016F:"u",\u0171:"u",\u0173:"u",\u0174:"W",\u0175:"w",\u0176:"Y",\u0177:"y",\u0178:"Y",\u0179:"Z",\u017B:"Z",\u017D:"Z",\u017A:"z",\u017C:"z",\u017E:"z",\u0132:"IJ",\u0133:"ij",\u0152:"Oe",\u0153:"oe",\u0149:"'n",\u017F:"s"},Yo={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"},Zo={"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"},Jo={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Xo=parseFloat,Qo=parseInt,ps=typeof ge=="object"&&ge&&ge.Object===Object&&ge,Vo=typeof self=="object"&&self&&self.Object===Object&&self,k=ps||Vo||Function("return this")(),Tr=u&&!u.nodeType&&u,lt=Tr&&true&&A&&!A.nodeType&&A,ds=lt&&lt.exports===Tr,Lr=ds&&ps.process,_n=function(){try{var h=lt&&lt.require&&lt.require("util").types;return h||Lr&&Lr.binding&&Lr.binding("util")}catch{}}(),gs=_n&&_n.isArrayBuffer,vs=_n&&_n.isDate,_s=_n&&_n.isMap,ms=_n&&_n.isRegExp,ws=_n&&_n.isSet,Ps=_n&&_n.isTypedArray;function cn(h,g,p){switch(p.length){case 0:return h.call(g);case 1:return h.call(g,p[0]);case 2:return h.call(g,p[0],p[1]);case 3:return h.call(g,p[0],p[1],p[2])}return h.apply(g,p)}function ko(h,g,p,C){for(var S=-1,U=h==null?0:h.length;++S<U;){var X=h[S];g(C,X,p(X),h);}return C}function mn(h,g){for(var p=-1,C=h==null?0:h.length;++p<C&&g(h[p],p,h)!==false;);return h}function jo(h,g){for(var p=h==null?0:h.length;p--&&g(h[p],p,h)!==false;);return h}function As(h,g){for(var p=-1,C=h==null?0:h.length;++p<C;)if(!g(h[p],p,h))return  false;return  true}function jn(h,g){for(var p=-1,C=h==null?0:h.length,S=0,U=[];++p<C;){var X=h[p];g(X,p,h)&&(U[S++]=X);}return U}function Ee(h,g){var p=h==null?0:h.length;return !!p&&Tt(h,g,0)>-1}function Dr(h,g,p){for(var C=-1,S=h==null?0:h.length;++C<S;)if(p(g,h[C]))return  true;return  false}function G(h,g){for(var p=-1,C=h==null?0:h.length,S=Array(C);++p<C;)S[p]=g(h[p],p,h);return S}function nt(h,g){for(var p=-1,C=g.length,S=h.length;++p<C;)h[S+p]=g[p];return h}function Hr(h,g,p,C){var S=-1,U=h==null?0:h.length;for(C&&U&&(p=h[++S]);++S<U;)p=g(p,h[S],S,h);return p}function nf(h,g,p,C){var S=h==null?0:h.length;for(C&&S&&(p=h[--S]);S--;)p=g(p,h[S],S,h);return p}function Nr(h,g){for(var p=-1,C=h==null?0:h.length;++p<C;)if(g(h[p],p,h))return  true;return  false}var tf=$r("length");function ef(h){return h.split("")}function rf(h){return h.match(co)||[]}function Cs(h,g,p){var C;return p(h,function(S,U,X){if(g(S,U,X))return C=U,false}),C}function ye(h,g,p,C){for(var S=h.length,U=p+(C?1:-1);C?U--:++U<S;)if(g(h[U],U,h))return U;return  -1}function Tt(h,g,p){return g===g?vf(h,g,p):ye(h,Is,p)}function sf(h,g,p,C){for(var S=p-1,U=h.length;++S<U;)if(C(h[S],g))return S;return  -1}function Is(h){return h!==h}function xs(h,g){var p=h==null?0:h.length;return p?Wr(h,g)/p:_e}function $r(h){return function(g){return g==null?i:g[h]}}function Ur(h){return function(g){return h==null?i:h[g]}}function Es(h,g,p,C,S){return S(h,function(U,X,M){p=C?(C=false,U):g(p,U,X,M);}),p}function uf(h,g){var p=h.length;for(h.sort(g);p--;)h[p]=h[p].value;return h}function Wr(h,g){for(var p,C=-1,S=h.length;++C<S;){var U=g(h[C]);U!==i&&(p=p===i?U:p+U);}return p}function Fr(h,g){for(var p=-1,C=Array(h);++p<h;)C[p]=g(p);return C}function af(h,g){return G(g,function(p){return [p,h[p]]})}function ys(h){return h&&h.slice(0,bs(h)+1).replace(Er,"")}function hn(h){return function(g){return h(g)}}function Mr(h,g){return G(g,function(p){return h[p]})}function jt(h,g){return h.has(g)}function Ss(h,g){for(var p=-1,C=h.length;++p<C&&Tt(g,h[p],0)>-1;);return p}function Os(h,g){for(var p=h.length;p--&&Tt(g,h[p],0)>-1;);return p}function of(h,g){for(var p=h.length,C=0;p--;)h[p]===g&&++C;return C}var ff=Ur(Ko),cf=Ur(Yo);function hf(h){return "\\"+Jo[h]}function lf(h,g){return h==null?i:h[g]}function Lt(h){return qo.test(h)}function pf(h){return Bo.test(h)}function df(h){for(var g,p=[];!(g=h.next()).done;)p.push(g.value);return p}function qr(h){var g=-1,p=Array(h.size);return h.forEach(function(C,S){p[++g]=[S,C];}),p}function Rs(h,g){return function(p){return h(g(p))}}function tt(h,g){for(var p=-1,C=h.length,S=0,U=[];++p<C;){var X=h[p];(X===g||X===It)&&(h[p]=It,U[S++]=p);}return U}function Se(h){var g=-1,p=Array(h.size);return h.forEach(function(C){p[++g]=C;}),p}function gf(h){var g=-1,p=Array(h.size);return h.forEach(function(C){p[++g]=[C,C];}),p}function vf(h,g,p){for(var C=p-1,S=h.length;++C<S;)if(h[C]===g)return C;return  -1}function _f(h,g,p){for(var C=p+1;C--;)if(h[C]===g)return C;return C}function Dt(h){return Lt(h)?wf(h):tf(h)}function On(h){return Lt(h)?Pf(h):ef(h)}function bs(h){for(var g=h.length;g--&&uo.test(h.charAt(g)););return g}var mf=Ur(Zo);function wf(h){for(var g=br.lastIndex=0;br.test(h);)++g;return g}function Pf(h){return h.match(br)||[]}function Af(h){return h.match(Mo)||[]}var Cf=function h(g){g=g==null?k:Ht.defaults(k.Object(),g,Ht.pick(k,Go));var p=g.Array,C=g.Date,S=g.Error,U=g.Function,X=g.Math,M=g.Object,Br=g.RegExp,If=g.String,wn=g.TypeError,Oe=p.prototype,xf=U.prototype,Nt=M.prototype,Re=g["__core-js_shared__"],be=xf.toString,F=Nt.hasOwnProperty,Ef=0,Ts=function(){var n=/[^.]+$/.exec(Re&&Re.keys&&Re.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),Te=Nt.toString,yf=be.call(M),Sf=k._,Of=Br("^"+be.call(F).replace(xr,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),Le=ds?g.Buffer:i,et=g.Symbol,De=g.Uint8Array,Ls=Le?Le.allocUnsafe:i,He=Rs(M.getPrototypeOf,M),Ds=M.create,Hs=Nt.propertyIsEnumerable,Ne=Oe.splice,Ns=et?et.isConcatSpreadable:i,ne=et?et.iterator:i,pt=et?et.toStringTag:i,$e=function(){try{var n=mt(M,"defineProperty");return n({},"",{}),n}catch{}}(),Rf=g.clearTimeout!==k.clearTimeout&&g.clearTimeout,bf=C&&C.now!==k.Date.now&&C.now,Tf=g.setTimeout!==k.setTimeout&&g.setTimeout,Ue=X.ceil,We=X.floor,Gr=M.getOwnPropertySymbols,Lf=Le?Le.isBuffer:i,$s=g.isFinite,Df=Oe.join,Hf=Rs(M.keys,M),Q=X.max,nn=X.min,Nf=C.now,$f=g.parseInt,Us=X.random,Uf=Oe.reverse,zr=mt(g,"DataView"),te=mt(g,"Map"),Kr=mt(g,"Promise"),$t=mt(g,"Set"),ee=mt(g,"WeakMap"),re=mt(M,"create"),Fe=ee&&new ee,Ut={},Wf=wt(zr),Ff=wt(te),Mf=wt(Kr),qf=wt($t),Bf=wt(ee),Me=et?et.prototype:i,ie=Me?Me.valueOf:i,Ws=Me?Me.toString:i;function a(n){if(Y(n)&&!O(n)&&!(n instanceof N)){if(n instanceof Pn)return n;if(F.call(n,"__wrapped__"))return Fu(n)}return new Pn(n)}var Wt=function(){function n(){}return function(t){if(!K(t))return {};if(Ds)return Ds(t);n.prototype=t;var e=new n;return n.prototype=i,e}}();function qe(){}function Pn(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=i;}a.templateSettings={escape:no,evaluate:to,interpolate:Zi,variable:"",imports:{_:a}},a.prototype=qe.prototype,a.prototype.constructor=a,Pn.prototype=Wt(qe.prototype),Pn.prototype.constructor=Pn;function N(n){this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=Nn,this.__views__=[];}function Gf(){var n=new N(this.__wrapped__);return n.__actions__=un(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=un(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=un(this.__views__),n}function zf(){if(this.__filtered__){var n=new N(this);n.__dir__=-1,n.__filtered__=true;}else n=this.clone(),n.__dir__*=-1;return n}function Kf(){var n=this.__wrapped__.value(),t=this.__dir__,e=O(n),r=t<0,s=e?n.length:0,o=rh(0,s,this.__views__),f=o.start,c=o.end,l=c-f,v=r?c:f-1,_=this.__iteratees__,m=_.length,P=0,I=nn(l,this.__takeCount__);if(!e||!r&&s==l&&I==l)return ou(n,this.__actions__);var E=[];n:for(;l--&&P<I;){v+=t;for(var b=-1,y=n[v];++b<m;){var H=_[b],$=H.iteratee,dn=H.type,sn=$(y);if(dn==Ua)y=sn;else if(!sn){if(dn==Bi)continue n;break n}}E[P++]=y;}return E}N.prototype=Wt(qe.prototype),N.prototype.constructor=N;function dt(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1]);}}function Yf(){this.__data__=re?re(null):{},this.size=0;}function Zf(n){var t=this.has(n)&&delete this.__data__[n];return this.size-=t?1:0,t}function Jf(n){var t=this.__data__;if(re){var e=t[n];return e===zt?i:e}return F.call(t,n)?t[n]:i}function Xf(n){var t=this.__data__;return re?t[n]!==i:F.call(t,n)}function Qf(n,t){var e=this.__data__;return this.size+=this.has(n)?0:1,e[n]=re&&t===i?zt:t,this}dt.prototype.clear=Yf,dt.prototype.delete=Zf,dt.prototype.get=Jf,dt.prototype.has=Xf,dt.prototype.set=Qf;function Bn(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1]);}}function Vf(){this.__data__=[],this.size=0;}function kf(n){var t=this.__data__,e=Be(t,n);if(e<0)return  false;var r=t.length-1;return e==r?t.pop():Ne.call(t,e,1),--this.size,true}function jf(n){var t=this.__data__,e=Be(t,n);return e<0?i:t[e][1]}function nc(n){return Be(this.__data__,n)>-1}function tc(n,t){var e=this.__data__,r=Be(e,n);return r<0?(++this.size,e.push([n,t])):e[r][1]=t,this}Bn.prototype.clear=Vf,Bn.prototype.delete=kf,Bn.prototype.get=jf,Bn.prototype.has=nc,Bn.prototype.set=tc;function Gn(n){var t=-1,e=n==null?0:n.length;for(this.clear();++t<e;){var r=n[t];this.set(r[0],r[1]);}}function ec(){this.size=0,this.__data__={hash:new dt,map:new(te||Bn),string:new dt};}function rc(n){var t=nr(this,n).delete(n);return this.size-=t?1:0,t}function ic(n){return nr(this,n).get(n)}function sc(n){return nr(this,n).has(n)}function uc(n,t){var e=nr(this,n),r=e.size;return e.set(n,t),this.size+=e.size==r?0:1,this}Gn.prototype.clear=ec,Gn.prototype.delete=rc,Gn.prototype.get=ic,Gn.prototype.has=sc,Gn.prototype.set=uc;function gt(n){var t=-1,e=n==null?0:n.length;for(this.__data__=new Gn;++t<e;)this.add(n[t]);}function ac(n){return this.__data__.set(n,zt),this}function oc(n){return this.__data__.has(n)}gt.prototype.add=gt.prototype.push=ac,gt.prototype.has=oc;function Rn(n){var t=this.__data__=new Bn(n);this.size=t.size;}function fc(){this.__data__=new Bn,this.size=0;}function cc(n){var t=this.__data__,e=t.delete(n);return this.size=t.size,e}function hc(n){return this.__data__.get(n)}function lc(n){return this.__data__.has(n)}function pc(n,t){var e=this.__data__;if(e instanceof Bn){var r=e.__data__;if(!te||r.length<w-1)return r.push([n,t]),this.size=++e.size,this;e=this.__data__=new Gn(r);}return e.set(n,t),this.size=e.size,this}Rn.prototype.clear=fc,Rn.prototype.delete=cc,Rn.prototype.get=hc,Rn.prototype.has=lc,Rn.prototype.set=pc;function Fs(n,t){var e=O(n),r=!e&&Pt(n),s=!e&&!r&&at(n),o=!e&&!r&&!s&&Bt(n),f=e||r||s||o,c=f?Fr(n.length,If):[],l=c.length;for(var v in n)(t||F.call(n,v))&&!(f&&(v=="length"||s&&(v=="offset"||v=="parent")||o&&(v=="buffer"||v=="byteLength"||v=="byteOffset")||Zn(v,l)))&&c.push(v);return c}function Ms(n){var t=n.length;return t?n[ei(0,t-1)]:i}function dc(n,t){return tr(un(n),vt(t,0,n.length))}function gc(n){return tr(un(n))}function Yr(n,t,e){(e!==i&&!bn(n[t],e)||e===i&&!(t in n))&&zn(n,t,e);}function se(n,t,e){var r=n[t];(!(F.call(n,t)&&bn(r,e))||e===i&&!(t in n))&&zn(n,t,e);}function Be(n,t){for(var e=n.length;e--;)if(bn(n[e][0],t))return e;return  -1}function vc(n,t,e,r){return rt(n,function(s,o,f){t(r,s,e(s),f);}),r}function qs(n,t){return n&&Un(t,V(t),n)}function _c(n,t){return n&&Un(t,on(t),n)}function zn(n,t,e){t=="__proto__"&&$e?$e(n,t,{configurable:true,enumerable:true,value:e,writable:true}):n[t]=e;}function Zr(n,t){for(var e=-1,r=t.length,s=p(r),o=n==null;++e<r;)s[e]=o?i:Si(n,t[e]);return s}function vt(n,t,e){return n===n&&(e!==i&&(n=n<=e?n:e),t!==i&&(n=n>=t?n:t)),n}function An(n,t,e,r,s,o){var f,c=t&Ln,l=t&Fn,v=t&xt;if(e&&(f=s?e(n,r,s,o):e(n)),f!==i)return f;if(!K(n))return n;var _=O(n);if(_){if(f=sh(n),!c)return un(n,f)}else {var m=tn(n),P=m==Pe||m==Gi;if(at(n))return hu(n,c);if(m==qn||m==Ot||P&&!s){if(f=l||P?{}:bu(n),!c)return l?Jc(n,_c(f,n)):Zc(n,qs(f,n))}else {if(!q[m])return s?n:{};f=uh(n,m,c);}}o||(o=new Rn);var I=o.get(n);if(I)return I;o.set(n,f),sa(n)?n.forEach(function(y){f.add(An(y,t,e,y,n,o));}):ra(n)&&n.forEach(function(y,H){f.set(H,An(y,t,e,H,n,o));});var E=v?l?pi:li:l?on:V,b=_?i:E(n);return mn(b||n,function(y,H){b&&(H=y,y=n[H]),se(f,H,An(y,t,e,H,n,o));}),f}function mc(n){var t=V(n);return function(e){return Bs(e,n,t)}}function Bs(n,t,e){var r=e.length;if(n==null)return !r;for(n=M(n);r--;){var s=e[r],o=t[s],f=n[s];if(f===i&&!(s in n)||!o(f))return  false}return  true}function Gs(n,t,e){if(typeof n!="function")throw new wn(D);return le(function(){n.apply(i,e);},t)}function ue(n,t,e,r){var s=-1,o=Ee,f=true,c=n.length,l=[],v=t.length;if(!c)return l;e&&(t=G(t,hn(e))),r?(o=Dr,f=false):t.length>=w&&(o=jt,f=false,t=new gt(t));n:for(;++s<c;){var _=n[s],m=e==null?_:e(_);if(_=r||_!==0?_:0,f&&m===m){for(var P=v;P--;)if(t[P]===m)continue n;l.push(_);}else o(t,m,r)||l.push(_);}return l}var rt=vu($n),zs=vu(Xr,true);function wc(n,t){var e=true;return rt(n,function(r,s,o){return e=!!t(r,s,o),e}),e}function Ge(n,t,e){for(var r=-1,s=n.length;++r<s;){var o=n[r],f=t(o);if(f!=null&&(c===i?f===f&&!pn(f):e(f,c)))var c=f,l=o;}return l}function Pc(n,t,e,r){var s=n.length;for(e=R(e),e<0&&(e=-e>s?0:s+e),r=r===i||r>s?s:R(r),r<0&&(r+=s),r=e>r?0:aa(r);e<r;)n[e++]=t;return n}function Ks(n,t){var e=[];return rt(n,function(r,s,o){t(r,s,o)&&e.push(r);}),e}function j(n,t,e,r,s){var o=-1,f=n.length;for(e||(e=oh),s||(s=[]);++o<f;){var c=n[o];t>0&&e(c)?t>1?j(c,t-1,e,r,s):nt(s,c):r||(s[s.length]=c);}return s}var Jr=_u(),Ys=_u(true);function $n(n,t){return n&&Jr(n,t,V)}function Xr(n,t){return n&&Ys(n,t,V)}function ze(n,t){return jn(t,function(e){return Jn(n[e])})}function _t(n,t){t=st(t,n);for(var e=0,r=t.length;n!=null&&e<r;)n=n[Wn(t[e++])];return e&&e==r?n:i}function Zs(n,t,e){var r=t(n);return O(n)?r:nt(r,e(n))}function en(n){return n==null?n===i?Za:Ka:pt&&pt in M(n)?eh(n):gh(n)}function Qr(n,t){return n>t}function Ac(n,t){return n!=null&&F.call(n,t)}function Cc(n,t){return n!=null&&t in M(n)}function Ic(n,t,e){return n>=nn(t,e)&&n<Q(t,e)}function Vr(n,t,e){for(var r=e?Dr:Ee,s=n[0].length,o=n.length,f=o,c=p(o),l=1/0,v=[];f--;){var _=n[f];f&&t&&(_=G(_,hn(t))),l=nn(_.length,l),c[f]=!e&&(t||s>=120&&_.length>=120)?new gt(f&&_):i;}_=n[0];var m=-1,P=c[0];n:for(;++m<s&&v.length<l;){var I=_[m],E=t?t(I):I;if(I=e||I!==0?I:0,!(P?jt(P,E):r(v,E,e))){for(f=o;--f;){var b=c[f];if(!(b?jt(b,E):r(n[f],E,e)))continue n}P&&P.push(E),v.push(I);}}return v}function xc(n,t,e,r){return $n(n,function(s,o,f){t(r,e(s),o,f);}),r}function ae(n,t,e){t=st(t,n),n=Hu(n,t);var r=n==null?n:n[Wn(In(t))];return r==null?i:cn(r,n,e)}function Js(n){return Y(n)&&en(n)==Ot}function Ec(n){return Y(n)&&en(n)==kt}function yc(n){return Y(n)&&en(n)==Zt}function oe(n,t,e,r,s){return n===t?true:n==null||t==null||!Y(n)&&!Y(t)?n!==n&&t!==t:Sc(n,t,e,r,oe,s)}function Sc(n,t,e,r,s,o){var f=O(n),c=O(t),l=f?me:tn(n),v=c?me:tn(t);l=l==Ot?qn:l,v=v==Ot?qn:v;var _=l==qn,m=v==qn,P=l==v;if(P&&at(n)){if(!at(t))return  false;f=true,_=false;}if(P&&!_)return o||(o=new Rn),f||Bt(n)?Su(n,t,e,r,s,o):nh(n,t,l,e,r,s,o);if(!(e&Et)){var I=_&&F.call(n,"__wrapped__"),E=m&&F.call(t,"__wrapped__");if(I||E){var b=I?n.value():n,y=E?t.value():t;return o||(o=new Rn),s(b,y,e,r,o)}}return P?(o||(o=new Rn),th(n,t,e,r,s,o)):false}function Oc(n){return Y(n)&&tn(n)==yn}function kr(n,t,e,r){var s=e.length,o=s,f=!r;if(n==null)return !o;for(n=M(n);s--;){var c=e[s];if(f&&c[2]?c[1]!==n[c[0]]:!(c[0]in n))return  false}for(;++s<o;){c=e[s];var l=c[0],v=n[l],_=c[1];if(f&&c[2]){if(v===i&&!(l in n))return  false}else {var m=new Rn;if(r)var P=r(v,_,l,n,t,m);if(!(P===i?oe(_,v,Et|ve,r,m):P))return  false}}return  true}function Xs(n){if(!K(n)||ch(n))return  false;var t=Jn(n)?Of:_o;return t.test(wt(n))}function Rc(n){return Y(n)&&en(n)==Xt}function bc(n){return Y(n)&&tn(n)==Sn}function Tc(n){return Y(n)&&ar(n.length)&&!!B[en(n)]}function Qs(n){return typeof n=="function"?n:n==null?fn:typeof n=="object"?O(n)?js(n[0],n[1]):ks(n):ma(n)}function jr(n){if(!he(n))return Hf(n);var t=[];for(var e in M(n))F.call(n,e)&&e!="constructor"&&t.push(e);return t}function Lc(n){if(!K(n))return dh(n);var t=he(n),e=[];for(var r in n)r=="constructor"&&(t||!F.call(n,r))||e.push(r);return e}function ni(n,t){return n<t}function Vs(n,t){var e=-1,r=an(n)?p(n.length):[];return rt(n,function(s,o,f){r[++e]=t(s,o,f);}),r}function ks(n){var t=gi(n);return t.length==1&&t[0][2]?Lu(t[0][0],t[0][1]):function(e){return e===n||kr(e,n,t)}}function js(n,t){return _i(n)&&Tu(t)?Lu(Wn(n),t):function(e){var r=Si(e,n);return r===i&&r===t?Oi(e,n):oe(t,r,Et|ve)}}function Ke(n,t,e,r,s){n!==t&&Jr(t,function(o,f){if(s||(s=new Rn),K(o))Dc(n,t,f,e,Ke,r,s);else {var c=r?r(wi(n,f),o,f+"",n,t,s):i;c===i&&(c=o),Yr(n,f,c);}},on);}function Dc(n,t,e,r,s,o,f){var c=wi(n,e),l=wi(t,e),v=f.get(l);if(v){Yr(n,e,v);return}var _=o?o(c,l,e+"",n,t,f):i,m=_===i;if(m){var P=O(l),I=!P&&at(l),E=!P&&!I&&Bt(l);_=l,P||I||E?O(c)?_=c:Z(c)?_=un(c):I?(m=false,_=hu(l,true)):E?(m=false,_=lu(l,true)):_=[]:pe(l)||Pt(l)?(_=c,Pt(c)?_=oa(c):(!K(c)||Jn(c))&&(_=bu(l))):m=false;}m&&(f.set(l,_),s(_,l,r,o,f),f.delete(l)),Yr(n,e,_);}function nu(n,t){var e=n.length;if(e)return t+=t<0?e:0,Zn(t,e)?n[t]:i}function tu(n,t,e){t.length?t=G(t,function(o){return O(o)?function(f){return _t(f,o.length===1?o[0]:o)}:o}):t=[fn];var r=-1;t=G(t,hn(x()));var s=Vs(n,function(o,f,c){var l=G(t,function(v){return v(o)});return {criteria:l,index:++r,value:o}});return uf(s,function(o,f){return Yc(o,f,e)})}function Hc(n,t){return eu(n,t,function(e,r){return Oi(n,r)})}function eu(n,t,e){for(var r=-1,s=t.length,o={};++r<s;){var f=t[r],c=_t(n,f);e(c,f)&&fe(o,st(f,n),c);}return o}function Nc(n){return function(t){return _t(t,n)}}function ti(n,t,e,r){var s=r?sf:Tt,o=-1,f=t.length,c=n;for(n===t&&(t=un(t)),e&&(c=G(n,hn(e)));++o<f;)for(var l=0,v=t[o],_=e?e(v):v;(l=s(c,_,l,r))>-1;)c!==n&&Ne.call(c,l,1),Ne.call(n,l,1);return n}function ru(n,t){for(var e=n?t.length:0,r=e-1;e--;){var s=t[e];if(e==r||s!==o){var o=s;Zn(s)?Ne.call(n,s,1):si(n,s);}}return n}function ei(n,t){return n+We(Us()*(t-n+1))}function $c(n,t,e,r){for(var s=-1,o=Q(Ue((t-n)/(e||1)),0),f=p(o);o--;)f[r?o:++s]=n,n+=e;return f}function ri(n,t){var e="";if(!n||t<1||t>kn)return e;do t%2&&(e+=n),t=We(t/2),t&&(n+=n);while(t);return e}function T(n,t){return Pi(Du(n,t,fn),n+"")}function Uc(n){return Ms(Gt(n))}function Wc(n,t){var e=Gt(n);return tr(e,vt(t,0,e.length))}function fe(n,t,e,r){if(!K(n))return n;t=st(t,n);for(var s=-1,o=t.length,f=o-1,c=n;c!=null&&++s<o;){var l=Wn(t[s]),v=e;if(l==="__proto__"||l==="constructor"||l==="prototype")return n;if(s!=f){var _=c[l];v=r?r(_,l,c):i,v===i&&(v=K(_)?_:Zn(t[s+1])?[]:{});}se(c,l,v),c=c[l];}return n}var iu=Fe?function(n,t){return Fe.set(n,t),n}:fn,Fc=$e?function(n,t){return $e(n,"toString",{configurable:true,enumerable:false,value:bi(t),writable:true})}:fn;function Mc(n){return tr(Gt(n))}function Cn(n,t,e){var r=-1,s=n.length;t<0&&(t=-t>s?0:s+t),e=e>s?s:e,e<0&&(e+=s),s=t>e?0:e-t>>>0,t>>>=0;for(var o=p(s);++r<s;)o[r]=n[r+t];return o}function qc(n,t){var e;return rt(n,function(r,s,o){return e=t(r,s,o),!e}),!!e}function Ye(n,t,e){var r=0,s=n==null?r:n.length;if(typeof t=="number"&&t===t&&s<=qa){for(;r<s;){var o=r+s>>>1,f=n[o];f!==null&&!pn(f)&&(e?f<=t:f<t)?r=o+1:s=o;}return s}return ii(n,t,fn,e)}function ii(n,t,e,r){var s=0,o=n==null?0:n.length;if(o===0)return 0;t=e(t);for(var f=t!==t,c=t===null,l=pn(t),v=t===i;s<o;){var _=We((s+o)/2),m=e(n[_]),P=m!==i,I=m===null,E=m===m,b=pn(m);if(f)var y=r||E;else v?y=E&&(r||P):c?y=E&&P&&(r||!I):l?y=E&&P&&!I&&(r||!b):I||b?y=false:y=r?m<=t:m<t;y?s=_+1:o=_;}return nn(o,Ma)}function su(n,t){for(var e=-1,r=n.length,s=0,o=[];++e<r;){var f=n[e],c=t?t(f):f;if(!e||!bn(c,l)){var l=c;o[s++]=f===0?0:f;}}return o}function uu(n){return typeof n=="number"?n:pn(n)?_e:+n}function ln(n){if(typeof n=="string")return n;if(O(n))return G(n,ln)+"";if(pn(n))return Ws?Ws.call(n):"";var t=n+"";return t=="0"&&1/n==-Infinity?"-0":t}function it(n,t,e){var r=-1,s=Ee,o=n.length,f=true,c=[],l=c;if(e)f=false,s=Dr;else if(o>=w){var v=t?null:kc(n);if(v)return Se(v);f=false,s=jt,l=new gt;}else l=t?[]:c;n:for(;++r<o;){var _=n[r],m=t?t(_):_;if(_=e||_!==0?_:0,f&&m===m){for(var P=l.length;P--;)if(l[P]===m)continue n;t&&l.push(m),c.push(_);}else s(l,m,e)||(l!==c&&l.push(m),c.push(_));}return c}function si(n,t){return t=st(t,n),n=Hu(n,t),n==null||delete n[Wn(In(t))]}function au(n,t,e,r){return fe(n,t,e(_t(n,t)),r)}function Ze(n,t,e,r){for(var s=n.length,o=r?s:-1;(r?o--:++o<s)&&t(n[o],o,n););return e?Cn(n,r?0:o,r?o+1:s):Cn(n,r?o+1:0,r?s:o)}function ou(n,t){var e=n;return e instanceof N&&(e=e.value()),Hr(t,function(r,s){return s.func.apply(s.thisArg,nt([r],s.args))},e)}function ui(n,t,e){var r=n.length;if(r<2)return r?it(n[0]):[];for(var s=-1,o=p(r);++s<r;)for(var f=n[s],c=-1;++c<r;)c!=s&&(o[s]=ue(o[s]||f,n[c],t,e));return it(j(o,1),t,e)}function fu(n,t,e){for(var r=-1,s=n.length,o=t.length,f={};++r<s;){var c=r<o?t[r]:i;e(f,n[r],c);}return f}function ai(n){return Z(n)?n:[]}function oi(n){return typeof n=="function"?n:fn}function st(n,t){return O(n)?n:_i(n,t)?[n]:Wu(W(n))}var Bc=T;function ut(n,t,e){var r=n.length;return e=e===i?r:e,!t&&e>=r?n:Cn(n,t,e)}var cu=Rf||function(n){return k.clearTimeout(n)};function hu(n,t){if(t)return n.slice();var e=n.length,r=Ls?Ls(e):new n.constructor(e);return n.copy(r),r}function fi(n){var t=new n.constructor(n.byteLength);return new De(t).set(new De(n)),t}function Gc(n,t){var e=t?fi(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.byteLength)}function zc(n){var t=new n.constructor(n.source,Ji.exec(n));return t.lastIndex=n.lastIndex,t}function Kc(n){return ie?M(ie.call(n)):{}}function lu(n,t){var e=t?fi(n.buffer):n.buffer;return new n.constructor(e,n.byteOffset,n.length)}function pu(n,t){if(n!==t){var e=n!==i,r=n===null,s=n===n,o=pn(n),f=t!==i,c=t===null,l=t===t,v=pn(t);if(!c&&!v&&!o&&n>t||o&&f&&l&&!c&&!v||r&&f&&l||!e&&l||!s)return 1;if(!r&&!o&&!v&&n<t||v&&e&&s&&!r&&!o||c&&e&&s||!f&&s||!l)return  -1}return 0}function Yc(n,t,e){for(var r=-1,s=n.criteria,o=t.criteria,f=s.length,c=e.length;++r<f;){var l=pu(s[r],o[r]);if(l){if(r>=c)return l;var v=e[r];return l*(v=="desc"?-1:1)}}return n.index-t.index}function du(n,t,e,r){for(var s=-1,o=n.length,f=e.length,c=-1,l=t.length,v=Q(o-f,0),_=p(l+v),m=!r;++c<l;)_[c]=t[c];for(;++s<f;)(m||s<o)&&(_[e[s]]=n[s]);for(;v--;)_[c++]=n[s++];return _}function gu(n,t,e,r){for(var s=-1,o=n.length,f=-1,c=e.length,l=-1,v=t.length,_=Q(o-c,0),m=p(_+v),P=!r;++s<_;)m[s]=n[s];for(var I=s;++l<v;)m[I+l]=t[l];for(;++f<c;)(P||s<o)&&(m[I+e[f]]=n[s++]);return m}function un(n,t){var e=-1,r=n.length;for(t||(t=p(r));++e<r;)t[e]=n[e];return t}function Un(n,t,e,r){var s=!e;e||(e={});for(var o=-1,f=t.length;++o<f;){var c=t[o],l=r?r(e[c],n[c],c,e,n):i;l===i&&(l=n[c]),s?zn(e,c,l):se(e,c,l);}return e}function Zc(n,t){return Un(n,vi(n),t)}function Jc(n,t){return Un(n,Ou(n),t)}function Je(n,t){return function(e,r){var s=O(e)?ko:vc,o=t?t():{};return s(e,n,x(r,2),o)}}function Ft(n){return T(function(t,e){var r=-1,s=e.length,o=s>1?e[s-1]:i,f=s>2?e[2]:i;for(o=n.length>3&&typeof o=="function"?(s--,o):i,f&&rn(e[0],e[1],f)&&(o=s<3?i:o,s=1),t=M(t);++r<s;){var c=e[r];c&&n(t,c,r,o);}return t})}function vu(n,t){return function(e,r){if(e==null)return e;if(!an(e))return n(e,r);for(var s=e.length,o=t?s:-1,f=M(e);(t?o--:++o<s)&&r(f[o],o,f)!==false;);return e}}function _u(n){return function(t,e,r){for(var s=-1,o=M(t),f=r(t),c=f.length;c--;){var l=f[n?c:++s];if(e(o[l],l,o)===false)break}return t}}function Xc(n,t,e){var r=t&vn,s=ce(n);function o(){var f=this&&this!==k&&this instanceof o?s:n;return f.apply(r?e:this,arguments)}return o}function mu(n){return function(t){t=W(t);var e=Lt(t)?On(t):i,r=e?e[0]:t.charAt(0),s=e?ut(e,1).join(""):t.slice(1);return r[n]()+s}}function Mt(n){return function(t){return Hr(va(ga(t).replace(Wo,"")),n,"")}}function ce(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var e=Wt(n.prototype),r=n.apply(e,t);return K(r)?r:e}}function Qc(n,t,e){var r=ce(n);function s(){for(var o=arguments.length,f=p(o),c=o,l=qt(s);c--;)f[c]=arguments[c];var v=o<3&&f[0]!==l&&f[o-1]!==l?[]:tt(f,l);if(o-=v.length,o<e)return Iu(n,t,Xe,s.placeholder,i,f,v,i,i,e-o);var _=this&&this!==k&&this instanceof s?r:n;return cn(_,this,f)}return s}function wu(n){return function(t,e,r){var s=M(t);if(!an(t)){var o=x(e,3);t=V(t),e=function(c){return o(s[c],c,s)};}var f=n(t,e,r);return f>-1?s[o?t[f]:f]:i}}function Pu(n){return Yn(function(t){var e=t.length,r=e,s=Pn.prototype.thru;for(n&&t.reverse();r--;){var o=t[r];if(typeof o!="function")throw new wn(D);if(s&&!f&&je(o)=="wrapper")var f=new Pn([],true);}for(r=f?r:e;++r<e;){o=t[r];var c=je(o),l=c=="wrapper"?di(o):i;l&&mi(l[0])&&l[1]==(Mn|Dn|Hn|Kt)&&!l[4].length&&l[9]==1?f=f[je(l[0])].apply(f,l[3]):f=o.length==1&&mi(o)?f[c]():f.thru(o);}return function(){var v=arguments,_=v[0];if(f&&v.length==1&&O(_))return f.plant(_).value();for(var m=0,P=e?t[m].apply(this,v):_;++m<e;)P=t[m].call(this,P);return P}})}function Xe(n,t,e,r,s,o,f,c,l,v){var _=t&Mn,m=t&vn,P=t&ct,I=t&(Dn|yt),E=t&dr,b=P?i:ce(n);function y(){for(var H=arguments.length,$=p(H),dn=H;dn--;)$[dn]=arguments[dn];if(I)var sn=qt(y),gn=of($,sn);if(r&&($=du($,r,s,I)),o&&($=gu($,o,f,I)),H-=gn,I&&H<v){var J=tt($,sn);return Iu(n,t,Xe,y.placeholder,e,$,J,c,l,v-H)}var Tn=m?e:this,Qn=P?Tn[n]:n;return H=$.length,c?$=vh($,c):E&&H>1&&$.reverse(),_&&l<H&&($.length=l),this&&this!==k&&this instanceof y&&(Qn=b||ce(Qn)),Qn.apply(Tn,$)}return y}function Au(n,t){return function(e,r){return xc(e,n,t(r),{})}}function Qe(n,t){return function(e,r){var s;if(e===i&&r===i)return t;if(e!==i&&(s=e),r!==i){if(s===i)return r;typeof e=="string"||typeof r=="string"?(e=ln(e),r=ln(r)):(e=uu(e),r=uu(r)),s=n(e,r);}return s}}function ci(n){return Yn(function(t){return t=G(t,hn(x())),T(function(e){var r=this;return n(t,function(s){return cn(s,r,e)})})})}function Ve(n,t){t=t===i?" ":ln(t);var e=t.length;if(e<2)return e?ri(t,n):t;var r=ri(t,Ue(n/Dt(t)));return Lt(t)?ut(On(r),0,n).join(""):r.slice(0,n)}function Vc(n,t,e,r){var s=t&vn,o=ce(n);function f(){for(var c=-1,l=arguments.length,v=-1,_=r.length,m=p(_+l),P=this&&this!==k&&this instanceof f?o:n;++v<_;)m[v]=r[v];for(;l--;)m[v++]=arguments[++c];return cn(P,s?e:this,m)}return f}function Cu(n){return function(t,e,r){return r&&typeof r!="number"&&rn(t,e,r)&&(e=r=i),t=Xn(t),e===i?(e=t,t=0):e=Xn(e),r=r===i?t<e?1:-1:Xn(r),$c(t,e,r,n)}}function ke(n){return function(t,e){return typeof t=="string"&&typeof e=="string"||(t=xn(t),e=xn(e)),n(t,e)}}function Iu(n,t,e,r,s,o,f,c,l,v){var _=t&Dn,m=_?f:i,P=_?i:f,I=_?o:i,E=_?i:o;t|=_?Hn:St,t&=~(_?St:Hn),t&qi||(t&=-4);var b=[n,t,s,I,m,E,P,c,l,v],y=e.apply(i,b);return mi(n)&&Nu(y,b),y.placeholder=r,$u(y,n,t)}function hi(n){var t=X[n];return function(e,r){if(e=xn(e),r=r==null?0:nn(R(r),292),r&&$s(e)){var s=(W(e)+"e").split("e"),o=t(s[0]+"e"+(+s[1]+r));return s=(W(o)+"e").split("e"),+(s[0]+"e"+(+s[1]-r))}return t(e)}}var kc=$t&&1/Se(new $t([,-0]))[1]==ht?function(n){return new $t(n)}:Di;function xu(n){return function(t){var e=tn(t);return e==yn?qr(t):e==Sn?gf(t):af(t,n(t))}}function Kn(n,t,e,r,s,o,f,c){var l=t&ct;if(!l&&typeof n!="function")throw new wn(D);var v=r?r.length:0;if(v||(t&=-97,r=s=i),f=f===i?f:Q(R(f),0),c=c===i?c:R(c),v-=s?s.length:0,t&St){var _=r,m=s;r=s=i;}var P=l?i:di(n),I=[n,t,e,r,s,_,m,o,f,c];if(P&&ph(I,P),n=I[0],t=I[1],e=I[2],r=I[3],s=I[4],c=I[9]=I[9]===i?l?0:n.length:Q(I[9]-v,0),!c&&t&(Dn|yt)&&(t&=-25),!t||t==vn)var E=Xc(n,t,e);else t==Dn||t==yt?E=Qc(n,t,c):(t==Hn||t==(vn|Hn))&&!s.length?E=Vc(n,t,e,r):E=Xe.apply(i,I);var b=P?iu:Nu;return $u(b(E,I),n,t)}function Eu(n,t,e,r){return n===i||bn(n,Nt[e])&&!F.call(r,e)?t:n}function yu(n,t,e,r,s,o){return K(n)&&K(t)&&(o.set(t,n),Ke(n,t,i,yu,o),o.delete(t)),n}function jc(n){return pe(n)?i:n}function Su(n,t,e,r,s,o){var f=e&Et,c=n.length,l=t.length;if(c!=l&&!(f&&l>c))return  false;var v=o.get(n),_=o.get(t);if(v&&_)return v==t&&_==n;var m=-1,P=true,I=e&ve?new gt:i;for(o.set(n,t),o.set(t,n);++m<c;){var E=n[m],b=t[m];if(r)var y=f?r(b,E,m,t,n,o):r(E,b,m,n,t,o);if(y!==i){if(y)continue;P=false;break}if(I){if(!Nr(t,function(H,$){if(!jt(I,$)&&(E===H||s(E,H,e,r,o)))return I.push($)})){P=false;break}}else if(!(E===b||s(E,b,e,r,o))){P=false;break}}return o.delete(n),o.delete(t),P}function nh(n,t,e,r,s,o,f){switch(e){case Rt:if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)return  false;n=n.buffer,t=t.buffer;case kt:return !(n.byteLength!=t.byteLength||!o(new De(n),new De(t)));case Yt:case Zt:case Jt:return bn(+n,+t);case we:return n.name==t.name&&n.message==t.message;case Xt:case Qt:return n==t+"";case yn:var c=qr;case Sn:var l=r&Et;if(c||(c=Se),n.size!=t.size&&!l)return  false;var v=f.get(n);if(v)return v==t;r|=ve,f.set(n,t);var _=Su(c(n),c(t),r,s,o,f);return f.delete(n),_;case Ae:if(ie)return ie.call(n)==ie.call(t)}return  false}function th(n,t,e,r,s,o){var f=e&Et,c=li(n),l=c.length,v=li(t),_=v.length;if(l!=_&&!f)return  false;for(var m=l;m--;){var P=c[m];if(!(f?P in t:F.call(t,P)))return  false}var I=o.get(n),E=o.get(t);if(I&&E)return I==t&&E==n;var b=true;o.set(n,t),o.set(t,n);for(var y=f;++m<l;){P=c[m];var H=n[P],$=t[P];if(r)var dn=f?r($,H,P,t,n,o):r(H,$,P,n,t,o);if(!(dn===i?H===$||s(H,$,e,r,o):dn)){b=false;break}y||(y=P=="constructor");}if(b&&!y){var sn=n.constructor,gn=t.constructor;sn!=gn&&"constructor"in n&&"constructor"in t&&!(typeof sn=="function"&&sn instanceof sn&&typeof gn=="function"&&gn instanceof gn)&&(b=false);}return o.delete(n),o.delete(t),b}function Yn(n){return Pi(Du(n,i,Bu),n+"")}function li(n){return Zs(n,V,vi)}function pi(n){return Zs(n,on,Ou)}var di=Fe?function(n){return Fe.get(n)}:Di;function je(n){for(var t=n.name+"",e=Ut[t],r=F.call(Ut,t)?e.length:0;r--;){var s=e[r],o=s.func;if(o==null||o==n)return s.name}return t}function qt(n){var t=F.call(a,"placeholder")?a:n;return t.placeholder}function x(){var n=a.iteratee||Ti;return n=n===Ti?Qs:n,arguments.length?n(arguments[0],arguments[1]):n}function nr(n,t){var e=n.__data__;return fh(t)?e[typeof t=="string"?"string":"hash"]:e.map}function gi(n){for(var t=V(n),e=t.length;e--;){var r=t[e],s=n[r];t[e]=[r,s,Tu(s)];}return t}function mt(n,t){var e=lf(n,t);return Xs(e)?e:i}function eh(n){var t=F.call(n,pt),e=n[pt];try{n[pt]=i;var r=!0;}catch{}var s=Te.call(n);return r&&(t?n[pt]=e:delete n[pt]),s}var vi=Gr?function(n){return n==null?[]:(n=M(n),jn(Gr(n),function(t){return Hs.call(n,t)}))}:Hi,Ou=Gr?function(n){for(var t=[];n;)nt(t,vi(n)),n=He(n);return t}:Hi,tn=en;(zr&&tn(new zr(new ArrayBuffer(1)))!=Rt||te&&tn(new te)!=yn||Kr&&tn(Kr.resolve())!=zi||$t&&tn(new $t)!=Sn||ee&&tn(new ee)!=Vt)&&(tn=function(n){var t=en(n),e=t==qn?n.constructor:i,r=e?wt(e):"";if(r)switch(r){case Wf:return Rt;case Ff:return yn;case Mf:return zi;case qf:return Sn;case Bf:return Vt}return t});function rh(n,t,e){for(var r=-1,s=e.length;++r<s;){var o=e[r],f=o.size;switch(o.type){case "drop":n+=f;break;case "dropRight":t-=f;break;case "take":t=nn(t,n+f);break;case "takeRight":n=Q(n,t-f);break}}return {start:n,end:t}}function ih(n){var t=n.match(oo);return t?t[1].split(fo):[]}function Ru(n,t,e){t=st(t,n);for(var r=-1,s=t.length,o=false;++r<s;){var f=Wn(t[r]);if(!(o=n!=null&&e(n,f)))break;n=n[f];}return o||++r!=s?o:(s=n==null?0:n.length,!!s&&ar(s)&&Zn(f,s)&&(O(n)||Pt(n)))}function sh(n){var t=n.length,e=new n.constructor(t);return t&&typeof n[0]=="string"&&F.call(n,"index")&&(e.index=n.index,e.input=n.input),e}function bu(n){return typeof n.constructor=="function"&&!he(n)?Wt(He(n)):{}}function uh(n,t,e){var r=n.constructor;switch(t){case kt:return fi(n);case Yt:case Zt:return new r(+n);case Rt:return Gc(n,e);case gr:case vr:case _r:case mr:case wr:case Pr:case Ar:case Cr:case Ir:return lu(n,e);case yn:return new r;case Jt:case Qt:return new r(n);case Xt:return zc(n);case Sn:return new r;case Ae:return Kc(n)}}function ah(n,t){var e=t.length;if(!e)return n;var r=e-1;return t[r]=(e>1?"& ":"")+t[r],t=t.join(e>2?", ":" "),n.replace(ao,`{
/* [wrapped with `+t+`] */
`)}function oh(n){return O(n)||Pt(n)||!!(Ns&&n&&n[Ns])}function Zn(n,t){var e=typeof n;return t=t??kn,!!t&&(e=="number"||e!="symbol"&&wo.test(n))&&n>-1&&n%1==0&&n<t}function rn(n,t,e){if(!K(e))return  false;var r=typeof t;return (r=="number"?an(e)&&Zn(t,e.length):r=="string"&&t in e)?bn(e[t],n):false}function _i(n,t){if(O(n))return  false;var e=typeof n;return e=="number"||e=="symbol"||e=="boolean"||n==null||pn(n)?true:ro.test(n)||!eo.test(n)||t!=null&&n in M(t)}function fh(n){var t=typeof n;return t=="string"||t=="number"||t=="symbol"||t=="boolean"?n!=="__proto__":n===null}function mi(n){var t=je(n),e=a[t];if(typeof e!="function"||!(t in N.prototype))return  false;if(n===e)return  true;var r=di(e);return !!r&&n===r[0]}function ch(n){return !!Ts&&Ts in n}var hh=Re?Jn:Ni;function he(n){var t=n&&n.constructor,e=typeof t=="function"&&t.prototype||Nt;return n===e}function Tu(n){return n===n&&!K(n)}function Lu(n,t){return function(e){return e==null?false:e[n]===t&&(t!==i||n in M(e))}}function lh(n){var t=sr(n,function(r){return e.size===pr&&e.clear(),r}),e=t.cache;return t}function ph(n,t){var e=n[1],r=t[1],s=e|r,o=s<(vn|ct|Mn),f=r==Mn&&e==Dn||r==Mn&&e==Kt&&n[7].length<=t[8]||r==(Mn|Kt)&&t[7].length<=t[8]&&e==Dn;if(!(o||f))return n;r&vn&&(n[2]=t[2],s|=e&vn?0:qi);var c=t[3];if(c){var l=n[3];n[3]=l?du(l,c,t[4]):c,n[4]=l?tt(n[3],It):t[4];}return c=t[5],c&&(l=n[5],n[5]=l?gu(l,c,t[6]):c,n[6]=l?tt(n[5],It):t[6]),c=t[7],c&&(n[7]=c),r&Mn&&(n[8]=n[8]==null?t[8]:nn(n[8],t[8])),n[9]==null&&(n[9]=t[9]),n[0]=t[0],n[1]=s,n}function dh(n){var t=[];if(n!=null)for(var e in M(n))t.push(e);return t}function gh(n){return Te.call(n)}function Du(n,t,e){return t=Q(t===i?n.length-1:t,0),function(){for(var r=arguments,s=-1,o=Q(r.length-t,0),f=p(o);++s<o;)f[s]=r[t+s];s=-1;for(var c=p(t+1);++s<t;)c[s]=r[s];return c[t]=e(f),cn(n,this,c)}}function Hu(n,t){return t.length<2?n:_t(n,Cn(t,0,-1))}function vh(n,t){for(var e=n.length,r=nn(t.length,e),s=un(n);r--;){var o=t[r];n[r]=Zn(o,e)?s[o]:i;}return n}function wi(n,t){if(!(t==="constructor"&&typeof n[t]=="function")&&t!="__proto__")return n[t]}var Nu=Uu(iu),le=Tf||function(n,t){return k.setTimeout(n,t)},Pi=Uu(Fc);function $u(n,t,e){var r=t+"";return Pi(n,ah(r,_h(ih(r),e)))}function Uu(n){var t=0,e=0;return function(){var r=Nf(),s=$a-(r-e);if(e=r,s>0){if(++t>=Na)return arguments[0]}else t=0;return n.apply(i,arguments)}}function tr(n,t){var e=-1,r=n.length,s=r-1;for(t=t===i?r:t;++e<t;){var o=ei(e,s),f=n[o];n[o]=n[e],n[e]=f;}return n.length=t,n}var Wu=lh(function(n){var t=[];return n.charCodeAt(0)===46&&t.push(""),n.replace(io,function(e,r,s,o){t.push(s?o.replace(lo,"$1"):r||e);}),t});function Wn(n){if(typeof n=="string"||pn(n))return n;var t=n+"";return t=="0"&&1/n==-Infinity?"-0":t}function wt(n){if(n!=null){try{return be.call(n)}catch{}try{return n+""}catch{}}return ""}function _h(n,t){return mn(Ba,function(e){var r="_."+e[0];t&e[1]&&!Ee(n,r)&&n.push(r);}),n.sort()}function Fu(n){if(n instanceof N)return n.clone();var t=new Pn(n.__wrapped__,n.__chain__);return t.__actions__=un(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function mh(n,t,e){(e?rn(n,t,e):t===i)?t=1:t=Q(R(t),0);var r=n==null?0:n.length;if(!r||t<1)return [];for(var s=0,o=0,f=p(Ue(r/t));s<r;)f[o++]=Cn(n,s,s+=t);return f}function wh(n){for(var t=-1,e=n==null?0:n.length,r=0,s=[];++t<e;){var o=n[t];o&&(s[r++]=o);}return s}function Ph(){var n=arguments.length;if(!n)return [];for(var t=p(n-1),e=arguments[0],r=n;r--;)t[r-1]=arguments[r];return nt(O(e)?un(e):[e],j(t,1))}var Ah=T(function(n,t){return Z(n)?ue(n,j(t,1,Z,true)):[]}),Ch=T(function(n,t){var e=In(t);return Z(e)&&(e=i),Z(n)?ue(n,j(t,1,Z,true),x(e,2)):[]}),Ih=T(function(n,t){var e=In(t);return Z(e)&&(e=i),Z(n)?ue(n,j(t,1,Z,true),i,e):[]});function xh(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===i?1:R(t),Cn(n,t<0?0:t,r)):[]}function Eh(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===i?1:R(t),t=r-t,Cn(n,0,t<0?0:t)):[]}function yh(n,t){return n&&n.length?Ze(n,x(t,3),true,true):[]}function Sh(n,t){return n&&n.length?Ze(n,x(t,3),true):[]}function Oh(n,t,e,r){var s=n==null?0:n.length;return s?(e&&typeof e!="number"&&rn(n,t,e)&&(e=0,r=s),Pc(n,t,e,r)):[]}function Mu(n,t,e){var r=n==null?0:n.length;if(!r)return  -1;var s=e==null?0:R(e);return s<0&&(s=Q(r+s,0)),ye(n,x(t,3),s)}function qu(n,t,e){var r=n==null?0:n.length;if(!r)return  -1;var s=r-1;return e!==i&&(s=R(e),s=e<0?Q(r+s,0):nn(s,r-1)),ye(n,x(t,3),s,true)}function Bu(n){var t=n==null?0:n.length;return t?j(n,1):[]}function Rh(n){var t=n==null?0:n.length;return t?j(n,ht):[]}function bh(n,t){var e=n==null?0:n.length;return e?(t=t===i?1:R(t),j(n,t)):[]}function Th(n){for(var t=-1,e=n==null?0:n.length,r={};++t<e;){var s=n[t];r[s[0]]=s[1];}return r}function Gu(n){return n&&n.length?n[0]:i}function Lh(n,t,e){var r=n==null?0:n.length;if(!r)return  -1;var s=e==null?0:R(e);return s<0&&(s=Q(r+s,0)),Tt(n,t,s)}function Dh(n){var t=n==null?0:n.length;return t?Cn(n,0,-1):[]}var Hh=T(function(n){var t=G(n,ai);return t.length&&t[0]===n[0]?Vr(t):[]}),Nh=T(function(n){var t=In(n),e=G(n,ai);return t===In(e)?t=i:e.pop(),e.length&&e[0]===n[0]?Vr(e,x(t,2)):[]}),$h=T(function(n){var t=In(n),e=G(n,ai);return t=typeof t=="function"?t:i,t&&e.pop(),e.length&&e[0]===n[0]?Vr(e,i,t):[]});function Uh(n,t){return n==null?"":Df.call(n,t)}function In(n){var t=n==null?0:n.length;return t?n[t-1]:i}function Wh(n,t,e){var r=n==null?0:n.length;if(!r)return  -1;var s=r;return e!==i&&(s=R(e),s=s<0?Q(r+s,0):nn(s,r-1)),t===t?_f(n,t,s):ye(n,Is,s,true)}function Fh(n,t){return n&&n.length?nu(n,R(t)):i}var Mh=T(zu);function zu(n,t){return n&&n.length&&t&&t.length?ti(n,t):n}function qh(n,t,e){return n&&n.length&&t&&t.length?ti(n,t,x(e,2)):n}function Bh(n,t,e){return n&&n.length&&t&&t.length?ti(n,t,i,e):n}var Gh=Yn(function(n,t){var e=n==null?0:n.length,r=Zr(n,t);return ru(n,G(t,function(s){return Zn(s,e)?+s:s}).sort(pu)),r});function zh(n,t){var e=[];if(!(n&&n.length))return e;var r=-1,s=[],o=n.length;for(t=x(t,3);++r<o;){var f=n[r];t(f,r,n)&&(e.push(f),s.push(r));}return ru(n,s),e}function Ai(n){return n==null?n:Uf.call(n)}function Kh(n,t,e){var r=n==null?0:n.length;return r?(e&&typeof e!="number"&&rn(n,t,e)?(t=0,e=r):(t=t==null?0:R(t),e=e===i?r:R(e)),Cn(n,t,e)):[]}function Yh(n,t){return Ye(n,t)}function Zh(n,t,e){return ii(n,t,x(e,2))}function Jh(n,t){var e=n==null?0:n.length;if(e){var r=Ye(n,t);if(r<e&&bn(n[r],t))return r}return  -1}function Xh(n,t){return Ye(n,t,true)}function Qh(n,t,e){return ii(n,t,x(e,2),true)}function Vh(n,t){var e=n==null?0:n.length;if(e){var r=Ye(n,t,true)-1;if(bn(n[r],t))return r}return  -1}function kh(n){return n&&n.length?su(n):[]}function jh(n,t){return n&&n.length?su(n,x(t,2)):[]}function nl(n){var t=n==null?0:n.length;return t?Cn(n,1,t):[]}function tl(n,t,e){return n&&n.length?(t=e||t===i?1:R(t),Cn(n,0,t<0?0:t)):[]}function el(n,t,e){var r=n==null?0:n.length;return r?(t=e||t===i?1:R(t),t=r-t,Cn(n,t<0?0:t,r)):[]}function rl(n,t){return n&&n.length?Ze(n,x(t,3),false,true):[]}function il(n,t){return n&&n.length?Ze(n,x(t,3)):[]}var sl=T(function(n){return it(j(n,1,Z,true))}),ul=T(function(n){var t=In(n);return Z(t)&&(t=i),it(j(n,1,Z,true),x(t,2))}),al=T(function(n){var t=In(n);return t=typeof t=="function"?t:i,it(j(n,1,Z,true),i,t)});function ol(n){return n&&n.length?it(n):[]}function fl(n,t){return n&&n.length?it(n,x(t,2)):[]}function cl(n,t){return t=typeof t=="function"?t:i,n&&n.length?it(n,i,t):[]}function Ci(n){if(!(n&&n.length))return [];var t=0;return n=jn(n,function(e){if(Z(e))return t=Q(e.length,t),true}),Fr(t,function(e){return G(n,$r(e))})}function Ku(n,t){if(!(n&&n.length))return [];var e=Ci(n);return t==null?e:G(e,function(r){return cn(t,i,r)})}var hl=T(function(n,t){return Z(n)?ue(n,t):[]}),ll=T(function(n){return ui(jn(n,Z))}),pl=T(function(n){var t=In(n);return Z(t)&&(t=i),ui(jn(n,Z),x(t,2))}),dl=T(function(n){var t=In(n);return t=typeof t=="function"?t:i,ui(jn(n,Z),i,t)}),gl=T(Ci);function vl(n,t){return fu(n||[],t||[],se)}function _l(n,t){return fu(n||[],t||[],fe)}var ml=T(function(n){var t=n.length,e=t>1?n[t-1]:i;return e=typeof e=="function"?(n.pop(),e):i,Ku(n,e)});function Yu(n){var t=a(n);return t.__chain__=true,t}function wl(n,t){return t(n),n}function er(n,t){return t(n)}var Pl=Yn(function(n){var t=n.length,e=t?n[0]:0,r=this.__wrapped__,s=function(o){return Zr(o,n)};return t>1||this.__actions__.length||!(r instanceof N)||!Zn(e)?this.thru(s):(r=r.slice(e,+e+(t?1:0)),r.__actions__.push({func:er,args:[s],thisArg:i}),new Pn(r,this.__chain__).thru(function(o){return t&&!o.length&&o.push(i),o}))});function Al(){return Yu(this)}function Cl(){return new Pn(this.value(),this.__chain__)}function Il(){this.__values__===i&&(this.__values__=ua(this.value()));var n=this.__index__>=this.__values__.length,t=n?i:this.__values__[this.__index__++];return {done:n,value:t}}function xl(){return this}function El(n){for(var t,e=this;e instanceof qe;){var r=Fu(e);r.__index__=0,r.__values__=i,t?s.__wrapped__=r:t=r;var s=r;e=e.__wrapped__;}return s.__wrapped__=n,t}function yl(){var n=this.__wrapped__;if(n instanceof N){var t=n;return this.__actions__.length&&(t=new N(this)),t=t.reverse(),t.__actions__.push({func:er,args:[Ai],thisArg:i}),new Pn(t,this.__chain__)}return this.thru(Ai)}function Sl(){return ou(this.__wrapped__,this.__actions__)}var Ol=Je(function(n,t,e){F.call(n,e)?++n[e]:zn(n,e,1);});function Rl(n,t,e){var r=O(n)?As:wc;return e&&rn(n,t,e)&&(t=i),r(n,x(t,3))}function bl(n,t){var e=O(n)?jn:Ks;return e(n,x(t,3))}var Tl=wu(Mu),Ll=wu(qu);function Dl(n,t){return j(rr(n,t),1)}function Hl(n,t){return j(rr(n,t),ht)}function Nl(n,t,e){return e=e===i?1:R(e),j(rr(n,t),e)}function Zu(n,t){var e=O(n)?mn:rt;return e(n,x(t,3))}function Ju(n,t){var e=O(n)?jo:zs;return e(n,x(t,3))}var $l=Je(function(n,t,e){F.call(n,e)?n[e].push(t):zn(n,e,[t]);});function Ul(n,t,e,r){n=an(n)?n:Gt(n),e=e&&!r?R(e):0;var s=n.length;return e<0&&(e=Q(s+e,0)),or(n)?e<=s&&n.indexOf(t,e)>-1:!!s&&Tt(n,t,e)>-1}var Wl=T(function(n,t,e){var r=-1,s=typeof t=="function",o=an(n)?p(n.length):[];return rt(n,function(f){o[++r]=s?cn(t,f,e):ae(f,t,e);}),o}),Fl=Je(function(n,t,e){zn(n,e,t);});function rr(n,t){var e=O(n)?G:Vs;return e(n,x(t,3))}function Ml(n,t,e,r){return n==null?[]:(O(t)||(t=t==null?[]:[t]),e=r?i:e,O(e)||(e=e==null?[]:[e]),tu(n,t,e))}var ql=Je(function(n,t,e){n[e?0:1].push(t);},function(){return [[],[]]});function Bl(n,t,e){var r=O(n)?Hr:Es,s=arguments.length<3;return r(n,x(t,4),e,s,rt)}function Gl(n,t,e){var r=O(n)?nf:Es,s=arguments.length<3;return r(n,x(t,4),e,s,zs)}function zl(n,t){var e=O(n)?jn:Ks;return e(n,ur(x(t,3)))}function Kl(n){var t=O(n)?Ms:Uc;return t(n)}function Yl(n,t,e){(e?rn(n,t,e):t===i)?t=1:t=R(t);var r=O(n)?dc:Wc;return r(n,t)}function Zl(n){var t=O(n)?gc:Mc;return t(n)}function Jl(n){if(n==null)return 0;if(an(n))return or(n)?Dt(n):n.length;var t=tn(n);return t==yn||t==Sn?n.size:jr(n).length}function Xl(n,t,e){var r=O(n)?Nr:qc;return e&&rn(n,t,e)&&(t=i),r(n,x(t,3))}var Ql=T(function(n,t){if(n==null)return [];var e=t.length;return e>1&&rn(n,t[0],t[1])?t=[]:e>2&&rn(t[0],t[1],t[2])&&(t=[t[0]]),tu(n,j(t,1),[])}),ir=bf||function(){return k.Date.now()};function Vl(n,t){if(typeof t!="function")throw new wn(D);return n=R(n),function(){if(--n<1)return t.apply(this,arguments)}}function Xu(n,t,e){return t=e?i:t,t=n&&t==null?n.length:t,Kn(n,Mn,i,i,i,i,t)}function Qu(n,t){var e;if(typeof t!="function")throw new wn(D);return n=R(n),function(){return --n>0&&(e=t.apply(this,arguments)),n<=1&&(t=i),e}}var Ii=T(function(n,t,e){var r=vn;if(e.length){var s=tt(e,qt(Ii));r|=Hn;}return Kn(n,r,t,e,s)}),Vu=T(function(n,t,e){var r=vn|ct;if(e.length){var s=tt(e,qt(Vu));r|=Hn;}return Kn(t,r,n,e,s)});function ku(n,t,e){t=e?i:t;var r=Kn(n,Dn,i,i,i,i,i,t);return r.placeholder=ku.placeholder,r}function ju(n,t,e){t=e?i:t;var r=Kn(n,yt,i,i,i,i,i,t);return r.placeholder=ju.placeholder,r}function na(n,t,e){var r,s,o,f,c,l,v=0,_=false,m=false,P=true;if(typeof n!="function")throw new wn(D);t=xn(t)||0,K(e)&&(_=!!e.leading,m="maxWait"in e,o=m?Q(xn(e.maxWait)||0,t):o,P="trailing"in e?!!e.trailing:P);function I(J){var Tn=r,Qn=s;return r=s=i,v=J,f=n.apply(Qn,Tn),f}function E(J){return v=J,c=le(H,t),_?I(J):f}function b(J){var Tn=J-l,Qn=J-v,wa=t-Tn;return m?nn(wa,o-Qn):wa}function y(J){var Tn=J-l,Qn=J-v;return l===i||Tn>=t||Tn<0||m&&Qn>=o}function H(){var J=ir();if(y(J))return $(J);c=le(H,b(J));}function $(J){return c=i,P&&r?I(J):(r=s=i,f)}function dn(){c!==i&&cu(c),v=0,r=l=s=c=i;}function sn(){return c===i?f:$(ir())}function gn(){var J=ir(),Tn=y(J);if(r=arguments,s=this,l=J,Tn){if(c===i)return E(l);if(m)return cu(c),c=le(H,t),I(l)}return c===i&&(c=le(H,t)),f}return gn.cancel=dn,gn.flush=sn,gn}var kl=T(function(n,t){return Gs(n,1,t)}),jl=T(function(n,t,e){return Gs(n,xn(t)||0,e)});function np(n){return Kn(n,dr)}function sr(n,t){if(typeof n!="function"||t!=null&&typeof t!="function")throw new wn(D);var e=function(){var r=arguments,s=t?t.apply(this,r):r[0],o=e.cache;if(o.has(s))return o.get(s);var f=n.apply(this,r);return e.cache=o.set(s,f)||o,f};return e.cache=new(sr.Cache||Gn),e}sr.Cache=Gn;function ur(n){if(typeof n!="function")throw new wn(D);return function(){var t=arguments;switch(t.length){case 0:return !n.call(this);case 1:return !n.call(this,t[0]);case 2:return !n.call(this,t[0],t[1]);case 3:return !n.call(this,t[0],t[1],t[2])}return !n.apply(this,t)}}function tp(n){return Qu(2,n)}var ep=Bc(function(n,t){t=t.length==1&&O(t[0])?G(t[0],hn(x())):G(j(t,1),hn(x()));var e=t.length;return T(function(r){for(var s=-1,o=nn(r.length,e);++s<o;)r[s]=t[s].call(this,r[s]);return cn(n,this,r)})}),xi=T(function(n,t){var e=tt(t,qt(xi));return Kn(n,Hn,i,t,e)}),ta=T(function(n,t){var e=tt(t,qt(ta));return Kn(n,St,i,t,e)}),rp=Yn(function(n,t){return Kn(n,Kt,i,i,i,t)});function ip(n,t){if(typeof n!="function")throw new wn(D);return t=t===i?t:R(t),T(n,t)}function sp(n,t){if(typeof n!="function")throw new wn(D);return t=t==null?0:Q(R(t),0),T(function(e){var r=e[t],s=ut(e,0,t);return r&&nt(s,r),cn(n,this,s)})}function up(n,t,e){var r=true,s=true;if(typeof n!="function")throw new wn(D);return K(e)&&(r="leading"in e?!!e.leading:r,s="trailing"in e?!!e.trailing:s),na(n,t,{leading:r,maxWait:t,trailing:s})}function ap(n){return Xu(n,1)}function op(n,t){return xi(oi(t),n)}function fp(){if(!arguments.length)return [];var n=arguments[0];return O(n)?n:[n]}function cp(n){return An(n,xt)}function hp(n,t){return t=typeof t=="function"?t:i,An(n,xt,t)}function lp(n){return An(n,Ln|xt)}function pp(n,t){return t=typeof t=="function"?t:i,An(n,Ln|xt,t)}function dp(n,t){return t==null||Bs(n,t,V(t))}function bn(n,t){return n===t||n!==n&&t!==t}var gp=ke(Qr),vp=ke(function(n,t){return n>=t}),Pt=Js(function(){return arguments}())?Js:function(n){return Y(n)&&F.call(n,"callee")&&!Hs.call(n,"callee")},O=p.isArray,_p=gs?hn(gs):Ec;function an(n){return n!=null&&ar(n.length)&&!Jn(n)}function Z(n){return Y(n)&&an(n)}function mp(n){return n===true||n===false||Y(n)&&en(n)==Yt}var at=Lf||Ni,wp=vs?hn(vs):yc;function Pp(n){return Y(n)&&n.nodeType===1&&!pe(n)}function Ap(n){if(n==null)return  true;if(an(n)&&(O(n)||typeof n=="string"||typeof n.splice=="function"||at(n)||Bt(n)||Pt(n)))return !n.length;var t=tn(n);if(t==yn||t==Sn)return !n.size;if(he(n))return !jr(n).length;for(var e in n)if(F.call(n,e))return  false;return  true}function Cp(n,t){return oe(n,t)}function Ip(n,t,e){e=typeof e=="function"?e:i;var r=e?e(n,t):i;return r===i?oe(n,t,i,e):!!r}function Ei(n){if(!Y(n))return  false;var t=en(n);return t==we||t==za||typeof n.message=="string"&&typeof n.name=="string"&&!pe(n)}function xp(n){return typeof n=="number"&&$s(n)}function Jn(n){if(!K(n))return  false;var t=en(n);return t==Pe||t==Gi||t==Ga||t==Ya}function ea(n){return typeof n=="number"&&n==R(n)}function ar(n){return typeof n=="number"&&n>-1&&n%1==0&&n<=kn}function K(n){var t=typeof n;return n!=null&&(t=="object"||t=="function")}function Y(n){return n!=null&&typeof n=="object"}var ra=_s?hn(_s):Oc;function Ep(n,t){return n===t||kr(n,t,gi(t))}function yp(n,t,e){return e=typeof e=="function"?e:i,kr(n,t,gi(t),e)}function Sp(n){return ia(n)&&n!=+n}function Op(n){if(hh(n))throw new S(L);return Xs(n)}function Rp(n){return n===null}function bp(n){return n==null}function ia(n){return typeof n=="number"||Y(n)&&en(n)==Jt}function pe(n){if(!Y(n)||en(n)!=qn)return  false;var t=He(n);if(t===null)return  true;var e=F.call(t,"constructor")&&t.constructor;return typeof e=="function"&&e instanceof e&&be.call(e)==yf}var yi=ms?hn(ms):Rc;function Tp(n){return ea(n)&&n>=-9007199254740991&&n<=kn}var sa=ws?hn(ws):bc;function or(n){return typeof n=="string"||!O(n)&&Y(n)&&en(n)==Qt}function pn(n){return typeof n=="symbol"||Y(n)&&en(n)==Ae}var Bt=Ps?hn(Ps):Tc;function Lp(n){return n===i}function Dp(n){return Y(n)&&tn(n)==Vt}function Hp(n){return Y(n)&&en(n)==Ja}var Np=ke(ni),$p=ke(function(n,t){return n<=t});function ua(n){if(!n)return [];if(an(n))return or(n)?On(n):un(n);if(ne&&n[ne])return df(n[ne]());var t=tn(n),e=t==yn?qr:t==Sn?Se:Gt;return e(n)}function Xn(n){if(!n)return n===0?n:0;if(n=xn(n),n===ht||n===-Infinity){var t=n<0?-1:1;return t*Fa}return n===n?n:0}function R(n){var t=Xn(n),e=t%1;return t===t?e?t-e:t:0}function aa(n){return n?vt(R(n),0,Nn):0}function xn(n){if(typeof n=="number")return n;if(pn(n))return _e;if(K(n)){var t=typeof n.valueOf=="function"?n.valueOf():n;n=K(t)?t+"":t;}if(typeof n!="string")return n===0?n:+n;n=ys(n);var e=vo.test(n);return e||mo.test(n)?Qo(n.slice(2),e?2:8):go.test(n)?_e:+n}function oa(n){return Un(n,on(n))}function Up(n){return n?vt(R(n),-9007199254740991,kn):n===0?n:0}function W(n){return n==null?"":ln(n)}var Wp=Ft(function(n,t){if(he(t)||an(t)){Un(t,V(t),n);return}for(var e in t)F.call(t,e)&&se(n,e,t[e]);}),fa=Ft(function(n,t){Un(t,on(t),n);}),fr=Ft(function(n,t,e,r){Un(t,on(t),n,r);}),Fp=Ft(function(n,t,e,r){Un(t,V(t),n,r);}),Mp=Yn(Zr);function qp(n,t){var e=Wt(n);return t==null?e:qs(e,t)}var Bp=T(function(n,t){n=M(n);var e=-1,r=t.length,s=r>2?t[2]:i;for(s&&rn(t[0],t[1],s)&&(r=1);++e<r;)for(var o=t[e],f=on(o),c=-1,l=f.length;++c<l;){var v=f[c],_=n[v];(_===i||bn(_,Nt[v])&&!F.call(n,v))&&(n[v]=o[v]);}return n}),Gp=T(function(n){return n.push(i,yu),cn(ca,i,n)});function zp(n,t){return Cs(n,x(t,3),$n)}function Kp(n,t){return Cs(n,x(t,3),Xr)}function Yp(n,t){return n==null?n:Jr(n,x(t,3),on)}function Zp(n,t){return n==null?n:Ys(n,x(t,3),on)}function Jp(n,t){return n&&$n(n,x(t,3))}function Xp(n,t){return n&&Xr(n,x(t,3))}function Qp(n){return n==null?[]:ze(n,V(n))}function Vp(n){return n==null?[]:ze(n,on(n))}function Si(n,t,e){var r=n==null?i:_t(n,t);return r===i?e:r}function kp(n,t){return n!=null&&Ru(n,t,Ac)}function Oi(n,t){return n!=null&&Ru(n,t,Cc)}var jp=Au(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Te.call(t)),n[t]=e;},bi(fn)),nd=Au(function(n,t,e){t!=null&&typeof t.toString!="function"&&(t=Te.call(t)),F.call(n,t)?n[t].push(e):n[t]=[e];},x),td=T(ae);function V(n){return an(n)?Fs(n):jr(n)}function on(n){return an(n)?Fs(n,true):Lc(n)}function ed(n,t){var e={};return t=x(t,3),$n(n,function(r,s,o){zn(e,t(r,s,o),r);}),e}function rd(n,t){var e={};return t=x(t,3),$n(n,function(r,s,o){zn(e,s,t(r,s,o));}),e}var id=Ft(function(n,t,e){Ke(n,t,e);}),ca=Ft(function(n,t,e,r){Ke(n,t,e,r);}),sd=Yn(function(n,t){var e={};if(n==null)return e;var r=false;t=G(t,function(o){return o=st(o,n),r||(r=o.length>1),o}),Un(n,pi(n),e),r&&(e=An(e,Ln|Fn|xt,jc));for(var s=t.length;s--;)si(e,t[s]);return e});function ud(n,t){return ha(n,ur(x(t)))}var ad=Yn(function(n,t){return n==null?{}:Hc(n,t)});function ha(n,t){if(n==null)return {};var e=G(pi(n),function(r){return [r]});return t=x(t),eu(n,e,function(r,s){return t(r,s[0])})}function od(n,t,e){t=st(t,n);var r=-1,s=t.length;for(s||(s=1,n=i);++r<s;){var o=n==null?i:n[Wn(t[r])];o===i&&(r=s,o=e),n=Jn(o)?o.call(n):o;}return n}function fd(n,t,e){return n==null?n:fe(n,t,e)}function cd(n,t,e,r){return r=typeof r=="function"?r:i,n==null?n:fe(n,t,e,r)}var la=xu(V),pa=xu(on);function hd(n,t,e){var r=O(n),s=r||at(n)||Bt(n);if(t=x(t,4),e==null){var o=n&&n.constructor;s?e=r?new o:[]:K(n)?e=Jn(o)?Wt(He(n)):{}:e={};}return (s?mn:$n)(n,function(f,c,l){return t(e,f,c,l)}),e}function ld(n,t){return n==null?true:si(n,t)}function pd(n,t,e){return n==null?n:au(n,t,oi(e))}function dd(n,t,e,r){return r=typeof r=="function"?r:i,n==null?n:au(n,t,oi(e),r)}function Gt(n){return n==null?[]:Mr(n,V(n))}function gd(n){return n==null?[]:Mr(n,on(n))}function vd(n,t,e){return e===i&&(e=t,t=i),e!==i&&(e=xn(e),e=e===e?e:0),t!==i&&(t=xn(t),t=t===t?t:0),vt(xn(n),t,e)}function _d(n,t,e){return t=Xn(t),e===i?(e=t,t=0):e=Xn(e),n=xn(n),Ic(n,t,e)}function md(n,t,e){if(e&&typeof e!="boolean"&&rn(n,t,e)&&(t=e=i),e===i&&(typeof t=="boolean"?(e=t,t=i):typeof n=="boolean"&&(e=n,n=i)),n===i&&t===i?(n=0,t=1):(n=Xn(n),t===i?(t=n,n=0):t=Xn(t)),n>t){var r=n;n=t,t=r;}if(e||n%1||t%1){var s=Us();return nn(n+s*(t-n+Xo("1e-"+((s+"").length-1))),t)}return ei(n,t)}var wd=Mt(function(n,t,e){return t=t.toLowerCase(),n+(e?da(t):t)});function da(n){return Ri(W(n).toLowerCase())}function ga(n){return n=W(n),n&&n.replace(Po,ff).replace(Fo,"")}function Pd(n,t,e){n=W(n),t=ln(t);var r=n.length;e=e===i?r:vt(R(e),0,r);var s=e;return e-=t.length,e>=0&&n.slice(e,s)==t}function Ad(n){return n=W(n),n&&ja.test(n)?n.replace(Yi,cf):n}function Cd(n){return n=W(n),n&&so.test(n)?n.replace(xr,"\\$&"):n}var Id=Mt(function(n,t,e){return n+(e?"-":"")+t.toLowerCase()}),xd=Mt(function(n,t,e){return n+(e?" ":"")+t.toLowerCase()}),Ed=mu("toLowerCase");function yd(n,t,e){n=W(n),t=R(t);var r=t?Dt(n):0;if(!t||r>=t)return n;var s=(t-r)/2;return Ve(We(s),e)+n+Ve(Ue(s),e)}function Sd(n,t,e){n=W(n),t=R(t);var r=t?Dt(n):0;return t&&r<t?n+Ve(t-r,e):n}function Od(n,t,e){n=W(n),t=R(t);var r=t?Dt(n):0;return t&&r<t?Ve(t-r,e)+n:n}function Rd(n,t,e){return e||t==null?t=0:t&&(t=+t),$f(W(n).replace(Er,""),t||0)}function bd(n,t,e){return (e?rn(n,t,e):t===i)?t=1:t=R(t),ri(W(n),t)}function Td(){var n=arguments,t=W(n[0]);return n.length<3?t:t.replace(n[1],n[2])}var Ld=Mt(function(n,t,e){return n+(e?"_":"")+t.toLowerCase()});function Dd(n,t,e){return e&&typeof e!="number"&&rn(n,t,e)&&(t=e=i),e=e===i?Nn:e>>>0,e?(n=W(n),n&&(typeof t=="string"||t!=null&&!yi(t))&&(t=ln(t),!t&&Lt(n))?ut(On(n),0,e):n.split(t,e)):[]}var Hd=Mt(function(n,t,e){return n+(e?" ":"")+Ri(t)});function Nd(n,t,e){return n=W(n),e=e==null?0:vt(R(e),0,n.length),t=ln(t),n.slice(e,e+t.length)==t}function $d(n,t,e){var r=a.templateSettings;e&&rn(n,t,e)&&(t=i),n=W(n),t=fr({},t,r,Eu);var s=fr({},t.imports,r.imports,Eu),o=V(s),f=Mr(s,o),c,l,v=0,_=t.interpolate||Ce,m="__p += '",P=Br((t.escape||Ce).source+"|"+_.source+"|"+(_===Zi?po:Ce).source+"|"+(t.evaluate||Ce).source+"|$","g"),I="//# sourceURL="+(F.call(t,"sourceURL")?(t.sourceURL+"").replace(/\s/g," "):"lodash.templateSources["+ ++zo+"]")+`
`;n.replace(P,function(y,H,$,dn,sn,gn){return $||($=dn),m+=n.slice(v,gn).replace(Ao,hf),H&&(c=true,m+=`' +
__e(`+H+`) +
'`),sn&&(l=true,m+=`';
`+sn+`;
__p += '`),$&&(m+=`' +
((__t = (`+$+`)) == null ? '' : __t) +
'`),v=gn+y.length,y}),m+=`';
`;var E=F.call(t,"variable")&&t.variable;if(!E)m=`with (obj) {
`+m+`
}
`;else if(ho.test(E))throw new S(En);m=(l?m.replace(Xa,""):m).replace(Qa,"$1").replace(Va,"$1;"),m="function("+(E||"obj")+`) {
`+(E?"":`obj || (obj = {});
`)+"var __t, __p = ''"+(c?", __e = _.escape":"")+(l?`, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
`:`;
`)+m+`return __p
}`;var b=_a(function(){return U(o,I+"return "+m).apply(i,f)});if(b.source=m,Ei(b))throw b;return b}function Ud(n){return W(n).toLowerCase()}function Wd(n){return W(n).toUpperCase()}function Fd(n,t,e){if(n=W(n),n&&(e||t===i))return ys(n);if(!n||!(t=ln(t)))return n;var r=On(n),s=On(t),o=Ss(r,s),f=Os(r,s)+1;return ut(r,o,f).join("")}function Md(n,t,e){if(n=W(n),n&&(e||t===i))return n.slice(0,bs(n)+1);if(!n||!(t=ln(t)))return n;var r=On(n),s=Os(r,On(t))+1;return ut(r,0,s).join("")}function qd(n,t,e){if(n=W(n),n&&(e||t===i))return n.replace(Er,"");if(!n||!(t=ln(t)))return n;var r=On(n),s=Ss(r,On(t));return ut(r,s).join("")}function Bd(n,t){var e=Da,r=Ha;if(K(t)){var s="separator"in t?t.separator:s;e="length"in t?R(t.length):e,r="omission"in t?ln(t.omission):r;}n=W(n);var o=n.length;if(Lt(n)){var f=On(n);o=f.length;}if(e>=o)return n;var c=e-Dt(r);if(c<1)return r;var l=f?ut(f,0,c).join(""):n.slice(0,c);if(s===i)return l+r;if(f&&(c+=l.length-c),yi(s)){if(n.slice(c).search(s)){var v,_=l;for(s.global||(s=Br(s.source,W(Ji.exec(s))+"g")),s.lastIndex=0;v=s.exec(_);)var m=v.index;l=l.slice(0,m===i?c:m);}}else if(n.indexOf(ln(s),c)!=c){var P=l.lastIndexOf(s);P>-1&&(l=l.slice(0,P));}return l+r}function Gd(n){return n=W(n),n&&ka.test(n)?n.replace(Ki,mf):n}var zd=Mt(function(n,t,e){return n+(e?" ":"")+t.toUpperCase()}),Ri=mu("toUpperCase");function va(n,t,e){return n=W(n),t=e?i:t,t===i?pf(n)?Af(n):rf(n):n.match(t)||[]}var _a=T(function(n,t){try{return cn(n,i,t)}catch(e){return Ei(e)?e:new S(e)}}),Kd=Yn(function(n,t){return mn(t,function(e){e=Wn(e),zn(n,e,Ii(n[e],n));}),n});function Yd(n){var t=n==null?0:n.length,e=x();return n=t?G(n,function(r){if(typeof r[1]!="function")throw new wn(D);return [e(r[0]),r[1]]}):[],T(function(r){for(var s=-1;++s<t;){var o=n[s];if(cn(o[0],this,r))return cn(o[1],this,r)}})}function Zd(n){return mc(An(n,Ln))}function bi(n){return function(){return n}}function Jd(n,t){return n==null||n!==n?t:n}var Xd=Pu(),Qd=Pu(true);function fn(n){return n}function Ti(n){return Qs(typeof n=="function"?n:An(n,Ln))}function Vd(n){return ks(An(n,Ln))}function kd(n,t){return js(n,An(t,Ln))}var jd=T(function(n,t){return function(e){return ae(e,n,t)}}),ng=T(function(n,t){return function(e){return ae(n,e,t)}});function Li(n,t,e){var r=V(t),s=ze(t,r);e==null&&!(K(t)&&(s.length||!r.length))&&(e=t,t=n,n=this,s=ze(t,V(t)));var o=!(K(e)&&"chain"in e)||!!e.chain,f=Jn(n);return mn(s,function(c){var l=t[c];n[c]=l,f&&(n.prototype[c]=function(){var v=this.__chain__;if(o||v){var _=n(this.__wrapped__),m=_.__actions__=un(this.__actions__);return m.push({func:l,args:arguments,thisArg:n}),_.__chain__=v,_}return l.apply(n,nt([this.value()],arguments))});}),n}function tg(){return k._===this&&(k._=Sf),this}function Di(){}function eg(n){return n=R(n),T(function(t){return nu(t,n)})}var rg=ci(G),ig=ci(As),sg=ci(Nr);function ma(n){return _i(n)?$r(Wn(n)):Nc(n)}function ug(n){return function(t){return n==null?i:_t(n,t)}}var ag=Cu(),og=Cu(true);function Hi(){return []}function Ni(){return  false}function fg(){return {}}function cg(){return ""}function hg(){return  true}function lg(n,t){if(n=R(n),n<1||n>kn)return [];var e=Nn,r=nn(n,Nn);t=x(t),n-=Nn;for(var s=Fr(r,t);++e<n;)t(e);return s}function pg(n){return O(n)?G(n,Wn):pn(n)?[n]:un(Wu(W(n)))}function dg(n){var t=++Ef;return W(n)+t}var gg=Qe(function(n,t){return n+t},0),vg=hi("ceil"),_g=Qe(function(n,t){return n/t},1),mg=hi("floor");function wg(n){return n&&n.length?Ge(n,fn,Qr):i}function Pg(n,t){return n&&n.length?Ge(n,x(t,2),Qr):i}function Ag(n){return xs(n,fn)}function Cg(n,t){return xs(n,x(t,2))}function Ig(n){return n&&n.length?Ge(n,fn,ni):i}function xg(n,t){return n&&n.length?Ge(n,x(t,2),ni):i}var Eg=Qe(function(n,t){return n*t},1),yg=hi("round"),Sg=Qe(function(n,t){return n-t},0);function Og(n){return n&&n.length?Wr(n,fn):0}function Rg(n,t){return n&&n.length?Wr(n,x(t,2)):0}return a.after=Vl,a.ary=Xu,a.assign=Wp,a.assignIn=fa,a.assignInWith=fr,a.assignWith=Fp,a.at=Mp,a.before=Qu,a.bind=Ii,a.bindAll=Kd,a.bindKey=Vu,a.castArray=fp,a.chain=Yu,a.chunk=mh,a.compact=wh,a.concat=Ph,a.cond=Yd,a.conforms=Zd,a.constant=bi,a.countBy=Ol,a.create=qp,a.curry=ku,a.curryRight=ju,a.debounce=na,a.defaults=Bp,a.defaultsDeep=Gp,a.defer=kl,a.delay=jl,a.difference=Ah,a.differenceBy=Ch,a.differenceWith=Ih,a.drop=xh,a.dropRight=Eh,a.dropRightWhile=yh,a.dropWhile=Sh,a.fill=Oh,a.filter=bl,a.flatMap=Dl,a.flatMapDeep=Hl,a.flatMapDepth=Nl,a.flatten=Bu,a.flattenDeep=Rh,a.flattenDepth=bh,a.flip=np,a.flow=Xd,a.flowRight=Qd,a.fromPairs=Th,a.functions=Qp,a.functionsIn=Vp,a.groupBy=$l,a.initial=Dh,a.intersection=Hh,a.intersectionBy=Nh,a.intersectionWith=$h,a.invert=jp,a.invertBy=nd,a.invokeMap=Wl,a.iteratee=Ti,a.keyBy=Fl,a.keys=V,a.keysIn=on,a.map=rr,a.mapKeys=ed,a.mapValues=rd,a.matches=Vd,a.matchesProperty=kd,a.memoize=sr,a.merge=id,a.mergeWith=ca,a.method=jd,a.methodOf=ng,a.mixin=Li,a.negate=ur,a.nthArg=eg,a.omit=sd,a.omitBy=ud,a.once=tp,a.orderBy=Ml,a.over=rg,a.overArgs=ep,a.overEvery=ig,a.overSome=sg,a.partial=xi,a.partialRight=ta,a.partition=ql,a.pick=ad,a.pickBy=ha,a.property=ma,a.propertyOf=ug,a.pull=Mh,a.pullAll=zu,a.pullAllBy=qh,a.pullAllWith=Bh,a.pullAt=Gh,a.range=ag,a.rangeRight=og,a.rearg=rp,a.reject=zl,a.remove=zh,a.rest=ip,a.reverse=Ai,a.sampleSize=Yl,a.set=fd,a.setWith=cd,a.shuffle=Zl,a.slice=Kh,a.sortBy=Ql,a.sortedUniq=kh,a.sortedUniqBy=jh,a.split=Dd,a.spread=sp,a.tail=nl,a.take=tl,a.takeRight=el,a.takeRightWhile=rl,a.takeWhile=il,a.tap=wl,a.throttle=up,a.thru=er,a.toArray=ua,a.toPairs=la,a.toPairsIn=pa,a.toPath=pg,a.toPlainObject=oa,a.transform=hd,a.unary=ap,a.union=sl,a.unionBy=ul,a.unionWith=al,a.uniq=ol,a.uniqBy=fl,a.uniqWith=cl,a.unset=ld,a.unzip=Ci,a.unzipWith=Ku,a.update=pd,a.updateWith=dd,a.values=Gt,a.valuesIn=gd,a.without=hl,a.words=va,a.wrap=op,a.xor=ll,a.xorBy=pl,a.xorWith=dl,a.zip=gl,a.zipObject=vl,a.zipObjectDeep=_l,a.zipWith=ml,a.entries=la,a.entriesIn=pa,a.extend=fa,a.extendWith=fr,Li(a,a),a.add=gg,a.attempt=_a,a.camelCase=wd,a.capitalize=da,a.ceil=vg,a.clamp=vd,a.clone=cp,a.cloneDeep=lp,a.cloneDeepWith=pp,a.cloneWith=hp,a.conformsTo=dp,a.deburr=ga,a.defaultTo=Jd,a.divide=_g,a.endsWith=Pd,a.eq=bn,a.escape=Ad,a.escapeRegExp=Cd,a.every=Rl,a.find=Tl,a.findIndex=Mu,a.findKey=zp,a.findLast=Ll,a.findLastIndex=qu,a.findLastKey=Kp,a.floor=mg,a.forEach=Zu,a.forEachRight=Ju,a.forIn=Yp,a.forInRight=Zp,a.forOwn=Jp,a.forOwnRight=Xp,a.get=Si,a.gt=gp,a.gte=vp,a.has=kp,a.hasIn=Oi,a.head=Gu,a.identity=fn,a.includes=Ul,a.indexOf=Lh,a.inRange=_d,a.invoke=td,a.isArguments=Pt,a.isArray=O,a.isArrayBuffer=_p,a.isArrayLike=an,a.isArrayLikeObject=Z,a.isBoolean=mp,a.isBuffer=at,a.isDate=wp,a.isElement=Pp,a.isEmpty=Ap,a.isEqual=Cp,a.isEqualWith=Ip,a.isError=Ei,a.isFinite=xp,a.isFunction=Jn,a.isInteger=ea,a.isLength=ar,a.isMap=ra,a.isMatch=Ep,a.isMatchWith=yp,a.isNaN=Sp,a.isNative=Op,a.isNil=bp,a.isNull=Rp,a.isNumber=ia,a.isObject=K,a.isObjectLike=Y,a.isPlainObject=pe,a.isRegExp=yi,a.isSafeInteger=Tp,a.isSet=sa,a.isString=or,a.isSymbol=pn,a.isTypedArray=Bt,a.isUndefined=Lp,a.isWeakMap=Dp,a.isWeakSet=Hp,a.join=Uh,a.kebabCase=Id,a.last=In,a.lastIndexOf=Wh,a.lowerCase=xd,a.lowerFirst=Ed,a.lt=Np,a.lte=$p,a.max=wg,a.maxBy=Pg,a.mean=Ag,a.meanBy=Cg,a.min=Ig,a.minBy=xg,a.stubArray=Hi,a.stubFalse=Ni,a.stubObject=fg,a.stubString=cg,a.stubTrue=hg,a.multiply=Eg,a.nth=Fh,a.noConflict=tg,a.noop=Di,a.now=ir,a.pad=yd,a.padEnd=Sd,a.padStart=Od,a.parseInt=Rd,a.random=md,a.reduce=Bl,a.reduceRight=Gl,a.repeat=bd,a.replace=Td,a.result=od,a.round=yg,a.runInContext=h,a.sample=Kl,a.size=Jl,a.snakeCase=Ld,a.some=Xl,a.sortedIndex=Yh,a.sortedIndexBy=Zh,a.sortedIndexOf=Jh,a.sortedLastIndex=Xh,a.sortedLastIndexBy=Qh,a.sortedLastIndexOf=Vh,a.startCase=Hd,a.startsWith=Nd,a.subtract=Sg,a.sum=Og,a.sumBy=Rg,a.template=$d,a.times=lg,a.toFinite=Xn,a.toInteger=R,a.toLength=aa,a.toLower=Ud,a.toNumber=xn,a.toSafeInteger=Up,a.toString=W,a.toUpper=Wd,a.trim=Fd,a.trimEnd=Md,a.trimStart=qd,a.truncate=Bd,a.unescape=Gd,a.uniqueId=dg,a.upperCase=zd,a.upperFirst=Ri,a.each=Zu,a.eachRight=Ju,a.first=Gu,Li(a,function(){var n={};return $n(a,function(t,e){F.call(a.prototype,e)||(n[e]=t);}),n}(),{chain:false}),a.VERSION=d,mn(["bind","bindKey","curry","curryRight","partial","partialRight"],function(n){a[n].placeholder=a;}),mn(["drop","take"],function(n,t){N.prototype[n]=function(e){e=e===i?1:Q(R(e),0);var r=this.__filtered__&&!t?new N(this):this.clone();return r.__filtered__?r.__takeCount__=nn(e,r.__takeCount__):r.__views__.push({size:nn(e,Nn),type:n+(r.__dir__<0?"Right":"")}),r},N.prototype[n+"Right"]=function(e){return this.reverse()[n](e).reverse()};}),mn(["filter","map","takeWhile"],function(n,t){var e=t+1,r=e==Bi||e==Wa;N.prototype[n]=function(s){var o=this.clone();return o.__iteratees__.push({iteratee:x(s,3),type:e}),o.__filtered__=o.__filtered__||r,o};}),mn(["head","last"],function(n,t){var e="take"+(t?"Right":"");N.prototype[n]=function(){return this[e](1).value()[0]};}),mn(["initial","tail"],function(n,t){var e="drop"+(t?"":"Right");N.prototype[n]=function(){return this.__filtered__?new N(this):this[e](1)};}),N.prototype.compact=function(){return this.filter(fn)},N.prototype.find=function(n){return this.filter(n).head()},N.prototype.findLast=function(n){return this.reverse().find(n)},N.prototype.invokeMap=T(function(n,t){return typeof n=="function"?new N(this):this.map(function(e){return ae(e,n,t)})}),N.prototype.reject=function(n){return this.filter(ur(x(n)))},N.prototype.slice=function(n,t){n=R(n);var e=this;return e.__filtered__&&(n>0||t<0)?new N(e):(n<0?e=e.takeRight(-n):n&&(e=e.drop(n)),t!==i&&(t=R(t),e=t<0?e.dropRight(-t):e.take(t-n)),e)},N.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},N.prototype.toArray=function(){return this.take(Nn)},$n(N.prototype,function(n,t){var e=/^(?:filter|find|map|reject)|While$/.test(t),r=/^(?:head|last)$/.test(t),s=a[r?"take"+(t=="last"?"Right":""):t],o=r||/^find/.test(t);s&&(a.prototype[t]=function(){var f=this.__wrapped__,c=r?[1]:arguments,l=f instanceof N,v=c[0],_=l||O(f),m=function(H){var $=s.apply(a,nt([H],c));return r&&P?$[0]:$};_&&e&&typeof v=="function"&&v.length!=1&&(l=_=false);var P=this.__chain__,I=!!this.__actions__.length,E=o&&!P,b=l&&!I;if(!o&&_){f=b?f:new N(this);var y=n.apply(f,c);return y.__actions__.push({func:er,args:[m],thisArg:i}),new Pn(y,P)}return E&&b?n.apply(this,c):(y=this.thru(m),E?r?y.value()[0]:y.value():y)});}),mn(["pop","push","shift","sort","splice","unshift"],function(n){var t=Oe[n],e=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",r=/^(?:pop|shift)$/.test(n);a.prototype[n]=function(){var s=arguments;if(r&&!this.__chain__){var o=this.value();return t.apply(O(o)?o:[],s)}return this[e](function(f){return t.apply(O(f)?f:[],s)})};}),$n(N.prototype,function(n,t){var e=a[t];if(e){var r=e.name+"";F.call(Ut,r)||(Ut[r]=[]),Ut[r].push({name:t,func:e});}}),Ut[Xe(i,ct).name]=[{name:"wrapper",func:i}],N.prototype.clone=Gf,N.prototype.reverse=zf,N.prototype.value=Kf,a.prototype.at=Pl,a.prototype.chain=Al,a.prototype.commit=Cl,a.prototype.next=Il,a.prototype.plant=El,a.prototype.reverse=yl,a.prototype.toJSON=a.prototype.valueOf=a.prototype.value=Sl,a.prototype.first=a.prototype.head,ne&&(a.prototype[ne]=xl),a},Ht=Cf();lt?((lt.exports=Ht)._=Ht,Tr._=Ht):k._=Ht;}).call(ge);})(Ui,Ui.exports);var Gg=Object.defineProperty,zg=Object.defineProperties,Kg=Object.getOwnPropertyDescriptors,Ea=Object.getOwnPropertySymbols,Yg=Object.prototype.hasOwnProperty,Zg=Object.prototype.propertyIsEnumerable,ya=(A,u,i)=>u in A?Gg(A,u,{enumerable:true,configurable:true,writable:true,value:i}):A[u]=i,cr=(A,u)=>{for(var i in u||(u={}))Yg.call(u,i)&&ya(A,i,u[i]);if(Ea)for(var i of Ea(u))Zg.call(u,i)&&ya(A,i,u[i]);return A},Jg=(A,u)=>zg(A,Kg(u));function ft(A,u,i){var d;const w=ve$2(A);return ((d=u.rpcMap)==null?void 0:d[w.reference])||`${Bg}?chainId=${w.namespace}:${w.reference}&projectId=${i}`}function Ct(A){return A.includes(":")?A.split(":")[1]:A}function Sa(A){return A.map(u=>`${u.split(":")[0]}:${u.split(":")[1]}`)}function Xg(A,u){const i=Object.keys(u.namespaces).filter(w=>w.includes(A));if(!i.length)return [];const d=[];return i.forEach(w=>{const L=u.namespaces[w].accounts;d.push(...L);}),d}function Oa(A={},u={}){const i=Ra(A),d=Ra(u);return Ui.exports.merge(i,d)}function Ra(A){var u,i,d,w;const L={};if(!B$4(A))return L;for(const[D,En]of Object.entries(A)){const zt=oe$1(D)?[D]:En.chains,pr=En.methods||[],It=En.events||[],Ln=En.rpcMap||{},Fn=en$2(D);L[Fn]=Jg(cr(cr({},L[Fn]),En),{chains:S$4(zt,(u=L[Fn])==null?void 0:u.chains),methods:S$4(pr,(i=L[Fn])==null?void 0:i.methods),events:S$4(It,(d=L[Fn])==null?void 0:d.events),rpcMap:cr(cr({},Ln),(w=L[Fn])==null?void 0:w.rpcMap)});}return L}function Qg(A){return A.includes(":")?A.split(":")[2]:A}function Vg(A){const u={};for(const[i,d]of Object.entries(A)){const w=d.methods||[],L=d.events||[],D=d.accounts||[],En=oe$1(i)?[i]:d.chains?d.chains:Sa(d.accounts);u[i]={chains:En,methods:w,events:L,accounts:D};}return u}function Wi(A){return typeof A=="number"?A:A.includes("0x")?parseInt(A,16):(A=A.includes(":")?A.split(":")[1]:A,isNaN(Number(A))?A:Number(A))}const ba={},z$3=A=>ba[A],Fi=(A,u)=>{ba[A]=u;};class kg{constructor(u){this.name="polkadot",this.namespace=u.namespace,this.events=z$3("events"),this.client=z$3("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){this.httpProviders[u]||this.setHttpProvider(u,i),this.chainId=u,this.events.emit(Vn.DEFAULT_CHAIN_CHANGED,`${this.name}:${u}`);}getAccounts(){const u=this.namespace.accounts;return u?u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2])||[]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var d;const w=Ct(i);u[w]=this.createHttpProvider(w,(d=this.namespace.rpcMap)==null?void 0:d[i]);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}setHttpProvider(u,i){const d=this.createHttpProvider(u,i);d&&(this.httpProviders[u]=d);}createHttpProvider(u,i){const d=i||ft(u,this.namespace,this.client.core.projectId);if(!d)throw new Error(`No RPC url provided for chainId: ${u}`);return new JsonRpcProvider(new f$3(d,z$3("disableProviderPing")))}}class jg{constructor(u){this.name="eip155",this.namespace=u.namespace,this.events=z$3("events"),this.client=z$3("client"),this.httpProviders=this.createHttpProviders(),this.chainId=parseInt(this.getDefaultChain());}async request(u){switch(u.request.method){case "eth_requestAccounts":return this.getAccounts();case "eth_accounts":return this.getAccounts();case "wallet_switchEthereumChain":return await this.handleSwitchChain(u);case "eth_chainId":return parseInt(this.getDefaultChain())}return this.namespace.methods.includes(u.request.method)?await this.client.request(u):this.getHttpProvider().request(u.request)}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}setDefaultChain(u,i){this.httpProviders[u]||this.setHttpProvider(parseInt(u),i),this.chainId=parseInt(u),this.events.emit(Vn.DEFAULT_CHAIN_CHANGED,`${this.name}:${u}`);}requestAccounts(){return this.getAccounts()}getDefaultChain(){if(this.chainId)return this.chainId.toString();if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}createHttpProvider(u,i){const d=i||ft(`${this.name}:${u}`,this.namespace,this.client.core.projectId);if(!d)throw new Error(`No RPC url provided for chainId: ${u}`);return new JsonRpcProvider(new f$3(d,z$3("disableProviderPing")))}setHttpProvider(u,i){const d=this.createHttpProvider(u,i);d&&(this.httpProviders[u]=d);}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var d;const w=parseInt(Ct(i));u[w]=this.createHttpProvider(w,(d=this.namespace.rpcMap)==null?void 0:d[i]);}),u}getAccounts(){const u=this.namespace.accounts;return u?[...new Set(u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2]))]:[]}getHttpProvider(){const u=this.chainId,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}async handleSwitchChain(u){var i,d;let w=u.request.params?(i=u.request.params[0])==null?void 0:i.chainId:"0x0";w=w.startsWith("0x")?w:`0x${w}`;const L=parseInt(w,16);if(this.isChainApproved(L))this.setDefaultChain(`${L}`);else if(this.namespace.methods.includes("wallet_switchEthereumChain"))await this.client.request({topic:u.topic,request:{method:u.request.method,params:[{chainId:w}]},chainId:(d=this.namespace.chains)==null?void 0:d[0]}),this.setDefaultChain(`${L}`);else throw new Error(`Failed to switch to chain 'eip155:${L}'. The chain is not approved or the wallet does not support 'wallet_switchEthereumChain' method.`);return null}isChainApproved(u){return this.namespace.chains.includes(`${this.name}:${u}`)}}class nv{constructor(u){this.name="solana",this.namespace=u.namespace,this.events=z$3("events"),this.client=z$3("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){this.httpProviders[u]||this.setHttpProvider(u,i),this.chainId=u,this.events.emit(Vn.DEFAULT_CHAIN_CHANGED,`${this.name}:${u}`);}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}getAccounts(){const u=this.namespace.accounts;return u?[...new Set(u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2]))]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var d;const w=Ct(i);u[w]=this.createHttpProvider(w,(d=this.namespace.rpcMap)==null?void 0:d[i]);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}setHttpProvider(u,i){const d=this.createHttpProvider(u,i);d&&(this.httpProviders[u]=d);}createHttpProvider(u,i){const d=i||ft(u,this.namespace,this.client.core.projectId);if(!d)throw new Error(`No RPC url provided for chainId: ${u}`);return new JsonRpcProvider(new f$3(d,z$3("disableProviderPing")))}}class tv{constructor(u){this.name="cosmos",this.namespace=u.namespace,this.events=z$3("events"),this.client=z$3("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){this.httpProviders[u]||this.setHttpProvider(u,i),this.chainId=u,this.events.emit(Vn.DEFAULT_CHAIN_CHANGED,`${this.name}:${this.chainId}`);}getAccounts(){const u=this.namespace.accounts;return u?[...new Set(u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2]))]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var d;const w=Ct(i);u[w]=this.createHttpProvider(w,(d=this.namespace.rpcMap)==null?void 0:d[i]);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}setHttpProvider(u,i){const d=this.createHttpProvider(u,i);d&&(this.httpProviders[u]=d);}createHttpProvider(u,i){const d=i||ft(u,this.namespace,this.client.core.projectId);if(!d)throw new Error(`No RPC url provided for chainId: ${u}`);return new JsonRpcProvider(new f$3(d,z$3("disableProviderPing")))}}class ev{constructor(u){this.name="cip34",this.namespace=u.namespace,this.events=z$3("events"),this.client=z$3("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){this.httpProviders[u]||this.setHttpProvider(u,i),this.chainId=u,this.events.emit(Vn.DEFAULT_CHAIN_CHANGED,`${this.name}:${this.chainId}`);}getAccounts(){const u=this.namespace.accounts;return u?[...new Set(u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2]))]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{const d=this.getCardanoRPCUrl(i),w=Ct(i);u[w]=this.createHttpProvider(w,d);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}getCardanoRPCUrl(u){const i=this.namespace.rpcMap;if(i)return i[u]}setHttpProvider(u,i){const d=this.createHttpProvider(u,i);d&&(this.httpProviders[u]=d);}createHttpProvider(u,i){const d=i||this.getCardanoRPCUrl(u);if(!d)throw new Error(`No RPC url provided for chainId: ${u}`);return new JsonRpcProvider(new f$3(d,z$3("disableProviderPing")))}}class rv{constructor(u){this.name="elrond",this.namespace=u.namespace,this.events=z$3("events"),this.client=z$3("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){this.httpProviders[u]||this.setHttpProvider(u,i),this.chainId=u,this.events.emit(Vn.DEFAULT_CHAIN_CHANGED,`${this.name}:${u}`);}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}getAccounts(){const u=this.namespace.accounts;return u?[...new Set(u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2]))]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var d;const w=Ct(i);u[w]=this.createHttpProvider(w,(d=this.namespace.rpcMap)==null?void 0:d[i]);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}setHttpProvider(u,i){const d=this.createHttpProvider(u,i);d&&(this.httpProviders[u]=d);}createHttpProvider(u,i){const d=i||ft(u,this.namespace,this.client.core.projectId);if(!d)throw new Error(`No RPC url provided for chainId: ${u}`);return new JsonRpcProvider(new f$3(d,z$3("disableProviderPing")))}}class iv{constructor(u){this.name="multiversx",this.namespace=u.namespace,this.events=z$3("events"),this.client=z$3("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){this.httpProviders[u]||this.setHttpProvider(u,i),this.chainId=u,this.events.emit(Vn.DEFAULT_CHAIN_CHANGED,`${this.name}:${u}`);}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}getAccounts(){const u=this.namespace.accounts;return u?[...new Set(u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2]))]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var d;const w=Ct(i);u[w]=this.createHttpProvider(w,(d=this.namespace.rpcMap)==null?void 0:d[i]);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}setHttpProvider(u,i){const d=this.createHttpProvider(u,i);d&&(this.httpProviders[u]=d);}createHttpProvider(u,i){const d=i||ft(u,this.namespace,this.client.core.projectId);if(!d)throw new Error(`No RPC url provided for chainId: ${u}`);return new JsonRpcProvider(new f$3(d,z$3("disableProviderPing")))}}class sv{constructor(u){this.name="near",this.namespace=u.namespace,this.events=z$3("events"),this.client=z$3("client"),this.chainId=this.getDefaultChain(),this.httpProviders=this.createHttpProviders();}updateNamespace(u){this.namespace=Object.assign(this.namespace,u);}requestAccounts(){return this.getAccounts()}getDefaultChain(){if(this.chainId)return this.chainId;if(this.namespace.defaultChain)return this.namespace.defaultChain;const u=this.namespace.chains[0];if(!u)throw new Error("ChainId not found");return u.split(":")[1]}request(u){return this.namespace.methods.includes(u.request.method)?this.client.request(u):this.getHttpProvider().request(u.request)}setDefaultChain(u,i){if(this.chainId=u,!this.httpProviders[u]){const d=i||ft(`${this.name}:${u}`,this.namespace);if(!d)throw new Error(`No RPC url provided for chainId: ${u}`);this.setHttpProvider(u,d);}this.events.emit(Vn.DEFAULT_CHAIN_CHANGED,`${this.name}:${this.chainId}`);}getAccounts(){const u=this.namespace.accounts;return u?u.filter(i=>i.split(":")[1]===this.chainId.toString()).map(i=>i.split(":")[2])||[]:[]}createHttpProviders(){const u={};return this.namespace.chains.forEach(i=>{var d;u[i]=this.createHttpProvider(i,(d=this.namespace.rpcMap)==null?void 0:d[i]);}),u}getHttpProvider(){const u=`${this.name}:${this.chainId}`,i=this.httpProviders[u];if(typeof i>"u")throw new Error(`JSON-RPC provider for ${u} not found`);return i}setHttpProvider(u,i){const d=this.createHttpProvider(u,i);d&&(this.httpProviders[u]=d);}createHttpProvider(u,i){const d=i||ft(u,this.namespace);return typeof d>"u"?void 0:new JsonRpcProvider(new f$3(d,z$3("disableProviderPing")))}}var uv=Object.defineProperty,av=Object.defineProperties,ov=Object.getOwnPropertyDescriptors,Ta=Object.getOwnPropertySymbols,fv=Object.prototype.hasOwnProperty,cv=Object.prototype.propertyIsEnumerable,La=(A,u,i)=>u in A?uv(A,u,{enumerable:true,configurable:true,writable:true,value:i}):A[u]=i,hr=(A,u)=>{for(var i in u||(u={}))fv.call(u,i)&&La(A,i,u[i]);if(Ta)for(var i of Ta(u))cv.call(u,i)&&La(A,i,u[i]);return A},Mi=(A,u)=>av(A,ov(u));class lr{constructor(u){this.events=new require$$1$1,this.rpcProviders={},this.shouldAbortPairingAttempt=false,this.maxPairingAttempts=10,this.disableProviderPing=false,this.providerOpts=u,this.logger=typeof u?.logger<"u"&&typeof u?.logger!="string"?u.logger:Hg(k$3({level:u?.logger||Ia})),this.disableProviderPing=u?.disableProviderPing||false;}static async init(u){const i=new lr(u);return await i.initialize(),i}async request(u,i,d){const[w,L]=this.validateChain(i);if(!this.session)throw new Error("Please call connect() before request()");return await this.getProvider(w).request({request:hr({},u),chainId:`${w}:${L}`,topic:this.session.topic,expiry:d})}sendAsync(u,i,d,w){const L=new Date().getTime();this.request(u,d,w).then(D=>i(null,formatJsonRpcResult(L,D))).catch(D=>i(D,void 0));}async enable(){if(!this.client)throw new Error("Sign Client not initialized");return this.session||await this.connect({namespaces:this.namespaces,optionalNamespaces:this.optionalNamespaces,sessionProperties:this.sessionProperties}),await this.requestAccounts()}async disconnect(){var u;if(!this.session)throw new Error("Please call connect() before enable()");await this.client.disconnect({topic:(u=this.session)==null?void 0:u.topic,reason:U$2("USER_DISCONNECTED")}),await this.cleanup();}async connect(u){if(!this.client)throw new Error("Sign Client not initialized");if(this.setNamespaces(u),await this.cleanupPendingPairings(),!u.skipPairing)return await this.pair(u.pairingTopic)}on(u,i){this.events.on(u,i);}once(u,i){this.events.once(u,i);}removeListener(u,i){this.events.removeListener(u,i);}off(u,i){this.events.off(u,i);}get isWalletConnect(){return  true}async pair(u){this.shouldAbortPairingAttempt=false;let i=0;do{if(this.shouldAbortPairingAttempt)throw new Error("Pairing aborted");if(i>=this.maxPairingAttempts)throw new Error("Max auto pairing attempts reached");const{uri:d,approval:w}=await this.client.connect({pairingTopic:u,requiredNamespaces:this.namespaces,optionalNamespaces:this.optionalNamespaces,sessionProperties:this.sessionProperties});d&&(this.uri=d,this.events.emit("display_uri",d)),await w().then(L=>{this.session=L;const D=Vg(L.namespaces);this.namespaces=Oa(this.namespaces,D),this.persist("namespaces",this.namespaces);}).catch(L=>{if(L.message!==ae$1)throw L;i++;});}while(!this.session);return this.onConnect(),this.session}setDefaultChain(u,i){try{if(!this.session)return;const[d,w]=this.validateChain(u);this.getProvider(d).setDefaultChain(w,i);}catch(d){if(!/Please call connect/.test(d.message))throw d}}async cleanupPendingPairings(u={}){this.logger.info("Cleaning up inactive pairings...");const i=this.client.pairing.getAll();if(k$5(i)){for(const d of i)u.deletePairings?this.client.core.expirer.set(d.topic,0):await this.client.core.relayer.subscriber.unsubscribe(d.topic);this.logger.info(`Inactive pairings cleared: ${i.length}`);}}abortPairingAttempt(){this.shouldAbortPairingAttempt=true;}async checkStorage(){if(this.namespaces=await this.getFromStore("namespaces"),this.optionalNamespaces=await this.getFromStore("optionalNamespaces")||{},this.client.session.length){const u=this.client.session.keys.length-1;this.session=this.client.session.get(this.client.session.keys[u]),this.createProviders();}}async initialize(){this.logger.trace("Initialized"),await this.createClient(),await this.checkStorage(),this.registerEventListeners();}async createClient(){this.client=this.providerOpts.client||await Q$2.init({logger:this.providerOpts.logger||Ia,relayUrl:this.providerOpts.relayUrl||Fg,projectId:this.providerOpts.projectId,metadata:this.providerOpts.metadata,storageOptions:this.providerOpts.storageOptions,storage:this.providerOpts.storage,name:this.providerOpts.name}),this.logger.trace("SignClient Initialized");}createProviders(){if(!this.client)throw new Error("Sign Client not initialized");if(!this.session)throw new Error("Session not initialized. Please call connect() before enable()");const u=[...new Set(Object.keys(this.session.namespaces).map(i=>en$2(i)))];Fi("client",this.client),Fi("events",this.events),Fi("disableProviderPing",this.disableProviderPing),u.forEach(i=>{if(!this.session)return;const d=Xg(i,this.session),w=Sa(d),L=Oa(this.namespaces,this.optionalNamespaces),D=Mi(hr({},L[i]),{accounts:d,chains:w});switch(i){case "eip155":this.rpcProviders[i]=new jg({namespace:D});break;case "solana":this.rpcProviders[i]=new nv({namespace:D});break;case "cosmos":this.rpcProviders[i]=new tv({namespace:D});break;case "polkadot":this.rpcProviders[i]=new kg({namespace:D});break;case "cip34":this.rpcProviders[i]=new ev({namespace:D});break;case "elrond":this.rpcProviders[i]=new rv({namespace:D});break;case "multiversx":this.rpcProviders[i]=new iv({namespace:D});break;case "near":this.rpcProviders[i]=new sv({namespace:D});break}});}registerEventListeners(){if(typeof this.client>"u")throw new Error("Sign Client is not initialized");this.client.on("session_ping",u=>{this.events.emit("session_ping",u);}),this.client.on("session_event",u=>{const{params:i}=u,{event:d}=i;if(d.name==="accountsChanged"){const w=d.data;w&&k$5(w)&&this.events.emit("accountsChanged",w.map(Qg));}else if(d.name==="chainChanged"){const w=i.chainId,L=i.event.data,D=en$2(w),En=Wi(w)!==Wi(L)?`${D}:${Wi(L)}`:w;this.onChainChanged(En);}else this.events.emit(d.name,d.data);this.events.emit("session_event",u);}),this.client.on("session_update",({topic:u,params:i})=>{var d;const{namespaces:w}=i,L=(d=this.client)==null?void 0:d.session.get(u);this.session=Mi(hr({},L),{namespaces:w}),this.onSessionUpdate(),this.events.emit("session_update",{topic:u,params:i});}),this.client.on("session_delete",async u=>{await this.cleanup(),this.events.emit("session_delete",u),this.events.emit("disconnect",Mi(hr({},U$2("USER_DISCONNECTED")),{data:u.topic}));}),this.on(Vn.DEFAULT_CHAIN_CHANGED,u=>{this.onChainChanged(u,true);});}getProvider(u){if(!this.rpcProviders[u])throw new Error(`Provider not found: ${u}`);return this.rpcProviders[u]}onSessionUpdate(){Object.keys(this.rpcProviders).forEach(u=>{var i;this.getProvider(u).updateNamespace((i=this.session)==null?void 0:i.namespaces[u]);});}setNamespaces(u){const{namespaces:i,optionalNamespaces:d,sessionProperties:w}=u;i&&Object.keys(i).length&&(this.namespaces=i),d&&Object.keys(d).length&&(this.optionalNamespaces=d),this.sessionProperties=w,this.persist("namespaces",i),this.persist("optionalNamespaces",d);}validateChain(u){const[i,d]=u?.split(":")||["",""];if(!this.namespaces||!Object.keys(this.namespaces).length)return [i,d];if(i&&!Object.keys(this.namespaces||{}).map(D=>en$2(D)).includes(i))throw new Error(`Namespace '${i}' is not configured. Please call connect() first with namespace config.`);if(i&&d)return [i,d];const w=en$2(Object.keys(this.namespaces)[0]),L=this.rpcProviders[w].getDefaultChain();return [w,L]}async requestAccounts(){const[u]=this.validateChain();return await this.getProvider(u).requestAccounts()}onChainChanged(u,i=false){if(!this.namespaces)return;const[d,w]=this.validateChain(u);w&&(i||this.getProvider(d).setDefaultChain(w),this.namespaces[d]?this.namespaces[d].defaultChain=w:this.namespaces[`${d}:${w}`]?this.namespaces[`${d}:${w}`].defaultChain=w:this.namespaces[`${d}:${w}`]={defaultChain:w},this.persist("namespaces",this.namespaces),this.events.emit("chainChanged",w));}onConnect(){this.createProviders(),this.events.emit("connect",{session:this.session});}async cleanup(){this.session=void 0,this.namespaces=void 0,this.optionalNamespaces=void 0,this.sessionProperties=void 0,this.persist("namespaces",void 0),this.persist("optionalNamespaces",void 0),this.persist("sessionProperties",void 0),await this.cleanupPendingPairings({deletePairings:true});}persist(u,i){this.client.core.storage.setItem(`${xa}/${u}`,i);}async getFromStore(u){return await this.client.core.storage.getItem(`${xa}/${u}`)}}const hv=lr;

const P$2="wc",S$1="ethereum_provider",$$2=`${P$2}@2:${S$1}:`,j$2="https://rpc.walletconnect.com/v1/",u$2=["eth_sendTransaction","personal_sign"],E$1=["eth_accounts","eth_requestAccounts","eth_sendRawTransaction","eth_sign","eth_signTransaction","eth_signTypedData","eth_signTypedData_v3","eth_signTypedData_v4","eth_sendTransaction","personal_sign","wallet_switchEthereumChain","wallet_addEthereumChain","wallet_getPermissions","wallet_requestPermissions","wallet_registerOnboarding","wallet_watchAsset","wallet_scanQRCode"],m$2=["chainChanged","accountsChanged"],_$1=["chainChanged","accountsChanged","message","disconnect","connect"];var N$1=Object.defineProperty,q$2=Object.defineProperties,D$2=Object.getOwnPropertyDescriptors,y$2=Object.getOwnPropertySymbols,U=Object.prototype.hasOwnProperty,Q$1=Object.prototype.propertyIsEnumerable,O$1=(a,t,s)=>t in a?N$1(a,t,{enumerable:true,configurable:true,writable:true,value:s}):a[t]=s,p$2=(a,t)=>{for(var s in t||(t={}))U.call(t,s)&&O$1(a,s,t[s]);if(y$2)for(var s of y$2(t))Q$1.call(t,s)&&O$1(a,s,t[s]);return a},M$2=(a,t)=>q$2(a,D$2(t));function g$1(a){return Number(a[0].split(":")[1])}function f$2(a){return `0x${a.toString(16)}`}function L$1(a){const{chains:t,optionalChains:s,methods:i,optionalMethods:n,events:e,optionalEvents:h,rpcMap:c}=a;if(!k$5(t))throw new Error("Invalid chains");const o={chains:t,methods:i||u$2,events:e||m$2,rpcMap:p$2({},t.length?{[g$1(t)]:c[g$1(t)]}:{})},r=e?.filter(l=>!m$2.includes(l)),d=i?.filter(l=>!u$2.includes(l));if(!s&&!h&&!n&&!(r!=null&&r.length)&&!(d!=null&&d.length))return {required:t.length?o:void 0};const C=r?.length&&d?.length||!s,I={chains:[...new Set(C?o.chains.concat(s||[]):s)],methods:[...new Set(o.methods.concat(n!=null&&n.length?n:E$1))],events:[...new Set(o.events.concat(h!=null&&h.length?h:_$1))],rpcMap:c};return {required:t.length?o:void 0,optional:s.length?I:void 0}}let v$2 = class v{constructor(){this.events=new EventEmitter$2,this.namespace="eip155",this.accounts=[],this.chainId=1,this.STORAGE_KEY=$$2,this.on=(t,s)=>(this.events.on(t,s),this),this.once=(t,s)=>(this.events.once(t,s),this),this.removeListener=(t,s)=>(this.events.removeListener(t,s),this),this.off=(t,s)=>(this.events.off(t,s),this),this.parseAccount=t=>this.isCompatibleChainId(t)?this.parseAccountId(t).address:t,this.signer={},this.rpc={};}static async init(t){const s=new v;return await s.initialize(t),s}async request(t,s){return await this.signer.request(t,this.formatChainId(this.chainId),s)}sendAsync(t,s,i){this.signer.sendAsync(t,s,this.formatChainId(this.chainId),i);}get connected(){return this.signer.client?this.signer.client.core.relayer.connected:false}get connecting(){return this.signer.client?this.signer.client.core.relayer.connecting:false}async enable(){return this.session||await this.connect(),await this.request({method:"eth_requestAccounts"})}async connect(t){if(!this.signer.client)throw new Error("Provider not initialized. Call init() first");this.loadConnectOpts(t);const{required:s,optional:i}=L$1(this.rpc);try{const n=await new Promise(async(h,c)=>{var o;this.rpc.showQrModal&&((o=this.modal)==null||o.subscribeModal(r=>{!r.open&&!this.signer.session&&(this.signer.abortPairingAttempt(),c(new Error("Connection request reset. Please try again.")));})),await this.signer.connect(M$2(p$2({namespaces:p$2({},s&&{[this.namespace]:s})},i&&{optionalNamespaces:{[this.namespace]:i}}),{pairingTopic:t?.pairingTopic})).then(r=>{h(r);}).catch(r=>{c(new Error(r.message));});});if(!n)return;const e=Un$1(n.namespaces,[this.namespace]);this.setChainIds(this.rpc.chains.length?this.rpc.chains:e),this.setAccounts(e),this.events.emit("connect",{chainId:f$2(this.chainId)});}catch(n){throw this.signer.logger.error(n),n}finally{this.modal&&this.modal.closeModal();}}async disconnect(){this.session&&await this.signer.disconnect(),this.reset();}get isWalletConnect(){return  true}get session(){return this.signer.session}registerEventListeners(){this.signer.on("session_event",t=>{const{params:s}=t,{event:i}=s;i.name==="accountsChanged"?(this.accounts=this.parseAccounts(i.data),this.events.emit("accountsChanged",this.accounts)):i.name==="chainChanged"?this.setChainId(this.formatChainId(i.data)):this.events.emit(i.name,i.data),this.events.emit("session_event",t);}),this.signer.on("chainChanged",t=>{const s=parseInt(t);this.chainId=s,this.events.emit("chainChanged",f$2(this.chainId)),this.persist();}),this.signer.on("session_update",t=>{this.events.emit("session_update",t);}),this.signer.on("session_delete",t=>{this.reset(),this.events.emit("session_delete",t),this.events.emit("disconnect",M$2(p$2({},U$2("USER_DISCONNECTED")),{data:t.topic,name:"USER_DISCONNECTED"}));}),this.signer.on("display_uri",t=>{var s,i;this.rpc.showQrModal&&((s=this.modal)==null||s.closeModal(),(i=this.modal)==null||i.openModal({uri:t})),this.events.emit("display_uri",t);});}switchEthereumChain(t){this.request({method:"wallet_switchEthereumChain",params:[{chainId:t.toString(16)}]});}isCompatibleChainId(t){return typeof t=="string"?t.startsWith(`${this.namespace}:`):false}formatChainId(t){return `${this.namespace}:${t}`}parseChainId(t){return Number(t.split(":")[1])}setChainIds(t){const s=t.filter(i=>this.isCompatibleChainId(i)).map(i=>this.parseChainId(i));s.length&&(this.chainId=s[0],this.events.emit("chainChanged",f$2(this.chainId)),this.persist());}setChainId(t){if(this.isCompatibleChainId(t)){const s=this.parseChainId(t);this.chainId=s,this.switchEthereumChain(s);}}parseAccountId(t){const[s,i,n]=t.split(":");return {chainId:`${s}:${i}`,address:n}}setAccounts(t){this.accounts=t.filter(s=>this.parseChainId(this.parseAccountId(s).chainId)===this.chainId).map(s=>this.parseAccountId(s).address),this.events.emit("accountsChanged",this.accounts);}getRpcConfig(t){var s,i;const n=(s=t?.chains)!=null?s:[],e=(i=t?.optionalChains)!=null?i:[],h=n.concat(e);if(!h.length)throw new Error("No chains specified in either `chains` or `optionalChains`");const c=n.length?t?.methods||u$2:[],o=n.length?t?.events||m$2:[],r=t?.optionalMethods||[],d=t?.optionalEvents||[],C=t?.rpcMap||this.buildRpcMap(h,t.projectId),I=t?.qrModalOptions||void 0;return {chains:n?.map(l=>this.formatChainId(l)),optionalChains:e.map(l=>this.formatChainId(l)),methods:c,events:o,optionalMethods:r,optionalEvents:d,rpcMap:C,showQrModal:!!(t!=null&&t.showQrModal),qrModalOptions:I,projectId:t.projectId,metadata:t.metadata}}buildRpcMap(t,s){const i={};return t.forEach(n=>{i[n]=this.getRpcUrl(n,s);}),i}async initialize(t){if(this.rpc=this.getRpcConfig(t),this.chainId=this.rpc.chains.length?g$1(this.rpc.chains):g$1(this.rpc.optionalChains),this.signer=await hv.init({projectId:this.rpc.projectId,metadata:this.rpc.metadata,disableProviderPing:t.disableProviderPing,relayUrl:t.relayUrl,storageOptions:t.storageOptions}),this.registerEventListeners(),await this.loadPersistedSession(),this.rpc.showQrModal){let s;try{const{WalletConnectModal:i}=await import('./index-DANKTBG1.js').then(function (n) { return n.i; });s=i;}catch{throw new Error("To use QR modal, please install @walletconnect/modal package")}if(s)try{this.modal=new s(p$2({projectId:this.rpc.projectId},this.rpc.qrModalOptions));}catch(i){throw this.signer.logger.error(i),new Error("Could not generate WalletConnectModal Instance")}}}loadConnectOpts(t){if(!t)return;const{chains:s,optionalChains:i,rpcMap:n}=t;s&&k$5(s)&&(this.rpc.chains=s.map(e=>this.formatChainId(e)),s.forEach(e=>{this.rpc.rpcMap[e]=n?.[e]||this.getRpcUrl(e);})),i&&k$5(i)&&(this.rpc.optionalChains=[],this.rpc.optionalChains=i?.map(e=>this.formatChainId(e)),i.forEach(e=>{this.rpc.rpcMap[e]=n?.[e]||this.getRpcUrl(e);}));}getRpcUrl(t,s){var i;return ((i=this.rpc.rpcMap)==null?void 0:i[t])||`${j$2}?chainId=eip155:${t}&projectId=${s||this.rpc.projectId}`}async loadPersistedSession(){if(!this.session)return;const t=await this.signer.client.core.storage.getItem(`${this.STORAGE_KEY}/chainId`),s=this.session.namespaces[`${this.namespace}:${t}`]?this.session.namespaces[`${this.namespace}:${t}`]:this.session.namespaces[this.namespace];this.setChainIds(t?[this.formatChainId(t)]:s?.accounts),this.setAccounts(s?.accounts);}reset(){this.chainId=1,this.accounts=[];}persist(){this.session&&this.signer.client.core.storage.setItem(`${this.STORAGE_KEY}/chainId`,this.chainId);}parseAccounts(t){return typeof t=="string"||t instanceof String?[this.parseAccount(t)]:t.map(s=>this.parseAccount(s))}};

const activeAccountKey = (walletName) => `dynamic-wc2-active-account-${walletName}`;
const sessionTopicKey = (walletName) => `dynamic-wc2-session-topic-${walletName}`;
const currentChainKey = (walletName) => `dynamic-wc2-current-chain-${walletName}`;
const ee$1 = new EventEmitter$1();
class WalletConnect extends EthereumWalletConnector {
    supportsNetworkSwitching() {
        return true;
    }
    constructor(opts) {
        super(opts);
        this.isInitialized = false;
        this.canConnectViaQrCode = true;
        this.isWalletConnect = true;
        this.preferredChains = [];
        this.sessionEventHandler = () => { };
        this.sessionDeleteHandler = () => { };
        this.name = opts.walletName;
        this.projectId = opts.projectId;
        this.deepLinkPreference = opts.deepLinkPreference || 'native';
        this.preferredChains = opts.walletConnectPreferredChains || [];
        const lsCurrentChain = localStorage.getItem(this.currentChainKey);
        this.currentChainId = lsCurrentChain
            ? parseIntSafe(lsCurrentChain)
            : undefined;
    }
    /**
     * This method is used to get the address of the active account.
     * It will re-initialize the provider if the provider is not found.
     * @param opts
     * @returns
     */
    getAddress(opts) {
        return __awaiter$8(this, void 0, void 0, function* () {
            var _a, _b;
            const activeAccount = this.getActiveAccount();
            if (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.address) {
                return activeAccount.address;
            }
            if (!WalletConnect.provider || !((_a = WalletConnect.provider) === null || _a === void 0 ? void 0 : _a.signer.uri)) {
                logger$8.debug('No WC2 provider found, re-initializing...');
                yield this.endSession();
                yield this.init();
                // sleep 1 s to wait for connect call to finish
                // the connect call isn't await-ed because it only resolves once
                // the connection is established, but we need to wait for it to
                // finish setting up the connection URI and making it available
                // on the provider
                yield sleep(1000);
                if (!WalletConnect.provider || !((_b = WalletConnect.provider) === null || _b === void 0 ? void 0 : _b.signer.uri)) {
                    logger$8.debug('No WC2 provider was found after init attempt, aborting');
                    throw new DynamicError('No provider found');
                }
                else {
                    logger$8.debug('provider was successfully initialized, continuing');
                }
            }
            // Set Deep links
            performPlatformSpecificConnectionMethod(WalletConnect.provider.signer.uri, this.metadata.deepLinks, {
                onDesktopUri: opts === null || opts === void 0 ? void 0 : opts.onDesktopUri,
                onDisplayUri: opts === null || opts === void 0 ? void 0 : opts.onDisplayUri,
            }, this.deepLinkPreference);
            return new Promise((resolve, reject) => {
                if (!WalletConnect.provider) {
                    reject(new DynamicError('No provider found'));
                    return;
                }
                const onFail = () => {
                    logger$8.debug('onConnection faile re-initializing provider');
                    const error = new DynamicError('Connection rejected. Please try again.');
                    error.code = 'connection_rejected';
                    if (WalletConnect.provider) {
                        WalletConnect.provider.signer.uri = undefined;
                        // this is needed for mobile to work when using universal links.
                        // if the user cancels the connection, we need to re-initialize the provider
                        // so that the async work is done ahead of time, before the user tries to connect again,
                        // otherwise they will trigger the iOS bug where they are redirected to the app store
                        this.init();
                        logger$8.debug('provider was re-initialized in onConnection fail, continuing');
                    }
                    reject(error);
                    // We must clean up the onConnect and onFail listeners
                    // whenever the connection attempt either succeeds or fails
                    cleanupListeners();
                };
                const onConnect = () => {
                    var _a;
                    logger$8.debug('onConnection success, setting session');
                    const session = (_a = WalletConnect.provider) === null || _a === void 0 ? void 0 : _a.session;
                    if (!session) {
                        logger$8.debug('onConnection success, but no session found rejecting');
                        reject(new DynamicError('No session found'));
                        return;
                    }
                    this.setSession(session);
                    this.setWCActiveAccount(session.namespaces.eip155.accounts[0].split(':')[2]);
                    this.getNetwork().then((chainId) => {
                        var _a, _b;
                        logger$8.debug('onConnection success, resolving, chainId:', chainId);
                        this.currentChainId = chainId;
                        logger$8.debug('onConnection success, resolving, activeAccountAddress:', (_a = this.getActiveAccount()) === null || _a === void 0 ? void 0 : _a.address);
                        resolve((_b = this.getActiveAccount()) === null || _b === void 0 ? void 0 : _b.address);
                    });
                    // We must clean up the onConnect and onFail listeners
                    // whenever the connection attempt either succeeds or fails
                    cleanupListeners();
                };
                const cleanupListeners = () => {
                    var _a;
                    ee$1.off('walletconnect_connection_failed', onFail);
                    (_a = WalletConnect.provider) === null || _a === void 0 ? void 0 : _a.off('connect', onConnect);
                };
                ee$1.on('walletconnect_connection_failed', onFail);
                WalletConnect.provider.on('connect', onConnect);
            });
        });
    }
    init() {
        return __awaiter$8(this, void 0, void 0, function* () {
            logger$8.debug('init was called', this.name);
            yield this.initProvider();
            yield this.initConnection();
            this.isInitialized = true;
        });
    }
    // We need to add a gate to this method since we will be calling it asynchronously
    // from different places (such as setShowAuthFlow), which means there's a chance for
    // a race condition to happen where createInitProviderPromise is called multiple times
    initProvider() {
        return __awaiter$8(this, void 0, void 0, function* () {
            logger$8.debug('initProvider was called', this.name);
            const { provider } = WalletConnect;
            if (!provider) {
                logger$8.debug('provider is undefined', this.name);
                if (this.initializePromise === undefined) {
                    this.initializePromise = this.createInitProviderPromise();
                }
                yield this.initializePromise;
            }
        });
    }
    createInitProviderPromise() {
        return __awaiter$8(this, void 0, void 0, function* () {
            WalletConnect.provider = yield this.createProvider();
            this.teardownEventListeners();
            this.setupEventListeners();
        });
    }
    initConnection() {
        return __awaiter$8(this, void 0, void 0, function* () {
            logger$8.debug('initConnection was called', this.name);
            const { provider } = WalletConnect;
            if (!provider) {
                throw new DynamicError('No provider found (init connection)');
            }
            // this means there is already a connection in progress, so don't call connect again
            if (provider === null || provider === void 0 ? void 0 : provider.signer.uri) {
                return;
            }
            provider.connect().catch((e) => {
                logger$8.error(e);
                ee$1.emit('walletconnect_connection_failed', e);
            });
        });
    }
    createProvider() {
        return __awaiter$8(this, void 0, void 0, function* () {
            logger$8.debug('createProvider was called', this.name);
            return v$2.init({
                events: ['chainChanged', 'accountsChanged'],
                methods: [],
                optionalChains: this.getMappedChainsByPreferredOrder(),
                optionalMethods: [
                    'eth_chainId',
                    'eth_signTypedData',
                    'eth_signTransaction',
                    'eth_sign',
                    'personal_sign',
                    'eth_sendTransaction',
                    'eth_signTypedData_v4',
                    'wallet_switchEthereumChain',
                    'wallet_addEthereumChain',
                ],
                projectId: this.projectId,
                rpcMap: this.evmNetworkRpcMap(),
                showQrModal: false,
            });
        });
    }
    refreshSession() {
        return __awaiter$8(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            logger$8.debug('refreshSession was called', this.name);
            if ((_b = (_a = WalletConnect.provider) === null || _a === void 0 ? void 0 : _a.session) === null || _b === void 0 ? void 0 : _b.topic) {
                if (localStorage.getItem(this.sessionTopicKey) ===
                    ((_d = (_c = WalletConnect.provider) === null || _c === void 0 ? void 0 : _c.session) === null || _d === void 0 ? void 0 : _d.topic)) {
                    this.session = WalletConnect.provider.session;
                    this.setActiveAccount(((_e = localStorage.getItem(this.activeAccountKey)) !== null && _e !== void 0 ? _e : undefined));
                }
            }
            const walletClient = this.getWalletClient();
            const walletChainId = yield walletClient.getChainId();
            logger$8.debug('checking selected chain in refreshSession', this.name, walletChainId, this.currentChainId);
            if (this.currentChainId && this.currentChainId !== walletChainId) {
                logger$8.debug('switching to selected chain', this.currentChainId);
                yield walletClient.switchChain({ id: this.currentChainId });
            }
        });
    }
    getMappedChainsByPreferredOrder() {
        const allChains = this.evmNetworks.map((network) => `eip155:${network.chainId}`);
        const reorderedChains = this.preferredChains.filter((chain) => allChains.includes(chain));
        const remainingChains = allChains.filter((chain) => !this.preferredChains.includes(chain));
        return [...reorderedChains, ...remainingChains].map((chain) => Number(chain.split(':')[1]));
    }
    getWalletClient(chainId) {
        logger$8.debug('getWalletClient was called', this.name);
        const walletConnect = WalletConnect.provider || this.createProvider();
        const walletClient = createWalletClient({
            account: this.getActiveAccount(),
            chain: chainsMap[chainId !== null && chainId !== void 0 ? chainId : String(this.currentChainId)],
            transport: custom$1({
                request: (args) => __awaiter$8(this, void 0, void 0, function* () {
                    const provider = yield walletConnect;
                    return provider.request(args);
                }),
            }),
        });
        return walletClient;
    }
    get currentChainId() {
        return this._currentChainId;
    }
    set currentChainId(value) {
        this._currentChainId = value;
        if (value) {
            localStorage.setItem(this.currentChainKey, value.toString());
        }
        else {
            localStorage.removeItem(this.currentChainKey);
        }
    }
    get sessionTopicKey() {
        return sessionTopicKey(this.key);
    }
    get activeAccountKey() {
        return activeAccountKey(this.key);
    }
    get currentChainKey() {
        return currentChainKey(this.key);
    }
    setupEventListeners() {
        if (!WalletConnect.provider) {
            return;
        }
        this.sessionEventHandler = ({ params, }) => {
            logger$8.debug('session_event was called', { params });
            if (!params || !params.event) {
                logger$8.debug('session_event was called without params or params.event');
                return;
            }
            const { name, data } = params.event;
            if (name === 'chainChanged') {
                const chainId = parseIntSafe(data);
                if (chainId === this.currentChainId) {
                    logger$8.debug(`ignoring chainChanged event with same chain id as current chain id: ${chainId}`);
                    return;
                }
                if (chainId === undefined) {
                    logger$8.debug(`received unexpected data for chainChanged: ${data} with type ${typeof data}}`);
                    return;
                }
                this.currentChainId = chainId;
                this.emit('chainChange', { chain: String(chainId) });
                // When a user switches network from their wallet, we need the provider to change network
                // such that any future calls to `getNetwork` will return the correct network
                this.switchNetwork({ networkChainId: chainId });
            }
            else if (name === 'accountsChanged') {
                if (!Array.isArray(data)) {
                    logger$8.debug(`received unexpected data for accountsChanged: ${data} with type ${typeof data}}`);
                    return;
                }
                // eslint-disable-next-line prefer-destructuring
                const account = data[0].split(':')[2];
                this.setWCActiveAccount(account);
            }
        };
        WalletConnect.provider.on('session_event', this.sessionEventHandler);
        this.sessionDeleteHandler = () => __awaiter$8(this, void 0, void 0, function* () {
            this.endSession();
            this.emit('disconnect');
        });
        WalletConnect.provider.on('session_delete', this.sessionDeleteHandler);
    }
    teardownEventListeners() {
        if (!WalletConnect.provider) {
            return;
        }
        WalletConnect.provider.off('session_event', this.sessionEventHandler);
        WalletConnect.provider.off('session_delete', this.sessionDeleteHandler);
    }
    /**
     * WalletConnect V2 will fail to send the sign message request if the chainId
     * is not the same as the one in the session. This method will wait for the
     * chainId to change and then retry the sign message request.
     *
     * Otherwise it will just return the result of the sign message request.
     *
     * @param signMessageFn - Function to sign message with provider
     * @param messageToSign - Message to sign
     * @returns
     */
    waitForSignMessage(signMessageFn, messageToSign) {
        return __awaiter$8(this, void 0, void 0, function* () {
            const raceConditionPromise = new Promise((resolve, reject) => {
                // Create listener for chain change event
                this.on('chainChange', () => resolve({ success: false }));
                signMessageFn(messageToSign)
                    .then((result) => resolve({ signedMessage: result, success: true }))
                    .catch(reject);
            });
            const signedMessageResult = yield raceConditionPromise;
            if (signedMessageResult.success === false) {
                return signMessageFn(messageToSign);
            }
            return signedMessageResult.signedMessage;
        });
    }
    getDeepLink() {
        var _a;
        if (!this.session) {
            return;
        }
        const deepLink = getDeepLink({
            deepLinks: this.metadata.deepLinks,
            mode: 'regular',
            preference: this.deepLinkPreference,
            uri: (_a = WalletConnect.provider) === null || _a === void 0 ? void 0 : _a.signer.uri,
        });
        if (!deepLink) {
            return;
        }
        // we need to include the session topic here because it helps the wallet
        // auto redirect back to the dapp after signing
        return `${deepLink}?sessionTopic=${this.session.topic}`;
    }
    signMessage(messageToSign) {
        return __awaiter$8(this, void 0, void 0, function* () {
            if (!this.session) {
                throw new DynamicError('no session');
            }
            const deepLink = this.getDeepLink();
            if (isMobile() && deepLink) {
                window.location.href = deepLink;
            }
            const signMessageFn = (messageToSign) => __awaiter$8(this, void 0, void 0, function* () {
                const activeAccount = this.getActiveAccount();
                if (!activeAccount) {
                    return;
                }
                const walletClient = yield this.getWalletClient();
                return walletClient.signMessage({
                    account: activeAccount,
                    message: messageToSign,
                });
            });
            const response = yield this.waitForSignMessage(signMessageFn, messageToSign);
            return response;
        });
    }
    clearActiveAccount() {
        localStorage.removeItem(this.activeAccountKey);
        this.setActiveAccount(undefined);
    }
    clearSession() {
        localStorage.removeItem(this.sessionTopicKey);
        this.session = undefined;
    }
    setWCActiveAccount(account) {
        localStorage.setItem(this.activeAccountKey, account);
        this.setActiveAccount(account);
        this.emit('accountChange', { accounts: [account] });
    }
    setSession(session) {
        localStorage.setItem(this.sessionTopicKey, session.topic);
        this.session = session;
    }
    endSession() {
        return __awaiter$8(this, void 0, void 0, function* () {
            var _a;
            this.clearActiveAccount();
            this.clearSession();
            this.currentChainId = undefined;
            if (!((_a = WalletConnect.provider) === null || _a === void 0 ? void 0 : _a.session)) {
                return;
            }
            try {
                yield WalletConnect.provider.disconnect();
                // We must unset provider on logout so that a new session can be established
                // If we don't then the provider will still have the old session and will hang
                WalletConnect.provider = undefined;
            }
            catch (e) {
                logger$8.debug(e);
            }
        });
    }
    getNetwork() {
        const _super = Object.create(null, {
            getNetwork: { get: () => super.getNetwork }
        });
        return __awaiter$8(this, void 0, void 0, function* () {
            if (this.currentChainId) {
                return this.currentChainId;
            }
            yield this.initProvider();
            return _super.getNetwork.call(this);
        });
    }
    providerSwitchNetwork(_a) {
        const _super = Object.create(null, {
            providerSwitchNetwork: { get: () => super.providerSwitchNetwork }
        });
        return __awaiter$8(this, arguments, void 0, function* ({ network, }) {
            const supportedNetworks = yield this.getSupportedNetworks();
            if (!(supportedNetworks === null || supportedNetworks === void 0 ? void 0 : supportedNetworks.includes(network.chainId.toString()))) {
                const error = new DynamicError('Network switching is not available at this time. The user should manually switch network in their wallet');
                error.code = 'network_switching_only_available_in_wallet';
                throw error;
            }
            const currentNetworkId = yield this.getNetwork();
            if (currentNetworkId && currentNetworkId === network.chainId) {
                return;
            }
            if (this.switchNetworkOnlyFromWallet) {
                throw new DynamicError('Network switching is only supported through the wallet');
            }
            const walletClient = yield this.getWalletClient();
            yield _super.providerSwitchNetwork.call(this, { network, provider: walletClient });
            this.currentChainId = network.chainId;
            this.emit('chainChange', { chain: String(network.chainId) });
        });
    }
    getConnectedAccounts() {
        return __awaiter$8(this, void 0, void 0, function* () {
            if (this.isInitialized === false) {
                // TODO why not just call init()?
                yield this.initProvider();
                yield this.refreshSession();
                this.isInitialized = true;
            }
            const activeAccount = this.getActiveAccount();
            if (!(activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.address)) {
                return [];
            }
            return [activeAccount.address];
        });
    }
    getSupportedNetworks() {
        return __awaiter$8(this, void 0, void 0, function* () {
            var _a;
            yield this.initProvider();
            yield this.refreshSession();
            if (!this.session) {
                return [];
            }
            const chains = [];
            // Some wallet (i.e ZenGo) use namespaces.account to list supported chains
            // while others use keys within the namespaces object
            Object.keys(this.session.namespaces).forEach((key) => {
                if (key.startsWith('eip155:')) {
                    chains.push(key.split(':')[1]);
                }
            });
            (_a = this.session.namespaces.eip155) === null || _a === void 0 ? void 0 : _a.accounts.forEach((account) => chains.push(account.split(':')[1]));
            return chains.length
                ? chains
                : this.evmNetworks.map((network) => network.chainId.toString());
        });
    }
}

class InjectedWalletBase extends EthereumWalletConnector {
    constructor() {
        super(...arguments);
        this.walletConnectorFallback = false;
    }
    get ethProviderHelper() {
        if (!this._ethProviderHelper) {
            this._ethProviderHelper = new EthProviderHelper(this);
        }
        return this._ethProviderHelper;
    }
    getMobileOrInstalledWallet() {
        var _a;
        if (this.isInstalledOnBrowser()) {
            return this;
        }
        // this is to handle the case where the user is in a webview.
        // when the user is in a webview, customers should set the deepLinkPreference prop to universal,
        // in which case this condition will be false, and the SDK will use WalletConnect (if available)
        if (((_a = this.metadata) === null || _a === void 0 ? void 0 : _a.inAppBrowserUrl) &&
            this.mobileExperience === 'in-app-browser' &&
            isMobile()) {
            return this;
        }
        // this is the case where the wallet is not installed on the browser and
        // it does not support WalletConnect. in this case, the SDK will instruct
        // the user to download the wallet extension
        if (!this.walletConnectorFallback) {
            return this;
        }
        return new WalletConnect(Object.assign(Object.assign({}, this.constructorProps), { walletName: this.name }));
    }
    findProvider() {
        var _a;
        return (_a = this.ethProviderHelper) === null || _a === void 0 ? void 0 : _a.getInstalledProvider();
    }
    setupEventListeners() {
        const provider = this.getWalletClient();
        if (!provider)
            return;
        if (!this.ethProviderHelper)
            return;
        const { tearDownEventListeners } = this.ethProviderHelper._setupEventListeners(this);
        this.teardownEventListeners = tearDownEventListeners;
    }
    getWalletClient(chainId) {
        var _a;
        return (_a = this.ethProviderHelper) === null || _a === void 0 ? void 0 : _a.findWalletClient(chainId);
    }
    isInstalledOnBrowser() {
        var _a;
        return ((_a = this.ethProviderHelper) === null || _a === void 0 ? void 0 : _a.findProvider()) !== undefined;
    }
    getAddress() {
        return __awaiter$8(this, void 0, void 0, function* () {
            var _a;
            return (_a = this.ethProviderHelper) === null || _a === void 0 ? void 0 : _a.getAddress();
        });
    }
    connect() {
        return __awaiter$8(this, void 0, void 0, function* () {
            yield this.getAddress();
        });
    }
    signMessage(messageToSign) {
        return __awaiter$8(this, void 0, void 0, function* () {
            var _a;
            return (_a = this.ethProviderHelper) === null || _a === void 0 ? void 0 : _a.signMessage(messageToSign);
        });
    }
    proveOwnership(address, messageToSign) {
        return __awaiter$8(this, void 0, void 0, function* () {
            yield this.validateActiveWallet(address);
            return this.signMessage(messageToSign);
        });
    }
    endSession() {
        return __awaiter$8(this, void 0, void 0, function* () {
            // nothing to do on browser-based metamask
            return;
        });
    }
    providerSwitchNetwork(_a) {
        const _super = Object.create(null, {
            providerSwitchNetwork: { get: () => super.providerSwitchNetwork }
        });
        return __awaiter$8(this, arguments, void 0, function* ({ network, provider, }) {
            return _super.providerSwitchNetwork.call(this, { network, provider });
        });
    }
}

class PhantomEvm extends InjectedWalletBase {
    constructor() {
        super(...arguments);
        this.name = 'Phantom';
        this.overrideKey = 'phantomevm';
    }
    getAddress() {
        const _super = Object.create(null, {
            getAddress: { get: () => super.getAddress }
        });
        return __awaiter$8(this, void 0, void 0, function* () {
            if (this.isInstalledOnBrowser()) {
                return _super.getAddress.call(this);
            }
            if (isMobile()) {
                handleMobileWalletRedirect({
                    nativeLink: 'phantom://browse',
                    universalLink: 'https://phantom.app/ul/browse',
                });
            }
            return undefined;
        });
    }
    canGetChainAddress() {
        var _a, _b;
        return Boolean((_b = (_a = this.ethProviderHelper) === null || _a === void 0 ? void 0 : _a.findProvider()) === null || _b === void 0 ? void 0 : _b.selectedAddress);
    }
}

// leaving ExodusEvm in here due to a backwards compatibility issue with this one wallet and v18
class ExodusEvm extends InjectedWalletBase {
    constructor() {
        super(...arguments);
        this.name = 'ExodusEvm';
        this.overrideKey = 'exodusevm';
        this.walletConnectorFallback = true;
    }
}

class FallbackEvmConnector extends InjectedWalletBase {
    constructor() {
        super(...arguments);
        this.name = 'Fallback Connector';
        this.overrideKey = 'fallbackconnector';
        this.isAvailable = false;
    }
    isInstalledOnBrowser() {
        return false;
    }
}

const getConnectorConstructorForEip6963Wallet = (walletDetail) => {
    const { info, provider } = walletDetail;
    const sanitizedName = sanitizeName(info.name);
    return class extends InjectedWalletBase {
        constructor(props) {
            super(Object.assign(Object.assign({}, props), { metadata: {
                    groupKey: sanitizedName,
                    icon: info.icon,
                    id: info.uuid,
                    name: info.name,
                    rdns: info.rdns,
                } }));
            this.name = info.name;
            this.overrideKey = `${sanitizedName}evm`;
        }
        findProvider() {
            return provider;
        }
    };
};

const logger$4 = new Logger$1('@dynamic-labs/ethereum');

const getConnectorConstructorInjectedWallet = (key, wallet) => {
    const { shortName } = wallet;
    const name = shortName || wallet.name;
    const walletConnectorFallback = Boolean(wallet.walletConnect);
    return class extends InjectedWalletBase {
        constructor() {
            super(...arguments);
            this.name = name;
            this.walletConnectorFallback = walletConnectorFallback;
            // this is the key from the wallet book entry so that we don't purely rely on the normalized name
            this.overrideKey = key;
        }
        getAddress() {
            const _super = Object.create(null, {
                getAddress: { get: () => super.getAddress }
            });
            return __awaiter$8(this, void 0, void 0, function* () {
                var _a;
                if (this.isInstalledOnBrowser()) {
                    return _super.getAddress.call(this);
                }
                const inAppBrowserBase = (_a = this.metadata) === null || _a === void 0 ? void 0 : _a.inAppBrowserUrl;
                if (!inAppBrowserBase) {
                    const error = new Error(`No inAppBrowserBase found for ${this.name}.`);
                    logger$4.error(error.message);
                    throw error;
                }
                window.location.href = `${inAppBrowserBase}/${window.location.href}`;
                return undefined;
            });
        }
    };
};

const injectedWalletOverrides = [
    PhantomEvm,
    ExodusEvm,
];
const walletsWithCustomConnectors = [
    'phantomevm',
    'coinbase',
    'exodusevm',
    'abstract',
    'metamask',
    'edenonline',
    'intersend',
];
let removeEip6963EventsListener;
// should add eip6963 connector only if not in wallet-book, to avoid adding duplicate connectors
const shouldAddEip6963Connector = (eip6963ProviderInfo, walletBook) => {
    var _a;
    const { rdns, name } = eip6963ProviderInfo;
    const chain = 'evm';
    const connectorKey = `${sanitizeName(name)}${chain}`;
    logger$8.logVerboseTroubleshootingMessage('[ETH shouldAddEip6963Connector]', rdns, name, chain, connectorKey);
    const existingWallet = Object.entries((_a = walletBook === null || walletBook === void 0 ? void 0 : walletBook.wallets) !== null && _a !== void 0 ? _a : {}).find(([key, wallet]) => {
        var _a, _b;
        return ((_a = wallet.eip6963Config) === null || _a === void 0 ? void 0 : _a.rdns) === rdns ||
            key === connectorKey ||
            walletsWithCustomConnectors.includes(connectorKey) ||
            (wallet.name === name && ((_b = wallet.injectedConfig) === null || _b === void 0 ? void 0 : _b[0].chain) === chain);
    });
    logger$8.logVerboseTroubleshootingMessage('[ETH shouldAddEip6963Connector]', existingWallet);
    return !existingWallet;
};
const addEip6963Listener = (walletBook) => {
    removeEip6963EventsListener === null || removeEip6963EventsListener === void 0 ? void 0 : removeEip6963EventsListener();
    removeEip6963EventsListener = listenToEip6963Events((event) => {
        if (!shouldAddEip6963Connector(event.detail.info, walletBook)) {
            return;
        }
        logger$8.logVerboseTroubleshootingMessage('[ETH fetchInjectedWalletConnectors] listenToEip6963Events', event.detail);
        walletConnectorEvents.emit('providerInjected', {
            injectedConnectorConstructor: getConnectorConstructorForEip6963Wallet(event.detail),
        });
    });
};
const fetchInjectedWalletConnector = ({ walletBook, }) => {
    var _a;
    addEip6963Listener(walletBook);
    const walletBookConnectors = Object.entries((_a = walletBook === null || walletBook === void 0 ? void 0 : walletBook.wallets) !== null && _a !== void 0 ? _a : {})
        .filter(([key, wallet]) => {
        var _a;
        return ((_a = wallet.injectedConfig) === null || _a === void 0 ? void 0 : _a.find((config) => config.chain === 'evm')) &&
            !walletsWithCustomConnectors.includes(key);
    })
        .map(([key, wallet]) => getConnectorConstructorInjectedWallet(key, wallet));
    const { providers } = Eip6963ProviderSingleton.get();
    const eip6963Connectors = providers
        .filter((provider) => shouldAddEip6963Connector(provider.info, walletBook))
        .map((provider) => getConnectorConstructorForEip6963Wallet(provider));
    logger$8.logVerboseTroubleshootingMessage('[ETH fetchInjectedWalletConnectors] eip6963Connectors', eip6963Connectors);
    return [...walletBookConnectors, ...eip6963Connectors];
};

var version$7 = "4.6.1";

var version$6 = "4.6.1";

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter$4(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (f ? f.value = value : state.set(receiver, value)), value;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Code modified from https://github.com/github/webauthn-json/blob/e932b3585fa70b0bd5b5a4012ba7dbad7b0a0d0f/src/webauthn-json/base64url.ts#L23
 */
const DEFAULT_JWK_MEMBER_BYTE_LENGTH = 32;
function stringToBase64urlString(input) {
    // string to base64 -- we do not rely on the browser's btoa since it's not present in React Native environments
    const base64String = btoa$1(input);
    return base64StringToBase64UrlEncodedString(base64String);
}
function hexStringToBase64url(input, length) {
    // Add an extra 0 to the start of the string to get a valid hex string (even length)
    // (e.g. 0x0123 instead of 0x123)
    const hexString = input.padStart(Math.ceil(input.length / 2) * 2, "0");
    const buffer = uint8ArrayFromHexString(hexString, length);
    return stringToBase64urlString(buffer.reduce((result, x) => result + String.fromCharCode(x), ""));
}
function base64StringToBase64UrlEncodedString(input) {
    return input.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function uint8ArrayToHexString(input) {
    return input.reduce((result, x) => result + x.toString(16).padStart(2, "0"), "");
}
const uint8ArrayFromHexString = (hexString, length) => {
    const hexRegex = /^[0-9A-Fa-f]+$/;
    if (!hexString || hexString.length % 2 != 0 || !hexRegex.test(hexString)) {
        throw new Error(`cannot create uint8array from invalid hex string: "${hexString}"`);
    }
    const buffer = new Uint8Array(hexString.match(/../g).map((h) => parseInt(h, 16)));
    if (!length) {
        return buffer;
    }
    if (hexString.length / 2 > length) {
        throw new Error("hex value cannot fit in a buffer of " + length + " byte(s)");
    }
    // If a length is specified, ensure we sufficiently pad
    let paddedBuffer = new Uint8Array(length);
    paddedBuffer.set(buffer, length - buffer.length);
    return paddedBuffer;
};
// Pure JS implementation of btoa. This is adapted from the following:
// https://github.com/jsdom/abab/blob/80874ae1fe1cde2e587bb6e51b6d7c9b42ca1d34/lib/btoa.js
function btoa$1(s) {
    if (arguments.length === 0) {
        throw new TypeError("1 argument required, but only 0 present.");
    }
    let i;
    // String conversion as required by Web IDL.
    s = `${s}`;
    // "The btoa() method must throw an "InvalidCharacterError" DOMException if
    // data contains any character whose code point is greater than U+00FF."
    for (i = 0; i < s.length; i++) {
        if (s.charCodeAt(i) > 255) {
            throw new Error(`InvalidCharacterError: found code point greater than 255:${s.charCodeAt(i)} at position ${i}`);
        }
    }
    let out = "";
    for (i = 0; i < s.length; i += 3) {
        const groupsOfSix = [
            undefined,
            undefined,
            undefined,
            undefined,
        ];
        groupsOfSix[0] = s.charCodeAt(i) >> 2;
        groupsOfSix[1] = (s.charCodeAt(i) & 0x03) << 4;
        if (s.length > i + 1) {
            groupsOfSix[1] |= s.charCodeAt(i + 1) >> 4;
            groupsOfSix[2] = (s.charCodeAt(i + 1) & 0x0f) << 2;
        }
        if (s.length > i + 2) {
            groupsOfSix[2] |= s.charCodeAt(i + 2) >> 6;
            groupsOfSix[3] = s.charCodeAt(i + 2) & 0x3f;
        }
        for (let j = 0; j < groupsOfSix.length; j++) {
            if (typeof groupsOfSix[j] === "undefined") {
                out += "=";
            }
            else {
                out += btoaLookup(groupsOfSix[j]);
            }
        }
    }
    return out;
}
function btoaLookup(index) {
    /**
     * Lookup table for btoa(), which converts a six-bit number into the
     * corresponding ASCII character.
     */
    const keystr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    if (index >= 0 && index < 64) {
        return keystr[index];
    }
    // Throw INVALID_CHARACTER_ERR exception here -- won't be hit in the tests.
    return undefined;
}

/// <reference lib="dom" />
// Header name for an API key stamp
const stampHeaderName$2 = "X-Stamp";
// `window.document` ensures that we're in a browser context
// and `crypto.subtle` ensures that it supports the web crypto APIs
// Inspired by https://github.com/flexdinesh/browser-or-node/blob/master/src/index.ts
const isCryptoEnabledBrowser = typeof window !== "undefined" &&
    typeof window.document !== "undefined" &&
    typeof crypto !== "undefined" &&
    typeof crypto.subtle !== "undefined";
// We check `process.versions.node`
// Taken from https://github.com/flexdinesh/browser-or-node/blob/master/src/index.ts
const isNode = typeof process !== "undefined" &&
    process.versions != null &&
    process.versions.node != null;
/**
 * Signature function abstracting the differences between NodeJS and web environments for signing with API keys.
 */
const signWithApiKey = async (input) => {
    if (isCryptoEnabledBrowser) {
        const fn = await import('./webcrypto-BBL7lsZO.js').then((m) => m.signWithApiKey);
        return fn(input);
    }
    else if (isNode) {
        const fn = await import('./nodecrypto-CbDqcAuB.js').then((m) => m.signWithApiKey);
        return fn(input);
    }
    else {
        // If we don't have NodeJS or web crypto at our disposal, default to pure JS implementation
        // This is the case for old browsers and react native environments
        const fn = await import('./purejs-Dl6azvB2.js').then((m) => m.signWithApiKey);
        return fn(input);
    }
};
/**
 * Stamper to use with `@turnkey/http`'s `TurnkeyClient`
 */
class ApiKeyStamper {
    constructor(config) {
        this.apiPublicKey = config.apiPublicKey;
        this.apiPrivateKey = config.apiPrivateKey;
    }
    async stamp(payload) {
        const signature = await signWithApiKey({
            publicKey: this.apiPublicKey,
            privateKey: this.apiPrivateKey,
            content: payload,
        });
        const stamp = {
            publicKey: this.apiPublicKey,
            scheme: "SIGNATURE_SCHEME_TK_API_P256",
            signature: signature,
        };
        return {
            stampHeaderName: stampHeaderName$2,
            stampHeaderValue: stringToBase64urlString(JSON.stringify(stamp)),
        };
    }
}

/// <reference lib="dom" />
// This is useful for mocking fetch in tests.
const fetch$1 = browserPonyfillExports.fetch;

class TurnkeyRequestError extends Error {
    constructor(input) {
        let turnkeyErrorMessage = `Turnkey error ${input.code}: ${input.message}`;
        if (input.details != null) {
            turnkeyErrorMessage += ` (Details: ${JSON.stringify(input.details)})`;
        }
        super(turnkeyErrorMessage);
        this.name = "TurnkeyRequestError";
        this.details = input.details ?? null;
        this.code = input.code;
    }
}

const VERSION$2 = "@turnkey/http@2.15.0";

/* @generated by `@turnkey/fetchers`. DO NOT EDIT BY HAND */
class TurnkeyClient {
    constructor(config, stamper) {
        /**
         * Get details about an Activity
         *
         * Sign the provided `TGetActivityBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_activity).
         *
         * See also {@link stampGetActivity}.
         */
        this.getActivity = async (input) => {
            return this.request("/public/v1/query/get_activity", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetActivityBody` by using the client's `stamp` function.
         *
         * See also {@link GetActivity}.
         */
        this.stampGetActivity = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_activity";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get details about an API key
         *
         * Sign the provided `TGetApiKeyBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_api_key).
         *
         * See also {@link stampGetApiKey}.
         */
        this.getApiKey = async (input) => {
            return this.request("/public/v1/query/get_api_key", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetApiKeyBody` by using the client's `stamp` function.
         *
         * See also {@link GetApiKey}.
         */
        this.stampGetApiKey = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_api_key";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get details about API keys for a user
         *
         * Sign the provided `TGetApiKeysBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_api_keys).
         *
         * See also {@link stampGetApiKeys}.
         */
        this.getApiKeys = async (input) => {
            return this.request("/public/v1/query/get_api_keys", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetApiKeysBody` by using the client's `stamp` function.
         *
         * See also {@link GetApiKeys}.
         */
        this.stampGetApiKeys = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_api_keys";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get the attestation document corresponding to an enclave.
         *
         * Sign the provided `TGetAttestationDocumentBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_attestation).
         *
         * See also {@link stampGetAttestationDocument}.
         */
        this.getAttestationDocument = async (input) => {
            return this.request("/public/v1/query/get_attestation", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetAttestationDocumentBody` by using the client's `stamp` function.
         *
         * See also {@link GetAttestationDocument}.
         */
        this.stampGetAttestationDocument = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_attestation";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get details about an authenticator
         *
         * Sign the provided `TGetAuthenticatorBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_authenticator).
         *
         * See also {@link stampGetAuthenticator}.
         */
        this.getAuthenticator = async (input) => {
            return this.request("/public/v1/query/get_authenticator", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetAuthenticatorBody` by using the client's `stamp` function.
         *
         * See also {@link GetAuthenticator}.
         */
        this.stampGetAuthenticator = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_authenticator";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get details about authenticators for a user
         *
         * Sign the provided `TGetAuthenticatorsBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_authenticators).
         *
         * See also {@link stampGetAuthenticators}.
         */
        this.getAuthenticators = async (input) => {
            return this.request("/public/v1/query/get_authenticators", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetAuthenticatorsBody` by using the client's `stamp` function.
         *
         * See also {@link GetAuthenticators}.
         */
        this.stampGetAuthenticators = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_authenticators";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get details about Oauth providers for a user
         *
         * Sign the provided `TGetOauthProvidersBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_oauth_providers).
         *
         * See also {@link stampGetOauthProviders}.
         */
        this.getOauthProviders = async (input) => {
            return this.request("/public/v1/query/get_oauth_providers", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetOauthProvidersBody` by using the client's `stamp` function.
         *
         * See also {@link GetOauthProviders}.
         */
        this.stampGetOauthProviders = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_oauth_providers";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get details about an Organization
         *
         * Sign the provided `TGetOrganizationBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_organization).
         *
         * See also {@link stampGetOrganization}.
         */
        this.getOrganization = async (input) => {
            return this.request("/public/v1/query/get_organization", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetOrganizationBody` by using the client's `stamp` function.
         *
         * See also {@link GetOrganization}.
         */
        this.stampGetOrganization = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_organization";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get quorum settings and features for an organization
         *
         * Sign the provided `TGetOrganizationConfigsBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_organization_configs).
         *
         * See also {@link stampGetOrganizationConfigs}.
         */
        this.getOrganizationConfigs = async (input) => {
            return this.request("/public/v1/query/get_organization_configs", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetOrganizationConfigsBody` by using the client's `stamp` function.
         *
         * See also {@link GetOrganizationConfigs}.
         */
        this.stampGetOrganizationConfigs = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_organization_configs";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get details about a Policy
         *
         * Sign the provided `TGetPolicyBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_policy).
         *
         * See also {@link stampGetPolicy}.
         */
        this.getPolicy = async (input) => {
            return this.request("/public/v1/query/get_policy", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetPolicyBody` by using the client's `stamp` function.
         *
         * See also {@link GetPolicy}.
         */
        this.stampGetPolicy = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_policy";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get details about a Private Key
         *
         * Sign the provided `TGetPrivateKeyBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_private_key).
         *
         * See also {@link stampGetPrivateKey}.
         */
        this.getPrivateKey = async (input) => {
            return this.request("/public/v1/query/get_private_key", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetPrivateKeyBody` by using the client's `stamp` function.
         *
         * See also {@link GetPrivateKey}.
         */
        this.stampGetPrivateKey = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_private_key";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get details about a User
         *
         * Sign the provided `TGetUserBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_user).
         *
         * See also {@link stampGetUser}.
         */
        this.getUser = async (input) => {
            return this.request("/public/v1/query/get_user", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetUserBody` by using the client's `stamp` function.
         *
         * See also {@link GetUser}.
         */
        this.stampGetUser = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_user";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get details about a Wallet
         *
         * Sign the provided `TGetWalletBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/get_wallet).
         *
         * See also {@link stampGetWallet}.
         */
        this.getWallet = async (input) => {
            return this.request("/public/v1/query/get_wallet", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetWalletBody` by using the client's `stamp` function.
         *
         * See also {@link GetWallet}.
         */
        this.stampGetWallet = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/get_wallet";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * List all Activities within an Organization
         *
         * Sign the provided `TGetActivitiesBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/list_activities).
         *
         * See also {@link stampGetActivities}.
         */
        this.getActivities = async (input) => {
            return this.request("/public/v1/query/list_activities", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetActivitiesBody` by using the client's `stamp` function.
         *
         * See also {@link GetActivities}.
         */
        this.stampGetActivities = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/list_activities";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * List all Policies within an Organization
         *
         * Sign the provided `TGetPoliciesBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/list_policies).
         *
         * See also {@link stampGetPolicies}.
         */
        this.getPolicies = async (input) => {
            return this.request("/public/v1/query/list_policies", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetPoliciesBody` by using the client's `stamp` function.
         *
         * See also {@link GetPolicies}.
         */
        this.stampGetPolicies = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/list_policies";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * List all Private Key Tags within an Organization
         *
         * Sign the provided `TListPrivateKeyTagsBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/list_private_key_tags).
         *
         * See also {@link stampListPrivateKeyTags}.
         */
        this.listPrivateKeyTags = async (input) => {
            return this.request("/public/v1/query/list_private_key_tags", input);
        };
        /**
         * Produce a `SignedRequest` from `TListPrivateKeyTagsBody` by using the client's `stamp` function.
         *
         * See also {@link ListPrivateKeyTags}.
         */
        this.stampListPrivateKeyTags = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/list_private_key_tags";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * List all Private Keys within an Organization
         *
         * Sign the provided `TGetPrivateKeysBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/list_private_keys).
         *
         * See also {@link stampGetPrivateKeys}.
         */
        this.getPrivateKeys = async (input) => {
            return this.request("/public/v1/query/list_private_keys", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetPrivateKeysBody` by using the client's `stamp` function.
         *
         * See also {@link GetPrivateKeys}.
         */
        this.stampGetPrivateKeys = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/list_private_keys";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get all suborg IDs associated given a parent org ID and an optional filter.
         *
         * Sign the provided `TGetSubOrgIdsBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/list_suborgs).
         *
         * See also {@link stampGetSubOrgIds}.
         */
        this.getSubOrgIds = async (input) => {
            return this.request("/public/v1/query/list_suborgs", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetSubOrgIdsBody` by using the client's `stamp` function.
         *
         * See also {@link GetSubOrgIds}.
         */
        this.stampGetSubOrgIds = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/list_suborgs";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * List all User Tags within an Organization
         *
         * Sign the provided `TListUserTagsBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/list_user_tags).
         *
         * See also {@link stampListUserTags}.
         */
        this.listUserTags = async (input) => {
            return this.request("/public/v1/query/list_user_tags", input);
        };
        /**
         * Produce a `SignedRequest` from `TListUserTagsBody` by using the client's `stamp` function.
         *
         * See also {@link ListUserTags}.
         */
        this.stampListUserTags = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/list_user_tags";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * List all Users within an Organization
         *
         * Sign the provided `TGetUsersBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/list_users).
         *
         * See also {@link stampGetUsers}.
         */
        this.getUsers = async (input) => {
            return this.request("/public/v1/query/list_users", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetUsersBody` by using the client's `stamp` function.
         *
         * See also {@link GetUsers}.
         */
        this.stampGetUsers = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/list_users";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * List all Accounts wirhin a Wallet
         *
         * Sign the provided `TGetWalletAccountsBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/list_wallet_accounts).
         *
         * See also {@link stampGetWalletAccounts}.
         */
        this.getWalletAccounts = async (input) => {
            return this.request("/public/v1/query/list_wallet_accounts", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetWalletAccountsBody` by using the client's `stamp` function.
         *
         * See also {@link GetWalletAccounts}.
         */
        this.stampGetWalletAccounts = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/list_wallet_accounts";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * List all Wallets within an Organization
         *
         * Sign the provided `TGetWalletsBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/list_wallets).
         *
         * See also {@link stampGetWallets}.
         */
        this.getWallets = async (input) => {
            return this.request("/public/v1/query/list_wallets", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetWalletsBody` by using the client's `stamp` function.
         *
         * See also {@link GetWallets}.
         */
        this.stampGetWallets = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/list_wallets";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Get basic information about your current API or WebAuthN user and their organization. Affords Sub-Organization look ups via Parent Organization for WebAuthN or API key users.
         *
         * Sign the provided `TGetWhoamiBody` with the client's `stamp` function, and submit the request (POST /public/v1/query/whoami).
         *
         * See also {@link stampGetWhoami}.
         */
        this.getWhoami = async (input) => {
            return this.request("/public/v1/query/whoami", input);
        };
        /**
         * Produce a `SignedRequest` from `TGetWhoamiBody` by using the client's `stamp` function.
         *
         * See also {@link GetWhoami}.
         */
        this.stampGetWhoami = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/query/whoami";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Approve an Activity
         *
         * Sign the provided `TApproveActivityBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/approve_activity).
         *
         * See also {@link stampApproveActivity}.
         */
        this.approveActivity = async (input) => {
            return this.request("/public/v1/submit/approve_activity", input);
        };
        /**
         * Produce a `SignedRequest` from `TApproveActivityBody` by using the client's `stamp` function.
         *
         * See also {@link ApproveActivity}.
         */
        this.stampApproveActivity = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/approve_activity";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Add api keys to an existing User
         *
         * Sign the provided `TCreateApiKeysBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_api_keys).
         *
         * See also {@link stampCreateApiKeys}.
         */
        this.createApiKeys = async (input) => {
            return this.request("/public/v1/submit/create_api_keys", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreateApiKeysBody` by using the client's `stamp` function.
         *
         * See also {@link CreateApiKeys}.
         */
        this.stampCreateApiKeys = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_api_keys";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create API-only Users in an existing Organization
         *
         * Sign the provided `TCreateApiOnlyUsersBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_api_only_users).
         *
         * See also {@link stampCreateApiOnlyUsers}.
         */
        this.createApiOnlyUsers = async (input) => {
            return this.request("/public/v1/submit/create_api_only_users", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreateApiOnlyUsersBody` by using the client's `stamp` function.
         *
         * See also {@link CreateApiOnlyUsers}.
         */
        this.stampCreateApiOnlyUsers = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_api_only_users";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create Authenticators to authenticate requests to Turnkey
         *
         * Sign the provided `TCreateAuthenticatorsBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_authenticators).
         *
         * See also {@link stampCreateAuthenticators}.
         */
        this.createAuthenticators = async (input) => {
            return this.request("/public/v1/submit/create_authenticators", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreateAuthenticatorsBody` by using the client's `stamp` function.
         *
         * See also {@link CreateAuthenticators}.
         */
        this.stampCreateAuthenticators = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_authenticators";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create Invitations to join an existing Organization
         *
         * Sign the provided `TCreateInvitationsBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_invitations).
         *
         * See also {@link stampCreateInvitations}.
         */
        this.createInvitations = async (input) => {
            return this.request("/public/v1/submit/create_invitations", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreateInvitationsBody` by using the client's `stamp` function.
         *
         * See also {@link CreateInvitations}.
         */
        this.stampCreateInvitations = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_invitations";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Creates Oauth providers for a specified user - BETA
         *
         * Sign the provided `TCreateOauthProvidersBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_oauth_providers).
         *
         * See also {@link stampCreateOauthProviders}.
         */
        this.createOauthProviders = async (input) => {
            return this.request("/public/v1/submit/create_oauth_providers", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreateOauthProvidersBody` by using the client's `stamp` function.
         *
         * See also {@link CreateOauthProviders}.
         */
        this.stampCreateOauthProviders = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_oauth_providers";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create new Policies
         *
         * Sign the provided `TCreatePoliciesBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_policies).
         *
         * See also {@link stampCreatePolicies}.
         */
        this.createPolicies = async (input) => {
            return this.request("/public/v1/submit/create_policies", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreatePoliciesBody` by using the client's `stamp` function.
         *
         * See also {@link CreatePolicies}.
         */
        this.stampCreatePolicies = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_policies";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create a new Policy
         *
         * Sign the provided `TCreatePolicyBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_policy).
         *
         * See also {@link stampCreatePolicy}.
         */
        this.createPolicy = async (input) => {
            return this.request("/public/v1/submit/create_policy", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreatePolicyBody` by using the client's `stamp` function.
         *
         * See also {@link CreatePolicy}.
         */
        this.stampCreatePolicy = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_policy";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create a private key tag and add it to private keys.
         *
         * Sign the provided `TCreatePrivateKeyTagBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_private_key_tag).
         *
         * See also {@link stampCreatePrivateKeyTag}.
         */
        this.createPrivateKeyTag = async (input) => {
            return this.request("/public/v1/submit/create_private_key_tag", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreatePrivateKeyTagBody` by using the client's `stamp` function.
         *
         * See also {@link CreatePrivateKeyTag}.
         */
        this.stampCreatePrivateKeyTag = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_private_key_tag";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create new Private Keys
         *
         * Sign the provided `TCreatePrivateKeysBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_private_keys).
         *
         * See also {@link stampCreatePrivateKeys}.
         */
        this.createPrivateKeys = async (input) => {
            return this.request("/public/v1/submit/create_private_keys", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreatePrivateKeysBody` by using the client's `stamp` function.
         *
         * See also {@link CreatePrivateKeys}.
         */
        this.stampCreatePrivateKeys = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_private_keys";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create a read only session for a user (valid for 1 hour)
         *
         * Sign the provided `TCreateReadOnlySessionBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_read_only_session).
         *
         * See also {@link stampCreateReadOnlySession}.
         */
        this.createReadOnlySession = async (input) => {
            return this.request("/public/v1/submit/create_read_only_session", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreateReadOnlySessionBody` by using the client's `stamp` function.
         *
         * See also {@link CreateReadOnlySession}.
         */
        this.stampCreateReadOnlySession = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_read_only_session";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create a read write session for a user
         *
         * Sign the provided `TCreateReadWriteSessionBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_read_write_session).
         *
         * See also {@link stampCreateReadWriteSession}.
         */
        this.createReadWriteSession = async (input) => {
            return this.request("/public/v1/submit/create_read_write_session", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreateReadWriteSessionBody` by using the client's `stamp` function.
         *
         * See also {@link CreateReadWriteSession}.
         */
        this.stampCreateReadWriteSession = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_read_write_session";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create a new Sub-Organization
         *
         * Sign the provided `TCreateSubOrganizationBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_sub_organization).
         *
         * See also {@link stampCreateSubOrganization}.
         */
        this.createSubOrganization = async (input) => {
            return this.request("/public/v1/submit/create_sub_organization", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreateSubOrganizationBody` by using the client's `stamp` function.
         *
         * See also {@link CreateSubOrganization}.
         */
        this.stampCreateSubOrganization = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_sub_organization";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create a user tag and add it to users.
         *
         * Sign the provided `TCreateUserTagBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_user_tag).
         *
         * See also {@link stampCreateUserTag}.
         */
        this.createUserTag = async (input) => {
            return this.request("/public/v1/submit/create_user_tag", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreateUserTagBody` by using the client's `stamp` function.
         *
         * See also {@link CreateUserTag}.
         */
        this.stampCreateUserTag = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_user_tag";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create Users in an existing Organization
         *
         * Sign the provided `TCreateUsersBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_users).
         *
         * See also {@link stampCreateUsers}.
         */
        this.createUsers = async (input) => {
            return this.request("/public/v1/submit/create_users", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreateUsersBody` by using the client's `stamp` function.
         *
         * See also {@link CreateUsers}.
         */
        this.stampCreateUsers = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_users";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Create a Wallet and derive addresses
         *
         * Sign the provided `TCreateWalletBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_wallet).
         *
         * See also {@link stampCreateWallet}.
         */
        this.createWallet = async (input) => {
            return this.request("/public/v1/submit/create_wallet", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreateWalletBody` by using the client's `stamp` function.
         *
         * See also {@link CreateWallet}.
         */
        this.stampCreateWallet = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_wallet";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Derive additional addresses using an existing wallet
         *
         * Sign the provided `TCreateWalletAccountsBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/create_wallet_accounts).
         *
         * See also {@link stampCreateWalletAccounts}.
         */
        this.createWalletAccounts = async (input) => {
            return this.request("/public/v1/submit/create_wallet_accounts", input);
        };
        /**
         * Produce a `SignedRequest` from `TCreateWalletAccountsBody` by using the client's `stamp` function.
         *
         * See also {@link CreateWalletAccounts}.
         */
        this.stampCreateWalletAccounts = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/create_wallet_accounts";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Remove api keys from a User
         *
         * Sign the provided `TDeleteApiKeysBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/delete_api_keys).
         *
         * See also {@link stampDeleteApiKeys}.
         */
        this.deleteApiKeys = async (input) => {
            return this.request("/public/v1/submit/delete_api_keys", input);
        };
        /**
         * Produce a `SignedRequest` from `TDeleteApiKeysBody` by using the client's `stamp` function.
         *
         * See also {@link DeleteApiKeys}.
         */
        this.stampDeleteApiKeys = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/delete_api_keys";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Remove authenticators from a User
         *
         * Sign the provided `TDeleteAuthenticatorsBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/delete_authenticators).
         *
         * See also {@link stampDeleteAuthenticators}.
         */
        this.deleteAuthenticators = async (input) => {
            return this.request("/public/v1/submit/delete_authenticators", input);
        };
        /**
         * Produce a `SignedRequest` from `TDeleteAuthenticatorsBody` by using the client's `stamp` function.
         *
         * See also {@link DeleteAuthenticators}.
         */
        this.stampDeleteAuthenticators = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/delete_authenticators";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Delete an existing Invitation
         *
         * Sign the provided `TDeleteInvitationBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/delete_invitation).
         *
         * See also {@link stampDeleteInvitation}.
         */
        this.deleteInvitation = async (input) => {
            return this.request("/public/v1/submit/delete_invitation", input);
        };
        /**
         * Produce a `SignedRequest` from `TDeleteInvitationBody` by using the client's `stamp` function.
         *
         * See also {@link DeleteInvitation}.
         */
        this.stampDeleteInvitation = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/delete_invitation";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Removes Oauth providers for a specified user - BETA
         *
         * Sign the provided `TDeleteOauthProvidersBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/delete_oauth_providers).
         *
         * See also {@link stampDeleteOauthProviders}.
         */
        this.deleteOauthProviders = async (input) => {
            return this.request("/public/v1/submit/delete_oauth_providers", input);
        };
        /**
         * Produce a `SignedRequest` from `TDeleteOauthProvidersBody` by using the client's `stamp` function.
         *
         * See also {@link DeleteOauthProviders}.
         */
        this.stampDeleteOauthProviders = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/delete_oauth_providers";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Delete an existing Policy
         *
         * Sign the provided `TDeletePolicyBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/delete_policy).
         *
         * See also {@link stampDeletePolicy}.
         */
        this.deletePolicy = async (input) => {
            return this.request("/public/v1/submit/delete_policy", input);
        };
        /**
         * Produce a `SignedRequest` from `TDeletePolicyBody` by using the client's `stamp` function.
         *
         * See also {@link DeletePolicy}.
         */
        this.stampDeletePolicy = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/delete_policy";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Delete Private Key Tags within an Organization
         *
         * Sign the provided `TDeletePrivateKeyTagsBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/delete_private_key_tags).
         *
         * See also {@link stampDeletePrivateKeyTags}.
         */
        this.deletePrivateKeyTags = async (input) => {
            return this.request("/public/v1/submit/delete_private_key_tags", input);
        };
        /**
         * Produce a `SignedRequest` from `TDeletePrivateKeyTagsBody` by using the client's `stamp` function.
         *
         * See also {@link DeletePrivateKeyTags}.
         */
        this.stampDeletePrivateKeyTags = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/delete_private_key_tags";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Deletes private keys for an organization
         *
         * Sign the provided `TDeletePrivateKeysBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/delete_private_keys).
         *
         * See also {@link stampDeletePrivateKeys}.
         */
        this.deletePrivateKeys = async (input) => {
            return this.request("/public/v1/submit/delete_private_keys", input);
        };
        /**
         * Produce a `SignedRequest` from `TDeletePrivateKeysBody` by using the client's `stamp` function.
         *
         * See also {@link DeletePrivateKeys}.
         */
        this.stampDeletePrivateKeys = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/delete_private_keys";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Deletes a sub organization
         *
         * Sign the provided `TDeleteSubOrganizationBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/delete_sub_organization).
         *
         * See also {@link stampDeleteSubOrganization}.
         */
        this.deleteSubOrganization = async (input) => {
            return this.request("/public/v1/submit/delete_sub_organization", input);
        };
        /**
         * Produce a `SignedRequest` from `TDeleteSubOrganizationBody` by using the client's `stamp` function.
         *
         * See also {@link DeleteSubOrganization}.
         */
        this.stampDeleteSubOrganization = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/delete_sub_organization";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Delete User Tags within an Organization
         *
         * Sign the provided `TDeleteUserTagsBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/delete_user_tags).
         *
         * See also {@link stampDeleteUserTags}.
         */
        this.deleteUserTags = async (input) => {
            return this.request("/public/v1/submit/delete_user_tags", input);
        };
        /**
         * Produce a `SignedRequest` from `TDeleteUserTagsBody` by using the client's `stamp` function.
         *
         * See also {@link DeleteUserTags}.
         */
        this.stampDeleteUserTags = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/delete_user_tags";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Delete Users within an Organization
         *
         * Sign the provided `TDeleteUsersBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/delete_users).
         *
         * See also {@link stampDeleteUsers}.
         */
        this.deleteUsers = async (input) => {
            return this.request("/public/v1/submit/delete_users", input);
        };
        /**
         * Produce a `SignedRequest` from `TDeleteUsersBody` by using the client's `stamp` function.
         *
         * See also {@link DeleteUsers}.
         */
        this.stampDeleteUsers = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/delete_users";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Deletes wallets for an organization
         *
         * Sign the provided `TDeleteWalletsBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/delete_wallets).
         *
         * See also {@link stampDeleteWallets}.
         */
        this.deleteWallets = async (input) => {
            return this.request("/public/v1/submit/delete_wallets", input);
        };
        /**
         * Produce a `SignedRequest` from `TDeleteWalletsBody` by using the client's `stamp` function.
         *
         * See also {@link DeleteWallets}.
         */
        this.stampDeleteWallets = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/delete_wallets";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Authenticate a user via Email
         *
         * Sign the provided `TEmailAuthBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/email_auth).
         *
         * See also {@link stampEmailAuth}.
         */
        this.emailAuth = async (input) => {
            return this.request("/public/v1/submit/email_auth", input);
        };
        /**
         * Produce a `SignedRequest` from `TEmailAuthBody` by using the client's `stamp` function.
         *
         * See also {@link EmailAuth}.
         */
        this.stampEmailAuth = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/email_auth";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Exports a Private Key
         *
         * Sign the provided `TExportPrivateKeyBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/export_private_key).
         *
         * See also {@link stampExportPrivateKey}.
         */
        this.exportPrivateKey = async (input) => {
            return this.request("/public/v1/submit/export_private_key", input);
        };
        /**
         * Produce a `SignedRequest` from `TExportPrivateKeyBody` by using the client's `stamp` function.
         *
         * See also {@link ExportPrivateKey}.
         */
        this.stampExportPrivateKey = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/export_private_key";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Exports a Wallet
         *
         * Sign the provided `TExportWalletBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/export_wallet).
         *
         * See also {@link stampExportWallet}.
         */
        this.exportWallet = async (input) => {
            return this.request("/public/v1/submit/export_wallet", input);
        };
        /**
         * Produce a `SignedRequest` from `TExportWalletBody` by using the client's `stamp` function.
         *
         * See also {@link ExportWallet}.
         */
        this.stampExportWallet = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/export_wallet";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Exports a Wallet Account
         *
         * Sign the provided `TExportWalletAccountBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/export_wallet_account).
         *
         * See also {@link stampExportWalletAccount}.
         */
        this.exportWalletAccount = async (input) => {
            return this.request("/public/v1/submit/export_wallet_account", input);
        };
        /**
         * Produce a `SignedRequest` from `TExportWalletAccountBody` by using the client's `stamp` function.
         *
         * See also {@link ExportWalletAccount}.
         */
        this.stampExportWalletAccount = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/export_wallet_account";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Imports a private key
         *
         * Sign the provided `TImportPrivateKeyBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/import_private_key).
         *
         * See also {@link stampImportPrivateKey}.
         */
        this.importPrivateKey = async (input) => {
            return this.request("/public/v1/submit/import_private_key", input);
        };
        /**
         * Produce a `SignedRequest` from `TImportPrivateKeyBody` by using the client's `stamp` function.
         *
         * See also {@link ImportPrivateKey}.
         */
        this.stampImportPrivateKey = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/import_private_key";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Imports a wallet
         *
         * Sign the provided `TImportWalletBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/import_wallet).
         *
         * See also {@link stampImportWallet}.
         */
        this.importWallet = async (input) => {
            return this.request("/public/v1/submit/import_wallet", input);
        };
        /**
         * Produce a `SignedRequest` from `TImportWalletBody` by using the client's `stamp` function.
         *
         * See also {@link ImportWallet}.
         */
        this.stampImportWallet = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/import_wallet";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Initializes a new private key import
         *
         * Sign the provided `TInitImportPrivateKeyBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/init_import_private_key).
         *
         * See also {@link stampInitImportPrivateKey}.
         */
        this.initImportPrivateKey = async (input) => {
            return this.request("/public/v1/submit/init_import_private_key", input);
        };
        /**
         * Produce a `SignedRequest` from `TInitImportPrivateKeyBody` by using the client's `stamp` function.
         *
         * See also {@link InitImportPrivateKey}.
         */
        this.stampInitImportPrivateKey = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/init_import_private_key";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Initializes a new wallet import
         *
         * Sign the provided `TInitImportWalletBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/init_import_wallet).
         *
         * See also {@link stampInitImportWallet}.
         */
        this.initImportWallet = async (input) => {
            return this.request("/public/v1/submit/init_import_wallet", input);
        };
        /**
         * Produce a `SignedRequest` from `TInitImportWalletBody` by using the client's `stamp` function.
         *
         * See also {@link InitImportWallet}.
         */
        this.stampInitImportWallet = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/init_import_wallet";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Initiate an OTP auth activity
         *
         * Sign the provided `TInitOtpAuthBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/init_otp_auth).
         *
         * See also {@link stampInitOtpAuth}.
         */
        this.initOtpAuth = async (input) => {
            return this.request("/public/v1/submit/init_otp_auth", input);
        };
        /**
         * Produce a `SignedRequest` from `TInitOtpAuthBody` by using the client's `stamp` function.
         *
         * See also {@link InitOtpAuth}.
         */
        this.stampInitOtpAuth = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/init_otp_auth";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Initializes a new email recovery
         *
         * Sign the provided `TInitUserEmailRecoveryBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/init_user_email_recovery).
         *
         * See also {@link stampInitUserEmailRecovery}.
         */
        this.initUserEmailRecovery = async (input) => {
            return this.request("/public/v1/submit/init_user_email_recovery", input);
        };
        /**
         * Produce a `SignedRequest` from `TInitUserEmailRecoveryBody` by using the client's `stamp` function.
         *
         * See also {@link InitUserEmailRecovery}.
         */
        this.stampInitUserEmailRecovery = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/init_user_email_recovery";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Authenticate a user with an Oidc token (Oauth) - BETA
         *
         * Sign the provided `TOauthBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/oauth).
         *
         * See also {@link stampOauth}.
         */
        this.oauth = async (input) => {
            return this.request("/public/v1/submit/oauth", input);
        };
        /**
         * Produce a `SignedRequest` from `TOauthBody` by using the client's `stamp` function.
         *
         * See also {@link Oauth}.
         */
        this.stampOauth = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/oauth";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Authenticate a user with an OTP code sent via email or SMS
         *
         * Sign the provided `TOtpAuthBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/otp_auth).
         *
         * See also {@link stampOtpAuth}.
         */
        this.otpAuth = async (input) => {
            return this.request("/public/v1/submit/otp_auth", input);
        };
        /**
         * Produce a `SignedRequest` from `TOtpAuthBody` by using the client's `stamp` function.
         *
         * See also {@link OtpAuth}.
         */
        this.stampOtpAuth = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/otp_auth";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Completes the process of recovering a user by adding an authenticator
         *
         * Sign the provided `TRecoverUserBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/recover_user).
         *
         * See also {@link stampRecoverUser}.
         */
        this.recoverUser = async (input) => {
            return this.request("/public/v1/submit/recover_user", input);
        };
        /**
         * Produce a `SignedRequest` from `TRecoverUserBody` by using the client's `stamp` function.
         *
         * See also {@link RecoverUser}.
         */
        this.stampRecoverUser = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/recover_user";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Reject an Activity
         *
         * Sign the provided `TRejectActivityBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/reject_activity).
         *
         * See also {@link stampRejectActivity}.
         */
        this.rejectActivity = async (input) => {
            return this.request("/public/v1/submit/reject_activity", input);
        };
        /**
         * Produce a `SignedRequest` from `TRejectActivityBody` by using the client's `stamp` function.
         *
         * See also {@link RejectActivity}.
         */
        this.stampRejectActivity = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/reject_activity";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Removes an organization feature
         *
         * Sign the provided `TRemoveOrganizationFeatureBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/remove_organization_feature).
         *
         * See also {@link stampRemoveOrganizationFeature}.
         */
        this.removeOrganizationFeature = async (input) => {
            return this.request("/public/v1/submit/remove_organization_feature", input);
        };
        /**
         * Produce a `SignedRequest` from `TRemoveOrganizationFeatureBody` by using the client's `stamp` function.
         *
         * See also {@link RemoveOrganizationFeature}.
         */
        this.stampRemoveOrganizationFeature = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/remove_organization_feature";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Sets an organization feature
         *
         * Sign the provided `TSetOrganizationFeatureBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/set_organization_feature).
         *
         * See also {@link stampSetOrganizationFeature}.
         */
        this.setOrganizationFeature = async (input) => {
            return this.request("/public/v1/submit/set_organization_feature", input);
        };
        /**
         * Produce a `SignedRequest` from `TSetOrganizationFeatureBody` by using the client's `stamp` function.
         *
         * See also {@link SetOrganizationFeature}.
         */
        this.stampSetOrganizationFeature = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/set_organization_feature";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Sign a raw payload
         *
         * Sign the provided `TSignRawPayloadBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/sign_raw_payload).
         *
         * See also {@link stampSignRawPayload}.
         */
        this.signRawPayload = async (input) => {
            return this.request("/public/v1/submit/sign_raw_payload", input);
        };
        /**
         * Produce a `SignedRequest` from `TSignRawPayloadBody` by using the client's `stamp` function.
         *
         * See also {@link SignRawPayload}.
         */
        this.stampSignRawPayload = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/sign_raw_payload";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Sign multiple raw payloads with the same signing parameters
         *
         * Sign the provided `TSignRawPayloadsBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/sign_raw_payloads).
         *
         * See also {@link stampSignRawPayloads}.
         */
        this.signRawPayloads = async (input) => {
            return this.request("/public/v1/submit/sign_raw_payloads", input);
        };
        /**
         * Produce a `SignedRequest` from `TSignRawPayloadsBody` by using the client's `stamp` function.
         *
         * See also {@link SignRawPayloads}.
         */
        this.stampSignRawPayloads = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/sign_raw_payloads";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Sign a transaction
         *
         * Sign the provided `TSignTransactionBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/sign_transaction).
         *
         * See also {@link stampSignTransaction}.
         */
        this.signTransaction = async (input) => {
            return this.request("/public/v1/submit/sign_transaction", input);
        };
        /**
         * Produce a `SignedRequest` from `TSignTransactionBody` by using the client's `stamp` function.
         *
         * See also {@link SignTransaction}.
         */
        this.stampSignTransaction = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/sign_transaction";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Update an existing Policy
         *
         * Sign the provided `TUpdatePolicyBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/update_policy).
         *
         * See also {@link stampUpdatePolicy}.
         */
        this.updatePolicy = async (input) => {
            return this.request("/public/v1/submit/update_policy", input);
        };
        /**
         * Produce a `SignedRequest` from `TUpdatePolicyBody` by using the client's `stamp` function.
         *
         * See also {@link UpdatePolicy}.
         */
        this.stampUpdatePolicy = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/update_policy";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Update human-readable name or associated private keys. Note that this activity is atomic: all of the updates will succeed at once, or all of them will fail.
         *
         * Sign the provided `TUpdatePrivateKeyTagBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/update_private_key_tag).
         *
         * See also {@link stampUpdatePrivateKeyTag}.
         */
        this.updatePrivateKeyTag = async (input) => {
            return this.request("/public/v1/submit/update_private_key_tag", input);
        };
        /**
         * Produce a `SignedRequest` from `TUpdatePrivateKeyTagBody` by using the client's `stamp` function.
         *
         * See also {@link UpdatePrivateKeyTag}.
         */
        this.stampUpdatePrivateKeyTag = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/update_private_key_tag";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Set the threshold and members of the root quorum. This must be approved by the current root quorum.
         *
         * Sign the provided `TUpdateRootQuorumBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/update_root_quorum).
         *
         * See also {@link stampUpdateRootQuorum}.
         */
        this.updateRootQuorum = async (input) => {
            return this.request("/public/v1/submit/update_root_quorum", input);
        };
        /**
         * Produce a `SignedRequest` from `TUpdateRootQuorumBody` by using the client's `stamp` function.
         *
         * See also {@link UpdateRootQuorum}.
         */
        this.stampUpdateRootQuorum = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/update_root_quorum";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Update a User in an existing Organization
         *
         * Sign the provided `TUpdateUserBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/update_user).
         *
         * See also {@link stampUpdateUser}.
         */
        this.updateUser = async (input) => {
            return this.request("/public/v1/submit/update_user", input);
        };
        /**
         * Produce a `SignedRequest` from `TUpdateUserBody` by using the client's `stamp` function.
         *
         * See also {@link UpdateUser}.
         */
        this.stampUpdateUser = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/update_user";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        /**
         * Update human-readable name or associated users. Note that this activity is atomic: all of the updates will succeed at once, or all of them will fail.
         *
         * Sign the provided `TUpdateUserTagBody` with the client's `stamp` function, and submit the request (POST /public/v1/submit/update_user_tag).
         *
         * See also {@link stampUpdateUserTag}.
         */
        this.updateUserTag = async (input) => {
            return this.request("/public/v1/submit/update_user_tag", input);
        };
        /**
         * Produce a `SignedRequest` from `TUpdateUserTagBody` by using the client's `stamp` function.
         *
         * See also {@link UpdateUserTag}.
         */
        this.stampUpdateUserTag = async (input) => {
            const fullUrl = this.config.baseUrl + "/public/v1/submit/update_user_tag";
            const body = JSON.stringify(input);
            const stamp = await this.stamper.stamp(body);
            return {
                body: body,
                stamp: stamp,
                url: fullUrl,
            };
        };
        if (!config.baseUrl) {
            throw new Error(`Missing base URL. Please verify env vars.`);
        }
        this.config = config;
        this.stamper = stamper;
    }
    async request(url, body) {
        const fullUrl = this.config.baseUrl + url;
        const stringifiedBody = JSON.stringify(body);
        const stamp = await this.stamper.stamp(stringifiedBody);
        const response = await fetch$1(fullUrl, {
            method: "POST",
            headers: {
                [stamp.stampHeaderName]: stamp.stampHeaderValue,
                "X-Client-Version": VERSION$2,
            },
            body: stringifiedBody,
            redirect: "follow",
        });
        if (!response.ok) {
            let res;
            try {
                res = await response.json();
            }
            catch (_) {
                throw new Error(`${response.status} ${response.statusText}`);
            }
            throw new TurnkeyRequestError(res);
        }
        const data = await response.json();
        return data;
    }
}

let TurnkeyActivityError$1 = class TurnkeyActivityError extends Error {
    constructor(input) {
        const { message, cause, activityId, activityStatus, activityType } = input;
        super(message);
        this.name = "TurnkeyActivityError";
        this.activityId = activityId ?? undefined;
        this.activityStatus = activityStatus ?? undefined;
        this.activityType = activityType ?? undefined;
        this.cause = cause ?? undefined;
    }
};
class TurnkeyActivityConsensusNeededError extends Error {
    constructor(input) {
        const { message, cause, activityId, activityStatus, activityType } = input;
        super(message);
        this.name = "TurnkeyActivityConsensusNeededError";
        this.activityId = activityId ?? undefined;
        this.activityStatus = activityStatus ?? undefined;
        this.activityType = activityType ?? undefined;
        this.cause = cause ?? undefined;
    }
}
function assertActivityCompleted(activity) {
    const { id: activityId, status: activityStatus } = activity;
    if (activityStatus === "ACTIVITY_STATUS_CONSENSUS_NEEDED") {
        throw new TurnkeyActivityConsensusNeededError({
            message: "Activity requires consensus",
            activityId,
            activityStatus,
        });
    }
    if (activityStatus !== "ACTIVITY_STATUS_COMPLETED") {
        throw new TurnkeyActivityError$1({
            message: `Expected COMPLETED status, got ${activityStatus}`,
            activityId,
            activityStatus,
        });
    }
    return true;
}
function assertNonNull(input) {
    if (input == null) {
        throw new Error(`Got unexpected ${JSON.stringify(input)}`);
    }
    return input;
}

const base64UrlEncode = (challenge) => Buffer.from(challenge)
    .toString('base64')
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');

const generateRandomBuffer = () => {
    const arr = new Uint8Array(32);
    crypto.getRandomValues(arr);
    return arr.buffer;
};

const transportMap = {
    AUTHENTICATOR_TRANSPORT_BLE: AuthenticatorTransportProtocol.Ble,
    AUTHENTICATOR_TRANSPORT_HYBRID: AuthenticatorTransportProtocol.Hybrid,
    AUTHENTICATOR_TRANSPORT_INTERNAL: AuthenticatorTransportProtocol.Internal,
    AUTHENTICATOR_TRANSPORT_NFC: AuthenticatorTransportProtocol.Nfc,
    AUTHENTICATOR_TRANSPORT_USB: AuthenticatorTransportProtocol.Usb,
};
const convertAttestationTransports = (attestationTransports) => attestationTransports.map((transport) => transportMap[transport]);

const TURNKEY_API_BASE_URL = 'https://api.turnkey.com';
const TURNKEY_API_KEY_EXPIRY_MESSAGE = 'Turnkey error 16: expired api key';
const TURNKEY_API_KEY_NOT_FOUND_MESSAGE = 'Turnkey error 16: could not find public key';
const WEBAUTHN_NOT_SUPPORTED_OR_CANCELLED_ERROR_MESSAGE = 'The operation either timed out or was not allowed';
const WEBAUTHN_NOT_SUPPORTED_OR_DISABLED_ERROR_MESSAGE = 'The request is not allowed by the user agent or the platform in the current context, possibly because the user denied permission.';
const INVALID_PASSKEY_SELECTED_ERROR_MESSAGE = 'Turnkey error 5: webauthn authenticator not found in organization or parent organization';
const USER_CANCELLED_REQUEST_ERROR_MESSAGE = 'The user cancelled the request';
const TURNKEY_SDK_SESSION_KEY_RETRYABLE_ERRORS = [
    TURNKEY_API_KEY_EXPIRY_MESSAGE,
    TURNKEY_API_KEY_NOT_FOUND_MESSAGE,
];
const TURNKEY_SDK_BENIGN_ERRORS = [
    WEBAUTHN_NOT_SUPPORTED_OR_CANCELLED_ERROR_MESSAGE,
    WEBAUTHN_NOT_SUPPORTED_OR_DISABLED_ERROR_MESSAGE,
    INVALID_PASSKEY_SELECTED_ERROR_MESSAGE,
    USER_CANCELLED_REQUEST_ERROR_MESSAGE,
];

class DynamicEmbeddedWalletsLogger extends Logger$1 {
    constructor(name, level) {
        super(name, level);
    }
    error(message, ...args) {
        const [err] = args;
        if (!(err === null || err === void 0 ? void 0 : err.message) ||
            !TURNKEY_SDK_BENIGN_ERRORS.some((errorMsg) => err.message.includes(errorMsg))) {
            Logger$1.events.emit('error', message);
            this.log(LogLevel.ERROR, message, ...args);
        }
        else {
            // log benign turnkey sdk errors as WARN
            this.warn(message, ...args);
        }
    }
}
const logger$3 = new DynamicEmbeddedWalletsLogger('Dynamic embedded wallets', LogLevel.INFO);

/// <reference lib="dom" />
// Header name for an API key stamp
const stampHeaderName$1 = "X-Stamp";
// Set of constants for event types expected to be sent and received between a parent page and its iframe.
var IframeEventType;
(function (IframeEventType) {
    // Event sent by the iframe to its parent to indicate readiness.
    // Value: the iframe public key
    IframeEventType["PublicKeyReady"] = "PUBLIC_KEY_READY";
    // Event sent by the parent to inject a credential bundle (for recovery or auth) into the iframe.
    // Value: the bundle to inject
    IframeEventType["InjectCredentialBundle"] = "INJECT_CREDENTIAL_BUNDLE";
    // Event sent by the parent to inject a private key export bundle into the iframe.
    // Value: the bundle to inject
    // Key Format (optional): the key format to encode the private key in after it's exported and decrypted: HEXADECIMAL or SOLANA. Defaults to HEXADECIMAL.
    // Public Key (optional): the public key of the exported private key. Required when the key format is SOLANA.
    IframeEventType["InjectKeyExportBundle"] = "INJECT_KEY_EXPORT_BUNDLE";
    // Event sent by the parent to inject a wallet export bundle into the iframe.
    // Value: the bundle to inject
    IframeEventType["InjectWalletExportBundle"] = "INJECT_WALLET_EXPORT_BUNDLE";
    // Event sent by the parent to inject an import bundle into the iframe.
    // Value: the bundle to inject
    IframeEventType["InjectImportBundle"] = "INJECT_IMPORT_BUNDLE";
    // Event sent by the parent to extract an encrypted wallet bundle from the iframe.
    // Value: none
    IframeEventType["ExtractWalletEncryptedBundle"] = "EXTRACT_WALLET_ENCRYPTED_BUNDLE";
    // Event sent by the parent to extract an encrypted private key bundle from the iframe.
    // Value: none
    // Key Format (optional): the key format to decode the private key in before it's encrypted for import: HEXADECIMAL or SOLANA. Defaults to HEXADECIMAL.
    IframeEventType["ExtractKeyEncryptedBundle"] = "EXTRACT_KEY_ENCRYPTED_BUNDLE";
    // Event sent by the parent to apply settings on the iframe.
    // Value: the settings to apply in JSON string format.
    IframeEventType["ApplySettings"] = "APPLY_SETTINGS";
    // Event sent by the iframe to its parent when `InjectBundle` is successful
    // Value: true (boolean)
    IframeEventType["BundleInjected"] = "BUNDLE_INJECTED";
    // Event sent by the iframe to its parent when `ExtractEncryptedBundle` is successful
    // Value: the bundle encrypted in the iframe
    IframeEventType["EncryptedBundleExtracted"] = "ENCRYPTED_BUNDLE_EXTRACTED";
    // Event sent by the iframe to its parent when `ApplySettings` is successful
    // Value: true (boolean)
    IframeEventType["SettingsApplied"] = "SETTINGS_APPLIED";
    // Event sent by the parent page to request a signature
    // Value: payload to sign
    IframeEventType["StampRequest"] = "STAMP_REQUEST";
    // Event sent by the iframe to communicate the result of a stamp operation.
    // Value: signed payload
    IframeEventType["Stamp"] = "STAMP";
    // Event sent by the iframe to communicate an error
    // Value: serialized error
    IframeEventType["Error"] = "ERROR";
})(IframeEventType || (IframeEventType = {}));
// Set of constants for private key formats. These formats map to the encoding type used on a private key before encrypting and importing it
// or after exporting it and decrypting it.
var KeyFormat;
(function (KeyFormat) {
    // 64 hexadecimal digits. Key format used by MetaMask, MyEtherWallet, Phantom, Ledger, and Trezor for Ethereum and Tron keys
    KeyFormat["Hexadecimal"] = "HEXADECIMAL";
    // Key format used by Phantom and Solflare for Solana keys
    KeyFormat["Solana"] = "SOLANA";
})(KeyFormat || (KeyFormat = {}));
/**
 * Stamper to use with `@turnkey/http`'s `TurnkeyClient`
 * Creating a stamper inserts an iframe in the current page.
 */
class IframeStamper {
    /**
     * Creates a new iframe stamper. This function _does not_ insert the iframe in the DOM.
     * Call `.init()` to insert the iframe element in the DOM.
     */
    constructor(config) {
        if (typeof window === "undefined") {
            throw new Error("Cannot initialize iframe in non-browser environment");
        }
        if (!config.iframeContainer) {
            throw new Error("Iframe container cannot be found");
        }
        this.container = config.iframeContainer;
        if (this.container.querySelector(`#${config.iframeElementId}`)) {
            throw new Error(`Iframe element with ID ${config.iframeElementId} already exists`);
        }
        let iframe = window.document.createElement("iframe");
        // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#sandbox
        // We do not need any other permission than running scripts for import/export/auth frames.
        iframe.setAttribute("sandbox", "allow-scripts allow-same-origin");
        iframe.id = config.iframeElementId;
        iframe.src = config.iframeUrl;
        this.iframe = iframe;
        const iframeUrl = new URL(config.iframeUrl);
        this.iframeOrigin = iframeUrl.origin;
        // This is populated once the iframe is ready. Call `.init()` to kick off DOM insertion!
        this.iframePublicKey = null;
    }
    /**
     * Inserts the iframe on the page and returns a promise resolving to the iframe's public key
     */
    async init() {
        this.container.appendChild(this.iframe);
        return new Promise((resolve, _reject) => {
            window.addEventListener("message", (event) => {
                if (event.origin !== this.iframeOrigin) {
                    // There might be other things going on in the window, for example: react dev tools, other extensions, etc.
                    // Instead of erroring out
                    return;
                }
                if (event.data?.type === IframeEventType.PublicKeyReady) {
                    this.iframePublicKey = event.data["value"];
                    resolve(event.data["value"]);
                }
            }, false);
        });
    }
    /**
     * Removes the iframe from the DOM
     */
    clear() {
        this.iframe.remove();
    }
    /**
     * Returns the public key, or `null` if the underlying iframe isn't properly initialized.
     */
    publicKey() {
        return this.iframePublicKey;
    }
    /**
     * Function to inject a new credential into the iframe
     * The bundle should be encrypted to the iframe's initial public key
     * Encryption should be performed with HPKE (RFC 9180).
     * This is used during recovery and auth flows.
     */
    async injectCredentialBundle(bundle) {
        return new Promise((resolve, reject) => {
            this.iframe.contentWindow?.postMessage({
                type: IframeEventType.InjectCredentialBundle,
                value: bundle,
            }, "*");
            window.addEventListener("message", (event) => {
                if (event.origin !== this.iframeOrigin) {
                    // There might be other things going on in the window, for example: react dev tools, other extensions, etc.
                    // Instead of erroring out we simply return. Not our event!
                    return;
                }
                if (event.data?.type === IframeEventType.BundleInjected) {
                    resolve(event.data["value"]);
                }
                if (event.data?.type === IframeEventType.Error) {
                    reject(event.data["value"]);
                }
            }, false);
        });
    }
    /**
     * Function to inject an export bundle into the iframe
     * The bundle should be encrypted to the iframe's initial public key
     * Encryption should be performed with HPKE (RFC 9180).
     * The key format to encode the private key in after it's exported and decrypted: HEXADECIMAL or SOLANA. Defaults to HEXADECIMAL.
     * This is used during the private key export flow.
     */
    async injectKeyExportBundle(bundle, organizationId, keyFormat) {
        this.iframe.contentWindow?.postMessage({
            type: IframeEventType.InjectKeyExportBundle,
            value: bundle,
            keyFormat,
            organizationId,
        }, "*");
        return new Promise((resolve, reject) => {
            window.addEventListener("message", (event) => {
                if (event.origin !== this.iframeOrigin) {
                    // There might be other things going on in the window, for example: react dev tools, other extensions, etc.
                    // Instead of erroring out we simply return. Not our event!
                    return;
                }
                if (event.data?.type === IframeEventType.BundleInjected) {
                    resolve(event.data["value"]);
                }
                if (event.data?.type === IframeEventType.Error) {
                    reject(event.data["value"]);
                }
            }, false);
        });
    }
    /**
     * Function to inject an export bundle into the iframe
     * The bundle should be encrypted to the iframe's initial public key
     * Encryption should be performed with HPKE (RFC 9180).
     * This is used during the wallet export flow.
     */
    async injectWalletExportBundle(bundle, organizationId) {
        this.iframe.contentWindow?.postMessage({
            type: IframeEventType.InjectWalletExportBundle,
            value: bundle,
            organizationId,
        }, "*");
        return new Promise((resolve, reject) => {
            window.addEventListener("message", (event) => {
                if (event.origin !== this.iframeOrigin) {
                    // There might be other things going on in the window, for example: react dev tools, other extensions, etc.
                    // Instead of erroring out we simply return. Not our event!
                    return;
                }
                if (event.data?.type === IframeEventType.BundleInjected) {
                    resolve(event.data["value"]);
                }
                if (event.data?.type === IframeEventType.Error) {
                    reject(event.data["value"]);
                }
            }, false);
        });
    }
    /**
     * Function to inject an import bundle into the iframe
     * This is used to initiate either the wallet import flow or the private key import flow.
     */
    async injectImportBundle(bundle, organizationId, userId) {
        this.iframe.contentWindow?.postMessage({
            type: IframeEventType.InjectImportBundle,
            value: bundle,
            organizationId,
            userId,
        }, "*");
        return new Promise((resolve, reject) => {
            window.addEventListener("message", (event) => {
                if (event.origin !== this.iframeOrigin) {
                    // There might be other things going on in the window, for example: react dev tools, other extensions, etc.
                    // Instead of erroring out we simply return. Not our event!
                    return;
                }
                if (event.data?.type === IframeEventType.BundleInjected) {
                    resolve(event.data["value"]);
                }
                if (event.data?.type === IframeEventType.Error) {
                    reject(event.data["value"]);
                }
            }, false);
        });
    }
    /**
     * Function to extract an encrypted bundle from the iframe
     * The bundle should be encrypted to Turnkey's Signer enclave's initial public key
     * Encryption should be performed with HPKE (RFC 9180).
     * This is used during the wallet import flow.
     */
    async extractWalletEncryptedBundle() {
        this.iframe.contentWindow?.postMessage({
            type: IframeEventType.ExtractWalletEncryptedBundle,
        }, "*");
        return new Promise((resolve, reject) => {
            window.addEventListener("message", (event) => {
                if (event.origin !== this.iframeOrigin) {
                    // There might be other things going on in the window, for example: react dev tools, other extensions, etc.
                    // Instead of erroring out we simply return. Not our event!
                    return;
                }
                if (event.data?.type === IframeEventType.EncryptedBundleExtracted) {
                    resolve(event.data["value"]);
                }
                if (event.data?.type === IframeEventType.Error) {
                    reject(event.data["value"]);
                }
            }, false);
        });
    }
    /**
     * Function to extract an encrypted bundle from the iframe
     * The bundle should be encrypted to Turnkey's Signer enclave's initial public key
     * Encryption should be performed with HPKE (RFC 9180).
     * The key format to encode the private key in before it's encrypted and imported: HEXADECIMAL or SOLANA. Defaults to HEXADECIMAL.
     * This is used during the private key import flow.
     */
    async extractKeyEncryptedBundle(keyFormat) {
        this.iframe.contentWindow?.postMessage({
            type: IframeEventType.ExtractKeyEncryptedBundle,
            keyFormat: keyFormat,
        }, "*");
        return new Promise((resolve, reject) => {
            window.addEventListener("message", (event) => {
                if (event.origin !== this.iframeOrigin) {
                    // There might be other things going on in the window, for example: react dev tools, other extensions, etc.
                    // Instead of erroring out we simply return. Not our event!
                    return;
                }
                if (event.data?.type === IframeEventType.EncryptedBundleExtracted) {
                    resolve(event.data["value"]);
                }
                if (event.data?.type === IframeEventType.Error) {
                    reject(event.data["value"]);
                }
            }, false);
        });
    }
    /**
     * Function to apply settings on allowed parameters in the iframe
     * This is used to style the HTML element used for plaintext in wallet and private key import.
     */
    async applySettings(settings) {
        const settingsStr = JSON.stringify(settings);
        this.iframe.contentWindow?.postMessage({
            type: IframeEventType.ApplySettings,
            value: settingsStr,
        }, "*");
        return new Promise((resolve, reject) => {
            window.addEventListener("message", (event) => {
                if (event.origin !== this.iframeOrigin) {
                    // There might be other things going on in the window, for example: react dev tools, other extensions, etc.
                    // Instead of erroring out we simply return. Not our event!
                    return;
                }
                if (event.data?.type === IframeEventType.SettingsApplied) {
                    resolve(event.data["value"]);
                }
                if (event.data?.type === IframeEventType.Error) {
                    reject(event.data["value"]);
                }
            }, false);
        });
    }
    /**
     * Function to sign a payload with the underlying iframe
     */
    async stamp(payload) {
        if (this.iframePublicKey === null) {
            throw new Error("null iframe public key. Have you called/awaited .init()?");
        }
        const iframeOrigin = this.iframeOrigin;
        this.iframe.contentWindow?.postMessage({
            type: IframeEventType.StampRequest,
            value: payload,
        }, "*");
        return new Promise(function (resolve, reject) {
            window.addEventListener("message", (event) => {
                if (event.origin !== iframeOrigin) {
                    // There might be other things going on in the window, for example: react dev tools, other extensions, etc.
                    // Instead of erroring out we simply return. Not our event!
                    return;
                }
                if (event.data?.type === IframeEventType.Stamp) {
                    resolve({
                        stampHeaderName: stampHeaderName$1,
                        stampHeaderValue: event.data["value"],
                    });
                }
                if (event.data?.type === IframeEventType.Error) {
                    reject(event.data["value"]);
                }
            }, false);
        });
    }
}

function bufferToBase64url(buffer) {
    // Buffer to binary string
    const byteView = new Uint8Array(buffer);
    let str = "";
    for (const charCode of byteView) {
        str += String.fromCharCode(charCode);
    }
    // Binary string to base64
    const base64String = btoa(str);
    // Base64 to base64url
    // We assume that the base64url string is well-formed.
    const base64urlString = base64String
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=/g, "");
    return base64urlString;
}

// We export these values in order so that they can be used to deduplicate
// schema definitions in minified JS code.
// TODO: Parcel isn't deduplicating these values.
const copyValue = "copy";
const convertValue = "convert";
function convert(conversionFn, schema, input) {
    if (schema === copyValue) {
        return input;
    }
    if (schema === convertValue) {
        return conversionFn(input);
    }
    if (schema instanceof Array) {
        return input.map((v) => convert(conversionFn, schema[0], v));
    }
    if (schema instanceof Object) {
        const output = {};
        for (const [key, schemaField] of Object.entries(schema)) {
            if (schemaField.derive) {
                const v = schemaField.derive(input);
                if (v !== undefined) {
                    input[key] = v;
                }
            }
            if (!(key in input)) {
                if (schemaField.required) {
                    throw new Error(`Missing key: ${key}`);
                }
                continue;
            }
            // Fields can be null (rather than missing or `undefined`), e.g. the
            // `userHandle` field of the `AuthenticatorAssertionResponse`:
            // https://www.w3.org/TR/webauthn/#iface-authenticatorassertionresponse
            if (input[key] == null) {
                output[key] = null;
                continue;
            }
            output[key] = convert(conversionFn, schemaField.schema, input[key]);
        }
        return output;
    }
}
function derived(schema, derive) {
    return {
        required: true,
        schema,
        derive,
    };
}
function required(schema) {
    return {
        required: true,
        schema,
    };
}
function optional(schema) {
    return {
        required: false,
        schema,
    };
}

const simplifiedClientExtensionResultsSchema = {
    appid: optional(copyValue),
    appidExclude: optional(copyValue),
    credProps: optional(copyValue),
};
// `navigator.get()` response
const publicKeyCredentialWithAssertion = {
    type: required(copyValue),
    id: required(copyValue),
    rawId: required(convertValue),
    authenticatorAttachment: optional(copyValue),
    response: required({
        clientDataJSON: required(convertValue),
        authenticatorData: required(convertValue),
        signature: required(convertValue),
        userHandle: required(convertValue),
    }),
    clientExtensionResults: derived(simplifiedClientExtensionResultsSchema, (pkc) => pkc.getClientExtensionResults()),
};

function getResponseToJSON(credential) {
    return convert(bufferToBase64url, publicKeyCredentialWithAssertion, credential);
}

async function get$1(options) {
    const response = (await navigator.credentials.get(options));
    response.toJSON = () => getResponseToJSON(response);
    return response;
}

/**
 * sha256-uint8array.ts
 */
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311
const K = [
    0x428a2f98 | 0, 0x71374491 | 0, 0xb5c0fbcf | 0, 0xe9b5dba5 | 0,
    0x3956c25b | 0, 0x59f111f1 | 0, 0x923f82a4 | 0, 0xab1c5ed5 | 0,
    0xd807aa98 | 0, 0x12835b01 | 0, 0x243185be | 0, 0x550c7dc3 | 0,
    0x72be5d74 | 0, 0x80deb1fe | 0, 0x9bdc06a7 | 0, 0xc19bf174 | 0,
    0xe49b69c1 | 0, 0xefbe4786 | 0, 0x0fc19dc6 | 0, 0x240ca1cc | 0,
    0x2de92c6f | 0, 0x4a7484aa | 0, 0x5cb0a9dc | 0, 0x76f988da | 0,
    0x983e5152 | 0, 0xa831c66d | 0, 0xb00327c8 | 0, 0xbf597fc7 | 0,
    0xc6e00bf3 | 0, 0xd5a79147 | 0, 0x06ca6351 | 0, 0x14292967 | 0,
    0x27b70a85 | 0, 0x2e1b2138 | 0, 0x4d2c6dfc | 0, 0x53380d13 | 0,
    0x650a7354 | 0, 0x766a0abb | 0, 0x81c2c92e | 0, 0x92722c85 | 0,
    0xa2bfe8a1 | 0, 0xa81a664b | 0, 0xc24b8b70 | 0, 0xc76c51a3 | 0,
    0xd192e819 | 0, 0xd6990624 | 0, 0xf40e3585 | 0, 0x106aa070 | 0,
    0x19a4c116 | 0, 0x1e376c08 | 0, 0x2748774c | 0, 0x34b0bcb5 | 0,
    0x391c0cb3 | 0, 0x4ed8aa4a | 0, 0x5b9cca4f | 0, 0x682e6ff3 | 0,
    0x748f82ee | 0, 0x78a5636f | 0, 0x84c87814 | 0, 0x8cc70208 | 0,
    0x90befffa | 0, 0xa4506ceb | 0, 0xbef9a3f7 | 0, 0xc67178f2 | 0,
];
function createHash(algorithm) {
    return new Hash$1();
}
let Hash$1 = class Hash {
    constructor() {
        // first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
        this.A = 0x6a09e667 | 0;
        this.B = 0xbb67ae85 | 0;
        this.C = 0x3c6ef372 | 0;
        this.D = 0xa54ff53a | 0;
        this.E = 0x510e527f | 0;
        this.F = 0x9b05688c | 0;
        this.G = 0x1f83d9ab | 0;
        this.H = 0x5be0cd19 | 0;
        this._size = 0;
        this._sp = 0; // surrogate pair
        if (!sharedBuffer || sharedOffset >= 8000 /* N.allocTotal */) {
            sharedBuffer = new ArrayBuffer(8000 /* N.allocTotal */);
            sharedOffset = 0;
        }
        this._byte = new Uint8Array(sharedBuffer, sharedOffset, 80 /* N.allocBytes */);
        this._word = new Int32Array(sharedBuffer, sharedOffset, 20 /* N.allocWords */);
        sharedOffset += 80 /* N.allocBytes */;
    }
    update(data) {
        // data: string
        if ("string" === typeof data) {
            return this._utf8(data);
        }
        // data: undefined
        if (data == null) {
            throw new TypeError("Invalid type: " + typeof data);
        }
        const byteOffset = data.byteOffset;
        const length = data.byteLength;
        let blocks = (length / 64 /* N.inputBytes */) | 0;
        let offset = 0;
        // longer than 1 block
        if (blocks && !(byteOffset & 3) && !(this._size % 64 /* N.inputBytes */)) {
            const block = new Int32Array(data.buffer, byteOffset, blocks * 16 /* N.inputWords */);
            while (blocks--) {
                this._int32(block, offset >> 2);
                offset += 64 /* N.inputBytes */;
            }
            this._size += offset;
        }
        // data: TypedArray | DataView
        const BYTES_PER_ELEMENT = data.BYTES_PER_ELEMENT;
        if (BYTES_PER_ELEMENT !== 1 && data.buffer) {
            const rest = new Uint8Array(data.buffer, byteOffset + offset, length - offset);
            return this._uint8(rest);
        }
        // no more bytes
        if (offset === length)
            return this;
        // data: Uint8Array | Int8Array
        return this._uint8(data, offset);
    }
    _uint8(data, offset) {
        const { _byte, _word } = this;
        const length = data.length;
        offset = offset | 0;
        while (offset < length) {
            const start = this._size % 64 /* N.inputBytes */;
            let index = start;
            while (offset < length && index < 64 /* N.inputBytes */) {
                _byte[index++] = data[offset++];
            }
            if (index >= 64 /* N.inputBytes */) {
                this._int32(_word);
            }
            this._size += index - start;
        }
        return this;
    }
    _utf8(text) {
        const { _byte, _word } = this;
        const length = text.length;
        let surrogate = this._sp;
        for (let offset = 0; offset < length;) {
            const start = this._size % 64 /* N.inputBytes */;
            let index = start;
            while (offset < length && index < 64 /* N.inputBytes */) {
                let code = text.charCodeAt(offset++) | 0;
                if (code < 0x80) {
                    // ASCII characters
                    _byte[index++] = code;
                }
                else if (code < 0x800) {
                    // 2 bytes
                    _byte[index++] = 0xC0 | (code >>> 6);
                    _byte[index++] = 0x80 | (code & 0x3F);
                }
                else if (code < 0xD800 || code > 0xDFFF) {
                    // 3 bytes
                    _byte[index++] = 0xE0 | (code >>> 12);
                    _byte[index++] = 0x80 | ((code >>> 6) & 0x3F);
                    _byte[index++] = 0x80 | (code & 0x3F);
                }
                else if (surrogate) {
                    // 4 bytes - surrogate pair
                    code = ((surrogate & 0x3FF) << 10) + (code & 0x3FF) + 0x10000;
                    _byte[index++] = 0xF0 | (code >>> 18);
                    _byte[index++] = 0x80 | ((code >>> 12) & 0x3F);
                    _byte[index++] = 0x80 | ((code >>> 6) & 0x3F);
                    _byte[index++] = 0x80 | (code & 0x3F);
                    surrogate = 0;
                }
                else {
                    surrogate = code;
                }
            }
            if (index >= 64 /* N.inputBytes */) {
                this._int32(_word);
                _word[0] = _word[16 /* N.inputWords */];
            }
            this._size += index - start;
        }
        this._sp = surrogate;
        return this;
    }
    _int32(data, offset) {
        let { A, B, C, D, E, F, G, H } = this;
        let i = 0;
        offset = offset | 0;
        while (i < 16 /* N.inputWords */) {
            W$1[i++] = swap32(data[offset++]);
        }
        for (i = 16 /* N.inputWords */; i < 64 /* N.workWords */; i++) {
            W$1[i] = (gamma1(W$1[i - 2]) + W$1[i - 7] + gamma0(W$1[i - 15]) + W$1[i - 16]) | 0;
        }
        for (i = 0; i < 64 /* N.workWords */; i++) {
            const T1 = (H + sigma1(E) + ch(E, F, G) + K[i] + W$1[i]) | 0;
            const T2 = (sigma0(A) + maj(A, B, C)) | 0;
            H = G;
            G = F;
            F = E;
            E = (D + T1) | 0;
            D = C;
            C = B;
            B = A;
            A = (T1 + T2) | 0;
        }
        this.A = (A + this.A) | 0;
        this.B = (B + this.B) | 0;
        this.C = (C + this.C) | 0;
        this.D = (D + this.D) | 0;
        this.E = (E + this.E) | 0;
        this.F = (F + this.F) | 0;
        this.G = (G + this.G) | 0;
        this.H = (H + this.H) | 0;
    }
    digest(encoding) {
        const { _byte, _word } = this;
        let i = (this._size % 64 /* N.inputBytes */) | 0;
        _byte[i++] = 0x80;
        // pad 0 for current word
        while (i & 3) {
            _byte[i++] = 0;
        }
        i >>= 2;
        if (i > 14 /* N.highIndex */) {
            while (i < 16 /* N.inputWords */) {
                _word[i++] = 0;
            }
            i = 0;
            this._int32(_word);
        }
        // pad 0 for rest words
        while (i < 16 /* N.inputWords */) {
            _word[i++] = 0;
        }
        // input size
        const bits64 = this._size * 8;
        const low32 = (bits64 & 0xffffffff) >>> 0;
        const high32 = (bits64 - low32) / 0x100000000;
        if (high32)
            _word[14 /* N.highIndex */] = swap32(high32);
        if (low32)
            _word[15 /* N.lowIndex */] = swap32(low32);
        this._int32(_word);
        return (encoding === "hex") ? this._hex() : this._bin();
    }
    _hex() {
        const { A, B, C, D, E, F, G, H } = this;
        return hex32(A) + hex32(B) + hex32(C) + hex32(D) + hex32(E) + hex32(F) + hex32(G) + hex32(H);
    }
    _bin() {
        const { A, B, C, D, E, F, G, H, _byte, _word } = this;
        _word[0] = swap32(A);
        _word[1] = swap32(B);
        _word[2] = swap32(C);
        _word[3] = swap32(D);
        _word[4] = swap32(E);
        _word[5] = swap32(F);
        _word[6] = swap32(G);
        _word[7] = swap32(H);
        return _byte.slice(0, 32);
    }
};
const W$1 = new Int32Array(64 /* N.workWords */);
let sharedBuffer;
let sharedOffset = 0;
const hex32 = num => (num + 0x100000000).toString(16).substr(-8);
const swapLE = (c => (((c << 24) & 0xff000000) | ((c << 8) & 0xff0000) | ((c >> 8) & 0xff00) | ((c >> 24) & 0xff)));
const swapBE = (c => c);
const swap32 = isBE() ? swapBE : swapLE;
const ch = (x, y, z) => (z ^ (x & (y ^ z)));
const maj = (x, y, z) => ((x & y) | (z & (x | y)));
const sigma0 = x => ((x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10));
const sigma1 = x => ((x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7));
const gamma0 = x => ((x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3));
const gamma1 = x => ((x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10));
function isBE() {
    const buf = new Uint8Array(new Uint16Array([0xFEFF]).buffer); // BOM
    return (buf[0] === 0xFE);
}

/// <reference lib="dom" />
// Header name for a webauthn stamp
const stampHeaderName = "X-Stamp-Webauthn";
const defaultTimeout = 5 * 60 * 1000; // five minutes
const defaultUserVerification = "preferred";
/**
 * Stamper to use with `@turnkey/http`'s `TurnkeyClient`
 */
class WebauthnStamper {
    constructor(config) {
        this.rpId = config.rpId;
        this.timeout = config.timeout || defaultTimeout;
        this.userVerification = config.userVerification || defaultUserVerification;
        this.allowCredentials = config.allowCredentials || [];
    }
    async stamp(payload) {
        const challenge = getChallengeFromPayload(payload);
        const signingOptions = {
            publicKey: {
                rpId: this.rpId,
                challenge: challenge,
                allowCredentials: this.allowCredentials,
                timeout: this.timeout,
                userVerification: this.userVerification,
            },
        };
        const clientGetResult = await get$1(signingOptions);
        const assertion = clientGetResult.toJSON();
        const stamp = {
            authenticatorData: assertion.response.authenticatorData,
            clientDataJson: assertion.response.clientDataJSON,
            credentialId: assertion.id,
            signature: assertion.response.signature,
        };
        return {
            stampHeaderName: stampHeaderName,
            stampHeaderValue: JSON.stringify(stamp),
        };
    }
}
function getChallengeFromPayload(payload) {
    const hexString = createHash().update(payload).digest("hex");
    return new TextEncoder().encode(hexString);
}

var version$5 = "4.6.1";

class WebauthnNotSupportedError extends Error {
    constructor() {
        super('Webauthn is not supported on this device');
    }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter$3(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/* [@simplewebauthn/browser@9.0.1] */
function utf8StringToBuffer(value) {
    return new TextEncoder().encode(value);
}

function bufferToBase64URLString(buffer) {
    const bytes = new Uint8Array(buffer);
    let str = '';
    for (const charCode of bytes) {
        str += String.fromCharCode(charCode);
    }
    const base64String = btoa(str);
    return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

function base64URLStringToBuffer(base64URLString) {
    const base64 = base64URLString.replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - (base64.length % 4)) % 4;
    const padded = base64.padEnd(base64.length + padLength, '=');
    const binary = atob(padded);
    const buffer = new ArrayBuffer(binary.length);
    const bytes = new Uint8Array(buffer);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return buffer;
}

function browserSupportsWebAuthn() {
    return (window?.PublicKeyCredential !== undefined &&
        typeof window.PublicKeyCredential === 'function');
}

function toPublicKeyCredentialDescriptor(descriptor) {
    const { id } = descriptor;
    return {
        ...descriptor,
        id: base64URLStringToBuffer(id),
        transports: descriptor.transports,
    };
}

function isValidDomain(hostname) {
    return (hostname === 'localhost' ||
        /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname));
}

class WebAuthnError extends Error {
    constructor({ message, code, cause, name, }) {
        super(message, { cause });
        this.name = name ?? cause.name;
        this.code = code;
    }
}

function identifyRegistrationError({ error, options, }) {
    const { publicKey } = options;
    if (!publicKey) {
        throw Error('options was missing required publicKey property');
    }
    if (error.name === 'AbortError') {
        if (options.signal instanceof AbortSignal) {
            return new WebAuthnError({
                message: 'Registration ceremony was sent an abort signal',
                code: 'ERROR_CEREMONY_ABORTED',
                cause: error,
            });
        }
    }
    else if (error.name === 'ConstraintError') {
        if (publicKey.authenticatorSelection?.requireResidentKey === true) {
            return new WebAuthnError({
                message: 'Discoverable credentials were required but no available authenticator supported it',
                code: 'ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT',
                cause: error,
            });
        }
        else if (publicKey.authenticatorSelection?.userVerification === 'required') {
            return new WebAuthnError({
                message: 'User verification was required but no available authenticator supported it',
                code: 'ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT',
                cause: error,
            });
        }
    }
    else if (error.name === 'InvalidStateError') {
        return new WebAuthnError({
            message: 'The authenticator was previously registered',
            code: 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED',
            cause: error,
        });
    }
    else if (error.name === 'NotAllowedError') {
        return new WebAuthnError({
            message: error.message,
            code: 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY',
            cause: error,
        });
    }
    else if (error.name === 'NotSupportedError') {
        const validPubKeyCredParams = publicKey.pubKeyCredParams.filter((param) => param.type === 'public-key');
        if (validPubKeyCredParams.length === 0) {
            return new WebAuthnError({
                message: 'No entry in pubKeyCredParams was of type "public-key"',
                code: 'ERROR_MALFORMED_PUBKEYCREDPARAMS',
                cause: error,
            });
        }
        return new WebAuthnError({
            message: 'No available authenticator supported any of the specified pubKeyCredParams algorithms',
            code: 'ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG',
            cause: error,
        });
    }
    else if (error.name === 'SecurityError') {
        const effectiveDomain = window.location.hostname;
        if (!isValidDomain(effectiveDomain)) {
            return new WebAuthnError({
                message: `${window.location.hostname} is an invalid domain`,
                code: 'ERROR_INVALID_DOMAIN',
                cause: error,
            });
        }
        else if (publicKey.rp.id !== effectiveDomain) {
            return new WebAuthnError({
                message: `The RP ID "${publicKey.rp.id}" is invalid for this domain`,
                code: 'ERROR_INVALID_RP_ID',
                cause: error,
            });
        }
    }
    else if (error.name === 'TypeError') {
        if (publicKey.user.id.byteLength < 1 || publicKey.user.id.byteLength > 64) {
            return new WebAuthnError({
                message: 'User ID was not between 1 and 64 characters',
                code: 'ERROR_INVALID_USER_ID_LENGTH',
                cause: error,
            });
        }
    }
    else if (error.name === 'UnknownError') {
        return new WebAuthnError({
            message: 'The authenticator was unable to process the specified options, or could not create a new credential',
            code: 'ERROR_AUTHENTICATOR_GENERAL_ERROR',
            cause: error,
        });
    }
    return error;
}

class BaseWebAuthnAbortService {
    createNewAbortSignal() {
        if (this.controller) {
            const abortError = new Error('Cancelling existing WebAuthn API call for new one');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
        }
        const newController = new AbortController();
        this.controller = newController;
        return newController.signal;
    }
    cancelCeremony() {
        if (this.controller) {
            const abortError = new Error('Manually cancelling existing WebAuthn API call');
            abortError.name = 'AbortError';
            this.controller.abort(abortError);
            this.controller = undefined;
        }
    }
}
const WebAuthnAbortService = new BaseWebAuthnAbortService();

const attachments = ['cross-platform', 'platform'];
function toAuthenticatorAttachment(attachment) {
    if (!attachment) {
        return;
    }
    if (attachments.indexOf(attachment) < 0) {
        return;
    }
    return attachment;
}

async function startRegistration(creationOptionsJSON) {
    if (!browserSupportsWebAuthn()) {
        throw new Error('WebAuthn is not supported in this browser');
    }
    const publicKey = {
        ...creationOptionsJSON,
        challenge: base64URLStringToBuffer(creationOptionsJSON.challenge),
        user: {
            ...creationOptionsJSON.user,
            id: utf8StringToBuffer(creationOptionsJSON.user.id),
        },
        excludeCredentials: creationOptionsJSON.excludeCredentials?.map(toPublicKeyCredentialDescriptor),
    };
    const options = { publicKey };
    options.signal = WebAuthnAbortService.createNewAbortSignal();
    let credential;
    try {
        credential = (await navigator.credentials.create(options));
    }
    catch (err) {
        throw identifyRegistrationError({ error: err, options });
    }
    if (!credential) {
        throw new Error('Registration was not completed');
    }
    const { id, rawId, response, type } = credential;
    let transports = undefined;
    if (typeof response.getTransports === 'function') {
        transports = response.getTransports();
    }
    let responsePublicKeyAlgorithm = undefined;
    if (typeof response.getPublicKeyAlgorithm === 'function') {
        try {
            responsePublicKeyAlgorithm = response.getPublicKeyAlgorithm();
        }
        catch (error) {
            warnOnBrokenImplementation('getPublicKeyAlgorithm()', error);
        }
    }
    let responsePublicKey = undefined;
    if (typeof response.getPublicKey === 'function') {
        try {
            const _publicKey = response.getPublicKey();
            if (_publicKey !== null) {
                responsePublicKey = bufferToBase64URLString(_publicKey);
            }
        }
        catch (error) {
            warnOnBrokenImplementation('getPublicKey()', error);
        }
    }
    let responseAuthenticatorData;
    if (typeof response.getAuthenticatorData === 'function') {
        try {
            responseAuthenticatorData = bufferToBase64URLString(response.getAuthenticatorData());
        }
        catch (error) {
            warnOnBrokenImplementation('getAuthenticatorData()', error);
        }
    }
    return {
        id,
        rawId: bufferToBase64URLString(rawId),
        response: {
            attestationObject: bufferToBase64URLString(response.attestationObject),
            clientDataJSON: bufferToBase64URLString(response.clientDataJSON),
            transports,
            publicKeyAlgorithm: responsePublicKeyAlgorithm,
            publicKey: responsePublicKey,
            authenticatorData: responseAuthenticatorData,
        },
        type,
        clientExtensionResults: credential.getClientExtensionResults(),
        authenticatorAttachment: toAuthenticatorAttachment(credential.authenticatorAttachment),
    };
}
function warnOnBrokenImplementation(methodName, cause) {
    console.warn(`The browser extension that intercepted this WebAuthn API call incorrectly implemented ${methodName}. You should report this error to them.\n`, cause);
}

const logger$2 = new Logger$1('Webauthn');

const createWebauthnCredential = (options) => __awaiter$3(void 0, void 0, void 0, function* () {
    if (!browserSupportsWebAuthn()) {
        throw new WebauthnNotSupportedError();
    }
    let attestationResp;
    try {
        attestationResp = yield startRegistration(options);
    }
    catch (error) {
        logger$2.debug('Failed to create webauthn credential', error);
        throw error;
    }
    return attestationResp;
});

const convertTransportEnumToTurnkeyEnum = (transportEnum) => {
    switch (transportEnum) {
        case 'internal': {
            return 'AUTHENTICATOR_TRANSPORT_INTERNAL';
        }
        case 'usb': {
            return 'AUTHENTICATOR_TRANSPORT_USB';
        }
        case 'nfc': {
            return 'AUTHENTICATOR_TRANSPORT_NFC';
        }
        case 'ble': {
            return 'AUTHENTICATOR_TRANSPORT_BLE';
        }
        case 'hybrid': {
            return 'AUTHENTICATOR_TRANSPORT_HYBRID';
        }
        default: {
            throw new Error('unsupported transport format ' + transportEnum);
        }
    }
};

// As part of migrating off of turnkey for passkeys, swap out the turnkey implementation of this
// with our own. Next we should move the PasskeyService out of embedded-wallets in favor of purely in
// the `passkey` package GVTY-2169
// for now continue to use the turnkey input and output types here to not make any breaking changes.
// input: turnkey type => convert to our type => create attestation => output: converted to turnkey type
const getWebAuthnAttestationTurnkeyAdapter = (options) => __awaiter$3(void 0, void 0, void 0, function* () {
    if (!options.publicKey) {
        throw new Error('Invalid options. Public key attribute must be defined');
    }
    const attestation = yield createWebauthnCredential(convertPublicKeyToWebauthn(options.publicKey));
    return convertAttestationResultToTurnkey(attestation);
});
const convertAttestationResultToTurnkey = (attestation) => {
    var _a;
    return ({
        attestationObject: attestation.response.attestationObject,
        clientDataJson: attestation.response.clientDataJSON,
        credentialId: attestation.rawId,
        transports: ((_a = attestation.response.transports) === null || _a === void 0 ? void 0 : _a.map(convertTransportEnumToTurnkeyEnum)) ||
            [],
    });
};
const convertPublicKeyToWebauthn = (publicKey) => {
    var _a;
    return (Object.assign(Object.assign({}, publicKey), { challenge: bufferSourceToString(publicKey.challenge), excludeCredentials: (_a = publicKey.excludeCredentials) === null || _a === void 0 ? void 0 : _a.map((cred) => (Object.assign(Object.assign({}, cred), { id: bufferSourceToString(cred.id) }))), user: Object.assign(Object.assign({}, publicKey.user), { id: bufferSourceToString(publicKey.user.id) }) }));
};
const bufferSourceToString = (buf) => {
    if (buf instanceof ArrayBuffer) {
        return bufferToBase64URLString(buf);
    }
    else {
        const arr = new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
        return bufferToBase64URLString(arr);
    }
};

assertPackageVersion('@dynamic-labs/webauthn', version$5);

const createTurnkeyPasskeyService = () => ({
    createWebauthnStamper: (config) => new WebauthnStamper(config),
    getWebAuthnAttestation: getWebAuthnAttestationTurnkeyAdapter,
});

var _a, _PasskeyService_implementation;
class PasskeyService {
    /**
     * Gets the current passkey service implementation.
     * If no implementation is set, it will create a new turnkey passkey service.
     * @returns {IPasskeyService} The passkey service implementation.
     */
    static get implementation() {
        if (!__classPrivateFieldGet(_a, _a, "f", _PasskeyService_implementation)) {
            return createTurnkeyPasskeyService();
        }
        return __classPrivateFieldGet(_a, _a, "f", _PasskeyService_implementation);
    }
    /**
     * Sets the passkey service implementation.
     * @param {IPasskeyService} implementation The passkey service implementation to set.
     */
    static set implementation(implementation) {
        __classPrivateFieldSet(_a, _a, implementation, "f", _PasskeyService_implementation);
    }
    /**
     * Gets the WebAuthn attestation method from the current implementation.
     */
    static get getWebAuthnAttestation() {
        return _a.implementation.getWebAuthnAttestation;
    }
    /**
     * Gets the createWebauthnStamper method from the current implementation.
     */
    static get createWebauthnStamper() {
        return _a.implementation.createWebauthnStamper;
    }
}
_a = PasskeyService;
_PasskeyService_implementation = { value: void 0 };

class BaseTurnkeyHandler {
    get client() {
        return this.__turnkeyClient;
    }
    get publicKey() {
        return this.__publicKey;
    }
    clear() {
        var _a;
        (_a = this.__iframeStamper) === null || _a === void 0 ? void 0 : _a.clear();
        this.__iframeStamper = undefined;
        this.__publicKey = undefined;
        this.__turnkeyClient = undefined;
    }
}

const turnkeyPasskeyRecoveryUrl = 'https://recovery.turnkey.com';
const turnkeyEmailRecoveryUrl = 'https://auth.turnkey.com';
const TURNKEY_RECOVERY_CREDENTIAL_EXPIRATION_SECONDS = 900; // 15 seconds
const TURNKEY_SESSION_EXPIRATION_SECONDS = 1800; //30 seconds
const EMAIL_AUTH_CREDENTIAL_TYPE = 'CREDENTIAL_TYPE_API_KEY_P256';
const PASSKEY_RECOVERY_CREDENTIAL_TYPE = 'CREDENTIAL_TYPE_RECOVER_USER_KEY_P256';
class TurnkeyAuthenticatorRecoveryHandler extends BaseTurnkeyHandler {
    constructor() {
        super(...arguments);
        this.isSessionActive = () => {
            // it's only used for email auth session
            if (!this.__createdAt || this.__recoveryType !== 'email') {
                return false;
            }
            const isExpired = this.isExpired(this.__createdAt, this.__sessionExpiration || TURNKEY_SESSION_EXPIRATION_SECONDS);
            if (isExpired) {
                this.clear();
                return false;
            }
            return true;
        };
        this.isValidCode = (organizationId) => __awaiter$4(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            if (!organizationId || !this.__turnkeyRecoveryUserId) {
                throw new DynamicError('Cannot proceed with your request');
            }
            const userResponse = yield ((_a = this.__turnkeyClient) === null || _a === void 0 ? void 0 : _a.getUser({
                organizationId,
                userId: this.__turnkeyRecoveryUserId,
            }));
            const credentialTypeMap = {
                email: EMAIL_AUTH_CREDENTIAL_TYPE,
                passkey: PASSKEY_RECOVERY_CREDENTIAL_TYPE,
            };
            const recoveryCredential = (_d = (_c = (_b = userResponse === null || userResponse === void 0 ? void 0 : userResponse.user) === null || _b === void 0 ? void 0 : _b.apiKeys) === null || _c === void 0 ? void 0 : _c.filter((k) => k.credential.type === credentialTypeMap[this.__recoveryType])) === null || _d === void 0 ? void 0 : _d.pop();
            if (!recoveryCredential) {
                return false;
            }
            const isExpired = this.isExpired(parseInt(recoveryCredential.createdAt.seconds, 10), TURNKEY_RECOVERY_CREDENTIAL_EXPIRATION_SECONDS);
            if (isExpired) {
                return false;
            }
            this.__createdAt = parseInt(recoveryCredential.createdAt.seconds, 10);
            return true;
        });
        this.isExpired = (createdAtSeconds, expirationTimeSeconds) => {
            const recoveryExpirationSeconds = createdAtSeconds + expirationTimeSeconds;
            const expirationTime = new Date(recoveryExpirationSeconds * 1000);
            if (new Date() >= expirationTime) {
                return true;
            }
            return false;
        };
    }
    get recoveryType() {
        return this.__recoveryType;
    }
    get recoveryUserId() {
        return this.__turnkeyRecoveryUserId || '';
    }
    set recoveryUserId(turnkeyRecoveryUserId) {
        this.__turnkeyRecoveryUserId = turnkeyRecoveryUserId;
    }
    clear() {
        super.clear();
        this.__recoveryType = undefined;
        this.__turnkeyRecoveryUserId = undefined;
        this.__createdAt = undefined;
    }
    initRecovery(authType, iframeContainer, iframeElementId, sessionExpiration) {
        return __awaiter$4(this, void 0, void 0, function* () {
            if (this.__recoveryType) {
                this.clear();
            }
            this.__sessionExpiration = sessionExpiration;
            this.__recoveryType = authType;
            const iframeUrl = authType === 'passkey'
                ? turnkeyPasskeyRecoveryUrl
                : turnkeyEmailRecoveryUrl;
            this.__iframeStamper = new IframeStamper({
                iframeContainer,
                iframeElementId,
                iframeUrl,
            });
            yield this.__iframeStamper.init();
            this.__publicKey = this.__iframeStamper.publicKey();
            return this.__publicKey;
        });
    }
    verifyRecoveryCode(recoveryBundle, organizationId) {
        return __awaiter$4(this, void 0, void 0, function* () {
            if (!this.__iframeStamper) {
                throw new DynamicError('Cannot proceed with your request');
            }
            try {
                yield this.__iframeStamper.injectCredentialBundle(recoveryBundle);
                this.__turnkeyClient = new TurnkeyClient({
                    baseUrl: TURNKEY_API_BASE_URL,
                }, this.__iframeStamper);
                if (!organizationId || !this.__turnkeyRecoveryUserId) {
                    throw new DynamicError('Cannot proceed with your request');
                }
                if (!(yield this.isValidCode(organizationId))) {
                    throw new DynamicError('The code is invalid or expired.');
                }
            }
            catch (err) {
                logger$3.error('Error while verifying recovery code', err);
                if (err instanceof DynamicError) {
                    throw err;
                }
                throw new DynamicError('The code is invalid or expired.');
            }
        });
    }
    completeRecovery(_a) {
        return __awaiter$4(this, arguments, void 0, function* ({ attestation, challenge, turnkeySubOrganizationId, }) {
            if (!this.__turnkeyClient || !this.__turnkeyRecoveryUserId) {
                throw new DynamicError('Cannot proceed with your request');
            }
            try {
                return this.__turnkeyClient.recoverUser({
                    organizationId: turnkeySubOrganizationId,
                    parameters: {
                        authenticator: {
                            attestation: attestation,
                            authenticatorName: 'Passkey',
                            challenge,
                        },
                        userId: this.__turnkeyRecoveryUserId,
                    },
                    timestampMs: String(Date.now()),
                    type: 'ACTIVITY_TYPE_RECOVER_USER',
                });
            }
            catch (err) {
                logger$3.error('[TK] Error while completing recovery process', err);
                throw err;
            }
        });
    }
    addPasskeyAuthenticator(_a) {
        return __awaiter$4(this, arguments, void 0, function* ({ attestation, challenge, turnkeySubOrganizationId, }) {
            if (!this.__turnkeyClient || !this.__turnkeyRecoveryUserId) {
                throw new DynamicError('Cannot proceed with your request');
            }
            try {
                return this.__turnkeyClient.createAuthenticators({
                    organizationId: turnkeySubOrganizationId,
                    parameters: {
                        authenticators: [
                            {
                                attestation: attestation,
                                authenticatorName: 'Passkey',
                                challenge,
                            },
                        ],
                        userId: this.__turnkeyRecoveryUserId,
                    },
                    timestampMs: String(Date.now()),
                    type: 'ACTIVITY_TYPE_CREATE_AUTHENTICATORS_V2',
                });
            }
            catch (err) {
                logger$3.error('[TK] Error while creating new authenticator', err);
                throw err;
            }
        });
    }
    addEmailRecovery(_a) {
        return __awaiter$4(this, arguments, void 0, function* ({ organizationId, email, turnkeyUserId, }) {
            let rpId = getTLD();
            if (!rpId) {
                rpId = PlatformService.getHostname();
            }
            const stamper = PasskeyService.createWebauthnStamper({
                rpId,
            });
            const client = new TurnkeyClient({
                baseUrl: TURNKEY_API_BASE_URL,
            }, stamper);
            try {
                const signedRequest = yield client.stampUpdateUser({
                    organizationId,
                    parameters: {
                        userEmail: email,
                        userId: turnkeyUserId,
                        userTagIds: [],
                    },
                    timestampMs: String(Date.now()),
                    type: 'ACTIVITY_TYPE_UPDATE_USER',
                });
                return { signedRequest, userId: turnkeyUserId };
            }
            catch (err) {
                logger$3.error('Error while adding email recovery', err);
                throw err;
            }
        });
    }
}
const turnkeyAuthenticatorRecoveryHandler = new TurnkeyAuthenticatorRecoveryHandler();

const turnkeyExportUrl = 'https://export.turnkey.com';
class TurnkeyExportHandler extends BaseTurnkeyHandler {
    initExport(iframeContainer, iframeElementId) {
        return __awaiter$4(this, void 0, void 0, function* () {
            this.__iframeStamper = new IframeStamper({
                iframeContainer,
                iframeElementId,
                iframeUrl: turnkeyExportUrl,
            });
            yield this.__iframeStamper.init();
            this.__publicKey = this.__iframeStamper.publicKey();
            if (turnkeyAuthenticatorRecoveryHandler.isSessionActive()) {
                this.__turnkeyClient = turnkeyAuthenticatorRecoveryHandler.client;
            }
            else {
                let rpId = getTLD();
                if (!rpId) {
                    rpId = PlatformService.getHostname();
                }
                const passkeyStamper = PasskeyService.createWebauthnStamper({
                    rpId,
                });
                const apiKeyStamper = TurnkeyExportHandler === null || TurnkeyExportHandler === void 0 ? void 0 : TurnkeyExportHandler.apiKeyStamper;
                const stamper = apiKeyStamper !== null && apiKeyStamper !== void 0 ? apiKeyStamper : passkeyStamper;
                this.__turnkeyClient = new TurnkeyClient({
                    baseUrl: TURNKEY_API_BASE_URL,
                }, stamper);
            }
            return this.__publicKey;
        });
    }
    verifyExportWallet(_a) {
        return __awaiter$4(this, arguments, void 0, function* ({ exportBundle, organizationId, }) {
            if (!this.__iframeStamper) {
                throw new DynamicError('Cannot proceed with your request');
            }
            try {
                return yield this.__iframeStamper.injectWalletExportBundle(exportBundle, organizationId);
            }
            catch (err) {
                logger$3.error('Error while verifying export wallet', err);
                throw err;
            }
        });
    }
    verifyExportPrivateKey(_a) {
        return __awaiter$4(this, arguments, void 0, function* ({ exportBundle, organizationId, chain, }) {
            if (!this.__iframeStamper) {
                throw new DynamicError('Cannot proceed with your request');
            }
            const keyFormat = chain === 'solana' || chain === 'SOL'
                ? KeyFormat.Solana
                : KeyFormat.Hexadecimal;
            try {
                return yield this.__iframeStamper.injectKeyExportBundle(exportBundle, organizationId, keyFormat);
            }
            catch (err) {
                logger$3.error('Error while verifying export private key', err);
                throw err;
            }
        });
    }
    exportPrivateKey(_a) {
        return __awaiter$4(this, arguments, void 0, function* ({ privateKeyId, organizationId, }) {
            const apiKeyStamper = TurnkeyExportHandler === null || TurnkeyExportHandler === void 0 ? void 0 : TurnkeyExportHandler.apiKeyStamper;
            if (apiKeyStamper) {
                this.__turnkeyClient = new TurnkeyClient({
                    baseUrl: TURNKEY_API_BASE_URL,
                }, apiKeyStamper);
            }
            if (!this.__iframeStamper ||
                !this.__publicKey ||
                !this.__turnkeyClient ||
                !privateKeyId) {
                throw new DynamicError('Cannot proceed with your request');
            }
            try {
                const newActivity = yield this.__turnkeyClient.exportPrivateKey({
                    organizationId,
                    parameters: { privateKeyId, targetPublicKey: this.__publicKey },
                    timestampMs: String(Date.now()),
                    type: 'ACTIVITY_TYPE_EXPORT_PRIVATE_KEY',
                });
                return newActivity.activity;
            }
            catch (err) {
                logger$3.error('[TK] Error while completing export private key process', err);
                throw err;
            }
        });
    }
    exportWallet(_a) {
        return __awaiter$4(this, arguments, void 0, function* ({ walletId, organizationId, address, }) {
            const apiKeyStamper = TurnkeyExportHandler === null || TurnkeyExportHandler === void 0 ? void 0 : TurnkeyExportHandler.apiKeyStamper;
            if (apiKeyStamper) {
                this.__turnkeyClient = new TurnkeyClient({
                    baseUrl: TURNKEY_API_BASE_URL,
                }, apiKeyStamper);
            }
            if (!this.__iframeStamper ||
                !this.__publicKey ||
                !this.__turnkeyClient ||
                !walletId) {
                throw new DynamicError('Cannot proceed with your request');
            }
            try {
                if (address) {
                    const newActivity = yield this.__turnkeyClient.exportWalletAccount({
                        organizationId,
                        parameters: { address, targetPublicKey: this.__publicKey },
                        timestampMs: String(Date.now()),
                        type: 'ACTIVITY_TYPE_EXPORT_WALLET_ACCOUNT',
                    });
                    return newActivity.activity;
                }
                const newActivity = yield this.__turnkeyClient.exportWallet({
                    organizationId,
                    parameters: { targetPublicKey: this.__publicKey, walletId },
                    timestampMs: String(Date.now()),
                    type: 'ACTIVITY_TYPE_EXPORT_WALLET',
                });
                return newActivity.activity;
            }
            catch (err) {
                logger$3.error('[TK] Error while completing export wallet process', err);
                throw err;
            }
        });
    }
}

class TurnkeyWalletConnectorBase extends WalletConnectorBase {
    constructor(nameAndKey, props) {
        super(props);
        // Public fields
        this.requiresNonDynamicEmailOtp = false;
        this.isEmbeddedWallet = true;
        this.removeSessionKeys = () => __awaiter$4(this, void 0, void 0, function* () {
            TurnkeyWalletConnectorBase.sessionKeys = undefined;
            TurnkeyWalletConnectorBase.apiKeyStamper = undefined;
            TurnkeyExportHandler.apiKeyStamper = undefined;
        });
        this.stampCreateWalletAccountRequest = (_a) => __awaiter$4(this, [_a], void 0, function* ({ request, }) {
            yield this.createOrRestoreSession();
            const turnkeyClient = this.getTurnkeyClient();
            return turnkeyClient.stampCreateWalletAccounts(request);
        });
        this.stampDeleteSubOrganizationRequest = (_b) => __awaiter$4(this, [_b], void 0, function* ({ request, }) {
            yield this.createOrRestoreSession();
            const turnkeyClient = this.getTurnkeyClient();
            return turnkeyClient.stampDeleteSubOrganization(request);
        });
        if (!props.appName) {
            throw new Error('appName not set');
        }
        this.name = nameAndKey.name;
        this.overrideKey = nameAndKey.key;
        this.appName = props.appName;
        this.__authenticatorMethodHandler = turnkeyAuthenticatorRecoveryHandler;
        this.__exportHandler = new TurnkeyExportHandler();
    }
    getWebAuthnAttestation() {
        return __awaiter$4(this, void 0, void 0, function* () {
            const challenge = generateRandomBuffer();
            const authenticatorUserId = generateRandomBuffer();
            const { email, passkeyIdentifier } = this;
            if (!email && !passkeyIdentifier) {
                throw new Error('Email or passkeyIdentifier must be set to register a webauthn credential.');
            }
            const displayName = email || `${this.appName} - ${passkeyIdentifier}`;
            const webAuthnCreateParams = {
                publicKey: {
                    authenticatorSelection: {
                        authenticatorAttachment: undefined,
                        requireResidentKey: false,
                        residentKey: 'preferred',
                        userVerification: 'discouraged',
                    },
                    challenge,
                    pubKeyCredParams: [
                        {
                            alg: -7,
                            type: 'public-key',
                        },
                    ],
                    rp: {
                        id: getTLD(),
                        name: this.appName,
                    },
                    user: {
                        displayName,
                        id: authenticatorUserId,
                        name: email || `${this.appName} - ${passkeyIdentifier}`,
                    },
                },
            };
            let attestation;
            try {
                attestation = yield PasskeyService.getWebAuthnAttestation(webAuthnCreateParams);
            }
            catch (error) {
                logger$3.warn(`Unable to register webauthn credential on the current page's TLD ${getTLD()}. Falling back to using hostname. ${PlatformService.getHostname()}`, error);
                // Create the passkey on the hostname instead.
                webAuthnCreateParams.publicKey.rp.id = PlatformService.getHostname();
                attestation = yield PasskeyService.getWebAuthnAttestation(webAuthnCreateParams);
            }
            return {
                attestation: {
                    attestationObject: attestation.attestationObject,
                    clientDataJson: attestation.clientDataJson,
                    credentialId: attestation.credentialId,
                    transports: convertAttestationTransports(attestation.transports),
                },
                challenge: base64UrlEncode(challenge),
                displayName,
            };
        });
    }
    getAuthenticatorHandler() {
        return this.__authenticatorMethodHandler;
    }
    getExportHandler() {
        return this.__exportHandler;
    }
    // Public methods
    get email() {
        return this._email;
    }
    setEmail(email) {
        this._email = email;
    }
    get phone() {
        return this._phone;
    }
    setPhone(phone) {
        this._phone = phone;
    }
    get passkeyIdentifier() {
        return this._passkeyIdentifier;
    }
    setPasskeyIdentifier(passkeyIdentifier) {
        this._passkeyIdentifier = passkeyIdentifier;
    }
    clearEmail() {
        this._email = null;
    }
    getAddress() {
        return __awaiter$4(this, void 0, void 0, function* () {
            var _a;
            return (_a = this.verifiedCredential) === null || _a === void 0 ? void 0 : _a.address;
        });
    }
    getConnectedAccounts() {
        return __awaiter$4(this, void 0, void 0, function* () {
            const verifiedCredentials = this.verifiedCredentials || [];
            const addresses = verifiedCredentials
                .map((vc) => vc === null || vc === void 0 ? void 0 : vc.address)
                .filter((a) => typeof a === 'string');
            return addresses;
        });
    }
    get turnkeyAddress() {
        var _a;
        const { address } = (_a = this.verifiedCredential) !== null && _a !== void 0 ? _a : {};
        return address;
    }
    get walletProperties() {
        const { walletProperties } = this.verifiedCredential || {};
        return walletProperties;
    }
    // Private methods
    set verifiedCredentials(verifiedCredentials) {
        this._verifiedCredentials = verifiedCredentials;
    }
    get verifiedCredentials() {
        return this._verifiedCredentials;
    }
    set verifiedCredential(verifiedCredential) {
        this._verifiedCredential = verifiedCredential;
    }
    get verifiedCredential() {
        return this._verifiedCredential;
    }
    setSessionKeyFetcher(func) {
        this.createOrRestoreSessionFetcherFunction = func;
    }
    setSessionKeyRemoveFunction(func) {
        this.removeSessionKeysFunction = func;
    }
    createOrRestoreSession() {
        return __awaiter$4(this, arguments, void 0, function* ({ ignoreRestore, } = {}) {
            if (!this.isSessionKeyCompatible() ||
                TurnkeyWalletConnectorBase.isLoadingSession) {
                return;
            }
            if (!this.createOrRestoreSessionFetcherFunction) {
                throw new DynamicError('Cannot register session key to init provider');
            }
            const { sessionKeys } = TurnkeyWalletConnectorBase;
            if (sessionKeys === null || sessionKeys === void 0 ? void 0 : sessionKeys.publicKey) {
                const isExpired = new Date() >= new Date(sessionKeys.expirationDate);
                if (!isExpired)
                    return sessionKeys.publicKey;
            }
            try {
                TurnkeyWalletConnectorBase.isLoadingSession = true;
                const sessionKeys = yield this.createOrRestoreSessionFetcherFunction({
                    ignoreRestore,
                });
                TurnkeyWalletConnectorBase.sessionKeys = sessionKeys;
                TurnkeyWalletConnectorBase.apiKeyStamper = new ApiKeyStamper({
                    apiPrivateKey: sessionKeys.privateKey,
                    apiPublicKey: sessionKeys.publicKey,
                });
                TurnkeyExportHandler.apiKeyStamper =
                    TurnkeyWalletConnectorBase.apiKeyStamper;
                logger$3.metaData.set('sessionApiPublicKey', sessionKeys.publicKey);
                return sessionKeys.publicKey;
            }
            catch (error) {
                throw new DynamicError('Failed to create or restore session');
            }
            finally {
                TurnkeyWalletConnectorBase.isLoadingSession = false;
            }
        });
    }
    isSessionKeyCompatible() {
        var _a;
        const walletProperties = (_a = this.verifiedCredential) === null || _a === void 0 ? void 0 : _a.walletProperties;
        const isSessionKeyCompatible = walletProperties === null || walletProperties === void 0 ? void 0 : walletProperties.isSessionKeyCompatible;
        return Boolean(isSessionKeyCompatible);
    }
    isSessionActive() {
        return __awaiter$4(this, void 0, void 0, function* () {
            const hasWallet = yield this.getAddress();
            return Boolean(hasWallet &&
                TurnkeyWalletConnectorBase.sessionKeys &&
                TurnkeyWalletConnectorBase.apiKeyStamper);
        });
    }
    get sessionKeys() {
        return TurnkeyWalletConnectorBase.sessionKeys;
    }
    getTurnkeyClient() {
        var _a;
        let rpId = getTLD();
        if (!rpId) {
            rpId = PlatformService.getHostname();
        }
        const passkeyStamper = PasskeyService.createWebauthnStamper({
            rpId,
        });
        const apiKeyStamper = TurnkeyWalletConnectorBase === null || TurnkeyWalletConnectorBase === void 0 ? void 0 : TurnkeyWalletConnectorBase.apiKeyStamper;
        const stamper = apiKeyStamper !== null && apiKeyStamper !== void 0 ? apiKeyStamper : passkeyStamper;
        this.__turnkeyClient =
            (_a = this.getAuthenticatorHandler().client) !== null && _a !== void 0 ? _a : new TurnkeyClient({
                baseUrl: TURNKEY_API_BASE_URL,
            }, stamper);
        return this.__turnkeyClient;
    }
    setLoggerMetadata() {
        var _a, _b, _c;
        logger$3.metaData.set('turnkeySubOrganizationId', (_b = (_a = this._verifiedCredential) === null || _a === void 0 ? void 0 : _a.walletProperties) === null || _b === void 0 ? void 0 : _b.turnkeySubOrganizationId);
        logger$3.metaData.set('walletId', (_c = this._verifiedCredential) === null || _c === void 0 ? void 0 : _c.id);
        let authMethod = 'Unknown';
        if (this.isSessionKeyCompatible()) {
            authMethod = 'SessionKeys';
        }
        else if (this.__authenticatorMethodHandler.recoveryType === 'passkey') {
            authMethod = 'Passkey';
        }
        else if (this.__authenticatorMethodHandler.recoveryType === 'email') {
            authMethod = 'EmailAuth';
        }
        logger$3.metaData.set('authMethod', authMethod);
    }
}
TurnkeyWalletConnectorBase.isLoadingSession = false;

const TurnkeyWalletConnectorInfo = {
    Turnkey: {
        key: 'turnkey',
        name: 'Turnkey',
    },
    TurnkeyHD: {
        key: 'turnkeyhd',
        name: 'Turnkey HD',
    },
};

const findTurnkeyVerifiedCredentialsWithSmartWalletRef = (verifiedCredentials, chain) => verifiedCredentials === null || verifiedCredentials === void 0 ? void 0 : verifiedCredentials.reduce((acc, vc) => {
    var _a;
    if (((_a = vc.walletName) === null || _a === void 0 ? void 0 : _a.startsWith('turnkey')) && chain === vc.chain) {
        const smartWallet = verifiedCredentials.find((v) => v.signerRefId === vc.id);
        const smartWalletRefId = smartWallet === null || smartWallet === void 0 ? void 0 : smartWallet.id;
        const smartWalletRefAddress = smartWallet === null || smartWallet === void 0 ? void 0 : smartWallet.address;
        acc.push(Object.assign(Object.assign({}, vc), { smartWalletRefAddress, smartWalletRefId }));
    }
    return acc;
}, []);

assertPackageVersion('@dynamic-labs/embedded-wallet', version$6);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter$2(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

class TurnkeyConsensusNeededError extends BaseError$1 {
    constructor({ message = "Turnkey activity requires consensus.", activityId, activityStatus, }) {
        super(message);
        this.name = "TurnkeyConsensusNeededError";
        this.activityId = activityId;
        this.activityStatus = activityStatus;
    }
}
class TurnkeyActivityError extends BaseError$1 {
    constructor({ message = "Received unexpected Turnkey activity status.", activityId, activityStatus, }) {
        super(message);
        this.name = "TurnkeyActivityError";
        this.activityId = activityId;
        this.activityStatus = activityStatus;
    }
}
function createAccountWithAddress(input) {
    const { client, organizationId, signWith } = input;
    let { ethereumAddress } = input;
    if (!signWith) {
        throw new TurnkeyActivityError$1({
            message: `Missing signWith parameter`,
        });
    }
    if (isAddress(signWith)) {
        // override provided `ethereumAddress`
        ethereumAddress = signWith;
    }
    else if (!ethereumAddress) {
        throw new TurnkeyActivityError({
            message: `Missing ethereumAddress parameter`,
        });
    }
    return toAccount({
        address: ethereumAddress,
        signMessage: function ({ message, }) {
            return signMessage(client, message, organizationId, signWith);
        },
        signTransaction: function (transaction, args) {
            const serializer = !args?.serializer
                ? serializeTransaction$3
                : args.serializer;
            return signTransaction(client, transaction, serializer, organizationId, signWith);
        },
        signTypedData: function (typedData) {
            return signTypedData(client, typedData, organizationId, signWith);
        },
    });
}
async function createAccount(input) {
    const { client, organizationId, signWith } = input;
    let { ethereumAddress } = input;
    if (!signWith) {
        throw new TurnkeyActivityError({
            message: `Missing signWith parameter`,
        });
    }
    if (isAddress(signWith)) {
        // override provided `ethereumAddress`
        ethereumAddress = signWith;
    }
    else if (!ethereumAddress) {
        // we have a private key ID, but not an ethereumAddress
        const data = await client.getPrivateKey({
            privateKeyId: signWith,
            organizationId: organizationId,
        });
        ethereumAddress = data.privateKey.addresses.find((item) => item.format === "ADDRESS_FORMAT_ETHEREUM")?.address;
        if (typeof ethereumAddress !== "string" || !ethereumAddress) {
            throw new TurnkeyActivityError({
                message: `Unable to find Ethereum address for key ${signWith} under organization ${organizationId}`,
            });
        }
    }
    return createAccountWithAddress({
        client,
        organizationId,
        signWith,
        ethereumAddress,
    });
}
async function signMessage(client, message, organizationId, signWith) {
    const hashedMessage = hashMessage(message);
    const signedMessage = await signMessageWithErrorWrapping(client, hashedMessage, organizationId, signWith);
    return `${signedMessage}`;
}
async function signTransaction(client, transaction, serializer, organizationId, signWith) {
    const serializedTx = serializer(transaction);
    const nonHexPrefixedSerializedTx = serializedTx.replace(/^0x/, "");
    return await signTransactionWithErrorWrapping(client, nonHexPrefixedSerializedTx, organizationId, signWith);
}
async function signTypedData(client, data, organizationId, signWith) {
    const hashToSign = hashTypedData(data);
    return await signMessageWithErrorWrapping(client, hashToSign, organizationId, signWith);
}
async function signTransactionWithErrorWrapping(client, unsignedTransaction, organizationId, signWith) {
    let signedTx;
    try {
        signedTx = await signTransactionImpl(client, unsignedTransaction, organizationId, signWith);
    }
    catch (error) {
        // Wrap Turnkey error in Viem-specific error
        if (error instanceof TurnkeyActivityError$1) {
            throw new TurnkeyActivityError({
                message: error.message,
                activityId: error.activityId,
                activityStatus: error.activityStatus,
            });
        }
        if (error instanceof TurnkeyActivityConsensusNeededError) {
            throw new TurnkeyConsensusNeededError({
                message: error.message,
                activityId: error.activityId,
                activityStatus: error.activityStatus,
            });
        }
        throw new TurnkeyActivityError({
            message: `Failed to sign: ${error.message}`,
        });
    }
    return `0x${signedTx}`;
}
async function signTransactionImpl(client, unsignedTransaction, organizationId, signWith) {
    if (client instanceof TurnkeyClient) {
        const { activity } = await client.signTransaction({
            type: "ACTIVITY_TYPE_SIGN_TRANSACTION_V2",
            organizationId: organizationId,
            parameters: {
                signWith,
                type: "TRANSACTION_TYPE_ETHEREUM",
                unsignedTransaction: unsignedTransaction,
            },
            timestampMs: String(Date.now()), // millisecond timestamp
        });
        assertActivityCompleted(activity);
        return assertNonNull(activity?.result?.signTransactionResult?.signedTransaction);
    }
    else {
        const { activity, signedTransaction } = await client.signTransaction({
            signWith,
            type: "TRANSACTION_TYPE_ETHEREUM",
            unsignedTransaction: unsignedTransaction,
        });
        assertActivityCompleted(activity);
        return assertNonNull(signedTransaction);
    }
}
async function signMessageWithErrorWrapping(client, message, organizationId, signWith) {
    let signedMessage;
    try {
        signedMessage = await signMessageImpl(client, message, organizationId, signWith);
    }
    catch (error) {
        // Wrap Turnkey error in Viem-specific error
        if (error instanceof TurnkeyActivityError$1) {
            throw new TurnkeyActivityError({
                message: error.message,
                activityId: error.activityId,
                activityStatus: error.activityStatus,
            });
        }
        if (error instanceof TurnkeyActivityConsensusNeededError) {
            throw new TurnkeyConsensusNeededError({
                message: error.message,
                activityId: error.activityId,
                activityStatus: error.activityStatus,
            });
        }
        throw new TurnkeyActivityError({
            message: `Failed to sign: ${error.message}`,
        });
    }
    return signedMessage;
}
async function signMessageImpl(client, message, organizationId, signWith) {
    let result;
    if (client instanceof TurnkeyClient) {
        const { activity } = await client.signRawPayload({
            type: "ACTIVITY_TYPE_SIGN_RAW_PAYLOAD_V2",
            organizationId: organizationId,
            parameters: {
                signWith,
                payload: message,
                encoding: "PAYLOAD_ENCODING_HEXADECIMAL",
                hashFunction: "HASH_FUNCTION_NO_OP",
            },
            timestampMs: String(Date.now()), // millisecond timestamp
        });
        assertActivityCompleted(activity);
        result = assertNonNull(activity?.result?.signRawPayloadResult);
    }
    else {
        const { activity, r, s, v } = await client.signRawPayload({
            signWith,
            payload: message,
            encoding: "PAYLOAD_ENCODING_HEXADECIMAL",
            hashFunction: "HASH_FUNCTION_NO_OP",
        });
        assertActivityCompleted(activity);
        result = {
            r,
            s,
            v,
        };
    }
    return assertNonNull(serializeSignature(result));
}
function serializeSignature(sig) {
    return serializeSignature$1({
        r: `0x${sig.r}`,
        s: `0x${sig.s}`,
        v: sig.v === "00" ? 27n : 28n,
    });
}

class TurnkeyEVMWalletConnector extends TurnkeyWalletConnectorBase {
    constructor(nameAndKey, props) {
        var _a, _b;
        super(nameAndKey, props);
        this.walletFallback = {
            brand: {
                alt: 'Turnkey Wallet',
                spriteId: 'turnkey',
            },
            name: 'Turnkey HD',
        };
        // Public fields
        this.ChainWallet = EthereumWallet;
        this.connectedChain = 'EVM';
        this.supportedChains = ['ETH', 'EVM'];
        this.verifiedCredentialChain = 'eip155';
        this.evmNetworks = parseEvmNetworks(props.evmNetworks);
        this.walletUiUtils = props.walletUiUtils;
        this._turnkeyAccount = undefined;
        this._selectedChainId = this.getLastUsedChainId();
        this.chainRpcProviders = props.chainRpcProviders;
        (_a = this.chainRpcProviders) === null || _a === void 0 ? void 0 : _a.registerEvmProviders((_b = props.providersConfig) !== null && _b !== void 0 ? _b : {});
        this.__turnkeyClient = this.getTurnkeyClient();
    }
    getLastUsedChainId() {
        var _a;
        if (this.lastUsedChainId) {
            return this.lastUsedChainId;
        }
        if (!((_a = this.evmNetworks) === null || _a === void 0 ? void 0 : _a.length)) {
            return undefined;
        }
        return this.evmNetworks[0].chainId;
    }
    // Public methods
    getNetwork() {
        return __awaiter$2(this, void 0, void 0, function* () {
            var _a;
            return (_a = (yield this.getSigner())) === null || _a === void 0 ? void 0 : _a.getChainId();
        });
    }
    supportsNetworkSwitching() {
        return true;
    }
    switchNetwork(_a) {
        return __awaiter$2(this, arguments, void 0, function* ({ networkChainId, }) {
            if (!networkChainId) {
                return;
            }
            if (typeof networkChainId === 'string') {
                networkChainId = parseInt(networkChainId);
            }
            this.lastUsedChainId = networkChainId;
            this._selectedChainId = networkChainId;
            yield this.refreshTurnkeyAccount();
            this.emit('chainChange', {
                chain: networkChainId.toString(),
            });
        });
    }
    setVerifiedCredentials(verifiedCredentials) {
        const turnkeyVerifiedCredentials = findTurnkeyVerifiedCredentialsWithSmartWalletRef(verifiedCredentials, 'eip155');
        const [turnkeyVerifiedCredential] = turnkeyVerifiedCredentials;
        const didTurnkeyVerifiedCredentialsChanged = JSON.stringify(this.verifiedCredentials) !==
            JSON.stringify(turnkeyVerifiedCredentials);
        if (!didTurnkeyVerifiedCredentialsChanged) {
            return;
        }
        this.verifiedCredential = turnkeyVerifiedCredential;
        this.verifiedCredentials = turnkeyVerifiedCredentials;
        this.refreshTurnkeyAccount();
    }
    validateActiveWallet(expectedAddress) {
        return __awaiter$2(this, void 0, void 0, function* () {
            var _a, _b;
            const activeAddress = ((_a = this.verifiedCredential) === null || _a === void 0 ? void 0 : _a.address) || '';
            const isWalletActive = isSameAddress(activeAddress, expectedAddress, this.connectedChain);
            if (!isWalletActive) {
                const targetActiveAccount = (_b = this.verifiedCredentials) === null || _b === void 0 ? void 0 : _b.find((vc) => (vc === null || vc === void 0 ? void 0 : vc.address) === expectedAddress);
                if (!targetActiveAccount) {
                    throw new DynamicError('Account not found');
                }
                this.verifiedCredential = targetActiveAccount;
                this.refreshTurnkeyAccount();
            }
        });
    }
    getBalance(address) {
        return __awaiter$2(this, void 0, void 0, function* () {
            const client = yield this.getPublicClient();
            if (!client) {
                return undefined;
            }
            const balance = yield client.getBalance({
                address: address,
            });
            return formatEther$1(balance);
        });
    }
    signMessage(messageToSign) {
        return __awaiter$2(this, void 0, void 0, function* () {
            const signer = yield this.getSigner();
            if (!signer) {
                throw new Error('Signer not found');
            }
            return signer.signMessage({
                message: messageToSign,
            });
        });
    }
    getPublicClient() {
        return __awaiter$2(this, void 0, void 0, function* () {
            var _a, _b;
            if (this.evmNetworks.length === 0) {
                return undefined;
            }
            const networkId = (_a = (yield this.getNetwork())) !== null && _a !== void 0 ? _a : 1;
            const configurations = {
                cosmos: [],
                evm: this.evmNetworks,
                solana: [],
                starknet: undefined,
            };
            if (!this.chainRpcProviders)
                return undefined;
            const providers = this.chainRpcProviders.getProviders(configurations);
            return (_b = this.chainRpcProviders.getEvmProviderByChainId(providers, networkId)) === null || _b === void 0 ? void 0 : _b.provider;
        });
    }
    getSigner() {
        return __awaiter$2(this, void 0, void 0, function* () {
            yield this.getTurnkeyAccount();
            return this.getWalletClient();
        });
    }
    // decides in runtime which stamper to use and creates the corresponding account
    getAccount() {
        return __awaiter$2(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (this.isSessionKeyCompatible() &&
                ((_a = this.__turnkeyClient) === null || _a === void 0 ? void 0 : _a.stamper) instanceof ApiKeyStamper) {
                return this._turnkeyAccount;
            }
            if ((this.getAuthenticatorHandler().recoveryType === 'passkey' &&
                ((_b = this.__turnkeyClient) === null || _b === void 0 ? void 0 : _b.stamper) instanceof IframeStamper) ||
                (this.getAuthenticatorHandler().recoveryType === 'email' &&
                    ((_c = this.__turnkeyClient) === null || _c === void 0 ? void 0 : _c.stamper) instanceof WebauthnStamper) ||
                this.__turnkeyClient !== this.getAuthenticatorHandler().client) {
                yield this.refreshTurnkeyAccount();
            }
            return this._turnkeyAccount;
        });
    }
    getWalletClient() {
        const rpcUrl = this.networkRpcUrl;
        const account = this._turnkeyAccount;
        const evmNetwork = this.currentEvmNetwork;
        if (!account || !rpcUrl || !evmNetwork) {
            return undefined;
        }
        return createWalletClientWithUiConfirmation({
            account: this.getAccount.bind(this),
            address: this.turnkeyAddress,
            chain: getOrMapViemChain(evmNetwork),
            transport: http(rpcUrl),
            // TODO: remove this. We should not be passing references to wallet connectors
            walletConnector: this,
            walletUiUtils: this.walletUiUtils,
        });
    }
    // Private methods
    get currentChainId() {
        var _a, _b, _c;
        return (_a = this._selectedChainId) !== null && _a !== void 0 ? _a : (_c = (_b = this.evmNetworks) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.chainId;
    }
    get lastUsedChainId() {
        const lastUsedChainIdLS = localStorage.getItem(TurnkeyEVMWalletConnector.lastUsedChainIdStorageKey);
        if (!lastUsedChainIdLS)
            return undefined;
        try {
            const chainId = parseInt(lastUsedChainIdLS);
            if (isNaN(chainId)) {
                return undefined;
            }
            const isChainCurrentlyEnabled = this.evmNetworks.some((network) => network.chainId === chainId);
            if (!isChainCurrentlyEnabled) {
                const lastUsedChainId = this.evmNetworks[0].chainId;
                this.lastUsedChainId = lastUsedChainId;
                return this.lastUsedChainId;
            }
            return chainId;
        }
        catch (err) {
            logger$3.error(err);
            return undefined;
        }
    }
    set lastUsedChainId(chainId) {
        if (chainId === undefined) {
            localStorage.removeItem(TurnkeyEVMWalletConnector.lastUsedChainIdStorageKey);
        }
        else {
            localStorage.setItem(TurnkeyEVMWalletConnector.lastUsedChainIdStorageKey, chainId.toString());
        }
    }
    get networkRpcUrl() {
        const chainId = this.currentChainId;
        const evmNetwork = this.evmNetworks.find((network) => network.chainId === chainId);
        if (!evmNetwork) {
            return undefined;
        }
        const rpcUrl = getRpcUrlForChain({
            chainId: chainId,
            networks: this.evmNetworks,
        });
        return rpcUrl;
    }
    get currentEvmNetwork() {
        const chainId = this.currentChainId;
        return this.evmNetworks.find((network) => network.chainId === chainId);
    }
    internalSignTransaction(_a) {
        return __awaiter$2(this, arguments, void 0, function* ({ transaction, args, address, turnkeySubOrganizationId, }) {
            return this.doRetryableTurnkeyAction({
                action: (turnkeyAccount) => turnkeyAccount.signTransaction(transaction, args),
                activityType: 'SignTransaction',
                address,
                turnkeySubOrganizationId,
            });
        });
    }
    internalSignTypedData(_a) {
        return __awaiter$2(this, arguments, void 0, function* ({ typedData, address, turnkeySubOrganizationId, }) {
            return this.doRetryableTurnkeyAction({
                action: (turnkeyAccount) => turnkeyAccount.signTypedData(typedData),
                activityType: 'SignTypedData',
                address,
                turnkeySubOrganizationId,
            });
        });
    }
    internalSignMessage(_a) {
        return __awaiter$2(this, arguments, void 0, function* ({ message, address, turnkeySubOrganizationId, }) {
            return this.doRetryableTurnkeyAction({
                action: (turnkeyAccount) => turnkeyAccount.signMessage({ message }),
                activityType: 'SignMessage',
                address,
                turnkeySubOrganizationId,
            });
        });
    }
    doRetryableTurnkeyAction(_a) {
        return __awaiter$2(this, arguments, void 0, function* ({ action, activityType, address, turnkeySubOrganizationId, }) {
            yield this.createOrRestoreSession();
            let newTurnkeyAccountRaw = yield this.createTurnkeyAccount({
                address,
                turnkeySubOrganizationId,
            });
            try {
                return yield action(newTurnkeyAccountRaw);
            }
            catch (err) {
                if (TURNKEY_SDK_SESSION_KEY_RETRYABLE_ERRORS.some((errorMsg) => err.message
                    .toLowerCase()
                    .includes(errorMsg.toLowerCase()))) {
                    yield this.removeSessionKeys();
                    yield this.createOrRestoreSession({
                        ignoreRestore: true,
                    });
                    newTurnkeyAccountRaw = yield this.createTurnkeyAccount({
                        address,
                        turnkeySubOrganizationId,
                    });
                    return action(newTurnkeyAccountRaw);
                }
                logger$3.error(`[TK] failed to perform ${activityType} activity`, err);
                throw err;
            }
        });
    }
    createTurnkeyAccount(_a) {
        return __awaiter$2(this, arguments, void 0, function* ({ address, turnkeySubOrganizationId, }) {
            return createAccount({
                client: this.getTurnkeyClient(),
                ethereumAddress: address,
                organizationId: turnkeySubOrganizationId,
                signWith: address,
            });
        });
    }
    refreshTurnkeyAccount() {
        return __awaiter$2(this, void 0, void 0, function* () {
            this._turnkeyAccount = undefined;
            return this.getTurnkeyAccount();
        });
    }
    getTurnkeyAccount() {
        return __awaiter$2(this, void 0, void 0, function* () {
            var _a, _b;
            if (this._turnkeyAccount) {
                return this._turnkeyAccount;
            }
            const { turnkeySubOrganizationId } = (_a = this.walletProperties) !== null && _a !== void 0 ? _a : {};
            const { address } = (_b = this.verifiedCredential) !== null && _b !== void 0 ? _b : {};
            if (!turnkeySubOrganizationId || !address) {
                return;
            }
            this._turnkeyAccount = toAccount({
                address: address,
                signMessage: (_c) => __awaiter$2(this, [_c], void 0, function* ({ message, }) {
                    return this.internalSignMessage({
                        address: address,
                        message,
                        turnkeySubOrganizationId,
                    });
                }),
                signTransaction: (transaction, args) => __awaiter$2(this, void 0, void 0, function* () {
                    return this.internalSignTransaction({
                        address: address,
                        args,
                        transaction,
                        turnkeySubOrganizationId,
                    });
                }),
                signTypedData: (typedData) => __awaiter$2(this, void 0, void 0, function* () {
                    return this.internalSignTypedData({
                        address: address,
                        turnkeySubOrganizationId,
                        typedData,
                    });
                }),
            });
            this.setLoggerMetadata();
            return this._turnkeyAccount;
        });
    }
    createUiTransaction(from) {
        return __awaiter$2(this, void 0, void 0, function* () {
            yield this.validateActiveWallet(from);
            const walletClient = this.getWalletClient();
            const publicClient = yield this.getPublicClient();
            if (!publicClient || !walletClient) {
                throw new DynamicError('No public client available');
            }
            return createViemUiTransaction({ from, publicClient, walletClient });
        });
    }
    getEnabledNetworks() {
        return this.evmNetworks;
    }
}
TurnkeyEVMWalletConnector.lastUsedChainIdStorageKey = 'turnkey-last-used-chain-id';

const TurnkeyEVMWalletConnectors = (props) => {
    var _a;
    if ((_a = props.apiProviders) === null || _a === void 0 ? void 0 : _a.turnkey) {
        return [
            class extends TurnkeyEVMWalletConnector {
                constructor(innerProps) {
                    super(TurnkeyWalletConnectorInfo.TurnkeyHD, Object.assign(Object.assign({}, props), innerProps));
                }
            },
            class extends TurnkeyEVMWalletConnector {
                constructor(innerProps) {
                    super(TurnkeyWalletConnectorInfo.Turnkey, Object.assign(Object.assign({}, props), innerProps));
                }
            },
        ];
    }
    return [];
};

assertPackageVersion('@dynamic-labs/embedded-wallet-evm', version$7);

const fetchWalletConnectWallets = ({ walletBook, }) => {
    var _a;
    return Object.entries((_a = walletBook === null || walletBook === void 0 ? void 0 : walletBook.wallets) !== null && _a !== void 0 ? _a : {})
        .filter(([, wallet]) => wallet.walletConnect && !wallet.filterFromWalletConnect)
        .map(([key, wallet]) => {
        const { shortName } = wallet;
        const name = shortName || wallet.name;
        return class extends WalletConnect {
            constructor(props) {
                super(Object.assign(Object.assign({}, props), { walletName: name }));
                this.overrideKey = key;
            }
        };
    });
};
const getWalletConnectConnector = () => class extends WalletConnect {
    constructor(props) {
        super(Object.assign(Object.assign({}, props), { walletName: 'WalletConnect' }));
    }
};

const walletLogo = (type, width) => {
    let height;
    switch (type) {
        case 'standard':
            height = width;
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E `;
        case 'circle':
            height = width;
            return `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${width}' height='${height}' viewBox='0 0 999.81 999.81'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052fe;%7D.cls-2%7Bfill:%23fefefe;%7D.cls-3%7Bfill:%230152fe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M655-115.9h56c.83,1.59,2.36.88,3.56,1a478,478,0,0,1,75.06,10.42C891.4-81.76,978.33-32.58,1049.19,44q116.7,126,131.94,297.61c.38,4.14-.34,8.53,1.78,12.45v59c-1.58.84-.91,2.35-1,3.56a482.05,482.05,0,0,1-10.38,74.05c-24,106.72-76.64,196.76-158.83,268.93s-178.18,112.82-287.2,122.6c-4.83.43-9.86-.25-14.51,1.77H654c-1-1.68-2.69-.91-4.06-1a496.89,496.89,0,0,1-105.9-18.59c-93.54-27.42-172.78-77.59-236.91-150.94Q199.34,590.1,184.87,426.58c-.47-5.19.25-10.56-1.77-15.59V355c1.68-1,.91-2.7,1-4.06a498.12,498.12,0,0,1,18.58-105.9c26-88.75,72.64-164.9,140.6-227.57q126-116.27,297.21-131.61C645.32-114.57,650.35-113.88,655-115.9Zm377.92,500c0-192.44-156.31-349.49-347.56-350.15-194.13-.68-350.94,155.13-352.29,347.42-1.37,194.55,155.51,352.1,348.56,352.47C876.15,734.23,1032.93,577.84,1032.93,384.11Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-2' d='M1032.93,384.11c0,193.73-156.78,350.12-351.29,349.74-193-.37-349.93-157.92-348.56-352.47C334.43,189.09,491.24,33.28,685.37,34,876.62,34.62,1032.94,191.67,1032.93,384.11ZM683,496.81q43.74,0,87.48,0c15.55,0,25.32-9.72,25.33-25.21q0-87.48,0-175c0-15.83-9.68-25.46-25.59-25.46H595.77c-15.88,0-25.57,9.64-25.58,25.46q0,87.23,0,174.45c0,16.18,9.59,25.7,25.84,25.71Z' transform='translate(-183.1 115.9)'/%3E%3Cpath class='cls-3' d='M683,496.81H596c-16.25,0-25.84-9.53-25.84-25.71q0-87.23,0-174.45c0-15.82,9.7-25.46,25.58-25.46H770.22c15.91,0,25.59,9.63,25.59,25.46q0,87.47,0,175c0,15.49-9.78,25.2-25.33,25.21Q726.74,496.84,683,496.81Z' transform='translate(-183.1 115.9)'/%3E%3C/svg%3E`;
        case 'text':
            height = (0.1 * width).toFixed(2);
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E`;
        case 'textWithLogo':
            height = (0.25 * width).toFixed(2);
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%230052ff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E`;
        case 'textLight':
            height = (0.1 * width).toFixed(2);
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 528.15 53.64'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3ECoinbase_Wordmark_SubBrands_ALL%3C/title%3E%3Cpath class='cls-1' d='M164.45,15a15,15,0,0,0-11.74,5.4V0h-8.64V52.92h8.5V48a15,15,0,0,0,11.88,5.62c10.37,0,18.21-8.21,18.21-19.3S174.67,15,164.45,15Zm-1.3,30.67c-6.19,0-10.73-4.83-10.73-11.31S157,23,163.22,23s10.66,4.82,10.66,11.37S169.34,45.65,163.15,45.65Zm83.31-14.91-6.34-.93c-3-.43-5.18-1.44-5.18-3.82,0-2.59,2.8-3.89,6.62-3.89,4.18,0,6.84,1.8,7.42,4.76h8.35c-.94-7.49-6.7-11.88-15.55-11.88-9.15,0-15.2,4.68-15.2,11.3,0,6.34,4,10,12,11.16l6.33.94c3.1.43,4.83,1.65,4.83,4,0,2.95-3,4.17-7.2,4.17-5.12,0-8-2.09-8.43-5.25h-8.49c.79,7.27,6.48,12.38,16.84,12.38,9.44,0,15.7-4.32,15.7-11.74C258.12,35.28,253.58,31.82,246.46,30.74Zm-27.65-2.3c0-8.06-4.9-13.46-15.27-13.46-9.79,0-15.26,5-16.34,12.6h8.57c.43-3,2.73-5.4,7.63-5.4,4.39,0,6.55,1.94,6.55,4.32,0,3.09-4,3.88-8.85,4.39-6.63.72-14.84,3-14.84,11.66,0,6.7,5,11,12.89,11,6.19,0,10.08-2.59,12-6.7.28,3.67,3,6.05,6.84,6.05h5v-7.7h-4.25Zm-8.5,9.36c0,5-4.32,8.64-9.57,8.64-3.24,0-6-1.37-6-4.25,0-3.67,4.39-4.68,8.42-5.11s6-1.22,7.13-2.88ZM281.09,15c-11.09,0-19.23,8.35-19.23,19.36,0,11.6,8.72,19.3,19.37,19.3,9,0,16.06-5.33,17.86-12.89h-9c-1.3,3.31-4.47,5.19-8.71,5.19-5.55,0-9.72-3.46-10.66-9.51H299.3V33.12C299.3,22.46,291.53,15,281.09,15Zm-9.87,15.26c1.37-5.18,5.26-7.7,9.72-7.7,4.9,0,8.64,2.8,9.51,7.7ZM19.3,23a9.84,9.84,0,0,1,9.5,7h9.14c-1.65-8.93-9-15-18.57-15A19,19,0,0,0,0,34.34c0,11.09,8.28,19.3,19.37,19.3,9.36,0,16.85-6,18.5-15H28.8a9.75,9.75,0,0,1-9.43,7.06c-6.27,0-10.66-4.83-10.66-11.31S13,23,19.3,23Zm41.11-8A19,19,0,0,0,41,34.34c0,11.09,8.28,19.3,19.37,19.3A19,19,0,0,0,79.92,34.27C79.92,23.33,71.64,15,60.41,15Zm.07,30.67c-6.19,0-10.73-4.83-10.73-11.31S54.22,23,60.41,23s10.8,4.89,10.8,11.37S66.67,45.65,60.48,45.65ZM123.41,15c-5.62,0-9.29,2.3-11.45,5.54V15.7h-8.57V52.92H112V32.69C112,27,115.63,23,121,23c5,0,8.06,3.53,8.06,8.64V52.92h8.64V31C137.66,21.6,132.84,15,123.41,15ZM92,.36a5.36,5.36,0,0,0-5.55,5.47,5.55,5.55,0,0,0,11.09,0A5.35,5.35,0,0,0,92,.36Zm-9.72,23h5.4V52.92h8.64V15.7h-14Zm298.17-7.7L366.2,52.92H372L375.29,44H392l3.33,8.88h6L386.87,15.7ZM377,39.23l6.45-17.56h.1l6.56,17.56ZM362.66,15.7l-7.88,29h-.11l-8.14-29H341l-8,28.93h-.1l-8-28.87H319L329.82,53h5.45l8.19-29.24h.11L352,53h5.66L368.1,15.7Zm135.25,0v4.86h12.32V52.92h5.6V20.56h12.32V15.7ZM467.82,52.92h25.54V48.06H473.43v-12h18.35V31.35H473.43V20.56h19.93V15.7H467.82ZM443,15.7h-5.6V52.92h24.32V48.06H443Zm-30.45,0h-5.61V52.92h24.32V48.06H412.52Z'/%3E%3C/svg%3E`;
        case 'textWithLogoLight':
            height = (0.25 * width).toFixed(2);
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 308.44 77.61'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fefefe;%7D%3C/style%3E%3C/defs%3E%3Cpath class='cls-1' d='M142.94,20.2l-7.88,29H135l-8.15-29h-5.55l-8,28.93h-.11l-8-28.87H99.27l10.84,37.27h5.44l8.2-29.24h.1l8.41,29.24h5.66L148.39,20.2Zm17.82,0L146.48,57.42h5.82l3.28-8.88h16.65l3.34,8.88h6L167.16,20.2Zm-3.44,23.52,6.45-17.55h.11l6.56,17.55ZM278.2,20.2v4.86h12.32V57.42h5.6V25.06h12.32V20.2ZM248.11,57.42h25.54V52.55H253.71V40.61h18.35V35.85H253.71V25.06h19.94V20.2H248.11ZM223.26,20.2h-5.61V57.42H242V52.55H223.26Zm-30.46,0h-5.6V57.42h24.32V52.55H192.8Zm-154,38A19.41,19.41,0,1,1,57.92,35.57H77.47a38.81,38.81,0,1,0,0,6.47H57.92A19.39,19.39,0,0,1,38.81,58.21Z'/%3E%3C/svg%3E`;
        default:
            height = width;
            return `data:image/svg+xml,%3Csvg width='${width}' height='${height}' viewBox='0 0 1024 1024' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect width='1024' height='1024' fill='%230052FF'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M152 512C152 710.823 313.177 872 512 872C710.823 872 872 710.823 872 512C872 313.177 710.823 152 512 152C313.177 152 152 313.177 152 512ZM420 396C406.745 396 396 406.745 396 420V604C396 617.255 406.745 628 420 628H604C617.255 628 628 617.255 628 604V420C628 406.745 617.255 396 604 396H420Z' fill='white'/%3E %3C/svg%3E `;
    }
};

// Copyright (c) 2018-2024 Coinbase, Inc. <https://www.coinbase.com/>
// TODO: clean up, or possibly deprecate Storage class
class ScopedLocalStorage {
    constructor(scope, module) {
        this.scope = scope;
        this.module = module;
    }
    storeObject(key, item) {
        this.setItem(key, JSON.stringify(item));
    }
    loadObject(key) {
        const item = this.getItem(key);
        return item ? JSON.parse(item) : undefined;
    }
    setItem(key, value) {
        localStorage.setItem(this.scopedKey(key), value);
    }
    getItem(key) {
        return localStorage.getItem(this.scopedKey(key));
    }
    removeItem(key) {
        localStorage.removeItem(this.scopedKey(key));
    }
    clear() {
        const prefix = this.scopedKey('');
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (typeof key === 'string' && key.startsWith(prefix)) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach((key) => localStorage.removeItem(key));
    }
    scopedKey(key) {
        return `-${this.scope}${this.module ? `:${this.module}` : ''}:${key}`;
    }
    static clearAll() {
        new ScopedLocalStorage('CBWSDK').clear();
        new ScopedLocalStorage('walletlink').clear();
    }
}

const standardErrorCodes = {
    rpc: {
        invalidInput: -32e3,
        resourceNotFound: -32001,
        resourceUnavailable: -32002,
        transactionRejected: -32003,
        methodNotSupported: -32004,
        limitExceeded: -32005,
        parse: -32700,
        invalidRequest: -32600,
        methodNotFound: -32601,
        invalidParams: -32602,
        internal: -32603,
    },
    provider: {
        userRejectedRequest: 4001,
        unauthorized: 4100,
        unsupportedMethod: 4200,
        disconnected: 4900,
        chainDisconnected: 4901,
        unsupportedChain: 4902,
    },
};
const errorValues = {
    '-32700': {
        standard: 'JSON RPC 2.0',
        message: 'Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text.',
    },
    '-32600': {
        standard: 'JSON RPC 2.0',
        message: 'The JSON sent is not a valid Request object.',
    },
    '-32601': {
        standard: 'JSON RPC 2.0',
        message: 'The method does not exist / is not available.',
    },
    '-32602': {
        standard: 'JSON RPC 2.0',
        message: 'Invalid method parameter(s).',
    },
    '-32603': {
        standard: 'JSON RPC 2.0',
        message: 'Internal JSON-RPC error.',
    },
    '-32000': {
        standard: 'EIP-1474',
        message: 'Invalid input.',
    },
    '-32001': {
        standard: 'EIP-1474',
        message: 'Resource not found.',
    },
    '-32002': {
        standard: 'EIP-1474',
        message: 'Resource unavailable.',
    },
    '-32003': {
        standard: 'EIP-1474',
        message: 'Transaction rejected.',
    },
    '-32004': {
        standard: 'EIP-1474',
        message: 'Method not supported.',
    },
    '-32005': {
        standard: 'EIP-1474',
        message: 'Request limit exceeded.',
    },
    '4001': {
        standard: 'EIP-1193',
        message: 'User rejected the request.',
    },
    '4100': {
        standard: 'EIP-1193',
        message: 'The requested account and/or method has not been authorized by the user.',
    },
    '4200': {
        standard: 'EIP-1193',
        message: 'The requested method is not supported by this Ethereum provider.',
    },
    '4900': {
        standard: 'EIP-1193',
        message: 'The provider is disconnected from all chains.',
    },
    '4901': {
        standard: 'EIP-1193',
        message: 'The provider is disconnected from the specified chain.',
    },
    '4902': {
        standard: 'EIP-3085',
        message: 'Unrecognized chain ID.',
    },
};

const FALLBACK_MESSAGE = 'Unspecified error message.';
const JSON_RPC_SERVER_ERROR_MESSAGE = 'Unspecified server error.';
/**
 * Gets the message for a given code, or a fallback message if the code has
 * no corresponding message.
 */
function getMessageFromCode(code, fallbackMessage = FALLBACK_MESSAGE) {
    if (code && Number.isInteger(code)) {
        const codeString = code.toString();
        if (hasKey(errorValues, codeString)) {
            return errorValues[codeString].message;
        }
        if (isJsonRpcServerError(code)) {
            return JSON_RPC_SERVER_ERROR_MESSAGE;
        }
    }
    return fallbackMessage;
}
/**
 * Returns whether the given code is valid.
 * A code is only valid if it has a message.
 */
function isValidCode(code) {
    if (!Number.isInteger(code)) {
        return false;
    }
    const codeString = code.toString();
    if (errorValues[codeString]) {
        return true;
    }
    if (isJsonRpcServerError(code)) {
        return true;
    }
    return false;
}
function serialize(error, { shouldIncludeStack = false } = {}) {
    const serialized = {};
    if (error &&
        typeof error === 'object' &&
        !Array.isArray(error) &&
        hasKey(error, 'code') &&
        isValidCode(error.code)) {
        const _error = error;
        serialized.code = _error.code;
        if (_error.message && typeof _error.message === 'string') {
            serialized.message = _error.message;
            if (hasKey(_error, 'data')) {
                serialized.data = _error.data;
            }
        }
        else {
            serialized.message = getMessageFromCode(serialized.code);
            serialized.data = { originalError: assignOriginalError(error) };
        }
    }
    else {
        serialized.code = standardErrorCodes.rpc.internal;
        serialized.message = hasStringProperty(error, 'message') ? error.message : FALLBACK_MESSAGE;
        serialized.data = { originalError: assignOriginalError(error) };
    }
    if (shouldIncludeStack) {
        serialized.stack = hasStringProperty(error, 'stack') ? error.stack : undefined;
    }
    return serialized;
}
// Internal
function isJsonRpcServerError(code) {
    return code >= -32099 && code <= -32e3;
}
function assignOriginalError(error) {
    if (error && typeof error === 'object' && !Array.isArray(error)) {
        return Object.assign({}, error);
    }
    return error;
}
function hasKey(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function hasStringProperty(obj, prop) {
    return (typeof obj === 'object' && obj !== null && prop in obj && typeof obj[prop] === 'string');
}

const standardErrors = {
    rpc: {
        parse: (arg) => getEthJsonRpcError(standardErrorCodes.rpc.parse, arg),
        invalidRequest: (arg) => getEthJsonRpcError(standardErrorCodes.rpc.invalidRequest, arg),
        invalidParams: (arg) => getEthJsonRpcError(standardErrorCodes.rpc.invalidParams, arg),
        methodNotFound: (arg) => getEthJsonRpcError(standardErrorCodes.rpc.methodNotFound, arg),
        internal: (arg) => getEthJsonRpcError(standardErrorCodes.rpc.internal, arg),
        server: (opts) => {
            if (!opts || typeof opts !== 'object' || Array.isArray(opts)) {
                throw new Error('Ethereum RPC Server errors must provide single object argument.');
            }
            const { code } = opts;
            if (!Number.isInteger(code) || code > -32005 || code < -32099) {
                throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
            }
            return getEthJsonRpcError(code, opts);
        },
        invalidInput: (arg) => getEthJsonRpcError(standardErrorCodes.rpc.invalidInput, arg),
        resourceNotFound: (arg) => getEthJsonRpcError(standardErrorCodes.rpc.resourceNotFound, arg),
        resourceUnavailable: (arg) => getEthJsonRpcError(standardErrorCodes.rpc.resourceUnavailable, arg),
        transactionRejected: (arg) => getEthJsonRpcError(standardErrorCodes.rpc.transactionRejected, arg),
        methodNotSupported: (arg) => getEthJsonRpcError(standardErrorCodes.rpc.methodNotSupported, arg),
        limitExceeded: (arg) => getEthJsonRpcError(standardErrorCodes.rpc.limitExceeded, arg),
    },
    provider: {
        userRejectedRequest: (arg) => {
            return getEthProviderError(standardErrorCodes.provider.userRejectedRequest, arg);
        },
        unauthorized: (arg) => {
            return getEthProviderError(standardErrorCodes.provider.unauthorized, arg);
        },
        unsupportedMethod: (arg) => {
            return getEthProviderError(standardErrorCodes.provider.unsupportedMethod, arg);
        },
        disconnected: (arg) => {
            return getEthProviderError(standardErrorCodes.provider.disconnected, arg);
        },
        chainDisconnected: (arg) => {
            return getEthProviderError(standardErrorCodes.provider.chainDisconnected, arg);
        },
        unsupportedChain: (arg) => {
            return getEthProviderError(standardErrorCodes.provider.unsupportedChain, arg);
        },
        custom: (opts) => {
            if (!opts || typeof opts !== 'object' || Array.isArray(opts)) {
                throw new Error('Ethereum Provider custom errors must provide single object argument.');
            }
            const { code, message, data } = opts;
            if (!message || typeof message !== 'string') {
                throw new Error('"message" must be a nonempty string');
            }
            return new EthereumProviderError(code, message, data);
        },
    },
};
// Internal
function getEthJsonRpcError(code, arg) {
    const [message, data] = parseOpts(arg);
    return new EthereumRpcError(code, message || getMessageFromCode(code), data);
}
function getEthProviderError(code, arg) {
    const [message, data] = parseOpts(arg);
    return new EthereumProviderError(code, message || getMessageFromCode(code), data);
}
function parseOpts(arg) {
    if (arg) {
        if (typeof arg === 'string') {
            return [arg];
        }
        else if (typeof arg === 'object' && !Array.isArray(arg)) {
            const { message, data } = arg;
            if (message && typeof message !== 'string') {
                throw new Error('Must specify string message.');
            }
            return [message || undefined, data];
        }
    }
    return [];
}
class EthereumRpcError extends Error {
    constructor(code, message, data) {
        if (!Number.isInteger(code)) {
            throw new Error('"code" must be an integer.');
        }
        if (!message || typeof message !== 'string') {
            throw new Error('"message" must be a nonempty string.');
        }
        super(message);
        this.code = code;
        if (data !== undefined) {
            this.data = data;
        }
    }
}
class EthereumProviderError extends EthereumRpcError {
    /**
     * Create an Ethereum Provider JSON-RPC error.
     * `code` must be an integer in the 1000 <= 4999 range.
     */
    constructor(code, message, data) {
        if (!isValidEthProviderCode(code)) {
            throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
        }
        super(code, message, data);
    }
}
function isValidEthProviderCode(code) {
    return Number.isInteger(code) && code >= 1000 && code <= 4999;
}

function OpaqueType() {
    return (value) => value;
}
const HexString = OpaqueType();
const AddressString = OpaqueType();
const BigIntString = OpaqueType();
function IntNumber(num) {
    return Math.floor(num);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
const INT_STRING_REGEX = /^[0-9]*$/;
const HEXADECIMAL_STRING_REGEX = /^[a-f0-9]*$/;
/**
 * @param length number of bytes
 */
function randomBytesHex(length) {
    return uint8ArrayToHex(crypto.getRandomValues(new Uint8Array(length)));
}
function uint8ArrayToHex(value) {
    return [...value].map((b) => b.toString(16).padStart(2, '0')).join('');
}
function hexStringToUint8Array(hexString) {
    return new Uint8Array(hexString.match(/.{1,2}/g).map((byte) => Number.parseInt(byte, 16)));
}
function hexStringFromBuffer(buf, includePrefix = false) {
    const hex = buf.toString('hex');
    return HexString(includePrefix ? `0x${hex}` : hex);
}
function encodeToHexString(str) {
    return hexStringFromBuffer(ensureBuffer(str), true);
}
function bigIntStringFromBigInt(bi) {
    return BigIntString(bi.toString(10));
}
function hexStringFromNumber(num) {
    return HexString(`0x${BigInt(num).toString(16)}`);
}
function has0xPrefix(str) {
    return str.startsWith('0x') || str.startsWith('0X');
}
function strip0x(hex) {
    if (has0xPrefix(hex)) {
        return hex.slice(2);
    }
    return hex;
}
function prepend0x(hex) {
    if (has0xPrefix(hex)) {
        return `0x${hex.slice(2)}`;
    }
    return `0x${hex}`;
}
function isHexString(hex) {
    if (typeof hex !== 'string') {
        return false;
    }
    const s = strip0x(hex).toLowerCase();
    return HEXADECIMAL_STRING_REGEX.test(s);
}
function ensureHexString(hex, includePrefix = false) {
    if (typeof hex === 'string') {
        const s = strip0x(hex).toLowerCase();
        if (HEXADECIMAL_STRING_REGEX.test(s)) {
            return HexString(includePrefix ? `0x${s}` : s);
        }
    }
    throw standardErrors.rpc.invalidParams(`"${String(hex)}" is not a hexadecimal string`);
}
function ensureEvenLengthHexString(hex, includePrefix = false) {
    let h = ensureHexString(hex, false);
    if (h.length % 2 === 1) {
        h = HexString(`0${h}`);
    }
    return includePrefix ? HexString(`0x${h}`) : h;
}
function ensureAddressString(str) {
    if (typeof str === 'string') {
        const s = strip0x(str).toLowerCase();
        if (isHexString(s) && s.length === 40) {
            return AddressString(prepend0x(s));
        }
    }
    throw standardErrors.rpc.invalidParams(`Invalid Ethereum address: ${String(str)}`);
}
function ensureBuffer(str) {
    if (Buffer.isBuffer(str)) {
        return str;
    }
    if (typeof str === 'string') {
        if (isHexString(str)) {
            const s = ensureEvenLengthHexString(str, false);
            return Buffer.from(s, 'hex');
        }
        return Buffer.from(str, 'utf8');
    }
    throw standardErrors.rpc.invalidParams(`Not binary data: ${String(str)}`);
}
function ensureIntNumber(num) {
    if (typeof num === 'number' && Number.isInteger(num)) {
        return IntNumber(num);
    }
    if (typeof num === 'string') {
        if (INT_STRING_REGEX.test(num)) {
            return IntNumber(Number(num));
        }
        if (isHexString(num)) {
            return IntNumber(Number(BigInt(ensureEvenLengthHexString(num, true))));
        }
    }
    throw standardErrors.rpc.invalidParams(`Not an integer: ${String(num)}`);
}
function ensureBigInt(val) {
    if (val !== null && (typeof val === 'bigint' || isBigNumber(val))) {
        return BigInt(val.toString(10));
    }
    if (typeof val === 'number') {
        return BigInt(ensureIntNumber(val));
    }
    if (typeof val === 'string') {
        if (INT_STRING_REGEX.test(val)) {
            return BigInt(val);
        }
        if (isHexString(val)) {
            return BigInt(ensureEvenLengthHexString(val, true));
        }
    }
    throw standardErrors.rpc.invalidParams(`Not an integer: ${String(val)}`);
}
function ensureParsedJSONObject(val) {
    if (typeof val === 'string') {
        return JSON.parse(val);
    }
    if (typeof val === 'object') {
        return val;
    }
    throw standardErrors.rpc.invalidParams(`Not a JSON string or an object: ${String(val)}`);
}
function isBigNumber(val) {
    if (val == null || typeof val.constructor !== 'function') {
        return false;
    }
    const { constructor } = val;
    return typeof constructor.config === 'function' && typeof constructor.EUCLID === 'number';
}
function getFavicon() {
    const el = document.querySelector('link[sizes="192x192"]') ||
        document.querySelector('link[sizes="180x180"]') ||
        document.querySelector('link[rel="icon"]') ||
        document.querySelector('link[rel="shortcut icon"]');
    const { protocol, host } = document.location;
    const href = el ? el.getAttribute('href') : null;
    if (!href || href.startsWith('javascript:') || href.startsWith('vbscript:')) {
        return `${protocol}//${host}/favicon.ico`; // fallback
    }
    if (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('data:')) {
        return href;
    }
    if (href.startsWith('//')) {
        return protocol + href;
    }
    return `${protocol}//${host}${href}`;
}

async function generateKeyPair() {
    return crypto.subtle.generateKey({
        name: 'ECDH',
        namedCurve: 'P-256',
    }, true, ['deriveKey']);
}
async function deriveSharedSecret(ownPrivateKey, peerPublicKey) {
    return crypto.subtle.deriveKey({
        name: 'ECDH',
        public: peerPublicKey,
    }, ownPrivateKey, {
        name: 'AES-GCM',
        length: 256,
    }, false, ['encrypt', 'decrypt']);
}
async function encrypt(sharedSecret, plainText) {
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const cipherText = await crypto.subtle.encrypt({
        name: 'AES-GCM',
        iv,
    }, sharedSecret, new TextEncoder().encode(plainText));
    return { iv, cipherText };
}
async function decrypt(sharedSecret, { iv, cipherText }) {
    const plainText = await crypto.subtle.decrypt({
        name: 'AES-GCM',
        iv,
    }, sharedSecret, cipherText);
    return new TextDecoder().decode(plainText);
}
function getFormat(keyType) {
    switch (keyType) {
        case 'public':
            return 'spki';
        case 'private':
            return 'pkcs8';
    }
}
async function exportKeyToHexString(type, key) {
    const format = getFormat(type);
    const exported = await crypto.subtle.exportKey(format, key);
    return uint8ArrayToHex(new Uint8Array(exported));
}
async function importKeyFromHexString(type, hexString) {
    const format = getFormat(type);
    const arrayBuffer = hexStringToUint8Array(hexString).buffer;
    return await crypto.subtle.importKey(format, new Uint8Array(arrayBuffer), {
        name: 'ECDH',
        namedCurve: 'P-256',
    }, true, type === 'private' ? ['deriveKey'] : []);
}
async function encryptContent(content, sharedSecret) {
    const serialized = JSON.stringify(content, (_, value) => {
        if (!(value instanceof Error))
            return value;
        const error = value;
        return Object.assign(Object.assign({}, (error.code ? { code: error.code } : {})), { message: error.message });
    });
    return encrypt(sharedSecret, serialized);
}
async function decryptContent(encryptedData, sharedSecret) {
    return JSON.parse(await decrypt(sharedSecret, encryptedData));
}

const OWN_PRIVATE_KEY = {
    storageKey: 'ownPrivateKey',
    keyType: 'private',
};
const OWN_PUBLIC_KEY = {
    storageKey: 'ownPublicKey',
    keyType: 'public',
};
const PEER_PUBLIC_KEY = {
    storageKey: 'peerPublicKey',
    keyType: 'public',
};
class SCWKeyManager {
    constructor() {
        this.storage = new ScopedLocalStorage('CBWSDK', 'SCWKeyManager');
        this.ownPrivateKey = null;
        this.ownPublicKey = null;
        this.peerPublicKey = null;
        this.sharedSecret = null;
    }
    async getOwnPublicKey() {
        await this.loadKeysIfNeeded();
        return this.ownPublicKey;
    }
    // returns null if the shared secret is not yet derived
    async getSharedSecret() {
        await this.loadKeysIfNeeded();
        return this.sharedSecret;
    }
    async setPeerPublicKey(key) {
        this.sharedSecret = null;
        this.peerPublicKey = key;
        await this.storeKey(PEER_PUBLIC_KEY, key);
        await this.loadKeysIfNeeded();
    }
    async clear() {
        this.ownPrivateKey = null;
        this.ownPublicKey = null;
        this.peerPublicKey = null;
        this.sharedSecret = null;
        this.storage.removeItem(OWN_PUBLIC_KEY.storageKey);
        this.storage.removeItem(OWN_PRIVATE_KEY.storageKey);
        this.storage.removeItem(PEER_PUBLIC_KEY.storageKey);
    }
    async generateKeyPair() {
        const newKeyPair = await generateKeyPair();
        this.ownPrivateKey = newKeyPair.privateKey;
        this.ownPublicKey = newKeyPair.publicKey;
        await this.storeKey(OWN_PRIVATE_KEY, newKeyPair.privateKey);
        await this.storeKey(OWN_PUBLIC_KEY, newKeyPair.publicKey);
    }
    async loadKeysIfNeeded() {
        if (this.ownPrivateKey === null) {
            this.ownPrivateKey = await this.loadKey(OWN_PRIVATE_KEY);
        }
        if (this.ownPublicKey === null) {
            this.ownPublicKey = await this.loadKey(OWN_PUBLIC_KEY);
        }
        if (this.ownPrivateKey === null || this.ownPublicKey === null) {
            await this.generateKeyPair();
        }
        if (this.peerPublicKey === null) {
            this.peerPublicKey = await this.loadKey(PEER_PUBLIC_KEY);
        }
        if (this.sharedSecret === null) {
            if (this.ownPrivateKey === null || this.peerPublicKey === null)
                return;
            this.sharedSecret = await deriveSharedSecret(this.ownPrivateKey, this.peerPublicKey);
        }
    }
    // storage methods
    async loadKey(item) {
        const key = this.storage.getItem(item.storageKey);
        if (!key)
            return null;
        return importKeyFromHexString(item.keyType, key);
    }
    async storeKey(item, key) {
        const hexString = await exportKeyToHexString(item.keyType, key);
        this.storage.setItem(item.storageKey, hexString);
    }
}

const VERSION$1 = '4.3.0';
const NAME = '@coinbase/wallet-sdk';

async function fetchRPCRequest(request, rpcUrl) {
    const requestBody = Object.assign(Object.assign({}, request), { jsonrpc: '2.0', id: crypto.randomUUID() });
    const res = await window.fetch(rpcUrl, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'X-Cbw-Sdk-Version': VERSION$1,
            'X-Cbw-Sdk-Platform': NAME,
        },
    });
    const { result, error } = await res.json();
    if (error)
        throw error;
    return result;
}
function getCoinbaseInjectedLegacyProvider() {
    const window = globalThis;
    return window.coinbaseWalletExtension;
}
function getInjectedEthereum() {
    var _a, _b;
    try {
        const window = globalThis;
        return (_a = window.ethereum) !== null && _a !== void 0 ? _a : (_b = window.top) === null || _b === void 0 ? void 0 : _b.ethereum;
    }
    catch (_c) {
        return undefined;
    }
}
function getCoinbaseInjectedProvider({ metadata, preference, }) {
    var _a, _b;
    const { appName, appLogoUrl, appChainIds } = metadata;
    if (preference.options !== 'smartWalletOnly') {
        const extension = getCoinbaseInjectedLegacyProvider();
        if (extension) {
            (_a = extension.setAppInfo) === null || _a === void 0 ? void 0 : _a.call(extension, appName, appLogoUrl, appChainIds, preference);
            return extension;
        }
    }
    const ethereum = getInjectedEthereum();
    if (ethereum === null || ethereum === void 0 ? void 0 : ethereum.isCoinbaseBrowser) {
        (_b = ethereum.setAppInfo) === null || _b === void 0 ? void 0 : _b.call(ethereum, appName, appLogoUrl, appChainIds, preference);
        return ethereum;
    }
    return undefined;
}
/**
 * Validates the arguments for an invalid request and returns an error if any validation fails.
 * Valid request args are defined here: https://eips.ethereum.org/EIPS/eip-1193#request
 * @param args The request arguments to validate.
 * @returns An error object if the arguments are invalid, otherwise undefined.
 */
function checkErrorForInvalidRequestArgs(args) {
    if (!args || typeof args !== 'object' || Array.isArray(args)) {
        throw standardErrors.rpc.invalidParams({
            message: 'Expected a single, non-array, object argument.',
            data: args,
        });
    }
    const { method, params } = args;
    if (typeof method !== 'string' || method.length === 0) {
        throw standardErrors.rpc.invalidParams({
            message: "'args.method' must be a non-empty string.",
            data: args,
        });
    }
    if (params !== undefined &&
        !Array.isArray(params) &&
        (typeof params !== 'object' || params === null)) {
        throw standardErrors.rpc.invalidParams({
            message: "'args.params' must be an object or array if provided.",
            data: args,
        });
    }
    switch (method) {
        case 'eth_sign':
        case 'eth_signTypedData_v2':
        case 'eth_subscribe':
        case 'eth_unsubscribe':
            throw standardErrors.provider.unsupportedMethod();
    }
}

const ACCOUNTS_KEY = 'accounts';
const ACTIVE_CHAIN_STORAGE_KEY = 'activeChain';
const AVAILABLE_CHAINS_STORAGE_KEY = 'availableChains';
const WALLET_CAPABILITIES_STORAGE_KEY = 'walletCapabilities';
class SCWSigner {
    constructor(params) {
        var _a, _b, _c;
        this.metadata = params.metadata;
        this.communicator = params.communicator;
        this.callback = params.callback;
        this.keyManager = new SCWKeyManager();
        this.storage = new ScopedLocalStorage('CBWSDK', 'SCWStateManager');
        this.accounts = (_a = this.storage.loadObject(ACCOUNTS_KEY)) !== null && _a !== void 0 ? _a : [];
        this.chain = this.storage.loadObject(ACTIVE_CHAIN_STORAGE_KEY) || {
            id: (_c = (_b = params.metadata.appChainIds) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : 1,
        };
        this.handshake = this.handshake.bind(this);
        this.request = this.request.bind(this);
        this.createRequestMessage = this.createRequestMessage.bind(this);
        this.decryptResponseMessage = this.decryptResponseMessage.bind(this);
    }
    async handshake(args) {
        var _a, _b, _c, _d;
        // Open the popup before constructing the request message.
        // This is to ensure that the popup is not blocked by some browsers (i.e. Safari)
        await ((_b = (_a = this.communicator).waitForPopupLoaded) === null || _b === void 0 ? void 0 : _b.call(_a));
        const handshakeMessage = await this.createRequestMessage({
            handshake: {
                method: args.method,
                params: Object.assign({}, this.metadata, (_c = args.params) !== null && _c !== void 0 ? _c : {}),
            },
        });
        const response = await this.communicator.postRequestAndWaitForResponse(handshakeMessage);
        // store peer's public key
        if ('failure' in response.content)
            throw response.content.failure;
        const peerPublicKey = await importKeyFromHexString('public', response.sender);
        await this.keyManager.setPeerPublicKey(peerPublicKey);
        const decrypted = await this.decryptResponseMessage(response);
        const result = decrypted.result;
        if ('error' in result)
            throw result.error;
        switch (args.method) {
            case 'eth_requestAccounts': {
                const accounts = result.value;
                this.accounts = accounts;
                this.storage.storeObject(ACCOUNTS_KEY, accounts);
                (_d = this.callback) === null || _d === void 0 ? void 0 : _d.call(this, 'accountsChanged', accounts);
                break;
            }
        }
    }
    async request(request) {
        var _a;
        if (this.accounts.length === 0) {
            switch (request.method) {
                case 'wallet_sendCalls':
                    return this.sendRequestToPopup(request);
                default:
                    throw standardErrors.provider.unauthorized();
            }
        }
        switch (request.method) {
            case 'eth_requestAccounts':
                (_a = this.callback) === null || _a === void 0 ? void 0 : _a.call(this, 'connect', { chainId: hexStringFromNumber(this.chain.id) });
                return this.accounts;
            case 'eth_accounts':
                return this.accounts;
            case 'eth_coinbase':
                return this.accounts[0];
            case 'net_version':
                return this.chain.id;
            case 'eth_chainId':
                return hexStringFromNumber(this.chain.id);
            case 'wallet_getCapabilities':
                return this.storage.loadObject(WALLET_CAPABILITIES_STORAGE_KEY);
            case 'wallet_switchEthereumChain':
                return this.handleSwitchChainRequest(request);
            case 'eth_ecRecover':
            case 'personal_sign':
            case 'wallet_sign':
            case 'personal_ecRecover':
            case 'eth_signTransaction':
            case 'eth_sendTransaction':
            case 'eth_signTypedData_v1':
            case 'eth_signTypedData_v3':
            case 'eth_signTypedData_v4':
            case 'eth_signTypedData':
            case 'wallet_addEthereumChain':
            case 'wallet_watchAsset':
            case 'wallet_sendCalls':
            case 'wallet_showCallsStatus':
            case 'wallet_grantPermissions':
                return this.sendRequestToPopup(request);
            default:
                if (!this.chain.rpcUrl)
                    throw standardErrors.rpc.internal('No RPC URL set for chain');
                return fetchRPCRequest(request, this.chain.rpcUrl);
        }
    }
    async sendRequestToPopup(request) {
        var _a, _b;
        // Open the popup before constructing the request message.
        // This is to ensure that the popup is not blocked by some browsers (i.e. Safari)
        await ((_b = (_a = this.communicator).waitForPopupLoaded) === null || _b === void 0 ? void 0 : _b.call(_a));
        const response = await this.sendEncryptedRequest(request);
        const decrypted = await this.decryptResponseMessage(response);
        const result = decrypted.result;
        if ('error' in result)
            throw result.error;
        return result.value;
    }
    async cleanup() {
        var _a, _b;
        this.storage.clear();
        await this.keyManager.clear();
        this.accounts = [];
        this.chain = {
            id: (_b = (_a = this.metadata.appChainIds) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : 1,
        };
    }
    /**
     * @returns `null` if the request was successful.
     * https://eips.ethereum.org/EIPS/eip-3326#wallet_switchethereumchain
     */
    async handleSwitchChainRequest(request) {
        var _a;
        const params = request.params;
        if (!params || !((_a = params[0]) === null || _a === void 0 ? void 0 : _a.chainId)) {
            throw standardErrors.rpc.invalidParams();
        }
        const chainId = ensureIntNumber(params[0].chainId);
        const localResult = this.updateChain(chainId);
        if (localResult)
            return null;
        const popupResult = await this.sendRequestToPopup(request);
        if (popupResult === null) {
            this.updateChain(chainId);
        }
        return popupResult;
    }
    async sendEncryptedRequest(request) {
        const sharedSecret = await this.keyManager.getSharedSecret();
        if (!sharedSecret) {
            throw standardErrors.provider.unauthorized('No valid session found, try requestAccounts before other methods');
        }
        const encrypted = await encryptContent({
            action: request,
            chainId: this.chain.id,
        }, sharedSecret);
        const message = await this.createRequestMessage({ encrypted });
        return this.communicator.postRequestAndWaitForResponse(message);
    }
    async createRequestMessage(content) {
        const publicKey = await exportKeyToHexString('public', await this.keyManager.getOwnPublicKey());
        return {
            id: crypto.randomUUID(),
            sender: publicKey,
            content,
            timestamp: new Date(),
        };
    }
    async decryptResponseMessage(message) {
        var _a, _b;
        const content = message.content;
        // throw protocol level error
        if ('failure' in content) {
            throw content.failure;
        }
        const sharedSecret = await this.keyManager.getSharedSecret();
        if (!sharedSecret) {
            throw standardErrors.provider.unauthorized('Invalid session');
        }
        const response = await decryptContent(content.encrypted, sharedSecret);
        const availableChains = (_a = response.data) === null || _a === void 0 ? void 0 : _a.chains;
        if (availableChains) {
            const chains = Object.entries(availableChains).map(([id, rpcUrl]) => ({
                id: Number(id),
                rpcUrl,
            }));
            this.storage.storeObject(AVAILABLE_CHAINS_STORAGE_KEY, chains);
            this.updateChain(this.chain.id, chains);
        }
        const walletCapabilities = (_b = response.data) === null || _b === void 0 ? void 0 : _b.capabilities;
        if (walletCapabilities) {
            this.storage.storeObject(WALLET_CAPABILITIES_STORAGE_KEY, walletCapabilities);
        }
        return response;
    }
    updateChain(chainId, newAvailableChains) {
        var _a;
        const chains = newAvailableChains !== null && newAvailableChains !== void 0 ? newAvailableChains : this.storage.loadObject(AVAILABLE_CHAINS_STORAGE_KEY);
        const chain = chains === null || chains === void 0 ? void 0 : chains.find((chain) => chain.id === chainId);
        if (!chain)
            return false;
        if (chain !== this.chain) {
            this.chain = chain;
            this.storage.storeObject(ACTIVE_CHAIN_STORAGE_KEY, chain);
            (_a = this.callback) === null || _a === void 0 ? void 0 : _a.call(this, 'chainChanged', hexStringFromNumber(chain.id));
        }
        return true;
    }
}

var sha3 = {};

var _assert = {};

var hasRequired_assert;

function require_assert () {
	if (hasRequired_assert) return _assert;
	hasRequired_assert = 1;
	/**
	 * Internal assertion helpers.
	 * @module
	 */
	Object.defineProperty(_assert, "__esModule", { value: true });
	_assert.anumber = anumber;
	_assert.abytes = abytes;
	_assert.ahash = ahash;
	_assert.aexists = aexists;
	_assert.aoutput = aoutput;
	/** Asserts something is positive integer. */
	function anumber(n) {
	    if (!Number.isSafeInteger(n) || n < 0)
	        throw new Error('positive integer expected, got ' + n);
	}
	/** Is number an Uint8Array? Copied from utils for perf. */
	function isBytes(a) {
	    return a instanceof Uint8Array || (ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array');
	}
	/** Asserts something is Uint8Array. */
	function abytes(b, ...lengths) {
	    if (!isBytes(b))
	        throw new Error('Uint8Array expected');
	    if (lengths.length > 0 && !lengths.includes(b.length))
	        throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
	}
	/** Asserts something is hash */
	function ahash(h) {
	    if (typeof h !== 'function' || typeof h.create !== 'function')
	        throw new Error('Hash should be wrapped by utils.wrapConstructor');
	    anumber(h.outputLen);
	    anumber(h.blockLen);
	}
	/** Asserts a hash instance has not been destroyed / finished */
	function aexists(instance, checkFinished = true) {
	    if (instance.destroyed)
	        throw new Error('Hash instance has been destroyed');
	    if (checkFinished && instance.finished)
	        throw new Error('Hash#digest() has already been called');
	}
	/** Asserts output is properly-sized byte array */
	function aoutput(out, instance) {
	    abytes(out);
	    const min = instance.outputLen;
	    if (out.length < min) {
	        throw new Error('digestInto() expects output buffer of length at least ' + min);
	    }
	}
	
	return _assert;
}

var _u64 = {};

var hasRequired_u64;

function require_u64 () {
	if (hasRequired_u64) return _u64;
	hasRequired_u64 = 1;
	Object.defineProperty(_u64, "__esModule", { value: true });
	_u64.add5L = _u64.add5H = _u64.add4H = _u64.add4L = _u64.add3H = _u64.add3L = _u64.rotlBL = _u64.rotlBH = _u64.rotlSL = _u64.rotlSH = _u64.rotr32L = _u64.rotr32H = _u64.rotrBL = _u64.rotrBH = _u64.rotrSL = _u64.rotrSH = _u64.shrSL = _u64.shrSH = _u64.toBig = void 0;
	_u64.fromBig = fromBig;
	_u64.split = split;
	_u64.add = add;
	/**
	 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
	 * @todo re-check https://issues.chromium.org/issues/42212588
	 * @module
	 */
	const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
	const _32n = /* @__PURE__ */ BigInt(32);
	function fromBig(n, le = false) {
	    if (le)
	        return { h: Number(n & U32_MASK64), l: Number((n >> _32n) & U32_MASK64) };
	    return { h: Number((n >> _32n) & U32_MASK64) | 0, l: Number(n & U32_MASK64) | 0 };
	}
	function split(lst, le = false) {
	    let Ah = new Uint32Array(lst.length);
	    let Al = new Uint32Array(lst.length);
	    for (let i = 0; i < lst.length; i++) {
	        const { h, l } = fromBig(lst[i], le);
	        [Ah[i], Al[i]] = [h, l];
	    }
	    return [Ah, Al];
	}
	const toBig = (h, l) => (BigInt(h >>> 0) << _32n) | BigInt(l >>> 0);
	_u64.toBig = toBig;
	// for Shift in [0, 32)
	const shrSH = (h, _l, s) => h >>> s;
	_u64.shrSH = shrSH;
	const shrSL = (h, l, s) => (h << (32 - s)) | (l >>> s);
	_u64.shrSL = shrSL;
	// Right rotate for Shift in [1, 32)
	const rotrSH = (h, l, s) => (h >>> s) | (l << (32 - s));
	_u64.rotrSH = rotrSH;
	const rotrSL = (h, l, s) => (h << (32 - s)) | (l >>> s);
	_u64.rotrSL = rotrSL;
	// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
	const rotrBH = (h, l, s) => (h << (64 - s)) | (l >>> (s - 32));
	_u64.rotrBH = rotrBH;
	const rotrBL = (h, l, s) => (h >>> (s - 32)) | (l << (64 - s));
	_u64.rotrBL = rotrBL;
	// Right rotate for shift===32 (just swaps l&h)
	const rotr32H = (_h, l) => l;
	_u64.rotr32H = rotr32H;
	const rotr32L = (h, _l) => h;
	_u64.rotr32L = rotr32L;
	// Left rotate for Shift in [1, 32)
	const rotlSH = (h, l, s) => (h << s) | (l >>> (32 - s));
	_u64.rotlSH = rotlSH;
	const rotlSL = (h, l, s) => (l << s) | (h >>> (32 - s));
	_u64.rotlSL = rotlSL;
	// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
	const rotlBH = (h, l, s) => (l << (s - 32)) | (h >>> (64 - s));
	_u64.rotlBH = rotlBH;
	const rotlBL = (h, l, s) => (h << (s - 32)) | (l >>> (64 - s));
	_u64.rotlBL = rotlBL;
	// JS uses 32-bit signed integers for bitwise operations which means we cannot
	// simple take carry out of low bit sum by shift, we need to use division.
	function add(Ah, Al, Bh, Bl) {
	    const l = (Al >>> 0) + (Bl >>> 0);
	    return { h: (Ah + Bh + ((l / 2 ** 32) | 0)) | 0, l: l | 0 };
	}
	// Addition with more than 2 elements
	const add3L = (Al, Bl, Cl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
	_u64.add3L = add3L;
	const add3H = (low, Ah, Bh, Ch) => (Ah + Bh + Ch + ((low / 2 ** 32) | 0)) | 0;
	_u64.add3H = add3H;
	const add4L = (Al, Bl, Cl, Dl) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
	_u64.add4L = add4L;
	const add4H = (low, Ah, Bh, Ch, Dh) => (Ah + Bh + Ch + Dh + ((low / 2 ** 32) | 0)) | 0;
	_u64.add4H = add4H;
	const add5L = (Al, Bl, Cl, Dl, El) => (Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
	_u64.add5L = add5L;
	const add5H = (low, Ah, Bh, Ch, Dh, Eh) => (Ah + Bh + Ch + Dh + Eh + ((low / 2 ** 32) | 0)) | 0;
	_u64.add5H = add5H;
	// prettier-ignore
	const u64 = {
	    fromBig, split, toBig,
	    shrSH, shrSL,
	    rotrSH, rotrSL, rotrBH, rotrBL,
	    rotr32H, rotr32L,
	    rotlSH, rotlSL, rotlBH, rotlBL,
	    add, add3L, add3H, add4L, add4H, add5H, add5L,
	};
	_u64.default = u64;
	
	return _u64;
}

var utils$2 = {};

var crypto$1 = {};

var hasRequiredCrypto;

function requireCrypto () {
	if (hasRequiredCrypto) return crypto$1;
	hasRequiredCrypto = 1;
	Object.defineProperty(crypto$1, "__esModule", { value: true });
	crypto$1.crypto = void 0;
	crypto$1.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;
	
	return crypto$1;
}

var hasRequiredUtils$2;

function requireUtils$2 () {
	if (hasRequiredUtils$2) return utils$2;
	hasRequiredUtils$2 = 1;
	(function (exports) {
		/**
		 * Utilities for hex, bytes, CSPRNG.
		 * @module
		 */
		/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.Hash = exports.nextTick = exports.byteSwapIfBE = exports.isLE = void 0;
		exports.isBytes = isBytes;
		exports.u8 = u8;
		exports.u32 = u32;
		exports.createView = createView;
		exports.rotr = rotr;
		exports.rotl = rotl;
		exports.byteSwap = byteSwap;
		exports.byteSwap32 = byteSwap32;
		exports.bytesToHex = bytesToHex;
		exports.hexToBytes = hexToBytes;
		exports.asyncLoop = asyncLoop;
		exports.utf8ToBytes = utf8ToBytes;
		exports.toBytes = toBytes;
		exports.concatBytes = concatBytes;
		exports.checkOpts = checkOpts;
		exports.wrapConstructor = wrapConstructor;
		exports.wrapConstructorWithOpts = wrapConstructorWithOpts;
		exports.wrapXOFConstructorWithOpts = wrapXOFConstructorWithOpts;
		exports.randomBytes = randomBytes;
		// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
		// node.js versions earlier than v19 don't declare it in global scope.
		// For node.js, package.json#exports field mapping rewrites import
		// from `crypto` to `cryptoNode`, which imports native module.
		// Makes the utils un-importable in browsers without a bundler.
		// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
		const crypto_1 = requireCrypto();
		const _assert_js_1 = /*@__PURE__*/ require_assert();
		// export { isBytes } from './_assert.js';
		// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
		function isBytes(a) {
		    return a instanceof Uint8Array || (ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array');
		}
		// Cast array to different type
		function u8(arr) {
		    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
		}
		function u32(arr) {
		    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
		}
		// Cast array to view
		function createView(arr) {
		    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
		}
		/** The rotate right (circular right shift) operation for uint32 */
		function rotr(word, shift) {
		    return (word << (32 - shift)) | (word >>> shift);
		}
		/** The rotate left (circular left shift) operation for uint32 */
		function rotl(word, shift) {
		    return (word << shift) | ((word >>> (32 - shift)) >>> 0);
		}
		/** Is current platform little-endian? Most are. Big-Endian platform: IBM */
		exports.isLE = (() => new Uint8Array(new Uint32Array([0x11223344]).buffer)[0] === 0x44)();
		// The byte swap operation for uint32
		function byteSwap(word) {
		    return (((word << 24) & 0xff000000) |
		        ((word << 8) & 0xff0000) |
		        ((word >>> 8) & 0xff00) |
		        ((word >>> 24) & 0xff));
		}
		/** Conditionally byte swap if on a big-endian platform */
		exports.byteSwapIfBE = exports.isLE
		    ? (n) => n
		    : (n) => byteSwap(n);
		/** In place byte swap for Uint32Array */
		function byteSwap32(arr) {
		    for (let i = 0; i < arr.length; i++) {
		        arr[i] = byteSwap(arr[i]);
		    }
		}
		// Array where index 0xf0 (240) is mapped to string 'f0'
		const hexes = /* @__PURE__ */ Array.from({ length: 256 }, (_, i) => i.toString(16).padStart(2, '0'));
		/**
		 * Convert byte array to hex string.
		 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
		 */
		function bytesToHex(bytes) {
		    (0, _assert_js_1.abytes)(bytes);
		    // pre-caching improves the speed 6x
		    let hex = '';
		    for (let i = 0; i < bytes.length; i++) {
		        hex += hexes[bytes[i]];
		    }
		    return hex;
		}
		// We use optimized technique to convert hex string to byte array
		const asciis = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
		function asciiToBase16(ch) {
		    if (ch >= asciis._0 && ch <= asciis._9)
		        return ch - asciis._0; // '2' => 50-48
		    if (ch >= asciis.A && ch <= asciis.F)
		        return ch - (asciis.A - 10); // 'B' => 66-(65-10)
		    if (ch >= asciis.a && ch <= asciis.f)
		        return ch - (asciis.a - 10); // 'b' => 98-(97-10)
		    return;
		}
		/**
		 * Convert hex string to byte array.
		 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
		 */
		function hexToBytes(hex) {
		    if (typeof hex !== 'string')
		        throw new Error('hex string expected, got ' + typeof hex);
		    const hl = hex.length;
		    const al = hl / 2;
		    if (hl % 2)
		        throw new Error('hex string expected, got unpadded hex of length ' + hl);
		    const array = new Uint8Array(al);
		    for (let ai = 0, hi = 0; ai < al; ai++, hi += 2) {
		        const n1 = asciiToBase16(hex.charCodeAt(hi));
		        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
		        if (n1 === undefined || n2 === undefined) {
		            const char = hex[hi] + hex[hi + 1];
		            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
		        }
		        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
		    }
		    return array;
		}
		/**
		 * There is no setImmediate in browser and setTimeout is slow.
		 * Call of async fn will return Promise, which will be fullfiled only on
		 * next scheduler queue processing step and this is exactly what we need.
		 */
		const nextTick = async () => { };
		exports.nextTick = nextTick;
		/** Returns control to thread each 'tick' ms to avoid blocking. */
		async function asyncLoop(iters, tick, cb) {
		    let ts = Date.now();
		    for (let i = 0; i < iters; i++) {
		        cb(i);
		        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
		        const diff = Date.now() - ts;
		        if (diff >= 0 && diff < tick)
		            continue;
		        await (0, exports.nextTick)();
		        ts += diff;
		    }
		}
		/**
		 * Convert JS string to byte array.
		 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
		 */
		function utf8ToBytes(str) {
		    if (typeof str !== 'string')
		        throw new Error('utf8ToBytes expected string, got ' + typeof str);
		    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
		}
		/**
		 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
		 * Warning: when Uint8Array is passed, it would NOT get copied.
		 * Keep in mind for future mutable operations.
		 */
		function toBytes(data) {
		    if (typeof data === 'string')
		        data = utf8ToBytes(data);
		    (0, _assert_js_1.abytes)(data);
		    return data;
		}
		/**
		 * Copies several Uint8Arrays into one.
		 */
		function concatBytes(...arrays) {
		    let sum = 0;
		    for (let i = 0; i < arrays.length; i++) {
		        const a = arrays[i];
		        (0, _assert_js_1.abytes)(a);
		        sum += a.length;
		    }
		    const res = new Uint8Array(sum);
		    for (let i = 0, pad = 0; i < arrays.length; i++) {
		        const a = arrays[i];
		        res.set(a, pad);
		        pad += a.length;
		    }
		    return res;
		}
		/** For runtime check if class implements interface */
		class Hash {
		    // Safe version that clones internal state
		    clone() {
		        return this._cloneInto();
		    }
		}
		exports.Hash = Hash;
		function checkOpts(defaults, opts) {
		    if (opts !== undefined && {}.toString.call(opts) !== '[object Object]')
		        throw new Error('Options should be object or undefined');
		    const merged = Object.assign(defaults, opts);
		    return merged;
		}
		/** Wraps hash function, creating an interface on top of it */
		function wrapConstructor(hashCons) {
		    const hashC = (msg) => hashCons().update(toBytes(msg)).digest();
		    const tmp = hashCons();
		    hashC.outputLen = tmp.outputLen;
		    hashC.blockLen = tmp.blockLen;
		    hashC.create = () => hashCons();
		    return hashC;
		}
		function wrapConstructorWithOpts(hashCons) {
		    const hashC = (msg, opts) => hashCons(opts).update(toBytes(msg)).digest();
		    const tmp = hashCons({});
		    hashC.outputLen = tmp.outputLen;
		    hashC.blockLen = tmp.blockLen;
		    hashC.create = (opts) => hashCons(opts);
		    return hashC;
		}
		function wrapXOFConstructorWithOpts(hashCons) {
		    const hashC = (msg, opts) => hashCons(opts).update(toBytes(msg)).digest();
		    const tmp = hashCons({});
		    hashC.outputLen = tmp.outputLen;
		    hashC.blockLen = tmp.blockLen;
		    hashC.create = (opts) => hashCons(opts);
		    return hashC;
		}
		/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */
		function randomBytes(bytesLength = 32) {
		    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === 'function') {
		        return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
		    }
		    // Legacy Node.js compatibility
		    if (crypto_1.crypto && typeof crypto_1.crypto.randomBytes === 'function') {
		        return crypto_1.crypto.randomBytes(bytesLength);
		    }
		    throw new Error('crypto.getRandomValues must be defined');
		}
		
	} (utils$2));
	return utils$2;
}

var hasRequiredSha3;

function requireSha3 () {
	if (hasRequiredSha3) return sha3;
	hasRequiredSha3 = 1;
	Object.defineProperty(sha3, "__esModule", { value: true });
	sha3.shake256 = sha3.shake128 = sha3.keccak_512 = sha3.keccak_384 = sha3.keccak_256 = sha3.keccak_224 = sha3.sha3_512 = sha3.sha3_384 = sha3.sha3_256 = sha3.sha3_224 = sha3.Keccak = void 0;
	sha3.keccakP = keccakP;
	/**
	 * SHA3 (keccak) hash function, based on a new "Sponge function" design.
	 * Different from older hashes, the internal state is bigger than output size.
	 *
	 * Check out [FIPS-202](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.202.pdf),
	 * [Website](https://keccak.team/keccak.html),
	 * [the differences between SHA-3 and Keccak](https://crypto.stackexchange.com/questions/15727/what-are-the-key-differences-between-the-draft-sha-3-standard-and-the-keccak-sub).
	 *
	 * Check out `sha3-addons` module for cSHAKE, k12, and others.
	 * @module
	 */
	const _assert_js_1 = /*@__PURE__*/ require_assert();
	const _u64_js_1 = /*@__PURE__*/ require_u64();
	const utils_js_1 = /*@__PURE__*/ requireUtils$2();
	// Various per round constants calculations
	const SHA3_PI = [];
	const SHA3_ROTL = [];
	const _SHA3_IOTA = [];
	const _0n = /* @__PURE__ */ BigInt(0);
	const _1n = /* @__PURE__ */ BigInt(1);
	const _2n = /* @__PURE__ */ BigInt(2);
	const _7n = /* @__PURE__ */ BigInt(7);
	const _256n = /* @__PURE__ */ BigInt(256);
	const _0x71n = /* @__PURE__ */ BigInt(0x71);
	for (let round = 0, R = _1n, x = 1, y = 0; round < 24; round++) {
	    // Pi
	    [x, y] = [y, (2 * x + 3 * y) % 5];
	    SHA3_PI.push(2 * (5 * y + x));
	    // Rotational
	    SHA3_ROTL.push((((round + 1) * (round + 2)) / 2) % 64);
	    // Iota
	    let t = _0n;
	    for (let j = 0; j < 7; j++) {
	        R = ((R << _1n) ^ ((R >> _7n) * _0x71n)) % _256n;
	        if (R & _2n)
	            t ^= _1n << ((_1n << /* @__PURE__ */ BigInt(j)) - _1n);
	    }
	    _SHA3_IOTA.push(t);
	}
	const [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ (0, _u64_js_1.split)(_SHA3_IOTA, true);
	// Left rotation (without 0, 32, 64)
	const rotlH = (h, l, s) => (s > 32 ? (0, _u64_js_1.rotlBH)(h, l, s) : (0, _u64_js_1.rotlSH)(h, l, s));
	const rotlL = (h, l, s) => (s > 32 ? (0, _u64_js_1.rotlBL)(h, l, s) : (0, _u64_js_1.rotlSL)(h, l, s));
	/** `keccakf1600` internal function, additionally allows to adjust round count. */
	function keccakP(s, rounds = 24) {
	    const B = new Uint32Array(5 * 2);
	    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
	    for (let round = 24 - rounds; round < 24; round++) {
	        // Theta θ
	        for (let x = 0; x < 10; x++)
	            B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
	        for (let x = 0; x < 10; x += 2) {
	            const idx1 = (x + 8) % 10;
	            const idx0 = (x + 2) % 10;
	            const B0 = B[idx0];
	            const B1 = B[idx0 + 1];
	            const Th = rotlH(B0, B1, 1) ^ B[idx1];
	            const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
	            for (let y = 0; y < 50; y += 10) {
	                s[x + y] ^= Th;
	                s[x + y + 1] ^= Tl;
	            }
	        }
	        // Rho (ρ) and Pi (π)
	        let curH = s[2];
	        let curL = s[3];
	        for (let t = 0; t < 24; t++) {
	            const shift = SHA3_ROTL[t];
	            const Th = rotlH(curH, curL, shift);
	            const Tl = rotlL(curH, curL, shift);
	            const PI = SHA3_PI[t];
	            curH = s[PI];
	            curL = s[PI + 1];
	            s[PI] = Th;
	            s[PI + 1] = Tl;
	        }
	        // Chi (χ)
	        for (let y = 0; y < 50; y += 10) {
	            for (let x = 0; x < 10; x++)
	                B[x] = s[y + x];
	            for (let x = 0; x < 10; x++)
	                s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
	        }
	        // Iota (ι)
	        s[0] ^= SHA3_IOTA_H[round];
	        s[1] ^= SHA3_IOTA_L[round];
	    }
	    B.fill(0);
	}
	/** Keccak sponge function. */
	class Keccak extends utils_js_1.Hash {
	    // NOTE: we accept arguments in bytes instead of bits here.
	    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24) {
	        super();
	        this.blockLen = blockLen;
	        this.suffix = suffix;
	        this.outputLen = outputLen;
	        this.enableXOF = enableXOF;
	        this.rounds = rounds;
	        this.pos = 0;
	        this.posOut = 0;
	        this.finished = false;
	        this.destroyed = false;
	        // Can be passed from user as dkLen
	        (0, _assert_js_1.anumber)(outputLen);
	        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
	        // 0 < blockLen < 200
	        if (0 >= this.blockLen || this.blockLen >= 200)
	            throw new Error('Sha3 supports only keccak-f1600 function');
	        this.state = new Uint8Array(200);
	        this.state32 = (0, utils_js_1.u32)(this.state);
	    }
	    keccak() {
	        if (!utils_js_1.isLE)
	            (0, utils_js_1.byteSwap32)(this.state32);
	        keccakP(this.state32, this.rounds);
	        if (!utils_js_1.isLE)
	            (0, utils_js_1.byteSwap32)(this.state32);
	        this.posOut = 0;
	        this.pos = 0;
	    }
	    update(data) {
	        (0, _assert_js_1.aexists)(this);
	        const { blockLen, state } = this;
	        data = (0, utils_js_1.toBytes)(data);
	        const len = data.length;
	        for (let pos = 0; pos < len;) {
	            const take = Math.min(blockLen - this.pos, len - pos);
	            for (let i = 0; i < take; i++)
	                state[this.pos++] ^= data[pos++];
	            if (this.pos === blockLen)
	                this.keccak();
	        }
	        return this;
	    }
	    finish() {
	        if (this.finished)
	            return;
	        this.finished = true;
	        const { state, suffix, pos, blockLen } = this;
	        // Do the padding
	        state[pos] ^= suffix;
	        if ((suffix & 0x80) !== 0 && pos === blockLen - 1)
	            this.keccak();
	        state[blockLen - 1] ^= 0x80;
	        this.keccak();
	    }
	    writeInto(out) {
	        (0, _assert_js_1.aexists)(this, false);
	        (0, _assert_js_1.abytes)(out);
	        this.finish();
	        const bufferOut = this.state;
	        const { blockLen } = this;
	        for (let pos = 0, len = out.length; pos < len;) {
	            if (this.posOut >= blockLen)
	                this.keccak();
	            const take = Math.min(blockLen - this.posOut, len - pos);
	            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
	            this.posOut += take;
	            pos += take;
	        }
	        return out;
	    }
	    xofInto(out) {
	        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
	        if (!this.enableXOF)
	            throw new Error('XOF is not possible for this instance');
	        return this.writeInto(out);
	    }
	    xof(bytes) {
	        (0, _assert_js_1.anumber)(bytes);
	        return this.xofInto(new Uint8Array(bytes));
	    }
	    digestInto(out) {
	        (0, _assert_js_1.aoutput)(out, this);
	        if (this.finished)
	            throw new Error('digest() was already called');
	        this.writeInto(out);
	        this.destroy();
	        return out;
	    }
	    digest() {
	        return this.digestInto(new Uint8Array(this.outputLen));
	    }
	    destroy() {
	        this.destroyed = true;
	        this.state.fill(0);
	    }
	    _cloneInto(to) {
	        const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
	        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
	        to.state32.set(this.state32);
	        to.pos = this.pos;
	        to.posOut = this.posOut;
	        to.finished = this.finished;
	        to.rounds = rounds;
	        // Suffix can change in cSHAKE
	        to.suffix = suffix;
	        to.outputLen = outputLen;
	        to.enableXOF = enableXOF;
	        to.destroyed = this.destroyed;
	        return to;
	    }
	}
	sha3.Keccak = Keccak;
	const gen = (suffix, blockLen, outputLen) => (0, utils_js_1.wrapConstructor)(() => new Keccak(blockLen, suffix, outputLen));
	/** SHA3-224 hash function. */
	sha3.sha3_224 = gen(0x06, 144, 224 / 8);
	/** SHA3-256 hash function. Different from keccak-256. */
	sha3.sha3_256 = gen(0x06, 136, 256 / 8);
	/** SHA3-384 hash function. */
	sha3.sha3_384 = gen(0x06, 104, 384 / 8);
	/** SHA3-512 hash function. */
	sha3.sha3_512 = gen(0x06, 72, 512 / 8);
	/** keccak-224 hash function. */
	sha3.keccak_224 = gen(0x01, 144, 224 / 8);
	/** keccak-256 hash function. Different from SHA3-256. */
	sha3.keccak_256 = gen(0x01, 136, 256 / 8);
	/** keccak-384 hash function. */
	sha3.keccak_384 = gen(0x01, 104, 384 / 8);
	/** keccak-512 hash function. */
	sha3.keccak_512 = gen(0x01, 72, 512 / 8);
	const genShake = (suffix, blockLen, outputLen) => (0, utils_js_1.wrapXOFConstructorWithOpts)((opts = {}) => new Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
	/** SHAKE128 XOF with 128-bit security. */
	sha3.shake128 = genShake(0x1f, 168, 128 / 8);
	/** SHAKE256 XOF with 256-bit security. */
	sha3.shake256 = genShake(0x1f, 136, 256 / 8);
	
	return sha3;
}

var util;
var hasRequiredUtil;

function requireUtil () {
	if (hasRequiredUtil) return util;
	hasRequiredUtil = 1;
	// Extracted from https://github.com/ethereumjs/ethereumjs-util and stripped out irrelevant code
	// Original code licensed under the Mozilla Public License Version 2.0

	/* eslint-disable */
	//prettier-ignore
	const { keccak_256 } = /*@__PURE__*/ requireSha3();

	/**
	 * Returns a buffer filled with 0s
	 * @method zeros
	 * @param {Number} bytes  the number of bytes the buffer should be
	 * @return {Buffer}
	 */
	function zeros (bytes) {
	  return Buffer.allocUnsafe(bytes).fill(0)
	}

	function bitLengthFromBigInt (num) {
	  return num.toString(2).length
	}

	function bufferBEFromBigInt(num, length) {
	  let hex = num.toString(16);
	  // Ensure the hex string length is even
	  if (hex.length % 2 !== 0) hex = '0' + hex;
	  // Convert hex string to a byte array
	  const byteArray = hex.match(/.{1,2}/g).map(byte => parseInt(byte, 16));
	  // Ensure the byte array is of the specified length
	  while (byteArray.length < length) {
	    byteArray.unshift(0); // Prepend with zeroes if shorter than required length
	  }

	  return Buffer.from(byteArray);
	}

	function twosFromBigInt(value, width) {
	  const isNegative = value < 0n;
	  let result;
	  if (isNegative) {
	    // Prepare a mask for the specified width to perform NOT operation
	    const mask = (1n << BigInt(width)) - 1n;
	    // Invert bits (using NOT) and add one
	    result = (~value & mask) + 1n;
	  } else {
	    result = value;
	  }
	  // Ensure the result fits in the specified width
	  result &= (1n << BigInt(width)) - 1n;

	  return result;
	}

	/**
	 * Left Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
	 * Or it truncates the beginning if it exceeds.
	 * @method setLength
	 * @param {Buffer|Array} msg the value to pad
	 * @param {Number} length the number of bytes the output should be
	 * @param {Boolean} [right=false] whether to start padding form the left or right
	 * @return {Buffer|Array}
	 */
	function setLength (msg, length, right) {
	  const buf = zeros(length);
	  msg = toBuffer(msg);
	  if (right) {
	    if (msg.length < length) {
	      msg.copy(buf);
	      return buf
	    }
	    return msg.slice(0, length)
	  } else {
	    if (msg.length < length) {
	      msg.copy(buf, length - msg.length);
	      return buf
	    }
	    return msg.slice(-length)
	  }
	}

	/**
	 * Right Pads an `Array` or `Buffer` with leading zeros till it has `length` bytes.
	 * Or it truncates the beginning if it exceeds.
	 * @param {Buffer|Array} msg the value to pad
	 * @param {Number} length the number of bytes the output should be
	 * @return {Buffer|Array}
	 */
	function setLengthRight (msg, length) {
	  return setLength(msg, length, true)
	}

	/**
	 * Attempts to turn a value into a `Buffer`. As input it supports `Buffer`, `String`, `Number`, null/undefined, `BIgInt` and other objects with a `toArray()` method.
	 * @param {*} v the value
	 */
	function toBuffer (v) {
	  if (!Buffer.isBuffer(v)) {
	    if (Array.isArray(v)) {
	      v = Buffer.from(v);
	    } else if (typeof v === 'string') {
	      if (isHexString(v)) {
	        v = Buffer.from(padToEven(stripHexPrefix(v)), 'hex');
	      } else {
	        v = Buffer.from(v);
	      }
	    } else if (typeof v === 'number') {
	      v = intToBuffer(v);
	    } else if (v === null || v === undefined) {
	      v = Buffer.allocUnsafe(0);
	    } else if (typeof v === 'bigint') {
	      v = bufferBEFromBigInt(v);
	    } else if (v.toArray) {
	      // TODO: bigint should be handled above, may remove this duplicate
	      // converts a BigInt to a Buffer
	      v = Buffer.from(v.toArray());
	    } else {
	      throw new Error('invalid type')
	    }
	  }
	  return v
	}

	/**
	 * Converts a `Buffer` into a hex `String`
	 * @param {Buffer} buf
	 * @return {String}
	 */
	function bufferToHex (buf) {
	  buf = toBuffer(buf);
	  return '0x' + buf.toString('hex')
	}

	/**
	 * Creates Keccak hash of the input
	 * @param {Buffer|Array|String|Number} a the input data
	 * @param {Number} [bits=256] the Keccak width
	 * @return {Buffer}
	 */
	function keccak (a, bits) {
	  a = toBuffer(a);
	  if (!bits) bits = 256;
	  if (bits !== 256) {
	    throw new Error('unsupported')
	  }
	  return Buffer.from(keccak_256(new Uint8Array(a)))
	}

	function padToEven (str) {
	  return str.length % 2 ? '0' + str : str
	}

	function isHexString (str) {
	  return typeof str === 'string' && str.match(/^0x[0-9A-Fa-f]*$/)
	}

	function stripHexPrefix (str) {
	  if (typeof str === 'string' && str.startsWith('0x')) {
	    return str.slice(2)
	  }
	  return str
	}

	util = {
	  zeros,
	  setLength,
	  setLengthRight,
	  isHexString,
	  stripHexPrefix,
	  toBuffer,
	  bufferToHex,
	  keccak,
	  bitLengthFromBigInt,
	  bufferBEFromBigInt,
	  twosFromBigInt
	};
	return util;
}

var abi;
var hasRequiredAbi;

function requireAbi () {
	if (hasRequiredAbi) return abi;
	hasRequiredAbi = 1;
	// Extracted from https://github.com/ethereumjs/ethereumjs-abi and stripped out irrelevant code
	// Original code licensed under the MIT License - Copyright (c) 2015 Alex Beregszaszi

	/* eslint-disable */
	//prettier-ignore
	const util = /*@__PURE__*/ requireUtil();

	// Convert from short to canonical names
	// FIXME: optimise or make this nicer?
	function elementaryName (name) {
	  if (name.startsWith('int[')) {
	    return 'int256' + name.slice(3)
	  } else if (name === 'int') {
	    return 'int256'
	  } else if (name.startsWith('uint[')) {
	    return 'uint256' + name.slice(4)
	  } else if (name === 'uint') {
	    return 'uint256'
	  } else if (name.startsWith('fixed[')) {
	    return 'fixed128x128' + name.slice(5)
	  } else if (name === 'fixed') {
	    return 'fixed128x128'
	  } else if (name.startsWith('ufixed[')) {
	    return 'ufixed128x128' + name.slice(6)
	  } else if (name === 'ufixed') {
	    return 'ufixed128x128'
	  }
	  return name
	}

	// Parse N from type<N>
	function parseTypeN (type) {
	  return Number.parseInt(/^\D+(\d+)$/.exec(type)[1], 10)
	}

	// Parse N,M from type<N>x<M>
	function parseTypeNxM (type) {
	  var tmp = /^\D+(\d+)x(\d+)$/.exec(type);
	  return [ Number.parseInt(tmp[1], 10), Number.parseInt(tmp[2], 10) ]
	}

	// Parse N in type[<N>] where "type" can itself be an array type.
	function parseTypeArray (type) {
	  var tmp = type.match(/(.*)\[(.*?)\]$/);
	  if (tmp) {
	    return tmp[2] === '' ? 'dynamic' : Number.parseInt(tmp[2], 10)
	  }
	  return null
	}

	function parseNumber (arg) {
	  var type = typeof arg;
	  if (type === 'string' || type === 'number') {
	    return BigInt(arg)
	  } else if (type === 'bigint') {
	    return arg
	  } else {
	    throw new Error('Argument is not a number')
	  }
	}

	// Encodes a single item (can be dynamic array)
	// @returns: Buffer
	function encodeSingle (type, arg) {
	  var size, num, ret, i;

	  if (type === 'address') {
	    return encodeSingle('uint160', parseNumber(arg))
	  } else if (type === 'bool') {
	    return encodeSingle('uint8', arg ? 1 : 0)
	  } else if (type === 'string') {
	    return encodeSingle('bytes', new Buffer(arg, 'utf8'))
	  } else if (isArray(type)) {
	    // this part handles fixed-length ([2]) and variable length ([]) arrays
	    // NOTE: we catch here all calls to arrays, that simplifies the rest
	    if (typeof arg.length === 'undefined') {
	      throw new Error('Not an array?')
	    }
	    size = parseTypeArray(type);
	    if (size !== 'dynamic' && size !== 0 && arg.length > size) {
	      throw new Error('Elements exceed array size: ' + size)
	    }
	    ret = [];
	    type = type.slice(0, type.lastIndexOf('['));
	    if (typeof arg === 'string') {
	      arg = JSON.parse(arg);
	    }
	    for (i in arg) {
	      ret.push(encodeSingle(type, arg[i]));
	    }
	    if (size === 'dynamic') {
	      var length = encodeSingle('uint256', arg.length);
	      ret.unshift(length);
	    }
	    return Buffer.concat(ret)
	  } else if (type === 'bytes') {
	    arg = new Buffer(arg);

	    ret = Buffer.concat([ encodeSingle('uint256', arg.length), arg ]);

	    if ((arg.length % 32) !== 0) {
	      ret = Buffer.concat([ ret, util.zeros(32 - (arg.length % 32)) ]);
	    }

	    return ret
	  } else if (type.startsWith('bytes')) {
	    size = parseTypeN(type);
	    if (size < 1 || size > 32) {
	      throw new Error('Invalid bytes<N> width: ' + size)
	    }

	    return util.setLengthRight(arg, 32)
	  } else if (type.startsWith('uint')) {
	    size = parseTypeN(type);
	    if ((size % 8) || (size < 8) || (size > 256)) {
	      throw new Error('Invalid uint<N> width: ' + size)
	    }

	    num = parseNumber(arg);
	    const bitLength = util.bitLengthFromBigInt(num);
	    if (bitLength > size) {
	      throw new Error('Supplied uint exceeds width: ' + size + ' vs ' + bitLength)
	    }

	    if (num < 0) {
	      throw new Error('Supplied uint is negative')
	    }

	    return util.bufferBEFromBigInt(num, 32);
	  } else if (type.startsWith('int')) {
	    size = parseTypeN(type);
	    if ((size % 8) || (size < 8) || (size > 256)) {
	      throw new Error('Invalid int<N> width: ' + size)
	    }

	    num = parseNumber(arg);
	    const bitLength = util.bitLengthFromBigInt(num);
	    if (bitLength > size) {
	      throw new Error('Supplied int exceeds width: ' + size + ' vs ' + bitLength)
	    }

	    const twos = util.twosFromBigInt(num, 256);

	    return util.bufferBEFromBigInt(twos, 32);
	  } else if (type.startsWith('ufixed')) {
	    size = parseTypeNxM(type);

	    num = parseNumber(arg);

	    if (num < 0) {
	      throw new Error('Supplied ufixed is negative')
	    }

	    return encodeSingle('uint256', num * BigInt(2) ** BigInt(size[1]))
	  } else if (type.startsWith('fixed')) {
	    size = parseTypeNxM(type);

	    return encodeSingle('int256', parseNumber(arg) * BigInt(2) ** BigInt(size[1]))
	  }

	  throw new Error('Unsupported or invalid type: ' + type)
	}

	// Is a type dynamic?
	function isDynamic (type) {
	  // FIXME: handle all types? I don't think anything is missing now
	  return (type === 'string') || (type === 'bytes') || (parseTypeArray(type) === 'dynamic')
	}

	// Is a type an array?
	function isArray (type) {
	  return type.lastIndexOf(']') === type.length - 1
	}

	// Encode a method/event with arguments
	// @types an array of string type names
	// @args  an array of the appropriate values
	function rawEncode (types, values) {
	  var output = [];
	  var data = [];

	  var headLength = 32 * types.length;

	  for (var i in types) {
	    var type = elementaryName(types[i]);
	    var value = values[i];
	    var cur = encodeSingle(type, value);

	    // Use the head/tail method for storing dynamic data
	    if (isDynamic(type)) {
	      output.push(encodeSingle('uint256', headLength));
	      data.push(cur);
	      headLength += cur.length;
	    } else {
	      output.push(cur);
	    }
	  }

	  return Buffer.concat(output.concat(data))
	}

	function solidityPack (types, values) {
	  if (types.length !== values.length) {
	    throw new Error('Number of types are not matching the values')
	  }

	  var size, num;
	  var ret = [];

	  for (var i = 0; i < types.length; i++) {
	    var type = elementaryName(types[i]);
	    var value = values[i];

	    if (type === 'bytes') {
	      ret.push(value);
	    } else if (type === 'string') {
	      ret.push(new Buffer(value, 'utf8'));
	    } else if (type === 'bool') {
	      ret.push(new Buffer(value ? '01' : '00', 'hex'));
	    } else if (type === 'address') {
	      ret.push(util.setLength(value, 20));
	    } else if (type.startsWith('bytes')) {
	      size = parseTypeN(type);
	      if (size < 1 || size > 32) {
	        throw new Error('Invalid bytes<N> width: ' + size)
	      }

	      ret.push(util.setLengthRight(value, size));
	    } else if (type.startsWith('uint')) {
	      size = parseTypeN(type);
	      if ((size % 8) || (size < 8) || (size > 256)) {
	        throw new Error('Invalid uint<N> width: ' + size)
	      }

	      num = parseNumber(value);
	      const bitLength = util.bitLengthFromBigInt(num);
	      if (bitLength > size) {
	        throw new Error('Supplied uint exceeds width: ' + size + ' vs ' + bitLength)
	      }

	      ret.push(util.bufferBEFromBigInt(num, size / 8));
	    } else if (type.startsWith('int')) {
	      size = parseTypeN(type);
	      if ((size % 8) || (size < 8) || (size > 256)) {
	        throw new Error('Invalid int<N> width: ' + size)
	      }

	      num = parseNumber(value);
	      const bitLength = util.bitLengthFromBigInt(num);
	      if (bitLength > size) {
	        throw new Error('Supplied int exceeds width: ' + size + ' vs ' + bitLength)
	      }

	      const twos = util.twosFromBigInt(num, size);
	      ret.push(util.bufferBEFromBigInt(twos, size / 8));
	    } else {
	      // FIXME: support all other types
	      throw new Error('Unsupported or invalid type: ' + type)
	    }
	  }

	  return Buffer.concat(ret)
	}

	function soliditySHA3 (types, values) {
	  return util.keccak(solidityPack(types, values))
	}

	abi = {
	  rawEncode,
	  solidityPack,
	  soliditySHA3
	};
	return abi;
}

/* eslint-disable */

var ethEip712Util;
var hasRequiredEthEip712Util;

function requireEthEip712Util () {
	if (hasRequiredEthEip712Util) return ethEip712Util;
	hasRequiredEthEip712Util = 1;
	//prettier-ignore

	const util = /*@__PURE__*/ requireUtil();
	const abi = /*@__PURE__*/ requireAbi();

	const TYPED_MESSAGE_SCHEMA = {
	  type: 'object',
	  properties: {
	    types: {
	      type: 'object',
	      additionalProperties: {
	        type: 'array',
	        items: {
	          type: 'object',
	          properties: {
	            name: {type: 'string'},
	            type: {type: 'string'},
	          },
	          required: ['name', 'type'],
	        },
	      },
	    },
	    primaryType: {type: 'string'},
	    domain: {type: 'object'},
	    message: {type: 'object'},
	  },
	  required: ['types', 'primaryType', 'domain', 'message'],
	};

	/**
	 * A collection of utility functions used for signing typed data
	 */
	const TypedDataUtils = {
	  /**
	   * Encodes an object by encoding and concatenating each of its members
	   *
	   * @param {string} primaryType - Root type
	   * @param {Object} data - Object to encode
	   * @param {Object} types - Type definitions
	   * @returns {string} - Encoded representation of an object
	   */
	  encodeData (primaryType, data, types, useV4 = true) {
	    const encodedTypes = ['bytes32'];
	    const encodedValues = [this.hashType(primaryType, types)];

	    if(useV4) {
	      const encodeField = (name, type, value) => {
	        if (types[type] !== undefined) {
	          return ['bytes32', value == null ?
	            '0x0000000000000000000000000000000000000000000000000000000000000000' :
	            util.keccak(this.encodeData(type, value, types, useV4))]
	        }

	        if(value === undefined)
	          throw new Error(`missing value for field ${name} of type ${type}`)

	        if (type === 'bytes') {
	          return ['bytes32', util.keccak(value)]
	        }

	        if (type === 'string') {
	          // convert string to buffer - prevents ethUtil from interpreting strings like '0xabcd' as hex
	          if (typeof value === 'string') {
	            value = Buffer.from(value, 'utf8');
	          }
	          return ['bytes32', util.keccak(value)]
	        }

	        if (type.lastIndexOf(']') === type.length - 1) {
	          const parsedType = type.slice(0, type.lastIndexOf('['));
	          const typeValuePairs = value.map(item =>
	            encodeField(name, parsedType, item));
	          return ['bytes32', util.keccak(abi.rawEncode(
	            typeValuePairs.map(([type]) => type),
	            typeValuePairs.map(([, value]) => value),
	          ))]
	        }

	        return [type, value]
	      };

	      for (const field of types[primaryType]) {
	        const [type, value] = encodeField(field.name, field.type, data[field.name]);
	        encodedTypes.push(type);
	        encodedValues.push(value);
	      }
	    } else {
	      for (const field of types[primaryType]) {
	        let value = data[field.name];
	        if (value !== undefined) {
	          if (field.type === 'bytes') {
	            encodedTypes.push('bytes32');
	            value = util.keccak(value);
	            encodedValues.push(value);
	          } else if (field.type === 'string') {
	            encodedTypes.push('bytes32');
	            // convert string to buffer - prevents ethUtil from interpreting strings like '0xabcd' as hex
	            if (typeof value === 'string') {
	              value = Buffer.from(value, 'utf8');
	            }
	            value = util.keccak(value);
	            encodedValues.push(value);
	          } else if (types[field.type] !== undefined) {
	            encodedTypes.push('bytes32');
	            value = util.keccak(this.encodeData(field.type, value, types, useV4));
	            encodedValues.push(value);
	          } else if (field.type.lastIndexOf(']') === field.type.length - 1) {
	            throw new Error('Arrays currently unimplemented in encodeData')
	          } else {
	            encodedTypes.push(field.type);
	            encodedValues.push(value);
	          }
	        }
	      }
	    }

	    return abi.rawEncode(encodedTypes, encodedValues)
	  },

	  /**
	   * Encodes the type of an object by encoding a comma delimited list of its members
	   *
	   * @param {string} primaryType - Root type to encode
	   * @param {Object} types - Type definitions
	   * @returns {string} - Encoded representation of the type of an object
	   */
	  encodeType (primaryType, types) {
	    let result = '';
	    let deps = this.findTypeDependencies(primaryType, types).filter(dep => dep !== primaryType);
	    deps = [primaryType].concat(deps.sort());
	    for (const type of deps) {
	      const children = types[type];
	      if (!children) {
	        throw new Error('No type definition specified: ' + type)
	      }
	      result += type + '(' + types[type].map(({ name, type }) => type + ' ' + name).join(',') + ')';
	    }
	    return result
	  },

	  /**
	   * Finds all types within a type definition object
	   *
	   * @param {string} primaryType - Root type
	   * @param {Object} types - Type definitions
	   * @param {Array} results - current set of accumulated types
	   * @returns {Array} - Set of all types found in the type definition
	   */
	  findTypeDependencies (primaryType, types, results = []) {
	    primaryType = primaryType.match(/^\w*/)[0];
	    if (results.includes(primaryType) || types[primaryType] === undefined) { return results }
	    results.push(primaryType);
	    for (const field of types[primaryType]) {
	      for (const dep of this.findTypeDependencies(field.type, types, results)) {
	        !results.includes(dep) && results.push(dep);
	      }
	    }
	    return results
	  },

	  /**
	   * Hashes an object
	   *
	   * @param {string} primaryType - Root type
	   * @param {Object} data - Object to hash
	   * @param {Object} types - Type definitions
	   * @returns {Buffer} - Hash of an object
	   */
	  hashStruct (primaryType, data, types, useV4 = true) {
	    return util.keccak(this.encodeData(primaryType, data, types, useV4))
	  },

	  /**
	   * Hashes the type of an object
	   *
	   * @param {string} primaryType - Root type to hash
	   * @param {Object} types - Type definitions
	   * @returns {string} - Hash of an object
	   */
	  hashType (primaryType, types) {
	    return util.keccak(this.encodeType(primaryType, types))
	  },

	  /**
	   * Removes properties from a message object that are not defined per EIP-712
	   *
	   * @param {Object} data - typed message object
	   * @returns {Object} - typed message object with only allowed fields
	   */
	  sanitizeData (data) {
	    const sanitizedData = {};
	    for (const key in TYPED_MESSAGE_SCHEMA.properties) {
	      data[key] && (sanitizedData[key] = data[key]);
	    }
	    if (sanitizedData.types) {
	      sanitizedData.types = Object.assign({ EIP712Domain: [] }, sanitizedData.types);
	    }
	    return sanitizedData
	  },

	  /**
	   * Returns the hash of a typed message as per EIP-712 for signing
	   *
	   * @param {Object} typedData - Types message data to sign
	   * @returns {string} - sha3 hash for signing
	   */
	  hash (typedData, useV4 = true) {
	    const sanitizedData = this.sanitizeData(typedData);
	    const parts = [Buffer.from('1901', 'hex')];
	    parts.push(this.hashStruct('EIP712Domain', sanitizedData.domain, sanitizedData.types, useV4));
	    if (sanitizedData.primaryType !== 'EIP712Domain') {
	      parts.push(this.hashStruct(sanitizedData.primaryType, sanitizedData.message, sanitizedData.types, useV4));
	    }
	    return util.keccak(Buffer.concat(parts))
	  },
	};

	ethEip712Util = {
	  TYPED_MESSAGE_SCHEMA,
	  TypedDataUtils,

	  hashForSignTypedDataLegacy: function (msgParams) {
	    return typedSignatureHashLegacy(msgParams.data)
	  },

	  hashForSignTypedData_v3: function (msgParams) {
	    return TypedDataUtils.hash(msgParams.data, false)
	  },

	  hashForSignTypedData_v4: function (msgParams) {
	    return TypedDataUtils.hash(msgParams.data)
	  },
	};

	/**
	 * @param typedData - Array of data along with types, as per EIP712.
	 * @returns Buffer
	 */
	function typedSignatureHashLegacy(typedData) {
	  const error = new Error('Expect argument to be non-empty array');
	  if (typeof typedData !== 'object' || !typedData.length) throw error

	  const data = typedData.map(function (e) {
	    return e.type === 'bytes' ? util.toBuffer(e.value) : e.value
	  });
	  const types = typedData.map(function (e) { return e.type });
	  const schema = typedData.map(function (e) {
	    if (!e.name) throw error
	    return e.type + ' ' + e.name
	  });

	  return abi.soliditySHA3(
	    ['bytes32', 'bytes32'],
	    [
	      abi.soliditySHA3(new Array(typedData.length).fill('string'), schema),
	      abi.soliditySHA3(types, data)
	    ]
	  )
	}
	return ethEip712Util;
}

var ethEip712UtilExports = /*@__PURE__*/ requireEthEip712Util();
var eip712 = /*@__PURE__*/getDefaultExportFromCjs(ethEip712UtilExports);

const WALLET_USER_NAME_KEY = 'walletUsername';
const LOCAL_STORAGE_ADDRESSES_KEY = 'Addresses';
const APP_VERSION_KEY = 'AppVersion';

// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
function isErrorResponse(response) {
    return response.errorMessage !== undefined;
}

// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
class WalletLinkCipher {
    // @param secret hex representation of 32-byte secret
    constructor(secret) {
        this.secret = secret;
    }
    /**
     *
     * @param plainText string to be encrypted
     * returns hex string representation of bytes in the order: initialization vector (iv),
     * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes. Remaining bytes are the
     * encrypted plainText.
     */
    async encrypt(plainText) {
        const secret = this.secret;
        if (secret.length !== 64)
            throw Error(`secret must be 256 bits`);
        const ivBytes = crypto.getRandomValues(new Uint8Array(12));
        const secretKey = await crypto.subtle.importKey('raw', hexStringToUint8Array(secret), { name: 'aes-gcm' }, false, ['encrypt', 'decrypt']);
        const enc = new TextEncoder();
        // Will return encrypted plainText with auth tag (ie MAC or checksum) appended at the end
        const encryptedResult = await window.crypto.subtle.encrypt({
            name: 'AES-GCM',
            iv: ivBytes,
        }, secretKey, enc.encode(plainText));
        const tagLength = 16;
        const authTag = encryptedResult.slice(encryptedResult.byteLength - tagLength);
        const encryptedPlaintext = encryptedResult.slice(0, encryptedResult.byteLength - tagLength);
        const authTagBytes = new Uint8Array(authTag);
        const encryptedPlaintextBytes = new Uint8Array(encryptedPlaintext);
        const concatted = new Uint8Array([...ivBytes, ...authTagBytes, ...encryptedPlaintextBytes]);
        return uint8ArrayToHex(concatted);
    }
    /**
     *
     * @param cipherText hex string representation of bytes in the order: initialization vector (iv),
     * auth tag, encrypted plaintext. IV is 12 bytes. Auth tag is 16 bytes.
     */
    async decrypt(cipherText) {
        const secret = this.secret;
        if (secret.length !== 64)
            throw Error(`secret must be 256 bits`);
        return new Promise((resolve, reject) => {
            void (async function () {
                const secretKey = await crypto.subtle.importKey('raw', hexStringToUint8Array(secret), { name: 'aes-gcm' }, false, ['encrypt', 'decrypt']);
                const encrypted = hexStringToUint8Array(cipherText);
                const ivBytes = encrypted.slice(0, 12);
                const authTagBytes = encrypted.slice(12, 28);
                const encryptedPlaintextBytes = encrypted.slice(28);
                const concattedBytes = new Uint8Array([...encryptedPlaintextBytes, ...authTagBytes]);
                const algo = {
                    name: 'AES-GCM',
                    iv: new Uint8Array(ivBytes),
                };
                try {
                    const decrypted = await window.crypto.subtle.decrypt(algo, secretKey, concattedBytes);
                    const decoder = new TextDecoder();
                    resolve(decoder.decode(decrypted));
                }
                catch (err) {
                    reject(err);
                }
            })();
        });
    }
}

class WalletLinkHTTP {
    constructor(linkAPIUrl, sessionId, sessionKey) {
        this.linkAPIUrl = linkAPIUrl;
        this.sessionId = sessionId;
        const credentials = `${sessionId}:${sessionKey}`;
        this.auth = `Basic ${btoa(credentials)}`;
    }
    // mark unseen events as seen
    async markUnseenEventsAsSeen(events) {
        return Promise.all(events.map((e) => fetch(`${this.linkAPIUrl}/events/${e.eventId}/seen`, {
            method: 'POST',
            headers: {
                Authorization: this.auth,
            },
        }))).catch((error) => console.error('Unabled to mark event as failed:', error));
    }
    async fetchUnseenEvents() {
        var _a;
        const response = await fetch(`${this.linkAPIUrl}/events?unseen=true`, {
            headers: {
                Authorization: this.auth,
            },
        });
        if (response.ok) {
            const { events, error } = (await response.json());
            if (error) {
                throw new Error(`Check unseen events failed: ${error}`);
            }
            const responseEvents = (_a = events === null || events === void 0 ? void 0 : events.filter((e) => e.event === 'Web3Response').map((e) => ({
                type: 'Event',
                sessionId: this.sessionId,
                eventId: e.id,
                event: e.event,
                data: e.data,
            }))) !== null && _a !== void 0 ? _a : [];
            this.markUnseenEventsAsSeen(responseEvents);
            return responseEvents;
        }
        throw new Error(`Check unseen events failed: ${response.status}`);
    }
}

// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
var ConnectionState;
(function (ConnectionState) {
    ConnectionState[ConnectionState["DISCONNECTED"] = 0] = "DISCONNECTED";
    ConnectionState[ConnectionState["CONNECTING"] = 1] = "CONNECTING";
    ConnectionState[ConnectionState["CONNECTED"] = 2] = "CONNECTED";
})(ConnectionState || (ConnectionState = {}));
class WalletLinkWebSocket {
    setConnectionStateListener(listener) {
        this.connectionStateListener = listener;
    }
    setIncomingDataListener(listener) {
        this.incomingDataListener = listener;
    }
    /**
     * Constructor
     * @param url WebSocket server URL
     * @param [WebSocketClass] Custom WebSocket implementation
     */
    constructor(url, WebSocketClass = WebSocket) {
        this.WebSocketClass = WebSocketClass;
        this.webSocket = null;
        this.pendingData = [];
        this.url = url.replace(/^http/, 'ws');
    }
    /**
     * Make a websocket connection
     * @returns a Promise that resolves when connected
     */
    async connect() {
        if (this.webSocket) {
            throw new Error('webSocket object is not null');
        }
        return new Promise((resolve, reject) => {
            var _a;
            let webSocket;
            try {
                this.webSocket = webSocket = new this.WebSocketClass(this.url);
            }
            catch (err) {
                reject(err);
                return;
            }
            (_a = this.connectionStateListener) === null || _a === void 0 ? void 0 : _a.call(this, ConnectionState.CONNECTING);
            webSocket.onclose = (evt) => {
                var _a;
                this.clearWebSocket();
                reject(new Error(`websocket error ${evt.code}: ${evt.reason}`));
                (_a = this.connectionStateListener) === null || _a === void 0 ? void 0 : _a.call(this, ConnectionState.DISCONNECTED);
            };
            webSocket.onopen = (_) => {
                var _a;
                resolve();
                (_a = this.connectionStateListener) === null || _a === void 0 ? void 0 : _a.call(this, ConnectionState.CONNECTED);
                if (this.pendingData.length > 0) {
                    const pending = [...this.pendingData];
                    pending.forEach((data) => this.sendData(data));
                    this.pendingData = [];
                }
            };
            webSocket.onmessage = (evt) => {
                var _a, _b;
                if (evt.data === 'h') {
                    (_a = this.incomingDataListener) === null || _a === void 0 ? void 0 : _a.call(this, {
                        type: 'Heartbeat',
                    });
                }
                else {
                    try {
                        const message = JSON.parse(evt.data);
                        (_b = this.incomingDataListener) === null || _b === void 0 ? void 0 : _b.call(this, message);
                    }
                    catch (_c) {
                        /* empty */
                    }
                }
            };
        });
    }
    /**
     * Disconnect from server
     */
    disconnect() {
        var _a;
        const { webSocket } = this;
        if (!webSocket) {
            return;
        }
        this.clearWebSocket();
        (_a = this.connectionStateListener) === null || _a === void 0 ? void 0 : _a.call(this, ConnectionState.DISCONNECTED);
        this.connectionStateListener = undefined;
        this.incomingDataListener = undefined;
        try {
            webSocket.close();
        }
        catch (_b) {
            // noop
        }
    }
    /**
     * Send data to server
     * @param data text to send
     */
    sendData(data) {
        const { webSocket } = this;
        if (!webSocket) {
            this.pendingData.push(data);
            this.connect();
            return;
        }
        webSocket.send(data);
    }
    clearWebSocket() {
        const { webSocket } = this;
        if (!webSocket) {
            return;
        }
        this.webSocket = null;
        webSocket.onclose = null;
        webSocket.onerror = null;
        webSocket.onmessage = null;
        webSocket.onopen = null;
    }
}

// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
const HEARTBEAT_INTERVAL = 10000;
const REQUEST_TIMEOUT = 60000;
/**
 * Coinbase Wallet Connection
 */
class WalletLinkConnection {
    /**
     * Constructor
     * @param session Session
     * @param linkAPIUrl Coinbase Wallet link server URL
     * @param listener WalletLinkConnectionUpdateListener
     * @param [WebSocketClass] Custom WebSocket implementation
     */
    constructor({ session, linkAPIUrl, listener }) {
        this.destroyed = false;
        this.lastHeartbeatResponse = 0;
        this.nextReqId = IntNumber(1);
        /**
         * true if connected and authenticated, else false
         * runs listener when connected status changes
         */
        this._connected = false;
        /**
         * true if linked (a guest has joined before)
         * runs listener when linked status changes
         */
        this._linked = false;
        this.shouldFetchUnseenEventsOnConnect = false;
        this.requestResolutions = new Map();
        this.handleSessionMetadataUpdated = (metadata) => {
            if (!metadata)
                return;
            // Map of metadata key to handler function
            const handlers = new Map([
                ['__destroyed', this.handleDestroyed],
                ['EthereumAddress', this.handleAccountUpdated],
                ['WalletUsername', this.handleWalletUsernameUpdated],
                ['AppVersion', this.handleAppVersionUpdated],
                [
                    'ChainId', // ChainId and JsonRpcUrl are always updated together
                    (v) => metadata.JsonRpcUrl && this.handleChainUpdated(v, metadata.JsonRpcUrl),
                ],
            ]);
            // call handler for each metadata key if value is defined
            handlers.forEach((handler, key) => {
                const value = metadata[key];
                if (value === undefined)
                    return;
                handler(value);
            });
        };
        this.handleDestroyed = (__destroyed) => {
            var _a;
            if (__destroyed !== '1')
                return;
            (_a = this.listener) === null || _a === void 0 ? void 0 : _a.resetAndReload();
        };
        this.handleAccountUpdated = async (encryptedEthereumAddress) => {
            var _a;
            const address = await this.cipher.decrypt(encryptedEthereumAddress);
            (_a = this.listener) === null || _a === void 0 ? void 0 : _a.accountUpdated(address);
        };
        this.handleMetadataUpdated = async (key, encryptedMetadataValue) => {
            var _a;
            const decryptedValue = await this.cipher.decrypt(encryptedMetadataValue);
            (_a = this.listener) === null || _a === void 0 ? void 0 : _a.metadataUpdated(key, decryptedValue);
        };
        this.handleWalletUsernameUpdated = async (walletUsername) => {
            this.handleMetadataUpdated(WALLET_USER_NAME_KEY, walletUsername);
        };
        this.handleAppVersionUpdated = async (appVersion) => {
            this.handleMetadataUpdated(APP_VERSION_KEY, appVersion);
        };
        this.handleChainUpdated = async (encryptedChainId, encryptedJsonRpcUrl) => {
            var _a;
            const chainId = await this.cipher.decrypt(encryptedChainId);
            const jsonRpcUrl = await this.cipher.decrypt(encryptedJsonRpcUrl);
            (_a = this.listener) === null || _a === void 0 ? void 0 : _a.chainUpdated(chainId, jsonRpcUrl);
        };
        this.session = session;
        this.cipher = new WalletLinkCipher(session.secret);
        this.listener = listener;
        const ws = new WalletLinkWebSocket(`${linkAPIUrl}/rpc`, WebSocket);
        ws.setConnectionStateListener(async (state) => {
            // attempt to reconnect every 5 seconds when disconnected
            let connected = false;
            switch (state) {
                case ConnectionState.DISCONNECTED:
                    // if DISCONNECTED and not destroyed
                    if (!this.destroyed) {
                        const connect = async () => {
                            // wait 5 seconds
                            await new Promise((resolve) => setTimeout(resolve, 5000));
                            // check whether it's destroyed again
                            if (!this.destroyed) {
                                // reconnect
                                ws.connect().catch(() => {
                                    connect();
                                });
                            }
                        };
                        connect();
                    }
                    break;
                case ConnectionState.CONNECTED:
                    // perform authentication upon connection
                    // if CONNECTED, authenticate, and then check link status
                    connected = await this.handleConnected();
                    // send heartbeat every n seconds while connected
                    // if CONNECTED, start the heartbeat timer
                    // first timer event updates lastHeartbeat timestamp
                    // subsequent calls send heartbeat message
                    this.updateLastHeartbeat();
                    setInterval(() => {
                        this.heartbeat();
                    }, HEARTBEAT_INTERVAL);
                    // check for unseen events
                    if (this.shouldFetchUnseenEventsOnConnect) {
                        this.fetchUnseenEventsAPI();
                    }
                    break;
                case ConnectionState.CONNECTING:
                    break;
            }
            // distinctUntilChanged
            if (this.connected !== connected) {
                this.connected = connected;
            }
        });
        ws.setIncomingDataListener((m) => {
            var _a;
            switch (m.type) {
                // handle server's heartbeat responses
                case 'Heartbeat':
                    this.updateLastHeartbeat();
                    return;
                // handle link status updates
                case 'IsLinkedOK':
                case 'Linked': {
                    const linked = m.type === 'IsLinkedOK' ? m.linked : undefined;
                    this.linked = linked || m.onlineGuests > 0;
                    break;
                }
                // handle session config updates
                case 'GetSessionConfigOK':
                case 'SessionConfigUpdated': {
                    this.handleSessionMetadataUpdated(m.metadata);
                    break;
                }
                case 'Event': {
                    this.handleIncomingEvent(m);
                    break;
                }
            }
            // resolve request promises
            if (m.id !== undefined) {
                (_a = this.requestResolutions.get(m.id)) === null || _a === void 0 ? void 0 : _a(m);
            }
        });
        this.ws = ws;
        this.http = new WalletLinkHTTP(linkAPIUrl, session.id, session.key);
    }
    /**
     * Make a connection to the server
     */
    connect() {
        if (this.destroyed) {
            throw new Error('instance is destroyed');
        }
        this.ws.connect();
    }
    /**
     * Terminate connection, and mark as destroyed. To reconnect, create a new
     * instance of WalletSDKConnection
     */
    async destroy() {
        if (this.destroyed)
            return;
        await this.makeRequest({
            type: 'SetSessionConfig',
            id: IntNumber(this.nextReqId++),
            sessionId: this.session.id,
            metadata: { __destroyed: '1' },
        }, { timeout: 1000 });
        this.destroyed = true;
        this.ws.disconnect();
        this.listener = undefined;
    }
    get connected() {
        return this._connected;
    }
    set connected(connected) {
        this._connected = connected;
    }
    get linked() {
        return this._linked;
    }
    set linked(linked) {
        var _a, _b;
        this._linked = linked;
        if (linked)
            (_a = this.onceLinked) === null || _a === void 0 ? void 0 : _a.call(this);
        (_b = this.listener) === null || _b === void 0 ? void 0 : _b.linkedUpdated(linked);
    }
    setOnceLinked(callback) {
        return new Promise((resolve) => {
            if (this.linked) {
                callback().then(resolve);
            }
            else {
                this.onceLinked = () => {
                    callback().then(resolve);
                    this.onceLinked = undefined;
                };
            }
        });
    }
    async handleIncomingEvent(m) {
        var _a;
        if (m.type !== 'Event' || m.event !== 'Web3Response') {
            return;
        }
        const decryptedData = await this.cipher.decrypt(m.data);
        const message = JSON.parse(decryptedData);
        if (message.type !== 'WEB3_RESPONSE')
            return;
        const { id, response } = message;
        (_a = this.listener) === null || _a === void 0 ? void 0 : _a.handleWeb3ResponseMessage(id, response);
    }
    async checkUnseenEvents() {
        if (!this.connected) {
            this.shouldFetchUnseenEventsOnConnect = true;
            return;
        }
        await new Promise((resolve) => setTimeout(resolve, 250));
        try {
            await this.fetchUnseenEventsAPI();
        }
        catch (e) {
            console.error('Unable to check for unseen events', e);
        }
    }
    async fetchUnseenEventsAPI() {
        this.shouldFetchUnseenEventsOnConnect = false;
        const responseEvents = await this.http.fetchUnseenEvents();
        responseEvents.forEach((e) => this.handleIncomingEvent(e));
    }
    /**
     * Publish an event and emit event ID when successful
     * @param event event name
     * @param unencryptedData unencrypted event data
     * @param callWebhook whether the webhook should be invoked
     * @returns a Promise that emits event ID when successful
     */
    async publishEvent(event, unencryptedData, callWebhook = false) {
        const data = await this.cipher.encrypt(JSON.stringify(Object.assign(Object.assign({}, unencryptedData), { origin: location.origin, location: location.href, relaySource: 'coinbaseWalletExtension' in window && window.coinbaseWalletExtension
                ? 'injected_sdk'
                : 'sdk' })));
        const message = {
            type: 'PublishEvent',
            id: IntNumber(this.nextReqId++),
            sessionId: this.session.id,
            event,
            data,
            callWebhook,
        };
        return this.setOnceLinked(async () => {
            const res = await this.makeRequest(message);
            if (res.type === 'Fail') {
                throw new Error(res.error || 'failed to publish event');
            }
            return res.eventId;
        });
    }
    sendData(message) {
        this.ws.sendData(JSON.stringify(message));
    }
    updateLastHeartbeat() {
        this.lastHeartbeatResponse = Date.now();
    }
    heartbeat() {
        if (Date.now() - this.lastHeartbeatResponse > HEARTBEAT_INTERVAL * 2) {
            this.ws.disconnect();
            return;
        }
        try {
            this.ws.sendData('h');
        }
        catch (_a) {
            // noop
        }
    }
    async makeRequest(message, options = { timeout: REQUEST_TIMEOUT }) {
        const reqId = message.id;
        this.sendData(message);
        // await server message with corresponding id
        let timeoutId;
        return Promise.race([
            new Promise((_, reject) => {
                timeoutId = window.setTimeout(() => {
                    reject(new Error(`request ${reqId} timed out`));
                }, options.timeout);
            }),
            new Promise((resolve) => {
                this.requestResolutions.set(reqId, (m) => {
                    clearTimeout(timeoutId); // clear the timeout
                    resolve(m);
                    this.requestResolutions.delete(reqId);
                });
            }),
        ]);
    }
    async handleConnected() {
        const res = await this.makeRequest({
            type: 'HostSession',
            id: IntNumber(this.nextReqId++),
            sessionId: this.session.id,
            sessionKey: this.session.key,
        });
        if (res.type === 'Fail')
            return false;
        this.sendData({
            type: 'IsLinked',
            id: IntNumber(this.nextReqId++),
            sessionId: this.session.id,
        });
        this.sendData({
            type: 'GetSessionConfig',
            id: IntNumber(this.nextReqId++),
            sessionId: this.session.id,
        });
        return true;
    }
}

class RelayEventManager {
    constructor() {
        this._nextRequestId = 0;
        this.callbacks = new Map();
    }
    makeRequestId() {
        // max nextId == max int32 for compatibility with mobile
        this._nextRequestId = (this._nextRequestId + 1) % 0x7fffffff;
        const id = this._nextRequestId;
        const idStr = prepend0x(id.toString(16));
        // unlikely that this will ever be an issue, but just to be safe
        const callback = this.callbacks.get(idStr);
        if (callback) {
            this.callbacks.delete(idStr);
        }
        return id;
    }
}

// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
const STORAGE_KEY_SESSION_ID = 'session:id';
const STORAGE_KEY_SESSION_SECRET = 'session:secret';
const STORAGE_KEY_SESSION_LINKED = 'session:linked';
class WalletLinkSession {
    constructor(storage, id, secret, linked = false) {
        this.storage = storage;
        this.id = id;
        this.secret = secret;
        this.key = bytesToHex$1(sha256$2(`${id}, ${secret} WalletLink`));
        this._linked = !!linked;
    }
    static create(storage) {
        const id = randomBytesHex(16);
        const secret = randomBytesHex(32);
        return new WalletLinkSession(storage, id, secret).save();
    }
    static load(storage) {
        const id = storage.getItem(STORAGE_KEY_SESSION_ID);
        const linked = storage.getItem(STORAGE_KEY_SESSION_LINKED);
        const secret = storage.getItem(STORAGE_KEY_SESSION_SECRET);
        if (id && secret) {
            return new WalletLinkSession(storage, id, secret, linked === '1');
        }
        return null;
    }
    get linked() {
        return this._linked;
    }
    set linked(val) {
        this._linked = val;
        this.persistLinked();
    }
    save() {
        this.storage.setItem(STORAGE_KEY_SESSION_ID, this.id);
        this.storage.setItem(STORAGE_KEY_SESSION_SECRET, this.secret);
        this.persistLinked();
        return this;
    }
    persistLinked() {
        this.storage.setItem(STORAGE_KEY_SESSION_LINKED, this._linked ? '1' : '0');
    }
}

function isInIFrame() {
    try {
        return window.frameElement !== null;
    }
    catch (e) {
        return false;
    }
}
function getLocation() {
    try {
        if (isInIFrame() && window.top) {
            return window.top.location;
        }
        return window.location;
    }
    catch (e) {
        return window.location;
    }
}
function isMobileWeb() {
    var _a;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent);
}
function isDarkMode() {
    var _a, _b;
    return (_b = (_a = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(prefers-color-scheme: dark)').matches) !== null && _b !== void 0 ? _b : false;
}

var css$2 = (() => `@namespace svg "http://www.w3.org/2000/svg";.-cbwsdk-css-reset,.-cbwsdk-css-reset *{animation:none;animation-delay:0;animation-direction:normal;animation-duration:0;animation-fill-mode:none;animation-iteration-count:1;animation-name:none;animation-play-state:running;animation-timing-function:ease;backface-visibility:visible;background:0;background-attachment:scroll;background-clip:border-box;background-color:rgba(0,0,0,0);background-image:none;background-origin:padding-box;background-position:0 0;background-position-x:0;background-position-y:0;background-repeat:repeat;background-size:auto auto;border:0;border-style:none;border-width:medium;border-color:inherit;border-bottom:0;border-bottom-color:inherit;border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom-style:none;border-bottom-width:medium;border-collapse:separate;border-image:none;border-left:0;border-left-color:inherit;border-left-style:none;border-left-width:medium;border-radius:0;border-right:0;border-right-color:inherit;border-right-style:none;border-right-width:medium;border-spacing:0;border-top:0;border-top-color:inherit;border-top-left-radius:0;border-top-right-radius:0;border-top-style:none;border-top-width:medium;box-shadow:none;box-sizing:border-box;caption-side:top;clear:none;clip:auto;color:inherit;columns:auto;column-count:auto;column-fill:balance;column-gap:normal;column-rule:medium none currentColor;column-rule-color:currentColor;column-rule-style:none;column-rule-width:none;column-span:1;column-width:auto;counter-increment:none;counter-reset:none;direction:ltr;empty-cells:show;float:none;font:normal;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;height:auto;hyphens:none;letter-spacing:normal;line-height:normal;list-style:none;list-style-image:none;list-style-position:outside;list-style-type:disc;margin:0;margin-bottom:0;margin-left:0;margin-right:0;margin-top:0;opacity:1;orphans:0;outline:0;outline-color:invert;outline-style:none;outline-width:medium;overflow:visible;overflow-x:visible;overflow-y:visible;padding:0;padding-bottom:0;padding-left:0;padding-right:0;padding-top:0;page-break-after:auto;page-break-before:auto;page-break-inside:auto;perspective:none;perspective-origin:50% 50%;pointer-events:auto;position:static;quotes:"\\201C" "\\201D" "\\2018" "\\2019";tab-size:8;table-layout:auto;text-align:inherit;text-align-last:auto;text-decoration:none;text-decoration-color:inherit;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-shadow:none;text-transform:none;transform:none;transform-style:flat;transition:none;transition-delay:0s;transition-duration:0s;transition-property:none;transition-timing-function:ease;unicode-bidi:normal;vertical-align:baseline;visibility:visible;white-space:normal;widows:0;word-spacing:normal;z-index:auto}.-cbwsdk-css-reset strong{font-weight:bold}.-cbwsdk-css-reset *{box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Arial,sans-serif;line-height:1}.-cbwsdk-css-reset [class*=container]{margin:0;padding:0}.-cbwsdk-css-reset style{display:none}`)();

// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
function injectCssReset() {
    const styleEl = document.createElement('style');
    styleEl.type = 'text/css';
    styleEl.appendChild(document.createTextNode(css$2));
    document.documentElement.appendChild(styleEl);
}

function r$2(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r$2(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r$2(e))&&(n&&(n+=" "),n+=t);return n}

var n,l$1,u$1,i$1,r$1,o$1,e$1,f$1,c$1,s$1,a$1,p$1={},v$1=[],y$1=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,d$1=Array.isArray;function w$1(n,l){for(var u in l)n[u]=l[u];return n}function _(n){n&&n.parentNode&&n.parentNode.removeChild(n);}function g(l,u,t){var i,r,o,e={};for(o in u)"key"==o?i=u[o]:"ref"==o?r=u[o]:e[o]=u[o];if(arguments.length>2&&(e.children=arguments.length>3?n.call(arguments,2):t),"function"==typeof l&&null!=l.defaultProps)for(o in l.defaultProps) void 0===e[o]&&(e[o]=l.defaultProps[o]);return m$1(l,e,i,r,null)}function m$1(n,t,i,r,o){var e={type:n,props:t,key:i,ref:r,__k:null,__:null,__b:0,__e:null,__c:null,constructor:void 0,__v:null==o?++u$1:o,__i:-1,__u:0};return null==o&&null!=l$1.vnode&&l$1.vnode(e),e}function k$1(n){return n.children}function x(n,l){this.props=n,this.context=l;}function C$1(n,l){if(null==l)return n.__?C$1(n.__,n.__i+1):null;for(var u;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e)return u.__e;return "function"==typeof n.type?C$1(n):null}function S(n){var l,u;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(u=n.__k[l])&&null!=u.__e){n.__e=n.__c.base=u.__e;break}return S(n)}}function M$1(n){(!n.__d&&(n.__d=true)&&i$1.push(n)&&!P$1.__r++||r$1!==l$1.debounceRendering)&&((r$1=l$1.debounceRendering)||o$1)(P$1);}function P$1(){var n,u,t,r,o,f,c,s;for(i$1.sort(e$1);n=i$1.shift();)n.__d&&(u=i$1.length,r=void 0,f=(o=(t=n).__v).__e,c=[],s=[],t.__P&&((r=w$1({},o)).__v=o.__v+1,l$1.vnode&&l$1.vnode(r),j$1(t.__P,r,o,t.__n,t.__P.namespaceURI,32&o.__u?[f]:null,c,null==f?C$1(o):f,!!(32&o.__u),s),r.__v=o.__v,r.__.__k[r.__i]=r,z$2(c,r,s),r.__e!=f&&S(r)),i$1.length>u&&i$1.sort(e$1));P$1.__r=0;}function $$1(n,l,u,t,i,r,o,e,f,c,s){var a,h,y,d,w,_,g=t&&t.__k||v$1,m=l.length;for(f=I(u,l,g,f,m),a=0;a<m;a++)null!=(y=u.__k[a])&&(h=-1===y.__i?p$1:g[y.__i]||p$1,y.__i=a,_=j$1(n,y,h,i,r,o,e,f,c,s),d=y.__e,y.ref&&h.ref!=y.ref&&(h.ref&&V(h.ref,null,y),s.push(y.ref,y.__c||d,y)),null==w&&null!=d&&(w=d),4&y.__u||h.__k===y.__k?f=A(y,f,n):"function"==typeof y.type&&void 0!==_?f=_:d&&(f=d.nextSibling),y.__u&=-7);return u.__e=w,f}function I(n,l,u,t,i){var r,o,e,f,c,s=u.length,a=s,h=0;for(n.__k=new Array(i),r=0;r<i;r++)null!=(o=l[r])&&"boolean"!=typeof o&&"function"!=typeof o?(f=r+h,(o=n.__k[r]="string"==typeof o||"number"==typeof o||"bigint"==typeof o||o.constructor==String?m$1(null,o,null,null,null):d$1(o)?m$1(k$1,{children:o},null,null,null):void 0===o.constructor&&o.__b>0?m$1(o.type,o.props,o.key,o.ref?o.ref:null,o.__v):o).__=n,o.__b=n.__b+1,e=null,-1!==(c=o.__i=L(o,u,f,a))&&(a--,(e=u[c])&&(e.__u|=2)),null==e||null===e.__v?(-1==c&&h--,"function"!=typeof o.type&&(o.__u|=4)):c!=f&&(c==f-1?h--:c==f+1?h++:(c>f?h--:h++,o.__u|=4))):n.__k[r]=null;if(a)for(r=0;r<s;r++)null!=(e=u[r])&&0==(2&e.__u)&&(e.__e==t&&(t=C$1(e)),q$1(e,e));return t}function A(n,l,u){var t,i;if("function"==typeof n.type){for(t=n.__k,i=0;t&&i<t.length;i++)t[i]&&(t[i].__=n,l=A(t[i],l,u));return l}n.__e!=l&&(l&&n.type&&!u.contains(l)&&(l=C$1(n)),u.insertBefore(n.__e,l||null),l=n.__e);do{l=l&&l.nextSibling;}while(null!=l&&8==l.nodeType);return l}function L(n,l,u,t){var i,r,o=n.key,e=n.type,f=l[u];if(null===f||f&&o==f.key&&e===f.type&&0==(2&f.__u))return u;if(t>(null!=f&&0==(2&f.__u)?1:0))for(i=u-1,r=u+1;i>=0||r<l.length;){if(i>=0){if((f=l[i])&&0==(2&f.__u)&&o==f.key&&e===f.type)return i;i--;}if(r<l.length){if((f=l[r])&&0==(2&f.__u)&&o==f.key&&e===f.type)return r;r++;}}return  -1}function T(n,l,u){"-"==l[0]?n.setProperty(l,null==u?"":u):n[l]=null==u?"":"number"!=typeof u||y$1.test(l)?u:u+"px";}function F$1(n,l,u,t,i){var r;n:if("style"==l)if("string"==typeof u)n.style.cssText=u;else {if("string"==typeof t&&(n.style.cssText=t=""),t)for(l in t)u&&l in u||T(n.style,l,"");if(u)for(l in u)t&&u[l]===t[l]||T(n.style,l,u[l]);}else if("o"==l[0]&&"n"==l[1])r=l!=(l=l.replace(f$1,"$1")),l=l.toLowerCase()in n||"onFocusOut"==l||"onFocusIn"==l?l.toLowerCase().slice(2):l.slice(2),n.l||(n.l={}),n.l[l+r]=u,u?t?u.u=t.u:(u.u=c$1,n.addEventListener(l,r?a$1:s$1,r)):n.removeEventListener(l,r?a$1:s$1,r);else {if("http://www.w3.org/2000/svg"==i)l=l.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("width"!=l&&"height"!=l&&"href"!=l&&"list"!=l&&"form"!=l&&"tabIndex"!=l&&"download"!=l&&"rowSpan"!=l&&"colSpan"!=l&&"role"!=l&&"popover"!=l&&l in n)try{n[l]=null==u?"":u;break n}catch(n){}"function"==typeof u||(null==u||false===u&&"-"!=l[4]?n.removeAttribute(l):n.setAttribute(l,"popover"==l&&1==u?"":u));}}function O(n){return function(u){if(this.l){var t=this.l[u.type+n];if(null==u.t)u.t=c$1++;else if(u.t<t.u)return;return t(l$1.event?l$1.event(u):u)}}}function j$1(n,u,t,i,r,o,e,f,c,s){var a,h,p,v,y,g,m,b,C,S,M,P,I,A,H,L,T,F=u.type;if(void 0!==u.constructor)return null;128&t.__u&&(c=!!(32&t.__u),o=[f=u.__e=t.__e]),(a=l$1.__b)&&a(u);n:if("function"==typeof F)try{if(b=u.props,C="prototype"in F&&F.prototype.render,S=(a=F.contextType)&&i[a.__c],M=a?S?S.props.value:a.__:i,t.__c?m=(h=u.__c=t.__c).__=h.__E:(C?u.__c=h=new F(b,M):(u.__c=h=new x(b,M),h.constructor=F,h.render=B$2),S&&S.sub(h),h.props=b,h.state||(h.state={}),h.context=M,h.__n=i,p=h.__d=!0,h.__h=[],h._sb=[]),C&&null==h.__s&&(h.__s=h.state),C&&null!=F.getDerivedStateFromProps&&(h.__s==h.state&&(h.__s=w$1({},h.__s)),w$1(h.__s,F.getDerivedStateFromProps(b,h.__s))),v=h.props,y=h.state,h.__v=u,p)C&&null==F.getDerivedStateFromProps&&null!=h.componentWillMount&&h.componentWillMount(),C&&null!=h.componentDidMount&&h.__h.push(h.componentDidMount);else {if(C&&null==F.getDerivedStateFromProps&&b!==v&&null!=h.componentWillReceiveProps&&h.componentWillReceiveProps(b,M),!h.__e&&(null!=h.shouldComponentUpdate&&!1===h.shouldComponentUpdate(b,h.__s,M)||u.__v==t.__v)){for(u.__v!=t.__v&&(h.props=b,h.state=h.__s,h.__d=!1),u.__e=t.__e,u.__k=t.__k,u.__k.some(function(n){n&&(n.__=u);}),P=0;P<h._sb.length;P++)h.__h.push(h._sb[P]);h._sb=[],h.__h.length&&e.push(h);break n}null!=h.componentWillUpdate&&h.componentWillUpdate(b,h.__s,M),C&&null!=h.componentDidUpdate&&h.__h.push(function(){h.componentDidUpdate(v,y,g);});}if(h.context=M,h.props=b,h.__P=n,h.__e=!1,I=l$1.__r,A=0,C){for(h.state=h.__s,h.__d=!1,I&&I(u),a=h.render(h.props,h.state,h.context),H=0;H<h._sb.length;H++)h.__h.push(h._sb[H]);h._sb=[];}else do{h.__d=!1,I&&I(u),a=h.render(h.props,h.state,h.context),h.state=h.__s;}while(h.__d&&++A<25);h.state=h.__s,null!=h.getChildContext&&(i=w$1(w$1({},i),h.getChildContext())),C&&!p&&null!=h.getSnapshotBeforeUpdate&&(g=h.getSnapshotBeforeUpdate(v,y)),f=$$1(n,d$1(L=null!=a&&a.type===k$1&&null==a.key?a.props.children:a)?L:[L],u,t,i,r,o,e,f,c,s),h.base=u.__e,u.__u&=-161,h.__h.length&&e.push(h),m&&(h.__E=h.__=null);}catch(n){if(u.__v=null,c||null!=o)if(n.then){for(u.__u|=c?160:128;f&&8==f.nodeType&&f.nextSibling;)f=f.nextSibling;o[o.indexOf(f)]=null,u.__e=f;}else for(T=o.length;T--;)_(o[T]);else u.__e=t.__e,u.__k=t.__k;l$1.__e(n,u,t);}else null==o&&u.__v==t.__v?(u.__k=t.__k,u.__e=t.__e):f=u.__e=N(t.__e,u,t,i,r,o,e,c,s);return (a=l$1.diffed)&&a(u),128&u.__u?void 0:f}function z$2(n,u,t){for(var i=0;i<t.length;i++)V(t[i],t[++i],t[++i]);l$1.__c&&l$1.__c(u,n),n.some(function(u){try{n=u.__h,u.__h=[],n.some(function(n){n.call(u);});}catch(n){l$1.__e(n,u.__v);}});}function N(u,t,i,r,o,e,f,c,s){var a,h,v,y,w,g,m,b=i.props,k=t.props,x=t.type;if("svg"==x?o="http://www.w3.org/2000/svg":"math"==x?o="http://www.w3.org/1998/Math/MathML":o||(o="http://www.w3.org/1999/xhtml"),null!=e)for(a=0;a<e.length;a++)if((w=e[a])&&"setAttribute"in w==!!x&&(x?w.localName==x:3==w.nodeType)){u=w,e[a]=null;break}if(null==u){if(null==x)return document.createTextNode(k);u=document.createElementNS(o,x,k.is&&k),c&&(l$1.__m&&l$1.__m(t,e),c=false),e=null;}if(null===x)b===k||c&&u.data===k||(u.data=k);else {if(e=e&&n.call(u.childNodes),b=i.props||p$1,!c&&null!=e)for(b={},a=0;a<u.attributes.length;a++)b[(w=u.attributes[a]).name]=w.value;for(a in b)if(w=b[a],"children"==a);else if("dangerouslySetInnerHTML"==a)v=w;else if(!(a in k)){if("value"==a&&"defaultValue"in k||"checked"==a&&"defaultChecked"in k)continue;F$1(u,a,null,w,o);}for(a in k)w=k[a],"children"==a?y=w:"dangerouslySetInnerHTML"==a?h=w:"value"==a?g=w:"checked"==a?m=w:c&&"function"!=typeof w||b[a]===w||F$1(u,a,w,b[a],o);if(h)c||v&&(h.__html===v.__html||h.__html===u.innerHTML)||(u.innerHTML=h.__html),t.__k=[];else if(v&&(u.innerHTML=""),$$1(u,d$1(y)?y:[y],t,i,r,"foreignObject"==x?"http://www.w3.org/1999/xhtml":o,e,f,e?e[0]:i.__k&&C$1(i,0),c,s),null!=e)for(a=e.length;a--;)_(e[a]);c||(a="value","progress"==x&&null==g?u.removeAttribute("value"):void 0!==g&&(g!==u[a]||"progress"==x&&!g||"option"==x&&g!==b[a])&&F$1(u,a,g,b[a],o),a="checked",void 0!==m&&m!==u[a]&&F$1(u,a,m,b[a],o));}return u}function V(n,u,t){try{if("function"==typeof n){var i="function"==typeof n.__u;i&&n.__u(),i&&null==u||(n.__u=n(u));}else n.current=u;}catch(n){l$1.__e(n,t);}}function q$1(n,u,t){var i,r;if(l$1.unmount&&l$1.unmount(n),(i=n.ref)&&(i.current&&i.current!==n.__e||V(i,null,u)),null!=(i=n.__c)){if(i.componentWillUnmount)try{i.componentWillUnmount();}catch(n){l$1.__e(n,u);}i.base=i.__P=null;}if(i=n.__k)for(r=0;r<i.length;r++)i[r]&&q$1(i[r],u,t||"function"!=typeof n.type);t||_(n.__e),n.__c=n.__=n.__e=void 0;}function B$2(n,l,u){return this.constructor(n,u)}function D$1(u,t,i){var r,o,e,f;t==document&&(t=document.documentElement),l$1.__&&l$1.__(u,t),o=(r="function"=="undefined")?null:t.__k,e=[],f=[],j$1(t,u=(t).__k=g(k$1,null,[u]),o||p$1,p$1,t.namespaceURI,o?null:t.firstChild?n.call(t.childNodes):null,e,o?o.__e:t.firstChild,r,f),z$2(e,u,f);}n=v$1.slice,l$1={__e:function(n,l,u,t){for(var i,r,o;l=l.__;)if((i=l.__c)&&!i.__)try{if((r=i.constructor)&&null!=r.getDerivedStateFromError&&(i.setState(r.getDerivedStateFromError(n)),o=i.__d),null!=i.componentDidCatch&&(i.componentDidCatch(n,t||{}),o=i.__d),o)return i.__E=i}catch(l){n=l;}throw n}},u$1=0,x.prototype.setState=function(n,l){var u;u=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=w$1({},this.state),"function"==typeof n&&(n=n(w$1({},u),this.props)),n&&w$1(u,n),null!=n&&this.__v&&(l&&this._sb.push(l),M$1(this));},x.prototype.forceUpdate=function(n){this.__v&&(this.__e=true,n&&this.__h.push(n),M$1(this));},x.prototype.render=k$1,i$1=[],o$1="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,e$1=function(n,l){return n.__v.__b-l.__v.__b},P$1.__r=0,f$1=/(PointerCapture)$|Capture$/i,c$1=0,s$1=O(false),a$1=O(true);

var t,r,u,i,o=0,f=[],c=l$1,e=c.__b,a=c.__r,v=c.diffed,l=c.__c,m=c.unmount,s=c.__;function d(n,t){c.__h&&c.__h(r,n,o||t),o=0;var u=r.__H||(r.__H={__:[],__h:[]});return n>=u.__.length&&u.__.push({}),u.__[n]}function h(n){return o=1,p(D,n)}function p(n,u,i){var o=d(t++,2);if(o.t=n,!o.__c&&(o.__=[D(void 0,u),function(n){var t=o.__N?o.__N[0]:o.__[0],r=o.t(t,n);t!==r&&(o.__N=[r,o.__[1]],o.__c.setState({}));}],o.__c=r,!r.u)){var f=function(n,t,r){if(!o.__c.__H)return  true;var u=o.__c.__H.__.filter(function(n){return !!n.__c});if(u.every(function(n){return !n.__N}))return !c||c.call(this,n,t,r);var i=o.__c.props!==n;return u.forEach(function(n){if(n.__N){var t=n.__[0];n.__=n.__N,n.__N=void 0,t!==n.__[0]&&(i=true);}}),c&&c.call(this,n,t,r)||i};r.u=true;var c=r.shouldComponentUpdate,e=r.componentWillUpdate;r.componentWillUpdate=function(n,t,r){if(this.__e){var u=c;c=void 0,f(n,t,r),c=u;}e&&e.call(this,n,t,r);},r.shouldComponentUpdate=f;}return o.__N||o.__}function y(n,u){var i=d(t++,3);!c.__s&&C(i.__H,u)&&(i.__=n,i.i=u,r.__H.__h.push(i));}function j(){for(var n;n=f.shift();)if(n.__P&&n.__H)try{n.__H.__h.forEach(z$1),n.__H.__h.forEach(B$1),n.__H.__h=[];}catch(t){n.__H.__h=[],c.__e(t,n.__v);}}c.__b=function(n){r=null,e&&e(n);},c.__=function(n,t){n&&t.__k&&t.__k.__m&&(n.__m=t.__k.__m),s&&s(n,t);},c.__r=function(n){a&&a(n),t=0;var i=(r=n.__c).__H;i&&(u===r?(i.__h=[],r.__h=[],i.__.forEach(function(n){n.__N&&(n.__=n.__N),n.i=n.__N=void 0;})):(i.__h.forEach(z$1),i.__h.forEach(B$1),i.__h=[],t=0)),u=r;},c.diffed=function(n){v&&v(n);var t=n.__c;t&&t.__H&&(t.__H.__h.length&&(1!==f.push(t)&&i===c.requestAnimationFrame||((i=c.requestAnimationFrame)||w)(j)),t.__H.__.forEach(function(n){n.i&&(n.__H=n.i),n.i=void 0;})),u=r=null;},c.__c=function(n,t){t.some(function(n){try{n.__h.forEach(z$1),n.__h=n.__h.filter(function(n){return !n.__||B$1(n)});}catch(r){t.some(function(n){n.__h&&(n.__h=[]);}),t=[],c.__e(r,n.__v);}}),l&&l(n,t);},c.unmount=function(n){m&&m(n);var t,r=n.__c;r&&r.__H&&(r.__H.__.forEach(function(n){try{z$1(n);}catch(n){t=n;}}),r.__H=void 0,t&&c.__e(t,r.__v));};var k="function"==typeof requestAnimationFrame;function w(n){var t,r=function(){clearTimeout(u),k&&cancelAnimationFrame(t),setTimeout(n);},u=setTimeout(r,100);k&&(t=requestAnimationFrame(r));}function z$1(n){var t=r,u=n.__c;"function"==typeof u&&(n.__c=void 0,u()),r=t;}function B$1(n){var t=r;n.__c=n.__(),r=t;}function C(n,t){return !n||n.length!==t.length||t.some(function(t,r){return t!==n[r]})}function D(n,t){return "function"==typeof t?t(n):t}

var css$1 = (() => `.-cbwsdk-css-reset .-gear-container{margin-left:16px !important;margin-right:9px !important;display:flex;align-items:center;justify-content:center;width:24px;height:24px;transition:opacity .25s}.-cbwsdk-css-reset .-gear-container *{user-select:none}.-cbwsdk-css-reset .-gear-container svg{opacity:0;position:absolute}.-cbwsdk-css-reset .-gear-icon{height:12px;width:12px;z-index:10000}.-cbwsdk-css-reset .-cbwsdk-snackbar{align-items:flex-end;display:flex;flex-direction:column;position:fixed;right:0;top:0;z-index:2147483647}.-cbwsdk-css-reset .-cbwsdk-snackbar *{user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance{display:flex;flex-direction:column;margin:8px 16px 0 16px;overflow:visible;text-align:left;transform:translateX(0);transition:opacity .25s,transform .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header:hover .-gear-container svg{opacity:1}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header{display:flex;align-items:center;background:#fff;overflow:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-cblogo{margin:8px 8px 8px 8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-header-message{color:#000;font-size:13px;line-height:1.5;user-select:none}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu{background:#fff;transition:opacity .25s ease-in-out,transform .25s linear,visibility 0s;visibility:hidden;border:1px solid #e7ebee;box-sizing:border-box;border-radius:8px;opacity:0;flex-direction:column;padding-left:8px;padding-right:8px}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:last-child{margin-bottom:8px !important}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover{background:#f5f7f8;border-radius:6px;transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover span{color:#050f19;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item:hover svg path{fill:#000;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item{visibility:inherit;height:35px;margin-top:8px;margin-bottom:0;display:flex;flex-direction:row;align-items:center;padding:8px;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item *{visibility:inherit;cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover{background:rgba(223,95,103,.2);transition:background .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover *{cursor:pointer}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover svg path{fill:#df5f67;transition:fill .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-is-red:hover span{color:#df5f67;transition:color .25s}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-menu-item-info{color:#aaa;font-size:13px;margin:0 8px 0 32px;position:absolute}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-hidden{opacity:0;text-align:left;transform:translateX(25%);transition:opacity .5s linear}.-cbwsdk-css-reset .-cbwsdk-snackbar-instance-expanded .-cbwsdk-snackbar-instance-menu{opacity:1;display:flex;transform:translateY(8px);visibility:visible}`)();

// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
const cblogo = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEuNDkyIDEwLjQxOWE4LjkzIDguOTMgMCAwMTguOTMtOC45M2gxMS4xNjNhOC45MyA4LjkzIDAgMDE4LjkzIDguOTN2MTEuMTYzYTguOTMgOC45MyAwIDAxLTguOTMgOC45M0gxMC40MjJhOC45MyA4LjkzIDAgMDEtOC45My04LjkzVjEwLjQxOXoiIGZpbGw9IiMxNjUyRjAiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjQxOSAwSDIxLjU4QzI3LjMzNSAwIDMyIDQuNjY1IDMyIDEwLjQxOVYyMS41OEMzMiAyNy4zMzUgMjcuMzM1IDMyIDIxLjU4MSAzMkgxMC40MkM0LjY2NSAzMiAwIDI3LjMzNSAwIDIxLjU4MVYxMC40MkMwIDQuNjY1IDQuNjY1IDAgMTAuNDE5IDB6bTAgMS40ODhhOC45MyA4LjkzIDAgMDAtOC45MyA4LjkzdjExLjE2M2E4LjkzIDguOTMgMCAwMDguOTMgOC45M0gyMS41OGE4LjkzIDguOTMgMCAwMDguOTMtOC45M1YxMC40MmE4LjkzIDguOTMgMCAwMC04LjkzLTguOTNIMTAuNDJ6IiBmaWxsPSIjZmZmIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS45OTggMjYuMDQ5Yy01LjU0OSAwLTEwLjA0Ny00LjQ5OC0xMC4wNDctMTAuMDQ3IDAtNS41NDggNC40OTgtMTAuMDQ2IDEwLjA0Ny0xMC4wNDYgNS41NDggMCAxMC4wNDYgNC40OTggMTAuMDQ2IDEwLjA0NiAwIDUuNTQ5LTQuNDk4IDEwLjA0Ny0xMC4wNDYgMTAuMDQ3eiIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0xMi43NjIgMTQuMjU0YzAtLjgyMi42NjctMS40ODkgMS40ODktMS40ODloMy40OTdjLjgyMiAwIDEuNDg4LjY2NiAxLjQ4OCAxLjQ4OXYzLjQ5N2MwIC44MjItLjY2NiAxLjQ4OC0xLjQ4OCAxLjQ4OGgtMy40OTdhMS40ODggMS40ODggMCAwMS0xLjQ4OS0xLjQ4OHYtMy40OTh6IiBmaWxsPSIjMTY1MkYwIi8+PC9zdmc+`;
const gearIcon = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDYuNzV2LTEuNWwtMS43Mi0uNTdjLS4wOC0uMjctLjE5LS41Mi0uMzItLjc3bC44MS0xLjYyLTEuMDYtMS4wNi0xLjYyLjgxYy0uMjQtLjEzLS41LS4yNC0uNzctLjMyTDYuNzUgMGgtMS41bC0uNTcgMS43MmMtLjI3LjA4LS41My4xOS0uNzcuMzJsLTEuNjItLjgxLTEuMDYgMS4wNi44MSAxLjYyYy0uMTMuMjQtLjI0LjUtLjMyLjc3TDAgNS4yNXYxLjVsMS43Mi41N2MuMDguMjcuMTkuNTMuMzIuNzdsLS44MSAxLjYyIDEuMDYgMS4wNiAxLjYyLS44MWMuMjQuMTMuNS4yMy43Ny4zMkw1LjI1IDEyaDEuNWwuNTctMS43MmMuMjctLjA4LjUyLS4xOS43Ny0uMzJsMS42Mi44MSAxLjA2LTEuMDYtLjgxLTEuNjJjLjEzLS4yNC4yMy0uNS4zMi0uNzdMMTIgNi43NXpNNiA4LjVhMi41IDIuNSAwIDAxMC01IDIuNSAyLjUgMCAwMTAgNXoiIGZpbGw9IiMwNTBGMTkiLz48L3N2Zz4=`;
class Snackbar {
    constructor() {
        this.items = new Map();
        this.nextItemKey = 0;
        this.root = null;
        this.darkMode = isDarkMode();
    }
    attach(el) {
        this.root = document.createElement('div');
        this.root.className = '-cbwsdk-snackbar-root';
        el.appendChild(this.root);
        this.render();
    }
    presentItem(itemProps) {
        const key = this.nextItemKey++;
        this.items.set(key, itemProps);
        this.render();
        return () => {
            this.items.delete(key);
            this.render();
        };
    }
    clear() {
        this.items.clear();
        this.render();
    }
    render() {
        if (!this.root) {
            return;
        }
        D$1(g("div", null,
            g(SnackbarContainer, { darkMode: this.darkMode }, Array.from(this.items.entries()).map(([key, itemProps]) => (g(SnackbarInstance, Object.assign({}, itemProps, { key: key })))))), this.root);
    }
}
const SnackbarContainer = (props) => (g("div", { class: clsx('-cbwsdk-snackbar-container') },
    g("style", null, css$1),
    g("div", { class: "-cbwsdk-snackbar" }, props.children)));
const SnackbarInstance = ({ autoExpand, message, menuItems, }) => {
    const [hidden, setHidden] = h(true);
    const [expanded, setExpanded] = h(autoExpand !== null && autoExpand !== void 0 ? autoExpand : false);
    y(() => {
        const timers = [
            window.setTimeout(() => {
                setHidden(false);
            }, 1),
            window.setTimeout(() => {
                setExpanded(true);
            }, 10000),
        ];
        return () => {
            timers.forEach(window.clearTimeout);
        };
    });
    const toggleExpanded = () => {
        setExpanded(!expanded);
    };
    return (g("div", { class: clsx('-cbwsdk-snackbar-instance', hidden && '-cbwsdk-snackbar-instance-hidden', expanded && '-cbwsdk-snackbar-instance-expanded') },
        g("div", { class: "-cbwsdk-snackbar-instance-header", onClick: toggleExpanded },
            g("img", { src: cblogo, class: "-cbwsdk-snackbar-instance-header-cblogo" }),
            ' ',
            g("div", { class: "-cbwsdk-snackbar-instance-header-message" }, message),
            g("div", { class: "-gear-container" },
                !expanded && (g("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    g("circle", { cx: "12", cy: "12", r: "12", fill: "#F5F7F8" }))),
                g("img", { src: gearIcon, class: "-gear-icon", title: "Expand" }))),
        menuItems && menuItems.length > 0 && (g("div", { class: "-cbwsdk-snackbar-instance-menu" }, menuItems.map((action, i) => (g("div", { class: clsx('-cbwsdk-snackbar-instance-menu-item', action.isRed && '-cbwsdk-snackbar-instance-menu-item-is-red'), onClick: action.onClick, key: i },
            g("svg", { width: action.svgWidth, height: action.svgHeight, viewBox: "0 0 10 11", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                g("path", { "fill-rule": action.defaultFillRule, "clip-rule": action.defaultClipRule, d: action.path, fill: "#AAAAAA" })),
            g("span", { class: clsx('-cbwsdk-snackbar-instance-menu-item-info', action.isRed && '-cbwsdk-snackbar-instance-menu-item-info-is-red') }, action.info))))))));
};

class WalletLinkRelayUI {
    constructor() {
        this.attached = false;
        this.snackbar = new Snackbar();
    }
    attach() {
        if (this.attached) {
            throw new Error('Coinbase Wallet SDK UI is already attached');
        }
        const el = document.documentElement;
        const container = document.createElement('div');
        container.className = '-cbwsdk-css-reset';
        el.appendChild(container);
        this.snackbar.attach(container);
        this.attached = true;
        injectCssReset();
    }
    showConnecting(options) {
        let snackbarProps;
        if (options.isUnlinkedErrorState) {
            snackbarProps = {
                autoExpand: true,
                message: 'Connection lost',
                menuItems: [
                    {
                        isRed: false,
                        info: 'Reset connection',
                        svgWidth: '10',
                        svgHeight: '11',
                        path: 'M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z',
                        defaultFillRule: 'evenodd',
                        defaultClipRule: 'evenodd',
                        onClick: options.onResetConnection,
                    },
                ],
            };
        }
        else {
            snackbarProps = {
                message: 'Confirm on phone',
                menuItems: [
                    {
                        isRed: true,
                        info: 'Cancel transaction',
                        svgWidth: '11',
                        svgHeight: '11',
                        path: 'M10.3711 1.52346L9.21775 0.370117L5.37109 4.21022L1.52444 0.370117L0.371094 1.52346L4.2112 5.37012L0.371094 9.21677L1.52444 10.3701L5.37109 6.53001L9.21775 10.3701L10.3711 9.21677L6.53099 5.37012L10.3711 1.52346Z',
                        defaultFillRule: 'inherit',
                        defaultClipRule: 'inherit',
                        onClick: options.onCancel,
                    },
                    {
                        isRed: false,
                        info: 'Reset connection',
                        svgWidth: '10',
                        svgHeight: '11',
                        path: 'M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z',
                        defaultFillRule: 'evenodd',
                        defaultClipRule: 'evenodd',
                        onClick: options.onResetConnection,
                    },
                ],
            };
        }
        return this.snackbar.presentItem(snackbarProps);
    }
}

var css = (() => `.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-backdrop{position:fixed;top:0;left:0;right:0;bottom:0;transition:opacity .25s;background-color:rgba(10,11,13,.5)}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-backdrop-hidden{opacity:0}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box{display:block;position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);padding:20px;border-radius:8px;background-color:#fff;color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box p{display:block;font-weight:400;font-size:14px;line-height:20px;padding-bottom:12px;color:#5b636e}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box button{appearance:none;border:none;background:none;color:#0052ff;padding:0;text-decoration:none;display:block;font-weight:600;font-size:16px;line-height:24px}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.dark{background-color:#0a0b0d;color:#fff}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.dark button{color:#0052ff}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.light{background-color:#fff;color:#0a0b0d}.-cbwsdk-css-reset .-cbwsdk-redirect-dialog-box.light button{color:#0052ff}`)();

class RedirectDialog {
    constructor() {
        this.root = null;
        this.darkMode = isDarkMode();
    }
    attach() {
        const el = document.documentElement;
        this.root = document.createElement('div');
        this.root.className = '-cbwsdk-css-reset';
        el.appendChild(this.root);
        injectCssReset();
    }
    present(props) {
        this.render(props);
    }
    clear() {
        this.render(null);
    }
    render(props) {
        if (!this.root)
            return;
        D$1(null, this.root);
        if (!props)
            return;
        D$1(g(RedirectDialogContent, Object.assign({}, props, { onDismiss: () => {
                this.clear();
            }, darkMode: this.darkMode })), this.root);
    }
}
const RedirectDialogContent = ({ title, buttonText, darkMode, onButtonClick, onDismiss }) => {
    const theme = darkMode ? 'dark' : 'light';
    return (g(SnackbarContainer, { darkMode: darkMode },
        g("div", { class: "-cbwsdk-redirect-dialog" },
            g("style", null, css),
            g("div", { class: "-cbwsdk-redirect-dialog-backdrop", onClick: onDismiss }),
            g("div", { class: clsx('-cbwsdk-redirect-dialog-box', theme) },
                g("p", null, title),
                g("button", { onClick: onButtonClick }, buttonText)))));
};

const CB_KEYS_URL = 'https://keys.coinbase.com/connect';
const CB_WALLET_RPC_URL = 'http://rpc.wallet.coinbase.com';
const WALLETLINK_URL = 'https://www.walletlink.org';
const CBW_MOBILE_DEEPLINK_URL = 'https://go.cb-w.com/walletlink';

class WLMobileRelayUI {
    constructor() {
        this.attached = false;
        this.redirectDialog = new RedirectDialog();
    }
    attach() {
        if (this.attached) {
            throw new Error('Coinbase Wallet SDK UI is already attached');
        }
        this.redirectDialog.attach();
        this.attached = true;
    }
    redirectToCoinbaseWallet(walletLinkUrl) {
        const url = new URL(CBW_MOBILE_DEEPLINK_URL);
        url.searchParams.append('redirect_url', getLocation().href);
        if (walletLinkUrl) {
            url.searchParams.append('wl_url', walletLinkUrl);
        }
        const anchorTag = document.createElement('a');
        anchorTag.target = 'cbw-opener';
        anchorTag.href = url.href;
        anchorTag.rel = 'noreferrer noopener';
        anchorTag.click();
    }
    openCoinbaseWalletDeeplink(walletLinkUrl) {
        this.redirectDialog.present({
            title: 'Redirecting to Coinbase Wallet...',
            buttonText: 'Open',
            onButtonClick: () => {
                this.redirectToCoinbaseWallet(walletLinkUrl);
            },
        });
        setTimeout(() => {
            this.redirectToCoinbaseWallet(walletLinkUrl);
        }, 99);
    }
    showConnecting(_options) {
        // it uses the return callback to clear the dialog
        return () => {
            this.redirectDialog.clear();
        };
    }
}

// Copyright (c) 2018-2023 Coinbase, Inc. <https://www.coinbase.com/>
class WalletLinkRelay {
    constructor(options) {
        this.chainCallbackParams = { chainId: '', jsonRpcUrl: '' }; // to implement distinctUntilChanged
        this.isMobileWeb = isMobileWeb();
        this.linkedUpdated = (linked) => {
            this.isLinked = linked;
            const cachedAddresses = this.storage.getItem(LOCAL_STORAGE_ADDRESSES_KEY);
            if (linked) {
                // Only set linked session variable one way
                this._session.linked = linked;
            }
            this.isUnlinkedErrorState = false;
            if (cachedAddresses) {
                const addresses = cachedAddresses.split(' ');
                const wasConnectedViaStandalone = this.storage.getItem('IsStandaloneSigning') === 'true';
                if (addresses[0] !== '' && !linked && this._session.linked && !wasConnectedViaStandalone) {
                    this.isUnlinkedErrorState = true;
                }
            }
        };
        this.metadataUpdated = (key, value) => {
            this.storage.setItem(key, value);
        };
        this.chainUpdated = (chainId, jsonRpcUrl) => {
            if (this.chainCallbackParams.chainId === chainId &&
                this.chainCallbackParams.jsonRpcUrl === jsonRpcUrl) {
                return;
            }
            this.chainCallbackParams = {
                chainId,
                jsonRpcUrl,
            };
            if (this.chainCallback) {
                this.chainCallback(jsonRpcUrl, Number.parseInt(chainId, 10));
            }
        };
        this.accountUpdated = (selectedAddress) => {
            if (this.accountsCallback) {
                this.accountsCallback([selectedAddress]);
            }
            if (WalletLinkRelay.accountRequestCallbackIds.size > 0) {
                // We get the ethereum address from the metadata.  If for whatever
                // reason we don't get a response via an explicit web3 message
                // we can still fulfill the eip1102 request.
                Array.from(WalletLinkRelay.accountRequestCallbackIds.values()).forEach((id) => {
                    this.invokeCallback(id, {
                        method: 'requestEthereumAccounts',
                        result: [selectedAddress],
                    });
                });
                WalletLinkRelay.accountRequestCallbackIds.clear();
            }
        };
        this.resetAndReload = this.resetAndReload.bind(this);
        this.linkAPIUrl = options.linkAPIUrl;
        this.storage = options.storage;
        this.metadata = options.metadata;
        this.accountsCallback = options.accountsCallback;
        this.chainCallback = options.chainCallback;
        const { session, ui, connection } = this.subscribe();
        this._session = session;
        this.connection = connection;
        this.relayEventManager = new RelayEventManager();
        this.ui = ui;
        this.ui.attach();
    }
    subscribe() {
        const session = WalletLinkSession.load(this.storage) || WalletLinkSession.create(this.storage);
        const { linkAPIUrl } = this;
        const connection = new WalletLinkConnection({
            session,
            linkAPIUrl,
            listener: this,
        });
        const ui = this.isMobileWeb ? new WLMobileRelayUI() : new WalletLinkRelayUI();
        connection.connect();
        return { session, ui, connection };
    }
    resetAndReload() {
        this.connection
            .destroy()
            .then(() => {
            /**
             * Only clear storage if the session id we have in memory matches the one on disk
             * Otherwise, in the case where we have 2 tabs, another tab might have cleared
             * storage already.  In that case if we clear storage again, the user will be in
             * a state where the first tab allows the user to connect but the session that
             * was used isn't persisted.  This leaves the user in a state where they aren't
             * connected to the mobile app.
             */
            const storedSession = WalletLinkSession.load(this.storage);
            if ((storedSession === null || storedSession === void 0 ? void 0 : storedSession.id) === this._session.id) {
                ScopedLocalStorage.clearAll();
            }
            document.location.reload();
        })
            .catch((_) => { });
    }
    signEthereumTransaction(params) {
        return this.sendRequest({
            method: 'signEthereumTransaction',
            params: {
                fromAddress: params.fromAddress,
                toAddress: params.toAddress,
                weiValue: bigIntStringFromBigInt(params.weiValue),
                data: hexStringFromBuffer(params.data, true),
                nonce: params.nonce,
                gasPriceInWei: params.gasPriceInWei ? bigIntStringFromBigInt(params.gasPriceInWei) : null,
                maxFeePerGas: params.gasPriceInWei ? bigIntStringFromBigInt(params.gasPriceInWei) : null,
                maxPriorityFeePerGas: params.gasPriceInWei
                    ? bigIntStringFromBigInt(params.gasPriceInWei)
                    : null,
                gasLimit: params.gasLimit ? bigIntStringFromBigInt(params.gasLimit) : null,
                chainId: params.chainId,
                shouldSubmit: false,
            },
        });
    }
    signAndSubmitEthereumTransaction(params) {
        return this.sendRequest({
            method: 'signEthereumTransaction',
            params: {
                fromAddress: params.fromAddress,
                toAddress: params.toAddress,
                weiValue: bigIntStringFromBigInt(params.weiValue),
                data: hexStringFromBuffer(params.data, true),
                nonce: params.nonce,
                gasPriceInWei: params.gasPriceInWei ? bigIntStringFromBigInt(params.gasPriceInWei) : null,
                maxFeePerGas: params.maxFeePerGas ? bigIntStringFromBigInt(params.maxFeePerGas) : null,
                maxPriorityFeePerGas: params.maxPriorityFeePerGas
                    ? bigIntStringFromBigInt(params.maxPriorityFeePerGas)
                    : null,
                gasLimit: params.gasLimit ? bigIntStringFromBigInt(params.gasLimit) : null,
                chainId: params.chainId,
                shouldSubmit: true,
            },
        });
    }
    submitEthereumTransaction(signedTransaction, chainId) {
        return this.sendRequest({
            method: 'submitEthereumTransaction',
            params: {
                signedTransaction: hexStringFromBuffer(signedTransaction, true),
                chainId,
            },
        });
    }
    getWalletLinkSession() {
        return this._session;
    }
    sendRequest(request) {
        let hideSnackbarItem = null;
        const id = randomBytesHex(8);
        const cancel = (error) => {
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
            hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
        };
        return new Promise((resolve, reject) => {
            {
                hideSnackbarItem = this.ui.showConnecting({
                    isUnlinkedErrorState: this.isUnlinkedErrorState,
                    onCancel: cancel,
                    onResetConnection: this.resetAndReload, // eslint-disable-line @typescript-eslint/unbound-method
                });
            }
            this.relayEventManager.callbacks.set(id, (response) => {
                hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
                if (isErrorResponse(response)) {
                    return reject(new Error(response.errorMessage));
                }
                resolve(response);
            });
            this.publishWeb3RequestEvent(id, request);
        });
    }
    publishWeb3RequestEvent(id, request) {
        const message = { type: 'WEB3_REQUEST', id, request };
        this.publishEvent('Web3Request', message, true)
            .then((_) => { })
            .catch((err) => {
            this.handleWeb3ResponseMessage(message.id, {
                method: request.method,
                errorMessage: err.message,
            });
        });
        if (this.isMobileWeb) {
            this.openCoinbaseWalletDeeplink(request.method);
        }
    }
    // copied from MobileRelay
    openCoinbaseWalletDeeplink(method) {
        if (!(this.ui instanceof WLMobileRelayUI))
            return;
        // For mobile relay requests, open the Coinbase Wallet app
        switch (method) {
            case 'requestEthereumAccounts': // requestEthereumAccounts is handled via popup
            case 'switchEthereumChain': // switchEthereumChain doesn't need to open the app
                return;
            default:
                window.addEventListener('blur', () => {
                    window.addEventListener('focus', () => {
                        this.connection.checkUnseenEvents();
                    }, { once: true });
                }, { once: true });
                this.ui.openCoinbaseWalletDeeplink();
                break;
        }
    }
    publishWeb3RequestCanceledEvent(id) {
        const message = {
            type: 'WEB3_REQUEST_CANCELED',
            id,
        };
        this.publishEvent('Web3RequestCanceled', message, false).then();
    }
    publishEvent(event, message, callWebhook) {
        return this.connection.publishEvent(event, message, callWebhook);
    }
    handleWeb3ResponseMessage(id, response) {
        if (response.method === 'requestEthereumAccounts') {
            WalletLinkRelay.accountRequestCallbackIds.forEach((id) => this.invokeCallback(id, response));
            WalletLinkRelay.accountRequestCallbackIds.clear();
            return;
        }
        this.invokeCallback(id, response);
    }
    handleErrorResponse(id, method, error) {
        var _a;
        const errorMessage = (_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : 'Unspecified error message.';
        this.handleWeb3ResponseMessage(id, {
            method,
            errorMessage,
        });
    }
    invokeCallback(id, response) {
        const callback = this.relayEventManager.callbacks.get(id);
        if (callback) {
            callback(response);
            this.relayEventManager.callbacks.delete(id);
        }
    }
    requestEthereumAccounts() {
        const { appName, appLogoUrl } = this.metadata;
        const request = {
            method: 'requestEthereumAccounts',
            params: {
                appName,
                appLogoUrl,
            },
        };
        const id = randomBytesHex(8);
        return new Promise((resolve, reject) => {
            this.relayEventManager.callbacks.set(id, (response) => {
                if (isErrorResponse(response)) {
                    return reject(new Error(response.errorMessage));
                }
                resolve(response);
            });
            WalletLinkRelay.accountRequestCallbackIds.add(id);
            this.publishWeb3RequestEvent(id, request);
        });
    }
    watchAsset(type, address, symbol, decimals, image, chainId) {
        const request = {
            method: 'watchAsset',
            params: {
                type,
                options: {
                    address,
                    symbol,
                    decimals,
                    image,
                },
                chainId,
            },
        };
        let hideSnackbarItem = null;
        const id = randomBytesHex(8);
        const cancel = (error) => {
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
            hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
        };
        {
            hideSnackbarItem = this.ui.showConnecting({
                isUnlinkedErrorState: this.isUnlinkedErrorState,
                onCancel: cancel,
                onResetConnection: this.resetAndReload, // eslint-disable-line @typescript-eslint/unbound-method
            });
        }
        return new Promise((resolve, reject) => {
            this.relayEventManager.callbacks.set(id, (response) => {
                hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
                if (isErrorResponse(response)) {
                    return reject(new Error(response.errorMessage));
                }
                resolve(response);
            });
            this.publishWeb3RequestEvent(id, request);
        });
    }
    addEthereumChain(chainId, rpcUrls, iconUrls, blockExplorerUrls, chainName, nativeCurrency) {
        const request = {
            method: 'addEthereumChain',
            params: {
                chainId,
                rpcUrls,
                blockExplorerUrls,
                chainName,
                iconUrls,
                nativeCurrency,
            },
        };
        let hideSnackbarItem = null;
        const id = randomBytesHex(8);
        const cancel = (error) => {
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
            hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
        };
        {
            hideSnackbarItem = this.ui.showConnecting({
                isUnlinkedErrorState: this.isUnlinkedErrorState,
                onCancel: cancel,
                onResetConnection: this.resetAndReload, // eslint-disable-line @typescript-eslint/unbound-method
            });
        }
        return new Promise((resolve, reject) => {
            this.relayEventManager.callbacks.set(id, (response) => {
                hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
                if (isErrorResponse(response)) {
                    return reject(new Error(response.errorMessage));
                }
                resolve(response);
            });
            this.publishWeb3RequestEvent(id, request);
        });
    }
    switchEthereumChain(chainId, address) {
        const request = {
            method: 'switchEthereumChain',
            params: Object.assign({ chainId }, { address }),
        };
        let hideSnackbarItem = null;
        const id = randomBytesHex(8);
        const cancel = (error) => {
            this.publishWeb3RequestCanceledEvent(id);
            this.handleErrorResponse(id, request.method, error);
            hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
        };
        {
            hideSnackbarItem = this.ui.showConnecting({
                isUnlinkedErrorState: this.isUnlinkedErrorState,
                onCancel: cancel,
                onResetConnection: this.resetAndReload, // eslint-disable-line @typescript-eslint/unbound-method
            });
        }
        return new Promise((resolve, reject) => {
            this.relayEventManager.callbacks.set(id, (response) => {
                hideSnackbarItem === null || hideSnackbarItem === void 0 ? void 0 : hideSnackbarItem();
                if (isErrorResponse(response) && response.errorCode) {
                    return reject(standardErrors.provider.custom({
                        code: response.errorCode,
                        message: `Unrecognized chain ID. Try adding the chain using addEthereumChain first.`,
                    }));
                }
                else if (isErrorResponse(response)) {
                    return reject(new Error(response.errorMessage));
                }
                resolve(response);
            });
            this.publishWeb3RequestEvent(id, request);
        });
    }
}
WalletLinkRelay.accountRequestCallbackIds = new Set();

// Copyright (c) 2018-2024 Coinbase, Inc. <https://www.coinbase.com/>
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const DEFAULT_CHAIN_ID_KEY = 'DefaultChainId';
const DEFAULT_JSON_RPC_URL = 'DefaultJsonRpcUrl';
// original source: https://github.com/coinbase/coinbase-wallet-sdk/blob/v3.7.1/packages/wallet-sdk/src/provider/CoinbaseWalletProvider.ts
class WalletLinkSigner {
    constructor(options) {
        this._relay = null;
        this._addresses = [];
        this.metadata = options.metadata;
        this._storage = new ScopedLocalStorage('walletlink', WALLETLINK_URL);
        this.callback = options.callback || null;
        const cachedAddresses = this._storage.getItem(LOCAL_STORAGE_ADDRESSES_KEY);
        if (cachedAddresses) {
            const addresses = cachedAddresses.split(' ');
            if (addresses[0] !== '') {
                this._addresses = addresses.map((address) => ensureAddressString(address));
            }
        }
        this.initializeRelay();
    }
    getSession() {
        const relay = this.initializeRelay();
        const { id, secret } = relay.getWalletLinkSession();
        return { id, secret };
    }
    async handshake() {
        await this._eth_requestAccounts();
    }
    get selectedAddress() {
        return this._addresses[0] || undefined;
    }
    get jsonRpcUrl() {
        var _a;
        return (_a = this._storage.getItem(DEFAULT_JSON_RPC_URL)) !== null && _a !== void 0 ? _a : undefined;
    }
    set jsonRpcUrl(value) {
        this._storage.setItem(DEFAULT_JSON_RPC_URL, value);
    }
    updateProviderInfo(jsonRpcUrl, chainId) {
        var _a;
        this.jsonRpcUrl = jsonRpcUrl;
        // emit chainChanged event if necessary
        const originalChainId = this.getChainId();
        this._storage.setItem(DEFAULT_CHAIN_ID_KEY, chainId.toString(10));
        const chainChanged = ensureIntNumber(chainId) !== originalChainId;
        if (chainChanged) {
            (_a = this.callback) === null || _a === void 0 ? void 0 : _a.call(this, 'chainChanged', hexStringFromNumber(chainId));
        }
    }
    async watchAsset(params) {
        const request = (Array.isArray(params) ? params[0] : params);
        if (!request.type) {
            throw standardErrors.rpc.invalidParams('Type is required');
        }
        if ((request === null || request === void 0 ? void 0 : request.type) !== 'ERC20') {
            throw standardErrors.rpc.invalidParams(`Asset of type '${request.type}' is not supported`);
        }
        if (!(request === null || request === void 0 ? void 0 : request.options)) {
            throw standardErrors.rpc.invalidParams('Options are required');
        }
        if (!(request === null || request === void 0 ? void 0 : request.options.address)) {
            throw standardErrors.rpc.invalidParams('Address is required');
        }
        const chainId = this.getChainId();
        const { address, symbol, image, decimals } = request.options;
        const relay = this.initializeRelay();
        const result = await relay.watchAsset(request.type, address, symbol, decimals, image, chainId === null || chainId === void 0 ? void 0 : chainId.toString());
        if (isErrorResponse(result))
            return false;
        return !!result.result;
    }
    async addEthereumChain(params) {
        var _a, _b;
        const request = params[0];
        if (((_a = request.rpcUrls) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            throw standardErrors.rpc.invalidParams('please pass in at least 1 rpcUrl');
        }
        if (!request.chainName || request.chainName.trim() === '') {
            throw standardErrors.rpc.invalidParams('chainName is a required field');
        }
        if (!request.nativeCurrency) {
            throw standardErrors.rpc.invalidParams('nativeCurrency is a required field');
        }
        const chainIdNumber = Number.parseInt(request.chainId, 16);
        if (chainIdNumber === this.getChainId()) {
            return false;
        }
        const relay = this.initializeRelay();
        const { rpcUrls = [], blockExplorerUrls = [], chainName, iconUrls = [], nativeCurrency, } = request;
        const res = await relay.addEthereumChain(chainIdNumber.toString(), rpcUrls, iconUrls, blockExplorerUrls, chainName, nativeCurrency);
        if (isErrorResponse(res))
            return false;
        if (((_b = res.result) === null || _b === void 0 ? void 0 : _b.isApproved) === true) {
            this.updateProviderInfo(rpcUrls[0], chainIdNumber);
            return null;
        }
        throw standardErrors.rpc.internal('unable to add ethereum chain');
    }
    async switchEthereumChain(params) {
        const request = params[0];
        const chainId = Number.parseInt(request.chainId, 16);
        const relay = this.initializeRelay();
        const res = await relay.switchEthereumChain(chainId.toString(10), this.selectedAddress || undefined);
        if (isErrorResponse(res))
            throw res;
        const switchResponse = res.result;
        if (switchResponse.isApproved && switchResponse.rpcUrl.length > 0) {
            this.updateProviderInfo(switchResponse.rpcUrl, chainId);
        }
        return null;
    }
    async cleanup() {
        this.callback = null;
        if (this._relay) {
            this._relay.resetAndReload();
        }
        this._storage.clear();
    }
    _setAddresses(addresses, _) {
        var _a;
        if (!Array.isArray(addresses)) {
            throw new Error('addresses is not an array');
        }
        const newAddresses = addresses.map((address) => ensureAddressString(address));
        if (JSON.stringify(newAddresses) === JSON.stringify(this._addresses)) {
            return;
        }
        this._addresses = newAddresses;
        (_a = this.callback) === null || _a === void 0 ? void 0 : _a.call(this, 'accountsChanged', newAddresses);
        this._storage.setItem(LOCAL_STORAGE_ADDRESSES_KEY, newAddresses.join(' '));
    }
    async request(request) {
        const params = request.params || [];
        switch (request.method) {
            case 'eth_accounts':
                return [...this._addresses];
            case 'eth_coinbase':
                return this.selectedAddress || null;
            case 'net_version':
                return this.getChainId().toString(10);
            case 'eth_chainId':
                return hexStringFromNumber(this.getChainId());
            case 'eth_requestAccounts':
                return this._eth_requestAccounts();
            case 'eth_ecRecover':
            case 'personal_ecRecover':
                return this.ecRecover(request);
            case 'personal_sign':
                return this.personalSign(request);
            case 'eth_signTransaction':
                return this._eth_signTransaction(params);
            case 'eth_sendRawTransaction':
                return this._eth_sendRawTransaction(params);
            case 'eth_sendTransaction':
                return this._eth_sendTransaction(params);
            case 'eth_signTypedData_v1':
            case 'eth_signTypedData_v3':
            case 'eth_signTypedData_v4':
            case 'eth_signTypedData':
                return this.signTypedData(request);
            case 'wallet_addEthereumChain':
                return this.addEthereumChain(params);
            case 'wallet_switchEthereumChain':
                return this.switchEthereumChain(params);
            case 'wallet_watchAsset':
                return this.watchAsset(params);
            default:
                if (!this.jsonRpcUrl)
                    throw standardErrors.rpc.internal('No RPC URL set for chain');
                return fetchRPCRequest(request, this.jsonRpcUrl);
        }
    }
    _ensureKnownAddress(addressString) {
        const addressStr = ensureAddressString(addressString);
        const lowercaseAddresses = this._addresses.map((address) => ensureAddressString(address));
        if (!lowercaseAddresses.includes(addressStr)) {
            throw new Error('Unknown Ethereum address');
        }
    }
    _prepareTransactionParams(tx) {
        const fromAddress = tx.from ? ensureAddressString(tx.from) : this.selectedAddress;
        if (!fromAddress) {
            throw new Error('Ethereum address is unavailable');
        }
        this._ensureKnownAddress(fromAddress);
        const toAddress = tx.to ? ensureAddressString(tx.to) : null;
        const weiValue = tx.value != null ? ensureBigInt(tx.value) : BigInt(0);
        const data = tx.data ? ensureBuffer(tx.data) : Buffer.alloc(0);
        const nonce = tx.nonce != null ? ensureIntNumber(tx.nonce) : null;
        const gasPriceInWei = tx.gasPrice != null ? ensureBigInt(tx.gasPrice) : null;
        const maxFeePerGas = tx.maxFeePerGas != null ? ensureBigInt(tx.maxFeePerGas) : null;
        const maxPriorityFeePerGas = tx.maxPriorityFeePerGas != null ? ensureBigInt(tx.maxPriorityFeePerGas) : null;
        const gasLimit = tx.gas != null ? ensureBigInt(tx.gas) : null;
        const chainId = tx.chainId ? ensureIntNumber(tx.chainId) : this.getChainId();
        return {
            fromAddress,
            toAddress,
            weiValue,
            data,
            nonce,
            gasPriceInWei,
            maxFeePerGas,
            maxPriorityFeePerGas,
            gasLimit,
            chainId,
        };
    }
    async ecRecover(request) {
        const { method, params } = request;
        if (!Array.isArray(params))
            throw standardErrors.rpc.invalidParams();
        const relay = this.initializeRelay();
        const res = await relay.sendRequest({
            method: 'ethereumAddressFromSignedMessage',
            params: {
                message: encodeToHexString(params[0]),
                signature: encodeToHexString(params[1]),
                addPrefix: method === 'personal_ecRecover',
            },
        });
        if (isErrorResponse(res))
            throw res;
        return res.result;
    }
    getChainId() {
        var _a;
        return Number.parseInt((_a = this._storage.getItem(DEFAULT_CHAIN_ID_KEY)) !== null && _a !== void 0 ? _a : '1', 10);
    }
    async _eth_requestAccounts() {
        var _a, _b;
        if (this._addresses.length > 0) {
            (_a = this.callback) === null || _a === void 0 ? void 0 : _a.call(this, 'connect', { chainId: hexStringFromNumber(this.getChainId()) });
            return this._addresses;
        }
        const relay = this.initializeRelay();
        const res = await relay.requestEthereumAccounts();
        if (isErrorResponse(res))
            throw res;
        if (!res.result) {
            throw new Error('accounts received is empty');
        }
        this._setAddresses(res.result);
        (_b = this.callback) === null || _b === void 0 ? void 0 : _b.call(this, 'connect', { chainId: hexStringFromNumber(this.getChainId()) });
        return this._addresses;
    }
    async personalSign({ params }) {
        if (!Array.isArray(params))
            throw standardErrors.rpc.invalidParams();
        const address = params[1];
        const rawData = params[0];
        this._ensureKnownAddress(address);
        const relay = this.initializeRelay();
        const res = await relay.sendRequest({
            method: 'signEthereumMessage',
            params: {
                address: ensureAddressString(address),
                message: encodeToHexString(rawData),
                addPrefix: true,
                typedDataJson: null,
            },
        });
        if (isErrorResponse(res))
            throw res;
        return res.result;
    }
    async _eth_signTransaction(params) {
        const tx = this._prepareTransactionParams(params[0] || {});
        const relay = this.initializeRelay();
        const res = await relay.signEthereumTransaction(tx);
        if (isErrorResponse(res))
            throw res;
        return res.result;
    }
    async _eth_sendRawTransaction(params) {
        const signedTransaction = ensureBuffer(params[0]);
        const relay = this.initializeRelay();
        const res = await relay.submitEthereumTransaction(signedTransaction, this.getChainId());
        if (isErrorResponse(res))
            throw res;
        return res.result;
    }
    async _eth_sendTransaction(params) {
        const tx = this._prepareTransactionParams(params[0] || {});
        const relay = this.initializeRelay();
        const res = await relay.signAndSubmitEthereumTransaction(tx);
        if (isErrorResponse(res))
            throw res;
        return res.result;
    }
    async signTypedData(request) {
        const { method, params } = request;
        if (!Array.isArray(params))
            throw standardErrors.rpc.invalidParams();
        const encode = (input) => {
            const hashFuncMap = {
                eth_signTypedData_v1: eip712.hashForSignTypedDataLegacy,
                eth_signTypedData_v3: eip712.hashForSignTypedData_v3,
                eth_signTypedData_v4: eip712.hashForSignTypedData_v4,
                eth_signTypedData: eip712.hashForSignTypedData_v4,
            };
            return hexStringFromBuffer(hashFuncMap[method]({
                data: ensureParsedJSONObject(input),
            }), true);
        };
        const address = params[method === 'eth_signTypedData_v1' ? 1 : 0];
        const rawData = params[method === 'eth_signTypedData_v1' ? 0 : 1];
        this._ensureKnownAddress(address);
        const relay = this.initializeRelay();
        const res = await relay.sendRequest({
            method: 'signEthereumMessage',
            params: {
                address: ensureAddressString(address),
                message: encode(rawData),
                typedDataJson: JSON.stringify(rawData, null, 2),
                addPrefix: false,
            },
        });
        if (isErrorResponse(res))
            throw res;
        return res.result;
    }
    initializeRelay() {
        if (!this._relay) {
            this._relay = new WalletLinkRelay({
                linkAPIUrl: WALLETLINK_URL,
                storage: this._storage,
                metadata: this.metadata,
                accountsCallback: this._setAddresses.bind(this),
                chainCallback: this.updateProviderInfo.bind(this),
            });
        }
        return this._relay;
    }
}

const SIGNER_TYPE_KEY = 'SignerType';
const storage = new ScopedLocalStorage('CBWSDK', 'SignerConfigurator');
function loadSignerType() {
    return storage.getItem(SIGNER_TYPE_KEY);
}
function storeSignerType(signerType) {
    storage.setItem(SIGNER_TYPE_KEY, signerType);
}
async function fetchSignerType(params) {
    const { communicator, metadata, handshakeRequest, callback } = params;
    listenForWalletLinkSessionRequest(communicator, metadata, callback).catch(() => { });
    const request = {
        id: crypto.randomUUID(),
        event: 'selectSignerType',
        data: Object.assign(Object.assign({}, params.preference), { handshakeRequest }),
    };
    const { data } = await communicator.postRequestAndWaitForResponse(request);
    return data;
}
function createSigner(params) {
    const { signerType, metadata, communicator, callback } = params;
    switch (signerType) {
        case 'scw': {
            return new SCWSigner({
                metadata,
                callback,
                communicator,
            });
        }
        case 'walletlink': {
            return new WalletLinkSigner({
                metadata,
                callback,
            });
        }
    }
}
async function listenForWalletLinkSessionRequest(communicator, metadata, callback) {
    await communicator.onMessage(({ event }) => event === 'WalletLinkSessionRequest');
    // temporary walletlink signer instance to handle WalletLinkSessionRequest
    // will revisit this when refactoring the walletlink signer
    const walletlink = new WalletLinkSigner({
        metadata,
        callback,
    });
    // send wallet link session to popup
    communicator.postMessage({
        event: 'WalletLinkUpdate',
        data: { session: walletlink.getSession() },
    });
    // wait for handshake to complete
    await walletlink.handshake();
    // send connected status to popup
    communicator.postMessage({
        event: 'WalletLinkUpdate',
        data: { connected: true },
    });
}

const COOP_ERROR_MESSAGE = `Coinbase Wallet SDK requires the Cross-Origin-Opener-Policy header to not be set to 'same-origin'. This is to ensure that the SDK can communicate with the Coinbase Smart Wallet app.

Please see https://www.smartwallet.dev/guides/tips/popup-tips#cross-origin-opener-policy for more information.`;
/**
 * Creates a checker for the Cross-Origin-Opener-Policy (COOP).
 *
 * @returns An object with methods to get and check the Cross-Origin-Opener-Policy.
 *
 * @method getCrossOriginOpenerPolicy
 * Retrieves current Cross-Origin-Opener-Policy.
 * @throws Will throw an error if the policy has not been checked yet.
 *
 * @method checkCrossOriginOpenerPolicy
 * Checks the Cross-Origin-Opener-Policy of the current environment.
 * If in a non-browser environment, sets the policy to 'non-browser-env'.
 * If in a browser environment, fetches the policy from the current origin.
 * Logs an error if the policy is 'same-origin'.
 */
const createCoopChecker = () => {
    let crossOriginOpenerPolicy;
    return {
        getCrossOriginOpenerPolicy: () => {
            if (crossOriginOpenerPolicy === undefined) {
                return 'undefined';
            }
            return crossOriginOpenerPolicy;
        },
        checkCrossOriginOpenerPolicy: async () => {
            if (typeof window === 'undefined') {
                // Non-browser environment
                crossOriginOpenerPolicy = 'non-browser-env';
                return;
            }
            try {
                const url = `${window.location.origin}${window.location.pathname}`;
                const response = await fetch(url, {
                    method: 'HEAD',
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = response.headers.get('Cross-Origin-Opener-Policy');
                crossOriginOpenerPolicy = result !== null && result !== void 0 ? result : 'null';
                if (crossOriginOpenerPolicy === 'same-origin') {
                    console.error(COOP_ERROR_MESSAGE);
                }
            }
            catch (error) {
                console.error('Error checking Cross-Origin-Opener-Policy:', error.message);
                crossOriginOpenerPolicy = 'error';
            }
        },
    };
};
const { checkCrossOriginOpenerPolicy, getCrossOriginOpenerPolicy } = createCoopChecker();

const POPUP_WIDTH = 420;
const POPUP_HEIGHT = 540;
// Window Management
function openPopup(url) {
    const left = (window.innerWidth - POPUP_WIDTH) / 2 + window.screenX;
    const top = (window.innerHeight - POPUP_HEIGHT) / 2 + window.screenY;
    appendAppInfoQueryParams(url);
    const popupId = `wallet_${crypto.randomUUID()}`;
    const popup = window.open(url, popupId, `width=${POPUP_WIDTH}, height=${POPUP_HEIGHT}, left=${left}, top=${top}`);
    popup === null || popup === void 0 ? void 0 : popup.focus();
    if (!popup) {
        throw standardErrors.rpc.internal('Pop up window failed to open');
    }
    return popup;
}
function closePopup(popup) {
    if (popup && !popup.closed) {
        popup.close();
    }
}
function appendAppInfoQueryParams(url) {
    const params = {
        sdkName: NAME,
        sdkVersion: VERSION$1,
        origin: window.location.origin,
        coop: getCrossOriginOpenerPolicy(),
    };
    for (const [key, value] of Object.entries(params)) {
        url.searchParams.append(key, value.toString());
    }
}

/**
 * Communicates with a popup window for Coinbase keys.coinbase.com (or another url)
 * to send and receive messages.
 *
 * This class is responsible for opening a popup window, posting messages to it,
 * and listening for responses.
 *
 * It also handles cleanup of event listeners and the popup window itself when necessary.
 */
class Communicator {
    constructor({ url = CB_KEYS_URL, metadata, preference }) {
        this.popup = null;
        this.listeners = new Map();
        /**
         * Posts a message to the popup window
         */
        this.postMessage = async (message) => {
            const popup = await this.waitForPopupLoaded();
            popup.postMessage(message, this.url.origin);
        };
        /**
         * Posts a request to the popup window and waits for a response
         */
        this.postRequestAndWaitForResponse = async (request) => {
            const responsePromise = this.onMessage(({ requestId }) => requestId === request.id);
            this.postMessage(request);
            return await responsePromise;
        };
        /**
         * Listens for messages from the popup window that match a given predicate.
         */
        this.onMessage = async (predicate) => {
            return new Promise((resolve, reject) => {
                const listener = (event) => {
                    if (event.origin !== this.url.origin)
                        return; // origin validation
                    const message = event.data;
                    if (predicate(message)) {
                        resolve(message);
                        window.removeEventListener('message', listener);
                        this.listeners.delete(listener);
                    }
                };
                window.addEventListener('message', listener);
                this.listeners.set(listener, { reject });
            });
        };
        /**
         * Closes the popup, rejects all requests and clears the listeners
         */
        this.disconnect = () => {
            // Note: keys popup handles closing itself. this is a fallback.
            closePopup(this.popup);
            this.popup = null;
            this.listeners.forEach(({ reject }, listener) => {
                reject(standardErrors.provider.userRejectedRequest('Request rejected'));
                window.removeEventListener('message', listener);
            });
            this.listeners.clear();
        };
        /**
         * Waits for the popup window to fully load and then sends a version message.
         */
        this.waitForPopupLoaded = async () => {
            if (this.popup && !this.popup.closed) {
                // In case the user un-focused the popup between requests, focus it again
                this.popup.focus();
                return this.popup;
            }
            this.popup = openPopup(this.url);
            this.onMessage(({ event }) => event === 'PopupUnload')
                .then(this.disconnect)
                .catch(() => { });
            return this.onMessage(({ event }) => event === 'PopupLoaded')
                .then((message) => {
                this.postMessage({
                    requestId: message.id,
                    data: {
                        version: VERSION$1,
                        metadata: this.metadata,
                        preference: this.preference,
                        location: window.location.toString(),
                    },
                });
            })
                .then(() => {
                if (!this.popup)
                    throw standardErrors.rpc.internal();
                return this.popup;
            });
        };
        this.url = new URL(url);
        this.metadata = metadata;
        this.preference = preference;
    }
}

// TODO: error should not depend on walletlink. revisit this.
/**
 * Serializes an error to a format that is compatible with the Ethereum JSON RPC error format.
 * See https://docs.cloud.coinbase.com/wallet-sdk/docs/errors
 * for more information.
 */
function serializeError(error) {
    const serialized = serialize(getErrorObject(error), {
        shouldIncludeStack: true,
    });
    const docUrl = new URL('https://docs.cloud.coinbase.com/wallet-sdk/docs/errors');
    docUrl.searchParams.set('version', VERSION$1);
    docUrl.searchParams.set('code', serialized.code.toString());
    docUrl.searchParams.set('message', serialized.message);
    return Object.assign(Object.assign({}, serialized), { docUrl: docUrl.href });
}
/**
 * Converts an error to a serializable object.
 */
function getErrorObject(error) {
    var _a;
    if (typeof error === 'string') {
        return {
            message: error,
            code: standardErrorCodes.rpc.internal,
        };
    }
    else if (isErrorResponse(error)) {
        const message = error.errorMessage;
        const code = (_a = error.errorCode) !== null && _a !== void 0 ? _a : (message.match(/(denied|rejected)/i)
            ? standardErrorCodes.provider.userRejectedRequest
            : undefined);
        return Object.assign(Object.assign({}, error), { message,
            code, data: { method: error.method } });
    }
    return error;
}

class ProviderEventEmitter extends EventEmitter$1 {
}

var __rest$1 = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
class CoinbaseWalletProvider extends ProviderEventEmitter {
    constructor(_a) {
        var { metadata } = _a, _b = _a.preference, { keysUrl } = _b, preference = __rest$1(_b, ["keysUrl"]);
        super();
        this.signer = null;
        this.isCoinbaseWallet = true;
        this.metadata = metadata;
        this.preference = preference;
        this.communicator = new Communicator({
            url: keysUrl,
            metadata,
            preference,
        });
        const signerType = loadSignerType();
        if (signerType) {
            this.signer = this.initSigner(signerType);
        }
    }
    async request(args) {
        try {
            checkErrorForInvalidRequestArgs(args);
            if (!this.signer) {
                switch (args.method) {
                    case 'eth_requestAccounts': {
                        const signerType = await this.requestSignerSelection(args);
                        const signer = this.initSigner(signerType);
                        await signer.handshake(args);
                        this.signer = signer;
                        storeSignerType(signerType);
                        break;
                    }
                    case 'wallet_sendCalls': {
                        const ephemeralSigner = this.initSigner('scw');
                        await ephemeralSigner.handshake({ method: 'handshake' }); // exchange session keys
                        const result = await ephemeralSigner.request(args); // send diffie-hellman encrypted request
                        await ephemeralSigner.cleanup(); // clean up (rotate) the ephemeral session keys
                        return result;
                    }
                    case 'wallet_getCallsStatus':
                        return fetchRPCRequest(args, CB_WALLET_RPC_URL);
                    case 'net_version':
                        return 1; // default value
                    case 'eth_chainId':
                        return hexStringFromNumber(1); // default value
                    default: {
                        throw standardErrors.provider.unauthorized("Must call 'eth_requestAccounts' before other methods");
                    }
                }
            }
            return await this.signer.request(args);
        }
        catch (error) {
            const { code } = error;
            if (code === standardErrorCodes.provider.unauthorized)
                this.disconnect();
            return Promise.reject(serializeError(error));
        }
    }
    /** @deprecated Use `.request({ method: 'eth_requestAccounts' })` instead. */
    async enable() {
        console.warn(`.enable() has been deprecated. Please use .request({ method: "eth_requestAccounts" }) instead.`);
        return await this.request({
            method: 'eth_requestAccounts',
        });
    }
    async disconnect() {
        var _a;
        await ((_a = this.signer) === null || _a === void 0 ? void 0 : _a.cleanup());
        this.signer = null;
        ScopedLocalStorage.clearAll();
        this.emit('disconnect', standardErrors.provider.disconnected('User initiated disconnection'));
    }
    requestSignerSelection(handshakeRequest) {
        return fetchSignerType({
            communicator: this.communicator,
            preference: this.preference,
            metadata: this.metadata,
            handshakeRequest,
            callback: this.emit.bind(this),
        });
    }
    initSigner(signerType) {
        return createSigner({
            signerType,
            metadata: this.metadata,
            communicator: this.communicator,
            callback: this.emit.bind(this),
        });
    }
}

/**
 * Validates user supplied preferences. Throws if keys are not valid.
 * @param preference
 */
function validatePreferences(preference) {
    if (!preference) {
        return;
    }
    if (!['all', 'smartWalletOnly', 'eoaOnly'].includes(preference.options)) {
        throw new Error(`Invalid options: ${preference.options}`);
    }
    if (preference.attribution) {
        if (preference.attribution.auto !== undefined &&
            preference.attribution.dataSuffix !== undefined) {
            throw new Error(`Attribution cannot contain both auto and dataSuffix properties`);
        }
    }
}

// Copyright (c) 2018-2024 Coinbase, Inc. <https://www.coinbase.com/>
/**
 * CoinbaseWalletSDK
 *
 * @deprecated CoinbaseWalletSDK is deprecated and will likely be removed in a future major version release.
 * It's recommended to use `createCoinbaseWalletSDK` instead.
 */
class CoinbaseWalletSDK {
    constructor(metadata) {
        this.metadata = {
            appName: metadata.appName || 'Dapp',
            appLogoUrl: metadata.appLogoUrl || getFavicon(),
            appChainIds: metadata.appChainIds || [],
        };
        this.storeLatestVersion();
        void checkCrossOriginOpenerPolicy();
    }
    makeWeb3Provider(preference = { options: 'all' }) {
        var _a;
        validatePreferences(preference);
        const params = { metadata: this.metadata, preference };
        return (_a = getCoinbaseInjectedProvider(params)) !== null && _a !== void 0 ? _a : new CoinbaseWalletProvider(params);
    }
    /**
     * Official Coinbase Wallet logo for developers to use on their frontend
     * @param type Type of wallet logo: "standard" | "circle" | "text" | "textWithLogo" | "textLight" | "textWithLogoLight"
     * @param width Width of the logo (Optional)
     * @returns SVG Data URI
     */
    getCoinbaseWalletLogo(type, width = 240) {
        return walletLogo(type, width);
    }
    storeLatestVersion() {
        const versionStorage = new ScopedLocalStorage('CBWSDK');
        versionStorage.setItem('VERSION', VERSION$1);
    }
}

// storing a reference to the coinbase provider because the provider methods work better when
// they are called on the same instance
let coinbaseProvider;
const baseSepolia = 84532;
const baseMainnet = 8453;
const getCoinbaseProvider = ({ appLogoUrl, appName, evmNetworks, walletPreference, } = {}) => {
    const appChainIds = evmNetworks === null || evmNetworks === void 0 ? void 0 : evmNetworks.map((network) => Number(network.chainId));
    // just brings base sepolia to the front of the list, because that is treated as the default chain
    const hasBaseSepolia = evmNetworks === null || evmNetworks === void 0 ? void 0 : evmNetworks.some((network) => network.chainId === baseSepolia);
    if (hasBaseSepolia) {
        appChainIds === null || appChainIds === void 0 ? void 0 : appChainIds.sort((a, b) => a === baseSepolia ? -1 : b === baseSepolia ? 1 : 0);
    }
    // just brings base mainnet to the front, because that that is treated as the default chain
    const hasBaseMainnet = evmNetworks === null || evmNetworks === void 0 ? void 0 : evmNetworks.some((network) => network.chainId === baseMainnet);
    if (hasBaseMainnet) {
        appChainIds === null || appChainIds === void 0 ? void 0 : appChainIds.sort((a, b) => a === baseMainnet ? -1 : b === baseMainnet ? 1 : 0);
    }
    if (!coinbaseProvider) {
        const coinbaseSdk = new CoinbaseWalletSDK({
            appChainIds,
            appLogoUrl,
            appName,
        });
        coinbaseProvider = coinbaseSdk.makeWeb3Provider({
            options: walletPreference !== null && walletPreference !== void 0 ? walletPreference : 'all',
        });
    }
    return coinbaseProvider;
};

class Coinbase extends EthereumWalletConnector {
    constructor(_a) {
        var { appName, appLogoUrl, evmNetworks, coinbaseWalletPreference } = _a, props = __rest$5(_a, ["appName", "appLogoUrl", "evmNetworks", "coinbaseWalletPreference"]);
        super(Object.assign({ evmNetworks }, props));
        this.name = 'Coinbase';
        this.overrideKey = 'coinbase';
        this.canConnectViaQrCode = false;
        this.canConnectViaCustodialService = !this.isInstalledOnBrowser();
        this.coinbaseProviderOpts = {
            appLogoUrl: appLogoUrl,
            appName: appName,
            evmNetworks: evmNetworks,
            walletPreference: coinbaseWalletPreference,
        };
    }
    get coinbaseProvider() {
        return getCoinbaseProvider(this.coinbaseProviderOpts);
    }
    getConnectedAccounts() {
        return __awaiter$8(this, void 0, void 0, function* () {
            try {
                const accounts = (yield this.coinbaseProvider.request({
                    method: 'eth_accounts',
                }));
                if (accounts[0]) {
                    this.setActiveAccount(this.parseAddress(accounts[0]));
                }
                return accounts.map(this.parseAddress);
            }
            catch (error) {
                return [];
            }
        });
    }
    isInstalledOnBrowser() {
        var _a, _b;
        return (Boolean((_a = window === null || window === void 0 ? void 0 : window.coinbaseWalletExtension) === null || _a === void 0 ? void 0 : _a.isCoinbaseWallet) ||
            Boolean((_b = window === null || window === void 0 ? void 0 : window.ethereum) === null || _b === void 0 ? void 0 : _b.isCoinbaseWallet));
    }
    getAddress() {
        return __awaiter$8(this, void 0, void 0, function* () {
            const [address] = (yield this.coinbaseProvider.request({
                method: 'eth_requestAccounts',
            }));
            const parsedAddress = this.parseAddress(address);
            this.setActiveAccount(parsedAddress);
            return parsedAddress;
        });
    }
    signMessage(messageToSign) {
        return __awaiter$8(this, void 0, void 0, function* () {
            const [address] = (yield this.coinbaseProvider.request({
                method: 'eth_requestAccounts',
            }));
            const parsedAddress = this.parseAddress(address);
            try {
                return (yield this.coinbaseProvider.request({
                    method: 'personal_sign',
                    params: [toHex(toBytes$1(messageToSign)), parsedAddress],
                }));
            }
            catch (err) {
                return undefined;
            }
        });
    }
    setupEventListeners() {
        const { handleAccountChange, handleChainChange, handleDisconnect } = eventListenerHandlers(this);
        this.coinbaseProvider.on('accountsChanged', handleAccountChange);
        this.coinbaseProvider.on('chainChanged', handleChainChange);
        this.coinbaseProvider.on('disconnect', handleDisconnect);
        this.teardownEventListeners = () => {
            this.coinbaseProvider.removeListener('accountsChanged', handleAccountChange);
            this.coinbaseProvider.removeListener('chainChanged', handleChainChange);
            this.coinbaseProvider.removeListener('disconnect', handleDisconnect);
        };
    }
    getWalletClient(chainId) {
        return createWalletClient({
            account: this.getActiveAccount(),
            chain: chainId ? chainsMap[chainId] : this.getActiveChain(),
            transport: custom$1(this.coinbaseProvider),
        });
    }
}

var metamaskSdk$1 = {exports: {}};

var metamaskSdk = metamaskSdk$1.exports;

var hasRequiredMetamaskSdk;

function requireMetamaskSdk () {
	if (hasRequiredMetamaskSdk) return metamaskSdk$1.exports;
	hasRequiredMetamaskSdk = 1;
	(function (module, exports) {
		!function(e,t){t(exports);}(metamaskSdk,(function(e){var t="undefined"!=typeof commonjsGlobal?commonjsGlobal:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},n="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof commonjsGlobal?commonjsGlobal:"undefined"!=typeof self?self:{};function r(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}function i(e){if(e.__esModule)return e;var t=e.default;if("function"==typeof t){var n=function e(){return this instanceof e?Reflect.construct(t,arguments,this.constructor):t.apply(this,arguments)};n.prototype=t.prototype;}else n={};return Object.defineProperty(n,"__esModule",{value:true}),Object.keys(e).forEach((function(t){var r=Object.getOwnPropertyDescriptor(e,t);Object.defineProperty(n,t,r.get?r:{enumerable:true,get:function(){return e[t]}});})),n}var o={exports:{}};!function(e,t){var r="undefined"!=typeof globalThis&&globalThis||"undefined"!=typeof self&&self||void 0!==n&&n,i=function(){function e(){this.fetch=false,this.DOMException=r.DOMException;}return e.prototype=r,new e}();!function(e){!function(t){var n=void 0!==e&&e||"undefined"!=typeof self&&self||void 0!==n&&n,r="URLSearchParams"in n,i="Symbol"in n&&"iterator"in Symbol,o="FileReader"in n&&"Blob"in n&&function(){try{return new Blob,!0}catch(e){return  false}}(),a="FormData"in n,s="ArrayBuffer"in n;if(s)var u=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],l=ArrayBuffer.isView||function(e){return e&&u.indexOf(Object.prototype.toString.call(e))>-1};function c(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e)||""===e)throw new TypeError('Invalid character in header field name: "'+e+'"');return e.toLowerCase()}function d(e){return "string"!=typeof e&&(e=String(e)),e}function f(e){var t={next:function(){var t=e.shift();return {done:void 0===t,value:t}}};return i&&(t[Symbol.iterator]=function(){return t}),t}function h(e){this.map={},e instanceof h?e.forEach((function(e,t){this.append(t,e);}),this):Array.isArray(e)?e.forEach((function(e){this.append(e[0],e[1]);}),this):e&&Object.getOwnPropertyNames(e).forEach((function(t){this.append(t,e[t]);}),this);}function p(e){if(e.bodyUsed)return Promise.reject(new TypeError("Already read"));e.bodyUsed=true;}function m(e){return new Promise((function(t,n){e.onload=function(){t(e.result);},e.onerror=function(){n(e.error);};}))}function g(e){var t=new FileReader,n=m(t);return t.readAsArrayBuffer(e),n}function v(e){if(e.slice)return e.slice(0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function b(){return this.bodyUsed=false,this._initBody=function(e){var t;this.bodyUsed=this.bodyUsed,this._bodyInit=e,e?"string"==typeof e?this._bodyText=e:o&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:a&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:r&&URLSearchParams.prototype.isPrototypeOf(e)?this._bodyText=e.toString():s&&o&&((t=e)&&DataView.prototype.isPrototypeOf(t))?(this._bodyArrayBuffer=v(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):s&&(ArrayBuffer.prototype.isPrototypeOf(e)||l(e))?this._bodyArrayBuffer=v(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="",this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):r&&URLSearchParams.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"));},o&&(this.blob=function(){var e=p(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){if(this._bodyArrayBuffer){var e=p(this);return e||(ArrayBuffer.isView(this._bodyArrayBuffer)?Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset,this._bodyArrayBuffer.byteOffset+this._bodyArrayBuffer.byteLength)):Promise.resolve(this._bodyArrayBuffer))}return this.blob().then(g)}),this.text=function(){var e,t,n,r=p(this);if(r)return r;if(this._bodyBlob)return e=this._bodyBlob,t=new FileReader,n=m(t),t.readAsText(e),n;if(this._bodyArrayBuffer)return Promise.resolve(function(e){for(var t=new Uint8Array(e),n=new Array(t.length),r=0;r<t.length;r++)n[r]=String.fromCharCode(t[r]);return n.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},a&&(this.formData=function(){return this.text().then(_)}),this.json=function(){return this.text().then(JSON.parse)},this}h.prototype.append=function(e,t){e=c(e),t=d(t);var n=this.map[e];this.map[e]=n?n+", "+t:t;},h.prototype.delete=function(e){delete this.map[c(e)];},h.prototype.get=function(e){return e=c(e),this.has(e)?this.map[e]:null},h.prototype.has=function(e){return this.map.hasOwnProperty(c(e))},h.prototype.set=function(e,t){this.map[c(e)]=d(t);},h.prototype.forEach=function(e,t){for(var n in this.map)this.map.hasOwnProperty(n)&&e.call(t,this.map[n],n,this);},h.prototype.keys=function(){var e=[];return this.forEach((function(t,n){e.push(n);})),f(e)},h.prototype.values=function(){var e=[];return this.forEach((function(t){e.push(t);})),f(e)},h.prototype.entries=function(){var e=[];return this.forEach((function(t,n){e.push([n,t]);})),f(e)},i&&(h.prototype[Symbol.iterator]=h.prototype.entries);var y=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function w(e,t){if(!(this instanceof w))throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');var n=(t=t||{}).body;if(e instanceof w){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new h(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,n||null==e._bodyInit||(n=e._bodyInit,e.bodyUsed=true);}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new h(t.headers)),this.method=function(e){var t=e.toUpperCase();return y.indexOf(t)>-1?t:e}(t.method||this.method||"GET"),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&n)throw new TypeError("Body not allowed for GET or HEAD requests");if(this._initBody(n),!("GET"!==this.method&&"HEAD"!==this.method||"no-store"!==t.cache&&"no-cache"!==t.cache)){var r=/([?&])_=[^&]*/;if(r.test(this.url))this.url=this.url.replace(r,"$1_="+(new Date).getTime());else {this.url+=(/\?/.test(this.url)?"&":"?")+"_="+(new Date).getTime();}}}function _(e){var t=new FormData;return e.trim().split("&").forEach((function(e){if(e){var n=e.split("="),r=n.shift().replace(/\+/g," "),i=n.join("=").replace(/\+/g," ");t.append(decodeURIComponent(r),decodeURIComponent(i));}})),t}function S(e,t){if(!(this instanceof S))throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText=void 0===t.statusText?"":""+t.statusText,this.headers=new h(t.headers),this.url=t.url||"",this._initBody(e);}w.prototype.clone=function(){return new w(this,{body:this._bodyInit})},b.call(w.prototype),b.call(S.prototype),S.prototype.clone=function(){return new S(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new h(this.headers),url:this.url})},S.error=function(){var e=new S(null,{status:0,statusText:""});return e.type="error",e};var E=[301,302,303,307,308];S.redirect=function(e,t){if(-1===E.indexOf(t))throw new RangeError("Invalid status code");return new S(null,{status:t,headers:{location:e}})},t.DOMException=n.DOMException;try{new t.DOMException;}catch(e){t.DOMException=function(e,t){this.message=e,this.name=t;var n=Error(e);this.stack=n.stack;},t.DOMException.prototype=Object.create(Error.prototype),t.DOMException.prototype.constructor=t.DOMException;}function k(e,r){return new Promise((function(i,a){var u=new w(e,r);if(u.signal&&u.signal.aborted)return a(new t.DOMException("Aborted","AbortError"));var l=new XMLHttpRequest;function c(){l.abort();}l.onload=function(){var e,t,n={status:l.status,statusText:l.statusText,headers:(e=l.getAllResponseHeaders()||"",t=new h,e.replace(/\r?\n[\t ]+/g," ").split("\r").map((function(e){return 0===e.indexOf("\n")?e.substr(1,e.length):e})).forEach((function(e){var n=e.split(":"),r=n.shift().trim();if(r){var i=n.join(":").trim();t.append(r,i);}})),t)};n.url="responseURL"in l?l.responseURL:n.headers.get("X-Request-URL");var r="response"in l?l.response:l.responseText;setTimeout((function(){i(new S(r,n));}),0);},l.onerror=function(){setTimeout((function(){a(new TypeError("Network request failed"));}),0);},l.ontimeout=function(){setTimeout((function(){a(new TypeError("Network request failed"));}),0);},l.onabort=function(){setTimeout((function(){a(new t.DOMException("Aborted","AbortError"));}),0);},l.open(u.method,function(e){try{return ""===e&&n.location.href?n.location.href:e}catch(t){return e}}(u.url),true),"include"===u.credentials?l.withCredentials=true:"omit"===u.credentials&&(l.withCredentials=false),"responseType"in l&&(o?l.responseType="blob":s&&u.headers.get("Content-Type")&&-1!==u.headers.get("Content-Type").indexOf("application/octet-stream")&&(l.responseType="arraybuffer")),!r||"object"!=typeof r.headers||r.headers instanceof h?u.headers.forEach((function(e,t){l.setRequestHeader(t,e);})):Object.getOwnPropertyNames(r.headers).forEach((function(e){l.setRequestHeader(e,d(r.headers[e]));})),u.signal&&(u.signal.addEventListener("abort",c),l.onreadystatechange=function(){4===l.readyState&&u.signal.removeEventListener("abort",c);}),l.send(void 0===u._bodyInit?null:u._bodyInit);}))}k.polyfill=true,n.fetch||(n.fetch=k,n.Headers=h,n.Request=w,n.Response=S),t.Headers=h,t.Request=w,t.Response=S,t.fetch=k;}({});}(i),i.fetch.ponyfill=true,delete i.fetch.polyfill;var o=r.fetch?r:i;(t=o.fetch).default=o.fetch,t.fetch=o.fetch,t.Headers=o.Headers,t.Request=o.Request,t.Response=o.Response,e.exports=t;}(o,o.exports);var a=r(o.exports),s=[],u=[],l="undefined"!=typeof Uint8Array?Uint8Array:Array,c=false;function d(){c=true;for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t=0;t<64;++t)s[t]=e[t],u[e.charCodeAt(t)]=t;u["-".charCodeAt(0)]=62,u["_".charCodeAt(0)]=63;}function f(e,t,n){for(var r,i,o=[],a=t;a<n;a+=3)r=(e[a]<<16)+(e[a+1]<<8)+e[a+2],o.push(s[(i=r)>>18&63]+s[i>>12&63]+s[i>>6&63]+s[63&i]);return o.join("")}function h(e){var t;c||d();for(var n=e.length,r=n%3,i="",o=[],a=16383,u=0,l=n-r;u<l;u+=a)o.push(f(e,u,u+a>l?l:u+a));return 1===r?(t=e[n-1],i+=s[t>>2],i+=s[t<<4&63],i+="=="):2===r&&(t=(e[n-2]<<8)+e[n-1],i+=s[t>>10],i+=s[t>>4&63],i+=s[t<<2&63],i+="="),o.push(i),o.join("")}function p(e,t,n,r,i){var o,a,s=8*i-r-1,u=(1<<s)-1,l=u>>1,c=-7,d=n?i-1:0,f=n?-1:1,h=e[t+d];for(d+=f,o=h&(1<<-c)-1,h>>=-c,c+=s;c>0;o=256*o+e[t+d],d+=f,c-=8);for(a=o&(1<<-c)-1,o>>=-c,c+=r;c>0;a=256*a+e[t+d],d+=f,c-=8);if(0===o)o=1-l;else {if(o===u)return a?NaN:1/0*(h?-1:1);a+=Math.pow(2,r),o-=l;}return (h?-1:1)*a*Math.pow(2,o-r)}function m(e,t,n,r,i,o){var a,s,u,l=8*o-i-1,c=(1<<l)-1,d=c>>1,f=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,h=r?0:o-1,p=r?1:-1,m=t<0||0===t&&1/t<0?1:0;for(t=Math.abs(t),isNaN(t)||t===1/0?(s=isNaN(t)?1:0,a=c):(a=Math.floor(Math.log(t)/Math.LN2),t*(u=Math.pow(2,-a))<1&&(a--,u*=2),(t+=a+d>=1?f/u:f*Math.pow(2,1-d))*u>=2&&(a++,u/=2),a+d>=c?(s=0,a=c):a+d>=1?(s=(t*u-1)*Math.pow(2,i),a+=d):(s=t*Math.pow(2,d-1)*Math.pow(2,i),a=0));i>=8;e[n+h]=255&s,h+=p,s/=256,i-=8);for(a=a<<i|s,l+=i;l>0;e[n+h]=255&a,h+=p,a/=256,l-=8);e[n+h-p]|=128*m;}var g={}.toString,v=Array.isArray||function(e){return "[object Array]"==g.call(e)};_.TYPED_ARRAY_SUPPORT=void 0===t.TYPED_ARRAY_SUPPORT||t.TYPED_ARRAY_SUPPORT;var b=y();function y(){return _.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function w(e,t){if(y()<t)throw new RangeError("Invalid typed array length");return _.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(t)).__proto__=_.prototype:(null===e&&(e=new _(t)),e.length=t),e}function _(e,t,n){if(!(_.TYPED_ARRAY_SUPPORT||this instanceof _))return new _(e,t,n);if("number"==typeof e){if("string"==typeof t)throw new Error("If encoding is specified then the first argument must be a string");return k(this,e)}return S(this,e,t,n)}function S(e,t,n,r){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return "undefined"!=typeof ArrayBuffer&&t instanceof ArrayBuffer?function(e,t,n,r){if(t.byteLength,n<0||t.byteLength<n)throw new RangeError("'offset' is out of bounds");if(t.byteLength<n+(r||0))throw new RangeError("'length' is out of bounds");t=void 0===n&&void 0===r?new Uint8Array(t):void 0===r?new Uint8Array(t,n):new Uint8Array(t,n,r);_.TYPED_ARRAY_SUPPORT?(e=t).__proto__=_.prototype:e=M(e,t);return e}(e,t,n,r):"string"==typeof t?function(e,t,n){"string"==typeof n&&""!==n||(n="utf8");if(!_.isEncoding(n))throw new TypeError('"encoding" must be a valid string encoding');var r=0|A(t,n);e=w(e,r);var i=e.write(t,n);i!==r&&(e=e.slice(0,i));return e}(e,t,n):function(e,t){if(x(t)){var n=0|C(t.length);return 0===(e=w(e,n)).length||t.copy(e,0,0,n),e}if(t){if("undefined"!=typeof ArrayBuffer&&t.buffer instanceof ArrayBuffer||"length"in t)return "number"!=typeof t.length||(r=t.length)!=r?w(e,0):M(e,t);if("Buffer"===t.type&&v(t.data))return M(e,t.data)}var r;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(e,t)}function E(e){if("number"!=typeof e)throw new TypeError('"size" argument must be a number');if(e<0)throw new RangeError('"size" argument must not be negative')}function k(e,t){if(E(t),e=w(e,t<0?0:0|C(t)),!_.TYPED_ARRAY_SUPPORT)for(var n=0;n<t;++n)e[n]=0;return e}function M(e,t){var n=t.length<0?0:0|C(t.length);e=w(e,n);for(var r=0;r<n;r+=1)e[r]=255&t[r];return e}function C(e){if(e>=y())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+y().toString(16)+" bytes");return 0|e}function x(e){return !(null==e||!e._isBuffer)}function A(e,t){if(x(e))return e.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(e)||e instanceof ArrayBuffer))return e.byteLength;"string"!=typeof e&&(e=""+e);var n=e.length;if(0===n)return 0;for(var r=false;;)switch(t){case "ascii":case "latin1":case "binary":return n;case "utf8":case "utf-8":case void 0:return te(e).length;case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":return 2*n;case "hex":return n>>>1;case "base64":return ne(e).length;default:if(r)return te(e).length;t=(""+t).toLowerCase(),r=true;}}function R(e,t,n){var r=false;if((void 0===t||t<0)&&(t=0),t>this.length)return "";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return "";if((n>>>=0)<=(t>>>=0))return "";for(e||(e="utf8");;)switch(e){case "hex":return H(this,t,n);case "utf8":case "utf-8":return U(this,t,n);case "ascii":return K(this,t,n);case "latin1":case "binary":return q(this,t,n);case "base64":return z(this,t,n);case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":return W(this,t,n);default:if(r)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase(),r=true;}}function T(e,t,n){var r=e[t];e[t]=e[n],e[n]=r;}function P(e,t,n,r,i){if(0===e.length)return  -1;if("string"==typeof n?(r=n,n=0):n>2147483647?n=2147483647:n<-2147483648&&(n=-2147483648),n=+n,isNaN(n)&&(n=i?0:e.length-1),n<0&&(n=e.length+n),n>=e.length){if(i)return  -1;n=e.length-1;}else if(n<0){if(!i)return  -1;n=0;}if("string"==typeof t&&(t=_.from(t,r)),x(t))return 0===t.length?-1:L(e,t,n,r,i);if("number"==typeof t)return t&=255,_.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(e,t,n):Uint8Array.prototype.lastIndexOf.call(e,t,n):L(e,[t],n,r,i);throw new TypeError("val must be string, number or Buffer")}function L(e,t,n,r,i){var o,a=1,s=e.length,u=t.length;if(void 0!==r&&("ucs2"===(r=String(r).toLowerCase())||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(e.length<2||t.length<2)return  -1;a=2,s/=2,u/=2,n/=2;}function l(e,t){return 1===a?e[t]:e.readUInt16BE(t*a)}if(i){var c=-1;for(o=n;o<s;o++)if(l(e,o)===l(t,-1===c?0:o-c)){if(-1===c&&(c=o),o-c+1===u)return c*a}else  -1!==c&&(o-=o-c),c=-1;}else for(n+u>s&&(n=s-u),o=n;o>=0;o--){for(var d=true,f=0;f<u;f++)if(l(e,o+f)!==l(t,f)){d=false;break}if(d)return o}return  -1}function I(e,t,n,r){n=Number(n)||0;var i=e.length-n;r?(r=Number(r))>i&&(r=i):r=i;var o=t.length;if(o%2!=0)throw new TypeError("Invalid hex string");r>o/2&&(r=o/2);for(var a=0;a<r;++a){var s=parseInt(t.substr(2*a,2),16);if(isNaN(s))return a;e[n+a]=s;}return a}function O(e,t,n,r){return re(te(t,e.length-n),e,n,r)}function N(e,t,n,r){return re(function(e){for(var t=[],n=0;n<e.length;++n)t.push(255&e.charCodeAt(n));return t}(t),e,n,r)}function D(e,t,n,r){return N(e,t,n,r)}function j(e,t,n,r){return re(ne(t),e,n,r)}function B(e,t,n,r){return re(function(e,t){for(var n,r,i,o=[],a=0;a<e.length&&!((t-=2)<0);++a)r=(n=e.charCodeAt(a))>>8,i=n%256,o.push(i),o.push(r);return o}(t,e.length-n),e,n,r)}function z(e,t,n){return 0===t&&n===e.length?h(e):h(e.slice(t,n))}function U(e,t,n){n=Math.min(e.length,n);for(var r=[],i=t;i<n;){var o,a,s,u,l=e[i],c=null,d=l>239?4:l>223?3:l>191?2:1;if(i+d<=n)switch(d){case 1:l<128&&(c=l);break;case 2:128==(192&(o=e[i+1]))&&(u=(31&l)<<6|63&o)>127&&(c=u);break;case 3:o=e[i+1],a=e[i+2],128==(192&o)&&128==(192&a)&&(u=(15&l)<<12|(63&o)<<6|63&a)>2047&&(u<55296||u>57343)&&(c=u);break;case 4:o=e[i+1],a=e[i+2],s=e[i+3],128==(192&o)&&128==(192&a)&&128==(192&s)&&(u=(15&l)<<18|(63&o)<<12|(63&a)<<6|63&s)>65535&&u<1114112&&(c=u);}null===c?(c=65533,d=1):c>65535&&(c-=65536,r.push(c>>>10&1023|55296),c=56320|1023&c),r.push(c),i+=d;}return function(e){var t=e.length;if(t<=F)return String.fromCharCode.apply(String,e);var n="",r=0;for(;r<t;)n+=String.fromCharCode.apply(String,e.slice(r,r+=F));return n}(r)}_.poolSize=8192,_._augment=function(e){return e.__proto__=_.prototype,e},_.from=function(e,t,n){return S(null,e,t,n)},_.TYPED_ARRAY_SUPPORT&&(_.prototype.__proto__=Uint8Array.prototype,_.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&_[Symbol.species]),_.alloc=function(e,t,n){return function(e,t,n,r){return E(t),t<=0?w(e,t):void 0!==n?"string"==typeof r?w(e,t).fill(n,r):w(e,t).fill(n):w(e,t)}(null,e,t,n)},_.allocUnsafe=function(e){return k(null,e)},_.allocUnsafeSlow=function(e){return k(null,e)},_.isBuffer=ie,_.compare=function(e,t){if(!x(e)||!x(t))throw new TypeError("Arguments must be Buffers");if(e===t)return 0;for(var n=e.length,r=t.length,i=0,o=Math.min(n,r);i<o;++i)if(e[i]!==t[i]){n=e[i],r=t[i];break}return n<r?-1:r<n?1:0},_.isEncoding=function(e){switch(String(e).toLowerCase()){case "hex":case "utf8":case "utf-8":case "ascii":case "latin1":case "binary":case "base64":case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":return  true;default:return  false}},_.concat=function(e,t){if(!v(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return _.alloc(0);var n;if(void 0===t)for(t=0,n=0;n<e.length;++n)t+=e[n].length;var r=_.allocUnsafe(t),i=0;for(n=0;n<e.length;++n){var o=e[n];if(!x(o))throw new TypeError('"list" argument must be an Array of Buffers');o.copy(r,i),i+=o.length;}return r},_.byteLength=A,_.prototype._isBuffer=true,_.prototype.swap16=function(){var e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var t=0;t<e;t+=2)T(this,t,t+1);return this},_.prototype.swap32=function(){var e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var t=0;t<e;t+=4)T(this,t,t+3),T(this,t+1,t+2);return this},_.prototype.swap64=function(){var e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var t=0;t<e;t+=8)T(this,t,t+7),T(this,t+1,t+6),T(this,t+2,t+5),T(this,t+3,t+4);return this},_.prototype.toString=function(){var e=0|this.length;return 0===e?"":0===arguments.length?U(this,0,e):R.apply(this,arguments)},_.prototype.equals=function(e){if(!x(e))throw new TypeError("Argument must be a Buffer");return this===e||0===_.compare(this,e)},_.prototype.inspect=function(){var e="";return this.length>0&&(e=this.toString("hex",0,50).match(/.{2}/g).join(" "),this.length>50&&(e+=" ... ")),"<Buffer "+e+">"},_.prototype.compare=function(e,t,n,r,i){if(!x(e))throw new TypeError("Argument must be a Buffer");if(void 0===t&&(t=0),void 0===n&&(n=e?e.length:0),void 0===r&&(r=0),void 0===i&&(i=this.length),t<0||n>e.length||r<0||i>this.length)throw new RangeError("out of range index");if(r>=i&&t>=n)return 0;if(r>=i)return  -1;if(t>=n)return 1;if(this===e)return 0;for(var o=(i>>>=0)-(r>>>=0),a=(n>>>=0)-(t>>>=0),s=Math.min(o,a),u=this.slice(r,i),l=e.slice(t,n),c=0;c<s;++c)if(u[c]!==l[c]){o=u[c],a=l[c];break}return o<a?-1:a<o?1:0},_.prototype.includes=function(e,t,n){return  -1!==this.indexOf(e,t,n)},_.prototype.indexOf=function(e,t,n){return P(this,e,t,n,true)},_.prototype.lastIndexOf=function(e,t,n){return P(this,e,t,n,false)},_.prototype.write=function(e,t,n,r){if(void 0===t)r="utf8",n=this.length,t=0;else if(void 0===n&&"string"==typeof t)r=t,n=this.length,t=0;else {if(!isFinite(t))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t|=0,isFinite(n)?(n|=0,void 0===r&&(r="utf8")):(r=n,n=void 0);}var i=this.length-t;if((void 0===n||n>i)&&(n=i),e.length>0&&(n<0||t<0)||t>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var o=false;;)switch(r){case "hex":return I(this,e,t,n);case "utf8":case "utf-8":return O(this,e,t,n);case "ascii":return N(this,e,t,n);case "latin1":case "binary":return D(this,e,t,n);case "base64":return j(this,e,t,n);case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":return B(this,e,t,n);default:if(o)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),o=true;}},_.prototype.toJSON=function(){return {type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var F=4096;function K(e,t,n){var r="";n=Math.min(e.length,n);for(var i=t;i<n;++i)r+=String.fromCharCode(127&e[i]);return r}function q(e,t,n){var r="";n=Math.min(e.length,n);for(var i=t;i<n;++i)r+=String.fromCharCode(e[i]);return r}function H(e,t,n){var r=e.length;(!t||t<0)&&(t=0),(!n||n<0||n>r)&&(n=r);for(var i="",o=t;o<n;++o)i+=ee(e[o]);return i}function W(e,t,n){for(var r=e.slice(t,n),i="",o=0;o<r.length;o+=2)i+=String.fromCharCode(r[o]+256*r[o+1]);return i}function $(e,t,n){if(e%1!=0||e<0)throw new RangeError("offset is not uint");if(e+t>n)throw new RangeError("Trying to access beyond buffer length")}function V(e,t,n,r,i,o){if(!x(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(t>i||t<o)throw new RangeError('"value" argument is out of bounds');if(n+r>e.length)throw new RangeError("Index out of range")}function Y(e,t,n,r){t<0&&(t=65535+t+1);for(var i=0,o=Math.min(e.length-n,2);i<o;++i)e[n+i]=(t&255<<8*(r?i:1-i))>>>8*(r?i:1-i);}function G(e,t,n,r){t<0&&(t=4294967295+t+1);for(var i=0,o=Math.min(e.length-n,4);i<o;++i)e[n+i]=t>>>8*(r?i:3-i)&255;}function Z(e,t,n,r,i,o){if(n+r>e.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("Index out of range")}function Q(e,t,n,r,i){return i||Z(e,0,n,4),m(e,t,n,r,23,4),n+4}function J(e,t,n,r,i){return i||Z(e,0,n,8),m(e,t,n,r,52,8),n+8}_.prototype.slice=function(e,t){var n,r=this.length;if((e=~~e)<0?(e+=r)<0&&(e=0):e>r&&(e=r),(t=void 0===t?r:~~t)<0?(t+=r)<0&&(t=0):t>r&&(t=r),t<e&&(t=e),_.TYPED_ARRAY_SUPPORT)(n=this.subarray(e,t)).__proto__=_.prototype;else {var i=t-e;n=new _(i,void 0);for(var o=0;o<i;++o)n[o]=this[o+e];}return n},_.prototype.readUIntLE=function(e,t,n){e|=0,t|=0,n||$(e,t,this.length);for(var r=this[e],i=1,o=0;++o<t&&(i*=256);)r+=this[e+o]*i;return r},_.prototype.readUIntBE=function(e,t,n){e|=0,t|=0,n||$(e,t,this.length);for(var r=this[e+--t],i=1;t>0&&(i*=256);)r+=this[e+--t]*i;return r},_.prototype.readUInt8=function(e,t){return t||$(e,1,this.length),this[e]},_.prototype.readUInt16LE=function(e,t){return t||$(e,2,this.length),this[e]|this[e+1]<<8},_.prototype.readUInt16BE=function(e,t){return t||$(e,2,this.length),this[e]<<8|this[e+1]},_.prototype.readUInt32LE=function(e,t){return t||$(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},_.prototype.readUInt32BE=function(e,t){return t||$(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},_.prototype.readIntLE=function(e,t,n){e|=0,t|=0,n||$(e,t,this.length);for(var r=this[e],i=1,o=0;++o<t&&(i*=256);)r+=this[e+o]*i;return r>=(i*=128)&&(r-=Math.pow(2,8*t)),r},_.prototype.readIntBE=function(e,t,n){e|=0,t|=0,n||$(e,t,this.length);for(var r=t,i=1,o=this[e+--r];r>0&&(i*=256);)o+=this[e+--r]*i;return o>=(i*=128)&&(o-=Math.pow(2,8*t)),o},_.prototype.readInt8=function(e,t){return t||$(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},_.prototype.readInt16LE=function(e,t){t||$(e,2,this.length);var n=this[e]|this[e+1]<<8;return 32768&n?4294901760|n:n},_.prototype.readInt16BE=function(e,t){t||$(e,2,this.length);var n=this[e+1]|this[e]<<8;return 32768&n?4294901760|n:n},_.prototype.readInt32LE=function(e,t){return t||$(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},_.prototype.readInt32BE=function(e,t){return t||$(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},_.prototype.readFloatLE=function(e,t){return t||$(e,4,this.length),p(this,e,true,23,4)},_.prototype.readFloatBE=function(e,t){return t||$(e,4,this.length),p(this,e,false,23,4)},_.prototype.readDoubleLE=function(e,t){return t||$(e,8,this.length),p(this,e,true,52,8)},_.prototype.readDoubleBE=function(e,t){return t||$(e,8,this.length),p(this,e,false,52,8)},_.prototype.writeUIntLE=function(e,t,n,r){(e=+e,t|=0,n|=0,r)||V(this,e,t,n,Math.pow(2,8*n)-1,0);var i=1,o=0;for(this[t]=255&e;++o<n&&(i*=256);)this[t+o]=e/i&255;return t+n},_.prototype.writeUIntBE=function(e,t,n,r){(e=+e,t|=0,n|=0,r)||V(this,e,t,n,Math.pow(2,8*n)-1,0);var i=n-1,o=1;for(this[t+i]=255&e;--i>=0&&(o*=256);)this[t+i]=e/o&255;return t+n},_.prototype.writeUInt8=function(e,t,n){return e=+e,t|=0,n||V(this,e,t,1,255,0),_.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[t]=255&e,t+1},_.prototype.writeUInt16LE=function(e,t,n){return e=+e,t|=0,n||V(this,e,t,2,65535,0),_.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):Y(this,e,t,true),t+2},_.prototype.writeUInt16BE=function(e,t,n){return e=+e,t|=0,n||V(this,e,t,2,65535,0),_.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):Y(this,e,t,false),t+2},_.prototype.writeUInt32LE=function(e,t,n){return e=+e,t|=0,n||V(this,e,t,4,4294967295,0),_.TYPED_ARRAY_SUPPORT?(this[t+3]=e>>>24,this[t+2]=e>>>16,this[t+1]=e>>>8,this[t]=255&e):G(this,e,t,true),t+4},_.prototype.writeUInt32BE=function(e,t,n){return e=+e,t|=0,n||V(this,e,t,4,4294967295,0),_.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):G(this,e,t,false),t+4},_.prototype.writeIntLE=function(e,t,n,r){if(e=+e,t|=0,!r){var i=Math.pow(2,8*n-1);V(this,e,t,n,i-1,-i);}var o=0,a=1,s=0;for(this[t]=255&e;++o<n&&(a*=256);)e<0&&0===s&&0!==this[t+o-1]&&(s=1),this[t+o]=(e/a>>0)-s&255;return t+n},_.prototype.writeIntBE=function(e,t,n,r){if(e=+e,t|=0,!r){var i=Math.pow(2,8*n-1);V(this,e,t,n,i-1,-i);}var o=n-1,a=1,s=0;for(this[t+o]=255&e;--o>=0&&(a*=256);)e<0&&0===s&&0!==this[t+o+1]&&(s=1),this[t+o]=(e/a>>0)-s&255;return t+n},_.prototype.writeInt8=function(e,t,n){return e=+e,t|=0,n||V(this,e,t,1,127,-128),_.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[t]=255&e,t+1},_.prototype.writeInt16LE=function(e,t,n){return e=+e,t|=0,n||V(this,e,t,2,32767,-32768),_.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):Y(this,e,t,true),t+2},_.prototype.writeInt16BE=function(e,t,n){return e=+e,t|=0,n||V(this,e,t,2,32767,-32768),_.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):Y(this,e,t,false),t+2},_.prototype.writeInt32LE=function(e,t,n){return e=+e,t|=0,n||V(this,e,t,4,2147483647,-2147483648),_.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8,this[t+2]=e>>>16,this[t+3]=e>>>24):G(this,e,t,true),t+4},_.prototype.writeInt32BE=function(e,t,n){return e=+e,t|=0,n||V(this,e,t,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),_.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):G(this,e,t,false),t+4},_.prototype.writeFloatLE=function(e,t,n){return Q(this,e,t,true,n)},_.prototype.writeFloatBE=function(e,t,n){return Q(this,e,t,false,n)},_.prototype.writeDoubleLE=function(e,t,n){return J(this,e,t,true,n)},_.prototype.writeDoubleBE=function(e,t,n){return J(this,e,t,false,n)},_.prototype.copy=function(e,t,n,r){if(n||(n=0),r||0===r||(r=this.length),t>=e.length&&(t=e.length),t||(t=0),r>0&&r<n&&(r=n),r===n)return 0;if(0===e.length||0===this.length)return 0;if(t<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("sourceStart out of bounds");if(r<0)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),e.length-t<r-n&&(r=e.length-t+n);var i,o=r-n;if(this===e&&n<t&&t<r)for(i=o-1;i>=0;--i)e[i+t]=this[i+n];else if(o<1e3||!_.TYPED_ARRAY_SUPPORT)for(i=0;i<o;++i)e[i+t]=this[i+n];else Uint8Array.prototype.set.call(e,this.subarray(n,n+o),t);return o},_.prototype.fill=function(e,t,n,r){if("string"==typeof e){if("string"==typeof t?(r=t,t=0,n=this.length):"string"==typeof n&&(r=n,n=this.length),1===e.length){var i=e.charCodeAt(0);i<256&&(e=i);}if(void 0!==r&&"string"!=typeof r)throw new TypeError("encoding must be a string");if("string"==typeof r&&!_.isEncoding(r))throw new TypeError("Unknown encoding: "+r)}else "number"==typeof e&&(e&=255);if(t<0||this.length<t||this.length<n)throw new RangeError("Out of range index");if(n<=t)return this;var o;if(t>>>=0,n=void 0===n?this.length:n>>>0,e||(e=0),"number"==typeof e)for(o=t;o<n;++o)this[o]=e;else {var a=x(e)?e:te(new _(e,r).toString()),s=a.length;for(o=0;o<n-t;++o)this[o+t]=a[o%s];}return this};var X=/[^+\/0-9A-Za-z-_]/g;function ee(e){return e<16?"0"+e.toString(16):e.toString(16)}function te(e,t){var n;t=t||1/0;for(var r=e.length,i=null,o=[],a=0;a<r;++a){if((n=e.charCodeAt(a))>55295&&n<57344){if(!i){if(n>56319){(t-=3)>-1&&o.push(239,191,189);continue}if(a+1===r){(t-=3)>-1&&o.push(239,191,189);continue}i=n;continue}if(n<56320){(t-=3)>-1&&o.push(239,191,189),i=n;continue}n=65536+(i-55296<<10|n-56320);}else i&&(t-=3)>-1&&o.push(239,191,189);if(i=null,n<128){if((t-=1)<0)break;o.push(n);}else if(n<2048){if((t-=2)<0)break;o.push(n>>6|192,63&n|128);}else if(n<65536){if((t-=3)<0)break;o.push(n>>12|224,n>>6&63|128,63&n|128);}else {if(!(n<1114112))throw new Error("Invalid code point");if((t-=4)<0)break;o.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128);}}return o}function ne(e){return function(e){var t,n,r,i,o,a;c||d();var s=e.length;if(s%4>0)throw new Error("Invalid string. Length must be a multiple of 4");o="="===e[s-2]?2:"="===e[s-1]?1:0,a=new l(3*s/4-o),r=o>0?s-4:s;var f=0;for(t=0,n=0;t<r;t+=4,n+=3)i=u[e.charCodeAt(t)]<<18|u[e.charCodeAt(t+1)]<<12|u[e.charCodeAt(t+2)]<<6|u[e.charCodeAt(t+3)],a[f++]=i>>16&255,a[f++]=i>>8&255,a[f++]=255&i;return 2===o?(i=u[e.charCodeAt(t)]<<2|u[e.charCodeAt(t+1)]>>4,a[f++]=255&i):1===o&&(i=u[e.charCodeAt(t)]<<10|u[e.charCodeAt(t+1)]<<4|u[e.charCodeAt(t+2)]>>2,a[f++]=i>>8&255,a[f++]=255&i),a}(function(e){if((e=function(e){return e.trim?e.trim():e.replace(/^\s+|\s+$/g,"")}(e).replace(X,"")).length<2)return "";for(;e.length%4!=0;)e+="=";return e}(e))}function re(e,t,n,r){for(var i=0;i<r&&!(i+n>=t.length||i>=e.length);++i)t[i+n]=e[i];return i}function ie(e){return null!=e&&(!!e._isBuffer||oe(e)||function(e){return "function"==typeof e.readFloatLE&&"function"==typeof e.slice&&oe(e.slice(0,0))}(e))}function oe(e){return !!e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}var ae=Object.freeze({__proto__:null,Buffer:_,INSPECT_MAX_BYTES:50,SlowBuffer:function(e){return +e!=e&&(e=0),_.alloc(+e)},isBuffer:ie,kMaxLength:b}),se={},ue={},le={},ce=i(ae),de={};function fe(){throw new Error("setTimeout has not been defined")}function he(){throw new Error("clearTimeout has not been defined")}var pe=fe,me=he;function ge(e){if(pe===setTimeout)return setTimeout(e,0);if((pe===fe||!pe)&&setTimeout)return pe=setTimeout,setTimeout(e,0);try{return pe(e,0)}catch(t){try{return pe.call(null,e,0)}catch(t){return pe.call(this,e,0)}}}"function"==typeof t.setTimeout&&(pe=setTimeout),"function"==typeof t.clearTimeout&&(me=clearTimeout);var ve,be=[],ye=false,we=-1;function _e(){ye&&ve&&(ye=false,ve.length?be=ve.concat(be):we=-1,be.length&&Se());}function Se(){if(!ye){var e=ge(_e);ye=true;for(var t=be.length;t;){for(ve=be,be=[];++we<t;)ve&&ve[we].run();we=-1,t=be.length;}ve=null,ye=false,function(e){if(me===clearTimeout)return clearTimeout(e);if((me===he||!me)&&clearTimeout)return me=clearTimeout,clearTimeout(e);try{return me(e)}catch(t){try{return me.call(null,e)}catch(t){return me.call(this,e)}}}(e);}}function Ee(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];be.push(new ke(e,t)),1!==be.length||ye||ge(Se);}function ke(e,t){this.fun=e,this.array=t;}ke.prototype.run=function(){this.fun.apply(null,this.array);};function Me(){}var Ce=Me,xe=Me,Ae=Me,Re=Me,Te=Me,Pe=Me,Le=Me;var Ie=t.performance||{},Oe=Ie.now||Ie.mozNow||Ie.msNow||Ie.oNow||Ie.webkitNow||function(){return (new Date).getTime()};var Ne=new Date;var De,je={nextTick:Ee,title:"browser",browser:true,env:{},argv:[],version:"",versions:{},on:Ce,addListener:xe,once:Ae,off:Re,removeListener:Te,removeAllListeners:Pe,emit:Le,binding:function(e){throw new Error("process.binding is not supported")},cwd:function(){return "/"},chdir:function(e){throw new Error("process.chdir is not supported")},umask:function(){return 0},hrtime:function(e){var t=.001*Oe.call(Ie),n=Math.floor(t),r=Math.floor(t%1*1e9);return e&&(n-=e[0],(r-=e[1])<0&&(n--,r+=1e9)),[n,r]},platform:"browser",release:{},config:{},uptime:function(){return (new Date-Ne)/1e3}},Be={exports:{}},ze={exports:{}};function Ue(){return De||(De=1,function(e,t){var n=ce,r=n.Buffer;function i(e,t){for(var n in e)t[n]=e[n];}function o(e,t,n){return r(e,t,n)}r.from&&r.alloc&&r.allocUnsafe&&r.allocUnsafeSlow?e.exports=n:(i(n,t),t.Buffer=o),o.prototype=Object.create(r.prototype),i(r,o),o.from=function(e,t,n){if("number"==typeof e)throw new TypeError("Argument must not be a number");return r(e,t,n)},o.alloc=function(e,t,n){if("number"!=typeof e)throw new TypeError("Argument must be a number");var i=r(e);return void 0!==t?"string"==typeof n?i.fill(t,n):i.fill(t):i.fill(0),i},o.allocUnsafe=function(e){if("number"!=typeof e)throw new TypeError("Argument must be a number");return r(e)},o.allocUnsafeSlow=function(e){if("number"!=typeof e)throw new TypeError("Argument must be a number");return n.SlowBuffer(e)};}(ze,ze.exports)),ze.exports}var Fe=65536,Ke=4294967295;var qe=Ue().Buffer,He=n.crypto||n.msCrypto;He&&He.getRandomValues?Be.exports=function(e,t){if(e>Ke)throw new RangeError("requested too many random bytes");var n=qe.allocUnsafe(e);if(e>0)if(e>Fe)for(var r=0;r<e;r+=Fe)He.getRandomValues(n.slice(r,r+Fe));else He.getRandomValues(n);if("function"==typeof t)return Ee((function(){t(null,n);}));return n}:Be.exports=function(){throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11")};var We=Be.exports,$e={exports:{}};"function"==typeof Object.create?$e.exports=function(e,t){t&&(e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}}));}:$e.exports=function(e,t){if(t){e.super_=t;var n=function(){};n.prototype=t.prototype,e.prototype=new n,e.prototype.constructor=e;}};var Ve=$e.exports,Ye={exports:{}};function Ge(){}function Ze(){Ze.init.call(this);}function Qe(e){return void 0===e._maxListeners?Ze.defaultMaxListeners:e._maxListeners}function Je(e,t,n,r){var i,o,a;if("function"!=typeof n)throw new TypeError('"listener" argument must be a function');if((o=e._events)?(o.newListener&&(e.emit("newListener",t,n.listener?n.listener:n),o=e._events),a=o[t]):(o=e._events=new Ge,e._eventsCount=0),a){if("function"==typeof a?a=o[t]=r?[n,a]:[a,n]:r?a.unshift(n):a.push(n),!a.warned&&(i=Qe(e))&&i>0&&a.length>i){a.warned=true;var s=new Error("Possible EventEmitter memory leak detected. "+a.length+" "+t+" listeners added. Use emitter.setMaxListeners() to increase limit");s.name="MaxListenersExceededWarning",s.emitter=e,s.type=t,s.count=a.length,function(e){"function"==typeof console.warn?console.warn(e):console.log(e);}(s);}}else a=o[t]=n,++e._eventsCount;return e}function Xe(e,t,n){var r=false;function i(){e.removeListener(t,i),r||(r=true,n.apply(e,arguments));}return i.listener=n,i}function et(e){var t=this._events;if(t){var n=t[e];if("function"==typeof n)return 1;if(n)return n.length}return 0}function tt(e,t){for(var n=new Array(t);t--;)n[t]=e[t];return n}Ge.prototype=Object.create(null),Ze.EventEmitter=Ze,Ze.usingDomains=false,Ze.prototype.domain=void 0,Ze.prototype._events=void 0,Ze.prototype._maxListeners=void 0,Ze.defaultMaxListeners=10,Ze.init=function(){this.domain=null,Ze.usingDomains&&undefined.active,this._events&&this._events!==Object.getPrototypeOf(this)._events||(this._events=new Ge,this._eventsCount=0),this._maxListeners=this._maxListeners||void 0;},Ze.prototype.setMaxListeners=function(e){if("number"!=typeof e||e<0||isNaN(e))throw new TypeError('"n" argument must be a positive number');return this._maxListeners=e,this},Ze.prototype.getMaxListeners=function(){return Qe(this)},Ze.prototype.emit=function(e){var t,n,r,i,o,a,s,u="error"===e;if(a=this._events)u=u&&null==a.error;else if(!u)return  false;if(s=this.domain,u){if(t=arguments[1],!s){if(t instanceof Error)throw t;var l=new Error('Uncaught, unspecified "error" event. ('+t+")");throw l.context=t,l}return t||(t=new Error('Uncaught, unspecified "error" event')),t.domainEmitter=this,t.domain=s,t.domainThrown=false,s.emit("error",t),false}if(!(n=a[e]))return  false;var c="function"==typeof n;switch(r=arguments.length){case 1:!function(e,t,n){if(t)e.call(n);else for(var r=e.length,i=tt(e,r),o=0;o<r;++o)i[o].call(n);}(n,c,this);break;case 2:!function(e,t,n,r){if(t)e.call(n,r);else for(var i=e.length,o=tt(e,i),a=0;a<i;++a)o[a].call(n,r);}(n,c,this,arguments[1]);break;case 3:!function(e,t,n,r,i){if(t)e.call(n,r,i);else for(var o=e.length,a=tt(e,o),s=0;s<o;++s)a[s].call(n,r,i);}(n,c,this,arguments[1],arguments[2]);break;case 4:!function(e,t,n,r,i,o){if(t)e.call(n,r,i,o);else for(var a=e.length,s=tt(e,a),u=0;u<a;++u)s[u].call(n,r,i,o);}(n,c,this,arguments[1],arguments[2],arguments[3]);break;default:for(i=new Array(r-1),o=1;o<r;o++)i[o-1]=arguments[o];!function(e,t,n,r){if(t)e.apply(n,r);else for(var i=e.length,o=tt(e,i),a=0;a<i;++a)o[a].apply(n,r);}(n,c,this,i);}return  true},Ze.prototype.addListener=function(e,t){return Je(this,e,t,false)},Ze.prototype.on=Ze.prototype.addListener,Ze.prototype.prependListener=function(e,t){return Je(this,e,t,true)},Ze.prototype.once=function(e,t){if("function"!=typeof t)throw new TypeError('"listener" argument must be a function');return this.on(e,Xe(this,e,t)),this},Ze.prototype.prependOnceListener=function(e,t){if("function"!=typeof t)throw new TypeError('"listener" argument must be a function');return this.prependListener(e,Xe(this,e,t)),this},Ze.prototype.removeListener=function(e,t){var n,r,i,o,a;if("function"!=typeof t)throw new TypeError('"listener" argument must be a function');if(!(r=this._events))return this;if(!(n=r[e]))return this;if(n===t||n.listener&&n.listener===t)0==--this._eventsCount?this._events=new Ge:(delete r[e],r.removeListener&&this.emit("removeListener",e,n.listener||t));else if("function"!=typeof n){for(i=-1,o=n.length;o-- >0;)if(n[o]===t||n[o].listener&&n[o].listener===t){a=n[o].listener,i=o;break}if(i<0)return this;if(1===n.length){if(n[0]=void 0,0==--this._eventsCount)return this._events=new Ge,this;delete r[e];}else !function(e,t){for(var n=t,r=n+1,i=e.length;r<i;n+=1,r+=1)e[n]=e[r];e.pop();}(n,i);r.removeListener&&this.emit("removeListener",e,a||t);}return this},Ze.prototype.removeAllListeners=function(e){var t,n;if(!(n=this._events))return this;if(!n.removeListener)return 0===arguments.length?(this._events=new Ge,this._eventsCount=0):n[e]&&(0==--this._eventsCount?this._events=new Ge:delete n[e]),this;if(0===arguments.length){for(var r,i=Object.keys(n),o=0;o<i.length;++o)"removeListener"!==(r=i[o])&&this.removeAllListeners(r);return this.removeAllListeners("removeListener"),this._events=new Ge,this._eventsCount=0,this}if("function"==typeof(t=n[e]))this.removeListener(e,t);else if(t)do{this.removeListener(e,t[t.length-1]);}while(t[0]);return this},Ze.prototype.listeners=function(e){var t,n,r=this._events;return n=r&&(t=r[e])?"function"==typeof t?[t.listener||t]:function(e){for(var t=new Array(e.length),n=0;n<t.length;++n)t[n]=e[n].listener||e[n];return t}(t):[],n},Ze.listenerCount=function(e,t){return "function"==typeof e.listenerCount?e.listenerCount(t):et.call(e,t)},Ze.prototype.listenerCount=et,Ze.prototype.eventNames=function(){return this._eventsCount>0?Reflect.ownKeys(this._events):[]};var nt=i(Object.freeze({__proto__:null,EventEmitter:Ze,default:Ze})),rt=nt.EventEmitter,it="function"==typeof Object.create?function(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}});}:function(e,t){e.super_=t;var n=function(){};n.prototype=t.prototype,e.prototype=new n,e.prototype.constructor=e;},ot=/%[sdj%]/g;function at(e){if(!St(e)){for(var t=[],n=0;n<arguments.length;n++)t.push(dt(arguments[n]));return t.join(" ")}n=1;for(var r=arguments,i=r.length,o=String(e).replace(ot,(function(e){if("%%"===e)return "%";if(n>=i)return e;switch(e){case "%s":return String(r[n++]);case "%d":return Number(r[n++]);case "%j":try{return JSON.stringify(r[n++])}catch(e){return "[Circular]"}default:return e}})),a=r[n];n<i;a=r[++n])yt(a)||!Ct(a)?o+=" "+a:o+=" "+dt(a);return o}function st(e,n){if(kt(t.process))return function(){return st(e,n).apply(this,arguments)};if(true===je.noDeprecation)return e;var r=false;return function(){if(!r){if(je.throwDeprecation)throw new Error(n);je.traceDeprecation?console.trace(n):console.error(n),r=true;}return e.apply(this,arguments)}}var ut,lt={};function ct(e){if(kt(ut)&&(ut=je.env.NODE_DEBUG||""),e=e.toUpperCase(),!lt[e])if(new RegExp("\\b"+e+"\\b","i").test(ut)){lt[e]=function(){var t=at.apply(null,arguments);console.error("%s %d: %s",e,0,t);};}else lt[e]=function(){};return lt[e]}function dt(e,t){var n={seen:[],stylize:ht};return arguments.length>=3&&(n.depth=arguments[2]),arguments.length>=4&&(n.colors=arguments[3]),bt(t)?n.showHidden=t:t&&Dt(n,t),kt(n.showHidden)&&(n.showHidden=false),kt(n.depth)&&(n.depth=2),kt(n.colors)&&(n.colors=false),kt(n.customInspect)&&(n.customInspect=true),n.colors&&(n.stylize=ft),pt(n,e,n.depth)}function ft(e,t){var n=dt.styles[t];return n?"["+dt.colors[n][0]+"m"+e+"["+dt.colors[n][1]+"m":e}function ht(e,t){return e}function pt(e,t,n){if(e.customInspect&&t&&Rt(t.inspect)&&t.inspect!==dt&&(!t.constructor||t.constructor.prototype!==t)){var r=t.inspect(n,e);return St(r)||(r=pt(e,r,n)),r}var i=function(e,t){if(kt(t))return e.stylize("undefined","undefined");if(St(t)){var n="'"+JSON.stringify(t).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return e.stylize(n,"string")}if(_t(t))return e.stylize(""+t,"number");if(bt(t))return e.stylize(""+t,"boolean");if(yt(t))return e.stylize("null","null")}(e,t);if(i)return i;var o=Object.keys(t),a=function(e){var t={};return e.forEach((function(e,n){t[e]=true;})),t}(o);if(e.showHidden&&(o=Object.getOwnPropertyNames(t)),At(t)&&(o.indexOf("message")>=0||o.indexOf("description")>=0))return mt(t);if(0===o.length){if(Rt(t)){var s=t.name?": "+t.name:"";return e.stylize("[Function"+s+"]","special")}if(Mt(t))return e.stylize(RegExp.prototype.toString.call(t),"regexp");if(xt(t))return e.stylize(Date.prototype.toString.call(t),"date");if(At(t))return mt(t)}var u,l="",c=false,d=["{","}"];(vt(t)&&(c=true,d=["[","]"]),Rt(t))&&(l=" [Function"+(t.name?": "+t.name:"")+"]");return Mt(t)&&(l=" "+RegExp.prototype.toString.call(t)),xt(t)&&(l=" "+Date.prototype.toUTCString.call(t)),At(t)&&(l=" "+mt(t)),0!==o.length||c&&0!=t.length?n<0?Mt(t)?e.stylize(RegExp.prototype.toString.call(t),"regexp"):e.stylize("[Object]","special"):(e.seen.push(t),u=c?function(e,t,n,r,i){for(var o=[],a=0,s=t.length;a<s;++a)jt(t,String(a))?o.push(gt(e,t,n,r,String(a),true)):o.push("");return i.forEach((function(i){i.match(/^\d+$/)||o.push(gt(e,t,n,r,i,true));})),o}(e,t,n,a,o):o.map((function(r){return gt(e,t,n,a,r,c)})),e.seen.pop(),function(e,t,n){var r=e.reduce((function(e,t){return t.indexOf("\n"),e+t.replace(/\u001b\[\d\d?m/g,"").length+1}),0);if(r>60)return n[0]+(""===t?"":t+"\n ")+" "+e.join(",\n  ")+" "+n[1];return n[0]+t+" "+e.join(", ")+" "+n[1]}(u,l,d)):d[0]+l+d[1]}function mt(e){return "["+Error.prototype.toString.call(e)+"]"}function gt(e,t,n,r,i,o){var a,s,u;if((u=Object.getOwnPropertyDescriptor(t,i)||{value:t[i]}).get?s=u.set?e.stylize("[Getter/Setter]","special"):e.stylize("[Getter]","special"):u.set&&(s=e.stylize("[Setter]","special")),jt(r,i)||(a="["+i+"]"),s||(e.seen.indexOf(u.value)<0?(s=yt(n)?pt(e,u.value,null):pt(e,u.value,n-1)).indexOf("\n")>-1&&(s=o?s.split("\n").map((function(e){return "  "+e})).join("\n").substr(2):"\n"+s.split("\n").map((function(e){return "   "+e})).join("\n")):s=e.stylize("[Circular]","special")),kt(a)){if(o&&i.match(/^\d+$/))return s;(a=JSON.stringify(""+i)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)?(a=a.substr(1,a.length-2),a=e.stylize(a,"name")):(a=a.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'"),a=e.stylize(a,"string"));}return a+": "+s}function vt(e){return Array.isArray(e)}function bt(e){return "boolean"==typeof e}function yt(e){return null===e}function wt(e){return null==e}function _t(e){return "number"==typeof e}function St(e){return "string"==typeof e}function Et(e){return "symbol"==typeof e}function kt(e){return void 0===e}function Mt(e){return Ct(e)&&"[object RegExp]"===Lt(e)}function Ct(e){return "object"==typeof e&&null!==e}function xt(e){return Ct(e)&&"[object Date]"===Lt(e)}function At(e){return Ct(e)&&("[object Error]"===Lt(e)||e instanceof Error)}function Rt(e){return "function"==typeof e}function Tt(e){return null===e||"boolean"==typeof e||"number"==typeof e||"string"==typeof e||"symbol"==typeof e||void 0===e}function Pt(e){return ie(e)}function Lt(e){return Object.prototype.toString.call(e)}function It(e){return e<10?"0"+e.toString(10):e.toString(10)}dt.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]},dt.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey",null:"bold",string:"green",date:"magenta",regexp:"red"};var Ot=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];function Nt(){console.log("%s - %s",function(){var e=new Date,t=[It(e.getHours()),It(e.getMinutes()),It(e.getSeconds())].join(":");return [e.getDate(),Ot[e.getMonth()],t].join(" ")}(),at.apply(null,arguments));}function Dt(e,t){if(!t||!Ct(t))return e;for(var n=Object.keys(t),r=n.length;r--;)e[n[r]]=t[n[r]];return e}function jt(e,t){return Object.prototype.hasOwnProperty.call(e,t)}var Bt,zt,Ut={inherits:it,_extend:Dt,log:Nt,isBuffer:Pt,isPrimitive:Tt,isFunction:Rt,isError:At,isDate:xt,isObject:Ct,isRegExp:Mt,isUndefined:kt,isSymbol:Et,isString:St,isNumber:_t,isNullOrUndefined:wt,isNull:yt,isBoolean:bt,isArray:vt,inspect:dt,deprecate:st,format:at,debuglog:ct},Ft=i(Object.freeze({__proto__:null,_extend:Dt,debuglog:ct,default:Ut,deprecate:st,format:at,inherits:it,inspect:dt,isArray:vt,isBoolean:bt,isBuffer:Pt,isDate:xt,isError:At,isFunction:Rt,isNull:yt,isNullOrUndefined:wt,isNumber:_t,isObject:Ct,isPrimitive:Tt,isRegExp:Mt,isString:St,isSymbol:Et,isUndefined:kt,log:Nt}));function Kt(){if(zt)return Bt;function e(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);t&&(r=r.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,r);}return n}function t(t){for(var r=1;r<arguments.length;r++){var i=null!=arguments[r]?arguments[r]:{};r%2?e(Object(i),true).forEach((function(e){n(t,e,i[e]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(i)):e(Object(i)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(i,e));}));}return t}function n(e,t,n){return (t=i(t))in e?Object.defineProperty(e,t,{value:n,enumerable:true,configurable:true,writable:true}):e[t]=n,e}function r(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||false,r.configurable=true,"value"in r&&(r.writable=true),Object.defineProperty(e,i(r.key),r);}}function i(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t);if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return (String)(e)}(e,"string");return "symbol"==typeof t?t:String(t)}zt=1;var o=ce.Buffer,a=Ft.inspect,s=a&&a.custom||"inspect";return Bt=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.head=null,this.tail=null,this.length=0;}var n,i;return n=e,i=[{key:"push",value:function(e){var t={data:e,next:null};this.length>0?this.tail.next=t:this.head=t,this.tail=t,++this.length;}},{key:"unshift",value:function(e){var t={data:e,next:this.head};0===this.length&&(this.tail=t),this.head=t,++this.length;}},{key:"shift",value:function(){if(0!==this.length){var e=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,e}}},{key:"clear",value:function(){this.head=this.tail=null,this.length=0;}},{key:"join",value:function(e){if(0===this.length)return "";for(var t=this.head,n=""+t.data;t=t.next;)n+=e+t.data;return n}},{key:"concat",value:function(e){if(0===this.length)return o.alloc(0);for(var t,n,r,i=o.allocUnsafe(e>>>0),a=this.head,s=0;a;)t=a.data,n=i,r=s,o.prototype.copy.call(t,n,r),s+=a.data.length,a=a.next;return i}},{key:"consume",value:function(e,t){var n;return e<this.head.data.length?(n=this.head.data.slice(0,e),this.head.data=this.head.data.slice(e)):n=e===this.head.data.length?this.shift():t?this._getString(e):this._getBuffer(e),n}},{key:"first",value:function(){return this.head.data}},{key:"_getString",value:function(e){var t=this.head,n=1,r=t.data;for(e-=r.length;t=t.next;){var i=t.data,o=e>i.length?i.length:e;if(o===i.length?r+=i:r+=i.slice(0,e),0==(e-=o)){o===i.length?(++n,t.next?this.head=t.next:this.head=this.tail=null):(this.head=t,t.data=i.slice(o));break}++n;}return this.length-=n,r}},{key:"_getBuffer",value:function(e){var t=o.allocUnsafe(e),n=this.head,r=1;for(n.data.copy(t),e-=n.data.length;n=n.next;){var i=n.data,a=e>i.length?i.length:e;if(i.copy(t,t.length-e,0,a),0==(e-=a)){a===i.length?(++r,n.next?this.head=n.next:this.head=this.tail=null):(this.head=n,n.data=i.slice(a));break}++r;}return this.length-=r,t}},{key:s,value:function(e,n){return a(this,t(t({},n),{},{depth:0,customInspect:false}))}}],i&&r(n.prototype,i),Object.defineProperty(n,"prototype",{writable:false}),e}(),Bt}function qt(e,t){Wt(e,t),Ht(e);}function Ht(e){e._writableState&&!e._writableState.emitClose||e._readableState&&!e._readableState.emitClose||e.emit("close");}function Wt(e,t){e.emit("error",t);}var $t={destroy:function(e,t){var n=this,r=this._readableState&&this._readableState.destroyed,i=this._writableState&&this._writableState.destroyed;return r||i?(t?t(e):e&&(this._writableState?this._writableState.errorEmitted||(this._writableState.errorEmitted=true,Ee(Wt,this,e)):Ee(Wt,this,e)),this):(this._readableState&&(this._readableState.destroyed=true),this._writableState&&(this._writableState.destroyed=true),this._destroy(e||null,(function(e){!t&&e?n._writableState?n._writableState.errorEmitted?Ee(Ht,n):(n._writableState.errorEmitted=true,Ee(qt,n,e)):Ee(qt,n,e):t?(Ee(Ht,n),t(e)):Ee(Ht,n);})),this)},undestroy:function(){this._readableState&&(this._readableState.destroyed=false,this._readableState.reading=false,this._readableState.ended=false,this._readableState.endEmitted=false),this._writableState&&(this._writableState.destroyed=false,this._writableState.ended=false,this._writableState.ending=false,this._writableState.finalCalled=false,this._writableState.prefinished=false,this._writableState.finished=false,this._writableState.errorEmitted=false);},errorOrDestroy:function(e,t){var n=e._readableState,r=e._writableState;n&&n.autoDestroy||r&&r.autoDestroy?e.destroy(t):e.emit("error",t);}},Vt={};var Yt={};function Gt(e,t,n){n||(n=Error);var r=function(e){var n,r;function i(n,r,i){return e.call(this,function(e,n,r){return "string"==typeof t?t:t(e,n,r)}(n,r,i))||this}return r=e,(n=i).prototype=Object.create(r.prototype),n.prototype.constructor=n,n.__proto__=r,i}(n);r.prototype.name=n.name,r.prototype.code=e,Yt[e]=r;}function Zt(e,t){if(Array.isArray(e)){var n=e.length;return e=e.map((function(e){return String(e)})),n>2?"one of ".concat(t," ").concat(e.slice(0,n-1).join(", "),", or ")+e[n-1]:2===n?"one of ".concat(t," ").concat(e[0]," or ").concat(e[1]):"of ".concat(t," ").concat(e[0])}return "of ".concat(t," ").concat(String(e))}Gt("ERR_INVALID_OPT_VALUE",(function(e,t){return 'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError),Gt("ERR_INVALID_ARG_TYPE",(function(e,t,n){var r,i,a;if("string"==typeof t&&(i="not ",t.substr(0,i.length)===i)?(r="must not be",t=t.replace(/^not /,"")):r="must be",function(e,t,n){return (void 0===n||n>e.length)&&(n=e.length),e.substring(n-t.length,n)===t}(e," argument"))a="The ".concat(e," ").concat(r," ").concat(Zt(t,"type"));else {var s=function(e,t,n){return "number"!=typeof n&&(n=0),!(n+t.length>e.length)&&-1!==e.indexOf(t,n)}(e,".")?"property":"argument";a='The "'.concat(e,'" ').concat(s," ").concat(r," ").concat(Zt(t,"type"));}return a+=". Received type ".concat(typeof n)}),TypeError),Gt("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF"),Gt("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return "The "+e+" method is not implemented"})),Gt("ERR_STREAM_PREMATURE_CLOSE","Premature close"),Gt("ERR_STREAM_DESTROYED",(function(e){return "Cannot call "+e+" after a stream was destroyed"})),Gt("ERR_MULTIPLE_CALLBACK","Callback called multiple times"),Gt("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable"),Gt("ERR_STREAM_WRITE_AFTER_END","write after end"),Gt("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError),Gt("ERR_UNKNOWN_ENCODING",(function(e){return "Unknown encoding: "+e}),TypeError),Gt("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event"),Vt.codes=Yt;var Qt=Vt.codes.ERR_INVALID_OPT_VALUE;var Jt,Xt,en,tn,nn={getHighWaterMark:function(e,t,n,r){var i=function(e,t,n){return null!=e.highWaterMark?e.highWaterMark:t?e[n]:null}(t,r,n);if(null!=i){if(!isFinite(i)||Math.floor(i)!==i||i<0)throw new Qt(r?n:"highWaterMark",i);return Math.floor(i)}return e.objectMode?16:16384}},rn=function(e,t){if(on("noDeprecation"))return e;var n=false;return function(){if(!n){if(on("throwDeprecation"))throw new Error(t);on("traceDeprecation")?console.trace(t):console.warn(t),n=true;}return e.apply(this,arguments)}};function on(e){try{if(!n.localStorage)return !1}catch(e){return  false}var t=n.localStorage[e];return null!=t&&"true"===String(t).toLowerCase()}function an(){if(Xt)return Jt;function e(e){var t=this;this.next=null,this.entry=null,this.finish=function(){!function(e,t,n){var r=e.entry;e.entry=null;for(;r;){var i=r.callback;t.pendingcb--,i(n),r=r.next;}t.corkedRequestsFree.next=e;}(t,e);};}var t;Xt=1,Jt=S,S.WritableState=_;var r={deprecate:rn},i=rt,o=ce.Buffer,a=(void 0!==n?n:"undefined"!=typeof window?window:"undefined"!=typeof self?self:{}).Uint8Array||function(){};var s,u=$t,l=nn.getHighWaterMark,c=Vt.codes,d=c.ERR_INVALID_ARG_TYPE,f=c.ERR_METHOD_NOT_IMPLEMENTED,h=c.ERR_MULTIPLE_CALLBACK,p=c.ERR_STREAM_CANNOT_PIPE,m=c.ERR_STREAM_DESTROYED,g=c.ERR_STREAM_NULL_VALUES,v=c.ERR_STREAM_WRITE_AFTER_END,b=c.ERR_UNKNOWN_ENCODING,y=u.errorOrDestroy;function w(){}function _(n,r,i){t=t||sn(),n=n||{},"boolean"!=typeof i&&(i=r instanceof t),this.objectMode=!!n.objectMode,i&&(this.objectMode=this.objectMode||!!n.writableObjectMode),this.highWaterMark=l(this,n,"writableHighWaterMark",i),this.finalCalled=false,this.needDrain=false,this.ending=false,this.ended=false,this.finished=false,this.destroyed=false;var o=false===n.decodeStrings;this.decodeStrings=!o,this.defaultEncoding=n.defaultEncoding||"utf8",this.length=0,this.writing=false,this.corked=0,this.sync=true,this.bufferProcessing=false,this.onwrite=function(e){!function(e,t){var n=e._writableState,r=n.sync,i=n.writecb;if("function"!=typeof i)throw new h;if(function(e){e.writing=false,e.writecb=null,e.length-=e.writelen,e.writelen=0;}(n),t)!function(e,t,n,r,i){--t.pendingcb,n?(Ee(i,r),Ee(A,e,t),e._writableState.errorEmitted=true,y(e,r)):(i(r),e._writableState.errorEmitted=true,y(e,r),A(e,t));}(e,n,r,t,i);else {var o=C(n)||e.destroyed;o||n.corked||n.bufferProcessing||!n.bufferedRequest||M(e,n),r?Ee(k,e,n,o,i):k(e,n,o,i);}}(r,e);},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=false,this.errorEmitted=false,this.emitClose=false!==n.emitClose,this.autoDestroy=!!n.autoDestroy,this.bufferedRequestCount=0,this.corkedRequestsFree=new e(this);}function S(e){var n=this instanceof(t=t||sn());if(!n&&!s.call(S,this))return new S(e);this._writableState=new _(e,this,n),this.writable=true,e&&("function"==typeof e.write&&(this._write=e.write),"function"==typeof e.writev&&(this._writev=e.writev),"function"==typeof e.destroy&&(this._destroy=e.destroy),"function"==typeof e.final&&(this._final=e.final)),i.call(this);}function E(e,t,n,r,i,o,a){t.writelen=r,t.writecb=a,t.writing=true,t.sync=true,t.destroyed?t.onwrite(new m("write")):n?e._writev(i,t.onwrite):e._write(i,o,t.onwrite),t.sync=false;}function k(e,t,n,r){n||function(e,t){0===t.length&&t.needDrain&&(t.needDrain=false,e.emit("drain"));}(e,t),t.pendingcb--,r(),A(e,t);}function M(t,n){n.bufferProcessing=true;var r=n.bufferedRequest;if(t._writev&&r&&r.next){var i=n.bufferedRequestCount,o=new Array(i),a=n.corkedRequestsFree;a.entry=r;for(var s=0,u=true;r;)o[s]=r,r.isBuf||(u=false),r=r.next,s+=1;o.allBuffers=u,E(t,n,true,n.length,o,"",a.finish),n.pendingcb++,n.lastBufferedRequest=null,a.next?(n.corkedRequestsFree=a.next,a.next=null):n.corkedRequestsFree=new e(n),n.bufferedRequestCount=0;}else {for(;r;){var l=r.chunk,c=r.encoding,d=r.callback;if(E(t,n,false,n.objectMode?1:l.length,l,c,d),r=r.next,n.bufferedRequestCount--,n.writing)break}null===r&&(n.lastBufferedRequest=null);}n.bufferedRequest=r,n.bufferProcessing=false;}function C(e){return e.ending&&0===e.length&&null===e.bufferedRequest&&!e.finished&&!e.writing}function x(e,t){e._final((function(n){t.pendingcb--,n&&y(e,n),t.prefinished=true,e.emit("prefinish"),A(e,t);}));}function A(e,t){var n=C(t);if(n&&(function(e,t){t.prefinished||t.finalCalled||("function"!=typeof e._final||t.destroyed?(t.prefinished=true,e.emit("prefinish")):(t.pendingcb++,t.finalCalled=true,Ee(x,e,t)));}(e,t),0===t.pendingcb&&(t.finished=true,e.emit("finish"),t.autoDestroy))){var r=e._readableState;(!r||r.autoDestroy&&r.endEmitted)&&e.destroy();}return n}return Ve(S,i),_.prototype.getBuffer=function(){for(var e=this.bufferedRequest,t=[];e;)t.push(e),e=e.next;return t},function(){try{Object.defineProperty(_.prototype,"buffer",{get:r.deprecate((function(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.","DEP0003")});}catch(e){}}(),"function"==typeof Symbol&&Symbol.hasInstance&&"function"==typeof Function.prototype[Symbol.hasInstance]?(s=Function.prototype[Symbol.hasInstance],Object.defineProperty(S,Symbol.hasInstance,{value:function(e){return !!s.call(this,e)||this===S&&(e&&e._writableState instanceof _)}})):s=function(e){return e instanceof this},S.prototype.pipe=function(){y(this,new p);},S.prototype.write=function(e,t,n){var r,i=this._writableState,s=false,u=!i.objectMode&&(r=e,o.isBuffer(r)||r instanceof a);return u&&!o.isBuffer(e)&&(e=function(e){return o.from(e)}(e)),"function"==typeof t&&(n=t,t=null),u?t="buffer":t||(t=i.defaultEncoding),"function"!=typeof n&&(n=w),i.ending?function(e,t){var n=new v;y(e,n),Ee(t,n);}(this,n):(u||function(e,t,n,r){var i;return null===n?i=new g:"string"==typeof n||t.objectMode||(i=new d("chunk",["string","Buffer"],n)),!i||(y(e,i),Ee(r,i),false)}(this,i,e,n))&&(i.pendingcb++,s=function(e,t,n,r,i,a){if(!n){var s=function(e,t,n){e.objectMode||false===e.decodeStrings||"string"!=typeof t||(t=o.from(t,n));return t}(t,r,i);r!==s&&(n=true,i="buffer",r=s);}var u=t.objectMode?1:r.length;t.length+=u;var l=t.length<t.highWaterMark;l||(t.needDrain=true);if(t.writing||t.corked){var c=t.lastBufferedRequest;t.lastBufferedRequest={chunk:r,encoding:i,isBuf:n,callback:a,next:null},c?c.next=t.lastBufferedRequest:t.bufferedRequest=t.lastBufferedRequest,t.bufferedRequestCount+=1;}else E(e,t,false,u,r,i,a);return l}(this,i,u,e,t,n)),s},S.prototype.cork=function(){this._writableState.corked++;},S.prototype.uncork=function(){var e=this._writableState;e.corked&&(e.corked--,e.writing||e.corked||e.bufferProcessing||!e.bufferedRequest||M(this,e));},S.prototype.setDefaultEncoding=function(e){if("string"==typeof e&&(e=e.toLowerCase()),!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new b(e);return this._writableState.defaultEncoding=e,this},Object.defineProperty(S.prototype,"writableBuffer",{enumerable:false,get:function(){return this._writableState&&this._writableState.getBuffer()}}),Object.defineProperty(S.prototype,"writableHighWaterMark",{enumerable:false,get:function(){return this._writableState.highWaterMark}}),S.prototype._write=function(e,t,n){n(new f("_write()"));},S.prototype._writev=null,S.prototype.end=function(e,t,n){var r=this._writableState;return "function"==typeof e?(n=e,e=null,t=null):"function"==typeof t&&(n=t,t=null),null!=e&&this.write(e,t),r.corked&&(r.corked=1,this.uncork()),r.ending||function(e,t,n){t.ending=true,A(e,t),n&&(t.finished?Ee(n):e.once("finish",n));t.ended=true,e.writable=false;}(this,r,n),this},Object.defineProperty(S.prototype,"writableLength",{enumerable:false,get:function(){return this._writableState.length}}),Object.defineProperty(S.prototype,"destroyed",{enumerable:false,get:function(){return void 0!==this._writableState&&this._writableState.destroyed},set:function(e){this._writableState&&(this._writableState.destroyed=e);}}),S.prototype.destroy=u.destroy,S.prototype._undestroy=u.undestroy,S.prototype._destroy=function(e,t){t(e);},Jt}function sn(){if(tn)return en;tn=1;var e=Object.keys||function(e){var t=[];for(var n in e)t.push(n);return t};en=a;var t=_n(),n=an();Ve(a,t);for(var r=e(n.prototype),i=0;i<r.length;i++){var o=r[i];a.prototype[o]||(a.prototype[o]=n.prototype[o]);}function a(e){if(!(this instanceof a))return new a(e);t.call(this,e),n.call(this,e),this.allowHalfOpen=true,e&&(false===e.readable&&(this.readable=false),false===e.writable&&(this.writable=false),false===e.allowHalfOpen&&(this.allowHalfOpen=false,this.once("end",s)));}function s(){this._writableState.ended||Ee(u,this);}function u(e){e.end();}return Object.defineProperty(a.prototype,"writableHighWaterMark",{enumerable:false,get:function(){return this._writableState.highWaterMark}}),Object.defineProperty(a.prototype,"writableBuffer",{enumerable:false,get:function(){return this._writableState&&this._writableState.getBuffer()}}),Object.defineProperty(a.prototype,"writableLength",{enumerable:false,get:function(){return this._writableState.length}}),Object.defineProperty(a.prototype,"destroyed",{enumerable:false,get:function(){return void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed&&this._writableState.destroyed)},set:function(e){ void 0!==this._readableState&&void 0!==this._writableState&&(this._readableState.destroyed=e,this._writableState.destroyed=e);}}),en}var un,ln={};function cn(){if(un)return ln;un=1;var e=Ue().Buffer,t=e.isEncoding||function(e){switch((e=""+e)&&e.toLowerCase()){case "hex":case "utf8":case "utf-8":case "ascii":case "binary":case "base64":case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":case "raw":return  true;default:return  false}};function n(n){var r;switch(this.encoding=function(n){var r=function(e){if(!e)return "utf8";for(var t;;)switch(e){case "utf8":case "utf-8":return "utf8";case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":return "utf16le";case "latin1":case "binary":return "latin1";case "base64":case "ascii":case "hex":return e;default:if(t)return;e=(""+e).toLowerCase(),t=true;}}(n);if("string"!=typeof r&&(e.isEncoding===t||!t(n)))throw new Error("Unknown encoding: "+n);return r||n}(n),this.encoding){case "utf16le":this.text=o,this.end=a,r=4;break;case "utf8":this.fillLast=i,r=4;break;case "base64":this.text=s,this.end=u,r=3;break;default:return this.write=l,void(this.end=c)}this.lastNeed=0,this.lastTotal=0,this.lastChar=e.allocUnsafe(r);}function r(e){return e<=127?0:e>>5==6?2:e>>4==14?3:e>>3==30?4:e>>6==2?-1:-2}function i(e){var t=this.lastTotal-this.lastNeed,n=function(e,t,n){if(128!=(192&t[0]))return e.lastNeed=0,"�";if(e.lastNeed>1&&t.length>1){if(128!=(192&t[1]))return e.lastNeed=1,"�";if(e.lastNeed>2&&t.length>2&&128!=(192&t[2]))return e.lastNeed=2,"�"}}(this,e);return void 0!==n?n:this.lastNeed<=e.length?(e.copy(this.lastChar,t,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal)):(e.copy(this.lastChar,t,0,e.length),void(this.lastNeed-=e.length))}function o(e,t){if((e.length-t)%2==0){var n=e.toString("utf16le",t);if(n){var r=n.charCodeAt(n.length-1);if(r>=55296&&r<=56319)return this.lastNeed=2,this.lastTotal=4,this.lastChar[0]=e[e.length-2],this.lastChar[1]=e[e.length-1],n.slice(0,-1)}return n}return this.lastNeed=1,this.lastTotal=2,this.lastChar[0]=e[e.length-1],e.toString("utf16le",t,e.length-1)}function a(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var n=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,n)}return t}function s(e,t){var n=(e.length-t)%3;return 0===n?e.toString("base64",t):(this.lastNeed=3-n,this.lastTotal=3,1===n?this.lastChar[0]=e[e.length-1]:(this.lastChar[0]=e[e.length-2],this.lastChar[1]=e[e.length-1]),e.toString("base64",t,e.length-n))}function u(e){var t=e&&e.length?this.write(e):"";return this.lastNeed?t+this.lastChar.toString("base64",0,3-this.lastNeed):t}function l(e){return e.toString(this.encoding)}function c(e){return e&&e.length?this.write(e):""}return ln.StringDecoder=n,n.prototype.write=function(e){if(0===e.length)return "";var t,n;if(this.lastNeed){if(void 0===(t=this.fillLast(e)))return "";n=this.lastNeed,this.lastNeed=0;}else n=0;return n<e.length?t?t+this.text(e,n):this.text(e,n):t||""},n.prototype.end=function(e){var t=e&&e.length?this.write(e):"";return this.lastNeed?t+"�":t},n.prototype.text=function(e,t){var n=function(e,t,n){var i=t.length-1;if(i<n)return 0;var o=r(t[i]);if(o>=0)return o>0&&(e.lastNeed=o-1),o;if(--i<n||-2===o)return 0;if(o=r(t[i]),o>=0)return o>0&&(e.lastNeed=o-2),o;if(--i<n||-2===o)return 0;if(o=r(t[i]),o>=0)return o>0&&(2===o?o=0:e.lastNeed=o-3),o;return 0}(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=n;var i=e.length-(n-this.lastNeed);return e.copy(this.lastChar,0,i),e.toString("utf8",t,i)},n.prototype.fillLast=function(e){if(this.lastNeed<=e.length)return e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed),this.lastChar.toString(this.encoding,0,this.lastTotal);e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length),this.lastNeed-=e.length;},ln}var dn=Vt.codes.ERR_STREAM_PREMATURE_CLOSE;function fn(){}var hn,pn,mn,gn,vn,bn,yn=function e(t,n,r){if("function"==typeof n)return e(t,null,n);n||(n={}),r=function(e){var t=false;return function(){if(!t){t=true;for(var n=arguments.length,r=new Array(n),i=0;i<n;i++)r[i]=arguments[i];e.apply(this,r);}}}(r||fn);var i=n.readable||false!==n.readable&&t.readable,o=n.writable||false!==n.writable&&t.writable,a=function(){t.writable||u();},s=t._writableState&&t._writableState.finished,u=function(){o=false,s=true,i||r.call(t);},l=t._readableState&&t._readableState.endEmitted,c=function(){i=false,l=true,o||r.call(t);},d=function(e){r.call(t,e);},f=function(){var e;return i&&!l?(t._readableState&&t._readableState.ended||(e=new dn),r.call(t,e)):o&&!s?(t._writableState&&t._writableState.ended||(e=new dn),r.call(t,e)):void 0},h=function(){t.req.on("finish",u);};return !function(e){return e.setHeader&&"function"==typeof e.abort}(t)?o&&!t._writableState&&(t.on("end",a),t.on("close",a)):(t.on("complete",u),t.on("abort",f),t.req?h():t.on("request",h)),t.on("end",c),t.on("finish",u),false!==n.error&&t.on("error",d),t.on("close",f),function(){t.removeListener("complete",u),t.removeListener("abort",f),t.removeListener("request",h),t.req&&t.req.removeListener("finish",u),t.removeListener("end",a),t.removeListener("close",a),t.removeListener("finish",u),t.removeListener("end",c),t.removeListener("error",d),t.removeListener("close",f);}};function wn(){if(pn)return hn;var e;function t(e,t,n){return (t=function(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t);if("object"!=typeof r)return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return ("string"===t?String:Number)(e)}(e,"string");return "symbol"==typeof t?t:String(t)}(t))in e?Object.defineProperty(e,t,{value:n,enumerable:true,configurable:true,writable:true}):e[t]=n,e}pn=1;var n=yn,r=Symbol("lastResolve"),i=Symbol("lastReject"),o=Symbol("error"),a=Symbol("ended"),s=Symbol("lastPromise"),u=Symbol("handlePromise"),l=Symbol("stream");function c(e,t){return {value:e,done:t}}function d(e){var t=e[r];if(null!==t){var n=e[l].read();null!==n&&(e[s]=null,e[r]=null,e[i]=null,t(c(n,false)));}}function f(e){Ee(d,e);}var h=Object.getPrototypeOf((function(){})),p=Object.setPrototypeOf((t(e={get stream(){return this[l]},next:function(){var e=this,t=this[o];if(null!==t)return Promise.reject(t);if(this[a])return Promise.resolve(c(void 0,true));if(this[l].destroyed)return new Promise((function(t,n){Ee((function(){e[o]?n(e[o]):t(c(void 0,true));}));}));var n,r=this[s];if(r)n=new Promise(function(e,t){return function(n,r){e.then((function(){t[a]?n(c(void 0,true)):t[u](n,r);}),r);}}(r,this));else {var i=this[l].read();if(null!==i)return Promise.resolve(c(i,false));n=new Promise(this[u]);}return this[s]=n,n}},Symbol.asyncIterator,(function(){return this})),t(e,"return",(function(){var e=this;return new Promise((function(t,n){e[l].destroy(null,(function(e){e?n(e):t(c(void 0,true));}));}))})),e),h);return hn=function(e){var d,h=Object.create(p,(t(d={},l,{value:e,writable:true}),t(d,r,{value:null,writable:true}),t(d,i,{value:null,writable:true}),t(d,o,{value:null,writable:true}),t(d,a,{value:e._readableState.endEmitted,writable:true}),t(d,u,{value:function(e,t){var n=h[l].read();n?(h[s]=null,h[r]=null,h[i]=null,e(c(n,false))):(h[r]=e,h[i]=t);},writable:true}),d));return h[s]=null,n(e,(function(e){if(e&&"ERR_STREAM_PREMATURE_CLOSE"!==e.code){var t=h[i];return null!==t&&(h[s]=null,h[r]=null,h[i]=null,t(e)),void(h[o]=e)}var n=h[r];null!==n&&(h[s]=null,h[r]=null,h[i]=null,n(c(void 0,true))),h[a]=true;})),e.on("readable",f.bind(null,h)),h},hn}function _n(){if(bn)return vn;var e;bn=1,vn=S,S.ReadableState=_,nt.EventEmitter;var t=function(e,t){return e.listeners(t).length},r=rt,i=ce.Buffer,o=(void 0!==n?n:"undefined"!=typeof window?window:"undefined"!=typeof self?self:{}).Uint8Array||function(){};var a,s=Ft;a=s&&s.debuglog?s.debuglog("stream"):function(){};var u,l,c,d=Kt(),f=$t,h=nn.getHighWaterMark,p=Vt.codes,m=p.ERR_INVALID_ARG_TYPE,g=p.ERR_STREAM_PUSH_AFTER_EOF,v=p.ERR_METHOD_NOT_IMPLEMENTED,b=p.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;Ve(S,r);var y=f.errorOrDestroy,w=["error","close","destroy","pause","resume"];function _(t,n,r){e=e||sn(),t=t||{},"boolean"!=typeof r&&(r=n instanceof e),this.objectMode=!!t.objectMode,r&&(this.objectMode=this.objectMode||!!t.readableObjectMode),this.highWaterMark=h(this,t,"readableHighWaterMark",r),this.buffer=new d,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=false,this.endEmitted=false,this.reading=false,this.sync=true,this.needReadable=false,this.emittedReadable=false,this.readableListening=false,this.resumeScheduled=false,this.paused=true,this.emitClose=false!==t.emitClose,this.autoDestroy=!!t.autoDestroy,this.destroyed=false,this.defaultEncoding=t.defaultEncoding||"utf8",this.awaitDrain=0,this.readingMore=false,this.decoder=null,this.encoding=null,t.encoding&&(u||(u=cn().StringDecoder),this.decoder=new u(t.encoding),this.encoding=t.encoding);}function S(t){if(e=e||sn(),!(this instanceof S))return new S(t);var n=this instanceof e;this._readableState=new _(t,this,n),this.readable=true,t&&("function"==typeof t.read&&(this._read=t.read),"function"==typeof t.destroy&&(this._destroy=t.destroy)),r.call(this);}function E(e,t,n,r,s){a("readableAddChunk",t);var u,l=e._readableState;if(null===t)l.reading=false,function(e,t){if(a("onEofChunk"),t.ended)return;if(t.decoder){var n=t.decoder.end();n&&n.length&&(t.buffer.push(n),t.length+=t.objectMode?1:n.length);}t.ended=true,t.sync?x(e):(t.needReadable=false,t.emittedReadable||(t.emittedReadable=true,A(e)));}(e,l);else if(s||(u=function(e,t){var n;r=t,i.isBuffer(r)||r instanceof o||"string"==typeof t||void 0===t||e.objectMode||(n=new m("chunk",["string","Buffer","Uint8Array"],t));var r;return n}(l,t)),u)y(e,u);else if(l.objectMode||t&&t.length>0)if("string"==typeof t||l.objectMode||Object.getPrototypeOf(t)===i.prototype||(t=function(e){return i.from(e)}(t)),r)l.endEmitted?y(e,new b):k(e,l,t,true);else if(l.ended)y(e,new g);else {if(l.destroyed)return  false;l.reading=false,l.decoder&&!n?(t=l.decoder.write(t),l.objectMode||0!==t.length?k(e,l,t,false):R(e,l)):k(e,l,t,false);}else r||(l.reading=false,R(e,l));return !l.ended&&(l.length<l.highWaterMark||0===l.length)}function k(e,t,n,r){t.flowing&&0===t.length&&!t.sync?(t.awaitDrain=0,e.emit("data",n)):(t.length+=t.objectMode?1:n.length,r?t.buffer.unshift(n):t.buffer.push(n),t.needReadable&&x(e)),R(e,t);}Object.defineProperty(S.prototype,"destroyed",{enumerable:false,get:function(){return void 0!==this._readableState&&this._readableState.destroyed},set:function(e){this._readableState&&(this._readableState.destroyed=e);}}),S.prototype.destroy=f.destroy,S.prototype._undestroy=f.undestroy,S.prototype._destroy=function(e,t){t(e);},S.prototype.push=function(e,t){var n,r=this._readableState;return r.objectMode?n=true:"string"==typeof e&&((t=t||r.defaultEncoding)!==r.encoding&&(e=i.from(e,t),t=""),n=true),E(this,e,t,false,n)},S.prototype.unshift=function(e){return E(this,e,null,true,false)},S.prototype.isPaused=function(){return  false===this._readableState.flowing},S.prototype.setEncoding=function(e){u||(u=cn().StringDecoder);var t=new u(e);this._readableState.decoder=t,this._readableState.encoding=this._readableState.decoder.encoding;for(var n=this._readableState.buffer.head,r="";null!==n;)r+=t.write(n.data),n=n.next;return this._readableState.buffer.clear(),""!==r&&this._readableState.buffer.push(r),this._readableState.length=r.length,this};var M=1073741824;function C(e,t){return e<=0||0===t.length&&t.ended?0:t.objectMode?1:e!=e?t.flowing&&t.length?t.buffer.head.data.length:t.length:(e>t.highWaterMark&&(t.highWaterMark=function(e){return e>=M?e=M:(e--,e|=e>>>1,e|=e>>>2,e|=e>>>4,e|=e>>>8,e|=e>>>16,e++),e}(e)),e<=t.length?e:t.ended?t.length:(t.needReadable=true,0))}function x(e){var t=e._readableState;a("emitReadable",t.needReadable,t.emittedReadable),t.needReadable=false,t.emittedReadable||(a("emitReadable",t.flowing),t.emittedReadable=true,Ee(A,e));}function A(e){var t=e._readableState;a("emitReadable_",t.destroyed,t.length,t.ended),t.destroyed||!t.length&&!t.ended||(e.emit("readable"),t.emittedReadable=false),t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark,O(e);}function R(e,t){t.readingMore||(t.readingMore=true,Ee(T,e,t));}function T(e,t){for(;!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&0===t.length);){var n=t.length;if(a("maybeReadMore read 0"),e.read(0),n===t.length)break}t.readingMore=false;}function P(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0,t.resumeScheduled&&!t.paused?t.flowing=true:e.listenerCount("data")>0&&e.resume();}function L(e){a("readable nexttick read 0"),e.read(0);}function I(e,t){a("resume",t.reading),t.reading||e.read(0),t.resumeScheduled=false,e.emit("resume"),O(e),t.flowing&&!t.reading&&e.read(0);}function O(e){var t=e._readableState;for(a("flow",t.flowing);t.flowing&&null!==e.read(););}function N(e,t){return 0===t.length?null:(t.objectMode?n=t.buffer.shift():!e||e>=t.length?(n=t.decoder?t.buffer.join(""):1===t.buffer.length?t.buffer.first():t.buffer.concat(t.length),t.buffer.clear()):n=t.buffer.consume(e,t.decoder),n);var n;}function D(e){var t=e._readableState;a("endReadable",t.endEmitted),t.endEmitted||(t.ended=true,Ee(j,t,e));}function j(e,t){if(a("endReadableNT",e.endEmitted,e.length),!e.endEmitted&&0===e.length&&(e.endEmitted=true,t.readable=false,t.emit("end"),e.autoDestroy)){var n=t._writableState;(!n||n.autoDestroy&&n.finished)&&t.destroy();}}function B(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return  -1}return S.prototype.read=function(e){a("read",e),e=parseInt(e,10);var t=this._readableState,n=e;if(0!==e&&(t.emittedReadable=false),0===e&&t.needReadable&&((0!==t.highWaterMark?t.length>=t.highWaterMark:t.length>0)||t.ended))return a("read: emitReadable",t.length,t.ended),0===t.length&&t.ended?D(this):x(this),null;if(0===(e=C(e,t))&&t.ended)return 0===t.length&&D(this),null;var r,i=t.needReadable;return a("need readable",i),(0===t.length||t.length-e<t.highWaterMark)&&a("length less than watermark",i=true),t.ended||t.reading?a("reading or ended",i=false):i&&(a("do read"),t.reading=true,t.sync=true,0===t.length&&(t.needReadable=true),this._read(t.highWaterMark),t.sync=false,t.reading||(e=C(n,t))),null===(r=e>0?N(e,t):null)?(t.needReadable=t.length<=t.highWaterMark,e=0):(t.length-=e,t.awaitDrain=0),0===t.length&&(t.ended||(t.needReadable=true),n!==e&&t.ended&&D(this)),null!==r&&this.emit("data",r),r},S.prototype._read=function(e){y(this,new v("_read()"));},S.prototype.pipe=function(e,n){var r=this,i=this._readableState;switch(i.pipesCount){case 0:i.pipes=e;break;case 1:i.pipes=[i.pipes,e];break;default:i.pipes.push(e);}i.pipesCount+=1,a("pipe count=%d opts=%j",i.pipesCount,n);var o=(!n||false!==n.end)&&e!==je.stdout&&e!==je.stderr?u:m;function s(t,n){a("onunpipe"),t===r&&n&&false===n.hasUnpiped&&(n.hasUnpiped=true,a("cleanup"),e.removeListener("close",h),e.removeListener("finish",p),e.removeListener("drain",l),e.removeListener("error",f),e.removeListener("unpipe",s),r.removeListener("end",u),r.removeListener("end",m),r.removeListener("data",d),c=true,!i.awaitDrain||e._writableState&&!e._writableState.needDrain||l());}function u(){a("onend"),e.end();}i.endEmitted?Ee(o):r.once("end",o),e.on("unpipe",s);var l=function(e){return function(){var n=e._readableState;a("pipeOnDrain",n.awaitDrain),n.awaitDrain&&n.awaitDrain--,0===n.awaitDrain&&t(e,"data")&&(n.flowing=true,O(e));}}(r);e.on("drain",l);var c=false;function d(t){a("ondata");var n=e.write(t);a("dest.write",n),false===n&&((1===i.pipesCount&&i.pipes===e||i.pipesCount>1&&-1!==B(i.pipes,e))&&!c&&(a("false write response, pause",i.awaitDrain),i.awaitDrain++),r.pause());}function f(n){a("onerror",n),m(),e.removeListener("error",f),0===t(e,"error")&&y(e,n);}function h(){e.removeListener("finish",p),m();}function p(){a("onfinish"),e.removeListener("close",h),m();}function m(){a("unpipe"),r.unpipe(e);}return r.on("data",d),function(e,t,n){if("function"==typeof e.prependListener)return e.prependListener(t,n);e._events&&e._events[t]?Array.isArray(e._events[t])?e._events[t].unshift(n):e._events[t]=[n,e._events[t]]:e.on(t,n);}(e,"error",f),e.once("close",h),e.once("finish",p),e.emit("pipe",r),i.flowing||(a("pipe resume"),r.resume()),e},S.prototype.unpipe=function(e){var t=this._readableState,n={hasUnpiped:false};if(0===t.pipesCount)return this;if(1===t.pipesCount)return e&&e!==t.pipes||(e||(e=t.pipes),t.pipes=null,t.pipesCount=0,t.flowing=false,e&&e.emit("unpipe",this,n)),this;if(!e){var r=t.pipes,i=t.pipesCount;t.pipes=null,t.pipesCount=0,t.flowing=false;for(var o=0;o<i;o++)r[o].emit("unpipe",this,{hasUnpiped:false});return this}var a=B(t.pipes,e);return  -1===a||(t.pipes.splice(a,1),t.pipesCount-=1,1===t.pipesCount&&(t.pipes=t.pipes[0]),e.emit("unpipe",this,n)),this},S.prototype.on=function(e,t){var n=r.prototype.on.call(this,e,t),i=this._readableState;return "data"===e?(i.readableListening=this.listenerCount("readable")>0,false!==i.flowing&&this.resume()):"readable"===e&&(i.endEmitted||i.readableListening||(i.readableListening=i.needReadable=true,i.flowing=false,i.emittedReadable=false,a("on readable",i.length,i.reading),i.length?x(this):i.reading||Ee(L,this))),n},S.prototype.addListener=S.prototype.on,S.prototype.removeListener=function(e,t){var n=r.prototype.removeListener.call(this,e,t);return "readable"===e&&Ee(P,this),n},S.prototype.removeAllListeners=function(e){var t=r.prototype.removeAllListeners.apply(this,arguments);return "readable"!==e&&void 0!==e||Ee(P,this),t},S.prototype.resume=function(){var e=this._readableState;return e.flowing||(a("resume"),e.flowing=!e.readableListening,function(e,t){t.resumeScheduled||(t.resumeScheduled=true,Ee(I,e,t));}(this,e)),e.paused=false,this},S.prototype.pause=function(){return a("call pause flowing=%j",this._readableState.flowing),false!==this._readableState.flowing&&(a("pause"),this._readableState.flowing=false,this.emit("pause")),this._readableState.paused=true,this},S.prototype.wrap=function(e){var t=this,n=this._readableState,r=false;for(var i in e.on("end",(function(){if(a("wrapped end"),n.decoder&&!n.ended){var e=n.decoder.end();e&&e.length&&t.push(e);}t.push(null);})),e.on("data",(function(i){(a("wrapped data"),n.decoder&&(i=n.decoder.write(i)),n.objectMode&&null==i)||(n.objectMode||i&&i.length)&&(t.push(i)||(r=true,e.pause()));})),e) void 0===this[i]&&"function"==typeof e[i]&&(this[i]=function(t){return function(){return e[t].apply(e,arguments)}}(i));for(var o=0;o<w.length;o++)e.on(w[o],this.emit.bind(this,w[o]));return this._read=function(t){a("wrapped _read",t),r&&(r=false,e.resume());},this},"function"==typeof Symbol&&(S.prototype[Symbol.asyncIterator]=function(){return void 0===l&&(l=wn()),l(this)}),Object.defineProperty(S.prototype,"readableHighWaterMark",{enumerable:false,get:function(){return this._readableState.highWaterMark}}),Object.defineProperty(S.prototype,"readableBuffer",{enumerable:false,get:function(){return this._readableState&&this._readableState.buffer}}),Object.defineProperty(S.prototype,"readableFlowing",{enumerable:false,get:function(){return this._readableState.flowing},set:function(e){this._readableState&&(this._readableState.flowing=e);}}),S._fromList=N,Object.defineProperty(S.prototype,"readableLength",{enumerable:false,get:function(){return this._readableState.length}}),"function"==typeof Symbol&&(S.from=function(e,t){return void 0===c&&(c=gn?mn:(gn=1,mn=function(){throw new Error("Readable.from is not available in the browser")})),c(S,e,t)}),vn}var Sn=Tn,En=Vt.codes,kn=En.ERR_METHOD_NOT_IMPLEMENTED,Mn=En.ERR_MULTIPLE_CALLBACK,Cn=En.ERR_TRANSFORM_ALREADY_TRANSFORMING,xn=En.ERR_TRANSFORM_WITH_LENGTH_0,An=sn();function Rn(e,t){var n=this._transformState;n.transforming=false;var r=n.writecb;if(null===r)return this.emit("error",new Mn);n.writechunk=null,n.writecb=null,null!=t&&this.push(t),r(e);var i=this._readableState;i.reading=false,(i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark);}function Tn(e){if(!(this instanceof Tn))return new Tn(e);An.call(this,e),this._transformState={afterTransform:Rn.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null},this._readableState.needReadable=true,this._readableState.sync=false,e&&("function"==typeof e.transform&&(this._transform=e.transform),"function"==typeof e.flush&&(this._flush=e.flush)),this.on("prefinish",Pn);}function Pn(){var e=this;"function"!=typeof this._flush||this._readableState.destroyed?Ln(this,null,null):this._flush((function(t,n){Ln(e,t,n);}));}function Ln(e,t,n){if(t)return e.emit("error",t);if(null!=n&&e.push(n),e._writableState.length)throw new xn;if(e._transformState.transforming)throw new Cn;return e.push(null)}Ve(Tn,An),Tn.prototype.push=function(e,t){return this._transformState.needTransform=false,An.prototype.push.call(this,e,t)},Tn.prototype._transform=function(e,t,n){n(new kn("_transform()"));},Tn.prototype._write=function(e,t,n){var r=this._transformState;if(r.writecb=n,r.writechunk=e,r.writeencoding=t,!r.transforming){var i=this._readableState;(r.needTransform||i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark);}},Tn.prototype._read=function(e){var t=this._transformState;null===t.writechunk||t.transforming?t.needTransform=true:(t.transforming=true,this._transform(t.writechunk,t.writeencoding,t.afterTransform));},Tn.prototype._destroy=function(e,t){An.prototype._destroy.call(this,e,(function(e){t(e);}));};var In,On=Dn,Nn=Sn;function Dn(e){if(!(this instanceof Dn))return new Dn(e);Nn.call(this,e);}Ve(Dn,Nn),Dn.prototype._transform=function(e,t,n){n(null,e);};var jn=Vt.codes,Bn=jn.ERR_MISSING_ARGS,zn=jn.ERR_STREAM_DESTROYED;function Un(e){if(e)throw e}function Fn(e){e();}function Kn(e,t){return e.pipe(t)}var qn=function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];var r,i=function(e){return e.length?"function"!=typeof e[e.length-1]?Un:e.pop():Un}(t);if(Array.isArray(t[0])&&(t=t[0]),t.length<2)throw new Bn("streams");var o=t.map((function(e,n){var a=n<t.length-1;return function(e,t,n,r){r=function(e){var t=false;return function(){t||(t=true,e.apply(void 0,arguments));}}(r);var i=false;e.on("close",(function(){i=true;})),void 0===In&&(In=yn),In(e,{readable:t,writable:n},(function(e){if(e)return r(e);i=true,r();}));var o=false;return function(t){if(!i&&!o)return o=true,function(e){return e.setHeader&&"function"==typeof e.abort}(e)?e.abort():"function"==typeof e.destroy?e.destroy():void r(t||new zn("pipe"))}}(e,a,n>0,(function(e){r||(r=e),e&&o.forEach(Fn),a||(o.forEach(Fn),i(r));}))}));return t.reduce(Kn)};!function(e,t){(t=e.exports=_n()).Stream=t,t.Readable=t,t.Writable=an(),t.Duplex=sn(),t.Transform=Sn,t.PassThrough=On,t.finished=yn,t.pipeline=qn;}(Ye,Ye.exports);var Hn=Ye.exports,Wn=Ue().Buffer,$n=Hn.Transform;function Vn(e){$n.call(this),this._block=Wn.allocUnsafe(e),this._blockSize=e,this._blockOffset=0,this._length=[0,0,0,0],this._finalized=false;}Ve(Vn,$n),Vn.prototype._transform=function(e,t,n){var r=null;try{this.update(e,t);}catch(e){r=e;}n(r);},Vn.prototype._flush=function(e){var t=null;try{this.push(this.digest());}catch(e){t=e;}e(t);},Vn.prototype.update=function(e,t){if(function(e,t){if(!Wn.isBuffer(e)&&"string"!=typeof e)throw new TypeError(t+" must be a string or a buffer")}(e,"Data"),this._finalized)throw new Error("Digest already called");Wn.isBuffer(e)||(e=Wn.from(e,t));for(var n=this._block,r=0;this._blockOffset+e.length-r>=this._blockSize;){for(var i=this._blockOffset;i<this._blockSize;)n[i++]=e[r++];this._update(),this._blockOffset=0;}for(;r<e.length;)n[this._blockOffset++]=e[r++];for(var o=0,a=8*e.length;a>0;++o)this._length[o]+=a,(a=this._length[o]/4294967296|0)>0&&(this._length[o]-=4294967296*a);return this},Vn.prototype._update=function(){throw new Error("_update is not implemented")},Vn.prototype.digest=function(e){if(this._finalized)throw new Error("Digest already called");this._finalized=true;var t=this._digest();void 0!==e&&(t=t.toString(e)),this._block.fill(0),this._blockOffset=0;for(var n=0;n<4;++n)this._length[n]=0;return t},Vn.prototype._digest=function(){throw new Error("_digest is not implemented")};var Yn=Vn,Gn=Ve,Zn=Yn,Qn=Ue().Buffer,Jn=new Array(16);function Xn(){Zn.call(this,64),this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878;}function er(e,t){return e<<t|e>>>32-t}function tr(e,t,n,r,i,o,a){return er(e+(t&n|~t&r)+i+o|0,a)+t|0}function nr(e,t,n,r,i,o,a){return er(e+(t&r|n&~r)+i+o|0,a)+t|0}function rr(e,t,n,r,i,o,a){return er(e+(t^n^r)+i+o|0,a)+t|0}function ir(e,t,n,r,i,o,a){return er(e+(n^(t|~r))+i+o|0,a)+t|0}Gn(Xn,Zn),Xn.prototype._update=function(){for(var e=Jn,t=0;t<16;++t)e[t]=this._block.readInt32LE(4*t);var n=this._a,r=this._b,i=this._c,o=this._d;n=tr(n,r,i,o,e[0],3614090360,7),o=tr(o,n,r,i,e[1],3905402710,12),i=tr(i,o,n,r,e[2],606105819,17),r=tr(r,i,o,n,e[3],3250441966,22),n=tr(n,r,i,o,e[4],4118548399,7),o=tr(o,n,r,i,e[5],1200080426,12),i=tr(i,o,n,r,e[6],2821735955,17),r=tr(r,i,o,n,e[7],4249261313,22),n=tr(n,r,i,o,e[8],1770035416,7),o=tr(o,n,r,i,e[9],2336552879,12),i=tr(i,o,n,r,e[10],4294925233,17),r=tr(r,i,o,n,e[11],2304563134,22),n=tr(n,r,i,o,e[12],1804603682,7),o=tr(o,n,r,i,e[13],4254626195,12),i=tr(i,o,n,r,e[14],2792965006,17),n=nr(n,r=tr(r,i,o,n,e[15],1236535329,22),i,o,e[1],4129170786,5),o=nr(o,n,r,i,e[6],3225465664,9),i=nr(i,o,n,r,e[11],643717713,14),r=nr(r,i,o,n,e[0],3921069994,20),n=nr(n,r,i,o,e[5],3593408605,5),o=nr(o,n,r,i,e[10],38016083,9),i=nr(i,o,n,r,e[15],3634488961,14),r=nr(r,i,o,n,e[4],3889429448,20),n=nr(n,r,i,o,e[9],568446438,5),o=nr(o,n,r,i,e[14],3275163606,9),i=nr(i,o,n,r,e[3],4107603335,14),r=nr(r,i,o,n,e[8],1163531501,20),n=nr(n,r,i,o,e[13],2850285829,5),o=nr(o,n,r,i,e[2],4243563512,9),i=nr(i,o,n,r,e[7],1735328473,14),n=rr(n,r=nr(r,i,o,n,e[12],2368359562,20),i,o,e[5],4294588738,4),o=rr(o,n,r,i,e[8],2272392833,11),i=rr(i,o,n,r,e[11],1839030562,16),r=rr(r,i,o,n,e[14],4259657740,23),n=rr(n,r,i,o,e[1],2763975236,4),o=rr(o,n,r,i,e[4],1272893353,11),i=rr(i,o,n,r,e[7],4139469664,16),r=rr(r,i,o,n,e[10],3200236656,23),n=rr(n,r,i,o,e[13],681279174,4),o=rr(o,n,r,i,e[0],3936430074,11),i=rr(i,o,n,r,e[3],3572445317,16),r=rr(r,i,o,n,e[6],76029189,23),n=rr(n,r,i,o,e[9],3654602809,4),o=rr(o,n,r,i,e[12],3873151461,11),i=rr(i,o,n,r,e[15],530742520,16),n=ir(n,r=rr(r,i,o,n,e[2],3299628645,23),i,o,e[0],4096336452,6),o=ir(o,n,r,i,e[7],1126891415,10),i=ir(i,o,n,r,e[14],2878612391,15),r=ir(r,i,o,n,e[5],4237533241,21),n=ir(n,r,i,o,e[12],1700485571,6),o=ir(o,n,r,i,e[3],2399980690,10),i=ir(i,o,n,r,e[10],4293915773,15),r=ir(r,i,o,n,e[1],2240044497,21),n=ir(n,r,i,o,e[8],1873313359,6),o=ir(o,n,r,i,e[15],4264355552,10),i=ir(i,o,n,r,e[6],2734768916,15),r=ir(r,i,o,n,e[13],1309151649,21),n=ir(n,r,i,o,e[4],4149444226,6),o=ir(o,n,r,i,e[11],3174756917,10),i=ir(i,o,n,r,e[2],718787259,15),r=ir(r,i,o,n,e[9],3951481745,21),this._a=this._a+n|0,this._b=this._b+r|0,this._c=this._c+i|0,this._d=this._d+o|0;},Xn.prototype._digest=function(){this._block[this._blockOffset++]=128,this._blockOffset>56&&(this._block.fill(0,this._blockOffset,64),this._update(),this._blockOffset=0),this._block.fill(0,this._blockOffset,56),this._block.writeUInt32LE(this._length[0],56),this._block.writeUInt32LE(this._length[1],60),this._update();var e=Qn.allocUnsafe(16);return e.writeInt32LE(this._a,0),e.writeInt32LE(this._b,4),e.writeInt32LE(this._c,8),e.writeInt32LE(this._d,12),e};var or=Xn,ar=ce.Buffer,sr=Ve,ur=Yn,lr=new Array(16),cr=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13],dr=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11],fr=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6],hr=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11],pr=[0,1518500249,1859775393,2400959708,2840853838],mr=[1352829926,1548603684,1836072691,2053994217,0];function gr(){ur.call(this,64),this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520;}function vr(e,t){return e<<t|e>>>32-t}function br(e,t,n,r,i,o,a,s){return vr(e+(t^n^r)+o+a|0,s)+i|0}function yr(e,t,n,r,i,o,a,s){return vr(e+(t&n|~t&r)+o+a|0,s)+i|0}function wr(e,t,n,r,i,o,a,s){return vr(e+((t|~n)^r)+o+a|0,s)+i|0}function _r(e,t,n,r,i,o,a,s){return vr(e+(t&r|n&~r)+o+a|0,s)+i|0}function Sr(e,t,n,r,i,o,a,s){return vr(e+(t^(n|~r))+o+a|0,s)+i|0}sr(gr,ur),gr.prototype._update=function(){for(var e=lr,t=0;t<16;++t)e[t]=this._block.readInt32LE(4*t);for(var n=0|this._a,r=0|this._b,i=0|this._c,o=0|this._d,a=0|this._e,s=0|this._a,u=0|this._b,l=0|this._c,c=0|this._d,d=0|this._e,f=0;f<80;f+=1){var h,p;f<16?(h=br(n,r,i,o,a,e[cr[f]],pr[0],fr[f]),p=Sr(s,u,l,c,d,e[dr[f]],mr[0],hr[f])):f<32?(h=yr(n,r,i,o,a,e[cr[f]],pr[1],fr[f]),p=_r(s,u,l,c,d,e[dr[f]],mr[1],hr[f])):f<48?(h=wr(n,r,i,o,a,e[cr[f]],pr[2],fr[f]),p=wr(s,u,l,c,d,e[dr[f]],mr[2],hr[f])):f<64?(h=_r(n,r,i,o,a,e[cr[f]],pr[3],fr[f]),p=yr(s,u,l,c,d,e[dr[f]],mr[3],hr[f])):(h=Sr(n,r,i,o,a,e[cr[f]],pr[4],fr[f]),p=br(s,u,l,c,d,e[dr[f]],mr[4],hr[f])),n=a,a=o,o=vr(i,10),i=r,r=h,s=d,d=c,c=vr(l,10),l=u,u=p;}var m=this._b+i+c|0;this._b=this._c+o+d|0,this._c=this._d+a+s|0,this._d=this._e+n+u|0,this._e=this._a+r+l|0,this._a=m;},gr.prototype._digest=function(){this._block[this._blockOffset++]=128,this._blockOffset>56&&(this._block.fill(0,this._blockOffset,64),this._update(),this._blockOffset=0),this._block.fill(0,this._blockOffset,56),this._block.writeUInt32LE(this._length[0],56),this._block.writeUInt32LE(this._length[1],60),this._update();var e=ar.alloc?ar.alloc(20):new ar(20);return e.writeInt32LE(this._a,0),e.writeInt32LE(this._b,4),e.writeInt32LE(this._c,8),e.writeInt32LE(this._d,12),e.writeInt32LE(this._e,16),e};var Er=gr,kr={exports:{}},Mr=Ue().Buffer;function Cr(e,t){this._block=Mr.alloc(e),this._finalSize=t,this._blockSize=e,this._len=0;}Cr.prototype.update=function(e,t){"string"==typeof e&&(t=t||"utf8",e=Mr.from(e,t));for(var n=this._block,r=this._blockSize,i=e.length,o=this._len,a=0;a<i;){for(var s=o%r,u=Math.min(i-a,r-s),l=0;l<u;l++)n[s+l]=e[a+l];a+=u,(o+=u)%r==0&&this._update(n);}return this._len+=i,this},Cr.prototype.digest=function(e){var t=this._len%this._blockSize;this._block[t]=128,this._block.fill(0,t+1),t>=this._finalSize&&(this._update(this._block),this._block.fill(0));var n=8*this._len;if(n<=4294967295)this._block.writeUInt32BE(n,this._blockSize-4);else {var r=(4294967295&n)>>>0,i=(n-r)/4294967296;this._block.writeUInt32BE(i,this._blockSize-8),this._block.writeUInt32BE(r,this._blockSize-4);}this._update(this._block);var o=this._hash();return e?o.toString(e):o},Cr.prototype._update=function(){throw new Error("_update must be implemented by subclass")};var xr=Cr,Ar=Ve,Rr=xr,Tr=Ue().Buffer,Pr=[1518500249,1859775393,-1894007588,-899497514],Lr=new Array(80);function Ir(){this.init(),this._w=Lr,Rr.call(this,64,56);}function Or(e){return e<<30|e>>>2}function Nr(e,t,n,r){return 0===e?t&n|~t&r:2===e?t&n|t&r|n&r:t^n^r}Ar(Ir,Rr),Ir.prototype.init=function(){return this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520,this},Ir.prototype._update=function(e){for(var t,n=this._w,r=0|this._a,i=0|this._b,o=0|this._c,a=0|this._d,s=0|this._e,u=0;u<16;++u)n[u]=e.readInt32BE(4*u);for(;u<80;++u)n[u]=n[u-3]^n[u-8]^n[u-14]^n[u-16];for(var l=0;l<80;++l){var c=~~(l/20),d=0|((t=r)<<5|t>>>27)+Nr(c,i,o,a)+s+n[l]+Pr[c];s=a,a=o,o=Or(i),i=r,r=d;}this._a=r+this._a|0,this._b=i+this._b|0,this._c=o+this._c|0,this._d=a+this._d|0,this._e=s+this._e|0;},Ir.prototype._hash=function(){var e=Tr.allocUnsafe(20);return e.writeInt32BE(0|this._a,0),e.writeInt32BE(0|this._b,4),e.writeInt32BE(0|this._c,8),e.writeInt32BE(0|this._d,12),e.writeInt32BE(0|this._e,16),e};var Dr=Ir,jr=Ve,Br=xr,zr=Ue().Buffer,Ur=[1518500249,1859775393,-1894007588,-899497514],Fr=new Array(80);function Kr(){this.init(),this._w=Fr,Br.call(this,64,56);}function qr(e){return e<<5|e>>>27}function Hr(e){return e<<30|e>>>2}function Wr(e,t,n,r){return 0===e?t&n|~t&r:2===e?t&n|t&r|n&r:t^n^r}jr(Kr,Br),Kr.prototype.init=function(){return this._a=1732584193,this._b=4023233417,this._c=2562383102,this._d=271733878,this._e=3285377520,this},Kr.prototype._update=function(e){for(var t,n=this._w,r=0|this._a,i=0|this._b,o=0|this._c,a=0|this._d,s=0|this._e,u=0;u<16;++u)n[u]=e.readInt32BE(4*u);for(;u<80;++u)n[u]=(t=n[u-3]^n[u-8]^n[u-14]^n[u-16])<<1|t>>>31;for(var l=0;l<80;++l){var c=~~(l/20),d=qr(r)+Wr(c,i,o,a)+s+n[l]+Ur[c]|0;s=a,a=o,o=Hr(i),i=r,r=d;}this._a=r+this._a|0,this._b=i+this._b|0,this._c=o+this._c|0,this._d=a+this._d|0,this._e=s+this._e|0;},Kr.prototype._hash=function(){var e=zr.allocUnsafe(20);return e.writeInt32BE(0|this._a,0),e.writeInt32BE(0|this._b,4),e.writeInt32BE(0|this._c,8),e.writeInt32BE(0|this._d,12),e.writeInt32BE(0|this._e,16),e};var $r=Kr,Vr=Ve,Yr=xr,Gr=Ue().Buffer,Zr=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298],Qr=new Array(64);function Jr(){this.init(),this._w=Qr,Yr.call(this,64,56);}function Xr(e,t,n){return n^e&(t^n)}function ei(e,t,n){return e&t|n&(e|t)}function ti(e){return (e>>>2|e<<30)^(e>>>13|e<<19)^(e>>>22|e<<10)}function ni(e){return (e>>>6|e<<26)^(e>>>11|e<<21)^(e>>>25|e<<7)}function ri(e){return (e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3}function ii(e){return (e>>>17|e<<15)^(e>>>19|e<<13)^e>>>10}Vr(Jr,Yr),Jr.prototype.init=function(){return this._a=1779033703,this._b=3144134277,this._c=1013904242,this._d=2773480762,this._e=1359893119,this._f=2600822924,this._g=528734635,this._h=1541459225,this},Jr.prototype._update=function(e){for(var t=this._w,n=0|this._a,r=0|this._b,i=0|this._c,o=0|this._d,a=0|this._e,s=0|this._f,u=0|this._g,l=0|this._h,c=0;c<16;++c)t[c]=e.readInt32BE(4*c);for(;c<64;++c)t[c]=ii(t[c-2])+t[c-7]+ri(t[c-15])+t[c-16]|0;for(var d=0;d<64;++d){var f=l+ni(a)+Xr(a,s,u)+Zr[d]+t[d]|0,h=ti(n)+ei(n,r,i)|0;l=u,u=s,s=a,a=o+f|0,o=i,i=r,r=n,n=f+h|0;}this._a=n+this._a|0,this._b=r+this._b|0,this._c=i+this._c|0,this._d=o+this._d|0,this._e=a+this._e|0,this._f=s+this._f|0,this._g=u+this._g|0,this._h=l+this._h|0;},Jr.prototype._hash=function(){var e=Gr.allocUnsafe(32);return e.writeInt32BE(this._a,0),e.writeInt32BE(this._b,4),e.writeInt32BE(this._c,8),e.writeInt32BE(this._d,12),e.writeInt32BE(this._e,16),e.writeInt32BE(this._f,20),e.writeInt32BE(this._g,24),e.writeInt32BE(this._h,28),e};var oi=Jr,ai=Ve,si=oi,ui=xr,li=Ue().Buffer,ci=new Array(64);function di(){this.init(),this._w=ci,ui.call(this,64,56);}ai(di,si),di.prototype.init=function(){return this._a=3238371032,this._b=914150663,this._c=812702999,this._d=4144912697,this._e=4290775857,this._f=1750603025,this._g=1694076839,this._h=3204075428,this},di.prototype._hash=function(){var e=li.allocUnsafe(28);return e.writeInt32BE(this._a,0),e.writeInt32BE(this._b,4),e.writeInt32BE(this._c,8),e.writeInt32BE(this._d,12),e.writeInt32BE(this._e,16),e.writeInt32BE(this._f,20),e.writeInt32BE(this._g,24),e};var fi=di,hi=Ve,pi=xr,mi=Ue().Buffer,gi=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591],vi=new Array(160);function bi(){this.init(),this._w=vi,pi.call(this,128,112);}function yi(e,t,n){return n^e&(t^n)}function wi(e,t,n){return e&t|n&(e|t)}function _i(e,t){return (e>>>28|t<<4)^(t>>>2|e<<30)^(t>>>7|e<<25)}function Si(e,t){return (e>>>14|t<<18)^(e>>>18|t<<14)^(t>>>9|e<<23)}function Ei(e,t){return (e>>>1|t<<31)^(e>>>8|t<<24)^e>>>7}function ki(e,t){return (e>>>1|t<<31)^(e>>>8|t<<24)^(e>>>7|t<<25)}function Mi(e,t){return (e>>>19|t<<13)^(t>>>29|e<<3)^e>>>6}function Ci(e,t){return (e>>>19|t<<13)^(t>>>29|e<<3)^(e>>>6|t<<26)}function xi(e,t){return e>>>0<t>>>0?1:0}hi(bi,pi),bi.prototype.init=function(){return this._ah=1779033703,this._bh=3144134277,this._ch=1013904242,this._dh=2773480762,this._eh=1359893119,this._fh=2600822924,this._gh=528734635,this._hh=1541459225,this._al=4089235720,this._bl=2227873595,this._cl=4271175723,this._dl=1595750129,this._el=2917565137,this._fl=725511199,this._gl=4215389547,this._hl=327033209,this},bi.prototype._update=function(e){for(var t=this._w,n=0|this._ah,r=0|this._bh,i=0|this._ch,o=0|this._dh,a=0|this._eh,s=0|this._fh,u=0|this._gh,l=0|this._hh,c=0|this._al,d=0|this._bl,f=0|this._cl,h=0|this._dl,p=0|this._el,m=0|this._fl,g=0|this._gl,v=0|this._hl,b=0;b<32;b+=2)t[b]=e.readInt32BE(4*b),t[b+1]=e.readInt32BE(4*b+4);for(;b<160;b+=2){var y=t[b-30],w=t[b-30+1],_=Ei(y,w),S=ki(w,y),E=Mi(y=t[b-4],w=t[b-4+1]),k=Ci(w,y),M=t[b-14],C=t[b-14+1],x=t[b-32],A=t[b-32+1],R=S+C|0,T=_+M+xi(R,S)|0;T=(T=T+E+xi(R=R+k|0,k)|0)+x+xi(R=R+A|0,A)|0,t[b]=T,t[b+1]=R;}for(var P=0;P<160;P+=2){T=t[P],R=t[P+1];var L=wi(n,r,i),I=wi(c,d,f),O=_i(n,c),N=_i(c,n),D=Si(a,p),j=Si(p,a),B=gi[P],z=gi[P+1],U=yi(a,s,u),F=yi(p,m,g),K=v+j|0,q=l+D+xi(K,v)|0;q=(q=(q=q+U+xi(K=K+F|0,F)|0)+B+xi(K=K+z|0,z)|0)+T+xi(K=K+R|0,R)|0;var H=N+I|0,W=O+L+xi(H,N)|0;l=u,v=g,u=s,g=m,s=a,m=p,a=o+q+xi(p=h+K|0,h)|0,o=i,h=f,i=r,f=d,r=n,d=c,n=q+W+xi(c=K+H|0,K)|0;}this._al=this._al+c|0,this._bl=this._bl+d|0,this._cl=this._cl+f|0,this._dl=this._dl+h|0,this._el=this._el+p|0,this._fl=this._fl+m|0,this._gl=this._gl+g|0,this._hl=this._hl+v|0,this._ah=this._ah+n+xi(this._al,c)|0,this._bh=this._bh+r+xi(this._bl,d)|0,this._ch=this._ch+i+xi(this._cl,f)|0,this._dh=this._dh+o+xi(this._dl,h)|0,this._eh=this._eh+a+xi(this._el,p)|0,this._fh=this._fh+s+xi(this._fl,m)|0,this._gh=this._gh+u+xi(this._gl,g)|0,this._hh=this._hh+l+xi(this._hl,v)|0;},bi.prototype._hash=function(){var e=mi.allocUnsafe(64);function t(t,n,r){e.writeInt32BE(t,r),e.writeInt32BE(n,r+4);}return t(this._ah,this._al,0),t(this._bh,this._bl,8),t(this._ch,this._cl,16),t(this._dh,this._dl,24),t(this._eh,this._el,32),t(this._fh,this._fl,40),t(this._gh,this._gl,48),t(this._hh,this._hl,56),e};var Ai=bi,Ri=Ve,Ti=Ai,Pi=xr,Li=Ue().Buffer,Ii=new Array(160);function Oi(){this.init(),this._w=Ii,Pi.call(this,128,112);}Ri(Oi,Ti),Oi.prototype.init=function(){return this._ah=3418070365,this._bh=1654270250,this._ch=2438529370,this._dh=355462360,this._eh=1731405415,this._fh=2394180231,this._gh=3675008525,this._hh=1203062813,this._al=3238371032,this._bl=914150663,this._cl=812702999,this._dl=4144912697,this._el=4290775857,this._fl=1750603025,this._gl=1694076839,this._hl=3204075428,this},Oi.prototype._hash=function(){var e=Li.allocUnsafe(48);function t(t,n,r){e.writeInt32BE(t,r),e.writeInt32BE(n,r+4);}return t(this._ah,this._al,0),t(this._bh,this._bl,8),t(this._ch,this._cl,16),t(this._dh,this._dl,24),t(this._eh,this._el,32),t(this._fh,this._fl,40),e};var Ni=Oi,Di=kr.exports=function(e){e=e.toLowerCase();var t=Di[e];if(!t)throw new Error(e+" is not supported (we accept pull requests)");return new t};Di.sha=Dr,Di.sha1=$r,Di.sha224=fi,Di.sha256=oi,Di.sha384=Ni,Di.sha512=Ai;var ji=kr.exports;function Bi(){this.head=null,this.tail=null,this.length=0;}Bi.prototype.push=function(e){var t={data:e,next:null};this.length>0?this.tail.next=t:this.head=t,this.tail=t,++this.length;},Bi.prototype.unshift=function(e){var t={data:e,next:this.head};0===this.length&&(this.tail=t),this.head=t,++this.length;},Bi.prototype.shift=function(){if(0!==this.length){var e=this.head.data;return 1===this.length?this.head=this.tail=null:this.head=this.head.next,--this.length,e}},Bi.prototype.clear=function(){this.head=this.tail=null,this.length=0;},Bi.prototype.join=function(e){if(0===this.length)return "";for(var t=this.head,n=""+t.data;t=t.next;)n+=e+t.data;return n},Bi.prototype.concat=function(e){if(0===this.length)return _.alloc(0);if(1===this.length)return this.head.data;for(var t=_.allocUnsafe(e>>>0),n=this.head,r=0;n;)n.data.copy(t,r),r+=n.data.length,n=n.next;return t};var zi=_.isEncoding||function(e){switch(e&&e.toLowerCase()){case "hex":case "utf8":case "utf-8":case "ascii":case "binary":case "base64":case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":case "raw":return  true;default:return  false}};function Ui(e){switch(this.encoding=(e||"utf8").toLowerCase().replace(/[-_]/,""),function(e){if(e&&!zi(e))throw new Error("Unknown encoding: "+e)}(e),this.encoding){case "utf8":this.surrogateSize=3;break;case "ucs2":case "utf16le":this.surrogateSize=2,this.detectIncompleteChar=Ki;break;case "base64":this.surrogateSize=3,this.detectIncompleteChar=qi;break;default:return void(this.write=Fi)}this.charBuffer=new _(6),this.charReceived=0,this.charLength=0;}function Fi(e){return e.toString(this.encoding)}function Ki(e){this.charReceived=e.length%2,this.charLength=this.charReceived?2:0;}function qi(e){this.charReceived=e.length%3,this.charLength=this.charReceived?3:0;}Ui.prototype.write=function(e){for(var t="";this.charLength;){var n=e.length>=this.charLength-this.charReceived?this.charLength-this.charReceived:e.length;if(e.copy(this.charBuffer,this.charReceived,0,n),this.charReceived+=n,this.charReceived<this.charLength)return "";if(e=e.slice(n,e.length),!((i=(t=this.charBuffer.slice(0,this.charLength).toString(this.encoding)).charCodeAt(t.length-1))>=55296&&i<=56319)){if(this.charReceived=this.charLength=0,0===e.length)return t;break}this.charLength+=this.surrogateSize,t="";}this.detectIncompleteChar(e);var r=e.length;this.charLength&&(e.copy(this.charBuffer,0,e.length-this.charReceived,r),r-=this.charReceived);var i;r=(t+=e.toString(this.encoding,0,r)).length-1;if((i=t.charCodeAt(r))>=55296&&i<=56319){var o=this.surrogateSize;return this.charLength+=o,this.charReceived+=o,this.charBuffer.copy(this.charBuffer,o,0,o),e.copy(this.charBuffer,0,0,o),t.substring(0,r)}return t},Ui.prototype.detectIncompleteChar=function(e){for(var t=e.length>=3?3:e.length;t>0;t--){var n=e[e.length-t];if(1==t&&n>>5==6){this.charLength=2;break}if(t<=2&&n>>4==14){this.charLength=3;break}if(t<=3&&n>>3==30){this.charLength=4;break}}this.charReceived=t;},Ui.prototype.end=function(e){var t="";if(e&&e.length&&(t=this.write(e)),this.charReceived){var n=this.charReceived,r=this.charBuffer,i=this.encoding;t+=r.slice(0,n).toString(i);}return t};var Hi=Object.freeze({__proto__:null,StringDecoder:Ui});Vi.ReadableState=$i;var Wi=ct("stream");function $i(e,t){e=e||{},this.objectMode=!!e.objectMode,t instanceof So&&(this.objectMode=this.objectMode||!!e.readableObjectMode);var n=e.highWaterMark,r=this.objectMode?16:16384;this.highWaterMark=n||0===n?n:r,this.highWaterMark=~~this.highWaterMark,this.buffer=new Bi,this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=false,this.endEmitted=false,this.reading=false,this.sync=true,this.needReadable=false,this.emittedReadable=false,this.readableListening=false,this.resumeScheduled=false,this.defaultEncoding=e.defaultEncoding||"utf8",this.ranOut=false,this.awaitDrain=0,this.readingMore=false,this.decoder=null,this.encoding=null,e.encoding&&(this.decoder=new Ui(e.encoding),this.encoding=e.encoding);}function Vi(e){if(!(this instanceof Vi))return new Vi(e);this._readableState=new $i(e,this),this.readable=true,e&&"function"==typeof e.read&&(this._read=e.read),Ze.call(this);}function Yi(e,t,n,r,i){var o=function(e,t){var n=null;ie(t)||"string"==typeof t||null==t||e.objectMode||(n=new TypeError("Invalid non-string/buffer chunk"));return n}(t,n);if(o)e.emit("error",o);else if(null===n)t.reading=false,function(e,t){if(t.ended)return;if(t.decoder){var n=t.decoder.end();n&&n.length&&(t.buffer.push(n),t.length+=t.objectMode?1:n.length);}t.ended=true,Qi(e);}(e,t);else if(t.objectMode||n&&n.length>0)if(t.ended&&!i){var a=new Error("stream.push() after EOF");e.emit("error",a);}else if(t.endEmitted&&i){var s=new Error("stream.unshift() after end event");e.emit("error",s);}else {var u;!t.decoder||i||r||(n=t.decoder.write(n),u=!t.objectMode&&0===n.length),i||(t.reading=false),u||(t.flowing&&0===t.length&&!t.sync?(e.emit("data",n),e.read(0)):(t.length+=t.objectMode?1:n.length,i?t.buffer.unshift(n):t.buffer.push(n),t.needReadable&&Qi(e))),function(e,t){t.readingMore||(t.readingMore=true,Ee(Xi,e,t));}(e,t);}else i||(t.reading=false);return function(e){return !e.ended&&(e.needReadable||e.length<e.highWaterMark||0===e.length)}(t)}it(Vi,Ze),Vi.prototype.push=function(e,t){var n=this._readableState;return n.objectMode||"string"!=typeof e||(t=t||n.defaultEncoding)!==n.encoding&&(e=_.from(e,t),t=""),Yi(this,n,e,t,false)},Vi.prototype.unshift=function(e){return Yi(this,this._readableState,e,"",true)},Vi.prototype.isPaused=function(){return  false===this._readableState.flowing},Vi.prototype.setEncoding=function(e){return this._readableState.decoder=new Ui(e),this._readableState.encoding=e,this};var Gi=8388608;function Zi(e,t){return e<=0||0===t.length&&t.ended?0:t.objectMode?1:e!=e?t.flowing&&t.length?t.buffer.head.data.length:t.length:(e>t.highWaterMark&&(t.highWaterMark=function(e){return e>=Gi?e=Gi:(e--,e|=e>>>1,e|=e>>>2,e|=e>>>4,e|=e>>>8,e|=e>>>16,e++),e}(e)),e<=t.length?e:t.ended?t.length:(t.needReadable=true,0))}function Qi(e){var t=e._readableState;t.needReadable=false,t.emittedReadable||(Wi("emitReadable",t.flowing),t.emittedReadable=true,t.sync?Ee(Ji,e):Ji(e));}function Ji(e){Wi("emit readable"),e.emit("readable"),no(e);}function Xi(e,t){for(var n=t.length;!t.reading&&!t.flowing&&!t.ended&&t.length<t.highWaterMark&&(Wi("maybeReadMore read 0"),e.read(0),n!==t.length);)n=t.length;t.readingMore=false;}function eo(e){Wi("readable nexttick read 0"),e.read(0);}function to(e,t){t.reading||(Wi("resume read 0"),e.read(0)),t.resumeScheduled=false,t.awaitDrain=0,e.emit("resume"),no(e),t.flowing&&!t.reading&&e.read(0);}function no(e){var t=e._readableState;for(Wi("flow",t.flowing);t.flowing&&null!==e.read(););}function ro(e,t){return 0===t.length?null:(t.objectMode?n=t.buffer.shift():!e||e>=t.length?(n=t.decoder?t.buffer.join(""):1===t.buffer.length?t.buffer.head.data:t.buffer.concat(t.length),t.buffer.clear()):n=function(e,t,n){var r;e<t.head.data.length?(r=t.head.data.slice(0,e),t.head.data=t.head.data.slice(e)):r=e===t.head.data.length?t.shift():n?function(e,t){var n=t.head,r=1,i=n.data;e-=i.length;for(;n=n.next;){var o=n.data,a=e>o.length?o.length:e;if(a===o.length?i+=o:i+=o.slice(0,e),0===(e-=a)){a===o.length?(++r,n.next?t.head=n.next:t.head=t.tail=null):(t.head=n,n.data=o.slice(a));break}++r;}return t.length-=r,i}(e,t):function(e,t){var n=_.allocUnsafe(e),r=t.head,i=1;r.data.copy(n),e-=r.data.length;for(;r=r.next;){var o=r.data,a=e>o.length?o.length:e;if(o.copy(n,n.length-e,0,a),0===(e-=a)){a===o.length?(++i,r.next?t.head=r.next:t.head=t.tail=null):(t.head=r,r.data=o.slice(a));break}++i;}return t.length-=i,n}(e,t);return r}(e,t.buffer,t.decoder),n);var n;}function io(e){var t=e._readableState;if(t.length>0)throw new Error('"endReadable()" called on non-empty stream');t.endEmitted||(t.ended=true,Ee(oo,t,e));}function oo(e,t){e.endEmitted||0!==e.length||(e.endEmitted=true,t.readable=false,t.emit("end"));}function ao(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return  -1}function so(){}function uo(e,t,n){this.chunk=e,this.encoding=t,this.callback=n,this.next=null;}function lo(e,t){Object.defineProperty(this,"buffer",{get:st((function(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")}),e=e||{},this.objectMode=!!e.objectMode,t instanceof So&&(this.objectMode=this.objectMode||!!e.writableObjectMode);var n=e.highWaterMark,r=this.objectMode?16:16384;this.highWaterMark=n||0===n?n:r,this.highWaterMark=~~this.highWaterMark,this.needDrain=false,this.ending=false,this.ended=false,this.finished=false;var i=false===e.decodeStrings;this.decodeStrings=!i,this.defaultEncoding=e.defaultEncoding||"utf8",this.length=0,this.writing=false,this.corked=0,this.sync=true,this.bufferProcessing=false,this.onwrite=function(e){!function(e,t){var n=e._writableState,r=n.sync,i=n.writecb;if(function(e){e.writing=false,e.writecb=null,e.length-=e.writelen,e.writelen=0;}(n),t)!function(e,t,n,r,i){--t.pendingcb,n?Ee(i,r):i(r);e._writableState.errorEmitted=true,e.emit("error",r);}(e,n,r,t,i);else {var o=mo(n);o||n.corked||n.bufferProcessing||!n.bufferedRequest||po(e,n),r?Ee(ho,e,n,o,i):ho(e,n,o,i);}}(t,e);},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=false,this.errorEmitted=false,this.bufferedRequestCount=0,this.corkedRequestsFree=new bo(this);}function co(e){if(!(this instanceof co||this instanceof So))return new co(e);this._writableState=new lo(e,this),this.writable=true,e&&("function"==typeof e.write&&(this._write=e.write),"function"==typeof e.writev&&(this._writev=e.writev)),Ze.call(this);}function fo(e,t,n,r,i,o,a){t.writelen=r,t.writecb=a,t.writing=true,t.sync=true,n?e._writev(i,t.onwrite):e._write(i,o,t.onwrite),t.sync=false;}function ho(e,t,n,r){n||function(e,t){0===t.length&&t.needDrain&&(t.needDrain=false,e.emit("drain"));}(e,t),t.pendingcb--,r(),vo(e,t);}function po(e,t){t.bufferProcessing=true;var n=t.bufferedRequest;if(e._writev&&n&&n.next){var r=t.bufferedRequestCount,i=new Array(r),o=t.corkedRequestsFree;o.entry=n;for(var a=0;n;)i[a]=n,n=n.next,a+=1;fo(e,t,true,t.length,i,"",o.finish),t.pendingcb++,t.lastBufferedRequest=null,o.next?(t.corkedRequestsFree=o.next,o.next=null):t.corkedRequestsFree=new bo(t);}else {for(;n;){var s=n.chunk,u=n.encoding,l=n.callback;if(fo(e,t,false,t.objectMode?1:s.length,s,u,l),n=n.next,t.writing)break}null===n&&(t.lastBufferedRequest=null);}t.bufferedRequestCount=0,t.bufferedRequest=n,t.bufferProcessing=false;}function mo(e){return e.ending&&0===e.length&&null===e.bufferedRequest&&!e.finished&&!e.writing}function go(e,t){t.prefinished||(t.prefinished=true,e.emit("prefinish"));}function vo(e,t){var n=mo(t);return n&&(0===t.pendingcb?(go(e,t),t.finished=true,e.emit("finish")):go(e,t)),n}function bo(e){var t=this;this.next=null,this.entry=null,this.finish=function(n){var r=t.entry;for(t.entry=null;r;){var i=r.callback;e.pendingcb--,i(n),r=r.next;}e.corkedRequestsFree?e.corkedRequestsFree.next=t:e.corkedRequestsFree=t;};}Vi.prototype.read=function(e){Wi("read",e),e=parseInt(e,10);var t=this._readableState,n=e;if(0!==e&&(t.emittedReadable=false),0===e&&t.needReadable&&(t.length>=t.highWaterMark||t.ended))return Wi("read: emitReadable",t.length,t.ended),0===t.length&&t.ended?io(this):Qi(this),null;if(0===(e=Zi(e,t))&&t.ended)return 0===t.length&&io(this),null;var r,i=t.needReadable;return Wi("need readable",i),(0===t.length||t.length-e<t.highWaterMark)&&Wi("length less than watermark",i=true),t.ended||t.reading?Wi("reading or ended",i=false):i&&(Wi("do read"),t.reading=true,t.sync=true,0===t.length&&(t.needReadable=true),this._read(t.highWaterMark),t.sync=false,t.reading||(e=Zi(n,t))),null===(r=e>0?ro(e,t):null)?(t.needReadable=true,e=0):t.length-=e,0===t.length&&(t.ended||(t.needReadable=true),n!==e&&t.ended&&io(this)),null!==r&&this.emit("data",r),r},Vi.prototype._read=function(e){this.emit("error",new Error("not implemented"));},Vi.prototype.pipe=function(e,t){var n=this,r=this._readableState;switch(r.pipesCount){case 0:r.pipes=e;break;case 1:r.pipes=[r.pipes,e];break;default:r.pipes.push(e);}r.pipesCount+=1,Wi("pipe count=%d opts=%j",r.pipesCount,t);var i=!t||false!==t.end?a:l;function o(e){Wi("onunpipe"),e===n&&l();}function a(){Wi("onend"),e.end();}r.endEmitted?Ee(i):n.once("end",i),e.on("unpipe",o);var s=function(e){return function(){var t=e._readableState;Wi("pipeOnDrain",t.awaitDrain),t.awaitDrain&&t.awaitDrain--,0===t.awaitDrain&&e.listeners("data").length&&(t.flowing=true,no(e));}}(n);e.on("drain",s);var u=false;function l(){Wi("cleanup"),e.removeListener("close",h),e.removeListener("finish",p),e.removeListener("drain",s),e.removeListener("error",f),e.removeListener("unpipe",o),n.removeListener("end",a),n.removeListener("end",l),n.removeListener("data",d),u=true,!r.awaitDrain||e._writableState&&!e._writableState.needDrain||s();}var c=false;function d(t){Wi("ondata"),c=false,false!==e.write(t)||c||((1===r.pipesCount&&r.pipes===e||r.pipesCount>1&&-1!==ao(r.pipes,e))&&!u&&(Wi("false write response, pause",n._readableState.awaitDrain),n._readableState.awaitDrain++,c=true),n.pause());}function f(t){var n;Wi("onerror",t),m(),e.removeListener("error",f),0===(n="error",e.listeners(n).length)&&e.emit("error",t);}function h(){e.removeListener("finish",p),m();}function p(){Wi("onfinish"),e.removeListener("close",h),m();}function m(){Wi("unpipe"),n.unpipe(e);}return n.on("data",d),function(e,t,n){if("function"==typeof e.prependListener)return e.prependListener(t,n);e._events&&e._events[t]?Array.isArray(e._events[t])?e._events[t].unshift(n):e._events[t]=[n,e._events[t]]:e.on(t,n);}(e,"error",f),e.once("close",h),e.once("finish",p),e.emit("pipe",n),r.flowing||(Wi("pipe resume"),n.resume()),e},Vi.prototype.unpipe=function(e){var t=this._readableState;if(0===t.pipesCount)return this;if(1===t.pipesCount)return e&&e!==t.pipes||(e||(e=t.pipes),t.pipes=null,t.pipesCount=0,t.flowing=false,e&&e.emit("unpipe",this)),this;if(!e){var n=t.pipes,r=t.pipesCount;t.pipes=null,t.pipesCount=0,t.flowing=false;for(var i=0;i<r;i++)n[i].emit("unpipe",this);return this}var o=ao(t.pipes,e);return  -1===o||(t.pipes.splice(o,1),t.pipesCount-=1,1===t.pipesCount&&(t.pipes=t.pipes[0]),e.emit("unpipe",this)),this},Vi.prototype.on=function(e,t){var n=Ze.prototype.on.call(this,e,t);if("data"===e) false!==this._readableState.flowing&&this.resume();else if("readable"===e){var r=this._readableState;r.endEmitted||r.readableListening||(r.readableListening=r.needReadable=true,r.emittedReadable=false,r.reading?r.length&&Qi(this):Ee(eo,this));}return n},Vi.prototype.addListener=Vi.prototype.on,Vi.prototype.resume=function(){var e=this._readableState;return e.flowing||(Wi("resume"),e.flowing=true,function(e,t){t.resumeScheduled||(t.resumeScheduled=true,Ee(to,e,t));}(this,e)),this},Vi.prototype.pause=function(){return Wi("call pause flowing=%j",this._readableState.flowing),false!==this._readableState.flowing&&(Wi("pause"),this._readableState.flowing=false,this.emit("pause")),this},Vi.prototype.wrap=function(e){var t=this._readableState,n=false,r=this;for(var i in e.on("end",(function(){if(Wi("wrapped end"),t.decoder&&!t.ended){var e=t.decoder.end();e&&e.length&&r.push(e);}r.push(null);})),e.on("data",(function(i){(Wi("wrapped data"),t.decoder&&(i=t.decoder.write(i)),t.objectMode&&null==i)||(t.objectMode||i&&i.length)&&(r.push(i)||(n=true,e.pause()));})),e) void 0===this[i]&&"function"==typeof e[i]&&(this[i]=function(t){return function(){return e[t].apply(e,arguments)}}(i));return function(e,t){for(var n=0,r=e.length;n<r;n++)t(e[n],n);}(["error","close","destroy","pause","resume"],(function(t){e.on(t,r.emit.bind(r,t));})),r._read=function(t){Wi("wrapped _read",t),n&&(n=false,e.resume());},r},Vi._fromList=ro,co.WritableState=lo,it(co,Ze),lo.prototype.getBuffer=function(){for(var e=this.bufferedRequest,t=[];e;)t.push(e),e=e.next;return t},co.prototype.pipe=function(){this.emit("error",new Error("Cannot pipe, not readable"));},co.prototype.write=function(e,t,n){var r=this._writableState,i=false;return "function"==typeof t&&(n=t,t=null),_.isBuffer(e)?t="buffer":t||(t=r.defaultEncoding),"function"!=typeof n&&(n=so),r.ended?function(e,t){var n=new Error("write after end");e.emit("error",n),Ee(t,n);}(this,n):function(e,t,n,r){var i=true,o=false;return null===n?o=new TypeError("May not write null values to stream"):_.isBuffer(n)||"string"==typeof n||void 0===n||t.objectMode||(o=new TypeError("Invalid non-string/buffer chunk")),o&&(e.emit("error",o),Ee(r,o),i=false),i}(this,r,e,n)&&(r.pendingcb++,i=function(e,t,n,r,i){n=function(e,t,n){e.objectMode||false===e.decodeStrings||"string"!=typeof t||(t=_.from(t,n));return t}(t,n,r),_.isBuffer(n)&&(r="buffer");var o=t.objectMode?1:n.length;t.length+=o;var a=t.length<t.highWaterMark;a||(t.needDrain=true);if(t.writing||t.corked){var s=t.lastBufferedRequest;t.lastBufferedRequest=new uo(n,r,i),s?s.next=t.lastBufferedRequest:t.bufferedRequest=t.lastBufferedRequest,t.bufferedRequestCount+=1;}else fo(e,t,false,o,n,r,i);return a}(this,r,e,t,n)),i},co.prototype.cork=function(){this._writableState.corked++;},co.prototype.uncork=function(){var e=this._writableState;e.corked&&(e.corked--,e.writing||e.corked||e.finished||e.bufferProcessing||!e.bufferedRequest||po(this,e));},co.prototype.setDefaultEncoding=function(e){if("string"==typeof e&&(e=e.toLowerCase()),!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new TypeError("Unknown encoding: "+e);return this._writableState.defaultEncoding=e,this},co.prototype._write=function(e,t,n){n(new Error("not implemented"));},co.prototype._writev=null,co.prototype.end=function(e,t,n){var r=this._writableState;"function"==typeof e?(n=e,e=null,t=null):"function"==typeof t&&(n=t,t=null),null!=e&&this.write(e,t),r.corked&&(r.corked=1,this.uncork()),r.ending||r.finished||function(e,t,n){t.ending=true,vo(e,t),n&&(t.finished?Ee(n):e.once("finish",n));t.ended=true,e.writable=false;}(this,r,n);},it(So,Vi);for(var yo=Object.keys(co.prototype),wo=0;wo<yo.length;wo++){var _o=yo[wo];So.prototype[_o]||(So.prototype[_o]=co.prototype[_o]);}function So(e){if(!(this instanceof So))return new So(e);Vi.call(this,e),co.call(this,e),e&&false===e.readable&&(this.readable=false),e&&false===e.writable&&(this.writable=false),this.allowHalfOpen=true,e&&false===e.allowHalfOpen&&(this.allowHalfOpen=false),this.once("end",Eo);}function Eo(){this.allowHalfOpen||this._writableState.ended||Ee(ko,this);}function ko(e){e.end();}function Mo(e){this.afterTransform=function(t,n){return function(e,t,n){var r=e._transformState;r.transforming=false;var i=r.writecb;if(!i)return e.emit("error",new Error("no writecb in Transform class"));r.writechunk=null,r.writecb=null,null!=n&&e.push(n);i(t);var o=e._readableState;o.reading=false,(o.needReadable||o.length<o.highWaterMark)&&e._read(o.highWaterMark);}(e,t,n)},this.needTransform=false,this.transforming=false,this.writecb=null,this.writechunk=null,this.writeencoding=null;}function Co(e){if(!(this instanceof Co))return new Co(e);So.call(this,e),this._transformState=new Mo(this);var t=this;this._readableState.needReadable=true,this._readableState.sync=false,e&&("function"==typeof e.transform&&(this._transform=e.transform),"function"==typeof e.flush&&(this._flush=e.flush)),this.once("prefinish",(function(){"function"==typeof this._flush?this._flush((function(e){xo(t,e);})):xo(t);}));}function xo(e,t){if(t)return e.emit("error",t);var n=e._writableState,r=e._transformState;if(n.length)throw new Error("Calling transform done when ws.length != 0");if(r.transforming)throw new Error("Calling transform done when still transforming");return e.push(null)}function Ao(e){if(!(this instanceof Ao))return new Ao(e);Co.call(this,e);}function Ro(){Ze.call(this);}it(Co,So),Co.prototype.push=function(e,t){return this._transformState.needTransform=false,So.prototype.push.call(this,e,t)},Co.prototype._transform=function(e,t,n){throw new Error("Not implemented")},Co.prototype._write=function(e,t,n){var r=this._transformState;if(r.writecb=n,r.writechunk=e,r.writeencoding=t,!r.transforming){var i=this._readableState;(r.needTransform||i.needReadable||i.length<i.highWaterMark)&&this._read(i.highWaterMark);}},Co.prototype._read=function(e){var t=this._transformState;null!==t.writechunk&&t.writecb&&!t.transforming?(t.transforming=true,this._transform(t.writechunk,t.writeencoding,t.afterTransform)):t.needTransform=true;},it(Ao,Co),Ao.prototype._transform=function(e,t,n){n(null,e);},it(Ro,Ze),Ro.Readable=Vi,Ro.Writable=co,Ro.Duplex=So,Ro.Transform=Co,Ro.PassThrough=Ao,Ro.Stream=Ro,Ro.prototype.pipe=function(e,t){var n=this;function r(t){e.writable&&false===e.write(t)&&n.pause&&n.pause();}function i(){n.readable&&n.resume&&n.resume();}n.on("data",r),e.on("drain",i),e._isStdio||t&&false===t.end||(n.on("end",a),n.on("close",s));var o=false;function a(){o||(o=true,e.end());}function s(){o||(o=true,"function"==typeof e.destroy&&e.destroy());}function u(e){if(l(),0===Ze.listenerCount(this,"error"))throw e}function l(){n.removeListener("data",r),e.removeListener("drain",i),n.removeListener("end",a),n.removeListener("close",s),n.removeListener("error",u),e.removeListener("error",u),n.removeListener("end",l),n.removeListener("close",l),e.removeListener("close",l);}return n.on("error",u),e.on("error",u),n.on("end",l),n.on("close",l),e.on("close",l),e.emit("pipe",n),e};var To=i(Object.freeze({__proto__:null,Duplex:So,PassThrough:Ao,Readable:Vi,Stream:Ro,Transform:Co,Writable:co,default:Ro})),Po=i(Hi),Lo=Ue().Buffer,Io=To.Transform,Oo=Po.StringDecoder;function No(e){Io.call(this),this.hashMode="string"==typeof e,this.hashMode?this[e]=this._finalOrDigest:this.final=this._finalOrDigest,this._final&&(this.__final=this._final,this._final=null),this._decoder=null,this._encoding=null;}Ve(No,Io),No.prototype.update=function(e,t,n){"string"==typeof e&&(e=Lo.from(e,t));var r=this._update(e);return this.hashMode?this:(n&&(r=this._toString(r,n)),r)},No.prototype.setAutoPadding=function(){},No.prototype.getAuthTag=function(){throw new Error("trying to get auth tag in unsupported state")},No.prototype.setAuthTag=function(){throw new Error("trying to set auth tag in unsupported state")},No.prototype.setAAD=function(){throw new Error("trying to set aad in unsupported state")},No.prototype._transform=function(e,t,n){var r;try{this.hashMode?this._update(e):this.push(this._update(e));}catch(e){r=e;}finally{n(r);}},No.prototype._flush=function(e){var t;try{this.push(this.__final());}catch(e){t=e;}e(t);},No.prototype._finalOrDigest=function(e){var t=this.__final()||Lo.alloc(0);return e&&(t=this._toString(t,e,true)),t},No.prototype._toString=function(e,t,n){if(this._decoder||(this._decoder=new Oo(t),this._encoding=t),this._encoding!==t)throw new Error("can't switch encodings");var r=this._decoder.write(e);return n&&(r+=this._decoder.end()),r};var Do=No,jo=or,Bo=Er,zo=ji,Uo=Do;function Fo(e){Uo.call(this,"digest"),this._hash=e;}Ve(Fo,Uo),Fo.prototype._update=function(e){this._hash.update(e);},Fo.prototype._final=function(){return this._hash.digest()};var Ko=function(e){return "md5"===(e=e.toLowerCase())?new jo:"rmd160"===e||"ripemd160"===e?new Bo:new Fo(zo(e))},qo=Ve,Ho=Ue().Buffer,Wo=Do,$o=Ho.alloc(128),Vo=64;function Yo(e,t){Wo.call(this,"digest"),"string"==typeof t&&(t=Ho.from(t)),this._alg=e,this._key=t,t.length>Vo?t=e(t):t.length<Vo&&(t=Ho.concat([t,$o],Vo));for(var n=this._ipad=Ho.allocUnsafe(Vo),r=this._opad=Ho.allocUnsafe(Vo),i=0;i<Vo;i++)n[i]=54^t[i],r[i]=92^t[i];this._hash=[n];}qo(Yo,Wo),Yo.prototype._update=function(e){this._hash.push(e);},Yo.prototype._final=function(){var e=this._alg(Ho.concat(this._hash));return this._alg(Ho.concat([this._opad,e]))};var Go=or,Zo=function(e){return (new Go).update(e).digest()},Qo=Ve,Jo=Yo,Xo=Do,ea=Ue().Buffer,ta=Zo,na=Er,ra=ji,ia=ea.alloc(128);function oa(e,t){Xo.call(this,"digest"),"string"==typeof t&&(t=ea.from(t));var n="sha512"===e||"sha384"===e?128:64;(this._alg=e,this._key=t,t.length>n)?t=("rmd160"===e?new na:ra(e)).update(t).digest():t.length<n&&(t=ea.concat([t,ia],n));for(var r=this._ipad=ea.allocUnsafe(n),i=this._opad=ea.allocUnsafe(n),o=0;o<n;o++)r[o]=54^t[o],i[o]=92^t[o];this._hash="rmd160"===e?new na:ra(e),this._hash.update(r);}Qo(oa,Xo),oa.prototype._update=function(e){this._hash.update(e);},oa.prototype._final=function(){var e=this._hash.digest();return ("rmd160"===this._alg?new na:ra(this._alg)).update(this._opad).update(e).digest()};var aa,sa=function(e,t){return "rmd160"===(e=e.toLowerCase())||"ripemd160"===e?new oa("rmd160",t):"md5"===e?new Jo(ta,t):new oa(e,t)},ua={sha224WithRSAEncryption:{sign:"rsa",hash:"sha224",id:"302d300d06096086480165030402040500041c"},"RSA-SHA224":{sign:"ecdsa/rsa",hash:"sha224",id:"302d300d06096086480165030402040500041c"},sha256WithRSAEncryption:{sign:"rsa",hash:"sha256",id:"3031300d060960864801650304020105000420"},"RSA-SHA256":{sign:"ecdsa/rsa",hash:"sha256",id:"3031300d060960864801650304020105000420"},sha384WithRSAEncryption:{sign:"rsa",hash:"sha384",id:"3041300d060960864801650304020205000430"},"RSA-SHA384":{sign:"ecdsa/rsa",hash:"sha384",id:"3041300d060960864801650304020205000430"},sha512WithRSAEncryption:{sign:"rsa",hash:"sha512",id:"3051300d060960864801650304020305000440"},"RSA-SHA512":{sign:"ecdsa/rsa",hash:"sha512",id:"3051300d060960864801650304020305000440"},"RSA-SHA1":{sign:"rsa",hash:"sha1",id:"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{sign:"ecdsa",hash:"sha1",id:""},sha256:{sign:"ecdsa",hash:"sha256",id:""},sha224:{sign:"ecdsa",hash:"sha224",id:""},sha384:{sign:"ecdsa",hash:"sha384",id:""},sha512:{sign:"ecdsa",hash:"sha512",id:""},"DSA-SHA":{sign:"dsa",hash:"sha1",id:""},"DSA-SHA1":{sign:"dsa",hash:"sha1",id:""},DSA:{sign:"dsa",hash:"sha1",id:""},"DSA-WITH-SHA224":{sign:"dsa",hash:"sha224",id:""},"DSA-SHA224":{sign:"dsa",hash:"sha224",id:""},"DSA-WITH-SHA256":{sign:"dsa",hash:"sha256",id:""},"DSA-SHA256":{sign:"dsa",hash:"sha256",id:""},"DSA-WITH-SHA384":{sign:"dsa",hash:"sha384",id:""},"DSA-SHA384":{sign:"dsa",hash:"sha384",id:""},"DSA-WITH-SHA512":{sign:"dsa",hash:"sha512",id:""},"DSA-SHA512":{sign:"dsa",hash:"sha512",id:""},"DSA-RIPEMD160":{sign:"dsa",hash:"rmd160",id:""},ripemd160WithRSA:{sign:"rsa",hash:"rmd160",id:"3021300906052b2403020105000414"},"RSA-RIPEMD160":{sign:"rsa",hash:"rmd160",id:"3021300906052b2403020105000414"},md5WithRSAEncryption:{sign:"rsa",hash:"md5",id:"3020300c06082a864886f70d020505000410"},"RSA-MD5":{sign:"rsa",hash:"md5",id:"3020300c06082a864886f70d020505000410"}},la=ua,ca={},da=Math.pow(2,30)-1,fa=function(e,t){if("number"!=typeof e)throw new TypeError("Iterations not a number");if(e<0)throw new TypeError("Bad iterations");if("number"!=typeof t)throw new TypeError("Key length not a number");if(t<0||t>da||t!=t)throw new TypeError("Bad key length")};if(n.process&&n.process.browser)aa="utf-8";else if(n.process&&n.process.version){aa=parseInt(je.version.split(".")[0].slice(1),10)>=6?"utf-8":"binary";}else aa="utf-8";var ha=aa,pa=Ue().Buffer,ma=function(e,t,n){if(pa.isBuffer(e))return e;if("string"==typeof e)return pa.from(e,t);if(ArrayBuffer.isView(e))return pa.from(e.buffer);throw new TypeError(n+" must be a string, a Buffer, a typed array or a DataView")},ga=Zo,va=Er,ba=ji,ya=Ue().Buffer,wa=fa,_a=ha,Sa=ma,Ea=ya.alloc(128),ka={md5:16,sha1:20,sha224:28,sha256:32,sha384:48,sha512:64,rmd160:20,ripemd160:20};function Ma(e,t,n){var r=function(e){function t(t){return ba(e).update(t).digest()}function n(e){return (new va).update(e).digest()}return "rmd160"===e||"ripemd160"===e?n:"md5"===e?ga:t}(e),i="sha512"===e||"sha384"===e?128:64;t.length>i?t=r(t):t.length<i&&(t=ya.concat([t,Ea],i));for(var o=ya.allocUnsafe(i+ka[e]),a=ya.allocUnsafe(i+ka[e]),s=0;s<i;s++)o[s]=54^t[s],a[s]=92^t[s];var u=ya.allocUnsafe(i+n+4);o.copy(u,0,0,i),this.ipad1=u,this.ipad2=o,this.opad=a,this.alg=e,this.blocksize=i,this.hash=r,this.size=ka[e];}Ma.prototype.run=function(e,t){return e.copy(t,this.blocksize),this.hash(t).copy(this.opad,this.blocksize),this.hash(this.opad)};var Ca,xa,Aa=function(e,t,n,r,i){wa(n,r);var o=new Ma(i=i||"sha1",e=Sa(e,_a,"Password"),(t=Sa(t,_a,"Salt")).length),a=ya.allocUnsafe(r),s=ya.allocUnsafe(t.length+4);t.copy(s,0,0,t.length);for(var u=0,l=ka[i],c=Math.ceil(r/l),d=1;d<=c;d++){s.writeUInt32BE(d,t.length);for(var f=o.run(s,o.ipad1),h=f,p=1;p<n;p++){h=o.run(h,o.ipad2);for(var m=0;m<l;m++)f[m]^=h[m];}f.copy(a,u),u+=l;}return a},Ra=Ue().Buffer,Ta=fa,Pa=ha,La=Aa,Ia=ma,Oa=n.crypto&&n.crypto.subtle,Na={sha:"SHA-1","sha-1":"SHA-1",sha1:"SHA-1",sha256:"SHA-256","sha-256":"SHA-256",sha384:"SHA-384","sha-384":"SHA-384","sha-512":"SHA-512",sha512:"SHA-512"},Da=[];function ja(){return xa||(xa=n.process&&n.process.nextTick?n.process.nextTick:n.queueMicrotask?n.queueMicrotask:n.setImmediate?n.setImmediate:n.setTimeout)}function Ba(e,t,n,r,i){return Oa.importKey("raw",e,{name:"PBKDF2"},false,["deriveBits"]).then((function(e){return Oa.deriveBits({name:"PBKDF2",salt:t,iterations:n,hash:{name:i}},e,r<<3)})).then((function(e){return Ra.from(e)}))}ca.pbkdf2=function(e,t,r,i,o,a){"function"==typeof o&&(a=o,o=void 0);var s=Na[(o=o||"sha1").toLowerCase()];if(s&&"function"==typeof n.Promise){if(Ta(r,i),e=Ia(e,Pa,"Password"),t=Ia(t,Pa,"Salt"),"function"!=typeof a)throw new Error("No callback provided to pbkdf2");!function(e,t){e.then((function(e){ja()((function(){t(null,e);}));}),(function(e){ja()((function(){t(e);}));}));}(function(e){if(n.process&&!n.process.browser)return Promise.resolve(false);if(!Oa||!Oa.importKey||!Oa.deriveBits)return Promise.resolve(false);if(void 0!==Da[e])return Da[e];var t=Ba(Ca=Ca||Ra.alloc(8),Ca,10,128,e).then((function(){return  true})).catch((function(){return  false}));return Da[e]=t,t}(s).then((function(n){return n?Ba(e,t,r,i,s):La(e,t,r,i,o)})),a);}else ja()((function(){var n;try{n=La(e,t,r,i,o);}catch(e){return a(e)}a(null,n);}));},ca.pbkdf2Sync=Aa;var za={},Ua={},Fa={readUInt32BE:function(e,t){return (e[0+t]<<24|e[1+t]<<16|e[2+t]<<8|e[3+t])>>>0},writeUInt32BE:function(e,t,n){e[0+n]=t>>>24,e[1+n]=t>>>16&255,e[2+n]=t>>>8&255,e[3+n]=255&t;},ip:function(e,t,n,r){for(var i=0,o=0,a=6;a>=0;a-=2){for(var s=0;s<=24;s+=8)i<<=1,i|=t>>>s+a&1;for(s=0;s<=24;s+=8)i<<=1,i|=e>>>s+a&1;}for(a=6;a>=0;a-=2){for(s=1;s<=25;s+=8)o<<=1,o|=t>>>s+a&1;for(s=1;s<=25;s+=8)o<<=1,o|=e>>>s+a&1;}n[r+0]=i>>>0,n[r+1]=o>>>0;},rip:function(e,t,n,r){for(var i=0,o=0,a=0;a<4;a++)for(var s=24;s>=0;s-=8)i<<=1,i|=t>>>s+a&1,i<<=1,i|=e>>>s+a&1;for(a=4;a<8;a++)for(s=24;s>=0;s-=8)o<<=1,o|=t>>>s+a&1,o<<=1,o|=e>>>s+a&1;n[r+0]=i>>>0,n[r+1]=o>>>0;},pc1:function(e,t,n,r){for(var i=0,o=0,a=7;a>=5;a--){for(var s=0;s<=24;s+=8)i<<=1,i|=t>>s+a&1;for(s=0;s<=24;s+=8)i<<=1,i|=e>>s+a&1;}for(s=0;s<=24;s+=8)i<<=1,i|=t>>s+a&1;for(a=1;a<=3;a++){for(s=0;s<=24;s+=8)o<<=1,o|=t>>s+a&1;for(s=0;s<=24;s+=8)o<<=1,o|=e>>s+a&1;}for(s=0;s<=24;s+=8)o<<=1,o|=e>>s+a&1;n[r+0]=i>>>0,n[r+1]=o>>>0;},r28shl:function(e,t){return e<<t&268435455|e>>>28-t}},Ka=[14,11,17,4,27,23,25,0,13,22,7,18,5,9,16,24,2,20,12,21,1,8,15,26,15,4,25,19,9,1,26,16,5,11,23,8,12,7,17,0,22,3,10,14,6,20,27,24];Fa.pc2=function(e,t,n,r){for(var i=0,o=0,a=Ka.length>>>1,s=0;s<a;s++)i<<=1,i|=e>>>Ka[s]&1;for(s=a;s<Ka.length;s++)o<<=1,o|=t>>>Ka[s]&1;n[r+0]=i>>>0,n[r+1]=o>>>0;},Fa.expand=function(e,t,n){var r=0,i=0;r=(1&e)<<5|e>>>27;for(var o=23;o>=15;o-=4)r<<=6,r|=e>>>o&63;for(o=11;o>=3;o-=4)i|=e>>>o&63,i<<=6;i|=(31&e)<<1|e>>>31,t[n+0]=r>>>0,t[n+1]=i>>>0;};var qa=[14,0,4,15,13,7,1,4,2,14,15,2,11,13,8,1,3,10,10,6,6,12,12,11,5,9,9,5,0,3,7,8,4,15,1,12,14,8,8,2,13,4,6,9,2,1,11,7,15,5,12,11,9,3,7,14,3,10,10,0,5,6,0,13,15,3,1,13,8,4,14,7,6,15,11,2,3,8,4,14,9,12,7,0,2,1,13,10,12,6,0,9,5,11,10,5,0,13,14,8,7,10,11,1,10,3,4,15,13,4,1,2,5,11,8,6,12,7,6,12,9,0,3,5,2,14,15,9,10,13,0,7,9,0,14,9,6,3,3,4,15,6,5,10,1,2,13,8,12,5,7,14,11,12,4,11,2,15,8,1,13,1,6,10,4,13,9,0,8,6,15,9,3,8,0,7,11,4,1,15,2,14,12,3,5,11,10,5,14,2,7,12,7,13,13,8,14,11,3,5,0,6,6,15,9,0,10,3,1,4,2,7,8,2,5,12,11,1,12,10,4,14,15,9,10,3,6,15,9,0,0,6,12,10,11,1,7,13,13,8,15,9,1,4,3,5,14,11,5,12,2,7,8,2,4,14,2,14,12,11,4,2,1,12,7,4,10,7,11,13,6,1,8,5,5,0,3,15,15,10,13,3,0,9,14,8,9,6,4,11,2,8,1,12,11,7,10,1,13,14,7,2,8,13,15,6,9,15,12,0,5,9,6,10,3,4,0,5,14,3,12,10,1,15,10,4,15,2,9,7,2,12,6,9,8,5,0,6,13,1,3,13,4,14,14,0,7,11,5,3,11,8,9,4,14,3,15,2,5,12,2,9,8,5,12,15,3,10,7,11,0,14,4,1,10,7,1,6,13,0,11,8,6,13,4,13,11,0,2,11,14,7,15,4,0,9,8,1,13,10,3,14,12,3,9,5,7,12,5,2,10,15,6,8,1,6,1,6,4,11,11,13,13,8,12,1,3,4,7,10,14,7,10,9,15,5,6,0,8,15,0,14,5,2,9,3,2,12,13,1,2,15,8,13,4,8,6,10,15,3,11,7,1,4,10,12,9,5,3,6,14,11,5,0,0,14,12,9,7,2,7,2,11,1,4,14,1,7,9,4,12,10,14,8,2,13,0,15,6,12,10,9,13,0,15,3,3,5,5,6,8,11];Fa.substitute=function(e,t){for(var n=0,r=0;r<4;r++){n<<=4,n|=qa[64*r+(e>>>18-6*r&63)];}for(r=0;r<4;r++){n<<=4,n|=qa[256+64*r+(t>>>18-6*r&63)];}return n>>>0};var Ha=[16,25,12,11,3,20,4,15,31,17,9,6,27,14,1,22,30,24,8,18,0,5,29,23,13,19,2,26,10,21,28,7];Fa.permute=function(e){for(var t=0,n=0;n<Ha.length;n++)t<<=1,t|=e>>>Ha[n]&1;return t>>>0},Fa.padSplit=function(e,t,n){for(var r=e.toString(2);r.length<t;)r="0"+r;for(var i=[],o=0;o<t;o+=n)i.push(r.slice(o,o+n));return i.join(" ")};var Wa=$a;function $a(e,t){if(!e)throw new Error(t||"Assertion failed")}$a.equal=function(e,t,n){if(e!=t)throw new Error(n||"Assertion failed: "+e+" != "+t)};var Va=Wa;function Ya(e){this.options=e,this.type=this.options.type,this.blockSize=8,this._init(),this.buffer=new Array(this.blockSize),this.bufferOff=0,this.padding=false!==e.padding;}var Ga=Ya;Ya.prototype._init=function(){},Ya.prototype.update=function(e){return 0===e.length?[]:"decrypt"===this.type?this._updateDecrypt(e):this._updateEncrypt(e)},Ya.prototype._buffer=function(e,t){for(var n=Math.min(this.buffer.length-this.bufferOff,e.length-t),r=0;r<n;r++)this.buffer[this.bufferOff+r]=e[t+r];return this.bufferOff+=n,n},Ya.prototype._flushBuffer=function(e,t){return this._update(this.buffer,0,e,t),this.bufferOff=0,this.blockSize},Ya.prototype._updateEncrypt=function(e){var t=0,n=0,r=(this.bufferOff+e.length)/this.blockSize|0,i=new Array(r*this.blockSize);0!==this.bufferOff&&(t+=this._buffer(e,t),this.bufferOff===this.buffer.length&&(n+=this._flushBuffer(i,n)));for(var o=e.length-(e.length-t)%this.blockSize;t<o;t+=this.blockSize)this._update(e,t,i,n),n+=this.blockSize;for(;t<e.length;t++,this.bufferOff++)this.buffer[this.bufferOff]=e[t];return i},Ya.prototype._updateDecrypt=function(e){for(var t=0,n=0,r=Math.ceil((this.bufferOff+e.length)/this.blockSize)-1,i=new Array(r*this.blockSize);r>0;r--)t+=this._buffer(e,t),n+=this._flushBuffer(i,n);return t+=this._buffer(e,t),i},Ya.prototype.final=function(e){var t,n;return e&&(t=this.update(e)),n="encrypt"===this.type?this._finalEncrypt():this._finalDecrypt(),t?t.concat(n):n},Ya.prototype._pad=function(e,t){if(0===t)return  false;for(;t<e.length;)e[t++]=0;return  true},Ya.prototype._finalEncrypt=function(){if(!this._pad(this.buffer,this.bufferOff))return [];var e=new Array(this.blockSize);return this._update(this.buffer,0,e,0),e},Ya.prototype._unpad=function(e){return e},Ya.prototype._finalDecrypt=function(){Va.equal(this.bufferOff,this.blockSize,"Not enough data to decrypt");var e=new Array(this.blockSize);return this._flushBuffer(e,0),this._unpad(e)};var Za=Wa,Qa=Fa,Ja=Ga;function Xa(){this.tmp=new Array(2),this.keys=null;}function es(e){Ja.call(this,e);var t=new Xa;this._desState=t,this.deriveKeys(t,e.key);}Ve(es,Ja);var ts=es;es.create=function(e){return new es(e)};var ns=[1,1,2,2,2,2,2,2,1,2,2,2,2,2,2,1];es.prototype.deriveKeys=function(e,t){e.keys=new Array(32),Za.equal(t.length,this.blockSize,"Invalid key length");var n=Qa.readUInt32BE(t,0),r=Qa.readUInt32BE(t,4);Qa.pc1(n,r,e.tmp,0),n=e.tmp[0],r=e.tmp[1];for(var i=0;i<e.keys.length;i+=2){var o=ns[i>>>1];n=Qa.r28shl(n,o),r=Qa.r28shl(r,o),Qa.pc2(n,r,e.keys,i);}},es.prototype._update=function(e,t,n,r){var i=this._desState,o=Qa.readUInt32BE(e,t),a=Qa.readUInt32BE(e,t+4);Qa.ip(o,a,i.tmp,0),o=i.tmp[0],a=i.tmp[1],"encrypt"===this.type?this._encrypt(i,o,a,i.tmp,0):this._decrypt(i,o,a,i.tmp,0),o=i.tmp[0],a=i.tmp[1],Qa.writeUInt32BE(n,o,r),Qa.writeUInt32BE(n,a,r+4);},es.prototype._pad=function(e,t){if(false===this.padding)return  false;for(var n=e.length-t,r=t;r<e.length;r++)e[r]=n;return  true},es.prototype._unpad=function(e){if(false===this.padding)return e;for(var t=e[e.length-1],n=e.length-t;n<e.length;n++)Za.equal(e[n],t);return e.slice(0,e.length-t)},es.prototype._encrypt=function(e,t,n,r,i){for(var o=t,a=n,s=0;s<e.keys.length;s+=2){var u=e.keys[s],l=e.keys[s+1];Qa.expand(a,e.tmp,0),u^=e.tmp[0],l^=e.tmp[1];var c=Qa.substitute(u,l),d=a;a=(o^Qa.permute(c))>>>0,o=d;}Qa.rip(a,o,r,i);},es.prototype._decrypt=function(e,t,n,r,i){for(var o=n,a=t,s=e.keys.length-2;s>=0;s-=2){var u=e.keys[s],l=e.keys[s+1];Qa.expand(o,e.tmp,0),u^=e.tmp[0],l^=e.tmp[1];var c=Qa.substitute(u,l),d=o;o=(a^Qa.permute(c))>>>0,a=d;}Qa.rip(o,a,r,i);};var rs={},is=Wa,os=Ve,as={};function ss(e){is.equal(e.length,8,"Invalid IV length"),this.iv=new Array(8);for(var t=0;t<this.iv.length;t++)this.iv[t]=e[t];}rs.instantiate=function(e){function t(t){e.call(this,t),this._cbcInit();}os(t,e);for(var n=Object.keys(as),r=0;r<n.length;r++){var i=n[r];t.prototype[i]=as[i];}return t.create=function(e){return new t(e)},t},as._cbcInit=function(){var e=new ss(this.options.iv);this._cbcState=e;},as._update=function(e,t,n,r){var i=this._cbcState,o=this.constructor.super_.prototype,a=i.iv;if("encrypt"===this.type){for(var s=0;s<this.blockSize;s++)a[s]^=e[t+s];o._update.call(this,a,0,n,r);for(s=0;s<this.blockSize;s++)a[s]=n[r+s];}else {o._update.call(this,e,t,n,r);for(s=0;s<this.blockSize;s++)n[r+s]^=a[s];for(s=0;s<this.blockSize;s++)a[s]=e[t+s];}};var us=Wa,ls=Ga,cs=ts;function ds(e,t){us.equal(t.length,24,"Invalid key length");var n=t.slice(0,8),r=t.slice(8,16),i=t.slice(16,24);this.ciphers="encrypt"===e?[cs.create({type:"encrypt",key:n}),cs.create({type:"decrypt",key:r}),cs.create({type:"encrypt",key:i})]:[cs.create({type:"decrypt",key:i}),cs.create({type:"encrypt",key:r}),cs.create({type:"decrypt",key:n})];}function fs(e){ls.call(this,e);var t=new ds(this.type,this.options.key);this._edeState=t;}Ve(fs,ls);var hs=fs;fs.create=function(e){return new fs(e)},fs.prototype._update=function(e,t,n,r){var i=this._edeState;i.ciphers[0]._update(e,t,n,r),i.ciphers[1]._update(n,r,n,r),i.ciphers[2]._update(n,r,n,r);},fs.prototype._pad=cs.prototype._pad,fs.prototype._unpad=cs.prototype._unpad,Ua.utils=Fa,Ua.Cipher=Ga,Ua.DES=ts,Ua.CBC=rs,Ua.EDE=hs;var ps=Do,ms=Ua,gs=Ve,vs=Ue().Buffer,bs={"des-ede3-cbc":ms.CBC.instantiate(ms.EDE),"des-ede3":ms.EDE,"des-ede-cbc":ms.CBC.instantiate(ms.EDE),"des-ede":ms.EDE,"des-cbc":ms.CBC.instantiate(ms.DES),"des-ecb":ms.DES};bs.des=bs["des-cbc"],bs.des3=bs["des-ede3-cbc"];var ys=ws;function ws(e){ps.call(this);var t,n=e.mode.toLowerCase(),r=bs[n];t=e.decrypt?"decrypt":"encrypt";var i=e.key;vs.isBuffer(i)||(i=vs.from(i)),"des-ede"!==n&&"des-ede-cbc"!==n||(i=vs.concat([i,i.slice(0,8)]));var o=e.iv;vs.isBuffer(o)||(o=vs.from(o)),this._des=r.create({key:i,iv:o,type:t});}gs(ws,ps),ws.prototype._update=function(e){return vs.from(this._des.update(e))},ws.prototype._final=function(){return vs.from(this._des.final())};var _s={},Ss={},Es={encrypt:function(e,t){return e._cipher.encryptBlock(t)},decrypt:function(e,t){return e._cipher.decryptBlock(t)}},ks={},Ms=function(e,t){for(var n=Math.min(e.length,t.length),r=new _(n),i=0;i<n;++i)r[i]=e[i]^t[i];return r},Cs=Ms;ks.encrypt=function(e,t){var n=Cs(t,e._prev);return e._prev=e._cipher.encryptBlock(n),e._prev},ks.decrypt=function(e,t){var n=e._prev;e._prev=t;var r=e._cipher.decryptBlock(t);return Cs(r,n)};var xs={},As=Ue().Buffer,Rs=Ms;function Ts(e,t,n){var r=t.length,i=Rs(t,e._cache);return e._cache=e._cache.slice(r),e._prev=As.concat([e._prev,n?t:i]),i}xs.encrypt=function(e,t,n){for(var r,i=As.allocUnsafe(0);t.length;){if(0===e._cache.length&&(e._cache=e._cipher.encryptBlock(e._prev),e._prev=As.allocUnsafe(0)),!(e._cache.length<=t.length)){i=As.concat([i,Ts(e,t,n)]);break}r=e._cache.length,i=As.concat([i,Ts(e,t.slice(0,r),n)]),t=t.slice(r);}return i};var Ps={},Ls=Ue().Buffer;function Is(e,t,n){var r=e._cipher.encryptBlock(e._prev)[0]^t;return e._prev=Ls.concat([e._prev.slice(1),Ls.from([n?t:r])]),r}Ps.encrypt=function(e,t,n){for(var r=t.length,i=Ls.allocUnsafe(r),o=-1;++o<r;)i[o]=Is(e,t[o],n);return i};var Os={},Ns=Ue().Buffer;function Ds(e,t,n){for(var r,i,o=-1,a=0;++o<8;)r=t&1<<7-o?128:0,a+=(128&(i=e._cipher.encryptBlock(e._prev)[0]^r))>>o%8,e._prev=js(e._prev,n?r:i);return a}function js(e,t){var n=e.length,r=-1,i=Ns.allocUnsafe(e.length);for(e=Ns.concat([e,Ns.from([t])]);++r<n;)i[r]=e[r]<<1|e[r+1]>>7;return i}Os.encrypt=function(e,t,n){for(var r=t.length,i=Ns.allocUnsafe(r),o=-1;++o<r;)i[o]=Ds(e,t[o],n);return i};var Bs={},zs=Ms;function Us(e){return e._prev=e._cipher.encryptBlock(e._prev),e._prev}Bs.encrypt=function(e,t){for(;e._cache.length<t.length;)e._cache=_.concat([e._cache,Us(e)]);var n=e._cache.slice(0,t.length);return e._cache=e._cache.slice(t.length),zs(t,n)};var Fs={};var Ks=function(e){for(var t,n=e.length;n--;){if(255!==(t=e.readUInt8(n))){t++,e.writeUInt8(t,n);break}e.writeUInt8(0,n);}},qs=Ms,Hs=Ue().Buffer,Ws=Ks;function $s(e){var t=e._cipher.encryptBlockRaw(e._prev);return Ws(e._prev),t}Fs.encrypt=function(e,t){var n=Math.ceil(t.length/16),r=e._cache.length;e._cache=Hs.concat([e._cache,Hs.allocUnsafe(16*n)]);for(var i=0;i<n;i++){var o=$s(e),a=r+16*i;e._cache.writeUInt32BE(o[0],a+0),e._cache.writeUInt32BE(o[1],a+4),e._cache.writeUInt32BE(o[2],a+8),e._cache.writeUInt32BE(o[3],a+12);}var s=e._cache.slice(0,t.length);return e._cache=e._cache.slice(t.length),qs(t,s)};var Vs={"aes-128-ecb":{cipher:"AES",key:128,iv:0,mode:"ECB",type:"block"},"aes-192-ecb":{cipher:"AES",key:192,iv:0,mode:"ECB",type:"block"},"aes-256-ecb":{cipher:"AES",key:256,iv:0,mode:"ECB",type:"block"},"aes-128-cbc":{cipher:"AES",key:128,iv:16,mode:"CBC",type:"block"},"aes-192-cbc":{cipher:"AES",key:192,iv:16,mode:"CBC",type:"block"},"aes-256-cbc":{cipher:"AES",key:256,iv:16,mode:"CBC",type:"block"},aes128:{cipher:"AES",key:128,iv:16,mode:"CBC",type:"block"},aes192:{cipher:"AES",key:192,iv:16,mode:"CBC",type:"block"},aes256:{cipher:"AES",key:256,iv:16,mode:"CBC",type:"block"},"aes-128-cfb":{cipher:"AES",key:128,iv:16,mode:"CFB",type:"stream"},"aes-192-cfb":{cipher:"AES",key:192,iv:16,mode:"CFB",type:"stream"},"aes-256-cfb":{cipher:"AES",key:256,iv:16,mode:"CFB",type:"stream"},"aes-128-cfb8":{cipher:"AES",key:128,iv:16,mode:"CFB8",type:"stream"},"aes-192-cfb8":{cipher:"AES",key:192,iv:16,mode:"CFB8",type:"stream"},"aes-256-cfb8":{cipher:"AES",key:256,iv:16,mode:"CFB8",type:"stream"},"aes-128-cfb1":{cipher:"AES",key:128,iv:16,mode:"CFB1",type:"stream"},"aes-192-cfb1":{cipher:"AES",key:192,iv:16,mode:"CFB1",type:"stream"},"aes-256-cfb1":{cipher:"AES",key:256,iv:16,mode:"CFB1",type:"stream"},"aes-128-ofb":{cipher:"AES",key:128,iv:16,mode:"OFB",type:"stream"},"aes-192-ofb":{cipher:"AES",key:192,iv:16,mode:"OFB",type:"stream"},"aes-256-ofb":{cipher:"AES",key:256,iv:16,mode:"OFB",type:"stream"},"aes-128-ctr":{cipher:"AES",key:128,iv:16,mode:"CTR",type:"stream"},"aes-192-ctr":{cipher:"AES",key:192,iv:16,mode:"CTR",type:"stream"},"aes-256-ctr":{cipher:"AES",key:256,iv:16,mode:"CTR",type:"stream"},"aes-128-gcm":{cipher:"AES",key:128,iv:12,mode:"GCM",type:"auth"},"aes-192-gcm":{cipher:"AES",key:192,iv:12,mode:"GCM",type:"auth"},"aes-256-gcm":{cipher:"AES",key:256,iv:12,mode:"GCM",type:"auth"}},Ys={ECB:Es,CBC:ks,CFB:xs,CFB8:Ps,CFB1:Os,OFB:Bs,CTR:Fs,GCM:Fs},Gs=Vs;for(var Zs in Gs)Gs[Zs].module=Ys[Gs[Zs].mode];var Qs=Gs,Js={},Xs=Ue().Buffer;function eu(e){Xs.isBuffer(e)||(e=Xs.from(e));for(var t=e.length/4|0,n=new Array(t),r=0;r<t;r++)n[r]=e.readUInt32BE(4*r);return n}function tu(e){for(;0<e.length;e++)e[0]=0;}function nu(e,t,n,r,i){for(var o,a,s,u,l=n[0],c=n[1],d=n[2],f=n[3],h=e[0]^t[0],p=e[1]^t[1],m=e[2]^t[2],g=e[3]^t[3],v=4,b=1;b<i;b++)o=l[h>>>24]^c[p>>>16&255]^d[m>>>8&255]^f[255&g]^t[v++],a=l[p>>>24]^c[m>>>16&255]^d[g>>>8&255]^f[255&h]^t[v++],s=l[m>>>24]^c[g>>>16&255]^d[h>>>8&255]^f[255&p]^t[v++],u=l[g>>>24]^c[h>>>16&255]^d[p>>>8&255]^f[255&m]^t[v++],h=o,p=a,m=s,g=u;return o=(r[h>>>24]<<24|r[p>>>16&255]<<16|r[m>>>8&255]<<8|r[255&g])^t[v++],a=(r[p>>>24]<<24|r[m>>>16&255]<<16|r[g>>>8&255]<<8|r[255&h])^t[v++],s=(r[m>>>24]<<24|r[g>>>16&255]<<16|r[h>>>8&255]<<8|r[255&p])^t[v++],u=(r[g>>>24]<<24|r[h>>>16&255]<<16|r[p>>>8&255]<<8|r[255&m])^t[v++],[o>>>=0,a>>>=0,s>>>=0,u>>>=0]}var ru=[0,1,2,4,8,16,32,64,128,27,54],iu=function(){for(var e=new Array(256),t=0;t<256;t++)e[t]=t<128?t<<1:t<<1^283;for(var n=[],r=[],i=[[],[],[],[]],o=[[],[],[],[]],a=0,s=0,u=0;u<256;++u){var l=s^s<<1^s<<2^s<<3^s<<4;l=l>>>8^255&l^99,n[a]=l,r[l]=a;var c=e[a],d=e[c],f=e[d],h=257*e[l]^16843008*l;i[0][a]=h<<24|h>>>8,i[1][a]=h<<16|h>>>16,i[2][a]=h<<8|h>>>24,i[3][a]=h,h=16843009*f^65537*d^257*c^16843008*a,o[0][l]=h<<24|h>>>8,o[1][l]=h<<16|h>>>16,o[2][l]=h<<8|h>>>24,o[3][l]=h,0===a?a=s=1:(a=c^e[e[e[f^c]]],s^=e[e[s]]);}return {SBOX:n,INV_SBOX:r,SUB_MIX:i,INV_SUB_MIX:o}}();function ou(e){this._key=eu(e),this._reset();}ou.blockSize=16,ou.keySize=32,ou.prototype.blockSize=ou.blockSize,ou.prototype.keySize=ou.keySize,ou.prototype._reset=function(){for(var e=this._key,t=e.length,n=t+6,r=4*(n+1),i=[],o=0;o<t;o++)i[o]=e[o];for(o=t;o<r;o++){var a=i[o-1];o%t==0?(a=a<<8|a>>>24,a=iu.SBOX[a>>>24]<<24|iu.SBOX[a>>>16&255]<<16|iu.SBOX[a>>>8&255]<<8|iu.SBOX[255&a],a^=ru[o/t|0]<<24):t>6&&o%t==4&&(a=iu.SBOX[a>>>24]<<24|iu.SBOX[a>>>16&255]<<16|iu.SBOX[a>>>8&255]<<8|iu.SBOX[255&a]),i[o]=i[o-t]^a;}for(var s=[],u=0;u<r;u++){var l=r-u,c=i[l-(u%4?0:4)];s[u]=u<4||l<=4?c:iu.INV_SUB_MIX[0][iu.SBOX[c>>>24]]^iu.INV_SUB_MIX[1][iu.SBOX[c>>>16&255]]^iu.INV_SUB_MIX[2][iu.SBOX[c>>>8&255]]^iu.INV_SUB_MIX[3][iu.SBOX[255&c]];}this._nRounds=n,this._keySchedule=i,this._invKeySchedule=s;},ou.prototype.encryptBlockRaw=function(e){return nu(e=eu(e),this._keySchedule,iu.SUB_MIX,iu.SBOX,this._nRounds)},ou.prototype.encryptBlock=function(e){var t=this.encryptBlockRaw(e),n=Xs.allocUnsafe(16);return n.writeUInt32BE(t[0],0),n.writeUInt32BE(t[1],4),n.writeUInt32BE(t[2],8),n.writeUInt32BE(t[3],12),n},ou.prototype.decryptBlock=function(e){var t=(e=eu(e))[1];e[1]=e[3],e[3]=t;var n=nu(e,this._invKeySchedule,iu.INV_SUB_MIX,iu.INV_SBOX,this._nRounds),r=Xs.allocUnsafe(16);return r.writeUInt32BE(n[0],0),r.writeUInt32BE(n[3],4),r.writeUInt32BE(n[2],8),r.writeUInt32BE(n[1],12),r},ou.prototype.scrub=function(){tu(this._keySchedule),tu(this._invKeySchedule),tu(this._key);},Js.AES=ou;var au=Ue().Buffer,su=au.alloc(16,0);function uu(e){var t=au.allocUnsafe(16);return t.writeUInt32BE(e[0]>>>0,0),t.writeUInt32BE(e[1]>>>0,4),t.writeUInt32BE(e[2]>>>0,8),t.writeUInt32BE(e[3]>>>0,12),t}function lu(e){this.h=e,this.state=au.alloc(16,0),this.cache=au.allocUnsafe(0);}lu.prototype.ghash=function(e){for(var t=-1;++t<e.length;)this.state[t]^=e[t];this._multiply();},lu.prototype._multiply=function(){for(var e,t,n,r=[(e=this.h).readUInt32BE(0),e.readUInt32BE(4),e.readUInt32BE(8),e.readUInt32BE(12)],i=[0,0,0,0],o=-1;++o<128;){for(0!=(this.state[~~(o/8)]&1<<7-o%8)&&(i[0]^=r[0],i[1]^=r[1],i[2]^=r[2],i[3]^=r[3]),n=0!=(1&r[3]),t=3;t>0;t--)r[t]=r[t]>>>1|(1&r[t-1])<<31;r[0]=r[0]>>>1,n&&(r[0]=r[0]^225<<24);}this.state=uu(i);},lu.prototype.update=function(e){var t;for(this.cache=au.concat([this.cache,e]);this.cache.length>=16;)t=this.cache.slice(0,16),this.cache=this.cache.slice(16),this.ghash(t);},lu.prototype.final=function(e,t){return this.cache.length&&this.ghash(au.concat([this.cache,su],16)),this.ghash(uu([0,e,0,t])),this.state};var cu=lu,du=Js,fu=Ue().Buffer,hu=Do,pu=cu,mu=Ms,gu=Ks;function vu(e,t,n,r){hu.call(this);var i=fu.alloc(4,0);this._cipher=new du.AES(t);var o=this._cipher.encryptBlock(i);this._ghash=new pu(o),n=function(e,t,n){if(12===t.length)return e._finID=fu.concat([t,fu.from([0,0,0,1])]),fu.concat([t,fu.from([0,0,0,2])]);var r=new pu(n),i=t.length,o=i%16;r.update(t),o&&(o=16-o,r.update(fu.alloc(o,0))),r.update(fu.alloc(8,0));var a=8*i,s=fu.alloc(8);s.writeUIntBE(a,0,8),r.update(s),e._finID=r.state;var u=fu.from(e._finID);return gu(u),u}(this,n,o),this._prev=fu.from(n),this._cache=fu.allocUnsafe(0),this._secCache=fu.allocUnsafe(0),this._decrypt=r,this._alen=0,this._len=0,this._mode=e,this._authTag=null,this._called=false;}Ve(vu,hu),vu.prototype._update=function(e){if(!this._called&&this._alen){var t=16-this._alen%16;t<16&&(t=fu.alloc(t,0),this._ghash.update(t));}this._called=true;var n=this._mode.encrypt(this,e);return this._decrypt?this._ghash.update(e):this._ghash.update(n),this._len+=e.length,n},vu.prototype._final=function(){if(this._decrypt&&!this._authTag)throw new Error("Unsupported state or unable to authenticate data");var e=mu(this._ghash.final(8*this._alen,8*this._len),this._cipher.encryptBlock(this._finID));if(this._decrypt&&function(e,t){var n=0;e.length!==t.length&&n++;for(var r=Math.min(e.length,t.length),i=0;i<r;++i)n+=e[i]^t[i];return n}(e,this._authTag))throw new Error("Unsupported state or unable to authenticate data");this._authTag=e,this._cipher.scrub();},vu.prototype.getAuthTag=function(){if(this._decrypt||!fu.isBuffer(this._authTag))throw new Error("Attempting to get auth tag in unsupported state");return this._authTag},vu.prototype.setAuthTag=function(e){if(!this._decrypt)throw new Error("Attempting to set auth tag in unsupported state");this._authTag=e;},vu.prototype.setAAD=function(e){if(this._called)throw new Error("Attempting to set AAD in unsupported state");this._ghash.update(e),this._alen+=e.length;};var bu=vu,yu=Js,wu=Ue().Buffer,_u=Do;function Su(e,t,n,r){_u.call(this),this._cipher=new yu.AES(t),this._prev=wu.from(n),this._cache=wu.allocUnsafe(0),this._secCache=wu.allocUnsafe(0),this._decrypt=r,this._mode=e;}Ve(Su,_u),Su.prototype._update=function(e){return this._mode.encrypt(this,e,this._decrypt)},Su.prototype._final=function(){this._cipher.scrub();};var Eu=Su,ku=Ue().Buffer,Mu=or;var Cu=function(e,t,n,r){if(ku.isBuffer(e)||(e=ku.from(e,"binary")),t&&(ku.isBuffer(t)||(t=ku.from(t,"binary")),8!==t.length))throw new RangeError("salt should be Buffer with 8 byte length");for(var i=n/8,o=ku.alloc(i),a=ku.alloc(r||0),s=ku.alloc(0);i>0||r>0;){var u=new Mu;u.update(s),u.update(e),t&&u.update(t),s=u.digest();var l=0;if(i>0){var c=o.length-i;l=Math.min(i,s.length),s.copy(o,c,0,l),i-=l;}if(l<s.length&&r>0){var d=a.length-r,f=Math.min(r,s.length-l);s.copy(a,d,l,l+f),r-=f;}}return s.fill(0),{key:o,iv:a}},xu=Qs,Au=bu,Ru=Ue().Buffer,Tu=Eu,Pu=Do,Lu=Js,Iu=Cu;function Ou(e,t,n){Pu.call(this),this._cache=new Du,this._cipher=new Lu.AES(t),this._prev=Ru.from(n),this._mode=e,this._autopadding=true;}Ve(Ou,Pu),Ou.prototype._update=function(e){var t,n;this._cache.add(e);for(var r=[];t=this._cache.get();)n=this._mode.encrypt(this,t),r.push(n);return Ru.concat(r)};var Nu=Ru.alloc(16,16);function Du(){this.cache=Ru.allocUnsafe(0);}function ju(e,t,n){var r=xu[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");if("string"==typeof t&&(t=Ru.from(t)),t.length!==r.key/8)throw new TypeError("invalid key length "+t.length);if("string"==typeof n&&(n=Ru.from(n)),"GCM"!==r.mode&&n.length!==r.iv)throw new TypeError("invalid iv length "+n.length);return "stream"===r.type?new Tu(r.module,t,n):"auth"===r.type?new Au(r.module,t,n):new Ou(r.module,t,n)}Ou.prototype._final=function(){var e=this._cache.flush();if(this._autopadding)return e=this._mode.encrypt(this,e),this._cipher.scrub(),e;if(!e.equals(Nu))throw this._cipher.scrub(),new Error("data not multiple of block length")},Ou.prototype.setAutoPadding=function(e){return this._autopadding=!!e,this},Du.prototype.add=function(e){this.cache=Ru.concat([this.cache,e]);},Du.prototype.get=function(){if(this.cache.length>15){var e=this.cache.slice(0,16);return this.cache=this.cache.slice(16),e}return null},Du.prototype.flush=function(){for(var e=16-this.cache.length,t=Ru.allocUnsafe(e),n=-1;++n<e;)t.writeUInt8(e,n);return Ru.concat([this.cache,t])},Ss.createCipheriv=ju,Ss.createCipher=function(e,t){var n=xu[e.toLowerCase()];if(!n)throw new TypeError("invalid suite type");var r=Iu(t,false,n.key,n.iv);return ju(e,r.key,r.iv)};var Bu={},zu=bu,Uu=Ue().Buffer,Fu=Qs,Ku=Eu,qu=Do,Hu=Js,Wu=Cu;function $u(e,t,n){qu.call(this),this._cache=new Vu,this._last=void 0,this._cipher=new Hu.AES(t),this._prev=Uu.from(n),this._mode=e,this._autopadding=true;}function Vu(){this.cache=Uu.allocUnsafe(0);}function Yu(e,t,n){var r=Fu[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");if("string"==typeof n&&(n=Uu.from(n)),"GCM"!==r.mode&&n.length!==r.iv)throw new TypeError("invalid iv length "+n.length);if("string"==typeof t&&(t=Uu.from(t)),t.length!==r.key/8)throw new TypeError("invalid key length "+t.length);return "stream"===r.type?new Ku(r.module,t,n,true):"auth"===r.type?new zu(r.module,t,n,true):new $u(r.module,t,n)}Ve($u,qu),$u.prototype._update=function(e){var t,n;this._cache.add(e);for(var r=[];t=this._cache.get(this._autopadding);)n=this._mode.decrypt(this,t),r.push(n);return Uu.concat(r)},$u.prototype._final=function(){var e=this._cache.flush();if(this._autopadding)return function(e){var t=e[15];if(t<1||t>16)throw new Error("unable to decrypt data");var n=-1;for(;++n<t;)if(e[n+(16-t)]!==t)throw new Error("unable to decrypt data");if(16===t)return;return e.slice(0,16-t)}(this._mode.decrypt(this,e));if(e)throw new Error("data not multiple of block length")},$u.prototype.setAutoPadding=function(e){return this._autopadding=!!e,this},Vu.prototype.add=function(e){this.cache=Uu.concat([this.cache,e]);},Vu.prototype.get=function(e){var t;if(e){if(this.cache.length>16)return t=this.cache.slice(0,16),this.cache=this.cache.slice(16),t}else if(this.cache.length>=16)return t=this.cache.slice(0,16),this.cache=this.cache.slice(16),t;return null},Vu.prototype.flush=function(){if(this.cache.length)return this.cache},Bu.createDecipher=function(e,t){var n=Fu[e.toLowerCase()];if(!n)throw new TypeError("invalid suite type");var r=Wu(t,false,n.key,n.iv);return Yu(e,r.key,r.iv)},Bu.createDecipheriv=Yu;var Gu=Ss,Zu=Bu,Qu=Vs;_s.createCipher=_s.Cipher=Gu.createCipher,_s.createCipheriv=_s.Cipheriv=Gu.createCipheriv,_s.createDecipher=_s.Decipher=Zu.createDecipher,_s.createDecipheriv=_s.Decipheriv=Zu.createDecipheriv,_s.listCiphers=_s.getCiphers=function(){return Object.keys(Qu)};var Ju={};!function(e){e["des-ecb"]={key:8,iv:0},e["des-cbc"]=e.des={key:8,iv:8},e["des-ede3-cbc"]=e.des3={key:24,iv:8},e["des-ede3"]={key:24,iv:0},e["des-ede-cbc"]={key:16,iv:8},e["des-ede"]={key:16,iv:0};}(Ju);var Xu=ys,el=_s,tl=Qs,nl=Ju,rl=Cu;function il(e,t,n){if(e=e.toLowerCase(),tl[e])return el.createCipheriv(e,t,n);if(nl[e])return new Xu({key:t,iv:n,mode:e});throw new TypeError("invalid suite type")}function ol(e,t,n){if(e=e.toLowerCase(),tl[e])return el.createDecipheriv(e,t,n);if(nl[e])return new Xu({key:t,iv:n,mode:e,decrypt:true});throw new TypeError("invalid suite type")}za.createCipher=za.Cipher=function(e,t){var n,r;if(e=e.toLowerCase(),tl[e])n=tl[e].key,r=tl[e].iv;else {if(!nl[e])throw new TypeError("invalid suite type");n=8*nl[e].key,r=nl[e].iv;}var i=rl(t,false,n,r);return il(e,i.key,i.iv)},za.createCipheriv=za.Cipheriv=il,za.createDecipher=za.Decipher=function(e,t){var n,r;if(e=e.toLowerCase(),tl[e])n=tl[e].key,r=tl[e].iv;else {if(!nl[e])throw new TypeError("invalid suite type");n=8*nl[e].key,r=nl[e].iv;}var i=rl(t,false,n,r);return ol(e,i.key,i.iv)},za.createDecipheriv=za.Decipheriv=ol,za.listCiphers=za.getCiphers=function(){return Object.keys(nl).concat(el.getCiphers())};var al={},sl={exports:{}};!function(e){!function(e,t){function n(e,t){if(!e)throw new Error(t||"Assertion failed")}function r(e,t){e.super_=t;var n=function(){};n.prototype=t.prototype,e.prototype=new n,e.prototype.constructor=e;}function i(e,t,n){if(i.isBN(e))return e;this.negative=0,this.words=null,this.length=0,this.red=null,null!==e&&("le"!==t&&"be"!==t||(n=t,t=10),this._init(e||0,t||10,n||"be"));}var o;"object"==typeof e?e.exports=i:t.BN=i,i.BN=i,i.wordSize=26;try{o="undefined"!=typeof window&&void 0!==window.Buffer?window.Buffer:ce.Buffer;}catch(e){}function a(e,t){var n=e.charCodeAt(t);return n>=65&&n<=70?n-55:n>=97&&n<=102?n-87:n-48&15}function s(e,t,n){var r=a(e,n);return n-1>=t&&(r|=a(e,n-1)<<4),r}function u(e,t,n,r){for(var i=0,o=Math.min(e.length,n),a=t;a<o;a++){var s=e.charCodeAt(a)-48;i*=r,i+=s>=49?s-49+10:s>=17?s-17+10:s;}return i}i.isBN=function(e){return e instanceof i||null!==e&&"object"==typeof e&&e.constructor.wordSize===i.wordSize&&Array.isArray(e.words)},i.max=function(e,t){return e.cmp(t)>0?e:t},i.min=function(e,t){return e.cmp(t)<0?e:t},i.prototype._init=function(e,t,r){if("number"==typeof e)return this._initNumber(e,t,r);if("object"==typeof e)return this._initArray(e,t,r);"hex"===t&&(t=16),n(t===(0|t)&&t>=2&&t<=36);var i=0;"-"===(e=e.toString().replace(/\s+/g,""))[0]&&(i++,this.negative=1),i<e.length&&(16===t?this._parseHex(e,i,r):(this._parseBase(e,t,i),"le"===r&&this._initArray(this.toArray(),t,r)));},i.prototype._initNumber=function(e,t,r){e<0&&(this.negative=1,e=-e),e<67108864?(this.words=[67108863&e],this.length=1):e<4503599627370496?(this.words=[67108863&e,e/67108864&67108863],this.length=2):(n(e<9007199254740992),this.words=[67108863&e,e/67108864&67108863,1],this.length=3),"le"===r&&this._initArray(this.toArray(),t,r);},i.prototype._initArray=function(e,t,r){if(n("number"==typeof e.length),e.length<=0)return this.words=[0],this.length=1,this;this.length=Math.ceil(e.length/3),this.words=new Array(this.length);for(var i=0;i<this.length;i++)this.words[i]=0;var o,a,s=0;if("be"===r)for(i=e.length-1,o=0;i>=0;i-=3)a=e[i]|e[i-1]<<8|e[i-2]<<16,this.words[o]|=a<<s&67108863,this.words[o+1]=a>>>26-s&67108863,(s+=24)>=26&&(s-=26,o++);else if("le"===r)for(i=0,o=0;i<e.length;i+=3)a=e[i]|e[i+1]<<8|e[i+2]<<16,this.words[o]|=a<<s&67108863,this.words[o+1]=a>>>26-s&67108863,(s+=24)>=26&&(s-=26,o++);return this.strip()},i.prototype._parseHex=function(e,t,n){this.length=Math.ceil((e.length-t)/6),this.words=new Array(this.length);for(var r=0;r<this.length;r++)this.words[r]=0;var i,o=0,a=0;if("be"===n)for(r=e.length-1;r>=t;r-=2)i=s(e,t,r)<<o,this.words[a]|=67108863&i,o>=18?(o-=18,a+=1,this.words[a]|=i>>>26):o+=8;else for(r=(e.length-t)%2==0?t+1:t;r<e.length;r+=2)i=s(e,t,r)<<o,this.words[a]|=67108863&i,o>=18?(o-=18,a+=1,this.words[a]|=i>>>26):o+=8;this.strip();},i.prototype._parseBase=function(e,t,n){this.words=[0],this.length=1;for(var r=0,i=1;i<=67108863;i*=t)r++;r--,i=i/t|0;for(var o=e.length-n,a=o%r,s=Math.min(o,o-a)+n,l=0,c=n;c<s;c+=r)l=u(e,c,c+r,t),this.imuln(i),this.words[0]+l<67108864?this.words[0]+=l:this._iaddn(l);if(0!==a){var d=1;for(l=u(e,c,e.length,t),c=0;c<a;c++)d*=t;this.imuln(d),this.words[0]+l<67108864?this.words[0]+=l:this._iaddn(l);}this.strip();},i.prototype.copy=function(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++)e.words[t]=this.words[t];e.length=this.length,e.negative=this.negative,e.red=this.red;},i.prototype.clone=function(){var e=new i(null);return this.copy(e),e},i.prototype._expand=function(e){for(;this.length<e;)this.words[this.length++]=0;return this},i.prototype.strip=function(){for(;this.length>1&&0===this.words[this.length-1];)this.length--;return this._normSign()},i.prototype._normSign=function(){return 1===this.length&&0===this.words[0]&&(this.negative=0),this},i.prototype.inspect=function(){return (this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"};var l=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"],c=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5],d=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];function f(e,t,n){n.negative=t.negative^e.negative;var r=e.length+t.length|0;n.length=r,r=r-1|0;var i=0|e.words[0],o=0|t.words[0],a=i*o,s=67108863&a,u=a/67108864|0;n.words[0]=s;for(var l=1;l<r;l++){for(var c=u>>>26,d=67108863&u,f=Math.min(l,t.length-1),h=Math.max(0,l-e.length+1);h<=f;h++){var p=l-h|0;c+=(a=(i=0|e.words[p])*(o=0|t.words[h])+d)/67108864|0,d=67108863&a;}n.words[l]=0|d,u=0|c;}return 0!==u?n.words[l]=0|u:n.length--,n.strip()}i.prototype.toString=function(e,t){var r;if(t=0|t||1,16===(e=e||10)||"hex"===e){r="";for(var i=0,o=0,a=0;a<this.length;a++){var s=this.words[a],u=(16777215&(s<<i|o)).toString(16);r=0!==(o=s>>>24-i&16777215)||a!==this.length-1?l[6-u.length]+u+r:u+r,(i+=2)>=26&&(i-=26,a--);}for(0!==o&&(r=o.toString(16)+r);r.length%t!=0;)r="0"+r;return 0!==this.negative&&(r="-"+r),r}if(e===(0|e)&&e>=2&&e<=36){var f=c[e],h=d[e];r="";var p=this.clone();for(p.negative=0;!p.isZero();){var m=p.modn(h).toString(e);r=(p=p.idivn(h)).isZero()?m+r:l[f-m.length]+m+r;}for(this.isZero()&&(r="0"+r);r.length%t!=0;)r="0"+r;return 0!==this.negative&&(r="-"+r),r}n(false,"Base should be between 2 and 36");},i.prototype.toNumber=function(){var e=this.words[0];return 2===this.length?e+=67108864*this.words[1]:3===this.length&&1===this.words[2]?e+=4503599627370496+67108864*this.words[1]:this.length>2&&n(false,"Number can only safely store up to 53 bits"),0!==this.negative?-e:e},i.prototype.toJSON=function(){return this.toString(16)},i.prototype.toBuffer=function(e,t){return n(void 0!==o),this.toArrayLike(o,e,t)},i.prototype.toArray=function(e,t){return this.toArrayLike(Array,e,t)},i.prototype.toArrayLike=function(e,t,r){var i=this.byteLength(),o=r||Math.max(1,i);n(i<=o,"byte array longer than desired length"),n(o>0,"Requested array length <= 0"),this.strip();var a,s,u="le"===t,l=new e(o),c=this.clone();if(u){for(s=0;!c.isZero();s++)a=c.andln(255),c.iushrn(8),l[s]=a;for(;s<o;s++)l[s]=0;}else {for(s=0;s<o-i;s++)l[s]=0;for(s=0;!c.isZero();s++)a=c.andln(255),c.iushrn(8),l[o-s-1]=a;}return l},Math.clz32?i.prototype._countBits=function(e){return 32-Math.clz32(e)}:i.prototype._countBits=function(e){var t=e,n=0;return t>=4096&&(n+=13,t>>>=13),t>=64&&(n+=7,t>>>=7),t>=8&&(n+=4,t>>>=4),t>=2&&(n+=2,t>>>=2),n+t},i.prototype._zeroBits=function(e){if(0===e)return 26;var t=e,n=0;return 0==(8191&t)&&(n+=13,t>>>=13),0==(127&t)&&(n+=7,t>>>=7),0==(15&t)&&(n+=4,t>>>=4),0==(3&t)&&(n+=2,t>>>=2),0==(1&t)&&n++,n},i.prototype.bitLength=function(){var e=this.words[this.length-1],t=this._countBits(e);return 26*(this.length-1)+t},i.prototype.zeroBits=function(){if(this.isZero())return 0;for(var e=0,t=0;t<this.length;t++){var n=this._zeroBits(this.words[t]);if(e+=n,26!==n)break}return e},i.prototype.byteLength=function(){return Math.ceil(this.bitLength()/8)},i.prototype.toTwos=function(e){return 0!==this.negative?this.abs().inotn(e).iaddn(1):this.clone()},i.prototype.fromTwos=function(e){return this.testn(e-1)?this.notn(e).iaddn(1).ineg():this.clone()},i.prototype.isNeg=function(){return 0!==this.negative},i.prototype.neg=function(){return this.clone().ineg()},i.prototype.ineg=function(){return this.isZero()||(this.negative^=1),this},i.prototype.iuor=function(e){for(;this.length<e.length;)this.words[this.length++]=0;for(var t=0;t<e.length;t++)this.words[t]=this.words[t]|e.words[t];return this.strip()},i.prototype.ior=function(e){return n(0==(this.negative|e.negative)),this.iuor(e)},i.prototype.or=function(e){return this.length>e.length?this.clone().ior(e):e.clone().ior(this)},i.prototype.uor=function(e){return this.length>e.length?this.clone().iuor(e):e.clone().iuor(this)},i.prototype.iuand=function(e){var t;t=this.length>e.length?e:this;for(var n=0;n<t.length;n++)this.words[n]=this.words[n]&e.words[n];return this.length=t.length,this.strip()},i.prototype.iand=function(e){return n(0==(this.negative|e.negative)),this.iuand(e)},i.prototype.and=function(e){return this.length>e.length?this.clone().iand(e):e.clone().iand(this)},i.prototype.uand=function(e){return this.length>e.length?this.clone().iuand(e):e.clone().iuand(this)},i.prototype.iuxor=function(e){var t,n;this.length>e.length?(t=this,n=e):(t=e,n=this);for(var r=0;r<n.length;r++)this.words[r]=t.words[r]^n.words[r];if(this!==t)for(;r<t.length;r++)this.words[r]=t.words[r];return this.length=t.length,this.strip()},i.prototype.ixor=function(e){return n(0==(this.negative|e.negative)),this.iuxor(e)},i.prototype.xor=function(e){return this.length>e.length?this.clone().ixor(e):e.clone().ixor(this)},i.prototype.uxor=function(e){return this.length>e.length?this.clone().iuxor(e):e.clone().iuxor(this)},i.prototype.inotn=function(e){n("number"==typeof e&&e>=0);var t=0|Math.ceil(e/26),r=e%26;this._expand(t),r>0&&t--;for(var i=0;i<t;i++)this.words[i]=67108863&~this.words[i];return r>0&&(this.words[i]=~this.words[i]&67108863>>26-r),this.strip()},i.prototype.notn=function(e){return this.clone().inotn(e)},i.prototype.setn=function(e,t){n("number"==typeof e&&e>=0);var r=e/26|0,i=e%26;return this._expand(r+1),this.words[r]=t?this.words[r]|1<<i:this.words[r]&~(1<<i),this.strip()},i.prototype.iadd=function(e){var t,n,r;if(0!==this.negative&&0===e.negative)return this.negative=0,t=this.isub(e),this.negative^=1,this._normSign();if(0===this.negative&&0!==e.negative)return e.negative=0,t=this.isub(e),e.negative=1,t._normSign();this.length>e.length?(n=this,r=e):(n=e,r=this);for(var i=0,o=0;o<r.length;o++)t=(0|n.words[o])+(0|r.words[o])+i,this.words[o]=67108863&t,i=t>>>26;for(;0!==i&&o<n.length;o++)t=(0|n.words[o])+i,this.words[o]=67108863&t,i=t>>>26;if(this.length=n.length,0!==i)this.words[this.length]=i,this.length++;else if(n!==this)for(;o<n.length;o++)this.words[o]=n.words[o];return this},i.prototype.add=function(e){var t;return 0!==e.negative&&0===this.negative?(e.negative=0,t=this.sub(e),e.negative^=1,t):0===e.negative&&0!==this.negative?(this.negative=0,t=e.sub(this),this.negative=1,t):this.length>e.length?this.clone().iadd(e):e.clone().iadd(this)},i.prototype.isub=function(e){if(0!==e.negative){e.negative=0;var t=this.iadd(e);return e.negative=1,t._normSign()}if(0!==this.negative)return this.negative=0,this.iadd(e),this.negative=1,this._normSign();var n,r,i=this.cmp(e);if(0===i)return this.negative=0,this.length=1,this.words[0]=0,this;i>0?(n=this,r=e):(n=e,r=this);for(var o=0,a=0;a<r.length;a++)o=(t=(0|n.words[a])-(0|r.words[a])+o)>>26,this.words[a]=67108863&t;for(;0!==o&&a<n.length;a++)o=(t=(0|n.words[a])+o)>>26,this.words[a]=67108863&t;if(0===o&&a<n.length&&n!==this)for(;a<n.length;a++)this.words[a]=n.words[a];return this.length=Math.max(this.length,a),n!==this&&(this.negative=1),this.strip()},i.prototype.sub=function(e){return this.clone().isub(e)};var h=function(e,t,n){var r,i,o,a=e.words,s=t.words,u=n.words,l=0,c=0|a[0],d=8191&c,f=c>>>13,h=0|a[1],p=8191&h,m=h>>>13,g=0|a[2],v=8191&g,b=g>>>13,y=0|a[3],w=8191&y,_=y>>>13,S=0|a[4],E=8191&S,k=S>>>13,M=0|a[5],C=8191&M,x=M>>>13,A=0|a[6],R=8191&A,T=A>>>13,P=0|a[7],L=8191&P,I=P>>>13,O=0|a[8],N=8191&O,D=O>>>13,j=0|a[9],B=8191&j,z=j>>>13,U=0|s[0],F=8191&U,K=U>>>13,q=0|s[1],H=8191&q,W=q>>>13,$=0|s[2],V=8191&$,Y=$>>>13,G=0|s[3],Z=8191&G,Q=G>>>13,J=0|s[4],X=8191&J,ee=J>>>13,te=0|s[5],ne=8191&te,re=te>>>13,ie=0|s[6],oe=8191&ie,ae=ie>>>13,se=0|s[7],ue=8191&se,le=se>>>13,ce=0|s[8],de=8191&ce,fe=ce>>>13,he=0|s[9],pe=8191&he,me=he>>>13;n.negative=e.negative^t.negative,n.length=19;var ge=(l+(r=Math.imul(d,F))|0)+((8191&(i=(i=Math.imul(d,K))+Math.imul(f,F)|0))<<13)|0;l=((o=Math.imul(f,K))+(i>>>13)|0)+(ge>>>26)|0,ge&=67108863,r=Math.imul(p,F),i=(i=Math.imul(p,K))+Math.imul(m,F)|0,o=Math.imul(m,K);var ve=(l+(r=r+Math.imul(d,H)|0)|0)+((8191&(i=(i=i+Math.imul(d,W)|0)+Math.imul(f,H)|0))<<13)|0;l=((o=o+Math.imul(f,W)|0)+(i>>>13)|0)+(ve>>>26)|0,ve&=67108863,r=Math.imul(v,F),i=(i=Math.imul(v,K))+Math.imul(b,F)|0,o=Math.imul(b,K),r=r+Math.imul(p,H)|0,i=(i=i+Math.imul(p,W)|0)+Math.imul(m,H)|0,o=o+Math.imul(m,W)|0;var be=(l+(r=r+Math.imul(d,V)|0)|0)+((8191&(i=(i=i+Math.imul(d,Y)|0)+Math.imul(f,V)|0))<<13)|0;l=((o=o+Math.imul(f,Y)|0)+(i>>>13)|0)+(be>>>26)|0,be&=67108863,r=Math.imul(w,F),i=(i=Math.imul(w,K))+Math.imul(_,F)|0,o=Math.imul(_,K),r=r+Math.imul(v,H)|0,i=(i=i+Math.imul(v,W)|0)+Math.imul(b,H)|0,o=o+Math.imul(b,W)|0,r=r+Math.imul(p,V)|0,i=(i=i+Math.imul(p,Y)|0)+Math.imul(m,V)|0,o=o+Math.imul(m,Y)|0;var ye=(l+(r=r+Math.imul(d,Z)|0)|0)+((8191&(i=(i=i+Math.imul(d,Q)|0)+Math.imul(f,Z)|0))<<13)|0;l=((o=o+Math.imul(f,Q)|0)+(i>>>13)|0)+(ye>>>26)|0,ye&=67108863,r=Math.imul(E,F),i=(i=Math.imul(E,K))+Math.imul(k,F)|0,o=Math.imul(k,K),r=r+Math.imul(w,H)|0,i=(i=i+Math.imul(w,W)|0)+Math.imul(_,H)|0,o=o+Math.imul(_,W)|0,r=r+Math.imul(v,V)|0,i=(i=i+Math.imul(v,Y)|0)+Math.imul(b,V)|0,o=o+Math.imul(b,Y)|0,r=r+Math.imul(p,Z)|0,i=(i=i+Math.imul(p,Q)|0)+Math.imul(m,Z)|0,o=o+Math.imul(m,Q)|0;var we=(l+(r=r+Math.imul(d,X)|0)|0)+((8191&(i=(i=i+Math.imul(d,ee)|0)+Math.imul(f,X)|0))<<13)|0;l=((o=o+Math.imul(f,ee)|0)+(i>>>13)|0)+(we>>>26)|0,we&=67108863,r=Math.imul(C,F),i=(i=Math.imul(C,K))+Math.imul(x,F)|0,o=Math.imul(x,K),r=r+Math.imul(E,H)|0,i=(i=i+Math.imul(E,W)|0)+Math.imul(k,H)|0,o=o+Math.imul(k,W)|0,r=r+Math.imul(w,V)|0,i=(i=i+Math.imul(w,Y)|0)+Math.imul(_,V)|0,o=o+Math.imul(_,Y)|0,r=r+Math.imul(v,Z)|0,i=(i=i+Math.imul(v,Q)|0)+Math.imul(b,Z)|0,o=o+Math.imul(b,Q)|0,r=r+Math.imul(p,X)|0,i=(i=i+Math.imul(p,ee)|0)+Math.imul(m,X)|0,o=o+Math.imul(m,ee)|0;var _e=(l+(r=r+Math.imul(d,ne)|0)|0)+((8191&(i=(i=i+Math.imul(d,re)|0)+Math.imul(f,ne)|0))<<13)|0;l=((o=o+Math.imul(f,re)|0)+(i>>>13)|0)+(_e>>>26)|0,_e&=67108863,r=Math.imul(R,F),i=(i=Math.imul(R,K))+Math.imul(T,F)|0,o=Math.imul(T,K),r=r+Math.imul(C,H)|0,i=(i=i+Math.imul(C,W)|0)+Math.imul(x,H)|0,o=o+Math.imul(x,W)|0,r=r+Math.imul(E,V)|0,i=(i=i+Math.imul(E,Y)|0)+Math.imul(k,V)|0,o=o+Math.imul(k,Y)|0,r=r+Math.imul(w,Z)|0,i=(i=i+Math.imul(w,Q)|0)+Math.imul(_,Z)|0,o=o+Math.imul(_,Q)|0,r=r+Math.imul(v,X)|0,i=(i=i+Math.imul(v,ee)|0)+Math.imul(b,X)|0,o=o+Math.imul(b,ee)|0,r=r+Math.imul(p,ne)|0,i=(i=i+Math.imul(p,re)|0)+Math.imul(m,ne)|0,o=o+Math.imul(m,re)|0;var Se=(l+(r=r+Math.imul(d,oe)|0)|0)+((8191&(i=(i=i+Math.imul(d,ae)|0)+Math.imul(f,oe)|0))<<13)|0;l=((o=o+Math.imul(f,ae)|0)+(i>>>13)|0)+(Se>>>26)|0,Se&=67108863,r=Math.imul(L,F),i=(i=Math.imul(L,K))+Math.imul(I,F)|0,o=Math.imul(I,K),r=r+Math.imul(R,H)|0,i=(i=i+Math.imul(R,W)|0)+Math.imul(T,H)|0,o=o+Math.imul(T,W)|0,r=r+Math.imul(C,V)|0,i=(i=i+Math.imul(C,Y)|0)+Math.imul(x,V)|0,o=o+Math.imul(x,Y)|0,r=r+Math.imul(E,Z)|0,i=(i=i+Math.imul(E,Q)|0)+Math.imul(k,Z)|0,o=o+Math.imul(k,Q)|0,r=r+Math.imul(w,X)|0,i=(i=i+Math.imul(w,ee)|0)+Math.imul(_,X)|0,o=o+Math.imul(_,ee)|0,r=r+Math.imul(v,ne)|0,i=(i=i+Math.imul(v,re)|0)+Math.imul(b,ne)|0,o=o+Math.imul(b,re)|0,r=r+Math.imul(p,oe)|0,i=(i=i+Math.imul(p,ae)|0)+Math.imul(m,oe)|0,o=o+Math.imul(m,ae)|0;var Ee=(l+(r=r+Math.imul(d,ue)|0)|0)+((8191&(i=(i=i+Math.imul(d,le)|0)+Math.imul(f,ue)|0))<<13)|0;l=((o=o+Math.imul(f,le)|0)+(i>>>13)|0)+(Ee>>>26)|0,Ee&=67108863,r=Math.imul(N,F),i=(i=Math.imul(N,K))+Math.imul(D,F)|0,o=Math.imul(D,K),r=r+Math.imul(L,H)|0,i=(i=i+Math.imul(L,W)|0)+Math.imul(I,H)|0,o=o+Math.imul(I,W)|0,r=r+Math.imul(R,V)|0,i=(i=i+Math.imul(R,Y)|0)+Math.imul(T,V)|0,o=o+Math.imul(T,Y)|0,r=r+Math.imul(C,Z)|0,i=(i=i+Math.imul(C,Q)|0)+Math.imul(x,Z)|0,o=o+Math.imul(x,Q)|0,r=r+Math.imul(E,X)|0,i=(i=i+Math.imul(E,ee)|0)+Math.imul(k,X)|0,o=o+Math.imul(k,ee)|0,r=r+Math.imul(w,ne)|0,i=(i=i+Math.imul(w,re)|0)+Math.imul(_,ne)|0,o=o+Math.imul(_,re)|0,r=r+Math.imul(v,oe)|0,i=(i=i+Math.imul(v,ae)|0)+Math.imul(b,oe)|0,o=o+Math.imul(b,ae)|0,r=r+Math.imul(p,ue)|0,i=(i=i+Math.imul(p,le)|0)+Math.imul(m,ue)|0,o=o+Math.imul(m,le)|0;var ke=(l+(r=r+Math.imul(d,de)|0)|0)+((8191&(i=(i=i+Math.imul(d,fe)|0)+Math.imul(f,de)|0))<<13)|0;l=((o=o+Math.imul(f,fe)|0)+(i>>>13)|0)+(ke>>>26)|0,ke&=67108863,r=Math.imul(B,F),i=(i=Math.imul(B,K))+Math.imul(z,F)|0,o=Math.imul(z,K),r=r+Math.imul(N,H)|0,i=(i=i+Math.imul(N,W)|0)+Math.imul(D,H)|0,o=o+Math.imul(D,W)|0,r=r+Math.imul(L,V)|0,i=(i=i+Math.imul(L,Y)|0)+Math.imul(I,V)|0,o=o+Math.imul(I,Y)|0,r=r+Math.imul(R,Z)|0,i=(i=i+Math.imul(R,Q)|0)+Math.imul(T,Z)|0,o=o+Math.imul(T,Q)|0,r=r+Math.imul(C,X)|0,i=(i=i+Math.imul(C,ee)|0)+Math.imul(x,X)|0,o=o+Math.imul(x,ee)|0,r=r+Math.imul(E,ne)|0,i=(i=i+Math.imul(E,re)|0)+Math.imul(k,ne)|0,o=o+Math.imul(k,re)|0,r=r+Math.imul(w,oe)|0,i=(i=i+Math.imul(w,ae)|0)+Math.imul(_,oe)|0,o=o+Math.imul(_,ae)|0,r=r+Math.imul(v,ue)|0,i=(i=i+Math.imul(v,le)|0)+Math.imul(b,ue)|0,o=o+Math.imul(b,le)|0,r=r+Math.imul(p,de)|0,i=(i=i+Math.imul(p,fe)|0)+Math.imul(m,de)|0,o=o+Math.imul(m,fe)|0;var Me=(l+(r=r+Math.imul(d,pe)|0)|0)+((8191&(i=(i=i+Math.imul(d,me)|0)+Math.imul(f,pe)|0))<<13)|0;l=((o=o+Math.imul(f,me)|0)+(i>>>13)|0)+(Me>>>26)|0,Me&=67108863,r=Math.imul(B,H),i=(i=Math.imul(B,W))+Math.imul(z,H)|0,o=Math.imul(z,W),r=r+Math.imul(N,V)|0,i=(i=i+Math.imul(N,Y)|0)+Math.imul(D,V)|0,o=o+Math.imul(D,Y)|0,r=r+Math.imul(L,Z)|0,i=(i=i+Math.imul(L,Q)|0)+Math.imul(I,Z)|0,o=o+Math.imul(I,Q)|0,r=r+Math.imul(R,X)|0,i=(i=i+Math.imul(R,ee)|0)+Math.imul(T,X)|0,o=o+Math.imul(T,ee)|0,r=r+Math.imul(C,ne)|0,i=(i=i+Math.imul(C,re)|0)+Math.imul(x,ne)|0,o=o+Math.imul(x,re)|0,r=r+Math.imul(E,oe)|0,i=(i=i+Math.imul(E,ae)|0)+Math.imul(k,oe)|0,o=o+Math.imul(k,ae)|0,r=r+Math.imul(w,ue)|0,i=(i=i+Math.imul(w,le)|0)+Math.imul(_,ue)|0,o=o+Math.imul(_,le)|0,r=r+Math.imul(v,de)|0,i=(i=i+Math.imul(v,fe)|0)+Math.imul(b,de)|0,o=o+Math.imul(b,fe)|0;var Ce=(l+(r=r+Math.imul(p,pe)|0)|0)+((8191&(i=(i=i+Math.imul(p,me)|0)+Math.imul(m,pe)|0))<<13)|0;l=((o=o+Math.imul(m,me)|0)+(i>>>13)|0)+(Ce>>>26)|0,Ce&=67108863,r=Math.imul(B,V),i=(i=Math.imul(B,Y))+Math.imul(z,V)|0,o=Math.imul(z,Y),r=r+Math.imul(N,Z)|0,i=(i=i+Math.imul(N,Q)|0)+Math.imul(D,Z)|0,o=o+Math.imul(D,Q)|0,r=r+Math.imul(L,X)|0,i=(i=i+Math.imul(L,ee)|0)+Math.imul(I,X)|0,o=o+Math.imul(I,ee)|0,r=r+Math.imul(R,ne)|0,i=(i=i+Math.imul(R,re)|0)+Math.imul(T,ne)|0,o=o+Math.imul(T,re)|0,r=r+Math.imul(C,oe)|0,i=(i=i+Math.imul(C,ae)|0)+Math.imul(x,oe)|0,o=o+Math.imul(x,ae)|0,r=r+Math.imul(E,ue)|0,i=(i=i+Math.imul(E,le)|0)+Math.imul(k,ue)|0,o=o+Math.imul(k,le)|0,r=r+Math.imul(w,de)|0,i=(i=i+Math.imul(w,fe)|0)+Math.imul(_,de)|0,o=o+Math.imul(_,fe)|0;var xe=(l+(r=r+Math.imul(v,pe)|0)|0)+((8191&(i=(i=i+Math.imul(v,me)|0)+Math.imul(b,pe)|0))<<13)|0;l=((o=o+Math.imul(b,me)|0)+(i>>>13)|0)+(xe>>>26)|0,xe&=67108863,r=Math.imul(B,Z),i=(i=Math.imul(B,Q))+Math.imul(z,Z)|0,o=Math.imul(z,Q),r=r+Math.imul(N,X)|0,i=(i=i+Math.imul(N,ee)|0)+Math.imul(D,X)|0,o=o+Math.imul(D,ee)|0,r=r+Math.imul(L,ne)|0,i=(i=i+Math.imul(L,re)|0)+Math.imul(I,ne)|0,o=o+Math.imul(I,re)|0,r=r+Math.imul(R,oe)|0,i=(i=i+Math.imul(R,ae)|0)+Math.imul(T,oe)|0,o=o+Math.imul(T,ae)|0,r=r+Math.imul(C,ue)|0,i=(i=i+Math.imul(C,le)|0)+Math.imul(x,ue)|0,o=o+Math.imul(x,le)|0,r=r+Math.imul(E,de)|0,i=(i=i+Math.imul(E,fe)|0)+Math.imul(k,de)|0,o=o+Math.imul(k,fe)|0;var Ae=(l+(r=r+Math.imul(w,pe)|0)|0)+((8191&(i=(i=i+Math.imul(w,me)|0)+Math.imul(_,pe)|0))<<13)|0;l=((o=o+Math.imul(_,me)|0)+(i>>>13)|0)+(Ae>>>26)|0,Ae&=67108863,r=Math.imul(B,X),i=(i=Math.imul(B,ee))+Math.imul(z,X)|0,o=Math.imul(z,ee),r=r+Math.imul(N,ne)|0,i=(i=i+Math.imul(N,re)|0)+Math.imul(D,ne)|0,o=o+Math.imul(D,re)|0,r=r+Math.imul(L,oe)|0,i=(i=i+Math.imul(L,ae)|0)+Math.imul(I,oe)|0,o=o+Math.imul(I,ae)|0,r=r+Math.imul(R,ue)|0,i=(i=i+Math.imul(R,le)|0)+Math.imul(T,ue)|0,o=o+Math.imul(T,le)|0,r=r+Math.imul(C,de)|0,i=(i=i+Math.imul(C,fe)|0)+Math.imul(x,de)|0,o=o+Math.imul(x,fe)|0;var Re=(l+(r=r+Math.imul(E,pe)|0)|0)+((8191&(i=(i=i+Math.imul(E,me)|0)+Math.imul(k,pe)|0))<<13)|0;l=((o=o+Math.imul(k,me)|0)+(i>>>13)|0)+(Re>>>26)|0,Re&=67108863,r=Math.imul(B,ne),i=(i=Math.imul(B,re))+Math.imul(z,ne)|0,o=Math.imul(z,re),r=r+Math.imul(N,oe)|0,i=(i=i+Math.imul(N,ae)|0)+Math.imul(D,oe)|0,o=o+Math.imul(D,ae)|0,r=r+Math.imul(L,ue)|0,i=(i=i+Math.imul(L,le)|0)+Math.imul(I,ue)|0,o=o+Math.imul(I,le)|0,r=r+Math.imul(R,de)|0,i=(i=i+Math.imul(R,fe)|0)+Math.imul(T,de)|0,o=o+Math.imul(T,fe)|0;var Te=(l+(r=r+Math.imul(C,pe)|0)|0)+((8191&(i=(i=i+Math.imul(C,me)|0)+Math.imul(x,pe)|0))<<13)|0;l=((o=o+Math.imul(x,me)|0)+(i>>>13)|0)+(Te>>>26)|0,Te&=67108863,r=Math.imul(B,oe),i=(i=Math.imul(B,ae))+Math.imul(z,oe)|0,o=Math.imul(z,ae),r=r+Math.imul(N,ue)|0,i=(i=i+Math.imul(N,le)|0)+Math.imul(D,ue)|0,o=o+Math.imul(D,le)|0,r=r+Math.imul(L,de)|0,i=(i=i+Math.imul(L,fe)|0)+Math.imul(I,de)|0,o=o+Math.imul(I,fe)|0;var Pe=(l+(r=r+Math.imul(R,pe)|0)|0)+((8191&(i=(i=i+Math.imul(R,me)|0)+Math.imul(T,pe)|0))<<13)|0;l=((o=o+Math.imul(T,me)|0)+(i>>>13)|0)+(Pe>>>26)|0,Pe&=67108863,r=Math.imul(B,ue),i=(i=Math.imul(B,le))+Math.imul(z,ue)|0,o=Math.imul(z,le),r=r+Math.imul(N,de)|0,i=(i=i+Math.imul(N,fe)|0)+Math.imul(D,de)|0,o=o+Math.imul(D,fe)|0;var Le=(l+(r=r+Math.imul(L,pe)|0)|0)+((8191&(i=(i=i+Math.imul(L,me)|0)+Math.imul(I,pe)|0))<<13)|0;l=((o=o+Math.imul(I,me)|0)+(i>>>13)|0)+(Le>>>26)|0,Le&=67108863,r=Math.imul(B,de),i=(i=Math.imul(B,fe))+Math.imul(z,de)|0,o=Math.imul(z,fe);var Ie=(l+(r=r+Math.imul(N,pe)|0)|0)+((8191&(i=(i=i+Math.imul(N,me)|0)+Math.imul(D,pe)|0))<<13)|0;l=((o=o+Math.imul(D,me)|0)+(i>>>13)|0)+(Ie>>>26)|0,Ie&=67108863;var Oe=(l+(r=Math.imul(B,pe))|0)+((8191&(i=(i=Math.imul(B,me))+Math.imul(z,pe)|0))<<13)|0;return l=((o=Math.imul(z,me))+(i>>>13)|0)+(Oe>>>26)|0,Oe&=67108863,u[0]=ge,u[1]=ve,u[2]=be,u[3]=ye,u[4]=we,u[5]=_e,u[6]=Se,u[7]=Ee,u[8]=ke,u[9]=Me,u[10]=Ce,u[11]=xe,u[12]=Ae,u[13]=Re,u[14]=Te,u[15]=Pe,u[16]=Le,u[17]=Ie,u[18]=Oe,0!==l&&(u[19]=l,n.length++),n};function p(e,t,n){return (new m).mulp(e,t,n)}function m(e,t){this.x=e,this.y=t;}Math.imul||(h=f),i.prototype.mulTo=function(e,t){var n,r=this.length+e.length;return n=10===this.length&&10===e.length?h(this,e,t):r<63?f(this,e,t):r<1024?function(e,t,n){n.negative=t.negative^e.negative,n.length=e.length+t.length;for(var r=0,i=0,o=0;o<n.length-1;o++){var a=i;i=0;for(var s=67108863&r,u=Math.min(o,t.length-1),l=Math.max(0,o-e.length+1);l<=u;l++){var c=o-l,d=(0|e.words[c])*(0|t.words[l]),f=67108863&d;s=67108863&(f=f+s|0),i+=(a=(a=a+(d/67108864|0)|0)+(f>>>26)|0)>>>26,a&=67108863;}n.words[o]=s,r=a,a=i;}return 0!==r?n.words[o]=r:n.length--,n.strip()}(this,e,t):p(this,e,t),n},m.prototype.makeRBT=function(e){for(var t=new Array(e),n=i.prototype._countBits(e)-1,r=0;r<e;r++)t[r]=this.revBin(r,n,e);return t},m.prototype.revBin=function(e,t,n){if(0===e||e===n-1)return e;for(var r=0,i=0;i<t;i++)r|=(1&e)<<t-i-1,e>>=1;return r},m.prototype.permute=function(e,t,n,r,i,o){for(var a=0;a<o;a++)r[a]=t[e[a]],i[a]=n[e[a]];},m.prototype.transform=function(e,t,n,r,i,o){this.permute(o,e,t,n,r,i);for(var a=1;a<i;a<<=1)for(var s=a<<1,u=Math.cos(2*Math.PI/s),l=Math.sin(2*Math.PI/s),c=0;c<i;c+=s)for(var d=u,f=l,h=0;h<a;h++){var p=n[c+h],m=r[c+h],g=n[c+h+a],v=r[c+h+a],b=d*g-f*v;v=d*v+f*g,g=b,n[c+h]=p+g,r[c+h]=m+v,n[c+h+a]=p-g,r[c+h+a]=m-v,h!==s&&(b=u*d-l*f,f=u*f+l*d,d=b);}},m.prototype.guessLen13b=function(e,t){var n=1|Math.max(t,e),r=1&n,i=0;for(n=n/2|0;n;n>>>=1)i++;return 1<<i+1+r},m.prototype.conjugate=function(e,t,n){if(!(n<=1))for(var r=0;r<n/2;r++){var i=e[r];e[r]=e[n-r-1],e[n-r-1]=i,i=t[r],t[r]=-t[n-r-1],t[n-r-1]=-i;}},m.prototype.normalize13b=function(e,t){for(var n=0,r=0;r<t/2;r++){var i=8192*Math.round(e[2*r+1]/t)+Math.round(e[2*r]/t)+n;e[r]=67108863&i,n=i<67108864?0:i/67108864|0;}return e},m.prototype.convert13b=function(e,t,r,i){for(var o=0,a=0;a<t;a++)o+=0|e[a],r[2*a]=8191&o,o>>>=13,r[2*a+1]=8191&o,o>>>=13;for(a=2*t;a<i;++a)r[a]=0;n(0===o),n(0==(-8192&o));},m.prototype.stub=function(e){for(var t=new Array(e),n=0;n<e;n++)t[n]=0;return t},m.prototype.mulp=function(e,t,n){var r=2*this.guessLen13b(e.length,t.length),i=this.makeRBT(r),o=this.stub(r),a=new Array(r),s=new Array(r),u=new Array(r),l=new Array(r),c=new Array(r),d=new Array(r),f=n.words;f.length=r,this.convert13b(e.words,e.length,a,r),this.convert13b(t.words,t.length,l,r),this.transform(a,o,s,u,r,i),this.transform(l,o,c,d,r,i);for(var h=0;h<r;h++){var p=s[h]*c[h]-u[h]*d[h];u[h]=s[h]*d[h]+u[h]*c[h],s[h]=p;}return this.conjugate(s,u,r),this.transform(s,u,f,o,r,i),this.conjugate(f,o,r),this.normalize13b(f,r),n.negative=e.negative^t.negative,n.length=e.length+t.length,n.strip()},i.prototype.mul=function(e){var t=new i(null);return t.words=new Array(this.length+e.length),this.mulTo(e,t)},i.prototype.mulf=function(e){var t=new i(null);return t.words=new Array(this.length+e.length),p(this,e,t)},i.prototype.imul=function(e){return this.clone().mulTo(e,this)},i.prototype.imuln=function(e){n("number"==typeof e),n(e<67108864);for(var t=0,r=0;r<this.length;r++){var i=(0|this.words[r])*e,o=(67108863&i)+(67108863&t);t>>=26,t+=i/67108864|0,t+=o>>>26,this.words[r]=67108863&o;}return 0!==t&&(this.words[r]=t,this.length++),this},i.prototype.muln=function(e){return this.clone().imuln(e)},i.prototype.sqr=function(){return this.mul(this)},i.prototype.isqr=function(){return this.imul(this.clone())},i.prototype.pow=function(e){var t=function(e){for(var t=new Array(e.bitLength()),n=0;n<t.length;n++){var r=n/26|0,i=n%26;t[n]=(e.words[r]&1<<i)>>>i;}return t}(e);if(0===t.length)return new i(1);for(var n=this,r=0;r<t.length&&0===t[r];r++,n=n.sqr());if(++r<t.length)for(var o=n.sqr();r<t.length;r++,o=o.sqr())0!==t[r]&&(n=n.mul(o));return n},i.prototype.iushln=function(e){n("number"==typeof e&&e>=0);var t,r=e%26,i=(e-r)/26,o=67108863>>>26-r<<26-r;if(0!==r){var a=0;for(t=0;t<this.length;t++){var s=this.words[t]&o,u=(0|this.words[t])-s<<r;this.words[t]=u|a,a=s>>>26-r;}a&&(this.words[t]=a,this.length++);}if(0!==i){for(t=this.length-1;t>=0;t--)this.words[t+i]=this.words[t];for(t=0;t<i;t++)this.words[t]=0;this.length+=i;}return this.strip()},i.prototype.ishln=function(e){return n(0===this.negative),this.iushln(e)},i.prototype.iushrn=function(e,t,r){var i;n("number"==typeof e&&e>=0),i=t?(t-t%26)/26:0;var o=e%26,a=Math.min((e-o)/26,this.length),s=67108863^67108863>>>o<<o,u=r;if(i-=a,i=Math.max(0,i),u){for(var l=0;l<a;l++)u.words[l]=this.words[l];u.length=a;}if(0===a);else if(this.length>a)for(this.length-=a,l=0;l<this.length;l++)this.words[l]=this.words[l+a];else this.words[0]=0,this.length=1;var c=0;for(l=this.length-1;l>=0&&(0!==c||l>=i);l--){var d=0|this.words[l];this.words[l]=c<<26-o|d>>>o,c=d&s;}return u&&0!==c&&(u.words[u.length++]=c),0===this.length&&(this.words[0]=0,this.length=1),this.strip()},i.prototype.ishrn=function(e,t,r){return n(0===this.negative),this.iushrn(e,t,r)},i.prototype.shln=function(e){return this.clone().ishln(e)},i.prototype.ushln=function(e){return this.clone().iushln(e)},i.prototype.shrn=function(e){return this.clone().ishrn(e)},i.prototype.ushrn=function(e){return this.clone().iushrn(e)},i.prototype.testn=function(e){n("number"==typeof e&&e>=0);var t=e%26,r=(e-t)/26,i=1<<t;return !(this.length<=r)&&!!(this.words[r]&i)},i.prototype.imaskn=function(e){n("number"==typeof e&&e>=0);var t=e%26,r=(e-t)/26;if(n(0===this.negative,"imaskn works only with positive numbers"),this.length<=r)return this;if(0!==t&&r++,this.length=Math.min(r,this.length),0!==t){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i;}return this.strip()},i.prototype.maskn=function(e){return this.clone().imaskn(e)},i.prototype.iaddn=function(e){return n("number"==typeof e),n(e<67108864),e<0?this.isubn(-e):0!==this.negative?1===this.length&&(0|this.words[0])<e?(this.words[0]=e-(0|this.words[0]),this.negative=0,this):(this.negative=0,this.isubn(e),this.negative=1,this):this._iaddn(e)},i.prototype._iaddn=function(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++)this.words[t]-=67108864,t===this.length-1?this.words[t+1]=1:this.words[t+1]++;return this.length=Math.max(this.length,t+1),this},i.prototype.isubn=function(e){if(n("number"==typeof e),n(e<67108864),e<0)return this.iaddn(-e);if(0!==this.negative)return this.negative=0,this.iaddn(e),this.negative=1,this;if(this.words[0]-=e,1===this.length&&this.words[0]<0)this.words[0]=-this.words[0],this.negative=1;else for(var t=0;t<this.length&&this.words[t]<0;t++)this.words[t]+=67108864,this.words[t+1]-=1;return this.strip()},i.prototype.addn=function(e){return this.clone().iaddn(e)},i.prototype.subn=function(e){return this.clone().isubn(e)},i.prototype.iabs=function(){return this.negative=0,this},i.prototype.abs=function(){return this.clone().iabs()},i.prototype._ishlnsubmul=function(e,t,r){var i,o,a=e.length+r;this._expand(a);var s=0;for(i=0;i<e.length;i++){o=(0|this.words[i+r])+s;var u=(0|e.words[i])*t;s=((o-=67108863&u)>>26)-(u/67108864|0),this.words[i+r]=67108863&o;}for(;i<this.length-r;i++)s=(o=(0|this.words[i+r])+s)>>26,this.words[i+r]=67108863&o;if(0===s)return this.strip();for(n(-1===s),s=0,i=0;i<this.length;i++)s=(o=-(0|this.words[i])+s)>>26,this.words[i]=67108863&o;return this.negative=1,this.strip()},i.prototype._wordDiv=function(e,t){var n=(this.length,e.length),r=this.clone(),o=e,a=0|o.words[o.length-1];0!==(n=26-this._countBits(a))&&(o=o.ushln(n),r.iushln(n),a=0|o.words[o.length-1]);var s,u=r.length-o.length;if("mod"!==t){(s=new i(null)).length=u+1,s.words=new Array(s.length);for(var l=0;l<s.length;l++)s.words[l]=0;}var c=r.clone()._ishlnsubmul(o,1,u);0===c.negative&&(r=c,s&&(s.words[u]=1));for(var d=u-1;d>=0;d--){var f=67108864*(0|r.words[o.length+d])+(0|r.words[o.length+d-1]);for(f=Math.min(f/a|0,67108863),r._ishlnsubmul(o,f,d);0!==r.negative;)f--,r.negative=0,r._ishlnsubmul(o,1,d),r.isZero()||(r.negative^=1);s&&(s.words[d]=f);}return s&&s.strip(),r.strip(),"div"!==t&&0!==n&&r.iushrn(n),{div:s||null,mod:r}},i.prototype.divmod=function(e,t,r){return n(!e.isZero()),this.isZero()?{div:new i(0),mod:new i(0)}:0!==this.negative&&0===e.negative?(s=this.neg().divmod(e,t),"mod"!==t&&(o=s.div.neg()),"div"!==t&&(a=s.mod.neg(),r&&0!==a.negative&&a.iadd(e)),{div:o,mod:a}):0===this.negative&&0!==e.negative?(s=this.divmod(e.neg(),t),"mod"!==t&&(o=s.div.neg()),{div:o,mod:s.mod}):0!=(this.negative&e.negative)?(s=this.neg().divmod(e.neg(),t),"div"!==t&&(a=s.mod.neg(),r&&0!==a.negative&&a.isub(e)),{div:s.div,mod:a}):e.length>this.length||this.cmp(e)<0?{div:new i(0),mod:this}:1===e.length?"div"===t?{div:this.divn(e.words[0]),mod:null}:"mod"===t?{div:null,mod:new i(this.modn(e.words[0]))}:{div:this.divn(e.words[0]),mod:new i(this.modn(e.words[0]))}:this._wordDiv(e,t);var o,a,s;},i.prototype.div=function(e){return this.divmod(e,"div",false).div},i.prototype.mod=function(e){return this.divmod(e,"mod",false).mod},i.prototype.umod=function(e){return this.divmod(e,"mod",true).mod},i.prototype.divRound=function(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var n=0!==t.div.negative?t.mod.isub(e):t.mod,r=e.ushrn(1),i=e.andln(1),o=n.cmp(r);return o<0||1===i&&0===o?t.div:0!==t.div.negative?t.div.isubn(1):t.div.iaddn(1)},i.prototype.modn=function(e){n(e<=67108863);for(var t=(1<<26)%e,r=0,i=this.length-1;i>=0;i--)r=(t*r+(0|this.words[i]))%e;return r},i.prototype.idivn=function(e){n(e<=67108863);for(var t=0,r=this.length-1;r>=0;r--){var i=(0|this.words[r])+67108864*t;this.words[r]=i/e|0,t=i%e;}return this.strip()},i.prototype.divn=function(e){return this.clone().idivn(e)},i.prototype.egcd=function(e){n(0===e.negative),n(!e.isZero());var t=this,r=e.clone();t=0!==t.negative?t.umod(e):t.clone();for(var o=new i(1),a=new i(0),s=new i(0),u=new i(1),l=0;t.isEven()&&r.isEven();)t.iushrn(1),r.iushrn(1),++l;for(var c=r.clone(),d=t.clone();!t.isZero();){for(var f=0,h=1;0==(t.words[0]&h)&&f<26;++f,h<<=1);if(f>0)for(t.iushrn(f);f-- >0;)(o.isOdd()||a.isOdd())&&(o.iadd(c),a.isub(d)),o.iushrn(1),a.iushrn(1);for(var p=0,m=1;0==(r.words[0]&m)&&p<26;++p,m<<=1);if(p>0)for(r.iushrn(p);p-- >0;)(s.isOdd()||u.isOdd())&&(s.iadd(c),u.isub(d)),s.iushrn(1),u.iushrn(1);t.cmp(r)>=0?(t.isub(r),o.isub(s),a.isub(u)):(r.isub(t),s.isub(o),u.isub(a));}return {a:s,b:u,gcd:r.iushln(l)}},i.prototype._invmp=function(e){n(0===e.negative),n(!e.isZero());var t=this,r=e.clone();t=0!==t.negative?t.umod(e):t.clone();for(var o,a=new i(1),s=new i(0),u=r.clone();t.cmpn(1)>0&&r.cmpn(1)>0;){for(var l=0,c=1;0==(t.words[0]&c)&&l<26;++l,c<<=1);if(l>0)for(t.iushrn(l);l-- >0;)a.isOdd()&&a.iadd(u),a.iushrn(1);for(var d=0,f=1;0==(r.words[0]&f)&&d<26;++d,f<<=1);if(d>0)for(r.iushrn(d);d-- >0;)s.isOdd()&&s.iadd(u),s.iushrn(1);t.cmp(r)>=0?(t.isub(r),a.isub(s)):(r.isub(t),s.isub(a));}return (o=0===t.cmpn(1)?a:s).cmpn(0)<0&&o.iadd(e),o},i.prototype.gcd=function(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone(),n=e.clone();t.negative=0,n.negative=0;for(var r=0;t.isEven()&&n.isEven();r++)t.iushrn(1),n.iushrn(1);for(;;){for(;t.isEven();)t.iushrn(1);for(;n.isEven();)n.iushrn(1);var i=t.cmp(n);if(i<0){var o=t;t=n,n=o;}else if(0===i||0===n.cmpn(1))break;t.isub(n);}return n.iushln(r)},i.prototype.invm=function(e){return this.egcd(e).a.umod(e)},i.prototype.isEven=function(){return 0==(1&this.words[0])},i.prototype.isOdd=function(){return 1==(1&this.words[0])},i.prototype.andln=function(e){return this.words[0]&e},i.prototype.bincn=function(e){n("number"==typeof e);var t=e%26,r=(e-t)/26,i=1<<t;if(this.length<=r)return this._expand(r+1),this.words[r]|=i,this;for(var o=i,a=r;0!==o&&a<this.length;a++){var s=0|this.words[a];o=(s+=o)>>>26,s&=67108863,this.words[a]=s;}return 0!==o&&(this.words[a]=o,this.length++),this},i.prototype.isZero=function(){return 1===this.length&&0===this.words[0]},i.prototype.cmpn=function(e){var t,r=e<0;if(0!==this.negative&&!r)return  -1;if(0===this.negative&&r)return 1;if(this.strip(),this.length>1)t=1;else {r&&(e=-e),n(e<=67108863,"Number is too big");var i=0|this.words[0];t=i===e?0:i<e?-1:1;}return 0!==this.negative?0|-t:t},i.prototype.cmp=function(e){if(0!==this.negative&&0===e.negative)return  -1;if(0===this.negative&&0!==e.negative)return 1;var t=this.ucmp(e);return 0!==this.negative?0|-t:t},i.prototype.ucmp=function(e){if(this.length>e.length)return 1;if(this.length<e.length)return  -1;for(var t=0,n=this.length-1;n>=0;n--){var r=0|this.words[n],i=0|e.words[n];if(r!==i){r<i?t=-1:r>i&&(t=1);break}}return t},i.prototype.gtn=function(e){return 1===this.cmpn(e)},i.prototype.gt=function(e){return 1===this.cmp(e)},i.prototype.gten=function(e){return this.cmpn(e)>=0},i.prototype.gte=function(e){return this.cmp(e)>=0},i.prototype.ltn=function(e){return  -1===this.cmpn(e)},i.prototype.lt=function(e){return  -1===this.cmp(e)},i.prototype.lten=function(e){return this.cmpn(e)<=0},i.prototype.lte=function(e){return this.cmp(e)<=0},i.prototype.eqn=function(e){return 0===this.cmpn(e)},i.prototype.eq=function(e){return 0===this.cmp(e)},i.red=function(e){return new S(e)},i.prototype.toRed=function(e){return n(!this.red,"Already a number in reduction context"),n(0===this.negative,"red works only with positives"),e.convertTo(this)._forceRed(e)},i.prototype.fromRed=function(){return n(this.red,"fromRed works only with numbers in reduction context"),this.red.convertFrom(this)},i.prototype._forceRed=function(e){return this.red=e,this},i.prototype.forceRed=function(e){return n(!this.red,"Already a number in reduction context"),this._forceRed(e)},i.prototype.redAdd=function(e){return n(this.red,"redAdd works only with red numbers"),this.red.add(this,e)},i.prototype.redIAdd=function(e){return n(this.red,"redIAdd works only with red numbers"),this.red.iadd(this,e)},i.prototype.redSub=function(e){return n(this.red,"redSub works only with red numbers"),this.red.sub(this,e)},i.prototype.redISub=function(e){return n(this.red,"redISub works only with red numbers"),this.red.isub(this,e)},i.prototype.redShl=function(e){return n(this.red,"redShl works only with red numbers"),this.red.shl(this,e)},i.prototype.redMul=function(e){return n(this.red,"redMul works only with red numbers"),this.red._verify2(this,e),this.red.mul(this,e)},i.prototype.redIMul=function(e){return n(this.red,"redMul works only with red numbers"),this.red._verify2(this,e),this.red.imul(this,e)},i.prototype.redSqr=function(){return n(this.red,"redSqr works only with red numbers"),this.red._verify1(this),this.red.sqr(this)},i.prototype.redISqr=function(){return n(this.red,"redISqr works only with red numbers"),this.red._verify1(this),this.red.isqr(this)},i.prototype.redSqrt=function(){return n(this.red,"redSqrt works only with red numbers"),this.red._verify1(this),this.red.sqrt(this)},i.prototype.redInvm=function(){return n(this.red,"redInvm works only with red numbers"),this.red._verify1(this),this.red.invm(this)},i.prototype.redNeg=function(){return n(this.red,"redNeg works only with red numbers"),this.red._verify1(this),this.red.neg(this)},i.prototype.redPow=function(e){return n(this.red&&!e.red,"redPow(normalNum)"),this.red._verify1(this),this.red.pow(this,e)};var g={k256:null,p224:null,p192:null,p25519:null};function v(e,t){this.name=e,this.p=new i(t,16),this.n=this.p.bitLength(),this.k=new i(1).iushln(this.n).isub(this.p),this.tmp=this._tmp();}function b(){v.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");}function y(){v.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");}function w(){v.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");}function _(){v.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");}function S(e){if("string"==typeof e){var t=i._prime(e);this.m=t.p,this.prime=t;}else n(e.gtn(1),"modulus must be greater than 1"),this.m=e,this.prime=null;}function E(e){S.call(this,e),this.shift=this.m.bitLength(),this.shift%26!=0&&(this.shift+=26-this.shift%26),this.r=new i(1).iushln(this.shift),this.r2=this.imod(this.r.sqr()),this.rinv=this.r._invmp(this.m),this.minv=this.rinv.mul(this.r).isubn(1).div(this.m),this.minv=this.minv.umod(this.r),this.minv=this.r.sub(this.minv);}v.prototype._tmp=function(){var e=new i(null);return e.words=new Array(Math.ceil(this.n/13)),e},v.prototype.ireduce=function(e){var t,n=e;do{this.split(n,this.tmp),t=(n=(n=this.imulK(n)).iadd(this.tmp)).bitLength();}while(t>this.n);var r=t<this.n?-1:n.ucmp(this.p);return 0===r?(n.words[0]=0,n.length=1):r>0?n.isub(this.p):void 0!==n.strip?n.strip():n._strip(),n},v.prototype.split=function(e,t){e.iushrn(this.n,0,t);},v.prototype.imulK=function(e){return e.imul(this.k)},r(b,v),b.prototype.split=function(e,t){for(var n=4194303,r=Math.min(e.length,9),i=0;i<r;i++)t.words[i]=e.words[i];if(t.length=r,e.length<=9)return e.words[0]=0,void(e.length=1);var o=e.words[9];for(t.words[t.length++]=o&n,i=10;i<e.length;i++){var a=0|e.words[i];e.words[i-10]=(a&n)<<4|o>>>22,o=a;}o>>>=22,e.words[i-10]=o,0===o&&e.length>10?e.length-=10:e.length-=9;},b.prototype.imulK=function(e){e.words[e.length]=0,e.words[e.length+1]=0,e.length+=2;for(var t=0,n=0;n<e.length;n++){var r=0|e.words[n];t+=977*r,e.words[n]=67108863&t,t=64*r+(t/67108864|0);}return 0===e.words[e.length-1]&&(e.length--,0===e.words[e.length-1]&&e.length--),e},r(y,v),r(w,v),r(_,v),_.prototype.imulK=function(e){for(var t=0,n=0;n<e.length;n++){var r=19*(0|e.words[n])+t,i=67108863&r;r>>>=26,e.words[n]=i,t=r;}return 0!==t&&(e.words[e.length++]=t),e},i._prime=function(e){if(g[e])return g[e];var t;if("k256"===e)t=new b;else if("p224"===e)t=new y;else if("p192"===e)t=new w;else {if("p25519"!==e)throw new Error("Unknown prime "+e);t=new _;}return g[e]=t,t},S.prototype._verify1=function(e){n(0===e.negative,"red works only with positives"),n(e.red,"red works only with red numbers");},S.prototype._verify2=function(e,t){n(0==(e.negative|t.negative),"red works only with positives"),n(e.red&&e.red===t.red,"red works only with red numbers");},S.prototype.imod=function(e){return this.prime?this.prime.ireduce(e)._forceRed(this):e.umod(this.m)._forceRed(this)},S.prototype.neg=function(e){return e.isZero()?e.clone():this.m.sub(e)._forceRed(this)},S.prototype.add=function(e,t){this._verify2(e,t);var n=e.add(t);return n.cmp(this.m)>=0&&n.isub(this.m),n._forceRed(this)},S.prototype.iadd=function(e,t){this._verify2(e,t);var n=e.iadd(t);return n.cmp(this.m)>=0&&n.isub(this.m),n},S.prototype.sub=function(e,t){this._verify2(e,t);var n=e.sub(t);return n.cmpn(0)<0&&n.iadd(this.m),n._forceRed(this)},S.prototype.isub=function(e,t){this._verify2(e,t);var n=e.isub(t);return n.cmpn(0)<0&&n.iadd(this.m),n},S.prototype.shl=function(e,t){return this._verify1(e),this.imod(e.ushln(t))},S.prototype.imul=function(e,t){return this._verify2(e,t),this.imod(e.imul(t))},S.prototype.mul=function(e,t){return this._verify2(e,t),this.imod(e.mul(t))},S.prototype.isqr=function(e){return this.imul(e,e.clone())},S.prototype.sqr=function(e){return this.mul(e,e)},S.prototype.sqrt=function(e){if(e.isZero())return e.clone();var t=this.m.andln(3);if(n(t%2==1),3===t){var r=this.m.add(new i(1)).iushrn(2);return this.pow(e,r)}for(var o=this.m.subn(1),a=0;!o.isZero()&&0===o.andln(1);)a++,o.iushrn(1);n(!o.isZero());var s=new i(1).toRed(this),u=s.redNeg(),l=this.m.subn(1).iushrn(1),c=this.m.bitLength();for(c=new i(2*c*c).toRed(this);0!==this.pow(c,l).cmp(u);)c.redIAdd(u);for(var d=this.pow(c,o),f=this.pow(e,o.addn(1).iushrn(1)),h=this.pow(e,o),p=a;0!==h.cmp(s);){for(var m=h,g=0;0!==m.cmp(s);g++)m=m.redSqr();n(g<p);var v=this.pow(d,new i(1).iushln(p-g-1));f=f.redMul(v),d=v.redSqr(),h=h.redMul(d),p=g;}return f},S.prototype.invm=function(e){var t=e._invmp(this.m);return 0!==t.negative?(t.negative=0,this.imod(t).redNeg()):this.imod(t)},S.prototype.pow=function(e,t){if(t.isZero())return new i(1).toRed(this);if(0===t.cmpn(1))return e.clone();var n=new Array(16);n[0]=new i(1).toRed(this),n[1]=e;for(var r=2;r<n.length;r++)n[r]=this.mul(n[r-1],e);var o=n[0],a=0,s=0,u=t.bitLength()%26;for(0===u&&(u=26),r=t.length-1;r>=0;r--){for(var l=t.words[r],c=u-1;c>=0;c--){var d=l>>c&1;o!==n[0]&&(o=this.sqr(o)),0!==d||0!==a?(a<<=1,a|=d,(4===++s||0===r&&0===c)&&(o=this.mul(o,n[a]),s=0,a=0)):s=0;}u=26;}return o},S.prototype.convertTo=function(e){var t=e.umod(this.m);return t===e?t.clone():t},S.prototype.convertFrom=function(e){var t=e.clone();return t.red=null,t},i.mont=function(e){return new E(e)},r(E,S),E.prototype.convertTo=function(e){return this.imod(e.ushln(this.shift))},E.prototype.convertFrom=function(e){var t=this.imod(e.mul(this.rinv));return t.red=null,t},E.prototype.imul=function(e,t){if(e.isZero()||t.isZero())return e.words[0]=0,e.length=1,e;var n=e.imul(t),r=n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),i=n.isub(r).iushrn(this.shift),o=i;return i.cmp(this.m)>=0?o=i.isub(this.m):i.cmpn(0)<0&&(o=i.iadd(this.m)),o._forceRed(this)},E.prototype.mul=function(e,t){if(e.isZero()||t.isZero())return new i(0)._forceRed(this);var n=e.mul(t),r=n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),o=n.isub(r).iushrn(this.shift),a=o;return o.cmp(this.m)>=0?a=o.isub(this.m):o.cmpn(0)<0&&(a=o.iadd(this.m)),a._forceRed(this)},E.prototype.invm=function(e){return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this)};}(e,n);}(sl);var ul,ll,cl,dl,fl,hl=sl.exports,pl={exports:{}};function ml(){if(ul)return pl.exports;var e;function t(e){this.rand=e;}if(ul=1,pl.exports=function(n){return e||(e=new t(null)),e.generate(n)},pl.exports.Rand=t,t.prototype.generate=function(e){return this._rand(e)},t.prototype._rand=function(e){if(this.rand.getBytes)return this.rand.getBytes(e);for(var t=new Uint8Array(e),n=0;n<t.length;n++)t[n]=this.rand.getByte();return t},"object"==typeof self)self.crypto&&self.crypto.getRandomValues?t.prototype._rand=function(e){var t=new Uint8Array(e);return self.crypto.getRandomValues(t),t}:self.msCrypto&&self.msCrypto.getRandomValues?t.prototype._rand=function(e){var t=new Uint8Array(e);return self.msCrypto.getRandomValues(t),t}:"object"==typeof window&&(t.prototype._rand=function(){throw new Error("Not implemented yet")});else try{var n=zm();if("function"!=typeof n.randomBytes)throw new Error("Not supported");t.prototype._rand=function(e){return n.randomBytes(e)};}catch(e){}return pl.exports}function gl(){if(cl)return ll;cl=1;var e=hl,t=ml();function n(e){this.rand=e||new t.Rand;}return ll=n,n.create=function(e){return new n(e)},n.prototype._randbelow=function(t){var n=t.bitLength(),r=Math.ceil(n/8);do{var i=new e(this.rand.generate(r));}while(i.cmp(t)>=0);return i},n.prototype._randrange=function(e,t){var n=t.sub(e);return e.add(this._randbelow(n))},n.prototype.test=function(t,n,r){var i=t.bitLength(),o=e.mont(t),a=new e(1).toRed(o);n||(n=Math.max(1,i/48|0));for(var s=t.subn(1),u=0;!s.testn(u);u++);for(var l=t.shrn(u),c=s.toRed(o);n>0;n--){var d=this._randrange(new e(2),s);r&&r(d);var f=d.toRed(o).redPow(l);if(0!==f.cmp(a)&&0!==f.cmp(c)){for(var h=1;h<u;h++){if(0===(f=f.redSqr()).cmp(a))return  false;if(0===f.cmp(c))break}if(h===u)return  false}}return  true},n.prototype.getDivisor=function(t,n){var r=t.bitLength(),i=e.mont(t),o=new e(1).toRed(i);n||(n=Math.max(1,r/48|0));for(var a=t.subn(1),s=0;!a.testn(s);s++);for(var u=t.shrn(s),l=a.toRed(i);n>0;n--){var c=this._randrange(new e(2),a),d=t.gcd(c);if(0!==d.cmpn(1))return d;var f=c.toRed(i).redPow(u);if(0!==f.cmp(o)&&0!==f.cmp(l)){for(var h=1;h<s;h++){if(0===(f=f.redSqr()).cmp(o))return f.fromRed().subn(1).gcd(t);if(0===f.cmp(l))break}if(h===s)return (f=f.redSqr()).fromRed().subn(1).gcd(t)}}return  false},ll}function vl(){if(fl)return dl;fl=1;var e=We;dl=m,m.simpleSieve=h,m.fermatTest=p;var t=hl,n=new t(24),r=new(gl()),i=new t(1),o=new t(2),a=new t(5);new t(16),new t(8);var s=new t(10),u=new t(3);new t(7);var l=new t(11),c=new t(4);new t(12);var d=null;function f(){if(null!==d)return d;var e=[];e[0]=2;for(var t=1,n=3;n<1048576;n+=2){for(var r=Math.ceil(Math.sqrt(n)),i=0;i<t&&e[i]<=r&&n%e[i]!=0;i++);t!==i&&e[i]<=r||(e[t++]=n);}return d=e,e}function h(e){for(var t=f(),n=0;n<t.length;n++)if(0===e.modn(t[n]))return 0===e.cmpn(t[n]);return  true}function p(e){var n=t.mont(e);return 0===o.toRed(n).redPow(e.subn(1)).fromRed().cmpn(1)}function m(d,f){if(d<16)return new t(2===f||5===f?[140,123]:[140,39]);var m,g;for(f=new t(f);;){for(m=new t(e(Math.ceil(d/8)));m.bitLength()>d;)m.ishrn(1);if(m.isEven()&&m.iadd(i),m.testn(1)||m.iadd(o),f.cmp(o)){if(!f.cmp(a))for(;m.mod(s).cmp(u);)m.iadd(c);}else for(;m.mod(n).cmp(l);)m.iadd(c);if(h(g=m.shrn(1))&&h(m)&&p(g)&&p(m)&&r.test(g)&&r.test(m))return m}}return dl}var bl,yl,wl,_l={modp1:{gen:"02",prime:"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},modp2:{gen:"02",prime:"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},modp5:{gen:"02",prime:"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},modp14:{gen:"02",prime:"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},modp15:{gen:"02",prime:"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},modp16:{gen:"02",prime:"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},modp17:{gen:"02",prime:"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},modp18:{gen:"02",prime:"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"}};function Sl(){if(yl)return bl;yl=1;var e=hl,t=new(gl()),n=new e(24),r=new e(11),i=new e(10),o=new e(3),a=new e(7),s=vl(),u=We;function l(t,n){return n=n||"utf8",ie(t)||(t=new _(t,n)),this._pub=new e(t),this}function c(t,n){return n=n||"utf8",ie(t)||(t=new _(t,n)),this._priv=new e(t),this}bl=f;var d={};function f(t,n,r){this.setGenerator(n),this.__prime=new e(t),this._prime=e.mont(this.__prime),this._primeLen=t.length,this._pub=void 0,this._priv=void 0,this._primeCode=void 0,r?(this.setPublicKey=l,this.setPrivateKey=c):this._primeCode=8;}function h(e,t){var n=new _(e.toArray());return t?n.toString(t):n}return Object.defineProperty(f.prototype,"verifyError",{enumerable:true,get:function(){return "number"!=typeof this._primeCode&&(this._primeCode=function(e,u){var l=u.toString("hex"),c=[l,e.toString(16)].join("_");if(c in d)return d[c];var f,h=0;if(e.isEven()||!s.simpleSieve||!s.fermatTest(e)||!t.test(e))return h+=1,h+="02"===l||"05"===l?8:4,d[c]=h,h;switch(t.test(e.shrn(1))||(h+=2),l){case "02":e.mod(n).cmp(r)&&(h+=8);break;case "05":(f=e.mod(i)).cmp(o)&&f.cmp(a)&&(h+=8);break;default:h+=4;}return d[c]=h,h}(this.__prime,this.__gen)),this._primeCode}}),f.prototype.generateKeys=function(){return this._priv||(this._priv=new e(u(this._primeLen))),this._pub=this._gen.toRed(this._prime).redPow(this._priv).fromRed(),this.getPublicKey()},f.prototype.computeSecret=function(t){var n=new _((t=(t=new e(t)).toRed(this._prime)).redPow(this._priv).fromRed().toArray()),r=this.getPrime();if(n.length<r.length){var i=new _(r.length-n.length);i.fill(0),n=_.concat([i,n]);}return n},f.prototype.getPublicKey=function(e){return h(this._pub,e)},f.prototype.getPrivateKey=function(e){return h(this._priv,e)},f.prototype.getPrime=function(e){return h(this.__prime,e)},f.prototype.getGenerator=function(e){return h(this._gen,e)},f.prototype.setGenerator=function(t,n){return n=n||"utf8",ie(t)||(t=new _(t,n)),this.__gen=t,this._gen=new e(t),this},bl}var El={exports:{}},kl={exports:{}};!function(e){!function(e,t){function n(e,t){if(!e)throw new Error(t||"Assertion failed")}function r(e,t){e.super_=t;var n=function(){};n.prototype=t.prototype,e.prototype=new n,e.prototype.constructor=e;}function i(e,t,n){if(i.isBN(e))return e;this.negative=0,this.words=null,this.length=0,this.red=null,null!==e&&("le"!==t&&"be"!==t||(n=t,t=10),this._init(e||0,t||10,n||"be"));}var o;"object"==typeof e?e.exports=i:t.BN=i,i.BN=i,i.wordSize=26;try{o="undefined"!=typeof window&&void 0!==window.Buffer?window.Buffer:ce.Buffer;}catch(e){}function a(e,t){var r=e.charCodeAt(t);return r>=48&&r<=57?r-48:r>=65&&r<=70?r-55:r>=97&&r<=102?r-87:void n(false,"Invalid character in "+e)}function s(e,t,n){var r=a(e,n);return n-1>=t&&(r|=a(e,n-1)<<4),r}function u(e,t,r,i){for(var o=0,a=0,s=Math.min(e.length,r),u=t;u<s;u++){var l=e.charCodeAt(u)-48;o*=i,a=l>=49?l-49+10:l>=17?l-17+10:l,n(l>=0&&a<i,"Invalid character"),o+=a;}return o}function l(e,t){e.words=t.words,e.length=t.length,e.negative=t.negative,e.red=t.red;}if(i.isBN=function(e){return e instanceof i||null!==e&&"object"==typeof e&&e.constructor.wordSize===i.wordSize&&Array.isArray(e.words)},i.max=function(e,t){return e.cmp(t)>0?e:t},i.min=function(e,t){return e.cmp(t)<0?e:t},i.prototype._init=function(e,t,r){if("number"==typeof e)return this._initNumber(e,t,r);if("object"==typeof e)return this._initArray(e,t,r);"hex"===t&&(t=16),n(t===(0|t)&&t>=2&&t<=36);var i=0;"-"===(e=e.toString().replace(/\s+/g,""))[0]&&(i++,this.negative=1),i<e.length&&(16===t?this._parseHex(e,i,r):(this._parseBase(e,t,i),"le"===r&&this._initArray(this.toArray(),t,r)));},i.prototype._initNumber=function(e,t,r){e<0&&(this.negative=1,e=-e),e<67108864?(this.words=[67108863&e],this.length=1):e<4503599627370496?(this.words=[67108863&e,e/67108864&67108863],this.length=2):(n(e<9007199254740992),this.words=[67108863&e,e/67108864&67108863,1],this.length=3),"le"===r&&this._initArray(this.toArray(),t,r);},i.prototype._initArray=function(e,t,r){if(n("number"==typeof e.length),e.length<=0)return this.words=[0],this.length=1,this;this.length=Math.ceil(e.length/3),this.words=new Array(this.length);for(var i=0;i<this.length;i++)this.words[i]=0;var o,a,s=0;if("be"===r)for(i=e.length-1,o=0;i>=0;i-=3)a=e[i]|e[i-1]<<8|e[i-2]<<16,this.words[o]|=a<<s&67108863,this.words[o+1]=a>>>26-s&67108863,(s+=24)>=26&&(s-=26,o++);else if("le"===r)for(i=0,o=0;i<e.length;i+=3)a=e[i]|e[i+1]<<8|e[i+2]<<16,this.words[o]|=a<<s&67108863,this.words[o+1]=a>>>26-s&67108863,(s+=24)>=26&&(s-=26,o++);return this._strip()},i.prototype._parseHex=function(e,t,n){this.length=Math.ceil((e.length-t)/6),this.words=new Array(this.length);for(var r=0;r<this.length;r++)this.words[r]=0;var i,o=0,a=0;if("be"===n)for(r=e.length-1;r>=t;r-=2)i=s(e,t,r)<<o,this.words[a]|=67108863&i,o>=18?(o-=18,a+=1,this.words[a]|=i>>>26):o+=8;else for(r=(e.length-t)%2==0?t+1:t;r<e.length;r+=2)i=s(e,t,r)<<o,this.words[a]|=67108863&i,o>=18?(o-=18,a+=1,this.words[a]|=i>>>26):o+=8;this._strip();},i.prototype._parseBase=function(e,t,n){this.words=[0],this.length=1;for(var r=0,i=1;i<=67108863;i*=t)r++;r--,i=i/t|0;for(var o=e.length-n,a=o%r,s=Math.min(o,o-a)+n,l=0,c=n;c<s;c+=r)l=u(e,c,c+r,t),this.imuln(i),this.words[0]+l<67108864?this.words[0]+=l:this._iaddn(l);if(0!==a){var d=1;for(l=u(e,c,e.length,t),c=0;c<a;c++)d*=t;this.imuln(d),this.words[0]+l<67108864?this.words[0]+=l:this._iaddn(l);}this._strip();},i.prototype.copy=function(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++)e.words[t]=this.words[t];e.length=this.length,e.negative=this.negative,e.red=this.red;},i.prototype._move=function(e){l(e,this);},i.prototype.clone=function(){var e=new i(null);return this.copy(e),e},i.prototype._expand=function(e){for(;this.length<e;)this.words[this.length++]=0;return this},i.prototype._strip=function(){for(;this.length>1&&0===this.words[this.length-1];)this.length--;return this._normSign()},i.prototype._normSign=function(){return 1===this.length&&0===this.words[0]&&(this.negative=0),this},"undefined"!=typeof Symbol&&"function"==typeof Symbol.for)try{i.prototype[Symbol.for("nodejs.util.inspect.custom")]=c;}catch(e){i.prototype.inspect=c;}else i.prototype.inspect=c;function c(){return (this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"}var d=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"],f=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5],h=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];i.prototype.toString=function(e,t){var r;if(t=0|t||1,16===(e=e||10)||"hex"===e){r="";for(var i=0,o=0,a=0;a<this.length;a++){var s=this.words[a],u=(16777215&(s<<i|o)).toString(16);o=s>>>24-i&16777215,(i+=2)>=26&&(i-=26,a--),r=0!==o||a!==this.length-1?d[6-u.length]+u+r:u+r;}for(0!==o&&(r=o.toString(16)+r);r.length%t!=0;)r="0"+r;return 0!==this.negative&&(r="-"+r),r}if(e===(0|e)&&e>=2&&e<=36){var l=f[e],c=h[e];r="";var p=this.clone();for(p.negative=0;!p.isZero();){var m=p.modrn(c).toString(e);r=(p=p.idivn(c)).isZero()?m+r:d[l-m.length]+m+r;}for(this.isZero()&&(r="0"+r);r.length%t!=0;)r="0"+r;return 0!==this.negative&&(r="-"+r),r}n(false,"Base should be between 2 and 36");},i.prototype.toNumber=function(){var e=this.words[0];return 2===this.length?e+=67108864*this.words[1]:3===this.length&&1===this.words[2]?e+=4503599627370496+67108864*this.words[1]:this.length>2&&n(false,"Number can only safely store up to 53 bits"),0!==this.negative?-e:e},i.prototype.toJSON=function(){return this.toString(16,2)},o&&(i.prototype.toBuffer=function(e,t){return this.toArrayLike(o,e,t)}),i.prototype.toArray=function(e,t){return this.toArrayLike(Array,e,t)};function p(e,t,n){n.negative=t.negative^e.negative;var r=e.length+t.length|0;n.length=r,r=r-1|0;var i=0|e.words[0],o=0|t.words[0],a=i*o,s=67108863&a,u=a/67108864|0;n.words[0]=s;for(var l=1;l<r;l++){for(var c=u>>>26,d=67108863&u,f=Math.min(l,t.length-1),h=Math.max(0,l-e.length+1);h<=f;h++){var p=l-h|0;c+=(a=(i=0|e.words[p])*(o=0|t.words[h])+d)/67108864|0,d=67108863&a;}n.words[l]=0|d,u=0|c;}return 0!==u?n.words[l]=0|u:n.length--,n._strip()}i.prototype.toArrayLike=function(e,t,r){this._strip();var i=this.byteLength(),o=r||Math.max(1,i);n(i<=o,"byte array longer than desired length"),n(o>0,"Requested array length <= 0");var a=function(e,t){return e.allocUnsafe?e.allocUnsafe(t):new e(t)}(e,o);return this["_toArrayLike"+("le"===t?"LE":"BE")](a,i),a},i.prototype._toArrayLikeLE=function(e,t){for(var n=0,r=0,i=0,o=0;i<this.length;i++){var a=this.words[i]<<o|r;e[n++]=255&a,n<e.length&&(e[n++]=a>>8&255),n<e.length&&(e[n++]=a>>16&255),6===o?(n<e.length&&(e[n++]=a>>24&255),r=0,o=0):(r=a>>>24,o+=2);}if(n<e.length)for(e[n++]=r;n<e.length;)e[n++]=0;},i.prototype._toArrayLikeBE=function(e,t){for(var n=e.length-1,r=0,i=0,o=0;i<this.length;i++){var a=this.words[i]<<o|r;e[n--]=255&a,n>=0&&(e[n--]=a>>8&255),n>=0&&(e[n--]=a>>16&255),6===o?(n>=0&&(e[n--]=a>>24&255),r=0,o=0):(r=a>>>24,o+=2);}if(n>=0)for(e[n--]=r;n>=0;)e[n--]=0;},Math.clz32?i.prototype._countBits=function(e){return 32-Math.clz32(e)}:i.prototype._countBits=function(e){var t=e,n=0;return t>=4096&&(n+=13,t>>>=13),t>=64&&(n+=7,t>>>=7),t>=8&&(n+=4,t>>>=4),t>=2&&(n+=2,t>>>=2),n+t},i.prototype._zeroBits=function(e){if(0===e)return 26;var t=e,n=0;return 0==(8191&t)&&(n+=13,t>>>=13),0==(127&t)&&(n+=7,t>>>=7),0==(15&t)&&(n+=4,t>>>=4),0==(3&t)&&(n+=2,t>>>=2),0==(1&t)&&n++,n},i.prototype.bitLength=function(){var e=this.words[this.length-1],t=this._countBits(e);return 26*(this.length-1)+t},i.prototype.zeroBits=function(){if(this.isZero())return 0;for(var e=0,t=0;t<this.length;t++){var n=this._zeroBits(this.words[t]);if(e+=n,26!==n)break}return e},i.prototype.byteLength=function(){return Math.ceil(this.bitLength()/8)},i.prototype.toTwos=function(e){return 0!==this.negative?this.abs().inotn(e).iaddn(1):this.clone()},i.prototype.fromTwos=function(e){return this.testn(e-1)?this.notn(e).iaddn(1).ineg():this.clone()},i.prototype.isNeg=function(){return 0!==this.negative},i.prototype.neg=function(){return this.clone().ineg()},i.prototype.ineg=function(){return this.isZero()||(this.negative^=1),this},i.prototype.iuor=function(e){for(;this.length<e.length;)this.words[this.length++]=0;for(var t=0;t<e.length;t++)this.words[t]=this.words[t]|e.words[t];return this._strip()},i.prototype.ior=function(e){return n(0==(this.negative|e.negative)),this.iuor(e)},i.prototype.or=function(e){return this.length>e.length?this.clone().ior(e):e.clone().ior(this)},i.prototype.uor=function(e){return this.length>e.length?this.clone().iuor(e):e.clone().iuor(this)},i.prototype.iuand=function(e){var t;t=this.length>e.length?e:this;for(var n=0;n<t.length;n++)this.words[n]=this.words[n]&e.words[n];return this.length=t.length,this._strip()},i.prototype.iand=function(e){return n(0==(this.negative|e.negative)),this.iuand(e)},i.prototype.and=function(e){return this.length>e.length?this.clone().iand(e):e.clone().iand(this)},i.prototype.uand=function(e){return this.length>e.length?this.clone().iuand(e):e.clone().iuand(this)},i.prototype.iuxor=function(e){var t,n;this.length>e.length?(t=this,n=e):(t=e,n=this);for(var r=0;r<n.length;r++)this.words[r]=t.words[r]^n.words[r];if(this!==t)for(;r<t.length;r++)this.words[r]=t.words[r];return this.length=t.length,this._strip()},i.prototype.ixor=function(e){return n(0==(this.negative|e.negative)),this.iuxor(e)},i.prototype.xor=function(e){return this.length>e.length?this.clone().ixor(e):e.clone().ixor(this)},i.prototype.uxor=function(e){return this.length>e.length?this.clone().iuxor(e):e.clone().iuxor(this)},i.prototype.inotn=function(e){n("number"==typeof e&&e>=0);var t=0|Math.ceil(e/26),r=e%26;this._expand(t),r>0&&t--;for(var i=0;i<t;i++)this.words[i]=67108863&~this.words[i];return r>0&&(this.words[i]=~this.words[i]&67108863>>26-r),this._strip()},i.prototype.notn=function(e){return this.clone().inotn(e)},i.prototype.setn=function(e,t){n("number"==typeof e&&e>=0);var r=e/26|0,i=e%26;return this._expand(r+1),this.words[r]=t?this.words[r]|1<<i:this.words[r]&~(1<<i),this._strip()},i.prototype.iadd=function(e){var t,n,r;if(0!==this.negative&&0===e.negative)return this.negative=0,t=this.isub(e),this.negative^=1,this._normSign();if(0===this.negative&&0!==e.negative)return e.negative=0,t=this.isub(e),e.negative=1,t._normSign();this.length>e.length?(n=this,r=e):(n=e,r=this);for(var i=0,o=0;o<r.length;o++)t=(0|n.words[o])+(0|r.words[o])+i,this.words[o]=67108863&t,i=t>>>26;for(;0!==i&&o<n.length;o++)t=(0|n.words[o])+i,this.words[o]=67108863&t,i=t>>>26;if(this.length=n.length,0!==i)this.words[this.length]=i,this.length++;else if(n!==this)for(;o<n.length;o++)this.words[o]=n.words[o];return this},i.prototype.add=function(e){var t;return 0!==e.negative&&0===this.negative?(e.negative=0,t=this.sub(e),e.negative^=1,t):0===e.negative&&0!==this.negative?(this.negative=0,t=e.sub(this),this.negative=1,t):this.length>e.length?this.clone().iadd(e):e.clone().iadd(this)},i.prototype.isub=function(e){if(0!==e.negative){e.negative=0;var t=this.iadd(e);return e.negative=1,t._normSign()}if(0!==this.negative)return this.negative=0,this.iadd(e),this.negative=1,this._normSign();var n,r,i=this.cmp(e);if(0===i)return this.negative=0,this.length=1,this.words[0]=0,this;i>0?(n=this,r=e):(n=e,r=this);for(var o=0,a=0;a<r.length;a++)o=(t=(0|n.words[a])-(0|r.words[a])+o)>>26,this.words[a]=67108863&t;for(;0!==o&&a<n.length;a++)o=(t=(0|n.words[a])+o)>>26,this.words[a]=67108863&t;if(0===o&&a<n.length&&n!==this)for(;a<n.length;a++)this.words[a]=n.words[a];return this.length=Math.max(this.length,a),n!==this&&(this.negative=1),this._strip()},i.prototype.sub=function(e){return this.clone().isub(e)};var m=function(e,t,n){var r,i,o,a=e.words,s=t.words,u=n.words,l=0,c=0|a[0],d=8191&c,f=c>>>13,h=0|a[1],p=8191&h,m=h>>>13,g=0|a[2],v=8191&g,b=g>>>13,y=0|a[3],w=8191&y,_=y>>>13,S=0|a[4],E=8191&S,k=S>>>13,M=0|a[5],C=8191&M,x=M>>>13,A=0|a[6],R=8191&A,T=A>>>13,P=0|a[7],L=8191&P,I=P>>>13,O=0|a[8],N=8191&O,D=O>>>13,j=0|a[9],B=8191&j,z=j>>>13,U=0|s[0],F=8191&U,K=U>>>13,q=0|s[1],H=8191&q,W=q>>>13,$=0|s[2],V=8191&$,Y=$>>>13,G=0|s[3],Z=8191&G,Q=G>>>13,J=0|s[4],X=8191&J,ee=J>>>13,te=0|s[5],ne=8191&te,re=te>>>13,ie=0|s[6],oe=8191&ie,ae=ie>>>13,se=0|s[7],ue=8191&se,le=se>>>13,ce=0|s[8],de=8191&ce,fe=ce>>>13,he=0|s[9],pe=8191&he,me=he>>>13;n.negative=e.negative^t.negative,n.length=19;var ge=(l+(r=Math.imul(d,F))|0)+((8191&(i=(i=Math.imul(d,K))+Math.imul(f,F)|0))<<13)|0;l=((o=Math.imul(f,K))+(i>>>13)|0)+(ge>>>26)|0,ge&=67108863,r=Math.imul(p,F),i=(i=Math.imul(p,K))+Math.imul(m,F)|0,o=Math.imul(m,K);var ve=(l+(r=r+Math.imul(d,H)|0)|0)+((8191&(i=(i=i+Math.imul(d,W)|0)+Math.imul(f,H)|0))<<13)|0;l=((o=o+Math.imul(f,W)|0)+(i>>>13)|0)+(ve>>>26)|0,ve&=67108863,r=Math.imul(v,F),i=(i=Math.imul(v,K))+Math.imul(b,F)|0,o=Math.imul(b,K),r=r+Math.imul(p,H)|0,i=(i=i+Math.imul(p,W)|0)+Math.imul(m,H)|0,o=o+Math.imul(m,W)|0;var be=(l+(r=r+Math.imul(d,V)|0)|0)+((8191&(i=(i=i+Math.imul(d,Y)|0)+Math.imul(f,V)|0))<<13)|0;l=((o=o+Math.imul(f,Y)|0)+(i>>>13)|0)+(be>>>26)|0,be&=67108863,r=Math.imul(w,F),i=(i=Math.imul(w,K))+Math.imul(_,F)|0,o=Math.imul(_,K),r=r+Math.imul(v,H)|0,i=(i=i+Math.imul(v,W)|0)+Math.imul(b,H)|0,o=o+Math.imul(b,W)|0,r=r+Math.imul(p,V)|0,i=(i=i+Math.imul(p,Y)|0)+Math.imul(m,V)|0,o=o+Math.imul(m,Y)|0;var ye=(l+(r=r+Math.imul(d,Z)|0)|0)+((8191&(i=(i=i+Math.imul(d,Q)|0)+Math.imul(f,Z)|0))<<13)|0;l=((o=o+Math.imul(f,Q)|0)+(i>>>13)|0)+(ye>>>26)|0,ye&=67108863,r=Math.imul(E,F),i=(i=Math.imul(E,K))+Math.imul(k,F)|0,o=Math.imul(k,K),r=r+Math.imul(w,H)|0,i=(i=i+Math.imul(w,W)|0)+Math.imul(_,H)|0,o=o+Math.imul(_,W)|0,r=r+Math.imul(v,V)|0,i=(i=i+Math.imul(v,Y)|0)+Math.imul(b,V)|0,o=o+Math.imul(b,Y)|0,r=r+Math.imul(p,Z)|0,i=(i=i+Math.imul(p,Q)|0)+Math.imul(m,Z)|0,o=o+Math.imul(m,Q)|0;var we=(l+(r=r+Math.imul(d,X)|0)|0)+((8191&(i=(i=i+Math.imul(d,ee)|0)+Math.imul(f,X)|0))<<13)|0;l=((o=o+Math.imul(f,ee)|0)+(i>>>13)|0)+(we>>>26)|0,we&=67108863,r=Math.imul(C,F),i=(i=Math.imul(C,K))+Math.imul(x,F)|0,o=Math.imul(x,K),r=r+Math.imul(E,H)|0,i=(i=i+Math.imul(E,W)|0)+Math.imul(k,H)|0,o=o+Math.imul(k,W)|0,r=r+Math.imul(w,V)|0,i=(i=i+Math.imul(w,Y)|0)+Math.imul(_,V)|0,o=o+Math.imul(_,Y)|0,r=r+Math.imul(v,Z)|0,i=(i=i+Math.imul(v,Q)|0)+Math.imul(b,Z)|0,o=o+Math.imul(b,Q)|0,r=r+Math.imul(p,X)|0,i=(i=i+Math.imul(p,ee)|0)+Math.imul(m,X)|0,o=o+Math.imul(m,ee)|0;var _e=(l+(r=r+Math.imul(d,ne)|0)|0)+((8191&(i=(i=i+Math.imul(d,re)|0)+Math.imul(f,ne)|0))<<13)|0;l=((o=o+Math.imul(f,re)|0)+(i>>>13)|0)+(_e>>>26)|0,_e&=67108863,r=Math.imul(R,F),i=(i=Math.imul(R,K))+Math.imul(T,F)|0,o=Math.imul(T,K),r=r+Math.imul(C,H)|0,i=(i=i+Math.imul(C,W)|0)+Math.imul(x,H)|0,o=o+Math.imul(x,W)|0,r=r+Math.imul(E,V)|0,i=(i=i+Math.imul(E,Y)|0)+Math.imul(k,V)|0,o=o+Math.imul(k,Y)|0,r=r+Math.imul(w,Z)|0,i=(i=i+Math.imul(w,Q)|0)+Math.imul(_,Z)|0,o=o+Math.imul(_,Q)|0,r=r+Math.imul(v,X)|0,i=(i=i+Math.imul(v,ee)|0)+Math.imul(b,X)|0,o=o+Math.imul(b,ee)|0,r=r+Math.imul(p,ne)|0,i=(i=i+Math.imul(p,re)|0)+Math.imul(m,ne)|0,o=o+Math.imul(m,re)|0;var Se=(l+(r=r+Math.imul(d,oe)|0)|0)+((8191&(i=(i=i+Math.imul(d,ae)|0)+Math.imul(f,oe)|0))<<13)|0;l=((o=o+Math.imul(f,ae)|0)+(i>>>13)|0)+(Se>>>26)|0,Se&=67108863,r=Math.imul(L,F),i=(i=Math.imul(L,K))+Math.imul(I,F)|0,o=Math.imul(I,K),r=r+Math.imul(R,H)|0,i=(i=i+Math.imul(R,W)|0)+Math.imul(T,H)|0,o=o+Math.imul(T,W)|0,r=r+Math.imul(C,V)|0,i=(i=i+Math.imul(C,Y)|0)+Math.imul(x,V)|0,o=o+Math.imul(x,Y)|0,r=r+Math.imul(E,Z)|0,i=(i=i+Math.imul(E,Q)|0)+Math.imul(k,Z)|0,o=o+Math.imul(k,Q)|0,r=r+Math.imul(w,X)|0,i=(i=i+Math.imul(w,ee)|0)+Math.imul(_,X)|0,o=o+Math.imul(_,ee)|0,r=r+Math.imul(v,ne)|0,i=(i=i+Math.imul(v,re)|0)+Math.imul(b,ne)|0,o=o+Math.imul(b,re)|0,r=r+Math.imul(p,oe)|0,i=(i=i+Math.imul(p,ae)|0)+Math.imul(m,oe)|0,o=o+Math.imul(m,ae)|0;var Ee=(l+(r=r+Math.imul(d,ue)|0)|0)+((8191&(i=(i=i+Math.imul(d,le)|0)+Math.imul(f,ue)|0))<<13)|0;l=((o=o+Math.imul(f,le)|0)+(i>>>13)|0)+(Ee>>>26)|0,Ee&=67108863,r=Math.imul(N,F),i=(i=Math.imul(N,K))+Math.imul(D,F)|0,o=Math.imul(D,K),r=r+Math.imul(L,H)|0,i=(i=i+Math.imul(L,W)|0)+Math.imul(I,H)|0,o=o+Math.imul(I,W)|0,r=r+Math.imul(R,V)|0,i=(i=i+Math.imul(R,Y)|0)+Math.imul(T,V)|0,o=o+Math.imul(T,Y)|0,r=r+Math.imul(C,Z)|0,i=(i=i+Math.imul(C,Q)|0)+Math.imul(x,Z)|0,o=o+Math.imul(x,Q)|0,r=r+Math.imul(E,X)|0,i=(i=i+Math.imul(E,ee)|0)+Math.imul(k,X)|0,o=o+Math.imul(k,ee)|0,r=r+Math.imul(w,ne)|0,i=(i=i+Math.imul(w,re)|0)+Math.imul(_,ne)|0,o=o+Math.imul(_,re)|0,r=r+Math.imul(v,oe)|0,i=(i=i+Math.imul(v,ae)|0)+Math.imul(b,oe)|0,o=o+Math.imul(b,ae)|0,r=r+Math.imul(p,ue)|0,i=(i=i+Math.imul(p,le)|0)+Math.imul(m,ue)|0,o=o+Math.imul(m,le)|0;var ke=(l+(r=r+Math.imul(d,de)|0)|0)+((8191&(i=(i=i+Math.imul(d,fe)|0)+Math.imul(f,de)|0))<<13)|0;l=((o=o+Math.imul(f,fe)|0)+(i>>>13)|0)+(ke>>>26)|0,ke&=67108863,r=Math.imul(B,F),i=(i=Math.imul(B,K))+Math.imul(z,F)|0,o=Math.imul(z,K),r=r+Math.imul(N,H)|0,i=(i=i+Math.imul(N,W)|0)+Math.imul(D,H)|0,o=o+Math.imul(D,W)|0,r=r+Math.imul(L,V)|0,i=(i=i+Math.imul(L,Y)|0)+Math.imul(I,V)|0,o=o+Math.imul(I,Y)|0,r=r+Math.imul(R,Z)|0,i=(i=i+Math.imul(R,Q)|0)+Math.imul(T,Z)|0,o=o+Math.imul(T,Q)|0,r=r+Math.imul(C,X)|0,i=(i=i+Math.imul(C,ee)|0)+Math.imul(x,X)|0,o=o+Math.imul(x,ee)|0,r=r+Math.imul(E,ne)|0,i=(i=i+Math.imul(E,re)|0)+Math.imul(k,ne)|0,o=o+Math.imul(k,re)|0,r=r+Math.imul(w,oe)|0,i=(i=i+Math.imul(w,ae)|0)+Math.imul(_,oe)|0,o=o+Math.imul(_,ae)|0,r=r+Math.imul(v,ue)|0,i=(i=i+Math.imul(v,le)|0)+Math.imul(b,ue)|0,o=o+Math.imul(b,le)|0,r=r+Math.imul(p,de)|0,i=(i=i+Math.imul(p,fe)|0)+Math.imul(m,de)|0,o=o+Math.imul(m,fe)|0;var Me=(l+(r=r+Math.imul(d,pe)|0)|0)+((8191&(i=(i=i+Math.imul(d,me)|0)+Math.imul(f,pe)|0))<<13)|0;l=((o=o+Math.imul(f,me)|0)+(i>>>13)|0)+(Me>>>26)|0,Me&=67108863,r=Math.imul(B,H),i=(i=Math.imul(B,W))+Math.imul(z,H)|0,o=Math.imul(z,W),r=r+Math.imul(N,V)|0,i=(i=i+Math.imul(N,Y)|0)+Math.imul(D,V)|0,o=o+Math.imul(D,Y)|0,r=r+Math.imul(L,Z)|0,i=(i=i+Math.imul(L,Q)|0)+Math.imul(I,Z)|0,o=o+Math.imul(I,Q)|0,r=r+Math.imul(R,X)|0,i=(i=i+Math.imul(R,ee)|0)+Math.imul(T,X)|0,o=o+Math.imul(T,ee)|0,r=r+Math.imul(C,ne)|0,i=(i=i+Math.imul(C,re)|0)+Math.imul(x,ne)|0,o=o+Math.imul(x,re)|0,r=r+Math.imul(E,oe)|0,i=(i=i+Math.imul(E,ae)|0)+Math.imul(k,oe)|0,o=o+Math.imul(k,ae)|0,r=r+Math.imul(w,ue)|0,i=(i=i+Math.imul(w,le)|0)+Math.imul(_,ue)|0,o=o+Math.imul(_,le)|0,r=r+Math.imul(v,de)|0,i=(i=i+Math.imul(v,fe)|0)+Math.imul(b,de)|0,o=o+Math.imul(b,fe)|0;var Ce=(l+(r=r+Math.imul(p,pe)|0)|0)+((8191&(i=(i=i+Math.imul(p,me)|0)+Math.imul(m,pe)|0))<<13)|0;l=((o=o+Math.imul(m,me)|0)+(i>>>13)|0)+(Ce>>>26)|0,Ce&=67108863,r=Math.imul(B,V),i=(i=Math.imul(B,Y))+Math.imul(z,V)|0,o=Math.imul(z,Y),r=r+Math.imul(N,Z)|0,i=(i=i+Math.imul(N,Q)|0)+Math.imul(D,Z)|0,o=o+Math.imul(D,Q)|0,r=r+Math.imul(L,X)|0,i=(i=i+Math.imul(L,ee)|0)+Math.imul(I,X)|0,o=o+Math.imul(I,ee)|0,r=r+Math.imul(R,ne)|0,i=(i=i+Math.imul(R,re)|0)+Math.imul(T,ne)|0,o=o+Math.imul(T,re)|0,r=r+Math.imul(C,oe)|0,i=(i=i+Math.imul(C,ae)|0)+Math.imul(x,oe)|0,o=o+Math.imul(x,ae)|0,r=r+Math.imul(E,ue)|0,i=(i=i+Math.imul(E,le)|0)+Math.imul(k,ue)|0,o=o+Math.imul(k,le)|0,r=r+Math.imul(w,de)|0,i=(i=i+Math.imul(w,fe)|0)+Math.imul(_,de)|0,o=o+Math.imul(_,fe)|0;var xe=(l+(r=r+Math.imul(v,pe)|0)|0)+((8191&(i=(i=i+Math.imul(v,me)|0)+Math.imul(b,pe)|0))<<13)|0;l=((o=o+Math.imul(b,me)|0)+(i>>>13)|0)+(xe>>>26)|0,xe&=67108863,r=Math.imul(B,Z),i=(i=Math.imul(B,Q))+Math.imul(z,Z)|0,o=Math.imul(z,Q),r=r+Math.imul(N,X)|0,i=(i=i+Math.imul(N,ee)|0)+Math.imul(D,X)|0,o=o+Math.imul(D,ee)|0,r=r+Math.imul(L,ne)|0,i=(i=i+Math.imul(L,re)|0)+Math.imul(I,ne)|0,o=o+Math.imul(I,re)|0,r=r+Math.imul(R,oe)|0,i=(i=i+Math.imul(R,ae)|0)+Math.imul(T,oe)|0,o=o+Math.imul(T,ae)|0,r=r+Math.imul(C,ue)|0,i=(i=i+Math.imul(C,le)|0)+Math.imul(x,ue)|0,o=o+Math.imul(x,le)|0,r=r+Math.imul(E,de)|0,i=(i=i+Math.imul(E,fe)|0)+Math.imul(k,de)|0,o=o+Math.imul(k,fe)|0;var Ae=(l+(r=r+Math.imul(w,pe)|0)|0)+((8191&(i=(i=i+Math.imul(w,me)|0)+Math.imul(_,pe)|0))<<13)|0;l=((o=o+Math.imul(_,me)|0)+(i>>>13)|0)+(Ae>>>26)|0,Ae&=67108863,r=Math.imul(B,X),i=(i=Math.imul(B,ee))+Math.imul(z,X)|0,o=Math.imul(z,ee),r=r+Math.imul(N,ne)|0,i=(i=i+Math.imul(N,re)|0)+Math.imul(D,ne)|0,o=o+Math.imul(D,re)|0,r=r+Math.imul(L,oe)|0,i=(i=i+Math.imul(L,ae)|0)+Math.imul(I,oe)|0,o=o+Math.imul(I,ae)|0,r=r+Math.imul(R,ue)|0,i=(i=i+Math.imul(R,le)|0)+Math.imul(T,ue)|0,o=o+Math.imul(T,le)|0,r=r+Math.imul(C,de)|0,i=(i=i+Math.imul(C,fe)|0)+Math.imul(x,de)|0,o=o+Math.imul(x,fe)|0;var Re=(l+(r=r+Math.imul(E,pe)|0)|0)+((8191&(i=(i=i+Math.imul(E,me)|0)+Math.imul(k,pe)|0))<<13)|0;l=((o=o+Math.imul(k,me)|0)+(i>>>13)|0)+(Re>>>26)|0,Re&=67108863,r=Math.imul(B,ne),i=(i=Math.imul(B,re))+Math.imul(z,ne)|0,o=Math.imul(z,re),r=r+Math.imul(N,oe)|0,i=(i=i+Math.imul(N,ae)|0)+Math.imul(D,oe)|0,o=o+Math.imul(D,ae)|0,r=r+Math.imul(L,ue)|0,i=(i=i+Math.imul(L,le)|0)+Math.imul(I,ue)|0,o=o+Math.imul(I,le)|0,r=r+Math.imul(R,de)|0,i=(i=i+Math.imul(R,fe)|0)+Math.imul(T,de)|0,o=o+Math.imul(T,fe)|0;var Te=(l+(r=r+Math.imul(C,pe)|0)|0)+((8191&(i=(i=i+Math.imul(C,me)|0)+Math.imul(x,pe)|0))<<13)|0;l=((o=o+Math.imul(x,me)|0)+(i>>>13)|0)+(Te>>>26)|0,Te&=67108863,r=Math.imul(B,oe),i=(i=Math.imul(B,ae))+Math.imul(z,oe)|0,o=Math.imul(z,ae),r=r+Math.imul(N,ue)|0,i=(i=i+Math.imul(N,le)|0)+Math.imul(D,ue)|0,o=o+Math.imul(D,le)|0,r=r+Math.imul(L,de)|0,i=(i=i+Math.imul(L,fe)|0)+Math.imul(I,de)|0,o=o+Math.imul(I,fe)|0;var Pe=(l+(r=r+Math.imul(R,pe)|0)|0)+((8191&(i=(i=i+Math.imul(R,me)|0)+Math.imul(T,pe)|0))<<13)|0;l=((o=o+Math.imul(T,me)|0)+(i>>>13)|0)+(Pe>>>26)|0,Pe&=67108863,r=Math.imul(B,ue),i=(i=Math.imul(B,le))+Math.imul(z,ue)|0,o=Math.imul(z,le),r=r+Math.imul(N,de)|0,i=(i=i+Math.imul(N,fe)|0)+Math.imul(D,de)|0,o=o+Math.imul(D,fe)|0;var Le=(l+(r=r+Math.imul(L,pe)|0)|0)+((8191&(i=(i=i+Math.imul(L,me)|0)+Math.imul(I,pe)|0))<<13)|0;l=((o=o+Math.imul(I,me)|0)+(i>>>13)|0)+(Le>>>26)|0,Le&=67108863,r=Math.imul(B,de),i=(i=Math.imul(B,fe))+Math.imul(z,de)|0,o=Math.imul(z,fe);var Ie=(l+(r=r+Math.imul(N,pe)|0)|0)+((8191&(i=(i=i+Math.imul(N,me)|0)+Math.imul(D,pe)|0))<<13)|0;l=((o=o+Math.imul(D,me)|0)+(i>>>13)|0)+(Ie>>>26)|0,Ie&=67108863;var Oe=(l+(r=Math.imul(B,pe))|0)+((8191&(i=(i=Math.imul(B,me))+Math.imul(z,pe)|0))<<13)|0;return l=((o=Math.imul(z,me))+(i>>>13)|0)+(Oe>>>26)|0,Oe&=67108863,u[0]=ge,u[1]=ve,u[2]=be,u[3]=ye,u[4]=we,u[5]=_e,u[6]=Se,u[7]=Ee,u[8]=ke,u[9]=Me,u[10]=Ce,u[11]=xe,u[12]=Ae,u[13]=Re,u[14]=Te,u[15]=Pe,u[16]=Le,u[17]=Ie,u[18]=Oe,0!==l&&(u[19]=l,n.length++),n};function g(e,t,n){n.negative=t.negative^e.negative,n.length=e.length+t.length;for(var r=0,i=0,o=0;o<n.length-1;o++){var a=i;i=0;for(var s=67108863&r,u=Math.min(o,t.length-1),l=Math.max(0,o-e.length+1);l<=u;l++){var c=o-l,d=(0|e.words[c])*(0|t.words[l]),f=67108863&d;s=67108863&(f=f+s|0),i+=(a=(a=a+(d/67108864|0)|0)+(f>>>26)|0)>>>26,a&=67108863;}n.words[o]=s,r=a,a=i;}return 0!==r?n.words[o]=r:n.length--,n._strip()}function v(e,t,n){return g(e,t,n)}Math.imul||(m=p),i.prototype.mulTo=function(e,t){var n=this.length+e.length;return 10===this.length&&10===e.length?m(this,e,t):n<63?p(this,e,t):n<1024?g(this,e,t):v(this,e,t)},i.prototype.mul=function(e){var t=new i(null);return t.words=new Array(this.length+e.length),this.mulTo(e,t)},i.prototype.mulf=function(e){var t=new i(null);return t.words=new Array(this.length+e.length),v(this,e,t)},i.prototype.imul=function(e){return this.clone().mulTo(e,this)},i.prototype.imuln=function(e){var t=e<0;t&&(e=-e),n("number"==typeof e),n(e<67108864);for(var r=0,i=0;i<this.length;i++){var o=(0|this.words[i])*e,a=(67108863&o)+(67108863&r);r>>=26,r+=o/67108864|0,r+=a>>>26,this.words[i]=67108863&a;}return 0!==r&&(this.words[i]=r,this.length++),t?this.ineg():this},i.prototype.muln=function(e){return this.clone().imuln(e)},i.prototype.sqr=function(){return this.mul(this)},i.prototype.isqr=function(){return this.imul(this.clone())},i.prototype.pow=function(e){var t=function(e){for(var t=new Array(e.bitLength()),n=0;n<t.length;n++){var r=n/26|0,i=n%26;t[n]=e.words[r]>>>i&1;}return t}(e);if(0===t.length)return new i(1);for(var n=this,r=0;r<t.length&&0===t[r];r++,n=n.sqr());if(++r<t.length)for(var o=n.sqr();r<t.length;r++,o=o.sqr())0!==t[r]&&(n=n.mul(o));return n},i.prototype.iushln=function(e){n("number"==typeof e&&e>=0);var t,r=e%26,i=(e-r)/26,o=67108863>>>26-r<<26-r;if(0!==r){var a=0;for(t=0;t<this.length;t++){var s=this.words[t]&o,u=(0|this.words[t])-s<<r;this.words[t]=u|a,a=s>>>26-r;}a&&(this.words[t]=a,this.length++);}if(0!==i){for(t=this.length-1;t>=0;t--)this.words[t+i]=this.words[t];for(t=0;t<i;t++)this.words[t]=0;this.length+=i;}return this._strip()},i.prototype.ishln=function(e){return n(0===this.negative),this.iushln(e)},i.prototype.iushrn=function(e,t,r){var i;n("number"==typeof e&&e>=0),i=t?(t-t%26)/26:0;var o=e%26,a=Math.min((e-o)/26,this.length),s=67108863^67108863>>>o<<o,u=r;if(i-=a,i=Math.max(0,i),u){for(var l=0;l<a;l++)u.words[l]=this.words[l];u.length=a;}if(0===a);else if(this.length>a)for(this.length-=a,l=0;l<this.length;l++)this.words[l]=this.words[l+a];else this.words[0]=0,this.length=1;var c=0;for(l=this.length-1;l>=0&&(0!==c||l>=i);l--){var d=0|this.words[l];this.words[l]=c<<26-o|d>>>o,c=d&s;}return u&&0!==c&&(u.words[u.length++]=c),0===this.length&&(this.words[0]=0,this.length=1),this._strip()},i.prototype.ishrn=function(e,t,r){return n(0===this.negative),this.iushrn(e,t,r)},i.prototype.shln=function(e){return this.clone().ishln(e)},i.prototype.ushln=function(e){return this.clone().iushln(e)},i.prototype.shrn=function(e){return this.clone().ishrn(e)},i.prototype.ushrn=function(e){return this.clone().iushrn(e)},i.prototype.testn=function(e){n("number"==typeof e&&e>=0);var t=e%26,r=(e-t)/26,i=1<<t;return !(this.length<=r)&&!!(this.words[r]&i)},i.prototype.imaskn=function(e){n("number"==typeof e&&e>=0);var t=e%26,r=(e-t)/26;if(n(0===this.negative,"imaskn works only with positive numbers"),this.length<=r)return this;if(0!==t&&r++,this.length=Math.min(r,this.length),0!==t){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i;}return this._strip()},i.prototype.maskn=function(e){return this.clone().imaskn(e)},i.prototype.iaddn=function(e){return n("number"==typeof e),n(e<67108864),e<0?this.isubn(-e):0!==this.negative?1===this.length&&(0|this.words[0])<=e?(this.words[0]=e-(0|this.words[0]),this.negative=0,this):(this.negative=0,this.isubn(e),this.negative=1,this):this._iaddn(e)},i.prototype._iaddn=function(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++)this.words[t]-=67108864,t===this.length-1?this.words[t+1]=1:this.words[t+1]++;return this.length=Math.max(this.length,t+1),this},i.prototype.isubn=function(e){if(n("number"==typeof e),n(e<67108864),e<0)return this.iaddn(-e);if(0!==this.negative)return this.negative=0,this.iaddn(e),this.negative=1,this;if(this.words[0]-=e,1===this.length&&this.words[0]<0)this.words[0]=-this.words[0],this.negative=1;else for(var t=0;t<this.length&&this.words[t]<0;t++)this.words[t]+=67108864,this.words[t+1]-=1;return this._strip()},i.prototype.addn=function(e){return this.clone().iaddn(e)},i.prototype.subn=function(e){return this.clone().isubn(e)},i.prototype.iabs=function(){return this.negative=0,this},i.prototype.abs=function(){return this.clone().iabs()},i.prototype._ishlnsubmul=function(e,t,r){var i,o,a=e.length+r;this._expand(a);var s=0;for(i=0;i<e.length;i++){o=(0|this.words[i+r])+s;var u=(0|e.words[i])*t;s=((o-=67108863&u)>>26)-(u/67108864|0),this.words[i+r]=67108863&o;}for(;i<this.length-r;i++)s=(o=(0|this.words[i+r])+s)>>26,this.words[i+r]=67108863&o;if(0===s)return this._strip();for(n(-1===s),s=0,i=0;i<this.length;i++)s=(o=-(0|this.words[i])+s)>>26,this.words[i]=67108863&o;return this.negative=1,this._strip()},i.prototype._wordDiv=function(e,t){var n=(this.length,e.length),r=this.clone(),o=e,a=0|o.words[o.length-1];0!==(n=26-this._countBits(a))&&(o=o.ushln(n),r.iushln(n),a=0|o.words[o.length-1]);var s,u=r.length-o.length;if("mod"!==t){(s=new i(null)).length=u+1,s.words=new Array(s.length);for(var l=0;l<s.length;l++)s.words[l]=0;}var c=r.clone()._ishlnsubmul(o,1,u);0===c.negative&&(r=c,s&&(s.words[u]=1));for(var d=u-1;d>=0;d--){var f=67108864*(0|r.words[o.length+d])+(0|r.words[o.length+d-1]);for(f=Math.min(f/a|0,67108863),r._ishlnsubmul(o,f,d);0!==r.negative;)f--,r.negative=0,r._ishlnsubmul(o,1,d),r.isZero()||(r.negative^=1);s&&(s.words[d]=f);}return s&&s._strip(),r._strip(),"div"!==t&&0!==n&&r.iushrn(n),{div:s||null,mod:r}},i.prototype.divmod=function(e,t,r){return n(!e.isZero()),this.isZero()?{div:new i(0),mod:new i(0)}:0!==this.negative&&0===e.negative?(s=this.neg().divmod(e,t),"mod"!==t&&(o=s.div.neg()),"div"!==t&&(a=s.mod.neg(),r&&0!==a.negative&&a.iadd(e)),{div:o,mod:a}):0===this.negative&&0!==e.negative?(s=this.divmod(e.neg(),t),"mod"!==t&&(o=s.div.neg()),{div:o,mod:s.mod}):0!=(this.negative&e.negative)?(s=this.neg().divmod(e.neg(),t),"div"!==t&&(a=s.mod.neg(),r&&0!==a.negative&&a.isub(e)),{div:s.div,mod:a}):e.length>this.length||this.cmp(e)<0?{div:new i(0),mod:this}:1===e.length?"div"===t?{div:this.divn(e.words[0]),mod:null}:"mod"===t?{div:null,mod:new i(this.modrn(e.words[0]))}:{div:this.divn(e.words[0]),mod:new i(this.modrn(e.words[0]))}:this._wordDiv(e,t);var o,a,s;},i.prototype.div=function(e){return this.divmod(e,"div",false).div},i.prototype.mod=function(e){return this.divmod(e,"mod",false).mod},i.prototype.umod=function(e){return this.divmod(e,"mod",true).mod},i.prototype.divRound=function(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var n=0!==t.div.negative?t.mod.isub(e):t.mod,r=e.ushrn(1),i=e.andln(1),o=n.cmp(r);return o<0||1===i&&0===o?t.div:0!==t.div.negative?t.div.isubn(1):t.div.iaddn(1)},i.prototype.modrn=function(e){var t=e<0;t&&(e=-e),n(e<=67108863);for(var r=(1<<26)%e,i=0,o=this.length-1;o>=0;o--)i=(r*i+(0|this.words[o]))%e;return t?-i:i},i.prototype.modn=function(e){return this.modrn(e)},i.prototype.idivn=function(e){var t=e<0;t&&(e=-e),n(e<=67108863);for(var r=0,i=this.length-1;i>=0;i--){var o=(0|this.words[i])+67108864*r;this.words[i]=o/e|0,r=o%e;}return this._strip(),t?this.ineg():this},i.prototype.divn=function(e){return this.clone().idivn(e)},i.prototype.egcd=function(e){n(0===e.negative),n(!e.isZero());var t=this,r=e.clone();t=0!==t.negative?t.umod(e):t.clone();for(var o=new i(1),a=new i(0),s=new i(0),u=new i(1),l=0;t.isEven()&&r.isEven();)t.iushrn(1),r.iushrn(1),++l;for(var c=r.clone(),d=t.clone();!t.isZero();){for(var f=0,h=1;0==(t.words[0]&h)&&f<26;++f,h<<=1);if(f>0)for(t.iushrn(f);f-- >0;)(o.isOdd()||a.isOdd())&&(o.iadd(c),a.isub(d)),o.iushrn(1),a.iushrn(1);for(var p=0,m=1;0==(r.words[0]&m)&&p<26;++p,m<<=1);if(p>0)for(r.iushrn(p);p-- >0;)(s.isOdd()||u.isOdd())&&(s.iadd(c),u.isub(d)),s.iushrn(1),u.iushrn(1);t.cmp(r)>=0?(t.isub(r),o.isub(s),a.isub(u)):(r.isub(t),s.isub(o),u.isub(a));}return {a:s,b:u,gcd:r.iushln(l)}},i.prototype._invmp=function(e){n(0===e.negative),n(!e.isZero());var t=this,r=e.clone();t=0!==t.negative?t.umod(e):t.clone();for(var o,a=new i(1),s=new i(0),u=r.clone();t.cmpn(1)>0&&r.cmpn(1)>0;){for(var l=0,c=1;0==(t.words[0]&c)&&l<26;++l,c<<=1);if(l>0)for(t.iushrn(l);l-- >0;)a.isOdd()&&a.iadd(u),a.iushrn(1);for(var d=0,f=1;0==(r.words[0]&f)&&d<26;++d,f<<=1);if(d>0)for(r.iushrn(d);d-- >0;)s.isOdd()&&s.iadd(u),s.iushrn(1);t.cmp(r)>=0?(t.isub(r),a.isub(s)):(r.isub(t),s.isub(a));}return (o=0===t.cmpn(1)?a:s).cmpn(0)<0&&o.iadd(e),o},i.prototype.gcd=function(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone(),n=e.clone();t.negative=0,n.negative=0;for(var r=0;t.isEven()&&n.isEven();r++)t.iushrn(1),n.iushrn(1);for(;;){for(;t.isEven();)t.iushrn(1);for(;n.isEven();)n.iushrn(1);var i=t.cmp(n);if(i<0){var o=t;t=n,n=o;}else if(0===i||0===n.cmpn(1))break;t.isub(n);}return n.iushln(r)},i.prototype.invm=function(e){return this.egcd(e).a.umod(e)},i.prototype.isEven=function(){return 0==(1&this.words[0])},i.prototype.isOdd=function(){return 1==(1&this.words[0])},i.prototype.andln=function(e){return this.words[0]&e},i.prototype.bincn=function(e){n("number"==typeof e);var t=e%26,r=(e-t)/26,i=1<<t;if(this.length<=r)return this._expand(r+1),this.words[r]|=i,this;for(var o=i,a=r;0!==o&&a<this.length;a++){var s=0|this.words[a];o=(s+=o)>>>26,s&=67108863,this.words[a]=s;}return 0!==o&&(this.words[a]=o,this.length++),this},i.prototype.isZero=function(){return 1===this.length&&0===this.words[0]},i.prototype.cmpn=function(e){var t,r=e<0;if(0!==this.negative&&!r)return  -1;if(0===this.negative&&r)return 1;if(this._strip(),this.length>1)t=1;else {r&&(e=-e),n(e<=67108863,"Number is too big");var i=0|this.words[0];t=i===e?0:i<e?-1:1;}return 0!==this.negative?0|-t:t},i.prototype.cmp=function(e){if(0!==this.negative&&0===e.negative)return  -1;if(0===this.negative&&0!==e.negative)return 1;var t=this.ucmp(e);return 0!==this.negative?0|-t:t},i.prototype.ucmp=function(e){if(this.length>e.length)return 1;if(this.length<e.length)return  -1;for(var t=0,n=this.length-1;n>=0;n--){var r=0|this.words[n],i=0|e.words[n];if(r!==i){r<i?t=-1:r>i&&(t=1);break}}return t},i.prototype.gtn=function(e){return 1===this.cmpn(e)},i.prototype.gt=function(e){return 1===this.cmp(e)},i.prototype.gten=function(e){return this.cmpn(e)>=0},i.prototype.gte=function(e){return this.cmp(e)>=0},i.prototype.ltn=function(e){return  -1===this.cmpn(e)},i.prototype.lt=function(e){return  -1===this.cmp(e)},i.prototype.lten=function(e){return this.cmpn(e)<=0},i.prototype.lte=function(e){return this.cmp(e)<=0},i.prototype.eqn=function(e){return 0===this.cmpn(e)},i.prototype.eq=function(e){return 0===this.cmp(e)},i.red=function(e){return new k(e)},i.prototype.toRed=function(e){return n(!this.red,"Already a number in reduction context"),n(0===this.negative,"red works only with positives"),e.convertTo(this)._forceRed(e)},i.prototype.fromRed=function(){return n(this.red,"fromRed works only with numbers in reduction context"),this.red.convertFrom(this)},i.prototype._forceRed=function(e){return this.red=e,this},i.prototype.forceRed=function(e){return n(!this.red,"Already a number in reduction context"),this._forceRed(e)},i.prototype.redAdd=function(e){return n(this.red,"redAdd works only with red numbers"),this.red.add(this,e)},i.prototype.redIAdd=function(e){return n(this.red,"redIAdd works only with red numbers"),this.red.iadd(this,e)},i.prototype.redSub=function(e){return n(this.red,"redSub works only with red numbers"),this.red.sub(this,e)},i.prototype.redISub=function(e){return n(this.red,"redISub works only with red numbers"),this.red.isub(this,e)},i.prototype.redShl=function(e){return n(this.red,"redShl works only with red numbers"),this.red.shl(this,e)},i.prototype.redMul=function(e){return n(this.red,"redMul works only with red numbers"),this.red._verify2(this,e),this.red.mul(this,e)},i.prototype.redIMul=function(e){return n(this.red,"redMul works only with red numbers"),this.red._verify2(this,e),this.red.imul(this,e)},i.prototype.redSqr=function(){return n(this.red,"redSqr works only with red numbers"),this.red._verify1(this),this.red.sqr(this)},i.prototype.redISqr=function(){return n(this.red,"redISqr works only with red numbers"),this.red._verify1(this),this.red.isqr(this)},i.prototype.redSqrt=function(){return n(this.red,"redSqrt works only with red numbers"),this.red._verify1(this),this.red.sqrt(this)},i.prototype.redInvm=function(){return n(this.red,"redInvm works only with red numbers"),this.red._verify1(this),this.red.invm(this)},i.prototype.redNeg=function(){return n(this.red,"redNeg works only with red numbers"),this.red._verify1(this),this.red.neg(this)},i.prototype.redPow=function(e){return n(this.red&&!e.red,"redPow(normalNum)"),this.red._verify1(this),this.red.pow(this,e)};var b={k256:null,p224:null,p192:null,p25519:null};function y(e,t){this.name=e,this.p=new i(t,16),this.n=this.p.bitLength(),this.k=new i(1).iushln(this.n).isub(this.p),this.tmp=this._tmp();}function w(){y.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");}function _(){y.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");}function S(){y.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");}function E(){y.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");}function k(e){if("string"==typeof e){var t=i._prime(e);this.m=t.p,this.prime=t;}else n(e.gtn(1),"modulus must be greater than 1"),this.m=e,this.prime=null;}function M(e){k.call(this,e),this.shift=this.m.bitLength(),this.shift%26!=0&&(this.shift+=26-this.shift%26),this.r=new i(1).iushln(this.shift),this.r2=this.imod(this.r.sqr()),this.rinv=this.r._invmp(this.m),this.minv=this.rinv.mul(this.r).isubn(1).div(this.m),this.minv=this.minv.umod(this.r),this.minv=this.r.sub(this.minv);}y.prototype._tmp=function(){var e=new i(null);return e.words=new Array(Math.ceil(this.n/13)),e},y.prototype.ireduce=function(e){var t,n=e;do{this.split(n,this.tmp),t=(n=(n=this.imulK(n)).iadd(this.tmp)).bitLength();}while(t>this.n);var r=t<this.n?-1:n.ucmp(this.p);return 0===r?(n.words[0]=0,n.length=1):r>0?n.isub(this.p):void 0!==n.strip?n.strip():n._strip(),n},y.prototype.split=function(e,t){e.iushrn(this.n,0,t);},y.prototype.imulK=function(e){return e.imul(this.k)},r(w,y),w.prototype.split=function(e,t){for(var n=4194303,r=Math.min(e.length,9),i=0;i<r;i++)t.words[i]=e.words[i];if(t.length=r,e.length<=9)return e.words[0]=0,void(e.length=1);var o=e.words[9];for(t.words[t.length++]=o&n,i=10;i<e.length;i++){var a=0|e.words[i];e.words[i-10]=(a&n)<<4|o>>>22,o=a;}o>>>=22,e.words[i-10]=o,0===o&&e.length>10?e.length-=10:e.length-=9;},w.prototype.imulK=function(e){e.words[e.length]=0,e.words[e.length+1]=0,e.length+=2;for(var t=0,n=0;n<e.length;n++){var r=0|e.words[n];t+=977*r,e.words[n]=67108863&t,t=64*r+(t/67108864|0);}return 0===e.words[e.length-1]&&(e.length--,0===e.words[e.length-1]&&e.length--),e},r(_,y),r(S,y),r(E,y),E.prototype.imulK=function(e){for(var t=0,n=0;n<e.length;n++){var r=19*(0|e.words[n])+t,i=67108863&r;r>>>=26,e.words[n]=i,t=r;}return 0!==t&&(e.words[e.length++]=t),e},i._prime=function(e){if(b[e])return b[e];var t;if("k256"===e)t=new w;else if("p224"===e)t=new _;else if("p192"===e)t=new S;else {if("p25519"!==e)throw new Error("Unknown prime "+e);t=new E;}return b[e]=t,t},k.prototype._verify1=function(e){n(0===e.negative,"red works only with positives"),n(e.red,"red works only with red numbers");},k.prototype._verify2=function(e,t){n(0==(e.negative|t.negative),"red works only with positives"),n(e.red&&e.red===t.red,"red works only with red numbers");},k.prototype.imod=function(e){return this.prime?this.prime.ireduce(e)._forceRed(this):(l(e,e.umod(this.m)._forceRed(this)),e)},k.prototype.neg=function(e){return e.isZero()?e.clone():this.m.sub(e)._forceRed(this)},k.prototype.add=function(e,t){this._verify2(e,t);var n=e.add(t);return n.cmp(this.m)>=0&&n.isub(this.m),n._forceRed(this)},k.prototype.iadd=function(e,t){this._verify2(e,t);var n=e.iadd(t);return n.cmp(this.m)>=0&&n.isub(this.m),n},k.prototype.sub=function(e,t){this._verify2(e,t);var n=e.sub(t);return n.cmpn(0)<0&&n.iadd(this.m),n._forceRed(this)},k.prototype.isub=function(e,t){this._verify2(e,t);var n=e.isub(t);return n.cmpn(0)<0&&n.iadd(this.m),n},k.prototype.shl=function(e,t){return this._verify1(e),this.imod(e.ushln(t))},k.prototype.imul=function(e,t){return this._verify2(e,t),this.imod(e.imul(t))},k.prototype.mul=function(e,t){return this._verify2(e,t),this.imod(e.mul(t))},k.prototype.isqr=function(e){return this.imul(e,e.clone())},k.prototype.sqr=function(e){return this.mul(e,e)},k.prototype.sqrt=function(e){if(e.isZero())return e.clone();var t=this.m.andln(3);if(n(t%2==1),3===t){var r=this.m.add(new i(1)).iushrn(2);return this.pow(e,r)}for(var o=this.m.subn(1),a=0;!o.isZero()&&0===o.andln(1);)a++,o.iushrn(1);n(!o.isZero());var s=new i(1).toRed(this),u=s.redNeg(),l=this.m.subn(1).iushrn(1),c=this.m.bitLength();for(c=new i(2*c*c).toRed(this);0!==this.pow(c,l).cmp(u);)c.redIAdd(u);for(var d=this.pow(c,o),f=this.pow(e,o.addn(1).iushrn(1)),h=this.pow(e,o),p=a;0!==h.cmp(s);){for(var m=h,g=0;0!==m.cmp(s);g++)m=m.redSqr();n(g<p);var v=this.pow(d,new i(1).iushln(p-g-1));f=f.redMul(v),d=v.redSqr(),h=h.redMul(d),p=g;}return f},k.prototype.invm=function(e){var t=e._invmp(this.m);return 0!==t.negative?(t.negative=0,this.imod(t).redNeg()):this.imod(t)},k.prototype.pow=function(e,t){if(t.isZero())return new i(1).toRed(this);if(0===t.cmpn(1))return e.clone();var n=new Array(16);n[0]=new i(1).toRed(this),n[1]=e;for(var r=2;r<n.length;r++)n[r]=this.mul(n[r-1],e);var o=n[0],a=0,s=0,u=t.bitLength()%26;for(0===u&&(u=26),r=t.length-1;r>=0;r--){for(var l=t.words[r],c=u-1;c>=0;c--){var d=l>>c&1;o!==n[0]&&(o=this.sqr(o)),0!==d||0!==a?(a<<=1,a|=d,(4===++s||0===r&&0===c)&&(o=this.mul(o,n[a]),s=0,a=0)):s=0;}u=26;}return o},k.prototype.convertTo=function(e){var t=e.umod(this.m);return t===e?t.clone():t},k.prototype.convertFrom=function(e){var t=e.clone();return t.red=null,t},i.mont=function(e){return new M(e)},r(M,k),M.prototype.convertTo=function(e){return this.imod(e.ushln(this.shift))},M.prototype.convertFrom=function(e){var t=this.imod(e.mul(this.rinv));return t.red=null,t},M.prototype.imul=function(e,t){if(e.isZero()||t.isZero())return e.words[0]=0,e.length=1,e;var n=e.imul(t),r=n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),i=n.isub(r).iushrn(this.shift),o=i;return i.cmp(this.m)>=0?o=i.isub(this.m):i.cmpn(0)<0&&(o=i.iadd(this.m)),o._forceRed(this)},M.prototype.mul=function(e,t){if(e.isZero()||t.isZero())return new i(0)._forceRed(this);var n=e.mul(t),r=n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),o=n.isub(r).iushrn(this.shift),a=o;return o.cmp(this.m)>=0?a=o.isub(this.m):o.cmpn(0)<0&&(a=o.iadd(this.m)),a._forceRed(this)},M.prototype.invm=function(e){return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this)};}(e,n);}(kl);var Ml=kl.exports,Cl=We;function xl(e){var t,n=e.modulus.byteLength();do{t=new Ml(Cl(n));}while(t.cmp(e.modulus)>=0||!t.umod(e.prime1)||!t.umod(e.prime2));return t}function Al(e,t){var n=function(e){var t=xl(e);return {blinder:t.toRed(Ml.mont(e.modulus)).redPow(new Ml(e.publicExponent)).fromRed(),unblinder:t.invm(e.modulus)}}(t),r=t.modulus.byteLength(),i=new Ml(e).mul(n.blinder).umod(t.modulus),o=i.toRed(Ml.mont(t.prime1)),a=i.toRed(Ml.mont(t.prime2)),s=t.coefficient,u=t.prime1,l=t.prime2,c=o.redPow(t.exponent1).fromRed(),d=a.redPow(t.exponent2).fromRed(),f=c.isub(d).imul(s).umod(u).imul(l);return d.iadd(f).imul(n.unblinder).umod(t.modulus).toArrayLike(_,"be",r)}Al.getr=xl;var Rl=Al,Tl={},Pl={version:"6.5.4"},Ll={},Il={};!function(e){var t=e;function n(e){return 1===e.length?"0"+e:e}function r(e){for(var t="",r=0;r<e.length;r++)t+=n(e[r].toString(16));return t}t.toArray=function(e,t){if(Array.isArray(e))return e.slice();if(!e)return [];var n=[];if("string"!=typeof e){for(var r=0;r<e.length;r++)n[r]=0|e[r];return n}if("hex"===t){(e=e.replace(/[^a-z0-9]+/gi,"")).length%2!=0&&(e="0"+e);for(r=0;r<e.length;r+=2)n.push(parseInt(e[r]+e[r+1],16));}else for(r=0;r<e.length;r++){var i=e.charCodeAt(r),o=i>>8,a=255&i;o?n.push(o,a):n.push(a);}return n},t.zero2=n,t.toHex=r,t.encode=function(e,t){return "hex"===t?r(e):e};}(Il),function(e){var t=e,n=hl,r=Wa,i=Il;t.assert=r,t.toArray=i.toArray,t.zero2=i.zero2,t.toHex=i.toHex,t.encode=i.encode,t.getNAF=function(e,t,n){var r=new Array(Math.max(e.bitLength(),n)+1);r.fill(0);for(var i=1<<t+1,o=e.clone(),a=0;a<r.length;a++){var s,u=o.andln(i-1);o.isOdd()?(s=u>(i>>1)-1?(i>>1)-u:u,o.isubn(s)):s=0,r[a]=s,o.iushrn(1);}return r},t.getJSF=function(e,t){var n=[[],[]];e=e.clone(),t=t.clone();for(var r,i=0,o=0;e.cmpn(-i)>0||t.cmpn(-o)>0;){var a,s,u=e.andln(3)+i&3,l=t.andln(3)+o&3;3===u&&(u=-1),3===l&&(l=-1),a=0==(1&u)?0:3!==(r=e.andln(7)+i&7)&&5!==r||2!==l?u:-u,n[0].push(a),s=0==(1&l)?0:3!==(r=t.andln(7)+o&7)&&5!==r||2!==u?l:-l,n[1].push(s),2*i===a+1&&(i=1-i),2*o===s+1&&(o=1-o),e.iushrn(1),t.iushrn(1);}return n},t.cachedProperty=function(e,t,n){var r="_"+t;e.prototype[t]=function(){return void 0!==this[r]?this[r]:this[r]=n.call(this)};},t.parseBytes=function(e){return "string"==typeof e?t.toArray(e,"hex"):e},t.intFromLE=function(e){return new n(e,"hex","le")};}(Ll);var Ol={},Nl=hl,Dl=Ll,jl=Dl.getNAF,Bl=Dl.getJSF,zl=Dl.assert;function Ul(e,t){this.type=e,this.p=new Nl(t.p,16),this.red=t.prime?Nl.red(t.prime):Nl.mont(this.p),this.zero=new Nl(0).toRed(this.red),this.one=new Nl(1).toRed(this.red),this.two=new Nl(2).toRed(this.red),this.n=t.n&&new Nl(t.n,16),this.g=t.g&&this.pointFromJSON(t.g,t.gRed),this._wnafT1=new Array(4),this._wnafT2=new Array(4),this._wnafT3=new Array(4),this._wnafT4=new Array(4),this._bitLength=this.n?this.n.bitLength():0;var n=this.n&&this.p.div(this.n);!n||n.cmpn(100)>0?this.redN=null:(this._maxwellTrick=true,this.redN=this.n.toRed(this.red));}var Fl=Ul;function Kl(e,t){this.curve=e,this.type=t,this.precomputed=null;}Ul.prototype.point=function(){throw new Error("Not implemented")},Ul.prototype.validate=function(){throw new Error("Not implemented")},Ul.prototype._fixedNafMul=function(e,t){zl(e.precomputed);var n=e._getDoubles(),r=jl(t,1,this._bitLength),i=(1<<n.step+1)-(n.step%2==0?2:1);i/=3;var o,a,s=[];for(o=0;o<r.length;o+=n.step){a=0;for(var u=o+n.step-1;u>=o;u--)a=(a<<1)+r[u];s.push(a);}for(var l=this.jpoint(null,null,null),c=this.jpoint(null,null,null),d=i;d>0;d--){for(o=0;o<s.length;o++)(a=s[o])===d?c=c.mixedAdd(n.points[o]):a===-d&&(c=c.mixedAdd(n.points[o].neg()));l=l.add(c);}return l.toP()},Ul.prototype._wnafMul=function(e,t){var n=4,r=e._getNAFPoints(n);n=r.wnd;for(var i=r.points,o=jl(t,n,this._bitLength),a=this.jpoint(null,null,null),s=o.length-1;s>=0;s--){for(var u=0;s>=0&&0===o[s];s--)u++;if(s>=0&&u++,a=a.dblp(u),s<0)break;var l=o[s];zl(0!==l),a="affine"===e.type?l>0?a.mixedAdd(i[l-1>>1]):a.mixedAdd(i[-l-1>>1].neg()):l>0?a.add(i[l-1>>1]):a.add(i[-l-1>>1].neg());}return "affine"===e.type?a.toP():a},Ul.prototype._wnafMulAdd=function(e,t,n,r,i){var o,a,s,u=this._wnafT1,l=this._wnafT2,c=this._wnafT3,d=0;for(o=0;o<r;o++){var f=(s=t[o])._getNAFPoints(e);u[o]=f.wnd,l[o]=f.points;}for(o=r-1;o>=1;o-=2){var h=o-1,p=o;if(1===u[h]&&1===u[p]){var m=[t[h],null,null,t[p]];0===t[h].y.cmp(t[p].y)?(m[1]=t[h].add(t[p]),m[2]=t[h].toJ().mixedAdd(t[p].neg())):0===t[h].y.cmp(t[p].y.redNeg())?(m[1]=t[h].toJ().mixedAdd(t[p]),m[2]=t[h].add(t[p].neg())):(m[1]=t[h].toJ().mixedAdd(t[p]),m[2]=t[h].toJ().mixedAdd(t[p].neg()));var g=[-3,-1,-5,-7,0,7,5,1,3],v=Bl(n[h],n[p]);for(d=Math.max(v[0].length,d),c[h]=new Array(d),c[p]=new Array(d),a=0;a<d;a++){var b=0|v[0][a],y=0|v[1][a];c[h][a]=g[3*(b+1)+(y+1)],c[p][a]=0,l[h]=m;}}else c[h]=jl(n[h],u[h],this._bitLength),c[p]=jl(n[p],u[p],this._bitLength),d=Math.max(c[h].length,d),d=Math.max(c[p].length,d);}var w=this.jpoint(null,null,null),_=this._wnafT4;for(o=d;o>=0;o--){for(var S=0;o>=0;){var E=true;for(a=0;a<r;a++)_[a]=0|c[a][o],0!==_[a]&&(E=false);if(!E)break;S++,o--;}if(o>=0&&S++,w=w.dblp(S),o<0)break;for(a=0;a<r;a++){var k=_[a];0!==k&&(k>0?s=l[a][k-1>>1]:k<0&&(s=l[a][-k-1>>1].neg()),w="affine"===s.type?w.mixedAdd(s):w.add(s));}}for(o=0;o<r;o++)l[o]=null;return i?w:w.toP()},Ul.BasePoint=Kl,Kl.prototype.eq=function(){throw new Error("Not implemented")},Kl.prototype.validate=function(){return this.curve.validate(this)},Ul.prototype.decodePoint=function(e,t){e=Dl.toArray(e,t);var n=this.p.byteLength();if((4===e[0]||6===e[0]||7===e[0])&&e.length-1==2*n)return 6===e[0]?zl(e[e.length-1]%2==0):7===e[0]&&zl(e[e.length-1]%2==1),this.point(e.slice(1,1+n),e.slice(1+n,1+2*n));if((2===e[0]||3===e[0])&&e.length-1===n)return this.pointFromX(e.slice(1,1+n),3===e[0]);throw new Error("Unknown point format")},Kl.prototype.encodeCompressed=function(e){return this.encode(e,true)},Kl.prototype._encode=function(e){var t=this.curve.p.byteLength(),n=this.getX().toArray("be",t);return e?[this.getY().isEven()?2:3].concat(n):[4].concat(n,this.getY().toArray("be",t))},Kl.prototype.encode=function(e,t){return Dl.encode(this._encode(t),e)},Kl.prototype.precompute=function(e){if(this.precomputed)return this;var t={doubles:null,naf:null,beta:null};return t.naf=this._getNAFPoints(8),t.doubles=this._getDoubles(4,e),t.beta=this._getBeta(),this.precomputed=t,this},Kl.prototype._hasDoubles=function(e){if(!this.precomputed)return  false;var t=this.precomputed.doubles;return !!t&&t.points.length>=Math.ceil((e.bitLength()+1)/t.step)},Kl.prototype._getDoubles=function(e,t){if(this.precomputed&&this.precomputed.doubles)return this.precomputed.doubles;for(var n=[this],r=this,i=0;i<t;i+=e){for(var o=0;o<e;o++)r=r.dbl();n.push(r);}return {step:e,points:n}},Kl.prototype._getNAFPoints=function(e){if(this.precomputed&&this.precomputed.naf)return this.precomputed.naf;for(var t=[this],n=(1<<e)-1,r=1===n?null:this.dbl(),i=1;i<n;i++)t[i]=t[i-1].add(r);return {wnd:e,points:t}},Kl.prototype._getBeta=function(){return null},Kl.prototype.dblp=function(e){for(var t=this,n=0;n<e;n++)t=t.dbl();return t};var ql=hl,Hl=Ve,Wl=Fl,$l=Ll.assert;function Vl(e){Wl.call(this,"short",e),this.a=new ql(e.a,16).toRed(this.red),this.b=new ql(e.b,16).toRed(this.red),this.tinv=this.two.redInvm(),this.zeroA=0===this.a.fromRed().cmpn(0),this.threeA=0===this.a.fromRed().sub(this.p).cmpn(-3),this.endo=this._getEndomorphism(e),this._endoWnafT1=new Array(4),this._endoWnafT2=new Array(4);}Hl(Vl,Wl);var Yl=Vl;function Gl(e,t,n,r){Wl.BasePoint.call(this,e,"affine"),null===t&&null===n?(this.x=null,this.y=null,this.inf=true):(this.x=new ql(t,16),this.y=new ql(n,16),r&&(this.x.forceRed(this.curve.red),this.y.forceRed(this.curve.red)),this.x.red||(this.x=this.x.toRed(this.curve.red)),this.y.red||(this.y=this.y.toRed(this.curve.red)),this.inf=false);}function Zl(e,t,n,r){Wl.BasePoint.call(this,e,"jacobian"),null===t&&null===n&&null===r?(this.x=this.curve.one,this.y=this.curve.one,this.z=new ql(0)):(this.x=new ql(t,16),this.y=new ql(n,16),this.z=new ql(r,16)),this.x.red||(this.x=this.x.toRed(this.curve.red)),this.y.red||(this.y=this.y.toRed(this.curve.red)),this.z.red||(this.z=this.z.toRed(this.curve.red)),this.zOne=this.z===this.curve.one;}Vl.prototype._getEndomorphism=function(e){if(this.zeroA&&this.g&&this.n&&1===this.p.modn(3)){var t,n;if(e.beta)t=new ql(e.beta,16).toRed(this.red);else {var r=this._getEndoRoots(this.p);t=(t=r[0].cmp(r[1])<0?r[0]:r[1]).toRed(this.red);}if(e.lambda)n=new ql(e.lambda,16);else {var i=this._getEndoRoots(this.n);0===this.g.mul(i[0]).x.cmp(this.g.x.redMul(t))?n=i[0]:(n=i[1],$l(0===this.g.mul(n).x.cmp(this.g.x.redMul(t))));}return {beta:t,lambda:n,basis:e.basis?e.basis.map((function(e){return {a:new ql(e.a,16),b:new ql(e.b,16)}})):this._getEndoBasis(n)}}},Vl.prototype._getEndoRoots=function(e){var t=e===this.p?this.red:ql.mont(e),n=new ql(2).toRed(t).redInvm(),r=n.redNeg(),i=new ql(3).toRed(t).redNeg().redSqrt().redMul(n);return [r.redAdd(i).fromRed(),r.redSub(i).fromRed()]},Vl.prototype._getEndoBasis=function(e){for(var t,n,r,i,o,a,s,u,l,c=this.n.ushrn(Math.floor(this.n.bitLength()/2)),d=e,f=this.n.clone(),h=new ql(1),p=new ql(0),m=new ql(0),g=new ql(1),v=0;0!==d.cmpn(0);){var b=f.div(d);u=f.sub(b.mul(d)),l=m.sub(b.mul(h));var y=g.sub(b.mul(p));if(!r&&u.cmp(c)<0)t=s.neg(),n=h,r=u.neg(),i=l;else if(r&&2==++v)break;s=u,f=d,d=u,m=h,h=l,g=p,p=y;}o=u.neg(),a=l;var w=r.sqr().add(i.sqr());return o.sqr().add(a.sqr()).cmp(w)>=0&&(o=t,a=n),r.negative&&(r=r.neg(),i=i.neg()),o.negative&&(o=o.neg(),a=a.neg()),[{a:r,b:i},{a:o,b:a}]},Vl.prototype._endoSplit=function(e){var t=this.endo.basis,n=t[0],r=t[1],i=r.b.mul(e).divRound(this.n),o=n.b.neg().mul(e).divRound(this.n),a=i.mul(n.a),s=o.mul(r.a),u=i.mul(n.b),l=o.mul(r.b);return {k1:e.sub(a).sub(s),k2:u.add(l).neg()}},Vl.prototype.pointFromX=function(e,t){(e=new ql(e,16)).red||(e=e.toRed(this.red));var n=e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),r=n.redSqrt();if(0!==r.redSqr().redSub(n).cmp(this.zero))throw new Error("invalid point");var i=r.fromRed().isOdd();return (t&&!i||!t&&i)&&(r=r.redNeg()),this.point(e,r)},Vl.prototype.validate=function(e){if(e.inf)return  true;var t=e.x,n=e.y,r=this.a.redMul(t),i=t.redSqr().redMul(t).redIAdd(r).redIAdd(this.b);return 0===n.redSqr().redISub(i).cmpn(0)},Vl.prototype._endoWnafMulAdd=function(e,t,n){for(var r=this._endoWnafT1,i=this._endoWnafT2,o=0;o<e.length;o++){var a=this._endoSplit(t[o]),s=e[o],u=s._getBeta();a.k1.negative&&(a.k1.ineg(),s=s.neg(true)),a.k2.negative&&(a.k2.ineg(),u=u.neg(true)),r[2*o]=s,r[2*o+1]=u,i[2*o]=a.k1,i[2*o+1]=a.k2;}for(var l=this._wnafMulAdd(1,r,i,2*o,n),c=0;c<2*o;c++)r[c]=null,i[c]=null;return l},Hl(Gl,Wl.BasePoint),Vl.prototype.point=function(e,t,n){return new Gl(this,e,t,n)},Vl.prototype.pointFromJSON=function(e,t){return Gl.fromJSON(this,e,t)},Gl.prototype._getBeta=function(){if(this.curve.endo){var e=this.precomputed;if(e&&e.beta)return e.beta;var t=this.curve.point(this.x.redMul(this.curve.endo.beta),this.y);if(e){var n=this.curve,r=function(e){return n.point(e.x.redMul(n.endo.beta),e.y)};e.beta=t,t.precomputed={beta:null,naf:e.naf&&{wnd:e.naf.wnd,points:e.naf.points.map(r)},doubles:e.doubles&&{step:e.doubles.step,points:e.doubles.points.map(r)}};}return t}},Gl.prototype.toJSON=function(){return this.precomputed?[this.x,this.y,this.precomputed&&{doubles:this.precomputed.doubles&&{step:this.precomputed.doubles.step,points:this.precomputed.doubles.points.slice(1)},naf:this.precomputed.naf&&{wnd:this.precomputed.naf.wnd,points:this.precomputed.naf.points.slice(1)}}]:[this.x,this.y]},Gl.fromJSON=function(e,t,n){"string"==typeof t&&(t=JSON.parse(t));var r=e.point(t[0],t[1],n);if(!t[2])return r;function i(t){return e.point(t[0],t[1],n)}var o=t[2];return r.precomputed={beta:null,doubles:o.doubles&&{step:o.doubles.step,points:[r].concat(o.doubles.points.map(i))},naf:o.naf&&{wnd:o.naf.wnd,points:[r].concat(o.naf.points.map(i))}},r},Gl.prototype.inspect=function(){return this.isInfinity()?"<EC Point Infinity>":"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+">"},Gl.prototype.isInfinity=function(){return this.inf},Gl.prototype.add=function(e){if(this.inf)return e;if(e.inf)return this;if(this.eq(e))return this.dbl();if(this.neg().eq(e))return this.curve.point(null,null);if(0===this.x.cmp(e.x))return this.curve.point(null,null);var t=this.y.redSub(e.y);0!==t.cmpn(0)&&(t=t.redMul(this.x.redSub(e.x).redInvm()));var n=t.redSqr().redISub(this.x).redISub(e.x),r=t.redMul(this.x.redSub(n)).redISub(this.y);return this.curve.point(n,r)},Gl.prototype.dbl=function(){if(this.inf)return this;var e=this.y.redAdd(this.y);if(0===e.cmpn(0))return this.curve.point(null,null);var t=this.curve.a,n=this.x.redSqr(),r=e.redInvm(),i=n.redAdd(n).redIAdd(n).redIAdd(t).redMul(r),o=i.redSqr().redISub(this.x.redAdd(this.x)),a=i.redMul(this.x.redSub(o)).redISub(this.y);return this.curve.point(o,a)},Gl.prototype.getX=function(){return this.x.fromRed()},Gl.prototype.getY=function(){return this.y.fromRed()},Gl.prototype.mul=function(e){return e=new ql(e,16),this.isInfinity()?this:this._hasDoubles(e)?this.curve._fixedNafMul(this,e):this.curve.endo?this.curve._endoWnafMulAdd([this],[e]):this.curve._wnafMul(this,e)},Gl.prototype.mulAdd=function(e,t,n){var r=[this,t],i=[e,n];return this.curve.endo?this.curve._endoWnafMulAdd(r,i):this.curve._wnafMulAdd(1,r,i,2)},Gl.prototype.jmulAdd=function(e,t,n){var r=[this,t],i=[e,n];return this.curve.endo?this.curve._endoWnafMulAdd(r,i,true):this.curve._wnafMulAdd(1,r,i,2,true)},Gl.prototype.eq=function(e){return this===e||this.inf===e.inf&&(this.inf||0===this.x.cmp(e.x)&&0===this.y.cmp(e.y))},Gl.prototype.neg=function(e){if(this.inf)return this;var t=this.curve.point(this.x,this.y.redNeg());if(e&&this.precomputed){var n=this.precomputed,r=function(e){return e.neg()};t.precomputed={naf:n.naf&&{wnd:n.naf.wnd,points:n.naf.points.map(r)},doubles:n.doubles&&{step:n.doubles.step,points:n.doubles.points.map(r)}};}return t},Gl.prototype.toJ=function(){return this.inf?this.curve.jpoint(null,null,null):this.curve.jpoint(this.x,this.y,this.curve.one)},Hl(Zl,Wl.BasePoint),Vl.prototype.jpoint=function(e,t,n){return new Zl(this,e,t,n)},Zl.prototype.toP=function(){if(this.isInfinity())return this.curve.point(null,null);var e=this.z.redInvm(),t=e.redSqr(),n=this.x.redMul(t),r=this.y.redMul(t).redMul(e);return this.curve.point(n,r)},Zl.prototype.neg=function(){return this.curve.jpoint(this.x,this.y.redNeg(),this.z)},Zl.prototype.add=function(e){if(this.isInfinity())return e;if(e.isInfinity())return this;var t=e.z.redSqr(),n=this.z.redSqr(),r=this.x.redMul(t),i=e.x.redMul(n),o=this.y.redMul(t.redMul(e.z)),a=e.y.redMul(n.redMul(this.z)),s=r.redSub(i),u=o.redSub(a);if(0===s.cmpn(0))return 0!==u.cmpn(0)?this.curve.jpoint(null,null,null):this.dbl();var l=s.redSqr(),c=l.redMul(s),d=r.redMul(l),f=u.redSqr().redIAdd(c).redISub(d).redISub(d),h=u.redMul(d.redISub(f)).redISub(o.redMul(c)),p=this.z.redMul(e.z).redMul(s);return this.curve.jpoint(f,h,p)},Zl.prototype.mixedAdd=function(e){if(this.isInfinity())return e.toJ();if(e.isInfinity())return this;var t=this.z.redSqr(),n=this.x,r=e.x.redMul(t),i=this.y,o=e.y.redMul(t).redMul(this.z),a=n.redSub(r),s=i.redSub(o);if(0===a.cmpn(0))return 0!==s.cmpn(0)?this.curve.jpoint(null,null,null):this.dbl();var u=a.redSqr(),l=u.redMul(a),c=n.redMul(u),d=s.redSqr().redIAdd(l).redISub(c).redISub(c),f=s.redMul(c.redISub(d)).redISub(i.redMul(l)),h=this.z.redMul(a);return this.curve.jpoint(d,f,h)},Zl.prototype.dblp=function(e){if(0===e)return this;if(this.isInfinity())return this;if(!e)return this.dbl();var t;if(this.curve.zeroA||this.curve.threeA){var n=this;for(t=0;t<e;t++)n=n.dbl();return n}var r=this.curve.a,i=this.curve.tinv,o=this.x,a=this.y,s=this.z,u=s.redSqr().redSqr(),l=a.redAdd(a);for(t=0;t<e;t++){var c=o.redSqr(),d=l.redSqr(),f=d.redSqr(),h=c.redAdd(c).redIAdd(c).redIAdd(r.redMul(u)),p=o.redMul(d),m=h.redSqr().redISub(p.redAdd(p)),g=p.redISub(m),v=h.redMul(g);v=v.redIAdd(v).redISub(f);var b=l.redMul(s);t+1<e&&(u=u.redMul(f)),o=m,s=b,l=v;}return this.curve.jpoint(o,l.redMul(i),s)},Zl.prototype.dbl=function(){return this.isInfinity()?this:this.curve.zeroA?this._zeroDbl():this.curve.threeA?this._threeDbl():this._dbl()},Zl.prototype._zeroDbl=function(){var e,t,n;if(this.zOne){var r=this.x.redSqr(),i=this.y.redSqr(),o=i.redSqr(),a=this.x.redAdd(i).redSqr().redISub(r).redISub(o);a=a.redIAdd(a);var s=r.redAdd(r).redIAdd(r),u=s.redSqr().redISub(a).redISub(a),l=o.redIAdd(o);l=(l=l.redIAdd(l)).redIAdd(l),e=u,t=s.redMul(a.redISub(u)).redISub(l),n=this.y.redAdd(this.y);}else {var c=this.x.redSqr(),d=this.y.redSqr(),f=d.redSqr(),h=this.x.redAdd(d).redSqr().redISub(c).redISub(f);h=h.redIAdd(h);var p=c.redAdd(c).redIAdd(c),m=p.redSqr(),g=f.redIAdd(f);g=(g=g.redIAdd(g)).redIAdd(g),e=m.redISub(h).redISub(h),t=p.redMul(h.redISub(e)).redISub(g),n=(n=this.y.redMul(this.z)).redIAdd(n);}return this.curve.jpoint(e,t,n)},Zl.prototype._threeDbl=function(){var e,t,n;if(this.zOne){var r=this.x.redSqr(),i=this.y.redSqr(),o=i.redSqr(),a=this.x.redAdd(i).redSqr().redISub(r).redISub(o);a=a.redIAdd(a);var s=r.redAdd(r).redIAdd(r).redIAdd(this.curve.a),u=s.redSqr().redISub(a).redISub(a);e=u;var l=o.redIAdd(o);l=(l=l.redIAdd(l)).redIAdd(l),t=s.redMul(a.redISub(u)).redISub(l),n=this.y.redAdd(this.y);}else {var c=this.z.redSqr(),d=this.y.redSqr(),f=this.x.redMul(d),h=this.x.redSub(c).redMul(this.x.redAdd(c));h=h.redAdd(h).redIAdd(h);var p=f.redIAdd(f),m=(p=p.redIAdd(p)).redAdd(p);e=h.redSqr().redISub(m),n=this.y.redAdd(this.z).redSqr().redISub(d).redISub(c);var g=d.redSqr();g=(g=(g=g.redIAdd(g)).redIAdd(g)).redIAdd(g),t=h.redMul(p.redISub(e)).redISub(g);}return this.curve.jpoint(e,t,n)},Zl.prototype._dbl=function(){var e=this.curve.a,t=this.x,n=this.y,r=this.z,i=r.redSqr().redSqr(),o=t.redSqr(),a=n.redSqr(),s=o.redAdd(o).redIAdd(o).redIAdd(e.redMul(i)),u=t.redAdd(t),l=(u=u.redIAdd(u)).redMul(a),c=s.redSqr().redISub(l.redAdd(l)),d=l.redISub(c),f=a.redSqr();f=(f=(f=f.redIAdd(f)).redIAdd(f)).redIAdd(f);var h=s.redMul(d).redISub(f),p=n.redAdd(n).redMul(r);return this.curve.jpoint(c,h,p)},Zl.prototype.trpl=function(){if(!this.curve.zeroA)return this.dbl().add(this);var e=this.x.redSqr(),t=this.y.redSqr(),n=this.z.redSqr(),r=t.redSqr(),i=e.redAdd(e).redIAdd(e),o=i.redSqr(),a=this.x.redAdd(t).redSqr().redISub(e).redISub(r),s=(a=(a=(a=a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(),u=r.redIAdd(r);u=(u=(u=u.redIAdd(u)).redIAdd(u)).redIAdd(u);var l=i.redIAdd(a).redSqr().redISub(o).redISub(s).redISub(u),c=t.redMul(l);c=(c=c.redIAdd(c)).redIAdd(c);var d=this.x.redMul(s).redISub(c);d=(d=d.redIAdd(d)).redIAdd(d);var f=this.y.redMul(l.redMul(u.redISub(l)).redISub(a.redMul(s)));f=(f=(f=f.redIAdd(f)).redIAdd(f)).redIAdd(f);var h=this.z.redAdd(a).redSqr().redISub(n).redISub(s);return this.curve.jpoint(d,f,h)},Zl.prototype.mul=function(e,t){return e=new ql(e,t),this.curve._wnafMul(this,e)},Zl.prototype.eq=function(e){if("affine"===e.type)return this.eq(e.toJ());if(this===e)return  true;var t=this.z.redSqr(),n=e.z.redSqr();if(0!==this.x.redMul(n).redISub(e.x.redMul(t)).cmpn(0))return  false;var r=t.redMul(this.z),i=n.redMul(e.z);return 0===this.y.redMul(i).redISub(e.y.redMul(r)).cmpn(0)},Zl.prototype.eqXToP=function(e){var t=this.z.redSqr(),n=e.toRed(this.curve.red).redMul(t);if(0===this.x.cmp(n))return  true;for(var r=e.clone(),i=this.curve.redN.redMul(t);;){if(r.iadd(this.curve.n),r.cmp(this.curve.p)>=0)return  false;if(n.redIAdd(i),0===this.x.cmp(n))return  true}},Zl.prototype.inspect=function(){return this.isInfinity()?"<EC JPoint Infinity>":"<EC JPoint x: "+this.x.toString(16,2)+" y: "+this.y.toString(16,2)+" z: "+this.z.toString(16,2)+">"},Zl.prototype.isInfinity=function(){return 0===this.z.cmpn(0)};var Ql=hl,Jl=Ve,Xl=Fl,ec=Ll;function tc(e){Xl.call(this,"mont",e),this.a=new Ql(e.a,16).toRed(this.red),this.b=new Ql(e.b,16).toRed(this.red),this.i4=new Ql(4).toRed(this.red).redInvm(),this.two=new Ql(2).toRed(this.red),this.a24=this.i4.redMul(this.a.redAdd(this.two));}Jl(tc,Xl);var nc=tc;function rc(e,t,n){Xl.BasePoint.call(this,e,"projective"),null===t&&null===n?(this.x=this.curve.one,this.z=this.curve.zero):(this.x=new Ql(t,16),this.z=new Ql(n,16),this.x.red||(this.x=this.x.toRed(this.curve.red)),this.z.red||(this.z=this.z.toRed(this.curve.red)));}tc.prototype.validate=function(e){var t=e.normalize().x,n=t.redSqr(),r=n.redMul(t).redAdd(n.redMul(this.a)).redAdd(t);return 0===r.redSqrt().redSqr().cmp(r)},Jl(rc,Xl.BasePoint),tc.prototype.decodePoint=function(e,t){return this.point(ec.toArray(e,t),1)},tc.prototype.point=function(e,t){return new rc(this,e,t)},tc.prototype.pointFromJSON=function(e){return rc.fromJSON(this,e)},rc.prototype.precompute=function(){},rc.prototype._encode=function(){return this.getX().toArray("be",this.curve.p.byteLength())},rc.fromJSON=function(e,t){return new rc(e,t[0],t[1]||e.one)},rc.prototype.inspect=function(){return this.isInfinity()?"<EC Point Infinity>":"<EC Point x: "+this.x.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"},rc.prototype.isInfinity=function(){return 0===this.z.cmpn(0)},rc.prototype.dbl=function(){var e=this.x.redAdd(this.z).redSqr(),t=this.x.redSub(this.z).redSqr(),n=e.redSub(t),r=e.redMul(t),i=n.redMul(t.redAdd(this.curve.a24.redMul(n)));return this.curve.point(r,i)},rc.prototype.add=function(){throw new Error("Not supported on Montgomery curve")},rc.prototype.diffAdd=function(e,t){var n=this.x.redAdd(this.z),r=this.x.redSub(this.z),i=e.x.redAdd(e.z),o=e.x.redSub(e.z).redMul(n),a=i.redMul(r),s=t.z.redMul(o.redAdd(a).redSqr()),u=t.x.redMul(o.redISub(a).redSqr());return this.curve.point(s,u)},rc.prototype.mul=function(e){for(var t=e.clone(),n=this,r=this.curve.point(null,null),i=[];0!==t.cmpn(0);t.iushrn(1))i.push(t.andln(1));for(var o=i.length-1;o>=0;o--)0===i[o]?(n=n.diffAdd(r,this),r=r.dbl()):(r=n.diffAdd(r,this),n=n.dbl());return r},rc.prototype.mulAdd=function(){throw new Error("Not supported on Montgomery curve")},rc.prototype.jumlAdd=function(){throw new Error("Not supported on Montgomery curve")},rc.prototype.eq=function(e){return 0===this.getX().cmp(e.getX())},rc.prototype.normalize=function(){return this.x=this.x.redMul(this.z.redInvm()),this.z=this.curve.one,this},rc.prototype.getX=function(){return this.normalize(),this.x.fromRed()};var ic=hl,oc=Ve,ac=Fl,sc=Ll.assert;function uc(e){this.twisted=1!=(0|e.a),this.mOneA=this.twisted&&-1==(0|e.a),this.extended=this.mOneA,ac.call(this,"edwards",e),this.a=new ic(e.a,16).umod(this.red.m),this.a=this.a.toRed(this.red),this.c=new ic(e.c,16).toRed(this.red),this.c2=this.c.redSqr(),this.d=new ic(e.d,16).toRed(this.red),this.dd=this.d.redAdd(this.d),sc(!this.twisted||0===this.c.fromRed().cmpn(1)),this.oneC=1==(0|e.c);}oc(uc,ac);var lc=uc;function cc(e,t,n,r,i){ac.BasePoint.call(this,e,"projective"),null===t&&null===n&&null===r?(this.x=this.curve.zero,this.y=this.curve.one,this.z=this.curve.one,this.t=this.curve.zero,this.zOne=true):(this.x=new ic(t,16),this.y=new ic(n,16),this.z=r?new ic(r,16):this.curve.one,this.t=i&&new ic(i,16),this.x.red||(this.x=this.x.toRed(this.curve.red)),this.y.red||(this.y=this.y.toRed(this.curve.red)),this.z.red||(this.z=this.z.toRed(this.curve.red)),this.t&&!this.t.red&&(this.t=this.t.toRed(this.curve.red)),this.zOne=this.z===this.curve.one,this.curve.extended&&!this.t&&(this.t=this.x.redMul(this.y),this.zOne||(this.t=this.t.redMul(this.z.redInvm()))));}uc.prototype._mulA=function(e){return this.mOneA?e.redNeg():this.a.redMul(e)},uc.prototype._mulC=function(e){return this.oneC?e:this.c.redMul(e)},uc.prototype.jpoint=function(e,t,n,r){return this.point(e,t,n,r)},uc.prototype.pointFromX=function(e,t){(e=new ic(e,16)).red||(e=e.toRed(this.red));var n=e.redSqr(),r=this.c2.redSub(this.a.redMul(n)),i=this.one.redSub(this.c2.redMul(this.d).redMul(n)),o=r.redMul(i.redInvm()),a=o.redSqrt();if(0!==a.redSqr().redSub(o).cmp(this.zero))throw new Error("invalid point");var s=a.fromRed().isOdd();return (t&&!s||!t&&s)&&(a=a.redNeg()),this.point(e,a)},uc.prototype.pointFromY=function(e,t){(e=new ic(e,16)).red||(e=e.toRed(this.red));var n=e.redSqr(),r=n.redSub(this.c2),i=n.redMul(this.d).redMul(this.c2).redSub(this.a),o=r.redMul(i.redInvm());if(0===o.cmp(this.zero)){if(t)throw new Error("invalid point");return this.point(this.zero,e)}var a=o.redSqrt();if(0!==a.redSqr().redSub(o).cmp(this.zero))throw new Error("invalid point");return a.fromRed().isOdd()!==t&&(a=a.redNeg()),this.point(a,e)},uc.prototype.validate=function(e){if(e.isInfinity())return  true;e.normalize();var t=e.x.redSqr(),n=e.y.redSqr(),r=t.redMul(this.a).redAdd(n),i=this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(n)));return 0===r.cmp(i)},oc(cc,ac.BasePoint),uc.prototype.pointFromJSON=function(e){return cc.fromJSON(this,e)},uc.prototype.point=function(e,t,n,r){return new cc(this,e,t,n,r)},cc.fromJSON=function(e,t){return new cc(e,t[0],t[1],t[2])},cc.prototype.inspect=function(){return this.isInfinity()?"<EC Point Infinity>":"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"},cc.prototype.isInfinity=function(){return 0===this.x.cmpn(0)&&(0===this.y.cmp(this.z)||this.zOne&&0===this.y.cmp(this.curve.c))},cc.prototype._extDbl=function(){var e=this.x.redSqr(),t=this.y.redSqr(),n=this.z.redSqr();n=n.redIAdd(n);var r=this.curve._mulA(e),i=this.x.redAdd(this.y).redSqr().redISub(e).redISub(t),o=r.redAdd(t),a=o.redSub(n),s=r.redSub(t),u=i.redMul(a),l=o.redMul(s),c=i.redMul(s),d=a.redMul(o);return this.curve.point(u,l,d,c)},cc.prototype._projDbl=function(){var e,t,n,r,i,o,a=this.x.redAdd(this.y).redSqr(),s=this.x.redSqr(),u=this.y.redSqr();if(this.curve.twisted){var l=(r=this.curve._mulA(s)).redAdd(u);this.zOne?(e=a.redSub(s).redSub(u).redMul(l.redSub(this.curve.two)),t=l.redMul(r.redSub(u)),n=l.redSqr().redSub(l).redSub(l)):(i=this.z.redSqr(),o=l.redSub(i).redISub(i),e=a.redSub(s).redISub(u).redMul(o),t=l.redMul(r.redSub(u)),n=l.redMul(o));}else r=s.redAdd(u),i=this.curve._mulC(this.z).redSqr(),o=r.redSub(i).redSub(i),e=this.curve._mulC(a.redISub(r)).redMul(o),t=this.curve._mulC(r).redMul(s.redISub(u)),n=r.redMul(o);return this.curve.point(e,t,n)},cc.prototype.dbl=function(){return this.isInfinity()?this:this.curve.extended?this._extDbl():this._projDbl()},cc.prototype._extAdd=function(e){var t=this.y.redSub(this.x).redMul(e.y.redSub(e.x)),n=this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)),r=this.t.redMul(this.curve.dd).redMul(e.t),i=this.z.redMul(e.z.redAdd(e.z)),o=n.redSub(t),a=i.redSub(r),s=i.redAdd(r),u=n.redAdd(t),l=o.redMul(a),c=s.redMul(u),d=o.redMul(u),f=a.redMul(s);return this.curve.point(l,c,f,d)},cc.prototype._projAdd=function(e){var t,n,r=this.z.redMul(e.z),i=r.redSqr(),o=this.x.redMul(e.x),a=this.y.redMul(e.y),s=this.curve.d.redMul(o).redMul(a),u=i.redSub(s),l=i.redAdd(s),c=this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(o).redISub(a),d=r.redMul(u).redMul(c);return this.curve.twisted?(t=r.redMul(l).redMul(a.redSub(this.curve._mulA(o))),n=u.redMul(l)):(t=r.redMul(l).redMul(a.redSub(o)),n=this.curve._mulC(u).redMul(l)),this.curve.point(d,t,n)},cc.prototype.add=function(e){return this.isInfinity()?e:e.isInfinity()?this:this.curve.extended?this._extAdd(e):this._projAdd(e)},cc.prototype.mul=function(e){return this._hasDoubles(e)?this.curve._fixedNafMul(this,e):this.curve._wnafMul(this,e)},cc.prototype.mulAdd=function(e,t,n){return this.curve._wnafMulAdd(1,[this,t],[e,n],2,false)},cc.prototype.jmulAdd=function(e,t,n){return this.curve._wnafMulAdd(1,[this,t],[e,n],2,true)},cc.prototype.normalize=function(){if(this.zOne)return this;var e=this.z.redInvm();return this.x=this.x.redMul(e),this.y=this.y.redMul(e),this.t&&(this.t=this.t.redMul(e)),this.z=this.curve.one,this.zOne=true,this},cc.prototype.neg=function(){return this.curve.point(this.x.redNeg(),this.y,this.z,this.t&&this.t.redNeg())},cc.prototype.getX=function(){return this.normalize(),this.x.fromRed()},cc.prototype.getY=function(){return this.normalize(),this.y.fromRed()},cc.prototype.eq=function(e){return this===e||0===this.getX().cmp(e.getX())&&0===this.getY().cmp(e.getY())},cc.prototype.eqXToP=function(e){var t=e.toRed(this.curve.red).redMul(this.z);if(0===this.x.cmp(t))return  true;for(var n=e.clone(),r=this.curve.redN.redMul(this.z);;){if(n.iadd(this.curve.n),n.cmp(this.curve.p)>=0)return  false;if(t.redIAdd(r),0===this.x.cmp(t))return  true}},cc.prototype.toP=cc.prototype.normalize,cc.prototype.mixedAdd=cc.prototype.add,function(e){var t=e;t.base=Fl,t.short=Yl,t.mont=nc,t.edwards=lc;}(Ol);var dc={},fc={},hc={},pc=Wa,mc=Ve;function gc(e,t){return 55296==(64512&e.charCodeAt(t))&&(!(t<0||t+1>=e.length)&&56320==(64512&e.charCodeAt(t+1)))}function vc(e){return (e>>>24|e>>>8&65280|e<<8&16711680|(255&e)<<24)>>>0}function bc(e){return 1===e.length?"0"+e:e}function yc(e){return 7===e.length?"0"+e:6===e.length?"00"+e:5===e.length?"000"+e:4===e.length?"0000"+e:3===e.length?"00000"+e:2===e.length?"000000"+e:1===e.length?"0000000"+e:e}hc.inherits=mc,hc.toArray=function(e,t){if(Array.isArray(e))return e.slice();if(!e)return [];var n=[];if("string"==typeof e)if(t){if("hex"===t)for((e=e.replace(/[^a-z0-9]+/gi,"")).length%2!=0&&(e="0"+e),i=0;i<e.length;i+=2)n.push(parseInt(e[i]+e[i+1],16));}else for(var r=0,i=0;i<e.length;i++){var o=e.charCodeAt(i);o<128?n[r++]=o:o<2048?(n[r++]=o>>6|192,n[r++]=63&o|128):gc(e,i)?(o=65536+((1023&o)<<10)+(1023&e.charCodeAt(++i)),n[r++]=o>>18|240,n[r++]=o>>12&63|128,n[r++]=o>>6&63|128,n[r++]=63&o|128):(n[r++]=o>>12|224,n[r++]=o>>6&63|128,n[r++]=63&o|128);}else for(i=0;i<e.length;i++)n[i]=0|e[i];return n},hc.toHex=function(e){for(var t="",n=0;n<e.length;n++)t+=bc(e[n].toString(16));return t},hc.htonl=vc,hc.toHex32=function(e,t){for(var n="",r=0;r<e.length;r++){var i=e[r];"little"===t&&(i=vc(i)),n+=yc(i.toString(16));}return n},hc.zero2=bc,hc.zero8=yc,hc.join32=function(e,t,n,r){var i=n-t;pc(i%4==0);for(var o=new Array(i/4),a=0,s=t;a<o.length;a++,s+=4){var u;u="big"===r?e[s]<<24|e[s+1]<<16|e[s+2]<<8|e[s+3]:e[s+3]<<24|e[s+2]<<16|e[s+1]<<8|e[s],o[a]=u>>>0;}return o},hc.split32=function(e,t){for(var n=new Array(4*e.length),r=0,i=0;r<e.length;r++,i+=4){var o=e[r];"big"===t?(n[i]=o>>>24,n[i+1]=o>>>16&255,n[i+2]=o>>>8&255,n[i+3]=255&o):(n[i+3]=o>>>24,n[i+2]=o>>>16&255,n[i+1]=o>>>8&255,n[i]=255&o);}return n},hc.rotr32=function(e,t){return e>>>t|e<<32-t},hc.rotl32=function(e,t){return e<<t|e>>>32-t},hc.sum32=function(e,t){return e+t>>>0},hc.sum32_3=function(e,t,n){return e+t+n>>>0},hc.sum32_4=function(e,t,n,r){return e+t+n+r>>>0},hc.sum32_5=function(e,t,n,r,i){return e+t+n+r+i>>>0},hc.sum64=function(e,t,n,r){var i=e[t],o=r+e[t+1]>>>0,a=(o<r?1:0)+n+i;e[t]=a>>>0,e[t+1]=o;},hc.sum64_hi=function(e,t,n,r){return (t+r>>>0<t?1:0)+e+n>>>0},hc.sum64_lo=function(e,t,n,r){return t+r>>>0},hc.sum64_4_hi=function(e,t,n,r,i,o,a,s){var u=0,l=t;return u+=(l=l+r>>>0)<t?1:0,u+=(l=l+o>>>0)<o?1:0,e+n+i+a+(u+=(l=l+s>>>0)<s?1:0)>>>0},hc.sum64_4_lo=function(e,t,n,r,i,o,a,s){return t+r+o+s>>>0},hc.sum64_5_hi=function(e,t,n,r,i,o,a,s,u,l){var c=0,d=t;return c+=(d=d+r>>>0)<t?1:0,c+=(d=d+o>>>0)<o?1:0,c+=(d=d+s>>>0)<s?1:0,e+n+i+a+u+(c+=(d=d+l>>>0)<l?1:0)>>>0},hc.sum64_5_lo=function(e,t,n,r,i,o,a,s,u,l){return t+r+o+s+l>>>0},hc.rotr64_hi=function(e,t,n){return (t<<32-n|e>>>n)>>>0},hc.rotr64_lo=function(e,t,n){return (e<<32-n|t>>>n)>>>0},hc.shr64_hi=function(e,t,n){return e>>>n},hc.shr64_lo=function(e,t,n){return (e<<32-n|t>>>n)>>>0};var wc={},_c=hc,Sc=Wa;function Ec(){this.pending=null,this.pendingTotal=0,this.blockSize=this.constructor.blockSize,this.outSize=this.constructor.outSize,this.hmacStrength=this.constructor.hmacStrength,this.padLength=this.constructor.padLength/8,this.endian="big",this._delta8=this.blockSize/8,this._delta32=this.blockSize/32;}wc.BlockHash=Ec,Ec.prototype.update=function(e,t){if(e=_c.toArray(e,t),this.pending?this.pending=this.pending.concat(e):this.pending=e,this.pendingTotal+=e.length,this.pending.length>=this._delta8){var n=(e=this.pending).length%this._delta8;this.pending=e.slice(e.length-n,e.length),0===this.pending.length&&(this.pending=null),e=_c.join32(e,0,e.length-n,this.endian);for(var r=0;r<e.length;r+=this._delta32)this._update(e,r,r+this._delta32);}return this},Ec.prototype.digest=function(e){return this.update(this._pad()),Sc(null===this.pending),this._digest(e)},Ec.prototype._pad=function(){var e=this.pendingTotal,t=this._delta8,n=t-(e+this.padLength)%t,r=new Array(n+this.padLength);r[0]=128;for(var i=1;i<n;i++)r[i]=0;if(e<<=3,"big"===this.endian){for(var o=8;o<this.padLength;o++)r[i++]=0;r[i++]=0,r[i++]=0,r[i++]=0,r[i++]=0,r[i++]=e>>>24&255,r[i++]=e>>>16&255,r[i++]=e>>>8&255,r[i++]=255&e;}else for(r[i++]=255&e,r[i++]=e>>>8&255,r[i++]=e>>>16&255,r[i++]=e>>>24&255,r[i++]=0,r[i++]=0,r[i++]=0,r[i++]=0,o=8;o<this.padLength;o++)r[i++]=0;return r};var kc={},Mc={},Cc=hc.rotr32;function xc(e,t,n){return e&t^~e&n}function Ac(e,t,n){return e&t^e&n^t&n}function Rc(e,t,n){return e^t^n}Mc.ft_1=function(e,t,n,r){return 0===e?xc(t,n,r):1===e||3===e?Rc(t,n,r):2===e?Ac(t,n,r):void 0},Mc.ch32=xc,Mc.maj32=Ac,Mc.p32=Rc,Mc.s0_256=function(e){return Cc(e,2)^Cc(e,13)^Cc(e,22)},Mc.s1_256=function(e){return Cc(e,6)^Cc(e,11)^Cc(e,25)},Mc.g0_256=function(e){return Cc(e,7)^Cc(e,18)^e>>>3},Mc.g1_256=function(e){return Cc(e,17)^Cc(e,19)^e>>>10};var Tc=hc,Pc=wc,Lc=Mc,Ic=Tc.rotl32,Oc=Tc.sum32,Nc=Tc.sum32_5,Dc=Lc.ft_1,jc=Pc.BlockHash,Bc=[1518500249,1859775393,2400959708,3395469782];function zc(){if(!(this instanceof zc))return new zc;jc.call(this),this.h=[1732584193,4023233417,2562383102,271733878,3285377520],this.W=new Array(80);}Tc.inherits(zc,jc);var Uc=zc;zc.blockSize=512,zc.outSize=160,zc.hmacStrength=80,zc.padLength=64,zc.prototype._update=function(e,t){for(var n=this.W,r=0;r<16;r++)n[r]=e[t+r];for(;r<n.length;r++)n[r]=Ic(n[r-3]^n[r-8]^n[r-14]^n[r-16],1);var i=this.h[0],o=this.h[1],a=this.h[2],s=this.h[3],u=this.h[4];for(r=0;r<n.length;r++){var l=~~(r/20),c=Nc(Ic(i,5),Dc(l,o,a,s),u,n[r],Bc[l]);u=s,s=a,a=Ic(o,30),o=i,i=c;}this.h[0]=Oc(this.h[0],i),this.h[1]=Oc(this.h[1],o),this.h[2]=Oc(this.h[2],a),this.h[3]=Oc(this.h[3],s),this.h[4]=Oc(this.h[4],u);},zc.prototype._digest=function(e){return "hex"===e?Tc.toHex32(this.h,"big"):Tc.split32(this.h,"big")};var Fc=hc,Kc=wc,qc=Mc,Hc=Wa,Wc=Fc.sum32,$c=Fc.sum32_4,Vc=Fc.sum32_5,Yc=qc.ch32,Gc=qc.maj32,Zc=qc.s0_256,Qc=qc.s1_256,Jc=qc.g0_256,Xc=qc.g1_256,ed=Kc.BlockHash,td=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function nd(){if(!(this instanceof nd))return new nd;ed.call(this),this.h=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225],this.k=td,this.W=new Array(64);}Fc.inherits(nd,ed);var rd=nd;nd.blockSize=512,nd.outSize=256,nd.hmacStrength=192,nd.padLength=64,nd.prototype._update=function(e,t){for(var n=this.W,r=0;r<16;r++)n[r]=e[t+r];for(;r<n.length;r++)n[r]=$c(Xc(n[r-2]),n[r-7],Jc(n[r-15]),n[r-16]);var i=this.h[0],o=this.h[1],a=this.h[2],s=this.h[3],u=this.h[4],l=this.h[5],c=this.h[6],d=this.h[7];for(Hc(this.k.length===n.length),r=0;r<n.length;r++){var f=Vc(d,Qc(u),Yc(u,l,c),this.k[r],n[r]),h=Wc(Zc(i),Gc(i,o,a));d=c,c=l,l=u,u=Wc(s,f),s=a,a=o,o=i,i=Wc(f,h);}this.h[0]=Wc(this.h[0],i),this.h[1]=Wc(this.h[1],o),this.h[2]=Wc(this.h[2],a),this.h[3]=Wc(this.h[3],s),this.h[4]=Wc(this.h[4],u),this.h[5]=Wc(this.h[5],l),this.h[6]=Wc(this.h[6],c),this.h[7]=Wc(this.h[7],d);},nd.prototype._digest=function(e){return "hex"===e?Fc.toHex32(this.h,"big"):Fc.split32(this.h,"big")};var id=hc,od=rd;function ad(){if(!(this instanceof ad))return new ad;od.call(this),this.h=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428];}id.inherits(ad,od);var sd=ad;ad.blockSize=512,ad.outSize=224,ad.hmacStrength=192,ad.padLength=64,ad.prototype._digest=function(e){return "hex"===e?id.toHex32(this.h.slice(0,7),"big"):id.split32(this.h.slice(0,7),"big")};var ud=hc,ld=wc,cd=Wa,dd=ud.rotr64_hi,fd=ud.rotr64_lo,hd=ud.shr64_hi,pd=ud.shr64_lo,md=ud.sum64,gd=ud.sum64_hi,vd=ud.sum64_lo,bd=ud.sum64_4_hi,yd=ud.sum64_4_lo,wd=ud.sum64_5_hi,_d=ud.sum64_5_lo,Sd=ld.BlockHash,Ed=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];function kd(){if(!(this instanceof kd))return new kd;Sd.call(this),this.h=[1779033703,4089235720,3144134277,2227873595,1013904242,4271175723,2773480762,1595750129,1359893119,2917565137,2600822924,725511199,528734635,4215389547,1541459225,327033209],this.k=Ed,this.W=new Array(160);}ud.inherits(kd,Sd);var Md=kd;function Cd(e,t,n,r,i){var o=e&n^~e&i;return o<0&&(o+=4294967296),o}function xd(e,t,n,r,i,o){var a=t&r^~t&o;return a<0&&(a+=4294967296),a}function Ad(e,t,n,r,i){var o=e&n^e&i^n&i;return o<0&&(o+=4294967296),o}function Rd(e,t,n,r,i,o){var a=t&r^t&o^r&o;return a<0&&(a+=4294967296),a}function Td(e,t){var n=dd(e,t,28)^dd(t,e,2)^dd(t,e,7);return n<0&&(n+=4294967296),n}function Pd(e,t){var n=fd(e,t,28)^fd(t,e,2)^fd(t,e,7);return n<0&&(n+=4294967296),n}function Ld(e,t){var n=dd(e,t,14)^dd(e,t,18)^dd(t,e,9);return n<0&&(n+=4294967296),n}function Id(e,t){var n=fd(e,t,14)^fd(e,t,18)^fd(t,e,9);return n<0&&(n+=4294967296),n}function Od(e,t){var n=dd(e,t,1)^dd(e,t,8)^hd(e,t,7);return n<0&&(n+=4294967296),n}function Nd(e,t){var n=fd(e,t,1)^fd(e,t,8)^pd(e,t,7);return n<0&&(n+=4294967296),n}function Dd(e,t){var n=dd(e,t,19)^dd(t,e,29)^hd(e,t,6);return n<0&&(n+=4294967296),n}function jd(e,t){var n=fd(e,t,19)^fd(t,e,29)^pd(e,t,6);return n<0&&(n+=4294967296),n}kd.blockSize=1024,kd.outSize=512,kd.hmacStrength=192,kd.padLength=128,kd.prototype._prepareBlock=function(e,t){for(var n=this.W,r=0;r<32;r++)n[r]=e[t+r];for(;r<n.length;r+=2){var i=Dd(n[r-4],n[r-3]),o=jd(n[r-4],n[r-3]),a=n[r-14],s=n[r-13],u=Od(n[r-30],n[r-29]),l=Nd(n[r-30],n[r-29]),c=n[r-32],d=n[r-31];n[r]=bd(i,o,a,s,u,l,c,d),n[r+1]=yd(i,o,a,s,u,l,c,d);}},kd.prototype._update=function(e,t){this._prepareBlock(e,t);var n=this.W,r=this.h[0],i=this.h[1],o=this.h[2],a=this.h[3],s=this.h[4],u=this.h[5],l=this.h[6],c=this.h[7],d=this.h[8],f=this.h[9],h=this.h[10],p=this.h[11],m=this.h[12],g=this.h[13],v=this.h[14],b=this.h[15];cd(this.k.length===n.length);for(var y=0;y<n.length;y+=2){var w=v,_=b,S=Ld(d,f),E=Id(d,f),k=Cd(d,f,h,p,m),M=xd(d,f,h,p,m,g),C=this.k[y],x=this.k[y+1],A=n[y],R=n[y+1],T=wd(w,_,S,E,k,M,C,x,A,R),P=_d(w,_,S,E,k,M,C,x,A,R);w=Td(r,i),_=Pd(r,i),S=Ad(r,i,o,a,s),E=Rd(r,i,o,a,s,u);var L=gd(w,_,S,E),I=vd(w,_,S,E);v=m,b=g,m=h,g=p,h=d,p=f,d=gd(l,c,T,P),f=vd(c,c,T,P),l=s,c=u,s=o,u=a,o=r,a=i,r=gd(T,P,L,I),i=vd(T,P,L,I);}md(this.h,0,r,i),md(this.h,2,o,a),md(this.h,4,s,u),md(this.h,6,l,c),md(this.h,8,d,f),md(this.h,10,h,p),md(this.h,12,m,g),md(this.h,14,v,b);},kd.prototype._digest=function(e){return "hex"===e?ud.toHex32(this.h,"big"):ud.split32(this.h,"big")};var Bd=hc,zd=Md;function Ud(){if(!(this instanceof Ud))return new Ud;zd.call(this),this.h=[3418070365,3238371032,1654270250,914150663,2438529370,812702999,355462360,4144912697,1731405415,4290775857,2394180231,1750603025,3675008525,1694076839,1203062813,3204075428];}Bd.inherits(Ud,zd);var Fd=Ud;Ud.blockSize=1024,Ud.outSize=384,Ud.hmacStrength=192,Ud.padLength=128,Ud.prototype._digest=function(e){return "hex"===e?Bd.toHex32(this.h.slice(0,12),"big"):Bd.split32(this.h.slice(0,12),"big")},kc.sha1=Uc,kc.sha224=sd,kc.sha256=rd,kc.sha384=Fd,kc.sha512=Md;var Kd={},qd=hc,Hd=wc,Wd=qd.rotl32,$d=qd.sum32,Vd=qd.sum32_3,Yd=qd.sum32_4,Gd=Hd.BlockHash;function Zd(){if(!(this instanceof Zd))return new Zd;Gd.call(this),this.h=[1732584193,4023233417,2562383102,271733878,3285377520],this.endian="little";}function Qd(e,t,n,r){return e<=15?t^n^r:e<=31?t&n|~t&r:e<=47?(t|~n)^r:e<=63?t&r|n&~r:t^(n|~r)}function Jd(e){return e<=15?0:e<=31?1518500249:e<=47?1859775393:e<=63?2400959708:2840853838}function Xd(e){return e<=15?1352829926:e<=31?1548603684:e<=47?1836072691:e<=63?2053994217:0}qd.inherits(Zd,Gd),Kd.ripemd160=Zd,Zd.blockSize=512,Zd.outSize=160,Zd.hmacStrength=192,Zd.padLength=64,Zd.prototype._update=function(e,t){for(var n=this.h[0],r=this.h[1],i=this.h[2],o=this.h[3],a=this.h[4],s=n,u=r,l=i,c=o,d=a,f=0;f<80;f++){var h=$d(Wd(Yd(n,Qd(f,r,i,o),e[ef[f]+t],Jd(f)),nf[f]),a);n=a,a=o,o=Wd(i,10),i=r,r=h,h=$d(Wd(Yd(s,Qd(79-f,u,l,c),e[tf[f]+t],Xd(f)),rf[f]),d),s=d,d=c,c=Wd(l,10),l=u,u=h;}h=Vd(this.h[1],i,c),this.h[1]=Vd(this.h[2],o,d),this.h[2]=Vd(this.h[3],a,s),this.h[3]=Vd(this.h[4],n,u),this.h[4]=Vd(this.h[0],r,l),this.h[0]=h;},Zd.prototype._digest=function(e){return "hex"===e?qd.toHex32(this.h,"little"):qd.split32(this.h,"little")};var ef=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13],tf=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11],nf=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6],rf=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11],of=hc,af=Wa;function sf(e,t,n){if(!(this instanceof sf))return new sf(e,t,n);this.Hash=e,this.blockSize=e.blockSize/8,this.outSize=e.outSize/8,this.inner=null,this.outer=null,this._init(of.toArray(t,n));}var uf,lf,cf=sf;sf.prototype._init=function(e){e.length>this.blockSize&&(e=(new this.Hash).update(e).digest()),af(e.length<=this.blockSize);for(var t=e.length;t<this.blockSize;t++)e.push(0);for(t=0;t<e.length;t++)e[t]^=54;for(this.inner=(new this.Hash).update(e),t=0;t<e.length;t++)e[t]^=106;this.outer=(new this.Hash).update(e);},sf.prototype.update=function(e,t){return this.inner.update(e,t),this},sf.prototype.digest=function(e){return this.outer.update(this.inner.digest()),this.outer.digest(e)},function(e){var t=e;t.utils=hc,t.common=wc,t.sha=kc,t.ripemd=Kd,t.hmac=cf,t.sha1=t.sha.sha1,t.sha256=t.sha.sha256,t.sha224=t.sha.sha224,t.sha384=t.sha.sha384,t.sha512=t.sha.sha512,t.ripemd160=t.ripemd.ripemd160;}(fc),function(e){var t,n=e,r=fc,i=Ol,o=Ll.assert;function a(e){"short"===e.type?this.curve=new i.short(e):"edwards"===e.type?this.curve=new i.edwards(e):this.curve=new i.mont(e),this.g=this.curve.g,this.n=this.curve.n,this.hash=e.hash,o(this.g.validate(),"Invalid curve"),o(this.g.mul(this.n).isInfinity(),"Invalid curve, G*N != O");}function s(e,t){Object.defineProperty(n,e,{configurable:true,enumerable:true,get:function(){var r=new a(t);return Object.defineProperty(n,e,{configurable:true,enumerable:true,value:r}),r}});}n.PresetCurve=a,s("p192",{type:"short",prime:"p192",p:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",a:"ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",b:"64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",n:"ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",hash:r.sha256,gRed:false,g:["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012","07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]}),s("p224",{type:"short",prime:"p224",p:"ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",a:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",b:"b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",n:"ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",hash:r.sha256,gRed:false,g:["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21","bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]}),s("p256",{type:"short",prime:null,p:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",a:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",b:"5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",n:"ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",hash:r.sha256,gRed:false,g:["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296","4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]}),s("p384",{type:"short",prime:null,p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",a:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",b:"b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",n:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",hash:r.sha384,gRed:false,g:["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7","3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]}),s("p521",{type:"short",prime:null,p:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",a:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",b:"00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",n:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",hash:r.sha512,gRed:false,g:["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66","00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]}),s("curve25519",{type:"mont",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"76d06",b:"1",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:r.sha256,gRed:false,g:["9"]}),s("ed25519",{type:"edwards",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"-1",c:"1",d:"52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:r.sha256,gRed:false,g:["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a","6666666666666666666666666666666666666666666666666666666666666658"]});try{t=lf?uf:(lf=1,uf={doubles:{step:4,points:[["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a","f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"],["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508","11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"],["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739","d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"],["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640","4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"],["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c","4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"],["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda","96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"],["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa","5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"],["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0","cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"],["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d","9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"],["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d","e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"],["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1","9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"],["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0","5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"],["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047","10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"],["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862","283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"],["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7","7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"],["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd","56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"],["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83","7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"],["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a","53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"],["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8","bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"],["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d","4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"],["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725","7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"],["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754","4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"],["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c","17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"],["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6","6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"],["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39","c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"],["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891","893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"],["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b","febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"],["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03","2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"],["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d","eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"],["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070","7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"],["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4","e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"],["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da","662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"],["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11","1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"],["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e","efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"],["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41","2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"],["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef","67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"],["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8","db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"],["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d","648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"],["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96","35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"],["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd","ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"],["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5","9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"],["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266","40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"],["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71","34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"],["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac","c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"],["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751","1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"],["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e","493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"],["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241","c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"],["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3","be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"],["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f","4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"],["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19","aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"],["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be","b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"],["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9","6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"],["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2","8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"],["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13","7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"],["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c","ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"],["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba","2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"],["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151","e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"],["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073","d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"],["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458","38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"],["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b","69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"],["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366","d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"],["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa","40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"],["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0","620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"],["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787","7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"],["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e","ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]},naf:{wnd:7,points:[["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9","388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"],["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4","d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"],["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc","6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"],["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe","cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"],["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb","d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"],["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8","ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"],["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e","581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"],["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34","4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"],["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c","85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"],["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5","321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"],["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f","2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"],["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714","73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"],["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729","a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"],["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db","2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"],["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4","e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"],["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5","b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"],["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479","2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"],["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d","80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"],["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f","1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"],["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb","d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"],["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9","eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"],["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963","758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"],["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74","958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"],["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530","e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"],["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b","5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"],["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247","cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"],["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1","cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"],["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120","4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"],["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435","91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"],["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18","673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"],["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8","59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"],["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb","3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"],["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f","55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"],["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143","efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"],["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba","e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"],["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45","f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"],["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a","744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"],["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e","c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"],["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8","e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"],["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c","30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"],["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519","e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"],["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab","100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"],["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca","ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"],["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf","8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"],["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610","68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"],["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4","f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"],["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c","d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"],["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940","edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"],["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980","a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"],["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3","66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"],["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf","9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"],["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63","4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"],["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448","fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"],["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf","5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"],["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5","8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"],["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6","8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"],["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5","5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"],["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99","f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"],["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51","f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"],["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5","42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"],["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5","204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"],["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997","4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"],["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881","73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"],["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5","39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"],["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66","d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"],["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726","ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"],["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede","6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"],["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94","60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"],["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31","3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"],["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51","b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"],["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252","ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"],["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5","cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"],["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b","6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"],["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4","322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"],["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f","6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"],["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889","2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"],["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246","b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"],["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984","998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"],["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a","b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"],["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030","bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"],["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197","6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"],["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593","c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"],["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef","21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"],["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38","60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"],["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a","49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"],["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111","5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"],["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502","7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"],["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea","be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"],["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26","8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"],["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986","39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"],["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e","62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"],["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4","25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"],["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda","ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"],["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859","cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"],["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f","f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"],["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c","6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"],["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942","fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"],["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a","1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"],["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80","5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"],["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d","438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"],["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1","cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"],["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63","c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"],["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352","6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"],["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193","ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"],["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00","9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"],["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58","ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"],["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7","d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"],["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8","c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"],["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e","67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"],["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d","cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"],["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b","299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"],["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f","f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"],["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6","462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"],["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297","62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"],["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a","7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"],["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c","ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"],["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52","4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"],["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb","bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"],["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065","bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"],["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917","603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"],["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9","cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"],["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3","553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"],["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57","712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"],["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66","ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"],["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8","9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"],["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721","9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"],["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180","4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]}});}catch(e){t=void 0;}s("secp256k1",{type:"short",prime:"k256",p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",a:"0",b:"7",n:"ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",h:"1",hash:r.sha256,beta:"7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",lambda:"5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",basis:[{a:"3086d221a7d46bcde86c90e49284eb15",b:"-e4437ed6010e88286f547fa90abfe4c3"},{a:"114ca50f7a8e2f3f657c1108d9d44cfd8",b:"3086d221a7d46bcde86c90e49284eb15"}],gRed:false,g:["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798","483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",t]});}(dc);var df=fc,ff=Il,hf=Wa;function pf(e){if(!(this instanceof pf))return new pf(e);this.hash=e.hash,this.predResist=!!e.predResist,this.outLen=this.hash.outSize,this.minEntropy=e.minEntropy||this.hash.hmacStrength,this._reseed=null,this.reseedInterval=null,this.K=null,this.V=null;var t=ff.toArray(e.entropy,e.entropyEnc||"hex"),n=ff.toArray(e.nonce,e.nonceEnc||"hex"),r=ff.toArray(e.pers,e.persEnc||"hex");hf(t.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits"),this._init(t,n,r);}var mf=pf;pf.prototype._init=function(e,t,n){var r=e.concat(t).concat(n);this.K=new Array(this.outLen/8),this.V=new Array(this.outLen/8);for(var i=0;i<this.V.length;i++)this.K[i]=0,this.V[i]=1;this._update(r),this._reseed=1,this.reseedInterval=281474976710656;},pf.prototype._hmac=function(){return new df.hmac(this.hash,this.K)},pf.prototype._update=function(e){var t=this._hmac().update(this.V).update([0]);e&&(t=t.update(e)),this.K=t.digest(),this.V=this._hmac().update(this.V).digest(),e&&(this.K=this._hmac().update(this.V).update([1]).update(e).digest(),this.V=this._hmac().update(this.V).digest());},pf.prototype.reseed=function(e,t,n,r){"string"!=typeof t&&(r=n,n=t,t=null),e=ff.toArray(e,t),n=ff.toArray(n,r),hf(e.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits"),this._update(e.concat(n||[])),this._reseed=1;},pf.prototype.generate=function(e,t,n,r){if(this._reseed>this.reseedInterval)throw new Error("Reseed is required");"string"!=typeof t&&(r=n,n=t,t=null),n&&(n=ff.toArray(n,r||"hex"),this._update(n));for(var i=[];i.length<e;)this.V=this._hmac().update(this.V).digest(),i=i.concat(this.V);var o=i.slice(0,e);return this._update(n),this._reseed++,ff.encode(o,t)};var gf=hl,vf=Ll.assert;function bf(e,t){this.ec=e,this.priv=null,this.pub=null,t.priv&&this._importPrivate(t.priv,t.privEnc),t.pub&&this._importPublic(t.pub,t.pubEnc);}var yf=bf;bf.fromPublic=function(e,t,n){return t instanceof bf?t:new bf(e,{pub:t,pubEnc:n})},bf.fromPrivate=function(e,t,n){return t instanceof bf?t:new bf(e,{priv:t,privEnc:n})},bf.prototype.validate=function(){var e=this.getPublic();return e.isInfinity()?{result:false,reason:"Invalid public key"}:e.validate()?e.mul(this.ec.curve.n).isInfinity()?{result:true,reason:null}:{result:false,reason:"Public key * N != O"}:{result:false,reason:"Public key is not a point"}},bf.prototype.getPublic=function(e,t){return "string"==typeof e&&(t=e,e=null),this.pub||(this.pub=this.ec.g.mul(this.priv)),t?this.pub.encode(t,e):this.pub},bf.prototype.getPrivate=function(e){return "hex"===e?this.priv.toString(16,2):this.priv},bf.prototype._importPrivate=function(e,t){this.priv=new gf(e,t||16),this.priv=this.priv.umod(this.ec.curve.n);},bf.prototype._importPublic=function(e,t){if(e.x||e.y)return "mont"===this.ec.curve.type?vf(e.x,"Need x coordinate"):"short"!==this.ec.curve.type&&"edwards"!==this.ec.curve.type||vf(e.x&&e.y,"Need both x and y coordinate"),void(this.pub=this.ec.curve.point(e.x,e.y));this.pub=this.ec.curve.decodePoint(e,t);},bf.prototype.derive=function(e){return e.validate()||vf(e.validate(),"public point not validated"),e.mul(this.priv).getX()},bf.prototype.sign=function(e,t,n){return this.ec.sign(e,this,t,n)},bf.prototype.verify=function(e,t){return this.ec.verify(e,t,this)},bf.prototype.inspect=function(){return "<Key priv: "+(this.priv&&this.priv.toString(16,2))+" pub: "+(this.pub&&this.pub.inspect())+" >"};var wf=hl,_f=Ll,Sf=_f.assert;function Ef(e,t){if(e instanceof Ef)return e;this._importDER(e,t)||(Sf(e.r&&e.s,"Signature without r or s"),this.r=new wf(e.r,16),this.s=new wf(e.s,16),void 0===e.recoveryParam?this.recoveryParam=null:this.recoveryParam=e.recoveryParam);}var kf,Mf,Cf=Ef;function xf(){this.place=0;}function Af(e,t){var n=e[t.place++];if(!(128&n))return n;var r=15&n;if(0===r||r>4)return  false;for(var i=0,o=0,a=t.place;o<r;o++,a++)i<<=8,i|=e[a],i>>>=0;return !(i<=127)&&(t.place=a,i)}function Rf(e){for(var t=0,n=e.length-1;!e[t]&&!(128&e[t+1])&&t<n;)t++;return 0===t?e:e.slice(t)}function Tf(e,t){if(t<128)e.push(t);else {var n=1+(Math.log(t)/Math.LN2>>>3);for(e.push(128|n);--n;)e.push(t>>>(n<<3)&255);e.push(t);}}Ef.prototype._importDER=function(e,t){e=_f.toArray(e,t);var n=new xf;if(48!==e[n.place++])return  false;var r=Af(e,n);if(false===r)return  false;if(r+n.place!==e.length)return  false;if(2!==e[n.place++])return  false;var i=Af(e,n);if(false===i)return  false;var o=e.slice(n.place,i+n.place);if(n.place+=i,2!==e[n.place++])return  false;var a=Af(e,n);if(false===a)return  false;if(e.length!==a+n.place)return  false;var s=e.slice(n.place,a+n.place);if(0===o[0]){if(!(128&o[1]))return  false;o=o.slice(1);}if(0===s[0]){if(!(128&s[1]))return  false;s=s.slice(1);}return this.r=new wf(o),this.s=new wf(s),this.recoveryParam=null,true},Ef.prototype.toDER=function(e){var t=this.r.toArray(),n=this.s.toArray();for(128&t[0]&&(t=[0].concat(t)),128&n[0]&&(n=[0].concat(n)),t=Rf(t),n=Rf(n);!(n[0]||128&n[1]);)n=n.slice(1);var r=[2];Tf(r,t.length),(r=r.concat(t)).push(2),Tf(r,n.length);var i=r.concat(n),o=[48];return Tf(o,i.length),o=o.concat(i),_f.encode(o,e)};var Pf=Ll,Lf=Pf.assert,If=Pf.parseBytes,Of=Pf.cachedProperty;function Nf(e,t){this.eddsa=e,this._secret=If(t.secret),e.isPoint(t.pub)?this._pub=t.pub:this._pubBytes=If(t.pub);}Nf.fromPublic=function(e,t){return t instanceof Nf?t:new Nf(e,{pub:t})},Nf.fromSecret=function(e,t){return t instanceof Nf?t:new Nf(e,{secret:t})},Nf.prototype.secret=function(){return this._secret},Of(Nf,"pubBytes",(function(){return this.eddsa.encodePoint(this.pub())})),Of(Nf,"pub",(function(){return this._pubBytes?this.eddsa.decodePoint(this._pubBytes):this.eddsa.g.mul(this.priv())})),Of(Nf,"privBytes",(function(){var e=this.eddsa,t=this.hash(),n=e.encodingLength-1,r=t.slice(0,e.encodingLength);return r[0]&=248,r[n]&=127,r[n]|=64,r})),Of(Nf,"priv",(function(){return this.eddsa.decodeInt(this.privBytes())})),Of(Nf,"hash",(function(){return this.eddsa.hash().update(this.secret()).digest()})),Of(Nf,"messagePrefix",(function(){return this.hash().slice(this.eddsa.encodingLength)})),Nf.prototype.sign=function(e){return Lf(this._secret,"KeyPair can only verify"),this.eddsa.sign(e,this)},Nf.prototype.verify=function(e,t){return this.eddsa.verify(e,t,this)},Nf.prototype.getSecret=function(e){return Lf(this._secret,"KeyPair is public only"),Pf.encode(this.secret(),e)},Nf.prototype.getPublic=function(e){return Pf.encode(this.pubBytes(),e)};var Df=Nf,jf=hl,Bf=Ll,zf=Bf.assert,Uf=Bf.cachedProperty,Ff=Bf.parseBytes;function Kf(e,t){this.eddsa=e,"object"!=typeof t&&(t=Ff(t)),Array.isArray(t)&&(t={R:t.slice(0,e.encodingLength),S:t.slice(e.encodingLength)}),zf(t.R&&t.S,"Signature without R or S"),e.isPoint(t.R)&&(this._R=t.R),t.S instanceof jf&&(this._S=t.S),this._Rencoded=Array.isArray(t.R)?t.R:t.Rencoded,this._Sencoded=Array.isArray(t.S)?t.S:t.Sencoded;}Uf(Kf,"S",(function(){return this.eddsa.decodeInt(this.Sencoded())})),Uf(Kf,"R",(function(){return this.eddsa.decodePoint(this.Rencoded())})),Uf(Kf,"Rencoded",(function(){return this.eddsa.encodePoint(this.R())})),Uf(Kf,"Sencoded",(function(){return this.eddsa.encodeInt(this.S())})),Kf.prototype.toBytes=function(){return this.Rencoded().concat(this.Sencoded())},Kf.prototype.toHex=function(){return Bf.encode(this.toBytes(),"hex").toUpperCase()};var qf=Kf,Hf=fc,Wf=dc,$f=Ll,Vf=$f.assert,Yf=$f.parseBytes,Gf=Df,Zf=qf;function Qf(e){if(Vf("ed25519"===e,"only tested with ed25519 so far"),!(this instanceof Qf))return new Qf(e);e=Wf[e].curve,this.curve=e,this.g=e.g,this.g.precompute(e.n.bitLength()+1),this.pointClass=e.point().constructor,this.encodingLength=Math.ceil(e.n.bitLength()/8),this.hash=Hf.sha512;}var Jf,Xf=Qf;function eh(){return Jf||(Jf=1,function(e){var t=e;t.version=Pl.version,t.utils=Ll,t.rand=ml(),t.curve=Ol,t.curves=dc,t.ec=function(){if(Mf)return kf;Mf=1;var e=hl,t=mf,n=Ll,r=dc,i=ml(),o=n.assert,a=yf,s=Cf;function u(e){if(!(this instanceof u))return new u(e);"string"==typeof e&&(o(Object.prototype.hasOwnProperty.call(r,e),"Unknown curve "+e),e=r[e]),e instanceof r.PresetCurve&&(e={curve:e}),this.curve=e.curve.curve,this.n=this.curve.n,this.nh=this.n.ushrn(1),this.g=this.curve.g,this.g=e.curve.g,this.g.precompute(e.curve.n.bitLength()+1),this.hash=e.hash||e.curve.hash;}return kf=u,u.prototype.keyPair=function(e){return new a(this,e)},u.prototype.keyFromPrivate=function(e,t){return a.fromPrivate(this,e,t)},u.prototype.keyFromPublic=function(e,t){return a.fromPublic(this,e,t)},u.prototype.genKeyPair=function(n){n||(n={});for(var r=new t({hash:this.hash,pers:n.pers,persEnc:n.persEnc||"utf8",entropy:n.entropy||i(this.hash.hmacStrength),entropyEnc:n.entropy&&n.entropyEnc||"utf8",nonce:this.n.toArray()}),o=this.n.byteLength(),a=this.n.sub(new e(2));;){var s=new e(r.generate(o));if(!(s.cmp(a)>0))return s.iaddn(1),this.keyFromPrivate(s)}},u.prototype._truncateToN=function(e,t){var n=8*e.byteLength()-this.n.bitLength();return n>0&&(e=e.ushrn(n)),!t&&e.cmp(this.n)>=0?e.sub(this.n):e},u.prototype.sign=function(n,r,i,o){"object"==typeof i&&(o=i,i=null),o||(o={}),r=this.keyFromPrivate(r,i),n=this._truncateToN(new e(n,16));for(var a=this.n.byteLength(),u=r.getPrivate().toArray("be",a),l=n.toArray("be",a),c=new t({hash:this.hash,entropy:u,nonce:l,pers:o.pers,persEnc:o.persEnc||"utf8"}),d=this.n.sub(new e(1)),f=0;;f++){var h=o.k?o.k(f):new e(c.generate(this.n.byteLength()));if(!((h=this._truncateToN(h,true)).cmpn(1)<=0||h.cmp(d)>=0)){var p=this.g.mul(h);if(!p.isInfinity()){var m=p.getX(),g=m.umod(this.n);if(0!==g.cmpn(0)){var v=h.invm(this.n).mul(g.mul(r.getPrivate()).iadd(n));if(0!==(v=v.umod(this.n)).cmpn(0)){var b=(p.getY().isOdd()?1:0)|(0!==m.cmp(g)?2:0);return o.canonical&&v.cmp(this.nh)>0&&(v=this.n.sub(v),b^=1),new s({r:g,s:v,recoveryParam:b})}}}}}},u.prototype.verify=function(t,n,r,i){t=this._truncateToN(new e(t,16)),r=this.keyFromPublic(r,i);var o=(n=new s(n,"hex")).r,a=n.s;if(o.cmpn(1)<0||o.cmp(this.n)>=0)return  false;if(a.cmpn(1)<0||a.cmp(this.n)>=0)return  false;var u,l=a.invm(this.n),c=l.mul(t).umod(this.n),d=l.mul(o).umod(this.n);return this.curve._maxwellTrick?!(u=this.g.jmulAdd(c,r.getPublic(),d)).isInfinity()&&u.eqXToP(o):!(u=this.g.mulAdd(c,r.getPublic(),d)).isInfinity()&&0===u.getX().umod(this.n).cmp(o)},u.prototype.recoverPubKey=function(t,n,r,i){o((3&r)===r,"The recovery param is more than two bits"),n=new s(n,i);var a=this.n,u=new e(t),l=n.r,c=n.s,d=1&r,f=r>>1;if(l.cmp(this.curve.p.umod(this.curve.n))>=0&&f)throw new Error("Unable to find sencond key candinate");l=f?this.curve.pointFromX(l.add(this.curve.n),d):this.curve.pointFromX(l,d);var h=n.r.invm(a),p=a.sub(u).mul(h).umod(a),m=c.mul(h).umod(a);return this.g.mulAdd(p,l,m)},u.prototype.getKeyRecoveryParam=function(e,t,n,r){if(null!==(t=new s(t,r)).recoveryParam)return t.recoveryParam;for(var i=0;i<4;i++){var o;try{o=this.recoverPubKey(e,t,i);}catch(e){continue}if(o.eq(n))return i}throw new Error("Unable to find valid recovery factor")},kf}(),t.eddsa=Xf;}(Tl)),Tl}Qf.prototype.sign=function(e,t){e=Yf(e);var n=this.keyFromSecret(t),r=this.hashInt(n.messagePrefix(),e),i=this.g.mul(r),o=this.encodePoint(i),a=this.hashInt(o,n.pubBytes(),e).mul(n.priv()),s=r.add(a).umod(this.curve.n);return this.makeSignature({R:i,S:s,Rencoded:o})},Qf.prototype.verify=function(e,t,n){e=Yf(e),t=this.makeSignature(t);var r=this.keyFromPublic(n),i=this.hashInt(t.Rencoded(),r.pubBytes(),e),o=this.g.mul(t.S());return t.R().add(r.pub().mul(i)).eq(o)},Qf.prototype.hashInt=function(){for(var e=this.hash(),t=0;t<arguments.length;t++)e.update(arguments[t]);return $f.intFromLE(e.digest()).umod(this.curve.n)},Qf.prototype.keyFromPublic=function(e){return Gf.fromPublic(this,e)},Qf.prototype.keyFromSecret=function(e){return Gf.fromSecret(this,e)},Qf.prototype.makeSignature=function(e){return e instanceof Zf?e:new Zf(this,e)},Qf.prototype.encodePoint=function(e){var t=e.getY().toArray("le",this.encodingLength);return t[this.encodingLength-1]|=e.getX().isOdd()?128:0,t},Qf.prototype.decodePoint=function(e){var t=(e=$f.parseBytes(e)).length-1,n=e.slice(0,t).concat(-129&e[t]),r=0!=(128&e[t]),i=$f.intFromLE(n);return this.curve.pointFromY(i,r)},Qf.prototype.encodeInt=function(e){return e.toArray("le",this.encodingLength)},Qf.prototype.decodeInt=function(e){return $f.intFromLE(e)},Qf.prototype.isPoint=function(e){return e instanceof this.pointClass};var th={exports:{}};!function(e){!function(e,t){function n(e,t){if(!e)throw new Error(t||"Assertion failed")}function r(e,t){e.super_=t;var n=function(){};n.prototype=t.prototype,e.prototype=new n,e.prototype.constructor=e;}function i(e,t,n){if(i.isBN(e))return e;this.negative=0,this.words=null,this.length=0,this.red=null,null!==e&&("le"!==t&&"be"!==t||(n=t,t=10),this._init(e||0,t||10,n||"be"));}var o;"object"==typeof e?e.exports=i:t.BN=i,i.BN=i,i.wordSize=26;try{o="undefined"!=typeof window&&void 0!==window.Buffer?window.Buffer:ce.Buffer;}catch(e){}function a(e,t){var r=e.charCodeAt(t);return r>=48&&r<=57?r-48:r>=65&&r<=70?r-55:r>=97&&r<=102?r-87:void n(false,"Invalid character in "+e)}function s(e,t,n){var r=a(e,n);return n-1>=t&&(r|=a(e,n-1)<<4),r}function u(e,t,r,i){for(var o=0,a=0,s=Math.min(e.length,r),u=t;u<s;u++){var l=e.charCodeAt(u)-48;o*=i,a=l>=49?l-49+10:l>=17?l-17+10:l,n(l>=0&&a<i,"Invalid character"),o+=a;}return o}function l(e,t){e.words=t.words,e.length=t.length,e.negative=t.negative,e.red=t.red;}if(i.isBN=function(e){return e instanceof i||null!==e&&"object"==typeof e&&e.constructor.wordSize===i.wordSize&&Array.isArray(e.words)},i.max=function(e,t){return e.cmp(t)>0?e:t},i.min=function(e,t){return e.cmp(t)<0?e:t},i.prototype._init=function(e,t,r){if("number"==typeof e)return this._initNumber(e,t,r);if("object"==typeof e)return this._initArray(e,t,r);"hex"===t&&(t=16),n(t===(0|t)&&t>=2&&t<=36);var i=0;"-"===(e=e.toString().replace(/\s+/g,""))[0]&&(i++,this.negative=1),i<e.length&&(16===t?this._parseHex(e,i,r):(this._parseBase(e,t,i),"le"===r&&this._initArray(this.toArray(),t,r)));},i.prototype._initNumber=function(e,t,r){e<0&&(this.negative=1,e=-e),e<67108864?(this.words=[67108863&e],this.length=1):e<4503599627370496?(this.words=[67108863&e,e/67108864&67108863],this.length=2):(n(e<9007199254740992),this.words=[67108863&e,e/67108864&67108863,1],this.length=3),"le"===r&&this._initArray(this.toArray(),t,r);},i.prototype._initArray=function(e,t,r){if(n("number"==typeof e.length),e.length<=0)return this.words=[0],this.length=1,this;this.length=Math.ceil(e.length/3),this.words=new Array(this.length);for(var i=0;i<this.length;i++)this.words[i]=0;var o,a,s=0;if("be"===r)for(i=e.length-1,o=0;i>=0;i-=3)a=e[i]|e[i-1]<<8|e[i-2]<<16,this.words[o]|=a<<s&67108863,this.words[o+1]=a>>>26-s&67108863,(s+=24)>=26&&(s-=26,o++);else if("le"===r)for(i=0,o=0;i<e.length;i+=3)a=e[i]|e[i+1]<<8|e[i+2]<<16,this.words[o]|=a<<s&67108863,this.words[o+1]=a>>>26-s&67108863,(s+=24)>=26&&(s-=26,o++);return this._strip()},i.prototype._parseHex=function(e,t,n){this.length=Math.ceil((e.length-t)/6),this.words=new Array(this.length);for(var r=0;r<this.length;r++)this.words[r]=0;var i,o=0,a=0;if("be"===n)for(r=e.length-1;r>=t;r-=2)i=s(e,t,r)<<o,this.words[a]|=67108863&i,o>=18?(o-=18,a+=1,this.words[a]|=i>>>26):o+=8;else for(r=(e.length-t)%2==0?t+1:t;r<e.length;r+=2)i=s(e,t,r)<<o,this.words[a]|=67108863&i,o>=18?(o-=18,a+=1,this.words[a]|=i>>>26):o+=8;this._strip();},i.prototype._parseBase=function(e,t,n){this.words=[0],this.length=1;for(var r=0,i=1;i<=67108863;i*=t)r++;r--,i=i/t|0;for(var o=e.length-n,a=o%r,s=Math.min(o,o-a)+n,l=0,c=n;c<s;c+=r)l=u(e,c,c+r,t),this.imuln(i),this.words[0]+l<67108864?this.words[0]+=l:this._iaddn(l);if(0!==a){var d=1;for(l=u(e,c,e.length,t),c=0;c<a;c++)d*=t;this.imuln(d),this.words[0]+l<67108864?this.words[0]+=l:this._iaddn(l);}this._strip();},i.prototype.copy=function(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++)e.words[t]=this.words[t];e.length=this.length,e.negative=this.negative,e.red=this.red;},i.prototype._move=function(e){l(e,this);},i.prototype.clone=function(){var e=new i(null);return this.copy(e),e},i.prototype._expand=function(e){for(;this.length<e;)this.words[this.length++]=0;return this},i.prototype._strip=function(){for(;this.length>1&&0===this.words[this.length-1];)this.length--;return this._normSign()},i.prototype._normSign=function(){return 1===this.length&&0===this.words[0]&&(this.negative=0),this},"undefined"!=typeof Symbol&&"function"==typeof Symbol.for)try{i.prototype[Symbol.for("nodejs.util.inspect.custom")]=c;}catch(e){i.prototype.inspect=c;}else i.prototype.inspect=c;function c(){return (this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"}var d=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"],f=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5],h=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];i.prototype.toString=function(e,t){var r;if(t=0|t||1,16===(e=e||10)||"hex"===e){r="";for(var i=0,o=0,a=0;a<this.length;a++){var s=this.words[a],u=(16777215&(s<<i|o)).toString(16);o=s>>>24-i&16777215,(i+=2)>=26&&(i-=26,a--),r=0!==o||a!==this.length-1?d[6-u.length]+u+r:u+r;}for(0!==o&&(r=o.toString(16)+r);r.length%t!=0;)r="0"+r;return 0!==this.negative&&(r="-"+r),r}if(e===(0|e)&&e>=2&&e<=36){var l=f[e],c=h[e];r="";var p=this.clone();for(p.negative=0;!p.isZero();){var m=p.modrn(c).toString(e);r=(p=p.idivn(c)).isZero()?m+r:d[l-m.length]+m+r;}for(this.isZero()&&(r="0"+r);r.length%t!=0;)r="0"+r;return 0!==this.negative&&(r="-"+r),r}n(false,"Base should be between 2 and 36");},i.prototype.toNumber=function(){var e=this.words[0];return 2===this.length?e+=67108864*this.words[1]:3===this.length&&1===this.words[2]?e+=4503599627370496+67108864*this.words[1]:this.length>2&&n(false,"Number can only safely store up to 53 bits"),0!==this.negative?-e:e},i.prototype.toJSON=function(){return this.toString(16,2)},o&&(i.prototype.toBuffer=function(e,t){return this.toArrayLike(o,e,t)}),i.prototype.toArray=function(e,t){return this.toArrayLike(Array,e,t)};function p(e,t,n){n.negative=t.negative^e.negative;var r=e.length+t.length|0;n.length=r,r=r-1|0;var i=0|e.words[0],o=0|t.words[0],a=i*o,s=67108863&a,u=a/67108864|0;n.words[0]=s;for(var l=1;l<r;l++){for(var c=u>>>26,d=67108863&u,f=Math.min(l,t.length-1),h=Math.max(0,l-e.length+1);h<=f;h++){var p=l-h|0;c+=(a=(i=0|e.words[p])*(o=0|t.words[h])+d)/67108864|0,d=67108863&a;}n.words[l]=0|d,u=0|c;}return 0!==u?n.words[l]=0|u:n.length--,n._strip()}i.prototype.toArrayLike=function(e,t,r){this._strip();var i=this.byteLength(),o=r||Math.max(1,i);n(i<=o,"byte array longer than desired length"),n(o>0,"Requested array length <= 0");var a=function(e,t){return e.allocUnsafe?e.allocUnsafe(t):new e(t)}(e,o);return this["_toArrayLike"+("le"===t?"LE":"BE")](a,i),a},i.prototype._toArrayLikeLE=function(e,t){for(var n=0,r=0,i=0,o=0;i<this.length;i++){var a=this.words[i]<<o|r;e[n++]=255&a,n<e.length&&(e[n++]=a>>8&255),n<e.length&&(e[n++]=a>>16&255),6===o?(n<e.length&&(e[n++]=a>>24&255),r=0,o=0):(r=a>>>24,o+=2);}if(n<e.length)for(e[n++]=r;n<e.length;)e[n++]=0;},i.prototype._toArrayLikeBE=function(e,t){for(var n=e.length-1,r=0,i=0,o=0;i<this.length;i++){var a=this.words[i]<<o|r;e[n--]=255&a,n>=0&&(e[n--]=a>>8&255),n>=0&&(e[n--]=a>>16&255),6===o?(n>=0&&(e[n--]=a>>24&255),r=0,o=0):(r=a>>>24,o+=2);}if(n>=0)for(e[n--]=r;n>=0;)e[n--]=0;},Math.clz32?i.prototype._countBits=function(e){return 32-Math.clz32(e)}:i.prototype._countBits=function(e){var t=e,n=0;return t>=4096&&(n+=13,t>>>=13),t>=64&&(n+=7,t>>>=7),t>=8&&(n+=4,t>>>=4),t>=2&&(n+=2,t>>>=2),n+t},i.prototype._zeroBits=function(e){if(0===e)return 26;var t=e,n=0;return 0==(8191&t)&&(n+=13,t>>>=13),0==(127&t)&&(n+=7,t>>>=7),0==(15&t)&&(n+=4,t>>>=4),0==(3&t)&&(n+=2,t>>>=2),0==(1&t)&&n++,n},i.prototype.bitLength=function(){var e=this.words[this.length-1],t=this._countBits(e);return 26*(this.length-1)+t},i.prototype.zeroBits=function(){if(this.isZero())return 0;for(var e=0,t=0;t<this.length;t++){var n=this._zeroBits(this.words[t]);if(e+=n,26!==n)break}return e},i.prototype.byteLength=function(){return Math.ceil(this.bitLength()/8)},i.prototype.toTwos=function(e){return 0!==this.negative?this.abs().inotn(e).iaddn(1):this.clone()},i.prototype.fromTwos=function(e){return this.testn(e-1)?this.notn(e).iaddn(1).ineg():this.clone()},i.prototype.isNeg=function(){return 0!==this.negative},i.prototype.neg=function(){return this.clone().ineg()},i.prototype.ineg=function(){return this.isZero()||(this.negative^=1),this},i.prototype.iuor=function(e){for(;this.length<e.length;)this.words[this.length++]=0;for(var t=0;t<e.length;t++)this.words[t]=this.words[t]|e.words[t];return this._strip()},i.prototype.ior=function(e){return n(0==(this.negative|e.negative)),this.iuor(e)},i.prototype.or=function(e){return this.length>e.length?this.clone().ior(e):e.clone().ior(this)},i.prototype.uor=function(e){return this.length>e.length?this.clone().iuor(e):e.clone().iuor(this)},i.prototype.iuand=function(e){var t;t=this.length>e.length?e:this;for(var n=0;n<t.length;n++)this.words[n]=this.words[n]&e.words[n];return this.length=t.length,this._strip()},i.prototype.iand=function(e){return n(0==(this.negative|e.negative)),this.iuand(e)},i.prototype.and=function(e){return this.length>e.length?this.clone().iand(e):e.clone().iand(this)},i.prototype.uand=function(e){return this.length>e.length?this.clone().iuand(e):e.clone().iuand(this)},i.prototype.iuxor=function(e){var t,n;this.length>e.length?(t=this,n=e):(t=e,n=this);for(var r=0;r<n.length;r++)this.words[r]=t.words[r]^n.words[r];if(this!==t)for(;r<t.length;r++)this.words[r]=t.words[r];return this.length=t.length,this._strip()},i.prototype.ixor=function(e){return n(0==(this.negative|e.negative)),this.iuxor(e)},i.prototype.xor=function(e){return this.length>e.length?this.clone().ixor(e):e.clone().ixor(this)},i.prototype.uxor=function(e){return this.length>e.length?this.clone().iuxor(e):e.clone().iuxor(this)},i.prototype.inotn=function(e){n("number"==typeof e&&e>=0);var t=0|Math.ceil(e/26),r=e%26;this._expand(t),r>0&&t--;for(var i=0;i<t;i++)this.words[i]=67108863&~this.words[i];return r>0&&(this.words[i]=~this.words[i]&67108863>>26-r),this._strip()},i.prototype.notn=function(e){return this.clone().inotn(e)},i.prototype.setn=function(e,t){n("number"==typeof e&&e>=0);var r=e/26|0,i=e%26;return this._expand(r+1),this.words[r]=t?this.words[r]|1<<i:this.words[r]&~(1<<i),this._strip()},i.prototype.iadd=function(e){var t,n,r;if(0!==this.negative&&0===e.negative)return this.negative=0,t=this.isub(e),this.negative^=1,this._normSign();if(0===this.negative&&0!==e.negative)return e.negative=0,t=this.isub(e),e.negative=1,t._normSign();this.length>e.length?(n=this,r=e):(n=e,r=this);for(var i=0,o=0;o<r.length;o++)t=(0|n.words[o])+(0|r.words[o])+i,this.words[o]=67108863&t,i=t>>>26;for(;0!==i&&o<n.length;o++)t=(0|n.words[o])+i,this.words[o]=67108863&t,i=t>>>26;if(this.length=n.length,0!==i)this.words[this.length]=i,this.length++;else if(n!==this)for(;o<n.length;o++)this.words[o]=n.words[o];return this},i.prototype.add=function(e){var t;return 0!==e.negative&&0===this.negative?(e.negative=0,t=this.sub(e),e.negative^=1,t):0===e.negative&&0!==this.negative?(this.negative=0,t=e.sub(this),this.negative=1,t):this.length>e.length?this.clone().iadd(e):e.clone().iadd(this)},i.prototype.isub=function(e){if(0!==e.negative){e.negative=0;var t=this.iadd(e);return e.negative=1,t._normSign()}if(0!==this.negative)return this.negative=0,this.iadd(e),this.negative=1,this._normSign();var n,r,i=this.cmp(e);if(0===i)return this.negative=0,this.length=1,this.words[0]=0,this;i>0?(n=this,r=e):(n=e,r=this);for(var o=0,a=0;a<r.length;a++)o=(t=(0|n.words[a])-(0|r.words[a])+o)>>26,this.words[a]=67108863&t;for(;0!==o&&a<n.length;a++)o=(t=(0|n.words[a])+o)>>26,this.words[a]=67108863&t;if(0===o&&a<n.length&&n!==this)for(;a<n.length;a++)this.words[a]=n.words[a];return this.length=Math.max(this.length,a),n!==this&&(this.negative=1),this._strip()},i.prototype.sub=function(e){return this.clone().isub(e)};var m=function(e,t,n){var r,i,o,a=e.words,s=t.words,u=n.words,l=0,c=0|a[0],d=8191&c,f=c>>>13,h=0|a[1],p=8191&h,m=h>>>13,g=0|a[2],v=8191&g,b=g>>>13,y=0|a[3],w=8191&y,_=y>>>13,S=0|a[4],E=8191&S,k=S>>>13,M=0|a[5],C=8191&M,x=M>>>13,A=0|a[6],R=8191&A,T=A>>>13,P=0|a[7],L=8191&P,I=P>>>13,O=0|a[8],N=8191&O,D=O>>>13,j=0|a[9],B=8191&j,z=j>>>13,U=0|s[0],F=8191&U,K=U>>>13,q=0|s[1],H=8191&q,W=q>>>13,$=0|s[2],V=8191&$,Y=$>>>13,G=0|s[3],Z=8191&G,Q=G>>>13,J=0|s[4],X=8191&J,ee=J>>>13,te=0|s[5],ne=8191&te,re=te>>>13,ie=0|s[6],oe=8191&ie,ae=ie>>>13,se=0|s[7],ue=8191&se,le=se>>>13,ce=0|s[8],de=8191&ce,fe=ce>>>13,he=0|s[9],pe=8191&he,me=he>>>13;n.negative=e.negative^t.negative,n.length=19;var ge=(l+(r=Math.imul(d,F))|0)+((8191&(i=(i=Math.imul(d,K))+Math.imul(f,F)|0))<<13)|0;l=((o=Math.imul(f,K))+(i>>>13)|0)+(ge>>>26)|0,ge&=67108863,r=Math.imul(p,F),i=(i=Math.imul(p,K))+Math.imul(m,F)|0,o=Math.imul(m,K);var ve=(l+(r=r+Math.imul(d,H)|0)|0)+((8191&(i=(i=i+Math.imul(d,W)|0)+Math.imul(f,H)|0))<<13)|0;l=((o=o+Math.imul(f,W)|0)+(i>>>13)|0)+(ve>>>26)|0,ve&=67108863,r=Math.imul(v,F),i=(i=Math.imul(v,K))+Math.imul(b,F)|0,o=Math.imul(b,K),r=r+Math.imul(p,H)|0,i=(i=i+Math.imul(p,W)|0)+Math.imul(m,H)|0,o=o+Math.imul(m,W)|0;var be=(l+(r=r+Math.imul(d,V)|0)|0)+((8191&(i=(i=i+Math.imul(d,Y)|0)+Math.imul(f,V)|0))<<13)|0;l=((o=o+Math.imul(f,Y)|0)+(i>>>13)|0)+(be>>>26)|0,be&=67108863,r=Math.imul(w,F),i=(i=Math.imul(w,K))+Math.imul(_,F)|0,o=Math.imul(_,K),r=r+Math.imul(v,H)|0,i=(i=i+Math.imul(v,W)|0)+Math.imul(b,H)|0,o=o+Math.imul(b,W)|0,r=r+Math.imul(p,V)|0,i=(i=i+Math.imul(p,Y)|0)+Math.imul(m,V)|0,o=o+Math.imul(m,Y)|0;var ye=(l+(r=r+Math.imul(d,Z)|0)|0)+((8191&(i=(i=i+Math.imul(d,Q)|0)+Math.imul(f,Z)|0))<<13)|0;l=((o=o+Math.imul(f,Q)|0)+(i>>>13)|0)+(ye>>>26)|0,ye&=67108863,r=Math.imul(E,F),i=(i=Math.imul(E,K))+Math.imul(k,F)|0,o=Math.imul(k,K),r=r+Math.imul(w,H)|0,i=(i=i+Math.imul(w,W)|0)+Math.imul(_,H)|0,o=o+Math.imul(_,W)|0,r=r+Math.imul(v,V)|0,i=(i=i+Math.imul(v,Y)|0)+Math.imul(b,V)|0,o=o+Math.imul(b,Y)|0,r=r+Math.imul(p,Z)|0,i=(i=i+Math.imul(p,Q)|0)+Math.imul(m,Z)|0,o=o+Math.imul(m,Q)|0;var we=(l+(r=r+Math.imul(d,X)|0)|0)+((8191&(i=(i=i+Math.imul(d,ee)|0)+Math.imul(f,X)|0))<<13)|0;l=((o=o+Math.imul(f,ee)|0)+(i>>>13)|0)+(we>>>26)|0,we&=67108863,r=Math.imul(C,F),i=(i=Math.imul(C,K))+Math.imul(x,F)|0,o=Math.imul(x,K),r=r+Math.imul(E,H)|0,i=(i=i+Math.imul(E,W)|0)+Math.imul(k,H)|0,o=o+Math.imul(k,W)|0,r=r+Math.imul(w,V)|0,i=(i=i+Math.imul(w,Y)|0)+Math.imul(_,V)|0,o=o+Math.imul(_,Y)|0,r=r+Math.imul(v,Z)|0,i=(i=i+Math.imul(v,Q)|0)+Math.imul(b,Z)|0,o=o+Math.imul(b,Q)|0,r=r+Math.imul(p,X)|0,i=(i=i+Math.imul(p,ee)|0)+Math.imul(m,X)|0,o=o+Math.imul(m,ee)|0;var _e=(l+(r=r+Math.imul(d,ne)|0)|0)+((8191&(i=(i=i+Math.imul(d,re)|0)+Math.imul(f,ne)|0))<<13)|0;l=((o=o+Math.imul(f,re)|0)+(i>>>13)|0)+(_e>>>26)|0,_e&=67108863,r=Math.imul(R,F),i=(i=Math.imul(R,K))+Math.imul(T,F)|0,o=Math.imul(T,K),r=r+Math.imul(C,H)|0,i=(i=i+Math.imul(C,W)|0)+Math.imul(x,H)|0,o=o+Math.imul(x,W)|0,r=r+Math.imul(E,V)|0,i=(i=i+Math.imul(E,Y)|0)+Math.imul(k,V)|0,o=o+Math.imul(k,Y)|0,r=r+Math.imul(w,Z)|0,i=(i=i+Math.imul(w,Q)|0)+Math.imul(_,Z)|0,o=o+Math.imul(_,Q)|0,r=r+Math.imul(v,X)|0,i=(i=i+Math.imul(v,ee)|0)+Math.imul(b,X)|0,o=o+Math.imul(b,ee)|0,r=r+Math.imul(p,ne)|0,i=(i=i+Math.imul(p,re)|0)+Math.imul(m,ne)|0,o=o+Math.imul(m,re)|0;var Se=(l+(r=r+Math.imul(d,oe)|0)|0)+((8191&(i=(i=i+Math.imul(d,ae)|0)+Math.imul(f,oe)|0))<<13)|0;l=((o=o+Math.imul(f,ae)|0)+(i>>>13)|0)+(Se>>>26)|0,Se&=67108863,r=Math.imul(L,F),i=(i=Math.imul(L,K))+Math.imul(I,F)|0,o=Math.imul(I,K),r=r+Math.imul(R,H)|0,i=(i=i+Math.imul(R,W)|0)+Math.imul(T,H)|0,o=o+Math.imul(T,W)|0,r=r+Math.imul(C,V)|0,i=(i=i+Math.imul(C,Y)|0)+Math.imul(x,V)|0,o=o+Math.imul(x,Y)|0,r=r+Math.imul(E,Z)|0,i=(i=i+Math.imul(E,Q)|0)+Math.imul(k,Z)|0,o=o+Math.imul(k,Q)|0,r=r+Math.imul(w,X)|0,i=(i=i+Math.imul(w,ee)|0)+Math.imul(_,X)|0,o=o+Math.imul(_,ee)|0,r=r+Math.imul(v,ne)|0,i=(i=i+Math.imul(v,re)|0)+Math.imul(b,ne)|0,o=o+Math.imul(b,re)|0,r=r+Math.imul(p,oe)|0,i=(i=i+Math.imul(p,ae)|0)+Math.imul(m,oe)|0,o=o+Math.imul(m,ae)|0;var Ee=(l+(r=r+Math.imul(d,ue)|0)|0)+((8191&(i=(i=i+Math.imul(d,le)|0)+Math.imul(f,ue)|0))<<13)|0;l=((o=o+Math.imul(f,le)|0)+(i>>>13)|0)+(Ee>>>26)|0,Ee&=67108863,r=Math.imul(N,F),i=(i=Math.imul(N,K))+Math.imul(D,F)|0,o=Math.imul(D,K),r=r+Math.imul(L,H)|0,i=(i=i+Math.imul(L,W)|0)+Math.imul(I,H)|0,o=o+Math.imul(I,W)|0,r=r+Math.imul(R,V)|0,i=(i=i+Math.imul(R,Y)|0)+Math.imul(T,V)|0,o=o+Math.imul(T,Y)|0,r=r+Math.imul(C,Z)|0,i=(i=i+Math.imul(C,Q)|0)+Math.imul(x,Z)|0,o=o+Math.imul(x,Q)|0,r=r+Math.imul(E,X)|0,i=(i=i+Math.imul(E,ee)|0)+Math.imul(k,X)|0,o=o+Math.imul(k,ee)|0,r=r+Math.imul(w,ne)|0,i=(i=i+Math.imul(w,re)|0)+Math.imul(_,ne)|0,o=o+Math.imul(_,re)|0,r=r+Math.imul(v,oe)|0,i=(i=i+Math.imul(v,ae)|0)+Math.imul(b,oe)|0,o=o+Math.imul(b,ae)|0,r=r+Math.imul(p,ue)|0,i=(i=i+Math.imul(p,le)|0)+Math.imul(m,ue)|0,o=o+Math.imul(m,le)|0;var ke=(l+(r=r+Math.imul(d,de)|0)|0)+((8191&(i=(i=i+Math.imul(d,fe)|0)+Math.imul(f,de)|0))<<13)|0;l=((o=o+Math.imul(f,fe)|0)+(i>>>13)|0)+(ke>>>26)|0,ke&=67108863,r=Math.imul(B,F),i=(i=Math.imul(B,K))+Math.imul(z,F)|0,o=Math.imul(z,K),r=r+Math.imul(N,H)|0,i=(i=i+Math.imul(N,W)|0)+Math.imul(D,H)|0,o=o+Math.imul(D,W)|0,r=r+Math.imul(L,V)|0,i=(i=i+Math.imul(L,Y)|0)+Math.imul(I,V)|0,o=o+Math.imul(I,Y)|0,r=r+Math.imul(R,Z)|0,i=(i=i+Math.imul(R,Q)|0)+Math.imul(T,Z)|0,o=o+Math.imul(T,Q)|0,r=r+Math.imul(C,X)|0,i=(i=i+Math.imul(C,ee)|0)+Math.imul(x,X)|0,o=o+Math.imul(x,ee)|0,r=r+Math.imul(E,ne)|0,i=(i=i+Math.imul(E,re)|0)+Math.imul(k,ne)|0,o=o+Math.imul(k,re)|0,r=r+Math.imul(w,oe)|0,i=(i=i+Math.imul(w,ae)|0)+Math.imul(_,oe)|0,o=o+Math.imul(_,ae)|0,r=r+Math.imul(v,ue)|0,i=(i=i+Math.imul(v,le)|0)+Math.imul(b,ue)|0,o=o+Math.imul(b,le)|0,r=r+Math.imul(p,de)|0,i=(i=i+Math.imul(p,fe)|0)+Math.imul(m,de)|0,o=o+Math.imul(m,fe)|0;var Me=(l+(r=r+Math.imul(d,pe)|0)|0)+((8191&(i=(i=i+Math.imul(d,me)|0)+Math.imul(f,pe)|0))<<13)|0;l=((o=o+Math.imul(f,me)|0)+(i>>>13)|0)+(Me>>>26)|0,Me&=67108863,r=Math.imul(B,H),i=(i=Math.imul(B,W))+Math.imul(z,H)|0,o=Math.imul(z,W),r=r+Math.imul(N,V)|0,i=(i=i+Math.imul(N,Y)|0)+Math.imul(D,V)|0,o=o+Math.imul(D,Y)|0,r=r+Math.imul(L,Z)|0,i=(i=i+Math.imul(L,Q)|0)+Math.imul(I,Z)|0,o=o+Math.imul(I,Q)|0,r=r+Math.imul(R,X)|0,i=(i=i+Math.imul(R,ee)|0)+Math.imul(T,X)|0,o=o+Math.imul(T,ee)|0,r=r+Math.imul(C,ne)|0,i=(i=i+Math.imul(C,re)|0)+Math.imul(x,ne)|0,o=o+Math.imul(x,re)|0,r=r+Math.imul(E,oe)|0,i=(i=i+Math.imul(E,ae)|0)+Math.imul(k,oe)|0,o=o+Math.imul(k,ae)|0,r=r+Math.imul(w,ue)|0,i=(i=i+Math.imul(w,le)|0)+Math.imul(_,ue)|0,o=o+Math.imul(_,le)|0,r=r+Math.imul(v,de)|0,i=(i=i+Math.imul(v,fe)|0)+Math.imul(b,de)|0,o=o+Math.imul(b,fe)|0;var Ce=(l+(r=r+Math.imul(p,pe)|0)|0)+((8191&(i=(i=i+Math.imul(p,me)|0)+Math.imul(m,pe)|0))<<13)|0;l=((o=o+Math.imul(m,me)|0)+(i>>>13)|0)+(Ce>>>26)|0,Ce&=67108863,r=Math.imul(B,V),i=(i=Math.imul(B,Y))+Math.imul(z,V)|0,o=Math.imul(z,Y),r=r+Math.imul(N,Z)|0,i=(i=i+Math.imul(N,Q)|0)+Math.imul(D,Z)|0,o=o+Math.imul(D,Q)|0,r=r+Math.imul(L,X)|0,i=(i=i+Math.imul(L,ee)|0)+Math.imul(I,X)|0,o=o+Math.imul(I,ee)|0,r=r+Math.imul(R,ne)|0,i=(i=i+Math.imul(R,re)|0)+Math.imul(T,ne)|0,o=o+Math.imul(T,re)|0,r=r+Math.imul(C,oe)|0,i=(i=i+Math.imul(C,ae)|0)+Math.imul(x,oe)|0,o=o+Math.imul(x,ae)|0,r=r+Math.imul(E,ue)|0,i=(i=i+Math.imul(E,le)|0)+Math.imul(k,ue)|0,o=o+Math.imul(k,le)|0,r=r+Math.imul(w,de)|0,i=(i=i+Math.imul(w,fe)|0)+Math.imul(_,de)|0,o=o+Math.imul(_,fe)|0;var xe=(l+(r=r+Math.imul(v,pe)|0)|0)+((8191&(i=(i=i+Math.imul(v,me)|0)+Math.imul(b,pe)|0))<<13)|0;l=((o=o+Math.imul(b,me)|0)+(i>>>13)|0)+(xe>>>26)|0,xe&=67108863,r=Math.imul(B,Z),i=(i=Math.imul(B,Q))+Math.imul(z,Z)|0,o=Math.imul(z,Q),r=r+Math.imul(N,X)|0,i=(i=i+Math.imul(N,ee)|0)+Math.imul(D,X)|0,o=o+Math.imul(D,ee)|0,r=r+Math.imul(L,ne)|0,i=(i=i+Math.imul(L,re)|0)+Math.imul(I,ne)|0,o=o+Math.imul(I,re)|0,r=r+Math.imul(R,oe)|0,i=(i=i+Math.imul(R,ae)|0)+Math.imul(T,oe)|0,o=o+Math.imul(T,ae)|0,r=r+Math.imul(C,ue)|0,i=(i=i+Math.imul(C,le)|0)+Math.imul(x,ue)|0,o=o+Math.imul(x,le)|0,r=r+Math.imul(E,de)|0,i=(i=i+Math.imul(E,fe)|0)+Math.imul(k,de)|0,o=o+Math.imul(k,fe)|0;var Ae=(l+(r=r+Math.imul(w,pe)|0)|0)+((8191&(i=(i=i+Math.imul(w,me)|0)+Math.imul(_,pe)|0))<<13)|0;l=((o=o+Math.imul(_,me)|0)+(i>>>13)|0)+(Ae>>>26)|0,Ae&=67108863,r=Math.imul(B,X),i=(i=Math.imul(B,ee))+Math.imul(z,X)|0,o=Math.imul(z,ee),r=r+Math.imul(N,ne)|0,i=(i=i+Math.imul(N,re)|0)+Math.imul(D,ne)|0,o=o+Math.imul(D,re)|0,r=r+Math.imul(L,oe)|0,i=(i=i+Math.imul(L,ae)|0)+Math.imul(I,oe)|0,o=o+Math.imul(I,ae)|0,r=r+Math.imul(R,ue)|0,i=(i=i+Math.imul(R,le)|0)+Math.imul(T,ue)|0,o=o+Math.imul(T,le)|0,r=r+Math.imul(C,de)|0,i=(i=i+Math.imul(C,fe)|0)+Math.imul(x,de)|0,o=o+Math.imul(x,fe)|0;var Re=(l+(r=r+Math.imul(E,pe)|0)|0)+((8191&(i=(i=i+Math.imul(E,me)|0)+Math.imul(k,pe)|0))<<13)|0;l=((o=o+Math.imul(k,me)|0)+(i>>>13)|0)+(Re>>>26)|0,Re&=67108863,r=Math.imul(B,ne),i=(i=Math.imul(B,re))+Math.imul(z,ne)|0,o=Math.imul(z,re),r=r+Math.imul(N,oe)|0,i=(i=i+Math.imul(N,ae)|0)+Math.imul(D,oe)|0,o=o+Math.imul(D,ae)|0,r=r+Math.imul(L,ue)|0,i=(i=i+Math.imul(L,le)|0)+Math.imul(I,ue)|0,o=o+Math.imul(I,le)|0,r=r+Math.imul(R,de)|0,i=(i=i+Math.imul(R,fe)|0)+Math.imul(T,de)|0,o=o+Math.imul(T,fe)|0;var Te=(l+(r=r+Math.imul(C,pe)|0)|0)+((8191&(i=(i=i+Math.imul(C,me)|0)+Math.imul(x,pe)|0))<<13)|0;l=((o=o+Math.imul(x,me)|0)+(i>>>13)|0)+(Te>>>26)|0,Te&=67108863,r=Math.imul(B,oe),i=(i=Math.imul(B,ae))+Math.imul(z,oe)|0,o=Math.imul(z,ae),r=r+Math.imul(N,ue)|0,i=(i=i+Math.imul(N,le)|0)+Math.imul(D,ue)|0,o=o+Math.imul(D,le)|0,r=r+Math.imul(L,de)|0,i=(i=i+Math.imul(L,fe)|0)+Math.imul(I,de)|0,o=o+Math.imul(I,fe)|0;var Pe=(l+(r=r+Math.imul(R,pe)|0)|0)+((8191&(i=(i=i+Math.imul(R,me)|0)+Math.imul(T,pe)|0))<<13)|0;l=((o=o+Math.imul(T,me)|0)+(i>>>13)|0)+(Pe>>>26)|0,Pe&=67108863,r=Math.imul(B,ue),i=(i=Math.imul(B,le))+Math.imul(z,ue)|0,o=Math.imul(z,le),r=r+Math.imul(N,de)|0,i=(i=i+Math.imul(N,fe)|0)+Math.imul(D,de)|0,o=o+Math.imul(D,fe)|0;var Le=(l+(r=r+Math.imul(L,pe)|0)|0)+((8191&(i=(i=i+Math.imul(L,me)|0)+Math.imul(I,pe)|0))<<13)|0;l=((o=o+Math.imul(I,me)|0)+(i>>>13)|0)+(Le>>>26)|0,Le&=67108863,r=Math.imul(B,de),i=(i=Math.imul(B,fe))+Math.imul(z,de)|0,o=Math.imul(z,fe);var Ie=(l+(r=r+Math.imul(N,pe)|0)|0)+((8191&(i=(i=i+Math.imul(N,me)|0)+Math.imul(D,pe)|0))<<13)|0;l=((o=o+Math.imul(D,me)|0)+(i>>>13)|0)+(Ie>>>26)|0,Ie&=67108863;var Oe=(l+(r=Math.imul(B,pe))|0)+((8191&(i=(i=Math.imul(B,me))+Math.imul(z,pe)|0))<<13)|0;return l=((o=Math.imul(z,me))+(i>>>13)|0)+(Oe>>>26)|0,Oe&=67108863,u[0]=ge,u[1]=ve,u[2]=be,u[3]=ye,u[4]=we,u[5]=_e,u[6]=Se,u[7]=Ee,u[8]=ke,u[9]=Me,u[10]=Ce,u[11]=xe,u[12]=Ae,u[13]=Re,u[14]=Te,u[15]=Pe,u[16]=Le,u[17]=Ie,u[18]=Oe,0!==l&&(u[19]=l,n.length++),n};function g(e,t,n){n.negative=t.negative^e.negative,n.length=e.length+t.length;for(var r=0,i=0,o=0;o<n.length-1;o++){var a=i;i=0;for(var s=67108863&r,u=Math.min(o,t.length-1),l=Math.max(0,o-e.length+1);l<=u;l++){var c=o-l,d=(0|e.words[c])*(0|t.words[l]),f=67108863&d;s=67108863&(f=f+s|0),i+=(a=(a=a+(d/67108864|0)|0)+(f>>>26)|0)>>>26,a&=67108863;}n.words[o]=s,r=a,a=i;}return 0!==r?n.words[o]=r:n.length--,n._strip()}function v(e,t,n){return g(e,t,n)}Math.imul||(m=p),i.prototype.mulTo=function(e,t){var n=this.length+e.length;return 10===this.length&&10===e.length?m(this,e,t):n<63?p(this,e,t):n<1024?g(this,e,t):v(this,e,t)},i.prototype.mul=function(e){var t=new i(null);return t.words=new Array(this.length+e.length),this.mulTo(e,t)},i.prototype.mulf=function(e){var t=new i(null);return t.words=new Array(this.length+e.length),v(this,e,t)},i.prototype.imul=function(e){return this.clone().mulTo(e,this)},i.prototype.imuln=function(e){var t=e<0;t&&(e=-e),n("number"==typeof e),n(e<67108864);for(var r=0,i=0;i<this.length;i++){var o=(0|this.words[i])*e,a=(67108863&o)+(67108863&r);r>>=26,r+=o/67108864|0,r+=a>>>26,this.words[i]=67108863&a;}return 0!==r&&(this.words[i]=r,this.length++),t?this.ineg():this},i.prototype.muln=function(e){return this.clone().imuln(e)},i.prototype.sqr=function(){return this.mul(this)},i.prototype.isqr=function(){return this.imul(this.clone())},i.prototype.pow=function(e){var t=function(e){for(var t=new Array(e.bitLength()),n=0;n<t.length;n++){var r=n/26|0,i=n%26;t[n]=e.words[r]>>>i&1;}return t}(e);if(0===t.length)return new i(1);for(var n=this,r=0;r<t.length&&0===t[r];r++,n=n.sqr());if(++r<t.length)for(var o=n.sqr();r<t.length;r++,o=o.sqr())0!==t[r]&&(n=n.mul(o));return n},i.prototype.iushln=function(e){n("number"==typeof e&&e>=0);var t,r=e%26,i=(e-r)/26,o=67108863>>>26-r<<26-r;if(0!==r){var a=0;for(t=0;t<this.length;t++){var s=this.words[t]&o,u=(0|this.words[t])-s<<r;this.words[t]=u|a,a=s>>>26-r;}a&&(this.words[t]=a,this.length++);}if(0!==i){for(t=this.length-1;t>=0;t--)this.words[t+i]=this.words[t];for(t=0;t<i;t++)this.words[t]=0;this.length+=i;}return this._strip()},i.prototype.ishln=function(e){return n(0===this.negative),this.iushln(e)},i.prototype.iushrn=function(e,t,r){var i;n("number"==typeof e&&e>=0),i=t?(t-t%26)/26:0;var o=e%26,a=Math.min((e-o)/26,this.length),s=67108863^67108863>>>o<<o,u=r;if(i-=a,i=Math.max(0,i),u){for(var l=0;l<a;l++)u.words[l]=this.words[l];u.length=a;}if(0===a);else if(this.length>a)for(this.length-=a,l=0;l<this.length;l++)this.words[l]=this.words[l+a];else this.words[0]=0,this.length=1;var c=0;for(l=this.length-1;l>=0&&(0!==c||l>=i);l--){var d=0|this.words[l];this.words[l]=c<<26-o|d>>>o,c=d&s;}return u&&0!==c&&(u.words[u.length++]=c),0===this.length&&(this.words[0]=0,this.length=1),this._strip()},i.prototype.ishrn=function(e,t,r){return n(0===this.negative),this.iushrn(e,t,r)},i.prototype.shln=function(e){return this.clone().ishln(e)},i.prototype.ushln=function(e){return this.clone().iushln(e)},i.prototype.shrn=function(e){return this.clone().ishrn(e)},i.prototype.ushrn=function(e){return this.clone().iushrn(e)},i.prototype.testn=function(e){n("number"==typeof e&&e>=0);var t=e%26,r=(e-t)/26,i=1<<t;return !(this.length<=r)&&!!(this.words[r]&i)},i.prototype.imaskn=function(e){n("number"==typeof e&&e>=0);var t=e%26,r=(e-t)/26;if(n(0===this.negative,"imaskn works only with positive numbers"),this.length<=r)return this;if(0!==t&&r++,this.length=Math.min(r,this.length),0!==t){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i;}return this._strip()},i.prototype.maskn=function(e){return this.clone().imaskn(e)},i.prototype.iaddn=function(e){return n("number"==typeof e),n(e<67108864),e<0?this.isubn(-e):0!==this.negative?1===this.length&&(0|this.words[0])<=e?(this.words[0]=e-(0|this.words[0]),this.negative=0,this):(this.negative=0,this.isubn(e),this.negative=1,this):this._iaddn(e)},i.prototype._iaddn=function(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++)this.words[t]-=67108864,t===this.length-1?this.words[t+1]=1:this.words[t+1]++;return this.length=Math.max(this.length,t+1),this},i.prototype.isubn=function(e){if(n("number"==typeof e),n(e<67108864),e<0)return this.iaddn(-e);if(0!==this.negative)return this.negative=0,this.iaddn(e),this.negative=1,this;if(this.words[0]-=e,1===this.length&&this.words[0]<0)this.words[0]=-this.words[0],this.negative=1;else for(var t=0;t<this.length&&this.words[t]<0;t++)this.words[t]+=67108864,this.words[t+1]-=1;return this._strip()},i.prototype.addn=function(e){return this.clone().iaddn(e)},i.prototype.subn=function(e){return this.clone().isubn(e)},i.prototype.iabs=function(){return this.negative=0,this},i.prototype.abs=function(){return this.clone().iabs()},i.prototype._ishlnsubmul=function(e,t,r){var i,o,a=e.length+r;this._expand(a);var s=0;for(i=0;i<e.length;i++){o=(0|this.words[i+r])+s;var u=(0|e.words[i])*t;s=((o-=67108863&u)>>26)-(u/67108864|0),this.words[i+r]=67108863&o;}for(;i<this.length-r;i++)s=(o=(0|this.words[i+r])+s)>>26,this.words[i+r]=67108863&o;if(0===s)return this._strip();for(n(-1===s),s=0,i=0;i<this.length;i++)s=(o=-(0|this.words[i])+s)>>26,this.words[i]=67108863&o;return this.negative=1,this._strip()},i.prototype._wordDiv=function(e,t){var n=(this.length,e.length),r=this.clone(),o=e,a=0|o.words[o.length-1];0!==(n=26-this._countBits(a))&&(o=o.ushln(n),r.iushln(n),a=0|o.words[o.length-1]);var s,u=r.length-o.length;if("mod"!==t){(s=new i(null)).length=u+1,s.words=new Array(s.length);for(var l=0;l<s.length;l++)s.words[l]=0;}var c=r.clone()._ishlnsubmul(o,1,u);0===c.negative&&(r=c,s&&(s.words[u]=1));for(var d=u-1;d>=0;d--){var f=67108864*(0|r.words[o.length+d])+(0|r.words[o.length+d-1]);for(f=Math.min(f/a|0,67108863),r._ishlnsubmul(o,f,d);0!==r.negative;)f--,r.negative=0,r._ishlnsubmul(o,1,d),r.isZero()||(r.negative^=1);s&&(s.words[d]=f);}return s&&s._strip(),r._strip(),"div"!==t&&0!==n&&r.iushrn(n),{div:s||null,mod:r}},i.prototype.divmod=function(e,t,r){return n(!e.isZero()),this.isZero()?{div:new i(0),mod:new i(0)}:0!==this.negative&&0===e.negative?(s=this.neg().divmod(e,t),"mod"!==t&&(o=s.div.neg()),"div"!==t&&(a=s.mod.neg(),r&&0!==a.negative&&a.iadd(e)),{div:o,mod:a}):0===this.negative&&0!==e.negative?(s=this.divmod(e.neg(),t),"mod"!==t&&(o=s.div.neg()),{div:o,mod:s.mod}):0!=(this.negative&e.negative)?(s=this.neg().divmod(e.neg(),t),"div"!==t&&(a=s.mod.neg(),r&&0!==a.negative&&a.isub(e)),{div:s.div,mod:a}):e.length>this.length||this.cmp(e)<0?{div:new i(0),mod:this}:1===e.length?"div"===t?{div:this.divn(e.words[0]),mod:null}:"mod"===t?{div:null,mod:new i(this.modrn(e.words[0]))}:{div:this.divn(e.words[0]),mod:new i(this.modrn(e.words[0]))}:this._wordDiv(e,t);var o,a,s;},i.prototype.div=function(e){return this.divmod(e,"div",false).div},i.prototype.mod=function(e){return this.divmod(e,"mod",false).mod},i.prototype.umod=function(e){return this.divmod(e,"mod",true).mod},i.prototype.divRound=function(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var n=0!==t.div.negative?t.mod.isub(e):t.mod,r=e.ushrn(1),i=e.andln(1),o=n.cmp(r);return o<0||1===i&&0===o?t.div:0!==t.div.negative?t.div.isubn(1):t.div.iaddn(1)},i.prototype.modrn=function(e){var t=e<0;t&&(e=-e),n(e<=67108863);for(var r=(1<<26)%e,i=0,o=this.length-1;o>=0;o--)i=(r*i+(0|this.words[o]))%e;return t?-i:i},i.prototype.modn=function(e){return this.modrn(e)},i.prototype.idivn=function(e){var t=e<0;t&&(e=-e),n(e<=67108863);for(var r=0,i=this.length-1;i>=0;i--){var o=(0|this.words[i])+67108864*r;this.words[i]=o/e|0,r=o%e;}return this._strip(),t?this.ineg():this},i.prototype.divn=function(e){return this.clone().idivn(e)},i.prototype.egcd=function(e){n(0===e.negative),n(!e.isZero());var t=this,r=e.clone();t=0!==t.negative?t.umod(e):t.clone();for(var o=new i(1),a=new i(0),s=new i(0),u=new i(1),l=0;t.isEven()&&r.isEven();)t.iushrn(1),r.iushrn(1),++l;for(var c=r.clone(),d=t.clone();!t.isZero();){for(var f=0,h=1;0==(t.words[0]&h)&&f<26;++f,h<<=1);if(f>0)for(t.iushrn(f);f-- >0;)(o.isOdd()||a.isOdd())&&(o.iadd(c),a.isub(d)),o.iushrn(1),a.iushrn(1);for(var p=0,m=1;0==(r.words[0]&m)&&p<26;++p,m<<=1);if(p>0)for(r.iushrn(p);p-- >0;)(s.isOdd()||u.isOdd())&&(s.iadd(c),u.isub(d)),s.iushrn(1),u.iushrn(1);t.cmp(r)>=0?(t.isub(r),o.isub(s),a.isub(u)):(r.isub(t),s.isub(o),u.isub(a));}return {a:s,b:u,gcd:r.iushln(l)}},i.prototype._invmp=function(e){n(0===e.negative),n(!e.isZero());var t=this,r=e.clone();t=0!==t.negative?t.umod(e):t.clone();for(var o,a=new i(1),s=new i(0),u=r.clone();t.cmpn(1)>0&&r.cmpn(1)>0;){for(var l=0,c=1;0==(t.words[0]&c)&&l<26;++l,c<<=1);if(l>0)for(t.iushrn(l);l-- >0;)a.isOdd()&&a.iadd(u),a.iushrn(1);for(var d=0,f=1;0==(r.words[0]&f)&&d<26;++d,f<<=1);if(d>0)for(r.iushrn(d);d-- >0;)s.isOdd()&&s.iadd(u),s.iushrn(1);t.cmp(r)>=0?(t.isub(r),a.isub(s)):(r.isub(t),s.isub(a));}return (o=0===t.cmpn(1)?a:s).cmpn(0)<0&&o.iadd(e),o},i.prototype.gcd=function(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone(),n=e.clone();t.negative=0,n.negative=0;for(var r=0;t.isEven()&&n.isEven();r++)t.iushrn(1),n.iushrn(1);for(;;){for(;t.isEven();)t.iushrn(1);for(;n.isEven();)n.iushrn(1);var i=t.cmp(n);if(i<0){var o=t;t=n,n=o;}else if(0===i||0===n.cmpn(1))break;t.isub(n);}return n.iushln(r)},i.prototype.invm=function(e){return this.egcd(e).a.umod(e)},i.prototype.isEven=function(){return 0==(1&this.words[0])},i.prototype.isOdd=function(){return 1==(1&this.words[0])},i.prototype.andln=function(e){return this.words[0]&e},i.prototype.bincn=function(e){n("number"==typeof e);var t=e%26,r=(e-t)/26,i=1<<t;if(this.length<=r)return this._expand(r+1),this.words[r]|=i,this;for(var o=i,a=r;0!==o&&a<this.length;a++){var s=0|this.words[a];o=(s+=o)>>>26,s&=67108863,this.words[a]=s;}return 0!==o&&(this.words[a]=o,this.length++),this},i.prototype.isZero=function(){return 1===this.length&&0===this.words[0]},i.prototype.cmpn=function(e){var t,r=e<0;if(0!==this.negative&&!r)return  -1;if(0===this.negative&&r)return 1;if(this._strip(),this.length>1)t=1;else {r&&(e=-e),n(e<=67108863,"Number is too big");var i=0|this.words[0];t=i===e?0:i<e?-1:1;}return 0!==this.negative?0|-t:t},i.prototype.cmp=function(e){if(0!==this.negative&&0===e.negative)return  -1;if(0===this.negative&&0!==e.negative)return 1;var t=this.ucmp(e);return 0!==this.negative?0|-t:t},i.prototype.ucmp=function(e){if(this.length>e.length)return 1;if(this.length<e.length)return  -1;for(var t=0,n=this.length-1;n>=0;n--){var r=0|this.words[n],i=0|e.words[n];if(r!==i){r<i?t=-1:r>i&&(t=1);break}}return t},i.prototype.gtn=function(e){return 1===this.cmpn(e)},i.prototype.gt=function(e){return 1===this.cmp(e)},i.prototype.gten=function(e){return this.cmpn(e)>=0},i.prototype.gte=function(e){return this.cmp(e)>=0},i.prototype.ltn=function(e){return  -1===this.cmpn(e)},i.prototype.lt=function(e){return  -1===this.cmp(e)},i.prototype.lten=function(e){return this.cmpn(e)<=0},i.prototype.lte=function(e){return this.cmp(e)<=0},i.prototype.eqn=function(e){return 0===this.cmpn(e)},i.prototype.eq=function(e){return 0===this.cmp(e)},i.red=function(e){return new k(e)},i.prototype.toRed=function(e){return n(!this.red,"Already a number in reduction context"),n(0===this.negative,"red works only with positives"),e.convertTo(this)._forceRed(e)},i.prototype.fromRed=function(){return n(this.red,"fromRed works only with numbers in reduction context"),this.red.convertFrom(this)},i.prototype._forceRed=function(e){return this.red=e,this},i.prototype.forceRed=function(e){return n(!this.red,"Already a number in reduction context"),this._forceRed(e)},i.prototype.redAdd=function(e){return n(this.red,"redAdd works only with red numbers"),this.red.add(this,e)},i.prototype.redIAdd=function(e){return n(this.red,"redIAdd works only with red numbers"),this.red.iadd(this,e)},i.prototype.redSub=function(e){return n(this.red,"redSub works only with red numbers"),this.red.sub(this,e)},i.prototype.redISub=function(e){return n(this.red,"redISub works only with red numbers"),this.red.isub(this,e)},i.prototype.redShl=function(e){return n(this.red,"redShl works only with red numbers"),this.red.shl(this,e)},i.prototype.redMul=function(e){return n(this.red,"redMul works only with red numbers"),this.red._verify2(this,e),this.red.mul(this,e)},i.prototype.redIMul=function(e){return n(this.red,"redMul works only with red numbers"),this.red._verify2(this,e),this.red.imul(this,e)},i.prototype.redSqr=function(){return n(this.red,"redSqr works only with red numbers"),this.red._verify1(this),this.red.sqr(this)},i.prototype.redISqr=function(){return n(this.red,"redISqr works only with red numbers"),this.red._verify1(this),this.red.isqr(this)},i.prototype.redSqrt=function(){return n(this.red,"redSqrt works only with red numbers"),this.red._verify1(this),this.red.sqrt(this)},i.prototype.redInvm=function(){return n(this.red,"redInvm works only with red numbers"),this.red._verify1(this),this.red.invm(this)},i.prototype.redNeg=function(){return n(this.red,"redNeg works only with red numbers"),this.red._verify1(this),this.red.neg(this)},i.prototype.redPow=function(e){return n(this.red&&!e.red,"redPow(normalNum)"),this.red._verify1(this),this.red.pow(this,e)};var b={k256:null,p224:null,p192:null,p25519:null};function y(e,t){this.name=e,this.p=new i(t,16),this.n=this.p.bitLength(),this.k=new i(1).iushln(this.n).isub(this.p),this.tmp=this._tmp();}function w(){y.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");}function _(){y.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");}function S(){y.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");}function E(){y.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");}function k(e){if("string"==typeof e){var t=i._prime(e);this.m=t.p,this.prime=t;}else n(e.gtn(1),"modulus must be greater than 1"),this.m=e,this.prime=null;}function M(e){k.call(this,e),this.shift=this.m.bitLength(),this.shift%26!=0&&(this.shift+=26-this.shift%26),this.r=new i(1).iushln(this.shift),this.r2=this.imod(this.r.sqr()),this.rinv=this.r._invmp(this.m),this.minv=this.rinv.mul(this.r).isubn(1).div(this.m),this.minv=this.minv.umod(this.r),this.minv=this.r.sub(this.minv);}y.prototype._tmp=function(){var e=new i(null);return e.words=new Array(Math.ceil(this.n/13)),e},y.prototype.ireduce=function(e){var t,n=e;do{this.split(n,this.tmp),t=(n=(n=this.imulK(n)).iadd(this.tmp)).bitLength();}while(t>this.n);var r=t<this.n?-1:n.ucmp(this.p);return 0===r?(n.words[0]=0,n.length=1):r>0?n.isub(this.p):void 0!==n.strip?n.strip():n._strip(),n},y.prototype.split=function(e,t){e.iushrn(this.n,0,t);},y.prototype.imulK=function(e){return e.imul(this.k)},r(w,y),w.prototype.split=function(e,t){for(var n=4194303,r=Math.min(e.length,9),i=0;i<r;i++)t.words[i]=e.words[i];if(t.length=r,e.length<=9)return e.words[0]=0,void(e.length=1);var o=e.words[9];for(t.words[t.length++]=o&n,i=10;i<e.length;i++){var a=0|e.words[i];e.words[i-10]=(a&n)<<4|o>>>22,o=a;}o>>>=22,e.words[i-10]=o,0===o&&e.length>10?e.length-=10:e.length-=9;},w.prototype.imulK=function(e){e.words[e.length]=0,e.words[e.length+1]=0,e.length+=2;for(var t=0,n=0;n<e.length;n++){var r=0|e.words[n];t+=977*r,e.words[n]=67108863&t,t=64*r+(t/67108864|0);}return 0===e.words[e.length-1]&&(e.length--,0===e.words[e.length-1]&&e.length--),e},r(_,y),r(S,y),r(E,y),E.prototype.imulK=function(e){for(var t=0,n=0;n<e.length;n++){var r=19*(0|e.words[n])+t,i=67108863&r;r>>>=26,e.words[n]=i,t=r;}return 0!==t&&(e.words[e.length++]=t),e},i._prime=function(e){if(b[e])return b[e];var t;if("k256"===e)t=new w;else if("p224"===e)t=new _;else if("p192"===e)t=new S;else {if("p25519"!==e)throw new Error("Unknown prime "+e);t=new E;}return b[e]=t,t},k.prototype._verify1=function(e){n(0===e.negative,"red works only with positives"),n(e.red,"red works only with red numbers");},k.prototype._verify2=function(e,t){n(0==(e.negative|t.negative),"red works only with positives"),n(e.red&&e.red===t.red,"red works only with red numbers");},k.prototype.imod=function(e){return this.prime?this.prime.ireduce(e)._forceRed(this):(l(e,e.umod(this.m)._forceRed(this)),e)},k.prototype.neg=function(e){return e.isZero()?e.clone():this.m.sub(e)._forceRed(this)},k.prototype.add=function(e,t){this._verify2(e,t);var n=e.add(t);return n.cmp(this.m)>=0&&n.isub(this.m),n._forceRed(this)},k.prototype.iadd=function(e,t){this._verify2(e,t);var n=e.iadd(t);return n.cmp(this.m)>=0&&n.isub(this.m),n},k.prototype.sub=function(e,t){this._verify2(e,t);var n=e.sub(t);return n.cmpn(0)<0&&n.iadd(this.m),n._forceRed(this)},k.prototype.isub=function(e,t){this._verify2(e,t);var n=e.isub(t);return n.cmpn(0)<0&&n.iadd(this.m),n},k.prototype.shl=function(e,t){return this._verify1(e),this.imod(e.ushln(t))},k.prototype.imul=function(e,t){return this._verify2(e,t),this.imod(e.imul(t))},k.prototype.mul=function(e,t){return this._verify2(e,t),this.imod(e.mul(t))},k.prototype.isqr=function(e){return this.imul(e,e.clone())},k.prototype.sqr=function(e){return this.mul(e,e)},k.prototype.sqrt=function(e){if(e.isZero())return e.clone();var t=this.m.andln(3);if(n(t%2==1),3===t){var r=this.m.add(new i(1)).iushrn(2);return this.pow(e,r)}for(var o=this.m.subn(1),a=0;!o.isZero()&&0===o.andln(1);)a++,o.iushrn(1);n(!o.isZero());var s=new i(1).toRed(this),u=s.redNeg(),l=this.m.subn(1).iushrn(1),c=this.m.bitLength();for(c=new i(2*c*c).toRed(this);0!==this.pow(c,l).cmp(u);)c.redIAdd(u);for(var d=this.pow(c,o),f=this.pow(e,o.addn(1).iushrn(1)),h=this.pow(e,o),p=a;0!==h.cmp(s);){for(var m=h,g=0;0!==m.cmp(s);g++)m=m.redSqr();n(g<p);var v=this.pow(d,new i(1).iushln(p-g-1));f=f.redMul(v),d=v.redSqr(),h=h.redMul(d),p=g;}return f},k.prototype.invm=function(e){var t=e._invmp(this.m);return 0!==t.negative?(t.negative=0,this.imod(t).redNeg()):this.imod(t)},k.prototype.pow=function(e,t){if(t.isZero())return new i(1).toRed(this);if(0===t.cmpn(1))return e.clone();var n=new Array(16);n[0]=new i(1).toRed(this),n[1]=e;for(var r=2;r<n.length;r++)n[r]=this.mul(n[r-1],e);var o=n[0],a=0,s=0,u=t.bitLength()%26;for(0===u&&(u=26),r=t.length-1;r>=0;r--){for(var l=t.words[r],c=u-1;c>=0;c--){var d=l>>c&1;o!==n[0]&&(o=this.sqr(o)),0!==d||0!==a?(a<<=1,a|=d,(4===++s||0===r&&0===c)&&(o=this.mul(o,n[a]),s=0,a=0)):s=0;}u=26;}return o},k.prototype.convertTo=function(e){var t=e.umod(this.m);return t===e?t.clone():t},k.prototype.convertFrom=function(e){var t=e.clone();return t.red=null,t},i.mont=function(e){return new M(e)},r(M,k),M.prototype.convertTo=function(e){return this.imod(e.ushln(this.shift))},M.prototype.convertFrom=function(e){var t=this.imod(e.mul(this.rinv));return t.red=null,t},M.prototype.imul=function(e,t){if(e.isZero()||t.isZero())return e.words[0]=0,e.length=1,e;var n=e.imul(t),r=n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),i=n.isub(r).iushrn(this.shift),o=i;return i.cmp(this.m)>=0?o=i.isub(this.m):i.cmpn(0)<0&&(o=i.iadd(this.m)),o._forceRed(this)},M.prototype.mul=function(e,t){if(e.isZero()||t.isZero())return new i(0)._forceRed(this);var n=e.mul(t),r=n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),o=n.isub(r).iushrn(this.shift),a=o;return o.cmp(this.m)>=0?a=o.isub(this.m):o.cmpn(0)<0&&(a=o.iadd(this.m)),a._forceRed(this)},M.prototype.invm=function(e){return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this)};}(e,n);}(th);var nh,rh=th.exports,ih={},oh={},ah={},sh={},uh=ce,lh=uh.Buffer,ch={};for(nh in uh)uh.hasOwnProperty(nh)&&"SlowBuffer"!==nh&&"Buffer"!==nh&&(ch[nh]=uh[nh]);var dh=ch.Buffer={};for(nh in lh)lh.hasOwnProperty(nh)&&"allocUnsafe"!==nh&&"allocUnsafeSlow"!==nh&&(dh[nh]=lh[nh]);if(ch.Buffer.prototype=lh.prototype,dh.from&&dh.from!==Uint8Array.from||(dh.from=function(e,t,n){if("number"==typeof e)throw new TypeError('The "value" argument must not be of type number. Received type '+typeof e);if(e&&void 0===e.length)throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type "+typeof e);return lh(e,t,n)}),dh.alloc||(dh.alloc=function(e,t,n){if("number"!=typeof e)throw new TypeError('The "size" argument must be of type number. Received type '+typeof e);if(e<0||e>=2*(1<<30))throw new RangeError('The value "'+e+'" is invalid for option "size"');var r=lh(e);return t&&0!==t.length?"string"==typeof n?r.fill(t,n):r.fill(t):r.fill(0),r}),!ch.kStringMaxLength)try{ch.kStringMaxLength=je.binding("buffer").kStringMaxLength;}catch(a){}ch.constants||(ch.constants={MAX_LENGTH:ch.kMaxLength},ch.kStringMaxLength&&(ch.constants.MAX_STRING_LENGTH=ch.kStringMaxLength));var fh=ch,hh={};const ph=Ve;function mh(e){this._reporterState={obj:null,path:[],options:e||{},errors:[]};}function gh(e,t){this.path=e,this.rethrow(t);}hh.Reporter=mh,mh.prototype.isError=function(e){return e instanceof gh},mh.prototype.save=function(){const e=this._reporterState;return {obj:e.obj,pathLen:e.path.length}},mh.prototype.restore=function(e){const t=this._reporterState;t.obj=e.obj,t.path=t.path.slice(0,e.pathLen);},mh.prototype.enterKey=function(e){return this._reporterState.path.push(e)},mh.prototype.exitKey=function(e){const t=this._reporterState;t.path=t.path.slice(0,e-1);},mh.prototype.leaveKey=function(e,t,n){const r=this._reporterState;this.exitKey(e),null!==r.obj&&(r.obj[t]=n);},mh.prototype.path=function(){return this._reporterState.path.join("/")},mh.prototype.enterObject=function(){const e=this._reporterState,t=e.obj;return e.obj={},t},mh.prototype.leaveObject=function(e){const t=this._reporterState,n=t.obj;return t.obj=e,n},mh.prototype.error=function(e){let t;const n=this._reporterState,r=e instanceof gh;if(t=r?e:new gh(n.path.map((function(e){return "["+JSON.stringify(e)+"]"})).join(""),e.message||e,e.stack),!n.options.partial)throw t;return r||n.errors.push(t),t},mh.prototype.wrapResult=function(e){const t=this._reporterState;return t.options.partial?{result:this.isError(e)?null:e,errors:t.errors}:e},ph(gh,Error),gh.prototype.rethrow=function(e){if(this.message=e+" at: "+(this.path||"(shallow)"),Error.captureStackTrace&&Error.captureStackTrace(this,gh),!this.stack)try{throw new Error(this.message)}catch(e){this.stack=e.stack;}return this};var vh={};const bh=Ve,yh=hh.Reporter,wh=fh.Buffer;function _h(e,t){yh.call(this,t),wh.isBuffer(e)?(this.base=e,this.offset=0,this.length=e.length):this.error("Input not Buffer");}function Sh(e,t){if(Array.isArray(e))this.length=0,this.value=e.map((function(e){return Sh.isEncoderBuffer(e)||(e=new Sh(e,t)),this.length+=e.length,e}),this);else if("number"==typeof e){if(!(0<=e&&e<=255))return t.error("non-byte EncoderBuffer value");this.value=e,this.length=1;}else if("string"==typeof e)this.value=e,this.length=wh.byteLength(e);else {if(!wh.isBuffer(e))return t.error("Unsupported type: "+typeof e);this.value=e,this.length=e.length;}}bh(_h,yh),vh.DecoderBuffer=_h,_h.isDecoderBuffer=function(e){if(e instanceof _h)return  true;return "object"==typeof e&&wh.isBuffer(e.base)&&"DecoderBuffer"===e.constructor.name&&"number"==typeof e.offset&&"number"==typeof e.length&&"function"==typeof e.save&&"function"==typeof e.restore&&"function"==typeof e.isEmpty&&"function"==typeof e.readUInt8&&"function"==typeof e.skip&&"function"==typeof e.raw},_h.prototype.save=function(){return {offset:this.offset,reporter:yh.prototype.save.call(this)}},_h.prototype.restore=function(e){const t=new _h(this.base);return t.offset=e.offset,t.length=this.offset,this.offset=e.offset,yh.prototype.restore.call(this,e.reporter),t},_h.prototype.isEmpty=function(){return this.offset===this.length},_h.prototype.readUInt8=function(e){return this.offset+1<=this.length?this.base.readUInt8(this.offset++,true):this.error(e||"DecoderBuffer overrun")},_h.prototype.skip=function(e,t){if(!(this.offset+e<=this.length))return this.error(t||"DecoderBuffer overrun");const n=new _h(this.base);return n._reporterState=this._reporterState,n.offset=this.offset,n.length=this.offset+e,this.offset+=e,n},_h.prototype.raw=function(e){return this.base.slice(e?e.offset:this.offset,this.length)},vh.EncoderBuffer=Sh,Sh.isEncoderBuffer=function(e){if(e instanceof Sh)return  true;return "object"==typeof e&&"EncoderBuffer"===e.constructor.name&&"number"==typeof e.length&&"function"==typeof e.join},Sh.prototype.join=function(e,t){return e||(e=wh.alloc(this.length)),t||(t=0),0===this.length||(Array.isArray(this.value)?this.value.forEach((function(n){n.join(e,t),t+=n.length;})):("number"==typeof this.value?e[t]=this.value:"string"==typeof this.value?e.write(this.value,t):wh.isBuffer(this.value)&&this.value.copy(e,t),t+=this.length)),e};const Eh=hh.Reporter,kh=vh.EncoderBuffer,Mh=vh.DecoderBuffer,Ch=Wa,xh=["seq","seqof","set","setof","objid","bool","gentime","utctime","null_","enum","int","objDesc","bitstr","bmpstr","charstr","genstr","graphstr","ia5str","iso646str","numstr","octstr","printstr","t61str","unistr","utf8str","videostr"],Ah=["key","obj","use","optional","explicit","implicit","def","choice","any","contains"].concat(xh);function Rh(e,t,n){const r={};this._baseState=r,r.name=n,r.enc=e,r.parent=t||null,r.children=null,r.tag=null,r.args=null,r.reverseArgs=null,r.choice=null,r.optional=false,r.any=false,r.obj=false,r.use=null,r.useDecoder=null,r.key=null,r.default=null,r.explicit=null,r.implicit=null,r.contains=null,r.parent||(r.children=[],this._wrap());}var Th=Rh;const Ph=["enc","parent","children","tag","args","reverseArgs","choice","optional","any","obj","use","alteredUse","key","default","explicit","implicit","contains"];Rh.prototype.clone=function(){const e=this._baseState,t={};Ph.forEach((function(n){t[n]=e[n];}));const n=new this.constructor(t.parent);return n._baseState=t,n},Rh.prototype._wrap=function(){const e=this._baseState;Ah.forEach((function(t){this[t]=function(){const n=new this.constructor(this);return e.children.push(n),n[t].apply(n,arguments)};}),this);},Rh.prototype._init=function(e){const t=this._baseState;Ch(null===t.parent),e.call(this),t.children=t.children.filter((function(e){return e._baseState.parent===this}),this),Ch.equal(t.children.length,1,"Root node can have only one child");},Rh.prototype._useArgs=function(e){const t=this._baseState,n=e.filter((function(e){return e instanceof this.constructor}),this);e=e.filter((function(e){return !(e instanceof this.constructor)}),this),0!==n.length&&(Ch(null===t.children),t.children=n,n.forEach((function(e){e._baseState.parent=this;}),this)),0!==e.length&&(Ch(null===t.args),t.args=e,t.reverseArgs=e.map((function(e){if("object"!=typeof e||e.constructor!==Object)return e;const t={};return Object.keys(e).forEach((function(n){n==(0|n)&&(n|=0);const r=e[n];t[r]=n;})),t})));},["_peekTag","_decodeTag","_use","_decodeStr","_decodeObjid","_decodeTime","_decodeNull","_decodeInt","_decodeBool","_decodeList","_encodeComposite","_encodeStr","_encodeObjid","_encodeTime","_encodeNull","_encodeInt","_encodeBool"].forEach((function(e){Rh.prototype[e]=function(){const t=this._baseState;throw new Error(e+" not implemented for encoding: "+t.enc)};})),xh.forEach((function(e){Rh.prototype[e]=function(){const t=this._baseState,n=Array.prototype.slice.call(arguments);return Ch(null===t.tag),t.tag=e,this._useArgs(n),this};})),Rh.prototype.use=function(e){Ch(e);const t=this._baseState;return Ch(null===t.use),t.use=e,this},Rh.prototype.optional=function(){return this._baseState.optional=true,this},Rh.prototype.def=function(e){const t=this._baseState;return Ch(null===t.default),t.default=e,t.optional=true,this},Rh.prototype.explicit=function(e){const t=this._baseState;return Ch(null===t.explicit&&null===t.implicit),t.explicit=e,this},Rh.prototype.implicit=function(e){const t=this._baseState;return Ch(null===t.explicit&&null===t.implicit),t.implicit=e,this},Rh.prototype.obj=function(){const e=this._baseState,t=Array.prototype.slice.call(arguments);return e.obj=true,0!==t.length&&this._useArgs(t),this},Rh.prototype.key=function(e){const t=this._baseState;return Ch(null===t.key),t.key=e,this},Rh.prototype.any=function(){return this._baseState.any=true,this},Rh.prototype.choice=function(e){const t=this._baseState;return Ch(null===t.choice),t.choice=e,this._useArgs(Object.keys(e).map((function(t){return e[t]}))),this},Rh.prototype.contains=function(e){const t=this._baseState;return Ch(null===t.use),t.contains=e,this},Rh.prototype._decode=function(e,t){const n=this._baseState;if(null===n.parent)return e.wrapResult(n.children[0]._decode(e,t));let r,i=n.default,o=true,a=null;if(null!==n.key&&(a=e.enterKey(n.key)),n.optional){let r=null;if(null!==n.explicit?r=n.explicit:null!==n.implicit?r=n.implicit:null!==n.tag&&(r=n.tag),null!==r||n.any){if(o=this._peekTag(e,r,n.any),e.isError(o))return o}else {const r=e.save();try{null===n.choice?this._decodeGeneric(n.tag,e,t):this._decodeChoice(e,t),o=!0;}catch(e){o=false;}e.restore(r);}}if(n.obj&&o&&(r=e.enterObject()),o){if(null!==n.explicit){const t=this._decodeTag(e,n.explicit);if(e.isError(t))return t;e=t;}const r=e.offset;if(null===n.use&&null===n.choice){let t;n.any&&(t=e.save());const r=this._decodeTag(e,null!==n.implicit?n.implicit:n.tag,n.any);if(e.isError(r))return r;n.any?i=e.raw(t):e=r;}if(t&&t.track&&null!==n.tag&&t.track(e.path(),r,e.length,"tagged"),t&&t.track&&null!==n.tag&&t.track(e.path(),e.offset,e.length,"content"),n.any||(i=null===n.choice?this._decodeGeneric(n.tag,e,t):this._decodeChoice(e,t)),e.isError(i))return i;if(n.any||null!==n.choice||null===n.children||n.children.forEach((function(n){n._decode(e,t);})),n.contains&&("octstr"===n.tag||"bitstr"===n.tag)){const r=new Mh(i);i=this._getUse(n.contains,e._reporterState.obj)._decode(r,t);}}return n.obj&&o&&(i=e.leaveObject(r)),null===n.key||null===i&&true!==o?null!==a&&e.exitKey(a):e.leaveKey(a,n.key,i),i},Rh.prototype._decodeGeneric=function(e,t,n){const r=this._baseState;return "seq"===e||"set"===e?null:"seqof"===e||"setof"===e?this._decodeList(t,e,r.args[0],n):/str$/.test(e)?this._decodeStr(t,e,n):"objid"===e&&r.args?this._decodeObjid(t,r.args[0],r.args[1],n):"objid"===e?this._decodeObjid(t,null,null,n):"gentime"===e||"utctime"===e?this._decodeTime(t,e,n):"null_"===e?this._decodeNull(t,n):"bool"===e?this._decodeBool(t,n):"objDesc"===e?this._decodeStr(t,e,n):"int"===e||"enum"===e?this._decodeInt(t,r.args&&r.args[0],n):null!==r.use?this._getUse(r.use,t._reporterState.obj)._decode(t,n):t.error("unknown tag: "+e)},Rh.prototype._getUse=function(e,t){const n=this._baseState;return n.useDecoder=this._use(e,t),Ch(null===n.useDecoder._baseState.parent),n.useDecoder=n.useDecoder._baseState.children[0],n.implicit!==n.useDecoder._baseState.implicit&&(n.useDecoder=n.useDecoder.clone(),n.useDecoder._baseState.implicit=n.implicit),n.useDecoder},Rh.prototype._decodeChoice=function(e,t){const n=this._baseState;let r=null,i=false;return Object.keys(n.choice).some((function(o){const a=e.save(),s=n.choice[o];try{const n=s._decode(e,t);if(e.isError(n))return !1;r={type:o,value:n},i=!0;}catch(t){return e.restore(a),false}return  true}),this),i?r:e.error("Choice not matched")},Rh.prototype._createEncoderBuffer=function(e){return new kh(e,this.reporter)},Rh.prototype._encode=function(e,t,n){const r=this._baseState;if(null!==r.default&&r.default===e)return;const i=this._encodeValue(e,t,n);return void 0===i||this._skipDefault(i,t,n)?void 0:i},Rh.prototype._encodeValue=function(e,t,n){const r=this._baseState;if(null===r.parent)return r.children[0]._encode(e,t||new Eh);let i=null;if(this.reporter=t,r.optional&&void 0===e){if(null===r.default)return;e=r.default;}let o=null,a=false;if(r.any)i=this._createEncoderBuffer(e);else if(r.choice)i=this._encodeChoice(e,t);else if(r.contains)o=this._getUse(r.contains,n)._encode(e,t),a=true;else if(r.children)o=r.children.map((function(n){if("null_"===n._baseState.tag)return n._encode(null,t,e);if(null===n._baseState.key)return t.error("Child should have a key");const r=t.enterKey(n._baseState.key);if("object"!=typeof e)return t.error("Child expected, but input is not object");const i=n._encode(e[n._baseState.key],t,e);return t.leaveKey(r),i}),this).filter((function(e){return e})),o=this._createEncoderBuffer(o);else if("seqof"===r.tag||"setof"===r.tag){if(!r.args||1!==r.args.length)return t.error("Too many args for : "+r.tag);if(!Array.isArray(e))return t.error("seqof/setof, but data is not Array");const n=this.clone();n._baseState.implicit=null,o=this._createEncoderBuffer(e.map((function(n){const r=this._baseState;return this._getUse(r.args[0],e)._encode(n,t)}),n));}else null!==r.use?i=this._getUse(r.use,n)._encode(e,t):(o=this._encodePrimitive(r.tag,e),a=true);if(!r.any&&null===r.choice){const e=null!==r.implicit?r.implicit:r.tag,n=null===r.implicit?"universal":"context";null===e?null===r.use&&t.error("Tag could be omitted only for .use()"):null===r.use&&(i=this._encodeComposite(e,a,n,o));}return null!==r.explicit&&(i=this._encodeComposite(r.explicit,false,"context",i)),i},Rh.prototype._encodeChoice=function(e,t){const n=this._baseState,r=n.choice[e.type];return r||Ch(false,e.type+" not found in "+JSON.stringify(Object.keys(n.choice))),r._encode(e.value,t)},Rh.prototype._encodePrimitive=function(e,t){const n=this._baseState;if(/str$/.test(e))return this._encodeStr(t,e);if("objid"===e&&n.args)return this._encodeObjid(t,n.reverseArgs[0],n.args[1]);if("objid"===e)return this._encodeObjid(t,null,null);if("gentime"===e||"utctime"===e)return this._encodeTime(t,e);if("null_"===e)return this._encodeNull();if("int"===e||"enum"===e)return this._encodeInt(t,n.args&&n.reverseArgs[0]);if("bool"===e)return this._encodeBool(t);if("objDesc"===e)return this._encodeStr(t,e);throw new Error("Unsupported tag: "+e)},Rh.prototype._isNumstr=function(e){return /^[0-9 ]*$/.test(e)},Rh.prototype._isPrintstr=function(e){return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(e)};var Lh={};!function(e){function t(e){const t={};return Object.keys(e).forEach((function(n){(0|n)==n&&(n|=0);const r=e[n];t[r]=n;})),t}e.tagClass={0:"universal",1:"application",2:"context",3:"private"},e.tagClassByName=t(e.tagClass),e.tag={0:"end",1:"bool",2:"int",3:"bitstr",4:"octstr",5:"null_",6:"objid",7:"objDesc",8:"external",9:"real",10:"enum",11:"embed",12:"utf8str",13:"relativeOid",16:"seq",17:"set",18:"numstr",19:"printstr",20:"t61str",21:"videostr",22:"ia5str",23:"utctime",24:"gentime",25:"graphstr",26:"iso646str",27:"genstr",28:"unistr",29:"charstr",30:"bmpstr"},e.tagByName=t(e.tag);}(Lh);const Ih=Ve,Oh=fh.Buffer,Nh=Th,Dh=Lh;function jh(e){this.enc="der",this.name=e.name,this.entity=e,this.tree=new zh,this.tree._init(e.body);}var Bh=jh;function zh(e){Nh.call(this,"der",e);}function Uh(e){return e<10?"0"+e:e}jh.prototype.encode=function(e,t){return this.tree._encode(e,t).join()},Ih(zh,Nh),zh.prototype._encodeComposite=function(e,t,n,r){const i=function(e,t,n,r){let i;"seqof"===e?e="seq":"setof"===e&&(e="set");if(Dh.tagByName.hasOwnProperty(e))i=Dh.tagByName[e];else {if("number"!=typeof e||(0|e)!==e)return r.error("Unknown tag: "+e);i=e;}if(i>=31)return r.error("Multi-octet tag encoding unsupported");t||(i|=32);return i|=Dh.tagClassByName[n||"universal"]<<6,i}(e,t,n,this.reporter);if(r.length<128){const e=Oh.alloc(2);return e[0]=i,e[1]=r.length,this._createEncoderBuffer([e,r])}let o=1;for(let e=r.length;e>=256;e>>=8)o++;const a=Oh.alloc(2+o);a[0]=i,a[1]=128|o;for(let e=1+o,t=r.length;t>0;e--,t>>=8)a[e]=255&t;return this._createEncoderBuffer([a,r])},zh.prototype._encodeStr=function(e,t){if("bitstr"===t)return this._createEncoderBuffer([0|e.unused,e.data]);if("bmpstr"===t){const t=Oh.alloc(2*e.length);for(let n=0;n<e.length;n++)t.writeUInt16BE(e.charCodeAt(n),2*n);return this._createEncoderBuffer(t)}return "numstr"===t?this._isNumstr(e)?this._createEncoderBuffer(e):this.reporter.error("Encoding of string type: numstr supports only digits and space"):"printstr"===t?this._isPrintstr(e)?this._createEncoderBuffer(e):this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark"):/str$/.test(t)||"objDesc"===t?this._createEncoderBuffer(e):this.reporter.error("Encoding of string type: "+t+" unsupported")},zh.prototype._encodeObjid=function(e,t,n){if("string"==typeof e){if(!t)return this.reporter.error("string objid given, but no values map found");if(!t.hasOwnProperty(e))return this.reporter.error("objid not found in values map");e=t[e].split(/[\s.]+/g);for(let t=0;t<e.length;t++)e[t]|=0;}else if(Array.isArray(e)){e=e.slice();for(let t=0;t<e.length;t++)e[t]|=0;}if(!Array.isArray(e))return this.reporter.error("objid() should be either array or string, got: "+JSON.stringify(e));if(!n){if(e[1]>=40)return this.reporter.error("Second objid identifier OOB");e.splice(0,2,40*e[0]+e[1]);}let r=0;for(let t=0;t<e.length;t++){let n=e[t];for(r++;n>=128;n>>=7)r++;}const i=Oh.alloc(r);let o=i.length-1;for(let t=e.length-1;t>=0;t--){let n=e[t];for(i[o--]=127&n;(n>>=7)>0;)i[o--]=128|127&n;}return this._createEncoderBuffer(i)},zh.prototype._encodeTime=function(e,t){let n;const r=new Date(e);return "gentime"===t?n=[Uh(r.getUTCFullYear()),Uh(r.getUTCMonth()+1),Uh(r.getUTCDate()),Uh(r.getUTCHours()),Uh(r.getUTCMinutes()),Uh(r.getUTCSeconds()),"Z"].join(""):"utctime"===t?n=[Uh(r.getUTCFullYear()%100),Uh(r.getUTCMonth()+1),Uh(r.getUTCDate()),Uh(r.getUTCHours()),Uh(r.getUTCMinutes()),Uh(r.getUTCSeconds()),"Z"].join(""):this.reporter.error("Encoding "+t+" time is not supported yet"),this._encodeStr(n,"octstr")},zh.prototype._encodeNull=function(){return this._createEncoderBuffer("")},zh.prototype._encodeInt=function(e,t){if("string"==typeof e){if(!t)return this.reporter.error("String int or enum given, but no values map");if(!t.hasOwnProperty(e))return this.reporter.error("Values map doesn't contain: "+JSON.stringify(e));e=t[e];}if("number"!=typeof e&&!Oh.isBuffer(e)){const t=e.toArray();!e.sign&&128&t[0]&&t.unshift(0),e=Oh.from(t);}if(Oh.isBuffer(e)){let t=e.length;0===e.length&&t++;const n=Oh.alloc(t);return e.copy(n),0===e.length&&(n[0]=0),this._createEncoderBuffer(n)}if(e<128)return this._createEncoderBuffer(e);if(e<256)return this._createEncoderBuffer([0,e]);let n=1;for(let t=e;t>=256;t>>=8)n++;const r=new Array(n);for(let t=r.length-1;t>=0;t--)r[t]=255&e,e>>=8;return 128&r[0]&&r.unshift(0),this._createEncoderBuffer(Oh.from(r))},zh.prototype._encodeBool=function(e){return this._createEncoderBuffer(e?255:0)},zh.prototype._use=function(e,t){return "function"==typeof e&&(e=e(t)),e._getEncoder("der").tree},zh.prototype._skipDefault=function(e,t,n){const r=this._baseState;let i;if(null===r.default)return  false;const o=e.join();if(void 0===r.defaultBuffer&&(r.defaultBuffer=this._encodeValue(r.default,t,n).join()),o.length!==r.defaultBuffer.length)return  false;for(i=0;i<o.length;i++)if(o[i]!==r.defaultBuffer[i])return  false;return  true};const Fh=Bh;function Kh(e){Fh.call(this,e),this.enc="pem";}Ve(Kh,Fh);var qh=Kh;Kh.prototype.encode=function(e,t){const n=Fh.prototype.encode.call(this,e).toString("base64"),r=["-----BEGIN "+t.label+"-----"];for(let e=0;e<n.length;e+=64)r.push(n.slice(e,e+64));return r.push("-----END "+t.label+"-----"),r.join("\n")},function(e){const t=e;t.der=Bh,t.pem=qh;}(sh);var Hh={};const Wh=Ve,$h=hl,Vh=vh.DecoderBuffer,Yh=Th,Gh=Lh;function Zh(e){this.enc="der",this.name=e.name,this.entity=e,this.tree=new Jh,this.tree._init(e.body);}var Qh=Zh;function Jh(e){Yh.call(this,"der",e);}function Xh(e,t){let n=e.readUInt8(t);if(e.isError(n))return n;const r=Gh.tagClass[n>>6],i=0==(32&n);if(31==(31&n)){let r=n;for(n=0;128==(128&r);){if(r=e.readUInt8(t),e.isError(r))return r;n<<=7,n|=127&r;}}else n&=31;return {cls:r,primitive:i,tag:n,tagStr:Gh.tag[n]}}function ep(e,t,n){let r=e.readUInt8(n);if(e.isError(r))return r;if(!t&&128===r)return null;if(0==(128&r))return r;const i=127&r;if(i>4)return e.error("length octect is too long");r=0;for(let t=0;t<i;t++){r<<=8;const t=e.readUInt8(n);if(e.isError(t))return t;r|=t;}return r}Zh.prototype.decode=function(e,t){return Vh.isDecoderBuffer(e)||(e=new Vh(e,t)),this.tree._decode(e,t)},Wh(Jh,Yh),Jh.prototype._peekTag=function(e,t,n){if(e.isEmpty())return  false;const r=e.save(),i=Xh(e,'Failed to peek tag: "'+t+'"');return e.isError(i)?i:(e.restore(r),i.tag===t||i.tagStr===t||i.tagStr+"of"===t||n)},Jh.prototype._decodeTag=function(e,t,n){const r=Xh(e,'Failed to decode tag of "'+t+'"');if(e.isError(r))return r;let i=ep(e,r.primitive,'Failed to get length of "'+t+'"');if(e.isError(i))return i;if(!n&&r.tag!==t&&r.tagStr!==t&&r.tagStr+"of"!==t)return e.error('Failed to match tag: "'+t+'"');if(r.primitive||null!==i)return e.skip(i,'Failed to match body of: "'+t+'"');const o=e.save(),a=this._skipUntilEnd(e,'Failed to skip indefinite length body: "'+this.tag+'"');return e.isError(a)?a:(i=e.offset-o.offset,e.restore(o),e.skip(i,'Failed to match body of: "'+t+'"'))},Jh.prototype._skipUntilEnd=function(e,t){for(;;){const n=Xh(e,t);if(e.isError(n))return n;const r=ep(e,n.primitive,t);if(e.isError(r))return r;let i;if(i=n.primitive||null!==r?e.skip(r):this._skipUntilEnd(e,t),e.isError(i))return i;if("end"===n.tagStr)break}},Jh.prototype._decodeList=function(e,t,n,r){const i=[];for(;!e.isEmpty();){const t=this._peekTag(e,"end");if(e.isError(t))return t;const o=n.decode(e,"der",r);if(e.isError(o)&&t)break;i.push(o);}return i},Jh.prototype._decodeStr=function(e,t){if("bitstr"===t){const t=e.readUInt8();return e.isError(t)?t:{unused:t,data:e.raw()}}if("bmpstr"===t){const t=e.raw();if(t.length%2==1)return e.error("Decoding of string type: bmpstr length mismatch");let n="";for(let e=0;e<t.length/2;e++)n+=String.fromCharCode(t.readUInt16BE(2*e));return n}if("numstr"===t){const t=e.raw().toString("ascii");return this._isNumstr(t)?t:e.error("Decoding of string type: numstr unsupported characters")}if("octstr"===t)return e.raw();if("objDesc"===t)return e.raw();if("printstr"===t){const t=e.raw().toString("ascii");return this._isPrintstr(t)?t:e.error("Decoding of string type: printstr unsupported characters")}return /str$/.test(t)?e.raw().toString():e.error("Decoding of string type: "+t+" unsupported")},Jh.prototype._decodeObjid=function(e,t,n){let r;const i=[];let o=0,a=0;for(;!e.isEmpty();)a=e.readUInt8(),o<<=7,o|=127&a,0==(128&a)&&(i.push(o),o=0);128&a&&i.push(o);const s=i[0]/40|0,u=i[0]%40;if(r=n?i:[s,u].concat(i.slice(1)),t){let e=t[r.join(" ")];void 0===e&&(e=t[r.join(".")]),void 0!==e&&(r=e);}return r},Jh.prototype._decodeTime=function(e,t){const n=e.raw().toString();let r,i,o,a,s,u;if("gentime"===t)r=0|n.slice(0,4),i=0|n.slice(4,6),o=0|n.slice(6,8),a=0|n.slice(8,10),s=0|n.slice(10,12),u=0|n.slice(12,14);else {if("utctime"!==t)return e.error("Decoding "+t+" time is not supported yet");r=0|n.slice(0,2),i=0|n.slice(2,4),o=0|n.slice(4,6),a=0|n.slice(6,8),s=0|n.slice(8,10),u=0|n.slice(10,12),r=r<70?2e3+r:1900+r;}return Date.UTC(r,i-1,o,a,s,u,0)},Jh.prototype._decodeNull=function(){return null},Jh.prototype._decodeBool=function(e){const t=e.readUInt8();return e.isError(t)?t:0!==t},Jh.prototype._decodeInt=function(e,t){const n=e.raw();let r=new $h(n);return t&&(r=t[r.toString(10)]||r),r},Jh.prototype._use=function(e,t){return "function"==typeof e&&(e=e(t)),e._getDecoder("der").tree};const tp=Ve,np=fh.Buffer,rp=Qh;function ip(e){rp.call(this,e),this.enc="pem";}tp(ip,rp);var op=ip;ip.prototype.decode=function(e,t){const n=e.toString().split(/[\r\n]+/g),r=t.label.toUpperCase(),i=/^-----(BEGIN|END) ([^-]+)-----$/;let o=-1,a=-1;for(let e=0;e<n.length;e++){const t=n[e].match(i);if(null!==t&&t[2]===r){if(-1!==o){if("END"!==t[1])break;a=e;break}if("BEGIN"!==t[1])break;o=e;}}if(-1===o||-1===a)throw new Error("PEM section not found for: "+r);const s=n.slice(o+1,a).join("");s.replace(/[^a-z0-9+/=]+/gi,"");const u=np.from(s,"base64");return rp.prototype.decode.call(this,u,t)},function(e){const t=e;t.der=Qh,t.pem=op;}(Hh),function(e){const t=sh,n=Hh,r=Ve;function i(e,t){this.name=e,this.body=t,this.decoders={},this.encoders={};}e.define=function(e,t){return new i(e,t)},i.prototype._createNamed=function(e){const t=this.name;function n(e){this._initNamed(e,t);}return r(n,e),n.prototype._initNamed=function(t,n){e.call(this,t,n);},new n(this)},i.prototype._getDecoder=function(e){return e=e||"der",this.decoders.hasOwnProperty(e)||(this.decoders[e]=this._createNamed(n[e])),this.decoders[e]},i.prototype.decode=function(e,t,n){return this._getDecoder(t).decode(e,n)},i.prototype._getEncoder=function(e){return e=e||"der",this.encoders.hasOwnProperty(e)||(this.encoders[e]=this._createNamed(t[e])),this.encoders[e]},i.prototype.encode=function(e,t,n){return this._getEncoder(t).encode(e,n)};}(ah);var ap={};!function(e){const t=e;t.Reporter=hh.Reporter,t.DecoderBuffer=vh.DecoderBuffer,t.EncoderBuffer=vh.EncoderBuffer,t.Node=Th;}(ap);var sp={};!function(e){const t=e;t._reverse=function(e){const t={};return Object.keys(e).forEach((function(n){(0|n)==n&&(n|=0);const r=e[n];t[r]=n;})),t},t.der=Lh;}(sp),function(e){const t=e;t.bignum=hl,t.define=ah.define,t.base=ap,t.constants=sp,t.decoders=Hh,t.encoders=sh;}(oh);var up=oh,lp=up.define("Time",(function(){this.choice({utcTime:this.utctime(),generalTime:this.gentime()});})),cp=up.define("AttributeTypeValue",(function(){this.seq().obj(this.key("type").objid(),this.key("value").any());})),dp=up.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("parameters").optional(),this.key("curve").objid().optional());})),fp=up.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(dp),this.key("subjectPublicKey").bitstr());})),hp=up.define("RelativeDistinguishedName",(function(){this.setof(cp);})),pp=up.define("RDNSequence",(function(){this.seqof(hp);})),mp=up.define("Name",(function(){this.choice({rdnSequence:this.use(pp)});})),gp=up.define("Validity",(function(){this.seq().obj(this.key("notBefore").use(lp),this.key("notAfter").use(lp));})),vp=up.define("Extension",(function(){this.seq().obj(this.key("extnID").objid(),this.key("critical").bool().def(false),this.key("extnValue").octstr());})),bp=up.define("TBSCertificate",(function(){this.seq().obj(this.key("version").explicit(0).int().optional(),this.key("serialNumber").int(),this.key("signature").use(dp),this.key("issuer").use(mp),this.key("validity").use(gp),this.key("subject").use(mp),this.key("subjectPublicKeyInfo").use(fp),this.key("issuerUniqueID").implicit(1).bitstr().optional(),this.key("subjectUniqueID").implicit(2).bitstr().optional(),this.key("extensions").explicit(3).seqof(vp).optional());})),yp=up.define("X509Certificate",(function(){this.seq().obj(this.key("tbsCertificate").use(bp),this.key("signatureAlgorithm").use(dp),this.key("signatureValue").bitstr());})),wp=oh;ih.certificate=yp;var _p=wp.define("RSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("modulus").int(),this.key("publicExponent").int(),this.key("privateExponent").int(),this.key("prime1").int(),this.key("prime2").int(),this.key("exponent1").int(),this.key("exponent2").int(),this.key("coefficient").int());}));ih.RSAPrivateKey=_p;var Sp=wp.define("RSAPublicKey",(function(){this.seq().obj(this.key("modulus").int(),this.key("publicExponent").int());}));ih.RSAPublicKey=Sp;var Ep=wp.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(kp),this.key("subjectPublicKey").bitstr());}));ih.PublicKey=Ep;var kp=wp.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("none").null_().optional(),this.key("curve").objid().optional(),this.key("params").seq().obj(this.key("p").int(),this.key("q").int(),this.key("g").int()).optional());})),Mp=wp.define("PrivateKeyInfo",(function(){this.seq().obj(this.key("version").int(),this.key("algorithm").use(kp),this.key("subjectPrivateKey").octstr());}));ih.PrivateKey=Mp;var Cp=wp.define("EncryptedPrivateKeyInfo",(function(){this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(),this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(),this.key("kdeparams").seq().obj(this.key("salt").octstr(),this.key("iters").int())),this.key("cipher").seq().obj(this.key("algo").objid(),this.key("iv").octstr()))),this.key("subjectPrivateKey").octstr());}));ih.EncryptedPrivateKey=Cp;var xp=wp.define("DSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("p").int(),this.key("q").int(),this.key("g").int(),this.key("pub_key").int(),this.key("priv_key").int());}));ih.DSAPrivateKey=xp,ih.DSAparam=wp.define("DSAparam",(function(){this.int();}));var Ap=wp.define("ECPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("privateKey").octstr(),this.key("parameters").optional().explicit(0).use(Rp),this.key("publicKey").optional().explicit(1).bitstr());}));ih.ECPrivateKey=Ap;var Rp=wp.define("ECParameters",(function(){this.choice({namedCurve:this.objid()});}));ih.signature=wp.define("signature",(function(){this.seq().obj(this.key("r").int(),this.key("s").int());}));var Tp=/Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m,Pp=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m,Lp=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m,Ip=Cu,Op=_s,Np=Ue().Buffer,Dp=ih,jp={"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"},Bp=function(e,t){var n,r=e.toString(),i=r.match(Tp);if(i){var o="aes"+i[1],a=Np.from(i[2],"hex"),s=Np.from(i[3].replace(/[\r\n]/g,""),"base64"),u=Ip(t,a.slice(0,8),parseInt(i[1],10)).key,l=[],c=Op.createDecipheriv(o,u,a);l.push(c.update(s)),l.push(c.final()),n=Np.concat(l);}else {var d=r.match(Lp);n=Np.from(d[2].replace(/[\r\n]/g,""),"base64");}return {tag:r.match(Pp)[1],data:n}},zp=_s,Up=ca,Fp=Ue().Buffer,Kp=qp;function qp(e){var t;"object"!=typeof e||Fp.isBuffer(e)||(t=e.passphrase,e=e.key),"string"==typeof e&&(e=Fp.from(e));var n,r,i=Bp(e,t),o=i.tag,a=i.data;switch(o){case "CERTIFICATE":r=Dp.certificate.decode(a,"der").tbsCertificate.subjectPublicKeyInfo;case "PUBLIC KEY":switch(r||(r=Dp.PublicKey.decode(a,"der")),n=r.algorithm.algorithm.join(".")){case "1.2.840.113549.1.1.1":return Dp.RSAPublicKey.decode(r.subjectPublicKey.data,"der");case "1.2.840.10045.2.1":return r.subjectPrivateKey=r.subjectPublicKey,{type:"ec",data:r};case "1.2.840.10040.4.1":return r.algorithm.params.pub_key=Dp.DSAparam.decode(r.subjectPublicKey.data,"der"),{type:"dsa",data:r.algorithm.params};default:throw new Error("unknown key id "+n)}case "ENCRYPTED PRIVATE KEY":a=function(e,t){var n=e.algorithm.decrypt.kde.kdeparams.salt,r=parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(),10),i=jp[e.algorithm.decrypt.cipher.algo.join(".")],o=e.algorithm.decrypt.cipher.iv,a=e.subjectPrivateKey,s=parseInt(i.split("-")[1],10)/8,u=Up.pbkdf2Sync(t,n,r,s,"sha1"),l=zp.createDecipheriv(i,u,o),c=[];return c.push(l.update(a)),c.push(l.final()),Fp.concat(c)}(a=Dp.EncryptedPrivateKey.decode(a,"der"),t);case "PRIVATE KEY":switch(n=(r=Dp.PrivateKey.decode(a,"der")).algorithm.algorithm.join(".")){case "1.2.840.113549.1.1.1":return Dp.RSAPrivateKey.decode(r.subjectPrivateKey,"der");case "1.2.840.10045.2.1":return {curve:r.algorithm.curve,privateKey:Dp.ECPrivateKey.decode(r.subjectPrivateKey,"der").privateKey};case "1.2.840.10040.4.1":return r.algorithm.params.priv_key=Dp.DSAparam.decode(r.subjectPrivateKey,"der"),{type:"dsa",params:r.algorithm.params};default:throw new Error("unknown key id "+n)}case "RSA PUBLIC KEY":return Dp.RSAPublicKey.decode(a,"der");case "RSA PRIVATE KEY":return Dp.RSAPrivateKey.decode(a,"der");case "DSA PRIVATE KEY":return {type:"dsa",params:Dp.DSAPrivateKey.decode(a,"der")};case "EC PRIVATE KEY":return {curve:(a=Dp.ECPrivateKey.decode(a,"der")).parameters.value,privateKey:a.privateKey};default:throw new Error("unknown key type "+o)}}qp.signature=Dp.signature;var Hp,Wp,$p,Vp,Yp,Gp,Zp,Qp={"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"};function Jp(){if(Hp)return El.exports;Hp=1;var e=Ue().Buffer,t=sa,n=Rl,r=eh().ec,i=rh,o=Kp,a=Qp;function s(n,r,i,o){if((n=e.from(n.toArray())).length<r.byteLength()){var a=e.alloc(r.byteLength()-n.length);n=e.concat([a,n]);}var s=i.length,l=function(t,n){t=u(t,n),t=t.mod(n);var r=e.from(t.toArray());if(r.length<n.byteLength()){var i=e.alloc(n.byteLength()-r.length);r=e.concat([i,r]);}return r}(i,r),c=e.alloc(s);c.fill(1);var d=e.alloc(s);return d=t(o,d).update(c).update(e.from([0])).update(n).update(l).digest(),c=t(o,d).update(c).digest(),{k:d=t(o,d).update(c).update(e.from([1])).update(n).update(l).digest(),v:c=t(o,d).update(c).digest()}}function u(e,t){var n=new i(e),r=(e.length<<3)-t.bitLength();return r>0&&n.ishrn(r),n}function l(n,r,i){var o,a;do{for(o=e.alloc(0);8*o.length<n.bitLength();)r.v=t(i,r.k).update(r.v).digest(),o=e.concat([o,r.v]);a=u(o,n),r.k=t(i,r.k).update(r.v).update(e.from([0])).digest(),r.v=t(i,r.k).update(r.v).digest();}while(-1!==a.cmp(n));return a}function c(e,t,n,r){return e.toRed(i.mont(n)).redPow(t).fromRed().mod(r)}return El.exports=function(t,d,f,h,p){var m=o(d);if(m.curve){if("ecdsa"!==h&&"ecdsa/rsa"!==h)throw new Error("wrong private key type");return function(t,n){var i=a[n.curve.join(".")];if(!i)throw new Error("unknown curve "+n.curve.join("."));var o=new r(i),s=o.keyFromPrivate(n.privateKey),u=s.sign(t);return e.from(u.toDER())}(t,m)}if("dsa"===m.type){if("dsa"!==h)throw new Error("wrong private key type");return function(t,n,r){var o,a=n.params.priv_key,d=n.params.p,f=n.params.q,h=n.params.g,p=new i(0),m=u(t,f).mod(f),g=false,v=s(a,f,t,r);for(;false===g;)p=c(h,o=l(f,v,r),d,f),0===(g=o.invm(f).imul(m.add(a.mul(p))).mod(f)).cmpn(0)&&(g=false,p=new i(0));return function(t,n){t=t.toArray(),n=n.toArray(),128&t[0]&&(t=[0].concat(t));128&n[0]&&(n=[0].concat(n));var r=t.length+n.length+4,i=[48,r,2,t.length];return i=i.concat(t,[2,n.length],n),e.from(i)}(p,g)}(t,m,f)}if("rsa"!==h&&"ecdsa/rsa"!==h)throw new Error("wrong private key type");t=e.concat([p,t]);for(var g=m.modulus.byteLength(),v=[0,1];t.length+v.length+1<g;)v.push(255);v.push(0);for(var b=-1;++b<t.length;)v.push(t[b]);return n(v,m)},El.exports.getKey=s,El.exports.makeKey=l,El.exports}function Xp(){if($p)return Wp;$p=1;var e=Ue().Buffer,t=rh,n=eh().ec,r=Kp,i=Qp;function o(e,t){if(e.cmpn(0)<=0)throw new Error("invalid sig");if(e.cmp(t)>=t)throw new Error("invalid sig")}return Wp=function(a,s,u,l,c){var d=r(u);if("ec"===d.type){if("ecdsa"!==l&&"ecdsa/rsa"!==l)throw new Error("wrong public key type");return function(e,t,r){var o=i[r.data.algorithm.curve.join(".")];if(!o)throw new Error("unknown curve "+r.data.algorithm.curve.join("."));var a=new n(o),s=r.data.subjectPrivateKey.data;return a.verify(t,e,s)}(a,s,d)}if("dsa"===d.type){if("dsa"!==l)throw new Error("wrong public key type");return function(e,n,i){var a=i.data.p,s=i.data.q,u=i.data.g,l=i.data.pub_key,c=r.signature.decode(e,"der"),d=c.s,f=c.r;o(d,s),o(f,s);var h=t.mont(a),p=d.invm(s),m=u.toRed(h).redPow(new t(n).mul(p).mod(s)).fromRed().mul(l.toRed(h).redPow(f.mul(p).mod(s)).fromRed()).mod(a).mod(s);return 0===m.cmp(f)}(a,s,d)}if("rsa"!==l&&"ecdsa/rsa"!==l)throw new Error("wrong public key type");s=e.concat([c,s]);for(var f=d.modulus.byteLength(),h=[1],p=0;s.length+h.length+2<f;)h.push(255),p++;h.push(0);for(var m=-1;++m<s.length;)h.push(s[m]);h=e.from(h);var g=t.mont(d.modulus);a=(a=new t(a).toRed(g)).redPow(new t(d.publicExponent)),a=e.from(a.fromRed().toArray());var v=p<8?1:0;for(f=Math.min(a.length,h.length),a.length!==h.length&&(v=1),m=-1;++m<f;)v|=a[m]^h[m];return 0===v},Wp}var em={},tm=Ko,nm=Ue().Buffer,rm=function(e,t){for(var n,r=nm.alloc(0),i=0;r.length<t;)n=im(i++),r=nm.concat([r,tm("sha1").update(e).update(n).digest()]);return r.slice(0,t)};function im(e){var t=nm.allocUnsafe(4);return t.writeUInt32BE(e,0),t}var om=function(e,t){for(var n=e.length,r=-1;++r<n;)e[r]^=t[r];return e},am=hl,sm=Ue().Buffer;var um=function(e,t){return sm.from(e.toRed(am.mont(t.modulus)).redPow(new am(t.publicExponent)).fromRed().toArray())},lm=Kp,cm=We,dm=Ko,fm=rm,hm=om,pm=hl,mm=um,gm=Rl,vm=Ue().Buffer,bm=function(e,t,n){var r;r=e.padding?e.padding:n?1:4;var i,o=lm(e);if(4===r)i=function(e,t){var n=e.modulus.byteLength(),r=t.length,i=dm("sha1").update(vm.alloc(0)).digest(),o=i.length,a=2*o;if(r>n-a-2)throw new Error("message too long");var s=vm.alloc(n-r-a-2),u=n-o-1,l=cm(o),c=hm(vm.concat([i,s,vm.alloc(1,1),t],u),fm(l,u)),d=hm(l,fm(c,o));return new pm(vm.concat([vm.alloc(1),d,c],n))}(o,t);else if(1===r)i=function(e,t,n){var r,i=t.length,o=e.modulus.byteLength();if(i>o-11)throw new Error("message too long");r=n?vm.alloc(o-i-3,255):function(e){var t,n=vm.allocUnsafe(e),r=0,i=cm(2*e),o=0;for(;r<e;)o===i.length&&(i=cm(2*e),o=0),(t=i[o++])&&(n[r++]=t);return n}(o-i-3);return new pm(vm.concat([vm.from([0,n?1:2]),r,vm.alloc(1),t],o))}(o,t,n);else {if(3!==r)throw new Error("unknown padding");if((i=new pm(t)).cmp(o.modulus)>=0)throw new Error("data too long for modulus")}return n?gm(i,o):mm(i,o)};var ym=Kp,wm=rm,_m=om,Sm=hl,Em=Rl,km=Ko,Mm=um,Cm=Ue().Buffer,xm=function(e,t,n){var r;r=e.padding?e.padding:n?1:4;var i,o=ym(e),a=o.modulus.byteLength();if(t.length>a||new Sm(t).cmp(o.modulus)>=0)throw new Error("decryption error");i=n?Mm(new Sm(t),o):Em(t,o);var s=Cm.alloc(a-i.length);if(i=Cm.concat([s,i],a),4===r)return function(e,t){var n=e.modulus.byteLength(),r=km("sha1").update(Cm.alloc(0)).digest(),i=r.length;if(0!==t[0])throw new Error("decryption error");var o=t.slice(1,i+1),a=t.slice(i+1),s=_m(o,wm(a,i)),u=_m(a,wm(s,n-i-1));if(function(e,t){e=Cm.from(e),t=Cm.from(t);var n=0,r=e.length;e.length!==t.length&&(n++,r=Math.min(e.length,t.length));var i=-1;for(;++i<r;)n+=e[i]^t[i];return n}(r,u.slice(0,i)))throw new Error("decryption error");var l=i;for(;0===u[l];)l++;if(1!==u[l++])throw new Error("decryption error");return u.slice(l)}(o,i);if(1===r)return function(e,t,n){var r=t.slice(0,2),i=2,o=0;for(;0!==t[i++];)if(i>=t.length){o++;break}var a=t.slice(2,i-1);("0002"!==r.toString("hex")&&!n||"0001"!==r.toString("hex")&&n)&&o++;a.length<8&&o++;if(o)throw new Error("decryption error");return t.slice(i)}(0,i,n);if(3===r)return i;throw new Error("unknown padding")};!function(e){e.publicEncrypt=bm,e.privateDecrypt=xm,e.privateEncrypt=function(t,n){return e.publicEncrypt(t,n,true)},e.publicDecrypt=function(t,n){return e.privateDecrypt(t,n,true)};}(em);var Am={};function Rm(){throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11")}var Tm,Pm=Ue(),Lm=Pm.Buffer,Im=Pm.kMaxLength,Om=n.crypto||n.msCrypto,Nm=Math.pow(2,32)-1;function Dm(e,t){if("number"!=typeof e||e!=e)throw new TypeError("offset must be a number");if(e>Nm||e<0)throw new TypeError("offset must be a uint32");if(e>Im||e>t)throw new RangeError("offset out of range")}function jm(e,t,n){if("number"!=typeof e||e!=e)throw new TypeError("size must be a number");if(e>Nm||e<0)throw new TypeError("size must be a uint32");if(e+t>n||e>Im)throw new RangeError("buffer too small")}function Bm(e,t,n,r){var i=e.buffer,o=new Uint8Array(i,t,n);return Om.getRandomValues(o),r?void Ee((function(){r(null,e);})):e}function zm(){if(Tm)return de;Tm=1,de.randomBytes=de.rng=de.pseudoRandomBytes=de.prng=We,de.createHash=de.Hash=Ko,de.createHmac=de.Hmac=sa;var e=la,t=Object.keys(e),n=["sha1","sha224","sha256","sha384","sha512","md5","rmd160"].concat(t);de.getHashes=function(){return n};var r=ca;de.pbkdf2=r.pbkdf2,de.pbkdf2Sync=r.pbkdf2Sync;var i=za;de.Cipher=i.Cipher,de.createCipher=i.createCipher,de.Cipheriv=i.Cipheriv,de.createCipheriv=i.createCipheriv,de.Decipher=i.Decipher,de.createDecipher=i.createDecipher,de.Decipheriv=i.Decipheriv,de.createDecipheriv=i.createDecipheriv,de.getCiphers=i.getCiphers,de.listCiphers=i.listCiphers;var o=function(){if(wl)return al;wl=1;var e=vl(),t=_l,n=Sl(),r={binary:true,hex:true,base64:true};return al.DiffieHellmanGroup=al.createDiffieHellmanGroup=al.getDiffieHellman=function(e){var r=new _(t[e].prime,"hex"),i=new _(t[e].gen,"hex");return new n(r,i)},al.createDiffieHellman=al.DiffieHellman=function t(i,o,a,s){return ie(o)||void 0===r[o]?t(i,"binary",o,a):(o=o||"binary",s=s||"binary",ie(a=a||new _([2]))||(a=new _(a,s)),"number"==typeof i?new n(e(i,a),a,true):(ie(i)||(i=new _(i,o)),new n(i,a,true)))},al}();de.DiffieHellmanGroup=o.DiffieHellmanGroup,de.createDiffieHellmanGroup=o.createDiffieHellmanGroup,de.getDiffieHellman=o.getDiffieHellman,de.createDiffieHellman=o.createDiffieHellman,de.DiffieHellman=o.DiffieHellman;var a=function(){if(Yp)return Vp;Yp=1;var e=Ue().Buffer,t=Ko,n=Hn,r=Ve,i=Jp(),o=Xp(),a=ua;function s(e){n.Writable.call(this);var r=a[e];if(!r)throw new Error("Unknown message digest");this._hashType=r.hash,this._hash=t(r.hash),this._tag=r.id,this._signType=r.sign;}function u(e){n.Writable.call(this);var r=a[e];if(!r)throw new Error("Unknown message digest");this._hash=t(r.hash),this._tag=r.id,this._signType=r.sign;}function l(e){return new s(e)}function c(e){return new u(e)}return Object.keys(a).forEach((function(t){a[t].id=e.from(a[t].id,"hex"),a[t.toLowerCase()]=a[t];})),r(s,n.Writable),s.prototype._write=function(e,t,n){this._hash.update(e),n();},s.prototype.update=function(t,n){return "string"==typeof t&&(t=e.from(t,n)),this._hash.update(t),this},s.prototype.sign=function(e,t){this.end();var n=this._hash.digest(),r=i(n,e,this._hashType,this._signType,this._tag);return t?r.toString(t):r},r(u,n.Writable),u.prototype._write=function(e,t,n){this._hash.update(e),n();},u.prototype.update=function(t,n){return "string"==typeof t&&(t=e.from(t,n)),this._hash.update(t),this},u.prototype.verify=function(t,n,r){"string"==typeof n&&(n=e.from(n,r)),this.end();var i=this._hash.digest();return o(n,i,t,this._signType,this._tag)},Vp={Sign:l,Verify:c,createSign:l,createVerify:c}}();de.createSign=a.createSign,de.Sign=a.Sign,de.createVerify=a.createVerify,de.Verify=a.Verify,de.createECDH=function(){if(Zp)return Gp;Zp=1;var e=eh(),t=hl;Gp=function(e){return new r(e)};var n={secp256k1:{name:"secp256k1",byteLength:32},secp224r1:{name:"p224",byteLength:28},prime256v1:{name:"p256",byteLength:32},prime192v1:{name:"p192",byteLength:24},ed25519:{name:"ed25519",byteLength:32},secp384r1:{name:"p384",byteLength:48},secp521r1:{name:"p521",byteLength:66}};function r(t){this.curveType=n[t],this.curveType||(this.curveType={name:t}),this.curve=new e.ec(this.curveType.name),this.keys=void 0;}function i(e,t,n){Array.isArray(e)||(e=e.toArray());var r=new _(e);if(n&&r.length<n){var i=new _(n-r.length);i.fill(0),r=_.concat([i,r]);}return t?r.toString(t):r}return n.p224=n.secp224r1,n.p256=n.secp256r1=n.prime256v1,n.p192=n.secp192r1=n.prime192v1,n.p384=n.secp384r1,n.p521=n.secp521r1,r.prototype.generateKeys=function(e,t){return this.keys=this.curve.genKeyPair(),this.getPublicKey(e,t)},r.prototype.computeSecret=function(e,t,n){return t=t||"utf8",ie(e)||(e=new _(e,t)),i(this.curve.keyFromPublic(e).getPublic().mul(this.keys.getPrivate()).getX(),n,this.curveType.byteLength)},r.prototype.getPublicKey=function(e,t){var n=this.keys.getPublic("compressed"===t,true);return "hybrid"===t&&(n[n.length-1]%2?n[0]=7:n[0]=6),i(n,e)},r.prototype.getPrivateKey=function(e){return i(this.keys.getPrivate(),e)},r.prototype.setPublicKey=function(e,t){return t=t||"utf8",ie(e)||(e=new _(e,t)),this.keys._importPublic(e),this},r.prototype.setPrivateKey=function(e,n){n=n||"utf8",ie(e)||(e=new _(e,n));var r=new t(e);return r=r.toString(16),this.keys=this.curve.genKeyPair(),this.keys._importPrivate(r),this},Gp}();var s=em;de.publicEncrypt=s.publicEncrypt,de.privateEncrypt=s.privateEncrypt,de.publicDecrypt=s.publicDecrypt,de.privateDecrypt=s.privateDecrypt;var u=Am;return de.randomFill=u.randomFill,de.randomFillSync=u.randomFillSync,de.createCredentials=function(){throw new Error(["sorry, createCredentials is not implemented yet","we accept pull requests","https://github.com/crypto-browserify/crypto-browserify"].join("\n"))},de.constants={DH_CHECK_P_NOT_SAFE_PRIME:2,DH_CHECK_P_NOT_PRIME:1,DH_UNABLE_TO_CHECK_GENERATOR:4,DH_NOT_SUITABLE_GENERATOR:8,NPN_ENABLED:1,ALPN_ENABLED:1,RSA_PKCS1_PADDING:1,RSA_SSLV23_PADDING:2,RSA_NO_PADDING:3,RSA_PKCS1_OAEP_PADDING:4,RSA_X931_PADDING:5,RSA_PKCS1_PSS_PADDING:6,POINT_CONVERSION_COMPRESSED:2,POINT_CONVERSION_UNCOMPRESSED:4,POINT_CONVERSION_HYBRID:6},de}Om&&Om.getRandomValues?(Am.randomFill=function(e,t,r,i){if(!(Lm.isBuffer(e)||e instanceof n.Uint8Array))throw new TypeError('"buf" argument must be a Buffer or Uint8Array');if("function"==typeof t)i=t,t=0,r=e.length;else if("function"==typeof r)i=r,r=e.length-t;else if("function"!=typeof i)throw new TypeError('"cb" argument must be a function');return Dm(t,e.length),jm(r,t,e.length),Bm(e,t,r,i)},Am.randomFillSync=function(e,t,r){ void 0===t&&(t=0);if(!(Lm.isBuffer(e)||e instanceof n.Uint8Array))throw new TypeError('"buf" argument must be a Buffer or Uint8Array');Dm(t,e.length),void 0===r&&(r=e.length-t);return jm(r,t,e.length),Bm(e,t,r)}):(Am.randomFill=Rm,Am.randomFillSync=Rm);const{Buffer:Um}=ce,{createHash:Fm,createHmac:Km}=zm(),qm={},Hm=e=>{switch(e){case "sha256":case "sha3-256":case "blake2s256":return 32;case "sha512":case "sha3-512":case "blake2b512":return 64;case "sha224":case "sha3-224":return 28;case "sha384":case "sha3-384":return 48;case "sha1":return 20;case "md5":return 16;default:{let t=qm[e];return void 0===t&&(t=Fm(e).digest().length,qm[e]=t),t}}},Wm=(e,t,n,r)=>{const i=Um.isBuffer(n)?n:Um.from(n),o=r&&r.length?Um.from(r):Um.alloc(t,0);return Km(e,o).update(i).digest()},$m=(e,t,n,r,i)=>{const o=Um.isBuffer(i)?i:Um.from(i||""),a=o.length,s=Math.ceil(r/t);if(s>255)throw new Error(`OKM length ${r} is too long for ${e} hash`);const u=Um.alloc(t*s+a+1);for(let r=1,i=0,l=0;r<=s;++r)o.copy(u,l),u[l+a]=r,Km(e,n).update(u.slice(i,l+a+1)).digest().copy(u,l),i=l,l+=t;return u.slice(0,r)};function Vm(e,t,{salt:n="",info:r="",hash:i="SHA-256"}={}){i=i.toLowerCase().replace("-","");const o=Hm(i),a=Wm(i,o,e,n);return $m(i,o,a,t,r)}Object.defineProperties(Vm,{hash_length:{configurable:false,enumerable:false,writable:false,value:Hm},extract:{configurable:false,enumerable:false,writable:false,value:Wm},expand:{configurable:false,enumerable:false,writable:false,value:$m}});var Ym=Vm;const Gm="Impossible case. Please create issue.",Zm="The tweak was out of range or the resulted private key is invalid",Qm="The tweak was out of range or equal to zero",Jm="Unknow error on context randomization",Xm="Private Key is invalid",eg="Public Key could not be parsed",tg="Public Key serialization error",ng="The sum of the public keys is not valid",rg="Signature could not be parsed",ig="The nonce generation function failed, or the private key was invalid",og="Public key could not be recover",ag="Scalar was invalid (zero or overflow)";function sg(e,t){if(!e)throw new Error(t)}function ug(e,t,n){if(sg(t instanceof Uint8Array,`Expected ${e} to be an Uint8Array`),void 0!==n)if(Array.isArray(n)){const r=`Expected ${e} to be an Uint8Array with length [${n.join(", ")}]`;sg(n.includes(t.length),r);}else {const r=`Expected ${e} to be an Uint8Array with length ${n}`;sg(t.length===n,r);}}function lg(e){sg("Boolean"===dg(e),"Expected compressed to be a Boolean");}function cg(e=(e=>new Uint8Array(e)),t){return "function"==typeof e&&(e=e(t)),ug("output",e,t),e}function dg(e){return Object.prototype.toString.call(e).slice(8,-1)}var fg={},hg="6.5.4",pg={},mg={exports:{}};!function(e){!function(e,t){function n(e,t){if(!e)throw new Error(t||"Assertion failed")}function r(e,t){e.super_=t;var n=function(){};n.prototype=t.prototype,e.prototype=new n,e.prototype.constructor=e;}function i(e,t,n){if(i.isBN(e))return e;this.negative=0,this.words=null,this.length=0,this.red=null,null!==e&&("le"!==t&&"be"!==t||(n=t,t=10),this._init(e||0,t||10,n||"be"));}var o;"object"==typeof e?e.exports=i:t.BN=i,i.BN=i,i.wordSize=26;try{o="undefined"!=typeof window&&void 0!==window.Buffer?window.Buffer:ce.Buffer;}catch(e){}function a(e,t){var n=e.charCodeAt(t);return n>=65&&n<=70?n-55:n>=97&&n<=102?n-87:n-48&15}function s(e,t,n){var r=a(e,n);return n-1>=t&&(r|=a(e,n-1)<<4),r}function u(e,t,n,r){for(var i=0,o=Math.min(e.length,n),a=t;a<o;a++){var s=e.charCodeAt(a)-48;i*=r,i+=s>=49?s-49+10:s>=17?s-17+10:s;}return i}i.isBN=function(e){return e instanceof i||null!==e&&"object"==typeof e&&e.constructor.wordSize===i.wordSize&&Array.isArray(e.words)},i.max=function(e,t){return e.cmp(t)>0?e:t},i.min=function(e,t){return e.cmp(t)<0?e:t},i.prototype._init=function(e,t,r){if("number"==typeof e)return this._initNumber(e,t,r);if("object"==typeof e)return this._initArray(e,t,r);"hex"===t&&(t=16),n(t===(0|t)&&t>=2&&t<=36);var i=0;"-"===(e=e.toString().replace(/\s+/g,""))[0]&&(i++,this.negative=1),i<e.length&&(16===t?this._parseHex(e,i,r):(this._parseBase(e,t,i),"le"===r&&this._initArray(this.toArray(),t,r)));},i.prototype._initNumber=function(e,t,r){e<0&&(this.negative=1,e=-e),e<67108864?(this.words=[67108863&e],this.length=1):e<4503599627370496?(this.words=[67108863&e,e/67108864&67108863],this.length=2):(n(e<9007199254740992),this.words=[67108863&e,e/67108864&67108863,1],this.length=3),"le"===r&&this._initArray(this.toArray(),t,r);},i.prototype._initArray=function(e,t,r){if(n("number"==typeof e.length),e.length<=0)return this.words=[0],this.length=1,this;this.length=Math.ceil(e.length/3),this.words=new Array(this.length);for(var i=0;i<this.length;i++)this.words[i]=0;var o,a,s=0;if("be"===r)for(i=e.length-1,o=0;i>=0;i-=3)a=e[i]|e[i-1]<<8|e[i-2]<<16,this.words[o]|=a<<s&67108863,this.words[o+1]=a>>>26-s&67108863,(s+=24)>=26&&(s-=26,o++);else if("le"===r)for(i=0,o=0;i<e.length;i+=3)a=e[i]|e[i+1]<<8|e[i+2]<<16,this.words[o]|=a<<s&67108863,this.words[o+1]=a>>>26-s&67108863,(s+=24)>=26&&(s-=26,o++);return this.strip()},i.prototype._parseHex=function(e,t,n){this.length=Math.ceil((e.length-t)/6),this.words=new Array(this.length);for(var r=0;r<this.length;r++)this.words[r]=0;var i,o=0,a=0;if("be"===n)for(r=e.length-1;r>=t;r-=2)i=s(e,t,r)<<o,this.words[a]|=67108863&i,o>=18?(o-=18,a+=1,this.words[a]|=i>>>26):o+=8;else for(r=(e.length-t)%2==0?t+1:t;r<e.length;r+=2)i=s(e,t,r)<<o,this.words[a]|=67108863&i,o>=18?(o-=18,a+=1,this.words[a]|=i>>>26):o+=8;this.strip();},i.prototype._parseBase=function(e,t,n){this.words=[0],this.length=1;for(var r=0,i=1;i<=67108863;i*=t)r++;r--,i=i/t|0;for(var o=e.length-n,a=o%r,s=Math.min(o,o-a)+n,l=0,c=n;c<s;c+=r)l=u(e,c,c+r,t),this.imuln(i),this.words[0]+l<67108864?this.words[0]+=l:this._iaddn(l);if(0!==a){var d=1;for(l=u(e,c,e.length,t),c=0;c<a;c++)d*=t;this.imuln(d),this.words[0]+l<67108864?this.words[0]+=l:this._iaddn(l);}this.strip();},i.prototype.copy=function(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++)e.words[t]=this.words[t];e.length=this.length,e.negative=this.negative,e.red=this.red;},i.prototype.clone=function(){var e=new i(null);return this.copy(e),e},i.prototype._expand=function(e){for(;this.length<e;)this.words[this.length++]=0;return this},i.prototype.strip=function(){for(;this.length>1&&0===this.words[this.length-1];)this.length--;return this._normSign()},i.prototype._normSign=function(){return 1===this.length&&0===this.words[0]&&(this.negative=0),this},i.prototype.inspect=function(){return (this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"};var l=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"],c=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5],d=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];function f(e,t,n){n.negative=t.negative^e.negative;var r=e.length+t.length|0;n.length=r,r=r-1|0;var i=0|e.words[0],o=0|t.words[0],a=i*o,s=67108863&a,u=a/67108864|0;n.words[0]=s;for(var l=1;l<r;l++){for(var c=u>>>26,d=67108863&u,f=Math.min(l,t.length-1),h=Math.max(0,l-e.length+1);h<=f;h++){var p=l-h|0;c+=(a=(i=0|e.words[p])*(o=0|t.words[h])+d)/67108864|0,d=67108863&a;}n.words[l]=0|d,u=0|c;}return 0!==u?n.words[l]=0|u:n.length--,n.strip()}i.prototype.toString=function(e,t){var r;if(t=0|t||1,16===(e=e||10)||"hex"===e){r="";for(var i=0,o=0,a=0;a<this.length;a++){var s=this.words[a],u=(16777215&(s<<i|o)).toString(16);r=0!==(o=s>>>24-i&16777215)||a!==this.length-1?l[6-u.length]+u+r:u+r,(i+=2)>=26&&(i-=26,a--);}for(0!==o&&(r=o.toString(16)+r);r.length%t!=0;)r="0"+r;return 0!==this.negative&&(r="-"+r),r}if(e===(0|e)&&e>=2&&e<=36){var f=c[e],h=d[e];r="";var p=this.clone();for(p.negative=0;!p.isZero();){var m=p.modn(h).toString(e);r=(p=p.idivn(h)).isZero()?m+r:l[f-m.length]+m+r;}for(this.isZero()&&(r="0"+r);r.length%t!=0;)r="0"+r;return 0!==this.negative&&(r="-"+r),r}n(false,"Base should be between 2 and 36");},i.prototype.toNumber=function(){var e=this.words[0];return 2===this.length?e+=67108864*this.words[1]:3===this.length&&1===this.words[2]?e+=4503599627370496+67108864*this.words[1]:this.length>2&&n(false,"Number can only safely store up to 53 bits"),0!==this.negative?-e:e},i.prototype.toJSON=function(){return this.toString(16)},i.prototype.toBuffer=function(e,t){return n(void 0!==o),this.toArrayLike(o,e,t)},i.prototype.toArray=function(e,t){return this.toArrayLike(Array,e,t)},i.prototype.toArrayLike=function(e,t,r){var i=this.byteLength(),o=r||Math.max(1,i);n(i<=o,"byte array longer than desired length"),n(o>0,"Requested array length <= 0"),this.strip();var a,s,u="le"===t,l=new e(o),c=this.clone();if(u){for(s=0;!c.isZero();s++)a=c.andln(255),c.iushrn(8),l[s]=a;for(;s<o;s++)l[s]=0;}else {for(s=0;s<o-i;s++)l[s]=0;for(s=0;!c.isZero();s++)a=c.andln(255),c.iushrn(8),l[o-s-1]=a;}return l},Math.clz32?i.prototype._countBits=function(e){return 32-Math.clz32(e)}:i.prototype._countBits=function(e){var t=e,n=0;return t>=4096&&(n+=13,t>>>=13),t>=64&&(n+=7,t>>>=7),t>=8&&(n+=4,t>>>=4),t>=2&&(n+=2,t>>>=2),n+t},i.prototype._zeroBits=function(e){if(0===e)return 26;var t=e,n=0;return 0==(8191&t)&&(n+=13,t>>>=13),0==(127&t)&&(n+=7,t>>>=7),0==(15&t)&&(n+=4,t>>>=4),0==(3&t)&&(n+=2,t>>>=2),0==(1&t)&&n++,n},i.prototype.bitLength=function(){var e=this.words[this.length-1],t=this._countBits(e);return 26*(this.length-1)+t},i.prototype.zeroBits=function(){if(this.isZero())return 0;for(var e=0,t=0;t<this.length;t++){var n=this._zeroBits(this.words[t]);if(e+=n,26!==n)break}return e},i.prototype.byteLength=function(){return Math.ceil(this.bitLength()/8)},i.prototype.toTwos=function(e){return 0!==this.negative?this.abs().inotn(e).iaddn(1):this.clone()},i.prototype.fromTwos=function(e){return this.testn(e-1)?this.notn(e).iaddn(1).ineg():this.clone()},i.prototype.isNeg=function(){return 0!==this.negative},i.prototype.neg=function(){return this.clone().ineg()},i.prototype.ineg=function(){return this.isZero()||(this.negative^=1),this},i.prototype.iuor=function(e){for(;this.length<e.length;)this.words[this.length++]=0;for(var t=0;t<e.length;t++)this.words[t]=this.words[t]|e.words[t];return this.strip()},i.prototype.ior=function(e){return n(0==(this.negative|e.negative)),this.iuor(e)},i.prototype.or=function(e){return this.length>e.length?this.clone().ior(e):e.clone().ior(this)},i.prototype.uor=function(e){return this.length>e.length?this.clone().iuor(e):e.clone().iuor(this)},i.prototype.iuand=function(e){var t;t=this.length>e.length?e:this;for(var n=0;n<t.length;n++)this.words[n]=this.words[n]&e.words[n];return this.length=t.length,this.strip()},i.prototype.iand=function(e){return n(0==(this.negative|e.negative)),this.iuand(e)},i.prototype.and=function(e){return this.length>e.length?this.clone().iand(e):e.clone().iand(this)},i.prototype.uand=function(e){return this.length>e.length?this.clone().iuand(e):e.clone().iuand(this)},i.prototype.iuxor=function(e){var t,n;this.length>e.length?(t=this,n=e):(t=e,n=this);for(var r=0;r<n.length;r++)this.words[r]=t.words[r]^n.words[r];if(this!==t)for(;r<t.length;r++)this.words[r]=t.words[r];return this.length=t.length,this.strip()},i.prototype.ixor=function(e){return n(0==(this.negative|e.negative)),this.iuxor(e)},i.prototype.xor=function(e){return this.length>e.length?this.clone().ixor(e):e.clone().ixor(this)},i.prototype.uxor=function(e){return this.length>e.length?this.clone().iuxor(e):e.clone().iuxor(this)},i.prototype.inotn=function(e){n("number"==typeof e&&e>=0);var t=0|Math.ceil(e/26),r=e%26;this._expand(t),r>0&&t--;for(var i=0;i<t;i++)this.words[i]=67108863&~this.words[i];return r>0&&(this.words[i]=~this.words[i]&67108863>>26-r),this.strip()},i.prototype.notn=function(e){return this.clone().inotn(e)},i.prototype.setn=function(e,t){n("number"==typeof e&&e>=0);var r=e/26|0,i=e%26;return this._expand(r+1),this.words[r]=t?this.words[r]|1<<i:this.words[r]&~(1<<i),this.strip()},i.prototype.iadd=function(e){var t,n,r;if(0!==this.negative&&0===e.negative)return this.negative=0,t=this.isub(e),this.negative^=1,this._normSign();if(0===this.negative&&0!==e.negative)return e.negative=0,t=this.isub(e),e.negative=1,t._normSign();this.length>e.length?(n=this,r=e):(n=e,r=this);for(var i=0,o=0;o<r.length;o++)t=(0|n.words[o])+(0|r.words[o])+i,this.words[o]=67108863&t,i=t>>>26;for(;0!==i&&o<n.length;o++)t=(0|n.words[o])+i,this.words[o]=67108863&t,i=t>>>26;if(this.length=n.length,0!==i)this.words[this.length]=i,this.length++;else if(n!==this)for(;o<n.length;o++)this.words[o]=n.words[o];return this},i.prototype.add=function(e){var t;return 0!==e.negative&&0===this.negative?(e.negative=0,t=this.sub(e),e.negative^=1,t):0===e.negative&&0!==this.negative?(this.negative=0,t=e.sub(this),this.negative=1,t):this.length>e.length?this.clone().iadd(e):e.clone().iadd(this)},i.prototype.isub=function(e){if(0!==e.negative){e.negative=0;var t=this.iadd(e);return e.negative=1,t._normSign()}if(0!==this.negative)return this.negative=0,this.iadd(e),this.negative=1,this._normSign();var n,r,i=this.cmp(e);if(0===i)return this.negative=0,this.length=1,this.words[0]=0,this;i>0?(n=this,r=e):(n=e,r=this);for(var o=0,a=0;a<r.length;a++)o=(t=(0|n.words[a])-(0|r.words[a])+o)>>26,this.words[a]=67108863&t;for(;0!==o&&a<n.length;a++)o=(t=(0|n.words[a])+o)>>26,this.words[a]=67108863&t;if(0===o&&a<n.length&&n!==this)for(;a<n.length;a++)this.words[a]=n.words[a];return this.length=Math.max(this.length,a),n!==this&&(this.negative=1),this.strip()},i.prototype.sub=function(e){return this.clone().isub(e)};var h=function(e,t,n){var r,i,o,a=e.words,s=t.words,u=n.words,l=0,c=0|a[0],d=8191&c,f=c>>>13,h=0|a[1],p=8191&h,m=h>>>13,g=0|a[2],v=8191&g,b=g>>>13,y=0|a[3],w=8191&y,_=y>>>13,S=0|a[4],E=8191&S,k=S>>>13,M=0|a[5],C=8191&M,x=M>>>13,A=0|a[6],R=8191&A,T=A>>>13,P=0|a[7],L=8191&P,I=P>>>13,O=0|a[8],N=8191&O,D=O>>>13,j=0|a[9],B=8191&j,z=j>>>13,U=0|s[0],F=8191&U,K=U>>>13,q=0|s[1],H=8191&q,W=q>>>13,$=0|s[2],V=8191&$,Y=$>>>13,G=0|s[3],Z=8191&G,Q=G>>>13,J=0|s[4],X=8191&J,ee=J>>>13,te=0|s[5],ne=8191&te,re=te>>>13,ie=0|s[6],oe=8191&ie,ae=ie>>>13,se=0|s[7],ue=8191&se,le=se>>>13,ce=0|s[8],de=8191&ce,fe=ce>>>13,he=0|s[9],pe=8191&he,me=he>>>13;n.negative=e.negative^t.negative,n.length=19;var ge=(l+(r=Math.imul(d,F))|0)+((8191&(i=(i=Math.imul(d,K))+Math.imul(f,F)|0))<<13)|0;l=((o=Math.imul(f,K))+(i>>>13)|0)+(ge>>>26)|0,ge&=67108863,r=Math.imul(p,F),i=(i=Math.imul(p,K))+Math.imul(m,F)|0,o=Math.imul(m,K);var ve=(l+(r=r+Math.imul(d,H)|0)|0)+((8191&(i=(i=i+Math.imul(d,W)|0)+Math.imul(f,H)|0))<<13)|0;l=((o=o+Math.imul(f,W)|0)+(i>>>13)|0)+(ve>>>26)|0,ve&=67108863,r=Math.imul(v,F),i=(i=Math.imul(v,K))+Math.imul(b,F)|0,o=Math.imul(b,K),r=r+Math.imul(p,H)|0,i=(i=i+Math.imul(p,W)|0)+Math.imul(m,H)|0,o=o+Math.imul(m,W)|0;var be=(l+(r=r+Math.imul(d,V)|0)|0)+((8191&(i=(i=i+Math.imul(d,Y)|0)+Math.imul(f,V)|0))<<13)|0;l=((o=o+Math.imul(f,Y)|0)+(i>>>13)|0)+(be>>>26)|0,be&=67108863,r=Math.imul(w,F),i=(i=Math.imul(w,K))+Math.imul(_,F)|0,o=Math.imul(_,K),r=r+Math.imul(v,H)|0,i=(i=i+Math.imul(v,W)|0)+Math.imul(b,H)|0,o=o+Math.imul(b,W)|0,r=r+Math.imul(p,V)|0,i=(i=i+Math.imul(p,Y)|0)+Math.imul(m,V)|0,o=o+Math.imul(m,Y)|0;var ye=(l+(r=r+Math.imul(d,Z)|0)|0)+((8191&(i=(i=i+Math.imul(d,Q)|0)+Math.imul(f,Z)|0))<<13)|0;l=((o=o+Math.imul(f,Q)|0)+(i>>>13)|0)+(ye>>>26)|0,ye&=67108863,r=Math.imul(E,F),i=(i=Math.imul(E,K))+Math.imul(k,F)|0,o=Math.imul(k,K),r=r+Math.imul(w,H)|0,i=(i=i+Math.imul(w,W)|0)+Math.imul(_,H)|0,o=o+Math.imul(_,W)|0,r=r+Math.imul(v,V)|0,i=(i=i+Math.imul(v,Y)|0)+Math.imul(b,V)|0,o=o+Math.imul(b,Y)|0,r=r+Math.imul(p,Z)|0,i=(i=i+Math.imul(p,Q)|0)+Math.imul(m,Z)|0,o=o+Math.imul(m,Q)|0;var we=(l+(r=r+Math.imul(d,X)|0)|0)+((8191&(i=(i=i+Math.imul(d,ee)|0)+Math.imul(f,X)|0))<<13)|0;l=((o=o+Math.imul(f,ee)|0)+(i>>>13)|0)+(we>>>26)|0,we&=67108863,r=Math.imul(C,F),i=(i=Math.imul(C,K))+Math.imul(x,F)|0,o=Math.imul(x,K),r=r+Math.imul(E,H)|0,i=(i=i+Math.imul(E,W)|0)+Math.imul(k,H)|0,o=o+Math.imul(k,W)|0,r=r+Math.imul(w,V)|0,i=(i=i+Math.imul(w,Y)|0)+Math.imul(_,V)|0,o=o+Math.imul(_,Y)|0,r=r+Math.imul(v,Z)|0,i=(i=i+Math.imul(v,Q)|0)+Math.imul(b,Z)|0,o=o+Math.imul(b,Q)|0,r=r+Math.imul(p,X)|0,i=(i=i+Math.imul(p,ee)|0)+Math.imul(m,X)|0,o=o+Math.imul(m,ee)|0;var _e=(l+(r=r+Math.imul(d,ne)|0)|0)+((8191&(i=(i=i+Math.imul(d,re)|0)+Math.imul(f,ne)|0))<<13)|0;l=((o=o+Math.imul(f,re)|0)+(i>>>13)|0)+(_e>>>26)|0,_e&=67108863,r=Math.imul(R,F),i=(i=Math.imul(R,K))+Math.imul(T,F)|0,o=Math.imul(T,K),r=r+Math.imul(C,H)|0,i=(i=i+Math.imul(C,W)|0)+Math.imul(x,H)|0,o=o+Math.imul(x,W)|0,r=r+Math.imul(E,V)|0,i=(i=i+Math.imul(E,Y)|0)+Math.imul(k,V)|0,o=o+Math.imul(k,Y)|0,r=r+Math.imul(w,Z)|0,i=(i=i+Math.imul(w,Q)|0)+Math.imul(_,Z)|0,o=o+Math.imul(_,Q)|0,r=r+Math.imul(v,X)|0,i=(i=i+Math.imul(v,ee)|0)+Math.imul(b,X)|0,o=o+Math.imul(b,ee)|0,r=r+Math.imul(p,ne)|0,i=(i=i+Math.imul(p,re)|0)+Math.imul(m,ne)|0,o=o+Math.imul(m,re)|0;var Se=(l+(r=r+Math.imul(d,oe)|0)|0)+((8191&(i=(i=i+Math.imul(d,ae)|0)+Math.imul(f,oe)|0))<<13)|0;l=((o=o+Math.imul(f,ae)|0)+(i>>>13)|0)+(Se>>>26)|0,Se&=67108863,r=Math.imul(L,F),i=(i=Math.imul(L,K))+Math.imul(I,F)|0,o=Math.imul(I,K),r=r+Math.imul(R,H)|0,i=(i=i+Math.imul(R,W)|0)+Math.imul(T,H)|0,o=o+Math.imul(T,W)|0,r=r+Math.imul(C,V)|0,i=(i=i+Math.imul(C,Y)|0)+Math.imul(x,V)|0,o=o+Math.imul(x,Y)|0,r=r+Math.imul(E,Z)|0,i=(i=i+Math.imul(E,Q)|0)+Math.imul(k,Z)|0,o=o+Math.imul(k,Q)|0,r=r+Math.imul(w,X)|0,i=(i=i+Math.imul(w,ee)|0)+Math.imul(_,X)|0,o=o+Math.imul(_,ee)|0,r=r+Math.imul(v,ne)|0,i=(i=i+Math.imul(v,re)|0)+Math.imul(b,ne)|0,o=o+Math.imul(b,re)|0,r=r+Math.imul(p,oe)|0,i=(i=i+Math.imul(p,ae)|0)+Math.imul(m,oe)|0,o=o+Math.imul(m,ae)|0;var Ee=(l+(r=r+Math.imul(d,ue)|0)|0)+((8191&(i=(i=i+Math.imul(d,le)|0)+Math.imul(f,ue)|0))<<13)|0;l=((o=o+Math.imul(f,le)|0)+(i>>>13)|0)+(Ee>>>26)|0,Ee&=67108863,r=Math.imul(N,F),i=(i=Math.imul(N,K))+Math.imul(D,F)|0,o=Math.imul(D,K),r=r+Math.imul(L,H)|0,i=(i=i+Math.imul(L,W)|0)+Math.imul(I,H)|0,o=o+Math.imul(I,W)|0,r=r+Math.imul(R,V)|0,i=(i=i+Math.imul(R,Y)|0)+Math.imul(T,V)|0,o=o+Math.imul(T,Y)|0,r=r+Math.imul(C,Z)|0,i=(i=i+Math.imul(C,Q)|0)+Math.imul(x,Z)|0,o=o+Math.imul(x,Q)|0,r=r+Math.imul(E,X)|0,i=(i=i+Math.imul(E,ee)|0)+Math.imul(k,X)|0,o=o+Math.imul(k,ee)|0,r=r+Math.imul(w,ne)|0,i=(i=i+Math.imul(w,re)|0)+Math.imul(_,ne)|0,o=o+Math.imul(_,re)|0,r=r+Math.imul(v,oe)|0,i=(i=i+Math.imul(v,ae)|0)+Math.imul(b,oe)|0,o=o+Math.imul(b,ae)|0,r=r+Math.imul(p,ue)|0,i=(i=i+Math.imul(p,le)|0)+Math.imul(m,ue)|0,o=o+Math.imul(m,le)|0;var ke=(l+(r=r+Math.imul(d,de)|0)|0)+((8191&(i=(i=i+Math.imul(d,fe)|0)+Math.imul(f,de)|0))<<13)|0;l=((o=o+Math.imul(f,fe)|0)+(i>>>13)|0)+(ke>>>26)|0,ke&=67108863,r=Math.imul(B,F),i=(i=Math.imul(B,K))+Math.imul(z,F)|0,o=Math.imul(z,K),r=r+Math.imul(N,H)|0,i=(i=i+Math.imul(N,W)|0)+Math.imul(D,H)|0,o=o+Math.imul(D,W)|0,r=r+Math.imul(L,V)|0,i=(i=i+Math.imul(L,Y)|0)+Math.imul(I,V)|0,o=o+Math.imul(I,Y)|0,r=r+Math.imul(R,Z)|0,i=(i=i+Math.imul(R,Q)|0)+Math.imul(T,Z)|0,o=o+Math.imul(T,Q)|0,r=r+Math.imul(C,X)|0,i=(i=i+Math.imul(C,ee)|0)+Math.imul(x,X)|0,o=o+Math.imul(x,ee)|0,r=r+Math.imul(E,ne)|0,i=(i=i+Math.imul(E,re)|0)+Math.imul(k,ne)|0,o=o+Math.imul(k,re)|0,r=r+Math.imul(w,oe)|0,i=(i=i+Math.imul(w,ae)|0)+Math.imul(_,oe)|0,o=o+Math.imul(_,ae)|0,r=r+Math.imul(v,ue)|0,i=(i=i+Math.imul(v,le)|0)+Math.imul(b,ue)|0,o=o+Math.imul(b,le)|0,r=r+Math.imul(p,de)|0,i=(i=i+Math.imul(p,fe)|0)+Math.imul(m,de)|0,o=o+Math.imul(m,fe)|0;var Me=(l+(r=r+Math.imul(d,pe)|0)|0)+((8191&(i=(i=i+Math.imul(d,me)|0)+Math.imul(f,pe)|0))<<13)|0;l=((o=o+Math.imul(f,me)|0)+(i>>>13)|0)+(Me>>>26)|0,Me&=67108863,r=Math.imul(B,H),i=(i=Math.imul(B,W))+Math.imul(z,H)|0,o=Math.imul(z,W),r=r+Math.imul(N,V)|0,i=(i=i+Math.imul(N,Y)|0)+Math.imul(D,V)|0,o=o+Math.imul(D,Y)|0,r=r+Math.imul(L,Z)|0,i=(i=i+Math.imul(L,Q)|0)+Math.imul(I,Z)|0,o=o+Math.imul(I,Q)|0,r=r+Math.imul(R,X)|0,i=(i=i+Math.imul(R,ee)|0)+Math.imul(T,X)|0,o=o+Math.imul(T,ee)|0,r=r+Math.imul(C,ne)|0,i=(i=i+Math.imul(C,re)|0)+Math.imul(x,ne)|0,o=o+Math.imul(x,re)|0,r=r+Math.imul(E,oe)|0,i=(i=i+Math.imul(E,ae)|0)+Math.imul(k,oe)|0,o=o+Math.imul(k,ae)|0,r=r+Math.imul(w,ue)|0,i=(i=i+Math.imul(w,le)|0)+Math.imul(_,ue)|0,o=o+Math.imul(_,le)|0,r=r+Math.imul(v,de)|0,i=(i=i+Math.imul(v,fe)|0)+Math.imul(b,de)|0,o=o+Math.imul(b,fe)|0;var Ce=(l+(r=r+Math.imul(p,pe)|0)|0)+((8191&(i=(i=i+Math.imul(p,me)|0)+Math.imul(m,pe)|0))<<13)|0;l=((o=o+Math.imul(m,me)|0)+(i>>>13)|0)+(Ce>>>26)|0,Ce&=67108863,r=Math.imul(B,V),i=(i=Math.imul(B,Y))+Math.imul(z,V)|0,o=Math.imul(z,Y),r=r+Math.imul(N,Z)|0,i=(i=i+Math.imul(N,Q)|0)+Math.imul(D,Z)|0,o=o+Math.imul(D,Q)|0,r=r+Math.imul(L,X)|0,i=(i=i+Math.imul(L,ee)|0)+Math.imul(I,X)|0,o=o+Math.imul(I,ee)|0,r=r+Math.imul(R,ne)|0,i=(i=i+Math.imul(R,re)|0)+Math.imul(T,ne)|0,o=o+Math.imul(T,re)|0,r=r+Math.imul(C,oe)|0,i=(i=i+Math.imul(C,ae)|0)+Math.imul(x,oe)|0,o=o+Math.imul(x,ae)|0,r=r+Math.imul(E,ue)|0,i=(i=i+Math.imul(E,le)|0)+Math.imul(k,ue)|0,o=o+Math.imul(k,le)|0,r=r+Math.imul(w,de)|0,i=(i=i+Math.imul(w,fe)|0)+Math.imul(_,de)|0,o=o+Math.imul(_,fe)|0;var xe=(l+(r=r+Math.imul(v,pe)|0)|0)+((8191&(i=(i=i+Math.imul(v,me)|0)+Math.imul(b,pe)|0))<<13)|0;l=((o=o+Math.imul(b,me)|0)+(i>>>13)|0)+(xe>>>26)|0,xe&=67108863,r=Math.imul(B,Z),i=(i=Math.imul(B,Q))+Math.imul(z,Z)|0,o=Math.imul(z,Q),r=r+Math.imul(N,X)|0,i=(i=i+Math.imul(N,ee)|0)+Math.imul(D,X)|0,o=o+Math.imul(D,ee)|0,r=r+Math.imul(L,ne)|0,i=(i=i+Math.imul(L,re)|0)+Math.imul(I,ne)|0,o=o+Math.imul(I,re)|0,r=r+Math.imul(R,oe)|0,i=(i=i+Math.imul(R,ae)|0)+Math.imul(T,oe)|0,o=o+Math.imul(T,ae)|0,r=r+Math.imul(C,ue)|0,i=(i=i+Math.imul(C,le)|0)+Math.imul(x,ue)|0,o=o+Math.imul(x,le)|0,r=r+Math.imul(E,de)|0,i=(i=i+Math.imul(E,fe)|0)+Math.imul(k,de)|0,o=o+Math.imul(k,fe)|0;var Ae=(l+(r=r+Math.imul(w,pe)|0)|0)+((8191&(i=(i=i+Math.imul(w,me)|0)+Math.imul(_,pe)|0))<<13)|0;l=((o=o+Math.imul(_,me)|0)+(i>>>13)|0)+(Ae>>>26)|0,Ae&=67108863,r=Math.imul(B,X),i=(i=Math.imul(B,ee))+Math.imul(z,X)|0,o=Math.imul(z,ee),r=r+Math.imul(N,ne)|0,i=(i=i+Math.imul(N,re)|0)+Math.imul(D,ne)|0,o=o+Math.imul(D,re)|0,r=r+Math.imul(L,oe)|0,i=(i=i+Math.imul(L,ae)|0)+Math.imul(I,oe)|0,o=o+Math.imul(I,ae)|0,r=r+Math.imul(R,ue)|0,i=(i=i+Math.imul(R,le)|0)+Math.imul(T,ue)|0,o=o+Math.imul(T,le)|0,r=r+Math.imul(C,de)|0,i=(i=i+Math.imul(C,fe)|0)+Math.imul(x,de)|0,o=o+Math.imul(x,fe)|0;var Re=(l+(r=r+Math.imul(E,pe)|0)|0)+((8191&(i=(i=i+Math.imul(E,me)|0)+Math.imul(k,pe)|0))<<13)|0;l=((o=o+Math.imul(k,me)|0)+(i>>>13)|0)+(Re>>>26)|0,Re&=67108863,r=Math.imul(B,ne),i=(i=Math.imul(B,re))+Math.imul(z,ne)|0,o=Math.imul(z,re),r=r+Math.imul(N,oe)|0,i=(i=i+Math.imul(N,ae)|0)+Math.imul(D,oe)|0,o=o+Math.imul(D,ae)|0,r=r+Math.imul(L,ue)|0,i=(i=i+Math.imul(L,le)|0)+Math.imul(I,ue)|0,o=o+Math.imul(I,le)|0,r=r+Math.imul(R,de)|0,i=(i=i+Math.imul(R,fe)|0)+Math.imul(T,de)|0,o=o+Math.imul(T,fe)|0;var Te=(l+(r=r+Math.imul(C,pe)|0)|0)+((8191&(i=(i=i+Math.imul(C,me)|0)+Math.imul(x,pe)|0))<<13)|0;l=((o=o+Math.imul(x,me)|0)+(i>>>13)|0)+(Te>>>26)|0,Te&=67108863,r=Math.imul(B,oe),i=(i=Math.imul(B,ae))+Math.imul(z,oe)|0,o=Math.imul(z,ae),r=r+Math.imul(N,ue)|0,i=(i=i+Math.imul(N,le)|0)+Math.imul(D,ue)|0,o=o+Math.imul(D,le)|0,r=r+Math.imul(L,de)|0,i=(i=i+Math.imul(L,fe)|0)+Math.imul(I,de)|0,o=o+Math.imul(I,fe)|0;var Pe=(l+(r=r+Math.imul(R,pe)|0)|0)+((8191&(i=(i=i+Math.imul(R,me)|0)+Math.imul(T,pe)|0))<<13)|0;l=((o=o+Math.imul(T,me)|0)+(i>>>13)|0)+(Pe>>>26)|0,Pe&=67108863,r=Math.imul(B,ue),i=(i=Math.imul(B,le))+Math.imul(z,ue)|0,o=Math.imul(z,le),r=r+Math.imul(N,de)|0,i=(i=i+Math.imul(N,fe)|0)+Math.imul(D,de)|0,o=o+Math.imul(D,fe)|0;var Le=(l+(r=r+Math.imul(L,pe)|0)|0)+((8191&(i=(i=i+Math.imul(L,me)|0)+Math.imul(I,pe)|0))<<13)|0;l=((o=o+Math.imul(I,me)|0)+(i>>>13)|0)+(Le>>>26)|0,Le&=67108863,r=Math.imul(B,de),i=(i=Math.imul(B,fe))+Math.imul(z,de)|0,o=Math.imul(z,fe);var Ie=(l+(r=r+Math.imul(N,pe)|0)|0)+((8191&(i=(i=i+Math.imul(N,me)|0)+Math.imul(D,pe)|0))<<13)|0;l=((o=o+Math.imul(D,me)|0)+(i>>>13)|0)+(Ie>>>26)|0,Ie&=67108863;var Oe=(l+(r=Math.imul(B,pe))|0)+((8191&(i=(i=Math.imul(B,me))+Math.imul(z,pe)|0))<<13)|0;return l=((o=Math.imul(z,me))+(i>>>13)|0)+(Oe>>>26)|0,Oe&=67108863,u[0]=ge,u[1]=ve,u[2]=be,u[3]=ye,u[4]=we,u[5]=_e,u[6]=Se,u[7]=Ee,u[8]=ke,u[9]=Me,u[10]=Ce,u[11]=xe,u[12]=Ae,u[13]=Re,u[14]=Te,u[15]=Pe,u[16]=Le,u[17]=Ie,u[18]=Oe,0!==l&&(u[19]=l,n.length++),n};function p(e,t,n){return (new m).mulp(e,t,n)}function m(e,t){this.x=e,this.y=t;}Math.imul||(h=f),i.prototype.mulTo=function(e,t){var n,r=this.length+e.length;return n=10===this.length&&10===e.length?h(this,e,t):r<63?f(this,e,t):r<1024?function(e,t,n){n.negative=t.negative^e.negative,n.length=e.length+t.length;for(var r=0,i=0,o=0;o<n.length-1;o++){var a=i;i=0;for(var s=67108863&r,u=Math.min(o,t.length-1),l=Math.max(0,o-e.length+1);l<=u;l++){var c=o-l,d=(0|e.words[c])*(0|t.words[l]),f=67108863&d;s=67108863&(f=f+s|0),i+=(a=(a=a+(d/67108864|0)|0)+(f>>>26)|0)>>>26,a&=67108863;}n.words[o]=s,r=a,a=i;}return 0!==r?n.words[o]=r:n.length--,n.strip()}(this,e,t):p(this,e,t),n},m.prototype.makeRBT=function(e){for(var t=new Array(e),n=i.prototype._countBits(e)-1,r=0;r<e;r++)t[r]=this.revBin(r,n,e);return t},m.prototype.revBin=function(e,t,n){if(0===e||e===n-1)return e;for(var r=0,i=0;i<t;i++)r|=(1&e)<<t-i-1,e>>=1;return r},m.prototype.permute=function(e,t,n,r,i,o){for(var a=0;a<o;a++)r[a]=t[e[a]],i[a]=n[e[a]];},m.prototype.transform=function(e,t,n,r,i,o){this.permute(o,e,t,n,r,i);for(var a=1;a<i;a<<=1)for(var s=a<<1,u=Math.cos(2*Math.PI/s),l=Math.sin(2*Math.PI/s),c=0;c<i;c+=s)for(var d=u,f=l,h=0;h<a;h++){var p=n[c+h],m=r[c+h],g=n[c+h+a],v=r[c+h+a],b=d*g-f*v;v=d*v+f*g,g=b,n[c+h]=p+g,r[c+h]=m+v,n[c+h+a]=p-g,r[c+h+a]=m-v,h!==s&&(b=u*d-l*f,f=u*f+l*d,d=b);}},m.prototype.guessLen13b=function(e,t){var n=1|Math.max(t,e),r=1&n,i=0;for(n=n/2|0;n;n>>>=1)i++;return 1<<i+1+r},m.prototype.conjugate=function(e,t,n){if(!(n<=1))for(var r=0;r<n/2;r++){var i=e[r];e[r]=e[n-r-1],e[n-r-1]=i,i=t[r],t[r]=-t[n-r-1],t[n-r-1]=-i;}},m.prototype.normalize13b=function(e,t){for(var n=0,r=0;r<t/2;r++){var i=8192*Math.round(e[2*r+1]/t)+Math.round(e[2*r]/t)+n;e[r]=67108863&i,n=i<67108864?0:i/67108864|0;}return e},m.prototype.convert13b=function(e,t,r,i){for(var o=0,a=0;a<t;a++)o+=0|e[a],r[2*a]=8191&o,o>>>=13,r[2*a+1]=8191&o,o>>>=13;for(a=2*t;a<i;++a)r[a]=0;n(0===o),n(0==(-8192&o));},m.prototype.stub=function(e){for(var t=new Array(e),n=0;n<e;n++)t[n]=0;return t},m.prototype.mulp=function(e,t,n){var r=2*this.guessLen13b(e.length,t.length),i=this.makeRBT(r),o=this.stub(r),a=new Array(r),s=new Array(r),u=new Array(r),l=new Array(r),c=new Array(r),d=new Array(r),f=n.words;f.length=r,this.convert13b(e.words,e.length,a,r),this.convert13b(t.words,t.length,l,r),this.transform(a,o,s,u,r,i),this.transform(l,o,c,d,r,i);for(var h=0;h<r;h++){var p=s[h]*c[h]-u[h]*d[h];u[h]=s[h]*d[h]+u[h]*c[h],s[h]=p;}return this.conjugate(s,u,r),this.transform(s,u,f,o,r,i),this.conjugate(f,o,r),this.normalize13b(f,r),n.negative=e.negative^t.negative,n.length=e.length+t.length,n.strip()},i.prototype.mul=function(e){var t=new i(null);return t.words=new Array(this.length+e.length),this.mulTo(e,t)},i.prototype.mulf=function(e){var t=new i(null);return t.words=new Array(this.length+e.length),p(this,e,t)},i.prototype.imul=function(e){return this.clone().mulTo(e,this)},i.prototype.imuln=function(e){n("number"==typeof e),n(e<67108864);for(var t=0,r=0;r<this.length;r++){var i=(0|this.words[r])*e,o=(67108863&i)+(67108863&t);t>>=26,t+=i/67108864|0,t+=o>>>26,this.words[r]=67108863&o;}return 0!==t&&(this.words[r]=t,this.length++),this},i.prototype.muln=function(e){return this.clone().imuln(e)},i.prototype.sqr=function(){return this.mul(this)},i.prototype.isqr=function(){return this.imul(this.clone())},i.prototype.pow=function(e){var t=function(e){for(var t=new Array(e.bitLength()),n=0;n<t.length;n++){var r=n/26|0,i=n%26;t[n]=(e.words[r]&1<<i)>>>i;}return t}(e);if(0===t.length)return new i(1);for(var n=this,r=0;r<t.length&&0===t[r];r++,n=n.sqr());if(++r<t.length)for(var o=n.sqr();r<t.length;r++,o=o.sqr())0!==t[r]&&(n=n.mul(o));return n},i.prototype.iushln=function(e){n("number"==typeof e&&e>=0);var t,r=e%26,i=(e-r)/26,o=67108863>>>26-r<<26-r;if(0!==r){var a=0;for(t=0;t<this.length;t++){var s=this.words[t]&o,u=(0|this.words[t])-s<<r;this.words[t]=u|a,a=s>>>26-r;}a&&(this.words[t]=a,this.length++);}if(0!==i){for(t=this.length-1;t>=0;t--)this.words[t+i]=this.words[t];for(t=0;t<i;t++)this.words[t]=0;this.length+=i;}return this.strip()},i.prototype.ishln=function(e){return n(0===this.negative),this.iushln(e)},i.prototype.iushrn=function(e,t,r){var i;n("number"==typeof e&&e>=0),i=t?(t-t%26)/26:0;var o=e%26,a=Math.min((e-o)/26,this.length),s=67108863^67108863>>>o<<o,u=r;if(i-=a,i=Math.max(0,i),u){for(var l=0;l<a;l++)u.words[l]=this.words[l];u.length=a;}if(0===a);else if(this.length>a)for(this.length-=a,l=0;l<this.length;l++)this.words[l]=this.words[l+a];else this.words[0]=0,this.length=1;var c=0;for(l=this.length-1;l>=0&&(0!==c||l>=i);l--){var d=0|this.words[l];this.words[l]=c<<26-o|d>>>o,c=d&s;}return u&&0!==c&&(u.words[u.length++]=c),0===this.length&&(this.words[0]=0,this.length=1),this.strip()},i.prototype.ishrn=function(e,t,r){return n(0===this.negative),this.iushrn(e,t,r)},i.prototype.shln=function(e){return this.clone().ishln(e)},i.prototype.ushln=function(e){return this.clone().iushln(e)},i.prototype.shrn=function(e){return this.clone().ishrn(e)},i.prototype.ushrn=function(e){return this.clone().iushrn(e)},i.prototype.testn=function(e){n("number"==typeof e&&e>=0);var t=e%26,r=(e-t)/26,i=1<<t;return !(this.length<=r)&&!!(this.words[r]&i)},i.prototype.imaskn=function(e){n("number"==typeof e&&e>=0);var t=e%26,r=(e-t)/26;if(n(0===this.negative,"imaskn works only with positive numbers"),this.length<=r)return this;if(0!==t&&r++,this.length=Math.min(r,this.length),0!==t){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i;}return this.strip()},i.prototype.maskn=function(e){return this.clone().imaskn(e)},i.prototype.iaddn=function(e){return n("number"==typeof e),n(e<67108864),e<0?this.isubn(-e):0!==this.negative?1===this.length&&(0|this.words[0])<e?(this.words[0]=e-(0|this.words[0]),this.negative=0,this):(this.negative=0,this.isubn(e),this.negative=1,this):this._iaddn(e)},i.prototype._iaddn=function(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++)this.words[t]-=67108864,t===this.length-1?this.words[t+1]=1:this.words[t+1]++;return this.length=Math.max(this.length,t+1),this},i.prototype.isubn=function(e){if(n("number"==typeof e),n(e<67108864),e<0)return this.iaddn(-e);if(0!==this.negative)return this.negative=0,this.iaddn(e),this.negative=1,this;if(this.words[0]-=e,1===this.length&&this.words[0]<0)this.words[0]=-this.words[0],this.negative=1;else for(var t=0;t<this.length&&this.words[t]<0;t++)this.words[t]+=67108864,this.words[t+1]-=1;return this.strip()},i.prototype.addn=function(e){return this.clone().iaddn(e)},i.prototype.subn=function(e){return this.clone().isubn(e)},i.prototype.iabs=function(){return this.negative=0,this},i.prototype.abs=function(){return this.clone().iabs()},i.prototype._ishlnsubmul=function(e,t,r){var i,o,a=e.length+r;this._expand(a);var s=0;for(i=0;i<e.length;i++){o=(0|this.words[i+r])+s;var u=(0|e.words[i])*t;s=((o-=67108863&u)>>26)-(u/67108864|0),this.words[i+r]=67108863&o;}for(;i<this.length-r;i++)s=(o=(0|this.words[i+r])+s)>>26,this.words[i+r]=67108863&o;if(0===s)return this.strip();for(n(-1===s),s=0,i=0;i<this.length;i++)s=(o=-(0|this.words[i])+s)>>26,this.words[i]=67108863&o;return this.negative=1,this.strip()},i.prototype._wordDiv=function(e,t){var n=(this.length,e.length),r=this.clone(),o=e,a=0|o.words[o.length-1];0!==(n=26-this._countBits(a))&&(o=o.ushln(n),r.iushln(n),a=0|o.words[o.length-1]);var s,u=r.length-o.length;if("mod"!==t){(s=new i(null)).length=u+1,s.words=new Array(s.length);for(var l=0;l<s.length;l++)s.words[l]=0;}var c=r.clone()._ishlnsubmul(o,1,u);0===c.negative&&(r=c,s&&(s.words[u]=1));for(var d=u-1;d>=0;d--){var f=67108864*(0|r.words[o.length+d])+(0|r.words[o.length+d-1]);for(f=Math.min(f/a|0,67108863),r._ishlnsubmul(o,f,d);0!==r.negative;)f--,r.negative=0,r._ishlnsubmul(o,1,d),r.isZero()||(r.negative^=1);s&&(s.words[d]=f);}return s&&s.strip(),r.strip(),"div"!==t&&0!==n&&r.iushrn(n),{div:s||null,mod:r}},i.prototype.divmod=function(e,t,r){return n(!e.isZero()),this.isZero()?{div:new i(0),mod:new i(0)}:0!==this.negative&&0===e.negative?(s=this.neg().divmod(e,t),"mod"!==t&&(o=s.div.neg()),"div"!==t&&(a=s.mod.neg(),r&&0!==a.negative&&a.iadd(e)),{div:o,mod:a}):0===this.negative&&0!==e.negative?(s=this.divmod(e.neg(),t),"mod"!==t&&(o=s.div.neg()),{div:o,mod:s.mod}):0!=(this.negative&e.negative)?(s=this.neg().divmod(e.neg(),t),"div"!==t&&(a=s.mod.neg(),r&&0!==a.negative&&a.isub(e)),{div:s.div,mod:a}):e.length>this.length||this.cmp(e)<0?{div:new i(0),mod:this}:1===e.length?"div"===t?{div:this.divn(e.words[0]),mod:null}:"mod"===t?{div:null,mod:new i(this.modn(e.words[0]))}:{div:this.divn(e.words[0]),mod:new i(this.modn(e.words[0]))}:this._wordDiv(e,t);var o,a,s;},i.prototype.div=function(e){return this.divmod(e,"div",false).div},i.prototype.mod=function(e){return this.divmod(e,"mod",false).mod},i.prototype.umod=function(e){return this.divmod(e,"mod",true).mod},i.prototype.divRound=function(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var n=0!==t.div.negative?t.mod.isub(e):t.mod,r=e.ushrn(1),i=e.andln(1),o=n.cmp(r);return o<0||1===i&&0===o?t.div:0!==t.div.negative?t.div.isubn(1):t.div.iaddn(1)},i.prototype.modn=function(e){n(e<=67108863);for(var t=(1<<26)%e,r=0,i=this.length-1;i>=0;i--)r=(t*r+(0|this.words[i]))%e;return r},i.prototype.idivn=function(e){n(e<=67108863);for(var t=0,r=this.length-1;r>=0;r--){var i=(0|this.words[r])+67108864*t;this.words[r]=i/e|0,t=i%e;}return this.strip()},i.prototype.divn=function(e){return this.clone().idivn(e)},i.prototype.egcd=function(e){n(0===e.negative),n(!e.isZero());var t=this,r=e.clone();t=0!==t.negative?t.umod(e):t.clone();for(var o=new i(1),a=new i(0),s=new i(0),u=new i(1),l=0;t.isEven()&&r.isEven();)t.iushrn(1),r.iushrn(1),++l;for(var c=r.clone(),d=t.clone();!t.isZero();){for(var f=0,h=1;0==(t.words[0]&h)&&f<26;++f,h<<=1);if(f>0)for(t.iushrn(f);f-- >0;)(o.isOdd()||a.isOdd())&&(o.iadd(c),a.isub(d)),o.iushrn(1),a.iushrn(1);for(var p=0,m=1;0==(r.words[0]&m)&&p<26;++p,m<<=1);if(p>0)for(r.iushrn(p);p-- >0;)(s.isOdd()||u.isOdd())&&(s.iadd(c),u.isub(d)),s.iushrn(1),u.iushrn(1);t.cmp(r)>=0?(t.isub(r),o.isub(s),a.isub(u)):(r.isub(t),s.isub(o),u.isub(a));}return {a:s,b:u,gcd:r.iushln(l)}},i.prototype._invmp=function(e){n(0===e.negative),n(!e.isZero());var t=this,r=e.clone();t=0!==t.negative?t.umod(e):t.clone();for(var o,a=new i(1),s=new i(0),u=r.clone();t.cmpn(1)>0&&r.cmpn(1)>0;){for(var l=0,c=1;0==(t.words[0]&c)&&l<26;++l,c<<=1);if(l>0)for(t.iushrn(l);l-- >0;)a.isOdd()&&a.iadd(u),a.iushrn(1);for(var d=0,f=1;0==(r.words[0]&f)&&d<26;++d,f<<=1);if(d>0)for(r.iushrn(d);d-- >0;)s.isOdd()&&s.iadd(u),s.iushrn(1);t.cmp(r)>=0?(t.isub(r),a.isub(s)):(r.isub(t),s.isub(a));}return (o=0===t.cmpn(1)?a:s).cmpn(0)<0&&o.iadd(e),o},i.prototype.gcd=function(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone(),n=e.clone();t.negative=0,n.negative=0;for(var r=0;t.isEven()&&n.isEven();r++)t.iushrn(1),n.iushrn(1);for(;;){for(;t.isEven();)t.iushrn(1);for(;n.isEven();)n.iushrn(1);var i=t.cmp(n);if(i<0){var o=t;t=n,n=o;}else if(0===i||0===n.cmpn(1))break;t.isub(n);}return n.iushln(r)},i.prototype.invm=function(e){return this.egcd(e).a.umod(e)},i.prototype.isEven=function(){return 0==(1&this.words[0])},i.prototype.isOdd=function(){return 1==(1&this.words[0])},i.prototype.andln=function(e){return this.words[0]&e},i.prototype.bincn=function(e){n("number"==typeof e);var t=e%26,r=(e-t)/26,i=1<<t;if(this.length<=r)return this._expand(r+1),this.words[r]|=i,this;for(var o=i,a=r;0!==o&&a<this.length;a++){var s=0|this.words[a];o=(s+=o)>>>26,s&=67108863,this.words[a]=s;}return 0!==o&&(this.words[a]=o,this.length++),this},i.prototype.isZero=function(){return 1===this.length&&0===this.words[0]},i.prototype.cmpn=function(e){var t,r=e<0;if(0!==this.negative&&!r)return  -1;if(0===this.negative&&r)return 1;if(this.strip(),this.length>1)t=1;else {r&&(e=-e),n(e<=67108863,"Number is too big");var i=0|this.words[0];t=i===e?0:i<e?-1:1;}return 0!==this.negative?0|-t:t},i.prototype.cmp=function(e){if(0!==this.negative&&0===e.negative)return  -1;if(0===this.negative&&0!==e.negative)return 1;var t=this.ucmp(e);return 0!==this.negative?0|-t:t},i.prototype.ucmp=function(e){if(this.length>e.length)return 1;if(this.length<e.length)return  -1;for(var t=0,n=this.length-1;n>=0;n--){var r=0|this.words[n],i=0|e.words[n];if(r!==i){r<i?t=-1:r>i&&(t=1);break}}return t},i.prototype.gtn=function(e){return 1===this.cmpn(e)},i.prototype.gt=function(e){return 1===this.cmp(e)},i.prototype.gten=function(e){return this.cmpn(e)>=0},i.prototype.gte=function(e){return this.cmp(e)>=0},i.prototype.ltn=function(e){return  -1===this.cmpn(e)},i.prototype.lt=function(e){return  -1===this.cmp(e)},i.prototype.lten=function(e){return this.cmpn(e)<=0},i.prototype.lte=function(e){return this.cmp(e)<=0},i.prototype.eqn=function(e){return 0===this.cmpn(e)},i.prototype.eq=function(e){return 0===this.cmp(e)},i.red=function(e){return new S(e)},i.prototype.toRed=function(e){return n(!this.red,"Already a number in reduction context"),n(0===this.negative,"red works only with positives"),e.convertTo(this)._forceRed(e)},i.prototype.fromRed=function(){return n(this.red,"fromRed works only with numbers in reduction context"),this.red.convertFrom(this)},i.prototype._forceRed=function(e){return this.red=e,this},i.prototype.forceRed=function(e){return n(!this.red,"Already a number in reduction context"),this._forceRed(e)},i.prototype.redAdd=function(e){return n(this.red,"redAdd works only with red numbers"),this.red.add(this,e)},i.prototype.redIAdd=function(e){return n(this.red,"redIAdd works only with red numbers"),this.red.iadd(this,e)},i.prototype.redSub=function(e){return n(this.red,"redSub works only with red numbers"),this.red.sub(this,e)},i.prototype.redISub=function(e){return n(this.red,"redISub works only with red numbers"),this.red.isub(this,e)},i.prototype.redShl=function(e){return n(this.red,"redShl works only with red numbers"),this.red.shl(this,e)},i.prototype.redMul=function(e){return n(this.red,"redMul works only with red numbers"),this.red._verify2(this,e),this.red.mul(this,e)},i.prototype.redIMul=function(e){return n(this.red,"redMul works only with red numbers"),this.red._verify2(this,e),this.red.imul(this,e)},i.prototype.redSqr=function(){return n(this.red,"redSqr works only with red numbers"),this.red._verify1(this),this.red.sqr(this)},i.prototype.redISqr=function(){return n(this.red,"redISqr works only with red numbers"),this.red._verify1(this),this.red.isqr(this)},i.prototype.redSqrt=function(){return n(this.red,"redSqrt works only with red numbers"),this.red._verify1(this),this.red.sqrt(this)},i.prototype.redInvm=function(){return n(this.red,"redInvm works only with red numbers"),this.red._verify1(this),this.red.invm(this)},i.prototype.redNeg=function(){return n(this.red,"redNeg works only with red numbers"),this.red._verify1(this),this.red.neg(this)},i.prototype.redPow=function(e){return n(this.red&&!e.red,"redPow(normalNum)"),this.red._verify1(this),this.red.pow(this,e)};var g={k256:null,p224:null,p192:null,p25519:null};function v(e,t){this.name=e,this.p=new i(t,16),this.n=this.p.bitLength(),this.k=new i(1).iushln(this.n).isub(this.p),this.tmp=this._tmp();}function b(){v.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");}function y(){v.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");}function w(){v.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");}function _(){v.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");}function S(e){if("string"==typeof e){var t=i._prime(e);this.m=t.p,this.prime=t;}else n(e.gtn(1),"modulus must be greater than 1"),this.m=e,this.prime=null;}function E(e){S.call(this,e),this.shift=this.m.bitLength(),this.shift%26!=0&&(this.shift+=26-this.shift%26),this.r=new i(1).iushln(this.shift),this.r2=this.imod(this.r.sqr()),this.rinv=this.r._invmp(this.m),this.minv=this.rinv.mul(this.r).isubn(1).div(this.m),this.minv=this.minv.umod(this.r),this.minv=this.r.sub(this.minv);}v.prototype._tmp=function(){var e=new i(null);return e.words=new Array(Math.ceil(this.n/13)),e},v.prototype.ireduce=function(e){var t,n=e;do{this.split(n,this.tmp),t=(n=(n=this.imulK(n)).iadd(this.tmp)).bitLength();}while(t>this.n);var r=t<this.n?-1:n.ucmp(this.p);return 0===r?(n.words[0]=0,n.length=1):r>0?n.isub(this.p):void 0!==n.strip?n.strip():n._strip(),n},v.prototype.split=function(e,t){e.iushrn(this.n,0,t);},v.prototype.imulK=function(e){return e.imul(this.k)},r(b,v),b.prototype.split=function(e,t){for(var n=4194303,r=Math.min(e.length,9),i=0;i<r;i++)t.words[i]=e.words[i];if(t.length=r,e.length<=9)return e.words[0]=0,void(e.length=1);var o=e.words[9];for(t.words[t.length++]=o&n,i=10;i<e.length;i++){var a=0|e.words[i];e.words[i-10]=(a&n)<<4|o>>>22,o=a;}o>>>=22,e.words[i-10]=o,0===o&&e.length>10?e.length-=10:e.length-=9;},b.prototype.imulK=function(e){e.words[e.length]=0,e.words[e.length+1]=0,e.length+=2;for(var t=0,n=0;n<e.length;n++){var r=0|e.words[n];t+=977*r,e.words[n]=67108863&t,t=64*r+(t/67108864|0);}return 0===e.words[e.length-1]&&(e.length--,0===e.words[e.length-1]&&e.length--),e},r(y,v),r(w,v),r(_,v),_.prototype.imulK=function(e){for(var t=0,n=0;n<e.length;n++){var r=19*(0|e.words[n])+t,i=67108863&r;r>>>=26,e.words[n]=i,t=r;}return 0!==t&&(e.words[e.length++]=t),e},i._prime=function(e){if(g[e])return g[e];var t;if("k256"===e)t=new b;else if("p224"===e)t=new y;else if("p192"===e)t=new w;else {if("p25519"!==e)throw new Error("Unknown prime "+e);t=new _;}return g[e]=t,t},S.prototype._verify1=function(e){n(0===e.negative,"red works only with positives"),n(e.red,"red works only with red numbers");},S.prototype._verify2=function(e,t){n(0==(e.negative|t.negative),"red works only with positives"),n(e.red&&e.red===t.red,"red works only with red numbers");},S.prototype.imod=function(e){return this.prime?this.prime.ireduce(e)._forceRed(this):e.umod(this.m)._forceRed(this)},S.prototype.neg=function(e){return e.isZero()?e.clone():this.m.sub(e)._forceRed(this)},S.prototype.add=function(e,t){this._verify2(e,t);var n=e.add(t);return n.cmp(this.m)>=0&&n.isub(this.m),n._forceRed(this)},S.prototype.iadd=function(e,t){this._verify2(e,t);var n=e.iadd(t);return n.cmp(this.m)>=0&&n.isub(this.m),n},S.prototype.sub=function(e,t){this._verify2(e,t);var n=e.sub(t);return n.cmpn(0)<0&&n.iadd(this.m),n._forceRed(this)},S.prototype.isub=function(e,t){this._verify2(e,t);var n=e.isub(t);return n.cmpn(0)<0&&n.iadd(this.m),n},S.prototype.shl=function(e,t){return this._verify1(e),this.imod(e.ushln(t))},S.prototype.imul=function(e,t){return this._verify2(e,t),this.imod(e.imul(t))},S.prototype.mul=function(e,t){return this._verify2(e,t),this.imod(e.mul(t))},S.prototype.isqr=function(e){return this.imul(e,e.clone())},S.prototype.sqr=function(e){return this.mul(e,e)},S.prototype.sqrt=function(e){if(e.isZero())return e.clone();var t=this.m.andln(3);if(n(t%2==1),3===t){var r=this.m.add(new i(1)).iushrn(2);return this.pow(e,r)}for(var o=this.m.subn(1),a=0;!o.isZero()&&0===o.andln(1);)a++,o.iushrn(1);n(!o.isZero());var s=new i(1).toRed(this),u=s.redNeg(),l=this.m.subn(1).iushrn(1),c=this.m.bitLength();for(c=new i(2*c*c).toRed(this);0!==this.pow(c,l).cmp(u);)c.redIAdd(u);for(var d=this.pow(c,o),f=this.pow(e,o.addn(1).iushrn(1)),h=this.pow(e,o),p=a;0!==h.cmp(s);){for(var m=h,g=0;0!==m.cmp(s);g++)m=m.redSqr();n(g<p);var v=this.pow(d,new i(1).iushln(p-g-1));f=f.redMul(v),d=v.redSqr(),h=h.redMul(d),p=g;}return f},S.prototype.invm=function(e){var t=e._invmp(this.m);return 0!==t.negative?(t.negative=0,this.imod(t).redNeg()):this.imod(t)},S.prototype.pow=function(e,t){if(t.isZero())return new i(1).toRed(this);if(0===t.cmpn(1))return e.clone();var n=new Array(16);n[0]=new i(1).toRed(this),n[1]=e;for(var r=2;r<n.length;r++)n[r]=this.mul(n[r-1],e);var o=n[0],a=0,s=0,u=t.bitLength()%26;for(0===u&&(u=26),r=t.length-1;r>=0;r--){for(var l=t.words[r],c=u-1;c>=0;c--){var d=l>>c&1;o!==n[0]&&(o=this.sqr(o)),0!==d||0!==a?(a<<=1,a|=d,(4===++s||0===r&&0===c)&&(o=this.mul(o,n[a]),s=0,a=0)):s=0;}u=26;}return o},S.prototype.convertTo=function(e){var t=e.umod(this.m);return t===e?t.clone():t},S.prototype.convertFrom=function(e){var t=e.clone();return t.red=null,t},i.mont=function(e){return new E(e)},r(E,S),E.prototype.convertTo=function(e){return this.imod(e.ushln(this.shift))},E.prototype.convertFrom=function(e){var t=this.imod(e.mul(this.rinv));return t.red=null,t},E.prototype.imul=function(e,t){if(e.isZero()||t.isZero())return e.words[0]=0,e.length=1,e;var n=e.imul(t),r=n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),i=n.isub(r).iushrn(this.shift),o=i;return i.cmp(this.m)>=0?o=i.isub(this.m):i.cmpn(0)<0&&(o=i.iadd(this.m)),o._forceRed(this)},E.prototype.mul=function(e,t){if(e.isZero()||t.isZero())return new i(0)._forceRed(this);var n=e.mul(t),r=n.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m),o=n.isub(r).iushrn(this.shift),a=o;return o.cmp(this.m)>=0?a=o.isub(this.m):o.cmpn(0)<0&&(a=o.iadd(this.m)),a._forceRed(this)},E.prototype.invm=function(e){return this.imod(e._invmp(this.m).mul(this.r2))._forceRed(this)};}(e,n);}(mg);var gg=mg.exports,vg=bg;function bg(e,t){if(!e)throw new Error(t||"Assertion failed")}bg.equal=function(e,t,n){if(e!=t)throw new Error(n||"Assertion failed: "+e+" != "+t)};var yg={};!function(e){var t=e;function n(e){return 1===e.length?"0"+e:e}function r(e){for(var t="",r=0;r<e.length;r++)t+=n(e[r].toString(16));return t}t.toArray=function(e,t){if(Array.isArray(e))return e.slice();if(!e)return [];var n=[];if("string"!=typeof e){for(var r=0;r<e.length;r++)n[r]=0|e[r];return n}if("hex"===t){(e=e.replace(/[^a-z0-9]+/gi,"")).length%2!=0&&(e="0"+e);for(r=0;r<e.length;r+=2)n.push(parseInt(e[r]+e[r+1],16));}else for(r=0;r<e.length;r++){var i=e.charCodeAt(r),o=i>>8,a=255&i;o?n.push(o,a):n.push(a);}return n},t.zero2=n,t.toHex=r,t.encode=function(e,t){return "hex"===t?r(e):e};}(yg),function(e){var t=e,n=gg,r=vg,i=yg;t.assert=r,t.toArray=i.toArray,t.zero2=i.zero2,t.toHex=i.toHex,t.encode=i.encode,t.getNAF=function(e,t,n){var r=new Array(Math.max(e.bitLength(),n)+1);r.fill(0);for(var i=1<<t+1,o=e.clone(),a=0;a<r.length;a++){var s,u=o.andln(i-1);o.isOdd()?(s=u>(i>>1)-1?(i>>1)-u:u,o.isubn(s)):s=0,r[a]=s,o.iushrn(1);}return r},t.getJSF=function(e,t){var n=[[],[]];e=e.clone(),t=t.clone();for(var r,i=0,o=0;e.cmpn(-i)>0||t.cmpn(-o)>0;){var a,s,u=e.andln(3)+i&3,l=t.andln(3)+o&3;3===u&&(u=-1),3===l&&(l=-1),a=0==(1&u)?0:3!==(r=e.andln(7)+i&7)&&5!==r||2!==l?u:-u,n[0].push(a),s=0==(1&l)?0:3!==(r=t.andln(7)+o&7)&&5!==r||2!==u?l:-l,n[1].push(s),2*i===a+1&&(i=1-i),2*o===s+1&&(o=1-o),e.iushrn(1),t.iushrn(1);}return n},t.cachedProperty=function(e,t,n){var r="_"+t;e.prototype[t]=function(){return void 0!==this[r]?this[r]:this[r]=n.call(this)};},t.parseBytes=function(e){return "string"==typeof e?t.toArray(e,"hex"):e},t.intFromLE=function(e){return new n(e,"hex","le")};}(pg);var wg,_g={exports:{}};function Sg(e){this.rand=e;}if(_g.exports=function(e){return wg||(wg=new Sg(null)),wg.generate(e)},_g.exports.Rand=Sg,Sg.prototype.generate=function(e){return this._rand(e)},Sg.prototype._rand=function(e){if(this.rand.getBytes)return this.rand.getBytes(e);for(var t=new Uint8Array(e),n=0;n<t.length;n++)t[n]=this.rand.getByte();return t},"object"==typeof self)self.crypto&&self.crypto.getRandomValues?Sg.prototype._rand=function(e){var t=new Uint8Array(e);return self.crypto.getRandomValues(t),t}:self.msCrypto&&self.msCrypto.getRandomValues?Sg.prototype._rand=function(e){var t=new Uint8Array(e);return self.msCrypto.getRandomValues(t),t}:"object"==typeof window&&(Sg.prototype._rand=function(){throw new Error("Not implemented yet")});else try{var Eg=zm();if("function"!=typeof Eg.randomBytes)throw new Error("Not supported");Sg.prototype._rand=function(e){return Eg.randomBytes(e)};}catch(a){}var kg=_g.exports,Mg={},Cg=gg,xg=pg,Ag=xg.getNAF,Rg=xg.getJSF,Tg=xg.assert;function Pg(e,t){this.type=e,this.p=new Cg(t.p,16),this.red=t.prime?Cg.red(t.prime):Cg.mont(this.p),this.zero=new Cg(0).toRed(this.red),this.one=new Cg(1).toRed(this.red),this.two=new Cg(2).toRed(this.red),this.n=t.n&&new Cg(t.n,16),this.g=t.g&&this.pointFromJSON(t.g,t.gRed),this._wnafT1=new Array(4),this._wnafT2=new Array(4),this._wnafT3=new Array(4),this._wnafT4=new Array(4),this._bitLength=this.n?this.n.bitLength():0;var n=this.n&&this.p.div(this.n);!n||n.cmpn(100)>0?this.redN=null:(this._maxwellTrick=true,this.redN=this.n.toRed(this.red));}var Lg=Pg;function Ig(e,t){this.curve=e,this.type=t,this.precomputed=null;}Pg.prototype.point=function(){throw new Error("Not implemented")},Pg.prototype.validate=function(){throw new Error("Not implemented")},Pg.prototype._fixedNafMul=function(e,t){Tg(e.precomputed);var n=e._getDoubles(),r=Ag(t,1,this._bitLength),i=(1<<n.step+1)-(n.step%2==0?2:1);i/=3;var o,a,s=[];for(o=0;o<r.length;o+=n.step){a=0;for(var u=o+n.step-1;u>=o;u--)a=(a<<1)+r[u];s.push(a);}for(var l=this.jpoint(null,null,null),c=this.jpoint(null,null,null),d=i;d>0;d--){for(o=0;o<s.length;o++)(a=s[o])===d?c=c.mixedAdd(n.points[o]):a===-d&&(c=c.mixedAdd(n.points[o].neg()));l=l.add(c);}return l.toP()},Pg.prototype._wnafMul=function(e,t){var n=4,r=e._getNAFPoints(n);n=r.wnd;for(var i=r.points,o=Ag(t,n,this._bitLength),a=this.jpoint(null,null,null),s=o.length-1;s>=0;s--){for(var u=0;s>=0&&0===o[s];s--)u++;if(s>=0&&u++,a=a.dblp(u),s<0)break;var l=o[s];Tg(0!==l),a="affine"===e.type?l>0?a.mixedAdd(i[l-1>>1]):a.mixedAdd(i[-l-1>>1].neg()):l>0?a.add(i[l-1>>1]):a.add(i[-l-1>>1].neg());}return "affine"===e.type?a.toP():a},Pg.prototype._wnafMulAdd=function(e,t,n,r,i){var o,a,s,u=this._wnafT1,l=this._wnafT2,c=this._wnafT3,d=0;for(o=0;o<r;o++){var f=(s=t[o])._getNAFPoints(e);u[o]=f.wnd,l[o]=f.points;}for(o=r-1;o>=1;o-=2){var h=o-1,p=o;if(1===u[h]&&1===u[p]){var m=[t[h],null,null,t[p]];0===t[h].y.cmp(t[p].y)?(m[1]=t[h].add(t[p]),m[2]=t[h].toJ().mixedAdd(t[p].neg())):0===t[h].y.cmp(t[p].y.redNeg())?(m[1]=t[h].toJ().mixedAdd(t[p]),m[2]=t[h].add(t[p].neg())):(m[1]=t[h].toJ().mixedAdd(t[p]),m[2]=t[h].toJ().mixedAdd(t[p].neg()));var g=[-3,-1,-5,-7,0,7,5,1,3],v=Rg(n[h],n[p]);for(d=Math.max(v[0].length,d),c[h]=new Array(d),c[p]=new Array(d),a=0;a<d;a++){var b=0|v[0][a],y=0|v[1][a];c[h][a]=g[3*(b+1)+(y+1)],c[p][a]=0,l[h]=m;}}else c[h]=Ag(n[h],u[h],this._bitLength),c[p]=Ag(n[p],u[p],this._bitLength),d=Math.max(c[h].length,d),d=Math.max(c[p].length,d);}var w=this.jpoint(null,null,null),_=this._wnafT4;for(o=d;o>=0;o--){for(var S=0;o>=0;){var E=true;for(a=0;a<r;a++)_[a]=0|c[a][o],0!==_[a]&&(E=false);if(!E)break;S++,o--;}if(o>=0&&S++,w=w.dblp(S),o<0)break;for(a=0;a<r;a++){var k=_[a];0!==k&&(k>0?s=l[a][k-1>>1]:k<0&&(s=l[a][-k-1>>1].neg()),w="affine"===s.type?w.mixedAdd(s):w.add(s));}}for(o=0;o<r;o++)l[o]=null;return i?w:w.toP()},Pg.BasePoint=Ig,Ig.prototype.eq=function(){throw new Error("Not implemented")},Ig.prototype.validate=function(){return this.curve.validate(this)},Pg.prototype.decodePoint=function(e,t){e=xg.toArray(e,t);var n=this.p.byteLength();if((4===e[0]||6===e[0]||7===e[0])&&e.length-1==2*n)return 6===e[0]?Tg(e[e.length-1]%2==0):7===e[0]&&Tg(e[e.length-1]%2==1),this.point(e.slice(1,1+n),e.slice(1+n,1+2*n));if((2===e[0]||3===e[0])&&e.length-1===n)return this.pointFromX(e.slice(1,1+n),3===e[0]);throw new Error("Unknown point format")},Ig.prototype.encodeCompressed=function(e){return this.encode(e,true)},Ig.prototype._encode=function(e){var t=this.curve.p.byteLength(),n=this.getX().toArray("be",t);return e?[this.getY().isEven()?2:3].concat(n):[4].concat(n,this.getY().toArray("be",t))},Ig.prototype.encode=function(e,t){return xg.encode(this._encode(t),e)},Ig.prototype.precompute=function(e){if(this.precomputed)return this;var t={doubles:null,naf:null,beta:null};return t.naf=this._getNAFPoints(8),t.doubles=this._getDoubles(4,e),t.beta=this._getBeta(),this.precomputed=t,this},Ig.prototype._hasDoubles=function(e){if(!this.precomputed)return  false;var t=this.precomputed.doubles;return !!t&&t.points.length>=Math.ceil((e.bitLength()+1)/t.step)},Ig.prototype._getDoubles=function(e,t){if(this.precomputed&&this.precomputed.doubles)return this.precomputed.doubles;for(var n=[this],r=this,i=0;i<t;i+=e){for(var o=0;o<e;o++)r=r.dbl();n.push(r);}return {step:e,points:n}},Ig.prototype._getNAFPoints=function(e){if(this.precomputed&&this.precomputed.naf)return this.precomputed.naf;for(var t=[this],n=(1<<e)-1,r=1===n?null:this.dbl(),i=1;i<n;i++)t[i]=t[i-1].add(r);return {wnd:e,points:t}},Ig.prototype._getBeta=function(){return null},Ig.prototype.dblp=function(e){for(var t=this,n=0;n<e;n++)t=t.dbl();return t};var Og={exports:{}};"function"==typeof Object.create?Og.exports=function(e,t){t&&(e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}}));}:Og.exports=function(e,t){if(t){e.super_=t;var n=function(){};n.prototype=t.prototype,e.prototype=new n,e.prototype.constructor=e;}};var Ng=Og.exports,Dg=gg,jg=Ng,Bg=Lg,zg=pg.assert;function Ug(e){Bg.call(this,"short",e),this.a=new Dg(e.a,16).toRed(this.red),this.b=new Dg(e.b,16).toRed(this.red),this.tinv=this.two.redInvm(),this.zeroA=0===this.a.fromRed().cmpn(0),this.threeA=0===this.a.fromRed().sub(this.p).cmpn(-3),this.endo=this._getEndomorphism(e),this._endoWnafT1=new Array(4),this._endoWnafT2=new Array(4);}jg(Ug,Bg);var Fg=Ug;function Kg(e,t,n,r){Bg.BasePoint.call(this,e,"affine"),null===t&&null===n?(this.x=null,this.y=null,this.inf=true):(this.x=new Dg(t,16),this.y=new Dg(n,16),r&&(this.x.forceRed(this.curve.red),this.y.forceRed(this.curve.red)),this.x.red||(this.x=this.x.toRed(this.curve.red)),this.y.red||(this.y=this.y.toRed(this.curve.red)),this.inf=false);}function qg(e,t,n,r){Bg.BasePoint.call(this,e,"jacobian"),null===t&&null===n&&null===r?(this.x=this.curve.one,this.y=this.curve.one,this.z=new Dg(0)):(this.x=new Dg(t,16),this.y=new Dg(n,16),this.z=new Dg(r,16)),this.x.red||(this.x=this.x.toRed(this.curve.red)),this.y.red||(this.y=this.y.toRed(this.curve.red)),this.z.red||(this.z=this.z.toRed(this.curve.red)),this.zOne=this.z===this.curve.one;}Ug.prototype._getEndomorphism=function(e){if(this.zeroA&&this.g&&this.n&&1===this.p.modn(3)){var t,n;if(e.beta)t=new Dg(e.beta,16).toRed(this.red);else {var r=this._getEndoRoots(this.p);t=(t=r[0].cmp(r[1])<0?r[0]:r[1]).toRed(this.red);}if(e.lambda)n=new Dg(e.lambda,16);else {var i=this._getEndoRoots(this.n);0===this.g.mul(i[0]).x.cmp(this.g.x.redMul(t))?n=i[0]:(n=i[1],zg(0===this.g.mul(n).x.cmp(this.g.x.redMul(t))));}return {beta:t,lambda:n,basis:e.basis?e.basis.map((function(e){return {a:new Dg(e.a,16),b:new Dg(e.b,16)}})):this._getEndoBasis(n)}}},Ug.prototype._getEndoRoots=function(e){var t=e===this.p?this.red:Dg.mont(e),n=new Dg(2).toRed(t).redInvm(),r=n.redNeg(),i=new Dg(3).toRed(t).redNeg().redSqrt().redMul(n);return [r.redAdd(i).fromRed(),r.redSub(i).fromRed()]},Ug.prototype._getEndoBasis=function(e){for(var t,n,r,i,o,a,s,u,l,c=this.n.ushrn(Math.floor(this.n.bitLength()/2)),d=e,f=this.n.clone(),h=new Dg(1),p=new Dg(0),m=new Dg(0),g=new Dg(1),v=0;0!==d.cmpn(0);){var b=f.div(d);u=f.sub(b.mul(d)),l=m.sub(b.mul(h));var y=g.sub(b.mul(p));if(!r&&u.cmp(c)<0)t=s.neg(),n=h,r=u.neg(),i=l;else if(r&&2==++v)break;s=u,f=d,d=u,m=h,h=l,g=p,p=y;}o=u.neg(),a=l;var w=r.sqr().add(i.sqr());return o.sqr().add(a.sqr()).cmp(w)>=0&&(o=t,a=n),r.negative&&(r=r.neg(),i=i.neg()),o.negative&&(o=o.neg(),a=a.neg()),[{a:r,b:i},{a:o,b:a}]},Ug.prototype._endoSplit=function(e){var t=this.endo.basis,n=t[0],r=t[1],i=r.b.mul(e).divRound(this.n),o=n.b.neg().mul(e).divRound(this.n),a=i.mul(n.a),s=o.mul(r.a),u=i.mul(n.b),l=o.mul(r.b);return {k1:e.sub(a).sub(s),k2:u.add(l).neg()}},Ug.prototype.pointFromX=function(e,t){(e=new Dg(e,16)).red||(e=e.toRed(this.red));var n=e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b),r=n.redSqrt();if(0!==r.redSqr().redSub(n).cmp(this.zero))throw new Error("invalid point");var i=r.fromRed().isOdd();return (t&&!i||!t&&i)&&(r=r.redNeg()),this.point(e,r)},Ug.prototype.validate=function(e){if(e.inf)return  true;var t=e.x,n=e.y,r=this.a.redMul(t),i=t.redSqr().redMul(t).redIAdd(r).redIAdd(this.b);return 0===n.redSqr().redISub(i).cmpn(0)},Ug.prototype._endoWnafMulAdd=function(e,t,n){for(var r=this._endoWnafT1,i=this._endoWnafT2,o=0;o<e.length;o++){var a=this._endoSplit(t[o]),s=e[o],u=s._getBeta();a.k1.negative&&(a.k1.ineg(),s=s.neg(true)),a.k2.negative&&(a.k2.ineg(),u=u.neg(true)),r[2*o]=s,r[2*o+1]=u,i[2*o]=a.k1,i[2*o+1]=a.k2;}for(var l=this._wnafMulAdd(1,r,i,2*o,n),c=0;c<2*o;c++)r[c]=null,i[c]=null;return l},jg(Kg,Bg.BasePoint),Ug.prototype.point=function(e,t,n){return new Kg(this,e,t,n)},Ug.prototype.pointFromJSON=function(e,t){return Kg.fromJSON(this,e,t)},Kg.prototype._getBeta=function(){if(this.curve.endo){var e=this.precomputed;if(e&&e.beta)return e.beta;var t=this.curve.point(this.x.redMul(this.curve.endo.beta),this.y);if(e){var n=this.curve,r=function(e){return n.point(e.x.redMul(n.endo.beta),e.y)};e.beta=t,t.precomputed={beta:null,naf:e.naf&&{wnd:e.naf.wnd,points:e.naf.points.map(r)},doubles:e.doubles&&{step:e.doubles.step,points:e.doubles.points.map(r)}};}return t}},Kg.prototype.toJSON=function(){return this.precomputed?[this.x,this.y,this.precomputed&&{doubles:this.precomputed.doubles&&{step:this.precomputed.doubles.step,points:this.precomputed.doubles.points.slice(1)},naf:this.precomputed.naf&&{wnd:this.precomputed.naf.wnd,points:this.precomputed.naf.points.slice(1)}}]:[this.x,this.y]},Kg.fromJSON=function(e,t,n){"string"==typeof t&&(t=JSON.parse(t));var r=e.point(t[0],t[1],n);if(!t[2])return r;function i(t){return e.point(t[0],t[1],n)}var o=t[2];return r.precomputed={beta:null,doubles:o.doubles&&{step:o.doubles.step,points:[r].concat(o.doubles.points.map(i))},naf:o.naf&&{wnd:o.naf.wnd,points:[r].concat(o.naf.points.map(i))}},r},Kg.prototype.inspect=function(){return this.isInfinity()?"<EC Point Infinity>":"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+">"},Kg.prototype.isInfinity=function(){return this.inf},Kg.prototype.add=function(e){if(this.inf)return e;if(e.inf)return this;if(this.eq(e))return this.dbl();if(this.neg().eq(e))return this.curve.point(null,null);if(0===this.x.cmp(e.x))return this.curve.point(null,null);var t=this.y.redSub(e.y);0!==t.cmpn(0)&&(t=t.redMul(this.x.redSub(e.x).redInvm()));var n=t.redSqr().redISub(this.x).redISub(e.x),r=t.redMul(this.x.redSub(n)).redISub(this.y);return this.curve.point(n,r)},Kg.prototype.dbl=function(){if(this.inf)return this;var e=this.y.redAdd(this.y);if(0===e.cmpn(0))return this.curve.point(null,null);var t=this.curve.a,n=this.x.redSqr(),r=e.redInvm(),i=n.redAdd(n).redIAdd(n).redIAdd(t).redMul(r),o=i.redSqr().redISub(this.x.redAdd(this.x)),a=i.redMul(this.x.redSub(o)).redISub(this.y);return this.curve.point(o,a)},Kg.prototype.getX=function(){return this.x.fromRed()},Kg.prototype.getY=function(){return this.y.fromRed()},Kg.prototype.mul=function(e){return e=new Dg(e,16),this.isInfinity()?this:this._hasDoubles(e)?this.curve._fixedNafMul(this,e):this.curve.endo?this.curve._endoWnafMulAdd([this],[e]):this.curve._wnafMul(this,e)},Kg.prototype.mulAdd=function(e,t,n){var r=[this,t],i=[e,n];return this.curve.endo?this.curve._endoWnafMulAdd(r,i):this.curve._wnafMulAdd(1,r,i,2)},Kg.prototype.jmulAdd=function(e,t,n){var r=[this,t],i=[e,n];return this.curve.endo?this.curve._endoWnafMulAdd(r,i,true):this.curve._wnafMulAdd(1,r,i,2,true)},Kg.prototype.eq=function(e){return this===e||this.inf===e.inf&&(this.inf||0===this.x.cmp(e.x)&&0===this.y.cmp(e.y))},Kg.prototype.neg=function(e){if(this.inf)return this;var t=this.curve.point(this.x,this.y.redNeg());if(e&&this.precomputed){var n=this.precomputed,r=function(e){return e.neg()};t.precomputed={naf:n.naf&&{wnd:n.naf.wnd,points:n.naf.points.map(r)},doubles:n.doubles&&{step:n.doubles.step,points:n.doubles.points.map(r)}};}return t},Kg.prototype.toJ=function(){return this.inf?this.curve.jpoint(null,null,null):this.curve.jpoint(this.x,this.y,this.curve.one)},jg(qg,Bg.BasePoint),Ug.prototype.jpoint=function(e,t,n){return new qg(this,e,t,n)},qg.prototype.toP=function(){if(this.isInfinity())return this.curve.point(null,null);var e=this.z.redInvm(),t=e.redSqr(),n=this.x.redMul(t),r=this.y.redMul(t).redMul(e);return this.curve.point(n,r)},qg.prototype.neg=function(){return this.curve.jpoint(this.x,this.y.redNeg(),this.z)},qg.prototype.add=function(e){if(this.isInfinity())return e;if(e.isInfinity())return this;var t=e.z.redSqr(),n=this.z.redSqr(),r=this.x.redMul(t),i=e.x.redMul(n),o=this.y.redMul(t.redMul(e.z)),a=e.y.redMul(n.redMul(this.z)),s=r.redSub(i),u=o.redSub(a);if(0===s.cmpn(0))return 0!==u.cmpn(0)?this.curve.jpoint(null,null,null):this.dbl();var l=s.redSqr(),c=l.redMul(s),d=r.redMul(l),f=u.redSqr().redIAdd(c).redISub(d).redISub(d),h=u.redMul(d.redISub(f)).redISub(o.redMul(c)),p=this.z.redMul(e.z).redMul(s);return this.curve.jpoint(f,h,p)},qg.prototype.mixedAdd=function(e){if(this.isInfinity())return e.toJ();if(e.isInfinity())return this;var t=this.z.redSqr(),n=this.x,r=e.x.redMul(t),i=this.y,o=e.y.redMul(t).redMul(this.z),a=n.redSub(r),s=i.redSub(o);if(0===a.cmpn(0))return 0!==s.cmpn(0)?this.curve.jpoint(null,null,null):this.dbl();var u=a.redSqr(),l=u.redMul(a),c=n.redMul(u),d=s.redSqr().redIAdd(l).redISub(c).redISub(c),f=s.redMul(c.redISub(d)).redISub(i.redMul(l)),h=this.z.redMul(a);return this.curve.jpoint(d,f,h)},qg.prototype.dblp=function(e){if(0===e)return this;if(this.isInfinity())return this;if(!e)return this.dbl();var t;if(this.curve.zeroA||this.curve.threeA){var n=this;for(t=0;t<e;t++)n=n.dbl();return n}var r=this.curve.a,i=this.curve.tinv,o=this.x,a=this.y,s=this.z,u=s.redSqr().redSqr(),l=a.redAdd(a);for(t=0;t<e;t++){var c=o.redSqr(),d=l.redSqr(),f=d.redSqr(),h=c.redAdd(c).redIAdd(c).redIAdd(r.redMul(u)),p=o.redMul(d),m=h.redSqr().redISub(p.redAdd(p)),g=p.redISub(m),v=h.redMul(g);v=v.redIAdd(v).redISub(f);var b=l.redMul(s);t+1<e&&(u=u.redMul(f)),o=m,s=b,l=v;}return this.curve.jpoint(o,l.redMul(i),s)},qg.prototype.dbl=function(){return this.isInfinity()?this:this.curve.zeroA?this._zeroDbl():this.curve.threeA?this._threeDbl():this._dbl()},qg.prototype._zeroDbl=function(){var e,t,n;if(this.zOne){var r=this.x.redSqr(),i=this.y.redSqr(),o=i.redSqr(),a=this.x.redAdd(i).redSqr().redISub(r).redISub(o);a=a.redIAdd(a);var s=r.redAdd(r).redIAdd(r),u=s.redSqr().redISub(a).redISub(a),l=o.redIAdd(o);l=(l=l.redIAdd(l)).redIAdd(l),e=u,t=s.redMul(a.redISub(u)).redISub(l),n=this.y.redAdd(this.y);}else {var c=this.x.redSqr(),d=this.y.redSqr(),f=d.redSqr(),h=this.x.redAdd(d).redSqr().redISub(c).redISub(f);h=h.redIAdd(h);var p=c.redAdd(c).redIAdd(c),m=p.redSqr(),g=f.redIAdd(f);g=(g=g.redIAdd(g)).redIAdd(g),e=m.redISub(h).redISub(h),t=p.redMul(h.redISub(e)).redISub(g),n=(n=this.y.redMul(this.z)).redIAdd(n);}return this.curve.jpoint(e,t,n)},qg.prototype._threeDbl=function(){var e,t,n;if(this.zOne){var r=this.x.redSqr(),i=this.y.redSqr(),o=i.redSqr(),a=this.x.redAdd(i).redSqr().redISub(r).redISub(o);a=a.redIAdd(a);var s=r.redAdd(r).redIAdd(r).redIAdd(this.curve.a),u=s.redSqr().redISub(a).redISub(a);e=u;var l=o.redIAdd(o);l=(l=l.redIAdd(l)).redIAdd(l),t=s.redMul(a.redISub(u)).redISub(l),n=this.y.redAdd(this.y);}else {var c=this.z.redSqr(),d=this.y.redSqr(),f=this.x.redMul(d),h=this.x.redSub(c).redMul(this.x.redAdd(c));h=h.redAdd(h).redIAdd(h);var p=f.redIAdd(f),m=(p=p.redIAdd(p)).redAdd(p);e=h.redSqr().redISub(m),n=this.y.redAdd(this.z).redSqr().redISub(d).redISub(c);var g=d.redSqr();g=(g=(g=g.redIAdd(g)).redIAdd(g)).redIAdd(g),t=h.redMul(p.redISub(e)).redISub(g);}return this.curve.jpoint(e,t,n)},qg.prototype._dbl=function(){var e=this.curve.a,t=this.x,n=this.y,r=this.z,i=r.redSqr().redSqr(),o=t.redSqr(),a=n.redSqr(),s=o.redAdd(o).redIAdd(o).redIAdd(e.redMul(i)),u=t.redAdd(t),l=(u=u.redIAdd(u)).redMul(a),c=s.redSqr().redISub(l.redAdd(l)),d=l.redISub(c),f=a.redSqr();f=(f=(f=f.redIAdd(f)).redIAdd(f)).redIAdd(f);var h=s.redMul(d).redISub(f),p=n.redAdd(n).redMul(r);return this.curve.jpoint(c,h,p)},qg.prototype.trpl=function(){if(!this.curve.zeroA)return this.dbl().add(this);var e=this.x.redSqr(),t=this.y.redSqr(),n=this.z.redSqr(),r=t.redSqr(),i=e.redAdd(e).redIAdd(e),o=i.redSqr(),a=this.x.redAdd(t).redSqr().redISub(e).redISub(r),s=(a=(a=(a=a.redIAdd(a)).redAdd(a).redIAdd(a)).redISub(o)).redSqr(),u=r.redIAdd(r);u=(u=(u=u.redIAdd(u)).redIAdd(u)).redIAdd(u);var l=i.redIAdd(a).redSqr().redISub(o).redISub(s).redISub(u),c=t.redMul(l);c=(c=c.redIAdd(c)).redIAdd(c);var d=this.x.redMul(s).redISub(c);d=(d=d.redIAdd(d)).redIAdd(d);var f=this.y.redMul(l.redMul(u.redISub(l)).redISub(a.redMul(s)));f=(f=(f=f.redIAdd(f)).redIAdd(f)).redIAdd(f);var h=this.z.redAdd(a).redSqr().redISub(n).redISub(s);return this.curve.jpoint(d,f,h)},qg.prototype.mul=function(e,t){return e=new Dg(e,t),this.curve._wnafMul(this,e)},qg.prototype.eq=function(e){if("affine"===e.type)return this.eq(e.toJ());if(this===e)return  true;var t=this.z.redSqr(),n=e.z.redSqr();if(0!==this.x.redMul(n).redISub(e.x.redMul(t)).cmpn(0))return  false;var r=t.redMul(this.z),i=n.redMul(e.z);return 0===this.y.redMul(i).redISub(e.y.redMul(r)).cmpn(0)},qg.prototype.eqXToP=function(e){var t=this.z.redSqr(),n=e.toRed(this.curve.red).redMul(t);if(0===this.x.cmp(n))return  true;for(var r=e.clone(),i=this.curve.redN.redMul(t);;){if(r.iadd(this.curve.n),r.cmp(this.curve.p)>=0)return  false;if(n.redIAdd(i),0===this.x.cmp(n))return  true}},qg.prototype.inspect=function(){return this.isInfinity()?"<EC JPoint Infinity>":"<EC JPoint x: "+this.x.toString(16,2)+" y: "+this.y.toString(16,2)+" z: "+this.z.toString(16,2)+">"},qg.prototype.isInfinity=function(){return 0===this.z.cmpn(0)};var Hg=gg,Wg=Ng,$g=Lg,Vg=pg;function Yg(e){$g.call(this,"mont",e),this.a=new Hg(e.a,16).toRed(this.red),this.b=new Hg(e.b,16).toRed(this.red),this.i4=new Hg(4).toRed(this.red).redInvm(),this.two=new Hg(2).toRed(this.red),this.a24=this.i4.redMul(this.a.redAdd(this.two));}Wg(Yg,$g);var Gg=Yg;function Zg(e,t,n){$g.BasePoint.call(this,e,"projective"),null===t&&null===n?(this.x=this.curve.one,this.z=this.curve.zero):(this.x=new Hg(t,16),this.z=new Hg(n,16),this.x.red||(this.x=this.x.toRed(this.curve.red)),this.z.red||(this.z=this.z.toRed(this.curve.red)));}Yg.prototype.validate=function(e){var t=e.normalize().x,n=t.redSqr(),r=n.redMul(t).redAdd(n.redMul(this.a)).redAdd(t);return 0===r.redSqrt().redSqr().cmp(r)},Wg(Zg,$g.BasePoint),Yg.prototype.decodePoint=function(e,t){return this.point(Vg.toArray(e,t),1)},Yg.prototype.point=function(e,t){return new Zg(this,e,t)},Yg.prototype.pointFromJSON=function(e){return Zg.fromJSON(this,e)},Zg.prototype.precompute=function(){},Zg.prototype._encode=function(){return this.getX().toArray("be",this.curve.p.byteLength())},Zg.fromJSON=function(e,t){return new Zg(e,t[0],t[1]||e.one)},Zg.prototype.inspect=function(){return this.isInfinity()?"<EC Point Infinity>":"<EC Point x: "+this.x.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"},Zg.prototype.isInfinity=function(){return 0===this.z.cmpn(0)},Zg.prototype.dbl=function(){var e=this.x.redAdd(this.z).redSqr(),t=this.x.redSub(this.z).redSqr(),n=e.redSub(t),r=e.redMul(t),i=n.redMul(t.redAdd(this.curve.a24.redMul(n)));return this.curve.point(r,i)},Zg.prototype.add=function(){throw new Error("Not supported on Montgomery curve")},Zg.prototype.diffAdd=function(e,t){var n=this.x.redAdd(this.z),r=this.x.redSub(this.z),i=e.x.redAdd(e.z),o=e.x.redSub(e.z).redMul(n),a=i.redMul(r),s=t.z.redMul(o.redAdd(a).redSqr()),u=t.x.redMul(o.redISub(a).redSqr());return this.curve.point(s,u)},Zg.prototype.mul=function(e){for(var t=e.clone(),n=this,r=this.curve.point(null,null),i=[];0!==t.cmpn(0);t.iushrn(1))i.push(t.andln(1));for(var o=i.length-1;o>=0;o--)0===i[o]?(n=n.diffAdd(r,this),r=r.dbl()):(r=n.diffAdd(r,this),n=n.dbl());return r},Zg.prototype.mulAdd=function(){throw new Error("Not supported on Montgomery curve")},Zg.prototype.jumlAdd=function(){throw new Error("Not supported on Montgomery curve")},Zg.prototype.eq=function(e){return 0===this.getX().cmp(e.getX())},Zg.prototype.normalize=function(){return this.x=this.x.redMul(this.z.redInvm()),this.z=this.curve.one,this},Zg.prototype.getX=function(){return this.normalize(),this.x.fromRed()};var Qg=gg,Jg=Ng,Xg=Lg,ev=pg.assert;function tv(e){this.twisted=1!=(0|e.a),this.mOneA=this.twisted&&-1==(0|e.a),this.extended=this.mOneA,Xg.call(this,"edwards",e),this.a=new Qg(e.a,16).umod(this.red.m),this.a=this.a.toRed(this.red),this.c=new Qg(e.c,16).toRed(this.red),this.c2=this.c.redSqr(),this.d=new Qg(e.d,16).toRed(this.red),this.dd=this.d.redAdd(this.d),ev(!this.twisted||0===this.c.fromRed().cmpn(1)),this.oneC=1==(0|e.c);}Jg(tv,Xg);var nv=tv;function rv(e,t,n,r,i){Xg.BasePoint.call(this,e,"projective"),null===t&&null===n&&null===r?(this.x=this.curve.zero,this.y=this.curve.one,this.z=this.curve.one,this.t=this.curve.zero,this.zOne=true):(this.x=new Qg(t,16),this.y=new Qg(n,16),this.z=r?new Qg(r,16):this.curve.one,this.t=i&&new Qg(i,16),this.x.red||(this.x=this.x.toRed(this.curve.red)),this.y.red||(this.y=this.y.toRed(this.curve.red)),this.z.red||(this.z=this.z.toRed(this.curve.red)),this.t&&!this.t.red&&(this.t=this.t.toRed(this.curve.red)),this.zOne=this.z===this.curve.one,this.curve.extended&&!this.t&&(this.t=this.x.redMul(this.y),this.zOne||(this.t=this.t.redMul(this.z.redInvm()))));}tv.prototype._mulA=function(e){return this.mOneA?e.redNeg():this.a.redMul(e)},tv.prototype._mulC=function(e){return this.oneC?e:this.c.redMul(e)},tv.prototype.jpoint=function(e,t,n,r){return this.point(e,t,n,r)},tv.prototype.pointFromX=function(e,t){(e=new Qg(e,16)).red||(e=e.toRed(this.red));var n=e.redSqr(),r=this.c2.redSub(this.a.redMul(n)),i=this.one.redSub(this.c2.redMul(this.d).redMul(n)),o=r.redMul(i.redInvm()),a=o.redSqrt();if(0!==a.redSqr().redSub(o).cmp(this.zero))throw new Error("invalid point");var s=a.fromRed().isOdd();return (t&&!s||!t&&s)&&(a=a.redNeg()),this.point(e,a)},tv.prototype.pointFromY=function(e,t){(e=new Qg(e,16)).red||(e=e.toRed(this.red));var n=e.redSqr(),r=n.redSub(this.c2),i=n.redMul(this.d).redMul(this.c2).redSub(this.a),o=r.redMul(i.redInvm());if(0===o.cmp(this.zero)){if(t)throw new Error("invalid point");return this.point(this.zero,e)}var a=o.redSqrt();if(0!==a.redSqr().redSub(o).cmp(this.zero))throw new Error("invalid point");return a.fromRed().isOdd()!==t&&(a=a.redNeg()),this.point(a,e)},tv.prototype.validate=function(e){if(e.isInfinity())return  true;e.normalize();var t=e.x.redSqr(),n=e.y.redSqr(),r=t.redMul(this.a).redAdd(n),i=this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(n)));return 0===r.cmp(i)},Jg(rv,Xg.BasePoint),tv.prototype.pointFromJSON=function(e){return rv.fromJSON(this,e)},tv.prototype.point=function(e,t,n,r){return new rv(this,e,t,n,r)},rv.fromJSON=function(e,t){return new rv(e,t[0],t[1],t[2])},rv.prototype.inspect=function(){return this.isInfinity()?"<EC Point Infinity>":"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"},rv.prototype.isInfinity=function(){return 0===this.x.cmpn(0)&&(0===this.y.cmp(this.z)||this.zOne&&0===this.y.cmp(this.curve.c))},rv.prototype._extDbl=function(){var e=this.x.redSqr(),t=this.y.redSqr(),n=this.z.redSqr();n=n.redIAdd(n);var r=this.curve._mulA(e),i=this.x.redAdd(this.y).redSqr().redISub(e).redISub(t),o=r.redAdd(t),a=o.redSub(n),s=r.redSub(t),u=i.redMul(a),l=o.redMul(s),c=i.redMul(s),d=a.redMul(o);return this.curve.point(u,l,d,c)},rv.prototype._projDbl=function(){var e,t,n,r,i,o,a=this.x.redAdd(this.y).redSqr(),s=this.x.redSqr(),u=this.y.redSqr();if(this.curve.twisted){var l=(r=this.curve._mulA(s)).redAdd(u);this.zOne?(e=a.redSub(s).redSub(u).redMul(l.redSub(this.curve.two)),t=l.redMul(r.redSub(u)),n=l.redSqr().redSub(l).redSub(l)):(i=this.z.redSqr(),o=l.redSub(i).redISub(i),e=a.redSub(s).redISub(u).redMul(o),t=l.redMul(r.redSub(u)),n=l.redMul(o));}else r=s.redAdd(u),i=this.curve._mulC(this.z).redSqr(),o=r.redSub(i).redSub(i),e=this.curve._mulC(a.redISub(r)).redMul(o),t=this.curve._mulC(r).redMul(s.redISub(u)),n=r.redMul(o);return this.curve.point(e,t,n)},rv.prototype.dbl=function(){return this.isInfinity()?this:this.curve.extended?this._extDbl():this._projDbl()},rv.prototype._extAdd=function(e){var t=this.y.redSub(this.x).redMul(e.y.redSub(e.x)),n=this.y.redAdd(this.x).redMul(e.y.redAdd(e.x)),r=this.t.redMul(this.curve.dd).redMul(e.t),i=this.z.redMul(e.z.redAdd(e.z)),o=n.redSub(t),a=i.redSub(r),s=i.redAdd(r),u=n.redAdd(t),l=o.redMul(a),c=s.redMul(u),d=o.redMul(u),f=a.redMul(s);return this.curve.point(l,c,f,d)},rv.prototype._projAdd=function(e){var t,n,r=this.z.redMul(e.z),i=r.redSqr(),o=this.x.redMul(e.x),a=this.y.redMul(e.y),s=this.curve.d.redMul(o).redMul(a),u=i.redSub(s),l=i.redAdd(s),c=this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(o).redISub(a),d=r.redMul(u).redMul(c);return this.curve.twisted?(t=r.redMul(l).redMul(a.redSub(this.curve._mulA(o))),n=u.redMul(l)):(t=r.redMul(l).redMul(a.redSub(o)),n=this.curve._mulC(u).redMul(l)),this.curve.point(d,t,n)},rv.prototype.add=function(e){return this.isInfinity()?e:e.isInfinity()?this:this.curve.extended?this._extAdd(e):this._projAdd(e)},rv.prototype.mul=function(e){return this._hasDoubles(e)?this.curve._fixedNafMul(this,e):this.curve._wnafMul(this,e)},rv.prototype.mulAdd=function(e,t,n){return this.curve._wnafMulAdd(1,[this,t],[e,n],2,false)},rv.prototype.jmulAdd=function(e,t,n){return this.curve._wnafMulAdd(1,[this,t],[e,n],2,true)},rv.prototype.normalize=function(){if(this.zOne)return this;var e=this.z.redInvm();return this.x=this.x.redMul(e),this.y=this.y.redMul(e),this.t&&(this.t=this.t.redMul(e)),this.z=this.curve.one,this.zOne=true,this},rv.prototype.neg=function(){return this.curve.point(this.x.redNeg(),this.y,this.z,this.t&&this.t.redNeg())},rv.prototype.getX=function(){return this.normalize(),this.x.fromRed()},rv.prototype.getY=function(){return this.normalize(),this.y.fromRed()},rv.prototype.eq=function(e){return this===e||0===this.getX().cmp(e.getX())&&0===this.getY().cmp(e.getY())},rv.prototype.eqXToP=function(e){var t=e.toRed(this.curve.red).redMul(this.z);if(0===this.x.cmp(t))return  true;for(var n=e.clone(),r=this.curve.redN.redMul(this.z);;){if(n.iadd(this.curve.n),n.cmp(this.curve.p)>=0)return  false;if(t.redIAdd(r),0===this.x.cmp(t))return  true}},rv.prototype.toP=rv.prototype.normalize,rv.prototype.mixedAdd=rv.prototype.add,function(e){var t=e;t.base=Lg,t.short=Fg,t.mont=Gg,t.edwards=nv;}(Mg);var iv={},ov={},av={},sv=vg,uv=Ng;function lv(e,t){return 55296==(64512&e.charCodeAt(t))&&(!(t<0||t+1>=e.length)&&56320==(64512&e.charCodeAt(t+1)))}function cv(e){return (e>>>24|e>>>8&65280|e<<8&16711680|(255&e)<<24)>>>0}function dv(e){return 1===e.length?"0"+e:e}function fv(e){return 7===e.length?"0"+e:6===e.length?"00"+e:5===e.length?"000"+e:4===e.length?"0000"+e:3===e.length?"00000"+e:2===e.length?"000000"+e:1===e.length?"0000000"+e:e}av.inherits=uv,av.toArray=function(e,t){if(Array.isArray(e))return e.slice();if(!e)return [];var n=[];if("string"==typeof e)if(t){if("hex"===t)for((e=e.replace(/[^a-z0-9]+/gi,"")).length%2!=0&&(e="0"+e),i=0;i<e.length;i+=2)n.push(parseInt(e[i]+e[i+1],16));}else for(var r=0,i=0;i<e.length;i++){var o=e.charCodeAt(i);o<128?n[r++]=o:o<2048?(n[r++]=o>>6|192,n[r++]=63&o|128):lv(e,i)?(o=65536+((1023&o)<<10)+(1023&e.charCodeAt(++i)),n[r++]=o>>18|240,n[r++]=o>>12&63|128,n[r++]=o>>6&63|128,n[r++]=63&o|128):(n[r++]=o>>12|224,n[r++]=o>>6&63|128,n[r++]=63&o|128);}else for(i=0;i<e.length;i++)n[i]=0|e[i];return n},av.toHex=function(e){for(var t="",n=0;n<e.length;n++)t+=dv(e[n].toString(16));return t},av.htonl=cv,av.toHex32=function(e,t){for(var n="",r=0;r<e.length;r++){var i=e[r];"little"===t&&(i=cv(i)),n+=fv(i.toString(16));}return n},av.zero2=dv,av.zero8=fv,av.join32=function(e,t,n,r){var i=n-t;sv(i%4==0);for(var o=new Array(i/4),a=0,s=t;a<o.length;a++,s+=4){var u;u="big"===r?e[s]<<24|e[s+1]<<16|e[s+2]<<8|e[s+3]:e[s+3]<<24|e[s+2]<<16|e[s+1]<<8|e[s],o[a]=u>>>0;}return o},av.split32=function(e,t){for(var n=new Array(4*e.length),r=0,i=0;r<e.length;r++,i+=4){var o=e[r];"big"===t?(n[i]=o>>>24,n[i+1]=o>>>16&255,n[i+2]=o>>>8&255,n[i+3]=255&o):(n[i+3]=o>>>24,n[i+2]=o>>>16&255,n[i+1]=o>>>8&255,n[i]=255&o);}return n},av.rotr32=function(e,t){return e>>>t|e<<32-t},av.rotl32=function(e,t){return e<<t|e>>>32-t},av.sum32=function(e,t){return e+t>>>0},av.sum32_3=function(e,t,n){return e+t+n>>>0},av.sum32_4=function(e,t,n,r){return e+t+n+r>>>0},av.sum32_5=function(e,t,n,r,i){return e+t+n+r+i>>>0},av.sum64=function(e,t,n,r){var i=e[t],o=r+e[t+1]>>>0,a=(o<r?1:0)+n+i;e[t]=a>>>0,e[t+1]=o;},av.sum64_hi=function(e,t,n,r){return (t+r>>>0<t?1:0)+e+n>>>0},av.sum64_lo=function(e,t,n,r){return t+r>>>0},av.sum64_4_hi=function(e,t,n,r,i,o,a,s){var u=0,l=t;return u+=(l=l+r>>>0)<t?1:0,u+=(l=l+o>>>0)<o?1:0,e+n+i+a+(u+=(l=l+s>>>0)<s?1:0)>>>0},av.sum64_4_lo=function(e,t,n,r,i,o,a,s){return t+r+o+s>>>0},av.sum64_5_hi=function(e,t,n,r,i,o,a,s,u,l){var c=0,d=t;return c+=(d=d+r>>>0)<t?1:0,c+=(d=d+o>>>0)<o?1:0,c+=(d=d+s>>>0)<s?1:0,e+n+i+a+u+(c+=(d=d+l>>>0)<l?1:0)>>>0},av.sum64_5_lo=function(e,t,n,r,i,o,a,s,u,l){return t+r+o+s+l>>>0},av.rotr64_hi=function(e,t,n){return (t<<32-n|e>>>n)>>>0},av.rotr64_lo=function(e,t,n){return (e<<32-n|t>>>n)>>>0},av.shr64_hi=function(e,t,n){return e>>>n},av.shr64_lo=function(e,t,n){return (e<<32-n|t>>>n)>>>0};var hv={},pv=av,mv=vg;function gv(){this.pending=null,this.pendingTotal=0,this.blockSize=this.constructor.blockSize,this.outSize=this.constructor.outSize,this.hmacStrength=this.constructor.hmacStrength,this.padLength=this.constructor.padLength/8,this.endian="big",this._delta8=this.blockSize/8,this._delta32=this.blockSize/32;}hv.BlockHash=gv,gv.prototype.update=function(e,t){if(e=pv.toArray(e,t),this.pending?this.pending=this.pending.concat(e):this.pending=e,this.pendingTotal+=e.length,this.pending.length>=this._delta8){var n=(e=this.pending).length%this._delta8;this.pending=e.slice(e.length-n,e.length),0===this.pending.length&&(this.pending=null),e=pv.join32(e,0,e.length-n,this.endian);for(var r=0;r<e.length;r+=this._delta32)this._update(e,r,r+this._delta32);}return this},gv.prototype.digest=function(e){return this.update(this._pad()),mv(null===this.pending),this._digest(e)},gv.prototype._pad=function(){var e=this.pendingTotal,t=this._delta8,n=t-(e+this.padLength)%t,r=new Array(n+this.padLength);r[0]=128;for(var i=1;i<n;i++)r[i]=0;if(e<<=3,"big"===this.endian){for(var o=8;o<this.padLength;o++)r[i++]=0;r[i++]=0,r[i++]=0,r[i++]=0,r[i++]=0,r[i++]=e>>>24&255,r[i++]=e>>>16&255,r[i++]=e>>>8&255,r[i++]=255&e;}else for(r[i++]=255&e,r[i++]=e>>>8&255,r[i++]=e>>>16&255,r[i++]=e>>>24&255,r[i++]=0,r[i++]=0,r[i++]=0,r[i++]=0,o=8;o<this.padLength;o++)r[i++]=0;return r};var vv={},bv={},yv=av.rotr32;function wv(e,t,n){return e&t^~e&n}function _v(e,t,n){return e&t^e&n^t&n}function Sv(e,t,n){return e^t^n}bv.ft_1=function(e,t,n,r){return 0===e?wv(t,n,r):1===e||3===e?Sv(t,n,r):2===e?_v(t,n,r):void 0},bv.ch32=wv,bv.maj32=_v,bv.p32=Sv,bv.s0_256=function(e){return yv(e,2)^yv(e,13)^yv(e,22)},bv.s1_256=function(e){return yv(e,6)^yv(e,11)^yv(e,25)},bv.g0_256=function(e){return yv(e,7)^yv(e,18)^e>>>3},bv.g1_256=function(e){return yv(e,17)^yv(e,19)^e>>>10};var Ev=av,kv=hv,Mv=bv,Cv=Ev.rotl32,xv=Ev.sum32,Av=Ev.sum32_5,Rv=Mv.ft_1,Tv=kv.BlockHash,Pv=[1518500249,1859775393,2400959708,3395469782];function Lv(){if(!(this instanceof Lv))return new Lv;Tv.call(this),this.h=[1732584193,4023233417,2562383102,271733878,3285377520],this.W=new Array(80);}Ev.inherits(Lv,Tv);var Iv=Lv;Lv.blockSize=512,Lv.outSize=160,Lv.hmacStrength=80,Lv.padLength=64,Lv.prototype._update=function(e,t){for(var n=this.W,r=0;r<16;r++)n[r]=e[t+r];for(;r<n.length;r++)n[r]=Cv(n[r-3]^n[r-8]^n[r-14]^n[r-16],1);var i=this.h[0],o=this.h[1],a=this.h[2],s=this.h[3],u=this.h[4];for(r=0;r<n.length;r++){var l=~~(r/20),c=Av(Cv(i,5),Rv(l,o,a,s),u,n[r],Pv[l]);u=s,s=a,a=Cv(o,30),o=i,i=c;}this.h[0]=xv(this.h[0],i),this.h[1]=xv(this.h[1],o),this.h[2]=xv(this.h[2],a),this.h[3]=xv(this.h[3],s),this.h[4]=xv(this.h[4],u);},Lv.prototype._digest=function(e){return "hex"===e?Ev.toHex32(this.h,"big"):Ev.split32(this.h,"big")};var Ov=av,Nv=hv,Dv=bv,jv=vg,Bv=Ov.sum32,zv=Ov.sum32_4,Uv=Ov.sum32_5,Fv=Dv.ch32,Kv=Dv.maj32,qv=Dv.s0_256,Hv=Dv.s1_256,Wv=Dv.g0_256,$v=Dv.g1_256,Vv=Nv.BlockHash,Yv=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function Gv(){if(!(this instanceof Gv))return new Gv;Vv.call(this),this.h=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225],this.k=Yv,this.W=new Array(64);}Ov.inherits(Gv,Vv);var Zv=Gv;Gv.blockSize=512,Gv.outSize=256,Gv.hmacStrength=192,Gv.padLength=64,Gv.prototype._update=function(e,t){for(var n=this.W,r=0;r<16;r++)n[r]=e[t+r];for(;r<n.length;r++)n[r]=zv($v(n[r-2]),n[r-7],Wv(n[r-15]),n[r-16]);var i=this.h[0],o=this.h[1],a=this.h[2],s=this.h[3],u=this.h[4],l=this.h[5],c=this.h[6],d=this.h[7];for(jv(this.k.length===n.length),r=0;r<n.length;r++){var f=Uv(d,Hv(u),Fv(u,l,c),this.k[r],n[r]),h=Bv(qv(i),Kv(i,o,a));d=c,c=l,l=u,u=Bv(s,f),s=a,a=o,o=i,i=Bv(f,h);}this.h[0]=Bv(this.h[0],i),this.h[1]=Bv(this.h[1],o),this.h[2]=Bv(this.h[2],a),this.h[3]=Bv(this.h[3],s),this.h[4]=Bv(this.h[4],u),this.h[5]=Bv(this.h[5],l),this.h[6]=Bv(this.h[6],c),this.h[7]=Bv(this.h[7],d);},Gv.prototype._digest=function(e){return "hex"===e?Ov.toHex32(this.h,"big"):Ov.split32(this.h,"big")};var Qv=av,Jv=Zv;function Xv(){if(!(this instanceof Xv))return new Xv;Jv.call(this),this.h=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428];}Qv.inherits(Xv,Jv);var eb=Xv;Xv.blockSize=512,Xv.outSize=224,Xv.hmacStrength=192,Xv.padLength=64,Xv.prototype._digest=function(e){return "hex"===e?Qv.toHex32(this.h.slice(0,7),"big"):Qv.split32(this.h.slice(0,7),"big")};var tb=av,nb=hv,rb=vg,ib=tb.rotr64_hi,ob=tb.rotr64_lo,ab=tb.shr64_hi,sb=tb.shr64_lo,ub=tb.sum64,lb=tb.sum64_hi,cb=tb.sum64_lo,db=tb.sum64_4_hi,fb=tb.sum64_4_lo,hb=tb.sum64_5_hi,pb=tb.sum64_5_lo,mb=nb.BlockHash,gb=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];function vb(){if(!(this instanceof vb))return new vb;mb.call(this),this.h=[1779033703,4089235720,3144134277,2227873595,1013904242,4271175723,2773480762,1595750129,1359893119,2917565137,2600822924,725511199,528734635,4215389547,1541459225,327033209],this.k=gb,this.W=new Array(160);}tb.inherits(vb,mb);var bb=vb;function yb(e,t,n,r,i){var o=e&n^~e&i;return o<0&&(o+=4294967296),o}function wb(e,t,n,r,i,o){var a=t&r^~t&o;return a<0&&(a+=4294967296),a}function _b(e,t,n,r,i){var o=e&n^e&i^n&i;return o<0&&(o+=4294967296),o}function Sb(e,t,n,r,i,o){var a=t&r^t&o^r&o;return a<0&&(a+=4294967296),a}function Eb(e,t){var n=ib(e,t,28)^ib(t,e,2)^ib(t,e,7);return n<0&&(n+=4294967296),n}function kb(e,t){var n=ob(e,t,28)^ob(t,e,2)^ob(t,e,7);return n<0&&(n+=4294967296),n}function Mb(e,t){var n=ib(e,t,14)^ib(e,t,18)^ib(t,e,9);return n<0&&(n+=4294967296),n}function Cb(e,t){var n=ob(e,t,14)^ob(e,t,18)^ob(t,e,9);return n<0&&(n+=4294967296),n}function xb(e,t){var n=ib(e,t,1)^ib(e,t,8)^ab(e,t,7);return n<0&&(n+=4294967296),n}function Ab(e,t){var n=ob(e,t,1)^ob(e,t,8)^sb(e,t,7);return n<0&&(n+=4294967296),n}function Rb(e,t){var n=ib(e,t,19)^ib(t,e,29)^ab(e,t,6);return n<0&&(n+=4294967296),n}function Tb(e,t){var n=ob(e,t,19)^ob(t,e,29)^sb(e,t,6);return n<0&&(n+=4294967296),n}vb.blockSize=1024,vb.outSize=512,vb.hmacStrength=192,vb.padLength=128,vb.prototype._prepareBlock=function(e,t){for(var n=this.W,r=0;r<32;r++)n[r]=e[t+r];for(;r<n.length;r+=2){var i=Rb(n[r-4],n[r-3]),o=Tb(n[r-4],n[r-3]),a=n[r-14],s=n[r-13],u=xb(n[r-30],n[r-29]),l=Ab(n[r-30],n[r-29]),c=n[r-32],d=n[r-31];n[r]=db(i,o,a,s,u,l,c,d),n[r+1]=fb(i,o,a,s,u,l,c,d);}},vb.prototype._update=function(e,t){this._prepareBlock(e,t);var n=this.W,r=this.h[0],i=this.h[1],o=this.h[2],a=this.h[3],s=this.h[4],u=this.h[5],l=this.h[6],c=this.h[7],d=this.h[8],f=this.h[9],h=this.h[10],p=this.h[11],m=this.h[12],g=this.h[13],v=this.h[14],b=this.h[15];rb(this.k.length===n.length);for(var y=0;y<n.length;y+=2){var w=v,_=b,S=Mb(d,f),E=Cb(d,f),k=yb(d,f,h,p,m),M=wb(d,f,h,p,m,g),C=this.k[y],x=this.k[y+1],A=n[y],R=n[y+1],T=hb(w,_,S,E,k,M,C,x,A,R),P=pb(w,_,S,E,k,M,C,x,A,R);w=Eb(r,i),_=kb(r,i),S=_b(r,i,o,a,s),E=Sb(r,i,o,a,s,u);var L=lb(w,_,S,E),I=cb(w,_,S,E);v=m,b=g,m=h,g=p,h=d,p=f,d=lb(l,c,T,P),f=cb(c,c,T,P),l=s,c=u,s=o,u=a,o=r,a=i,r=lb(T,P,L,I),i=cb(T,P,L,I);}ub(this.h,0,r,i),ub(this.h,2,o,a),ub(this.h,4,s,u),ub(this.h,6,l,c),ub(this.h,8,d,f),ub(this.h,10,h,p),ub(this.h,12,m,g),ub(this.h,14,v,b);},vb.prototype._digest=function(e){return "hex"===e?tb.toHex32(this.h,"big"):tb.split32(this.h,"big")};var Pb=av,Lb=bb;function Ib(){if(!(this instanceof Ib))return new Ib;Lb.call(this),this.h=[3418070365,3238371032,1654270250,914150663,2438529370,812702999,355462360,4144912697,1731405415,4290775857,2394180231,1750603025,3675008525,1694076839,1203062813,3204075428];}Pb.inherits(Ib,Lb);var Ob=Ib;Ib.blockSize=1024,Ib.outSize=384,Ib.hmacStrength=192,Ib.padLength=128,Ib.prototype._digest=function(e){return "hex"===e?Pb.toHex32(this.h.slice(0,12),"big"):Pb.split32(this.h.slice(0,12),"big")},vv.sha1=Iv,vv.sha224=eb,vv.sha256=Zv,vv.sha384=Ob,vv.sha512=bb;var Nb={},Db=av,jb=hv,Bb=Db.rotl32,zb=Db.sum32,Ub=Db.sum32_3,Fb=Db.sum32_4,Kb=jb.BlockHash;function qb(){if(!(this instanceof qb))return new qb;Kb.call(this),this.h=[1732584193,4023233417,2562383102,271733878,3285377520],this.endian="little";}function Hb(e,t,n,r){return e<=15?t^n^r:e<=31?t&n|~t&r:e<=47?(t|~n)^r:e<=63?t&r|n&~r:t^(n|~r)}function Wb(e){return e<=15?0:e<=31?1518500249:e<=47?1859775393:e<=63?2400959708:2840853838}function $b(e){return e<=15?1352829926:e<=31?1548603684:e<=47?1836072691:e<=63?2053994217:0}Db.inherits(qb,Kb),Nb.ripemd160=qb,qb.blockSize=512,qb.outSize=160,qb.hmacStrength=192,qb.padLength=64,qb.prototype._update=function(e,t){for(var n=this.h[0],r=this.h[1],i=this.h[2],o=this.h[3],a=this.h[4],s=n,u=r,l=i,c=o,d=a,f=0;f<80;f++){var h=zb(Bb(Fb(n,Hb(f,r,i,o),e[Vb[f]+t],Wb(f)),Gb[f]),a);n=a,a=o,o=Bb(i,10),i=r,r=h,h=zb(Bb(Fb(s,Hb(79-f,u,l,c),e[Yb[f]+t],$b(f)),Zb[f]),d),s=d,d=c,c=Bb(l,10),l=u,u=h;}h=Ub(this.h[1],i,c),this.h[1]=Ub(this.h[2],o,d),this.h[2]=Ub(this.h[3],a,s),this.h[3]=Ub(this.h[4],n,u),this.h[4]=Ub(this.h[0],r,l),this.h[0]=h;},qb.prototype._digest=function(e){return "hex"===e?Db.toHex32(this.h,"little"):Db.split32(this.h,"little")};var Vb=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13],Yb=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11],Gb=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6],Zb=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11],Qb=av,Jb=vg;function Xb(e,t,n){if(!(this instanceof Xb))return new Xb(e,t,n);this.Hash=e,this.blockSize=e.blockSize/8,this.outSize=e.outSize/8,this.inner=null,this.outer=null,this._init(Qb.toArray(t,n));}var ey,ty,ny=Xb;Xb.prototype._init=function(e){e.length>this.blockSize&&(e=(new this.Hash).update(e).digest()),Jb(e.length<=this.blockSize);for(var t=e.length;t<this.blockSize;t++)e.push(0);for(t=0;t<e.length;t++)e[t]^=54;for(this.inner=(new this.Hash).update(e),t=0;t<e.length;t++)e[t]^=106;this.outer=(new this.Hash).update(e);},Xb.prototype.update=function(e,t){return this.inner.update(e,t),this},Xb.prototype.digest=function(e){return this.outer.update(this.inner.digest()),this.outer.digest(e)},function(e){var t=e;t.utils=av,t.common=hv,t.sha=vv,t.ripemd=Nb,t.hmac=ny,t.sha1=t.sha.sha1,t.sha256=t.sha.sha256,t.sha224=t.sha.sha224,t.sha384=t.sha.sha384,t.sha512=t.sha.sha512,t.ripemd160=t.ripemd.ripemd160;}(ov),function(e){var t,n=e,r=ov,i=Mg,o=pg.assert;function a(e){"short"===e.type?this.curve=new i.short(e):"edwards"===e.type?this.curve=new i.edwards(e):this.curve=new i.mont(e),this.g=this.curve.g,this.n=this.curve.n,this.hash=e.hash,o(this.g.validate(),"Invalid curve"),o(this.g.mul(this.n).isInfinity(),"Invalid curve, G*N != O");}function s(e,t){Object.defineProperty(n,e,{configurable:true,enumerable:true,get:function(){var r=new a(t);return Object.defineProperty(n,e,{configurable:true,enumerable:true,value:r}),r}});}n.PresetCurve=a,s("p192",{type:"short",prime:"p192",p:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",a:"ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",b:"64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",n:"ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",hash:r.sha256,gRed:false,g:["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012","07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]}),s("p224",{type:"short",prime:"p224",p:"ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",a:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",b:"b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",n:"ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",hash:r.sha256,gRed:false,g:["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21","bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]}),s("p256",{type:"short",prime:null,p:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",a:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",b:"5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",n:"ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",hash:r.sha256,gRed:false,g:["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296","4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]}),s("p384",{type:"short",prime:null,p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",a:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",b:"b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",n:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",hash:r.sha384,gRed:false,g:["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7","3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]}),s("p521",{type:"short",prime:null,p:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",a:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",b:"00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",n:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",hash:r.sha512,gRed:false,g:["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66","00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"]}),s("curve25519",{type:"mont",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"76d06",b:"1",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:r.sha256,gRed:false,g:["9"]}),s("ed25519",{type:"edwards",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"-1",c:"1",d:"52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:r.sha256,gRed:false,g:["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a","6666666666666666666666666666666666666666666666666666666666666658"]});try{t=ty?ey:(ty=1,ey={doubles:{step:4,points:[["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a","f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"],["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508","11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"],["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739","d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"],["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640","4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"],["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c","4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"],["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda","96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"],["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa","5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"],["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0","cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"],["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d","9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"],["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d","e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"],["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1","9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"],["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0","5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"],["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047","10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"],["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862","283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"],["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7","7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"],["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd","56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"],["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83","7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"],["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a","53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"],["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8","bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"],["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d","4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"],["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725","7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"],["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754","4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"],["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c","17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"],["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6","6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"],["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39","c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"],["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891","893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"],["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b","febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"],["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03","2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"],["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d","eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"],["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070","7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"],["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4","e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"],["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da","662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"],["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11","1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"],["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e","efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"],["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41","2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"],["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef","67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"],["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8","db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"],["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d","648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"],["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96","35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"],["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd","ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"],["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5","9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"],["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266","40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"],["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71","34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"],["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac","c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"],["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751","1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"],["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e","493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"],["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241","c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"],["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3","be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"],["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f","4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"],["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19","aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"],["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be","b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"],["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9","6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"],["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2","8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"],["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13","7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"],["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c","ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"],["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba","2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"],["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151","e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"],["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073","d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"],["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458","38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"],["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b","69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"],["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366","d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"],["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa","40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"],["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0","620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"],["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787","7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"],["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e","ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]},naf:{wnd:7,points:[["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9","388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"],["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4","d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"],["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc","6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"],["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe","cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"],["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb","d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"],["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8","ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"],["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e","581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"],["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34","4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"],["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c","85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"],["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5","321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"],["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f","2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"],["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714","73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"],["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729","a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"],["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db","2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"],["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4","e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"],["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5","b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"],["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479","2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"],["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d","80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"],["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f","1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"],["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb","d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"],["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9","eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"],["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963","758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"],["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74","958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"],["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530","e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"],["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b","5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"],["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247","cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"],["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1","cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"],["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120","4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"],["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435","91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"],["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18","673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"],["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8","59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"],["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb","3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"],["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f","55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"],["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143","efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"],["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba","e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"],["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45","f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"],["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a","744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"],["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e","c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"],["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8","e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"],["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c","30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"],["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519","e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"],["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab","100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"],["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca","ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"],["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf","8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"],["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610","68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"],["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4","f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"],["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c","d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"],["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940","edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"],["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980","a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"],["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3","66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"],["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf","9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"],["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63","4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"],["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448","fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"],["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf","5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"],["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5","8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"],["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6","8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"],["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5","5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"],["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99","f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"],["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51","f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"],["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5","42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"],["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5","204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"],["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997","4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"],["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881","73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"],["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5","39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"],["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66","d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"],["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726","ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"],["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede","6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"],["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94","60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"],["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31","3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"],["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51","b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"],["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252","ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"],["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5","cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"],["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b","6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"],["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4","322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"],["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f","6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"],["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889","2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"],["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246","b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"],["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984","998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"],["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a","b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"],["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030","bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"],["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197","6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"],["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593","c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"],["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef","21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"],["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38","60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"],["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a","49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"],["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111","5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"],["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502","7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"],["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea","be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"],["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26","8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"],["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986","39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"],["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e","62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"],["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4","25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"],["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda","ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"],["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859","cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"],["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f","f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"],["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c","6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"],["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942","fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"],["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a","1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"],["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80","5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"],["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d","438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"],["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1","cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"],["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63","c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"],["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352","6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"],["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193","ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"],["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00","9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"],["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58","ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"],["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7","d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"],["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8","c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"],["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e","67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"],["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d","cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"],["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b","299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"],["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f","f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"],["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6","462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"],["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297","62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"],["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a","7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"],["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c","ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"],["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52","4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"],["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb","bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"],["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065","bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"],["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917","603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"],["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9","cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"],["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3","553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"],["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57","712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"],["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66","ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"],["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8","9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"],["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721","9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"],["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180","4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]}});}catch(e){t=void 0;}s("secp256k1",{type:"short",prime:"k256",p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",a:"0",b:"7",n:"ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",h:"1",hash:r.sha256,beta:"7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",lambda:"5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",basis:[{a:"3086d221a7d46bcde86c90e49284eb15",b:"-e4437ed6010e88286f547fa90abfe4c3"},{a:"114ca50f7a8e2f3f657c1108d9d44cfd8",b:"3086d221a7d46bcde86c90e49284eb15"}],gRed:false,g:["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798","483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",t]});}(iv);var ry=ov,iy=yg,oy=vg;function ay(e){if(!(this instanceof ay))return new ay(e);this.hash=e.hash,this.predResist=!!e.predResist,this.outLen=this.hash.outSize,this.minEntropy=e.minEntropy||this.hash.hmacStrength,this._reseed=null,this.reseedInterval=null,this.K=null,this.V=null;var t=iy.toArray(e.entropy,e.entropyEnc||"hex"),n=iy.toArray(e.nonce,e.nonceEnc||"hex"),r=iy.toArray(e.pers,e.persEnc||"hex");oy(t.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits"),this._init(t,n,r);}var sy=ay;ay.prototype._init=function(e,t,n){var r=e.concat(t).concat(n);this.K=new Array(this.outLen/8),this.V=new Array(this.outLen/8);for(var i=0;i<this.V.length;i++)this.K[i]=0,this.V[i]=1;this._update(r),this._reseed=1,this.reseedInterval=281474976710656;},ay.prototype._hmac=function(){return new ry.hmac(this.hash,this.K)},ay.prototype._update=function(e){var t=this._hmac().update(this.V).update([0]);e&&(t=t.update(e)),this.K=t.digest(),this.V=this._hmac().update(this.V).digest(),e&&(this.K=this._hmac().update(this.V).update([1]).update(e).digest(),this.V=this._hmac().update(this.V).digest());},ay.prototype.reseed=function(e,t,n,r){"string"!=typeof t&&(r=n,n=t,t=null),e=iy.toArray(e,t),n=iy.toArray(n,r),oy(e.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits"),this._update(e.concat(n||[])),this._reseed=1;},ay.prototype.generate=function(e,t,n,r){if(this._reseed>this.reseedInterval)throw new Error("Reseed is required");"string"!=typeof t&&(r=n,n=t,t=null),n&&(n=iy.toArray(n,r||"hex"),this._update(n));for(var i=[];i.length<e;)this.V=this._hmac().update(this.V).digest(),i=i.concat(this.V);var o=i.slice(0,e);return this._update(n),this._reseed++,iy.encode(o,t)};var uy=gg,ly=pg.assert;function cy(e,t){this.ec=e,this.priv=null,this.pub=null,t.priv&&this._importPrivate(t.priv,t.privEnc),t.pub&&this._importPublic(t.pub,t.pubEnc);}var dy=cy;cy.fromPublic=function(e,t,n){return t instanceof cy?t:new cy(e,{pub:t,pubEnc:n})},cy.fromPrivate=function(e,t,n){return t instanceof cy?t:new cy(e,{priv:t,privEnc:n})},cy.prototype.validate=function(){var e=this.getPublic();return e.isInfinity()?{result:false,reason:"Invalid public key"}:e.validate()?e.mul(this.ec.curve.n).isInfinity()?{result:true,reason:null}:{result:false,reason:"Public key * N != O"}:{result:false,reason:"Public key is not a point"}},cy.prototype.getPublic=function(e,t){return "string"==typeof e&&(t=e,e=null),this.pub||(this.pub=this.ec.g.mul(this.priv)),t?this.pub.encode(t,e):this.pub},cy.prototype.getPrivate=function(e){return "hex"===e?this.priv.toString(16,2):this.priv},cy.prototype._importPrivate=function(e,t){this.priv=new uy(e,t||16),this.priv=this.priv.umod(this.ec.curve.n);},cy.prototype._importPublic=function(e,t){if(e.x||e.y)return "mont"===this.ec.curve.type?ly(e.x,"Need x coordinate"):"short"!==this.ec.curve.type&&"edwards"!==this.ec.curve.type||ly(e.x&&e.y,"Need both x and y coordinate"),void(this.pub=this.ec.curve.point(e.x,e.y));this.pub=this.ec.curve.decodePoint(e,t);},cy.prototype.derive=function(e){return e.validate()||ly(e.validate(),"public point not validated"),e.mul(this.priv).getX()},cy.prototype.sign=function(e,t,n){return this.ec.sign(e,this,t,n)},cy.prototype.verify=function(e,t){return this.ec.verify(e,t,this)},cy.prototype.inspect=function(){return "<Key priv: "+(this.priv&&this.priv.toString(16,2))+" pub: "+(this.pub&&this.pub.inspect())+" >"};var fy=gg,hy=pg,py=hy.assert;function my(e,t){if(e instanceof my)return e;this._importDER(e,t)||(py(e.r&&e.s,"Signature without r or s"),this.r=new fy(e.r,16),this.s=new fy(e.s,16),void 0===e.recoveryParam?this.recoveryParam=null:this.recoveryParam=e.recoveryParam);}var gy=my;function vy(){this.place=0;}function by(e,t){var n=e[t.place++];if(!(128&n))return n;var r=15&n;if(0===r||r>4)return  false;for(var i=0,o=0,a=t.place;o<r;o++,a++)i<<=8,i|=e[a],i>>>=0;return !(i<=127)&&(t.place=a,i)}function yy(e){for(var t=0,n=e.length-1;!e[t]&&!(128&e[t+1])&&t<n;)t++;return 0===t?e:e.slice(t)}function wy(e,t){if(t<128)e.push(t);else {var n=1+(Math.log(t)/Math.LN2>>>3);for(e.push(128|n);--n;)e.push(t>>>(n<<3)&255);e.push(t);}}my.prototype._importDER=function(e,t){e=hy.toArray(e,t);var n=new vy;if(48!==e[n.place++])return  false;var r=by(e,n);if(false===r)return  false;if(r+n.place!==e.length)return  false;if(2!==e[n.place++])return  false;var i=by(e,n);if(false===i)return  false;var o=e.slice(n.place,i+n.place);if(n.place+=i,2!==e[n.place++])return  false;var a=by(e,n);if(false===a)return  false;if(e.length!==a+n.place)return  false;var s=e.slice(n.place,a+n.place);if(0===o[0]){if(!(128&o[1]))return  false;o=o.slice(1);}if(0===s[0]){if(!(128&s[1]))return  false;s=s.slice(1);}return this.r=new fy(o),this.s=new fy(s),this.recoveryParam=null,true},my.prototype.toDER=function(e){var t=this.r.toArray(),n=this.s.toArray();for(128&t[0]&&(t=[0].concat(t)),128&n[0]&&(n=[0].concat(n)),t=yy(t),n=yy(n);!(n[0]||128&n[1]);)n=n.slice(1);var r=[2];wy(r,t.length),(r=r.concat(t)).push(2),wy(r,n.length);var i=r.concat(n),o=[48];return wy(o,i.length),o=o.concat(i),hy.encode(o,e)};var _y=gg,Sy=sy,Ey=iv,ky=kg,My=pg.assert,Cy=dy,xy=gy;function Ay(e){if(!(this instanceof Ay))return new Ay(e);"string"==typeof e&&(My(Object.prototype.hasOwnProperty.call(Ey,e),"Unknown curve "+e),e=Ey[e]),e instanceof Ey.PresetCurve&&(e={curve:e}),this.curve=e.curve.curve,this.n=this.curve.n,this.nh=this.n.ushrn(1),this.g=this.curve.g,this.g=e.curve.g,this.g.precompute(e.curve.n.bitLength()+1),this.hash=e.hash||e.curve.hash;}var Ry=Ay;Ay.prototype.keyPair=function(e){return new Cy(this,e)},Ay.prototype.keyFromPrivate=function(e,t){return Cy.fromPrivate(this,e,t)},Ay.prototype.keyFromPublic=function(e,t){return Cy.fromPublic(this,e,t)},Ay.prototype.genKeyPair=function(e){e||(e={});for(var t=new Sy({hash:this.hash,pers:e.pers,persEnc:e.persEnc||"utf8",entropy:e.entropy||ky(this.hash.hmacStrength),entropyEnc:e.entropy&&e.entropyEnc||"utf8",nonce:this.n.toArray()}),n=this.n.byteLength(),r=this.n.sub(new _y(2));;){var i=new _y(t.generate(n));if(!(i.cmp(r)>0))return i.iaddn(1),this.keyFromPrivate(i)}},Ay.prototype._truncateToN=function(e,t){var n=8*e.byteLength()-this.n.bitLength();return n>0&&(e=e.ushrn(n)),!t&&e.cmp(this.n)>=0?e.sub(this.n):e},Ay.prototype.sign=function(e,t,n,r){"object"==typeof n&&(r=n,n=null),r||(r={}),t=this.keyFromPrivate(t,n),e=this._truncateToN(new _y(e,16));for(var i=this.n.byteLength(),o=t.getPrivate().toArray("be",i),a=e.toArray("be",i),s=new Sy({hash:this.hash,entropy:o,nonce:a,pers:r.pers,persEnc:r.persEnc||"utf8"}),u=this.n.sub(new _y(1)),l=0;;l++){var c=r.k?r.k(l):new _y(s.generate(this.n.byteLength()));if(!((c=this._truncateToN(c,true)).cmpn(1)<=0||c.cmp(u)>=0)){var d=this.g.mul(c);if(!d.isInfinity()){var f=d.getX(),h=f.umod(this.n);if(0!==h.cmpn(0)){var p=c.invm(this.n).mul(h.mul(t.getPrivate()).iadd(e));if(0!==(p=p.umod(this.n)).cmpn(0)){var m=(d.getY().isOdd()?1:0)|(0!==f.cmp(h)?2:0);return r.canonical&&p.cmp(this.nh)>0&&(p=this.n.sub(p),m^=1),new xy({r:h,s:p,recoveryParam:m})}}}}}},Ay.prototype.verify=function(e,t,n,r){e=this._truncateToN(new _y(e,16)),n=this.keyFromPublic(n,r);var i=(t=new xy(t,"hex")).r,o=t.s;if(i.cmpn(1)<0||i.cmp(this.n)>=0)return  false;if(o.cmpn(1)<0||o.cmp(this.n)>=0)return  false;var a,s=o.invm(this.n),u=s.mul(e).umod(this.n),l=s.mul(i).umod(this.n);return this.curve._maxwellTrick?!(a=this.g.jmulAdd(u,n.getPublic(),l)).isInfinity()&&a.eqXToP(i):!(a=this.g.mulAdd(u,n.getPublic(),l)).isInfinity()&&0===a.getX().umod(this.n).cmp(i)},Ay.prototype.recoverPubKey=function(e,t,n,r){My((3&n)===n,"The recovery param is more than two bits"),t=new xy(t,r);var i=this.n,o=new _y(e),a=t.r,s=t.s,u=1&n,l=n>>1;if(a.cmp(this.curve.p.umod(this.curve.n))>=0&&l)throw new Error("Unable to find sencond key candinate");a=l?this.curve.pointFromX(a.add(this.curve.n),u):this.curve.pointFromX(a,u);var c=t.r.invm(i),d=i.sub(o).mul(c).umod(i),f=s.mul(c).umod(i);return this.g.mulAdd(d,a,f)},Ay.prototype.getKeyRecoveryParam=function(e,t,n,r){if(null!==(t=new xy(t,r)).recoveryParam)return t.recoveryParam;for(var i=0;i<4;i++){var o;try{o=this.recoverPubKey(e,t,i);}catch(e){continue}if(o.eq(n))return i}throw new Error("Unable to find valid recovery factor")};var Ty=pg,Py=Ty.assert,Ly=Ty.parseBytes,Iy=Ty.cachedProperty;function Oy(e,t){this.eddsa=e,this._secret=Ly(t.secret),e.isPoint(t.pub)?this._pub=t.pub:this._pubBytes=Ly(t.pub);}Oy.fromPublic=function(e,t){return t instanceof Oy?t:new Oy(e,{pub:t})},Oy.fromSecret=function(e,t){return t instanceof Oy?t:new Oy(e,{secret:t})},Oy.prototype.secret=function(){return this._secret},Iy(Oy,"pubBytes",(function(){return this.eddsa.encodePoint(this.pub())})),Iy(Oy,"pub",(function(){return this._pubBytes?this.eddsa.decodePoint(this._pubBytes):this.eddsa.g.mul(this.priv())})),Iy(Oy,"privBytes",(function(){var e=this.eddsa,t=this.hash(),n=e.encodingLength-1,r=t.slice(0,e.encodingLength);return r[0]&=248,r[n]&=127,r[n]|=64,r})),Iy(Oy,"priv",(function(){return this.eddsa.decodeInt(this.privBytes())})),Iy(Oy,"hash",(function(){return this.eddsa.hash().update(this.secret()).digest()})),Iy(Oy,"messagePrefix",(function(){return this.hash().slice(this.eddsa.encodingLength)})),Oy.prototype.sign=function(e){return Py(this._secret,"KeyPair can only verify"),this.eddsa.sign(e,this)},Oy.prototype.verify=function(e,t){return this.eddsa.verify(e,t,this)},Oy.prototype.getSecret=function(e){return Py(this._secret,"KeyPair is public only"),Ty.encode(this.secret(),e)},Oy.prototype.getPublic=function(e){return Ty.encode(this.pubBytes(),e)};var Ny=Oy,Dy=gg,jy=pg,By=jy.assert,zy=jy.cachedProperty,Uy=jy.parseBytes;function Fy(e,t){this.eddsa=e,"object"!=typeof t&&(t=Uy(t)),Array.isArray(t)&&(t={R:t.slice(0,e.encodingLength),S:t.slice(e.encodingLength)}),By(t.R&&t.S,"Signature without R or S"),e.isPoint(t.R)&&(this._R=t.R),t.S instanceof Dy&&(this._S=t.S),this._Rencoded=Array.isArray(t.R)?t.R:t.Rencoded,this._Sencoded=Array.isArray(t.S)?t.S:t.Sencoded;}zy(Fy,"S",(function(){return this.eddsa.decodeInt(this.Sencoded())})),zy(Fy,"R",(function(){return this.eddsa.decodePoint(this.Rencoded())})),zy(Fy,"Rencoded",(function(){return this.eddsa.encodePoint(this.R())})),zy(Fy,"Sencoded",(function(){return this.eddsa.encodeInt(this.S())})),Fy.prototype.toBytes=function(){return this.Rencoded().concat(this.Sencoded())},Fy.prototype.toHex=function(){return jy.encode(this.toBytes(),"hex").toUpperCase()};var Ky=Fy,qy=ov,Hy=iv,Wy=pg,$y=Wy.assert,Vy=Wy.parseBytes,Yy=Ny,Gy=Ky;function Zy(e){if($y("ed25519"===e,"only tested with ed25519 so far"),!(this instanceof Zy))return new Zy(e);e=Hy[e].curve,this.curve=e,this.g=e.g,this.g.precompute(e.n.bitLength()+1),this.pointClass=e.point().constructor,this.encodingLength=Math.ceil(e.n.bitLength()/8),this.hash=qy.sha512;}var Qy=Zy;Zy.prototype.sign=function(e,t){e=Vy(e);var n=this.keyFromSecret(t),r=this.hashInt(n.messagePrefix(),e),i=this.g.mul(r),o=this.encodePoint(i),a=this.hashInt(o,n.pubBytes(),e).mul(n.priv()),s=r.add(a).umod(this.curve.n);return this.makeSignature({R:i,S:s,Rencoded:o})},Zy.prototype.verify=function(e,t,n){e=Vy(e),t=this.makeSignature(t);var r=this.keyFromPublic(n),i=this.hashInt(t.Rencoded(),r.pubBytes(),e),o=this.g.mul(t.S());return t.R().add(r.pub().mul(i)).eq(o)},Zy.prototype.hashInt=function(){for(var e=this.hash(),t=0;t<arguments.length;t++)e.update(arguments[t]);return Wy.intFromLE(e.digest()).umod(this.curve.n)},Zy.prototype.keyFromPublic=function(e){return Yy.fromPublic(this,e)},Zy.prototype.keyFromSecret=function(e){return Yy.fromSecret(this,e)},Zy.prototype.makeSignature=function(e){return e instanceof Gy?e:new Gy(this,e)},Zy.prototype.encodePoint=function(e){var t=e.getY().toArray("le",this.encodingLength);return t[this.encodingLength-1]|=e.getX().isOdd()?128:0,t},Zy.prototype.decodePoint=function(e){var t=(e=Wy.parseBytes(e)).length-1,n=e.slice(0,t).concat(-129&e[t]),r=0!=(128&e[t]),i=Wy.intFromLE(n);return this.curve.pointFromY(i,r)},Zy.prototype.encodeInt=function(e){return e.toArray("le",this.encodingLength)},Zy.prototype.decodeInt=function(e){return Wy.intFromLE(e)},Zy.prototype.isPoint=function(e){return e instanceof this.pointClass},function(e){var t=e;t.version=hg,t.utils=pg,t.rand=kg,t.curve=Mg,t.curves=iv,t.ec=Ry,t.eddsa=Qy;}(fg);const Jy=new(fg.ec)("secp256k1"),Xy=Jy.curve,ew=Xy.n.constructor;function tw(e){const t=e[0];switch(t){case 2:case 3:return 33!==e.length?null:function(e,t){let n=new ew(t);if(n.cmp(Xy.p)>=0)return null;n=n.toRed(Xy.red);let r=n.redSqr().redIMul(n).redIAdd(Xy.b).redSqrt();return 3===e!==r.isOdd()&&(r=r.redNeg()),Jy.keyPair({pub:{x:n,y:r}})}(t,e.subarray(1,33));case 4:case 6:case 7:return 65!==e.length?null:function(e,t,n){let r=new ew(t),i=new ew(n);if(r.cmp(Xy.p)>=0||i.cmp(Xy.p)>=0)return null;if(r=r.toRed(Xy.red),i=i.toRed(Xy.red),(6===e||7===e)&&i.isOdd()!==(7===e))return null;const o=r.redSqr().redIMul(r);return i.redSqr().redISub(o.redIAdd(Xy.b)).isZero()?Jy.keyPair({pub:{x:r,y:i}}):null}(t,e.subarray(1,33),e.subarray(33,65));default:return null}}function nw(e,t){const n=t.encode(null,33===e.length);for(let t=0;t<e.length;++t)e[t]=n[t];}var rw={contextRandomize:()=>0,privateKeyVerify(e){const t=new ew(e);return t.cmp(Xy.n)<0&&!t.isZero()?0:1},privateKeyNegate(e){const t=new ew(e),n=Xy.n.sub(t).umod(Xy.n).toArrayLike(Uint8Array,"be",32);return e.set(n),0},privateKeyTweakAdd(e,t){const n=new ew(t);if(n.cmp(Xy.n)>=0)return 1;if(n.iadd(new ew(e)),n.cmp(Xy.n)>=0&&n.isub(Xy.n),n.isZero())return 1;const r=n.toArrayLike(Uint8Array,"be",32);return e.set(r),0},privateKeyTweakMul(e,t){let n=new ew(t);if(n.cmp(Xy.n)>=0||n.isZero())return 1;n.imul(new ew(e)),n.cmp(Xy.n)>=0&&(n=n.umod(Xy.n));const r=n.toArrayLike(Uint8Array,"be",32);return e.set(r),0},publicKeyVerify:e=>null===tw(e)?1:0,publicKeyCreate(e,t){const n=new ew(t);if(n.cmp(Xy.n)>=0||n.isZero())return 1;return nw(e,Jy.keyFromPrivate(t).getPublic()),0},publicKeyConvert(e,t){const n=tw(t);if(null===n)return 1;return nw(e,n.getPublic()),0},publicKeyNegate(e,t){const n=tw(t);if(null===n)return 1;const r=n.getPublic();return r.y=r.y.redNeg(),nw(e,r),0},publicKeyCombine(e,t){const n=new Array(t.length);for(let e=0;e<t.length;++e)if(n[e]=tw(t[e]),null===n[e])return 1;let r=n[0].getPublic();for(let e=1;e<n.length;++e)r=r.add(n[e].pub);return r.isInfinity()?2:(nw(e,r),0)},publicKeyTweakAdd(e,t,n){const r=tw(t);if(null===r)return 1;if((n=new ew(n)).cmp(Xy.n)>=0)return 2;const i=r.getPublic().add(Xy.g.mul(n));return i.isInfinity()?2:(nw(e,i),0)},publicKeyTweakMul(e,t,n){const r=tw(t);if(null===r)return 1;if((n=new ew(n)).cmp(Xy.n)>=0||n.isZero())return 2;return nw(e,r.getPublic().mul(n)),0},signatureNormalize(e){const t=new ew(e.subarray(0,32)),n=new ew(e.subarray(32,64));return t.cmp(Xy.n)>=0||n.cmp(Xy.n)>=0?1:(1===n.cmp(Jy.nh)&&e.set(Xy.n.sub(n).toArrayLike(Uint8Array,"be",32),32),0)},signatureExport(e,t){const n=t.subarray(0,32),r=t.subarray(32,64);if(new ew(n).cmp(Xy.n)>=0)return 1;if(new ew(r).cmp(Xy.n)>=0)return 1;const{output:i}=e;let o=i.subarray(4,37);o[0]=0,o.set(n,1);let a=33,s=0;for(;a>1&&0===o[s]&&!(128&o[s+1]);--a,++s);if(o=o.subarray(s),128&o[0])return 1;if(a>1&&0===o[0]&&!(128&o[1]))return 1;let u=i.subarray(39,72);u[0]=0,u.set(r,1);let l=33,c=0;for(;l>1&&0===u[c]&&!(128&u[c+1]);--l,++c);return u=u.subarray(c),128&u[0]||l>1&&0===u[0]&&!(128&u[1])?1:(e.outputlen=6+a+l,i[0]=48,i[1]=e.outputlen-2,i[2]=2,i[3]=o.length,i.set(o,4),i[4+a]=2,i[5+a]=u.length,i.set(u,6+a),0)},signatureImport(e,t){if(t.length<8)return 1;if(t.length>72)return 1;if(48!==t[0])return 1;if(t[1]!==t.length-2)return 1;if(2!==t[2])return 1;const n=t[3];if(0===n)return 1;if(5+n>=t.length)return 1;if(2!==t[4+n])return 1;const r=t[5+n];if(0===r)return 1;if(6+n+r!==t.length)return 1;if(128&t[4])return 1;if(n>1&&0===t[4]&&!(128&t[5]))return 1;if(128&t[n+6])return 1;if(r>1&&0===t[n+6]&&!(128&t[n+7]))return 1;let i=t.subarray(4,4+n);if(33===i.length&&0===i[0]&&(i=i.subarray(1)),i.length>32)return 1;let o=t.subarray(6+n);if(33===o.length&&0===o[0]&&(o=o.slice(1)),o.length>32)throw new Error("S length is too long");let a=new ew(i);a.cmp(Xy.n)>=0&&(a=new ew(0));let s=new ew(t.subarray(6+n));return s.cmp(Xy.n)>=0&&(s=new ew(0)),e.set(a.toArrayLike(Uint8Array,"be",32),0),e.set(s.toArrayLike(Uint8Array,"be",32),32),0},ecdsaSign(e,t,n,r,i){if(i){const e=i;i=i=>{const o=e(t,n,null,r,i);if(!(o instanceof Uint8Array&&32===o.length))throw new Error("This is the way");return new ew(o)};}const o=new ew(n);if(o.cmp(Xy.n)>=0||o.isZero())return 1;let a;try{a=Jy.sign(t,n,{canonical:!0,k:i,pers:r});}catch(e){return 1}return e.signature.set(a.r.toArrayLike(Uint8Array,"be",32),0),e.signature.set(a.s.toArrayLike(Uint8Array,"be",32),32),e.recid=a.recoveryParam,0},ecdsaVerify(e,t,n){const r={r:e.subarray(0,32),s:e.subarray(32,64)},i=new ew(r.r),o=new ew(r.s);if(i.cmp(Xy.n)>=0||o.cmp(Xy.n)>=0)return 1;if(1===o.cmp(Jy.nh)||i.isZero()||o.isZero())return 3;const a=tw(n);if(null===a)return 2;const s=a.getPublic();return Jy.verify(t,r,s)?0:3},ecdsaRecover(e,t,n,r){const i={r:t.slice(0,32),s:t.slice(32,64)},o=new ew(i.r),a=new ew(i.s);if(o.cmp(Xy.n)>=0||a.cmp(Xy.n)>=0)return 1;if(o.isZero()||a.isZero())return 2;let s;try{s=Jy.recoverPubKey(r,i,n);}catch(e){return 2}return nw(e,s),0},ecdh(e,t,n,r,i,o,a){const s=tw(t);if(null===s)return 1;const u=new ew(n);if(u.cmp(Xy.n)>=0||u.isZero())return 2;const l=s.getPublic().mul(u);if(void 0===i){const t=l.encode(null,true),n=Jy.hash().update(t).digest();for(let t=0;t<32;++t)e[t]=n[t];}else {o||(o=new Uint8Array(32));const t=l.getX().toArray("be",32);for(let e=0;e<32;++e)o[e]=t[e];a||(a=new Uint8Array(32));const n=l.getY().toArray("be",32);for(let e=0;e<32;++e)a[e]=n[e];const s=i(o,a,r);if(!(s instanceof Uint8Array&&s.length===e.length))return 2;e.set(s);}return 0}},iw=(e=>({contextRandomize(t){if(sg(null===t||t instanceof Uint8Array,"Expected seed to be an Uint8Array or null"),null!==t&&ug("seed",t,32),1===e.contextRandomize(t))throw new Error(Jm)},privateKeyVerify:t=>(ug("private key",t,32),0===e.privateKeyVerify(t)),privateKeyNegate(t){switch(ug("private key",t,32),e.privateKeyNegate(t)){case 0:return t;case 1:throw new Error(Gm)}},privateKeyTweakAdd(t,n){switch(ug("private key",t,32),ug("tweak",n,32),e.privateKeyTweakAdd(t,n)){case 0:return t;case 1:throw new Error(Zm)}},privateKeyTweakMul(t,n){switch(ug("private key",t,32),ug("tweak",n,32),e.privateKeyTweakMul(t,n)){case 0:return t;case 1:throw new Error(Qm)}},publicKeyVerify:t=>(ug("public key",t,[33,65]),0===e.publicKeyVerify(t)),publicKeyCreate(t,n=true,r){switch(ug("private key",t,32),lg(n),r=cg(r,n?33:65),e.publicKeyCreate(r,t)){case 0:return r;case 1:throw new Error(Xm);case 2:throw new Error(tg)}},publicKeyConvert(t,n=true,r){switch(ug("public key",t,[33,65]),lg(n),r=cg(r,n?33:65),e.publicKeyConvert(r,t)){case 0:return r;case 1:throw new Error(eg);case 2:throw new Error(tg)}},publicKeyNegate(t,n=true,r){switch(ug("public key",t,[33,65]),lg(n),r=cg(r,n?33:65),e.publicKeyNegate(r,t)){case 0:return r;case 1:throw new Error(eg);case 2:throw new Error(Gm);case 3:throw new Error(tg)}},publicKeyCombine(t,n=true,r){sg(Array.isArray(t),"Expected public keys to be an Array"),sg(t.length>0,"Expected public keys array will have more than zero items");for(const e of t)ug("public key",e,[33,65]);switch(lg(n),r=cg(r,n?33:65),e.publicKeyCombine(r,t)){case 0:return r;case 1:throw new Error(eg);case 2:throw new Error(ng);case 3:throw new Error(tg)}},publicKeyTweakAdd(t,n,r=true,i){switch(ug("public key",t,[33,65]),ug("tweak",n,32),lg(r),i=cg(i,r?33:65),e.publicKeyTweakAdd(i,t,n)){case 0:return i;case 1:throw new Error(eg);case 2:throw new Error(Zm)}},publicKeyTweakMul(t,n,r=true,i){switch(ug("public key",t,[33,65]),ug("tweak",n,32),lg(r),i=cg(i,r?33:65),e.publicKeyTweakMul(i,t,n)){case 0:return i;case 1:throw new Error(eg);case 2:throw new Error(Qm)}},signatureNormalize(t){switch(ug("signature",t,64),e.signatureNormalize(t)){case 0:return t;case 1:throw new Error(rg)}},signatureExport(t,n){ug("signature",t,64);const r={output:n=cg(n,72),outputlen:72};switch(e.signatureExport(r,t)){case 0:return n.slice(0,r.outputlen);case 1:throw new Error(rg);case 2:throw new Error(Gm)}},signatureImport(t,n){switch(ug("signature",t),n=cg(n,64),e.signatureImport(n,t)){case 0:return n;case 1:throw new Error(rg);case 2:throw new Error(Gm)}},ecdsaSign(t,n,r={},i){ug("message",t,32),ug("private key",n,32),sg("Object"===dg(r),"Expected options to be an Object"),void 0!==r.data&&ug("options.data",r.data),void 0!==r.noncefn&&sg("Function"===dg(r.noncefn),"Expected options.noncefn to be a Function");const o={signature:i=cg(i,64),recid:null};switch(e.ecdsaSign(o,t,n,r.data,r.noncefn)){case 0:return o;case 1:throw new Error(ig);case 2:throw new Error(Gm)}},ecdsaVerify(t,n,r){switch(ug("signature",t,64),ug("message",n,32),ug("public key",r,[33,65]),e.ecdsaVerify(t,n,r)){case 0:return  true;case 3:return  false;case 1:throw new Error(rg);case 2:throw new Error(eg)}},ecdsaRecover(t,n,r,i=true,o){switch(ug("signature",t,64),sg("Number"===dg(n)&&n>=0&&n<=3,"Expected recovery id to be a Number within interval [0, 3]"),ug("message",r,32),lg(i),o=cg(o,i?33:65),e.ecdsaRecover(o,t,n,r)){case 0:return o;case 1:throw new Error(rg);case 2:throw new Error(og);case 3:throw new Error(Gm)}},ecdh(t,n,r={},i){switch(ug("public key",t,[33,65]),ug("private key",n,32),sg("Object"===dg(r),"Expected options to be an Object"),void 0!==r.data&&ug("options.data",r.data),void 0!==r.hashfn?(sg("Function"===dg(r.hashfn),"Expected options.hashfn to be a Function"),void 0!==r.xbuf&&ug("options.xbuf",r.xbuf,32),void 0!==r.ybuf&&ug("options.ybuf",r.ybuf,32),ug("output",i)):i=cg(i,32),e.ecdh(i,t,n,r.data,r.hashfn,r.xbuf,r.ybuf)){case 0:return i;case 1:throw new Error(eg);case 2:throw new Error(ag)}}}))(rw),ow={},aw={};!function(e){Object.defineProperty(e,"__esModule",{value:true}),e.SECRET_KEY_LENGTH=e.AES_IV_PLUS_TAG_LENGTH=e.AES_TAG_LENGTH=e.AES_IV_LENGTH=e.UNCOMPRESSED_PUBLIC_KEY_SIZE=void 0,e.UNCOMPRESSED_PUBLIC_KEY_SIZE=65,e.AES_IV_LENGTH=16,e.AES_TAG_LENGTH=16,e.AES_IV_PLUS_TAG_LENGTH=e.AES_IV_LENGTH+e.AES_TAG_LENGTH,e.SECRET_KEY_LENGTH=32;}(aw);var sw=n&&n.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(ow,"__esModule",{value:true}),ow.aesDecrypt=ow.aesEncrypt=ow.getValidSecret=ow.decodeHex=ow.remove0x=void 0;var uw=zm(),lw=sw(iw),cw=aw;function dw(e){return e.startsWith("0x")||e.startsWith("0X")?e.slice(2):e}ow.remove0x=dw,ow.decodeHex=function(e){return _.from(dw(e),"hex")},ow.getValidSecret=function(){var e;do{e=(0, uw.randomBytes)(cw.SECRET_KEY_LENGTH);}while(!lw.default.privateKeyVerify(e));return e},ow.aesEncrypt=function(e,t){var n=(0, uw.randomBytes)(cw.AES_IV_LENGTH),r=(0, uw.createCipheriv)("aes-256-gcm",e,n),i=_.concat([r.update(t),r.final()]),o=r.getAuthTag();return _.concat([n,o,i])},ow.aesDecrypt=function(e,t){var n=t.slice(0,cw.AES_IV_LENGTH),r=t.slice(cw.AES_IV_LENGTH,cw.AES_IV_PLUS_TAG_LENGTH),i=t.slice(cw.AES_IV_PLUS_TAG_LENGTH),o=(0, uw.createDecipheriv)("aes-256-gcm",e,n);return o.setAuthTag(r),_.concat([o.update(i),o.final()])};var fw={},hw=n&&n.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(fw,"__esModule",{value:true});var pw=hw(Ym),mw=hw(iw),gw=ow,vw=aw,bw=function(){function e(e){this.uncompressed=_.from(mw.default.publicKeyConvert(e,false)),this.compressed=_.from(mw.default.publicKeyConvert(e,true));}return e.fromHex=function(t){var n=(0, gw.decodeHex)(t);if(n.length===vw.UNCOMPRESSED_PUBLIC_KEY_SIZE-1){var r=_.from([4]);return new e(_.concat([r,n]))}return new e(n)},e.prototype.toHex=function(e){return void 0===e&&(e=true),e?this.compressed.toString("hex"):this.uncompressed.toString("hex")},e.prototype.decapsulate=function(e){var t=_.concat([this.uncompressed,e.multiply(this)]);return (0, pw.default)(t,32,{hash:"SHA-256"})},e.prototype.equals=function(e){return this.uncompressed.equals(e.uncompressed)},e}();fw.default=bw;var yw=n&&n.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(le,"__esModule",{value:true});var ww=yw(Ym),_w=yw(iw),Sw=ow,Ew=yw(fw),kw=function(){function e(e){if(this.secret=e||(0, Sw.getValidSecret)(),!_w.default.privateKeyVerify(this.secret))throw new Error("Invalid private key");this.publicKey=new Ew.default(_.from(_w.default.publicKeyCreate(this.secret)));}return e.fromHex=function(t){return new e((0, Sw.decodeHex)(t))},e.prototype.toHex=function(){return "0x".concat(this.secret.toString("hex"))},e.prototype.encapsulate=function(e){var t=_.concat([this.publicKey.uncompressed,this.multiply(e)]);return (0, ww.default)(t,32,{hash:"SHA-256"})},e.prototype.multiply=function(e){return _.from(_w.default.publicKeyTweakMul(e.compressed,this.secret,false))},e.prototype.equals=function(e){return this.secret.equals(e.secret)},e}();le.default=kw,function(e){var t=n&&n.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(e,"__esModule",{value:true}),e.PublicKey=e.PrivateKey=void 0;var r=le;Object.defineProperty(e,"PrivateKey",{enumerable:true,get:function(){return t(r).default}});var i=fw;Object.defineProperty(e,"PublicKey",{enumerable:true,get:function(){return t(i).default}});}(ue),function(e){Object.defineProperty(e,"__esModule",{value:true}),e.utils=e.PublicKey=e.PrivateKey=e.decrypt=e.encrypt=void 0;var t=ue,n=ow,r=aw;e.encrypt=function(e,r){var i=new t.PrivateKey,o=e instanceof _?new t.PublicKey(e):t.PublicKey.fromHex(e),a=i.encapsulate(o),s=(0, n.aesEncrypt)(a,r);return _.concat([i.publicKey.uncompressed,s])},e.decrypt=function(e,i){var o=e instanceof _?new t.PrivateKey(e):t.PrivateKey.fromHex(e),a=new t.PublicKey(i.slice(0,r.UNCOMPRESSED_PUBLIC_KEY_SIZE)),s=i.slice(r.UNCOMPRESSED_PUBLIC_KEY_SIZE),u=a.decapsulate(o);return (0, n.aesDecrypt)(u,s)};var i=ue;Object.defineProperty(e,"PrivateKey",{enumerable:true,get:function(){return i.PrivateKey}}),Object.defineProperty(e,"PublicKey",{enumerable:true,get:function(){return i.PublicKey}}),e.utils={aesDecrypt:n.aesDecrypt,aesEncrypt:n.aesEncrypt,decodeHex:n.decodeHex,getValidSecret:n.getValidSecret,remove0x:n.remove0x};}(se);var Mw={exports:{}};!function(e,t){!function(t){var n=Object.hasOwnProperty,r=Array.isArray?Array.isArray:function(e){return "[object Array]"===Object.prototype.toString.call(e)},i="object"==typeof je&&true,o="function"==typeof Symbol,a="object"==typeof Reflect,s="function"==typeof setImmediate?setImmediate:setTimeout,u=o?a&&"function"==typeof Reflect.ownKeys?Reflect.ownKeys:function(e){var t=Object.getOwnPropertyNames(e);return t.push.apply(t,Object.getOwnPropertySymbols(e)),t}:Object.keys;function l(){this._events={},this._conf&&c.call(this,this._conf);}function c(e){e&&(this._conf=e,e.delimiter&&(this.delimiter=e.delimiter),e.maxListeners!==t&&(this._maxListeners=e.maxListeners),e.wildcard&&(this.wildcard=e.wildcard),e.newListener&&(this._newListener=e.newListener),e.removeListener&&(this._removeListener=e.removeListener),e.verboseMemoryLeak&&(this.verboseMemoryLeak=e.verboseMemoryLeak),e.ignoreErrors&&(this.ignoreErrors=e.ignoreErrors),this.wildcard&&(this.listenerTree={}));}function d(e,t){var n="(node) warning: possible EventEmitter memory leak detected. "+e+" listeners added. Use emitter.setMaxListeners() to increase limit.";if(this.verboseMemoryLeak&&(n+=" Event name: "+t+"."),void 0!==je&&je.emitWarning){var r=new Error(n);r.name="MaxListenersExceededWarning",r.emitter=this,r.count=e,je.emitWarning(r);}else console.error(n),console.trace&&console.trace();}var f=function(e,t,n){var r=arguments.length;switch(r){case 0:return [];case 1:return [e];case 2:return [e,t];case 3:return [e,t,n];default:for(var i=new Array(r);r--;)i[r]=arguments[r];return i}};function h(e,n){for(var r={},i=e.length,o=0,a=0;a<i;a++)r[e[a]]=a<o?n[a]:t;return r}function p(e,t,n){var r,i;if(this._emitter=e,this._target=t,this._listeners={},this._listenersCount=0,(n.on||n.off)&&(r=n.on,i=n.off),t.addEventListener?(r=t.addEventListener,i=t.removeEventListener):t.addListener?(r=t.addListener,i=t.removeListener):t.on&&(r=t.on,i=t.off),!r&&!i)throw Error("target does not implement any known event API");if("function"!=typeof r)throw TypeError("on method must be a function");if("function"!=typeof i)throw TypeError("off method must be a function");this._on=r,this._off=i;var o=e._observers;o?o.push(this):e._observers=[this];}function m(e,r,i,o){var a=Object.assign({},r);if(!e)return a;if("object"!=typeof e)throw TypeError("options must be an object");var s,u,l,c=Object.keys(e),d=c.length;function f(e){throw Error('Invalid "'+s+'" option value'+(e?". Reason: "+e:""))}for(var h=0;h<d;h++){if(s=c[h],!n.call(r,s))throw Error('Unknown "'+s+'" option');(u=e[s])!==t&&(l=i[s],a[s]=l?l(u,f):u);}return a}function g(e,t){return "function"==typeof e&&e.hasOwnProperty("prototype")||t("value must be a constructor"),e}function v(e){var t="value must be type of "+e.join("|"),n=e.length,r=e[0],i=e[1];return 1===n?function(e,n){if(typeof e===r)return e;n(t);}:2===n?function(e,n){var o=typeof e;if(o===r||o===i)return e;n(t);}:function(r,i){for(var o=typeof r,a=n;a-- >0;)if(o===e[a])return r;i(t);}}Object.assign(p.prototype,{subscribe:function(e,t,n){var r=this,i=this._target,o=this._emitter,a=this._listeners,s=function(){var r=f.apply(null,arguments),a={data:r,name:t,original:e};n?false!==n.call(i,a)&&o.emit.apply(o,[a.name].concat(r)):o.emit.apply(o,[t].concat(r));};if(a[e])throw Error("Event '"+e+"' is already listening");this._listenersCount++,o._newListener&&o._removeListener&&!r._onNewListener?(this._onNewListener=function(n){n===t&&null===a[e]&&(a[e]=s,r._on.call(i,e,s));},o.on("newListener",this._onNewListener),this._onRemoveListener=function(n){n===t&&!o.hasListeners(n)&&a[e]&&(a[e]=null,r._off.call(i,e,s));},a[e]=null,o.on("removeListener",this._onRemoveListener)):(a[e]=s,r._on.call(i,e,s));},unsubscribe:function(e){var t,n,r,i=this,o=this._listeners,a=this._emitter,s=this._off,l=this._target;if(e&&"string"!=typeof e)throw TypeError("event must be a string");function c(){i._onNewListener&&(a.off("newListener",i._onNewListener),a.off("removeListener",i._onRemoveListener),i._onNewListener=null,i._onRemoveListener=null);var e=_.call(a,i);a._observers.splice(e,1);}if(e){if(!(t=o[e]))return;s.call(l,e,t),delete o[e],--this._listenersCount||c();}else {for(r=(n=u(o)).length;r-- >0;)e=n[r],s.call(l,e,o[e]);this._listeners={},this._listenersCount=0,c();}}});var b=v(["function"]),y=v(["object","function"]);function w(e,t,n){var r,i,o,a=0,s=new e((function(u,l,c){function d(){i&&(i=null),a&&(clearTimeout(a),a=0);}n=m(n,{timeout:0,overload:false},{timeout:function(e,t){return ("number"!=typeof(e*=1)||e<0||!Number.isFinite(e))&&t("timeout must be a positive number"),e}}),r=!n.overload&&"function"==typeof e.prototype.cancel&&"function"==typeof c;var f=function(e){d(),u(e);},h=function(e){d(),l(e);};r?t(f,h,c):(i=[function(e){h(e||Error("canceled"));}],t(f,h,(function(e){if(o)throw Error("Unable to subscribe on cancel event asynchronously");if("function"!=typeof e)throw TypeError("onCancel callback must be a function");i.push(e);})),o=true),n.timeout>0&&(a=setTimeout((function(){var e=Error("timeout");e.code="ETIMEDOUT",a=0,s.cancel(e),l(e);}),n.timeout));}));return r||(s.cancel=function(e){if(i){for(var t=i.length,n=1;n<t;n++)i[n](e);i[0](e),i=null;}}),s}function _(e){var t=this._observers;if(!t)return  -1;for(var n=t.length,r=0;r<n;r++)if(t[r]._target===e)return r;return  -1}function S(e,t,n,r,i){if(!n)return null;if(0===r){var o=typeof t;if("string"===o){var a,s,l=0,c=0,d=this.delimiter,f=d.length;if(-1!==(s=t.indexOf(d))){a=new Array(5);do{a[l++]=t.slice(c,s),c=s+f;}while(-1!==(s=t.indexOf(d,c)));a[l++]=t.slice(c),t=a,i=l;}else t=[t],i=1;}else "object"===o?i=t.length:(t=[t],i=1);}var h,p,m,g,v,b,y,w=null,_=t[r],E=t[r+1];if(r===i)n._listeners&&("function"==typeof n._listeners?(e&&e.push(n._listeners),w=[n]):(e&&e.push.apply(e,n._listeners),w=[n]));else {if("*"===_){for(s=(b=u(n)).length;s-- >0;)"_listeners"!==(h=b[s])&&(y=S(e,t,n[h],r+1,i))&&(w?w.push.apply(w,y):w=y);return w}if("**"===_){for((v=r+1===i||r+2===i&&"*"===E)&&n._listeners&&(w=S(e,t,n,i,i)),s=(b=u(n)).length;s-- >0;)"_listeners"!==(h=b[s])&&("*"===h||"**"===h?(n[h]._listeners&&!v&&(y=S(e,t,n[h],i,i))&&(w?w.push.apply(w,y):w=y),y=S(e,t,n[h],r,i)):y=S(e,t,n[h],h===E?r+2:r,i),y&&(w?w.push.apply(w,y):w=y));return w}n[_]&&(w=S(e,t,n[_],r+1,i));}if((p=n["*"])&&S(e,t,p,r+1,i),m=n["**"])if(r<i)for(m._listeners&&S(e,t,m,i,i),s=(b=u(m)).length;s-- >0;)"_listeners"!==(h=b[s])&&(h===E?S(e,t,m[h],r+2,i):h===_?S(e,t,m[h],r+1,i):((g={})[h]=m[h],S(e,t,{"**":g},r+1,i)));else m._listeners?S(e,t,m,i,i):m["*"]&&m["*"]._listeners&&S(e,t,m["*"],i,i);return w}function E(e,t,n){var r,i,o=0,a=0,s=this.delimiter,u=s.length;if("string"==typeof e)if(-1!==(r=e.indexOf(s))){i=new Array(5);do{i[o++]=e.slice(a,r),a=r+u;}while(-1!==(r=e.indexOf(s,a)));i[o++]=e.slice(a);}else i=[e],o=1;else i=e,o=e.length;if(o>1)for(r=0;r+1<o;r++)if("**"===i[r]&&"**"===i[r+1])return;var l,c=this.listenerTree;for(r=0;r<o;r++)if(c=c[l=i[r]]||(c[l]={}),r===o-1)return c._listeners?("function"==typeof c._listeners&&(c._listeners=[c._listeners]),n?c._listeners.unshift(t):c._listeners.push(t),!c._listeners.warned&&this._maxListeners>0&&c._listeners.length>this._maxListeners&&(c._listeners.warned=true,d.call(this,c._listeners.length,l))):c._listeners=t,true;return  true}function k(e,t,n,r){for(var i,o,a,s,l=u(e),c=l.length,d=e._listeners;c-- >0;)i=e[o=l[c]],a="_listeners"===o?n:n?n.concat(o):[o],s=r||"symbol"==typeof o,d&&t.push(s?a:a.join(this.delimiter)),"object"==typeof i&&k.call(this,i,t,a,s);return t}function M(e){for(var t,n,r,i=u(e),o=i.length;o-- >0;)(t=e[n=i[o]])&&(r=true,"_listeners"===n||M(t)||delete e[n]);return r}function C(e,t,n){this.emitter=e,this.event=t,this.listener=n;}function x(e,n,r){if(true===r)a=true;else if(false===r)o=true;else {if(!r||"object"!=typeof r)throw TypeError("options should be an object or true");var o=r.async,a=r.promisify,u=r.nextTick,l=r.objectify;}if(o||u||a){var c=n,d=n._origin||n;if(u&&!i)throw Error("process.nextTick is not supported");a===t&&(a="AsyncFunction"===n.constructor.name),n=function(){var e=arguments,t=this,n=this.event;return a?u?Promise.resolve():new Promise((function(e){s(e);})).then((function(){return t.event=n,c.apply(t,e)})):(u?Ee:s)((function(){t.event=n,c.apply(t,e);}))},n._async=true,n._origin=d;}return [n,l?new C(this,e,n):this]}function A(e){this._events={},this._newListener=false,this._removeListener=false,this.verboseMemoryLeak=false,c.call(this,e);}C.prototype.off=function(){return this.emitter.off(this.event,this.listener),this},A.EventEmitter2=A,A.prototype.listenTo=function(e,n,i){if("object"!=typeof e)throw TypeError("target musts be an object");var o=this;function a(t){if("object"!=typeof t)throw TypeError("events must be an object");var n,r=i.reducers,a=_.call(o,e);n=-1===a?new p(o,e,i):o._observers[a];for(var s,l=u(t),c=l.length,d="function"==typeof r,f=0;f<c;f++)s=l[f],n.subscribe(s,t[s]||s,d?r:r&&r[s]);}return i=m(i,{on:t,off:t,reducers:t},{on:b,off:b,reducers:y}),r(n)?a(h(n)):a("string"==typeof n?h(n.split(/\s+/)):n),this},A.prototype.stopListeningTo=function(e,t){var n=this._observers;if(!n)return  false;var r,i=n.length,o=false;if(e&&"object"!=typeof e)throw TypeError("target should be an object");for(;i-- >0;)r=n[i],e&&r._target!==e||(r.unsubscribe(t),o=true);return o},A.prototype.delimiter=".",A.prototype.setMaxListeners=function(e){e!==t&&(this._maxListeners=e,this._conf||(this._conf={}),this._conf.maxListeners=e);},A.prototype.getMaxListeners=function(){return this._maxListeners},A.prototype.event="",A.prototype.once=function(e,t,n){return this._once(e,t,false,n)},A.prototype.prependOnceListener=function(e,t,n){return this._once(e,t,true,n)},A.prototype._once=function(e,t,n,r){return this._many(e,1,t,n,r)},A.prototype.many=function(e,t,n,r){return this._many(e,t,n,false,r)},A.prototype.prependMany=function(e,t,n,r){return this._many(e,t,n,true,r)},A.prototype._many=function(e,t,n,r,i){var o=this;if("function"!=typeof n)throw new Error("many only accepts instances of Function");function a(){return 0==--t&&o.off(e,a),n.apply(this,arguments)}return a._origin=n,this._on(e,a,r,i)},A.prototype.emit=function(){if(!this._events&&!this._all)return  false;this._events||l.call(this);var e,t,n,r,i,a,s=arguments[0],u=this.wildcard;if("newListener"===s&&!this._newListener&&!this._events.newListener)return  false;if(u&&(e=s,"newListener"!==s&&"removeListener"!==s&&"object"==typeof s)){if(n=s.length,o)for(r=0;r<n;r++)if("symbol"==typeof s[r]){a=true;break}a||(s=s.join(this.delimiter));}var c,d=arguments.length;if(this._all&&this._all.length)for(r=0,n=(c=this._all.slice()).length;r<n;r++)switch(this.event=s,d){case 1:c[r].call(this,s);break;case 2:c[r].call(this,s,arguments[1]);break;case 3:c[r].call(this,s,arguments[1],arguments[2]);break;default:c[r].apply(this,arguments);}if(u)c=[],S.call(this,c,e,this.listenerTree,0,n);else {if("function"==typeof(c=this._events[s])){switch(this.event=s,d){case 1:c.call(this);break;case 2:c.call(this,arguments[1]);break;case 3:c.call(this,arguments[1],arguments[2]);break;default:for(t=new Array(d-1),i=1;i<d;i++)t[i-1]=arguments[i];c.apply(this,t);}return  true}c&&(c=c.slice());}if(c&&c.length){if(d>3)for(t=new Array(d-1),i=1;i<d;i++)t[i-1]=arguments[i];for(r=0,n=c.length;r<n;r++)switch(this.event=s,d){case 1:c[r].call(this);break;case 2:c[r].call(this,arguments[1]);break;case 3:c[r].call(this,arguments[1],arguments[2]);break;default:c[r].apply(this,t);}return  true}if(!this.ignoreErrors&&!this._all&&"error"===s)throw arguments[1]instanceof Error?arguments[1]:new Error("Uncaught, unspecified 'error' event.");return !!this._all},A.prototype.emitAsync=function(){if(!this._events&&!this._all)return  false;this._events||l.call(this);var e,t,n,r,i,a,s=arguments[0],u=this.wildcard;if("newListener"===s&&!this._newListener&&!this._events.newListener)return Promise.resolve([false]);if(u&&(e=s,"newListener"!==s&&"removeListener"!==s&&"object"==typeof s)){if(r=s.length,o)for(i=0;i<r;i++)if("symbol"==typeof s[i]){t=true;break}t||(s=s.join(this.delimiter));}var c,d=[],f=arguments.length;if(this._all)for(i=0,r=this._all.length;i<r;i++)switch(this.event=s,f){case 1:d.push(this._all[i].call(this,s));break;case 2:d.push(this._all[i].call(this,s,arguments[1]));break;case 3:d.push(this._all[i].call(this,s,arguments[1],arguments[2]));break;default:d.push(this._all[i].apply(this,arguments));}if(u?(c=[],S.call(this,c,e,this.listenerTree,0)):c=this._events[s],"function"==typeof c)switch(this.event=s,f){case 1:d.push(c.call(this));break;case 2:d.push(c.call(this,arguments[1]));break;case 3:d.push(c.call(this,arguments[1],arguments[2]));break;default:for(n=new Array(f-1),a=1;a<f;a++)n[a-1]=arguments[a];d.push(c.apply(this,n));}else if(c&&c.length){if(c=c.slice(),f>3)for(n=new Array(f-1),a=1;a<f;a++)n[a-1]=arguments[a];for(i=0,r=c.length;i<r;i++)switch(this.event=s,f){case 1:d.push(c[i].call(this));break;case 2:d.push(c[i].call(this,arguments[1]));break;case 3:d.push(c[i].call(this,arguments[1],arguments[2]));break;default:d.push(c[i].apply(this,n));}}else if(!this.ignoreErrors&&!this._all&&"error"===s)return arguments[1]instanceof Error?Promise.reject(arguments[1]):Promise.reject("Uncaught, unspecified 'error' event.");return Promise.all(d)},A.prototype.on=function(e,t,n){return this._on(e,t,false,n)},A.prototype.prependListener=function(e,t,n){return this._on(e,t,true,n)},A.prototype.onAny=function(e){return this._onAny(e,false)},A.prototype.prependAny=function(e){return this._onAny(e,true)},A.prototype.addListener=A.prototype.on,A.prototype._onAny=function(e,t){if("function"!=typeof e)throw new Error("onAny only accepts instances of Function");return this._all||(this._all=[]),t?this._all.unshift(e):this._all.push(e),this},A.prototype._on=function(e,n,r,i){if("function"==typeof e)return this._onAny(e,n),this;if("function"!=typeof n)throw new Error("on only accepts instances of Function");this._events||l.call(this);var o,a=this;return i!==t&&(n=(o=x.call(this,e,n,i))[0],a=o[1]),this._newListener&&this.emit("newListener",e,n),this.wildcard?(E.call(this,e,n,r),a):(this._events[e]?("function"==typeof this._events[e]&&(this._events[e]=[this._events[e]]),r?this._events[e].unshift(n):this._events[e].push(n),!this._events[e].warned&&this._maxListeners>0&&this._events[e].length>this._maxListeners&&(this._events[e].warned=true,d.call(this,this._events[e].length,e))):this._events[e]=n,a)},A.prototype.off=function(e,t){if("function"!=typeof t)throw new Error("removeListener only takes instances of Function");var n,i=[];if(this.wildcard){var o="string"==typeof e?e.split(this.delimiter):e.slice();if(!(i=S.call(this,null,o,this.listenerTree,0)))return this}else {if(!this._events[e])return this;n=this._events[e],i.push({_listeners:n});}for(var a=0;a<i.length;a++){var s=i[a];if(n=s._listeners,r(n)){for(var u=-1,l=0,c=n.length;l<c;l++)if(n[l]===t||n[l].listener&&n[l].listener===t||n[l]._origin&&n[l]._origin===t){u=l;break}if(u<0)continue;return this.wildcard?s._listeners.splice(u,1):this._events[e].splice(u,1),0===n.length&&(this.wildcard?delete s._listeners:delete this._events[e]),this._removeListener&&this.emit("removeListener",e,t),this}(n===t||n.listener&&n.listener===t||n._origin&&n._origin===t)&&(this.wildcard?delete s._listeners:delete this._events[e],this._removeListener&&this.emit("removeListener",e,t));}return this.listenerTree&&M(this.listenerTree),this},A.prototype.offAny=function(e){var t,n=0,r=0;if(e&&this._all&&this._all.length>0){for(n=0,r=(t=this._all).length;n<r;n++)if(e===t[n])return t.splice(n,1),this._removeListener&&this.emit("removeListenerAny",e),this}else {if(t=this._all,this._removeListener)for(n=0,r=t.length;n<r;n++)this.emit("removeListenerAny",t[n]);this._all=[];}return this},A.prototype.removeListener=A.prototype.off,A.prototype.removeAllListeners=function(e){if(e===t)return !this._events||l.call(this),this;if(this.wildcard){var n,r=S.call(this,null,e,this.listenerTree,0);if(!r)return this;for(n=0;n<r.length;n++)r[n]._listeners=null;this.listenerTree&&M(this.listenerTree);}else this._events&&(this._events[e]=null);return this},A.prototype.listeners=function(e){var n,r,i,o,a,s=this._events;if(e===t){if(this.wildcard)throw Error("event name required for wildcard emitter");if(!s)return [];for(o=(n=u(s)).length,i=[];o-- >0;)"function"==typeof(r=s[n[o]])?i.push(r):i.push.apply(i,r);return i}if(this.wildcard){if(!(a=this.listenerTree))return [];var l=[],c="string"==typeof e?e.split(this.delimiter):e.slice();return S.call(this,l,c,a,0),l}return s&&(r=s[e])?"function"==typeof r?[r]:r:[]},A.prototype.eventNames=function(e){var t=this._events;return this.wildcard?k.call(this,this.listenerTree,[],null,e):t?u(t):[]},A.prototype.listenerCount=function(e){return this.listeners(e).length},A.prototype.hasListeners=function(e){if(this.wildcard){var n=[],r="string"==typeof e?e.split(this.delimiter):e.slice();return S.call(this,n,r,this.listenerTree,0),n.length>0}var i=this._events,o=this._all;return !!(o&&o.length||i&&(e===t?u(i).length:i[e]))},A.prototype.listenersAny=function(){return this._all?this._all:[]},A.prototype.waitFor=function(e,n){var r=this,i=typeof n;return "number"===i?n={timeout:n}:"function"===i&&(n={filter:n}),w((n=m(n,{timeout:0,filter:t,handleError:false,Promise:Promise,overload:false},{filter:b,Promise:g})).Promise,(function(t,i,o){function a(){var o=n.filter;if(!o||o.apply(r,arguments))if(r.off(e,a),n.handleError){var s=arguments[0];s?i(s):t(f.apply(null,arguments).slice(1));}else t(f.apply(null,arguments));}o((function(){r.off(e,a);})),r._on(e,a,false);}),{timeout:n.timeout,overload:n.overload})};var R=A.prototype;Object.defineProperties(A,{defaultMaxListeners:{get:function(){return R._maxListeners},set:function(e){if("number"!=typeof e||e<0||Number.isNaN(e))throw TypeError("n must be a non-negative number");R._maxListeners=e;},enumerable:true},once:{value:function(e,t,n){return w((n=m(n,{Promise:Promise,timeout:0,overload:false},{Promise:g})).Promise,(function(n,r,i){var o;if("function"==typeof e.addEventListener)return o=function(){n(f.apply(null,arguments));},i((function(){e.removeEventListener(t,o);})),void e.addEventListener(t,o,{once:true});var a,s=function(){a&&e.removeListener("error",a),n(f.apply(null,arguments));};"error"!==t&&(a=function(n){e.removeListener(t,s),r(n);},e.once("error",a)),i((function(){a&&e.removeListener("error",a),e.removeListener(t,s);})),e.once(t,s);}),{timeout:n.timeout,overload:n.overload})},writable:true,configurable:true}}),Object.defineProperties(R,{_maxListeners:{value:10,writable:true,configurable:true},_observers:{value:null,writable:true,configurable:true}}),e.exports=A;}();}(Mw);var Cw,xw=Mw.exports,Aw=new Uint8Array(16);function Rw(){if(!Cw&&!(Cw="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto)))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return Cw(Aw)}var Tw=/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;function Pw(e){return "string"==typeof e&&Tw.test(e)}for(var Lw=[],Iw=0;Iw<256;++Iw)Lw.push((Iw+256).toString(16).substr(1));function Ow(e,t,n){var r=(e=e||{}).random||(e.rng||Rw)();if(r[6]=15&r[6]|64,r[8]=63&r[8]|128,t);return function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=(Lw[e[t+0]]+Lw[e[t+1]]+Lw[e[t+2]]+Lw[e[t+3]]+"-"+Lw[e[t+4]]+Lw[e[t+5]]+"-"+Lw[e[t+6]]+Lw[e[t+7]]+"-"+Lw[e[t+8]]+Lw[e[t+9]]+"-"+Lw[e[t+10]]+Lw[e[t+11]]+Lw[e[t+12]]+Lw[e[t+13]]+Lw[e[t+14]]+Lw[e[t+15]]).toLowerCase();if(!Pw(n))throw TypeError("Stringified UUID is invalid");return n}(r)}const Nw=Object.create(null);Nw.open="0",Nw.close="1",Nw.ping="2",Nw.pong="3",Nw.message="4",Nw.upgrade="5",Nw.noop="6";const Dw=Object.create(null);Object.keys(Nw).forEach((e=>{Dw[Nw[e]]=e;}));const jw={type:"error",data:"parser error"},Bw="function"==typeof Blob||"undefined"!=typeof Blob&&"[object BlobConstructor]"===Object.prototype.toString.call(Blob),zw="function"==typeof ArrayBuffer,Uw=e=>"function"==typeof ArrayBuffer.isView?ArrayBuffer.isView(e):e&&e.buffer instanceof ArrayBuffer,Fw=({type:e,data:t},n,r)=>Bw&&t instanceof Blob?n?r(t):Kw(t,r):zw&&(t instanceof ArrayBuffer||Uw(t))?n?r(t):Kw(new Blob([t]),r):r(Nw[e]+(t||"")),Kw=(e,t)=>{const n=new FileReader;return n.onload=function(){const e=n.result.split(",")[1];t("b"+(e||""));},n.readAsDataURL(e)};function qw(e){return e instanceof Uint8Array?e:e instanceof ArrayBuffer?new Uint8Array(e):new Uint8Array(e.buffer,e.byteOffset,e.byteLength)}let Hw;function Ww(e,t){return Bw&&e.data instanceof Blob?e.data.arrayBuffer().then(qw).then(t):zw&&(e.data instanceof ArrayBuffer||Uw(e.data))?t(qw(e.data)):void Fw(e,false,(e=>{Hw||(Hw=new TextEncoder),t(Hw.encode(e));}))}const $w="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",Vw="undefined"==typeof Uint8Array?[]:new Uint8Array(256);for(let e=0;e<64;e++)Vw[$w.charCodeAt(e)]=e;const Yw="function"==typeof ArrayBuffer,Gw=(e,t)=>{if("string"!=typeof e)return {type:"message",data:Qw(e,t)};const n=e.charAt(0);if("b"===n)return {type:"message",data:Zw(e.substring(1),t)};return Dw[n]?e.length>1?{type:Dw[n],data:e.substring(1)}:{type:Dw[n]}:jw},Zw=(e,t)=>{if(Yw){const n=(e=>{let t,n,r,i,o,a=.75*e.length,s=e.length,u=0;"="===e[e.length-1]&&(a--,"="===e[e.length-2]&&a--);const l=new ArrayBuffer(a),c=new Uint8Array(l);for(t=0;t<s;t+=4)n=Vw[e.charCodeAt(t)],r=Vw[e.charCodeAt(t+1)],i=Vw[e.charCodeAt(t+2)],o=Vw[e.charCodeAt(t+3)],c[u++]=n<<2|r>>4,c[u++]=(15&r)<<4|i>>2,c[u++]=(3&i)<<6|63&o;return l})(e);return Qw(n,t)}return {base64:true,data:e}},Qw=(e,t)=>"blob"===t?e instanceof Blob?e:new Blob([e]):e instanceof ArrayBuffer?e:e.buffer,Jw=String.fromCharCode(30);let Xw;function e_(e){if(e)return function(e){for(var t in e_.prototype)e[t]=e_.prototype[t];return e}(e)}e_.prototype.on=e_.prototype.addEventListener=function(e,t){return this._callbacks=this._callbacks||{},(this._callbacks["$"+e]=this._callbacks["$"+e]||[]).push(t),this},e_.prototype.once=function(e,t){function n(){this.off(e,n),t.apply(this,arguments);}return n.fn=t,this.on(e,n),this},e_.prototype.off=e_.prototype.removeListener=e_.prototype.removeAllListeners=e_.prototype.removeEventListener=function(e,t){if(this._callbacks=this._callbacks||{},0==arguments.length)return this._callbacks={},this;var n,r=this._callbacks["$"+e];if(!r)return this;if(1==arguments.length)return delete this._callbacks["$"+e],this;for(var i=0;i<r.length;i++)if((n=r[i])===t||n.fn===t){r.splice(i,1);break}return 0===r.length&&delete this._callbacks["$"+e],this},e_.prototype.emit=function(e){this._callbacks=this._callbacks||{};for(var t=new Array(arguments.length-1),n=this._callbacks["$"+e],r=1;r<arguments.length;r++)t[r-1]=arguments[r];if(n){r=0;for(var i=(n=n.slice(0)).length;r<i;++r)n[r].apply(this,t);}return this},e_.prototype.emitReserved=e_.prototype.emit,e_.prototype.listeners=function(e){return this._callbacks=this._callbacks||{},this._callbacks["$"+e]||[]},e_.prototype.hasListeners=function(e){return !!this.listeners(e).length};const t_="undefined"!=typeof self?self:"undefined"!=typeof window?window:Function("return this")();function n_(e,...t){return t.reduce(((t,n)=>(e.hasOwnProperty(n)&&(t[n]=e[n]),t)),{})}const r_=t_.setTimeout,i_=t_.clearTimeout;function o_(e,t){t.useNativeTimers?(e.setTimeoutFn=r_.bind(t_),e.clearTimeoutFn=i_.bind(t_)):(e.setTimeoutFn=t_.setTimeout.bind(t_),e.clearTimeoutFn=t_.clearTimeout.bind(t_));}class a_ extends Error{constructor(e,t,n){super(e),this.description=t,this.context=n,this.type="TransportError";}}class s_ extends e_{constructor(e){super(),this.writable=false,o_(this,e),this.opts=e,this.query=e.query,this.socket=e.socket;}onError(e,t,n){return super.emitReserved("error",new a_(e,t,n)),this}open(){return this.readyState="opening",this.doOpen(),this}close(){return "opening"!==this.readyState&&"open"!==this.readyState||(this.doClose(),this.onClose()),this}send(e){"open"===this.readyState&&this.write(e);}onOpen(){this.readyState="open",this.writable=true,super.emitReserved("open");}onData(e){const t=Gw(e,this.socket.binaryType);this.onPacket(t);}onPacket(e){super.emitReserved("packet",e);}onClose(e){this.readyState="closed",super.emitReserved("close",e);}pause(e){}createUri(e,t={}){return e+"://"+this._hostname()+this._port()+this.opts.path+this._query(t)}_hostname(){const e=this.opts.hostname;return  -1===e.indexOf(":")?e:"["+e+"]"}_port(){return this.opts.port&&(this.opts.secure&&Number(443!==this.opts.port)||!this.opts.secure&&80!==Number(this.opts.port))?":"+this.opts.port:""}_query(e){const t=function(e){let t="";for(let n in e)e.hasOwnProperty(n)&&(t.length&&(t+="&"),t+=encodeURIComponent(n)+"="+encodeURIComponent(e[n]));return t}(e);return t.length?"?"+t:""}}const u_="0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""),l_=64,c_={};let d_,f_=0,h_=0;function p_(e){let t="";do{t=u_[e%l_]+t,e=Math.floor(e/l_);}while(e>0);return t}function m_(){const e=p_(+new Date);return e!==d_?(f_=0,d_=e):e+"."+p_(f_++)}for(;h_<l_;h_++)c_[u_[h_]]=h_;let g_=false;try{g_="undefined"!=typeof XMLHttpRequest&&"withCredentials"in new XMLHttpRequest;}catch(e){}const v_=g_;function b_(e){const t=e.xdomain;try{if("undefined"!=typeof XMLHttpRequest&&(!t||v_))return new XMLHttpRequest}catch(e){}if(!t)try{return new(t_[["Active"].concat("Object").join("X")])("Microsoft.XMLHTTP")}catch(e){}}function y_(){}const w_=null!=new b_({xdomain:false}).responseType;class __ extends e_{constructor(e,t){super(),o_(this,t),this.opts=t,this.method=t.method||"GET",this.uri=e,this.data=void 0!==t.data?t.data:null,this.create();}create(){var e;const t=n_(this.opts,"agent","pfx","key","passphrase","cert","ca","ciphers","rejectUnauthorized","autoUnref");t.xdomain=!!this.opts.xd;const n=this.xhr=new b_(t);try{n.open(this.method,this.uri,!0);try{if(this.opts.extraHeaders){n.setDisableHeaderCheck&&n.setDisableHeaderCheck(!0);for(let e in this.opts.extraHeaders)this.opts.extraHeaders.hasOwnProperty(e)&&n.setRequestHeader(e,this.opts.extraHeaders[e]);}}catch(e){}if("POST"===this.method)try{n.setRequestHeader("Content-type","text/plain;charset=UTF-8");}catch(e){}try{n.setRequestHeader("Accept","*/*");}catch(e){}null===(e=this.opts.cookieJar)||void 0===e||e.addCookies(n),"withCredentials"in n&&(n.withCredentials=this.opts.withCredentials),this.opts.requestTimeout&&(n.timeout=this.opts.requestTimeout),n.onreadystatechange=()=>{var e;3===n.readyState&&(null===(e=this.opts.cookieJar)||void 0===e||e.parseCookies(n)),4===n.readyState&&(200===n.status||1223===n.status?this.onLoad():this.setTimeoutFn((()=>{this.onError("number"==typeof n.status?n.status:0);}),0));},n.send(this.data);}catch(e){return void this.setTimeoutFn((()=>{this.onError(e);}),0)}"undefined"!=typeof document&&(this.index=__.requestsCount++,__.requests[this.index]=this);}onError(e){this.emitReserved("error",e,this.xhr),this.cleanup(true);}cleanup(e){if(void 0!==this.xhr&&null!==this.xhr){if(this.xhr.onreadystatechange=y_,e)try{this.xhr.abort();}catch(e){}"undefined"!=typeof document&&delete __.requests[this.index],this.xhr=null;}}onLoad(){const e=this.xhr.responseText;null!==e&&(this.emitReserved("data",e),this.emitReserved("success"),this.cleanup());}abort(){this.cleanup();}}if(__.requestsCount=0,__.requests={},"undefined"!=typeof document)if("function"==typeof attachEvent)attachEvent("onunload",S_);else if("function"==typeof addEventListener){addEventListener("onpagehide"in t_?"pagehide":"unload",S_,false);}function S_(){for(let e in __.requests)__.requests.hasOwnProperty(e)&&__.requests[e].abort();}const E_="function"==typeof Promise&&"function"==typeof Promise.resolve?e=>Promise.resolve().then(e):(e,t)=>t(e,0),k_=t_.WebSocket||t_.MozWebSocket,M_="undefined"!=typeof navigator&&"string"==typeof navigator.product&&"reactnative"===navigator.product.toLowerCase();function C_(e,t){return "message"===e.type&&"string"!=typeof e.data&&t[0]>=48&&t[0]<=54}const x_={websocket:class extends s_{constructor(e){super(e),this.supportsBinary=!e.forceBase64;}get name(){return "websocket"}doOpen(){if(!this.check())return;const e=this.uri(),t=this.opts.protocols,n=M_?{}:n_(this.opts,"agent","perMessageDeflate","pfx","key","passphrase","cert","ca","ciphers","rejectUnauthorized","localAddress","protocolVersion","origin","maxPayload","family","checkServerIdentity");this.opts.extraHeaders&&(n.headers=this.opts.extraHeaders);try{this.ws=M_?new k_(e,t,n):t?new k_(e,t):new k_(e);}catch(e){return this.emitReserved("error",e)}this.ws.binaryType=this.socket.binaryType||"arraybuffer",this.addEventListeners();}addEventListeners(){this.ws.onopen=()=>{this.opts.autoUnref&&this.ws._socket.unref(),this.onOpen();},this.ws.onclose=e=>this.onClose({description:"websocket connection closed",context:e}),this.ws.onmessage=e=>this.onData(e.data),this.ws.onerror=e=>this.onError("websocket error",e);}write(e){this.writable=false;for(let t=0;t<e.length;t++){const n=e[t],r=t===e.length-1;Fw(n,this.supportsBinary,(e=>{try{this.ws.send(e);}catch(e){}r&&E_((()=>{this.writable=true,this.emitReserved("drain");}),this.setTimeoutFn);}));}}doClose(){ void 0!==this.ws&&(this.ws.close(),this.ws=null);}uri(){const e=this.opts.secure?"wss":"ws",t=this.query||{};return this.opts.timestampRequests&&(t[this.opts.timestampParam]=m_()),this.supportsBinary||(t.b64=1),this.createUri(e,t)}check(){return !!k_}},webtransport:class extends s_{get name(){return "webtransport"}doOpen(){"function"==typeof WebTransport&&(this.transport=new WebTransport(this.createUri("https"),this.opts.transportOptions[this.name]),this.transport.closed.then((()=>{this.onClose();})).catch((e=>{this.onError("webtransport error",e);})),this.transport.ready.then((()=>{this.transport.createBidirectionalStream().then((e=>{const t=e.readable.getReader();let n;this.writer=e.writable.getWriter();const r=()=>{t.read().then((({done:e,value:t})=>{e||(n||1!==t.byteLength||54!==t[0]?(this.onPacket(function(e,t,n){Xw||(Xw=new TextDecoder);const r=t||e[0]<48||e[0]>54;return Gw(r?e:Xw.decode(e),n)}(t,n,"arraybuffer")),n=false):n=true,r());})).catch((e=>{}));};r();const i=this.query.sid?`0{"sid":"${this.query.sid}"}`:"0";this.writer.write((new TextEncoder).encode(i)).then((()=>this.onOpen()));}));})));}write(e){this.writable=false;for(let t=0;t<e.length;t++){const n=e[t],r=t===e.length-1;Ww(n,(e=>{C_(n,e)&&this.writer.write(Uint8Array.of(54)),this.writer.write(e).then((()=>{r&&E_((()=>{this.writable=true,this.emitReserved("drain");}),this.setTimeoutFn);}));}));}}doClose(){var e;null===(e=this.transport)||void 0===e||e.close();}},polling:class extends s_{constructor(e){if(super(e),this.polling=false,"undefined"!=typeof location){const t="https:"===location.protocol;let n=location.port;n||(n=t?"443":"80"),this.xd="undefined"!=typeof location&&e.hostname!==location.hostname||n!==e.port;}const t=e&&e.forceBase64;this.supportsBinary=w_&&!t,this.opts.withCredentials&&(this.cookieJar=void 0);}get name(){return "polling"}doOpen(){this.poll();}pause(e){this.readyState="pausing";const t=()=>{this.readyState="paused",e();};if(this.polling||!this.writable){let e=0;this.polling&&(e++,this.once("pollComplete",(function(){--e||t();}))),this.writable||(e++,this.once("drain",(function(){--e||t();})));}else t();}poll(){this.polling=true,this.doPoll(),this.emitReserved("poll");}onData(e){((e,t)=>{const n=e.split(Jw),r=[];for(let e=0;e<n.length;e++){const i=Gw(n[e],t);if(r.push(i),"error"===i.type)break}return r})(e,this.socket.binaryType).forEach((e=>{if("opening"===this.readyState&&"open"===e.type&&this.onOpen(),"close"===e.type)return this.onClose({description:"transport closed by the server"}),false;this.onPacket(e);})),"closed"!==this.readyState&&(this.polling=false,this.emitReserved("pollComplete"),"open"===this.readyState&&this.poll());}doClose(){const e=()=>{this.write([{type:"close"}]);};"open"===this.readyState?e():this.once("open",e);}write(e){this.writable=false,((e,t)=>{const n=e.length,r=new Array(n);let i=0;e.forEach(((e,o)=>{Fw(e,false,(e=>{r[o]=e,++i===n&&t(r.join(Jw));}));}));})(e,(e=>{this.doWrite(e,(()=>{this.writable=true,this.emitReserved("drain");}));}));}uri(){const e=this.opts.secure?"https":"http",t=this.query||{};return  false!==this.opts.timestampRequests&&(t[this.opts.timestampParam]=m_()),this.supportsBinary||t.sid||(t.b64=1),this.createUri(e,t)}request(e={}){return Object.assign(e,{xd:this.xd,cookieJar:this.cookieJar},this.opts),new __(this.uri(),e)}doWrite(e,t){const n=this.request({method:"POST",data:e});n.on("success",t),n.on("error",((e,t)=>{this.onError("xhr post error",e,t);}));}doPoll(){const e=this.request();e.on("data",this.onData.bind(this)),e.on("error",((e,t)=>{this.onError("xhr poll error",e,t);})),this.pollXhr=e;}}},A_=/^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,R_=["source","protocol","authority","userInfo","user","password","host","port","relative","path","directory","file","query","anchor"];function T_(e){const t=e,n=e.indexOf("["),r=e.indexOf("]");-1!=n&&-1!=r&&(e=e.substring(0,n)+e.substring(n,r).replace(/:/g,";")+e.substring(r,e.length));let i=A_.exec(e||""),o={},a=14;for(;a--;)o[R_[a]]=i[a]||"";return  -1!=n&&-1!=r&&(o.source=t,o.host=o.host.substring(1,o.host.length-1).replace(/;/g,":"),o.authority=o.authority.replace("[","").replace("]","").replace(/;/g,":"),o.ipv6uri=true),o.pathNames=function(e,t){const n=/\/{2,9}/g,r=t.replace(n,"/").split("/");"/"!=t.slice(0,1)&&0!==t.length||r.splice(0,1);"/"==t.slice(-1)&&r.splice(r.length-1,1);return r}(0,o.path),o.queryKey=function(e,t){const n={};return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g,(function(e,t,r){t&&(n[t]=r);})),n}(0,o.query),o}let P_=class e extends e_{constructor(e,t={}){super(),this.writeBuffer=[],e&&"object"==typeof e&&(t=e,e=null),e?(e=T_(e),t.hostname=e.host,t.secure="https"===e.protocol||"wss"===e.protocol,t.port=e.port,e.query&&(t.query=e.query)):t.host&&(t.hostname=T_(t.host).host),o_(this,t),this.secure=null!=t.secure?t.secure:"undefined"!=typeof location&&"https:"===location.protocol,t.hostname&&!t.port&&(t.port=this.secure?"443":"80"),this.hostname=t.hostname||("undefined"!=typeof location?location.hostname:"localhost"),this.port=t.port||("undefined"!=typeof location&&location.port?location.port:this.secure?"443":"80"),this.transports=t.transports||["polling","websocket","webtransport"],this.writeBuffer=[],this.prevBufferLen=0,this.opts=Object.assign({path:"/engine.io",agent:false,withCredentials:false,upgrade:true,timestampParam:"t",rememberUpgrade:false,addTrailingSlash:true,rejectUnauthorized:true,perMessageDeflate:{threshold:1024},transportOptions:{},closeOnBeforeunload:false},t),this.opts.path=this.opts.path.replace(/\/$/,"")+(this.opts.addTrailingSlash?"/":""),"string"==typeof this.opts.query&&(this.opts.query=function(e){let t={},n=e.split("&");for(let e=0,r=n.length;e<r;e++){let r=n[e].split("=");t[decodeURIComponent(r[0])]=decodeURIComponent(r[1]);}return t}(this.opts.query)),this.id=null,this.upgrades=null,this.pingInterval=null,this.pingTimeout=null,this.pingTimeoutTimer=null,"function"==typeof addEventListener&&(this.opts.closeOnBeforeunload&&(this.beforeunloadEventListener=()=>{this.transport&&(this.transport.removeAllListeners(),this.transport.close());},addEventListener("beforeunload",this.beforeunloadEventListener,false)),"localhost"!==this.hostname&&(this.offlineEventListener=()=>{this.onClose("transport close",{description:"network connection lost"});},addEventListener("offline",this.offlineEventListener,false))),this.open();}createTransport(e){const t=Object.assign({},this.opts.query);t.EIO=4,t.transport=e,this.id&&(t.sid=this.id);const n=Object.assign({},this.opts,{query:t,socket:this,hostname:this.hostname,secure:this.secure,port:this.port},this.opts.transportOptions[e]);return new x_[e](n)}open(){let t;if(this.opts.rememberUpgrade&&e.priorWebsocketSuccess&&-1!==this.transports.indexOf("websocket"))t="websocket";else {if(0===this.transports.length)return void this.setTimeoutFn((()=>{this.emitReserved("error","No transports available");}),0);t=this.transports[0];}this.readyState="opening";try{t=this.createTransport(t);}catch(e){return this.transports.shift(),void this.open()}t.open(),this.setTransport(t);}setTransport(e){this.transport&&this.transport.removeAllListeners(),this.transport=e,e.on("drain",this.onDrain.bind(this)).on("packet",this.onPacket.bind(this)).on("error",this.onError.bind(this)).on("close",(e=>this.onClose("transport close",e)));}probe(t){let n=this.createTransport(t),r=false;e.priorWebsocketSuccess=false;const i=()=>{r||(n.send([{type:"ping",data:"probe"}]),n.once("packet",(t=>{if(!r)if("pong"===t.type&&"probe"===t.data){if(this.upgrading=true,this.emitReserved("upgrading",n),!n)return;e.priorWebsocketSuccess="websocket"===n.name,this.transport.pause((()=>{r||"closed"!==this.readyState&&(c(),this.setTransport(n),n.send([{type:"upgrade"}]),this.emitReserved("upgrade",n),n=null,this.upgrading=false,this.flush());}));}else {const e=new Error("probe error");e.transport=n.name,this.emitReserved("upgradeError",e);}})));};function o(){r||(r=true,c(),n.close(),n=null);}const a=e=>{const t=new Error("probe error: "+e);t.transport=n.name,o(),this.emitReserved("upgradeError",t);};function s(){a("transport closed");}function u(){a("socket closed");}function l(e){n&&e.name!==n.name&&o();}const c=()=>{n.removeListener("open",i),n.removeListener("error",a),n.removeListener("close",s),this.off("close",u),this.off("upgrading",l);};n.once("open",i),n.once("error",a),n.once("close",s),this.once("close",u),this.once("upgrading",l),-1!==this.upgrades.indexOf("webtransport")&&"webtransport"!==t?this.setTimeoutFn((()=>{r||n.open();}),200):n.open();}onOpen(){if(this.readyState="open",e.priorWebsocketSuccess="websocket"===this.transport.name,this.emitReserved("open"),this.flush(),"open"===this.readyState&&this.opts.upgrade){let e=0;const t=this.upgrades.length;for(;e<t;e++)this.probe(this.upgrades[e]);}}onPacket(e){if("opening"===this.readyState||"open"===this.readyState||"closing"===this.readyState)switch(this.emitReserved("packet",e),this.emitReserved("heartbeat"),e.type){case "open":this.onHandshake(JSON.parse(e.data));break;case "ping":this.resetPingTimeout(),this.sendPacket("pong"),this.emitReserved("ping"),this.emitReserved("pong");break;case "error":const t=new Error("server error");t.code=e.data,this.onError(t);break;case "message":this.emitReserved("data",e.data),this.emitReserved("message",e.data);}}onHandshake(e){this.emitReserved("handshake",e),this.id=e.sid,this.transport.query.sid=e.sid,this.upgrades=this.filterUpgrades(e.upgrades),this.pingInterval=e.pingInterval,this.pingTimeout=e.pingTimeout,this.maxPayload=e.maxPayload,this.onOpen(),"closed"!==this.readyState&&this.resetPingTimeout();}resetPingTimeout(){this.clearTimeoutFn(this.pingTimeoutTimer),this.pingTimeoutTimer=this.setTimeoutFn((()=>{this.onClose("ping timeout");}),this.pingInterval+this.pingTimeout),this.opts.autoUnref&&this.pingTimeoutTimer.unref();}onDrain(){this.writeBuffer.splice(0,this.prevBufferLen),this.prevBufferLen=0,0===this.writeBuffer.length?this.emitReserved("drain"):this.flush();}flush(){if("closed"!==this.readyState&&this.transport.writable&&!this.upgrading&&this.writeBuffer.length){const e=this.getWritablePackets();this.transport.send(e),this.prevBufferLen=e.length,this.emitReserved("flush");}}getWritablePackets(){if(!(this.maxPayload&&"polling"===this.transport.name&&this.writeBuffer.length>1))return this.writeBuffer;let e=1;for(let n=0;n<this.writeBuffer.length;n++){const r=this.writeBuffer[n].data;if(r&&(e+="string"==typeof(t=r)?function(e){let t=0,n=0;for(let r=0,i=e.length;r<i;r++)t=e.charCodeAt(r),t<128?n+=1:t<2048?n+=2:t<55296||t>=57344?n+=3:(r++,n+=4);return n}(t):Math.ceil(1.33*(t.byteLength||t.size))),n>0&&e>this.maxPayload)return this.writeBuffer.slice(0,n);e+=2;}var t;return this.writeBuffer}write(e,t,n){return this.sendPacket("message",e,t,n),this}send(e,t,n){return this.sendPacket("message",e,t,n),this}sendPacket(e,t,n,r){if("function"==typeof t&&(r=t,t=void 0),"function"==typeof n&&(r=n,n=null),"closing"===this.readyState||"closed"===this.readyState)return;(n=n||{}).compress=false!==n.compress;const i={type:e,data:t,options:n};this.emitReserved("packetCreate",i),this.writeBuffer.push(i),r&&this.once("flush",r),this.flush();}close(){const e=()=>{this.onClose("forced close"),this.transport.close();},t=()=>{this.off("upgrade",t),this.off("upgradeError",t),e();},n=()=>{this.once("upgrade",t),this.once("upgradeError",t);};return "opening"!==this.readyState&&"open"!==this.readyState||(this.readyState="closing",this.writeBuffer.length?this.once("drain",(()=>{this.upgrading?n():e();})):this.upgrading?n():e()),this}onError(t){e.priorWebsocketSuccess=false,this.emitReserved("error",t),this.onClose("transport error",t);}onClose(e,t){"opening"!==this.readyState&&"open"!==this.readyState&&"closing"!==this.readyState||(this.clearTimeoutFn(this.pingTimeoutTimer),this.transport.removeAllListeners("close"),this.transport.close(),this.transport.removeAllListeners(),"function"==typeof removeEventListener&&(removeEventListener("beforeunload",this.beforeunloadEventListener,false),removeEventListener("offline",this.offlineEventListener,false)),this.readyState="closed",this.id=null,this.emitReserved("close",e,t),this.writeBuffer=[],this.prevBufferLen=0);}filterUpgrades(e){const t=[];let n=0;const r=e.length;for(;n<r;n++)~this.transports.indexOf(e[n])&&t.push(e[n]);return t}};P_.protocol=4;const L_="function"==typeof ArrayBuffer,I_=e=>"function"==typeof ArrayBuffer.isView?ArrayBuffer.isView(e):e.buffer instanceof ArrayBuffer,O_=Object.prototype.toString,N_="function"==typeof Blob||"undefined"!=typeof Blob&&"[object BlobConstructor]"===O_.call(Blob),D_="function"==typeof File||"undefined"!=typeof File&&"[object FileConstructor]"===O_.call(File);function j_(e){return L_&&(e instanceof ArrayBuffer||I_(e))||N_&&e instanceof Blob||D_&&e instanceof File}function B_(e,t){if(!e||"object"!=typeof e)return  false;if(Array.isArray(e)){for(let t=0,n=e.length;t<n;t++)if(B_(e[t]))return  true;return  false}if(j_(e))return  true;if(e.toJSON&&"function"==typeof e.toJSON&&1===arguments.length)return B_(e.toJSON(),true);for(const t in e)if(Object.prototype.hasOwnProperty.call(e,t)&&B_(e[t]))return  true;return  false}function z_(e){const t=[],n=e.data,r=e;return r.data=U_(n,t),r.attachments=t.length,{packet:r,buffers:t}}function U_(e,t){if(!e)return e;if(j_(e)){const n={_placeholder:true,num:t.length};return t.push(e),n}if(Array.isArray(e)){const n=new Array(e.length);for(let r=0;r<e.length;r++)n[r]=U_(e[r],t);return n}if("object"==typeof e&&!(e instanceof Date)){const n={};for(const r in e)Object.prototype.hasOwnProperty.call(e,r)&&(n[r]=U_(e[r],t));return n}return e}function F_(e,t){return e.data=K_(e.data,t),delete e.attachments,e}function K_(e,t){if(!e)return e;if(e&&true===e._placeholder){if("number"==typeof e.num&&e.num>=0&&e.num<t.length)return t[e.num];throw new Error("illegal attachments")}if(Array.isArray(e))for(let n=0;n<e.length;n++)e[n]=K_(e[n],t);else if("object"==typeof e)for(const n in e)Object.prototype.hasOwnProperty.call(e,n)&&(e[n]=K_(e[n],t));return e}const q_=["connect","connect_error","disconnect","disconnecting","newListener","removeListener"];var H_;!function(e){e[e.CONNECT=0]="CONNECT",e[e.DISCONNECT=1]="DISCONNECT",e[e.EVENT=2]="EVENT",e[e.ACK=3]="ACK",e[e.CONNECT_ERROR=4]="CONNECT_ERROR",e[e.BINARY_EVENT=5]="BINARY_EVENT",e[e.BINARY_ACK=6]="BINARY_ACK";}(H_||(H_={}));function W_(e){return "[object Object]"===Object.prototype.toString.call(e)}class $_ extends e_{constructor(e){super(),this.reviver=e;}add(e){let t;if("string"==typeof e){if(this.reconstructor)throw new Error("got plaintext data when reconstructing a packet");t=this.decodeString(e);const n=t.type===H_.BINARY_EVENT;n||t.type===H_.BINARY_ACK?(t.type=n?H_.EVENT:H_.ACK,this.reconstructor=new V_(t),0===t.attachments&&super.emitReserved("decoded",t)):super.emitReserved("decoded",t);}else {if(!j_(e)&&!e.base64)throw new Error("Unknown type: "+e);if(!this.reconstructor)throw new Error("got binary data when not reconstructing a packet");t=this.reconstructor.takeBinaryData(e),t&&(this.reconstructor=null,super.emitReserved("decoded",t));}}decodeString(e){let t=0;const n={type:Number(e.charAt(0))};if(void 0===H_[n.type])throw new Error("unknown packet type "+n.type);if(n.type===H_.BINARY_EVENT||n.type===H_.BINARY_ACK){const r=t+1;for(;"-"!==e.charAt(++t)&&t!=e.length;);const i=e.substring(r,t);if(i!=Number(i)||"-"!==e.charAt(t))throw new Error("Illegal attachments");n.attachments=Number(i);}if("/"===e.charAt(t+1)){const r=t+1;for(;++t;){if(","===e.charAt(t))break;if(t===e.length)break}n.nsp=e.substring(r,t);}else n.nsp="/";const r=e.charAt(t+1);if(""!==r&&Number(r)==r){const r=t+1;for(;++t;){const n=e.charAt(t);if(null==n||Number(n)!=n){--t;break}if(t===e.length)break}n.id=Number(e.substring(r,t+1));}if(e.charAt(++t)){const r=this.tryParse(e.substr(t));if(!$_.isPayloadValid(n.type,r))throw new Error("invalid payload");n.data=r;}return n}tryParse(e){try{return JSON.parse(e,this.reviver)}catch(e){return  false}}static isPayloadValid(e,t){switch(e){case H_.CONNECT:return W_(t);case H_.DISCONNECT:return void 0===t;case H_.CONNECT_ERROR:return "string"==typeof t||W_(t);case H_.EVENT:case H_.BINARY_EVENT:return Array.isArray(t)&&("number"==typeof t[0]||"string"==typeof t[0]&&-1===q_.indexOf(t[0]));case H_.ACK:case H_.BINARY_ACK:return Array.isArray(t)}}destroy(){this.reconstructor&&(this.reconstructor.finishedReconstruction(),this.reconstructor=null);}}class V_{constructor(e){this.packet=e,this.buffers=[],this.reconPack=e;}takeBinaryData(e){if(this.buffers.push(e),this.buffers.length===this.reconPack.attachments){const e=F_(this.reconPack,this.buffers);return this.finishedReconstruction(),e}return null}finishedReconstruction(){this.reconPack=null,this.buffers=[];}}var Y_=Object.freeze({__proto__:null,Decoder:$_,Encoder:class{constructor(e){this.replacer=e;}encode(e){return e.type!==H_.EVENT&&e.type!==H_.ACK||!B_(e)?[this.encodeAsString(e)]:this.encodeAsBinary({type:e.type===H_.EVENT?H_.BINARY_EVENT:H_.BINARY_ACK,nsp:e.nsp,data:e.data,id:e.id})}encodeAsString(e){let t=""+e.type;return e.type!==H_.BINARY_EVENT&&e.type!==H_.BINARY_ACK||(t+=e.attachments+"-"),e.nsp&&"/"!==e.nsp&&(t+=e.nsp+","),null!=e.id&&(t+=e.id),null!=e.data&&(t+=JSON.stringify(e.data,this.replacer)),t}encodeAsBinary(e){const t=z_(e),n=this.encodeAsString(t.packet),r=t.buffers;return r.unshift(n),r}},get PacketType(){return H_},protocol:5});function G_(e,t,n){return e.on(t,n),function(){e.off(t,n);}}const Z_=Object.freeze({connect:1,connect_error:1,disconnect:1,disconnecting:1,newListener:1,removeListener:1});class Q_ extends e_{constructor(e,t,n){super(),this.connected=false,this.recovered=false,this.receiveBuffer=[],this.sendBuffer=[],this._queue=[],this._queueSeq=0,this.ids=0,this.acks={},this.flags={},this.io=e,this.nsp=t,n&&n.auth&&(this.auth=n.auth),this._opts=Object.assign({},n),this.io._autoConnect&&this.open();}get disconnected(){return !this.connected}subEvents(){if(this.subs)return;const e=this.io;this.subs=[G_(e,"open",this.onopen.bind(this)),G_(e,"packet",this.onpacket.bind(this)),G_(e,"error",this.onerror.bind(this)),G_(e,"close",this.onclose.bind(this))];}get active(){return !!this.subs}connect(){return this.connected||(this.subEvents(),this.io._reconnecting||this.io.open(),"open"===this.io._readyState&&this.onopen()),this}open(){return this.connect()}send(...e){return e.unshift("message"),this.emit.apply(this,e),this}emit(e,...t){if(Z_.hasOwnProperty(e))throw new Error('"'+e.toString()+'" is a reserved event name');if(t.unshift(e),this._opts.retries&&!this.flags.fromQueue&&!this.flags.volatile)return this._addToQueue(t),this;const n={type:H_.EVENT,data:t,options:{}};if(n.options.compress=false!==this.flags.compress,"function"==typeof t[t.length-1]){const e=this.ids++,r=t.pop();this._registerAckCallback(e,r),n.id=e;}const r=this.io.engine&&this.io.engine.transport&&this.io.engine.transport.writable;return this.flags.volatile&&(!r||!this.connected)||(this.connected?(this.notifyOutgoingListeners(n),this.packet(n)):this.sendBuffer.push(n)),this.flags={},this}_registerAckCallback(e,t){var n;const r=null!==(n=this.flags.timeout)&&void 0!==n?n:this._opts.ackTimeout;if(void 0===r)return void(this.acks[e]=t);const i=this.io.setTimeoutFn((()=>{delete this.acks[e];for(let t=0;t<this.sendBuffer.length;t++)this.sendBuffer[t].id===e&&this.sendBuffer.splice(t,1);t.call(this,new Error("operation has timed out"));}),r);this.acks[e]=(...e)=>{this.io.clearTimeoutFn(i),t.apply(this,[null,...e]);};}emitWithAck(e,...t){const n=void 0!==this.flags.timeout||void 0!==this._opts.ackTimeout;return new Promise(((r,i)=>{t.push(((e,t)=>n?e?i(e):r(t):r(e))),this.emit(e,...t);}))}_addToQueue(e){let t;"function"==typeof e[e.length-1]&&(t=e.pop());const n={id:this._queueSeq++,tryCount:0,pending:false,args:e,flags:Object.assign({fromQueue:true},this.flags)};e.push(((e,...r)=>{if(n!==this._queue[0])return;return null!==e?n.tryCount>this._opts.retries&&(this._queue.shift(),t&&t(e)):(this._queue.shift(),t&&t(null,...r)),n.pending=false,this._drainQueue()})),this._queue.push(n),this._drainQueue();}_drainQueue(e=false){if(!this.connected||0===this._queue.length)return;const t=this._queue[0];t.pending&&!e||(t.pending=true,t.tryCount++,this.flags=t.flags,this.emit.apply(this,t.args));}packet(e){e.nsp=this.nsp,this.io._packet(e);}onopen(){"function"==typeof this.auth?this.auth((e=>{this._sendConnectPacket(e);})):this._sendConnectPacket(this.auth);}_sendConnectPacket(e){this.packet({type:H_.CONNECT,data:this._pid?Object.assign({pid:this._pid,offset:this._lastOffset},e):e});}onerror(e){this.connected||this.emitReserved("connect_error",e);}onclose(e,t){this.connected=false,delete this.id,this.emitReserved("disconnect",e,t);}onpacket(e){if(e.nsp===this.nsp)switch(e.type){case H_.CONNECT:e.data&&e.data.sid?this.onconnect(e.data.sid,e.data.pid):this.emitReserved("connect_error",new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));break;case H_.EVENT:case H_.BINARY_EVENT:this.onevent(e);break;case H_.ACK:case H_.BINARY_ACK:this.onack(e);break;case H_.DISCONNECT:this.ondisconnect();break;case H_.CONNECT_ERROR:this.destroy();const t=new Error(e.data.message);t.data=e.data.data,this.emitReserved("connect_error",t);}}onevent(e){const t=e.data||[];null!=e.id&&t.push(this.ack(e.id)),this.connected?this.emitEvent(t):this.receiveBuffer.push(Object.freeze(t));}emitEvent(e){if(this._anyListeners&&this._anyListeners.length){const t=this._anyListeners.slice();for(const n of t)n.apply(this,e);}super.emit.apply(this,e),this._pid&&e.length&&"string"==typeof e[e.length-1]&&(this._lastOffset=e[e.length-1]);}ack(e){const t=this;let n=false;return function(...r){n||(n=true,t.packet({type:H_.ACK,id:e,data:r}));}}onack(e){const t=this.acks[e.id];"function"==typeof t&&(t.apply(this,e.data),delete this.acks[e.id]);}onconnect(e,t){this.id=e,this.recovered=t&&this._pid===t,this._pid=t,this.connected=true,this.emitBuffered(),this.emitReserved("connect"),this._drainQueue(true);}emitBuffered(){this.receiveBuffer.forEach((e=>this.emitEvent(e))),this.receiveBuffer=[],this.sendBuffer.forEach((e=>{this.notifyOutgoingListeners(e),this.packet(e);})),this.sendBuffer=[];}ondisconnect(){this.destroy(),this.onclose("io server disconnect");}destroy(){this.subs&&(this.subs.forEach((e=>e())),this.subs=void 0),this.io._destroy(this);}disconnect(){return this.connected&&this.packet({type:H_.DISCONNECT}),this.destroy(),this.connected&&this.onclose("io client disconnect"),this}close(){return this.disconnect()}compress(e){return this.flags.compress=e,this}get volatile(){return this.flags.volatile=true,this}timeout(e){return this.flags.timeout=e,this}onAny(e){return this._anyListeners=this._anyListeners||[],this._anyListeners.push(e),this}prependAny(e){return this._anyListeners=this._anyListeners||[],this._anyListeners.unshift(e),this}offAny(e){if(!this._anyListeners)return this;if(e){const t=this._anyListeners;for(let n=0;n<t.length;n++)if(e===t[n])return t.splice(n,1),this}else this._anyListeners=[];return this}listenersAny(){return this._anyListeners||[]}onAnyOutgoing(e){return this._anyOutgoingListeners=this._anyOutgoingListeners||[],this._anyOutgoingListeners.push(e),this}prependAnyOutgoing(e){return this._anyOutgoingListeners=this._anyOutgoingListeners||[],this._anyOutgoingListeners.unshift(e),this}offAnyOutgoing(e){if(!this._anyOutgoingListeners)return this;if(e){const t=this._anyOutgoingListeners;for(let n=0;n<t.length;n++)if(e===t[n])return t.splice(n,1),this}else this._anyOutgoingListeners=[];return this}listenersAnyOutgoing(){return this._anyOutgoingListeners||[]}notifyOutgoingListeners(e){if(this._anyOutgoingListeners&&this._anyOutgoingListeners.length){const t=this._anyOutgoingListeners.slice();for(const n of t)n.apply(this,e.data);}}}function J_(e){e=e||{},this.ms=e.min||100,this.max=e.max||1e4,this.factor=e.factor||2,this.jitter=e.jitter>0&&e.jitter<=1?e.jitter:0,this.attempts=0;}J_.prototype.duration=function(){var e=this.ms*Math.pow(this.factor,this.attempts++);if(this.jitter){var t=Math.random(),n=Math.floor(t*this.jitter*e);e=0==(1&Math.floor(10*t))?e-n:e+n;}return 0|Math.min(e,this.max)},J_.prototype.reset=function(){this.attempts=0;},J_.prototype.setMin=function(e){this.ms=e;},J_.prototype.setMax=function(e){this.max=e;},J_.prototype.setJitter=function(e){this.jitter=e;};class X_ extends e_{constructor(e,t){var n;super(),this.nsps={},this.subs=[],e&&"object"==typeof e&&(t=e,e=void 0),(t=t||{}).path=t.path||"/socket.io",this.opts=t,o_(this,t),this.reconnection(false!==t.reconnection),this.reconnectionAttempts(t.reconnectionAttempts||1/0),this.reconnectionDelay(t.reconnectionDelay||1e3),this.reconnectionDelayMax(t.reconnectionDelayMax||5e3),this.randomizationFactor(null!==(n=t.randomizationFactor)&&void 0!==n?n:.5),this.backoff=new J_({min:this.reconnectionDelay(),max:this.reconnectionDelayMax(),jitter:this.randomizationFactor()}),this.timeout(null==t.timeout?2e4:t.timeout),this._readyState="closed",this.uri=e;const r=t.parser||Y_;this.encoder=new r.Encoder,this.decoder=new r.Decoder,this._autoConnect=false!==t.autoConnect,this._autoConnect&&this.open();}reconnection(e){return arguments.length?(this._reconnection=!!e,this):this._reconnection}reconnectionAttempts(e){return void 0===e?this._reconnectionAttempts:(this._reconnectionAttempts=e,this)}reconnectionDelay(e){var t;return void 0===e?this._reconnectionDelay:(this._reconnectionDelay=e,null===(t=this.backoff)||void 0===t||t.setMin(e),this)}randomizationFactor(e){var t;return void 0===e?this._randomizationFactor:(this._randomizationFactor=e,null===(t=this.backoff)||void 0===t||t.setJitter(e),this)}reconnectionDelayMax(e){var t;return void 0===e?this._reconnectionDelayMax:(this._reconnectionDelayMax=e,null===(t=this.backoff)||void 0===t||t.setMax(e),this)}timeout(e){return arguments.length?(this._timeout=e,this):this._timeout}maybeReconnectOnOpen(){!this._reconnecting&&this._reconnection&&0===this.backoff.attempts&&this.reconnect();}open(e){if(~this._readyState.indexOf("open"))return this;this.engine=new P_(this.uri,this.opts);const t=this.engine,n=this;this._readyState="opening",this.skipReconnect=false;const r=G_(t,"open",(function(){n.onopen(),e&&e();})),i=t=>{this.cleanup(),this._readyState="closed",this.emitReserved("error",t),e?e(t):this.maybeReconnectOnOpen();},o=G_(t,"error",i);if(false!==this._timeout){const e=this._timeout,n=this.setTimeoutFn((()=>{r(),i(new Error("timeout")),t.close();}),e);this.opts.autoUnref&&n.unref(),this.subs.push((()=>{this.clearTimeoutFn(n);}));}return this.subs.push(r),this.subs.push(o),this}connect(e){return this.open(e)}onopen(){this.cleanup(),this._readyState="open",this.emitReserved("open");const e=this.engine;this.subs.push(G_(e,"ping",this.onping.bind(this)),G_(e,"data",this.ondata.bind(this)),G_(e,"error",this.onerror.bind(this)),G_(e,"close",this.onclose.bind(this)),G_(this.decoder,"decoded",this.ondecoded.bind(this)));}onping(){this.emitReserved("ping");}ondata(e){try{this.decoder.add(e);}catch(e){this.onclose("parse error",e);}}ondecoded(e){E_((()=>{this.emitReserved("packet",e);}),this.setTimeoutFn);}onerror(e){this.emitReserved("error",e);}socket(e,t){let n=this.nsps[e];return n?this._autoConnect&&!n.active&&n.connect():(n=new Q_(this,e,t),this.nsps[e]=n),n}_destroy(e){const t=Object.keys(this.nsps);for(const e of t){if(this.nsps[e].active)return}this._close();}_packet(e){const t=this.encoder.encode(e);for(let n=0;n<t.length;n++)this.engine.write(t[n],e.options);}cleanup(){this.subs.forEach((e=>e())),this.subs.length=0,this.decoder.destroy();}_close(){this.skipReconnect=true,this._reconnecting=false,this.onclose("forced close"),this.engine&&this.engine.close();}disconnect(){return this._close()}onclose(e,t){this.cleanup(),this.backoff.reset(),this._readyState="closed",this.emitReserved("close",e,t),this._reconnection&&!this.skipReconnect&&this.reconnect();}reconnect(){if(this._reconnecting||this.skipReconnect)return this;const e=this;if(this.backoff.attempts>=this._reconnectionAttempts)this.backoff.reset(),this.emitReserved("reconnect_failed"),this._reconnecting=false;else {const t=this.backoff.duration();this._reconnecting=true;const n=this.setTimeoutFn((()=>{e.skipReconnect||(this.emitReserved("reconnect_attempt",e.backoff.attempts),e.skipReconnect||e.open((t=>{t?(e._reconnecting=false,e.reconnect(),this.emitReserved("reconnect_error",t)):e.onreconnect();})));}),t);this.opts.autoUnref&&n.unref(),this.subs.push((()=>{this.clearTimeoutFn(n);}));}}onreconnect(){const e=this.backoff.attempts;this._reconnecting=false,this.backoff.reset(),this.emitReserved("reconnect",e);}}const eS={};function tS(e,t){"object"==typeof e&&(t=e,e=void 0);const n=function(e,t="",n){let r=e;n=n||"undefined"!=typeof location&&location,null==e&&(e=n.protocol+"//"+n.host),"string"==typeof e&&("/"===e.charAt(0)&&(e="/"===e.charAt(1)?n.protocol+e:n.host+e),/^(https?|wss?):\/\//.test(e)||(e=void 0!==n?n.protocol+"//"+e:"https://"+e),r=T_(e)),r.port||(/^(http|ws)$/.test(r.protocol)?r.port="80":/^(http|ws)s$/.test(r.protocol)&&(r.port="443")),r.path=r.path||"/";const i=-1!==r.host.indexOf(":")?"["+r.host+"]":r.host;return r.id=r.protocol+"://"+i+":"+r.port+t,r.href=r.protocol+"://"+i+(n&&n.port===r.port?"":":"+r.port),r}(e,(t=t||{}).path||"/socket.io"),r=n.source,i=n.id,o=n.path,a=eS[i]&&o in eS[i].nsps;let s;return t.forceNew||t["force new connection"]||false===t.multiplex||a?s=new X_(r,t):(eS[i]||(eS[i]=new X_(r,t)),s=eS[i]),n.query&&!t.query&&(t.query=n.queryKey),s.socket(n.path,t)}function nS(e,t,n,r){return new(n||(n=Promise))((function(i,o){function a(e){try{u(r.next(e));}catch(e){o(e);}}function s(e){try{u(r.throw(e));}catch(e){o(e);}}function u(e){var t;e.done?i(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t);}))).then(a,s);}u((r=r.apply(e,[])).next());}))}Object.assign(tS,{Manager:X_,Socket:Q_,io:tS,connect:tS}),"function"==typeof SuppressedError&&SuppressedError;var rS=void 0!==t?t:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{};function iS(){throw new Error("setTimeout has not been defined")}function oS(){throw new Error("clearTimeout has not been defined")}var aS=iS,sS=oS;function uS(e){if(aS===setTimeout)return setTimeout(e,0);if((aS===iS||!aS)&&setTimeout)return aS=setTimeout,setTimeout(e,0);try{return aS(e,0)}catch(t){try{return aS.call(null,e,0)}catch(t){return aS.call(this,e,0)}}}"function"==typeof rS.setTimeout&&(aS=setTimeout),"function"==typeof rS.clearTimeout&&(sS=clearTimeout);var lS,cS=[],dS=false,fS=-1;function hS(){dS&&lS&&(dS=false,lS.length?cS=lS.concat(cS):fS=-1,cS.length&&pS());}function pS(){if(!dS){var e=uS(hS);dS=true;for(var t=cS.length;t;){for(lS=cS,cS=[];++fS<t;)lS&&lS[fS].run();fS=-1,t=cS.length;}lS=null,dS=false,function(e){if(sS===clearTimeout)return clearTimeout(e);if((sS===oS||!sS)&&clearTimeout)return sS=clearTimeout,clearTimeout(e);try{return sS(e)}catch(t){try{return sS.call(null,e)}catch(t){return sS.call(this,e)}}}(e);}}function mS(e,t){this.fun=e,this.array=t;}function gS(){}mS.prototype.run=function(){this.fun.apply(null,this.array);};var vS=gS,bS=gS,yS=gS,wS=gS,_S=gS,SS=gS,ES=gS,kS=rS.performance||{},MS=kS.now||kS.mozNow||kS.msNow||kS.oNow||kS.webkitNow||function(){return (new Date).getTime()},CS=new Date,xS={nextTick:function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];cS.push(new mS(e,t)),1!==cS.length||dS||uS(pS);},title:"browser",browser:true,env:{},argv:[],version:"",versions:{},on:vS,addListener:bS,once:yS,off:wS,removeListener:_S,removeAllListeners:SS,emit:ES,binding:function(e){throw new Error("process.binding is not supported")},cwd:function(){return "/"},chdir:function(e){throw new Error("process.chdir is not supported")},umask:function(){return 0},hrtime:function(e){var t=.001*MS.call(kS),n=Math.floor(t),r=Math.floor(t%1*1e9);return e&&(n-=e[0],(r-=e[1])<0&&(n--,r+=1e9)),[n,r]},platform:"browser",release:{},config:{},uptime:function(){return (new Date-CS)/1e3}};var AS,RS,TS={exports:{}};var PS=function(e){function t(e){let r,i,o,a=null;function s(...e){if(!s.enabled)return;const n=s,i=Number(new Date),o=i-(r||i);n.diff=o,n.prev=r,n.curr=i,r=i,e[0]=t.coerce(e[0]),"string"!=typeof e[0]&&e.unshift("%O");let a=0;e[0]=e[0].replace(/%([a-zA-Z%])/g,((r,i)=>{if("%%"===r)return "%";a++;const o=t.formatters[i];if("function"==typeof o){const t=e[a];r=o.call(n,t),e.splice(a,1),a--;}return r})),t.formatArgs.call(n,e),(n.log||t.log).apply(n,e);}return s.namespace=e,s.useColors=t.useColors(),s.color=t.selectColor(e),s.extend=n,s.destroy=t.destroy,Object.defineProperty(s,"enabled",{enumerable:true,configurable:false,get:()=>null!==a?a:(i!==t.namespaces&&(i=t.namespaces,o=t.enabled(e)),o),set:e=>{a=e;}}),"function"==typeof t.init&&t.init(s),s}function n(e,n){const r=t(this.namespace+(void 0===n?":":n)+e);return r.log=this.log,r}function r(e){return e.toString().substring(2,e.toString().length-2).replace(/\.\*\?$/,"*")}return t.debug=t,t.default=t,t.coerce=function(e){return e instanceof Error?e.stack||e.message:e},t.disable=function(){const e=[...t.names.map(r),...t.skips.map(r).map((e=>"-"+e))].join(",");return t.enable(""),e},t.enable=function(e){let n;t.save(e),t.namespaces=e,t.names=[],t.skips=[];const r=("string"==typeof e?e:"").split(/[\s,]+/),i=r.length;for(n=0;n<i;n++)r[n]&&("-"===(e=r[n].replace(/\*/g,".*?"))[0]?t.skips.push(new RegExp("^"+e.slice(1)+"$")):t.names.push(new RegExp("^"+e+"$")));},t.enabled=function(e){if("*"===e[e.length-1])return  true;let n,r;for(n=0,r=t.skips.length;n<r;n++)if(t.skips[n].test(e))return  false;for(n=0,r=t.names.length;n<r;n++)if(t.names[n].test(e))return  true;return  false},t.humanize=function(){if(RS)return AS;RS=1;var e=1e3,t=60*e,n=60*t,r=24*n;function i(e,t,n,r){var i=t>=1.5*n;return Math.round(e/n)+" "+r+(i?"s":"")}return AS=function(o,a){a=a||{};var s=typeof o;if("string"===s&&o.length>0)return function(i){if(!((i=String(i)).length>100)){var o=/^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(i);if(o){var a=parseFloat(o[1]);switch((o[2]||"ms").toLowerCase()){case "years":case "year":case "yrs":case "yr":case "y":return 315576e5*a;case "weeks":case "week":case "w":return 6048e5*a;case "days":case "day":case "d":return a*r;case "hours":case "hour":case "hrs":case "hr":case "h":return a*n;case "minutes":case "minute":case "mins":case "min":case "m":return a*t;case "seconds":case "second":case "secs":case "sec":case "s":return a*e;case "milliseconds":case "millisecond":case "msecs":case "msec":case "ms":return a;default:return}}}}(o);if("number"===s&&isFinite(o))return a.long?function(o){var a=Math.abs(o);return a>=r?i(o,a,r,"day"):a>=n?i(o,a,n,"hour"):a>=t?i(o,a,t,"minute"):a>=e?i(o,a,e,"second"):o+" ms"}(o):function(i){var o=Math.abs(i);return o>=r?Math.round(i/r)+"d":o>=n?Math.round(i/n)+"h":o>=t?Math.round(i/t)+"m":o>=e?Math.round(i/e)+"s":i+"ms"}(o);throw new Error("val is not a non-empty string or a valid number. val="+JSON.stringify(o))}}(),t.destroy=function(){console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");},Object.keys(e).forEach((n=>{t[n]=e[n];})),t.names=[],t.skips=[],t.formatters={},t.selectColor=function(e){let n=0;for(let t=0;t<e.length;t++)n=(n<<5)-n+e.charCodeAt(t),n|=0;return t.colors[Math.abs(n)%t.colors.length]},t.enable(t.load()),t};!function(e,t){t.formatArgs=function(t){if(t[0]=(this.useColors?"%c":"")+this.namespace+(this.useColors?" %c":" ")+t[0]+(this.useColors?"%c ":" ")+"+"+e.exports.humanize(this.diff),!this.useColors)return;const n="color: "+this.color;t.splice(1,0,n,"color: inherit");let r=0,i=0;t[0].replace(/%[a-zA-Z%]/g,(e=>{"%%"!==e&&(r++,"%c"===e&&(i=r));})),t.splice(i,0,n);},t.save=function(e){try{e?t.storage.setItem("debug",e):t.storage.removeItem("debug");}catch(e){}},t.load=function(){let e;try{e=t.storage.getItem("debug");}catch(e){}return !e&&void 0!==xS&&"env"in xS&&(e=xS.env.DEBUG),e},t.useColors=function(){return !("undefined"==typeof window||!window.process||"renderer"!==window.process.type&&!window.process.__nwjs)||("undefined"==typeof navigator||!navigator.userAgent||!navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/))&&("undefined"!=typeof document&&document.documentElement&&document.documentElement.style&&document.documentElement.style.WebkitAppearance||"undefined"!=typeof window&&window.console&&(window.console.firebug||window.console.exception&&window.console.table)||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)&&parseInt(RegExp.$1,10)>=31||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/))},t.storage=function(){try{return localStorage}catch(e){}}(),t.destroy=(()=>{let e=false;return ()=>{e||(e=true,console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));}})(),t.colors=["#0000CC","#0000FF","#0033CC","#0033FF","#0066CC","#0066FF","#0099CC","#0099FF","#00CC00","#00CC33","#00CC66","#00CC99","#00CCCC","#00CCFF","#3300CC","#3300FF","#3333CC","#3333FF","#3366CC","#3366FF","#3399CC","#3399FF","#33CC00","#33CC33","#33CC66","#33CC99","#33CCCC","#33CCFF","#6600CC","#6600FF","#6633CC","#6633FF","#66CC00","#66CC33","#9900CC","#9900FF","#9933CC","#9933FF","#99CC00","#99CC33","#CC0000","#CC0033","#CC0066","#CC0099","#CC00CC","#CC00FF","#CC3300","#CC3333","#CC3366","#CC3399","#CC33CC","#CC33FF","#CC6600","#CC6633","#CC9900","#CC9933","#CCCC00","#CCCC33","#FF0000","#FF0033","#FF0066","#FF0099","#FF00CC","#FF00FF","#FF3300","#FF3333","#FF3366","#FF3399","#FF33CC","#FF33FF","#FF6600","#FF6633","#FF9900","#FF9933","#FFCC00","#FFCC33"],t.log=console.debug||console.log||(()=>{}),e.exports=PS(t);const{formatters:n}=e.exports;n.j=function(e){try{return JSON.stringify(e)}catch(e){return "[UnexpectedJSONParseError]: "+e.message}};}(TS,TS.exports);var LS=function(e){return e&&e.__esModule&&Object.prototype.hasOwnProperty.call(e,"default")?e.default:e}(TS.exports);const IS=LS("KeyExchange:Layer"),OS=LS("SocketService:Layer"),NS=LS("Ecies:Layer"),DS=LS("RemoteCommunication:Layer");IS.color="##95c44e",OS.color="#f638d7",NS.color="#465b9c",DS.color="#47a2be";const jS={KeyExchange:IS,SocketService:OS,Ecies:NS,RemoteCommunication:DS};let BS,zS=[],US=[];function FS(e){return nS(this,void 0,void 0,(function*(){if(!BS||!e)return;!function(){const e=US;US=zS,zS=e;}();const t=BS.endsWith("/")?`${BS}evt`:`${BS}/evt`,n=Object.assign({},e);if(delete n.params,e.params)for(const[t,r]of Object.entries(e.params))n[t]=r;const r=JSON.stringify(n);jS.RemoteCommunication(`[sendBufferedEvents] Sending ${zS.length} analytics events to ${t}`);try{const e=yield a(t,{method:"POST",headers:{Accept:"application/json","Content-Type":"application/json"},body:r}),n=yield e.text();jS.RemoteCommunication(`[sendBufferedEvents] Response: ${n}`),zS.length=0;}catch(e){console.warn("Error sending analytics",e);}}))}const KS=(e,t)=>nS(void 0,void 0,void 0,(function*(){var n;BS=t,n=e,US.push(n),FS(e).catch((()=>{}));}));var qS=[],HS=[],WS="undefined"!=typeof Uint8Array?Uint8Array:Array,$S=false;function VS(){$S=true;for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t=0;t<64;++t)qS[t]=e[t],HS[e.charCodeAt(t)]=t;HS["-".charCodeAt(0)]=62,HS["_".charCodeAt(0)]=63;}function YS(e,t,n){for(var r,i,o=[],a=t;a<n;a+=3)r=(e[a]<<16)+(e[a+1]<<8)+e[a+2],o.push(qS[(i=r)>>18&63]+qS[i>>12&63]+qS[i>>6&63]+qS[63&i]);return o.join("")}function GS(e){var t;$S||VS();for(var n=e.length,r=n%3,i="",o=[],a=16383,s=0,u=n-r;s<u;s+=a)o.push(YS(e,s,s+a>u?u:s+a));return 1===r?(t=e[n-1],i+=qS[t>>2],i+=qS[t<<4&63],i+="=="):2===r&&(t=(e[n-2]<<8)+e[n-1],i+=qS[t>>10],i+=qS[t>>4&63],i+=qS[t<<2&63],i+="="),o.push(i),o.join("")}function ZS(e,t,n,r,i){var o,a,s=8*i-r-1,u=(1<<s)-1,l=u>>1,c=-7,d=n?i-1:0,f=n?-1:1,h=e[t+d];for(d+=f,o=h&(1<<-c)-1,h>>=-c,c+=s;c>0;o=256*o+e[t+d],d+=f,c-=8);for(a=o&(1<<-c)-1,o>>=-c,c+=r;c>0;a=256*a+e[t+d],d+=f,c-=8);if(0===o)o=1-l;else {if(o===u)return a?NaN:1/0*(h?-1:1);a+=Math.pow(2,r),o-=l;}return (h?-1:1)*a*Math.pow(2,o-r)}function QS(e,t,n,r,i,o){var a,s,u,l=8*o-i-1,c=(1<<l)-1,d=c>>1,f=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,h=r?0:o-1,p=r?1:-1,m=t<0||0===t&&1/t<0?1:0;for(t=Math.abs(t),isNaN(t)||t===1/0?(s=isNaN(t)?1:0,a=c):(a=Math.floor(Math.log(t)/Math.LN2),t*(u=Math.pow(2,-a))<1&&(a--,u*=2),(t+=a+d>=1?f/u:f*Math.pow(2,1-d))*u>=2&&(a++,u/=2),a+d>=c?(s=0,a=c):a+d>=1?(s=(t*u-1)*Math.pow(2,i),a+=d):(s=t*Math.pow(2,d-1)*Math.pow(2,i),a=0));i>=8;e[n+h]=255&s,h+=p,s/=256,i-=8);for(a=a<<i|s,l+=i;l>0;e[n+h]=255&a,h+=p,a/=256,l-=8);e[n+h-p]|=128*m;}var JS={}.toString,XS=Array.isArray||function(e){return "[object Array]"==JS.call(e)};function eE(){return nE.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function tE(e,t){if(eE()<t)throw new RangeError("Invalid typed array length");return nE.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(t)).__proto__=nE.prototype:(null===e&&(e=new nE(t)),e.length=t),e}function nE(e,t,n){if(!(nE.TYPED_ARRAY_SUPPORT||this instanceof nE))return new nE(e,t,n);if("number"==typeof e){if("string"==typeof t)throw new Error("If encoding is specified then the first argument must be a string");return oE(this,e)}return rE(this,e,t,n)}function rE(e,t,n,r){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return "undefined"!=typeof ArrayBuffer&&t instanceof ArrayBuffer?function(e,t,n,r){if(t.byteLength,n<0||t.byteLength<n)throw new RangeError("'offset' is out of bounds");if(t.byteLength<n+(r||0))throw new RangeError("'length' is out of bounds");return t=void 0===n&&void 0===r?new Uint8Array(t):void 0===r?new Uint8Array(t,n):new Uint8Array(t,n,r),nE.TYPED_ARRAY_SUPPORT?(e=t).__proto__=nE.prototype:e=aE(e,t),e}(e,t,n,r):"string"==typeof t?function(e,t,n){if("string"==typeof n&&""!==n||(n="utf8"),!nE.isEncoding(n))throw new TypeError('"encoding" must be a valid string encoding');var r=0|lE(t,n),i=(e=tE(e,r)).write(t,n);return i!==r&&(e=e.slice(0,i)),e}(e,t,n):function(e,t){if(uE(t)){var n=0|sE(t.length);return 0===(e=tE(e,n)).length||t.copy(e,0,0,n),e}if(t){if("undefined"!=typeof ArrayBuffer&&t.buffer instanceof ArrayBuffer||"length"in t)return "number"!=typeof t.length||(r=t.length)!=r?tE(e,0):aE(e,t);if("Buffer"===t.type&&XS(t.data))return aE(e,t.data)}var r;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(e,t)}function iE(e){if("number"!=typeof e)throw new TypeError('"size" argument must be a number');if(e<0)throw new RangeError('"size" argument must not be negative')}function oE(e,t){if(iE(t),e=tE(e,t<0?0:0|sE(t)),!nE.TYPED_ARRAY_SUPPORT)for(var n=0;n<t;++n)e[n]=0;return e}function aE(e,t){var n=t.length<0?0:0|sE(t.length);e=tE(e,n);for(var r=0;r<n;r+=1)e[r]=255&t[r];return e}function sE(e){if(e>=eE())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+eE().toString(16)+" bytes");return 0|e}function uE(e){return !(null==e||!e._isBuffer)}function lE(e,t){if(uE(e))return e.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(e)||e instanceof ArrayBuffer))return e.byteLength;"string"!=typeof e&&(e=""+e);var n=e.length;if(0===n)return 0;for(var r=false;;)switch(t){case "ascii":case "latin1":case "binary":return n;case "utf8":case "utf-8":case void 0:return DE(e).length;case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":return 2*n;case "hex":return n>>>1;case "base64":return jE(e).length;default:if(r)return DE(e).length;t=(""+t).toLowerCase(),r=true;}}function cE(e,t,n){var r=false;if((void 0===t||t<0)&&(t=0),t>this.length)return "";if((void 0===n||n>this.length)&&(n=this.length),n<=0)return "";if((n>>>=0)<=(t>>>=0))return "";for(e||(e="utf8");;)switch(e){case "hex":return ME(this,t,n);case "utf8":case "utf-8":return _E(this,t,n);case "ascii":return EE(this,t,n);case "latin1":case "binary":return kE(this,t,n);case "base64":return wE(this,t,n);case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":return CE(this,t,n);default:if(r)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase(),r=true;}}function dE(e,t,n){var r=e[t];e[t]=e[n],e[n]=r;}function fE(e,t,n,r,i){if(0===e.length)return  -1;if("string"==typeof n?(r=n,n=0):n>2147483647?n=2147483647:n<-2147483648&&(n=-2147483648),n=+n,isNaN(n)&&(n=i?0:e.length-1),n<0&&(n=e.length+n),n>=e.length){if(i)return  -1;n=e.length-1;}else if(n<0){if(!i)return  -1;n=0;}if("string"==typeof t&&(t=nE.from(t,r)),uE(t))return 0===t.length?-1:hE(e,t,n,r,i);if("number"==typeof t)return t&=255,nE.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(e,t,n):Uint8Array.prototype.lastIndexOf.call(e,t,n):hE(e,[t],n,r,i);throw new TypeError("val must be string, number or Buffer")}function hE(e,t,n,r,i){var o,a=1,s=e.length,u=t.length;if(void 0!==r&&("ucs2"===(r=String(r).toLowerCase())||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(e.length<2||t.length<2)return  -1;a=2,s/=2,u/=2,n/=2;}function l(e,t){return 1===a?e[t]:e.readUInt16BE(t*a)}if(i){var c=-1;for(o=n;o<s;o++)if(l(e,o)===l(t,-1===c?0:o-c)){if(-1===c&&(c=o),o-c+1===u)return c*a}else  -1!==c&&(o-=o-c),c=-1;}else for(n+u>s&&(n=s-u),o=n;o>=0;o--){for(var d=true,f=0;f<u;f++)if(l(e,o+f)!==l(t,f)){d=false;break}if(d)return o}return  -1}function pE(e,t,n,r){n=Number(n)||0;var i=e.length-n;r?(r=Number(r))>i&&(r=i):r=i;var o=t.length;if(o%2!=0)throw new TypeError("Invalid hex string");r>o/2&&(r=o/2);for(var a=0;a<r;++a){var s=parseInt(t.substr(2*a,2),16);if(isNaN(s))return a;e[n+a]=s;}return a}function mE(e,t,n,r){return BE(DE(t,e.length-n),e,n,r)}function gE(e,t,n,r){return BE(function(e){for(var t=[],n=0;n<e.length;++n)t.push(255&e.charCodeAt(n));return t}(t),e,n,r)}function vE(e,t,n,r){return gE(e,t,n,r)}function bE(e,t,n,r){return BE(jE(t),e,n,r)}function yE(e,t,n,r){return BE(function(e,t){for(var n,r,i,o=[],a=0;a<e.length&&!((t-=2)<0);++a)r=(n=e.charCodeAt(a))>>8,i=n%256,o.push(i),o.push(r);return o}(t,e.length-n),e,n,r)}function wE(e,t,n){return 0===t&&n===e.length?GS(e):GS(e.slice(t,n))}function _E(e,t,n){n=Math.min(e.length,n);for(var r=[],i=t;i<n;){var o,a,s,u,l=e[i],c=null,d=l>239?4:l>223?3:l>191?2:1;if(i+d<=n)switch(d){case 1:l<128&&(c=l);break;case 2:128==(192&(o=e[i+1]))&&(u=(31&l)<<6|63&o)>127&&(c=u);break;case 3:o=e[i+1],a=e[i+2],128==(192&o)&&128==(192&a)&&(u=(15&l)<<12|(63&o)<<6|63&a)>2047&&(u<55296||u>57343)&&(c=u);break;case 4:o=e[i+1],a=e[i+2],s=e[i+3],128==(192&o)&&128==(192&a)&&128==(192&s)&&(u=(15&l)<<18|(63&o)<<12|(63&a)<<6|63&s)>65535&&u<1114112&&(c=u);}null===c?(c=65533,d=1):c>65535&&(c-=65536,r.push(c>>>10&1023|55296),c=56320|1023&c),r.push(c),i+=d;}return function(e){var t=e.length;if(t<=SE)return String.fromCharCode.apply(String,e);for(var n="",r=0;r<t;)n+=String.fromCharCode.apply(String,e.slice(r,r+=SE));return n}(r)}nE.TYPED_ARRAY_SUPPORT=void 0===rS.TYPED_ARRAY_SUPPORT||rS.TYPED_ARRAY_SUPPORT,eE(),nE.poolSize=8192,nE._augment=function(e){return e.__proto__=nE.prototype,e},nE.from=function(e,t,n){return rE(null,e,t,n)},nE.TYPED_ARRAY_SUPPORT&&(nE.prototype.__proto__=Uint8Array.prototype,nE.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&nE[Symbol.species]),nE.alloc=function(e,t,n){return function(e,t,n,r){return iE(t),t<=0?tE(e,t):void 0!==n?"string"==typeof r?tE(e,t).fill(n,r):tE(e,t).fill(n):tE(e,t)}(null,e,t,n)},nE.allocUnsafe=function(e){return oE(null,e)},nE.allocUnsafeSlow=function(e){return oE(null,e)},nE.isBuffer=function(e){return null!=e&&(!!e._isBuffer||zE(e)||function(e){return "function"==typeof e.readFloatLE&&"function"==typeof e.slice&&zE(e.slice(0,0))}(e))},nE.compare=function(e,t){if(!uE(e)||!uE(t))throw new TypeError("Arguments must be Buffers");if(e===t)return 0;for(var n=e.length,r=t.length,i=0,o=Math.min(n,r);i<o;++i)if(e[i]!==t[i]){n=e[i],r=t[i];break}return n<r?-1:r<n?1:0},nE.isEncoding=function(e){switch(String(e).toLowerCase()){case "hex":case "utf8":case "utf-8":case "ascii":case "latin1":case "binary":case "base64":case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":return  true;default:return  false}},nE.concat=function(e,t){if(!XS(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return nE.alloc(0);var n;if(void 0===t)for(t=0,n=0;n<e.length;++n)t+=e[n].length;var r=nE.allocUnsafe(t),i=0;for(n=0;n<e.length;++n){var o=e[n];if(!uE(o))throw new TypeError('"list" argument must be an Array of Buffers');o.copy(r,i),i+=o.length;}return r},nE.byteLength=lE,nE.prototype._isBuffer=true,nE.prototype.swap16=function(){var e=this.length;if(e%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var t=0;t<e;t+=2)dE(this,t,t+1);return this},nE.prototype.swap32=function(){var e=this.length;if(e%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var t=0;t<e;t+=4)dE(this,t,t+3),dE(this,t+1,t+2);return this},nE.prototype.swap64=function(){var e=this.length;if(e%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var t=0;t<e;t+=8)dE(this,t,t+7),dE(this,t+1,t+6),dE(this,t+2,t+5),dE(this,t+3,t+4);return this},nE.prototype.toString=function(){var e=0|this.length;return 0===e?"":0===arguments.length?_E(this,0,e):cE.apply(this,arguments)},nE.prototype.equals=function(e){if(!uE(e))throw new TypeError("Argument must be a Buffer");return this===e||0===nE.compare(this,e)},nE.prototype.inspect=function(){var e="";return this.length>0&&(e=this.toString("hex",0,50).match(/.{2}/g).join(" "),this.length>50&&(e+=" ... ")),"<Buffer "+e+">"},nE.prototype.compare=function(e,t,n,r,i){if(!uE(e))throw new TypeError("Argument must be a Buffer");if(void 0===t&&(t=0),void 0===n&&(n=e?e.length:0),void 0===r&&(r=0),void 0===i&&(i=this.length),t<0||n>e.length||r<0||i>this.length)throw new RangeError("out of range index");if(r>=i&&t>=n)return 0;if(r>=i)return  -1;if(t>=n)return 1;if(this===e)return 0;for(var o=(i>>>=0)-(r>>>=0),a=(n>>>=0)-(t>>>=0),s=Math.min(o,a),u=this.slice(r,i),l=e.slice(t,n),c=0;c<s;++c)if(u[c]!==l[c]){o=u[c],a=l[c];break}return o<a?-1:a<o?1:0},nE.prototype.includes=function(e,t,n){return  -1!==this.indexOf(e,t,n)},nE.prototype.indexOf=function(e,t,n){return fE(this,e,t,n,true)},nE.prototype.lastIndexOf=function(e,t,n){return fE(this,e,t,n,false)},nE.prototype.write=function(e,t,n,r){if(void 0===t)r="utf8",n=this.length,t=0;else if(void 0===n&&"string"==typeof t)r=t,n=this.length,t=0;else {if(!isFinite(t))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t|=0,isFinite(n)?(n|=0,void 0===r&&(r="utf8")):(r=n,n=void 0);}var i=this.length-t;if((void 0===n||n>i)&&(n=i),e.length>0&&(n<0||t<0)||t>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var o=false;;)switch(r){case "hex":return pE(this,e,t,n);case "utf8":case "utf-8":return mE(this,e,t,n);case "ascii":return gE(this,e,t,n);case "latin1":case "binary":return vE(this,e,t,n);case "base64":return bE(this,e,t,n);case "ucs2":case "ucs-2":case "utf16le":case "utf-16le":return yE(this,e,t,n);default:if(o)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),o=true;}},nE.prototype.toJSON=function(){return {type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var SE=4096;function EE(e,t,n){var r="";n=Math.min(e.length,n);for(var i=t;i<n;++i)r+=String.fromCharCode(127&e[i]);return r}function kE(e,t,n){var r="";n=Math.min(e.length,n);for(var i=t;i<n;++i)r+=String.fromCharCode(e[i]);return r}function ME(e,t,n){var r=e.length;(!t||t<0)&&(t=0),(!n||n<0||n>r)&&(n=r);for(var i="",o=t;o<n;++o)i+=NE(e[o]);return i}function CE(e,t,n){for(var r=e.slice(t,n),i="",o=0;o<r.length;o+=2)i+=String.fromCharCode(r[o]+256*r[o+1]);return i}function xE(e,t,n){if(e%1!=0||e<0)throw new RangeError("offset is not uint");if(e+t>n)throw new RangeError("Trying to access beyond buffer length")}function AE(e,t,n,r,i,o){if(!uE(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(t>i||t<o)throw new RangeError('"value" argument is out of bounds');if(n+r>e.length)throw new RangeError("Index out of range")}function RE(e,t,n,r){t<0&&(t=65535+t+1);for(var i=0,o=Math.min(e.length-n,2);i<o;++i)e[n+i]=(t&255<<8*(r?i:1-i))>>>8*(r?i:1-i);}function TE(e,t,n,r){t<0&&(t=4294967295+t+1);for(var i=0,o=Math.min(e.length-n,4);i<o;++i)e[n+i]=t>>>8*(r?i:3-i)&255;}function PE(e,t,n,r,i,o){if(n+r>e.length)throw new RangeError("Index out of range");if(n<0)throw new RangeError("Index out of range")}function LE(e,t,n,r,i){return i||PE(e,0,n,4),QS(e,t,n,r,23,4),n+4}function IE(e,t,n,r,i){return i||PE(e,0,n,8),QS(e,t,n,r,52,8),n+8}nE.prototype.slice=function(e,t){var n,r=this.length;if((e=~~e)<0?(e+=r)<0&&(e=0):e>r&&(e=r),(t=void 0===t?r:~~t)<0?(t+=r)<0&&(t=0):t>r&&(t=r),t<e&&(t=e),nE.TYPED_ARRAY_SUPPORT)(n=this.subarray(e,t)).__proto__=nE.prototype;else {var i=t-e;n=new nE(i,void 0);for(var o=0;o<i;++o)n[o]=this[o+e];}return n},nE.prototype.readUIntLE=function(e,t,n){e|=0,t|=0,n||xE(e,t,this.length);for(var r=this[e],i=1,o=0;++o<t&&(i*=256);)r+=this[e+o]*i;return r},nE.prototype.readUIntBE=function(e,t,n){e|=0,t|=0,n||xE(e,t,this.length);for(var r=this[e+--t],i=1;t>0&&(i*=256);)r+=this[e+--t]*i;return r},nE.prototype.readUInt8=function(e,t){return t||xE(e,1,this.length),this[e]},nE.prototype.readUInt16LE=function(e,t){return t||xE(e,2,this.length),this[e]|this[e+1]<<8},nE.prototype.readUInt16BE=function(e,t){return t||xE(e,2,this.length),this[e]<<8|this[e+1]},nE.prototype.readUInt32LE=function(e,t){return t||xE(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},nE.prototype.readUInt32BE=function(e,t){return t||xE(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},nE.prototype.readIntLE=function(e,t,n){e|=0,t|=0,n||xE(e,t,this.length);for(var r=this[e],i=1,o=0;++o<t&&(i*=256);)r+=this[e+o]*i;return r>=(i*=128)&&(r-=Math.pow(2,8*t)),r},nE.prototype.readIntBE=function(e,t,n){e|=0,t|=0,n||xE(e,t,this.length);for(var r=t,i=1,o=this[e+--r];r>0&&(i*=256);)o+=this[e+--r]*i;return o>=(i*=128)&&(o-=Math.pow(2,8*t)),o},nE.prototype.readInt8=function(e,t){return t||xE(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},nE.prototype.readInt16LE=function(e,t){t||xE(e,2,this.length);var n=this[e]|this[e+1]<<8;return 32768&n?4294901760|n:n},nE.prototype.readInt16BE=function(e,t){t||xE(e,2,this.length);var n=this[e+1]|this[e]<<8;return 32768&n?4294901760|n:n},nE.prototype.readInt32LE=function(e,t){return t||xE(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},nE.prototype.readInt32BE=function(e,t){return t||xE(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},nE.prototype.readFloatLE=function(e,t){return t||xE(e,4,this.length),ZS(this,e,true,23,4)},nE.prototype.readFloatBE=function(e,t){return t||xE(e,4,this.length),ZS(this,e,false,23,4)},nE.prototype.readDoubleLE=function(e,t){return t||xE(e,8,this.length),ZS(this,e,true,52,8)},nE.prototype.readDoubleBE=function(e,t){return t||xE(e,8,this.length),ZS(this,e,false,52,8)},nE.prototype.writeUIntLE=function(e,t,n,r){e=+e,t|=0,n|=0,r||AE(this,e,t,n,Math.pow(2,8*n)-1,0);var i=1,o=0;for(this[t]=255&e;++o<n&&(i*=256);)this[t+o]=e/i&255;return t+n},nE.prototype.writeUIntBE=function(e,t,n,r){e=+e,t|=0,n|=0,r||AE(this,e,t,n,Math.pow(2,8*n)-1,0);var i=n-1,o=1;for(this[t+i]=255&e;--i>=0&&(o*=256);)this[t+i]=e/o&255;return t+n},nE.prototype.writeUInt8=function(e,t,n){return e=+e,t|=0,n||AE(this,e,t,1,255,0),nE.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[t]=255&e,t+1},nE.prototype.writeUInt16LE=function(e,t,n){return e=+e,t|=0,n||AE(this,e,t,2,65535,0),nE.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):RE(this,e,t,true),t+2},nE.prototype.writeUInt16BE=function(e,t,n){return e=+e,t|=0,n||AE(this,e,t,2,65535,0),nE.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):RE(this,e,t,false),t+2},nE.prototype.writeUInt32LE=function(e,t,n){return e=+e,t|=0,n||AE(this,e,t,4,4294967295,0),nE.TYPED_ARRAY_SUPPORT?(this[t+3]=e>>>24,this[t+2]=e>>>16,this[t+1]=e>>>8,this[t]=255&e):TE(this,e,t,true),t+4},nE.prototype.writeUInt32BE=function(e,t,n){return e=+e,t|=0,n||AE(this,e,t,4,4294967295,0),nE.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):TE(this,e,t,false),t+4},nE.prototype.writeIntLE=function(e,t,n,r){if(e=+e,t|=0,!r){var i=Math.pow(2,8*n-1);AE(this,e,t,n,i-1,-i);}var o=0,a=1,s=0;for(this[t]=255&e;++o<n&&(a*=256);)e<0&&0===s&&0!==this[t+o-1]&&(s=1),this[t+o]=(e/a>>0)-s&255;return t+n},nE.prototype.writeIntBE=function(e,t,n,r){if(e=+e,t|=0,!r){var i=Math.pow(2,8*n-1);AE(this,e,t,n,i-1,-i);}var o=n-1,a=1,s=0;for(this[t+o]=255&e;--o>=0&&(a*=256);)e<0&&0===s&&0!==this[t+o+1]&&(s=1),this[t+o]=(e/a>>0)-s&255;return t+n},nE.prototype.writeInt8=function(e,t,n){return e=+e,t|=0,n||AE(this,e,t,1,127,-128),nE.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),e<0&&(e=255+e+1),this[t]=255&e,t+1},nE.prototype.writeInt16LE=function(e,t,n){return e=+e,t|=0,n||AE(this,e,t,2,32767,-32768),nE.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):RE(this,e,t,true),t+2},nE.prototype.writeInt16BE=function(e,t,n){return e=+e,t|=0,n||AE(this,e,t,2,32767,-32768),nE.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):RE(this,e,t,false),t+2},nE.prototype.writeInt32LE=function(e,t,n){return e=+e,t|=0,n||AE(this,e,t,4,2147483647,-2147483648),nE.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8,this[t+2]=e>>>16,this[t+3]=e>>>24):TE(this,e,t,true),t+4},nE.prototype.writeInt32BE=function(e,t,n){return e=+e,t|=0,n||AE(this,e,t,4,2147483647,-2147483648),e<0&&(e=4294967295+e+1),nE.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):TE(this,e,t,false),t+4},nE.prototype.writeFloatLE=function(e,t,n){return LE(this,e,t,true,n)},nE.prototype.writeFloatBE=function(e,t,n){return LE(this,e,t,false,n)},nE.prototype.writeDoubleLE=function(e,t,n){return IE(this,e,t,true,n)},nE.prototype.writeDoubleBE=function(e,t,n){return IE(this,e,t,false,n)},nE.prototype.copy=function(e,t,n,r){if(n||(n=0),r||0===r||(r=this.length),t>=e.length&&(t=e.length),t||(t=0),r>0&&r<n&&(r=n),r===n)return 0;if(0===e.length||0===this.length)return 0;if(t<0)throw new RangeError("targetStart out of bounds");if(n<0||n>=this.length)throw new RangeError("sourceStart out of bounds");if(r<0)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),e.length-t<r-n&&(r=e.length-t+n);var i,o=r-n;if(this===e&&n<t&&t<r)for(i=o-1;i>=0;--i)e[i+t]=this[i+n];else if(o<1e3||!nE.TYPED_ARRAY_SUPPORT)for(i=0;i<o;++i)e[i+t]=this[i+n];else Uint8Array.prototype.set.call(e,this.subarray(n,n+o),t);return o},nE.prototype.fill=function(e,t,n,r){if("string"==typeof e){if("string"==typeof t?(r=t,t=0,n=this.length):"string"==typeof n&&(r=n,n=this.length),1===e.length){var i=e.charCodeAt(0);i<256&&(e=i);}if(void 0!==r&&"string"!=typeof r)throw new TypeError("encoding must be a string");if("string"==typeof r&&!nE.isEncoding(r))throw new TypeError("Unknown encoding: "+r)}else "number"==typeof e&&(e&=255);if(t<0||this.length<t||this.length<n)throw new RangeError("Out of range index");if(n<=t)return this;var o;if(t>>>=0,n=void 0===n?this.length:n>>>0,e||(e=0),"number"==typeof e)for(o=t;o<n;++o)this[o]=e;else {var a=uE(e)?e:DE(new nE(e,r).toString()),s=a.length;for(o=0;o<n-t;++o)this[o+t]=a[o%s];}return this};var OE=/[^+\/0-9A-Za-z-_]/g;function NE(e){return e<16?"0"+e.toString(16):e.toString(16)}function DE(e,t){var n;t=t||1/0;for(var r=e.length,i=null,o=[],a=0;a<r;++a){if((n=e.charCodeAt(a))>55295&&n<57344){if(!i){if(n>56319){(t-=3)>-1&&o.push(239,191,189);continue}if(a+1===r){(t-=3)>-1&&o.push(239,191,189);continue}i=n;continue}if(n<56320){(t-=3)>-1&&o.push(239,191,189),i=n;continue}n=65536+(i-55296<<10|n-56320);}else i&&(t-=3)>-1&&o.push(239,191,189);if(i=null,n<128){if((t-=1)<0)break;o.push(n);}else if(n<2048){if((t-=2)<0)break;o.push(n>>6|192,63&n|128);}else if(n<65536){if((t-=3)<0)break;o.push(n>>12|224,n>>6&63|128,63&n|128);}else {if(!(n<1114112))throw new Error("Invalid code point");if((t-=4)<0)break;o.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128);}}return o}function jE(e){return function(e){var t,n,r,i,o,a;$S||VS();var s=e.length;if(s%4>0)throw new Error("Invalid string. Length must be a multiple of 4");o="="===e[s-2]?2:"="===e[s-1]?1:0,a=new WS(3*s/4-o),r=o>0?s-4:s;var u=0;for(t=0,n=0;t<r;t+=4,n+=3)i=HS[e.charCodeAt(t)]<<18|HS[e.charCodeAt(t+1)]<<12|HS[e.charCodeAt(t+2)]<<6|HS[e.charCodeAt(t+3)],a[u++]=i>>16&255,a[u++]=i>>8&255,a[u++]=255&i;return 2===o?(i=HS[e.charCodeAt(t)]<<2|HS[e.charCodeAt(t+1)]>>4,a[u++]=255&i):1===o&&(i=HS[e.charCodeAt(t)]<<10|HS[e.charCodeAt(t+1)]<<4|HS[e.charCodeAt(t+2)]>>2,a[u++]=i>>8&255,a[u++]=255&i),a}(function(e){if((e=function(e){return e.trim?e.trim():e.replace(/^\s+|\s+$/g,"")}(e).replace(OE,"")).length<2)return "";for(;e.length%4!=0;)e+="=";return e}(e))}function BE(e,t,n,r){for(var i=0;i<r&&!(i+n>=t.length||i>=e.length);++i)t[i+n]=e[i];return i}function zE(e){return !!e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)}class UE{constructor(e){this.enabled=true,(null==e?void 0:e.debug)&&LS.enable("Ecies:Layer"),(null==e?void 0:e.privateKey)?this.ecies=se.PrivateKey.fromHex(e.privateKey):this.ecies=new se.PrivateKey,jS.Ecies("[ECIES constructor()] initialized secret: ",this.ecies.toHex()),jS.Ecies("[ECIES constructor()] initialized public: ",this.ecies.publicKey.toHex()),jS.Ecies("[ECIES constructor()] init with",this);}generateECIES(){this.ecies=new se.PrivateKey;}getPublicKey(){return this.ecies.publicKey.toHex()}encrypt(e,t){let n=e;if(this.enabled)try{jS.Ecies("[ECIES: encrypt()] using otherPublicKey",t);const r=nE.from(e),i=se.encrypt(t,r);n=nE.from(i).toString("base64");}catch(n){throw jS.Ecies("[ECIES: encrypt()] error encrypt:",n),jS.Ecies("[ECIES: encrypt()] private: ",this.ecies.toHex()),jS.Ecies("[ECIES: encrypt()] data: ",e),jS.Ecies("[ECIES: encrypt()] otherkey: ",t),n}return n}decrypt(e){let t=e;if(this.enabled)try{jS.Ecies("[ECIES: decrypt()] using privateKey",this.ecies.toHex());const n=nE.from(e.toString(),"base64");t=se.decrypt(this.ecies.toHex(),n).toString();}catch(t){throw jS.Ecies("[ECIES: decrypt()] error decrypt",t),jS.Ecies("[ECIES: decrypt()] private: ",this.ecies.toHex()),jS.Ecies("[ECIES: decrypt()] encryptedData: ",e),t}return t}getKeyInfo(){return {private:this.ecies.toHex(),public:this.ecies.publicKey.toHex()}}toString(){jS.Ecies("[ECIES: toString()]",this.getKeyInfo());}}var FE={version:"0.30.0"};const KE="https://metamask-sdk.api.cx.metamask.io/",qE=["websocket"],HE=6048e5,WE=3e3,$E={ETH_REQUESTACCOUNTS:"eth_requestAccounts"};function VE(e){const{context:t}=e;jS.RemoteCommunication(`[RemoteCommunication: clean()] context=${t}`),e.channelConfig=void 0,e.ready=false,e.originatorConnectStarted=false;}var YE,GE,ZE;e.ConnectionStatus=void 0,e.EventType=void 0,e.MessageType=void 0,function(e){e.DISCONNECTED="disconnected",e.WAITING="waiting",e.TIMEOUT="timeout",e.LINKED="linked",e.PAUSED="paused",e.TERMINATED="terminated";}(e.ConnectionStatus||(e.ConnectionStatus={})),function(e){e.KEY_INFO="key_info",e.SERVICE_STATUS="service_status",e.PROVIDER_UPDATE="provider_update",e.RPC_UPDATE="rpc_update",e.KEYS_EXCHANGED="keys_exchanged",e.JOIN_CHANNEL="join_channel",e.PUBLIC_KEY="public_key",e.CHANNEL_CREATED="channel_created",e.CLIENTS_CONNECTED="clients_connected",e.CLIENTS_DISCONNECTED="clients_disconnected",e.CLIENTS_WAITING="clients_waiting",e.CLIENTS_READY="clients_ready",e.REJECTED="rejected",e.WALLET_INIT="wallet_init",e.CHANNEL_PERSISTENCE="channel_persistence",e.CONFIG="config",e.MESSAGE_ACK="ack",e.SOCKET_DISCONNECTED="socket_disconnected",e.SOCKET_RECONNECT="socket_reconnect",e.OTP="otp",e.SDK_RPC_CALL="sdk_rpc_call",e.AUTHORIZED="authorized",e.CONNECTION_STATUS="connection_status",e.MESSAGE="message",e.TERMINATE="terminate";}(e.EventType||(e.EventType={})),function(e){e.KEY_EXCHANGE="key_exchange";}(YE||(YE={})),function(e){e.KEY_HANDSHAKE_START="key_handshake_start",e.KEY_HANDSHAKE_CHECK="key_handshake_check",e.KEY_HANDSHAKE_SYN="key_handshake_SYN",e.KEY_HANDSHAKE_SYNACK="key_handshake_SYNACK",e.KEY_HANDSHAKE_ACK="key_handshake_ACK",e.KEY_HANDSHAKE_WALLET="key_handshake_wallet",e.KEY_HANDSHAKE_NONE="none";}(GE||(GE={}));class QE extends xw.EventEmitter2{constructor({communicationLayer:e,otherPublicKey:t,context:n,ecies:r,logging:i}){super(),this.keysExchanged=false,this.step=GE.KEY_HANDSHAKE_NONE,this.debug=false,this.context=n,this.communicationLayer=e,(null==r?void 0:r.privateKey)&&t&&(jS.KeyExchange(`[KeyExchange: constructor()] otherPubKey=${t} set keysExchanged to true!`,r),this.keysExchanged=true),this.myECIES=new UE(Object.assign(Object.assign({},r),{debug:null==i?void 0:i.eciesLayer})),this.communicationLayer.state.eciesInstance=this.myECIES,this.myPublicKey=this.myECIES.getPublicKey(),this.debug=true===(null==i?void 0:i.keyExchangeLayer),t&&this.setOtherPublicKey(t),this.communicationLayer.on(YE.KEY_EXCHANGE,this.onKeyExchangeMessage.bind(this));}onKeyExchangeMessage(t){const{relayPersistence:n}=this.communicationLayer.remote.state;if(jS.KeyExchange(`[KeyExchange: onKeyExchangeMessage()] context=${this.context} keysExchanged=${this.keysExchanged} relayPersistence=${n}`,t),n)return void jS.KeyExchange("[KeyExchange: onKeyExchangeMessage()] Ignoring key exchange message because relay persistence is activated");const{message:r}=t;this.keysExchanged&&jS.KeyExchange(`[KeyExchange: onKeyExchangeMessage()] context=${this.context} received handshake while already exchanged. step=${this.step} otherPubKey=${this.otherPublicKey}`),this.emit(e.EventType.KEY_INFO,r.type),r.type===GE.KEY_HANDSHAKE_SYN?(this.checkStep([GE.KEY_HANDSHAKE_NONE,GE.KEY_HANDSHAKE_ACK]),jS.KeyExchange("[KeyExchange: onKeyExchangeMessage()] KEY_HANDSHAKE_SYN",r),r.pubkey&&this.setOtherPublicKey(r.pubkey),this.communicationLayer.sendMessage({type:GE.KEY_HANDSHAKE_SYNACK,pubkey:this.myPublicKey}).catch((e=>{jS.KeyExchange("[KeyExchange: onKeyExchangeMessage()] Error sending KEY_HANDSHAKE_SYNACK",e);})),this.setStep(GE.KEY_HANDSHAKE_ACK)):r.type===GE.KEY_HANDSHAKE_SYNACK?(this.checkStep([GE.KEY_HANDSHAKE_SYNACK,GE.KEY_HANDSHAKE_ACK,GE.KEY_HANDSHAKE_NONE]),jS.KeyExchange("[KeyExchange: onKeyExchangeMessage()] KEY_HANDSHAKE_SYNACK"),r.pubkey&&this.setOtherPublicKey(r.pubkey),this.communicationLayer.sendMessage({type:GE.KEY_HANDSHAKE_ACK}).catch((e=>{jS.KeyExchange("[KeyExchange: onKeyExchangeMessage()] Error sending KEY_HANDSHAKE_ACK",e);})),this.keysExchanged=true,this.setStep(GE.KEY_HANDSHAKE_ACK),this.emit(e.EventType.KEYS_EXCHANGED)):r.type===GE.KEY_HANDSHAKE_ACK&&(jS.KeyExchange("[KeyExchange: onKeyExchangeMessage()] KEY_HANDSHAKE_ACK set keysExchanged to true!"),this.checkStep([GE.KEY_HANDSHAKE_ACK,GE.KEY_HANDSHAKE_NONE]),this.keysExchanged=true,this.setStep(GE.KEY_HANDSHAKE_ACK),this.emit(e.EventType.KEYS_EXCHANGED));}resetKeys(e){this.clean(),this.myECIES=new UE(e);}clean(){jS.KeyExchange(`[KeyExchange: clean()] context=${this.context} reset handshake state`),this.setStep(GE.KEY_HANDSHAKE_NONE),this.emit(e.EventType.KEY_INFO,this.step),this.keysExchanged=false;}start({isOriginator:e,force:t}){const{relayPersistence:n,protocolVersion:r}=this.communicationLayer.remote.state,i=r>=2;if(n)return jS.KeyExchange("[KeyExchange: start()] Ignoring key exchange message because relay persistence is activated"),void console.log(`[KeyExchange: start()] relayPersistence=${n}`);jS.KeyExchange(`[KeyExchange: start()] context=${this.context} protocolVersion=${r} isOriginator=${e} step=${this.step} force=${t} relayPersistence=${n} keysExchanged=${this.keysExchanged}`),e?!(this.keysExchanged||this.step!==GE.KEY_HANDSHAKE_NONE&&this.step!==GE.KEY_HANDSHAKE_SYNACK)||t?(jS.KeyExchange(`[KeyExchange: start()] context=${this.context} -- start key exchange (force=${t}) -- step=${this.step}`,this.step),this.clean(),this.setStep(GE.KEY_HANDSHAKE_SYNACK),this.communicationLayer.sendMessage({type:GE.KEY_HANDSHAKE_SYN,pubkey:this.myPublicKey,v:2}).catch((e=>{jS.KeyExchange("[KeyExchange: start()] Error sending KEY_HANDSHAKE_SYN",e);}))):jS.KeyExchange(`[KeyExchange: start()] context=${this.context} -- key exchange already ${this.keysExchanged?"done":"in progress"} -- aborted.`,this.step):this.keysExchanged&&true!==t?jS.KeyExchange("[KeyExchange: start()] don't send KEY_HANDSHAKE_START -- exchange already done."):i?this.communicationLayer.sendMessage({type:GE.KEY_HANDSHAKE_SYNACK,pubkey:this.myPublicKey,v:2}).catch((e=>{jS.KeyExchange("[KeyExchange: start()] Error sending KEY_HANDSHAKE_SYNACK",e);})):(this.communicationLayer.sendMessage({type:GE.KEY_HANDSHAKE_START}).catch((e=>{jS.KeyExchange("[KeyExchange: start()] Error sending KEY_HANDSHAKE_START",e);})),this.clean());}setStep(t){this.step=t,this.emit(e.EventType.KEY_INFO,t);}checkStep(e){e.length>0&&-1===e.indexOf(this.step.toString())&&console.warn(`[KeyExchange: checkStep()]  Wrong Step "${this.step}" not within ${e}`);}setRelayPersistence({localKey:e,otherKey:t}){this.otherPublicKey=t,this.myECIES=new UE({privateKey:e,debug:this.debug}),this.keysExchanged=true;}setKeysExchanged(e){this.keysExchanged=e;}areKeysExchanged(){return this.keysExchanged}getMyPublicKey(){return this.myPublicKey}getOtherPublicKey(){return this.otherPublicKey}setOtherPublicKey(e){jS.KeyExchange("[KeyExchange: setOtherPubKey()]",e),this.otherPublicKey=e;}encryptMessage(e){if(!this.otherPublicKey)throw new Error("encryptMessage: Keys not exchanged - missing otherPubKey");return this.myECIES.encrypt(e,this.otherPublicKey)}decryptMessage(e){if(!this.otherPublicKey)throw new Error("decryptMessage: Keys not exchanged - missing otherPubKey");return this.myECIES.decrypt(e)}getKeyInfo(){return {ecies:Object.assign(Object.assign({},this.myECIES.getKeyInfo()),{otherPubKey:this.otherPublicKey}),step:this.step,keysExchanged:this.areKeysExchanged()}}toString(){const e={keyInfo:this.getKeyInfo(),keysExchanged:this.keysExchanged,step:this.step};return JSON.stringify(e)}}!function(e){e.TERMINATE="terminate",e.ANSWER="answer",e.OFFER="offer",e.CANDIDATE="candidate",e.JSONRPC="jsonrpc",e.WALLET_INFO="wallet_info",e.WALLET_INIT="wallet_init",e.ORIGINATOR_INFO="originator_info",e.PAUSE="pause",e.OTP="otp",e.AUTHORIZED="authorized",e.PING="ping",e.READY="ready";}(e.MessageType||(e.MessageType={})),function(e){e.REQUEST="sdk_connect_request_started",e.REQUEST_MOBILE="sdk_connect_request_started_mobile",e.RECONNECT="sdk_reconnect_request_started",e.CONNECTED="sdk_connection_established",e.CONNECTED_MOBILE="sdk_connection_established_mobile",e.AUTHORIZED="sdk_connection_authorized",e.REJECTED="sdk_connection_rejected",e.TERMINATED="sdk_connection_terminated",e.DISCONNECTED="sdk_disconnected",e.SDK_USE_EXTENSION="sdk_use_extension",e.SDK_RPC_REQUEST="sdk_rpc_request",e.SDK_RPC_REQUEST_RECEIVED="sdk_rpc_request_received",e.SDK_RPC_REQUEST_DONE="sdk_rpc_request_done",e.SDK_EXTENSION_UTILIZED="sdk_extension_utilized",e.SDK_USE_INAPP_BROWSER="sdk_use_inapp_browser";}(ZE||(ZE={}));const JE=(t,n,r)=>nS(void 0,void 0,void 0,(function*(){var i,o,a,s,u,l;const{remote:c,state:d}=t,{channelId:f,isOriginator:h}=d;if("error_terminated"===n)return jS.SocketService(`handleJoinChannelResults: Channel ${f} terminated`),void t.emit(e.EventType.TERMINATE);if(!r)return void jS.SocketService(`handleJoinChannelResults: No result for channel ${f}`);const{persistence:p,walletKey:m,rejected:g}=r;if(jS.SocketService(`handleJoinChannelResults: Channel ${f} persistence=${p} walletKey=${m} rejected=${g}`),g)return jS.SocketService(`handleJoinChannelResults: Channel ${f} rejected`),yield t.remote.disconnect({terminate:true}),t.remote.emit(e.EventType.REJECTED,{channelId:f}),void t.remote.emitServiceStatusEvent();if(m&&!(null===(i=c.state.channelConfig)||void 0===i?void 0:i.otherKey)){t.getKeyExchange().setOtherPublicKey(m),null===(o=t.state.keyExchange)||void 0===o||o.setKeysExchanged(true),c.state.ready=true,c.state.authorized=true,c.emit(e.EventType.AUTHORIZED);const{communicationLayer:n,storageManager:r}=c.state,i=Object.assign(Object.assign({},c.state.channelConfig),{channelId:null!==(a=c.state.channelId)&&void 0!==a?a:"",validUntil:Date.now()+HE,localKey:null==n?void 0:n.getKeyInfo().ecies.private,otherKey:m});t.sendMessage({type:GE.KEY_HANDSHAKE_ACK}).catch((e=>{console.error(e);})),null===(s=t.state.socket)||void 0===s||s.emit(e.MessageType.PING,{id:f,clientType:h?"dapp":"wallet",context:"on_channel_reconnect",message:""}),yield null==r?void 0:r.persistChannelConfig(i),c.emitServiceStatusEvent(),c.setConnectionStatus(e.ConnectionStatus.LINKED);}p&&(t.emit(e.EventType.CHANNEL_PERSISTENCE),null===(u=t.state.keyExchange)||void 0===u||u.setKeysExchanged(true),c.state.ready=true,c.state.authorized=true,c.emit(e.EventType.AUTHORIZED),KS(Object.assign(Object.assign({id:null!=f?f:"",event:h?ZE.CONNECTED:ZE.CONNECTED_MOBILE},t.remote.state.originatorInfo),{sdkVersion:t.remote.state.sdkVersion,commLayer:t.state.communicationLayerPreference,commLayerVersion:FE.version,walletVersion:null===(l=t.remote.state.walletInfo)||void 0===l?void 0:l.version}),d.communicationServerUrl).catch((e=>{console.error("Cannot send analytics",e);})));})),XE=e=>new Promise((t=>{setTimeout(t,e);})),ek=(e,t,n=200)=>nS(void 0,void 0,void 0,(function*(){let r;const i=Date.now();let o=false;for(;!o;){if(o=Date.now()-i>3e5,r=t[e],void 0!==r.elapsedTime)return r;yield XE(n);}throw new Error(`RPC ${e} timed out`)})),tk=t=>nS(void 0,void 0,void 0,(function*(){const{state:n}=t,{socket:r,channelId:i,context:o,isOriginator:a,isReconnecting:s}=n;if(s)return jS.SocketService("[SocketService: reconnectSocket()] Reconnection already in progress, skipping",t),false;if(!r)return jS.SocketService("[SocketService: reconnectSocket()] socket is not defined",t),false;if(!i)return  false;const{connected:u}=r;n.isReconnecting=true,n.reconnectionAttempts=0,jS.SocketService(`[SocketService: reconnectSocket()] connected=${u} trying to reconnect after socketio disconnection`,t);try{for(;n.reconnectionAttempts<3;){if(jS.SocketService(`[SocketService: reconnectSocket()] Attempt ${n.reconnectionAttempts+1} of 3`,t),yield XE(200),r.connected)return jS.SocketService("Socket already connected --- ping to retrieve messages"),r.emit(e.MessageType.PING,{id:i,clientType:a?"dapp":"wallet",context:"on_channel_config",message:""}),!0;n.resumed=!0,r.connect(),t.emit(e.EventType.SOCKET_RECONNECT);try{if(yield new Promise(((n,s)=>{r.emit(e.EventType.JOIN_CHANNEL,{channelId:i,context:`${o}connect_again`,clientType:a?"dapp":"wallet"},((e,r)=>nS(void 0,void 0,void 0,(function*(){try{yield JE(t,e,r),n();}catch(e){s(e);}}))));})),yield XE(100),r.connected)return jS.SocketService(`Reconnection successful on attempt ${n.reconnectionAttempts+1}`),!0}catch(e){jS.SocketService(`Error during reconnection attempt ${n.reconnectionAttempts+1}:`,e);}n.reconnectionAttempts+=1,n.reconnectionAttempts<3&&(yield XE(200));}return jS.SocketService("Failed to reconnect after 3 attempts"),!1}finally{n.isReconnecting=false,n.reconnectionAttempts=0;}}));function nk(t,n){var r;return nS(this,void 0,void 0,(function*(){const i=null===(r=t.state.keyExchange)||void 0===r?void 0:r.encryptMessage(JSON.stringify(n)),o={id:t.state.channelId,context:t.state.context,clientType:t.state.isOriginator?"dapp":"wallet",message:i,plaintext:t.state.hasPlaintext?JSON.stringify(n):void 0};return jS.SocketService(`[SocketService: encryptAndSendMessage()] context=${t.state.context}`,o),n.type===e.MessageType.TERMINATE&&(t.state.manualDisconnect=true),new Promise(((n,r)=>{var i;null===(i=t.state.socket)||void 0===i||i.emit(e.EventType.MESSAGE,o,((e,t)=>{var i;e&&(jS.SocketService(`[SocketService: encryptAndSendMessage()] error=${e}`),r(e)),jS.SocketService("[encryptAndSendMessage] response",t),n(null!==(i=null==t?void 0:t.success)&&void 0!==i&&i);}));}))}))}var rk;!function(e){e.RPC_CHECK="rpcCheck",e.SKIPPED_RPC="skippedRpc";}(rk||(rk={}));const ik=["eth_sendTransaction","eth_signTypedData","eth_signTransaction","personal_sign","wallet_requestPermissions","wallet_switchEthereumChain","eth_signTypedData_v3","eth_signTypedData_v4","metamask_connectSign","metamask_connectWith","metamask_batch"].map((e=>e.toLowerCase()));function ok(t,n){var r,i,o;return nS(this,void 0,void 0,(function*(){if(!t.state.channelId)throw jS.SocketService("handleSendMessage: no channelId - Create a channel first"),new Error("Create a channel first");if(jS.SocketService(`[SocketService: handleSendMessage()] context=${t.state.context} areKeysExchanged=${null===(r=t.state.keyExchange)||void 0===r?void 0:r.areKeysExchanged()}`,n),null===(i=null==n?void 0:n.type)||void 0===i?void 0:i.startsWith("key_handshake"))return function(t,n){var r;jS.SocketService(`[SocketService: handleKeyHandshake()] context=${t.state.context}`,n),null===(r=t.state.socket)||void 0===r||r.emit(e.EventType.MESSAGE,{id:t.state.channelId,context:t.state.context,clientType:t.state.isOriginator?"dapp":"wallet",message:n});}(t,n),true;!function(e,t){var n;if(!(null===(n=e.state.keyExchange)||void 0===n?void 0:n.areKeysExchanged())&&!e.remote.state.relayPersistence)throw jS.SocketService(`[SocketService: validateKeyExchange()] context=${e.state.context} ERROR keys not exchanged`,t),console.error("[SocketService: validateKeyExchange()] ERROR keys not exchanged",t),new Error("Keys not exchanged BBB")}(t,n),function(t,n){var r;const i=null!==(r=null==n?void 0:n.method)&&void 0!==r?r:"",o=null==n?void 0:n.id;t.state.isOriginator&&o&&(t.state.rpcMethodTracker[o]={id:o,timestamp:Date.now(),method:i},t.emit(e.EventType.RPC_UPDATE,t.state.rpcMethodTracker[o]));}(t,n);const a=yield nk(t,n);return t.remote.state.analytics&&t.remote.state.isOriginator&&n.method&&ik.includes(n.method.toLowerCase())&&KS({id:null!==(o=t.remote.state.channelId)&&void 0!==o?o:"",event:ZE.SDK_RPC_REQUEST,params:{method:n.method,from:"mobile"}},t.remote.state.communicationServerUrl).catch((e=>{console.error("[handleSendMessage] Cannot send analytics",e);})),function(t,n){var r;return nS(this,void 0,void 0,(function*(){const i=null==n?void 0:n.id,o=null!==(r=null==n?void 0:n.method)&&void 0!==r?r:"";if(t.state.isOriginator&&i)try{const r=ek(i,t.state.rpcMethodTracker,200).then((e=>({type:rk.RPC_CHECK,result:e}))),a=(()=>nS(this,void 0,void 0,(function*(){const e=yield (({rpcId:e,instance:t})=>nS(void 0,void 0,void 0,(function*(){for(;t.state.lastRpcId===e||void 0===t.state.lastRpcId;)yield XE(200);return t.state.lastRpcId})))({instance:t,rpcId:i}),n=yield ek(e,t.state.rpcMethodTracker,200);return {type:rk.SKIPPED_RPC,result:n}})))(),s=yield Promise.race([r,a]);if(s.type===rk.RPC_CHECK){const e=s.result;jS.SocketService(`[SocketService:handleRpcReplies()] id=${n.id} ${o} ( ${e.elapsedTime} ms)`,e.result);}else {if(s.type!==rk.SKIPPED_RPC)throw new Error(`Error handling RPC replies for ${i}`);{const{result:n}=s;console.warn(`[SocketService handleRpcReplies()] RPC METHOD HAS BEEN SKIPPED rpcid=${i} method=${o}`,n);const r=Object.assign(Object.assign({},t.state.rpcMethodTracker[i]),{error:new Error("SDK_CONNECTION_ISSUE")});t.emit(e.EventType.RPC_UPDATE,r);const a={data:Object.assign(Object.assign({},r),{jsonrpc:"2.0"}),name:"metamask-provider"};t.emit(e.EventType.MESSAGE,{message:a});}}}catch(e){throw console.warn(`[SocketService handleRpcReplies()] Error rpcId=${n.id} ${o}`,e),e}}))}(t,n).catch((e=>{console.warn("[handleSendMessage] Error handleRpcReplies",e);})),a}))}const ak=[{event:e.EventType.CLIENTS_CONNECTED,handler:function(t,n){return r=>nS(this,void 0,void 0,(function*(){var r,i,o,a,s,u,l,c,d,f,h;const p=null!==(i=null===(r=t.remote.state.channelConfig)||void 0===r?void 0:r.relayPersistence)&&void 0!==i&&i;if(jS.SocketService(`[SocketService: handleClientsConnected()] context=${t.state.context} on 'clients_connected-${n}' relayPersistence=${p} resumed=${t.state.resumed}  clientsPaused=${t.state.clientsPaused} keysExchanged=${null===(o=t.state.keyExchange)||void 0===o?void 0:o.areKeysExchanged()} isOriginator=${t.state.isOriginator}`),t.emit(e.EventType.CLIENTS_CONNECTED,{isOriginator:t.state.isOriginator,keysExchanged:null===(a=t.state.keyExchange)||void 0===a?void 0:a.areKeysExchanged(),context:t.state.context}),t.state.resumed)t.state.isOriginator||(jS.SocketService(`[SocketService: handleClientsConnected()] context=${t.state.context} 'clients_connected' / keysExchanged=${null===(s=t.state.keyExchange)||void 0===s?void 0:s.areKeysExchanged()} -- backward compatibility`),null===(u=t.state.keyExchange)||void 0===u||u.start({isOriginator:null!==(l=t.state.isOriginator)&&void 0!==l&&l})),t.state.resumed=false;else if(t.state.clientsPaused)jS.SocketService("[SocketService: handleClientsConnected()] 'clients_connected' skip sending originatorInfo on pause");else if(!t.state.isOriginator){const e=!p;jS.SocketService(`[SocketService: handleClientsConnected()] context=${t.state.context} on 'clients_connected' / keysExchanged=${null===(c=t.state.keyExchange)||void 0===c?void 0:c.areKeysExchanged()} -- force=${e} -- backward compatibility`),jS.SocketService(`[SocketService: handleClientsConnected()] context=${t.state.context} on 'clients_connected' / keysExchanged=${null===(d=t.state.keyExchange)||void 0===d?void 0:d.areKeysExchanged()} -- force=${e} -- backward compatibility`),null===(f=t.state.keyExchange)||void 0===f||f.start({isOriginator:null!==(h=t.state.isOriginator)&&void 0!==h&&h,force:e});}t.state.clientsConnected=true,t.state.clientsPaused=false;}))}},{event:e.EventType.CHANNEL_CREATED,handler:function(t,n){return r=>{jS.SocketService(`[SocketService: handleChannelCreated()] context=${t.state.context} on 'channel_created-${n}'`,r),t.emit(e.EventType.CHANNEL_CREATED,r);}}},{event:e.EventType.CLIENTS_DISCONNECTED,handler:function(t,n){return ()=>{var r;t.state.clientsConnected=false,jS.SocketService(`[SocketService: handlesClientsDisconnected()] context=${t.state.context} on 'clients_disconnected-${n}'`),t.remote.state.relayPersistence?jS.SocketService(`[SocketService: handlesClientsDisconnected()] context=${t.state.context} on 'clients_disconnected-${n}' - relayPersistence enabled, skipping key exchange cleanup.`):(t.state.isOriginator&&!t.state.clientsPaused&&(null===(r=t.state.keyExchange)||void 0===r||r.clean()),t.emit(e.EventType.CLIENTS_DISCONNECTED,n));}}},{event:e.EventType.CONFIG,handler:function(t,n){return r=>nS(this,void 0,void 0,(function*(){var i,o,a;jS.SocketService(`[SocketService: handleChannelConfig()] update relayPersistence on 'config-${n}'`,r);const{persistence:s,walletKey:u}=r;t.state.isOriginator&&t.remote.state.channelConfig?(r.walletKey&&!t.remote.state.channelConfig.otherKey&&(jS.SocketService(`Setting wallet key ${u}`),t.remote.state.channelConfig.otherKey=u,t.getKeyExchange().setOtherPublicKey(r.walletKey),null===(i=t.state.keyExchange)||void 0===i||i.setKeysExchanged(true),yield t.remote.sendMessage({type:GE.KEY_HANDSHAKE_ACK}),yield t.remote.sendMessage({type:e.MessageType.PING}),yield null===(o=t.remote.state.storageManager)||void 0===o?void 0:o.persistChannelConfig(t.remote.state.channelConfig)),true!==s||t.remote.state.channelConfig.relayPersistence||(jS.SocketService(`Setting relay persistence ${s}`),t.remote.state.channelConfig.relayPersistence=s,t.remote.state.relayPersistence=true,t.remote.emit(e.EventType.CHANNEL_PERSISTENCE),t.remote.state.authorized=true,t.remote.state.ready=true,t.remote.emit(e.EventType.AUTHORIZED),yield null===(a=t.remote.state.storageManager)||void 0===a?void 0:a.persistChannelConfig(t.remote.state.channelConfig))):t.state.isOriginator||r.persistence&&(t.remote.state.relayPersistence=true,t.remote.emit(e.EventType.CHANNEL_PERSISTENCE));}))}},{event:e.EventType.MESSAGE,handler:function(t,n){return r=>{var i,o,a,s,u,l,c,d,f,h,p,m,g,v,b,y,w,_;const{ackId:S,message:E,error:k}=r,M=null!==(i=t.remote.state.relayPersistence)&&void 0!==i&&i;if(jS.SocketService(`[SocketService handleMessage()]  relayPersistence=${M}  context=${t.state.context} on 'message' ${n} keysExchanged=${null===(o=t.state.keyExchange)||void 0===o?void 0:o.areKeysExchanged()}`,r),k)throw jS.SocketService(`\n      [SocketService handleMessage()] context=${t.state.context}::on 'message' error=${k}`),new Error(k);const C="string"==typeof E;if(!C&&(null==E?void 0:E.type)===GE.KEY_HANDSHAKE_START)return M?void console.warn("[SocketService handleMessage()] Ignoring key exchange message because relay persistence is activated",E):(jS.SocketService(`[SocketService handleMessage()] context=${t.state.context}::on 'message' received HANDSHAKE_START isOriginator=${t.state.isOriginator}`,E),void(null===(a=t.state.keyExchange)||void 0===a||a.start({isOriginator:null!==(s=t.state.isOriginator)&&void 0!==s&&s,force:true})));if(!C&&(null===(u=null==E?void 0:E.type)||void 0===u?void 0:u.startsWith("key_handshake")))return M?void console.warn("[SocketService handleMessage()] Ignoring key exchange message because relay persistence is activated",E):(jS.SocketService(`[SocketService handleMessage()] context=${t.state.context}::on 'message' emit KEY_EXCHANGE`,E),void t.emit(YE.KEY_EXCHANGE,{message:E,context:t.state.context}));if(C&&!(null===(l=t.state.keyExchange)||void 0===l?void 0:l.areKeysExchanged())){let e=false;try{jS.SocketService(`[SocketService handleMessage()] context=${t.state.context}::on 'message' trying to decrypt message`),null===(c=t.state.keyExchange)||void 0===c||c.decryptMessage(E),e=!0;}catch(e){jS.SocketService(`[SocketService handleMessage()] context=${t.state.context}::on 'message' error`,e);}if(!e)return t.state.isOriginator?null===(f=t.state.keyExchange)||void 0===f||f.start({isOriginator:null!==(h=t.state.isOriginator)&&void 0!==h&&h}):t.sendMessage({type:GE.KEY_HANDSHAKE_START}).catch((e=>{console.error(`[SocketService handleMessage()] context=${t.state.context}::on 'message' error`,e);})),void jS.SocketService(`Message ignored because invalid key exchange status. step=${null===(p=t.state.keyExchange)||void 0===p?void 0:p.getKeyInfo().step}`,null===(m=t.state.keyExchange)||void 0===m?void 0:m.getKeyInfo(),E);jS.SocketService("Invalid key exchange status detected --- updating it."),null===(d=t.state.keyExchange)||void 0===d||d.setKeysExchanged(true);}else if(!C&&(null==E?void 0:E.type))return console.warn("[SocketService handleMessage() ::on 'message' received non encrypted unkwown message"),void t.emit(e.EventType.MESSAGE,E);if(!C)return console.warn("[SocketService handleMessage() ::on 'message' received unkwown message",E),void t.emit(e.EventType.MESSAGE,E);const x=null===(g=t.state.keyExchange)||void 0===g?void 0:g.decryptMessage(E),A=JSON.parse(null!=x?x:"{}");if(S&&(null==S?void 0:S.length)>0&&(jS.SocketService(`[SocketService handleMessage()] context=${t.state.context}::on 'message' ackid=${S} channelId=${n}`),null===(v=t.state.socket)||void 0===v||v.emit(e.EventType.MESSAGE_ACK,{ackId:S,channelId:n,clientType:t.state.isOriginator?"dapp":"wallet"})),(null==A?void 0:A.type)===e.MessageType.PAUSE?t.state.clientsPaused=true:t.state.clientsPaused=false,t.state.isOriginator&&A.data){const n=A.data,r=t.state.rpcMethodTracker[n.id];if(r){const i=Date.now()-r.timestamp;jS.SocketService(`[SocketService handleMessage()] context=${t.state.context}::on 'message' received answer for id=${n.id} method=${r.method} responseTime=${i}`,A),t.remote.state.analytics&&ik.includes(r.method.toLowerCase())&&KS(Object.assign(Object.assign({id:null!==(b=t.remote.state.channelId)&&void 0!==b?b:"",event:ZE.SDK_RPC_REQUEST_DONE,sdkVersion:t.remote.state.sdkVersion,commLayerVersion:FE.version},t.remote.state.originatorInfo),{walletVersion:null===(y=t.remote.state.walletInfo)||void 0===y?void 0:y.version,params:{method:r.method,from:"mobile"}}),t.remote.state.communicationServerUrl).catch((e=>{console.error("Cannot send analytics",e);}));const o=Object.assign(Object.assign({},r),{result:n.result,error:n.error?{code:null===(w=n.error)||void 0===w?void 0:w.code,message:null===(_=n.error)||void 0===_?void 0:_.message}:void 0,elapsedTime:i});t.state.rpcMethodTracker[n.id]=o,t.emit(e.EventType.RPC_UPDATE,o);}}t.emit(e.EventType.MESSAGE,{message:A});}}},{event:e.EventType.REJECTED,handler:function(t,n){return r=>nS(this,void 0,void 0,(function*(){var r;t.state.isOriginator&&!t.remote.state.ready?(jS.SocketService(`[SocketService: handleChannelRejected()] context=${t.state.context} channelId=${n} isOriginator=${t.state.isOriginator} ready=${t.remote.state.ready}`,t.remote.state.originatorInfo),KS(Object.assign(Object.assign({id:n,event:ZE.REJECTED},t.remote.state.originatorInfo),{sdkVersion:t.remote.state.sdkVersion,commLayer:t.state.communicationLayerPreference,commLayerVersion:FE.version,walletVersion:null===(r=t.remote.state.walletInfo)||void 0===r?void 0:r.version}),t.remote.state.communicationServerUrl).catch((e=>{console.error("handleChannelRejected:: Error emitting analytics event",e);})),yield t.remote.disconnect({terminate:true}),t.remote.emit(e.EventType.REJECTED,{channelId:n}),t.remote.setConnectionStatus(e.ConnectionStatus.DISCONNECTED)):jS.SocketService(`[SocketService: handleChannelRejected()] SKIP -- channelId=${n} isOriginator=${t.state.isOriginator} ready=${t.remote.state.ready}`);}))}},{event:"clients_waiting_to_join",handler:function(t,n){return r=>{jS.SocketService(`[SocketService: handleClientsWaitingToJoin()] context=${t.state.context} on 'clients_waiting_to_join-${n}'`,r),t.emit(e.EventType.CLIENTS_WAITING,r);}}}],sk=[{event:e.EventType.KEY_INFO,handler:function(t){return n=>{jS.SocketService("[SocketService: handleKeyInfo()] on 'KEY_INFO'",n),t.emit(e.EventType.KEY_INFO,n);}}},{event:e.EventType.KEYS_EXCHANGED,handler:function(t){return ()=>{var n,r,i;jS.SocketService(`[SocketService: handleKeysExchanged()] on 'keys_exchanged' keyschanged=${null===(n=t.state.keyExchange)||void 0===n?void 0:n.areKeysExchanged()}`);const{channelConfig:o}=t.remote.state;if(o){const e=t.getKeyExchange().getKeyInfo().ecies;o.localKey=e.private,o.otherKey=e.otherPubKey,t.remote.state.channelConfig=o,null===(r=t.remote.state.storageManager)||void 0===r||r.persistChannelConfig(o).catch((e=>{console.error("Error persisting channel config",e);}));}t.emit(e.EventType.KEYS_EXCHANGED,{keysExchanged:null===(i=t.state.keyExchange)||void 0===i?void 0:i.areKeysExchanged(),isOriginator:t.state.isOriginator});const a={keyInfo:t.getKeyInfo()};t.emit(e.EventType.SERVICE_STATUS,a);}}}];function uk(t,n){jS.SocketService(`[SocketService: setupChannelListener()] context=${t.state.context} setting socket listeners for channel ${n}...`);const{socket:r}=t.state,{keyExchange:i}=t.state;r&&t.state.isOriginator&&(t.state.debug&&(null==r||r.io.on("error",(e=>{jS.SocketService(`[SocketService: setupChannelListener()] context=${t.state.context} socket event=error`,e);})),null==r||r.io.on("reconnect",(e=>{jS.SocketService(`[SocketService: setupChannelListener()] context=${t.state.context} socket event=reconnect`,e),tk(t).catch((e=>{}));})),null==r||r.io.on("reconnect_error",(e=>{jS.SocketService(`[SocketService: setupChannelListener()] context=${t.state.context} socket event=reconnect_error`,e);})),null==r||r.io.on("reconnect_failed",(()=>{jS.SocketService(`[SocketService: setupChannelListener()] context=${t.state.context} socket event=reconnect_failed`);}))),null==r||r.on("disconnect",(n=>(jS.SocketService(`[SocketService: setupChannelListener()] on 'disconnect' -- MetaMaskSDK socket disconnected '${n}' begin recovery...`),function(t){return n=>{jS.SocketService(`[SocketService: handleDisconnect()] on 'disconnect' manualDisconnect=${t.state.manualDisconnect}`,n),t.state.manualDisconnect||(t.emit(e.EventType.SOCKET_DISCONNECTED),tk(t).catch((e=>{console.error("SocketService::handleDisconnect Error reconnecting socket",e);})));}}(t)(n))))),ak.forEach((({event:e,handler:i})=>{const o=`${e}-${n}`;null==r||r.on(o,i(t,n));})),sk.forEach((({event:e,handler:n})=>{null==i||i.on(e,n(t));})),t.state.setupChannelListeners=true;}class lk extends xw.EventEmitter2{constructor(e){super(),this.state={clientsConnected:false,clientsPaused:false,manualDisconnect:false,lastRpcId:void 0,rpcMethodTracker:{},hasPlaintext:false,communicationServerUrl:"",focusListenerAdded:false,removeFocusListener:void 0,isReconnecting:false,reconnectionAttempts:0},this.options=e;const{reconnect:t,communicationLayerPreference:n,communicationServerUrl:r,context:i,remote:o,logging:a}=e;this.state.resumed=t,this.state.context=i,this.state.isOriginator=o.state.isOriginator,this.state.communicationLayerPreference=n,this.state.debug=true===(null==a?void 0:a.serviceLayer),this.remote=o,true===(null==a?void 0:a.serviceLayer)&&LS.enable("SocketService:Layer"),this.state.communicationServerUrl=r,this.state.hasPlaintext=this.state.communicationServerUrl!==KE&&true===(null==a?void 0:a.plaintext),jS.SocketService(`[SocketService: constructor()] Socket IO url: ${this.state.communicationServerUrl}`),this.initSocket();}initSocket(){var e;const{otherPublicKey:t,ecies:n,logging:r}=this.options,i={autoConnect:false,transports:qE,withCredentials:true},o=this.state.communicationServerUrl;jS.SocketService(`[SocketService: initSocket()] Socket IO url: ${o}`),this.state.socket=tS(o,i),function(e){if("undefined"!=typeof window&&"undefined"!=typeof document&&(jS.SocketService(`[SocketService: setupSocketFocusListener()] hasFocus=${document.hasFocus()}`,e),!e.state.focusListenerAdded)){const t=()=>{jS.SocketService("Document has focus --- reconnecting socket"),tk(e).catch((e=>{console.error("setupSocketFocusListeners Error reconnecting socket",e);}));};window.addEventListener("focus",t),e.state.focusListenerAdded=true,e.state.removeFocusListener=()=>{window.removeEventListener("focus",t),e.state.focusListenerAdded=false;};}}(this);const a={communicationLayer:this,otherPublicKey:t,sendPublicKey:false,context:null!==(e=this.state.context)&&void 0!==e?e:"",ecies:n,logging:r};this.state.keyExchange=new QE(a);}resetKeys(){return jS.SocketService("[SocketService: resetKeys()] Resetting keys."),void(null===(e=this.state.keyExchange)||void 0===e||e.resetKeys());var e;}createChannel(){return nS(this,void 0,void 0,(function*(){return function(t){var n,r,i;return nS(this,void 0,void 0,(function*(){if(jS.SocketService(`[SocketService: createChannel()] context=${t.state.context}`),t.state.socket||t.initSocket(),null===(n=t.state.socket)||void 0===n?void 0:n.connected)throw console.error("[SocketService: createChannel()] socket already connected"),new Error("socket already connected");null===(r=t.state.socket)||void 0===r||r.connect(),t.state.manualDisconnect=false,t.state.isOriginator=true;const o=Ow();t.state.channelId=o,uk(t,o),yield new Promise(((n,r)=>{var i;null===(i=t.state.socket)||void 0===i||i.emit(e.EventType.JOIN_CHANNEL,{channelId:o,context:`${t.state.context}createChannel`,clientType:"dapp"},((e,i)=>nS(this,void 0,void 0,(function*(){try{yield JE(t,e,i),n();}catch(e){r(e);}}))));}));const a=null===(i=t.state.keyExchange)||void 0===i?void 0:i.getKeyInfo();return {channelId:o,pubKey:(null==a?void 0:a.ecies.public)||"",privKey:(null==a?void 0:a.ecies.private)||""}}))}(this)}))}connectToChannel({channelId:t,withKeyExchange:n=false,authorized:r}){return function({options:t,instance:n}){return nS(this,void 0,void 0,(function*(){const{channelId:r,authorized:i,withKeyExchange:o}=t,{state:a,remote:s}=n,{isOriginator:u=false,socket:l,keyExchange:c}=a,{channelConfig:d}=s.state;if(null==l?void 0:l.connected)throw console.error("[SocketService: connectToChannel()] socket already connected"),new Error("socket already connected");if(u&&(null==d?void 0:d.relayPersistence)){const{localKey:e,otherKey:t}=d;e&&t?null==c||c.setRelayPersistence({localKey:e,otherKey:t}):console.warn("Missing keys in relay persistence",d);}return Object.assign(a,{manualDisconnect:false,withKeyExchange:o,isOriginator:u,channelId:r}),null==l||l.connect(),uk(n,r),!u&&i&&(null==c||c.setKeysExchanged(true),Object.assign(s.state,{ready:true,authorized:true})),new Promise((t=>{var o;const s=null===(o=null==c?void 0:c.getKeyInfo())||void 0===o?void 0:o.ecies.public,d=i&&!u?s:void 0;null==l||l.emit(e.EventType.JOIN_CHANNEL,{channelId:r,context:`${a.context}_connectToChannel`,clientType:u?"dapp":"wallet",publicKey:d},((e,r)=>nS(this,void 0,void 0,(function*(){yield JE(n,e,r),t();}))));}))}))}({options:{channelId:t,withKeyExchange:n,authorized:r},instance:this})}getKeyInfo(){return this.state.keyExchange.getKeyInfo()}keyCheck(){var t,n;null===(n=(t=this).state.socket)||void 0===n||n.emit(e.EventType.MESSAGE,{id:t.state.channelId,context:t.state.context,message:{type:GE.KEY_HANDSHAKE_CHECK,pubkey:t.getKeyInfo().ecies.otherPubKey}});}getKeyExchange(){return this.state.keyExchange}sendMessage(e){return nS(this,void 0,void 0,(function*(){return ok(this,e)}))}ping(){return function(t){var n,r;return nS(this,void 0,void 0,(function*(){jS.SocketService(`[SocketService: ping()] context=${t.state.context} originator=${t.state.isOriginator} keysExchanged=${null===(n=t.state.keyExchange)||void 0===n?void 0:n.areKeysExchanged()}`),null===(r=t.state.socket)||void 0===r||r.emit(e.MessageType.PING,{id:t.state.channelId,context:"ping",clientType:t.remote.state.isOriginator?"dapp":"wallet",message:""});}))}(this)}pause(){return function(t){var n,r;return nS(this,void 0,void 0,(function*(){jS.SocketService(`[SocketService: pause()] context=${t.state.context}`),t.state.manualDisconnect=true,(null===(n=t.state.keyExchange)||void 0===n?void 0:n.areKeysExchanged())&&(yield t.sendMessage({type:e.MessageType.PAUSE})),null===(r=t.state.socket)||void 0===r||r.disconnect();}))}(this)}isConnected(){var e;return null===(e=this.state.socket)||void 0===e?void 0:e.connected}resume(){return function(t){return nS(this,void 0,void 0,(function*(){const{state:n,remote:r}=t,{socket:i,channelId:o,context:a,keyExchange:s,isOriginator:u}=n,{isOriginator:l}=r.state;if(jS.SocketService(`[SocketService: resume()] channelId=${o} context=${a} connected=${null==i?void 0:i.connected} manualDisconnect=${n.manualDisconnect} resumed=${n.resumed} keysExchanged=${null==s?void 0:s.areKeysExchanged()}`),!o)throw jS.SocketService("[SocketService: resume()] channelId is not defined"),new Error("ChannelId is not defined");(null==i?void 0:i.connected)?(jS.SocketService("[SocketService: resume()] already connected."),i.emit(e.MessageType.PING,{id:o,clientType:l?"dapp":"wallet",context:"on_channel_config",message:""}),r.hasRelayPersistence()||(null==s?void 0:s.areKeysExchanged())||(u?yield t.sendMessage({type:e.MessageType.READY}):null==s||s.start({isOriginator:false}))):(null==i||i.connect(),jS.SocketService(`[SocketService: resume()] after connecting socket --\x3e connected=${null==i?void 0:i.connected}`),null==i||i.emit(e.EventType.JOIN_CHANNEL,{channelId:o,context:`${a}_resume`,clientType:l?"dapp":"wallet"},((e,n)=>nS(this,void 0,void 0,(function*(){try{yield JE(t,e,n);}catch(e){console.warn("Error reconnecting to channel",e);}}))))),n.manualDisconnect=false,n.resumed=true;}))}(this)}getRPCMethodTracker(){return this.state.rpcMethodTracker}disconnect(e){return function(e,t){var n,r,i,o,a;jS.SocketService(`[SocketService: disconnect()] context=${e.state.context}`,t),(null==t?void 0:t.terminate)&&(null===(r=(n=e.state).removeFocusListener)||void 0===r||r.call(n),e.state.channelId=t.channelId,null===(i=e.state.socket)||void 0===i||i.removeAllListeners(),null===(o=e.state.keyExchange)||void 0===o||o.clean(),e.remote.state.ready=false,e.state.socket=void 0,e.state.rpcMethodTracker={}),e.state.manualDisconnect=true,null===(a=e.state.socket)||void 0===a||a.disconnect();}(this,e)}}var ck;function dk(t){return ()=>nS(this,void 0,void 0,(function*(){var n,r,i;const{state:o}=t;if(o.authorized)return;yield (()=>nS(this,void 0,void 0,(function*(){for(;!o.walletInfo;)yield XE(500);})))();const a="7.3".localeCompare((null===(n=o.walletInfo)||void 0===n?void 0:n.version)||"");if(jS.RemoteCommunication(`[RemoteCommunication: handleAuthorizedEvent()] HACK 'authorized' version=${null===(r=o.walletInfo)||void 0===r?void 0:r.version} compareValue=${a}`),1!==a)return;const s=o.platformType===e.PlatformType.MobileWeb||o.platformType===e.PlatformType.ReactNative||o.platformType===e.PlatformType.MetaMaskMobileWebview;jS.RemoteCommunication(`[RemoteCommunication: handleAuthorizedEvent()] HACK 'authorized' platform=${o.platformType} secure=${s} channel=${o.channelId} walletVersion=${null===(i=o.walletInfo)||void 0===i?void 0:i.version}`),s&&(o.authorized=true,t.emit(e.EventType.AUTHORIZED));}))}function fk(t){return n=>{const{state:r}=t;jS.RemoteCommunication(`[RemoteCommunication: handleChannelCreatedEvent()] context=${r.context} on 'channel_created' channelId=${n}`),t.emit(e.EventType.CHANNEL_CREATED,n);}}function hk(t,n){return ()=>{var r,i,o,a;const{state:s}=t;if(jS.RemoteCommunication(`[RemoteCommunication: handleClientsConnectedEvent()] on 'clients_connected' channel=${s.channelId} keysExchanged=${null===(i=null===(r=s.communicationLayer)||void 0===r?void 0:r.getKeyInfo())||void 0===i?void 0:i.keysExchanged}`),s.analytics){const e=s.isOriginator?ZE.REQUEST:ZE.REQUEST_MOBILE;KS(Object.assign(Object.assign({id:null!==(o=s.channelId)&&void 0!==o?o:"",event:s.reconnection?ZE.RECONNECT:e},s.originatorInfo),{commLayer:n,sdkVersion:s.sdkVersion,walletVersion:null===(a=s.walletInfo)||void 0===a?void 0:a.version,commLayerVersion:FE.version}),s.communicationServerUrl).catch((e=>{console.error("Cannot send analytics",e);}));}s.clientsConnected=true,s.originatorInfoSent=false,t.emit(e.EventType.CLIENTS_CONNECTED);}}function pk(t){return n=>{const{state:r}=t;jS.RemoteCommunication(`[RemoteCommunication: handleClientsDisconnectedEvent()] context=${r.context} on 'clients_disconnected' channelId=${n}`),r.relayPersistence||(r.clientsConnected=false,r.ready=false,r.authorized=false),t.emit(e.EventType.CLIENTS_DISCONNECTED,r.channelId),t.setConnectionStatus(e.ConnectionStatus.DISCONNECTED);}}function mk(t){return n=>{var r;const{state:i}=t;if(jS.RemoteCommunication(`[RemoteCommunication: handleClientsWaitingEvent()] context=${i.context} on 'clients_waiting' numberUsers=${n} ready=${i.ready} autoStarted=${i.originatorConnectStarted}`),t.setConnectionStatus(e.ConnectionStatus.WAITING),t.emit(e.EventType.CLIENTS_WAITING,n),i.originatorConnectStarted){jS.RemoteCommunication(`[RemoteCommunication: handleClientsWaitingEvent()] on 'clients_waiting' watch autoStarted=${i.originatorConnectStarted} timeout`,i.autoConnectOptions);const n=(null===(r=i.autoConnectOptions)||void 0===r?void 0:r.timeout)||3e3,o=setTimeout((()=>{jS.RemoteCommunication(`[RemoteCommunication: handleClientsWaitingEvent()] setTimeout(${n}) terminate channelConfig`,i.autoConnectOptions),i.originatorConnectStarted=false,i.ready||t.setConnectionStatus(e.ConnectionStatus.TIMEOUT),clearTimeout(o);}),n);}}}function gk(t,n){return r=>{var i,o,a,s,u,l,c,d;const{state:f}=t;if(jS.RemoteCommunication(`[RemoteCommunication: handleKeysExchangedEvent()] context=${f.context} on commLayer.'keys_exchanged' channel=${f.channelId}`,r),null===(o=null===(i=f.communicationLayer)||void 0===i?void 0:i.getKeyInfo())||void 0===o?void 0:o.keysExchanged){const n=Object.assign(Object.assign({},f.channelConfig),{channelId:null!==(a=f.channelId)&&void 0!==a?a:"",validUntil:(null===(s=f.channelConfig)||void 0===s?void 0:s.validUntil)||HE,localKey:f.communicationLayer.getKeyInfo().ecies.private,otherKey:f.communicationLayer.getKeyInfo().ecies.otherPubKey});null===(u=f.storageManager)||void 0===u||u.persistChannelConfig(n).catch((e=>{console.error("Error persisting channel config",e);})),t.setConnectionStatus(e.ConnectionStatus.LINKED);}!function(e,t){var n,r,i,o,a,s,u,l;const{state:c}=e;jS.RemoteCommunication(`[RemoteCommunication: setLastActiveDate()] channel=${c.channelId}`,t);const d=Object.assign(Object.assign({},c.channelConfig),{channelId:null!==(n=c.channelId)&&void 0!==n?n:"",validUntil:null!==(i=null===(r=c.channelConfig)||void 0===r?void 0:r.validUntil)&&void 0!==i?i:0,relayPersistence:c.relayPersistence,localKey:null===(a=null===(o=c.communicationLayer)||void 0===o?void 0:o.state.keyExchange)||void 0===a?void 0:a.getKeyInfo().ecies.private,otherKey:null===(u=null===(s=c.communicationLayer)||void 0===s?void 0:s.state.keyExchange)||void 0===u?void 0:u.getKeyInfo().ecies.otherPubKey,lastActive:t.getTime()});null===(l=c.storageManager)||void 0===l||l.persistChannelConfig(d);}(t,new Date),f.analytics&&f.channelId&&KS(Object.assign(Object.assign({id:f.channelId,event:r.isOriginator?ZE.CONNECTED:ZE.CONNECTED_MOBILE},f.originatorInfo),{sdkVersion:f.sdkVersion,commLayer:n,commLayerVersion:FE.version,walletVersion:null===(l=f.walletInfo)||void 0===l?void 0:l.version}),f.communicationServerUrl).catch((e=>{console.error("Cannot send analytics",e);})),f.isOriginator=r.isOriginator,r.isOriginator||(null===(c=f.communicationLayer)||void 0===c||c.sendMessage({type:e.MessageType.READY}),f.ready=true,f.paused=false),r.isOriginator&&!f.originatorInfoSent&&(null===(d=f.communicationLayer)||void 0===d||d.sendMessage({type:e.MessageType.ORIGINATOR_INFO,originatorInfo:f.originatorInfo,originator:f.originatorInfo}),f.originatorInfoSent=true);}}function vk(t){return n=>{let r=n;n.message&&(r=r.message),function(t,n){const{state:r}=n;if(jS.RemoteCommunication(`[RemoteCommunication: onCommunicationLayerMessage()] context=${r.context} on 'message' typeof=${typeof t}`,t),n.state.ready=true,r.isOriginator||t.type!==e.MessageType.ORIGINATOR_INFO)if(r.isOriginator&&t.type===e.MessageType.WALLET_INFO)!function(e,t){const{state:n}=e;n.walletInfo=t.walletInfo,n.paused=false;}(n,t);else {if(r.isOriginator&&t.type===e.MessageType.WALLET_INIT)(function(t,n){var r,i,o;return nS(this,void 0,void 0,(function*(){const{state:a}=t;if(a.isOriginator){const a=n.data||{};if("object"==typeof a&&"accounts"in a&&"chainId"in a&&"walletKey"in a)try{const{channelConfig:n}=t.state;if(jS.RemoteCommunication("WALLET_INIT: channelConfig",JSON.stringify(n,null,2)),n){const e=a.accounts,s=a.chainId,u=a.walletKey;let l,c=!1;"deeplinkProtocol"in a&&(c=Boolean(a.deeplinkProtocol),t.state.deeplinkProtocolAvailable=c),"walletVersion"in a&&(l=a.walletVersion),yield null===(r=t.state.storageManager)||void 0===r?void 0:r.persistChannelConfig(Object.assign(Object.assign({},n),{otherKey:u,walletVersion:l,deeplinkProtocolAvailable:c,relayPersistence:!0})),yield null===(i=t.state.storageManager)||void 0===i?void 0:i.persistAccounts(e),yield null===(o=t.state.storageManager)||void 0===o?void 0:o.persistChainId(s);}t.emit(e.EventType.WALLET_INIT,{accounts:a.accounts,chainId:a.chainId});}catch(e){console.error('RemoteCommunication::on "wallet_init" -- error',e);}else console.error('RemoteCommunication::on "wallet_init" -- invalid data format',a);}}))})(n,t).catch((e=>{jS.RemoteCommunication(`[RemoteCommunication: onCommunicationLayerMessage()] error=${e}`);}));else if(t.type===e.MessageType.TERMINATE)(function(t){return nS(this,void 0,void 0,(function*(){const{state:n}=t;n.isOriginator&&(yield Sk({options:{terminate:true,sendMessage:false},instance:t}),t.emit(e.EventType.TERMINATE));}))})(n).catch((e=>{jS.RemoteCommunication(`[RemoteCommunication: onCommunicationLayerMessage()] error=${e}`);}));else if(t.type===e.MessageType.PAUSE)!function(t){const{state:n}=t;n.paused=true,t.setConnectionStatus(e.ConnectionStatus.PAUSED);}(n);else if(t.type===e.MessageType.READY&&r.isOriginator)!function(t){const{state:n}=t;t.setConnectionStatus(e.ConnectionStatus.LINKED);const r=n.paused;n.paused=false,t.emit(e.EventType.CLIENTS_READY,{isOriginator:n.isOriginator,walletInfo:n.walletInfo}),r&&(n.authorized=true,t.emit(e.EventType.AUTHORIZED));}(n);else {if(t.type===e.MessageType.OTP&&r.isOriginator)return void function(t,n){var r;const{state:i}=t;t.emit(e.EventType.OTP,n.otpAnswer),1==="6.6".localeCompare((null===(r=i.walletInfo)||void 0===r?void 0:r.version)||"")&&(console.warn("RemoteCommunication::on 'otp' -- backward compatibility <6.6 -- triger eth_requestAccounts"),t.emit(e.EventType.SDK_RPC_CALL,{method:$E.ETH_REQUESTACCOUNTS,params:[]}));}(n,t);t.type===e.MessageType.AUTHORIZED&&r.isOriginator&&function(t){const{state:n}=t;n.authorized=true,t.emit(e.EventType.AUTHORIZED);}(n);}n.emit(e.EventType.MESSAGE,t);}else !function(t,n){var r;const{state:i}=t;null===(r=i.communicationLayer)||void 0===r||r.sendMessage({type:e.MessageType.WALLET_INFO,walletInfo:i.walletInfo}),i.originatorInfo=n.originatorInfo||n.originator,t.emit(e.EventType.CLIENTS_READY,{isOriginator:i.isOriginator,originatorInfo:i.originatorInfo}),i.paused=false;}(n,t);}(r,t);}}function bk(e){return ()=>{const{state:t}=e;jS.RemoteCommunication("[RemoteCommunication: handleSocketReconnectEvent()] on 'socket_reconnect' -- reset key exchange status / set ready to false"),t.ready=false,t.authorized=false,VE(t),e.emitServiceStatusEvent({context:"socket_reconnect"});}}function yk(e){return ()=>{const{state:t}=e;jS.RemoteCommunication("[RemoteCommunication: handleSocketDisconnectedEvent()] on 'socket_Disconnected' set ready to false"),t.ready=false;}}function wk(t){return ()=>nS(this,void 0,void 0,(function*(){var n,r,i,o,a,s,u;const{state:l}=t;jS.RemoteCommunication(`[RemoteCommunication: handleFullPersistenceEvent()] context=${l.context}`),t.state.ready=true,t.state.clientsConnected=true,t.state.authorized=true,t.state.relayPersistence=true,null===(n=t.state.communicationLayer)||void 0===n||n.getKeyExchange().setKeysExchanged(true),t.emit(e.EventType.KEYS_EXCHANGED,{keysExchanged:true,isOriginator:true}),t.emit(e.EventType.AUTHORIZED),t.emit(e.EventType.CLIENTS_READY),t.emit(e.EventType.CHANNEL_PERSISTENCE);try{l.channelConfig=Object.assign(Object.assign({},l.channelConfig),{localKey:null===(r=l.communicationLayer)||void 0===r?void 0:r.getKeyExchange().getKeyInfo().ecies.private,otherKey:null===(i=l.communicationLayer)||void 0===i?void 0:i.getKeyExchange().getOtherPublicKey(),channelId:null!==(o=l.channelId)&&void 0!==o?o:"",validUntil:null!==(s=null===(a=l.channelConfig)||void 0===a?void 0:a.validUntil)&&void 0!==s?s:HE,relayPersistence:!0}),yield null===(u=l.storageManager)||void 0===u?void 0:u.persistChannelConfig(l.channelConfig);}catch(e){console.error("Error persisting channel config",e);}}))}function _k({communicationLayerPreference:t,otherPublicKey:n,reconnect:r,ecies:i,communicationServerUrl:o=KE,instance:a}){var s,u,l,c,d,f,h,p,m,g,v;const{state:b}=a;if(jS.RemoteCommunication("[initCommunicationLayer()] ",JSON.stringify(b,null,2)),t!==e.CommunicationLayerPreference.SOCKET)throw new Error("Invalid communication protocol");b.communicationLayer=new lk({communicationLayerPreference:t,otherPublicKey:n,reconnect:r,transports:b.transports,communicationServerUrl:o,context:b.context,ecies:i,logging:b.logging,remote:a});let y="undefined"!=typeof document&&document.URL||"",w="undefined"!=typeof document&&document.title||"";(null===(s=b.dappMetadata)||void 0===s?void 0:s.url)&&(y=b.dappMetadata.url),(null===(u=b.dappMetadata)||void 0===u?void 0:u.name)&&(w=b.dappMetadata.name);const _=null!==(f=null!==(c=null===(l=b.dappMetadata)||void 0===l?void 0:l.name)&&void 0!==c?c:null===(d=b.dappMetadata)||void 0===d?void 0:d.url)&&void 0!==f?f:"N/A",S="undefined"!=typeof window&&void 0!==window.location&&null!==(h=window.location.hostname)&&void 0!==h?h:_,E={url:y,title:w,source:null===(p=b.dappMetadata)||void 0===p?void 0:p.source,dappId:S,icon:(null===(m=b.dappMetadata)||void 0===m?void 0:m.iconUrl)||(null===(g=b.dappMetadata)||void 0===g?void 0:g.base64Icon),platform:b.platformType,apiVersion:FE.version,connector:null===(v=b.dappMetadata)||void 0===v?void 0:v.connector};b.originatorInfo=E;const k={[e.EventType.AUTHORIZED]:dk(a),[e.EventType.MESSAGE]:vk(a),[e.EventType.CHANNEL_PERSISTENCE]:wk(a),[e.EventType.CLIENTS_CONNECTED]:hk(a,t),[e.EventType.KEYS_EXCHANGED]:gk(a,t),[e.EventType.SOCKET_DISCONNECTED]:yk(a),[e.EventType.SOCKET_RECONNECT]:bk(a),[e.EventType.CLIENTS_DISCONNECTED]:pk(a),[e.EventType.KEY_INFO]:()=>{},[e.EventType.CHANNEL_CREATED]:fk(a),[e.EventType.CLIENTS_WAITING]:mk(a),[e.EventType.RPC_UPDATE]:t=>{a.emit(e.EventType.RPC_UPDATE,t);}};for(const[e,t]of Object.entries(k))try{b.communicationLayer.on(e,t);}catch(n){console.error(`Error registering handler for ${e}:`,n);}}function Sk({options:t,instance:n}){return nS(this,void 0,void 0,(function*(){const{state:r}=n;return jS.RemoteCommunication(`[RemoteCommunication: disconnect()] channel=${r.channelId}`,t),new Promise(((i,o)=>{var a,s,u,l,c,d;(null==t?void 0:t.terminate)?(n.state.ready&&KS({id:null!==(a=n.state.channelId)&&void 0!==a?a:"",event:ZE.TERMINATED},n.state.communicationServerUrl).catch((e=>{console.error("[handleSendMessage] Cannot send analytics",e);})),r.ready=false,r.paused=false,null===(s=r.storageManager)||void 0===s||s.terminate(null!==(u=r.channelId)&&void 0!==u?u:""),n.state.terminated=true,t.sendMessage?(null===(l=r.communicationLayer)||void 0===l?void 0:l.getKeyInfo().keysExchanged)&&n.state.communicationLayer&&nk(n.state.communicationLayer,{type:e.MessageType.TERMINATE}).then((()=>{console.warn("[disconnect] Terminate message sent to the other peer"),i(true);})).catch((e=>{o(e);})):i(true),r.authorized=false,r.relayPersistence=false,r.channelId=Ow(),t.channelId=r.channelId,r.channelConfig=void 0,r.originatorConnectStarted=false,null===(c=r.communicationLayer)||void 0===c||c.disconnect(t),n.setConnectionStatus(e.ConnectionStatus.TERMINATED)):(null===(d=r.communicationLayer)||void 0===d||d.disconnect(t),n.setConnectionStatus(e.ConnectionStatus.DISCONNECTED),i(true));}))}))}e.CommunicationLayerPreference=void 0,e.PlatformType=void 0,function(e){e.SOCKET="socket";}(e.CommunicationLayerPreference||(e.CommunicationLayerPreference={})),function(e){e.NonBrowser="nodejs",e.MetaMaskMobileWebview="in-app-browser",e.DesktopWeb="web-desktop",e.MobileWeb="web-mobile",e.ReactNative="react-native";}(e.PlatformType||(e.PlatformType={}));class Ek extends xw.EventEmitter2{constructor(t){super(),this.state={ready:false,authorized:false,isOriginator:false,terminated:false,protocolVersion:1,paused:false,deeplinkProtocolAvailable:false,platformType:"metamask-mobile",analytics:false,reconnection:false,originatorInfoSent:false,communicationServerUrl:KE,context:"",persist:false,clientsConnected:false,sessionDuration:HE,originatorConnectStarted:false,debug:false,_connectionStatus:e.ConnectionStatus.DISCONNECTED},this._options=t;const{platformType:n,communicationLayerPreference:r,otherPublicKey:i,reconnect:o,walletInfo:a,dappMetadata:s,protocolVersion:u,transports:l,context:c,relayPersistence:d,ecies:f,analytics:h=false,storage:p,sdkVersion:m,communicationServerUrl:g=KE,logging:v,autoConnect:b={timeout:WE}}=t;this.state.otherPublicKey=i,this.state.dappMetadata=s,this.state.walletInfo=a,this.state.transports=l,this.state.platformType=n,this.state.analytics=h,this.state.protocolVersion=null!=u?u:1,this.state.isOriginator=!i,this.state.relayPersistence=d,this.state.communicationServerUrl=g,this.state.context=c,this.state.terminated=false,this.state.sdkVersion=m,this.setMaxListeners(50),this.setConnectionStatus(e.ConnectionStatus.DISCONNECTED),(null==p?void 0:p.duration)&&(this.state.sessionDuration=HE),this.state.storageOptions=p,this.state.autoConnectOptions=b,this.state.debug=true===(null==v?void 0:v.remoteLayer),true===(null==v?void 0:v.remoteLayer)&&LS.enable("RemoteCommunication:Layer"),true===(null==v?void 0:v.serviceLayer)&&LS.enable("SocketService:Layer"),true===(null==v?void 0:v.eciesLayer)&&LS.enable("ECIES:Layer"),true===(null==v?void 0:v.keyExchangeLayer)&&LS.enable("KeyExchange:Layer"),this.state.logging=v,(null==p?void 0:p.storageManager)&&(this.state.storageManager=p.storageManager),jS.RemoteCommunication(`[RemoteCommunication: constructor()] protocolVersion=${u} relayPersistence=${d} isOriginator=${this.state.isOriginator} communicationLayerPreference=${r} otherPublicKey=${i} reconnect=${o}`),this.state.isOriginator||_k({communicationLayerPreference:r,otherPublicKey:i,reconnect:o,ecies:f,communicationServerUrl:g,instance:this}),this.emitServiceStatusEvent({context:"constructor"});}initFromDappStorage(){var t;return nS(this,void 0,void 0,(function*(){if(this.state.storageManager){const n=yield this.state.storageManager.getPersistedChannelConfig({});n&&(this.state.channelConfig=n,this.state.channelId=n.channelId,this.state.deeplinkProtocolAvailable=null!==(t=n.deeplinkProtocolAvailable)&&void 0!==t&&t,n.relayPersistence&&(this.state.authorized=true,this.state.ready=true,this.setConnectionStatus(e.ConnectionStatus.LINKED),yield this.connectToChannel({channelId:n.channelId})));}_k({communicationLayerPreference:e.CommunicationLayerPreference.SOCKET,otherPublicKey:this.state.otherPublicKey,reconnect:this._options.reconnect,ecies:this._options.ecies,communicationServerUrl:this.state.communicationServerUrl,instance:this});}))}originatorSessionConnect(){return nS(this,void 0,void 0,(function*(){return yield function(e){var t;return nS(this,void 0,void 0,(function*(){const{state:n}=e;if(!n.storageManager)return void jS.RemoteCommunication("[RemoteCommunication: originatorSessionConnect()] no storage manager defined - skip");const r=yield n.storageManager.getPersistedChannelConfig({});if(jS.RemoteCommunication(`[RemoteCommunication: originatorSessionConnect()] autoStarted=${n.originatorConnectStarted} channelConfig`,r),null===(t=n.communicationLayer)||void 0===t?void 0:t.isConnected())return jS.RemoteCommunication("[RemoteCommunication: originatorSessionConnect()] socket already connected - skip"),r;if(r){if(r.validUntil>Date.now())return n.channelConfig=r,n.originatorConnectStarted=true,n.channelId=null==r?void 0:r.channelId,n.reconnection=true,r;jS.RemoteCommunication("[RemoteCommunication: autoConnect()] Session has expired");}n.originatorConnectStarted=false;}))}(this)}))}generateChannelIdConnect(){return nS(this,void 0,void 0,(function*(){return function(e){var t,n,r,i,o,a;return nS(this,void 0,void 0,(function*(){if(!e.communicationLayer)throw new Error("communication layer not initialized");if(e.ready)throw new Error("Channel already connected");if(e.channelId&&(null===(t=e.communicationLayer)||void 0===t?void 0:t.isConnected()))return e.channelConfig=Object.assign(Object.assign({},e.channelConfig),{channelId:e.channelId,validUntil:Date.now()+e.sessionDuration}),null===(n=e.storageManager)||void 0===n||n.persistChannelConfig(e.channelConfig),{channelId:e.channelId,privKey:null===(i=null===(r=e.communicationLayer)||void 0===r?void 0:r.getKeyInfo())||void 0===i?void 0:i.ecies.private,pubKey:null===(a=null===(o=e.communicationLayer)||void 0===o?void 0:o.getKeyInfo())||void 0===a?void 0:a.ecies.public};jS.RemoteCommunication("[RemoteCommunication: generateChannelId()]");const s=yield e.communicationLayer.createChannel();jS.RemoteCommunication("[RemoteCommunication: generateChannelId()] channel created",s);const u=Object.assign(Object.assign({},e.channelConfig),{channelId:s.channelId,localKey:s.privKey,validUntil:Date.now()+e.sessionDuration});return e.channelId=s.channelId,e.channelConfig=u,{channelId:e.channelId,pubKey:s.pubKey,privKey:s.privKey}}))}(this.state)}))}clean(){return VE(this.state)}connectToChannel({channelId:e,withKeyExchange:t,authorized:n}){return function({channelId:e,withKeyExchange:t,authorized:n,state:r}){var i,o,a;return nS(this,void 0,void 0,(function*(){if(!Pw(e))throw jS.RemoteCommunication(`[RemoteCommunication: connectToChannel()] context=${r.context} invalid channel channelId=${e}`),new Error(`Invalid channel ${e}`);if(jS.RemoteCommunication(`[RemoteCommunication: connectToChannel()] context=${r.context} channelId=${e} withKeyExchange=${t}`),null===(i=r.communicationLayer)||void 0===i?void 0:i.isConnected())return void jS.RemoteCommunication(`[RemoteCommunication: connectToChannel()] context=${r.context} already connected - interrupt connection.`);r.channelId=e,yield null===(o=r.communicationLayer)||void 0===o?void 0:o.connectToChannel({channelId:e,authorized:n,withKeyExchange:t});const s=Object.assign(Object.assign({},r.channelConfig),{channelId:e,validUntil:Date.now()+r.sessionDuration});r.channelConfig=s,null===(a=r.storageManager)||void 0===a||a.persistChannelConfig(s);}))}({channelId:e,authorized:n,withKeyExchange:t,state:this.state})}sendMessage(t){return function(t,n){var r,i;return nS(this,void 0,void 0,(function*(){const{state:o}=t;jS.RemoteCommunication(`[RemoteCommunication: sendMessage()] context=${o.context} paused=${o.paused} ready=${o.ready} relayPersistence=${o.relayPersistence} authorized=${o.authorized} socket=${null===(r=o.communicationLayer)||void 0===r?void 0:r.isConnected()} clientsConnected=${o.clientsConnected} status=${o._connectionStatus}`,n),o.relayPersistence||o.ready&&(null===(i=o.communicationLayer)||void 0===i?void 0:i.isConnected())&&o.clientsConnected||(jS.RemoteCommunication(`[RemoteCommunication: sendMessage()] context=${o.context}  SKIP message waiting for MM mobile readiness.`),yield new Promise((n=>{t.once(e.EventType.CLIENTS_READY,n);})),jS.RemoteCommunication(`[RemoteCommunication: sendMessage()] context=${o.context}  AFTER SKIP / READY -- sending pending message`));try{const r=yield function(t,n){return nS(this,void 0,void 0,(function*(){return new Promise((r=>{var i;const{state:o}=t;jS.RemoteCommunication(`[RemoteCommunication: handleAuthorization()] context=${o.context} ready=${o.ready} authorized=${o.authorized} method=${n.method}`),!o.isOriginator||o.authorized||o.relayPersistence?null===(i=o.communicationLayer)||void 0===i||i.sendMessage(n).then((e=>{r(e);})).catch((e=>{console.error(`[RemoteCommunication: handleAuthorization()] context=${o.context}  ERROR`,e),r(!1);})):t.once(e.EventType.AUTHORIZED,(()=>{var e;jS.RemoteCommunication(`[RemoteCommunication: handleAuthorization()] context=${o.context}  AFTER SKIP / AUTHORIZED -- sending pending message`),null===(e=o.communicationLayer)||void 0===e||e.sendMessage(n).then((e=>{r(e);})).catch((e=>{console.error(`[RemoteCommunication: handleAuthorization()] context=${o.context}  ERROR`,e),r(!1);}));}));}))}))}(t,n);return r}catch(e){throw console.error(`[RemoteCommunication: sendMessage()] context=${o.context}  ERROR`,e),e}}))}(this,t)}testStorage(){return nS(this,void 0,void 0,(function*(){return function(e){var t;return nS(this,void 0,void 0,(function*(){const n=yield null===(t=e.storageManager)||void 0===t?void 0:t.getPersistedChannelConfig();jS.RemoteCommunication("[RemoteCommunication: testStorage()] res",n);}))}(this.state)}))}hasDeeplinkProtocol(){return this.state.deeplinkProtocolAvailable}getChannelConfig(){return this.state.channelConfig}isReady(){return this.state.ready}isConnected(){var e;return null===(e=this.state.communicationLayer)||void 0===e?void 0:e.isConnected()}isAuthorized(){return this.state.authorized}isPaused(){return this.state.paused}getCommunicationLayer(){return this.state.communicationLayer}ping(){var e;return nS(this,void 0,void 0,(function*(){jS.RemoteCommunication(`[RemoteCommunication: ping()] channel=${this.state.channelId}`),yield null===(e=this.state.communicationLayer)||void 0===e?void 0:e.ping();}))}testLogger(){jS.RemoteCommunication(`testLogger() channel=${this.state.channelId}`),jS.SocketService(`testLogger() channel=${this.state.channelId}`),jS.Ecies(`testLogger() channel=${this.state.channelId}`),jS.KeyExchange(`testLogger() channel=${this.state.channelId}`);}keyCheck(){var e;jS.RemoteCommunication(`[RemoteCommunication: keyCheck()] channel=${this.state.channelId}`),null===(e=this.state.communicationLayer)||void 0===e||e.keyCheck();}setConnectionStatus(t){this.state._connectionStatus!==t&&(this.state._connectionStatus=t,this.emit(e.EventType.CONNECTION_STATUS,t),this.emitServiceStatusEvent({context:"setConnectionStatus"}));}emitServiceStatusEvent(t={}){this.emit(e.EventType.SERVICE_STATUS,this.getServiceStatus());}getConnectionStatus(){return this.state._connectionStatus}getServiceStatus(){return {originatorInfo:this.state.originatorInfo,keyInfo:this.getKeyInfo(),connectionStatus:this.state._connectionStatus,channelConfig:this.state.channelConfig,channelId:this.state.channelId}}getKeyInfo(){var e;return null===(e=this.state.communicationLayer)||void 0===e?void 0:e.getKeyInfo()}resetKeys(){var e;null===(e=this.state.communicationLayer)||void 0===e||e.resetKeys();}setOtherPublicKey(e){var t;const n=null===(t=this.state.communicationLayer)||void 0===t?void 0:t.getKeyExchange();if(!n)throw new Error("KeyExchange is not initialized.");n.getOtherPublicKey()!==e&&n.setOtherPublicKey(e);}pause(){var t;return nS(this,void 0,void 0,(function*(){jS.RemoteCommunication(`[RemoteCommunication: pause()] channel=${this.state.channelId}`),yield null===(t=this.state.communicationLayer)||void 0===t?void 0:t.pause(),this.setConnectionStatus(e.ConnectionStatus.PAUSED);}))}getVersion(){return FE.version}hasRelayPersistence(){var e;return null!==(e=this.state.relayPersistence)&&void 0!==e&&e}resume(){return nS(this,void 0,void 0,(function*(){return function(t){var n;return nS(this,void 0,void 0,(function*(){const{state:r}=t;jS.RemoteCommunication(`[RemoteCommunication: resume()] channel=${r.channelId}`),yield null===(n=r.communicationLayer)||void 0===n?void 0:n.resume(),t.setConnectionStatus(e.ConnectionStatus.LINKED);}))}(this)}))}encrypt(e){var t,n,r;const i=null===(t=this.state.communicationLayer)||void 0===t?void 0:t.getKeyExchange(),o=null==i?void 0:i.getOtherPublicKey();if(!o)throw new Error("KeyExchange not completed");return null===(r=null===(n=this.state.communicationLayer)||void 0===n?void 0:n.state.eciesInstance)||void 0===r?void 0:r.encrypt(e,o)}decrypt(e){var t,n,r;if(!(null===(t=this.state.communicationLayer)||void 0===t?void 0:t.state.eciesInstance))throw new Error("ECIES instance is not initialized");return null===(r=null===(n=this.state.communicationLayer)||void 0===n?void 0:n.state.eciesInstance)||void 0===r?void 0:r.decrypt(e)}getChannelId(){return this.state.channelId}getRPCMethodTracker(){var e;return null===(e=this.state.communicationLayer)||void 0===e?void 0:e.getRPCMethodTracker()}reject({channelId:t}){return function({channelId:t,state:n}){var r,i,o;return nS(this,void 0,void 0,(function*(){if(!Pw(t))throw jS.RemoteCommunication(`[RemoteCommunication: connectToChannel()] context=${n.context} invalid channel channelId=${t}`),new Error(`Invalid channel ${t}`);if(n.isOriginator)return void jS.RemoteCommunication(`[RemoteCommunication: reject()] context=${n.context} isOriginator=${n.isOriginator} channelId=${t}`);const{socket:a}=null!==(i=null===(r=n.communicationLayer)||void 0===r?void 0:r.state)&&void 0!==i?i:{};(null==a?void 0:a.connected)||(jS.RemoteCommunication(`[RemoteCommunication: reject()] context=${n.context} socket already connected`),null==a||a.connect()),KS(Object.assign(Object.assign({id:t,event:ZE.REJECTED},n.originatorInfo),{sdkVersion:n.sdkVersion,commLayerVersion:FE.version,walletVersion:null===(o=n.walletInfo)||void 0===o?void 0:o.version}),n.communicationServerUrl).catch((e=>{console.error("rejectChannel:: Error emitting analytics event",e);})),yield new Promise(((r,i)=>{null==a||a.emit(e.EventType.REJECTED,{channelId:t},((e,t)=>{jS.RemoteCommunication(`[RemoteCommunication: reject()] context=${n.context} socket=${null==a?void 0:a.id}`,{error:e,response:t}),e?i(e):r(t);}));}));}))}({channelId:t,state:this.state})}disconnect(e){return nS(this,void 0,void 0,(function*(){return Sk({options:e,instance:this})}))}}function kk(e,t,n,r){return new(n||(n=Promise))((function(i,o){function a(e){try{u(r.next(e));}catch(e){o(e);}}function s(e){try{u(r.throw(e));}catch(e){o(e);}}function u(e){e.done?i(e.value):function(e){return e instanceof n?e:new n((function(t){t(e);}))}(e.value).then(a,s);}u((r=r.apply(e,[])).next());}))}function Mk(e,t,n,r){if("function"==typeof t?e!==t||true:!t.has(e))throw new TypeError("Cannot read private member from an object whose class did not declare it");return t.get(e)}function Ck(e,t,n,r,i){if("function"==typeof t?e!==t||true:!t.has(e))throw new TypeError("Cannot write private member to an object whose class did not declare it");return t.set(e,n),n}!function(e){e.RENEW="renew",e.LINK="link";}(ck||(ck={})),"function"==typeof SuppressedError&&SuppressedError;var xk="ERC721",Ak="ERC1155",Rk={errors:{disconnected:()=>"MetaMask: Disconnected from chain. Attempting to connect.",permanentlyDisconnected:()=>"MetaMask: Disconnected from MetaMask background. Page reload required.",sendSiteMetadata:()=>"MetaMask: Failed to send site metadata. This is an internal error, please report this bug.",unsupportedSync:e=>`MetaMask: The MetaMask Ethereum provider does not support synchronous methods like ${e} without a callback parameter.`,invalidDuplexStream:()=>"Must provide a Node.js-style duplex stream.",invalidNetworkParams:()=>"MetaMask: Received invalid network parameters. Please report this bug.",invalidRequestArgs:()=>"Expected a single, non-array, object argument.",invalidRequestMethod:()=>"'args.method' must be a non-empty string.",invalidRequestParams:()=>"'args.params' must be an object or array if provided.",invalidLoggerObject:()=>"'args.logger' must be an object if provided.",invalidLoggerMethod:e=>`'args.logger' must include required method '${e}'.`},info:{connected:e=>`MetaMask: Connected to chain with ID "${e}".`},warnings:{chainIdDeprecation:"MetaMask: 'ethereum.chainId' is deprecated and may be removed in the future. Please use the 'eth_chainId' RPC method instead.\nFor more information, see: https://github.com/MetaMask/metamask-improvement-proposals/discussions/23",networkVersionDeprecation:"MetaMask: 'ethereum.networkVersion' is deprecated and may be removed in the future. Please use the 'net_version' RPC method instead.\nFor more information, see: https://github.com/MetaMask/metamask-improvement-proposals/discussions/23",selectedAddressDeprecation:"MetaMask: 'ethereum.selectedAddress' is deprecated and may be removed in the future. Please use the 'eth_accounts' RPC method instead.\nFor more information, see: https://github.com/MetaMask/metamask-improvement-proposals/discussions/23",enableDeprecation:"MetaMask: 'ethereum.enable()' is deprecated and may be removed in the future. Please use the 'eth_requestAccounts' RPC method instead.\nFor more information, see: https://eips.ethereum.org/EIPS/eip-1102",sendDeprecation:"MetaMask: 'ethereum.send(...)' is deprecated and may be removed in the future. Please use 'ethereum.sendAsync(...)' or 'ethereum.request(...)' instead.\nFor more information, see: https://eips.ethereum.org/EIPS/eip-1193",events:{close:"MetaMask: The event 'close' is deprecated and may be removed in the future. Please use 'disconnect' instead.\nFor more information, see: https://eips.ethereum.org/EIPS/eip-1193#disconnect",data:"MetaMask: The event 'data' is deprecated and will be removed in the future. Use 'message' instead.\nFor more information, see: https://eips.ethereum.org/EIPS/eip-1193#message",networkChanged:"MetaMask: The event 'networkChanged' is deprecated and may be removed in the future. Use 'chainChanged' instead.\nFor more information, see: https://eips.ethereum.org/EIPS/eip-1193#chainchanged",notification:"MetaMask: The event 'notification' is deprecated and may be removed in the future. Use 'message' instead.\nFor more information, see: https://eips.ethereum.org/EIPS/eip-1193#message"},rpc:{ethDecryptDeprecation:"MetaMask: The RPC method 'eth_decrypt' is deprecated and may be removed in the future.\nFor more information, see: https://medium.com/metamask/metamask-api-method-deprecation-2b0564a84686",ethGetEncryptionPublicKeyDeprecation:"MetaMask: The RPC method 'eth_getEncryptionPublicKey' is deprecated and may be removed in the future.\nFor more information, see: https://medium.com/metamask/metamask-api-method-deprecation-2b0564a84686",walletWatchAssetNFTExperimental:"MetaMask: The RPC method 'wallet_watchAsset' is experimental for ERC721/ERC1155 assets and may change in the future.\nFor more information, see: https://github.com/MetaMask/metamask-improvement-proposals/blob/main/MIPs/mip-1.md and https://github.com/MetaMask/metamask-improvement-proposals/blob/main/PROCESS-GUIDE.md#proposal-lifecycle"},experimentalMethods:"MetaMask: 'ethereum._metamask' exposes non-standard, experimental methods. They may be removed or changed without warning."}},Tk=Rk;function Pk(e){const t={ethDecryptDeprecation:false,ethGetEncryptionPublicKeyDeprecation:false,walletWatchAssetNFTExperimental:false};return (n,r,i)=>{t.ethDecryptDeprecation||"eth_decrypt"!==n.method?t.ethGetEncryptionPublicKeyDeprecation||"eth_getEncryptionPublicKey"!==n.method?!t.walletWatchAssetNFTExperimental&&"wallet_watchAsset"===n.method&&[xk,Ak].includes(n.params?.type||"")&&(e.warn(Tk.warnings.rpc.walletWatchAssetNFTExperimental),t.walletWatchAssetNFTExperimental=true):(e.warn(Tk.warnings.rpc.ethGetEncryptionPublicKeyDeprecation),t.ethGetEncryptionPublicKeyDeprecation=true):(e.warn(Tk.warnings.rpc.ethDecryptDeprecation),t.ethDecryptDeprecation=true),i();}}var Lk=4294967295,Ik=Math.floor(Math.random()*Lk);function Ok(){return (e,t,n,r)=>{const i=e.id,o=Ik=(Ik+1)%Lk;e.id=o,t.id=o,n((n=>{e.id=i,t.id=i,n();}));}}var Nk=(e,t,n)=>{if(!t.has(e))throw TypeError("Cannot "+n)},Dk=(e,t,n)=>(Nk(e,t,"read from private field"),n?n.call(e):t.get(e)),jk=(e,t,n)=>{if(t.has(e))throw TypeError("Cannot add the same private member more than once");t instanceof WeakSet?t.add(e):t.set(e,n);},Bk=(e,t,n,r)=>(Nk(e,t,"write to private field"),t.set(e,n),n),zk=(e,t,n)=>(Nk(e,t,"access private method"),n),Uk={invalidInput:-32e3,resourceNotFound:-32001,resourceUnavailable:-32002,transactionRejected:-32003,methodNotSupported:-32004,limitExceeded:-32005,parse:-32700,invalidRequest:-32600,methodNotFound:-32601,invalidParams:-32602,internal:-32603},Fk={"-32700":{standard:"JSON RPC 2.0",message:"Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."},"-32600":{standard:"JSON RPC 2.0",message:"The JSON sent is not a valid Request object."},"-32601":{standard:"JSON RPC 2.0",message:"The method does not exist / is not available."},"-32602":{standard:"JSON RPC 2.0",message:"Invalid method parameter(s)."},"-32603":{standard:"JSON RPC 2.0",message:"Internal JSON-RPC error."},"-32000":{standard:"EIP-1474",message:"Invalid input."},"-32001":{standard:"EIP-1474",message:"Resource not found."},"-32002":{standard:"EIP-1474",message:"Resource unavailable."},"-32003":{standard:"EIP-1474",message:"Transaction rejected."},"-32004":{standard:"EIP-1474",message:"Method not supported."},"-32005":{standard:"EIP-1474",message:"Request limit exceeded."},4001:{standard:"EIP-1193",message:"User rejected the request."},4100:{standard:"EIP-1193",message:"The requested account and/or method has not been authorized by the user."},4200:{standard:"EIP-1193",message:"The requested method is not supported by this Ethereum provider."},4900:{standard:"EIP-1193",message:"The provider is disconnected from all chains."},4901:{standard:"EIP-1193",message:"The provider is disconnected from the specified chain."}};function Kk(e){return Boolean(e)&&"object"==typeof e&&!Array.isArray(e)}var qk=(e,t)=>Object.hasOwnProperty.call(e,t);class Hk extends TypeError{constructor(e,t){let n;const{message:r,explanation:i,...o}=e,{path:a}=e,s=0===a.length?r:`At path: ${a.join(".")} -- ${r}`;super(i??s),null!=i&&(this.cause=s),Object.assign(this,o),this.name=this.constructor.name,this.failures=()=>n??(n=[e,...t()]);}}function Wk(e){return "object"==typeof e&&null!=e}function $k(e){return "symbol"==typeof e?e.toString():"string"==typeof e?JSON.stringify(e):`${e}`}function Vk(e,t,n,r){if(true===e)return;false===e?e={}:"string"==typeof e&&(e={message:e});const{path:i,branch:o}=t,{type:a}=n,{refinement:s,message:u=`Expected a value of type \`${a}\`${s?` with refinement \`${s}\``:""}, but received: \`${$k(r)}\``}=e;return {value:r,type:a,refinement:s,key:i[i.length-1],path:i,branch:o,...e,message:u}}function*Yk(e,t,n,r){(function(e){return Wk(e)&&"function"==typeof e[Symbol.iterator]})(e)||(e=[e]);for(const i of e){const e=Vk(i,t,n,r);e&&(yield e);}}function*Gk(e,t,n={}){const{path:r=[],branch:i=[e],coerce:o=false,mask:a=false}=n,s={path:r,branch:i};if(o&&(e=t.coercer(e,s),a&&"type"!==t.type&&Wk(t.schema)&&Wk(e)&&!Array.isArray(e)))for(const n in e) void 0===t.schema[n]&&delete e[n];let u="valid";for(const r of t.validator(e,s))r.explanation=n.message,u="not_valid",yield [r,void 0];for(let[l,c,d]of t.entries(e,s)){const t=Gk(c,d,{path:void 0===l?r:[...r,l],branch:void 0===l?i:[...i,c],coerce:o,mask:a,message:n.message});for(const n of t)n[0]?(u=null!=n[0].refinement?"not_refined":"not_valid",yield [n[0],void 0]):o&&(c=n[1],void 0===l?e=c:e instanceof Map?e.set(l,c):e instanceof Set?e.add(c):Wk(e)&&(void 0!==c||l in e)&&(e[l]=c));}if("not_valid"!==u)for(const r of t.refiner(e,s))r.explanation=n.message,u="not_refined",yield [r,void 0];"valid"===u&&(yield [void 0,e]);}class Zk{constructor(e){const{type:t,schema:n,validator:r,refiner:i,coercer:o=(e=>e),entries:a=function*(){}}=e;this.type=t,this.schema=n,this.entries=a,this.coercer=o,this.validator=r?(e,t)=>Yk(r(e,t),t,this,e):()=>[],this.refiner=i?(e,t)=>Yk(i(e,t),t,this,e):()=>[];}assert(e,t){return Qk(e,this,t)}create(e,t){return Jk(e,this,t)}is(e){return Xk(e,this)}mask(e,t){return function(e,t,n){const r=eM(e,t,{coerce:true,mask:true,message:n});if(r[0])throw r[0];return r[1]}(e,this,t)}validate(e,t={}){return eM(e,this,t)}}function Qk(e,t,n){const r=eM(e,t,{message:n});if(r[0])throw r[0]}function Jk(e,t,n){const r=eM(e,t,{coerce:true,message:n});if(r[0])throw r[0];return r[1]}function Xk(e,t){return !eM(e,t)[0]}function eM(e,t,n={}){const r=Gk(e,t,n),i=function(e){const{done:t,value:n}=e.next();return t?void 0:n}(r);if(i[0]){return [new Hk(i[0],(function*(){for(const e of r)e[0]&&(yield e[0]);})),void 0]}return [void 0,i[1]]}function tM(e,t){return new Zk({type:e,schema:null,validator:t})}function nM(e){let t;return new Zk({type:"lazy",schema:null,*entries(n,r){t??(t=e()),yield*t.entries(n,r);},validator:(n,r)=>(t??(t=e()),t.validator(n,r)),coercer:(n,r)=>(t??(t=e()),t.coercer(n,r)),refiner:(n,r)=>(t??(t=e()),t.refiner(n,r))})}function rM(e){return new Zk({type:"array",schema:e,*entries(t){if(e&&Array.isArray(t))for(const[n,r]of t.entries())yield [n,r,e];},coercer:e=>Array.isArray(e)?e.slice():e,validator:e=>Array.isArray(e)||`Expected an array value, but received: ${$k(e)}`})}function iM(e){const t=$k(e),n=typeof e;return new Zk({type:"literal",schema:"string"===n||"number"===n||"boolean"===n?e:null,validator:n=>n===e||`Expected the literal \`${t}\`, but received: ${$k(n)}`})}function oM(){return tM("number",(e=>"number"==typeof e&&!isNaN(e)||`Expected a number, but received: ${$k(e)}`))}function aM(e){const t=e?Object.keys(e):[],n=tM("never",(()=>false));return new Zk({type:"object",schema:e||null,*entries(r){if(e&&Wk(r)){const i=new Set(Object.keys(r));for(const n of t)i.delete(n),yield [n,r[n],e[n]];for(const e of i)yield [e,r[e],n];}},validator:e=>Wk(e)||`Expected an object, but received: ${$k(e)}`,coercer:e=>Wk(e)?{...e}:e})}function sM(e){return new Zk({...e,validator:(t,n)=>void 0===t||e.validator(t,n),refiner:(t,n)=>void 0===t||e.refiner(t,n)})}function uM(e,t){return new Zk({type:"record",schema:null,*entries(n){if(Wk(n))for(const r in n){const i=n[r];yield [r,r,e],yield [r,i,t];}},validator:e=>Wk(e)||`Expected an object, but received: ${$k(e)}`})}function lM(){return tM("string",(e=>"string"==typeof e||`Expected a string, but received: ${$k(e)}`))}function cM(e){const t=e.map((e=>e.type)).join(" | ");return new Zk({type:"union",schema:null,coercer(t){for(const n of e){const[e,r]=n.validate(t,{coerce:true});if(!e)return r}return t},validator(n,r){const i=[];for(const t of e){const[...e]=Gk(n,t,r),[o]=e;if(!o[0])return [];for(const[t]of e)t&&i.push(t);}return [`Expected the value to satisfy a union of \`${t}\`, but received: ${$k(n)}`,...i]}})}function dM(e){return function(e){return function(e){return "object"==typeof e&&null!==e&&"message"in e}(e)&&"string"==typeof e.message?e.message:function(e){return null==e}(e)?"":String(e)}(e).replace(/\.$/u,"")}function fM(e,t){return n=e,Boolean("string"==typeof n?.prototype?.constructor?.name)?new e({message:t}):e({message:t});var n;}var hM=class extends Error{constructor(e){super(e.message),this.code="ERR_ASSERTION";}};var pM=e=>aM(e);function mM({path:e,branch:t}){const n=e[e.length-1];return qk(t[t.length-2],n)}function gM(e){return new Zk({...e,type:`optional ${e.type}`,validator:(t,n)=>!mM(n)||e.validator(t,n),refiner:(t,n)=>!mM(n)||e.refiner(t,n)})}var vM,bM,yM,wM=cM([iM(null),tM("boolean",(e=>"boolean"==typeof e)),tM("finite number",(e=>Xk(e,oM())&&Number.isFinite(e))),lM(),rM(nM((()=>wM))),uM(lM(),nM((()=>wM)))]),_M=(vM=wM,bM=tM("any",(()=>true)),yM=e=>(function(e,t,n="Assertion failed",r=hM){try{Qk(e,t);}catch(e){throw fM(r,`${n}: ${dM(e)}.`)}}(e,wM),JSON.parse(JSON.stringify(e,((e,t)=>{if("__proto__"!==e&&"constructor"!==e)return t})))),new Zk({...vM,coercer:(e,t)=>Xk(e,bM)?vM.coercer(yM(e,t),t):vM.coercer(e,t)}));function SM(e){try{return function(e){Jk(e,_M);}(e),!0}catch{return  false}}var EM=iM("2.0"),kM=function(e){return new Zk({...e,validator:(t,n)=>null===t||e.validator(t,n),refiner:(t,n)=>null===t||e.refiner(t,n)})}(cM([oM(),lM()])),MM=pM({code:tM("integer",(e=>"number"==typeof e&&!isNaN(e)&&Number.isInteger(e)||`Expected an integer, but received: ${$k(e)}`)),message:lM(),data:gM(_M),stack:gM(lM())}),CM=cM([uM(lM(),_M),rM(_M)]),xM=pM({id:kM,jsonrpc:EM,method:lM(),params:gM(CM)}),AM=pM({jsonrpc:EM,method:lM(),params:gM(CM)});function RM(e){return Xk(e,xM)}function TM(e){return Xk(e,MM)}aM({id:kM,jsonrpc:EM,result:sM(tM("unknown",(()=>true))),error:sM(MM)}),cM([pM({id:kM,jsonrpc:EM,result:_M}),pM({id:kM,jsonrpc:EM,error:MM})]);var PM,LM,IM={exports:{}};function OM(){if(LM)return PM;LM=1;var e=1e3,t=60*e,n=60*t,r=24*n,i=7*r,o=365.25*r;function a(e,t,n,r){var i=t>=1.5*n;return Math.round(e/n)+" "+r+(i?"s":"")}return PM=function(s,u){u=u||{};var l=typeof s;if("string"===l&&s.length>0)return function(a){if((a=String(a)).length>100)return;var s=/^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(a);if(!s)return;var u=parseFloat(s[1]);switch((s[2]||"ms").toLowerCase()){case "years":case "year":case "yrs":case "yr":case "y":return u*o;case "weeks":case "week":case "w":return u*i;case "days":case "day":case "d":return u*r;case "hours":case "hour":case "hrs":case "hr":case "h":return u*n;case "minutes":case "minute":case "mins":case "min":case "m":return u*t;case "seconds":case "second":case "secs":case "sec":case "s":return u*e;case "milliseconds":case "millisecond":case "msecs":case "msec":case "ms":return u;default:return}}(s);if("number"===l&&isFinite(s))return u.long?function(i){var o=Math.abs(i);if(o>=r)return a(i,o,r,"day");if(o>=n)return a(i,o,n,"hour");if(o>=t)return a(i,o,t,"minute");if(o>=e)return a(i,o,e,"second");return i+" ms"}(s):function(i){var o=Math.abs(i);if(o>=r)return Math.round(i/r)+"d";if(o>=n)return Math.round(i/n)+"h";if(o>=t)return Math.round(i/t)+"m";if(o>=e)return Math.round(i/e)+"s";return i+"ms"}(s);throw new Error("val is not a non-empty string or a valid number. val="+JSON.stringify(s))}}var NM=function(e){function t(e){let r,i,o,a=null;function s(...e){if(!s.enabled)return;const n=s,i=Number(new Date),o=i-(r||i);n.diff=o,n.prev=r,n.curr=i,r=i,e[0]=t.coerce(e[0]),"string"!=typeof e[0]&&e.unshift("%O");let a=0;e[0]=e[0].replace(/%([a-zA-Z%])/g,((r,i)=>{if("%%"===r)return "%";a++;const o=t.formatters[i];if("function"==typeof o){const t=e[a];r=o.call(n,t),e.splice(a,1),a--;}return r})),t.formatArgs.call(n,e);(n.log||t.log).apply(n,e);}return s.namespace=e,s.useColors=t.useColors(),s.color=t.selectColor(e),s.extend=n,s.destroy=t.destroy,Object.defineProperty(s,"enabled",{enumerable:true,configurable:false,get:()=>null!==a?a:(i!==t.namespaces&&(i=t.namespaces,o=t.enabled(e)),o),set:e=>{a=e;}}),"function"==typeof t.init&&t.init(s),s}function n(e,n){const r=t(this.namespace+(void 0===n?":":n)+e);return r.log=this.log,r}function r(e){return e.toString().substring(2,e.toString().length-2).replace(/\.\*\?$/,"*")}return t.debug=t,t.default=t,t.coerce=function(e){if(e instanceof Error)return e.stack||e.message;return e},t.disable=function(){const e=[...t.names.map(r),...t.skips.map(r).map((e=>"-"+e))].join(",");return t.enable(""),e},t.enable=function(e){let n;t.save(e),t.namespaces=e,t.names=[],t.skips=[];const r=("string"==typeof e?e:"").split(/[\s,]+/),i=r.length;for(n=0;n<i;n++)r[n]&&("-"===(e=r[n].replace(/\*/g,".*?"))[0]?t.skips.push(new RegExp("^"+e.slice(1)+"$")):t.names.push(new RegExp("^"+e+"$")));},t.enabled=function(e){if("*"===e[e.length-1])return  true;let n,r;for(n=0,r=t.skips.length;n<r;n++)if(t.skips[n].test(e))return  false;for(n=0,r=t.names.length;n<r;n++)if(t.names[n].test(e))return  true;return  false},t.humanize=OM(),t.destroy=function(){console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");},Object.keys(e).forEach((n=>{t[n]=e[n];})),t.names=[],t.skips=[],t.formatters={},t.selectColor=function(e){let n=0;for(let t=0;t<e.length;t++)n=(n<<5)-n+e.charCodeAt(t),n|=0;return t.colors[Math.abs(n)%t.colors.length]},t.enable(t.load()),t};!function(e,t){t.formatArgs=function(t){if(t[0]=(this.useColors?"%c":"")+this.namespace+(this.useColors?" %c":" ")+t[0]+(this.useColors?"%c ":" ")+"+"+e.exports.humanize(this.diff),!this.useColors)return;const n="color: "+this.color;t.splice(1,0,n,"color: inherit");let r=0,i=0;t[0].replace(/%[a-zA-Z%]/g,(e=>{"%%"!==e&&(r++,"%c"===e&&(i=r));})),t.splice(i,0,n);},t.save=function(e){try{e?t.storage.setItem("debug",e):t.storage.removeItem("debug");}catch(e){}},t.load=function(){let e;try{e=t.storage.getItem("debug");}catch(e){}!e&&void 0!==je&&"env"in je&&(e=je.env.DEBUG);return e},t.useColors=function(){if("undefined"!=typeof window&&window.process&&("renderer"===window.process.type||window.process.__nwjs))return  true;if("undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/))return  false;return "undefined"!=typeof document&&document.documentElement&&document.documentElement.style&&document.documentElement.style.WebkitAppearance||"undefined"!=typeof window&&window.console&&(window.console.firebug||window.console.exception&&window.console.table)||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)&&parseInt(RegExp.$1,10)>=31||"undefined"!=typeof navigator&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/)},t.storage=function(){try{return localStorage}catch(e){}}(),t.destroy=(()=>{let e=false;return ()=>{e||(e=true,console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."));}})(),t.colors=["#0000CC","#0000FF","#0033CC","#0033FF","#0066CC","#0066FF","#0099CC","#0099FF","#00CC00","#00CC33","#00CC66","#00CC99","#00CCCC","#00CCFF","#3300CC","#3300FF","#3333CC","#3333FF","#3366CC","#3366FF","#3399CC","#3399FF","#33CC00","#33CC33","#33CC66","#33CC99","#33CCCC","#33CCFF","#6600CC","#6600FF","#6633CC","#6633FF","#66CC00","#66CC33","#9900CC","#9900FF","#9933CC","#9933FF","#99CC00","#99CC33","#CC0000","#CC0033","#CC0066","#CC0099","#CC00CC","#CC00FF","#CC3300","#CC3333","#CC3366","#CC3399","#CC33CC","#CC33FF","#CC6600","#CC6633","#CC9900","#CC9933","#CCCC00","#CCCC33","#FF0000","#FF0033","#FF0066","#FF0099","#FF00CC","#FF00FF","#FF3300","#FF3333","#FF3366","#FF3399","#FF33CC","#FF33FF","#FF6600","#FF6633","#FF9900","#FF9933","#FFCC00","#FFCC33"],t.log=console.debug||console.log||(()=>{}),e.exports=NM(t);const{formatters:n}=e.exports;n.j=function(e){try{return JSON.stringify(e)}catch(e){return "[UnexpectedJSONParseError]: "+e.message}};}(IM,IM.exports);var DM=r(IM.exports),jM=Uk.internal,BM="Unspecified error message. This is a bug, please report it.",zM={code:jM,message:FM(jM)},UM="Unspecified server error.";function FM(e,t=BM){if(function(e){return Number.isInteger(e)}(e)){const t=e.toString();if(qk(Fk,t))return Fk[t].message;if(function(e){return e>=-32099&&e<=-32e3}(e))return UM}return t}function KM(e,{fallbackError:t=zM,shouldIncludeStack:n=true}={}){if(!TM(t))throw new Error("Must provide fallback error with integer number code and string message.");const r=function(e,t){if(e&&"object"==typeof e&&"serialize"in e&&"function"==typeof e.serialize)return e.serialize();if(TM(e))return e;const n=qM(e),r={...t,data:{cause:n}};return r}(e,t);return n||delete r.stack,r}function qM(e){return Array.isArray(e)?e.map((e=>SM(e)?e:Kk(e)?HM(e):null)):Kk(e)?HM(e):SM(e)?e:null}function HM(e){return Object.getOwnPropertyNames(e).reduce(((t,n)=>{const r=e[n];return SM(r)&&(t[n]=r),t}),{})}var WM=QM;QM.default=QM,QM.stable=tC,QM.stableStringify=tC;var $M="[...]",VM="[Circular]",YM=[],GM=[];function ZM(){return {depthLimit:Number.MAX_SAFE_INTEGER,edgesLimit:Number.MAX_SAFE_INTEGER}}function QM(e,t,n,r){var i;void 0===r&&(r=ZM()),XM(e,"",0,[],void 0,0,r);try{i=0===GM.length?JSON.stringify(e,t,n):JSON.stringify(e,rC(t),n);}catch(e){return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]")}finally{for(;0!==YM.length;){var o=YM.pop();4===o.length?Object.defineProperty(o[0],o[1],o[3]):o[0][o[1]]=o[2];}}return i}function JM(e,t,n,r){var i=Object.getOwnPropertyDescriptor(r,n);void 0!==i.get?i.configurable?(Object.defineProperty(r,n,{value:e}),YM.push([r,n,t,i])):GM.push([t,n,e]):(r[n]=e,YM.push([r,n,t]));}function XM(e,t,n,r,i,o,a){var s;if(o+=1,"object"==typeof e&&null!==e){for(s=0;s<r.length;s++)if(r[s]===e)return void JM(VM,e,t,i);if(void 0!==a.depthLimit&&o>a.depthLimit)return void JM($M,e,t,i);if(void 0!==a.edgesLimit&&n+1>a.edgesLimit)return void JM($M,e,t,i);if(r.push(e),Array.isArray(e))for(s=0;s<e.length;s++)XM(e[s],s,s,r,e,o,a);else {var u=Object.keys(e);for(s=0;s<u.length;s++){var l=u[s];XM(e[l],l,s,r,e,o,a);}}r.pop();}}function eC(e,t){return e<t?-1:e>t?1:0}function tC(e,t,n,r){ void 0===r&&(r=ZM());var i,o=nC(e,"",0,[],void 0,0,r)||e;try{i=0===GM.length?JSON.stringify(o,t,n):JSON.stringify(o,rC(t),n);}catch(e){return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]")}finally{for(;0!==YM.length;){var a=YM.pop();4===a.length?Object.defineProperty(a[0],a[1],a[3]):a[0][a[1]]=a[2];}}return i}function nC(e,t,n,r,i,o,a){var s;if(o+=1,"object"==typeof e&&null!==e){for(s=0;s<r.length;s++)if(r[s]===e)return void JM(VM,e,t,i);try{if("function"==typeof e.toJSON)return}catch(e){return}if(void 0!==a.depthLimit&&o>a.depthLimit)return void JM($M,e,t,i);if(void 0!==a.edgesLimit&&n+1>a.edgesLimit)return void JM($M,e,t,i);if(r.push(e),Array.isArray(e))for(s=0;s<e.length;s++)nC(e[s],s,s,r,e,o,a);else {var u={},l=Object.keys(e).sort(eC);for(s=0;s<l.length;s++){var c=l[s];nC(e[c],c,s,r,e,o,a),u[c]=e[c];}if(void 0===i)return u;YM.push([i,t,e]),i[t]=u;}r.pop();}}function rC(e){return e=void 0!==e?e:function(e,t){return t},function(t,n){if(GM.length>0)for(var r=0;r<GM.length;r++){var i=GM[r];if(i[1]===t&&i[0]===n){n=i[2],GM.splice(r,1);break}}return e.call(this,t,n)}}var iC=r(WM),oC=class extends Error{constructor(e,t,n){if(!Number.isInteger(e))throw new Error('"code" must be an integer.');if(!t||"string"!=typeof t)throw new Error('"message" must be a non-empty string.');super(t),this.code=e,void 0!==n&&(this.data=n);}serialize(){const e={code:this.code,message:this.message};return void 0!==this.data&&(e.data=this.data,function(e){if("object"!=typeof e||null===e)return  false;try{let t=e;for(;null!==Object.getPrototypeOf(t);)t=Object.getPrototypeOf(t);return Object.getPrototypeOf(e)===t}catch(e){return  false}}(this.data)&&(e.data.cause=qM(this.data.cause))),this.stack&&(e.stack=this.stack),e}toString(){return iC(this.serialize(),aC,2)}};function aC(e,t){if("[Circular]"!==t)return t}var sC=e=>uC(Uk.invalidRequest,e);function uC(e,t){const[n,r]=function(e){if(e){if("string"==typeof e)return [e];if("object"==typeof e&&!Array.isArray(e)){const{message:t,data:n}=e;if(t&&"string"!=typeof t)throw new Error("Must specify string message.");return [t??void 0,n]}}return []}(t);return new oC(e,n??FM(e),r)}var lC={};Object.defineProperty(lC,"__esModule",{value:true});const cC=nt;function dC(e,t,n){try{Reflect.apply(e,t,n);}catch(e){setTimeout((()=>{throw e}));}}let fC=class extends cC.EventEmitter{emit(e,...t){let n="error"===e;const r=this._events;if(void 0!==r)n=n&&void 0===r.error;else if(!n)return  false;if(n){let e;if(t.length>0&&([e]=t),e instanceof Error)throw e;const n=new Error("Unhandled error."+(e?` (${e.message})`:""));throw n.context=e,n}const i=r[e];if(void 0===i)return  false;if("function"==typeof i)dC(i,this,t);else {const e=i.length,n=function(e){const t=e.length,n=new Array(t);for(let r=0;r<t;r+=1)n[r]=e[r];return n}(i);for(let r=0;r<e;r+=1)dC(n[r],this,t);}return  true}};var hC,pC,mC,gC,vC,bC,yC,wC,_C,SC,EC,kC,MC,CC,xC,AC,RC,TC,PC,LC=lC.default=fC,IC=class e extends LC{constructor({notificationHandler:e}={}){super(),jk(this,gC),jk(this,bC),jk(this,wC),jk(this,hC,false),jk(this,pC,void 0),jk(this,mC,void 0),Bk(this,pC,[]),Bk(this,mC,e);}destroy(){Dk(this,pC).forEach((e=>{"destroy"in e&&"function"==typeof e.destroy&&e.destroy();})),Bk(this,pC,[]),Bk(this,hC,true);}push(e){zk(this,gC,vC).call(this),Dk(this,pC).push(e);}handle(e,t){if(zk(this,gC,vC).call(this),t&&"function"!=typeof t)throw new Error('"callback" must be a function if provided.');return Array.isArray(e)?t?zk(this,bC,yC).call(this,e,t):zk(this,bC,yC).call(this,e):t?zk(this,wC,_C).call(this,e,t):this._promiseHandle(e)}asMiddleware(){return zk(this,gC,vC).call(this),async(t,n,r,i)=>{var o,a;try{const[s,u,l]=await zk(o=e,kC,MC).call(o,t,n,Dk(this,pC));return u?(await zk(a=e,AC,RC).call(a,l),i(s)):r((async t=>{var n;try{await zk(n=e,AC,RC).call(n,l);}catch(e){return t(e)}return t()}))}catch(e){return i(e)}}}async _promiseHandle(e){return new Promise(((t,n)=>{zk(this,wC,_C).call(this,e,((e,r)=>{e&&void 0===r?n(e):t(r);})).catch(n);}))}};hC=new WeakMap,pC=new WeakMap,mC=new WeakMap,gC=new WeakSet,vC=function(){if(Dk(this,hC))throw new Error("This engine is destroyed and can no longer be used.")},bC=new WeakSet,yC=async function(e,t){try{if(0===e.length){const e=[{id:null,jsonrpc:"2.0",error:new oC(Uk.invalidRequest,"Request batch must contain plain objects. Received an empty array")}];return t?t(null,e):e}const n=(await Promise.all(e.map(this._promiseHandle.bind(this)))).filter((e=>void 0!==e));return t?t(null,n):n}catch(e){if(t)return t(e);throw e}},wC=new WeakSet,_C=async function(e,t){var n;if(!e||Array.isArray(e)||"object"!=typeof e){const n=new oC(Uk.invalidRequest,"Requests must be plain objects. Received: "+typeof e,{request:e});return t(n,{id:null,jsonrpc:"2.0",error:n})}if("string"!=typeof e.method){const n=new oC(Uk.invalidRequest,"Must specify a string method. Received: "+typeof e.method,{request:e});return Dk(this,mC)&&!RM(e)?t(null):t(n,{id:e.id??null,jsonrpc:"2.0",error:n})}if(Dk(this,mC)&&function(e){return Xk(e,AM)}(e)&&!RM(e)){try{await Dk(this,mC).call(this,e);}catch(e){return t(e)}return t(null)}let r=null;const i={...e},o={id:i.id,jsonrpc:i.jsonrpc};try{await zk(n=IC,SC,EC).call(n,i,o,Dk(this,pC));}catch(e){r=e;}return r&&(delete o.result,o.error||(o.error=KM(r))),t(r,o)},SC=new WeakSet,EC=async function(e,t,n){var r,i,o;const[a,s,u]=await zk(r=IC,kC,MC).call(r,e,t,n);if(zk(i=IC,TC,PC).call(i,e,t,s),await zk(o=IC,AC,RC).call(o,u),a)throw a},kC=new WeakSet,MC=async function(e,t,n){var r;const i=[];let o=null,a=false;for(const s of n)if([o,a]=await zk(r=IC,CC,xC).call(r,e,t,s,i),a)break;return [o,a,i.reverse()]},CC=new WeakSet,xC=async function(e,t,n,r){return new Promise((i=>{const o=e=>{const n=e||t.error;n&&(t.error=KM(n)),i([n,true]);},a=n=>{t.error?o(t.error):(n&&("function"!=typeof n&&o(new oC(Uk.internal,`JsonRpcEngine: "next" return handlers must be functions. Received "${typeof n}" for request:\n${NC(e)}`,{request:e})),r.push(n)),i([null,false]));};try{n(e,t,a,o);}catch(e){o(e);}}))},AC=new WeakSet,RC=async function(e){for(const t of e)await new Promise(((e,n)=>{t((t=>t?n(t):e()));}));},TC=new WeakSet,PC=function(e,t,n){if(!qk(t,"result")&&!qk(t,"error"))throw new oC(Uk.internal,`JsonRpcEngine: Response has no error or result for request:\n${NC(e)}`,{request:e});if(!n)throw new oC(Uk.internal,`JsonRpcEngine: Nothing ended request:\n${NC(e)}`,{request:e})},jk(IC,SC),jk(IC,kC),jk(IC,CC),jk(IC,AC),jk(IC,TC);var OC=IC;function NC(e){return JSON.stringify(e,null,2)}var DC=Object.freeze(["eth_subscription"]),jC=(e=console)=>[Ok(),BC(e),Pk(e)];function BC(e){return (t,n,r)=>{"string"==typeof t.method&&t.method||(n.error=sC({message:"The request 'method' must be a non-empty string.",data:t})),r((t=>{const{error:r}=n;return r?(e.error(`MetaMask - RPC Error: ${r.message}`,r),t()):t()}));}}var zC=(e,t,n=true)=>(r,i)=>{r||i.error?t(r||i.error):!n||Array.isArray(i)?e(i):e(i.result);},UC=e=>Boolean(e)&&"string"==typeof e&&e.startsWith("0x"),FC=()=>{};async function KC(e,t){try{const t=await async function(){return {name:qC(window),icon:await HC(window)}}();e.handle({jsonrpc:"2.0",id:1,method:"metamask_sendDomainMetadata",params:t},FC);}catch(e){t.error({message:Tk.errors.sendSiteMetadata(),originalError:e});}}function qC(e){const{document:t}=e,n=t.querySelector('head > meta[property="og:site_name"]');if(n)return n.content;const r=t.querySelector('head > meta[name="title"]');return r?r.content:t.title&&t.title.length>0?t.title:window.location.hostname}async function HC(e){const{document:t}=e,n=t.querySelectorAll('head > link[rel~="icon"]');for(const e of Array.from(n))if(e&&await WC(e.href))return e.href;return null}async function WC(e){return new Promise(((t,n)=>{try{const n=document.createElement("img");n.onload=()=>t(!0),n.onerror=()=>t(!1),n.src=e;}catch(e){n(e);}}))}var $C=(e,t,n)=>{if(!t.has(e))throw TypeError("Cannot "+n)},VC=(e,t,n)=>($C(e,t,"read from private field"),n?n.call(e):t.get(e)),YC=(e,t,n)=>{if(t.has(e))throw TypeError("Cannot add the same private member more than once");t instanceof WeakSet?t.add(e):t.set(e,n);},GC=(e,t,n,r)=>($C(e,t,"write to private field"),t.set(e,n),n);function ZC(e,t,n){try{Reflect.apply(e,t,n);}catch(e){setTimeout((()=>{throw e}));}}class QC extends Ze{emit(e,...t){let n="error"===e;const r=this._events;if(void 0!==r)n=n&&void 0===r.error;else if(!n)return  false;if(n){let e;if(t.length>0&&([e]=t),e instanceof Error)throw e;const n=new Error("Unhandled error."+(e?` (${e.message})`:""));throw n.context=e,n}const i=r[e];if(void 0===i)return  false;if("function"==typeof i)ZC(i,this,t);else {const e=i.length,n=function(e){const t=e.length,n=new Array(t);for(let r=0;r<t;r+=1)n[r]=e[r];return n}(i);for(let r=0;r<e;r+=1)ZC(n[r],this,t);}return  true}}var JC,XC,ex=function e(t,n){if(t===n)return  true;if(t&&n&&"object"==typeof t&&"object"==typeof n){if(t.constructor!==n.constructor)return  false;var r,i,o;if(Array.isArray(t)){if((r=t.length)!=n.length)return  false;for(i=r;0!=i--;)if(!e(t[i],n[i]))return  false;return  true}if(t.constructor===RegExp)return t.source===n.source&&t.flags===n.flags;if(t.valueOf!==Object.prototype.valueOf)return t.valueOf()===n.valueOf();if(t.toString!==Object.prototype.toString)return t.toString()===n.toString();if((r=(o=Object.keys(t)).length)!==Object.keys(n).length)return  false;for(i=r;0!=i--;)if(!Object.prototype.hasOwnProperty.call(n,o[i]))return  false;for(i=r;0!=i--;){var a=o[i];if(!e(t[a],n[a]))return  false}return  true}return t!=t&&n!=n},tx=r(ex),nx=class e extends QC{constructor({logger:t=console,maxEventListeners:n=100,rpcMiddleware:r=[]}={}){super(),YC(this,JC,void 0),YC(this,XC,void 0),this._log=t,this.setMaxListeners(n),this._state={...e._defaultState},GC(this,XC,null),GC(this,JC,null),this._handleAccountsChanged=this._handleAccountsChanged.bind(this),this._handleConnect=this._handleConnect.bind(this),this._handleChainChanged=this._handleChainChanged.bind(this),this._handleDisconnect=this._handleDisconnect.bind(this),this._handleUnlockStateChanged=this._handleUnlockStateChanged.bind(this),this._rpcRequest=this._rpcRequest.bind(this),this.request=this.request.bind(this);const i=new OC;r.forEach((e=>i.push(e))),this._rpcEngine=i;}get chainId(){return VC(this,JC)}get selectedAddress(){return VC(this,XC)}isConnected(){return this._state.isConnected}async request(e){if(!e||"object"!=typeof e||Array.isArray(e))throw sC({message:Tk.errors.invalidRequestArgs(),data:e});const{method:t,params:n}=e;if("string"!=typeof t||0===t.length)throw sC({message:Tk.errors.invalidRequestMethod(),data:e});if(void 0!==n&&!Array.isArray(n)&&("object"!=typeof n||null===n))throw sC({message:Tk.errors.invalidRequestParams(),data:e});const r=null==n?{method:t}:{method:t,params:n};return new Promise(((e,t)=>{this._rpcRequest(r,zC(e,t));}))}_initializeState(e){if(this._state.initialized)throw new Error("Provider already initialized.");if(e){const{accounts:t,chainId:n,isUnlocked:r,networkVersion:i}=e;this._handleConnect(n),this._handleChainChanged({chainId:n,networkVersion:i}),this._handleUnlockStateChanged({accounts:t,isUnlocked:r}),this._handleAccountsChanged(t);}this._state.initialized=true,this.emit("_initialized");}_rpcRequest(e,t){let n=t;return Array.isArray(e)||(e.jsonrpc||(e.jsonrpc="2.0"),"eth_accounts"!==e.method&&"eth_requestAccounts"!==e.method||(n=(n,r)=>{this._handleAccountsChanged(r.result??[],"eth_accounts"===e.method),t(n,r);})),this._rpcEngine.handle(e,n)}_handleConnect(e){this._state.isConnected||(this._state.isConnected=true,this.emit("connect",{chainId:e}),this._log.debug(Tk.info.connected(e)));}_handleDisconnect(e,t){if(this._state.isConnected||!this._state.isPermanentlyDisconnected&&!e){let n;this._state.isConnected=false,e?(n=new oC(1013,t??Tk.errors.disconnected()),this._log.debug(n)):(n=new oC(1011,t??Tk.errors.permanentlyDisconnected()),this._log.error(n),GC(this,JC,null),this._state.accounts=null,GC(this,XC,null),this._state.isUnlocked=false,this._state.isPermanentlyDisconnected=true),this.emit("disconnect",n);}}_handleChainChanged({chainId:e}={}){UC(e)?(this._handleConnect(e),e!==VC(this,JC)&&(GC(this,JC,e),this._state.initialized&&this.emit("chainChanged",VC(this,JC)))):this._log.error(Tk.errors.invalidNetworkParams(),{chainId:e});}_handleAccountsChanged(e,t=false){let n=e;Array.isArray(e)||(this._log.error("MetaMask: Received invalid accounts parameter. Please report this bug.",e),n=[]);for(const t of e)if("string"!=typeof t){this._log.error("MetaMask: Received non-string account. Please report this bug.",e),n=[];break}if(!tx(this._state.accounts,n)&&(t&&null!==this._state.accounts&&this._log.error("MetaMask: 'eth_accounts' unexpectedly updated accounts. Please report this bug.",n),this._state.accounts=n,VC(this,XC)!==n[0]&&GC(this,XC,n[0]||null),this._state.initialized)){const e=[...n];this.emit("accountsChanged",e);}}_handleUnlockStateChanged({accounts:e,isUnlocked:t}={}){"boolean"==typeof t?t!==this._state.isUnlocked&&(this._state.isUnlocked=t,this._handleAccountsChanged(e??[])):this._log.error("MetaMask: Received invalid isUnlocked parameter. Please report this bug.");}};JC=new WeakMap,XC=new WeakMap,nx._defaultState={accounts:null,isConnected:false,isUnlocked:false,initialized:false,isPermanentlyDisconnected:false};var rx=nx;function ix(e={}){const t={},n=new Hn.Duplex({objectMode:true,read:()=>{},write:function(n,o,a){let s=null;try{!n.id?function(n){e?.retryOnMessage&&n.method===e.retryOnMessage&&Object.values(t).forEach((({req:e,retryCount:n=0})=>{if(!e.id)return;if(n>=3)throw new Error(`StreamMiddleware - Retry limit exceeded for request id "${e.id}"`);const r=t[e.id];r&&(r.retryCount=n+1),i(e);}));r.emit("notification",n);}(n):function(e){const{id:n}=e;if(null===n)return;const r=t[n];if(!r)return void console.warn(`StreamMiddleware - Unknown response id "${n}"`);delete t[n],Object.assign(r.res,e),setTimeout(r.end);}(n);}catch(e){s=e;}a(s);}}),r=new LC;return {events:r,middleware:(e,n,r,o)=>{t[e.id]={req:e,res:n,next:r,end:o},i(e);},stream:n};function i(e){n.push(e);}}var ox={},ax={exports:{}},sx=function e(t,n){if(t&&n)return e(t)(n);if("function"!=typeof t)throw new TypeError("need wrapper function");return Object.keys(t).forEach((function(e){r[e]=t[e];})),r;function r(){for(var e=new Array(arguments.length),n=0;n<e.length;n++)e[n]=arguments[n];var r=t.apply(this,e),i=e[e.length-1];return "function"==typeof r&&r!==i&&Object.keys(i).forEach((function(e){r[e]=i[e];})),r}};var ux=sx;function lx(e){var t=function(){return t.called?t.value:(t.called=true,t.value=e.apply(this,arguments))};return t.called=false,t}function cx(e){var t=function(){if(t.called)throw new Error(t.onceError);return t.called=true,t.value=e.apply(this,arguments)},n=e.name||"Function wrapped with `once`";return t.onceError=n+" shouldn't be called more than once",t.called=false,t}ax.exports=ux(lx),ax.exports.strict=ux(cx),lx.proto=lx((function(){Object.defineProperty(Function.prototype,"once",{value:function(){return lx(this)},configurable:true}),Object.defineProperty(Function.prototype,"onceStrict",{value:function(){return cx(this)},configurable:true});}));var dx=ax.exports,fx={};Object.defineProperty(fx,"__esModule",{value:true}),fx.Substream=void 0;const hx=Hn;class px extends hx.Duplex{constructor({parent:e,name:t}){super({objectMode:true}),this._parent=e,this._name=t;}_read(){}_write(e,t,n){this._parent.push({name:this._name,data:e}),n();}}fx.Substream=px;var mx=n&&n.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(ox,"__esModule",{value:true}),ox.ObjectMultiplex=void 0;const gx=Hn,vx=mx(dx),bx=fx,yx=Symbol("IGNORE_SUBSTREAM");let wx=class extends gx.Duplex{constructor(e={}){super(Object.assign(Object.assign({},e),{objectMode:true})),this._substreams={};}createStream(e){if(this.destroyed)throw new Error(`ObjectMultiplex - parent stream for name "${e}" already destroyed`);if(this._readableState.ended||this._writableState.ended)throw new Error(`ObjectMultiplex - parent stream for name "${e}" already ended`);if(!e)throw new Error("ObjectMultiplex - name must not be empty");if(this._substreams[e])throw new Error(`ObjectMultiplex - Substream for name "${e}" already exists`);const t=new bx.Substream({parent:this,name:e});return this._substreams[e]=t,function(e,t){const n=(0, vx.default)(t);(0, gx.finished)(e,{readable:false},n),(0, gx.finished)(e,{writable:false},n);}(this,(e=>t.destroy(e||void 0))),t}ignoreStream(e){if(!e)throw new Error("ObjectMultiplex - name must not be empty");if(this._substreams[e])throw new Error(`ObjectMultiplex - Substream for name "${e}" already exists`);this._substreams[e]=yx;}_read(){}_write(e,t,n){const{name:r,data:i}=e;if(!r)return console.warn(`ObjectMultiplex - malformed chunk without name "${e}"`),n();const o=this._substreams[r];return o?(o!==yx&&o.push(i),n()):(console.warn(`ObjectMultiplex - orphaned data for stream "${r}"`),n())}};ox.ObjectMultiplex=wx;var _x=r(ox.ObjectMultiplex);const Sx=e=>null!==e&&"object"==typeof e&&"function"==typeof e.pipe;Sx.writable=e=>Sx(e)&&false!==e.writable&&"function"==typeof e._write&&"object"==typeof e._writableState,Sx.readable=e=>Sx(e)&&false!==e.readable&&"function"==typeof e._read&&"object"==typeof e._readableState,Sx.duplex=e=>Sx.writable(e)&&Sx.readable(e),Sx.transform=e=>Sx.duplex(e)&&"function"==typeof e._transform;var Ex,kx=Sx,Mx=class extends rx{constructor(e,{jsonRpcStreamName:t,logger:n=console,maxEventListeners:r=100,rpcMiddleware:i=[]}){if(super({logger:n,maxEventListeners:r,rpcMiddleware:i}),!kx.duplex(e))throw new Error(Tk.errors.invalidDuplexStream());this._handleStreamDisconnect=this._handleStreamDisconnect.bind(this);const o=new _x;Hn.pipeline(e,o,e,this._handleStreamDisconnect.bind(this,"MetaMask")),this._jsonRpcConnection=ix({retryOnMessage:"METAMASK_EXTENSION_CONNECT_CAN_RETRY"}),Hn.pipeline(this._jsonRpcConnection.stream,o.createStream(t),this._jsonRpcConnection.stream,this._handleStreamDisconnect.bind(this,"MetaMask RpcProvider")),this._rpcEngine.push(this._jsonRpcConnection.middleware),this._jsonRpcConnection.events.on("notification",(t=>{const{method:n,params:r}=t;"metamask_accountsChanged"===n?this._handleAccountsChanged(r):"metamask_unlockStateChanged"===n?this._handleUnlockStateChanged(r):"metamask_chainChanged"===n?this._handleChainChanged(r):DC.includes(n)?this.emit("message",{type:n,data:r}):"METAMASK_STREAM_FAILURE"===n&&e.destroy(new Error(Tk.errors.permanentlyDisconnected()));}));}async _initializeStateAsync(){let e;try{e=await this.request({method:"metamask_getProviderState"});}catch(e){this._log.error("MetaMask: Failed to get initial state. Please report this bug.",e);}this._initializeState(e);}_handleStreamDisconnect(e,t){let n=`MetaMask: Lost connection to "${e}".`;t?.stack&&(n+=`\n${t.stack}`),this._log.warn(n),this.listenerCount("error")>0&&this.emit("error",n),this._handleDisconnect(false,t?t.message:void 0);}_handleChainChanged({chainId:e,networkVersion:t}={}){UC(e)&&(e=>Boolean(e)&&"string"==typeof e)(t)?"loading"===t?this._handleDisconnect(true):super._handleChainChanged({chainId:e}):this._log.error(Tk.errors.invalidNetworkParams(),{chainId:e,networkVersion:t});}},Cx=class extends Mx{constructor(e,{jsonRpcStreamName:t="metamask-provider",logger:n=console,maxEventListeners:r=100,shouldSendMetadata:i}={}){if(super(e,{jsonRpcStreamName:t,logger:n,maxEventListeners:r,rpcMiddleware:jC(n)}),this._sentWarnings={chainId:false,networkVersion:false,selectedAddress:false,enable:false,experimentalMethods:false,send:false,events:{close:false,data:false,networkChanged:false,notification:false}},YC(this,Ex,void 0),this._initializeStateAsync(),GC(this,Ex,null),this.isMetaMask=true,this._sendSync=this._sendSync.bind(this),this.enable=this.enable.bind(this),this.send=this.send.bind(this),this.sendAsync=this.sendAsync.bind(this),this._warnOfDeprecation=this._warnOfDeprecation.bind(this),this._metamask=this._getExperimentalApi(),this._jsonRpcConnection.events.on("notification",(e=>{const{method:t}=e;DC.includes(t)&&(this.emit("data",e),this.emit("notification",e.params.result));})),i)if("complete"===document.readyState)KC(this._rpcEngine,this._log);else {const e=()=>{KC(this._rpcEngine,this._log),window.removeEventListener("DOMContentLoaded",e);};window.addEventListener("DOMContentLoaded",e);}}get chainId(){return this._sentWarnings.chainId||(this._log.warn(Tk.warnings.chainIdDeprecation),this._sentWarnings.chainId=true),super.chainId}get networkVersion(){return this._sentWarnings.networkVersion||(this._log.warn(Tk.warnings.networkVersionDeprecation),this._sentWarnings.networkVersion=true),VC(this,Ex)}get selectedAddress(){return this._sentWarnings.selectedAddress||(this._log.warn(Tk.warnings.selectedAddressDeprecation),this._sentWarnings.selectedAddress=true),super.selectedAddress}sendAsync(e,t){this._rpcRequest(e,t);}addListener(e,t){return this._warnOfDeprecation(e),super.addListener(e,t)}on(e,t){return this._warnOfDeprecation(e),super.on(e,t)}once(e,t){return this._warnOfDeprecation(e),super.once(e,t)}prependListener(e,t){return this._warnOfDeprecation(e),super.prependListener(e,t)}prependOnceListener(e,t){return this._warnOfDeprecation(e),super.prependOnceListener(e,t)}_handleDisconnect(e,t){super._handleDisconnect(e,t),VC(this,Ex)&&!e&&GC(this,Ex,null);}_warnOfDeprecation(e){ false===this._sentWarnings?.events[e]&&(this._log.warn(Tk.warnings.events[e]),this._sentWarnings.events[e]=true);}async enable(){return this._sentWarnings.enable||(this._log.warn(Tk.warnings.enableDeprecation),this._sentWarnings.enable=true),new Promise(((e,t)=>{try{this._rpcRequest({method:"eth_requestAccounts",params:[]},zC(e,t));}catch(e){t(e);}}))}send(e,t){return this._sentWarnings.send||(this._log.warn(Tk.warnings.sendDeprecation),this._sentWarnings.send=true),"string"!=typeof e||t&&!Array.isArray(t)?e&&"object"==typeof e&&"function"==typeof t?this._rpcRequest(e,t):this._sendSync(e):new Promise(((n,r)=>{try{this._rpcRequest({method:e,params:t},zC(n,r,!1));}catch(e){r(e);}}))}_sendSync(e){let t;switch(e.method){case "eth_accounts":t=this.selectedAddress?[this.selectedAddress]:[];break;case "eth_coinbase":t=this.selectedAddress??null;break;case "eth_uninstallFilter":this._rpcRequest(e,FC),t=true;break;case "net_version":t=VC(this,Ex)??null;break;default:throw new Error(Tk.errors.unsupportedSync(e.method))}return {id:e.id,jsonrpc:e.jsonrpc,result:t}}_getExperimentalApi(){return new Proxy({isUnlocked:async()=>(this._state.initialized||await new Promise((e=>{this.on("_initialized",(()=>e()));})),this._state.isUnlocked),requestBatch:async e=>{if(!Array.isArray(e))throw sC({message:"Batch requests must be made with an array of request objects.",data:e});return new Promise(((t,n)=>{this._rpcRequest(e,zC(t,n));}))}},{get:(e,t,...n)=>(this._sentWarnings.experimentalMethods||(this._log.warn(Tk.warnings.experimentalMethods),this._sentWarnings.experimentalMethods=true),Reflect.get(e,t,...n))})}_handleChainChanged({chainId:e,networkVersion:t}={}){super._handleChainChanged({chainId:e,networkVersion:t}),this._state.isConnected&&t!==VC(this,Ex)&&(GC(this,Ex,t),this._state.initialized&&this.emit("networkChanged",VC(this,Ex)));}};Ex=new WeakMap;const xx=DM("MM_SDK");xx.color="#FFAC1C";var Ax={},Rx={};Object.defineProperty(Rx,"__esModule",{value:true}),Rx.EthereumProviderError=Rx.EthereumRpcError=void 0;const Tx=WM;class Px extends Error{constructor(e,t,n){if(!Number.isInteger(e))throw new Error('"code" must be an integer.');if(!t||"string"!=typeof t)throw new Error('"message" must be a nonempty string.');super(t),this.code=e,void 0!==n&&(this.data=n);}serialize(){const e={code:this.code,message:this.message};return void 0!==this.data&&(e.data=this.data),this.stack&&(e.stack=this.stack),e}toString(){return Tx.default(this.serialize(),Lx,2)}}Rx.EthereumRpcError=Px;function Lx(e,t){if("[Circular]"!==t)return t}Rx.EthereumProviderError=class extends Px{constructor(e,t,n){if(!function(e){return Number.isInteger(e)&&e>=1e3&&e<=4999}(e))throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');super(e,t,n);}};var Ix={},Ox={};Object.defineProperty(Ox,"__esModule",{value:true}),Ox.errorValues=Ox.errorCodes=void 0,Ox.errorCodes={rpc:{invalidInput:-32e3,resourceNotFound:-32001,resourceUnavailable:-32002,transactionRejected:-32003,methodNotSupported:-32004,limitExceeded:-32005,parse:-32700,invalidRequest:-32600,methodNotFound:-32601,invalidParams:-32602,internal:-32603},provider:{userRejectedRequest:4001,unauthorized:4100,unsupportedMethod:4200,disconnected:4900,chainDisconnected:4901}},Ox.errorValues={"-32700":{standard:"JSON RPC 2.0",message:"Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."},"-32600":{standard:"JSON RPC 2.0",message:"The JSON sent is not a valid Request object."},"-32601":{standard:"JSON RPC 2.0",message:"The method does not exist / is not available."},"-32602":{standard:"JSON RPC 2.0",message:"Invalid method parameter(s)."},"-32603":{standard:"JSON RPC 2.0",message:"Internal JSON-RPC error."},"-32000":{standard:"EIP-1474",message:"Invalid input."},"-32001":{standard:"EIP-1474",message:"Resource not found."},"-32002":{standard:"EIP-1474",message:"Resource unavailable."},"-32003":{standard:"EIP-1474",message:"Transaction rejected."},"-32004":{standard:"EIP-1474",message:"Method not supported."},"-32005":{standard:"EIP-1474",message:"Request limit exceeded."},4001:{standard:"EIP-1193",message:"User rejected the request."},4100:{standard:"EIP-1193",message:"The requested account and/or method has not been authorized by the user."},4200:{standard:"EIP-1193",message:"The requested method is not supported by this Ethereum provider."},4900:{standard:"EIP-1193",message:"The provider is disconnected from all chains."},4901:{standard:"EIP-1193",message:"The provider is disconnected from the specified chain."}},function(e){Object.defineProperty(e,"__esModule",{value:true}),e.serializeError=e.isValidCode=e.getMessageFromCode=e.JSON_RPC_SERVER_ERROR_MESSAGE=void 0;const t=Ox,n=Rx,r=t.errorCodes.rpc.internal,i="Unspecified error message. This is a bug, please report it.",o={code:r,message:a(r)};function a(n,r=i){if(Number.isInteger(n)){const r=n.toString();if(c(t.errorValues,r))return t.errorValues[r].message;if(u(n))return e.JSON_RPC_SERVER_ERROR_MESSAGE}return r}function s(e){if(!Number.isInteger(e))return  false;const n=e.toString();return !!t.errorValues[n]||!!u(e)}function u(e){return e>=-32099&&e<=-32e3}function l(e){return e&&"object"==typeof e&&!Array.isArray(e)?Object.assign({},e):e}function c(e,t){return Object.prototype.hasOwnProperty.call(e,t)}e.JSON_RPC_SERVER_ERROR_MESSAGE="Unspecified server error.",e.getMessageFromCode=a,e.isValidCode=s,e.serializeError=function(e,{fallbackError:t=o,shouldIncludeStack:r=false}={}){var i,u;if(!t||!Number.isInteger(t.code)||"string"!=typeof t.message)throw new Error("Must provide fallback error with integer number code and string message.");if(e instanceof n.EthereumRpcError)return e.serialize();const d={};if(e&&"object"==typeof e&&!Array.isArray(e)&&c(e,"code")&&s(e.code)){const t=e;d.code=t.code,t.message&&"string"==typeof t.message?(d.message=t.message,c(t,"data")&&(d.data=t.data)):(d.message=a(d.code),d.data={originalError:l(e)});}else {d.code=t.code;const n=null===(i=e)||void 0===i?void 0:i.message;d.message=n&&"string"==typeof n?n:t.message,d.data={originalError:l(e)};}const f=null===(u=e)||void 0===u?void 0:u.stack;return r&&e&&f&&"string"==typeof f&&(d.stack=f),d};}(Ix);var Nx={};Object.defineProperty(Nx,"__esModule",{value:true}),Nx.ethErrors=void 0;const Dx=Rx,jx=Ix,Bx=Ox;function zx(e,t){const[n,r]=Fx(t);return new Dx.EthereumRpcError(e,n||jx.getMessageFromCode(e),r)}function Ux(e,t){const[n,r]=Fx(t);return new Dx.EthereumProviderError(e,n||jx.getMessageFromCode(e),r)}function Fx(e){if(e){if("string"==typeof e)return [e];if("object"==typeof e&&!Array.isArray(e)){const{message:t,data:n}=e;if(t&&"string"!=typeof t)throw new Error("Must specify string message.");return [t||void 0,n]}}return []}Nx.ethErrors={rpc:{parse:e=>zx(Bx.errorCodes.rpc.parse,e),invalidRequest:e=>zx(Bx.errorCodes.rpc.invalidRequest,e),invalidParams:e=>zx(Bx.errorCodes.rpc.invalidParams,e),methodNotFound:e=>zx(Bx.errorCodes.rpc.methodNotFound,e),internal:e=>zx(Bx.errorCodes.rpc.internal,e),server:e=>{if(!e||"object"!=typeof e||Array.isArray(e))throw new Error("Ethereum RPC Server errors must provide single object argument.");const{code:t}=e;if(!Number.isInteger(t)||t>-32005||t<-32099)throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');return zx(t,e)},invalidInput:e=>zx(Bx.errorCodes.rpc.invalidInput,e),resourceNotFound:e=>zx(Bx.errorCodes.rpc.resourceNotFound,e),resourceUnavailable:e=>zx(Bx.errorCodes.rpc.resourceUnavailable,e),transactionRejected:e=>zx(Bx.errorCodes.rpc.transactionRejected,e),methodNotSupported:e=>zx(Bx.errorCodes.rpc.methodNotSupported,e),limitExceeded:e=>zx(Bx.errorCodes.rpc.limitExceeded,e)},provider:{userRejectedRequest:e=>Ux(Bx.errorCodes.provider.userRejectedRequest,e),unauthorized:e=>Ux(Bx.errorCodes.provider.unauthorized,e),unsupportedMethod:e=>Ux(Bx.errorCodes.provider.unsupportedMethod,e),disconnected:e=>Ux(Bx.errorCodes.provider.disconnected,e),chainDisconnected:e=>Ux(Bx.errorCodes.provider.chainDisconnected,e),custom:e=>{if(!e||"object"!=typeof e||Array.isArray(e))throw new Error("Ethereum Provider custom errors must provide single object argument.");const{code:t,message:n,data:r}=e;if(!n||"string"!=typeof n)throw new Error('"message" must be a nonempty string');return new Dx.EthereumProviderError(t,n,r)}}},function(e){Object.defineProperty(e,"__esModule",{value:true}),e.getMessageFromCode=e.serializeError=e.EthereumProviderError=e.EthereumRpcError=e.ethErrors=e.errorCodes=void 0;const t=Rx;Object.defineProperty(e,"EthereumRpcError",{enumerable:true,get:function(){return t.EthereumRpcError}}),Object.defineProperty(e,"EthereumProviderError",{enumerable:true,get:function(){return t.EthereumProviderError}});const n=Ix;Object.defineProperty(e,"serializeError",{enumerable:true,get:function(){return n.serializeError}}),Object.defineProperty(e,"getMessageFromCode",{enumerable:true,get:function(){return n.getMessageFromCode}});const r=Nx;Object.defineProperty(e,"ethErrors",{enumerable:true,get:function(){return r.ethErrors}});const i=Ox;Object.defineProperty(e,"errorCodes",{enumerable:true,get:function(){return i.errorCodes}});}(Ax);const Kx={METAMASK_GETPROVIDERSTATE:"metamask_getProviderState",METAMASK_CONNECTSIGN:"metamask_connectSign",METAMASK_CONNECTWITH:"metamask_connectWith",METAMASK_OPEN:"metamask_open",METAMASK_BATCH:"metamask_batch",PERSONAL_SIGN:"personal_sign",WALLET_REQUESTPERMISSIONS:"wallet_requestPermissions",WALLET_REVOKEPERMISSIONS:"wallet_revokePermissions",WALLET_GETPERMISSIONS:"wallet_getPermissions",WALLET_WATCHASSET:"wallet_watchAsset",WALLET_ADDETHEREUMCHAIN:"wallet_addEthereumChain",WALLET_SWITCHETHETHEREUMCHAIN:"wallet_switchEthereumChain",ETH_REQUESTACCOUNTS:"eth_requestAccounts",ETH_ACCOUNTS:"eth_accounts",ETH_CHAINID:"eth_chainId",ETH_SENDTRANSACTION:"eth_sendTransaction",ETH_SIGNTYPEDDATA:"eth_signTypedData",ETH_SIGNTYPEDDATA_V3:"eth_signTypedData_v3",ETH_SIGNTYPEDDATA_V4:"eth_signTypedData_v4",ETH_SIGNTRANSACTION:"eth_signTransaction",ETH_SIGN:"eth_sign",PERSONAL_EC_RECOVER:"personal_ecRecover"},qx={[Kx.ETH_REQUESTACCOUNTS]:true,[Kx.ETH_SENDTRANSACTION]:true,[Kx.ETH_SIGNTRANSACTION]:true,[Kx.ETH_SIGN]:true,[Kx.PERSONAL_SIGN]:true,[Kx.ETH_ACCOUNTS]:false,[Kx.ETH_CHAINID]:false,[Kx.PERSONAL_SIGN]:true,[Kx.ETH_SIGNTYPEDDATA]:true,[Kx.ETH_SIGNTYPEDDATA_V3]:true,[Kx.ETH_SIGNTYPEDDATA_V4]:true,[Kx.WALLET_REQUESTPERMISSIONS]:true,[Kx.WALLET_GETPERMISSIONS]:true,[Kx.WALLET_WATCHASSET]:true,[Kx.WALLET_ADDETHEREUMCHAIN]:true,[Kx.WALLET_SWITCHETHETHEREUMCHAIN]:true,[Kx.METAMASK_CONNECTSIGN]:true,[Kx.METAMASK_CONNECTWITH]:true,[Kx.PERSONAL_EC_RECOVER]:true,[Kx.METAMASK_BATCH]:true,[Kx.METAMASK_OPEN]:true},Hx=Object.keys(qx).map((e=>e.toLowerCase())),Wx=["eth_signTypedData","eth_signTypedData_v3","eth_signTypedData_v4","eth_sign"].map((e=>e.toLowerCase())),$x=".sdk-comm",Vx="providerType",Yx=".MMSDK_cached_address",Gx=".MMSDK_cached_chainId",Zx={CHAIN_CHANGED:"chainChanged",ACCOUNTS_CHANGED:"accountsChanged",DISCONNECT:"disconnect",CONNECT:"connect",CONNECTED:"connected"};class Qx{constructor({enabled:e}={enabled:false}){this.enabled=false,this.enabled=e;}persistChannelConfig(e){return kk(this,void 0,void 0,(function*(){const t=JSON.stringify(e);xx(`[StorageManagerWeb: persistChannelConfig()] enabled=${this.enabled}`,e),localStorage.setItem($x,t);}))}getPersistedChannelConfig(){return kk(this,void 0,void 0,(function*(){let e;try{if(xx(`[StorageManagerWeb: getPersistedChannelConfig()] enabled=${this.enabled}`),e=localStorage.getItem($x),xx("[StorageManagerWeb: getPersistedChannelConfig()]",e),!e)return;const t=JSON.parse(e);return xx("[StorageManagerWeb: getPersistedChannelConfig()] channelConfig",t),t}catch(e){return void console.error("[StorageManagerWeb: getPersistedChannelConfig()] Can't find existing channel config",e)}}))}persistAccounts(e){return kk(this,void 0,void 0,(function*(){xx(`[StorageManagerWeb: persistAccounts()] enabled=${this.enabled}`,e);const t=JSON.stringify(e);localStorage.setItem(Yx,t);}))}getCachedAccounts(){return kk(this,void 0,void 0,(function*(){try{const e=localStorage.getItem(Yx);return e?JSON.parse(e):[]}catch(e){throw console.error("[StorageManagerWeb: getCachedAccounts()] Error reading cached accounts",e),e}}))}persistChainId(e){return kk(this,void 0,void 0,(function*(){xx(`[StorageManagerWeb: persistChainId()] enabled=${this.enabled}`,e),localStorage.setItem(Gx,e);}))}getCachedChainId(){return kk(this,void 0,void 0,(function*(){try{const e=localStorage.getItem(Gx);return null!=e?e:void 0}catch(e){throw console.error("[StorageManagerWeb: getCachedChainId()] Error reading cached chainId",e),e}}))}terminate(){return kk(this,void 0,void 0,(function*(){xx(`[StorageManagerWeb: terminate()] enabled=${this.enabled}`),localStorage.removeItem($x);}))}}const Jx=e=>new Qx(e);class Xx extends Cx{constructor({connectionStream:e,shouldSendMetadata:t,autoRequestAccounts:n=false}){super(e,{logger:console,maxEventListeners:100,shouldSendMetadata:t}),this.state={accounts:null,autoRequestAccounts:false,providerStateRequested:false,chainId:"",networkVersion:""},xx(`[SDKProvider: constructor()] autoRequestAccounts=${n}`),this.state.autoRequestAccounts=n;}forceInitializeState(){return kk(this,void 0,void 0,(function*(){return xx(`[SDKProvider: forceInitializeState()] autoRequestAccounts=${this.state.autoRequestAccounts}`),this._initializeStateAsync()}))}_setConnected(){xx("[SDKProvider: _setConnected()] Setting connected state"),this._state.isConnected=true;}getState(){return this._state}getSDKProviderState(){return this.state}getSelectedAddress(){var e;const{accounts:t}=this._state;return t&&0!==t.length?(null===(e=t[0])||void 0===e?void 0:e.toLowerCase())||"":(xx("[SDKProvider: getSelectedAddress] No accounts found"),null)}getChainId(){return this.state.chainId}getNetworkVersion(){return this.state.networkVersion}setSDKProviderState(e){this.state=Object.assign(Object.assign({},this.state),e);}handleAccountsChanged(e,t){return this._handleAccountsChanged(e,t)}handleDisconnect({terminate:e=false}){!function({terminate:e=false,instance:t}){const{state:n}=t;xx(`[SDKProvider: handleDisconnect()] cleaning up provider state terminate=${e}`,t),e&&(t._state.accounts=null,t._state.isUnlocked=false,t._state.isPermanentlyDisconnected=true,t._state.initialized=false),t._handleAccountsChanged([]),t._state.isConnected=false,t.emit("disconnect",Ax.ethErrors.provider.disconnected()),n.providerStateRequested=false;}({terminate:e,instance:this});}_initializeStateAsync(){return kk(this,void 0,void 0,(function*(){return function(e){var t,n;return kk(this,void 0,void 0,(function*(){ void 0===e.state&&(e.state={accounts:null,autoRequestAccounts:false,providerStateRequested:false,chainId:""});const{state:r}=e;let i;if(r.providerStateRequested)xx("[SDKProvider: initializeStateAsync()] initialization already in progress");else {let o;r.providerStateRequested=true;let a=null,s=false,u=false;const l=Jx({enabled:true});if(l){const e=yield l.getPersistedChannelConfig({});s=null!==(t=null==e?void 0:e.relayPersistence)&&void 0!==t&&t,o=yield l.getCachedChainId();const n=yield l.getCachedAccounts();n.length>0&&(a=n[0]);}if(xx(`[SDKProvider: initializeStateAsync()] relayPersistence=${s}`,{relayPersistence:s,cachedChainId:o,cachedSelectedAddress:a}),s)if(o&&a)i={accounts:[a],chainId:o,isUnlocked:false},u=true;else try{i=yield e.request({method:"metamask_getProviderState"});}catch(t){return e._log.error("MetaMask: Failed to get initial state. Please report this bug.",t),void(r.providerStateRequested=false)}if(0===(null===(n=null==i?void 0:i.accounts)||void 0===n?void 0:n.length))if(e.getSelectedAddress())i.accounts=[e.getSelectedAddress()];else {xx("[SDKProvider: initializeStateAsync()] Fetch accounts remotely.");const t=yield e.request({method:"eth_requestAccounts",params:[]});i.accounts=t;}e._initializeState(i),r.providerStateRequested=false,u&&(e._state.isConnected=true,e.emit("connect",{chainId:null==i?void 0:i.chainId}));}}))}(this)}))}_initializeState(e){return xx("[SDKProvider: _initializeState()]",e),function(e,t,n){return xx("[SDKProvider: initializeState()] set state._initialized to false"),e._state.initialized=false,t(n)}(this,super._initializeState.bind(this),e)}_handleChainChanged({chainId:e,networkVersion:t}={}){this.state.chainId=e,this.state.networkVersion=t,function({instance:e,chainId:t,networkVersion:n,superHandleChainChanged:r}){xx(`[SDKProvider: handleChainChanged()] chainId=${t} networkVersion=${n}`);let i=n;n||(xx("[SDKProvider: handleChainChanged()] forced network version to prevent provider error"),i="1"),e._state.isConnected=true,e.emit("connect",{chainId:t}),r({chainId:t,networkVersion:i});}({instance:this,chainId:e,networkVersion:t,superHandleChainChanged:super._handleChainChanged.bind(this)});}}var eA={exports:{}};!function(e,t){!function(t){var n=Object.hasOwnProperty,r=Array.isArray?Array.isArray:function(e){return "[object Array]"===Object.prototype.toString.call(e)},i="object"==typeof je&&true,o="function"==typeof Symbol,a="object"==typeof Reflect,s="function"==typeof setImmediate?setImmediate:setTimeout,u=o?a&&"function"==typeof Reflect.ownKeys?Reflect.ownKeys:function(e){var t=Object.getOwnPropertyNames(e);return t.push.apply(t,Object.getOwnPropertySymbols(e)),t}:Object.keys;function l(){this._events={},this._conf&&c.call(this,this._conf);}function c(e){e&&(this._conf=e,e.delimiter&&(this.delimiter=e.delimiter),e.maxListeners!==t&&(this._maxListeners=e.maxListeners),e.wildcard&&(this.wildcard=e.wildcard),e.newListener&&(this._newListener=e.newListener),e.removeListener&&(this._removeListener=e.removeListener),e.verboseMemoryLeak&&(this.verboseMemoryLeak=e.verboseMemoryLeak),e.ignoreErrors&&(this.ignoreErrors=e.ignoreErrors),this.wildcard&&(this.listenerTree={}));}function d(e,t){var n="(node) warning: possible EventEmitter memory leak detected. "+e+" listeners added. Use emitter.setMaxListeners() to increase limit.";if(this.verboseMemoryLeak&&(n+=" Event name: "+t+"."),void 0!==je&&je.emitWarning){var r=new Error(n);r.name="MaxListenersExceededWarning",r.emitter=this,r.count=e,je.emitWarning(r);}else console.error(n),console.trace&&console.trace();}var f=function(e,t,n){var r=arguments.length;switch(r){case 0:return [];case 1:return [e];case 2:return [e,t];case 3:return [e,t,n];default:for(var i=new Array(r);r--;)i[r]=arguments[r];return i}};function h(e,n){for(var r={},i=e.length,o=0,a=0;a<i;a++)r[e[a]]=a<o?n[a]:t;return r}function p(e,t,n){var r,i;if(this._emitter=e,this._target=t,this._listeners={},this._listenersCount=0,(n.on||n.off)&&(r=n.on,i=n.off),t.addEventListener?(r=t.addEventListener,i=t.removeEventListener):t.addListener?(r=t.addListener,i=t.removeListener):t.on&&(r=t.on,i=t.off),!r&&!i)throw Error("target does not implement any known event API");if("function"!=typeof r)throw TypeError("on method must be a function");if("function"!=typeof i)throw TypeError("off method must be a function");this._on=r,this._off=i;var o=e._observers;o?o.push(this):e._observers=[this];}function m(e,r,i,o){var a=Object.assign({},r);if(!e)return a;if("object"!=typeof e)throw TypeError("options must be an object");var s,u,l,c=Object.keys(e),d=c.length;function f(e){throw Error('Invalid "'+s+'" option value'+(e?". Reason: "+e:""))}for(var h=0;h<d;h++){if(s=c[h],!n.call(r,s))throw Error('Unknown "'+s+'" option');(u=e[s])!==t&&(l=i[s],a[s]=l?l(u,f):u);}return a}function g(e,t){return "function"==typeof e&&e.hasOwnProperty("prototype")||t("value must be a constructor"),e}function v(e){var t="value must be type of "+e.join("|"),n=e.length,r=e[0],i=e[1];return 1===n?function(e,n){if(typeof e===r)return e;n(t);}:2===n?function(e,n){var o=typeof e;if(o===r||o===i)return e;n(t);}:function(r,i){for(var o=typeof r,a=n;a-- >0;)if(o===e[a])return r;i(t);}}Object.assign(p.prototype,{subscribe:function(e,t,n){var r=this,i=this._target,o=this._emitter,a=this._listeners,s=function(){var r=f.apply(null,arguments),a={data:r,name:t,original:e};n?false!==n.call(i,a)&&o.emit.apply(o,[a.name].concat(r)):o.emit.apply(o,[t].concat(r));};if(a[e])throw Error("Event '"+e+"' is already listening");this._listenersCount++,o._newListener&&o._removeListener&&!r._onNewListener?(this._onNewListener=function(n){n===t&&null===a[e]&&(a[e]=s,r._on.call(i,e,s));},o.on("newListener",this._onNewListener),this._onRemoveListener=function(n){n===t&&!o.hasListeners(n)&&a[e]&&(a[e]=null,r._off.call(i,e,s));},a[e]=null,o.on("removeListener",this._onRemoveListener)):(a[e]=s,r._on.call(i,e,s));},unsubscribe:function(e){var t,n,r,i=this,o=this._listeners,a=this._emitter,s=this._off,l=this._target;if(e&&"string"!=typeof e)throw TypeError("event must be a string");function c(){i._onNewListener&&(a.off("newListener",i._onNewListener),a.off("removeListener",i._onRemoveListener),i._onNewListener=null,i._onRemoveListener=null);var e=_.call(a,i);a._observers.splice(e,1);}if(e){if(!(t=o[e]))return;s.call(l,e,t),delete o[e],--this._listenersCount||c();}else {for(r=(n=u(o)).length;r-- >0;)e=n[r],s.call(l,e,o[e]);this._listeners={},this._listenersCount=0,c();}}});var b=v(["function"]),y=v(["object","function"]);function w(e,t,n){var r,i,o,a=0,s=new e((function(u,l,c){function d(){i&&(i=null),a&&(clearTimeout(a),a=0);}n=m(n,{timeout:0,overload:false},{timeout:function(e,t){return ("number"!=typeof(e*=1)||e<0||!Number.isFinite(e))&&t("timeout must be a positive number"),e}}),r=!n.overload&&"function"==typeof e.prototype.cancel&&"function"==typeof c;var f=function(e){d(),u(e);},h=function(e){d(),l(e);};r?t(f,h,c):(i=[function(e){h(e||Error("canceled"));}],t(f,h,(function(e){if(o)throw Error("Unable to subscribe on cancel event asynchronously");if("function"!=typeof e)throw TypeError("onCancel callback must be a function");i.push(e);})),o=true),n.timeout>0&&(a=setTimeout((function(){var e=Error("timeout");e.code="ETIMEDOUT",a=0,s.cancel(e),l(e);}),n.timeout));}));return r||(s.cancel=function(e){if(i){for(var t=i.length,n=1;n<t;n++)i[n](e);i[0](e),i=null;}}),s}function _(e){var t=this._observers;if(!t)return  -1;for(var n=t.length,r=0;r<n;r++)if(t[r]._target===e)return r;return  -1}function S(e,t,n,r,i){if(!n)return null;if(0===r){var o=typeof t;if("string"===o){var a,s,l=0,c=0,d=this.delimiter,f=d.length;if(-1!==(s=t.indexOf(d))){a=new Array(5);do{a[l++]=t.slice(c,s),c=s+f;}while(-1!==(s=t.indexOf(d,c)));a[l++]=t.slice(c),t=a,i=l;}else t=[t],i=1;}else "object"===o?i=t.length:(t=[t],i=1);}var h,p,m,g,v,b,y,w=null,_=t[r],E=t[r+1];if(r===i)n._listeners&&("function"==typeof n._listeners?(e&&e.push(n._listeners),w=[n]):(e&&e.push.apply(e,n._listeners),w=[n]));else {if("*"===_){for(s=(b=u(n)).length;s-- >0;)"_listeners"!==(h=b[s])&&(y=S(e,t,n[h],r+1,i))&&(w?w.push.apply(w,y):w=y);return w}if("**"===_){for((v=r+1===i||r+2===i&&"*"===E)&&n._listeners&&(w=S(e,t,n,i,i)),s=(b=u(n)).length;s-- >0;)"_listeners"!==(h=b[s])&&("*"===h||"**"===h?(n[h]._listeners&&!v&&(y=S(e,t,n[h],i,i))&&(w?w.push.apply(w,y):w=y),y=S(e,t,n[h],r,i)):y=S(e,t,n[h],h===E?r+2:r,i),y&&(w?w.push.apply(w,y):w=y));return w}n[_]&&(w=S(e,t,n[_],r+1,i));}if((p=n["*"])&&S(e,t,p,r+1,i),m=n["**"])if(r<i)for(m._listeners&&S(e,t,m,i,i),s=(b=u(m)).length;s-- >0;)"_listeners"!==(h=b[s])&&(h===E?S(e,t,m[h],r+2,i):h===_?S(e,t,m[h],r+1,i):((g={})[h]=m[h],S(e,t,{"**":g},r+1,i)));else m._listeners?S(e,t,m,i,i):m["*"]&&m["*"]._listeners&&S(e,t,m["*"],i,i);return w}function E(e,t,n){var r,i,o=0,a=0,s=this.delimiter,u=s.length;if("string"==typeof e)if(-1!==(r=e.indexOf(s))){i=new Array(5);do{i[o++]=e.slice(a,r),a=r+u;}while(-1!==(r=e.indexOf(s,a)));i[o++]=e.slice(a);}else i=[e],o=1;else i=e,o=e.length;if(o>1)for(r=0;r+1<o;r++)if("**"===i[r]&&"**"===i[r+1])return;var l,c=this.listenerTree;for(r=0;r<o;r++)if(c=c[l=i[r]]||(c[l]={}),r===o-1)return c._listeners?("function"==typeof c._listeners&&(c._listeners=[c._listeners]),n?c._listeners.unshift(t):c._listeners.push(t),!c._listeners.warned&&this._maxListeners>0&&c._listeners.length>this._maxListeners&&(c._listeners.warned=true,d.call(this,c._listeners.length,l))):c._listeners=t,true;return  true}function k(e,t,n,r){for(var i,o,a,s,l=u(e),c=l.length,d=e._listeners;c-- >0;)i=e[o=l[c]],a="_listeners"===o?n:n?n.concat(o):[o],s=r||"symbol"==typeof o,d&&t.push(s?a:a.join(this.delimiter)),"object"==typeof i&&k.call(this,i,t,a,s);return t}function M(e){for(var t,n,r,i=u(e),o=i.length;o-- >0;)(t=e[n=i[o]])&&(r=true,"_listeners"===n||M(t)||delete e[n]);return r}function C(e,t,n){this.emitter=e,this.event=t,this.listener=n;}function x(e,n,r){if(true===r)a=true;else if(false===r)o=true;else {if(!r||"object"!=typeof r)throw TypeError("options should be an object or true");var o=r.async,a=r.promisify,u=r.nextTick,l=r.objectify;}if(o||u||a){var c=n,d=n._origin||n;if(u&&!i)throw Error("process.nextTick is not supported");a===t&&(a="AsyncFunction"===n.constructor.name),n=function(){var e=arguments,t=this,n=this.event;return a?u?Promise.resolve():new Promise((function(e){s(e);})).then((function(){return t.event=n,c.apply(t,e)})):(u?Ee:s)((function(){t.event=n,c.apply(t,e);}))},n._async=true,n._origin=d;}return [n,l?new C(this,e,n):this]}function A(e){this._events={},this._newListener=false,this._removeListener=false,this.verboseMemoryLeak=false,c.call(this,e);}C.prototype.off=function(){return this.emitter.off(this.event,this.listener),this},A.EventEmitter2=A,A.prototype.listenTo=function(e,n,i){if("object"!=typeof e)throw TypeError("target musts be an object");var o=this;function a(t){if("object"!=typeof t)throw TypeError("events must be an object");var n,r=i.reducers,a=_.call(o,e);n=-1===a?new p(o,e,i):o._observers[a];for(var s,l=u(t),c=l.length,d="function"==typeof r,f=0;f<c;f++)s=l[f],n.subscribe(s,t[s]||s,d?r:r&&r[s]);}return i=m(i,{on:t,off:t,reducers:t},{on:b,off:b,reducers:y}),r(n)?a(h(n)):a("string"==typeof n?h(n.split(/\s+/)):n),this},A.prototype.stopListeningTo=function(e,t){var n=this._observers;if(!n)return  false;var r,i=n.length,o=false;if(e&&"object"!=typeof e)throw TypeError("target should be an object");for(;i-- >0;)r=n[i],e&&r._target!==e||(r.unsubscribe(t),o=true);return o},A.prototype.delimiter=".",A.prototype.setMaxListeners=function(e){e!==t&&(this._maxListeners=e,this._conf||(this._conf={}),this._conf.maxListeners=e);},A.prototype.getMaxListeners=function(){return this._maxListeners},A.prototype.event="",A.prototype.once=function(e,t,n){return this._once(e,t,false,n)},A.prototype.prependOnceListener=function(e,t,n){return this._once(e,t,true,n)},A.prototype._once=function(e,t,n,r){return this._many(e,1,t,n,r)},A.prototype.many=function(e,t,n,r){return this._many(e,t,n,false,r)},A.prototype.prependMany=function(e,t,n,r){return this._many(e,t,n,true,r)},A.prototype._many=function(e,t,n,r,i){var o=this;if("function"!=typeof n)throw new Error("many only accepts instances of Function");function a(){return 0==--t&&o.off(e,a),n.apply(this,arguments)}return a._origin=n,this._on(e,a,r,i)},A.prototype.emit=function(){if(!this._events&&!this._all)return  false;this._events||l.call(this);var e,t,n,r,i,a,s=arguments[0],u=this.wildcard;if("newListener"===s&&!this._newListener&&!this._events.newListener)return  false;if(u&&(e=s,"newListener"!==s&&"removeListener"!==s&&"object"==typeof s)){if(n=s.length,o)for(r=0;r<n;r++)if("symbol"==typeof s[r]){a=true;break}a||(s=s.join(this.delimiter));}var c,d=arguments.length;if(this._all&&this._all.length)for(r=0,n=(c=this._all.slice()).length;r<n;r++)switch(this.event=s,d){case 1:c[r].call(this,s);break;case 2:c[r].call(this,s,arguments[1]);break;case 3:c[r].call(this,s,arguments[1],arguments[2]);break;default:c[r].apply(this,arguments);}if(u)c=[],S.call(this,c,e,this.listenerTree,0,n);else {if("function"==typeof(c=this._events[s])){switch(this.event=s,d){case 1:c.call(this);break;case 2:c.call(this,arguments[1]);break;case 3:c.call(this,arguments[1],arguments[2]);break;default:for(t=new Array(d-1),i=1;i<d;i++)t[i-1]=arguments[i];c.apply(this,t);}return  true}c&&(c=c.slice());}if(c&&c.length){if(d>3)for(t=new Array(d-1),i=1;i<d;i++)t[i-1]=arguments[i];for(r=0,n=c.length;r<n;r++)switch(this.event=s,d){case 1:c[r].call(this);break;case 2:c[r].call(this,arguments[1]);break;case 3:c[r].call(this,arguments[1],arguments[2]);break;default:c[r].apply(this,t);}return  true}if(!this.ignoreErrors&&!this._all&&"error"===s)throw arguments[1]instanceof Error?arguments[1]:new Error("Uncaught, unspecified 'error' event.");return !!this._all},A.prototype.emitAsync=function(){if(!this._events&&!this._all)return  false;this._events||l.call(this);var e,t,n,r,i,a,s=arguments[0],u=this.wildcard;if("newListener"===s&&!this._newListener&&!this._events.newListener)return Promise.resolve([false]);if(u&&(e=s,"newListener"!==s&&"removeListener"!==s&&"object"==typeof s)){if(r=s.length,o)for(i=0;i<r;i++)if("symbol"==typeof s[i]){t=true;break}t||(s=s.join(this.delimiter));}var c,d=[],f=arguments.length;if(this._all)for(i=0,r=this._all.length;i<r;i++)switch(this.event=s,f){case 1:d.push(this._all[i].call(this,s));break;case 2:d.push(this._all[i].call(this,s,arguments[1]));break;case 3:d.push(this._all[i].call(this,s,arguments[1],arguments[2]));break;default:d.push(this._all[i].apply(this,arguments));}if(u?(c=[],S.call(this,c,e,this.listenerTree,0)):c=this._events[s],"function"==typeof c)switch(this.event=s,f){case 1:d.push(c.call(this));break;case 2:d.push(c.call(this,arguments[1]));break;case 3:d.push(c.call(this,arguments[1],arguments[2]));break;default:for(n=new Array(f-1),a=1;a<f;a++)n[a-1]=arguments[a];d.push(c.apply(this,n));}else if(c&&c.length){if(c=c.slice(),f>3)for(n=new Array(f-1),a=1;a<f;a++)n[a-1]=arguments[a];for(i=0,r=c.length;i<r;i++)switch(this.event=s,f){case 1:d.push(c[i].call(this));break;case 2:d.push(c[i].call(this,arguments[1]));break;case 3:d.push(c[i].call(this,arguments[1],arguments[2]));break;default:d.push(c[i].apply(this,n));}}else if(!this.ignoreErrors&&!this._all&&"error"===s)return arguments[1]instanceof Error?Promise.reject(arguments[1]):Promise.reject("Uncaught, unspecified 'error' event.");return Promise.all(d)},A.prototype.on=function(e,t,n){return this._on(e,t,false,n)},A.prototype.prependListener=function(e,t,n){return this._on(e,t,true,n)},A.prototype.onAny=function(e){return this._onAny(e,false)},A.prototype.prependAny=function(e){return this._onAny(e,true)},A.prototype.addListener=A.prototype.on,A.prototype._onAny=function(e,t){if("function"!=typeof e)throw new Error("onAny only accepts instances of Function");return this._all||(this._all=[]),t?this._all.unshift(e):this._all.push(e),this},A.prototype._on=function(e,n,r,i){if("function"==typeof e)return this._onAny(e,n),this;if("function"!=typeof n)throw new Error("on only accepts instances of Function");this._events||l.call(this);var o,a=this;return i!==t&&(n=(o=x.call(this,e,n,i))[0],a=o[1]),this._newListener&&this.emit("newListener",e,n),this.wildcard?(E.call(this,e,n,r),a):(this._events[e]?("function"==typeof this._events[e]&&(this._events[e]=[this._events[e]]),r?this._events[e].unshift(n):this._events[e].push(n),!this._events[e].warned&&this._maxListeners>0&&this._events[e].length>this._maxListeners&&(this._events[e].warned=true,d.call(this,this._events[e].length,e))):this._events[e]=n,a)},A.prototype.off=function(e,t){if("function"!=typeof t)throw new Error("removeListener only takes instances of Function");var n,i=[];if(this.wildcard){var o="string"==typeof e?e.split(this.delimiter):e.slice();if(!(i=S.call(this,null,o,this.listenerTree,0)))return this}else {if(!this._events[e])return this;n=this._events[e],i.push({_listeners:n});}for(var a=0;a<i.length;a++){var s=i[a];if(n=s._listeners,r(n)){for(var u=-1,l=0,c=n.length;l<c;l++)if(n[l]===t||n[l].listener&&n[l].listener===t||n[l]._origin&&n[l]._origin===t){u=l;break}if(u<0)continue;return this.wildcard?s._listeners.splice(u,1):this._events[e].splice(u,1),0===n.length&&(this.wildcard?delete s._listeners:delete this._events[e]),this._removeListener&&this.emit("removeListener",e,t),this}(n===t||n.listener&&n.listener===t||n._origin&&n._origin===t)&&(this.wildcard?delete s._listeners:delete this._events[e],this._removeListener&&this.emit("removeListener",e,t));}return this.listenerTree&&M(this.listenerTree),this},A.prototype.offAny=function(e){var t,n=0,r=0;if(e&&this._all&&this._all.length>0){for(n=0,r=(t=this._all).length;n<r;n++)if(e===t[n])return t.splice(n,1),this._removeListener&&this.emit("removeListenerAny",e),this}else {if(t=this._all,this._removeListener)for(n=0,r=t.length;n<r;n++)this.emit("removeListenerAny",t[n]);this._all=[];}return this},A.prototype.removeListener=A.prototype.off,A.prototype.removeAllListeners=function(e){if(e===t)return !this._events||l.call(this),this;if(this.wildcard){var n,r=S.call(this,null,e,this.listenerTree,0);if(!r)return this;for(n=0;n<r.length;n++)r[n]._listeners=null;this.listenerTree&&M(this.listenerTree);}else this._events&&(this._events[e]=null);return this},A.prototype.listeners=function(e){var n,r,i,o,a,s=this._events;if(e===t){if(this.wildcard)throw Error("event name required for wildcard emitter");if(!s)return [];for(o=(n=u(s)).length,i=[];o-- >0;)"function"==typeof(r=s[n[o]])?i.push(r):i.push.apply(i,r);return i}if(this.wildcard){if(!(a=this.listenerTree))return [];var l=[],c="string"==typeof e?e.split(this.delimiter):e.slice();return S.call(this,l,c,a,0),l}return s&&(r=s[e])?"function"==typeof r?[r]:r:[]},A.prototype.eventNames=function(e){var t=this._events;return this.wildcard?k.call(this,this.listenerTree,[],null,e):t?u(t):[]},A.prototype.listenerCount=function(e){return this.listeners(e).length},A.prototype.hasListeners=function(e){if(this.wildcard){var n=[],r="string"==typeof e?e.split(this.delimiter):e.slice();return S.call(this,n,r,this.listenerTree,0),n.length>0}var i=this._events,o=this._all;return !!(o&&o.length||i&&(e===t?u(i).length:i[e]))},A.prototype.listenersAny=function(){return this._all?this._all:[]},A.prototype.waitFor=function(e,n){var r=this,i=typeof n;return "number"===i?n={timeout:n}:"function"===i&&(n={filter:n}),w((n=m(n,{timeout:0,filter:t,handleError:false,Promise:Promise,overload:false},{filter:b,Promise:g})).Promise,(function(t,i,o){function a(){var o=n.filter;if(!o||o.apply(r,arguments))if(r.off(e,a),n.handleError){var s=arguments[0];s?i(s):t(f.apply(null,arguments).slice(1));}else t(f.apply(null,arguments));}o((function(){r.off(e,a);})),r._on(e,a,false);}),{timeout:n.timeout,overload:n.overload})};var R=A.prototype;Object.defineProperties(A,{defaultMaxListeners:{get:function(){return R._maxListeners},set:function(e){if("number"!=typeof e||e<0||Number.isNaN(e))throw TypeError("n must be a non-negative number");R._maxListeners=e;},enumerable:true},once:{value:function(e,t,n){return w((n=m(n,{Promise:Promise,timeout:0,overload:false},{Promise:g})).Promise,(function(n,r,i){var o;if("function"==typeof e.addEventListener)return o=function(){n(f.apply(null,arguments));},i((function(){e.removeEventListener(t,o);})),void e.addEventListener(t,o,{once:true});var a,s=function(){a&&e.removeListener("error",a),n(f.apply(null,arguments));};"error"!==t&&(a=function(n){e.removeListener(t,s),r(n);},e.once("error",a)),i((function(){a&&e.removeListener("error",a),e.removeListener(t,s);})),e.once(t,s);}),{timeout:n.timeout,overload:n.overload})},writable:true,configurable:true}}),Object.defineProperties(R,{_maxListeners:{value:10,writable:true,configurable:true},_observers:{value:null,writable:true,configurable:true}}),e.exports=A;}();}(eA);var tA=r(eA.exports);const nA={type:"logger",log(e){this.output("log",e);},warn(e){this.output("warn",e);},error(e){this.output("error",e);},output(e,t){console&&console[e]&&console[e].apply(console,t);}};class rA{constructor(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};this.init(e,t);}init(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};this.prefix=t.prefix||"i18next:",this.logger=e||nA,this.options=t,this.debug=t.debug;}log(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return this.forward(t,"log","",true)}warn(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return this.forward(t,"warn","",true)}error(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return this.forward(t,"error","")}deprecate(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return this.forward(t,"warn","WARNING DEPRECATED: ",true)}forward(e,t,n,r){return r&&!this.debug?null:("string"==typeof e[0]&&(e[0]=`${n}${this.prefix} ${e[0]}`),this.logger[t](e))}create(e){return new rA(this.logger,{prefix:`${this.prefix}:${e}:`,...this.options})}clone(e){return (e=e||this.options).prefix=e.prefix||this.prefix,new rA(this.logger,e)}}var iA=new rA;class oA{constructor(){this.observers={};}on(e,t){return e.split(" ").forEach((e=>{this.observers[e]||(this.observers[e]=new Map);const n=this.observers[e].get(t)||0;this.observers[e].set(t,n+1);})),this}off(e,t){this.observers[e]&&(t?this.observers[e].delete(t):delete this.observers[e]);}emit(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];if(this.observers[e]){Array.from(this.observers[e].entries()).forEach((e=>{let[t,r]=e;for(let e=0;e<r;e++)t(...n);}));}if(this.observers["*"]){Array.from(this.observers["*"].entries()).forEach((t=>{let[r,i]=t;for(let t=0;t<i;t++)r.apply(r,[e,...n]);}));}}}function aA(){let e,t;const n=new Promise(((n,r)=>{e=n,t=r;}));return n.resolve=e,n.reject=t,n}function sA(e){return null==e?"":""+e}const uA=/###/g;function lA(e,t,n){function r(e){return e&&e.indexOf("###")>-1?e.replace(uA,"."):e}function i(){return !e||"string"==typeof e}const o="string"!=typeof t?t:t.split(".");let a=0;for(;a<o.length-1;){if(i())return {};const t=r(o[a]);!e[t]&&n&&(e[t]=new n),e=Object.prototype.hasOwnProperty.call(e,t)?e[t]:{},++a;}return i()?{}:{obj:e,k:r(o[a])}}function cA(e,t,n){const{obj:r,k:i}=lA(e,t,Object);if(void 0!==r||1===t.length)return void(r[i]=n);let o=t[t.length-1],a=t.slice(0,t.length-1),s=lA(e,a,Object);for(;void 0===s.obj&&a.length;)o=`${a[a.length-1]}.${o}`,a=a.slice(0,a.length-1),s=lA(e,a,Object),s&&s.obj&&void 0!==s.obj[`${s.k}.${o}`]&&(s.obj=void 0);s.obj[`${s.k}.${o}`]=n;}function dA(e,t){const{obj:n,k:r}=lA(e,t);if(n)return n[r]}function fA(e,t,n){for(const r in t)"__proto__"!==r&&"constructor"!==r&&(r in e?"string"==typeof e[r]||e[r]instanceof String||"string"==typeof t[r]||t[r]instanceof String?n&&(e[r]=t[r]):fA(e[r],t[r],n):e[r]=t[r]);return e}function hA(e){return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")}var pA={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#x2F;"};function mA(e){return "string"==typeof e?e.replace(/[&<>"'\/]/g,(e=>pA[e])):e}const gA=[" ",",","?","!",";"],vA=new class{constructor(e){this.capacity=e,this.regExpMap=new Map,this.regExpQueue=[];}getRegExp(e){const t=this.regExpMap.get(e);if(void 0!==t)return t;const n=new RegExp(e);return this.regExpQueue.length===this.capacity&&this.regExpMap.delete(this.regExpQueue.shift()),this.regExpMap.set(e,n),this.regExpQueue.push(e),n}}(20);function bA(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:".";if(!e)return;if(e[t])return e[t];const r=t.split(n);let i=e;for(let e=0;e<r.length;){if(!i||"object"!=typeof i)return;let t,o="";for(let a=e;a<r.length;++a)if(a!==e&&(o+=n),o+=r[a],t=i[o],void 0!==t){if(["string","number","boolean"].indexOf(typeof t)>-1&&a<r.length-1)continue;e+=a-e+1;break}i=t;}return i}function yA(e){return e&&e.indexOf("_")>0?e.replace("_","-"):e}class wA extends oA{constructor(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{ns:["translation"],defaultNS:"translation"};super(),this.data=e||{},this.options=t,void 0===this.options.keySeparator&&(this.options.keySeparator="."),void 0===this.options.ignoreJSONStructure&&(this.options.ignoreJSONStructure=true);}addNamespaces(e){this.options.ns.indexOf(e)<0&&this.options.ns.push(e);}removeNamespaces(e){const t=this.options.ns.indexOf(e);t>-1&&this.options.ns.splice(t,1);}getResource(e,t,n){let r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};const i=void 0!==r.keySeparator?r.keySeparator:this.options.keySeparator,o=void 0!==r.ignoreJSONStructure?r.ignoreJSONStructure:this.options.ignoreJSONStructure;let a;e.indexOf(".")>-1?a=e.split("."):(a=[e,t],n&&(Array.isArray(n)?a.push(...n):"string"==typeof n&&i?a.push(...n.split(i)):a.push(n)));const s=dA(this.data,a);return !s&&!t&&!n&&e.indexOf(".")>-1&&(e=a[0],t=a[1],n=a.slice(2).join(".")),s||!o||"string"!=typeof n?s:bA(this.data&&this.data[e]&&this.data[e][t],n,i)}addResource(e,t,n,r){let i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:{silent:false};const o=void 0!==i.keySeparator?i.keySeparator:this.options.keySeparator;let a=[e,t];n&&(a=a.concat(o?n.split(o):n)),e.indexOf(".")>-1&&(a=e.split("."),r=t,t=a[1]),this.addNamespaces(t),cA(this.data,a,r),i.silent||this.emit("added",e,t,n,r);}addResources(e,t,n){let r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{silent:false};for(const r in n)("string"==typeof n[r]||Array.isArray(n[r]))&&this.addResource(e,t,r,n[r],{silent:true});r.silent||this.emit("added",e,t,n);}addResourceBundle(e,t,n,r,i){let o=arguments.length>5&&void 0!==arguments[5]?arguments[5]:{silent:false,skipCopy:false},a=[e,t];e.indexOf(".")>-1&&(a=e.split("."),r=n,n=t,t=a[1]),this.addNamespaces(t);let s=dA(this.data,a)||{};o.skipCopy||(n=JSON.parse(JSON.stringify(n))),r?fA(s,n,i):s={...s,...n},cA(this.data,a,s),o.silent||this.emit("added",e,t,n);}removeResourceBundle(e,t){this.hasResourceBundle(e,t)&&delete this.data[e][t],this.removeNamespaces(t),this.emit("removed",e,t);}hasResourceBundle(e,t){return void 0!==this.getResource(e,t)}getResourceBundle(e,t){return t||(t=this.options.defaultNS),"v1"===this.options.compatibilityAPI?{...this.getResource(e,t)}:this.getResource(e,t)}getDataByLanguage(e){return this.data[e]}hasLanguageSomeTranslations(e){const t=this.getDataByLanguage(e);return !!(t&&Object.keys(t)||[]).find((e=>t[e]&&Object.keys(t[e]).length>0))}toJSON(){return this.data}}var _A={processors:{},addPostProcessor(e){this.processors[e.name]=e;},handle(e,t,n,r,i){return e.forEach((e=>{this.processors[e]&&(t=this.processors[e].process(t,n,r,i));})),t}};const SA={};class EA extends oA{constructor(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};super(),function(e,t,n){e.forEach((e=>{t[e]&&(n[e]=t[e]);}));}(["resourceStore","languageUtils","pluralResolver","interpolator","backendConnector","i18nFormat","utils"],e,this),this.options=t,void 0===this.options.keySeparator&&(this.options.keySeparator="."),this.logger=iA.create("translator");}changeLanguage(e){e&&(this.language=e);}exists(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{interpolation:{}};if(null==e)return  false;const n=this.resolve(e,t);return n&&void 0!==n.res}extractFromKey(e,t){let n=void 0!==t.nsSeparator?t.nsSeparator:this.options.nsSeparator;void 0===n&&(n=":");const r=void 0!==t.keySeparator?t.keySeparator:this.options.keySeparator;let i=t.ns||this.options.defaultNS||[];const o=n&&e.indexOf(n)>-1,a=!(this.options.userDefinedKeySeparator||t.keySeparator||this.options.userDefinedNsSeparator||t.nsSeparator||function(e,t,n){t=t||"",n=n||"";const r=gA.filter((e=>t.indexOf(e)<0&&n.indexOf(e)<0));if(0===r.length)return  true;const i=vA.getRegExp(`(${r.map((e=>"?"===e?"\\?":e)).join("|")})`);let o=!i.test(e);if(!o){const t=e.indexOf(n);t>0&&!i.test(e.substring(0,t))&&(o=true);}return o}(e,n,r));if(o&&!a){const t=e.match(this.interpolator.nestingRegexp);if(t&&t.length>0)return {key:e,namespaces:i};const o=e.split(n);(n!==r||n===r&&this.options.ns.indexOf(o[0])>-1)&&(i=o.shift()),e=o.join(r);}return "string"==typeof i&&(i=[i]),{key:e,namespaces:i}}translate(e,t,n){if("object"!=typeof t&&this.options.overloadTranslationOptionHandler&&(t=this.options.overloadTranslationOptionHandler(arguments)),"object"==typeof t&&(t={...t}),t||(t={}),null==e)return "";Array.isArray(e)||(e=[String(e)]);const r=void 0!==t.returnDetails?t.returnDetails:this.options.returnDetails,i=void 0!==t.keySeparator?t.keySeparator:this.options.keySeparator,{key:o,namespaces:a}=this.extractFromKey(e[e.length-1],t),s=a[a.length-1],u=t.lng||this.language,l=t.appendNamespaceToCIMode||this.options.appendNamespaceToCIMode;if(u&&"cimode"===u.toLowerCase()){if(l){const e=t.nsSeparator||this.options.nsSeparator;return r?{res:`${s}${e}${o}`,usedKey:o,exactUsedKey:o,usedLng:u,usedNS:s,usedParams:this.getUsedParamsDetails(t)}:`${s}${e}${o}`}return r?{res:o,usedKey:o,exactUsedKey:o,usedLng:u,usedNS:s,usedParams:this.getUsedParamsDetails(t)}:o}const c=this.resolve(e,t);let d=c&&c.res;const f=c&&c.usedKey||o,h=c&&c.exactUsedKey||o,p=Object.prototype.toString.apply(d),m=void 0!==t.joinArrays?t.joinArrays:this.options.joinArrays,g=!this.i18nFormat||this.i18nFormat.handleAsObject;if(g&&d&&("string"!=typeof d&&"boolean"!=typeof d&&"number"!=typeof d)&&["[object Number]","[object Function]","[object RegExp]"].indexOf(p)<0&&("string"!=typeof m||!Array.isArray(d))){if(!t.returnObjects&&!this.options.returnObjects){this.options.returnedObjectHandler||this.logger.warn("accessing an object - but returnObjects options is not enabled!");const e=this.options.returnedObjectHandler?this.options.returnedObjectHandler(f,d,{...t,ns:a}):`key '${o} (${this.language})' returned an object instead of string.`;return r?(c.res=e,c.usedParams=this.getUsedParamsDetails(t),c):e}if(i){const e=Array.isArray(d),n=e?[]:{},r=e?h:f;for(const e in d)if(Object.prototype.hasOwnProperty.call(d,e)){const o=`${r}${i}${e}`;n[e]=this.translate(o,{...t,joinArrays:false,ns:a}),n[e]===o&&(n[e]=d[e]);}d=n;}}else if(g&&"string"==typeof m&&Array.isArray(d))d=d.join(m),d&&(d=this.extendTranslation(d,e,t,n));else {let r=false,a=false;const l=void 0!==t.count&&"string"!=typeof t.count,f=EA.hasDefaultValue(t),h=l?this.pluralResolver.getSuffix(u,t.count,t):"",p=t.ordinal&&l?this.pluralResolver.getSuffix(u,t.count,{ordinal:false}):"",m=l&&!t.ordinal&&0===t.count&&this.pluralResolver.shouldUseIntlApi(),g=m&&t[`defaultValue${this.options.pluralSeparator}zero`]||t[`defaultValue${h}`]||t[`defaultValue${p}`]||t.defaultValue;!this.isValidLookup(d)&&f&&(r=true,d=g),this.isValidLookup(d)||(a=true,d=o);const v=(t.missingKeyNoValueFallbackToKey||this.options.missingKeyNoValueFallbackToKey)&&a?void 0:d,b=f&&g!==d&&this.options.updateMissing;if(a||r||b){if(this.logger.log(b?"updateKey":"missingKey",u,s,o,b?g:d),i){const e=this.resolve(o,{...t,keySeparator:false});e&&e.res&&this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");}let e=[];const n=this.languageUtils.getFallbackCodes(this.options.fallbackLng,t.lng||this.language);if("fallback"===this.options.saveMissingTo&&n&&n[0])for(let t=0;t<n.length;t++)e.push(n[t]);else "all"===this.options.saveMissingTo?e=this.languageUtils.toResolveHierarchy(t.lng||this.language):e.push(t.lng||this.language);const r=(e,n,r)=>{const i=f&&r!==d?r:v;this.options.missingKeyHandler?this.options.missingKeyHandler(e,s,n,i,b,t):this.backendConnector&&this.backendConnector.saveMissing&&this.backendConnector.saveMissing(e,s,n,i,b,t),this.emit("missingKey",e,s,n,d);};this.options.saveMissing&&(this.options.saveMissingPlurals&&l?e.forEach((e=>{const n=this.pluralResolver.getSuffixes(e,t);m&&t[`defaultValue${this.options.pluralSeparator}zero`]&&n.indexOf(`${this.options.pluralSeparator}zero`)<0&&n.push(`${this.options.pluralSeparator}zero`),n.forEach((n=>{r([e],o+n,t[`defaultValue${n}`]||g);}));})):r(e,o,g));}d=this.extendTranslation(d,e,t,c,n),a&&d===o&&this.options.appendNamespaceToMissingKey&&(d=`${s}:${o}`),(a||r)&&this.options.parseMissingKeyHandler&&(d="v1"!==this.options.compatibilityAPI?this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey?`${s}:${o}`:o,r?d:void 0):this.options.parseMissingKeyHandler(d));}return r?(c.res=d,c.usedParams=this.getUsedParamsDetails(t),c):d}extendTranslation(e,t,n,r,i){var o=this;if(this.i18nFormat&&this.i18nFormat.parse)e=this.i18nFormat.parse(e,{...this.options.interpolation.defaultVariables,...n},n.lng||this.language||r.usedLng,r.usedNS,r.usedKey,{resolved:r});else if(!n.skipInterpolation){n.interpolation&&this.interpolator.init({...n,interpolation:{...this.options.interpolation,...n.interpolation}});const a="string"==typeof e&&(n&&n.interpolation&&void 0!==n.interpolation.skipOnVariables?n.interpolation.skipOnVariables:this.options.interpolation.skipOnVariables);let s;if(a){const t=e.match(this.interpolator.nestingRegexp);s=t&&t.length;}let u=n.replace&&"string"!=typeof n.replace?n.replace:n;if(this.options.interpolation.defaultVariables&&(u={...this.options.interpolation.defaultVariables,...u}),e=this.interpolator.interpolate(e,u,n.lng||this.language,n),a){const t=e.match(this.interpolator.nestingRegexp);s<(t&&t.length)&&(n.nest=false);}!n.lng&&"v1"!==this.options.compatibilityAPI&&r&&r.res&&(n.lng=r.usedLng),false!==n.nest&&(e=this.interpolator.nest(e,(function(){for(var e=arguments.length,r=new Array(e),a=0;a<e;a++)r[a]=arguments[a];return i&&i[0]===r[0]&&!n.context?(o.logger.warn(`It seems you are nesting recursively key: ${r[0]} in key: ${t[0]}`),null):o.translate(...r,t)}),n)),n.interpolation&&this.interpolator.reset();}const a=n.postProcess||this.options.postProcess,s="string"==typeof a?[a]:a;return null!=e&&s&&s.length&&false!==n.applyPostProcessor&&(e=_A.handle(s,e,t,this.options&&this.options.postProcessPassResolved?{i18nResolved:{...r,usedParams:this.getUsedParamsDetails(n)},...n}:n,this)),e}resolve(e){let t,n,r,i,o,a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return "string"==typeof e&&(e=[e]),e.forEach((e=>{if(this.isValidLookup(t))return;const s=this.extractFromKey(e,a),u=s.key;n=u;let l=s.namespaces;this.options.fallbackNS&&(l=l.concat(this.options.fallbackNS));const c=void 0!==a.count&&"string"!=typeof a.count,d=c&&!a.ordinal&&0===a.count&&this.pluralResolver.shouldUseIntlApi(),f=void 0!==a.context&&("string"==typeof a.context||"number"==typeof a.context)&&""!==a.context,h=a.lngs?a.lngs:this.languageUtils.toResolveHierarchy(a.lng||this.language,a.fallbackLng);l.forEach((e=>{this.isValidLookup(t)||(o=e,!SA[`${h[0]}-${e}`]&&this.utils&&this.utils.hasLoadedNamespace&&!this.utils.hasLoadedNamespace(o)&&(SA[`${h[0]}-${e}`]=true,this.logger.warn(`key "${n}" for languages "${h.join(", ")}" won't get resolved as namespace "${o}" was not yet loaded`,"This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")),h.forEach((n=>{if(this.isValidLookup(t))return;i=n;const o=[u];if(this.i18nFormat&&this.i18nFormat.addLookupKeys)this.i18nFormat.addLookupKeys(o,u,n,e,a);else {let e;c&&(e=this.pluralResolver.getSuffix(n,a.count,a));const t=`${this.options.pluralSeparator}zero`,r=`${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;if(c&&(o.push(u+e),a.ordinal&&0===e.indexOf(r)&&o.push(u+e.replace(r,this.options.pluralSeparator)),d&&o.push(u+t)),f){const n=`${u}${this.options.contextSeparator}${a.context}`;o.push(n),c&&(o.push(n+e),a.ordinal&&0===e.indexOf(r)&&o.push(n+e.replace(r,this.options.pluralSeparator)),d&&o.push(n+t));}}let s;for(;s=o.pop();)this.isValidLookup(t)||(r=s,t=this.getResource(n,e,s,a));})));}));})),{res:t,usedKey:n,exactUsedKey:r,usedLng:i,usedNS:o}}isValidLookup(e){return !(void 0===e||!this.options.returnNull&&null===e||!this.options.returnEmptyString&&""===e)}getResource(e,t,n){let r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};return this.i18nFormat&&this.i18nFormat.getResource?this.i18nFormat.getResource(e,t,n,r):this.resourceStore.getResource(e,t,n,r)}getUsedParamsDetails(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const t=["defaultValue","ordinal","context","replace","lng","lngs","fallbackLng","ns","keySeparator","nsSeparator","returnObjects","returnDetails","joinArrays","postProcess","interpolation"],n=e.replace&&"string"!=typeof e.replace;let r=n?e.replace:e;if(n&&void 0!==e.count&&(r.count=e.count),this.options.interpolation.defaultVariables&&(r={...this.options.interpolation.defaultVariables,...r}),!n){r={...r};for(const e of t)delete r[e];}return r}static hasDefaultValue(e){const t="defaultValue";for(const n in e)if(Object.prototype.hasOwnProperty.call(e,n)&&t===n.substring(0,12)&&void 0!==e[n])return  true;return  false}}function kA(e){return e.charAt(0).toUpperCase()+e.slice(1)}class MA{constructor(e){this.options=e,this.supportedLngs=this.options.supportedLngs||false,this.logger=iA.create("languageUtils");}getScriptPartFromCode(e){if(!(e=yA(e))||e.indexOf("-")<0)return null;const t=e.split("-");return 2===t.length?null:(t.pop(),"x"===t[t.length-1].toLowerCase()?null:this.formatLanguageCode(t.join("-")))}getLanguagePartFromCode(e){if(!(e=yA(e))||e.indexOf("-")<0)return e;const t=e.split("-");return this.formatLanguageCode(t[0])}formatLanguageCode(e){if("string"==typeof e&&e.indexOf("-")>-1){const t=["hans","hant","latn","cyrl","cans","mong","arab"];let n=e.split("-");return this.options.lowerCaseLng?n=n.map((e=>e.toLowerCase())):2===n.length?(n[0]=n[0].toLowerCase(),n[1]=n[1].toUpperCase(),t.indexOf(n[1].toLowerCase())>-1&&(n[1]=kA(n[1].toLowerCase()))):3===n.length&&(n[0]=n[0].toLowerCase(),2===n[1].length&&(n[1]=n[1].toUpperCase()),"sgn"!==n[0]&&2===n[2].length&&(n[2]=n[2].toUpperCase()),t.indexOf(n[1].toLowerCase())>-1&&(n[1]=kA(n[1].toLowerCase())),t.indexOf(n[2].toLowerCase())>-1&&(n[2]=kA(n[2].toLowerCase()))),n.join("-")}return this.options.cleanCode||this.options.lowerCaseLng?e.toLowerCase():e}isSupportedCode(e){return ("languageOnly"===this.options.load||this.options.nonExplicitSupportedLngs)&&(e=this.getLanguagePartFromCode(e)),!this.supportedLngs||!this.supportedLngs.length||this.supportedLngs.indexOf(e)>-1}getBestMatchFromCodes(e){if(!e)return null;let t;return e.forEach((e=>{if(t)return;const n=this.formatLanguageCode(e);this.options.supportedLngs&&!this.isSupportedCode(n)||(t=n);})),!t&&this.options.supportedLngs&&e.forEach((e=>{if(t)return;const n=this.getLanguagePartFromCode(e);if(this.isSupportedCode(n))return t=n;t=this.options.supportedLngs.find((e=>e===n?e:e.indexOf("-")<0&&n.indexOf("-")<0?void 0:e.indexOf("-")>0&&n.indexOf("-")<0&&e.substring(0,e.indexOf("-"))===n||0===e.indexOf(n)&&n.length>1?e:void 0));})),t||(t=this.getFallbackCodes(this.options.fallbackLng)[0]),t}getFallbackCodes(e,t){if(!e)return [];if("function"==typeof e&&(e=e(t)),"string"==typeof e&&(e=[e]),Array.isArray(e))return e;if(!t)return e.default||[];let n=e[t];return n||(n=e[this.getScriptPartFromCode(t)]),n||(n=e[this.formatLanguageCode(t)]),n||(n=e[this.getLanguagePartFromCode(t)]),n||(n=e.default),n||[]}toResolveHierarchy(e,t){const n=this.getFallbackCodes(t||this.options.fallbackLng||[],e),r=[],i=e=>{e&&(this.isSupportedCode(e)?r.push(e):this.logger.warn(`rejecting language code not found in supportedLngs: ${e}`));};return "string"==typeof e&&(e.indexOf("-")>-1||e.indexOf("_")>-1)?("languageOnly"!==this.options.load&&i(this.formatLanguageCode(e)),"languageOnly"!==this.options.load&&"currentOnly"!==this.options.load&&i(this.getScriptPartFromCode(e)),"currentOnly"!==this.options.load&&i(this.getLanguagePartFromCode(e))):"string"==typeof e&&i(this.formatLanguageCode(e)),n.forEach((e=>{r.indexOf(e)<0&&i(this.formatLanguageCode(e));})),r}}let CA=[{lngs:["ach","ak","am","arn","br","fil","gun","ln","mfe","mg","mi","oc","pt","pt-BR","tg","tl","ti","tr","uz","wa"],nr:[1,2],fc:1},{lngs:["af","an","ast","az","bg","bn","ca","da","de","dev","el","en","eo","es","et","eu","fi","fo","fur","fy","gl","gu","ha","hi","hu","hy","ia","it","kk","kn","ku","lb","mai","ml","mn","mr","nah","nap","nb","ne","nl","nn","no","nso","pa","pap","pms","ps","pt-PT","rm","sco","se","si","so","son","sq","sv","sw","ta","te","tk","ur","yo"],nr:[1,2],fc:2},{lngs:["ay","bo","cgg","fa","ht","id","ja","jbo","ka","km","ko","ky","lo","ms","sah","su","th","tt","ug","vi","wo","zh"],nr:[1],fc:3},{lngs:["be","bs","cnr","dz","hr","ru","sr","uk"],nr:[1,2,5],fc:4},{lngs:["ar"],nr:[0,1,2,3,11,100],fc:5},{lngs:["cs","sk"],nr:[1,2,5],fc:6},{lngs:["csb","pl"],nr:[1,2,5],fc:7},{lngs:["cy"],nr:[1,2,3,8],fc:8},{lngs:["fr"],nr:[1,2],fc:9},{lngs:["ga"],nr:[1,2,3,7,11],fc:10},{lngs:["gd"],nr:[1,2,3,20],fc:11},{lngs:["is"],nr:[1,2],fc:12},{lngs:["jv"],nr:[0,1],fc:13},{lngs:["kw"],nr:[1,2,3,4],fc:14},{lngs:["lt"],nr:[1,2,10],fc:15},{lngs:["lv"],nr:[1,2,0],fc:16},{lngs:["mk"],nr:[1,2],fc:17},{lngs:["mnk"],nr:[0,1,2],fc:18},{lngs:["mt"],nr:[1,2,11,20],fc:19},{lngs:["or"],nr:[2,1],fc:2},{lngs:["ro"],nr:[1,2,20],fc:20},{lngs:["sl"],nr:[5,1,2,3],fc:21},{lngs:["he","iw"],nr:[1,2,20,21],fc:22}],xA={1:function(e){return Number(e>1)},2:function(e){return Number(1!=e)},3:function(e){return 0},4:function(e){return Number(e%10==1&&e%100!=11?0:e%10>=2&&e%10<=4&&(e%100<10||e%100>=20)?1:2)},5:function(e){return Number(0==e?0:1==e?1:2==e?2:e%100>=3&&e%100<=10?3:e%100>=11?4:5)},6:function(e){return Number(1==e?0:e>=2&&e<=4?1:2)},7:function(e){return Number(1==e?0:e%10>=2&&e%10<=4&&(e%100<10||e%100>=20)?1:2)},8:function(e){return Number(1==e?0:2==e?1:8!=e&&11!=e?2:3)},9:function(e){return Number(e>=2)},10:function(e){return Number(1==e?0:2==e?1:e<7?2:e<11?3:4)},11:function(e){return Number(1==e||11==e?0:2==e||12==e?1:e>2&&e<20?2:3)},12:function(e){return Number(e%10!=1||e%100==11)},13:function(e){return Number(0!==e)},14:function(e){return Number(1==e?0:2==e?1:3==e?2:3)},15:function(e){return Number(e%10==1&&e%100!=11?0:e%10>=2&&(e%100<10||e%100>=20)?1:2)},16:function(e){return Number(e%10==1&&e%100!=11?0:0!==e?1:2)},17:function(e){return Number(1==e||e%10==1&&e%100!=11?0:1)},18:function(e){return Number(0==e?0:1==e?1:2)},19:function(e){return Number(1==e?0:0==e||e%100>1&&e%100<11?1:e%100>10&&e%100<20?2:3)},20:function(e){return Number(1==e?0:0==e||e%100>0&&e%100<20?1:2)},21:function(e){return Number(e%100==1?1:e%100==2?2:e%100==3||e%100==4?3:0)},22:function(e){return Number(1==e?0:2==e?1:(e<0||e>10)&&e%10==0?2:3)}};const AA=["v1","v2","v3"],RA=["v4"],TA={zero:0,one:1,two:2,few:3,many:4,other:5};class PA{constructor(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};this.languageUtils=e,this.options=t,this.logger=iA.create("pluralResolver"),this.options.compatibilityJSON&&!RA.includes(this.options.compatibilityJSON)||"undefined"!=typeof Intl&&Intl.PluralRules||(this.options.compatibilityJSON="v3",this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")),this.rules=function(){const e={};return CA.forEach((t=>{t.lngs.forEach((n=>{e[n]={numbers:t.nr,plurals:xA[t.fc]};}));})),e}();}addRule(e,t){this.rules[e]=t;}getRule(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(this.shouldUseIntlApi())try{return new Intl.PluralRules(yA("dev"===e?"en":e),{type:t.ordinal?"ordinal":"cardinal"})}catch(e){return}return this.rules[e]||this.rules[this.languageUtils.getLanguagePartFromCode(e)]}needsPlural(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};const n=this.getRule(e,t);return this.shouldUseIntlApi()?n&&n.resolvedOptions().pluralCategories.length>1:n&&n.numbers.length>1}getPluralFormsOfKey(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return this.getSuffixes(e,n).map((e=>`${t}${e}`))}getSuffixes(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};const n=this.getRule(e,t);return n?this.shouldUseIntlApi()?n.resolvedOptions().pluralCategories.sort(((e,t)=>TA[e]-TA[t])).map((e=>`${this.options.prepend}${t.ordinal?`ordinal${this.options.prepend}`:""}${e}`)):n.numbers.map((n=>this.getSuffix(e,n,t))):[]}getSuffix(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};const r=this.getRule(e,n);return r?this.shouldUseIntlApi()?`${this.options.prepend}${n.ordinal?`ordinal${this.options.prepend}`:""}${r.select(t)}`:this.getSuffixRetroCompatible(r,t):(this.logger.warn(`no plural rule found for: ${e}`),"")}getSuffixRetroCompatible(e,t){const n=e.noAbs?e.plurals(t):e.plurals(Math.abs(t));let r=e.numbers[n];this.options.simplifyPluralSuffix&&2===e.numbers.length&&1===e.numbers[0]&&(2===r?r="plural":1===r&&(r=""));const i=()=>this.options.prepend&&r.toString()?this.options.prepend+r.toString():r.toString();return "v1"===this.options.compatibilityJSON?1===r?"":"number"==typeof r?`_plural_${r.toString()}`:i():"v2"===this.options.compatibilityJSON||this.options.simplifyPluralSuffix&&2===e.numbers.length&&1===e.numbers[0]?i():this.options.prepend&&n.toString()?this.options.prepend+n.toString():n.toString()}shouldUseIntlApi(){return !AA.includes(this.options.compatibilityJSON)}}function LA(e,t,n){let r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:".",i=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],o=function(e,t,n){const r=dA(e,n);return void 0!==r?r:dA(t,n)}(e,t,n);return !o&&i&&"string"==typeof n&&(o=bA(e,n,r),void 0===o&&(o=bA(t,n,r))),o}class IA{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.logger=iA.create("interpolator"),this.options=e,this.format=e.interpolation&&e.interpolation.format||(e=>e),this.init(e);}init(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};e.interpolation||(e.interpolation={escapeValue:true});const{escape:t,escapeValue:n,useRawValueToEscape:r,prefix:i,prefixEscaped:o,suffix:a,suffixEscaped:s,formatSeparator:u,unescapeSuffix:l,unescapePrefix:c,nestingPrefix:d,nestingPrefixEscaped:f,nestingSuffix:h,nestingSuffixEscaped:p,nestingOptionsSeparator:m,maxReplaces:g,alwaysFormat:v}=e.interpolation;this.escape=void 0!==t?t:mA,this.escapeValue=void 0===n||n,this.useRawValueToEscape=void 0!==r&&r,this.prefix=i?hA(i):o||"{{",this.suffix=a?hA(a):s||"}}",this.formatSeparator=u||",",this.unescapePrefix=l?"":c||"-",this.unescapeSuffix=this.unescapePrefix?"":l||"",this.nestingPrefix=d?hA(d):f||hA("$t("),this.nestingSuffix=h?hA(h):p||hA(")"),this.nestingOptionsSeparator=m||",",this.maxReplaces=g||1e3,this.alwaysFormat=void 0!==v&&v,this.resetRegExp();}reset(){this.options&&this.init(this.options);}resetRegExp(){const e=(e,t)=>e&&e.source===t?(e.lastIndex=0,e):new RegExp(t,"g");this.regexp=e(this.regexp,`${this.prefix}(.+?)${this.suffix}`),this.regexpUnescape=e(this.regexpUnescape,`${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`),this.nestingRegexp=e(this.nestingRegexp,`${this.nestingPrefix}(.+?)${this.nestingSuffix}`);}interpolate(e,t,n,r){let i,o,a;const s=this.options&&this.options.interpolation&&this.options.interpolation.defaultVariables||{};function u(e){return e.replace(/\$/g,"$$$$")}const l=e=>{if(e.indexOf(this.formatSeparator)<0){const i=LA(t,s,e,this.options.keySeparator,this.options.ignoreJSONStructure);return this.alwaysFormat?this.format(i,void 0,n,{...r,...t,interpolationkey:e}):i}const i=e.split(this.formatSeparator),o=i.shift().trim(),a=i.join(this.formatSeparator).trim();return this.format(LA(t,s,o,this.options.keySeparator,this.options.ignoreJSONStructure),a,n,{...r,...t,interpolationkey:o})};this.resetRegExp();const c=r&&r.missingInterpolationHandler||this.options.missingInterpolationHandler,d=r&&r.interpolation&&void 0!==r.interpolation.skipOnVariables?r.interpolation.skipOnVariables:this.options.interpolation.skipOnVariables;return [{regex:this.regexpUnescape,safeValue:e=>u(e)},{regex:this.regexp,safeValue:e=>this.escapeValue?u(this.escape(e)):u(e)}].forEach((t=>{for(a=0;i=t.regex.exec(e);){const n=i[1].trim();if(o=l(n),void 0===o)if("function"==typeof c){const t=c(e,i,r);o="string"==typeof t?t:"";}else if(r&&Object.prototype.hasOwnProperty.call(r,n))o="";else {if(d){o=i[0];continue}this.logger.warn(`missed to pass in variable ${n} for interpolating ${e}`),o="";}else "string"==typeof o||this.useRawValueToEscape||(o=sA(o));const s=t.safeValue(o);if(e=e.replace(i[0],s),d?(t.regex.lastIndex+=o.length,t.regex.lastIndex-=i[0].length):t.regex.lastIndex=0,a++,a>=this.maxReplaces)break}})),e}nest(e,t){let n,r,i,o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};function a(e,t){const n=this.nestingOptionsSeparator;if(e.indexOf(n)<0)return e;const r=e.split(new RegExp(`${n}[ ]*{`));let o=`{${r[1]}`;e=r[0],o=this.interpolate(o,i);const a=o.match(/'/g),s=o.match(/"/g);(a&&a.length%2==0&&!s||s.length%2!=0)&&(o=o.replace(/'/g,'"'));try{i=JSON.parse(o),t&&(i={...t,...i});}catch(t){return this.logger.warn(`failed parsing options string in nesting for key ${e}`,t),`${e}${n}${o}`}return i.defaultValue&&i.defaultValue.indexOf(this.prefix)>-1&&delete i.defaultValue,e}for(;n=this.nestingRegexp.exec(e);){let s=[];i={...o},i=i.replace&&"string"!=typeof i.replace?i.replace:i,i.applyPostProcessor=false,delete i.defaultValue;let u=false;if(-1!==n[0].indexOf(this.formatSeparator)&&!/{.*}/.test(n[1])){const e=n[1].split(this.formatSeparator).map((e=>e.trim()));n[1]=e.shift(),s=e,u=true;}if(r=t(a.call(this,n[1].trim(),i),i),r&&n[0]===e&&"string"!=typeof r)return r;"string"!=typeof r&&(r=sA(r)),r||(this.logger.warn(`missed to resolve ${n[1]} for nesting ${e}`),r=""),u&&(r=s.reduce(((e,t)=>this.format(e,t,o.lng,{...o,interpolationkey:n[1].trim()})),r.trim())),e=e.replace(n[0],r),this.regexp.lastIndex=0;}return e}}function OA(e){const t={};return function(n,r,i){const o=r+JSON.stringify(i);let a=t[o];return a||(a=e(yA(r),i),t[o]=a),a(n)}}class NA{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.logger=iA.create("formatter"),this.options=e,this.formats={number:OA(((e,t)=>{const n=new Intl.NumberFormat(e,{...t});return e=>n.format(e)})),currency:OA(((e,t)=>{const n=new Intl.NumberFormat(e,{...t,style:"currency"});return e=>n.format(e)})),datetime:OA(((e,t)=>{const n=new Intl.DateTimeFormat(e,{...t});return e=>n.format(e)})),relativetime:OA(((e,t)=>{const n=new Intl.RelativeTimeFormat(e,{...t});return e=>n.format(e,t.range||"day")})),list:OA(((e,t)=>{const n=new Intl.ListFormat(e,{...t});return e=>n.format(e)}))},this.init(e);}init(e){const t=(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{interpolation:{}}).interpolation;this.formatSeparator=t.formatSeparator?t.formatSeparator:t.formatSeparator||",";}add(e,t){this.formats[e.toLowerCase().trim()]=t;}addCached(e,t){this.formats[e.toLowerCase().trim()]=OA(t);}format(e,t,n){let r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};const i=t.split(this.formatSeparator).reduce(((e,t)=>{const{formatName:i,formatOptions:o}=function(e){let t=e.toLowerCase().trim();const n={};if(e.indexOf("(")>-1){const r=e.split("(");t=r[0].toLowerCase().trim();const i=r[1].substring(0,r[1].length-1);"currency"===t&&i.indexOf(":")<0?n.currency||(n.currency=i.trim()):"relativetime"===t&&i.indexOf(":")<0?n.range||(n.range=i.trim()):i.split(";").forEach((e=>{if(e){const[t,...r]=e.split(":"),i=r.join(":").trim().replace(/^'+|'+$/g,""),o=t.trim();n[o]||(n[o]=i),"false"===i&&(n[o]=false),"true"===i&&(n[o]=true),isNaN(i)||(n[o]=parseInt(i,10));}}));}return {formatName:t,formatOptions:n}}(t);if(this.formats[i]){let t=e;try{const a=r&&r.formatParams&&r.formatParams[r.interpolationkey]||{},s=a.locale||a.lng||r.locale||r.lng||n;t=this.formats[i](e,s,{...o,...r,...a});}catch(e){this.logger.warn(e);}return t}return this.logger.warn(`there was no format function for ${i}`),e}),e);return i}}class DA extends oA{constructor(e,t,n){let r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:{};super(),this.backend=e,this.store=t,this.services=n,this.languageUtils=n.languageUtils,this.options=r,this.logger=iA.create("backendConnector"),this.waitingReads=[],this.maxParallelReads=r.maxParallelReads||10,this.readingCalls=0,this.maxRetries=r.maxRetries>=0?r.maxRetries:5,this.retryTimeout=r.retryTimeout>=1?r.retryTimeout:350,this.state={},this.queue=[],this.backend&&this.backend.init&&this.backend.init(n,r.backend,r);}queueLoad(e,t,n,r){const i={},o={},a={},s={};return e.forEach((e=>{let r=true;t.forEach((t=>{const a=`${e}|${t}`;!n.reload&&this.store.hasResourceBundle(e,t)?this.state[a]=2:this.state[a]<0||(1===this.state[a]?void 0===o[a]&&(o[a]=true):(this.state[a]=1,r=false,void 0===o[a]&&(o[a]=true),void 0===i[a]&&(i[a]=true),void 0===s[t]&&(s[t]=true)));})),r||(a[e]=true);})),(Object.keys(i).length||Object.keys(o).length)&&this.queue.push({pending:o,pendingCount:Object.keys(o).length,loaded:{},errors:[],callback:r}),{toLoad:Object.keys(i),pending:Object.keys(o),toLoadLanguages:Object.keys(a),toLoadNamespaces:Object.keys(s)}}loaded(e,t,n){const r=e.split("|"),i=r[0],o=r[1];t&&this.emit("failedLoading",i,o,t),n&&this.store.addResourceBundle(i,o,n,void 0,void 0,{skipCopy:true}),this.state[e]=t?-1:2;const a={};this.queue.forEach((n=>{!function(e,t,n,r){const{obj:i,k:o}=lA(e,t,Object);i[o]=i[o]||[],i[o].push(n);}(n.loaded,[i],o),function(e,t){ void 0!==e.pending[t]&&(delete e.pending[t],e.pendingCount--);}(n,e),t&&n.errors.push(t),0!==n.pendingCount||n.done||(Object.keys(n.loaded).forEach((e=>{a[e]||(a[e]={});const t=n.loaded[e];t.length&&t.forEach((t=>{ void 0===a[e][t]&&(a[e][t]=true);}));})),n.done=true,n.errors.length?n.callback(n.errors):n.callback());})),this.emit("loaded",a),this.queue=this.queue.filter((e=>!e.done));}read(e,t,n){let r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:this.retryTimeout,o=arguments.length>5?arguments[5]:void 0;if(!e.length)return o(null,{});if(this.readingCalls>=this.maxParallelReads)return void this.waitingReads.push({lng:e,ns:t,fcName:n,tried:r,wait:i,callback:o});this.readingCalls++;const a=(a,s)=>{if(this.readingCalls--,this.waitingReads.length>0){const e=this.waitingReads.shift();this.read(e.lng,e.ns,e.fcName,e.tried,e.wait,e.callback);}a&&s&&r<this.maxRetries?setTimeout((()=>{this.read.call(this,e,t,n,r+1,2*i,o);}),i):o(a,s);},s=this.backend[n].bind(this.backend);if(2!==s.length)return s(e,t,a);try{const n=s(e,t);n&&"function"==typeof n.then?n.then((e=>a(null,e))).catch(a):a(null,n);}catch(e){a(e);}}prepareLoading(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},r=arguments.length>3?arguments[3]:void 0;if(!this.backend)return this.logger.warn("No backend was added via i18next.use. Will not load resources."),r&&r();"string"==typeof e&&(e=this.languageUtils.toResolveHierarchy(e)),"string"==typeof t&&(t=[t]);const i=this.queueLoad(e,t,n,r);if(!i.toLoad.length)return i.pending.length||r(),null;i.toLoad.forEach((e=>{this.loadOne(e);}));}load(e,t,n){this.prepareLoading(e,t,{},n);}reload(e,t,n){this.prepareLoading(e,t,{reload:true},n);}loadOne(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";const n=e.split("|"),r=n[0],i=n[1];this.read(r,i,"read",void 0,void 0,((n,o)=>{n&&this.logger.warn(`${t}loading namespace ${i} for language ${r} failed`,n),!n&&o&&this.logger.log(`${t}loaded namespace ${i} for language ${r}`,o),this.loaded(e,n,o);}));}saveMissing(e,t,n,r,i){let o=arguments.length>5&&void 0!==arguments[5]?arguments[5]:{},a=arguments.length>6&&void 0!==arguments[6]?arguments[6]:()=>{};if(this.services.utils&&this.services.utils.hasLoadedNamespace&&!this.services.utils.hasLoadedNamespace(t))this.logger.warn(`did not save key "${n}" as the namespace "${t}" was not yet loaded`,"This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");else if(null!=n&&""!==n){if(this.backend&&this.backend.create){const s={...o,isUpdate:i},u=this.backend.create.bind(this.backend);if(u.length<6)try{let i;i=5===u.length?u(e,t,n,r,s):u(e,t,n,r),i&&"function"==typeof i.then?i.then((e=>a(null,e))).catch(a):a(null,i);}catch(e){a(e);}else u(e,t,n,r,a,s);}e&&e[0]&&this.store.addResource(e[0],t,n,r);}}}function jA(){return {debug:false,initImmediate:true,ns:["translation"],defaultNS:["translation"],fallbackLng:["dev"],fallbackNS:false,supportedLngs:false,nonExplicitSupportedLngs:false,load:"all",preload:false,simplifyPluralSuffix:true,keySeparator:".",nsSeparator:":",pluralSeparator:"_",contextSeparator:"_",partialBundledLanguages:false,saveMissing:false,updateMissing:false,saveMissingTo:"fallback",saveMissingPlurals:true,missingKeyHandler:false,missingInterpolationHandler:false,postProcess:false,postProcessPassResolved:false,returnNull:false,returnEmptyString:true,returnObjects:false,joinArrays:false,returnedObjectHandler:false,parseMissingKeyHandler:false,appendNamespaceToMissingKey:false,appendNamespaceToCIMode:false,overloadTranslationOptionHandler:function(e){let t={};if("object"==typeof e[1]&&(t=e[1]),"string"==typeof e[1]&&(t.defaultValue=e[1]),"string"==typeof e[2]&&(t.tDescription=e[2]),"object"==typeof e[2]||"object"==typeof e[3]){const n=e[3]||e[2];Object.keys(n).forEach((e=>{t[e]=n[e];}));}return t},interpolation:{escapeValue:true,format:e=>e,prefix:"{{",suffix:"}}",formatSeparator:",",unescapePrefix:"-",nestingPrefix:"$t(",nestingSuffix:")",nestingOptionsSeparator:",",maxReplaces:1e3,skipOnVariables:true}}}function BA(e){return "string"==typeof e.ns&&(e.ns=[e.ns]),"string"==typeof e.fallbackLng&&(e.fallbackLng=[e.fallbackLng]),"string"==typeof e.fallbackNS&&(e.fallbackNS=[e.fallbackNS]),e.supportedLngs&&e.supportedLngs.indexOf("cimode")<0&&(e.supportedLngs=e.supportedLngs.concat(["cimode"])),e}function zA(){}class UA extends oA{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1?arguments[1]:void 0;var n;if(super(),this.options=BA(e),this.services={},this.logger=iA,this.modules={external:[]},n=this,Object.getOwnPropertyNames(Object.getPrototypeOf(n)).forEach((e=>{"function"==typeof n[e]&&(n[e]=n[e].bind(n));})),t&&!this.isInitialized&&!e.isClone){if(!this.options.initImmediate)return this.init(e,t),this;setTimeout((()=>{this.init(e,t);}),0);}}init(){var e=this;let t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=arguments.length>1?arguments[1]:void 0;this.isInitializing=true,"function"==typeof t&&(n=t,t={}),!t.defaultNS&&false!==t.defaultNS&&t.ns&&("string"==typeof t.ns?t.defaultNS=t.ns:t.ns.indexOf("translation")<0&&(t.defaultNS=t.ns[0]));const r=jA();function i(e){return e?"function"==typeof e?new e:e:null}if(this.options={...r,...this.options,...BA(t)},"v1"!==this.options.compatibilityAPI&&(this.options.interpolation={...r.interpolation,...this.options.interpolation}),void 0!==t.keySeparator&&(this.options.userDefinedKeySeparator=t.keySeparator),void 0!==t.nsSeparator&&(this.options.userDefinedNsSeparator=t.nsSeparator),!this.options.isClone){let t;this.modules.logger?iA.init(i(this.modules.logger),this.options):iA.init(null,this.options),this.modules.formatter?t=this.modules.formatter:"undefined"!=typeof Intl&&(t=NA);const n=new MA(this.options);this.store=new wA(this.options.resources,this.options);const o=this.services;o.logger=iA,o.resourceStore=this.store,o.languageUtils=n,o.pluralResolver=new PA(n,{prepend:this.options.pluralSeparator,compatibilityJSON:this.options.compatibilityJSON,simplifyPluralSuffix:this.options.simplifyPluralSuffix}),!t||this.options.interpolation.format&&this.options.interpolation.format!==r.interpolation.format||(o.formatter=i(t),o.formatter.init(o,this.options),this.options.interpolation.format=o.formatter.format.bind(o.formatter)),o.interpolator=new IA(this.options),o.utils={hasLoadedNamespace:this.hasLoadedNamespace.bind(this)},o.backendConnector=new DA(i(this.modules.backend),o.resourceStore,o,this.options),o.backendConnector.on("*",(function(t){for(var n=arguments.length,r=new Array(n>1?n-1:0),i=1;i<n;i++)r[i-1]=arguments[i];e.emit(t,...r);})),this.modules.languageDetector&&(o.languageDetector=i(this.modules.languageDetector),o.languageDetector.init&&o.languageDetector.init(o,this.options.detection,this.options)),this.modules.i18nFormat&&(o.i18nFormat=i(this.modules.i18nFormat),o.i18nFormat.init&&o.i18nFormat.init(this)),this.translator=new EA(this.services,this.options),this.translator.on("*",(function(t){for(var n=arguments.length,r=new Array(n>1?n-1:0),i=1;i<n;i++)r[i-1]=arguments[i];e.emit(t,...r);})),this.modules.external.forEach((e=>{e.init&&e.init(this);}));}if(this.format=this.options.interpolation.format,n||(n=zA),this.options.fallbackLng&&!this.services.languageDetector&&!this.options.lng){const e=this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);e.length>0&&"dev"!==e[0]&&(this.options.lng=e[0]);}this.services.languageDetector||this.options.lng||this.logger.warn("init: no languageDetector is used and no lng is defined");["getResource","hasResourceBundle","getResourceBundle","getDataByLanguage"].forEach((t=>{this[t]=function(){return e.store[t](...arguments)};}));["addResource","addResources","addResourceBundle","removeResourceBundle"].forEach((t=>{this[t]=function(){return e.store[t](...arguments),e};}));const o=aA(),a=()=>{const e=(e,t)=>{this.isInitializing=false,this.isInitialized&&!this.initializedStoreOnce&&this.logger.warn("init: i18next is already initialized. You should call init just once!"),this.isInitialized=true,this.options.isClone||this.logger.log("initialized",this.options),this.emit("initialized",this.options),o.resolve(t),n(e,t);};if(this.languages&&"v1"!==this.options.compatibilityAPI&&!this.isInitialized)return e(null,this.t.bind(this));this.changeLanguage(this.options.lng,e);};return this.options.resources||!this.options.initImmediate?a():setTimeout(a,0),o}loadResources(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:zA;const n="string"==typeof e?e:this.language;if("function"==typeof e&&(t=e),!this.options.resources||this.options.partialBundledLanguages){if(n&&"cimode"===n.toLowerCase()&&(!this.options.preload||0===this.options.preload.length))return t();const e=[],r=t=>{if(!t)return;if("cimode"===t)return;this.services.languageUtils.toResolveHierarchy(t).forEach((t=>{"cimode"!==t&&e.indexOf(t)<0&&e.push(t);}));};if(n)r(n);else {this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((e=>r(e)));}this.options.preload&&this.options.preload.forEach((e=>r(e))),this.services.backendConnector.load(e,this.options.ns,(e=>{e||this.resolvedLanguage||!this.language||this.setResolvedLanguage(this.language),t(e);}));}else t(null);}reloadResources(e,t,n){const r=aA();return e||(e=this.languages),t||(t=this.options.ns),n||(n=zA),this.services.backendConnector.reload(e,t,(e=>{r.resolve(),n(e);})),r}use(e){if(!e)throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");if(!e.type)throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");return "backend"===e.type&&(this.modules.backend=e),("logger"===e.type||e.log&&e.warn&&e.error)&&(this.modules.logger=e),"languageDetector"===e.type&&(this.modules.languageDetector=e),"i18nFormat"===e.type&&(this.modules.i18nFormat=e),"postProcessor"===e.type&&_A.addPostProcessor(e),"formatter"===e.type&&(this.modules.formatter=e),"3rdParty"===e.type&&this.modules.external.push(e),this}setResolvedLanguage(e){if(e&&this.languages&&!(["cimode","dev"].indexOf(e)>-1))for(let e=0;e<this.languages.length;e++){const t=this.languages[e];if(!(["cimode","dev"].indexOf(t)>-1)&&this.store.hasLanguageSomeTranslations(t)){this.resolvedLanguage=t;break}}}changeLanguage(e,t){var n=this;this.isLanguageChangingTo=e;const r=aA();this.emit("languageChanging",e);const i=e=>{this.language=e,this.languages=this.services.languageUtils.toResolveHierarchy(e),this.resolvedLanguage=void 0,this.setResolvedLanguage(e);},o=(e,o)=>{o?(i(o),this.translator.changeLanguage(o),this.isLanguageChangingTo=void 0,this.emit("languageChanged",o),this.logger.log("languageChanged",o)):this.isLanguageChangingTo=void 0,r.resolve((function(){return n.t(...arguments)})),t&&t(e,(function(){return n.t(...arguments)}));},a=t=>{e||t||!this.services.languageDetector||(t=[]);const n="string"==typeof t?t:this.services.languageUtils.getBestMatchFromCodes(t);n&&(this.language||i(n),this.translator.language||this.translator.changeLanguage(n),this.services.languageDetector&&this.services.languageDetector.cacheUserLanguage&&this.services.languageDetector.cacheUserLanguage(n)),this.loadResources(n,(e=>{o(e,n);}));};return e||!this.services.languageDetector||this.services.languageDetector.async?!e&&this.services.languageDetector&&this.services.languageDetector.async?0===this.services.languageDetector.detect.length?this.services.languageDetector.detect().then(a):this.services.languageDetector.detect(a):a(e):a(this.services.languageDetector.detect()),r}getFixedT(e,t,n){var r=this;const i=function(e,t){let o;if("object"!=typeof t){for(var a=arguments.length,s=new Array(a>2?a-2:0),u=2;u<a;u++)s[u-2]=arguments[u];o=r.options.overloadTranslationOptionHandler([e,t].concat(s));}else o={...t};o.lng=o.lng||i.lng,o.lngs=o.lngs||i.lngs,o.ns=o.ns||i.ns,o.keyPrefix=o.keyPrefix||n||i.keyPrefix;const l=r.options.keySeparator||".";let c;return c=o.keyPrefix&&Array.isArray(e)?e.map((e=>`${o.keyPrefix}${l}${e}`)):o.keyPrefix?`${o.keyPrefix}${l}${e}`:e,r.t(c,o)};return "string"==typeof e?i.lng=e:i.lngs=e,i.ns=t,i.keyPrefix=n,i}t(){return this.translator&&this.translator.translate(...arguments)}exists(){return this.translator&&this.translator.exists(...arguments)}setDefaultNamespace(e){this.options.defaultNS=e;}hasLoadedNamespace(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!this.isInitialized)return this.logger.warn("hasLoadedNamespace: i18next was not initialized",this.languages),false;if(!this.languages||!this.languages.length)return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty",this.languages),false;const n=t.lng||this.resolvedLanguage||this.languages[0],r=!!this.options&&this.options.fallbackLng,i=this.languages[this.languages.length-1];if("cimode"===n.toLowerCase())return  true;const o=(e,t)=>{const n=this.services.backendConnector.state[`${e}|${t}`];return  -1===n||2===n};if(t.precheck){const e=t.precheck(this,o);if(void 0!==e)return e}return !!this.hasResourceBundle(n,e)||(!(this.services.backendConnector.backend&&(!this.options.resources||this.options.partialBundledLanguages))||!(!o(n,e)||r&&!o(i,e)))}loadNamespaces(e,t){const n=aA();return this.options.ns?("string"==typeof e&&(e=[e]),e.forEach((e=>{this.options.ns.indexOf(e)<0&&this.options.ns.push(e);})),this.loadResources((e=>{n.resolve(),t&&t(e);})),n):(t&&t(),Promise.resolve())}loadLanguages(e,t){const n=aA();"string"==typeof e&&(e=[e]);const r=this.options.preload||[],i=e.filter((e=>r.indexOf(e)<0&&this.services.languageUtils.isSupportedCode(e)));return i.length?(this.options.preload=r.concat(i),this.loadResources((e=>{n.resolve(),t&&t(e);})),n):(t&&t(),Promise.resolve())}dir(e){if(e||(e=this.resolvedLanguage||(this.languages&&this.languages.length>0?this.languages[0]:this.language)),!e)return "rtl";const t=this.services&&this.services.languageUtils||new MA(jA());return ["ar","shu","sqr","ssh","xaa","yhd","yud","aao","abh","abv","acm","acq","acw","acx","acy","adf","ads","aeb","aec","afb","ajp","apc","apd","arb","arq","ars","ary","arz","auz","avl","ayh","ayl","ayn","ayp","bbz","pga","he","iw","ps","pbt","pbu","pst","prp","prd","ug","ur","ydd","yds","yih","ji","yi","hbo","men","xmn","fa","jpr","peo","pes","prs","dv","sam","ckb"].indexOf(t.getLanguagePartFromCode(e))>-1||e.toLowerCase().indexOf("-arab")>1?"rtl":"ltr"}static createInstance(){return new UA(arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},arguments.length>1?arguments[1]:void 0)}cloneInstance(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:zA;const n=e.forkResourceStore;n&&delete e.forkResourceStore;const r={...this.options,...e,isClone:true},i=new UA(r);void 0===e.debug&&void 0===e.prefix||(i.logger=i.logger.clone(e));return ["store","services","language"].forEach((e=>{i[e]=this[e];})),i.services={...this.services},i.services.utils={hasLoadedNamespace:i.hasLoadedNamespace.bind(i)},n&&(i.store=new wA(this.store.data,r),i.services.resourceStore=i.store),i.translator=new EA(i.services,r),i.translator.on("*",(function(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];i.emit(e,...n);})),i.init(r,t),i.translator.options=r,i.translator.backendConnector.services.utils={hasLoadedNamespace:i.hasLoadedNamespace.bind(i)},i}toJSON(){return {options:this.options,store:this.store,language:this.language,languages:this.languages,resolvedLanguage:this.resolvedLanguage}}}const FA=UA.createInstance();FA.createInstance=UA.createInstance;const KA=FA.createInstance;FA.dir,FA.init,FA.loadResources,FA.reloadResources,FA.use,FA.changeLanguage,FA.getFixedT,FA.t,FA.exists,FA.setDefaultNamespace,FA.hasLoadedNamespace,FA.loadNamespaces,FA.loadLanguages;var qA,HA={name:"@metamask/sdk",version:"0.30.1",description:"",homepage:"https://github.com/MetaMask/metamask-sdk#readme",bugs:{url:"https://github.com/MetaMask/metamask-sdk/issues"},repository:{type:"git",url:"https://github.com/MetaMask/metamask-sdk",directory:"packages/sdk"},main:"dist/node/cjs/metamask-sdk.js",unpkg:"dist/browser/umd/metamask-sdk.js",module:"dist/node/es/metamask-sdk.js",browser:"dist/browser/umd/metamask-sdk.js","react-native":"dist/react-native/es/metamask-sdk.js",types:"dist/browser/es/src/index.d.ts",sideEffects:false,files:["/dist"],scripts:{build:"rm -rf dist && rollup -c --bundleConfigAsCjs","build:dev":"rimraf dist && NODE_ENV=dev rollup -c --bundleConfigAsCjs","build:post-tsc":"echo 'N/A'","build:pre-tsc":"echo 'N/A'",clean:"rimraf ./dist",size:"node bundle-size && size-limit",lint:"yarn lint:eslint && yarn lint:misc --check","lint:changelog":"../../scripts/validate-changelog.sh @metamask/sdk","lint:eslint":"eslint . --cache --ext js,ts","lint:fix":"yarn lint:eslint --fix && yarn lint:misc --write","lint:misc":"prettier '**/*.json' '**/*.md' '!CHANGELOG.md' --ignore-path ../../.gitignore",prepack:"../../scripts/prepack.sh","publish:preview":"yarn npm publish --tag preview",reset:"yarn clean && rimraf ./node_modules/",test:'jest --testPathIgnorePatterns "/e2e/"',"test:coverage":'jest --coverage --testPathIgnorePatterns "/e2e/"',"test:e2e":'jest --testPathPattern "/e2e/"',"test:ci":'jest --coverage --passWithNoTests --setupFilesAfterEnv ./jest-preload.js --testPathIgnorePatterns "/e2e/"',"test:dev":'jest -c ./jest.config.ts --detectOpenHandles  --testPathIgnorePatterns "/e2e/"',watch:"rollup -c -w"},dependencies:{"@metamask/onboarding":"^1.0.1","@metamask/providers":"16.1.0","@metamask/sdk-communication-layer":"workspace:*","@metamask/sdk-install-modal-web":"workspace:*",bowser:"^2.9.0","cross-fetch":"^4.0.0",debug:"^4.3.4",eciesjs:"^0.4.8","eth-rpc-errors":"^4.0.3",eventemitter2:"^6.4.7",i18next:"23.11.5","i18next-browser-languagedetector":"7.1.0","obj-multiplex":"^1.0.0",pump:"^3.0.0","qrcode-terminal-nooctal":"^0.12.1","react-native-webview":"^11.26.0","readable-stream":"^3.6.2","socket.io-client":"^4.5.1",util:"^0.12.4",uuid:"^8.3.2"},devDependencies:{"@jest/globals":"^29.3.1","@lavamoat/allow-scripts":"^2.3.1","@metamask/auto-changelog":"3.1.0","@metamask/eslint-config":"^6.0.0","@metamask/eslint-config-nodejs":"^6.0.0","@metamask/eslint-config-typescript":"^6.0.0","@react-native-async-storage/async-storage":"^1.19.6","@rollup/plugin-commonjs":"^25.0.7","@rollup/plugin-json":"^6.0.0","@rollup/plugin-node-resolve":"^15.0.2","@rollup/plugin-terser":"^0.4.1","@size-limit/preset-big-lib":"^11.0.2","@types/dom-screen-wake-lock":"^1.0.2","@types/node":"^20.1.3","@types/pump":"^1.1.1","@types/qrcode-terminal":"^0.12.0","@types/uuid":"^10.0.0","@typescript-eslint/eslint-plugin":"^4.26.0","@typescript-eslint/parser":"^4.26.0",eslint:"^7.30.0","eslint-config-prettier":"^8.3.0","eslint-plugin-import":"^2.23.4","eslint-plugin-jest":"^24.4.0","eslint-plugin-jsdoc":"^36.1.0","eslint-plugin-node":"^11.1.0","eslint-plugin-prettier":"^3.4.0",jest:"^29.3.1","jest-environment-jsdom":"^29.3.1",prettier:"^2.3.0",react:"^18.2.0","react-dom":"18.2.0",rimraf:"^4.4.0",rollup:"^3.21.7","rollup-plugin-jscc":"^2.0.0","rollup-plugin-natives":"^0.7.5","rollup-plugin-node-builtins":"^2.1.2","rollup-plugin-node-globals":"^1.4.0","rollup-plugin-polyfill-node":"^0.11.0","rollup-plugin-sizes":"^1.0.6","rollup-plugin-typescript2":"^0.31.2","rollup-plugin-visualizer":"^5.9.2","size-limit":"^11.0.2","ts-jest":"^29.0.3","ts-node":"^10.9.1",tslib:"latest",typescript:"^4.3.2"},peerDependencies:{react:"^18.2.0","react-dom":"^18.2.0"},peerDependenciesMeta:{react:{optional:true},"react-dom":{optional:true}},publishConfig:{access:"public",registry:"https://registry.npmjs.org/"},lavamoat:{allowScripts:{"eciesjs>secp256k1":false,"socket.io-client>engine.io-client>ws>bufferutil":false,"socket.io-client>engine.io-client>ws>utf-8-validate":false,"@metamask/sdk-communication-layer>bufferutil":false,"@metamask/sdk-communication-layer>eciesjs>secp256k1":false,"@metamask/sdk-communication-layer>utf-8-validate":false}}};!function(e){e.INPAGE="metamask-inpage",e.CONTENT_SCRIPT="metamask-contentscript",e.PROVIDER="metamask-provider";}(qA||(qA={}));const WA="direct",$A="https://metamask.app.link/connect",VA="metamask://connect",YA={NAME:"MetaMask",RDNS:"io.metamask"},GA=/(?:^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}$)|(?:^0{8}-0{4}-0{4}-0{4}-0{12}$)/u;const ZA={Initialized:"initialized",DisplayURI:"display_uri",ProviderUpdate:"provider_update",ConnectWithResponse:"connectWithResponse",ConnectionStatus:"connection_status",ServiceStatus:"service_status"};var QA;e.PROVIDER_UPDATE_TYPE=void 0,(QA=e.PROVIDER_UPDATE_TYPE||(e.PROVIDER_UPDATE_TYPE={})).TERMINATE="terminate",QA.EXTENSION="extension",QA.INITIALIZED="initialized";const JA="undefined"!=typeof window&&window.localStorage;function XA({instance:e,msg:t}){return kk(this,void 0,void 0,(function*(){if(e._initialized||(xx("[MetaMaskSDK: connectAndSign()] provider not ready -- wait for init()"),yield e.init()),xx(`[MetaMaskSDK: connectAndSign()] activeProvider=${e.activeProvider}`),!e.activeProvider)throw new Error("SDK state invalid -- undefined provider");const n=function(e){return /^0x([0-9A-Fa-f]{2})*$/u.test(e)}(t)?t:function(e){let t;if("undefined"!=typeof Buffer)t=Buffer.from(e,"utf8").toString("hex");else if("undefined"!=typeof TextEncoder){const n=(new TextEncoder).encode(e);t=Array.from(n).map((e=>e.toString(16).padStart(2,"0"))).join("");}else {if("object"!=typeof commonjsGlobal||!("Buffer"in commonjsGlobal))throw new Error("Unable to convert string to hex: No available method.");t=commonjsGlobal.Buffer.from(e,"utf8").toString("hex");}return `0x${t}`}(t);return e.activeProvider.request({method:Kx.METAMASK_CONNECTWITH,params:[{method:Kx.PERSONAL_SIGN,params:[n]}]})}))}function eR(t){var n,r;return kk(this,void 0,void 0,(function*(){xx("[MetaMaskSDK: connectWithExtensionProvider()] ",t),t.sdkProvider=t.activeProvider,t.activeProvider=window.extension,window.ethereum=window.extension;try{const e=yield null===(n=window.extension)||void 0===n?void 0:n.request({method:"eth_requestAccounts"});xx(`[MetaMaskSDK: connectWithExtensionProvider()] accounts=${e}`);}catch(e){return void console.warn("[MetaMaskSDK: connectWithExtensionProvider()] can't request accounts error",e)}localStorage.setItem(Vx,"extension"),t.extensionActive=true,t.emit(ZA.ProviderUpdate,e.PROVIDER_UPDATE_TYPE.EXTENSION),t.options.enableAnalytics&&(null===(r=t.analytics)||void 0===r||r.send({event:ZE.SDK_USE_EXTENSION}));}))}function tR(e){return tR="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},tR(e)}function nR(e){var t=function(e,t){if("object"!==tR(e)||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var r=n.call(e,t);if("object"!==tR(r))return r;throw new TypeError("@@toPrimitive must return a primitive value.")}return (String)(e)}(e,"string");return "symbol"===tR(t)?t:String(t)}function rR(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||false,r.configurable=true,"value"in r&&(r.writable=true),Object.defineProperty(e,nR(r.key),r);}}var iR=[],oR=iR.forEach,aR=iR.slice;var sR=/^[\u0009\u0020-\u007e\u0080-\u00ff]+$/,uR=function(e,t,n,r){var i=arguments.length>4&&void 0!==arguments[4]?arguments[4]:{path:"/",sameSite:"strict"};n&&(i.expires=new Date,i.expires.setTime(i.expires.getTime()+60*n*1e3)),r&&(i.domain=r),document.cookie=function(e,t,n){var r=n||{};r.path=r.path||"/";var i=encodeURIComponent(t),o="".concat(e,"=").concat(i);if(r.maxAge>0){var a=r.maxAge-0;if(Number.isNaN(a))throw new Error("maxAge should be a Number");o+="; Max-Age=".concat(Math.floor(a));}if(r.domain){if(!sR.test(r.domain))throw new TypeError("option domain is invalid");o+="; Domain=".concat(r.domain);}if(r.path){if(!sR.test(r.path))throw new TypeError("option path is invalid");o+="; Path=".concat(r.path);}if(r.expires){if("function"!=typeof r.expires.toUTCString)throw new TypeError("option expires is invalid");o+="; Expires=".concat(r.expires.toUTCString());}if(r.httpOnly&&(o+="; HttpOnly"),r.secure&&(o+="; Secure"),r.sameSite)switch("string"==typeof r.sameSite?r.sameSite.toLowerCase():r.sameSite){case  true:o+="; SameSite=Strict";break;case "lax":o+="; SameSite=Lax";break;case "strict":o+="; SameSite=Strict";break;case "none":o+="; SameSite=None";break;default:throw new TypeError("option sameSite is invalid")}return o}(e,encodeURIComponent(t),i);},lR=function(e){for(var t="".concat(e,"="),n=document.cookie.split(";"),r=0;r<n.length;r++){for(var i=n[r];" "===i.charAt(0);)i=i.substring(1,i.length);if(0===i.indexOf(t))return i.substring(t.length,i.length)}return null},cR={name:"cookie",lookup:function(e){var t;if(e.lookupCookie&&"undefined"!=typeof document){var n=lR(e.lookupCookie);n&&(t=n);}return t},cacheUserLanguage:function(e,t){t.lookupCookie&&"undefined"!=typeof document&&uR(t.lookupCookie,e,t.cookieMinutes,t.cookieDomain,t.cookieOptions);}},dR={name:"querystring",lookup:function(e){var t;if("undefined"!=typeof window){var n=window.location.search;!window.location.search&&window.location.hash&&window.location.hash.indexOf("?")>-1&&(n=window.location.hash.substring(window.location.hash.indexOf("?")));for(var r=n.substring(1).split("&"),i=0;i<r.length;i++){var o=r[i].indexOf("=");if(o>0)r[i].substring(0,o)===e.lookupQuerystring&&(t=r[i].substring(o+1));}}return t}},fR=null,hR=function(){if(null!==fR)return fR;try{fR="undefined"!==window&&null!==window.localStorage;var e="i18next.translate.boo";window.localStorage.setItem(e,"foo"),window.localStorage.removeItem(e);}catch(e){fR=false;}return fR},pR={name:"localStorage",lookup:function(e){var t;if(e.lookupLocalStorage&&hR()){var n=window.localStorage.getItem(e.lookupLocalStorage);n&&(t=n);}return t},cacheUserLanguage:function(e,t){t.lookupLocalStorage&&hR()&&window.localStorage.setItem(t.lookupLocalStorage,e);}},mR=null,gR=function(){if(null!==mR)return mR;try{mR="undefined"!==window&&null!==window.sessionStorage;var e="i18next.translate.boo";window.sessionStorage.setItem(e,"foo"),window.sessionStorage.removeItem(e);}catch(e){mR=false;}return mR},vR={name:"sessionStorage",lookup:function(e){var t;if(e.lookupSessionStorage&&gR()){var n=window.sessionStorage.getItem(e.lookupSessionStorage);n&&(t=n);}return t},cacheUserLanguage:function(e,t){t.lookupSessionStorage&&gR()&&window.sessionStorage.setItem(t.lookupSessionStorage,e);}},bR={name:"navigator",lookup:function(e){var t=[];if("undefined"!=typeof navigator){if(navigator.languages)for(var n=0;n<navigator.languages.length;n++)t.push(navigator.languages[n]);navigator.userLanguage&&t.push(navigator.userLanguage),navigator.language&&t.push(navigator.language);}return t.length>0?t:void 0}},yR={name:"htmlTag",lookup:function(e){var t,n=e.htmlTag||("undefined"!=typeof document?document.documentElement:null);return n&&"function"==typeof n.getAttribute&&(t=n.getAttribute("lang")),t}},wR={name:"path",lookup:function(e){var t;if("undefined"!=typeof window){var n=window.location.pathname.match(/\/([a-zA-Z-]*)/g);if(n instanceof Array)if("number"==typeof e.lookupFromPathIndex){if("string"!=typeof n[e.lookupFromPathIndex])return;t=n[e.lookupFromPathIndex].replace("/","");}else t=n[0].replace("/","");}return t}},_R={name:"subdomain",lookup:function(e){var t="number"==typeof e.lookupFromSubdomainIndex?e.lookupFromSubdomainIndex+1:1,n="undefined"!=typeof window&&window.location&&window.location.hostname&&window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);if(n)return n[t]}};var SR=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.type="languageDetector",this.detectors={},this.init(t,n);}var t,n;return t=e,n=[{key:"init",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};this.services=e||{languageUtils:{}},this.options=function(e){return oR.call(aR.call(arguments,1),(function(t){if(t)for(var n in t) void 0===e[n]&&(e[n]=t[n]);})),e}(t,this.options||{},{order:["querystring","cookie","localStorage","sessionStorage","navigator","htmlTag"],lookupQuerystring:"lng",lookupCookie:"i18next",lookupLocalStorage:"i18nextLng",lookupSessionStorage:"i18nextLng",caches:["localStorage"],excludeCacheFor:["cimode"],convertDetectedLanguage:function(e){return e}}),"string"==typeof this.options.convertDetectedLanguage&&this.options.convertDetectedLanguage.indexOf("15897")>-1&&(this.options.convertDetectedLanguage=function(e){return e.replace("-","_")}),this.options.lookupFromUrlIndex&&(this.options.lookupFromPathIndex=this.options.lookupFromUrlIndex),this.i18nOptions=n,this.addDetector(cR),this.addDetector(dR),this.addDetector(pR),this.addDetector(vR),this.addDetector(bR),this.addDetector(yR),this.addDetector(wR),this.addDetector(_R);}},{key:"addDetector",value:function(e){this.detectors[e.name]=e;}},{key:"detect",value:function(e){var t=this;e||(e=this.options.order);var n=[];return e.forEach((function(e){if(t.detectors[e]){var r=t.detectors[e].lookup(t.options);r&&"string"==typeof r&&(r=[r]),r&&(n=n.concat(r));}})),n=n.map((function(e){return t.options.convertDetectedLanguage(e)})),this.services.languageUtils.getBestMatchFromCodes?n:n.length>0?n[0]:null}},{key:"cacheUserLanguage",value:function(e,t){var n=this;t||(t=this.options.caches),t&&(this.options.excludeCacheFor&&this.options.excludeCacheFor.indexOf(e)>-1||t.forEach((function(t){n.detectors[t]&&n.detectors[t].cacheUserLanguage(e,n.options);})));}}],n&&rR(t.prototype,n),Object.defineProperty(t,"prototype",{writable:false}),e}();SR.type="languageDetector";var ER={DESKTOP:"Desktop",MOBILE:"Mobile",META_MASK_MOBILE_APP:"MetaMask mobile app",SCAN_TO_CONNECT:"Scan to connect and sign with",CONNECT_WITH_EXTENSION:"Connect With MetaMask Extension",INSTALL_MODAL:{TRUSTED_BY_USERS:"Trusted by over 30 million users to buy, store, send and swap crypto securely",LEADING_CRYPTO_WALLET:"The leading crypto wallet & gateway to blockchain apps built on Ethereum Mainnet, Polygon, Optimism, and many other networks",CONTROL_DIGITAL_INTERACTIONS:"Puts you in control of your digital interactions by making power of cryptography more accessible",INSTALL_META_MASK_EXTENSION:"Install MetaMask Extension"},PENDING_MODAL:{OPEN_META_MASK_SELECT_CODE:"Please open the MetaMask wallet app and select the code on the screen OR disconnect",OPEN_META_MASK_CONTINUE:"Open the MetaMask app to continue with your session.",NUMBER_AFTER_OPEN_NOTICE:"If a number doesn't appear after opening MetaMask, please click disconnect and re-scan the QRCode.",DISCONNECT:"Disconnect"},SELECT_MODAL:{CRYPTO_TAKE_CONTROL_TEXT:"Take control of your crypto and explore the blockchain with the wallet trusted by over 30 million people worldwide"},META_MASK_MODAL:{ADDRESS_COPIED:"Address copied to clipboard!",DISCONNECT:"Disconnect",ACTIVE_NETWORK:"Active Network"}},kR={DESKTOP:"Escritorio",MOBILE:"Móvil",META_MASK_MOBILE_APP:"Aplicación móvil de MetaMask",SCAN_TO_CONNECT:"Escanear para conectar y firmar con",CONNECT_WITH_EXTENSION:"Conectar con la Extensión de MetaMask",INSTALL_MODAL:{TRUSTED_BY_USERS:"Confiado por más de 30 millones de usuarios para comprar, almacenar, enviar e intercambiar cripto de manera segura",LEADING_CRYPTO_WALLET:"La principal billetera de criptomonedas y pasarela hacia aplicaciones blockchain construidas en Ethereum Mainnet, Polygon, Optimism y muchas otras redes",CONTROL_DIGITAL_INTERACTIONS:"Te da el control de tus interacciones digitales al hacer que el poder de la criptografía sea más accesible",INSTALL_META_MASK_EXTENSION:"Instalar la Extensión de MetaMask"},PENDING_MODAL:{OPEN_META_MASK_SELECT_CODE:"Por favor, abre la aplicación de billetera MetaMask y selecciona el código en la pantalla O desconecta",OPEN_META_MASK_CONTINUE:"Abre la aplicación de MetaMask para continuar con tu sesión.",NUMBER_AFTER_OPEN_NOTICE:"Si no aparece un número después de abrir MetaMask, por favor haz clic en desconectar y vuelve a escanear el código QR.",DISCONNECT:"Desconectar"},SELECT_MODAL:{CRYPTO_TAKE_CONTROL_TEXT:"Toma el control de tu cripto y explora la blockchain con la billetera en la que confían más de 30 millones de personas en todo el mundo"},META_MASK_MODAL:{ADDRESS_COPIED:"¡Dirección copiada al portapapeles!",DISCONNECT:"Desconectar",ACTIVE_NETWORK:"Red activa"}},MR={DESKTOP:"Bureau",MOBILE:"Mobile",META_MASK_MOBILE_APP:"Application mobile MetaMask",SCAN_TO_CONNECT:"Scannez pour vous connecter et signer avec",CONNECT_WITH_EXTENSION:"Connectez-vous avec l'extension MetaMask",INSTALL_MODAL:{TRUSTED_BY_USERS:"Fait confiance à plus de 30 millions d'utilisateurs pour acheter, stocker, envoyer et échanger des crypto en toute sécurité",LEADING_CRYPTO_WALLET:"Le portefeuille crypto leader et la passerelle vers des applications blockchain basées sur Ethereum Mainnet, Polygon, Optimism, et de nombreux autres réseaux",CONTROL_DIGITAL_INTERACTIONS:"Vous donne le contrôle de vos interactions numériques en rendant la puissance de la cryptographie plus accessible",INSTALL_META_MASK_EXTENSION:"Installez l'extension MetaMask"},PENDING_MODAL:{OPEN_META_MASK_SELECT_CODE:"Veuillez ouvrir l'application MetaMask et sélectionnez le code à l'écran OU déconnectez-vous",OPEN_META_MASK_CONTINUE:"Ouvrez l'application MetaMask pour continuer votre session.",NUMBER_AFTER_OPEN_NOTICE:"Si un numéro n'apparaît pas après avoir ouvert MetaMask, veuillez cliquer sur déconnecter et rescanner le QRCode.",DISCONNECT:"Déconnecter"},SELECT_MODAL:{CRYPTO_TAKE_CONTROL_TEXT:"Prenez le contrôle de votre crypto et explorez la blockchain avec le portefeuille fait confiance par plus de 30 millions de personnes à travers le monde"},META_MASK_MODAL:{ADDRESS_COPIED:"Adresse copiée dans le presse-papiers!",DISCONNECT:"Déconnecter",ACTIVE_NETWORK:"Réseau actif"}},CR={DESKTOP:"שולחן עבודה",MOBILE:"נייד",META_MASK_MOBILE_APP:"אפליקציית מטא מאסק לנייד",SCAN_TO_CONNECT:"סרוק כדי להתחבר ולחתום עם",CONNECT_WITH_EXTENSION:"התחבר עם התוסף של מטא מאסק",INSTALL_MODAL:{TRUSTED_BY_USERS:"מהימנים על ידי למעלה מ-30 מיליון משתמשים לקנות, לאחסן, לשלוח ולהחליף מטבע קריפטוגרפי בבטחה",LEADING_CRYPTO_WALLET:"ארנק הקריפטו המוביל והשער ליישומי בלוקצ'יין המתוכנתים על אתריום, פוליגון, ורשתות רבות נוספות",CONTROL_DIGITAL_INTERACTIONS:"מכניס אותך לשליטה על האינטראקציות הדיגיטליות שלך על ידי הפיכת כוח הקריפטוגרפיה לנגיש יותר",INSTALL_META_MASK_EXTENSION:"התקן את ההרחבה של מטא מאסק"},PENDING_MODAL:{OPEN_META_MASK_SELECT_CODE:"אנא פתח את אפליקציית ארנק מטא מאסק ובחר את הקוד שמופיע על המסך או התנתק",OPEN_META_MASK_CONTINUE:"פתח את האפליקציה של מטא מאסק כדי להמשיך בפעולה שלך.",NUMBER_AFTER_OPEN_NOTICE:"אם מספר אינו מופיע לאחר פתיחת מטא מאסק, אנא לחץ על התנתקות וסרוק מחדש את ה-QRCode.",DISCONNECT:"התנתק"},SELECT_MODAL:{CRYPTO_TAKE_CONTROL_TEXT:"קח שליטה על הקריפטו שלך וחקור את הבלוקצ'יין עם הארנק האמין שבשימוש על ידי למעלה מ-30 מיליון אנשים ברחבי העולם"},META_MASK_MODAL:{ADDRESS_COPIED:"הכתובת הועתקה ללוח!",DISCONNECT:"התנתק",ACTIVE_NETWORK:"רשת פעילה"}},xR={DESKTOP:"Desktop",MOBILE:"Mobile",META_MASK_MOBILE_APP:"App mobile MetaMask",SCAN_TO_CONNECT:"Scansiona per connetterti e firmare con",CONNECT_WITH_EXTENSION:"Connettiti con l'estensione MetaMask",INSTALL_MODAL:{TRUSTED_BY_USERS:"Ritenuto affidabile da oltre 30 milioni di utenti per acquistare, conservare, inviare e scambiare cripto in modo sicuro",LEADING_CRYPTO_WALLET:"Il principale portafoglio cripto e gateway per applicazioni blockchain funzionanti su Ethereum Mainnet, Polygon, Optimism e molte altre reti",CONTROL_DIGITAL_INTERACTIONS:"Ti da il controllo delle tue interazioni digitali rendendo piu' accessibile il potere della crittografia",INSTALL_META_MASK_EXTENSION:"Installa l'estensione MetaMask"},PENDING_MODAL:{OPEN_META_MASK_SELECT_CODE:"Si prega di aprire l'app mobile MetaMask Wallet e selezionare il codice sullo schermo OPPURE scollegarsi",OPEN_META_MASK_CONTINUE:"Apri l'app mobile MetaMask per continuare con la tua sessione.",NUMBER_AFTER_OPEN_NOTICE:"Se, dopo aver aperto MetaMask, non appare alcun numero, si prega di fare clic su disconnetti e ris canzionare il QRCode.",DISCONNECT:"Disconnetti"},SELECT_MODAL:{CRYPTO_TAKE_CONTROL_TEXT:"Prendi il controllo delle tue cripto e esplora la blockchain con il portafoglio ritenuto affidabile da oltre 30 milioni di persone in tutto il mondo"},META_MASK_MODAL:{ADDRESS_COPIED:"Indirizzo copiato negli appunti!",DISCONNECT:"Disconnetti",ACTIVE_NETWORK:"Rete attiva"}},AR={DESKTOP:"Desktop",MOBILE:"Móvel",META_MASK_MOBILE_APP:"Aplicativo móvel MetaMask",SCAN_TO_CONNECT:"Escanear para conectar e assinar com",CONNECT_WITH_EXTENSION:"Conectar com a extensão MetaMask",INSTALL_MODAL:{TRUSTED_BY_USERS:"Confiado por mais de 30 milhões de usuários para comprar, armazenar, enviar e trocar cripto com segurança",LEADING_CRYPTO_WALLET:"A principal carteira de cripto & portal para aplicativos blockchain construídos em Ethereum Mainnet, Polygon, Optimism, e muitas outras redes",CONTROL_DIGITAL_INTERACTIONS:"Coloca você no controle de suas interações digitais, tornando o poder da criptografia mais acessível",INSTALL_META_MASK_EXTENSION:"Instalar a extensão MetaMask"},PENDING_MODAL:{OPEN_META_MASK_SELECT_CODE:"Por favor, abra o aplicativo MetaMask e selecione o código na tela OU desconecte",OPEN_META_MASK_CONTINUE:"Abra o aplicativo MetaMask para continuar sua sessão.",NUMBER_AFTER_OPEN_NOTICE:"Se um número não aparecer após abrir o MetaMask, por favor clique em desconectar e re-escaneie o QRCode.",DISCONNECT:"Desconectar"},SELECT_MODAL:{CRYPTO_TAKE_CONTROL_TEXT:"Assuma o controle de sua cripto e explore a blockchain com a carteira confiada por mais de 30 milhões de pessoas em todo o mundo"},META_MASK_MODAL:{ADDRESS_COPIED:"Endereço copiado para a área de transferência!",DISCONNECT:"Desconectar",ACTIVE_NETWORK:"Rede ativa"}},RR={DESKTOP:"Masaüstü",MOBILE:"Mobil",META_MASK_MOBILE_APP:"MetaMask mobil uygulama",SCAN_TO_CONNECT:"Bağlanmak ve imzalamak için tarayın",CONNECT_WITH_EXTENSION:"MetaMask Eklentisi ile Bağlan",INSTALL_MODAL:{TRUSTED_BY_USERS:"Kriptoyu güvenle satın almak, saklamak, göndermek ve değiştirmek için 30 milyondan fazla kullanıcı tarafından güvenilir",LEADING_CRYPTO_WALLET:"Ethereum Ana Ağı, Polygon, Optimism ve birçok diğer ağda kurulu blockchain uygulamalarına erişim sağlayan öncü kripto cüzdanı",CONTROL_DIGITAL_INTERACTIONS:"Kriptografinin gücünü daha erişilebilir kılarak dijital etkileşimlerinizin kontrolünü size verir",INSTALL_META_MASK_EXTENSION:"MetaMask Eklentisini Yükleyin"},PENDING_MODAL:{OPEN_META_MASK_SELECT_CODE:"Lütfen MetaMask cüzdan uygulamasını açın ve ekrandaki kodu seçin YA DA bağlantıyı kesin",OPEN_META_MASK_CONTINUE:"Oturumunuzla devam etmek için MetaMask uygulamasını açın.",NUMBER_AFTER_OPEN_NOTICE:"MetaMask'ı açtıktan sonra bir numara görünmezse, lütfen bağlantıyı kesin ve QR Kodunu tekrar tarayın.",DISCONNECT:"Bağlantıyı Kes"},SELECT_MODAL:{CRYPTO_TAKE_CONTROL_TEXT:"Kriptonuzu kontrol edin ve dünya genelinde 30 milyondan fazla kişi tarafından güvenilen cüzdanla blockchain'i keşfedin"},META_MASK_MODAL:{ADDRESS_COPIED:"Adres panoya kopyalandı!",DISCONNECT:"Bağlantıyı Kes",ACTIVE_NETWORK:"Aktif Ağ"}};function TR(e){let t;if("undefined"!=typeof Buffer)t=Buffer.from(e,"utf8").toString("base64");else if("function"==typeof btoa)t=btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/gu,((e,t)=>String.fromCharCode(parseInt(t,16)))));else {if("object"!=typeof commonjsGlobal||!("Buffer"in commonjsGlobal))throw new Error("Unable to base64 encode: No available method.");t=commonjsGlobal.Buffer.from(e,"utf8").toString("base64");}return t}class PR{constructor({shouldSetOnWindow:e,connectionStream:t,shouldSendMetadata:n=false,shouldShimWeb3:r,sdkInstance:i}){const o=new Xx({connectionStream:t,shouldSendMetadata:n,shouldSetOnWindow:e,shouldShimWeb3:r,autoRequestAccounts:false}),a=new Proxy(o,{deleteProperty:()=>true});var s;this.provider=a,this.sdkInstance=i,e&&"undefined"!=typeof window&&(s=o,window.ethereum=s,window.dispatchEvent(new Event("ethereum#initialized"))),r&&"undefined"!=typeof window&&function(e,t=console){let n=false,r=false;if(!window.web3){const i="__isMetaMaskShim__";let o={currentProvider:e};Object.defineProperty(o,i,{value:true,enumerable:true,configurable:false,writable:false}),o=new Proxy(o,{get:(o,a,...s)=>("currentProvider"!==a||n?"currentProvider"===a||a===i||r||(r=true,t.error("MetaMask no longer injects web3. For details, see: https://docs.metamask.io/guide/provider-migration.html#replacing-window-web3"),e.request({method:"metamask_logWeb3ShimUsage"}).catch((e=>{t.debug("MetaMask: Failed to log web3 shim usage.",e);}))):(n=true,t.warn("You are accessing the MetaMask window.web3.currentProvider shim. This property is deprecated; use window.ethereum instead. For details, see: https://docs.metamask.io/guide/provider-migration.html#replacing-window-web3")),Reflect.get(o,a,...s)),set:(...e)=>(t.warn("You are accessing the MetaMask window.web3 shim. This object is deprecated; use window.ethereum instead. For details, see: https://docs.metamask.io/guide/provider-migration.html#replacing-window-web3"),Reflect.set(...e))}),Object.defineProperty(window,"web3",{value:o,enumerable:false,configurable:true,writable:true});}}(this.provider),this.provider.on("display_uri",(e=>{this.sdkInstance.emit(ZA.DisplayURI,e);})),this.provider.on("_initialized",(()=>{const e={chainId:this.provider.getChainId(),isConnected:this.provider.isConnected(),isMetaMask:this.provider.isMetaMask,selectedAddress:this.provider.getSelectedAddress(),networkVersion:this.provider.getNetworkVersion()};this.sdkInstance.emit(ZA.Initialized,e),xx("[Ethereum: constructor()] provider initialized",e);}));}static init(e){var t;return xx("[Ethereum: init()] Initializing Ethereum service"),this.instance=new PR(e),null===(t=this.instance)||void 0===t?void 0:t.provider}static destroy(){}static getInstance(){var e;if(!(null===(e=this.instance)||void 0===e?void 0:e.provider))throw new Error("Ethereum instance not intiialized - call Ethereum.factory first.");return this.instance}static getProvider(){var e;if(!(null===(e=this.instance)||void 0===e?void 0:e.provider))throw new Error("Ethereum instance not intiialized - call Ethereum.factory first.");return this.instance.provider}}function LR(e,t,n,r){var i,o,a,s,u,l,c,d,f,h,p,m,g,v,b,y,w,S,E,k;return kk(this,void 0,void 0,(function*(){const n=null===(i=e.state.remote)||void 0===i?void 0:i.isReady(),M=null===(o=e.state.remote)||void 0===o?void 0:o.isConnected(),C=null===(a=e.state.remote)||void 0===a?void 0:a.isPaused(),x=PR.getProvider(),A=null===(s=e.state.remote)||void 0===s?void 0:s.getChannelId(),R=null===(u=e.state.remote)||void 0===u?void 0:u.isAuthorized(),{deeplinkProtocol:T}=e.state,{method:P,data:L,triggeredInstaller:I}=(e=>{var t,n,r,i;let o;_.isBuffer(e)?(o=e.toJSON(),o._isBuffer=true):o=e;const a=null===(t=null==o?void 0:o.data)||void 0===t?void 0:t.method;let s=false;return "object"==typeof(null===(n=null==o?void 0:o.data)||void 0===n?void 0:n.params)&&true===(null===(i=null===(r=null==o?void 0:o.data)||void 0===r?void 0:r.params)||void 0===i?void 0:i.__triggeredInstaller)&&(s=true,o.data.params=o.data.params.wrappedParams),{method:a,data:o,triggeredInstaller:s}})(t);if(xx(`[RCPMS: write()] method='${P}' isRemoteReady=${n} channelId=${A} isSocketConnected=${M} isRemotePaused=${C} providerConnected=${x.isConnected()}`,t),!A)return P!==Kx.METAMASK_GETPROVIDERSTATE&&xx(`[RCPMS: write()] ${P} --\x3e channelId is undefined`),r(new Error("disconnected"));xx(`[RCPMS: write()] remote.isPaused()=${null===(l=e.state.remote)||void 0===l?void 0:l.isPaused()} authorized=${R} ready=${n} socketConnected=${M}`,t);const O=null===(c=e.state.platformManager)||void 0===c?void 0:c.isSecure(),N=null!==(f=null===(d=e.state.platformManager)||void 0===d?void 0:d.isMobileWeb())&&void 0!==f&&f,D=null!==(p=null===(h=e.state.remote)||void 0===h?void 0:h.hasDeeplinkProtocol())&&void 0!==p&&p&&N&&R;try{if(D&&!I||null===(m=e.state.remote)||void 0===m||m.sendMessage(null==L?void 0:L.data).then((()=>{xx(`[RCPMS: _write()] ${P} sent successfully`);})).catch((e=>{xx("[RCPMS: _write()] error sending message",e);})),!O)return xx(`[RCPMS: _write()] unsecure platform for method ${P} -- return callback`),r();if(I)return xx("[RCPMS: _write()] prevent deeplink -- installation completed separately."),r();const t=null!==(b=null===(v=null===(g=e.state.remote)||void 0===g?void 0:g.getKeyInfo())||void 0===v?void 0:v.ecies.public)&&void 0!==b?b:"";let n=encodeURI(`channelId=${A}&pubkey=${t}&comm=socket&t=d&v=2`);if(D){const t=JSON.stringify(null==L?void 0:L.data),i=null===(y=e.state.remote)||void 0===y?void 0:y.encrypt(t);if(!i)return xx("[RCPMS: _write()] error encrypting message"),r(new Error("RemoteCommunicationPostMessageStream - disconnected"));n+=`&scheme=${T}&rpc=${TR(i)}`;}if(!(null===(w=e.state.platformManager)||void 0===w?void 0:w.isMetaMaskInstalled()))return xx("[RCPMS: _write()] prevent deeplink until installation is completed."),r();qx[P]?(xx(`[RCPMS: _write()] redirect link for '${P}' socketConnected=${M} connect?${n}`),null===(S=e.state.platformManager)||void 0===S||S.openDeeplink(`${$A}?${n}`,`${VA}?${n}`,"_self")):(null===(E=e.state.remote)||void 0===E?void 0:E.isPaused())?(xx(`[RCPMS: _write()] MM is PAUSED! deeplink with connect! targetMethod=${P}`),null===(k=e.state.platformManager)||void 0===k||k.openDeeplink(`${$A}?redirect=true&${n}`,`${VA}?redirect=true&${n}`,"_self")):xx(`[RCPMS: _write()] method ${P} doesn't need redirect.`);}catch(e){return xx("[RCPMS: _write()] error sending message",e),r(new Error("RemoteCommunicationPostMessageStream - disconnected"))}return r()}))}class IR extends Hn.Duplex{constructor({name:t,remote:n,deeplinkProtocol:r,platformManager:i}){super({objectMode:true}),this.state={_name:null,remote:null,deeplinkProtocol:false,platformManager:null},this.state._name=t,this.state.remote=n,this.state.deeplinkProtocol=r,this.state.platformManager=i,this._onMessage=this._onMessage.bind(this),this.state.remote.on(e.EventType.MESSAGE,this._onMessage);}_write(e,t,n){return kk(this,void 0,void 0,(function*(){return LR(this,e,0,n)}))}_read(){}_onMessage(e){return function(e,t){try{if(xx("[RCPMS: onMessage()] message",t),!t||"object"!=typeof t)return;if("object"!=typeof(null==t?void 0:t.data))return;if(!(null==t?void 0:t.name))return void xx("[RCPMS: onMessage()] ignore message without name",t);if((null==t?void 0:t.name)!==qA.PROVIDER)return void xx(`[RCPMS: onMessage()] ignore message with wrong name message=${t}`);if(_.isBuffer(t)){const n=_.from(t);e.push(n);}else e.push(t);}catch(e){xx(`[RCPMS: onMessage()] ignore message error err=${e}`);}}(this,e)}start(){}}var OR={exports:{}};!function(e,t){var r="undefined"!=typeof globalThis&&globalThis||"undefined"!=typeof self&&self||void 0!==n&&n,i=function(){function e(){this.fetch=false,this.DOMException=r.DOMException;}return e.prototype=r,new e}();!function(e){!function(t){var n=void 0!==e&&e||"undefined"!=typeof self&&self||void 0!==n&&n,r="URLSearchParams"in n,i="Symbol"in n&&"iterator"in Symbol,o="FileReader"in n&&"Blob"in n&&function(){try{return new Blob,!0}catch(e){return  false}}(),a="FormData"in n,s="ArrayBuffer"in n;if(s)var u=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],l=ArrayBuffer.isView||function(e){return e&&u.indexOf(Object.prototype.toString.call(e))>-1};function c(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e)||""===e)throw new TypeError('Invalid character in header field name: "'+e+'"');return e.toLowerCase()}function d(e){return "string"!=typeof e&&(e=String(e)),e}function f(e){var t={next:function(){var t=e.shift();return {done:void 0===t,value:t}}};return i&&(t[Symbol.iterator]=function(){return t}),t}function h(e){this.map={},e instanceof h?e.forEach((function(e,t){this.append(t,e);}),this):Array.isArray(e)?e.forEach((function(e){this.append(e[0],e[1]);}),this):e&&Object.getOwnPropertyNames(e).forEach((function(t){this.append(t,e[t]);}),this);}function p(e){if(e.bodyUsed)return Promise.reject(new TypeError("Already read"));e.bodyUsed=true;}function m(e){return new Promise((function(t,n){e.onload=function(){t(e.result);},e.onerror=function(){n(e.error);};}))}function g(e){var t=new FileReader,n=m(t);return t.readAsArrayBuffer(e),n}function v(e){if(e.slice)return e.slice(0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function b(){return this.bodyUsed=false,this._initBody=function(e){var t;this.bodyUsed=this.bodyUsed,this._bodyInit=e,e?"string"==typeof e?this._bodyText=e:o&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:a&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:r&&URLSearchParams.prototype.isPrototypeOf(e)?this._bodyText=e.toString():s&&o&&((t=e)&&DataView.prototype.isPrototypeOf(t))?(this._bodyArrayBuffer=v(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):s&&(ArrayBuffer.prototype.isPrototypeOf(e)||l(e))?this._bodyArrayBuffer=v(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="",this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):r&&URLSearchParams.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"));},o&&(this.blob=function(){var e=p(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){if(this._bodyArrayBuffer){var e=p(this);return e||(ArrayBuffer.isView(this._bodyArrayBuffer)?Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset,this._bodyArrayBuffer.byteOffset+this._bodyArrayBuffer.byteLength)):Promise.resolve(this._bodyArrayBuffer))}return this.blob().then(g)}),this.text=function(){var e,t,n,r=p(this);if(r)return r;if(this._bodyBlob)return e=this._bodyBlob,t=new FileReader,n=m(t),t.readAsText(e),n;if(this._bodyArrayBuffer)return Promise.resolve(function(e){for(var t=new Uint8Array(e),n=new Array(t.length),r=0;r<t.length;r++)n[r]=String.fromCharCode(t[r]);return n.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},a&&(this.formData=function(){return this.text().then(_)}),this.json=function(){return this.text().then(JSON.parse)},this}h.prototype.append=function(e,t){e=c(e),t=d(t);var n=this.map[e];this.map[e]=n?n+", "+t:t;},h.prototype.delete=function(e){delete this.map[c(e)];},h.prototype.get=function(e){return e=c(e),this.has(e)?this.map[e]:null},h.prototype.has=function(e){return this.map.hasOwnProperty(c(e))},h.prototype.set=function(e,t){this.map[c(e)]=d(t);},h.prototype.forEach=function(e,t){for(var n in this.map)this.map.hasOwnProperty(n)&&e.call(t,this.map[n],n,this);},h.prototype.keys=function(){var e=[];return this.forEach((function(t,n){e.push(n);})),f(e)},h.prototype.values=function(){var e=[];return this.forEach((function(t){e.push(t);})),f(e)},h.prototype.entries=function(){var e=[];return this.forEach((function(t,n){e.push([n,t]);})),f(e)},i&&(h.prototype[Symbol.iterator]=h.prototype.entries);var y=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function w(e,t){if(!(this instanceof w))throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');var n=(t=t||{}).body;if(e instanceof w){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new h(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,n||null==e._bodyInit||(n=e._bodyInit,e.bodyUsed=true);}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new h(t.headers)),this.method=function(e){var t=e.toUpperCase();return y.indexOf(t)>-1?t:e}(t.method||this.method||"GET"),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&n)throw new TypeError("Body not allowed for GET or HEAD requests");if(this._initBody(n),!("GET"!==this.method&&"HEAD"!==this.method||"no-store"!==t.cache&&"no-cache"!==t.cache)){var r=/([?&])_=[^&]*/;if(r.test(this.url))this.url=this.url.replace(r,"$1_="+(new Date).getTime());else {this.url+=(/\?/.test(this.url)?"&":"?")+"_="+(new Date).getTime();}}}function _(e){var t=new FormData;return e.trim().split("&").forEach((function(e){if(e){var n=e.split("="),r=n.shift().replace(/\+/g," "),i=n.join("=").replace(/\+/g," ");t.append(decodeURIComponent(r),decodeURIComponent(i));}})),t}function S(e,t){if(!(this instanceof S))throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText=void 0===t.statusText?"":""+t.statusText,this.headers=new h(t.headers),this.url=t.url||"",this._initBody(e);}w.prototype.clone=function(){return new w(this,{body:this._bodyInit})},b.call(w.prototype),b.call(S.prototype),S.prototype.clone=function(){return new S(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new h(this.headers),url:this.url})},S.error=function(){var e=new S(null,{status:0,statusText:""});return e.type="error",e};var E=[301,302,303,307,308];S.redirect=function(e,t){if(-1===E.indexOf(t))throw new RangeError("Invalid status code");return new S(null,{status:t,headers:{location:e}})},t.DOMException=n.DOMException;try{new t.DOMException;}catch(e){t.DOMException=function(e,t){this.message=e,this.name=t;var n=Error(e);this.stack=n.stack;},t.DOMException.prototype=Object.create(Error.prototype),t.DOMException.prototype.constructor=t.DOMException;}function k(e,r){return new Promise((function(i,a){var u=new w(e,r);if(u.signal&&u.signal.aborted)return a(new t.DOMException("Aborted","AbortError"));var l=new XMLHttpRequest;function c(){l.abort();}l.onload=function(){var e,t,n={status:l.status,statusText:l.statusText,headers:(e=l.getAllResponseHeaders()||"",t=new h,e.replace(/\r?\n[\t ]+/g," ").split("\r").map((function(e){return 0===e.indexOf("\n")?e.substr(1,e.length):e})).forEach((function(e){var n=e.split(":"),r=n.shift().trim();if(r){var i=n.join(":").trim();t.append(r,i);}})),t)};n.url="responseURL"in l?l.responseURL:n.headers.get("X-Request-URL");var r="response"in l?l.response:l.responseText;setTimeout((function(){i(new S(r,n));}),0);},l.onerror=function(){setTimeout((function(){a(new TypeError("Network request failed"));}),0);},l.ontimeout=function(){setTimeout((function(){a(new TypeError("Network request failed"));}),0);},l.onabort=function(){setTimeout((function(){a(new t.DOMException("Aborted","AbortError"));}),0);},l.open(u.method,function(e){try{return ""===e&&n.location.href?n.location.href:e}catch(t){return e}}(u.url),true),"include"===u.credentials?l.withCredentials=true:"omit"===u.credentials&&(l.withCredentials=false),"responseType"in l&&(o?l.responseType="blob":s&&u.headers.get("Content-Type")&&-1!==u.headers.get("Content-Type").indexOf("application/octet-stream")&&(l.responseType="arraybuffer")),!r||"object"!=typeof r.headers||r.headers instanceof h?u.headers.forEach((function(e,t){l.setRequestHeader(t,e);})):Object.getOwnPropertyNames(r.headers).forEach((function(e){l.setRequestHeader(e,d(r.headers[e]));})),u.signal&&(u.signal.addEventListener("abort",c),l.onreadystatechange=function(){4===l.readyState&&u.signal.removeEventListener("abort",c);}),l.send(void 0===u._bodyInit?null:u._bodyInit);}))}k.polyfill=true,n.fetch||(n.fetch=k,n.Headers=h,n.Request=w,n.Response=S),t.Headers=h,t.Request=w,t.Response=S,t.fetch=k;}({});}(i),i.fetch.ponyfill=true,delete i.fetch.polyfill;var o=r.fetch?r:i;(t=o.fetch).default=o.fetch,t.fetch=o.fetch,t.Headers=o.Headers,t.Request=o.Request,t.Response=o.Response,e.exports=t;}(OR,OR.exports);var NR=r(OR.exports);let DR=1;const jR=e=>new Promise((t=>{setTimeout((()=>{t(true);}),e);})),BR=({checkInstallationOnAllCalls:t=false,communicationLayerPreference:n,injectProvider:r,shouldShimWeb3:i,platformManager:o,installer:a,sdk:s,remoteConnection:u,debug:l})=>kk(void 0,void 0,void 0,(function*(){var c,d;const f=(({name:e,remoteConnection:t})=>{if(!t||!(null==t?void 0:t.getConnector()))throw new Error("Missing remote connection parameter");return new IR({name:e,remote:null==t?void 0:t.getConnector(),deeplinkProtocol:null==t?void 0:t.state.deeplinkProtocol,platformManager:null==t?void 0:t.getPlatformManager()})})({name:qA.INPAGE,target:qA.CONTENT_SCRIPT,remoteConnection:u}),h=o.getPlatformType(),p=s.options.dappMetadata,m=`Sdk/Javascript SdkVersion/${HA.version} Platform/${h} dApp/${null!==(c=p.url)&&void 0!==c?c:p.name} dAppTitle/${p.name}`;let g=null,v=null;const b=null===(d=s.options.storage)||void 0===d?void 0:d.storageManager;if(b){try{const e=yield b.getCachedAccounts();e.length>0&&(g=e[0]);}catch(e){console.error(`[initializeMobileProvider] failed to get cached addresses: ${e}`);}try{const e=yield b.getCachedChainId();e&&(v=e);}catch(e){console.error(`[initializeMobileProvider] failed to parse cached chainId: ${e}`);}}xx(`[initializeMobileProvider] cachedAccountAddress: ${g}, cachedChainId: ${v}`);const y=!(!r||h===e.PlatformType.NonBrowser||h===e.PlatformType.ReactNative),w=PR.init({shouldSetOnWindow:y,connectionStream:f,shouldShimWeb3:i,sdkInstance:s});let _=false;const S=e=>{console.log(`[initializeMobileProvider] setInitializing: ${e}`),_=e;},E=()=>_,k=(n,r,i,l)=>kk(void 0,void 0,void 0,(function*(){var c,d,f,h,p,y,w,k,M;const C=PR.getProvider();if(_){C.emit("display_uri",(null==u?void 0:u.state.qrcodeLink)||""),null==u||u.showActiveModal();let e=E();for(;e;){const t=E(),n=null==u?void 0:u.isAuthorized();e=t&&!n,xx(`[initializeMobileProvider: sendRequest()] waiting for initialization to complete - initializing: ${t} authorized: ${n}`),yield jR(1e3);}return xx("[initializeMobileProvider: sendRequest()] initial method completed -- prevent installation and call provider"),i(...r)}const x=o.isMetaMaskInstalled(),A=null==u?void 0:u.isConnected();let R=null,T=null,P=null;if(R=null!==(c=C.getSelectedAddress())&&void 0!==c?c:g,P=C.getChainId()||v,R&&b&&R!==g&&b.persistAccounts([R]).catch((e=>{console.error(`[initializeMobileProvider] failed to persist account: ${e}`);})),P&&(v=P,b&&b.persistChainId(P).catch((e=>{console.error(`[initializeMobileProvider] failed to persist chainId: ${e}`);}))),xx("[initializeMobileProvider: sendRequest()]",{selectedAddress:R,chainId:P}),l&&xx(`[initializeMobileProvider: sendRequest()] method=${n} ongoing=${_} selectedAddress=${R} isInstalled=${x} checkInstallationOnAllCalls=${t} socketConnected=${A}`),R&&n.toLowerCase()===Kx.ETH_ACCOUNTS.toLowerCase())return [R];if(P&&n.toLowerCase()===Kx.ETH_CHAINID.toLowerCase())return P;const L=[Kx.ETH_REQUESTACCOUNTS,Kx.WALLET_REQUESTPERMISSIONS,Kx.METAMASK_CONNECTSIGN,Kx.METAMASK_CONNECTWITH],I=!qx[n],O=null===(d=s.options.readonlyRPCMap)||void 0===d?void 0:d[P];if(O&&I)try{const e=null===(f=null==r?void 0:r[0])||void 0===f?void 0:f.params,t=yield (({rpcEndpoint:e,method:t,sdkInfo:n,params:r})=>kk(void 0,void 0,void 0,(function*(){const i=JSON.stringify({jsonrpc:"2.0",method:t,params:r,id:(DR+=1,DR)}),o={Accept:"application/json","Content-Type":"application/json"};let a;e.includes("infura")&&(o["Metamask-Sdk-Info"]=n);try{a=yield NR(e,{method:"POST",headers:o,body:i});}catch(e){throw e instanceof Error?new Error(`Failed to fetch from RPC: ${e.message}`):new Error(`Failed to fetch from RPC: ${e}`)}if(!a.ok)throw new Error(`Server responded with a status of ${a.status}`);return (yield a.json()).result})))({rpcEndpoint:O,sdkInfo:m,method:n,params:e||[]});return l&&xx(`initializeProvider::ReadOnlyRPCResponse ${t}`),t}catch(e){console.warn(`[initializeMobileProvider: sendRequest()] method=${n} readOnlyRPCRequest failed:`,e);}if((!x||x&&!A)&&n!==Kx.METAMASK_GETPROVIDERSTATE){const l=(null===(h=null==r?void 0:r[0])||void 0===h?void 0:h.params)||[];if(-1!==L.indexOf(n)||t){S(true);const t=n===Kx.METAMASK_CONNECTWITH,o=`${Date.now()}`;try{yield a.start({wait:!1,connectWith:t?{method:n,id:o,params:l}:void 0}),yield new Promise(((t,n)=>{(null==u?void 0:u.isAuthorized())&&(xx("[initializeMobileProvider: sendRequest()] already authorized"),t(!0)),null==u||u.getConnector().once(e.EventType.AUTHORIZED,(()=>{t(!0);})),s.once(e.EventType.PROVIDER_UPDATE,(t=>{xx(`[initializeMobileProvider: sendRequest()] PROVIDER_UPDATE --- remote provider request interupted type=${t}`),t===e.PROVIDER_UPDATE_TYPE.EXTENSION?n(e.EventType.PROVIDER_UPDATE):n(new Error("Connection Terminated"));}));}));}catch(t){if(e.PROVIDER_UPDATE_TYPE.EXTENSION===t){if(xx(`[initializeMobileProvider: sendRequest()] extension provider detect: re-create ${n} on the active provider`),n.toLowerCase()===Kx.METAMASK_CONNECTSIGN.toLowerCase()){const e=yield null===(p=s.getProvider())||void 0===p?void 0:p.request({method:Kx.ETH_REQUESTACCOUNTS,params:[]});if(!e.length)throw new Error("SDK state invalid -- undefined accounts");const t=yield null===(y=s.getProvider())||void 0===y?void 0:y.request({method:Kx.PERSONAL_SIGN,params:[l[0],e[0]]});return s.emit(ZA.ConnectWithResponse,t),t}if(n.toLowerCase()===Kx.METAMASK_CONNECTWITH.toLowerCase()){const[e]=l,t=yield (({method:e,sdk:t,params:n})=>kk(void 0,void 0,void 0,(function*(){var r,i,o,a;if(!t.isExtensionActive())throw new Error("SDK state invalid -- extension is not active");xx("[MetaMaskProvider: extensionConnectWithOverwrite()] Overwriting request method",e,n);const s=yield null===(r=t.getProvider())||void 0===r?void 0:r.request({method:Kx.ETH_REQUESTACCOUNTS,params:[]});if(!s.length)throw new Error("SDK state invalid -- undefined accounts");if((null==e?void 0:e.toLowerCase())===Kx.PERSONAL_SIGN.toLowerCase()){const r={method:e,params:[n[0],s[0]]};return yield null===(i=t.getProvider())||void 0===i?void 0:i.request(r)}if((null==e?void 0:e.toLowerCase())===Kx.ETH_SENDTRANSACTION.toLowerCase()){const r={method:e,params:[Object.assign(Object.assign({},n[0]),{from:s[0]})]};return yield null===(o=t.getProvider())||void 0===o?void 0:o.request(r)}return Wx.includes(e.toLowerCase())?(console.warn(`MetaMaskSDK connectWith method=${e} -- not handled by the extension -- call separately`),s):yield null===(a=t.getProvider())||void 0===a?void 0:a.request({method:e,params:n})})))({method:e.method,sdk:s,params:e.params});return s.emit(ZA.ConnectWithResponse,t),t}return xx(`[initializeMobileProvider: sendRequest()] sending '${n}' on active provider`,l),yield null===(w=s.getProvider())||void 0===w?void 0:w.request({method:n,params:l})}if(t===e.EventType.REJECTED)throw null==u||u.closeModal(),null===(k=s.getProvider())||void 0===k||k.handleDisconnect({terminate:false}),Object.assign(new Error("User rejected connection"),{code:4001});throw xx(`[initializeMobileProvider: sendRequest()] failed to start installer: ${t}`),t}finally{S(false);}if(n===Kx.ETH_REQUESTACCOUNTS)return T=yield new Promise((e=>{const t=setInterval((()=>{const{accounts:n}=C.getState();n&&(clearInterval(t),e(n));}),100);})),xx(`[initializeMobileProvider: sendRequest()] selectedAddress: ${R} --- SKIP rpc call`),T;if(n===Kx.METAMASK_CONNECTWITH)try{let t=0;const n=5,r=({resolve:e,reject:r})=>{t+=1;const i=null==u?void 0:u.getConnector().getRPCMethodTracker(),a=null==i?void 0:i[o];return xx(`TRACKER: update method ${o}`,a),(null==a?void 0:a.result)?(xx("[initializeMobileProvider: sendRequest()] found result",a.result),s.emit(ZA.ConnectWithResponse,a.result),void e(a.result)):(null==a?void 0:a.error)?(xx("[initializeMobileProvider: sendRequest()] found error",a.error),void r(a.error)):t>=n?(xx("[initializeMobileProvider: sendRequest()] max message count reached without result"),void r(new Error("Max message count reached without result"))):void xx("[initializeMobileProvider: sendRequest()] not found yet, need to wait for next update")};let i,a;const l=yield new Promise(((t,n)=>{const s=null==u?void 0:u.getConnector().getRPCMethodTracker();xx(`TRACKER: method ${o}`,s),(null==s?void 0:s[o].result)?(xx("[initializeMobileProvider: sendRequest()] found result",null==s?void 0:s[o].result),t(null==s?void 0:s[o].result)):(null==s?void 0:s[o].error)&&(xx("[initializeMobileProvider: sendRequest()] found error",null==s?void 0:s[o].error),n(null==s?void 0:s[o].error)),a=()=>r({resolve:t,reject:n}),i=null==u?void 0:u.getConnector().on(e.EventType.RPC_UPDATE,a);}));return a&&(null==i||i.off(e.EventType.RPC_UPDATE,a)),xx("TRACKER: result",l),l}catch(e){throw xx("[initializeMobileProvider: sendRequest()] error:",e),e}r[0]&&"object"==typeof r[0]&&(r[0].params={__triggeredInstaller:true,wrappedParams:r[0].params});return i(...r)}if(o.isSecure()&&qx[n])return i(...r);if(s.isExtensionActive())return xx(`[initializeMobileProvider: sendRequest()] EXTENSION active - redirect request '${n}' to it`,r,l),yield null===(M=s.getProvider())||void 0===M?void 0:M.request({method:n,params:l});throw xx(`[initializeMobileProvider: sendRequest()] method=${n} --- skip --- not connected/installed`),new Error("MetaMask is not connected/installed, please call eth_requestAccounts to connect first.")}try{const e=yield i(...r);if(xx(`[initializeMobileProvider: sendRequest()] method=${n} rpcResponse`,e),n===Kx.WALLET_REQUESTPERMISSIONS){const t=e.reduce(((e,t)=>{var n;if("eth_accounts"===t.parentCapability){const r=null===(n=t.caveats.find((e=>"restrictReturnedAccounts"===e.type)))||void 0===n?void 0:n.value;r&&e.push(...r);}return e}),[]);xx("[initializeMobileProvider: sendRequest()] accountsToPersist:",t),t.length>0&&(C.handleAccountsChanged(t,!1),null==b||b.persistAccounts(t));}return e}catch(e){throw console.error("[initializeMobileProvider: sendRequest()] error:",e),e}})),{request:M}=w;w.request=(...e)=>kk(void 0,void 0,void 0,(function*(){return k(null==e?void 0:e[0].method,e,M,l)}));const{send:C}=w;return w.send=(...e)=>kk(void 0,void 0,void 0,(function*(){return k(null==e?void 0:e[0],e,C,l)})),xx("[initializeMobileProvider: sendRequest()] metamaskStream.start()"),f.start(),w}));function zR(t){var n,r,i,o;return kk(this,void 0,void 0,(function*(){const{options:a}=t,s={communicationLayerPreference:null!==(n=a.communicationLayerPreference)&&void 0!==n?n:e.CommunicationLayerPreference.SOCKET,platformManager:t.platformManager,sdk:t,checkInstallationOnAllCalls:a.checkInstallationOnAllCalls,injectProvider:null===(r=a.injectProvider)||void 0===r||r,shouldShimWeb3:null===(i=a.shouldShimWeb3)||void 0===i||i,extensionOnly:null===(o=a.extensionOnly)||void 0===o||o,installer:t.installer,remoteConnection:t.remoteConnection,debug:t.debug},u=yield BR(s);t.activeProvider=u,function(e){var t,n,r,i;null===(n=null===(t=e.remoteConnection)||void 0===t?void 0:t.getConnector())||void 0===n||n.on(ZA.ConnectionStatus,(t=>{e.emit(ZA.ConnectionStatus,t);})),null===(i=null===(r=e.remoteConnection)||void 0===r?void 0:r.getConnector())||void 0===i||i.on(ZA.ServiceStatus,(t=>{e.emit(ZA.ServiceStatus,t);}));}(t);}))}var UR,FR,KR;const qR="sdk";class HR{constructor({serverUrl:e,enabled:t,originatorInfo:n}){UR.set(this,KE),FR.set(this,void 0),KR.set(this,void 0),Ck(this,UR,e),Ck(this,KR,n),Ck(this,FR,null==t||t);}send({event:e,params:t}){if(!Mk(this,FR))return;const n=Object.assign(Object.assign({id:qR,event:e,sdkVersion:HA.version},Mk(this,KR)),{params:t});xx(`[Analytics: send()] event: ${e}`,n),KS(n,Mk(this,UR)).catch((e=>{xx(`[Analytics: send()] error: ${e}`);}));}}UR=new WeakMap,FR=new WeakMap,KR=new WeakMap;const WR=()=>{if("undefined"==typeof document)return;let e;const t=document.getElementsByTagName("link");for(let n=0;n<t.length;n++)"icon"!==t[n].getAttribute("rel")&&"shortcut icon"!==t[n].getAttribute("rel")||(e=t[n].getAttribute("href"));return e},$R=163400;var VR,YR=new Uint8Array(16);function GR(){if(!VR&&!(VR="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto)))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return VR(YR)}var ZR=/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;for(var QR=[],JR=0;JR<256;++JR)QR.push((JR+256).toString(16).substr(1));function XR(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=(QR[e[t+0]]+QR[e[t+1]]+QR[e[t+2]]+QR[e[t+3]]+"-"+QR[e[t+4]]+QR[e[t+5]]+"-"+QR[e[t+6]]+QR[e[t+7]]+"-"+QR[e[t+8]]+QR[e[t+9]]+"-"+QR[e[t+10]]+QR[e[t+11]]+QR[e[t+12]]+QR[e[t+13]]+QR[e[t+14]]+QR[e[t+15]]).toLowerCase();if(!function(e){return "string"==typeof e&&ZR.test(e)}(n))throw TypeError("Stringified UUID is invalid");return n}function eT(e,t,n){var r=(e=e||{}).random||(e.rng||GR)();if(r[6]=15&r[6]|64,r[8]=63&r[8]|128,t);return XR(r)}function tT(t){var n,r,i;const{dappMetadata:o}=t,a=function({url:e,name:t}){var n;const r=e+t,i=TR(r);if(!localStorage)return "";let o=null!==(n=localStorage.getItem(i))&&void 0!==n?n:"";if(!o){o=eT();try{localStorage.setItem(i,o);}catch(e){return ""}}return o}({url:null!==(n=null==o?void 0:o.url)&&void 0!==n?n:"no_url",name:null!==(r=null==o?void 0:o.name)&&void 0!==r?r:"no_name"}),s=null===(i=t.platformManager)||void 0===i?void 0:i.getPlatformType(),u=s===e.PlatformType.DesktopWeb,l=s===e.PlatformType.MetaMaskMobileWebview;let c="N/A";return u?c="extension":l&&(c="mobile"),{id:a,from:c}}const nT=({provider:e,sdkInstance:t})=>{if("state"in e)throw new Error("INVALID EXTENSION PROVIDER");return new Proxy(e,{get:(n,r)=>"request"===r?function(e){var r,i;return kk(this,void 0,void 0,(function*(){xx("[wrapExtensionProvider()] Overwriting request method",e);const{method:o,params:a}=e,s=Hx.includes(o.toLowerCase()),{id:u,from:l}=tT(t);if(s&&(null===(r=t.analytics)||void 0===r||r.send({event:ZE.SDK_RPC_REQUEST,params:{method:o,from:l,id:u}})),o===Kx.METAMASK_BATCH&&Array.isArray(a))return (({target:e,args:t,trackEvent:n,sdkInstance:r})=>kk(void 0,void 0,void 0,(function*(){var i,o;if("metamask_batch"!==t.method)throw new Error("Invalid usage");const a=[],s=null!==(i=null==t?void 0:t.params)&&void 0!==i?i:[];for(const t of s){const n=yield null==e?void 0:e.request({method:t.method,params:t.params});a.push(n);}const{id:u,from:l}=tT(r);return n&&(null===(o=r.analytics)||void 0===o||o.send({event:ZE.SDK_RPC_REQUEST_DONE,params:{method:t.method,from:l,id:u}})),a})))({target:n,args:e,trackEvent:s,sdkInstance:t});if(o.toLowerCase()===Kx.METAMASK_CONNECTSIGN.toLowerCase()&&Array.isArray(a))return (({target:e,params:t})=>kk(void 0,void 0,void 0,(function*(){const n=yield e.request({method:Kx.ETH_REQUESTACCOUNTS,params:[]});if(!n.length)throw new Error("SDK state invalid -- undefined accounts");return yield e.request({method:Kx.PERSONAL_SIGN,params:[t[0],n[0]]})})))({target:n,params:a});if(o.toLowerCase()===Kx.METAMASK_CONNECTWITH.toLowerCase()&&Array.isArray(a))return (({target:e,params:t})=>kk(void 0,void 0,void 0,(function*(){const[n]=t,r=n.method,i=n.params,o=yield e.request({method:Kx.ETH_REQUESTACCOUNTS,params:[]});if(!o.length)throw new Error("SDK state invalid -- undefined accounts");return (null==r?void 0:r.toLowerCase())===Kx.PERSONAL_SIGN.toLowerCase()?yield e.request({method:r,params:[i[0],o[0]]}):(null==r?void 0:r.toLowerCase())===Kx.ETH_SENDTRANSACTION.toLowerCase()?yield e.request({method:r,params:[Object.assign(Object.assign({},i[0]),{from:o[0]})]}):Wx.includes(r.toLowerCase())?(console.warn(`MetaMaskSDK connectWith method=${r} -- not handled by the extension -- call separately`),o):yield e.request({method:r,params:i})})))({target:n,params:a});let c;try{return c=yield n.request(e),c}finally{s&&(null===(i=t.analytics)||void 0===i||i.send({event:ZE.SDK_RPC_REQUEST_DONE,params:{method:o,from:l,id:u}}));}}))}:"getChainId"===r?function(){return e.chainId}:"getNetworkVersion"===r?function(){return e.networkVersion}:"getSelectedAddress"===r?function(){return e.selectedAddress}:"isConnected"===r?function(){return e._state.isConnected}:n[r]})};var rT;function iT({mustBeMetaMask:e,sdkInstance:t}){return kk(this,void 0,void 0,(function*(){if("undefined"==typeof window)throw new Error("window not available");let n;try{return n=yield new Promise(((e,t)=>{const n=setTimeout((()=>{t(new Error("eip6963RequestProvider timed out"));}),500);window.addEventListener(rT.Announce,(t=>{const r=t,{detail:{info:i,provider:o}={}}=r,{name:a,rdns:s,uuid:u}=null!=i?i:{};GA.test(u)&&a.startsWith(YA.NAME)&&s===YA.RDNS&&(clearTimeout(n),e(o));})),window.dispatchEvent(new Event(rT.Request));})),nT({provider:n,sdkInstance:t})}catch(n){const{ethereum:r}=window;if(!r)throw new Error("Ethereum not found in window object");if("providers"in r){if(Array.isArray(r.providers)){const n=r.providers.find((e=>oT(e)));if(!n)throw new Error("No suitable provider found");return nT({provider:n,sdkInstance:t})}}else if(!oT(r))throw new Error("MetaMask provider not found in Ethereum");return nT({provider:r,sdkInstance:t})}}))}function oT(e){if(!e.isMetaMask)return  false;if(e.isBraveWallet&&!e._events&&!e._state)return  false;const t=["isApexWallet","isAvalanche","isBitKeep","isBlockWallet","isKuCoinWallet","isMathWallet","isOkxWallet","isOKExWallet","isOneInchIOSWallet","isOneInchAndroidWallet","isOpera","isPortal","isRabby","isTokenPocket","isTokenary","isUniswapWallet","isZerion"];for(const n of t)if(e[n])return  false;return  true}!function(e){e.Announce="eip6963:announceProvider",e.Request="eip6963:requestProvider";}(rT||(rT={}));const aT=e=>kk(void 0,void 0,void 0,(function*(){const{options:t}=e,{infuraAPIKey:n}=t;if(!n)return;const r={"0x1":`https://mainnet.infura.io/v3/${n}`,"0x5":`https://goerli.infura.io/v3/${n}`,"0x2a":`https://sepolia.infura.io/v3/${n}`,"0xe708":`https://linea-mainnet.infura.io/v3/${n}`,"0xe704":`https://linea-goerli.infura.io/v3/${n}`,"0x89":`https://polygon-mainnet.infura.io/v3/${n}`,"0x13881":`https://polygon-mumbai.infura.io/v3/${n}`,"0x45":`https://optimism-mainnet.infura.io/v3/${n}`,"0x1a4":`https://optimism-goerli.infura.io/v3/${n}`,"0xa4b1":`https://arbitrum-mainnet.infura.io/v3/${n}`,"0x66eed":`https://arbitrum-goerli.infura.io/v3/${n}`,"0x2a15c308d":`https://palm-mainnet.infura.io/v3/${n}`,"0x2a15c3083":`https://palm-testnet.infura.io/v3/${n}`,"0xa86a":`https://avalanche-mainnet.infura.io/v3/${n}`,"0xa869":`https://avalanche-fuji.infura.io/v3/${n}`,"0x4e454152":`https://aurora-mainnet.infura.io/v3/${n}`,"0x4e454153":`https://aurora-testnet.infura.io/v3/${n}`,"0x534e5f4d41494e":`https://starknet-mainnet.infura.io/v3/${n}`,"0x534e5f474f45524c49":`https://starknet-goerli.infura.io/v3/${n}`,"0x534e5f474f45524c4932":`https://starknet-goerli2.infura.io/v3/${n}`,"0xa4ec":`https://celo-mainnet.infura.io/v3/${n}`,"0xaef3":`https://celo-alfajores.infura.io/v3/${n}`};e.options.readonlyRPCMap?e.options.readonlyRPCMap=Object.assign(Object.assign({},e.options.readonlyRPCMap),r):e.options.readonlyRPCMap=r;}));var sT={exports:{}};!function(e,t){e.exports=function(e){var t={};function n(r){if(t[r])return t[r].exports;var i=t[r]={i:r,l:false,exports:{}};return e[r].call(i.exports,i,i.exports,n),i.l=true,i.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:true,get:r});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:true});},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:true,value:e}),2&t&&"string"!=typeof e)for(var i in e)n.d(r,i,function(t){return e[t]}.bind(null,i));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=90)}({17:function(e,t,n){t.__esModule=true,t.default=void 0;var r=n(18),i=function(){function e(){}return e.getFirstMatch=function(e,t){var n=t.match(e);return n&&n.length>0&&n[1]||""},e.getSecondMatch=function(e,t){var n=t.match(e);return n&&n.length>1&&n[2]||""},e.matchAndReturnConst=function(e,t,n){if(e.test(t))return n},e.getWindowsVersionName=function(e){switch(e){case "NT":return "NT";case "XP":case "NT 5.1":return "XP";case "NT 5.0":return "2000";case "NT 5.2":return "2003";case "NT 6.0":return "Vista";case "NT 6.1":return "7";case "NT 6.2":return "8";case "NT 6.3":return "8.1";case "NT 10.0":return "10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),10===t[0])switch(t[1]){case 5:return "Leopard";case 6:return "Snow Leopard";case 7:return "Lion";case 8:return "Mountain Lion";case 9:return "Mavericks";case 10:return "Yosemite";case 11:return "El Capitan";case 12:return "Sierra";case 13:return "High Sierra";case 14:return "Mojave";case 15:return "Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,n,r){ void 0===r&&(r=false);var i=e.getVersionPrecision(t),o=e.getVersionPrecision(n),a=Math.max(i,o),s=0,u=e.map([t,n],(function(t){var n=a-e.getVersionPrecision(t),r=t+new Array(n+1).join(".0");return e.map(r.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(r&&(s=a-Math.min(i,o)),a-=1;a>=s;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===s)return 0;a-=1;}else if(u[0][a]<u[1][a])return  -1}},e.map=function(e,t){var n,r=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(n=0;n<e.length;n+=1)r.push(t(e[n]));return r},e.find=function(e,t){var n,r;if(Array.prototype.find)return Array.prototype.find.call(e,t);for(n=0,r=e.length;n<r;n+=1){var i=e[n];if(t(i,n))return i}},e.assign=function(e){for(var t,n,r=e,i=arguments.length,o=new Array(i>1?i-1:0),a=1;a<i;a++)o[a-1]=arguments[a];if(Object.assign)return Object.assign.apply(Object,[e].concat(o));var s=function(){var e=o[t];"object"==typeof e&&null!==e&&Object.keys(e).forEach((function(t){r[t]=e[t];}));};for(t=0,n=o.length;t<n;t+=1)s();return e},e.getBrowserAlias=function(e){return r.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return r.BROWSER_MAP[e]||""},e}();t.default=i,e.exports=t.default;},18:function(e,t,n){t.__esModule=true,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0,t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"},t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"},t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"},t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"},t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"};},90:function(e,t,n){t.__esModule=true,t.default=void 0;var r,i=(r=n(91))&&r.__esModule?r:{default:r},o=n(18);function a(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||false,r.configurable=true,"value"in r&&(r.writable=true),Object.defineProperty(e,r.key,r);}}var s=function(){function e(){}var t,n,r;return e.getParser=function(e,t){if(void 0===t&&(t=false),"string"!=typeof e)throw new Error("UserAgent should be a string");return new i.default(e,t)},e.parse=function(e){return new i.default(e).getResult()},t=e,r=[{key:"BROWSER_MAP",get:function(){return o.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return o.ENGINE_MAP}},{key:"OS_MAP",get:function(){return o.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return o.PLATFORMS_MAP}}],(n=null)&&a(t.prototype,n),r&&a(t,r),e}();t.default=s,e.exports=t.default;},91:function(e,t,n){t.__esModule=true,t.default=void 0;var r=u(n(92)),i=u(n(93)),o=u(n(94)),a=u(n(95)),s=u(n(17));function u(e){return e&&e.__esModule?e:{default:e}}var l=function(){function e(e,t){if(void 0===t&&(t=false),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},true!==t&&this.parse();}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=s.default.find(r.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=s.default.find(i.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){ void 0===e&&(e=false);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=s.default.find(o.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=s.default.find(a.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return s.default.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,n={},r=0,i={},o=0;if(Object.keys(e).forEach((function(t){var a=e[t];"string"==typeof a?(i[t]=a,o+=1):"object"==typeof a&&(n[t]=a,r+=1);})),r>0){var a=Object.keys(n),u=s.default.find(a,(function(e){return t.isOS(e)}));if(u){var l=this.satisfies(n[u]);if(void 0!==l)return l}var c=s.default.find(a,(function(e){return t.isPlatform(e)}));if(c){var d=this.satisfies(n[c]);if(void 0!==d)return d}}if(o>0){var f=Object.keys(i),h=s.default.find(f,(function(e){return t.isBrowser(e,true)}));if(void 0!==h)return this.compareVersion(i[h])}},t.isBrowser=function(e,t){ void 0===t&&(t=false);var n=this.getBrowserName().toLowerCase(),r=e.toLowerCase(),i=s.default.getBrowserTypeByAlias(r);return t&&i&&(r=i.toLowerCase()),r===n},t.compareVersion=function(e){var t=[0],n=e,r=false,i=this.getBrowserVersion();if("string"==typeof i)return ">"===e[0]||"<"===e[0]?(n=e.substr(1),"="===e[1]?(r=true,n=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?n=e.substr(1):"~"===e[0]&&(r=true,n=e.substr(1)),t.indexOf(s.default.compareVersions(i,n,r))>-1},t.isOS=function(e){return this.getOSName(true)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(true)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(true)===String(e).toLowerCase()},t.is=function(e,t){return void 0===t&&(t=false),this.isBrowser(e,t)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=l,e.exports=t.default;},92:function(e,t,n){t.__esModule=true,t.default=void 0;var r,i=(r=n(17))&&r.__esModule?r:{default:r},o=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},n=i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},n=i.default.getFirstMatch(o,e)||i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},n=i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},n=i.default.getFirstMatch(o,e)||i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},n=i.default.getFirstMatch(o,e)||i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},n=i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},n=i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},n=i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},n=i.default.getFirstMatch(o,e)||i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/opt\/\d+(?:.?_?\d+)+/i],describe:function(e){var t={name:"Opera Touch"},n=i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},n=i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},n=i.default.getFirstMatch(o,e)||i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},n=i.default.getFirstMatch(o,e)||i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},n=i.default.getFirstMatch(o,e)||i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},n=i.default.getFirstMatch(o,e)||i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},n=i.default.getFirstMatch(o,e)||i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},n=i.default.getFirstMatch(o,e)||i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},n=i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},n=i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},n=i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},n=i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},n=i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},n=i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},n=i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},n=i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return n&&(t.version=n),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},n=i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},n=i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},n=i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},n=i.default.getFirstMatch(o,e)||i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},n=i.default.getFirstMatch(o,e)||i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},n=i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},n=i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},n=i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},n=i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/electron/i],describe:function(e){var t={name:"Electron"},n=i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/MiuiBrowser/i],describe:function(e){var t={name:"Miui"},n=i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},n=i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},n=i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},n=i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:function(e){var t=!e.test(/like android/i),n=e.test(/android/i);return t&&n},describe:function(e){var t={name:"Android Browser"},n=i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},n=i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},n=i.default.getFirstMatch(o,e);return n&&(t.version=n),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return {name:i.default.getFirstMatch(t,e),version:i.default.getSecondMatch(t,e)}}}];t.default=a,e.exports=t.default;},93:function(e,t,n){t.__esModule=true,t.default=void 0;var r,i=(r=n(17))&&r.__esModule?r:{default:r},o=n(18),a=[{test:[/Roku\/DVP/],describe:function(e){var t=i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return {name:o.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return {name:o.OS_MAP.WindowsPhone,version:t}}},{test:[/windows /i],describe:function(e){var t=i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),n=i.default.getWindowsVersionName(t);return {name:o.OS_MAP.Windows,version:t,versionName:n}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(e){var t={name:o.OS_MAP.iOS},n=i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/,e);return n&&(t.version=n),t}},{test:[/macintosh/i],describe:function(e){var t=i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),n=i.default.getMacOSVersionName(t),r={name:o.OS_MAP.MacOS,version:t};return n&&(r.versionName=n),r}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return {name:o.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),n=e.test(/android/i);return t&&n},describe:function(e){var t=i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),n=i.default.getAndroidVersionName(t),r={name:o.OS_MAP.Android,version:t};return n&&(r.versionName=n),r}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),n={name:o.OS_MAP.WebOS};return t&&t.length&&(n.version=t),n}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||i.default.getFirstMatch(/\bbb(\d+)/i,e);return {name:o.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return {name:o.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return {name:o.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return {name:o.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return {name:o.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return {name:o.OS_MAP.PlayStation4,version:t}}}];t.default=a,e.exports=t.default;},94:function(e,t,n){t.__esModule=true,t.default=void 0;var r,i=(r=n(17))&&r.__esModule?r:{default:r},o=n(18),a=[{test:[/googlebot/i],describe:function(){return {type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=i.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",n={type:o.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(n.model=t),n}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return {type:o.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return {type:o.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(){return {type:o.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return {type:o.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return {type:o.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return {type:o.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),n=e.test(/like (ipod|iphone)/i);return t&&!n},describe:function(e){var t=i.default.getFirstMatch(/(ipod|iphone)/i,e);return {type:o.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return {type:o.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return {type:o.PLATFORMS_MAP.mobile}}},{test:function(e){return "blackberry"===e.getBrowserName(true)},describe:function(){return {type:o.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return "bada"===e.getBrowserName(true)},describe:function(){return {type:o.PLATFORMS_MAP.mobile}}},{test:function(e){return "windows phone"===e.getBrowserName()},describe:function(){return {type:o.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return "android"===e.getOSName(true)&&t>=3},describe:function(){return {type:o.PLATFORMS_MAP.tablet}}},{test:function(e){return "android"===e.getOSName(true)},describe:function(){return {type:o.PLATFORMS_MAP.mobile}}},{test:function(e){return "macos"===e.getOSName(true)},describe:function(){return {type:o.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return "windows"===e.getOSName(true)},describe:function(){return {type:o.PLATFORMS_MAP.desktop}}},{test:function(e){return "linux"===e.getOSName(true)},describe:function(){return {type:o.PLATFORMS_MAP.desktop}}},{test:function(e){return "playstation 4"===e.getOSName(true)},describe:function(){return {type:o.PLATFORMS_MAP.tv}}},{test:function(e){return "roku"===e.getOSName(true)},describe:function(){return {type:o.PLATFORMS_MAP.tv}}}];t.default=a,e.exports=t.default;},95:function(e,t,n){t.__esModule=true,t.default=void 0;var r,i=(r=n(17))&&r.__esModule?r:{default:r},o=n(18),a=[{test:function(e){return "microsoft edge"===e.getBrowserName(true)},describe:function(e){if(/\sedg\//i.test(e))return {name:o.ENGINE_MAP.Blink};var t=i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return {name:o.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:o.ENGINE_MAP.Trident},n=i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:o.ENGINE_MAP.Presto},n=i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:function(e){var t=e.test(/gecko/i),n=e.test(/like gecko/i);return t&&!n},describe:function(e){var t={name:o.ENGINE_MAP.Gecko},n=i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return {name:o.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:o.ENGINE_MAP.WebKit},n=i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return n&&(t.version=n),t}}];t.default=a,e.exports=t.default;}});}(sT);var uT=r(sT.exports);class lT{constructor({useDeepLink:e,preferredOpenLink:t,debug:n=false}){this.state={platformType:void 0,useDeeplink:false,preferredOpenLink:void 0,debug:false},this.state.platformType=this.getPlatformType(),this.state.useDeeplink=e,this.state.preferredOpenLink=t,this.state.debug=n;}openDeeplink(e,t,n){return function(e,t,n,r){const{state:i}=e;xx(`[PlatfformManager: openDeeplink()] universalLink --\x3e ${t}`),xx(`[PlatfformManager: openDeeplink()] deepLink --\x3e ${n}`);try{if(i.preferredOpenLink)return void i.preferredOpenLink(i.useDeeplink?n:t,r);if(xx(`[PlatfformManager: openDeeplink()] open link now useDeepLink=${i.useDeeplink} link=${i.useDeeplink?n:t}`),i.useDeeplink)"undefined"!=typeof window&&(window.location.href=n);else if("undefined"!=typeof document){const e=document.createElement("a");e.href=t,e.target="_self",e.rel="noreferrer noopener",e.click();}}catch(e){console.log("[PlatfformManager: openDeeplink()] can't open link",e);}}(this,e,t,n)}isReactNative(){var e;return this.isNotBrowser()&&"undefined"!=typeof window&&(null===window||void 0===window?void 0:window.navigator)&&"ReactNative"===(null===(e=window.navigator)||void 0===e?void 0:e.product)}isMetaMaskInstalled(){return function(){const e=PR.getProvider()||(null===window||void 0===window?void 0:window.ethereum);return xx(`[PlatfformManager: isMetaMaskInstalled()] isMetaMask=${null==e?void 0:e.isMetaMask} isConnected=${null==e?void 0:e.isConnected()}`),(null==e?void 0:e.isMetaMask)&&(null==e?void 0:e.isConnected())}()}isDesktopWeb(){return this.isBrowser()&&!this.isMobileWeb()}isMobile(){var e,t;const n=uT.parse(window.navigator.userAgent);return "mobile"===(null===(e=null==n?void 0:n.platform)||void 0===e?void 0:e.type)||"tablet"===(null===(t=null==n?void 0:n.platform)||void 0===t?void 0:t.type)}isSecure(){return this.isReactNative()||this.isMobileWeb()}isMetaMaskMobileWebView(){return "undefined"!=typeof window&&(Boolean(window.ReactNativeWebView)&&Boolean(navigator.userAgent.endsWith("MetaMaskMobile")))}isMobileWeb(){return this.state.platformType===e.PlatformType.MobileWeb}isNotBrowser(){var e;return "undefined"==typeof window||!(null===window||void 0===window?void 0:window.navigator)||"undefined"!=typeof commonjsGlobal&&"ReactNative"===(null===(e=null===commonjsGlobal||void 0===commonjsGlobal?void 0:commonjsGlobal.navigator)||void 0===e?void 0:e.product)||"ReactNative"===(null===navigator||void 0===navigator?void 0:navigator.product)}isNodeJS(){return this.isNotBrowser()&&!this.isReactNative()}isBrowser(){return !this.isNotBrowser()}isUseDeepLink(){return this.state.useDeeplink}getPlatformType(){return function(t){const{state:n}=t;return n.platformType?n.platformType:t.isReactNative()?e.PlatformType.ReactNative:t.isNotBrowser()?e.PlatformType.NonBrowser:t.isMetaMaskMobileWebView()?e.PlatformType.MetaMaskMobileWebview:t.isMobile()?e.PlatformType.MobileWeb:e.PlatformType.DesktopWeb}(this)}}const cT=e=>kk(void 0,void 0,void 0,(function*(){const{options:t}=e,{readonlyRPCMap:n}=t;if(n)try{xx("[MetaMaskSDK: setupReadOnlyRPCProviders()] Setting up Readonly RPC Providers",n),e.setReadOnlyRPCCalls(!0);}catch(e){throw new Error("Invalid Infura Settings")}}));
		/*! *****************************************************************************
		            Copyright (c) Microsoft Corporation.

		            Permission to use, copy, modify, and/or distribute this software for any
		            purpose with or without fee is hereby granted.

		            THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
		            REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
		            AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
		            INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
		            LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
		            OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
		            PERFORMANCE OF THIS SOFTWARE.
		            ***************************************************************************** */
		function dT(e,t,n,r){return new(n||(n=Promise))((function(i,o){function a(e){try{u(r.next(e));}catch(e){o(e);}}function s(e){try{u(r.throw(e));}catch(e){o(e);}}function u(e){e.done?i(e.value):function(e){return e instanceof n?e:new n((function(t){t(e);}))}(e.value).then(a,s);}u((r=r.apply(e,[])).next());}))}function fT(e,t){var n,r,i,o,a={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function s(o){return function(s){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return a.label++,{value:o[1],done:!1};case 5:a.label++,r=o[1],o=[0];continue;case 7:o=a.ops.pop(),a.trys.pop();continue;default:if(!(i=a.trys,(i=i.length>0&&i[i.length-1])||6!==o[0]&&2!==o[0])){a=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){a.label=o[1];break}if(6===o[0]&&a.label<i[1]){a.label=i[1],i=o;break}if(i&&a.label<i[2]){a.label=i[2],a.ops.push(o);break}i[2]&&a.ops.pop(),a.trys.pop();continue}o=t.call(e,a);}catch(e){o=[6,e],r=0;}finally{n=i=0;}if(5&o[0])throw o[1];return {value:o[0]?o[1]:void 0,done:true}}([o,s])}}}var hT="INSTALLED",pT="NOT_INSTALLED",mT="REGISTERED",gT="REGISTERING",vT="RELOADING",bT={CHROME:"https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn",FIREFOX:"https://addons.mozilla.org/firefox/addon/ether-metamask/",DEFAULT:"https://metamask.io"},yT="REGISTRATION_IN_PROGRESS",wT="FORWARDER_ID",_T=function(){function e(t){var n=void 0===t?{}:t,r=n.forwarderOrigin,i=void 0===r?"https://fwd.metamask.io":r,o=n.forwarderMode,a=void 0===o?e.FORWARDER_MODE.INJECT:o;this.forwarderOrigin=i,this.forwarderMode=a,this.state=e.isMetaMaskInstalled()?hT:pT;var s=e._detectBrowser();this.downloadUrl=s?bT[s]:bT.DEFAULT,this._onMessage=this._onMessage.bind(this),this._onMessageFromForwarder=this._onMessageFromForwarder.bind(this),this._openForwarder=this._openForwarder.bind(this),this._openDownloadPage=this._openDownloadPage.bind(this),this.startOnboarding=this.startOnboarding.bind(this),this.stopOnboarding=this.stopOnboarding.bind(this),window.addEventListener("message",this._onMessage),a===e.FORWARDER_MODE.INJECT&&"true"===sessionStorage.getItem(yT)&&e._injectForwarder(this.forwarderOrigin);}return e.prototype._onMessage=function(e){if(e.origin===this.forwarderOrigin)return "metamask:reload"===e.data.type?this._onMessageFromForwarder(e):void console.debug("Unknown message from '"+e.origin+"' with data "+JSON.stringify(e.data))},e.prototype._onMessageUnknownStateError=function(e){throw new Error("Unknown state: '"+e+"'")},e.prototype._onMessageFromForwarder=function(t){return dT(this,void 0,void 0,(function(){return fT(this,(function(n){switch(n.label){case 0:switch(this.state){case vT:return [3,1];case pT:return [3,2];case hT:return [3,3];case gT:return [3,5];case mT:return [3,6]}return [3,7];case 1:return console.debug("Ignoring message while reloading"),[3,8];case 2:return console.debug("Reloading now to register with MetaMask"),this.state=vT,location.reload(),[3,8];case 3:return console.debug("Registering with MetaMask"),this.state=gT,[4,e._register()];case 4:return n.sent(),this.state=mT,t.source.postMessage({type:"metamask:registrationCompleted"},t.origin),this.stopOnboarding(),[3,8];case 5:return console.debug("Already registering - ignoring reload message"),[3,8];case 6:return console.debug("Already registered - ignoring reload message"),[3,8];case 7:this._onMessageUnknownStateError(this.state),n.label=8;case 8:return [2]}}))}))},e.prototype.startOnboarding=function(){sessionStorage.setItem(yT,"true"),this._openDownloadPage(),this._openForwarder();},e.prototype.stopOnboarding=function(){"true"===sessionStorage.getItem(yT)&&(this.forwarderMode===e.FORWARDER_MODE.INJECT&&(console.debug("Removing forwarder"),e._removeForwarder()),sessionStorage.setItem(yT,"false"));},e.prototype._openForwarder=function(){this.forwarderMode===e.FORWARDER_MODE.OPEN_TAB?window.open(this.forwarderOrigin,"_blank"):e._injectForwarder(this.forwarderOrigin);},e.prototype._openDownloadPage=function(){window.open(this.downloadUrl,"_blank");},e.isMetaMaskInstalled=function(){return Boolean(window.ethereum&&window.ethereum.isMetaMask)},e._register=function(){return window.ethereum.request({method:"wallet_registerOnboarding"})},e._injectForwarder=function(e){var t=document.body,n=document.createElement("iframe");n.setAttribute("height","0"),n.setAttribute("width","0"),n.setAttribute("style","display: none;"),n.setAttribute("src",e),n.setAttribute("id",wT),t.insertBefore(n,t.children[0]);},e._removeForwarder=function(){var e;null===(e=document.getElementById(wT))||void 0===e||e.remove();},e._detectBrowser=function(){var e=uT.parse(window.navigator.userAgent);return "Firefox"===e.browser.name?"FIREFOX":["Chrome","Chromium"].includes(e.browser.name||"")?"CHROME":null},e.FORWARDER_MODE={INJECT:"INJECT",OPEN_TAB:"OPEN_TAB"},e}();function ST(e,{wait:t=false}){return kk(this,void 0,void 0,(function*(){return xx(`[MetamaskInstaller: startInstaller()] wait=${t}`),t&&(yield jR(1e3)),yield e.checkInstallation()}))}class ET{constructor({remote:e,preferDesktop:t,platformManager:n,debug:r=false}){this.state={isInstalling:false,hasInstalled:false,resendRequest:null,preferDesktop:false,platformManager:null,remote:null,debug:false,connectWith:void 0},this.state.remote=e,this.state.preferDesktop=t,this.state.platformManager=n,this.state.debug=r;}startDesktopOnboarding(){return function(){return kk(this,void 0,void 0,(function*(){xx("[MetamaskInstaller: startDesktopOnboarding() starting desktop onboarding"),delete window.ethereum,(new _T).startOnboarding();}))}()}redirectToProperInstall(){return kk(this,void 0,void 0,(function*(){return function(t){var n,r;return kk(this,void 0,void 0,(function*(){const{state:i}=t,o=null===(n=i.platformManager)||void 0===n?void 0:n.getPlatformType();if(xx(`[MetamaskInstaller: redirectToProperInstall()] platform=${o}`),o===e.PlatformType.MetaMaskMobileWebview)return  false;i.isInstalling=true;try{yield null===(r=i.remote)||void 0===r?void 0:r.startConnection({connectWith:i.connectWith}),i.isInstalling=!1,i.hasInstalled=!0;}catch(e){throw i.isInstalling=false,e}return  true}))}(this)}))}checkInstallation(){return kk(this,void 0,void 0,(function*(){return function(e){var t;return kk(this,void 0,void 0,(function*(){const{state:n}=e,r=null===(t=n.platformManager)||void 0===t?void 0:t.isMetaMaskInstalled();return xx(`[MetamaskInstaller: checkInstallation()] isInstalled=${r}`),!!r||(yield e.redirectToProperInstall())}))}(this)}))}start({wait:e=false,connectWith:t}){return kk(this,void 0,void 0,(function*(){this.state.connectWith=t,xx(`[MetaMaskInstaller: start()] wait=${e}`,t),yield ST(this,{wait:e});}))}}var kT,MT={exports:{}},CT={exports:{}},xT={};function AT(){if(kT)return xT;kT=1;var e=Symbol.for("react.element"),t=Symbol.for("react.portal"),n=Symbol.for("react.fragment"),r=Symbol.for("react.strict_mode"),i=Symbol.for("react.profiler"),o=Symbol.for("react.provider"),a=Symbol.for("react.context"),s=Symbol.for("react.forward_ref"),u=Symbol.for("react.suspense"),l=Symbol.for("react.memo"),c=Symbol.for("react.lazy"),d=Symbol.iterator;var f={isMounted:function(){return  false},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},h=Object.assign,p={};function m(e,t,n){this.props=e,this.context=t,this.refs=p,this.updater=n||f;}function g(){}function v(e,t,n){this.props=e,this.context=t,this.refs=p,this.updater=n||f;}m.prototype.isReactComponent={},m.prototype.setState=function(e,t){if("object"!=typeof e&&"function"!=typeof e&&null!=e)throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,e,t,"setState");},m.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this,e,"forceUpdate");},g.prototype=m.prototype;var b=v.prototype=new g;b.constructor=v,h(b,m.prototype),b.isPureReactComponent=true;var y=Array.isArray,w=Object.prototype.hasOwnProperty,_={current:null},S={key:true,ref:true,__self:true,__source:true};function E(t,n,r){var i,o={},a=null,s=null;if(null!=n)for(i in void 0!==n.ref&&(s=n.ref),void 0!==n.key&&(a=""+n.key),n)w.call(n,i)&&!S.hasOwnProperty(i)&&(o[i]=n[i]);var u=arguments.length-2;if(1===u)o.children=r;else if(1<u){for(var l=Array(u),c=0;c<u;c++)l[c]=arguments[c+2];o.children=l;}if(t&&t.defaultProps)for(i in u=t.defaultProps) void 0===o[i]&&(o[i]=u[i]);return {$$typeof:e,type:t,key:a,ref:s,props:o,_owner:_.current}}function k(t){return "object"==typeof t&&null!==t&&t.$$typeof===e}var M=/\/+/g;function C(e,t){return "object"==typeof e&&null!==e&&null!=e.key?function(e){var t={"=":"=0",":":"=2"};return "$"+e.replace(/[=:]/g,(function(e){return t[e]}))}(""+e.key):t.toString(36)}function x(n,r,i,o,a){var s=typeof n;"undefined"!==s&&"boolean"!==s||(n=null);var u=false;if(null===n)u=true;else switch(s){case "string":case "number":u=true;break;case "object":switch(n.$$typeof){case e:case t:u=true;}}if(u)return a=a(u=n),n=""===o?"."+C(u,0):o,y(a)?(i="",null!=n&&(i=n.replace(M,"$&/")+"/"),x(a,r,i,"",(function(e){return e}))):null!=a&&(k(a)&&(a=function(t,n){return {$$typeof:e,type:t.type,key:n,ref:t.ref,props:t.props,_owner:t._owner}}(a,i+(!a.key||u&&u.key===a.key?"":(""+a.key).replace(M,"$&/")+"/")+n)),r.push(a)),1;if(u=0,o=""===o?".":o+":",y(n))for(var l=0;l<n.length;l++){var c=o+C(s=n[l],l);u+=x(s,r,i,c,a);}else if(c=function(e){return null===e||"object"!=typeof e?null:"function"==typeof(e=d&&e[d]||e["@@iterator"])?e:null}(n),"function"==typeof c)for(n=c.call(n),l=0;!(s=n.next()).done;)u+=x(s=s.value,r,i,c=o+C(s,l++),a);else if("object"===s)throw r=String(n),Error("Objects are not valid as a React child (found: "+("[object Object]"===r?"object with keys {"+Object.keys(n).join(", ")+"}":r)+"). If you meant to render a collection of children, use an array instead.");return u}function A(e,t,n){if(null==e)return e;var r=[],i=0;return x(e,r,"","",(function(e){return t.call(n,e,i++)})),r}function R(e){if(-1===e._status){var t=e._result;(t=t()).then((function(t){0!==e._status&&-1!==e._status||(e._status=1,e._result=t);}),(function(t){0!==e._status&&-1!==e._status||(e._status=2,e._result=t);})),-1===e._status&&(e._status=0,e._result=t);}if(1===e._status)return e._result.default;throw e._result}var T={current:null},P={transition:null},L={ReactCurrentDispatcher:T,ReactCurrentBatchConfig:P,ReactCurrentOwner:_};return xT.Children={map:A,forEach:function(e,t,n){A(e,(function(){t.apply(this,arguments);}),n);},count:function(e){var t=0;return A(e,(function(){t++;})),t},toArray:function(e){return A(e,(function(e){return e}))||[]},only:function(e){if(!k(e))throw Error("React.Children.only expected to receive a single React element child.");return e}},xT.Component=m,xT.Fragment=n,xT.Profiler=i,xT.PureComponent=v,xT.StrictMode=r,xT.Suspense=u,xT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=L,xT.cloneElement=function(t,n,r){if(null==t)throw Error("React.cloneElement(...): The argument must be a React element, but you passed "+t+".");var i=h({},t.props),o=t.key,a=t.ref,s=t._owner;if(null!=n){if(void 0!==n.ref&&(a=n.ref,s=_.current),void 0!==n.key&&(o=""+n.key),t.type&&t.type.defaultProps)var u=t.type.defaultProps;for(l in n)w.call(n,l)&&!S.hasOwnProperty(l)&&(i[l]=void 0===n[l]&&void 0!==u?u[l]:n[l]);}var l=arguments.length-2;if(1===l)i.children=r;else if(1<l){u=Array(l);for(var c=0;c<l;c++)u[c]=arguments[c+2];i.children=u;}return {$$typeof:e,type:t.type,key:o,ref:a,props:i,_owner:s}},xT.createContext=function(e){return (e={$$typeof:a,_currentValue:e,_currentValue2:e,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null}).Provider={$$typeof:o,_context:e},e.Consumer=e},xT.createElement=E,xT.createFactory=function(e){var t=E.bind(null,e);return t.type=e,t},xT.createRef=function(){return {current:null}},xT.forwardRef=function(e){return {$$typeof:s,render:e}},xT.isValidElement=k,xT.lazy=function(e){return {$$typeof:c,_payload:{_status:-1,_result:e},_init:R}},xT.memo=function(e,t){return {$$typeof:l,type:e,compare:void 0===t?null:t}},xT.startTransition=function(e){var t=P.transition;P.transition={};try{e();}finally{P.transition=t;}},xT.unstable_act=function(){throw Error("act(...) is not supported in production builds of React.")},xT.useCallback=function(e,t){return T.current.useCallback(e,t)},xT.useContext=function(e){return T.current.useContext(e)},xT.useDebugValue=function(){},xT.useDeferredValue=function(e){return T.current.useDeferredValue(e)},xT.useEffect=function(e,t){return T.current.useEffect(e,t)},xT.useId=function(){return T.current.useId()},xT.useImperativeHandle=function(e,t,n){return T.current.useImperativeHandle(e,t,n)},xT.useInsertionEffect=function(e,t){return T.current.useInsertionEffect(e,t)},xT.useLayoutEffect=function(e,t){return T.current.useLayoutEffect(e,t)},xT.useMemo=function(e,t){return T.current.useMemo(e,t)},xT.useReducer=function(e,t,n){return T.current.useReducer(e,t,n)},xT.useRef=function(e){return T.current.useRef(e)},xT.useState=function(e){return T.current.useState(e)},xT.useSyncExternalStore=function(e,t,n){return T.current.useSyncExternalStore(e,t,n)},xT.useTransition=function(){return T.current.useTransition()},xT.version="18.2.0",xT}var RT,TT,PT={exports:{}};function LT(){return RT||(RT=1,function(e,t){"production"!==je.env.NODE_ENV&&function(){"undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error);var n=Symbol.for("react.element"),r=Symbol.for("react.portal"),i=Symbol.for("react.fragment"),o=Symbol.for("react.strict_mode"),a=Symbol.for("react.profiler"),s=Symbol.for("react.provider"),u=Symbol.for("react.context"),l=Symbol.for("react.forward_ref"),c=Symbol.for("react.suspense"),d=Symbol.for("react.suspense_list"),f=Symbol.for("react.memo"),h=Symbol.for("react.lazy"),p=Symbol.for("react.offscreen"),m=Symbol.iterator,g="@@iterator";function v(e){if(null===e||"object"!=typeof e)return null;var t=m&&e[m]||e[g];return "function"==typeof t?t:null}var b={current:null},y={transition:null},w={current:null,isBatchingLegacy:false,didScheduleLegacyUpdate:false},_={current:null},S={},E=null;function k(e){E=e;}S.setExtraStackFrame=function(e){E=e;},S.getCurrentStack=null,S.getStackAddendum=function(){var e="";E&&(e+=E);var t=S.getCurrentStack;return t&&(e+=t()||""),e};var M=false,C=false,x=false,A=false,R=false,T={ReactCurrentDispatcher:b,ReactCurrentBatchConfig:y,ReactCurrentOwner:_};function P(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];I("warn",e,n);}function L(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];I("error",e,n);}function I(e,t,n){var r=T.ReactDebugCurrentFrame.getStackAddendum();""!==r&&(t+="%s",n=n.concat([r]));var i=n.map((function(e){return String(e)}));i.unshift("Warning: "+t),Function.prototype.apply.call(console[e],console,i);}T.ReactDebugCurrentFrame=S,T.ReactCurrentActQueue=w;var O={};function N(e,t){var n=e.constructor,r=n&&(n.displayName||n.name)||"ReactClass",i=r+"."+t;O[i]||(L("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",t,r),O[i]=true);}var D={isMounted:function(e){return  false},enqueueForceUpdate:function(e,t,n){N(e,"forceUpdate");},enqueueReplaceState:function(e,t,n,r){N(e,"replaceState");},enqueueSetState:function(e,t,n,r){N(e,"setState");}},j=Object.assign,B={};function z(e,t,n){this.props=e,this.context=t,this.refs=B,this.updater=n||D;}Object.freeze(B),z.prototype.isReactComponent={},z.prototype.setState=function(e,t){if("object"!=typeof e&&"function"!=typeof e&&null!=e)throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");this.updater.enqueueSetState(this,e,t,"setState");},z.prototype.forceUpdate=function(e){this.updater.enqueueForceUpdate(this,e,"forceUpdate");};var U={isMounted:["isMounted","Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],replaceState:["replaceState","Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]},F=function(e,t){Object.defineProperty(z.prototype,e,{get:function(){P("%s(...) is deprecated in plain JavaScript React classes. %s",t[0],t[1]);}});};for(var K in U)U.hasOwnProperty(K)&&F(K,U[K]);function q(){}function H(e,t,n){this.props=e,this.context=t,this.refs=B,this.updater=n||D;}q.prototype=z.prototype;var W=H.prototype=new q;W.constructor=H,j(W,z.prototype),W.isPureReactComponent=true;var $=Array.isArray;function V(e){return $(e)}function Y(e){return ""+e}function G(e){if(function(e){try{return Y(e),!1}catch(e){return  true}}(e))return L("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.",function(e){return "function"==typeof Symbol&&Symbol.toStringTag&&e[Symbol.toStringTag]||e.constructor.name||"Object"}(e)),Y(e)}function Z(e){return e.displayName||"Context"}function Q(e){if(null==e)return null;if("number"==typeof e.tag&&L("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."),"function"==typeof e)return e.displayName||e.name||null;if("string"==typeof e)return e;switch(e){case i:return "Fragment";case r:return "Portal";case a:return "Profiler";case o:return "StrictMode";case c:return "Suspense";case d:return "SuspenseList"}if("object"==typeof e)switch(e.$$typeof){case u:return Z(e)+".Consumer";case s:return Z(e._context)+".Provider";case l:return function(e,t,n){var r=e.displayName;if(r)return r;var i=t.displayName||t.name||"";return ""!==i?n+"("+i+")":n}(e,e.render,"ForwardRef");case f:var t=e.displayName||null;return null!==t?t:Q(e.type)||"Memo";case h:var n=e,p=n._payload,m=n._init;try{return Q(m(p))}catch(e){return null}}return null}var J,X,ee,te=Object.prototype.hasOwnProperty,ne={key:true,ref:true,__self:true,__source:true};function re(e){if(te.call(e,"ref")){var t=Object.getOwnPropertyDescriptor(e,"ref").get;if(t&&t.isReactWarning)return  false}return void 0!==e.ref}function ie(e){if(te.call(e,"key")){var t=Object.getOwnPropertyDescriptor(e,"key").get;if(t&&t.isReactWarning)return  false}return void 0!==e.key}ee={};var oe=function(e,t,r,i,o,a,s){var u={$$typeof:n,type:e,key:t,ref:r,props:s,_owner:a,_store:{}};return Object.defineProperty(u._store,"validated",{configurable:false,enumerable:false,writable:true,value:false}),Object.defineProperty(u,"_self",{configurable:false,enumerable:false,writable:false,value:i}),Object.defineProperty(u,"_source",{configurable:false,enumerable:false,writable:false,value:o}),Object.freeze&&(Object.freeze(u.props),Object.freeze(u)),u};function ae(e,t,n){var r,i={},o=null,a=null,s=null,u=null;if(null!=t)for(r in re(t)&&(a=t.ref,function(e){if("string"==typeof e.ref&&_.current&&e.__self&&_.current.stateNode!==e.__self){var t=Q(_.current.type);ee[t]||(L('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref',t,e.ref),ee[t]=true);}}(t)),ie(t)&&(G(t.key),o=""+t.key),s=void 0===t.__self?null:t.__self,u=void 0===t.__source?null:t.__source,t)te.call(t,r)&&!ne.hasOwnProperty(r)&&(i[r]=t[r]);var l=arguments.length-2;if(1===l)i.children=n;else if(l>1){for(var c=Array(l),d=0;d<l;d++)c[d]=arguments[d+2];Object.freeze&&Object.freeze(c),i.children=c;}if(e&&e.defaultProps){var f=e.defaultProps;for(r in f) void 0===i[r]&&(i[r]=f[r]);}if(o||a){var h="function"==typeof e?e.displayName||e.name||"Unknown":e;o&&function(e,t){var n=function(){J||(J=true,L("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)",t));};n.isReactWarning=true,Object.defineProperty(e,"key",{get:n,configurable:true});}(i,h),a&&function(e,t){var n=function(){X||(X=true,L("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)",t));};n.isReactWarning=true,Object.defineProperty(e,"ref",{get:n,configurable:true});}(i,h);}return oe(e,o,a,s,u,_.current,i)}function se(e,t,n){if(null==e)throw new Error("React.cloneElement(...): The argument must be a React element, but you passed "+e+".");var r,i,o=j({},e.props),a=e.key,s=e.ref,u=e._self,l=e._source,c=e._owner;if(null!=t)for(r in re(t)&&(s=t.ref,c=_.current),ie(t)&&(G(t.key),a=""+t.key),e.type&&e.type.defaultProps&&(i=e.type.defaultProps),t)te.call(t,r)&&!ne.hasOwnProperty(r)&&(void 0===t[r]&&void 0!==i?o[r]=i[r]:o[r]=t[r]);var d=arguments.length-2;if(1===d)o.children=n;else if(d>1){for(var f=Array(d),h=0;h<d;h++)f[h]=arguments[h+2];o.children=f;}return oe(e.type,a,s,u,l,c,o)}function ue(e){return "object"==typeof e&&null!==e&&e.$$typeof===n}var le=".",ce=":";var de=false,fe=/\/+/g;function he(e){return e.replace(fe,"$&/")}function pe(e,t){return "object"==typeof e&&null!==e&&null!=e.key?(G(e.key),function(e){var t={"=":"=0",":":"=2"};return "$"+e.replace(/[=:]/g,(function(e){return t[e]}))}(""+e.key)):t.toString(36)}function me(e,t,i,o,a){var s=typeof e;"undefined"!==s&&"boolean"!==s||(e=null);var u,l,c,d=false;if(null===e)d=true;else switch(s){case "string":case "number":d=true;break;case "object":switch(e.$$typeof){case n:case r:d=true;}}if(d){var f=e,h=a(f),p=""===o?le+pe(f,0):o;if(V(h)){var m="";null!=p&&(m=he(p)+"/"),me(h,t,m,"",(function(e){return e}));}else null!=h&&(ue(h)&&(!h.key||f&&f.key===h.key||G(h.key),u=h,l=i+(!h.key||f&&f.key===h.key?"":he(""+h.key)+"/")+p,h=oe(u.type,l,u.ref,u._self,u._source,u._owner,u.props)),t.push(h));return 1}var g=0,b=""===o?le:o+ce;if(V(e))for(var y=0;y<e.length;y++)g+=me(c=e[y],t,i,b+pe(c,y),a);else {var w=v(e);if("function"==typeof w){var _=e;w===_.entries&&(de||P("Using Maps as children is not supported. Use an array of keyed ReactElements instead."),de=true);for(var S,E=w.call(_),k=0;!(S=E.next()).done;)g+=me(c=S.value,t,i,b+pe(c,k++),a);}else if("object"===s){var M=String(e);throw new Error("Objects are not valid as a React child (found: "+("[object Object]"===M?"object with keys {"+Object.keys(e).join(", ")+"}":M)+"). If you meant to render a collection of children, use an array instead.")}}return g}function ge(e,t,n){if(null==e)return e;var r=[],i=0;return me(e,r,"","",(function(e){return t.call(n,e,i++)})),r}var ve,be=-1,ye=0,we=1,_e=2;function Se(e){if(e._status===be){var t=(0, e._result)();if(t.then((function(t){if(e._status===ye||e._status===be){var n=e;n._status=we,n._result=t;}}),(function(t){if(e._status===ye||e._status===be){var n=e;n._status=_e,n._result=t;}})),e._status===be){var n=e;n._status=ye,n._result=t;}}if(e._status===we){var r=e._result;return void 0===r&&L("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?",r),"default"in r||L("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))",r),r.default}throw e._result}function Ee(e){return "string"==typeof e||"function"==typeof e||(!!(e===i||e===a||R||e===o||e===c||e===d||A||e===p||M||C||x)||"object"==typeof e&&null!==e&&(e.$$typeof===h||e.$$typeof===f||e.$$typeof===s||e.$$typeof===u||e.$$typeof===l||e.$$typeof===ve||void 0!==e.getModuleId))}function ke(){var e=b.current;return null===e&&L("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem."),e}ve=Symbol.for("react.module.reference");var Me,Ce,xe,Ae,Re,Te,Pe,Le=0;function Ie(){}Ie.__reactDisabledLog=true;var Oe,Ne=T.ReactCurrentDispatcher;function De(e,t,n){if(void 0===Oe)try{throw Error()}catch(e){var r=e.stack.trim().match(/\n( *(at )?)/);Oe=r&&r[1]||"";}return "\n"+Oe+e}var je,Be=false,ze="function"==typeof WeakMap?WeakMap:Map;function Ue(e,t){if(!e||Be)return "";var n,r=je.get(e);if(void 0!==r)return r;Be=true;var i,o=Error.prepareStackTrace;Error.prepareStackTrace=void 0,i=Ne.current,Ne.current=null,function(){if(0===Le){Me=console.log,Ce=console.info,xe=console.warn,Ae=console.error,Re=console.group,Te=console.groupCollapsed,Pe=console.groupEnd;var e={configurable:true,enumerable:true,value:Ie,writable:true};Object.defineProperties(console,{info:e,log:e,warn:e,error:e,group:e,groupCollapsed:e,groupEnd:e});}Le++;}();try{if(t){var a=function(){throw Error()};if(Object.defineProperty(a.prototype,"props",{set:function(){throw Error()}}),"object"==typeof Reflect&&Reflect.construct){try{Reflect.construct(a,[]);}catch(e){n=e;}Reflect.construct(e,[],a);}else {try{a.call();}catch(e){n=e;}e.call(a.prototype);}}else {try{throw Error()}catch(e){n=e;}e();}}catch(t){if(t&&n&&"string"==typeof t.stack){for(var s=t.stack.split("\n"),u=n.stack.split("\n"),l=s.length-1,c=u.length-1;l>=1&&c>=0&&s[l]!==u[c];)c--;for(;l>=1&&c>=0;l--,c--)if(s[l]!==u[c]){if(1!==l||1!==c)do{if(l--,--c<0||s[l]!==u[c]){var d="\n"+s[l].replace(" at new "," at ");return e.displayName&&d.includes("<anonymous>")&&(d=d.replace("<anonymous>",e.displayName)),"function"==typeof e&&je.set(e,d),d}}while(l>=1&&c>=0);break}}}finally{Be=false,Ne.current=i,function(){if(0==--Le){var e={configurable:true,enumerable:true,writable:true};Object.defineProperties(console,{log:j({},e,{value:Me}),info:j({},e,{value:Ce}),warn:j({},e,{value:xe}),error:j({},e,{value:Ae}),group:j({},e,{value:Re}),groupCollapsed:j({},e,{value:Te}),groupEnd:j({},e,{value:Pe})});}Le<0&&L("disabledDepth fell below zero. This is a bug in React. Please file an issue.");}(),Error.prepareStackTrace=o;}var f=e?e.displayName||e.name:"",h=f?De(f):"";return "function"==typeof e&&je.set(e,h),h}function Fe(e,t,n){if(null==e)return "";if("function"==typeof e)return Ue(e,function(e){var t=e.prototype;return !(!t||!t.isReactComponent)}(e));if("string"==typeof e)return De(e);switch(e){case c:return De("Suspense");case d:return De("SuspenseList")}if("object"==typeof e)switch(e.$$typeof){case l:return Ue(e.render,false);case f:return Fe(e.type,t,n);case h:var r=e,i=r._payload,o=r._init;try{return Fe(o(i),t,n)}catch(e){}}return ""}je=new ze;var Ke,qe={},He=T.ReactDebugCurrentFrame;function We(e){if(e){var t=e._owner,n=Fe(e.type,e._source,t?t.type:null);He.setExtraStackFrame(n);}else He.setExtraStackFrame(null);}function $e(e){if(e){var t=e._owner;k(Fe(e.type,e._source,t?t.type:null));}else k(null);}function Ve(){if(_.current){var e=Q(_.current.type);if(e)return "\n\nCheck the render method of `"+e+"`."}return ""}Ke=false;var Ye={};function Ge(e,t){if(e._store&&!e._store.validated&&null==e.key){e._store.validated=true;var n=function(e){var t=Ve();if(!t){var n="string"==typeof e?e:e.displayName||e.name;n&&(t="\n\nCheck the top-level render call using <"+n+">.");}return t}(t);if(!Ye[n]){Ye[n]=true;var r="";e&&e._owner&&e._owner!==_.current&&(r=" It was passed a child from "+Q(e._owner.type)+"."),$e(e),L('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.',n,r),$e(null);}}}function Ze(e,t){if("object"==typeof e)if(V(e))for(var n=0;n<e.length;n++){var r=e[n];ue(r)&&Ge(r,t);}else if(ue(e))e._store&&(e._store.validated=true);else if(e){var i=v(e);if("function"==typeof i&&i!==e.entries)for(var o,a=i.call(e);!(o=a.next()).done;)ue(o.value)&&Ge(o.value,t);}}function Qe(e){var t,n=e.type;if(null!=n&&"string"!=typeof n){if("function"==typeof n)t=n.propTypes;else {if("object"!=typeof n||n.$$typeof!==l&&n.$$typeof!==f)return;t=n.propTypes;}if(t){var r=Q(n);!function(e,t,n,r,i){var o=Function.call.bind(te);for(var a in e)if(o(e,a)){var s=void 0;try{if("function"!=typeof e[a]){var u=Error((r||"React class")+": "+n+" type `"+a+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof e[a]+"`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");throw u.name="Invariant Violation",u}s=e[a](t,a,r,n,null,"SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");}catch(e){s=e;}!s||s instanceof Error||(We(i),L("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",r||"React class",n,a,typeof s),We(null)),s instanceof Error&&!(s.message in qe)&&(qe[s.message]=true,We(i),L("Failed %s type: %s",n,s.message),We(null));}}(t,e.props,"prop",r,e);}else if(void 0!==n.PropTypes&&!Ke){Ke=true,L("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?",Q(n)||"Unknown");}"function"!=typeof n.getDefaultProps||n.getDefaultProps.isReactClassApproved||L("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");}}function Je(e,t,r){var o,a,s=Ee(e);if(!s){var u="";(void 0===e||"object"==typeof e&&null!==e&&0===Object.keys(e).length)&&(u+=" You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");var l,c=null!=(o=t)&&void 0!==(a=o.__source)?"\n\nCheck your code at "+a.fileName.replace(/^.*[\\\/]/,"")+":"+a.lineNumber+".":"";u+=c||Ve(),null===e?l="null":V(e)?l="array":void 0!==e&&e.$$typeof===n?(l="<"+(Q(e.type)||"Unknown")+" />",u=" Did you accidentally export a JSX literal instead of a component?"):l=typeof e,L("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",l,u);}var d=ae.apply(this,arguments);if(null==d)return d;if(s)for(var f=2;f<arguments.length;f++)Ze(arguments[f],e);return e===i?function(e){for(var t=Object.keys(e.props),n=0;n<t.length;n++){var r=t[n];if("children"!==r&&"key"!==r){$e(e),L("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",r),$e(null);break}}null!==e.ref&&($e(e),L("Invalid attribute `ref` supplied to `React.Fragment`."),$e(null));}(d):Qe(d),d}var Xe=false;var et=false,tt=null;var nt=0,rt=false;function it(e){e!==nt-1&&L("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "),nt=e;}function ot(t,n,r){var i=w.current;if(null!==i)try{st(i),function(t){if(null===tt)try{var n=("require"+Math.random()).slice(0,7),r=e&&e[n];tt=r.call(e,"timers").setImmediate;}catch(e){tt=function(e){!1===et&&(et=!0,"undefined"==typeof MessageChannel&&L("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));var t=new MessageChannel;t.port1.onmessage=e,t.port2.postMessage(void 0);};}tt(t);}((function(){0===i.length?(w.current=null,n(t)):ot(t,n,r);}));}catch(e){r(e);}else n(t);}var at=false;function st(e){if(!at){at=true;var t=0;try{for(;t<e.length;t++){var n=e[t];do{n=n(!0);}while(null!==n)}e.length=0;}catch(n){throw e=e.slice(t+1),n}finally{at=false;}}}var ut=Je,lt=function(e,t,n){for(var r=se.apply(this,arguments),i=2;i<arguments.length;i++)Ze(arguments[i],r.type);return Qe(r),r},ct=function(e){var t=Je.bind(null,e);return t.type=e,Xe||(Xe=true,P("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")),Object.defineProperty(t,"type",{enumerable:false,get:function(){return P("Factory.type is deprecated. Access the class directly before passing it to createFactory."),Object.defineProperty(this,"type",{value:e}),e}}),t},dt={map:ge,forEach:function(e,t,n){ge(e,(function(){t.apply(this,arguments);}),n);},count:function(e){var t=0;return ge(e,(function(){t++;})),t},toArray:function(e){return ge(e,(function(e){return e}))||[]},only:function(e){if(!ue(e))throw new Error("React.Children.only expected to receive a single React element child.");return e}};t.Children=dt,t.Component=z,t.Fragment=i,t.Profiler=a,t.PureComponent=H,t.StrictMode=o,t.Suspense=c,t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T,t.cloneElement=lt,t.createContext=function(e){var t={$$typeof:u,_currentValue:e,_currentValue2:e,_threadCount:0,Provider:null,Consumer:null,_defaultValue:null,_globalName:null};t.Provider={$$typeof:s,_context:t};var n=false,r=false,i=false,o={$$typeof:u,_context:t};return Object.defineProperties(o,{Provider:{get:function(){return r||(r=true,L("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")),t.Provider},set:function(e){t.Provider=e;}},_currentValue:{get:function(){return t._currentValue},set:function(e){t._currentValue=e;}},_currentValue2:{get:function(){return t._currentValue2},set:function(e){t._currentValue2=e;}},_threadCount:{get:function(){return t._threadCount},set:function(e){t._threadCount=e;}},Consumer:{get:function(){return n||(n=true,L("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")),t.Consumer}},displayName:{get:function(){return t.displayName},set:function(e){i||(P("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.",e),i=true);}}}),t.Consumer=o,t._currentRenderer=null,t._currentRenderer2=null,t},t.createElement=ut,t.createFactory=ct,t.createRef=function(){var e={current:null};return Object.seal(e),e},t.forwardRef=function(e){null!=e&&e.$$typeof===f?L("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))."):"function"!=typeof e?L("forwardRef requires a render function but was given %s.",null===e?"null":typeof e):0!==e.length&&2!==e.length&&L("forwardRef render functions accept exactly two parameters: props and ref. %s",1===e.length?"Did you forget to use the ref parameter?":"Any additional parameter will be undefined."),null!=e&&(null==e.defaultProps&&null==e.propTypes||L("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?"));var t,n={$$typeof:l,render:e};return Object.defineProperty(n,"displayName",{enumerable:false,configurable:true,get:function(){return t},set:function(n){t=n,e.name||e.displayName||(e.displayName=n);}}),n},t.isValidElement=ue,t.lazy=function(e){var t,n,r={$$typeof:h,_payload:{_status:be,_result:e},_init:Se};return Object.defineProperties(r,{defaultProps:{configurable:true,get:function(){return t},set:function(e){L("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."),t=e,Object.defineProperty(r,"defaultProps",{enumerable:true});}},propTypes:{configurable:true,get:function(){return n},set:function(e){L("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."),n=e,Object.defineProperty(r,"propTypes",{enumerable:true});}}}),r},t.memo=function(e,t){Ee(e)||L("memo: The first argument must be a component. Instead received: %s",null===e?"null":typeof e);var n,r={$$typeof:f,type:e,compare:void 0===t?null:t};return Object.defineProperty(r,"displayName",{enumerable:false,configurable:true,get:function(){return n},set:function(t){n=t,e.name||e.displayName||(e.displayName=t);}}),r},t.startTransition=function(e,t){var n=y.transition;y.transition={};var r=y.transition;y.transition._updatedFibers=new Set;try{e();}finally{if(y.transition=n,null===n&&r._updatedFibers)r._updatedFibers.size>10&&P("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."),r._updatedFibers.clear();}},t.unstable_act=function(e){var t=nt;nt++,null===w.current&&(w.current=[]);var n,r=w.isBatchingLegacy;try{if(w.isBatchingLegacy=!0,n=e(),!r&&w.didScheduleLegacyUpdate){var i=w.current;null!==i&&(w.didScheduleLegacyUpdate=!1,st(i));}}catch(e){throw it(t),e}finally{w.isBatchingLegacy=r;}if(null!==n&&"object"==typeof n&&"function"==typeof n.then){var o=n,a=false,s={then:function(e,n){a=true,o.then((function(r){it(t),0===nt?ot(r,e,n):e(r);}),(function(e){it(t),n(e);}));}};return rt||"undefined"==typeof Promise||Promise.resolve().then((function(){})).then((function(){a||(rt=true,L("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));})),s}var u=n;if(it(t),0===nt){var l=w.current;return null!==l&&(st(l),w.current=null),{then:function(e,t){null===w.current?(w.current=[],ot(u,e,t)):e(u);}}}return {then:function(e,t){e(u);}}},t.useCallback=function(e,t){return ke().useCallback(e,t)},t.useContext=function(e){var t=ke();if(void 0!==e._context){var n=e._context;n.Consumer===e?L("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?"):n.Provider===e&&L("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");}return t.useContext(e)},t.useDebugValue=function(e,t){return ke().useDebugValue(e,t)},t.useDeferredValue=function(e){return ke().useDeferredValue(e)},t.useEffect=function(e,t){return ke().useEffect(e,t)},t.useId=function(){return ke().useId()},t.useImperativeHandle=function(e,t,n){return ke().useImperativeHandle(e,t,n)},t.useInsertionEffect=function(e,t){return ke().useInsertionEffect(e,t)},t.useLayoutEffect=function(e,t){return ke().useLayoutEffect(e,t)},t.useMemo=function(e,t){return ke().useMemo(e,t)},t.useReducer=function(e,t,n){return ke().useReducer(e,t,n)},t.useRef=function(e){return ke().useRef(e)},t.useState=function(e){return ke().useState(e)},t.useSyncExternalStore=function(e,t,n){return ke().useSyncExternalStore(e,t,n)},t.useTransition=function(){return ke().useTransition()},t.version="18.2.0","undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error);}();}(PT,PT.exports)),PT.exports}function IT(){return TT||(TT=1,"production"===je.env.NODE_ENV?CT.exports=AT():CT.exports=LT()),CT.exports}PT.exports;var OT,NT={},DT={exports:{}},jT={},BT={exports:{}},zT={};var UT,FT,KT,qT={};function HT(){return UT||(UT=1,function(e){"production"!==je.env.NODE_ENV&&function(){"undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error);var t=false,n=false;function r(e,t){var n=e.length;e.push(t),function(e,t,n){var r=n;for(;r>0;){var i=r-1>>>1,o=e[i];if(!(a(o,t)>0))return;e[i]=t,e[r]=o,r=i;}}(e,t,n);}function i(e){return 0===e.length?null:e[0]}function o(e){if(0===e.length)return null;var t=e[0],n=e.pop();return n!==t&&(e[0]=n,function(e,t,n){var r=n,i=e.length,o=i>>>1;for(;r<o;){var s=2*(r+1)-1,u=e[s],l=s+1,c=e[l];if(a(u,t)<0)l<i&&a(c,u)<0?(e[r]=c,e[l]=t,r=l):(e[r]=u,e[s]=t,r=s);else {if(!(l<i&&a(c,t)<0))return;e[r]=c,e[l]=t,r=l;}}}(e,n,0)),t}function a(e,t){var n=e.sortIndex-t.sortIndex;return 0!==n?n:e.id-t.id}if("object"==typeof performance&&"function"==typeof performance.now){var s=performance;e.unstable_now=function(){return s.now()};}else {var u=Date,l=u.now();e.unstable_now=function(){return u.now()-l};}var c=[],d=[],f=1,h=null,p=3,m=false,g=false,v=false,b="function"==typeof setTimeout?setTimeout:null,y="function"==typeof clearTimeout?clearTimeout:null,w="undefined"!=typeof setImmediate?setImmediate:null;function _(e){for(var t=i(d);null!==t;){if(null===t.callback)o(d);else {if(!(t.startTime<=e))return;o(d),t.sortIndex=t.expirationTime,r(c,t);}t=i(d);}}function S(e){if(v=false,_(e),!g)if(null!==i(c))g=true,O(E);else {var t=i(d);null!==t&&N(S,t.startTime-e);}}function E(r,a){g=false,v&&(v=false,D()),m=true;var s=p;try{if(!n)return function(n,r){var a=r;_(a),h=i(c);for(;null!==h&&!t&&(!(h.expirationTime>a)||n&&!R());){var s=h.callback;if("function"==typeof s){h.callback=null,p=h.priorityLevel;var u=s(h.expirationTime<=a);a=e.unstable_now(),"function"==typeof u?h.callback=u:h===i(c)&&o(c),_(a);}else o(c);h=i(c);}if(null!==h)return !0;var l=i(d);return null!==l&&N(S,l.startTime-a),!1}(r,a)}finally{h=null,p=s,m=false;}}"undefined"!=typeof navigator&&void 0!==navigator.scheduling&&void 0!==navigator.scheduling.isInputPending&&navigator.scheduling.isInputPending.bind(navigator.scheduling);var k=false,M=null,C=-1,x=5,A=-1;function R(){return !(e.unstable_now()-A<x)}var T,P=function(){if(null!==M){var t=e.unstable_now();A=t;var n=true;try{n=M(!0,t);}finally{n?T():(k=false,M=null);}}else k=false;};if("function"==typeof w)T=function(){w(P);};else if("undefined"!=typeof MessageChannel){var L=new MessageChannel,I=L.port2;L.port1.onmessage=P,T=function(){I.postMessage(null);};}else T=function(){b(P,0);};function O(e){M=e,k||(k=true,T());}function N(t,n){C=b((function(){t(e.unstable_now());}),n);}function D(){y(C),C=-1;}var j=function(){};e.unstable_IdlePriority=5,e.unstable_ImmediatePriority=1,e.unstable_LowPriority=4,e.unstable_NormalPriority=3,e.unstable_Profiling=null,e.unstable_UserBlockingPriority=2,e.unstable_cancelCallback=function(e){e.callback=null;},e.unstable_continueExecution=function(){g||m||(g=true,O(E));},e.unstable_forceFrameRate=function(e){e<0||e>125?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):x=e>0?Math.floor(1e3/e):5;},e.unstable_getCurrentPriorityLevel=function(){return p},e.unstable_getFirstCallbackNode=function(){return i(c)},e.unstable_next=function(e){var t;switch(p){case 1:case 2:case 3:t=3;break;default:t=p;}var n=p;p=t;try{return e()}finally{p=n;}},e.unstable_pauseExecution=function(){},e.unstable_requestPaint=j,e.unstable_runWithPriority=function(e,t){switch(e){case 1:case 2:case 3:case 4:case 5:break;default:e=3;}var n=p;p=e;try{return t()}finally{p=n;}},e.unstable_scheduleCallback=function(t,n,o){var a,s,u=e.unstable_now();if("object"==typeof o&&null!==o){var l=o.delay;a="number"==typeof l&&l>0?u+l:u;}else a=u;switch(t){case 1:s=-1;break;case 2:s=250;break;case 5:s=1073741823;break;case 4:s=1e4;break;default:s=5e3;}var h=a+s,p={id:f++,callback:n,priorityLevel:t,startTime:a,expirationTime:h,sortIndex:-1};return a>u?(p.sortIndex=a,r(d,p),null===i(c)&&p===i(d)&&(v?D():v=true,N(S,a-u))):(p.sortIndex=h,r(c,p),g||m||(g=true,O(E))),p},e.unstable_shouldYield=R,e.unstable_wrapCallback=function(e){var t=p;return function(){var n=p;p=t;try{return e.apply(this,arguments)}finally{p=n;}}},"undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error);}();}(qT)),qT}function WT(){return FT||(FT=1,"production"===je.env.NODE_ENV?BT.exports=(OT||(OT=1,function(e){function t(e,t){var n=e.length;e.push(t);e:for(;0<n;){var r=n-1>>>1,o=e[r];if(!(0<i(o,t)))break e;e[r]=t,e[n]=o,n=r;}}function n(e){return 0===e.length?null:e[0]}function r(e){if(0===e.length)return null;var t=e[0],n=e.pop();if(n!==t){e[0]=n;e:for(var r=0,o=e.length,a=o>>>1;r<a;){var s=2*(r+1)-1,u=e[s],l=s+1,c=e[l];if(0>i(u,n))l<o&&0>i(c,u)?(e[r]=c,e[l]=n,r=l):(e[r]=u,e[s]=n,r=s);else {if(!(l<o&&0>i(c,n)))break e;e[r]=c,e[l]=n,r=l;}}}return t}function i(e,t){var n=e.sortIndex-t.sortIndex;return 0!==n?n:e.id-t.id}if("object"==typeof performance&&"function"==typeof performance.now){var o=performance;e.unstable_now=function(){return o.now()};}else {var a=Date,s=a.now();e.unstable_now=function(){return a.now()-s};}var u=[],l=[],c=1,d=null,f=3,h=false,p=false,m=false,g="function"==typeof setTimeout?setTimeout:null,v="function"==typeof clearTimeout?clearTimeout:null,b="undefined"!=typeof setImmediate?setImmediate:null;function y(e){for(var i=n(l);null!==i;){if(null===i.callback)r(l);else {if(!(i.startTime<=e))break;r(l),i.sortIndex=i.expirationTime,t(u,i);}i=n(l);}}function w(e){if(m=false,y(e),!p)if(null!==n(u))p=true,L(_);else {var t=n(l);null!==t&&I(w,t.startTime-e);}}function _(t,i){p=false,m&&(m=false,v(M),M=-1),h=true;var o=f;try{for(y(i),d=n(u);null!==d&&(!(d.expirationTime>i)||t&&!A());){var a=d.callback;if("function"==typeof a){d.callback=null,f=d.priorityLevel;var s=a(d.expirationTime<=i);i=e.unstable_now(),"function"==typeof s?d.callback=s:d===n(u)&&r(u),y(i);}else r(u);d=n(u);}if(null!==d)var c=!0;else {var g=n(l);null!==g&&I(w,g.startTime-i),c=!1;}return c}finally{d=null,f=o,h=false;}}"undefined"!=typeof navigator&&void 0!==navigator.scheduling&&void 0!==navigator.scheduling.isInputPending&&navigator.scheduling.isInputPending.bind(navigator.scheduling);var S,E=false,k=null,M=-1,C=5,x=-1;function A(){return !(e.unstable_now()-x<C)}function R(){if(null!==k){var t=e.unstable_now();x=t;var n=true;try{n=k(!0,t);}finally{n?S():(E=false,k=null);}}else E=false;}if("function"==typeof b)S=function(){b(R);};else if("undefined"!=typeof MessageChannel){var T=new MessageChannel,P=T.port2;T.port1.onmessage=R,S=function(){P.postMessage(null);};}else S=function(){g(R,0);};function L(e){k=e,E||(E=true,S());}function I(t,n){M=g((function(){t(e.unstable_now());}),n);}e.unstable_IdlePriority=5,e.unstable_ImmediatePriority=1,e.unstable_LowPriority=4,e.unstable_NormalPriority=3,e.unstable_Profiling=null,e.unstable_UserBlockingPriority=2,e.unstable_cancelCallback=function(e){e.callback=null;},e.unstable_continueExecution=function(){p||h||(p=true,L(_));},e.unstable_forceFrameRate=function(e){0>e||125<e?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):C=0<e?Math.floor(1e3/e):5;},e.unstable_getCurrentPriorityLevel=function(){return f},e.unstable_getFirstCallbackNode=function(){return n(u)},e.unstable_next=function(e){switch(f){case 1:case 2:case 3:var t=3;break;default:t=f;}var n=f;f=t;try{return e()}finally{f=n;}},e.unstable_pauseExecution=function(){},e.unstable_requestPaint=function(){},e.unstable_runWithPriority=function(e,t){switch(e){case 1:case 2:case 3:case 4:case 5:break;default:e=3;}var n=f;f=e;try{return t()}finally{f=n;}},e.unstable_scheduleCallback=function(r,i,o){var a=e.unstable_now();switch(o="object"==typeof o&&null!==o&&"number"==typeof(o=o.delay)&&0<o?a+o:a,r){case 1:var s=-1;break;case 2:s=250;break;case 5:s=1073741823;break;case 4:s=1e4;break;default:s=5e3;}return r={id:c++,callback:i,priorityLevel:r,startTime:o,expirationTime:s=o+s,sortIndex:-1},o>a?(r.sortIndex=o,t(l,r),null===n(u)&&r===n(l)&&(m?(v(M),M=-1):m=true,I(w,o-a))):(r.sortIndex=s,t(u,r),p||h||(p=true,L(_))),r},e.unstable_shouldYield=A,e.unstable_wrapCallback=function(e){var t=f;return function(){var n=f;f=t;try{return e.apply(this,arguments)}finally{f=n;}}};}(zT)),zT):BT.exports=HT()),BT.exports}
		/**
		             * @license React
		             * react-dom.production.min.js
		             *
		             * Copyright (c) Facebook, Inc. and its affiliates.
		             *
		             * This source code is licensed under the MIT license found in the
		             * LICENSE file in the root directory of this source tree.
		             */function $T(){if(KT)return jT;KT=1;var e=IT(),t=WT();function n(e){for(var t="https://reactjs.org/docs/error-decoder.html?invariant="+e,n=1;n<arguments.length;n++)t+="&args[]="+encodeURIComponent(arguments[n]);return "Minified React error #"+e+"; visit "+t+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var r=new Set,i={};function o(e,t){a(e,t),a(e+"Capture",t);}function a(e,t){for(i[e]=t,e=0;e<t.length;e++)r.add(t[e]);}var s=!("undefined"==typeof window||void 0===window.document||void 0===window.document.createElement),u=Object.prototype.hasOwnProperty,l=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,c={},d={};function f(e,t,n,r,i,o,a){this.acceptsBooleans=2===t||3===t||4===t,this.attributeName=r,this.attributeNamespace=i,this.mustUseProperty=n,this.propertyName=e,this.type=t,this.sanitizeURL=o,this.removeEmptyString=a;}var h={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach((function(e){h[e]=new f(e,0,false,e,null,false,false);})),[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach((function(e){var t=e[0];h[t]=new f(t,1,false,e[1],null,false,false);})),["contentEditable","draggable","spellCheck","value"].forEach((function(e){h[e]=new f(e,2,false,e.toLowerCase(),null,false,false);})),["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach((function(e){h[e]=new f(e,2,false,e,null,false,false);})),"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach((function(e){h[e]=new f(e,3,false,e.toLowerCase(),null,false,false);})),["checked","multiple","muted","selected"].forEach((function(e){h[e]=new f(e,3,true,e,null,false,false);})),["capture","download"].forEach((function(e){h[e]=new f(e,4,false,e,null,false,false);})),["cols","rows","size","span"].forEach((function(e){h[e]=new f(e,6,false,e,null,false,false);})),["rowSpan","start"].forEach((function(e){h[e]=new f(e,5,false,e.toLowerCase(),null,false,false);}));var p=/[\-:]([a-z])/g;function m(e){return e[1].toUpperCase()}function g(e,t,n,r){var i=h.hasOwnProperty(t)?h[t]:null;(null!==i?0!==i.type:r||!(2<t.length)||"o"!==t[0]&&"O"!==t[0]||"n"!==t[1]&&"N"!==t[1])&&(function(e,t,n,r){if(null==t||function(e,t,n,r){if(null!==n&&0===n.type)return  false;switch(typeof t){case "function":case "symbol":return  true;case "boolean":return !r&&(null!==n?!n.acceptsBooleans:"data-"!==(e=e.toLowerCase().slice(0,5))&&"aria-"!==e);default:return  false}}(e,t,n,r))return  true;if(r)return  false;if(null!==n)switch(n.type){case 3:return !t;case 4:return  false===t;case 5:return isNaN(t);case 6:return isNaN(t)||1>t}return  false}(t,n,i,r)&&(n=null),r||null===i?function(e){return !!u.call(d,e)||!u.call(c,e)&&(l.test(e)?d[e]=true:(c[e]=true,false))}(t)&&(null===n?e.removeAttribute(t):e.setAttribute(t,""+n)):i.mustUseProperty?e[i.propertyName]=null===n?3!==i.type&&"":n:(t=i.attributeName,r=i.attributeNamespace,null===n?e.removeAttribute(t):(n=3===(i=i.type)||4===i&&true===n?"":""+n,r?e.setAttributeNS(r,t,n):e.setAttribute(t,n))));}"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach((function(e){var t=e.replace(p,m);h[t]=new f(t,1,false,e,null,false,false);})),"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach((function(e){var t=e.replace(p,m);h[t]=new f(t,1,false,e,"http://www.w3.org/1999/xlink",false,false);})),["xml:base","xml:lang","xml:space"].forEach((function(e){var t=e.replace(p,m);h[t]=new f(t,1,false,e,"http://www.w3.org/XML/1998/namespace",false,false);})),["tabIndex","crossOrigin"].forEach((function(e){h[e]=new f(e,1,false,e.toLowerCase(),null,false,false);})),h.xlinkHref=new f("xlinkHref",1,false,"xlink:href","http://www.w3.org/1999/xlink",true,false),["src","href","action","formAction"].forEach((function(e){h[e]=new f(e,1,false,e.toLowerCase(),null,true,true);}));var v=e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,b=Symbol.for("react.element"),y=Symbol.for("react.portal"),w=Symbol.for("react.fragment"),_=Symbol.for("react.strict_mode"),S=Symbol.for("react.profiler"),E=Symbol.for("react.provider"),k=Symbol.for("react.context"),M=Symbol.for("react.forward_ref"),C=Symbol.for("react.suspense"),x=Symbol.for("react.suspense_list"),A=Symbol.for("react.memo"),R=Symbol.for("react.lazy"),T=Symbol.for("react.offscreen"),P=Symbol.iterator;function L(e){return null===e||"object"!=typeof e?null:"function"==typeof(e=P&&e[P]||e["@@iterator"])?e:null}var I,O=Object.assign;function N(e){if(void 0===I)try{throw Error()}catch(e){var t=e.stack.trim().match(/\n( *(at )?)/);I=t&&t[1]||"";}return "\n"+I+e}var D=false;function j(e,t){if(!e||D)return "";D=true;var n=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(t)if(t=function(){throw Error()},Object.defineProperty(t.prototype,"props",{set:function(){throw Error()}}),"object"==typeof Reflect&&Reflect.construct){try{Reflect.construct(t,[]);}catch(e){var r=e;}Reflect.construct(e,[],t);}else {try{t.call();}catch(e){r=e;}e.call(t.prototype);}else {try{throw Error()}catch(e){r=e;}e();}}catch(t){if(t&&r&&"string"==typeof t.stack){for(var i=t.stack.split("\n"),o=r.stack.split("\n"),a=i.length-1,s=o.length-1;1<=a&&0<=s&&i[a]!==o[s];)s--;for(;1<=a&&0<=s;a--,s--)if(i[a]!==o[s]){if(1!==a||1!==s)do{if(a--,0>--s||i[a]!==o[s]){var u="\n"+i[a].replace(" at new "," at ");return e.displayName&&u.includes("<anonymous>")&&(u=u.replace("<anonymous>",e.displayName)),u}}while(1<=a&&0<=s);break}}}finally{D=false,Error.prepareStackTrace=n;}return (e=e?e.displayName||e.name:"")?N(e):""}function B(e){switch(e.tag){case 5:return N(e.type);case 16:return N("Lazy");case 13:return N("Suspense");case 19:return N("SuspenseList");case 0:case 2:case 15:return e=j(e.type,false);case 11:return e=j(e.type.render,false);case 1:return e=j(e.type,true);default:return ""}}function z(e){if(null==e)return null;if("function"==typeof e)return e.displayName||e.name||null;if("string"==typeof e)return e;switch(e){case w:return "Fragment";case y:return "Portal";case S:return "Profiler";case _:return "StrictMode";case C:return "Suspense";case x:return "SuspenseList"}if("object"==typeof e)switch(e.$$typeof){case k:return (e.displayName||"Context")+".Consumer";case E:return (e._context.displayName||"Context")+".Provider";case M:var t=e.render;return (e=e.displayName)||(e=""!==(e=t.displayName||t.name||"")?"ForwardRef("+e+")":"ForwardRef"),e;case A:return null!==(t=e.displayName||null)?t:z(e.type)||"Memo";case R:t=e._payload,e=e._init;try{return z(e(t))}catch(e){}}return null}function U(e){var t=e.type;switch(e.tag){case 24:return "Cache";case 9:return (t.displayName||"Context")+".Consumer";case 10:return (t._context.displayName||"Context")+".Provider";case 18:return "DehydratedFragment";case 11:return e=(e=t.render).displayName||e.name||"",t.displayName||(""!==e?"ForwardRef("+e+")":"ForwardRef");case 7:return "Fragment";case 5:return t;case 4:return "Portal";case 3:return "Root";case 6:return "Text";case 16:return z(t);case 8:return t===_?"StrictMode":"Mode";case 22:return "Offscreen";case 12:return "Profiler";case 21:return "Scope";case 13:return "Suspense";case 19:return "SuspenseList";case 25:return "TracingMarker";case 1:case 0:case 17:case 2:case 14:case 15:if("function"==typeof t)return t.displayName||t.name||null;if("string"==typeof t)return t}return null}function F(e){switch(typeof e){case "boolean":case "number":case "string":case "undefined":case "object":return e;default:return ""}}function K(e){var t=e.type;return (e=e.nodeName)&&"input"===e.toLowerCase()&&("checkbox"===t||"radio"===t)}function q(e){e._valueTracker||(e._valueTracker=function(e){var t=K(e)?"checked":"value",n=Object.getOwnPropertyDescriptor(e.constructor.prototype,t),r=""+e[t];if(!e.hasOwnProperty(t)&&void 0!==n&&"function"==typeof n.get&&"function"==typeof n.set){var i=n.get,o=n.set;return Object.defineProperty(e,t,{configurable:true,get:function(){return i.call(this)},set:function(e){r=""+e,o.call(this,e);}}),Object.defineProperty(e,t,{enumerable:n.enumerable}),{getValue:function(){return r},setValue:function(e){r=""+e;},stopTracking:function(){e._valueTracker=null,delete e[t];}}}}(e));}function H(e){if(!e)return  false;var t=e._valueTracker;if(!t)return  true;var n=t.getValue(),r="";return e&&(r=K(e)?e.checked?"true":"false":e.value),(e=r)!==n&&(t.setValue(e),true)}function W(e){if(void 0===(e=e||("undefined"!=typeof document?document:void 0)))return null;try{return e.activeElement||e.body}catch(t){return e.body}}function $(e,t){var n=t.checked;return O({},t,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=n?n:e._wrapperState.initialChecked})}function V(e,t){var n=null==t.defaultValue?"":t.defaultValue,r=null!=t.checked?t.checked:t.defaultChecked;n=F(null!=t.value?t.value:n),e._wrapperState={initialChecked:r,initialValue:n,controlled:"checkbox"===t.type||"radio"===t.type?null!=t.checked:null!=t.value};}function Y(e,t){null!=(t=t.checked)&&g(e,"checked",t,false);}function G(e,t){Y(e,t);var n=F(t.value),r=t.type;if(null!=n)"number"===r?(0===n&&""===e.value||e.value!=n)&&(e.value=""+n):e.value!==""+n&&(e.value=""+n);else if("submit"===r||"reset"===r)return void e.removeAttribute("value");t.hasOwnProperty("value")?Q(e,t.type,n):t.hasOwnProperty("defaultValue")&&Q(e,t.type,F(t.defaultValue)),null==t.checked&&null!=t.defaultChecked&&(e.defaultChecked=!!t.defaultChecked);}function Z(e,t,n){if(t.hasOwnProperty("value")||t.hasOwnProperty("defaultValue")){var r=t.type;if(!("submit"!==r&&"reset"!==r||void 0!==t.value&&null!==t.value))return;t=""+e._wrapperState.initialValue,n||t===e.value||(e.value=t),e.defaultValue=t;}""!==(n=e.name)&&(e.name=""),e.defaultChecked=!!e._wrapperState.initialChecked,""!==n&&(e.name=n);}function Q(e,t,n){"number"===t&&W(e.ownerDocument)===e||(null==n?e.defaultValue=""+e._wrapperState.initialValue:e.defaultValue!==""+n&&(e.defaultValue=""+n));}var J=Array.isArray;function X(e,t,n,r){if(e=e.options,t){t={};for(var i=0;i<n.length;i++)t["$"+n[i]]=true;for(n=0;n<e.length;n++)i=t.hasOwnProperty("$"+e[n].value),e[n].selected!==i&&(e[n].selected=i),i&&r&&(e[n].defaultSelected=true);}else {for(n=""+F(n),t=null,i=0;i<e.length;i++){if(e[i].value===n)return e[i].selected=true,void(r&&(e[i].defaultSelected=true));null!==t||e[i].disabled||(t=e[i]);}null!==t&&(t.selected=true);}}function ee(e,t){if(null!=t.dangerouslySetInnerHTML)throw Error(n(91));return O({},t,{value:void 0,defaultValue:void 0,children:""+e._wrapperState.initialValue})}function te(e,t){var r=t.value;if(null==r){if(r=t.children,t=t.defaultValue,null!=r){if(null!=t)throw Error(n(92));if(J(r)){if(1<r.length)throw Error(n(93));r=r[0];}t=r;}null==t&&(t=""),r=t;}e._wrapperState={initialValue:F(r)};}function ne(e,t){var n=F(t.value),r=F(t.defaultValue);null!=n&&((n=""+n)!==e.value&&(e.value=n),null==t.defaultValue&&e.defaultValue!==n&&(e.defaultValue=n)),null!=r&&(e.defaultValue=""+r);}function re(e){var t=e.textContent;t===e._wrapperState.initialValue&&""!==t&&null!==t&&(e.value=t);}function ie(e){switch(e){case "svg":return "http://www.w3.org/2000/svg";case "math":return "http://www.w3.org/1998/Math/MathML";default:return "http://www.w3.org/1999/xhtml"}}function oe(e,t){return null==e||"http://www.w3.org/1999/xhtml"===e?ie(t):"http://www.w3.org/2000/svg"===e&&"foreignObject"===t?"http://www.w3.org/1999/xhtml":e}var ae,se,ue=(se=function(e,t){if("http://www.w3.org/2000/svg"!==e.namespaceURI||"innerHTML"in e)e.innerHTML=t;else {for((ae=ae||document.createElement("div")).innerHTML="<svg>"+t.valueOf().toString()+"</svg>",t=ae.firstChild;e.firstChild;)e.removeChild(e.firstChild);for(;t.firstChild;)e.appendChild(t.firstChild);}},"undefined"!=typeof MSApp&&MSApp.execUnsafeLocalFunction?function(e,t,n,r){MSApp.execUnsafeLocalFunction((function(){return se(e,t)}));}:se);function le(e,t){if(t){var n=e.firstChild;if(n&&n===e.lastChild&&3===n.nodeType)return void(n.nodeValue=t)}e.textContent=t;}var ce={animationIterationCount:true,aspectRatio:true,borderImageOutset:true,borderImageSlice:true,borderImageWidth:true,boxFlex:true,boxFlexGroup:true,boxOrdinalGroup:true,columnCount:true,columns:true,flex:true,flexGrow:true,flexPositive:true,flexShrink:true,flexNegative:true,flexOrder:true,gridArea:true,gridRow:true,gridRowEnd:true,gridRowSpan:true,gridRowStart:true,gridColumn:true,gridColumnEnd:true,gridColumnSpan:true,gridColumnStart:true,fontWeight:true,lineClamp:true,lineHeight:true,opacity:true,order:true,orphans:true,tabSize:true,widows:true,zIndex:true,zoom:true,fillOpacity:true,floodOpacity:true,stopOpacity:true,strokeDasharray:true,strokeDashoffset:true,strokeMiterlimit:true,strokeOpacity:true,strokeWidth:true},de=["Webkit","ms","Moz","O"];function fe(e,t,n){return null==t||"boolean"==typeof t||""===t?"":n||"number"!=typeof t||0===t||ce.hasOwnProperty(e)&&ce[e]?(""+t).trim():t+"px"}function he(e,t){for(var n in e=e.style,t)if(t.hasOwnProperty(n)){var r=0===n.indexOf("--"),i=fe(n,t[n],r);"float"===n&&(n="cssFloat"),r?e.setProperty(n,i):e[n]=i;}}Object.keys(ce).forEach((function(e){de.forEach((function(t){t=t+e.charAt(0).toUpperCase()+e.substring(1),ce[t]=ce[e];}));}));var pe=O({menuitem:true},{area:true,base:true,br:true,col:true,embed:true,hr:true,img:true,input:true,keygen:true,link:true,meta:true,param:true,source:true,track:true,wbr:true});function me(e,t){if(t){if(pe[e]&&(null!=t.children||null!=t.dangerouslySetInnerHTML))throw Error(n(137,e));if(null!=t.dangerouslySetInnerHTML){if(null!=t.children)throw Error(n(60));if("object"!=typeof t.dangerouslySetInnerHTML||!("__html"in t.dangerouslySetInnerHTML))throw Error(n(61))}if(null!=t.style&&"object"!=typeof t.style)throw Error(n(62))}}function ge(e,t){if(-1===e.indexOf("-"))return "string"==typeof t.is;switch(e){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return  false;default:return  true}}var ve=null;function be(e){return (e=e.target||e.srcElement||window).correspondingUseElement&&(e=e.correspondingUseElement),3===e.nodeType?e.parentNode:e}var ye=null,we=null,_e=null;function Se(e){if(e=gi(e)){if("function"!=typeof ye)throw Error(n(280));var t=e.stateNode;t&&(t=bi(t),ye(e.stateNode,e.type,t));}}function Ee(e){we?_e?_e.push(e):_e=[e]:we=e;}function ke(){if(we){var e=we,t=_e;if(_e=we=null,Se(e),t)for(e=0;e<t.length;e++)Se(t[e]);}}function Me(e,t){return e(t)}function Ce(){}var xe=false;function Ae(e,t,n){if(xe)return e(t,n);xe=true;try{return Me(e,t,n)}finally{xe=false,(null!==we||null!==_e)&&(Ce(),ke());}}function Re(e,t){var r=e.stateNode;if(null===r)return null;var i=bi(r);if(null===i)return null;r=i[t];e:switch(t){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(i=!i.disabled)||(i=!("button"===(e=e.type)||"input"===e||"select"===e||"textarea"===e)),e=!i;break e;default:e=false;}if(e)return null;if(r&&"function"!=typeof r)throw Error(n(231,t,typeof r));return r}var Te=false;if(s)try{var Pe={};Object.defineProperty(Pe,"passive",{get:function(){Te=!0;}}),window.addEventListener("test",Pe,Pe),window.removeEventListener("test",Pe,Pe);}catch(se){Te=false;}function Le(e,t,n,r,i,o,a,s,u){var l=Array.prototype.slice.call(arguments,3);try{t.apply(n,l);}catch(e){this.onError(e);}}var Ie=false,Oe=null,Ne=false,De=null,je={onError:function(e){Ie=true,Oe=e;}};function Be(e,t,n,r,i,o,a,s,u){Ie=false,Oe=null,Le.apply(je,arguments);}function ze(e){var t=e,n=e;if(e.alternate)for(;t.return;)t=t.return;else {e=t;do{0!=(4098&(t=e).flags)&&(n=t.return),e=t.return;}while(e)}return 3===t.tag?n:null}function Ue(e){if(13===e.tag){var t=e.memoizedState;if(null===t&&(null!==(e=e.alternate)&&(t=e.memoizedState)),null!==t)return t.dehydrated}return null}function Fe(e){if(ze(e)!==e)throw Error(n(188))}function Ke(e){return e=function(e){var t=e.alternate;if(!t){if(null===(t=ze(e)))throw Error(n(188));return t!==e?null:e}for(var r=e,i=t;;){var o=r.return;if(null===o)break;var a=o.alternate;if(null===a){if(null!==(i=o.return)){r=i;continue}break}if(o.child===a.child){for(a=o.child;a;){if(a===r)return Fe(o),e;if(a===i)return Fe(o),t;a=a.sibling;}throw Error(n(188))}if(r.return!==i.return)r=o,i=a;else {for(var s=false,u=o.child;u;){if(u===r){s=true,r=o,i=a;break}if(u===i){s=true,i=o,r=a;break}u=u.sibling;}if(!s){for(u=a.child;u;){if(u===r){s=true,r=a,i=o;break}if(u===i){s=true,i=a,r=o;break}u=u.sibling;}if(!s)throw Error(n(189))}}if(r.alternate!==i)throw Error(n(190))}if(3!==r.tag)throw Error(n(188));return r.stateNode.current===r?e:t}(e),null!==e?qe(e):null}function qe(e){if(5===e.tag||6===e.tag)return e;for(e=e.child;null!==e;){var t=qe(e);if(null!==t)return t;e=e.sibling;}return null}var He=t.unstable_scheduleCallback,We=t.unstable_cancelCallback,$e=t.unstable_shouldYield,Ve=t.unstable_requestPaint,Ye=t.unstable_now,Ge=t.unstable_getCurrentPriorityLevel,Ze=t.unstable_ImmediatePriority,Qe=t.unstable_UserBlockingPriority,Je=t.unstable_NormalPriority,Xe=t.unstable_LowPriority,et=t.unstable_IdlePriority,tt=null,nt=null;var rt=Math.clz32?Math.clz32:function(e){return e>>>=0,0===e?32:31-(it(e)/ot|0)|0},it=Math.log,ot=Math.LN2;var at=64,st=4194304;function ut(e){switch(e&-e){case 1:return 1;case 2:return 2;case 4:return 4;case 8:return 8;case 16:return 16;case 32:return 32;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return 4194240&e;case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:return 130023424&e;case 134217728:return 134217728;case 268435456:return 268435456;case 536870912:return 536870912;case 1073741824:return 1073741824;default:return e}}function lt(e,t){var n=e.pendingLanes;if(0===n)return 0;var r=0,i=e.suspendedLanes,o=e.pingedLanes,a=268435455&n;if(0!==a){var s=a&~i;0!==s?r=ut(s):0!==(o&=a)&&(r=ut(o));}else 0!==(a=n&~i)?r=ut(a):0!==o&&(r=ut(o));if(0===r)return 0;if(0!==t&&t!==r&&0==(t&i)&&((i=r&-r)>=(o=t&-t)||16===i&&0!=(4194240&o)))return t;if(0!=(4&r)&&(r|=16&n),0!==(t=e.entangledLanes))for(e=e.entanglements,t&=r;0<t;)i=1<<(n=31-rt(t)),r|=e[n],t&=~i;return r}function ct(e,t){switch(e){case 1:case 2:case 4:return t+250;case 8:case 16:case 32:case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:return t+5e3;default:return  -1}}function dt(e){return 0!==(e=-1073741825&e.pendingLanes)?e:1073741824&e?1073741824:0}function ft(){var e=at;return 0==(4194240&(at<<=1))&&(at=64),e}function ht(e){for(var t=[],n=0;31>n;n++)t.push(e);return t}function pt(e,t,n){e.pendingLanes|=t,536870912!==t&&(e.suspendedLanes=0,e.pingedLanes=0),(e=e.eventTimes)[t=31-rt(t)]=n;}function mt(e,t){var n=e.entangledLanes|=t;for(e=e.entanglements;n;){var r=31-rt(n),i=1<<r;i&t|e[r]&t&&(e[r]|=t),n&=~i;}}var gt=0;function vt(e){return 1<(e&=-e)?4<e?0!=(268435455&e)?16:536870912:4:1}var bt,yt,wt,_t,St,Et=false,kt=[],Mt=null,Ct=null,xt=null,At=new Map,Rt=new Map,Tt=[],Pt="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");function Lt(e,t){switch(e){case "focusin":case "focusout":Mt=null;break;case "dragenter":case "dragleave":Ct=null;break;case "mouseover":case "mouseout":xt=null;break;case "pointerover":case "pointerout":At.delete(t.pointerId);break;case "gotpointercapture":case "lostpointercapture":Rt.delete(t.pointerId);}}function It(e,t,n,r,i,o){return null===e||e.nativeEvent!==o?(e={blockedOn:t,domEventName:n,eventSystemFlags:r,nativeEvent:o,targetContainers:[i]},null!==t&&(null!==(t=gi(t))&&yt(t)),e):(e.eventSystemFlags|=r,t=e.targetContainers,null!==i&&-1===t.indexOf(i)&&t.push(i),e)}function Ot(e){var t=mi(e.target);if(null!==t){var n=ze(t);if(null!==n)if(13===(t=n.tag)){if(null!==(t=Ue(n)))return e.blockedOn=t,void St(e.priority,(function(){wt(n);}))}else if(3===t&&n.stateNode.current.memoizedState.isDehydrated)return void(e.blockedOn=3===n.tag?n.stateNode.containerInfo:null)}e.blockedOn=null;}function Nt(e){if(null!==e.blockedOn)return  false;for(var t=e.targetContainers;0<t.length;){var n=$t(e.domEventName,e.eventSystemFlags,t[0],e.nativeEvent);if(null!==n)return null!==(t=gi(n))&&yt(t),e.blockedOn=n,false;var r=new(n=e.nativeEvent).constructor(n.type,n);ve=r,n.target.dispatchEvent(r),ve=null,t.shift();}return  true}function Dt(e,t,n){Nt(e)&&n.delete(t);}function jt(){Et=false,null!==Mt&&Nt(Mt)&&(Mt=null),null!==Ct&&Nt(Ct)&&(Ct=null),null!==xt&&Nt(xt)&&(xt=null),At.forEach(Dt),Rt.forEach(Dt);}function Bt(e,n){e.blockedOn===n&&(e.blockedOn=null,Et||(Et=true,t.unstable_scheduleCallback(t.unstable_NormalPriority,jt)));}function zt(e){function t(t){return Bt(t,e)}if(0<kt.length){Bt(kt[0],e);for(var n=1;n<kt.length;n++){var r=kt[n];r.blockedOn===e&&(r.blockedOn=null);}}for(null!==Mt&&Bt(Mt,e),null!==Ct&&Bt(Ct,e),null!==xt&&Bt(xt,e),At.forEach(t),Rt.forEach(t),n=0;n<Tt.length;n++)(r=Tt[n]).blockedOn===e&&(r.blockedOn=null);for(;0<Tt.length&&null===(n=Tt[0]).blockedOn;)Ot(n),null===n.blockedOn&&Tt.shift();}var Ut=v.ReactCurrentBatchConfig,Ft=true;function Kt(e,t,n,r){var i=gt,o=Ut.transition;Ut.transition=null;try{gt=1,Ht(e,t,n,r);}finally{gt=i,Ut.transition=o;}}function qt(e,t,n,r){var i=gt,o=Ut.transition;Ut.transition=null;try{gt=4,Ht(e,t,n,r);}finally{gt=i,Ut.transition=o;}}function Ht(e,t,n,r){if(Ft){var i=$t(e,t,n,r);if(null===i)Fr(e,t,r,Wt,n),Lt(e,r);else if(function(e,t,n,r,i){switch(t){case "focusin":return Mt=It(Mt,e,t,n,r,i),true;case "dragenter":return Ct=It(Ct,e,t,n,r,i),true;case "mouseover":return xt=It(xt,e,t,n,r,i),true;case "pointerover":var o=i.pointerId;return At.set(o,It(At.get(o)||null,e,t,n,r,i)),true;case "gotpointercapture":return o=i.pointerId,Rt.set(o,It(Rt.get(o)||null,e,t,n,r,i)),true}return  false}(i,e,t,n,r))r.stopPropagation();else if(Lt(e,r),4&t&&-1<Pt.indexOf(e)){for(;null!==i;){var o=gi(i);if(null!==o&&bt(o),null===(o=$t(e,t,n,r))&&Fr(e,t,r,Wt,n),o===i)break;i=o;}null!==i&&r.stopPropagation();}else Fr(e,t,r,null,n);}}var Wt=null;function $t(e,t,n,r){if(Wt=null,null!==(e=mi(e=be(r))))if(null===(t=ze(e)))e=null;else if(13===(n=t.tag)){if(null!==(e=Ue(t)))return e;e=null;}else if(3===n){if(t.stateNode.current.memoizedState.isDehydrated)return 3===t.tag?t.stateNode.containerInfo:null;e=null;}else t!==e&&(e=null);return Wt=e,null}function Vt(e){switch(e){case "cancel":case "click":case "close":case "contextmenu":case "copy":case "cut":case "auxclick":case "dblclick":case "dragend":case "dragstart":case "drop":case "focusin":case "focusout":case "input":case "invalid":case "keydown":case "keypress":case "keyup":case "mousedown":case "mouseup":case "paste":case "pause":case "play":case "pointercancel":case "pointerdown":case "pointerup":case "ratechange":case "reset":case "resize":case "seeked":case "submit":case "touchcancel":case "touchend":case "touchstart":case "volumechange":case "change":case "selectionchange":case "textInput":case "compositionstart":case "compositionend":case "compositionupdate":case "beforeblur":case "afterblur":case "beforeinput":case "blur":case "fullscreenchange":case "focus":case "hashchange":case "popstate":case "select":case "selectstart":return 1;case "drag":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "mousemove":case "mouseout":case "mouseover":case "pointermove":case "pointerout":case "pointerover":case "scroll":case "toggle":case "touchmove":case "wheel":case "mouseenter":case "mouseleave":case "pointerenter":case "pointerleave":return 4;case "message":switch(Ge()){case Ze:return 1;case Qe:return 4;case Je:case Xe:return 16;case et:return 536870912;default:return 16}default:return 16}}var Yt=null,Gt=null,Zt=null;function Qt(){if(Zt)return Zt;var e,t,n=Gt,r=n.length,i="value"in Yt?Yt.value:Yt.textContent,o=i.length;for(e=0;e<r&&n[e]===i[e];e++);var a=r-e;for(t=1;t<=a&&n[r-t]===i[o-t];t++);return Zt=i.slice(e,1<t?1-t:void 0)}function Jt(e){var t=e.keyCode;return "charCode"in e?0===(e=e.charCode)&&13===t&&(e=13):e=t,10===e&&(e=13),32<=e||13===e?e:0}function Xt(){return  true}function en(){return  false}function tn(e){function t(t,n,r,i,o){for(var a in this._reactName=t,this._targetInst=r,this.type=n,this.nativeEvent=i,this.target=o,this.currentTarget=null,e)e.hasOwnProperty(a)&&(t=e[a],this[a]=t?t(i):i[a]);return this.isDefaultPrevented=(null!=i.defaultPrevented?i.defaultPrevented:false===i.returnValue)?Xt:en,this.isPropagationStopped=en,this}return O(t.prototype,{preventDefault:function(){this.defaultPrevented=true;var e=this.nativeEvent;e&&(e.preventDefault?e.preventDefault():"unknown"!=typeof e.returnValue&&(e.returnValue=false),this.isDefaultPrevented=Xt);},stopPropagation:function(){var e=this.nativeEvent;e&&(e.stopPropagation?e.stopPropagation():"unknown"!=typeof e.cancelBubble&&(e.cancelBubble=true),this.isPropagationStopped=Xt);},persist:function(){},isPersistent:Xt}),t}var nn,rn,on,an={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(e){return e.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},sn=tn(an),un=O({},an,{view:0,detail:0}),ln=tn(un),cn=O({},un,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:Sn,button:0,buttons:0,relatedTarget:function(e){return void 0===e.relatedTarget?e.fromElement===e.srcElement?e.toElement:e.fromElement:e.relatedTarget},movementX:function(e){return "movementX"in e?e.movementX:(e!==on&&(on&&"mousemove"===e.type?(nn=e.screenX-on.screenX,rn=e.screenY-on.screenY):rn=nn=0,on=e),nn)},movementY:function(e){return "movementY"in e?e.movementY:rn}}),dn=tn(cn),fn=tn(O({},cn,{dataTransfer:0})),hn=tn(O({},un,{relatedTarget:0})),pn=tn(O({},an,{animationName:0,elapsedTime:0,pseudoElement:0})),mn=O({},an,{clipboardData:function(e){return "clipboardData"in e?e.clipboardData:window.clipboardData}}),gn=tn(mn),vn=tn(O({},an,{data:0})),bn={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},yn={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},wn={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function _n(e){var t=this.nativeEvent;return t.getModifierState?t.getModifierState(e):!!(e=wn[e])&&!!t[e]}function Sn(){return _n}var En=O({},un,{key:function(e){if(e.key){var t=bn[e.key]||e.key;if("Unidentified"!==t)return t}return "keypress"===e.type?13===(e=Jt(e))?"Enter":String.fromCharCode(e):"keydown"===e.type||"keyup"===e.type?yn[e.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:Sn,charCode:function(e){return "keypress"===e.type?Jt(e):0},keyCode:function(e){return "keydown"===e.type||"keyup"===e.type?e.keyCode:0},which:function(e){return "keypress"===e.type?Jt(e):"keydown"===e.type||"keyup"===e.type?e.keyCode:0}}),kn=tn(En),Mn=tn(O({},cn,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0})),Cn=tn(O({},un,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:Sn})),xn=tn(O({},an,{propertyName:0,elapsedTime:0,pseudoElement:0})),An=O({},cn,{deltaX:function(e){return "deltaX"in e?e.deltaX:"wheelDeltaX"in e?-e.wheelDeltaX:0},deltaY:function(e){return "deltaY"in e?e.deltaY:"wheelDeltaY"in e?-e.wheelDeltaY:"wheelDelta"in e?-e.wheelDelta:0},deltaZ:0,deltaMode:0}),Rn=tn(An),Tn=[9,13,27,32],Pn=s&&"CompositionEvent"in window,Ln=null;s&&"documentMode"in document&&(Ln=document.documentMode);var In=s&&"TextEvent"in window&&!Ln,On=s&&(!Pn||Ln&&8<Ln&&11>=Ln),Nn=String.fromCharCode(32),Dn=false;function jn(e,t){switch(e){case "keyup":return  -1!==Tn.indexOf(t.keyCode);case "keydown":return 229!==t.keyCode;case "keypress":case "mousedown":case "focusout":return  true;default:return  false}}function Bn(e){return "object"==typeof(e=e.detail)&&"data"in e?e.data:null}var zn=false;var Un={color:true,date:true,datetime:true,"datetime-local":true,email:true,month:true,number:true,password:true,range:true,search:true,tel:true,text:true,time:true,url:true,week:true};function Fn(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return "input"===t?!!Un[e.type]:"textarea"===t}function Kn(e,t,n,r){Ee(r),0<(t=qr(t,"onChange")).length&&(n=new sn("onChange","change",null,n,r),e.push({event:n,listeners:t}));}var qn=null,Hn=null;function Wn(e){Nr(e,0);}function $n(e){if(H(vi(e)))return e}function Vn(e,t){if("change"===e)return t}var Yn=false;if(s){var Gn;if(s){var Zn="oninput"in document;if(!Zn){var Qn=document.createElement("div");Qn.setAttribute("oninput","return;"),Zn="function"==typeof Qn.oninput;}Gn=Zn;}else Gn=false;Yn=Gn&&(!document.documentMode||9<document.documentMode);}function Jn(){qn&&(qn.detachEvent("onpropertychange",Xn),Hn=qn=null);}function Xn(e){if("value"===e.propertyName&&$n(Hn)){var t=[];Kn(t,Hn,e,be(e)),Ae(Wn,t);}}function er(e,t,n){"focusin"===e?(Jn(),Hn=n,(qn=t).attachEvent("onpropertychange",Xn)):"focusout"===e&&Jn();}function tr(e){if("selectionchange"===e||"keyup"===e||"keydown"===e)return $n(Hn)}function nr(e,t){if("click"===e)return $n(t)}function rr(e,t){if("input"===e||"change"===e)return $n(t)}var ir="function"==typeof Object.is?Object.is:function(e,t){return e===t&&(0!==e||1/e==1/t)||e!=e&&t!=t};function or(e,t){if(ir(e,t))return  true;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return  false;var n=Object.keys(e),r=Object.keys(t);if(n.length!==r.length)return  false;for(r=0;r<n.length;r++){var i=n[r];if(!u.call(t,i)||!ir(e[i],t[i]))return  false}return  true}function ar(e){for(;e&&e.firstChild;)e=e.firstChild;return e}function sr(e,t){var n,r=ar(e);for(e=0;r;){if(3===r.nodeType){if(n=e+r.textContent.length,e<=t&&n>=t)return {node:r,offset:t-e};e=n;}e:{for(;r;){if(r.nextSibling){r=r.nextSibling;break e}r=r.parentNode;}r=void 0;}r=ar(r);}}function ur(e,t){return !(!e||!t)&&(e===t||(!e||3!==e.nodeType)&&(t&&3===t.nodeType?ur(e,t.parentNode):"contains"in e?e.contains(t):!!e.compareDocumentPosition&&!!(16&e.compareDocumentPosition(t))))}function lr(){for(var e=window,t=W();t instanceof e.HTMLIFrameElement;){try{var n="string"==typeof t.contentWindow.location.href;}catch(e){n=false;}if(!n)break;t=W((e=t.contentWindow).document);}return t}function cr(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return t&&("input"===t&&("text"===e.type||"search"===e.type||"tel"===e.type||"url"===e.type||"password"===e.type)||"textarea"===t||"true"===e.contentEditable)}function dr(e){var t=lr(),n=e.focusedElem,r=e.selectionRange;if(t!==n&&n&&n.ownerDocument&&ur(n.ownerDocument.documentElement,n)){if(null!==r&&cr(n))if(t=r.start,void 0===(e=r.end)&&(e=t),"selectionStart"in n)n.selectionStart=t,n.selectionEnd=Math.min(e,n.value.length);else if((e=(t=n.ownerDocument||document)&&t.defaultView||window).getSelection){e=e.getSelection();var i=n.textContent.length,o=Math.min(r.start,i);r=void 0===r.end?o:Math.min(r.end,i),!e.extend&&o>r&&(i=r,r=o,o=i),i=sr(n,o);var a=sr(n,r);i&&a&&(1!==e.rangeCount||e.anchorNode!==i.node||e.anchorOffset!==i.offset||e.focusNode!==a.node||e.focusOffset!==a.offset)&&((t=t.createRange()).setStart(i.node,i.offset),e.removeAllRanges(),o>r?(e.addRange(t),e.extend(a.node,a.offset)):(t.setEnd(a.node,a.offset),e.addRange(t)));}for(t=[],e=n;e=e.parentNode;)1===e.nodeType&&t.push({element:e,left:e.scrollLeft,top:e.scrollTop});for("function"==typeof n.focus&&n.focus(),n=0;n<t.length;n++)(e=t[n]).element.scrollLeft=e.left,e.element.scrollTop=e.top;}}var fr=s&&"documentMode"in document&&11>=document.documentMode,hr=null,pr=null,mr=null,gr=false;function vr(e,t,n){var r=n.window===n?n.document:9===n.nodeType?n:n.ownerDocument;gr||null==hr||hr!==W(r)||("selectionStart"in(r=hr)&&cr(r)?r={start:r.selectionStart,end:r.selectionEnd}:r={anchorNode:(r=(r.ownerDocument&&r.ownerDocument.defaultView||window).getSelection()).anchorNode,anchorOffset:r.anchorOffset,focusNode:r.focusNode,focusOffset:r.focusOffset},mr&&or(mr,r)||(mr=r,0<(r=qr(pr,"onSelect")).length&&(t=new sn("onSelect","select",null,t,n),e.push({event:t,listeners:r}),t.target=hr)));}function br(e,t){var n={};return n[e.toLowerCase()]=t.toLowerCase(),n["Webkit"+e]="webkit"+t,n["Moz"+e]="moz"+t,n}var yr={animationend:br("Animation","AnimationEnd"),animationiteration:br("Animation","AnimationIteration"),animationstart:br("Animation","AnimationStart"),transitionend:br("Transition","TransitionEnd")},wr={},_r={};function Sr(e){if(wr[e])return wr[e];if(!yr[e])return e;var t,n=yr[e];for(t in n)if(n.hasOwnProperty(t)&&t in _r)return wr[e]=n[t];return e}s&&(_r=document.createElement("div").style,"AnimationEvent"in window||(delete yr.animationend.animation,delete yr.animationiteration.animation,delete yr.animationstart.animation),"TransitionEvent"in window||delete yr.transitionend.transition);var Er=Sr("animationend"),kr=Sr("animationiteration"),Mr=Sr("animationstart"),Cr=Sr("transitionend"),xr=new Map,Ar="abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");function Rr(e,t){xr.set(e,t),o(t,[e]);}for(var Tr=0;Tr<Ar.length;Tr++){var Pr=Ar[Tr];Rr(Pr.toLowerCase(),"on"+(Pr[0].toUpperCase()+Pr.slice(1)));}Rr(Er,"onAnimationEnd"),Rr(kr,"onAnimationIteration"),Rr(Mr,"onAnimationStart"),Rr("dblclick","onDoubleClick"),Rr("focusin","onFocus"),Rr("focusout","onBlur"),Rr(Cr,"onTransitionEnd"),a("onMouseEnter",["mouseout","mouseover"]),a("onMouseLeave",["mouseout","mouseover"]),a("onPointerEnter",["pointerout","pointerover"]),a("onPointerLeave",["pointerout","pointerover"]),o("onChange","change click focusin focusout input keydown keyup selectionchange".split(" ")),o("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")),o("onBeforeInput",["compositionend","keypress","textInput","paste"]),o("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" ")),o("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" ")),o("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var Lr="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Ir=new Set("cancel close invalid load scroll toggle".split(" ").concat(Lr));function Or(e,t,r){var i=e.type||"unknown-event";e.currentTarget=r,function(e,t,r,i,o,a,s,u,l){if(Be.apply(this,arguments),Ie){if(!Ie)throw Error(n(198));var c=Oe;Ie=false,Oe=null,Ne||(Ne=true,De=c);}}(i,t,void 0,e),e.currentTarget=null;}function Nr(e,t){t=0!=(4&t);for(var n=0;n<e.length;n++){var r=e[n],i=r.event;r=r.listeners;e:{var o=void 0;if(t)for(var a=r.length-1;0<=a;a--){var s=r[a],u=s.instance,l=s.currentTarget;if(s=s.listener,u!==o&&i.isPropagationStopped())break e;Or(i,s,l),o=u;}else for(a=0;a<r.length;a++){if(u=(s=r[a]).instance,l=s.currentTarget,s=s.listener,u!==o&&i.isPropagationStopped())break e;Or(i,s,l),o=u;}}}if(Ne)throw e=De,Ne=false,De=null,e}function Dr(e,t){var n=t[fi];void 0===n&&(n=t[fi]=new Set);var r=e+"__bubble";n.has(r)||(Ur(t,e,2,false),n.add(r));}function jr(e,t,n){var r=0;t&&(r|=4),Ur(n,e,r,t);}var Br="_reactListening"+Math.random().toString(36).slice(2);function zr(e){if(!e[Br]){e[Br]=true,r.forEach((function(t){"selectionchange"!==t&&(Ir.has(t)||jr(t,false,e),jr(t,true,e));}));var t=9===e.nodeType?e:e.ownerDocument;null===t||t[Br]||(t[Br]=true,jr("selectionchange",false,t));}}function Ur(e,t,n,r){switch(Vt(t)){case 1:var i=Kt;break;case 4:i=qt;break;default:i=Ht;}n=i.bind(null,t,n,e),i=void 0,!Te||"touchstart"!==t&&"touchmove"!==t&&"wheel"!==t||(i=true),r?void 0!==i?e.addEventListener(t,n,{capture:true,passive:i}):e.addEventListener(t,n,true):void 0!==i?e.addEventListener(t,n,{passive:i}):e.addEventListener(t,n,false);}function Fr(e,t,n,r,i){var o=r;if(0==(1&t)&&0==(2&t)&&null!==r)e:for(;;){if(null===r)return;var a=r.tag;if(3===a||4===a){var s=r.stateNode.containerInfo;if(s===i||8===s.nodeType&&s.parentNode===i)break;if(4===a)for(a=r.return;null!==a;){var u=a.tag;if((3===u||4===u)&&((u=a.stateNode.containerInfo)===i||8===u.nodeType&&u.parentNode===i))return;a=a.return;}for(;null!==s;){if(null===(a=mi(s)))return;if(5===(u=a.tag)||6===u){r=o=a;continue e}s=s.parentNode;}}r=r.return;}Ae((function(){var r=o,i=be(n),a=[];e:{var s=xr.get(e);if(void 0!==s){var u=sn,l=e;switch(e){case "keypress":if(0===Jt(n))break e;case "keydown":case "keyup":u=kn;break;case "focusin":l="focus",u=hn;break;case "focusout":l="blur",u=hn;break;case "beforeblur":case "afterblur":u=hn;break;case "click":if(2===n.button)break e;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":u=dn;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":u=fn;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":u=Cn;break;case Er:case kr:case Mr:u=pn;break;case Cr:u=xn;break;case "scroll":u=ln;break;case "wheel":u=Rn;break;case "copy":case "cut":case "paste":u=gn;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":u=Mn;}var c=0!=(4&t),d=!c&&"scroll"===e,f=c?null!==s?s+"Capture":null:s;c=[];for(var h,p=r;null!==p;){var m=(h=p).stateNode;if(5===h.tag&&null!==m&&(h=m,null!==f&&(null!=(m=Re(p,f))&&c.push(Kr(p,m,h)))),d)break;p=p.return;}0<c.length&&(s=new u(s,l,null,n,i),a.push({event:s,listeners:c}));}}if(0==(7&t)){if(u="mouseout"===e||"pointerout"===e,(!(s="mouseover"===e||"pointerover"===e)||n===ve||!(l=n.relatedTarget||n.fromElement)||!mi(l)&&!l[di])&&(u||s)&&(s=i.window===i?i:(s=i.ownerDocument)?s.defaultView||s.parentWindow:window,u?(u=r,null!==(l=(l=n.relatedTarget||n.toElement)?mi(l):null)&&(l!==(d=ze(l))||5!==l.tag&&6!==l.tag)&&(l=null)):(u=null,l=r),u!==l)){if(c=dn,m="onMouseLeave",f="onMouseEnter",p="mouse","pointerout"!==e&&"pointerover"!==e||(c=Mn,m="onPointerLeave",f="onPointerEnter",p="pointer"),d=null==u?s:vi(u),h=null==l?s:vi(l),(s=new c(m,p+"leave",u,n,i)).target=d,s.relatedTarget=h,m=null,mi(i)===r&&((c=new c(f,p+"enter",l,n,i)).target=h,c.relatedTarget=d,m=c),d=m,u&&l)e:{for(f=l,p=0,h=c=u;h;h=Hr(h))p++;for(h=0,m=f;m;m=Hr(m))h++;for(;0<p-h;)c=Hr(c),p--;for(;0<h-p;)f=Hr(f),h--;for(;p--;){if(c===f||null!==f&&c===f.alternate)break e;c=Hr(c),f=Hr(f);}c=null;}else c=null;null!==u&&Wr(a,s,u,c,false),null!==l&&null!==d&&Wr(a,d,l,c,true);}if("select"===(u=(s=r?vi(r):window).nodeName&&s.nodeName.toLowerCase())||"input"===u&&"file"===s.type)var g=Vn;else if(Fn(s))if(Yn)g=rr;else {g=tr;var v=er;}else (u=s.nodeName)&&"input"===u.toLowerCase()&&("checkbox"===s.type||"radio"===s.type)&&(g=nr);switch(g&&(g=g(e,r))?Kn(a,g,n,i):(v&&v(e,s,r),"focusout"===e&&(v=s._wrapperState)&&v.controlled&&"number"===s.type&&Q(s,"number",s.value)),v=r?vi(r):window,e){case "focusin":(Fn(v)||"true"===v.contentEditable)&&(hr=v,pr=r,mr=null);break;case "focusout":mr=pr=hr=null;break;case "mousedown":gr=true;break;case "contextmenu":case "mouseup":case "dragend":gr=false,vr(a,n,i);break;case "selectionchange":if(fr)break;case "keydown":case "keyup":vr(a,n,i);}var b;if(Pn)e:{switch(e){case "compositionstart":var y="onCompositionStart";break e;case "compositionend":y="onCompositionEnd";break e;case "compositionupdate":y="onCompositionUpdate";break e}y=void 0;}else zn?jn(e,n)&&(y="onCompositionEnd"):"keydown"===e&&229===n.keyCode&&(y="onCompositionStart");y&&(On&&"ko"!==n.locale&&(zn||"onCompositionStart"!==y?"onCompositionEnd"===y&&zn&&(b=Qt()):(Gt="value"in(Yt=i)?Yt.value:Yt.textContent,zn=true)),0<(v=qr(r,y)).length&&(y=new vn(y,e,null,n,i),a.push({event:y,listeners:v}),b?y.data=b:null!==(b=Bn(n))&&(y.data=b))),(b=In?function(e,t){switch(e){case "compositionend":return Bn(t);case "keypress":return 32!==t.which?null:(Dn=true,Nn);case "textInput":return (e=t.data)===Nn&&Dn?null:e;default:return null}}(e,n):function(e,t){if(zn)return "compositionend"===e||!Pn&&jn(e,t)?(e=Qt(),Zt=Gt=Yt=null,zn=false,e):null;switch(e){case "paste":default:return null;case "keypress":if(!(t.ctrlKey||t.altKey||t.metaKey)||t.ctrlKey&&t.altKey){if(t.char&&1<t.char.length)return t.char;if(t.which)return String.fromCharCode(t.which)}return null;case "compositionend":return On&&"ko"!==t.locale?null:t.data}}(e,n))&&(0<(r=qr(r,"onBeforeInput")).length&&(i=new vn("onBeforeInput","beforeinput",null,n,i),a.push({event:i,listeners:r}),i.data=b));}Nr(a,t);}));}function Kr(e,t,n){return {instance:e,listener:t,currentTarget:n}}function qr(e,t){for(var n=t+"Capture",r=[];null!==e;){var i=e,o=i.stateNode;5===i.tag&&null!==o&&(i=o,null!=(o=Re(e,n))&&r.unshift(Kr(e,o,i)),null!=(o=Re(e,t))&&r.push(Kr(e,o,i))),e=e.return;}return r}function Hr(e){if(null===e)return null;do{e=e.return;}while(e&&5!==e.tag);return e||null}function Wr(e,t,n,r,i){for(var o=t._reactName,a=[];null!==n&&n!==r;){var s=n,u=s.alternate,l=s.stateNode;if(null!==u&&u===r)break;5===s.tag&&null!==l&&(s=l,i?null!=(u=Re(n,o))&&a.unshift(Kr(n,u,s)):i||null!=(u=Re(n,o))&&a.push(Kr(n,u,s))),n=n.return;}0!==a.length&&e.push({event:t,listeners:a});}var $r=/\r\n?/g,Vr=/\u0000|\uFFFD/g;function Yr(e){return ("string"==typeof e?e:""+e).replace($r,"\n").replace(Vr,"")}function Gr(e,t,r){if(t=Yr(t),Yr(e)!==t&&r)throw Error(n(425))}function Zr(){}var Qr=null,Jr=null;function Xr(e,t){return "textarea"===e||"noscript"===e||"string"==typeof t.children||"number"==typeof t.children||"object"==typeof t.dangerouslySetInnerHTML&&null!==t.dangerouslySetInnerHTML&&null!=t.dangerouslySetInnerHTML.__html}var ei="function"==typeof setTimeout?setTimeout:void 0,ti="function"==typeof clearTimeout?clearTimeout:void 0,ni="function"==typeof Promise?Promise:void 0,ri="function"==typeof queueMicrotask?queueMicrotask:void 0!==ni?function(e){return ni.resolve(null).then(e).catch(ii)}:ei;function ii(e){setTimeout((function(){throw e}));}function oi(e,t){var n=t,r=0;do{var i=n.nextSibling;if(e.removeChild(n),i&&8===i.nodeType)if("/$"===(n=i.data)){if(0===r)return e.removeChild(i),void zt(t);r--;}else "$"!==n&&"$?"!==n&&"$!"!==n||r++;n=i;}while(n);zt(t);}function ai(e){for(;null!=e;e=e.nextSibling){var t=e.nodeType;if(1===t||3===t)break;if(8===t){if("$"===(t=e.data)||"$!"===t||"$?"===t)break;if("/$"===t)return null}}return e}function si(e){e=e.previousSibling;for(var t=0;e;){if(8===e.nodeType){var n=e.data;if("$"===n||"$!"===n||"$?"===n){if(0===t)return e;t--;}else "/$"===n&&t++;}e=e.previousSibling;}return null}var ui=Math.random().toString(36).slice(2),li="__reactFiber$"+ui,ci="__reactProps$"+ui,di="__reactContainer$"+ui,fi="__reactEvents$"+ui,hi="__reactListeners$"+ui,pi="__reactHandles$"+ui;function mi(e){var t=e[li];if(t)return t;for(var n=e.parentNode;n;){if(t=n[di]||n[li]){if(n=t.alternate,null!==t.child||null!==n&&null!==n.child)for(e=si(e);null!==e;){if(n=e[li])return n;e=si(e);}return t}n=(e=n).parentNode;}return null}function gi(e){return !(e=e[li]||e[di])||5!==e.tag&&6!==e.tag&&13!==e.tag&&3!==e.tag?null:e}function vi(e){if(5===e.tag||6===e.tag)return e.stateNode;throw Error(n(33))}function bi(e){return e[ci]||null}var yi=[],wi=-1;function _i(e){return {current:e}}function Si(e){0>wi||(e.current=yi[wi],yi[wi]=null,wi--);}function Ei(e,t){wi++,yi[wi]=e.current,e.current=t;}var ki={},Mi=_i(ki),Ci=_i(false),xi=ki;function Ai(e,t){var n=e.type.contextTypes;if(!n)return ki;var r=e.stateNode;if(r&&r.__reactInternalMemoizedUnmaskedChildContext===t)return r.__reactInternalMemoizedMaskedChildContext;var i,o={};for(i in n)o[i]=t[i];return r&&((e=e.stateNode).__reactInternalMemoizedUnmaskedChildContext=t,e.__reactInternalMemoizedMaskedChildContext=o),o}function Ri(e){return null!=(e=e.childContextTypes)}function Ti(){Si(Ci),Si(Mi);}function Pi(e,t,r){if(Mi.current!==ki)throw Error(n(168));Ei(Mi,t),Ei(Ci,r);}function Li(e,t,r){var i=e.stateNode;if(t=t.childContextTypes,"function"!=typeof i.getChildContext)return r;for(var o in i=i.getChildContext())if(!(o in t))throw Error(n(108,U(e)||"Unknown",o));return O({},r,i)}function Ii(e){return e=(e=e.stateNode)&&e.__reactInternalMemoizedMergedChildContext||ki,xi=Mi.current,Ei(Mi,e),Ei(Ci,Ci.current),true}function Oi(e,t,r){var i=e.stateNode;if(!i)throw Error(n(169));r?(e=Li(e,t,xi),i.__reactInternalMemoizedMergedChildContext=e,Si(Ci),Si(Mi),Ei(Mi,e)):Si(Ci),Ei(Ci,r);}var Ni=null,Di=false,ji=false;function Bi(e){null===Ni?Ni=[e]:Ni.push(e);}function zi(){if(!ji&&null!==Ni){ji=true;var e=0,t=gt;try{var n=Ni;for(gt=1;e<n.length;e++){var r=n[e];do{r=r(!0);}while(null!==r)}Ni=null,Di=!1;}catch(t){throw null!==Ni&&(Ni=Ni.slice(e+1)),He(Ze,zi),t}finally{gt=t,ji=false;}}return null}var Ui=[],Fi=0,Ki=null,qi=0,Hi=[],Wi=0,$i=null,Vi=1,Yi="";function Gi(e,t){Ui[Fi++]=qi,Ui[Fi++]=Ki,Ki=e,qi=t;}function Zi(e,t,n){Hi[Wi++]=Vi,Hi[Wi++]=Yi,Hi[Wi++]=$i,$i=e;var r=Vi;e=Yi;var i=32-rt(r)-1;r&=~(1<<i),n+=1;var o=32-rt(t)+i;if(30<o){var a=i-i%5;o=(r&(1<<a)-1).toString(32),r>>=a,i-=a,Vi=1<<32-rt(t)+i|n<<i|r,Yi=o+e;}else Vi=1<<o|n<<i|r,Yi=e;}function Qi(e){null!==e.return&&(Gi(e,1),Zi(e,1,0));}function Ji(e){for(;e===Ki;)Ki=Ui[--Fi],Ui[Fi]=null,qi=Ui[--Fi],Ui[Fi]=null;for(;e===$i;)$i=Hi[--Wi],Hi[Wi]=null,Yi=Hi[--Wi],Hi[Wi]=null,Vi=Hi[--Wi],Hi[Wi]=null;}var Xi=null,eo=null,to=false,no=null;function ro(e,t){var n=Rl(5,null,null,0);n.elementType="DELETED",n.stateNode=t,n.return=e,null===(t=e.deletions)?(e.deletions=[n],e.flags|=16):t.push(n);}function io(e,t){switch(e.tag){case 5:var n=e.type;return null!==(t=1!==t.nodeType||n.toLowerCase()!==t.nodeName.toLowerCase()?null:t)&&(e.stateNode=t,Xi=e,eo=ai(t.firstChild),true);case 6:return null!==(t=""===e.pendingProps||3!==t.nodeType?null:t)&&(e.stateNode=t,Xi=e,eo=null,true);case 13:return null!==(t=8!==t.nodeType?null:t)&&(n=null!==$i?{id:Vi,overflow:Yi}:null,e.memoizedState={dehydrated:t,treeContext:n,retryLane:1073741824},(n=Rl(18,null,null,0)).stateNode=t,n.return=e,e.child=n,Xi=e,eo=null,true);default:return  false}}function oo(e){return 0!=(1&e.mode)&&0==(128&e.flags)}function ao(e){if(to){var t=eo;if(t){var r=t;if(!io(e,t)){if(oo(e))throw Error(n(418));t=ai(r.nextSibling);var i=Xi;t&&io(e,t)?ro(i,r):(e.flags=-4097&e.flags|2,to=false,Xi=e);}}else {if(oo(e))throw Error(n(418));e.flags=-4097&e.flags|2,to=false,Xi=e;}}}function so(e){for(e=e.return;null!==e&&5!==e.tag&&3!==e.tag&&13!==e.tag;)e=e.return;Xi=e;}function uo(e){if(e!==Xi)return  false;if(!to)return so(e),to=true,false;var t;if((t=3!==e.tag)&&!(t=5!==e.tag)&&(t="head"!==(t=e.type)&&"body"!==t&&!Xr(e.type,e.memoizedProps)),t&&(t=eo)){if(oo(e))throw lo(),Error(n(418));for(;t;)ro(e,t),t=ai(t.nextSibling);}if(so(e),13===e.tag){if(!(e=null!==(e=e.memoizedState)?e.dehydrated:null))throw Error(n(317));e:{for(e=e.nextSibling,t=0;e;){if(8===e.nodeType){var r=e.data;if("/$"===r){if(0===t){eo=ai(e.nextSibling);break e}t--;}else "$"!==r&&"$!"!==r&&"$?"!==r||t++;}e=e.nextSibling;}eo=null;}}else eo=Xi?ai(e.stateNode.nextSibling):null;return  true}function lo(){for(var e=eo;e;)e=ai(e.nextSibling);}function co(){eo=Xi=null,to=false;}function fo(e){null===no?no=[e]:no.push(e);}var ho=v.ReactCurrentBatchConfig;function po(e,t){if(e&&e.defaultProps){for(var n in t=O({},t),e=e.defaultProps) void 0===t[n]&&(t[n]=e[n]);return t}return t}var mo=_i(null),go=null,vo=null,bo=null;function yo(){bo=vo=go=null;}function wo(e){var t=mo.current;Si(mo),e._currentValue=t;}function _o(e,t,n){for(;null!==e;){var r=e.alternate;if((e.childLanes&t)!==t?(e.childLanes|=t,null!==r&&(r.childLanes|=t)):null!==r&&(r.childLanes&t)!==t&&(r.childLanes|=t),e===n)break;e=e.return;}}function So(e,t){go=e,bo=vo=null,null!==(e=e.dependencies)&&null!==e.firstContext&&(0!=(e.lanes&t)&&(vs=true),e.firstContext=null);}function Eo(e){var t=e._currentValue;if(bo!==e)if(e={context:e,memoizedValue:t,next:null},null===vo){if(null===go)throw Error(n(308));vo=e,go.dependencies={lanes:0,firstContext:e};}else vo=vo.next=e;return t}var ko=null;function Mo(e){null===ko?ko=[e]:ko.push(e);}function Co(e,t,n,r){var i=t.interleaved;return null===i?(n.next=n,Mo(t)):(n.next=i.next,i.next=n),t.interleaved=n,xo(e,r)}function xo(e,t){e.lanes|=t;var n=e.alternate;for(null!==n&&(n.lanes|=t),n=e,e=e.return;null!==e;)e.childLanes|=t,null!==(n=e.alternate)&&(n.childLanes|=t),n=e,e=e.return;return 3===n.tag?n.stateNode:null}var Ao=false;function Ro(e){e.updateQueue={baseState:e.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null,interleaved:null,lanes:0},effects:null};}function To(e,t){e=e.updateQueue,t.updateQueue===e&&(t.updateQueue={baseState:e.baseState,firstBaseUpdate:e.firstBaseUpdate,lastBaseUpdate:e.lastBaseUpdate,shared:e.shared,effects:e.effects});}function Po(e,t){return {eventTime:e,lane:t,tag:0,payload:null,callback:null,next:null}}function Lo(e,t,n){var r=e.updateQueue;if(null===r)return null;if(r=r.shared,0!=(2&Cu)){var i=r.pending;return null===i?t.next=t:(t.next=i.next,i.next=t),r.pending=t,xo(e,n)}return null===(i=r.interleaved)?(t.next=t,Mo(r)):(t.next=i.next,i.next=t),r.interleaved=t,xo(e,n)}function Io(e,t,n){if(null!==(t=t.updateQueue)&&(t=t.shared,0!=(4194240&n))){var r=t.lanes;n|=r&=e.pendingLanes,t.lanes=n,mt(e,n);}}function Oo(e,t){var n=e.updateQueue,r=e.alternate;if(null!==r&&n===(r=r.updateQueue)){var i=null,o=null;if(null!==(n=n.firstBaseUpdate)){do{var a={eventTime:n.eventTime,lane:n.lane,tag:n.tag,payload:n.payload,callback:n.callback,next:null};null===o?i=o=a:o=o.next=a,n=n.next;}while(null!==n);null===o?i=o=t:o=o.next=t;}else i=o=t;return n={baseState:r.baseState,firstBaseUpdate:i,lastBaseUpdate:o,shared:r.shared,effects:r.effects},void(e.updateQueue=n)}null===(e=n.lastBaseUpdate)?n.firstBaseUpdate=t:e.next=t,n.lastBaseUpdate=t;}function No(e,t,n,r){var i=e.updateQueue;Ao=false;var o=i.firstBaseUpdate,a=i.lastBaseUpdate,s=i.shared.pending;if(null!==s){i.shared.pending=null;var u=s,l=u.next;u.next=null,null===a?o=l:a.next=l,a=u;var c=e.alternate;null!==c&&((s=(c=c.updateQueue).lastBaseUpdate)!==a&&(null===s?c.firstBaseUpdate=l:s.next=l,c.lastBaseUpdate=u));}if(null!==o){var d=i.baseState;for(a=0,c=l=u=null,s=o;;){var f=s.lane,h=s.eventTime;if((r&f)===f){null!==c&&(c=c.next={eventTime:h,lane:0,tag:s.tag,payload:s.payload,callback:s.callback,next:null});e:{var p=e,m=s;switch(f=t,h=n,m.tag){case 1:if("function"==typeof(p=m.payload)){d=p.call(h,d,f);break e}d=p;break e;case 3:p.flags=-65537&p.flags|128;case 0:if(null==(f="function"==typeof(p=m.payload)?p.call(h,d,f):p))break e;d=O({},d,f);break e;case 2:Ao=true;}}null!==s.callback&&0!==s.lane&&(e.flags|=64,null===(f=i.effects)?i.effects=[s]:f.push(s));}else h={eventTime:h,lane:f,tag:s.tag,payload:s.payload,callback:s.callback,next:null},null===c?(l=c=h,u=d):c=c.next=h,a|=f;if(null===(s=s.next)){if(null===(s=i.shared.pending))break;s=(f=s).next,f.next=null,i.lastBaseUpdate=f,i.shared.pending=null;}}if(null===c&&(u=d),i.baseState=u,i.firstBaseUpdate=l,i.lastBaseUpdate=c,null!==(t=i.shared.interleaved)){i=t;do{a|=i.lane,i=i.next;}while(i!==t)}else null===o&&(i.shared.lanes=0);Ou|=a,e.lanes=a,e.memoizedState=d;}}function Do(e,t,r){if(e=t.effects,t.effects=null,null!==e)for(t=0;t<e.length;t++){var i=e[t],o=i.callback;if(null!==o){if(i.callback=null,i=r,"function"!=typeof o)throw Error(n(191,o));o.call(i);}}}var jo=(new e.Component).refs;function Bo(e,t,n,r){n=null==(n=n(r,t=e.memoizedState))?t:O({},t,n),e.memoizedState=n,0===e.lanes&&(e.updateQueue.baseState=n);}var zo={isMounted:function(e){return !!(e=e._reactInternals)&&ze(e)===e},enqueueSetState:function(e,t,n){e=e._reactInternals;var r=Ju(),i=Xu(e),o=Po(r,i);o.payload=t,null!=n&&(o.callback=n),null!==(t=Lo(e,o,i))&&(el(t,e,i,r),Io(t,e,i));},enqueueReplaceState:function(e,t,n){e=e._reactInternals;var r=Ju(),i=Xu(e),o=Po(r,i);o.tag=1,o.payload=t,null!=n&&(o.callback=n),null!==(t=Lo(e,o,i))&&(el(t,e,i,r),Io(t,e,i));},enqueueForceUpdate:function(e,t){e=e._reactInternals;var n=Ju(),r=Xu(e),i=Po(n,r);i.tag=2,null!=t&&(i.callback=t),null!==(t=Lo(e,i,r))&&(el(t,e,r,n),Io(t,e,r));}};function Uo(e,t,n,r,i,o,a){return "function"==typeof(e=e.stateNode).shouldComponentUpdate?e.shouldComponentUpdate(r,o,a):!t.prototype||!t.prototype.isPureReactComponent||(!or(n,r)||!or(i,o))}function Fo(e,t,n){var r=false,i=ki,o=t.contextType;return "object"==typeof o&&null!==o?o=Eo(o):(i=Ri(t)?xi:Mi.current,o=(r=null!=(r=t.contextTypes))?Ai(e,i):ki),t=new t(n,o),e.memoizedState=null!==t.state&&void 0!==t.state?t.state:null,t.updater=zo,e.stateNode=t,t._reactInternals=e,r&&((e=e.stateNode).__reactInternalMemoizedUnmaskedChildContext=i,e.__reactInternalMemoizedMaskedChildContext=o),t}function Ko(e,t,n,r){e=t.state,"function"==typeof t.componentWillReceiveProps&&t.componentWillReceiveProps(n,r),"function"==typeof t.UNSAFE_componentWillReceiveProps&&t.UNSAFE_componentWillReceiveProps(n,r),t.state!==e&&zo.enqueueReplaceState(t,t.state,null);}function qo(e,t,n,r){var i=e.stateNode;i.props=n,i.state=e.memoizedState,i.refs=jo,Ro(e);var o=t.contextType;"object"==typeof o&&null!==o?i.context=Eo(o):(o=Ri(t)?xi:Mi.current,i.context=Ai(e,o)),i.state=e.memoizedState,"function"==typeof(o=t.getDerivedStateFromProps)&&(Bo(e,t,o,n),i.state=e.memoizedState),"function"==typeof t.getDerivedStateFromProps||"function"==typeof i.getSnapshotBeforeUpdate||"function"!=typeof i.UNSAFE_componentWillMount&&"function"!=typeof i.componentWillMount||(t=i.state,"function"==typeof i.componentWillMount&&i.componentWillMount(),"function"==typeof i.UNSAFE_componentWillMount&&i.UNSAFE_componentWillMount(),t!==i.state&&zo.enqueueReplaceState(i,i.state,null),No(e,n,i,r),i.state=e.memoizedState),"function"==typeof i.componentDidMount&&(e.flags|=4194308);}function Ho(e,t,r){if(null!==(e=r.ref)&&"function"!=typeof e&&"object"!=typeof e){if(r._owner){if(r=r._owner){if(1!==r.tag)throw Error(n(309));var i=r.stateNode;}if(!i)throw Error(n(147,e));var o=i,a=""+e;return null!==t&&null!==t.ref&&"function"==typeof t.ref&&t.ref._stringRef===a?t.ref:(t=function(e){var t=o.refs;t===jo&&(t=o.refs={}),null===e?delete t[a]:t[a]=e;},t._stringRef=a,t)}if("string"!=typeof e)throw Error(n(284));if(!r._owner)throw Error(n(290,e))}return e}function Wo(e,t){throw e=Object.prototype.toString.call(t),Error(n(31,"[object Object]"===e?"object with keys {"+Object.keys(t).join(", ")+"}":e))}function $o(e){return (0, e._init)(e._payload)}function Vo(e){function t(t,n){if(e){var r=t.deletions;null===r?(t.deletions=[n],t.flags|=16):r.push(n);}}function r(n,r){if(!e)return null;for(;null!==r;)t(n,r),r=r.sibling;return null}function i(e,t){for(e=new Map;null!==t;)null!==t.key?e.set(t.key,t):e.set(t.index,t),t=t.sibling;return e}function o(e,t){return (e=Pl(e,t)).index=0,e.sibling=null,e}function a(t,n,r){return t.index=r,e?null!==(r=t.alternate)?(r=r.index)<n?(t.flags|=2,n):r:(t.flags|=2,n):(t.flags|=1048576,n)}function s(t){return e&&null===t.alternate&&(t.flags|=2),t}function u(e,t,n,r){return null===t||6!==t.tag?((t=Nl(n,e.mode,r)).return=e,t):((t=o(t,n)).return=e,t)}function l(e,t,n,r){var i=n.type;return i===w?d(e,t,n.props.children,r,n.key):null!==t&&(t.elementType===i||"object"==typeof i&&null!==i&&i.$$typeof===R&&$o(i)===t.type)?((r=o(t,n.props)).ref=Ho(e,t,n),r.return=e,r):((r=Ll(n.type,n.key,n.props,null,e.mode,r)).ref=Ho(e,t,n),r.return=e,r)}function c(e,t,n,r){return null===t||4!==t.tag||t.stateNode.containerInfo!==n.containerInfo||t.stateNode.implementation!==n.implementation?((t=Dl(n,e.mode,r)).return=e,t):((t=o(t,n.children||[])).return=e,t)}function d(e,t,n,r,i){return null===t||7!==t.tag?((t=Il(n,e.mode,r,i)).return=e,t):((t=o(t,n)).return=e,t)}function f(e,t,n){if("string"==typeof t&&""!==t||"number"==typeof t)return (t=Nl(""+t,e.mode,n)).return=e,t;if("object"==typeof t&&null!==t){switch(t.$$typeof){case b:return (n=Ll(t.type,t.key,t.props,null,e.mode,n)).ref=Ho(e,null,t),n.return=e,n;case y:return (t=Dl(t,e.mode,n)).return=e,t;case R:return f(e,(0, t._init)(t._payload),n)}if(J(t)||L(t))return (t=Il(t,e.mode,n,null)).return=e,t;Wo(e,t);}return null}function h(e,t,n,r){var i=null!==t?t.key:null;if("string"==typeof n&&""!==n||"number"==typeof n)return null!==i?null:u(e,t,""+n,r);if("object"==typeof n&&null!==n){switch(n.$$typeof){case b:return n.key===i?l(e,t,n,r):null;case y:return n.key===i?c(e,t,n,r):null;case R:return h(e,t,(i=n._init)(n._payload),r)}if(J(n)||L(n))return null!==i?null:d(e,t,n,r,null);Wo(e,n);}return null}function p(e,t,n,r,i){if("string"==typeof r&&""!==r||"number"==typeof r)return u(t,e=e.get(n)||null,""+r,i);if("object"==typeof r&&null!==r){switch(r.$$typeof){case b:return l(t,e=e.get(null===r.key?n:r.key)||null,r,i);case y:return c(t,e=e.get(null===r.key?n:r.key)||null,r,i);case R:return p(e,t,n,(0, r._init)(r._payload),i)}if(J(r)||L(r))return d(t,e=e.get(n)||null,r,i,null);Wo(t,r);}return null}function m(n,o,s,u){for(var l=null,c=null,d=o,m=o=0,g=null;null!==d&&m<s.length;m++){d.index>m?(g=d,d=null):g=d.sibling;var v=h(n,d,s[m],u);if(null===v){null===d&&(d=g);break}e&&d&&null===v.alternate&&t(n,d),o=a(v,o,m),null===c?l=v:c.sibling=v,c=v,d=g;}if(m===s.length)return r(n,d),to&&Gi(n,m),l;if(null===d){for(;m<s.length;m++)null!==(d=f(n,s[m],u))&&(o=a(d,o,m),null===c?l=d:c.sibling=d,c=d);return to&&Gi(n,m),l}for(d=i(n,d);m<s.length;m++)null!==(g=p(d,n,m,s[m],u))&&(e&&null!==g.alternate&&d.delete(null===g.key?m:g.key),o=a(g,o,m),null===c?l=g:c.sibling=g,c=g);return e&&d.forEach((function(e){return t(n,e)})),to&&Gi(n,m),l}function g(o,s,u,l){var c=L(u);if("function"!=typeof c)throw Error(n(150));if(null==(u=c.call(u)))throw Error(n(151));for(var d=c=null,m=s,g=s=0,v=null,b=u.next();null!==m&&!b.done;g++,b=u.next()){m.index>g?(v=m,m=null):v=m.sibling;var y=h(o,m,b.value,l);if(null===y){null===m&&(m=v);break}e&&m&&null===y.alternate&&t(o,m),s=a(y,s,g),null===d?c=y:d.sibling=y,d=y,m=v;}if(b.done)return r(o,m),to&&Gi(o,g),c;if(null===m){for(;!b.done;g++,b=u.next())null!==(b=f(o,b.value,l))&&(s=a(b,s,g),null===d?c=b:d.sibling=b,d=b);return to&&Gi(o,g),c}for(m=i(o,m);!b.done;g++,b=u.next())null!==(b=p(m,o,g,b.value,l))&&(e&&null!==b.alternate&&m.delete(null===b.key?g:b.key),s=a(b,s,g),null===d?c=b:d.sibling=b,d=b);return e&&m.forEach((function(e){return t(o,e)})),to&&Gi(o,g),c}return function e(n,i,a,u){if("object"==typeof a&&null!==a&&a.type===w&&null===a.key&&(a=a.props.children),"object"==typeof a&&null!==a){switch(a.$$typeof){case b:e:{for(var l=a.key,c=i;null!==c;){if(c.key===l){if((l=a.type)===w){if(7===c.tag){r(n,c.sibling),(i=o(c,a.props.children)).return=n,n=i;break e}}else if(c.elementType===l||"object"==typeof l&&null!==l&&l.$$typeof===R&&$o(l)===c.type){r(n,c.sibling),(i=o(c,a.props)).ref=Ho(n,c,a),i.return=n,n=i;break e}r(n,c);break}t(n,c),c=c.sibling;}a.type===w?((i=Il(a.props.children,n.mode,u,a.key)).return=n,n=i):((u=Ll(a.type,a.key,a.props,null,n.mode,u)).ref=Ho(n,i,a),u.return=n,n=u);}return s(n);case y:e:{for(c=a.key;null!==i;){if(i.key===c){if(4===i.tag&&i.stateNode.containerInfo===a.containerInfo&&i.stateNode.implementation===a.implementation){r(n,i.sibling),(i=o(i,a.children||[])).return=n,n=i;break e}r(n,i);break}t(n,i),i=i.sibling;}(i=Dl(a,n.mode,u)).return=n,n=i;}return s(n);case R:return e(n,i,(c=a._init)(a._payload),u)}if(J(a))return m(n,i,a,u);if(L(a))return g(n,i,a,u);Wo(n,a);}return "string"==typeof a&&""!==a||"number"==typeof a?(a=""+a,null!==i&&6===i.tag?(r(n,i.sibling),(i=o(i,a)).return=n,n=i):(r(n,i),(i=Nl(a,n.mode,u)).return=n,n=i),s(n)):r(n,i)}}var Yo=Vo(true),Go=Vo(false),Zo={},Qo=_i(Zo),Jo=_i(Zo),Xo=_i(Zo);function ea(e){if(e===Zo)throw Error(n(174));return e}function ta(e,t){switch(Ei(Xo,t),Ei(Jo,e),Ei(Qo,Zo),e=t.nodeType){case 9:case 11:t=(t=t.documentElement)?t.namespaceURI:oe(null,"");break;default:t=oe(t=(e=8===e?t.parentNode:t).namespaceURI||null,e=e.tagName);}Si(Qo),Ei(Qo,t);}function na(){Si(Qo),Si(Jo),Si(Xo);}function ra(e){ea(Xo.current);var t=ea(Qo.current),n=oe(t,e.type);t!==n&&(Ei(Jo,e),Ei(Qo,n));}function ia(e){Jo.current===e&&(Si(Qo),Si(Jo));}var oa=_i(0);function aa(e){for(var t=e;null!==t;){if(13===t.tag){var n=t.memoizedState;if(null!==n&&(null===(n=n.dehydrated)||"$?"===n.data||"$!"===n.data))return t}else if(19===t.tag&&void 0!==t.memoizedProps.revealOrder){if(0!=(128&t.flags))return t}else if(null!==t.child){t.child.return=t,t=t.child;continue}if(t===e)break;for(;null===t.sibling;){if(null===t.return||t.return===e)return null;t=t.return;}t.sibling.return=t.return,t=t.sibling;}return null}var sa=[];function ua(){for(var e=0;e<sa.length;e++)sa[e]._workInProgressVersionPrimary=null;sa.length=0;}var la=v.ReactCurrentDispatcher,ca=v.ReactCurrentBatchConfig,da=0,fa=null,ha=null,pa=null,ma=false,ga=false,va=0,ba=0;function ya(){throw Error(n(321))}function wa(e,t){if(null===t)return  false;for(var n=0;n<t.length&&n<e.length;n++)if(!ir(e[n],t[n]))return  false;return  true}function _a(e,t,r,i,o,a){if(da=a,fa=t,t.memoizedState=null,t.updateQueue=null,t.lanes=0,la.current=null===e||null===e.memoizedState?is:os,e=r(i,o),ga){a=0;do{if(ga=false,va=0,25<=a)throw Error(n(301));a+=1,pa=ha=null,t.updateQueue=null,la.current=as,e=r(i,o);}while(ga)}if(la.current=rs,t=null!==ha&&null!==ha.next,da=0,pa=ha=fa=null,ma=false,t)throw Error(n(300));return e}function Sa(){var e=0!==va;return va=0,e}function Ea(){var e={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};return null===pa?fa.memoizedState=pa=e:pa=pa.next=e,pa}function ka(){if(null===ha){var e=fa.alternate;e=null!==e?e.memoizedState:null;}else e=ha.next;var t=null===pa?fa.memoizedState:pa.next;if(null!==t)pa=t,ha=e;else {if(null===e)throw Error(n(310));e={memoizedState:(ha=e).memoizedState,baseState:ha.baseState,baseQueue:ha.baseQueue,queue:ha.queue,next:null},null===pa?fa.memoizedState=pa=e:pa=pa.next=e;}return pa}function Ma(e,t){return "function"==typeof t?t(e):t}function Ca(e){var t=ka(),r=t.queue;if(null===r)throw Error(n(311));r.lastRenderedReducer=e;var i=ha,o=i.baseQueue,a=r.pending;if(null!==a){if(null!==o){var s=o.next;o.next=a.next,a.next=s;}i.baseQueue=o=a,r.pending=null;}if(null!==o){a=o.next,i=i.baseState;var u=s=null,l=null,c=a;do{var d=c.lane;if((da&d)===d)null!==l&&(l=l.next={lane:0,action:c.action,hasEagerState:c.hasEagerState,eagerState:c.eagerState,next:null}),i=c.hasEagerState?c.eagerState:e(i,c.action);else {var f={lane:d,action:c.action,hasEagerState:c.hasEagerState,eagerState:c.eagerState,next:null};null===l?(u=l=f,s=i):l=l.next=f,fa.lanes|=d,Ou|=d;}c=c.next;}while(null!==c&&c!==a);null===l?s=i:l.next=u,ir(i,t.memoizedState)||(vs=true),t.memoizedState=i,t.baseState=s,t.baseQueue=l,r.lastRenderedState=i;}if(null!==(e=r.interleaved)){o=e;do{a=o.lane,fa.lanes|=a,Ou|=a,o=o.next;}while(o!==e)}else null===o&&(r.lanes=0);return [t.memoizedState,r.dispatch]}function xa(e){var t=ka(),r=t.queue;if(null===r)throw Error(n(311));r.lastRenderedReducer=e;var i=r.dispatch,o=r.pending,a=t.memoizedState;if(null!==o){r.pending=null;var s=o=o.next;do{a=e(a,s.action),s=s.next;}while(s!==o);ir(a,t.memoizedState)||(vs=true),t.memoizedState=a,null===t.baseQueue&&(t.baseState=a),r.lastRenderedState=a;}return [a,i]}function Aa(){}function Ra(e,t){var r=fa,i=ka(),o=t(),a=!ir(i.memoizedState,o);if(a&&(i.memoizedState=o,vs=true),i=i.queue,Fa(La.bind(null,r,i,e),[e]),i.getSnapshot!==t||a||null!==pa&&1&pa.memoizedState.tag){if(r.flags|=2048,Da(9,Pa.bind(null,r,i,o,t),void 0,null),null===xu)throw Error(n(349));0!=(30&da)||Ta(r,t,o);}return o}function Ta(e,t,n){e.flags|=16384,e={getSnapshot:t,value:n},null===(t=fa.updateQueue)?(t={lastEffect:null,stores:null},fa.updateQueue=t,t.stores=[e]):null===(n=t.stores)?t.stores=[e]:n.push(e);}function Pa(e,t,n,r){t.value=n,t.getSnapshot=r,Ia(t)&&Oa(e);}function La(e,t,n){return n((function(){Ia(t)&&Oa(e);}))}function Ia(e){var t=e.getSnapshot;e=e.value;try{var n=t();return !ir(e,n)}catch(e){return  true}}function Oa(e){var t=xo(e,1);null!==t&&el(t,e,1,-1);}function Na(e){var t=Ea();return "function"==typeof e&&(e=e()),t.memoizedState=t.baseState=e,e={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:Ma,lastRenderedState:e},t.queue=e,e=e.dispatch=Xa.bind(null,fa,e),[t.memoizedState,e]}function Da(e,t,n,r){return e={tag:e,create:t,destroy:n,deps:r,next:null},null===(t=fa.updateQueue)?(t={lastEffect:null,stores:null},fa.updateQueue=t,t.lastEffect=e.next=e):null===(n=t.lastEffect)?t.lastEffect=e.next=e:(r=n.next,n.next=e,e.next=r,t.lastEffect=e),e}function ja(){return ka().memoizedState}function Ba(e,t,n,r){var i=Ea();fa.flags|=e,i.memoizedState=Da(1|t,n,void 0,void 0===r?null:r);}function za(e,t,n,r){var i=ka();r=void 0===r?null:r;var o=void 0;if(null!==ha){var a=ha.memoizedState;if(o=a.destroy,null!==r&&wa(r,a.deps))return void(i.memoizedState=Da(t,n,o,r))}fa.flags|=e,i.memoizedState=Da(1|t,n,o,r);}function Ua(e,t){return Ba(8390656,8,e,t)}function Fa(e,t){return za(2048,8,e,t)}function Ka(e,t){return za(4,2,e,t)}function qa(e,t){return za(4,4,e,t)}function Ha(e,t){return "function"==typeof t?(e=e(),t(e),function(){t(null);}):null!=t?(e=e(),t.current=e,function(){t.current=null;}):void 0}function Wa(e,t,n){return n=null!=n?n.concat([e]):null,za(4,4,Ha.bind(null,t,e),n)}function $a(){}function Va(e,t){var n=ka();t=void 0===t?null:t;var r=n.memoizedState;return null!==r&&null!==t&&wa(t,r[1])?r[0]:(n.memoizedState=[e,t],e)}function Ya(e,t){var n=ka();t=void 0===t?null:t;var r=n.memoizedState;return null!==r&&null!==t&&wa(t,r[1])?r[0]:(e=e(),n.memoizedState=[e,t],e)}function Ga(e,t,n){return 0==(21&da)?(e.baseState&&(e.baseState=false,vs=true),e.memoizedState=n):(ir(n,t)||(n=ft(),fa.lanes|=n,Ou|=n,e.baseState=true),t)}function Za(e,t){var n=gt;gt=0!==n&&4>n?n:4,e(true);var r=ca.transition;ca.transition={};try{e(!1),t();}finally{gt=n,ca.transition=r;}}function Qa(){return ka().memoizedState}function Ja(e,t,n){var r=Xu(e);if(n={lane:r,action:n,hasEagerState:false,eagerState:null,next:null},es(e))ts(t,n);else if(null!==(n=Co(e,t,n,r))){el(n,e,r,Ju()),ns(n,t,r);}}function Xa(e,t,n){var r=Xu(e),i={lane:r,action:n,hasEagerState:false,eagerState:null,next:null};if(es(e))ts(t,i);else {var o=e.alternate;if(0===e.lanes&&(null===o||0===o.lanes)&&null!==(o=t.lastRenderedReducer))try{var a=t.lastRenderedState,s=o(a,n);if(i.hasEagerState=!0,i.eagerState=s,ir(s,a)){var u=t.interleaved;return null===u?(i.next=i,Mo(t)):(i.next=u.next,u.next=i),void(t.interleaved=i)}}catch(e){}null!==(n=Co(e,t,i,r))&&(el(n,e,r,i=Ju()),ns(n,t,r));}}function es(e){var t=e.alternate;return e===fa||null!==t&&t===fa}function ts(e,t){ga=ma=true;var n=e.pending;null===n?t.next=t:(t.next=n.next,n.next=t),e.pending=t;}function ns(e,t,n){if(0!=(4194240&n)){var r=t.lanes;n|=r&=e.pendingLanes,t.lanes=n,mt(e,n);}}var rs={readContext:Eo,useCallback:ya,useContext:ya,useEffect:ya,useImperativeHandle:ya,useInsertionEffect:ya,useLayoutEffect:ya,useMemo:ya,useReducer:ya,useRef:ya,useState:ya,useDebugValue:ya,useDeferredValue:ya,useTransition:ya,useMutableSource:ya,useSyncExternalStore:ya,useId:ya,unstable_isNewReconciler:false},is={readContext:Eo,useCallback:function(e,t){return Ea().memoizedState=[e,void 0===t?null:t],e},useContext:Eo,useEffect:Ua,useImperativeHandle:function(e,t,n){return n=null!=n?n.concat([e]):null,Ba(4194308,4,Ha.bind(null,t,e),n)},useLayoutEffect:function(e,t){return Ba(4194308,4,e,t)},useInsertionEffect:function(e,t){return Ba(4,2,e,t)},useMemo:function(e,t){var n=Ea();return t=void 0===t?null:t,e=e(),n.memoizedState=[e,t],e},useReducer:function(e,t,n){var r=Ea();return t=void 0!==n?n(t):t,r.memoizedState=r.baseState=t,e={pending:null,interleaved:null,lanes:0,dispatch:null,lastRenderedReducer:e,lastRenderedState:t},r.queue=e,e=e.dispatch=Ja.bind(null,fa,e),[r.memoizedState,e]},useRef:function(e){return e={current:e},Ea().memoizedState=e},useState:Na,useDebugValue:$a,useDeferredValue:function(e){return Ea().memoizedState=e},useTransition:function(){var e=Na(false),t=e[0];return e=Za.bind(null,e[1]),Ea().memoizedState=e,[t,e]},useMutableSource:function(){},useSyncExternalStore:function(e,t,r){var i=fa,o=Ea();if(to){if(void 0===r)throw Error(n(407));r=r();}else {if(r=t(),null===xu)throw Error(n(349));0!=(30&da)||Ta(i,t,r);}o.memoizedState=r;var a={value:r,getSnapshot:t};return o.queue=a,Ua(La.bind(null,i,a,e),[e]),i.flags|=2048,Da(9,Pa.bind(null,i,a,r,t),void 0,null),r},useId:function(){var e=Ea(),t=xu.identifierPrefix;if(to){var n=Yi;t=":"+t+"R"+(n=(Vi&~(1<<32-rt(Vi)-1)).toString(32)+n),0<(n=va++)&&(t+="H"+n.toString(32)),t+=":";}else t=":"+t+"r"+(n=ba++).toString(32)+":";return e.memoizedState=t},unstable_isNewReconciler:false},os={readContext:Eo,useCallback:Va,useContext:Eo,useEffect:Fa,useImperativeHandle:Wa,useInsertionEffect:Ka,useLayoutEffect:qa,useMemo:Ya,useReducer:Ca,useRef:ja,useState:function(){return Ca(Ma)},useDebugValue:$a,useDeferredValue:function(e){return Ga(ka(),ha.memoizedState,e)},useTransition:function(){return [Ca(Ma)[0],ka().memoizedState]},useMutableSource:Aa,useSyncExternalStore:Ra,useId:Qa,unstable_isNewReconciler:false},as={readContext:Eo,useCallback:Va,useContext:Eo,useEffect:Fa,useImperativeHandle:Wa,useInsertionEffect:Ka,useLayoutEffect:qa,useMemo:Ya,useReducer:xa,useRef:ja,useState:function(){return xa(Ma)},useDebugValue:$a,useDeferredValue:function(e){var t=ka();return null===ha?t.memoizedState=e:Ga(t,ha.memoizedState,e)},useTransition:function(){return [xa(Ma)[0],ka().memoizedState]},useMutableSource:Aa,useSyncExternalStore:Ra,useId:Qa,unstable_isNewReconciler:false};function ss(e,t){try{var n="",r=t;do{n+=B(r),r=r.return;}while(r);var i=n;}catch(e){i="\nError generating stack: "+e.message+"\n"+e.stack;}return {value:e,source:t,stack:i,digest:null}}function us(e,t,n){return {value:e,source:null,stack:null!=n?n:null,digest:null!=t?t:null}}function ls(e,t){try{console.error(t.value);}catch(e){setTimeout((function(){throw e}));}}var cs="function"==typeof WeakMap?WeakMap:Map;function ds(e,t,n){(n=Po(-1,n)).tag=3,n.payload={element:null};var r=t.value;return n.callback=function(){Ku||(Ku=true,qu=r),ls(0,t);},n}function fs(e,t,n){(n=Po(-1,n)).tag=3;var r=e.type.getDerivedStateFromError;if("function"==typeof r){var i=t.value;n.payload=function(){return r(i)},n.callback=function(){ls(0,t);};}var o=e.stateNode;return null!==o&&"function"==typeof o.componentDidCatch&&(n.callback=function(){ls(0,t),"function"!=typeof r&&(null===Hu?Hu=new Set([this]):Hu.add(this));var e=t.stack;this.componentDidCatch(t.value,{componentStack:null!==e?e:""});}),n}function hs(e,t,n){var r=e.pingCache;if(null===r){r=e.pingCache=new cs;var i=new Set;r.set(t,i);}else void 0===(i=r.get(t))&&(i=new Set,r.set(t,i));i.has(n)||(i.add(n),e=El.bind(null,e,t,n),t.then(e,e));}function ps(e){do{var t;if((t=13===e.tag)&&(t=null===(t=e.memoizedState)||null!==t.dehydrated),t)return e;e=e.return;}while(null!==e);return null}function ms(e,t,n,r,i){return 0==(1&e.mode)?(e===t?e.flags|=65536:(e.flags|=128,n.flags|=131072,n.flags&=-52805,1===n.tag&&(null===n.alternate?n.tag=17:((t=Po(-1,1)).tag=2,Lo(n,t,1))),n.lanes|=1),e):(e.flags|=65536,e.lanes=i,e)}var gs=v.ReactCurrentOwner,vs=false;function bs(e,t,n,r){t.child=null===e?Go(t,null,n,r):Yo(t,e.child,n,r);}function ys(e,t,n,r,i){n=n.render;var o=t.ref;return So(t,i),r=_a(e,t,n,r,o,i),n=Sa(),null===e||vs?(to&&n&&Qi(t),t.flags|=1,bs(e,t,r,i),t.child):(t.updateQueue=e.updateQueue,t.flags&=-2053,e.lanes&=~i,Ks(e,t,i))}function ws(e,t,n,r,i){if(null===e){var o=n.type;return "function"!=typeof o||Tl(o)||void 0!==o.defaultProps||null!==n.compare||void 0!==n.defaultProps?((e=Ll(n.type,null,r,t,t.mode,i)).ref=t.ref,e.return=t,t.child=e):(t.tag=15,t.type=o,_s(e,t,o,r,i))}if(o=e.child,0==(e.lanes&i)){var a=o.memoizedProps;if((n=null!==(n=n.compare)?n:or)(a,r)&&e.ref===t.ref)return Ks(e,t,i)}return t.flags|=1,(e=Pl(o,r)).ref=t.ref,e.return=t,t.child=e}function _s(e,t,n,r,i){if(null!==e){var o=e.memoizedProps;if(or(o,r)&&e.ref===t.ref){if(vs=false,t.pendingProps=r=o,0==(e.lanes&i))return t.lanes=e.lanes,Ks(e,t,i);0!=(131072&e.flags)&&(vs=true);}}return ks(e,t,n,r,i)}function Ss(e,t,n){var r=t.pendingProps,i=r.children,o=null!==e?e.memoizedState:null;if("hidden"===r.mode)if(0==(1&t.mode))t.memoizedState={baseLanes:0,cachePool:null,transitions:null},Ei(Pu,Tu),Tu|=n;else {if(0==(1073741824&n))return e=null!==o?o.baseLanes|n:n,t.lanes=t.childLanes=1073741824,t.memoizedState={baseLanes:e,cachePool:null,transitions:null},t.updateQueue=null,Ei(Pu,Tu),Tu|=e,null;t.memoizedState={baseLanes:0,cachePool:null,transitions:null},r=null!==o?o.baseLanes:n,Ei(Pu,Tu),Tu|=r;}else null!==o?(r=o.baseLanes|n,t.memoizedState=null):r=n,Ei(Pu,Tu),Tu|=r;return bs(e,t,i,n),t.child}function Es(e,t){var n=t.ref;(null===e&&null!==n||null!==e&&e.ref!==n)&&(t.flags|=512,t.flags|=2097152);}function ks(e,t,n,r,i){var o=Ri(n)?xi:Mi.current;return o=Ai(t,o),So(t,i),n=_a(e,t,n,r,o,i),r=Sa(),null===e||vs?(to&&r&&Qi(t),t.flags|=1,bs(e,t,n,i),t.child):(t.updateQueue=e.updateQueue,t.flags&=-2053,e.lanes&=~i,Ks(e,t,i))}function Ms(e,t,n,r,i){if(Ri(n)){var o=true;Ii(t);}else o=false;if(So(t,i),null===t.stateNode)Fs(e,t),Fo(t,n,r),qo(t,n,r,i),r=true;else if(null===e){var a=t.stateNode,s=t.memoizedProps;a.props=s;var u=a.context,l=n.contextType;"object"==typeof l&&null!==l?l=Eo(l):l=Ai(t,l=Ri(n)?xi:Mi.current);var c=n.getDerivedStateFromProps,d="function"==typeof c||"function"==typeof a.getSnapshotBeforeUpdate;d||"function"!=typeof a.UNSAFE_componentWillReceiveProps&&"function"!=typeof a.componentWillReceiveProps||(s!==r||u!==l)&&Ko(t,a,r,l),Ao=false;var f=t.memoizedState;a.state=f,No(t,r,a,i),u=t.memoizedState,s!==r||f!==u||Ci.current||Ao?("function"==typeof c&&(Bo(t,n,c,r),u=t.memoizedState),(s=Ao||Uo(t,n,s,r,f,u,l))?(d||"function"!=typeof a.UNSAFE_componentWillMount&&"function"!=typeof a.componentWillMount||("function"==typeof a.componentWillMount&&a.componentWillMount(),"function"==typeof a.UNSAFE_componentWillMount&&a.UNSAFE_componentWillMount()),"function"==typeof a.componentDidMount&&(t.flags|=4194308)):("function"==typeof a.componentDidMount&&(t.flags|=4194308),t.memoizedProps=r,t.memoizedState=u),a.props=r,a.state=u,a.context=l,r=s):("function"==typeof a.componentDidMount&&(t.flags|=4194308),r=false);}else {a=t.stateNode,To(e,t),s=t.memoizedProps,l=t.type===t.elementType?s:po(t.type,s),a.props=l,d=t.pendingProps,f=a.context,"object"==typeof(u=n.contextType)&&null!==u?u=Eo(u):u=Ai(t,u=Ri(n)?xi:Mi.current);var h=n.getDerivedStateFromProps;(c="function"==typeof h||"function"==typeof a.getSnapshotBeforeUpdate)||"function"!=typeof a.UNSAFE_componentWillReceiveProps&&"function"!=typeof a.componentWillReceiveProps||(s!==d||f!==u)&&Ko(t,a,r,u),Ao=false,f=t.memoizedState,a.state=f,No(t,r,a,i);var p=t.memoizedState;s!==d||f!==p||Ci.current||Ao?("function"==typeof h&&(Bo(t,n,h,r),p=t.memoizedState),(l=Ao||Uo(t,n,l,r,f,p,u)||false)?(c||"function"!=typeof a.UNSAFE_componentWillUpdate&&"function"!=typeof a.componentWillUpdate||("function"==typeof a.componentWillUpdate&&a.componentWillUpdate(r,p,u),"function"==typeof a.UNSAFE_componentWillUpdate&&a.UNSAFE_componentWillUpdate(r,p,u)),"function"==typeof a.componentDidUpdate&&(t.flags|=4),"function"==typeof a.getSnapshotBeforeUpdate&&(t.flags|=1024)):("function"!=typeof a.componentDidUpdate||s===e.memoizedProps&&f===e.memoizedState||(t.flags|=4),"function"!=typeof a.getSnapshotBeforeUpdate||s===e.memoizedProps&&f===e.memoizedState||(t.flags|=1024),t.memoizedProps=r,t.memoizedState=p),a.props=r,a.state=p,a.context=u,r=l):("function"!=typeof a.componentDidUpdate||s===e.memoizedProps&&f===e.memoizedState||(t.flags|=4),"function"!=typeof a.getSnapshotBeforeUpdate||s===e.memoizedProps&&f===e.memoizedState||(t.flags|=1024),r=false);}return Cs(e,t,n,r,o,i)}function Cs(e,t,n,r,i,o){Es(e,t);var a=0!=(128&t.flags);if(!r&&!a)return i&&Oi(t,n,false),Ks(e,t,o);r=t.stateNode,gs.current=t;var s=a&&"function"!=typeof n.getDerivedStateFromError?null:r.render();return t.flags|=1,null!==e&&a?(t.child=Yo(t,e.child,null,o),t.child=Yo(t,null,s,o)):bs(e,t,s,o),t.memoizedState=r.state,i&&Oi(t,n,true),t.child}function xs(e){var t=e.stateNode;t.pendingContext?Pi(0,t.pendingContext,t.pendingContext!==t.context):t.context&&Pi(0,t.context,false),ta(e,t.containerInfo);}function As(e,t,n,r,i){return co(),fo(i),t.flags|=256,bs(e,t,n,r),t.child}var Rs,Ts,Ps,Ls,Is={dehydrated:null,treeContext:null,retryLane:0};function Os(e){return {baseLanes:e,cachePool:null,transitions:null}}function Ns(e,t,r){var i,o=t.pendingProps,a=oa.current,s=false,u=0!=(128&t.flags);if((i=u)||(i=(null===e||null!==e.memoizedState)&&0!=(2&a)),i?(s=true,t.flags&=-129):null!==e&&null===e.memoizedState||(a|=1),Ei(oa,1&a),null===e)return ao(t),null!==(e=t.memoizedState)&&null!==(e=e.dehydrated)?(0==(1&t.mode)?t.lanes=1:"$!"===e.data?t.lanes=8:t.lanes=1073741824,null):(u=o.children,e=o.fallback,s?(o=t.mode,s=t.child,u={mode:"hidden",children:u},0==(1&o)&&null!==s?(s.childLanes=0,s.pendingProps=u):s=Ol(u,o,0,null),e=Il(e,o,r,null),s.return=t,e.return=t,s.sibling=e,t.child=s,t.child.memoizedState=Os(r),t.memoizedState=Is,e):Ds(t,u));if(null!==(a=e.memoizedState)&&null!==(i=a.dehydrated))return function(e,t,r,i,o,a,s){if(r)return 256&t.flags?(t.flags&=-257,js(e,t,s,i=us(Error(n(422))))):null!==t.memoizedState?(t.child=e.child,t.flags|=128,null):(a=i.fallback,o=t.mode,i=Ol({mode:"visible",children:i.children},o,0,null),(a=Il(a,o,s,null)).flags|=2,i.return=t,a.return=t,i.sibling=a,t.child=i,0!=(1&t.mode)&&Yo(t,e.child,null,s),t.child.memoizedState=Os(s),t.memoizedState=Is,a);if(0==(1&t.mode))return js(e,t,s,null);if("$!"===o.data){if(i=o.nextSibling&&o.nextSibling.dataset)var u=i.dgst;return i=u,js(e,t,s,i=us(a=Error(n(419)),i,void 0))}if(u=0!=(s&e.childLanes),vs||u){if(null!==(i=xu)){switch(s&-s){case 4:o=2;break;case 16:o=8;break;case 64:case 128:case 256:case 512:case 1024:case 2048:case 4096:case 8192:case 16384:case 32768:case 65536:case 131072:case 262144:case 524288:case 1048576:case 2097152:case 4194304:case 8388608:case 16777216:case 33554432:case 67108864:o=32;break;case 536870912:o=268435456;break;default:o=0;}0!==(o=0!=(o&(i.suspendedLanes|s))?0:o)&&o!==a.retryLane&&(a.retryLane=o,xo(e,o),el(i,e,o,-1));}return hl(),js(e,t,s,i=us(Error(n(421))))}return "$?"===o.data?(t.flags|=128,t.child=e.child,t=Ml.bind(null,e),o._reactRetry=t,null):(e=a.treeContext,eo=ai(o.nextSibling),Xi=t,to=true,no=null,null!==e&&(Hi[Wi++]=Vi,Hi[Wi++]=Yi,Hi[Wi++]=$i,Vi=e.id,Yi=e.overflow,$i=t),t=Ds(t,i.children),t.flags|=4096,t)}(e,t,u,o,i,a,r);if(s){s=o.fallback,u=t.mode,i=(a=e.child).sibling;var l={mode:"hidden",children:o.children};return 0==(1&u)&&t.child!==a?((o=t.child).childLanes=0,o.pendingProps=l,t.deletions=null):(o=Pl(a,l)).subtreeFlags=14680064&a.subtreeFlags,null!==i?s=Pl(i,s):(s=Il(s,u,r,null)).flags|=2,s.return=t,o.return=t,o.sibling=s,t.child=o,o=s,s=t.child,u=null===(u=e.child.memoizedState)?Os(r):{baseLanes:u.baseLanes|r,cachePool:null,transitions:u.transitions},s.memoizedState=u,s.childLanes=e.childLanes&~r,t.memoizedState=Is,o}return e=(s=e.child).sibling,o=Pl(s,{mode:"visible",children:o.children}),0==(1&t.mode)&&(o.lanes=r),o.return=t,o.sibling=null,null!==e&&(null===(r=t.deletions)?(t.deletions=[e],t.flags|=16):r.push(e)),t.child=o,t.memoizedState=null,o}function Ds(e,t){return (t=Ol({mode:"visible",children:t},e.mode,0,null)).return=e,e.child=t}function js(e,t,n,r){return null!==r&&fo(r),Yo(t,e.child,null,n),(e=Ds(t,t.pendingProps.children)).flags|=2,t.memoizedState=null,e}function Bs(e,t,n){e.lanes|=t;var r=e.alternate;null!==r&&(r.lanes|=t),_o(e.return,t,n);}function zs(e,t,n,r,i){var o=e.memoizedState;null===o?e.memoizedState={isBackwards:t,rendering:null,renderingStartTime:0,last:r,tail:n,tailMode:i}:(o.isBackwards=t,o.rendering=null,o.renderingStartTime=0,o.last=r,o.tail=n,o.tailMode=i);}function Us(e,t,n){var r=t.pendingProps,i=r.revealOrder,o=r.tail;if(bs(e,t,r.children,n),0!=(2&(r=oa.current)))r=1&r|2,t.flags|=128;else {if(null!==e&&0!=(128&e.flags))e:for(e=t.child;null!==e;){if(13===e.tag)null!==e.memoizedState&&Bs(e,n,t);else if(19===e.tag)Bs(e,n,t);else if(null!==e.child){e.child.return=e,e=e.child;continue}if(e===t)break e;for(;null===e.sibling;){if(null===e.return||e.return===t)break e;e=e.return;}e.sibling.return=e.return,e=e.sibling;}r&=1;}if(Ei(oa,r),0==(1&t.mode))t.memoizedState=null;else switch(i){case "forwards":for(n=t.child,i=null;null!==n;)null!==(e=n.alternate)&&null===aa(e)&&(i=n),n=n.sibling;null===(n=i)?(i=t.child,t.child=null):(i=n.sibling,n.sibling=null),zs(t,false,i,n,o);break;case "backwards":for(n=null,i=t.child,t.child=null;null!==i;){if(null!==(e=i.alternate)&&null===aa(e)){t.child=i;break}e=i.sibling,i.sibling=n,n=i,i=e;}zs(t,true,n,null,o);break;case "together":zs(t,false,null,null,void 0);break;default:t.memoizedState=null;}return t.child}function Fs(e,t){0==(1&t.mode)&&null!==e&&(e.alternate=null,t.alternate=null,t.flags|=2);}function Ks(e,t,r){if(null!==e&&(t.dependencies=e.dependencies),Ou|=t.lanes,0==(r&t.childLanes))return null;if(null!==e&&t.child!==e.child)throw Error(n(153));if(null!==t.child){for(r=Pl(e=t.child,e.pendingProps),t.child=r,r.return=t;null!==e.sibling;)e=e.sibling,(r=r.sibling=Pl(e,e.pendingProps)).return=t;r.sibling=null;}return t.child}function qs(e,t){if(!to)switch(e.tailMode){case "hidden":t=e.tail;for(var n=null;null!==t;)null!==t.alternate&&(n=t),t=t.sibling;null===n?e.tail=null:n.sibling=null;break;case "collapsed":n=e.tail;for(var r=null;null!==n;)null!==n.alternate&&(r=n),n=n.sibling;null===r?t||null===e.tail?e.tail=null:e.tail.sibling=null:r.sibling=null;}}function Hs(e){var t=null!==e.alternate&&e.alternate.child===e.child,n=0,r=0;if(t)for(var i=e.child;null!==i;)n|=i.lanes|i.childLanes,r|=14680064&i.subtreeFlags,r|=14680064&i.flags,i.return=e,i=i.sibling;else for(i=e.child;null!==i;)n|=i.lanes|i.childLanes,r|=i.subtreeFlags,r|=i.flags,i.return=e,i=i.sibling;return e.subtreeFlags|=r,e.childLanes=n,t}function Ws(e,t,r){var o=t.pendingProps;switch(Ji(t),t.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return Hs(t),null;case 1:case 17:return Ri(t.type)&&Ti(),Hs(t),null;case 3:return o=t.stateNode,na(),Si(Ci),Si(Mi),ua(),o.pendingContext&&(o.context=o.pendingContext,o.pendingContext=null),null!==e&&null!==e.child||(uo(t)?t.flags|=4:null===e||e.memoizedState.isDehydrated&&0==(256&t.flags)||(t.flags|=1024,null!==no&&(il(no),no=null))),Ts(e,t),Hs(t),null;case 5:ia(t);var a=ea(Xo.current);if(r=t.type,null!==e&&null!=t.stateNode)Ps(e,t,r,o,a),e.ref!==t.ref&&(t.flags|=512,t.flags|=2097152);else {if(!o){if(null===t.stateNode)throw Error(n(166));return Hs(t),null}if(e=ea(Qo.current),uo(t)){o=t.stateNode,r=t.type;var s=t.memoizedProps;switch(o[li]=t,o[ci]=s,e=0!=(1&t.mode),r){case "dialog":Dr("cancel",o),Dr("close",o);break;case "iframe":case "object":case "embed":Dr("load",o);break;case "video":case "audio":for(a=0;a<Lr.length;a++)Dr(Lr[a],o);break;case "source":Dr("error",o);break;case "img":case "image":case "link":Dr("error",o),Dr("load",o);break;case "details":Dr("toggle",o);break;case "input":V(o,s),Dr("invalid",o);break;case "select":o._wrapperState={wasMultiple:!!s.multiple},Dr("invalid",o);break;case "textarea":te(o,s),Dr("invalid",o);}for(var u in me(r,s),a=null,s)if(s.hasOwnProperty(u)){var l=s[u];"children"===u?"string"==typeof l?o.textContent!==l&&(true!==s.suppressHydrationWarning&&Gr(o.textContent,l,e),a=["children",l]):"number"==typeof l&&o.textContent!==""+l&&(true!==s.suppressHydrationWarning&&Gr(o.textContent,l,e),a=["children",""+l]):i.hasOwnProperty(u)&&null!=l&&"onScroll"===u&&Dr("scroll",o);}switch(r){case "input":q(o),Z(o,s,true);break;case "textarea":q(o),re(o);break;case "select":case "option":break;default:"function"==typeof s.onClick&&(o.onclick=Zr);}o=a,t.updateQueue=o,null!==o&&(t.flags|=4);}else {u=9===a.nodeType?a:a.ownerDocument,"http://www.w3.org/1999/xhtml"===e&&(e=ie(r)),"http://www.w3.org/1999/xhtml"===e?"script"===r?((e=u.createElement("div")).innerHTML="<script><\/script>",e=e.removeChild(e.firstChild)):"string"==typeof o.is?e=u.createElement(r,{is:o.is}):(e=u.createElement(r),"select"===r&&(u=e,o.multiple?u.multiple=true:o.size&&(u.size=o.size))):e=u.createElementNS(e,r),e[li]=t,e[ci]=o,Rs(e,t,false,false),t.stateNode=e;e:{switch(u=ge(r,o),r){case "dialog":Dr("cancel",e),Dr("close",e),a=o;break;case "iframe":case "object":case "embed":Dr("load",e),a=o;break;case "video":case "audio":for(a=0;a<Lr.length;a++)Dr(Lr[a],e);a=o;break;case "source":Dr("error",e),a=o;break;case "img":case "image":case "link":Dr("error",e),Dr("load",e),a=o;break;case "details":Dr("toggle",e),a=o;break;case "input":V(e,o),a=$(e,o),Dr("invalid",e);break;case "option":default:a=o;break;case "select":e._wrapperState={wasMultiple:!!o.multiple},a=O({},o,{value:void 0}),Dr("invalid",e);break;case "textarea":te(e,o),a=ee(e,o),Dr("invalid",e);}for(s in me(r,a),l=a)if(l.hasOwnProperty(s)){var c=l[s];"style"===s?he(e,c):"dangerouslySetInnerHTML"===s?null!=(c=c?c.__html:void 0)&&ue(e,c):"children"===s?"string"==typeof c?("textarea"!==r||""!==c)&&le(e,c):"number"==typeof c&&le(e,""+c):"suppressContentEditableWarning"!==s&&"suppressHydrationWarning"!==s&&"autoFocus"!==s&&(i.hasOwnProperty(s)?null!=c&&"onScroll"===s&&Dr("scroll",e):null!=c&&g(e,s,c,u));}switch(r){case "input":q(e),Z(e,o,false);break;case "textarea":q(e),re(e);break;case "option":null!=o.value&&e.setAttribute("value",""+F(o.value));break;case "select":e.multiple=!!o.multiple,null!=(s=o.value)?X(e,!!o.multiple,s,false):null!=o.defaultValue&&X(e,!!o.multiple,o.defaultValue,true);break;default:"function"==typeof a.onClick&&(e.onclick=Zr);}switch(r){case "button":case "input":case "select":case "textarea":o=!!o.autoFocus;break e;case "img":o=true;break e;default:o=false;}}o&&(t.flags|=4);}null!==t.ref&&(t.flags|=512,t.flags|=2097152);}return Hs(t),null;case 6:if(e&&null!=t.stateNode)Ls(e,t,e.memoizedProps,o);else {if("string"!=typeof o&&null===t.stateNode)throw Error(n(166));if(r=ea(Xo.current),ea(Qo.current),uo(t)){if(o=t.stateNode,r=t.memoizedProps,o[li]=t,(s=o.nodeValue!==r)&&null!==(e=Xi))switch(e.tag){case 3:Gr(o.nodeValue,r,0!=(1&e.mode));break;case 5:true!==e.memoizedProps.suppressHydrationWarning&&Gr(o.nodeValue,r,0!=(1&e.mode));}s&&(t.flags|=4);}else (o=(9===r.nodeType?r:r.ownerDocument).createTextNode(o))[li]=t,t.stateNode=o;}return Hs(t),null;case 13:if(Si(oa),o=t.memoizedState,null===e||null!==e.memoizedState&&null!==e.memoizedState.dehydrated){if(to&&null!==eo&&0!=(1&t.mode)&&0==(128&t.flags))lo(),co(),t.flags|=98560,s=false;else if(s=uo(t),null!==o&&null!==o.dehydrated){if(null===e){if(!s)throw Error(n(318));if(!(s=null!==(s=t.memoizedState)?s.dehydrated:null))throw Error(n(317));s[li]=t;}else co(),0==(128&t.flags)&&(t.memoizedState=null),t.flags|=4;Hs(t),s=false;}else null!==no&&(il(no),no=null),s=true;if(!s)return 65536&t.flags?t:null}return 0!=(128&t.flags)?(t.lanes=r,t):((o=null!==o)!==(null!==e&&null!==e.memoizedState)&&o&&(t.child.flags|=8192,0!=(1&t.mode)&&(null===e||0!=(1&oa.current)?0===Lu&&(Lu=3):hl())),null!==t.updateQueue&&(t.flags|=4),Hs(t),null);case 4:return na(),Ts(e,t),null===e&&zr(t.stateNode.containerInfo),Hs(t),null;case 10:return wo(t.type._context),Hs(t),null;case 19:if(Si(oa),null===(s=t.memoizedState))return Hs(t),null;if(o=0!=(128&t.flags),null===(u=s.rendering))if(o)qs(s,false);else {if(0!==Lu||null!==e&&0!=(128&e.flags))for(e=t.child;null!==e;){if(null!==(u=aa(e))){for(t.flags|=128,qs(s,false),null!==(o=u.updateQueue)&&(t.updateQueue=o,t.flags|=4),t.subtreeFlags=0,o=r,r=t.child;null!==r;)e=o,(s=r).flags&=14680066,null===(u=s.alternate)?(s.childLanes=0,s.lanes=e,s.child=null,s.subtreeFlags=0,s.memoizedProps=null,s.memoizedState=null,s.updateQueue=null,s.dependencies=null,s.stateNode=null):(s.childLanes=u.childLanes,s.lanes=u.lanes,s.child=u.child,s.subtreeFlags=0,s.deletions=null,s.memoizedProps=u.memoizedProps,s.memoizedState=u.memoizedState,s.updateQueue=u.updateQueue,s.type=u.type,e=u.dependencies,s.dependencies=null===e?null:{lanes:e.lanes,firstContext:e.firstContext}),r=r.sibling;return Ei(oa,1&oa.current|2),t.child}e=e.sibling;}null!==s.tail&&Ye()>Uu&&(t.flags|=128,o=true,qs(s,false),t.lanes=4194304);}else {if(!o)if(null!==(e=aa(u))){if(t.flags|=128,o=true,null!==(r=e.updateQueue)&&(t.updateQueue=r,t.flags|=4),qs(s,true),null===s.tail&&"hidden"===s.tailMode&&!u.alternate&&!to)return Hs(t),null}else 2*Ye()-s.renderingStartTime>Uu&&1073741824!==r&&(t.flags|=128,o=true,qs(s,false),t.lanes=4194304);s.isBackwards?(u.sibling=t.child,t.child=u):(null!==(r=s.last)?r.sibling=u:t.child=u,s.last=u);}return null!==s.tail?(t=s.tail,s.rendering=t,s.tail=t.sibling,s.renderingStartTime=Ye(),t.sibling=null,r=oa.current,Ei(oa,o?1&r|2:1&r),t):(Hs(t),null);case 22:case 23:return ll(),o=null!==t.memoizedState,null!==e&&null!==e.memoizedState!==o&&(t.flags|=8192),o&&0!=(1&t.mode)?0!=(1073741824&Tu)&&(Hs(t),6&t.subtreeFlags&&(t.flags|=8192)):Hs(t),null;case 24:case 25:return null}throw Error(n(156,t.tag))}function $s(e,t){switch(Ji(t),t.tag){case 1:return Ri(t.type)&&Ti(),65536&(e=t.flags)?(t.flags=-65537&e|128,t):null;case 3:return na(),Si(Ci),Si(Mi),ua(),0!=(65536&(e=t.flags))&&0==(128&e)?(t.flags=-65537&e|128,t):null;case 5:return ia(t),null;case 13:if(Si(oa),null!==(e=t.memoizedState)&&null!==e.dehydrated){if(null===t.alternate)throw Error(n(340));co();}return 65536&(e=t.flags)?(t.flags=-65537&e|128,t):null;case 19:return Si(oa),null;case 4:return na(),null;case 10:return wo(t.type._context),null;case 22:case 23:return ll(),null;default:return null}}Rs=function(e,t){for(var n=t.child;null!==n;){if(5===n.tag||6===n.tag)e.appendChild(n.stateNode);else if(4!==n.tag&&null!==n.child){n.child.return=n,n=n.child;continue}if(n===t)break;for(;null===n.sibling;){if(null===n.return||n.return===t)return;n=n.return;}n.sibling.return=n.return,n=n.sibling;}},Ts=function(){},Ps=function(e,t,n,r){var o=e.memoizedProps;if(o!==r){e=t.stateNode,ea(Qo.current);var a,s=null;switch(n){case "input":o=$(e,o),r=$(e,r),s=[];break;case "select":o=O({},o,{value:void 0}),r=O({},r,{value:void 0}),s=[];break;case "textarea":o=ee(e,o),r=ee(e,r),s=[];break;default:"function"!=typeof o.onClick&&"function"==typeof r.onClick&&(e.onclick=Zr);}for(c in me(n,r),n=null,o)if(!r.hasOwnProperty(c)&&o.hasOwnProperty(c)&&null!=o[c])if("style"===c){var u=o[c];for(a in u)u.hasOwnProperty(a)&&(n||(n={}),n[a]="");}else "dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(i.hasOwnProperty(c)?s||(s=[]):(s=s||[]).push(c,null));for(c in r){var l=r[c];if(u=null!=o?o[c]:void 0,r.hasOwnProperty(c)&&l!==u&&(null!=l||null!=u))if("style"===c)if(u){for(a in u)!u.hasOwnProperty(a)||l&&l.hasOwnProperty(a)||(n||(n={}),n[a]="");for(a in l)l.hasOwnProperty(a)&&u[a]!==l[a]&&(n||(n={}),n[a]=l[a]);}else n||(s||(s=[]),s.push(c,n)),n=l;else "dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,u=u?u.__html:void 0,null!=l&&u!==l&&(s=s||[]).push(c,l)):"children"===c?"string"!=typeof l&&"number"!=typeof l||(s=s||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(i.hasOwnProperty(c)?(null!=l&&"onScroll"===c&&Dr("scroll",e),s||u===l||(s=[])):(s=s||[]).push(c,l));}n&&(s=s||[]).push("style",n);var c=s;(t.updateQueue=c)&&(t.flags|=4);}},Ls=function(e,t,n,r){n!==r&&(t.flags|=4);};var Vs=false,Ys=false,Gs="function"==typeof WeakSet?WeakSet:Set,Zs=null;function Qs(e,t){var n=e.ref;if(null!==n)if("function"==typeof n)try{n(null);}catch(n){Sl(e,t,n);}else n.current=null;}function Js(e,t,n){try{n();}catch(n){Sl(e,t,n);}}var Xs=false;function eu(e,t,n){var r=t.updateQueue;if(null!==(r=null!==r?r.lastEffect:null)){var i=r=r.next;do{if((i.tag&e)===e){var o=i.destroy;i.destroy=void 0,void 0!==o&&Js(t,n,o);}i=i.next;}while(i!==r)}}function tu(e,t){if(null!==(t=null!==(t=t.updateQueue)?t.lastEffect:null)){var n=t=t.next;do{if((n.tag&e)===e){var r=n.create;n.destroy=r();}n=n.next;}while(n!==t)}}function nu(e){var t=e.ref;if(null!==t){var n=e.stateNode;e.tag,e=n,"function"==typeof t?t(e):t.current=e;}}function ru(e){var t=e.alternate;null!==t&&(e.alternate=null,ru(t)),e.child=null,e.deletions=null,e.sibling=null,5===e.tag&&(null!==(t=e.stateNode)&&(delete t[li],delete t[ci],delete t[fi],delete t[hi],delete t[pi])),e.stateNode=null,e.return=null,e.dependencies=null,e.memoizedProps=null,e.memoizedState=null,e.pendingProps=null,e.stateNode=null,e.updateQueue=null;}function iu(e){return 5===e.tag||3===e.tag||4===e.tag}function ou(e){e:for(;;){for(;null===e.sibling;){if(null===e.return||iu(e.return))return null;e=e.return;}for(e.sibling.return=e.return,e=e.sibling;5!==e.tag&&6!==e.tag&&18!==e.tag;){if(2&e.flags)continue e;if(null===e.child||4===e.tag)continue e;e.child.return=e,e=e.child;}if(!(2&e.flags))return e.stateNode}}function au(e,t,n){var r=e.tag;if(5===r||6===r)e=e.stateNode,t?8===n.nodeType?n.parentNode.insertBefore(e,t):n.insertBefore(e,t):(8===n.nodeType?(t=n.parentNode).insertBefore(e,n):(t=n).appendChild(e),null!=(n=n._reactRootContainer)||null!==t.onclick||(t.onclick=Zr));else if(4!==r&&null!==(e=e.child))for(au(e,t,n),e=e.sibling;null!==e;)au(e,t,n),e=e.sibling;}function su(e,t,n){var r=e.tag;if(5===r||6===r)e=e.stateNode,t?n.insertBefore(e,t):n.appendChild(e);else if(4!==r&&null!==(e=e.child))for(su(e,t,n),e=e.sibling;null!==e;)su(e,t,n),e=e.sibling;}var uu=null,lu=false;function cu(e,t,n){for(n=n.child;null!==n;)du(e,t,n),n=n.sibling;}function du(e,t,n){if(nt&&"function"==typeof nt.onCommitFiberUnmount)try{nt.onCommitFiberUnmount(tt,n);}catch(e){}switch(n.tag){case 5:Ys||Qs(n,t);case 6:var r=uu,i=lu;uu=null,cu(e,t,n),lu=i,null!==(uu=r)&&(lu?(e=uu,n=n.stateNode,8===e.nodeType?e.parentNode.removeChild(n):e.removeChild(n)):uu.removeChild(n.stateNode));break;case 18:null!==uu&&(lu?(e=uu,n=n.stateNode,8===e.nodeType?oi(e.parentNode,n):1===e.nodeType&&oi(e,n),zt(e)):oi(uu,n.stateNode));break;case 4:r=uu,i=lu,uu=n.stateNode.containerInfo,lu=true,cu(e,t,n),uu=r,lu=i;break;case 0:case 11:case 14:case 15:if(!Ys&&(null!==(r=n.updateQueue)&&null!==(r=r.lastEffect))){i=r=r.next;do{var o=i,a=o.destroy;o=o.tag,void 0!==a&&(0!=(2&o)||0!=(4&o))&&Js(n,t,a),i=i.next;}while(i!==r)}cu(e,t,n);break;case 1:if(!Ys&&(Qs(n,t),"function"==typeof(r=n.stateNode).componentWillUnmount))try{r.props=n.memoizedProps,r.state=n.memoizedState,r.componentWillUnmount();}catch(e){Sl(n,t,e);}cu(e,t,n);break;case 21:cu(e,t,n);break;case 22:1&n.mode?(Ys=(r=Ys)||null!==n.memoizedState,cu(e,t,n),Ys=r):cu(e,t,n);break;default:cu(e,t,n);}}function fu(e){var t=e.updateQueue;if(null!==t){e.updateQueue=null;var n=e.stateNode;null===n&&(n=e.stateNode=new Gs),t.forEach((function(t){var r=Cl.bind(null,e,t);n.has(t)||(n.add(t),t.then(r,r));}));}}function hu(e,t){var r=t.deletions;if(null!==r)for(var i=0;i<r.length;i++){var o=r[i];try{var a=e,s=t,u=s;e:for(;null!==u;){switch(u.tag){case 5:uu=u.stateNode,lu=!1;break e;case 3:case 4:uu=u.stateNode.containerInfo,lu=!0;break e}u=u.return;}if(null===uu)throw Error(n(160));du(a,s,o),uu=null,lu=!1;var l=o.alternate;null!==l&&(l.return=null),o.return=null;}catch(e){Sl(o,t,e);}}if(12854&t.subtreeFlags)for(t=t.child;null!==t;)pu(t,e),t=t.sibling;}function pu(e,t){var r=e.alternate,i=e.flags;switch(e.tag){case 0:case 11:case 14:case 15:if(hu(t,e),mu(e),4&i){try{eu(3,e,e.return),tu(3,e);}catch(t){Sl(e,e.return,t);}try{eu(5,e,e.return);}catch(t){Sl(e,e.return,t);}}break;case 1:hu(t,e),mu(e),512&i&&null!==r&&Qs(r,r.return);break;case 5:if(hu(t,e),mu(e),512&i&&null!==r&&Qs(r,r.return),32&e.flags){var o=e.stateNode;try{le(o,"");}catch(t){Sl(e,e.return,t);}}if(4&i&&null!=(o=e.stateNode)){var a=e.memoizedProps,s=null!==r?r.memoizedProps:a,u=e.type,l=e.updateQueue;if(e.updateQueue=null,null!==l)try{"input"===u&&"radio"===a.type&&null!=a.name&&Y(o,a),ge(u,s);var c=ge(u,a);for(s=0;s<l.length;s+=2){var d=l[s],f=l[s+1];"style"===d?he(o,f):"dangerouslySetInnerHTML"===d?ue(o,f):"children"===d?le(o,f):g(o,d,f,c);}switch(u){case "input":G(o,a);break;case "textarea":ne(o,a);break;case "select":var h=o._wrapperState.wasMultiple;o._wrapperState.wasMultiple=!!a.multiple;var p=a.value;null!=p?X(o,!!a.multiple,p,!1):h!==!!a.multiple&&(null!=a.defaultValue?X(o,!!a.multiple,a.defaultValue,!0):X(o,!!a.multiple,a.multiple?[]:"",!1));}o[ci]=a;}catch(t){Sl(e,e.return,t);}}break;case 6:if(hu(t,e),mu(e),4&i){if(null===e.stateNode)throw Error(n(162));o=e.stateNode,a=e.memoizedProps;try{o.nodeValue=a;}catch(t){Sl(e,e.return,t);}}break;case 3:if(hu(t,e),mu(e),4&i&&null!==r&&r.memoizedState.isDehydrated)try{zt(t.containerInfo);}catch(t){Sl(e,e.return,t);}break;case 4:default:hu(t,e),mu(e);break;case 13:hu(t,e),mu(e),8192&(o=e.child).flags&&(a=null!==o.memoizedState,o.stateNode.isHidden=a,!a||null!==o.alternate&&null!==o.alternate.memoizedState||(zu=Ye())),4&i&&fu(e);break;case 22:if(d=null!==r&&null!==r.memoizedState,1&e.mode?(Ys=(c=Ys)||d,hu(t,e),Ys=c):hu(t,e),mu(e),8192&i){if(c=null!==e.memoizedState,(e.stateNode.isHidden=c)&&!d&&0!=(1&e.mode))for(Zs=e,d=e.child;null!==d;){for(f=Zs=d;null!==Zs;){switch(p=(h=Zs).child,h.tag){case 0:case 11:case 14:case 15:eu(4,h,h.return);break;case 1:Qs(h,h.return);var m=h.stateNode;if("function"==typeof m.componentWillUnmount){i=h,r=h.return;try{t=i,m.props=t.memoizedProps,m.state=t.memoizedState,m.componentWillUnmount();}catch(e){Sl(i,r,e);}}break;case 5:Qs(h,h.return);break;case 22:if(null!==h.memoizedState){yu(f);continue}}null!==p?(p.return=h,Zs=p):yu(f);}d=d.sibling;}e:for(d=null,f=e;;){if(5===f.tag){if(null===d){d=f;try{o=f.stateNode,c?"function"==typeof(a=o.style).setProperty?a.setProperty("display","none","important"):a.display="none":(u=f.stateNode,s=null!=(l=f.memoizedProps.style)&&l.hasOwnProperty("display")?l.display:null,u.style.display=fe("display",s));}catch(t){Sl(e,e.return,t);}}}else if(6===f.tag){if(null===d)try{f.stateNode.nodeValue=c?"":f.memoizedProps;}catch(t){Sl(e,e.return,t);}}else if((22!==f.tag&&23!==f.tag||null===f.memoizedState||f===e)&&null!==f.child){f.child.return=f,f=f.child;continue}if(f===e)break e;for(;null===f.sibling;){if(null===f.return||f.return===e)break e;d===f&&(d=null),f=f.return;}d===f&&(d=null),f.sibling.return=f.return,f=f.sibling;}}break;case 19:hu(t,e),mu(e),4&i&&fu(e);case 21:}}function mu(e){var t=e.flags;if(2&t){try{e:{for(var r=e.return;null!==r;){if(iu(r)){var i=r;break e}r=r.return;}throw Error(n(160))}switch(i.tag){case 5:var o=i.stateNode;32&i.flags&&(le(o,""),i.flags&=-33),su(e,ou(e),o);break;case 3:case 4:var a=i.stateNode.containerInfo;au(e,ou(e),a);break;default:throw Error(n(161))}}catch(t){Sl(e,e.return,t);}e.flags&=-3;}4096&t&&(e.flags&=-4097);}function gu(e,t,n){Zs=e,vu(e);}function vu(e,t,n){for(var r=0!=(1&e.mode);null!==Zs;){var i=Zs,o=i.child;if(22===i.tag&&r){var a=null!==i.memoizedState||Vs;if(!a){var s=i.alternate,u=null!==s&&null!==s.memoizedState||Ys;s=Vs;var l=Ys;if(Vs=a,(Ys=u)&&!l)for(Zs=i;null!==Zs;)u=(a=Zs).child,22===a.tag&&null!==a.memoizedState?wu(i):null!==u?(u.return=a,Zs=u):wu(i);for(;null!==o;)Zs=o,vu(o),o=o.sibling;Zs=i,Vs=s,Ys=l;}bu(e);}else 0!=(8772&i.subtreeFlags)&&null!==o?(o.return=i,Zs=o):bu(e);}}function bu(e){for(;null!==Zs;){var t=Zs;if(0!=(8772&t.flags)){var r=t.alternate;try{if(0!=(8772&t.flags))switch(t.tag){case 0:case 11:case 15:Ys||tu(5,t);break;case 1:var i=t.stateNode;if(4&t.flags&&!Ys)if(null===r)i.componentDidMount();else {var o=t.elementType===t.type?r.memoizedProps:po(t.type,r.memoizedProps);i.componentDidUpdate(o,r.memoizedState,i.__reactInternalSnapshotBeforeUpdate);}var a=t.updateQueue;null!==a&&Do(t,a,i);break;case 3:var s=t.updateQueue;if(null!==s){if(r=null,null!==t.child)switch(t.child.tag){case 5:case 1:r=t.child.stateNode;}Do(t,s,r);}break;case 5:var u=t.stateNode;if(null===r&&4&t.flags){r=u;var l=t.memoizedProps;switch(t.type){case "button":case "input":case "select":case "textarea":l.autoFocus&&r.focus();break;case "img":l.src&&(r.src=l.src);}}break;case 6:case 4:case 12:case 19:case 17:case 21:case 22:case 23:case 25:break;case 13:if(null===t.memoizedState){var c=t.alternate;if(null!==c){var d=c.memoizedState;if(null!==d){var f=d.dehydrated;null!==f&&zt(f);}}}break;default:throw Error(n(163))}Ys||512&t.flags&&nu(t);}catch(e){Sl(t,t.return,e);}}if(t===e){Zs=null;break}if(null!==(r=t.sibling)){r.return=t.return,Zs=r;break}Zs=t.return;}}function yu(e){for(;null!==Zs;){var t=Zs;if(t===e){Zs=null;break}var n=t.sibling;if(null!==n){n.return=t.return,Zs=n;break}Zs=t.return;}}function wu(e){for(;null!==Zs;){var t=Zs;try{switch(t.tag){case 0:case 11:case 15:var n=t.return;try{tu(4,t);}catch(e){Sl(t,n,e);}break;case 1:var r=t.stateNode;if("function"==typeof r.componentDidMount){var i=t.return;try{r.componentDidMount();}catch(e){Sl(t,i,e);}}var o=t.return;try{nu(t);}catch(e){Sl(t,o,e);}break;case 5:var a=t.return;try{nu(t);}catch(e){Sl(t,a,e);}}}catch(e){Sl(t,t.return,e);}if(t===e){Zs=null;break}var s=t.sibling;if(null!==s){s.return=t.return,Zs=s;break}Zs=t.return;}}var _u,Su=Math.ceil,Eu=v.ReactCurrentDispatcher,ku=v.ReactCurrentOwner,Mu=v.ReactCurrentBatchConfig,Cu=0,xu=null,Au=null,Ru=0,Tu=0,Pu=_i(0),Lu=0,Iu=null,Ou=0,Nu=0,Du=0,ju=null,Bu=null,zu=0,Uu=1/0,Fu=null,Ku=false,qu=null,Hu=null,Wu=false,$u=null,Vu=0,Yu=0,Gu=null,Zu=-1,Qu=0;function Ju(){return 0!=(6&Cu)?Ye():-1!==Zu?Zu:Zu=Ye()}function Xu(e){return 0==(1&e.mode)?1:0!=(2&Cu)&&0!==Ru?Ru&-Ru:null!==ho.transition?(0===Qu&&(Qu=ft()),Qu):0!==(e=gt)?e:e=void 0===(e=window.event)?16:Vt(e.type)}function el(e,t,r,i){if(50<Yu)throw Yu=0,Gu=null,Error(n(185));pt(e,r,i),0!=(2&Cu)&&e===xu||(e===xu&&(0==(2&Cu)&&(Nu|=r),4===Lu&&ol(e,Ru)),tl(e,i),1===r&&0===Cu&&0==(1&t.mode)&&(Uu=Ye()+500,Di&&zi()));}function tl(e,t){var n=e.callbackNode;!function(e,t){for(var n=e.suspendedLanes,r=e.pingedLanes,i=e.expirationTimes,o=e.pendingLanes;0<o;){var a=31-rt(o),s=1<<a,u=i[a];-1===u?0!=(s&n)&&0==(s&r)||(i[a]=ct(s,t)):u<=t&&(e.expiredLanes|=s),o&=~s;}}(e,t);var r=lt(e,e===xu?Ru:0);if(0===r)null!==n&&We(n),e.callbackNode=null,e.callbackPriority=0;else if(t=r&-r,e.callbackPriority!==t){if(null!=n&&We(n),1===t)0===e.tag?function(e){Di=true,Bi(e);}(al.bind(null,e)):Bi(al.bind(null,e)),ri((function(){0==(6&Cu)&&zi();})),n=null;else {switch(vt(r)){case 1:n=Ze;break;case 4:n=Qe;break;case 16:default:n=Je;break;case 536870912:n=et;}n=xl(n,nl.bind(null,e));}e.callbackPriority=t,e.callbackNode=n;}}function nl(e,t){if(Zu=-1,Qu=0,0!=(6&Cu))throw Error(n(327));var r=e.callbackNode;if(wl()&&e.callbackNode!==r)return null;var i=lt(e,e===xu?Ru:0);if(0===i)return null;if(0!=(30&i)||0!=(i&e.expiredLanes)||t)t=pl(e,i);else {t=i;var o=Cu;Cu|=2;var a=fl();for(xu===e&&Ru===t||(Fu=null,Uu=Ye()+500,cl(e,t));;)try{gl();break}catch(t){dl(e,t);}yo(),Eu.current=a,Cu=o,null!==Au?t=0:(xu=null,Ru=0,t=Lu);}if(0!==t){if(2===t&&(0!==(o=dt(e))&&(i=o,t=rl(e,o))),1===t)throw r=Iu,cl(e,0),ol(e,i),tl(e,Ye()),r;if(6===t)ol(e,i);else {if(o=e.current.alternate,0==(30&i)&&!function(e){for(var t=e;;){if(16384&t.flags){var n=t.updateQueue;if(null!==n&&null!==(n=n.stores))for(var r=0;r<n.length;r++){var i=n[r],o=i.getSnapshot;i=i.value;try{if(!ir(o(),i))return !1}catch(e){return  false}}}if(n=t.child,16384&t.subtreeFlags&&null!==n)n.return=t,t=n;else {if(t===e)break;for(;null===t.sibling;){if(null===t.return||t.return===e)return  true;t=t.return;}t.sibling.return=t.return,t=t.sibling;}}return  true}(o)&&(2===(t=pl(e,i))&&(0!==(a=dt(e))&&(i=a,t=rl(e,a))),1===t))throw r=Iu,cl(e,0),ol(e,i),tl(e,Ye()),r;switch(e.finishedWork=o,e.finishedLanes=i,t){case 0:case 1:throw Error(n(345));case 2:case 5:yl(e,Bu,Fu);break;case 3:if(ol(e,i),(130023424&i)===i&&10<(t=zu+500-Ye())){if(0!==lt(e,0))break;if(((o=e.suspendedLanes)&i)!==i){Ju(),e.pingedLanes|=e.suspendedLanes&o;break}e.timeoutHandle=ei(yl.bind(null,e,Bu,Fu),t);break}yl(e,Bu,Fu);break;case 4:if(ol(e,i),(4194240&i)===i)break;for(t=e.eventTimes,o=-1;0<i;){var s=31-rt(i);a=1<<s,(s=t[s])>o&&(o=s),i&=~a;}if(i=o,10<(i=(120>(i=Ye()-i)?120:480>i?480:1080>i?1080:1920>i?1920:3e3>i?3e3:4320>i?4320:1960*Su(i/1960))-i)){e.timeoutHandle=ei(yl.bind(null,e,Bu,Fu),i);break}yl(e,Bu,Fu);break;default:throw Error(n(329))}}}return tl(e,Ye()),e.callbackNode===r?nl.bind(null,e):null}function rl(e,t){var n=ju;return e.current.memoizedState.isDehydrated&&(cl(e,t).flags|=256),2!==(e=pl(e,t))&&(t=Bu,Bu=n,null!==t&&il(t)),e}function il(e){null===Bu?Bu=e:Bu.push.apply(Bu,e);}function ol(e,t){for(t&=~Du,t&=~Nu,e.suspendedLanes|=t,e.pingedLanes&=~t,e=e.expirationTimes;0<t;){var n=31-rt(t),r=1<<n;e[n]=-1,t&=~r;}}function al(e){if(0!=(6&Cu))throw Error(n(327));wl();var t=lt(e,0);if(0==(1&t))return tl(e,Ye()),null;var r=pl(e,t);if(0!==e.tag&&2===r){var i=dt(e);0!==i&&(t=i,r=rl(e,i));}if(1===r)throw r=Iu,cl(e,0),ol(e,t),tl(e,Ye()),r;if(6===r)throw Error(n(345));return e.finishedWork=e.current.alternate,e.finishedLanes=t,yl(e,Bu,Fu),tl(e,Ye()),null}function sl(e,t){var n=Cu;Cu|=1;try{return e(t)}finally{0===(Cu=n)&&(Uu=Ye()+500,Di&&zi());}}function ul(e){null!==$u&&0===$u.tag&&0==(6&Cu)&&wl();var t=Cu;Cu|=1;var n=Mu.transition,r=gt;try{if(Mu.transition=null,gt=1,e)return e()}finally{gt=r,Mu.transition=n,0==(6&(Cu=t))&&zi();}}function ll(){Tu=Pu.current,Si(Pu);}function cl(e,t){e.finishedWork=null,e.finishedLanes=0;var n=e.timeoutHandle;if(-1!==n&&(e.timeoutHandle=-1,ti(n)),null!==Au)for(n=Au.return;null!==n;){var r=n;switch(Ji(r),r.tag){case 1:null!=(r=r.type.childContextTypes)&&Ti();break;case 3:na(),Si(Ci),Si(Mi),ua();break;case 5:ia(r);break;case 4:na();break;case 13:case 19:Si(oa);break;case 10:wo(r.type._context);break;case 22:case 23:ll();}n=n.return;}if(xu=e,Au=e=Pl(e.current,null),Ru=Tu=t,Lu=0,Iu=null,Du=Nu=Ou=0,Bu=ju=null,null!==ko){for(t=0;t<ko.length;t++)if(null!==(r=(n=ko[t]).interleaved)){n.interleaved=null;var i=r.next,o=n.pending;if(null!==o){var a=o.next;o.next=i,r.next=a;}n.pending=r;}ko=null;}return e}function dl(e,t){for(;;){var r=Au;try{if(yo(),la.current=rs,ma){for(var i=fa.memoizedState;null!==i;){var o=i.queue;null!==o&&(o.pending=null),i=i.next;}ma=!1;}if(da=0,pa=ha=fa=null,ga=!1,va=0,ku.current=null,null===r||null===r.return){Lu=1,Iu=t,Au=null;break}e:{var a=e,s=r.return,u=r,l=t;if(t=Ru,u.flags|=32768,null!==l&&"object"==typeof l&&"function"==typeof l.then){var c=l,d=u,f=d.tag;if(0==(1&d.mode)&&(0===f||11===f||15===f)){var h=d.alternate;h?(d.updateQueue=h.updateQueue,d.memoizedState=h.memoizedState,d.lanes=h.lanes):(d.updateQueue=null,d.memoizedState=null);}var p=ps(s);if(null!==p){p.flags&=-257,ms(p,s,u,0,t),1&p.mode&&hs(a,c,t),l=c;var m=(t=p).updateQueue;if(null===m){var g=new Set;g.add(l),t.updateQueue=g;}else m.add(l);break e}if(0==(1&t)){hs(a,c,t),hl();break e}l=Error(n(426));}else if(to&&1&u.mode){var v=ps(s);if(null!==v){0==(65536&v.flags)&&(v.flags|=256),ms(v,s,u,0,t),fo(ss(l,u));break e}}a=l=ss(l,u),4!==Lu&&(Lu=2),null===ju?ju=[a]:ju.push(a),a=s;do{switch(a.tag){case 3:a.flags|=65536,t&=-t,a.lanes|=t,Oo(a,ds(0,l,t));break e;case 1:u=l;var b=a.type,y=a.stateNode;if(0==(128&a.flags)&&("function"==typeof b.getDerivedStateFromError||null!==y&&"function"==typeof y.componentDidCatch&&(null===Hu||!Hu.has(y)))){a.flags|=65536,t&=-t,a.lanes|=t,Oo(a,fs(a,u,t));break e}}a=a.return;}while(null!==a)}bl(r);}catch(e){t=e,Au===r&&null!==r&&(Au=r=r.return);continue}break}}function fl(){var e=Eu.current;return Eu.current=rs,null===e?rs:e}function hl(){0!==Lu&&3!==Lu&&2!==Lu||(Lu=4),null===xu||0==(268435455&Ou)&&0==(268435455&Nu)||ol(xu,Ru);}function pl(e,t){var r=Cu;Cu|=2;var i=fl();for(xu===e&&Ru===t||(Fu=null,cl(e,t));;)try{ml();break}catch(t){dl(e,t);}if(yo(),Cu=r,Eu.current=i,null!==Au)throw Error(n(261));return xu=null,Ru=0,Lu}function ml(){for(;null!==Au;)vl(Au);}function gl(){for(;null!==Au&&!$e();)vl(Au);}function vl(e){var t=_u(e.alternate,e,Tu);e.memoizedProps=e.pendingProps,null===t?bl(e):Au=t,ku.current=null;}function bl(e){var t=e;do{var n=t.alternate;if(e=t.return,0==(32768&t.flags)){if(null!==(n=Ws(n,t,Tu)))return void(Au=n)}else {if(null!==(n=$s(n,t)))return n.flags&=32767,void(Au=n);if(null===e)return Lu=6,void(Au=null);e.flags|=32768,e.subtreeFlags=0,e.deletions=null;}if(null!==(t=t.sibling))return void(Au=t);Au=t=e;}while(null!==t);0===Lu&&(Lu=5);}function yl(e,t,r){var i=gt,o=Mu.transition;try{Mu.transition=null,gt=1,function(e,t,r,i){do{wl();}while(null!==$u);if(0!=(6&Cu))throw Error(n(327));r=e.finishedWork;var o=e.finishedLanes;if(null===r)return null;if(e.finishedWork=null,e.finishedLanes=0,r===e.current)throw Error(n(177));e.callbackNode=null,e.callbackPriority=0;var a=r.lanes|r.childLanes;if(function(e,t){var n=e.pendingLanes&~t;e.pendingLanes=t,e.suspendedLanes=0,e.pingedLanes=0,e.expiredLanes&=t,e.mutableReadLanes&=t,e.entangledLanes&=t,t=e.entanglements;var r=e.eventTimes;for(e=e.expirationTimes;0<n;){var i=31-rt(n),o=1<<i;t[i]=0,r[i]=-1,e[i]=-1,n&=~o;}}(e,a),e===xu&&(Au=xu=null,Ru=0),0==(2064&r.subtreeFlags)&&0==(2064&r.flags)||Wu||(Wu=!0,xl(Je,(function(){return wl(),null}))),a=0!=(15990&r.flags),0!=(15990&r.subtreeFlags)||a){a=Mu.transition,Mu.transition=null;var s=gt;gt=1;var u=Cu;Cu|=4,ku.current=null,function(e,t){if(Qr=Ft,cr(e=lr())){if("selectionStart"in e)var r={start:e.selectionStart,end:e.selectionEnd};else e:{var i=(r=(r=e.ownerDocument)&&r.defaultView||window).getSelection&&r.getSelection();if(i&&0!==i.rangeCount){r=i.anchorNode;var o=i.anchorOffset,a=i.focusNode;i=i.focusOffset;try{r.nodeType,a.nodeType;}catch(e){r=null;break e}var s=0,u=-1,l=-1,c=0,d=0,f=e,h=null;t:for(;;){for(var p;f!==r||0!==o&&3!==f.nodeType||(u=s+o),f!==a||0!==i&&3!==f.nodeType||(l=s+i),3===f.nodeType&&(s+=f.nodeValue.length),null!==(p=f.firstChild);)h=f,f=p;for(;;){if(f===e)break t;if(h===r&&++c===o&&(u=s),h===a&&++d===i&&(l=s),null!==(p=f.nextSibling))break;h=(f=h).parentNode;}f=p;}r=-1===u||-1===l?null:{start:u,end:l};}else r=null;}r=r||{start:0,end:0};}else r=null;for(Jr={focusedElem:e,selectionRange:r},Ft=!1,Zs=t;null!==Zs;)if(e=(t=Zs).child,0!=(1028&t.subtreeFlags)&&null!==e)e.return=t,Zs=e;else for(;null!==Zs;){t=Zs;try{var m=t.alternate;if(0!=(1024&t.flags))switch(t.tag){case 0:case 11:case 15:case 5:case 6:case 4:case 17:break;case 1:if(null!==m){var g=m.memoizedProps,v=m.memoizedState,b=t.stateNode,y=b.getSnapshotBeforeUpdate(t.elementType===t.type?g:po(t.type,g),v);b.__reactInternalSnapshotBeforeUpdate=y;}break;case 3:var w=t.stateNode.containerInfo;1===w.nodeType?w.textContent="":9===w.nodeType&&w.documentElement&&w.removeChild(w.documentElement);break;default:throw Error(n(163))}}catch(e){Sl(t,t.return,e);}if(null!==(e=t.sibling)){e.return=t.return,Zs=e;break}Zs=t.return;}m=Xs,Xs=!1;}(e,r),pu(r,e),dr(Jr),Ft=!!Qr,Jr=Qr=null,e.current=r,gu(r),Ve(),Cu=u,gt=s,Mu.transition=a;}else e.current=r;if(Wu&&(Wu=!1,$u=e,Vu=o),a=e.pendingLanes,0===a&&(Hu=null),function(e){if(nt&&"function"==typeof nt.onCommitFiberRoot)try{nt.onCommitFiberRoot(tt,e,void 0,128==(128&e.current.flags));}catch(e){}}(r.stateNode),tl(e,Ye()),null!==t)for(i=e.onRecoverableError,r=0;r<t.length;r++)o=t[r],i(o.value,{componentStack:o.stack,digest:o.digest});if(Ku)throw Ku=!1,e=qu,qu=null,e;0!=(1&Vu)&&0!==e.tag&&wl(),a=e.pendingLanes,0!=(1&a)?e===Gu?Yu++:(Yu=0,Gu=e):Yu=0,zi();}(e,t,r,i);}finally{Mu.transition=o,gt=i;}return null}function wl(){if(null!==$u){var e=vt(Vu),t=Mu.transition,r=gt;try{if(Mu.transition=null,gt=16>e?16:e,null===$u)var i=!1;else {if(e=$u,$u=null,Vu=0,0!=(6&Cu))throw Error(n(331));var o=Cu;for(Cu|=4,Zs=e.current;null!==Zs;){var a=Zs,s=a.child;if(0!=(16&Zs.flags)){var u=a.deletions;if(null!==u){for(var l=0;l<u.length;l++){var c=u[l];for(Zs=c;null!==Zs;){var d=Zs;switch(d.tag){case 0:case 11:case 15:eu(8,d,a);}var f=d.child;if(null!==f)f.return=d,Zs=f;else for(;null!==Zs;){var h=(d=Zs).sibling,p=d.return;if(ru(d),d===c){Zs=null;break}if(null!==h){h.return=p,Zs=h;break}Zs=p;}}}var m=a.alternate;if(null!==m){var g=m.child;if(null!==g){m.child=null;do{var v=g.sibling;g.sibling=null,g=v;}while(null!==g)}}Zs=a;}}if(0!=(2064&a.subtreeFlags)&&null!==s)s.return=a,Zs=s;else e:for(;null!==Zs;){if(0!=(2048&(a=Zs).flags))switch(a.tag){case 0:case 11:case 15:eu(9,a,a.return);}var b=a.sibling;if(null!==b){b.return=a.return,Zs=b;break e}Zs=a.return;}}var y=e.current;for(Zs=y;null!==Zs;){var w=(s=Zs).child;if(0!=(2064&s.subtreeFlags)&&null!==w)w.return=s,Zs=w;else e:for(s=y;null!==Zs;){if(0!=(2048&(u=Zs).flags))try{switch(u.tag){case 0:case 11:case 15:tu(9,u);}}catch(e){Sl(u,u.return,e);}if(u===s){Zs=null;break e}var _=u.sibling;if(null!==_){_.return=u.return,Zs=_;break e}Zs=u.return;}}if(Cu=o,zi(),nt&&"function"==typeof nt.onPostCommitFiberRoot)try{nt.onPostCommitFiberRoot(tt,e);}catch(e){}i=!0;}return i}finally{gt=r,Mu.transition=t;}}return  false}function _l(e,t,n){e=Lo(e,t=ds(0,t=ss(n,t),1),1),t=Ju(),null!==e&&(pt(e,1,t),tl(e,t));}function Sl(e,t,n){if(3===e.tag)_l(e,e,n);else for(;null!==t;){if(3===t.tag){_l(t,e,n);break}if(1===t.tag){var r=t.stateNode;if("function"==typeof t.type.getDerivedStateFromError||"function"==typeof r.componentDidCatch&&(null===Hu||!Hu.has(r))){t=Lo(t,e=fs(t,e=ss(n,e),1),1),e=Ju(),null!==t&&(pt(t,1,e),tl(t,e));break}}t=t.return;}}function El(e,t,n){var r=e.pingCache;null!==r&&r.delete(t),t=Ju(),e.pingedLanes|=e.suspendedLanes&n,xu===e&&(Ru&n)===n&&(4===Lu||3===Lu&&(130023424&Ru)===Ru&&500>Ye()-zu?cl(e,0):Du|=n),tl(e,t);}function kl(e,t){0===t&&(0==(1&e.mode)?t=1:(t=st,0==(130023424&(st<<=1))&&(st=4194304)));var n=Ju();null!==(e=xo(e,t))&&(pt(e,t,n),tl(e,n));}function Ml(e){var t=e.memoizedState,n=0;null!==t&&(n=t.retryLane),kl(e,n);}function Cl(e,t){var r=0;switch(e.tag){case 13:var i=e.stateNode,o=e.memoizedState;null!==o&&(r=o.retryLane);break;case 19:i=e.stateNode;break;default:throw Error(n(314))}null!==i&&i.delete(t),kl(e,r);}function xl(e,t){return He(e,t)}function Al(e,t,n,r){this.tag=e,this.key=n,this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null,this.index=0,this.ref=null,this.pendingProps=t,this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null,this.mode=r,this.subtreeFlags=this.flags=0,this.deletions=null,this.childLanes=this.lanes=0,this.alternate=null;}function Rl(e,t,n,r){return new Al(e,t,n,r)}function Tl(e){return !(!(e=e.prototype)||!e.isReactComponent)}function Pl(e,t){var n=e.alternate;return null===n?((n=Rl(e.tag,t,e.key,e.mode)).elementType=e.elementType,n.type=e.type,n.stateNode=e.stateNode,n.alternate=e,e.alternate=n):(n.pendingProps=t,n.type=e.type,n.flags=0,n.subtreeFlags=0,n.deletions=null),n.flags=14680064&e.flags,n.childLanes=e.childLanes,n.lanes=e.lanes,n.child=e.child,n.memoizedProps=e.memoizedProps,n.memoizedState=e.memoizedState,n.updateQueue=e.updateQueue,t=e.dependencies,n.dependencies=null===t?null:{lanes:t.lanes,firstContext:t.firstContext},n.sibling=e.sibling,n.index=e.index,n.ref=e.ref,n}function Ll(e,t,r,i,o,a){var s=2;if(i=e,"function"==typeof e)Tl(e)&&(s=1);else if("string"==typeof e)s=5;else e:switch(e){case w:return Il(r.children,o,a,t);case _:s=8,o|=8;break;case S:return (e=Rl(12,r,t,2|o)).elementType=S,e.lanes=a,e;case C:return (e=Rl(13,r,t,o)).elementType=C,e.lanes=a,e;case x:return (e=Rl(19,r,t,o)).elementType=x,e.lanes=a,e;case T:return Ol(r,o,a,t);default:if("object"==typeof e&&null!==e)switch(e.$$typeof){case E:s=10;break e;case k:s=9;break e;case M:s=11;break e;case A:s=14;break e;case R:s=16,i=null;break e}throw Error(n(130,null==e?e:typeof e,""))}return (t=Rl(s,r,t,o)).elementType=e,t.type=i,t.lanes=a,t}function Il(e,t,n,r){return (e=Rl(7,e,r,t)).lanes=n,e}function Ol(e,t,n,r){return (e=Rl(22,e,r,t)).elementType=T,e.lanes=n,e.stateNode={isHidden:false},e}function Nl(e,t,n){return (e=Rl(6,e,null,t)).lanes=n,e}function Dl(e,t,n){return (t=Rl(4,null!==e.children?e.children:[],e.key,t)).lanes=n,t.stateNode={containerInfo:e.containerInfo,pendingChildren:null,implementation:e.implementation},t}function jl(e,t,n,r,i){this.tag=t,this.containerInfo=e,this.finishedWork=this.pingCache=this.current=this.pendingChildren=null,this.timeoutHandle=-1,this.callbackNode=this.pendingContext=this.context=null,this.callbackPriority=0,this.eventTimes=ht(0),this.expirationTimes=ht(-1),this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0,this.entanglements=ht(0),this.identifierPrefix=r,this.onRecoverableError=i,this.mutableSourceEagerHydrationData=null;}function Bl(e,t,n,r,i,o,a,s,u){return e=new jl(e,t,n,s,u),1===t?(t=1,true===o&&(t|=8)):t=0,o=Rl(3,null,null,t),e.current=o,o.stateNode=e,o.memoizedState={element:r,isDehydrated:n,cache:null,transitions:null,pendingSuspenseBoundaries:null},Ro(o),e}function zl(e){if(!e)return ki;e:{if(ze(e=e._reactInternals)!==e||1!==e.tag)throw Error(n(170));var t=e;do{switch(t.tag){case 3:t=t.stateNode.context;break e;case 1:if(Ri(t.type)){t=t.stateNode.__reactInternalMemoizedMergedChildContext;break e}}t=t.return;}while(null!==t);throw Error(n(171))}if(1===e.tag){var r=e.type;if(Ri(r))return Li(e,r,t)}return t}function Ul(e,t,n,r,i,o,a,s,u){return (e=Bl(n,r,true,e,0,o,0,s,u)).context=zl(null),n=e.current,(o=Po(r=Ju(),i=Xu(n))).callback=null!=t?t:null,Lo(n,o,i),e.current.lanes=i,pt(e,i,r),tl(e,r),e}function Fl(e,t,n,r){var i=t.current,o=Ju(),a=Xu(i);return n=zl(n),null===t.context?t.context=n:t.pendingContext=n,(t=Po(o,a)).payload={element:e},null!==(r=void 0===r?null:r)&&(t.callback=r),null!==(e=Lo(i,t,a))&&(el(e,i,a,o),Io(e,i,a)),a}function Kl(e){return (e=e.current).child?(e.child.tag,e.child.stateNode):null}function ql(e,t){if(null!==(e=e.memoizedState)&&null!==e.dehydrated){var n=e.retryLane;e.retryLane=0!==n&&n<t?n:t;}}function Hl(e,t){ql(e,t),(e=e.alternate)&&ql(e,t);}_u=function(e,t,r){if(null!==e)if(e.memoizedProps!==t.pendingProps||Ci.current)vs=true;else {if(0==(e.lanes&r)&&0==(128&t.flags))return vs=false,function(e,t,n){switch(t.tag){case 3:xs(t),co();break;case 5:ra(t);break;case 1:Ri(t.type)&&Ii(t);break;case 4:ta(t,t.stateNode.containerInfo);break;case 10:var r=t.type._context,i=t.memoizedProps.value;Ei(mo,r._currentValue),r._currentValue=i;break;case 13:if(null!==(r=t.memoizedState))return null!==r.dehydrated?(Ei(oa,1&oa.current),t.flags|=128,null):0!=(n&t.child.childLanes)?Ns(e,t,n):(Ei(oa,1&oa.current),null!==(e=Ks(e,t,n))?e.sibling:null);Ei(oa,1&oa.current);break;case 19:if(r=0!=(n&t.childLanes),0!=(128&e.flags)){if(r)return Us(e,t,n);t.flags|=128;}if(null!==(i=t.memoizedState)&&(i.rendering=null,i.tail=null,i.lastEffect=null),Ei(oa,oa.current),r)break;return null;case 22:case 23:return t.lanes=0,Ss(e,t,n)}return Ks(e,t,n)}(e,t,r);vs=0!=(131072&e.flags);}else vs=false,to&&0!=(1048576&t.flags)&&Zi(t,qi,t.index);switch(t.lanes=0,t.tag){case 2:var i=t.type;Fs(e,t),e=t.pendingProps;var o=Ai(t,Mi.current);So(t,r),o=_a(null,t,i,e,o,r);var a=Sa();return t.flags|=1,"object"==typeof o&&null!==o&&"function"==typeof o.render&&void 0===o.$$typeof?(t.tag=1,t.memoizedState=null,t.updateQueue=null,Ri(i)?(a=true,Ii(t)):a=false,t.memoizedState=null!==o.state&&void 0!==o.state?o.state:null,Ro(t),o.updater=zo,t.stateNode=o,o._reactInternals=t,qo(t,i,e,r),t=Cs(null,t,i,true,a,r)):(t.tag=0,to&&a&&Qi(t),bs(null,t,o,r),t=t.child),t;case 16:i=t.elementType;e:{switch(Fs(e,t),e=t.pendingProps,i=(o=i._init)(i._payload),t.type=i,o=t.tag=function(e){if("function"==typeof e)return Tl(e)?1:0;if(null!=e){if((e=e.$$typeof)===M)return 11;if(e===A)return 14}return 2}(i),e=po(i,e),o){case 0:t=ks(null,t,i,e,r);break e;case 1:t=Ms(null,t,i,e,r);break e;case 11:t=ys(null,t,i,e,r);break e;case 14:t=ws(null,t,i,po(i.type,e),r);break e}throw Error(n(306,i,""))}return t;case 0:return i=t.type,o=t.pendingProps,ks(e,t,i,o=t.elementType===i?o:po(i,o),r);case 1:return i=t.type,o=t.pendingProps,Ms(e,t,i,o=t.elementType===i?o:po(i,o),r);case 3:e:{if(xs(t),null===e)throw Error(n(387));i=t.pendingProps,o=(a=t.memoizedState).element,To(e,t),No(t,i,null,r);var s=t.memoizedState;if(i=s.element,a.isDehydrated){if(a={element:i,isDehydrated:false,cache:s.cache,pendingSuspenseBoundaries:s.pendingSuspenseBoundaries,transitions:s.transitions},t.updateQueue.baseState=a,t.memoizedState=a,256&t.flags){t=As(e,t,i,r,o=ss(Error(n(423)),t));break e}if(i!==o){t=As(e,t,i,r,o=ss(Error(n(424)),t));break e}for(eo=ai(t.stateNode.containerInfo.firstChild),Xi=t,to=true,no=null,r=Go(t,null,i,r),t.child=r;r;)r.flags=-3&r.flags|4096,r=r.sibling;}else {if(co(),i===o){t=Ks(e,t,r);break e}bs(e,t,i,r);}t=t.child;}return t;case 5:return ra(t),null===e&&ao(t),i=t.type,o=t.pendingProps,a=null!==e?e.memoizedProps:null,s=o.children,Xr(i,o)?s=null:null!==a&&Xr(i,a)&&(t.flags|=32),Es(e,t),bs(e,t,s,r),t.child;case 6:return null===e&&ao(t),null;case 13:return Ns(e,t,r);case 4:return ta(t,t.stateNode.containerInfo),i=t.pendingProps,null===e?t.child=Yo(t,null,i,r):bs(e,t,i,r),t.child;case 11:return i=t.type,o=t.pendingProps,ys(e,t,i,o=t.elementType===i?o:po(i,o),r);case 7:return bs(e,t,t.pendingProps,r),t.child;case 8:case 12:return bs(e,t,t.pendingProps.children,r),t.child;case 10:e:{if(i=t.type._context,o=t.pendingProps,a=t.memoizedProps,s=o.value,Ei(mo,i._currentValue),i._currentValue=s,null!==a)if(ir(a.value,s)){if(a.children===o.children&&!Ci.current){t=Ks(e,t,r);break e}}else for(null!==(a=t.child)&&(a.return=t);null!==a;){var u=a.dependencies;if(null!==u){s=a.child;for(var l=u.firstContext;null!==l;){if(l.context===i){if(1===a.tag){(l=Po(-1,r&-r)).tag=2;var c=a.updateQueue;if(null!==c){var d=(c=c.shared).pending;null===d?l.next=l:(l.next=d.next,d.next=l),c.pending=l;}}a.lanes|=r,null!==(l=a.alternate)&&(l.lanes|=r),_o(a.return,r,t),u.lanes|=r;break}l=l.next;}}else if(10===a.tag)s=a.type===t.type?null:a.child;else if(18===a.tag){if(null===(s=a.return))throw Error(n(341));s.lanes|=r,null!==(u=s.alternate)&&(u.lanes|=r),_o(s,r,t),s=a.sibling;}else s=a.child;if(null!==s)s.return=a;else for(s=a;null!==s;){if(s===t){s=null;break}if(null!==(a=s.sibling)){a.return=s.return,s=a;break}s=s.return;}a=s;}bs(e,t,o.children,r),t=t.child;}return t;case 9:return o=t.type,i=t.pendingProps.children,So(t,r),i=i(o=Eo(o)),t.flags|=1,bs(e,t,i,r),t.child;case 14:return o=po(i=t.type,t.pendingProps),ws(e,t,i,o=po(i.type,o),r);case 15:return _s(e,t,t.type,t.pendingProps,r);case 17:return i=t.type,o=t.pendingProps,o=t.elementType===i?o:po(i,o),Fs(e,t),t.tag=1,Ri(i)?(e=true,Ii(t)):e=false,So(t,r),Fo(t,i,o),qo(t,i,o,r),Cs(null,t,i,true,e,r);case 19:return Us(e,t,r);case 22:return Ss(e,t,r)}throw Error(n(156,t.tag))};var Wl="function"==typeof reportError?reportError:function(e){console.error(e);};function $l(e){this._internalRoot=e;}function Vl(e){this._internalRoot=e;}function Yl(e){return !(!e||1!==e.nodeType&&9!==e.nodeType&&11!==e.nodeType)}function Gl(e){return !(!e||1!==e.nodeType&&9!==e.nodeType&&11!==e.nodeType&&(8!==e.nodeType||" react-mount-point-unstable "!==e.nodeValue))}function Zl(){}function Ql(e,t,n,r,i){var o=n._reactRootContainer;if(o){var a=o;if("function"==typeof i){var s=i;i=function(){var e=Kl(a);s.call(e);};}Fl(t,a,e,i);}else a=function(e,t,n,r,i){if(i){if("function"==typeof r){var o=r;r=function(){var e=Kl(a);o.call(e);};}var a=Ul(t,r,e,0,null,false,0,"",Zl);return e._reactRootContainer=a,e[di]=a.current,zr(8===e.nodeType?e.parentNode:e),ul(),a}for(;i=e.lastChild;)e.removeChild(i);if("function"==typeof r){var s=r;r=function(){var e=Kl(u);s.call(e);};}var u=Bl(e,0,false,null,0,false,0,"",Zl);return e._reactRootContainer=u,e[di]=u.current,zr(8===e.nodeType?e.parentNode:e),ul((function(){Fl(t,u,n,r);})),u}(n,t,e,i,r);return Kl(a)}Vl.prototype.render=$l.prototype.render=function(e){var t=this._internalRoot;if(null===t)throw Error(n(409));Fl(e,t,null,null);},Vl.prototype.unmount=$l.prototype.unmount=function(){var e=this._internalRoot;if(null!==e){this._internalRoot=null;var t=e.containerInfo;ul((function(){Fl(null,e,null,null);})),t[di]=null;}},Vl.prototype.unstable_scheduleHydration=function(e){if(e){var t=_t();e={blockedOn:null,target:e,priority:t};for(var n=0;n<Tt.length&&0!==t&&t<Tt[n].priority;n++);Tt.splice(n,0,e),0===n&&Ot(e);}},bt=function(e){switch(e.tag){case 3:var t=e.stateNode;if(t.current.memoizedState.isDehydrated){var n=ut(t.pendingLanes);0!==n&&(mt(t,1|n),tl(t,Ye()),0==(6&Cu)&&(Uu=Ye()+500,zi()));}break;case 13:ul((function(){var t=xo(e,1);if(null!==t){var n=Ju();el(t,e,1,n);}})),Hl(e,1);}},yt=function(e){if(13===e.tag){var t=xo(e,134217728);if(null!==t)el(t,e,134217728,Ju());Hl(e,134217728);}},wt=function(e){if(13===e.tag){var t=Xu(e),n=xo(e,t);if(null!==n)el(n,e,t,Ju());Hl(e,t);}},_t=function(){return gt},St=function(e,t){var n=gt;try{return gt=e,t()}finally{gt=n;}},ye=function(e,t,r){switch(t){case "input":if(G(e,r),t=r.name,"radio"===r.type&&null!=t){for(r=e;r.parentNode;)r=r.parentNode;for(r=r.querySelectorAll("input[name="+JSON.stringify(""+t)+'][type="radio"]'),t=0;t<r.length;t++){var i=r[t];if(i!==e&&i.form===e.form){var o=bi(i);if(!o)throw Error(n(90));H(i),G(i,o);}}}break;case "textarea":ne(e,r);break;case "select":null!=(t=r.value)&&X(e,!!r.multiple,t,false);}},Me=sl,Ce=ul;var Jl={usingClientEntryPoint:false,Events:[gi,vi,bi,Ee,ke,sl]},Xl={findFiberByHostInstance:mi,bundleType:0,version:"18.2.0",rendererPackageName:"react-dom"},ec={bundleType:Xl.bundleType,version:Xl.version,rendererPackageName:Xl.rendererPackageName,rendererConfig:Xl.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setErrorHandler:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:v.ReactCurrentDispatcher,findHostInstanceByFiber:function(e){return null===(e=Ke(e))?null:e.stateNode},findFiberByHostInstance:Xl.findFiberByHostInstance||function(){return null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null,reconcilerVersion:"18.2.0-next-9e3b772b8-20220608"};if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var tc=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!tc.isDisabled&&tc.supportsFiber)try{tt=tc.inject(ec),nt=tc;}catch(se){}}return jT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=Jl,jT.createPortal=function(e,t){var r=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!Yl(t))throw Error(n(200));return function(e,t,n){var r=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return {$$typeof:y,key:null==r?null:""+r,children:e,containerInfo:t,implementation:n}}(e,t,null,r)},jT.createRoot=function(e,t){if(!Yl(e))throw Error(n(299));var r=false,i="",o=Wl;return null!=t&&(true===t.unstable_strictMode&&(r=true),void 0!==t.identifierPrefix&&(i=t.identifierPrefix),void 0!==t.onRecoverableError&&(o=t.onRecoverableError)),t=Bl(e,1,false,null,0,r,0,i,o),e[di]=t.current,zr(8===e.nodeType?e.parentNode:e),new $l(t)},jT.findDOMNode=function(e){if(null==e)return null;if(1===e.nodeType)return e;var t=e._reactInternals;if(void 0===t){if("function"==typeof e.render)throw Error(n(188));throw e=Object.keys(e).join(","),Error(n(268,e))}return e=null===(e=Ke(t))?null:e.stateNode},jT.flushSync=function(e){return ul(e)},jT.hydrate=function(e,t,r){if(!Gl(t))throw Error(n(200));return Ql(null,e,t,true,r)},jT.hydrateRoot=function(e,t,r){if(!Yl(e))throw Error(n(405));var i=null!=r&&r.hydratedSources||null,o=false,a="",s=Wl;if(null!=r&&(true===r.unstable_strictMode&&(o=true),void 0!==r.identifierPrefix&&(a=r.identifierPrefix),void 0!==r.onRecoverableError&&(s=r.onRecoverableError)),t=Ul(t,null,e,1,null!=r?r:null,o,0,a,s),e[di]=t.current,zr(e),i)for(e=0;e<i.length;e++)o=(o=(r=i[e])._getVersion)(r._source),null==t.mutableSourceEagerHydrationData?t.mutableSourceEagerHydrationData=[r,o]:t.mutableSourceEagerHydrationData.push(r,o);return new Vl(t)},jT.render=function(e,t,r){if(!Gl(t))throw Error(n(200));return Ql(null,e,t,false,r)},jT.unmountComponentAtNode=function(e){if(!Gl(e))throw Error(n(40));return !!e._reactRootContainer&&(ul((function(){Ql(null,null,e,!1,(function(){e._reactRootContainer=null,e[di]=null;}));})),true)},jT.unstable_batchedUpdates=sl,jT.unstable_renderSubtreeIntoContainer=function(e,t,r,i){if(!Gl(r))throw Error(n(200));if(null==e||void 0===e._reactInternals)throw Error(n(38));return Ql(e,t,r,false,i)},jT.version="18.2.0-next-9e3b772b8-20220608",jT}var VT,YT,GT,ZT={};function QT(){return VT||(VT=1,"production"!==je.env.NODE_ENV&&function(){"undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error);var e=IT(),t=WT(),n=e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,r=false;function i(e){if(!r){for(var t=arguments.length,n=new Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];a("warn",e,n);}}function o(e){if(!r){for(var t=arguments.length,n=new Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];a("error",e,n);}}function a(e,t,r){var i=n.ReactDebugCurrentFrame.getStackAddendum();""!==i&&(t+="%s",r=r.concat([i]));var o=r.map((function(e){return String(e)}));o.unshift("Warning: "+t),Function.prototype.apply.call(console[e],console,o);}var s=0,u=1,l=2,c=3,d=4,f=5,h=6,p=7,m=8,g=9,v=10,b=11,y=12,w=13,_=14,S=15,E=16,k=17,M=18,C=19,x=21,A=22,R=23,T=24,P=25,L=true,I=false,O=false,N=false,j=true,z=false,U=true,F=true,K=true,q=new Set,H={},W={};function $(e,t){V(e,t),V(e+"Capture",t);}function V(e,t){H[e]&&o("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",e),H[e]=t;var n=e.toLowerCase();W[n]=e,"onDoubleClick"===e&&(W.ondblclick=e);for(var r=0;r<t.length;r++)q.add(t[r]);}var Y=!("undefined"==typeof window||void 0===window.document||void 0===window.document.createElement),G=Object.prototype.hasOwnProperty;function Z(e){return "function"==typeof Symbol&&Symbol.toStringTag&&e[Symbol.toStringTag]||e.constructor.name||"Object"}function Q(e){try{return J(e),!1}catch(e){return  true}}function J(e){return ""+e}function X(e,t){if(Q(e))return o("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.",t,Z(e)),J(e)}function ee(e){if(Q(e))return o("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.",Z(e)),J(e)}var te=0,ne=3,re=4,ie=5,oe=6,ae=":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",se=ae+"\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",ue=new RegExp("^["+ae+"]["+se+"]*$"),le={},ce={};function de(e){return !!G.call(ce,e)||!G.call(le,e)&&(ue.test(e)?(ce[e]=true,true):(le[e]=true,o("Invalid attribute name: `%s`",e),false))}function fe(e,t,n){return null!==t?t.type===te:!n&&(e.length>2&&("o"===e[0]||"O"===e[0])&&("n"===e[1]||"N"===e[1]))}function he(e,t,n,r){if(null!==n&&n.type===te)return  false;switch(typeof t){case "function":case "symbol":return  true;case "boolean":if(r)return  false;if(null!==n)return !n.acceptsBooleans;var i=e.toLowerCase().slice(0,5);return "data-"!==i&&"aria-"!==i;default:return  false}}function pe(e,t,n,r){if(null==t)return  true;if(he(e,t,n,r))return  true;if(r)return  false;if(null!==n)switch(n.type){case ne:return !t;case re:return  false===t;case ie:return isNaN(t);case oe:return isNaN(t)||t<1}return  false}function me(e){return ve.hasOwnProperty(e)?ve[e]:null}function ge(e,t,n,r,i,o,a){this.acceptsBooleans=2===t||t===ne||t===re,this.attributeName=r,this.attributeNamespace=i,this.mustUseProperty=n,this.propertyName=e,this.type=t,this.sanitizeURL=o,this.removeEmptyString=a;}var ve={};["children","dangerouslySetInnerHTML","defaultValue","defaultChecked","innerHTML","suppressContentEditableWarning","suppressHydrationWarning","style"].forEach((function(e){ve[e]=new ge(e,te,false,e,null,false,false);})),[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach((function(e){var t=e[0],n=e[1];ve[t]=new ge(t,1,false,n,null,false,false);})),["contentEditable","draggable","spellCheck","value"].forEach((function(e){ve[e]=new ge(e,2,false,e.toLowerCase(),null,false,false);})),["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach((function(e){ve[e]=new ge(e,2,false,e,null,false,false);})),["allowFullScreen","async","autoFocus","autoPlay","controls","default","defer","disabled","disablePictureInPicture","disableRemotePlayback","formNoValidate","hidden","loop","noModule","noValidate","open","playsInline","readOnly","required","reversed","scoped","seamless","itemScope"].forEach((function(e){ve[e]=new ge(e,ne,false,e.toLowerCase(),null,false,false);})),["checked","multiple","muted","selected"].forEach((function(e){ve[e]=new ge(e,ne,true,e,null,false,false);})),["capture","download"].forEach((function(e){ve[e]=new ge(e,re,false,e,null,false,false);})),["cols","rows","size","span"].forEach((function(e){ve[e]=new ge(e,oe,false,e,null,false,false);})),["rowSpan","start"].forEach((function(e){ve[e]=new ge(e,ie,false,e.toLowerCase(),null,false,false);}));var be=/[\-\:]([a-z])/g,ye=function(e){return e[1].toUpperCase()};["accent-height","alignment-baseline","arabic-form","baseline-shift","cap-height","clip-path","clip-rule","color-interpolation","color-interpolation-filters","color-profile","color-rendering","dominant-baseline","enable-background","fill-opacity","fill-rule","flood-color","flood-opacity","font-family","font-size","font-size-adjust","font-stretch","font-style","font-variant","font-weight","glyph-name","glyph-orientation-horizontal","glyph-orientation-vertical","horiz-adv-x","horiz-origin-x","image-rendering","letter-spacing","lighting-color","marker-end","marker-mid","marker-start","overline-position","overline-thickness","paint-order","panose-1","pointer-events","rendering-intent","shape-rendering","stop-color","stop-opacity","strikethrough-position","strikethrough-thickness","stroke-dasharray","stroke-dashoffset","stroke-linecap","stroke-linejoin","stroke-miterlimit","stroke-opacity","stroke-width","text-anchor","text-decoration","text-rendering","underline-position","underline-thickness","unicode-bidi","unicode-range","units-per-em","v-alphabetic","v-hanging","v-ideographic","v-mathematical","vector-effect","vert-adv-y","vert-origin-x","vert-origin-y","word-spacing","writing-mode","xmlns:xlink","x-height"].forEach((function(e){var t=e.replace(be,ye);ve[t]=new ge(t,1,false,e,null,false,false);})),["xlink:actuate","xlink:arcrole","xlink:role","xlink:show","xlink:title","xlink:type"].forEach((function(e){var t=e.replace(be,ye);ve[t]=new ge(t,1,false,e,"http://www.w3.org/1999/xlink",false,false);})),["xml:base","xml:lang","xml:space"].forEach((function(e){var t=e.replace(be,ye);ve[t]=new ge(t,1,false,e,"http://www.w3.org/XML/1998/namespace",false,false);})),["tabIndex","crossOrigin"].forEach((function(e){ve[e]=new ge(e,1,false,e.toLowerCase(),null,false,false);}));ve.xlinkHref=new ge("xlinkHref",1,false,"xlink:href","http://www.w3.org/1999/xlink",true,false),["src","href","action","formAction"].forEach((function(e){ve[e]=new ge(e,1,false,e.toLowerCase(),null,true,true);}));var we=/^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i,_e=false;function Se(e){!_e&&we.test(e)&&(_e=true,o("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.",JSON.stringify(e)));}function Ee(e,t,n,r){if(r.mustUseProperty)return e[r.propertyName];X(n,t),r.sanitizeURL&&Se(""+n);var i=r.attributeName,o=null;if(r.type===re){if(e.hasAttribute(i)){var a=e.getAttribute(i);return ""===a||(pe(t,n,r,false)?a:a===""+n?n:a)}}else if(e.hasAttribute(i)){if(pe(t,n,r,false))return e.getAttribute(i);if(r.type===ne)return n;o=e.getAttribute(i);}return pe(t,n,r,false)?null===o?n:o:o===""+n?n:o}function ke(e,t,n,r){if(de(t)){if(!e.hasAttribute(t))return void 0===n?void 0:null;var i=e.getAttribute(t);return X(n,t),i===""+n?n:i}}function Me(e,t,n,r){var i=me(t);if(!fe(t,i,r))if(pe(t,n,i,r)&&(n=null),r||null===i){if(de(t)){var o=t;null===n?e.removeAttribute(o):(X(n,t),e.setAttribute(o,""+n));}}else if(i.mustUseProperty){var a=i.propertyName;if(null===n){var s=i.type;e[a]=s!==ne&&"";}else e[a]=n;}else {var u=i.attributeName,l=i.attributeNamespace;if(null===n)e.removeAttribute(u);else {var c,d=i.type;d===ne||d===re&&true===n?c="":(X(n,u),c=""+n,i.sanitizeURL&&Se(c.toString())),l?e.setAttributeNS(l,u,c):e.setAttribute(u,c);}}}var Ce=Symbol.for("react.element"),xe=Symbol.for("react.portal"),Ae=Symbol.for("react.fragment"),Re=Symbol.for("react.strict_mode"),Te=Symbol.for("react.profiler"),Pe=Symbol.for("react.provider"),Le=Symbol.for("react.context"),Ie=Symbol.for("react.forward_ref"),Oe=Symbol.for("react.suspense"),Ne=Symbol.for("react.suspense_list"),De=Symbol.for("react.memo"),je=Symbol.for("react.lazy"),Be=(Symbol.for("react.offscreen")),ze=(Symbol.iterator),Ue="@@iterator";function Fe(e){if(null===e||"object"!=typeof e)return null;var t=ze&&e[ze]||e[Ue];return "function"==typeof t?t:null}var Ke,qe,He,We,$e,Ve,Ye,Ge=Object.assign,Ze=0;function Qe(){}Qe.__reactDisabledLog=true;var Je,Xe=n.ReactCurrentDispatcher;function et(e,t,n){if(void 0===Je)try{throw Error()}catch(e){var r=e.stack.trim().match(/\n( *(at )?)/);Je=r&&r[1]||"";}return "\n"+Je+e}var tt,nt=false,rt="function"==typeof WeakMap?WeakMap:Map;function it(e,t){if(!e||nt)return "";var n,r=tt.get(e);if(void 0!==r)return r;nt=true;var i,a=Error.prepareStackTrace;Error.prepareStackTrace=void 0,i=Xe.current,Xe.current=null,function(){if(0===Ze){Ke=console.log,qe=console.info,He=console.warn,We=console.error,$e=console.group,Ve=console.groupCollapsed,Ye=console.groupEnd;var e={configurable:true,enumerable:true,value:Qe,writable:true};Object.defineProperties(console,{info:e,log:e,warn:e,error:e,group:e,groupCollapsed:e,groupEnd:e});}Ze++;}();try{if(t){var s=function(){throw Error()};if(Object.defineProperty(s.prototype,"props",{set:function(){throw Error()}}),"object"==typeof Reflect&&Reflect.construct){try{Reflect.construct(s,[]);}catch(e){n=e;}Reflect.construct(e,[],s);}else {try{s.call();}catch(e){n=e;}e.call(s.prototype);}}else {try{throw Error()}catch(e){n=e;}e();}}catch(t){if(t&&n&&"string"==typeof t.stack){for(var u=t.stack.split("\n"),l=n.stack.split("\n"),c=u.length-1,d=l.length-1;c>=1&&d>=0&&u[c]!==l[d];)d--;for(;c>=1&&d>=0;c--,d--)if(u[c]!==l[d]){if(1!==c||1!==d)do{if(c--,--d<0||u[c]!==l[d]){var f="\n"+u[c].replace(" at new "," at ");return e.displayName&&f.includes("<anonymous>")&&(f=f.replace("<anonymous>",e.displayName)),"function"==typeof e&&tt.set(e,f),f}}while(c>=1&&d>=0);break}}}finally{nt=false,Xe.current=i,function(){if(0==--Ze){var e={configurable:true,enumerable:true,writable:true};Object.defineProperties(console,{log:Ge({},e,{value:Ke}),info:Ge({},e,{value:qe}),warn:Ge({},e,{value:He}),error:Ge({},e,{value:We}),group:Ge({},e,{value:$e}),groupCollapsed:Ge({},e,{value:Ve}),groupEnd:Ge({},e,{value:Ye})});}Ze<0&&o("disabledDepth fell below zero. This is a bug in React. Please file an issue.");}(),Error.prepareStackTrace=a;}var h=e?e.displayName||e.name:"",p=h?et(h):"";return "function"==typeof e&&tt.set(e,p),p}function ot(e,t,n){return it(e,false)}function at(e,t,n){if(null==e)return "";if("function"==typeof e)return it(e,!(!(r=e.prototype)||!r.isReactComponent));var r;if("string"==typeof e)return et(e);switch(e){case Oe:return et("Suspense");case Ne:return et("SuspenseList")}if("object"==typeof e)switch(e.$$typeof){case Ie:return ot(e.render);case De:return at(e.type,t,n);case je:var i=e,o=i._payload,a=i._init;try{return at(a(o),t,n)}catch(e){}}return ""}function st(e){switch(e._debugOwner&&e._debugOwner.type,e._debugSource,e.tag){case f:return et(e.type);case E:return et("Lazy");case w:return et("Suspense");case C:return et("SuspenseList");case s:case l:case S:return ot(e.type);case b:return ot(e.type.render);case u:return it(e.type,true);default:return ""}}function ut(e){try{var t="",n=e;do{t+=st(n),n=n.return;}while(n);return t}catch(e){return "\nError generating stack: "+e.message+"\n"+e.stack}}function lt(e){return e.displayName||"Context"}function ct(e){if(null==e)return null;if("number"==typeof e.tag&&o("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."),"function"==typeof e)return e.displayName||e.name||null;if("string"==typeof e)return e;switch(e){case Ae:return "Fragment";case xe:return "Portal";case Te:return "Profiler";case Re:return "StrictMode";case Oe:return "Suspense";case Ne:return "SuspenseList"}if("object"==typeof e)switch(e.$$typeof){case Le:return lt(e)+".Consumer";case Pe:return lt(e._context)+".Provider";case Ie:return function(e,t,n){var r=e.displayName;if(r)return r;var i=t.displayName||t.name||"";return ""!==i?n+"("+i+")":n}(e,e.render,"ForwardRef");case De:var t=e.displayName||null;return null!==t?t:ct(e.type)||"Memo";case je:var n=e,r=n._payload,i=n._init;try{return ct(i(r))}catch(e){return null}}return null}function dt(e){return e.displayName||"Context"}function ft(e){var t,n,r,i,o=e.tag,a=e.type;switch(o){case T:return "Cache";case g:return dt(a)+".Consumer";case v:return dt(a._context)+".Provider";case M:return "DehydratedFragment";case b:return t=a,n=a.render,r="ForwardRef",i=n.displayName||n.name||"",t.displayName||(""!==i?r+"("+i+")":r);case p:return "Fragment";case f:return a;case d:return "Portal";case c:return "Root";case h:return "Text";case E:return ct(a);case m:return a===Re?"StrictMode":"Mode";case A:return "Offscreen";case y:return "Profiler";case x:return "Scope";case w:return "Suspense";case C:return "SuspenseList";case P:return "TracingMarker";case u:case s:case k:case l:case _:case S:if("function"==typeof a)return a.displayName||a.name||null;if("string"==typeof a)return a}return null}tt=new rt;var ht=n.ReactDebugCurrentFrame,pt=null,mt=false;function gt(){if(null===pt)return null;var e=pt._debugOwner;return null!=e?ft(e):null}function vt(){return null===pt?"":ut(pt)}function bt(){ht.getCurrentStack=null,pt=null,mt=false;}function yt(e){ht.getCurrentStack=null===e?null:vt,pt=e,mt=false;}function wt(e){mt=e;}function _t(e){return ""+e}function St(e){switch(typeof e){case "boolean":case "number":case "string":case "undefined":return e;case "object":return ee(e),e;default:return ""}}var Et={button:true,checkbox:true,image:true,hidden:true,radio:true,reset:true,submit:true};function kt(e,t){Et[t.type]||t.onChange||t.onInput||t.readOnly||t.disabled||null==t.value||o("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."),t.onChange||t.readOnly||t.disabled||null==t.checked||o("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");}function Mt(e){var t=e.type,n=e.nodeName;return n&&"input"===n.toLowerCase()&&("checkbox"===t||"radio"===t)}function Ct(e){return e._valueTracker}function xt(e){Ct(e)||(e._valueTracker=function(e){var t=Mt(e)?"checked":"value",n=Object.getOwnPropertyDescriptor(e.constructor.prototype,t);ee(e[t]);var r=""+e[t];if(!e.hasOwnProperty(t)&&void 0!==n&&"function"==typeof n.get&&"function"==typeof n.set){var i=n.get,o=n.set;Object.defineProperty(e,t,{configurable:true,get:function(){return i.call(this)},set:function(e){ee(e),r=""+e,o.call(this,e);}}),Object.defineProperty(e,t,{enumerable:n.enumerable});var a={getValue:function(){return r},setValue:function(e){ee(e),r=""+e;},stopTracking:function(){!function(e){e._valueTracker=null;}(e),delete e[t];}};return a}}(e));}function At(e){if(!e)return  false;var t=Ct(e);if(!t)return  true;var n=t.getValue(),r=function(e){var t="";return e?t=Mt(e)?e.checked?"true":"false":e.value:t}(e);return r!==n&&(t.setValue(r),true)}function Rt(e){if(void 0===(e=e||("undefined"!=typeof document?document:void 0)))return null;try{return e.activeElement||e.body}catch(t){return e.body}}var Tt=false,Pt=false,Lt=false,It=false;function Ot(e){return "checkbox"===e.type||"radio"===e.type?null!=e.checked:null!=e.value}function Nt(e,t){var n=e,r=t.checked;return Ge({},t,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=r?r:n._wrapperState.initialChecked})}function Dt(e,t){kt(0,t),void 0===t.checked||void 0===t.defaultChecked||Pt||(o("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components",gt()||"A component",t.type),Pt=true),void 0===t.value||void 0===t.defaultValue||Tt||(o("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components",gt()||"A component",t.type),Tt=true);var n=e,r=null==t.defaultValue?"":t.defaultValue;n._wrapperState={initialChecked:null!=t.checked?t.checked:t.defaultChecked,initialValue:St(null!=t.value?t.value:r),controlled:Ot(t)};}function jt(e,t){var n=e,r=t.checked;null!=r&&Me(n,"checked",r,false);}function Bt(e,t){var n=e,r=Ot(t);n._wrapperState.controlled||!r||It||(o("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"),It=true),!n._wrapperState.controlled||r||Lt||(o("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"),Lt=true),jt(e,t);var i=St(t.value),a=t.type;if(null!=i)"number"===a?(0===i&&""===n.value||n.value!=i)&&(n.value=_t(i)):n.value!==_t(i)&&(n.value=_t(i));else if("submit"===a||"reset"===a)return void n.removeAttribute("value");t.hasOwnProperty("value")?Ft(n,t.type,i):t.hasOwnProperty("defaultValue")&&Ft(n,t.type,St(t.defaultValue)),null==t.checked&&null!=t.defaultChecked&&(n.defaultChecked=!!t.defaultChecked);}function zt(e,t,n){var r=e;if(t.hasOwnProperty("value")||t.hasOwnProperty("defaultValue")){var i=t.type;if(("submit"===i||"reset"===i)&&(void 0===t.value||null===t.value))return;var o=_t(r._wrapperState.initialValue);n||o!==r.value&&(r.value=o),r.defaultValue=o;}var a=r.name;""!==a&&(r.name=""),r.defaultChecked=!r.defaultChecked,r.defaultChecked=!!r._wrapperState.initialChecked,""!==a&&(r.name=a);}function Ut(e,t){var n=e;Bt(n,t),function(e,t){var n=t.name;if("radio"===t.type&&null!=n){for(var r=e;r.parentNode;)r=r.parentNode;X(n,"name");for(var i=r.querySelectorAll("input[name="+JSON.stringify(""+n)+'][type="radio"]'),o=0;o<i.length;o++){var a=i[o];if(a!==e&&a.form===e.form){var s=Gc(a);if(!s)throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");At(a),Bt(a,s);}}}}(n,t);}function Ft(e,t,n){"number"===t&&Rt(e.ownerDocument)===e||(null==n?e.defaultValue=_t(e._wrapperState.initialValue):e.defaultValue!==_t(n)&&(e.defaultValue=_t(n)));}var Kt=false,qt=false,Ht=false;function Wt(t,n){null==n.value&&("object"==typeof n.children&&null!==n.children?e.Children.forEach(n.children,(function(e){null!=e&&"string"!=typeof e&&"number"!=typeof e&&(qt||(qt=true,o("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));})):null!=n.dangerouslySetInnerHTML&&(Ht||(Ht=true,o("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))),null==n.selected||Kt||(o("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."),Kt=true);}var $t,Vt=Array.isArray;function Yt(e){return Vt(e)}function Gt(){var e=gt();return e?"\n\nCheck the render method of `"+e+"`.":""}$t=false;var Zt=["value","defaultValue"];function Qt(e,t,n,r){var i=e.options;if(t){for(var o=n,a={},s=0;s<o.length;s++)a["$"+o[s]]=true;for(var u=0;u<i.length;u++){var l=a.hasOwnProperty("$"+i[u].value);i[u].selected!==l&&(i[u].selected=l),l&&r&&(i[u].defaultSelected=true);}}else {for(var c=_t(St(n)),d=null,f=0;f<i.length;f++){if(i[f].value===c)return i[f].selected=true,void(r&&(i[f].defaultSelected=true));null!==d||i[f].disabled||(d=i[f]);}null!==d&&(d.selected=true);}}function Jt(e,t){return Ge({},t,{value:void 0})}function Xt(e,t){var n=e;!function(e){kt(0,e);for(var t=0;t<Zt.length;t++){var n=Zt[t];if(null!=e[n]){var r=Yt(e[n]);e.multiple&&!r?o("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",n,Gt()):!e.multiple&&r&&o("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",n,Gt());}}}(t),n._wrapperState={wasMultiple:!!t.multiple},void 0===t.value||void 0===t.defaultValue||$t||(o("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"),$t=true);}var en=false;function tn(e,t){var n=e;if(null!=t.dangerouslySetInnerHTML)throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");return Ge({},t,{value:void 0,defaultValue:void 0,children:_t(n._wrapperState.initialValue)})}function nn(e,t){var n=e;kt(0,t),void 0===t.value||void 0===t.defaultValue||en||(o("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components",gt()||"A component"),en=true);var r=t.value;if(null==r){var i=t.children,a=t.defaultValue;if(null!=i){if(o("Use the `defaultValue` or `value` props instead of setting children on <textarea>."),null!=a)throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");if(Yt(i)){if(i.length>1)throw new Error("<textarea> can only have at most one child.");i=i[0];}a=i;}null==a&&(a=""),r=a;}n._wrapperState={initialValue:St(r)};}function rn(e,t){var n=e,r=St(t.value),i=St(t.defaultValue);if(null!=r){var o=_t(r);o!==n.value&&(n.value=o),null==t.defaultValue&&n.defaultValue!==o&&(n.defaultValue=o);}null!=i&&(n.defaultValue=_t(i));}function on(e,t){var n=e,r=n.textContent;r===n._wrapperState.initialValue&&""!==r&&null!==r&&(n.value=r);}var an="http://www.w3.org/1999/xhtml",sn="http://www.w3.org/1998/Math/MathML",un="http://www.w3.org/2000/svg";function ln(e){switch(e){case "svg":return un;case "math":return sn;default:return an}}function cn(e,t){return null==e||e===an?ln(t):e===un&&"foreignObject"===t?an:e}var dn,fn,hn=(fn=function(e,t){if(e.namespaceURI!==un||"innerHTML"in e)e.innerHTML=t;else {(dn=dn||document.createElement("div")).innerHTML="<svg>"+t.valueOf().toString()+"</svg>";for(var n=dn.firstChild;e.firstChild;)e.removeChild(e.firstChild);for(;n.firstChild;)e.appendChild(n.firstChild);}},"undefined"!=typeof MSApp&&MSApp.execUnsafeLocalFunction?function(e,t,n,r){MSApp.execUnsafeLocalFunction((function(){return fn(e,t,n,r)}));}:fn),pn=1,mn=3,gn=8,vn=9,bn=11,yn=function(e,t){if(t){var n=e.firstChild;if(n&&n===e.lastChild&&n.nodeType===mn)return void(n.nodeValue=t)}e.textContent=t;},wn={animation:["animationDelay","animationDirection","animationDuration","animationFillMode","animationIterationCount","animationName","animationPlayState","animationTimingFunction"],background:["backgroundAttachment","backgroundClip","backgroundColor","backgroundImage","backgroundOrigin","backgroundPositionX","backgroundPositionY","backgroundRepeat","backgroundSize"],backgroundPosition:["backgroundPositionX","backgroundPositionY"],border:["borderBottomColor","borderBottomStyle","borderBottomWidth","borderImageOutset","borderImageRepeat","borderImageSlice","borderImageSource","borderImageWidth","borderLeftColor","borderLeftStyle","borderLeftWidth","borderRightColor","borderRightStyle","borderRightWidth","borderTopColor","borderTopStyle","borderTopWidth"],borderBlockEnd:["borderBlockEndColor","borderBlockEndStyle","borderBlockEndWidth"],borderBlockStart:["borderBlockStartColor","borderBlockStartStyle","borderBlockStartWidth"],borderBottom:["borderBottomColor","borderBottomStyle","borderBottomWidth"],borderColor:["borderBottomColor","borderLeftColor","borderRightColor","borderTopColor"],borderImage:["borderImageOutset","borderImageRepeat","borderImageSlice","borderImageSource","borderImageWidth"],borderInlineEnd:["borderInlineEndColor","borderInlineEndStyle","borderInlineEndWidth"],borderInlineStart:["borderInlineStartColor","borderInlineStartStyle","borderInlineStartWidth"],borderLeft:["borderLeftColor","borderLeftStyle","borderLeftWidth"],borderRadius:["borderBottomLeftRadius","borderBottomRightRadius","borderTopLeftRadius","borderTopRightRadius"],borderRight:["borderRightColor","borderRightStyle","borderRightWidth"],borderStyle:["borderBottomStyle","borderLeftStyle","borderRightStyle","borderTopStyle"],borderTop:["borderTopColor","borderTopStyle","borderTopWidth"],borderWidth:["borderBottomWidth","borderLeftWidth","borderRightWidth","borderTopWidth"],columnRule:["columnRuleColor","columnRuleStyle","columnRuleWidth"],columns:["columnCount","columnWidth"],flex:["flexBasis","flexGrow","flexShrink"],flexFlow:["flexDirection","flexWrap"],font:["fontFamily","fontFeatureSettings","fontKerning","fontLanguageOverride","fontSize","fontSizeAdjust","fontStretch","fontStyle","fontVariant","fontVariantAlternates","fontVariantCaps","fontVariantEastAsian","fontVariantLigatures","fontVariantNumeric","fontVariantPosition","fontWeight","lineHeight"],fontVariant:["fontVariantAlternates","fontVariantCaps","fontVariantEastAsian","fontVariantLigatures","fontVariantNumeric","fontVariantPosition"],gap:["columnGap","rowGap"],grid:["gridAutoColumns","gridAutoFlow","gridAutoRows","gridTemplateAreas","gridTemplateColumns","gridTemplateRows"],gridArea:["gridColumnEnd","gridColumnStart","gridRowEnd","gridRowStart"],gridColumn:["gridColumnEnd","gridColumnStart"],gridColumnGap:["columnGap"],gridGap:["columnGap","rowGap"],gridRow:["gridRowEnd","gridRowStart"],gridRowGap:["rowGap"],gridTemplate:["gridTemplateAreas","gridTemplateColumns","gridTemplateRows"],listStyle:["listStyleImage","listStylePosition","listStyleType"],margin:["marginBottom","marginLeft","marginRight","marginTop"],marker:["markerEnd","markerMid","markerStart"],mask:["maskClip","maskComposite","maskImage","maskMode","maskOrigin","maskPositionX","maskPositionY","maskRepeat","maskSize"],maskPosition:["maskPositionX","maskPositionY"],outline:["outlineColor","outlineStyle","outlineWidth"],overflow:["overflowX","overflowY"],padding:["paddingBottom","paddingLeft","paddingRight","paddingTop"],placeContent:["alignContent","justifyContent"],placeItems:["alignItems","justifyItems"],placeSelf:["alignSelf","justifySelf"],textDecoration:["textDecorationColor","textDecorationLine","textDecorationStyle"],textEmphasis:["textEmphasisColor","textEmphasisStyle"],transition:["transitionDelay","transitionDuration","transitionProperty","transitionTimingFunction"],wordWrap:["overflowWrap"]},_n={animationIterationCount:true,aspectRatio:true,borderImageOutset:true,borderImageSlice:true,borderImageWidth:true,boxFlex:true,boxFlexGroup:true,boxOrdinalGroup:true,columnCount:true,columns:true,flex:true,flexGrow:true,flexPositive:true,flexShrink:true,flexNegative:true,flexOrder:true,gridArea:true,gridRow:true,gridRowEnd:true,gridRowSpan:true,gridRowStart:true,gridColumn:true,gridColumnEnd:true,gridColumnSpan:true,gridColumnStart:true,fontWeight:true,lineClamp:true,lineHeight:true,opacity:true,order:true,orphans:true,tabSize:true,widows:true,zIndex:true,zoom:true,fillOpacity:true,floodOpacity:true,stopOpacity:true,strokeDasharray:true,strokeDashoffset:true,strokeMiterlimit:true,strokeOpacity:true,strokeWidth:true};var Sn=["Webkit","ms","Moz","O"];function En(e,t,n){return null==t||"boolean"==typeof t||""===t?"":n||"number"!=typeof t||0===t||_n.hasOwnProperty(e)&&_n[e]?(function(e,t){if(Q(e))o("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.",t,Z(e));}(t,e),(""+t).trim()):t+"px"}Object.keys(_n).forEach((function(e){Sn.forEach((function(t){_n[function(e,t){return e+t.charAt(0).toUpperCase()+t.substring(1)}(t,e)]=_n[e];}));}));var kn=/([A-Z])/g,Mn=/^ms-/;function Cn(e){return e.replace(kn,"-$1").toLowerCase().replace(Mn,"-ms-")}var xn,An=/^(?:webkit|moz|o)[A-Z]/,Rn=/^-ms-/,Tn=/-(.)/g,Pn=/;\s*$/,Ln={},In={},On=false,Nn=false,Dn=function(e){Ln.hasOwnProperty(e)&&Ln[e]||(Ln[e]=true,o("Unsupported style property %s. Did you mean %s?",e,function(e){return e.replace(Tn,(function(e,t){return t.toUpperCase()}))}(e.replace(Rn,"ms-"))));};xn=function(e,t){e.indexOf("-")>-1?Dn(e):An.test(e)?function(e){Ln.hasOwnProperty(e)&&Ln[e]||(Ln[e]=true,o("Unsupported vendor-prefixed style property %s. Did you mean %s?",e,e.charAt(0).toUpperCase()+e.slice(1)));}(e):Pn.test(t)&&function(e,t){In.hasOwnProperty(t)&&In[t]||(In[t]=true,o('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.',e,t.replace(Pn,"")));}(e,t),"number"==typeof t&&(isNaN(t)?function(e,t){On||(On=true,o("`NaN` is an invalid value for the `%s` css style property.",e));}(e):isFinite(t)||function(e,t){Nn||(Nn=true,o("`Infinity` is an invalid value for the `%s` css style property.",e));}(e));};var jn=xn;function Bn(e){var t="",n="";for(var r in e)if(e.hasOwnProperty(r)){var i=e[r];if(null!=i){var o=0===r.indexOf("--");t+=n+(o?r:Cn(r))+":",t+=En(r,i,o),n=";";}}return t||null}function zn(e,t){var n=e.style;for(var r in t)if(t.hasOwnProperty(r)){var i=0===r.indexOf("--");i||jn(r,t[r]);var o=En(r,t[r],i);"float"===r&&(r="cssFloat"),i?n.setProperty(r,o):n[r]=o;}}function Un(e){return null==e||"boolean"==typeof e||""===e}function Fn(e){var t={};for(var n in e)for(var r=wn[n]||[n],i=0;i<r.length;i++)t[r[i]]=n;return t}var Kn=Ge({menuitem:true},{area:true,base:true,br:true,col:true,embed:true,hr:true,img:true,input:true,keygen:true,link:true,meta:true,param:true,source:true,track:true,wbr:true}),qn="__html";function Hn(e,t){if(t){if(Kn[e]&&(null!=t.children||null!=t.dangerouslySetInnerHTML))throw new Error(e+" is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");if(null!=t.dangerouslySetInnerHTML){if(null!=t.children)throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");if("object"!=typeof t.dangerouslySetInnerHTML||!(qn in t.dangerouslySetInnerHTML))throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.")}if(!t.suppressContentEditableWarning&&t.contentEditable&&null!=t.children&&o("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."),null!=t.style&&"object"!=typeof t.style)throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.")}}function Wn(e,t){if(-1===e.indexOf("-"))return "string"==typeof t.is;switch(e){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return  false;default:return  true}}var $n={accept:"accept",acceptcharset:"acceptCharset","accept-charset":"acceptCharset",accesskey:"accessKey",action:"action",allowfullscreen:"allowFullScreen",alt:"alt",as:"as",async:"async",autocapitalize:"autoCapitalize",autocomplete:"autoComplete",autocorrect:"autoCorrect",autofocus:"autoFocus",autoplay:"autoPlay",autosave:"autoSave",capture:"capture",cellpadding:"cellPadding",cellspacing:"cellSpacing",challenge:"challenge",charset:"charSet",checked:"checked",children:"children",cite:"cite",class:"className",classid:"classID",classname:"className",cols:"cols",colspan:"colSpan",content:"content",contenteditable:"contentEditable",contextmenu:"contextMenu",controls:"controls",controlslist:"controlsList",coords:"coords",crossorigin:"crossOrigin",dangerouslysetinnerhtml:"dangerouslySetInnerHTML",data:"data",datetime:"dateTime",default:"default",defaultchecked:"defaultChecked",defaultvalue:"defaultValue",defer:"defer",dir:"dir",disabled:"disabled",disablepictureinpicture:"disablePictureInPicture",disableremoteplayback:"disableRemotePlayback",download:"download",draggable:"draggable",enctype:"encType",enterkeyhint:"enterKeyHint",for:"htmlFor",form:"form",formmethod:"formMethod",formaction:"formAction",formenctype:"formEncType",formnovalidate:"formNoValidate",formtarget:"formTarget",frameborder:"frameBorder",headers:"headers",height:"height",hidden:"hidden",high:"high",href:"href",hreflang:"hrefLang",htmlfor:"htmlFor",httpequiv:"httpEquiv","http-equiv":"httpEquiv",icon:"icon",id:"id",imagesizes:"imageSizes",imagesrcset:"imageSrcSet",innerhtml:"innerHTML",inputmode:"inputMode",integrity:"integrity",is:"is",itemid:"itemID",itemprop:"itemProp",itemref:"itemRef",itemscope:"itemScope",itemtype:"itemType",keyparams:"keyParams",keytype:"keyType",kind:"kind",label:"label",lang:"lang",list:"list",loop:"loop",low:"low",manifest:"manifest",marginwidth:"marginWidth",marginheight:"marginHeight",max:"max",maxlength:"maxLength",media:"media",mediagroup:"mediaGroup",method:"method",min:"min",minlength:"minLength",multiple:"multiple",muted:"muted",name:"name",nomodule:"noModule",nonce:"nonce",novalidate:"noValidate",open:"open",optimum:"optimum",pattern:"pattern",placeholder:"placeholder",playsinline:"playsInline",poster:"poster",preload:"preload",profile:"profile",radiogroup:"radioGroup",readonly:"readOnly",referrerpolicy:"referrerPolicy",rel:"rel",required:"required",reversed:"reversed",role:"role",rows:"rows",rowspan:"rowSpan",sandbox:"sandbox",scope:"scope",scoped:"scoped",scrolling:"scrolling",seamless:"seamless",selected:"selected",shape:"shape",size:"size",sizes:"sizes",span:"span",spellcheck:"spellCheck",src:"src",srcdoc:"srcDoc",srclang:"srcLang",srcset:"srcSet",start:"start",step:"step",style:"style",summary:"summary",tabindex:"tabIndex",target:"target",title:"title",type:"type",usemap:"useMap",value:"value",width:"width",wmode:"wmode",wrap:"wrap",about:"about",accentheight:"accentHeight","accent-height":"accentHeight",accumulate:"accumulate",additive:"additive",alignmentbaseline:"alignmentBaseline","alignment-baseline":"alignmentBaseline",allowreorder:"allowReorder",alphabetic:"alphabetic",amplitude:"amplitude",arabicform:"arabicForm","arabic-form":"arabicForm",ascent:"ascent",attributename:"attributeName",attributetype:"attributeType",autoreverse:"autoReverse",azimuth:"azimuth",basefrequency:"baseFrequency",baselineshift:"baselineShift","baseline-shift":"baselineShift",baseprofile:"baseProfile",bbox:"bbox",begin:"begin",bias:"bias",by:"by",calcmode:"calcMode",capheight:"capHeight","cap-height":"capHeight",clip:"clip",clippath:"clipPath","clip-path":"clipPath",clippathunits:"clipPathUnits",cliprule:"clipRule","clip-rule":"clipRule",color:"color",colorinterpolation:"colorInterpolation","color-interpolation":"colorInterpolation",colorinterpolationfilters:"colorInterpolationFilters","color-interpolation-filters":"colorInterpolationFilters",colorprofile:"colorProfile","color-profile":"colorProfile",colorrendering:"colorRendering","color-rendering":"colorRendering",contentscripttype:"contentScriptType",contentstyletype:"contentStyleType",cursor:"cursor",cx:"cx",cy:"cy",d:"d",datatype:"datatype",decelerate:"decelerate",descent:"descent",diffuseconstant:"diffuseConstant",direction:"direction",display:"display",divisor:"divisor",dominantbaseline:"dominantBaseline","dominant-baseline":"dominantBaseline",dur:"dur",dx:"dx",dy:"dy",edgemode:"edgeMode",elevation:"elevation",enablebackground:"enableBackground","enable-background":"enableBackground",end:"end",exponent:"exponent",externalresourcesrequired:"externalResourcesRequired",fill:"fill",fillopacity:"fillOpacity","fill-opacity":"fillOpacity",fillrule:"fillRule","fill-rule":"fillRule",filter:"filter",filterres:"filterRes",filterunits:"filterUnits",floodopacity:"floodOpacity","flood-opacity":"floodOpacity",floodcolor:"floodColor","flood-color":"floodColor",focusable:"focusable",fontfamily:"fontFamily","font-family":"fontFamily",fontsize:"fontSize","font-size":"fontSize",fontsizeadjust:"fontSizeAdjust","font-size-adjust":"fontSizeAdjust",fontstretch:"fontStretch","font-stretch":"fontStretch",fontstyle:"fontStyle","font-style":"fontStyle",fontvariant:"fontVariant","font-variant":"fontVariant",fontweight:"fontWeight","font-weight":"fontWeight",format:"format",from:"from",fx:"fx",fy:"fy",g1:"g1",g2:"g2",glyphname:"glyphName","glyph-name":"glyphName",glyphorientationhorizontal:"glyphOrientationHorizontal","glyph-orientation-horizontal":"glyphOrientationHorizontal",glyphorientationvertical:"glyphOrientationVertical","glyph-orientation-vertical":"glyphOrientationVertical",glyphref:"glyphRef",gradienttransform:"gradientTransform",gradientunits:"gradientUnits",hanging:"hanging",horizadvx:"horizAdvX","horiz-adv-x":"horizAdvX",horizoriginx:"horizOriginX","horiz-origin-x":"horizOriginX",ideographic:"ideographic",imagerendering:"imageRendering","image-rendering":"imageRendering",in2:"in2",in:"in",inlist:"inlist",intercept:"intercept",k1:"k1",k2:"k2",k3:"k3",k4:"k4",k:"k",kernelmatrix:"kernelMatrix",kernelunitlength:"kernelUnitLength",kerning:"kerning",keypoints:"keyPoints",keysplines:"keySplines",keytimes:"keyTimes",lengthadjust:"lengthAdjust",letterspacing:"letterSpacing","letter-spacing":"letterSpacing",lightingcolor:"lightingColor","lighting-color":"lightingColor",limitingconeangle:"limitingConeAngle",local:"local",markerend:"markerEnd","marker-end":"markerEnd",markerheight:"markerHeight",markermid:"markerMid","marker-mid":"markerMid",markerstart:"markerStart","marker-start":"markerStart",markerunits:"markerUnits",markerwidth:"markerWidth",mask:"mask",maskcontentunits:"maskContentUnits",maskunits:"maskUnits",mathematical:"mathematical",mode:"mode",numoctaves:"numOctaves",offset:"offset",opacity:"opacity",operator:"operator",order:"order",orient:"orient",orientation:"orientation",origin:"origin",overflow:"overflow",overlineposition:"overlinePosition","overline-position":"overlinePosition",overlinethickness:"overlineThickness","overline-thickness":"overlineThickness",paintorder:"paintOrder","paint-order":"paintOrder",panose1:"panose1","panose-1":"panose1",pathlength:"pathLength",patterncontentunits:"patternContentUnits",patterntransform:"patternTransform",patternunits:"patternUnits",pointerevents:"pointerEvents","pointer-events":"pointerEvents",points:"points",pointsatx:"pointsAtX",pointsaty:"pointsAtY",pointsatz:"pointsAtZ",prefix:"prefix",preservealpha:"preserveAlpha",preserveaspectratio:"preserveAspectRatio",primitiveunits:"primitiveUnits",property:"property",r:"r",radius:"radius",refx:"refX",refy:"refY",renderingintent:"renderingIntent","rendering-intent":"renderingIntent",repeatcount:"repeatCount",repeatdur:"repeatDur",requiredextensions:"requiredExtensions",requiredfeatures:"requiredFeatures",resource:"resource",restart:"restart",result:"result",results:"results",rotate:"rotate",rx:"rx",ry:"ry",scale:"scale",security:"security",seed:"seed",shaperendering:"shapeRendering","shape-rendering":"shapeRendering",slope:"slope",spacing:"spacing",specularconstant:"specularConstant",specularexponent:"specularExponent",speed:"speed",spreadmethod:"spreadMethod",startoffset:"startOffset",stddeviation:"stdDeviation",stemh:"stemh",stemv:"stemv",stitchtiles:"stitchTiles",stopcolor:"stopColor","stop-color":"stopColor",stopopacity:"stopOpacity","stop-opacity":"stopOpacity",strikethroughposition:"strikethroughPosition","strikethrough-position":"strikethroughPosition",strikethroughthickness:"strikethroughThickness","strikethrough-thickness":"strikethroughThickness",string:"string",stroke:"stroke",strokedasharray:"strokeDasharray","stroke-dasharray":"strokeDasharray",strokedashoffset:"strokeDashoffset","stroke-dashoffset":"strokeDashoffset",strokelinecap:"strokeLinecap","stroke-linecap":"strokeLinecap",strokelinejoin:"strokeLinejoin","stroke-linejoin":"strokeLinejoin",strokemiterlimit:"strokeMiterlimit","stroke-miterlimit":"strokeMiterlimit",strokewidth:"strokeWidth","stroke-width":"strokeWidth",strokeopacity:"strokeOpacity","stroke-opacity":"strokeOpacity",suppresscontenteditablewarning:"suppressContentEditableWarning",suppresshydrationwarning:"suppressHydrationWarning",surfacescale:"surfaceScale",systemlanguage:"systemLanguage",tablevalues:"tableValues",targetx:"targetX",targety:"targetY",textanchor:"textAnchor","text-anchor":"textAnchor",textdecoration:"textDecoration","text-decoration":"textDecoration",textlength:"textLength",textrendering:"textRendering","text-rendering":"textRendering",to:"to",transform:"transform",typeof:"typeof",u1:"u1",u2:"u2",underlineposition:"underlinePosition","underline-position":"underlinePosition",underlinethickness:"underlineThickness","underline-thickness":"underlineThickness",unicode:"unicode",unicodebidi:"unicodeBidi","unicode-bidi":"unicodeBidi",unicoderange:"unicodeRange","unicode-range":"unicodeRange",unitsperem:"unitsPerEm","units-per-em":"unitsPerEm",unselectable:"unselectable",valphabetic:"vAlphabetic","v-alphabetic":"vAlphabetic",values:"values",vectoreffect:"vectorEffect","vector-effect":"vectorEffect",version:"version",vertadvy:"vertAdvY","vert-adv-y":"vertAdvY",vertoriginx:"vertOriginX","vert-origin-x":"vertOriginX",vertoriginy:"vertOriginY","vert-origin-y":"vertOriginY",vhanging:"vHanging","v-hanging":"vHanging",videographic:"vIdeographic","v-ideographic":"vIdeographic",viewbox:"viewBox",viewtarget:"viewTarget",visibility:"visibility",vmathematical:"vMathematical","v-mathematical":"vMathematical",vocab:"vocab",widths:"widths",wordspacing:"wordSpacing","word-spacing":"wordSpacing",writingmode:"writingMode","writing-mode":"writingMode",x1:"x1",x2:"x2",x:"x",xchannelselector:"xChannelSelector",xheight:"xHeight","x-height":"xHeight",xlinkactuate:"xlinkActuate","xlink:actuate":"xlinkActuate",xlinkarcrole:"xlinkArcrole","xlink:arcrole":"xlinkArcrole",xlinkhref:"xlinkHref","xlink:href":"xlinkHref",xlinkrole:"xlinkRole","xlink:role":"xlinkRole",xlinkshow:"xlinkShow","xlink:show":"xlinkShow",xlinktitle:"xlinkTitle","xlink:title":"xlinkTitle",xlinktype:"xlinkType","xlink:type":"xlinkType",xmlbase:"xmlBase","xml:base":"xmlBase",xmllang:"xmlLang","xml:lang":"xmlLang",xmlns:"xmlns","xml:space":"xmlSpace",xmlnsxlink:"xmlnsXlink","xmlns:xlink":"xmlnsXlink",xmlspace:"xmlSpace",y1:"y1",y2:"y2",y:"y",ychannelselector:"yChannelSelector",z:"z",zoomandpan:"zoomAndPan"},Vn={"aria-current":0,"aria-description":0,"aria-details":0,"aria-disabled":0,"aria-hidden":0,"aria-invalid":0,"aria-keyshortcuts":0,"aria-label":0,"aria-roledescription":0,"aria-autocomplete":0,"aria-checked":0,"aria-expanded":0,"aria-haspopup":0,"aria-level":0,"aria-modal":0,"aria-multiline":0,"aria-multiselectable":0,"aria-orientation":0,"aria-placeholder":0,"aria-pressed":0,"aria-readonly":0,"aria-required":0,"aria-selected":0,"aria-sort":0,"aria-valuemax":0,"aria-valuemin":0,"aria-valuenow":0,"aria-valuetext":0,"aria-atomic":0,"aria-busy":0,"aria-live":0,"aria-relevant":0,"aria-dropeffect":0,"aria-grabbed":0,"aria-activedescendant":0,"aria-colcount":0,"aria-colindex":0,"aria-colspan":0,"aria-controls":0,"aria-describedby":0,"aria-errormessage":0,"aria-flowto":0,"aria-labelledby":0,"aria-owns":0,"aria-posinset":0,"aria-rowcount":0,"aria-rowindex":0,"aria-rowspan":0,"aria-setsize":0},Yn={},Gn=new RegExp("^(aria)-["+se+"]*$"),Zn=new RegExp("^(aria)[A-Z]["+se+"]*$");function Qn(e,t){if(G.call(Yn,t)&&Yn[t])return  true;if(Zn.test(t)){var n="aria-"+t.slice(4).toLowerCase(),r=Vn.hasOwnProperty(n)?n:null;if(null==r)return o("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",t),Yn[t]=true,true;if(t!==r)return o("Invalid ARIA attribute `%s`. Did you mean `%s`?",t,r),Yn[t]=true,true}if(Gn.test(t)){var i=t.toLowerCase(),a=Vn.hasOwnProperty(i)?i:null;if(null==a)return Yn[t]=true,false;if(t!==a)return o("Unknown ARIA attribute `%s`. Did you mean `%s`?",t,a),Yn[t]=true,true}return  true}function Jn(e,t){Wn(e,t)||function(e,t){var n=[];for(var r in t)Qn(0,r)||n.push(r);var i=n.map((function(e){return "`"+e+"`"})).join(", ");1===n.length?o("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props",i,e):n.length>1&&o("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props",i,e);}(e,t);}var Xn=false;var er,tr={},nr=/^on./,rr=/^on[^A-Z]/,ir=new RegExp("^(aria)-["+se+"]*$"),or=new RegExp("^(aria)[A-Z]["+se+"]*$");er=function(e,t,n,r){if(G.call(tr,t)&&tr[t])return  true;var i=t.toLowerCase();if("onfocusin"===i||"onfocusout"===i)return o("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."),tr[t]=true,true;if(null!=r){var a=r.registrationNameDependencies,s=r.possibleRegistrationNames;if(a.hasOwnProperty(t))return  true;var u=s.hasOwnProperty(i)?s[i]:null;if(null!=u)return o("Invalid event handler property `%s`. Did you mean `%s`?",t,u),tr[t]=true,true;if(nr.test(t))return o("Unknown event handler property `%s`. It will be ignored.",t),tr[t]=true,true}else if(nr.test(t))return rr.test(t)&&o("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",t),tr[t]=true,true;if(ir.test(t)||or.test(t))return  true;if("innerhtml"===i)return o("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."),tr[t]=true,true;if("aria"===i)return o("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."),tr[t]=true,true;if("is"===i&&null!=n&&"string"!=typeof n)return o("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",typeof n),tr[t]=true,true;if("number"==typeof n&&isNaN(n))return o("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",t),tr[t]=true,true;var l=me(t),c=null!==l&&l.type===te;if($n.hasOwnProperty(i)){var d=$n[i];if(d!==t)return o("Invalid DOM property `%s`. Did you mean `%s`?",t,d),tr[t]=true,true}else if(!c&&t!==i)return o("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",t,i),tr[t]=true,true;return "boolean"==typeof n&&he(t,n,l,false)?(n?o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',n,t,t,n,t):o('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',n,t,t,n,t,t,t),tr[t]=true,true):!!c||(he(t,n,l,false)?(tr[t]=true,false):("false"!==n&&"true"!==n||null===l||l.type!==ne||(o("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",n,t,"false"===n?"The browser will interpret it as a truthy value.":'Although this works, it will not work as expected if you pass the string "false".',t,n),tr[t]=true),true))};function ar(e,t,n){Wn(e,t)||function(e,t,n){var r=[];for(var i in t)er(0,i,t[i],n)||r.push(i);var a=r.map((function(e){return "`"+e+"`"})).join(", ");1===r.length?o("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ",a,e):r.length>1&&o("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ",a,e);}(e,t,n);}var sr=1,ur=2,lr=4,cr=sr|ur|lr,dr=null;function fr(e){var t=e.target||e.srcElement||window;return t.correspondingUseElement&&(t=t.correspondingUseElement),t.nodeType===mn?t.parentNode:t}var hr=null,pr=null,mr=null;function gr(e){var t=Vc(e);if(t){if("function"!=typeof hr)throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");var n=t.stateNode;if(n){var r=Gc(n);hr(t.stateNode,t.type,r);}}}function vr(e){pr?mr?mr.push(e):mr=[e]:pr=e;}function br(){if(pr){var e=pr,t=mr;if(pr=null,mr=null,gr(e),t)for(var n=0;n<t.length;n++)gr(t[n]);}}var yr=function(e,t){return e(t)},wr=function(){},_r=false;function Sr(){(null!==pr||null!==mr)&&(wr(),br());}function Er(e,t,n){if(_r)return e(t,n);_r=true;try{return yr(e,t,n)}finally{_r=false,Sr();}}function kr(e,t){var n=e.stateNode;if(null===n)return null;var r=Gc(n);if(null===r)return null;var i=r[t];if(function(e,t,n){switch(e){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":return !(!n.disabled||(r=t,"button"!==r&&"input"!==r&&"select"!==r&&"textarea"!==r));default:return  false}var r;}(t,e.type,r))return null;if(i&&"function"!=typeof i)throw new Error("Expected `"+t+"` listener to be a function, instead got a value of `"+typeof i+"` type.");return i}var Mr=false;if(Y)try{var Cr={};Object.defineProperty(Cr,"passive",{get:function(){Mr=!0;}}),window.addEventListener("test",Cr,Cr),window.removeEventListener("test",Cr,Cr);}catch(e){Mr=false;}function xr(e,t,n,r,i,o,a,s,u){var l=Array.prototype.slice.call(arguments,3);try{t.apply(n,l);}catch(e){this.onError(e);}}var Ar=xr;if("undefined"!=typeof window&&"function"==typeof window.dispatchEvent&&"undefined"!=typeof document&&"function"==typeof document.createEvent){var Rr=document.createElement("react");Ar=function(e,t,n,r,i,o,a,s,u){if("undefined"==typeof document||null===document)throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");var l=document.createEvent("Event"),c=false,d=true,f=window.event,h=Object.getOwnPropertyDescriptor(window,"event");function p(){Rr.removeEventListener(_,v,false),void 0!==window.event&&window.hasOwnProperty("event")&&(window.event=f);}var m,g=Array.prototype.slice.call(arguments,3);function v(){c=true,p(),t.apply(n,g),d=false;}var b=false,y=false;function w(e){if(m=e.error,b=true,null===m&&0===e.colno&&0===e.lineno&&(y=true),e.defaultPrevented&&null!=m&&"object"==typeof m)try{m._suppressLogging=!0;}catch(e){}}var _="react-"+(e||"invokeguardedcallback");if(window.addEventListener("error",w),Rr.addEventListener(_,v,false),l.initEvent(_,false,false),Rr.dispatchEvent(l),h&&Object.defineProperty(window,"event",h),c&&d&&(b?y&&(m=new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")):m=new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue."),this.onError(m)),window.removeEventListener("error",w),!c)return p(),xr.apply(this,arguments)};}var Tr=Ar,Pr=false,Lr=null,Ir=false,Or=null,Nr={onError:function(e){Pr=true,Lr=e;}};function Dr(e,t,n,r,i,o,a,s,u){Pr=false,Lr=null,Tr.apply(Nr,arguments);}function jr(){if(Pr){var e=Lr;return Pr=false,Lr=null,e}throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.")}function Br(e){return e._reactInternals}var zr=0,Ur=1,Fr=2,Kr=4,qr=16,Hr=32,Wr=64,$r=128,Vr=256,Yr=512,Gr=1024,Zr=2048,Qr=4096,Jr=8192,Xr=16384,ti=32767,ni=32768,ri=65536,ii=131072,oi=1048576,ai=2097152,si=4194304,ui=8388608,li=16777216,ci=33554432,di=Kr|Gr|0,fi=Fr|Kr|qr|Hr|Yr|Qr|Jr,hi=Kr|Wr|Yr|Jr,pi=Zr|qr,mi=si|ui|ai,gi=n.ReactCurrentOwner;function vi(e){var t=e,n=e;if(e.alternate)for(;t.return;)t=t.return;else {var r=t;do{((t=r).flags&(Fr|Qr))!==zr&&(n=t.return),r=t.return;}while(r)}return t.tag===c?n:null}function bi(e){if(e.tag===w){var t=e.memoizedState;if(null===t){var n=e.alternate;null!==n&&(t=n.memoizedState);}if(null!==t)return t.dehydrated}return null}function yi(e){return e.tag===c?e.stateNode.containerInfo:null}function wi(e){if(vi(e)!==e)throw new Error("Unable to find node on an unmounted component.")}function _i(e){var t=e.alternate;if(!t){var n=vi(e);if(null===n)throw new Error("Unable to find node on an unmounted component.");return n!==e?null:e}for(var r=e,i=t;;){var o=r.return;if(null===o)break;var a=o.alternate;if(null===a){var s=o.return;if(null!==s){r=i=s;continue}break}if(o.child===a.child){for(var u=o.child;u;){if(u===r)return wi(o),e;if(u===i)return wi(o),t;u=u.sibling;}throw new Error("Unable to find node on an unmounted component.")}if(r.return!==i.return)r=o,i=a;else {for(var l=false,d=o.child;d;){if(d===r){l=true,r=o,i=a;break}if(d===i){l=true,i=o,r=a;break}d=d.sibling;}if(!l){for(d=a.child;d;){if(d===r){l=true,r=a,i=o;break}if(d===i){l=true,i=a,r=o;break}d=d.sibling;}if(!l)throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.")}}if(r.alternate!==i)throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.")}if(r.tag!==c)throw new Error("Unable to find node on an unmounted component.");return r.stateNode.current===r?e:t}function Si(e){var t=_i(e);return null!==t?Ei(t):null}function Ei(e){if(e.tag===f||e.tag===h)return e;for(var t=e.child;null!==t;){var n=Ei(t);if(null!==n)return n;t=t.sibling;}return null}function ki(e){var t=_i(e);return null!==t?Mi(t):null}function Mi(e){if(e.tag===f||e.tag===h)return e;for(var t=e.child;null!==t;){if(t.tag!==d){var n=Mi(t);if(null!==n)return n}t=t.sibling;}return null}var Ci=t.unstable_scheduleCallback,xi=t.unstable_cancelCallback,Ai=t.unstable_shouldYield,Ri=t.unstable_requestPaint,Ti=t.unstable_now,Pi=t.unstable_getCurrentPriorityLevel,Li=t.unstable_ImmediatePriority,Ii=t.unstable_UserBlockingPriority,Oi=t.unstable_NormalPriority,Ni=t.unstable_LowPriority,Di=t.unstable_IdlePriority,ji=t.unstable_yieldValue,Bi=t.unstable_setDisableYieldValue,zi=null,Ui=null,Fi=null,Ki=false,qi="undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;function Hi(e){if("function"==typeof ji&&(Bi(e),r=e),Ui&&"function"==typeof Ui.setStrictMode)try{Ui.setStrictMode(zi,e);}catch(e){Ki||(Ki=true,o("React instrumentation encountered an error: %s",e));}}function Wi(e){Fi=e;}function $i(){for(var e=new Map,t=1,n=0;n<ho;n++){var r=Qo(t);e.set(t,r),t*=2;}return e}function Vi(){null!==Fi&&"function"==typeof Fi.markCommitStopped&&Fi.markCommitStopped();}function Yi(e){null!==Fi&&"function"==typeof Fi.markComponentRenderStarted&&Fi.markComponentRenderStarted(e);}function Gi(){null!==Fi&&"function"==typeof Fi.markComponentRenderStopped&&Fi.markComponentRenderStopped();}function Zi(e){null!==Fi&&"function"==typeof Fi.markComponentLayoutEffectMountStarted&&Fi.markComponentLayoutEffectMountStarted(e);}function Qi(e){null!==Fi&&"function"==typeof Fi.markComponentLayoutEffectUnmountStarted&&Fi.markComponentLayoutEffectUnmountStarted(e);}function Ji(){null!==Fi&&"function"==typeof Fi.markComponentLayoutEffectUnmountStopped&&Fi.markComponentLayoutEffectUnmountStopped();}function Xi(e,t,n){null!==Fi&&"function"==typeof Fi.markComponentErrored&&Fi.markComponentErrored(e,t,n);}function eo(e,t,n){null!==Fi&&"function"==typeof Fi.markComponentSuspended&&Fi.markComponentSuspended(e,t,n);}function to(e){null!==Fi&&"function"==typeof Fi.markRenderStarted&&Fi.markRenderStarted(e);}function no(){null!==Fi&&"function"==typeof Fi.markRenderStopped&&Fi.markRenderStopped();}function ro(e,t){null!==Fi&&"function"==typeof Fi.markStateUpdateScheduled&&Fi.markStateUpdateScheduled(e,t);}var io=0,oo=1,ao=2,so=8,uo=16,lo=Math.clz32?Math.clz32:function(e){var t=e>>>0;if(0===t)return 32;return 31-(co(t)/fo|0)|0},co=Math.log,fo=Math.LN2;var ho=31,po=0,mo=0,go=1,vo=2,bo=4,yo=8,wo=16,_o=32,So=4194240,Eo=64,ko=128,Mo=256,Co=512,xo=1024,Ao=2048,Ro=4096,To=8192,Po=16384,Lo=32768,Io=65536,Oo=131072,No=262144,Do=524288,jo=1048576,Bo=2097152,zo=130023424,Uo=4194304,Fo=8388608,Ko=16777216,qo=33554432,Ho=67108864,Wo=Uo,$o=134217728,Vo=268435455,Yo=268435456,Go=536870912,Zo=1073741824;function Qo(e){return e&go?"Sync":e&vo?"InputContinuousHydration":e&bo?"InputContinuous":e&yo?"DefaultHydration":e&wo?"Default":e&_o?"TransitionHydration":e&So?"Transition":e&zo?"Retry":e&$o?"SelectiveHydration":e&Yo?"IdleHydration":e&Go?"Idle":e&Zo?"Offscreen":void 0}var Jo=-1,Xo=Eo,ea=Uo;function ta(e){switch(ca(e)){case go:return go;case vo:return vo;case bo:return bo;case yo:return yo;case wo:return wo;case _o:return _o;case Eo:case ko:case Mo:case Co:case xo:case Ao:case Ro:case To:case Po:case Lo:case Io:case Oo:case No:case Do:case jo:case Bo:return e&So;case Uo:case Fo:case Ko:case qo:case Ho:return e&zo;case $o:return $o;case Yo:return Yo;case Go:return Go;case Zo:return Zo;default:return o("Should have found matching lanes. This is a bug in React."),e}}function na(e,t){var n=e.pendingLanes;if(n===po)return po;var r=po,i=e.suspendedLanes,o=e.pingedLanes,a=n&Vo;if(a!==po){var s=a&~i;if(s!==po)r=ta(s);else {var u=a&o;u!==po&&(r=ta(u));}}else {var l=n&~i;l!==po?r=ta(l):o!==po&&(r=ta(o));}if(r===po)return po;if(t!==po&&t!==r&&(t&i)===po){var c=ca(r),d=ca(t);if(c>=d||c===wo&&(d&So)!==po)return t}(r&bo)!==po&&(r|=n&wo);var f=e.entangledLanes;if(f!==po)for(var h=e.entanglements,p=r&f;p>0;){var m=fa(p),g=1<<m;r|=h[m],p&=~g;}return r}function ra(e,t){switch(e){case go:case vo:case bo:return t+250;case yo:case wo:case _o:case Eo:case ko:case Mo:case Co:case xo:case Ao:case Ro:case To:case Po:case Lo:case Io:case Oo:case No:case Do:case jo:case Bo:return t+5e3;case Uo:case Fo:case Ko:case qo:case Ho:case $o:case Yo:case Go:case Zo:return Jo;default:return o("Should have found matching lanes. This is a bug in React."),Jo}}function ia(e){var t=e.pendingLanes&-1073741825;return t!==po?t:t&Zo?Zo:po}function oa(e){return (e&Vo)!==po}function aa(e){return (e&zo)===e}function sa(e,t){return (t&(vo|bo|yo|wo))!==po}function ua(e){return (e&So)!==po}function la(){var e=Xo;return ((Xo<<=1)&So)===po&&(Xo=Eo),e}function ca(e){return e&-e}function da(e){return ca(e)}function fa(e){return 31-lo(e)}function ha(e){return fa(e)}function pa(e,t){return (e&t)!==po}function ma(e,t){return (e&t)===t}function ga(e,t){return e|t}function va(e,t){return e&~t}function ba(e,t){return e&t}function ya(e){for(var t=[],n=0;n<ho;n++)t.push(e);return t}function wa(e,t,n){e.pendingLanes|=t,t!==Go&&(e.suspendedLanes=po,e.pingedLanes=po),e.eventTimes[ha(t)]=n;}function _a(e,t,n){e.pingedLanes|=e.suspendedLanes&t;}function Sa(e,t){for(var n=e.entangledLanes|=t,r=e.entanglements,i=n;i;){var o=fa(i),a=1<<o;a&t|r[o]&t&&(r[o]|=t),i&=~a;}}function Ea(e,t,n){if(qi)for(var r=e.pendingUpdatersLaneMap;n>0;){var i=ha(n),o=1<<i;r[i].add(t),n&=~o;}}function ka(e,t){if(qi)for(var n=e.pendingUpdatersLaneMap,r=e.memoizedUpdaters;t>0;){var i=ha(t),o=1<<i,a=n[i];a.size>0&&(a.forEach((function(e){var t=e.alternate;null!==t&&r.has(t)||r.add(e);})),a.clear()),t&=~o;}}var Ma,Ca,xa,Aa,Ra,Ta=go,Pa=bo,La=wo,Ia=Go,Oa=mo;function Na(){return Oa}function Da(e){Oa=e;}function ja(e,t){return 0!==e&&e<t}function Ba(e){var t=ca(e);return ja(Ta,t)?ja(Pa,t)?oa(t)?La:Ia:Pa:Ta}function za(e){return e.current.memoizedState.isDehydrated}function Ua(e){Ma(e);}var Fa=false,Ka=[],qa=null,Ha=null,Wa=null,$a=new Map,Va=new Map,Ya=[],Ga=["mousedown","mouseup","touchcancel","touchend","touchstart","auxclick","dblclick","pointercancel","pointerdown","pointerup","dragend","dragstart","drop","compositionend","compositionstart","keydown","keypress","keyup","input","textInput","copy","cut","paste","click","change","contextmenu","reset","submit"];function Za(e,t){switch(e){case "focusin":case "focusout":qa=null;break;case "dragenter":case "dragleave":Ha=null;break;case "mouseover":case "mouseout":Wa=null;break;case "pointerover":case "pointerout":var n=t.pointerId;$a.delete(n);break;case "gotpointercapture":case "lostpointercapture":var r=t.pointerId;Va.delete(r);}}function Qa(e,t,n,r,i,o){if(null===e||e.nativeEvent!==o){var a=function(e,t,n,r,i){return {blockedOn:e,domEventName:t,eventSystemFlags:n,nativeEvent:i,targetContainers:[r]}}(t,n,r,i,o);if(null!==t){var s=Vc(t);null!==s&&Ca(s);}return a}e.eventSystemFlags|=r;var u=e.targetContainers;return null!==i&&-1===u.indexOf(i)&&u.push(i),e}function Ja(e){var t=$c(e.target);if(null!==t){var n=vi(t);if(null!==n){var r=n.tag;if(r===w){var i=bi(n);if(null!==i)return e.blockedOn=i,void Ra(e.priority,(function(){xa(n);}))}else if(r===c){if(za(n.stateNode))return void(e.blockedOn=yi(n))}}}e.blockedOn=null;}function Xa(e){if(null!==e.blockedOn)return  false;for(var t,n=e.targetContainers;n.length>0;){var r=n[0],i=ds(e.domEventName,e.eventSystemFlags,r,e.nativeEvent);if(null!==i){var a=Vc(i);return null!==a&&Ca(a),e.blockedOn=i,false}var s=e.nativeEvent,u=new s.constructor(s.type,s);t=u,null!==dr&&o("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."),dr=t,s.target.dispatchEvent(u),null===dr&&o("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."),dr=null,n.shift();}return  true}function es(e,t,n){Xa(e)&&n.delete(t);}function ts(){Fa=false,null!==qa&&Xa(qa)&&(qa=null),null!==Ha&&Xa(Ha)&&(Ha=null),null!==Wa&&Xa(Wa)&&(Wa=null),$a.forEach(es),Va.forEach(es);}function ns(e,n){e.blockedOn===n&&(e.blockedOn=null,Fa||(Fa=true,t.unstable_scheduleCallback(t.unstable_NormalPriority,ts)));}function rs(e){if(Ka.length>0){ns(Ka[0],e);for(var t=1;t<Ka.length;t++){var n=Ka[t];n.blockedOn===e&&(n.blockedOn=null);}}null!==qa&&ns(qa,e),null!==Ha&&ns(Ha,e),null!==Wa&&ns(Wa,e);var r=function(t){return ns(t,e)};$a.forEach(r),Va.forEach(r);for(var i=0;i<Ya.length;i++){var o=Ya[i];o.blockedOn===e&&(o.blockedOn=null);}for(;Ya.length>0;){var a=Ya[0];if(null!==a.blockedOn)break;Ja(a),null===a.blockedOn&&Ya.shift();}}var is=n.ReactCurrentBatchConfig,os=true;function as(e){os=!!e;}function ss(e,t,n,r){var i=Na(),o=is.transition;is.transition=null;try{Da(Ta),ls(e,t,n,r);}finally{Da(i),is.transition=o;}}function us(e,t,n,r){var i=Na(),o=is.transition;is.transition=null;try{Da(Pa),ls(e,t,n,r);}finally{Da(i),is.transition=o;}}function ls(e,t,n,r){os&&function(e,t,n,r){var i=ds(e,t,n,r);if(null===i)return bl(e,t,r,cs,n),void Za(e,r);if(function(e,t,n,r,i){switch(t){case "focusin":return qa=Qa(qa,e,t,n,r,i),true;case "dragenter":return Ha=Qa(Ha,e,t,n,r,i),true;case "mouseover":return Wa=Qa(Wa,e,t,n,r,i),true;case "pointerover":var o=i,a=o.pointerId;return $a.set(a,Qa($a.get(a)||null,e,t,n,r,o)),true;case "gotpointercapture":var s=i,u=s.pointerId;return Va.set(u,Qa(Va.get(u)||null,e,t,n,r,s)),true}return  false}(i,e,t,n,r))return void r.stopPropagation();if(Za(e,r),t&lr&&function(e){return Ga.indexOf(e)>-1}(e)){for(;null!==i;){var o=Vc(i);null!==o&&Ua(o);var a=ds(e,t,n,r);if(null===a&&bl(e,t,r,cs,n),a===i)break;i=a;}return void(null!==i&&r.stopPropagation())}bl(e,t,r,null,n);}(e,t,n,r);}var cs=null;function ds(e,t,n,r){cs=null;var i=$c(fr(r));if(null!==i){var o=vi(i);if(null===o)i=null;else {var a=o.tag;if(a===w){var s=bi(o);if(null!==s)return s;i=null;}else if(a===c){if(za(o.stateNode))return yi(o);i=null;}else o!==i&&(i=null);}}return cs=i,null}function fs(e){switch(e){case "cancel":case "click":case "close":case "contextmenu":case "copy":case "cut":case "auxclick":case "dblclick":case "dragend":case "dragstart":case "drop":case "focusin":case "focusout":case "input":case "invalid":case "keydown":case "keypress":case "keyup":case "mousedown":case "mouseup":case "paste":case "pause":case "play":case "pointercancel":case "pointerdown":case "pointerup":case "ratechange":case "reset":case "resize":case "seeked":case "submit":case "touchcancel":case "touchend":case "touchstart":case "volumechange":case "change":case "selectionchange":case "textInput":case "compositionstart":case "compositionend":case "compositionupdate":case "beforeblur":case "afterblur":case "beforeinput":case "blur":case "fullscreenchange":case "focus":case "hashchange":case "popstate":case "select":case "selectstart":return Ta;case "drag":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "mousemove":case "mouseout":case "mouseover":case "pointermove":case "pointerout":case "pointerover":case "scroll":case "toggle":case "touchmove":case "wheel":case "mouseenter":case "mouseleave":case "pointerenter":case "pointerleave":return Pa;case "message":switch(Pi()){case Li:return Ta;case Ii:return Pa;case Oi:case Ni:return La;case Di:return Ia;default:return La}default:return La}}var hs=null,ps=null,ms=null;function gs(){if(ms)return ms;var e,t,n=ps,r=n.length,i=vs(),o=i.length;for(e=0;e<r&&n[e]===i[e];e++);var a=r-e;for(t=1;t<=a&&n[r-t]===i[o-t];t++);var s=t>1?1-t:void 0;return ms=i.slice(e,s)}function vs(){return "value"in hs?hs.value:hs.textContent}function bs(e){var t,n=e.keyCode;return "charCode"in e?0===(t=e.charCode)&&13===n&&(t=13):t=n,10===t&&(t=13),t>=32||13===t?t:0}function ys(){return  true}function ws(){return  false}function _s(e){function t(t,n,r,i,o){for(var a in this._reactName=t,this._targetInst=r,this.type=n,this.nativeEvent=i,this.target=o,this.currentTarget=null,e)if(e.hasOwnProperty(a)){var s=e[a];this[a]=s?s(i):i[a];}var u=null!=i.defaultPrevented?i.defaultPrevented:false===i.returnValue;return this.isDefaultPrevented=u?ys:ws,this.isPropagationStopped=ws,this}return Ge(t.prototype,{preventDefault:function(){this.defaultPrevented=true;var e=this.nativeEvent;e&&(e.preventDefault?e.preventDefault():"unknown"!=typeof e.returnValue&&(e.returnValue=false),this.isDefaultPrevented=ys);},stopPropagation:function(){var e=this.nativeEvent;e&&(e.stopPropagation?e.stopPropagation():"unknown"!=typeof e.cancelBubble&&(e.cancelBubble=true),this.isPropagationStopped=ys);},persist:function(){},isPersistent:ys}),t}var Ss,Es,ks,Ms={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(e){return e.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},Cs=_s(Ms),xs=Ge({},Ms,{view:0,detail:0}),As=_s(xs);var Rs=Ge({},xs,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:Fs,button:0,buttons:0,relatedTarget:function(e){return void 0===e.relatedTarget?e.fromElement===e.srcElement?e.toElement:e.fromElement:e.relatedTarget},movementX:function(e){return "movementX"in e?e.movementX:(function(e){e!==ks&&(ks&&"mousemove"===e.type?(Ss=e.screenX-ks.screenX,Es=e.screenY-ks.screenY):(Ss=0,Es=0),ks=e);}(e),Ss)},movementY:function(e){return "movementY"in e?e.movementY:Es}}),Ts=_s(Rs),Ps=_s(Ge({},Rs,{dataTransfer:0})),Ls=_s(Ge({},xs,{relatedTarget:0})),Is=_s(Ge({},Ms,{animationName:0,elapsedTime:0,pseudoElement:0})),Os=_s(Ge({},Ms,{clipboardData:function(e){return "clipboardData"in e?e.clipboardData:window.clipboardData}})),Ns=_s(Ge({},Ms,{data:0})),Ds=Ns,js={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Bs={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};var zs={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Us(e){var t=this.nativeEvent;if(t.getModifierState)return t.getModifierState(e);var n=zs[e];return !!n&&!!t[n]}function Fs(e){return Us}var Ks=Ge({},xs,{key:function(e){if(e.key){var t=js[e.key]||e.key;if("Unidentified"!==t)return t}if("keypress"===e.type){var n=bs(e);return 13===n?"Enter":String.fromCharCode(n)}return "keydown"===e.type||"keyup"===e.type?Bs[e.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:Fs,charCode:function(e){return "keypress"===e.type?bs(e):0},keyCode:function(e){return "keydown"===e.type||"keyup"===e.type?e.keyCode:0},which:function(e){return "keypress"===e.type?bs(e):"keydown"===e.type||"keyup"===e.type?e.keyCode:0}}),qs=_s(Ks),Hs=_s(Ge({},Rs,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0})),Ws=_s(Ge({},xs,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:Fs})),$s=_s(Ge({},Ms,{propertyName:0,elapsedTime:0,pseudoElement:0})),Vs=_s(Ge({},Rs,{deltaX:function(e){return "deltaX"in e?e.deltaX:"wheelDeltaX"in e?-e.wheelDeltaX:0},deltaY:function(e){return "deltaY"in e?e.deltaY:"wheelDeltaY"in e?-e.wheelDeltaY:"wheelDelta"in e?-e.wheelDelta:0},deltaZ:0,deltaMode:0})),Ys=[9,13,27,32],Gs=229,Zs=Y&&"CompositionEvent"in window,Qs=null;Y&&"documentMode"in document&&(Qs=document.documentMode);var Js=Y&&"TextEvent"in window&&!Qs,Xs=Y&&(!Zs||Qs&&Qs>8&&Qs<=11),eu=32,tu=String.fromCharCode(eu);var nu=false;function ru(e,t){switch(e){case "keyup":return  -1!==Ys.indexOf(t.keyCode);case "keydown":return t.keyCode!==Gs;case "keypress":case "mousedown":case "focusout":return  true;default:return  false}}function iu(e){var t=e.detail;return "object"==typeof t&&"data"in t?t.data:null}function ou(e){return "ko"===e.locale}var au=false;function su(e,t,n,r,i){var o,a;if(Zs?o=function(e){switch(e){case "compositionstart":return "onCompositionStart";case "compositionend":return "onCompositionEnd";case "compositionupdate":return "onCompositionUpdate"}}(t):au?ru(t,r)&&(o="onCompositionEnd"):function(e,t){return "keydown"===e&&t.keyCode===Gs}(t,r)&&(o="onCompositionStart"),!o)return null;Xs&&!ou(r)&&(au||"onCompositionStart"!==o?"onCompositionEnd"===o&&au&&(a=gs()):au=function(e){return hs=e,ps=vs(),true}(i));var s=wl(n,o);if(s.length>0){var u=new Ns(o,t,null,r,i);if(e.push({event:u,listeners:s}),a)u.data=a;else {var l=iu(r);null!==l&&(u.data=l);}}}function uu(e,t){if(au){if("compositionend"===e||!Zs&&ru(e,t)){var n=gs();return hs=null,ps=null,ms=null,au=false,n}return null}switch(e){case "paste":default:return null;case "keypress":if(!function(e){return (e.ctrlKey||e.altKey||e.metaKey)&&!(e.ctrlKey&&e.altKey)}(t)){if(t.char&&t.char.length>1)return t.char;if(t.which)return String.fromCharCode(t.which)}return null;case "compositionend":return Xs&&!ou(t)?null:t.data}}function lu(e,t,n,r,i){var o;if(!(o=Js?function(e,t){switch(e){case "compositionend":return iu(t);case "keypress":return t.which!==eu?null:(nu=true,tu);case "textInput":var n=t.data;return n===tu&&nu?null:n;default:return null}}(t,r):uu(t,r)))return null;var a=wl(n,"onBeforeInput");if(a.length>0){var s=new Ds("onBeforeInput","beforeinput",null,r,i);e.push({event:s,listeners:a}),s.data=o;}}var cu={color:true,date:true,datetime:true,"datetime-local":true,email:true,month:true,number:true,password:true,range:true,search:true,tel:true,text:true,time:true,url:true,week:true};function du(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return "input"===t?!!cu[e.type]:"textarea"===t}
		/**
		            	 * Checks if an event is supported in the current execution environment.
		            	 *
		            	 * NOTE: This will not work correctly for non-generic events such as `change`,
		            	 * `reset`, `load`, `error`, and `select`.
		            	 *
		            	 * Borrows from Modernizr.
		            	 *
		            	 * @param {string} eventNameSuffix Event name, e.g. "click".
		            	 * @return {boolean} True if the event is supported.
		            	 * @internal
		            	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
		            	 */function fu(e,t,n,r){vr(r);var i=wl(t,"onChange");if(i.length>0){var o=new Cs("onChange","change",null,n,r);e.push({event:o,listeners:i});}}var hu=null,pu=null;function mu(e){dl(e,0);}function gu(e){if(At(Yc(e)))return e}function vu(e,t){if("change"===e)return t}var bu=false;function yu(){hu&&(hu.detachEvent("onpropertychange",wu),hu=null,pu=null);}function wu(e){"value"===e.propertyName&&gu(pu)&&function(e){var t=[];fu(t,pu,e,fr(e)),Er(mu,t);}(e);}function _u(e,t,n){"focusin"===e?(yu(),function(e,t){pu=t,(hu=e).attachEvent("onpropertychange",wu);}(t,n)):"focusout"===e&&yu();}function Su(e,t){if("selectionchange"===e||"keyup"===e||"keydown"===e)return gu(pu)}function Eu(e,t){if("click"===e)return gu(t)}function ku(e,t){if("input"===e||"change"===e)return gu(t)}function Mu(e,t,n,r,i,o,a){var s,u,l,c,d=n?Yc(n):window;if("select"===(c=(l=d).nodeName&&l.nodeName.toLowerCase())||"input"===c&&"file"===l.type?s=vu:du(d)?bu?s=ku:(s=Su,u=_u):function(e){var t=e.nodeName;return t&&"input"===t.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)}(d)&&(s=Eu),s){var f=s(t,n);if(f)return void fu(e,f,r,i)}u&&u(t,d,n),"focusout"===t&&function(e){var t=e._wrapperState;t&&t.controlled&&"number"===e.type&&Ft(e,"number",e.value);}(d);}function Cu(e,t,n,r,i,o,a){var s="mouseover"===t||"pointerover"===t,u="mouseout"===t||"pointerout"===t;if(s&&r!==dr){var l=r.relatedTarget||r.fromElement;if(l&&($c(l)||Wc(l)))return}if(u||s){var c,d,p;if(i.window===i)c=i;else {var m=i.ownerDocument;c=m?m.defaultView||m.parentWindow:window;}if(u){var g=r.relatedTarget||r.toElement;if(d=n,null!==(p=g?$c(g):null))(p!==vi(p)||p.tag!==f&&p.tag!==h)&&(p=null);}else d=null,p=n;if(d!==p){var v=Ts,b="onMouseLeave",y="onMouseEnter",w="mouse";"pointerout"!==t&&"pointerover"!==t||(v=Hs,b="onPointerLeave",y="onPointerEnter",w="pointer");var _=null==d?c:Yc(d),S=null==p?c:Yc(p),E=new v(b,w+"leave",d,r,i);E.target=_,E.relatedTarget=S;var k=null;if($c(i)===n){var M=new v(y,w+"enter",p,r,i);M.target=S,M.relatedTarget=_,k=M;}!function(e,t,n,r,i){var o=r&&i?function(e,t){for(var n=e,r=t,i=0,o=n;o;o=_l(o))i++;for(var a=0,s=r;s;s=_l(s))a++;for(;i-a>0;)n=_l(n),i--;for(;a-i>0;)r=_l(r),a--;var u=i;for(;u--;){if(n===r||null!==r&&n===r.alternate)return n;n=_l(n),r=_l(r);}return null}(r,i):null;null!==r&&Sl(e,t,r,o,false);null!==i&&null!==n&&Sl(e,n,i,o,true);}(e,E,k,d,p);}}}Y&&(bu=function(e){if(!Y)return  false;var t="on"+e,n=t in document;if(!n){var r=document.createElement("div");r.setAttribute(t,"return;"),n="function"==typeof r[t];}return n}("input")&&(!document.documentMode||document.documentMode>9));var xu="function"==typeof Object.is?Object.is:function(e,t){return e===t&&(0!==e||1/e==1/t)||e!=e&&t!=t};function Au(e,t){if(xu(e,t))return  true;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return  false;var n=Object.keys(e),r=Object.keys(t);if(n.length!==r.length)return  false;for(var i=0;i<n.length;i++){var o=n[i];if(!G.call(t,o)||!xu(e[o],t[o]))return  false}return  true}function Ru(e){for(;e&&e.firstChild;)e=e.firstChild;return e}function Tu(e){for(;e;){if(e.nextSibling)return e.nextSibling;e=e.parentNode;}}function Pu(e,t){for(var n=Ru(e),r=0,i=0;n;){if(n.nodeType===mn){if(i=r+n.textContent.length,r<=t&&i>=t)return {node:n,offset:t-r};r=i;}n=Ru(Tu(n));}}function Lu(e){var t=e.ownerDocument,n=t&&t.defaultView||window,r=n.getSelection&&n.getSelection();if(!r||0===r.rangeCount)return null;var i=r.anchorNode,o=r.anchorOffset,a=r.focusNode,s=r.focusOffset;try{i.nodeType,a.nodeType;}catch(e){return null}return function(e,t,n,r,i){var o=0,a=-1,s=-1,u=0,l=0,c=e,d=null;e:for(;;){for(var f=null;c!==t||0!==n&&c.nodeType!==mn||(a=o+n),c!==r||0!==i&&c.nodeType!==mn||(s=o+i),c.nodeType===mn&&(o+=c.nodeValue.length),null!==(f=c.firstChild);)d=c,c=f;for(;;){if(c===e)break e;if(d===t&&++u===n&&(a=o),d===r&&++l===i&&(s=o),null!==(f=c.nextSibling))break;d=(c=d).parentNode;}c=f;}if(-1===a||-1===s)return null;return {start:a,end:s}}(e,i,o,a,s)}function Iu(e){return e&&e.nodeType===mn}function Ou(e,t){return !(!e||!t)&&(e===t||!Iu(e)&&(Iu(t)?Ou(e,t.parentNode):"contains"in e?e.contains(t):!!e.compareDocumentPosition&&!!(16&e.compareDocumentPosition(t))))}function Nu(e){return e&&e.ownerDocument&&Ou(e.ownerDocument.documentElement,e)}function Du(e){try{return "string"==typeof e.contentWindow.location.href}catch(e){return  false}}function ju(){for(var e=window,t=Rt();t instanceof e.HTMLIFrameElement;){if(!Du(t))return t;t=Rt((e=t.contentWindow).document);}return t}function Bu(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return t&&("input"===t&&("text"===e.type||"search"===e.type||"tel"===e.type||"url"===e.type||"password"===e.type)||"textarea"===t||"true"===e.contentEditable)}function zu(e){var t=ju(),n=e.focusedElem,r=e.selectionRange;if(t!==n&&Nu(n)){null!==r&&Bu(n)&&function(e,t){var n=t.start,r=t.end;void 0===r&&(r=n);"selectionStart"in e?(e.selectionStart=n,e.selectionEnd=Math.min(r,e.value.length)):function(e,t){var n=e.ownerDocument||document,r=n&&n.defaultView||window;if(r.getSelection){var i=r.getSelection(),o=e.textContent.length,a=Math.min(t.start,o),s=void 0===t.end?a:Math.min(t.end,o);if(!i.extend&&a>s){var u=s;s=a,a=u;}var l=Pu(e,a),c=Pu(e,s);if(l&&c){if(1===i.rangeCount&&i.anchorNode===l.node&&i.anchorOffset===l.offset&&i.focusNode===c.node&&i.focusOffset===c.offset)return;var d=n.createRange();d.setStart(l.node,l.offset),i.removeAllRanges(),a>s?(i.addRange(d),i.extend(c.node,c.offset)):(d.setEnd(c.node,c.offset),i.addRange(d));}}}(e,t);}(n,r);for(var i=[],o=n;o=o.parentNode;)o.nodeType===pn&&i.push({element:o,left:o.scrollLeft,top:o.scrollTop});"function"==typeof n.focus&&n.focus();for(var a=0;a<i.length;a++){var s=i[a];s.element.scrollLeft=s.left,s.element.scrollTop=s.top;}}}function Uu(e){return ("selectionStart"in e?{start:e.selectionStart,end:e.selectionEnd}:Lu(e))||{start:0,end:0}}var Fu=Y&&"documentMode"in document&&document.documentMode<=11;var Ku=null,qu=null,Hu=null,Wu=false;function $u(e,t,n){var r,i=(r=n).window===r?r.document:r.nodeType===vn?r:r.ownerDocument;if(!Wu&&null!=Ku&&Ku===Rt(i)){var o=function(e){if("selectionStart"in e&&Bu(e))return {start:e.selectionStart,end:e.selectionEnd};var t=(e.ownerDocument&&e.ownerDocument.defaultView||window).getSelection();return {anchorNode:t.anchorNode,anchorOffset:t.anchorOffset,focusNode:t.focusNode,focusOffset:t.focusOffset}}(Ku);if(!Hu||!Au(Hu,o)){Hu=o;var a=wl(qu,"onSelect");if(a.length>0){var s=new Cs("onSelect","select",null,t,n);e.push({event:s,listeners:a}),s.target=Ku;}}}}function Vu(e,t){var n={};return n[e.toLowerCase()]=t.toLowerCase(),n["Webkit"+e]="webkit"+t,n["Moz"+e]="moz"+t,n}var Yu={animationend:Vu("Animation","AnimationEnd"),animationiteration:Vu("Animation","AnimationIteration"),animationstart:Vu("Animation","AnimationStart"),transitionend:Vu("Transition","TransitionEnd")},Gu={},Zu={};function Qu(e){if(Gu[e])return Gu[e];if(!Yu[e])return e;var t=Yu[e];for(var n in t)if(t.hasOwnProperty(n)&&n in Zu)return Gu[e]=t[n];return e}Y&&(Zu=document.createElement("div").style,"AnimationEvent"in window||(delete Yu.animationend.animation,delete Yu.animationiteration.animation,delete Yu.animationstart.animation),"TransitionEvent"in window||delete Yu.transitionend.transition);var Ju=Qu("animationend"),Xu=Qu("animationiteration"),el=Qu("animationstart"),tl=Qu("transitionend"),nl=new Map,rl=["abort","auxClick","cancel","canPlay","canPlayThrough","click","close","contextMenu","copy","cut","drag","dragEnd","dragEnter","dragExit","dragLeave","dragOver","dragStart","drop","durationChange","emptied","encrypted","ended","error","gotPointerCapture","input","invalid","keyDown","keyPress","keyUp","load","loadedData","loadedMetadata","loadStart","lostPointerCapture","mouseDown","mouseMove","mouseOut","mouseOver","mouseUp","paste","pause","play","playing","pointerCancel","pointerDown","pointerMove","pointerOut","pointerOver","pointerUp","progress","rateChange","reset","resize","seeked","seeking","stalled","submit","suspend","timeUpdate","touchCancel","touchEnd","touchStart","volumeChange","scroll","toggle","touchMove","waiting","wheel"];function il(e,t){nl.set(e,t),$(t,[e]);}function ol(e,t,n,r,i,o,a){var s=nl.get(t);if(void 0!==s){var u=Cs,l=t;switch(t){case "keypress":if(0===bs(r))return;case "keydown":case "keyup":u=qs;break;case "focusin":l="focus",u=Ls;break;case "focusout":l="blur",u=Ls;break;case "beforeblur":case "afterblur":u=Ls;break;case "click":if(2===r.button)return;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":u=Ts;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":u=Ps;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":u=Ws;break;case Ju:case Xu:case el:u=Is;break;case tl:u=$s;break;case "scroll":u=As;break;case "wheel":u=Vs;break;case "copy":case "cut":case "paste":u=Os;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":u=Hs;}var c=0!=(o&lr),d=!c&&"scroll"===t,h=function(e,t,n,r,i,o){var a=null!==t?t+"Capture":null,s=r?a:t,u=[],l=e,c=null;for(;null!==l;){var d=l,h=d.stateNode;if(d.tag===f&&null!==h&&(c=h,null!==s)){var p=kr(l,s);null!=p&&u.push(yl(l,p,c));}if(i)break;l=l.return;}return u}(n,s,r.type,c,d);if(h.length>0){var p=new u(s,l,null,r,i);e.push({event:p,listeners:h});}}}function al(e,t,n,r,i,o,a){ol(e,t,n,r,i,o),0==(o&cr)&&(Cu(e,t,n,r,i),Mu(e,t,n,r,i),function(e,t,n,r,i,o,a){var s=n?Yc(n):window;switch(t){case "focusin":(du(s)||"true"===s.contentEditable)&&(Ku=s,qu=n,Hu=null);break;case "focusout":Ku=null,qu=null,Hu=null;break;case "mousedown":Wu=true;break;case "contextmenu":case "mouseup":case "dragend":Wu=false,$u(e,r,i);break;case "selectionchange":if(Fu)break;case "keydown":case "keyup":$u(e,r,i);}}(e,t,n,r,i),function(e,t,n,r,i,o,a){su(e,t,n,r,i),lu(e,t,n,r,i);}(e,t,n,r,i));}!function(){for(var e=0;e<rl.length;e++){var t=rl[e];il(t.toLowerCase(),"on"+(t[0].toUpperCase()+t.slice(1)));}il(Ju,"onAnimationEnd"),il(Xu,"onAnimationIteration"),il(el,"onAnimationStart"),il("dblclick","onDoubleClick"),il("focusin","onFocus"),il("focusout","onBlur"),il(tl,"onTransitionEnd");}(),V("onMouseEnter",["mouseout","mouseover"]),V("onMouseLeave",["mouseout","mouseover"]),V("onPointerEnter",["pointerout","pointerover"]),V("onPointerLeave",["pointerout","pointerover"]),$("onChange",["change","click","focusin","focusout","input","keydown","keyup","selectionchange"]),$("onSelect",["focusout","contextmenu","dragend","focusin","keydown","keyup","mousedown","mouseup","selectionchange"]),$("onBeforeInput",["compositionend","keypress","textInput","paste"]),$("onCompositionEnd",["compositionend","focusout","keydown","keypress","keyup","mousedown"]),$("onCompositionStart",["compositionstart","focusout","keydown","keypress","keyup","mousedown"]),$("onCompositionUpdate",["compositionupdate","focusout","keydown","keypress","keyup","mousedown"]);var sl=["abort","canplay","canplaythrough","durationchange","emptied","encrypted","ended","error","loadeddata","loadedmetadata","loadstart","pause","play","playing","progress","ratechange","resize","seeked","seeking","stalled","suspend","timeupdate","volumechange","waiting"],ul=new Set(["cancel","close","invalid","load","scroll","toggle"].concat(sl));function ll(e,t,n){var r=e.type||"unknown-event";e.currentTarget=n,function(e,t,n,r,i,o,a,s,u){if(Dr.apply(this,arguments),Pr){var l=jr();Ir||(Ir=true,Or=l);}}(r,t,void 0,e),e.currentTarget=null;}function cl(e,t,n){var r;if(n)for(var i=t.length-1;i>=0;i--){var o=t[i],a=o.instance,s=o.currentTarget,u=o.listener;if(a!==r&&e.isPropagationStopped())return;ll(e,u,s),r=a;}else for(var l=0;l<t.length;l++){var c=t[l],d=c.instance,f=c.currentTarget,h=c.listener;if(d!==r&&e.isPropagationStopped())return;ll(e,h,f),r=d;}}function dl(e,t){for(var n=0!=(t&lr),r=0;r<e.length;r++){var i=e[r];cl(i.event,i.listeners,n);}!function(){if(Ir){var e=Or;throw Ir=false,Or=null,e}}();}function fl(e,t){ul.has(e)||o('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',e);var n=function(e){var t=e[zc];void 0===t&&(t=e[zc]=new Set);return t}(t),r=function(e,t){return e+"__"+("bubble")}(e);n.has(r)||(gl(t,e,ur,false),n.add(r));}function hl(e,t,n){ul.has(e)&&!t&&o('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',e);var r=0;t&&(r|=lr),gl(n,e,r,t);}var pl="_reactListening"+Math.random().toString(36).slice(2);function ml(e){if(!e[pl]){e[pl]=true,q.forEach((function(t){"selectionchange"!==t&&(ul.has(t)||hl(t,false,e),hl(t,true,e));}));var t=e.nodeType===vn?e:e.ownerDocument;null!==t&&(t[pl]||(t[pl]=true,hl("selectionchange",false,t)));}}function gl(e,t,n,r,i){var o=function(e,t,n){var r;switch(fs(t)){case Ta:r=ss;break;case Pa:r=us;break;default:r=ls;}return r.bind(null,t,n,e)}(e,t,n),a=void 0;Mr&&("touchstart"!==t&&"touchmove"!==t&&"wheel"!==t||(a=true)),r?void 0!==a?function(e,t,n,r){e.addEventListener(t,n,{capture:true,passive:r});}(e,t,o,a):function(e,t,n){e.addEventListener(t,n,true);}(e,t,o):void 0!==a?function(e,t,n,r){e.addEventListener(t,n,{passive:r});}(e,t,o,a):function(e,t,n){e.addEventListener(t,n,false);}(e,t,o);}function vl(e,t){return e===t||e.nodeType===gn&&e.parentNode===t}function bl(e,t,n,r,i){var o=r;if(0==(t&sr)&&0==(t&ur)){var a=i;if(null!==r){var s=r;e:for(;;){if(null===s)return;var u=s.tag;if(u===c||u===d){var l=s.stateNode.containerInfo;if(vl(l,a))break;if(u===d)for(var p=s.return;null!==p;){var m=p.tag;if(m===c||m===d)if(vl(p.stateNode.containerInfo,a))return;p=p.return;}for(;null!==l;){var g=$c(l);if(null===g)return;var v=g.tag;if(v===f||v===h){s=o=g;continue e}l=l.parentNode;}}s=s.return;}}}Er((function(){return function(e,t,n,r,i){var o=[];al(o,e,r,n,fr(n),t),dl(o,t);}(e,t,n,o)}));}function yl(e,t,n){return {instance:e,listener:t,currentTarget:n}}function wl(e,t){for(var n=t+"Capture",r=[],i=e;null!==i;){var o=i,a=o.stateNode;if(o.tag===f&&null!==a){var s=a,u=kr(i,n);null!=u&&r.unshift(yl(i,u,s));var l=kr(i,t);null!=l&&r.push(yl(i,l,s));}i=i.return;}return r}function _l(e){if(null===e)return null;do{e=e.return;}while(e&&e.tag!==f);return e||null}function Sl(e,t,n,r,i){for(var o=t._reactName,a=[],s=n;null!==s&&s!==r;){var u=s,l=u.alternate,c=u.stateNode,d=u.tag;if(null!==l&&l===r)break;if(d===f&&null!==c){var h=c;if(i){var p=kr(s,o);null!=p&&a.unshift(yl(s,p,h));}else if(!i){var m=kr(s,o);null!=m&&a.push(yl(s,m,h));}}s=s.return;}0!==a.length&&e.push({event:t,listeners:a});}var El,kl,Ml,Cl,xl,Al,Rl,Tl=false,Pl="dangerouslySetInnerHTML",Ll="suppressContentEditableWarning",Il="suppressHydrationWarning",Ol="autoFocus",Nl="children",Dl="style",jl="__html";El={dialog:true,webview:true},kl=function(e,t){Jn(e,t),function(e,t){"input"!==e&&"textarea"!==e&&"select"!==e||null==t||null!==t.value||Xn||(Xn=true,"select"===e&&t.multiple?o("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",e):o("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",e));}(e,t),ar(e,t,{registrationNameDependencies:H,possibleRegistrationNames:W});},Al=Y&&!document.documentMode,Ml=function(e,t,n){if(!Tl){var r=Ul(n),i=Ul(t);i!==r&&(Tl=true,o("Prop `%s` did not match. Server: %s Client: %s",e,JSON.stringify(i),JSON.stringify(r)));}},Cl=function(e){if(!Tl){Tl=true;var t=[];e.forEach((function(e){t.push(e);})),o("Extra attributes from the server: %s",t);}},xl=function(e,t){ false===t?o("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",e,e,e):o("Expected `%s` listener to be a function, instead got a value of `%s` type.",e,typeof t);},Rl=function(e,t){var n=e.namespaceURI===an?e.ownerDocument.createElement(e.tagName):e.ownerDocument.createElementNS(e.namespaceURI,e.tagName);return n.innerHTML=t,n.innerHTML};var Bl=/\r\n?/g,zl=/\u0000|\uFFFD/g;function Ul(e){return function(e){if(Q(e))o("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.",Z(e));}(e),("string"==typeof e?e:""+e).replace(Bl,"\n").replace(zl,"")}function Fl(e,t,n,r){var i=Ul(t),a=Ul(e);if(a!==i&&(r&&(Tl||(Tl=true,o('Text content did not match. Server: "%s" Client: "%s"',a,i))),n&&L))throw new Error("Text content does not match server-rendered HTML.")}function Kl(e){return e.nodeType===vn?e:e.ownerDocument}function ql(){}function Hl(e){e.onclick=ql;}function Wl(e,t,n,r){var i,o=Wn(t,n);switch(kl(t,n),t){case "dialog":fl("cancel",e),fl("close",e),i=n;break;case "iframe":case "object":case "embed":fl("load",e),i=n;break;case "video":case "audio":for(var a=0;a<sl.length;a++)fl(sl[a],e);i=n;break;case "source":fl("error",e),i=n;break;case "img":case "image":case "link":fl("error",e),fl("load",e),i=n;break;case "details":fl("toggle",e),i=n;break;case "input":Dt(e,n),i=Nt(e,n),fl("invalid",e);break;case "option":Wt(0,n),i=n;break;case "select":Xt(e,n),i=Jt(0,n),fl("invalid",e);break;case "textarea":nn(e,n),i=tn(e,n),fl("invalid",e);break;default:i=n;}switch(Hn(t,i),function(e,t,n,r,i){for(var o in r)if(r.hasOwnProperty(o)){var a=r[o];if(o===Dl)a&&Object.freeze(a),zn(t,a);else if(o===Pl){var s=a?a[jl]:void 0;null!=s&&hn(t,s);}else o===Nl?"string"==typeof a?("textarea"!==e||""!==a)&&yn(t,a):"number"==typeof a&&yn(t,""+a):o===Ll||o===Il||o===Ol||(H.hasOwnProperty(o)?null!=a&&("function"!=typeof a&&xl(o,a),"onScroll"===o&&fl("scroll",t)):null!=a&&Me(t,o,a,i));}}(t,e,0,i,o),t){case "input":xt(e),zt(e,n,false);break;case "textarea":xt(e),on(e);break;case "option":!function(e,t){null!=t.value&&e.setAttribute("value",_t(St(t.value)));}(e,n);break;case "select":!function(e,t){var n=e;n.multiple=!!t.multiple;var r=t.value;null!=r?Qt(n,!!t.multiple,r,false):null!=t.defaultValue&&Qt(n,!!t.multiple,t.defaultValue,true);}(e,n);break;default:"function"==typeof i.onClick&&Hl(e);}}function $l(e,t,n,r,i){kl(t,r);var a,s,u,l,c=null;switch(t){case "input":a=Nt(e,n),s=Nt(e,r),c=[];break;case "select":a=Jt(0,n),s=Jt(0,r),c=[];break;case "textarea":a=tn(e,n),s=tn(e,r),c=[];break;default:s=r,"function"!=typeof(a=n).onClick&&"function"==typeof s.onClick&&Hl(e);}Hn(t,s);var d=null;for(u in a)if(!s.hasOwnProperty(u)&&a.hasOwnProperty(u)&&null!=a[u])if(u===Dl){var f=a[u];for(l in f)f.hasOwnProperty(l)&&(d||(d={}),d[l]="");}else u===Pl||u===Nl||u===Ll||u===Il||u===Ol||(H.hasOwnProperty(u)?c||(c=[]):(c=c||[]).push(u,null));for(u in s){var h=s[u],p=null!=a?a[u]:void 0;if(s.hasOwnProperty(u)&&h!==p&&(null!=h||null!=p))if(u===Dl)if(h&&Object.freeze(h),p){for(l in p)!p.hasOwnProperty(l)||h&&h.hasOwnProperty(l)||(d||(d={}),d[l]="");for(l in h)h.hasOwnProperty(l)&&p[l]!==h[l]&&(d||(d={}),d[l]=h[l]);}else d||(c||(c=[]),c.push(u,d)),d=h;else if(u===Pl){var m=h?h[jl]:void 0,g=p?p[jl]:void 0;null!=m&&g!==m&&(c=c||[]).push(u,m);}else u===Nl?"string"!=typeof h&&"number"!=typeof h||(c=c||[]).push(u,""+h):u===Ll||u===Il||(H.hasOwnProperty(u)?(null!=h&&("function"!=typeof h&&xl(u,h),"onScroll"===u&&fl("scroll",e)),c||p===h||(c=[])):(c=c||[]).push(u,h));}return d&&(!function(e,t){if(t){var n=Fn(e),r=Fn(t),i={};for(var a in n){var s=n[a],u=r[a];if(u&&s!==u){var l=s+","+u;if(i[l])continue;i[l]=true,o("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",Un(e[s])?"Removing":"Updating",s,u);}}}}(d,s[Dl]),(c=c||[]).push(Dl,d)),c}function Vl(e,t,n,r,i){"input"===n&&"radio"===i.type&&null!=i.name&&jt(e,i);Wn(n,r);switch(function(e,t,n,r){for(var i=0;i<t.length;i+=2){var o=t[i],a=t[i+1];o===Dl?zn(e,a):o===Pl?hn(e,a):o===Nl?yn(e,a):Me(e,o,a,r);}}(e,t,0,Wn(n,i)),n){case "input":Bt(e,i);break;case "textarea":rn(e,i);break;case "select":!function(e,t){var n=e,r=n._wrapperState.wasMultiple;n._wrapperState.wasMultiple=!!t.multiple;var i=t.value;null!=i?Qt(n,!!t.multiple,i,false):r!==!!t.multiple&&(null!=t.defaultValue?Qt(n,!!t.multiple,t.defaultValue,true):Qt(n,!!t.multiple,t.multiple?[]:"",false));}(e,i);}}function Yl(e,t){Tl||(Tl=true,o("Did not expect server HTML to contain a <%s> in <%s>.",t.nodeName.toLowerCase(),e.nodeName.toLowerCase()));}function Gl(e,t){Tl||(Tl=true,o('Did not expect server HTML to contain the text node "%s" in <%s>.',t.nodeValue,e.nodeName.toLowerCase()));}function Zl(e,t,n){Tl||(Tl=true,o("Expected server HTML to contain a matching <%s> in <%s>.",t,e.nodeName.toLowerCase()));}function Ql(e,t){""!==t&&(Tl||(Tl=true,o('Expected server HTML to contain a matching text node for "%s" in <%s>.',t,e.nodeName.toLowerCase())));}var Jl=function(){},Xl=function(){},ec=["address","applet","area","article","aside","base","basefont","bgsound","blockquote","body","br","button","caption","center","col","colgroup","dd","details","dir","div","dl","dt","embed","fieldset","figcaption","figure","footer","form","frame","frameset","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","iframe","img","input","isindex","li","link","listing","main","marquee","menu","menuitem","meta","nav","noembed","noframes","noscript","object","ol","p","param","plaintext","pre","script","section","select","source","style","summary","table","tbody","td","template","textarea","tfoot","th","thead","title","tr","track","ul","wbr","xmp"],tc=["applet","caption","html","table","td","th","marquee","object","template","foreignObject","desc","title"],nc=tc.concat(["button"]),rc=["dd","dt","li","option","optgroup","p","rp","rt"],ic={current:null,formTag:null,aTagInScope:null,buttonTagInScope:null,nobrTagInScope:null,pTagInButtonScope:null,listItemTagAutoclosing:null,dlItemTagAutoclosing:null};Xl=function(e,t){var n=Ge({},e||ic),r={tag:t};return  -1!==tc.indexOf(t)&&(n.aTagInScope=null,n.buttonTagInScope=null,n.nobrTagInScope=null),-1!==nc.indexOf(t)&&(n.pTagInButtonScope=null),-1!==ec.indexOf(t)&&"address"!==t&&"div"!==t&&"p"!==t&&(n.listItemTagAutoclosing=null,n.dlItemTagAutoclosing=null),n.current=r,"form"===t&&(n.formTag=r),"a"===t&&(n.aTagInScope=r),"button"===t&&(n.buttonTagInScope=r),"nobr"===t&&(n.nobrTagInScope=r),"p"===t&&(n.pTagInButtonScope=r),"li"===t&&(n.listItemTagAutoclosing=r),"dd"!==t&&"dt"!==t||(n.dlItemTagAutoclosing=r),n};var oc={};Jl=function(e,t,n){var r=(n=n||ic).current,i=r&&r.tag;null!=t&&(null!=e&&o("validateDOMNesting: when childText is passed, childTag should be null"),e="#text");var a=function(e,t){switch(t){case "select":return "option"===e||"optgroup"===e||"#text"===e;case "optgroup":return "option"===e||"#text"===e;case "option":return "#text"===e;case "tr":return "th"===e||"td"===e||"style"===e||"script"===e||"template"===e;case "tbody":case "thead":case "tfoot":return "tr"===e||"style"===e||"script"===e||"template"===e;case "colgroup":return "col"===e||"template"===e;case "table":return "caption"===e||"colgroup"===e||"tbody"===e||"tfoot"===e||"thead"===e||"style"===e||"script"===e||"template"===e;case "head":return "base"===e||"basefont"===e||"bgsound"===e||"link"===e||"meta"===e||"title"===e||"noscript"===e||"noframes"===e||"style"===e||"script"===e||"template"===e;case "html":return "head"===e||"body"===e||"frameset"===e;case "frameset":return "frame"===e;case "#document":return "html"===e}switch(e){case "h1":case "h2":case "h3":case "h4":case "h5":case "h6":return "h1"!==t&&"h2"!==t&&"h3"!==t&&"h4"!==t&&"h5"!==t&&"h6"!==t;case "rp":case "rt":return  -1===rc.indexOf(t);case "body":case "caption":case "col":case "colgroup":case "frameset":case "frame":case "head":case "html":case "tbody":case "td":case "tfoot":case "th":case "thead":case "tr":return null==t}return  true}(e,i)?null:r,s=a?null:function(e,t){switch(e){case "address":case "article":case "aside":case "blockquote":case "center":case "details":case "dialog":case "dir":case "div":case "dl":case "fieldset":case "figcaption":case "figure":case "footer":case "header":case "hgroup":case "main":case "menu":case "nav":case "ol":case "p":case "section":case "summary":case "ul":case "pre":case "listing":case "table":case "hr":case "xmp":case "h1":case "h2":case "h3":case "h4":case "h5":case "h6":return t.pTagInButtonScope;case "form":return t.formTag||t.pTagInButtonScope;case "li":return t.listItemTagAutoclosing;case "dd":case "dt":return t.dlItemTagAutoclosing;case "button":return t.buttonTagInScope;case "a":return t.aTagInScope;case "nobr":return t.nobrTagInScope}return null}(e,n),u=a||s;if(u){var l=u.tag,c=!!a+"|"+e+"|"+l;if(!oc[c]){oc[c]=true;var d=e,f="";if("#text"===e?/\S/.test(t)?d="Text nodes":(d="Whitespace text nodes",f=" Make sure you don't have any extra whitespace between tags on each line of your source code."):d="<"+e+">",a){var h="";"table"===l&&"tr"===e&&(h+=" Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."),o("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s",d,l,f,h);}else o("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.",d,l);}}};var ac="suppressHydrationWarning",sc="$",uc="/$",lc="$?",cc="$!",dc="style",fc=null,hc=null;function pc(e){var t;fc=os,t=ju(),hc={focusedElem:t,selectionRange:Bu(t)?Uu(t):null};return as(false),null}function mc(e,t,n,r,i){var a=r;if(Jl(e,null,a.ancestorInfo),"string"==typeof t.children||"number"==typeof t.children){var s=""+t.children,u=Xl(a.ancestorInfo,e);Jl(null,s,u);}var l=function(e,t,n,r){var i,a,s=Kl(n),u=r;if(u===an&&(u=ln(e)),u===an){if((i=Wn(e,t))||e===e.toLowerCase()||o("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",e),"script"===e){var l=s.createElement("div");l.innerHTML="<script><\/script>";var c=l.firstChild;a=l.removeChild(c);}else if("string"==typeof t.is)a=s.createElement(e,{is:t.is});else if(a=s.createElement(e),"select"===e){var d=a;t.multiple?d.multiple=true:t.size&&(d.size=t.size);}}else a=s.createElementNS(u,e);return u===an&&(i||"[object HTMLUnknownElement]"!==Object.prototype.toString.call(a)||G.call(El,e)||(El[e]=true,o("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",e))),a}(e,t,n,a.namespace);return Kc(i,l),Zc(l,t),l}function gc(e,t){return "textarea"===e||"noscript"===e||"string"==typeof t.children||"number"==typeof t.children||"object"==typeof t.dangerouslySetInnerHTML&&null!==t.dangerouslySetInnerHTML&&null!=t.dangerouslySetInnerHTML.__html}function vc(e,t,n,r){Jl(null,e,n.ancestorInfo);var i=function(e,t){return Kl(t).createTextNode(e)}(e,t);return Kc(r,i),i}var bc="function"==typeof setTimeout?setTimeout:void 0,yc="function"==typeof clearTimeout?clearTimeout:void 0,wc=-1,_c="function"==typeof Promise?Promise:void 0,Sc="function"==typeof queueMicrotask?queueMicrotask:void 0!==_c?function(e){return _c.resolve(null).then(e).catch(Ec)}:bc;function Ec(e){setTimeout((function(){throw e}));}function kc(e){yn(e,"");}function Mc(e,t){var n=t,r=0;do{var i=n.nextSibling;if(e.removeChild(n),i&&i.nodeType===gn){var o=i.data;if(o===uc){if(0===r)return e.removeChild(i),void rs(t);r--;}else o!==sc&&o!==lc&&o!==cc||r++;}n=i;}while(n);rs(t);}function Cc(e){var t=e.style;"function"==typeof t.setProperty?t.setProperty("display","none","important"):t.display="none";}function xc(e,t){var n=t[dc],r=null!=n&&n.hasOwnProperty("display")?n.display:null;e.style.display=En("display",r);}function Ac(e,t){e.nodeValue=t;}function Rc(e){return e.data===lc}function Tc(e){return e.data===cc}function Pc(e){for(;null!=e;e=e.nextSibling){var t=e.nodeType;if(t===pn||t===mn)break;if(t===gn){var n=e.data;if(n===sc||n===cc||n===lc)break;if(n===uc)return null}}return e}function Lc(e){return Pc(e.nextSibling)}function Ic(e,t,n,r,i,o,a){return Kc(o,e),Zc(e,n),function(e,t,n,r,i,o,a){var s,u;switch(s=Wn(t,n),kl(t,n),t){case "dialog":fl("cancel",e),fl("close",e);break;case "iframe":case "object":case "embed":fl("load",e);break;case "video":case "audio":for(var l=0;l<sl.length;l++)fl(sl[l],e);break;case "source":fl("error",e);break;case "img":case "image":case "link":fl("error",e),fl("load",e);break;case "details":fl("toggle",e);break;case "input":Dt(e,n),fl("invalid",e);break;case "option":Wt(0,n);break;case "select":Xt(e,n),fl("invalid",e);break;case "textarea":nn(e,n),fl("invalid",e);}Hn(t,n),u=new Set;for(var c=e.attributes,d=0;d<c.length;d++)switch(c[d].name.toLowerCase()){case "value":case "checked":case "selected":break;default:u.add(c[d].name);}var f,h=null;for(var p in n)if(n.hasOwnProperty(p)){var m=n[p];if(p===Nl)"string"==typeof m?e.textContent!==m&&(true!==n[Il]&&Fl(e.textContent,m,o,a),h=[Nl,m]):"number"==typeof m&&e.textContent!==""+m&&(true!==n[Il]&&Fl(e.textContent,m,o,a),h=[Nl,""+m]);else if(H.hasOwnProperty(p))null!=m&&("function"!=typeof m&&xl(p,m),"onScroll"===p&&fl("scroll",e));else if(a&&"boolean"==typeof s){var g=void 0,v=me(p);if(true===n[Il]);else if(p===Ll||p===Il||"value"===p||"checked"===p||"selected"===p);else if(p===Pl){var b=e.innerHTML,y=m?m[jl]:void 0;if(null!=y){var w=Rl(e,y);w!==b&&Ml(p,b,w);}}else if(p===Dl){if(u.delete(p),Al){var _=Bn(m);_!==(g=e.getAttribute("style"))&&Ml(p,g,_);}}else if(s&&true)u.delete(p.toLowerCase()),m!==(g=ke(e,p,m))&&Ml(p,g,m);else if(!fe(p,v,s)&&!pe(p,m,v,s)){var S=false;if(null!==v)u.delete(v.attributeName),g=Ee(e,p,m,v);else {var E=r;if(E===an&&(E=ln(t)),E===an)u.delete(p.toLowerCase());else {var k=(f=void 0,f=p.toLowerCase(),$n.hasOwnProperty(f)&&$n[f]||null);null!==k&&k!==p&&(S=true,u.delete(k)),u.delete(p);}g=ke(e,p,m);}m===g||S||Ml(p,g,m);}}}switch(a&&u.size>0&&true!==n[Il]&&Cl(u),t){case "input":xt(e),zt(e,n,true);break;case "textarea":xt(e),on(e);break;case "select":case "option":break;default:"function"==typeof n.onClick&&Hl(e);}return h}(e,t,n,i.namespace,0,(o.mode&oo)!==io,a)}function Oc(e){for(var t=e.previousSibling,n=0;t;){if(t.nodeType===gn){var r=t.data;if(r===sc||r===cc||r===lc){if(0===n)return t;n--;}else r===uc&&n++;}t=t.previousSibling;}return null}var Nc=Math.random().toString(36).slice(2),Dc="__reactFiber$"+Nc,jc="__reactProps$"+Nc,Bc="__reactContainer$"+Nc,zc="__reactEvents$"+Nc,Uc="__reactListeners$"+Nc,Fc="__reactHandles$"+Nc;function Kc(e,t){t[Dc]=e;}function qc(e,t){t[Bc]=e;}function Hc(e){e[Bc]=null;}function Wc(e){return !!e[Bc]}function $c(e){var t=e[Dc];if(t)return t;for(var n=e.parentNode;n;){if(t=n[Bc]||n[Dc]){var r=t.alternate;if(null!==t.child||null!==r&&null!==r.child)for(var i=Oc(e);null!==i;){var o=i[Dc];if(o)return o;i=Oc(i);}return t}n=(e=n).parentNode;}return null}function Vc(e){var t=e[Dc]||e[Bc];return t&&(t.tag===f||t.tag===h||t.tag===w||t.tag===c)?t:null}function Yc(e){if(e.tag===f||e.tag===h)return e.stateNode;throw new Error("getNodeFromInstance: Invalid argument.")}function Gc(e){return e[jc]||null}function Zc(e,t){e[jc]=t;}var Qc={},Jc=n.ReactDebugCurrentFrame;function Xc(e){if(e){var t=e._owner,n=at(e.type,e._source,t?t.type:null);Jc.setExtraStackFrame(n);}else Jc.setExtraStackFrame(null);}function ed(e,t,n,r,i){var a=Function.call.bind(G);for(var s in e)if(a(e,s)){var u=void 0;try{if("function"!=typeof e[s]){var l=Error((r||"React class")+": "+n+" type `"+s+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof e[s]+"`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");throw l.name="Invariant Violation",l}u=e[s](t,s,r,n,null,"SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");}catch(e){u=e;}!u||u instanceof Error||(Xc(i),o("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).",r||"React class",n,s,typeof u),Xc(null)),u instanceof Error&&!(u.message in Qc)&&(Qc[u.message]=true,Xc(i),o("Failed %s type: %s",n,u.message),Xc(null));}}var td,nd=[];td=[];var rd,id=-1;function od(e){return {current:e}}function ad(e,t){id<0?o("Unexpected pop."):(t!==td[id]&&o("Unexpected Fiber popped."),e.current=nd[id],nd[id]=null,td[id]=null,id--);}function sd(e,t,n){id++,nd[id]=e.current,td[id]=n,e.current=t;}rd={};var ud={};Object.freeze(ud);var ld=od(ud),cd=od(false),dd=ud;function fd(e,t,n){return n&&gd(t)?dd:ld.current}function hd(e,t,n){var r=e.stateNode;r.__reactInternalMemoizedUnmaskedChildContext=t,r.__reactInternalMemoizedMaskedChildContext=n;}function pd(e,t){var n=e.type.contextTypes;if(!n)return ud;var r=e.stateNode;if(r&&r.__reactInternalMemoizedUnmaskedChildContext===t)return r.__reactInternalMemoizedMaskedChildContext;var i={};for(var o in n)i[o]=t[o];return ed(n,i,"context",ft(e)||"Unknown"),r&&hd(e,t,i),i}function md(){return cd.current}function gd(e){var t=e.childContextTypes;return null!=t}function vd(e){ad(cd,e),ad(ld,e);}function bd(e){ad(cd,e),ad(ld,e);}function yd(e,t,n){if(ld.current!==ud)throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");sd(ld,t,e),sd(cd,n,e);}function wd(e,t,n){var r=e.stateNode,i=t.childContextTypes;if("function"!=typeof r.getChildContext){var a=ft(e)||"Unknown";return rd[a]||(rd[a]=true,o("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.",a,a)),n}var s=r.getChildContext();for(var u in s)if(!(u in i))throw new Error((ft(e)||"Unknown")+'.getChildContext(): key "'+u+'" is not defined in childContextTypes.');return ed(i,s,"child context",ft(e)||"Unknown"),Ge({},n,s)}function _d(e){var t=e.stateNode,n=t&&t.__reactInternalMemoizedMergedChildContext||ud;return dd=ld.current,sd(ld,n,e),sd(cd,cd.current,e),true}function Sd(e,t,n){var r=e.stateNode;if(!r)throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");if(n){var i=wd(e,t,dd);r.__reactInternalMemoizedMergedChildContext=i,ad(cd,e),ad(ld,e),sd(ld,i,e),sd(cd,n,e);}else ad(cd,e),sd(cd,n,e);}function Ed(e){if(!function(e){return vi(e)===e}(e)||e.tag!==u)throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");var t=e;do{switch(t.tag){case c:return t.stateNode.context;case u:if(gd(t.type))return t.stateNode.__reactInternalMemoizedMergedChildContext}t=t.return;}while(null!==t);throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.")}var kd=0,Md=1,Cd=null,xd=false,Ad=false;function Rd(e){null===Cd?Cd=[e]:Cd.push(e);}function Td(){xd&&Pd();}function Pd(){if(!Ad&&null!==Cd){Ad=true;var e=0,t=Na();try{var n=Cd;for(Da(Ta);e<n.length;e++){var r=n[e];do{r=r(true);}while(null!==r)}Cd=null,xd=!1;}catch(t){throw null!==Cd&&(Cd=Cd.slice(e+1)),Ci(Li,Pd),t}finally{Da(t),Ad=false;}}return null}var Ld=[],Id=0,Od=null,Nd=0,Dd=[],jd=0,Bd=null,zd=1,Ud="";function Fd(){var e=Ud;return (zd&~function(e){return 1<<Wd(e)-1}(zd)).toString(32)+e}function Kd(e,t){Vd(),Ld[Id++]=Nd,Ld[Id++]=Od,Od=e,Nd=t;}function qd(e,t,n){Vd(),Dd[jd++]=zd,Dd[jd++]=Ud,Dd[jd++]=Bd,Bd=e;var r=zd,i=Ud,o=Wd(r)-1,a=r&~(1<<o),s=n+1,u=Wd(t)+o;if(u>30){var l=o-o%5,c=(a&(1<<l)-1).toString(32),d=a>>l,f=o-l,h=Wd(t)+f;zd=1<<h|(s<<f|d),Ud=c+i;}else {zd=1<<u|(s<<o|a),Ud=i;}}function Hd(e){if(Vd(),null!==e.return){Kd(e,1),qd(e,1,0);}}function Wd(e){return 32-lo(e)}function $d(e){for(;e===Od;)Od=Ld[--Id],Ld[Id]=null,Nd=Ld[--Id],Ld[Id]=null;for(;e===Bd;)Bd=Dd[--jd],Dd[jd]=null,Ud=Dd[--jd],Dd[jd]=null,zd=Dd[--jd],Dd[jd]=null;}function Vd(){wf()||o("Expected to be hydrating. This is a bug in React. Please file an issue.");}var Yd=null,Gd=null,Zd=false,Qd=false,Jd=null;function Xd(){Zd&&o("We should not be hydrating here. This is a bug in React. Please file a bug.");}function ef(){Qd=true;}function tf(e){var t=e.stateNode.containerInfo;return Gd=Pc(t.firstChild),Yd=e,Zd=true,Jd=null,Qd=false,true}function nf(e,t,n){return Gd=Pc(t.nextSibling),Yd=e,Zd=true,Jd=null,Qd=false,null!==n&&function(e,t){Vd(),Dd[jd++]=zd,Dd[jd++]=Ud,Dd[jd++]=Bd,zd=t.id,Ud=t.overflow,Bd=e;}(e,n),true}function rf(e,t){switch(e.tag){case c:!function(e,t){t.nodeType===pn?Yl(e,t):t.nodeType===gn||Gl(e,t);}(e.stateNode.containerInfo,t);break;case f:var n=(e.mode&oo)!==io;!function(e,t,n,r,i){(i||true!==t[ac])&&(r.nodeType===pn?Yl(n,r):r.nodeType===gn||Gl(n,r));}(e.type,e.memoizedProps,e.stateNode,t,n);break;case w:var r=e.memoizedState;null!==r.dehydrated&&function(e,t){var n=e.parentNode;null!==n&&(t.nodeType===pn?Yl(n,t):t.nodeType===gn||Gl(n,t));}(r.dehydrated,t);}}function of(e,t){rf(e,t);var n,r=((n=s_(f,null,null,io)).elementType="DELETED",n);r.stateNode=t,r.return=e;var i=e.deletions;null===i?(e.deletions=[r],e.flags|=qr):i.push(r);}function af(e,t){if(!Qd)switch(e.tag){case c:var n=e.stateNode.containerInfo;switch(t.tag){case f:var r=t.type;t.pendingProps,function(e,t,n){Zl(e,t);}(n,r);break;case h:!function(e,t){Ql(e,t);}(n,t.pendingProps);}break;case f:e.type;var i=e.memoizedProps,o=e.stateNode;switch(t.tag){case f:var a=t.type;t.pendingProps;!function(e,t,n,r,i,o){(o||true!==t[ac])&&Zl(n,r);}(0,i,o,a,0,(e.mode&oo)!==io);break;case h:!function(e,t,n,r,i){(i||true!==t[ac])&&Ql(n,r);}(0,i,o,t.pendingProps,(e.mode&oo)!==io);}break;case w:var s=e.memoizedState.dehydrated;if(null!==s)switch(t.tag){case f:var u=t.type;t.pendingProps,function(e,t,n){var r=e.parentNode;null!==r&&Zl(r,t);}(s,u);break;case h:!function(e,t){var n=e.parentNode;null!==n&&Ql(n,t);}(s,t.pendingProps);}break;default:return}}function sf(e,t){t.flags=t.flags&-4097|Fr,af(e,t);}function uf(e,t){switch(e.tag){case f:var n=e.type;e.pendingProps;var r=function(e,t,n){return e.nodeType!==pn||t.toLowerCase()!==e.nodeName.toLowerCase()?null:e}(t,n);return null!==r&&(e.stateNode=r,Yd=e,Gd=Pc(r.firstChild),true);case h:var i=function(e,t){return ""===t||e.nodeType!==mn?null:e}(t,e.pendingProps);return null!==i&&(e.stateNode=i,Yd=e,Gd=null,true);case w:var o=function(e){return e.nodeType!==gn?null:e}(t);if(null!==o){var a={dehydrated:o,treeContext:(Vd(),null!==Bd?{id:zd,overflow:Ud}:null),retryLane:Zo};e.memoizedState=a;var s=function(e){var t=s_(M,null,null,io);return t.stateNode=e,t}(o);return s.return=e,e.child=s,Yd=e,Gd=null,true}return  false;default:return  false}}function lf(e){return (e.mode&oo)!==io&&(e.flags&$r)===zr}function cf(e){throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.")}function df(e){if(Zd){var t=Gd;if(!t)return lf(e)&&(af(Yd,e),cf()),sf(Yd,e),Zd=false,void(Yd=e);var n=t;if(!uf(e,t)){lf(e)&&(af(Yd,e),cf()),t=Lc(n);var r=Yd;if(!t||!uf(e,t))return sf(Yd,e),Zd=false,void(Yd=e);of(r,n);}}}function ff(e){var t=e.stateNode,n=e.memoizedProps,r=function(e,t,n,r){return Kc(n,e),n.mode,function(e,t,n){return e.nodeValue!==t}(e,t)}(t,n,e);if(r){var i=Yd;if(null!==i)switch(i.tag){case c:i.stateNode.containerInfo;!function(e,t,n,r){Fl(t.nodeValue,n,r,true);}(0,t,n,(i.mode&oo)!==io);break;case f:i.type;var o=i.memoizedProps;i.stateNode;!function(e,t,n,r,i,o){ true!==t[ac]&&Fl(r.nodeValue,i,o,true);}(0,o,0,t,n,(i.mode&oo)!==io);}}return r}function hf(e){var t=e.memoizedState,n=null!==t?t.dehydrated:null;if(!n)throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");!function(e,t){Kc(t,e);}(n,e);}function pf(e){var t=e.memoizedState,n=null!==t?t.dehydrated:null;if(!n)throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");return function(e){for(var t=e.nextSibling,n=0;t;){if(t.nodeType===gn){var r=t.data;if(r===uc){if(0===n)return Lc(t);n--;}else r!==sc&&r!==cc&&r!==lc||n++;}t=t.nextSibling;}return null}(n)}function mf(e){for(var t=e.return;null!==t&&t.tag!==f&&t.tag!==c&&t.tag!==w;)t=t.return;Yd=t;}function gf(e){if(e!==Yd)return  false;if(!Zd)return mf(e),Zd=true,false;if(e.tag!==c&&(e.tag!==f||"head"!==(n=e.type)&&"body"!==n&&!gc(e.type,e.memoizedProps))){var t=Gd;if(t)if(lf(e))vf(e),cf();else for(;t;)of(e,t),t=Lc(t);}var n;return mf(e),Gd=e.tag===w?pf(e):Yd?Lc(e.stateNode):null,true}function vf(e){for(var t=Gd;t;)rf(e,t),t=Lc(t);}function bf(){Yd=null,Gd=null,Zd=false,Qd=false;}function yf(){null!==Jd&&(rw(Jd),Jd=null);}function wf(){return Zd}function _f(e){null===Jd?Jd=[e]:Jd.push(e);}var Sf=n.ReactCurrentBatchConfig,Ef=null;var kf={recordUnsafeLifecycleWarnings:function(e,t){},flushPendingUnsafeLifecycleWarnings:function(){},recordLegacyContextWarning:function(e,t){},flushLegacyContextWarning:function(){},discardPendingWarnings:function(){}},Mf=function(e){var t=[];return e.forEach((function(e){t.push(e);})),t.sort().join(", ")},Cf=[],xf=[],Af=[],Rf=[],Tf=[],Pf=[],Lf=new Set;kf.recordUnsafeLifecycleWarnings=function(e,t){Lf.has(e.type)||("function"==typeof t.componentWillMount&&true!==t.componentWillMount.__suppressDeprecationWarning&&Cf.push(e),e.mode&so&&"function"==typeof t.UNSAFE_componentWillMount&&xf.push(e),"function"==typeof t.componentWillReceiveProps&&true!==t.componentWillReceiveProps.__suppressDeprecationWarning&&Af.push(e),e.mode&so&&"function"==typeof t.UNSAFE_componentWillReceiveProps&&Rf.push(e),"function"==typeof t.componentWillUpdate&&true!==t.componentWillUpdate.__suppressDeprecationWarning&&Tf.push(e),e.mode&so&&"function"==typeof t.UNSAFE_componentWillUpdate&&Pf.push(e));},kf.flushPendingUnsafeLifecycleWarnings=function(){var e=new Set;Cf.length>0&&(Cf.forEach((function(t){e.add(ft(t)||"Component"),Lf.add(t.type);})),Cf=[]);var t=new Set;xf.length>0&&(xf.forEach((function(e){t.add(ft(e)||"Component"),Lf.add(e.type);})),xf=[]);var n=new Set;Af.length>0&&(Af.forEach((function(e){n.add(ft(e)||"Component"),Lf.add(e.type);})),Af=[]);var r=new Set;Rf.length>0&&(Rf.forEach((function(e){r.add(ft(e)||"Component"),Lf.add(e.type);})),Rf=[]);var a=new Set;Tf.length>0&&(Tf.forEach((function(e){a.add(ft(e)||"Component"),Lf.add(e.type);})),Tf=[]);var s=new Set;(Pf.length>0&&(Pf.forEach((function(e){s.add(ft(e)||"Component"),Lf.add(e.type);})),Pf=[]),t.size>0)&&o("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s",Mf(t));r.size>0&&o("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s",Mf(r));s.size>0&&o("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s",Mf(s));e.size>0&&i("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",Mf(e));n.size>0&&i("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",Mf(n));a.size>0&&i("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",Mf(a));};var If=new Map,Of=new Set;function Nf(e,t){if(e&&e.defaultProps){var n=Ge({},t),r=e.defaultProps;for(var i in r) void 0===n[i]&&(n[i]=r[i]);return n}return t}kf.recordLegacyContextWarning=function(e,t){var n=function(e){for(var t=null,n=e;null!==n;)n.mode&so&&(t=n),n=n.return;return t}(e);if(null!==n){if(!Of.has(e.type)){var r=If.get(n);(null!=e.type.contextTypes||null!=e.type.childContextTypes||null!==t&&"function"==typeof t.getChildContext)&&(void 0===r&&(r=[],If.set(n,r)),r.push(e));}}else o("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");},kf.flushLegacyContextWarning=function(){If.forEach((function(e,t){if(0!==e.length){var n=e[0],r=new Set;e.forEach((function(e){r.add(ft(e)||"Component"),Of.add(e.type);}));var i=Mf(r);try{yt(n),o("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context",i);}finally{bt();}}}));},kf.discardPendingWarnings=function(){Cf=[],xf=[],Af=[],Rf=[],Tf=[],Pf=[],If=new Map;};var Df,jf=od(null);Df={};var Bf=null,zf=null,Uf=null,Ff=false;function Kf(){Bf=null,zf=null,Uf=null,Ff=false;}function qf(){Ff=true;}function Hf(){Ff=false;}function Wf(e,t,n){sd(jf,t._currentValue,e),t._currentValue=n,void 0!==t._currentRenderer&&null!==t._currentRenderer&&t._currentRenderer!==Df&&o("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."),t._currentRenderer=Df;}function $f(e,t){var n=jf.current;ad(jf,t),e._currentValue=n;}function Vf(e,t,n){for(var r=e;null!==r;){var i=r.alternate;if(ma(r.childLanes,t)?null===i||ma(i.childLanes,t)||(i.childLanes=ga(i.childLanes,t)):(r.childLanes=ga(r.childLanes,t),null!==i&&(i.childLanes=ga(i.childLanes,t))),r===n)break;r=r.return;}r!==n&&o("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");}function Yf(e,t,n){!function(e,t,n){var r=e.child;null!==r&&(r.return=e);for(;null!==r;){var i=void 0,o=r.dependencies;if(null!==o){i=r.child;for(var a=o.firstContext;null!==a;){if(a.context===t){if(r.tag===u){var s=da(n),l=fh(Jo,s);l.tag=sh;var c=r.updateQueue;if(null===c);else {var d=c.shared,f=d.pending;null===f?l.next=l:(l.next=f.next,f.next=l),d.pending=l;}}r.lanes=ga(r.lanes,n);var h=r.alternate;null!==h&&(h.lanes=ga(h.lanes,n)),Vf(r.return,n,e),o.lanes=ga(o.lanes,n);break}a=a.next;}}else if(r.tag===v)i=r.type===e.type?null:r.child;else if(r.tag===M){var p=r.return;if(null===p)throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");p.lanes=ga(p.lanes,n);var m=p.alternate;null!==m&&(m.lanes=ga(m.lanes,n)),Vf(p,n,e),i=r.sibling;}else i=r.child;if(null!==i)i.return=r;else for(i=r;null!==i;){if(i===e){i=null;break}var g=i.sibling;if(null!==g){g.return=i.return,i=g;break}i=i.return;}r=i;}}(e,t,n);}function Gf(e,t){Bf=e,zf=null,Uf=null;var n=e.dependencies;null!==n&&(null!==n.firstContext&&(pa(n.lanes,t)&&xv(),n.firstContext=null));}function Zf(e){Ff&&o("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");var t=e._currentValue;if(Uf===e);else {var n={context:e,memoizedValue:t,next:null};if(null===zf){if(null===Bf)throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");zf=n,Bf.dependencies={lanes:po,firstContext:n};}else zf=zf.next=n;}return t}var Qf=null;function Jf(e){null===Qf?Qf=[e]:Qf.push(e);}function Xf(e,t,n,r){var i=t.interleaved;return null===i?(n.next=n,Jf(t)):(n.next=i.next,i.next=n),t.interleaved=n,nh(e,r)}function eh(e,t){return nh(e,t)}var th=nh;function nh(e,t){e.lanes=ga(e.lanes,t);var n=e.alternate;null!==n&&(n.lanes=ga(n.lanes,t)),null===n&&(e.flags&(Fr|Qr))!==zr&&Dw(e);for(var r=e,i=e.return;null!==i;)i.childLanes=ga(i.childLanes,t),null!==(n=i.alternate)?n.childLanes=ga(n.childLanes,t):(i.flags&(Fr|Qr))!==zr&&Dw(e),r=i,i=i.return;return r.tag===c?r.stateNode:null}var rh,ih,oh=0,ah=1,sh=2,uh=3,lh=false;function ch(e){var t={baseState:e.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null,interleaved:null,lanes:po},effects:null};e.updateQueue=t;}function dh(e,t){var n=t.updateQueue,r=e.updateQueue;if(n===r){var i={baseState:r.baseState,firstBaseUpdate:r.firstBaseUpdate,lastBaseUpdate:r.lastBaseUpdate,shared:r.shared,effects:r.effects};t.updateQueue=i;}}function fh(e,t){return {eventTime:e,lane:t,tag:oh,payload:null,callback:null,next:null}}function hh(e,t,n){var r=e.updateQueue;if(null===r)return null;var i=r.shared;if(ih!==i||rh||(o("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."),rh=true),(cy&ty)!==Xb){var a=i.pending;return null===a?t.next=t:(t.next=a.next,a.next=t),i.pending=t,th(e,n)}return function(e,t,n,r){var i=t.interleaved;return null===i?(n.next=n,Jf(t)):(n.next=i.next,i.next=n),t.interleaved=n,nh(e,r)}(e,i,t,n)}function ph(e,t,n){var r=t.updateQueue;if(null!==r){var i=r.shared;if(ua(n)){var o=i.lanes,a=ga(o=ba(o,e.pendingLanes),n);i.lanes=a,Sa(e,a);}}}function mh(e,t){var n=e.updateQueue,r=e.alternate;if(null!==r){var i=r.updateQueue;if(n===i){var o=null,a=null,s=n.firstBaseUpdate;if(null!==s){var u=s;do{var l={eventTime:u.eventTime,lane:u.lane,tag:u.tag,payload:u.payload,callback:u.callback,next:null};null===a?o=a=l:(a.next=l,a=l),u=u.next;}while(null!==u);null===a?o=a=t:(a.next=t,a=t);}else o=a=t;return n={baseState:i.baseState,firstBaseUpdate:o,lastBaseUpdate:a,shared:i.shared,effects:i.effects},void(e.updateQueue=n)}}var c=n.lastBaseUpdate;null===c?n.firstBaseUpdate=t:c.next=t,n.lastBaseUpdate=t;}function gh(e,t,n,r,i,o){switch(n.tag){case ah:var a=n.payload;if("function"==typeof a){qf();var s=a.call(o,r,i);if(e.mode&so){Hi(true);try{a.call(o,r,i);}finally{Hi(false);}}return Hf(),s}return a;case uh:e.flags=e.flags&-65537|$r;case oh:var u,l=n.payload;if("function"==typeof l){if(qf(),u=l.call(o,r,i),e.mode&so){Hi(true);try{l.call(o,r,i);}finally{Hi(false);}}Hf();}else u=l;return null==u?r:Ge({},r,u);case sh:return lh=true,r}return r}function vh(e,t,n,r){var i=e.updateQueue;lh=false,ih=i.shared;var o=i.firstBaseUpdate,a=i.lastBaseUpdate,s=i.shared.pending;if(null!==s){i.shared.pending=null;var u=s,l=u.next;u.next=null,null===a?o=l:a.next=l,a=u;var c=e.alternate;if(null!==c){var d=c.updateQueue,f=d.lastBaseUpdate;f!==a&&(null===f?d.firstBaseUpdate=l:f.next=l,d.lastBaseUpdate=u);}}if(null!==o){for(var h=i.baseState,p=po,m=null,g=null,v=null,b=o;;){var y=b.lane,w=b.eventTime;if(ma(r,y)){if(null!==v){var _={eventTime:w,lane:mo,tag:b.tag,payload:b.payload,callback:b.callback,next:null};v=v.next=_;}if(h=gh(e,0,b,h,t,n),null!==b.callback&&b.lane!==mo){e.flags|=Wr;var S=i.effects;null===S?i.effects=[b]:S.push(b);}}else {var E={eventTime:w,lane:y,tag:b.tag,payload:b.payload,callback:b.callback,next:null};null===v?(g=v=E,m=h):v=v.next=E,p=ga(p,y);}if(null===(b=b.next)){if(null===(s=i.shared.pending))break;var k=s,M=k.next;k.next=null,b=M,i.lastBaseUpdate=k,i.shared.pending=null;}}null===v&&(m=h),i.baseState=m,i.firstBaseUpdate=g,i.lastBaseUpdate=v;var C=i.shared.interleaved;if(null!==C){var x=C;do{p=ga(p,x.lane),x=x.next;}while(x!==C)}else null===o&&(i.shared.lanes=po);mw(p),e.lanes=p,e.memoizedState=h;}ih=null;}function bh(e,t){if("function"!=typeof e)throw new Error("Invalid argument passed as callback. Expected a function. Instead received: "+e);e.call(t);}function yh(){lh=false;}function wh(){return lh}function _h(e,t,n){var r=t.effects;if(t.effects=null,null!==r)for(var i=0;i<r.length;i++){var o=r[i],a=o.callback;null!==a&&(o.callback=null,bh(a,n));}}rh=false,ih=null;var Sh,Eh,kh,Mh,Ch,xh,Ah,Rh,Th,Ph,Lh={},Ih=(new e.Component).refs;Sh=new Set,Eh=new Set,kh=new Set,Mh=new Set,Rh=new Set,Ch=new Set,Th=new Set,Ph=new Set;var Oh=new Set;function Nh(e,t,n,r){var i=e.memoizedState,o=n(r,i);if(e.mode&so){Hi(true);try{o=n(r,i);}finally{Hi(false);}}xh(t,o);var a=null==o?i:Ge({},i,o);(e.memoizedState=a,e.lanes===po)&&(e.updateQueue.baseState=a);}Ah=function(e,t){if(null!==e&&"function"!=typeof e){var n=t+"_"+e;Oh.has(n)||(Oh.add(n),o("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.",t,e));}},xh=function(e,t){if(void 0===t){var n=ct(e)||"Component";Ch.has(n)||(Ch.add(n),o("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",n));}},Object.defineProperty(Lh,"_processChildContext",{enumerable:false,value:function(){throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).")}}),Object.freeze(Lh);var Dh,jh,Bh,zh,Uh,Fh={isMounted:function(e){var t=gi.current;if(null!==t&&t.tag===u){var n=t,r=n.stateNode;r._warnedAboutRefsInRender||o("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.",ft(n)||"A component"),r._warnedAboutRefsInRender=true;}var i=Br(e);return !!i&&vi(i)===i},enqueueSetState:function(e,t,n){var r=Br(e),i=Zy(),o=Qy(r),a=fh(i,o);a.payload=t,null!=n&&(Ah(n,"setState"),a.callback=n);var s=hh(r,a,o);null!==s&&(Xy(s,r,o,i),ph(s,r,o)),ro(r,o);},enqueueReplaceState:function(e,t,n){var r=Br(e),i=Zy(),o=Qy(r),a=fh(i,o);a.tag=ah,a.payload=t,null!=n&&(Ah(n,"replaceState"),a.callback=n);var s=hh(r,a,o);null!==s&&(Xy(s,r,o,i),ph(s,r,o)),ro(r,o);},enqueueForceUpdate:function(e,t){var n=Br(e),r=Zy(),i=Qy(n),o=fh(r,i);o.tag=sh,null!=t&&(Ah(t,"forceUpdate"),o.callback=t);var a=hh(n,o,i);null!==a&&(Xy(a,n,i,r),ph(a,n,i)),function(e,t){null!==Fi&&"function"==typeof Fi.markForceUpdateScheduled&&Fi.markForceUpdateScheduled(e,t);}(n,i);}};function Kh(e,t,n,r,i,a,s){var u=e.stateNode;if("function"==typeof u.shouldComponentUpdate){var l=u.shouldComponentUpdate(r,a,s);if(e.mode&so){Hi(true);try{l=u.shouldComponentUpdate(r,a,s);}finally{Hi(false);}}return void 0===l&&o("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",ct(t)||"Component"),l}return !t.prototype||!t.prototype.isPureReactComponent||(!Au(n,r)||!Au(i,a))}function qh(e,t){t.updater=Fh,e.stateNode=t,function(e,t){e._reactInternals=t;}(t,e),t._reactInternalInstance=Lh;}function Hh(e,t,n){var r=false,i=ud,a=ud,s=t.contextType;if("contextType"in t&&(!(null===s||void 0!==s&&s.$$typeof===Le&&void 0===s._context)&&!Ph.has(t))){Ph.add(t);var u="";u=void 0===s?" However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.":"object"!=typeof s?" However, it is set to a "+typeof s+".":s.$$typeof===Pe?" Did you accidentally pass the Context.Provider instead?":void 0!==s._context?" Did you accidentally pass the Context.Consumer instead?":" However, it is set to an object with keys {"+Object.keys(s).join(", ")+"}.",o("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",ct(t)||"Component",u);}if("object"==typeof s&&null!==s)a=Zf(s);else {i=fd(0,t,true);var l=t.contextTypes;a=(r=null!=l)?pd(e,i):ud;}var c=new t(n,a);if(e.mode&so){Hi(true);try{c=new t(n,a);}finally{Hi(false);}}var d=e.memoizedState=null!==c.state&&void 0!==c.state?c.state:null;if(qh(e,c),"function"==typeof t.getDerivedStateFromProps&&null===d){var f=ct(t)||"Component";Eh.has(f)||(Eh.add(f),o("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",f,null===c.state?"null":"undefined",f));}if("function"==typeof t.getDerivedStateFromProps||"function"==typeof c.getSnapshotBeforeUpdate){var h=null,p=null,m=null;if("function"==typeof c.componentWillMount&&true!==c.componentWillMount.__suppressDeprecationWarning?h="componentWillMount":"function"==typeof c.UNSAFE_componentWillMount&&(h="UNSAFE_componentWillMount"),"function"==typeof c.componentWillReceiveProps&&true!==c.componentWillReceiveProps.__suppressDeprecationWarning?p="componentWillReceiveProps":"function"==typeof c.UNSAFE_componentWillReceiveProps&&(p="UNSAFE_componentWillReceiveProps"),"function"==typeof c.componentWillUpdate&&true!==c.componentWillUpdate.__suppressDeprecationWarning?m="componentWillUpdate":"function"==typeof c.UNSAFE_componentWillUpdate&&(m="UNSAFE_componentWillUpdate"),null!==h||null!==p||null!==m){var g=ct(t)||"Component",v="function"==typeof t.getDerivedStateFromProps?"getDerivedStateFromProps()":"getSnapshotBeforeUpdate()";Mh.has(g)||(Mh.add(g),o("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles",g,v,null!==h?"\n  "+h:"",null!==p?"\n  "+p:"",null!==m?"\n  "+m:""));}}return r&&hd(e,i,a),c}function Wh(e,t,n,r){var i=t.state;if("function"==typeof t.componentWillReceiveProps&&t.componentWillReceiveProps(n,r),"function"==typeof t.UNSAFE_componentWillReceiveProps&&t.UNSAFE_componentWillReceiveProps(n,r),t.state!==i){var a=ft(e)||"Component";Sh.has(a)||(Sh.add(a),o("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",a)),Fh.enqueueReplaceState(t,t.state,null);}}function $h(e,t,n,r){!function(e,t,n){var r=e.stateNode,i=ct(t)||"Component";r.render||(t.prototype&&"function"==typeof t.prototype.render?o("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?",i):o("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.",i)),!r.getInitialState||r.getInitialState.isReactClassApproved||r.state||o("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",i),r.getDefaultProps&&!r.getDefaultProps.isReactClassApproved&&o("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",i),r.propTypes&&o("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.",i),r.contextType&&o("contextType was defined as an instance property on %s. Use a static property to define contextType instead.",i),r.contextTypes&&o("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.",i),t.contextType&&t.contextTypes&&!Th.has(t)&&(Th.add(t),o("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.",i)),"function"==typeof r.componentShouldUpdate&&o("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",i),t.prototype&&t.prototype.isPureReactComponent&&void 0!==r.shouldComponentUpdate&&o("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",ct(t)||"A pure component"),"function"==typeof r.componentDidUnmount&&o("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",i),"function"==typeof r.componentDidReceiveProps&&o("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",i),"function"==typeof r.componentWillRecieveProps&&o("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",i),"function"==typeof r.UNSAFE_componentWillRecieveProps&&o("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",i);var a=r.props!==n;void 0!==r.props&&a&&o("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",i,i),r.defaultProps&&o("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",i,i),"function"!=typeof r.getSnapshotBeforeUpdate||"function"==typeof r.componentDidUpdate||kh.has(t)||(kh.add(t),o("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",ct(t))),"function"==typeof r.getDerivedStateFromProps&&o("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",i),"function"==typeof r.getDerivedStateFromError&&o("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",i),"function"==typeof t.getSnapshotBeforeUpdate&&o("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",i);var s=r.state;s&&("object"!=typeof s||Yt(s))&&o("%s.state: must be set to an object or null",i),"function"==typeof r.getChildContext&&"object"!=typeof t.childContextTypes&&o("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",i);}(e,t,n);var i=e.stateNode;i.props=n,i.state=e.memoizedState,i.refs=Ih,ch(e);var a=t.contextType;if("object"==typeof a&&null!==a)i.context=Zf(a);else {var s=fd(0,t,true);i.context=pd(e,s);}if(i.state===n){var u=ct(t)||"Component";Rh.has(u)||(Rh.add(u),o("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",u));}e.mode&so&&kf.recordLegacyContextWarning(e,i),kf.recordUnsafeLifecycleWarnings(e,i),i.state=e.memoizedState;var l=t.getDerivedStateFromProps;if("function"==typeof l&&(Nh(e,t,l,n),i.state=e.memoizedState),"function"==typeof t.getDerivedStateFromProps||"function"==typeof i.getSnapshotBeforeUpdate||"function"!=typeof i.UNSAFE_componentWillMount&&"function"!=typeof i.componentWillMount||(!function(e,t){var n=t.state;"function"==typeof t.componentWillMount&&t.componentWillMount(),"function"==typeof t.UNSAFE_componentWillMount&&t.UNSAFE_componentWillMount(),n!==t.state&&(o("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",ft(e)||"Component"),Fh.enqueueReplaceState(t,t.state,null));}(e,i),vh(e,n,i,r),i.state=e.memoizedState),"function"==typeof i.componentDidMount){var c=Kr;c|=si,(e.mode&uo)!==io&&(c|=li),e.flags|=c;}}var Vh;function Yh(e,t,n){var r=n.ref;if(null!==r&&"function"!=typeof r&&"object"!=typeof r){if((e.mode&so||z)&&(!n._owner||!n._self||n._owner.stateNode===n._self)){var i=ft(e)||"Component";Bh[i]||(o('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref',r),Bh[i]=true);}if(n._owner){var a,s=n._owner;if(s){var l=s;if(l.tag!==u)throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");a=l.stateNode;}if(!a)throw new Error("Missing owner for string ref "+r+". This error is likely caused by a bug in React. Please file an issue.");var c=a;!function(e,t){if(Q(e))o("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.",t,Z(e));}(r,"ref");var d=""+r;if(null!==t&&null!==t.ref&&"function"==typeof t.ref&&t.ref._stringRef===d)return t.ref;var f=function(e){var t=c.refs;t===Ih&&(t=c.refs={}),null===e?delete t[d]:t[d]=e;};return f._stringRef=d,f}if("string"!=typeof r)throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");if(!n._owner)throw new Error("Element ref was specified as a string ("+r+") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information.")}return r}function Gh(e,t){var n=Object.prototype.toString.call(t);throw new Error("Objects are not valid as a React child (found: "+("[object Object]"===n?"object with keys {"+Object.keys(t).join(", ")+"}":n)+"). If you meant to render a collection of children, use an array instead.")}function Zh(e){var t=ft(e)||"Component";Uh[t]||(Uh[t]=true,o("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it."));}function Qh(e){var t=e._payload;return (0, e._init)(t)}function Jh(e){function t(t,n){if(e){var r=t.deletions;null===r?(t.deletions=[n],t.flags|=qr):r.push(n);}}function n(n,r){if(!e)return null;for(var i=r;null!==i;)t(n,i),i=i.sibling;return null}function r(e,t){for(var n=new Map,r=t;null!==r;)null!==r.key?n.set(r.key,r):n.set(r.index,r),r=r.sibling;return n}function i(e,t){var n=l_(e,t);return n.index=0,n.sibling=null,n}function a(t,n,r){if(t.index=r,!e)return t.flags|=oi,n;var i=t.alternate;if(null!==i){var o=i.index;return o<n?(t.flags|=Fr,n):o}return t.flags|=Fr,n}function s(t){return e&&null===t.alternate&&(t.flags|=Fr),t}function u(e,t,n,r){if(null===t||t.tag!==h){var o=m_(n,e.mode,r);return o.return=e,o}var a=i(t,n);return a.return=e,a}function l(e,t,n,r){var o=n.type;if(o===Ae)return f(e,t,n.props.children,r,n.key);if(null!==t&&(t.elementType===o||Qw(t,n)||"object"==typeof o&&null!==o&&o.$$typeof===je&&Qh(o)===t.type)){var a=i(t,n.props);return a.ref=Yh(e,t,n),a.return=e,a._debugSource=n._source,a._debugOwner=n._owner,a}var s=f_(n,e.mode,r);return s.ref=Yh(e,t,n),s.return=e,s}function c(e,t,n,r){if(null===t||t.tag!==d||t.stateNode.containerInfo!==n.containerInfo||t.stateNode.implementation!==n.implementation){var o=g_(n,e.mode,r);return o.return=e,o}var a=i(t,n.children||[]);return a.return=e,a}function f(e,t,n,r,o){if(null===t||t.tag!==p){var a=h_(n,e.mode,r,o);return a.return=e,a}var s=i(t,n);return s.return=e,s}function m(e,t,n){if("string"==typeof t&&""!==t||"number"==typeof t){var r=m_(""+t,e.mode,n);return r.return=e,r}if("object"==typeof t&&null!==t){switch(t.$$typeof){case Ce:var i=f_(t,e.mode,n);return i.ref=Yh(e,null,t),i.return=e,i;case xe:var o=g_(t,e.mode,n);return o.return=e,o;case je:var a=t._payload;return m(e,(0, t._init)(a),n)}if(Yt(t)||Fe(t)){var s=h_(t,e.mode,n,null);return s.return=e,s}Gh(0,t);}return "function"==typeof t&&Zh(e),null}function g(e,t,n,r){var i=null!==t?t.key:null;if("string"==typeof n&&""!==n||"number"==typeof n)return null!==i?null:u(e,t,""+n,r);if("object"==typeof n&&null!==n){switch(n.$$typeof){case Ce:return n.key===i?l(e,t,n,r):null;case xe:return n.key===i?c(e,t,n,r):null;case je:var o=n._payload;return g(e,t,(0, n._init)(o),r)}if(Yt(n)||Fe(n))return null!==i?null:f(e,t,n,r,null);Gh(0,n);}return "function"==typeof n&&Zh(e),null}function v(e,t,n,r,i){if("string"==typeof r&&""!==r||"number"==typeof r)return u(t,e.get(n)||null,""+r,i);if("object"==typeof r&&null!==r){switch(r.$$typeof){case Ce:return l(t,e.get(null===r.key?n:r.key)||null,r,i);case xe:return c(t,e.get(null===r.key?n:r.key)||null,r,i);case je:var o=r._payload;return v(e,t,n,(0, r._init)(o),i)}if(Yt(r)||Fe(r))return f(t,e.get(n)||null,r,i,null);Gh(0,r);}return "function"==typeof r&&Zh(t),null}function b(e,t,n){if("object"!=typeof e||null===e)return t;switch(e.$$typeof){case Ce:case xe:Vh(e,n);var r=e.key;if("string"!=typeof r)break;if(null===t){(t=new Set).add(r);break}if(!t.has(r)){t.add(r);break}o("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",r);break;case je:var i=e._payload;b((0, e._init)(i),t,n);}return t}return function u(l,c,f,y){if("object"==typeof f&&null!==f&&f.type===Ae&&null===f.key&&(f=f.props.children),"object"==typeof f&&null!==f){switch(f.$$typeof){case Ce:return s(function(e,r,o,a){for(var s=o.key,u=r;null!==u;){if(u.key===s){var l=o.type;if(l===Ae){if(u.tag===p){n(e,u.sibling);var c=i(u,o.props.children);return c.return=e,c._debugSource=o._source,c._debugOwner=o._owner,c}}else if(u.elementType===l||Qw(u,o)||"object"==typeof l&&null!==l&&l.$$typeof===je&&Qh(l)===u.type){n(e,u.sibling);var d=i(u,o.props);return d.ref=Yh(e,u,o),d.return=e,d._debugSource=o._source,d._debugOwner=o._owner,d}n(e,u);break}t(e,u),u=u.sibling;}if(o.type===Ae){var f=h_(o.props.children,e.mode,a,o.key);return f.return=e,f}var h=f_(o,e.mode,a);return h.ref=Yh(e,r,o),h.return=e,h}(l,c,f,y));case xe:return s(function(e,r,o,a){for(var s=o.key,u=r;null!==u;){if(u.key===s){if(u.tag===d&&u.stateNode.containerInfo===o.containerInfo&&u.stateNode.implementation===o.implementation){n(e,u.sibling);var l=i(u,o.children||[]);return l.return=e,l}n(e,u);break}t(e,u),u=u.sibling;}var c=g_(o,e.mode,a);return c.return=e,c}(l,c,f,y));case je:var w=f._payload;return u(l,c,(0, f._init)(w),y)}if(Yt(f))return function(i,o,s,u){for(var l=null,c=0;c<s.length;c++)l=b(s[c],l,i);for(var d=null,f=null,h=o,p=0,y=0,w=null;null!==h&&y<s.length;y++){h.index>y?(w=h,h=null):w=h.sibling;var _=g(i,h,s[y],u);if(null===_){null===h&&(h=w);break}e&&h&&null===_.alternate&&t(i,h),p=a(_,p,y),null===f?d=_:f.sibling=_,f=_,h=w;}if(y===s.length)return n(i,h),wf()&&Kd(i,y),d;if(null===h){for(;y<s.length;y++){var S=m(i,s[y],u);null!==S&&(p=a(S,p,y),null===f?d=S:f.sibling=S,f=S);}return wf()&&Kd(i,y),d}for(var E=r(0,h);y<s.length;y++){var k=v(E,i,y,s[y],u);null!==k&&(e&&null!==k.alternate&&E.delete(null===k.key?y:k.key),p=a(k,p,y),null===f?d=k:f.sibling=k,f=k);}return e&&E.forEach((function(e){return t(i,e)})),wf()&&Kd(i,y),d}(l,c,f,y);if(Fe(f))return function(i,s,u,l){var c=Fe(u);if("function"!=typeof c)throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");"function"==typeof Symbol&&"Generator"===u[Symbol.toStringTag]&&(jh||o("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."),jh=true),u.entries===c&&(Dh||o("Using Maps as children is not supported. Use an array of keyed ReactElements instead."),Dh=true);var d=c.call(u);if(d)for(var f=null,h=d.next();!h.done;h=d.next())f=b(h.value,f,i);var p=c.call(u);if(null==p)throw new Error("An iterable object provided no iterator.");for(var y=null,w=null,_=s,S=0,E=0,k=null,M=p.next();null!==_&&!M.done;E++,M=p.next()){_.index>E?(k=_,_=null):k=_.sibling;var C=g(i,_,M.value,l);if(null===C){null===_&&(_=k);break}e&&_&&null===C.alternate&&t(i,_),S=a(C,S,E),null===w?y=C:w.sibling=C,w=C,_=k;}if(M.done)return n(i,_),wf()&&Kd(i,E),y;if(null===_){for(;!M.done;E++,M=p.next()){var x=m(i,M.value,l);null!==x&&(S=a(x,S,E),null===w?y=x:w.sibling=x,w=x);}return wf()&&Kd(i,E),y}for(var A=r(0,_);!M.done;E++,M=p.next()){var R=v(A,i,E,M.value,l);null!==R&&(e&&null!==R.alternate&&A.delete(null===R.key?E:R.key),S=a(R,S,E),null===w?y=R:w.sibling=R,w=R);}return e&&A.forEach((function(e){return t(i,e)})),wf()&&Kd(i,E),y}(l,c,f,y);Gh(0,f);}return "string"==typeof f&&""!==f||"number"==typeof f?s(function(e,t,r,o){if(null!==t&&t.tag===h){n(e,t.sibling);var a=i(t,r);return a.return=e,a}n(e,t);var s=m_(r,e.mode,o);return s.return=e,s}(l,c,""+f,y)):("function"==typeof f&&Zh(l),n(l,c))}}Dh=false,jh=false,Bh={},zh={},Uh={},Vh=function(e,t){if(null!==e&&"object"==typeof e&&e._store&&!e._store.validated&&null==e.key){if("object"!=typeof e._store)throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");e._store.validated=true;var n=ft(t)||"Component";zh[n]||(zh[n]=true,o('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));}};var Xh=Jh(true),ep=Jh(false);function tp(e,t){for(var n=e.child;null!==n;)c_(n,t),n=n.sibling;}var np={},rp=od(np),ip=od(np),op=od(np);function ap(e){if(e===np)throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");return e}function sp(){return ap(op.current)}function up(e,t){sd(op,t,e),sd(ip,e,e),sd(rp,np,e);var n=function(e){var t,n,r=e.nodeType;switch(r){case vn:case bn:t=r===vn?"#document":"#fragment";var i=e.documentElement;n=i?i.namespaceURI:cn(null,"");break;default:var o=r===gn?e.parentNode:e;n=cn(o.namespaceURI||null,t=o.tagName);}var a=t.toLowerCase();return {namespace:n,ancestorInfo:Xl(null,a)}}(t);ad(rp,e),sd(rp,n,e);}function lp(e){ad(rp,e),ad(ip,e),ad(op,e);}function cp(){return ap(rp.current)}function dp(e){ap(op.current);var t,n,r,i=ap(rp.current),o=(t=i,n=e.type,{namespace:cn((r=t).namespace,n),ancestorInfo:Xl(r.ancestorInfo,n)});i!==o&&(sd(ip,e,e),sd(rp,o,e));}function fp(e){ip.current===e&&(ad(rp,e),ad(ip,e));}var hp=1,pp=1,mp=2,gp=od(0);function vp(e,t){return 0!=(e&t)}function bp(e){return e&hp}function yp(e,t){return e&hp|t}function wp(e,t){sd(gp,t,e);}function _p(e){ad(gp,e);}function Sp(e,t){var n=e.memoizedState;return null!==n?null!==n.dehydrated:(e.memoizedProps,true)}function Ep(e){for(var t=e;null!==t;){if(t.tag===w){var n=t.memoizedState;if(null!==n){var r=n.dehydrated;if(null===r||Rc(r)||Tc(r))return t}}else if(t.tag===C&&void 0!==t.memoizedProps.revealOrder){if((t.flags&$r)!==zr)return t}else if(null!==t.child){t.child.return=t,t=t.child;continue}if(t===e)return null;for(;null===t.sibling;){if(null===t.return||t.return===e)return null;t=t.return;}t.sibling.return=t.return,t=t.sibling;}return null}var kp=0,Mp=1,Cp=2,xp=4,Ap=8,Rp=[];function Tp(){for(var e=0;e<Rp.length;e++){Rp[e]._workInProgressVersionPrimary=null;}Rp.length=0;}function Pp(e,t){var n=(0, t._getVersion)(t._source);null==e.mutableSourceEagerHydrationData?e.mutableSourceEagerHydrationData=[t,n]:e.mutableSourceEagerHydrationData.push(t,n);}var Lp,Ip,Op=n.ReactCurrentDispatcher,Np=n.ReactCurrentBatchConfig;Lp=new Set;var Dp=po,jp=null,Bp=null,zp=null,Up=false,Fp=false,Kp=0,qp=0,Hp=25,Wp=null,$p=null,Vp=-1,Yp=false;function Gp(){var e=Wp;null===$p?$p=[e]:$p.push(e);}function Zp(){var e=Wp;null!==$p&&(Vp++,$p[Vp]!==e&&function(e){var t=ft(jp);if(!Lp.has(t)&&(Lp.add(t),null!==$p)){for(var n="",r=30,i=0;i<=Vp;i++){for(var a=$p[i],s=i===Vp?e:a,u=i+1+". "+a;u.length<r;)u+=" ";n+=u+=s+"\n";}o("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n",t,n);}}(e));}function Qp(e){null==e||Yt(e)||o("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",Wp,typeof e);}function Jp(){throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.")}function Xp(e,t){if(Yp)return  false;if(null===t)return o("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",Wp),false;e.length!==t.length&&o("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s",Wp,"["+t.join(", ")+"]","["+e.join(", ")+"]");for(var n=0;n<t.length&&n<e.length;n++)if(!xu(e[n],t[n]))return  false;return  true}function em(e,t,n,r,i,a){Dp=a,jp=t,$p=null!==e?e._debugHookTypes:null,Vp=-1,Yp=null!==e&&e.type!==t.type,t.memoizedState=null,t.updateQueue=null,t.lanes=po,null!==e&&null!==e.memoizedState?Op.current=ag:Op.current=null!==$p?og:ig;var s=n(r,i);if(Fp){var u=0;do{if(Fp=false,Kp=0,u>=Hp)throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");u+=1,Yp=false,Bp=null,zp=null,t.updateQueue=null,Vp=-1,Op.current=sg,s=n(r,i);}while(Fp)}Op.current=rg,t._debugHookTypes=$p;var l=null!==Bp&&null!==Bp.next;if(Dp=po,jp=null,Bp=null,zp=null,Wp=null,$p=null,Vp=-1,null!==e&&(e.flags&mi)!=(t.flags&mi)&&(e.mode&oo)!==io&&o("Internal React error: Expected static flag was missing. Please notify the React team."),Up=false,l)throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");return s}function tm(){var e=0!==Kp;return Kp=0,e}function nm(e,t,n){t.updateQueue=e.updateQueue,(t.mode&uo)!==io?t.flags&=-50333701:t.flags&=-2053,e.lanes=va(e.lanes,n);}function rm(){if(Op.current=rg,Up){for(var e=jp.memoizedState;null!==e;){var t=e.queue;null!==t&&(t.pending=null),e=e.next;}Up=false;}Dp=po,jp=null,Bp=null,zp=null,$p=null,Vp=-1,Wp=null,Ym=false,Fp=false,Kp=0;}function im(){var e={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};return null===zp?jp.memoizedState=zp=e:zp=zp.next=e,zp}function om(){var e,t;if(null===Bp){var n=jp.alternate;e=null!==n?n.memoizedState:null;}else e=Bp.next;if(null!==(t=null===zp?jp.memoizedState:zp.next))t=(zp=t).next,Bp=e;else {if(null===e)throw new Error("Rendered more hooks than during the previous render.");var r={memoizedState:(Bp=e).memoizedState,baseState:Bp.baseState,baseQueue:Bp.baseQueue,queue:Bp.queue,next:null};null===zp?jp.memoizedState=zp=r:zp=zp.next=r;}return zp}function am(e,t){return "function"==typeof t?t(e):t}function sm(e,t,n){var r,i=im();r=void 0!==n?n(t):t,i.memoizedState=i.baseState=r;var o={pending:null,interleaved:null,lanes:po,dispatch:null,lastRenderedReducer:e,lastRenderedState:r};i.queue=o;var a=o.dispatch=Qm.bind(null,jp,o);return [i.memoizedState,a]}function um(e,t,n){var r=om(),i=r.queue;if(null===i)throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");i.lastRenderedReducer=e;var a=Bp,s=a.baseQueue,u=i.pending;if(null!==u){if(null!==s){var l=s.next,c=u.next;s.next=c,u.next=l;}a.baseQueue!==s&&o("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."),a.baseQueue=s=u,i.pending=null;}if(null!==s){var d=s.next,f=a.baseState,h=null,p=null,m=null,g=d;do{var v=g.lane;if(ma(Dp,v)){if(null!==m){var b={lane:mo,action:g.action,hasEagerState:g.hasEagerState,eagerState:g.eagerState,next:null};m=m.next=b;}if(g.hasEagerState)f=g.eagerState;else f=e(f,g.action);}else {var y={lane:v,action:g.action,hasEagerState:g.hasEagerState,eagerState:g.eagerState,next:null};null===m?(p=m=y,h=f):m=m.next=y,jp.lanes=ga(jp.lanes,v),mw(v);}g=g.next;}while(null!==g&&g!==d);null===m?h=f:m.next=p,xu(f,r.memoizedState)||xv(),r.memoizedState=f,r.baseState=h,r.baseQueue=m,i.lastRenderedState=f;}var w=i.interleaved;if(null!==w){var _=w;do{var S=_.lane;jp.lanes=ga(jp.lanes,S),mw(S),_=_.next;}while(_!==w)}else null===s&&(i.lanes=po);var E=i.dispatch;return [r.memoizedState,E]}function lm(e,t,n){var r=om(),i=r.queue;if(null===i)throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");i.lastRenderedReducer=e;var o=i.dispatch,a=i.pending,s=r.memoizedState;if(null!==a){i.pending=null;var u=a.next,l=u;do{s=e(s,l.action),l=l.next;}while(l!==u);xu(s,r.memoizedState)||xv(),r.memoizedState=s,null===r.baseQueue&&(r.baseState=s),i.lastRenderedState=s;}return [s,o]}function cm(e,t,n){var r,i=jp,a=im();if(wf()){if(void 0===n)throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");r=n(),Ip||r!==n()&&(o("The result of getServerSnapshot should be cached to avoid an infinite loop"),Ip=true);}else {if(r=t(),!Ip){var s=t();xu(r,s)||(o("The result of getSnapshot should be cached to avoid an infinite loop"),Ip=true);}var u=Gy();if(null===u)throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");sa(0,Dp)||fm(i,t,r);}a.memoizedState=r;var l={value:r,getSnapshot:t};return a.queue=l,Mm(pm.bind(null,i,l,e),[e]),i.flags|=Zr,wm(Mp|Ap,hm.bind(null,i,l,r,t),void 0,null),r}function dm(e,t,n){var r=jp,i=om(),a=t();if(!Ip){var s=t();xu(a,s)||(o("The result of getSnapshot should be cached to avoid an infinite loop"),Ip=true);}var u=i.memoizedState,l=!xu(u,a);l&&(i.memoizedState=a,xv());var c=i.queue;if(Cm(pm.bind(null,r,c,e),[e]),c.getSnapshot!==t||l||null!==zp&&zp.memoizedState.tag&Mp){r.flags|=Zr,wm(Mp|Ap,hm.bind(null,r,c,a,t),void 0,null);var d=Gy();if(null===d)throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");sa(0,Dp)||fm(r,t,a);}return a}function fm(e,t,n){e.flags|=Xr;var r={getSnapshot:t,value:n},i=jp.updateQueue;if(null===i)i={lastEffect:null,stores:null},jp.updateQueue=i,i.stores=[r];else {var o=i.stores;null===o?i.stores=[r]:o.push(r);}}function hm(e,t,n,r){t.value=n,t.getSnapshot=r,mm(t)&&gm(e);}function pm(e,t,n){return n((function(){mm(t)&&gm(e);}))}function mm(e){var t=e.getSnapshot,n=e.value;try{var r=t();return !xu(n,r)}catch(e){return  true}}function gm(e){var t=eh(e,go);null!==t&&Xy(t,e,go,Jo);}function vm(e){var t=im();"function"==typeof e&&(e=e()),t.memoizedState=t.baseState=e;var n={pending:null,interleaved:null,lanes:po,dispatch:null,lastRenderedReducer:am,lastRenderedState:e};t.queue=n;var r=n.dispatch=Jm.bind(null,jp,n);return [t.memoizedState,r]}function bm(e){return um(am)}function ym(e){return lm(am)}function wm(e,t,n,r){var i={tag:e,create:t,destroy:n,deps:r,next:null},o=jp.updateQueue;if(null===o)o={lastEffect:null,stores:null},jp.updateQueue=o,o.lastEffect=i.next=i;else {var a=o.lastEffect;if(null===a)o.lastEffect=i.next=i;else {var s=a.next;a.next=i,i.next=s,o.lastEffect=i;}}return i}function _m(e){var t={current:e};return im().memoizedState=t,t}function Sm(e){return om().memoizedState}function Em(e,t,n,r){var i=im(),o=void 0===r?null:r;jp.flags|=e,i.memoizedState=wm(Mp|t,n,void 0,o);}function km(e,t,n,r){var i=om(),o=void 0===r?null:r,a=void 0;if(null!==Bp){var s=Bp.memoizedState;if(a=s.destroy,null!==o)if(Xp(o,s.deps))return void(i.memoizedState=wm(t,n,a,o))}jp.flags|=e,i.memoizedState=wm(Mp|t,n,a,o);}function Mm(e,t){return (jp.mode&uo)!==io?Em(ci|Zr|ui,Ap,e,t):Em(Zr|ui,Ap,e,t)}function Cm(e,t){return km(Zr,Ap,e,t)}function xm(e,t){return Em(Kr,Cp,e,t)}function Am(e,t){return km(Kr,Cp,e,t)}function Rm(e,t){var n=Kr;return n|=si,(jp.mode&uo)!==io&&(n|=li),Em(n,xp,e,t)}function Tm(e,t){return km(Kr,xp,e,t)}function Pm(e,t){if("function"==typeof t){var n=t,r=e();return n(r),function(){n(null);}}if(null!=t){var i=t;i.hasOwnProperty("current")||o("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.","an object with keys {"+Object.keys(i).join(", ")+"}");var a=e();return i.current=a,function(){i.current=null;}}}function Lm(e,t,n){"function"!=typeof t&&o("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",null!==t?typeof t:"null");var r=null!=n?n.concat([e]):null,i=Kr;return i|=si,(jp.mode&uo)!==io&&(i|=li),Em(i,xp,Pm.bind(null,t,e),r)}function Im(e,t,n){"function"!=typeof t&&o("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",null!==t?typeof t:"null");var r=null!=n?n.concat([e]):null;return km(Kr,xp,Pm.bind(null,t,e),r)}function Om(e,t){}var Nm=Om;function Dm(e,t){var n=void 0===t?null:t;return im().memoizedState=[e,n],e}function jm(e,t){var n=om(),r=void 0===t?null:t,i=n.memoizedState;if(null!==i&&(null!==r&&Xp(r,i[1])))return i[0];return n.memoizedState=[e,r],e}function Bm(e,t){var n=im(),r=void 0===t?null:t,i=e();return n.memoizedState=[i,r],i}function zm(e,t){var n=om(),r=void 0===t?null:t,i=n.memoizedState;if(null!==i&&(null!==r&&Xp(r,i[1])))return i[0];var o=e();return n.memoizedState=[o,r],o}function Um(e){return im().memoizedState=e,e}function Fm(e){return qm(om(),Bp.memoizedState,e)}function Km(e){var t=om();return null===Bp?(t.memoizedState=e,e):qm(t,Bp.memoizedState,e)}function qm(e,t,n){if(!((Dp&(go|bo|wo))===po)){if(!xu(n,t)){var r=la();jp.lanes=ga(jp.lanes,r),mw(r),e.baseState=true;}return t}return e.baseState&&(e.baseState=false,xv()),e.memoizedState=n,n}function Hm(e,t,n){var r=Na();Da(function(e,t){return 0!==e&&e<t?e:t}(r,Pa)),e(true);var o=Np.transition;Np.transition={};var a=Np.transition;Np.transition._updatedFibers=new Set;try{e(!1),t();}finally{if(Da(r),Np.transition=o,null===o&&a._updatedFibers)a._updatedFibers.size>10&&i("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."),a._updatedFibers.clear();}}function Wm(){var e=vm(false),t=e[0],n=e[1],r=Hm.bind(null,n);return im().memoizedState=r,[t,r]}function $m(){return [bm()[0],om().memoizedState]}function Vm(){return [ym()[0],om().memoizedState]}var Ym=false;function Gm(){var e,t=im(),n=Gy().identifierPrefix;if(wf()){e=":"+n+"R"+Fd();var r=Kp++;r>0&&(e+="H"+r.toString(32)),e+=":";}else {e=":"+n+"r"+(qp++).toString(32)+":";}return t.memoizedState=e,e}function Zm(){return om().memoizedState}function Qm(e,t,n){"function"==typeof arguments[3]&&o("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");var r=Qy(e),i={lane:r,action:n,hasEagerState:false,eagerState:null,next:null};if(Xm(e))eg(t,i);else {var a=Xf(e,t,i,r);if(null!==a)Xy(a,e,r,Zy()),tg(a,t,r);}ng(e,r);}function Jm(e,t,n){"function"==typeof arguments[3]&&o("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");var r=Qy(e),i={lane:r,action:n,hasEagerState:false,eagerState:null,next:null};if(Xm(e))eg(t,i);else {var a=e.alternate;if(e.lanes===po&&(null===a||a.lanes===po)){var s=t.lastRenderedReducer;if(null!==s){var u;u=Op.current,Op.current=lg;try{var l=t.lastRenderedState,c=s(l,n);if(i.hasEagerState=!0,i.eagerState=c,xu(c,l))return void function(e,t,n,r){var i=t.interleaved;null===i?(n.next=n,Jf(t)):(n.next=i.next,i.next=n),t.interleaved=n;}(0,t,i)}catch(e){}finally{Op.current=u;}}}var d=Xf(e,t,i,r);if(null!==d)Xy(d,e,r,Zy()),tg(d,t,r);}ng(e,r);}function Xm(e){var t=e.alternate;return e===jp||null!==t&&t===jp}function eg(e,t){Fp=Up=true;var n=e.pending;null===n?t.next=t:(t.next=n.next,n.next=t),e.pending=t;}function tg(e,t,n){if(ua(n)){var r=t.lanes,i=ga(r=ba(r,e.pendingLanes),n);t.lanes=i,Sa(e,i);}}function ng(e,t,n){ro(e,t);}var rg={readContext:Zf,useCallback:Jp,useContext:Jp,useEffect:Jp,useImperativeHandle:Jp,useInsertionEffect:Jp,useLayoutEffect:Jp,useMemo:Jp,useReducer:Jp,useRef:Jp,useState:Jp,useDebugValue:Jp,useDeferredValue:Jp,useTransition:Jp,useMutableSource:Jp,useSyncExternalStore:Jp,useId:Jp,unstable_isNewReconciler:I},ig=null,og=null,ag=null,sg=null,ug=null,lg=null,cg=null,dg=function(){o("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");},fg=function(){o("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");};ig={readContext:function(e){return Zf(e)},useCallback:function(e,t){return Wp="useCallback",Gp(),Qp(t),Dm(e,t)},useContext:function(e){return Wp="useContext",Gp(),Zf(e)},useEffect:function(e,t){return Wp="useEffect",Gp(),Qp(t),Mm(e,t)},useImperativeHandle:function(e,t,n){return Wp="useImperativeHandle",Gp(),Qp(n),Lm(e,t,n)},useInsertionEffect:function(e,t){return Wp="useInsertionEffect",Gp(),Qp(t),xm(e,t)},useLayoutEffect:function(e,t){return Wp="useLayoutEffect",Gp(),Qp(t),Rm(e,t)},useMemo:function(e,t){Wp="useMemo",Gp(),Qp(t);var n=Op.current;Op.current=ug;try{return Bm(e,t)}finally{Op.current=n;}},useReducer:function(e,t,n){Wp="useReducer",Gp();var r=Op.current;Op.current=ug;try{return sm(e,t,n)}finally{Op.current=r;}},useRef:function(e){return Wp="useRef",Gp(),_m(e)},useState:function(e){Wp="useState",Gp();var t=Op.current;Op.current=ug;try{return vm(e)}finally{Op.current=t;}},useDebugValue:function(e,t){Wp="useDebugValue",Gp();},useDeferredValue:function(e){return Wp="useDeferredValue",Gp(),Um(e)},useTransition:function(){return Wp="useTransition",Gp(),Wm()},useMutableSource:function(e,t,n){Wp="useMutableSource",Gp();},useSyncExternalStore:function(e,t,n){return Wp="useSyncExternalStore",Gp(),cm(e,t,n)},useId:function(){return Wp="useId",Gp(),Gm()},unstable_isNewReconciler:I},og={readContext:function(e){return Zf(e)},useCallback:function(e,t){return Wp="useCallback",Zp(),Dm(e,t)},useContext:function(e){return Wp="useContext",Zp(),Zf(e)},useEffect:function(e,t){return Wp="useEffect",Zp(),Mm(e,t)},useImperativeHandle:function(e,t,n){return Wp="useImperativeHandle",Zp(),Lm(e,t,n)},useInsertionEffect:function(e,t){return Wp="useInsertionEffect",Zp(),xm(e,t)},useLayoutEffect:function(e,t){return Wp="useLayoutEffect",Zp(),Rm(e,t)},useMemo:function(e,t){Wp="useMemo",Zp();var n=Op.current;Op.current=ug;try{return Bm(e,t)}finally{Op.current=n;}},useReducer:function(e,t,n){Wp="useReducer",Zp();var r=Op.current;Op.current=ug;try{return sm(e,t,n)}finally{Op.current=r;}},useRef:function(e){return Wp="useRef",Zp(),_m(e)},useState:function(e){Wp="useState",Zp();var t=Op.current;Op.current=ug;try{return vm(e)}finally{Op.current=t;}},useDebugValue:function(e,t){Wp="useDebugValue",Zp();},useDeferredValue:function(e){return Wp="useDeferredValue",Zp(),Um(e)},useTransition:function(){return Wp="useTransition",Zp(),Wm()},useMutableSource:function(e,t,n){Wp="useMutableSource",Zp();},useSyncExternalStore:function(e,t,n){return Wp="useSyncExternalStore",Zp(),cm(e,t,n)},useId:function(){return Wp="useId",Zp(),Gm()},unstable_isNewReconciler:I},ag={readContext:function(e){return Zf(e)},useCallback:function(e,t){return Wp="useCallback",Zp(),jm(e,t)},useContext:function(e){return Wp="useContext",Zp(),Zf(e)},useEffect:function(e,t){return Wp="useEffect",Zp(),Cm(e,t)},useImperativeHandle:function(e,t,n){return Wp="useImperativeHandle",Zp(),Im(e,t,n)},useInsertionEffect:function(e,t){return Wp="useInsertionEffect",Zp(),Am(e,t)},useLayoutEffect:function(e,t){return Wp="useLayoutEffect",Zp(),Tm(e,t)},useMemo:function(e,t){Wp="useMemo",Zp();var n=Op.current;Op.current=lg;try{return zm(e,t)}finally{Op.current=n;}},useReducer:function(e,t,n){Wp="useReducer",Zp();var r=Op.current;Op.current=lg;try{return um(e)}finally{Op.current=r;}},useRef:function(e){return Wp="useRef",Zp(),Sm()},useState:function(e){Wp="useState",Zp();var t=Op.current;Op.current=lg;try{return bm()}finally{Op.current=t;}},useDebugValue:function(e,t){return Wp="useDebugValue",Zp(),Nm()},useDeferredValue:function(e){return Wp="useDeferredValue",Zp(),Fm(e)},useTransition:function(){return Wp="useTransition",Zp(),$m()},useMutableSource:function(e,t,n){Wp="useMutableSource",Zp();},useSyncExternalStore:function(e,t,n){return Wp="useSyncExternalStore",Zp(),dm(e,t)},useId:function(){return Wp="useId",Zp(),Zm()},unstable_isNewReconciler:I},sg={readContext:function(e){return Zf(e)},useCallback:function(e,t){return Wp="useCallback",Zp(),jm(e,t)},useContext:function(e){return Wp="useContext",Zp(),Zf(e)},useEffect:function(e,t){return Wp="useEffect",Zp(),Cm(e,t)},useImperativeHandle:function(e,t,n){return Wp="useImperativeHandle",Zp(),Im(e,t,n)},useInsertionEffect:function(e,t){return Wp="useInsertionEffect",Zp(),Am(e,t)},useLayoutEffect:function(e,t){return Wp="useLayoutEffect",Zp(),Tm(e,t)},useMemo:function(e,t){Wp="useMemo",Zp();var n=Op.current;Op.current=cg;try{return zm(e,t)}finally{Op.current=n;}},useReducer:function(e,t,n){Wp="useReducer",Zp();var r=Op.current;Op.current=cg;try{return lm(e)}finally{Op.current=r;}},useRef:function(e){return Wp="useRef",Zp(),Sm()},useState:function(e){Wp="useState",Zp();var t=Op.current;Op.current=cg;try{return ym()}finally{Op.current=t;}},useDebugValue:function(e,t){return Wp="useDebugValue",Zp(),Nm()},useDeferredValue:function(e){return Wp="useDeferredValue",Zp(),Km(e)},useTransition:function(){return Wp="useTransition",Zp(),Vm()},useMutableSource:function(e,t,n){Wp="useMutableSource",Zp();},useSyncExternalStore:function(e,t,n){return Wp="useSyncExternalStore",Zp(),dm(e,t)},useId:function(){return Wp="useId",Zp(),Zm()},unstable_isNewReconciler:I},ug={readContext:function(e){return dg(),Zf(e)},useCallback:function(e,t){return Wp="useCallback",fg(),Gp(),Dm(e,t)},useContext:function(e){return Wp="useContext",fg(),Gp(),Zf(e)},useEffect:function(e,t){return Wp="useEffect",fg(),Gp(),Mm(e,t)},useImperativeHandle:function(e,t,n){return Wp="useImperativeHandle",fg(),Gp(),Lm(e,t,n)},useInsertionEffect:function(e,t){return Wp="useInsertionEffect",fg(),Gp(),xm(e,t)},useLayoutEffect:function(e,t){return Wp="useLayoutEffect",fg(),Gp(),Rm(e,t)},useMemo:function(e,t){Wp="useMemo",fg(),Gp();var n=Op.current;Op.current=ug;try{return Bm(e,t)}finally{Op.current=n;}},useReducer:function(e,t,n){Wp="useReducer",fg(),Gp();var r=Op.current;Op.current=ug;try{return sm(e,t,n)}finally{Op.current=r;}},useRef:function(e){return Wp="useRef",fg(),Gp(),_m(e)},useState:function(e){Wp="useState",fg(),Gp();var t=Op.current;Op.current=ug;try{return vm(e)}finally{Op.current=t;}},useDebugValue:function(e,t){Wp="useDebugValue",fg(),Gp();},useDeferredValue:function(e){return Wp="useDeferredValue",fg(),Gp(),Um(e)},useTransition:function(){return Wp="useTransition",fg(),Gp(),Wm()},useMutableSource:function(e,t,n){Wp="useMutableSource",fg(),Gp();},useSyncExternalStore:function(e,t,n){return Wp="useSyncExternalStore",fg(),Gp(),cm(e,t,n)},useId:function(){return Wp="useId",fg(),Gp(),Gm()},unstable_isNewReconciler:I},lg={readContext:function(e){return dg(),Zf(e)},useCallback:function(e,t){return Wp="useCallback",fg(),Zp(),jm(e,t)},useContext:function(e){return Wp="useContext",fg(),Zp(),Zf(e)},useEffect:function(e,t){return Wp="useEffect",fg(),Zp(),Cm(e,t)},useImperativeHandle:function(e,t,n){return Wp="useImperativeHandle",fg(),Zp(),Im(e,t,n)},useInsertionEffect:function(e,t){return Wp="useInsertionEffect",fg(),Zp(),Am(e,t)},useLayoutEffect:function(e,t){return Wp="useLayoutEffect",fg(),Zp(),Tm(e,t)},useMemo:function(e,t){Wp="useMemo",fg(),Zp();var n=Op.current;Op.current=lg;try{return zm(e,t)}finally{Op.current=n;}},useReducer:function(e,t,n){Wp="useReducer",fg(),Zp();var r=Op.current;Op.current=lg;try{return um(e)}finally{Op.current=r;}},useRef:function(e){return Wp="useRef",fg(),Zp(),Sm()},useState:function(e){Wp="useState",fg(),Zp();var t=Op.current;Op.current=lg;try{return bm()}finally{Op.current=t;}},useDebugValue:function(e,t){return Wp="useDebugValue",fg(),Zp(),Nm()},useDeferredValue:function(e){return Wp="useDeferredValue",fg(),Zp(),Fm(e)},useTransition:function(){return Wp="useTransition",fg(),Zp(),$m()},useMutableSource:function(e,t,n){Wp="useMutableSource",fg(),Zp();},useSyncExternalStore:function(e,t,n){return Wp="useSyncExternalStore",fg(),Zp(),dm(e,t)},useId:function(){return Wp="useId",fg(),Zp(),Zm()},unstable_isNewReconciler:I},cg={readContext:function(e){return dg(),Zf(e)},useCallback:function(e,t){return Wp="useCallback",fg(),Zp(),jm(e,t)},useContext:function(e){return Wp="useContext",fg(),Zp(),Zf(e)},useEffect:function(e,t){return Wp="useEffect",fg(),Zp(),Cm(e,t)},useImperativeHandle:function(e,t,n){return Wp="useImperativeHandle",fg(),Zp(),Im(e,t,n)},useInsertionEffect:function(e,t){return Wp="useInsertionEffect",fg(),Zp(),Am(e,t)},useLayoutEffect:function(e,t){return Wp="useLayoutEffect",fg(),Zp(),Tm(e,t)},useMemo:function(e,t){Wp="useMemo",fg(),Zp();var n=Op.current;Op.current=lg;try{return zm(e,t)}finally{Op.current=n;}},useReducer:function(e,t,n){Wp="useReducer",fg(),Zp();var r=Op.current;Op.current=lg;try{return lm(e)}finally{Op.current=r;}},useRef:function(e){return Wp="useRef",fg(),Zp(),Sm()},useState:function(e){Wp="useState",fg(),Zp();var t=Op.current;Op.current=lg;try{return ym()}finally{Op.current=t;}},useDebugValue:function(e,t){return Wp="useDebugValue",fg(),Zp(),Nm()},useDeferredValue:function(e){return Wp="useDeferredValue",fg(),Zp(),Km(e)},useTransition:function(){return Wp="useTransition",fg(),Zp(),Vm()},useMutableSource:function(e,t,n){Wp="useMutableSource",fg(),Zp();},useSyncExternalStore:function(e,t,n){return Wp="useSyncExternalStore",fg(),Zp(),dm(e,t)},useId:function(){return Wp="useId",fg(),Zp(),Zm()},unstable_isNewReconciler:I};var hg=t.unstable_now,pg=0,mg=-1,gg=-1,vg=-1,bg=false,yg=false;function wg(){return bg}function _g(){return pg}function Sg(){pg=hg();}function Eg(e){gg=hg(),e.actualStartTime<0&&(e.actualStartTime=hg());}function kg(e){gg=-1;}function Mg(e,t){if(gg>=0){var n=hg()-gg;e.actualDuration+=n,t&&(e.selfBaseDuration=n),gg=-1;}}function Cg(e){if(mg>=0){var t=hg()-mg;mg=-1;for(var n=e.return;null!==n;){switch(n.tag){case c:return void(n.stateNode.effectDuration+=t);case y:return void(n.stateNode.effectDuration+=t)}n=n.return;}}}function xg(e){if(vg>=0){var t=hg()-vg;vg=-1;for(var n=e.return;null!==n;){switch(n.tag){case c:var r=n.stateNode;return void(null!==r&&(r.passiveEffectDuration+=t));case y:var i=n.stateNode;return void(null!==i&&(i.passiveEffectDuration+=t))}n=n.return;}}}function Ag(){mg=hg();}function Rg(){vg=hg();}function Tg(e){for(var t=e.child;t;)e.actualDuration+=t.actualDuration,t=t.sibling;}function Pg(e,t){return {value:e,source:t,stack:ut(t),digest:null}}function Lg(e,t,n){return {value:e,source:null,stack:null!=n?n:null,digest:null!=t?t:null}}function Ig(e,t){try{0;var n=t.value,r=t.source,i=t.stack,o=null!==i?i:"";if(null!=n&&n._suppressLogging){if(e.tag===u)return;console.error(n);}var a=r?ft(r):null,s=(a?"The above error occurred in the <"+a+"> component:":"The above error occurred in one of your React components:")+"\n"+o+"\n\n"+(e.tag===c?"Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.":"React will try to recreate this component tree from scratch using the error boundary you provided, "+(ft(e)||"Anonymous")+".");console.error(s);}catch(e){setTimeout((function(){throw e}));}}var Og="function"==typeof WeakMap?WeakMap:Map;function Ng(e,t,n){var r=fh(Jo,n);r.tag=uh,r.payload={element:null};var i=t.value;return r.callback=function(){Mw(i),Ig(e,t);},r}function Dg(e,t,n){var r=fh(Jo,n);r.tag=uh;var i=e.type.getDerivedStateFromError;if("function"==typeof i){var a=t.value;r.payload=function(){return i(a)},r.callback=function(){Jw(e),Ig(e,t);};}var s=e.stateNode;return null!==s&&"function"==typeof s.componentDidCatch&&(r.callback=function(){Jw(e),Ig(e,t),"function"!=typeof i&&function(e){null===Ly?Ly=new Set([e]):Ly.add(e);}(this);var n=t.value,r=t.stack;this.componentDidCatch(n,{componentStack:null!==r?r:""}),"function"!=typeof i&&(pa(e.lanes,go)||o("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",ft(e)||"Unknown"));}),r}function jg(e,t,n){var r,i=e.pingCache;if(null===i?(i=e.pingCache=new Og,r=new Set,i.set(t,r)):void 0===(r=i.get(t))&&(r=new Set,i.set(t,r)),!r.has(n)){r.add(n);var o=Aw.bind(null,e,t,n);qi&&zw(e,n),t.then(o,o);}}function Bg(e){var t=e;do{if(t.tag===w&&Sp(t))return t;t=t.return;}while(null!==t);return null}function zg(e,t,n,r,i){if((e.mode&oo)===io){if(e===t)e.flags|=ri;else {if(e.flags|=$r,n.flags|=ii,n.flags&=-52805,n.tag===u)if(null===n.alternate)n.tag=k;else {var o=fh(Jo,go);o.tag=sh,hh(n,o,go);}n.lanes=ga(n.lanes,go);}return e}return e.flags|=ri,e.lanes=i,e}function Ug(e,t,n,r,i){if(n.flags|=ni,qi&&zw(e,i),null!==r&&"object"==typeof r&&"function"==typeof r.then){var o=r;!function(e,t){var n=e.tag;if((e.mode&oo)===io&&(n===s||n===b||n===S)){var r=e.alternate;r?(e.updateQueue=r.updateQueue,e.memoizedState=r.memoizedState,e.lanes=r.lanes):(e.updateQueue=null,e.memoizedState=null);}}(n),wf()&&n.mode&oo&&ef();var a=Bg(t);if(null!==a)return a.flags&=-257,zg(a,t,n,0,i),a.mode&oo&&jg(e,o,i),void function(e,t,n,r){var i=e.updateQueue;if(null===i){var o=new Set;o.add(n),e.updateQueue=o;}else i.add(n);}(a,0,o);if((i&go)===po)return jg(e,o,i),void gw();r=new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");}else if(wf()&&n.mode&oo){ef();var l=Bg(t);if(null!==l)return (l.flags&ri)===zr&&(l.flags|=Vr),zg(l,t,n,0,i),void _f(Pg(r,n))}!function(e){gy!==sy&&(gy=oy);null===_y?_y=[e]:_y.push(e);}(r=Pg(r,n));var d=t;do{switch(d.tag){case c:var f=r;d.flags|=ri;var h=da(i);return d.lanes=ga(d.lanes,h),void mh(d,Ng(d,f,h));case u:var p=r,m=d.type,g=d.stateNode;if((d.flags&$r)===zr&&("function"==typeof m.getDerivedStateFromError||null!==g&&"function"==typeof g.componentDidCatch&&!kw(g))){d.flags|=ri;var v=da(i);return d.lanes=ga(d.lanes,v),void mh(d,Dg(d,p,v))}}d=d.return;}while(null!==d)}var Fg,Kg,qg,Hg,Wg,$g,Vg,Yg,Gg=n.ReactCurrentOwner,Zg=false;function Qg(e,t,n,r){t.child=null===e?ep(t,null,n,r):Xh(t,e.child,n,r);}function Jg(e,t,n,r,i){if(t.type!==t.elementType){var o=n.propTypes;o&&ed(o,r,"prop",ct(n));}var a,s,u=n.render,l=t.ref;if(Gf(t,i),Yi(t),Gg.current=t,wt(true),a=em(e,t,u,r,l,i),s=tm(),t.mode&so){Hi(true);try{a=em(e,t,u,r,l,i),s=tm();}finally{Hi(false);}}return wt(false),Gi(),null===e||Zg?(wf()&&s&&Hd(t),t.flags|=Ur,Qg(e,t,a,i),t.child):(nm(e,t,i),Rv(e,t,i))}function Xg(e,t,n,r,i){if(null===e){var o=n.type;if(function(e){return "function"==typeof e&&!u_(e)&&void 0===e.defaultProps}(o)&&null===n.compare&&void 0===n.defaultProps){var a;return a=Yw(o),t.tag=S,t.type=a,lv(t,o),ev(e,t,a,r,i)}var s=o.propTypes;s&&ed(s,r,"prop",ct(o));var u=d_(n.type,null,r,t,t.mode,i);return u.ref=t.ref,u.return=t,t.child=u,u}var l=n.type,c=l.propTypes;c&&ed(c,r,"prop",ct(l));var d=e.child;if(!Tv(e,i)){var f=d.memoizedProps,h=n.compare;if((h=null!==h?h:Au)(f,r)&&e.ref===t.ref)return Rv(e,t,i)}t.flags|=Ur;var p=l_(d,r);return p.ref=t.ref,p.return=t,t.child=p,p}function ev(e,t,n,r,i){if(t.type!==t.elementType){var o=t.elementType;if(o.$$typeof===je){var a=o,s=a._payload,u=a._init;try{o=u(s);}catch(e){o=null;}var l=o&&o.propTypes;l&&ed(l,r,"prop",ct(o));}}if(null!==e){var c=e.memoizedProps;if(Au(c,r)&&e.ref===t.ref&&t.type===e.type){if(Zg=false,t.pendingProps=r=c,!Tv(e,i))return t.lanes=e.lanes,Rv(e,t,i);(e.flags&ii)!==zr&&(Zg=true);}}return rv(e,t,n,r,i)}function tv(e,t,n){var r,i=t.pendingProps,o=i.children,a=null!==e?e.memoizedState:null;if("hidden"===i.mode||N)if((t.mode&oo)===io){var s={baseLanes:po,cachePool:null,transitions:null};t.memoizedState=s,lw(t,n);}else {if(!pa(n,Zo)){var u;if(null!==a)u=ga(a.baseLanes,n);else u=n;t.lanes=t.childLanes=Zo;var l={baseLanes:u,cachePool:null,transitions:null};return t.memoizedState=l,t.updateQueue=null,lw(t,u),null}var c={baseLanes:po,cachePool:null,transitions:null};t.memoizedState=c,lw(t,null!==a?a.baseLanes:n);}else null!==a?(r=ga(a.baseLanes,n),t.memoizedState=null):r=n,lw(t,r);return Qg(e,t,o,n),t.child}function nv(e,t){var n=t.ref;(null===e&&null!==n||null!==e&&e.ref!==n)&&(t.flags|=Yr,t.flags|=ai);}function rv(e,t,n,r,i){if(t.type!==t.elementType){var o=n.propTypes;o&&ed(o,r,"prop",ct(n));}var a,s,u;if(a=pd(t,fd(0,n,true)),Gf(t,i),Yi(t),Gg.current=t,wt(true),s=em(e,t,n,r,a,i),u=tm(),t.mode&so){Hi(true);try{s=em(e,t,n,r,a,i),u=tm();}finally{Hi(false);}}return wt(false),Gi(),null===e||Zg?(wf()&&u&&Hd(t),t.flags|=Ur,Qg(e,t,s,i),t.child):(nm(e,t,i),Rv(e,t,i))}function iv(e,t,n,r,i){switch(L_(t)){case  false:var a=t.stateNode,s=new(t.type)(t.memoizedProps,a.context).state;a.updater.enqueueSetState(a,s,null);break;case  true:t.flags|=$r,t.flags|=ri;var u=new Error("Simulated error coming from DevTools"),l=da(i);t.lanes=ga(t.lanes,l),mh(t,Dg(t,Pg(u,t),l));}if(t.type!==t.elementType){var c=n.propTypes;c&&ed(c,r,"prop",ct(n));}var d,f;gd(n)?(d=true,_d(t)):d=false,Gf(t,i),null===t.stateNode?(Av(e,t),Hh(t,n,r),$h(t,n,r,i),f=true):f=null===e?function(e,t,n,r){var i=e.stateNode,o=e.memoizedProps;i.props=o;var a=i.context,s=t.contextType,u=ud;u="object"==typeof s&&null!==s?Zf(s):pd(e,fd(0,t,true));var l=t.getDerivedStateFromProps,c="function"==typeof l||"function"==typeof i.getSnapshotBeforeUpdate;c||"function"!=typeof i.UNSAFE_componentWillReceiveProps&&"function"!=typeof i.componentWillReceiveProps||o===n&&a===u||Wh(e,i,n,u),yh();var d=e.memoizedState,f=i.state=d;if(vh(e,n,i,r),f=e.memoizedState,o===n&&d===f&&!md()&&!wh()){if("function"==typeof i.componentDidMount){var h=Kr;h|=si,(e.mode&uo)!==io&&(h|=li),e.flags|=h;}return  false}"function"==typeof l&&(Nh(e,t,l,n),f=e.memoizedState);var p=wh()||Kh(e,t,o,n,d,f,u);if(p){if(c||"function"!=typeof i.UNSAFE_componentWillMount&&"function"!=typeof i.componentWillMount||("function"==typeof i.componentWillMount&&i.componentWillMount(),"function"==typeof i.UNSAFE_componentWillMount&&i.UNSAFE_componentWillMount()),"function"==typeof i.componentDidMount){var m=Kr;m|=si,(e.mode&uo)!==io&&(m|=li),e.flags|=m;}}else {if("function"==typeof i.componentDidMount){var g=Kr;g|=si,(e.mode&uo)!==io&&(g|=li),e.flags|=g;}e.memoizedProps=n,e.memoizedState=f;}return i.props=n,i.state=f,i.context=u,p}(t,n,r,i):function(e,t,n,r,i){var o=t.stateNode;dh(e,t);var a=t.memoizedProps,s=t.type===t.elementType?a:Nf(t.type,a);o.props=s;var u=t.pendingProps,l=o.context,c=n.contextType,d=ud;d="object"==typeof c&&null!==c?Zf(c):pd(t,fd(0,n,true));var f=n.getDerivedStateFromProps,h="function"==typeof f||"function"==typeof o.getSnapshotBeforeUpdate;h||"function"!=typeof o.UNSAFE_componentWillReceiveProps&&"function"!=typeof o.componentWillReceiveProps||a===u&&l===d||Wh(t,o,r,d),yh();var p=t.memoizedState,m=o.state=p;if(vh(t,r,o,i),m=t.memoizedState,a===u&&p===m&&!md()&&!wh()&&true)return "function"==typeof o.componentDidUpdate&&(a===e.memoizedProps&&p===e.memoizedState||(t.flags|=Kr)),"function"==typeof o.getSnapshotBeforeUpdate&&(a===e.memoizedProps&&p===e.memoizedState||(t.flags|=Gr)),false;"function"==typeof f&&(Nh(t,n,f,r),m=t.memoizedState);var g=wh()||Kh(t,n,s,r,p,m,d)||O;return g?(h||"function"!=typeof o.UNSAFE_componentWillUpdate&&"function"!=typeof o.componentWillUpdate||("function"==typeof o.componentWillUpdate&&o.componentWillUpdate(r,m,d),"function"==typeof o.UNSAFE_componentWillUpdate&&o.UNSAFE_componentWillUpdate(r,m,d)),"function"==typeof o.componentDidUpdate&&(t.flags|=Kr),"function"==typeof o.getSnapshotBeforeUpdate&&(t.flags|=Gr)):("function"==typeof o.componentDidUpdate&&(a===e.memoizedProps&&p===e.memoizedState||(t.flags|=Kr)),"function"==typeof o.getSnapshotBeforeUpdate&&(a===e.memoizedProps&&p===e.memoizedState||(t.flags|=Gr)),t.memoizedProps=r,t.memoizedState=m),o.props=r,o.state=m,o.context=d,g}(e,t,n,r,i);var h=ov(e,t,n,f,d,i),p=t.stateNode;return f&&p.props!==r&&($g||o("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",ft(t)||"a component"),$g=true),h}function ov(e,t,n,r,i,o){nv(e,t);var a=(t.flags&$r)!==zr;if(!r&&!a)return i&&Sd(t,n,false),Rv(e,t,o);var s,u=t.stateNode;if(Gg.current=t,a&&"function"!=typeof n.getDerivedStateFromError)s=null,kg();else {if(Yi(t),wt(true),s=u.render(),t.mode&so){Hi(true);try{u.render();}finally{Hi(false);}}wt(false),Gi();}return t.flags|=Ur,null!==e&&a?function(e,t,n,r){t.child=Xh(t,e.child,null,r),t.child=Xh(t,null,n,r);}(e,t,s,o):Qg(e,t,s,o),t.memoizedState=u.state,i&&Sd(t,n,true),t.child}function av(e){var t=e.stateNode;t.pendingContext?yd(e,t.pendingContext,t.pendingContext!==t.context):t.context&&yd(e,t.context,false),up(e,t.containerInfo);}function sv(e,t,n,r,i){return bf(),_f(i),t.flags|=Vr,Qg(e,t,n,r),t.child}function uv(e,t,n,r){Av(e,t);var i=t.pendingProps,o=n,a=o._payload,c=(0, o._init)(a);t.type=c;var d=t.tag=function(e){if("function"==typeof e)return u_(e)?u:s;if(null!=e){var t=e.$$typeof;if(t===Ie)return b;if(t===De)return _}return l}(c),f=Nf(c,i);switch(d){case s:return lv(t,c),t.type=c=Yw(c),rv(null,t,c,f,r);case u:return t.type=c=Gw(c),iv(null,t,c,f,r);case b:return t.type=c=Zw(c),Jg(null,t,c,f,r);case _:if(t.type!==t.elementType){var h=c.propTypes;h&&ed(h,f,"prop",ct(c));}return Xg(null,t,c,Nf(c.type,f),r)}var p="";throw null!==c&&"object"==typeof c&&c.$$typeof===je&&(p=" Did you wrap a component in React.lazy() more than once?"),new Error("Element type is invalid. Received a promise that resolves to: "+c+". Lazy element type must resolve to a class or function."+p)}function lv(e,t){if(t&&t.childContextTypes&&o("%s(...): childContextTypes cannot be defined on a function component.",t.displayName||t.name||"Component"),null!==e.ref){var n="",r=gt();r&&(n+="\n\nCheck the render method of `"+r+"`.");var i=r||"",a=e._debugSource;a&&(i=a.fileName+":"+a.lineNumber),Wg[i]||(Wg[i]=true,o("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s",n));}if("function"==typeof t.getDerivedStateFromProps){var s=ct(t)||"Unknown";Hg[s]||(o("%s: Function components do not support getDerivedStateFromProps.",s),Hg[s]=true);}if("object"==typeof t.contextType&&null!==t.contextType){var u=ct(t)||"Unknown";qg[u]||(o("%s: Function components do not support contextType.",u),qg[u]=true);}}Fg={},Kg={},qg={},Hg={},Wg={},$g=false,Vg={},Yg={};var cv={dehydrated:null,treeContext:null,retryLane:mo};function dv(e){return {baseLanes:e,cachePool:null,transitions:null}}function fv(e,t,n){var r=t.pendingProps;I_(t)&&(t.flags|=$r);var i=gp.current,a=false,s=(t.flags&$r)!==zr;if(s||function(e,t,n,r){return (null===t||null!==t.memoizedState)&&vp(e,mp)}(i,e)?(a=true,t.flags&=-129):null!==e&&null===e.memoizedState||(i=i|pp),wp(t,i=bp(i)),null===e){df(t);var u=t.memoizedState;if(null!==u){var l=u.dehydrated;if(null!==l)return function(e,t,n){(e.mode&oo)===io?(o("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."),e.lanes=go):Tc(t)?e.lanes=yo:e.lanes=Zo;return null}(t,l)}var c=r.children,d=r.fallback;if(a){var f=function(e,t,n,r){var i,o,a=e.mode,s=e.child,u={mode:"hidden",children:t};(a&oo)===io&&null!==s?((i=s).childLanes=po,i.pendingProps=u,e.mode&ao&&(i.actualDuration=0,i.actualStartTime=-1,i.selfBaseDuration=0,i.treeBaseDuration=0),o=h_(n,a,r,null)):(i=pv(u,a),o=h_(n,a,r,null));return i.return=e,o.return=e,i.sibling=o,e.child=i,o}(t,c,d,n);return t.child.memoizedState=dv(n),t.memoizedState=cv,f}return hv(t,c)}var h=e.memoizedState;if(null!==h){var p=h.dehydrated;if(null!==p)return function(e,t,n,r,i,o,a){if(n){if(t.flags&Vr)return t.flags&=-257,gv(e,t,a,Lg(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering.")));if(null!==t.memoizedState)return t.child=e.child,t.flags|=$r,null;var s=function(e,t,n,r,i){var o=t.mode,a={mode:"visible",children:n},s=pv(a,o),u=h_(r,o,i,null);u.flags|=Fr,s.return=t,u.return=t,s.sibling=u,t.child=s,(t.mode&oo)!==io&&Xh(t,e.child,null,i);return u}(e,t,r.children,r.fallback,a);return t.child.memoizedState=dv(a),t.memoizedState=cv,s}if(Xd(),(t.mode&oo)===io)return gv(e,t,a,null);if(Tc(i)){var u,l,c,d=function(e){var t,n,r,i=e.nextSibling&&e.nextSibling.dataset;return i&&(t=i.dgst,n=i.msg,r=i.stck),{message:n,digest:t,stack:r}}(i);return u=d.digest,l=d.message,c=d.stack,gv(e,t,a,Lg(l?new Error(l):new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."),u,c))}var f=pa(a,e.childLanes);if(Zg||f){var h=Gy();if(null!==h){var p=function(e,t){var n;switch(ca(t)){case bo:n=vo;break;case wo:n=yo;break;case Eo:case ko:case Mo:case Co:case xo:case Ao:case Ro:case To:case Po:case Lo:case Io:case Oo:case No:case Do:case jo:case Bo:case Uo:case Fo:case Ko:case qo:case Ho:n=_o;break;case Go:n=Yo;break;default:n=mo;}return (n&(e.suspendedLanes|t))!==mo?mo:n}(h,a);if(p!==mo&&p!==o.retryLane){o.retryLane=p;var m=Jo;eh(e,p),Xy(h,e,p,m);}}return gw(),gv(e,t,a,Lg(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.")))}if(Rc(i))return t.flags|=$r,t.child=e.child,function(e,t){e._reactRetry=t;}(i,Tw.bind(null,e)),null;nf(t,i,o.treeContext);var g=hv(t,r.children);return g.flags|=Qr,g}(e,t,s,r,p,h,n)}if(a){var m=r.fallback,g=function(e,t,n,r,i){var o,a,s=t.mode,u=e.child,l=u.sibling,c={mode:"hidden",children:n};if((s&oo)===io&&t.child!==u){(o=t.child).childLanes=po,o.pendingProps=c,t.mode&ao&&(o.actualDuration=0,o.actualStartTime=-1,o.selfBaseDuration=u.selfBaseDuration,o.treeBaseDuration=u.treeBaseDuration),t.deletions=null;}else (o=mv(u,c)).subtreeFlags=u.subtreeFlags&mi;null!==l?a=l_(l,r):(a=h_(r,s,i,null)).flags|=Fr;return a.return=t,o.return=t,o.sibling=a,t.child=o,a}(e,t,r.children,m,n),v=t.child,b=e.child.memoizedState;return v.memoizedState=null===b?dv(n):function(e,t){return {baseLanes:ga(e.baseLanes,t),cachePool:null,transitions:e.transitions}}(b,n),v.childLanes=function(e,t){return va(e.childLanes,t)}(e,n),t.memoizedState=cv,g}var y=function(e,t,n,r){var i=e.child,o=i.sibling,a=mv(i,{mode:"visible",children:n});(t.mode&oo)===io&&(a.lanes=r);if(a.return=t,a.sibling=null,null!==o){var s=t.deletions;null===s?(t.deletions=[o],t.flags|=qr):s.push(o);}return t.child=a,a}(e,t,r.children,n);return t.memoizedState=null,y}function hv(e,t,n){var r=pv({mode:"visible",children:t},e.mode);return r.return=e,e.child=r,r}function pv(e,t,n){return p_(e,t,po,null)}function mv(e,t){return l_(e,t)}function gv(e,t,n,r){null!==r&&_f(r),Xh(t,e.child,null,n);var i=hv(t,t.pendingProps.children);return i.flags|=Fr,t.memoizedState=null,i}function vv(e,t,n){e.lanes=ga(e.lanes,t);var r=e.alternate;null!==r&&(r.lanes=ga(r.lanes,t)),Vf(e.return,t,n);}function bv(e,t){var n=Yt(e),r=!n&&"function"==typeof Fe(e);if(n||r){var i=n?"array":"iterable";return o("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",i,t,i),false}return  true}function yv(e,t,n,r,i){var o=e.memoizedState;null===o?e.memoizedState={isBackwards:t,rendering:null,renderingStartTime:0,last:r,tail:n,tailMode:i}:(o.isBackwards=t,o.rendering=null,o.renderingStartTime=0,o.last=r,o.tail=n,o.tailMode=i);}function wv(e,t,n){var r=t.pendingProps,i=r.revealOrder,a=r.tail,s=r.children;!function(e){if(void 0!==e&&"forwards"!==e&&"backwards"!==e&&"together"!==e&&!Vg[e])if(Vg[e]=true,"string"==typeof e)switch(e.toLowerCase()){case "together":case "forwards":case "backwards":o('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',e,e.toLowerCase());break;case "forward":case "backward":o('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',e,e.toLowerCase());break;default:o('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',e);}else o('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',e);}(i),function(e,t){ void 0===e||Yg[e]||("collapsed"!==e&&"hidden"!==e?(Yg[e]=true,o('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?',e)):"forwards"!==t&&"backwards"!==t&&(Yg[e]=true,o('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',e)));}(a,i),function(e,t){if(("forwards"===t||"backwards"===t)&&null!=e&&false!==e)if(Yt(e)){for(var n=0;n<e.length;n++)if(!bv(e[n],n))return}else {var r=Fe(e);if("function"==typeof r){var i=r.call(e);if(i)for(var a=i.next(),s=0;!a.done;a=i.next()){if(!bv(a.value,s))return;s++;}}else o('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',t);}}(s,i),Qg(e,t,s,n);var u=gp.current;vp(u,mp)?(u=yp(u,mp),t.flags|=$r):(null!==e&&(e.flags&$r)!==zr&&function(e,t,n){for(var r=t;null!==r;){if(r.tag===w)null!==r.memoizedState&&vv(r,n,e);else if(r.tag===C)vv(r,n,e);else if(null!==r.child){r.child.return=r,r=r.child;continue}if(r===e)return;for(;null===r.sibling;){if(null===r.return||r.return===e)return;r=r.return;}r.sibling.return=r.return,r=r.sibling;}}(t,t.child,n),u=bp(u));if(wp(t,u),(t.mode&oo)===io)t.memoizedState=null;else switch(i){case "forwards":var l,c=function(e){for(var t=e,n=null;null!==t;){var r=t.alternate;null!==r&&null===Ep(r)&&(n=t),t=t.sibling;}return n}(t.child);null===c?(l=t.child,t.child=null):(l=c.sibling,c.sibling=null),yv(t,false,l,c,a);break;case "backwards":var d=null,f=t.child;for(t.child=null;null!==f;){var h=f.alternate;if(null!==h&&null===Ep(h)){t.child=f;break}var p=f.sibling;f.sibling=d,d=f,f=p;}yv(t,true,d,null,a);break;case "together":yv(t,false,null,null,void 0);break;default:t.memoizedState=null;}return t.child}var _v=false;var Sv,Ev,kv,Mv,Cv=false;function xv(){Zg=true;}function Av(e,t){(t.mode&oo)===io&&null!==e&&(e.alternate=null,t.alternate=null,t.flags|=Fr);}function Rv(e,t,n){return null!==e&&(t.dependencies=e.dependencies),kg(),mw(t.lanes),pa(n,t.childLanes)?(function(e,t){if(null!==e&&t.child!==e.child)throw new Error("Resuming work not yet implemented.");if(null!==t.child){var n=t.child,r=l_(n,n.pendingProps);for(t.child=r,r.return=t;null!==n.sibling;)n=n.sibling,(r=r.sibling=l_(n,n.pendingProps)).return=t;r.sibling=null;}}(e,t),t.child):null}function Tv(e,t){return !!pa(e.lanes,t)}function Pv(e,t,n){if(t._debugNeedsRemount&&null!==e)return function(e,t,n){var r=t.return;if(null===r)throw new Error("Cannot swap the root fiber.");if(e.alternate=null,t.alternate=null,n.index=t.index,n.sibling=t.sibling,n.return=t.return,n.ref=t.ref,t===r.child)r.child=n;else {var i=r.child;if(null===i)throw new Error("Expected parent to have a child.");for(;i.sibling!==t;)if(null===(i=i.sibling))throw new Error("Expected to find the previous sibling.");i.sibling=n;}var o=r.deletions;return null===o?(r.deletions=[e],r.flags|=qr):o.push(e),n.flags|=Fr,n}(e,t,d_(t.type,t.key,t.pendingProps,t._debugOwner||null,t.mode,t.lanes));if(null!==e)if(e.memoizedProps!==t.pendingProps||md()||t.type!==e.type)Zg=true;else {if(!Tv(e,n)&&(t.flags&$r)===zr)return Zg=false,function(e,t,n){switch(t.tag){case c:av(t),t.stateNode,bf();break;case f:dp(t);break;case u:gd(t.type)&&_d(t);break;case d:up(t,t.stateNode.containerInfo);break;case v:var r=t.memoizedProps.value;Wf(t,t.type._context,r);break;case y:pa(n,t.childLanes)&&(t.flags|=Kr);var i=t.stateNode;i.effectDuration=0,i.passiveEffectDuration=0;break;case w:var o=t.memoizedState;if(null!==o){if(null!==o.dehydrated)return wp(t,bp(gp.current)),t.flags|=$r,null;if(pa(n,t.child.childLanes))return fv(e,t,n);wp(t,bp(gp.current));var a=Rv(e,t,n);return null!==a?a.sibling:null}wp(t,bp(gp.current));break;case C:var s=(e.flags&$r)!==zr,l=pa(n,t.childLanes);if(s){if(l)return wv(e,t,n);t.flags|=$r;}var h=t.memoizedState;if(null!==h&&(h.rendering=null,h.tail=null,h.lastEffect=null),wp(t,gp.current),l)break;return null;case A:case R:return t.lanes=po,tv(e,t,n)}return Rv(e,t,n)}(e,t,n);Zg=(e.flags&ii)!==zr;}else if(Zg=false,wf()&&function(e){return Vd(),(e.flags&oi)!==zr}(t)){var r=t.index;qd(t,(Vd(),Nd),r);}switch(t.lanes=po,t.tag){case l:return function(e,t,n,r){Av(e,t);var i,a,l,c=t.pendingProps;if(i=pd(t,fd(0,n,false)),Gf(t,r),Yi(t),n.prototype&&"function"==typeof n.prototype.render){var d=ct(n)||"Unknown";Fg[d]||(o("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",d,d),Fg[d]=true);}if(t.mode&so&&kf.recordLegacyContextWarning(t,null),wt(true),Gg.current=t,a=em(null,t,n,c,i,r),l=tm(),wt(false),Gi(),t.flags|=Ur,"object"==typeof a&&null!==a&&"function"==typeof a.render&&void 0===a.$$typeof){var f=ct(n)||"Unknown";Kg[f]||(o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.",f,f,f),Kg[f]=true);}if("object"==typeof a&&null!==a&&"function"==typeof a.render&&void 0===a.$$typeof){var h=ct(n)||"Unknown";Kg[h]||(o("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.",h,h,h),Kg[h]=true),t.tag=u,t.memoizedState=null,t.updateQueue=null;var p=false;return gd(n)?(p=true,_d(t)):p=false,t.memoizedState=null!==a.state&&void 0!==a.state?a.state:null,ch(t),qh(t,a),$h(t,n,c,r),ov(null,t,n,true,p,r)}if(t.tag=s,t.mode&so){Hi(true);try{a=em(null,t,n,c,i,r),l=tm();}finally{Hi(false);}}return wf()&&l&&Hd(t),Qg(null,t,a,r),lv(t,n),t.child}(e,t,t.type,n);case E:return uv(e,t,t.elementType,n);case s:var i=t.type,a=t.pendingProps;return rv(e,t,i,t.elementType===i?a:Nf(i,a),n);case u:var M=t.type,T=t.pendingProps;return iv(e,t,M,t.elementType===M?T:Nf(M,T),n);case c:return function(e,t,n){if(av(t),null===e)throw new Error("Should have a current fiber. This is a bug in React.");var r=t.pendingProps,i=t.memoizedState,o=i.element;dh(e,t),vh(t,r,null,n);var a=t.memoizedState;t.stateNode;var s=a.element;if(i.isDehydrated){var u={element:s,isDehydrated:false,cache:a.cache,pendingSuspenseBoundaries:a.pendingSuspenseBoundaries,transitions:a.transitions};if(t.updateQueue.baseState=u,t.memoizedState=u,t.flags&Vr)return sv(e,t,s,n,Pg(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."),t));if(s!==o)return sv(e,t,s,n,Pg(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."),t));tf(t);var l=ep(t,null,s,n);t.child=l;for(var c=l;c;)c.flags=c.flags&-3|Qr,c=c.sibling;}else {if(bf(),s===o)return Rv(e,t,n);Qg(e,t,s,n);}return t.child}(e,t,n);case f:return function(e,t,n){dp(t),null===e&&df(t);var r=t.type,i=t.pendingProps,o=null!==e?e.memoizedProps:null,a=i.children;return gc(r,i)?a=null:null!==o&&gc(r,o)&&(t.flags|=Hr),nv(e,t),Qg(e,t,a,n),t.child}(e,t,n);case h:return function(e,t){return null===e&&df(t),null}(e,t);case w:return fv(e,t,n);case d:return function(e,t,n){up(t,t.stateNode.containerInfo);var r=t.pendingProps;return null===e?t.child=Xh(t,null,r,n):Qg(e,t,r,n),t.child}(e,t,n);case b:var P=t.type,L=t.pendingProps;return Jg(e,t,P,t.elementType===P?L:Nf(P,L),n);case p:return function(e,t,n){return Qg(e,t,t.pendingProps,n),t.child}(e,t,n);case m:return function(e,t,n){return Qg(e,t,t.pendingProps.children,n),t.child}(e,t,n);case y:return function(e,t,n){t.flags|=Kr;var r=t.stateNode;return r.effectDuration=0,r.passiveEffectDuration=0,Qg(e,t,t.pendingProps.children,n),t.child}(e,t,n);case v:return function(e,t,n){var r=t.type._context,i=t.pendingProps,a=t.memoizedProps,s=i.value;"value"in i||_v||(_v=true,o("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));var u=t.type.propTypes;if(u&&ed(u,i,"prop","Context.Provider"),Wf(t,r,s),null!==a){var l=a.value;if(xu(l,s)){if(a.children===i.children&&!md())return Rv(e,t,n)}else Yf(t,r,n);}return Qg(e,t,i.children,n),t.child}(e,t,n);case g:return function(e,t,n){var r=t.type;void 0===r._context?r!==r.Consumer&&(Cv||(Cv=true,o("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))):r=r._context;var i=t.pendingProps.children;"function"!=typeof i&&o("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."),Gf(t,n);var a,s=Zf(r);return Yi(t),Gg.current=t,wt(true),a=i(s),wt(false),Gi(),t.flags|=Ur,Qg(e,t,a,n),t.child}(e,t,n);case _:var I=t.type,O=Nf(I,t.pendingProps);if(t.type!==t.elementType){var N=I.propTypes;N&&ed(N,O,"prop",ct(I));}return Xg(e,t,I,O=Nf(I.type,O),n);case S:return ev(e,t,t.type,t.pendingProps,n);case k:var D=t.type,j=t.pendingProps;return function(e,t,n,r,i){var o;return Av(e,t),t.tag=u,gd(n)?(o=true,_d(t)):o=false,Gf(t,i),Hh(t,n,r),$h(t,n,r,i),ov(null,t,n,true,o,i)}(e,t,D,t.elementType===D?j:Nf(D,j),n);case C:return wv(e,t,n);case x:break;case A:return tv(e,t,n)}throw new Error("Unknown unit of work tag ("+t.tag+"). This error is likely caused by a bug in React. Please file an issue.")}function Lv(e){e.flags|=Kr;}function Iv(e){e.flags|=Yr,e.flags|=ai;}function Ov(e,t){if(!wf())switch(e.tailMode){case "hidden":for(var n=e.tail,r=null;null!==n;)null!==n.alternate&&(r=n),n=n.sibling;null===r?e.tail=null:r.sibling=null;break;case "collapsed":for(var i=e.tail,o=null;null!==i;)null!==i.alternate&&(o=i),i=i.sibling;null===o?t||null===e.tail?e.tail=null:e.tail.sibling=null:o.sibling=null;}}function Nv(e){var t=null!==e.alternate&&e.alternate.child===e.child,n=po,r=zr;if(t){if((e.mode&ao)!==io){for(var i=e.selfBaseDuration,o=e.child;null!==o;)n=ga(n,ga(o.lanes,o.childLanes)),r|=o.subtreeFlags&mi,r|=o.flags&mi,i+=o.treeBaseDuration,o=o.sibling;e.treeBaseDuration=i;}else for(var a=e.child;null!==a;)n=ga(n,ga(a.lanes,a.childLanes)),r|=a.subtreeFlags&mi,r|=a.flags&mi,a.return=e,a=a.sibling;e.subtreeFlags|=r;}else {if((e.mode&ao)!==io){for(var s=e.actualDuration,u=e.selfBaseDuration,l=e.child;null!==l;)n=ga(n,ga(l.lanes,l.childLanes)),r|=l.subtreeFlags,r|=l.flags,s+=l.actualDuration,u+=l.treeBaseDuration,l=l.sibling;e.actualDuration=s,e.treeBaseDuration=u;}else for(var c=e.child;null!==c;)n=ga(n,ga(c.lanes,c.childLanes)),r|=c.subtreeFlags,r|=c.flags,c.return=e,c=c.sibling;e.subtreeFlags|=r;}return e.childLanes=n,t}function Dv(e,t,n){if(Zd&&null!==Gd&&(t.mode&oo)!==io&&(t.flags&$r)===zr)return vf(t),bf(),t.flags|=Vr|ni|ri,false;var r=gf(t);if(null!==n&&null!==n.dehydrated){if(null===e){if(!r)throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");if(hf(t),Nv(t),(t.mode&ao)!==io)if(null!==n){var i=t.child;null!==i&&(t.treeBaseDuration-=i.treeBaseDuration);}return  false}if(bf(),(t.flags&$r)===zr&&(t.memoizedState=null),t.flags|=Kr,Nv(t),(t.mode&ao)!==io&&null!==n){var o=t.child;null!==o&&(t.treeBaseDuration-=o.treeBaseDuration);}return  false}return yf(),true}function jv(e,t,n){var r=t.pendingProps;switch($d(t),t.tag){case l:case E:case S:case s:case b:case p:case m:case y:case g:case _:return Nv(t),null;case u:return gd(t.type)&&vd(t),Nv(t),null;case c:var i=t.stateNode;if(lp(t),bd(t),Tp(),i.pendingContext&&(i.context=i.pendingContext,i.pendingContext=null),null===e||null===e.child)if(gf(t))Lv(t);else if(null!==e)e.memoizedState.isDehydrated&&(t.flags&Vr)===zr||(t.flags|=Gr,yf());return Ev(e,t),Nv(t),null;case f:fp(t);var o=sp(),a=t.type;if(null!==e&&null!=t.stateNode)kv(e,t,a,r,o),e.ref!==t.ref&&Iv(t);else {if(!r){if(null===t.stateNode)throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");return Nv(t),null}var M=cp();if(gf(t))(function(e,t,n){var r=e.stateNode,i=!Qd,o=Ic(r,e.type,e.memoizedProps,0,n,e,i);return e.updateQueue=o,null!==o})(t,0,M)&&Lv(t);else {var L=mc(a,r,o,M,t);Sv(L,t,false,false),t.stateNode=L,function(e,t,n,r,i){switch(Wl(e,t,n),t){case "button":case "input":case "select":case "textarea":return !!n.autoFocus;case "img":return  true;default:return  false}}(L,a,r)&&Lv(t);}null!==t.ref&&Iv(t);}return Nv(t),null;case h:var I=r;if(e&&null!=t.stateNode){var O=e.memoizedProps;Mv(e,t,O,I);}else {if("string"!=typeof I&&null===t.stateNode)throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");var j=sp(),B=cp();gf(t)?ff(t)&&Lv(t):t.stateNode=vc(I,j,B,t);}return Nv(t),null;case w:_p(t);var z=t.memoizedState;if(null===e||null!==e.memoizedState&&null!==e.memoizedState.dehydrated)if(!Dv(e,t,z))return t.flags&ri?t:null;if((t.flags&$r)!==zr)return t.lanes=n,(t.mode&ao)!==io&&Tg(t),t;var U=null!==z;if(U!==(null!==e&&null!==e.memoizedState))if(U)if(t.child.flags|=Jr,(t.mode&oo)!==io)null===e&&(true!==t.memoizedProps.unstable_avoidThisFallback||true)||vp(gp.current,pp)?gy===ry&&(gy=ay):gw();if(null!==t.updateQueue&&(t.flags|=Kr),Nv(t),(t.mode&ao)!==io&&U){var F=t.child;null!==F&&(t.treeBaseDuration-=F.treeBaseDuration);}return null;case d:return lp(t),Ev(e,t),null===e&&ml(t.stateNode.containerInfo),Nv(t),null;case v:return $f(t.type._context,t),Nv(t),null;case k:return gd(t.type)&&vd(t),Nv(t),null;case C:_p(t);var K=t.memoizedState;if(null===K)return Nv(t),null;var q=(t.flags&$r)!==zr,H=K.rendering;if(null===H)if(q)Ov(K,false);else {if(!(gy===ry&&(null===e||(e.flags&$r)===zr)))for(var W=t.child;null!==W;){var $=Ep(W);if(null!==$){q=true,t.flags|=$r,Ov(K,false);var V=$.updateQueue;return null!==V&&(t.updateQueue=V,t.flags|=Kr),t.subtreeFlags=zr,tp(t,n),wp(t,yp(gp.current,mp)),t.child}W=W.sibling;}null!==K.tail&&Ti()>Ry()&&(t.flags|=$r,q=true,Ov(K,false),t.lanes=Wo);}else {if(!q){var Y=Ep(H);if(null!==Y){t.flags|=$r,q=true;var G=Y.updateQueue;if(null!==G&&(t.updateQueue=G,t.flags|=Kr),Ov(K,true),null===K.tail&&"hidden"===K.tailMode&&!H.alternate&&!wf())return Nv(t),null}else 2*Ti()-K.renderingStartTime>Ry()&&n!==Zo&&(t.flags|=$r,q=true,Ov(K,false),t.lanes=Wo);}if(K.isBackwards)H.sibling=t.child,t.child=H;else {var Z=K.last;null!==Z?Z.sibling=H:t.child=H,K.last=H;}}if(null!==K.tail){var Q=K.tail;K.rendering=Q,K.tail=Q.sibling,K.renderingStartTime=Ti(),Q.sibling=null;var J=gp.current;return wp(t,J=q?yp(J,mp):bp(J)),Q}return Nv(t),null;case x:break;case A:case R:cw(t);var X=null!==t.memoizedState;if(null!==e)null!==e.memoizedState===X||N||(t.flags|=Jr);return X&&(t.mode&oo)!==io?pa(py,Zo)&&(Nv(t),t.subtreeFlags&(Fr|Kr)&&(t.flags|=Jr)):Nv(t),null;case T:case P:return null}throw new Error("Unknown unit of work tag ("+t.tag+"). This error is likely caused by a bug in React. Please file an issue.")}function Bv(e,t,n){switch($d(t),t.tag){case u:gd(t.type)&&vd(t);var r=t.flags;return r&ri?(t.flags=r&-65537|$r,(t.mode&ao)!==io&&Tg(t),t):null;case c:t.stateNode,lp(t),bd(t),Tp();var i=t.flags;return (i&ri)!==zr&&(i&$r)===zr?(t.flags=i&-65537|$r,t):null;case f:return fp(t),null;case w:_p(t);var o=t.memoizedState;if(null!==o&&null!==o.dehydrated){if(null===t.alternate)throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");bf();}var a=t.flags;return a&ri?(t.flags=a&-65537|$r,(t.mode&ao)!==io&&Tg(t),t):null;case C:return _p(t),null;case d:return lp(t),null;case v:return $f(t.type._context,t),null;case A:case R:return cw(t),null;default:return null}}function zv(e,t,n){switch($d(t),t.tag){case u:var r=t.type.childContextTypes;null!=r&&vd(t);break;case c:t.stateNode,lp(t),bd(t),Tp();break;case f:fp(t);break;case d:lp(t);break;case w:case C:_p(t);break;case v:$f(t.type._context,t);break;case A:case R:cw(t);}}Sv=function(e,t,n,r){for(var i,o,a=t.child;null!==a;){if(a.tag===f||a.tag===h)i=e,o=a.stateNode,i.appendChild(o);else if(a.tag===d);else if(null!==a.child){a.child.return=a,a=a.child;continue}if(a===t)return;for(;null===a.sibling;){if(null===a.return||a.return===t)return;a=a.return;}a.sibling.return=a.return,a=a.sibling;}},Ev=function(e,t){},kv=function(e,t,n,r,i){var o=e.memoizedProps;if(o!==r){var a=function(e,t,n,r,i,o){var a=o;if(typeof r.children!=typeof n.children&&("string"==typeof r.children||"number"==typeof r.children)){var s=""+r.children,u=Xl(a.ancestorInfo,t);Jl(null,s,u);}return $l(e,t,n,r)}(t.stateNode,n,o,r,0,cp());t.updateQueue=a,a&&Lv(t);}},Mv=function(e,t,n,r){n!==r&&Lv(t);};var Uv=null;Uv=new Set;var Fv=false,Kv=false,qv="function"==typeof WeakSet?WeakSet:Set,Hv=null,Wv=null,$v=null;var Vv=function(e,t){if(t.props=e.memoizedProps,t.state=e.memoizedState,e.mode&ao)try{Ag(),t.componentWillUnmount();}finally{Cg(e);}else t.componentWillUnmount();};function Yv(e,t){try{ib(xp,e);}catch(n){xw(e,t,n);}}function Gv(e,t,n){try{Vv(e,n);}catch(n){xw(e,t,n);}}function Zv(e,t){try{ub(e);}catch(n){xw(e,t,n);}}function Qv(e,t){var n=e.ref;if(null!==n)if("function"==typeof n){var r;try{if(F&&K&&e.mode&ao)try{Ag(),r=n(null);}finally{Cg(e);}else r=n(null);}catch(n){xw(e,t,n);}"function"==typeof r&&o("Unexpected return value from a callback ref in %s. A callback ref should not return a function.",ft(e));}else n.current=null;}function Jv(e,t,n){try{n();}catch(n){xw(e,t,n);}}var Xv=false;function eb(e,t){pc(e.containerInfo),Hv=t,function(){for(;null!==Hv;){var e=Hv,t=e.child;(e.subtreeFlags&di)!==zr&&null!==t?(t.return=e,Hv=t):tb();}}();var n=Xv;return Xv=false,n}function tb(){for(;null!==Hv;){var e=Hv;yt(e);try{nb(e);}catch(t){xw(e,e.return,t);}bt();var t=e.sibling;if(null!==t)return t.return=e.return,void(Hv=t);Hv=e.return;}}function nb(e){var t,n=e.alternate;if((e.flags&Gr)!==zr){switch(yt(e),e.tag){case s:case b:case S:break;case u:if(null!==n){var r=n.memoizedProps,i=n.memoizedState,a=e.stateNode;e.type!==e.elementType||$g||(a.props!==e.memoizedProps&&o("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",ft(e)||"instance"),a.state!==e.memoizedState&&o("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",ft(e)||"instance"));var l=a.getSnapshotBeforeUpdate(e.elementType===e.type?r:Nf(e.type,r),i),p=Uv;void 0!==l||p.has(e.type)||(p.add(e.type),o("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",ft(e))),a.__reactInternalSnapshotBeforeUpdate=l;}break;case c:var m=e.stateNode;(t=m.containerInfo).nodeType===pn?t.textContent="":t.nodeType===vn&&t.documentElement&&t.removeChild(t.documentElement);break;case f:case h:case d:case k:break;default:throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.")}bt();}}function rb(e,t,n){var r,i=t.updateQueue,o=null!==i?i.lastEffect:null;if(null!==o){var a=o.next,s=a;do{if((s.tag&e)===e){var u=s.destroy;s.destroy=void 0,void 0!==u&&((e&Ap)!==kp?(r=t,null!==Fi&&"function"==typeof Fi.markComponentPassiveEffectUnmountStarted&&Fi.markComponentPassiveEffectUnmountStarted(r)):(e&xp)!==kp&&Qi(t),(e&Cp)!==kp&&Hw(true),Jv(t,n,u),(e&Cp)!==kp&&Hw(false),(e&Ap)!==kp?null!==Fi&&"function"==typeof Fi.markComponentPassiveEffectUnmountStopped&&Fi.markComponentPassiveEffectUnmountStopped():(e&xp)!==kp&&Ji());}s=s.next;}while(s!==a)}}function ib(e,t){var n,r=t.updateQueue,i=null!==r?r.lastEffect:null;if(null!==i){var a=i.next,s=a;do{if((s.tag&e)===e){(e&Ap)!==kp?(n=t,null!==Fi&&"function"==typeof Fi.markComponentPassiveEffectMountStarted&&Fi.markComponentPassiveEffectMountStarted(n)):(e&xp)!==kp&&Zi(t);var u=s.create;(e&Cp)!==kp&&Hw(true),s.destroy=u(),(e&Cp)!==kp&&Hw(false),(e&Ap)!==kp?null!==Fi&&"function"==typeof Fi.markComponentPassiveEffectMountStopped&&Fi.markComponentPassiveEffectMountStopped():(e&xp)!==kp&&null!==Fi&&"function"==typeof Fi.markComponentLayoutEffectMountStopped&&Fi.markComponentLayoutEffectMountStopped();var l=s.destroy;if(void 0!==l&&"function"!=typeof l){var c=void 0;o("%s must not return anything besides a function, which is used for clean-up.%s",c=(s.tag&xp)!==zr?"useLayoutEffect":(s.tag&Cp)!==zr?"useInsertionEffect":"useEffect",null===l?" You returned null. If your effect does not require clean up, return undefined (or nothing).":"function"==typeof l.then?"\n\nIt looks like you wrote "+c+"(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n"+c+"(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching":" You returned: "+l);}}s=s.next;}while(s!==a)}}function ob(e,t){if((t.flags&Kr)!==zr&&t.tag===y){var n=t.stateNode.passiveEffectDuration,r=t.memoizedProps,i=r.id,o=r.onPostCommit,a=_g(),s=null===t.alternate?"mount":"update";wg()&&(s="nested-update"),"function"==typeof o&&o(i,s,n,a);var u=t.return;e:for(;null!==u;){switch(u.tag){case c:u.stateNode.passiveEffectDuration+=n;break e;case y:u.stateNode.passiveEffectDuration+=n;break e}u=u.return;}}}function ab(e,t,n,r){if((n.flags&hi)!==zr)switch(n.tag){case s:case b:case S:if(!Kv)if(n.mode&ao)try{Ag(),ib(xp|Mp,n);}finally{Cg(n);}else ib(xp|Mp,n);break;case u:var i=n.stateNode;if(n.flags&Kr&&!Kv)if(null===t)if(n.type!==n.elementType||$g||(i.props!==n.memoizedProps&&o("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",ft(n)||"instance"),i.state!==n.memoizedState&&o("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",ft(n)||"instance")),n.mode&ao)try{Ag(),i.componentDidMount();}finally{Cg(n);}else i.componentDidMount();else {var a=n.elementType===n.type?t.memoizedProps:Nf(n.type,t.memoizedProps),l=t.memoizedState;if(n.type!==n.elementType||$g||(i.props!==n.memoizedProps&&o("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",ft(n)||"instance"),i.state!==n.memoizedState&&o("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",ft(n)||"instance")),n.mode&ao)try{Ag(),i.componentDidUpdate(a,l,i.__reactInternalSnapshotBeforeUpdate);}finally{Cg(n);}else i.componentDidUpdate(a,l,i.__reactInternalSnapshotBeforeUpdate);}var p=n.updateQueue;null!==p&&(n.type!==n.elementType||$g||(i.props!==n.memoizedProps&&o("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",ft(n)||"instance"),i.state!==n.memoizedState&&o("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",ft(n)||"instance")),_h(0,p,i));break;case c:var m=n.updateQueue;if(null!==m){var g=null;if(null!==n.child)switch(n.child.tag){case f:case u:g=n.child.stateNode;}_h(0,m,g);}break;case f:var v=n.stateNode;if(null===t&&n.flags&Kr)!function(e,t,n,r){switch(t){case "button":case "input":case "select":case "textarea":return void(n.autoFocus&&e.focus());case "img":n.src&&(e.src=n.src);}}(v,n.type,n.memoizedProps);break;case h:case d:break;case y:var _=n.memoizedProps,E=_.onCommit,M=_.onRender,T=n.stateNode.effectDuration,L=_g(),I=null===t?"mount":"update";wg()&&(I="nested-update"),"function"==typeof M&&M(n.memoizedProps.id,I,n.actualDuration,n.treeBaseDuration,n.actualStartTime,L),"function"==typeof E&&E(n.memoizedProps.id,I,T,L),N=n,Dy.push(N),Iy||(Iy=true,Fw(Oi,(function(){return Ew(),null})));var O=n.return;e:for(;null!==O;){switch(O.tag){case c:O.stateNode.effectDuration+=T;break e;case y:O.stateNode.effectDuration+=T;break e}O=O.return;}break;case w:!function(e,t){var n=t.memoizedState;if(null===n){var r=t.alternate;if(null!==r){var i=r.memoizedState;if(null!==i){var o=i.dehydrated;null!==o&&function(e){rs(e);}(o);}}}}(0,n);break;case C:case k:case x:case A:case R:case P:break;default:throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.")}var N;Kv||n.flags&Yr&&ub(n);}function sb(e){switch(e.tag){case s:case b:case S:if(e.mode&ao)try{Ag(),Yv(e,e.return);}finally{Cg(e);}else Yv(e,e.return);break;case u:var t=e.stateNode;"function"==typeof t.componentDidMount&&function(e,t,n){try{n.componentDidMount();}catch(n){xw(e,t,n);}}(e,e.return,t),Zv(e,e.return);break;case f:Zv(e,e.return);}}function ub(e){var t=e.ref;if(null!==t){var n,r=e.stateNode;if(e.tag,n=r,"function"==typeof t){var i;if(e.mode&ao)try{Ag(),i=t(n);}finally{Cg(e);}else i=t(n);"function"==typeof i&&o("Unexpected return value from a callback ref in %s. A callback ref should not return a function.",ft(e));}else t.hasOwnProperty("current")||o("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",ft(e)),t.current=n;}}function lb(e){var t=e.alternate;if(null!==t&&(e.alternate=null,lb(t)),e.child=null,e.deletions=null,e.sibling=null,e.tag===f){var n=e.stateNode;null!==n&&function(e){delete e[Dc],delete e[jc],delete e[zc],delete e[Uc],delete e[Fc];}(n);}e.stateNode=null,e._debugOwner=null,e.return=null,e.dependencies=null,e.memoizedProps=null,e.memoizedState=null,e.pendingProps=null,e.stateNode=null,e.updateQueue=null;}function cb(e){return e.tag===f||e.tag===c||e.tag===d}function db(e){var t=e;e:for(;;){for(;null===t.sibling;){if(null===t.return||cb(t.return))return null;t=t.return;}for(t.sibling.return=t.return,t=t.sibling;t.tag!==f&&t.tag!==h&&t.tag!==M;){if(t.flags&Fr)continue e;if(null===t.child||t.tag===d)continue e;t.child.return=t,t=t.child;}if(!(t.flags&Fr))return t.stateNode}}function fb(e){var t=function(e){for(var t=e.return;null!==t;){if(cb(t))return t;t=t.return;}throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.")}(e);switch(t.tag){case f:var n=t.stateNode;t.flags&Hr&&(kc(n),t.flags&=-33),pb(e,db(e),n);break;case c:case d:var r=t.stateNode.containerInfo;hb(e,db(e),r);break;default:throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.")}}function hb(e,t,n){var r=e.tag;if(r===f||r===h){var i=e.stateNode;t?function(e,t,n){e.nodeType===gn?e.parentNode.insertBefore(t,n):e.insertBefore(t,n);}(n,i,t):function(e,t){var n;e.nodeType===gn?(n=e.parentNode).insertBefore(t,e):(n=e).appendChild(t),null==e._reactRootContainer&&null===n.onclick&&Hl(n);}(n,i);}else if(r===d);else {var o=e.child;if(null!==o){hb(o,t,n);for(var a=o.sibling;null!==a;)hb(a,t,n),a=a.sibling;}}}function pb(e,t,n){var r=e.tag;if(r===f||r===h){var i=e.stateNode;t?function(e,t,n){e.insertBefore(t,n);}(n,i,t):function(e,t){e.appendChild(t);}(n,i);}else if(r===d);else {var o=e.child;if(null!==o){pb(o,t,n);for(var a=o.sibling;null!==a;)pb(a,t,n),a=a.sibling;}}}var mb=null,gb=false;function vb(e,t,n){var r,i,o=t;e:for(;null!==o;){switch(o.tag){case f:mb=o.stateNode,gb=false;break e;case c:case d:mb=o.stateNode.containerInfo,gb=true;break e}o=o.return;}if(null===mb)throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");yb(e,t,n),mb=null,gb=false,null!==(i=(r=n).alternate)&&(i.return=null),r.return=null;}function bb(e,t,n){for(var r=n.child;null!==r;)yb(e,t,r),r=r.sibling;}function yb(e,t,n){switch(function(e){if(Ui&&"function"==typeof Ui.onCommitFiberUnmount)try{Ui.onCommitFiberUnmount(zi,e);}catch(e){Ki||(Ki=true,o("React instrumentation encountered an error: %s",e));}}(n),n.tag){case f:Kv||Qv(n,t);case h:var r=mb,i=gb;return mb=null,bb(e,t,n),gb=i,void(null!==(mb=r)&&(gb?(C=mb,R=n.stateNode,C.nodeType===gn?C.parentNode.removeChild(R):C.removeChild(R)):function(e,t){e.removeChild(t);}(mb,n.stateNode)));case M:return void(null!==mb&&(gb?function(e,t){e.nodeType===gn?Mc(e.parentNode,t):e.nodeType===pn&&Mc(e,t),rs(e);}(mb,n.stateNode):Mc(mb,n.stateNode)));case d:var a=mb,l=gb;return mb=n.stateNode.containerInfo,gb=true,bb(e,t,n),mb=a,void(gb=l);case s:case b:case _:case S:if(!Kv){var c=n.updateQueue;if(null!==c){var p=c.lastEffect;if(null!==p){var m=p.next,g=m;do{var v=g,y=v.destroy,w=v.tag;void 0!==y&&((w&Cp)!==kp?Jv(n,t,y):(w&xp)!==kp&&(Qi(n),n.mode&ao?(Ag(),Jv(n,t,y),Cg(n)):Jv(n,t,y),Ji())),g=g.next;}while(g!==m)}}}return void bb(e,t,n);case u:if(!Kv){Qv(n,t);var E=n.stateNode;"function"==typeof E.componentWillUnmount&&Gv(n,t,E);}return void bb(e,t,n);case x:return void bb(e,t,n);case A:if(n.mode&oo){var k=Kv;Kv=k||null!==n.memoizedState,bb(e,t,n),Kv=k;}else bb(e,t,n);break;default:return void bb(e,t,n)}var C,R;}function wb(e){var t=e.updateQueue;if(null!==t){e.updateQueue=null;var n=e.stateNode;null===n&&(n=e.stateNode=new qv),t.forEach((function(t){var r=Pw.bind(null,e,t);if(!n.has(t)){if(n.add(t),qi){if(null===Wv||null===$v)throw Error("Expected finished root and lanes to be set. This is a bug in React.");zw($v,Wv);}t.then(r,r);}}));}}function _b(e,t,n){var r=t.deletions;if(null!==r)for(var i=0;i<r.length;i++){var o=r[i];try{vb(e,t,o);}catch(e){xw(o,t,e);}}var a=pt;if(t.subtreeFlags&fi)for(var s=t.child;null!==s;)yt(s),Sb(s,e),s=s.sibling;yt(a);}function Sb(e,t,n){var r=e.alternate,i=e.flags;switch(e.tag){case s:case b:case _:case S:if(_b(t,e),Eb(e),i&Kr){try{rb(Cp|Mp,e,e.return),ib(Cp|Mp,e);}catch(t){xw(e,e.return,t);}if(e.mode&ao){try{Ag(),rb(xp|Mp,e,e.return);}catch(t){xw(e,e.return,t);}Cg(e);}else try{rb(xp|Mp,e,e.return);}catch(t){xw(e,e.return,t);}}return;case u:return _b(t,e),Eb(e),void(i&Yr&&null!==r&&Qv(r,r.return));case f:if(_b(t,e),Eb(e),i&Yr&&null!==r&&Qv(r,r.return),e.flags&Hr){var o=e.stateNode;try{kc(o);}catch(t){xw(e,e.return,t);}}if(i&Kr){var a=e.stateNode;if(null!=a){var l=e.memoizedProps,p=null!==r?r.memoizedProps:l,m=e.type,g=e.updateQueue;if(e.updateQueue=null,null!==g)try{!function(e,t,n,r,i,o){Vl(e,t,n,r,i),Zc(e,i);}(a,g,m,p,l);}catch(t){xw(e,e.return,t);}}}return;case h:if(_b(t,e),Eb(e),i&Kr){if(null===e.stateNode)throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");var v=e.stateNode,y=e.memoizedProps;null!==r&&r.memoizedProps;try{!function(e,t,n){e.nodeValue=n;}(v,0,y);}catch(t){xw(e,e.return,t);}}return;case c:if(_b(t,e),Eb(e),i&Kr)if(null!==r)if(r.memoizedState.isDehydrated)try{rs(t.containerInfo);}catch(t){xw(e,e.return,t);}return;case d:return _b(t,e),void Eb(e);case w:_b(t,e),Eb(e);var E=e.child;if(E.flags&Jr){var k=E.stateNode,M=null!==E.memoizedState;if(k.isHidden=M,M)null!==E.alternate&&null!==E.alternate.memoizedState||(Ey=Ti());}if(i&Kr){try{!function(e){e.memoizedState;}(e);}catch(t){xw(e,e.return,t);}wb(e);}return;case A:var T=null!==r&&null!==r.memoizedState;if(e.mode&oo){var P=Kv;Kv=P||T,_b(t,e),Kv=P;}else _b(t,e);if(Eb(e),i&Jr){var L=e.stateNode,I=null!==e.memoizedState,O=e;if(L.isHidden=I,I&&!T&&(O.mode&oo)!==io){Hv=O;for(var N=O.child;null!==N;)Hv=N,xb(N),N=N.sibling;}!function(e,t){for(var n=null,r=e;;){if(r.tag===f){if(null===n){n=r;try{var i=r.stateNode;t?Cc(i):xc(r.stateNode,r.memoizedProps);}catch(t){xw(e,e.return,t);}}}else if(r.tag===h){if(null===n)try{var o=r.stateNode;t?o.nodeValue="":Ac(o,r.memoizedProps);}catch(t){xw(e,e.return,t);}}else if((r.tag!==A&&r.tag!==R||null===r.memoizedState||r===e)&&null!==r.child){r.child.return=r,r=r.child;continue}if(r===e)return;for(;null===r.sibling;){if(null===r.return||r.return===e)return;n===r&&(n=null),r=r.return;}n===r&&(n=null),r.sibling.return=r.return,r=r.sibling;}}(O,I);}return;case C:return _b(t,e),Eb(e),void(i&Kr&&wb(e));case x:return;default:return _b(t,e),void Eb(e)}}function Eb(e){var t=e.flags;if(t&Fr){try{fb(e);}catch(t){xw(e,e.return,t);}e.flags&=-3;}t&Qr&&(e.flags&=-4097);}function kb(e,t,n){Wv=n,$v=t,Hv=e,Mb(e),Wv=null,$v=null;}function Mb(e,t,n){for(var r=(e.mode&oo)!==io;null!==Hv;){var i=Hv,o=i.child;if(i.tag===A&&r){var a=null!==i.memoizedState||Fv;if(a){Cb(e);continue}var s=i.alternate,u=null!==s&&null!==s.memoizedState,l=Fv,c=Kv;Fv=a,(Kv=u||Kv)&&!c&&(Hv=i,Rb(i));for(var d=o;null!==d;)Hv=d,Mb(d),d=d.sibling;Hv=i,Fv=l,Kv=c,Cb(e);}else (i.subtreeFlags&hi)!==zr&&null!==o?(o.return=i,Hv=o):Cb(e);}}function Cb(e,t,n){for(;null!==Hv;){var r=Hv;if((r.flags&hi)!==zr){var i=r.alternate;yt(r);try{ab(0,i,r);}catch(e){xw(r,r.return,e);}bt();}if(r===e)return void(Hv=null);var o=r.sibling;if(null!==o)return o.return=r.return,void(Hv=o);Hv=r.return;}}function xb(e){for(;null!==Hv;){var t=Hv,n=t.child;switch(t.tag){case s:case b:case _:case S:if(t.mode&ao)try{Ag(),rb(xp,t,t.return);}finally{Cg(t);}else rb(xp,t,t.return);break;case u:Qv(t,t.return);var r=t.stateNode;"function"==typeof r.componentWillUnmount&&Gv(t,t.return,r);break;case f:Qv(t,t.return);break;case A:if(null!==t.memoizedState){Ab(e);continue}}null!==n?(n.return=t,Hv=n):Ab(e);}}function Ab(e){for(;null!==Hv;){var t=Hv;if(t===e)return void(Hv=null);var n=t.sibling;if(null!==n)return n.return=t.return,void(Hv=n);Hv=t.return;}}function Rb(e){for(;null!==Hv;){var t=Hv,n=t.child;if(t.tag===A)if(null!==t.memoizedState){Tb(e);continue}null!==n?(n.return=t,Hv=n):Tb(e);}}function Tb(e){for(;null!==Hv;){var t=Hv;yt(t);try{sb(t);}catch(e){xw(t,t.return,e);}if(bt(),t===e)return void(Hv=null);var n=t.sibling;if(null!==n)return n.return=t.return,void(Hv=n);Hv=t.return;}}function Pb(e,t,n,r){Hv=t,function(e,t,n,r){for(;null!==Hv;){var i=Hv,o=i.child;(i.subtreeFlags&pi)!==zr&&null!==o?(o.return=i,Hv=o):Lb(e,t,n,r);}}(t,e,n,r);}function Lb(e,t,n,r){for(;null!==Hv;){var i=Hv;if((i.flags&Zr)!==zr){yt(i);try{Ib(t,i,n,r);}catch(e){xw(i,i.return,e);}bt();}if(i===e)return void(Hv=null);var o=i.sibling;if(null!==o)return o.return=i.return,void(Hv=o);Hv=i.return;}}function Ib(e,t,n,r){switch(t.tag){case s:case b:case S:if(t.mode&ao){Rg();try{ib(Ap|Mp,t);}finally{xg(t);}}else ib(Ap|Mp,t);}}function Ob(e){Hv=e,function(){for(;null!==Hv;){var e=Hv,t=e.child;if((Hv.flags&qr)!==zr){var n=e.deletions;if(null!==n){for(var r=0;r<n.length;r++){var i=n[r];Hv=i,jb(i,e);}var o=e.alternate;if(null!==o){var a=o.child;if(null!==a){o.child=null;do{var s=a.sibling;a.sibling=null,a=s;}while(null!==a)}}Hv=e;}}(e.subtreeFlags&pi)!==zr&&null!==t?(t.return=e,Hv=t):Nb();}}();}function Nb(){for(;null!==Hv;){var e=Hv;(e.flags&Zr)!==zr&&(yt(e),Db(e),bt());var t=e.sibling;if(null!==t)return t.return=e.return,void(Hv=t);Hv=e.return;}}function Db(e){switch(e.tag){case s:case b:case S:e.mode&ao?(Rg(),rb(Ap|Mp,e,e.return),xg(e)):rb(Ap|Mp,e,e.return);}}function jb(e,t){for(;null!==Hv;){var n=Hv;yt(n),zb(n,t),bt();var r=n.child;null!==r?(r.return=n,Hv=r):Bb(e);}}function Bb(e){for(;null!==Hv;){var t=Hv,n=t.sibling,r=t.return;if(lb(t),t===e)return void(Hv=null);if(null!==n)return n.return=r,void(Hv=n);Hv=r;}}function zb(e,t){switch(e.tag){case s:case b:case S:e.mode&ao?(Rg(),rb(Ap,e,t),xg(e)):rb(Ap,e,t);}}function Ub(e){switch(e.tag){case s:case b:case S:try{ib(xp|Mp,e);}catch(t){xw(e,e.return,t);}break;case u:var t=e.stateNode;try{t.componentDidMount();}catch(t){xw(e,e.return,t);}}}function Fb(e){switch(e.tag){case s:case b:case S:try{ib(Ap|Mp,e);}catch(t){xw(e,e.return,t);}}}function Kb(e){switch(e.tag){case s:case b:case S:try{rb(xp|Mp,e,e.return);}catch(t){xw(e,e.return,t);}break;case u:var t=e.stateNode;"function"==typeof t.componentWillUnmount&&Gv(e,e.return,t);}}function qb(e){switch(e.tag){case s:case b:case S:try{rb(Ap|Mp,e,e.return);}catch(t){xw(e,e.return,t);}}}if("function"==typeof Symbol&&Symbol.for){var Hb=Symbol.for;Hb("selector.component"),Hb("selector.has_pseudo_class"),Hb("selector.role"),Hb("selector.test_id"),Hb("selector.text");}var Wb=[];var $b=n.ReactCurrentActQueue;function Vb(){var e="undefined"!=typeof IS_REACT_ACT_ENVIRONMENT?IS_REACT_ACT_ENVIRONMENT:void 0;return e||null===$b.current||o("The current testing environment is not configured to support act(...)"),e}var Yb=Math.ceil,Gb=n.ReactCurrentDispatcher,Zb=n.ReactCurrentOwner,Qb=n.ReactCurrentBatchConfig,Jb=n.ReactCurrentActQueue,Xb=0,ey=1,ty=2,ny=4,ry=0,iy=1,oy=2,ay=3,sy=4,uy=5,ly=6,cy=Xb,dy=null,fy=null,hy=po,py=po,my=od(po),gy=ry,vy=null,by=po,yy=po,wy=po,_y=null,Sy=null,Ey=0,ky=500,My=1/0,Cy=500,xy=null;function Ay(){My=Ti()+Cy;}function Ry(){return My}var Ty=false,Py=null,Ly=null,Iy=false,Oy=null,Ny=po,Dy=[],jy=null,By=50,zy=0,Uy=null,Fy=false,Ky=false,qy=50,Hy=0,Wy=null,$y=Jo,Vy=po,Yy=false;function Gy(){return dy}function Zy(){return (cy&(ty|ny))!==Xb?Ti():$y!==Jo?$y:$y=Ti()}function Qy(e){if((e.mode&oo)===io)return go;if((cy&ty)!==Xb&&hy!==po)return da(hy);if(Sf.transition!==Ef){if(null!==Qb.transition){var t=Qb.transition;t._updatedFibers||(t._updatedFibers=new Set),t._updatedFibers.add(e);}return Vy===mo&&(Vy=la()),Vy}var n,r=Na();return r!==mo?r:void 0===(n=window.event)?La:fs(n.type)}function Jy(e){var t;return (e.mode&oo)===io?go:(t=ea,((ea<<=1)&zo)===po&&(ea=Uo),t)}function Xy(e,t,n,r){!function(){if(zy>By)throw zy=0,Uy=null,new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");Hy>qy&&(Hy=0,Wy=null,o("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));}(),Yy&&o("useInsertionEffect must not schedule updates."),Fy&&(Ky=true),wa(e,n,r),(cy&ty)!==po&&e===dy?function(e){if(mt&&!Ym)switch(e.tag){case s:case b:case S:var t=fy&&ft(fy)||"Unknown",n=t;if(!jw.has(n))jw.add(n),o("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render",ft(e)||"Unknown",t,t);break;case u:Bw||(o("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."),Bw=true);}}(t):(qi&&Ea(e,t,n),function(e){if(e.mode&oo){if(!Vb())return}else {if(t="undefined"!=typeof IS_REACT_ACT_ENVIRONMENT?IS_REACT_ACT_ENVIRONMENT:void 0,"undefined"==typeof jest||false===t)return;if(cy!==Xb)return;if(e.tag!==s&&e.tag!==b&&e.tag!==S)return}var t;if(null===Jb.current){var n=pt;try{yt(e),o("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act",ft(e));}finally{n?yt(e):bt();}}}(t),e===dy&&((cy&ty)===Xb&&(yy=ga(yy,n)),gy===sy&&iw(e,hy)),ew(e,r),n!==go||cy!==Xb||(t.mode&oo)!==io||Jb.isBatchingLegacy||(Ay(),Td()));}function ew(e,t){var n=e.callbackNode;!function(e,t){for(var n=e.pendingLanes,r=e.suspendedLanes,i=e.pingedLanes,o=e.expirationTimes,a=n;a>0;){var s=fa(a),u=1<<s,l=o[s];l===Jo?(u&r)!==po&&(u&i)===po||(o[s]=ra(u,t)):l<=t&&(e.expiredLanes|=u),a&=~u;}}(e,t);var r=na(e,e===dy?hy:po);if(r===po)return null!==n&&Kw(n),e.callbackNode=null,void(e.callbackPriority=mo);var i=ca(r),a=e.callbackPriority;if(a!==i||null!==Jb.current&&n!==Uw){var s,u;if(null!=n&&Kw(n),i===go)e.tag===kd?(null!==Jb.isBatchingLegacy&&(Jb.didScheduleLegacyUpdate=true),u=ow.bind(null,e),xd=true,Rd(u)):Rd(ow.bind(null,e)),null!==Jb.current?Jb.current.push(Pd):Sc((function(){(cy&(ty|ny))===Xb&&Pd();})),s=null;else {var l;switch(Ba(r)){case Ta:l=Li;break;case Pa:l=Ii;break;case La:l=Oi;break;case Ia:l=Di;break;default:l=Oi;}s=Fw(l,tw.bind(null,e));}e.callbackPriority=i,e.callbackNode=s;}else null==n&&a!==go&&o("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");}function tw(e,t){if(bg=false,yg=false,$y=Jo,Vy=po,(cy&(ty|ny))!==Xb)throw new Error("Should not already be working.");var n=e.callbackNode;if(Ew()&&e.callbackNode!==n)return null;var r=na(e,e===dy?hy:po);if(r===po)return null;var i=!sa(0,r)&&!function(e,t){return (t&e.expiredLanes)!==po}(e,r)&&!t,o=i?function(e,t){var n=cy;cy|=ty;var r=hw();if(dy!==e||hy!==t){if(qi){var i=e.memoizedUpdaters;i.size>0&&(zw(e,hy),i.clear()),ka(e,t);}xy=null,Ay(),dw(e,t);}to(t);for(;;)try{yw();break}catch(t){fw(e,t);}return Kf(),pw(r),cy=n,null!==fy?(null!==Fi&&"function"==typeof Fi.markRenderYielded&&Fi.markRenderYielded(),ry):(no(),dy=null,hy=po,gy)}(e,r):vw(e,r);if(o!==ry){if(o===oy){var a=ia(e);a!==po&&(r=a,o=nw(e,a));}if(o===iy){var s=vy;throw dw(e,po),iw(e,r),ew(e,Ti()),s}if(o===ly)iw(e,r);else {var u=!sa(0,r),l=e.current.alternate;if(u&&!function(e){var t=e;for(;;){if(t.flags&Xr){var n=t.updateQueue;if(null!==n){var r=n.stores;if(null!==r)for(var i=0;i<r.length;i++){var o=r[i],a=o.getSnapshot,s=o.value;try{if(!xu(a(),s))return !1}catch(e){return  false}}}}var u=t.child;if(t.subtreeFlags&Xr&&null!==u)u.return=t,t=u;else {if(t===e)return  true;for(;null===t.sibling;){if(null===t.return||t.return===e)return  true;t=t.return;}t.sibling.return=t.return,t=t.sibling;}}return  true}(l)){if((o=vw(e,r))===oy){var c=ia(e);c!==po&&(r=c,o=nw(e,c));}if(o===iy){var d=vy;throw dw(e,po),iw(e,r),ew(e,Ti()),d}}e.finishedWork=l,e.finishedLanes=r,function(e,t,n){switch(t){case ry:case iy:throw new Error("Root did not complete. This is a bug in React.");case oy:Sw(e,Sy,xy);break;case ay:if(iw(e,n),aa(n)&&!qw()){var r=Ey+ky-Ti();if(r>10){if(na(e,po)!==po)break;var i=e.suspendedLanes;if(!ma(i,n)){Zy(),_a(e,i);break}e.timeoutHandle=bc(Sw.bind(null,e,Sy,xy),r);break}}Sw(e,Sy,xy);break;case sy:if(iw(e,n),function(e){return (e&So)===e}(n))break;if(!qw()){var o=function(e,t){for(var n=e.eventTimes,r=Jo;t>0;){var i=fa(t),o=1<<i,a=n[i];a>r&&(r=a),t&=~o;}return r}(e,n),a=o,s=Ti()-a,u=((l=s)<120?120:l<480?480:l<1080?1080:l<1920?1920:l<3e3?3e3:l<4320?4320:1960*Yb(l/1960))-s;if(u>10){e.timeoutHandle=bc(Sw.bind(null,e,Sy,xy),u);break}}Sw(e,Sy,xy);break;case uy:Sw(e,Sy,xy);break;default:throw new Error("Unknown root exit status.")}var l;}(e,o,r);}}return ew(e,Ti()),e.callbackNode===n?tw.bind(null,e):null}function nw(e,t){var n=_y;za(e)&&(dw(e,t).flags|=Vr,o("An error occurred during hydration. The server HTML was replaced with client content in <%s>.",e.containerInfo.nodeName.toLowerCase()));var r=vw(e,t);if(r!==oy){var i=Sy;Sy=n,null!==i&&rw(i);}return r}function rw(e){null===Sy?Sy=e:Sy.push.apply(Sy,e);}function iw(e,t){t=va(t,wy),function(e,t){e.suspendedLanes|=t,e.pingedLanes&=~t;for(var n=e.expirationTimes,r=t;r>0;){var i=fa(r),o=1<<i;n[i]=Jo,r&=~o;}}(e,t=va(t,yy));}function ow(e){if(bg=yg,yg=false,(cy&(ty|ny))!==Xb)throw new Error("Should not already be working.");Ew();var t=na(e,po);if(!pa(t,go))return ew(e,Ti()),null;var n=vw(e,t);if(e.tag!==kd&&n===oy){var r=ia(e);r!==po&&(t=r,n=nw(e,r));}if(n===iy){var i=vy;throw dw(e,po),iw(e,t),ew(e,Ti()),i}if(n===ly)throw new Error("Root did not complete. This is a bug in React.");var o=e.current.alternate;return e.finishedWork=o,e.finishedLanes=t,Sw(e,Sy,xy),ew(e,Ti()),null}function aw(e,t){var n=cy;cy|=ey;try{return e(t)}finally{(cy=n)!==Xb||Jb.isBatchingLegacy||(Ay(),Td());}}function sw(e){null!==Oy&&Oy.tag===kd&&(cy&(ty|ny))===Xb&&Ew();var t=cy;cy|=ey;var n=Qb.transition,r=Na();try{return Qb.transition=null,Da(Ta),e?e():void 0}finally{Da(r),Qb.transition=n,((cy=t)&(ty|ny))===Xb&&Pd();}}function uw(){return (cy&(ty|ny))!==Xb}function lw(e,t){sd(my,py,e),py=ga(py,t);}function cw(e){py=my.current,ad(my,e);}function dw(e,t){e.finishedWork=null,e.finishedLanes=po;var n=e.timeoutHandle;if(n!==wc&&(e.timeoutHandle=wc,yc(n)),null!==fy)for(var r=fy.return;null!==r;){r.alternate;zv(0,r),r=r.return;}dy=e;var i=l_(e.current,null);return fy=i,hy=py=t,gy=ry,vy=null,by=po,yy=po,wy=po,_y=null,Sy=null,function(){if(null!==Qf){for(var e=0;e<Qf.length;e++){var t=Qf[e],n=t.interleaved;if(null!==n){t.interleaved=null;var r=n.next,i=t.pending;if(null!==i){var o=i.next;i.next=r,n.next=o;}t.pending=n;}}Qf=null;}}(),kf.discardPendingWarnings(),i}function fw(e,t){for(;;){var n=fy;try{if(Kf(),rm(),bt(),Zb.current=null,null===n||null===n.return)return gy=iy,vy=t,void(fy=null);if(F&&n.mode&ao&&Mg(n,!0),U)if(Gi(),null!==t&&"object"==typeof t&&"function"==typeof t.then)eo(n,t,hy);else Xi(n,t,hy);Ug(e,n.return,n,t,hy),_w(n);}catch(e){t=e,fy===n&&null!==n?(n=n.return,fy=n):n=fy;continue}return}}function hw(){var e=Gb.current;return Gb.current=rg,null===e?rg:e}function pw(e){Gb.current=e;}function mw(e){by=ga(e,by);}function gw(){gy!==ry&&gy!==ay&&gy!==oy||(gy=sy),null!==dy&&(oa(by)||oa(yy))&&iw(dy,hy);}function vw(e,t){var n=cy;cy|=ty;var r=hw();if(dy!==e||hy!==t){if(qi){var i=e.memoizedUpdaters;i.size>0&&(zw(e,hy),i.clear()),ka(e,t);}xy=null,dw(e,t);}for(to(t);;)try{bw();break}catch(t){fw(e,t);}if(Kf(),cy=n,pw(r),null!==fy)throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");return no(),dy=null,hy=po,gy}function bw(){for(;null!==fy;)ww(fy);}function yw(){for(;null!==fy&&!Ai();)ww(fy);}function ww(e){var t,n=e.alternate;yt(e),(e.mode&ao)!==io?(Eg(e),t=Ow(n,e,py),Mg(e,true)):t=Ow(n,e,py),bt(),e.memoizedProps=e.pendingProps,null===t?_w(e):fy=t,Zb.current=null;}function _w(e){var t=e;do{var n=t.alternate,r=t.return;if((t.flags&ni)===zr){yt(t);var i=void 0;if((t.mode&ao)===io?i=jv(n,t,py):(Eg(t),i=jv(n,t,py),Mg(t,false)),bt(),null!==i)return void(fy=i)}else {var o=Bv(0,t);if(null!==o)return o.flags&=ti,void(fy=o);if((t.mode&ao)!==io){Mg(t,false);for(var a=t.actualDuration,s=t.child;null!==s;)a+=s.actualDuration,s=s.sibling;t.actualDuration=a;}if(null===r)return gy=ly,void(fy=null);r.flags|=ni,r.subtreeFlags=zr,r.deletions=null;}var u=t.sibling;if(null!==u)return void(fy=u);fy=t=r;}while(null!==t);gy===ry&&(gy=uy);}function Sw(e,t,n){var r=Na(),i=Qb.transition;try{Qb.transition=null,Da(Ta),function(e,t,n,r){do{Ew();}while(null!==Oy);if(function(){kf.flushLegacyContextWarning(),kf.flushPendingUnsafeLifecycleWarnings();}(),(cy&(ty|ny))!==Xb)throw new Error("Should not already be working.");var i=e.finishedWork,a=e.finishedLanes;if(function(e){null!==Fi&&"function"==typeof Fi.markCommitStarted&&Fi.markCommitStarted(e);}(a),null===i)return Vi(),null;a===po&&o("root.finishedLanes should not be empty during a commit. This is a bug in React.");if(e.finishedWork=null,e.finishedLanes=po,i===e.current)throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");e.callbackNode=null,e.callbackPriority=mo;var s=ga(i.lanes,i.childLanes);((function(e,t){var n=e.pendingLanes&~t;e.pendingLanes=t,e.suspendedLanes=po,e.pingedLanes=po,e.expiredLanes&=t,e.mutableReadLanes&=t,e.entangledLanes&=t;for(var r=e.entanglements,i=e.eventTimes,o=e.expirationTimes,a=n;a>0;){var s=fa(a),u=1<<s;r[s]=po,i[s]=Jo,o[s]=Jo,a&=~u;}}))(e,s),e===dy&&(dy=null,fy=null,hy=po);(i.subtreeFlags&pi)===zr&&(i.flags&pi)===zr||Iy||(Iy=!0,jy=n,Fw(Oi,(function(){return Ew(),null})));var u=(i.subtreeFlags&(di|fi|hi|pi))!==zr,l=(i.flags&(di|fi|hi|pi))!==zr;if(u||l){var c=Qb.transition;Qb.transition=null;var d=Na();Da(Ta);var f=cy;cy|=ny,Zb.current=null,eb(e,i),Sg(),function(e,t,n){Wv=n,$v=e,yt(t),Sb(t,e),yt(t),Wv=null,$v=null;}(e,i,a),e.containerInfo,zu(hc),as(fc),fc=null,hc=null,e.current=i,function(e){null!==Fi&&"function"==typeof Fi.markLayoutEffectsStarted&&Fi.markLayoutEffectsStarted(e);}(a),kb(i,e,a),null!==Fi&&"function"==typeof Fi.markLayoutEffectsStopped&&Fi.markLayoutEffectsStopped(),Ri(),cy=f,Da(d),Qb.transition=c;}else e.current=i,Sg();var h=Iy;Iy?(Iy=!1,Oy=e,Ny=a):(Hy=0,Wy=null);s=e.pendingLanes,s===po&&(Ly=null);h||Lw(e.current,!1);((function(e,t){if(Ui&&"function"==typeof Ui.onCommitFiberRoot)try{var n=(e.current.flags&$r)===$r;if(F){var r;switch(t){case Ta:r=Li;break;case Pa:r=Ii;break;case La:r=Oi;break;case Ia:r=Di;break;default:r=Oi;}Ui.onCommitFiberRoot(zi,e,r,n);}}catch(e){Ki||(Ki=!0,o("React instrumentation encountered an error: %s",e));}}))(i.stateNode,r),qi&&e.memoizedUpdaters.clear();if(function(){Wb.forEach((function(e){return e()}));}(),ew(e,Ti()),null!==t)for(var p=e.onRecoverableError,m=0;m<t.length;m++){var g=t[m],v=g.stack,b=g.digest;p(g.value,{componentStack:v,digest:b});}if(Ty){Ty=!1;var y=Py;throw Py=null,y}pa(Ny,go)&&e.tag!==kd&&Ew();s=e.pendingLanes,pa(s,go)?(yg=!0,e===Uy?zy++:(zy=0,Uy=e)):zy=0;Pd(),Vi();}(e,t,n,r);}finally{Qb.transition=i,Da(r);}return null}function Ew(){if(null!==Oy){var e=Ba(Ny),t=function(e,t){return e>t?e:t}(La,e),n=Qb.transition,r=Na();try{return Qb.transition=null,Da(t),function(){if(null===Oy)return !1;var e=jy;jy=null;var t=Oy,n=Ny;if(Oy=null,Ny=po,(cy&(ty|ny))!==Xb)throw new Error("Cannot flush passive effects while already rendering.");Fy=!0,Ky=!1,function(e){null!==Fi&&"function"==typeof Fi.markPassiveEffectsStarted&&Fi.markPassiveEffectsStarted(e);}(n);var r=cy;cy|=ny,Ob(t.current),Pb(t,t.current,n,e);var i=Dy;Dy=[];for(var a=0;a<i.length;a++){ob(0,i[a]);}void(null!==Fi&&"function"==typeof Fi.markPassiveEffectsStopped&&Fi.markPassiveEffectsStopped()),Lw(t.current,!0),cy=r,Pd(),Ky?t===Wy?Hy++:(Hy=0,Wy=t):Hy=0;Fy=!1,Ky=!1,function(e){if(Ui&&"function"==typeof Ui.onPostCommitFiberRoot)try{Ui.onPostCommitFiberRoot(zi,e);}catch(e){Ki||(Ki=!0,o("React instrumentation encountered an error: %s",e));}}(t);var s=t.current.stateNode;return s.effectDuration=0,s.passiveEffectDuration=0,!0}()}finally{Da(r),Qb.transition=n;}}return  false}function kw(e){return null!==Ly&&Ly.has(e)}var Mw=function(e){Ty||(Ty=true,Py=e);};function Cw(e,t,n){var r=hh(e,Ng(e,Pg(n,t),go),go),i=Zy();null!==r&&(wa(r,go,i),ew(r,i));}function xw(e,t,n){if(function(e){Dr(null,(function(){throw e})),jr();}(n),Hw(false),e.tag!==c){var r=null;for(r=t;null!==r;){if(r.tag===c)return void Cw(r,e,n);if(r.tag===u){var i=r.type,a=r.stateNode;if("function"==typeof i.getDerivedStateFromError||"function"==typeof a.componentDidCatch&&!kw(a)){var s=hh(r,Dg(r,Pg(n,e),go),go),l=Zy();return void(null!==s&&(wa(s,go,l),ew(s,l)))}}r=r.return;}o("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s",n);}else Cw(e,e,n);}function Aw(e,t,n){var r=e.pingCache;null!==r&&r.delete(t);var i=Zy();_a(e,n),function(e){e.tag!==kd&&Vb()&&null===Jb.current&&o("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");}(e),dy===e&&ma(hy,n)&&(gy===sy||gy===ay&&aa(hy)&&Ti()-Ey<ky?dw(e,po):wy=ga(wy,n)),ew(e,i);}function Rw(e,t){t===mo&&(t=Jy(e));var n=Zy(),r=eh(e,t);null!==r&&(wa(r,t,n),ew(r,n));}function Tw(e){var t=e.memoizedState,n=mo;null!==t&&(n=t.retryLane),Rw(e,n);}function Pw(e,t){var n,r=mo;switch(e.tag){case w:n=e.stateNode;var i=e.memoizedState;null!==i&&(r=i.retryLane);break;case C:n=e.stateNode;break;default:throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.")}null!==n&&n.delete(t),Rw(e,r);}function Lw(e,t){yt(e),Iw(e,li,Kb),t&&Iw(e,ci,qb),Iw(e,li,Ub),t&&Iw(e,ci,Fb),bt();}function Iw(e,t,n){for(var r=e,i=null;null!==r;){var o=r.subtreeFlags&t;r!==i&&null!==r.child&&o!==zr?r=r.child:((r.flags&t)!==zr&&n(r),r=null!==r.sibling?r.sibling:i=r.return);}}var Ow,Nw=null;function Dw(e){if((cy&ty)===Xb&&e.mode&oo){var t=e.tag;if(t===l||t===c||t===u||t===s||t===b||t===_||t===S){var n=ft(e)||"ReactComponent";if(null!==Nw){if(Nw.has(n))return;Nw.add(n);}else Nw=new Set([n]);var r=pt;try{yt(e),o("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");}finally{r?yt(e):bt();}}}}Ow=function(e,t,n){var r=v_(null,t);try{return Pv(e,t,n)}catch(o){if(Qd||null!==o&&"object"==typeof o&&"function"==typeof o.then)throw o;if(Kf(),rm(),zv(0,t),v_(t,r),t.mode&ao&&Eg(t),Dr(null,Pv,null,e,t,n),Pr){var i=jr();"object"==typeof i&&null!==i&&i._suppressLogging&&"object"==typeof o&&null!==o&&!o._suppressLogging&&(o._suppressLogging=true);}throw o}};var jw,Bw=false;function zw(e,t){qi&&e.memoizedUpdaters.forEach((function(n){Ea(e,n,t);}));}jw=new Set;var Uw={};function Fw(e,t){var n=Jb.current;return null!==n?(n.push(t),Uw):Ci(e,t)}function Kw(e){if(e!==Uw)return xi(e)}function qw(){return null!==Jb.current}function Hw(e){Yy=e;}var Ww=null,$w=null,Vw=function(e){Ww=e;};function Yw(e){if(null===Ww)return e;var t=Ww(e);return void 0===t?e:t.current}function Gw(e){return Yw(e)}function Zw(e){if(null===Ww)return e;var t=Ww(e);if(void 0===t){if(null!=e&&"function"==typeof e.render){var n=Yw(e.render);if(e.render!==n){var r={$$typeof:Ie,render:n};return void 0!==e.displayName&&(r.displayName=e.displayName),r}}return e}return t.current}function Qw(e,t){if(null===Ww)return  false;var n=e.elementType,r=t.type,i=false,o="object"==typeof r&&null!==r?r.$$typeof:null;switch(e.tag){case u:"function"==typeof r&&(i=true);break;case s:("function"==typeof r||o===je)&&(i=true);break;case b:(o===Ie||o===je)&&(i=true);break;case _:case S:(o===De||o===je)&&(i=true);break;default:return  false}if(i){var a=Ww(n);if(void 0!==a&&a===Ww(r))return  true}return  false}function Jw(e){null!==Ww&&"function"==typeof WeakSet&&(null===$w&&($w=new WeakSet),$w.add(e));}var Xw=function(e,t){if(null!==Ww){var n=t.staleFamilies,r=t.updatedFamilies;Ew(),sw((function(){t_(e.current,r,n);}));}},e_=function(e,t){e.context===ud&&(Ew(),sw((function(){x_(t,e,null,null);})));};function t_(e,t,n){var r=e.alternate,i=e.child,o=e.sibling,a=e.tag,l=e.type,c=null;switch(a){case s:case S:case u:c=l;break;case b:c=l.render;}if(null===Ww)throw new Error("Expected resolveFamily to be set during hot reload.");var d=false,f=false;if(null!==c){var h=Ww(c);void 0!==h&&(n.has(h)?f=true:t.has(h)&&(a===u?f=true:d=true));}if(null!==$w&&($w.has(e)||null!==r&&$w.has(r))&&(f=true),f&&(e._debugNeedsRemount=true),f||d){var p=eh(e,go);null!==p&&Xy(p,e,go,Jo);}null===i||f||t_(i,t,n),null!==o&&t_(o,t,n);}var n_,r_=function(e,t){var n=new Set,r=new Set(t.map((function(e){return e.current})));return i_(e.current,r,n),n};function i_(e,t,n){var r=e.child,i=e.sibling,o=e.tag,a=e.type,l=null;switch(o){case s:case S:case u:l=a;break;case b:l=a.render;}var h=false;null!==l&&t.has(l)&&(h=true),h?function(e,t){var n=function(e,t){var n=e,r=false;for(;;){if(n.tag===f)r=true,t.add(n.stateNode);else if(null!==n.child){n.child.return=n,n=n.child;continue}if(n===e)return r;for(;null===n.sibling;){if(null===n.return||n.return===e)return r;n=n.return;}n.sibling.return=n.return,n=n.sibling;}return  false}(e,t);if(n)return;var r=e;for(;;){switch(r.tag){case f:return void t.add(r.stateNode);case d:case c:return void t.add(r.stateNode.containerInfo)}if(null===r.return)throw new Error("Expected to reach root first.");r=r.return;}}(e,n):null!==r&&i_(r,t,n),null!==i&&i_(i,t,n);}n_=false;try{var o_=Object.preventExtensions({});new Map([[o_,null]]),new Set([o_]);}catch(e){n_=true;}function a_(e,t,n,r){this.tag=e,this.key=n,this.elementType=null,this.type=null,this.stateNode=null,this.return=null,this.child=null,this.sibling=null,this.index=0,this.ref=null,this.pendingProps=t,this.memoizedProps=null,this.updateQueue=null,this.memoizedState=null,this.dependencies=null,this.mode=r,this.flags=zr,this.subtreeFlags=zr,this.deletions=null,this.lanes=po,this.childLanes=po,this.alternate=null,this.actualDuration=Number.NaN,this.actualStartTime=Number.NaN,this.selfBaseDuration=Number.NaN,this.treeBaseDuration=Number.NaN,this.actualDuration=0,this.actualStartTime=-1,this.selfBaseDuration=0,this.treeBaseDuration=0,this._debugSource=null,this._debugOwner=null,this._debugNeedsRemount=false,this._debugHookTypes=null,n_||"function"!=typeof Object.preventExtensions||Object.preventExtensions(this);}var s_=function(e,t,n,r){return new a_(e,t,n,r)};function u_(e){var t=e.prototype;return !(!t||!t.isReactComponent)}function l_(e,t){var n=e.alternate;null===n?((n=s_(e.tag,t,e.key,e.mode)).elementType=e.elementType,n.type=e.type,n.stateNode=e.stateNode,n._debugSource=e._debugSource,n._debugOwner=e._debugOwner,n._debugHookTypes=e._debugHookTypes,n.alternate=e,e.alternate=n):(n.pendingProps=t,n.type=e.type,n.flags=zr,n.subtreeFlags=zr,n.deletions=null,n.actualDuration=0,n.actualStartTime=-1),n.flags=e.flags&mi,n.childLanes=e.childLanes,n.lanes=e.lanes,n.child=e.child,n.memoizedProps=e.memoizedProps,n.memoizedState=e.memoizedState,n.updateQueue=e.updateQueue;var r=e.dependencies;switch(n.dependencies=null===r?null:{lanes:r.lanes,firstContext:r.firstContext},n.sibling=e.sibling,n.index=e.index,n.ref=e.ref,n.selfBaseDuration=e.selfBaseDuration,n.treeBaseDuration=e.treeBaseDuration,n._debugNeedsRemount=e._debugNeedsRemount,n.tag){case l:case s:case S:n.type=Yw(e.type);break;case u:n.type=Gw(e.type);break;case b:n.type=Zw(e.type);}return n}function c_(e,t){e.flags&=mi|Fr;var n=e.alternate;if(null===n)e.childLanes=po,e.lanes=t,e.child=null,e.subtreeFlags=zr,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null,e.stateNode=null,e.selfBaseDuration=0,e.treeBaseDuration=0;else {e.childLanes=n.childLanes,e.lanes=n.lanes,e.child=n.child,e.subtreeFlags=zr,e.deletions=null,e.memoizedProps=n.memoizedProps,e.memoizedState=n.memoizedState,e.updateQueue=n.updateQueue,e.type=n.type;var r=n.dependencies;e.dependencies=null===r?null:{lanes:r.lanes,firstContext:r.firstContext},e.selfBaseDuration=n.selfBaseDuration,e.treeBaseDuration=n.treeBaseDuration;}return e}function d_(e,t,n,r,i,a){var s=l,c=e;if("function"==typeof e)u_(e)?(s=u,c=Gw(c)):c=Yw(c);else if("string"==typeof e)s=f;else e:switch(e){case Ae:return h_(n.children,i,a,t);case Re:s=m,((i|=so)&oo)!==io&&(i|=uo);break;case Te:return function(e,t,n,r){"string"!=typeof e.id&&o('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',typeof e.id);var i=s_(y,e,r,t|ao);return i.elementType=Te,i.lanes=n,i.stateNode={effectDuration:0,passiveEffectDuration:0},i}(n,i,a,t);case Oe:return function(e,t,n,r){var i=s_(w,e,r,t);return i.elementType=Oe,i.lanes=n,i}(n,i,a,t);case Ne:return function(e,t,n,r){var i=s_(C,e,r,t);return i.elementType=Ne,i.lanes=n,i}(n,i,a,t);case Be:return p_(n,i,a,t);default:if("object"==typeof e&&null!==e)switch(e.$$typeof){case Pe:s=v;break e;case Le:s=g;break e;case Ie:s=b,c=Zw(c);break e;case De:s=_;break e;case je:s=E,c=null;break e}var d="";(void 0===e||"object"==typeof e&&null!==e&&0===Object.keys(e).length)&&(d+=" You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");var h=r?ft(r):null;throw h&&(d+="\n\nCheck the render method of `"+h+"`."),new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: "+(null==e?e:typeof e)+"."+d)}var p=s_(s,n,t,i);return p.elementType=e,p.type=c,p.lanes=a,p._debugOwner=r,p}function f_(e,t,n){var r;r=e._owner;var i=d_(e.type,e.key,e.props,r,t,n);return i._debugSource=e._source,i._debugOwner=e._owner,i}function h_(e,t,n,r){var i=s_(p,e,r,t);return i.lanes=n,i}function p_(e,t,n,r){var i=s_(A,e,r,t);i.elementType=Be,i.lanes=n;return i.stateNode={isHidden:false},i}function m_(e,t,n){var r=s_(h,e,null,t);return r.lanes=n,r}function g_(e,t,n){var r=null!==e.children?e.children:[],i=s_(d,r,e.key,t);return i.lanes=n,i.stateNode={containerInfo:e.containerInfo,pendingChildren:null,implementation:e.implementation},i}function v_(e,t){return null===e&&(e=s_(l,null,null,io)),e.tag=t.tag,e.key=t.key,e.elementType=t.elementType,e.type=t.type,e.stateNode=t.stateNode,e.return=t.return,e.child=t.child,e.sibling=t.sibling,e.index=t.index,e.ref=t.ref,e.pendingProps=t.pendingProps,e.memoizedProps=t.memoizedProps,e.updateQueue=t.updateQueue,e.memoizedState=t.memoizedState,e.dependencies=t.dependencies,e.mode=t.mode,e.flags=t.flags,e.subtreeFlags=t.subtreeFlags,e.deletions=t.deletions,e.lanes=t.lanes,e.childLanes=t.childLanes,e.alternate=t.alternate,e.actualDuration=t.actualDuration,e.actualStartTime=t.actualStartTime,e.selfBaseDuration=t.selfBaseDuration,e.treeBaseDuration=t.treeBaseDuration,e._debugSource=t._debugSource,e._debugOwner=t._debugOwner,e._debugNeedsRemount=t._debugNeedsRemount,e._debugHookTypes=t._debugHookTypes,e}function b_(e,t,n,r,i){this.tag=t,this.containerInfo=e,this.pendingChildren=null,this.current=null,this.pingCache=null,this.finishedWork=null,this.timeoutHandle=wc,this.context=null,this.pendingContext=null,this.callbackNode=null,this.callbackPriority=mo,this.eventTimes=ya(po),this.expirationTimes=ya(Jo),this.pendingLanes=po,this.suspendedLanes=po,this.pingedLanes=po,this.expiredLanes=po,this.mutableReadLanes=po,this.finishedLanes=po,this.entangledLanes=po,this.entanglements=ya(po),this.identifierPrefix=r,this.onRecoverableError=i,this.mutableSourceEagerHydrationData=null,this.effectDuration=0,this.passiveEffectDuration=0,this.memoizedUpdaters=new Set;for(var o=this.pendingUpdatersLaneMap=[],a=0;a<ho;a++)o.push(new Set);switch(t){case Md:this._debugRootType=n?"hydrateRoot()":"createRoot()";break;case kd:this._debugRootType=n?"hydrate()":"render()";}}function y_(e,t,n,r,i,o,a,s,u,l){var d=new b_(e,t,n,s,u),f=function(e,t,n){var r;return e===Md?(r=oo,true===t&&(r|=so,r|=uo)):r=io,qi&&(r|=ao),s_(c,null,null,r)}(t,o);d.current=f,f.stateNode=d;var h={element:r,isDehydrated:n,cache:null,transitions:null,pendingSuspenseBoundaries:null};return f.memoizedState=h,ch(f),d}var w_,__,S_="18.2.0";function E_(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null;return function(e){if(Q(e))o("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.",Z(e));}(r),{$$typeof:xe,key:null==r?null:""+r,children:e,containerInfo:t,implementation:n}}function k_(e){if(!e)return ud;var t=Br(e),n=Ed(t);if(t.tag===u){var r=t.type;if(gd(r))return wd(t,r,n)}return n}function M_(e,t,n,r,i,o,a,s){return y_(e,t,false,null,0,r,0,o,a)}function C_(e,t,n,r,i,o,a,s,u,l){var c=y_(n,r,true,e,0,o,0,s,u);c.context=k_(null);var d=c.current,f=Zy(),h=Qy(d),p=fh(f,h);return p.callback=null!=t?t:null,hh(d,p,h),function(e,t,n){e.current.lanes=t,wa(e,t,n),ew(e,n);}(c,h,f),c}function x_(e,t,n,r){!function(e,t){if(Ui&&"function"==typeof Ui.onScheduleFiberRoot)try{Ui.onScheduleFiberRoot(zi,e,t);}catch(e){Ki||(Ki=true,o("React instrumentation encountered an error: %s",e));}}(t,e);var i=t.current,a=Zy(),s=Qy(i);!function(e){null!==Fi&&"function"==typeof Fi.markRenderScheduled&&Fi.markRenderScheduled(e);}(s);var u=k_(n);null===t.context?t.context=u:t.pendingContext=u,mt&&null!==pt&&!w_&&(w_=true,o("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.",ft(pt)||"Unknown"));var l=fh(a,s);l.payload={element:e},null!==(r=void 0===r?null:r)&&("function"!=typeof r&&o("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.",r),l.callback=r);var c=hh(i,l,s);return null!==c&&(Xy(c,i,s,a),ph(c,i,s)),s}function A_(e){var t=e.current;return t.child?(t.child.tag,t.child.stateNode):null}function R_(e,t){var n=e.memoizedState;null!==n&&null!==n.dehydrated&&(n.retryLane=function(e,t){return e!==mo&&e<t?e:t}(n.retryLane,t));}function T_(e,t){R_(e,t);var n=e.alternate;n&&R_(n,t);}function P_(e){var t=ki(e);return null===t?null:t.stateNode}w_=false,__={};var L_=function(e){return null};var I_=function(e){return  false};var O_,N_,D_,j_,B_,z_,U_,F_,K_,q_=function(e,t,n){var r=t[n],i=Yt(e)?e.slice():Ge({},e);return n+1===t.length?(Yt(i)?i.splice(r,1):delete i[r],i):(i[r]=q_(e[r],t,n+1),i)},H_=function(e,t){return q_(e,t,0)},W_=function(e,t,n,r){var i=t[r],o=Yt(e)?e.slice():Ge({},e);r+1===t.length?(o[n[r]]=o[i],Yt(o)?o.splice(i,1):delete o[i]):o[i]=W_(e[i],t,n,r+1);return o},$_=function(e,t,n){if(t.length===n.length){for(var r=0;r<n.length-1;r++)if(t[r]!==n[r])return void i("copyWithRename() expects paths to be the same except for the deepest key");return W_(e,t,n,0)}i("copyWithRename() expects paths of the same length");},V_=function(e,t,n,r){if(n>=t.length)return r;var i=t[n],o=Yt(e)?e.slice():Ge({},e);return o[i]=V_(e[i],t,n+1,r),o},Y_=function(e,t,n){return V_(e,t,0,n)},G_=function(e,t){for(var n=e.memoizedState;null!==n&&t>0;)n=n.next,t--;return n};function Z_(e){var t=Si(e);return null===t?null:t.stateNode}function Q_(e){return null}function J_(){return pt}O_=function(e,t,n,r){var i=G_(e,t);if(null!==i){var o=Y_(i.memoizedState,n,r);i.memoizedState=o,i.baseState=o,e.memoizedProps=Ge({},e.memoizedProps);var a=eh(e,go);null!==a&&Xy(a,e,go,Jo);}},N_=function(e,t,n){var r=G_(e,t);if(null!==r){var i=H_(r.memoizedState,n);r.memoizedState=i,r.baseState=i,e.memoizedProps=Ge({},e.memoizedProps);var o=eh(e,go);null!==o&&Xy(o,e,go,Jo);}},D_=function(e,t,n,r){var i=G_(e,t);if(null!==i){var o=$_(i.memoizedState,n,r);i.memoizedState=o,i.baseState=o,e.memoizedProps=Ge({},e.memoizedProps);var a=eh(e,go);null!==a&&Xy(a,e,go,Jo);}},j_=function(e,t,n){e.pendingProps=Y_(e.memoizedProps,t,n),e.alternate&&(e.alternate.pendingProps=e.pendingProps);var r=eh(e,go);null!==r&&Xy(r,e,go,Jo);},B_=function(e,t){e.pendingProps=H_(e.memoizedProps,t),e.alternate&&(e.alternate.pendingProps=e.pendingProps);var n=eh(e,go);null!==n&&Xy(n,e,go,Jo);},z_=function(e,t,n){e.pendingProps=$_(e.memoizedProps,t,n),e.alternate&&(e.alternate.pendingProps=e.pendingProps);var r=eh(e,go);null!==r&&Xy(r,e,go,Jo);},U_=function(e){var t=eh(e,go);null!==t&&Xy(t,e,go,Jo);},F_=function(e){L_=e;},K_=function(e){I_=e;};var X_="function"==typeof reportError?reportError:function(e){console.error(e);};function eS(e){this._internalRoot=e;}function tS(e){this._internalRoot=e;}function nS(e){return !(!e||e.nodeType!==pn&&e.nodeType!==vn&&e.nodeType!==bn&&j)}function rS(e){return !(!e||e.nodeType!==pn&&e.nodeType!==vn&&e.nodeType!==bn&&(e.nodeType!==gn||" react-mount-point-unstable "!==e.nodeValue))}function iS(e){e.nodeType===pn&&e.tagName&&"BODY"===e.tagName.toUpperCase()&&o("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."),Wc(e)&&(e._reactRootContainer?o("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."):o("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));}tS.prototype.render=eS.prototype.render=function(e){var t=this._internalRoot;if(null===t)throw new Error("Cannot update an unmounted root.");"function"==typeof arguments[1]?o("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."):nS(arguments[1])?o("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."):void 0!==arguments[1]&&o("You passed a second argument to root.render(...) but it only accepts one argument.");var n=t.containerInfo;if(n.nodeType!==gn){var r=P_(t.current);r&&r.parentNode!==n&&o("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");}x_(e,t,null,null);},tS.prototype.unmount=eS.prototype.unmount=function(){"function"==typeof arguments[0]&&o("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");var e=this._internalRoot;if(null!==e){this._internalRoot=null;var t=e.containerInfo;uw()&&o("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."),sw((function(){x_(null,e,null,null);})),Hc(t);}},tS.prototype.unstable_scheduleHydration=function(e){e&&function(e){for(var t=Aa(),n={blockedOn:null,target:e,priority:t},r=0;r<Ya.length&&ja(t,Ya[r].priority);r++);Ya.splice(r,0,n),0===r&&Ja(n);}(e);};var oS,aS,sS,uS=n.ReactCurrentOwner;function lS(e){return e?e.nodeType===vn?e.documentElement:e.firstChild:null}function cS(){}function dS(e,t,n,r,i){oS(n),function(e,t){null!==e&&"function"!=typeof e&&o("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.",t,e);}(void 0===i?null:i,"render");var a,s=n._reactRootContainer;if(s){if("function"==typeof i){var u=i;i=function(){var e=A_(a);u.call(e);};}x_(t,a=s,e,i);}else a=function(e,t,n,r,i){if(i){if("function"==typeof r){var o=r;r=function(){var e=A_(a);o.call(e);};}var a=C_(t,r,e,kd,0,false,0,"",cS);return e._reactRootContainer=a,qc(a.current,e),ml(e.nodeType===gn?e.parentNode:e),sw(),a}for(var s;s=e.lastChild;)e.removeChild(s);if("function"==typeof r){var u=r;r=function(){var e=A_(l);u.call(e);};}var l=M_(e,kd,0,false,0,"",cS);return e._reactRootContainer=l,qc(l.current,e),ml(e.nodeType===gn?e.parentNode:e),sw((function(){x_(t,l,n,r);})),l}(n,t,e,i,r);return A_(a)}oS=function(e){if(e._reactRootContainer&&e.nodeType!==gn){var t=P_(e._reactRootContainer.current);t&&t.parentNode!==e&&o("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");}var n=!!e._reactRootContainer,r=lS(e);!(!r||!Vc(r))&&!n&&o("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."),e.nodeType===pn&&e.tagName&&"BODY"===e.tagName.toUpperCase()&&o("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");},aS=function(e){switch(e.tag){case c:var t=e.stateNode;if(za(t)){var n=function(e){return ta(e.pendingLanes)}(t);!function(e,t){t!==po&&(Sa(e,ga(t,go)),ew(e,Ti()),(cy&(ty|ny))===Xb&&(Ay(),Pd()));}(t,n);}break;case w:sw((function(){var t=eh(e,go);if(null!==t){var n=Zy();Xy(t,e,go,n);}})),T_(e,go);}},Ma=aS,function(e){Ca=e;}((function(e){if(e.tag===w){var t=$o,n=eh(e,t);if(null!==n)Xy(n,e,t,Zy());T_(e,t);}})),function(e){xa=e;}((function(e){if(e.tag===w){var t=Qy(e),n=eh(e,t);if(null!==n)Xy(n,e,t,Zy());T_(e,t);}})),function(e){Aa=e;}(Na),function(e){Ra=e;}((function(e,t){var n=Oa;try{return Oa=e,t()}finally{Oa=n;}})),"function"==typeof Map&&null!=Map.prototype&&"function"==typeof Map.prototype.forEach&&"function"==typeof Set&&null!=Set.prototype&&"function"==typeof Set.prototype.clear&&"function"==typeof Set.prototype.forEach||o("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"),sS=function(e,t,n){switch(t){case "input":return void Ut(e,n);case "textarea":return void function(e,t){rn(e,t);}(e,n);case "select":return void function(e,t){var n=e,r=t.value;null!=r&&Qt(n,!!t.multiple,r,false);}(e,n)}},hr=sS,yr=aw,wr=sw;var fS={usingClientEntryPoint:false,Events:[Vc,Yc,Gc,vr,br,aw]};var hS=function(e){var t=e.findFiberByHostInstance,r=n.ReactCurrentDispatcher;return function(e){if("undefined"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return  false;var t=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(t.isDisabled)return  true;if(!t.supportsFiber)return o("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"),true;try{U&&(e=Ge({},e,{getLaneLabelMap:$i,injectProfilingHooks:Wi})),zi=t.inject(e),Ui=t;}catch(e){o("React instrumentation encountered an error: %s.",e);}return !!t.checkDCE}({bundleType:e.bundleType,version:e.version,rendererPackageName:e.rendererPackageName,rendererConfig:e.rendererConfig,overrideHookState:O_,overrideHookStateDeletePath:N_,overrideHookStateRenamePath:D_,overrideProps:j_,overridePropsDeletePath:B_,overridePropsRenamePath:z_,setErrorHandler:F_,setSuspenseHandler:K_,scheduleUpdate:U_,currentDispatcherRef:r,findHostInstanceByFiber:Z_,findFiberByHostInstance:t||Q_,findHostInstancesForRefresh:r_,scheduleRefresh:Xw,scheduleRoot:e_,setRefreshHandler:Vw,getCurrentFiber:J_,reconcilerVersion:S_})}({findFiberByHostInstance:$c,bundleType:1,version:S_,rendererPackageName:"react-dom"});if(!hS&&Y&&window.top===window.self&&(navigator.userAgent.indexOf("Chrome")>-1&&-1===navigator.userAgent.indexOf("Edge")||navigator.userAgent.indexOf("Firefox")>-1)){var pS=window.location.protocol;/^(https?|file):$/.test(pS)&&console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools"+("file:"===pS?"\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq":""),"font-weight:bold");}ZT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=fS,ZT.createPortal=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;if(!nS(t))throw new Error("Target container is not a DOM element.");return E_(e,t,null,n)},ZT.createRoot=function(e,t){return fS.usingClientEntryPoint||o('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'),function(e,t){if(!nS(e))throw new Error("createRoot(...): Target container is not a DOM element.");iS(e);var n=false,r="",a=X_;null!=t&&(t.hydrate?i("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead."):"object"==typeof t&&null!==t&&t.$$typeof===Ce&&o("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);"),true===t.unstable_strictMode&&(n=true),void 0!==t.identifierPrefix&&(r=t.identifierPrefix),void 0!==t.onRecoverableError&&(a=t.onRecoverableError),void 0!==t.transitionCallbacks&&t.transitionCallbacks);var s=M_(e,Md,0,n,0,r,a);return qc(s.current,e),ml(e.nodeType===gn?e.parentNode:e),new eS(s)}(e,t)},ZT.findDOMNode=function(e){var t=uS.current;return null!==t&&null!==t.stateNode&&(t.stateNode._warnedAboutRefsInRender||o("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.",ct(t.type)||"A component"),t.stateNode._warnedAboutRefsInRender=true),null==e?null:e.nodeType===pn?e:function(e,t){var n=Br(e);if(void 0===n){if("function"==typeof e.render)throw new Error("Unable to find node on an unmounted component.");var r=Object.keys(e).join(",");throw new Error("Argument appears to not be a ReactComponent. Keys: "+r)}var i=Si(n);if(null===i)return null;if(i.mode&so){var a=ft(n)||"Component";if(!__[a]){__[a]=true;var s=pt;try{yt(i),n.mode&so?o("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node",t,t,a):o("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node",t,t,a);}finally{s?yt(s):bt();}}}return i.stateNode}(e,"findDOMNode")},ZT.flushSync=function(e){return uw()&&o("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."),sw(e)},ZT.hydrate=function(e,t,n){if(o("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"),!rS(t))throw new Error("Target container is not a DOM element.");return Wc(t)&&void 0===t._reactRootContainer&&o("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?"),dS(null,e,t,true,n)},ZT.hydrateRoot=function(e,t,n){return fS.usingClientEntryPoint||o('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'),function(e,t,n){if(!nS(e))throw new Error("hydrateRoot(...): Target container is not a DOM element.");iS(e),void 0===t&&o("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");var r=null!=n&&n.hydratedSources||null,i=false,a="",s=X_;null!=n&&(true===n.unstable_strictMode&&(i=true),void 0!==n.identifierPrefix&&(a=n.identifierPrefix),void 0!==n.onRecoverableError&&(s=n.onRecoverableError));var u=C_(t,null,e,Md,0,i,0,a,s);if(qc(u.current,e),ml(e),r)for(var l=0;l<r.length;l++)Pp(u,r[l]);return new tS(u)}(e,t,n)},ZT.render=function(e,t,n){if(o("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"),!rS(t))throw new Error("Target container is not a DOM element.");return Wc(t)&&void 0===t._reactRootContainer&&o("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?"),dS(null,e,t,false,n)},ZT.unmountComponentAtNode=function(e){if(!rS(e))throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");if(Wc(e)&&void 0===e._reactRootContainer&&o("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?"),e._reactRootContainer){var t=lS(e);return t&&!Vc(t)&&o("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React."),sw((function(){dS(null,null,e,!1,(function(){e._reactRootContainer=null,Hc(e);}));})),true}var n=lS(e),r=!(!n||!Vc(n)),i=e.nodeType===pn&&rS(e.parentNode)&&!!e.parentNode._reactRootContainer;return r&&o("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s",i?"You may have accidentally passed in a React root node instead of its container.":"Instead, have the parent component update its state and rerender in order to remove this component."),false},ZT.unstable_batchedUpdates=aw,ZT.unstable_renderSubtreeIntoContainer=function(e,t,n,r){return function(e,t,n,r){if(o("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"),!rS(n))throw new Error("Target container is not a DOM element.");if(null==e||!function(e){return void 0!==e._reactInternals}(e))throw new Error("parentComponent must be a valid React Component");return dS(e,t,n,false,r)}(e,t,n,r)},ZT.version=S_,"undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop&&__REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error);}()),ZT}function JT(){if(GT)return NT;GT=1;var e=(YT||(YT=1,"production"===je.env.NODE_ENV?(function e(){if("undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE){if("production"!==je.env.NODE_ENV)throw new Error("^_^");try{__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);}catch(e){console.error(e);}}}(),DT.exports=$T()):DT.exports=QT()),DT.exports);if("production"===je.env.NODE_ENV)NT.createRoot=e.createRoot,NT.hydrateRoot=e.hydrateRoot;else {var t=e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;NT.createRoot=function(n,r){t.usingClientEntryPoint=true;try{return e.createRoot(n,r)}finally{t.usingClientEntryPoint=false;}},NT.hydrateRoot=function(n,r,i){t.usingClientEntryPoint=true;try{return e.hydrateRoot(n,r,i)}finally{t.usingClientEntryPoint=false;}};}return NT}var XT,eP={exports:{}};function tP(){return XT||(XT=1,function(e,t){e.exports=(()=>{var e={192:(e,t)=>{var n,r,i=function(){var e=function(e,t){var n=e,r=a[t],i=null,o=0,u=null,g=[],v={},y=function(e,t){i=function(e){for(var t=new Array(e),n=0;n<e;n+=1){t[n]=new Array(e);for(var r=0;r<e;r+=1)t[n][r]=null;}return t}(o=4*n+17),w(0,0),w(o-7,0),w(0,o-7),S(),_(),k(e,t),n>=7&&E(e),null==u&&(u=C(n,r,g)),M(u,t);},w=function(e,t){for(var n=-1;n<=7;n+=1)if(!(e+n<=-1||o<=e+n))for(var r=-1;r<=7;r+=1)t+r<=-1||o<=t+r||(i[e+n][t+r]=0<=n&&n<=6&&(0==r||6==r)||0<=r&&r<=6&&(0==n||6==n)||2<=n&&n<=4&&2<=r&&r<=4);},_=function(){for(var e=8;e<o-8;e+=1)null==i[e][6]&&(i[e][6]=e%2==0);for(var t=8;t<o-8;t+=1)null==i[6][t]&&(i[6][t]=t%2==0);},S=function(){for(var e=s.getPatternPosition(n),t=0;t<e.length;t+=1)for(var r=0;r<e.length;r+=1){var o=e[t],a=e[r];if(null==i[o][a])for(var u=-2;u<=2;u+=1)for(var l=-2;l<=2;l+=1)i[o+u][a+l]=-2==u||2==u||-2==l||2==l||0==u&&0==l;}},E=function(e){for(var t=s.getBCHTypeNumber(n),r=0;r<18;r+=1){var a=!e&&1==(t>>r&1);i[Math.floor(r/3)][r%3+o-8-3]=a;}for(r=0;r<18;r+=1)a=!e&&1==(t>>r&1),i[r%3+o-8-3][Math.floor(r/3)]=a;},k=function(e,t){for(var n=r<<3|t,a=s.getBCHTypeInfo(n),u=0;u<15;u+=1){var l=!e&&1==(a>>u&1);u<6?i[u][8]=l:u<8?i[u+1][8]=l:i[o-15+u][8]=l;}for(u=0;u<15;u+=1)l=!e&&1==(a>>u&1),u<8?i[8][o-u-1]=l:u<9?i[8][15-u-1+1]=l:i[8][15-u-1]=l;i[o-8][8]=!e;},M=function(e,t){for(var n=-1,r=o-1,a=7,u=0,l=s.getMaskFunction(t),c=o-1;c>0;c-=2)for(6==c&&(c-=1);;){for(var d=0;d<2;d+=1)if(null==i[r][c-d]){var f=false;u<e.length&&(f=1==(e[u]>>>a&1)),l(r,c-d)&&(f=!f),i[r][c-d]=f,-1==(a-=1)&&(u+=1,a=7);}if((r+=n)<0||o<=r){r-=n,n=-n;break}}},C=function(e,t,n){for(var r=c.getRSBlocks(e,t),i=d(),o=0;o<n.length;o+=1){var a=n[o];i.put(a.getMode(),4),i.put(a.getLength(),s.getLengthInBits(a.getMode(),e)),a.write(i);}var u=0;for(o=0;o<r.length;o+=1)u+=r[o].dataCount;if(i.getLengthInBits()>8*u)throw "code length overflow. ("+i.getLengthInBits()+">"+8*u+")";for(i.getLengthInBits()+4<=8*u&&i.put(0,4);i.getLengthInBits()%8!=0;)i.putBit(false);for(;!(i.getLengthInBits()>=8*u||(i.put(236,8),i.getLengthInBits()>=8*u));)i.put(17,8);return function(e,t){for(var n=0,r=0,i=0,o=new Array(t.length),a=new Array(t.length),u=0;u<t.length;u+=1){var c=t[u].dataCount,d=t[u].totalCount-c;r=Math.max(r,c),i=Math.max(i,d),o[u]=new Array(c);for(var f=0;f<o[u].length;f+=1)o[u][f]=255&e.getBuffer()[f+n];n+=c;var h=s.getErrorCorrectPolynomial(d),p=l(o[u],h.getLength()-1).mod(h);for(a[u]=new Array(h.getLength()-1),f=0;f<a[u].length;f+=1){var m=f+p.getLength()-a[u].length;a[u][f]=m>=0?p.getAt(m):0;}}var g=0;for(f=0;f<t.length;f+=1)g+=t[f].totalCount;var v=new Array(g),b=0;for(f=0;f<r;f+=1)for(u=0;u<t.length;u+=1)f<o[u].length&&(v[b]=o[u][f],b+=1);for(f=0;f<i;f+=1)for(u=0;u<t.length;u+=1)f<a[u].length&&(v[b]=a[u][f],b+=1);return v}(i,r)};v.addData=function(e,t){var n=null;switch(t=t||"Byte"){case "Numeric":n=f(e);break;case "Alphanumeric":n=h(e);break;case "Byte":n=p(e);break;case "Kanji":n=m(e);break;default:throw "mode:"+t}g.push(n),u=null;},v.isDark=function(e,t){if(e<0||o<=e||t<0||o<=t)throw e+","+t;return i[e][t]},v.getModuleCount=function(){return o},v.make=function(){if(n<1){for(var e=1;e<40;e++){for(var t=c.getRSBlocks(e,r),i=d(),o=0;o<g.length;o++){var a=g[o];i.put(a.getMode(),4),i.put(a.getLength(),s.getLengthInBits(a.getMode(),e)),a.write(i);}var u=0;for(o=0;o<t.length;o++)u+=t[o].dataCount;if(i.getLengthInBits()<=8*u)break}n=e;}y(false,function(){for(var e=0,t=0,n=0;n<8;n+=1){y(true,n);var r=s.getLostPoint(v);(0==n||e>r)&&(e=r,t=n);}return t}());},v.createTableTag=function(e,t){e=e||2;var n="";n+='<table style="',n+=" border-width: 0px; border-style: none;",n+=" border-collapse: collapse;",n+=" padding: 0px; margin: "+(t=void 0===t?4*e:t)+"px;",n+='">',n+="<tbody>";for(var r=0;r<v.getModuleCount();r+=1){n+="<tr>";for(var i=0;i<v.getModuleCount();i+=1)n+='<td style="',n+=" border-width: 0px; border-style: none;",n+=" border-collapse: collapse;",n+=" padding: 0px; margin: 0px;",n+=" width: "+e+"px;",n+=" height: "+e+"px;",n+=" background-color: ",n+=v.isDark(r,i)?"#000000":"#ffffff",n+=";",n+='"/>';n+="</tr>";}return (n+="</tbody>")+"</table>"},v.createSvgTag=function(e,t,n,r){var i={};"object"==typeof arguments[0]&&(e=(i=arguments[0]).cellSize,t=i.margin,n=i.alt,r=i.title),e=e||2,t=void 0===t?4*e:t,(n="string"==typeof n?{text:n}:n||{}).text=n.text||null,n.id=n.text?n.id||"qrcode-description":null,(r="string"==typeof r?{text:r}:r||{}).text=r.text||null,r.id=r.text?r.id||"qrcode-title":null;var o,a,s,u,l=v.getModuleCount()*e+2*t,c="";for(u="l"+e+",0 0,"+e+" -"+e+",0 0,-"+e+"z ",c+='<svg version="1.1" xmlns="http://www.w3.org/2000/svg"',c+=i.scalable?"":' width="'+l+'px" height="'+l+'px"',c+=' viewBox="0 0 '+l+" "+l+'" ',c+=' preserveAspectRatio="xMinYMin meet"',c+=r.text||n.text?' role="img" aria-labelledby="'+x([r.id,n.id].join(" ").trim())+'"':"",c+=">",c+=r.text?'<title id="'+x(r.id)+'">'+x(r.text)+"</title>":"",c+=n.text?'<description id="'+x(n.id)+'">'+x(n.text)+"</description>":"",c+='<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>',c+='<path d="',a=0;a<v.getModuleCount();a+=1)for(s=a*e+t,o=0;o<v.getModuleCount();o+=1)v.isDark(a,o)&&(c+="M"+(o*e+t)+","+s+u);return (c+='" stroke="transparent" fill="black"/>')+"</svg>"},v.createDataURL=function(e,t){e=e||2,t=void 0===t?4*e:t;var n=v.getModuleCount()*e+2*t,r=t,i=n-t;return b(n,n,(function(t,n){if(r<=t&&t<i&&r<=n&&n<i){var o=Math.floor((t-r)/e),a=Math.floor((n-r)/e);return v.isDark(a,o)?0:1}return 1}))},v.createImgTag=function(e,t,n){e=e||2,t=void 0===t?4*e:t;var r=v.getModuleCount()*e+2*t,i="";return i+="<img",i+=' src="',i+=v.createDataURL(e,t),i+='"',i+=' width="',i+=r,i+='"',i+=' height="',i+=r,i+='"',n&&(i+=' alt="',i+=x(n),i+='"'),i+"/>"};var x=function(e){for(var t="",n=0;n<e.length;n+=1){var r=e.charAt(n);switch(r){case "<":t+="&lt;";break;case ">":t+="&gt;";break;case "&":t+="&amp;";break;case '"':t+="&quot;";break;default:t+=r;}}return t};return v.createASCII=function(e,t){if((e=e||1)<2)return function(e){e=void 0===e?2:e;var t,n,r,i,o,a=1*v.getModuleCount()+2*e,s=e,u=a-e,l={"██":"█","█ ":"▀"," █":"▄","  ":" "},c={"██":"▀","█ ":"▀"," █":" ","  ":" "},d="";for(t=0;t<a;t+=2){for(r=Math.floor((t-s)/1),i=Math.floor((t+1-s)/1),n=0;n<a;n+=1)o="█",s<=n&&n<u&&s<=t&&t<u&&v.isDark(r,Math.floor((n-s)/1))&&(o=" "),s<=n&&n<u&&s<=t+1&&t+1<u&&v.isDark(i,Math.floor((n-s)/1))?o+=" ":o+="█",d+=e<1&&t+1>=u?c[o]:l[o];d+="\n";}return a%2&&e>0?d.substring(0,d.length-a-1)+Array(a+1).join("▀"):d.substring(0,d.length-1)}(t);e-=1,t=void 0===t?2*e:t;var n,r,i,o,a=v.getModuleCount()*e+2*t,s=t,u=a-t,l=Array(e+1).join("██"),c=Array(e+1).join("  "),d="",f="";for(n=0;n<a;n+=1){for(i=Math.floor((n-s)/e),f="",r=0;r<a;r+=1)o=1,s<=r&&r<u&&s<=n&&n<u&&v.isDark(i,Math.floor((r-s)/e))&&(o=0),f+=o?l:c;for(i=0;i<e;i+=1)d+=f+"\n";}return d.substring(0,d.length-1)},v.renderTo2dContext=function(e,t){t=t||2;for(var n=v.getModuleCount(),r=0;r<n;r++)for(var i=0;i<n;i++)e.fillStyle=v.isDark(r,i)?"black":"white",e.fillRect(r*t,i*t,t,t);},v};e.stringToBytes=(e.stringToBytesFuncs={default:function(e){for(var t=[],n=0;n<e.length;n+=1){var r=e.charCodeAt(n);t.push(255&r);}return t}}).default,e.createStringToBytes=function(e,t){var n=function(){for(var n=v(e),r=function(){var e=n.read();if(-1==e)throw "eof";return e},i=0,o={};;){var a=n.read();if(-1==a)break;var s=r(),u=r()<<8|r();o[String.fromCharCode(a<<8|s)]=u,i+=1;}if(i!=t)throw i+" != "+t;return o}(),r="?".charCodeAt(0);return function(e){for(var t=[],i=0;i<e.length;i+=1){var o=e.charCodeAt(i);if(o<128)t.push(o);else {var a=n[e.charAt(i)];"number"==typeof a?(255&a)==a?t.push(a):(t.push(a>>>8),t.push(255&a)):t.push(r);}}return t}};var t,n,r,i,o,a={L:1,M:0,Q:3,H:2},s=(t=[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],n=1335,r=7973,o=function(e){for(var t=0;0!=e;)t+=1,e>>>=1;return t},(i={}).getBCHTypeInfo=function(e){for(var t=e<<10;o(t)-o(n)>=0;)t^=n<<o(t)-o(n);return 21522^(e<<10|t)},i.getBCHTypeNumber=function(e){for(var t=e<<12;o(t)-o(r)>=0;)t^=r<<o(t)-o(r);return e<<12|t},i.getPatternPosition=function(e){return t[e-1]},i.getMaskFunction=function(e){switch(e){case 0:return function(e,t){return (e+t)%2==0};case 1:return function(e,t){return e%2==0};case 2:return function(e,t){return t%3==0};case 3:return function(e,t){return (e+t)%3==0};case 4:return function(e,t){return (Math.floor(e/2)+Math.floor(t/3))%2==0};case 5:return function(e,t){return e*t%2+e*t%3==0};case 6:return function(e,t){return (e*t%2+e*t%3)%2==0};case 7:return function(e,t){return (e*t%3+(e+t)%2)%2==0};default:throw "bad maskPattern:"+e}},i.getErrorCorrectPolynomial=function(e){for(var t=l([1],0),n=0;n<e;n+=1)t=t.multiply(l([1,u.gexp(n)],0));return t},i.getLengthInBits=function(e,t){if(1<=t&&t<10)switch(e){case 1:return 10;case 2:return 9;case 4:case 8:return 8;default:throw "mode:"+e}else if(t<27)switch(e){case 1:return 12;case 2:return 11;case 4:return 16;case 8:return 10;default:throw "mode:"+e}else {if(!(t<41))throw "type:"+t;switch(e){case 1:return 14;case 2:return 13;case 4:return 16;case 8:return 12;default:throw "mode:"+e}}},i.getLostPoint=function(e){for(var t=e.getModuleCount(),n=0,r=0;r<t;r+=1)for(var i=0;i<t;i+=1){for(var o=0,a=e.isDark(r,i),s=-1;s<=1;s+=1)if(!(r+s<0||t<=r+s))for(var u=-1;u<=1;u+=1)i+u<0||t<=i+u||0==s&&0==u||a==e.isDark(r+s,i+u)&&(o+=1);o>5&&(n+=3+o-5);}for(r=0;r<t-1;r+=1)for(i=0;i<t-1;i+=1){var l=0;e.isDark(r,i)&&(l+=1),e.isDark(r+1,i)&&(l+=1),e.isDark(r,i+1)&&(l+=1),e.isDark(r+1,i+1)&&(l+=1),0!=l&&4!=l||(n+=3);}for(r=0;r<t;r+=1)for(i=0;i<t-6;i+=1)e.isDark(r,i)&&!e.isDark(r,i+1)&&e.isDark(r,i+2)&&e.isDark(r,i+3)&&e.isDark(r,i+4)&&!e.isDark(r,i+5)&&e.isDark(r,i+6)&&(n+=40);for(i=0;i<t;i+=1)for(r=0;r<t-6;r+=1)e.isDark(r,i)&&!e.isDark(r+1,i)&&e.isDark(r+2,i)&&e.isDark(r+3,i)&&e.isDark(r+4,i)&&!e.isDark(r+5,i)&&e.isDark(r+6,i)&&(n+=40);var c=0;for(i=0;i<t;i+=1)for(r=0;r<t;r+=1)e.isDark(r,i)&&(c+=1);return n+Math.abs(100*c/t/t-50)/5*10},i),u=function(){for(var e=new Array(256),t=new Array(256),n=0;n<8;n+=1)e[n]=1<<n;for(n=8;n<256;n+=1)e[n]=e[n-4]^e[n-5]^e[n-6]^e[n-8];for(n=0;n<255;n+=1)t[e[n]]=n;return {glog:function(e){if(e<1)throw "glog("+e+")";return t[e]},gexp:function(t){for(;t<0;)t+=255;for(;t>=256;)t-=255;return e[t]}}}();function l(e,t){if(void 0===e.length)throw e.length+"/"+t;var n=function(){for(var n=0;n<e.length&&0==e[n];)n+=1;for(var r=new Array(e.length-n+t),i=0;i<e.length-n;i+=1)r[i]=e[i+n];return r}(),r={getAt:function(e){return n[e]},getLength:function(){return n.length},multiply:function(e){for(var t=new Array(r.getLength()+e.getLength()-1),n=0;n<r.getLength();n+=1)for(var i=0;i<e.getLength();i+=1)t[n+i]^=u.gexp(u.glog(r.getAt(n))+u.glog(e.getAt(i)));return l(t,0)},mod:function(e){if(r.getLength()-e.getLength()<0)return r;for(var t=u.glog(r.getAt(0))-u.glog(e.getAt(0)),n=new Array(r.getLength()),i=0;i<r.getLength();i+=1)n[i]=r.getAt(i);for(i=0;i<e.getLength();i+=1)n[i]^=u.gexp(u.glog(e.getAt(i))+t);return l(n,0).mod(e)}};return r}var c=function(){var e=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12,7,37,13],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]],t=function(e,t){var n={};return n.totalCount=e,n.dataCount=t,n},n={getRSBlocks:function(n,r){var i=function(t,n){switch(n){case a.L:return e[4*(t-1)+0];case a.M:return e[4*(t-1)+1];case a.Q:return e[4*(t-1)+2];case a.H:return e[4*(t-1)+3];default:return}}(n,r);if(void 0===i)throw "bad rs block @ typeNumber:"+n+"/errorCorrectionLevel:"+r;for(var o=i.length/3,s=[],u=0;u<o;u+=1)for(var l=i[3*u+0],c=i[3*u+1],d=i[3*u+2],f=0;f<l;f+=1)s.push(t(c,d));return s}};return n}(),d=function(){var e=[],t=0,n={getBuffer:function(){return e},getAt:function(t){var n=Math.floor(t/8);return 1==(e[n]>>>7-t%8&1)},put:function(e,t){for(var r=0;r<t;r+=1)n.putBit(1==(e>>>t-r-1&1));},getLengthInBits:function(){return t},putBit:function(n){var r=Math.floor(t/8);e.length<=r&&e.push(0),n&&(e[r]|=128>>>t%8),t+=1;}};return n},f=function(e){var t=e,n={getMode:function(){return 1},getLength:function(e){return t.length},write:function(e){for(var n=t,i=0;i+2<n.length;)e.put(r(n.substring(i,i+3)),10),i+=3;i<n.length&&(n.length-i==1?e.put(r(n.substring(i,i+1)),4):n.length-i==2&&e.put(r(n.substring(i,i+2)),7));}},r=function(e){for(var t=0,n=0;n<e.length;n+=1)t=10*t+i(e.charAt(n));return t},i=function(e){if("0"<=e&&e<="9")return e.charCodeAt(0)-"0".charCodeAt(0);throw "illegal char :"+e};return n},h=function(e){var t=e,n={getMode:function(){return 2},getLength:function(e){return t.length},write:function(e){for(var n=t,i=0;i+1<n.length;)e.put(45*r(n.charAt(i))+r(n.charAt(i+1)),11),i+=2;i<n.length&&e.put(r(n.charAt(i)),6);}},r=function(e){if("0"<=e&&e<="9")return e.charCodeAt(0)-"0".charCodeAt(0);if("A"<=e&&e<="Z")return e.charCodeAt(0)-"A".charCodeAt(0)+10;switch(e){case " ":return 36;case "$":return 37;case "%":return 38;case "*":return 39;case "+":return 40;case "-":return 41;case ".":return 42;case "/":return 43;case ":":return 44;default:throw "illegal char :"+e}};return n},p=function(t){var n=e.stringToBytes(t);return {getMode:function(){return 4},getLength:function(e){return n.length},write:function(e){for(var t=0;t<n.length;t+=1)e.put(n[t],8);}}},m=function(t){var n=e.stringToBytesFuncs.SJIS;if(!n)throw "sjis not supported.";!function(e,t){var r=n("友");if(2!=r.length||38726!=(r[0]<<8|r[1]))throw "sjis not supported."}();var r=n(t);return {getMode:function(){return 8},getLength:function(e){return ~~(r.length/2)},write:function(e){for(var t=r,n=0;n+1<t.length;){var i=(255&t[n])<<8|255&t[n+1];if(33088<=i&&i<=40956)i-=33088;else {if(!(57408<=i&&i<=60351))throw "illegal char at "+(n+1)+"/"+i;i-=49472;}i=192*(i>>>8&255)+(255&i),e.put(i,13),n+=2;}if(n<t.length)throw "illegal char at "+(n+1)}}},g=function(){var e=[],t={writeByte:function(t){e.push(255&t);},writeShort:function(e){t.writeByte(e),t.writeByte(e>>>8);},writeBytes:function(e,n,r){n=n||0,r=r||e.length;for(var i=0;i<r;i+=1)t.writeByte(e[i+n]);},writeString:function(e){for(var n=0;n<e.length;n+=1)t.writeByte(e.charCodeAt(n));},toByteArray:function(){return e},toString:function(){var t="";t+="[";for(var n=0;n<e.length;n+=1)n>0&&(t+=","),t+=e[n];return t+"]"}};return t},v=function(e){var t=e,n=0,r=0,i=0,o={read:function(){for(;i<8;){if(n>=t.length){if(0==i)return  -1;throw "unexpected end of file./"+i}var e=t.charAt(n);if(n+=1,"="==e)return i=0,-1;e.match(/^\s$/)||(r=r<<6|a(e.charCodeAt(0)),i+=6);}var o=r>>>i-8&255;return i-=8,o}},a=function(e){if(65<=e&&e<=90)return e-65;if(97<=e&&e<=122)return e-97+26;if(48<=e&&e<=57)return e-48+52;if(43==e)return 62;if(47==e)return 63;throw "c:"+e};return o},b=function(e,t,n){for(var r=function(e,t){var n=e,r=t,i=new Array(e*t),o={setPixel:function(e,t,r){i[t*n+e]=r;},write:function(e){e.writeString("GIF87a"),e.writeShort(n),e.writeShort(r),e.writeByte(128),e.writeByte(0),e.writeByte(0),e.writeByte(0),e.writeByte(0),e.writeByte(0),e.writeByte(255),e.writeByte(255),e.writeByte(255),e.writeString(","),e.writeShort(0),e.writeShort(0),e.writeShort(n),e.writeShort(r),e.writeByte(0);var t=a(2);e.writeByte(2);for(var i=0;t.length-i>255;)e.writeByte(255),e.writeBytes(t,i,255),i+=255;e.writeByte(t.length-i),e.writeBytes(t,i,t.length-i),e.writeByte(0),e.writeString(";");}},a=function(e){for(var t=1<<e,n=1+(1<<e),r=e+1,o=s(),a=0;a<t;a+=1)o.add(String.fromCharCode(a));o.add(String.fromCharCode(t)),o.add(String.fromCharCode(n));var u,l,c,d=g(),f=(u=d,l=0,c=0,{write:function(e,t){if(e>>>t!=0)throw "length over";for(;l+t>=8;)u.writeByte(255&(e<<l|c)),t-=8-l,e>>>=8-l,c=0,l=0;c|=e<<l,l+=t;},flush:function(){l>0&&u.writeByte(c);}});f.write(t,r);var h=0,p=String.fromCharCode(i[h]);for(h+=1;h<i.length;){var m=String.fromCharCode(i[h]);h+=1,o.contains(p+m)?p+=m:(f.write(o.indexOf(p),r),o.size()<4095&&(o.size()==1<<r&&(r+=1),o.add(p+m)),p=m);}return f.write(o.indexOf(p),r),f.write(n,r),f.flush(),d.toByteArray()},s=function(){var e={},t=0,n={add:function(r){if(n.contains(r))throw "dup key:"+r;e[r]=t,t+=1;},size:function(){return t},indexOf:function(t){return e[t]},contains:function(t){return void 0!==e[t]}};return n};return o}(e,t),i=0;i<t;i+=1)for(var o=0;o<e;o+=1)r.setPixel(o,i,n(o,i));var a=g();r.write(a);for(var s=function(){var e=0,t=0,n=0,r="",i={},o=function(e){r+=String.fromCharCode(a(63&e));},a=function(e){if(e<0);else {if(e<26)return 65+e;if(e<52)return e-26+97;if(e<62)return e-52+48;if(62==e)return 43;if(63==e)return 47}throw "n:"+e};return i.writeByte=function(r){for(e=e<<8|255&r,t+=8,n+=1;t>=6;)o(e>>>t-6),t-=6;},i.flush=function(){if(t>0&&(o(e<<6-t),e=0,t=0),n%3!=0)for(var i=3-n%3,a=0;a<i;a+=1)r+="=";},i.toString=function(){return r},i}(),u=a.toByteArray(),l=0;l<u.length;l+=1)s.writeByte(u[l]);return s.flush(),"data:image/gif;base64,"+s};return e}();i.stringToBytesFuncs["UTF-8"]=function(e){return function(e){for(var t=[],n=0;n<e.length;n++){var r=e.charCodeAt(n);r<128?t.push(r):r<2048?t.push(192|r>>6,128|63&r):r<55296||r>=57344?t.push(224|r>>12,128|r>>6&63,128|63&r):(n++,r=65536+((1023&r)<<10|1023&e.charCodeAt(n)),t.push(240|r>>18,128|r>>12&63,128|r>>6&63,128|63&r));}return t}(e)},void 0===(r="function"==typeof(n=function(){return i})?n.apply(t,[]):n)||(e.exports=r);},676:(e,t,n)=>{n.d(t,{default:()=>I});var r=function(){return (r=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e}).apply(this,arguments)},i=function(){for(var e=0,t=0,n=arguments.length;t<n;t++)e+=arguments[t].length;var r=Array(e),i=0;for(t=0;t<n;t++)for(var o=arguments[t],a=0,s=o.length;a<s;a++,i++)r[i]=o[a];return r},o=function(e){return !!e&&"object"==typeof e&&!Array.isArray(e)};function a(e){for(var t=[],n=1;n<arguments.length;n++)t[n-1]=arguments[n];if(!t.length)return e;var s=t.shift();return void 0!==s&&o(e)&&o(s)?(e=r({},e),Object.keys(s).forEach((function(t){var n=e[t],r=s[t];Array.isArray(n)&&Array.isArray(r)?e[t]=r:o(n)&&o(r)?e[t]=a(Object.assign({},n),r):e[t]=r;})),a.apply(void 0,i([e],t))):e}function s(e,t){var n=document.createElement("a");n.download=t,n.href=e,document.body.appendChild(n),n.click(),document.body.removeChild(n);}function u(e){return t=this,n=void 0,i=function(){return function(e,t){var n,r,i,o,a={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function s(o){return function(s){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return a.label++,{value:o[1],done:!1};case 5:a.label++,r=o[1],o=[0];continue;case 7:o=a.ops.pop(),a.trys.pop();continue;default:if(!((i=(i=a.trys).length>0&&i[i.length-1])||6!==o[0]&&2!==o[0])){a=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){a.label=o[1];break}if(6===o[0]&&a.label<i[1]){a.label=i[1],i=o;break}if(i&&a.label<i[2]){a.label=i[2],a.ops.push(o);break}i[2]&&a.ops.pop(),a.trys.pop();continue}o=t.call(e,a);}catch(e){o=[6,e],r=0;}finally{n=i=0;}if(5&o[0])throw o[1];return {value:o[0]?o[1]:void 0,done:true}}([o,s])}}}(this,(function(t){return [2,new Promise((function(t){var n=new XMLHttpRequest;n.onload=function(){var e=new FileReader;e.onloadend=function(){t(e.result);},e.readAsDataURL(n.response);},n.open("GET",e),n.responseType="blob",n.send();}))]}))},new((r=void 0)||(r=Promise))((function(e,o){function a(e){try{u(i.next(e));}catch(e){o(e);}}function s(e){try{u(i.throw(e));}catch(e){o(e);}}function u(t){var n;t.done?e(t.value):(n=t.value,n instanceof r?n:new r((function(e){e(n);}))).then(a,s);}u((i=i.apply(t,n||[])).next());}));var t,n,r,i;}const l={L:.07,M:.15,Q:.25,H:.3};var c=function(){return (c=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e}).apply(this,arguments)};const d=function(){function e(e){var t=e.svg,n=e.type;this._svg=t,this._type=n;}return e.prototype.draw=function(e,t,n,r){var i;switch(this._type){case "dots":i=this._drawDot;break;case "classy":i=this._drawClassy;break;case "classy-rounded":i=this._drawClassyRounded;break;case "rounded":i=this._drawRounded;break;case "extra-rounded":i=this._drawExtraRounded;break;default:i=this._drawSquare;}i.call(this,{x:e,y:t,size:n,getNeighbor:r});},e.prototype._rotateFigure=function(e){var t,n=e.x,r=e.y,i=e.size,o=e.rotation,a=void 0===o?0:o,s=n+i/2,u=r+i/2;(0, e.draw)(),null===(t=this._element)||void 0===t||t.setAttribute("transform","rotate("+180*a/Math.PI+","+s+","+u+")");},e.prototype._basicDot=function(e){var t=this,n=e.size,r=e.x,i=e.y;this._rotateFigure(c(c({},e),{draw:function(){t._element=document.createElementNS("http://www.w3.org/2000/svg","circle"),t._element.setAttribute("cx",String(r+n/2)),t._element.setAttribute("cy",String(i+n/2)),t._element.setAttribute("r",String(n/2));}}));},e.prototype._basicSquare=function(e){var t=this,n=e.size,r=e.x,i=e.y;this._rotateFigure(c(c({},e),{draw:function(){t._element=document.createElementNS("http://www.w3.org/2000/svg","rect"),t._element.setAttribute("x",String(r)),t._element.setAttribute("y",String(i)),t._element.setAttribute("width",String(n)),t._element.setAttribute("height",String(n));}}));},e.prototype._basicSideRounded=function(e){var t=this,n=e.size,r=e.x,i=e.y;this._rotateFigure(c(c({},e),{draw:function(){t._element=document.createElementNS("http://www.w3.org/2000/svg","path"),t._element.setAttribute("d","M "+r+" "+i+"v "+n+"h "+n/2+"a "+n/2+" "+n/2+", 0, 0, 0, 0 "+-n);}}));},e.prototype._basicCornerRounded=function(e){var t=this,n=e.size,r=e.x,i=e.y;this._rotateFigure(c(c({},e),{draw:function(){t._element=document.createElementNS("http://www.w3.org/2000/svg","path"),t._element.setAttribute("d","M "+r+" "+i+"v "+n+"h "+n+"v "+-n/2+"a "+n/2+" "+n/2+", 0, 0, 0, "+-n/2+" "+-n/2);}}));},e.prototype._basicCornerExtraRounded=function(e){var t=this,n=e.size,r=e.x,i=e.y;this._rotateFigure(c(c({},e),{draw:function(){t._element=document.createElementNS("http://www.w3.org/2000/svg","path"),t._element.setAttribute("d","M "+r+" "+i+"v "+n+"h "+n+"a "+n+" "+n+", 0, 0, 0, "+-n+" "+-n);}}));},e.prototype._basicCornersRounded=function(e){var t=this,n=e.size,r=e.x,i=e.y;this._rotateFigure(c(c({},e),{draw:function(){t._element=document.createElementNS("http://www.w3.org/2000/svg","path"),t._element.setAttribute("d","M "+r+" "+i+"v "+n/2+"a "+n/2+" "+n/2+", 0, 0, 0, "+n/2+" "+n/2+"h "+n/2+"v "+-n/2+"a "+n/2+" "+n/2+", 0, 0, 0, "+-n/2+" "+-n/2);}}));},e.prototype._drawDot=function(e){var t=e.x,n=e.y,r=e.size;this._basicDot({x:t,y:n,size:r,rotation:0});},e.prototype._drawSquare=function(e){var t=e.x,n=e.y,r=e.size;this._basicSquare({x:t,y:n,size:r,rotation:0});},e.prototype._drawRounded=function(e){var t=e.x,n=e.y,r=e.size,i=e.getNeighbor,o=i?+i(-1,0):0,a=i?+i(1,0):0,s=i?+i(0,-1):0,u=i?+i(0,1):0,l=o+a+s+u;if(0!==l)if(l>2||o&&a||s&&u)this._basicSquare({x:t,y:n,size:r,rotation:0});else {if(2===l){var c=0;return o&&s?c=Math.PI/2:s&&a?c=Math.PI:a&&u&&(c=-Math.PI/2),void this._basicCornerRounded({x:t,y:n,size:r,rotation:c})}if(1===l)return c=0,s?c=Math.PI/2:a?c=Math.PI:u&&(c=-Math.PI/2),void this._basicSideRounded({x:t,y:n,size:r,rotation:c})}else this._basicDot({x:t,y:n,size:r,rotation:0});},e.prototype._drawExtraRounded=function(e){var t=e.x,n=e.y,r=e.size,i=e.getNeighbor,o=i?+i(-1,0):0,a=i?+i(1,0):0,s=i?+i(0,-1):0,u=i?+i(0,1):0,l=o+a+s+u;if(0!==l)if(l>2||o&&a||s&&u)this._basicSquare({x:t,y:n,size:r,rotation:0});else {if(2===l){var c=0;return o&&s?c=Math.PI/2:s&&a?c=Math.PI:a&&u&&(c=-Math.PI/2),void this._basicCornerExtraRounded({x:t,y:n,size:r,rotation:c})}if(1===l)return c=0,s?c=Math.PI/2:a?c=Math.PI:u&&(c=-Math.PI/2),void this._basicSideRounded({x:t,y:n,size:r,rotation:c})}else this._basicDot({x:t,y:n,size:r,rotation:0});},e.prototype._drawClassy=function(e){var t=e.x,n=e.y,r=e.size,i=e.getNeighbor,o=i?+i(-1,0):0,a=i?+i(1,0):0,s=i?+i(0,-1):0,u=i?+i(0,1):0;0!==o+a+s+u?o||s?a||u?this._basicSquare({x:t,y:n,size:r,rotation:0}):this._basicCornerRounded({x:t,y:n,size:r,rotation:Math.PI/2}):this._basicCornerRounded({x:t,y:n,size:r,rotation:-Math.PI/2}):this._basicCornersRounded({x:t,y:n,size:r,rotation:Math.PI/2});},e.prototype._drawClassyRounded=function(e){var t=e.x,n=e.y,r=e.size,i=e.getNeighbor,o=i?+i(-1,0):0,a=i?+i(1,0):0,s=i?+i(0,-1):0,u=i?+i(0,1):0;0!==o+a+s+u?o||s?a||u?this._basicSquare({x:t,y:n,size:r,rotation:0}):this._basicCornerExtraRounded({x:t,y:n,size:r,rotation:Math.PI/2}):this._basicCornerExtraRounded({x:t,y:n,size:r,rotation:-Math.PI/2}):this._basicCornersRounded({x:t,y:n,size:r,rotation:Math.PI/2});},e}();var f=function(){return (f=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e}).apply(this,arguments)};const h=function(){function e(e){var t=e.svg,n=e.type;this._svg=t,this._type=n;}return e.prototype.draw=function(e,t,n,r){var i;switch(this._type){case "square":i=this._drawSquare;break;case "extra-rounded":i=this._drawExtraRounded;break;default:i=this._drawDot;}i.call(this,{x:e,y:t,size:n,rotation:r});},e.prototype._rotateFigure=function(e){var t,n=e.x,r=e.y,i=e.size,o=e.rotation,a=void 0===o?0:o,s=n+i/2,u=r+i/2;(0, e.draw)(),null===(t=this._element)||void 0===t||t.setAttribute("transform","rotate("+180*a/Math.PI+","+s+","+u+")");},e.prototype._basicDot=function(e){var t=this,n=e.size,r=e.x,i=e.y,o=n/7;this._rotateFigure(f(f({},e),{draw:function(){t._element=document.createElementNS("http://www.w3.org/2000/svg","path"),t._element.setAttribute("clip-rule","evenodd"),t._element.setAttribute("d","M "+(r+n/2)+" "+i+"a "+n/2+" "+n/2+" 0 1 0 0.1 0zm 0 "+o+"a "+(n/2-o)+" "+(n/2-o)+" 0 1 1 -0.1 0Z");}}));},e.prototype._basicSquare=function(e){var t=this,n=e.size,r=e.x,i=e.y,o=n/7;this._rotateFigure(f(f({},e),{draw:function(){t._element=document.createElementNS("http://www.w3.org/2000/svg","path"),t._element.setAttribute("clip-rule","evenodd"),t._element.setAttribute("d","M "+r+" "+i+"v "+n+"h "+n+"v "+-n+"zM "+(r+o)+" "+(i+o)+"h "+(n-2*o)+"v "+(n-2*o)+"h "+(2*o-n)+"z");}}));},e.prototype._basicExtraRounded=function(e){var t=this,n=e.size,r=e.x,i=e.y,o=n/7;this._rotateFigure(f(f({},e),{draw:function(){t._element=document.createElementNS("http://www.w3.org/2000/svg","path"),t._element.setAttribute("clip-rule","evenodd"),t._element.setAttribute("d","M "+r+" "+(i+2.5*o)+"v "+2*o+"a "+2.5*o+" "+2.5*o+", 0, 0, 0, "+2.5*o+" "+2.5*o+"h "+2*o+"a "+2.5*o+" "+2.5*o+", 0, 0, 0, "+2.5*o+" "+2.5*-o+"v "+-2*o+"a "+2.5*o+" "+2.5*o+", 0, 0, 0, "+2.5*-o+" "+2.5*-o+"h "+-2*o+"a "+2.5*o+" "+2.5*o+", 0, 0, 0, "+2.5*-o+" "+2.5*o+"M "+(r+2.5*o)+" "+(i+o)+"h "+2*o+"a "+1.5*o+" "+1.5*o+", 0, 0, 1, "+1.5*o+" "+1.5*o+"v "+2*o+"a "+1.5*o+" "+1.5*o+", 0, 0, 1, "+1.5*-o+" "+1.5*o+"h "+-2*o+"a "+1.5*o+" "+1.5*o+", 0, 0, 1, "+1.5*-o+" "+1.5*-o+"v "+-2*o+"a "+1.5*o+" "+1.5*o+", 0, 0, 1, "+1.5*o+" "+1.5*-o);}}));},e.prototype._drawDot=function(e){var t=e.x,n=e.y,r=e.size,i=e.rotation;this._basicDot({x:t,y:n,size:r,rotation:i});},e.prototype._drawSquare=function(e){var t=e.x,n=e.y,r=e.size,i=e.rotation;this._basicSquare({x:t,y:n,size:r,rotation:i});},e.prototype._drawExtraRounded=function(e){var t=e.x,n=e.y,r=e.size,i=e.rotation;this._basicExtraRounded({x:t,y:n,size:r,rotation:i});},e}();var p=function(){return (p=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e}).apply(this,arguments)};const m=function(){function e(e){var t=e.svg,n=e.type;this._svg=t,this._type=n;}return e.prototype.draw=function(e,t,n,r){("square"===this._type?this._drawSquare:this._drawDot).call(this,{x:e,y:t,size:n,rotation:r});},e.prototype._rotateFigure=function(e){var t,n=e.x,r=e.y,i=e.size,o=e.rotation,a=void 0===o?0:o,s=n+i/2,u=r+i/2;(0, e.draw)(),null===(t=this._element)||void 0===t||t.setAttribute("transform","rotate("+180*a/Math.PI+","+s+","+u+")");},e.prototype._basicDot=function(e){var t=this,n=e.size,r=e.x,i=e.y;this._rotateFigure(p(p({},e),{draw:function(){t._element=document.createElementNS("http://www.w3.org/2000/svg","circle"),t._element.setAttribute("cx",String(r+n/2)),t._element.setAttribute("cy",String(i+n/2)),t._element.setAttribute("r",String(n/2));}}));},e.prototype._basicSquare=function(e){var t=this,n=e.size,r=e.x,i=e.y;this._rotateFigure(p(p({},e),{draw:function(){t._element=document.createElementNS("http://www.w3.org/2000/svg","rect"),t._element.setAttribute("x",String(r)),t._element.setAttribute("y",String(i)),t._element.setAttribute("width",String(n)),t._element.setAttribute("height",String(n));}}));},e.prototype._drawDot=function(e){var t=e.x,n=e.y,r=e.size,i=e.rotation;this._basicDot({x:t,y:n,size:r,rotation:i});},e.prototype._drawSquare=function(e){var t=e.x,n=e.y,r=e.size,i=e.rotation;this._basicSquare({x:t,y:n,size:r,rotation:i});},e}(),g="circle";var v=function(e,t,n,r){return new(n||(n=Promise))((function(i,o){function a(e){try{u(r.next(e));}catch(e){o(e);}}function s(e){try{u(r.throw(e));}catch(e){o(e);}}function u(e){var t;e.done?i(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t);}))).then(a,s);}u((r=r.apply(e,[])).next());}))},b=function(e,t){var n,r,i,o,a={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function s(o){return function(s){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return a.label++,{value:o[1],done:!1};case 5:a.label++,r=o[1],o=[0];continue;case 7:o=a.ops.pop(),a.trys.pop();continue;default:if(!((i=(i=a.trys).length>0&&i[i.length-1])||6!==o[0]&&2!==o[0])){a=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){a.label=o[1];break}if(6===o[0]&&a.label<i[1]){a.label=i[1],i=o;break}if(i&&a.label<i[2]){a.label=i[2],a.ops.push(o);break}i[2]&&a.ops.pop(),a.trys.pop();continue}o=t.call(e,a);}catch(e){o=[6,e],r=0;}finally{n=i=0;}if(5&o[0])throw o[1];return {value:o[0]?o[1]:void 0,done:true}}([o,s])}}},y=[[1,1,1,1,1,1,1],[1,0,0,0,0,0,1],[1,0,0,0,0,0,1],[1,0,0,0,0,0,1],[1,0,0,0,0,0,1],[1,0,0,0,0,0,1],[1,1,1,1,1,1,1]],w=[[0,0,0,0,0,0,0],[0,0,0,0,0,0,0],[0,0,1,1,1,0,0],[0,0,1,1,1,0,0],[0,0,1,1,1,0,0],[0,0,0,0,0,0,0],[0,0,0,0,0,0,0]];const _=function(){function e(e){this._element=document.createElementNS("http://www.w3.org/2000/svg","svg"),this._element.setAttribute("width",String(e.width)),this._element.setAttribute("height",String(e.height)),this._defs=document.createElementNS("http://www.w3.org/2000/svg","defs"),this._element.appendChild(this._defs),this._options=e;}return Object.defineProperty(e.prototype,"width",{get:function(){return this._options.width},enumerable:false,configurable:true}),Object.defineProperty(e.prototype,"height",{get:function(){return this._options.height},enumerable:false,configurable:true}),e.prototype.getElement=function(){return this._element},e.prototype.drawQR=function(e){return v(this,void 0,void 0,(function(){var t,n,r,i,o,a,s,u,c,d,f=this;return b(this,(function(h){switch(h.label){case 0:return t=e.getModuleCount(),n=Math.min(this._options.width,this._options.height)-2*this._options.margin,r=this._options.shape===g?n/Math.sqrt(2):n,i=Math.floor(r/t),o={hideXDots:0,hideYDots:0,width:0,height:0},this._qr=e,this._options.image?[4,this.loadImage()]:[3,2];case 1:if(h.sent(),!this._image)return [2];a=this._options,s=a.imageOptions,u=a.qrOptions,c=s.imageSize*l[u.errorCorrectionLevel],d=Math.floor(c*t*t),o=function(e){var t=e.originalHeight,n=e.originalWidth,r=e.maxHiddenDots,i=e.maxHiddenAxisDots,o=e.dotSize,a={x:0,y:0},s={x:0,y:0};if(t<=0||n<=0||r<=0||o<=0)return {height:0,width:0,hideYDots:0,hideXDots:0};var u=t/n;return a.x=Math.floor(Math.sqrt(r/u)),a.x<=0&&(a.x=1),i&&i<a.x&&(a.x=i),a.x%2==0&&a.x--,s.x=a.x*o,a.y=1+2*Math.ceil((a.x*u-1)/2),s.y=Math.round(s.x*u),(a.y*a.x>r||i&&i<a.y)&&(i&&i<a.y?(a.y=i,a.y%2==0&&a.x--):a.y-=2,s.y=a.y*o,a.x=1+2*Math.ceil((a.y/u-1)/2),s.x=Math.round(s.y/u)),{height:s.y,width:s.x,hideYDots:a.y,hideXDots:a.x}}({originalWidth:this._image.width,originalHeight:this._image.height,maxHiddenDots:d,maxHiddenAxisDots:t-14,dotSize:i}),h.label=2;case 2:return this.drawBackground(),this.drawDots((function(e,n){var r,i,a,s,u,l;return !(f._options.imageOptions.hideBackgroundDots&&e>=(t-o.hideXDots)/2&&e<(t+o.hideXDots)/2&&n>=(t-o.hideYDots)/2&&n<(t+o.hideYDots)/2||(null===(r=y[e])||void 0===r?void 0:r[n])||(null===(i=y[e-t+7])||void 0===i?void 0:i[n])||(null===(a=y[e])||void 0===a?void 0:a[n-t+7])||(null===(s=w[e])||void 0===s?void 0:s[n])||(null===(u=w[e-t+7])||void 0===u?void 0:u[n])||(null===(l=w[e])||void 0===l?void 0:l[n-t+7]))})),this.drawCorners(),this._options.image?[4,this.drawImage({width:o.width,height:o.height,count:t,dotSize:i})]:[3,4];case 3:h.sent(),h.label=4;case 4:return [2]}}))}))},e.prototype.drawBackground=function(){var e,t,n,r=this._element,i=this._options;if(r){var o=null===(e=i.backgroundOptions)||void 0===e?void 0:e.gradient,a=null===(t=i.backgroundOptions)||void 0===t?void 0:t.color;if((o||a)&&this._createColor({options:o,color:a,additionalRotation:0,x:0,y:0,height:i.height,width:i.width,name:"background-color"}),null===(n=i.backgroundOptions)||void 0===n?void 0:n.round){var s=Math.min(i.width,i.height),u=document.createElementNS("http://www.w3.org/2000/svg","rect");this._backgroundClipPath=document.createElementNS("http://www.w3.org/2000/svg","clipPath"),this._backgroundClipPath.setAttribute("id","clip-path-background-color"),this._defs.appendChild(this._backgroundClipPath),u.setAttribute("x",String((i.width-s)/2)),u.setAttribute("y",String((i.height-s)/2)),u.setAttribute("width",String(s)),u.setAttribute("height",String(s)),u.setAttribute("rx",String(s/2*i.backgroundOptions.round)),this._backgroundClipPath.appendChild(u);}}},e.prototype.drawDots=function(e){var t,n,r=this;if(!this._qr)throw "QR code is not defined";var i=this._options,o=this._qr.getModuleCount();if(o>i.width||o>i.height)throw "The canvas is too small.";var a=Math.min(i.width,i.height)-2*i.margin,s=i.shape===g?a/Math.sqrt(2):a,u=Math.floor(s/o),l=Math.floor((i.width-o*u)/2),c=Math.floor((i.height-o*u)/2),f=new d({svg:this._element,type:i.dotsOptions.type});this._dotsClipPath=document.createElementNS("http://www.w3.org/2000/svg","clipPath"),this._dotsClipPath.setAttribute("id","clip-path-dot-color"),this._defs.appendChild(this._dotsClipPath),this._createColor({options:null===(t=i.dotsOptions)||void 0===t?void 0:t.gradient,color:i.dotsOptions.color,additionalRotation:0,x:0,y:0,height:i.height,width:i.width,name:"dot-color"});for(var h=function(t){for(var i=function(i){return e&&!e(t,i)?"continue":(null===(n=p._qr)||void 0===n?void 0:n.isDark(t,i))?(f.draw(l+t*u,c+i*u,u,(function(n,a){return !(t+n<0||i+a<0||t+n>=o||i+a>=o)&&!(e&&!e(t+n,i+a))&&!!r._qr&&r._qr.isDark(t+n,i+a)})),void(f._element&&p._dotsClipPath&&p._dotsClipPath.appendChild(f._element))):"continue"},a=0;a<o;a++)i(a);},p=this,m=0;m<o;m++)h(m);if(i.shape===g){var v=Math.floor((a/u-o)/2),b=o+2*v,y=l-v*u,w=c-v*u,_=[],S=Math.floor(b/2);for(m=0;m<b;m++){_[m]=[];for(var E=0;E<b;E++)m>=v-1&&m<=b-v&&E>=v-1&&E<=b-v||Math.sqrt((m-S)*(m-S)+(E-S)*(E-S))>S?_[m][E]=0:_[m][E]=this._qr.isDark(E-2*v<0?E:E>=o?E-2*v:E-v,m-2*v<0?m:m>=o?m-2*v:m-v)?1:0;}var k=function(e){for(var t=function(t){if(!_[e][t])return "continue";f.draw(y+e*u,w+t*u,u,(function(n,r){var i;return !!(null===(i=_[e+n])||void 0===i?void 0:i[t+r])})),f._element&&M._dotsClipPath&&M._dotsClipPath.appendChild(f._element);},n=0;n<b;n++)t(n);},M=this;for(m=0;m<b;m++)k(m);}},e.prototype.drawCorners=function(){var e=this;if(!this._qr)throw "QR code is not defined";var t=this._element,n=this._options;if(!t)throw "Element code is not defined";var r=this._qr.getModuleCount(),i=Math.min(n.width,n.height)-2*n.margin,o=n.shape===g?i/Math.sqrt(2):i,a=Math.floor(o/r),s=7*a,u=3*a,l=Math.floor((n.width-r*a)/2),c=Math.floor((n.height-r*a)/2);[[0,0,0],[1,0,Math.PI/2],[0,1,-Math.PI/2]].forEach((function(t){var i,o,f,p,g,v,b,_,S,E,k,M,C=t[0],x=t[1],A=t[2],R=l+C*a*(r-7),T=c+x*a*(r-7),P=e._dotsClipPath,L=e._dotsClipPath;if(((null===(i=n.cornersSquareOptions)||void 0===i?void 0:i.gradient)||(null===(o=n.cornersSquareOptions)||void 0===o?void 0:o.color))&&((P=document.createElementNS("http://www.w3.org/2000/svg","clipPath")).setAttribute("id","clip-path-corners-square-color-"+C+"-"+x),e._defs.appendChild(P),e._cornersSquareClipPath=e._cornersDotClipPath=L=P,e._createColor({options:null===(f=n.cornersSquareOptions)||void 0===f?void 0:f.gradient,color:null===(p=n.cornersSquareOptions)||void 0===p?void 0:p.color,additionalRotation:A,x:R,y:T,height:s,width:s,name:"corners-square-color-"+C+"-"+x})),null===(g=n.cornersSquareOptions)||void 0===g?void 0:g.type){var I=new h({svg:e._element,type:n.cornersSquareOptions.type});I.draw(R,T,s,A),I._element&&P&&P.appendChild(I._element);}else for(var O=new d({svg:e._element,type:n.dotsOptions.type}),N=function(e){for(var t=function(t){if(!(null===(v=y[e])||void 0===v?void 0:v[t]))return "continue";O.draw(R+e*a,T+t*a,a,(function(n,r){var i;return !!(null===(i=y[e+n])||void 0===i?void 0:i[t+r])})),O._element&&P&&P.appendChild(O._element);},n=0;n<y[e].length;n++)t(n);},D=0;D<y.length;D++)N(D);if(((null===(b=n.cornersDotOptions)||void 0===b?void 0:b.gradient)||(null===(_=n.cornersDotOptions)||void 0===_?void 0:_.color))&&((L=document.createElementNS("http://www.w3.org/2000/svg","clipPath")).setAttribute("id","clip-path-corners-dot-color-"+C+"-"+x),e._defs.appendChild(L),e._cornersDotClipPath=L,e._createColor({options:null===(S=n.cornersDotOptions)||void 0===S?void 0:S.gradient,color:null===(E=n.cornersDotOptions)||void 0===E?void 0:E.color,additionalRotation:A,x:R+2*a,y:T+2*a,height:u,width:u,name:"corners-dot-color-"+C+"-"+x})),null===(k=n.cornersDotOptions)||void 0===k?void 0:k.type){var j=new m({svg:e._element,type:n.cornersDotOptions.type});j.draw(R+2*a,T+2*a,u,A),j._element&&L&&L.appendChild(j._element);}else {O=new d({svg:e._element,type:n.dotsOptions.type});var B=function(e){for(var t=function(t){if(!(null===(M=w[e])||void 0===M?void 0:M[t]))return "continue";O.draw(R+e*a,T+t*a,a,(function(n,r){var i;return !!(null===(i=w[e+n])||void 0===i?void 0:i[t+r])})),O._element&&L&&L.appendChild(O._element);},n=0;n<w[e].length;n++)t(n);};for(D=0;D<w.length;D++)B(D);}}));},e.prototype.loadImage=function(){var e=this;return new Promise((function(t,n){var r=e._options,i=new Image;if(!r.image)return n("Image is not defined");"string"==typeof r.imageOptions.crossOrigin&&(i.crossOrigin=r.imageOptions.crossOrigin),e._image=i,i.onload=function(){t();},i.src=r.image;}))},e.prototype.drawImage=function(e){var t=e.width,n=e.height,r=e.count,i=e.dotSize;return v(this,void 0,void 0,(function(){var e,o,a,s,l,c,d,f,h;return b(this,(function(p){switch(p.label){case 0:return e=this._options,o=Math.floor((e.width-r*i)/2),a=Math.floor((e.height-r*i)/2),s=o+e.imageOptions.margin+(r*i-t)/2,l=a+e.imageOptions.margin+(r*i-n)/2,c=t-2*e.imageOptions.margin,d=n-2*e.imageOptions.margin,(f=document.createElementNS("http://www.w3.org/2000/svg","image")).setAttribute("x",String(s)),f.setAttribute("y",String(l)),f.setAttribute("width",c+"px"),f.setAttribute("height",d+"px"),[4,u(e.image||"")];case 1:return h=p.sent(),f.setAttribute("href",h||""),this._element.appendChild(f),[2]}}))}))},e.prototype._createColor=function(e){var t=e.options,n=e.color,r=e.additionalRotation,i=e.x,o=e.y,a=e.height,s=e.width,u=e.name,l=s>a?s:a,c=document.createElementNS("http://www.w3.org/2000/svg","rect");if(c.setAttribute("x",String(i)),c.setAttribute("y",String(o)),c.setAttribute("height",String(a)),c.setAttribute("width",String(s)),c.setAttribute("clip-path","url('#clip-path-"+u+"')"),t){var d;if("radial"===t.type)(d=document.createElementNS("http://www.w3.org/2000/svg","radialGradient")).setAttribute("id",u),d.setAttribute("gradientUnits","userSpaceOnUse"),d.setAttribute("fx",String(i+s/2)),d.setAttribute("fy",String(o+a/2)),d.setAttribute("cx",String(i+s/2)),d.setAttribute("cy",String(o+a/2)),d.setAttribute("r",String(l/2));else {var f=((t.rotation||0)+r)%(2*Math.PI),h=(f+2*Math.PI)%(2*Math.PI),p=i+s/2,m=o+a/2,g=i+s/2,v=o+a/2;h>=0&&h<=.25*Math.PI||h>1.75*Math.PI&&h<=2*Math.PI?(p-=s/2,m-=a/2*Math.tan(f),g+=s/2,v+=a/2*Math.tan(f)):h>.25*Math.PI&&h<=.75*Math.PI?(m-=a/2,p-=s/2/Math.tan(f),v+=a/2,g+=s/2/Math.tan(f)):h>.75*Math.PI&&h<=1.25*Math.PI?(p+=s/2,m+=a/2*Math.tan(f),g-=s/2,v-=a/2*Math.tan(f)):h>1.25*Math.PI&&h<=1.75*Math.PI&&(m+=a/2,p+=s/2/Math.tan(f),v-=a/2,g-=s/2/Math.tan(f)),(d=document.createElementNS("http://www.w3.org/2000/svg","linearGradient")).setAttribute("id",u),d.setAttribute("gradientUnits","userSpaceOnUse"),d.setAttribute("x1",String(Math.round(p))),d.setAttribute("y1",String(Math.round(m))),d.setAttribute("x2",String(Math.round(g))),d.setAttribute("y2",String(Math.round(v)));}t.colorStops.forEach((function(e){var t=e.offset,n=e.color,r=document.createElementNS("http://www.w3.org/2000/svg","stop");r.setAttribute("offset",100*t+"%"),r.setAttribute("stop-color",n),d.appendChild(r);})),c.setAttribute("fill","url('#"+u+"')"),this._defs.appendChild(d);}else n&&c.setAttribute("fill",n);this._element.appendChild(c);},e}(),S="canvas";for(var E={},k=0;k<=40;k++)E[k]=k;const M={type:S,shape:"square",width:300,height:300,data:"",margin:0,qrOptions:{typeNumber:E[0],mode:void 0,errorCorrectionLevel:"Q"},imageOptions:{hideBackgroundDots:true,imageSize:.4,crossOrigin:void 0,margin:0},dotsOptions:{type:"square",color:"#000"},backgroundOptions:{round:0,color:"#fff"}};var C=function(){return (C=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e}).apply(this,arguments)};function x(e){var t=C({},e);if(!t.colorStops||!t.colorStops.length)throw "Field 'colorStops' is required in gradient";return t.rotation?t.rotation=Number(t.rotation):t.rotation=0,t.colorStops=t.colorStops.map((function(e){return C(C({},e),{offset:Number(e.offset)})})),t}function A(e){var t=C({},e);return t.width=Number(t.width),t.height=Number(t.height),t.margin=Number(t.margin),t.imageOptions=C(C({},t.imageOptions),{hideBackgroundDots:Boolean(t.imageOptions.hideBackgroundDots),imageSize:Number(t.imageOptions.imageSize),margin:Number(t.imageOptions.margin)}),t.margin>Math.min(t.width,t.height)&&(t.margin=Math.min(t.width,t.height)),t.dotsOptions=C({},t.dotsOptions),t.dotsOptions.gradient&&(t.dotsOptions.gradient=x(t.dotsOptions.gradient)),t.cornersSquareOptions&&(t.cornersSquareOptions=C({},t.cornersSquareOptions),t.cornersSquareOptions.gradient&&(t.cornersSquareOptions.gradient=x(t.cornersSquareOptions.gradient))),t.cornersDotOptions&&(t.cornersDotOptions=C({},t.cornersDotOptions),t.cornersDotOptions.gradient&&(t.cornersDotOptions.gradient=x(t.cornersDotOptions.gradient))),t.backgroundOptions&&(t.backgroundOptions=C({},t.backgroundOptions),t.backgroundOptions.gradient&&(t.backgroundOptions.gradient=x(t.backgroundOptions.gradient))),t}var R=n(192),T=n.n(R),P=function(e,t,n,r){return new(n||(n=Promise))((function(i,o){function a(e){try{u(r.next(e));}catch(e){o(e);}}function s(e){try{u(r.throw(e));}catch(e){o(e);}}function u(e){var t;e.done?i(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t);}))).then(a,s);}u((r=r.apply(e,[])).next());}))},L=function(e,t){var n,r,i,o,a={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function s(o){return function(s){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;a;)try{if(n=1,r&&(i=2&o[0]?r.return:o[0]?r.throw||((i=r.return)&&i.call(r),0):r.next)&&!(i=i.call(r,o[1])).done)return i;switch(r=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return a.label++,{value:o[1],done:!1};case 5:a.label++,r=o[1],o=[0];continue;case 7:o=a.ops.pop(),a.trys.pop();continue;default:if(!((i=(i=a.trys).length>0&&i[i.length-1])||6!==o[0]&&2!==o[0])){a=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){a.label=o[1];break}if(6===o[0]&&a.label<i[1]){a.label=i[1],i=o;break}if(i&&a.label<i[2]){a.label=i[2],a.ops.push(o);break}i[2]&&a.ops.pop(),a.trys.pop();continue}o=t.call(e,a);}catch(e){o=[6,e],r=0;}finally{n=i=0;}if(5&o[0])throw o[1];return {value:o[0]?o[1]:void 0,done:true}}([o,s])}}};const I=function(){function e(e){this._options=e?A(a(M,e)):M,this.update();}return e._clearContainer=function(e){e&&(e.innerHTML="");},e.prototype._setupSvg=function(){var e=this;if(this._qr){var t=new _(this._options);this._svg=t.getElement(),this._svgDrawingPromise=t.drawQR(this._qr).then((function(){var n;e._svg&&(null===(n=e._extension)||void 0===n||n.call(e,t.getElement(),e._options));}));}},e.prototype._setupCanvas=function(){var e,t=this;this._qr&&(this._canvas=document.createElement("canvas"),this._canvas.width=this._options.width,this._canvas.height=this._options.height,this._setupSvg(),this._canvasDrawingPromise=null===(e=this._svgDrawingPromise)||void 0===e?void 0:e.then((function(){if(t._svg){var e=t._svg,n=(new XMLSerializer).serializeToString(e),r="data:image/svg+xml;base64,"+btoa(n),i=new Image;return new Promise((function(e){i.onload=function(){var n,r;null===(r=null===(n=t._canvas)||void 0===n?void 0:n.getContext("2d"))||void 0===r||r.drawImage(i,0,0),e();},i.src=r;}))}})));},e.prototype._getElement=function(e){return void 0===e&&(e="png"),P(this,void 0,void 0,(function(){return L(this,(function(t){switch(t.label){case 0:if(!this._qr)throw "QR code is empty";return "svg"!==e.toLowerCase()?[3,2]:(this._svg&&this._svgDrawingPromise||this._setupSvg(),[4,this._svgDrawingPromise]);case 1:return t.sent(),[2,this._svg];case 2:return this._canvas&&this._canvasDrawingPromise||this._setupCanvas(),[4,this._canvasDrawingPromise];case 3:return t.sent(),[2,this._canvas]}}))}))},e.prototype.update=function(t){e._clearContainer(this._container),this._options=t?A(a(this._options,t)):this._options,this._options.data&&(this._qr=T()(this._options.qrOptions.typeNumber,this._options.qrOptions.errorCorrectionLevel),this._qr.addData(this._options.data,this._options.qrOptions.mode||function(e){switch(true){case /^[0-9]*$/.test(e):return "Numeric";case /^[0-9A-Z $%*+\-./:]*$/.test(e):return "Alphanumeric";default:return "Byte"}}(this._options.data)),this._qr.make(),this._options.type===S?this._setupCanvas():this._setupSvg(),this.append(this._container));},e.prototype.append=function(e){if(e){if("function"!=typeof e.appendChild)throw "Container should be a single DOM node";this._options.type===S?this._canvas&&e.appendChild(this._canvas):this._svg&&e.appendChild(this._svg),this._container=e;}},e.prototype.applyExtension=function(e){if(!e)throw "Extension function should be defined.";this._extension=e,this.update();},e.prototype.deleteExtension=function(){this._extension=void 0,this.update();},e.prototype.getRawData=function(e){return void 0===e&&(e="png"),P(this,void 0,void 0,(function(){var t,n,r;return L(this,(function(i){switch(i.label){case 0:if(!this._qr)throw "QR code is empty";return [4,this._getElement(e)];case 1:return (t=i.sent())?"svg"===e.toLowerCase()?(n=new XMLSerializer,r=n.serializeToString(t),[2,new Blob(['<?xml version="1.0" standalone="no"?>\r\n'+r],{type:"image/svg+xml"})]):[2,new Promise((function(n){return t.toBlob(n,"image/"+e,1)}))]:[2,null]}}))}))},e.prototype.download=function(e){return P(this,void 0,void 0,(function(){var t,n,r,i,o;return L(this,(function(a){switch(a.label){case 0:if(!this._qr)throw "QR code is empty";return t="png",n="qr","string"==typeof e?(t=e,console.warn("Extension is deprecated as argument for 'download' method, please pass object { name: '...', extension: '...' } as argument")):"object"==typeof e&&null!==e&&(e.name&&(n=e.name),e.extension&&(t=e.extension)),[4,this._getElement(t)];case 1:return (r=a.sent())?("svg"===t.toLowerCase()?(i=new XMLSerializer,o='<?xml version="1.0" standalone="no"?>\r\n'+(o=i.serializeToString(r)),s("data:image/svg+xml;charset=utf-8,"+encodeURIComponent(o),n+".svg")):s(r.toDataURL("image/"+t),n+"."+t),[2]):[2]}}))}))},e}();}},t={};function n(r){if(t[r])return t[r].exports;var i=t[r]={exports:{}};return e[r](i,i.exports,n),i.exports}return n.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return n.d(t,{a:t}),t},n.d=(e,t)=>{for(var r in t)n.o(t,r)&&!n.o(e,r)&&Object.defineProperty(e,r,{enumerable:true,get:t[r]});},n.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),n(676)})().default;}(eP)),eP.exports}!function(e,t){!function(e,t,n){var r="data:image/png;base64,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",i=function(){return i=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var i in t=arguments[n])Object.prototype.hasOwnProperty.call(t,i)&&(e[i]=t[i]);return e},i.apply(this,arguments)};"function"==typeof SuppressedError&&SuppressedError;var o={fontFamily:"Roboto, sans-serif"},a=function(e){var n=e.children,r=e.className;return t.createElement("div",{style:o,className:r},n)},s={flexContainer:{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"row"},flexItem:{flex:1,justifyContent:"center",alignItems:"center"},flexItem11:{flex:11,justifyContent:"center",alignItems:"center"},flexItem1:{flex:1,justifyContent:"center",alignItems:"center"},tab:{padding:8,cursor:"pointer",backgroundColor:"#F2F4F6",fontSize:12,textAlign:"center",color:"#24292E"},tabcontainer:{padding:"4px",backgroundColor:"#F2F4F6",borderRadius:"8px",marginBottom:30,marginTop:30},tabactive:{backgroundColor:"white",WebkitTransition:"background-color 300ms linear",msTransition:"background-color 300ms linear",transition:"background-color 300ms linear",borderRadius:"8px"},item:{fontSize:"12px",marginBottom:16,borderRadius:"8px",padding:"10px",border:"2px #F2F4F6 solid",color:"#24292E"},extensionLabel:{fontsStyle:"normal",fontWeight:"bold",fontSize:14,textAlign:"center",color:"#24272A"},notice:{fontSize:12,marginLeft:10,marginRight:10,color:"grey"},button:{marginTop:"41.5px",marginBottom:"20px",width:"100%",display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center",padding:"12px 20px",background:"#037DD6",borderRadius:"32px",color:"white",border:"0",fontSize:"14px",cursor:"pointer"},backdrop:{visibility:"visible",position:"fixed",top:"0",left:"0",right:"0",bottom:"0",width:"100%",zIndex:99998,background:"rgba(0, 0, 0, 0.87)",opacity:.3},modal:{visibility:"visible",position:"fixed",left:"50%",transform:"translate(-50%, -50%)",zIndex:99999,background:"#fff",padding:"20px",borderRadius:"8px",top:"50%",maxWidth:"100%",width:460,minWidth:300,boxShadow:"rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px",WebkitFontSmoothing:"antialiased"},closeButton:{color:"#BBC0C5",cursor:"pointer"},closeButtonContainer:{},logoContainer:{marginHorizontal:24,marginTop:24,display:"flex",alignItems:"center",justifyContent:"center"},connectMobileText:{fontSize:14,color:"black",marginTop:28,marginBottom:28,lineHeight:2},blue:{color:"#037DD6",fontWeight:700},installExtensionText:{marginLeft:10},center:{display:"flex",alignItems:"center",justifyContent:"center"},right:{display:"flex",alignItems:"center",justifyContent:"right"}},u=function(e){var n=e.Icon,r=e.text;return t.createElement("div",{style:i(i({padding:6},s.flexContainer),{flexDirection:"row"})},t.createElement("div",{style:s.flexItem1},t.createElement(n,null)),t.createElement("div",{style:s.flexItem11},t.createElement("span",{style:{lineHeight:"2",color:"black"}},r)))},l=function(){return t.createElement("svg",{width:"14",height:"14",viewBox:"0 0 16 16",fill:"none",xmlns:"http://www.w3.org/2000/svg"},t.createElement("rect",{width:"16",height:"16",fill:"white"}),t.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M2.40554 2.40554C2.94627 1.86482 3.82296 1.86482 4.36369 2.40554L8 6.04186L11.6363 2.40554C12.177 1.86482 13.0537 1.86482 13.5945 2.40554C14.1352 2.94627 14.1352 3.82296 13.5945 4.36369L9.95814 8L13.5945 11.6363C14.1352 12.177 14.1352 13.0537 13.5945 13.5945C13.0537 14.1352 12.177 14.1352 11.6363 13.5945L8 9.95814L4.36369 13.5945C3.82296 14.1352 2.94627 14.1352 2.40554 13.5945C1.86482 13.0537 1.86482 12.177 2.40554 11.6363L6.04186 8L2.40554 4.36369C1.86482 3.82296 1.86482 2.94627 2.40554 2.40554Z",fill:"#BBC0C5"}))},c=function(){return t.createElement("svg",{width:"20",height:"18",viewBox:"0 0 20 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},t.createElement("path",{d:"M14.44 0.0999756C12.63 0.0999756 11.01 0.979976 10 2.32998C8.99 0.979976 7.37 0.0999756 5.56 0.0999756C2.49 0.0999756 0 2.59998 0 5.68998C0 6.87998 0.19 7.97998 0.52 8.99998C2.1 14 6.97 16.99 9.38 17.81C9.72 17.93 10.28 17.93 10.62 17.81C13.03 16.99 17.9 14 19.48 8.99998C19.81 7.97998 20 6.87998 20 5.68998C20 2.59998 17.51 0.0999756 14.44 0.0999756Z",fill:"#037DD6"}))},d=function(){return t.createElement("svg",{width:"20",height:"20",viewBox:"0 0 24 24",fill:"none",xmlns:"http://www.w3.org/2000/svg"},t.createElement("path",{d:"M16.4405 8.8999C20.0405 9.2099 21.5105 11.0599 21.5105 15.1099V15.2399C21.5105 19.7099 19.7205 21.4999 15.2505 21.4999H8.74047C4.27047 21.4999 2.48047 19.7099 2.48047 15.2399V15.1099C2.48047 11.0899 3.93047 9.2399 7.47047 8.9099",stroke:"white",strokeWidth:"1.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M12 2V14.88",stroke:"white",strokeWidth:"1.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M15.3504 12.6499L12.0004 15.9999L8.65039 12.6499",stroke:"white",strokeWidth:"1.5",strokeLinecap:"round",strokeLinejoin:"round"}))},f=function(){return t.createElement("svg",{width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",xmlns:"http://www.w3.org/2000/svg"},t.createElement("path",{d:"M16.28 7.53V6.28C16.28 3.58 15.63 0 10 0C4.37 0 3.72 3.58 3.72 6.28V7.53C0.92 7.88 0 9.3 0 12.79V14.65C0 18.75 1.25 20 5.35 20H14.65C18.75 20 20 18.75 20 14.65V12.79C20 9.3 19.08 7.88 16.28 7.53ZM10 16.74C8.33 16.74 6.98 15.38 6.98 13.72C6.98 12.05 8.34 10.7 10 10.7C11.66 10.7 13.02 12.06 13.02 13.72C13.02 15.39 11.67 16.74 10 16.74ZM5.35 7.44C5.27 7.44 5.2 7.44 5.12 7.44V6.28C5.12 3.35 5.95 1.4 10 1.4C14.05 1.4 14.88 3.35 14.88 6.28V7.45C14.8 7.45 14.73 7.45 14.65 7.45H5.35V7.44Z",fill:"#037DD6"}))},h=function(){return t.createElement("svg",{width:"273",height:"51",viewBox:"0 0 273 51",fill:"none",xmlns:"http://www.w3.org/2000/svg"},t.createElement("path",{d:"M240.882 25.9263C239.472 24.997 237.916 24.3361 236.443 23.5101C235.489 22.9731 234.473 22.4982 233.643 21.8167C232.233 20.6602 232.524 18.3885 233.996 17.3973C236.112 15.993 239.617 16.7777 239.99 19.6483C239.99 19.7102 240.052 19.7515 240.114 19.7515H243.308C243.391 19.7515 243.454 19.6896 243.433 19.607C243.267 17.6244 242.5 15.9723 241.089 14.9191C239.741 13.9072 238.206 13.3702 236.568 13.3702C228.127 13.3702 227.359 22.271 231.901 25.0796C232.42 25.41 236.879 27.6404 238.455 28.611C240.032 29.5816 240.529 31.3576 239.845 32.7619C239.223 34.0423 237.605 34.9303 235.987 34.8271C234.224 34.7238 232.855 33.7738 232.378 32.2869C232.295 32.0185 232.254 31.5022 232.254 31.275C232.254 31.2131 232.192 31.1511 232.129 31.1511H228.666C228.604 31.1511 228.541 31.2131 228.541 31.275C228.541 33.7738 229.164 35.1575 230.864 36.4172C232.461 37.615 234.203 38.1106 236.008 38.1106C240.737 38.1106 243.184 35.4466 243.682 32.6793C244.117 29.974 243.308 27.5371 240.882 25.9263Z",fill:"#24292E"}),t.createElement("path",{d:"M90.4943 13.8246H88.9595H87.2795C87.2173 13.8246 87.1758 13.8659 87.1551 13.9072L84.3137 23.2416C84.2722 23.3655 84.1063 23.3655 84.0648 23.2416L81.2234 13.9072C81.2026 13.8452 81.1612 13.8246 81.0989 13.8246H79.419H77.8842H75.8102C75.748 13.8246 75.6857 13.8865 75.6857 13.9485V37.7802C75.6857 37.8422 75.748 37.9041 75.8102 37.9041H79.2738C79.336 37.9041 79.3982 37.8422 79.3982 37.7802V19.6689C79.3982 19.5244 79.6056 19.5037 79.6471 19.6276L82.5093 29.024L82.7167 29.6849C82.7374 29.7468 82.7789 29.7675 82.8411 29.7675H85.4959C85.5581 29.7675 85.5996 29.7262 85.6203 29.6849L85.8277 29.024L88.6899 19.6276C88.7313 19.4831 88.9387 19.5244 88.9387 19.6689V37.7802C88.9387 37.8422 89.001 37.9041 89.0632 37.9041H92.5268C92.589 37.9041 92.6513 37.8422 92.6513 37.7802V13.9485C92.6513 13.8865 92.589 13.8246 92.5268 13.8246H90.4943Z",fill:"#24292E"}),t.createElement("path",{d:"M187.849 13.8246C187.787 13.8246 187.745 13.8659 187.725 13.9072L184.883 23.2416C184.842 23.3655 184.676 23.3655 184.634 23.2416L181.793 13.9072C181.772 13.8452 181.731 13.8246 181.668 13.8246H176.4C176.338 13.8246 176.276 13.8865 176.276 13.9485V37.7802C176.276 37.8422 176.338 37.9041 176.4 37.9041H179.864C179.926 37.9041 179.988 37.8422 179.988 37.7802V19.6689C179.988 19.5244 180.196 19.5037 180.237 19.6276L183.099 29.024L183.307 29.6849C183.328 29.7468 183.369 29.7675 183.431 29.7675H186.086C186.148 29.7675 186.19 29.7262 186.211 29.6849L186.418 29.024L189.28 19.6276C189.322 19.4831 189.529 19.5244 189.529 19.6689V37.7802C189.529 37.8422 189.591 37.9041 189.653 37.9041H193.117C193.179 37.9041 193.241 37.8422 193.241 37.7802V13.9485C193.241 13.8865 193.179 13.8246 193.117 13.8246H187.849Z",fill:"#24292E"}),t.createElement("path",{d:"M143.174 13.8246H136.724H133.261H126.81C126.748 13.8246 126.686 13.8865 126.686 13.9485V16.9223C126.686 16.9843 126.748 17.0462 126.81 17.0462H133.136V37.7802C133.136 37.8422 133.198 37.9041 133.261 37.9041H136.724C136.786 37.9041 136.849 37.8422 136.849 37.7802V17.0462H143.174C143.237 17.0462 143.299 16.9843 143.299 16.9223V13.9485C143.299 13.8865 143.257 13.8246 143.174 13.8246Z",fill:"#24292E"}),t.createElement("path",{d:"M163.604 37.9041H166.756C166.839 37.9041 166.901 37.8215 166.881 37.7389L160.368 13.8245C160.347 13.7626 160.306 13.7419 160.244 13.7419H159.041H156.925H155.722C155.66 13.7419 155.619 13.7832 155.598 13.8245L149.085 37.7389C149.065 37.8215 149.127 37.9041 149.21 37.9041H152.362C152.425 37.9041 152.466 37.8628 152.487 37.8215L154.374 30.862C154.395 30.8 154.436 30.7794 154.499 30.7794H161.467C161.53 30.7794 161.571 30.8207 161.592 30.862L163.479 37.8215C163.5 37.8628 163.562 37.9041 163.604 37.9041ZM155.328 27.3719L157.859 18.0581C157.9 17.9342 158.066 17.9342 158.107 18.0581L160.638 27.3719C160.659 27.4545 160.596 27.5371 160.513 27.5371H155.453C155.37 27.5371 155.308 27.4545 155.328 27.3719Z",fill:"#24292E"}),t.createElement("path",{d:"M217.362 37.9041H220.515C220.598 37.9041 220.66 37.8215 220.639 37.7389L214.127 13.8245C214.106 13.7626 214.065 13.7419 214.002 13.7419H212.8H210.684H209.481C209.419 13.7419 209.377 13.7832 209.357 13.8245L202.844 37.7389C202.823 37.8215 202.886 37.9041 202.969 37.9041H206.121C206.183 37.9041 206.225 37.8628 206.246 37.8215L208.133 30.862C208.154 30.8 208.195 30.7794 208.257 30.7794H215.226C215.288 30.7794 215.33 30.8207 215.351 30.862L217.238 37.8215C217.259 37.8628 217.3 37.9041 217.362 37.9041ZM209.087 27.3719L211.617 18.0581C211.659 17.9342 211.825 17.9342 211.866 18.0581L214.397 27.3719C214.417 27.4545 214.355 27.5371 214.272 27.5371H209.211C209.129 27.5371 209.066 27.4545 209.087 27.3719Z",fill:"#24292E"}),t.createElement("path",{d:"M106.713 34.3727V26.9795C106.713 26.9176 106.775 26.8556 106.837 26.8556H116.067C116.129 26.8556 116.191 26.7936 116.191 26.7317V23.7579C116.191 23.6959 116.129 23.634 116.067 23.634H106.837C106.775 23.634 106.713 23.572 106.713 23.5101V17.1907C106.713 17.1288 106.775 17.0668 106.837 17.0668H117.332C117.394 17.0668 117.457 17.0049 117.457 16.9429V13.9691C117.457 13.9072 117.394 13.8452 117.332 13.8452H106.713H103.125C103.063 13.8452 103.001 13.9072 103.001 13.9691V17.0668V23.6546V26.8763V34.5173V37.7802C103.001 37.8422 103.063 37.9041 103.125 37.9041H106.713H117.768C117.83 37.9041 117.892 37.8422 117.892 37.7802V34.6412C117.892 34.5792 117.83 34.5173 117.768 34.5173H106.817C106.755 34.4966 106.713 34.4553 106.713 34.3727Z",fill:"#24292E"}),t.createElement("path",{d:"M272.532 37.6976L260.544 25.3687C260.502 25.3274 260.502 25.2448 260.544 25.2035L271.329 14.0517C271.412 13.9691 271.349 13.8452 271.246 13.8452H266.828C266.787 13.8452 266.766 13.8659 266.745 13.8865L257.599 23.3449C257.516 23.4275 257.391 23.3655 257.391 23.2623V13.9691C257.391 13.9072 257.329 13.8452 257.267 13.8452H253.803C253.741 13.8452 253.679 13.9072 253.679 13.9691V37.8009C253.679 37.8628 253.741 37.9248 253.803 37.9248H257.267C257.329 37.9248 257.391 37.8628 257.391 37.8009V27.3099C257.391 27.2067 257.536 27.1447 257.599 27.2273L267.969 37.8835C267.989 37.9041 268.031 37.9248 268.052 37.9248H272.469C272.552 37.9041 272.615 37.7596 272.532 37.6976Z",fill:"#24292E"}),t.createElement("path",{d:"M52.021 1L31.0526 16.4886L34.9517 7.36063L52.021 1Z",fill:"#E17726",stroke:"#E17726",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M3.65491 1L24.4366 16.6331L20.7241 7.36063L3.65491 1Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M44.4716 36.9127L38.8925 45.4211L50.8389 48.7047L54.261 37.0986L44.4716 36.9127Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M1.43555 37.0986L4.83695 48.7047L16.7626 45.4211L11.2042 36.9127L1.43555 37.0986Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M16.1197 22.5395L12.8013 27.5371L24.6232 28.074L24.2292 15.3734L16.1197 22.5395Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M39.5561 22.5394L31.3222 15.2288L31.0526 28.0739L42.8746 27.537L39.5561 22.5394Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M16.7626 45.4212L23.918 41.9724L17.7582 37.1813L16.7626 45.4212Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M31.7578 41.9724L38.8925 45.4212L37.9177 37.1813L31.7578 41.9724Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M38.8923 45.4212L31.7577 41.9724L32.3384 46.5983L32.2762 48.5602L38.8923 45.4212Z",fill:"#D5BFB2",stroke:"#D5BFB2",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M16.7625 45.4212L23.3994 48.5602L23.3579 46.5983L23.9179 41.9724L16.7625 45.4212Z",fill:"#D5BFB2",stroke:"#D5BFB2",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M23.5239 34.1249L17.5922 32.3902L21.7818 30.4696L23.5239 34.1249Z",fill:"#233447",stroke:"#233447",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M32.1517 34.1249L33.8939 30.4696L38.1042 32.3902L32.1517 34.1249Z",fill:"#233447",stroke:"#233447",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M16.7626 45.4212L17.7996 36.9128L11.2042 37.0987L16.7626 45.4212Z",fill:"#CC6228",stroke:"#CC6228",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M37.8761 36.9128L38.8924 45.4212L44.4715 37.0987L37.8761 36.9128Z",fill:"#CC6228",stroke:"#CC6228",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M42.8745 27.5371L31.0526 28.074L32.1518 34.1249L33.894 30.4696L38.1042 32.3902L42.8745 27.5371Z",fill:"#CC6228",stroke:"#CC6228",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M17.5922 32.3902L21.7817 30.4696L23.5239 34.1249L24.6232 28.074L12.8012 27.5371L17.5922 32.3902Z",fill:"#CC6228",stroke:"#CC6228",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M12.8013 27.5371L17.7582 37.1813L17.5923 32.3902L12.8013 27.5371Z",fill:"#E27525",stroke:"#E27525",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M38.1044 32.3902L37.9177 37.1813L42.8746 27.5371L38.1044 32.3902Z",fill:"#E27525",stroke:"#E27525",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M24.6232 28.0741L23.524 34.125L24.9136 41.2703L25.2247 31.8533L24.6232 28.0741Z",fill:"#E27525",stroke:"#E27525",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M31.0526 28.0741L30.4719 31.8327L30.7623 41.2703L32.1519 34.125L31.0526 28.0741Z",fill:"#E27525",stroke:"#E27525",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M32.1519 34.1249L30.7623 41.2702L31.7578 41.9724L37.9177 37.1813L38.1043 32.3901L32.1519 34.1249Z",fill:"#F5841F",stroke:"#F5841F",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M17.5922 32.3901L17.7581 37.1813L23.918 41.9724L24.9135 41.2702L23.5239 34.1249L17.5922 32.3901Z",fill:"#F5841F",stroke:"#F5841F",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M32.2763 48.5602L32.3385 46.5983L31.7993 46.1439H23.8765L23.358 46.5983L23.3995 48.5602L16.7626 45.4211L19.0855 47.3211L23.7935 50.5633H31.8615L36.5903 47.3211L38.8924 45.4211L32.2763 48.5602Z",fill:"#C0AC9D",stroke:"#C0AC9D",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M31.7578 41.9724L30.7622 41.2703H24.9135L23.918 41.9724L23.358 46.5983L23.8765 46.144H31.7993L32.3385 46.5983L31.7578 41.9724Z",fill:"#24292E",stroke:"#24292E",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M52.9128 17.5005L54.6757 8.95079L52.021 1L31.7578 15.9723L39.5561 22.5394L50.5692 25.7404L52.9958 22.9111L51.938 22.147L53.618 20.6188L52.3321 19.6276L54.0121 18.3472L52.9128 17.5005Z",fill:"#763E1A",stroke:"#763E1A",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M1 8.95079L2.78366 17.5005L1.64295 18.3472L3.34365 19.6276L2.05775 20.6188L3.73771 22.147L2.67996 22.9111L5.10657 25.7404L16.1196 22.5394L23.918 15.9723L3.65475 1L1 8.95079Z",fill:"#763E1A",stroke:"#763E1A",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M50.5692 25.7404L39.5561 22.5394L42.8746 27.5371L37.9177 37.1813L44.4716 37.0987H54.261L50.5692 25.7404Z",fill:"#F5841F",stroke:"#F5841F",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M16.1196 22.5394L5.10651 25.7404L1.43549 37.0987H11.2041L17.7581 37.1813L12.8011 27.5371L16.1196 22.5394Z",fill:"#F5841F",stroke:"#F5841F",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M31.0526 28.0741L31.7578 15.9724L34.9518 7.36072H20.7239L23.9179 15.9724L24.6231 28.0741L24.8927 31.8739L24.9135 41.2703H30.7622L30.783 31.8739L31.0526 28.0741Z",fill:"#F5841F",stroke:"#F5841F",strokeWidth:"0.5",strokeLinecap:"round",strokeLinejoin:"round"}))},p=function(){return t.createElement("svg",{width:"20",height:"18",viewBox:"0 0 20 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},t.createElement("path",{d:"M20.0002 7.9702V10.0302C20.0002 10.5802 19.5602 11.0302 19.0002 11.0502H17.0402C15.9602 11.0502 14.9702 10.2602 14.8802 9.1802C14.8202 8.5502 15.0602 7.9602 15.4802 7.5502C15.8502 7.1702 16.3602 6.9502 16.9202 6.9502H19.0002C19.5602 6.9702 20.0002 7.4202 20.0002 7.9702Z",fill:"#037DD6"}),t.createElement("path",{d:"M18.47 12.55H17.04C15.14 12.55 13.54 11.12 13.38 9.3C13.29 8.26 13.67 7.22 14.43 6.48C15.07 5.82 15.96 5.45 16.92 5.45H18.47C18.76 5.45 19 5.21 18.97 4.92C18.75 2.49 17.14 0.83 14.75 0.55C14.51 0.51 14.26 0.5 14 0.5H5C4.72 0.5 4.45 0.52 4.19 0.56C1.64 0.88 0 2.78 0 5.5V12.5C0 15.26 2.24 17.5 5 17.5H14C16.8 17.5 18.73 15.75 18.97 13.08C19 12.79 18.76 12.55 18.47 12.55ZM11 6.75H5C4.59 6.75 4.25 6.41 4.25 6C4.25 5.59 4.59 5.25 5 5.25H11C11.41 5.25 11.75 5.59 11.75 6C11.75 6.41 11.41 6.75 11 6.75Z",fill:"#037DD6"}))};function m(e){var n=e.version;return t.createElement("div",{style:{textAlign:"center",color:"#BBC0C5",fontSize:12}},"SDK Version ",n?"v".concat(n):"unknown")}var g=function(e){var n=t.useState(e.preferDesktop?1:2),o=n[0],g=n[1],v=t.useRef(null),b=e.sdkVersion,y=e.i18nInstance.t;return t.useEffect((function(){v.current&&new(tP())({width:270,height:270,type:"svg",data:e.link,image:r,dotsOptions:{color:"black",type:"rounded"},imageOptions:{margin:5},cornersDotOptions:{color:"#f66a07"},qrOptions:{errorCorrectionLevel:"M"}}).append(v.current);}),[v]),t.createElement(a,{className:"install-model"},t.createElement("div",{style:s.backdrop,onClick:e.onClose}),t.createElement("div",{style:s.modal},t.createElement("div",{style:s.closeButtonContainer},t.createElement("div",{style:s.right},t.createElement("span",{style:s.closeButton,onClick:e.onClose},t.createElement(l,null)))),t.createElement("div",{style:s.logoContainer},t.createElement(h,null)),t.createElement("div",null,t.createElement("div",{style:s.tabcontainer},t.createElement("div",{style:s.flexContainer},t.createElement("div",{onClick:function(){return g(1)},style:i(i(i({},s.tab),1===o?s.tabactive:{}),s.flexItem)},y("DESKTOP")),t.createElement("div",{onClick:function(){return g(2)},style:i(i(i({},s.tab),2===o?s.tabactive:{}),s.flexItem)},y("MOBILE")))),t.createElement("div",{style:{display:1===o?"none":"block"}},t.createElement("div",{style:s.flexContainer},t.createElement("div",{style:i({textAlign:"center",marginTop:4},s.flexItem)},t.createElement("div",{ref:v,style:s.center}),t.createElement("div",{style:s.connectMobileText},y("SCAN_TO_CONNECT")," ",t.createElement("br",null),t.createElement("span",{style:s.blue},t.createElement("b",null,y("META_MASK_MOBILE_APP"))))))),t.createElement("div",{style:{display:2===o?"none":"block"}},t.createElement("div",{style:s.item},t.createElement(u,{Icon:c,text:y("INSTALL_MODAL.TRUSTED_BY_USERS")})),t.createElement("div",{style:s.item},t.createElement(u,{Icon:f,text:y("INSTALL_MODAL.LEADING_CRYPTO_WALLET")})),t.createElement("div",{style:s.item},t.createElement(u,{Icon:p,text:y("INSTALL_MODAL.CONTROL_DIGITAL_INTERACTIONS")})),t.createElement("button",{style:s.button,onClick:e.metaMaskInstaller.startDesktopOnboarding},t.createElement(d,null),t.createElement("span",{style:s.installExtensionText},y("INSTALL_MODAL.INSTALL_META_MASK_EXTENSION"))))),t.createElement(m,{version:b})))},v=function(e){var n,r=null===(n=e.displayOTP)||void 0===n||n,o=e.sdkVersion,u=e.i18nInstance.t;return t.createElement(a,{className:"pending-modal"},t.createElement("div",{style:s.backdrop,onClick:e.onClose}),t.createElement("div",{style:s.modal},t.createElement("div",{style:s.closeButtonContainer},t.createElement("div",{style:s.right},t.createElement("span",{style:s.closeButton,onClick:e.onClose},t.createElement(l,null)))),t.createElement("div",{style:s.logoContainer},t.createElement(h,null)),t.createElement("div",null,t.createElement("div",{style:i(i({},s.flexContainer),{flexDirection:"column",color:"black"})},t.createElement("div",{style:i(i({textAlign:"center",marginTop:"30px",marginBottom:"30px"},s.flexItem),{fontSize:16})},u(r?"PENDING_MODAL.OPEN_META_MASK_SELECT_CODE":"PENDING_MODAL.OPEN_META_MASK_CONTINUE")),t.createElement("div",{id:"sdk-mm-otp-value",style:{padding:10,fontSize:32,display:"none"}}),r&&t.createElement("div",{style:i({},s.notice)},"* ",u("PENDING_MODAL.NUMBER_AFTER_OPEN_NOTICE"))),t.createElement("div",{style:{marginTop:"20px"}},t.createElement("button",{style:i(i(i({},s.button),s.blue),{marginTop:"5px",color:"#0376C9",borderColor:"#0376C9",borderWidth:"1px",borderStyle:"solid",backgroundColor:"white"}),onClick:e.onDisconnect},u("PENDING_MODAL.DISCONNECT")))),t.createElement(m,{version:o})))},b=function(){return t.createElement("svg",{width:"21",height:"15",viewBox:"0 0 21 15",fill:"none",xmlns:"http://www.w3.org/2000/svg"},t.createElement("path",{d:"M14.1364 14.9851C13.5909 14.9851 13.2273 14.5851 13.2273 13.9851C13.2273 13.3851 13.5909 12.9851 14.1364 12.9851C16.6818 12.9851 18.6818 10.7851 18.6818 7.98508C18.6818 5.18508 16.6818 2.98508 14.1364 2.98508C11.5909 2.98508 9.59091 5.18508 9.59091 7.98508C9.59091 8.58508 9.22727 8.98508 8.68182 8.98508C8.13636 8.98508 7.77273 8.58508 7.77273 7.98508C7.77273 4.08508 10.5909 0.985077 14.1364 0.985077C17.6818 0.985077 20.5 4.08508 20.5 7.98508C20.5 11.8851 17.6818 14.9851 14.1364 14.9851ZM6.68182 14.7851C3.22727 14.7851 0.5 11.6851 0.5 7.98508C0.5 4.28508 3.22727 1.18508 6.68182 1.18508C7.22727 1.18508 7.59091 1.58508 7.59091 2.18508C7.59091 2.78508 7.22727 3.18508 6.68182 3.18508C4.22727 3.18508 2.31818 5.38508 2.31818 7.98508C2.31818 10.5851 4.22727 12.7851 6.68182 12.7851C9.13636 12.7851 11.0455 10.6851 11.0455 7.98508C11.0455 7.38508 11.4091 6.98508 11.9545 6.98508C12.5 6.98508 12.8636 7.38508 12.8636 7.98508C12.7727 11.6851 10.0455 14.7851 6.68182 14.7851Z",fill:"white"}))},y=function(){return t.createElement("svg",{width:"400",height:"300",viewBox:"0 0 467 300",fill:"none",xmlns:"http://www.w3.org/2000/svg"},t.createElement("path",{d:"M312.387 280.629C312.549 280.583 312.247 280.735 312.387 280.629L339.678 260.425C340.088 260.118 340.132 259.156 340.07 258.647C340.008 258.138 339.573 258.257 339.106 258.084L311.712 247.455C311.292 247.301 311.308 247.402 310.939 247.673C310.569 247.944 310.356 248.21 310.356 248.672L310.459 279.504C310.461 280.025 311.163 280.619 311.614 280.847C311.913 280.996 312.072 280.718 312.387 280.629ZM336.204 259.736L312.979 276.292L313.439 251.139L336.204 259.736Z",fill:"url(#paint0_linear_1356_14057)"}),t.createElement("path",{d:"M324.639 260.342C324.358 259.547 323.485 258.91 322.707 259.215C319.6 260.432 318.17 262.313 317.287 264.066C316.482 265.665 316.197 267.482 314.188 268.269C312.178 269.055 310.763 268.663 309.162 268.007C307.406 267.287 305.504 266.182 302.397 267.399C299.289 268.616 297.859 270.497 296.976 272.25C296.171 273.849 295.697 274.886 293.685 275.673C291.675 276.459 290.261 276.067 288.659 275.411C286.903 274.691 284.999 273.587 281.894 274.803C278.789 276.019 277.549 278.681 276.666 280.434C275.861 282.034 275.386 283.07 273.374 283.857C272.596 284.161 271.931 285.055 272.211 285.849C272.492 286.644 273.365 287.281 274.143 286.977C277.25 285.76 278.68 283.879 279.563 282.125C280.368 280.526 280.65 278.71 282.662 277.923C284.672 277.136 286.087 277.528 287.688 278.184C289.444 278.904 291.348 280.009 294.453 278.793C297.561 277.576 298.991 275.695 299.874 273.941C300.679 272.342 301.153 271.306 303.165 270.519C305.175 269.732 306.589 270.124 308.191 270.78C309.947 271.5 311.849 272.605 314.956 271.388C318.063 270.172 319.301 267.511 320.184 265.757C320.989 264.158 321.466 263.121 323.476 262.335C324.254 262.032 324.919 261.137 324.639 260.342Z",fill:"url(#paint1_linear_1356_14057)"}),t.createElement("path",{d:"M389.034 111.124C388.968 112.406 387.342 113.113 386.324 113.549C384.297 114.419 382.089 114.493 379.942 114.5C376.607 114.509 373.215 114.163 369.89 113.976C366.712 113.798 363.156 113.311 360.03 114.232C357.705 114.919 355.667 116.762 353.452 117.739C351.129 118.765 348.957 119.198 346.489 119.687C335.569 121.85 323.587 120.825 312.656 119.977C311.92 119.92 312.539 118.997 313.237 118.981C313.207 118.815 313.001 118.394 313.045 118.201C313.086 118.029 312.781 117.586 312.853 117.421C312.67 117.198 313.316 117.427 313.626 117.204C315.912 115.557 318.721 114.79 321.363 115.041C324.677 115.355 327.293 116.04 330.641 115.781C334.392 115.491 338.125 114.787 341.857 114.312C345.142 113.892 349.09 113.941 352.106 112.28C352.916 111.834 353.137 111.262 353.269 110.287C353.331 109.828 353.672 108.969 353.658 108.511C353.629 107.529 354.191 107.886 355.013 107.298C356.857 105.981 358.274 105.516 360.428 105.784C362.841 106.083 365.264 107.273 367.578 107.953C370.761 108.888 374.328 108.646 377.631 108.477C380.517 108.329 383.141 107.901 385.944 108.653C387.013 108.941 389.104 109.745 389.034 111.124Z",fill:"url(#paint2_linear_1356_14057)"}),t.createElement("path",{d:"M278.118 85.4414C280.313 83.8186 283.302 83.9 285.853 83.2728C290.501 82.127 295.644 78.4476 300.549 79.1524C301.299 79.2595 300.904 81.0355 300.159 80.9295C300.131 80.9256 300.187 80.9333 300.159 80.9295C300.089 81.0185 299.516 81.1051 299.385 81.1463C294.999 82.515 292.895 87.5083 289.126 89.8598C287.799 90.688 286.771 90.8351 285.258 90.9441C283.515 91.0691 280.964 90.5775 279.269 90.1219C277.15 89.5532 275.965 87.034 278.118 85.4414Z",fill:"url(#paint3_linear_1356_14057)"}),t.createElement("path",{d:"M122.567 166.093C113.597 172.832 104.535 179.836 99.517 190.092C98.5342 192.099 97.519 195.019 97.9533 197.204C98.9699 202.316 105.76 203.049 110.691 201.96C113.468 201.347 116.325 199.231 115.921 196.319C115.576 193.81 113.158 192.986 112.072 190.73C110.779 188.04 112.35 184.97 114.218 182.62C128.134 165.099 150.074 157.394 171.093 151.607C175.385 150.425 180.897 147.69 180.581 143.099C180.372 140.072 177.118 137.683 174.221 137.383C171.324 137.082 168.481 138.773 165.715 139.776C158.416 142.419 151.17 143.799 143.489 143.526C136.865 143.29 130.976 143.316 129.562 150.781C128.138 158.276 129.53 160.863 122.567 166.093Z",fill:"url(#paint4_linear_1356_14057)"}),t.createElement("path",{d:"M79.1056 153.531C60.3932 164.378 43.7478 178.354 32.8214 197.415C30.3313 201.76 27.9216 206.554 27.1821 211.512C26.4448 216.47 27.7591 222.525 30.8133 226.337C34.908 231.446 41.6938 232.915 48.1811 233.125C50.7248 233.208 53.0035 233.066 55.3316 231.947C57.6602 230.83 59.7548 228.359 59.5978 225.742C59.3303 221.315 54.5491 219.665 50.9271 217.34C42.6566 212.037 40.4958 199.493 44.2381 190.032C47.9803 180.57 55.8228 173.173 63.2316 166.338C67.229 162.651 71.5194 158.372 76.777 157.522C79.9167 157.015 83.4706 157.589 86.6295 157.252C93.9004 156.479 99.64 151.404 105.588 146.912C115.048 139.765 126.045 134.283 137.501 132.093C141.913 131.248 146.293 130.493 149.682 127.831C151.37 126.507 150.803 123.567 148.726 123.93C138.542 125.713 128.652 131.135 119.142 134.758C105.627 139.914 91.7133 146.223 79.1056 153.531Z",fill:"url(#paint5_linear_1356_14057)"}),t.createElement("path",{d:"M96.3677 117.321C96.0315 116.64 95.2914 116.612 94.6293 116.975C91.9858 118.417 91.5452 120.509 90.9466 122.178C90.4004 123.702 89.3647 124.67 87.6542 125.604C85.9437 126.538 85.0983 126.316 83.5956 125.91C81.9481 125.465 79.8603 125.424 77.2168 126.866C74.5734 128.309 74.1348 130.401 73.5341 132.07C72.9879 133.593 71.9522 134.562 70.2417 135.496C68.5313 136.43 67.6859 136.208 66.1832 135.801C64.5357 135.357 62.2569 134.538 59.6128 135.978C56.9694 137.42 56.5308 139.512 55.9301 141.181C55.3839 142.705 54.5398 144.454 52.8293 145.388C52.1667 145.748 52.1006 146.485 52.439 147.165C52.7752 147.845 53.5153 147.874 54.1773 147.511C56.8208 146.069 57.2594 143.977 57.86 142.307C58.4062 140.784 59.4419 139.815 61.1524 138.881C62.8629 137.948 63.7083 138.17 65.211 138.576C66.8585 139.021 68.9458 139.059 71.5898 137.619C74.2333 136.177 74.6718 134.085 75.2725 132.416C75.8187 130.892 76.8544 129.924 78.5649 128.99C80.2754 128.056 81.1207 128.278 82.6235 128.684C84.2709 129.129 86.5503 129.95 89.1938 128.507C91.8373 127.065 92.2779 124.973 92.8765 123.304C93.4227 121.78 94.2663 120.03 95.9773 119.098C96.6378 118.738 96.7039 118.001 96.3677 117.321Z",fill:"#FBC49D"}),t.createElement("path",{d:"M391.827 164.699C392.04 164.639 392.39 164.573 392.6 164.481C393.87 163.921 395.363 162.429 395.893 161.051C396.421 159.673 396.237 158.321 395.712 156.931C394.629 154.061 391.777 152.62 389.155 153.775C386.531 154.931 384.962 158.455 386.042 161.325C387.038 163.963 389.369 165.392 391.827 164.699ZM394.166 157.367C394.529 158.332 394.52 159.751 394.156 160.706C393.792 161.662 393.1 162.534 392.218 162.921C390.398 163.723 388.338 162.878 387.589 160.889C387.226 159.925 387.234 158.506 387.599 157.55C387.963 156.594 388.654 155.723 389.536 155.336C391.356 154.534 393.416 155.376 394.166 157.367Z",fill:"#86E29B"}),t.createElement("path",{d:"M62.7198 108.691C64.4912 108.191 66.6152 106.609 67.5596 104.824C68.4273 103.187 68.465 101.455 67.9609 99.7066C67.4547 97.9586 66.0792 96.5141 64.4963 95.6786C62.9135 94.843 61.2077 94.8578 59.4756 95.4255C57.7435 95.9933 56.2768 97.4364 55.409 99.074C53.6185 102.456 55.2032 106.494 58.4723 108.22C60.0142 109.035 61.1315 109.138 62.7198 108.691ZM60.6304 96.7682C61.819 96.4332 63.0232 96.8871 64.1048 97.4571C65.2463 98.0603 66.0495 98.8796 66.4145 100.142C66.7791 101.403 66.4488 103.299 65.8224 104.48C64.5299 106.919 61.2212 107.686 58.8638 106.441C56.5063 105.197 55.8538 101.858 57.1462 99.4185C57.7726 98.2375 58.6059 97.3957 59.8573 96.9862C59.9214 96.9635 60.5631 96.7872 60.6304 96.7682Z",fill:"#FFB0EB"}),t.createElement("path",{d:"M77.0217 242.979C75.9542 243.28 75.1664 242.151 74.9029 241.074C74.6394 239.996 75 239.378 76.0676 239.077C77.1351 238.776 78.5053 238.907 78.7688 239.984C79.0323 241.061 78.0893 242.678 77.0217 242.979Z",fill:"url(#paint6_linear_1356_14057)"}),t.createElement("path",{d:"M380.506 184.577C379.439 184.878 378.651 183.749 378.387 182.672C378.124 181.594 378.484 180.976 379.552 180.675C380.619 180.374 381.99 180.505 382.253 181.582C382.517 182.659 381.574 184.276 380.506 184.577Z",fill:"url(#paint7_linear_1356_14057)"}),t.createElement("path",{d:"M348.82 246.969C347.752 247.27 346.382 247.14 346.119 246.063C345.855 244.985 346.798 243.369 347.866 243.068C348.933 242.767 349.721 243.896 349.985 244.973C350.248 246.05 349.888 246.669 348.82 246.969Z",fill:"url(#paint8_linear_1356_14057)"}),t.createElement("path",{d:"M140.419 282.412C139.351 282.713 138.754 282.365 138.491 281.288C138.227 280.21 138.397 278.812 139.464 278.511C140.532 278.21 142.093 279.121 142.357 280.198C142.62 281.275 141.486 282.111 140.419 282.412Z",fill:"url(#paint9_linear_1356_14057)"}),t.createElement("path",{d:"M121.462 101.679C120.395 101.979 119.798 101.631 119.534 100.554C119.271 99.4764 119.44 98.0779 120.508 97.777C121.575 97.4761 123.136 98.3868 123.4 99.4642C123.663 100.542 122.53 101.378 121.462 101.679Z",fill:"url(#paint10_linear_1356_14057)"}),t.createElement("path",{d:"M370.749 159.005C369.682 159.306 368.311 159.175 368.048 158.098C367.784 157.021 368.727 155.404 369.795 155.103C370.863 154.802 371.65 155.931 371.914 157.008C372.177 158.086 371.817 158.704 370.749 159.005Z",fill:"url(#paint11_linear_1356_14057)"}),t.createElement("path",{d:"M384.211 245.345C383.143 245.646 381.773 245.515 381.51 244.438C381.246 243.361 382.189 241.744 383.257 241.443C384.324 241.142 385.112 242.271 385.376 243.348C385.639 244.426 385.278 245.044 384.211 245.345Z",fill:"url(#paint12_linear_1356_14057)"}),t.createElement("path",{d:"M364.771 41.3873C363.063 41.8687 361.337 40.8616 360.915 39.1378C360.493 37.414 361.536 35.6263 363.244 35.1449C364.953 34.6634 366.679 35.6706 367.101 37.3944C367.522 39.1182 366.479 40.9059 364.771 41.3873Z",fill:"url(#paint13_linear_1356_14057)"}),t.createElement("path",{d:"M404.311 77.905C404.602 77.8231 404.875 77.9236 405.084 77.6871C405.437 77.2908 404.814 76.6385 404.703 76.1265L401.277 58.7418C401.149 58.163 400.687 57.5371 400.123 57.3991C399.558 57.2611 398.969 57.3812 398.576 57.835L385.784 73.1179C385.395 73.564 385.199 74.3453 385.393 74.8964C385.585 75.4481 385.978 76.1646 386.548 76.2391L403.538 78.123C403.744 78.1479 404.114 77.9607 404.311 77.905ZM398.948 62.7348L401.811 74.4394L389.841 72.8085L398.948 62.7348Z",fill:"#FFB0EB"}),t.createElement("path",{d:"M97.5393 295.311C97.7108 295.263 97.4284 295.461 97.5393 295.311L108.785 280.464C108.975 280.211 108.718 279.972 108.594 279.684C108.47 279.396 108.124 279.917 107.821 279.902L88.5106 278.672C88.2101 278.659 87.895 278.62 87.7374 278.89C87.5798 279.159 87.7755 279.402 87.9283 279.67L96.5753 294.749C96.7102 294.99 97.2696 295.297 97.5393 295.311C97.6283 295.319 97.4556 295.335 97.5393 295.311ZM106.465 281.118L96.9667 292.97L90.6295 280.577L106.465 281.118Z",fill:"#86E29B"}),t.createElement("path",{d:"M393.699 108.848C389.518 104.446 414.629 114.366 413.945 120.659C413.259 126.952 401.355 129.102 403.894 123.491C406.042 118.747 400.376 115.876 393.699 108.848Z",fill:"#FBC49D"}),t.createElement("path",{d:"M139.414 115.959C139.434 115.953 139.392 115.965 139.414 115.959C141.963 115.2 143.436 111.976 142.717 109.189C142.37 107.839 141.526 107.199 140.408 106.504C139.289 105.808 138.171 105.449 136.933 105.815C135.698 106.182 134.85 107.033 134.222 108.247C133.595 109.461 133.282 111.234 133.63 112.585C133.978 113.935 134.821 114.574 135.94 115.27C137.04 115.952 138.199 116.301 139.414 115.959ZM137.315 107.375C138.222 107.12 139.005 106.994 139.825 107.502C140.661 108.02 140.912 108.618 141.171 109.625C141.708 111.704 140.935 113.834 139.032 114.398C138.11 114.675 137.356 114.791 136.522 114.272C135.686 113.753 135.436 113.155 135.176 112.149C134.917 111.142 134.718 109.714 135.186 108.81C135.654 107.905 136.394 107.649 137.315 107.375C137.329 107.371 137.299 107.38 137.315 107.375Z",fill:"#75C4FD"}),t.createElement("path",{d:"M308.981 78.7519C310.052 78.4043 311.158 78.7096 312.265 78.6613C313.655 78.6006 314.936 78.517 316.323 78.3531C319.497 77.9795 322.798 77.4906 325.984 77.3012C329.309 77.1025 332.514 76.8551 335.836 77.0295C338.809 77.1842 342.163 77.3405 345.105 77.7558C352.129 78.7468 359.331 79.0578 366.347 80.1158C372.252 81.008 377.93 82.1319 383.722 83.5644C385.925 84.0054 388.267 85.0754 389.126 85.3792C389.421 85.4833 389.37 85.8347 389.317 86.1595C389.306 86.2271 389.353 86.1146 389.317 86.1595C388.269 87.414 386.564 86.8124 385.259 86.4677C384.406 86.241 381.488 85.9494 381.011 85.9957C380.14 86.0815 379.277 86.014 379.656 87.2114C380.122 88.6824 382.391 89.7375 383.704 90.2419C385.883 91.0803 388.771 91.2561 390.845 92.4015C392.968 92.821 395.425 93.5002 397.022 93.9986C402.83 95.8103 407.806 98.8678 413.033 102.002C415.503 103.482 417.829 104.764 419.973 106.72C421.647 108.248 423.771 109.882 424.595 112.091C425.113 113.482 424.451 115.471 422.848 115.085C420.353 114.488 419.638 111.665 418.227 109.714C415.003 105.251 410.067 102.067 405.118 100.06C402.64 99.0556 399.803 98.729 397.204 98.1176C394.411 97.4613 391.597 97.0442 388.707 97.1736C385.646 97.3097 382.846 97.5534 379.819 98.0078C377.027 98.4264 374.252 98.4441 371.514 97.8441C368.766 97.2421 366.276 96.7553 363.6 95.9021C361.662 95.2848 359.013 94.5583 357.232 93.5247C355.699 92.6339 355.631 91.2381 357.241 90.186C359.87 88.4656 362.778 89.8021 365.546 90.3497C365.561 90.3527 365.532 90.3468 365.546 90.3497C367.858 90.804 369.649 90.098 371.923 89.3884C372.489 89.2128 373.255 89.0482 373.47 88.953C374.383 88.5432 375.895 87.8227 375.407 86.7394C374.868 85.5457 372.659 84.8846 371.55 84.4891C369.74 83.8428 368.053 82.9215 366.147 82.6743C365.654 82.6095 365.109 83.1606 364.6 83.1097C363.36 83.1121 361.769 83.348 360.543 83.418C357.43 83.5916 354.583 83.6228 351.464 83.4719C348.714 83.3377 346.432 82.8542 343.741 82.3102C340.773 81.7101 337.52 81.5879 334.471 81.5839C331.393 81.5811 328.6 81.7214 325.583 82.4181C322.758 83.0702 319.757 83.6198 316.887 84.0326C314.698 84.3481 312.467 84.6054 310.319 84.2137C309.079 83.9871 306.994 83.3394 306.461 81.9635C305.846 80.3659 307.736 79.1556 308.981 78.7519Z",fill:"url(#paint14_linear_1356_14057)"}),t.createElement("path",{d:"M242.269 242.95C242.295 242.947 242.244 242.955 242.269 242.95C244.934 242.606 247.53 241.858 250.2 241.574C253.133 241.264 256.006 240.56 258.906 239.982C263.26 239.117 268.026 238.52 272.254 237.097C274.429 236.365 276.067 235.298 278.251 234.592C280.361 233.909 283.058 233.12 285.216 232.652C289.317 231.764 293.049 231.66 297.016 230.198C301.109 228.69 305.088 226.673 308.819 224.409C312.645 222.086 316.282 219.769 320.622 218.62C322.381 218.154 323.919 218.219 325.65 218.886C327.016 219.413 327.739 220.337 327.196 221.79C326.557 223.504 324.659 224.7 323.131 225.423C320.854 226.5 319.53 227.184 317.134 227.927C314.619 228.707 311.888 229.24 309.395 230.083C308.226 230.947 307.17 232.522 306.105 233.501C303.996 235.441 301.666 237.03 298.945 237.996C292.934 240.129 286.354 238.602 280.183 239.056C279.661 239.095 279.162 239.442 278.635 239.487C275.592 240.135 272.2 240.63 269.156 241.294C264.546 242.299 260.456 243.409 255.808 244.179C251.971 244.814 243.815 245.854 243.815 245.854L242.074 245.505C240.575 245.281 240.751 243.152 242.269 242.95Z",fill:"url(#paint15_linear_1356_14057)"}),t.createElement("path",{d:"M432.985 171.626C438.212 165.465 445.109 153.64 442.906 144.649C442.162 137.999 433.671 132.912 424.963 135.518C420.16 136.957 416.435 142.146 419.724 144.498C420.656 145.164 422.187 145.591 423.391 145.969C434.204 149.375 434.925 162.538 425.069 169.683C421.087 172.569 416.347 174.292 411.914 176.719C400.151 183.162 399.887 196.847 387.7 202.712C382.326 205.298 375.761 206.838 370.297 209.275C359.98 213.88 352.555 221.733 342.241 226.341C337.225 228.584 330.266 231.632 323.483 234.12C321.475 234.855 321.999 237.058 324.056 236.46C324.098 236.449 324.017 236.474 324.056 236.46C329.079 234.971 334.437 233.161 339.331 231.33C352.278 226.48 365.28 220.971 377.43 214.775C401.78 202.367 416.881 190.609 432.985 171.626Z",fill:"url(#paint16_linear_1356_14057)"}),t.createElement("path",{d:"M343.644 241.104C348.002 234.144 357.126 232.455 364.343 231.134C368.176 230.431 372.406 229.878 376.137 228.662C380.691 227.175 384.558 224.095 388.327 221.077C389.452 220.177 391.204 218.466 392.393 217.436C393.185 216.748 393.644 216.026 394.33 215.225C396 213.275 399.599 209.812 401.687 208.16C403.263 206.914 407.779 204.758 408.259 207.986C408.611 210.359 406.379 213.087 404.961 214.747C402.224 217.953 398.998 221.079 395.475 223.243C391.749 225.531 387.701 227.439 383.674 229.051C381.672 229.853 379.519 230.073 377.486 230.785C376.001 231.307 374.486 232.236 373.037 232.866C371.034 233.738 368.99 234.28 367.041 235.38C364.436 236.849 361.782 238.783 359.108 240.105C356.331 241.477 353.823 242.691 350.791 243.27C348.6 243.687 345.501 243.641 343.836 241.884C343.526 241.554 343.389 241.51 343.644 241.104Z",fill:"url(#paint17_linear_1356_14057)"}),t.createElement("path",{d:"M190.163 273.219C222.905 268.849 232.64 262.943 213.962 259.057C195.285 255.172 187.5 262.08 188.434 266.2C189.366 270.32 180.381 271.326 169.286 272.39C158.193 273.454 157.141 276.354 190.163 273.219Z",fill:"url(#paint18_linear_1356_14057)"}),t.createElement("path",{d:"M295.952 95.4242L241.395 135.226L251.54 111.77L295.952 95.4242Z",fill:"#E17726",stroke:"#E17726",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M170.111 95.4242L224.181 135.598L214.522 111.77L170.111 95.4242Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M276.309 187.712L261.793 209.576L292.876 218.014L301.78 188.189L276.309 187.712Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M164.336 188.189L173.186 218.014L204.215 209.576L189.753 187.712L164.336 188.189Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M202.542 150.776L193.908 163.618L224.667 164.998L223.642 132.36L202.542 150.776Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M263.52 150.775L242.097 131.989L241.395 164.998L272.154 163.618L263.52 150.775Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M204.215 209.576L222.832 200.714L206.805 188.402L204.215 209.576Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M243.23 200.714L261.793 209.576L259.257 188.402L243.23 200.714Z",fill:"#E27625",stroke:"#E27625",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M261.793 209.576L243.23 200.714L244.741 212.601L244.579 217.643L261.793 209.576Z",fill:"#D5BFB2",stroke:"#D5BFB2",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M204.215 209.576L221.483 217.643L221.375 212.601L222.832 200.714L204.215 209.576Z",fill:"#D5BFB2",stroke:"#D5BFB2",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M221.807 180.547L206.373 176.09L217.274 171.154L221.807 180.547Z",fill:"#233447",stroke:"#233447",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M244.255 180.547L248.788 171.154L259.742 176.09L244.255 180.547Z",fill:"#233447",stroke:"#233447",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M204.215 209.576L206.913 187.712L189.753 188.189L204.215 209.576Z",fill:"#CC6228",stroke:"#CC6228",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M259.149 187.712L261.793 209.576L276.309 188.189L259.149 187.712Z",fill:"#CC6228",stroke:"#CC6228",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M272.154 163.618L241.395 164.998L244.255 180.547L248.788 171.154L259.742 176.09L272.154 163.618Z",fill:"#CC6228",stroke:"#CC6228",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M206.373 176.09L217.274 171.154L221.807 180.547L224.667 164.998L193.908 163.618L206.373 176.09Z",fill:"#CC6228",stroke:"#CC6228",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M193.908 163.618L206.805 188.402L206.373 176.09L193.908 163.618Z",fill:"#E27525",stroke:"#E27525",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M259.743 176.09L259.257 188.402L272.154 163.618L259.743 176.09Z",fill:"#E27525",stroke:"#E27525",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M224.667 164.998L221.807 180.548L225.422 198.909L226.232 174.71L224.667 164.998Z",fill:"#E27525",stroke:"#E27525",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M241.395 164.998L239.884 174.657L240.64 198.909L244.255 180.548L241.395 164.998Z",fill:"#E27525",stroke:"#E27525",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M244.255 180.547L240.64 198.909L243.23 200.714L259.257 188.402L259.743 176.09L244.255 180.547Z",fill:"#F5841F",stroke:"#F5841F",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M206.373 176.09L206.805 188.402L222.832 200.714L225.422 198.909L221.807 180.547L206.373 176.09Z",fill:"#F5841F",stroke:"#F5841F",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M244.579 217.643L244.741 212.601L243.338 211.434H222.724L221.375 212.601L221.483 217.643L204.215 209.576L210.259 214.459L222.508 222.791H243.5L255.803 214.459L261.793 209.576L244.579 217.643Z",fill:"#C0AC9D",stroke:"#C0AC9D",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M243.23 200.714L240.64 198.909H225.422L222.832 200.714L221.375 212.601L222.724 211.434H243.338L244.741 212.601L243.23 200.714Z",fill:"#161616",stroke:"#161616",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M298.272 137.827L302.859 115.856L295.952 95.4242L243.23 133.899L263.52 150.775L292.174 159.001L298.488 151.731L295.736 149.767L300.107 145.84L296.761 143.293L301.132 140.002L298.272 137.827Z",fill:"#763E1A",stroke:"#763E1A",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M163.203 115.856L167.844 137.827L164.876 140.002L169.301 143.293L165.955 145.84L170.326 149.767L167.574 151.731L173.888 159.001L202.542 150.775L222.832 133.899L170.11 95.4242L163.203 115.856Z",fill:"#763E1A",stroke:"#763E1A",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M292.175 159.001L263.52 150.775L272.154 163.618L259.257 188.402L276.309 188.189H301.78L292.175 159.001Z",fill:"#F5841F",stroke:"#F5841F",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M202.542 150.775L173.888 159.001L164.336 188.189H189.753L206.805 188.402L193.908 163.618L202.542 150.775Z",fill:"#F5841F",stroke:"#F5841F",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("path",{d:"M241.395 164.998L243.23 133.9L251.54 111.77H214.522L222.832 133.9L224.667 164.998L225.368 174.763L225.422 198.909H240.64L240.694 174.763L241.395 164.998Z",fill:"#F5841F",stroke:"#F5841F",strokeWidth:"0.94513",strokeLinecap:"round",strokeLinejoin:"round"}),t.createElement("defs",null,t.createElement("linearGradient",{id:"paint0_linear_1356_14057",x1:"335.991",y1:"250.487",x2:"303.873",y2:"266.801",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#FFE466"}),t.createElement("stop",{offset:"1",stopColor:"#FFAFEA"})),t.createElement("linearGradient",{id:"paint1_linear_1356_14057",x1:"276.993",y1:"303.722",x2:"205.254",y2:"401.574",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#75C3FC"}),t.createElement("stop",{offset:"0.0929",stopColor:"#81C2F6"}),t.createElement("stop",{offset:"1",stopColor:"#F0B8BD"})),t.createElement("linearGradient",{id:"paint2_linear_1356_14057",x1:"271.074",y1:"119.924",x2:"553.077",y2:"104.53",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#FFE466"}),t.createElement("stop",{offset:"1",stopColor:"#FFAFEA"})),t.createElement("linearGradient",{id:"paint3_linear_1356_14057",x1:"264.209",y1:"91.0943",x2:"357.834",y2:"72.8792",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#FFE466"}),t.createElement("stop",{offset:"1",stopColor:"#FFAFEA"})),t.createElement("linearGradient",{id:"paint4_linear_1356_14057",x1:"212.46",y1:"121.997",x2:"92.6119",y2:"183.406",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#FFE466"}),t.createElement("stop",{offset:"1",stopColor:"#FFAFEA"})),t.createElement("linearGradient",{id:"paint5_linear_1356_14057",x1:"23.0498",y1:"204.411",x2:"161.86",y2:"163.003",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#75C3FC"}),t.createElement("stop",{offset:"0.0929",stopColor:"#81C2F6"}),t.createElement("stop",{offset:"1",stopColor:"#F0B8BD"})),t.createElement("linearGradient",{id:"paint6_linear_1356_14057",x1:"78.8647",y1:"240.375",x2:"74.9655",y2:"241.328",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#75C3FC"}),t.createElement("stop",{offset:"1",stopColor:"#75C3FC"})),t.createElement("linearGradient",{id:"paint7_linear_1356_14057",x1:"382.349",y1:"181.971",x2:"378.45",y2:"182.925",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#75C3FC"}),t.createElement("stop",{offset:"1",stopColor:"#75C3FC"})),t.createElement("linearGradient",{id:"paint8_linear_1356_14057",x1:"349.889",y1:"244.583",x2:"345.99",y2:"245.537",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#75C3FC"}),t.createElement("stop",{offset:"1",stopColor:"#75C3FC"})),t.createElement("linearGradient",{id:"paint9_linear_1356_14057",x1:"142.262",y1:"279.808",x2:"138.362",y2:"280.762",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#75C3FC"}),t.createElement("stop",{offset:"1",stopColor:"#75C3FC"})),t.createElement("linearGradient",{id:"paint10_linear_1356_14057",x1:"123.305",y1:"99.0746",x2:"119.406",y2:"100.028",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#75C3FC"}),t.createElement("stop",{offset:"1",stopColor:"#75C3FC"})),t.createElement("linearGradient",{id:"paint11_linear_1356_14057",x1:"371.818",y1:"156.617",x2:"367.919",y2:"157.571",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#75C3FC"}),t.createElement("stop",{offset:"1",stopColor:"#75C3FC"})),t.createElement("linearGradient",{id:"paint12_linear_1356_14057",x1:"385.281",y1:"242.958",x2:"381.382",y2:"243.911",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#75C3FC"}),t.createElement("stop",{offset:"1",stopColor:"#75C3FC"})),t.createElement("linearGradient",{id:"paint13_linear_1356_14057",x1:"367.125",y1:"37.5052",x2:"360.843",y2:"38.8076",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#75C3FC"}),t.createElement("stop",{offset:"1",stopColor:"#75C3FC"})),t.createElement("linearGradient",{id:"paint14_linear_1356_14057",x1:"300.182",y1:"91.321",x2:"479.464",y2:"104.041",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#FFE466"}),t.createElement("stop",{offset:"1",stopColor:"#FFAFEA"})),t.createElement("linearGradient",{id:"paint15_linear_1356_14057",x1:"363.434",y1:"201.232",x2:"102.977",y2:"302.269",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#FFE466"}),t.createElement("stop",{offset:"1",stopColor:"#FFAFEA"})),t.createElement("linearGradient",{id:"paint16_linear_1356_14057",x1:"447.962",y1:"165.159",x2:"313.049",y2:"197.95",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#75C3FC"}),t.createElement("stop",{offset:"0.0929",stopColor:"#81C2F6"}),t.createElement("stop",{offset:"1",stopColor:"#F0B8BD"})),t.createElement("linearGradient",{id:"paint17_linear_1356_14057",x1:"410.211",y1:"215.859",x2:"341.378",y2:"232.788",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#75C3FC"}),t.createElement("stop",{offset:"0.0929",stopColor:"#81C2F6"}),t.createElement("stop",{offset:"1",stopColor:"#F0B8BD"})),t.createElement("linearGradient",{id:"paint18_linear_1356_14057",x1:"222.282",y1:"258.986",x2:"162.257",y2:"273.774",gradientUnits:"userSpaceOnUse"},t.createElement("stop",{stopColor:"#FFE466"}),t.createElement("stop",{offset:"1",stopColor:"#FFAFEA"}))))},w=function(e){var n=t.useState(2),r=n[0],o=n[1],u=e.sdkVersion,c=e.i18nInstance.t;return t.createElement(a,{className:"select-modal"},t.createElement("div",{style:s.backdrop,onClick:function(){return e.onClose(true)}}),t.createElement("div",{style:s.modal},t.createElement("div",{style:s.closeButtonContainer},t.createElement("div",{style:s.right},t.createElement("span",{style:s.closeButton,onClick:function(){return e.onClose(true)}},t.createElement(l,null)))),t.createElement("div",{style:s.logoContainer},t.createElement(h,null)),t.createElement("div",null,t.createElement("div",{style:s.tabcontainer},t.createElement("div",{style:s.flexContainer},t.createElement("div",{onClick:function(){return o(1)},style:i(i(i({},s.tab),1===r?s.tabactive:{}),s.flexItem)},c("DESKTOP")),t.createElement("div",{onClick:function(){return o(2)},style:i(i(i({},s.tab),2===r?s.tabactive:{}),s.flexItem)},c("MOBILE")))),t.createElement("div",{style:{display:1===r?"none":"block"}},t.createElement("div",{style:s.flexContainer},t.createElement("div",{style:i({textAlign:"center",marginTop:4},s.flexItem)},t.createElement("div",{id:"sdk-qrcode-container",style:s.center}),t.createElement("div",{style:s.connectMobileText},c("SCAN_TO_CONNECT"),t.createElement("br",null),t.createElement("span",{style:s.blue},t.createElement("b",null,c("META_MASK_MOBILE_APP"))))))),t.createElement("div",{style:{display:2===r?"none":"block"}},t.createElement("div",{style:{display:"flex",justifyContent:"center",height:300,marginTop:-20}},t.createElement(y,null)),t.createElement("div",{style:s.extensionLabel},c("SELECT_MODAL.CRYPTO_TAKE_CONTROL_TEXT")),t.createElement("button",{style:s.button,onClick:e.connectWithExtension},t.createElement(b,null),t.createElement("span",{style:s.installExtensionText},c("CONNECT_WITH_EXTENSION"))))),t.createElement(m,{version:u})))},_=function(){function e(e){var t=e.debug,n=e.sdkVersion,i=this;this.debug=false,this.updateOTPValue=function(e){i.debug&&console.debug("ModalLoader: updateOTPValue",e),setTimeout((function(){var t;i.debug&&console.debug("ModalLoader: updateOTPValue: delayed otp update"),t=document.getElementById("sdk-mm-otp-value"),i.debug&&console.debug("ModalLoader: updateOTPValue: otpNode",t),t&&(t.textContent=e,t.style.display="block");}),800);},this.updateQRCode=function(e){i.debug&&console.debug("ModalLoader: updateQRCode",e);var t=document.getElementById("sdk-qrcode-container");t&&(t.innerHTML="",new(tP())({width:270,height:270,type:"svg",data:e,image:r,dotsOptions:{color:"black",type:"rounded"},imageOptions:{margin:5},cornersDotOptions:{color:"#f66a07"},qrOptions:{errorCorrectionLevel:"M"}}).append(t));},this.debug=null!=t&&t,this.sdkVersion=n;}return e.prototype.renderInstallModal=function(e){this.debug&&console.debug("ModalLoader: renderInstallModal",e),this.installContainer=e.parentElement,n.createRoot(e.parentElement).render(t.createElement(g,{link:e.link,preferDesktop:e.preferDesktop,onClose:e.onClose,sdkVersion:this.sdkVersion,metaMaskInstaller:e.metaMaskInstaller,i18nInstance:e.i18nInstance}));},e.prototype.renderSelectModal=function(e){var r=this;this.debug&&console.debug("ModalLoader: renderSelectModal",e),this.selectContainer=e.parentElement,n.createRoot(e.parentElement).render(t.createElement(w,{link:e.link,sdkVersion:this.sdkVersion,onClose:e.onClose,connectWithExtension:e.connectWithExtension,i18nInstance:e.i18nInstance})),setTimeout((function(){r.updateQRCode(e.link);}),100);},e.prototype.renderPendingModal=function(e){this.debug&&console.debug("ModalLoader: renderPendingModal",e),this.pendingContainer=e.parentElement,n.createRoot(e.parentElement).render(t.createElement(v,{onClose:e.onClose,onDisconnect:e.onDisconnect,sdkVersion:this.sdkVersion,updateOTPValue:e.updateOTPValue,displayOTP:e.displayOTP,i18nInstance:e.i18nInstance}));},e.prototype.unmount=function(){var e,t,n,r,i,o;null===(t=null===(e=this.pendingContainer)||void 0===e?void 0:e.parentNode)||void 0===t||t.removeChild(this.pendingContainer),this.pendingContainer=void 0,null===(r=null===(n=this.installContainer)||void 0===n?void 0:n.parentNode)||void 0===r||r.removeChild(this.installContainer),this.installContainer=void 0,null===(o=null===(i=this.selectContainer)||void 0===i?void 0:i.parentNode)||void 0===o||o.removeChild(this.selectContainer),this.selectContainer=void 0;},e}();e.ModalLoader=_;}(t,IT(),JT());}(0,MT.exports);var nP=MT.exports;const rP=({link:e,debug:t,installer:n,terminate:r,connectWithExtension:i,preferDesktop:o,i18nInstance:a})=>{let s=null,u=null;xx("[UI: InstallModal-web: sdkWebInstallModal()] ################## Installing Modal #################"),xx(`[UI: InstallModal-web: sdkWebInstallModal()] link=${e}`),xx(`[UI: InstallModal-web: sdkWebInstallModal()] npx uri-scheme open "${e}" --ios`),xx(`[UI: InstallModal-web: sdkWebInstallModal()] npx uri-scheme open "${e}" --android`),xx(`[UI: InstallModal-web: sdkWebInstallModal()] adb shell am start -a android.intent.action.VIEW -d "${e}"`);const l=e=>{var t;xx("[UI: InstallModal-web: sdkWebInstallModal()] installModal-web unmounting install modal -- shouldTerminate:",e,u),(null==u?void 0:u.parentNode)&&(null===(t=u.parentNode)||void 0===t||t.removeChild(u)),u=null,s=null,true===e&&(null==r||r());};return {mount:r=>{if(xx("[UI: InstallModal-web: sdkWebInstallModal()] installModal-web mounting install modal",u),u)return u.style.display="block",void(null==s||s.updateQRCode(r));s=new nP.ModalLoader({debug:t,sdkVersion:HA.version}),u=document.createElement("div"),document.body.appendChild(u),window.extension?s.renderSelectModal({i18nInstance:a,parentElement:u,connectWithExtension:()=>{l(),null==i||i();},onClose:l,link:e}):s.renderInstallModal({i18nInstance:a,parentElement:u,preferDesktop:null!=o&&o,link:e,metaMaskInstaller:n,onClose:l});},unmount:l}},iP=({onDisconnect:e,i18nInstance:t,debug:n})=>{let r=null,i=null;const o=()=>{xx("[UI: pendingModal-web: sdkWebPendingModal()] pendingModal-web unmount",r),(null==r?void 0:r.parentNode)&&r.parentNode.removeChild(r),r=null,i=null;},a=e=>{xx("[UI: pendingModal-web: sdkWebPendingModal()] pendingModal-web updateOTPValue",e),i&&i.updateOTPValue(e);},s=({displayOTP:s}={displayOTP:true})=>{xx("[UI: pendingModal-web: sdkWebPendingModal()] pendingModal-web mount",r),r?r.style.display="block":(i=new nP.ModalLoader({debug:n,sdkVersion:HA.version}),r=document.createElement("div"),document.body.appendChild(r),i.renderPendingModal({i18nInstance:t,parentElement:r,onClose:o,onDisconnect:e,updateOTPValue:a,displayOTP:s}));};return s(),{mount:s,unmount:o,updateOTPValue:a}};function oP(e,t){var n,r,i,o;e.connector||(xx("[RemoteConnection: initializeConnector()] initialize connector"),e.connector=new Ek({platformType:t.platformManager.getPlatformType(),communicationLayerPreference:t.communicationLayerPreference,transports:t.transports,dappMetadata:Object.assign(Object.assign({},t.dappMetadata),{source:t._source}),analytics:t.enableAnalytics,communicationServerUrl:t.communicationServerUrl,sdkVersion:HA.version,context:"dapp",ecies:t.ecies,storage:t.storage,logging:t.logging}),t.timer&&(xx("[RemoteConnection: initializeConnector()] reset background timer",t.timer),null===(r=null===(n=t.timer)||void 0===n?void 0:n.stopBackgroundTimer)||void 0===r||r.call(n),null===(o=null===(i=t.timer)||void 0===i?void 0:i.runBackgroundTimer)||void 0===o||o.call(i,(()=>false),1e4)));}function aP(e){e.listeners.forEach((({event:t,handler:n})=>{var r;null===(r=e.connector)||void 0===r||r.off(t,n);})),e.listeners=[];}function sP(t,n,r){return kk(this,void 0,void 0,(function*(){return new Promise(((i,o)=>{if(!t.connector)return void o(new Error("No connector available"));xx("[RemoteConnection: connectWithModalInstaller()]",{state:t,options:n,linkParams:r});const a=`${t.useDeeplink?VA:$A}?${r}`;!function(e,t,n){var r,i,o,a;e.installModal=null===(i=(r=t.modals).install)||void 0===i?void 0:i.call(r,{i18nInstance:t.sdk.i18nInstance,link:n,preferDesktop:e.preferDesktop,installer:t.getMetaMaskInstaller(),terminate:()=>{xx("[RemoteConnection: showInstallModal() => terminate()] terminate connection"),t.sdk.terminate().catch((e=>{console.warn("[MMSDK] failed to terminate connection",e);}));},debug:e.developerMode,connectWithExtension:()=>{var e;return null===(e=t.connectWithExtensionProvider)||void 0===e||e.call(t),false}}),null===(a=null===(o=e.installModal)||void 0===o?void 0:o.mount)||void 0===a||a.call(o,n);}(t,n,a),n.sdk.once(e.EventType.PROVIDER_UPDATE,(t=>kk(this,void 0,void 0,(function*(){if(xx("[RemoteConnection: connectWithModalInstaller()] once provider_update -- resolving startConnection promise"),t!==e.PROVIDER_UPDATE_TYPE.TERMINATE)o(t);else {o({code:4001,message:"User rejected the request."});}})))),t.connector.once(e.EventType.AUTHORIZED,(()=>{i();})),t.connector.once(e.EventType.REJECTED,(()=>{o(e.EventType.REJECTED);})),t.connector.once(e.EventType.CLIENTS_READY,(()=>kk(this,void 0,void 0,(function*(){xx("[RemoteConnection: connectWithModalInstaller()] once clients_ready -- resolving startConnection promise"),i();}))));}))}))}function uP(t,n){function r(e,n){var r;null===(r=t.connector)||void 0===r||r.on(e,n),t.listeners.push({event:e,handler:n});}t.connector&&(aP(t),r(e.EventType.WALLET_INIT,(({accounts:e,chainId:t})=>kk(this,void 0,void 0,(function*(){xx(`[RemoteConnection: setupListeners() => EventType.WALLET_INIT] 'wallet_init' accounts=${e} chainId=${t}`);const n=PR.getProvider();n._setConnected();const r={accounts:e,chainId:t,isUnlocked:false};n._initializeState(r),n.emit("chainChanged",t),n.emit("accountsChanged",e);})))),r(e.EventType.AUTHORIZED,(()=>kk(this,void 0,void 0,(function*(){var e,n,r,i;try{xx("[RemoteConnection: setupListeners() => EventType.AUTHORIZED] 'authorized' closing modals",t.pendingModal,t.installModal);const o=PR.getProvider();o._setConnected(),null===(n=null===(e=t.pendingModal)||void 0===e?void 0:e.unmount)||void 0===n||n.call(e),null===(i=null===(r=t.installModal)||void 0===r?void 0:r.unmount)||void 0===i||i.call(r,!1),t.otpAnswer=void 0,t.authorized=!0,xx("[RemoteConnection: setupListeners() => EventType.AUTHORIZED] 'authorized' provider.state",o.getState()),yield o.forceInitializeState();}catch(e){}})))),r(e.EventType.TERMINATE,(()=>{var e,n,r,i,o,a;(null===(e=t.platformManager)||void 0===e?void 0:e.isBrowser())?alert("SDK Connection has been terminated from MetaMask."):console.info("SDK Connection has been terminated"),null===(r=null===(n=t.pendingModal)||void 0===n?void 0:n.unmount)||void 0===r||r.call(n),null===(o=null===(i=t.installModal)||void 0===i?void 0:i.unmount)||void 0===o||o.call(i,true),t.pendingModal=void 0,t.installModal=void 0,t.otpAnswer=void 0,null===(a=t.connector)||void 0===a||a.disconnect({terminate:true}),t.authorized=false;PR.getProvider().handleDisconnect({terminate:true}),aP(t),xx("[RemoteConnection: setupListeners()] All listeners cleaned up");})));}function lP(t,n,{initialCheck:r,connectWith:i}={}){var o,a,s,u,l,c,d,f,h,p,m,g,v,b,y,w,_,S,E;return kk(this,void 0,void 0,(function*(){try{if(oP(t,n),!t.connector)throw new Error("no connector defined");uP(t);const k=PR.getProvider();t.authorized=!1,k.emit("connecting");const M=yield null===(o=t.connector)||void 0===o?void 0:o.originatorSessionConnect();xx(`[RemoteConnection: startConnection()] after originatorSessionConnect initialCheck=${r}`,M);let C=null!==(a=null==M?void 0:M.channelId)&&void 0!==a?a:"",x=null!==(u=null===(s=t.connector.getKeyInfo())||void 0===s?void 0:s.ecies.public)&&void 0!==u?u:"",A=null!==(c=null===(l=t.connector.getKeyInfo())||void 0===l?void 0:l.ecies.private)&&void 0!==c?c:"";if(r&&!M)return Promise.resolve();if(!M&&!r){const e=yield t.connector.generateChannelIdConnect();C=null!==(d=e.channelId)&&void 0!==d?d:"",x=null!==(f=e.pubKey)&&void 0!==f?f:"",A=null!==(h=e.privKey)&&void 0!==h?h:"";const n=Date.now();null===(p=t.connector.state.storageManager)||void 0===p||p.persistChannelConfig({channelId:C,localKey:A,lastActive:n,validUntil:n+HE});}if(r&&(null==M?void 0:M.channelId))return (null===(m=t.connector)||void 0===m?void 0:m.isConnected())||(xx(`[RemoteConnection: startConnection()] reconnecting to channel initialCheck=${r}`,M),yield null===(g=t.connector)||void 0===g?void 0:g.connectToChannel({channelId:C})),Promise.resolve();M&&!(null===(v=t.connector)||void 0===v?void 0:v.isConnected())&&(xx("[RemoteConnection: startConnection()] reconnecting to channel",M),yield null===(b=t.connector)||void 0===b?void 0:b.connectToChannel({channelId:C}));const R=(null===(y=t.platformManager)||void 0===y?void 0:y.isSecure())?"":"&t=q",T=HA.version,{iconUrl:P,name:L,url:I,scheme:O}=n.dappMetadata||{},N=null===(w=t.platformManager)||void 0===w?void 0:w.getPlatformType();let D="N/A";"undefined"!=typeof window&&window.location&&window.location.hostname?D=window.location.hostname:void 0!==L?D=L:void 0!==I&&(D=I);const j={url:null!=I?I:"",title:null!=L?L:"",icon:P,scheme:null!=O?O:"",apiVersion:T,dappId:D||I||"N/A",platform:null!=N?N:"",source:null!==(_=n._source)&&void 0!==_?_:""},B=TR(JSON.stringify(j));let z=`channelId=${C}&v=2&comm=${null!==(S=t.communicationLayerPreference)&&void 0!==S?S:""}&pubkey=${x}${R}&originatorInfo=${B}`;if(i){z+=`&rpc=${TR(JSON.stringify(i))}`;const e=t.connector.getRPCMethodTracker();e&&(e[`${i.id}`]=Object.assign(Object.assign({},i),{id:`${i.id}`,timestamp:Date.now()}));}const U=encodeURI(z),F=`${t.useDeeplink?VA:$A}?${z}`;return t.qrcodeLink=F,t.developerMode&&xx(`[RemoteConnection: startConnection()] qrcodeLink=${U}`),k.emit("display_uri",F),(null===(E=t.platformManager)||void 0===E?void 0:E.isSecure())?(yield function(e,t){var n,r;return kk(this,void 0,void 0,(function*(){const i=`${$A}?${t}`,o=`${VA}?${t}`;null===(r=null===(n=e.platformManager)||void 0===n?void 0:n.openDeeplink)||void 0===r||r.call(n,i,o,"_self");}))}(t,U),new Promise(((n,r)=>{var i,o,a;(null===(i=t.connector)||void 0===i?void 0:i.isAuthorized())?n():(null===(o=t.connector)||void 0===o||o.once(e.EventType.AUTHORIZED,(()=>{n();})),null===(a=t.connector)||void 0===a||a.once(e.EventType.REJECTED,(()=>{r(e.EventType.REJECTED);})));}))):sP(t,n,U)}catch(e){throw console.error("[startConnection] error",e),e}}))}class cP{constructor(e){var t,n,r;this.state={connector:void 0,qrcodeLink:void 0,analytics:void 0,developerMode:false,authorized:false,reconnection:false,preferDesktop:false,deeplinkProtocol:false,listeners:[],communicationLayerPreference:void 0,platformManager:void 0,pendingModal:void 0,installModal:void 0,otpAnswer:void 0},this.options=e;const i=true===(null===(t=e.logging)||void 0===t?void 0:t.developerMode)||true===(null===(n=e.logging)||void 0===n?void 0:n.sdk);this.state.developerMode=i,this.state.analytics=e.analytics,this.state.preferDesktop=null!==(r=e.preferDesktop)&&void 0!==r&&r,this.state.useDeeplink=e.sdk.options.useDeeplink,this.state.communicationLayerPreference=e.communicationLayerPreference,this.state.platformManager=e.platformManager,e.modals.install||(e.modals.install=rP),e.modals.otp||(e.modals.otp=iP);}startConnection(e){return kk(this,void 0,void 0,(function*(){return lP(this.state,this.options,e)}))}initRemoteCommunication({sdkInstance:e}){var t,n,r;return kk(this,void 0,void 0,(function*(){const i=yield null===(n=null===(t=e.options.storage)||void 0===t?void 0:t.storageManager)||void 0===n?void 0:n.getPersistedChannelConfig();if(!this.options.ecies){const e={privateKey:null==i?void 0:i.localKey};this.options.ecies=e;}oP(this.state,this.options),yield null===(r=this.getConnector())||void 0===r?void 0:r.initFromDappStorage(),uP(this.state,this.options);}))}showActiveModal(){return function(e){var t,n,r,i;e.authorized?xx("[RemoteConnection: showActiveModal()] already authorized"):e.pendingModal?null===(n=(t=e.pendingModal).mount)||void 0===n||n.call(t):e.installModal&&(null===(i=(r=e.installModal).mount)||void 0===i||i.call(r,e.qrcodeLink||""));}(this.state)}closeModal(){var e,t,n,r;null===(t=null===(e=this.state.pendingModal)||void 0===e?void 0:e.unmount)||void 0===t||t.call(e),null===(r=null===(n=this.state.installModal)||void 0===n?void 0:n.unmount)||void 0===r||r.call(n,false);}getUniversalLink(){if(!this.state.qrcodeLink)throw new Error("connection not started. run startConnection() first.");return this.state.qrcodeLink}getChannelConfig(){var e;return null===(e=this.state.connector)||void 0===e?void 0:e.getChannelConfig()}getKeyInfo(){var e;return null===(e=this.state.connector)||void 0===e?void 0:e.getKeyInfo()}getConnector(){if(!this.state.connector)throw new Error("invalid remote connector");return this.state.connector}getPlatformManager(){if(!this.state.platformManager)throw new Error("PlatformManager not available");return this.state.platformManager}isConnected(){var e;return (null===(e=this.state.connector)||void 0===e?void 0:e.isReady())||false}isAuthorized(){var e;return (null===(e=this.state.connector)||void 0===e?void 0:e.isAuthorized())||false}isPaused(){var e;return null===(e=this.state.connector)||void 0===e?void 0:e.isPaused()}disconnect(e){var t,n,r;xx("[RemoteConnection: disconnect()]",e),(null==e?void 0:e.terminate)&&(PR.getProvider().handleDisconnect({terminate:true}),null===(n=null===(t=this.state.pendingModal)||void 0===t?void 0:t.unmount)||void 0===n||n.call(t),this.state.otpAnswer=void 0),null===(r=this.state.connector)||void 0===r||r.disconnect(e),function(e){xx("[RemoteConnection: cleanupConnector()] cleaning up connector"),e.connector&&(aP(e),e.connector.disconnect({terminate:true}).catch((e=>{xx("[RemoteConnection: cleanupConnector()] error disconnecting connector",e);})));}(this.state);}}function dP(t){var n,r,i,o,a,s,u,l,c,d,f;return kk(this,void 0,void 0,(function*(){const{options:h}=t;if(h.logging=null!==(n=h.logging)&&void 0!==n?n:{},h.communicationLayerPreference=null!==(r=h.communicationLayerPreference)&&void 0!==r?r:e.CommunicationLayerPreference.SOCKET,void 0!==h.enableDebug&&(DM.enable("MM_SDK"),console.warn("enableDebug is removed. Please use enableAnalytics instead.")),h.enableAnalytics=null===(i=h.enableAnalytics)||void 0===i||i,h.injectProvider=null===(o=h.injectProvider)||void 0===o||o,h.shouldShimWeb3=null===(a=h.shouldShimWeb3)||void 0===a||a,h.extensionOnly=null===(s=h.extensionOnly)||void 0===s||s,h.useDeeplink=null===(u=h.useDeeplink)||void 0===u||u,h.storage=null!==(l=h.storage)&&void 0!==l?l:{enabled:true},h.headless){DM("[MetaMaskSDK: performSDKInitialization()] headless mode enabled");const e=()=>{},t={install:()=>({mount:e,unmount:e})},n={installer:e};h.modals=t,h.ui=n;}const p=true===(null===(c=h.logging)||void 0===c?void 0:c.developerMode);t.debug=(null===(d=h.logging)||void 0===d?void 0:d.sdk)||p,xx("[MetaMaskSDK: performSDKInitialization()] options",t.options);const m=Object.assign({},h.logging);p&&(m.sdk=true,m.eciesLayer=true,m.keyExchangeLayer=true,m.remoteLayer=true,m.serviceLayer=true,m.plaintext=true),yield function(e){var t,n,r;return kk(this,void 0,void 0,(function*(){const i=null!==(t=e.options.i18nOptions)&&void 0!==t?t:{},o=i.enabled;yield e.i18nInstance.use(SR).init({debug:null!==(n=i.debug)&&void 0!==n&&n,compatibilityJSON:"v3",fallbackLng:"en",interpolation:{escapeValue:false},resources:o?{en:{translation:ER},es:{translation:kR},it:{translation:xR},fr:{translation:MR},pt:{translation:AR},tr:{translation:RR},he:{translation:CR}}:{en:{translation:ER}},detection:{order:["localStorage","navigator"],lookupLocalStorage:"MetaMaskSDKLng",caches:["localStorage"]}}),e.availableLanguages=Object.keys(null!==(r=e.i18nInstance.services.resourceStore.data)&&void 0!==r?r:{});}))}(t),yield function(e){var t;return kk(this,void 0,void 0,(function*(){const{options:n}=e;e.platformManager=new lT({useDeepLink:null!==(t=n.useDeeplink)&&void 0!==t&&t,preferredOpenLink:n.openDeeplink,debug:e.debug});}))}(t),yield function(e){var t,n,r,i,o,a,s,u,l;return kk(this,void 0,void 0,(function*(){const{options:c}=e,d=null===(t=e.platformManager)||void 0===t?void 0:t.getPlatformType();e.analytics=new HR({serverUrl:null!==(n=c.communicationServerUrl)&&void 0!==n?n:KE,enabled:c.enableAnalytics,originatorInfo:{url:null!==(r=c.dappMetadata.url)&&void 0!==r?r:"",title:null!==(i=c.dappMetadata.name)&&void 0!==i?i:"",dappId:"undefined"==typeof window||void 0===window.location?null!==(u=null!==(a=null===(o=c.dappMetadata)||void 0===o?void 0:o.name)&&void 0!==a?a:null===(s=c.dappMetadata)||void 0===s?void 0:s.url)&&void 0!==u?u:"N/A":window.location.hostname,platform:null!=d?d:"",source:null!==(l=c._source)&&void 0!==l?l:""}});}))}(t),yield function(e){var t;return kk(this,void 0,void 0,(function*(){const{options:n}=e;true!==(null===(t=n.storage)||void 0===t?void 0:t.enabled)||n.storage.storageManager||(n.storage.storageManager=Jx(n.storage));}))}(t),yield function(e){return kk(this,void 0,void 0,(function*(){const{options:t}=e,n=/^(http|https):\/\/[^\s]*$/;if(t.dappMetadata){t.dappMetadata.iconUrl&&!n.test(t.dappMetadata.iconUrl)&&(console.warn("Invalid dappMetadata.iconUrl: URL must start with http:// or https://"),t.dappMetadata.iconUrl=void 0),t.dappMetadata.base64Icon&&t.dappMetadata.base64Icon.length>$R&&(console.warn("Invalid dappMetadata.base64Icon: Base64-encoded icon string length must be less than 163400 characters"),t.dappMetadata.base64Icon=void 0),t.dappMetadata.url&&!n.test(t.dappMetadata.url)&&console.warn("Invalid dappMetadata.url: URL must start with http:// or https://");const e=WR();if(e&&!t.dappMetadata.iconUrl&&!t.dappMetadata.base64Icon){const n=`${window.location.protocol}//${window.location.host}${e}`;t.dappMetadata.iconUrl=n;}}e.dappMetadata=t.dappMetadata;}))}(t),yield aT(t),yield cT(t);const{metamaskBrowserExtension:g,preferExtension:v,shouldReturn:b}=yield function(e){var t,n,r,i;return kk(this,void 0,void 0,(function*(){const{options:o}=e;let a,s=false,u=false;if("undefined"!=typeof window&&window.ethereum&&!(null===(t=e.platformManager)||void 0===t?void 0:t.isMetaMaskMobileWebView())){s="extension"===localStorage.getItem(Vx);try{a=yield iT({mustBeMetaMask:!0,sdkInstance:e}),window.extension=a,a.on(Zx.CHAIN_CHANGED,(t=>{xx(`[MetaMaskSDK: setupExtensionPreferences()] PROPAGATE chainChanged chainId=${t}`),Boolean(e.sdkProvider)&&e.getMobileProvider().emit(Zx.CHAIN_CHANGED,t);})),a.on(Zx.ACCOUNTS_CHANGED,(t=>{xx(`[MetaMaskSDK: setupExtensionPreferences()] PROPAGATE accountsChanged accounts=${t}`);const n=Boolean(e.sdkProvider),r=Boolean(e.extensionActive);n&&e.getMobileProvider().emit(Zx.ACCOUNTS_CHANGED,t),r&&0===(null==t?void 0:t.length)&&e.terminate().catch((e=>{xx("[MetaMaskSDK: setupExtensionPreferences()] Error terminating",e);}));})),a.on(Zx.DISCONNECT,(t=>{xx(`[MetaMaskSDK: setupExtensionPreferences()] PROPAGATE disconnect error=${t}`),Boolean(e.sdkProvider)&&e.getMobileProvider().emit(Zx.DISCONNECT,t);})),a.on(Zx.CONNECT,(t=>{xx(`[MetaMaskSDK: setupExtensionPreferences()] PROPAGATE connect args=${t}`),Boolean(e.sdkProvider)&&e.getMobileProvider().emit(Zx.CONNECT,t);})),a.on(Zx.CONNECTED,(t=>{xx("[MetaMaskSDK: setupExtensionPreferences()] PROPAGATE connected",t),Boolean(e.sdkProvider)&&e.getMobileProvider().emit(Zx.CONNECTED,t);}));}catch(e){window.extension=void 0;}}else (null===(n=e.platformManager)||void 0===n?void 0:n.isMetaMaskMobileWebView())&&(null===(r=e.analytics)||void 0===r||r.send({event:ZE.SDK_USE_INAPP_BROWSER}),e.activeProvider=nT({provider:window.ethereum,sdkInstance:e}),e._initialized=true,u=true);return a&&o.extensionOnly&&(xx("[MetaMaskSDK: setupExtensionPreferences()] EXTENSION ONLY --- prevent sdk initialization"),null===(i=e.analytics)||void 0===i||i.send({event:ZE.SDK_USE_EXTENSION}),e.activeProvider=a,e.extensionActive=true,e.extension=a,e._initialized=true,u=true),{preferExtension:s,shouldReturn:u,metamaskBrowserExtension:a}}))}(t);if(b)xx("[MetaMaskSDK: performSDKInitialization()] shouldReturn=true --- prevent sdk initialization");else {yield function(t,n){var r,i,o,a,s;return kk(this,void 0,void 0,(function*(){const{options:u}=t,l=Object.assign({},u.logging);t.remoteConnection=new cP({i18nInstance:t.i18nInstance,preferDesktop:null!==(r=u.preferDesktop)&&void 0!==r&&r,communicationLayerPreference:null!==(i=u.communicationLayerPreference)&&void 0!==i?i:e.CommunicationLayerPreference.SOCKET,analytics:t.analytics,dappMetadata:u.dappMetadata,_source:u._source,enableAnalytics:null===(o=u.enableAnalytics)||void 0===o||o,timer:u.timer,sdk:t,platformManager:t.platformManager,transports:u.transports,communicationServerUrl:u.communicationServerUrl,storage:null!==(a=u.storage)&&void 0!==a?a:{enabled:true},getMetaMaskInstaller:()=>{if(!t.installer)throw new Error("Invalid SDK status -- installer not initialized");return t.installer},logging:l,connectWithExtensionProvider:void 0===n?void 0:()=>eR(t),modals:Object.assign(Object.assign({},u.modals),{onPendingModalDisconnect:t.terminate.bind(t)})}),yield t.remoteConnection.initRemoteCommunication({sdkInstance:t}),t.installer=new ET({remote:t.remoteConnection,preferDesktop:null!==(s=u.preferDesktop)&&void 0!==s&&s,platformManager:t.platformManager,debug:t.debug});}))}(t,g),yield zR(t),yield function(e,t){var n,r;return kk(this,void 0,void 0,(function*(){const{options:i}=e;t?(xx("[MetaMaskSDK: handleAutoAndExtensionConnections()] preferExtension is detected -- connect with it."),null===(n=e.analytics)||void 0===n||n.send({event:ZE.SDK_EXTENSION_UTILIZED}),eR(e).catch((e=>{console.warn("Can't connect with MetaMask extension...",e),localStorage.removeItem(Vx);}))):i.checkInstallationImmediately&&((null===(r=e.platformManager)||void 0===r?void 0:r.isDesktopWeb())?(xx("[MetaMaskSDK: handleAutoAndExtensionConnections()] checkInstallationImmediately"),e.connect().catch((e=>{xx(`[MetaMaskSDK: handleAutoAndExtensionConnections()] checkInstallationImmediately --- IGNORED --- error on autoconnect _err=${e}`);}))):console.warn("[handleAutoAndExtensionConnections()] checkInstallationImmediately --- IGNORED --- only for web desktop")),e._initialized=true;}))}(t,v);try{yield null===(f=t.remoteConnection)||void 0===f?void 0:f.startConnection({initialCheck:!0});}catch(e){console.error("[MetaMaskSDK: setupRemoteConnectionAndInstaller()] Error while checking installation",e);}t.emit(ZA.ProviderUpdate,e.PROVIDER_UPDATE_TYPE.INITIALIZED);}}))}class fP extends tA{constructor(e={storage:{enabled:true},injectProvider:true,forceInjectProvider:false,enableAnalytics:true,shouldShimWeb3:true,useDeeplink:true,extensionOnly:true,headless:false,dappMetadata:{name:"",url:"",iconUrl:""},_source:WA,i18nOptions:{enabled:false}}){var t,n,r;super(),this.extensionActive=false,this._initialized=false,this.sdkInitPromise=void 0,this.debug=false,this.readonlyRPCCalls=false,this.i18nInstance=KA(),this.availableLanguages=["en"],DM.disable();const i=true===(null===(t=e.logging)||void 0===t?void 0:t.developerMode);if(((null===(n=e.logging)||void 0===n?void 0:n.sdk)||i)&&DM.enable("MM_SDK"),xx("[MetaMaskSDK: constructor()]: begin."),this.setMaxListeners(50),!(null===(r=e.dappMetadata)||void 0===r?void 0:r.url)){if("undefined"==typeof window||"undefined"==typeof document)throw new Error("You must provide dAppMetadata url");e.dappMetadata=Object.assign(Object.assign({},e.dappMetadata),{url:`${window.location.protocol}//${window.location.host}`});}this.options=e,this.options._source||(e._source=WA),this.init().then((()=>{xx("[MetaMaskSDK: constructor()]: initialized successfully."),"undefined"!=typeof window&&(window.mmsdk=this);})).catch((e=>{console.error("[MetaMaskSDK: constructor()] error during initialization",e);}));}init(){return kk(this,void 0,void 0,(function*(){return function(e){var t;return kk(this,void 0,void 0,(function*(){if("undefined"!=typeof window&&(null===(t=window.mmsdk)||void 0===t?void 0:t.isInitialized()))return xx("[MetaMaskSDK: initializeMetaMaskSDK()] already initialized"),Promise.resolve(window.mmsdk);if(e._initialized)return xx("[MetaMaskSDK: initializeMetaMaskSDK()] already initialized"),e.sdkInitPromise;if(e.sdkInitPromise)return xx("[MetaMaskSDK: initializeMetaMaskSDK()] already initializing"),e.sdkInitPromise;try{e.sdkInitPromise=dP(e),yield e.sdkInitPromise;}catch(e){throw console.error(e),e}return e.sdkInitPromise}))}(this)}))}isExtensionActive(){return this.extensionActive}checkExtensionAvailability(){var e;return "undefined"!=typeof window&&Boolean(null===(e=window.ethereum)||void 0===e?void 0:e.isMetaMask)}connect(){return kk(this,void 0,void 0,(function*(){return function(e){return kk(this,void 0,void 0,(function*(){if(e._initialized||(xx("[MetaMaskSDK: connect()] provider not ready -- wait for init()"),yield e.init()),xx(`[MetaMaskSDK: connect()] isExtensionActive=${e.isExtensionActive()} activeProvider`,e.activeProvider),!e.activeProvider)throw new Error("SDK state invalid -- undefined provider");const t=e.activeProvider.getSelectedAddress();return t?[t]:e.activeProvider.request({method:Kx.ETH_REQUESTACCOUNTS,params:[]})}))}(this)}))}connectAndSign({msg:e}){return kk(this,void 0,void 0,(function*(){return XA({instance:this,msg:e})}))}connectWith(e){return kk(this,void 0,void 0,(function*(){return function({instance:e,rpc:t}){return kk(this,void 0,void 0,(function*(){if(e._initialized||(xx("[MetaMaskSDK: connectWith()] provider not ready -- wait for init()"),yield e.init()),xx(`[MetaMaskSDK: connectWith()] method: ${t.method} rpc=${t}`),!e.activeProvider)throw new Error("SDK state invalid -- undefined provider");return e.activeProvider.request({method:Kx.METAMASK_CONNECTWITH,params:[t]})}))}({instance:this,rpc:e})}))}resume(){return function(e){var t,n,r;return kk(this,void 0,void 0,(function*(){if(!(null===(n=null===(t=e.remoteConnection)||void 0===t?void 0:t.getConnector())||void 0===n?void 0:n.isReady()))return xx("[MetaMaskSDK: resume()] channel is not ready -- starting connection"),void(null===(r=e.remoteConnection)||void 0===r||r.startConnection());xx("[MetaMaskSDK: resume()] channel is ready");}))}(this)}disconnect(){return console.warn("MetaMaskSDK.disconnect() is deprecated, use terminate()"),this.terminate()}isAuthorized(){var e;null===(e=this.remoteConnection)||void 0===e||e.isAuthorized();}terminate(){return function(t){var n,r,i;return kk(this,void 0,void 0,(function*(){if(!(null===(n=t.platformManager)||void 0===n?void 0:n.isMetaMaskMobileWebView())){if(JA&&(window.localStorage.removeItem(Vx),window.localStorage.removeItem(Gx),window.localStorage.removeItem(Yx)),t.extensionActive){try{yield null===(r=t.activeProvider)||void 0===r?void 0:r.request({method:Kx.WALLET_REVOKEPERMISSIONS,params:[{eth_accounts:{}}]});}catch(e){xx("[MetaMaskSDK: terminate()] error revoking permissions",e);}return t.options.extensionOnly?void xx("[MetaMaskSDK: terminate()] extensionOnly --- prevent switching providers"):(t.activeProvider=t.sdkProvider,window.ethereum=t.activeProvider,t.extensionActive=false,void t.emit(ZA.ProviderUpdate,e.PROVIDER_UPDATE_TYPE.TERMINATE))}t.emit(ZA.ProviderUpdate,e.PROVIDER_UPDATE_TYPE.TERMINATE),xx(`[MetaMaskSDK: terminate()] remoteConnection=${t.remoteConnection}`),null===(i=t.remoteConnection)||void 0===i||i.disconnect({terminate:true,sendMessage:true});}}))}(this)}isInitialized(){return this._initialized}setReadOnlyRPCCalls(e){this.readonlyRPCCalls=e;}hasReadOnlyRPCCalls(){return this.readonlyRPCCalls}getProvider(){if(this.activeProvider)return this.activeProvider;console.warn("MetaMaskSDK: No active provider found");}getMobileProvider(){if(!this.sdkProvider)throw new Error("SDK state invalid -- undefined mobile provider");return this.sdkProvider}getUniversalLink(){var e;const t=null===(e=this.remoteConnection)||void 0===e?void 0:e.getUniversalLink();if(!t)throw new Error("No Universal Link available, please call eth_requestAccounts first.");return t}getChannelId(){var e,t;return null===(t=null===(e=this.remoteConnection)||void 0===e?void 0:e.getChannelConfig())||void 0===t?void 0:t.channelId}getRPCHistory(){var e,t;return null===(t=null===(e=this.remoteConnection)||void 0===e?void 0:e.getConnector())||void 0===t?void 0:t.getRPCMethodTracker()}getVersion(){return HA.version}getWalletStatus(){var e,t;return null===(t=null===(e=this.remoteConnection)||void 0===e?void 0:e.getConnector())||void 0===t?void 0:t.getConnectionStatus()}_getChannelConfig(){var e;return null===(e=this.remoteConnection)||void 0===e?void 0:e.getChannelConfig()}_ping(){var e,t;null===(t=null===(e=this.remoteConnection)||void 0===e?void 0:e.getConnector())||void 0===t||t.ping();}_keyCheck(){var e,t;null===(t=null===(e=this.remoteConnection)||void 0===e?void 0:e.getConnector())||void 0===t||t.keyCheck();}_getServiceStatus(){var e,t;return null===(t=null===(e=this.remoteConnection)||void 0===e?void 0:e.getConnector())||void 0===t?void 0:t.getServiceStatus()}_getRemoteConnection(){return this.remoteConnection}_getDappMetadata(){return this.dappMetadata}_getKeyInfo(){var e;return null===(e=this.remoteConnection)||void 0===e?void 0:e.getKeyInfo()}_resetKeys(){var e,t;null===(t=null===(e=this.remoteConnection)||void 0===e?void 0:e.getConnector())||void 0===t||t.resetKeys();}_getConnection(){return this.remoteConnection}emit(e,t){return super.emit(e,t)}on(e,t){return super.on(e,t)}}e.DEFAULT_SERVER_URL=KE,e.MetaMaskSDK=fP,e.MetaMaskSDKEvent=ZA,e.SDKProvider=Xx,e.default=fP,Object.defineProperty(e,"__esModule",{value:true});}));
		
	} (metamaskSdk$1, metamaskSdk$1.exports));
	return metamaskSdk$1.exports;
}

var metamaskSdkExports = /*@__PURE__*/ requireMetamaskSdk();

/**
 * Listens for the `display_uri` event emitted by the MetaMask SDK.
 *
 * The `display_uri` event is triggered during SDK initialization or when the `connect` method is called.
 * Calling `terminate` in the MetaMask SDK resets the connection, and a new `display_uri` will only be emitted
 * when `connect` is called again.
 *
 * This function manages the new `display_uri` received from these events.
 */
const createMetaMaskSDKDisplayUriState = (metaMaskSDK) => {
    let lastKnownMetaMaskDeepLinkUri = null;
    let displayUri = null;
    metaMaskSDK.on('display_uri', (latestDisplayUri) => {
        if (lastKnownMetaMaskDeepLinkUri !== latestDisplayUri) {
            lastKnownMetaMaskDeepLinkUri = latestDisplayUri;
            displayUri = latestDisplayUri.trim();
        }
    });
    return {
        consumeDisplayUri: () => __awaiter$8(void 0, void 0, void 0, function* () {
            const currentDisplayUri = displayUri;
            if (currentDisplayUri) {
                displayUri = null;
                return currentDisplayUri;
            }
            return new Promise((resolve) => {
                let timeoutId = null;
                let intervalId = null;
                const cleanUp = () => {
                    if (timeoutId)
                        clearTimeout(timeoutId);
                    if (intervalId)
                        clearInterval(intervalId);
                };
                timeoutId = setTimeout(() => {
                    cleanUp();
                    resolve(undefined);
                }, 1000);
                intervalId = setInterval(() => {
                    if (displayUri) {
                        cleanUp();
                        resolve(displayUri);
                        displayUri = null;
                    }
                }, 10);
            });
        }),
    };
};

const waitForConnection = (provider) => new Promise((resolve) => {
    provider.once('connect', () => resolve());
});

const isPendingWalletRequestPermissionError = (error) => typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    error.message.includes("Request of type 'wallet_requestPermissions' already pending for origin");

/**
 * The MetaMask SDK must be initialized only once, so we store the instance
 * in these variables to avoid initializing it multiple times
 */
let _metaMaskSDK = null;
let _metaMaskSDKDisplayUriState = null;
const eventTimeline = createEventTimeline();
class MetaMaskConnector extends InjectedWalletBase {
    constructor(props) {
        super(props);
        this.name = 'MetaMask';
        this.overrideKey = 'metamask';
        this.canConnectViaQrCode = true;
        this.isInAppBrowser = false;
        this.appName = props.appName;
        this.appLogoUrl = props.appLogoUrl;
        /**
         * The isInAppBrowser must be calculated before initializing the MetaMask SDK.
         *
         * The isInAppBrowser is calculated by checking if the window provider is installed
         * in the browser and if it is running on a mobile device.
         *
         * But the MetaMask SDK will inject its own provider to the window if not provider is injected.
         * This means the MetaMask SDK can interfere with the isInAppBrowser calculation.
         *
         * So we need to calculate the isInAppBrowser before initializing the MetaMask SDK
         * to prevent a false negative
         */
        this.isInAppBrowser = this.getIsInAppBrowser();
        if (!_metaMaskSDK) {
            this.createMetaMaskSDK();
        }
    }
    isInstalledOnBrowser() {
        var _a;
        const metaMaskEip6963Provider = (_a = this.ethProviderHelper) === null || _a === void 0 ? void 0 : _a.eip6963ProviderLookup(this.rdns);
        const isInstalled = Boolean(metaMaskEip6963Provider);
        return isInstalled;
    }
    getSupportedNetworks() {
        return __awaiter$8(this, void 0, void 0, function* () {
            return this.evmNetworks.map((network) => network.chainId.toString());
        });
    }
    get metaMaskSDK() {
        if (!_metaMaskSDK)
            throw new Error('MetaMaskSDK not initialized');
        return _metaMaskSDK;
    }
    set metaMaskSDK(metaMaskSDK) {
        _metaMaskSDK = metaMaskSDK;
    }
    get metaMaskSDKDisplayUriState() {
        if (!_metaMaskSDKDisplayUriState)
            throw new Error('MetaMaskSDKDisplayUriState not initialized');
        return _metaMaskSDKDisplayUriState;
    }
    createMetaMaskSDK() {
        const dappMetadata = {
            iconUrl: this.appLogoUrl,
            name: this.appName,
            url: PlatformService.getOrigin(),
        };
        _metaMaskSDK = new metamaskSdkExports.MetaMaskSDK({
            checkInstallationImmediately: true,
            dappMetadata,
            enableAnalytics: false,
            extensionOnly: this.isInstalledOnBrowser(),
            headless: true,
            injectProvider: false,
            openDeeplink: PlatformService.openURL,
            preferDesktop: !isMobile(),
            readonlyRPCMap: getReadonlyRPCMap(this.evmNetworkRpcMap()),
            useDeeplink: true,
        });
        _metaMaskSDKDisplayUriState =
            createMetaMaskSDKDisplayUriState(_metaMaskSDK);
    }
    endSession() {
        return __awaiter$8(this, void 0, void 0, function* () {
            eventTimeline.postEvent('disconnect');
            /**
             * The MetaMask SDK must be terminated and reinitialized on mobile
             * to prevent deeplinks not working
             */
            if (isMobile()) {
                return this.metaMaskSDK.terminate().then(() => {
                    _metaMaskSDK = null;
                    _metaMaskSDKDisplayUriState = null;
                    return this.createMetaMaskSDK();
                });
            }
            /**
             * Just terminate the SDK on desktop
             */
            return this.metaMaskSDK.terminate();
        });
    }
    getAddress(opts) {
        return __awaiter$8(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                // QR Code flow
                if (!isMobile() && Boolean(opts === null || opts === void 0 ? void 0 : opts.onDisplayUri)) {
                    this.metaMaskSDKDisplayUriState
                        .consumeDisplayUri()
                        .then((displayUri) => {
                        var _a;
                        if (!displayUri) {
                            reject(new Error('MetaMask display uri not found'));
                            return;
                        }
                        (_a = opts === null || opts === void 0 ? void 0 : opts.onDisplayUri) === null || _a === void 0 ? void 0 : _a.call(opts, displayUri);
                    });
                }
                // Deep link to MetaMask app in-app browser
                if (this.shouldDeepLinkToMetaMaskInAppBrowser() &&
                    this.metadata.inAppBrowserUrl) {
                    // Redirect to the in-app browser and append the current url
                    window.location.href = `${this.metadata.inAppBrowserUrl}/${window.location.href}`;
                    resolve(undefined);
                    return;
                }
                // Connect to MetaMask
                this.getConnectedAccountsSafely().then((initialConnectedAccounts) => __awaiter$8(this, void 0, void 0, function* () {
                    if (initialConnectedAccounts.length) {
                        resolve(this.parseAddress(initialConnectedAccounts[0]));
                        return;
                    }
                    try {
                        yield this.metaMaskSDK.connect();
                    }
                    catch (error) {
                        const isRequestPendingError = isPendingWalletRequestPermissionError(error);
                        if (!isRequestPendingError) {
                            throw error;
                        }
                        else {
                            yield waitForConnection(this.getProvider());
                        }
                    }
                    const accounts = yield this.getConnectedAccounts();
                    resolve(accounts[0]);
                }));
            });
        });
    }
    getConnectedAccountsSafely() {
        return __awaiter$8(this, void 0, void 0, function* () {
            try {
                const connectedAccounts = yield this.getConnectedAccounts();
                return connectedAccounts;
            }
            catch (err) {
                logger$4.error(err);
                return [];
            }
        });
    }
    getConnectedAccounts() {
        return __awaiter$8(this, void 0, void 0, function* () {
            // Wait for for MetaMask SDK to initialize
            yield this.metaMaskSDK.sdkInitPromise;
            const provider = this.getProvider();
            if (!provider) {
                return [];
            }
            /**
             * The eth_accounts method can hang on mobile devices when
             * the MetaMask SDK has not connected yet. So we use a retryable
             * to ensure the timeout will be respected
             */
            const accounts = yield retryableFn(() => provider.request({
                method: 'eth_accounts',
                params: [],
            }), {
                fallbackValue: [],
                timeoutMs: 1000,
            });
            if (!(accounts === null || accounts === void 0 ? void 0 : accounts.length)) {
                return [];
            }
            return accounts.map(this.parseAddress);
        });
    }
    signMessage(messageToSign) {
        return __awaiter$8(this, void 0, void 0, function* () {
            yield this.metaMaskSDK.sdkInitPromise;
            /**
             * Should wait for the window to be focused on mobile
             * to account for the user moving between the MetaMaskApp
             * and the browser
             */
            const windowFocusPromiseForMobile = !this.isInAppBrowser && isMobile()
                ? waitForFocusWindowEvent()
                : Promise.resolve();
            const provider = this.getProvider();
            if (!provider) {
                return undefined;
            }
            const [selectedAddress] = yield this.getConnectedAccounts();
            if (!selectedAddress) {
                return undefined;
            }
            const walletClient = this.getWalletClientForAddress(selectedAddress);
            if (!walletClient)
                return undefined;
            const signature = yield walletClient.signMessage({
                message: messageToSign,
            });
            yield windowFocusPromiseForMobile;
            return signature;
        });
    }
    chooseAccountsToConnect() {
        return __awaiter$8(this, void 0, void 0, function* () {
            return [];
        });
    }
    getWalletClient(chainId) {
        const provider = this.getProvider();
        if (!provider) {
            return undefined;
        }
        const selectedAddress = provider.getSelectedAddress();
        return this.getWalletClientForAddress(selectedAddress || undefined, chainId);
    }
    get rdns() {
        const { rdns } = this.metadata;
        if (!rdns) {
            throw new Error('rdns not found in metadata');
        }
        return rdns;
    }
    setupEventListeners() {
        return __awaiter$8(this, void 0, void 0, function* () {
            yield this.metaMaskSDK.sdkInitPromise;
            const metaMaskProvider = this.getProvider();
            if (!metaMaskProvider) {
                return;
            }
            const { handleAccountChange, handleChainChange, handleDisconnect } = eventListenerHandlers(this);
            const handleAccountsChangedFromMetaMask = (accounts) => {
                /**
                 * MetaMask emits an account changed event when the wallet is disconnected
                 * so we ignore the accountsChanged event if the disconnect event was recent
                 */
                if (eventTimeline.isEventRecent('disconnect', 1000)) {
                    return;
                }
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                handleAccountChange(accounts);
            };
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            metaMaskProvider.on('accountsChanged', handleAccountsChangedFromMetaMask);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            metaMaskProvider.on('chainChanged', handleChainChange);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            metaMaskProvider.on('disconnect', handleDisconnect);
            this.teardownEventListeners = () => {
                metaMaskProvider.off('accountsChanged', handleAccountsChangedFromMetaMask);
                metaMaskProvider.off('chainChanged', handleChainChange);
                metaMaskProvider.off('disconnect', handleDisconnect);
            };
        });
    }
    /**
     * This override is necessary to wait for the MetaMask SDK to initialize
     * before calling the super method. Otherwise, the super method may fail
     * to fetch the provider
     */
    getNetwork() {
        const _super = Object.create(null, {
            getNetwork: { get: () => super.getNetwork }
        });
        return __awaiter$8(this, void 0, void 0, function* () {
            yield this.metaMaskSDK.sdkInitPromise;
            const net = yield _super.getNetwork.call(this);
            return net;
        });
    }
    // Utils
    getProvider() {
        var _a;
        return ((_a = this.metaMaskSDK.getProvider()) !== null && _a !== void 0 ? _a : this.metaMaskSDK.getMobileProvider());
    }
    evmNetworkByChainId(chainId) {
        return this.evmNetworks.find((network) => network.chainId === chainId);
    }
    getWalletClientForAddress(address, chainId) {
        var _a, _b;
        const provider = this.getProvider();
        if (!provider) {
            return undefined;
        }
        const effectiveChainId = (_b = (_a = this.toInt(chainId)) !== null && _a !== void 0 ? _a : this.getCurrentChainId()) !== null && _b !== void 0 ? _b : '1';
        const network = this.evmNetworkByChainId(effectiveChainId);
        return createWalletClient({
            account: address,
            chain: network ? getOrMapViemChain(network) : this.getActiveChain(),
            transport: custom$1(provider),
        });
    }
    toInt(chainId) {
        if (!chainId)
            return undefined;
        try {
            return parseInt(chainId);
        }
        catch (err) {
            logger$4.debug(err);
            return undefined;
        }
    }
    getCurrentChainId() {
        const provider = this.getProvider();
        if (!provider) {
            return undefined;
        }
        const chainId = provider.getChainId();
        if (isHex$2(chainId)) {
            return parseInt(chainId);
        }
        return chainId;
    }
    /**
     * Checks if the current environment is the MetaMask in-app browser
     * by checking if the MetaMask provider is installed in the window object
     * on a mobile device
     */
    getIsInAppBrowser() {
        var _a, _b;
        if (!isMobile())
            return false;
        const provider = ((_a = this.ethProviderHelper) === null || _a === void 0 ? void 0 : _a.eip6963ProviderLookup(this.rdns)) ||
            ((_b = this.ethProviderHelper) === null || _b === void 0 ? void 0 : _b.getInjectedProvider());
        return Boolean(provider);
    }
    shouldDeepLinkToMetaMaskInAppBrowser() {
        // Not in an in-app browser
        if (this.isInAppBrowser)
            return false;
        // Not a mobile device
        if (!isMobile())
            return false;
        // SDK is configured to use the in-app browser
        if (this.mobileExperience !== 'in-app-browser')
            return false;
        // Wallet does not have an in-app browser link
        if (!this.metadata.inAppBrowserUrl)
            return false;
        return true;
    }
}
// Utils
const getReadonlyRPCMap = (evmNetworkRpcMap) => Object.keys(evmNetworkRpcMap).reduce((acc, chainId) => (Object.assign(Object.assign({}, acc), { [toHex(parseInt(chainId))]: evmNetworkRpcMap[chainId] })), {});
/**
 * Waits for the focus page event and await for an extra second
 * This is necessary to ensure the verify call will succeed
 */
const waitForFocusWindowEvent = () => new Promise((resolve) => {
    window.addEventListener('focus', resolve);
}).then(() => new Promise((resolve) => setTimeout(resolve, 1000)));

const EthereumWalletConnectors = (props) => [
    ...injectedWalletOverrides,
    ...fetchInjectedWalletConnector(props),
    ...fetchWalletConnectWallets(props),
    ...TurnkeyEVMWalletConnectors(props),
    MetaMaskConnector,
    Coinbase,
    FallbackEvmConnector,
    getWalletConnectConnector(),
];

assertPackageVersion('@dynamic-labs/ethereum', version$i);

var version$4 = "4.6.1";
var dependencies = {
	"@dynamic-labs/sdk-api-core": "0.0.622"};

const isSSR = () => typeof window === 'undefined';

(() => {
    if (!isSSR()) {
        new URL(window.location.href);
    }
})();

const VERSION = version$4;
const API_VERSION = dependencies['@dynamic-labs/sdk-api-core'];

var version$3 = "4.6.1";

const generateMessageToSign = ({ blockchain, domain, chainId, nonce, uri, publicKey, issuedAt = new Date().toISOString(), statement, requestId, resources, }) => {
    var _a, _b;
    if (blockchain === 'STARK') {
        /**
         * Starknet requires the strings to be 31 chars long
         * Nonce - we need to keep full size for nonce verification on the backend (the backend shortens it to 31 chars)
         * Domain - we need to shorten the domain to 31 chars
         */
        return JSON.stringify({
            domain: domain.substring(0, 31),
            nonce,
        });
    }
    const blockchainName = (_b = (_a = getChainInfo(blockchain)) === null || _a === void 0 ? void 0 : _a.blockchainName) !== null && _b !== void 0 ? _b : 'Ethereum';
    // This format follows the sign-in with ethereum (SIWE) standard,
    // but we are using it also for non-ethereum wallets for now (eg. Solana)
    // for more context on format and fields, please see:
    // https://docs.login.xyz/general-information/siwe-overview/eip-4361
    const header = `${domain} wants you to sign in with your ${blockchainName} account:`;
    const prefix = [header, publicKey].join('\n');
    // If there is a statement, we want to add a gap between the prefix and the statement
    // two times '\n', first to move statement to next line and second to add a gap between prefix and statement
    const prefixWithStatementGap = statement ? '\n\n' : '\n';
    const prefixWithStatement = `${[prefix, statement].join(prefixWithStatementGap)}\n`;
    const suffixFields = [];
    suffixFields.push(`URI: ${uri}`);
    suffixFields.push('Version: 1');
    if (chainId) {
        suffixFields.push(`Chain ID: ${chainId}`);
    }
    suffixFields.push(`Nonce: ${nonce}`);
    suffixFields.push(`Issued At: ${issuedAt}`);
    if (requestId) {
        suffixFields.push(`Request ID: ${requestId}`);
    }
    if (resources === null || resources === void 0 ? void 0 : resources.length) {
        suffixFields.push(`Resources:${resources.map((resource) => '\n- ' + resource).join()}`);
    }
    const suffix = suffixFields.join('\n');
    return [prefixWithStatement, suffix].join('\n');
};

// get list of providers enabled in the sense that we should have wallet connectors for them
// note: magic and turnkey are considered enabled when a provider exists (for magic, a providerProjectId exists)
const getEnabledProviders = (providers) => {
    var _a;
    return (_a = providers === null || providers === void 0 ? void 0 : providers.filter((provider) => Boolean(provider.enabledAt) ||
        (provider.provider === ProviderEnum.MagicLink &&
            Boolean(provider.providerProjectId)) ||
        provider.provider === ProviderEnum.Turnkey)) !== null && _a !== void 0 ? _a : [];
};

const getApiProviders = (providers) => Object.values(ProviderEnum).reduce((acc, provider) => {
    const foundProvider = providers.find((providerSetting) => providerSetting.provider === provider);
    if (foundProvider) {
        acc[provider] = foundProvider;
    }
    return acc;
}, {});

const defaultWalletUiUtils = {
    addNetwork: () => {
        throw Error('addNetwork not implemented');
    },
    disabledConfirmationOnce: () => {
        throw Error('disabledConfirmationOnce, not implemented');
    },
    sendTransaction: () => {
        throw Error('requestSendTransactionConfirmation not implemented');
    },
    signMessage: () => {
        throw Error('signMessage not implemented');
    },
    signTransaction: () => {
        throw Error('signTransaction not implemented');
    },
    syncWallet: () => {
        throw Error('syncWallet not implemented');
    },
};

const getWalletConnectorConstructorOptions = ({ appLogoUrl, appName, authMode, coinbaseWalletPreference, chainRpcProviders, deepLinkPreference, flowNetwork, mobileExperience, networkConfigurations, settings, walletConnectProjectId, walletUiUtils, walletBook, walletConnectPreferredChains, }) => {
    const eclipseNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.eclipse) || [];
    const evmNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.evm) || [];
    const solanaNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.solana) || [];
    const cosmosNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.cosmos) || [];
    const starknetNetworkConfigs = (networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.starknet) || [];
    const apiProviders = getApiProviders(getEnabledProviders(settings.providers));
    const opts = {
        apiProviders,
        appLogoUrl,
        appName,
        authMode,
        chainRpcProviders,
        coinbaseWalletPreference,
        cosmosNetworks: cosmosNetworkConfigs,
        deepLinkPreference,
        eclipseNetworks: eclipseNetworkConfigs,
        evmNetworks: evmNetworkConfigs,
        flowNetwork,
        mobileExperience,
        projectId: walletConnectProjectId,
        settings,
        solNetworks: solanaNetworkConfigs,
        starknetNetworks: starknetNetworkConfigs,
        walletBook,
        walletConnectPreferredChains,
        walletConnectorEventsEmitter: walletConnectorEvents,
        walletUiUtils: walletUiUtils || defaultWalletUiUtils,
    };
    return opts;
};

const handleMobileWalletFilter = (connector) => {
    var _a, _b;
    if (!connector.metadata)
        return false;
    const { downloadLinks, deepLinks } = connector.metadata;
    /**
     * WalletConnect provides a "universal" and "native" deep link. They recommend using
     * the universal deep link over the native one due to UX differences, and our current
     * implementation uses only universal. This means we need to filter for wallets that
     * have a universal deep link available.
     */
    const hasWalletConnectLink = Boolean((_a = deepLinks === null || deepLinks === void 0 ? void 0 : deepLinks.mobile) === null || _a === void 0 ? void 0 : _a.universal) || Boolean((_b = deepLinks === null || deepLinks === void 0 ? void 0 : deepLinks.mobile) === null || _b === void 0 ? void 0 : _b.native);
    const shouldShowIfHadDownloadLink = !connector.isWalletConnect ||
        connector.key === 'walletconnect' ||
        hasWalletConnectLink;
    const walletLinks = getWalletLinks(downloadLinks);
    if (isIPad() || isIPhone()) {
        const hasIOSLink = Boolean(walletLinks.ios);
        return hasIOSLink && shouldShowIfHadDownloadLink;
    }
    else {
        const hasAndroidLink = Boolean(walletLinks.android);
        return hasAndroidLink && shouldShowIfHadDownloadLink;
    }
};

const filterWalletsForPlatform = (walletBook, connectors) => connectors.filter((connector) => {
    const walletBookWallet = findWalletBookWallet(walletBook, connector.key);
    if (connector.isInstalledOnBrowser()) {
        return true;
    }
    else if (isEmbeddedConnector(connector)) {
        return true;
    }
    else if (walletBookWallet === null || walletBookWallet === void 0 ? void 0 : walletBookWallet.showOnlyIfInstalled) {
        return false;
    }
    else if (!isMobile()) {
        return true;
    }
    else {
        return handleMobileWalletFilter(connector);
    }
});

const applyLinksOverrides = (walletBook, wallets) => wallets.map((wallet) => {
    const walletData = findWalletBookWallet(walletBook, wallet.key);
    if ((walletData === null || walletData === void 0 ? void 0 : walletData.switchNetworkOnlyFromWallet) !== undefined) {
        wallet.switchNetworkOnlyFromWallet =
            walletData.switchNetworkOnlyFromWallet;
    }
    return wallet;
});

// needs to be a global variable, otherwise it breaks the list of wallets in the dashboard
// https://linear.app/dynamic-labs/issue/QNTM-2642/update-to-getsupportedwallets-broke-the-list-of-wallets-on-the
let walletConnectors = [];
const getSupportedWallets = (args) => {
    var _a;
    const { settings, skipMemo = false, walletConnectorsProp, walletBook } = args;
    if (!skipMemo && walletConnectors.length > 0) {
        return walletConnectors;
    }
    const disabledConnectors = (_a = settings.sdk.disabledWalletConnectors) !== null && _a !== void 0 ? _a : [];
    const opts = getWalletConnectorConstructorOptions(args);
    const allWalletConnectors = walletConnectorsProp
        .map((getWalletConnectorConstructors) => getWalletConnectorConstructors(opts))
        .flat()
        .map((walletConnectorConstructor) => {
        try {
            // This may contain third party code so we must be ready for anything
            return new walletConnectorConstructor(opts);
        }
        catch (error) {
            logger$8.error(`Failed to construct wallet ${walletConnectorConstructor.name}`, error);
            return undefined;
        }
    })
        // filter out undefined and disabled connectors
        .filter((walletConnector) => {
        var _a;
        return walletConnector &&
            (!((_a = walletConnector.metadata) === null || _a === void 0 ? void 0 : _a.id) ||
                !disabledConnectors.includes(walletConnector.metadata.id));
    })
        // initialize the wallet connector if it's not a WalletConnect connector
        // or just the generic 'walletconnect' connector, not other WC connectors
        .map((walletConnector) => {
        if (!(walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.isWalletConnect) ||
            walletConnector.key === 'walletconnect') {
            walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.init();
        }
        return walletConnector;
    })
        // applies custom filter defined in the wallet connector
        .filter((walletConnector) => walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.filter())
        .map((walletConnector) => walletConnector.getMobileOrInstalledWallet());
    // Filter out duplicated wallets (WC vs. non-WC)
    const nonDuplicatedWalletConnectors = allWalletConnectors.filter((walletConnector) => {
        if (!walletConnector.isWalletConnect)
            return true;
        // if current wallet is WalletConnect, check if there is another wallet with the same key that is
        // not WalletConnect
        // if there is, return false (filter out WC wallet)
        // if there is no other wallet with the same key that is not WalletConnect, return true (keep WC wallet)
        return !allWalletConnectors.some((wc) => wc.key === walletConnector.key &&
            !wc.isWalletConnect &&
            wc.isInstalledOnBrowser());
    });
    const filteredWalletConnectors = filterWalletsForPlatform(walletBook, nonDuplicatedWalletConnectors);
    walletConnectors = applyLinksOverrides(walletBook, filteredWalletConnectors);
    return walletConnectors;
};

const chainStringToChains = {
    'eip155:1': ['ETH', 'EVM'],
    'flow:mainnet': ['FLOW'],
};
const getSupportedChainsForWalletConnector = (walletBook, walletConnector) => {
    var _a;
    const walletBookWallet = findWalletBookWallet(walletBook, walletConnector.key);
    if (!walletBookWallet) {
        return walletConnector.supportedChains;
    }
    /**
     * chains could contain multiple eth networks eg
     *  "eip155:1",
     *  "eip155:10",
     *  "eip155:56",
     *  "eip155:100",
     *
     * so we will use a set to ensure uniqueness
     */
    const chainSet = new Set();
    const chainStringList = (_a = walletBookWallet.chains) !== null && _a !== void 0 ? _a : [];
    chainStringList.forEach((chainString) => {
        const chains = chainStringToChains[chainString];
        chains === null || chains === void 0 ? void 0 : chains.forEach((chain) => {
            chainSet.add(chain);
        });
    });
    walletConnector.supportedChains.forEach((chain) => {
        chainSet.add(chain);
    });
    return [...chainSet];
};

// this function will return a list of connectors that are enabled based on the chains that are enabled
const getEnabledWallets = (props) => {
    const supportedWallets = getSupportedWallets(props.getSupportedWalletOpts);
    const allEnabledWallets = supportedWallets.filter((wallet) => props.enabledChains.some((chain) => getSupportedChainsForWalletConnector(props.getSupportedWalletOpts.walletBook, wallet).includes(chain)) || wallet.key === 'magiclink');
    return allEnabledWallets;
};

assertPackageVersion('@dynamic-labs/multi-wallet', version$3);

const logger$1 = new Logger$1('DynamicSDK');

// ATTENTION
// Everything below should be made public soon, but we need to plan this out first
// Main issues:
// 1. How should we map customer callback names to our dynamic event names?
//  -> Gui's suggestion: breaking change to rename customer callbacks so they fit these events names
// 2. We would have to remove these callbacks from the useCustomerCallbacks hook
/** Which events are accessible by our clients */
const externalEvents = [
    'authFailure',
    'authFlowCancelled',
    'authFlowClose',
    'authFlowOpen',
    'authInit',
    'emailVerificationResult',
    'embeddedWalletCreated',
    'logout',
    'mfaCompletionFailure',
    'mfaCompletionSuccess',
    'primaryWalletChanged',
    'primaryWalletNetworkChanged',
    'smsVerificationResult',
    'walletAdded',
    'walletRemoved',
    'userWalletsChanged',
];
// Full internal event emitter
const dynamicEvents = new EventEmitter$1();

/** Allows us to subscribe to all dynamicEvents with a hook, even the internal ones */
const useInternalDynamicEvents = (event, listener) => {
    const handler = useRef(listener);
    handler.current = listener;
    useEffect(() => {
        const callback = (...args) => handler.current(...args);
        dynamicEvents.on(event, callback);
        return () => {
            dynamicEvents.off(event, callback);
        };
    }, [event]);
};
/** Allows subscribing to dynamic events directly inside components with a hook */
const useDynamicEvents = (event, listener) => {
    if (!externalEvents.includes(event))
        throw new Error(`Unrecognized event "${event}" used with useDynamicEvents`);
    useInternalDynamicEvents(event, listener);
};

const errorMessageMap = {
    '-32000': 'Message signature denied',
    '-32002': 'Please unlock your wallet extension and try again.',
    '-32003': 'Message signature denied.',
    '-32602': 'Invalid parameters. Please try again.',
    '-32603': 'There was an internal error. Please try again.',
    0: 'Message signature denied.',
    4001: 'Message signature denied.',
    4100: 'Please unlock your wallet extension and try again.',
    4900: 'There was an internal error. Please try again.',
    5001: 'Message signature denied.',
    5002: 'Message signature denied.',
    account_already_linked_to_different_profile: 'This social account is already linked to a different profile.',
    connection_rejected: 'Connection rejected. Please try again.',
    metamask_timeout: 'Whoops. Looks like something went wrong. Please try again.',
    'missing-nonce': 'Something went wrong. Please try again.',
    'missing-public-address': 'Connection cancelled. Please try again',
    oauth_window_blocked: 'To connect to your social account, enable popups in your browser and then try again.',
    oauth_window_timeout: 'Session time out. Please try again.',
    too_many_email_verification_attempts: 'Too many email verification attempts, please try again later',
    'user-cancelled': '',
    wallet_not_deployed: 'Your smart wallet has not been deployed.',
    wrong_email_verification_token: 'The code you entered is incorrect. Please try again.',
};
const ErrorContext = createContext(undefined);
const ErrorContextProvider = ({ children }) => {
    const [error, setError] = useState(undefined);
    const setErrorMessage = useCallback((status) => {
        var _a;
        setError((_a = errorMessageMap[status]) !== null && _a !== void 0 ? _a : 'Something went wrong. Please try again.');
    }, []);
    const clearError = useCallback(() => {
        setError(undefined);
    }, []);
    const value = useMemo(() => ({
        clearError,
        error,
        setError,
        setErrorMessage,
    }), [clearError, error, setError, setErrorMessage]);
    return (jsxRuntimeExports.jsx(ErrorContext.Provider, { value: value, children: children }));
};
const useErrorContext = () => {
    const context = useContext(ErrorContext);
    if (context === undefined) {
        throw new Error('usage of useErrorContext not wrapped in `ErrorContextProvider`.');
    }
    return context;
};

const ViewContext = createContext(undefined);
const ViewContextProvider = ({ children, initialViewType }) => {
    var _a;
    const [stack, setStack] = useState([]);
    const initialView = useMemo(() => ({ type: initialViewType }), [initialViewType]);
    const view = (_a = stack[stack.length - 1]) !== null && _a !== void 0 ? _a : initialView;
    const { clearError } = useErrorContext();
    const pushView = useCallback((type, props, events) => {
        if (view.type === type)
            return;
        clearError();
        // If the stack was "empty" (i.e. showing a default view), let's make sure the stack
        // reflects this by having this default view as the first item in the stack
        setStack((stack) => {
            if (stack.length === 0)
                return [{ type: initialViewType }, { events, props, type }];
            else
                return [...stack, { events, props, type }];
        });
    }, [clearError, view.type, initialViewType]);
    const replaceView = useCallback((type, props, events) => {
        if (view.type === type)
            return;
        clearError();
        setStack((prev) => [...prev.slice(0, -1), { events, props, type }]);
    }, [clearError, view]);
    const canGoBack = stack.length > 1;
    const goBack = useCallback(() => {
        if (!canGoBack)
            return;
        clearError();
        setStack((prev) => prev.slice(0, -1));
    }, [canGoBack, clearError]);
    const clearStackAndPush = useCallback((type, props, events) => {
        clearError();
        setStack([{ events, props, type }]);
    }, [clearError]);
    const clearStackAndPushInitialView = useCallback(() => {
        clearError();
        setStack((stack) => {
            if (stack.length > 0)
                return [];
            return stack;
        });
    }, [clearError]);
    useInternalDynamicEvents('logout', clearStackAndPushInitialView);
    // Wait for the auth flow animation transition to finish before clearing the stack
    useInternalDynamicEvents('authFlowClose', () => setTimeout(clearStackAndPushInitialView, 10));
    const value = useMemo(() => ({
        canGoBack: stack.length > 1,
        clearStackAndPush,
        clearStackAndPushInitialView,
        goBack,
        pushView,
        replaceView,
        stack,
        view,
    }), [
        clearStackAndPushInitialView,
        goBack,
        clearStackAndPush,
        pushView,
        view,
        stack,
        replaceView,
    ]);
    return jsxRuntimeExports.jsx(ViewContext.Provider, { value: value, children: children });
};
const useViewContext = () => {
    const context = useContext(ViewContext);
    if (context === undefined) {
        throw new Error('usage of useViewContext not wrapped in `ViewContextProvider`.');
    }
    return context;
};

const createWallet = (walletBook, walletConnector) => {
    var _a;
    const walletBookWallet = findWalletBookWallet(walletBook, walletConnector.key);
    return {
        chainGroup: walletConnector.metadata.groupKey,
        group: walletConnector.metadata.groupKey,
        injectedConfig: walletBookWallet === null || walletBookWallet === void 0 ? void 0 : walletBookWallet.injectedConfig,
        isInstalledOnBrowser: (_a = walletConnector.isInstalledOnBrowser()) !== null && _a !== void 0 ? _a : false,
        key: walletConnector.key,
        name: walletConnector.name,
        walletConnector: walletConnector,
        walletGroup: walletConnector.metadata.groupKey,
    };
};

const convertHexToRGBA = (hex, alpha = 1) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
};

const TEXT_LIGHT_PRIMARY = '#363A46';
convertHexToRGBA(TEXT_LIGHT_PRIMARY, 0.65);
convertHexToRGBA(TEXT_LIGHT_PRIMARY, 0.4);
const TEXT_DARK_BASE = '#F5F8FF';
convertHexToRGBA(TEXT_DARK_BASE, 0.95);
convertHexToRGBA(TEXT_DARK_BASE, 0.55);
convertHexToRGBA(TEXT_DARK_BASE, 0.4);

const DEFAULT_NUMBER_OF_WALLETS_TO_SHOW = 10;
// references:
// https://www.iana.org/assignments/jwt/jwt.xhtml#claims
// https://github.com/jaredhanson/id-blockchain-claims-in-jwt/blob/main/draft.md
const ChainEnumToVerifiedCredentialName = {
    ALGO: 'algorand',
    BTC: 'bip122', // see: https://namespaces.chainagnostic.org/bip122/caip2
    COSMOS: 'cosmos',
    ETH: 'eip155',
    EVM: 'eip155',
    FLOW: 'flow',
    SOL: 'solana',
    STARK: 'starknet',
};
const VerifiedCredentialNameToChainEnum = {
    algorand: ChainEnum.Algo,
    bip122: ChainEnum.Btc,
    cosmos: ChainEnum.Cosmos,
    eip155: ChainEnum.Evm,
    flow: ChainEnum.Flow,
    solana: ChainEnum.Sol,
    starknet: ChainEnum.Stark,
};
const DYNAMIC_AUTH_COOKIE_NAME = 'DYNAMIC_JWT_TOKEN';

var countryList = {};

var require$$0 = [
	{
		code: "AD",
		name: "Andorra"
	},
	{
		code: "AE",
		name: "United Arab Emirates"
	},
	{
		code: "AF",
		name: "Afghanistan"
	},
	{
		code: "AG",
		name: "Antigua and Barbuda"
	},
	{
		code: "AI",
		name: "Anguilla"
	},
	{
		code: "AL",
		name: "Albania"
	},
	{
		code: "AM",
		name: "Armenia"
	},
	{
		code: "AO",
		name: "Angola"
	},
	{
		code: "AQ",
		name: "Antarctica"
	},
	{
		code: "AR",
		name: "Argentina"
	},
	{
		code: "AS",
		name: "American Samoa"
	},
	{
		code: "AT",
		name: "Austria"
	},
	{
		code: "AU",
		name: "Australia"
	},
	{
		code: "AW",
		name: "Aruba"
	},
	{
		code: "AX",
		name: "Åland Islands"
	},
	{
		code: "AZ",
		name: "Azerbaijan"
	},
	{
		code: "BA",
		name: "Bosnia and Herzegovina"
	},
	{
		code: "BB",
		name: "Barbados"
	},
	{
		code: "BD",
		name: "Bangladesh"
	},
	{
		code: "BE",
		name: "Belgium"
	},
	{
		code: "BF",
		name: "Burkina Faso"
	},
	{
		code: "BG",
		name: "Bulgaria"
	},
	{
		code: "BH",
		name: "Bahrain"
	},
	{
		code: "BI",
		name: "Burundi"
	},
	{
		code: "BJ",
		name: "Benin"
	},
	{
		code: "BL",
		name: "Saint Barthélemy"
	},
	{
		code: "BM",
		name: "Bermuda"
	},
	{
		code: "BN",
		name: "Brunei Darussalam"
	},
	{
		code: "BO",
		name: "Bolivia, Plurinational State of"
	},
	{
		code: "BQ",
		name: "Bonaire, Sint Eustatius and Saba"
	},
	{
		code: "BR",
		name: "Brazil"
	},
	{
		code: "BS",
		name: "Bahamas"
	},
	{
		code: "BT",
		name: "Bhutan"
	},
	{
		code: "BV",
		name: "Bouvet Island"
	},
	{
		code: "BW",
		name: "Botswana"
	},
	{
		code: "BY",
		name: "Belarus"
	},
	{
		code: "BZ",
		name: "Belize"
	},
	{
		code: "CA",
		name: "Canada"
	},
	{
		code: "CC",
		name: "Cocos (Keeling) Islands"
	},
	{
		code: "CD",
		name: "Congo, Democratic Republic of the"
	},
	{
		code: "CF",
		name: "Central African Republic"
	},
	{
		code: "CG",
		name: "Congo"
	},
	{
		code: "CH",
		name: "Switzerland"
	},
	{
		code: "CI",
		name: "Côte d'Ivoire"
	},
	{
		code: "CK",
		name: "Cook Islands"
	},
	{
		code: "CL",
		name: "Chile"
	},
	{
		code: "CM",
		name: "Cameroon"
	},
	{
		code: "CN",
		name: "China"
	},
	{
		code: "CO",
		name: "Colombia"
	},
	{
		code: "CR",
		name: "Costa Rica"
	},
	{
		code: "CU",
		name: "Cuba"
	},
	{
		code: "CV",
		name: "Cabo Verde"
	},
	{
		code: "CW",
		name: "Curaçao"
	},
	{
		code: "CX",
		name: "Christmas Island"
	},
	{
		code: "CY",
		name: "Cyprus"
	},
	{
		code: "CZ",
		name: "Czechia"
	},
	{
		code: "DE",
		name: "Germany"
	},
	{
		code: "DJ",
		name: "Djibouti"
	},
	{
		code: "DK",
		name: "Denmark"
	},
	{
		code: "DM",
		name: "Dominica"
	},
	{
		code: "DO",
		name: "Dominican Republic"
	},
	{
		code: "DZ",
		name: "Algeria"
	},
	{
		code: "EC",
		name: "Ecuador"
	},
	{
		code: "EE",
		name: "Estonia"
	},
	{
		code: "EG",
		name: "Egypt"
	},
	{
		code: "EH",
		name: "Western Sahara"
	},
	{
		code: "ER",
		name: "Eritrea"
	},
	{
		code: "ES",
		name: "Spain"
	},
	{
		code: "ET",
		name: "Ethiopia"
	},
	{
		code: "FI",
		name: "Finland"
	},
	{
		code: "FJ",
		name: "Fiji"
	},
	{
		code: "FK",
		name: "Falkland Islands (Malvinas)"
	},
	{
		code: "FM",
		name: "Micronesia, Federated States of"
	},
	{
		code: "FO",
		name: "Faroe Islands"
	},
	{
		code: "FR",
		name: "France"
	},
	{
		code: "GA",
		name: "Gabon"
	},
	{
		code: "GB",
		name: "United Kingdom of Great Britain and Northern Ireland"
	},
	{
		code: "GD",
		name: "Grenada"
	},
	{
		code: "GE",
		name: "Georgia"
	},
	{
		code: "GF",
		name: "French Guiana"
	},
	{
		code: "GG",
		name: "Guernsey"
	},
	{
		code: "GH",
		name: "Ghana"
	},
	{
		code: "GI",
		name: "Gibraltar"
	},
	{
		code: "GL",
		name: "Greenland"
	},
	{
		code: "GM",
		name: "Gambia"
	},
	{
		code: "GN",
		name: "Guinea"
	},
	{
		code: "GP",
		name: "Guadeloupe"
	},
	{
		code: "GQ",
		name: "Equatorial Guinea"
	},
	{
		code: "GR",
		name: "Greece"
	},
	{
		code: "GS",
		name: "South Georgia and the South Sandwich Islands"
	},
	{
		code: "GT",
		name: "Guatemala"
	},
	{
		code: "GU",
		name: "Guam"
	},
	{
		code: "GW",
		name: "Guinea-Bissau"
	},
	{
		code: "GY",
		name: "Guyana"
	},
	{
		code: "HK",
		name: "Hong Kong"
	},
	{
		code: "HM",
		name: "Heard Island and McDonald Islands"
	},
	{
		code: "HN",
		name: "Honduras"
	},
	{
		code: "HR",
		name: "Croatia"
	},
	{
		code: "HT",
		name: "Haiti"
	},
	{
		code: "HU",
		name: "Hungary"
	},
	{
		code: "ID",
		name: "Indonesia"
	},
	{
		code: "IE",
		name: "Ireland"
	},
	{
		code: "IL",
		name: "Israel"
	},
	{
		code: "IM",
		name: "Isle of Man"
	},
	{
		code: "IN",
		name: "India"
	},
	{
		code: "IO",
		name: "British Indian Ocean Territory"
	},
	{
		code: "IQ",
		name: "Iraq"
	},
	{
		code: "IR",
		name: "Iran, Islamic Republic of"
	},
	{
		code: "IS",
		name: "Iceland"
	},
	{
		code: "IT",
		name: "Italy"
	},
	{
		code: "JE",
		name: "Jersey"
	},
	{
		code: "JM",
		name: "Jamaica"
	},
	{
		code: "JO",
		name: "Jordan"
	},
	{
		code: "JP",
		name: "Japan"
	},
	{
		code: "KE",
		name: "Kenya"
	},
	{
		code: "KG",
		name: "Kyrgyzstan"
	},
	{
		code: "KH",
		name: "Cambodia"
	},
	{
		code: "KI",
		name: "Kiribati"
	},
	{
		code: "KM",
		name: "Comoros"
	},
	{
		code: "KN",
		name: "Saint Kitts and Nevis"
	},
	{
		code: "KP",
		name: "Korea, Democratic People's Republic of"
	},
	{
		code: "KR",
		name: "Korea, Republic of"
	},
	{
		code: "KW",
		name: "Kuwait"
	},
	{
		code: "KY",
		name: "Cayman Islands"
	},
	{
		code: "KZ",
		name: "Kazakhstan"
	},
	{
		code: "LA",
		name: "Lao People's Democratic Republic"
	},
	{
		code: "LB",
		name: "Lebanon"
	},
	{
		code: "LC",
		name: "Saint Lucia"
	},
	{
		code: "LI",
		name: "Liechtenstein"
	},
	{
		code: "LK",
		name: "Sri Lanka"
	},
	{
		code: "LR",
		name: "Liberia"
	},
	{
		code: "LS",
		name: "Lesotho"
	},
	{
		code: "LT",
		name: "Lithuania"
	},
	{
		code: "LU",
		name: "Luxembourg"
	},
	{
		code: "LV",
		name: "Latvia"
	},
	{
		code: "LY",
		name: "Libya"
	},
	{
		code: "MA",
		name: "Morocco"
	},
	{
		code: "MC",
		name: "Monaco"
	},
	{
		code: "MD",
		name: "Moldova, Republic of"
	},
	{
		code: "ME",
		name: "Montenegro"
	},
	{
		code: "MF",
		name: "Saint Martin, (French part)"
	},
	{
		code: "MG",
		name: "Madagascar"
	},
	{
		code: "MH",
		name: "Marshall Islands"
	},
	{
		code: "MK",
		name: "North Macedonia"
	},
	{
		code: "ML",
		name: "Mali"
	},
	{
		code: "MM",
		name: "Myanmar"
	},
	{
		code: "MN",
		name: "Mongolia"
	},
	{
		code: "MO",
		name: "Macao"
	},
	{
		code: "MP",
		name: "Northern Mariana Islands"
	},
	{
		code: "MQ",
		name: "Martinique"
	},
	{
		code: "MR",
		name: "Mauritania"
	},
	{
		code: "MS",
		name: "Montserrat"
	},
	{
		code: "MT",
		name: "Malta"
	},
	{
		code: "MU",
		name: "Mauritius"
	},
	{
		code: "MV",
		name: "Maldives"
	},
	{
		code: "MW",
		name: "Malawi"
	},
	{
		code: "MX",
		name: "Mexico"
	},
	{
		code: "MY",
		name: "Malaysia"
	},
	{
		code: "MZ",
		name: "Mozambique"
	},
	{
		code: "NA",
		name: "Namibia"
	},
	{
		code: "NC",
		name: "New Caledonia"
	},
	{
		code: "NE",
		name: "Niger"
	},
	{
		code: "NF",
		name: "Norfolk Island"
	},
	{
		code: "NG",
		name: "Nigeria"
	},
	{
		code: "NI",
		name: "Nicaragua"
	},
	{
		code: "NL",
		name: "Netherlands"
	},
	{
		code: "NO",
		name: "Norway"
	},
	{
		code: "NP",
		name: "Nepal"
	},
	{
		code: "NR",
		name: "Nauru"
	},
	{
		code: "NU",
		name: "Niue"
	},
	{
		code: "NZ",
		name: "New Zealand"
	},
	{
		code: "OM",
		name: "Oman"
	},
	{
		code: "PA",
		name: "Panama"
	},
	{
		code: "PE",
		name: "Peru"
	},
	{
		code: "PF",
		name: "French Polynesia"
	},
	{
		code: "PG",
		name: "Papua New Guinea"
	},
	{
		code: "PH",
		name: "Philippines"
	},
	{
		code: "PK",
		name: "Pakistan"
	},
	{
		code: "PL",
		name: "Poland"
	},
	{
		code: "PM",
		name: "Saint Pierre and Miquelon"
	},
	{
		code: "PN",
		name: "Pitcairn"
	},
	{
		code: "PR",
		name: "Puerto Rico"
	},
	{
		code: "PS",
		name: "Palestine, State of"
	},
	{
		code: "PT",
		name: "Portugal"
	},
	{
		code: "PW",
		name: "Palau"
	},
	{
		code: "PY",
		name: "Paraguay"
	},
	{
		code: "QA",
		name: "Qatar"
	},
	{
		code: "RE",
		name: "Réunion"
	},
	{
		code: "RO",
		name: "Romania"
	},
	{
		code: "RS",
		name: "Serbia"
	},
	{
		code: "RU",
		name: "Russian Federation"
	},
	{
		code: "RW",
		name: "Rwanda"
	},
	{
		code: "SA",
		name: "Saudi Arabia"
	},
	{
		code: "SB",
		name: "Solomon Islands"
	},
	{
		code: "SC",
		name: "Seychelles"
	},
	{
		code: "SD",
		name: "Sudan"
	},
	{
		code: "SE",
		name: "Sweden"
	},
	{
		code: "SG",
		name: "Singapore"
	},
	{
		code: "SH",
		name: "Saint Helena, Ascension and Tristan da Cunha"
	},
	{
		code: "SI",
		name: "Slovenia"
	},
	{
		code: "SJ",
		name: "Svalbard and Jan Mayen"
	},
	{
		code: "SK",
		name: "Slovakia"
	},
	{
		code: "SL",
		name: "Sierra Leone"
	},
	{
		code: "SM",
		name: "San Marino"
	},
	{
		code: "SN",
		name: "Senegal"
	},
	{
		code: "SO",
		name: "Somalia"
	},
	{
		code: "SR",
		name: "Suriname"
	},
	{
		code: "SS",
		name: "South Sudan"
	},
	{
		code: "ST",
		name: "Sao Tome and Principe"
	},
	{
		code: "SV",
		name: "El Salvador"
	},
	{
		code: "SX",
		name: "Sint Maarten, (Dutch part)"
	},
	{
		code: "SY",
		name: "Syrian Arab Republic"
	},
	{
		code: "SZ",
		name: "Eswatini"
	},
	{
		code: "TC",
		name: "Turks and Caicos Islands"
	},
	{
		code: "TD",
		name: "Chad"
	},
	{
		code: "TF",
		name: "French Southern Territories"
	},
	{
		code: "TG",
		name: "Togo"
	},
	{
		code: "TH",
		name: "Thailand"
	},
	{
		code: "TJ",
		name: "Tajikistan"
	},
	{
		code: "TK",
		name: "Tokelau"
	},
	{
		code: "TL",
		name: "Timor-Leste"
	},
	{
		code: "TM",
		name: "Turkmenistan"
	},
	{
		code: "TN",
		name: "Tunisia"
	},
	{
		code: "TO",
		name: "Tonga"
	},
	{
		code: "TR",
		name: "Türkiye"
	},
	{
		code: "TT",
		name: "Trinidad and Tobago"
	},
	{
		code: "TV",
		name: "Tuvalu"
	},
	{
		code: "TW",
		name: "Taiwan, Province of China"
	},
	{
		code: "TZ",
		name: "Tanzania, United Republic of"
	},
	{
		code: "UA",
		name: "Ukraine"
	},
	{
		code: "UG",
		name: "Uganda"
	},
	{
		code: "UM",
		name: "United States Minor Outlying Islands"
	},
	{
		code: "US",
		name: "United States of America"
	},
	{
		code: "UY",
		name: "Uruguay"
	},
	{
		code: "UZ",
		name: "Uzbekistan"
	},
	{
		code: "VA",
		name: "Holy See"
	},
	{
		code: "VC",
		name: "Saint Vincent and the Grenadines"
	},
	{
		code: "VE",
		name: "Venezuela, Bolivarian Republic of"
	},
	{
		code: "VG",
		name: "Virgin Islands, British"
	},
	{
		code: "VI",
		name: "Virgin Islands, U.S."
	},
	{
		code: "VN",
		name: "Viet Nam"
	},
	{
		code: "VU",
		name: "Vanuatu"
	},
	{
		code: "WF",
		name: "Wallis and Futuna"
	},
	{
		code: "WS",
		name: "Samoa"
	},
	{
		code: "YE",
		name: "Yemen"
	},
	{
		code: "YT",
		name: "Mayotte"
	},
	{
		code: "ZA",
		name: "South Africa"
	},
	{
		code: "ZM",
		name: "Zambia"
	},
	{
		code: "ZW",
		name: "Zimbabwe"
	}
];

var hasRequiredCountryList;

function requireCountryList () {
	if (hasRequiredCountryList) return countryList;
	hasRequiredCountryList = 1;

	var data = require$$0;

	/** Precompute name and code lookups. */
	var nameMap = {};
	var codeMap = {};
	data.forEach(mapCodeAndName);

	function mapCodeAndName (country) {
	  nameMap[country.name.toLowerCase()] = country.code;
	  codeMap[country.code.toLowerCase()] = country.name;
	}

	countryList.overwrite = function overwrite (countries) {
	  if (!countries || !countries.length) return
	  countries.forEach(function (country) {
	    var foundIndex = data.findIndex(function (item) {
	      return item.code === country.code
	    });
	    data[foundIndex] = country;
	    mapCodeAndName(country);
	  });
	};

	countryList.getCode = function getCode (name) {
	  return nameMap[name.toLowerCase()]
	};

	countryList.getName = function getName (code) {
	  return codeMap[code.toLowerCase()]
	};

	countryList.getNames = function getNames () {
	  return data.map(function (country) {
	    return country.name
	  })
	};

	countryList.getCodes = function getCodes () {
	  return data.map(function (country) {
	    return country.code
	  })
	};

	countryList.getCodeList = function getCodeList () {
	  return codeMap
	};

	countryList.getNameList = function getNameList () {
	  return nameMap
	};

	countryList.getData = function getData () {
	  return data
	};
	return countryList;
}

var countryListExports = requireCountryList();

const tShirtSizes = ['XS', 'S', 'M', 'L', 'XL', '2XL'];
// getData will contain a list of country codes and names
// eg: [ { code: "AU", name: "Australia" }]
const countryCodes = countryListExports.getData();
// see: dyn-1131 - this is a hardcoded list for animoca
// these will be removed once we have custom fields
const teamNames = [
    'Brunei DS',
    'Cambodia',
    'Indonesia',
    'Laos',
    'Malaysia',
    'Myanmar',
    'Philippines',
    'Singapore',
    'Thailand',
    'Vietnam',
];
const defaultWalletsForChains = {
    primary_chain: 'evm',
    wallets: {
        algorand: 'perawallet',
        bitcoin: 'xverse',
        cosmos: 'keplr',
        evm: 'metamask',
        flow: 'blocto',
        solana: 'phantom',
    },
};
// z-index
const tooltipZIndex = 2147483647;
const toolkitZIndex = 2147483646;
const authModalZIndex = 2147483645;
const widgetModalZIndex = 2147483643;

/**
 * This object is needed because the selected symbols default value from
 * getChainInfo differs from the one used in the wallet connectors
 */
const chainInfoOverrides = {
    starknet: 'STARK',
};
const getEnabledChains = (chains) => chains
    .filter(({ enabled }) => enabled)
    .map(({ name }) => { var _a, _b; return (_a = chainInfoOverrides[name]) !== null && _a !== void 0 ? _a : (_b = getChainInfo(name)) === null || _b === void 0 ? void 0 : _b.symbol; })
    .filter((chain) => Boolean(chain));
const getWallets = (props) => {
    var _a;
    return getEnabledWallets({
        enabledChains: getEnabledChains(props.getSupportedWalletOpts.settings.chains),
        getSupportedWalletOpts: Object.assign(Object.assign({}, props.getSupportedWalletOpts), { chainRpcProviders: ChainRpcProviders, walletConnectProjectId: (_a = props.getSupportedWalletOpts.settings.sdk.walletConnect) === null || _a === void 0 ? void 0 : _a.projectId }),
    }).map((wallet) => {
        var _a;
        (_a = props.walletConnectorExtensions) === null || _a === void 0 ? void 0 : _a.forEach((extension) => {
            var _a;
            return wallet.extend(extension, {
                walletConnectDappProjectId: (_a = props.getSupportedWalletOpts.settings.sdk.walletConnect) === null || _a === void 0 ? void 0 : _a.walletProjectId,
            });
        });
        return createWallet(props.getSupportedWalletOpts.walletBook, wallet);
    });
};

const parseToken = (token) => {
    var _a;
    if (!token)
        return undefined;
    const base64 = (_a = token.split('.')[1]) === null || _a === void 0 ? void 0 : _a.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = base64 &&
        decodeURIComponent(atob(base64)
            .split('')
            .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
            .join(''));
    return JSON.parse(jsonPayload);
};

const decodeJwt = (token) => {
    try {
        const json = parseToken(token);
        if (!json)
            return undefined;
        return DynamicJwtFromJSON(json);
    }
    catch (e) {
        logger$1.error(e);
        return undefined;
    }
};

const decodeMinJwt = (token) => {
    try {
        const json = parseToken(token);
        if (!json)
            return undefined;
        return MinifiedDynamicJwtFromJSON(json);
    }
    catch (e) {
        logger$1.error(e);
        return undefined;
    }
};

const AUTH_TOKEN = 'dynamic_authentication_token';
const AUTH_MIN_TOKEN = 'dynamic_min_authentication_token';
const DEVICE_FINGERPRINT = 'dynamic_device_fingerprint';
const AUTH_EXPIRES_AT = 'dynamic_auth_expires_at';
const LAST_USED_WALLET = 'dynamic_last_used_wallet';
const WALLET_PICKER_SEARCH_KEY = 'dynamic_wallet_picker_search';
const NEWTOWEB3_WALLET_EXTENSION_FLAG_KEY = 'dynamic_newtoweb3_wallet_extension_installed';
const CONNECTED_WALLETS_INFO = 'dynamic_connected_wallets';
const CONNECTED_WALLET_NAME_SERVICE = 'dynamic_connected_wallet_ns';
const BRIDGE_ONBOARDING_COMPLETED = 'dynamic_bridge_onboarding_completed';
const DYNAMIC_CONTEXT_LAST_SESSION_SETTINGS = 'dynamic_context_session_settings';
const WAGMI_LAST_SESSION_SETTINGS = 'dynamic_wagmi_session_settings';
const EMBEDDED_WALLET_SESSION_SETTINGS = 'dynamic_embedded_wallet_session_settings';
const EMBEDDED_WALLET_SECURE_BANNER = 'dynamic_embedded_secure_banner';
const PHONE_INPUT_DEFAULT_COUNTRY = 'dynamic_phone_input_default_country';
const CAPTCHA_TOKEN = 'dynamic_captcha_token';
/**
 * Used to identify the purpose of a signature after phantom redirects back to the app in mobile
 */
const PHANTOM_SIGNATURE_STATE = 'phantom_verification_type';
const STORE_STORAGE_KEY = 'dynamic_store';
const SECURE_ENCLAVE_WALLET_SESSION_KEYS = 'dynamic_secure_enclave_session_keys';
const SECURE_ENCLAVE_WALLET_SESSION_KEYS_STORAGE_OPTIONS = {
    priority: ['secureStorage', 'localStorage'],
};

const getExpiresAt = () => StorageService.getItem(AUTH_EXPIRES_AT);

let logoutTimer;
let dynamicContextSettingsTimer;
let wagmiSettingsTimer;
const sdkSettingsTimeout = 24 * 60 * 60 * 1000; // 24 hours
const isMinAuthTokenExpired = (token) => {
    const decoded = decodeMinJwt(token);
    return isTokenExpired(decoded);
};
const isAuthTokenExpired = (token) => {
    const decoded = decodeJwt(token);
    return isTokenExpired(decoded);
};
const isTokenExpired = (decoded) => {
    if (!decoded) {
        return true;
    }
    if (!decoded.exp) {
        return true;
    }
    const expirationTime = new Date(decoded.exp * 1000).getTime();
    const currentTime = new Date().getTime();
    if (currentTime >= expirationTime) {
        return true;
    }
    return false;
};
const initExpirationTime = (logout) => {
    const expiresAt = getExpiresAt();
    if (!expiresAt)
        return clearTimeout(logoutTimer);
    const expirationTime = new Date(expiresAt * 1000).getTime();
    const currentTime = new Date().getTime();
    if (currentTime >= expirationTime) {
        clearTimeout(logoutTimer);
        return logout();
    }
    const expirationTimeInMs = expirationTime - currentTime;
    // If value is greater than 2,147,483,647 ms (about 24.8 days), there's an integer overflow
    // and the callback will fire imediately
    // https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value
    const expiryTimeout = Math.min(expirationTimeInMs, 2147483647);
    logoutTimer = setTimeout(logout, expiryTimeout);
};
const getInitialViewType = ({ connectedWallets, isBridgeFlow, bridgeOnboardingCompleted, isAuthenticated, isMultiWalletEnabled, }) => {
    // when multiwallet enabled, and user wants to link wallet
    // show wallet-list view
    if (isAuthenticated || bridgeOnboardingCompleted) {
        return isMultiWalletEnabled ? 'multi-wallet-wallet-list' : 'wallet-list';
    }
    if (isBridgeFlow && !connectedWallets.length) {
        return 'bridge-welcome';
    }
    return 'login-with-email-or-wallet';
};
const setDynamicContextSessionSettings = () => {
    setSessionSettings(DYNAMIC_CONTEXT_LAST_SESSION_SETTINGS);
    dynamicContextSettingsTimer = setTimeout(isDynamicContextSessionSettingExpired, sdkSettingsTimeout);
};
const setWagmiSessionSettings = () => {
    setSessionSettings(WAGMI_LAST_SESSION_SETTINGS);
    wagmiSettingsTimer = setTimeout(isWagmiSessionSettingExpired, sdkSettingsTimeout);
};
const setSessionSettings = (lsKey) => {
    const timestamp = new Date().getTime();
    StorageService.setItem(lsKey, timestamp.toString());
};
const isDynamicContextSessionSettingExpired = () => isSettingExpired(DYNAMIC_CONTEXT_LAST_SESSION_SETTINGS, dynamicContextSettingsTimer);
const isWagmiSessionSettingExpired = () => isSettingExpired(WAGMI_LAST_SESSION_SETTINGS, wagmiSettingsTimer);
const isSettingExpired = (lsKey, timer) => {
    const lastSentTime = StorageService.getItem(lsKey);
    // should set new time
    if (!lastSentTime) {
        return true;
    }
    const lastSentTimestamp = parseInt(lastSentTime);
    const currentTime = new Date().getTime();
    if (currentTime - lastSentTimestamp > sdkSettingsTimeout) {
        // Reset session-related data here
        clearTimeout(timer);
        StorageService.removeItem(lsKey);
        return true;
    }
    return false;
};
const resolveNetworkValidationMode = ({ networkValidationMode, bridgeChains, }) => {
    if (networkValidationMode) {
        return networkValidationMode;
    }
    if (bridgeChains) {
        return 'always';
    }
    return 'sign-in';
};
const getDeepLinkPreference = (deepLinkPreferenceProp, isBridgeFlow) => {
    if (isBridgeFlow) {
        return 'universal';
    }
    return deepLinkPreferenceProp;
};

const getAuthToken = () => {
    if (typeof window === 'undefined') {
        return undefined;
    }
    const token = StorageService.getItem(AUTH_TOKEN, {
        priority: ['secureStorage', 'localStorage'],
    });
    if (!token) {
        return undefined;
    }
    if (isAuthTokenExpired(token)) {
        return undefined;
    }
    return token;
};

const getMinAuthToken = () => {
    if (typeof window === 'undefined')
        return undefined;
    const token = StorageService.getItem(AUTH_MIN_TOKEN, {
        priority: ['secureStorage', 'localStorage'],
    });
    if (!token || isMinAuthTokenExpired(token))
        return undefined;
    return token;
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function _extends$1E() {
  return _extends$1E = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1E.apply(null, arguments);
}

function warn() {
  if (console && console.warn) {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (typeof args[0] === 'string') args[0] = `react-i18next:: ${args[0]}`;
    console.warn(...args);
  }
}
const alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn(...args);
}
const loadedClb = (i18n, cb) => () => {
  if (i18n.isInitialized) {
    cb();
  } else {
    const initialized = () => {
      setTimeout(() => {
        i18n.off('initialized', initialized);
      }, 0);
      cb();
    };
    i18n.on('initialized', initialized);
  }
};
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
function loadLanguages(i18n, lng, ns, cb) {
  if (typeof ns === 'string') ns = [ns];
  ns.forEach(n => {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
}
function oldI18nextHasLoadedNamespace(ns, i18n) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const lng = i18n.languages[0];
  const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  const lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;
  const loadNotPending = (l, n) => {
    const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
    return loadState === -1 || loadState === 2;
  };
  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}
function hasLoadedNamespace(ns, i18n) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }
  const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }
  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: (i18nInstance, loadNotPending) => {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}

const matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};
const unescapeHtmlEntity = m => htmlEntities[m];
const unescape$1 = text => text.replace(matchHtmlEntity, unescapeHtmlEntity);

let defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape$1
};
function setDefaults() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = {
    ...defaultOptions,
    ...options
  };
}
function getDefaults() {
  return defaultOptions;
}

let i18nInstance;
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}

const initReactI18next = {
  type: '3rdParty',
  init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

const I18nContext = createContext();
class ReportNamespaces {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(namespaces) {
    namespaces.forEach(ns => {
      if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}

const usePrevious$1 = (value, ignore) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value, ignore]);
  return ref.current;
};
function useTranslation(ns) {
  let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    i18n: i18nFromProps
  } = props;
  const {
    i18n: i18nFromContext,
    defaultNS: defaultNSFromContext
  } = useContext(I18nContext) || {};
  const i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();
  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');
    const notReadyT = (k, optsOrDefaultValue) => {
      if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
      if (optsOrDefaultValue && typeof optsOrDefaultValue === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
      return Array.isArray(k) ? k[k.length - 1] : k;
    };
    const retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }
  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
  const i18nOptions = {
    ...getDefaults(),
    ...i18n.options.react,
    ...props
  };
  const {
    useSuspense,
    keyPrefix
  } = i18nOptions;
  let namespaces = defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(n => hasLoadedNamespace(n, i18n, i18nOptions));
  function getT() {
    return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }
  const [t, setT] = useState(getT);
  let joinedNS = namespaces.join();
  if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
  const previousJoinedNS = usePrevious$1(joinedNS);
  const isMounted = useRef(true);
  useEffect(() => {
    const {
      bindI18n,
      bindI18nStore
    } = i18nOptions;
    isMounted.current = true;
    if (!ready && !useSuspense) {
      if (props.lng) {
        loadLanguages(i18n, props.lng, namespaces, () => {
          if (isMounted.current) setT(getT);
        });
      } else {
        loadNamespaces(i18n, namespaces, () => {
          if (isMounted.current) setT(getT);
        });
      }
    }
    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }
    function boundReset() {
      if (isMounted.current) setT(getT);
    }
    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return () => {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(e => i18n.off(e, boundReset));
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(e => i18n.store.off(e, boundReset));
    };
  }, [i18n, joinedNS]);
  const isInitial = useRef(true);
  useEffect(() => {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }
    isInitial.current = false;
  }, [i18n, keyPrefix]);
  const ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(resolve => {
    if (props.lng) {
      loadLanguages(i18n, props.lng, namespaces, () => resolve());
    } else {
      loadNamespaces(i18n, namespaces, () => resolve());
    }
  });
}

function I18nextProvider(_ref) {
  let {
    i18n,
    defaultNS,
    children
  } = _ref;
  const value = useMemo(() => ({
    i18n,
    defaultNS
  }), [i18n, defaultNS]);
  return createElement(I18nContext.Provider, {
    value
  }, children);
}

const isClassNamesObjectArg = (arg) => typeof arg === 'object';

const classNames = (...args) => {
    const classes1 = args.reduce((classes, arg) => {
        if (isString$1(arg)) {
            return [...classes, arg];
        }
        if (isClassNamesObjectArg(arg)) {
            const keys = Object.keys(arg);
            const validClasses = keys
                .map((key) => {
                if (arg[key]) {
                    return key;
                }
                return null;
            })
                .filter(isString$1);
            return [...classes, ...validClasses];
        }
        return classes;
    }, []);
    return classes1.join(' ');
};

const useLocalStorage = (key, initialValue, valueValidator, otherKeysToRemove) => {
    const intialValueRef = useRef(initialValue);
    intialValueRef.current = initialValue;
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = StorageService.getItem(key);
            if (item && valueValidator && !valueValidator(item)) {
                StorageService.removeItem(key);
                otherKeysToRemove === null || otherKeysToRemove === void 0 ? void 0 : otherKeysToRemove.forEach((k) => StorageService.removeItem(k));
                return intialValueRef.current;
            }
            else {
                return item !== null && item !== void 0 ? item : intialValueRef.current;
            }
        }
        catch (error) {
            logger$1.error(error);
            return intialValueRef.current;
        }
    });
    const setValue = useCallback((value) => {
        try {
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            StorageService.setItem(key, valueToStore);
        }
        catch (error) {
            logger$1.error(error);
        }
    }, [key, storedValue]);
    const removeValue = useCallback(() => {
        StorageService.removeItem(key);
        setStoredValue(intialValueRef.current);
    }, [key]);
    return [storedValue, setValue, removeValue];
};

const CaptchaContext = createContext(undefined);
const CaptchaContextProvider = ({ children, }) => {
    const { pushView } = useViewContext();
    const [captchaToken, setCaptchaToken, removeCaptchaToken] = useLocalStorage(CAPTCHA_TOKEN, undefined);
    const [captchaAuthState, setCaptchaAuthState] = useState();
    const engageCaptcha = useCallback(({ authMethod, onCaptchaSuccess, }) => {
        setCaptchaAuthState({ authMethod, onCaptchaSuccess });
        pushView('captcha');
    }, [pushView, setCaptchaAuthState]);
    const getCaptchaToken = useCallback(() => {
        const token = captchaToken;
        removeCaptchaToken();
        return token;
    }, [captchaToken, removeCaptchaToken]);
    const value = useMemo(() => ({
        captchaAuthState,
        engageCaptcha,
        getCaptchaToken,
        removeCaptchaToken,
        setCaptchaAuthState,
        setCaptchaToken,
    }), [
        captchaAuthState,
        getCaptchaToken,
        engageCaptcha,
        setCaptchaAuthState,
        setCaptchaToken,
        removeCaptchaToken,
    ]);
    return (jsxRuntimeExports.jsx(CaptchaContext.Provider, { value: value, children: children }));
};
const useCaptchaContext = () => {
    const context = useContext(CaptchaContext);
    if (context === undefined) {
        throw new Error('usage of useCaptchaContext not wrapped in `CaptchaContextProvider`.');
    }
    return context;
};

var R=[["Afghanistan","af","93"],["Albania","al","355"],["Algeria","dz","213"],["Andorra","ad","376"],["Angola","ao","244"],["Antigua and Barbuda","ag","1268"],["Argentina","ar","54","(..) ........",0],["Armenia","am","374",".. ......"],["Aruba","aw","297"],["Australia","au","61",{default:". .... ....","/^4/":"... ... ...","/^5(?!50)/":"... ... ...","/^1(3|8)00/":".... ... ...","/^13/":".. .. ..","/^180/":"... ...."},0,[]],["Austria","at","43"],["Azerbaijan","az","994","(..) ... .. .."],["Bahamas","bs","1242"],["Bahrain","bh","973"],["Bangladesh","bd","880"],["Barbados","bb","1246"],["Belarus","by","375","(..) ... .. .."],["Belgium","be","32","... .. .. .."],["Belize","bz","501"],["Benin","bj","229"],["Bhutan","bt","975"],["Bolivia","bo","591"],["Bosnia and Herzegovina","ba","387"],["Botswana","bw","267"],["Brazil","br","55","(..) ........."],["British Indian Ocean Territory","io","246"],["Brunei","bn","673"],["Bulgaria","bg","359"],["Burkina Faso","bf","226"],["Burundi","bi","257"],["Cambodia","kh","855"],["Cameroon","cm","237"],["Canada","ca","1","(...) ...-....",1,["204","226","236","249","250","289","306","343","365","387","403","416","418","431","437","438","450","506","514","519","548","579","581","587","604","613","639","647","672","705","709","742","778","780","782","807","819","825","867","873","902","905"]],["Cape Verde","cv","238"],["Caribbean Netherlands","bq","599","",1],["Central African Republic","cf","236"],["Chad","td","235"],["Chile","cl","56"],["China","cn","86","... .... ...."],["Colombia","co","57","... ... ...."],["Comoros","km","269"],["Congo","cd","243"],["Congo","cg","242"],["Costa Rica","cr","506","....-...."],["C\xF4te d'Ivoire","ci","225",".. .. .. .. .."],["Croatia","hr","385"],["Cuba","cu","53"],["Cura\xE7ao","cw","599","",0],["Cyprus","cy","357",".. ......"],["Czech Republic","cz","420","... ... ..."],["Denmark","dk","45",".. .. .. .."],["Djibouti","dj","253"],["Dominica","dm","1767"],["Dominican Republic","do","1","",2],["Ecuador","ec","593"],["Egypt","eg","20"],["El Salvador","sv","503","....-...."],["Equatorial Guinea","gq","240"],["Eritrea","er","291"],["Estonia","ee","372",".... ......"],["Ethiopia","et","251"],["Fiji","fj","679"],["Finland","fi","358",".. ... .. .."],["France","fr","33",". .. .. .. .."],["French Guiana","gf","594"],["French Polynesia","pf","689"],["Gabon","ga","241"],["Gambia","gm","220"],["Georgia","ge","995"],["Germany","de","49",".... ........"],["Ghana","gh","233"],["Greece","gr","30"],["Grenada","gd","1473"],["Guadeloupe","gp","590","",0],["Guam","gu","1671"],["Guatemala","gt","502","....-...."],["Guinea","gn","224"],["Guinea-Bissau","gw","245"],["Guyana","gy","592"],["Haiti","ht","509","....-...."],["Honduras","hn","504"],["Hong Kong","hk","852",".... ...."],["Hungary","hu","36"],["Iceland","is","354","... ...."],["India","in","91",".....-....."],["Indonesia","id","62"],["Iran","ir","98","... ... ...."],["Iraq","iq","964"],["Ireland","ie","353",".. ......."],["Israel","il","972","... ... ...."],["Italy","it","39","... .......",0],["Jamaica","jm","1876"],["Japan","jp","81",".. .... ...."],["Jordan","jo","962"],["Kazakhstan","kz","7","... ...-..-..",0],["Kenya","ke","254"],["Kiribati","ki","686"],["Kosovo","xk","383"],["Kuwait","kw","965"],["Kyrgyzstan","kg","996","... ... ..."],["Laos","la","856"],["Latvia","lv","371",".. ... ..."],["Lebanon","lb","961"],["Lesotho","ls","266"],["Liberia","lr","231"],["Libya","ly","218"],["Liechtenstein","li","423"],["Lithuania","lt","370"],["Luxembourg","lu","352"],["Macau","mo","853"],["Macedonia","mk","389"],["Madagascar","mg","261"],["Malawi","mw","265"],["Malaysia","my","60","..-....-...."],["Maldives","mv","960"],["Mali","ml","223"],["Malta","mt","356"],["Marshall Islands","mh","692"],["Martinique","mq","596"],["Mauritania","mr","222"],["Mauritius","mu","230"],["Mexico","mx","52","... ... ....",0],["Micronesia","fm","691"],["Moldova","md","373","(..) ..-..-.."],["Monaco","mc","377"],["Mongolia","mn","976"],["Montenegro","me","382"],["Morocco","ma","212"],["Mozambique","mz","258"],["Myanmar","mm","95"],["Namibia","na","264"],["Nauru","nr","674"],["Nepal","np","977"],["Netherlands","nl","31",".. ........"],["New Caledonia","nc","687"],["New Zealand","nz","64","...-...-...."],["Nicaragua","ni","505"],["Niger","ne","227"],["Nigeria","ng","234"],["North Korea","kp","850"],["Norway","no","47","... .. ..."],["Oman","om","968"],["Pakistan","pk","92","...-......."],["Palau","pw","680"],["Palestine","ps","970"],["Panama","pa","507"],["Papua New Guinea","pg","675"],["Paraguay","py","595"],["Peru","pe","51"],["Philippines","ph","63",".... ......."],["Poland","pl","48","...-...-..."],["Portugal","pt","351"],["Puerto Rico","pr","1","",3,["787","939"]],["Qatar","qa","974"],["R\xE9union","re","262"],["Romania","ro","40"],["Russia","ru","7","(...) ...-..-..",1],["Rwanda","rw","250"],["Saint Kitts and Nevis","kn","1869"],["Saint Lucia","lc","1758"],["Saint Vincent and the Grenadines","vc","1784"],["Samoa","ws","685"],["San Marino","sm","378"],["S\xE3o Tom\xE9 and Pr\xEDncipe","st","239"],["Saudi Arabia","sa","966"],["Senegal","sn","221"],["Serbia","rs","381"],["Seychelles","sc","248"],["Sierra Leone","sl","232"],["Singapore","sg","65","....-...."],["Slovakia","sk","421"],["Slovenia","si","386"],["Solomon Islands","sb","677"],["Somalia","so","252"],["South Africa","za","27"],["South Korea","kr","82","... .... ...."],["South Sudan","ss","211"],["Spain","es","34","... ... ..."],["Sri Lanka","lk","94"],["Sudan","sd","249"],["Suriname","sr","597"],["Swaziland","sz","268"],["Sweden","se","46","... ... ..."],["Switzerland","ch","41",".. ... .. .."],["Syria","sy","963"],["Taiwan","tw","886"],["Tajikistan","tj","992"],["Tanzania","tz","255"],["Thailand","th","66"],["Timor-Leste","tl","670"],["Togo","tg","228"],["Tonga","to","676"],["Trinidad and Tobago","tt","1868"],["Tunisia","tn","216"],["Turkey","tr","90","... ... .. .."],["Turkmenistan","tm","993"],["Tuvalu","tv","688"],["Uganda","ug","256"],["Ukraine","ua","380","(..) ... .. .."],["United Arab Emirates","ae","971"],["United Kingdom","gb","44",".... ......"],["United States","us","1","(...) ...-....",0],["Uruguay","uy","598"],["Uzbekistan","uz","998",".. ... .. .."],["Vanuatu","vu","678"],["Vatican City","va","39",".. .... ....",1],["Venezuela","ve","58"],["Vietnam","vn","84"],["Yemen","ye","967"],["Zambia","zm","260"],["Zimbabwe","zw","263"]];var ve="react-international-phone-",se=(...t)=>t.filter(e=>!!e).join(" ").trim(),xe=(...t)=>se(...t).split(" ").map(e=>`${ve}${e}`).join(" "),P=({addPrefix:t,rawClassNames:e})=>se(xe(...t),...e);var le=({value:t,mask:e,maskSymbol:a,offset:s=0,trimNonMaskCharsLeftover:r=false})=>{if(t.length<s)return t;let o=t.slice(0,s),c=t.slice(s),i=o,n=0;for(let l of e.split("")){if(n>=c.length){if(!r&&l!==a){i+=l;continue}break}l===a?(i+=c[n],n+=1):i+=l;}return i};var F=t=>t?/^\d+$/.test(t):false;var z=t=>t.replace(/\D/g,"");var ue=(t,e)=>{let a=t.style.display;a!=="block"&&(t.style.display="block");let s=t.getBoundingClientRect(),r=e.getBoundingClientRect(),o=r.top-s.top,c=s.bottom-r.bottom;o>=0&&c>=0||(Math.abs(o)<Math.abs(c)?t.scrollTop+=o:t.scrollTop-=c),t.style.display=a;};var Se=t=>{let{name:e,iso2:a,dialCode:s,format:r,priority:o,areaCodes:c}=t,i=[e,a,s,r,o,c];for(let n=0;n<i.length;n+=1){if(n===0)continue;let l=i[n-1],d=i[n];if(l===void 0&&d!==void 0){let m=JSON.stringify(i,(f,g)=>g===void 0?"__undefined":g).replace(/"__undefined"/g,"undefined");throw new Error(`[react-international-phone] invalid country values passed to buildCountryData. Check ${l} in: ${m}`)}}return i.filter(n=>n!==void 0)};var de=({phone:t,dialCode:e,prefix:a="+",charAfterDialCode:s=" "})=>{if(!t||!e)return t;let r=t;return r.startsWith(a)&&(r=r.replace(a,"")),r.startsWith(e)?(r=r.replace(e,""),r.startsWith(s)&&(r=r.replace(s,"")),r):t};var ce=(t,e)=>{let a=e.disableDialCodeAndPrefix?false:e.forceDialCode,s=e.disableDialCodeAndPrefix?false:e.insertDialCodeOnEmpty,r=t,o=l=>e.trimNonDigitsEnd?l.trim():l;if(!r)return s&&!r.length||a?o(`${e.prefix}${e.dialCode}${e.charAfterDialCode}`):o(r);if(r=z(r),r===e.dialCode&&!e.disableDialCodeAndPrefix)return o(`${e.prefix}${e.dialCode}${e.charAfterDialCode}`);if(e.dialCode.startsWith(r)&&!e.disableDialCodeAndPrefix)return o(a?`${e.prefix}${e.dialCode}${e.charAfterDialCode}`:`${e.prefix}${r}`);if(!r.startsWith(e.dialCode)&&!e.disableDialCodeAndPrefix){if(a)return o(`${e.prefix}${e.dialCode}${e.charAfterDialCode}`);if(r.length<e.dialCode.length)return o(`${e.prefix}${r}`)}let c=()=>{let l=e.dialCode.length,d=r.slice(0,l),m=r.slice(l);return {phoneLeftSide:d,phoneRightSide:m}},{phoneLeftSide:i,phoneRightSide:n}=c();return i=`${e.prefix}${i}${e.charAfterDialCode}`,n=le({value:n,mask:e.mask,maskSymbol:e.maskChar,trimNonMaskCharsLeftover:e.trimNonDigitsEnd||e.disableDialCodeAndPrefix&&n.length===0}),e.disableDialCodeAndPrefix&&(i=""),o(`${i}${n}`)};var pe=({phoneBeforeInput:t,phoneAfterInput:e,phoneAfterFormatted:a,cursorPositionAfterInput:s,leftOffset:r=0,deletion:o})=>{if(s<r)return r;if(!t)return a.length;let c=null;for(let d=s-1;d>=0;d-=1)if(F(e[d])){c=d;break}if(c===null){for(let d=0;d<e.length;d+=1)if(F(a[d]))return d;return e.length}let i=0;for(let d=0;d<c;d+=1)F(e[d])&&(i+=1);let n=0,l=0;for(let d=0;d<a.length&&(n+=1,F(a[d])&&(l+=1),!(l>=i+1));d+=1);if(o!=="backward")for(;!F(a[n])&&n<a.length;)n+=1;return n};var B=({phone:t,prefix:e})=>t?`${e}${z(t)}`:"";function W({value:t,country:e,insertDialCodeOnEmpty:a,trimNonDigitsEnd:s,countries:r,prefix:o,charAfterDialCode:c,forceDialCode:i,disableDialCodeAndPrefix:n,defaultMask:l,countryGuessingEnabled:d,disableFormatting:m}){let f=t;n&&(f=f.startsWith(`${o}`)?f:`${o}${e.dialCode}${f}`);let g=d?X({phone:f,countries:r,currentCountryIso2:e?.iso2}):void 0,x=g?.country??e,p=ce(f,{prefix:o,mask:Q({phone:f,country:x,defaultMask:l,disableFormatting:m}),maskChar:J,dialCode:x.dialCode,trimNonDigitsEnd:s,charAfterDialCode:c,forceDialCode:i,insertDialCodeOnEmpty:a,disableDialCodeAndPrefix:n}),h=d&&!g?.fullDialCodeMatch?e:x;return {phone:B({phone:n?`${h.dialCode}${p}`:p,prefix:o}),inputValue:p,country:h}}var De=t=>{if(t?.toLocaleLowerCase().includes("delete")??false)return t?.toLocaleLowerCase().includes("forward")?"forward":"backward"},me=(t,{country:e,insertDialCodeOnEmpty:a,phoneBeforeInput:s,prefix:r,charAfterDialCode:o,forceDialCode:c,disableDialCodeAndPrefix:i,countryGuessingEnabled:n,defaultMask:l,disableFormatting:d,countries:m})=>{let f=t.nativeEvent,g=f.inputType,x=De(g),p=!!g?.startsWith("insertFrom"),h=g==="insertText",S=f?.data||void 0,D=t.target.value,_=t.target.selectionStart??0;if(g?.includes("history"))return {inputValue:s,phone:B({phone:s,prefix:r}),cursorPosition:s.length,country:e};if(h&&!F(S)&&D!==r)return {inputValue:s,phone:B({phone:i?`${e.dialCode}${s}`:s,prefix:r}),cursorPosition:_-(S?.length??0),country:e};if(c&&!D.startsWith(`${r}${e.dialCode}`)&&!p){let b=D?s:`${r}${e.dialCode}${o}`;return {inputValue:b,phone:B({phone:b,prefix:r}),cursorPosition:r.length+e.dialCode.length+o.length,country:e}}let{phone:N,inputValue:u,country:C}=W({value:D,country:e,trimNonDigitsEnd:x==="backward",insertDialCodeOnEmpty:a,countryGuessingEnabled:n,countries:m,prefix:r,charAfterDialCode:o,forceDialCode:c,disableDialCodeAndPrefix:i,disableFormatting:d,defaultMask:l}),y=pe({cursorPositionAfterInput:_,phoneBeforeInput:s,phoneAfterInput:D,phoneAfterFormatted:u,leftOffset:c?r.length+e.dialCode.length+o.length:0,deletion:x});return {phone:N,inputValue:u,cursorPosition:y,country:C}};var fe=(t,e)=>{let a=Object.keys(t),s=Object.keys(e);if(a.length!==s.length)return  false;for(let r of a)if(t[r]!==e[r])return  false;return  true};var Ce=()=>{let t=useRef(),e=useRef(Date.now());return {check:()=>{let s=Date.now(),r=t.current?s-e.current:void 0;return t.current=e.current,e.current=s,r}}};var ke={size:20,overrideLastItemDebounceMS:-1};function ye(t,e){let{size:a,overrideLastItemDebounceMS:s,onChange:r}={...ke,...e},[o,c]=useState(t),[i,n]=useState([o]),[l,d]=useState(0),m=Ce();return [o,(p,h)=>{if(typeof p=="object"&&typeof o=="object"&&fe(p,o)||p===o)return;let I=s>0,S=m.check(),D=I&&S!==void 0?S>s:true;if(h?.overrideLastItem!==void 0?h.overrideLastItem:!D)n(N=>[...N.slice(0,l),p]);else {let N=i.length>=a;n(u=>[...u.slice(N?1:0,l+1),p]),N||d(u=>u+1);}c(p),r?.(p);},()=>{if(l<=0)return {success:false};let p=i[l-1];return c(p),d(h=>h-1),r?.(p),{success:true,value:p}},()=>{if(l+1>=i.length)return {success:false};let p=i[l+1];return c(p),d(h=>h+1),r?.(p),{success:true,value:p}}]}var J=".",E={defaultCountry:"us",value:"",prefix:"+",defaultMask:"............",charAfterDialCode:" ",historySaveDebounceMS:200,disableCountryGuess:false,disableDialCodePrefill:false,forceDialCode:false,disableDialCodeAndPrefix:false,disableFormatting:false,countries:R},ee=({defaultCountry:t=E.defaultCountry,value:e=E.value,countries:a=E.countries,prefix:s=E.prefix,defaultMask:r=E.defaultMask,charAfterDialCode:o=E.charAfterDialCode,historySaveDebounceMS:c=E.historySaveDebounceMS,disableCountryGuess:i=E.disableCountryGuess,disableDialCodePrefill:n=E.disableDialCodePrefill,forceDialCode:l=E.forceDialCode,disableDialCodeAndPrefix:d=E.disableDialCodeAndPrefix,disableFormatting:m=E.disableFormatting,onChange:f,inputRef:g})=>{let h={countries:a,prefix:s,charAfterDialCode:o,forceDialCode:d?false:l,disableDialCodeAndPrefix:d,defaultMask:r,countryGuessingEnabled:!i,disableFormatting:m},I=useRef(null),S=g||I,D=w=>{Promise.resolve().then(()=>{typeof window>"u"||S.current!==document?.activeElement||S.current?.setSelectionRange(w,w);});},[{phone:_,inputValue:N,country:u},C,y,b]=ye(()=>{let w=$({value:t,field:"iso2",countries:a});w||console.error(`[react-international-phone]: can not find a country with "${t}" iso2 code`);let T=w||$({value:"us",field:"iso2",countries:a}),{phone:k,inputValue:L,country:U}=W({value:e,country:T,insertDialCodeOnEmpty:!n,...h});return D(L.length),{phone:k,inputValue:L,country:U.iso2}},{overrideLastItemDebounceMS:c,onChange:({inputValue:w,phone:T,country:k})=>{if(!f)return;let L=v(k);f({phone:T,inputValue:w,country:L});}}),v=useCallback(w=>$({value:w,field:"iso2",countries:a}),[a]),A=useMemo(()=>v(u),[u,v]);useEffect(()=>{let w=S.current;if(!w)return;let T=k=>{if(!k.key)return;let L=k.ctrlKey,U=k.shiftKey,Pe=k.key.toLowerCase()==="z";!L||!Pe||(U?b():y());};return w.addEventListener("keydown",T),()=>{w.removeEventListener("keydown",T);}},[S,y,b]);let V=w=>{w.preventDefault();let{phone:T,inputValue:k,country:L,cursorPosition:U}=me(w,{country:A,phoneBeforeInput:N,insertDialCodeOnEmpty:false,...h});return C({inputValue:k,phone:T,country:L.iso2}),D(U),e},K=(w,T={focusOnInput:false})=>{let k=$({value:w,field:"iso2",countries:a});if(!k){console.error(`[react-international-phone]: can not find a country with "${w}" iso2 code`);return}let L=d?"":`${s}${k.dialCode}${o}`;C({inputValue:L,phone:`${s}${k.dialCode}`,country:k.iso2}),T.focusOnInput&&Promise.resolve().then(()=>{S.current?.focus();});},[G,j]=useState(false);return useEffect(()=>{if(!G){j(true),e!==_&&f?.({inputValue:N,phone:_,country:A});return}if(e===_)return;let{phone:w,inputValue:T,country:k}=W({value:e,country:A,insertDialCodeOnEmpty:!n,...h});C({phone:w,inputValue:T,country:k.iso2});},[e]),{phone:_,inputValue:N,country:A,setCountry:K,handlePhoneValueChange:V,inputRef:S}};var Q=({phone:t,country:e,defaultMask:a="............",disableFormatting:s=false})=>{let r=e.format,o=i=>s?i.replace(new RegExp(`[^${J}]`,"g"),""):i;if(!r)return o(a);if(typeof r=="string")return o(r);if(!r.default)return console.error(`[react-international-phone]: default mask for ${e.iso2} is not provided`),o(a);let c=Object.keys(r).find(i=>{if(i==="default")return  false;if(!(i.charAt(0)==="/"&&i.charAt(i.length-1)==="/"))return console.error(`[react-international-phone]: format regex "${i}" for ${e.iso2} is not valid`),false;let l=new RegExp(i.substring(1,i.length-1)),d=t.replace(e.dialCode,"");return l.test(z(d))});return o(c?r[c]:r.default)};var M=t=>{let[e,a,s,r,o,c]=t;return {name:e,iso2:a,dialCode:s,format:r,priority:o,areaCodes:c}};var _e=t=>`Field "${t}" is not supported`,$=({field:t,value:e,countries:a=R})=>{if(["priority"].includes(t))throw new Error(_e(t));let s=a.find(r=>{let o=M(r);return e===o[t]});if(s)return M(s)};var X=({phone:t,countries:e=R,currentCountryIso2:a})=>{let s={country:void 0,fullDialCodeMatch:false};if(!t)return s;let r=z(t);if(!r)return s;let o=s,c=({country:i,fullDialCodeMatch:n})=>{let l=i.dialCode===o.country?.dialCode,d=(i.priority??0)<(o.country?.priority??0);(!l||d)&&(o={country:i,fullDialCodeMatch:n});};for(let i of e){let n=M(i),{dialCode:l,areaCodes:d}=n;if(r.startsWith(l)){let m=o.country?Number(l)>=Number(o.country.dialCode):true;if(d){let f=r.substring(l.length);for(let g of d)if(f.startsWith(g))return {country:n,fullDialCodeMatch:true}}(m||l===r||!o.fullDialCodeMatch)&&c({country:n,fullDialCodeMatch:true});}o.fullDialCodeMatch||r.length<l.length&&l.startsWith(r)&&(!o.country||Number(l)<=Number(o.country.dialCode))&&c({country:n,fullDialCodeMatch:false});}if(a){let i=$({value:a,field:"iso2",countries:e});if(!i)return o;let l=i?(m=>{if(!m?.areaCodes)return  false;let f=r.substring(m.dialCode.length);return m.areaCodes.some(g=>g.startsWith(f))})(i):false;!!o&&o.country?.dialCode===i.dialCode&&o.country!==i&&o.fullDialCodeMatch&&(!i.areaCodes||l)&&(o={country:i,fullDialCodeMatch:true});}return o};var Ae=(t,e)=>{let a=parseInt(t,16);return Number(a+e).toString(16)},Te="abcdefghijklmnopqrstuvwxyz",Ee="1f1e6",we=Te.split("").reduce((t,e,a)=>({...t,[e]:Ae(Ee,a)}),{}),Le=t=>[we[t[0]],we[t[1]]].join("-"),q=({iso2:t,size:e,src:a,protocol:s="https",disableLazyLoading:r,className:o,style:c,...i})=>{if(!t)return React__default.createElement("img",{className:P({addPrefix:["flag-emoji"],rawClassNames:[o]}),width:e,height:e,...i});let n=()=>{if(a)return a;let l=Le(t);return `${s}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${l}.svg`};return React__default.createElement("img",{className:P({addPrefix:["flag-emoji"],rawClassNames:[o]}),src:n(),width:e,height:e,draggable:false,"data-country":t,loading:r?void 0:"lazy",style:{width:e,height:e,...c},alt:"",...i})};var ze=1e3,ne=({show:t,dialCodePrefix:e="+",selectedCountry:a,countries:s=R,preferredCountries:r=[],flags:o,onSelect:c,onClose:i,...n})=>{let l=useRef(null),d=useRef(),m=useMemo(()=>{if(!r||!r.length)return s;let u=[],C=[...s];for(let y of r){let b=C.findIndex(v=>M(v).iso2===y);if(b!==-1){let v=C.splice(b,1)[0];u.push(v);}}return u.concat(C)},[s,r]),f=useRef({updatedAt:void 0,value:""}),g=u=>{let C=f.current.updatedAt&&new Date().getTime()-f.current.updatedAt.getTime()>ze;f.current={value:C?u:`${f.current.value}${u}`,updatedAt:new Date};let y=m.findIndex(b=>M(b).name.toLowerCase().startsWith(f.current.value));y!==-1&&h(y);},x=useCallback(u=>m.findIndex(C=>M(C).iso2===u),[m]),[p,h]=useState(x(a)),I=()=>{d.current!==a&&h(x(a));},S=useCallback(u=>{h(x(u.iso2)),c?.(u);},[c,x]),D=u=>{let C=m.length-1,y=b=>u==="prev"?b-1:u==="next"?b+1:u==="last"?C:0;h(b=>{let v=y(b);return v<0?0:v>C?C:v});},_=u=>{if(u.stopPropagation(),u.key==="Enter"){u.preventDefault();let C=M(m[p]);S(C);return}if(u.key==="Escape"){i?.();return}if(u.key==="ArrowUp"){u.preventDefault(),D("prev");return}if(u.key==="ArrowDown"){u.preventDefault(),D("next");return}if(u.key==="PageUp"){u.preventDefault(),D("first");return}if(u.key==="PageDown"){u.preventDefault(),D("last");return}u.key===" "&&u.preventDefault(),u.key.length===1&&!u.altKey&&!u.ctrlKey&&!u.metaKey&&g(u.key.toLocaleLowerCase());},N=useCallback(()=>{if(!l.current||p===void 0)return;let u=M(m[p]).iso2;if(u===d.current)return;let C=l.current.querySelector(`[data-country="${u}"]`);C&&(ue(l.current,C),d.current=u);},[p,m]);return useEffect(()=>{N();},[p,N]),useEffect(()=>{l.current&&(t?l.current.focus():I());},[t]),useEffect(()=>{I();},[a]),React__default.createElement("ul",{ref:l,role:"listbox",className:P({addPrefix:["country-selector-dropdown"],rawClassNames:[n.className]}),style:{display:t?"block":"none",...n.style},onKeyDown:_,onBlur:i,tabIndex:-1,"aria-activedescendant":`react-international-phone__${M(m[p]).iso2}-option`},m.map((u,C)=>{let y=M(u),b=y.iso2===a,v=C===p,A=r.includes(y.iso2),V=C===r.length-1,K=o?.find(G=>G.iso2===y.iso2);return React__default.createElement(React__default.Fragment,{key:y.iso2},React__default.createElement("li",{"data-country":y.iso2,role:"option","aria-selected":b,"aria-label":`${y.name} ${e}${y.dialCode}`,id:`react-international-phone__${y.iso2}-option`,className:P({addPrefix:["country-selector-dropdown__list-item",A&&"country-selector-dropdown__list-item--preferred",b&&"country-selector-dropdown__list-item--selected",v&&"country-selector-dropdown__list-item--focused"],rawClassNames:[n.listItemClassName]}),onClick:()=>S(y),style:n.listItemStyle,title:y.name},React__default.createElement(q,{iso2:y.iso2,src:K?.src,className:P({addPrefix:["country-selector-dropdown__list-item-flag-emoji"],rawClassNames:[n.listItemFlagClassName]}),style:n.listItemFlagStyle}),React__default.createElement("span",{className:P({addPrefix:["country-selector-dropdown__list-item-country-name"],rawClassNames:[n.listItemCountryNameClassName]}),style:n.listItemCountryNameStyle},y.name),React__default.createElement("span",{className:P({addPrefix:["country-selector-dropdown__list-item-dial-code"],rawClassNames:[n.listItemDialCodeClassName]}),style:n.listItemDialCodeStyle},e,y.dialCode)),V?React__default.createElement("hr",{className:P({addPrefix:["country-selector-dropdown__preferred-list-divider"],rawClassNames:[n.preferredListDividerClassName]}),style:n.preferredListDividerStyle}):null)}))};var ae=({selectedCountry:t,onSelect:e,disabled:a,hideDropdown:s,countries:r=R,preferredCountries:o=[],flags:c,renderButtonWrapper:i,...n})=>{let[l,d]=useState(false),m=useMemo(()=>{if(t)return $({value:t,field:"iso2",countries:r})},[r,t]),f=useRef(null),g=p=>{p.key&&["ArrowUp","ArrowDown"].includes(p.key)&&(p.preventDefault(),d(true));},x=()=>{let p={title:m?.name,onClick:()=>d(I=>!I),onMouseDown:I=>I.preventDefault(),onKeyDown:g,disabled:s||a,role:"combobox","aria-label":"Country selector","aria-haspopup":"listbox","aria-expanded":l},h=React__default.createElement("div",{className:P({addPrefix:["country-selector-button__button-content"],rawClassNames:[n.buttonContentWrapperClassName]}),style:n.buttonContentWrapperStyle},React__default.createElement(q,{iso2:t,src:c?.find(I=>I.iso2===t)?.src,className:P({addPrefix:["country-selector-button__flag-emoji",a&&"country-selector-button__flag-emoji--disabled"],rawClassNames:[n.flagClassName]}),style:{visibility:t?"visible":"hidden",...n.flagStyle}}),!s&&React__default.createElement("div",{className:P({addPrefix:["country-selector-button__dropdown-arrow",a&&"country-selector-button__dropdown-arrow--disabled",l&&"country-selector-button__dropdown-arrow--active"],rawClassNames:[n.dropdownArrowClassName]}),style:n.dropdownArrowStyle}));return i?i({children:h,rootProps:p}):React__default.createElement("button",{...p,type:"button",className:P({addPrefix:["country-selector-button",l&&"country-selector-button--active",a&&"country-selector-button--disabled",s&&"country-selector-button--hide-dropdown"],rawClassNames:[n.buttonClassName]}),"data-country":t,style:n.buttonStyle},h)};return React__default.createElement("div",{className:P({addPrefix:["country-selector"],rawClassNames:[n.className]}),style:n.style,ref:f},x(),React__default.createElement(ne,{show:l,countries:r,preferredCountries:o,flags:c,onSelect:p=>{d(false),e?.(p);},selectedCountry:t,onClose:()=>{d(false);},...n.dropdownStyleProps}))};var ie=({dialCode:t,prefix:e,disabled:a,style:s,className:r})=>React__default.createElement("div",{className:P({addPrefix:["dial-code-preview",a&&"dial-code-preview--disabled"],rawClassNames:[r]}),style:s},`${e}${t}`);forwardRef(({value:t,onChange:e,countries:a=R,preferredCountries:s=[],hideDropdown:r,showDisabledDialCodeAndPrefix:o,disableFocusAfterCountrySelect:c,flags:i,style:n,className:l,inputStyle:d,inputClassName:m,countrySelectorStyleProps:f,dialCodePreviewStyleProps:g,inputProps:x,placeholder:p,disabled:h,name:I,onFocus:S,onBlur:D,required:_,autoFocus:N,...u},C)=>{let{phone:y,inputValue:b,inputRef:v,country:A,setCountry:V,handlePhoneValueChange:K}=ee({value:t,countries:a,...u,onChange:j=>{e?.(j.phone,{country:j.country,inputValue:j.inputValue});}}),G=u.disableDialCodeAndPrefix&&o&&A?.dialCode;return useImperativeHandle(C,()=>v.current?Object.assign(v.current,{setCountry:V,state:{phone:y,inputValue:b,country:A}}):null,[v,V,y,b,A]),React__default.createElement("div",{ref:C,className:P({addPrefix:["input-container"],rawClassNames:[l]}),style:n},React__default.createElement(ae,{onSelect:j=>V(j.iso2,{focusOnInput:!c}),flags:i,selectedCountry:A.iso2,countries:a,preferredCountries:s,disabled:h,hideDropdown:r,...f}),G&&React__default.createElement(ie,{dialCode:A.dialCode,prefix:u.prefix??"+",disabled:h,...g}),React__default.createElement("input",{onChange:K,value:b,type:"tel",ref:v,className:P({addPrefix:["input",h&&"input--disabled"],rawClassNames:[m]}),placeholder:p,disabled:h,style:d,name:I,onFocus:S,onBlur:D,autoFocus:N,required:_,...x}))});

/* eslint-disable no-underscore-dangle */
class ApiEndpoint {
}
ApiEndpoint.getBaseUrl = () => {
    if (!ApiEndpoint.__baseUrl__) {
        throw new Error('ApiEndpoint Base URL has not been initialized');
    }
    return ApiEndpoint.__baseUrl__;
};
ApiEndpoint.setBaseUrl = (baseUrlInput) => {
    if (!baseUrlInput) {
        /**
         * If the baseUrl is not provided, use the default baseUrl from the sdk-api package
         */
        ApiEndpoint.__baseUrl__ = new Configuration().basePath;
    }
    else {
        ApiEndpoint.__baseUrl__ = baseUrlInput;
    }
};

/**
 * Custom hook that provides a slice of the store state based on a selector function.
 *
 * @template TState - The type of the store state.
 * @template StateSlice - The type of the selected slice of the store state.
 * @param {StoreApi<TState>} api - The store API object.
 * @param {(state: TState) => StateSlice} selector - The selector function to extract the desired store slice.
 * @returns {StateSlice} - The selected slice of the store state.
 *
 * @example
 * const store = createStore(() => ({
 *   count: 0,
 * }))
 *
 * const count = useStoreWithSelector(store, ({ count }) => count);
 */
const useStoreWithSelector = (api, selector) => {
    /**
     * The cache is either an object or undefined. This allows us to differentiate between:
     * 1. A selector that resolved to an undefined value
     * 2. A cache that hasn't been populated yet
     */
    const serverSnapshotCacheRef = useRef(undefined);
    const getSnapshot = () => selector(api.getState());
    /**
     * Cache the server snapshot in a ref to prevent infinite loops in Next.js SSR
     *
     * Next.js can re-render components multiple times during server-side rendering.
     * If we don't cache the result of getServerSnapshot, it may cause an infinite loop
     * as the component keeps re-rendering with new snapshots.
     *
     * Prevents this log "Warning: The result of getServerSnapshot should be cached to avoid an infinite loop"
     */
    const getServerSnapshot = () => {
        if (serverSnapshotCacheRef.current === undefined) {
            serverSnapshotCacheRef.current = {
                value: selector(api.getInitialState()),
            };
        }
        return serverSnapshotCacheRef.current.value;
    };
    const slice = useSyncExternalStore(api.subscribe, getSnapshot, getServerSnapshot);
    return slice;
};

var version$2 = "4.6.1";

/**
 * Creates a store with the specified initial state and provides methods to manage and subscribe to the state.
 *
 * @template T - The type of the state object.
 * @param getInitialState - A function that returns the initial state object.
 * @returns An object that represents the store and provides methods to interact with the state.
 */
const createStore = (getInitialState) => {
    const subscriptions = new Set();
    let state = getInitialState();
    const notifySubscribers = () => {
        for (const subscription of subscriptions) {
            subscription(state);
        }
    };
    return {
        /**
         * Returns the initial state object.
         *
         * @returns The initial state object.
         */
        getInitialState: () => getInitialState(),
        /**
         * Returns the current state object.
         *
         * @returns The current state object.
         */
        getState: () => state,
        /**
         * Updates the state object with the provided partial state and notifies all subscribers.
         *
         * @param partialState - The partial state object to merge with the current state.
         */
        setState: (partialState) => {
            state = Object.assign(Object.assign({}, state), partialState);
            notifySubscribers();
        },
        /**
         * Subscribes to state changes and invokes the provided callback whenever the state is updated.
         *
         * @param subscription - A callback function that receives the updated state as a parameter.
         * @returns A function that can be called to unsubscribe from state changes.
         */
        subscribe: (subscription) => {
            subscriptions.add(subscription);
            return () => {
                subscriptions.delete(subscription);
            };
        },
    };
};

const logger = new Logger$1('@dynamic-labs/logger');

/**
 * Creates a persist middleware that saves the store state to the storage.
 */
const persist = ({ name, version = '0', storage, store, partialize, onVersionChanged, }) => {
    store.subscribe((state) => {
        const persistedState = partialize(state);
        storage.setItem(name, JSON.stringify({ state: persistedState, version }));
    });
    const storedState = storage.getItem(name);
    if (storedState) {
        try {
            const { state: persistedState, version: persistedVersion } = JSON.parse(storedState);
            if (persistedVersion === version) {
                store.setState(Object.assign(store.getInitialState(), persistedState));
            }
            else if (onVersionChanged) {
                onVersionChanged(persistedVersion);
            }
        }
        catch (error) {
            logger.error('Failed to load state from storage', error);
        }
    }
    return store;
};

assertPackageVersion('@dynamic-labs/store', version$2);

/**
 * Returns the initial state for the SdkStore
 */
const createInitialStates = (dynamicContextProps) => ({
    dynamicContextProps,
    loadingAndLifecycle: {
        sessionValidation: false,
    },
    nonce: { expiresAt: undefined, nonce: undefined },
    primaryWalletId: undefined,
    projectSettings: { expiresAt: undefined, settings: undefined },
    sendBalanceState: {
        amount: undefined,
        chainName: undefined,
        nativePrice: undefined,
    },
    tokenBalancesState: {
        error: undefined,
        isError: false,
        isLoading: false,
        tokenBalances: undefined,
    },
    user: undefined,
    walletOptions: {
        groups: {},
        walletConnectorOptions: [],
    },
});
/**
 * Filters out which variables should be stored to local storage.
 * Also allows transforming them before storage.
 */
const transformStateForLocalStorage = (state) => ({
    nonce: state.nonce,
    primaryWalletId: state.primaryWalletId,
    projectSettings: state.projectSettings,
    user: state.user,
});

const AUTH_USER = 'dynamic_authenticated_user';
const syncLegacyStorage = (store) => {
    const legacyUser = StorageService.getItem(AUTH_USER);
    if (Boolean(legacyUser) && !store.getState().user) {
        store.setState({ user: legacyUser !== null && legacyUser !== void 0 ? legacyUser : undefined });
        StorageService.removeItem(AUTH_USER);
    }
    return store;
};

let store;
const getStore = () => {
    if (!store) {
        throw new Error('Store not initialized');
    }
    return store;
};
const removeStoreInstance = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    store = undefined;
};
const initializeStore = (props) => {
    var _a;
    if (store) {
        return;
    }
    const { localStorageSuffix } = (_a = props.settings) !== null && _a !== void 0 ? _a : {};
    const persistName = localStorageSuffix
        ? `${STORE_STORAGE_KEY}_${localStorageSuffix}`
        : STORE_STORAGE_KEY;
    store = syncLegacyStorage(persist({
        name: persistName,
        onVersionChanged: props.onPersistedVersionChanged,
        partialize: transformStateForLocalStorage,
        storage: getStorage(),
        // Map each entry to its initialValue
        store: createStore(() => createInitialStates(props)),
        version: formatVersion(VERSION, 'major.minor'),
    }));
};
const getStorage = () => {
    if (typeof localStorage === 'undefined') {
        return {
            getItem: () => null,
            setItem: () => { },
        };
    }
    return window.localStorage;
};

const createStoreState = (variable) => {
    const capitalizedName = variable[0].toUpperCase() + variable.slice(1);
    const useValue = () => useStoreWithSelector(getStore(), (state) => state[variable]);
    const setValue = (value) => getStore().setState(Object.assign(Object.assign({}, getStore().getState()), { [variable]: value }));
    const getValue = () => getStore().getState()[variable];
    const resetValue = () => setValue(getStore().getInitialState()[variable]);
    return {
        [`use${capitalizedName}`]: useValue,
        [`get${capitalizedName}`]: getValue,
        [`set${capitalizedName}`]: setValue,
        [`reset${capitalizedName}`]: resetValue,
    };
};

const PUBLIC_PROJECT_LIVE_ENVIRONMENT_ID$1 = '2762a57b-faa4-41ce-9f16-abff9300e2c9';
/**
 * These values will override undefined values in the dynamic context settings.
 */
const defaultDynamicSettings = {
    appLogoUrl: 'https://demo.dynamic.xyz/assets/dynamic-logo.svg',
    appName: 'Dynamic Example',
    debugError: false,
    deepLinkPreference: 'native',
    detectNewWalletsForLinking: false,
    displaySiweStatement: true,
    enableConnectOnlyFallback: false,
    enableVisitTrackingOnConnectOnly: true,
    initialAuthenticationMode: 'connect-and-sign',
    logLevel: 'WARN',
    shadowDOMEnabled: true,
    showLockedWalletView: false,
    tokensFilter: (tokens) => tokens,
};

const { getDynamicContextProps, setDynamicContextProps, useDynamicContextProps, } = createStoreState('dynamicContextProps');
const getDynamicSettings = () => applyDefaultSettings(getDynamicContextProps().settings);
const useDynamicSettings = () => applyDefaultSettings(useDynamicContextProps().settings);
const getEnvironmentId = () => getDynamicSettings().environmentId;
const useEnvironmentId = () => useDynamicSettings().environmentId;
const setEnvironmentId = (environmentId) => {
    const props = getDynamicContextProps();
    setDynamicContextProps(Object.assign(Object.assign({}, props), { settings: Object.assign(Object.assign({}, props.settings), { environmentId }) }));
};
const applyDefaultSettings = (settings) => {
    const newSettings = Object.assign({}, settings);
    Object.keys(defaultDynamicSettings).forEach((key) => {
        const typedKey = key;
        if (newSettings[typedKey] === undefined) {
            // @ts-expect-error TS fails to infer this type properly
            newSettings[typedKey] = defaultDynamicSettings[typedKey];
        }
    });
    return newSettings;
};
const useSyncDynamicContextProps = ({ settings, emitErrors, enableInstrumentation, locale, theme, }) => {
    const environmentId = useEnvironmentId();
    if (!environmentId) {
        throw new MissingEnvironmentIdError();
    }
    // We don't want to update the env id here.
    // If it changes, the user should be logged out and we will detect that in useValidateSession.
    settings.environmentId = environmentId;
    useEffect(() => {
        var _a;
        if (environmentId === PUBLIC_PROJECT_LIVE_ENVIRONMENT_ID$1) {
            logger$1.warn(`WARNING: DYNAMIC is using a test environment ID ${environmentId}. Please sign up on https://app.dynamic.xyz/ to get your production environment ID.`);
        }
        if (settings.logLevel) {
            logger$1.setLogLevel(settings.logLevel);
            logger$8.setLogLevel(settings.logLevel);
        }
        ApiEndpoint.setBaseUrl((_a = process.env.DYNAMIC_API_BASE_URL) !== null && _a !== void 0 ? _a : settings.apiBaseUrl);
        setDynamicContextProps({
            emitErrors,
            enableInstrumentation,
            locale,
            settings,
            theme,
        });
    }, [
        emitErrors,
        enableInstrumentation,
        environmentId,
        locale,
        settings,
        theme,
    ]);
};

const { getPrimaryWalletId, setPrimaryWalletId, usePrimaryWalletId, resetPrimaryWalletId, } = createStoreState('primaryWalletId');

const hasPendingMfaAction = (user) => {
    var _a;
    return ((_a = user.scope) === null || _a === void 0 ? void 0 : _a.includes('requiresAdditionalAuth')) ||
        user.mfaBackupCodeAcknowledgement === MfaBackupCodeAcknowledgement.Pending;
};

const hasPendingRequirements = (user) => { var _a; return Boolean((_a = user.missingFields) === null || _a === void 0 ? void 0 : _a.length) || hasPendingMfaAction(user); };

const hasFieldChanged = (fields, record1, record2) => {
    if (!record1 || !record2)
        return false;
    for (const name of fields) {
        const oldValue = record1[name];
        const newValue = record2[name];
        if (JSON.stringify(oldValue) !== JSON.stringify(newValue)) {
            return true;
        }
    }
    return false;
};
const raiseUserProfileEvent = ({ oldUser, newUser, }) => {
    var _a, _b;
    const settings = getProjectSettings();
    if (!settings)
        return;
    const hasKycChanged = hasFieldChanged(settings.kyc.map(({ name }) => name), oldUser, newUser);
    const hasCustomFieldsChanged = hasFieldChanged((_b = (_a = settings.customFields) === null || _a === void 0 ? void 0 : _a.map(({ name }) => name)) !== null && _b !== void 0 ? _b : [], oldUser.metadata, newUser.metadata);
    if (!hasKycChanged && !hasCustomFieldsChanged)
        return;
    dynamicEvents.emit('userProfileUpdated', newUser);
};

const { getUser, setUser: setUserRaw, useUser: useUserRaw, } = createStoreState('user');
const setUser = (user) => {
    if (user) {
        logger$1.metaData.set('user', user);
    }
    else {
        logger$1.metaData.set('user', undefined);
    }
    const oldUser = getUser();
    setUserRaw(user);
    if (user && oldUser)
        raiseUserProfileEvent({ newUser: user, oldUser });
};
const useUser = () => {
    // after user has fully logged in (user is defined), it should never go back to
    // not being fully logged in (userWithMissingInfo defined instead of user),
    // unless it's logged out (no user or userWithMissingInfo defined)
    const hasFullyLoggedIn = useRef(false);
    const userFromStore = useUserRaw();
    if (!userFromStore) {
        hasFullyLoggedIn.current = false;
        return {};
    }
    // adding userWithMissingInfo to avoid breaking changes for customer who consider that when we have a user,
    // it means that they are already fully authenticated.
    // since we won't have onboarding jwt anymore, the idea is to just store the user in LS and either use the user state
    // or userWithMissingInfo, depending on the value of missing fields or mfa required.
    // this is just following our existing logic of how we handle authToken vs onboardingOnlyToken.
    if (!hasFullyLoggedIn.current && hasPendingRequirements(userFromStore)) {
        return { userWithMissingInfo: userFromStore };
    }
    hasFullyLoggedIn.current = true;
    return { user: userFromStore };
};

const getDeviceFingerprint = () => {
    if (typeof window === 'undefined')
        return undefined;
    const deviceFingerprint = StorageService.getItem(DEVICE_FINGERPRINT);
    if (!deviceFingerprint)
        return undefined;
    return deviceFingerprint;
};

const isCookieEnabled = (projectSettings) => {
    var _a, _b;
    assertDefined(projectSettings, 'projectSettings is required');
    /**
     * There is no cookie on native mobile applications
     * so this feature must be disabled for native mobile
     */
    if (PlatformService.isNativeMobile) {
        return false;
    }
    const securitySettings = projectSettings.security;
    if (!securitySettings)
        return false;
    // client uses Dynamic cookies
    const dynamicCookiesEnabled = (((_a = securitySettings.auth) === null || _a === void 0 ? void 0 : _a.storage) || []).includes(AuthStorageEnum.Cookie);
    // BYO JWT client puts their non-Dynamic JWT in a cookie
    const byoJwtCookieEnabled = Boolean((_b = securitySettings.externalAuth) === null || _b === void 0 ? void 0 : _b.cookieName);
    // should return true for both of these scenarios
    // because we also need to do `credentials: true` in api.ts when
    // a byo jwt client sets their named cookie for their jwt and
    // needs to send it to our backend
    return dynamicCookiesEnabled || byoJwtCookieEnabled;
};

const consoleLogger = {
  type: 'logger',
  log(args) {
    this.output('log', args);
  },
  warn(args) {
    this.output('warn', args);
  },
  error(args) {
    this.output('error', args);
  },
  output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};
class Logger {
  constructor(concreteLogger) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.init(concreteLogger, options);
  }
  init(concreteLogger) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  }
  log() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return this.forward(args, 'log', '', true);
  }
  warn() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return this.forward(args, 'warn', '', true);
  }
  error() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return this.forward(args, 'error', '');
  }
  deprecate() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  }
  forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = `${prefix}${this.prefix} ${args[0]}`;
    return this.logger[lvl](args);
  }
  create(moduleName) {
    return new Logger(this.logger, {
      ...{
        prefix: `${this.prefix}:${moduleName}:`
      },
      ...this.options
    });
  }
  clone(options) {
    options = options || this.options;
    options.prefix = options.prefix || this.prefix;
    return new Logger(this.logger, options);
  }
}
var baseLogger = new Logger();

class EventEmitter {
  constructor() {
    this.observers = {};
  }
  on(events, listener) {
    events.split(' ').forEach(event => {
      this.observers[event] = this.observers[event] || [];
      this.observers[event].push(listener);
    });
    return this;
  }
  off(event, listener) {
    if (!this.observers[event]) return;
    if (!listener) {
      delete this.observers[event];
      return;
    }
    this.observers[event] = this.observers[event].filter(l => l !== listener);
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (this.observers[event]) {
      const cloned = [].concat(this.observers[event]);
      cloned.forEach(observer => {
        observer(...args);
      });
    }
    if (this.observers['*']) {
      const cloned = [].concat(this.observers['*']);
      cloned.forEach(observer => {
        observer.apply(observer, [event, ...args]);
      });
    }
  }
}

function defer() {
  let res;
  let rej;
  const promise = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(m => {
    if (s[m]) t[m] = s[m];
  });
}
function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }
  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }
  const stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    const key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }
  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}
function setPath(object, path, newValue) {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = obj[k] || [];
  obj[k].push(newValue);
}
function getPath(object, path) {
  const {
    obj,
    k
  } = getLastOfPath(object, path);
  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  const value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (const prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, s => _entityMap[s]);
  }
  return data;
}
const chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  const possibleChars = chars.filter(c => nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
  if (possibleChars.length === 0) return true;
  const r = new RegExp(`(${possibleChars.map(c => c === '?' ? '\\?' : c).join('|')})`);
  let matched = !r.test(key);
  if (!matched) {
    const ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
}
function deepFind(obj, path) {
  let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  const paths = path.split(keySeparator);
  let current = obj;
  for (let i = 0; i < paths.length; ++i) {
    if (!current) return undefined;
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }
    if (current[paths[i]] === undefined) {
      let j = 2;
      let p = paths.slice(i, i + j).join(keySeparator);
      let mix = current[p];
      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }
      if (mix === undefined) return undefined;
      if (mix === null) return null;
      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }
      const joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }
    current = current[paths[i]];
  }
  return current;
}
function getCleanedCode(code) {
  if (code && code.indexOf('_') > 0) return code.replace('_', '-');
  return code;
}

class ResourceStore extends EventEmitter {
  constructor(data) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };
    super();
    this.data = data || {};
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    if (this.options.ignoreJSONStructure === undefined) {
      this.options.ignoreJSONStructure = true;
    }
  }
  addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  }
  removeNamespaces(ns) {
    const index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  }
  getResource(lng, ns, key) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }
    const result = getPath(this.data, path);
    if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
    return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
  }
  addResource(lng, ns, key, value) {
    let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      silent: false
    };
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    setPath(this.data, path, value);
    if (!options.silent) this.emit('added', lng, ns, key, value);
  }
  addResources(lng, ns, resources) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
      silent: false
    };
    for (const m in resources) {
      if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
        silent: true
      });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  addResourceBundle(lng, ns, resources, deep, overwrite) {
    let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
      silent: false
    };
    let path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    let pack = getPath(this.data, path) || {};
    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      pack = {
        ...pack,
        ...resources
      };
    }
    setPath(this.data, path, pack);
    if (!options.silent) this.emit('added', lng, ns, resources);
  }
  removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);
    this.emit('removed', lng, ns);
  }
  hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  }
  getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;
    if (this.options.compatibilityAPI === 'v1') return {
      ...{},
      ...this.getResource(lng, ns)
    };
    return this.getResource(lng, ns);
  }
  getDataByLanguage(lng) {
    return this.data[lng];
  }
  hasLanguageSomeTranslations(lng) {
    const data = this.getDataByLanguage(lng);
    const n = data && Object.keys(data) || [];
    return !!n.find(v => data[v] && Object.keys(data[v]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}

var postProcessor = {
  processors: {},
  addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle(processors, value, key, options, translator) {
    processors.forEach(processor => {
      if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

const checkedLoadedFor = {};
class Translator extends EventEmitter {
  constructor(services) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, this);
    this.options = options;
    if (this.options.keySeparator === undefined) {
      this.options.keySeparator = '.';
    }
    this.logger = baseLogger.create('translator');
  }
  changeLanguage(lng) {
    if (lng) this.language = lng;
  }
  exists(key) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      interpolation: {}
    };
    if (key === undefined || key === null) {
      return false;
    }
    const resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  }
  extractFromKey(key, options) {
    let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    let namespaces = options.ns || this.options.defaultNS || [];
    const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
    const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
    if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
      const m = key.match(this.interpolator.nestingRegexp);
      if (m && m.length > 0) {
        return {
          key,
          namespaces
        };
      }
      const parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];
    return {
      key,
      namespaces
    };
  }
  translate(keys, options, lastKey) {
    if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) {
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (typeof options === 'object') options = {
      ...options
    };
    if (!options) options = {};
    if (keys === undefined || keys === null) return '';
    if (!Array.isArray(keys)) keys = [String(keys)];
    const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
    const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
    const {
      key,
      namespaces
    } = this.extractFromKey(keys[keys.length - 1], options);
    const namespace = namespaces[namespaces.length - 1];
    const lng = options.lng || this.language;
    const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        const nsSeparator = options.nsSeparator || this.options.nsSeparator;
        if (returnDetails) {
          return {
            res: `${namespace}${nsSeparator}${key}`,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace
          };
        }
        return `${namespace}${nsSeparator}${key}`;
      }
      if (returnDetails) {
        return {
          res: key,
          usedKey: key,
          exactUsedKey: key,
          usedLng: lng,
          usedNS: namespace
        };
      }
      return key;
    }
    const resolved = this.resolve(keys, options);
    let res = resolved && resolved.res;
    const resUsedKey = resolved && resolved.usedKey || key;
    const resExactUsedKey = resolved && resolved.exactUsedKey || key;
    const resType = Object.prototype.toString.apply(res);
    const noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
    const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
    const handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
    if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        if (!this.options.returnedObjectHandler) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        }
        const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
          ...options,
          ns: namespaces
        }) : `key '${key} (${this.language})' returned an object instead of string.`;
        if (returnDetails) {
          resolved.res = r;
          return resolved;
        }
        return r;
      }
      if (keySeparator) {
        const resTypeIsArray = resType === '[object Array]';
        const copy = resTypeIsArray ? [] : {};
        const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
        for (const m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            const deepKey = `${newKeyToUse}${keySeparator}${m}`;
            copy[m] = this.translate(deepKey, {
              ...options,
              ...{
                joinArrays: false,
                ns: namespaces
              }
            });
            if (copy[m] === deepKey) copy[m] = res[m];
          }
        }
        res = copy;
      }
    } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options, lastKey);
    } else {
      let usedDefault = false;
      let usedKey = false;
      const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      const hasDefaultValue = Translator.hasDefaultValue(options);
      const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
      const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
        ordinal: false
      }) : '';
      const defaultValue = options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
      if (!this.isValidLookup(res) && hasDefaultValue) {
        usedDefault = true;
        res = defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }
      const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
      const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
      const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
        if (keySeparator) {
          const fk = this.resolve(key, {
            ...options,
            keySeparator: false
          });
          if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
        }
        let lngs = [];
        const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (let i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }
        const send = (l, k, specificDefaultValue) => {
          const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
          } else if (this.backendConnector && this.backendConnector.saveMissing) {
            this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
          }
          this.emit('missingKey', l, namespace, k, res);
        };
        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && needsPluralHandling) {
            lngs.forEach(language => {
              this.pluralResolver.getSuffixes(language, options).forEach(suffix => {
                send([language], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
              });
            });
          } else {
            send(lngs, key, defaultValue);
          }
        }
      }
      res = this.extendTranslation(res, keys, options, resolved, lastKey);
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
      if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
        if (this.options.compatibilityAPI !== 'v1') {
          res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
        } else {
          res = this.options.parseMissingKeyHandler(res);
        }
      }
    }
    if (returnDetails) {
      resolved.res = res;
      return resolved;
    }
    return res;
  }
  extendTranslation(res, key, options, resolved, lastKey) {
    var _this = this;
    if (this.i18nFormat && this.i18nFormat.parse) {
      res = this.i18nFormat.parse(res, {
        ...this.options.interpolation.defaultVariables,
        ...options
      }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
        resolved
      });
    } else if (!options.skipInterpolation) {
      if (options.interpolation) this.interpolator.init({
        ...options,
        ...{
          interpolation: {
            ...this.options.interpolation,
            ...options.interpolation
          }
        }
      });
      const skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let nestBef;
      if (skipOnVariables) {
        const nb = res.match(this.interpolator.nestingRegexp);
        nestBef = nb && nb.length;
      }
      let data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
      if (this.options.interpolation.defaultVariables) data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
      res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
      if (skipOnVariables) {
        const na = res.match(this.interpolator.nestingRegexp);
        const nestAft = na && na.length;
        if (nestBef < nestAft) options.nest = false;
      }
      if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
      if (options.nest !== false) res = this.interpolator.nest(res, function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (lastKey && lastKey[0] === args[0] && !options.context) {
          _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
          return null;
        }
        return _this.translate(...args, key);
      }, options);
      if (options.interpolation) this.interpolator.reset();
    }
    const postProcess = options.postProcess || this.options.postProcess;
    const postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
        i18nResolved: resolved,
        ...options
      } : options, this);
    }
    return res;
  }
  resolve(keys) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let found;
    let usedKey;
    let exactUsedKey;
    let usedLng;
    let usedNS;
    if (typeof keys === 'string') keys = [keys];
    keys.forEach(k => {
      if (this.isValidLookup(found)) return;
      const extracted = this.extractFromKey(k, options);
      const key = extracted.key;
      usedKey = key;
      let namespaces = extracted.namespaces;
      if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
      const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
      const needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
      const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
      namespaces.forEach(ns => {
        if (this.isValidLookup(found)) return;
        usedNS = ns;
        if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
          checkedLoadedFor[`${codes[0]}-${ns}`] = true;
          this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        }
        codes.forEach(code => {
          if (this.isValidLookup(found)) return;
          usedLng = code;
          const finalKeys = [key];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys) {
            this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            let pluralSuffix;
            if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
            const zeroSuffix = `${this.options.pluralSeparator}zero`;
            const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (needsPluralHandling) {
              finalKeys.push(key + pluralSuffix);
              if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
              }
              if (needsZeroSuffixLookup) {
                finalKeys.push(key + zeroSuffix);
              }
            }
            if (needsContextHandling) {
              const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
              finalKeys.push(contextKey);
              if (needsPluralHandling) {
                finalKeys.push(contextKey + pluralSuffix);
                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                  finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                }
                if (needsZeroSuffixLookup) {
                  finalKeys.push(contextKey + zeroSuffix);
                }
              }
            }
          }
          let possibleKey;
          while (possibleKey = finalKeys.pop()) {
            if (!this.isValidLookup(found)) {
              exactUsedKey = possibleKey;
              found = this.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });
    return {
      res: found,
      usedKey,
      exactUsedKey,
      usedLng,
      usedNS
    };
  }
  isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  }
  getResource(code, ns, key) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
    return this.resourceStore.getResource(code, ns, key, options);
  }
  static hasDefaultValue(options) {
    const prefix = 'defaultValue';
    for (const option in options) {
      if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
        return true;
      }
    }
    return false;
  }
}

function capitalize$3(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
class LanguageUtil {
  constructor(options) {
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  getScriptPartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return null;
    const p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    if (p[p.length - 1].toLowerCase() === 'x') return null;
    return this.formatLanguageCode(p.join('-'));
  }
  getLanguagePartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf('-') < 0) return code;
    const p = code.split('-');
    return this.formatLanguageCode(p[0]);
  }
  formatLanguageCode(code) {
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      const specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      let p = code.split('-');
      if (this.options.lowerCaseLng) {
        p = p.map(part => part.toLowerCase());
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();
        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize$3(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize$3(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize$3(p[2].toLowerCase());
      }
      return p.join('-');
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  }
  isSupportedCode(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
  }
  getBestMatchFromCodes(codes) {
    if (!codes) return null;
    let found;
    codes.forEach(code => {
      if (found) return;
      const cleanedLng = this.formatLanguageCode(code);
      if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
    });
    if (!found && this.options.supportedLngs) {
      codes.forEach(code => {
        if (found) return;
        const lngOnly = this.getLanguagePartFromCode(code);
        if (this.isSupportedCode(lngOnly)) return found = lngOnly;
        found = this.options.supportedLngs.find(supportedLng => {
          if (supportedLng === lngOnly) return supportedLng;
          if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
          if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
        });
      });
    }
    if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
    return found;
  }
  getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
    if (!code) return fallbacks.default || [];
    let found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
    if (!found) found = fallbacks.default;
    return found || [];
  }
  toResolveHierarchy(code, fallbackCode) {
    const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
    const codes = [];
    const addCode = c => {
      if (!c) return;
      if (this.isSupportedCode(c)) {
        codes.push(c);
      } else {
        this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
      }
    };
    if (typeof code === 'string' && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }
    fallbackCodes.forEach(fc => {
      if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
    });
    return codes;
  }
}

let sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
let _rulesPluralsTypes = {
  1: function (n) {
    return Number(n > 1);
  },
  2: function (n) {
    return Number(n != 1);
  },
  3: function (n) {
    return 0;
  },
  4: function (n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function (n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function (n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function (n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function (n) {
    return Number(n >= 2);
  },
  10: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function (n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function (n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function (n) {
    return Number(n !== 0);
  },
  14: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function (n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function (n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function (n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function (n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function (n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function (n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function (n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function (n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
const nonIntlVersions = ['v1', 'v2', 'v3'];
const intlVersions = ['v4'];
const suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  const rules = {};
  sets.forEach(set => {
    set.lngs.forEach(l => {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}
class PluralResolver {
  constructor(languageUtils) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    if ((!this.options.compatibilityJSON || intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }
    this.rules = createRules();
  }
  addRule(lng, obj) {
    this.rules[lng] = obj;
  }
  getRule(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      try {
        return new Intl.PluralRules(getCleanedCode(code), {
          type: options.ordinal ? 'ordinal' : 'cardinal'
        });
      } catch {
        return;
      }
    }
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  }
  needsPlural(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const rule = this.getRule(code, options);
    if (this.shouldUseIntlApi()) {
      return rule && rule.resolvedOptions().pluralCategories.length > 1;
    }
    return rule && rule.numbers.length > 1;
  }
  getPluralFormsOfKey(code, key) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return this.getSuffixes(code, options).map(suffix => `${key}${suffix}`);
  }
  getSuffixes(code) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const rule = this.getRule(code, options);
    if (!rule) {
      return [];
    }
    if (this.shouldUseIntlApi()) {
      return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2) => suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map(pluralCategory => `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
    }
    return rule.numbers.map(number => this.getSuffix(code, number, options));
  }
  getSuffix(code, count) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const rule = this.getRule(code, options);
    if (rule) {
      if (this.shouldUseIntlApi()) {
        return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
      }
      return this.getSuffixRetroCompatible(rule, count);
    }
    this.logger.warn(`no plural rule found for: ${code}`);
    return '';
  }
  getSuffixRetroCompatible(rule, count) {
    const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
    let suffix = rule.numbers[idx];
    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
      if (suffix === 2) {
        suffix = 'plural';
      } else if (suffix === 1) {
        suffix = '';
      }
    }
    const returnSuffix = () => this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
    if (this.options.compatibilityJSON === 'v1') {
      if (suffix === 1) return '';
      if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
      return returnSuffix();
    } else if (this.options.compatibilityJSON === 'v2') {
      return returnSuffix();
    } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
      return returnSuffix();
    }
    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
  }
  shouldUseIntlApi() {
    return !nonIntlVersions.includes(this.options.compatibilityJSON);
  }
}

function deepFindWithDefaults(data, defaultData, key) {
  let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  let path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && typeof key === 'string') {
    path = deepFind(data, key, keySeparator);
    if (path === undefined) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
}
class Interpolator {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || (value => value);
    this.init(options);
  }
  init() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!options.interpolation) options.interpolation = {
      escapeValue: true
    };
    const iOpts = options.interpolation;
    this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
    this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
    this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
    this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
    this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
    this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
    this.resetRegExp();
  }
  reset() {
    if (this.options) this.init(this.options);
  }
  resetRegExp() {
    const regexpStr = `${this.prefix}(.+?)${this.suffix}`;
    this.regexp = new RegExp(regexpStr, 'g');
    const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
    const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  }
  interpolate(str, data, lng, options) {
    let match;
    let value;
    let replaces;
    const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }
    const handleFormat = key => {
      if (key.indexOf(this.formatSeparator) < 0) {
        const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(path, undefined, lng, {
          ...options,
          ...data,
          interpolationkey: key
        }) : path;
      }
      const p = key.split(this.formatSeparator);
      const k = p.shift().trim();
      const f = p.join(this.formatSeparator).trim();
      return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
        ...options,
        ...data,
        interpolationkey: k
      });
    };
    this.resetRegExp();
    const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
    const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    const todos = [{
      regex: this.regexpUnescape,
      safeValue: val => regexSafe(val)
    }, {
      regex: this.regexp,
      safeValue: val => this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
    }];
    todos.forEach(todo => {
      replaces = 0;
      while (match = todo.regex.exec(str)) {
        const matchedVar = match[1].trim();
        value = handleFormat(matchedVar);
        if (value === undefined) {
          if (typeof missingInterpolationHandler === 'function') {
            const temp = missingInterpolationHandler(str, match, options);
            value = typeof temp === 'string' ? temp : '';
          } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
            value = '';
          } else if (skipOnVariables) {
            value = match[0];
            continue;
          } else {
            this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
            value = '';
          }
        } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
          value = makeString(value);
        }
        const safeValue = todo.safeValue(value);
        str = str.replace(match[0], safeValue);
        if (skipOnVariables) {
          todo.regex.lastIndex += value.length;
          todo.regex.lastIndex -= match[0].length;
        } else {
          todo.regex.lastIndex = 0;
        }
        replaces++;
        if (replaces >= this.maxReplaces) {
          break;
        }
      }
    });
    return str;
  }
  nest(str, fc) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let match;
    let value;
    let clonedOptions;
    function handleHasOptions(key, inheritedOptions) {
      const sep = this.nestingOptionsSeparator;
      if (key.indexOf(sep) < 0) return key;
      const c = key.split(new RegExp(`${sep}[ ]*{`));
      let optionsString = `{${c[1]}`;
      key = c[0];
      optionsString = this.interpolate(optionsString, clonedOptions);
      const matchedSingleQuotes = optionsString.match(/'/g);
      const matchedDoubleQuotes = optionsString.match(/"/g);
      if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
        optionsString = optionsString.replace(/'/g, '"');
      }
      try {
        clonedOptions = JSON.parse(optionsString);
        if (inheritedOptions) clonedOptions = {
          ...inheritedOptions,
          ...clonedOptions
        };
      } catch (e) {
        this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
        return `${key}${sep}${optionsString}`;
      }
      delete clonedOptions.defaultValue;
      return key;
    }
    while (match = this.nestingRegexp.exec(str)) {
      let formatters = [];
      clonedOptions = {
        ...options
      };
      clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;
      let doReduce = false;
      if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
        const r = match[1].split(this.formatSeparator).map(elem => elem.trim());
        match[1] = r.shift();
        formatters = r;
        doReduce = true;
      }
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
      if (value && match[0] === str && typeof value !== 'string') return value;
      if (typeof value !== 'string') value = makeString(value);
      if (!value) {
        this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
        value = '';
      }
      if (doReduce) {
        value = formatters.reduce((v, f) => this.format(v, f, options.lng, {
          ...options,
          interpolationkey: match[1].trim()
        }), value.trim());
      }
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  }
}

function parseFormatStr(formatStr) {
  let formatName = formatStr.toLowerCase().trim();
  const formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    const p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    const optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      const opts = optStr.split(';');
      opts.forEach(opt => {
        if (!opt) return;
        const [key, ...rest] = opt.split(':');
        const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }
  return {
    formatName,
    formatOptions
  };
}
function createCachedFormatter(fn) {
  const cache = {};
  return function invokeFormatter(val, lng, options) {
    const key = lng + JSON.stringify(options);
    let formatter = cache[key];
    if (!formatter) {
      formatter = fn(getCleanedCode(lng), options);
      cache[key] = formatter;
    }
    return formatter(val);
  };
}
class Formatter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      currency: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt,
          style: 'currency'
        });
        return val => formatter.format(val);
      }),
      datetime: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.DateTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      }),
      relativetime: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.RelativeTimeFormat(lng, {
          ...opt
        });
        return val => formatter.format(val, opt.range || 'day');
      }),
      list: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.ListFormat(lng, {
          ...opt
        });
        return val => formatter.format(val);
      })
    };
    this.init(options);
  }
  init(services) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      interpolation: {}
    };
    const iOpts = options.interpolation;
    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
  }
  add(name, fc) {
    this.formats[name.toLowerCase().trim()] = fc;
  }
  addCached(name, fc) {
    this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
  }
  format(value, format, lng) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    const formats = format.split(this.formatSeparator);
    const result = formats.reduce((mem, f) => {
      const {
        formatName,
        formatOptions
      } = parseFormatStr(f);
      if (this.formats[formatName]) {
        let formatted = mem;
        try {
          const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
          const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
          formatted = this.formats[formatName](mem, l, {
            ...formatOptions,
            ...options,
            ...valOptions
          });
        } catch (error) {
          this.logger.warn(error);
        }
        return formatted;
      } else {
        this.logger.warn(`there was no format function for ${formatName}`);
      }
      return mem;
    }, value);
    return result;
  }
}

function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}
class Connector extends EventEmitter {
  constructor(backend, store, services) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    super();
    this.backend = backend;
    this.store = store;
    this.services = services;
    this.languageUtils = services.languageUtils;
    this.options = options;
    this.logger = baseLogger.create('backendConnector');
    this.waitingReads = [];
    this.maxParallelReads = options.maxParallelReads || 10;
    this.readingCalls = 0;
    this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    this.state = {};
    this.queue = [];
    if (this.backend && this.backend.init) {
      this.backend.init(services, options.backend, options);
    }
  }
  queueLoad(languages, namespaces, options, callback) {
    const toLoad = {};
    const pending = {};
    const toLoadLanguages = {};
    const toLoadNamespaces = {};
    languages.forEach(lng => {
      let hasAllNamespaces = true;
      namespaces.forEach(ns => {
        const name = `${lng}|${ns}`;
        if (!options.reload && this.store.hasResourceBundle(lng, ns)) {
          this.state[name] = 2;
        } else if (this.state[name] < 0) ; else if (this.state[name] === 1) {
          if (pending[name] === undefined) pending[name] = true;
        } else {
          this.state[name] = 1;
          hasAllNamespaces = false;
          if (pending[name] === undefined) pending[name] = true;
          if (toLoad[name] === undefined) toLoad[name] = true;
          if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
        }
      });
      if (!hasAllNamespaces) toLoadLanguages[lng] = true;
    });
    if (Object.keys(toLoad).length || Object.keys(pending).length) {
      this.queue.push({
        pending,
        pendingCount: Object.keys(pending).length,
        loaded: {},
        errors: [],
        callback
      });
    }
    return {
      toLoad: Object.keys(toLoad),
      pending: Object.keys(pending),
      toLoadLanguages: Object.keys(toLoadLanguages),
      toLoadNamespaces: Object.keys(toLoadNamespaces)
    };
  }
  loaded(name, err, data) {
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    if (err) this.emit('failedLoading', lng, ns, err);
    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }
    this.state[name] = err ? -1 : 2;
    const loaded = {};
    this.queue.forEach(q => {
      pushPath(q.loaded, [lng], ns);
      removePending(q, name);
      if (err) q.errors.push(err);
      if (q.pendingCount === 0 && !q.done) {
        Object.keys(q.loaded).forEach(l => {
          if (!loaded[l]) loaded[l] = {};
          const loadedKeys = q.loaded[l];
          if (loadedKeys.length) {
            loadedKeys.forEach(n => {
              if (loaded[l][n] === undefined) loaded[l][n] = true;
            });
          }
        });
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });
    this.emit('loaded', loaded);
    this.queue = this.queue.filter(q => !q.done);
  }
  read(lng, ns, fcName) {
    let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
    let callback = arguments.length > 5 ? arguments[5] : undefined;
    if (!lng.length) return callback(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng,
        ns,
        fcName,
        tried,
        wait,
        callback
      });
      return;
    }
    this.readingCalls++;
    const resolver = (err, data) => {
      this.readingCalls--;
      if (this.waitingReads.length > 0) {
        const next = this.waitingReads.shift();
        this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
      }
      if (err && data && tried < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    };
    const fc = this.backend[fcName].bind(this.backend);
    if (fc.length === 2) {
      try {
        const r = fc(lng, ns);
        if (r && typeof r.then === 'function') {
          r.then(data => resolver(null, data)).catch(resolver);
        } else {
          resolver(null, r);
        }
      } catch (err) {
        resolver(err);
      }
      return;
    }
    return fc(lng, ns, resolver);
  }
  prepareLoading(languages, namespaces) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let callback = arguments.length > 3 ? arguments[3] : undefined;
    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }
    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];
    const toLoad = this.queueLoad(languages, namespaces, options, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback();
      return null;
    }
    toLoad.toLoad.forEach(name => {
      this.loadOne(name);
    });
  }
  load(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {}, callback);
  }
  reload(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {
      reload: true
    }, callback);
  }
  loadOne(name) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const s = name.split('|');
    const lng = s[0];
    const ns = s[1];
    this.read(lng, ns, 'read', undefined, undefined, (err, data) => {
      if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
      if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
      this.loaded(name, err, data);
    });
  }
  saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : () => {};
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
      this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
      return;
    }
    if (key === undefined || key === null || key === '') return;
    if (this.backend && this.backend.create) {
      const opts = {
        ...options,
        isUpdate
      };
      const fc = this.backend.create.bind(this.backend);
      if (fc.length < 6) {
        try {
          let r;
          if (fc.length === 5) {
            r = fc(languages, namespace, key, fallbackValue, opts);
          } else {
            r = fc(languages, namespace, key, fallbackValue);
          }
          if (r && typeof r.then === 'function') {
            r.then(data => clb(null, data)).catch(clb);
          } else {
            clb(null, r);
          }
        } catch (err) {
          clb(err);
        }
      } else {
        fc(languages, namespace, key, fallbackValue, clb, opts);
      }
    }
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  }
}

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: false,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      let ret = {};
      if (typeof args[1] === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];
      if (typeof args[2] === 'object' || typeof args[3] === 'object') {
        const options = args[3] || args[2];
        Object.keys(options).forEach(key => {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: (value, format, lng, options) => value,
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  return options;
}

function noop$1() {}
function bindMemberFunctions(inst) {
  const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(mem => {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}
class I18n extends EventEmitter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    super();
    this.options = transformOptions(options);
    this.services = {};
    this.logger = baseLogger;
    this.modules = {
      external: []
    };
    bindMemberFunctions(this);
    if (callback && !this.isInitialized && !options.isClone) {
      if (!this.options.initImmediate) {
        this.init(options, callback);
        return this;
      }
      setTimeout(() => {
        this.init(options, callback);
      }, 0);
    }
  }
  init() {
    var _this = this;
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!options.defaultNS && options.defaultNS !== false && options.ns) {
      if (typeof options.ns === 'string') {
        options.defaultNS = options.ns;
      } else if (options.ns.indexOf('translation') < 0) {
        options.defaultNS = options.ns[0];
      }
    }
    const defOpts = get();
    this.options = {
      ...defOpts,
      ...this.options,
      ...transformOptions(options)
    };
    if (this.options.compatibilityAPI !== 'v1') {
      this.options.interpolation = {
        ...defOpts.interpolation,
        ...this.options.interpolation
      };
    }
    if (options.keySeparator !== undefined) {
      this.options.userDefinedKeySeparator = options.keySeparator;
    }
    if (options.nsSeparator !== undefined) {
      this.options.userDefinedNsSeparator = options.nsSeparator;
    }
    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }
    if (!this.options.isClone) {
      if (this.modules.logger) {
        baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        baseLogger.init(null, this.options);
      }
      let formatter;
      if (this.modules.formatter) {
        formatter = this.modules.formatter;
      } else if (typeof Intl !== 'undefined') {
        formatter = Formatter;
      }
      const lu = new LanguageUtil(this.options);
      this.store = new ResourceStore(this.options.resources, this.options);
      const s = this.services;
      s.logger = baseLogger;
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new PluralResolver(lu, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      });
      if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
        s.formatter = createClassOnDemand(formatter);
        s.formatter.init(s, this.options);
        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
      }
      s.interpolator = new Interpolator(this.options);
      s.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      };
      s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        _this.emit(event, ...args);
      });
      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
      }
      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }
      this.translator = new Translator(this.services, this.options);
      this.translator.on('*', function (event) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        _this.emit(event, ...args);
      });
      this.modules.external.forEach(m => {
        if (m.init) m.init(this);
      });
    }
    this.format = this.options.interpolation.format;
    if (!callback) callback = noop$1;
    if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
    }
    if (!this.services.languageDetector && !this.options.lng) {
      this.logger.warn('init: no languageDetector is used and no lng is defined');
    }
    const storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
    storeApi.forEach(fcName => {
      this[fcName] = function () {
        return _this.store[fcName](...arguments);
      };
    });
    const storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
    storeApiChained.forEach(fcName => {
      this[fcName] = function () {
        _this.store[fcName](...arguments);
        return _this;
      };
    });
    const deferred = defer();
    const load = () => {
      const finish = (err, t) => {
        if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
        this.isInitialized = true;
        if (!this.options.isClone) this.logger.log('initialized', this.options);
        this.emit('initialized', this.options);
        deferred.resolve(t);
        callback(err, t);
      };
      if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, finish);
    };
    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }
    return deferred;
  }
  loadResources(language) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
    let usedCallback = callback;
    const usedLng = typeof language === 'string' ? language : this.language;
    if (typeof language === 'function') usedCallback = language;
    if (!this.options.resources || this.options.partialBundledLanguages) {
      if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
      const toLoad = [];
      const append = lng => {
        if (!lng) return;
        const lngs = this.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(l => {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      if (!usedLng) {
        const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(l => append(l));
      } else {
        append(usedLng);
      }
      if (this.options.preload) {
        this.options.preload.forEach(l => append(l));
      }
      this.services.backendConnector.load(toLoad, this.options.ns, e => {
        if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
        usedCallback(e);
      });
    } else {
      usedCallback(null);
    }
  }
  reloadResources(lngs, ns, callback) {
    const deferred = defer();
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    if (!callback) callback = noop$1;
    this.services.backendConnector.reload(lngs, ns, err => {
      deferred.resolve();
      callback(err);
    });
    return deferred;
  }
  use(module) {
    if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
    if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
    if (module.type === 'backend') {
      this.modules.backend = module;
    }
    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }
    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }
    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }
    if (module.type === 'postProcessor') {
      postProcessor.addPostProcessor(module);
    }
    if (module.type === 'formatter') {
      this.modules.formatter = module;
    }
    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }
    return this;
  }
  setResolvedLanguage(l) {
    if (!l || !this.languages) return;
    if (['cimode', 'dev'].indexOf(l) > -1) return;
    for (let li = 0; li < this.languages.length; li++) {
      const lngInLngs = this.languages[li];
      if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
      if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
        this.resolvedLanguage = lngInLngs;
        break;
      }
    }
  }
  changeLanguage(lng, callback) {
    var _this2 = this;
    this.isLanguageChangingTo = lng;
    const deferred = defer();
    this.emit('languageChanging', lng);
    const setLngProps = l => {
      this.language = l;
      this.languages = this.services.languageUtils.toResolveHierarchy(l);
      this.resolvedLanguage = undefined;
      this.setResolvedLanguage(l);
    };
    const done = (err, l) => {
      if (l) {
        setLngProps(l);
        this.translator.changeLanguage(l);
        this.isLanguageChangingTo = undefined;
        this.emit('languageChanged', l);
        this.logger.log('languageChanged', l);
      } else {
        this.isLanguageChangingTo = undefined;
      }
      deferred.resolve(function () {
        return _this2.t(...arguments);
      });
      if (callback) callback(err, function () {
        return _this2.t(...arguments);
      });
    };
    const setLng = lngs => {
      if (!lng && !lngs && this.services.languageDetector) lngs = [];
      const l = typeof lngs === 'string' ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
      if (l) {
        if (!this.language) {
          setLngProps(l);
        }
        if (!this.translator.language) this.translator.changeLanguage(l);
        if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
      }
      this.loadResources(l, err => {
        done(err, l);
      });
    };
    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      if (this.services.languageDetector.detect.length === 0) {
        this.services.languageDetector.detect().then(setLng);
      } else {
        this.services.languageDetector.detect(setLng);
      }
    } else {
      setLng(lng);
    }
    return deferred;
  }
  getFixedT(lng, ns, keyPrefix) {
    var _this3 = this;
    const fixedT = function (key, opts) {
      let options;
      if (typeof opts !== 'object') {
        for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          rest[_key3 - 2] = arguments[_key3];
        }
        options = _this3.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      } else {
        options = {
          ...opts
        };
      }
      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
      const keySeparator = _this3.options.keySeparator || '.';
      let resultKey;
      if (options.keyPrefix && Array.isArray(key)) {
        resultKey = key.map(k => `${options.keyPrefix}${keySeparator}${k}`);
      } else {
        resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
      }
      return _this3.t(resultKey, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    fixedT.keyPrefix = keyPrefix;
    return fixedT;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  }
  hasLoadedNamespace(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!this.isInitialized) {
      this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
      return false;
    }
    if (!this.languages || !this.languages.length) {
      this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
      return false;
    }
    const lng = options.lng || this.resolvedLanguage || this.languages[0];
    const fallbackLng = this.options ? this.options.fallbackLng : false;
    const lastLng = this.languages[this.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n) => {
      const loadState = this.services.backendConnector.state[`${l}|${n}`];
      return loadState === -1 || loadState === 2;
    };
    if (options.precheck) {
      const preResult = options.precheck(this, loadNotPending);
      if (preResult !== undefined) return preResult;
    }
    if (this.hasResourceBundle(lng, ns)) return true;
    if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
  }
  loadNamespaces(ns, callback) {
    const deferred = defer();
    if (!this.options.ns) {
      if (callback) callback();
      return Promise.resolve();
    }
    if (typeof ns === 'string') ns = [ns];
    ns.forEach(n => {
      if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
    });
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  loadLanguages(lngs, callback) {
    const deferred = defer();
    if (typeof lngs === 'string') lngs = [lngs];
    const preloaded = this.options.preload || [];
    const newLngs = lngs.filter(lng => preloaded.indexOf(lng) < 0);
    if (!newLngs.length) {
      if (callback) callback();
      return Promise.resolve();
    }
    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(err => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  dir(lng) {
    if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
    if (!lng) return 'rtl';
    const rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
    const languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
    return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
  }
  static createInstance() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
  }
  cloneInstance() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
    const forkResourceStore = options.forkResourceStore;
    if (forkResourceStore) delete options.forkResourceStore;
    const mergedOptions = {
      ...this.options,
      ...options,
      ...{
        isClone: true
      }
    };
    const clone = new I18n(mergedOptions);
    if (options.debug !== undefined || options.prefix !== undefined) {
      clone.logger = clone.logger.clone(options);
    }
    const membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(m => {
      clone[m] = this[m];
    });
    clone.services = {
      ...this.services
    };
    clone.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    if (forkResourceStore) {
      clone.store = new ResourceStore(this.store.data, mergedOptions);
      clone.services.resourceStore = clone.store;
    }
    clone.translator = new Translator(clone.services, mergedOptions);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      clone.emit(event, ...args);
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = mergedOptions;
    clone.translator.backendConnector.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    return clone;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

instance.createInstance;
instance.dir;
instance.init;
instance.loadResources;
instance.reloadResources;
instance.use;
instance.changeLanguage;
instance.getFixedT;
instance.t;
instance.exists;
instance.setDefaultNamespace;
instance.hasLoadedNamespace;
instance.loadNamespaces;
instance.loadLanguages;

/* eslint-disable */
const translation = {
    /**
     * @description copy keys for account exists view
     * @default
     * {
          connect: 'Connect with {{socialOauth}}',
          description: 'It looks like an account already exists using',
          title: 'Account already exists',
          trail_message_email: '. Please log in with your email.',
          trail_message_social: 'through {{socialOauth}}',
        }
     */
    dyn_sandbox_maximum_threshold: {
        title: 'Max User Limit Reached',
        description: 'Your sandbox environment has reached your 100 MAU limit. To test with new users, delete existing users.',
        button: 'Back',
    },
    dyn_account_exists: {
        connect: 'Connect with {{socialOauth}}',
        description_email: 'It looks like an account already exists using',
        description_social: 'To restore your account to the right place, we need you to log in again.',
        title: 'Re-Authentication Required',
        trail_message_email: '. Please log in with your email.',
        trail_message_social: 'through {{socialOauth}}',
    },
    /**
     * @description copy keys for active wallet information (address, network, etc)
     * @default
     * {
          testnet_warning: 'A testnet network has been selected. Please only use testnet funds or they will be lost.',
          ordinals_address: 'Ordinals address',
          payment_address: 'Payment address',
          balance: 'Balance',
          options: {
            copy_ens: 'Copy ENS',
            view_address: 'View address',
            settings: 'Wallet settings',
            export: 'Export private keys',
          },
        }
     */
    dyn_active_wallet_info: {
        testnet_warning: 'A testnet network has been selected. Please only use testnet funds or they will be lost.',
        ordinals_address: 'Ordinals address',
        payment_address: 'Payment address',
        balance: 'Balance',
        options: {
            copy_ens: 'Copy ENS',
            view_address: 'View address',
            settings: 'Wallet settings',
            export: 'Export private keys',
        },
    },
    /**
     * @description copy keys for wallet details card
     * @default
     * {
          header: 'Wallet Details',
          address: 'Address',
          copy: 'Copy',
          copied: 'Copied!',
       }
     */
    dyn_wallet_details_card: {
        header: 'Wallet Details',
        address: 'Address',
        copy: 'Copy',
        copied: 'Copied!',
    },
    /**
     * @description copy keys for add network view
     * @default
     * {
        title: 'Add {{name}} network to your wallet',
        add_button: {
          title: 'Add network',
        },
        cancel_button: {
          title: 'Cancel',
        },
      }
     */
    dyn_add_network_view: {
        title: 'Network unavailable',
        description: 'This network is not supported in your {{name}} wallet.',
        add_button: {
            title: 'Add Network',
        },
        cancel_button: {
            title: 'Cancel',
        },
    },
    /**
     * @description copy keys for bridge view
     * @default
     * {
          summary_view: {
            connection_succeed: 'Congratulations on connecting both your {{firstBlockchainName}} and {{secondBlockchainName}} wallets',
            title: 'Welcome to {{appName}}',
          },
          welcome_view: {
            button: 'Get started',
            description: 'You’ll need to connect both your {{firstBlockchainName}} and {{secondBlockchainName}} wallets to get started',
            title: 'Connect to {{appName}}',
          },
          widget: {
            address: 'Copy wallet address',
            connect: 'Connect wallet',
            connect_with_network: 'Connect {{blockchainName}} wallet',
            copy: {
              address: 'Copy wallet address',
              ens: 'Copy ENS',
            },
            disconnect: 'Disconnect',
            edit_profile: 'Edit profile',
            wallet_network: '{{networkName}} wallet',
          },
        }
     */
    dyn_bridge: {
        summary_view: {
            connection_succeed: 'Congratulations on connecting both your {{firstBlockchainName}} and {{secondBlockchainName}} wallets',
            title: 'Welcome to {{appName}}',
        },
        welcome_view: {
            button: 'Get started',
            description: 'You’ll need to connect both your {{firstBlockchainName}} and {{secondBlockchainName}} wallets to get started',
            title: 'Connect to {{appName}}',
        },
        widget: {
            address: 'Copy wallet address',
            connect: 'Connect wallet',
            connect_with_network: 'Connect {{blockchainName}} wallet',
            copy: {
                address: 'Copy wallet address',
                ens: 'Copy ENS',
            },
            disconnect: 'Disconnect',
            edit_profile: 'Edit profile',
            wallet_network: '{{networkName}} wallet',
        },
    },
    /**
     * @description copy keys for Dynamic Captcha
     * @default
     * {
        verify_user_subtitle: 'We need to quickly verify you’re human before we proceed.',
        verify_user_title: "Let's verify you're human",
      }
     */
    dyn_captcha: {
        verify_user_subtitle: 'We need to quickly verify you’re human before we proceed.',
        verify_user_title: "Let's verify you're human",
    },
    /**
     * @description copy keys for sanctioned access blocked view
     * @default
     * {
     *  title: 'Access Blocked',
     *  content: 'Logging in is not available to persons in {{jurisdiction}} as you are in a sanctioned jurisdiction.',
     * }
     */
    dyn_access_blocked: {
        title: 'Access Blocked',
        content: 'Logging in is not available to persons in {{jurisdiction}} as you are in a sanctioned jurisdiction.',
    },
    /**
     * @description copy keys for chainalysis blocked wallet view
     * @default
     * {
         title: 'Access denied',
       }
     */
    dyn_chainalysis_blocked_wallet: {
        title: 'Access denied',
    },
    /**
     * @description copy keys for collecting user data
     * @default
     * {
        description: 'We need a bit of information to get started',
        fields: {
          alias: {
            label: 'Alias',
          },
          country: {
            label: 'Country',
          },
          email: {
            label: 'Email',
            validation: 'Email is not valid',
          },
          first_name: {
            label: 'First Name',
          },
          job_title: {
            label: 'Job Title',
          },
          last_name: {
            label: 'Last Name',
          },
          phone_number: {
            label: 'Phone number',
            validation: 'Phone number is not valid',
            too_short: 'Phone number is too short',
          },
          policies_consent: {
            label: 'Policies Consent',
          },
          t_shirt_size: {
            label: 'T-Shirt Size',
          },
          team: {
            label: 'Team',
          },
          username: {
            label: 'Username',
            validation: 'Username is not valid',
          },
        },
        greeting: 'Welcome to {{appName}}',
        log_out_button: 'Log out',
        not_supported_network: {
          description: 'Your wallet is not connected to a supported network. Please update before continuing.',
          error_message: 'This network is not available, please update.',
          title: 'Update Network',
        },
        update_email_tooltip:
        'This email is tied to your wallet so cannot be updated',
        update_phone_number_tooltip:
        'This phone number is tied to your wallet so cannot be updated',
        lock_editing_multiple_verified_fields:
        'You can only edit 1 field at a time that requires verification',
      }
     */
    dyn_collect_user_data: {
        description: 'We need a bit of information to get started',
        fields: {
            alias: {
                label: 'Alias',
            },
            country: {
                label: 'Country',
            },
            email: {
                label: 'Email',
                validation: 'Email is not valid',
            },
            first_name: {
                label: 'First Name',
            },
            job_title: {
                label: 'Job Title',
            },
            last_name: {
                label: 'Last Name',
            },
            phone_number: {
                label: 'Phone number',
                validation: 'Phone number is not valid',
                too_short: 'Phone number is too short',
            },
            policies_consent: {
                label: 'Policies Consent',
            },
            t_shirt_size: {
                label: 'T-Shirt Size',
            },
            team: {
                label: 'Team',
            },
            username: {
                label: 'Username',
                validation: 'Username is not valid',
            },
        },
        greeting: 'Welcome to {{appName}}',
        log_out_button: 'Log out',
        not_supported_network: {
            description: 'Your wallet is not connected to a supported network. Please update before continuing.',
            error_message: 'This network is not available, please update.',
            title: 'Update Network',
        },
        update_email_tooltip: 'This email is tied to your wallet so cannot be updated',
        update_phone_number_tooltip: 'This phone number is tied to your wallet so cannot be updated',
        lock_editing_multiple_verified_fields: 'You can only edit 1 field at a time that requires verification',
    },
    /**
     * @description copy keys for create password view
     * @default
     * {
        continue: 'Continue',
        create_input: {
          label: 'Create passcode',
          placeholder: 'Create passcode',
        },
        confirm_input: {
          label: 'Confirm passcode',
          placeholder: 'Confirm passcode',
        },
        current_password_input: {
          label: 'Current passcode',
          placeholder: 'Current passcode',
        },
        description:
          "Choose a strong, unique passcode to ensure your account's security and privacy.",
        errors: {
          invalid_current_password: 'Invalid current passcode',
          error_changing_password: 'Error changing passcode',
          new_password_same_as_old: 'New passcode cannot be the same as the old passcode',
          password_mismatch: 'Passcodes do not match',
          user_closed_view: 'User closed the view',
        },
        intro: {
          continue: 'Set up a passcode',
          description: {
            title: 'Add a passcode to protect your account',
            additional_protection: {
              title: 'Passcode Security',
              description:
                'Add a secure passcode to further prevent un-authrized access to your account.',
            },
            restore_access: {
              title: 'Restore Access',
              description:
                'You will be asked to enter it when signing on to a new device.',
            },
          },
          title: 'Add a Passcode',
        },
        logout: 'Log out',
        title: {
          create: 'Create passcode',
          update: 'Create new passcode',
        },
        update_input: {
          label: 'New passcode',
          placeholder: 'New passcode',
        },
      }
     */
    dyn_create_password: {
        continue: 'Continue',
        create_input: {
            label: 'Create passcode',
            placeholder: 'Create passcode',
        },
        confirm_input: {
            label: 'Confirm passcode',
            placeholder: 'Confirm passcode',
        },
        current_password_input: {
            label: 'Current passcode',
            placeholder: 'Current passcode',
        },
        description: "Choose a strong, unique passcode to ensure your account's security and privacy.",
        errors: {
            invalid_current_password: 'Invalid current passcode',
            error_changing_password: 'Error changing passcode',
            new_password_same_as_old: 'New passcode cannot be the same as the old passcode',
            password_mismatch: 'Passcodes do not match',
            user_closed_view: 'User closed the view',
        },
        intro: {
            continue: 'Set up a passcode',
            description: {
                title: 'Add a passcode to protect your account',
                additional_protection: {
                    title: 'Passcode Security',
                    description: 'Add a secure passcode to further prevent un-authrized access to your account.',
                },
                restore_access: {
                    title: 'Restore Access',
                    description: 'You will be asked to enter it when signing on to a new device.',
                },
            },
            title: 'Add a Passcode',
        },
        logout: 'Log out',
        title: {
            create: 'Create passcode',
            update: 'Create new passcode',
        },
        update_input: {
            label: 'New passcode',
            placeholder: 'New passcode',
        },
    },
    /**
     * @description copy keys for creating wallet wallet message
     * @default
     * {
        loading_message: 'Your wallet is being created...',
      }
     */
    dyn_creating_wallet: {
        loading_message: 'Your wallet is being created...',
    },
    /**
     * @description copy keys for email verification view after email logging in with magiclink
     * @default
     * {
        description: 'We’ve sent a verification email to',
        note: 'Note: it might take a few seconds to proceed after clicking the link in your email',
        title: 'Confirm your email',
      }
     */
    dyn_email_confirmation: {
        description: 'We’ve sent a verification email to',
        note: 'Note: it might take a few seconds to proceed after clicking the link in your email',
        title: 'Confirm your email',
    },
    /**
     * @description copy keys for email update view
     * @default
     * {
        current_email: 'Your current email address is',
        label: 'Email address',
        send_verification: 'Send Verification Code',
        title: 'Update email',
      }
    */
    dyn_email_update: {
        current_email: 'Your current email address is',
        label: 'Email address',
        send_verification: 'Send Verification Code',
        title: 'Update email',
    },
    /**
     * @description copy keys for one-time password verification view after logging in with dynamic email or phone number provider or after kyc verification
     * @default
     * {
        code_not_received: 'Did not receive a code? Check spam or',
        code_sent: 'Code sent',
        description: 'We’ve sent a verification code to',
        log_out_button: 'Log out',
        resend_code: 'Re-send code',
        resend_code_in: 'Re-send code in {{remainingSeconds}}',
        confirm_code: 'Confirm verification code',
        verification_succeeded: 'Verification code confirmed',
        hang_tight: 'Hang tight while we get things ready for you',
  
        email: {
          title: 'Confirm your email',
          complete:
            'Verification complete, the email is now verified to this account.',
        },
        phone_number: {
          title: 'Confirm your phone number',
          edit: 'Edit phone number',
          complete:
            'Verification complete, the phone number is now verified to this account.',
        },
      },
     */
    dyn_otp_verification: {
        code_not_received: 'Did not receive a code? Check spam or',
        code_sent: 'Code sent',
        description: 'We’ve sent a verification code to',
        log_out_button: 'Log out',
        resend_code: 'Re-send code',
        resend_code_in: 'Re-send code in {{remainingSeconds}}',
        confirm_code: 'Confirm verification code',
        verification_succeeded: 'Verification code confirmed',
        hang_tight: 'Hang tight while we get things ready for you',
        email: {
            title: 'Confirm your email',
            complete: 'Verification complete, the email is now verified to this account.',
        },
        phone_number: {
            title: 'Confirm your phone number',
            edit: 'Edit phone number',
            complete: 'Verification complete, the phone number is now verified to this account.',
        },
    },
    /**
     * @description copy keys for deposit view
     * @default
     * {
        title: 'Deposit',
      }
     */
    dyn_deposit: {
        title: 'Deposit',
        receive_funds_on: 'You can receive tokens on ',
    },
    /**
     * @description copy keys for embedded wallet authenticator choice view
     * @default
     * {
        description:
          'Protect your account and simplify your transaction experience.',
        email: {
          badge: 'Fastest',
          description: ' You will need to renew after {{expiration}} minutes ',
          title: 'Use a one-time code',
        },
        passkey: {
          auth_info: {
            convinience: {
              title: 'Convenient and Fast',
              description:
                'Use Face ID or Touch ID to complete transactions quickly.',
            },
            security: {
              title: 'Increased Security',
              description:
                'Passkeys are encrypted end-to-end on your device or password manager to prevent phishing attempts.',
            },
            add_button: 'Add a passkey',
            start_button: 'Add a passkey',
          },
          no_email_auth_info: {
            convinience: {
              title: 'Simple and Fast',
              description:
                'Works across devices and syncs between devices and browsers.',
            },
            security: {
              title: 'Secured with a bio-metric',
              description: 'Phishing resistant and encrypted.',
            },
            add_button: 'Add passkey',
            start_button: 'Add passkey',
          },
          badge: 'Recommended',
          description:
            'Works across devices & secured with biometric to prevent phishing attempts ',
          title: 'Create new passkey',
          reveal_title: 'Add a passkey',
        },
        skip: 'Not now',
        title: 'Account security',
        need_help_title: 'Problem Signing?',
        need_help_description: 'Select from an option below to complete',
        reveal_title: 'Verification Required',
        reveal_description: 'Choose a verification method.',
      }
     */
    dyn_embedded_authenticator: {
        description: 'Protect your account and simplify your transaction experience.',
        email: {
            badge: 'Fastest',
            description: ' You will need to renew after {{expiration}} minutes ',
            title: 'Use a one-time code',
        },
        passkey: {
            auth_info: {
                convinience: {
                    title: 'Convenient and Fast',
                    description: 'Use Face ID or Touch ID to complete transactions quickly.',
                },
                security: {
                    title: 'Increased Security',
                    description: 'Passkeys are encrypted end-to-end on your device or password manager to prevent phishing attempts.',
                },
                add_button: 'Add a passkey',
                start_button: 'Add a passkey',
            },
            no_email_auth_info: {
                convinience: {
                    title: 'Simple and Fast',
                    description: 'Works across devices and syncs between devices and browsers.',
                },
                security: {
                    title: 'Secured with a bio-metric',
                    description: 'Phishing resistant and encrypted.',
                },
                add_button: 'Add passkey',
                start_button: 'Add passkey',
            },
            badge: 'Recommended',
            description: 'Works across devices & secured with biometric to prevent phishing attempts ',
            title: 'Create new passkey',
            reveal_title: 'Add a passkey',
        },
        skip: 'Not now',
        title: 'Account security',
        need_help_title: 'Problem Signing?',
        need_help_description: 'Select from an option below to complete',
        reveal_title: 'Verification Required',
        reveal_description: 'Choose a verification method.',
    },
    /**
       * @description copy keys for enter password view
       * @default
       * {
          continue_button_label: 'Continue',
          description: 'Please enter your passcode below to continue.',
          error: {
            invalid_password: 'Invalid passcode',
          },
          input: {
            label: 'Passcode',
            placeholder: 'Passcode',
          },
          title: 'Enter passcode',
        }
       */
    dyn_enter_password: {
        continue_button_label: 'Continue',
        description: 'Please enter your passcode below to continue.',
        error: {
            invalid_password: 'Invalid passcode',
        },
        input: {
            label: 'Passcode',
            placeholder: 'Passcode',
        },
        title: 'Enter passcode',
    },
    /**
       * @description copy keys for Dynamic Farcaster connect view
       * @default
       * {
          copy_button: 'Copy QR URI',
          scan_title: "Scan this QR code from your mobile app or phone's camera to connect.",
        }
       */
    dyn_farcaster_connect_view: {
        copy_button: 'Copy QR URI',
        scan_title: "Scan this QR code from your mobile app or phone's camera to connect.",
    },
    /**
     * @description copy keys for log in view
     * @default
     * dyn_login: {
      connect_wallet: {
        title: 'Connect',
      },
      email_form: {
        email_field: {
          label: 'Enter your email',
        },
        submit_button: {
          label: 'Continue',
        },
      },
      email_or_phone: {
        use_email: 'Use email',
        use_phone: 'Use phone',
        prefer_email: 'Prefer email sign up?',
        prefer_phone: 'Prefer phone number sign up?',
      },
      helper: {
        all_wallet_list: 'Get your first wallet',
        email_form: {
          invalid_email: 'Invalid or incorrect email. Did you mistype it?',
        },
        pending_connect: {
          title: 'Connecting a wallet',
        },
        pending_signature: {
          title: 'Signing a wallet',
        },
        pending_signature_without_back_button: {
          title: 'Signing a wallet',
        },
        phone_number_form: {
          invalid_phone: 'Invalid or incorrect number. Did you mistype it?',
          invalid_sms_verification:
            'The code you entered is incorrect. Please try again.',
          too_many_sms_verification_attempts:
            'Too many verification attempts, please try again later.',
        },
        qr_code: {
          title: 'Connecting a wallet',
        },
        wallet_only: 'Get your first wallet',
      },
      qr_code: {
        title: 'Connect',
      },
      separators: {
        default: 'OR',
      },
      sign_wallet: {
        title: 'Sign',
      },
      select_wallet_in_wallet_group: {
        title: 'Select',
      },
      social: {
        button_label: 'Continue with {{provider}}',
        overlay_title: 'Choose a social account',
      },
      title: {
        all: 'Log in or sign up',
        all_wallet_list: 'Select your wallet',
        wallet_only: 'Select your wallet',
      },
      wallet_group: {
        title: 'Select Chain',
      },
      wallet_list: {
        button_only: 'Continue with a wallet',
      },
      mobile_wallet_redirect: {
        backup_title: 'Connect mobile app',
        prompt: "Tap 'Open' to continue",
        get_app_prompt: 'Get',
        open_prompt: 'Open',
        redirect_fail_message:
          "If the app doesn't open, you might need to download the {{walletName}} Wallet app.",
        app_store: 'App Store',
        play_store: 'Play Store',
      },
      wrong_social_account: {
        retry_button: 'Try again',
        retry_title: 'Please connect with: ',
        subtitle:
          'You must connect with the same account you originally signed in with.',
        title: 'Whoops. Wrong Account',
      },
    },
     */
    dyn_login: {
        connect_wallet: {
            title: 'Connect',
        },
        email_form: {
            email_field: {
                label: 'Enter your email',
            },
            submit_button: {
                label: 'Continue',
            },
        },
        email_or_phone: {
            use_email: 'Use email',
            use_phone: 'Use phone',
            prefer_email: 'Prefer email sign up?',
            prefer_phone: 'Prefer phone number sign up?',
        },
        helper: {
            all_wallet_list: 'Get your first wallet',
            email_form: {
                invalid_email: 'Invalid or incorrect email. Did you mistype it?',
            },
            pending_connect: {
                title: 'Connecting a wallet',
            },
            pending_signature: {
                title: 'Signing a wallet',
            },
            pending_signature_without_back_button: {
                title: 'Signing a wallet',
            },
            phone_number_form: {
                invalid_phone: 'Invalid or incorrect number. Did you mistype it?',
                invalid_sms_verification: 'The code you entered is incorrect. Please try again.',
                too_many_sms_verification_attempts: 'Too many verification attempts, please try again later.',
            },
            qr_code: {
                title: 'Connecting a wallet',
            },
            wallet_only: 'Get your first wallet',
        },
        qr_code: {
            title: 'Connect',
        },
        separators: {
            default: 'OR',
        },
        sign_wallet: {
            title: 'Sign',
        },
        select_wallet_in_wallet_group: {
            title: 'Select',
        },
        social: {
            button_label: 'Continue with {{provider}}',
            overlay_title: 'Choose a social account',
        },
        title: {
            all: 'Log in or sign up',
            all_wallet_list: 'Select your wallet',
            wallet_only: 'Select your wallet',
        },
        wallet_group: {
            title: 'Select Chain',
        },
        wallet_list: {
            button_only: 'Continue with a wallet',
        },
        mobile_wallet_redirect: {
            backup_title: 'Connect mobile app',
            prompt: "Tap 'Open' to continue",
            get_app_prompt: 'Get',
            open_prompt: 'Open',
            redirect_fail_message: "If the app doesn't open, you might need to download the {{walletName}} Wallet app.",
            app_store: 'App Store',
            play_store: 'Play Store',
        },
        wrong_social_account: {
            retry_button: 'Try again',
            retry_title: 'Please connect with: ',
            subtitle: 'You must connect with the same account you originally signed in with.',
            title: 'Whoops. Wrong Account',
        },
    },
    /**
     * @description copy keys for Dynamic manage passkeys view which are used inside dynamic widget
     * @default
     * {
        title: 'My passkeys',
        passkey_from: 'from',
        passkey_providers: {
          android: 'Android Phone',
          brave: 'Brave Browser',
          chrome: 'Google Chrome',
          edge: 'Microsoft Edge',
          firefox: 'Firefox',
          iPhone: 'iPhone',
          opera: 'Opera Browser',
          safari: 'Safari Browser',
        },
        recovery_button: 'Set up new passkey',
      }
     */
    dyn_manage_passkeys: {
        title: 'Manage passkeys',
        passkey_from: 'from',
        passkey_providers: {
            android: 'Android Phone',
            brave: 'Brave Browser',
            chrome: 'Google Chrome',
            edge: 'Microsoft Edge',
            firefox: 'Firefox',
            iPhone: 'iPhone',
            opera: 'Opera Browser',
            safari: 'Safari Browser',
        },
        recovery_button: 'Set up new passkey',
    },
    /**
     * @description copy keys for Dynamic rename passkey view
     * @default
     * {
      error: Whoops! There was an error updating your passkey
      input_label: 'Passkey name',
      save: 'Save',
      title: 'Rename your passkey',
      not_found: 'No passkeys found',
     }
     */
    dyn_rename_passkeys: {
        error: 'Whoops! There was an error updating your passkey',
        input_label: 'Passkey name',
        save: 'Save',
        title: 'Rename your passkey',
        not_found: 'No passkeys found',
    },
    /**
     * @description export keys for Dynamic embedded reveal view
     * @default
     * {
        title: 'Export wallet',
        agreement_title: 'Agree to continue',
        private_key_title: 'Private key',
        recovery_phrase_title: 'Secret recovery phrase',
        description:
          'Your wallet is non-custodial, meaning you are always in control of it.',
        statement_1: {
          title: 'Do not publicly share your {{keyType}}',
          description: 'Your {{keyType}} controls your account and assets.',
        },
        checkbox_label:
          'I am responsible for safeguarding and using my wallet key information.',
        reveal_description: 'Make sure to safely back up this information',
        reveal_button_label: 'Reveal',
        copy_button_label: 'Copy to clipboard',
        done_button_label: "I'm Done",
        aa_warning: {
           title: 'Your assets are not in this wallet.',
           subtitle:
           'This is a smart-contract wallet. You will not see your balance if you import this to an external service. Please send your assets to your preferred external wallet first to access your funds:',
           button: 'here',
        },
        unlink: 'Unlink wallet info',
      },
     */
    dyn_embedded_reveal: {
        title: 'Export wallet',
        agreement_title: 'Agree to continue',
        prompt_for_export_title: 'Back up wallet key',
        private_key_title: 'Private key',
        recovery_phrase_title: 'Secret recovery phrase',
        badge_label: 'Sensitive information',
        prompt_for_export_description: 'Your wallet is ready. Back up your key to protect your assets.',
        statement_1: {
            title: 'Non-custodial wallet',
            description: "You're always in control",
        },
        statement_2: {
            title: 'Keep your key private. It controls your account and assets.',
        },
        checkbox_label: 'I am responsible for safeguarding and using my wallet key information.',
        reveal_description: 'Make sure to safely back up this information',
        skip_button_label: 'Skip for now',
        reveal_button_label: 'Reveal',
        backup_button_label: 'Back up now',
        copy_button_label: 'Copy to clipboard',
        done_button_label: "I'm Done",
        aa_warning: {
            title: 'Your assets are not in this wallet.',
            subtitle: 'This is a smart-contract wallet. You will not see your balance if you import this to an external service. Please send your assets to your preferred external wallet first to access your funds:',
            button: 'here',
        },
        unlink: 'Unlink wallet info',
    },
    /**
     * @description export keys for Dynamic embedded delete view
     * @default
     *
     */
    dyn_embedded_delete: {
        title: 'Unlink from app',
        description_1: 'By continuing you acknowledge that if you return to the application, you will receive a new wallet address.',
        description_2: 'Once unlinked, you cannot recover any wallet information through this application including any associated smart contract wallets.',
        acknowledgement: 'I have safely backed up my wallet seed phrase information. If I return to this application, a new wallet will be created for me.',
        cancel_button: 'Cancel',
        action_button: 'Unlink & Log out',
    },
    /**
     * @description Settings for Dynamic settings view which are used inside dynamic widget
     * @default
     * {
      global_connectivity_section: {
        title: 'Global Connectivity',
        connected_apps_button: 'Connected Apps',
      },
      export_section: {
        private_key_button: 'Private key',
        srp_button: 'Recovery phrase',
        title: 'Export & Backup',
      },
      identity_section: {
        title: 'Recovery',
        add_email_button: 'Add an email',
      },
      tags: { recommended: 'Recommended' },
      security_section: {
        email_auth_button: 'One time code',
        passkey_button: 'Passkeys',
        password_button: 'Passcode',
        mfa_button: 'Authenticator App',
        title: '2 factor authentication',
      },
      title: 'Settings',
      button_logout: 'Log out',
      empty_screen: {
        title: 'Nothing to see here yet!',
      },
    }
     */
    dyn_settings: {
        global_connectivity_section: {
            title: 'Global Connectivity',
            connected_apps_button: 'Connected Apps',
        },
        export_section: {
            private_key_button: 'Private key',
            srp_button: 'Recovery phrase',
            title: 'Export & Backup',
        },
        identity_section: {
            title: 'Recovery',
            add_email_button: 'Add an email',
        },
        tags: { recommended: 'Recommended' },
        security_section: {
            email_auth_button: 'One time code',
            passkey_button: 'Passkeys',
            password_button: 'Passcode',
            mfa_button: 'Authenticator App',
            title: '2 factor authentication',
        },
        title: 'Settings',
        button_logout: 'Log out',
        empty_screen: {
            title: 'Nothing to see here yet!',
        },
    },
    /**
     * @description copy keys for global wallet view
     * @default
     *  {
      connect_to_apps: 'Connect to apps',
      scan_qr_code: 'Scan QR Code',
      or: 'OR',
      walletconnect_uri: 'WalletConnect URI',
      the_dapp: 'the dApp',
      this_app: 'this app',
      confirm: {
        title: 'Confirm Connection',
        description: 'Are you sure you want to connect to {{name}}?',
        cancel_button: 'Cancel',
        connect_button: 'Connect',
      },
      banner: {
        warning: 'There was an error connecting to {{name}}.',
        success: 'Successfully connected to {{name}}.',
        already_connected: 'You are already connected to {{name}}.',
        expired:
          'The link you entered expired, please get a new URI from the app.',
        bad_input:
          'Invalid URI. Please check below for how to find the valid URI.',
      },
      help: {
        title: 'How do I find the URI code?',
        step: {
          1: '1. Go to the website you want to connect to',
          2: '2. Locate the "Connect" or "Login" button',
          3: '3. Open WalletConnect from the list',
        },
        learn_more: 'Learn more about global wallets',
      },
      malicious_site: {
        certain: {
          title: 'Malicious app detected!',
          subtitle_header: 'Risk of losing funds',
          subtitle_text:
            'The site is known to exploit and or take assets from connected wallets.',
          go_back: 'Cancel',
          proceed: 'Proceed',
        },
        unknown: {
          title: 'Site verification did not run.',
          subtitle_header: 'Double check the app',
          subtitle_text:
            'We were unable to verify the vailidity of the app at this time.',
          go_back: 'Cancel',
          proceed: 'Proceed',
        },
      },
       connected_apps: {
        title: 'Connected Apps',
        no_connections: 'No connected apps',
      },
    },
     */
    global_wallet: {
        connect_to_apps: 'Connect to apps',
        scan_qr_code: 'Scan QR Code',
        or: 'OR',
        walletconnect_uri: 'WalletConnect URI',
        the_dapp: 'the dApp',
        this_app: 'this app',
        confirm: {
            title: 'Confirm Connection',
            description: 'Are you sure you want to connect to {{name}}?',
            cancel_button: 'Cancel',
            connect_button: 'Connect',
        },
        banner: {
            warning: 'There was an error connecting to {{name}}.',
            success: 'Successfully connected to {{name}}.',
            already_connected: 'You are already connected to {{name}}.',
            expired: 'The link you entered expired, please get a new URI from the app.',
            bad_input: 'Invalid URI. Please check below for how to find the valid URI.',
        },
        help: {
            title: 'How do I find the URI code?',
            step: {
                1: '1. Go to the website you want to connect to',
                2: '2. Locate the "Connect" or "Login" button',
                3: '3. Open WalletConnect from the list',
            },
            learn_more: 'Learn more about global wallets',
        },
        malicious_site: {
            certain: {
                title: 'Malicious app detected!',
                subtitle_header: 'Risk of losing funds',
                subtitle_text: 'The site is known to exploit and or take assets from connected wallets.',
                go_back: 'Cancel',
                proceed: 'Proceed',
            },
            unknown: {
                title: 'Site verification did not run.',
                subtitle_header: 'Double check the app',
                subtitle_text: 'We were unable to verify the vailidity of the app at this time.',
                go_back: 'Cancel',
                proceed: 'Proceed',
            },
        },
        connected_apps: {
            title: 'Connected Apps',
            subtitle: 'Connected apps allow you to interact with your wallet on other platforms.',
            success: 'Successfully connected to {{name}}.',
        },
    },
    /**
     * @description copy keys for mfa management view
     * @default
     *  {
          title: 'Authenticator App',
          add_mfa_button: 'Authenticator App',
          no_devices: 'No authenticator apps configured',
          generate_backup_codes_button: 'Get new backup codes',
        },
     */
    dyn_manage_mfa: {
        title: 'Authenticator App',
        add_mfa_button: 'Authenticator App',
        no_devices: 'No authenticator apps configured',
        generate_backup_codes_button: 'Get new backup codes',
    },
    /**
     * @description copy keys for mfa views
     * @default
     * {
        choose_device_view: {
          title: 'Secure your account',
          select_options: 'Protect your account by adding multi-factor authentication',
          authenticator_app: 'Authenticator app',
          authenticator_app_description:
            'Use your preferred authenticator app such as Authy, Google Authenticator, etc.',
          backup_code: 'Backup code',
          backup_code_description:
            'Enter one of your saved backup codes to authenticate.',
          choose_another_method:  'Choose another method',
          choose_another_method_description: 'Use one of the methods below:',
        logout: 'Log out',
        },
        display_backup_codes_view: {
          title: 'Back up your codes',
          body: 'Backup codes help recover your account if you lose access to your device. Each code can be used only 1 time.',
          warning: 'You won’t be able to see these again',
          copy_all: 'Copy all',
          download: 'Download',
          checkbox: 'I have safely stored a copy of my backup codes',
          complete: 'Complete',
        },
        otp_verification_view: {
          title: 'Confirm verification code',
          body: 'Enter the verification code generated by your authenticator app',
          error: 'Invalid code. Please try again.',
          rate_limit_error: 'Too many attempts, please try again later.',
          choose_another_method: 'Sign in another way',
        },
        secure_device_view: {
          title: 'Secure your account',
          body: 'Setup a new sign-in method in your authenticator app',
          continue: 'Continue',
          helper: {
            button: "Can't scan QR Code?",
            title: 'Troubles with scanning?',
            step1: {
              title: 'Open your Authenticator App',
              description: 'You will set up a new sign-in method',
            },
            step2: {
              title: 'Enter the key provided below',
              description: 'Make sure time-based or one-time password is enabled.',
            },
            uri: {
              title: 'Copy the full URI',
              description:
                'This only works if your authenticator app supports TOTP URIs',
            },
          },
          logout: 'Log out',
        },
      },
     */
    dyn_mfa: {
        choose_device_view: {
            title: 'Secure your account',
            select_options: 'Protect your account by adding multi-factor authentication',
            authenticator_app: 'Authenticator app',
            authenticator_app_description: 'Use your preferred authenticator app such as Authy, Google Authenticator, etc.',
            backup_code: 'Backup code',
            backup_code_description: 'Enter one of your saved backup codes to authenticate.',
            choose_another_method: 'Choose another method',
            choose_another_method_description: 'Use one of the methods below:',
            logout: 'Log out',
        },
        display_backup_codes_view: {
            title: 'Back up your codes',
            body: 'Backup codes help recover your account if you lose access to your device. Each code can be used only 1 time.',
            warning: 'You won’t be able to see these again',
            copy_all: 'Copy all',
            download: 'Download',
            checkbox: "I've safely stored a copy of my backup codes",
            complete: 'Complete',
        },
        otp_verification_view: {
            title: 'Confirm verification code',
            body: 'Enter the verification code generated by your authenticator app',
            error: 'Invalid code. Please try again.',
            rate_limit_error: 'Too many attempts, please try again later.',
            choose_another_method: 'Sign in another way',
        },
        secure_device_view: {
            title: 'Secure your account',
            body: 'Setup a new sign-in method in your authenticator app',
            continue: 'Continue',
            helper: {
                button: "Can't scan QR Code?",
                title: 'Troubles with scanning?',
                step1: {
                    title: 'Open your Authenticator App',
                    description: 'You will set up a new sign-in method',
                },
                step2: {
                    title: 'Enter the key provided below',
                    description: 'Make sure time-based or one-time password is enabled.',
                },
                uri: {
                    title: 'Copy the full URI',
                    description: 'This only works if your authenticator app supports TOTP URIs',
                },
            },
            logout: 'Log out',
        },
        recovery_view: {
            title: 'Enter your backup code',
            body: 'Your backup code is one of the 10 codes you received when you first enrolled in multi-factor authentication',
            input_label: 'Enter back up code',
            button_label: 'Continue',
            get_help: {
                description: 'Missing your back up codes?',
                button_label: 'Get Help',
            },
            helper: {
                title: 'Mfa Recovery Help',
            },
        },
    },
    /**
     * @description copy keys for merge user accounts view
     * @default
     * {
        confirm_button: 'Merge accounts',
        errors: {
          merge_error: 'Something went wrong, please try again.',
        },
        wallet: {
          content: 'This wallet is associated to another account. Would you like to merge accounts?',
          title: 'Wallet already in use',
        },
      }
     */
    dyn_merge_user_accounts: {
        confirm_button: 'Merge accounts',
        errors: {
            merge_error: 'Something went wrong, please try again.',
        },
        wallet: {
            content: 'This wallet is associated to another account. Would you like to merge accounts?',
            title: 'Wallet already in use',
        },
    },
    /**
     * @description copy keys for merge user accounts conflicts view
     * @default
     * {
        confirm_button: 'Confirm & Merge',
        description:
          'You have some conflicting information. Please select your preferences',
        errors: {
          merge_error: 'Something went wrong, please try again.',
        },
        title: 'Confirm your preferences',
      }
     */
    dyn_merge_user_accounts_conflicts: {
        confirm_button: 'Confirm & Merge',
        description: 'You have some conflicting information. Please select your preferences',
        errors: {
            merge_error: 'Something went wrong, please try again.',
        },
        title: 'Confirm your preferences',
    },
    /**
     * @description copy keys for merge user accounts view when using email associated to a different account
     * @default
     * {
        cancel_button: "No, I'll use a different email",
        confirm_button: 'Yes, link to existing account',
        errors: {
          merge_error: 'Something went wrong, please try again.',
        },
        existing_account: 'An account already exists that uses',
        existing_account_trail: 'email.',
        title: 'Would you like to link this wallet to this existing account?',
      }
     */
    dyn_merge_user_accounts_with_same_email: {
        cancel_button: "No, I'll use a different email",
        confirm_button: 'Yes, link to existing account',
        errors: {
            merge_error: 'Something went wrong, please try again.',
        },
        existing_account: 'An account already exists that uses',
        existing_account_trail: 'email.',
        title: 'Would you like to link this wallet to this existing account?',
    },
    /**
     * @description copy key for Dynamic need help footer section
     * @default
     * {
        info: 'Problem Signing?',
        contact_support: 'Contact support',
        divider: 'or',
        help_button: 'go here.',
      }
     */
    dyn_need_help_section: {
        info: 'Need Help?',
        contact_support: 'Contact support',
        divider: 'or',
        help_button: 'Go here for support',
        visit_platform: 'Visit {{platform}}',
    },
    /**
     * @description copy keys for network not supported view
     * @default
     * {
        button: 'Switch Network',
        subtitle: 'Your wallet is not connected to a supported network. Please update before continuing.',
        title: 'Update Network',
        warning_message: 'This network is not available, please update.',
      }
     */
    dyn_network_not_supported: {
        button: 'Switch Network',
        subtitle: 'Your wallet is not connected to a supported network. Please update before continuing.',
        title: 'Update Network',
        warning_message: 'This network is not available, please update.',
        wallet: 'Not Supported',
    },
    /**
     * @description copy keys for network not supported view for manual switch
     * @default
     * {
        subtitle_network_defined_metamaskstarknet:
          'To continue, please update the network in your wallet to {{network}} by visiting the Starknet Snap companion app',
        subtitle_network_defined_metamaskstarknet_companion_app: 'companion app',
        subtitle_network_defined: 'To continue, please update the network in your wallet to {{network}}',
        subtitle_no_network_defined: 'Your wallet does not support switching networks from this app. Switch networks directly in your wallet.',
        title: 'Update your Network',
        warning_message: 'This network is not available, please update.',
      }
     */
    dyn_network_not_supported_manual_switch: {
        subtitle_network_defined_metamaskstarknet: 'To continue, please update the network in your wallet to {{network}} by visiting the Starknet Snap',
        subtitle_network_defined_metamaskstarknet_companion_app: 'companion app',
        subtitle_network_defined: 'To continue, please update the network in your wallet to {{network}}',
        subtitle_no_network_defined: 'Your wallet does not support switching networks from this app. Switch networks directly in your wallet.',
        title: 'Update your Network',
        warning_message: 'This network is not available, please update.',
    },
    /**
     * @description copy keys for no access view
     * @default
     * {
        chainalysis: {
          button_text: 'Try another method',
          description: 'This wallet has been correlated to illicit activity and cannot access this site.',
          social_media_link_text: 'Why am I seeing this message?',
          social_media_link_url: 'https://docs.dynamic.xyz/docs',
          title: 'This address seems corrupted.',
        },
        default: {
          button_text: 'Try another method',
          description: "You are not currently on the allow list.",
          title: 'Access denied',
        },
        gate: {
          button_text: 'Try a different wallet',
          description: 'A NFT or a token is required to access this site.',
          title: 'You cannot access the site',
        },
        not_in_the_list_image_alt: 'user is not in the list',
        title: "You don't have access",
      }
     */
    dyn_no_access: {
        chainalysis: {
            button_text: 'Try another method',
            description: 'This wallet has been correlated to illicit activity and cannot access this site.',
            social_media_link_text: 'Why am I seeing this message?',
            social_media_link_url: 'https://docs.dynamic.xyz/docs',
            title: 'This address seems corrupted.',
        },
        default: {
            button_text: 'Try another method',
            description: 'You are not currently on the allow list.',
            title: 'Access denied',
        },
        gate: {
            button_text: 'Try a different wallet',
            description: 'A NFT or a token is required to access this site.',
            title: 'You cannot access the site',
        },
        not_in_the_list_image_alt: 'user is not in the list',
        title: "You don't have access",
    },
    /**
     * @description copy keys for email OTP verification for magiclink
     * @default
     * {
        banner_text: 'Sign in to access your email based wallet',
      }
     */
    dyn_magic_verification: {
        banner_text: 'Sign in to access your email based wallet',
    },
    /**
     * @description copy key for passkey created success banner
     * @default
     * {
        text: 'A new passkey has been created',
      }
     */
    dyn_passkey_success: {
        created: 'A new passkey has been created',
        edited: 'Your passkey has been edited',
    },
    /**
     * @description copy keys for passkey intro view
     * @default
     * {
        button: 'Set up a passkey',
        button_logout: 'Log out',
        button_skip: 'Skip for now',
        disabled: 'Passkeys are not available on this device or browser. Please open on Chrome, Safari, or Brave to continue',
        helper: {
          section_1: {
            description: 'Passkeys are a standard built by Apple, Google and others, and eliminates the use of passwords.',
            title: 'Built by Apple and Google',
          },
          section_2: {
            description: 'Passkeys are stored on your phone and are not shared with anyone.',
            title: 'Secure and Private',
          },
          title: "What's Passkey",
          tooltip: 'Need some help?',
        },
        sms_auth: {
          title: 'Finish set up',
          description:
            'Add a security method to finish your profile and complete transactions',
        },
        subtitle: 'Passkeys are stored natively to your device with a biometric and can only be accessed by you.',
        title: 'Secure your wallet',
      }
     */
    dyn_passkey_intro: {
        button: 'Set up a passkey',
        button_logout: 'Log out',
        button_skip: 'Skip for now',
        disabled: 'Passkeys are not available on this device or browser. Please open on Chrome, Safari, or Brave to continue',
        helper: {
            section_1: {
                description: 'Passkeys are a standard built by Apple, Google and others, and eliminates the use of passwords.',
                title: 'Built by Apple and Google',
            },
            section_2: {
                description: 'Passkeys are stored on your phone and are not shared with anyone.',
                title: 'Secure and Private',
            },
            title: "What's Passkey",
            tooltip: 'Need some help?',
        },
        sms_auth: {
            title: 'Finish set up',
            description: 'Add a security method to finish your profile and complete transactions',
        },
        subtitle: 'Passkeys are stored natively to your device with a biometric and can only be accessed by you.',
        title: 'Secure your wallet',
    },
    /**
     * @description copy keys for passkey new domain detected modal
     * @default
     * {
     title: 'New domain detected',
     description: 'To complete your transaction select a signing method',
     actions: {
     passkey: {
     title: 'Add new passkey',
     subtitle: 'Does not expire. Works across devices & secured with biometric.',
     },
     emailAuth: {
     title: 'Use a one-time code',
     subtitle: 'Allows you to transact for 30 min',
     },
     badges: {
     recommended: 'Recommended',
     fastest: 'Fastest',
     },
     },
     }
     */
    dyn_passkey_new_domain_detected: {
        title: 'New domain detected',
        description: 'To complete your transaction select a signing method',
        actions: {
            passkey: {
                title: 'Add new passkey',
                subtitle: 'Does not expire. Works across devices & secured with biometric.',
            },
            emailAuth: {
                title: 'Use a one-time code',
                subtitle: 'Allows you to transact for 30 min',
            },
            badges: {
                recommended: 'Recommended',
                fastest: 'Fastest',
            },
        },
    },
    /**
     * @description copy keys for passkeys recovery flow
     * @default
     * {
        add_email: {
          description:
            'Don’t get locked out if you delete your passkey or lose your device.',
          input_label: 'Enter your email',
          title: 'Add a recovery email',
          confirm_button: 'Confirm with a passkey',
          skip_button: 'Skip for now',
          success_message: 'Recovery email added!',
        },
        code: {
            description: 'A verification code has been sent to {{email}}',
            input_label: 'Enter your code here...',
            title: 'Verification code sent',
          resend: {
              button: 'Resend code',
              text: "Didn't receive a code?",
          },
        },
        complete: {
          complete_button: 'Create a passkey',
          description: 'Secure your wallet by adding a new passkey.',
          title: 'Create a new passkey',
        },
        start: {
          description:
            'To complete this process, ensure you are using the same device/browser.',
          start_button: 'Send me an email',
          title: 'Initiate Request',
        },
      }
     */
    dyn_passkey_recovery: {
        add_email: {
            description: 'Don’t get locked out if you delete your passkey or lose your device.',
            input_label: 'Enter your email',
            title: 'Add a recovery email',
            confirm_button: 'Confirm with a passkey',
            skip_button: 'Skip for now',
            success_message: 'Recovery email added!',
        },
        code: {
            description: 'A verification code has been sent to {{email}}',
            input_label: 'Enter your code here...',
            title: 'Verification code sent',
            resend: {
                button: 'Resend code',
                text: "Didn't receive a code?",
            },
        },
        complete: {
            complete_button: 'Create a passkey',
            description: 'Secure your wallet by adding a new passkey.',
            title: 'Create a new passkey',
        },
        start: {
            description: 'To complete this process, ensure you are using the same device/browser.',
            start_button: 'Send me an email',
            title: 'Initiate Request',
        },
    },
    /**
     * @description copy keys for Dynamic pending wallet connection
     * @default
     * {
        mobile: 'Click connect in your mobile wallet',
        computer: 'Click connect in your wallet popup',
      }
     */
    dyn_pending_connection: {
        title: 'Connect',
        mobile: 'Click connect in your mobile wallet',
        computer: 'Click connect in your wallet popup',
    },
    /**
       * @description copy keys for Dynamic pending signature, we have overrides for phantom ledger which does not support message signing.
       * @default
       * {
          click_to_sign: 'Click to Sign',
          note: 'Note: ',
          phantom_ledger_sign: "Click sign in your wallet to confirm you own this wallet (this doesn't cost gas).",
          phantom_ledger_warning: "Ledger with Phantom doesn't support message signing. When logging in, a small fee (which should not apply) may appear. See below to learn more.",
          regular_sign_description: 'Click sign-in in your wallet to confirm you own this wallet.',
    }
       */
    dyn_pending_signature: {
        click_to_sign: 'Click to Sign',
        note: 'Note: ',
        phantom_ledger_sign: "Click sign in your wallet to confirm you own this wallet (this doesn't cost gas).",
        phantom_ledger_warning: "Ledger doesn't support message signing. When logging in, a small fee (which should not apply) may appear. See below to learn more.",
        regular_sign_description: 'Click sign-in in your wallet to confirm you own this wallet.',
    },
    /**
       * @description copy keys for Dynamic QR code Wallet Connection Pop-Up
       * @default
       * {
          copy_button: 'Copy QR URI',
          get_extension_button: 'Get extension',
          open_button: 'Open App',
          scan_title: "Scan this QR code from your mobile {{app}} or phone's camera to connect.",
          wallet_not_installed: {
            browser_install: 'Install {{browser}} extension',
            install: 'Install {{wallet}} extension to connect',
            refresh: 'Refresh the page once installed',
            select: 'Select from your preferred options below:',
          },
        }
       */
    dyn_qr_code: {
        copy_button: 'Copy QR URI',
        get_extension_button: 'Get Extension',
        open_button: 'Open App',
        scan_title: "Scan this QR code from your mobile {{app}} or phone's camera to connect.",
        wallet_not_installed: {
            browser_install: 'Install {{browser}} extension',
            install: 'Install {{wallet}} extension to connect',
            refresh: 'Refresh the page once installed',
            select: 'Select from your preferred options below:',
        },
    },
    /**
       * @description copy keys for Dynamic wallet locked/disconnected
       * @default
       * {
          connect_continue: 'Connect your wallet to continue',
          title: 'Welcome back',
          subtitle: "We couldn't connect to your wallet. Click connect to retry the connection ",
          connect: 'Connect wallet',
          logout: 'Log out',
        }
       */
    dyn_wallet_locked: {
        connect_continue: 'Connect your wallet to continue',
        title: 'Welcome back',
        subtitle: "We couldn't connect to your wallet. Click connect to retry the connection ",
        connect: 'Connect wallet',
        logout: 'Log out',
    },
    /**
     * @description copy keys for passkeys creation flow for existent embedded wallets
     * @default
     * {
        code: {
          action_based_description: 'To {{action}} verify account.',
          description: 'A secure code has been sent to {{email}}.',
          input_label: 'Enter your code here...',
          title: 'Verification code sent',
          resend: {
            button: 'Resend code',
            text: "Didn't receive a code?",
          },
          complete_transaction_action: 'complete transaction',
          sign_message_action: 'sign this message',
        },
        complete: {
          complete_button: 'Create a passkey',
          description:
            'Passkeys are stored natively to your device with a biometric and can only be accessed by you.',
          title: 'Secure your account',
        },
        start: {
          description:
            'A one-time security code will be sent to the email on file. It will expire in 15 minutes.',
          start_button: 'Send me an email',
          title: 'Send Email Code',
        },
      }
     */
    dyn_passkey_secure_modal: {
        code: {
            action_based_description: 'To {{action}} verify account.',
            description: 'A secure code has been sent to {{email}}.',
            input_label: 'Enter your code here...',
            title: 'Verification code sent',
            resend: {
                button: 'Resend code',
                text: "Didn't receive a code?",
            },
            complete_transaction_action: 'complete transaction',
            sign_message_action: 'sign this message',
        },
        complete: {
            complete_button: 'Create a passkey',
            description: 'Passkeys are stored natively to your device with a biometric and can only be accessed by you.',
            title: 'Secure your account',
        },
        start: {
            description: 'A one-time security code will be sent to the email on file. It will expire in 15 minutes.',
            start_button: 'Send me an email',
            title: 'Send Email Code',
        },
    },
    /**
     * @description copy keys for save password view
     * @default
     * {
        badge_text: 'Important!',
        checkbox_label: 'I have safely stored a copy of my passcode.',
        continue: 'Continue',
        copy_button: {
          copy: 'Copy',
          copied: 'Copied',
        },
        description: 'You must retain a copy of this passcode.',
        download_button: 'Download',
        logout: 'Log out',
        password_input: {
          label: 'Passcode',
          placeholder: 'Passcode',
        },
        title: 'Save passcode',
        warning:
          'If you lose your passcode, you cannot recover access to your account.',
      }
     */
    dyn_save_password: {
        badge_text: 'Important!',
        checkbox_label: 'I have safely stored a copy of my passcode.',
        continue: 'Continue',
        copy_button: {
            copy: 'Copy',
            copied: 'Copied',
        },
        description: 'You must retain a copy of this passcode.',
        download_button: 'Download',
        logout: 'Log out',
        password_input: {
            label: 'Passcode',
            placeholder: 'Passcode',
        },
        title: 'Save passcode',
        warning: 'If you lose your passcode, you cannot recover access to your account.',
    },
    /**
     * @description copy keys for secure pregenerated embedded wallet
     * @default
     * {
        description: 'Make transactions simpler and more secure.',
        action: 'Get started'
     }
     */
    dyn_secure_pregenerated_wallet: {
        description: 'Make transactions simpler and more secure.',
        action: 'Get started',
    },
    /**
     * @description copy keys for send transaction flow views
     * @default
     * {
        confirmation: {
          cancel_button: 'Cancel',
          confirm_button: 'Confirm',
          data: {
            amount: 'Amount',
            from: 'From (You)',
            gas: 'Gas',
            gas_estimate: 'Network Fee',
            to: 'To',
            total: 'Total',
          },
          not_applied: 'N/A',
          title: 'Confirm transaction',
        },
        data: {
          amount: {
            label: 'Amount',
            placeholder: 'Select amount',
          },
          balance: {
            label: 'Balance:',
          },
          from: 'Send from',
          recipient: {
            label: 'Recipient',
            placeholder: 'Enter wallet address...',
          },
        },
        multiple_recipients: 'Multiple',
        send_button: 'Send now',
        succeeded: {
          continue_button: 'Continue',
          network: {
            label: 'Network',
          },
          recipient: {
            label: 'Recipient',
          },
          title: 'Transaction successfully sent',
          total_amount: {
            label: 'Total amount',
          },
        },
        validation: {
          amount: {
            invalid_decimals: 'Please enter a value up to the {{decimals}}th decimal place.',
            invalid_format: 'The amount is in invalid format',
            over_balance: 'Insufficient funds to send this amount.',
            required: 'The amount field is required',
          },
          recipient: {
            invalid_format: 'The address is in invalid format',
            required: 'The recipient is required',
          },
        },
        warning_message: {
          insufficient_funds: 'Insufficient funds due to gas price increase from estimate. Please add {{amountLeft}} {{currencySymbol}} to continue.',
        },
        error_message: {
          gas_not_sponsored: 'The gas fee has increased. Confirm if you still want to complete this transaction.',
        },
      }
     */
    dyn_send_transaction: {
        confirmation: {
            cancel_button: 'Cancel',
            confirm_button: 'Confirm',
            send: 'Confirm',
            data: {
                amount: 'Amount',
                from: 'From (You)',
                gas: 'Gas',
                gas_estimate: 'Network Fee',
                to: 'To',
                total: 'Total',
                wallet_used: 'Wallet used',
                network: 'Network',
                recipient: 'Recipient',
                destination: 'Interacting with',
                gas_tooltip: 'Gas fees are charged by the network and can change quickly based on usage.',
                sending: 'Sending',
                receiving: 'Receiving',
                transfer: {
                    send: 'Send',
                    receive: 'Receive',
                },
            },
            not_applied: 'N/A',
            title: 'Confirm transaction',
        },
        data: {
            amount: {
                label: 'Amount',
                placeholder: 'Enter amount',
            },
            balance: {
                label: 'Balance:',
            },
            from: 'Send from',
            send: 'Send',
            send_preview: 'Send Preview',
            confirmation_tx: 'Confirm Transaction',
            banner: "You're nearly done! Confirm transaction to proceed.",
            recipient: {
                label: 'Address',
                placeholder: 'Enter wallet address...',
            },
        },
        multiple_recipients: 'Multiple',
        preview_transaction: 'Preview transaction',
        send_button: 'Send now',
        succeeded: {
            continue_button: 'Done',
            network: {
                label: 'Network',
            },
            recipient: {
                label: 'Recipient',
            },
            title: 'Transaction successfully sent to',
            total_amount: {
                label: 'Total amount',
            },
        },
        validation: {
            amount: {
                invalid_decimals: 'Please enter a value up to the {{decimals}}th decimal place.',
                invalid_format: 'The amount is in invalid format',
                over_balance: 'Insufficient funds to send this amount.',
                required: 'The amount field is required',
            },
            recipient: {
                invalid_format: 'The address is in invalid format',
                required: 'The recipient is required',
            },
        },
        info_message: {
            refresh_balance_time: 'Your balance may take up to 30s to refresh.',
        },
        warning_message: {
            insufficient_funds: {
                title: 'Insufficient funds',
                description: 'Insufficient funds for transaction. Please add {{amountLeft}} {{currencySymbol}} to continue.',
            },
            insufficient_gas_funds: {
                title: 'Insufficient gas funds',
                description: 'Please add {{amountLeft}} {{currencySymbol}} to continue.',
            },
            failed_simulation: {
                title: 'Transaction expected to fail',
                description: 'Something went wrong. Check your balances and try again.',
            },
        },
        error_message: {
            gas_not_sponsored: 'The gas fee has increased. Confirm if you still want to complete this transaction.',
        },
    },
    /**
     * @description copy keys for Select Chain view
     * @default
     * {
        description: "This wallet supports multiple chains. Select which chain you'd like to connect to",
        using_hardware_wallet_toggle_label: 'Using Ledger',
      }
     */
    dyn_select_chain: {
        description: "This wallet supports multiple chains. Select which chain you'd like to connect to",
        using_hardware_wallet_toggle_label: 'Using Ledger',
    },
    /**
     * @description copy keys for Select Wallet view
     * @default
     * {
        description: "This wallet supports multiple chains. Select which chain you'd like to connect to",
        using_hardware_wallet_toggle_label: 'Using Ledger with {{chainName}}',
      }
     */
    dyn_select_wallet: {
        description: 'Select your preferred {{walletName}} wallet?',
    },
    /**
     * @description copy keys for Select Chain view
     * @default
     * {
        title: "Connect",
        description:
          "This wallet supports using ledger. Toggle on ledger to enable it.",
        using_hardware_wallet_toggle_label: "Using Ledger with {{chainName}}",
        button: "Connect",
      }
     */
    dyn_select_hardware_wallet: {
        title: 'Connect',
        description: 'This wallet supports using ledger. Toggle on ledger to enable it.',
        using_hardware_wallet_toggle_label: 'Using Ledger with {{chainName}}',
        button: 'Connect',
    },
    /**
     * @description copy keys for sign message flow views
     * @default
     * {
        cancel_button: 'Cancel',
        sign_button: 'Sign',
        title: 'Requesting Signature',
      }
     */
    dyn_sign_message: {
        cancel_button: 'Cancel',
        sign_button: 'Sign',
        title: 'Requesting Signature',
    },
    /**
     * @description copy keys for social redirect view
     * @default
     * {
        logging_in: 'Logging you in',
      }
     */
    dyn_social_redirect: {
        logging_in: 'Logging you in',
    },
    /**
     * @description copy keys for wallet redirect view
     * @default
     * {
        loading: 'Loading...',
      }
     */
    dyn_wallet_redirect: {
        loading: 'Loading...',
    },
    /**
     * @description copy keys for messages related to time since a date
     * @default
     * {
        second: 'second',
        seconds: 'seconds',
        minute: 'minute',
        minutes: 'minutes',
        hour: 'hour',
        hours: 'hours',
        day: 'day',
        days: 'days',
        month: 'month',
        months: 'months',
        year: 'year',
        years: 'years',
        ago: 'ago',
        created: 'Created',
     }
     */
    dyn_time_since: {
        second: 'second',
        seconds: 'seconds',
        minute: 'minute',
        minutes: 'minutes',
        hour: 'hour',
        hours: 'hours',
        day: 'day',
        days: 'days',
        month: 'month',
        months: 'months',
        year: 'year',
        years: 'years',
        ago: 'ago',
        created: 'Created',
    },
    /**
     * @description copy keys for connecting wallets view
     * @default
     * {
        mobile: {
          wallet_list: {
            helper: 'Get your first wallet',
            title: 'WalletConnect wallets',
          },
        },
      }
     */
    dyn_wallet_conect: {
        mobile: {
            wallet_list: {
                helper: 'Get your first wallet',
                title: 'WalletConnect wallets',
            },
        },
    },
    /**
     * @description copy keys for linking wallets to profile view
     * @default
     * {
        cannot_link: {
          cancel_button: 'Cancel',
          description: 'This wallet is the only wallet in your other account. You cannot transfer it, since then you will lose access to that account.',
          link_other_button: 'Link a different wallet',
          title: 'Cannot link this wallet to a new account',
        },
        confirm_button: 'Link wallet to current account',
        existent_account: {
          acceptance: 'I understand that linking this wallet means that I will lose access to the other account.',
          warning: 'Linking your wallet to this account will unlink it from its previously associated account',
        },
        log_out_button: 'Log out',
        title: 'Transfer this wallet?'
      }
     */
    dyn_wallet_link: {
        cannot_link: {
            cancel_button: 'Cancel',
            description: 'This wallet is the only wallet in your other account. You cannot transfer it, since then you will lose access to that account.',
            link_other_button: 'Link a different wallet',
            title: 'Cannot link this wallet to a new account',
        },
        confirm_button: 'Link wallet to current account',
        existent_account: {
            acceptance: 'I understand that linking this wallet means that I will lose access to the other account.',
            warning: 'Linking your wallet to this account will unlink it from its previously associated account',
        },
        log_out_button: 'Log out',
        title: 'Transfer this wallet?',
        already_exists: {
            title: 'Wallet Already Linked',
            description: 'This wallet is already used as an embedded wallet. You cannot link it unless you delete the existing embedded wallet.',
        },
    },
    /**
     * @description copy keys for connecting wallets list view
     * @default
     * {
        configuration_mismatch: 'Oops, no login methods have been configured.',
        helper: 'Get your first wallet',
        search: {
          label: 'Search through {{numberOfWallets}} wallets...',
          not_found: {
            description: 'The wallet you’re looking for may not be available, or linking more than one of these wallets might not be possible.',
            title: 'Wallet not available',
          },
        },
        title: {
          connect: 'Connect a new wallet',
          link: 'Link a new wallet',
          select: 'Select your wallet',
        },
        view_all: 'View all wallets',
        wallet_missing: {
          description: 'Try search instead',
          title: "Don't see your wallet?",
        },
      }
     */
    dyn_wallet_list: {
        configuration_mismatch: 'Oops, no login methods have been configured.',
        helper: 'Get your first wallet',
        search: {
            label: 'Search through {{numberOfWallets}} wallets...',
            not_found: {
                description: 'The wallet you’re looking for may not be available, or linking more than one of these wallets might not be possible.',
                title: 'Wallet not available',
            },
        },
        title: {
            connect: 'Connect a new wallet',
            link: 'Link a new wallet',
            select: 'Select your wallet',
        },
        view_all: 'View all wallets',
        wallet_missing: {
            description: 'Try search instead',
            title: "Don't see your wallet?",
        },
    },
    /**
     * @description copy keys for transferring wallets between accounts view
     * @default
     * {
        sign: {
          spinner: {
            cancel: 'Cancel',
            confirm_transfer:
            'Sign the message to confirm transferring this wallet to this account.',
          },
          title: 'Sign to confirm transfer',
        },
      }
     */
    dyn_wallet_transfer: {
        sign: {
            spinner: {
                cancel: 'Cancel',
                confirm_transfer: 'Sign the message to confirm transferring this wallet to this account.',
            },
            title: 'Sign to confirm transfer',
        },
    },
    /**
     * @description copy keys for Dynamic widget
     * @default
     * {
        connect: 'Log in or sign up',
        empty_wallets: '{{action}} additional wallets to see them here.',
        other_wallets: 'My other wallets',
      }
     */
    dyn_widget: {
        connect: 'Log in or sign up',
        empty_wallets: '{{action}} additional wallets to see them here.',
        other_wallets: 'My other wallets',
        empty_wallets_action_link: 'Link',
        empty_wallets_action_connect: 'Connect',
    },
    /**
     * @description copy keys for Dynamic wallet information card
     * @default
     * {
        balance: 'Balance'
      }
     */
    dyn_wallet_information: {
        balance: 'Balance',
        multi_asset: {
            empty_state: 'No assets in this wallet',
        },
    },
    /**
     * @description copy keys for Unlink wallet prompt
     * @default
     * {
        disconnect_title: 'Disconnect your wallet?',
        unlink_title: 'Unlink your wallet?',
        disconnect_description: 'Are you sure you want to disconnect your wallet?',
        unlink_description: 'Are you sure you want to unlink your wallet?',
        disconnect_button: 'Yes, disconnect',
        unlink_button: 'Yes, unlink',
        cancel_button: 'No',
      }
     */
    dyn_unlink_wallet_pop_up: {
        disconnect_title: 'Disconnect your wallet?',
        unlink_title: 'Unlink your wallet?',
        disconnect_description: 'Are you sure you want to disconnect your wallet?',
        unlink_description: 'Are you sure you want to unlink your wallet?',
        disconnect_button: 'Yes, disconnect',
        unlink_button: 'Yes, unlink',
        cancel_button: 'No',
    },
    /**
     * @description copy keys for the user profile widget
     * @default
     * {
        my_information: {
          title: 'My information',
        },
        my_wallet: {
          title: 'My wallet',
        },
        social_accounts: {
          title: 'Social accounts',
        },
        tooltips: {
          verified_email: 'This email is verified',
          verified_phone: 'This phone number is verified',
        },
        wallets: {
          link_wallet_button: 'Link wallet',
          title: 'Wallets',
        },
      }
     */
    dyn_user_profile: {
        my_information: {
            title: 'My information',
        },
        my_wallet: {
            title: 'My wallet',
        },
        social_accounts: {
            title: 'Social accounts',
        },
        tooltips: {
            verified_email: 'This email is verified',
            verified_phone: 'This phone number is verified',
        },
        wallets: {
            link_wallet_button: 'Link wallet',
            title: 'Want to add a wallet?',
        },
        edit_profile_button: 'Edit Profile',
    },
    /**
     * @description copy keys for Dynamic subdomain field
     * @default
     * {
        label: 'Subdomain Handle',
        available: 'Subdomain is available',
        not_available: 'Subdomain is not available',
        error: 'Subdomain check failed',
        details:
          'A subdomain handle will create a unique ENS subdomain for your wallet, helping you easily share and identify it.',
      }
     */
    dyn_subdomain_field: {
        label: 'Subdomain Handle',
        available: 'Subdomain is available',
        not_available: 'Subdomain is not available',
        error: 'Subdomain check failed',
        details: 'A subdomain handle will create a unique ENS subdomain for your wallet, helping you easily share and identify it.',
    },
    /**
     * @description copy keys for Detected new wallet prompt
     * @default
     * {
        title: 'Account Change Detected',
        description: 'Your active account in {{walletName}} has changed. This account is not currently linked to this app. Do you want to add it?',
        confirm_button: 'Yes, link this wallet',
      }
     */
    dyn_detected_new_wallet: {
        title: 'Account Change Detected',
        description: 'Your active account in {{walletName}} has changed. This account is not currently linked to this app. Do you want to add it?',
        confirm_button: 'Yes, link this wallet',
    },
    /**
       * @description copy keys for sync wallet view
       * @default
       * {
          switch_wallet: {
            title: 'Your wallets are mismatched. \nSwitch to continue.',
            active_address: {
              heading: 'Currently active in wallet',
            },
            expected_address: {
              heading: 'Currently active on website',
              prompt: 'Manually switch to this wallet',
            },
          },
          reconnecting: {
            title: 'This wallet is not connected',
            description: 'Reconnecting wallet {{walletAddress}} to make it active...',
          },
          reconnect_with_qr_code: {
            title: 'This wallet is not connected',
          },
          cancel_button: 'Cancel',
          retry_button: 'Retry',
        }
      */
    dyn_sync_wallet: {
        switch_wallet: {
            title: 'Your wallets are mismatched. \nSwitch to continue.',
            active_address: {
                heading: 'Currently active in wallet',
            },
            expected_address: {
                heading: 'Currently active on website',
                prompt: 'Manually switch to this wallet',
            },
        },
        reconnecting: {
            title: 'This wallet is not connected',
            description: 'Reconnecting wallet {{walletAddress}} to make it active...',
        },
        reconnect_with_qr_code: {
            title: 'This wallet is not connected',
        },
        cancel_button: 'Cancel',
        retry_button: 'Retry',
    },
    /**
     * @description copy keys for the wallet funding flow
     * @default
     * {
        success: 'Transaction processing',
        success_txn_link: 'View transaction',
        
        funding_method_selection: {
          title: 'Deposit',
          qr_option: 'Receive by QR',
          buy_option: 'Buy Crypto',
          external_wallet_option: 'From External Wallets',
        },
        onramp_provider_selection: {
          title: 'Select provider',
          description: 'Select from a list of available onramp providers.',
        },
        from_external_wallet: {
          wallet_list: {
            title: 'Fund from Wallet',
          },
          funding_view: {
            title: 'Fund from Wallet',
            wallet_detail_from: 'From',
            confirm_button: 'Confirm Transaction',
            pricing_unavailable:
              'Pricing unavailable.',
            minimum_error: 'Minimum {{minimum}}',
            balance_error: 'Insufficient funds',
          },
          token_select: {
            title: 'Select a Token',
            search_placeholder: 'Search for a token',
            no_assets_title: 'No Supported Assets',
            no_assets_description: 'This wallet does not support any assets',
          },
        },
      }
     */
    dyn_wallet_funding: {
        success: 'Transaction processing',
        success_txn_link: 'View transaction',
        funding_method_selection: {
            title: 'Deposit',
            qr_option: 'Receive by QR',
            buy_option: 'Buy Crypto',
            external_wallet_option: 'From External Wallets',
        },
        onramp_provider_selection: {
            title: 'Select provider',
            description: 'Select from a list of available onramp providers.',
        },
        from_external_wallet: {
            wallet_list: {
                title: 'Fund from External Wallet',
            },
            funding_view: {
                title: 'Fund from External Wallet',
                wallet_detail_from: 'From',
                confirm_button: 'Confirm Transaction',
                pricing_unavailable: 'Pricing unavailable.',
                minimum_error: 'Minimum {{minimum}}',
                balance_error: 'Insufficient funds',
            },
            token_select: {
                title: 'Select a Token',
                search_placeholder: 'Search for a token',
                no_assets_title: 'No Supported Assets',
                no_assets_description: 'No supported assets in this wallet',
            },
        },
    },
    /**
     * @description copy keys for Dynamic widget header
     * @default
     * {
        buttons: {
          deposit_funds: 'Deposit',
          send_funds: 'Send',
          more: 'More',
        },
      }
     */
    dyn_widget_header: {
        buttons: {
            deposit_funds: 'Deposit',
            send_funds: 'Send',
            more: 'More',
        },
    },
};

const deepMerge = (obj1, obj2) => {
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
        // If either obj1 or obj2 is not an object, return obj1
        return obj2;
    }
    // Create a new object to store the merged result
    const result = Object.assign({}, obj1);
    for (const key in obj2) {
        if (Object.prototype.hasOwnProperty.call(obj2, key)) {
            if (typeof obj2[key] === 'object' &&
                Object.prototype.hasOwnProperty.call(obj1, key) &&
                typeof obj1[key] === 'object') {
                // If both obj1 and obj2 have objects with the same key, recursively merge them
                result[key] = deepMerge(obj1[key], obj2[key]);
            }
            else {
                // Otherwise, simply assign the value from obj2 to the result
                result[key] = obj2[key];
            }
        }
    }
    return result;
};

/* eslint-disable import/no-named-as-default-member */
class Locale {
    static setResources(customResources) {
        if (Locale.__resources__) {
            return;
        }
        if (!customResources) {
            Locale.__resources__ = {
                en: { translation: translation },
            };
            return;
        }
        const sdkResources = {};
        Object.keys(customResources).forEach((lang) => {
            const mergedResource = Object.assign({}, translation);
            sdkResources[lang] = {
                translation: deepMerge(mergedResource, customResources[lang]),
            };
        });
        Locale.__resources__ = sdkResources;
    }
    static setup(resources) {
        if (Locale.__initialized__ && Locale.__i18nInstance__) {
            return Locale.__i18nInstance__;
        }
        Locale.setResources(resources);
        const i18nInstance = instance.createInstance();
        i18nInstance.use(initReactI18next).init({
            fallbackLng: 'en',
            interpolation: {
                escapeValue: false, // not needed for react as it escapes by default
            },
            lng: 'en',
            resources: Locale.getResources(),
        });
        Locale.__i18nInstance__ = i18nInstance;
        Locale.__initialized__ = true;
        return Locale.__i18nInstance__;
    }
    static getInstance() {
        if (!Locale.__initialized__) {
            this.setup();
        }
        // istanbul ignore next
        if (!Locale.__i18nInstance__ || !Locale.__initialized__) {
            throw new Error('Locale is not initialized');
        }
        return Locale.__i18nInstance__;
    }
}
Locale.__i18nInstance__ = null;
Locale.__initialized__ = false;
Locale.getResources = () => Locale.__resources__;

const sdkApi = ({ customHeaders } = {}) => {
    const settings = {
        basePath: ApiEndpoint.getBaseUrl(),
        headers: Object.assign({ 'Content-Type': 'application/json' }, customHeaders),
    };
    const minJwt = getMinAuthToken();
    if (minJwt) {
        settings.headers.Authorization = `Bearer ${minJwt}`;
    }
    const deviceFingerprint = getDeviceFingerprint();
    if (deviceFingerprint) {
        settings.headers['x-dyn-device-fingerprint'] = deviceFingerprint;
    }
    const projectSettings = getProjectSettings();
    const credentials = projectSettings && isCookieEnabled(projectSettings) ? 'include' : undefined;
    settings.headers['x-dyn-version'] = `WalletKit/${VERSION}`;
    settings.headers['x-dyn-api-version'] = `API/${API_VERSION}`;
    return new SDKApi(new Configuration(Object.assign(Object.assign({}, settings), { credentials, fetchApi: FetchService.fetch })));
};

const fetchProjectSettings = (environmentId) => __awaiter$1(void 0, void 0, void 0, function* () {
    try {
        const res = yield sdkApi().getEnvironmentSettings({
            environmentId,
            sdkVersion: `WalletKit/${VERSION}`,
        }, {
            credentials: 'omit',
        });
        return res;
    }
    catch (e) {
        logger$1.error(e);
        return undefined;
    }
});
/**
 * Detects circular references in an object, and replaces them with a string
 * This ensures we can JSON stringify the object without errors
 *
 * @param obj
 * @returns obj mutated object with circular references replaced
 */
const detectCircular = (obj) => {
    const seen = new WeakMap();
    const _recursive = (obj, parentKey = '') => {
        for (const key in obj) {
            const thisKey = parentKey + (parentKey === '' ? '' : '.') + key;
            if (typeof obj[key] === 'object') {
                if (seen.has(obj[key])) {
                    const seenKey = seen.get(obj[key]);
                    obj[key] = `[Circular Reference => ${seenKey}]`;
                    continue;
                }
                seen.set(obj[key], thisKey);
                _recursive(obj[key], thisKey);
            }
        }
        return obj;
    };
    return _recursive(obj);
};
const sendDynamicProps = (environmentId, settingsToSend) => __awaiter$1(void 0, void 0, void 0, function* () {
    try {
        const { dynamicContextProps, dynamicWagmiSettings, frameworkSettings } = settingsToSend;
        if (dynamicContextProps) {
            yield sendDynamicContextSettings(environmentId, { dynamicContextProps, frameworkSettings }, isDynamicContextSessionSettingExpired, setDynamicContextSessionSettings);
        }
        if (dynamicWagmiSettings) {
            yield sendDynamicContextSettings(environmentId, { dynamicWagmiSettings }, isWagmiSessionSettingExpired, setWagmiSessionSettings);
        }
    }
    catch (error) {
        logger$1.warn('Error caught when sending sdkSettings to api. Please notify Dynamic, and send the DynamicContextProvider settings you currently have configured', { error });
    }
});
const sendDynamicContextSettings = (environmentId, sdkSettingsRequest, isSdkSettingExpired, setSDKSessionSettings) => __awaiter$1(void 0, void 0, void 0, function* () {
    // sent once. no need to send again
    if (!isSdkSettingExpired()) {
        return;
    }
    yield sdkApi().logDynamicSdkSettings({
        environmentId,
        sdkSettingsRequest: detectCircular(sdkSettingsRequest),
    });
    setSDKSessionSettings();
});

const AccessDeniedContext = createContext(undefined);
const AccessDeniedContextProvider = ({ children, }) => {
    const [deniedOauthUsername, setDeniedOauthUsername] = useState('');
    const [deniedAddress, setDeniedAddress] = useState('');
    const [deniedOauthProvider, setDeniedOauthProvider] = useState(undefined);
    const value = useMemo(() => ({
        deniedAddress,
        deniedOauthProvider,
        deniedOauthUsername,
        setDeniedAddress,
        setDeniedOauthProvider,
        setDeniedOauthUsername,
    }), [deniedAddress, deniedOauthProvider, deniedOauthUsername]);
    return (jsxRuntimeExports.jsx(AccessDeniedContext.Provider, { value: value, children: children }));
};
const useAccessDeniedContext = () => {
    const context = useContext(AccessDeniedContext);
    if (context === undefined) {
        throw new Error('usage of useAccessDeniedContext not wrapped in `AccessDeniedContextProvider`.');
    }
    return context;
};

const AccountExistsContext = createContext(undefined);
const AccountExistsContextProvider = ({ children, }) => {
    const [existentAccountData, setExistentAccountData] = useState();
    const value = useMemo(() => ({
        existentAccountData,
        setExistentAccountData,
    }), [existentAccountData, setExistentAccountData]);
    return (jsxRuntimeExports.jsx(AccountExistsContext.Provider, { value: value, children: children }));
};
const useAccountExistsContext = () => {
    const context = useContext(AccountExistsContext);
    if (context === undefined) {
        throw new Error('usage of useAccountExistsContext not wrapped in `AccountExistsContextProvider`.');
    }
    return context;
};

/** Context for accessing the current user/session's wallets */
const UserWalletsContext = createContext(undefined);
const UserWalletsProvider = ({ children }) => {
    const [userWallets, _setUserWallets] = useState([]);
    const prevUserWallets = useRef([]);
    const addedWalletsIds = useRef([]);
    const removedWalletsIds = useRef([]);
    const setUserWallets = useCallback((returnUpdatedWallets) => {
        _setUserWallets((prevWallets) => {
            const updatedWallets = returnUpdatedWallets(prevWallets);
            // Use old state value if nothing changed to prevent unnecessary re-renders
            if (updatedWallets.length === 0 && prevWallets.length === 0)
                return prevWallets;
            prevUserWallets.current = prevWallets;
            return updatedWallets;
        });
    }, []);
    // it's an useEffect because it needs to be called after the userWallets state is updated
    useEffect(() => {
        addedWalletsIds.current.forEach((walletId) => {
            const wallet = userWallets.find(({ id }) => id === walletId);
            if (!wallet)
                return;
            dynamicEvents.emit('walletAdded', wallet, userWallets);
        });
        removedWalletsIds.current.forEach((walletId) => {
            const wallet = prevUserWallets.current.find(({ id }) => id === walletId);
            if (!wallet)
                return;
            dynamicEvents.emit('walletRemoved', wallet, userWallets);
        });
        addedWalletsIds.current = [];
        removedWalletsIds.current = [];
    }, [userWallets]);
    const memoizedRegisterUserWallet = useCallback((newWallet) => setUserWallets((userWallets) => [...userWallets, newWallet]), [setUserWallets]);
    const memoizedRemoveUserWallet = useCallback((walletId) => setUserWallets((userWallets) => userWallets.filter(({ id }) => walletId !== id)), [setUserWallets]);
    return (jsxRuntimeExports.jsx(UserWalletsContext.Provider, { value: {
            addedWalletsIds,
            registerUserWallet: memoizedRegisterUserWallet,
            removeUserWallet: memoizedRemoveUserWallet,
            removedWalletsIds,
            setUserWallets,
            userWallets,
        }, children: children }));
};
/** Provides access to state and setters of the current user/session wallets array */
const useInternalUserWallets = () => {
    const context = useContext(UserWalletsContext);
    if (!context)
        throw new Error('Can only call useInternalUserWallets inside UserWalletsProvider');
    return context;
};
/** Provides access to the current user/session wallets */
const useUserWallets = () => {
    const context = useContext(UserWalletsContext);
    if (!context)
        throw new Error('Can only call useUserWallets inside UserWalletsProvider');
    return context.userWallets;
};

const VerificationContext = createContext(undefined);
// Context used to hold verificationUUID & email between views.
const VerificationProvider = ({ children }) => {
    const [displayedDestination, setDisplayedDestination] = useState(undefined);
    const [verificationUUID, setVerificationUUID] = useState(undefined);
    const [retryData, setRetryData] = useState(undefined);
    /** Update retryData state only if the new data is different from the current retryData */
    const externalSetRetryData = useCallback((data) => {
        setRetryData((prev) => (data === null || data === void 0 ? void 0 : data.phone) === (prev === null || prev === void 0 ? void 0 : prev.phone) &&
            (data === null || data === void 0 ? void 0 : data.iso2) === (prev === null || prev === void 0 ? void 0 : prev.iso2) &&
            (data === null || data === void 0 ? void 0 : data.dialCode) === (prev === null || prev === void 0 ? void 0 : prev.dialCode)
            ? prev
            : data);
    }, []);
    const value = useMemo(() => ({
        displayedDestination,
        retryData,
        setDisplayedDestination,
        setRetryData: externalSetRetryData,
        setVerificationUUID,
        verificationUUID,
    }), [displayedDestination, retryData, verificationUUID, externalSetRetryData]);
    return (jsxRuntimeExports.jsx(VerificationContext.Provider, { value: value, children: children }));
};
const useVerification = () => {
    const context = useContext(VerificationContext);
    if (context === undefined) {
        throw new Error('usage of useVerification not wrapped in `VerificationProvider`.');
    }
    return context;
};

const synonyms = {
    bitcoin: 'BTC',
    eip155: 'EVM',
    solana: 'SOL',
};
for (const chain in synonyms)
    synonyms[synonyms[chain]] = chain;
const compareChains = (chain1, chain2) => chain1 === chain2 || synonyms[chain1] === chain2;

const getValueByKey = (objectData, keyName) => objectData[keyName];

const themesData = {
    border: 'rounded',
    brandStyle: 'subtle',
    customColor: '',
    template: 'default',
    themes: {
        auto: {
            colors: {
                accent_1: '#2C303A',
                accent_2: '#3C414D',
                accent_3: '#4C525F',
                background: '#15181F',
                border: '1px solid #2C303A',
                error_1: 'rgba(255, 106, 106, 0.2)',
                error_2: '#FF6A6A',
                footer: '#2C303A',
                primary: '#15181F',
                secondary: '#2C303A',
                ternary: '#2660FF',
                textPrimary: '#FFF',
                textSecondary: '#ACACB9',
            },
            name: 'auto',
        },
        dark: {
            colors: {
                accent_1: '#2C303A',
                accent_2: '#3C414D',
                accent_3: '#4C525F',
                background: '#15181F',
                border: '1px solid #2C303A',
                error_1: 'rgba(255, 106, 106, 0.2)',
                error_2: '#FF6A6A',
                footer: '#2C303A',
                primary: '#15181F',
                secondary: '#2C303A',
                ternary: '#2660FF',
                textPrimary: '#FFF',
                textSecondary: '#ACACB9',
            },
            name: 'dark',
        },
        light: {
            colors: {
                accent_1: '#FFF',
                accent_2: '#F0F3FF',
                accent_3: '#E9EDFC',
                background: '#FFFFFF',
                border: '1px solid #E9EDFC',
                error_1: 'rgba(255, 70, 70, 0.1)',
                error_2: '#FF4646',
                footer: '#F7F9FE',
                primary: '#F7F7F9',
                secondary: '#FFFFFF',
                ternary: '#2660FF',
                textPrimary: '#404040',
                textSecondary: '#80858B',
            },
            name: 'light',
        },
    },
    view: 'extended',
    walletColor: {
        color: '#1648F9',
        gradient: '90deg, #1648F9 0%, #4B73FF 100%',
    },
};
const getThemeConfig = (modalSettings, themeMode) => {
    const { border, brand, view, primaryColor } = modalSettings || {};
    const themeName = themeMode || (modalSettings === null || modalSettings === void 0 ? void 0 : modalSettings.theme) || 'light';
    const themeTemplate = (modalSettings === null || modalSettings === void 0 ? void 0 : modalSettings.template) || 'default';
    return Object.assign(Object.assign({}, themesData), { border: border || themesData.border, brandStyle: brand || themesData.brandStyle, customColor: primaryColor || themesData.customColor, template: themeTemplate, theme: getValueByKey(themesData.themes, themeName), view: view || themesData.view });
};

const findOrCreateLinkTag = () => {
    if (isSSR())
        return;
    const existingStyleTag = document.querySelector('[data-source="dynamic-theme-cdn"]');
    if (existingStyleTag) {
        return existingStyleTag;
    }
    const linkTag = document.createElement('link');
    document.head.append(linkTag);
    linkTag.dataset.source = 'dynamic-theme-cdn';
    linkTag.rel = 'stylesheet';
    return linkTag;
};
const findOrCreateStyleTag = () => {
    if (isSSR())
        return;
    const existingStyleTag = document.querySelector('[data-source="dynamic-theme"]');
    if (existingStyleTag) {
        return existingStyleTag;
    }
    const styleTag = document.createElement('style');
    document.head.append(styleTag);
    styleTag.dataset.source = 'dynamic-theme';
    return styleTag;
};
const buildStylesheet = (theme) => {
    const { customColor, brandStyle } = theme;
    const footerBackgroundColor = brandStyle === 'bold' ? customColor : undefined;
    const footerIconColor = brandStyle === 'subtle' ? customColor : undefined;
    const cssAttributes = [
        ['--dynamic-brand-primary-color', customColor],
        ['--dynamic-badge-dot-background', customColor],
        ['--dynamic-footer-background-color', footerBackgroundColor],
        ['--dynamic-footer-icon-color', footerIconColor],
    ];
    return `@layer dynamic-project-environment-theme {
  #dynamic-widget, #dynamic-modal, .dynamic-shadow-dom {
    ${cssAttributes
        .filter(([, value]) => value !== undefined && value !== '')
        .map(([key, value]) => `${key}: ${value};`)
        .join('\n    ')}
  }
}`;
};

const ThemeContext = createContext(undefined);
const ThemeContextProvider = ({ customerTheme, designSettings, children }) => {
    const [theme, _setTheme] = useState(customerTheme || getThemeConfig(designSettings === null || designSettings === void 0 ? void 0 : designSettings.modal));
    const linkTag = useRef(findOrCreateLinkTag());
    const styleTag = useRef(findOrCreateStyleTag());
    const setTheme = useCallback((newTheme) => {
        _setTheme(newTheme);
        // SSR won't have document defined, so we can't run this logic in server side
        if (isSSR() ||
            linkTag.current === undefined ||
            styleTag.current === undefined)
            return;
        document.body.dataset.dynamicTheme = newTheme.theme.name;
        document.body.dataset.dynamicThemeBrand = newTheme.brandStyle;
        const linkHref = newTheme.template === 'default'
            ? ''
            : `https://app.dynamic.xyz/assets/templates/${newTheme.template}.css`;
        if (linkTag.current.href !== linkHref)
            linkTag.current.href = linkHref;
        const builtStylesheet = buildStylesheet(newTheme);
        if (styleTag.current.innerHTML === builtStylesheet)
            return;
        styleTag.current.innerHTML = builtStylesheet;
    }, []);
    const changeTheme = useCallback((passedTheme, footerColor) => {
        var _a;
        const selectedTheme = (_a = themesData.themes) === null || _a === void 0 ? void 0 : _a[passedTheme];
        const updatedThemeData = Object.assign(Object.assign({}, theme), { theme: Object.assign(Object.assign({}, selectedTheme), { colors: Object.assign(Object.assign({}, selectedTheme.colors), { ternary: footerColor !== null && footerColor !== void 0 ? footerColor : selectedTheme.colors.ternary }) }) });
        setTheme(updatedThemeData);
    }, [setTheme, theme]);
    const changeTemplate = useCallback((template) => setTheme(Object.assign(Object.assign({}, theme), { template })), [setTheme, theme]);
    const changeBorder = useCallback((border) => setTheme(Object.assign(Object.assign({}, theme), { border })), [setTheme, theme]);
    const changeView = useCallback((view) => setTheme(Object.assign(Object.assign({}, theme), { view })), [setTheme, theme]);
    const changePrimaryColor = useCallback((customColor) => setTheme(Object.assign(Object.assign({}, theme), { customColor })), [setTheme, theme]);
    const changeBrandStyle = useCallback((brandStyle) => setTheme(Object.assign(Object.assign({}, theme), { brandStyle })), [setTheme, theme]);
    // This hook changes theme when customerTheme prop changes
    // It can be changed by customer code so useEffect makes sense here
    useEffect(() => setTheme(customerTheme || getThemeConfig(designSettings === null || designSettings === void 0 ? void 0 : designSettings.modal)), [customerTheme, designSettings === null || designSettings === void 0 ? void 0 : designSettings.modal, setTheme]);
    const value = useMemo(() => ({
        changeBorder,
        changeBrandStyle,
        changePrimaryColor,
        changeTemplate,
        changeTheme,
        changeView,
        theme,
    }), [
        theme,
        changeBorder,
        changeBrandStyle,
        changeTemplate,
        changeTheme,
        changePrimaryColor,
        changeView,
    ]);
    return (jsxRuntimeExports.jsx(ThemeContext.Provider, { value: value, children: children }));
};
const useThemeContext = () => {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useThemeContext must be used within a ThemeContextProvider');
    }
    return context;
};

// ES6 Map
var map;
try {
  map = Map;
} catch (_) { }
var set;

// ES6 Set
try {
  set = Set;
} catch (_) { }

function baseClone$1 (src, circulars, clones) {
  // Null/undefined/functions/etc
  if (!src || typeof src !== 'object' || typeof src === 'function') {
    return src
  }

  // DOM Node
  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true)
  }

  // Date
  if (src instanceof Date) {
    return new Date(src.getTime())
  }

  // RegExp
  if (src instanceof RegExp) {
    return new RegExp(src)
  }

  // Arrays
  if (Array.isArray(src)) {
    return src.map(clone$1)
  }

  // ES6 Maps
  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()))
  }

  // ES6 Sets
  if (set && src instanceof set) {
    return new Set(Array.from(src.values()))
  }

  // Object
  if (src instanceof Object) {
    circulars.push(src);
    var obj = Object.create(src);
    clones.push(obj);
    for (var key in src) {
      var idx = circulars.findIndex(function (i) {
        return i === src[key]
      });
      obj[key] = idx > -1 ? clones[idx] : baseClone$1(src[key], circulars, clones);
    }
    return obj
  }

  // ???
  return src
}

function clone$1 (src) {
  return baseClone$1(src, [], [])
}

const toString$2 = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString$1 = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString$1.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString$2.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} must be defined'
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
});

/** Used for built-in method references. */

var _baseHas;
var hasRequired_baseHas;

function require_baseHas () {
	if (hasRequired_baseHas) return _baseHas;
	hasRequired_baseHas = 1;
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}

	_baseHas = baseHas;
	return _baseHas;
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray_1;
var hasRequiredIsArray;

function requireIsArray () {
	if (hasRequiredIsArray) return isArray_1;
	hasRequiredIsArray = 1;
	var isArray = Array.isArray;

	isArray_1 = isArray;
	return isArray_1;
}

/** Detect free variable `global` from Node.js. */

var _freeGlobal;
var hasRequired_freeGlobal;

function require_freeGlobal () {
	if (hasRequired_freeGlobal) return _freeGlobal;
	hasRequired_freeGlobal = 1;
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	_freeGlobal = freeGlobal;
	return _freeGlobal;
}

var _root;
var hasRequired_root;

function require_root () {
	if (hasRequired_root) return _root;
	hasRequired_root = 1;
	var freeGlobal = require_freeGlobal();

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	_root = root;
	return _root;
}

var _Symbol;
var hasRequired_Symbol;

function require_Symbol () {
	if (hasRequired_Symbol) return _Symbol;
	hasRequired_Symbol = 1;
	var root = require_root();

	/** Built-in value references. */
	var Symbol = root.Symbol;

	_Symbol = Symbol;
	return _Symbol;
}

var _getRawTag;
var hasRequired_getRawTag;

function require_getRawTag () {
	if (hasRequired_getRawTag) return _getRawTag;
	hasRequired_getRawTag = 1;
	var Symbol = require_Symbol();

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;

	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];

	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}

	_getRawTag = getRawTag;
	return _getRawTag;
}

/** Used for built-in method references. */

var _objectToString;
var hasRequired_objectToString;

function require_objectToString () {
	if (hasRequired_objectToString) return _objectToString;
	hasRequired_objectToString = 1;
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}

	_objectToString = objectToString;
	return _objectToString;
}

var _baseGetTag;
var hasRequired_baseGetTag;

function require_baseGetTag () {
	if (hasRequired_baseGetTag) return _baseGetTag;
	hasRequired_baseGetTag = 1;
	var Symbol = require_Symbol(),
	    getRawTag = require_getRawTag(),
	    objectToString = require_objectToString();

	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';

	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}

	_baseGetTag = baseGetTag;
	return _baseGetTag;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

var isObjectLike_1;
var hasRequiredIsObjectLike;

function requireIsObjectLike () {
	if (hasRequiredIsObjectLike) return isObjectLike_1;
	hasRequiredIsObjectLike = 1;
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}

	isObjectLike_1 = isObjectLike;
	return isObjectLike_1;
}

var isSymbol_1;
var hasRequiredIsSymbol;

function requireIsSymbol () {
	if (hasRequiredIsSymbol) return isSymbol_1;
	hasRequiredIsSymbol = 1;
	var baseGetTag = require_baseGetTag(),
	    isObjectLike = requireIsObjectLike();

	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}

	isSymbol_1 = isSymbol;
	return isSymbol_1;
}

var _isKey;
var hasRequired_isKey;

function require_isKey () {
	if (hasRequired_isKey) return _isKey;
	hasRequired_isKey = 1;
	var isArray = requireIsArray(),
	    isSymbol = requireIsSymbol();

	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;

	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}

	_isKey = isKey;
	return _isKey;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

var isObject_1;
var hasRequiredIsObject;

function requireIsObject () {
	if (hasRequiredIsObject) return isObject_1;
	hasRequiredIsObject = 1;
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}

	isObject_1 = isObject;
	return isObject_1;
}

var isFunction_1;
var hasRequiredIsFunction;

function requireIsFunction () {
	if (hasRequiredIsFunction) return isFunction_1;
	hasRequiredIsFunction = 1;
	var baseGetTag = require_baseGetTag(),
	    isObject = requireIsObject();

	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}

	isFunction_1 = isFunction;
	return isFunction_1;
}

var _coreJsData;
var hasRequired_coreJsData;

function require_coreJsData () {
	if (hasRequired_coreJsData) return _coreJsData;
	hasRequired_coreJsData = 1;
	var root = require_root();

	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];

	_coreJsData = coreJsData;
	return _coreJsData;
}

var _isMasked;
var hasRequired_isMasked;

function require_isMasked () {
	if (hasRequired_isMasked) return _isMasked;
	hasRequired_isMasked = 1;
	var coreJsData = require_coreJsData();

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	_isMasked = isMasked;
	return _isMasked;
}

/** Used for built-in method references. */

var _toSource;
var hasRequired_toSource;

function require_toSource () {
	if (hasRequired_toSource) return _toSource;
	hasRequired_toSource = 1;
	var funcProto = Function.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	_toSource = toSource;
	return _toSource;
}

var _baseIsNative;
var hasRequired_baseIsNative;

function require_baseIsNative () {
	if (hasRequired_baseIsNative) return _baseIsNative;
	hasRequired_baseIsNative = 1;
	var isFunction = requireIsFunction(),
	    isMasked = require_isMasked(),
	    isObject = requireIsObject(),
	    toSource = require_toSource();

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	_baseIsNative = baseIsNative;
	return _baseIsNative;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

var _getValue;
var hasRequired_getValue;

function require_getValue () {
	if (hasRequired_getValue) return _getValue;
	hasRequired_getValue = 1;
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	_getValue = getValue;
	return _getValue;
}

var _getNative;
var hasRequired_getNative;

function require_getNative () {
	if (hasRequired_getNative) return _getNative;
	hasRequired_getNative = 1;
	var baseIsNative = require_baseIsNative(),
	    getValue = require_getValue();

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	_getNative = getNative;
	return _getNative;
}

var _nativeCreate;
var hasRequired_nativeCreate;

function require_nativeCreate () {
	if (hasRequired_nativeCreate) return _nativeCreate;
	hasRequired_nativeCreate = 1;
	var getNative = require_getNative();

	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');

	_nativeCreate = nativeCreate;
	return _nativeCreate;
}

var _hashClear;
var hasRequired_hashClear;

function require_hashClear () {
	if (hasRequired_hashClear) return _hashClear;
	hasRequired_hashClear = 1;
	var nativeCreate = require_nativeCreate();

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}

	_hashClear = hashClear;
	return _hashClear;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

var _hashDelete;
var hasRequired_hashDelete;

function require_hashDelete () {
	if (hasRequired_hashDelete) return _hashDelete;
	hasRequired_hashDelete = 1;
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}

	_hashDelete = hashDelete;
	return _hashDelete;
}

var _hashGet;
var hasRequired_hashGet;

function require_hashGet () {
	if (hasRequired_hashGet) return _hashGet;
	hasRequired_hashGet = 1;
	var nativeCreate = require_nativeCreate();

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}

	_hashGet = hashGet;
	return _hashGet;
}

var _hashHas;
var hasRequired_hashHas;

function require_hashHas () {
	if (hasRequired_hashHas) return _hashHas;
	hasRequired_hashHas = 1;
	var nativeCreate = require_nativeCreate();

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}

	_hashHas = hashHas;
	return _hashHas;
}

var _hashSet;
var hasRequired_hashSet;

function require_hashSet () {
	if (hasRequired_hashSet) return _hashSet;
	hasRequired_hashSet = 1;
	var nativeCreate = require_nativeCreate();

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}

	_hashSet = hashSet;
	return _hashSet;
}

var _Hash;
var hasRequired_Hash;

function require_Hash () {
	if (hasRequired_Hash) return _Hash;
	hasRequired_Hash = 1;
	var hashClear = require_hashClear(),
	    hashDelete = require_hashDelete(),
	    hashGet = require_hashGet(),
	    hashHas = require_hashHas(),
	    hashSet = require_hashSet();

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;

	_Hash = Hash;
	return _Hash;
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

var _listCacheClear;
var hasRequired_listCacheClear;

function require_listCacheClear () {
	if (hasRequired_listCacheClear) return _listCacheClear;
	hasRequired_listCacheClear = 1;
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}

	_listCacheClear = listCacheClear;
	return _listCacheClear;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

var eq_1;
var hasRequiredEq;

function requireEq () {
	if (hasRequiredEq) return eq_1;
	hasRequiredEq = 1;
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	eq_1 = eq;
	return eq_1;
}

var _assocIndexOf;
var hasRequired_assocIndexOf;

function require_assocIndexOf () {
	if (hasRequired_assocIndexOf) return _assocIndexOf;
	hasRequired_assocIndexOf = 1;
	var eq = requireEq();

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	_assocIndexOf = assocIndexOf;
	return _assocIndexOf;
}

var _listCacheDelete;
var hasRequired_listCacheDelete;

function require_listCacheDelete () {
	if (hasRequired_listCacheDelete) return _listCacheDelete;
	hasRequired_listCacheDelete = 1;
	var assocIndexOf = require_assocIndexOf();

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;

	/** Built-in value references. */
	var splice = arrayProto.splice;

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}

	_listCacheDelete = listCacheDelete;
	return _listCacheDelete;
}

var _listCacheGet;
var hasRequired_listCacheGet;

function require_listCacheGet () {
	if (hasRequired_listCacheGet) return _listCacheGet;
	hasRequired_listCacheGet = 1;
	var assocIndexOf = require_assocIndexOf();

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	_listCacheGet = listCacheGet;
	return _listCacheGet;
}

var _listCacheHas;
var hasRequired_listCacheHas;

function require_listCacheHas () {
	if (hasRequired_listCacheHas) return _listCacheHas;
	hasRequired_listCacheHas = 1;
	var assocIndexOf = require_assocIndexOf();

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}

	_listCacheHas = listCacheHas;
	return _listCacheHas;
}

var _listCacheSet;
var hasRequired_listCacheSet;

function require_listCacheSet () {
	if (hasRequired_listCacheSet) return _listCacheSet;
	hasRequired_listCacheSet = 1;
	var assocIndexOf = require_assocIndexOf();

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	_listCacheSet = listCacheSet;
	return _listCacheSet;
}

var _ListCache;
var hasRequired_ListCache;

function require_ListCache () {
	if (hasRequired_ListCache) return _ListCache;
	hasRequired_ListCache = 1;
	var listCacheClear = require_listCacheClear(),
	    listCacheDelete = require_listCacheDelete(),
	    listCacheGet = require_listCacheGet(),
	    listCacheHas = require_listCacheHas(),
	    listCacheSet = require_listCacheSet();

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;

	_ListCache = ListCache;
	return _ListCache;
}

var _Map;
var hasRequired_Map;

function require_Map () {
	if (hasRequired_Map) return _Map;
	hasRequired_Map = 1;
	var getNative = require_getNative(),
	    root = require_root();

	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');

	_Map = Map;
	return _Map;
}

var _mapCacheClear;
var hasRequired_mapCacheClear;

function require_mapCacheClear () {
	if (hasRequired_mapCacheClear) return _mapCacheClear;
	hasRequired_mapCacheClear = 1;
	var Hash = require_Hash(),
	    ListCache = require_ListCache(),
	    Map = require_Map();

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}

	_mapCacheClear = mapCacheClear;
	return _mapCacheClear;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

var _isKeyable;
var hasRequired_isKeyable;

function require_isKeyable () {
	if (hasRequired_isKeyable) return _isKeyable;
	hasRequired_isKeyable = 1;
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	_isKeyable = isKeyable;
	return _isKeyable;
}

var _getMapData;
var hasRequired_getMapData;

function require_getMapData () {
	if (hasRequired_getMapData) return _getMapData;
	hasRequired_getMapData = 1;
	var isKeyable = require_isKeyable();

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	_getMapData = getMapData;
	return _getMapData;
}

var _mapCacheDelete;
var hasRequired_mapCacheDelete;

function require_mapCacheDelete () {
	if (hasRequired_mapCacheDelete) return _mapCacheDelete;
	hasRequired_mapCacheDelete = 1;
	var getMapData = require_getMapData();

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}

	_mapCacheDelete = mapCacheDelete;
	return _mapCacheDelete;
}

var _mapCacheGet;
var hasRequired_mapCacheGet;

function require_mapCacheGet () {
	if (hasRequired_mapCacheGet) return _mapCacheGet;
	hasRequired_mapCacheGet = 1;
	var getMapData = require_getMapData();

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}

	_mapCacheGet = mapCacheGet;
	return _mapCacheGet;
}

var _mapCacheHas;
var hasRequired_mapCacheHas;

function require_mapCacheHas () {
	if (hasRequired_mapCacheHas) return _mapCacheHas;
	hasRequired_mapCacheHas = 1;
	var getMapData = require_getMapData();

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}

	_mapCacheHas = mapCacheHas;
	return _mapCacheHas;
}

var _mapCacheSet;
var hasRequired_mapCacheSet;

function require_mapCacheSet () {
	if (hasRequired_mapCacheSet) return _mapCacheSet;
	hasRequired_mapCacheSet = 1;
	var getMapData = require_getMapData();

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;

	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}

	_mapCacheSet = mapCacheSet;
	return _mapCacheSet;
}

var _MapCache;
var hasRequired_MapCache;

function require_MapCache () {
	if (hasRequired_MapCache) return _MapCache;
	hasRequired_MapCache = 1;
	var mapCacheClear = require_mapCacheClear(),
	    mapCacheDelete = require_mapCacheDelete(),
	    mapCacheGet = require_mapCacheGet(),
	    mapCacheHas = require_mapCacheHas(),
	    mapCacheSet = require_mapCacheSet();

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;

	_MapCache = MapCache;
	return _MapCache;
}

var memoize_1;
var hasRequiredMemoize;

function requireMemoize () {
	if (hasRequiredMemoize) return memoize_1;
	hasRequiredMemoize = 1;
	var MapCache = require_MapCache();

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;

	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}

	// Expose `MapCache`.
	memoize.Cache = MapCache;

	memoize_1 = memoize;
	return memoize_1;
}

var _memoizeCapped;
var hasRequired_memoizeCapped;

function require_memoizeCapped () {
	if (hasRequired_memoizeCapped) return _memoizeCapped;
	hasRequired_memoizeCapped = 1;
	var memoize = requireMemoize();

	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;

	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });

	  var cache = result.cache;
	  return result;
	}

	_memoizeCapped = memoizeCapped;
	return _memoizeCapped;
}

var _stringToPath;
var hasRequired_stringToPath;

function require_stringToPath () {
	if (hasRequired_stringToPath) return _stringToPath;
	hasRequired_stringToPath = 1;
	var memoizeCapped = require_memoizeCapped();

	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;

	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});

	_stringToPath = stringToPath;
	return _stringToPath;
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

var _arrayMap;
var hasRequired_arrayMap;

function require_arrayMap () {
	if (hasRequired_arrayMap) return _arrayMap;
	hasRequired_arrayMap = 1;
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);

	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}

	_arrayMap = arrayMap;
	return _arrayMap;
}

var _baseToString;
var hasRequired_baseToString;

function require_baseToString () {
	if (hasRequired_baseToString) return _baseToString;
	hasRequired_baseToString = 1;
	var Symbol = require_Symbol(),
	    arrayMap = require_arrayMap(),
	    isArray = requireIsArray(),
	    isSymbol = requireIsSymbol();

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;

	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -Infinity) ? '-0' : result;
	}

	_baseToString = baseToString;
	return _baseToString;
}

var toString_1;
var hasRequiredToString;

function requireToString () {
	if (hasRequiredToString) return toString_1;
	hasRequiredToString = 1;
	var baseToString = require_baseToString();

	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}

	toString_1 = toString;
	return toString_1;
}

var _castPath;
var hasRequired_castPath;

function require_castPath () {
	if (hasRequired_castPath) return _castPath;
	hasRequired_castPath = 1;
	var isArray = requireIsArray(),
	    isKey = require_isKey(),
	    stringToPath = require_stringToPath(),
	    toString = requireToString();

	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}

	_castPath = castPath;
	return _castPath;
}

var _baseIsArguments;
var hasRequired_baseIsArguments;

function require_baseIsArguments () {
	if (hasRequired_baseIsArguments) return _baseIsArguments;
	hasRequired_baseIsArguments = 1;
	var baseGetTag = require_baseGetTag(),
	    isObjectLike = requireIsObjectLike();

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';

	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}

	_baseIsArguments = baseIsArguments;
	return _baseIsArguments;
}

var isArguments_1;
var hasRequiredIsArguments;

function requireIsArguments () {
	if (hasRequiredIsArguments) return isArguments_1;
	hasRequiredIsArguments = 1;
	var baseIsArguments = require_baseIsArguments(),
	    isObjectLike = requireIsObjectLike();

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};

	isArguments_1 = isArguments;
	return isArguments_1;
}

/** Used as references for various `Number` constants. */

var _isIndex;
var hasRequired_isIndex;

function require_isIndex () {
	if (hasRequired_isIndex) return _isIndex;
	hasRequired_isIndex = 1;
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;

	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}

	_isIndex = isIndex;
	return _isIndex;
}

/** Used as references for various `Number` constants. */

var isLength_1;
var hasRequiredIsLength;

function requireIsLength () {
	if (hasRequiredIsLength) return isLength_1;
	hasRequiredIsLength = 1;
	var MAX_SAFE_INTEGER = 9007199254740991;

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	isLength_1 = isLength;
	return isLength_1;
}

var _toKey;
var hasRequired_toKey;

function require_toKey () {
	if (hasRequired_toKey) return _toKey;
	hasRequired_toKey = 1;
	var isSymbol = requireIsSymbol();

	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -Infinity) ? '-0' : result;
	}

	_toKey = toKey;
	return _toKey;
}

var _hasPath;
var hasRequired_hasPath;

function require_hasPath () {
	if (hasRequired_hasPath) return _hasPath;
	hasRequired_hasPath = 1;
	var castPath = require_castPath(),
	    isArguments = requireIsArguments(),
	    isArray = requireIsArray(),
	    isIndex = require_isIndex(),
	    isLength = requireIsLength(),
	    toKey = require_toKey();

	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);

	  var index = -1,
	      length = path.length,
	      result = false;

	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}

	_hasPath = hasPath;
	return _hasPath;
}

var has_1;
var hasRequiredHas$1;

function requireHas$1 () {
	if (hasRequiredHas$1) return has_1;
	hasRequiredHas$1 = 1;
	var baseHas = require_baseHas(),
	    hasPath = require_hasPath();

	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}

	has_1 = has;
	return has_1;
}

var hasExports = requireHas$1();
var has$1 = /*@__PURE__*/getDefaultExportFromCjs(hasExports);

const isSchema = obj => obj && obj.__isYupSchema__;

class Condition {
  constructor(refs, options) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!has$1(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);

    this.fn = function (...args) {
      let options = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  resolve(base, options) {
    let values = this.refs.map(ref => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }

}

function toArray$1(value) {
  return value == null ? [] : [].concat(value);
}

function _extends$1D() { _extends$1D = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }
let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends$1D({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }

  static isError(err) {
    return err && err.name === 'ValidationError';
  }

  constructor(errorOrErrors, value, field, type) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray$1(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }

}

const once = cb => {
  let fired = false;
  return (...args) => {
    if (fired) return;
    fired = true;
    cb(...args);
  };
};

function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }

        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }

        nestedErrors.push(err);
      }

      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push(...errors);
          errors = nestedErrors;
        }

        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }

        callback(null, value);
      }
    });
  }
}

var _defineProperty$1;
var hasRequired_defineProperty;

function require_defineProperty () {
	if (hasRequired_defineProperty) return _defineProperty$1;
	hasRequired_defineProperty = 1;
	var getNative = require_getNative();

	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());

	_defineProperty$1 = defineProperty;
	return _defineProperty$1;
}

var _baseAssignValue;
var hasRequired_baseAssignValue;

function require_baseAssignValue () {
	if (hasRequired_baseAssignValue) return _baseAssignValue;
	hasRequired_baseAssignValue = 1;
	var defineProperty = require_defineProperty();

	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}

	_baseAssignValue = baseAssignValue;
	return _baseAssignValue;
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

var _createBaseFor;
var hasRequired_createBaseFor;

function require_createBaseFor () {
	if (hasRequired_createBaseFor) return _createBaseFor;
	hasRequired_createBaseFor = 1;
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;

	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}

	_createBaseFor = createBaseFor;
	return _createBaseFor;
}

var _baseFor;
var hasRequired_baseFor;

function require_baseFor () {
	if (hasRequired_baseFor) return _baseFor;
	hasRequired_baseFor = 1;
	var createBaseFor = require_createBaseFor();

	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();

	_baseFor = baseFor;
	return _baseFor;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

var _baseTimes;
var hasRequired_baseTimes;

function require_baseTimes () {
	if (hasRequired_baseTimes) return _baseTimes;
	hasRequired_baseTimes = 1;
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	_baseTimes = baseTimes;
	return _baseTimes;
}

var isBuffer$1 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

var stubFalse_1;
var hasRequiredStubFalse;

function requireStubFalse () {
	if (hasRequiredStubFalse) return stubFalse_1;
	hasRequiredStubFalse = 1;
	function stubFalse() {
	  return false;
	}

	stubFalse_1 = stubFalse;
	return stubFalse_1;
}

isBuffer$1.exports;

var hasRequiredIsBuffer;

function requireIsBuffer () {
	if (hasRequiredIsBuffer) return isBuffer$1.exports;
	hasRequiredIsBuffer = 1;
	(function (module, exports) {
		var root = require_root(),
		    stubFalse = requireStubFalse();

		/** Detect free variable `exports`. */
		var freeExports = exports && !exports.nodeType && exports;

		/** Detect free variable `module`. */
		var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;

		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined;

		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = nativeIsBuffer || stubFalse;

		module.exports = isBuffer; 
	} (isBuffer$1, isBuffer$1.exports));
	return isBuffer$1.exports;
}

var _baseIsTypedArray;
var hasRequired_baseIsTypedArray;

function require_baseIsTypedArray () {
	if (hasRequired_baseIsTypedArray) return _baseIsTypedArray;
	hasRequired_baseIsTypedArray = 1;
	var baseGetTag = require_baseGetTag(),
	    isLength = requireIsLength(),
	    isObjectLike = requireIsObjectLike();

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;

	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}

	_baseIsTypedArray = baseIsTypedArray;
	return _baseIsTypedArray;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

var _baseUnary;
var hasRequired_baseUnary;

function require_baseUnary () {
	if (hasRequired_baseUnary) return _baseUnary;
	hasRequired_baseUnary = 1;
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}

	_baseUnary = baseUnary;
	return _baseUnary;
}

var _nodeUtil = {exports: {}};

_nodeUtil.exports;

var hasRequired_nodeUtil;

function require_nodeUtil () {
	if (hasRequired_nodeUtil) return _nodeUtil.exports;
	hasRequired_nodeUtil = 1;
	(function (module, exports) {
		var freeGlobal = require_freeGlobal();

		/** Detect free variable `exports`. */
		var freeExports = exports && !exports.nodeType && exports;

		/** Detect free variable `module`. */
		var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;

		/** Detect free variable `process` from Node.js. */
		var freeProcess = moduleExports && freeGlobal.process;

		/** Used to access faster Node.js helpers. */
		var nodeUtil = (function() {
		  try {
		    // Use `util.types` for Node.js 10+.
		    var types = freeModule && freeModule.require && freeModule.require('util').types;

		    if (types) {
		      return types;
		    }

		    // Legacy `process.binding('util')` for Node.js < 10.
		    return freeProcess && freeProcess.binding && freeProcess.binding('util');
		  } catch (e) {}
		}());

		module.exports = nodeUtil; 
	} (_nodeUtil, _nodeUtil.exports));
	return _nodeUtil.exports;
}

var isTypedArray_1;
var hasRequiredIsTypedArray;

function requireIsTypedArray () {
	if (hasRequiredIsTypedArray) return isTypedArray_1;
	hasRequiredIsTypedArray = 1;
	var baseIsTypedArray = require_baseIsTypedArray(),
	    baseUnary = require_baseUnary(),
	    nodeUtil = require_nodeUtil();

	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

	isTypedArray_1 = isTypedArray;
	return isTypedArray_1;
}

var _arrayLikeKeys;
var hasRequired_arrayLikeKeys;

function require_arrayLikeKeys () {
	if (hasRequired_arrayLikeKeys) return _arrayLikeKeys;
	hasRequired_arrayLikeKeys = 1;
	var baseTimes = require_baseTimes(),
	    isArguments = requireIsArguments(),
	    isArray = requireIsArray(),
	    isBuffer = requireIsBuffer(),
	    isIndex = require_isIndex(),
	    isTypedArray = requireIsTypedArray();

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	_arrayLikeKeys = arrayLikeKeys;
	return _arrayLikeKeys;
}

/** Used for built-in method references. */

var _isPrototype;
var hasRequired_isPrototype;

function require_isPrototype () {
	if (hasRequired_isPrototype) return _isPrototype;
	hasRequired_isPrototype = 1;
	var objectProto = Object.prototype;

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	  return value === proto;
	}

	_isPrototype = isPrototype;
	return _isPrototype;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

var _overArg;
var hasRequired_overArg;

function require_overArg () {
	if (hasRequired_overArg) return _overArg;
	hasRequired_overArg = 1;
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	_overArg = overArg;
	return _overArg;
}

var _nativeKeys;
var hasRequired_nativeKeys;

function require_nativeKeys () {
	if (hasRequired_nativeKeys) return _nativeKeys;
	hasRequired_nativeKeys = 1;
	var overArg = require_overArg();

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);

	_nativeKeys = nativeKeys;
	return _nativeKeys;
}

var _baseKeys;
var hasRequired_baseKeys;

function require_baseKeys () {
	if (hasRequired_baseKeys) return _baseKeys;
	hasRequired_baseKeys = 1;
	var isPrototype = require_isPrototype(),
	    nativeKeys = require_nativeKeys();

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}

	_baseKeys = baseKeys;
	return _baseKeys;
}

var isArrayLike_1;
var hasRequiredIsArrayLike;

function requireIsArrayLike () {
	if (hasRequiredIsArrayLike) return isArrayLike_1;
	hasRequiredIsArrayLike = 1;
	var isFunction = requireIsFunction(),
	    isLength = requireIsLength();

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}

	isArrayLike_1 = isArrayLike;
	return isArrayLike_1;
}

var keys_1;
var hasRequiredKeys;

function requireKeys () {
	if (hasRequiredKeys) return keys_1;
	hasRequiredKeys = 1;
	var arrayLikeKeys = require_arrayLikeKeys(),
	    baseKeys = require_baseKeys(),
	    isArrayLike = requireIsArrayLike();

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}

	keys_1 = keys;
	return keys_1;
}

var _baseForOwn;
var hasRequired_baseForOwn;

function require_baseForOwn () {
	if (hasRequired_baseForOwn) return _baseForOwn;
	hasRequired_baseForOwn = 1;
	var baseFor = require_baseFor(),
	    keys = requireKeys();

	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}

	_baseForOwn = baseForOwn;
	return _baseForOwn;
}

var _stackClear;
var hasRequired_stackClear;

function require_stackClear () {
	if (hasRequired_stackClear) return _stackClear;
	hasRequired_stackClear = 1;
	var ListCache = require_ListCache();

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}

	_stackClear = stackClear;
	return _stackClear;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

var _stackDelete;
var hasRequired_stackDelete;

function require_stackDelete () {
	if (hasRequired_stackDelete) return _stackDelete;
	hasRequired_stackDelete = 1;
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);

	  this.size = data.size;
	  return result;
	}

	_stackDelete = stackDelete;
	return _stackDelete;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

var _stackGet;
var hasRequired_stackGet;

function require_stackGet () {
	if (hasRequired_stackGet) return _stackGet;
	hasRequired_stackGet = 1;
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	_stackGet = stackGet;
	return _stackGet;
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

var _stackHas;
var hasRequired_stackHas;

function require_stackHas () {
	if (hasRequired_stackHas) return _stackHas;
	hasRequired_stackHas = 1;
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	_stackHas = stackHas;
	return _stackHas;
}

var _stackSet;
var hasRequired_stackSet;

function require_stackSet () {
	if (hasRequired_stackSet) return _stackSet;
	hasRequired_stackSet = 1;
	var ListCache = require_ListCache(),
	    Map = require_Map(),
	    MapCache = require_MapCache();

	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}

	_stackSet = stackSet;
	return _stackSet;
}

var _Stack;
var hasRequired_Stack;

function require_Stack () {
	if (hasRequired_Stack) return _Stack;
	hasRequired_Stack = 1;
	var ListCache = require_ListCache(),
	    stackClear = require_stackClear(),
	    stackDelete = require_stackDelete(),
	    stackGet = require_stackGet(),
	    stackHas = require_stackHas(),
	    stackSet = require_stackSet();

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}

	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;

	_Stack = Stack;
	return _Stack;
}

/** Used to stand-in for `undefined` hash values. */

var _setCacheAdd;
var hasRequired_setCacheAdd;

function require_setCacheAdd () {
	if (hasRequired_setCacheAdd) return _setCacheAdd;
	hasRequired_setCacheAdd = 1;
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}

	_setCacheAdd = setCacheAdd;
	return _setCacheAdd;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

var _setCacheHas;
var hasRequired_setCacheHas;

function require_setCacheHas () {
	if (hasRequired_setCacheHas) return _setCacheHas;
	hasRequired_setCacheHas = 1;
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}

	_setCacheHas = setCacheHas;
	return _setCacheHas;
}

var _SetCache;
var hasRequired_SetCache;

function require_SetCache () {
	if (hasRequired_SetCache) return _SetCache;
	hasRequired_SetCache = 1;
	var MapCache = require_MapCache(),
	    setCacheAdd = require_setCacheAdd(),
	    setCacheHas = require_setCacheHas();

	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;

	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}

	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;

	_SetCache = SetCache;
	return _SetCache;
}

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

var _arraySome;
var hasRequired_arraySome;

function require_arraySome () {
	if (hasRequired_arraySome) return _arraySome;
	hasRequired_arraySome = 1;
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}

	_arraySome = arraySome;
	return _arraySome;
}

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

var _cacheHas;
var hasRequired_cacheHas;

function require_cacheHas () {
	if (hasRequired_cacheHas) return _cacheHas;
	hasRequired_cacheHas = 1;
	function cacheHas(cache, key) {
	  return cache.has(key);
	}

	_cacheHas = cacheHas;
	return _cacheHas;
}

var _equalArrays;
var hasRequired_equalArrays;

function require_equalArrays () {
	if (hasRequired_equalArrays) return _equalArrays;
	hasRequired_equalArrays = 1;
	var SetCache = require_SetCache(),
	    arraySome = require_arraySome(),
	    cacheHas = require_cacheHas();

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;

	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;

	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

	  stack.set(array, other);
	  stack.set(other, array);

	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}

	_equalArrays = equalArrays;
	return _equalArrays;
}

var _Uint8Array;
var hasRequired_Uint8Array;

function require_Uint8Array () {
	if (hasRequired_Uint8Array) return _Uint8Array;
	hasRequired_Uint8Array = 1;
	var root = require_root();

	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;

	_Uint8Array = Uint8Array;
	return _Uint8Array;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

var _mapToArray;
var hasRequired_mapToArray;

function require_mapToArray () {
	if (hasRequired_mapToArray) return _mapToArray;
	hasRequired_mapToArray = 1;
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);

	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	_mapToArray = mapToArray;
	return _mapToArray;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

var _setToArray;
var hasRequired_setToArray;

function require_setToArray () {
	if (hasRequired_setToArray) return _setToArray;
	hasRequired_setToArray = 1;
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}

	_setToArray = setToArray;
	return _setToArray;
}

var _equalByTag;
var hasRequired_equalByTag;

function require_equalByTag () {
	if (hasRequired_equalByTag) return _equalByTag;
	hasRequired_equalByTag = 1;
	var Symbol = require_Symbol(),
	    Uint8Array = require_Uint8Array(),
	    eq = requireEq(),
	    equalArrays = require_equalArrays(),
	    mapToArray = require_mapToArray(),
	    setToArray = require_setToArray();

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;

	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;

	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);

	    case errorTag:
	      return object.name == other.name && object.message == other.message;

	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');

	    case mapTag:
	      var convert = mapToArray;

	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);

	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;

	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;

	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}

	_equalByTag = equalByTag;
	return _equalByTag;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

var _arrayPush;
var hasRequired_arrayPush;

function require_arrayPush () {
	if (hasRequired_arrayPush) return _arrayPush;
	hasRequired_arrayPush = 1;
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}

	_arrayPush = arrayPush;
	return _arrayPush;
}

var _baseGetAllKeys;
var hasRequired_baseGetAllKeys;

function require_baseGetAllKeys () {
	if (hasRequired_baseGetAllKeys) return _baseGetAllKeys;
	hasRequired_baseGetAllKeys = 1;
	var arrayPush = require_arrayPush(),
	    isArray = requireIsArray();

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}

	_baseGetAllKeys = baseGetAllKeys;
	return _baseGetAllKeys;
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

var _arrayFilter;
var hasRequired_arrayFilter;

function require_arrayFilter () {
	if (hasRequired_arrayFilter) return _arrayFilter;
	hasRequired_arrayFilter = 1;
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}

	_arrayFilter = arrayFilter;
	return _arrayFilter;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

var stubArray_1;
var hasRequiredStubArray;

function requireStubArray () {
	if (hasRequiredStubArray) return stubArray_1;
	hasRequiredStubArray = 1;
	function stubArray() {
	  return [];
	}

	stubArray_1 = stubArray;
	return stubArray_1;
}

var _getSymbols;
var hasRequired_getSymbols;

function require_getSymbols () {
	if (hasRequired_getSymbols) return _getSymbols;
	hasRequired_getSymbols = 1;
	var arrayFilter = require_arrayFilter(),
	    stubArray = requireStubArray();

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;

	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};

	_getSymbols = getSymbols;
	return _getSymbols;
}

var _getAllKeys;
var hasRequired_getAllKeys;

function require_getAllKeys () {
	if (hasRequired_getAllKeys) return _getAllKeys;
	hasRequired_getAllKeys = 1;
	var baseGetAllKeys = require_baseGetAllKeys(),
	    getSymbols = require_getSymbols(),
	    keys = requireKeys();

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}

	_getAllKeys = getAllKeys;
	return _getAllKeys;
}

var _equalObjects;
var hasRequired_equalObjects;

function require_equalObjects () {
	if (hasRequired_equalObjects) return _equalObjects;
	hasRequired_equalObjects = 1;
	var getAllKeys = require_getAllKeys();

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;

	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);

	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];

	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;

	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}

	_equalObjects = equalObjects;
	return _equalObjects;
}

var _DataView;
var hasRequired_DataView;

function require_DataView () {
	if (hasRequired_DataView) return _DataView;
	hasRequired_DataView = 1;
	var getNative = require_getNative(),
	    root = require_root();

	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');

	_DataView = DataView;
	return _DataView;
}

var _Promise;
var hasRequired_Promise;

function require_Promise () {
	if (hasRequired_Promise) return _Promise;
	hasRequired_Promise = 1;
	var getNative = require_getNative(),
	    root = require_root();

	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');

	_Promise = Promise;
	return _Promise;
}

var _Set;
var hasRequired_Set;

function require_Set () {
	if (hasRequired_Set) return _Set;
	hasRequired_Set = 1;
	var getNative = require_getNative(),
	    root = require_root();

	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');

	_Set = Set;
	return _Set;
}

var _WeakMap;
var hasRequired_WeakMap;

function require_WeakMap () {
	if (hasRequired_WeakMap) return _WeakMap;
	hasRequired_WeakMap = 1;
	var getNative = require_getNative(),
	    root = require_root();

	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');

	_WeakMap = WeakMap;
	return _WeakMap;
}

var _getTag;
var hasRequired_getTag;

function require_getTag () {
	if (hasRequired_getTag) return _getTag;
	hasRequired_getTag = 1;
	var DataView = require_DataView(),
	    Map = require_Map(),
	    Promise = require_Promise(),
	    Set = require_Set(),
	    WeakMap = require_WeakMap(),
	    baseGetTag = require_baseGetTag(),
	    toSource = require_toSource();

	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';

	var dataViewTag = '[object DataView]';

	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);

	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;

	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}

	_getTag = getTag;
	return _getTag;
}

var _baseIsEqualDeep;
var hasRequired_baseIsEqualDeep;

function require_baseIsEqualDeep () {
	if (hasRequired_baseIsEqualDeep) return _baseIsEqualDeep;
	hasRequired_baseIsEqualDeep = 1;
	var Stack = require_Stack(),
	    equalArrays = require_equalArrays(),
	    equalByTag = require_equalByTag(),
	    equalObjects = require_equalObjects(),
	    getTag = require_getTag(),
	    isArray = requireIsArray(),
	    isBuffer = requireIsBuffer(),
	    isTypedArray = requireIsTypedArray();

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);

	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;

	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;

	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;

	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}

	_baseIsEqualDeep = baseIsEqualDeep;
	return _baseIsEqualDeep;
}

var _baseIsEqual;
var hasRequired_baseIsEqual;

function require_baseIsEqual () {
	if (hasRequired_baseIsEqual) return _baseIsEqual;
	hasRequired_baseIsEqual = 1;
	var baseIsEqualDeep = require_baseIsEqualDeep(),
	    isObjectLike = requireIsObjectLike();

	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}

	_baseIsEqual = baseIsEqual;
	return _baseIsEqual;
}

var _baseIsMatch;
var hasRequired_baseIsMatch;

function require_baseIsMatch () {
	if (hasRequired_baseIsMatch) return _baseIsMatch;
	hasRequired_baseIsMatch = 1;
	var Stack = require_Stack(),
	    baseIsEqual = require_baseIsEqual();

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;

	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;

	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];

	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}

	_baseIsMatch = baseIsMatch;
	return _baseIsMatch;
}

var _isStrictComparable;
var hasRequired_isStrictComparable;

function require_isStrictComparable () {
	if (hasRequired_isStrictComparable) return _isStrictComparable;
	hasRequired_isStrictComparable = 1;
	var isObject = requireIsObject();

	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}

	_isStrictComparable = isStrictComparable;
	return _isStrictComparable;
}

var _getMatchData;
var hasRequired_getMatchData;

function require_getMatchData () {
	if (hasRequired_getMatchData) return _getMatchData;
	hasRequired_getMatchData = 1;
	var isStrictComparable = require_isStrictComparable(),
	    keys = requireKeys();

	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;

	  while (length--) {
	    var key = result[length],
	        value = object[key];

	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}

	_getMatchData = getMatchData;
	return _getMatchData;
}

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

var _matchesStrictComparable;
var hasRequired_matchesStrictComparable;

function require_matchesStrictComparable () {
	if (hasRequired_matchesStrictComparable) return _matchesStrictComparable;
	hasRequired_matchesStrictComparable = 1;
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}

	_matchesStrictComparable = matchesStrictComparable;
	return _matchesStrictComparable;
}

var _baseMatches;
var hasRequired_baseMatches;

function require_baseMatches () {
	if (hasRequired_baseMatches) return _baseMatches;
	hasRequired_baseMatches = 1;
	var baseIsMatch = require_baseIsMatch(),
	    getMatchData = require_getMatchData(),
	    matchesStrictComparable = require_matchesStrictComparable();

	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}

	_baseMatches = baseMatches;
	return _baseMatches;
}

var _baseGet;
var hasRequired_baseGet;

function require_baseGet () {
	if (hasRequired_baseGet) return _baseGet;
	hasRequired_baseGet = 1;
	var castPath = require_castPath(),
	    toKey = require_toKey();

	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);

	  var index = 0,
	      length = path.length;

	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}

	_baseGet = baseGet;
	return _baseGet;
}

var get_1;
var hasRequiredGet;

function requireGet () {
	if (hasRequiredGet) return get_1;
	hasRequiredGet = 1;
	var baseGet = require_baseGet();

	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}

	get_1 = get;
	return get_1;
}

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

var _baseHasIn;
var hasRequired_baseHasIn;

function require_baseHasIn () {
	if (hasRequired_baseHasIn) return _baseHasIn;
	hasRequired_baseHasIn = 1;
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}

	_baseHasIn = baseHasIn;
	return _baseHasIn;
}

var hasIn_1;
var hasRequiredHasIn;

function requireHasIn () {
	if (hasRequiredHasIn) return hasIn_1;
	hasRequiredHasIn = 1;
	var baseHasIn = require_baseHasIn(),
	    hasPath = require_hasPath();

	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}

	hasIn_1 = hasIn;
	return hasIn_1;
}

var _baseMatchesProperty;
var hasRequired_baseMatchesProperty;

function require_baseMatchesProperty () {
	if (hasRequired_baseMatchesProperty) return _baseMatchesProperty;
	hasRequired_baseMatchesProperty = 1;
	var baseIsEqual = require_baseIsEqual(),
	    get = requireGet(),
	    hasIn = requireHasIn(),
	    isKey = require_isKey(),
	    isStrictComparable = require_isStrictComparable(),
	    matchesStrictComparable = require_matchesStrictComparable(),
	    toKey = require_toKey();

	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;

	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}

	_baseMatchesProperty = baseMatchesProperty;
	return _baseMatchesProperty;
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

var identity_1;
var hasRequiredIdentity;

function requireIdentity () {
	if (hasRequiredIdentity) return identity_1;
	hasRequiredIdentity = 1;
	function identity(value) {
	  return value;
	}

	identity_1 = identity;
	return identity_1;
}

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

var _baseProperty;
var hasRequired_baseProperty;

function require_baseProperty () {
	if (hasRequired_baseProperty) return _baseProperty;
	hasRequired_baseProperty = 1;
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}

	_baseProperty = baseProperty;
	return _baseProperty;
}

var _basePropertyDeep;
var hasRequired_basePropertyDeep;

function require_basePropertyDeep () {
	if (hasRequired_basePropertyDeep) return _basePropertyDeep;
	hasRequired_basePropertyDeep = 1;
	var baseGet = require_baseGet();

	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}

	_basePropertyDeep = basePropertyDeep;
	return _basePropertyDeep;
}

var property_1;
var hasRequiredProperty;

function requireProperty () {
	if (hasRequiredProperty) return property_1;
	hasRequiredProperty = 1;
	var baseProperty = require_baseProperty(),
	    basePropertyDeep = require_basePropertyDeep(),
	    isKey = require_isKey(),
	    toKey = require_toKey();

	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}

	property_1 = property;
	return property_1;
}

var _baseIteratee;
var hasRequired_baseIteratee;

function require_baseIteratee () {
	if (hasRequired_baseIteratee) return _baseIteratee;
	hasRequired_baseIteratee = 1;
	var baseMatches = require_baseMatches(),
	    baseMatchesProperty = require_baseMatchesProperty(),
	    identity = requireIdentity(),
	    isArray = requireIsArray(),
	    property = requireProperty();

	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}

	_baseIteratee = baseIteratee;
	return _baseIteratee;
}

var mapValues_1;
var hasRequiredMapValues;

function requireMapValues () {
	if (hasRequiredMapValues) return mapValues_1;
	hasRequiredMapValues = 1;
	var baseAssignValue = require_baseAssignValue(),
	    baseForOwn = require_baseForOwn(),
	    baseIteratee = require_baseIteratee();

	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);

	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}

	mapValues_1 = mapValues;
	return mapValues_1;
}

var mapValuesExports = requireMapValues();
var mapValues = /*@__PURE__*/getDefaultExportFromCjs(mapValuesExports);

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */

var propertyExpr;
var hasRequiredPropertyExpr;

function requirePropertyExpr () {
	if (hasRequiredPropertyExpr) return propertyExpr;
	hasRequiredPropertyExpr = 1;

	function Cache(maxSize) {
	  this._maxSize = maxSize;
	  this.clear();
	}
	Cache.prototype.clear = function () {
	  this._size = 0;
	  this._values = Object.create(null);
	};
	Cache.prototype.get = function (key) {
	  return this._values[key]
	};
	Cache.prototype.set = function (key, value) {
	  this._size >= this._maxSize && this.clear();
	  if (!(key in this._values)) this._size++;

	  return (this._values[key] = value)
	};

	var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
	  DIGIT_REGEX = /^\d+$/,
	  LEAD_DIGIT_REGEX = /^\d/,
	  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
	  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
	  MAX_CACHE_SIZE = 512;

	var pathCache = new Cache(MAX_CACHE_SIZE),
	  setCache = new Cache(MAX_CACHE_SIZE),
	  getCache = new Cache(MAX_CACHE_SIZE);

	propertyExpr = {
	  Cache: Cache,

	  split: split,

	  normalizePath: normalizePath,

	  setter: function (path) {
	    var parts = normalizePath(path);

	    return (
	      setCache.get(path) ||
	      setCache.set(path, function setter(obj, value) {
	        var index = 0;
	        var len = parts.length;
	        var data = obj;

	        while (index < len - 1) {
	          var part = parts[index];
	          if (
	            part === '__proto__' ||
	            part === 'constructor' ||
	            part === 'prototype'
	          ) {
	            return obj
	          }

	          data = data[parts[index++]];
	        }
	        data[parts[index]] = value;
	      })
	    )
	  },

	  getter: function (path, safe) {
	    var parts = normalizePath(path);
	    return (
	      getCache.get(path) ||
	      getCache.set(path, function getter(data) {
	        var index = 0,
	          len = parts.length;
	        while (index < len) {
	          if (data != null || !safe) data = data[parts[index++]];
	          else return
	        }
	        return data
	      })
	    )
	  },

	  join: function (segments) {
	    return segments.reduce(function (path, part) {
	      return (
	        path +
	        (isQuoted(part) || DIGIT_REGEX.test(part)
	          ? '[' + part + ']'
	          : (path ? '.' : '') + part)
	      )
	    }, '')
	  },

	  forEach: function (path, cb, thisArg) {
	    forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
	  },
	};

	function normalizePath(path) {
	  return (
	    pathCache.get(path) ||
	    pathCache.set(
	      path,
	      split(path).map(function (part) {
	        return part.replace(CLEAN_QUOTES_REGEX, '$2')
	      })
	    )
	  )
	}

	function split(path) {
	  return path.match(SPLIT_REGEX) || ['']
	}

	function forEach(parts, iter, thisArg) {
	  var len = parts.length,
	    part,
	    idx,
	    isArray,
	    isBracket;

	  for (idx = 0; idx < len; idx++) {
	    part = parts[idx];

	    if (part) {
	      if (shouldBeQuoted(part)) {
	        part = '"' + part + '"';
	      }

	      isBracket = isQuoted(part);
	      isArray = !isBracket && /^\d+$/.test(part);

	      iter.call(thisArg, part, isBracket, isArray, idx, parts);
	    }
	  }
	}

	function isQuoted(str) {
	  return (
	    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
	  )
	}

	function hasLeadingNumber(part) {
	  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
	}

	function hasSpecialChars(part) {
	  return SPEC_CHAR_REGEX.test(part)
	}

	function shouldBeQuoted(part) {
	  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
	}
	return propertyExpr;
}

var propertyExprExports = requirePropertyExpr();

const prefixes = {
  context: '$',
  value: '.'
};
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExprExports.getter(this.path, true);
    this.map = options.map;
  }

  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */


  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }

  resolve() {
    return this;
  }

  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }

  toString() {
    return `Ref(${this.key})`;
  }

  static isRef(value) {
    return value && value.__isYupRef;
  }

} // @ts-ignore

Reference.prototype.__isYupRef = true;

function _extends$1C() { _extends$1C = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }

function _objectWithoutPropertiesLoose$1A(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = '',
      label,
      options,
      originalValue,
      sync
    } = _ref,
        rest = _objectWithoutPropertiesLoose$1A(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;

    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }

    function createError(overrides = {}) {
      const nextParams = mapValues(_extends$1C({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }

    let ctx = _extends$1C({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);

    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(validOrError => {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        }).catch(cb);
      } catch (err) {
        cb(err);
      }

      return;
    }

    let result;

    try {
      var _ref2;

      result = test.call(ctx, value, ctx);

      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }

    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }

  validate.OPTIONS = config;
  return validate;
}

let trim = part => part.substr(0, part.length - 1).substr(1);

function getIn$1(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  propertyExprExports.forEach(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });

    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

class ReferenceSet {
  constructor() {
    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }

  get size() {
    return this.list.size + this.refs.size;
  }

  describe() {
    const description = [];

    for (const item of this.list) description.push(item);

    for (const [, ref] of this.refs) description.push(ref.describe());

    return description;
  }

  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }

  resolveAll(resolve) {
    return this.toArray().reduce((acc, e) => acc.concat(Reference.isRef(e) ? resolve(e) : e), []);
  }

  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }

  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }

  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }

  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach(value => next.add(value));
    newItems.refs.forEach(value => next.add(value));
    removeItems.list.forEach(value => next.delete(value));
    removeItems.refs.forEach(value => next.delete(value));
    return next;
  }

}

function _extends$1B() { _extends$1B = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }

class BaseSchema {
  constructor(options) {
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = _extends$1B({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove


  get _type() {
    return this.type;
  }

  _typeCheck(_value) {
    return true;
  }

  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    } // if the nested value is a schema we can skip cloning, since
    // they are already immutable


    const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = _extends$1B({}, this.exclusiveTests); // @ts-expect-error this is readonly

    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone$1(_extends$1B({}, this.spec, spec));
    return next;
  }

  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }

  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  } // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }


  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }

  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();

    const mergedSpec = _extends$1B({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
    //   mergedSpec.nullable = base.spec.nullable;
    // if (combined.spec.presence === UNSET)
    //   mergedSpec.presence = base.spec.presence;


    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)

    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
    // the deduping logic is consistent

    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }

  isType(v) {
    if (this.spec.nullable && v === null) return true;
    return this._typeCheck(v);
  }

  resolve(options) {
    let schema = this;

    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema, condition) => condition.resolve(schema, options), schema);
      schema = schema.resolve(options);
    }

    return schema;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */


  cast(value, options = {}) {
    let resolvedSchema = this.resolve(_extends$1B({
      value
    }, options));

    let result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }

    return result;
  }

  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn) => fn.call(this, value, rawValue, this), rawValue);

    if (value === undefined) {
      value = this.getDefault();
    }

    return value;
  }

  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;

    if (!strict) {
      // this._validating = true;
      value = this._cast(value, _extends$1B({
        assert: false
      }, options)); // this._validating = false;
    } // value is cast, we can check if it meets type requirements


    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError) initialTests.push(this._typeError);
    let finalTests = [];
    if (this._whitelistError) finalTests.push(this._whitelistError);
    if (this._blacklistError) finalTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      tests: initialTests,
      endEarly: abortEarly
    }, err => {
      if (err) return void cb(err, value);
      runTests({
        tests: this.tests.concat(finalTests),
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }

  validate(value, options, maybeCb) {
    let schema = this.resolve(_extends$1B({}, options, {
      value
    })); // callback case is for nested validations

    return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value) => {
      if (err) reject(err);else resolve(value);
    }));
  }

  validateSync(value, options) {
    let schema = this.resolve(_extends$1B({}, options, {
      value
    }));
    let result;

    schema._validate(value, _extends$1B({}, options, {
      sync: true
    }), (err, value) => {
      if (err) throw err;
      result = value;
    });

    return result;
  }

  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }

  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }

  _getDefault() {
    let defaultValue = this.spec.default;

    if (defaultValue == null) {
      return defaultValue;
    }

    return typeof defaultValue === 'function' ? defaultValue.call(this) : clone$1(defaultValue);
  }

  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }

  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }

    let next = this.clone({
      default: def
    });
    return next;
  }

  strict(isStrict = true) {
    let next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }

  _isPresent(value) {
    return value != null;
  }

  defined(message = mixed.defined) {
    return this.test({
      message,
      name: 'defined',
      exclusive: true,

      test(value) {
        return value !== undefined;
      }

    });
  }

  required(message = mixed.required) {
    return this.clone({
      presence: 'required'
    }).withMutation(s => s.test({
      message,
      name: 'required',
      exclusive: true,

      test(value) {
        return this.schema._isPresent(value);
      }

    }));
  }

  notRequired() {
    let next = this.clone({
      presence: 'optional'
    });
    next.tests = next.tests.filter(test => test.OPTIONS.name !== 'required');
    return next;
  }

  nullable(isNullable = true) {
    let next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }

  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */


  test(...args) {
    let opts;

    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }

    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;

    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  }

  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }

    let next = this.clone();
    let deps = toArray$1(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(new Condition(deps, options));
    return next;
  }

  typeError(message) {
    let next = this.clone();
    next._typeError = createValidation({
      message,
      name: 'typeError',

      test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }

    });
    return next;
  }

  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: 'oneOf',

      test(value) {
        if (value === undefined) return true;
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: valids.toArray().join(', '),
            resolved
          }
        });
      }

    });
    return next;
  }

  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: 'notOneOf',

      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: invalids.toArray().join(', '),
            resolved
          }
        });
        return true;
      }

    });
    return next;
  }

  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }

} // eslint-disable-next-line @typescript-eslint/no-unused-vars

// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;

for (const method of ['validate', 'validateSync']) BaseSchema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn$1(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], _extends$1B({}, options, {
    parent,
    path
  }));
};

for (const alias of ['equals', 'is']) BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;

for (const alias of ['not', 'nope']) BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;

BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;

const isAbsent = value => value == null;

function create$3() {
  return new BooleanSchema();
}
class BooleanSchema extends BaseSchema {
  constructor() {
    super({
      type: 'boolean'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (!this.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }

        return value;
      });
    });
  }

  _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }

  isTrue(message = boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'true'
      },

      test(value) {
        return isAbsent(value) || value === true;
      }

    });
  }

  isFalse(message = boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'false'
      },

      test(value) {
        return isAbsent(value) || value === false;
      }

    });
  }

}
create$3.prototype = BooleanSchema.prototype;

let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

let isTrimmed = value => isAbsent(value) || value === value.trim();

let objStringTag = {}.toString();
function create$2() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: 'string'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  }

  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }

  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;

    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }

    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      test: value => isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }

  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }

  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }

  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  } //-- transforms --


  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }

  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }

  lowercase(message = string.lowercase) {
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }

  uppercase(message = string.uppercase) {
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }

}
create$2.prototype = StringSchema.prototype; //
// String Interfaces
//

/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) struct[k] = +struct[k] || 0; // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}

// @ts-ignore
let invalidDate = new Date('');

let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';
class DateSchema extends BaseSchema {
  constructor() {
    super({
      type: 'date'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        value = parseIsoDate(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.

        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
  }

  _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  }

  prepareParam(ref, name) {
    let param;

    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }

    return param;
  }

  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return isAbsent(value) || value >= this.resolve(limit);
      }

    });
  }

  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value <= this.resolve(limit);
      }

    });
  }

}
DateSchema.INVALID_DATE = invalidDate;

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */

var _arrayReduce;
var hasRequired_arrayReduce;

function require_arrayReduce () {
	if (hasRequired_arrayReduce) return _arrayReduce;
	hasRequired_arrayReduce = 1;
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}

	_arrayReduce = arrayReduce;
	return _arrayReduce;
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */

var _basePropertyOf;
var hasRequired_basePropertyOf;

function require_basePropertyOf () {
	if (hasRequired_basePropertyOf) return _basePropertyOf;
	hasRequired_basePropertyOf = 1;
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}

	_basePropertyOf = basePropertyOf;
	return _basePropertyOf;
}

var _deburrLetter;
var hasRequired_deburrLetter;

function require_deburrLetter () {
	if (hasRequired_deburrLetter) return _deburrLetter;
	hasRequired_deburrLetter = 1;
	var basePropertyOf = require_basePropertyOf();

	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};

	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);

	_deburrLetter = deburrLetter;
	return _deburrLetter;
}

var deburr_1;
var hasRequiredDeburr;

function requireDeburr () {
	if (hasRequiredDeburr) return deburr_1;
	hasRequiredDeburr = 1;
	var deburrLetter = require_deburrLetter(),
	    toString = requireToString();

	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';

	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');

	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}

	deburr_1 = deburr;
	return deburr_1;
}

/** Used to match words composed of alphanumeric characters. */

var _asciiWords;
var hasRequired_asciiWords;

function require_asciiWords () {
	if (hasRequired_asciiWords) return _asciiWords;
	hasRequired_asciiWords = 1;
	var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

	/**
	 * Splits an ASCII `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function asciiWords(string) {
	  return string.match(reAsciiWord) || [];
	}

	_asciiWords = asciiWords;
	return _asciiWords;
}

/** Used to detect strings that need a more robust regexp to match words. */

var _hasUnicodeWord;
var hasRequired_hasUnicodeWord;

function require_hasUnicodeWord () {
	if (hasRequired_hasUnicodeWord) return _hasUnicodeWord;
	hasRequired_hasUnicodeWord = 1;
	var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

	/**
	 * Checks if `string` contains a word composed of Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a word is found, else `false`.
	 */
	function hasUnicodeWord(string) {
	  return reHasUnicodeWord.test(string);
	}

	_hasUnicodeWord = hasUnicodeWord;
	return _hasUnicodeWord;
}

/** Used to compose unicode character classes. */

var _unicodeWords;
var hasRequired_unicodeWords;

function require_unicodeWords () {
	if (hasRequired_unicodeWords) return _unicodeWords;
	hasRequired_unicodeWords = 1;
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsDingbatRange = '\\u2700-\\u27bf',
	    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	    rsPunctuationRange = '\\u2000-\\u206f',
	    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	    rsVarRange = '\\ufe0e\\ufe0f',
	    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]",
	    rsBreak = '[' + rsBreakRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsDigits = '\\d+',
	    rsDingbat = '[' + rsDingbatRange + ']',
	    rsLower = '[' + rsLowerRange + ']',
	    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsUpper = '[' + rsUpperRange + ']',
	    rsZWJ = '\\u200d';

	/** Used to compose unicode regexes. */
	var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	    reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

	/** Used to match complex or compound words. */
	var reUnicodeWord = RegExp([
	  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	  rsUpper + '+' + rsOptContrUpper,
	  rsOrdUpper,
	  rsOrdLower,
	  rsDigits,
	  rsEmoji
	].join('|'), 'g');

	/**
	 * Splits a Unicode `string` into an array of its words.
	 *
	 * @private
	 * @param {string} The string to inspect.
	 * @returns {Array} Returns the words of `string`.
	 */
	function unicodeWords(string) {
	  return string.match(reUnicodeWord) || [];
	}

	_unicodeWords = unicodeWords;
	return _unicodeWords;
}

var words_1;
var hasRequiredWords;

function requireWords () {
	if (hasRequiredWords) return words_1;
	hasRequiredWords = 1;
	var asciiWords = require_asciiWords(),
	    hasUnicodeWord = require_hasUnicodeWord(),
	    toString = requireToString(),
	    unicodeWords = require_unicodeWords();

	/**
	 * Splits `string` into an array of its words.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {RegExp|string} [pattern] The pattern to match words.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the words of `string`.
	 * @example
	 *
	 * _.words('fred, barney, & pebbles');
	 * // => ['fred', 'barney', 'pebbles']
	 *
	 * _.words('fred, barney, & pebbles', /[^, ]+/g);
	 * // => ['fred', 'barney', '&', 'pebbles']
	 */
	function words(string, pattern, guard) {
	  string = toString(string);
	  pattern = guard ? undefined : pattern;

	  if (pattern === undefined) {
	    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	  }
	  return string.match(pattern) || [];
	}

	words_1 = words;
	return words_1;
}

var _createCompounder;
var hasRequired_createCompounder;

function require_createCompounder () {
	if (hasRequired_createCompounder) return _createCompounder;
	hasRequired_createCompounder = 1;
	var arrayReduce = require_arrayReduce(),
	    deburr = requireDeburr(),
	    words = requireWords();

	/** Used to compose unicode capture groups. */
	var rsApos = "['\u2019]";

	/** Used to match apostrophes. */
	var reApos = RegExp(rsApos, 'g');

	/**
	 * Creates a function like `_.camelCase`.
	 *
	 * @private
	 * @param {Function} callback The function to combine each word.
	 * @returns {Function} Returns the new compounder function.
	 */
	function createCompounder(callback) {
	  return function(string) {
	    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	  };
	}

	_createCompounder = createCompounder;
	return _createCompounder;
}

var snakeCase_1;
var hasRequiredSnakeCase;

function requireSnakeCase () {
	if (hasRequiredSnakeCase) return snakeCase_1;
	hasRequiredSnakeCase = 1;
	var createCompounder = require_createCompounder();

	/**
	 * Converts `string` to
	 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the snake cased string.
	 * @example
	 *
	 * _.snakeCase('Foo Bar');
	 * // => 'foo_bar'
	 *
	 * _.snakeCase('fooBar');
	 * // => 'foo_bar'
	 *
	 * _.snakeCase('--FOO-BAR--');
	 * // => 'foo_bar'
	 */
	var snakeCase = createCompounder(function(result, word, index) {
	  return result + (index ? '_' : '') + word.toLowerCase();
	});

	snakeCase_1 = snakeCase;
	return snakeCase_1;
}

var snakeCaseExports = requireSnakeCase();
var snakeCase = /*@__PURE__*/getDefaultExportFromCjs(snakeCaseExports);

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

var _baseSlice;
var hasRequired_baseSlice;

function require_baseSlice () {
	if (hasRequired_baseSlice) return _baseSlice;
	hasRequired_baseSlice = 1;
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;

	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;

	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}

	_baseSlice = baseSlice;
	return _baseSlice;
}

var _castSlice;
var hasRequired_castSlice;

function require_castSlice () {
	if (hasRequired_castSlice) return _castSlice;
	hasRequired_castSlice = 1;
	var baseSlice = require_baseSlice();

	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}

	_castSlice = castSlice;
	return _castSlice;
}

/** Used to compose unicode character classes. */

var _hasUnicode;
var hasRequired_hasUnicode;

function require_hasUnicode () {
	if (hasRequired_hasUnicode) return _hasUnicode;
	hasRequired_hasUnicode = 1;
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';

	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';

	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}

	_hasUnicode = hasUnicode;
	return _hasUnicode;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

var _asciiToArray;
var hasRequired_asciiToArray;

function require_asciiToArray () {
	if (hasRequired_asciiToArray) return _asciiToArray;
	hasRequired_asciiToArray = 1;
	function asciiToArray(string) {
	  return string.split('');
	}

	_asciiToArray = asciiToArray;
	return _asciiToArray;
}

/** Used to compose unicode character classes. */

var _unicodeToArray;
var hasRequired_unicodeToArray;

function require_unicodeToArray () {
	if (hasRequired_unicodeToArray) return _unicodeToArray;
	hasRequired_unicodeToArray = 1;
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';

	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';

	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}

	_unicodeToArray = unicodeToArray;
	return _unicodeToArray;
}

var _stringToArray;
var hasRequired_stringToArray;

function require_stringToArray () {
	if (hasRequired_stringToArray) return _stringToArray;
	hasRequired_stringToArray = 1;
	var asciiToArray = require_asciiToArray(),
	    hasUnicode = require_hasUnicode(),
	    unicodeToArray = require_unicodeToArray();

	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}

	_stringToArray = stringToArray;
	return _stringToArray;
}

var _createCaseFirst;
var hasRequired_createCaseFirst;

function require_createCaseFirst () {
	if (hasRequired_createCaseFirst) return _createCaseFirst;
	hasRequired_createCaseFirst = 1;
	var castSlice = require_castSlice(),
	    hasUnicode = require_hasUnicode(),
	    stringToArray = require_stringToArray(),
	    toString = requireToString();

	/**
	 * Creates a function like `_.lowerFirst`.
	 *
	 * @private
	 * @param {string} methodName The name of the `String` case method to use.
	 * @returns {Function} Returns the new case function.
	 */
	function createCaseFirst(methodName) {
	  return function(string) {
	    string = toString(string);

	    var strSymbols = hasUnicode(string)
	      ? stringToArray(string)
	      : undefined;

	    var chr = strSymbols
	      ? strSymbols[0]
	      : string.charAt(0);

	    var trailing = strSymbols
	      ? castSlice(strSymbols, 1).join('')
	      : string.slice(1);

	    return chr[methodName]() + trailing;
	  };
	}

	_createCaseFirst = createCaseFirst;
	return _createCaseFirst;
}

var upperFirst_1;
var hasRequiredUpperFirst;

function requireUpperFirst () {
	if (hasRequiredUpperFirst) return upperFirst_1;
	hasRequiredUpperFirst = 1;
	var createCaseFirst = require_createCaseFirst();

	/**
	 * Converts the first character of `string` to upper case.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.upperFirst('fred');
	 * // => 'Fred'
	 *
	 * _.upperFirst('FRED');
	 * // => 'FRED'
	 */
	var upperFirst = createCaseFirst('toUpperCase');

	upperFirst_1 = upperFirst;
	return upperFirst_1;
}

var capitalize_1;
var hasRequiredCapitalize;

function requireCapitalize () {
	if (hasRequiredCapitalize) return capitalize_1;
	hasRequiredCapitalize = 1;
	var toString = requireToString(),
	    upperFirst = requireUpperFirst();

	/**
	 * Converts the first character of `string` to upper case and the remaining
	 * to lower case.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to capitalize.
	 * @returns {string} Returns the capitalized string.
	 * @example
	 *
	 * _.capitalize('FRED');
	 * // => 'Fred'
	 */
	function capitalize(string) {
	  return upperFirst(toString(string).toLowerCase());
	}

	capitalize_1 = capitalize;
	return capitalize_1;
}

var camelCase_1;
var hasRequiredCamelCase;

function requireCamelCase () {
	if (hasRequiredCamelCase) return camelCase_1;
	hasRequiredCamelCase = 1;
	var capitalize = requireCapitalize(),
	    createCompounder = require_createCompounder();

	/**
	 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the camel cased string.
	 * @example
	 *
	 * _.camelCase('Foo Bar');
	 * // => 'fooBar'
	 *
	 * _.camelCase('--foo-bar--');
	 * // => 'fooBar'
	 *
	 * _.camelCase('__FOO_BAR__');
	 * // => 'fooBar'
	 */
	var camelCase = createCompounder(function(result, word, index) {
	  word = word.toLowerCase();
	  return result + (index ? capitalize(word) : word);
	});

	camelCase_1 = camelCase;
	return camelCase_1;
}

var camelCaseExports = requireCamelCase();
var camelCase = /*@__PURE__*/getDefaultExportFromCjs(camelCaseExports);

var mapKeys_1;
var hasRequiredMapKeys;

function requireMapKeys () {
	if (hasRequiredMapKeys) return mapKeys_1;
	hasRequiredMapKeys = 1;
	var baseAssignValue = require_baseAssignValue(),
	    baseForOwn = require_baseForOwn(),
	    baseIteratee = require_baseIteratee();

	/**
	 * The opposite of `_.mapValues`; this method creates an object with the
	 * same values as `object` and keys generated by running each own enumerable
	 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	 * with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.8.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapValues
	 * @example
	 *
	 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   return key + value;
	 * });
	 * // => { 'a1': 1, 'b2': 2 }
	 */
	function mapKeys(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);

	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, iteratee(value, key, object), value);
	  });
	  return result;
	}

	mapKeys_1 = mapKeys;
	return mapKeys_1;
}

var mapKeysExports = requireMapKeys();
var mapKeys = /*@__PURE__*/getDefaultExportFromCjs(mapKeysExports);

var toposort$1 = {exports: {}};

var hasRequiredToposort;

function requireToposort () {
	if (hasRequiredToposort) return toposort$1.exports;
	hasRequiredToposort = 1;
	/**
	 * Topological sorting function
	 *
	 * @param {Array} edges
	 * @returns {Array}
	 */

	toposort$1.exports = function(edges) {
	  return toposort(uniqueNodes(edges), edges)
	};

	toposort$1.exports.array = toposort;

	function toposort(nodes, edges) {
	  var cursor = nodes.length
	    , sorted = new Array(cursor)
	    , visited = {}
	    , i = cursor
	    // Better data structures make algorithm much faster.
	    , outgoingEdges = makeOutgoingEdges(edges)
	    , nodesHash = makeNodesHash(nodes);

	  // check for unknown nodes
	  edges.forEach(function(edge) {
	    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
	      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
	    }
	  });

	  while (i--) {
	    if (!visited[i]) visit(nodes[i], i, new Set());
	  }

	  return sorted

	  function visit(node, i, predecessors) {
	    if(predecessors.has(node)) {
	      var nodeRep;
	      try {
	        nodeRep = ", node was:" + JSON.stringify(node);
	      } catch(e) {
	        nodeRep = "";
	      }
	      throw new Error('Cyclic dependency' + nodeRep)
	    }

	    if (!nodesHash.has(node)) {
	      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
	    }

	    if (visited[i]) return;
	    visited[i] = true;

	    var outgoing = outgoingEdges.get(node) || new Set();
	    outgoing = Array.from(outgoing);

	    if (i = outgoing.length) {
	      predecessors.add(node);
	      do {
	        var child = outgoing[--i];
	        visit(child, nodesHash.get(child), predecessors);
	      } while (i)
	      predecessors.delete(node);
	    }

	    sorted[--cursor] = node;
	  }
	}

	function uniqueNodes(arr){
	  var res = new Set();
	  for (var i = 0, len = arr.length; i < len; i++) {
	    var edge = arr[i];
	    res.add(edge[0]);
	    res.add(edge[1]);
	  }
	  return Array.from(res)
	}

	function makeOutgoingEdges(arr){
	  var edges = new Map();
	  for (var i = 0, len = arr.length; i < len; i++) {
	    var edge = arr[i];
	    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
	    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
	    edges.get(edge[0]).add(edge[1]);
	  }
	  return edges
	}

	function makeNodesHash(arr){
	  var res = new Map();
	  for (var i = 0, len = arr.length; i < len; i++) {
	    res.set(arr[i], i);
	  }
	  return res
	}
	return toposort$1.exports;
}

var toposortExports = requireToposort();
var toposort = /*@__PURE__*/getDefaultExportFromCjs(toposortExports);

function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));

  function addNode(depPath, key) {
    let node = propertyExprExports.split(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }

  for (const key in fields) if (has$1(fields, key)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }

  return toposort.array(Array.from(nodes), edges).reverse();
}

function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;

    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

function _extends$1A() { _extends$1A = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }

let isObject$2 = obj => Object.prototype.toString.call(obj) === '[object Object]';

function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}

const defaultSort = sortByKeyOrder([]);
class ObjectSchema extends BaseSchema {
  constructor(spec) {
    super({
      type: 'object'
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      this.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }

        if (this.isType(value)) return value;
        return null;
      });

      if (spec) {
        this.shape(spec);
      }
    });
  }

  _typeCheck(value) {
    return isObject$2(value) || typeof value === 'function';
  }

  _cast(_value, options = {}) {
    var _options$stripUnknown;

    let value = super._cast(_value, options); //should ignore nulls here


    if (value === undefined) return this.getDefault();
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;

    let props = this._nodes.concat(Object.keys(value).filter(v => this._nodes.indexOf(v) === -1));

    let intermediateValue = {}; // is filled during the transform below

    let innerOptions = _extends$1A({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });

    let isChanged = false;

    for (const prop of props) {
      let field = fields[prop];
      let exists = has$1(value, prop);

      if (field) {
        let fieldValue;
        let inputValue = value[prop]; // safe to mutate since this is fired in sequence

        innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];

        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = 'spec' in field ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;

        if (fieldSpec == null ? void 0 : fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }

        fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];

        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }

      if (intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }

    return isChanged ? intermediateValue : value;
  }

  _validate(_value, opts = {}, callback) {
    let errors = [];
    let {
      sync,
      from = [],
      originalValue = _value,
      abortEarly = this.spec.abortEarly,
      recursive = this.spec.recursive
    } = opts;
    from = [{
      schema: this,
      value: originalValue
    }, ...from]; // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating

    opts.__validating = true;
    opts.originalValue = originalValue;
    opts.from = from;

    super._validate(_value, opts, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || abortEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !isObject$2(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value;

      let tests = this._nodes.map(key => (_, cb) => {
        let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
        let field = this.fields[key];

        if (field && 'validate' in field) {
          field.validate(value[key], _extends$1A({}, opts, {
            // @ts-ignore
            path,
            from,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: true,
            parent: value,
            originalValue: originalValue[key]
          }), cb);
          return;
        }

        cb(null);
      });

      runTests({
        tests,
        value,
        errors,
        endEarly: abortEarly,
        sort: this._sortErrors,
        path: opts.path
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.fields = _extends$1A({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;

    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];

      if (target === undefined) {
        nextFields[field] = schemaOrRef;
      } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
        nextFields[field] = schemaOrRef.concat(target);
      }
    }

    return next.withMutation(() => next.shape(nextFields, this._excludedEdges));
  }

  getDefaultFromShape() {
    let dft = {};

    this._nodes.forEach(key => {
      const field = this.fields[key];
      dft[key] = 'default' in field ? field.getDefault() : undefined;
    });

    return dft;
  }

  _getDefault() {
    if ('default' in this.spec) {
      return super._getDefault();
    } // if there is no default set invent one


    if (!this._nodes.length) {
      return undefined;
    }

    return this.getDefaultFromShape();
  }

  shape(additions, excludes = []) {
    let next = this.clone();
    let fields = Object.assign(next.fields, additions);
    next.fields = fields;
    next._sortErrors = sortByKeyOrder(Object.keys(fields));

    if (excludes.length) {
      // this is a convenience for when users only supply a single pair
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      next._excludedEdges = [...next._excludedEdges, ...excludes];
    }

    next._nodes = sortFields(fields, next._excludedEdges);
    return next;
  }

  pick(keys) {
    const picked = {};

    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }

    return this.clone().withMutation(next => {
      next.fields = {};
      return next.shape(picked);
    });
  }

  omit(keys) {
    const next = this.clone();
    const fields = next.fields;
    next.fields = {};

    for (const key of keys) {
      delete fields[key];
    }

    return next.withMutation(() => next.shape(fields));
  }

  from(from, to, alias) {
    let fromGetter = propertyExprExports.getter(from, true);
    return this.transform(obj => {
      if (obj == null) return obj;
      let newObj = obj;

      if (has$1(obj, from)) {
        newObj = _extends$1A({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  }

  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,

      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }

    });
    next.spec.noUnknown = noAllow;
    return next;
  }

  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }

  transformKeys(fn) {
    return this.transform(obj => obj && mapKeys(obj, (_, key) => fn(key)));
  }

  camelCase() {
    return this.transformKeys(camelCase);
  }

  snakeCase() {
    return this.transformKeys(snakeCase);
  }

  constantCase() {
    return this.transformKeys(key => snakeCase(key).toUpperCase());
  }

  describe() {
    let base = super.describe();
    base.fields = mapValues(this.fields, value => value.describe());
    return base;
  }

}
function create$1(spec) {
  return new ObjectSchema(spec);
}
create$1.prototype = ObjectSchema.prototype;

function _extends$1z() { _extends$1z = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }
function create(type) {
  return new ArraySchema(type);
}
class ArraySchema extends BaseSchema {
  constructor(type) {
    super({
      type: 'array'
    }); // `undefined` specifically means uninitialized, as opposed to
    // "no subtype"

    this.innerType = void 0;
    this.innerType = type;
    this.withMutation(() => {
      this.transform(function (values) {
        if (typeof values === 'string') try {
          values = JSON.parse(values);
        } catch (err) {
          values = null;
        }
        return this.isType(values) ? values : null;
      });
    });
  }

  _typeCheck(v) {
    return Array.isArray(v);
  }

  get _subType() {
    return this.innerType;
  }

  _cast(_value, _opts) {
    const value = super._cast(_value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this.innerType) return value;
    let isChanged = false;
    const castArray = value.map((v, idx) => {
      const castElement = this.innerType.cast(v, _extends$1z({}, _opts, {
        path: `${_opts.path || ''}[${idx}]`
      }));

      if (castElement !== v) {
        isChanged = true;
      }

      return castElement;
    });
    return isChanged ? castArray : value;
  }

  _validate(_value, options = {}, callback) {
    var _options$abortEarly, _options$recursive;

    let errors = [];
    options.sync;
    let path = options.path;
    let innerType = this.innerType;
    let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
    let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
    let originalValue = options.originalValue != null ? options.originalValue : _value;

    super._validate(_value, options, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || endEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !innerType || !this._typeCheck(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated

      let tests = new Array(value.length);

      for (let idx = 0; idx < value.length; idx++) {
        let item = value[idx];
        let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation

        let innerOptions = _extends$1z({}, options, {
          path,
          strict: true,
          parent: value,
          index: idx,
          originalValue: originalValue[idx]
        });

        tests[idx] = (_, cb) => innerType.validate(item, innerOptions, cb);
      }

      runTests({
        path,
        value,
        errors,
        endEarly,
        tests
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.innerType = this.innerType;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    next.innerType = this.innerType;
    if (schema.innerType) next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat()
    next.innerType.concat(schema.innerType) : schema.innerType;
    return next;
  }

  of(schema) {
    // FIXME: this should return a new instance of array without the default to be
    let next = this.clone();
    if (!isSchema(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + printValue(schema)); // FIXME(ts):

    next.innerType = schema;
    return next;
  }

  length(length, message = array.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message) {
    message = message || array.min;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      // FIXME(ts): Array<typeof T>
      test(value) {
        return isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message) {
    message = message || array.max;
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  ensure() {
    return this.default(() => []).transform((val, original) => {
      // We don't want to return `null` for nullable schema
      if (this._typeCheck(val)) return val;
      return original == null ? [] : [].concat(original);
    });
  }

  compact(rejector) {
    let reject = !rejector ? v => !!v : (v, i, a) => !rejector(v, i, a);
    return this.transform(values => values != null ? values.filter(reject) : values);
  }

  describe() {
    let base = super.describe();
    if (this.innerType) base.innerType = this.innerType.describe();
    return base;
  }

  nullable(isNullable = true) {
    return super.nullable(isNullable);
  }

  defined() {
    return super.defined();
  }

  required(msg) {
    return super.required(msg);
  }

}
create.prototype = ArraySchema.prototype; //
// Interfaces
//

// User Fields Schema without captchaToken and policiesConsent properties
const userFieldsSchema = create$1().shape({
    alias: create$2(),
    btcWallet: create$2(),
    ckbWallet: create$2(),
    country: create$2(),
    discordNotification: create$3(),
    dogeWallet: create$2(),
    email: create$2(),
    emailNotification: create$3(),
    firstName: create$2(),
    jobTitle: create$2(),
    kasWallet: create$2(),
    kdaWallet: create$2(),
    lastName: create$2(),
    ltcWallet: create$2(),
    metadata: create$1(),
    newsletterNotification: create$3(),
    phoneNumber: create$2(),
    tShirtSize: create$2(),
    team: create$2(),
    username: create$2(),
});

var src;
var hasRequiredSrc;

function requireSrc () {
	if (hasRequiredSrc) return src;
	hasRequiredSrc = 1;
	// base-x encoding / decoding
	// Copyright (c) 2018 base-x contributors
	// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
	// Distributed under the MIT software license, see the accompanying
	// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
	function base (ALPHABET) {
	  if (ALPHABET.length >= 255) { throw new TypeError('Alphabet too long') }
	  var BASE_MAP = new Uint8Array(256);
	  for (var j = 0; j < BASE_MAP.length; j++) {
	    BASE_MAP[j] = 255;
	  }
	  for (var i = 0; i < ALPHABET.length; i++) {
	    var x = ALPHABET.charAt(i);
	    var xc = x.charCodeAt(0);
	    if (BASE_MAP[xc] !== 255) { throw new TypeError(x + ' is ambiguous') }
	    BASE_MAP[xc] = i;
	  }
	  var BASE = ALPHABET.length;
	  var LEADER = ALPHABET.charAt(0);
	  var FACTOR = Math.log(BASE) / Math.log(256); // log(BASE) / log(256), rounded up
	  var iFACTOR = Math.log(256) / Math.log(BASE); // log(256) / log(BASE), rounded up
	  function encode (source) {
	    if (source instanceof Uint8Array) ; else if (ArrayBuffer.isView(source)) {
	      source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
	    } else if (Array.isArray(source)) {
	      source = Uint8Array.from(source);
	    }
	    if (!(source instanceof Uint8Array)) { throw new TypeError('Expected Uint8Array') }
	    if (source.length === 0) { return '' }
	        // Skip & count leading zeroes.
	    var zeroes = 0;
	    var length = 0;
	    var pbegin = 0;
	    var pend = source.length;
	    while (pbegin !== pend && source[pbegin] === 0) {
	      pbegin++;
	      zeroes++;
	    }
	        // Allocate enough space in big-endian base58 representation.
	    var size = ((pend - pbegin) * iFACTOR + 1) >>> 0;
	    var b58 = new Uint8Array(size);
	        // Process the bytes.
	    while (pbegin !== pend) {
	      var carry = source[pbegin];
	            // Apply "b58 = b58 * 256 + ch".
	      var i = 0;
	      for (var it1 = size - 1; (carry !== 0 || i < length) && (it1 !== -1); it1--, i++) {
	        carry += (256 * b58[it1]) >>> 0;
	        b58[it1] = (carry % BASE) >>> 0;
	        carry = (carry / BASE) >>> 0;
	      }
	      if (carry !== 0) { throw new Error('Non-zero carry') }
	      length = i;
	      pbegin++;
	    }
	        // Skip leading zeroes in base58 result.
	    var it2 = size - length;
	    while (it2 !== size && b58[it2] === 0) {
	      it2++;
	    }
	        // Translate the result into a string.
	    var str = LEADER.repeat(zeroes);
	    for (; it2 < size; ++it2) { str += ALPHABET.charAt(b58[it2]); }
	    return str
	  }
	  function decodeUnsafe (source) {
	    if (typeof source !== 'string') { throw new TypeError('Expected String') }
	    if (source.length === 0) { return new Uint8Array() }
	    var psz = 0;
	        // Skip and count leading '1's.
	    var zeroes = 0;
	    var length = 0;
	    while (source[psz] === LEADER) {
	      zeroes++;
	      psz++;
	    }
	        // Allocate enough space in big-endian base256 representation.
	    var size = (((source.length - psz) * FACTOR) + 1) >>> 0; // log(58) / log(256), rounded up.
	    var b256 = new Uint8Array(size);
	        // Process the characters.
	    while (source[psz]) {
	            // Decode character
	      var carry = BASE_MAP[source.charCodeAt(psz)];
	            // Invalid character
	      if (carry === 255) { return }
	      var i = 0;
	      for (var it3 = size - 1; (carry !== 0 || i < length) && (it3 !== -1); it3--, i++) {
	        carry += (BASE * b256[it3]) >>> 0;
	        b256[it3] = (carry % 256) >>> 0;
	        carry = (carry / 256) >>> 0;
	      }
	      if (carry !== 0) { throw new Error('Non-zero carry') }
	      length = i;
	      psz++;
	    }
	        // Skip leading zeroes in b256.
	    var it4 = size - length;
	    while (it4 !== size && b256[it4] === 0) {
	      it4++;
	    }
	    var vch = new Uint8Array(zeroes + (size - it4));
	    var j = zeroes;
	    while (it4 !== size) {
	      vch[j++] = b256[it4++];
	    }
	    return vch
	  }
	  function decode (string) {
	    var buffer = decodeUnsafe(string);
	    if (buffer) { return buffer }
	    throw new Error('Non-base' + BASE + ' character')
	  }
	  return {
	    encode: encode,
	    decodeUnsafe: decodeUnsafe,
	    decode: decode
	  }
	}
	src = base;
	return src;
}

var bs58$1;
var hasRequiredBs58;

function requireBs58 () {
	if (hasRequiredBs58) return bs58$1;
	hasRequiredBs58 = 1;
	const basex = requireSrc();
	const ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';

	bs58$1 = basex(ALPHABET);
	return bs58$1;
}

var bs58Exports = requireBs58();
var bs58 = /*@__PURE__*/getDefaultExportFromCjs(bs58Exports);

const isPromise$1 = (value) => value instanceof Promise;
const resolveFetcher = (fetcher_1, _a, callback_1) => __awaiter$1(void 0, [fetcher_1, _a, callback_1], void 0, function* (fetcher, { retries }, callback) {
    const totalNumberOfAttempts = retries ? retries + 1 : 1;
    let currentAttempt = 0;
    let data;
    let err;
    while (currentAttempt < totalNumberOfAttempts) {
        currentAttempt = currentAttempt + 1;
        try {
            const result = fetcher();
            if (isPromise$1(result)) {
                data = yield result;
            }
            else {
                data = result;
            }
            err = undefined;
            // If we have data, we can break the loop
            if (data) {
                break;
            }
        }
        catch (error) {
            err = error;
        }
    }
    callback(err, data);
    return data;
});

/**
 * Custom hook for handling promises and fetching data.
 * @template T - The type of the data returned by the promise.
 * @template E - The type of the error thrown by the promise.
 * @returns {PromiseState<T, E>} - The state object containing the data, error, loading status
 * and a callback to manually retrigger the promise.
 * @example
 * // Example usage with a simple fetcher function
 * const fetcher = fetch('https://api.example.com/data');
 *
 * const MyComponent = () => {
 *  const { data, isLoading, error } = usePromise(fetcher);
 *
 *  if (isLoading) {
 *    return <div>Loading...</div>;
 *  }
 *
 *  if (error) {
 *    return <div>Error: {error.message}</div>;
 *  }
 *
 * return <div>Data: {data}</div>;
 * };
 */
const usePromise = (
/** A function that returns the data or a promise that resolves to the data */
fetcher, 
/** Options for the hook */
options) => {
    const lastCallTimestamp = useRef(new Date().getTime());
    const { deps = [], initialData = undefined, enabled = true, retries = 0, } = options || {};
    // Keep the callbacks updated regardless of when trigger is called
    const callbacks = useRef({
        onBeforeFetch: options === null || options === void 0 ? void 0 : options.onBeforeFetch,
        onReject: options === null || options === void 0 ? void 0 : options.onReject,
        onResolve: options === null || options === void 0 ? void 0 : options.onResolve,
    });
    callbacks.current = {
        onBeforeFetch: options === null || options === void 0 ? void 0 : options.onBeforeFetch,
        onReject: options === null || options === void 0 ? void 0 : options.onReject,
        onResolve: options === null || options === void 0 ? void 0 : options.onResolve,
    };
    const [data, setData] = useState(initialData);
    const [isLoading, setIsLoading] = useState(enabled);
    const [error, setError] = useState(undefined);
    const trigger = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a, _b;
        const callTimestamp = new Date().getTime();
        const diffFromLastCall = callTimestamp - lastCallTimestamp.current;
        if (diffFromLastCall < 5) {
            logger$1.logVerboseTroubleshootingMessage('usePromise: Fetcher function was called in very quick succession. Please make sure the fetcher function is not synchronous and that you are not calling it inside a loop.', deps);
        }
        lastCallTimestamp.current = callTimestamp;
        setIsLoading(true);
        (_b = (_a = callbacks.current).onBeforeFetch) === null || _b === void 0 ? void 0 : _b.call(_a);
        return resolveFetcher(fetcher, { retries }, (resultError, resultData) => {
            var _a, _b, _c, _d;
            if (callTimestamp !== lastCallTimestamp.current)
                return;
            if (resultError) {
                logger$1.error(resultError);
                setError(resultError);
                (_b = (_a = callbacks.current).onReject) === null || _b === void 0 ? void 0 : _b.call(_a, resultError);
                return;
            }
            setData(resultData);
            (_d = (_c = callbacks.current).onResolve) === null || _d === void 0 ? void 0 : _d.call(_c, resultData);
        }).finally(() => setIsLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), deps);
    useEffect(() => {
        if (enabled)
            trigger();
    }, [trigger, enabled]);
    return useMemo(() => ({
        data: data,
        error,
        isLoading,
        retrigger: trigger,
    }), [data, error, isLoading, trigger]);
};

/**
 * given a wallet it, this function will look through the jwt and do the following:
 * 1. find the account that matches the wallet id
 * 2. find the account that matches the refId of the account found in step 1
 * 3. return the account found in step 2. this is the referenced account
 */
const getReferencedAccount = (user, walletId) => {
    const accountForWalletId = user === null || user === void 0 ? void 0 : user.verifiedCredentials.find((account) => account.id === walletId);
    return user === null || user === void 0 ? void 0 : user.verifiedCredentials.find((account) => account.id === (accountForWalletId === null || accountForWalletId === void 0 ? void 0 : accountForWalletId.refId));
};

const createUserProfileFromSdkUser = (user) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const kyc = {
        alias: (_a = user.alias) !== null && _a !== void 0 ? _a : undefined,
        btcWallet: (_b = user.btcWallet) !== null && _b !== void 0 ? _b : undefined,
        ckbWallet: (_c = user.ckbWallet) !== null && _c !== void 0 ? _c : undefined,
        country: (_d = user.country) !== null && _d !== void 0 ? _d : undefined,
        discordNotification: (_e = user.discordNotification) !== null && _e !== void 0 ? _e : undefined,
        dogeWallet: (_f = user.dogeWallet) !== null && _f !== void 0 ? _f : undefined,
        email: (_g = user.email) !== null && _g !== void 0 ? _g : undefined,
        emailNotification: (_h = user.emailNotification) !== null && _h !== void 0 ? _h : undefined,
        firstName: (_j = user.firstName) !== null && _j !== void 0 ? _j : undefined,
        jobTitle: (_k = user.jobTitle) !== null && _k !== void 0 ? _k : undefined,
        kasWallet: (_l = user.kasWallet) !== null && _l !== void 0 ? _l : undefined,
        kdaWallet: (_m = user.kdaWallet) !== null && _m !== void 0 ? _m : undefined,
        lastName: (_o = user.lastName) !== null && _o !== void 0 ? _o : undefined,
        ltcWallet: (_p = user.ltcWallet) !== null && _p !== void 0 ? _p : undefined,
        newsletterNotification: (_q = user.newsletterNotification) !== null && _q !== void 0 ? _q : undefined,
        phoneNumber: (_r = user.phoneNumber) !== null && _r !== void 0 ? _r : undefined,
        policiesConsent: (_s = user.policiesConsent) !== null && _s !== void 0 ? _s : undefined,
        tShirtSize: (_t = user.tShirtSize) !== null && _t !== void 0 ? _t : undefined,
        team: (_u = user.team) !== null && _u !== void 0 ? _u : undefined,
        username: (_v = user.username) !== null && _v !== void 0 ? _v : undefined,
    };
    const userProfile = Object.assign({ environmentId: user.projectEnvironmentId, lastVerifiedCredentialId: (_w = user.lastVerifiedCredentialId) !== null && _w !== void 0 ? _w : undefined, lists: user.lists, metadata: user.metadata, mfaBackupCodeAcknowledgement: user.mfaBackupCodeAcknowledgement, missingFields: user.missingFields, newUser: user.newUser, scope: user.scope, sessionId: (_x = user.sessionId) !== null && _x !== void 0 ? _x : 'missing-sessionId', userId: user.id, verifiedCredentials: user.verifiedCredentials || [] }, kyc);
    return userProfile;
};

const storeExpiresAt = (expiresAt) => {
    StorageService.setItem(AUTH_EXPIRES_AT, expiresAt);
};

const storeAuthToken = ({ jwt, minifiedJwt, expiresAt, }) => {
    // expiresAt is always sent back by the backend, regardless of whether jwt/minifiedJwt are sent or not
    if (expiresAt !== undefined)
        storeExpiresAt(expiresAt);
    if (jwt && minifiedJwt) {
        StorageService.setItem(AUTH_TOKEN, jwt, {
            priority: ['secureStorage', 'localStorage'],
        });
        StorageService.setItem(AUTH_MIN_TOKEN, minifiedJwt, {
            priority: ['secureStorage', 'localStorage'],
        });
        const projectSettings = getProjectSettings();
        if (projectSettings && isCookieEnabled(projectSettings)) {
            // if cookie is enabled, but the backend returns a JWT, then use JS to store the cookie
            const expireDate = new Date(expiresAt * 1000).toUTCString();
            const authCookie = `${DYNAMIC_AUTH_COOKIE_NAME}=${minifiedJwt}; expires=${expireDate}; path=/; SameSite=Lax`;
            document.cookie = authCookie;
        }
    }
};

const storeAuthTokenAndUser = (params) => {
    storeAuthToken(params);
    const userProfile = createUserProfileFromSdkUser(params.user);
    if (params.preserveFieldsWithVerification) {
        const oldUser = getUser();
        const settings = getProjectSettings();
        if (settings === null || settings === void 0 ? void 0 : settings.kyc) {
            for (const field of settings.kyc) {
                if (!field.verify)
                    continue;
                const property = field.name;
                // @ts-expect-error TS doesn't know that the property exists
                userProfile[property] = oldUser === null || oldUser === void 0 ? void 0 : oldUser[property];
            }
        }
    }
    setUser(userProfile);
    return userProfile;
};

const logResponseError = (e, message) => __awaiter$1(void 0, void 0, void 0, function* () {
    if (e instanceof Response) {
        const data = yield e.json();
        logger$1.error(message, { error: data.error, status: e.status });
        return data;
    }
    else if (e instanceof Error) {
        logger$1.error(message, e);
    }
});
const getNonce$1 = (environmentId) => __awaiter$1(void 0, void 0, void 0, function* () {
    try {
        const res = yield sdkApi().getNonce({
            environmentId,
        });
        return res.nonce;
    }
    catch (e) {
        return undefined;
    }
});

const storeSelectedWallet = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ environmentId, walletId, }) {
    try {
        const response = yield sdkApi().selectUserWallet({
            environmentId,
            userWalletSelectionRequest: {
                walletId,
            },
        });
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        yield logResponseError(e, 'Error storing selected wallet');
        return undefined;
    }
});
const linkWallet = (environmentId_1, _b) => __awaiter$1(void 0, [environmentId_1, _b], void 0, function* (environmentId, { messageToSign, network, signedMessage, publicWalletAddress, chain, walletName, walletProvider, additionalWalletAddresses, backup, }) {
    const verifyRequest = VerifyRequestFromJSON({
        additionalWalletAddresses,
        backup,
        chain,
        messageToSign,
        network,
        publicWalletAddress,
        signedMessage,
        walletName,
        walletProvider,
    });
    try {
        const response = yield sdkApi().verifyLink({
            environmentId,
            verifyRequest,
        });
        storeAuthTokenAndUser(response);
        return response;
    }
    catch (e) {
        const data = yield logResponseError(e, 'Error linkWallet');
        if (data.code === 'embedded_wallet_address_already_linked') {
            throw new EmbeddedWalletExistsError(data.code);
        }
        if (data.code === 'reassign_wallet_confirm' ||
            data.code === 'reassign_wallet_error') {
            throw new WalletUsedError(data.code);
        }
        if (data.code === 'merge_accounts_confirmation') {
            throw new MergeAccountsConfirmationError({
                code: data.code,
                mergeConflicts: data.payload.mergeConflicts,
                walletAddress: publicWalletAddress,
            });
        }
        if (data.error.code === 'sandbox_maximum_threshold_reached') {
            throw new SandboxMaximumThresholdReachedError(data.error.message);
        }
        throw new DynamicError(data.error);
    }
});
const unlinkWallet = (_c) => __awaiter$1(void 0, [_c], void 0, function* ({ environmentId, primaryWalletId, walletId, onSuccess, }) {
    try {
        const response = yield sdkApi().verifyUnlink({
            environmentId,
            verifyUnlinkRequest: {
                primaryWalletId,
                walletId,
            },
        });
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        yield logResponseError(e, 'Error unlinkWallet');
        return undefined;
    }
});
const transferWallet = (environmentId_2, _d) => __awaiter$1(void 0, [environmentId_2, _d], void 0, function* (environmentId, { network, messageToSign, signedMessage, publicWalletAddress, chain, walletName, walletProvider, skipEmptyAccountCheck = false, }) {
    // We should find a better way to do this than force type casting
    const verifyRequest = {
        chain,
        messageToSign,
        network,
        publicWalletAddress,
        signedMessage,
        skipEmptyAccountCheck,
        walletName,
        walletProvider,
    };
    try {
        const response = yield sdkApi().verifyTransfer({
            environmentId,
            verifyRequest,
        });
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        yield logResponseError(e, 'Error transfering wallet');
        return undefined;
    }
});
const verifyWallet = (environmentId_3, _e) => __awaiter$1(void 0, [environmentId_3, _e], void 0, function* (environmentId, { messageToSign, signedMessage, publicWalletAddress, chain, walletName, walletProvider, captchaToken, network, oauth, additionalWalletAddresses, sessionPublicKey, }) {
    const verifyRequest = VerifyRequestFromJSON({
        additionalWalletAddresses,
        captchaToken,
        chain,
        messageToSign,
        network,
        oauth,
        publicWalletAddress,
        sessionPublicKey,
        signedMessage,
        walletName,
        walletProvider,
    });
    try {
        const response = yield sdkApi().verify({
            environmentId,
            verifyRequest,
        });
        return response;
    }
    catch (e) {
        const data = yield logResponseError(e, 'Error verifyWallet');
        if (data.code === 'wallet_not_deployed') {
            throw new WalletNotDeployedError();
        }
        if (data.error.code === 'chainalysis_blocked_wallet') {
            throw new ChainalysisError(data.payload.walletPublicKey);
        }
        if (data.error.code === 'gate_blocked') {
            throw new GateBlockedError(data.payload.walletPublicKey);
        }
        if (data.error.code === 'missing_from_list') {
            throw new NoAccessError({
                walletPublicKey: data.payload.walletPublicKey,
            });
        }
        if (data.code === 'email_associated_with_different_provider') {
            throw new AccountExistsError(data.error, data.payload);
        }
        if (data.error.code === 'sandbox_maximum_threshold_reached') {
            throw new SandboxMaximumThresholdReachedError(data.error.message);
        }
        return undefined;
    }
});

const updatePrimaryWalletId = (walletId) => __awaiter$1(void 0, void 0, void 0, function* () {
    setPrimaryWalletId(walletId);
    const user = getUser();
    if (user) {
        const environmentId = getEnvironmentId();
        yield storeSelectedWallet({ environmentId, walletId });
    }
});

// This is internal context hook only for SDK do not expose it to customers
const useInternalDynamicContext = () => {
    const context = useContext(DynamicContext);
    if (context === undefined) {
        throw new Error('useInternalDynamicContext must be used within a DynamicContextProvider');
    }
    return context;
};

// HEADLESS ERRORS
const ACTIVE_SESSION = 'session_active';
const ERROR_SENDING_CODE = 'error_sending_code';
const ERROR_PROCESSING_REVEAL_REQUEST = 'error_processing_reveal_request';
const INVALID_REQUEST = 'invalid_request';
const INVALID_WALLET_DATA = 'invalid_wallet';
const SECURE_ENCLAVE_PROVIDER_NOT_ENABLED = 'secure_enclave_provider_not_enabled';
const USER_NOT_LOGGED_IN = 'user_not_logged_in';
const CODE_SENT = 'code_sent';
const SESSION_CREATED = 'session_created';
const SESSION_RESTORED = 'session_restored';
const ACCESS_BLOCKED_ERROR_CODE = 451;

const generateMessages = (publicWalletAddress, walletConnector, nonce, projectEnvironmentId, displaySiweStatement, siweStatement) => __awaiter$1(void 0, void 0, void 0, function* () {
    if (publicWalletAddress === undefined) {
        throw new DynamicError('Unable to fetch the public address from the wallet');
    }
    if (!walletConnector.connectedChain) {
        throw new DynamicError('Wallet is not connected');
    }
    let chainId = yield walletConnector.getNetwork();
    if (chainId === undefined) {
        if (walletConnector.key === 'bloctoevm') {
            chainId = 137;
        }
        else if (walletConnector.connectedChain === 'EVM') {
            chainId = 1;
        }
    }
    const parsedAddress = walletConnector.parseAddress(publicWalletAddress);
    const messageToSign = generateMessageToSign({
        blockchain: walletConnector.connectedChain,
        chainId: chainId,
        domain: window.location.host,
        nonce,
        // The SIWE parser library used to validate signed messages for EVM/Ethereum
        // checks that an address is in EIP55 format, so make sure we do that here.
        // see: https://eips.ethereum.org/EIPS/eip-55
        publicKey: parsedAddress,
        requestId: projectEnvironmentId,
        resources: walletConnector.providerResources,
        statement: displaySiweStatement
            ? siweStatement.replace(/(\r\n|\n|\r)/gm, ' ').trim()
            : undefined,
        uri: window.location.origin + window.location.pathname,
    });
    const signedMessage = yield walletConnector.proveOwnership(parsedAddress, messageToSign);
    if (!signedMessage) {
        throw new DynamicError('Unable to sign the message');
    }
    return { messageToSign, signedMessage };
});

// TODO - This function is doing too much we should split it up.
const getVerifyArgs = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ walletConnector, walletProvider, environmentId, displaySiweStatement, skipEmptyAccountCheck, siweStatement, publicWalletAddress, signedMessageOverride, messageToSignOverride, }) {
    // WARNING - PLEASE READ!
    // DO NOT ADD ANY NEW ASYNC WORK WITH AWAIT!
    // Deep linking could break with too many blocking awaits
    // before the we call generateMessages.
    // This could manifest in users being directed to the app store
    // instead of the actual wallet app.
    const chain = walletConnector.connectedChain;
    if (signedMessageOverride && messageToSignOverride) {
        const [network, additionalWalletAddresses] = yield Promise.all([
            walletConnector.getNetwork(),
            walletConnector.getAdditionalAddresses(publicWalletAddress),
        ]);
        return {
            additionalWalletAddresses,
            chain,
            messageToSign: messageToSignOverride,
            network: String(network),
            publicWalletAddress,
            signedMessage: signedMessageOverride,
            skipEmptyAccountCheck,
            walletName: walletConnector.key,
            walletProvider,
        };
    }
    const nonce = consumeNonce();
    // generate message to sign and then initiate signing step to prove ownership
    const { messageToSign, signedMessage } = yield generateMessages(publicWalletAddress, walletConnector, nonce, environmentId, displaySiweStatement, siweStatement);
    const [network, additionalWalletAddresses] = yield Promise.all([
        walletConnector.getNetwork(),
        walletConnector.getAdditionalAddresses(publicWalletAddress),
    ]);
    return {
        additionalWalletAddresses,
        chain,
        messageToSign,
        network: String(network),
        publicWalletAddress,
        signedMessage,
        skipEmptyAccountCheck,
        walletName: walletConnector.key,
        walletProvider,
    };
});

const getSiweStatement = ({ appName, siweStatement, }) => {
    const defaultMessage = `Welcome to ${appName}. Signing is the only way we can truly know that you are the owner of the wallet you are connecting. Signing is a safe, gas-less transaction that does not in any way give ${appName} permission to perform any transactions with your wallet.`;
    return siweStatement || defaultMessage;
};

const getWalletProvider = (connector) => {
    if (connector.isEmbeddedWallet) {
        return 'embeddedWallet';
    }
    if (connector.canConnectViaCustodialService) {
        return 'custodialService';
    }
    if (connector.isInstalledOnBrowser()) {
        return 'browserExtension';
    }
    return isMobile() ? 'deepLink' : 'qrCode';
};

// Converts an ArrayBuffer to a hex-encoded string
const buf2hex = (buffer) => [...new Uint8Array(buffer)]
    .map((x) => x.toString(16).padStart(2, '0'))
    .join('');
// Takes a base64url-encoded string (e.g. "nMueRPiAm51YXEjRtka8S_8Ura3HaqbmqDqMJCZmvkM")
// and return the corresponding bytes, as an array buffer.
const base64urlDecode = (s) => {
    // Go from base64url encoding to base64 encoding
    s = (s === null || s === void 0 ? void 0 : s.replace(/-/g, '+').replace(/_/g, '/')) || '';
    // use `atob` to decode base64
    return Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
};
// Accepts a public key array buffer, and returns a buffer with the compressed version of the public key
const compressRawPublicKey = (rawPublicKey) => {
    const rawPublicKeyBytes = new Uint8Array(rawPublicKey);
    const len = rawPublicKeyBytes.byteLength;
    // Drop the y coordinate
    const compressedBytes = rawPublicKeyBytes.slice(0, (1 + len) >>> 1);
    // Encode the parity of `y` in first bit
    compressedBytes[0] = 0x2 | (rawPublicKeyBytes[len - 1] & 0x01);
    return compressedBytes.buffer;
};
const p256Keygen = () => __awaiter$1(void 0, void 0, void 0, function* () {
    // Create a new P-256 keypair
    const p256Keypair = yield crypto.subtle.generateKey({
        name: 'ECDSA',
        namedCurve: 'P-256',
    }, true, ['sign', 'verify']);
    // Export the raw public key. By default this will export in uncompressed format
    const rawPublicKey = yield crypto.subtle.exportKey('raw', p256Keypair.publicKey);
    // We need to export with JWK format because exporting EC private keys with "raw" isn't supported
    const privateKeyJwk = yield crypto.subtle.exportKey('jwk', p256Keypair.privateKey);
    // Optional: compress the public key! But you don't have to
    const compressedPublicKeyBuffer = compressRawPublicKey(rawPublicKey);
    const privateKeyBuffer = base64urlDecode(privateKeyJwk.d);
    return {
        private: buf2hex(privateKeyBuffer), // format for Turnkey API key stamper
        privateJwk: privateKeyJwk, // format required for use in signing redcoast signatures
        public: buf2hex(compressedPublicKeyBuffer),
        publicUncompressed: buf2hex(rawPublicKey),
    };
});
const p256Sign = (privateKeyJwk, message) => __awaiter$1(void 0, void 0, void 0, function* () {
    const privateKey = yield crypto.subtle.importKey('jwk', privateKeyJwk, {
        name: 'ECDSA',
        namedCurve: 'P-256',
    }, false, ['sign']);
    const signature = yield crypto.subtle.sign({
        hash: 'SHA-256',
        name: 'ECDSA',
    }, privateKey, new TextEncoder().encode(message));
    return buf2hex(signature);
});

const createTurnkeyEmbeddedWallet = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ attestation, challenge, environmentId, chains = [EmbeddedWalletChainEnum.Evm], passkeyAlias, sessionPublicKey, }) {
    const embeddedWallets = [
        {
            chains,
            embeddedWalletProvider: EmbeddedWalletProviderEnum.Turnkeyhd,
            isAuthenticatorAttached: false,
            passkeyAlias,
            sessionPublicKey,
        },
    ];
    if (attestation && challenge) {
        embeddedWallets[0] = Object.assign(Object.assign({}, embeddedWallets[0]), { embeddedWalletSpecificOpts: {
                attestation,
                challenge,
            }, isAuthenticatorAttached: true });
    }
    try {
        const response = yield sdkApi().createEmbeddedWallets({
            createEmbeddedWalletsRequest: {
                embeddedWallets,
            },
            environmentId,
        });
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        yield logResponseError(e, 'Error creating embedded wallet');
        return undefined;
    }
});
const initEmbeddedWalletSession$1 = (_b) => __awaiter$1(void 0, [_b], void 0, function* ({ authenticatorType, walletId, publicKey, environmentId, }) {
    if (authenticatorType === 'passkey') {
        return sdkApi().initPasskeyRecovery({
            environmentId,
            initPasskeyRecoveryRequest: {
                turnkeyRecoveryTargetPublicKey: publicKey,
                walletId,
            },
        });
    }
    return sdkApi().initEmailAuth({
        environmentId,
        initEmailAuthRequest: {
            turnkeyEmailAuthTargetPublicKey: publicKey,
            walletId,
        },
    });
});
const completePasskeyRecovery$1 = (_c) => __awaiter$1(void 0, [_c], void 0, function* ({ walletId, attestation, challenge, environmentId, }) {
    try {
        const response = yield sdkApi().completePasskeyRecovery({
            completePasskeyRecoveryRequest: {
                attestation,
                challenge,
                walletId,
            },
            environmentId,
        });
        return storeAuthTokenAndUser(response);
    }
    catch (e) {
        yield logResponseError(e, 'Error completing passkey recovery');
        return undefined;
    }
});
const updatePasskeyRecoveryEmail = (_d) => __awaiter$1(void 0, [_d], void 0, function* ({ environmentId, updateRecoveryEmailRequest, }) {
    try {
        yield sdkApi().updateEmbeddedWalletRecoveryEmail({
            environmentId,
            updateRecoveryEmailRequest,
        });
    }
    catch (e) {
        yield logResponseError(e, 'Error while trying to update recovery email');
        throw new DynamicError('Error updating recovery email');
    }
});
const getUserPasskeys = (_e) => __awaiter$1(void 0, [_e], void 0, function* ({ environmentId, }) {
    try {
        const data = yield sdkApi().getUserPasskeys({
            environmentId,
        });
        return data;
    }
    catch (e) {
        yield logResponseError(e, 'Error getting user passkeys');
        return {
            count: 0,
            passkeys: [],
        };
    }
});
const updateUserPasskey = (_f) => __awaiter$1(void 0, [_f], void 0, function* ({ environmentId, id, alias, }) {
    try {
        const data = yield sdkApi().updatePasskey({
            environmentId,
            updateUserPasskeyRequest: { alias, id },
        });
        return data;
    }
    catch (e) {
        yield logResponseError(e, 'Error updating user passkeys');
        return undefined;
    }
});
const exportEmbeddedWallet = (_g) => __awaiter$1(void 0, [_g], void 0, function* ({ environmentId, walletId, activityId, }) {
    try {
        const data = yield sdkApi().embeddedWalletExport({
            activityId,
            environmentId,
            walletId,
        });
        return data;
    }
    catch (e) {
        yield logResponseError(e, 'Error exporting embedded wallet');
        return { exportBundle: '' };
    }
});
const registerSessionKey = (_h) => __awaiter$1(void 0, [_h], void 0, function* ({ environmentId, publicKey, prevSessionKeySignature, }) {
    let response;
    try {
        response = yield sdkApi().registerSessionKey({
            environmentId,
            registerSessionKeyRequest: { prevSessionKeySignature, publicKey },
        });
    }
    catch (e) {
        const data = yield logResponseError(e, 'Error register session key');
        if (e.status === 422) {
            if (data.code === UnprocessableEntityErrorCode.InvalidSessionPublicKey) {
                throw new InvalidEmbeddedWalletSessionKeyError(data.error);
            }
        }
        throw e;
    }
    return response;
});
const getCreateEmbeddedWalletAccountRequest = (_j) => __awaiter$1(void 0, [_j], void 0, function* ({ environmentId, chain, }) {
    try {
        const response = yield sdkApi().getCreateWalletAccountRequest({
            chain,
            environmentId,
        });
        return response;
    }
    catch (e) {
        yield logResponseError(e, 'Error fetching create embedded wallet account request');
        throw new DynamicError('Error fetching create embedded wallet account request');
    }
});
const createEmbeddedWalletAccount = (_k) => __awaiter$1(void 0, [_k], void 0, function* ({ environmentId, createEmbeddedWalletAccountRequest, }) {
    try {
        const response = yield sdkApi().createWalletAccount({
            createWalletAccountRequest: {
                turnkeySignedRequest: createEmbeddedWalletAccountRequest,
            },
            environmentId,
        });
        return response;
    }
    catch (e) {
        yield logResponseError(e, 'Error creating embedded wallet account');
        throw new DynamicError('Error creating embedded wallet account');
    }
});
const getDeleteEmbeddedWalletsRequest = (_l) => __awaiter$1(void 0, [_l], void 0, function* ({ environmentId, }) {
    try {
        const response = yield sdkApi().getEmbeddedWalletsDeleteRequest({
            environmentId,
        });
        return response;
    }
    catch (e) {
        yield logResponseError(e, 'Error fetching delete embedded wallet request');
        throw new DynamicError('Error fetching delete embedded wallets request');
    }
});
const deleteEmbeddedWallets = (_m) => __awaiter$1(void 0, [_m], void 0, function* ({ environmentId, deleteEmbeddedWalletsRequest, }) {
    try {
        const response = yield sdkApi().deleteEmbeddedWallets({
            deleteEmbeddedWalletsRequest: {
                turnkeySignedRequest: deleteEmbeddedWalletsRequest,
            },
            environmentId,
        });
        return response;
    }
    catch (e) {
        yield logResponseError(e, 'Error deleting embedded wallets');
        throw new DynamicError('Error deleting embedded wallets');
    }
});

const useEmbeddedWalletSessionKeys = ({ environmentId, projectSettings, }) => {
    const { user } = useUser();
    // scenario 1: first time session register on first transaction.
    // Keys will have been previously generated at this point in local storage but marked as not registered
    // scenario 2: 2nd time register after expiration (key refresh)
    // scenario 3: refresh/rerender page - session still active
    // scenario 4: refresh/rerender page - session no longer active
    const registerEmbeddedWalletSessionKey = (...args_1) => __awaiter$1(void 0, [...args_1], void 0, function* ({ ignoreRestore = false, } = {}) {
        // check if session keys are already stored in session storage
        const sessionKeysSS = StorageService.getItem(SECURE_ENCLAVE_WALLET_SESSION_KEYS, SECURE_ENCLAVE_WALLET_SESSION_KEYS_STORAGE_OPTIONS);
        const decodedSessionKeys = sessionKeysSS
            ? JSON.parse(Buffer.from(sessionKeysSS, 'base64').toString())
            : undefined;
        if (!decodedSessionKeys) {
            logger$8.warn('Could not find session keys. Re-authentication is required to create new session keys.');
            dynamicEvents.emit('triggerLogout');
            throw new Error('Could not find session keys. Re-authentication is required to create new session keys.');
        }
        if (!user) {
            throw new Error('User not found');
        }
        if (decodedSessionKeys.expirationDate &&
            new Date() <= new Date(decodedSessionKeys.expirationDate) &&
            !ignoreRestore) {
            // scenario 3
            return decodedSessionKeys;
        }
        let publicKey;
        let privateKey;
        let privateKeyJwk;
        let prevSessionKeySignature = undefined;
        if (!decodedSessionKeys.registered) {
            // scenario 1
            ({ publicKey, privateKey, privateKeyJwk } = decodedSessionKeys);
        }
        else {
            // scenario 2 and 4
            const { publicKey: nextPublicKey, privateKey: nextPrivateKey, privateKeyJwk: nextPrivateKeyJwk, } = yield generateSessionKey();
            publicKey = nextPublicKey;
            privateKey = nextPrivateKey;
            privateKeyJwk = nextPrivateKeyJwk;
            prevSessionKeySignature = yield p256Sign(decodedSessionKeys.privateKeyJwk, user.sessionId);
        }
        let resp;
        try {
            resp = yield registerSessionKey({
                environmentId,
                prevSessionKeySignature,
                publicKey,
            });
        }
        catch (error) {
            if (error instanceof InvalidEmbeddedWalletSessionKeyError) {
                // this can happen if the public key passed during initial registration
                // does not match the root session public key that the backend expects
                logger$8.warn('Invalid embedded wallet session key. Re-authentication is required to create new session keys.');
                dynamicEvents.emit('triggerLogout');
            }
            throw error;
        }
        const expirationDate = new Date(resp.expiresAt * 1000);
        StorageService.setItem(SECURE_ENCLAVE_WALLET_SESSION_KEYS, toEncodedFormat(publicKey, privateKey, privateKeyJwk, true, expirationDate), SECURE_ENCLAVE_WALLET_SESSION_KEYS_STORAGE_OPTIONS);
        return { expirationDate, privateKey, publicKey };
    });
    const generateSessionKey = () => __awaiter$1(void 0, void 0, void 0, function* () {
        const { private: privateKey, public: publicKey, privateJwk, } = yield p256Keygen();
        // convert to base64 and store the session keys in session storage
        StorageService.setItem(SECURE_ENCLAVE_WALLET_SESSION_KEYS, toEncodedFormat(publicKey, privateKey, privateJwk, false), SECURE_ENCLAVE_WALLET_SESSION_KEYS_STORAGE_OPTIONS);
        return { privateKey, privateKeyJwk: privateJwk, publicKey };
    });
    const getSessionPublicKey = () => {
        const sessionKeysSS = StorageService.getItem(SECURE_ENCLAVE_WALLET_SESSION_KEYS, SECURE_ENCLAVE_WALLET_SESSION_KEYS_STORAGE_OPTIONS);
        const decodedSessionKeys = sessionKeysSS
            ? JSON.parse(Buffer.from(sessionKeysSS, 'base64').toString())
            : undefined;
        if (!(decodedSessionKeys === null || decodedSessionKeys === void 0 ? void 0 : decodedSessionKeys.publicKey)) {
            throw new Error('Could not find session keys.');
        }
        return decodedSessionKeys === null || decodedSessionKeys === void 0 ? void 0 : decodedSessionKeys.publicKey;
    };
    const shouldRegisterSessionKeysOnSignin = () => {
        var _a;
        return ((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _a === void 0 ? void 0 : _a.defaultWalletVersion) ===
            EmbeddedWalletVersionEnum.V2;
    };
    const toEncodedFormat = (publicKey, privateKey, privateKeyJwk, registered, expirationDate) => {
        const sessionKeys = {
            expirationDate,
            privateKey,
            privateKeyJwk,
            publicKey,
            registered,
        };
        const sessionKeysString = JSON.stringify(sessionKeys);
        return Buffer.from(sessionKeysString).toString('base64');
    };
    const removeSessionKey = useCallback(() => StorageService.removeItem(SECURE_ENCLAVE_WALLET_SESSION_KEYS, SECURE_ENCLAVE_WALLET_SESSION_KEYS_STORAGE_OPTIONS), []);
    return {
        generateSessionKey,
        getSessionPublicKey,
        registerEmbeddedWalletSessionKey,
        removeSessionKey,
        shouldRegisterSessionKeysOnSignin,
    };
};

const WalletContext = createContext(undefined);
const WalletContextProvider = ({ children, }) => {
    const [isLoadingEmbeddedWallet, setIsLoadingEmbeddedWallet] = useState(false);
    const value = useMemo(() => ({
        isLoadingEmbeddedWallet,
        setIsLoadingEmbeddedWallet,
    }), [isLoadingEmbeddedWallet]);
    return (jsxRuntimeExports.jsx(WalletContext.Provider, { value: value, children: children }));
};
const useWalletContext = () => {
    const context = useContext(WalletContext);
    if (context === undefined) {
        throw new Error('usage of useWalletContext not wrapped in `WalletContextProvider`.');
    }
    return context;
};

const iframeContainerId$2 = 'dyn-secure-enclave-container-id';
const iframeElementId$2 = 'dyn-secure-enclave-element-id';
const revealIframeContainerId = 'dyn-secure-enclave-export-container-id';
const revealIframeElementId = 'dyn-secure-enclave-export-element-id';
var EmbeddedWalletVersion;
(function (EmbeddedWalletVersion) {
    EmbeddedWalletVersion["V1"] = "V1";
    EmbeddedWalletVersion["V2"] = "V2";
})(EmbeddedWalletVersion || (EmbeddedWalletVersion = {}));

const FooterAnimationContext = createContext(undefined);
const FooterAnimationContextProvider = ({ children, }) => {
    const { view } = useViewContext();
    const [isFooterExpanded, setIsFooterExpanded] = useState(false);
    useEffect(() => {
        setIsFooterExpanded(false);
    }, [view]);
    const value = useMemo(() => ({
        isFooterExpanded,
        setIsFooterExpanded,
    }), [isFooterExpanded]);
    return (jsxRuntimeExports.jsx(FooterAnimationContext.Provider, { value: value, children: jsxRuntimeExports.jsx("div", { children: children }) }));
};
const useFooterAnimationContext = () => {
    const context = useContext(FooterAnimationContext);
    if (!context)
        throw new Error('Can only call useFooterAnimationContext inside FooterAnimationContextProvider');
    return context;
};

var _path$1j;
var _excluded$1x = ["title", "titleId"];
function _extends$1y() { return _extends$1y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1y.apply(null, arguments); }
function _objectWithoutProperties$1x(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1z(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1z(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgError = function SvgError(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1x(_ref, _excluded$1x);
  return /*#__PURE__*/React.createElement("svg", _extends$1y({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$1j || (_path$1j = /*#__PURE__*/React.createElement("path", {
    d: "M9.99 0C4.47 0 0 4.48 0 10s4.47 10 9.99 10C15.52 20 20 15.52 20 10S15.52 0 9.99 0ZM10 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm-1-5h2v2H9v-2Zm0-8h2v6H9V5Z",
    fill: "currentcolor"
  })));
};

const Icon = ({ children, className = '', color, size, }) => {
    const effectiveClassName = classNames(className, color ? `icon--color-${color}` : '', size ? `icon--size-${size}` : '');
    return cloneElement(children, { className: effectiveClassName });
};

const Typography = (_a) => {
    var { as: Tag = 'p', variant, weight, color = 'primary', transform, className = '', truncate = false, style } = _a, props = __rest(_a, ["as", "variant", "weight", "color", "transform", "className", "truncate", "style"]);
    const variantClassNameMap = {
        body_mini: 'typography--body-mini',
        body_normal: 'typography--body-normal',
        body_small: 'typography--body-small',
        button_primary: 'typography--button-primary',
        button_secondary: 'typography--button-secondary',
        button_tertiary: 'typography--button-tertiary',
        numbers_big: 'typography--numbers-big',
        numbers_medium: 'typography--numbers-medium',
        title: 'typography--title',
    };
    const weightClassNameMap = {
        bold: 'typography--bold',
        medium: 'typography--medium',
        regular: 'typography--regular',
    };
    const colorClassNameMap = {
        'brand-primary': 'typography--brand-primary',
        'current-color': 'typography--current-color',
        'error-1': 'typography--dynamic-error-1',
        'error-2': 'typography--dynamic-error-2',
        'green-1': 'typography--connection-green-1',
        inherit: 'typography--inherit',
        link: 'typography--link',
        primary: 'typography--primary',
        secondary: 'typography--secondary',
        tertiary: 'typography--tertiary',
        tooltip: 'typography--tooltip',
        white: 'typography--white',
    };
    const transformClassNameMap = {
        uppercase: 'typography--uppercase',
    };
    const effectiveClassName = classNames('typography', variant ? variantClassNameMap[variant] : '', weight ? weightClassNameMap[weight] : '', color ? colorClassNameMap[color] : '', transform ? transformClassNameMap[transform] : '', {
        'typography--truncate': truncate,
    }, className);
    return jsxRuntimeExports.jsx(Tag, Object.assign({ style: style, className: effectiveClassName }, props));
};

const AlertText = ({ content, contentDataTestId, }) => {
    if (typeof content === 'string')
        return (jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'current-color', "data-testid": contentDataTestId, children: content }));
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: content });
};

const errorIconMap = {
    error: jsxRuntimeExports.jsx(SvgError, {}),
};
const Alert = ({ children, icon, variant = 'error', contentDataTestId, className = '', }) => (jsxRuntimeExports.jsxs("div", { className: classNames('alert', `alert--${variant}`, className, {
        'alert--with-icon': Boolean(icon),
    }), children: [icon && (jsxRuntimeExports.jsx(Icon, { size: 'small', className: 'alert__icon', children: typeof icon === 'string' ? errorIconMap[icon] : icon })), jsxRuntimeExports.jsx(AlertText, { content: children, contentDataTestId: contentDataTestId })] }));

const FieldsStateContext = createContext(undefined);
const FieldsStateProvider = ({ children }) => {
    const selectedPhoneCountry = useRef();
    return (jsxRuntimeExports.jsx(FieldsStateContext.Provider, { value: { selectedPhoneCountry }, children: children }));
};
const useFieldsState = () => {
    const context = useContext(FieldsStateContext);
    if (!context)
        throw new DynamicError('Can only call useFieldsState inside FieldsStateProvider');
    return context;
};

const PHONE_NUMBER_REGEX = /^(\+[1-9]\d{1,14})?$/;
// Reserved fields
const NAME_SERVICE_FIELD_NAME = 'name-service-subdomain-handle';

/** Whether phone number is not empty */
const validatePhoneLength = (phone, country) => de({ dialCode: country.dialCode, phone }).length > 0;

const customFieldValidationMap = {
    checkbox: create(),
    select: create$2(),
    text: create$2(),
};
const useFields = () => {
    const { t } = useTranslation();
    const { selectedPhoneCountry } = useFieldsState();
    const fieldsConfig = useMemo(() => ({
        alias: {
            key: 'dyn_collect_user_data.fields.alias.label',
            label: t('dyn_collect_user_data.fields.alias.label'),
            type: 'string',
            validation: create$2().trim(),
        },
        country: {
            key: 'dyn_collect_user_data.fields.country.label',
            label: t('dyn_collect_user_data.fields.country.label'),
            type: 'select',
            validation: create$2().oneOf(countryCodes.map((c) => c.code)),
        },
        email: {
            autoComplete: 'email',
            key: 'dyn_collect_user_data.fields.email.label',
            label: t('dyn_collect_user_data.fields.email.label'),
            type: 'email',
            validation: create$2().email(t('dyn_collect_user_data.fields.email.validation')),
        },
        firstName: {
            key: 'dyn_collect_user_data.fields.first_name.label',
            label: t('dyn_collect_user_data.fields.first_name.label'),
            type: 'string',
            validation: create$2().trim(),
        },
        jobTitle: {
            key: 'dyn_collect_user_data.fields.job_title.label',
            label: t('dyn_collect_user_data.fields.job_title.label'),
            type: 'string',
            validation: create$2().trim(),
        },
        lastName: {
            key: 'dyn_collect_user_data.fields.last_name.label',
            label: t('dyn_collect_user_data.fields.last_name.label'),
            type: 'string',
            validation: create$2().trim(),
        },
        phoneNumber: {
            key: 'dyn_collect_user_data.fields.phone_number.label',
            label: t('dyn_collect_user_data.fields.phone_number.label'),
            type: 'string',
            validation: create$2()
                // Validate length
                .test('length', t('dyn_collect_user_data.fields.phone_number.too_short'), (phone) => {
                if (!selectedPhoneCountry.current)
                    return true;
                // Either it's the full length of a phone number, or empty
                return (phone === undefined ||
                    phone.length === 0 ||
                    validatePhoneLength(phone, selectedPhoneCountry.current));
            })
                // Validate format
                .matches(PHONE_NUMBER_REGEX, t('dyn_collect_user_data.fields.phone_number.validation')),
        },
        policiesConsent: {
            key: 'dyn_collect_user_data.fields.policies_consent.label',
            label: t('dyn_collect_user_data.fields.policies_consent.label'),
            type: 'boolean',
            validation: create$3(),
        },
        tShirtSize: {
            key: 'dyn_collect_user_data.fields.t_shirt_size.label',
            label: t('dyn_collect_user_data.fields.t_shirt_size.label'),
            type: 'select',
            validation: create$2().oneOf(tShirtSizes),
        },
        team: {
            key: 'dyn_collect_user_data.fields.team.label',
            label: t('dyn_collect_user_data.fields.team.label'),
            type: 'select',
            validation: create$2().oneOf(teamNames),
        },
        username: {
            key: 'dyn_collect_user_data.fields.username.label',
            label: t('dyn_collect_user_data.fields.username.label'),
            type: 'string',
            // From chatGPT:
            // - string can contain letters A-Z, a-z, numbers 0-9, or symbols $ ! # % ?
            // - string must be length 3 to 20
            // - string cannot contain consecutive symbols
            validation: create$2().matches(/^(?!.*([$!#%?])\1)[A-Za-z0-9$!#%?_-]{3,20}$/, t('dyn_collect_user_data.fields.username.validation')),
        },
    }), [selectedPhoneCountry, t]);
    return { fieldsConfig };
};

const { getLoadingAndLifecycle, setLoadingAndLifecycle, useLoadingAndLifecycle, } = createStoreState('loadingAndLifecycle');

const walletOptionsState = createStoreState('walletOptions');
const { getWalletOptions, useWalletOptions: useWalletOptions$1 } = walletOptionsState;
const getWalletConnectorOptions = () => getWalletOptions().walletConnectorOptions;
const useWalletConnectorOptions = () => useWalletOptions$1().walletConnectorOptions;
const setWalletConnectorOptions = (walletConnectorOptions) => {
    const options = getWalletOptions();
    walletOptionsState.setWalletOptions(Object.assign(Object.assign({}, options), { walletConnectorOptions }));
};
const getWalletGroups = () => getWalletOptions().groups;
const useWalletGroups = () => useWalletOptions$1().groups;
const setWalletGroups = (groups) => {
    const options = getWalletOptions();
    walletOptionsState.setWalletOptions(Object.assign(Object.assign({}, options), { groups }));
};
/**
 * Merges the current wallet groups with the new groups.
 * @param groups - The new wallet groups to merge.
 */
const mergeWalletGroups = (groups) => {
    const currentGroups = getWalletGroups();
    const mergedGroups = Object.assign(Object.assign({}, currentGroups), groups);
    setWalletGroups(mergedGroups);
};
/**
 * Merges the current wallet connector options with the new options.
 * @param options - The new wallet connector options to merge.
 */
const mergeWalletConnectorOptions = (options) => {
    const currentWalletOptions = getWalletConnectorOptions();
    // Create a unique key for each wallet option based on its key and connected chain
    const getKey = (walletOption) => `${walletOption.key}-${walletOption.walletConnector.connectedChain}`;
    const currentWalletOptionsMap = new Map(currentWalletOptions.map((walletOption) => [
        getKey(walletOption),
        walletOption,
    ]));
    options.forEach((walletOption) => {
        currentWalletOptionsMap.set(getKey(walletOption), walletOption);
    });
    const updatedWalletOptions = Array.from(currentWalletOptionsMap.values());
    setWalletConnectorOptions(updatedWalletOptions);
};

const IconButton = forwardRef((_a, ref) => {
    var { className = '', color } = _a, props = __rest(_a, ["className", "color"]);
    return (jsxRuntimeExports.jsx("button", Object.assign({}, props, { className: classNames('icon-button', className), ref: ref })));
});
IconButton.displayName = 'IconButton';

const InlineWidget = forwardRef(({ children, className, dataTestId }, ref) => (jsxRuntimeExports.jsx("div", { ref: ref, "data-testid": dataTestId, className: classNames('inline-widget', className), children: children })));
InlineWidget.displayName = 'InlineWidget';

const Input = forwardRef((_a, ref) => {
    var { className = '', id, label, type, onChange, onBlur, name, value, optional, error = false, success = false, disabled, message, placeholder, variant = 'dense', suffix, containerClassName } = _a, rest = __rest(_a, ["className", "id", "label", "type", "onChange", "onBlur", "name", "value", "optional", "error", "success", "disabled", "message", "placeholder", "variant", "suffix", "containerClassName"]);
    return (jsxRuntimeExports.jsxs("div", { className: classNames('input__container', containerClassName, {
            'input__container--dense': variant === 'dense',
            'input__container--regular': variant === 'regular',
        }), children: [jsxRuntimeExports.jsx("input", Object.assign({}, rest, { name: name, value: value, onChange: onChange, onBlur: onBlur, type: type, id: id, placeholder: variant === 'regular' || !label ? placeholder : label, disabled: disabled, className: classNames('input', className, {
                    'input--no-label': !label,
                    input__error: error,
                    input__has_trailing: optional,
                    input__success: success,
                }), ref: ref })), jsxRuntimeExports.jsx("label", { htmlFor: id, className: classNames('input__label'), children: label }), suffix && jsxRuntimeExports.jsx("div", { className: classNames('input__suffix'), children: suffix }), optional && jsxRuntimeExports.jsx("span", { className: 'input__trailing', children: "Optional" }), Boolean(message) && (jsxRuntimeExports.jsx(Typography, { variant: 'body_mini', className: classNames('input__message', {
                    input__message__error: error,
                    input__message__success: success,
                }), children: message }))] }));
});
Input.displayName = 'Input';

/**
 * This allows us to ignore nested IsBrowser components.
 */
const IsNestedBrowserContext = createContext(false);
const IsBrowser = ({ children }) => {
    const isNested = useContext(IsNestedBrowserContext);
    const [isBrowser, setIsBrowser] = useState(false);
    // this useEffect does not run during SSR
    useEffect(() => {
        setIsBrowser(true);
    }, []);
    if (isBrowser || isNested)
        return (jsxRuntimeExports.jsx(IsNestedBrowserContext.Provider, { value: true, children: children }));
    // Justification: We specifically need to return an element instead of null
    // in order to have stable content during SSR
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};

const useOnClickOutside = (ref, handler) => {
    const handlerRef = useRef(handler);
    handlerRef.current = handler;
    useEffect(() => {
        if (!ref)
            return;
        const listener = (event) => {
            event.stopPropagation();
            const realTarget = event.composedPath().shift();
            const refCurrent = 'current' in ref ? ref.current : ref;
            if (!refCurrent ||
                refCurrent.contains(event.currentTarget) ||
                refCurrent.contains(realTarget)) {
                return;
            }
            handlerRef.current(event);
        };
        document.addEventListener('touchstart', listener);
        document.addEventListener('click', listener);
        return () => {
            document.removeEventListener('touchstart', listener);
            document.removeEventListener('click', listener);
        };
    }, [ref]);
};

// Allows access to a forwarded ref's "current" field
// source: https://stackoverflow.com/questions/73015696/whats-the-difference-between-reacts-forwardedref-and-refobject
//
const useForwardedRef = (ref) => {
    const innerRef = useRef(null);
    useEffect(() => {
        if (!ref)
            return;
        if (typeof ref === 'function') {
            ref(innerRef.current);
        }
        else {
            ref.current = innerRef.current;
        }
    }, [ref, innerRef]);
    return innerRef;
};

const animationFrameTimeout = (callback, duration) => {
    const startTime = performance.now();
    const canceller = { id: -1 };
    const tick = () => {
        canceller.id = requestAnimationFrame((now) => {
            if (now - startTime > duration) {
                callback();
            }
            else {
                tick();
            }
        });
    };
    tick();
    return canceller;
};
const clearAnimationFrameTimeout = (canceller) => {
    if (canceller.id)
        cancelAnimationFrame(canceller.id);
};

const useIsFirstRender = () => {
    const isFirst = useRef(true);
    // force it to be false on second client render only avoiding SSR issues
    useEffect(() => {
        if (isFirst.current) {
            isFirst.current = false;
        }
    }, []);
    return isFirst.current;
};

const useUpdateEffect = (effect, deps) => {
    const isFirst = useIsFirstRender();
    useEffect(() => {
        if (!isFirst) {
            return effect();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};

const useTransitionEvents = (stage, events) => {
    const mapCallbackToStage = {
        ENTERED: events === null || events === void 0 ? void 0 : events.onEntered,
        ENTERING: events === null || events === void 0 ? void 0 : events.onEntering,
        EXITING: events === null || events === void 0 ? void 0 : events.onExiting,
        UNMOUNT: events === null || events === void 0 ? void 0 : events.onUnmount,
    };
    return useUpdateEffect(() => {
        var _a;
        (_a = mapCallbackToStage[stage]) === null || _a === void 0 ? void 0 : _a.call(mapCallbackToStage);
        return () => {
            var _a;
            if (stage === 'EXITING') {
                (_a = mapCallbackToStage.UNMOUNT) === null || _a === void 0 ? void 0 : _a.call(mapCallbackToStage);
            }
        };
    }, [stage]);
};

const DEFAULT_DURATION = 100;
// The hook inspired by https://github.com/reactjs/react-transition-group/blob/master/src/Transition.js
const useTransition = (_a) => {
    var { isShown, inDuration, outDuration, duration = DEFAULT_DURATION, delay, inDelay, outDelay, animateOnMount = true } = _a, events = __rest(_a, ["isShown", "inDuration", "outDuration", "duration", "delay", "inDelay", "outDelay", "animateOnMount"]);
    const initialStage = animateOnMount ? 'UNMOUNT' : 'ENTERED';
    const animationFrameTimeoutIdRef = useRef({ id: -1 });
    const timeoutIdRef = useRef({ id: -1 });
    const [stage, setStage] = useState(initialStage);
    const [mount, setMount] = useState(!animateOnMount);
    const [currentDuration, setCurrentDuration] = useState(duration);
    const performTransition = (runTransition, transitionDelay) => {
        if (transitionDelay) {
            timeoutIdRef.current = animationFrameTimeout(runTransition, transitionDelay);
        }
        else {
            runTransition();
        }
    };
    const performEnter = useCallback(() => {
        const animationDuration = inDuration || duration;
        setCurrentDuration(animationDuration);
        setMount(true);
        setStage('ENTERING');
        animationFrameTimeoutIdRef.current = animationFrameTimeout(() => {
            setStage('ENTERED');
        }, animationDuration);
    }, [duration, inDuration]);
    const performExit = useCallback(() => {
        const animationDuration = outDuration || duration;
        setCurrentDuration(animationDuration);
        setStage('EXITING');
        animationFrameTimeoutIdRef.current = animationFrameTimeout(() => {
            setMount(false);
            setStage('UNMOUNT');
        }, animationDuration);
    }, [duration, outDuration]);
    useEffect(() => {
        if (isShown && stage !== 'ENTERED') {
            const enterDelay = inDelay || delay;
            performTransition(performEnter, enterDelay);
        }
        else if (!isShown && stage !== 'UNMOUNT') {
            const exitDelay = outDelay || delay;
            performTransition(performExit, exitDelay);
        }
        return () => {
            clearAnimationFrameTimeout(animationFrameTimeoutIdRef.current);
            clearAnimationFrameTimeout(timeoutIdRef.current);
        };
    }, [inDelay, outDelay, performEnter, performExit, isShown, delay, stage]);
    useTransitionEvents(stage, events);
    return { currentDuration, mount, stage };
};

const mapTransformOriginToClassName = {
    'bottom-left': 'popper-content__transform-origin-bottom-left',
    'bottom-right': 'popper-content__transform-origin-bottom-right',
    'top-left': 'popper-content__transform-origin-top-left',
    'top-right': 'popper-content__transform-origin-top-right',
};
const PopperContent = forwardRef(({ children, transformOrigin, style, className }, ref) => (jsxRuntimeExports.jsx("div", { "data-testid": 'popper-content', ref: ref, className: classNames('popper-content', mapTransformOriginToClassName[transformOrigin], className), style: style, children: children })));
PopperContent.displayName = 'PopperContent';

const popperContext = createContext(undefined);
const PopperProvider = ({ children }) => {
    const { Provider } = popperContext;
    const containerRef = useRef(null);
    return (jsxRuntimeExports.jsx(Provider, { value: {
            containerRef,
        }, children: jsxRuntimeExports.jsx("div", { ref: containerRef, style: { position: 'relative' }, children: children }) }));
};
const usePopper = () => {
    const context = useContext(popperContext);
    if (!context) {
        throw new Error('To use popper, use the PopperProvider above in the dom hierarchy');
    }
    return context;
};

/** Return element's top-left position relative to root */
const getChildPosition = (root, element) => {
    const rootRect = root.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return {
        left: elementRect.x - rootRect.x,
        top: elementRect.y - rootRect.y,
    };
};

// eslint-disable-next-line multiline-comment-style
/** Allows to render content outside of the current DOM parent and specify a reference position
 * To allow for opening and closing of menus, see MenuList and Dropdown components
 */
const Popper = forwardRef(({ anchorRef, anchorOrigin = 'top-left', transformOrigin = 'top-left', children, style, className, }, ref) => {
    const { containerRef } = usePopper();
    const [anchorPosition, setAnchorPosition] = useState();
    const container = containerRef.current;
    // Calculates anchor position based on anchorOrigin's relative position to popper's container
    // and sets up scroll listener to close popper
    useEffect(() => {
        const container = containerRef.current;
        const anchor = anchorRef.current;
        if (!container || !anchor)
            return;
        setAnchorPosition(getChildPosition(container, anchor));
    }, [anchorRef, containerRef, setAnchorPosition]);
    /** Position of the anchor's vertex that was selected by anchorOrigin  */
    const anchorOriginPosition = useMemo(() => {
        var _a;
        const anchorRect = (_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!anchorPosition || !anchorRect)
            return;
        switch (anchorOrigin) {
            case 'top-left':
                return anchorPosition;
            case 'top-right':
                return Object.assign(Object.assign({}, anchorPosition), { left: anchorPosition.left + anchorRect.width });
            case 'bottom-left':
                return Object.assign(Object.assign({}, anchorPosition), { top: anchorPosition.top + anchorRect.height });
            case 'bottom-right':
                return Object.assign(Object.assign({}, anchorPosition), { left: anchorPosition.left + anchorRect.width, top: anchorPosition.top + anchorRect.height });
            default:
                return undefined;
        }
    }, [anchorPosition, anchorRef, anchorOrigin]);
    if (!anchorOriginPosition || container === null)
        return null;
    return createPortal(jsxRuntimeExports.jsx(PopperContent, { ref: ref, transformOrigin: transformOrigin, style: Object.assign(Object.assign({}, anchorOriginPosition), style), className: className, children: children }), container);
});
Popper.displayName = 'Popper';

const isScrollable = (element) => {
    const hasScrollableContent = element.scrollHeight > element.clientHeight;
    // It's not enough because the element's `overflow-y` style can be set as
    // * `hidden`
    // * `hidden !important`
    // In those cases, the scrollbar isn't shown
    const overflowYStyle = window.getComputedStyle(element).overflowY;
    const isOverflowHidden = overflowYStyle.indexOf('hidden') !== -1;
    return hasScrollableContent && !isOverflowHidden;
};

// eslint-disable-next-line multiline-comment-style
/** Listens for scroll events in all elements in the hierarchy range between the root and the element,
 * and executes the callback whenever it is triggered.
 * @returns A callback to clean up all event listeners created
 */
const watchToScrollInHierarchy = (root, element, callback) => {
    const elementsWithListener = [];
    let currentElement = element;
    while (currentElement !== null) {
        const reachedRoot = currentElement === root;
        if (isScrollable(currentElement)) {
            currentElement.addEventListener('scroll', callback);
            elementsWithListener.push(currentElement);
        }
        currentElement = currentElement.parentElement;
        if (reachedRoot) {
            break;
        }
    }
    return () => elementsWithListener.forEach((element) => element.removeEventListener('scroll', callback));
};

const IN_DURATION = 300;
const OUT_DURATION = 300;
const Dropdown = forwardRef((_a, ref) => {
    var { children, isOpen, onClickOutside, onScroll, className, style, maxHeight = 300 } = _a, popperProps = __rest(_a, ["children", "isOpen", "onClickOutside", "onScroll", "className", "style", "maxHeight"]);
    // Get popper container
    const { containerRef } = usePopper();
    // ==============================
    // OPEN/CLOSE LOGIC
    // ==============================
    const contentRef = useForwardedRef(ref);
    // Close on click outside
    useOnClickOutside(contentRef, () => onClickOutside === null || onClickOutside === void 0 ? void 0 : onClickOutside());
    // Listen for scroll events to auto close
    useEffect(() => {
        if (!containerRef.current || !popperProps.anchorRef.current)
            return;
        return watchToScrollInHierarchy(containerRef.current, popperProps.anchorRef.current, () => onScroll === null || onScroll === void 0 ? void 0 : onScroll());
    }, [containerRef, popperProps.anchorRef, onScroll]);
    // ==============================
    // ANIMATIONS
    // ==============================
    const { mount, stage, currentDuration } = useTransition({
        inDuration: IN_DURATION,
        isShown: isOpen,
        outDuration: OUT_DURATION,
    });
    const transitionClassName = classNames({
        'dropdown--entering': stage === 'ENTERING',
        'dropdown--exiting': stage === 'EXITING',
    });
    if (!mount)
        return null;
    return (jsxRuntimeExports.jsx(Popper, Object.assign({}, popperProps, { ref: contentRef, children: jsxRuntimeExports.jsx("div", { className: classNames('dropdown', transitionClassName, className), style: Object.assign({ '--max-height': `${maxHeight}px`, animationDuration: `${currentDuration}ms` }, style), children: children }) })));
});
Dropdown.displayName = 'Dropdown';

// This hook allows us to prevent page from scrolling ie. when a modal is open.
// It adds a class to the html and body elements which disables scrolling.
const usePreventPageScroll = (isOpen) => {
    const disableScroll = () => {
        var _a;
        const html = document.querySelector('html');
        const body = document.querySelector('body');
        /* istanbul ignore next */
        if (!html || !body)
            return;
        // https://developer.mozilla.org/en-US/docs/Web/API/Screen/height
        const deviceScreenHeight = (_a = window === null || window === void 0 ? void 0 : window.screen) === null || _a === void 0 ? void 0 : _a.height;
        const isScrollable = body.scrollHeight > deviceScreenHeight;
        // Don't prevent scroll if the page is not scrollable
        // If we don't know the device screen height, we can't know if the page is scrollable
        /* istanbul ignore else */
        if (!isScrollable || deviceScreenHeight === 0)
            return;
        html.classList.add('dynamic-no-scroll');
        body.classList.add('dynamic-no-scroll');
    };
    const enableScroll = (userScrollCoordinatesBeforeLock) => {
        const html = document.querySelector('html');
        const body = document.querySelector('body');
        /* istanbul ignore next */
        if (!html || !body)
            return;
        html.classList.remove('dynamic-no-scroll');
        body.classList.remove('dynamic-no-scroll');
        // Restore the scroll position when user is using IOS
        /* istanbul ignore else */
        if (isIOS()) {
            window.scrollTo(userScrollCoordinatesBeforeLock.x, userScrollCoordinatesBeforeLock.y);
        }
    };
    useEffect(() => {
        if (!isOpen)
            return;
        const userScrollCoordinatesBeforeLock = {
            x: window.scrollX,
            y: window.scrollY,
        };
        disableScroll();
        return () => {
            enableScroll(userScrollCoordinatesBeforeLock);
        };
    }, [isOpen]);
};

// Easing functions
const EASING_FUNCTION_DEFAULT = 'cubic-bezier(0, 0, 0.24, 1.0)';
// Durations
const DURATION_DEFAULT = 300;

const useForceUpdate = () => {
    const [, setValue] = useState(0);
    return () => setValue((value) => value + 1);
};

/**
 * This is used to track a previous value of a variable.
 *
 * Example:
 *   const someHook = ({ value }) => {
 *     const previousValue = usePrevious(value);
 *     useEffect(() => {
 *      if (previousValue !== value) {
 *        // do something
 *      }
 *     }, [value, previousValue]);
 *   }
 *
 * When someHook is rendered for the first time with value = true, previousValue will be undefined
 * so the condition will be true and the effect will run. When someHook is rendered again with
 * value = true, previousValue will have been set to true so the condition will be false and the
 * effect will not run.
 */
const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
};

const getZoomTransitionDefaultStyles = (duration) => ({
    transition: `transform ${duration}ms linear, opacity ${duration}ms linear`,
});
const transitionStyles$2 = {
    ENTERED: {
        opacity: '1',
        transform: 'scale(1)',
    },
    ENTERING: {
        opacity: '0',
        transform: 'scale(0.9)',
    },
    EXITING: {
        opacity: '0',
        transform: 'scale(1.1)',
    },
};
const UnoptimizedZoomTransition = (_a) => {
    var { children, className } = _a, transitionProps = __rest(_a, ["children", "className"]);
    const { mount, stage, currentDuration } = useTransition(transitionProps);
    const defaultStyles = getZoomTransitionDefaultStyles(currentDuration);
    const stageStyles = transitionStyles$2[stage];
    if (!mount)
        return null;
    return (jsxRuntimeExports.jsx("div", { className: classNames(className, 'zoom-transition__root'), style: Object.assign(Object.assign({}, defaultStyles), stageStyles), children: children }));
};
const ZoomTransition = React__default.memo(UnoptimizedZoomTransition);

const getSlideInUpTransitionDefaultStyles = (duration, curve = EASING_FUNCTION_DEFAULT) => ({
    transition: `transform ${duration}ms ${curve}, opacity ${duration}ms ${curve}`,
});
const transitionStyles$1 = {
    ENTERED: {
        transform: 'translateY(0)',
    },
    ENTERING: {
        transform: 'translateY(50vh)',
    },
    EXITING: {
        transform: 'translateY(50vh)',
    },
};
const UnoptimizedSlideInUpTransition = (_a) => {
    var { children, className, easingFunction } = _a, transitionProps = __rest(_a, ["children", "className", "easingFunction"]);
    const { mount, stage, currentDuration } = useTransition(transitionProps);
    const defaultStyles = getSlideInUpTransitionDefaultStyles(currentDuration, easingFunction);
    const stageStyles = transitionStyles$1[stage];
    if (!mount)
        return null;
    return (jsxRuntimeExports.jsx("div", { className: className, style: Object.assign(Object.assign({}, defaultStyles), stageStyles), children: children }));
};
const SlideInUpTransition = React__default.memo(UnoptimizedSlideInUpTransition);

const getOpacityTransitionDefaultStyles = (duration) => ({
    transition: `opacity ${duration}ms linear`,
});
const transitionStyles = {
    ENTERED: {
        opacity: 1,
    },
    ENTERING: {
        opacity: 0,
    },
    EXITING: {
        opacity: 0,
    },
    UNMOUNT: {
        opacity: 0,
    },
};
const UnoptimizedOpacityTransition = (_a) => {
    var { children, style, className } = _a, transitionProps = __rest(_a, ["children", "style", "className"]);
    const { mount, stage, currentDuration } = useTransition(transitionProps);
    const defaultStyles = getOpacityTransitionDefaultStyles(currentDuration);
    const stageStyles = transitionStyles[stage];
    if (!mount)
        return null;
    return (jsxRuntimeExports.jsx("div", { className: className, style: Object.assign(Object.assign(Object.assign({}, defaultStyles), stageStyles), style), children: children }));
};
const OpacityTransition = React__default.memo(UnoptimizedOpacityTransition);

const ErrorContainer = ({ children, className, isMultiWalletError = false, withIcon = true, variant = 'error', copykey, }) => {
    const effectiveContainerClassName = classNames('error-container', `error-container--${variant}`, className, {
        'error-container--multi-wallet': isMultiWalletError,
    });
    const effectiveErrorClassName = classNames('error', {
        'error--with-icon': withIcon,
    });
    return (jsxRuntimeExports.jsxs("div", { className: effectiveContainerClassName, "data-testid": `error-container--${variant}`, children: [withIcon && jsxRuntimeExports.jsx(SvgError, {}), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', className: effectiveErrorClassName, copykey: copykey, children: children })] }));
};

function _objectWithoutPropertiesLoose$1y(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

var propTypes$1 = {exports: {}};

var reactIs$1 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
	hasRequiredReactIs_production_min$1 = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min$1.AsyncMode=l;reactIs_production_min$1.ConcurrentMode=m;reactIs_production_min$1.ContextConsumer=k;reactIs_production_min$1.ContextProvider=h;reactIs_production_min$1.Element=c;reactIs_production_min$1.ForwardRef=n;reactIs_production_min$1.Fragment=e;reactIs_production_min$1.Lazy=t;reactIs_production_min$1.Memo=r;reactIs_production_min$1.Portal=d;
	reactIs_production_min$1.Profiler=g;reactIs_production_min$1.StrictMode=f;reactIs_production_min$1.Suspense=p;reactIs_production_min$1.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min$1.isConcurrentMode=A;reactIs_production_min$1.isContextConsumer=function(a){return z(a)===k};reactIs_production_min$1.isContextProvider=function(a){return z(a)===h};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min$1.isForwardRef=function(a){return z(a)===n};reactIs_production_min$1.isFragment=function(a){return z(a)===e};reactIs_production_min$1.isLazy=function(a){return z(a)===t};
	reactIs_production_min$1.isMemo=function(a){return z(a)===r};reactIs_production_min$1.isPortal=function(a){return z(a)===d};reactIs_production_min$1.isProfiler=function(a){return z(a)===g};reactIs_production_min$1.isStrictMode=function(a){return z(a)===f};reactIs_production_min$1.isSuspense=function(a){return z(a)===p};
	reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min$1.typeOf=z;
	return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$1.AsyncMode = AsyncMode;
	reactIs_development$1.ConcurrentMode = ConcurrentMode;
	reactIs_development$1.ContextConsumer = ContextConsumer;
	reactIs_development$1.ContextProvider = ContextProvider;
	reactIs_development$1.Element = Element;
	reactIs_development$1.ForwardRef = ForwardRef;
	reactIs_development$1.Fragment = Fragment;
	reactIs_development$1.Lazy = Lazy;
	reactIs_development$1.Memo = Memo;
	reactIs_development$1.Portal = Portal;
	reactIs_development$1.Profiler = Profiler;
	reactIs_development$1.StrictMode = StrictMode;
	reactIs_development$1.Suspense = Suspense;
	reactIs_development$1.isAsyncMode = isAsyncMode;
	reactIs_development$1.isConcurrentMode = isConcurrentMode;
	reactIs_development$1.isContextConsumer = isContextConsumer;
	reactIs_development$1.isContextProvider = isContextProvider;
	reactIs_development$1.isElement = isElement;
	reactIs_development$1.isForwardRef = isForwardRef;
	reactIs_development$1.isFragment = isFragment;
	reactIs_development$1.isLazy = isLazy;
	reactIs_development$1.isMemo = isMemo;
	reactIs_development$1.isPortal = isPortal;
	reactIs_development$1.isProfiler = isProfiler;
	reactIs_development$1.isStrictMode = isStrictMode;
	reactIs_development$1.isSuspense = isSuspense;
	reactIs_development$1.isValidElementType = isValidElementType;
	reactIs_development$1.typeOf = typeOf;
	  })();
	}
	return reactIs_development$1;
}

var hasRequiredReactIs$1;

function requireReactIs$1 () {
	if (hasRequiredReactIs$1) return reactIs$1.exports;
	hasRequiredReactIs$1 = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs$1.exports = requireReactIs_production_min$1();
	} else {
	  reactIs$1.exports = requireReactIs_development$1();
	}
	return reactIs$1.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = /*@__PURE__*/ requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = /*@__PURE__*/ requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs$1();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = /*@__PURE__*/ requireReactPropTypesSecret();
	var has = /*@__PURE__*/ requireHas();
	var checkPropTypes = /*@__PURE__*/ requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = /*@__PURE__*/ requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredPropTypes;

function requirePropTypes () {
	if (hasRequiredPropTypes) return propTypes$1.exports;
	hasRequiredPropTypes = 1;
	if (process.env.NODE_ENV !== 'production') {
	  var ReactIs = requireReactIs$1();

	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  propTypes$1.exports = /*@__PURE__*/ requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  propTypes$1.exports = /*@__PURE__*/ requireFactoryWithThrowingShims()();
	}
	return propTypes$1.exports;
}

var propTypesExports = /*@__PURE__*/ requirePropTypes();
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

/**
 * defines a focus group
 */
var FOCUS_GROUP = 'data-focus-lock';
/**
 * disables element discovery inside a group marked by key
 */
var FOCUS_DISABLED = 'data-focus-lock-disabled';
/**
 * allows uncontrolled focus within the marked area, effectively disabling focus lock for it's content
 */
var FOCUS_ALLOW = 'data-no-focus-lock';
/**
 * instructs autofocus engine to pick default autofocus inside a given node
 * can be set on the element or container
 */
var FOCUS_AUTO = 'data-autofocus-inside';
/**
 * instructs autofocus to ignore elements within a given node
 * can be set on the element or container
 */
var FOCUS_NO_AUTOFOCUS = 'data-no-autofocus';

/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */
function assignRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
    }
    else if (ref) {
        ref.current = value;
    }
    return ref;
}

/**
 * creates a MutableRef with ref change callback
 * @param initialValue - initial ref value
 * @param {Function} callback - a callback to run when value changes
 *
 * @example
 * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
 * ref.current = 1;
 * // prints 0 -> 1
 *
 * @see https://reactjs.org/docs/hooks-reference.html#useref
 * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
 * @returns {MutableRefObject}
 */
function useCallbackRef(initialValue, callback) {
    var ref = useState(function () { return ({
        // value
        value: initialValue,
        // last callback
        callback: callback,
        // "memoized" public interface
        facade: {
            get current() {
                return ref.value;
            },
            set current(value) {
                var last = ref.value;
                if (last !== value) {
                    ref.value = value;
                    ref.callback(value, last);
                }
            },
        },
    }); })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}

var useIsomorphicLayoutEffect$2 = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
var currentValues = new WeakMap();
/**
 * Merges two or more refs together providing a single interface to set their value
 * @param {RefObject|Ref} refs
 * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
 *
 * @see {@link mergeRefs} a version without buit-in memoization
 * @see https://github.com/theKashey/use-callback-ref#usemergerefs
 * @example
 * const Component = React.forwardRef((props, ref) => {
 *   const ownRef = useRef();
 *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
 *   return <div ref={domRef}>...</div>
 * }
 */
function useMergeRefs(refs, defaultValue) {
    var callbackRef = useCallbackRef(null, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
    // handle refs changes - added or removed
    useIsomorphicLayoutEffect$2(function () {
        var oldValue = currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function (ref) {
                if (!nextRefs_1.has(ref)) {
                    assignRef(ref, null);
                }
            });
            nextRefs_1.forEach(function (ref) {
                if (!prevRefs_1.has(ref)) {
                    assignRef(ref, current_1);
                }
            });
        }
        currentValues.set(callbackRef, refs);
    }, [refs]);
    return callbackRef;
}

var hiddenGuard = {
  width: '1px',
  height: '0px',
  padding: 0,
  overflow: 'hidden',
  position: 'fixed',
  top: '1px',
  left: '1px'
};

process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function ItoI(a) {
    return a;
}
function innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function () {
            if (assigned) {
                throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            }
            if (buffer.length) {
                return buffer[buffer.length - 1];
            }
            return defaults;
        },
        useMedium: function (data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function () {
                buffer = buffer.filter(function (x) { return x !== item; });
            };
        },
        assignSyncMedium: function (cb) {
            assigned = true;
            while (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function (x) { return cb(x); },
                filter: function () { return buffer; },
            };
        },
        assignMedium: function (cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function () {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function () { return Promise.resolve().then(executeQueue); };
            cycle();
            buffer = {
                push: function (x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function (filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                },
            };
        },
    };
    return medium;
}
function createMedium(defaults, middleware) {
    if (middleware === void 0) { middleware = ItoI; }
    return innerCreateMedium(defaults, middleware);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function createSidecarMedium(options) {
    if (options === void 0) { options = {}; }
    var medium = innerCreateMedium(null);
    medium.options = __assign({ async: true, ssr: false }, options);
    return medium;
}

var mediumFocus = createMedium({}, function (_ref) {
  var target = _ref.target,
      currentTarget = _ref.currentTarget;
  return {
    target: target,
    currentTarget: currentTarget
  };
});
var mediumBlur = createMedium();
var mediumEffect = createMedium();
var mediumSidecar = createSidecarMedium({
  async: true // focus-lock sidecar is not required on the server
  // however, it might be required for JSDOM tests
  // ssr: true,

});

var emptyArray = [];
var FocusLock = /*#__PURE__*/React.forwardRef(function FocusLockUI(props, parentRef) {
  var _extends2;

  var _React$useState = React.useState(),
      realObserved = _React$useState[0],
      setObserved = _React$useState[1];

  var observed = React.useRef();
  var isActive = React.useRef(false);
  var originalFocusedElement = React.useRef(null);
  var children = props.children,
      disabled = props.disabled,
      noFocusGuards = props.noFocusGuards,
      persistentFocus = props.persistentFocus,
      crossFrame = props.crossFrame,
      autoFocus = props.autoFocus,
      allowTextSelection = props.allowTextSelection,
      group = props.group,
      className = props.className,
      whiteList = props.whiteList,
      hasPositiveIndices = props.hasPositiveIndices,
      _props$shards = props.shards,
      shards = _props$shards === void 0 ? emptyArray : _props$shards,
      _props$as = props.as,
      Container = _props$as === void 0 ? 'div' : _props$as,
      _props$lockProps = props.lockProps,
      containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
      SideCar = props.sideCar,
      shouldReturnFocus = props.returnFocus,
      focusOptions = props.focusOptions,
      onActivationCallback = props.onActivation,
      onDeactivationCallback = props.onDeactivation;

  var _React$useState2 = React.useState({}),
      id = _React$useState2[0]; // SIDE EFFECT CALLBACKS


  var onActivation = React.useCallback(function () {
    originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;

    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }

    isActive.current = true;
  }, [onActivationCallback]);
  var onDeactivation = React.useCallback(function () {
    isActive.current = false;

    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
  }, [onDeactivationCallback]);
  useEffect(function () {
    if (!disabled) {
      // cleanup return focus on trap deactivation
      // sideEffect/returnFocus should happen by this time
      originalFocusedElement.current = null;
    }
  }, []);
  var returnFocus = React.useCallback(function (allowDefer) {
    var returnFocusTo = originalFocusedElement.current;

    if (returnFocusTo && returnFocusTo.focus) {
      var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;

      if (howToReturnFocus) {
        var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
        originalFocusedElement.current = null;

        if (allowDefer) {
          // React might return focus after update
          // it's safer to defer the action
          Promise.resolve().then(function () {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]); // MEDIUM CALLBACKS

  var onFocus = React.useCallback(function (event) {
    if (isActive.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur = mediumBlur.useMedium; // REF PROPAGATION
  // not using real refs due to race conditions

  var setObserveNode = React.useCallback(function (newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof allowTextSelection !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn('React-Focus-Lock: allowTextSelection is deprecated and enabled by default');
    }

    React.useEffect(function () {
      // report incorrect integration - https://github.com/theKashey/react-focus-lock/issues/123
      if (!observed.current && typeof Container !== 'string') {
        // eslint-disable-next-line no-console
        console.error('FocusLock: could not obtain ref to internal node');
      }
    }, []);
  }

  var lockProps = _extends$1E((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && 'disabled', _extends2[FOCUS_GROUP] = group, _extends2), containerProps);

  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
  var mergedRef = useMergeRefs([parentRef, setObserveNode]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, hasLeadingGuards && [
  /*#__PURE__*/
  // nearest focus guard
  React.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }), // first tabbed element guard
  hasPositiveIndices ? /*#__PURE__*/React.createElement("div", {
    key: "guard-nearest",
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 1,
    style: hiddenGuard
  }) : null], !disabled && /*#__PURE__*/React.createElement(SideCar, {
    id: id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled: disabled,
    persistentFocus: persistentFocus,
    crossFrame: crossFrame,
    autoFocus: autoFocus,
    whiteList: whiteList,
    shards: shards,
    onActivation: onActivation,
    onDeactivation: onDeactivation,
    returnFocus: returnFocus,
    focusOptions: focusOptions
  }), /*#__PURE__*/React.createElement(Container, _extends$1E({
    ref: mergedRef
  }, lockProps, {
    className: className,
    onBlur: onBlur,
    onFocus: onFocus
  }), children), hasTailingGuards && /*#__PURE__*/React.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes = process.env.NODE_ENV !== "production" ? {
  children: propTypesExports.node,
  disabled: propTypesExports.bool,
  returnFocus: propTypesExports.oneOfType([propTypesExports.bool, propTypesExports.object, propTypesExports.func]),
  focusOptions: propTypesExports.object,
  noFocusGuards: propTypesExports.bool,
  hasPositiveIndices: propTypesExports.bool,
  allowTextSelection: propTypesExports.bool,
  autoFocus: propTypesExports.bool,
  persistentFocus: propTypesExports.bool,
  crossFrame: propTypesExports.bool,
  group: propTypesExports.string,
  className: propTypesExports.string,
  whiteList: propTypesExports.func,
  shards: propTypesExports.arrayOf(propTypesExports.any),
  as: propTypesExports.oneOfType([propTypesExports.string, propTypesExports.func, propTypesExports.object]),
  lockProps: propTypesExports.object,
  onActivation: propTypesExports.func,
  onDeactivation: propTypesExports.func,
  sideCar: propTypesExports.any.isRequired
} : {};
FocusLock.defaultProps = {
  children: undefined,
  disabled: false,
  returnFocus: false,
  focusOptions: undefined,
  noFocusGuards: false,
  autoFocus: true,
  persistentFocus: false,
  crossFrame: true,
  hasPositiveIndices: undefined,
  allowTextSelection: undefined,
  group: undefined,
  className: undefined,
  whiteList: undefined,
  shards: undefined,
  as: 'div',
  lockProps: {},
  onActivation: undefined,
  onDeactivation: undefined
};

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}

function withSideEffect(reducePropsToState, handleStateChangeOnClient) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof reducePropsToState !== 'function') {
      throw new Error('Expected reducePropsToState to be a function.');
    }

    if (typeof handleStateChangeOnClient !== 'function') {
      throw new Error('Expected handleStateChangeOnClient to be a function.');
    }
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (process.env.NODE_ENV !== "production") {
      if (typeof WrappedComponent !== 'function') {
        throw new Error('Expected WrappedComponent to be a React component.');
      }
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));
      handleStateChangeOnClient(state);
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      var _proto = SideEffect.prototype;

      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    return SideEffect;
  };
}

/*
IE11 support
 */
var toArray = function (a) {
    var ret = Array(a.length);
    for (var i = 0; i < a.length; ++i) {
        ret[i] = a[i];
    }
    return ret;
};
var asArray = function (a) { return (Array.isArray(a) ? a : [a]); };
var getFirst = function (a) { return (Array.isArray(a) ? a[0] : a); };

var isElementHidden = function (node) {
    // we can measure only "elements"
    // consider others as "visible"
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
    }
    var computedStyle = window.getComputedStyle(node, null);
    if (!computedStyle || !computedStyle.getPropertyValue) {
        return false;
    }
    return (computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden');
};
var getParentNode = function (node) {
    // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
    return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
            node.parentNode.host
        : node.parentNode;
};
var isTopNode = function (node) {
    // @ts-ignore
    return node === document || (node && node.nodeType === Node.DOCUMENT_NODE);
};
var isVisibleUncached = function (node, checkParent) {
    return !node || isTopNode(node) || (!isElementHidden(node) && checkParent(getParentNode(node)));
};
var isVisibleCached = function (visibilityCache, node) {
    var cached = visibilityCache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isVisibleUncached(node, isVisibleCached.bind(undefined, visibilityCache));
    visibilityCache.set(node, result);
    return result;
};
var isAutoFocusAllowedUncached = function (node, checkParent) {
    return node && !isTopNode(node) ? (isAutoFocusAllowed(node) ? checkParent(getParentNode(node)) : false) : true;
};
var isAutoFocusAllowedCached = function (cache, node) {
    var cached = cache.get(node);
    if (cached !== undefined) {
        return cached;
    }
    var result = isAutoFocusAllowedUncached(node, isAutoFocusAllowedCached.bind(undefined, cache));
    cache.set(node, result);
    return result;
};
var getDataset = function (node) {
    // @ts-ignore
    return node.dataset;
};
var isHTMLButtonElement = function (node) { return node.tagName === 'BUTTON'; };
var isHTMLInputElement = function (node) { return node.tagName === 'INPUT'; };
var isRadioElement = function (node) {
    return isHTMLInputElement(node) && node.type === 'radio';
};
var notHiddenInput = function (node) {
    return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled));
};
var isAutoFocusAllowed = function (node) {
    var attribute = node.getAttribute(FOCUS_NO_AUTOFOCUS);
    return ![true, 'true', ''].includes(attribute);
};
var isGuard = function (node) { var _a; return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard)); };
var isNotAGuard = function (node) { return !isGuard(node); };
var isDefined = function (x) { return Boolean(x); };

var tabSort = function (a, b) {
    var tabDiff = a.tabIndex - b.tabIndex;
    var indexDiff = a.index - b.index;
    if (tabDiff) {
        if (!a.tabIndex) {
            return 1;
        }
        if (!b.tabIndex) {
            return -1;
        }
    }
    return tabDiff || indexDiff;
};
var orderByTabIndex = function (nodes, filterNegative, keepGuards) {
    return toArray(nodes)
        .map(function (node, index) { return ({
        node: node,
        index: index,
        tabIndex: keepGuards && node.tabIndex === -1 ? ((node.dataset || {}).focusGuard ? 0 : -1) : node.tabIndex,
    }); })
        .filter(function (data) { return !filterNegative || data.tabIndex >= 0; })
        .sort(tabSort);
};

/**
 * list of the object to be considered as focusable
 */
var tabbables = [
    'button:enabled',
    'select:enabled',
    'textarea:enabled',
    'input:enabled',
    // elements with explicit roles will also use explicit tabindex
    // '[role="button"]',
    'a[href]',
    'area[href]',
    'summary',
    'iframe',
    'object',
    'embed',
    'audio[controls]',
    'video[controls]',
    '[tabindex]',
    '[contenteditable]',
    '[autofocus]',
];

var queryTabbables = tabbables.join(',');
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function (parent, withGuards) {
    return toArray((parent.shadowRoot || parent).children).reduce(function (acc, child) {
        return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
    }, []);
};
var getFocusablesWithIFrame = function (parent, withGuards) {
    var _a;
    // contentDocument of iframe will be null if current origin cannot access it
    if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
        return getFocusables([parent.contentDocument.body], withGuards);
    }
    return [parent];
};
var getFocusables = function (parents, withGuards) {
    return parents.reduce(function (acc, parent) {
        var _a;
        var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
        var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function (node) { return getFocusablesWithIFrame(node, withGuards); }));
        return acc.concat(
        // add all tabbables inside and within shadow DOMs in DOM order
        focusableWithIframes, 
        // add if node is tabbable itself
        parent.parentNode
            ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function (node) { return node === parent; })
            : []);
    }, []);
};
/**
 * return a list of focusable nodes within an area marked as "auto-focusable"
 * @param parent
 */
var getParentAutofocusables = function (parent) {
    var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
    return toArray(parentFocus)
        .map(function (node) { return getFocusables([node]); })
        .reduce(function (acc, nodes) { return acc.concat(nodes); }, []);
};

/**
 * given list of focusable elements keeps the ones user can interact with
 * @param nodes
 * @param visibilityCache
 */
var filterFocusable = function (nodes, visibilityCache) {
    return toArray(nodes)
        .filter(function (node) { return isVisibleCached(visibilityCache, node); })
        .filter(function (node) { return notHiddenInput(node); });
};
var filterAutoFocusable = function (nodes, cache) {
    if (cache === void 0) { cache = new Map(); }
    return toArray(nodes).filter(function (node) { return isAutoFocusAllowedCached(cache, node); });
};
/**
 * only tabbable ones
 * (but with guards which would be ignored)
 */
var getTabbableNodes = function (topNodes, visibilityCache, withGuards) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
};
/**
 * actually anything "focusable", not only tabbable
 * (without guards, as long as they are not expected to be focused)
 */
var getAllTabbableNodes = function (topNodes, visibilityCache) {
    return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
/**
 * return list of nodes which are expected to be auto-focused
 * @param topNode
 * @param visibilityCache
 */
var parentAutofocusables = function (topNode, visibilityCache) {
    return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};
/*
 * Determines if element is contained in scope, including nested shadow DOMs
 */
var contains$1 = function (scope, element) {
    if (scope.shadowRoot) {
        return contains$1(scope.shadowRoot, element);
    }
    else {
        if (Object.getPrototypeOf(scope).contains !== undefined &&
            Object.getPrototypeOf(scope).contains.call(scope, element)) {
            return true;
        }
        return toArray(scope.children).some(function (child) {
            var _a;
            if (child instanceof HTMLIFrameElement) {
                var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                if (iframeBody) {
                    return contains$1(iframeBody, element);
                }
                return false;
            }
            return contains$1(child, element);
        });
    }
};

/**
 * in case of multiple nodes nested inside each other
 * keeps only top ones
 * this is O(nlogn)
 * @param nodes
 * @returns {*}
 */
var filterNested = function (nodes) {
    var contained = new Set();
    var l = nodes.length;
    for (var i = 0; i < l; i += 1) {
        for (var j = i + 1; j < l; j += 1) {
            var position = nodes[i].compareDocumentPosition(nodes[j]);
            /* eslint-disable no-bitwise */
            if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
                contained.add(j);
            }
            if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
                contained.add(i);
            }
            /* eslint-enable */
        }
    }
    return nodes.filter(function (_, index) { return !contained.has(index); });
};
/**
 * finds top most parent for a node
 * @param node
 * @returns {*}
 */
var getTopParent = function (node) {
    return node.parentNode ? getTopParent(node.parentNode) : node;
};
/**
 * returns all "focus containers" inside a given node
 * @param node
 * @returns {T}
 */
var getAllAffectedNodes = function (node) {
    var nodes = asArray(node);
    return nodes.filter(Boolean).reduce(function (acc, currentNode) {
        var group = currentNode.getAttribute(FOCUS_GROUP);
        acc.push.apply(acc, (group
            ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, "=\"").concat(group, "\"]:not([").concat(FOCUS_DISABLED, "=\"disabled\"])"))))
            : [currentNode]));
        return acc;
    }, []);
};

var safeProbe = function (cb) {
    try {
        return cb();
    }
    catch (e) {
        return undefined;
    }
};

/**
 * returns active element from document or from nested shadowdoms
 */
var getActiveElement$1 = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    if (!inDocument || !inDocument.activeElement) {
        return undefined;
    }
    var activeElement = inDocument.activeElement;
    return (activeElement.shadowRoot
        ? getActiveElement$1(activeElement.shadowRoot)
        : activeElement instanceof HTMLIFrameElement && safeProbe(function () { return activeElement.contentWindow.document; })
            ? getActiveElement$1(activeElement.contentWindow.document)
            : activeElement);
};

var focusInFrame = function (frame, activeElement) { return frame === activeElement; };
var focusInsideIframe = function (topNode, activeElement) {
    return Boolean(toArray(topNode.querySelectorAll('iframe')).some(function (node) { return focusInFrame(node, activeElement); }));
};
/**
 * @returns {Boolean} true, if the current focus is inside given node or nodes
 */
var focusInside = function (topNode, activeElement) {
    // const activeElement = document && getActiveElement();
    if (activeElement === void 0) { activeElement = getActiveElement$1(getFirst(topNode).ownerDocument); }
    if (!activeElement || (activeElement.dataset && activeElement.dataset.focusGuard)) {
        return false;
    }
    return getAllAffectedNodes(topNode).some(function (node) {
        return contains$1(node, activeElement) || focusInsideIframe(node, activeElement);
    });
};

/**
 * focus is hidden FROM the focus-lock
 * ie contained inside a node focus-lock shall ignore
 * @returns {boolean} focus is currently is in "allow" area
 */
var focusIsHidden = function (inDocument) {
    if (inDocument === void 0) { inDocument = document; }
    var activeElement = getActiveElement$1(inDocument);
    if (!activeElement) {
        return false;
    }
    // this does not support setting FOCUS_ALLOW within shadow dom
    return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function (node) { return contains$1(node, activeElement); });
};

var findSelectedRadio = function (node, nodes) {
    return nodes
        .filter(isRadioElement)
        .filter(function (el) { return el.name === node.name; })
        .filter(function (el) { return el.checked; })[0] || node;
};
var correctNode = function (node, nodes) {
    if (isRadioElement(node) && node.name) {
        return findSelectedRadio(node, nodes);
    }
    return node;
};
/**
 * giving a set of radio inputs keeps only selected (tabbable) ones
 * @param nodes
 */
var correctNodes = function (nodes) {
    // IE11 has no Set(array) constructor
    var resultSet = new Set();
    nodes.forEach(function (node) { return resultSet.add(correctNode(node, nodes)); });
    // using filter to support IE11
    return nodes.filter(function (node) { return resultSet.has(node); });
};

var pickFirstFocus = function (nodes) {
    if (nodes[0] && nodes.length > 1) {
        return correctNode(nodes[0], nodes);
    }
    return nodes[0];
};
var pickFocusable = function (nodes, index) {
    if (nodes.length > 1) {
        return nodes.indexOf(correctNode(nodes[index], nodes));
    }
    return index;
};

var NEW_FOCUS = 'NEW_FOCUS';
/**
 * Main solver for the "find next focus" question
 * @param innerNodes
 * @param outerNodes
 * @param activeElement
 * @param lastNode
 * @returns {number|string|undefined|*}
 */
var newFocus = function (innerNodes, outerNodes, activeElement, lastNode) {
    var cnt = innerNodes.length;
    var firstFocus = innerNodes[0];
    var lastFocus = innerNodes[cnt - 1];
    var isOnGuard = isGuard(activeElement);
    // focus is inside
    if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
        return undefined;
    }
    var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
    var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
    var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
    var indexDiff = activeIndex - lastIndex;
    var firstNodeIndex = outerNodes.indexOf(firstFocus);
    var lastNodeIndex = outerNodes.indexOf(lastFocus);
    var correctedNodes = correctNodes(outerNodes);
    var correctedIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
    var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
    var returnFirstNode = pickFocusable(innerNodes, 0);
    var returnLastNode = pickFocusable(innerNodes, cnt - 1);
    // new focus
    if (activeIndex === -1 || lastNodeInside === -1) {
        return NEW_FOCUS;
    }
    // old focus
    if (!indexDiff && lastNodeInside >= 0) {
        return lastNodeInside;
    }
    // first element
    if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnLastNode;
    }
    // last element
    if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
        return returnFirstNode;
    }
    // jump out, but not on the guard
    if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
        return lastNodeInside;
    }
    // focus above lock
    if (activeIndex <= firstNodeIndex) {
        return returnLastNode;
    }
    // focus below lock
    if (activeIndex > lastNodeIndex) {
        return returnFirstNode;
    }
    // index is inside tab order, but outside Lock
    if (indexDiff) {
        if (Math.abs(indexDiff) > 1) {
            return lastNodeInside;
        }
        return (cnt + lastNodeInside + indexDiff) % cnt;
    }
    // do nothing
    return undefined;
};

var findAutoFocused = function (autoFocusables) {
    return function (node) {
        var _a;
        var autofocus = (_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
        return (
        // @ts-expect-error
        node.autofocus ||
            //
            (autofocus !== undefined && autofocus !== 'false') ||
            //
            autoFocusables.indexOf(node) >= 0);
    };
};
var pickAutofocus = function (nodesIndexes, orderedNodes, groups) {
    var nodes = nodesIndexes.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
    if (autoFocusable && autoFocusable.length) {
        return pickFirstFocus(autoFocusable);
    }
    return pickFirstFocus(filterAutoFocusable(orderedNodes));
};

var getParents = function (node, parents) {
    if (parents === void 0) { parents = []; }
    parents.push(node);
    if (node.parentNode) {
        getParents(node.parentNode.host || node.parentNode, parents);
    }
    return parents;
};
/**
 * finds a parent for both nodeA and nodeB
 * @param nodeA
 * @param nodeB
 * @returns {boolean|*}
 */
var getCommonParent = function (nodeA, nodeB) {
    var parentsA = getParents(nodeA);
    var parentsB = getParents(nodeB);
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < parentsA.length; i += 1) {
        var currentParent = parentsA[i];
        if (parentsB.indexOf(currentParent) >= 0) {
            return currentParent;
        }
    }
    return false;
};
var getTopCommonParent = function (baseActiveElement, leftEntry, rightEntries) {
    var activeElements = asArray(baseActiveElement);
    var leftEntries = asArray(leftEntry);
    var activeElement = activeElements[0];
    var topCommon = false;
    leftEntries.filter(Boolean).forEach(function (entry) {
        topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
        rightEntries.filter(Boolean).forEach(function (subEntry) {
            var common = getCommonParent(activeElement, subEntry);
            if (common) {
                if (!topCommon || contains$1(common, topCommon)) {
                    topCommon = common;
                }
                else {
                    topCommon = getCommonParent(common, topCommon);
                }
            }
        });
    });
    // TODO: add assert here?
    return topCommon;
};
/**
 * return list of nodes which are expected to be autofocused inside a given top nodes
 * @param entries
 * @param visibilityCache
 */
var allParentAutofocusables = function (entries, visibilityCache) {
    return entries.reduce(function (acc, node) { return acc.concat(parentAutofocusables(node, visibilityCache)); }, []);
};

var reorderNodes = function (srcNodes, dstNodes) {
    var remap = new Map();
    // no Set(dstNodes) for IE11 :(
    dstNodes.forEach(function (entity) { return remap.set(entity.node, entity); });
    // remap to dstNodes
    return srcNodes.map(function (node) { return remap.get(node); }).filter(isDefined);
};
/**
 * given top node(s) and the last active element return the element to be focused next
 * @param topNode
 * @param lastNode
 */
var getFocusMerge = function (topNode, lastNode) {
    var activeElement = getActiveElement$1(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
    var visibilityCache = new Map();
    var anyFocusable = getAllTabbableNodes(entries, visibilityCache);
    var innerElements = getTabbableNodes(entries, visibilityCache).filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    });
    if (!innerElements[0]) {
        innerElements = anyFocusable;
        if (!innerElements[0]) {
            return undefined;
        }
    }
    var outerNodes = getAllTabbableNodes([commonParent], visibilityCache).map(function (_a) {
        var node = _a.node;
        return node;
    });
    var orderedInnerElements = reorderNodes(outerNodes, innerElements);
    var innerNodes = orderedInnerElements.map(function (_a) {
        var node = _a.node;
        return node;
    });
    var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode);
    if (newId === NEW_FOCUS) {
        var focusNode = pickAutofocus(anyFocusable, innerNodes, allParentAutofocusables(entries, visibilityCache));
        if (focusNode) {
            return { node: focusNode };
        }
        else {
            console.warn('focus-lock: cannot find any node to move focus into');
            return undefined;
        }
    }
    if (newId === undefined) {
        return newId;
    }
    return orderedInnerElements[newId];
};

/**
 * return list of focusable elements inside a given top node
 * @deprecated use {@link getFocusableIn}. Yep, there is typo in the function name
 */
var getFocusabledIn = function (topNode) {
    var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
    var commonParent = getTopCommonParent(topNode, topNode, entries);
    var visibilityCache = new Map();
    var outerNodes = getTabbableNodes([commonParent], visibilityCache, true);
    var innerElements = getTabbableNodes(entries, visibilityCache)
        .filter(function (_a) {
        var node = _a.node;
        return isNotAGuard(node);
    })
        .map(function (_a) {
        var node = _a.node;
        return node;
    });
    return outerNodes.map(function (_a) {
        var node = _a.node, index = _a.index;
        return ({
            node: node,
            index: index,
            lockItem: innerElements.indexOf(node) >= 0,
            guard: isGuard(node),
        });
    });
};

var focusOn = function (target, focusOptions) {
    if ('focus' in target) {
        target.focus(focusOptions);
    }
    if ('contentWindow' in target && target.contentWindow) {
        target.contentWindow.focus();
    }
};
var guardCount = 0;
var lockDisabled = false;
/**
 * Sets focus at a given node. The last focused element will help to determine which element(first or last) should be focused.
 * HTML markers (see {@link import('./constants').FOCUS_AUTO} constants) can control autofocus
 * @param topNode
 * @param lastNode
 * @param options
 */
var setFocus = function (topNode, lastNode, options) {
    if (options === void 0) { options = {}; }
    var focusable = getFocusMerge(topNode, lastNode);
    if (lockDisabled) {
        return;
    }
    if (focusable) {
        if (guardCount > 2) {
            // tslint:disable-next-line:no-console
            console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' +
                'See https://github.com/theKashey/focus-lock/#focus-fighting');
            lockDisabled = true;
            setTimeout(function () {
                lockDisabled = false;
            }, 1);
            return;
        }
        guardCount++;
        focusOn(focusable.node, options.focusOptions);
        guardCount--;
    }
};

function deferAction(action) {
  // Hidding setImmediate from Webpack to avoid inserting polyfill
  var _window = window,
      setImmediate = _window.setImmediate;

  if (typeof setImmediate !== 'undefined') {
    setImmediate(action);
  } else {
    setTimeout(action, 1);
  }
}

/* eslint-disable no-mixed-operators */

var focusOnBody = function focusOnBody() {
  return document && document.activeElement === document.body;
};

var isFreeFocus = function isFreeFocus() {
  return focusOnBody() || focusIsHidden();
};

var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;

var defaultWhitelist = function defaultWhitelist() {
  return true;
};

var focusWhitelisted = function focusWhitelisted(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};

var recordPortal = function recordPortal(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode: observerNode,
    portaledElement: portaledElement
  };
};

var focusIsPortaledPair = function focusIsPortaledPair(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};

function autoGuard(startIndex, end, step, allNodes) {
  var lastGuard = null;
  var i = startIndex;

  do {
    var item = allNodes[i];

    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i !== startIndex) {
        // we will tab to the next element
        return;
      }

      lastGuard = null;
    } else {
      break;
    }
  } while ((i += step) !== end);

  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}

var extractRef = function extractRef(ref) {
  return ref && 'current' in ref ? ref.current : ref;
};

var focusWasOutside = function focusWasOutside(crossFrameOption) {
  if (crossFrameOption) {
    // with cross frame return true for any value
    return Boolean(focusWasOutsideWindow);
  } // in other case return only of focus went a while aho


  return focusWasOutsideWindow === 'meanwhile';
};

var checkInHost = function checkInHost(check, el, boundary) {
  return el && ( // find host equal to active element and check nested active element
  el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) // dive up
  || el.parentNode && checkInHost(check, el.parentNode, boundary));
};

var withinHost = function withinHost(activeElement, workingArea) {
  return workingArea.some(function (area) {
    return checkInHost(activeElement, area, area);
  });
};

var activateTrap = function activateTrap() {
  var result = false;

  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap,
        observed = _lastActiveTrap.observed,
        persistentFocus = _lastActiveTrap.persistentFocus,
        autoFocus = _lastActiveTrap.autoFocus,
        shards = _lastActiveTrap.shards,
        crossFrame = _lastActiveTrap.crossFrame,
        focusOptions = _lastActiveTrap.focusOptions;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;

    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));

      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !( // active element is "inside" working area
          focusInside(workingArea) || // check for shadow-dom contained elements
          activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              // Check if blur() exists, which is missing on certain elements on IE
              if (activeElement.blur) {
                activeElement.blur();
              }

              document.body.focus();
            } else {
              result = setFocus(workingArea, lastActiveFocus, {
                focusOptions: focusOptions
              });
              lastPortaledElement = {};
            }
          }

          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }

      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = getFocusabledIn(workingArea);
        var focusedIndex = allNodes.map(function (_ref) {
          var node = _ref.node;
          return node;
        }).indexOf(newActiveElement);

        if (focusedIndex > -1) {
          // remove old focus
          allNodes.filter(function (_ref2) {
            var guard = _ref2.guard,
                node = _ref2.node;
            return guard && node.dataset.focusAutoGuard;
          }).forEach(function (_ref3) {
            var node = _ref3.node;
            return node.removeAttribute('tabIndex');
          });
          autoGuard(focusedIndex, allNodes.length, 1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }

  return result;
};

var onTrap = function onTrap(event) {
  if (activateTrap() && event) {
    // prevent scroll jump
    event.stopPropagation();
    event.preventDefault();
  }
};

var onBlur = function onBlur() {
  return deferAction(activateTrap);
};

var onFocus = function onFocus(event) {
  // detect portal
  var source = event.target;
  var currentNode = event.currentTarget;

  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};

var FocusWatcher = function FocusWatcher() {
  return null;
};

process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired
} : {};

var onWindowBlur = function onWindowBlur() {
  focusWasOutsideWindow = 'just'; // using setTimeout to set  this variable after React/sidecar reaction

  setTimeout(function () {
    focusWasOutsideWindow = 'meanwhile';
  }, 0);
};

var attachHandler = function attachHandler() {
  document.addEventListener('focusin', onTrap);
  document.addEventListener('focusout', onBlur);
  window.addEventListener('blur', onWindowBlur);
};

var detachHandler = function detachHandler() {
  document.removeEventListener('focusin', onTrap);
  document.removeEventListener('focusout', onBlur);
  window.removeEventListener('blur', onWindowBlur);
};

function reducePropsToState(propsList) {
  return propsList.filter(function (_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}

function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];

  if (trap && !lastActiveTrap) {
    attachHandler();
  }

  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;

  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation(); // return focus only of last trap was removed

    if (!traps.filter(function (_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      // allow defer is no other trap is awaiting restore
      lastTrap.returnFocus(!trap);
    }
  }

  if (trap) {
    lastActiveFocus = null;

    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }

    activateTrap();
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
} // bind medium


mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function (cb) {
  return cb({
    moveFocusInside: setFocus,
    focusInside: focusInside
  });
});
var FocusTrap = withSideEffect(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);

/* that would be a BREAKING CHANGE!
// delaying sidecar execution till the first usage
const RequireSideCar = (props) => {
  // eslint-disable-next-line global-require
  const SideCar = require('./Trap').default;
  return <SideCar {...props} />;
};
*/

var FocusLockCombination = /*#__PURE__*/React.forwardRef(function FocusLockUICombination(props, ref) {
  return /*#__PURE__*/React.createElement(FocusLock, _extends$1E({
    sideCar: FocusTrap,
    ref: ref
  }, props));
});

var _ref = FocusLock.propTypes || {};
    _ref.sideCar;
    var propTypes = _objectWithoutPropertiesLoose$1y(_ref, ["sideCar"]);

FocusLockCombination.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};

var browser = {};

var canPromise;
var hasRequiredCanPromise;

function requireCanPromise () {
	if (hasRequiredCanPromise) return canPromise;
	hasRequiredCanPromise = 1;
	// can-promise has a crash in some versions of react native that dont have
	// standard global objects
	// https://github.com/soldair/node-qrcode/issues/157

	canPromise = function () {
	  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
	};
	return canPromise;
}

var qrcode = {};

var utils$1 = {};

var hasRequiredUtils$1;

function requireUtils$1 () {
	if (hasRequiredUtils$1) return utils$1;
	hasRequiredUtils$1 = 1;
	let toSJISFunction;
	const CODEWORDS_COUNT = [
	  0, // Not used
	  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
	  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
	  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
	  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
	];

	/**
	 * Returns the QR Code size for the specified version
	 *
	 * @param  {Number} version QR Code version
	 * @return {Number}         size of QR code
	 */
	utils$1.getSymbolSize = function getSymbolSize (version) {
	  if (!version) throw new Error('"version" cannot be null or undefined')
	  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
	  return version * 4 + 17
	};

	/**
	 * Returns the total number of codewords used to store data and EC information.
	 *
	 * @param  {Number} version QR Code version
	 * @return {Number}         Data length in bits
	 */
	utils$1.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
	  return CODEWORDS_COUNT[version]
	};

	/**
	 * Encode data with Bose-Chaudhuri-Hocquenghem
	 *
	 * @param  {Number} data Value to encode
	 * @return {Number}      Encoded value
	 */
	utils$1.getBCHDigit = function (data) {
	  let digit = 0;

	  while (data !== 0) {
	    digit++;
	    data >>>= 1;
	  }

	  return digit
	};

	utils$1.setToSJISFunction = function setToSJISFunction (f) {
	  if (typeof f !== 'function') {
	    throw new Error('"toSJISFunc" is not a valid function.')
	  }

	  toSJISFunction = f;
	};

	utils$1.isKanjiModeEnabled = function () {
	  return typeof toSJISFunction !== 'undefined'
	};

	utils$1.toSJIS = function toSJIS (kanji) {
	  return toSJISFunction(kanji)
	};
	return utils$1;
}

var errorCorrectionLevel = {};

var hasRequiredErrorCorrectionLevel;

function requireErrorCorrectionLevel () {
	if (hasRequiredErrorCorrectionLevel) return errorCorrectionLevel;
	hasRequiredErrorCorrectionLevel = 1;
	(function (exports) {
		exports.L = { bit: 1 };
		exports.M = { bit: 0 };
		exports.Q = { bit: 3 };
		exports.H = { bit: 2 };

		function fromString (string) {
		  if (typeof string !== 'string') {
		    throw new Error('Param is not a string')
		  }

		  const lcStr = string.toLowerCase();

		  switch (lcStr) {
		    case 'l':
		    case 'low':
		      return exports.L

		    case 'm':
		    case 'medium':
		      return exports.M

		    case 'q':
		    case 'quartile':
		      return exports.Q

		    case 'h':
		    case 'high':
		      return exports.H

		    default:
		      throw new Error('Unknown EC Level: ' + string)
		  }
		}

		exports.isValid = function isValid (level) {
		  return level && typeof level.bit !== 'undefined' &&
		    level.bit >= 0 && level.bit < 4
		};

		exports.from = function from (value, defaultValue) {
		  if (exports.isValid(value)) {
		    return value
		  }

		  try {
		    return fromString(value)
		  } catch (e) {
		    return defaultValue
		  }
		}; 
	} (errorCorrectionLevel));
	return errorCorrectionLevel;
}

var bitBuffer;
var hasRequiredBitBuffer;

function requireBitBuffer () {
	if (hasRequiredBitBuffer) return bitBuffer;
	hasRequiredBitBuffer = 1;
	function BitBuffer () {
	  this.buffer = [];
	  this.length = 0;
	}

	BitBuffer.prototype = {

	  get: function (index) {
	    const bufIndex = Math.floor(index / 8);
	    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
	  },

	  put: function (num, length) {
	    for (let i = 0; i < length; i++) {
	      this.putBit(((num >>> (length - i - 1)) & 1) === 1);
	    }
	  },

	  getLengthInBits: function () {
	    return this.length
	  },

	  putBit: function (bit) {
	    const bufIndex = Math.floor(this.length / 8);
	    if (this.buffer.length <= bufIndex) {
	      this.buffer.push(0);
	    }

	    if (bit) {
	      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8));
	    }

	    this.length++;
	  }
	};

	bitBuffer = BitBuffer;
	return bitBuffer;
}

/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */

var bitMatrix;
var hasRequiredBitMatrix;

function requireBitMatrix () {
	if (hasRequiredBitMatrix) return bitMatrix;
	hasRequiredBitMatrix = 1;
	function BitMatrix (size) {
	  if (!size || size < 1) {
	    throw new Error('BitMatrix size must be defined and greater than 0')
	  }

	  this.size = size;
	  this.data = new Uint8Array(size * size);
	  this.reservedBit = new Uint8Array(size * size);
	}

	/**
	 * Set bit value at specified location
	 * If reserved flag is set, this bit will be ignored during masking process
	 *
	 * @param {Number}  row
	 * @param {Number}  col
	 * @param {Boolean} value
	 * @param {Boolean} reserved
	 */
	BitMatrix.prototype.set = function (row, col, value, reserved) {
	  const index = row * this.size + col;
	  this.data[index] = value;
	  if (reserved) this.reservedBit[index] = true;
	};

	/**
	 * Returns bit value at specified location
	 *
	 * @param  {Number}  row
	 * @param  {Number}  col
	 * @return {Boolean}
	 */
	BitMatrix.prototype.get = function (row, col) {
	  return this.data[row * this.size + col]
	};

	/**
	 * Applies xor operator at specified location
	 * (used during masking process)
	 *
	 * @param {Number}  row
	 * @param {Number}  col
	 * @param {Boolean} value
	 */
	BitMatrix.prototype.xor = function (row, col, value) {
	  this.data[row * this.size + col] ^= value;
	};

	/**
	 * Check if bit at specified location is reserved
	 *
	 * @param {Number}   row
	 * @param {Number}   col
	 * @return {Boolean}
	 */
	BitMatrix.prototype.isReserved = function (row, col) {
	  return this.reservedBit[row * this.size + col]
	};

	bitMatrix = BitMatrix;
	return bitMatrix;
}

var alignmentPattern = {};

/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

var hasRequiredAlignmentPattern;

function requireAlignmentPattern () {
	if (hasRequiredAlignmentPattern) return alignmentPattern;
	hasRequiredAlignmentPattern = 1;
	(function (exports) {
		const getSymbolSize = requireUtils$1().getSymbolSize;

		/**
		 * Calculate the row/column coordinates of the center module of each alignment pattern
		 * for the specified QR Code version.
		 *
		 * The alignment patterns are positioned symmetrically on either side of the diagonal
		 * running from the top left corner of the symbol to the bottom right corner.
		 *
		 * Since positions are simmetrical only half of the coordinates are returned.
		 * Each item of the array will represent in turn the x and y coordinate.
		 * @see {@link getPositions}
		 *
		 * @param  {Number} version QR Code version
		 * @return {Array}          Array of coordinate
		 */
		exports.getRowColCoords = function getRowColCoords (version) {
		  if (version === 1) return []

		  const posCount = Math.floor(version / 7) + 2;
		  const size = getSymbolSize(version);
		  const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
		  const positions = [size - 7]; // Last coord is always (size - 7)

		  for (let i = 1; i < posCount - 1; i++) {
		    positions[i] = positions[i - 1] - intervals;
		  }

		  positions.push(6); // First coord is always 6

		  return positions.reverse()
		};

		/**
		 * Returns an array containing the positions of each alignment pattern.
		 * Each array's element represent the center point of the pattern as (x, y) coordinates
		 *
		 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
		 * and filtering out the items that overlaps with finder pattern
		 *
		 * @example
		 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
		 * The alignment patterns, therefore, are to be centered on (row, column)
		 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
		 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
		 * and are not therefore used for alignment patterns.
		 *
		 * let pos = getPositions(7)
		 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
		 *
		 * @param  {Number} version QR Code version
		 * @return {Array}          Array of coordinates
		 */
		exports.getPositions = function getPositions (version) {
		  const coords = [];
		  const pos = exports.getRowColCoords(version);
		  const posLength = pos.length;

		  for (let i = 0; i < posLength; i++) {
		    for (let j = 0; j < posLength; j++) {
		      // Skip if position is occupied by finder patterns
		      if ((i === 0 && j === 0) || // top-left
		          (i === 0 && j === posLength - 1) || // bottom-left
		          (i === posLength - 1 && j === 0)) { // top-right
		        continue
		      }

		      coords.push([pos[i], pos[j]]);
		    }
		  }

		  return coords
		}; 
	} (alignmentPattern));
	return alignmentPattern;
}

var finderPattern = {};

var hasRequiredFinderPattern;

function requireFinderPattern () {
	if (hasRequiredFinderPattern) return finderPattern;
	hasRequiredFinderPattern = 1;
	const getSymbolSize = requireUtils$1().getSymbolSize;
	const FINDER_PATTERN_SIZE = 7;

	/**
	 * Returns an array containing the positions of each finder pattern.
	 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
	 *
	 * @param  {Number} version QR Code version
	 * @return {Array}          Array of coordinates
	 */
	finderPattern.getPositions = function getPositions (version) {
	  const size = getSymbolSize(version);

	  return [
	    // top-left
	    [0, 0],
	    // top-right
	    [size - FINDER_PATTERN_SIZE, 0],
	    // bottom-left
	    [0, size - FINDER_PATTERN_SIZE]
	  ]
	};
	return finderPattern;
}

var maskPattern = {};

/**
 * Data mask pattern reference
 * @type {Object}
 */

var hasRequiredMaskPattern;

function requireMaskPattern () {
	if (hasRequiredMaskPattern) return maskPattern;
	hasRequiredMaskPattern = 1;
	(function (exports) {
		exports.Patterns = {
		  PATTERN000: 0,
		  PATTERN001: 1,
		  PATTERN010: 2,
		  PATTERN011: 3,
		  PATTERN100: 4,
		  PATTERN101: 5,
		  PATTERN110: 6,
		  PATTERN111: 7
		};

		/**
		 * Weighted penalty scores for the undesirable features
		 * @type {Object}
		 */
		const PenaltyScores = {
		  N1: 3,
		  N2: 3,
		  N3: 40,
		  N4: 10
		};

		/**
		 * Check if mask pattern value is valid
		 *
		 * @param  {Number}  mask    Mask pattern
		 * @return {Boolean}         true if valid, false otherwise
		 */
		exports.isValid = function isValid (mask) {
		  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
		};

		/**
		 * Returns mask pattern from a value.
		 * If value is not valid, returns undefined
		 *
		 * @param  {Number|String} value        Mask pattern value
		 * @return {Number}                     Valid mask pattern or undefined
		 */
		exports.from = function from (value) {
		  return exports.isValid(value) ? parseInt(value, 10) : undefined
		};

		/**
		* Find adjacent modules in row/column with the same color
		* and assign a penalty value.
		*
		* Points: N1 + i
		* i is the amount by which the number of adjacent modules of the same color exceeds 5
		*/
		exports.getPenaltyN1 = function getPenaltyN1 (data) {
		  const size = data.size;
		  let points = 0;
		  let sameCountCol = 0;
		  let sameCountRow = 0;
		  let lastCol = null;
		  let lastRow = null;

		  for (let row = 0; row < size; row++) {
		    sameCountCol = sameCountRow = 0;
		    lastCol = lastRow = null;

		    for (let col = 0; col < size; col++) {
		      let module = data.get(row, col);
		      if (module === lastCol) {
		        sameCountCol++;
		      } else {
		        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
		        lastCol = module;
		        sameCountCol = 1;
		      }

		      module = data.get(col, row);
		      if (module === lastRow) {
		        sameCountRow++;
		      } else {
		        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
		        lastRow = module;
		        sameCountRow = 1;
		      }
		    }

		    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5);
		    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5);
		  }

		  return points
		};

		/**
		 * Find 2x2 blocks with the same color and assign a penalty value
		 *
		 * Points: N2 * (m - 1) * (n - 1)
		 */
		exports.getPenaltyN2 = function getPenaltyN2 (data) {
		  const size = data.size;
		  let points = 0;

		  for (let row = 0; row < size - 1; row++) {
		    for (let col = 0; col < size - 1; col++) {
		      const last = data.get(row, col) +
		        data.get(row, col + 1) +
		        data.get(row + 1, col) +
		        data.get(row + 1, col + 1);

		      if (last === 4 || last === 0) points++;
		    }
		  }

		  return points * PenaltyScores.N2
		};

		/**
		 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
		 * preceded or followed by light area 4 modules wide
		 *
		 * Points: N3 * number of pattern found
		 */
		exports.getPenaltyN3 = function getPenaltyN3 (data) {
		  const size = data.size;
		  let points = 0;
		  let bitsCol = 0;
		  let bitsRow = 0;

		  for (let row = 0; row < size; row++) {
		    bitsCol = bitsRow = 0;
		    for (let col = 0; col < size; col++) {
		      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col);
		      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;

		      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row);
		      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
		    }
		  }

		  return points * PenaltyScores.N3
		};

		/**
		 * Calculate proportion of dark modules in entire symbol
		 *
		 * Points: N4 * k
		 *
		 * k is the rating of the deviation of the proportion of dark modules
		 * in the symbol from 50% in steps of 5%
		 */
		exports.getPenaltyN4 = function getPenaltyN4 (data) {
		  let darkCount = 0;
		  const modulesCount = data.data.length;

		  for (let i = 0; i < modulesCount; i++) darkCount += data.data[i];

		  const k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10);

		  return k * PenaltyScores.N4
		};

		/**
		 * Return mask value at given position
		 *
		 * @param  {Number} maskPattern Pattern reference value
		 * @param  {Number} i           Row
		 * @param  {Number} j           Column
		 * @return {Boolean}            Mask value
		 */
		function getMaskAt (maskPattern, i, j) {
		  switch (maskPattern) {
		    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
		    case exports.Patterns.PATTERN001: return i % 2 === 0
		    case exports.Patterns.PATTERN010: return j % 3 === 0
		    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
		    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
		    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
		    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
		    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

		    default: throw new Error('bad maskPattern:' + maskPattern)
		  }
		}

		/**
		 * Apply a mask pattern to a BitMatrix
		 *
		 * @param  {Number}    pattern Pattern reference number
		 * @param  {BitMatrix} data    BitMatrix data
		 */
		exports.applyMask = function applyMask (pattern, data) {
		  const size = data.size;

		  for (let col = 0; col < size; col++) {
		    for (let row = 0; row < size; row++) {
		      if (data.isReserved(row, col)) continue
		      data.xor(row, col, getMaskAt(pattern, row, col));
		    }
		  }
		};

		/**
		 * Returns the best mask pattern for data
		 *
		 * @param  {BitMatrix} data
		 * @return {Number} Mask pattern reference number
		 */
		exports.getBestMask = function getBestMask (data, setupFormatFunc) {
		  const numPatterns = Object.keys(exports.Patterns).length;
		  let bestPattern = 0;
		  let lowerPenalty = Infinity;

		  for (let p = 0; p < numPatterns; p++) {
		    setupFormatFunc(p);
		    exports.applyMask(p, data);

		    // Calculate penalty
		    const penalty =
		      exports.getPenaltyN1(data) +
		      exports.getPenaltyN2(data) +
		      exports.getPenaltyN3(data) +
		      exports.getPenaltyN4(data);

		    // Undo previously applied mask
		    exports.applyMask(p, data);

		    if (penalty < lowerPenalty) {
		      lowerPenalty = penalty;
		      bestPattern = p;
		    }
		  }

		  return bestPattern
		}; 
	} (maskPattern));
	return maskPattern;
}

var errorCorrectionCode = {};

var hasRequiredErrorCorrectionCode;

function requireErrorCorrectionCode () {
	if (hasRequiredErrorCorrectionCode) return errorCorrectionCode;
	hasRequiredErrorCorrectionCode = 1;
	const ECLevel = requireErrorCorrectionLevel();

	const EC_BLOCKS_TABLE = [
	// L  M  Q  H
	  1, 1, 1, 1,
	  1, 1, 1, 1,
	  1, 1, 2, 2,
	  1, 2, 2, 4,
	  1, 2, 4, 4,
	  2, 4, 4, 4,
	  2, 4, 6, 5,
	  2, 4, 6, 6,
	  2, 5, 8, 8,
	  4, 5, 8, 8,
	  4, 5, 8, 11,
	  4, 8, 10, 11,
	  4, 9, 12, 16,
	  4, 9, 16, 16,
	  6, 10, 12, 18,
	  6, 10, 17, 16,
	  6, 11, 16, 19,
	  6, 13, 18, 21,
	  7, 14, 21, 25,
	  8, 16, 20, 25,
	  8, 17, 23, 25,
	  9, 17, 23, 34,
	  9, 18, 25, 30,
	  10, 20, 27, 32,
	  12, 21, 29, 35,
	  12, 23, 34, 37,
	  12, 25, 34, 40,
	  13, 26, 35, 42,
	  14, 28, 38, 45,
	  15, 29, 40, 48,
	  16, 31, 43, 51,
	  17, 33, 45, 54,
	  18, 35, 48, 57,
	  19, 37, 51, 60,
	  19, 38, 53, 63,
	  20, 40, 56, 66,
	  21, 43, 59, 70,
	  22, 45, 62, 74,
	  24, 47, 65, 77,
	  25, 49, 68, 81
	];

	const EC_CODEWORDS_TABLE = [
	// L  M  Q  H
	  7, 10, 13, 17,
	  10, 16, 22, 28,
	  15, 26, 36, 44,
	  20, 36, 52, 64,
	  26, 48, 72, 88,
	  36, 64, 96, 112,
	  40, 72, 108, 130,
	  48, 88, 132, 156,
	  60, 110, 160, 192,
	  72, 130, 192, 224,
	  80, 150, 224, 264,
	  96, 176, 260, 308,
	  104, 198, 288, 352,
	  120, 216, 320, 384,
	  132, 240, 360, 432,
	  144, 280, 408, 480,
	  168, 308, 448, 532,
	  180, 338, 504, 588,
	  196, 364, 546, 650,
	  224, 416, 600, 700,
	  224, 442, 644, 750,
	  252, 476, 690, 816,
	  270, 504, 750, 900,
	  300, 560, 810, 960,
	  312, 588, 870, 1050,
	  336, 644, 952, 1110,
	  360, 700, 1020, 1200,
	  390, 728, 1050, 1260,
	  420, 784, 1140, 1350,
	  450, 812, 1200, 1440,
	  480, 868, 1290, 1530,
	  510, 924, 1350, 1620,
	  540, 980, 1440, 1710,
	  570, 1036, 1530, 1800,
	  570, 1064, 1590, 1890,
	  600, 1120, 1680, 1980,
	  630, 1204, 1770, 2100,
	  660, 1260, 1860, 2220,
	  720, 1316, 1950, 2310,
	  750, 1372, 2040, 2430
	];

	/**
	 * Returns the number of error correction block that the QR Code should contain
	 * for the specified version and error correction level.
	 *
	 * @param  {Number} version              QR Code version
	 * @param  {Number} errorCorrectionLevel Error correction level
	 * @return {Number}                      Number of error correction blocks
	 */
	errorCorrectionCode.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
	  switch (errorCorrectionLevel) {
	    case ECLevel.L:
	      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
	    case ECLevel.M:
	      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
	    case ECLevel.Q:
	      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
	    case ECLevel.H:
	      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
	    default:
	      return undefined
	  }
	};

	/**
	 * Returns the number of error correction codewords to use for the specified
	 * version and error correction level.
	 *
	 * @param  {Number} version              QR Code version
	 * @param  {Number} errorCorrectionLevel Error correction level
	 * @return {Number}                      Number of error correction codewords
	 */
	errorCorrectionCode.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
	  switch (errorCorrectionLevel) {
	    case ECLevel.L:
	      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
	    case ECLevel.M:
	      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
	    case ECLevel.Q:
	      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
	    case ECLevel.H:
	      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
	    default:
	      return undefined
	  }
	};
	return errorCorrectionCode;
}

var polynomial = {};

var galoisField = {};

var hasRequiredGaloisField;

function requireGaloisField () {
	if (hasRequiredGaloisField) return galoisField;
	hasRequiredGaloisField = 1;
	const EXP_TABLE = new Uint8Array(512);
	const LOG_TABLE = new Uint8Array(256)
	/**
	 * Precompute the log and anti-log tables for faster computation later
	 *
	 * For each possible value in the galois field 2^8, we will pre-compute
	 * the logarithm and anti-logarithm (exponential) of this value
	 *
	 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
	 */
	;(function initTables () {
	  let x = 1;
	  for (let i = 0; i < 255; i++) {
	    EXP_TABLE[i] = x;
	    LOG_TABLE[x] = i;

	    x <<= 1; // multiply by 2

	    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
	    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
	    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
	      x ^= 0x11D;
	    }
	  }

	  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
	  // stay inside the bounds (because we will mainly use this table for the multiplication of
	  // two GF numbers, no more).
	  // @see {@link mul}
	  for (let i = 255; i < 512; i++) {
	    EXP_TABLE[i] = EXP_TABLE[i - 255];
	  }
	}());

	/**
	 * Returns log value of n inside Galois Field
	 *
	 * @param  {Number} n
	 * @return {Number}
	 */
	galoisField.log = function log (n) {
	  if (n < 1) throw new Error('log(' + n + ')')
	  return LOG_TABLE[n]
	};

	/**
	 * Returns anti-log value of n inside Galois Field
	 *
	 * @param  {Number} n
	 * @return {Number}
	 */
	galoisField.exp = function exp (n) {
	  return EXP_TABLE[n]
	};

	/**
	 * Multiplies two number inside Galois Field
	 *
	 * @param  {Number} x
	 * @param  {Number} y
	 * @return {Number}
	 */
	galoisField.mul = function mul (x, y) {
	  if (x === 0 || y === 0) return 0

	  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
	  // @see {@link initTables}
	  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
	};
	return galoisField;
}

var hasRequiredPolynomial;

function requirePolynomial () {
	if (hasRequiredPolynomial) return polynomial;
	hasRequiredPolynomial = 1;
	(function (exports) {
		const GF = requireGaloisField();

		/**
		 * Multiplies two polynomials inside Galois Field
		 *
		 * @param  {Uint8Array} p1 Polynomial
		 * @param  {Uint8Array} p2 Polynomial
		 * @return {Uint8Array}    Product of p1 and p2
		 */
		exports.mul = function mul (p1, p2) {
		  const coeff = new Uint8Array(p1.length + p2.length - 1);

		  for (let i = 0; i < p1.length; i++) {
		    for (let j = 0; j < p2.length; j++) {
		      coeff[i + j] ^= GF.mul(p1[i], p2[j]);
		    }
		  }

		  return coeff
		};

		/**
		 * Calculate the remainder of polynomials division
		 *
		 * @param  {Uint8Array} divident Polynomial
		 * @param  {Uint8Array} divisor  Polynomial
		 * @return {Uint8Array}          Remainder
		 */
		exports.mod = function mod (divident, divisor) {
		  let result = new Uint8Array(divident);

		  while ((result.length - divisor.length) >= 0) {
		    const coeff = result[0];

		    for (let i = 0; i < divisor.length; i++) {
		      result[i] ^= GF.mul(divisor[i], coeff);
		    }

		    // remove all zeros from buffer head
		    let offset = 0;
		    while (offset < result.length && result[offset] === 0) offset++;
		    result = result.slice(offset);
		  }

		  return result
		};

		/**
		 * Generate an irreducible generator polynomial of specified degree
		 * (used by Reed-Solomon encoder)
		 *
		 * @param  {Number} degree Degree of the generator polynomial
		 * @return {Uint8Array}    Buffer containing polynomial coefficients
		 */
		exports.generateECPolynomial = function generateECPolynomial (degree) {
		  let poly = new Uint8Array([1]);
		  for (let i = 0; i < degree; i++) {
		    poly = exports.mul(poly, new Uint8Array([1, GF.exp(i)]));
		  }

		  return poly
		}; 
	} (polynomial));
	return polynomial;
}

var reedSolomonEncoder;
var hasRequiredReedSolomonEncoder;

function requireReedSolomonEncoder () {
	if (hasRequiredReedSolomonEncoder) return reedSolomonEncoder;
	hasRequiredReedSolomonEncoder = 1;
	const Polynomial = requirePolynomial();

	function ReedSolomonEncoder (degree) {
	  this.genPoly = undefined;
	  this.degree = degree;

	  if (this.degree) this.initialize(this.degree);
	}

	/**
	 * Initialize the encoder.
	 * The input param should correspond to the number of error correction codewords.
	 *
	 * @param  {Number} degree
	 */
	ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
	  // create an irreducible generator polynomial
	  this.degree = degree;
	  this.genPoly = Polynomial.generateECPolynomial(this.degree);
	};

	/**
	 * Encodes a chunk of data
	 *
	 * @param  {Uint8Array} data Buffer containing input data
	 * @return {Uint8Array}      Buffer containing encoded data
	 */
	ReedSolomonEncoder.prototype.encode = function encode (data) {
	  if (!this.genPoly) {
	    throw new Error('Encoder not initialized')
	  }

	  // Calculate EC for this data block
	  // extends data size to data+genPoly size
	  const paddedData = new Uint8Array(data.length + this.degree);
	  paddedData.set(data);

	  // The error correction codewords are the remainder after dividing the data codewords
	  // by a generator polynomial
	  const remainder = Polynomial.mod(paddedData, this.genPoly);

	  // return EC data blocks (last n byte, where n is the degree of genPoly)
	  // If coefficients number in remainder are less than genPoly degree,
	  // pad with 0s to the left to reach the needed number of coefficients
	  const start = this.degree - remainder.length;
	  if (start > 0) {
	    const buff = new Uint8Array(this.degree);
	    buff.set(remainder, start);

	    return buff
	  }

	  return remainder
	};

	reedSolomonEncoder = ReedSolomonEncoder;
	return reedSolomonEncoder;
}

var version$1 = {};

var mode = {};

var versionCheck = {};

/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */

var hasRequiredVersionCheck;

function requireVersionCheck () {
	if (hasRequiredVersionCheck) return versionCheck;
	hasRequiredVersionCheck = 1;
	versionCheck.isValid = function isValid (version) {
	  return !isNaN(version) && version >= 1 && version <= 40
	};
	return versionCheck;
}

var regex = {};

var hasRequiredRegex;

function requireRegex () {
	if (hasRequiredRegex) return regex;
	hasRequiredRegex = 1;
	const numeric = '[0-9]+';
	const alphanumeric = '[A-Z $%*+\\-./:]+';
	let kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
	  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
	  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
	  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+';
	kanji = kanji.replace(/u/g, '\\u');

	const byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+';

	regex.KANJI = new RegExp(kanji, 'g');
	regex.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g');
	regex.BYTE = new RegExp(byte, 'g');
	regex.NUMERIC = new RegExp(numeric, 'g');
	regex.ALPHANUMERIC = new RegExp(alphanumeric, 'g');

	const TEST_KANJI = new RegExp('^' + kanji + '$');
	const TEST_NUMERIC = new RegExp('^' + numeric + '$');
	const TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$');

	regex.testKanji = function testKanji (str) {
	  return TEST_KANJI.test(str)
	};

	regex.testNumeric = function testNumeric (str) {
	  return TEST_NUMERIC.test(str)
	};

	regex.testAlphanumeric = function testAlphanumeric (str) {
	  return TEST_ALPHANUMERIC.test(str)
	};
	return regex;
}

var hasRequiredMode;

function requireMode () {
	if (hasRequiredMode) return mode;
	hasRequiredMode = 1;
	(function (exports) {
		const VersionCheck = requireVersionCheck();
		const Regex = requireRegex();

		/**
		 * Numeric mode encodes data from the decimal digit set (0 - 9)
		 * (byte values 30HEX to 39HEX).
		 * Normally, 3 data characters are represented by 10 bits.
		 *
		 * @type {Object}
		 */
		exports.NUMERIC = {
		  id: 'Numeric',
		  bit: 1 << 0,
		  ccBits: [10, 12, 14]
		};

		/**
		 * Alphanumeric mode encodes data from a set of 45 characters,
		 * i.e. 10 numeric digits (0 - 9),
		 *      26 alphabetic characters (A - Z),
		 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
		 * Normally, two input characters are represented by 11 bits.
		 *
		 * @type {Object}
		 */
		exports.ALPHANUMERIC = {
		  id: 'Alphanumeric',
		  bit: 1 << 1,
		  ccBits: [9, 11, 13]
		};

		/**
		 * In byte mode, data is encoded at 8 bits per character.
		 *
		 * @type {Object}
		 */
		exports.BYTE = {
		  id: 'Byte',
		  bit: 1 << 2,
		  ccBits: [8, 16, 16]
		};

		/**
		 * The Kanji mode efficiently encodes Kanji characters in accordance with
		 * the Shift JIS system based on JIS X 0208.
		 * The Shift JIS values are shifted from the JIS X 0208 values.
		 * JIS X 0208 gives details of the shift coded representation.
		 * Each two-byte character value is compacted to a 13-bit binary codeword.
		 *
		 * @type {Object}
		 */
		exports.KANJI = {
		  id: 'Kanji',
		  bit: 1 << 3,
		  ccBits: [8, 10, 12]
		};

		/**
		 * Mixed mode will contain a sequences of data in a combination of any of
		 * the modes described above
		 *
		 * @type {Object}
		 */
		exports.MIXED = {
		  bit: -1
		};

		/**
		 * Returns the number of bits needed to store the data length
		 * according to QR Code specifications.
		 *
		 * @param  {Mode}   mode    Data mode
		 * @param  {Number} version QR Code version
		 * @return {Number}         Number of bits
		 */
		exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
		  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

		  if (!VersionCheck.isValid(version)) {
		    throw new Error('Invalid version: ' + version)
		  }

		  if (version >= 1 && version < 10) return mode.ccBits[0]
		  else if (version < 27) return mode.ccBits[1]
		  return mode.ccBits[2]
		};

		/**
		 * Returns the most efficient mode to store the specified data
		 *
		 * @param  {String} dataStr Input data string
		 * @return {Mode}           Best mode
		 */
		exports.getBestModeForData = function getBestModeForData (dataStr) {
		  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
		  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
		  else if (Regex.testKanji(dataStr)) return exports.KANJI
		  else return exports.BYTE
		};

		/**
		 * Return mode name as string
		 *
		 * @param {Mode} mode Mode object
		 * @returns {String}  Mode name
		 */
		exports.toString = function toString (mode) {
		  if (mode && mode.id) return mode.id
		  throw new Error('Invalid mode')
		};

		/**
		 * Check if input param is a valid mode object
		 *
		 * @param   {Mode}    mode Mode object
		 * @returns {Boolean} True if valid mode, false otherwise
		 */
		exports.isValid = function isValid (mode) {
		  return mode && mode.bit && mode.ccBits
		};

		/**
		 * Get mode object from its name
		 *
		 * @param   {String} string Mode name
		 * @returns {Mode}          Mode object
		 */
		function fromString (string) {
		  if (typeof string !== 'string') {
		    throw new Error('Param is not a string')
		  }

		  const lcStr = string.toLowerCase();

		  switch (lcStr) {
		    case 'numeric':
		      return exports.NUMERIC
		    case 'alphanumeric':
		      return exports.ALPHANUMERIC
		    case 'kanji':
		      return exports.KANJI
		    case 'byte':
		      return exports.BYTE
		    default:
		      throw new Error('Unknown mode: ' + string)
		  }
		}

		/**
		 * Returns mode from a value.
		 * If value is not a valid mode, returns defaultValue
		 *
		 * @param  {Mode|String} value        Encoding mode
		 * @param  {Mode}        defaultValue Fallback value
		 * @return {Mode}                     Encoding mode
		 */
		exports.from = function from (value, defaultValue) {
		  if (exports.isValid(value)) {
		    return value
		  }

		  try {
		    return fromString(value)
		  } catch (e) {
		    return defaultValue
		  }
		}; 
	} (mode));
	return mode;
}

var hasRequiredVersion;

function requireVersion () {
	if (hasRequiredVersion) return version$1;
	hasRequiredVersion = 1;
	(function (exports) {
		const Utils = requireUtils$1();
		const ECCode = requireErrorCorrectionCode();
		const ECLevel = requireErrorCorrectionLevel();
		const Mode = requireMode();
		const VersionCheck = requireVersionCheck();

		// Generator polynomial used to encode version information
		const G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0);
		const G18_BCH = Utils.getBCHDigit(G18);

		function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
		  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
		    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
		      return currentVersion
		    }
		  }

		  return undefined
		}

		function getReservedBitsCount (mode, version) {
		  // Character count indicator + mode indicator bits
		  return Mode.getCharCountIndicator(mode, version) + 4
		}

		function getTotalBitsFromDataArray (segments, version) {
		  let totalBits = 0;

		  segments.forEach(function (data) {
		    const reservedBits = getReservedBitsCount(data.mode, version);
		    totalBits += reservedBits + data.getBitsLength();
		  });

		  return totalBits
		}

		function getBestVersionForMixedData (segments, errorCorrectionLevel) {
		  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
		    const length = getTotalBitsFromDataArray(segments, currentVersion);
		    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
		      return currentVersion
		    }
		  }

		  return undefined
		}

		/**
		 * Returns version number from a value.
		 * If value is not a valid version, returns defaultValue
		 *
		 * @param  {Number|String} value        QR Code version
		 * @param  {Number}        defaultValue Fallback value
		 * @return {Number}                     QR Code version number
		 */
		exports.from = function from (value, defaultValue) {
		  if (VersionCheck.isValid(value)) {
		    return parseInt(value, 10)
		  }

		  return defaultValue
		};

		/**
		 * Returns how much data can be stored with the specified QR code version
		 * and error correction level
		 *
		 * @param  {Number} version              QR Code version (1-40)
		 * @param  {Number} errorCorrectionLevel Error correction level
		 * @param  {Mode}   mode                 Data mode
		 * @return {Number}                      Quantity of storable data
		 */
		exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
		  if (!VersionCheck.isValid(version)) {
		    throw new Error('Invalid QR Code version')
		  }

		  // Use Byte mode as default
		  if (typeof mode === 'undefined') mode = Mode.BYTE;

		  // Total codewords for this QR code version (Data + Error correction)
		  const totalCodewords = Utils.getSymbolTotalCodewords(version);

		  // Total number of error correction codewords
		  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);

		  // Total number of data codewords
		  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;

		  if (mode === Mode.MIXED) return dataTotalCodewordsBits

		  const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version);

		  // Return max number of storable codewords
		  switch (mode) {
		    case Mode.NUMERIC:
		      return Math.floor((usableBits / 10) * 3)

		    case Mode.ALPHANUMERIC:
		      return Math.floor((usableBits / 11) * 2)

		    case Mode.KANJI:
		      return Math.floor(usableBits / 13)

		    case Mode.BYTE:
		    default:
		      return Math.floor(usableBits / 8)
		  }
		};

		/**
		 * Returns the minimum version needed to contain the amount of data
		 *
		 * @param  {Segment} data                    Segment of data
		 * @param  {Number} [errorCorrectionLevel=H] Error correction level
		 * @param  {Mode} mode                       Data mode
		 * @return {Number}                          QR Code version
		 */
		exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
		  let seg;

		  const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M);

		  if (Array.isArray(data)) {
		    if (data.length > 1) {
		      return getBestVersionForMixedData(data, ecl)
		    }

		    if (data.length === 0) {
		      return 1
		    }

		    seg = data[0];
		  } else {
		    seg = data;
		  }

		  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
		};

		/**
		 * Returns version information with relative error correction bits
		 *
		 * The version information is included in QR Code symbols of version 7 or larger.
		 * It consists of an 18-bit sequence containing 6 data bits,
		 * with 12 error correction bits calculated using the (18, 6) Golay code.
		 *
		 * @param  {Number} version QR Code version
		 * @return {Number}         Encoded version info bits
		 */
		exports.getEncodedBits = function getEncodedBits (version) {
		  if (!VersionCheck.isValid(version) || version < 7) {
		    throw new Error('Invalid QR Code version')
		  }

		  let d = version << 12;

		  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
		    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH));
		  }

		  return (version << 12) | d
		}; 
	} (version$1));
	return version$1;
}

var formatInfo = {};

var hasRequiredFormatInfo;

function requireFormatInfo () {
	if (hasRequiredFormatInfo) return formatInfo;
	hasRequiredFormatInfo = 1;
	const Utils = requireUtils$1();

	const G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0);
	const G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1);
	const G15_BCH = Utils.getBCHDigit(G15);

	/**
	 * Returns format information with relative error correction bits
	 *
	 * The format information is a 15-bit sequence containing 5 data bits,
	 * with 10 error correction bits calculated using the (15, 5) BCH code.
	 *
	 * @param  {Number} errorCorrectionLevel Error correction level
	 * @param  {Number} mask                 Mask pattern
	 * @return {Number}                      Encoded format information bits
	 */
	formatInfo.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
	  const data = ((errorCorrectionLevel.bit << 3) | mask);
	  let d = data << 10;

	  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
	    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH));
	  }

	  // xor final data with mask pattern in order to ensure that
	  // no combination of Error Correction Level and data mask pattern
	  // will result in an all-zero data string
	  return ((data << 10) | d) ^ G15_MASK
	};
	return formatInfo;
}

var segments = {};

var numericData;
var hasRequiredNumericData;

function requireNumericData () {
	if (hasRequiredNumericData) return numericData;
	hasRequiredNumericData = 1;
	const Mode = requireMode();

	function NumericData (data) {
	  this.mode = Mode.NUMERIC;
	  this.data = data.toString();
	}

	NumericData.getBitsLength = function getBitsLength (length) {
	  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
	};

	NumericData.prototype.getLength = function getLength () {
	  return this.data.length
	};

	NumericData.prototype.getBitsLength = function getBitsLength () {
	  return NumericData.getBitsLength(this.data.length)
	};

	NumericData.prototype.write = function write (bitBuffer) {
	  let i, group, value;

	  // The input data string is divided into groups of three digits,
	  // and each group is converted to its 10-bit binary equivalent.
	  for (i = 0; i + 3 <= this.data.length; i += 3) {
	    group = this.data.substr(i, 3);
	    value = parseInt(group, 10);

	    bitBuffer.put(value, 10);
	  }

	  // If the number of input digits is not an exact multiple of three,
	  // the final one or two digits are converted to 4 or 7 bits respectively.
	  const remainingNum = this.data.length - i;
	  if (remainingNum > 0) {
	    group = this.data.substr(i);
	    value = parseInt(group, 10);

	    bitBuffer.put(value, remainingNum * 3 + 1);
	  }
	};

	numericData = NumericData;
	return numericData;
}

var alphanumericData;
var hasRequiredAlphanumericData;

function requireAlphanumericData () {
	if (hasRequiredAlphanumericData) return alphanumericData;
	hasRequiredAlphanumericData = 1;
	const Mode = requireMode();

	/**
	 * Array of characters available in alphanumeric mode
	 *
	 * As per QR Code specification, to each character
	 * is assigned a value from 0 to 44 which in this case coincides
	 * with the array index
	 *
	 * @type {Array}
	 */
	const ALPHA_NUM_CHARS = [
	  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
	  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
	  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
	  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
	];

	function AlphanumericData (data) {
	  this.mode = Mode.ALPHANUMERIC;
	  this.data = data;
	}

	AlphanumericData.getBitsLength = function getBitsLength (length) {
	  return 11 * Math.floor(length / 2) + 6 * (length % 2)
	};

	AlphanumericData.prototype.getLength = function getLength () {
	  return this.data.length
	};

	AlphanumericData.prototype.getBitsLength = function getBitsLength () {
	  return AlphanumericData.getBitsLength(this.data.length)
	};

	AlphanumericData.prototype.write = function write (bitBuffer) {
	  let i;

	  // Input data characters are divided into groups of two characters
	  // and encoded as 11-bit binary codes.
	  for (i = 0; i + 2 <= this.data.length; i += 2) {
	    // The character value of the first character is multiplied by 45
	    let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;

	    // The character value of the second digit is added to the product
	    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);

	    // The sum is then stored as 11-bit binary number
	    bitBuffer.put(value, 11);
	  }

	  // If the number of input data characters is not a multiple of two,
	  // the character value of the final character is encoded as a 6-bit binary number.
	  if (this.data.length % 2) {
	    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
	  }
	};

	alphanumericData = AlphanumericData;
	return alphanumericData;
}

var encodeUtf8;
var hasRequiredEncodeUtf8;

function requireEncodeUtf8 () {
	if (hasRequiredEncodeUtf8) return encodeUtf8;
	hasRequiredEncodeUtf8 = 1;

	encodeUtf8 = function encodeUtf8 (input) {
	  var result = [];
	  var size = input.length;

	  for (var index = 0; index < size; index++) {
	    var point = input.charCodeAt(index);

	    if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
	      var second = input.charCodeAt(index + 1);

	      if (second >= 0xDC00 && second <= 0xDFFF) {
	        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
	        point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
	        index += 1;
	      }
	    }

	    // US-ASCII
	    if (point < 0x80) {
	      result.push(point);
	      continue
	    }

	    // 2-byte UTF-8
	    if (point < 0x800) {
	      result.push((point >> 6) | 192);
	      result.push((point & 63) | 128);
	      continue
	    }

	    // 3-byte UTF-8
	    if (point < 0xD800 || (point >= 0xE000 && point < 0x10000)) {
	      result.push((point >> 12) | 224);
	      result.push(((point >> 6) & 63) | 128);
	      result.push((point & 63) | 128);
	      continue
	    }

	    // 4-byte UTF-8
	    if (point >= 0x10000 && point <= 0x10FFFF) {
	      result.push((point >> 18) | 240);
	      result.push(((point >> 12) & 63) | 128);
	      result.push(((point >> 6) & 63) | 128);
	      result.push((point & 63) | 128);
	      continue
	    }

	    // Invalid character
	    result.push(0xEF, 0xBF, 0xBD);
	  }

	  return new Uint8Array(result).buffer
	};
	return encodeUtf8;
}

var byteData;
var hasRequiredByteData;

function requireByteData () {
	if (hasRequiredByteData) return byteData;
	hasRequiredByteData = 1;
	const encodeUtf8 = requireEncodeUtf8();
	const Mode = requireMode();

	function ByteData (data) {
	  this.mode = Mode.BYTE;
	  if (typeof (data) === 'string') {
	    data = encodeUtf8(data);
	  }
	  this.data = new Uint8Array(data);
	}

	ByteData.getBitsLength = function getBitsLength (length) {
	  return length * 8
	};

	ByteData.prototype.getLength = function getLength () {
	  return this.data.length
	};

	ByteData.prototype.getBitsLength = function getBitsLength () {
	  return ByteData.getBitsLength(this.data.length)
	};

	ByteData.prototype.write = function (bitBuffer) {
	  for (let i = 0, l = this.data.length; i < l; i++) {
	    bitBuffer.put(this.data[i], 8);
	  }
	};

	byteData = ByteData;
	return byteData;
}

var kanjiData;
var hasRequiredKanjiData;

function requireKanjiData () {
	if (hasRequiredKanjiData) return kanjiData;
	hasRequiredKanjiData = 1;
	const Mode = requireMode();
	const Utils = requireUtils$1();

	function KanjiData (data) {
	  this.mode = Mode.KANJI;
	  this.data = data;
	}

	KanjiData.getBitsLength = function getBitsLength (length) {
	  return length * 13
	};

	KanjiData.prototype.getLength = function getLength () {
	  return this.data.length
	};

	KanjiData.prototype.getBitsLength = function getBitsLength () {
	  return KanjiData.getBitsLength(this.data.length)
	};

	KanjiData.prototype.write = function (bitBuffer) {
	  let i;

	  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
	  // These byte values are shifted from the JIS X 0208 values.
	  // JIS X 0208 gives details of the shift coded representation.
	  for (i = 0; i < this.data.length; i++) {
	    let value = Utils.toSJIS(this.data[i]);

	    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
	    if (value >= 0x8140 && value <= 0x9FFC) {
	      // Subtract 0x8140 from Shift JIS value
	      value -= 0x8140;

	    // For characters with Shift JIS values from 0xE040 to 0xEBBF
	    } else if (value >= 0xE040 && value <= 0xEBBF) {
	      // Subtract 0xC140 from Shift JIS value
	      value -= 0xC140;
	    } else {
	      throw new Error(
	        'Invalid SJIS character: ' + this.data[i] + '\n' +
	        'Make sure your charset is UTF-8')
	    }

	    // Multiply most significant byte of result by 0xC0
	    // and add least significant byte to product
	    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff);

	    // Convert result to a 13-bit binary string
	    bitBuffer.put(value, 13);
	  }
	};

	kanjiData = KanjiData;
	return kanjiData;
}

var dijkstra = {exports: {}};

var hasRequiredDijkstra;

function requireDijkstra () {
	if (hasRequiredDijkstra) return dijkstra.exports;
	hasRequiredDijkstra = 1;
	(function (module) {

		/******************************************************************************
		 * Created 2008-08-19.
		 *
		 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
		 *
		 * Copyright (C) 2008
		 *   Wyatt Baldwin <self@wyattbaldwin.com>
		 *   All rights reserved
		 *
		 * Licensed under the MIT license.
		 *
		 *   http://www.opensource.org/licenses/mit-license.php
		 *
		 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
		 * THE SOFTWARE.
		 *****************************************************************************/
		var dijkstra = {
		  single_source_shortest_paths: function(graph, s, d) {
		    // Predecessor map for each node that has been encountered.
		    // node ID => predecessor node ID
		    var predecessors = {};

		    // Costs of shortest paths from s to all nodes encountered.
		    // node ID => cost
		    var costs = {};
		    costs[s] = 0;

		    // Costs of shortest paths from s to all nodes encountered; differs from
		    // `costs` in that it provides easy access to the node that currently has
		    // the known shortest path from s.
		    // XXX: Do we actually need both `costs` and `open`?
		    var open = dijkstra.PriorityQueue.make();
		    open.push(s, 0);

		    var closest,
		        u, v,
		        cost_of_s_to_u,
		        adjacent_nodes,
		        cost_of_e,
		        cost_of_s_to_u_plus_cost_of_e,
		        cost_of_s_to_v,
		        first_visit;
		    while (!open.empty()) {
		      // In the nodes remaining in graph that have a known cost from s,
		      // find the node, u, that currently has the shortest path from s.
		      closest = open.pop();
		      u = closest.value;
		      cost_of_s_to_u = closest.cost;

		      // Get nodes adjacent to u...
		      adjacent_nodes = graph[u] || {};

		      // ...and explore the edges that connect u to those nodes, updating
		      // the cost of the shortest paths to any or all of those nodes as
		      // necessary. v is the node across the current edge from u.
		      for (v in adjacent_nodes) {
		        if (adjacent_nodes.hasOwnProperty(v)) {
		          // Get the cost of the edge running from u to v.
		          cost_of_e = adjacent_nodes[v];

		          // Cost of s to u plus the cost of u to v across e--this is *a*
		          // cost from s to v that may or may not be less than the current
		          // known cost to v.
		          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

		          // If we haven't visited v yet OR if the current known cost from s to
		          // v is greater than the new cost we just found (cost of s to u plus
		          // cost of u to v across e), update v's cost in the cost list and
		          // update v's predecessor in the predecessor list (it's now u).
		          cost_of_s_to_v = costs[v];
		          first_visit = (typeof costs[v] === 'undefined');
		          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
		            costs[v] = cost_of_s_to_u_plus_cost_of_e;
		            open.push(v, cost_of_s_to_u_plus_cost_of_e);
		            predecessors[v] = u;
		          }
		        }
		      }
		    }

		    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
		      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
		      throw new Error(msg);
		    }

		    return predecessors;
		  },

		  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
		    var nodes = [];
		    var u = d;
		    while (u) {
		      nodes.push(u);
		      predecessors[u];
		      u = predecessors[u];
		    }
		    nodes.reverse();
		    return nodes;
		  },

		  find_path: function(graph, s, d) {
		    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
		    return dijkstra.extract_shortest_path_from_predecessor_list(
		      predecessors, d);
		  },

		  /**
		   * A very naive priority queue implementation.
		   */
		  PriorityQueue: {
		    make: function (opts) {
		      var T = dijkstra.PriorityQueue,
		          t = {},
		          key;
		      opts = opts || {};
		      for (key in T) {
		        if (T.hasOwnProperty(key)) {
		          t[key] = T[key];
		        }
		      }
		      t.queue = [];
		      t.sorter = opts.sorter || T.default_sorter;
		      return t;
		    },

		    default_sorter: function (a, b) {
		      return a.cost - b.cost;
		    },

		    /**
		     * Add a new item to the queue and ensure the highest priority element
		     * is at the front of the queue.
		     */
		    push: function (value, cost) {
		      var item = {value: value, cost: cost};
		      this.queue.push(item);
		      this.queue.sort(this.sorter);
		    },

		    /**
		     * Return the highest priority element in the queue.
		     */
		    pop: function () {
		      return this.queue.shift();
		    },

		    empty: function () {
		      return this.queue.length === 0;
		    }
		  }
		};


		// node.js module exports
		{
		  module.exports = dijkstra;
		} 
	} (dijkstra));
	return dijkstra.exports;
}

var hasRequiredSegments;

function requireSegments () {
	if (hasRequiredSegments) return segments;
	hasRequiredSegments = 1;
	(function (exports) {
		const Mode = requireMode();
		const NumericData = requireNumericData();
		const AlphanumericData = requireAlphanumericData();
		const ByteData = requireByteData();
		const KanjiData = requireKanjiData();
		const Regex = requireRegex();
		const Utils = requireUtils$1();
		const dijkstra = requireDijkstra();

		/**
		 * Returns UTF8 byte length
		 *
		 * @param  {String} str Input string
		 * @return {Number}     Number of byte
		 */
		function getStringByteLength (str) {
		  return unescape(encodeURIComponent(str)).length
		}

		/**
		 * Get a list of segments of the specified mode
		 * from a string
		 *
		 * @param  {Mode}   mode Segment mode
		 * @param  {String} str  String to process
		 * @return {Array}       Array of object with segments data
		 */
		function getSegments (regex, mode, str) {
		  const segments = [];
		  let result;

		  while ((result = regex.exec(str)) !== null) {
		    segments.push({
		      data: result[0],
		      index: result.index,
		      mode: mode,
		      length: result[0].length
		    });
		  }

		  return segments
		}

		/**
		 * Extracts a series of segments with the appropriate
		 * modes from a string
		 *
		 * @param  {String} dataStr Input string
		 * @return {Array}          Array of object with segments data
		 */
		function getSegmentsFromString (dataStr) {
		  const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr);
		  const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr);
		  let byteSegs;
		  let kanjiSegs;

		  if (Utils.isKanjiModeEnabled()) {
		    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr);
		    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr);
		  } else {
		    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr);
		    kanjiSegs = [];
		  }

		  const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);

		  return segs
		    .sort(function (s1, s2) {
		      return s1.index - s2.index
		    })
		    .map(function (obj) {
		      return {
		        data: obj.data,
		        mode: obj.mode,
		        length: obj.length
		      }
		    })
		}

		/**
		 * Returns how many bits are needed to encode a string of
		 * specified length with the specified mode
		 *
		 * @param  {Number} length String length
		 * @param  {Mode} mode     Segment mode
		 * @return {Number}        Bit length
		 */
		function getSegmentBitsLength (length, mode) {
		  switch (mode) {
		    case Mode.NUMERIC:
		      return NumericData.getBitsLength(length)
		    case Mode.ALPHANUMERIC:
		      return AlphanumericData.getBitsLength(length)
		    case Mode.KANJI:
		      return KanjiData.getBitsLength(length)
		    case Mode.BYTE:
		      return ByteData.getBitsLength(length)
		  }
		}

		/**
		 * Merges adjacent segments which have the same mode
		 *
		 * @param  {Array} segs Array of object with segments data
		 * @return {Array}      Array of object with segments data
		 */
		function mergeSegments (segs) {
		  return segs.reduce(function (acc, curr) {
		    const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
		    if (prevSeg && prevSeg.mode === curr.mode) {
		      acc[acc.length - 1].data += curr.data;
		      return acc
		    }

		    acc.push(curr);
		    return acc
		  }, [])
		}

		/**
		 * Generates a list of all possible nodes combination which
		 * will be used to build a segments graph.
		 *
		 * Nodes are divided by groups. Each group will contain a list of all the modes
		 * in which is possible to encode the given text.
		 *
		 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
		 * The group for '12345' will contain then 3 objects, one for each
		 * possible encoding mode.
		 *
		 * Each node represents a possible segment.
		 *
		 * @param  {Array} segs Array of object with segments data
		 * @return {Array}      Array of object with segments data
		 */
		function buildNodes (segs) {
		  const nodes = [];
		  for (let i = 0; i < segs.length; i++) {
		    const seg = segs[i];

		    switch (seg.mode) {
		      case Mode.NUMERIC:
		        nodes.push([seg,
		          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
		          { data: seg.data, mode: Mode.BYTE, length: seg.length }
		        ]);
		        break
		      case Mode.ALPHANUMERIC:
		        nodes.push([seg,
		          { data: seg.data, mode: Mode.BYTE, length: seg.length }
		        ]);
		        break
		      case Mode.KANJI:
		        nodes.push([seg,
		          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
		        ]);
		        break
		      case Mode.BYTE:
		        nodes.push([
		          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
		        ]);
		    }
		  }

		  return nodes
		}

		/**
		 * Builds a graph from a list of nodes.
		 * All segments in each node group will be connected with all the segments of
		 * the next group and so on.
		 *
		 * At each connection will be assigned a weight depending on the
		 * segment's byte length.
		 *
		 * @param  {Array} nodes    Array of object with segments data
		 * @param  {Number} version QR Code version
		 * @return {Object}         Graph of all possible segments
		 */
		function buildGraph (nodes, version) {
		  const table = {};
		  const graph = { start: {} };
		  let prevNodeIds = ['start'];

		  for (let i = 0; i < nodes.length; i++) {
		    const nodeGroup = nodes[i];
		    const currentNodeIds = [];

		    for (let j = 0; j < nodeGroup.length; j++) {
		      const node = nodeGroup[j];
		      const key = '' + i + j;

		      currentNodeIds.push(key);
		      table[key] = { node: node, lastCount: 0 };
		      graph[key] = {};

		      for (let n = 0; n < prevNodeIds.length; n++) {
		        const prevNodeId = prevNodeIds[n];

		        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
		          graph[prevNodeId][key] =
		            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
		            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);

		          table[prevNodeId].lastCount += node.length;
		        } else {
		          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;

		          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
		            4 + Mode.getCharCountIndicator(node.mode, version); // switch cost
		        }
		      }
		    }

		    prevNodeIds = currentNodeIds;
		  }

		  for (let n = 0; n < prevNodeIds.length; n++) {
		    graph[prevNodeIds[n]].end = 0;
		  }

		  return { map: graph, table: table }
		}

		/**
		 * Builds a segment from a specified data and mode.
		 * If a mode is not specified, the more suitable will be used.
		 *
		 * @param  {String} data             Input data
		 * @param  {Mode | String} modesHint Data mode
		 * @return {Segment}                 Segment
		 */
		function buildSingleSegment (data, modesHint) {
		  let mode;
		  const bestMode = Mode.getBestModeForData(data);

		  mode = Mode.from(modesHint, bestMode);

		  // Make sure data can be encoded
		  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
		    throw new Error('"' + data + '"' +
		      ' cannot be encoded with mode ' + Mode.toString(mode) +
		      '.\n Suggested mode is: ' + Mode.toString(bestMode))
		  }

		  // Use Mode.BYTE if Kanji support is disabled
		  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
		    mode = Mode.BYTE;
		  }

		  switch (mode) {
		    case Mode.NUMERIC:
		      return new NumericData(data)

		    case Mode.ALPHANUMERIC:
		      return new AlphanumericData(data)

		    case Mode.KANJI:
		      return new KanjiData(data)

		    case Mode.BYTE:
		      return new ByteData(data)
		  }
		}

		/**
		 * Builds a list of segments from an array.
		 * Array can contain Strings or Objects with segment's info.
		 *
		 * For each item which is a string, will be generated a segment with the given
		 * string and the more appropriate encoding mode.
		 *
		 * For each item which is an object, will be generated a segment with the given
		 * data and mode.
		 * Objects must contain at least the property "data".
		 * If property "mode" is not present, the more suitable mode will be used.
		 *
		 * @param  {Array} array Array of objects with segments data
		 * @return {Array}       Array of Segments
		 */
		exports.fromArray = function fromArray (array) {
		  return array.reduce(function (acc, seg) {
		    if (typeof seg === 'string') {
		      acc.push(buildSingleSegment(seg, null));
		    } else if (seg.data) {
		      acc.push(buildSingleSegment(seg.data, seg.mode));
		    }

		    return acc
		  }, [])
		};

		/**
		 * Builds an optimized sequence of segments from a string,
		 * which will produce the shortest possible bitstream.
		 *
		 * @param  {String} data    Input string
		 * @param  {Number} version QR Code version
		 * @return {Array}          Array of segments
		 */
		exports.fromString = function fromString (data, version) {
		  const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled());

		  const nodes = buildNodes(segs);
		  const graph = buildGraph(nodes, version);
		  const path = dijkstra.find_path(graph.map, 'start', 'end');

		  const optimizedSegs = [];
		  for (let i = 1; i < path.length - 1; i++) {
		    optimizedSegs.push(graph.table[path[i]].node);
		  }

		  return exports.fromArray(mergeSegments(optimizedSegs))
		};

		/**
		 * Splits a string in various segments with the modes which
		 * best represent their content.
		 * The produced segments are far from being optimized.
		 * The output of this function is only used to estimate a QR Code version
		 * which may contain the data.
		 *
		 * @param  {string} data Input string
		 * @return {Array}       Array of segments
		 */
		exports.rawSplit = function rawSplit (data) {
		  return exports.fromArray(
		    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
		  )
		}; 
	} (segments));
	return segments;
}

var hasRequiredQrcode;

function requireQrcode () {
	if (hasRequiredQrcode) return qrcode;
	hasRequiredQrcode = 1;
	const Utils = requireUtils$1();
	const ECLevel = requireErrorCorrectionLevel();
	const BitBuffer = requireBitBuffer();
	const BitMatrix = requireBitMatrix();
	const AlignmentPattern = requireAlignmentPattern();
	const FinderPattern = requireFinderPattern();
	const MaskPattern = requireMaskPattern();
	const ECCode = requireErrorCorrectionCode();
	const ReedSolomonEncoder = requireReedSolomonEncoder();
	const Version = requireVersion();
	const FormatInfo = requireFormatInfo();
	const Mode = requireMode();
	const Segments = requireSegments();

	/**
	 * QRCode for JavaScript
	 *
	 * modified by Ryan Day for nodejs support
	 * Copyright (c) 2011 Ryan Day
	 *
	 * Licensed under the MIT license:
	 *   http://www.opensource.org/licenses/mit-license.php
	 *
	//---------------------------------------------------------------------
	// QRCode for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//   http://www.opensource.org/licenses/mit-license.php
	//
	// The word "QR Code" is registered trademark of
	// DENSO WAVE INCORPORATED
	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------
	*/

	/**
	 * Add finder patterns bits to matrix
	 *
	 * @param  {BitMatrix} matrix  Modules matrix
	 * @param  {Number}    version QR Code version
	 */
	function setupFinderPattern (matrix, version) {
	  const size = matrix.size;
	  const pos = FinderPattern.getPositions(version);

	  for (let i = 0; i < pos.length; i++) {
	    const row = pos[i][0];
	    const col = pos[i][1];

	    for (let r = -1; r <= 7; r++) {
	      if (row + r <= -1 || size <= row + r) continue

	      for (let c = -1; c <= 7; c++) {
	        if (col + c <= -1 || size <= col + c) continue

	        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
	          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
	          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
	          matrix.set(row + r, col + c, true, true);
	        } else {
	          matrix.set(row + r, col + c, false, true);
	        }
	      }
	    }
	  }
	}

	/**
	 * Add timing pattern bits to matrix
	 *
	 * Note: this function must be called before {@link setupAlignmentPattern}
	 *
	 * @param  {BitMatrix} matrix Modules matrix
	 */
	function setupTimingPattern (matrix) {
	  const size = matrix.size;

	  for (let r = 8; r < size - 8; r++) {
	    const value = r % 2 === 0;
	    matrix.set(r, 6, value, true);
	    matrix.set(6, r, value, true);
	  }
	}

	/**
	 * Add alignment patterns bits to matrix
	 *
	 * Note: this function must be called after {@link setupTimingPattern}
	 *
	 * @param  {BitMatrix} matrix  Modules matrix
	 * @param  {Number}    version QR Code version
	 */
	function setupAlignmentPattern (matrix, version) {
	  const pos = AlignmentPattern.getPositions(version);

	  for (let i = 0; i < pos.length; i++) {
	    const row = pos[i][0];
	    const col = pos[i][1];

	    for (let r = -2; r <= 2; r++) {
	      for (let c = -2; c <= 2; c++) {
	        if (r === -2 || r === 2 || c === -2 || c === 2 ||
	          (r === 0 && c === 0)) {
	          matrix.set(row + r, col + c, true, true);
	        } else {
	          matrix.set(row + r, col + c, false, true);
	        }
	      }
	    }
	  }
	}

	/**
	 * Add version info bits to matrix
	 *
	 * @param  {BitMatrix} matrix  Modules matrix
	 * @param  {Number}    version QR Code version
	 */
	function setupVersionInfo (matrix, version) {
	  const size = matrix.size;
	  const bits = Version.getEncodedBits(version);
	  let row, col, mod;

	  for (let i = 0; i < 18; i++) {
	    row = Math.floor(i / 3);
	    col = i % 3 + size - 8 - 3;
	    mod = ((bits >> i) & 1) === 1;

	    matrix.set(row, col, mod, true);
	    matrix.set(col, row, mod, true);
	  }
	}

	/**
	 * Add format info bits to matrix
	 *
	 * @param  {BitMatrix} matrix               Modules matrix
	 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
	 * @param  {Number}    maskPattern          Mask pattern reference value
	 */
	function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
	  const size = matrix.size;
	  const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern);
	  let i, mod;

	  for (i = 0; i < 15; i++) {
	    mod = ((bits >> i) & 1) === 1;

	    // vertical
	    if (i < 6) {
	      matrix.set(i, 8, mod, true);
	    } else if (i < 8) {
	      matrix.set(i + 1, 8, mod, true);
	    } else {
	      matrix.set(size - 15 + i, 8, mod, true);
	    }

	    // horizontal
	    if (i < 8) {
	      matrix.set(8, size - i - 1, mod, true);
	    } else if (i < 9) {
	      matrix.set(8, 15 - i - 1 + 1, mod, true);
	    } else {
	      matrix.set(8, 15 - i - 1, mod, true);
	    }
	  }

	  // fixed module
	  matrix.set(size - 8, 8, 1, true);
	}

	/**
	 * Add encoded data bits to matrix
	 *
	 * @param  {BitMatrix}  matrix Modules matrix
	 * @param  {Uint8Array} data   Data codewords
	 */
	function setupData (matrix, data) {
	  const size = matrix.size;
	  let inc = -1;
	  let row = size - 1;
	  let bitIndex = 7;
	  let byteIndex = 0;

	  for (let col = size - 1; col > 0; col -= 2) {
	    if (col === 6) col--;

	    while (true) {
	      for (let c = 0; c < 2; c++) {
	        if (!matrix.isReserved(row, col - c)) {
	          let dark = false;

	          if (byteIndex < data.length) {
	            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1);
	          }

	          matrix.set(row, col - c, dark);
	          bitIndex--;

	          if (bitIndex === -1) {
	            byteIndex++;
	            bitIndex = 7;
	          }
	        }
	      }

	      row += inc;

	      if (row < 0 || size <= row) {
	        row -= inc;
	        inc = -inc;
	        break
	      }
	    }
	  }
	}

	/**
	 * Create encoded codewords from data input
	 *
	 * @param  {Number}   version              QR Code version
	 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
	 * @param  {ByteData} data                 Data input
	 * @return {Uint8Array}                    Buffer containing encoded codewords
	 */
	function createData (version, errorCorrectionLevel, segments) {
	  // Prepare data buffer
	  const buffer = new BitBuffer();

	  segments.forEach(function (data) {
	    // prefix data with mode indicator (4 bits)
	    buffer.put(data.mode.bit, 4);

	    // Prefix data with character count indicator.
	    // The character count indicator is a string of bits that represents the
	    // number of characters that are being encoded.
	    // The character count indicator must be placed after the mode indicator
	    // and must be a certain number of bits long, depending on the QR version
	    // and data mode
	    // @see {@link Mode.getCharCountIndicator}.
	    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version));

	    // add binary data sequence to buffer
	    data.write(buffer);
	  });

	  // Calculate required number of bits
	  const totalCodewords = Utils.getSymbolTotalCodewords(version);
	  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);
	  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;

	  // Add a terminator.
	  // If the bit string is shorter than the total number of required bits,
	  // a terminator of up to four 0s must be added to the right side of the string.
	  // If the bit string is more than four bits shorter than the required number of bits,
	  // add four 0s to the end.
	  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
	    buffer.put(0, 4);
	  }

	  // If the bit string is fewer than four bits shorter, add only the number of 0s that
	  // are needed to reach the required number of bits.

	  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
	  // pad the string on the right with 0s to make the string's length a multiple of 8.
	  while (buffer.getLengthInBits() % 8 !== 0) {
	    buffer.putBit(0);
	  }

	  // Add pad bytes if the string is still shorter than the total number of required bits.
	  // Extend the buffer to fill the data capacity of the symbol corresponding to
	  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
	  // and 00010001 (0x11) alternately.
	  const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
	  for (let i = 0; i < remainingByte; i++) {
	    buffer.put(i % 2 ? 0x11 : 0xEC, 8);
	  }

	  return createCodewords(buffer, version, errorCorrectionLevel)
	}

	/**
	 * Encode input data with Reed-Solomon and return codewords with
	 * relative error correction bits
	 *
	 * @param  {BitBuffer} bitBuffer            Data to encode
	 * @param  {Number}    version              QR Code version
	 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
	 * @return {Uint8Array}                     Buffer containing encoded codewords
	 */
	function createCodewords (bitBuffer, version, errorCorrectionLevel) {
	  // Total codewords for this QR code version (Data + Error correction)
	  const totalCodewords = Utils.getSymbolTotalCodewords(version);

	  // Total number of error correction codewords
	  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel);

	  // Total number of data codewords
	  const dataTotalCodewords = totalCodewords - ecTotalCodewords;

	  // Total number of blocks
	  const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel);

	  // Calculate how many blocks each group should contain
	  const blocksInGroup2 = totalCodewords % ecTotalBlocks;
	  const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;

	  const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);

	  const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
	  const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;

	  // Number of EC codewords is the same for both groups
	  const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;

	  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
	  const rs = new ReedSolomonEncoder(ecCount);

	  let offset = 0;
	  const dcData = new Array(ecTotalBlocks);
	  const ecData = new Array(ecTotalBlocks);
	  let maxDataSize = 0;
	  const buffer = new Uint8Array(bitBuffer.buffer);

	  // Divide the buffer into the required number of blocks
	  for (let b = 0; b < ecTotalBlocks; b++) {
	    const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;

	    // extract a block of data from buffer
	    dcData[b] = buffer.slice(offset, offset + dataSize);

	    // Calculate EC codewords for this data block
	    ecData[b] = rs.encode(dcData[b]);

	    offset += dataSize;
	    maxDataSize = Math.max(maxDataSize, dataSize);
	  }

	  // Create final data
	  // Interleave the data and error correction codewords from each block
	  const data = new Uint8Array(totalCodewords);
	  let index = 0;
	  let i, r;

	  // Add data codewords
	  for (i = 0; i < maxDataSize; i++) {
	    for (r = 0; r < ecTotalBlocks; r++) {
	      if (i < dcData[r].length) {
	        data[index++] = dcData[r][i];
	      }
	    }
	  }

	  // Apped EC codewords
	  for (i = 0; i < ecCount; i++) {
	    for (r = 0; r < ecTotalBlocks; r++) {
	      data[index++] = ecData[r][i];
	    }
	  }

	  return data
	}

	/**
	 * Build QR Code symbol
	 *
	 * @param  {String} data                 Input string
	 * @param  {Number} version              QR Code version
	 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
	 * @param  {MaskPattern} maskPattern     Mask pattern
	 * @return {Object}                      Object containing symbol data
	 */
	function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
	  let segments;

	  if (Array.isArray(data)) {
	    segments = Segments.fromArray(data);
	  } else if (typeof data === 'string') {
	    let estimatedVersion = version;

	    if (!estimatedVersion) {
	      const rawSegments = Segments.rawSplit(data);

	      // Estimate best version that can contain raw splitted segments
	      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel);
	    }

	    // Build optimized segments
	    // If estimated version is undefined, try with the highest version
	    segments = Segments.fromString(data, estimatedVersion || 40);
	  } else {
	    throw new Error('Invalid data')
	  }

	  // Get the min version that can contain data
	  const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel);

	  // If no version is found, data cannot be stored
	  if (!bestVersion) {
	    throw new Error('The amount of data is too big to be stored in a QR Code')
	  }

	  // If not specified, use min version as default
	  if (!version) {
	    version = bestVersion;

	  // Check if the specified version can contain the data
	  } else if (version < bestVersion) {
	    throw new Error('\n' +
	      'The chosen QR Code version cannot contain this amount of data.\n' +
	      'Minimum version required to store current data is: ' + bestVersion + '.\n'
	    )
	  }

	  const dataBits = createData(version, errorCorrectionLevel, segments);

	  // Allocate matrix buffer
	  const moduleCount = Utils.getSymbolSize(version);
	  const modules = new BitMatrix(moduleCount);

	  // Add function modules
	  setupFinderPattern(modules, version);
	  setupTimingPattern(modules);
	  setupAlignmentPattern(modules, version);

	  // Add temporary dummy bits for format info just to set them as reserved.
	  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
	  // since the masking operation must be performed only on the encoding region.
	  // These blocks will be replaced with correct values later in code.
	  setupFormatInfo(modules, errorCorrectionLevel, 0);

	  if (version >= 7) {
	    setupVersionInfo(modules, version);
	  }

	  // Add data codewords
	  setupData(modules, dataBits);

	  if (isNaN(maskPattern)) {
	    // Find best mask pattern
	    maskPattern = MaskPattern.getBestMask(modules,
	      setupFormatInfo.bind(null, modules, errorCorrectionLevel));
	  }

	  // Apply mask pattern
	  MaskPattern.applyMask(maskPattern, modules);

	  // Replace format info bits with correct values
	  setupFormatInfo(modules, errorCorrectionLevel, maskPattern);

	  return {
	    modules: modules,
	    version: version,
	    errorCorrectionLevel: errorCorrectionLevel,
	    maskPattern: maskPattern,
	    segments: segments
	  }
	}

	/**
	 * QR Code
	 *
	 * @param {String | Array} data                 Input data
	 * @param {Object} options                      Optional configurations
	 * @param {Number} options.version              QR Code version
	 * @param {String} options.errorCorrectionLevel Error correction level
	 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
	 */
	qrcode.create = function create (data, options) {
	  if (typeof data === 'undefined' || data === '') {
	    throw new Error('No input text')
	  }

	  let errorCorrectionLevel = ECLevel.M;
	  let version;
	  let mask;

	  if (typeof options !== 'undefined') {
	    // Use higher error correction level as default
	    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M);
	    version = Version.from(options.version);
	    mask = MaskPattern.from(options.maskPattern);

	    if (options.toSJISFunc) {
	      Utils.setToSJISFunction(options.toSJISFunc);
	    }
	  }

	  return createSymbol(data, version, errorCorrectionLevel, mask)
	};
	return qrcode;
}

var canvas = {};

var utils = {};

var hasRequiredUtils;

function requireUtils () {
	if (hasRequiredUtils) return utils;
	hasRequiredUtils = 1;
	(function (exports) {
		function hex2rgba (hex) {
		  if (typeof hex === 'number') {
		    hex = hex.toString();
		  }

		  if (typeof hex !== 'string') {
		    throw new Error('Color should be defined as hex string')
		  }

		  let hexCode = hex.slice().replace('#', '').split('');
		  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
		    throw new Error('Invalid hex color: ' + hex)
		  }

		  // Convert from short to long form (fff -> ffffff)
		  if (hexCode.length === 3 || hexCode.length === 4) {
		    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
		      return [c, c]
		    }));
		  }

		  // Add default alpha value
		  if (hexCode.length === 6) hexCode.push('F', 'F');

		  const hexValue = parseInt(hexCode.join(''), 16);

		  return {
		    r: (hexValue >> 24) & 255,
		    g: (hexValue >> 16) & 255,
		    b: (hexValue >> 8) & 255,
		    a: hexValue & 255,
		    hex: '#' + hexCode.slice(0, 6).join('')
		  }
		}

		exports.getOptions = function getOptions (options) {
		  if (!options) options = {};
		  if (!options.color) options.color = {};

		  const margin = typeof options.margin === 'undefined' ||
		    options.margin === null ||
		    options.margin < 0
		    ? 4
		    : options.margin;

		  const width = options.width && options.width >= 21 ? options.width : undefined;
		  const scale = options.scale || 4;

		  return {
		    width: width,
		    scale: width ? 4 : scale,
		    margin: margin,
		    color: {
		      dark: hex2rgba(options.color.dark || '#000000ff'),
		      light: hex2rgba(options.color.light || '#ffffffff')
		    },
		    type: options.type,
		    rendererOpts: options.rendererOpts || {}
		  }
		};

		exports.getScale = function getScale (qrSize, opts) {
		  return opts.width && opts.width >= qrSize + opts.margin * 2
		    ? opts.width / (qrSize + opts.margin * 2)
		    : opts.scale
		};

		exports.getImageWidth = function getImageWidth (qrSize, opts) {
		  const scale = exports.getScale(qrSize, opts);
		  return Math.floor((qrSize + opts.margin * 2) * scale)
		};

		exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
		  const size = qr.modules.size;
		  const data = qr.modules.data;
		  const scale = exports.getScale(size, opts);
		  const symbolSize = Math.floor((size + opts.margin * 2) * scale);
		  const scaledMargin = opts.margin * scale;
		  const palette = [opts.color.light, opts.color.dark];

		  for (let i = 0; i < symbolSize; i++) {
		    for (let j = 0; j < symbolSize; j++) {
		      let posDst = (i * symbolSize + j) * 4;
		      let pxColor = opts.color.light;

		      if (i >= scaledMargin && j >= scaledMargin &&
		        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
		        const iSrc = Math.floor((i - scaledMargin) / scale);
		        const jSrc = Math.floor((j - scaledMargin) / scale);
		        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
		      }

		      imgData[posDst++] = pxColor.r;
		      imgData[posDst++] = pxColor.g;
		      imgData[posDst++] = pxColor.b;
		      imgData[posDst] = pxColor.a;
		    }
		  }
		}; 
	} (utils));
	return utils;
}

var hasRequiredCanvas;

function requireCanvas () {
	if (hasRequiredCanvas) return canvas;
	hasRequiredCanvas = 1;
	(function (exports) {
		const Utils = requireUtils();

		function clearCanvas (ctx, canvas, size) {
		  ctx.clearRect(0, 0, canvas.width, canvas.height);

		  if (!canvas.style) canvas.style = {};
		  canvas.height = size;
		  canvas.width = size;
		  canvas.style.height = size + 'px';
		  canvas.style.width = size + 'px';
		}

		function getCanvasElement () {
		  try {
		    return document.createElement('canvas')
		  } catch (e) {
		    throw new Error('You need to specify a canvas element')
		  }
		}

		exports.render = function render (qrData, canvas, options) {
		  let opts = options;
		  let canvasEl = canvas;

		  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
		    opts = canvas;
		    canvas = undefined;
		  }

		  if (!canvas) {
		    canvasEl = getCanvasElement();
		  }

		  opts = Utils.getOptions(opts);
		  const size = Utils.getImageWidth(qrData.modules.size, opts);

		  const ctx = canvasEl.getContext('2d');
		  const image = ctx.createImageData(size, size);
		  Utils.qrToImageData(image.data, qrData, opts);

		  clearCanvas(ctx, canvasEl, size);
		  ctx.putImageData(image, 0, 0);

		  return canvasEl
		};

		exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
		  let opts = options;

		  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
		    opts = canvas;
		    canvas = undefined;
		  }

		  if (!opts) opts = {};

		  const canvasEl = exports.render(qrData, canvas, opts);

		  const type = opts.type || 'image/png';
		  const rendererOpts = opts.rendererOpts || {};

		  return canvasEl.toDataURL(type, rendererOpts.quality)
		}; 
	} (canvas));
	return canvas;
}

var svgTag = {};

var hasRequiredSvgTag;

function requireSvgTag () {
	if (hasRequiredSvgTag) return svgTag;
	hasRequiredSvgTag = 1;
	const Utils = requireUtils();

	function getColorAttrib (color, attrib) {
	  const alpha = color.a / 255;
	  const str = attrib + '="' + color.hex + '"';

	  return alpha < 1
	    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
	    : str
	}

	function svgCmd (cmd, x, y) {
	  let str = cmd + x;
	  if (typeof y !== 'undefined') str += ' ' + y;

	  return str
	}

	function qrToPath (data, size, margin) {
	  let path = '';
	  let moveBy = 0;
	  let newRow = false;
	  let lineLength = 0;

	  for (let i = 0; i < data.length; i++) {
	    const col = Math.floor(i % size);
	    const row = Math.floor(i / size);

	    if (!col && !newRow) newRow = true;

	    if (data[i]) {
	      lineLength++;

	      if (!(i > 0 && col > 0 && data[i - 1])) {
	        path += newRow
	          ? svgCmd('M', col + margin, 0.5 + row + margin)
	          : svgCmd('m', moveBy, 0);

	        moveBy = 0;
	        newRow = false;
	      }

	      if (!(col + 1 < size && data[i + 1])) {
	        path += svgCmd('h', lineLength);
	        lineLength = 0;
	      }
	    } else {
	      moveBy++;
	    }
	  }

	  return path
	}

	svgTag.render = function render (qrData, options, cb) {
	  const opts = Utils.getOptions(options);
	  const size = qrData.modules.size;
	  const data = qrData.modules.data;
	  const qrcodesize = size + opts.margin * 2;

	  const bg = !opts.color.light.a
	    ? ''
	    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
	      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>';

	  const path =
	    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
	    ' d="' + qrToPath(data, size, opts.margin) + '"/>';

	  const viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"';

	  const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" ';

	  const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n';

	  if (typeof cb === 'function') {
	    cb(null, svgTag);
	  }

	  return svgTag
	};
	return svgTag;
}

var hasRequiredBrowser;

function requireBrowser () {
	if (hasRequiredBrowser) return browser;
	hasRequiredBrowser = 1;
	const canPromise = requireCanPromise();

	const QRCode = requireQrcode();
	const CanvasRenderer = requireCanvas();
	const SvgRenderer = requireSvgTag();

	function renderCanvas (renderFunc, canvas, text, opts, cb) {
	  const args = [].slice.call(arguments, 1);
	  const argsNum = args.length;
	  const isLastArgCb = typeof args[argsNum - 1] === 'function';

	  if (!isLastArgCb && !canPromise()) {
	    throw new Error('Callback required as last argument')
	  }

	  if (isLastArgCb) {
	    if (argsNum < 2) {
	      throw new Error('Too few arguments provided')
	    }

	    if (argsNum === 2) {
	      cb = text;
	      text = canvas;
	      canvas = opts = undefined;
	    } else if (argsNum === 3) {
	      if (canvas.getContext && typeof cb === 'undefined') {
	        cb = opts;
	        opts = undefined;
	      } else {
	        cb = opts;
	        opts = text;
	        text = canvas;
	        canvas = undefined;
	      }
	    }
	  } else {
	    if (argsNum < 1) {
	      throw new Error('Too few arguments provided')
	    }

	    if (argsNum === 1) {
	      text = canvas;
	      canvas = opts = undefined;
	    } else if (argsNum === 2 && !canvas.getContext) {
	      opts = text;
	      text = canvas;
	      canvas = undefined;
	    }

	    return new Promise(function (resolve, reject) {
	      try {
	        const data = QRCode.create(text, opts);
	        resolve(renderFunc(data, canvas, opts));
	      } catch (e) {
	        reject(e);
	      }
	    })
	  }

	  try {
	    const data = QRCode.create(text, opts);
	    cb(null, renderFunc(data, canvas, opts));
	  } catch (e) {
	    cb(e);
	  }
	}

	browser.create = QRCode.create;
	browser.toCanvas = renderCanvas.bind(null, CanvasRenderer.render);
	browser.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL);

	// only svg for now.
	browser.toString = renderCanvas.bind(null, function (data, _, opts) {
	  return SvgRenderer.render(data, opts)
	});
	return browser;
}

var browserExports = requireBrowser();
var QRCodeUtil = /*@__PURE__*/getDefaultExportFromCjs(browserExports);

var reactFastCompare;
var hasRequiredReactFastCompare;

function requireReactFastCompare () {
	if (hasRequiredReactFastCompare) return reactFastCompare;
	hasRequiredReactFastCompare = 1;

	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';

	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;

	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;

	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }

	    if (arrA != arrB) return false;

	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();

	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();

	    var keys = keyList(a);
	    length = keys.length;

	    if (length !== keyList(b).length)
	      return false;

	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal

	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;

	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare

	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }

	  return a !== a && b !== b;
	}
	// end fast-deep-equal

	reactFastCompare = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};
	return reactFastCompare;
}

var reactFastCompareExports = requireReactFastCompare();
var isEqual = /*@__PURE__*/getDefaultExportFromCjs(reactFastCompareExports);

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Built-in value references. */
var Symbol$1 = root.Symbol;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$d.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$a.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$c.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$b = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$9.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$a = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$8).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root, 'Map');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty$6.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$1 || ListCache),
    'string': new Hash
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$1 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$4.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$2 = moduleExports$2 ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$2 ? Buffer$2.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] =
typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] =
typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

  return value === proto;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$2(value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$1(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys$1(source), object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject$1(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer$1 = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer$1 ? Buffer$1.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys$1, getSymbols);
}

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative(root, 'DataView');

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root, 'Promise');

/* Built-in method references that are verified to be native. */
var Set$1 = getNative(root, 'Set');

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root, 'WeakMap');

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2) ||
    (Map$1 && getTag(new Map$1) != mapTag$3) ||
    (Promise$1 && getTag(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag(new Set$1) != setTag$3) ||
    (WeakMap$1 && getTag(new WeakMap$1) != weakMapTag$1)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$3;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$3;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/** Built-in value references. */
var Uint8Array$1 = root.Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$2:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag$1;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag$1;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

/** Used to compose bitmasks for cloning. */
var CLONE_FLAT_FLAG = 2;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag$1] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isFlat = bitmask & CLONE_FLAT_FLAG;
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFunc) ? {} : initCloneObject(value);
      {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = (getAllKeys)
    ;

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -Infinity) ? '-0' : result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -Infinity) ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString$1(value)));
}

var isProduction = process.env.NODE_ENV === 'production';
function warning(condition, message) {
  if (!isProduction) {

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs.exports = requireReactIs_production_min();
	} else {
	  reactIs.exports = requireReactIs_development();
	}
	return reactIs.exports;
}

var hoistNonReactStatics_cjs;
var hasRequiredHoistNonReactStatics_cjs;

function requireHoistNonReactStatics_cjs () {
	if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
	hasRequiredHoistNonReactStatics_cjs = 1;

	var reactIs = requireReactIs();

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above


	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}

	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);

	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }

	    var keys = getOwnPropertyNames(sourceComponent);

	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }

	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);

	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];

	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }

	  return targetComponent;
	}

	hoistNonReactStatics_cjs = hoistNonReactStatics;
	return hoistNonReactStatics_cjs;
}

requireHoistNonReactStatics_cjs();

function _extends$1x() {
  _extends$1x = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1x.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$1x(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** @private is the given object a Function? */

var isFunction$1 = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */

var isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */

var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */

var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private Does a React component have exactly 0 children? */

var isEmptyChildren = function isEmptyChildren(children) {
  return Children.count(children) === 0;
};
/** @private is the given object/value a promise? */

var isPromise = function isPromise(value) {
  return isObject(value) && isFunction$1(value.then);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = toPath(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */

function setIn(obj, path, value) {
  var res = clone(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = toPath(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = clone(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current


  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.


  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];

    if (isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

var FormikContext = /*#__PURE__*/createContext(undefined);
FormikContext.displayName = 'FormikContext';
var FormikProvider = FormikContext.Provider;
FormikContext.Consumer;
function useFormikContext() {
  var formik = useContext(FormikContext);
  !!!formik ? process.env.NODE_ENV !== "production" ? warning(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : warning() : void 0;
  return formik;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends$1x({}, state, {
        values: msg.payload
      });

    case 'SET_TOUCHED':
      return _extends$1x({}, state, {
        touched: msg.payload
      });

    case 'SET_ERRORS':
      if (isEqual(state.errors, msg.payload)) {
        return state;
      }

      return _extends$1x({}, state, {
        errors: msg.payload
      });

    case 'SET_STATUS':
      return _extends$1x({}, state, {
        status: msg.payload
      });

    case 'SET_ISSUBMITTING':
      return _extends$1x({}, state, {
        isSubmitting: msg.payload
      });

    case 'SET_ISVALIDATING':
      return _extends$1x({}, state, {
        isValidating: msg.payload
      });

    case 'SET_FIELD_VALUE':
      return _extends$1x({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_TOUCHED':
      return _extends$1x({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_ERROR':
      return _extends$1x({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case 'RESET_FORM':
      return _extends$1x({}, state, msg.payload);

    case 'SET_FORMIK_STATE':
      return msg.payload(state);

    case 'SUBMIT_ATTEMPT':
      return _extends$1x({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case 'SUBMIT_FAILURE':
      return _extends$1x({}, state, {
        isSubmitting: false
      });

    case 'SUBMIT_SUCCESS':
      return _extends$1x({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
} // Initial empty states // objects


var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose$1x(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends$1x({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = useRef(props.initialValues);
  var initialErrors = useRef(props.initialErrors || emptyErrors);
  var initialTouched = useRef(props.initialTouched || emptyTouched);
  var initialStatus = useRef(props.initialStatus);
  var isMounted = useRef(false);
  var fieldRegistry = useRef({});

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !(typeof isInitialValid === 'undefined') ? process.env.NODE_ENV !== "production" ? warning(false, 'isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.') : warning() : void 0; // eslint-disable-next-line
    }, []);
  }

  useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useReducer = useReducer(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var runValidateHandler = useCallback(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = useCallback(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction$1(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (process.env.NODE_ENV !== 'production') {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = useCallback(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = useCallback(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction$1(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = useCallback(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = deepmerge_1.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
        dispatch({
          type: 'SET_ERRORS',
          payload: combinedErrors
        });
      }

      return combinedErrors;
    });
  });
  useEffect(function () {
    if (validateOnMount && isMounted.current === true && isEqual(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = useCallback(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  useEffect(function () {
    if (isMounted.current === true && !isEqual(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();
      }

      if (validateOnMount) {
        validateFormWithHighPriority(initialValues.current);
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !isEqual(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !isEqual(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !isEqual(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (fieldRegistry.current[name] && isFunction$1(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: error[name]
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = useCallback(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = useCallback(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = useCallback(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction$1(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = useCallback(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = useCallback(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && process.env.NODE_ENV !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn(state.values, field), checked, value) : options && multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }

    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = useCallback(function (e, path) {
    if (e.persist) {
      e.persist();
    }

    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && process.env.NODE_ENV !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = useCallback(function (stateOrCb) {
    if (isFunction$1(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = useCallback(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = useCallback(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction$1(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction$1(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.


    if (process.env.NODE_ENV !== "production" && typeof document !== 'undefined') {
      // Safely get the active element (works with IE)
      var activeElement = getActiveElement();

      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem('type')) ? process.env.NODE_ENV !== "production" ? warning(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : warning() : void 0;
      }
    }

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction$1(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction$1(e.stopPropagation)) {
      e.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = useCallback(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = useCallback(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = useCallback(function (nameOrOptions) {
    var isAnObject = isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = useMemo(function () {
    return !isEqual(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = useMemo(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction$1(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends$1x({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
      children = props.children,
      render = props.render,
      innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />

  useImperativeHandle(innerRef, function () {
    return formikbag;
  });

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !!props.render ? process.env.NODE_ENV !== "production" ? warning(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : warning() : void 0; // eslint-disable-next-line
    }, []);
  }

  return createElement(FormikProvider, {
    value: formikbag
  }, component ? createElement(component, formikbag) : render ? render(formikbag) : children // children come last, always called
  ? isFunction$1(children) ? children(formikbag) : !isEmptyChildren(children) ? Children.only(children) : null : null);
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */


function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}
/**
 * Validate a yup schema.
 */

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}
/**
 * Recursively prepare values.
 */

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }

  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? deepmerge_1(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = deepmerge_1(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */


function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */


function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array


  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values


  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values


  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array


  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85


var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;

function useEventCallback(fn) {
  var ref = useRef(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect$1(function () {
    ref.current = fn;
  });
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}
function Field(_ref) {
  var validate = _ref.validate,
      name = _ref.name,
      render = _ref.render,
      children = _ref.children,
      is = _ref.as,
      component = _ref.component,
      props = _objectWithoutPropertiesLoose$1x(_ref, ["validate", "name", "render", "children", "as", "component"]);

  var _useFormikContext = useFormikContext(),
      formik = _objectWithoutPropertiesLoose$1x(_useFormikContext, ["validate", "validationSchema"]);

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !!render ? process.env.NODE_ENV !== "production" ? warning(false, "<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name=\"" + name + "\" render={({field, form}) => ...} /> with <Field name=\"" + name + "\">{({field, form, meta}) => ...}</Field>") : warning() : void 0;
      !!(is && children && isFunction$1(children)) ? process.env.NODE_ENV !== "production" ? warning(false, 'You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.') : warning() : void 0;
      !!(component && children && isFunction$1(children)) ? process.env.NODE_ENV !== "production" ? warning(false, 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.') : warning() : void 0;
      !!(render && children && !isEmptyChildren(children)) ? process.env.NODE_ENV !== "production" ? warning(false, 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored') : warning() : void 0; // eslint-disable-next-line
    }, []);
  } // Register field and field-level validation with parent <Formik>


  var registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  useEffect(function () {
    registerField(name, {
      validate: validate
    });
    return function () {
      unregisterField(name);
    };
  }, [registerField, unregisterField, name, validate]);
  var field = formik.getFieldProps(_extends$1x({
    name: name
  }, props));
  var meta = formik.getFieldMeta(name);
  var legacyBag = {
    field: field,
    form: formik
  };

  if (render) {
    return render(_extends$1x({}, legacyBag, {
      meta: meta
    }));
  }

  if (isFunction$1(children)) {
    return children(_extends$1x({}, legacyBag, {
      meta: meta
    }));
  }

  if (component) {
    // This behavior is backwards compat with earlier Formik 0.9 to 1.x
    if (typeof component === 'string') {
      var innerRef = props.innerRef,
          rest = _objectWithoutPropertiesLoose$1x(props, ["innerRef"]);

      return createElement(component, _extends$1x({
        ref: innerRef
      }, field, rest), children);
    } // We don't pass `meta` for backwards compat


    return createElement(component, _extends$1x({
      field: field,
      form: formik
    }, props), children);
  } // default to input here so we can check for both `as` and `children` above


  var asElement = is || 'input';

  if (typeof asElement === 'string') {
    var _innerRef = props.innerRef,
        _rest = _objectWithoutPropertiesLoose$1x(props, ["innerRef"]);

    return createElement(asElement, _extends$1x({
      ref: _innerRef
    }, field, _rest), children);
  }

  return createElement(asElement, _extends$1x({}, field, props), children);
}

var Form = /*#__PURE__*/forwardRef(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose$1x(props, ["action"]);

  var _action = action != null ? action : '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return createElement("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form';

const getVerificationDestinationFromNextView = (nextView) => {
    if (nextView === NextViewEnum.VerifyEmail)
        return 'email';
    if (nextView === NextViewEnum.VerifySms)
        return 'sms';
    return undefined;
};

const updateUserProfileFields = (environmentId, fields) => __awaiter$1(void 0, void 0, void 0, function* () {
    try {
        const response = yield sdkApi().updateSelf({
            environmentId,
            userFields: fields,
        });
        const verificationRequired = Boolean(getVerificationDestinationFromNextView(response.nextView));
        const userProfile = storeAuthTokenAndUser(Object.assign(Object.assign({}, response), { 
            // If verification is pending, do not update fields that require it
            preserveFieldsWithVerification: verificationRequired }));
        return Object.assign(Object.assign({}, response), { userProfile });
    }
    catch (e) {
        const error = yield logResponseError(e, 'Error updateUserProfileFields');
        if (e instanceof Response) {
            if (error.code === 'email_already_exists') {
                throw new EmailAlreadyExistsError();
            }
            else if (error.code === 'custom_field_data_not_unique') {
                throw new CustomFieldNotUniqueError();
            }
            else if (error.code === 'username_already_exists') {
                throw new UsernameAlreadyExistsError();
            }
            else if (error.code === 'too_many_verification_attempts') {
                throw new TooManyEmailVerificationsError();
            }
            else if (error.code === 'invalid_phone' ||
                error.code === 'invalid_sms_verification') {
                throw new InvalidPhoneNumberError(error.error);
            }
        }
        throw e;
    }
});
const mergeUserAccounts = (environmentId) => __awaiter$1(void 0, void 0, void 0, function* () {
    try {
        const response = yield sdkApi().mergeUsers({
            environmentId,
        });
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        yield logResponseError(e, 'Error mergeUserAccounts');
        throw e;
    }
});
const verifyMergeUsers = (environmentId, mergeConflictResolutions) => __awaiter$1(void 0, void 0, void 0, function* () {
    try {
        const response = yield sdkApi().verifyMergeUsers({
            environmentId,
            mergeUserConflictResolutions: {
                mergeUserResolutions: mergeConflictResolutions,
            },
        });
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        yield logResponseError(e, 'Error verifyMergeUsers');
        throw e;
    }
});
const refreshUserJwt = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ environmentId, }) {
    try {
        const response = yield sdkApi().refreshAuth({
            environmentId,
        });
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        yield logResponseError(e, 'Error refreshUserJwt');
        return undefined;
    }
});
const getAuthenticatedUser = (_b) => __awaiter$1(void 0, [_b], void 0, function* ({ environmentId, }) {
    try {
        return yield sdkApi().getAuthenticatedUser({
            environmentId,
        });
    }
    catch (e) {
        yield logResponseError(e, 'Error getAuthenticatedUser');
        // only explicitly throw `CookieInvalidError` when we attempt to get the authenticated user
        // and the backend returns a 401, indicating that there is no valid auth for the request
        if (e.status === 401) {
            logger$1.error('No valid auth for getAuthenticatedUser', e);
            throw new CookieInvalidError();
        }
        logger$1.error('Other error getting authenticated user', e);
        return undefined;
    }
});
/** Hook implementation of [getUserFieldsCheck] */
const getUserFieldsCheck = (_c) => __awaiter$1(void 0, [_c], void 0, function* ({ environmentId, filter, }) {
    try {
        return yield sdkApi().getUserFieldsCheck({
            environmentId,
            filter,
        });
    }
    catch (e) {
        yield logResponseError(e, 'Error checking user field availability');
        return undefined;
    }
});

const getWalletGroupType = (walletGroup) => {
    if (!walletGroup.groupedWallets.length) {
        throw new Error('Wallet group must have at least one wallet');
    }
    const [wallet] = walletGroup.groupedWallets;
    if (wallet.chainGroup) {
        return 'multi-chain';
    }
    if (wallet.walletGroup) {
        return 'multi-wallet';
    }
    return undefined;
};

/**
 * Determines whether the programmable network switch feature is supported.
 *
 * @param {WalletConnector} walletConnector - The wallet connector instance.
 * @returns {boolean} Whether the programmable network switch feature is supported.
 */
const isProgrammableNetworkSwitchSupported = (walletConnector) => {
    const urlParams = new URLSearchParams(window.location.search);
    // Get the dev_isProgrammableNetworkSwitchSupported parameter from the URL.
    const devIsProgrammableNetworkSwitchSupported = urlParams.get('dev_isProgrammableNetworkSwitchSupported');
    if (devIsProgrammableNetworkSwitchSupported) {
        return devIsProgrammableNetworkSwitchSupported === 'true';
    }
    // Otherwise, fall back to the original logic and return whether switchNetworkOnlyFromWallet is not true.
    return walletConnector.switchNetworkOnlyFromWallet !== true;
};

const getWalletConnectorNetworks = (walletConnector) => {
    if (!walletConnector)
        return [];
    const _walletConnector = walletConnector;
    return (_walletConnector.evmNetworks || _walletConnector.starknetNetworks || []);
};

const isSupportedNetwork = ({ walletConnector, network }) => {
    const supportedNetworks = getWalletConnectorNetworks(walletConnector);
    if (!supportedNetworks.length) {
        return true;
    }
    const isCurrentNetworkSupported = supportedNetworks.some(({ chainId }) => String(chainId) === String(network));
    return isCurrentNetworkSupported;
};

const IpConfigurationContext = createContext(undefined);
const IpConfigurationContextProvider = ({ children, }) => {
    const [ipConfiguration, setIpConfiguration] = useState(null);
    const getIpConfiguration = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        if (ipConfiguration) {
            return ipConfiguration;
        }
        try {
            const response = yield fetch('http://ip-api.com/json');
            if (!response.ok) {
                return;
            }
            const data = yield response.json();
            if (data.status !== 'success') {
                return;
            }
            const { country, countryCode } = data;
            const configuration = { country, countryCode };
            setIpConfiguration(configuration);
            return configuration;
        }
        catch (e) {
            logger$8.warn('Error fetching IP configuration', e);
            return;
        }
    }), [ipConfiguration, setIpConfiguration]);
    const removeIpConfiguration = useCallback(() => {
        setIpConfiguration(null);
    }, [setIpConfiguration]);
    const value = useMemo(() => ({
        getIpConfiguration,
        removeIpConfiguration,
    }), [getIpConfiguration, removeIpConfiguration]);
    return (jsxRuntimeExports.jsx(IpConfigurationContext.Provider, { value: value, children: children }));
};
const useIpConfigurationContext = () => {
    const context = useContext(IpConfigurationContext);
    if (context === undefined) {
        throw new Error('usage of useIpConfigurationContext not wrapped in `IpConfigurationContextProvider`.');
    }
    return context;
};

const ConnectWithOtpContext = createContext(undefined);

const mapEmailProviderToProviderEnum = {
    dynamic: ProviderEnum.Dynamic,
};
const allSupportedProviders = Object.values(mapEmailProviderToProviderEnum);

const chainIconMap = {
    algorand: AlgorandIcon,
    bitcoin: BitcoinIcon,
    cosmos: CosmosIcon,
    eclipse: EclipseIcon,
    evm: EthereumIcon,
    flow: FlowIcon,
    solana: SolanaIcon,
    starknet: StarknetIcon,
};
const getChainIcon = (chain) => {
    var _a, _b, _c;
    const chainName = (_b = (_a = getChainInfo(chain)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
    return (_c = chainIconMap[chainName]) !== null && _c !== void 0 ? _c : SvgError;
};

const OverlayCardContext = createContext(undefined);
const OverlayCardTarget = ({ children }) => {
    const [portal, setPortal] = useState(null);
    /** Keeps track of which cards are using this target currently */
    const [openedCards, setOpenedCards] = useState(new Set());
    return (jsxRuntimeExports.jsxs(OverlayCardContext.Provider, { value: useMemo(() => ({
            closeCard: (cardId) => setOpenedCards((cards) => {
                cards.delete(cardId);
                return new Set(cards);
            }),
            openCard: (cardId) => setOpenedCards((cards) => {
                cards.add(cardId);
                return new Set(cards);
            }),
            portal,
        }), [portal]), children: [children, openedCards.size > 0 && (jsxRuntimeExports.jsx("div", { className: 'overlay-card-target', ref: setPortal }))] }));
};
/**
 * Returns an element from above in the hierarchy to use as target for an OverlayCard,
 * or undefined if such parent was never set
 */
const useOverlayCardTarget = (isOpen) => {
    var _a;
    const context = useContext(OverlayCardContext);
    const id = 'overlay-card-target-id';
    useEffect(() => {
        if (!context || !isOpen)
            return;
        context.openCard(id);
        return () => {
            context.closeCard(id);
        };
    }, [context, id, isOpen]);
    return (_a = context === null || context === void 0 ? void 0 : context.portal) !== null && _a !== void 0 ? _a : undefined;
};

/**
    Filters a list of ProjectSettingsKyc objects and returns only those that have the 'enabled' property set to true.
    @param {ProjectSettingsKyc[] | undefined} kyc - A list of ProjectSettingsKyc objects to filter.
    @returns {ProjectSettingsKyc[]} - The list of ProjectSettingsKyc objects that have the 'enabled' property set to true.
*/
const getEnabledKYC = (kyc) => { var _a; return (_a = kyc === null || kyc === void 0 ? void 0 : kyc.filter(({ enabled }) => Boolean(enabled))) !== null && _a !== void 0 ? _a : []; };

/**
 * The fields that are attached to the user and/or KYC but are not editable/showable.
 * @const {string[]}
 */
const filterFields = ['social'];
/**
 * Maps user profile fields to KYC settings based on project settings.
 *
 * @param {UserFields} user - The user profile object containing fields to map.
 * @param {ProjectSettingsKyc[]} projectSettingsKyc - The project settings KYC object array to map against.
 * @returns {ProjectSettingsKyc[]} - The mapped KYC settings object array.
 */
const mapUserFieldsToKycSettings = (user, projectSettingsKyc) => {
    // We do not want to use predefined KYC fields, but rather map all existing fields in the project.
    // This supports custom fields that may be added in the future.
    const fields = Object.entries(user).reduce((previousValue, [fieldName, fieldValue]) => {
        if (fieldValue) {
            const kycSetting = projectSettingsKyc.find((field) => field.name === fieldName);
            if (kycSetting && !kycSetting.enabled) {
                previousValue.push(Object.assign({}, kycSetting));
            }
        }
        return previousValue;
    }, []);
    return fields;
};
/**
 * Get editable user profile fields based on the project settings.
 * @param {ProjectSettingsKyc[]} projectSettings - The project settings KYC object array.
 * @returns {ProjectSettingsKyc[]} - The list of editable user profile fields based on project settings.
 */
const getEditableUserProfileFields = (projectSettings) => getEnabledKYC(projectSettings).filter(({ name, type }) => type === KycFieldType.Custom || !filterFields.includes(name));
/**
 * Get non-editable user profile fields that exist in the user profile and are disabled in the project
 * @param {Object} options - The function options object.
 * @param {ProjectSettingsKyc[]} options.projectSettingsKyc - The project settings KYC object array.
 * @param {UserFields} options.user - The user profile object.
 * @returns {ProjectSettingsKyc[]} - The list of non-editable user profile fields based on project settings.
 */
const getNonEditableUserProfileFields = ({ projectSettingsKyc = [], user, }) => {
    if (!user)
        return [];
    const userProfileFields = mapUserFieldsToKycSettings(user, projectSettingsKyc);
    return userProfileFields.filter(({ name }) => !filterFields.includes(name));
};
/**
 * Get all user profile fields that exist in the user profile and are defined in the project
 * @param {Object} options - The function options object.
 * @param {ProjectSettingsKyc[]} options.projectSettingsKyc - The project settings KYC object array.
 * @param {UserProfile} options.user - The user profile object.
 * @returns {ProjectSettingsKyc[]} - The list of all user profile fields based on project settings.
 */
const getUserProfileFields = ({ projectSettingsKyc = [], customFields = [], user, }) => {
    var _a, _b;
    const editableUserProfileFields = getEditableUserProfileFields([
        ...projectSettingsKyc,
        ...customFields,
    ]);
    const nonEditableUserProfileFields = getNonEditableUserProfileFields({
        projectSettingsKyc,
        user,
    });
    let concatedList = [
        ...editableUserProfileFields,
        ...nonEditableUserProfileFields,
    ];
    const userEmbeddedWallet = (_a = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.find(({ walletProvider }) => walletProvider === WalletProviderEnum.EmbeddedWallet);
    const hasV1EmbeddedWallet = ((_b = userEmbeddedWallet === null || userEmbeddedWallet === void 0 ? void 0 : userEmbeddedWallet.walletProperties) === null || _b === void 0 ? void 0 : _b.version) ===
        EmbeddedWalletVersionEnum.V1;
    const userHasEmail = Boolean(user === null || user === void 0 ? void 0 : user.email);
    const userHasPhoneNumber = Boolean(user === null || user === void 0 ? void 0 : user.phoneNumber);
    if (hasV1EmbeddedWallet) {
        concatedList = concatedList.map((field) => {
            if ((field.name === 'email' && userHasEmail) ||
                (field.name === 'phoneNumber' && userHasPhoneNumber)) {
                return Object.assign(Object.assign({}, field), { enabled: false });
            }
            return field;
        });
    }
    return concatedList.sort((a, b) => {
        const indexA = projectSettingsKyc.findIndex((field) => field.name === a.name);
        const indexB = projectSettingsKyc.findIndex((field) => field.name === b.name);
        return indexA - indexB;
    });
};

const isSocialKycEnabled = (projectSettings) => { var _a; return Boolean((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.kyc.find(({ name }) => name === 'social')) === null || _a === void 0 ? void 0 : _a.enabled); };

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function generateQuery(params) {
  return Object.entries(params).filter(function (_ref) {
    _ref[0];
        var value = _ref[1];
    return value || value === false;
  }).map(function (_ref2) {
    var key = _ref2[0],
        value = _ref2[1];
    return encodeURIComponent(key) + "=" + encodeURIComponent(value);
  }).join("&");
}

var SCRIPT_ID = 'hcaptcha-api-script-id';
var HCAPTCHA_LOAD_FN_NAME = 'hcaptchaOnLoad'; // Prevent loading API script multiple times

var resolveFn;
var rejectFn;
var mountPromise = new Promise(function (resolve, reject) {
  resolveFn = resolve;
  rejectFn = reject;
}); // Generate hCaptcha API script

var mountCaptchaScript = function mountCaptchaScript(params) {
  if (params === void 0) {
    params = {};
  }

  if (document.getElementById(SCRIPT_ID)) {
    // API was already requested
    return mountPromise;
  } // Create global onload callback


  window[HCAPTCHA_LOAD_FN_NAME] = resolveFn;
  var domain = params.apihost || "https://js.hcaptcha.com";
  delete params.apihost;
  var script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.src = domain + "/1/api.js?render=explicit&onload=" + HCAPTCHA_LOAD_FN_NAME;
  script.async = true;

  script.onerror = function (event) {
    return rejectFn('script-error');
  };

  var query = generateQuery(params);
  script.src += query !== "" ? "&" + query : "";
  document.head.appendChild(script);
  return mountPromise;
};

var HCaptcha = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(HCaptcha, _React$Component);

  function HCaptcha(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // API Methods

    _this.renderCaptcha = _this.renderCaptcha.bind(_assertThisInitialized(_this));
    _this.resetCaptcha = _this.resetCaptcha.bind(_assertThisInitialized(_this));
    _this.removeCaptcha = _this.removeCaptcha.bind(_assertThisInitialized(_this));
    _this.isReady = _this.isReady.bind(_assertThisInitialized(_this)); // Event Handlers

    _this.loadCaptcha = _this.loadCaptcha.bind(_assertThisInitialized(_this));
    _this.handleOnLoad = _this.handleOnLoad.bind(_assertThisInitialized(_this));
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.handleExpire = _this.handleExpire.bind(_assertThisInitialized(_this));
    _this.handleError = _this.handleError.bind(_assertThisInitialized(_this));
    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    _this.handleChallengeExpired = _this.handleChallengeExpired.bind(_assertThisInitialized(_this));
    var isApiReady = typeof hcaptcha !== 'undefined';
    _this.ref = /*#__PURE__*/React.createRef();
    _this.apiScriptRequested = false;
    _this.state = {
      isApiReady: isApiReady,
      isRemoved: false,
      elementId: props.id,
      captchaId: ''
    };
    return _this;
  }

  var _proto = HCaptcha.prototype;

  _proto.componentDidMount = function componentDidMount() {
    // Once captcha is mounted intialize hCaptcha - hCaptcha
    var isApiReady = this.state.isApiReady;
    /*
     * Check if hCaptcha has already been loaded,
     * If Yes, render the captcha
     * If No, create script tag and wait to render the captcha
     */

    if (isApiReady) {
      this.renderCaptcha();
      return;
    }

    this.loadCaptcha();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var captchaId = this.state.captchaId;

    if (!this.isReady()) {
      return;
    } // Reset any stored variables / timers when unmounting


    hcaptcha.reset(captchaId);
    hcaptcha.remove(captchaId);
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // Prevent component re-rendering when these internal state variables are updated
    if (this.state.isApiReady !== nextState.isApiReady || this.state.isRemoved !== nextState.isRemoved) {
      return false;
    }

    return true;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    // Prop Keys that could change
    var keys = ['sitekey', 'size', 'theme', 'tabindex', 'languageOverride', 'endpoint']; // See if any props changed during component update

    var match = keys.every(function (key) {
      return prevProps[key] === _this2.props[key];
    }); // If they have changed, remove current captcha and render a new one

    if (!match) {
      this.removeCaptcha(function () {
        _this2.renderCaptcha();
      });
    }
  };

  _proto.loadCaptcha = function loadCaptcha() {
    if (this.apiScriptRequested) {
      return;
    }

    var _this$props = this.props,
        apihost = _this$props.apihost,
        assethost = _this$props.assethost,
        endpoint = _this$props.endpoint,
        host = _this$props.host,
        imghost = _this$props.imghost,
        hl = _this$props.languageOverride,
        reCaptchaCompat = _this$props.reCaptchaCompat,
        reportapi = _this$props.reportapi,
        sentry = _this$props.sentry,
        custom = _this$props.custom;
    var mountParams = {
      apihost: apihost,
      assethost: assethost,
      endpoint: endpoint,
      hl: hl,
      host: host,
      imghost: imghost,
      recaptchacompat: reCaptchaCompat === false ? "off" : null,
      reportapi: reportapi,
      sentry: sentry,
      custom: custom
    };
    mountCaptchaScript(mountParams).then(this.handleOnLoad)["catch"](this.handleError);
    this.apiScriptRequested = true;
  };

  _proto.renderCaptcha = function renderCaptcha(onReady) {
    var isApiReady = this.state.isApiReady;
    if (!isApiReady) return;
    var renderParams = Object.assign({
      "open-callback": this.handleOpen,
      "close-callback": this.handleClose,
      "error-callback": this.handleError,
      "chalexpired-callback": this.handleChallengeExpired,
      "expired-callback": this.handleExpire,
      "callback": this.handleSubmit
    }, this.props, {
      hl: this.props.hl || this.props.languageOverride,
      languageOverride: undefined
    }); //Render hCaptcha widget and provide necessary callbacks - hCaptcha

    var captchaId = hcaptcha.render(this.ref.current, renderParams);
    this.setState({
      isRemoved: false,
      captchaId: captchaId
    }, function () {
      onReady && onReady();
    });
  };

  _proto.resetCaptcha = function resetCaptcha() {
    var captchaId = this.state.captchaId;

    if (!this.isReady()) {
      return;
    } // Reset captcha state, removes stored token and unticks checkbox


    hcaptcha.reset(captchaId);
  };

  _proto.removeCaptcha = function removeCaptcha(callback) {
    var captchaId = this.state.captchaId;

    if (!this.isReady()) {
      return;
    }

    this.setState({
      isRemoved: true
    }, function () {
      hcaptcha.remove(captchaId);
      callback && callback();
    });
  };

  _proto.handleOnLoad = function handleOnLoad() {
    var _this3 = this;

    this.setState({
      isApiReady: true
    }, function () {
      // render captcha and wait for captcha id
      _this3.renderCaptcha(function () {
        // trigger onLoad if it exists
        var onLoad = _this3.props.onLoad;
        if (onLoad) onLoad();
      });
    });
  };

  _proto.handleSubmit = function handleSubmit(event) {
    var onVerify = this.props.onVerify;
    var _this$state = this.state,
        isRemoved = _this$state.isRemoved,
        captchaId = _this$state.captchaId;
    if (typeof hcaptcha === 'undefined' || isRemoved) return;
    var token = hcaptcha.getResponse(captchaId); //Get response token from hCaptcha widget

    var ekey = hcaptcha.getRespKey(captchaId); //Get current challenge session id from hCaptcha widget

    onVerify(token, ekey); //Dispatch event to verify user response
  };

  _proto.handleExpire = function handleExpire() {
    var onExpire = this.props.onExpire;
    var captchaId = this.state.captchaId;

    if (!this.isReady()) {
      return;
    }

    hcaptcha.reset(captchaId); // If hCaptcha runs into error, reset captcha - hCaptcha

    if (onExpire) onExpire();
  };

  _proto.handleError = function handleError(event) {
    var onError = this.props.onError;
    var captchaId = this.state.captchaId;

    if (this.isReady()) {
      // If hCaptcha runs into error, reset captcha - hCaptcha
      hcaptcha.reset(captchaId);
    }

    if (onError) onError(event);
  };

  _proto.isReady = function isReady() {
    var _this$state2 = this.state,
        isApiReady = _this$state2.isApiReady,
        isRemoved = _this$state2.isRemoved;
    return isApiReady && !isRemoved;
  };

  _proto.handleOpen = function handleOpen() {
    if (!this.isReady() || !this.props.onOpen) {
      return;
    }

    this.props.onOpen();
  };

  _proto.handleClose = function handleClose() {
    if (!this.isReady() || !this.props.onClose) {
      return;
    }

    this.props.onClose();
  };

  _proto.handleChallengeExpired = function handleChallengeExpired() {
    if (!this.isReady() || !this.props.onChalExpired) {
      return;
    }

    this.props.onChalExpired();
  };

  _proto.execute = function execute(opts) {
    if (opts === void 0) {
      opts = null;
    }

    var captchaId = this.state.captchaId;

    if (!this.isReady()) {
      return;
    }

    if (opts && typeof opts !== "object") {
      opts = null;
    }

    return hcaptcha.execute(captchaId, opts);
  };

  _proto.setData = function setData(data) {
    var captchaId = this.state.captchaId;

    if (!this.isReady()) {
      return;
    }

    if (data && typeof data !== "object") {
      data = null;
    }

    hcaptcha.setData(captchaId, data);
  };

  _proto.getResponse = function getResponse() {
    return hcaptcha.getResponse(this.state.captchaId);
  };

  _proto.getRespKey = function getRespKey() {
    return hcaptcha.getRespKey(this.state.captchaId);
  };

  _proto.render = function render() {
    var elementId = this.state.elementId;
    return /*#__PURE__*/React.createElement("div", {
      ref: this.ref,
      id: elementId
    });
  };

  return HCaptcha;
}(React.Component);

/**
 * This will return a string which we can present to the user credential type
 * @param user
 * @param type optional parameter to check for specific credential type
 * @returns JwtVerifiedCredentialFormatEnum | undefined
 */
const getUserVerifiedCredentialType = (user, type) => {
    var _a, _b, _c;
    if (!user) {
        return undefined;
    }
    if (type) {
        return (_b = (_a = user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.find((credentials) => credentials.format === type)) === null || _b === void 0 ? void 0 : _b.format;
    }
    const verifiedCredential = (_c = user.verifiedCredentials) === null || _c === void 0 ? void 0 : _c.find((credentials) => credentials.id === user.lastVerifiedCredentialId);
    return verifiedCredential === null || verifiedCredential === void 0 ? void 0 : verifiedCredential.format;
};

const findWalletOptionFor = (account, walletOptions) => {
    const { walletName } = account;
    if (walletName === 'turnkeyhd') {
        const chain = account.chain
            ? VerifiedCredentialNameToChainEnum[account.chain]
            : undefined;
        return walletOptions.find((wallet) => walletName === wallet.key &&
            wallet.walletConnector.connectedChain === chain);
    }
    // Wallets with name "unknown" are legacy wallets that were created when wallet name was still
    // set to "unknown" if not found in wallet book. We need to use fallback connector for these wallets.
    // The "unknown" wallet connector is also legacy and should never be used.
    if (walletName !== 'unknown') {
        const wallet = walletOptions.find((wallet) => wallet.key === walletName);
        if (wallet)
            return wallet;
    }
    // If we cannot find the correct connector for the wallet, we default to the fallback
    // this way the wallet will appear in user wallets, but will not be able to be interacted with
    const fallbackOptions = walletOptions.filter((wallet) => wallet.key === 'fallbackconnector');
    const { chain } = account;
    if (chain) {
        const unknownWallet = fallbackOptions.find(({ walletConnector }) => compareChains(walletConnector.connectedChain, chain));
        if (unknownWallet)
            return unknownWallet;
    }
    return fallbackOptions[0];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createPartialStoreSetter = ({ get, set }) => (key, value) => set(Object.assign(Object.assign({}, get()), { [key]: value }));

const { getSendBalanceState, setSendBalanceState, useSendBalanceState, resetSendBalanceState, } = createStoreState('sendBalanceState');
const setSendBalanceVariable = createPartialStoreSetter({
    get: getSendBalanceState,
    set: setSendBalanceState,
});

// https://usehooks-ts.com/react-hook/use-isomorphic-layout-effect
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

// https://usehooks-ts.com/react-hook/use-interval
const useInterval = (callback, delay) => {
    const savedCallback = useRef(callback);
    // Remember the latest callback if it changes.
    useIsomorphicLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    useEffect(() => {
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) {
            return;
        }
        const id = setInterval(() => savedCallback.current(), delay);
        return () => clearInterval(id);
    }, [delay]);
};

const useMutation = (mutation, options = {}) => {
    const [state, setState] = useState({
        isLoading: false,
    });
    const mutate = useCallback((variables) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a, _b;
        let data;
        setState({
            isLoading: true,
        });
        try {
            const mutationResult = mutation(variables);
            if (mutationResult instanceof Promise) {
                data = yield mutationResult;
            }
            else {
                data = mutationResult;
            }
            setState({
                data,
                isLoading: false,
            });
            try {
                (_a = options === null || options === void 0 ? void 0 : options.onSuccess) === null || _a === void 0 ? void 0 : _a.call(options, data, variables);
            }
            catch (err) {
                logger$8.error(err);
            }
            return data;
        }
        catch (error) {
            setState({ error: error, isLoading: false });
            logger$8.error(error);
            try {
                (_b = options === null || options === void 0 ? void 0 : options.onFailure) === null || _b === void 0 ? void 0 : _b.call(options, error, variables);
            }
            catch (err) {
                logger$8.error(err);
            }
        }
        return undefined;
    }), [mutation, options]);
    return Object.assign(Object.assign({}, state), { hasData: Boolean(state.data), hasError: Boolean(state.error), mutate });
};

const getAppOrigin = () => {
    if (typeof window !== 'undefined') {
        return window.location.origin;
    }
    return undefined;
};

const isMaliciousUrl = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ environmentId, url, }) {
    try {
        const request = {
            environmentId,
            scanWebsiteUrlRequest: { url },
        };
        const data = yield sdkApi().scanUrl(request);
        return data.isMalicious;
    }
    catch (error) {
        return undefined;
    }
});
const simulateBlockaidUserOperation = (_b) => __awaiter$1(void 0, [_b], void 0, function* ({ environmentId, userOperation, chainId, value, entryPoint, }) {
    try {
        const request = {
            environmentId,
            simulateUserOpRequest: {
                chainId,
                entryPoint: entryPoint.address,
                operation: userOperation,
                value: value,
            },
        };
        const transactionData = yield sdkApi().simulateUserOp(request);
        return transactionData;
    }
    catch (error) {
        logger$1.warn('simulateBlockaidUserOperation error', error);
        // when tx is not sponsored and blockaid is on, but user doesnt have enough gas
        if (error instanceof Error &&
            error.message.includes("AA21 didn't pay prefund")) {
            return {
                inAssets: [],
                outAssets: [],
                priceData: { nativeTokenUsdPrice: undefined },
                showTotalFiat: false,
            };
        }
        return undefined;
    }
});
const simulateBlockaidEVMTransaction = (_c) => __awaiter$1(void 0, [_c], void 0, function* ({ environmentId, chainId, from, to, value, data, }) {
    try {
        const request = {
            chainId,
            data,
            from,
            to,
            value,
        };
        const simulationRequest = {
            environmentId,
            simulateEVMTransactionRequest: request,
        };
        const transactionData = yield sdkApi().simulateEVMTransaction(simulationRequest);
        return transactionData;
    }
    catch (error) {
        logger$1.warn('simulateBlockaidEVMTransaction error', error);
        return undefined;
    }
});
const simulateBlockaidSVMTransaction = (_d) => __awaiter$1(void 0, [_d], void 0, function* ({ environmentId, chain, accountAddress, transactions, }) {
    var _e;
    try {
        const request = {
            environmentId,
            simulateSVMTransactionRequest: {
                accountAddress,
                chain: chain,
                domain: (_e = getAppOrigin()) !== null && _e !== void 0 ? _e : 'https://example.com',
                // signAll works the same as sign, signAndSend, signAll
                method: 'signAllTransactions',
                transactions,
            },
        };
        const transactionData = yield sdkApi().simulateSVMTransaction(request);
        return transactionData;
    }
    catch (error) {
        logger$1.warn('simulateBlockaidSVMTransaction error', error);
        return undefined;
    }
});

const Badge = ({ className = '', dot, text, copykey, variant = 'secondary', }) => (jsxRuntimeExports.jsxs("div", { className: classNames('badge__container', `badge__container__${variant}`, className), children: [dot && jsxRuntimeExports.jsx("span", { "data-testid": 'badge__dot', className: 'badge__dot' }), jsxRuntimeExports.jsx("span", { copykey: copykey, children: text })] }));

const rejectPromiseRef = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
promise, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
error) => {
    if (!promise.current)
        return;
    promise.current.reject(error);
    promise.current = null;
};

var _path$1i;
var _excluded$1w = ["title", "titleId"];
function _extends$1w() { return _extends$1w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1w.apply(null, arguments); }
function _objectWithoutProperties$1w(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1w(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1w(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1w(_ref, _excluded$1w);
  return /*#__PURE__*/React.createElement("svg", _extends$1w({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$1i || (_path$1i = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.707 4.293a1 1 0 0 1 0 1.414L5.414 11H21a1 1 0 1 1 0 2H5.414l5.293 5.293a1 1 0 0 1-1.414 1.414l-7-7a1 1 0 0 1 0-1.414l7-7a1 1 0 0 1 1.414 0Z",
    fill: "currentColor"
  })));
};

var _path$1h;
var _excluded$1v = ["title", "titleId"];
function _extends$1v() { return _extends$1v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1v.apply(null, arguments); }
function _objectWithoutProperties$1v(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1v(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1v(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgChevronDown = function SvgChevronDown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1v(_ref, _excluded$1v);
  return /*#__PURE__*/React.createElement("svg", _extends$1v({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$1h || (_path$1h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.862 5.529c.26-.26.682-.26.943 0L8 9.724l4.195-4.195a.667.667 0 1 1 .943.943L8.47 11.138a.667.667 0 0 1-.943 0L2.862 6.472a.667.667 0 0 1 0-.943Z",
    fill: "#7B7D86"
  })));
};

var _path$1g;
var _excluded$1u = ["title", "titleId"];
function _extends$1u() { return _extends$1u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1u.apply(null, arguments); }
function _objectWithoutProperties$1u(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1u(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1u(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgFooterInfoIcon = function SvgFooterInfoIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1u(_ref, _excluded$1u);
  return /*#__PURE__*/React.createElement("svg", _extends$1u({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$1g || (_path$1g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.333a6.667 6.667 0 1 0 0 13.334 6.667 6.667 0 0 0 0-13.334ZM1.667 10a8.333 8.333 0 1 1 16.666 0 8.333 8.333 0 0 1-16.666 0Zm7.5-3.333c0-.46.373-.834.833-.834h.008a.833.833 0 1 1 0 1.667H10a.833.833 0 0 1-.833-.833ZM8.333 10c0-.46.374-.833.834-.833H10c.46 0 .833.373.833.833v2.5a.833.833 0 1 1 0 1.667H10a.833.833 0 0 1-.833-.834v-2.5A.833.833 0 0 1 8.333 10Z",
    fill: "currentcolor"
  })));
};

var _g$d;
var _excluded$1t = ["title", "titleId"];
function _extends$1t() { return _extends$1t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1t.apply(null, arguments); }
function _objectWithoutProperties$1t(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1t(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1t(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSwitchToggle = function SvgSwitchToggle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1t(_ref, _excluded$1t);
  return /*#__PURE__*/React.createElement("svg", _extends$1t({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$d || (_g$d = /*#__PURE__*/React.createElement("g", {
    fill: "#7B7D86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.417 10.102v-8.89c.012-.12.022-.3.224-.496a.782.782 0 0 1 1.08 0l3.056 2.955a.722.722 0 0 1 0 1.044.782.782 0 0 1-1.08 0L7.944 3.022v7.08a.752.752 0 0 1-.764.739.752.752 0 0 1-.764-.739ZM4.583 3.898v8.89c-.012.12-.022.3-.224.496a.782.782 0 0 1-1.08 0L.223 10.329a.722.722 0 0 1 0-1.044.782.782 0 0 1 1.08 0l1.752 1.693v-7.08c0-.408.342-.739.764-.739s.764.33.764.739Z"
  }))));
};

const shortenWalletAddress = (walletAddress, first = 6, last = 4) => {
    if (!walletAddress)
        return '';
    return walletAddress.replace(walletAddress.substring(first, Number(walletAddress.length) - last), '...');
};

const Skeleton = ({ count = 1, className, style, container, dataTestId, }) => (jsxRuntimeExports.jsx("span", { "data-testid": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'loading-skeleton-container', className: container === null || container === void 0 ? void 0 : container.className, style: container === null || container === void 0 ? void 0 : container.style, children: new Array(count).fill(null).map((_, id) => (jsxRuntimeExports.jsx("span", { className: `skeleton ${className} `, style: style, "data-testid": 'loading-skeleton', children: "\u200C" }, `skeleton-${id}`))) }));

var _path$1f;
var _excluded$1s = ["title", "titleId"];
function _extends$1s() { return _extends$1s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1s.apply(null, arguments); }
function _objectWithoutProperties$1s(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1s(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1s(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgTooltipArrow = function SvgTooltipArrow(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1s(_ref, _excluded$1s);
  return /*#__PURE__*/React.createElement("svg", _extends$1s({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$1f || (_path$1f = /*#__PURE__*/React.createElement("path", {
    d: "M4 3.75 7.031 0H.97L4 3.75Z",
    fill: "currentColor"
  })));
};

const debounce = (callback, timeout) => {
    let timeoutId;
    const onTimeoutTick = () => {
        callback();
    };
    const debouncedFn = () => {
        clearTimeout(timeoutId);
        timeoutId = window.setTimeout(onTimeoutTick, timeout);
    };
    return debouncedFn;
};

const useElementById = () => {
    const targetElement = useRef(null);
    const createRootElement = useCallback((elementId = 'dynamic-modal', parentElementId) => {
        if (typeof window === 'undefined')
            return targetElement;
        const isElementCreated = window.document.getElementById(elementId);
        if (isElementCreated) {
            targetElement.current = isElementCreated;
            return targetElement;
        }
        const parentElement = parentElementId
            ? window.document.getElementById(parentElementId)
            : undefined;
        // creates div and attaches it to the body
        targetElement.current = window.document.createElement('div');
        targetElement.current.setAttribute('id', elementId);
        targetElement.current.setAttribute('class', elementId);
        targetElement.current.setAttribute('data-testid', elementId);
        /**
         * Setting the pointer-events to auto is necessary to allow the user to interact with the modal
         * when other packages that use a modal set the pointer-events to none on the body element.
         * For example: https://reservoir.tools/ use chakra-ui and sets the pointer-events to none on the body element.
         */
        targetElement.current.style.pointerEvents = 'auto';
        if (parentElement) {
            parentElement.appendChild(targetElement.current);
        }
        else {
            window.document.body.appendChild(targetElement.current);
        }
        return targetElement;
    }, []);
    return {
        createRootElement,
    };
};

const useHover = ({ initialValue = false, falseOnClick = false, onHover, onHoverOff, }) => {
    const [hover, setHover] = useState(initialValue);
    const handlers = {
        onMouseDown: () => setHover(true),
        onMouseEnter: () => {
            onHover === null || onHover === void 0 ? void 0 : onHover();
            setHover(true);
        },
        onMouseLeave: () => {
            onHoverOff === null || onHoverOff === void 0 ? void 0 : onHoverOff();
            setHover(false);
        },
        onMouseUp: () => setHover(falseOnClick),
    };
    return [hover, handlers];
};

const { getTokenBalancesState, setTokenBalancesState, useTokenBalancesState } = createStoreState('tokenBalancesState');
const setTokenBalanceVariable = createPartialStoreSetter({
    get: getTokenBalancesState,
    set: setTokenBalancesState,
});

/** Map from useHover React handlers to JS ones */
const handlerMapping = {
    onMouseDown: 'mousedown',
    onMouseEnter: 'mouseenter',
    onMouseLeave: 'mouseleave',
    onMouseUp: 'mouseup',
};
/**
 * Sets up a Tooltip that appears on hover
 *
 * Note: Prefer to use targetRef instead of nesting children!
 * Children of Tooltip will eventually replace content.
 */
const Tooltip = ({ children, content, className, as: Tag = 'span', copykey, targetRef, }) => {
    const { createRootElement } = useElementById();
    const portalRoot = createRootElement('dynamic-tooltips');
    const [vector, setVector] = useState([0, 0]);
    const [visible, setVisible] = useState(false);
    /** If targetRef is not set, fall back to this ref */
    const [childrenWrapperRef, setChildrenWrapperRef] = useState(null);
    const effectiveRef = targetRef !== null && targetRef !== void 0 ? targetRef : childrenWrapperRef;
    /** Centers the tooltip to top-center of the target */
    const calcPosition = useCallback(() => {
        if (!effectiveRef)
            return;
        const childrenBounding = effectiveRef.getBoundingClientRect();
        setVector([
            childrenBounding.left + childrenBounding.width / 2,
            childrenBounding.top - 6, //add 6px margin over the children
        ]);
    }, [effectiveRef]);
    const [, childrenHoverHandlers] = useHover({
        falseOnClick: true,
        initialValue: false,
        onHover: () => {
            calcPosition();
            setVisible(true);
        },
        onHoverOff: () => {
            setVisible(false);
        },
    });
    // Updates top/left on initial render, and when window resizes
    useEffect(() => {
        calcPosition();
        const resizeListener = debounce(() => {
            calcPosition();
        }, 3);
        window.addEventListener('resize', resizeListener);
        return () => {
            window.removeEventListener('resize', resizeListener);
        };
    }, [calcPosition]);
    // Set handlers manually
    useEffect(() => {
        const element = effectiveRef;
        if (element) {
            for (const handler in childrenHoverHandlers) {
                element.addEventListener(handlerMapping[handler], childrenHoverHandlers[handler]);
            }
            return () => {
                for (const handler in childrenHoverHandlers) {
                    element.removeEventListener(handlerMapping[handler], childrenHoverHandlers[handler]);
                }
            };
        }
        return undefined;
    }, [effectiveRef, childrenHoverHandlers]);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [createPortal(jsxRuntimeExports.jsx(ShadowDOM, { zIndex: tooltipZIndex, children: jsxRuntimeExports.jsxs("div", { "data-testid": 'dynamicTooltip', className: classNames('dynamic-tooltip', {
                        'dynamic-tooltip--visible': visible,
                    }, className), style: { left: vector[0], top: vector[1] }, copykey: copykey, children: [content, jsxRuntimeExports.jsx(SvgTooltipArrow, { className: 'dynamic-tooltip__arrow' })] }) }), portalRoot.current), targetRef === undefined && (jsxRuntimeExports.jsx(Tag, { ref: setChildrenWrapperRef, children: children }))] }));
};

const Image$1 = ({ src, alt = '', fallback, className, dataTestId, }) => {
    const [error, setError] = useState(false);
    const handleError = () => {
        setError(true);
    };
    return src && !error ? (jsxRuntimeExports.jsx("img", { src: src, alt: alt, onError: handleError, className: className, "data-testid": dataTestId })) : (jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: fallback }));
};

var _circle$9, _g$c;
var _excluded$1r = ["title", "titleId"];
function _extends$1r() { return _extends$1r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1r.apply(null, arguments); }
function _objectWithoutProperties$1r(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1r(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1r(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSpinner = function SvgSpinner(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1r(_ref, _excluded$1r);
  return /*#__PURE__*/React.createElement("svg", _extends$1r({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "spinner_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _circle$9 || (_circle$9 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "currentColor",
    strokeWidth: 2
  }))), _g$c || (_g$c = /*#__PURE__*/React.createElement("g", {
    mask: "url(#spinner_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12-16.5h27v27H12z"
  }))));
};

const Spinner$1 = ({ className = '' }) => (jsxRuntimeExports.jsx(SvgSpinner, { className: classNames('spinner', className) }));

const defaultButtonVariant = 'primary';
const Button$1 = ({ buttonClassName = '', className, style, buttonPadding = 'medium', buttonVariant = defaultButtonVariant, buttonRef, children, feedback, expanded, dataTestId, disabled = false, showInternalLoading = true, loading = false, onClick, type, startSlot, endSlot, }) => {
    const [internalButtonLoading, setInternalButtonLoading] = useState(false);
    const [isFeedbackVisible, setIsFeedbackVisible] = useState(false);
    const buttonEffectiveClassName = classNames('button', {
        'button--expanded': Boolean(expanded),
        'button--loading': Boolean(loading),
    }, buttonPadding ? `button--padding-${buttonPadding}` : '', buttonVariant ? `button--${buttonVariant}` : '', buttonClassName, className);
    const handleClick = (e) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (onClick) {
            const onClickResult = onClick(e);
            if (onClickResult instanceof Promise) {
                if (showInternalLoading) {
                    setInternalButtonLoading(true);
                }
                try {
                    yield onClickResult;
                }
                finally {
                    setInternalButtonLoading(false);
                }
            }
        }
        if (feedback) {
            setIsFeedbackVisible(true);
            setTimeout(() => {
                setIsFeedbackVisible(false);
            }, 2000);
        }
    });
    const buttonContent = (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [startSlot && jsxRuntimeExports.jsx("div", { className: 'button__start-slot', children: startSlot }), (feedback || children) &&
                (isFeedbackVisible && feedback ? feedback : children), endSlot && jsxRuntimeExports.jsx("div", { className: 'button__end-slot', children: endSlot })] }));
    return (jsxRuntimeExports.jsxs("button", { type: type, ref: buttonRef, onClick: handleClick, className: buttonEffectiveClassName, disabled: disabled || internalButtonLoading || loading, "data-testid": dataTestId, style: style, children: [(internalButtonLoading || loading) && (jsxRuntimeExports.jsx("div", { className: 'button__spinner-container', "data-testid": 'button__spinner', children: jsxRuntimeExports.jsx(Spinner$1, { className: 'button__spinner' }) })), buttonContent] }));
};

const defaultTypographyVariantMap = {
    'brand-primary': 'button_primary',
    card: 'body_normal',
    primary: 'button_primary',
    secondary: 'button_secondary',
    tertiary: 'button_tertiary',
};
const defaultTypographyColorMap = {
    'brand-primary': 'primary',
    card: 'primary',
    primary: 'primary',
    secondary: 'primary',
    tertiary: 'secondary',
};
const TypographyButton = (_a) => {
    var _b;
    var { children, typographyProps, copykey, disabled, leading, trailing, buttonVariant = defaultButtonVariant, description } = _a, props = __rest(_a, ["children", "typographyProps", "copykey", "disabled", "leading", "trailing", "buttonVariant", "description"]);
    const defaultTypographyVariant = defaultTypographyVariantMap[buttonVariant];
    const defaultTypographyColor = defaultTypographyColorMap[buttonVariant];
    return (jsxRuntimeExports.jsxs(Button$1, Object.assign({}, props, { disabled: disabled, buttonVariant: buttonVariant, children: [leading, jsxRuntimeExports.jsxs("div", { className: classNames('typography-button__content', {
                    'typography-button__content--with-description': Boolean(description),
                }), children: [jsxRuntimeExports.jsx(Typography, Object.assign({ variant: defaultTypographyVariant, as: 'span' }, typographyProps, { color: disabled
                            ? 'tertiary'
                            : (_b = typographyProps === null || typographyProps === void 0 ? void 0 : typographyProps.color) !== null && _b !== void 0 ? _b : defaultTypographyColor, copykey: copykey, children: children })), description && (jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', weight: 'medium', children: description }))] }), trailing] })));
};

const ModalHeader = ({ alignContent, children, leading, displayLeading = true, trailing, displayTrailing = true, style, displayBorder, description, }) => {
    const hasLeading = displayLeading && leading && Children.count(leading);
    const hasTrailing = displayTrailing && trailing && Children.count(trailing);
    return (jsxRuntimeExports.jsxs("div", { className: classNames('modal-header', {
            'modal-header--border': displayBorder,
            'modal-header--empty': !hasLeading && !children && !hasTrailing,
        }), style: style, children: [jsxRuntimeExports.jsxs("div", { className: classNames('modal-header__content', alignContent &&
                    `modal-header__content--align-content-${alignContent}`), children: [displayLeading && (jsxRuntimeExports.jsx("div", { className: classNames('modal-header__content__leading', {
                            'modal-header__content__leading--empty': !hasLeading,
                        }), children: leading })), children, displayTrailing && (jsxRuntimeExports.jsx("div", { className: classNames('modal-header__content__trailing', {
                            'modal-header__content__trailing--empty': !hasTrailing,
                        }), children: trailing }))] }), description] }));
};

const MAX_DISPLAY_LENGTH = 20;
/**
 * This is the value that will be displayed when the value is not available.
 */
const UNAVAILABLE_VALUE = '--';

const FormattedInput = ({ value, onChange, leading, trailing, className, style, onInteraction, emitter, locked, }) => {
    var _a, _b;
    const id = useId();
    const cursorPosition = useRef(0);
    const [inputRef, _setInputRef] = useState(null);
    const setInputRef = (ref) => {
        _setInputRef(ref);
        // When we first populate this ref, we want to focus it
        if (!ref || inputRef)
            return;
        resetCursorToEnd(ref);
    };
    const setCursorPosition = (position) => {
        requestAnimationFrame(() => {
            if (!inputRef)
                return;
            inputRef.focus();
            inputRef.setSelectionRange(position, position);
        });
    };
    const resetCursorToEnd = useCallback((ref = inputRef) => {
        if (!ref)
            return;
        ref.focus();
        ref.setSelectionRange(ref.value.length, ref.value.length);
    }, [inputRef]);
    const handleCursorPosition = () => {
        if (!inputRef)
            return;
        if (inputRef.selectionStart)
            cursorPosition.current = inputRef.selectionStart;
    };
    const handleInputChange = (e) => {
        onInteraction === null || onInteraction === void 0 ? void 0 : onInteraction();
        const amountNumber = e.target.value
            .replace(/[^\d.]/g, '')
            .slice(0, MAX_DISPLAY_LENGTH);
        // When nothing changes, ensure the cursor stays put
        if (amountNumber === value) {
            setCursorPosition(cursorPosition.current);
            return;
        }
        // If there are multiple decimal points, keep only the new one
        const decimalCount = amountNumber.split('.').length - 1;
        let decimalValidated = amountNumber;
        if (decimalCount > 1) {
            // Find position of the new decimal point by comparing with previous value
            const newDecimalIndex = amountNumber
                .split('')
                .findIndex((char, i) => char === '.' && value[i] !== '.');
            // Keep only the new decimal point
            decimalValidated = amountNumber
                .split('')
                .filter((char, i) => char !== '.' || i === newDecimalIndex)
                .join('');
            // Set the cursor to after the new decimal point
            setCursorPosition(value.indexOf('.') > newDecimalIndex
                ? newDecimalIndex + 1
                : newDecimalIndex);
        }
        onChange(decimalValidated);
        handleCursorPosition();
    };
    useEffect(() => {
        emitter === null || emitter === void 0 ? void 0 : emitter.on('focus', resetCursorToEnd);
        return () => {
            emitter === null || emitter === void 0 ? void 0 : emitter.off('focus', resetCursorToEnd);
        };
    }, [emitter, resetCursorToEnd]);
    return (jsxRuntimeExports.jsxs("label", { className: classNames(className, 'formatted-input'), 
        // 0 and 1 length should be the same because placeholder is '0'
        style: Object.assign(Object.assign({}, style), { '--char-count': (value.length || 1) +
                ((_a = leading === null || leading === void 0 ? void 0 : leading.length) !== null && _a !== void 0 ? _a : 0) +
                ((_b = trailing === null || trailing === void 0 ? void 0 : trailing.length) !== null && _b !== void 0 ? _b : 0) }), htmlFor: id, children: [leading && (jsxRuntimeExports.jsx("label", { htmlFor: id, className: classNames('formatted-input__leading', {
                    'formatted-input__leading--secondary': value === '',
                }), children: leading })), jsxRuntimeExports.jsxs("div", { className: 'formatted-input__input-container', children: [!locked && (jsxRuntimeExports.jsx("input", { ref: setInputRef, value: value, onChange: handleInputChange, placeholder: '0', onKeyUp: handleCursorPosition, onClick: handleCursorPosition, className: 'formatted-input__input-container__input', id: id, "data-testid": 'formatted-input' })), jsxRuntimeExports.jsx("label", { htmlFor: id, className: classNames('formatted-input__input-container__ghost-text', {
                            'formatted-input__input-container__ghost-text--visible': locked,
                        }), "data-testid": 'formatted-input-ghost-text', children: value === '' ? '0' : value })] }), trailing && (jsxRuntimeExports.jsx("label", { htmlFor: id, className: 'formatted-input__trailing', children: trailing }))] }));
};

const createFormattedInputEmitter = () => new EventEmitter$1();

var _path$1e;
var _excluded$1q = ["title", "titleId"];
function _extends$1q() { return _extends$1q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1q.apply(null, arguments); }
function _objectWithoutProperties$1q(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1q(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1q(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSearch = function SvgSearch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1q(_ref, _excluded$1q);
  return /*#__PURE__*/React.createElement("svg", _extends$1q({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$1e || (_path$1e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.667 2.667a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm-5.333 4a5.333 5.333 0 1 1 9.546 3.27l3.592 3.592a.667.667 0 0 1-.943.942L9.937 10.88a5.333 5.333 0 0 1-8.604-4.213Z",
    fill: "currentColor"
  })));
};

var _path$1d;
var _excluded$1p = ["title", "titleId"];
function _extends$1p() { return _extends$1p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1p.apply(null, arguments); }
function _objectWithoutProperties$1p(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1p(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1p(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgClose = function SvgClose(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1p(_ref, _excluded$1p);
  return /*#__PURE__*/React.createElement("svg", _extends$1p({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$1d || (_path$1d = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41 4.41a.833.833 0 0 1 1.18 0L10 8.822l4.41-4.41a.833.833 0 1 1 1.18 1.178L11.178 10l4.41 4.41a.833.833 0 1 1-1.178 1.18L10 11.177 5.588 15.59a.833.833 0 1 1-1.178-1.178L8.82 10l-4.41-4.41a.833.833 0 0 1 0-1.18Z",
    fill: "currentcolor"
  })));
};

var _circle$8, _circle2, _circle3, _path$1c, _path2$6;
var _excluded$1o = ["title", "titleId"];
function _extends$1o() { return _extends$1o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1o.apply(null, arguments); }
function _objectWithoutProperties$1o(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1o(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1o(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgWalletIllustration = function SvgWalletIllustration(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1o(_ref, _excluded$1o);
  return /*#__PURE__*/React.createElement("svg", _extends$1o({
    width: 116,
    height: 112,
    viewBox: "0 0 116 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle$8 || (_circle$8 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 39.5,
    r: 10.5,
    fill: "#D6E4FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 78.5,
    r: 18.5,
    fill: "#E5EEFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 43,
    r: 15,
    fill: "#D6E4FF"
  })), _path$1c || (_path$1c = /*#__PURE__*/React.createElement("path", {
    d: "m29.113 48.714 48.646-5.195-1.027-9.609a2.489 2.489 0 0 0-2.739-2.21L28.6 43.914l.513 4.8Z",
    fill: "#4779FF"
  })), _path2$6 || (_path2$6 = /*#__PURE__*/React.createElement("path", {
    d: "m28.616 44.067 53.199-5.681a2.9 2.9 0 0 1 3.191 2.576l3.355 31.414a2.9 2.9 0 0 1-2.576 3.191L35.47 80.94a2.9 2.9 0 0 1-3.191-2.576l-3.663-34.297Z",
    fill: "#A2BDFF"
  })));
};

var _circle$7, _defs$a;
var _excluded$1n = ["title", "titleId"];
function _extends$1n() { return _extends$1n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1n.apply(null, arguments); }
function _objectWithoutProperties$1n(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1n(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1n(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgFramedLinearGradient = function SvgFramedLinearGradient(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1n(_ref, _excluded$1n);
  return /*#__PURE__*/React.createElement("svg", _extends$1n({
    width: 228,
    height: 112,
    viewBox: "0 0 228 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle$7 || (_circle$7 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 114,
    r: 114,
    fill: "url(#framed-linear-gradient_svg__a)",
    fillOpacity: 0.12
  })), _defs$a || (_defs$a = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "framed-linear-gradient_svg__a",
    x1: 114,
    y1: 0,
    x2: 114,
    y2: 93.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4779FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779FF",
    stopOpacity: 0
  })))));
};

const LinearGradientFrame = ({ Icon }) => (jsxRuntimeExports.jsxs("div", { className: 'linear-gradient-frame', children: [jsxRuntimeExports.jsx(SvgFramedLinearGradient, { className: 'linear-gradient-frame__linear-gradient' }), jsxRuntimeExports.jsx("div", { className: 'linear-gradient-frame__icon', children: Icon })] }));

const isFiatToken = (symbol) => symbol === 'USD';
const isFiatOrStablecoin = (symbol) => isFiatToken(symbol) || symbol === 'USDC' || symbol === 'USDT';

const calculateFiatBalance = (token, exchangeRates) => {
    // If there is no token, return 0 instead of undefined because token is only undefined
    // when and only when user has no balance for it.
    if (!token)
        return 0;
    if (token.fiatBalance)
        return token.fiatBalance;
    // Fixing price to 1 for stablecoins to match user expectation
    if (isFiatOrStablecoin(token.symbol))
        return token.balance;
    if (token.price)
        return token.balance * token.price;
    if (exchangeRates[token.symbol])
        return token.balance * exchangeRates[token.symbol];
    // Here we return undefined instead of 0 because we know user HAS balance for this token,
    // but we cannot calculate the fiat balance, so show as unavailable.
    return undefined;
};

/**
 * Converts a scientific notation number to a decimal number.
 *
 * It might be simpler to just call "toFixed", however, "toFixed" will return
 * incorrect values for numbers that are too large or too small.
 * Try (9.1).toFixed(16) and see for yourself.
 */
const convertScientificToDecimal = (value) => {
    const str = value.toString();
    // If the number is already in standard form (no 'e'), return it
    if (!str.includes('e'))
        return str;
    const [base, exponent] = str.split('e').map(parseFloat);
    const isNegativeExp = exponent < 0;
    const absoluteExponent = Math.abs(exponent);
    const absoluteBase = Math.abs(base).toString();
    if (isNegativeExp) {
        // Move the decimal point to the left
        const newNumber = '0.' + '0'.repeat(absoluteExponent - 1) + absoluteBase.replace('.', '');
        return value < 0 ? '-' + newNumber : newNumber;
    }
    // Move the decimal point to the right
    const [intPart, decimalPart = ''] = absoluteBase.split('.');
    const newNumber = intPart + decimalPart.padEnd(absoluteExponent, '0');
    return value < 0 ? '-' + newNumber : newNumber;
};

/* eslint-disable prefer-destructuring */
const categorizeValue = (value) => {
    if (Number.isNaN(value))
        return { symbol: '', value: 0 };
    if (value >= 1e15)
        return '>999T';
    if (value >= 1e12)
        return { symbol: 'T', value: Math.round(value / 1e11) / 10 };
    if (value >= 1e9)
        return { symbol: 'B', value: Math.round(value / 1e8) / 10 };
    if (value >= 1e6)
        return { symbol: 'M', value: Math.round(value / 1e5) / 10 };
    return { symbol: '', value };
};
const addSymbol = (value, symbol) => {
    if (!symbol)
        return value;
    if (symbol === 'USD')
        return `$${value}`;
    return `${value} ${symbol}`;
};
const formatValue = ({ value, symbol, withFixedZeros = false, maxDecimals, }) => {
    if (value === UNAVAILABLE_VALUE)
        return addSymbol(UNAVAILABLE_VALUE, symbol);
    if (value === undefined)
        return undefined;
    const parsed = value === '' ? 0 : parseFloat(value.toString());
    // Deal with 0 values so we can assume value is not zero from here on
    if (parsed === 0)
        return addSymbol(withFixedZeros && maxDecimals ? (0).toFixed(maxDecimals) : '0', symbol);
    const categorized = categorizeValue(parsed);
    const categorySymbol = typeof categorized === 'object' ? categorized.symbol : '';
    if (typeof categorized === 'string')
        return addSymbol(categorized + categorySymbol, symbol);
    const expandedValue = convertScientificToDecimal(categorized.value);
    let [integerPart, decimalPart] = expandedValue.split('.');
    if (maxDecimals !== undefined) {
        const [roundedInteger, roundedDecimal] = parseFloat(`0.${decimalPart}`)
            .toFixed(maxDecimals)
            .split('.');
        decimalPart = withFixedZeros
            ? roundedDecimal
            : roundedDecimal.replace(/0+$/, '');
        if (roundedInteger !== '0') {
            integerPart = convertScientificToDecimal(parseFloat(integerPart) + parseFloat(roundedInteger));
        }
    }
    // Add commas
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const formattedValue = decimalPart
        ? `${integerPart}.${decimalPart}`
        : integerPart;
    // If we ended up with 0 after all rounding, show less than symbol
    if (maxDecimals && parseFloat(formattedValue) === 0) {
        const number = `${(0).toFixed(maxDecimals - 1)}1`;
        return `<${addSymbol(number, symbol)}`;
    }
    return addSymbol(formattedValue + categorySymbol, symbol);
};

const TokenOption = ({ token, isSelected, onSelect, showTokenAsPrimary, exchangeRates, }) => {
    const fiatBalance = formatValue({
        maxDecimals: 2,
        symbol: 'USD',
        value: calculateFiatBalance(token, exchangeRates),
        withFixedZeros: true,
    });
    const tokenBalance = formatValue({
        maxDecimals: isFiatOrStablecoin(token.symbol) ? 2 : 6,
        symbol: token.symbol,
        value: token.balance,
        withFixedZeros: isFiatOrStablecoin(token.symbol),
    });
    const [primaryBalance, secondaryBalance] = showTokenAsPrimary
        ? [tokenBalance, fiatBalance]
        : [fiatBalance, tokenBalance];
    return (jsxRuntimeExports.jsxs("div", { className: classNames('token-option', {
            'token-option--selected': isSelected,
        }), onClick: onSelect, "data-testid": `token-option-${token.symbol}`, children: [token.logoURI ? (jsxRuntimeExports.jsx(Image$1, { src: token.logoURI, alt: token.symbol, className: 'token-option__icon', dataTestId: 'token-option-icon' })) : (jsxRuntimeExports.jsx("div", { className: 'token-option__icon--skeleton', "data-testid": 'token-option__icon--skeleton' })), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', className: 'token-option__name', children: token.name }), jsxRuntimeExports.jsxs("div", { className: 'token-option__balance-container', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'medium', "data-testid": 'token-option__primary-balance', children: primaryBalance }), jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'body_small', color: 'secondary', "data-testid": 'token-option__secondary-balance', children: secondaryBalance })] })] }));
};

const TokenSelectScreen = ({ onClose, onSelectToken, currentToken, tokens, className, style, showTokenAsPrimary, exchangeRates, }) => {
    const { t } = useTranslation();
    const [search, setSearch] = useState('');
    const filteredTokens = tokens.filter((token) => {
        if (token.symbol.toLowerCase().includes(search.toLowerCase()))
            return true;
        if (token.name.toLowerCase().includes(search.toLowerCase()))
            return true;
        return false;
    });
    const noAssets = tokens.length === 0;
    const closeButton = (jsxRuntimeExports.jsx(IconButton, { type: 'button', id: 'close-button', "data-testid": 'close-button', onClick: onClose, children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    return (jsxRuntimeExports.jsxs("div", { className: classNames('token-select', className), style: style, "data-testid": 'token-select', children: [jsxRuntimeExports.jsx(ModalHeader, { trailing: closeButton, children: jsxRuntimeExports.jsx(Typography, { variant: 'title', children: t(noAssets
                        ? 'dyn_wallet_funding.from_external_wallet.token_select.no_assets_title'
                        : 'dyn_wallet_funding.from_external_wallet.token_select.title') }) }), noAssets && (jsxRuntimeExports.jsxs("div", { className: 'token-select__no-assets', children: [jsxRuntimeExports.jsx(LinearGradientFrame, { Icon: jsxRuntimeExports.jsx(SvgWalletIllustration, {}) }), jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'secondary', weight: 'medium', children: t('dyn_wallet_funding.from_external_wallet.token_select.no_assets_description') })] })), !noAssets && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("label", { htmlFor: 'token-select-search', className: 'token-select__search', children: [jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', size: 'small', children: jsxRuntimeExports.jsx(SvgSearch, {}) }), jsxRuntimeExports.jsx("input", { id: 'token-select-search', placeholder: t('dyn_wallet_funding.from_external_wallet.token_select.search_placeholder'), className: 'token-select__search__input', value: search, onChange: (e) => setSearch(e.target.value) })] }), jsxRuntimeExports.jsx("div", { className: 'token-select__tokens', children: filteredTokens.map((token) => (jsxRuntimeExports.jsx(TokenOption, { token: token, isSelected: token.symbol === currentToken, onSelect: () => onSelectToken(token.symbol), showTokenAsPrimary: showTokenAsPrimary, exchangeRates: exchangeRates }, token.symbol))) })] }))] }));
};

const roundToMaxDisplayLength = (value) => value.toString().slice(0, MAX_DISPLAY_LENGTH);
const convertToFiat = (amount, token, exchangeRates) => {
    if (amount === '')
        return '';
    const value = parseFloat(amount);
    if (isNaN(value))
        return '';
    return exchangeRates[token] !== undefined
        ? roundToMaxDisplayLength(value * exchangeRates[token])
        : undefined;
};
const convertFromFiat = (amount, token, exchangeRates) => {
    if (amount === '')
        return '';
    const value = parseFloat(amount);
    if (isNaN(value))
        return '';
    return exchangeRates[token] !== undefined
        ? roundToMaxDisplayLength(value / exchangeRates[token])
        : undefined;
};

const isNonZero = (value) => Boolean(value && parseFloat(value.toString()) > 0);

const respectsMinimum = (amount, minimum, exchangeRates) => {
    if (!minimum)
        return true;
    const amountInFiat = !isFiatToken(amount.token)
        ? convertToFiat(amount.value, amount.token, exchangeRates)
        : amount.value;
    const minimumInFiat = !isFiatToken(minimum.token)
        ? convertToFiat(minimum.value, minimum.token, exchangeRates)
        : minimum.value;
    if (amountInFiat === undefined || minimumInFiat === undefined)
        return true;
    return parseFloat(amountInFiat) >= parseFloat(minimumInFiat);
};

const getExchangeRates = () => __awaiter$1(void 0, void 0, void 0, function* () {
    const rates = {};
    const data = yield sdkApi().getCurrencyExchangeRates({
        environmentId: getEnvironmentId(),
    });
    data.forEach((currency) => {
        rates[currency.code] = currency.value;
    });
    return rates;
});

const overrideBalances = (exchangeRates, tokenBalances) => {
    const updatedExchangeRates = Object.assign({}, exchangeRates);
    if (tokenBalances === null || tokenBalances === void 0 ? void 0 : tokenBalances.length) {
        tokenBalances.forEach(({ symbol, price }) => {
            if (price) {
                updatedExchangeRates[symbol] = price;
            }
        });
    }
    // Fix stablecoin exchange rates for better UX
    updatedExchangeRates['USDC'] = 1;
    updatedExchangeRates['USDT'] = 1;
    return updatedExchangeRates;
};
const useExchangeRatesForFunding = ({ onFetch, tokenBalances, }) => {
    const { data: exchangeRates } = usePromise(getExchangeRates, {
        initialData: {},
        onResolve: (rates) => onFetch(overrideBalances(rates, tokenBalances)),
    });
    return useMemo(() => overrideBalances(exchangeRates, tokenBalances), [tokenBalances, exchangeRates]);
};

//
// This is a helper to convert pixel to rem string.
// Since we are using rem as our unit of measurement, we need to convert pixel to rem
// otherwise, the styling can look broken if the user changes html font size in the browser.
//
const pixelToRem = (pixel) => `${pixel / 16}rem`;

const walletsRequiringTwoStepAuthentication = ['dapper'];
const requiresTwoStepAuthentication = (connector) => (isMobile() && !(connector === null || connector === void 0 ? void 0 : connector.canConnectViaCustodialService)) ||
    walletsRequiringTwoStepAuthentication.includes((connector === null || connector === void 0 ? void 0 : connector.key) || '');

const isSelectedWalletAlreadyConnected = (linkedWallets, selectedWallet, user) => {
    if (!user)
        return false;
    return linkedWallets
        .map(({ connector }) => connector.key)
        .includes(selectedWallet.key);
};

const useHandleWalletItem = ({ allowAlreadyConnectedWallet, onQrCodeConnect, onConnectOnly, onCustodialWallet, onInstalledExtension, }) => {
    const { setMultiWalletWidgetState, setShowAuthFlow, setSelectedWalletConnectorKey, walletConnectorOptions, setQrcodeUri, setDesktopUri, user, linkedWallets, setLegacyIsVerifying, authMode, } = useInternalDynamicContext();
    const { mockedSDK } = useMockContext();
    const { setError, setErrorMessage } = useErrorContext();
    const { pushView, clearStackAndPushInitialView } = useViewContext();
    const handleCustodialWalletClick = (walletConnector) => __awaiter$1(void 0, void 0, void 0, function* () {
        logger$1.debug('handleCustodialWalletClick', walletConnector);
        const twoStepAuthentication = requiresTwoStepAuthentication(walletConnector);
        logger$1.logVerboseTroubleshootingMessage('[handleCustodialWalletClick]', {
            twoStepAuthentication,
        });
        setSelectedWalletConnectorKey(walletConnector.key);
        return onCustodialWallet({
            requiresTwoStepAuthentication: twoStepAuthentication,
            walletConnector,
        });
    });
    const handleMobileWalletClick = (walletConnector) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a;
        logger$1.debug('handleMobileWalletClick', walletConnector);
        setSelectedWalletConnectorKey(walletConnector.key);
        // We need to set to LS when about to verify phantom wallet on mobile
        // because the deeplink interrupts this code execution and then redirects back on a new tab.
        // This resets all state (except for LS obviously). When we receive the phantom signature in this new tab,
        // we can't tell whether it's supposed to be used to sign a message, verify a wallet sign in/link,
        // or conclude a wallet transfer, which is why we need this LS variable: it will indicate whether it
        // is a signature, authentication or transfer.
        // Check method handleUserResponse in file useResponseHandlers, case 'signMessage'.
        if (walletConnector.key === 'phantom') {
            const currentState = StorageService.getItem(PHANTOM_SIGNATURE_STATE);
            StorageService.setItem(PHANTOM_SIGNATURE_STATE, {
                loseOriginalAccountOnTransfer: (_a = currentState === null || currentState === void 0 ? void 0 : currentState.loseOriginalAccountOnTransfer) !== null && _a !== void 0 ? _a : false,
                submittedAtTimestamp: new Date().toString(),
                verificationType: 'awaiting_verification',
            });
        }
        const attemptConnection = () => {
            onConnectOnly({ shouldShowPendingConnectView: false, walletConnector });
        };
        pushView('mobile-wallet-redirect-view', { onRetry: attemptConnection });
        attemptConnection();
    });
    const handleInstalledExtensionClick = (walletConnector) => __awaiter$1(void 0, void 0, void 0, function* () {
        logger$1.debug('handleInstalledExtensionClick', walletConnector);
        setSelectedWalletConnectorKey(walletConnector.key);
        return onInstalledExtension({ walletConnector });
    });
    const handleUninstalledClick = (walletConnector) => __awaiter$1(void 0, void 0, void 0, function* () {
        logger$1.debug('handleUninstalledClick', walletConnector);
        setSelectedWalletConnectorKey(walletConnector.key);
        if (!walletConnector.canConnectViaQrCode) {
            pushView('no-qr-not-installed');
        }
        else {
            onQrCodeConnect({
                getAddressOpts: {
                    onDesktopUri: (uri) => __awaiter$1(void 0, void 0, void 0, function* () {
                        setDesktopUri(uri);
                    }),
                    onDisplayUri: (uri) => __awaiter$1(void 0, void 0, void 0, function* () {
                        setQrcodeUri(uri);
                    }),
                },
                walletConnector,
            });
            pushView('qr-code');
        }
        setError(undefined);
    });
    const handleAlreadyConnectedWallet = (walletConnector) => __awaiter$1(void 0, void 0, void 0, function* () {
        logger$1.debug('handleAlreadyConnectedWallet', walletConnector);
        setShowAuthFlow(false);
        const connectedAccounts = yield walletConnector.getConnectedAccounts();
        const activeAccountAlreadyLinked = linkedWallets.find((wallet) => { var _a; return wallet.address.toLowerCase() === ((_a = connectedAccounts[0]) === null || _a === void 0 ? void 0 : _a.toLowerCase()); });
        logger$1.logVerboseTroubleshootingMessage('[handleAlreadyConnectedWallet]', {
            activeAccountAlreadyLinked,
            connectedAccounts,
            linkedWallets,
            walletConnectorKey: walletConnector.key,
        });
        setSelectedWalletConnectorKey(walletConnector.key);
        if (!activeAccountAlreadyLinked) {
            setMultiWalletWidgetState('awaiting_signature', undefined, 'linking_new_wallet');
            return;
        }
        const isTryingToUpdateUnknownWallet = activeAccountAlreadyLinked.connector.key === 'unknown';
        if (isTryingToUpdateUnknownWallet) {
            //prompt the user to connect and sign with the wallet
            dynamicEvents.emit('triggerConnectAndSign', walletConnector);
            return;
        }
        setMultiWalletWidgetState('awaiting_account_switch', 'linking_new_wallet');
    });
    const openWallet = (walletKey, handlers) => {
        var _a;
        const { openMobileWallet = handleMobileWalletClick, openCustodialWallet = handleCustodialWalletClick, openExtensionWallet = handleInstalledExtensionClick, } = handlers || {};
        const walletConnector = (_a = walletConnectorOptions.find((wallet) => wallet.key === walletKey)) === null || _a === void 0 ? void 0 : _a.walletConnector;
        if (!walletConnector)
            return;
        if (isMobile()) {
            openMobileWallet(walletConnector);
        }
        else if (walletConnector.canConnectViaCustodialService) {
            openCustodialWallet(walletConnector);
        }
        else if (walletConnector.isInstalledOnBrowser()) {
            openExtensionWallet(walletConnector);
        }
    };
    const handleWalletItemClick = (wallet) => __awaiter$1(void 0, void 0, void 0, function* () {
        const { walletConnector, isInstalledOnBrowser } = wallet;
        const shouldEndWalletConnectorSession = walletConnector.connectedChain === 'FLOW' ||
            isPhantomRedirectConnector(walletConnector);
        logger$1.logVerboseTroubleshootingMessage('[handleWalletItemClick]', {
            mockedSDK,
            shouldEndWalletConnectorSession,
            wallet,
        });
        if (mockedSDK)
            return;
        if (shouldEndWalletConnectorSession) {
            yield walletConnector.endSession();
        }
        setLegacyIsVerifying(false);
        const isMetamask = walletConnector.key === 'metamask';
        // in connect only we only allow one account to be connected in the same wallet
        // also this is only a feature in MM
        if (authMode !== 'connect-only' && isMetamask) {
            try {
                setSelectedWalletConnectorKey(walletConnector.key);
                pushView('pending-connect');
                yield walletConnector.chooseAccountsToConnect();
            }
            catch (error) {
                if (error instanceof UserRejectedRequestError) {
                    setErrorMessage('connection_rejected');
                    clearStackAndPushInitialView();
                    return;
                }
            }
        }
        if (!allowAlreadyConnectedWallet &&
            isSelectedWalletAlreadyConnected(linkedWallets, walletConnector, user) &&
            walletConnector.connectedChain !== 'FLOW') {
            // wallet is already connected
            handleAlreadyConnectedWallet(walletConnector);
        }
        else if (walletConnector.canConnectViaCustodialService) {
            // providers like coinbase, blocto and dapper
            handleCustodialWalletClick(walletConnector);
        }
        else if (isMobile()) {
            // mobile wallets
            if (walletConnector.key === 'walletconnect') {
                pushView('wallet-connect-mobile-wallets-list');
            }
            else {
                handleMobileWalletClick(walletConnector);
            }
        }
        else if (isInstalledOnBrowser) {
            // browser extensions or injected wallets
            handleInstalledExtensionClick(walletConnector);
        }
        else {
            // wallet requiring a qr code (wallet connect/coinbase wallet)
            handleUninstalledClick(walletConnector);
        }
    });
    return {
        handleAlreadyConnectedWallet,
        handleCustodialWalletClick,
        handleInstalledExtensionClick,
        handleMobileWalletClick,
        handleUninstalledClick,
        handleWalletItemClick,
        openWallet,
    };
};

const FilterBridgeChainsName = (chainName) => (wallets) => wallets.filter((wallet) => wallet.walletConnector.supportedChains.includes(chainName));
/**
 * Filters the wallets by the provided chain
 * @param chain The chain to filter by
 */
const FilterChain = (chain) => (wallets) => wallets.filter((wallet) => wallet.walletConnector.supportedChains.includes(chain));

const resolvePromiseRef = (promise, value) => {
    if (!promise.current)
        return;
    promise.current.resolve(value);
    promise.current = null;
};

/**
 *  Check if given WalletOption is defined as a group
 *
 * @param {WalletOption} walletOption - Wallet Option
 * @returns {Boolean} - boolean value
 */
const isWalletGroup = (walletOption) => { var _a; return Boolean((_a = walletOption.groupedWallets) === null || _a === void 0 ? void 0 : _a.length); };

const findGroupIndex = (groupKey, workingArray) => workingArray.findIndex((walletOption) => isWalletGroup(walletOption) && walletOption.key === groupKey);
/**
 *  Group wallets by `group` property
 *
 * @param {WalletOption[]} walletOptionList - WalletOption list
 * @returns {WalletOption[]} the wallet options list with groups
 */
const groupWalletOptions = (walletGroups, walletOptionList) => {
    const output = [];
    walletOptionList.forEach((currentWalletOption) => {
        var _a;
        // Go to the next step if walletOption does not contain group
        if (!currentWalletOption.group) {
            return output.push(currentWalletOption);
        }
        // Determine if there a already defined group
        const existingGroupIndex = findGroupIndex(currentWalletOption.group, output);
        if (existingGroupIndex > -1) {
            return (_a = output[existingGroupIndex].groupedWallets) === null || _a === void 0 ? void 0 : _a.push(currentWalletOption);
        }
        // Validate if there is any other wallet with the same group
        const isThereWalletOptionWithSameGroup = walletOptionList.some((walletOption) => {
            var _a;
            const isSameGroup = currentWalletOption.group === walletOption.group;
            const isDifferentKey = currentWalletOption.key !== walletOption.key;
            const hasInjectedConfig = ((_a = walletOption.injectedConfig) === null || _a === void 0 ? void 0 : _a.length) &&
                walletOption.injectedConfig.length > 1;
            return isSameGroup && (hasInjectedConfig || isDifferentKey);
        });
        // Avoid group creation if there only one wallet in group
        if (!isThereWalletOptionWithSameGroup) {
            return output.push(currentWalletOption);
        }
        const walletGroupData = walletGroups[currentWalletOption.group];
        // If for some reason this is undefined, ignore it
        if (!walletGroupData) {
            return output.push(currentWalletOption);
        }
        const walletGroup = {
            groupedWallets: [currentWalletOption],
            key: walletGroupData.key,
            name: walletGroupData.name,
        };
        return output.push(walletGroup);
    });
    return output;
};

const embeddedWalletsKeys = [
    'magicemailotp',
    'magiclink',
    'magicsocial',
    'turnkey',
    'turnkeyhd',
    'zerodev',
];
const useWalletOptions = () => {
    const { walletConnectorOptions, setShowAuthFlow } = useInternalDynamicContext();
    const walletGroups = useWalletGroups();
    const { pushView } = useViewContext();
    const { navigateToWalletGroup } = useWalletGroupContext();
    const { handleWalletItemClick } = useWalletItemActions();
    const getFilteredWalletOptions = useCallback((filter) => {
        const nonEmbeddedOptions = walletConnectorOptions.filter((option) => !embeddedWalletsKeys.includes(option.walletConnector.key));
        return filter(nonEmbeddedOptions).map((option) => {
            var _a;
            const groupName = option.group && ((_a = walletGroups[option.group]) === null || _a === void 0 ? void 0 : _a.name);
            return {
                chain: option.walletConnector.connectedChain,
                group: option.group,
                groupName,
                isInstalledOnBrowser: option.isInstalledOnBrowser,
                isWalletConnect: option.walletConnector.isWalletConnect,
                key: option.walletConnector.key,
                name: option.name,
            };
        });
    }, [walletConnectorOptions, walletGroups]);
    const allWalletOptions = useMemo(() => getFilteredWalletOptions((options) => options), [getFilteredWalletOptions]);
    const selectWalletOption = useCallback((walletKey_1, ...args_1) => __awaiter$1(void 0, [walletKey_1, ...args_1], void 0, function* (walletKey, selectGroupIfAvailable = true) {
        const group = groupWalletOptions(walletGroups, walletConnectorOptions);
        const walletGroup = group.find((wallet) => wallet.key === walletKey);
        const walletOption = walletConnectorOptions === null || walletConnectorOptions === void 0 ? void 0 : walletConnectorOptions.find((wallet) => wallet.key === walletKey);
        logger$1.logVerboseTroubleshootingMessage('[useWalletOptions] selectWalletOption', {
            selectGroupIfAvailable,
            walletKey,
            walletOption: walletOption === null || walletOption === void 0 ? void 0 : walletOption.key,
        });
        if (!walletOption) {
            throw new DynamicError('Invalid wallet option key provided.');
        }
        if (selectGroupIfAvailable && walletGroup && isWalletGroup(walletGroup)) {
            navigateToWalletGroup(walletGroup);
        }
        else if (isHardwareWalletConnector(walletOption.walletConnector) &&
            walletOption.walletConnector.canConnectWithHardwareWallet()) {
            pushView('select-hardware-wallet', {
                onSelectWallet: handleWalletItemClick,
                wallet: walletOption,
            });
        }
        else {
            handleWalletItemClick(walletOption);
        }
        setShowAuthFlow(true);
    }), [
        handleWalletItemClick,
        navigateToWalletGroup,
        setShowAuthFlow,
        pushView,
        walletConnectorOptions,
        walletGroups,
    ]);
    return {
        getFilteredWalletOptions,
        selectWalletOption,
        walletOptions: allWalletOptions,
    };
};

const SPECIFIC_WALLETS_WITHOUT_REDIRECTS = [
    'coinbase',
    'phantomevm',
    'magiceden',
];
const FilterWalletsForExternalFunding = (wallets) => {
    if (!isMobile()) {
        return wallets;
    }
    return wallets.filter((wallet) => {
        if (SPECIFIC_WALLETS_WITHOUT_REDIRECTS.includes(wallet.key)) {
            return false;
        }
        const mobileCondition = wallet.walletConnector.isWalletConnect ||
            wallet.walletConnector.mobileExperience !== 'in-app-browser';
        return mobileCondition;
    });
};

const useConnectWalletForFunding = () => {
    const { primaryWallet, setShowAuthFlow } = useInternalDynamicContext();
    const { clearStackAndPush } = useViewContext();
    const userWallets = useUserWallets();
    const { walletOptions } = useWalletOptions();
    const internalConnectionPromiseRef = useRef(null);
    const connectWalletPromiseRef = useRef(null);
    const handleWalletMethod = useCallback((props) => __awaiter$1(void 0, void 0, void 0, function* () {
        // This is for phantom redirect: store the reason for this connection
        // so we don't lose the flow when redirected back
        const connectionType = {
            connectorConsumed: false,
            type: 'external-wallet-funding',
        };
        StorageService.setItem(PHANTOM_REDIRECT_CONNECTION_TYPE_KEY, connectionType);
        const address = yield props.walletConnector.getAddress(props.getAddressOpts);
        if (!address) {
            rejectPromiseRef(internalConnectionPromiseRef, new DynamicError('No wallet address found'));
            return;
        }
        resolvePromiseRef(internalConnectionPromiseRef, address);
    }), []);
    const { handleWalletItemClick } = useHandleWalletItem({
        allowAlreadyConnectedWallet: true,
        onConnectOnly: handleWalletMethod,
        onCustodialWallet: handleWalletMethod,
        onInstalledExtension: handleWalletMethod,
        onQrCodeConnect: handleWalletMethod,
    });
    useInternalDynamicEvents('authFlowClose', () => {
        rejectPromiseRef(connectWalletPromiseRef, new DynamicError('User cancelled'));
    });
    const getWalletAddress = useCallback((walletConnector) => {
        const walletOption = walletOptions.find(({ key }) => key === walletConnector.key);
        if (!walletOption)
            return Promise.reject(new DynamicError(`Connect wallet for funding error: wallet option for ${walletConnector.key} not found`));
        internalConnectionPromiseRef.current = new DeferredPromise();
        handleWalletItemClick(Object.assign(Object.assign({}, walletOption), { walletConnector }));
        return internalConnectionPromiseRef.current.promise;
    }, [handleWalletItemClick, walletOptions]);
    const hasWalletConnectWallet = userWallets.some((wallet) => wallet.connector.isWalletConnect);
    // WC does not allow multiple sessions, so we have 2 cases here:
    // 1. The user has a linked WalletConnect wallet.
    //    In this case, we should not do anything, and our logic will prevent other WCs from being
    //    selected for funding.
    // 2. The user does not have a WalletConnect wallet linked.
    //    In this case, we should reset the WC session — this is because they might have just
    //    previously connected another WC wallet for funding and that session could still be active.
    const resetWalletConnectSession = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        if (hasWalletConnectWallet)
            return;
        const walletOption = getWalletConnectorOptions().find(({ walletConnector }) => walletConnector.isWalletConnect);
        yield (walletOption === null || walletOption === void 0 ? void 0 : walletOption.walletConnector.endSession());
        yield (walletOption === null || walletOption === void 0 ? void 0 : walletOption.walletConnector.init());
    }), [hasWalletConnectWallet]);
    return useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        if (connectWalletPromiseRef.current) {
            return connectWalletPromiseRef.current.promise;
        }
        resetWalletConnectSession();
        connectWalletPromiseRef.current = new DeferredPromise();
        clearStackAndPush('external-funding-wallet-list', {
            onSelectWallet: (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ walletConnector }) {
                if (!connectWalletPromiseRef.current)
                    return;
                try {
                    const walletAddress = yield getWalletAddress(walletConnector);
                    if (!walletAddress) {
                        rejectPromiseRef(connectWalletPromiseRef, new DynamicError('No wallet address found'));
                        return;
                    }
                    const wallet = walletConnector.createWallet({
                        address: walletAddress,
                        chain: walletConnector.connectedChain,
                        connector: walletConnector,
                        id: 'external-funding-wallet',
                        isAuthenticated: false,
                        key: walletConnector.key,
                    });
                    resolvePromiseRef(connectWalletPromiseRef, wallet);
                }
                catch (error) {
                    rejectPromiseRef(connectWalletPromiseRef, error);
                    return;
                }
                finally {
                    setShowAuthFlow(false);
                }
            }),
            showDefaultFooter: true,
            viewWalletsFilter: pipe(FilterWalletsForExternalFunding).pipe(FilterChain(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain)),
        });
        setShowAuthFlow(true, {
            emitCancelAuth: false,
            ignoreIfIsEmbeddedWidget: true,
            initializeWalletConnect: true,
            performMultiWalletChecks: false,
        });
        return connectWalletPromiseRef.current.promise;
    }), [
        resetWalletConnectSession,
        clearStackAndPush,
        primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain,
        setShowAuthFlow,
        getWalletAddress,
    ]);
};

const useFund = () => {
    const { primaryWallet } = useInternalDynamicContext();
    return useCallback((_a) => __awaiter$1(void 0, [_a], void 0, function* ({ amount, fromWallet, token }) {
        if (!amount || !fromWallet) {
            throw new Error('Amount and fromWallet are required');
        }
        if (!primaryWallet) {
            throw new Error('Primary wallet not found');
        }
        const fromWalletNetwork = yield fromWallet.getNetwork();
        const primaryWalletNetwork = yield primaryWallet.getNetwork();
        if (!fromWalletNetwork || !primaryWalletNetwork) {
            throw new Error('Wallet network not found');
        }
        if (fromWalletNetwork !== primaryWalletNetwork) {
            yield fromWallet.switchNetwork(primaryWalletNetwork);
        }
        const toAddress = primaryWallet.address;
        return fromWallet.sendBalance({
            amount: amount.toString(),
            toAddress,
            token,
        });
    }), [primaryWallet]);
};

const usePromptAmountAndFundWithWallet = () => {
    const { setDynamicWidgetView } = useWidgetContext();
    const { setShowDynamicUserProfile } = useInternalDynamicContext();
    return useCallback((props) => {
        setDynamicWidgetView('receive-external-wallet-funds', props);
        setShowDynamicUserProfile(true);
    }, [setDynamicWidgetView, setShowDynamicUserProfile]);
};

const useFundWithWallet = () => {
    var _a, _b;
    const projectSettings = useProjectSettings();
    const fundWithWallet = useFund();
    const connectWalletForFunding = useConnectWalletForFunding();
    const promptAmountAndFundWithWallet = usePromptAmountAndFundWithWallet();
    return useMemo(() => {
        var _a, _b;
        return ({
            /**
             * Connects an external wallet and returns the wallet.
             *
             * Use the returned wallet with methods of `fromWallet` to fund the primary wallet.
             */
            connectWalletForFunding,
            /**
             * Whether external wallet funding is enabled.
             */
            externalWalletFundingEnabled: Boolean((_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.funding) === null || _a === void 0 ? void 0 : _a.externalWallets) === null || _b === void 0 ? void 0 : _b.enabled),
            /**
             * Triggers a funding transaction from the given wallet to the primary wallet.
             */
            fund: fundWithWallet,
            /**
             * Prompts the user for an amount and token and triggers a funding transaction
             * from the given wallet to the primary wallet.
             */
            promptAmountAndFund: promptAmountAndFundWithWallet,
        });
    }, [
        connectWalletForFunding,
        (_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.funding) === null || _a === void 0 ? void 0 : _a.externalWallets) === null || _b === void 0 ? void 0 : _b.enabled,
        fundWithWallet,
        promptAmountAndFundWithWallet,
    ]);
};

const useSubmitExternalWalletFunding = () => {
    const { fund } = useFundWithWallet();
    const { goToInitialDynamicWidgetView, setHeaderAlert } = useWidgetContext();
    const { t } = useTranslation();
    return useCallback((_a) => __awaiter$1(void 0, [_a], void 0, function* ({ tokenAmount, externalWallet, tokenSymbol, tokenBalances, }) {
        var _b;
        if (!tokenAmount)
            return;
        // This should be defined because if the current token is not in the tokenBalances,
        // the user would not be able to select it in the token select screen,
        // or if it was already selected, the user would see balance as 0 and submit button would be disabled
        const token = (_b = tokenBalances === null || tokenBalances === void 0 ? void 0 : tokenBalances.find(({ symbol }) => symbol === tokenSymbol)) === null || _b === void 0 ? void 0 : _b.token;
        if (!token)
            return;
        try {
            const txId = yield fund({
                amount: parseFloat(tokenAmount),
                fromWallet: externalWallet,
                token: token === 'native' ? undefined : token,
            });
            logger$1.info(`Funding with external wallet succeeded with transaction id: ${txId}`);
            const blockExplorerUrl = (yield externalWallet.connector.getBlockExplorerUrlsForCurrentNetwork())[0];
            const TxnSuccessAlert = (jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', color: 'current-color', children: [t('dyn_wallet_funding.success'), blockExplorerUrl && (jsxRuntimeExports.jsx(Typography, { as: 'a', href: `${blockExplorerUrl}/tx/${txId}`, target: '_blank', rel: 'noreferrer', style: {
                            marginLeft: pixelToRem(4),
                            textDecoration: 'underline',
                            textDecorationThickness: pixelToRem(1),
                            textUnderlineOffset: pixelToRem(2),
                        }, weight: 'bold', color: 'current-color', children: t('dyn_wallet_funding.success_txn_link') }))] }));
            goToInitialDynamicWidgetView();
            setHeaderAlert({
                content: TxnSuccessAlert,
                variant: 'success',
            });
        }
        catch (error) {
            logger$1.error('Failed to fund with external wallet', error);
        }
    }), [fund, goToInitialDynamicWidgetView, setHeaderAlert, t]);
};

const useFetchBalance = ({ wallet, chain, network }) => {
    const [balance, setBalance] = useState('0.0');
    const isFetchBalanceDisabled = !chain || (wallet.connector.supportsNetworkSwitching() && !network);
    const fetchBalance = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (isFetchBalanceDisabled)
            return;
        const value = yield wallet.getBalance();
        setBalance(value);
    });
    const { isLoading } = usePromise(fetchBalance, {
        deps: [wallet.address, network === null || network === void 0 ? void 0 : network.toString(), chain],
        enabled: !isFetchBalanceDisabled,
    });
    return { balance, isLoading };
};

const getAccountTokenBalances = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ environmentId, chainName = ChainEnum.Evm, networkId, accountAddress, includeNative = false, includePrices = false, forceRefresh = false, }) {
    const customHeaders = forceRefresh
        ? { 'Cache-Control': 'no-cache' }
        : undefined;
    const data = yield sdkApi({ customHeaders }).getAccountBalances({
        accountAddress,
        chainName: chainName,
        environmentId,
        includeNative,
        includePrices,
        networkId,
    });
    return data;
});

// Hook exposed to customers and used internally to fetch account balances
const useTokenBalances = ({ accountAddress, networkId, chainName = ChainEnum.Evm, tokenAddresses, includeFiat = false, includeNativeBalance = false, } = {}) => {
    const tokenBalancesState = useTokenBalancesState();
    const { tokenBalances, isLoading, error } = tokenBalancesState;
    const { primaryWallet, environmentId, network, user, projectSettings, authMode, } = useInternalDynamicContext();
    const walletConnector = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector;
    const requestChainName = chainName !== null && chainName !== void 0 ? chainName : walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain;
    const requestAccount = accountAddress !== null && accountAddress !== void 0 ? accountAddress : primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address;
    const requestNetwork = networkId !== null && networkId !== void 0 ? networkId : network;
    const fetchAccountBalances = useCallback((...args_1) => __awaiter$1(void 0, [...args_1], void 0, function* (forceRefresh = false) {
        var _a;
        if (authMode !== 'connect-only' && !user) {
            setTokenBalanceVariable('error', USER_NOT_LOGGED_IN);
            return;
        }
        if (authMode === 'connect-only' &&
            !((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.featureFlags) === null || _a === void 0 ? void 0 : _a.connectOnlyMultiAsset)) {
            return;
        }
        if (![ChainEnum.Evm, ChainEnum.Sol].includes(requestChainName)) {
            setTokenBalanceVariable('error', `Chain ${requestChainName} is not supported for token balances`);
            return;
        }
        const isValidEvmRequest = chainName === ChainEnum.Evm &&
            requestNetwork &&
            !isNaN(Number(requestNetwork));
        const isValidRequest = isValidEvmRequest || chainName === ChainEnum.Sol;
        if (isLoading || !requestAccount || !isValidRequest) {
            setTokenBalanceVariable('tokenBalances', undefined);
            return;
        }
        setTokenBalanceVariable('isLoading', true);
        try {
            const response = yield getAccountTokenBalances({
                accountAddress: requestAccount,
                chainName: requestChainName,
                environmentId,
                forceRefresh,
                includeNative: includeNativeBalance,
                includePrices: includeFiat,
                networkId: chainName === ChainEnum.Evm ? Number(requestNetwork) : 0,
            });
            if (!response)
                return;
            setTokenBalanceVariable('error', undefined);
            setTokenBalanceVariable('tokenBalances', response);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (e) {
            yield logResponseError(e, 'Error getting token balances');
            const errorMessage = (e === null || e === void 0 ? void 0 : e.code) === 429 ? 'Too many requests fetching balances' : e === null || e === void 0 ? void 0 : e.message;
            setTokenBalanceVariable('error', errorMessage);
        }
        finally {
            setTokenBalanceVariable('isLoading', false);
        }
    }), [
        user,
        requestChainName,
        chainName,
        requestNetwork,
        isLoading,
        requestAccount,
        environmentId,
        includeNativeBalance,
        includeFiat,
    ]);
    useInternalDynamicEvents('tokenBalancesChanged', () => fetchAccountBalances(true));
    useEffect(() => {
        fetchAccountBalances();
    }, [requestAccount, requestNetwork]);
    const { tokensFilter } = useDynamicSettings();
    const lowerTokenAddresses = tokenAddresses === null || tokenAddresses === void 0 ? void 0 : tokenAddresses.map((address) => address.toLowerCase());
    const initialTokenBalances = lowerTokenAddresses
        ? tokenBalances === null || tokenBalances === void 0 ? void 0 : tokenBalances.filter((token) => lowerTokenAddresses === null || lowerTokenAddresses === void 0 ? void 0 : lowerTokenAddresses.includes(token.address.toLowerCase()))
        : tokenBalances;
    const filteredTokenBalances = initialTokenBalances
        ? tokensFilter(initialTokenBalances)
        : [];
    return {
        error,
        fetchAccountBalances,
        isError: Boolean(error),
        isLoading,
        tokenBalances: filteredTokenBalances,
    };
};

const useTokensForFunding = ({ wallet, }) => {
    var _a, _b;
    const { network } = useInternalDynamicContext();
    const { tokenBalances, isLoading: tokenBalancesLoading } = useTokenBalances({
        accountAddress: wallet.address,
        chainName: wallet.connector.connectedChain,
        includeFiat: true,
        includeNativeBalance: true,
    });
    const { currency, isLoading: currencyLoading } = useFetchCurrency(wallet.connector, network);
    const { balance, isLoading: balanceLoading } = useFetchBalance({
        chain: currency === null || currency === void 0 ? void 0 : currency.symbol,
        network,
        wallet,
    });
    if (tokenBalancesLoading || currencyLoading || balanceLoading) {
        return {
            isLoading: true,
            tokens: [],
        };
    }
    const enabledNetworks = wallet.connector.getEnabledNetworks();
    let parsedTokens = [];
    if (!tokenBalancesLoading) {
        parsedTokens = tokenBalances
            // Contrary to what the type says, symbol and name may be undefined
            .filter(({ symbol, balance, address }) => symbol && balance && address)
            .map(({ symbol, balance, name, logoURI, address, decimals, price, marketValue, }) => {
            const parsedBalance = parseFloat(balance.toString());
            // We use token balance for stablecoins to improve readability (user expectation is to be 1:1)
            let fiatBalance = isFiatOrStablecoin(symbol)
                ? parsedBalance
                : marketValue;
            if (fiatBalance === undefined && price)
                fiatBalance = price * parsedBalance;
            return {
                balance: parsedBalance,
                fiatBalance,
                logoURI,
                name: name !== null && name !== void 0 ? name : symbol,
                price,
                symbol,
                token: {
                    address,
                    decimals,
                },
            };
        });
    }
    if ((currency === null || currency === void 0 ? void 0 : currency.symbol) && parseFloat(balance !== null && balance !== void 0 ? balance : '0')) {
        const nativeToken = parsedTokens.find((token) => token.symbol === currency.symbol);
        if (nativeToken) {
            nativeToken.token = 'native';
            return {
                isLoading: false,
                tokens: parsedTokens,
            };
        }
        const logoURI = (_a = enabledNetworks.find(({ chainId }) => chainId === network)) === null || _a === void 0 ? void 0 : _a.iconUrls[0];
        const fetchedToken = {
            balance: parseFloat(balance !== null && balance !== void 0 ? balance : '0'),
            fiatBalance: undefined,
            logoURI,
            name: (_b = currency.name) !== null && _b !== void 0 ? _b : currency.symbol,
            symbol: currency.symbol,
            token: 'native',
        };
        return {
            isLoading: false,
            tokens: [...parsedTokens, fetchedToken],
        };
    }
    return {
        isLoading: false,
        tokens: parsedTokens,
    };
};

const defaultQuickSuggestions = {
    token: 'USD',
    values: [25, 100, 500],
};
const rulesThatHideQuickSuggestions = ['exact', 'minimum'];
const rulesThatDisableTokenSelect = ['exact', 'exact-with-amount'];
const inputEmitter = createFormattedInputEmitter();
const ReceiveExternalWalletFunds = ({ amount: initialAmount, token: initialTokenRaw, externalWallet, quickSuggestions = defaultQuickSuggestions, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    // For now we hardcode the default value, soon we will fetch this from project settings
    const initialToken = initialTokenRaw !== null && initialTokenRaw !== void 0 ? initialTokenRaw : {
        rule: 'recommended',
        value: 'USDC',
    };
    /** Whether the amount specified in the prop refers to the token amount instead of the fiat amount */
    const isInitialAmountValueForToken = (initialToken === null || initialToken === void 0 ? void 0 : initialToken.rule) === 'exact-with-amount';
    const minimum = (initialAmount === null || initialAmount === void 0 ? void 0 : initialAmount.rule) === 'minimum'
        ? {
            token: isInitialAmountValueForToken
                ? initialToken.value
                : 'USD',
            value: initialAmount.value.toString(),
        }
        : undefined;
    const { t } = useTranslation();
    const [hasUserInteracted, setHasUserInteracted] = useState(false);
    const [conversionErrorIconRef, setConversionErrorIconRef] = useState(null);
    const { setDynamicWidgetView } = useWidgetContext();
    const { isLoading: tokenBalancesLoading, tokens: tokenBalances } = useTokensForFunding({
        wallet: externalWallet,
    });
    const exchangeRates = useExchangeRatesForFunding({
        // Initialize amounts after exchange rates are fetched
        onFetch: (exchangeRates) => {
            if (tokenAmount === undefined && fiatAmount !== undefined) {
                setTokenAmount(convertFromFiat(fiatAmount, tokenSymbol, exchangeRates));
            }
            if (fiatAmount === undefined && tokenAmount !== undefined) {
                setFiatAmount(convertToFiat(tokenAmount, tokenSymbol, exchangeRates));
            }
        },
        tokenBalances,
    });
    const [tokenAmount, setTokenAmount] = useState(isInitialAmountValueForToken
        ? (_a = initialAmount === null || initialAmount === void 0 ? void 0 : initialAmount.value.toString()) !== null && _a !== void 0 ? _a : ''
        : convertFromFiat((_b = initialAmount === null || initialAmount === void 0 ? void 0 : initialAmount.value.toString()) !== null && _b !== void 0 ? _b : '', initialToken.value, exchangeRates));
    const [tokenSymbol, _setTokenSymbol] = useState(initialToken.value);
    const [fiatAmount, setFiatAmount] = useState(isInitialAmountValueForToken
        ? convertToFiat(tokenAmount !== null && tokenAmount !== void 0 ? tokenAmount : '', tokenSymbol, exchangeRates)
        : (_c = initialAmount === null || initialAmount === void 0 ? void 0 : initialAmount.value.toString()) !== null && _c !== void 0 ? _c : '');
    const setTokenSymbol = useCallback((symbol) => {
        setHasUserInteracted(true);
        _setTokenSymbol(symbol);
        if (fiatAmount)
            setTokenAmount(convertFromFiat(fiatAmount, symbol, exchangeRates));
    }, [fiatAmount, exchangeRates]);
    // When we eventually allow changing this, add setter as _setFiatSymbol
    // And then create a setFiatSymbol function similar to how we have setTokenSymbol
    const [fiatSymbol] = useState('USD');
    const setAmountsByTokenValue = useCallback((amount) => {
        setTokenAmount(amount);
        setFiatAmount(convertToFiat(amount, tokenSymbol, exchangeRates));
    }, [tokenSymbol, exchangeRates]);
    const setAmountsByFiatValue = useCallback((amount) => {
        setFiatAmount(amount);
        setTokenAmount(convertFromFiat(amount, tokenSymbol, exchangeRates));
    }, [tokenSymbol, exchangeRates]);
    const [showTokenAsPrimary, setShowTokenAsPrimary] = useState(false);
    const switchPrimaryAndSecondary = useCallback(() => {
        setHasUserInteracted(true);
        setShowTokenAsPrimary(!showTokenAsPrimary);
        if (tokenAmount && isNaN(parseFloat(tokenAmount))) {
            setTokenAmount('');
        }
        if (fiatAmount && isNaN(parseFloat(fiatAmount))) {
            setFiatAmount('');
        }
        inputEmitter.emit('focus');
    }, [fiatAmount, showTokenAsPrimary, tokenAmount]);
    const isMinimumRespected = minimum
        ? respectsMinimum({ token: fiatSymbol, value: fiatAmount !== null && fiatAmount !== void 0 ? fiatAmount : '' }, minimum, exchangeRates)
        : true;
    const [primaryData, secondaryData] = showTokenAsPrimary
        ? [
            {
                amount: tokenAmount,
                setAmount: setAmountsByTokenValue,
                symbol: tokenSymbol,
            },
            { amount: fiatAmount, symbol: fiatSymbol },
        ]
        : [
            {
                amount: fiatAmount,
                setAmount: setAmountsByFiatValue,
                symbol: fiatSymbol,
            },
            { amount: tokenAmount, symbol: tokenSymbol },
        ];
    const secondaryDisplay = formatValue({
        maxDecimals: isFiatOrStablecoin(secondaryData.symbol) ? 2 : undefined,
        symbol: secondaryData.symbol,
        value: secondaryData.amount,
        withFixedZeros: isFiatOrStablecoin(secondaryData.symbol),
    });
    const quickSuggestionsWithToken = Array.isArray(quickSuggestions)
        ? { token: 'USD', values: quickSuggestions }
        : quickSuggestions;
    const quickSuggestionsParsed = quickSuggestionsWithToken.values
        .filter((value) => respectsMinimum({ token: quickSuggestionsWithToken.token, value: value.toString() }, minimum, exchangeRates))
        .map((value) => ({
        display: formatValue({
            symbol: quickSuggestionsWithToken.token,
            value: value,
        }),
        value,
    }))
        .filter(({ display }) => display !== undefined);
    const currentToken = tokenBalances === null || tokenBalances === void 0 ? void 0 : tokenBalances.find(({ symbol }) => symbol === tokenSymbol);
    const fiatBalance = calculateFiatBalance(currentToken, exchangeRates);
    const [primaryBalance, secondaryBalance] = showTokenAsPrimary
        ? [
            {
                symbol: tokenSymbol,
                value: (_d = currentToken === null || currentToken === void 0 ? void 0 : currentToken.balance) !== null && _d !== void 0 ? _d : 0,
            },
            {
                symbol: fiatSymbol,
                value: fiatBalance,
            },
        ]
        : [
            {
                symbol: fiatSymbol,
                value: fiatBalance,
            },
            {
                symbol: tokenSymbol,
                value: (_e = currentToken === null || currentToken === void 0 ? void 0 : currentToken.balance) !== null && _e !== void 0 ? _e : 0,
            },
        ];
    const showNotEnoughBalance = Boolean(!currentToken ||
        (isNonZero(tokenAmount) &&
            tokenAmount !== undefined &&
            currentToken.balance < parseFloat(tokenAmount)));
    const showMinimumRequired = Boolean(!isMinimumRespected && !showNotEnoughBalance);
    const showQuickSuggestions = quickSuggestionsParsed.length > 0 &&
        !hasUserInteracted &&
        !rulesThatHideQuickSuggestions.includes(initialAmount === null || initialAmount === void 0 ? void 0 : initialAmount.rule) &&
        (tokenSymbol === quickSuggestionsWithToken.token ||
            isFiatToken(quickSuggestionsWithToken.token));
    const disableTokenSelect = rulesThatDisableTokenSelect.includes(initialToken.rule);
    const [showTokenSelect, setShowTokenSelect] = useState(false);
    const handleSelectToken = useCallback((token) => {
        setTokenSymbol(token);
        setShowTokenSelect(false);
    }, [setTokenSymbol]);
    const handleQuickSuggestion = useCallback((value) => {
        setHasUserInteracted(true);
        if (isFiatToken(quickSuggestionsWithToken.token))
            setAmountsByFiatValue(value.toString());
        else
            setAmountsByTokenValue(value.toString());
        inputEmitter.emit('focus');
    }, [
        quickSuggestionsWithToken.token,
        setAmountsByFiatValue,
        setAmountsByTokenValue,
    ]);
    const handleSubmit = useSubmitExternalWalletFunding();
    const disableSubmit = !isMinimumRespected || showNotEnoughBalance || !isNonZero(tokenAmount);
    const closeTokenSelect = useCallback(() => {
        setShowTokenSelect(false);
        inputEmitter.emit('focus');
    }, []);
    const grayOutSecondaryDisplay = !isNonZero(secondaryData.amount) ||
        (isFiatOrStablecoin(secondaryData.symbol) &&
            parseFloat((_f = secondaryData.amount) !== null && _f !== void 0 ? _f : '0') < 0.0099);
    const inputSymbolProp = primaryData.symbol === 'USD'
        ? { leading: '$' }
        : { trailing: primaryData.symbol };
    const backButton = (jsxRuntimeExports.jsx(IconButton, { type: 'button', id: 'back-button', "data-testid": 'back-button', onClick: () => setDynamicWidgetView('choose-wallet-funding-method'), children: jsxRuntimeExports.jsx(SvgArrowLeft, {}) }));
    return (jsxRuntimeExports.jsxs("div", { className: 'fund-from-wallet', children: [!disableTokenSelect && (jsxRuntimeExports.jsx(TokenSelectScreen, { onClose: closeTokenSelect, onSelectToken: handleSelectToken, tokens: tokenBalances !== null && tokenBalances !== void 0 ? tokenBalances : [], currentToken: tokenSymbol, className: classNames('fund-from-wallet__token-select', {
                    'fund-from-wallet__token-select--open': showTokenSelect,
                }), showTokenAsPrimary: showTokenAsPrimary, exchangeRates: exchangeRates })), jsxRuntimeExports.jsx(ModalHeader, { leading: backButton, children: jsxRuntimeExports.jsx(Typography, { variant: 'title', children: t('dyn_wallet_funding.from_external_wallet.funding_view.title') }) }), jsxRuntimeExports.jsxs("div", { className: 'fund-from-wallet__content', children: [jsxRuntimeExports.jsxs("div", { className: 'fund-from-wallet__content__amount-container', children: [minimum && (jsxRuntimeExports.jsx(Typography, { color: 'error-1', className: classNames('fund-from-wallet__content__amount-container__minimum-error', {
                                    'fund-from-wallet__content__amount-container__minimum-error--visible': showMinimumRequired,
                                }), variant: 'body_normal', weight: 'medium', children: t('dyn_wallet_funding.from_external_wallet.funding_view.minimum_error', {
                                    minimum: formatValue({
                                        symbol: minimum.token,
                                        value: minimum.value,
                                    }),
                                }) })), primaryData.amount !== undefined && (jsxRuntimeExports.jsx(FormattedInput, Object.assign({ className: 'fund-from-wallet__content__amount-container__amount', value: (initialAmount === null || initialAmount === void 0 ? void 0 : initialAmount.rule) === 'exact'
                                    ? (_g = formatValue({
                                        maxDecimals: isFiatOrStablecoin(primaryData.symbol)
                                            ? 2
                                            : 8,
                                        symbol: undefined,
                                        value: primaryData.amount,
                                        withFixedZeros: isFiatOrStablecoin(primaryData.symbol),
                                    })) !== null && _g !== void 0 ? _g : primaryData.amount
                                    : primaryData.amount, onChange: primaryData.setAmount, emitter: inputEmitter, onInteraction: () => setHasUserInteracted(true), locked: (initialAmount === null || initialAmount === void 0 ? void 0 : initialAmount.rule) === 'exact' }, inputSymbolProp))), primaryData.amount === undefined && (jsxRuntimeExports.jsx(Skeleton, { dataTestId: 'primary-amount-skeleton', container: {
                                    className: 'fund-from-wallet__content__amount-container__skeleton',
                                } })), showQuickSuggestions && (jsxRuntimeExports.jsx("div", { className: 'fund-from-wallet__content__amount-container__quick-suggestions', children: quickSuggestionsParsed.map(({ display, value }) => (jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', onClick: () => handleQuickSuggestion(value), weight: 'medium', children: display }, value))) })), !showQuickSuggestions && secondaryDisplay && (jsxRuntimeExports.jsxs("div", { className: 'fund-from-wallet__content__amount-container__secondary-amount-container', children: [(currentToken === null || currentToken === void 0 ? void 0 : currentToken.logoURI) ? (jsxRuntimeExports.jsx(Image$1, { dataTestId: 'token-icon', alt: tokenSymbol, src: currentToken.logoURI, className: 'fund-from-wallet__content__token-icon' })) : null, jsxRuntimeExports.jsx(Typography, { weight: 'medium', className: classNames('fund-from-wallet__content__amount-container__secondary-amount-container__amount', {
                                            'fund-from-wallet__content__amount-container__secondary-amount-container__amount--grayed-out': grayOutSecondaryDisplay,
                                        }), children: secondaryDisplay }), jsxRuntimeExports.jsx(Icon, { size: 'small', color: 'text-secondary', className: 'fund-from-wallet__content__amount-container__secondary-amount-container__switch', children: jsxRuntimeExports.jsx(SvgSwitchToggle, { "data-testid": 'switch-primary-and-secondary', onClick: switchPrimaryAndSecondary }) })] })), !showQuickSuggestions && !secondaryDisplay && (jsxRuntimeExports.jsxs("div", { className: 'fund-from-wallet__content__amount-container__secondary-missing', children: [jsxRuntimeExports.jsx(Typography, { weight: 'medium', children: formatValue({
                                            symbol: secondaryData.symbol,
                                            value: UNAVAILABLE_VALUE,
                                        }) }), jsxRuntimeExports.jsx("div", { ref: setConversionErrorIconRef, children: jsxRuntimeExports.jsx(Icon, { size: 'medium', color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgFooterInfoIcon, {}) }) }), jsxRuntimeExports.jsx(Tooltip, { content: t('dyn_wallet_funding.from_external_wallet.funding_view.pricing_unavailable'), targetRef: conversionErrorIconRef, className: 'fund-from-wallet__content__amount-container__secondary-missing__tooltip' })] })), jsxRuntimeExports.jsx(Typography, { color: 'error-1', className: classNames('fund-from-wallet__content__amount-container__balance-error', {
                                    'fund-from-wallet__content__amount-container__balance-error--visible': showNotEnoughBalance,
                                }), variant: 'body_normal', weight: 'medium', children: t('dyn_wallet_funding.from_external_wallet.funding_view.balance_error') })] }), jsxRuntimeExports.jsxs("div", { className: 'fund-from-wallet__content__wallet-card', children: [jsxRuntimeExports.jsxs("div", { className: 'fund-from-wallet__content__wallet-card__wallet-details', children: [jsxRuntimeExports.jsx(WalletIcon, { icon: externalWallet.connector.metadata.icon, walletKey: externalWallet.connector.key, className: 'fund-from-wallet__content__wallet-card__wallet-details__icon' }), jsxRuntimeExports.jsxs("div", { className: 'fund-from-wallet__content__wallet-card__wallet-details__rows', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'medium', children: t('dyn_wallet_funding.from_external_wallet.funding_view.wallet_detail_from') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', weight: 'medium', children: shortenWalletAddress(externalWallet.address) })] })] }), tokenBalancesLoading && (jsxRuntimeExports.jsx(Skeleton, { dataTestId: 'balance-skeleton', container: {
                                    className: 'fund-from-wallet__content__wallet-card__balance-skeleton',
                                } })), !tokenBalancesLoading && (jsxRuntimeExports.jsxs("div", { className: classNames('fund-from-wallet__content__wallet-card__balance', {
                                    'fund-from-wallet__content__wallet-card__balance--disable-select': disableTokenSelect,
                                }), onClick: () => !disableTokenSelect && setShowTokenSelect(true), children: [jsxRuntimeExports.jsxs("div", { className: 'fund-from-wallet__content__wallet-card__balance__rows', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_small', "data-testid": `primary-balance-amount-${primaryBalance.symbol}`, weight: 'medium', children: formatValue({
                                                    maxDecimals: isFiatOrStablecoin(primaryBalance.symbol)
                                                        ? 2
                                                        : 6,
                                                    symbol: primaryBalance.symbol,
                                                    value: (_h = primaryBalance.value) !== null && _h !== void 0 ? _h : UNAVAILABLE_VALUE,
                                                    withFixedZeros: isFiatOrStablecoin(primaryBalance.symbol),
                                                }) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', "data-testid": `secondary-balance-amount-${secondaryBalance.symbol}`, color: 'secondary', weight: 'medium', children: formatValue({
                                                    maxDecimals: isFiatOrStablecoin(secondaryBalance.symbol)
                                                        ? 2
                                                        : 6,
                                                    symbol: secondaryBalance.symbol,
                                                    value: (_j = secondaryBalance.value) !== null && _j !== void 0 ? _j : UNAVAILABLE_VALUE,
                                                    withFixedZeros: isFiatOrStablecoin(secondaryBalance.symbol),
                                                }) })] }), !disableTokenSelect && (jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', size: 'small', className: 'fund-from-wallet__content__wallet-card__balance__icon', children: jsxRuntimeExports.jsx(SvgChevronDown, { "data-testid": 'token-select-dropdown' }) }))] }))] })] }), jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'confirm-button', buttonVariant: 'brand-primary', buttonPadding: 'large', typographyProps: { color: 'white' }, className: 'fund-from-wallet__confirm-button', disabled: disableSubmit, onClick: () => handleSubmit({
                    externalWallet,
                    tokenAmount,
                    tokenBalances,
                    tokenSymbol,
                }), children: t('dyn_wallet_funding.from_external_wallet.funding_view.confirm_button') })] }));
};

const onrampConfigurationToOnrampOption = (provider, onClick) => {
    var _a, _b, _c;
    return ({
        displayName: (_b = (_a = provider.name) !== null && _a !== void 0 ? _a : provider.provider) !== null && _b !== void 0 ? _b : '',
        iconUrl: (_c = provider.iconUrl) !== null && _c !== void 0 ? _c : '',
        id: String(provider.provider),
        iframeUrl: provider.url,
        onClick: (_params) => onClick({
            onrampProvider: provider.provider,
        }),
    });
};

const getWalletAdditionalAddressByType = (type, wallet) => {
    var _a, _b;
    return (_b = (_a = wallet === null || wallet === void 0 ? void 0 : wallet.additionalAddresses) === null || _a === void 0 ? void 0 : _a.find((address) => address.type === type)) === null || _b === void 0 ? void 0 : _b.address;
};

const getOnrampProviders = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ chain, environmentId, networkId, token, walletAddress, }) {
    const { onramps } = yield sdkApi().getSupportedOnramps({
        chain,
        environmentId,
        networkId: networkId ? String(networkId) : undefined,
        token,
        walletAddress,
    });
    return onramps !== null && onramps !== void 0 ? onramps : [];
});

const useEnabledOnrampProviders = ({ primaryWallet, network, environmentId, projectSettingsOnramps, target, }) => {
    var _a;
    const chainName = (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain)
        ? (_a = getChainInfo(primaryWallet.chain)) === null || _a === void 0 ? void 0 : _a.name
        : undefined;
    const bitcoinAddress = primaryWallet &&
        isBitcoinConnector(primaryWallet.connector) &&
        getWalletAdditionalAddressByType(WalletAddressType.Payment, primaryWallet);
    const chainHasNetwork = network && chainName === 'evm';
    const { data: onrampProviders } = usePromise(() => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!chainName || !(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address))
            return [];
        return getOnrampProviders({
            chain: chainName,
            environmentId,
            networkId: chainHasNetwork ? network.toString() : undefined,
            token: target.token,
            walletAddress: target.address || bitcoinAddress || primaryWallet.address,
        });
    }), {
        deps: [
            environmentId,
            network,
            primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address,
            target.address,
            target.token,
        ],
        initialData: [],
    });
    return useMemo(() => onrampProviders.filter((p) => projectSettingsOnramps === null || projectSettingsOnramps === void 0 ? void 0 : projectSettingsOnramps.includes(p.provider)), [onrampProviders, projectSettingsOnramps]);
};

const OnrampContext = createContext(undefined);
const OnrampContextProvider = ({ children, }) => {
    var _a, _b, _c, _d, _e;
    const promiseRef = useRef(null);
    const [selectedOnrampProvider, setSelectedOnrampProvider] = useState();
    const [showOnramp, _setShowOnramp] = useState(false);
    const { environmentId, network, primaryWallet, projectSettings, overrides } = useInternalDynamicContext();
    const [enabledOnrampProvidersTarget, setEnabledOnrampProvidersTarget] = useState({});
    const setShowOnramp = useCallback((value) => {
        _setShowOnramp(value);
        if (!value && promiseRef.current) {
            rejectPromiseRef(promiseRef, new DynamicError('User cancelled'));
        }
    }, []);
    const onrampOverrides = useMemo(() => { var _a; return (_a = overrides === null || overrides === void 0 ? void 0 : overrides.onrampOptions) !== null && _a !== void 0 ? _a : []; }, [overrides === null || overrides === void 0 ? void 0 : overrides.onrampOptions]);
    const enabledOnrampProvidersInDashboard = useEnabledOnrampProviders({
        environmentId,
        network,
        primaryWallet,
        projectSettingsOnramps: (_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _a === void 0 ? void 0 : _a.funding) === null || _b === void 0 ? void 0 : _b.onramps,
        target: enabledOnrampProvidersTarget,
    });
    const onrampEnabled = Boolean(((_e = (_d = (_c = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _c === void 0 ? void 0 : _c.funding) === null || _d === void 0 ? void 0 : _d.onramps) === null || _e === void 0 ? void 0 : _e.length) &&
        enabledOnrampProvidersInDashboard.length) || Boolean(onrampOverrides.length);
    const openOnramp = useCallback((_f) => __awaiter$1(void 0, [_f], void 0, function* ({ onrampProvider, address, token }) {
        if (!onrampEnabled) {
            throw new Error('Onramp is not enabled');
        }
        if (promiseRef.current) {
            return promiseRef.current.promise;
        }
        promiseRef.current = new DeferredPromise();
        if (address || token)
            setEnabledOnrampProvidersTarget({ address, token });
        setSelectedOnrampProvider(onrampProvider);
        setShowOnramp(true);
        return promiseRef.current.promise;
    }), [onrampEnabled, setShowOnramp]);
    const enabledOnrampProviders = useMemo(() => {
        const enabledOnrampProvidersInDashboardOptions = enabledOnrampProvidersInDashboard.map((provider) => onrampConfigurationToOnrampOption(provider, openOnramp));
        return [...enabledOnrampProvidersInDashboardOptions, ...onrampOverrides];
    }, [enabledOnrampProvidersInDashboard, openOnramp, onrampOverrides]);
    const selectedOnramp = useMemo(() => {
        if (!enabledOnrampProviders.length)
            return;
        const selectedProvider = enabledOnrampProviders.find((p) => p.id === selectedOnrampProvider);
        return selectedProvider;
    }, [enabledOnrampProviders, selectedOnrampProvider]);
    const value = useMemo(() => ({
        enabledOnrampProviders,
        onrampEnabled,
        openOnramp,
        selectedOnramp,
        setSelectedOnrampProvider,
        setShowOnramp,
        showOnramp,
    }), [
        onrampEnabled,
        selectedOnramp,
        setSelectedOnrampProvider,
        showOnramp,
        enabledOnrampProviders,
        openOnramp,
        setShowOnramp,
    ]);
    return (jsxRuntimeExports.jsx(OnrampContext.Provider, { value: value, children: children }));
};
const useOnrampContext = () => {
    const context = useContext(OnrampContext);
    if (!context)
        throw new Error('useOnrampContext must be used within a OnrampContextProvider');
    return context;
};

const DotsMenuDropdown = ({ options, setShowMenu, }) => (jsxRuntimeExports.jsx("div", { className: 'dots-menu-dropdown__container', style: { zIndex: tooltipZIndex }, children: options.map((option) => option.hide ? null : (jsxRuntimeExports.jsxs("div", { className: 'dots-menu-dropdown__item', onClick: () => {
            option.callback();
            setShowMenu(false);
        }, children: [option.Icon && jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', children: option.Icon }), jsxRuntimeExports.jsxs(Typography, { className: 'dots-menu-dropdown__item-text', color: option.fontColor ? option.fontColor : 'secondary', weight: option.fontWeight, children: [option.text, " ", option.badge ? jsxRuntimeExports.jsx(Badge, { text: option.badge }) : null] }), option.endSlot && (jsxRuntimeExports.jsx("div", { className: 'dots-menu-dropdown__item__end-slot', children: option.endSlot }))] }, option.text))) }));

var _path$1b;
var _excluded$1m = ["title", "titleId"];
function _extends$1m() { return _extends$1m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1m.apply(null, arguments); }
function _objectWithoutProperties$1m(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1m(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1m(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgThreeDots = function SvgThreeDots(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1m(_ref, _excluded$1m);
  return /*#__PURE__*/React.createElement("svg", _extends$1m({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$1b || (_path$1b = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2a1.333 1.333 0 1 1 0 2.667A1.333 1.333 0 0 1 8 2Zm0 4.667a1.333 1.333 0 1 1 0 2.666 1.333 1.333 0 0 1 0-2.666Zm0 4.666A1.333 1.333 0 1 1 8 14a1.333 1.333 0 0 1 0-2.667Z",
    fill: "currentColor"
  })));
};

const DotsMenu = ({ options, buttonClassName, buttonClassNameWithOpenMenu, direction = 'right', iconOverride, }) => {
    const dotsMenuRef = useRef(null);
    const [showMenu, setShowMenu] = useState(false);
    const handleIconClick = useCallback(() => {
        // Use setTimeout here to prevent React 17 from triggering a click event
        // when the dropdown is rendered.
        setTimeout(() => setShowMenu(true), 0);
    }, [setShowMenu]);
    const handleMenuClose = useCallback(() => {
        setShowMenu(false);
    }, [setShowMenu]);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(IconButton, { ref: dotsMenuRef, onClick: handleIconClick, "data-testid": 'dotsMenu', className: showMenu ? buttonClassNameWithOpenMenu : buttonClassName, children: iconOverride ? (iconOverride) : (jsxRuntimeExports.jsx(Icon, { children: jsxRuntimeExports.jsx(SvgThreeDots, {}) })) }), jsxRuntimeExports.jsx(Dropdown, { isOpen: showMenu, onClickOutside: handleMenuClose, onScroll: handleMenuClose, anchorRef: dotsMenuRef, anchorOrigin: direction === 'right' ? 'bottom-left' : 'top-right', transformOrigin: direction === 'right' ? 'top-left' : 'bottom-right', children: jsxRuntimeExports.jsx(DotsMenuDropdown, { options: options, setShowMenu: setShowMenu }) })] }));
};

const DEFAULT_BREAKPOINT = 12;
const DEFAULT_CUT_END = 4;
const DEFAULT_CUT_START = 4;
const shortenString = (str, start, end) => str.replace(str.substring(start, end), '...');
const shortenEmail = (email, options) => {
    if (!email)
        return '';
    const breakpoint = (options === null || options === void 0 ? void 0 : options.breakpoint) || DEFAULT_BREAKPOINT;
    const cutStart = (options === null || options === void 0 ? void 0 : options.cutStart) || DEFAULT_CUT_START;
    const cutEnd = (options === null || options === void 0 ? void 0 : options.cutEnd) || DEFAULT_CUT_END;
    let [username, domain] = email.split('@');
    const shouldShortenUsername = (username === null || username === void 0 ? void 0 : username.length) > breakpoint;
    if (shouldShortenUsername) {
        username = shortenString(username, cutStart, username.length - cutEnd);
    }
    const shouldShortenDomain = (domain === null || domain === void 0 ? void 0 : domain.length) > breakpoint;
    if (shouldShortenDomain) {
        domain = shortenString(domain, cutStart, domain.length - cutEnd);
    }
    return `${username}@${domain}`;
};

const detectBrowserName = (customUserAgent) => {
    const userAgent = customUserAgent || navigator.userAgent;
    if (userAgent.match(/brave/i)) {
        return 'brave';
    }
    else if (userAgent.match(/edg/i)) {
        return 'edge';
    }
    else if (userAgent.match(/chrome|chromium|crios/i)) {
        return 'chrome';
    }
    else if (userAgent.match(/firefox|fxios/i)) {
        return 'firefox';
    }
    else if (userAgent.match(/safari/i)) {
        return 'safari';
    }
    return undefined;
};

const getPasskeyProviderFromUserAgent = (userAgent) => {
    const isIPhone = userAgent.match(/iPhone/i);
    if (isIPhone) {
        return 'iPhone';
    }
    const isAndroid = userAgent.match(/Android/i);
    if (isAndroid) {
        return 'android';
    }
    const browser = detectBrowserName(userAgent);
    return browser;
};

const getTimeSince = (date) => {
    const { t } = Locale.getInstance();
    const currentTime = Date.now();
    const timeDifference = currentTime - date.getTime();
    // Define time units in milliseconds
    const minute = 60 * 1000;
    const hour = 60 * minute;
    const day = 24 * hour;
    const month = 30 * day;
    const year = 365 * day;
    if (timeDifference >= year) {
        const yearsAgo = Math.floor(timeDifference / year);
        return {
            unit: yearsAgo === 1 ? t('dyn_time_since.year') : t('dyn_time_since.years'),
            value: yearsAgo,
        };
    }
    if (timeDifference >= month) {
        const monthsAgo = Math.floor(timeDifference / month);
        return {
            unit: monthsAgo === 1
                ? t('dyn_time_since.month')
                : t('dyn_time_since.months'),
            value: monthsAgo,
        };
    }
    if (timeDifference >= day) {
        const daysAgo = Math.floor(timeDifference / day);
        return {
            unit: daysAgo === 1 ? t('dyn_time_since.day') : t('dyn_time_since.days'),
            value: daysAgo,
        };
    }
    if (timeDifference >= hour) {
        const hoursAgo = Math.floor(timeDifference / hour);
        return {
            unit: hoursAgo === 1 ? t('dyn_time_since.hour') : t('dyn_time_since.hours'),
            value: hoursAgo,
        };
    }
    if (timeDifference >= minute) {
        const minutesAgo = Math.floor(timeDifference / minute);
        return {
            unit: minutesAgo === 1
                ? t('dyn_time_since.minute')
                : t('dyn_time_since.minutes'),
            value: minutesAgo,
        };
    }
    const secondsAgo = Math.floor(timeDifference / 1000);
    return {
        unit: secondsAgo === 1
            ? t('dyn_time_since.second')
            : t('dyn_time_since.seconds'),
        value: secondsAgo,
    };
};

const mapPasskeyProviderToIcon = {
    android: jsxRuntimeExports.jsx(AndroidIcon, {}),
    brave: jsxRuntimeExports.jsx(BraveIcon, {}),
    chrome: jsxRuntimeExports.jsx(ChromeIcon, {}),
    edge: jsxRuntimeExports.jsx(EdgeIcon, {}),
    firefox: jsxRuntimeExports.jsx(FirefoxIcon, {}),
    iPhone: jsxRuntimeExports.jsx(AppleIcon, {}),
    opera: jsxRuntimeExports.jsx(OperaIcon, {}),
    safari: jsxRuntimeExports.jsx(SafariIcon, {}),
};
const PasskeyCard = ({ passkey }) => {
    var _a;
    const { t } = useTranslation();
    const { setShowAuthFlow } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const { setPasskey, setPasskeyIcon } = usePasskeyContext();
    const menuOptions = [
        {
            Icon: null,
            callback: () => {
                setShowAuthFlow(true);
                setPasskey(passkey);
                setPasskeyIcon(() => { var _a; return (_a = PasskeyProviderIcon()) !== null && _a !== void 0 ? _a : undefined; });
                pushView('rename-passkey');
            },
            text: 'Rename',
        },
    ];
    const [showTooltip, setShowTooltip] = useState(false);
    const { value: timeSinceValue, unit: timeSinceUnit } = getTimeSince(passkey.createdAt);
    const PasskeyProviderIcon = () => {
        if (!passkey.userAgent)
            return null;
        const provider = getPasskeyProviderFromUserAgent(passkey.userAgent);
        if (!provider)
            return null;
        return mapPasskeyProviderToIcon[provider];
    };
    const getPasskeyProviderName = () => {
        if (!passkey.userAgent)
            return null;
        const provider = getPasskeyProviderFromUserAgent(passkey.userAgent);
        if (!provider)
            return null;
        return t(`dyn_manage_passkeys.passkey_providers.${provider}`);
    };
    const handleShowTooltip = () => {
        setShowTooltip(true);
        setTimeout(() => {
            setShowTooltip(false);
        }, 2000);
    };
    return (jsxRuntimeExports.jsxs("div", { className: 'passkey-card', children: [jsxRuntimeExports.jsx("div", { className: 'passkey-card__info', children: jsxRuntimeExports.jsxs("div", { className: 'passkey-card__info__text', children: [jsxRuntimeExports.jsxs(Typography, { "data-testid": 'passkey-alias', variant: 'body_normal', color: 'primary', title: passkey.alias, onClick: handleShowTooltip, children: [jsxRuntimeExports.jsxs("div", { className: 'passkey-card__body', children: [jsxRuntimeExports.jsxs("div", { className: 'passkey-card__left', children: [jsxRuntimeExports.jsx("div", { className: 'passkey-card__info__icon', "data-testid": 'provider-icon', children: jsxRuntimeExports.jsx(PasskeyProviderIcon, {}) }), ((_a = passkey.alias) === null || _a === void 0 ? void 0 : _a.includes('@'))
                                                    ? shortenEmail(passkey.alias, {
                                                        breakpoint: 12,
                                                        cutEnd: 4,
                                                        cutStart: 4,
                                                    })
                                                    : passkey.alias] }), jsxRuntimeExports.jsx(DotsMenu, { options: menuOptions })] }), jsxRuntimeExports.jsx("span", { className: classNames('passkey-card__info__tooltip', {
                                        'passkey-card__info__tooltip--visible': showTooltip,
                                    }), children: passkey.alias })] }), getPasskeyProviderName() && (jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', color: 'secondary', children: [t('dyn_manage_passkeys.passkey_from'), " ", getPasskeyProviderName()] }))] }) }), jsxRuntimeExports.jsx("div", { className: 'passkey-card__date', children: jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', color: 'secondary', copykey: 'dyn_time_since.created', children: [t('dyn_time_since.created'), ' ', `${timeSinceValue} ${timeSinceUnit} ${t('dyn_time_since.ago')}`] }) })] }));
};

const useFetchCurrency = (connector, network) => {
    const fetchChainCurrency = () => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f;
        if (!connector)
            return null;
        const chainId = yield connector.getNetwork();
        const chainInfo = getChainInfoWithOverrides((_a = connector.connectedChain) !== null && _a !== void 0 ? _a : '');
        /* istanbul ignore else */
        if (!chainId) {
            return {
                name: chainInfo === null || chainInfo === void 0 ? void 0 : chainInfo.displayName,
                symbol: chainInfo === null || chainInfo === void 0 ? void 0 : chainInfo.symbol,
            };
        }
        const network = (() => {
            if (connector.connectedChain === 'STARK') {
                return 'starknetNetworks';
            }
            else if (connector.connectedChain === 'ECLIPSE') {
                return 'eclipseNetworks';
            }
            else {
                return 'evmNetworks';
            }
        })();
        const result = (_b = connector[network]) === null || _b === void 0 ? void 0 : _b.find((element) => element.chainId === chainId);
        return {
            name: (_d = (_c = result === null || result === void 0 ? void 0 : result.nativeCurrency) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : chainInfo === null || chainInfo === void 0 ? void 0 : chainInfo.displayName,
            symbol: (_f = (_e = result === null || result === void 0 ? void 0 : result.nativeCurrency) === null || _e === void 0 ? void 0 : _e.symbol) !== null && _f !== void 0 ? _f : chainInfo === null || chainInfo === void 0 ? void 0 : chainInfo.symbol,
        };
    });
    const { data: currency, isLoading } = usePromise(fetchChainCurrency, {
        deps: [network],
        initialData: null,
    });
    return { currency, isLoading };
};

/**
 * Runs an effect function only once during component initialization.
 *
 * @param {Function} effect - The effect function to be executed.
 * @returns {void}
 *
 * @example
 * function ExampleComponent() {
 *   useEffectOnce(() => {
 *     console.log('Effect executed once');
 *   });
 *
 *   return <div>Example Component</div>;
 * }
 */
const useEffectOnce = (effect) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(effect, []);
};

var _g$b;
var _excluded$1l = ["title", "titleId"];
function _extends$1l() { return _extends$1l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1l.apply(null, arguments); }
function _objectWithoutProperties$1l(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1l(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1l(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSend = function SvgSend(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1l(_ref, _excluded$1l);
  return /*#__PURE__*/React.createElement("svg", _extends$1l({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$b || (_g$b = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#send_svg__clip0_6894_96)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.846 9.3.03-.01 14.64-5.728c.199-.078.399-.156.567-.205.156-.046.465-.126.794-.02.374.123.664.413.786.787.107.33.027.638-.019.794-.049.168-.127.368-.205.567L14.702 20.15c-.08.204-.16.408-.239.568-.073.147-.226.436-.537.614a1.277 1.277 0 0 1-1.136.072c-.323-.137-.496-.405-.58-.542-.09-.149-.184-.342-.278-.535l-2.693-5.52-5.546-2.724-.027-.014c-.193-.094-.385-.189-.533-.28-.137-.082-.403-.256-.54-.578a1.277 1.277 0 0 1 .074-1.136c.178-.31.466-.463.612-.536.16-.079.363-.158.567-.238Zm.972 1.425 4.88 2.396 2.912-2.913a.848.848 0 0 1 1.2-.017.848.848 0 0 1-.017 1.2l-2.898 2.898 2.384 4.888 5.433-13.888-13.894 5.436Z",
    fill: "currentColor",
    fillOpacity: 0.4
  }))));
};

const usingSessionKey = (walletConnector) => isSessionKeyCompatibleWalletConnector(walletConnector) ||
    (isAccountAbstractionConnector(walletConnector) &&
        isSessionKeyCompatibleWalletConnector(walletConnector.getEOAConnector()));

const getGasFiatValue = (currentToken, transaction, nativePrice) => {
    if (!(currentToken === null || currentToken === void 0 ? void 0 : currentToken.price) || !transaction.fee.gas)
        return;
    let currentNativePrice = currentToken.price;
    if (nativePrice) {
        currentNativePrice = nativePrice;
    }
    return (Number(transaction.format(transaction.fee.gas)) * currentNativePrice).toFixed(2);
};
const getTotalFiatCost = (currentToken, transaction, nativePrice, transactionValue) => {
    const gasValue = getGasFiatValue(currentToken, transaction, nativePrice);
    if (!gasValue || !(currentToken === null || currentToken === void 0 ? void 0 : currentToken.price))
        return;
    const totalFiatCost = Number(gasValue) + Number(transactionValue) * currentToken.price;
    return totalFiatCost.toFixed(2);
};

const isProviderEnabled = (providers, provider) => providers.some((providerItem) => {
    const providerEnabled = providerItem.provider === provider && Boolean(providerItem.enabledAt);
    if (providerItem.provider === ProviderEnum.MagicLink) {
        return providerEnabled && Boolean(providerItem.providerProjectId);
    }
    return providerEnabled;
});

const isTurnkeyEnabled = (projectSettings) => { var _a; return isProviderEnabled((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers) !== null && _a !== void 0 ? _a : [], ProviderEnum.Turnkey); };

const getEnabledEmbeddedWalletsAuthenticators = (supportedSecurityMethods) => {
    if (!supportedSecurityMethods ||
        !Object.keys(supportedSecurityMethods).length) {
        return {};
    }
    const enabledSecurityMethods = {};
    Object.keys(supportedSecurityMethods)
        .filter((key) => { var _a; return (_a = supportedSecurityMethods[key]) === null || _a === void 0 ? void 0 : _a.isEnabled; })
        .forEach((key) => (enabledSecurityMethods[key] =
        supportedSecurityMethods[key]));
    return enabledSecurityMethods;
};

const hasEmbeddedWallet = (user, walletNameFilter) => {
    var _a;
    return Boolean(user &&
        ((_a = user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.some(({ walletProvider, walletName }) => walletProvider === WalletProviderEnum.EmbeddedWallet &&
            (!walletNameFilter || (walletName === null || walletName === void 0 ? void 0 : walletName.startsWith(walletNameFilter))))));
};

const sessionExpirationUnit = {
    days: 86400,
    hours: 3600,
    minutes: 60,
};
/**
 * Convert the session expiration to seconds
 * @param {Duration} duration
 * @returns {number}
 */
const getEmbeddedWalletSessionExpiration = (duration) => {
    if (!duration) {
        return 0;
    }
    const { unit, amount } = duration;
    const sessionExpiration = amount || 0;
    const decodedSessionExpirationUnit = sessionExpirationUnit[unit] || 0;
    return sessionExpiration * decodedSessionExpirationUnit;
};

const iframeContainerId$1 = 'dyn-passkey-recovery-id';
const iframeElementId$1 = 'dyn-passkey-recovery-element-id';

const findEmbeddedWalletFromVerifiedCredentials = (user, chains) => {
    var _a;
    const verifiedCredentials = (_a = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.filter(({ walletProvider }) => walletProvider === WalletProviderEnum.EmbeddedWallet);
    if ((verifiedCredentials === null || verifiedCredentials === void 0 ? void 0 : verifiedCredentials.length) && (chains === null || chains === void 0 ? void 0 : chains.length)) {
        return verifiedCredentials.find(({ chain }) => chain && chains.includes(VerifiedCredentialNameToChainEnum[chain]));
    }
    return verifiedCredentials === null || verifiedCredentials === void 0 ? void 0 : verifiedCredentials.shift();
};

const removeElementById = (elementId) => {
    let elementToRemove;
    if (typeof window !== 'undefined') {
        elementToRemove = window.document.getElementById(elementId);
        const parentElement = elementToRemove === null || elementToRemove === void 0 ? void 0 : elementToRemove.parentElement;
        if (!elementToRemove || !parentElement) {
            return;
        }
        parentElement.removeChild(elementToRemove);
    }
};

const initEmbeddedWalletSession = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ authenticatorType, iframeContainer, iframeElementId, environmentId, user, wallet, sessionExpiration, }) {
    var _b;
    if (!user) {
        throw new DynamicError(USER_NOT_LOGGED_IN);
    }
    if (!(wallet === null || wallet === void 0 ? void 0 : wallet.connector) ||
        !(wallet === null || wallet === void 0 ? void 0 : wallet.id) ||
        !isPasskeyWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector)) {
        throw new DynamicError('Connector is missing. Please make sure you added EthereumWalletConnectors and/or SolanaWalletConnectors to DynamicProvider settings');
    }
    const turnkeyRecoveryHandler = (_b = wallet.connector) === null || _b === void 0 ? void 0 : _b.getAuthenticatorHandler();
    if (authenticatorType === 'passkey' &&
        turnkeyRecoveryHandler.isSessionActive()) {
        return addNewPasskeyAuthenticator({
            environmentId,
            user,
            wallet,
        });
    }
    const publicKey = yield turnkeyRecoveryHandler.initRecovery(authenticatorType, iframeContainer, iframeElementId, sessionExpiration);
    if (!publicKey) {
        throw new DynamicError('Something went wrong');
    }
    const response = yield initEmbeddedWalletSession$1({
        authenticatorType,
        environmentId,
        publicKey,
        walletId: wallet.id,
    });
    turnkeyRecoveryHandler.recoveryUserId =
        authenticatorType === 'passkey'
            ? response.turnkeyRecoveryUserId
            : response.turnkeyUserId;
    return;
});
const passkeyRecoveryBundleValidation = (_c) => __awaiter$1(void 0, [_c], void 0, function* ({ user, bundleInput, wallet, }) {
    var _d, _e, _f, _g;
    if (!bundleInput) {
        throw new DynamicError('Code must be informed');
    }
    if (!(wallet === null || wallet === void 0 ? void 0 : wallet.connector) ||
        !(wallet === null || wallet === void 0 ? void 0 : wallet.id) ||
        !isPasskeyWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector)) {
        throw new DynamicError('Connector is missing. Please make sure you added EthereumWalletConnectors and/or SolanaWalletConnectors to DynamicProvider settings');
    }
    if (!user) {
        throw new DynamicError(USER_NOT_LOGGED_IN);
    }
    const organizationId = (_f = (_e = (_d = user.verifiedCredentials) === null || _d === void 0 ? void 0 : _d.find(({ walletName }) => walletName === null || walletName === void 0 ? void 0 : walletName.startsWith('turnkey'))) === null || _e === void 0 ? void 0 : _e.walletProperties) === null || _f === void 0 ? void 0 : _f.turnkeySubOrganizationId;
    const turnkeyRecoveryHandler = (_g = wallet.connector) === null || _g === void 0 ? void 0 : _g.getAuthenticatorHandler();
    yield turnkeyRecoveryHandler.verifyRecoveryCode(bundleInput, organizationId);
    const sessionSettings = {
        createdAt: new Date().getTime(),
        emailCode: bundleInput,
        userId: turnkeyRecoveryHandler.recoveryUserId,
    };
    StorageService.setItem(EMBEDDED_WALLET_SESSION_SETTINGS, sessionSettings);
});
const resentRecoveryEmail = (_h) => __awaiter$1(void 0, [_h], void 0, function* ({ authenticatorType, user, environmentId, wallet, }) {
    var _j;
    if (!user) {
        throw new DynamicError(USER_NOT_LOGGED_IN);
    }
    if (!(wallet === null || wallet === void 0 ? void 0 : wallet.connector) ||
        !(wallet === null || wallet === void 0 ? void 0 : wallet.id) ||
        !isPasskeyWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector)) {
        throw new DynamicError('Connector is missing. Please make sure you added EthereumWalletConnectors and/or SolanaWalletConnectors to DynamicProvider settings');
    }
    const publicKey = (_j = wallet.connector) === null || _j === void 0 ? void 0 : _j.getAuthenticatorHandler().publicKey;
    if (!publicKey) {
        throw new DynamicError('Could not proceed with your request. Please restart the process.');
    }
    return initEmbeddedWalletSession$1({
        authenticatorType,
        environmentId,
        publicKey,
        walletId: wallet === null || wallet === void 0 ? void 0 : wallet.id,
    });
});
const completePasskeyRecovery = (_k) => __awaiter$1(void 0, [_k], void 0, function* ({ user, environmentId, wallet, }) {
    const { connector, user: updatedUser } = yield recoverTurnkeyWallet({
        addPasskeyAuthenticator: false,
        environmentId,
        user,
        wallet,
    });
    // clear iframeStamper and its reference
    connector.getAuthenticatorHandler().clear();
    // deletes iframe container after usage
    removeElementById(iframeElementId$1);
    return updatedUser;
});
const addNewPasskeyAuthenticator = (_l) => __awaiter$1(void 0, [_l], void 0, function* ({ user, environmentId, wallet, }) {
    const { user: updatedUser } = yield recoverTurnkeyWallet({
        addPasskeyAuthenticator: true,
        environmentId,
        user,
        wallet,
    });
    return updatedUser;
});
const recoverTurnkeyWallet = (_m) => __awaiter$1(void 0, [_m], void 0, function* ({ wallet, user, environmentId, addPasskeyAuthenticator, }) {
    var _o, _p, _q;
    if (!user) {
        throw new DynamicError(USER_NOT_LOGGED_IN);
    }
    if (!wallet ||
        !wallet.connector ||
        !wallet.id ||
        !isPasskeyWalletConnector(wallet.connector)) {
        throw new DynamicError('Connector is missing. Please make sure you added EthereumWalletConnectors and/or SolanaWalletConnectors to DynamicProvider settings');
    }
    const connector = wallet.connector;
    connector.setEmail(user.email);
    const turnkeySubOrganizationId = (_q = (_p = (_o = user.verifiedCredentials) === null || _o === void 0 ? void 0 : _o.find(({ walletName }) => walletName === null || walletName === void 0 ? void 0 : walletName.startsWith('turnkey'))) === null || _p === void 0 ? void 0 : _p.walletProperties) === null || _q === void 0 ? void 0 : _q.turnkeySubOrganizationId;
    if (!turnkeySubOrganizationId) {
        throw new DynamicError('The authentication token is invalid - turnkeySubOrganizationId is missing');
    }
    const turnkeyRecoveryHandler = wallet.connector.getAuthenticatorHandler();
    const { attestation, challenge } = yield connector.getWebAuthnAttestation();
    if (addPasskeyAuthenticator) {
        yield turnkeyRecoveryHandler.addPasskeyAuthenticator({
            attestation,
            challenge,
            turnkeySubOrganizationId,
        });
    }
    else {
        yield turnkeyRecoveryHandler.completeRecovery({
            attestation,
            challenge,
            turnkeySubOrganizationId,
        });
    }
    const updatedUser = yield completePasskeyRecovery$1({
        attestation: attestation,
        challenge,
        environmentId,
        walletId: wallet.id,
    });
    if (!updatedUser) {
        throw new DynamicError('No user returned from passkey recovery');
    }
    const chain = connector.connectedChain;
    const embeddedWalletVerifiedCredential = findEmbeddedWalletFromVerifiedCredentials(updatedUser, [chain]);
    if (!embeddedWalletVerifiedCredential) {
        throw new DynamicError('EmbeddedWalletVerifiedCredential not found');
    }
    connector.setVerifiedCredentials(updatedUser.verifiedCredentials);
    return {
        connector,
        user: updatedUser,
    };
});
const canRestoreEmbeddedWalletSession = (sessionExpirationTime) => {
    if (!(sessionExpirationTime === null || sessionExpirationTime === void 0 ? void 0 : sessionExpirationTime.amount)) {
        return false;
    }
    const sessionSettings = StorageService.getItem(EMBEDDED_WALLET_SESSION_SETTINGS);
    if (!sessionSettings) {
        return false;
    }
    const sessionExpiration = sessionExpirationTime.amount *
        (sessionExpirationTime.unit === 'minutes' ? 60 : 3600);
    const recoveryExpirationSeconds = (sessionSettings === null || sessionSettings === void 0 ? void 0 : sessionSettings.createdAt) + sessionExpiration * 1000;
    const expirationTime = new Date(recoveryExpirationSeconds);
    if (new Date() >= expirationTime) {
        StorageService.removeItem(EMBEDDED_WALLET_SESSION_SETTINGS);
        return false;
    }
    return true;
};
const restoreEmbeddedWalletSession = (_r) => __awaiter$1(void 0, [_r], void 0, function* ({ user, iframeContainer, iframeElementId, wallet, sessionExpiration, }) {
    var _s, _t, _u, _v;
    if (!user) {
        throw new DynamicError(USER_NOT_LOGGED_IN);
    }
    if (!(wallet === null || wallet === void 0 ? void 0 : wallet.connector) ||
        !(wallet === null || wallet === void 0 ? void 0 : wallet.id) ||
        !isPasskeyWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector)) {
        throw new DynamicError('Connector is missing. Please make sure you added EthereumWalletConnectors and/or SolanaWalletConnectors to DynamicProvider settings');
    }
    const sessionSettings = StorageService.getItem(EMBEDDED_WALLET_SESSION_SETTINGS);
    const turnkeyRecoveryHandler = (_s = wallet.connector) === null || _s === void 0 ? void 0 : _s.getAuthenticatorHandler();
    if (!sessionSettings || Boolean(turnkeyRecoveryHandler.recoveryUserId)) {
        return false;
    }
    const publicKey = yield turnkeyRecoveryHandler.initRecovery('email', iframeContainer, iframeElementId, sessionExpiration);
    if (!publicKey) {
        throw new DynamicError('Could not open embedded wallet connection communication');
    }
    turnkeyRecoveryHandler.recoveryUserId = sessionSettings.userId;
    const organizationId = (_v = (_u = (_t = user.verifiedCredentials) === null || _t === void 0 ? void 0 : _t.find(({ walletName }) => walletName === null || walletName === void 0 ? void 0 : walletName.startsWith('turnkey'))) === null || _u === void 0 ? void 0 : _u.walletProperties) === null || _v === void 0 ? void 0 : _v.turnkeySubOrganizationId;
    yield turnkeyRecoveryHandler.verifyRecoveryCode(sessionSettings.emailCode, organizationId);
    return true;
});
const addEmailRecovery = (_w) => __awaiter$1(void 0, [_w], void 0, function* ({ user, environmentId, wallet, }) {
    var _x, _y;
    if (!(user === null || user === void 0 ? void 0 : user.email)) {
        throw new DynamicError(USER_NOT_LOGGED_IN);
    }
    if (!(wallet === null || wallet === void 0 ? void 0 : wallet.connector) ||
        !(wallet === null || wallet === void 0 ? void 0 : wallet.id) ||
        !isPasskeyWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector) ||
        !isEmailWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector)) {
        throw new DynamicError('Connector is missing. Please make sure you added EthereumWalletConnectors and/or SolanaWalletConnectors to DynamicProvider settings');
    }
    const { turnkeySubOrganizationId, turnkeyUserId } = (_y = (_x = user.verifiedCredentials) === null || _x === void 0 ? void 0 : _x.find(({ walletName }) => walletName === null || walletName === void 0 ? void 0 : walletName.startsWith('turnkey'))) === null || _y === void 0 ? void 0 : _y.walletProperties;
    if (!turnkeySubOrganizationId || !turnkeyUserId) {
        throw new DynamicError('The authentication token is invalid - turnkeySubOrganizationId or turnkeyUserID is missing');
    }
    const turnkeyRecoveryHandler = wallet.connector.getAuthenticatorHandler();
    const { signedRequest } = (yield turnkeyRecoveryHandler.addEmailRecovery({
        email: user.email,
        organizationId: turnkeySubOrganizationId,
        turnkeyUserId,
    }));
    yield updatePasskeyRecoveryEmail({
        environmentId,
        updateRecoveryEmailRequest: { turnkeySignedRequest: signedRequest },
    });
    wallet.connector.setEmail(user.email);
    return refreshUserJwt({ environmentId });
});

// This hook needs to be async that's why it's not using useMutation
const useInitEmbeddedWalletAuthMethod = () => {
    const { primaryWallet, environmentId, user, projectSettings, setShowAuthFlow, } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const { getEOAWallet } = useSmartWallets();
    const initAuthMethod = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ authenticatorType, iframeContainer, currentAction, }) {
        var _b, _c, _d, _e, _f;
        setIsLoading(true);
        const wallet = (_b = (primaryWallet && getEOAWallet(primaryWallet))) !== null && _b !== void 0 ? _b : primaryWallet;
        const sessionExpiration = ((_d = (_c = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _c === void 0 ? void 0 : _c.sessionKeyDuration) === null || _d === void 0 ? void 0 : _d.amount) || 0;
        const sessionExpirationUnit = ((_f = (_e = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _e === void 0 ? void 0 : _e.sessionKeyDuration) === null || _f === void 0 ? void 0 : _f.unit) ===
            'minutes'
            ? 60
            : 3600;
        const showEmailBundle = authenticatorType === 'email' ||
            !(wallet === null || wallet === void 0 ? void 0 : wallet.connector)
                .getAuthenticatorHandler()
                .isSessionActive();
        try {
            yield initEmbeddedWalletSession({
                authenticatorType,
                environmentId,
                iframeContainer,
                iframeElementId: iframeElementId$1,
                sessionExpiration: sessionExpiration * sessionExpirationUnit || undefined,
                user,
                wallet: wallet,
            });
            if (showEmailBundle) {
                pushView('passkey-recovery-bundle', {
                    authenticatorType,
                    currentAction,
                });
                setShowAuthFlow(true, {
                    ignoreIfIsEmbeddedWidget: false,
                    performMultiWalletChecks: false,
                });
            }
            else {
                setShowAuthFlow(false);
            }
        }
        catch (err) {
            setError(err);
            logger$1.error('Failed to create embedded wallet session', err);
            dynamicEvents.emit('passkeyRecoveryFailed', err);
        }
        finally {
            setIsLoading(false);
        }
    });
    return {
        error,
        initAuthMethod,
        isLoading,
    };
};

// Hook exposed to customers and used internally to trigger passkey recovery
const usePasskeyRecovery = () => {
    var _a, _b, _c;
    const { environmentId, primaryWallet, projectSettings, setShowAuthFlow, user, } = useInternalDynamicContext();
    const { createRootElement } = useElementById();
    const iframeContainerRef = createRootElement(iframeContainerId$1);
    const { isTurnkeyWalletWithoutAuthenticator, hasRecoveryEmail } = useIsTurnkeyWallet();
    const { initAuthMethod } = useInitEmbeddedWalletAuthMethod();
    const { setDisplayedDestination: setEmailForVerification, setVerificationUUID, } = useVerification();
    const { getEOAWallet } = useSmartWallets();
    const { pushView } = useViewContext();
    const wallet = (_a = (primaryWallet && getEOAWallet(primaryWallet))) !== null && _a !== void 0 ? _a : primaryWallet;
    const isSessionRestored = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        var _d, _e;
        if (!((_d = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _d === void 0 ? void 0 : _d.sessionKeyDuration) ||
            !canRestoreEmbeddedWalletSession((_e = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _e === void 0 ? void 0 : _e.sessionKeyDuration)) {
            return false;
        }
        const sessionExpiration = getEmbeddedWalletSessionExpiration(projectSettings.sdk.embeddedWallets.sessionKeyDuration);
        try {
            return yield restoreEmbeddedWalletSession({
                iframeContainer: iframeContainerRef.current,
                iframeElementId: iframeElementId$1,
                sessionExpiration,
                user,
                wallet: primaryWallet,
            });
        }
        catch (err) {
            logger$1.error('Failed to restore embedded wallet', err);
        }
        return false;
    }), [
        user,
        iframeContainerRef,
        primaryWallet,
        (_c = (_b = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _b === void 0 ? void 0 : _b.embeddedWallets) === null || _c === void 0 ? void 0 : _c.sessionKeyDuration,
    ]);
    const shouldInitRecovery = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!wallet || !isPasskeyWalletConnector(wallet.connector)) {
            return false;
        }
        const turnkeyRecoveryHandler = wallet.connector.getAuthenticatorHandler();
        // user has passkey authenticator set up OR
        // email auth - session is still up, so no need to recover
        if (!isTurnkeyWalletWithoutAuthenticator ||
            turnkeyRecoveryHandler.isSessionActive() ||
            (yield isSessionRestored())) {
            return false;
        }
        return true;
    }), [wallet, isTurnkeyWalletWithoutAuthenticator, isSessionRestored]);
    const initPasskeyRecoveryProcess = useCallback((authenticatorType, currentAction) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _f;
        const validateRecoveryRequest = () => {
            if (!user) {
                throw new Error(USER_NOT_LOGGED_IN);
            }
            if (!isTurnkeyEnabled(projectSettings)) {
                throw new Error('Dynamic embedded wallet is not enabled. Go to the dashboard and make sure to have both Dynamic embedded wallet and at least one EVM network enabled. Also, check if EthereumWalletConnectors is in the  DynamicContextProvider > settings > walletConnectors.');
            }
            if (!hasEmbeddedWallet(user)) {
                throw new Error('Dynamic embedded wallet not found');
            }
            if (wallet && !isPasskeyWalletConnector(wallet.connector)) {
                throw new Error('Dynamic embedded wallet not found.');
            }
        };
        validateRecoveryRequest();
        const turnkeyRecoveryHandler = (wallet === null || wallet === void 0 ? void 0 : wallet.connector).getAuthenticatorHandler();
        // email auth - session is still up, so create passkey authenticator usign the same session
        if (authenticatorType === 'passkey' &&
            turnkeyRecoveryHandler.isSessionActive()) {
            yield addNewPasskeyAuthenticator({
                environmentId,
                user,
                wallet: wallet,
            });
            setShowAuthFlow(false);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return wallet;
        }
        const supportedAuthenticators = getEnabledEmbeddedWalletsAuthenticators((_f = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _f === void 0 ? void 0 : _f.supportedSecurityMethods);
        const supportedAuthenticatorMethods = supportedAuthenticators
            ? Object.keys(supportedAuthenticators)
            : [];
        if (!hasRecoveryEmail) {
            pushView('passkey-recovery-add-email', { shouldInitRecovery: true });
            setShowAuthFlow(true, {
                ignoreIfIsEmbeddedWidget: false,
                performMultiWalletChecks: false,
            });
        }
        else if (!authenticatorType &&
            supportedAuthenticatorMethods.length > 1) {
            pushView('embedded-wallet-auth-choice', { currentAction });
            setShowAuthFlow(true, {
                ignoreIfIsEmbeddedWidget: false,
                performMultiWalletChecks: false,
            });
        }
        else {
            const [authType] = supportedAuthenticatorMethods;
            // since we're forcing the authenticator type = 'email' during transactions when no passkey is configured,
            // we need to make sure it's supported.
            // Otherwise, we'll use the first supported authenticator type from the list
            if (authenticatorType &&
                !supportedAuthenticatorMethods.includes(authenticatorType)) {
                authenticatorType = authType;
            }
            yield initAuthMethod({
                authenticatorType: authenticatorType || authType,
                currentAction,
                iframeContainer: iframeContainerRef.current,
            });
        }
        return new Promise((resolve, reject) => {
            dynamicEvents.once('passkeyRecoveryCompleted', (wallet) => resolve(wallet));
            dynamicEvents.once('passkeyRecoveryFailed', (error) => reject(error));
        });
    }), [
        wallet,
        projectSettings,
        hasRecoveryEmail,
        environmentId,
        user,
        setShowAuthFlow,
        pushView,
        initAuthMethod,
        iframeContainerRef,
    ]);
    const addRecoveryEmail = (emailInput) => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            let updatedUser = user;
            // TODO - This seems wrong what if the user has a different email.
            // As well it does not verify the the email is verified
            if (!(user === null || user === void 0 ? void 0 : user.email)) {
                updatedUser = yield updateUserProfile(emailInput);
            }
            yield addEmailRecovery({
                environmentId,
                user: updatedUser,
                wallet: primaryWallet,
            });
            dynamicEvents.emit('embeddedWalletRecoveryEmailCompleted', '');
        }
        catch (err) {
            logger$1.error('Failed to add recovery email', err);
            dynamicEvents.emit('embeddedWalletRecoveryEmailFailed', err);
        }
    });
    const updateUserProfile = (emailInput) => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            const { nextView, emailVerification, userProfile } = yield updateUserProfileFields(environmentId, {
                email: emailInput,
            });
            if (nextView === NextViewEnum.Done) {
                return userProfile;
            }
            pushView('verify-email', { isEmailRecoveryFlow: true });
            setEmailForVerification(emailInput);
            setVerificationUUID(emailVerification === null || emailVerification === void 0 ? void 0 : emailVerification.verificationUUID);
            return new Promise((resolve, reject) => {
                // TODO - This is not the latest user, it is the not verified user
                dynamicEvents.once('emailVerificationResult', (wasSuccessful) => {
                    if (wasSuccessful) {
                        resolve(userProfile);
                    }
                    reject('Failed to verify email');
                });
            });
        }
        catch (err) {
            logger$1.error('Failed to update user email', err);
            throw err;
        }
    });
    return {
        addRecoveryEmail,
        initPasskeyRecoveryProcess,
        shouldInitRecovery,
    };
};

const useResizeObserver = (ref, callback) => {
    const [rect, setRect] = useState();
    const onResize = useCallback((entries) => {
        if (!Array.isArray(entries)) {
            return;
        }
        const [entry] = entries;
        setRect(entry.contentRect);
    }, [callback, setRect]);
    useLayoutEffect(() => {
        if (!ref.current) {
            return;
        }
        let observer = new ResizeObserver(onResize);
        observer.observe(ref.current);
        return () => {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
            observer = null;
        };
    }, [ref]);
    return [rect];
};

const VerticalDrawerTransition = (_a) => {
    var { style, children, className } = _a, props = __rest(_a, ["style", "children", "className"]);
    const containerRef = useRef(null);
    const childRef = useRef(null);
    const [childEntry] = useResizeObserver(childRef);
    const containerChildHeight = useMemo(() => childEntry === null || childEntry === void 0 ? void 0 : childEntry.height, [childEntry]);
    const { mount, stage, currentDuration } = useTransition(Object.assign({ animateOnMount: false }, props));
    const maxHeight = useMemo(() => {
        if (!mount || stage === 'EXITING' || stage === 'UNMOUNT') {
            return 0;
        }
        return containerChildHeight;
    }, [stage, containerChildHeight, mount]);
    return (jsxRuntimeExports.jsx("div", { ref: containerRef, className: classNames(className, 'vertical-drawer-animation'), style: Object.assign(Object.assign({}, style), { maxHeight, transitionDuration: `${currentDuration}ms` }), children: jsxRuntimeExports.jsx("div", { ref: childRef, children: mount && children }) }));
};

const TextButton = (_a) => {
    var { className = '' } = _a, props = __rest(_a, ["className"]);
    return (jsxRuntimeExports.jsx("button", Object.assign({ className: classNames('text-button', className) }, props)));
};

const SupportLinks = ({ supportEmail, supportUrls, }) => {
    const { t } = useTranslation();
    if (!supportEmail && !supportUrls) {
        return null;
    }
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [supportEmail && (jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', color: 'secondary', copykey: 'dyn_need_help_section.contact_support', children: [t('dyn_need_help_section.contact_support'), ":", ' ', jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'link', as: 'span', children: jsxRuntimeExports.jsx("a", { href: `mailto:${supportEmail}`, children: supportEmail }) })] })), supportUrls &&
                Object.entries(supportUrls).map(([key, url]) => {
                    const platformName = key.charAt(0).toUpperCase() + key.slice(1);
                    return (jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', color: 'secondary', copykey: 'dyn_need_help_section.visit_platform', children: [t('dyn_need_help_section.visit_platform', {
                                platform: platformName,
                            }), ":", ' ', jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'link', as: 'span', children: jsxRuntimeExports.jsx("a", { href: url, rel: 'noreferrer', target: '_blank', children: url }) })] }, key));
                })] }));
};

const NeedHelpSection = ({ isRecoveryFlow = false, isExport = false, }) => {
    var _a, _b, _c, _d, _e;
    const { projectSettings, user } = useInternalDynamicContext();
    const { t } = useTranslation();
    const { pushView } = useViewContext();
    const { initPasskeyRecoveryProcess } = usePasskeyRecovery();
    const supportEmail = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.general) === null || _a === void 0 ? void 0 : _a.supportEmail;
    const supportUrls = (_b = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.general) === null || _b === void 0 ? void 0 : _b.supportUrls;
    // don't show passkey recovery helper on passkey creation flow views
    const isRecoveryEnabled = !isRecoveryFlow &&
        ((_c = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers) === null || _c === void 0 ? void 0 : _c.find((p) => p.provider === ProviderEnum.Turnkey && p.enabledAt)) &&
        Boolean((_e = (_d = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _d === void 0 ? void 0 : _d.embeddedWallets) === null || _e === void 0 ? void 0 : _e.emailRecoveryEnabled);
    const v2Wallet = user === null || user === void 0 ? void 0 : user.verifiedCredentials.some((credential) => { var _a; return ((_a = credential.walletProperties) === null || _a === void 0 ? void 0 : _a.version) === EmbeddedWalletVersionEnum.V2; });
    // revert to v2 wallet view (no passkey recovery) if passkey recovery is not enabled
    const v1Wallet = !v2Wallet && isRecoveryEnabled;
    const hasContactInfo = Boolean(supportEmail || Object.keys(supportUrls || {}).length > 0);
    const getSupportHelpSession = () => {
        // For v1 wallets, only show the "Go here for support" link that triggers recovery
        if (v1Wallet) {
            return (jsxRuntimeExports.jsx(TextButton, { copykey: 'dyn_need_help_section.help_button', className: classNames('need-help-section__helper-link'), onClick: () => initPasskeyRecoveryProcess(undefined, {
                    settings: isExport
                        ? {
                            goBack: () => {
                                pushView('embedded-reveal-view');
                            },
                        }
                        : undefined,
                    type: 'helpSession',
                }), children: t('dyn_need_help_section.help_button') }));
        }
        // V2 Wallet or V1 Wallet without recovery
        if (hasContactInfo) {
            return (jsxRuntimeExports.jsx(SupportLinks, { supportEmail: supportEmail, supportUrls: supportUrls }));
        }
        return null;
    };
    // if there is no support info, don't render the component
    return getSupportHelpSession() ? (jsxRuntimeExports.jsxs("div", { className: 'need-help-section', children: [jsxRuntimeExports.jsx(Typography, { color: 'secondary', variant: 'body_small', copykey: 'dyn_need_help_section.info', weight: 'medium', children: t('dyn_need_help_section.info') }), getSupportHelpSession()] })) : null;
};

var _g$a, _defs$9;
var _excluded$1k = ["title", "titleId"];
function _extends$1k() { return _extends$1k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1k.apply(null, arguments); }
function _objectWithoutProperties$1k(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1k(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1k(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgDynamicLogo = function SvgDynamicLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1k(_ref, _excluded$1k);
  return /*#__PURE__*/React.createElement("svg", _extends$1k({
    fill: "none",
    viewBox: "0 0 114 21",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$a || (_g$a = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dynamic-logo_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.053 2.002c-.43.4-.85.793-1.273 1.184-1.959 1.818-3.918 3.638-5.879 5.453-.45.417-.915.817-1.48 1.061C.75 9.99.365 9.81.15 9.085-.153 8.072.009 7.128.59 6.258 1.087 5.517 1.71 4.9 2.354 4.3A178.857 178.857 0 0 1 5.45 1.47c.457-.408.957-.78 1.567-.905 1.828-.368 2.994 1.384 3.038 1.436l-.002.001zM1.259 11.254c1.112-.32 1.946-1.026 2.758-1.768 2.59-2.363 5.176-4.728 7.777-7.078A16.823 16.823 0 0 1 13.609.96C14.42.408 15.303.33 16.173.855c.314.189.623.409.878.672a106.565 106.565 0 0 1 5.28 5.866c.298.358.542.774.744 1.196.375.785.279 1.561-.178 2.293-.409.655-.956 1.192-1.52 1.702a699.92 699.92 0 0 1-6.653 5.96c-.6.53-1.26 1.004-1.94 1.422-1.282.791-2.568.693-3.737-.244A16.245 16.245 0 0 1 7.14 17.92c-1.883-2.087-3.73-4.203-5.592-6.31-.094-.106-.18-.22-.29-.358v.002zM39.574.915h2.808V16.14h-2.808v-1.284c-.827 1.06-2.003 1.587-3.526 1.587-1.522 0-2.717-.555-3.755-1.664s-1.556-2.469-1.556-4.078c0-1.609.518-2.968 1.556-4.077s2.288-1.665 3.755-1.665 2.7.53 3.526 1.587V.913v.002zm-5.17 11.996c.573.572 1.294.859 2.166.859s1.589-.287 2.155-.86c.566-.572.849-1.309.849-2.207 0-.898-.283-1.635-.85-2.207-.565-.572-1.283-.859-2.154-.859s-1.593.287-2.166.86c-.574.571-.86 1.308-.86 2.206 0 .898.286 1.635.86 2.208zM51.766 5.264h3.004l-3.968 10.894c-.566 1.554-1.315 2.682-2.251 3.385-.934.704-2.098 1.02-3.489.947v-2.61c.755.015 1.352-.144 1.796-.477.442-.334.796-.87 1.057-1.61L43.453 5.268h3.069l2.837 7.308 2.409-7.308-.002-.002zM61.908 4.959c1.19 0 2.174.398 2.949 1.196.777.798 1.163 1.9 1.163 3.305v6.678h-2.808v-6.33c0-.723-.196-1.279-.588-1.664-.392-.383-.914-.576-1.567-.576-.725 0-1.306.224-1.74.674s-.654 1.124-.654 2.022v5.872h-2.808V5.261h2.808v1.218c.683-1.014 1.763-1.522 3.243-1.522l.002.002zM76.243 5.264h2.808V16.14h-2.808v-1.283c-.842 1.06-2.024 1.587-3.548 1.587s-2.695-.555-3.733-1.665-1.556-2.468-1.556-4.077c0-1.61.518-2.968 1.556-4.078C70 5.514 71.242 4.96 72.695 4.96c1.524 0 2.706.53 3.548 1.587V5.262v.002zm-5.182 7.646c.566.572 1.284.86 2.156.86s1.592-.288 2.166-.86c.573-.572.86-1.309.86-2.207 0-.898-.287-1.635-.86-2.207-.574-.572-1.295-.86-2.166-.86s-1.59.288-2.156.86c-.566.572-.849 1.309-.849 2.207 0 .898.283 1.635.85 2.207zM92.864 4.959c1.249 0 2.246.406 2.993 1.218.748.813 1.121 1.9 1.121 3.263v6.7H94.17V9.637c0-.652-.16-1.16-.48-1.523s-.769-.544-1.35-.544c-.638 0-1.135.211-1.49.631-.356.42-.533 1.03-.533 1.828v6.113h-2.808V9.638c0-.651-.16-1.159-.48-1.522-.32-.363-.77-.544-1.35-.544-.623 0-1.121.21-1.491.631-.37.42-.555 1.03-.555 1.828v6.113h-2.808V5.269h2.808v1.153c.653-.972 1.661-1.457 3.027-1.457 1.365 0 2.321.522 2.96 1.566.724-1.044 1.807-1.566 3.242-1.566l.002-.006zM100.15 3.959c-.464 0-.868-.17-1.208-.511a1.653 1.653 0 0 1-.512-1.207c0-.465.17-.87.512-1.219.34-.348.744-.522 1.208-.522.464 0 .888.174 1.23.522.341.348.511.754.511 1.219 0 .464-.17.866-.511 1.207-.34.34-.751.511-1.23.511zM98.757 16.14V5.265h2.808V16.14h-2.808zM108.69 16.443c-1.641 0-3.008-.55-4.103-1.654-1.095-1.101-1.643-2.464-1.643-4.088s.548-2.987 1.643-4.089 2.464-1.653 4.103-1.653c1.06 0 2.024.253 2.895.76.871.508 1.532 1.19 1.981 2.045l-2.416 1.413a2.464 2.464 0 0 0-.989-1.067 2.878 2.878 0 0 0-1.491-.39c-.842 0-1.539.28-2.091.837-.551.559-.827 1.272-.827 2.142 0 .87.276 1.563.827 2.12.552.56 1.249.837 2.091.837.566 0 1.069-.126 1.513-.381.442-.254.773-.606.99-1.056l2.438 1.393a5.463 5.463 0 0 1-2.024 2.055c-.871.515-1.835.772-2.895.772l-.002.004z"
  }))), _defs$9 || (_defs$9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dynamic-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .5)",
    fill: "#fff",
    d: "M0 0h113.61v20H0z"
  })))));
};

const DynamicWidgetFooter = ({ children }) => (jsxRuntimeExports.jsx("div", { className: 'dynamic-widget-footer', "data-testid": 'dynamic-widget-footer', children: children }));

const URL$1 = 'https://dynamic.xyz';
const alignClassNames = {
    center: 'powered-by-dynamic--center',
    right: 'powered-by-dynamic--right',
};
const PoweredByDynamic = ({ align = 'center', classNameLogo, classNameRoot, classNameText, asFooter, }) => {
    var _a;
    const { projectSettings } = useInternalDynamicContext();
    if (((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _a === void 0 ? void 0 : _a.displayDynamicMessaging) === false) {
        return null;
    }
    const content = (jsxRuntimeExports.jsxs("a", { target: '_blank', href: URL$1, className: classNames('powered-by-dynamic', alignClassNames[align], classNameRoot), rel: 'noreferrer', children: [jsxRuntimeExports.jsx(Typography, { as: 'span', color: 'tertiary', weight: 'regular', variant: 'body_mini', className: classNames('powered-by-dynamic__text', classNameText), children: "Powered by" }), jsxRuntimeExports.jsx(SvgDynamicLogo, { className: classNames('powered-by-dynamic__logo', classNameLogo) })] }));
    if (asFooter)
        return jsxRuntimeExports.jsx(DynamicWidgetFooter, { children: content });
    return content;
};

const roundToNthDecimal = (value, decimal) => {
    if (!value)
        return;
    const factor = Math.pow(10, decimal);
    const rounded = Math.round(value * factor) / factor;
    const zeros = '0'.repeat(decimal - 1);
    return rounded === 0 ? `<0.${zeros}1` : rounded;
};

const useCurrencySymbol = (currentToken, currency) => (currentToken === null || currentToken === void 0 ? void 0 : currentToken.symbol) || currency;
const getValueRounded = (isNativeToken, transaction) => {
    let value;
    if (isNativeToken)
        value = transaction.value ? transaction.format(transaction.value) : '0';
    else {
        value =
            (transaction === null || transaction === void 0 ? void 0 : transaction.nonNativeValue) && (transaction === null || transaction === void 0 ? void 0 : transaction.formatNonNativeToken)
                ? transaction.formatNonNativeToken(transaction.nonNativeValue, transaction.nonNativeDecimal || 18)
                : '0';
    }
    return roundToNthDecimal(Number(value), 6);
};
const calculateFiatPrice = (amount, price, decimals) => {
    if (amount === undefined || isNaN(amount) || !decimals || !price)
        return 0;
    const scalingFactor = Math.pow(10, decimals);
    try {
        const amountBigInt = BigInt(Math.round(amount * scalingFactor));
        const priceBigInt = BigInt(Math.round(price * scalingFactor));
        const fiatValue = (amountBigInt * priceBigInt) / BigInt(scalingFactor);
        return Number(fiatValue) / scalingFactor;
    }
    catch (e) {
        // Possible issue: getting wrong price / decimals.
        // E.g: price is 0.00002206 and decimal is 5
        //'The number 2.206 cannot be converted to a BigInt because it is not an integer'
        return undefined;
    }
};
const getDisplayFiatPrice = (amountValue, currentToken) => {
    if (!(currentToken === null || currentToken === void 0 ? void 0 : currentToken.price))
        return '--';
    const fiatValue = calculateFiatPrice(amountValue, currentToken.price, currentToken.decimals);
    if (fiatValue === undefined) {
        return '--';
    }
    return fiatValue === 0 || fiatValue >= 0.01 ? fiatValue.toFixed(2) : '<0.01';
};
const useHandleRecovery = (walletConnector, usingSessionKey, onSuccess, shouldInitRecovery, initPasskeyRecoveryProcess, hideModal) => {
    const handleRecovery = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if ((yield shouldInitRecovery()) &&
            walletConnector &&
            !usingSessionKey(walletConnector)) {
            yield initPasskeyRecoveryProcess('email', {
                type: 'sendTransaction',
            }); // Ensure the parameters match the actual function signature
        }
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess('callHandlerOutsideModal');
    });
    useEffectOnce(() => {
        if (hideModal) {
            handleRecovery();
        }
    });
};
const useHandleSubmitWithChecks = (config, recoveryHandlers, viewHandlers) => (e) => __awaiter$1(void 0, void 0, void 0, function* () {
    const { walletConnector, usingSessionKey, onClickSend, isTurnkeyWallet, userNeedsCrossDomainPasskey, } = config;
    const { shouldInitRecovery, initPasskeyRecoveryProcess } = recoveryHandlers;
    const { pushView, setShowAuthFlow } = viewHandlers;
    if (walletConnector && usingSessionKey(walletConnector)) {
        onClickSend(e);
        return;
    }
    if (yield shouldInitRecovery()) {
        yield initPasskeyRecoveryProcess('email', {
            type: 'sendTransaction',
        });
    }
    if (isTurnkeyWallet && userNeedsCrossDomainPasskey) {
        pushView('passkey-new-domain-detected');
        setShowAuthFlow(true, {
            ignoreIfIsEmbeddedWidget: false,
            performMultiWalletChecks: false,
        });
        dynamicEvents.once('passkeyRecoveryCompleted', () => {
            onClickSend(e);
        });
        return;
    }
    onClickSend(e);
});

var _path$1a;
var _excluded$1j = ["title", "titleId"];
function _extends$1j() { return _extends$1j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1j.apply(null, arguments); }
function _objectWithoutProperties$1j(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1j(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1j(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgTooltip = function SvgTooltip(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1j(_ref, _excluded$1j);
  return /*#__PURE__*/React.createElement("svg", _extends$1j({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$1a || (_path$1a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10-5a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1Zm-1 9a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
    fill: "#ABACB2"
  })));
};

const getNetworkInfoEntry = (chain, networkInfo) => {
    if (!chain || !chain.symbol) {
        return;
    }
    const normalizedChainSymbol = chain.symbol === 'ETH' || chain.symbol === 'EVM'
        ? 'evm'
        : chain.symbol.toLowerCase();
    const networkData = networkInfo[normalizedChainSymbol] ||
        networkInfo[ChainEnumToVerifiedCredentialName[normalizedChainSymbol.toUpperCase()]];
    if (!networkData)
        return;
    if (normalizedChainSymbol === 'evm') {
        return networkData.find((e) => e.chainId === (chain === null || chain === void 0 ? void 0 : chain.chainId));
    }
    // Solana, etc
    return networkData[0];
};
const getEvmChainName = (chainId) => {
    const map = {
        1: 'Ethereum',
        10: 'OP Mainnet',
        11155111: 'Sepolia',
        137: 'Polygon',
        42161: 'Arbitrum One',
        43114: 'Avalanche',
        8453: 'Base',
    };
    return map[chainId] || 'Unknown';
};

const useFetchChain = (connector) => {
    const fetchChain = () => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!connector)
            return { chainId: undefined, name: '', symbol: undefined };
        const chainId = yield connector.getNetwork();
        const { connectedChain } = connector;
        const chainInfo = getChainInfoWithOverrides(connectedChain || '');
        const chainWithIcon = {
            chainId,
            name: chainInfo === null || chainInfo === void 0 ? void 0 : chainInfo.displayName,
            symbol: chainInfo === null || chainInfo === void 0 ? void 0 : chainInfo.symbol,
        };
        /* istanbul ignore else */
        if (chainId && connector.evmNetworks) {
            const result = connector.evmNetworks.find((element) => element.chainId === chainId);
            chainWithIcon.name =
                (_b = (_a = result === null || result === void 0 ? void 0 : result.vanityName) !== null && _a !== void 0 ? _a : result === null || result === void 0 ? void 0 : result.name) !== null && _b !== void 0 ? _b : chainWithIcon.name;
            chainWithIcon.icon = result === null || result === void 0 ? void 0 : result.iconUrls[0];
        }
        return chainWithIcon;
    });
    const { data: chain, isLoading } = usePromise(fetchChain, {
        deps: [connector],
    });
    return { chain, isLoading };
};

const useNetworkConfigurationsFromProjectSettings = ({ projectSettings, cosmosNetworkOverrides, evmNetworksOverrides, }) => useMemo(() => {
    var _a, _b, _c, _d, _e;
    const networks = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.networks;
    if (!networks)
        return {};
    const evm = networks.find((configurations) => configurations.chainName === 'evm');
    const solana = networks.find((configurations) => configurations.chainName === 'solana');
    const cosmos = networks.find((configurations) => configurations.chainName === 'cosmos');
    const starknet = networks.find((configurations) => configurations.chainName === 'starknet');
    const eclipse = networks.find((configurations) => configurations.chainName === 'eclipse');
    let cosmosNetworks = (_a = cosmos === null || cosmos === void 0 ? void 0 : cosmos.networks) === null || _a === void 0 ? void 0 : _a.map((net) => createNetwork(net, parseInt));
    cosmosNetworks = overrideNetworks(cosmosNetworkOverrides, cosmosNetworks);
    let evmNetworks = (_b = evm === null || evm === void 0 ? void 0 : evm.networks) === null || _b === void 0 ? void 0 : _b.map((net) => createNetwork(net, parseInt));
    evmNetworks = overrideNetworks(evmNetworksOverrides, evmNetworks);
    const starknetNetworks = (_c = starknet === null || starknet === void 0 ? void 0 : starknet.networks) === null || _c === void 0 ? void 0 : _c.map((net) => createNetwork(net));
    const solanaNetworks = (_d = solana === null || solana === void 0 ? void 0 : solana.networks) === null || _d === void 0 ? void 0 : _d.map((net) => createNetwork(net));
    const eclipseNetworks = (_e = eclipse === null || eclipse === void 0 ? void 0 : eclipse.networks) === null || _e === void 0 ? void 0 : _e.map((net) => createNetwork(net));
    if (evmNetworksOverrides) {
        if (Array.isArray(evmNetworksOverrides)) {
            evmNetworks = evmNetworksOverrides;
        }
        else {
            evmNetworks = evmNetworksOverrides(evmNetworks !== null && evmNetworks !== void 0 ? evmNetworks : []);
        }
    }
    const networkConfigurations = {
        cosmos: cosmosNetworks,
        eclipse: eclipseNetworks,
        evm: evmNetworks,
        solana: solanaNetworks,
        starknet: starknetNetworks,
    };
    return networkConfigurations;
}, [projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.networks, cosmosNetworkOverrides, evmNetworksOverrides]);
const createNetwork = (network, parser = (input) => input) => ({
    bech32Prefix: network.bech32Prefix,
    blockExplorerUrls: network.blockExplorerUrls,
    chainId: parser(network.chainId),
    iconUrls: network.iconUrls,
    lcdUrl: network.lcdUrl,
    name: network.name,
    nativeCurrency: network.nativeCurrency,
    networkId: parser(network.networkId),
    privateCustomerRpcUrls: network.privateCustomerRpcUrls,
    rpcUrls: network.rpcUrls,
    vanityName: network.vanityName,
});
const overrideNetworks = (networkOverrides, networks) => {
    if (!networkOverrides) {
        return networks;
    }
    if (Array.isArray(networkOverrides)) {
        return networkOverrides;
    }
    else {
        return networkOverrides(networks !== null && networks !== void 0 ? networks : []);
    }
};

const TransactionCard = ({ transaction, simulationResult, isGasSponsored, isAATransaction, recipient, }) => {
    var _a, _b, _c, _d, _e, _f;
    const { t } = useTranslation();
    const { primaryWallet, projectSettings, overrides } = useInternalDynamicContext();
    const networkInfo = useNetworkConfigurationsFromProjectSettings({
        evmNetworksOverrides: overrides === null || overrides === void 0 ? void 0 : overrides.evmNetworks,
        projectSettings,
    });
    const { chain } = useFetchChain(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector);
    const networkInfoEntry = getNetworkInfoEntry(chain, networkInfo);
    const { symbol: nativeCurrencySymbol, decimals: nativeCurrencyDecimals } = (_a = networkInfoEntry === null || networkInfoEntry === void 0 ? void 0 : networkInfoEntry.nativeCurrency) !== null && _a !== void 0 ? _a : {};
    const blockaidOn = simulationResult === null || simulationResult === void 0 ? void 0 : simulationResult.showTotalFiat;
    const feeInUsd = useMemo(() => {
        var _a;
        const nativeTokenUsdPrice = (_a = simulationResult === null || simulationResult === void 0 ? void 0 : simulationResult.priceData) === null || _a === void 0 ? void 0 : _a.nativeTokenUsdPrice;
        if (!nativeTokenUsdPrice || !nativeCurrencyDecimals) {
            return undefined;
        }
        return ((Number(nativeTokenUsdPrice) * Number(transaction.fee.gas)) /
            Math.pow(10, nativeCurrencyDecimals));
    }, [simulationResult, nativeCurrencyDecimals, transaction.fee.gas]);
    const getFeeInUsdDisplay = (feeInUsd) => {
        if (!feeInUsd)
            return undefined;
        return feeInUsd < 0.01 ? '<$0.01' : `~$${feeInUsd.toFixed(2)}`;
    };
    const totalAmountInUsd = useMemo(() => {
        var _a;
        const outgoingAssetsTotal = ((_a = simulationResult === null || simulationResult === void 0 ? void 0 : simulationResult.outAssets) === null || _a === void 0 ? void 0 : _a.reduce((acc, transfer) => {
            var _a;
            const transferOutTotal = ((_a = transfer.transferOut) === null || _a === void 0 ? void 0 : _a.reduce((sum, t) => sum + Number((t === null || t === void 0 ? void 0 : t.usdPrice) || 0), 0)) || 0;
            return acc + transferOutTotal;
        }, 0)) || 0;
        if (blockaidOn && isAATransaction) {
            return outgoingAssetsTotal;
        }
        // for solana, the fee is included in the outgoing assets already
        return (outgoingAssetsTotal +
            (nativeCurrencySymbol === 'SOL' || isGasSponsored ? 0 : feeInUsd || 0));
    }, [simulationResult === null || simulationResult === void 0 ? void 0 : simulationResult.outAssets, nativeCurrencySymbol, feeInUsd]);
    const getTotalAmountInUsdDisplay = (totalAmountInUsd) => {
        if (!totalAmountInUsd)
            return undefined;
        return totalAmountInUsd < 0.01
            ? '<$0.01'
            : `~$${totalAmountInUsd.toFixed(2)}`;
    };
    const renderAssetTransfer = (transfer, index, array) => {
        var _a, _b;
        if ((transfer.asset.type === 'NATIVE' || transfer.asset.type === 'SOL') &&
            transfer.asset.chainName === 'Solana' &&
            transaction.fee.gas) {
            transfer.amount = (Number(transfer.amount) -
                Number(transaction.fee.gas) / Math.pow(10, 9)).toString();
            transfer.usdPrice = (Number(transfer.usdPrice) - Number(feeInUsd)).toString();
        }
        const getAmountDisplay = () => {
            const amount = Number(transfer.amount);
            if (Number.isInteger(amount)) {
                return amount;
            }
            return amount < 0.000001 ? '<0.000001' : amount.toFixed(6);
        };
        const getUsdPriceDisplay = () => {
            const usdPrice = Number(transfer.usdPrice);
            if (usdPrice < 0.01) {
                return '<$0.01';
            }
            return `$${usdPrice.toFixed(2)}`;
        };
        return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("div", { className: `transaction-card__${transfer.direction}`, children: jsxRuntimeExports.jsxs("div", { className: 'transaction-card__info-container', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', children: transfer.direction === 'in' ? 'Receive' : 'Send' }), jsxRuntimeExports.jsxs("div", { className: 'transaction-card__amount-symbol', children: [jsxRuntimeExports.jsxs("div", { className: 'transaction-card__token-info', children: [jsxRuntimeExports.jsxs("div", { className: 'transaction-card__token-row', children: [jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', color: transfer.direction === 'in' ? 'green-1' : 'error-1', children: [transfer.direction === 'out' ? '-' : '+', getAmountDisplay()] }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', children: (_a = (transfer.asset.symbol || transfer.asset.name)) !== null && _a !== void 0 ? _a : nativeCurrencySymbol })] }), Number(transfer.usdPrice) > 0 && (jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: transfer.direction === 'in' ? 'green-1' : 'error-1', children: getUsdPriceDisplay() }))] }), jsxRuntimeExports.jsx("div", { className: 'transaction-card__icon', children: jsxRuntimeExports.jsx("div", { className: 'transaction-card__icon__container', children: jsxRuntimeExports.jsx("img", { src: transfer.asset.logoUrl ||
                                                    (networkInfoEntry === null || networkInfoEntry === void 0 ? void 0 : networkInfoEntry.nativeCurrency.iconUrl), alt: (_b = transfer.asset.symbol) !== null && _b !== void 0 ? _b : nativeCurrencySymbol, width: 32, height: 32, className: 'transaction-card__icon__container__main' }) }) })] })] }) }), index < array.length - 1 && (jsxRuntimeExports.jsx("div", { className: 'transaction-card__divider' }))] }));
    };
    const inAssets = ((_b = simulationResult === null || simulationResult === void 0 ? void 0 : simulationResult.inAssets) === null || _b === void 0 ? void 0 : _b.flatMap((assetDiff) => {
        var _a;
        return ((_a = assetDiff.transferIn) === null || _a === void 0 ? void 0 : _a.map((inTransfer) => {
            var _a, _b;
            return ({
                amount: (_a = inTransfer === null || inTransfer === void 0 ? void 0 : inTransfer.value) !== null && _a !== void 0 ? _a : '',
                asset: assetDiff.asset,
                direction: 'in',
                usdPrice: (_b = inTransfer === null || inTransfer === void 0 ? void 0 : inTransfer.usdPrice) !== null && _b !== void 0 ? _b : '',
            });
        })) || [];
    })) || [];
    const outAssets = ((_c = simulationResult === null || simulationResult === void 0 ? void 0 : simulationResult.outAssets) === null || _c === void 0 ? void 0 : _c.flatMap((assetDiff) => {
        var _a;
        return ((_a = assetDiff.transferOut) === null || _a === void 0 ? void 0 : _a.map((outTransfer) => {
            var _a, _b;
            return ({
                amount: (_a = outTransfer === null || outTransfer === void 0 ? void 0 : outTransfer.value) !== null && _a !== void 0 ? _a : '',
                asset: assetDiff.asset,
                direction: 'out',
                usdPrice: (_b = outTransfer === null || outTransfer === void 0 ? void 0 : outTransfer.usdPrice) !== null && _b !== void 0 ? _b : '',
            });
        })) || [];
    })) || [];
    // for solana, the simulation out asset includes the gas fee.
    // so if the gas fee is the same as the total solana spend, then there is no solana being sent, only a gas fee
    const outAssetsWithoutFee = outAssets.filter((asset) => !((asset.asset.type === 'NATIVE' || asset.asset.type === 'SOL') &&
        asset.asset.chainName === 'Solana' &&
        Number(asset.amount) === Number(transaction.fee.gas) / Math.pow(10, 9)));
    //for evm AA with blockaid ON, the outAssets includes the gas fee,
    //so we need to remove it if the transaction doesnt have a tx.value (ETH spend)
    const outAssetsWithoutFeeEvm = outAssetsWithoutFee.filter((asset) => !(asset.asset.type === 'NATIVE' &&
        transaction.chain === 'EVM' &&
        !transaction.value));
    const allAssets = [...outAssetsWithoutFeeEvm, ...inAssets];
    const getGasFeeDisplay = () => {
        if (feeInUsd) {
            return getFeeInUsdDisplay(feeInUsd);
        }
        if (transaction.fee.gas) {
            return `${transaction.format(transaction.fee.gas, {
                precision: 6,
            })} ${nativeCurrencySymbol}`;
        }
        return `-- ${nativeCurrencySymbol}`;
    };
    return (jsxRuntimeExports.jsxs("div", { className: 'transaction-card-container', children: [allAssets.length > 0 && (jsxRuntimeExports.jsx("div", { className: 'transaction-card', children: jsxRuntimeExports.jsx("div", { className: 'transaction-card__assets-container', children: allAssets.map((asset, index, array) => (jsxRuntimeExports.jsx(React__default.Fragment, { children: renderAssetTransfer(asset, index, array) }, `asset-${index}`))) }) })), jsxRuntimeExports.jsx("div", { className: 'transaction-card', children: jsxRuntimeExports.jsxs("div", { className: 'transaction-card__details', children: [recipient && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("div", { className: 'transaction-card__row', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', copykey: 'dyn_send_transaction.confirmation.data.recipient', children: t('dyn_send_transaction.confirmation.data.recipient') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', "data-testid": 'transaction-recipient', children: shortenWalletAddress(recipient, 4, 4) })] }), jsxRuntimeExports.jsx("div", { className: 'transaction-card__divider' })] })), !recipient &&
                            (transaction.to || ((_d = simulationResult === null || simulationResult === void 0 ? void 0 : simulationResult.counterparties) === null || _d === void 0 ? void 0 : _d[0])) && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("div", { className: 'transaction-card__row', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', copykey: 'dyn_send_transaction.confirmation.data.destination', children: t('dyn_send_transaction.confirmation.data.destination') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', "data-testid": 'transaction-destination', children: shortenWalletAddress((_e = transaction.to) !== null && _e !== void 0 ? _e : (_f = simulationResult === null || simulationResult === void 0 ? void 0 : simulationResult.counterparties) === null || _f === void 0 ? void 0 : _f[0], 4, 4) })] }), jsxRuntimeExports.jsx("div", { className: 'transaction-card__divider' })] })), jsxRuntimeExports.jsxs("div", { className: 'transaction-card__row', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', copykey: 'dyn_send_transaction.confirmation.data.network', children: t('dyn_send_transaction.confirmation.data.network') }), jsxRuntimeExports.jsxs("div", { className: 'transaction-card__network-info', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', children: (networkInfoEntry === null || networkInfoEntry === void 0 ? void 0 : networkInfoEntry.name) || 'Ethereum' }), jsxRuntimeExports.jsx("img", { src: networkInfoEntry === null || networkInfoEntry === void 0 ? void 0 : networkInfoEntry.iconUrls[0], alt: (networkInfoEntry === null || networkInfoEntry === void 0 ? void 0 : networkInfoEntry.name) || 'Network icon', width: 16, height: 16, className: 'transaction-card__network-icon' })] })] }), !isGasSponsored && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("div", { className: 'transaction-card__divider' }), jsxRuntimeExports.jsxs("div", { className: 'transaction-card__row', children: [jsxRuntimeExports.jsxs("div", { className: 'transaction-card__label-with-tooltip', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', copykey: 'dyn_send_transaction.confirmation.data.gas_estimate', children: t('dyn_send_transaction.confirmation.data.gas_estimate') }), jsxRuntimeExports.jsx(Tooltip, { content: 'Network fees are paid to process your transaction', className: 'transaction-confirmation', children: jsxRuntimeExports.jsx(Icon, { size: 'small', className: 'fee-tooltip', children: jsxRuntimeExports.jsx(SvgTooltip, {}) }) })] }), jsxRuntimeExports.jsx("div", { className: 'transaction-card__value', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', "data-testid": 'transaction-estimated-gas-fee', children: getGasFeeDisplay() }) })] })] })), blockaidOn &&
                            totalAmountInUsd !== undefined &&
                            totalAmountInUsd > 0 &&
                            !(isAATransaction && !isGasSponsored) && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("div", { className: 'transaction-card__divider' }), jsxRuntimeExports.jsxs("div", { className: 'transaction-card__row', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', weight: 'bold', copykey: 'dyn_send_transaction.confirmation.data.total', children: t('dyn_send_transaction.confirmation.data.total') }), jsxRuntimeExports.jsx("div", { className: 'transaction-card__total-amount', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', "data-testid": 'transaction-estimated-total', children: getTotalAmountInUsdDisplay(totalAmountInUsd) }) })] })] }))] }) })] }));
};

const SendBalanceTransactionCard = ({ transaction, currentToken, currencySymbol, valueRounded, transactionValue, isGasSponsored, gasFiatValue, totalGasFiatValue, currency, total, t, walletKey, }) => {
    const { primaryWallet, projectSettings, overrides } = useInternalDynamicContext();
    const networkInfo = useNetworkConfigurationsFromProjectSettings({
        evmNetworksOverrides: overrides === null || overrides === void 0 ? void 0 : overrides.evmNetworks,
        projectSettings,
    });
    const { chain } = useFetchChain(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector);
    const networkInfoEntry = getNetworkInfoEntry(chain, networkInfo);
    const renderTransferDetails = () => (jsxRuntimeExports.jsx("div", { className: 'transaction-card', children: jsxRuntimeExports.jsx("div", { className: 'transaction-card__assets-container', children: jsxRuntimeExports.jsx("div", { className: 'transaction-card__out', children: jsxRuntimeExports.jsxs("div", { className: 'transaction-card__info-container', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', children: t('dyn_send_transaction.confirmation.data.transfer.send') }), jsxRuntimeExports.jsxs("div", { className: 'transaction-card__amount-symbol', children: [jsxRuntimeExports.jsxs("div", { className: 'transaction-card__token-info', children: [jsxRuntimeExports.jsxs("div", { className: 'transaction-card__token-row', children: [jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', color: 'error-1', "data-testid": 'transaction-transfer-amount', children: ["-", valueRounded ||
                                                            ((transaction === null || transaction === void 0 ? void 0 : transaction.value)
                                                                ? transaction.format(transaction.value, {
                                                                    precision: 6,
                                                                })
                                                                : '')] }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', children: currencySymbol })] }), transactionValue && (jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', color: 'error-1', "data-testid": 'transaction-transfer-amount-fiat', children: ["$", getDisplayFiatPrice(Number(transactionValue) || Number(valueRounded) || 0, currentToken)] }))] }), jsxRuntimeExports.jsx("div", { className: 'transaction-card__icon', children: jsxRuntimeExports.jsx("div", { className: 'transaction-card__icon__container', children: jsxRuntimeExports.jsx("img", { src: (currentToken === null || currentToken === void 0 ? void 0 : currentToken.logoURI) ||
                                                (networkInfoEntry === null || networkInfoEntry === void 0 ? void 0 : networkInfoEntry.nativeCurrency.iconUrl), alt: currencySymbol, width: 32, height: 32, className: 'transaction-card__icon__container__main' }) }) })] })] }) }) }) }));
    const renderTransactionDetails = () => (jsxRuntimeExports.jsx("div", { className: 'transaction-card', children: jsxRuntimeExports.jsxs("div", { className: 'transaction-card__details', children: [jsxRuntimeExports.jsxs("div", { className: 'transaction-card__row', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', copykey: 'dyn_send_transaction.confirmation.data.destination', children: t('dyn_send_transaction.confirmation.data.destination') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', "data-testid": 'transaction-destination', children: shortenWalletAddress(transaction.to, 4, 4) })] }), !isGasSponsored && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("div", { className: 'transaction-card__divider' }), jsxRuntimeExports.jsxs("div", { className: 'transaction-card__row', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', "data-testid": 'transaction-network', copykey: 'dyn_send_transaction.confirmation.data.network', children: t('dyn_send_transaction.confirmation.data.network') }), jsxRuntimeExports.jsxs("div", { className: 'transaction-card__network-info', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', children: (networkInfoEntry === null || networkInfoEntry === void 0 ? void 0 : networkInfoEntry.name) || 'Ethereum' }), jsxRuntimeExports.jsx("img", { src: (networkInfoEntry === null || networkInfoEntry === void 0 ? void 0 : networkInfoEntry.iconUrls[0]) || (chain === null || chain === void 0 ? void 0 : chain.icon), alt: (networkInfoEntry === null || networkInfoEntry === void 0 ? void 0 : networkInfoEntry.name) || 'Network icon', width: 16, height: 16, className: 'transaction-card__network-icon' })] })] }), jsxRuntimeExports.jsx("div", { className: 'transaction-card__divider' }), jsxRuntimeExports.jsxs("div", { className: 'transaction-card__row', children: [jsxRuntimeExports.jsxs("div", { className: 'transaction-card__label-with-tooltip', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', copykey: 'dyn_send_transaction.confirmation.data.gas_estimate', children: t('dyn_send_transaction.confirmation.data.gas_estimate') }), jsxRuntimeExports.jsx(Tooltip, { content: 'Network fees are paid to process your transaction', className: 'transaction-confirmation', children: jsxRuntimeExports.jsx(Icon, { size: 'small', className: 'fee-tooltip', children: jsxRuntimeExports.jsx(SvgTooltip, {}) }) })] }), jsxRuntimeExports.jsx("div", { className: 'transaction-card__value', children: (currentToken === null || currentToken === void 0 ? void 0 : currentToken.price) ? (jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', "data-testid": 'transaction-estimated-gas-fee', children: Number(gasFiatValue) <= 0.01
                                            ? '<$0.01'
                                            : `$${gasFiatValue}` })) : (jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', color: 'primary', "data-testid": 'transaction-estimated-gas-fee', children: [transaction.fee.gas
                                                ? transaction.format(transaction.fee.gas, {
                                                    precision: 6,
                                                })
                                                : '--', ' ', currency] })) })] }), jsxRuntimeExports.jsx("div", { className: 'transaction-card__divider' }), jsxRuntimeExports.jsxs("div", { className: 'transaction-card__row', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', weight: 'bold', copykey: 'dyn_send_transaction.confirmation.data.total', children: t('dyn_send_transaction.confirmation.data.total') }), jsxRuntimeExports.jsx("div", { className: 'transaction-card__value', children: (currentToken === null || currentToken === void 0 ? void 0 : currentToken.price) ? (jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', "data-testid": 'transaction-total', children: Number(totalGasFiatValue) <= 0.01
                                            ? '<$0.01'
                                            : `$${totalGasFiatValue}` })) : (jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', color: 'primary', "data-testid": 'transaction-total', children: [total ? transaction.format(total, { precision: 6 }) : '--', ' ', currency] })) })] })] }))] }) }));
    return (jsxRuntimeExports.jsxs("div", { className: 'transaction-card-container', children: [renderTransferDetails(), renderTransactionDetails()] }));
};

const TransactionConfirmationPageLayout = ({ onClickClose, isLoading, onClickBack, onClickSend, disableSendButton, displayPoweredByDynamicFooter = false, alert, walletConnector, transaction, currentToken, children, hideModal, onSuccess, transactionValue, total, isGasSponsored, isNativeToken, walletKey, simulationResult, sendBalanceTransaction, recipient, }) => {
    var _a;
    const { t } = useTranslation();
    const { isTurnkeyWallet } = useIsTurnkeyWallet();
    const { setShowAuthFlow } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const { userNeedsCrossDomainPasskey } = usePasskeyContext();
    const { initPasskeyRecoveryProcess, shouldInitRecovery } = usePasskeyRecovery();
    const { currency } = useFetchCurrency(walletConnector);
    const currencySymbol = useCurrencySymbol(currentToken, currency === null || currency === void 0 ? void 0 : currency.symbol);
    const { nativePrice } = useSendBalanceState();
    useHandleRecovery(walletConnector, usingSessionKey, onSuccess, shouldInitRecovery, initPasskeyRecoveryProcess, hideModal);
    const handleSubmitWithChecks = useHandleSubmitWithChecks({
        isTurnkeyWallet,
        onClickSend,
        userNeedsCrossDomainPasskey,
        usingSessionKey,
        walletConnector,
    }, { initPasskeyRecoveryProcess, shouldInitRecovery }, { pushView, setShowAuthFlow });
    const closeButton = onClickClose && (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: onClickClose, "data-testid": 'close', disabled: isLoading, children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    const backButton = onClickBack && (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: onClickBack, "data-testid": 'back-button', children: jsxRuntimeExports.jsx(SvgArrowLeft, {}) }));
    const gasFiatValue = getGasFiatValue(currentToken, transaction, nativePrice);
    const totalGasFiatValue = getTotalFiatCost(currentToken, transaction, nativePrice, transactionValue);
    return hideModal ? null : (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(ModalHeader, { trailing: closeButton, leading: backButton, alignContent: 'bottom', children: jsxRuntimeExports.jsx("div", { className: 'send-balance-page-layout__header-content', children: jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', copykey: 'dyn_send_transaction.data.confirmation_tx', children: t('dyn_send_transaction.data.confirmation_tx') }) }) }), !sendBalanceTransaction && (jsxRuntimeExports.jsx("div", { className: 'transaction-confirmation__banner', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', copykey: 'dyn_send_transaction.data.banner', children: t('dyn_send_transaction.data.banner') }) })), jsxRuntimeExports.jsx(PasskeyCreatedSuccessBanner, {}), jsxRuntimeExports.jsxs("div", { className: 'transaction-confirmation__body', children: [jsxRuntimeExports.jsxs("div", { className: 'transaction-confirmation__content', children: [!sendBalanceTransaction ? (jsxRuntimeExports.jsx(TransactionCard, { transaction: transaction, isGasSponsored: isGasSponsored, isAATransaction: (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.key) === 'zerodev', simulationResult: simulationResult, recipient: recipient })) : (jsxRuntimeExports.jsx(SendBalanceTransactionCard, { transaction: transaction, currentToken: currentToken, currencySymbol: currencySymbol, valueRounded: (_a = getValueRounded(Boolean(isNativeToken), transaction)) === null || _a === void 0 ? void 0 : _a.toString(), transactionValue: transactionValue, isGasSponsored: isGasSponsored, gasFiatValue: gasFiatValue || '0', totalGasFiatValue: totalGasFiatValue || '0', currency: currency === null || currency === void 0 ? void 0 : currency.symbol, total: total, t: t, walletKey: walletKey })), children && (jsxRuntimeExports.jsx("div", { className: 'transaction-confirmation__rows', children: children }))] }), jsxRuntimeExports.jsx(AnimatePresence, { animationComponent: jsxRuntimeExports.jsx(VerticalDrawerTransition, {}), children: alert && (jsxRuntimeExports.jsx("div", { className: 'transaction-confirmation__warning', children: alert })) }), jsxRuntimeExports.jsxs("div", { className: 'transaction-confirmation__actions', children: [(onClickBack || onClickClose) && (jsxRuntimeExports.jsx(TypographyButton, { buttonVariant: 'primary', buttonPadding: 'small', onClick: onClickBack || onClickClose, expanded: true, disabled: isLoading, copykey: 'dyn_send_transaction.confirmation.cancel_button', children: t('dyn_send_transaction.confirmation.cancel_button') })), jsxRuntimeExports.jsx(TypographyButton, { buttonVariant: 'brand-primary', buttonPadding: 'small', onClick: handleSubmitWithChecks, expanded: true, loading: isLoading, disabled: disableSendButton, copykey: 'dyn_send_transaction.confirmation.send', startSlot: 
                                // eslint-disable-next-line react/jsx-wrap-multilines
                                jsxRuntimeExports.jsx(Icon, { size: 'small', color: 'text-secondary', children: jsxRuntimeExports.jsx(SvgSend, {}) }), dataTestId: 'transaction-confirmation-send', children: t('dyn_send_transaction.confirmation.send') })] }), jsxRuntimeExports.jsx(NeedHelpSection, {}), displayPoweredByDynamicFooter && (jsxRuntimeExports.jsx(PoweredByDynamic, { classNameRoot: 'transaction-confirmation__footer' }))] })] }));
};

const useTransactionTotal = ({ transactionValue, gasTotalPrice, isGasSponsored = false, }) => useMemo(() => {
    if (isGasSponsored) {
        return transactionValue !== undefined ? transactionValue : BigInt(0);
    }
    if (gasTotalPrice !== undefined && transactionValue !== undefined) {
        return gasTotalPrice + transactionValue;
    }
    return transactionValue || gasTotalPrice;
}, [gasTotalPrice, transactionValue, isGasSponsored]);

const magicRpcError = -32603;
const errorCodesMapping = {
    '-32002': 'Insufficient funds for this transaction.',
    0: 'The operation either timed out or was not allowed.',
    16: 'Invalid Passkey signature. Select the passkey for this account and device.',
    3: 'You reached the limit of passkeys for this account.',
    5: 'Invalid Passkey signature.',
    INSUFFICIENT_FUNDS: 'Insufficient funds for this transaction.',
    [magicRpcError.toString()]: 'A network error has occurred. Please try again later',
};
const errorReasonsMapping = {
    'provided ENS name resolves to null': 'Invalid address. Please check that the entered address is correct.',
};
const getCode = (error) => {
    var _a;
    const err = error;
    return (err === null || err === void 0 ? void 0 : err.code) || ((_a = err === null || err === void 0 ? void 0 : err.cause) === null || _a === void 0 ? void 0 : _a.code);
};
const getMessage = (error) => {
    const err = error;
    return err === null || err === void 0 ? void 0 : err.message;
};
const hasReason = (error) => 'reason' in error && error.reason !== undefined;
const isTransactionExecutionError = (error) => error !== undefined &&
    error !== null &&
    typeof error === 'object' &&
    'walk' in error &&
    typeof error['walk'] === 'function';
const transactionErrorMessage = (err) => {
    let error = err;
    if (isTransactionExecutionError(err)) {
        error = err.walk();
    }
    logger$1.debug('transaction error:', error);
    if (TransactionGasCannotBeSponsoredError.isInstance(error)) {
        return;
    }
    if (InsufficientFundsError.isInstance(error)) {
        return errorCodesMapping.INSUFFICIENT_FUNDS;
    }
    if (isMagicInsufficientFundsError(error)) {
        return errorCodesMapping.INSUFFICIENT_FUNDS;
    }
    const code = getCode(error);
    if (code !== undefined && errorCodesMapping[code]) {
        return errorCodesMapping[code];
    }
    if (hasReason(error) && errorReasonsMapping[error.reason]) {
        return errorReasonsMapping[error.reason];
    }
    return 'Something went wrong.';
};
const isMagicInsufficientFundsError = (error) => {
    const code = getCode(error);
    const message = getMessage(error);
    return (code === magicRpcError &&
        Boolean(message === null || message === void 0 ? void 0 : message.includes('insufficient funds for gas * price + value')));
};

const FEE_REFRESH_INTERVAL = 20000;
var SimulationStatus;
(function (SimulationStatus) {
    SimulationStatus["LOADING"] = "loading";
    SimulationStatus["FAILED"] = "failed";
    SimulationStatus["SKIPPED"] = "skipped";
    SimulationStatus["SUCCESS"] = "success";
})(SimulationStatus || (SimulationStatus = {}));
const TransactionConfirmationView = ({ transaction, onError, onSuccess, mutation, onClickBack, walletConnector, onClickClose, title, displayPoweredByDynamicFooter = false, copykey, hideModal, currentToken, isNativeToken, transactionValue, isModal, sendBalanceTransaction, }) => {
    const { primaryWallet, environmentId } = useInternalDynamicContext();
    const [isGasSponsored, setIsGasSponsored] = useState(false);
    const update = useForceUpdate();
    const { t } = useTranslation();
    const { currency } = useFetchCurrency(walletConnector);
    // Update the chainId access to handle undefined case
    const chainId = useMemo(() => {
        if (!(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector)) {
            return undefined;
        }
        const connector = primaryWallet.connector;
        return connector._selectedChainId || connector.lastUsedChainId;
    }, [primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector]);
    const [simulationState, setSimulationState] = useState({
        status: SimulationStatus.LOADING,
    });
    const [recipient, setRecipient] = useState(undefined);
    const fetchSimulationResult = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (simulationState.status !== SimulationStatus.LOADING) {
            return;
        }
        if (sendBalanceTransaction || hideModal) {
            setSimulationState({ status: SimulationStatus.SKIPPED });
            return;
        }
        if (!primaryWallet || (!chainId && (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain) !== 'SOL')) {
            logger$1.error('[TransactionConfirmationView] Simulation failed:', {
                chain: primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain,
                chainId,
                primaryWallet,
            });
            setSimulationState({ status: SimulationStatus.FAILED });
            return;
        }
        try {
            let result;
            if (primaryWallet.connector.key === 'zerodev') {
                const connector = primaryWallet.connector;
                const { userOperation } = yield connector.getCurrentUserOperation(transaction);
                if (userOperation) {
                    const formattedUserOperation = yield connector.formatUserOperation(userOperation);
                    // Set the gas fee on the transaction, only for zero dev
                    transaction.fee.gas = calculateGasUnits(userOperation);
                    const entryPoint = yield ((_a = connector.getAccountAbstractionProvider()) === null || _a === void 0 ? void 0 : _a.account.entryPoint);
                    if (!entryPoint) {
                        logger$1.error('[TransactionConfirmationView] Simulation failed: No entry point address found');
                        setSimulationState({ status: SimulationStatus.FAILED });
                        return;
                    }
                    setRecipient((_b = transaction === null || transaction === void 0 ? void 0 : transaction.getTransactionRecipient) === null || _b === void 0 ? void 0 : _b.call(transaction));
                    result = yield simulateBlockaidUserOperation({
                        chainId: String(chainId),
                        entryPoint,
                        environmentId,
                        userOperation: formattedUserOperation,
                        value: ((_c = transaction.value) === null || _c === void 0 ? void 0 : _c.toString()) || '0',
                    });
                }
                else {
                    setSimulationState({ status: SimulationStatus.FAILED });
                    return;
                }
            }
            else {
                // Handle SOLANA
                if (!chainId) {
                    const encodedTransactions = (_d = transaction.multipleTransactions) === null || _d === void 0 ? void 0 : _d.map((tx) => bs58.encode(tx.serialize({ requireAllSignatures: false })));
                    if (!encodedTransactions) {
                        logger$1.error('[TransactionConfirmationView] Simulation failed: No encoded transactions');
                        setSimulationState({ status: SimulationStatus.FAILED });
                        return;
                    }
                    result = yield simulateBlockaidSVMTransaction({
                        accountAddress: transaction.from,
                        chain: (yield (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.getNetwork())),
                        environmentId,
                        transactions: encodedTransactions,
                    });
                }
                else {
                    setRecipient((_e = transaction === null || transaction === void 0 ? void 0 : transaction.getTransactionRecipient) === null || _e === void 0 ? void 0 : _e.call(transaction));
                    // EVM
                    result = yield simulateBlockaidEVMTransaction({
                        chainId: String(chainId),
                        data: transaction.data || '0x',
                        environmentId,
                        from: transaction.from,
                        to: transaction.to || '',
                        value: ((_f = transaction.value) === null || _f === void 0 ? void 0 : _f.toString()) || '0',
                    });
                }
            }
            if (!result && ((_g = primaryWallet.connector) === null || _g === void 0 ? void 0 : _g.key) !== 'zerodev') {
                logger$1.warn('[TransactionConfirmationView] Simulation failed: No result');
                setSimulationState({ status: SimulationStatus.FAILED });
                return;
            }
            setSimulationState(result
                ? { result, status: SimulationStatus.SUCCESS }
                : { status: SimulationStatus.FAILED });
        }
        catch (error) {
            logger$1.error('[TransactionConfirmationView] Simulation failed:', error);
            setSimulationState({ status: SimulationStatus.FAILED });
        }
    }), [
        sendBalanceTransaction,
        hideModal,
        primaryWallet,
        chainId,
        environmentId,
        transaction,
        walletConnector,
    ]);
    useEffect(() => {
        if (simulationState.status === SimulationStatus.SUCCESS ||
            simulationState.status === SimulationStatus.SKIPPED) {
            return;
        }
        fetchSimulationResult();
    }, [fetchSimulationResult, primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector, simulationState.status]);
    /**
     * Update transaction fee and trigger a react update
     * to reflect the new fee on the UI
     */
    const fetchTransactionFee = useCallback(() => {
        var _a;
        if (((primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain) === ChainEnum.Sol &&
            transaction.fee.gas !== undefined) ||
            (primaryWallet && ((_a = primaryWallet.connector) === null || _a === void 0 ? void 0 : _a.key) === 'zerodev')) {
            return;
        }
        transaction.fetchFee().finally(update);
    }, [primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain, transaction, update]);
    const { isLoading: isGasSponsoredLoading } = usePromise(() => {
        if (!isAccountAbstractionConnector(walletConnector)) {
            return false;
        }
        return walletConnector.canSponsorTransactionGas(transaction);
    }, {
        initialData: false,
        onReject: logger$1.error,
        onResolve: (isGasSponsored) => {
            setIsGasSponsored(isGasSponsored);
            if (!isGasSponsored && isAccountAbstractionConnector(walletConnector)) {
                walletConnector.disableGasSponsorshipOnce();
            }
        },
    });
    useEffect(() => {
        var _a;
        // solana gas sponsorship check
        if ((_a = transaction.isGasSponsored) === null || _a === void 0 ? void 0 : _a.call(transaction)) {
            setIsGasSponsored(true);
        }
    }, [transaction]);
    const { mutate: send, isLoading, error: transactionError, } = useMutation(mutation, {
        onFailure: useCallback((error) => {
            fetchTransactionFee();
            if (TransactionGasCannotBeSponsoredError.isInstance(error)) {
                logger$1.debug(error);
                setIsGasSponsored(false);
                if (isAccountAbstractionConnector(walletConnector)) {
                    walletConnector.disableGasSponsorshipOnce();
                }
            }
            logger$1.error(error);
            onError === null || onError === void 0 ? void 0 : onError(error);
        }, [fetchTransactionFee, onError, walletConnector]),
        onSuccess: useCallback((tx) => onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(tx), [onSuccess]),
    });
    // Refresh transaction fee, Solana fees are static based on transaction data, dont need to refresh them
    useInterval(fetchTransactionFee, isLoading ? null : FEE_REFRESH_INTERVAL);
    useEffectOnce(fetchTransactionFee);
    const total = useTransactionTotal({
        gasTotalPrice: transaction.fee.gas,
        isGasSponsored,
        transactionValue: transaction.value,
    });
    const errorMessage = transactionError && transactionErrorMessage(transactionError);
    const { data: balance, isLoading: isBalanceLoading } = usePromise(() => transaction.getBalance());
    const hasInsufficientFunds = useMemo(() => {
        if (total === undefined || balance === undefined)
            return false;
        return balance < total;
    }, [balance, total]);
    const missingFunds = useMemo(() => {
        if (total === undefined || balance === undefined)
            return undefined;
        return total - balance;
    }, [total, balance]);
    const alert = useMemo(() => {
        if (errorMessage)
            return null;
        // Check for gas sponsorship errors
        if (TransactionGasCannotBeSponsoredError.isInstance(transactionError)) {
            return (jsxRuntimeExports.jsx(Alert, { icon: 'error', variant: 'error', copykey: 'dyn_send_transaction.error_message.gas_not_sponsored', children: t('dyn_send_transaction.error_message.gas_not_sponsored') }));
        }
        // Check for insufficient gas funds
        if (!isGasSponsoredLoading &&
            !isBalanceLoading &&
            missingFunds === undefined &&
            transaction.fee.gas &&
            !isGasSponsored) {
            return (jsxRuntimeExports.jsx(Alert, { icon: 'error', variant: 'warning', copykey: 'dyn_send_transaction.warning_message.insufficient_gas_funds', children: jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', color: 'current-color', "data-testid": 'warning_content', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', copykey: 'dyn_send_transaction.warning_message.insufficient_gas_funds.title', children: t('dyn_send_transaction.warning_message.insufficient_gas_funds.title') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', copykey: 'dyn_send_transaction.warning_message.insufficient_gas_funds.description', children: t('dyn_send_transaction.warning_message.insufficient_gas_funds.description', {
                                amountLeft: transaction.format(transaction.fee.gas, {
                                    precision: 6,
                                }),
                                currencySymbol: currency === null || currency === void 0 ? void 0 : currency.symbol,
                            }) })] }) }));
        }
        // Check for insufficient funds
        const showInsufficientFundsWarningMessage = hasInsufficientFunds && missingFunds;
        if (showInsufficientFundsWarningMessage) {
            const amountLeft = transaction.format(missingFunds, { precision: 6 });
            return (jsxRuntimeExports.jsx(Alert, { icon: 'error', variant: 'error', copykey: 'dyn_send_transaction.warning_message.insufficient_funds', children: jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', color: 'current-color', "data-testid": 'warning_content', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', copykey: 'dyn_send_transaction.warning_message.insufficient_funds.title', children: t('dyn_send_transaction.warning_message.insufficient_funds.title') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', copykey: 'dyn_send_transaction.warning_message.insufficient_funds.description', children: t('dyn_send_transaction.warning_message.insufficient_funds.description', {
                                amountLeft,
                                currencySymbol: currency === null || currency === void 0 ? void 0 : currency.symbol,
                            }) })] }) }));
        }
        // Finally, check for simulation failure
        if (simulationState.status === SimulationStatus.FAILED) {
            return (jsxRuntimeExports.jsx(Alert, { icon: 'error', variant: 'warning', copykey: 'dyn_send_transaction.warning_message.failed_simulation', children: jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', color: 'current-color', "data-testid": 'warning_content', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', copykey: 'dyn_send_transaction.warning_message.failed_simulation.title', as: 'div', children: t('dyn_send_transaction.warning_message.failed_simulation.title') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', copykey: 'dyn_send_transaction.warning_message.failed_simulation.description', as: 'div', children: t('dyn_send_transaction.warning_message.failed_simulation.description') })] }) }));
        }
        return null;
    }, [
        simulationState.status,
        errorMessage,
        transactionError,
        isGasSponsoredLoading,
        isBalanceLoading,
        missingFunds,
        transaction,
        isGasSponsored,
        hasInsufficientFunds,
        t,
        currency === null || currency === void 0 ? void 0 : currency.symbol,
    ]);
    useEffect(() => {
        var _a, _b;
        if (simulationState.status === SimulationStatus.SUCCESS &&
            !sendBalanceTransaction) {
            if (((_a = simulationState.result) === null || _a === void 0 ? void 0 : _a.outAssets.length) === 0 &&
                !chainId &&
                !((_b = transaction.isGasSponsored) === null || _b === void 0 ? void 0 : _b.call(transaction))) {
                // set failed but keep the result so that we have the native price
                setSimulationState({
                    result: simulationState.result,
                    status: SimulationStatus.FAILED,
                });
            }
        }
    }, [simulationState, chainId, transaction, sendBalanceTransaction]);
    const layoutProps = useMemo(() => {
        var _a;
        return ({
            alert,
            copykey,
            currentToken,
            disableSendButton: isBalanceLoading,
            displayPoweredByDynamicFooter,
            error: errorMessage,
            hideModal,
            isGasSponsored,
            isGasSponsoredLoading,
            isLoading,
            isNativeToken,
            onClickBack,
            onClickClose,
            onClickSend: () => send(),
            onSuccess: (tx) => onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(tx),
            recipient,
            sendBalanceTransaction,
            simulationResult: (_a = simulationState.result) !== null && _a !== void 0 ? _a : undefined,
            title,
            total,
            transaction,
            transactionValue,
            walletConnector,
            walletKey: (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.key) || '',
        });
    }, [
        total,
        recipient,
        currentToken,
        transactionValue,
        isNativeToken,
        onClickBack,
        onClickClose,
        copykey,
        title,
        hideModal,
        isLoading,
        send,
        onSuccess,
        displayPoweredByDynamicFooter,
        isBalanceLoading,
        errorMessage,
        alert,
        walletConnector,
        transaction,
        isGasSponsored,
        isGasSponsoredLoading,
        primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.key,
        simulationState.result,
        sendBalanceTransaction,
    ]);
    return simulationState.status === SimulationStatus.LOADING ? null : (jsxRuntimeExports.jsx(TransactionConfirmationPageLayout, Object.assign({}, layoutProps)));
};
const calculateGasUnits = (userOp) => {
    // Sum all gas units
    const totalGasUnits = BigInt(userOp.callGasLimit || 0) +
        BigInt(userOp.verificationGasLimit || 0) +
        BigInt(userOp.preVerificationGas || 0);
    // Multiply by maxFeePerGas to get the total gas cost in wei
    const gasCost = totalGasUnits * BigInt(userOp.maxFeePerGas || 0);
    return gasCost;
};

const useSmartWallets = () => {
    const { user, walletConnectorOptions } = useInternalDynamicContext();
    const getSCWAccount = useCallback((wallet) => {
        const { verifiedCredentials } = user !== null && user !== void 0 ? user : {};
        if (!verifiedCredentials)
            return;
        // Ensure this is a SCW wallet
        const scwAccount = verifiedCredentials.find((credential) => credential.id === wallet.id);
        return (scwAccount === null || scwAccount === void 0 ? void 0 : scwAccount.walletProvider) ===
            WalletProviderEnum.SmartContractWallet
            ? scwAccount
            : undefined;
    }, [user]);
    const getEOAWallet = useCallback((wallet) => {
        var _a, _b, _c;
        const verifiedCredentials = user === null || user === void 0 ? void 0 : user.verifiedCredentials;
        if (!verifiedCredentials)
            return;
        // Ensure this is a SCW wallet
        const scwAccount = getSCWAccount(wallet);
        // Find the EOA account for this SCW
        const eoaAccount = verifiedCredentials.find((credential) => credential.id === (scwAccount === null || scwAccount === void 0 ? void 0 : scwAccount.signerRefId));
        if (!(eoaAccount === null || eoaAccount === void 0 ? void 0 : eoaAccount.address) || !(eoaAccount === null || eoaAccount === void 0 ? void 0 : eoaAccount.chain))
            return;
        const { walletConnector } = (_a = findWalletOptionFor(eoaAccount, walletConnectorOptions)) !== null && _a !== void 0 ? _a : {};
        // It's always authenticated, unless it's a turnkey wallet that still hasn't created a passkey
        const isTurnkey = (_b = eoaAccount.walletName) === null || _b === void 0 ? void 0 : _b.startsWith('turnkey');
        const isAuthenticated = !isTurnkey ||
            Boolean((_c = eoaAccount.walletProperties) === null || _c === void 0 ? void 0 : _c.isAuthenticatorAttached);
        return walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.createWallet({
            address: eoaAccount.address,
            chain: walletConnector.connectedChain,
            connector: walletConnector,
            id: eoaAccount.id,
            isAuthenticated,
            key: walletConnector.key,
        });
    }, [getSCWAccount, user === null || user === void 0 ? void 0 : user.verifiedCredentials, walletConnectorOptions]);
    const getSmartWallet = useCallback((wallet) => {
        var _a;
        const verifiedCredentials = user === null || user === void 0 ? void 0 : user.verifiedCredentials;
        if (!verifiedCredentials)
            return;
        // Get the EOA account for this wallet
        const eoaAccount = verifiedCredentials.find((credential) => credential.id === wallet.id);
        // Find the smart wallet account for this EOA
        const scwAccount = verifiedCredentials.find((credential) => credential.signerRefId === (eoaAccount === null || eoaAccount === void 0 ? void 0 : eoaAccount.id));
        if (!(scwAccount === null || scwAccount === void 0 ? void 0 : scwAccount.address) || !(scwAccount === null || scwAccount === void 0 ? void 0 : scwAccount.chain))
            return;
        const { walletConnector } = (_a = findWalletOptionFor(scwAccount, walletConnectorOptions)) !== null && _a !== void 0 ? _a : {};
        return walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.createWallet({
            address: scwAccount.address,
            chain: walletConnector.connectedChain,
            connector: walletConnector,
            id: scwAccount.id,
            isAuthenticated: true,
            key: walletConnector.key,
        });
    }, [user === null || user === void 0 ? void 0 : user.verifiedCredentials, walletConnectorOptions]);
    return useMemo(() => ({
        getEOAWallet,
        getSmartWallet,
        isSmartWallet: (wallet) => getSCWAccount(wallet) !== undefined,
    }), [getEOAWallet, getSCWAccount, getSmartWallet]);
};

const useIsTurnkeyWallet = () => {
    var _a, _b, _c;
    const { primaryWallet, user } = useInternalDynamicContext();
    const { getEOAWallet } = useSmartWallets();
    const wallet = (_a = (primaryWallet && getEOAWallet(primaryWallet))) !== null && _a !== void 0 ? _a : primaryWallet;
    const getTurnkeyVerifiedCredential = () => {
        if (!wallet || !user || !wallet.connector.key.startsWith('turnkey')) {
            return undefined;
        }
        const primaryWalletId = wallet.id;
        const turnkeyVC = user.verifiedCredentials.find((vc) => vc.id === primaryWalletId);
        if (!turnkeyVC) {
            return undefined;
        }
        return turnkeyVC;
    };
    const getUnclaimedTurnkeyTheSignerOfScw = () => {
        if (!wallet || !user) {
            return false;
        }
        const unclaimedTurnkeyVc = user.verifiedCredentials.find((vc) => {
            var _a, _b;
            return ((_a = vc.walletName) === null || _a === void 0 ? void 0 : _a.startsWith('turnkey')) &&
                ((_b = vc.walletProperties) === null || _b === void 0 ? void 0 : _b.isAuthenticatorAttached) === false;
        });
        const smartContractWalletWithUnclaimedTurnkeySigner = user.verifiedCredentials.find((vc) => unclaimedTurnkeyVc && vc.signerRefId === unclaimedTurnkeyVc.id);
        return smartContractWalletWithUnclaimedTurnkeySigner;
    };
    const turnkeyVerifiedCredential = getTurnkeyVerifiedCredential();
    const isUnclaimedTurnkeyTheSignerOfScw = Boolean(getUnclaimedTurnkeyTheSignerOfScw());
    const isTurnkeyWallet = Boolean(turnkeyVerifiedCredential || isUnclaimedTurnkeyTheSignerOfScw);
    const hasTurnkeyVerifiedCredentialAuthenticator = Boolean((_b = turnkeyVerifiedCredential === null || turnkeyVerifiedCredential === void 0 ? void 0 : turnkeyVerifiedCredential.walletProperties) === null || _b === void 0 ? void 0 : _b.isAuthenticatorAttached);
    const isTurnkeyWalletWithoutAuthenticator = (isTurnkeyWallet && !hasTurnkeyVerifiedCredentialAuthenticator) ||
        isUnclaimedTurnkeyTheSignerOfScw;
    const hasRecoveryEmail = isTurnkeyWallet &&
        Boolean(getUserVerifiedCredentialType(user, JwtVerifiedCredentialFormatEnum.Email));
    const isSessionKeyCompatible = isTurnkeyWallet &&
        Boolean((_c = turnkeyVerifiedCredential === null || turnkeyVerifiedCredential === void 0 ? void 0 : turnkeyVerifiedCredential.walletProperties) === null || _c === void 0 ? void 0 : _c.isSessionKeyCompatible);
    return {
        hasRecoveryEmail,
        hasTurnkeyVerifiedCredentialAuthenticator,
        isSessionKeyCompatible,
        isTurnkeyWallet,
        isTurnkeyWalletWithoutAuthenticator,
        turnkeyVerifiedCredential,
    };
};

const findPrimaryEmbeddedChain = (projectSettings) => {
    var _a, _b, _c;
    const embeddedChainConfig = ((_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _a === void 0 ? void 0 : _a.embeddedWallets) === null || _b === void 0 ? void 0 : _b.chainConfigurations) || [];
    return ((_c = embeddedChainConfig.find((chain) => chain.primary)) === null || _c === void 0 ? void 0 : _c.name) === 'SOL'
        ? ChainEnum.Sol
        : ChainEnum.Evm;
};

const findTurnkeyWalletByChain = (walletOptions, chainName) => {
    const chain = chainName
        ? VerifiedCredentialNameToChainEnum[chainName]
        : undefined;
    return walletOptions === null || walletOptions === void 0 ? void 0 : walletOptions.find(({ key, walletConnector }) => key.startsWith('turnkey') && (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain) === chain);
};
const findTurnkeyWalletByPrimaryChain = (walletOptions, chainConfigurations, verifiedCredentials) => {
    var _a;
    const primaryEmbeddedChain = ((_a = chainConfigurations === null || chainConfigurations === void 0 ? void 0 : chainConfigurations.find((chain) => chain.primary)) === null || _a === void 0 ? void 0 : _a.name) || ChainEnum.Evm;
    const walletConnector = findTurnkeyWalletByChain(walletOptions, ChainEnumToVerifiedCredentialName[primaryEmbeddedChain]);
    const turnkeyVC = verifiedCredentials === null || verifiedCredentials === void 0 ? void 0 : verifiedCredentials.find(({ walletName, chain }) => (walletName === null || walletName === void 0 ? void 0 : walletName.startsWith('turnkey')) &&
        chain === ChainEnumToVerifiedCredentialName[primaryEmbeddedChain]);
    if (!walletConnector) {
        return undefined;
    }
    return Object.assign(Object.assign({}, turnkeyVC), walletConnector);
};

// verifies if user has any type of wallet by checking if walletProvider is present
// as walletProvider is only present in VC wallets
const getUserWalletsFromVerifiedCredentials = (user) => {
    var _a;
    return (_a = user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.filter(
    // Only wallets has walletProviders
    ({ walletProvider }) => walletProvider);
};

const addPasskeyIdentifierToWalletConnector = (walletConnector, user) => {
    var _a;
    const passkeyIdentifier = (user === null || user === void 0 ? void 0 : user.phoneNumber) ||
        ((_a = user === null || user === void 0 ? void 0 : user.verifiedCredentials.find((vc) => vc.oauthDisplayName)) === null || _a === void 0 ? void 0 : _a.oauthDisplayName) ||
        '';
    walletConnector.setPasskeyIdentifier(passkeyIdentifier);
};

const getEmbeddedWalletAuthHandler = (walletConnector) => {
    if (!walletConnector ||
        'getAuthenticatorHandler' in walletConnector === false) {
        throw new DynamicError('Invalid connector type');
    }
    const turnkeyAuthenticatorHandler = walletConnector.getAuthenticatorHandler();
    return turnkeyAuthenticatorHandler;
};

const initExport = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ iframeContainer, iframeElementId, wallet, }) {
    var _b;
    if (!(wallet === null || wallet === void 0 ? void 0 : wallet.connector) ||
        !(wallet === null || wallet === void 0 ? void 0 : wallet.id) ||
        !isPasskeyWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector)) {
        throw new DynamicError('Connector is missing. Please make sure you added EthereumWalletConnectors and/or SolanaWalletConnectors to DynamicProvider settings', INVALID_WALLET_DATA);
    }
    const turnkeyExportHandler = (_b = wallet.connector) === null || _b === void 0 ? void 0 : _b.getExportHandler();
    const publicKey = yield turnkeyExportHandler.initExport(iframeContainer, iframeElementId);
    if (!publicKey) {
        throw new DynamicError('Something went wrong', ERROR_PROCESSING_REVEAL_REQUEST);
    }
    return turnkeyExportHandler;
});
const handleExportInitCheck = ({ user, wallet, }) => {
    var _a, _b;
    if (!user) {
        throw new DynamicError(USER_NOT_LOGGED_IN);
    }
    if (!(wallet === null || wallet === void 0 ? void 0 : wallet.connector) ||
        !(wallet === null || wallet === void 0 ? void 0 : wallet.id) ||
        !isPasskeyWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector)) {
        throw new DynamicError('Connector is missing. Please make sure you added EthereumWalletConnectors and/or SolanaWalletConnectors to DynamicProvider settings');
    }
    const connector = wallet.connector;
    connector.setEmail(user.email);
    const walletProperties = (_b = (_a = user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.find(({ walletName }) => walletName === null || walletName === void 0 ? void 0 : walletName.startsWith('turnkey'))) === null || _b === void 0 ? void 0 : _b.walletProperties;
    const turnkeyHDWalletId = walletProperties === null || walletProperties === void 0 ? void 0 : walletProperties.turnkeyHDWalletId;
    const privateKeyId = walletProperties === null || walletProperties === void 0 ? void 0 : walletProperties.turnkeyPrivateKeyId;
    const organizationId = walletProperties === null || walletProperties === void 0 ? void 0 : walletProperties.turnkeySubOrganizationId;
    if (!organizationId ||
        (turnkeyHDWalletId === undefined && privateKeyId === undefined)) {
        throw new DynamicError('Invalid token!');
    }
    return {
        connector,
        organizationId,
        privateKeyId,
        turnkeyHDWalletId,
    };
};
const extractExportBundle = ({ address, privateKeyId, activity, }) => {
    var _a, _b, _c;
    const exportWalletResult = address
        ? (_a = activity.result) === null || _a === void 0 ? void 0 : _a.exportWalletAccountResult
        : (_b = activity.result) === null || _b === void 0 ? void 0 : _b.exportWalletResult;
    const result = privateKeyId
        ? (_c = activity.result) === null || _c === void 0 ? void 0 : _c.exportPrivateKeyResult
        : exportWalletResult;
    return result === null || result === void 0 ? void 0 : result.exportBundle;
};
const exportCredential = (_c) => __awaiter$1(void 0, [_c], void 0, function* ({ user, wallet, environmentId, address, }) {
    const { connector, turnkeyHDWalletId, privateKeyId, organizationId } = handleExportInitCheck({
        user,
        wallet,
    });
    const turnkeyExportHandler = connector.getExportHandler();
    const targetPublicKey = turnkeyExportHandler.publicKey;
    if (!targetPublicKey) {
        throw new DynamicError('Must initialize export first', ERROR_PROCESSING_REVEAL_REQUEST);
    }
    // calls turnkey export api
    let newActivity;
    if (turnkeyHDWalletId) {
        newActivity = yield turnkeyExportHandler.exportWallet({
            address,
            organizationId,
            walletId: turnkeyHDWalletId,
        });
    }
    else if (privateKeyId) {
        newActivity = yield turnkeyExportHandler.exportPrivateKey({
            organizationId,
            privateKeyId,
        });
    }
    const activityId = newActivity.id;
    const activityStatus = newActivity.status;
    let exportBundle;
    if (activityStatus === 'ACTIVITY_STATUS_COMPLETED') {
        exportBundle = extractExportBundle({
            activity: newActivity,
            address,
            privateKeyId,
        });
    }
    else {
        const res = yield exportEmbeddedWallet({
            activityId,
            environmentId,
            walletId: (wallet === null || wallet === void 0 ? void 0 : wallet.id) || '',
        });
        exportBundle = res === null || res === void 0 ? void 0 : res.exportBundle;
    }
    if (!exportBundle) {
        throw new DynamicError('Invalid export response', ERROR_PROCESSING_REVEAL_REQUEST);
    }
    if (address || privateKeyId) {
        return turnkeyExportHandler.verifyExportPrivateKey({
            chain: wallet === null || wallet === void 0 ? void 0 : wallet.chain,
            exportBundle,
            organizationId,
        });
    }
    return turnkeyExportHandler.verifyExportWallet({
        exportBundle,
        organizationId,
    });
});
const cleanupExport = (_d) => __awaiter$1(void 0, [_d], void 0, function* ({ wallet }) {
    var _e;
    const connector = wallet === null || wallet === void 0 ? void 0 : wallet.connector;
    // clear iframeStamper and its reference
    (_e = connector === null || connector === void 0 ? void 0 : connector.getExportHandler()) === null || _e === void 0 ? void 0 : _e.clear();
});

const validateTurnkeyProviderEnabled = (projectSettings) => {
    const isTurnkeyProviderEnabled = isTurnkeyEnabled(projectSettings);
    if (!isTurnkeyProviderEnabled) {
        throw new DynamicError('No embedded wallet is enabled. Go to the dashboard and make sure to have both Embedded wallets and at least one EVM network enabled. Also, check if EthereumWalletConnectors is in the DynamicContextProvider > settings > walletConnectors.', SECURE_ENCLAVE_PROVIDER_NOT_ENABLED);
    }
    return isTurnkeyProviderEnabled;
};

const getNewVerifiedCredentialsFromDiff = (verifiedCredentialsA, verifiedCredentialsB) => {
    const knownIds = verifiedCredentialsA.map((vc) => vc.id);
    return verifiedCredentialsB.filter((vc) => !knownIds.includes(vc.id));
};

const createEmbeddedWalletRequest = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ user, walletConnector, environmentId, chains, sessionPublicKey, webAuthnAttestation, withAuthenticator, }) {
    if (!walletConnector) {
        throw new DynamicError('Connector is missing. Please make sure you added EthereumWalletConnectors and/or SolanaWalletConnectors to DynamicProvider settings');
    }
    if (!user) {
        throw new DynamicError('User is not defined');
    }
    walletConnector.setEmail(user.email);
    let authenticatorBody;
    if (withAuthenticator || webAuthnAttestation !== undefined) {
        if (!user.email) {
            addPasskeyIdentifierToWalletConnector(walletConnector, user);
        }
        const { attestation, challenge, displayName } = webAuthnAttestation || (yield walletConnector.getWebAuthnAttestation());
        authenticatorBody = {
            attestation: attestation,
            challenge,
            passkeyAlias: displayName,
        };
    }
    const updatedUser = yield createTurnkeyEmbeddedWallet(Object.assign({ chains,
        environmentId,
        sessionPublicKey }, authenticatorBody));
    if (!updatedUser) {
        throw new DynamicError('Failed to create embedded wallet');
    }
    const primaryChain = walletConnector.connectedChain;
    const embeddedWalletVerifiedCredential = findEmbeddedWalletFromVerifiedCredentials(updatedUser, [primaryChain]);
    if (!embeddedWalletVerifiedCredential) {
        throw new DynamicError('EmbeddedWalletVerifiedCredential not found');
    }
    walletConnector.setVerifiedCredentials(updatedUser.verifiedCredentials);
    return {
        embeddedWalletVerifiedCredential,
        updatedUser,
        walletConnector,
    };
});

const findPasskeyEmailWalletConnector = (wallets, chain) => {
    const walletConnector = wallets
        .map(({ walletConnector }) => walletConnector)
        .find((walletConnector) => isPasskeyWalletConnector(walletConnector) &&
        isEmailWalletConnector(walletConnector) &&
        walletConnector.connectedChain === chain);
    return walletConnector;
};

// assumes `account` input is a smart wallet (has a signerRefId) and attempts to find
// the associated eoa account
const findOwner = (account, verifiedCredentials) => verifiedCredentials.find((credential) => credential.id === account.signerRefId);
const findSmartWallet = (account, verifiedCredentials) => verifiedCredentials.find((credential) => credential.signerRefId === account.id);
const isOwnerOfASmartWallet = (account, verifiedCredentials) => Boolean(findSmartWallet(account, verifiedCredentials));
const initializeSmartWallet = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ account, verifiedCredentials, walletConnectorOptions, primaryWalletId, }) {
    var _b, _c, _d, _e, _f;
    const owner = findOwner(account, verifiedCredentials);
    if (!owner) {
        throw new Error('could not find associated eoa account for smart wallet');
    }
    const ownerWallet = findWalletOptionFor(owner, walletConnectorOptions);
    if (!ownerWallet) {
        throw new Error('could not find owner wallet from wallet options');
    }
    if (ownerWallet && isTurnkeyWalletConnector(ownerWallet.walletConnector)) {
        const sortedVcs = (_c = (_b = ownerWallet.walletConnector) === null || _b === void 0 ? void 0 : _b.verifiedCredentials) === null || _c === void 0 ? void 0 : _c.reduce((acc, vc) => {
            if (vc.smartWalletRefAddress &&
                account.address &&
                account.chain &&
                isSameAddress(vc.smartWalletRefAddress, account.address, VerifiedCredentialNameToChainEnum[account.chain])) {
                return [vc, ...acc];
            }
            return [...acc, vc];
        }, []);
        if (sortedVcs) {
            ownerWallet.walletConnector.setVerifiedCredentials(sortedVcs);
        }
    }
    const smartWallet = findWalletOptionFor(account, walletConnectorOptions);
    if (!smartWallet) {
        throw new Error('could not find smart wallet from wallet options');
    }
    const connector = smartWallet.walletConnector;
    if (!isAccountAbstractionConnector(connector)) {
        throw new Error('could not initialize smart wallet');
    }
    if (!owner.address || !account.address) {
        throw new Error('could not find owner or smart wallet address');
    }
    const shouldSetEoaConnector = primaryWalletId === owner.id || primaryWalletId === account.id;
    yield connector.registerEoa({
        ecdsaProviderType: (_d = account.walletProperties) === null || _d === void 0 ? void 0 : _d.ecdsaProviderType,
        entryPointVersion: (_e = account.walletProperties) === null || _e === void 0 ? void 0 : _e.entryPointVersion,
        eoaAddress: owner.address,
        eoaConnector: ownerWallet.walletConnector,
        kernelVersion: (_f = account.walletProperties) === null || _f === void 0 ? void 0 : _f.kernelVersion,
        shouldSetEoaConnector,
        smartWalletAddress: account.address,
    });
});

// This hook needs to be async that's why it's not using useMutation
const useCreateDynamicEmbeddedWalletMutation = () => {
    var _a, _b;
    const { user, setShowAuthFlow, projectSettings, environmentId } = useInternalDynamicContext();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState();
    const { getSessionPublicKey, shouldRegisterSessionKeysOnSignin } = useEmbeddedWalletSessionKeys({
        environmentId,
        projectSettings,
    });
    const embeddedChainConfig = ((_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _a === void 0 ? void 0 : _a.embeddedWallets) === null || _b === void 0 ? void 0 : _b.chainConfigurations) || [];
    const primaryEmbeddedChain = findPrimaryEmbeddedChain(projectSettings);
    const embeddedChains = embeddedChainConfig
        .filter((chain) => chain.enabled)
        .map((c) => c.name === 'SOL'
        ? EmbeddedWalletChainEnum.Sol
        : EmbeddedWalletChainEnum.Evm);
    const createDynamicEmbeddedWalletMutation = useCallback((_c) => __awaiter$1(void 0, [_c], void 0, function* ({ environmentId, walletConnectorOptions, withAuthenticator, options, chains, }) {
        var _d, _e;
        setIsLoading(true);
        if (!user) {
            throw new DynamicError(USER_NOT_LOGGED_IN);
        }
        let sessionPublicKey;
        // get the session public key that was created in the login/signup flow
        if (shouldRegisterSessionKeysOnSignin()) {
            sessionPublicKey = getSessionPublicKey();
        }
        try {
            const { embeddedWalletVerifiedCredential, updatedUser, walletConnector, } = yield createEmbeddedWalletRequest({
                chains: chains !== null && chains !== void 0 ? chains : embeddedChains,
                environmentId,
                sessionPublicKey,
                user,
                walletConnector: findPasskeyEmailWalletConnector(walletConnectorOptions, primaryEmbeddedChain),
                webAuthnAttestation: options === null || options === void 0 ? void 0 : options.webAuthnAttestation,
                withAuthenticator,
            });
            const turnkeyVerifiedCredentials = (_d = updatedUser.verifiedCredentials) === null || _d === void 0 ? void 0 : _d.find(({ walletName }) => walletName === null || walletName === void 0 ? void 0 : walletName.startsWith('turnkey'));
            /** It's not authenticated if it's a turnkey wallet that still hasn't created a passkey */
            const isAuthenticated = Boolean((_e = turnkeyVerifiedCredentials === null || turnkeyVerifiedCredentials === void 0 ? void 0 : turnkeyVerifiedCredentials.walletProperties) === null || _e === void 0 ? void 0 : _e.isAuthenticatorAttached);
            const embeddedWallet = walletConnector.createWallet({
                address: (yield walletConnector.getAddress()) || '',
                chain: walletConnector.connectedChain,
                connector: walletConnector,
                id: embeddedWalletVerifiedCredential.id,
                isAuthenticated,
                key: embeddedWalletVerifiedCredential.walletName || walletConnector.key,
            });
            const smartWallet = findSmartWallet(embeddedWalletVerifiedCredential, updatedUser.verifiedCredentials);
            if (!smartWallet) {
                updatePrimaryWalletId(embeddedWalletVerifiedCredential.id);
            }
            else {
                yield initializeSmartWallet({
                    account: smartWallet,
                    primaryWalletId: smartWallet.id,
                    verifiedCredentials: updatedUser.verifiedCredentials,
                    walletConnectorOptions,
                });
                updatePrimaryWalletId(smartWallet.id);
            }
            dynamicEvents.emit('embeddedWalletCreated', embeddedWallet, turnkeyVerifiedCredentials, updatedUser);
            setShowAuthFlow(false, { performMultiWalletChecks: false });
        }
        catch (err) {
            logger$1.error('Failed to create embedded wallet', err);
            setError(err);
            dynamicEvents.emit('embeddedWalletFailed', err);
        }
        finally {
            setIsLoading(false);
        }
    }), [
        embeddedChains,
        primaryEmbeddedChain,
        setShowAuthFlow,
        user,
        getSessionPublicKey,
        shouldRegisterSessionKeysOnSignin,
    ]);
    return {
        createDynamicEmbeddedWalletMutation,
        error,
        isLoading,
    };
};

// Hook exposed to customers and used internally to trigger embedded wallet creation
const useTurnkey = () => {
    const { projectSettings, walletConnectorOptions, setShowAuthFlow, environmentId, user, primaryWallet, } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const { createDynamicEmbeddedWalletMutation } = useCreateDynamicEmbeddedWalletMutation();
    const { getEOAWallet } = useSmartWallets();
    const startHeadlessEmbeddedWalletCreationFlow = useCallback((chains, options) => __awaiter$1(void 0, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            // register the event listeners before calling create embedded wallet
            // as the event might fire before the listeners are registered.
            dynamicEvents.once('embeddedWalletCreated', (wallet) => {
                resolve(wallet);
            });
            dynamicEvents.once('embeddedWalletFailed', (error) => reject(error));
            createDynamicEmbeddedWalletMutation({
                chains,
                environmentId,
                options,
                walletConnectorOptions,
                withAuthenticator: false,
            })
                .then(() => {
                setShowAuthFlow(false, { performMultiWalletChecks: false }); // close email otp pin modal
            })
                .catch((error) => {
                reject(error);
            });
        });
    }), [
        createDynamicEmbeddedWalletMutation,
        environmentId,
        walletConnectorOptions,
        setShowAuthFlow,
    ]);
    const startPasskeyEmbeddedWalletCreationFlow = useCallback((chains) => __awaiter$1(void 0, void 0, void 0, function* () {
        setShowAuthFlow(true, {
            ignoreIfIsEmbeddedWidget: false,
            performMultiWalletChecks: false,
        });
        pushView('passkey-intro', { chains });
        return new Promise((resolve, reject) => {
            dynamicEvents.once('embeddedWalletCreated', (wallet) => resolve(wallet));
            dynamicEvents.once('embeddedWalletFailed', (error) => {
                // when creating a passkey, if user cancels the passkey modal more than once
                // it will throw this DOMException, but we don't want to let user to have access
                // to the app before they've a passkey correctly setup
                if (error instanceof DOMException &&
                    error.name === 'NotAllowedError') {
                    logger$1.error('User cancelled the passkey creation.', error);
                    return;
                }
                reject(error);
            });
        });
    }), [setShowAuthFlow, pushView]);
    const returnEmbeddedWallet = useCallback((embeddedWalletVerifiedCredential) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a, _b;
        const { chain } = embeddedWalletVerifiedCredential;
        const turnkeyWallet = findTurnkeyWalletByChain(walletConnectorOptions, chain);
        let newPrimaryWalletId = null;
        // if user already has embedded wallet, set it as primary wallet
        if (user) {
            (_a = turnkeyWallet === null || turnkeyWallet === void 0 ? void 0 : turnkeyWallet.walletConnector) === null || _a === void 0 ? void 0 : _a.setVerifiedCredentials(user.verifiedCredentials);
            const smartWallet = findSmartWallet(embeddedWalletVerifiedCredential, user.verifiedCredentials);
            if (smartWallet) {
                yield initializeSmartWallet({
                    account: smartWallet,
                    primaryWalletId: smartWallet.id,
                    verifiedCredentials: user.verifiedCredentials,
                    walletConnectorOptions,
                });
                newPrimaryWalletId = smartWallet.id;
            }
            else {
                newPrimaryWalletId = embeddedWalletVerifiedCredential.id;
            }
        }
        if (newPrimaryWalletId) {
            updatePrimaryWalletId(newPrimaryWalletId);
        }
        /** It's not authenticated if it still hasn't created a passkey */
        const isAuthenticated = Boolean((_b = embeddedWalletVerifiedCredential.walletProperties) === null || _b === void 0 ? void 0 : _b.isAuthenticatorAttached);
        if (!(turnkeyWallet === null || turnkeyWallet === void 0 ? void 0 : turnkeyWallet.walletConnector)) {
            throw new Error('Could not find the embedded wallet connector');
        }
        const connector = turnkeyWallet.walletConnector;
        const passkeyWallet = connector.createWallet({
            address: (yield connector.getAddress()) || '',
            chain: connector.connectedChain,
            connector,
            id: embeddedWalletVerifiedCredential.id,
            isAuthenticated,
            key: embeddedWalletVerifiedCredential.walletName || connector.key || '',
        });
        return Promise.resolve(passkeyWallet);
    }), [walletConnectorOptions, user]);
    const createTurnkeyWallet = useCallback((chains, options) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _c, _d, _e, _f, _g, _h;
        if (!user) {
            throw new Error(USER_NOT_LOGGED_IN);
        }
        const isManualMode = ((_c = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _c === void 0 ? void 0 : _c.automaticEmbeddedWalletCreation) === false;
        const shouldCreateV2WalletsByDefault = ((_d = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _d === void 0 ? void 0 : _d.defaultWalletVersion) ===
            EmbeddedWalletVersionEnum.V2;
        const primaryChain = findPrimaryEmbeddedChain(projectSettings);
        // if embedded wallet already exists
        // get the one with the primary chain if `chains` is undefined
        const embeddedWalletVerifiedCredential = findEmbeddedWalletFromVerifiedCredentials(user, chains !== null && chains !== void 0 ? chains : [primaryChain]);
        const userWalletsCredentials = getUserWalletsFromVerifiedCredentials(user);
        // If the user doesn't have a wallet, or if the customer is in Manual
        // Mode, we should attempt to create a new wallet. Note that if in manual
        // mode, the check for the existance of an embedded wallet was arbitrarily
        // added as a safeguard given the pre-existing condition we're overriding.
        if (!(userWalletsCredentials === null || userWalletsCredentials === void 0 ? void 0 : userWalletsCredentials.length) ||
            (!embeddedWalletVerifiedCredential && isManualMode)) {
            const hasEmailVC = getUserVerifiedCredentialType(user, JwtVerifiedCredentialFormatEnum.Email);
            if ((!((_e = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _e === void 0 ? void 0 : _e.forceAuthenticatorAtSignup) &&
                hasEmailVC) ||
                (options === null || options === void 0 ? void 0 : options.webAuthnAttestation) ||
                shouldCreateV2WalletsByDefault) {
                // create embedded wallet fully headless
                return startHeadlessEmbeddedWalletCreationFlow(chains, options);
            }
            else {
                // show the passkey view to create an embedded wallet
                return startPasskeyEmbeddedWalletCreationFlow(chains);
            }
        }
        else {
            // the pregenerated wallet must have been created at this point in the
            // backend if this called as part of a new user sign up.
            if (embeddedWalletVerifiedCredential &&
                user.newUser &&
                ((_f = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _f === void 0 ? void 0 : _f.automaticEmbeddedWalletCreation)) {
                const walletConnector = findPasskeyEmailWalletConnector(walletConnectorOptions, primaryChain);
                if (!walletConnector) {
                    throw new Error('Could not find the embedded wallet connector');
                }
                const wallet = walletConnector.createWallet({
                    address: (yield walletConnector.getAddress()) || '',
                    chain: walletConnector.connectedChain,
                    connector: walletConnector,
                    id: embeddedWalletVerifiedCredential.id,
                    isAuthenticated: Boolean((_g = embeddedWalletVerifiedCredential === null || embeddedWalletVerifiedCredential === void 0 ? void 0 : embeddedWalletVerifiedCredential.walletProperties) === null || _g === void 0 ? void 0 : _g.isAuthenticatorAttached),
                    key: (_h = embeddedWalletVerifiedCredential.walletName) !== null && _h !== void 0 ? _h : walletConnector.key,
                });
                updatePrimaryWalletId(embeddedWalletVerifiedCredential.id);
                dynamicEvents.emit('embeddedWalletCreated', wallet, embeddedWalletVerifiedCredential, user);
            }
        }
        setShowAuthFlow(false, { performMultiWalletChecks: false });
        // if user logged in with MM for example, just continue the flow
        if (!embeddedWalletVerifiedCredential) {
            throw new Error('Primary wallet is not an embedded wallet');
        }
        // if user already has embedded wallet, returns it
        return returnEmbeddedWallet(embeddedWalletVerifiedCredential);
    }), [
        user,
        projectSettings,
        primaryWallet,
        getEOAWallet,
        setShowAuthFlow,
        returnEmbeddedWallet,
        startHeadlessEmbeddedWalletCreationFlow,
        startPasskeyEmbeddedWalletCreationFlow,
        walletConnectorOptions,
    ]);
    return {
        createTurnkeyWallet,
    };
};

const isConnectorSessionKeyActive = (connector) => {
    var _a;
    if (!connector || !isSessionKeyCompatibleWalletConnector(connector))
        return false;
    return Boolean((_a = connector.sessionKeys) === null || _a === void 0 ? void 0 : _a.publicKey);
};
// Hook exposed to customers
/**
 *
 * @returns {
 * createEmbeddedWallet, - creates Secure enclave embedded wallet according to the settings
 * createOrRestoreSession, - creates or restores a embedded wallet session
 * createPasskey, - creates a new passkey both for an existing wallet or a wallet to be created
 * getPasskeys, - gets all passkeys for the user
 * isLoadingEmbeddedWallet, - loading state of the embedded wallet
 * isSessionActive, - checks if the embedded wallet session is active
 * revealEmbeddedWalletKey - export the recovery phrase or private key of the embedded wallet
 * sendOneTimeCode, - sends a one-time code to the user so they can create a session or add a new passkey
 * userHasEmbeddedWallet, - checks if the user has an embedded wallet
 * }
 */
const useSecureEnclaveEmbeddedWallet = () => {
    var _a, _b, _c, _d, _e;
    const { projectSettings, primaryWallet, user, environmentId, walletConnectorOptions, } = useInternalDynamicContext();
    const { addedWalletsIds } = useInternalUserWallets();
    const { createTurnkeyWallet } = useTurnkey();
    const { hasRecoveryEmail } = useIsTurnkeyWallet();
    const { createRootElement } = useElementById();
    const { isLoadingEmbeddedWallet, setIsLoadingEmbeddedWallet } = useWalletContext();
    const { getEOAWallet } = useSmartWallets();
    const wallet = (_a = (primaryWallet && getEOAWallet(primaryWallet))) !== null && _a !== void 0 ? _a : primaryWallet;
    const userHasEmbeddedWallet = useCallback(() => hasEmbeddedWallet(user, 'turnkey'), [user]);
    const getWalletVersion = useCallback(() => {
        if (isSessionKeyCompatibleWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector)) {
            return EmbeddedWalletVersion.V2;
        }
        return EmbeddedWalletVersion.V1;
    }, [wallet === null || wallet === void 0 ? void 0 : wallet.connector]);
    const { shouldInitRecovery, initPasskeyRecoveryProcess } = usePasskeyRecovery();
    /**
     * Creates a new secure enclave embedded wallet according to the settings from the dashboard
     * @param chain - optional chain parameter to create the wallet for
     * @param options - optional parameter contained more settings for the wallet creation
     * @returns Promise<Wallet | undefined>
     */
    const createEmbeddedWallet = useCallback((chains, options) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _f;
        if (!user) {
            throw new DynamicError(USER_NOT_LOGGED_IN);
        }
        const userWalletsCredentials = getUserWalletsFromVerifiedCredentials(user);
        const primaryChain = findPrimaryEmbeddedChain(projectSettings);
        const embeddedWalletVerifiedCredential = findEmbeddedWalletFromVerifiedCredentials(user, chains !== null && chains !== void 0 ? chains : [primaryChain]);
        const isManualMode = ((_f = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _f === void 0 ? void 0 : _f.automaticEmbeddedWalletCreation) === false;
        // if user has a wallet and it's not embedded,
        // throw error to follow another flow and set up the right wallet
        // However, if the user is in manual mode continue.
        if ((userWalletsCredentials === null || userWalletsCredentials === void 0 ? void 0 : userWalletsCredentials.length) &&
            !embeddedWalletVerifiedCredential &&
            !isManualMode) {
            throw new EmbeddedWalletException('User already has a linked branded wallet, and manual mode creation is not enabled.');
        }
        validateTurnkeyProviderEnabled(projectSettings);
        // TEMP: immediately disable loading state
        setIsLoadingEmbeddedWallet(false);
        return createTurnkeyWallet(chains, options);
    }), [createTurnkeyWallet, projectSettings, setIsLoadingEmbeddedWallet, user]);
    /**
     * Creates a new secure enclave embedded wallet account
     * @param chain - chain parameter to create the wallet for
     * @returns Promise<UserProfile | undefined>
     */
    const createEmbeddedWalletAccount$1 = useCallback((_g) => __awaiter$1(void 0, [_g], void 0, function* ({ chain }) {
        var _h, _j, _k;
        if (!user) {
            throw new Error(USER_NOT_LOGGED_IN);
        }
        validateTurnkeyProviderEnabled(projectSettings);
        const primaryChain = findPrimaryEmbeddedChain(projectSettings);
        const embeddedWalletVerifiedCredential = findEmbeddedWalletFromVerifiedCredentials(user, [primaryChain]);
        const turnkeyWalletId = (_h = embeddedWalletVerifiedCredential === null || embeddedWalletVerifiedCredential === void 0 ? void 0 : embeddedWalletVerifiedCredential.walletProperties) === null || _h === void 0 ? void 0 : _h.turnkeyHDWalletId;
        if (!turnkeyWalletId) {
            throw new DynamicError('No HD wallet was found for this user to derive a wallet account. Use createEmbeddedWallet first', 'NoHdWalletFound');
        }
        const requestToStamp = yield getCreateEmbeddedWalletAccountRequest({
            chain,
            environmentId,
        });
        if (isSessionKeyCompatibleWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector)) {
            yield ((_j = wallet === null || wallet === void 0 ? void 0 : wallet.connector) === null || _j === void 0 ? void 0 : _j.createOrRestoreSession({
                ignoreRestore: true,
            }));
        }
        else if (yield shouldInitRecovery()) {
            yield initPasskeyRecoveryProcess('email');
        }
        const signedRequest = yield ((_k = wallet === null || wallet === void 0 ? void 0 : wallet.connector) === null || _k === void 0 ? void 0 : _k.stampCreateWalletAccountRequest({
            request: requestToStamp,
        }));
        const verifiedUser = yield createEmbeddedWalletAccount({
            createEmbeddedWalletAccountRequest: signedRequest,
            environmentId,
        });
        const newWalletIds = getNewVerifiedCredentialsFromDiff(user.verifiedCredentials, verifiedUser.user.verifiedCredentials)
            .filter(({ format }) => format === JwtVerifiedCredentialFormatEnum.Blockchain)
            .map(({ id }) => id);
        addedWalletsIds.current = addedWalletsIds.current.concat(newWalletIds);
        return refreshUserJwt({ environmentId });
    }), [
        environmentId,
        wallet === null || wallet === void 0 ? void 0 : wallet.connector,
        initPasskeyRecoveryProcess,
        projectSettings,
        shouldInitRecovery,
        user,
        addedWalletsIds,
    ]);
    /**
     * Creates or restores a secure enclave embedded wallet session
     * If it detects that the session is possible to be restored, it will restore it
     * @param oneTimeCode - optional one-time code parameter. If not informed it tries to restore a session
     * @returns Promise<'session_created' | 'session_restored'> - returns a string indicating the status of the session
     */
    const createOrRestoreSession = useCallback((options) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _l, _m, _o, _p, _q, _r;
        if (!user) {
            throw new DynamicError(USER_NOT_LOGGED_IN);
        }
        const primaryConnector = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector;
        if (primaryConnector &&
            isSessionKeyCompatibleWalletConnector(primaryConnector)) {
            return primaryConnector.createOrRestoreSession();
        }
        const eoaConnector = wallet === null || wallet === void 0 ? void 0 : wallet.connector;
        if (eoaConnector && isSessionKeyCompatibleWalletConnector(eoaConnector)) {
            return eoaConnector.createOrRestoreSession();
        }
        const turnkeyRecoveryHandler = getEmbeddedWalletAuthHandler(wallet === null || wallet === void 0 ? void 0 : wallet.connector);
        if (turnkeyRecoveryHandler.isSessionActive()) {
            return ACTIVE_SESSION;
        }
        const turnkeyAuthIframeContainerRef = createRootElement(iframeContainerId$2);
        // try to restore session if possible
        if (canRestoreEmbeddedWalletSession((_l = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _l === void 0 ? void 0 : _l.sessionKeyDuration)) {
            try {
                const sessionRestored = yield restoreEmbeddedWalletSession({
                    iframeContainer: turnkeyAuthIframeContainerRef.current,
                    iframeElementId: iframeElementId$2,
                    sessionExpiration: getEmbeddedWalletSessionExpiration((_o = (_m = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _m === void 0 ? void 0 : _m.embeddedWallets) === null || _o === void 0 ? void 0 : _o.sessionKeyDuration),
                    user,
                    wallet: primaryWallet,
                });
                if (sessionRestored)
                    return SESSION_RESTORED;
            }
            catch (err) {
                logger$1.error('Failed to restore embedded wallet', err);
            }
        }
        if (!(options === null || options === void 0 ? void 0 : options.oneTimeCode)) {
            throw new DynamicError('One-time code is required to create a session.', INVALID_REQUEST);
        }
        // tries to create a new session with the informed one-time code
        // verify user has a turnkey wallet and email VC
        if (!userHasEmbeddedWallet() || !hasRecoveryEmail) {
            throw new DynamicError('User does not have a secure enclave wallet or a verified email', INVALID_WALLET_DATA);
        }
        const organizationId = (_r = (_q = (_p = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _p === void 0 ? void 0 : _p.find(({ walletName }) => walletName === null || walletName === void 0 ? void 0 : walletName.startsWith('turnkey'))) === null || _q === void 0 ? void 0 : _q.walletProperties) === null || _r === void 0 ? void 0 : _r.turnkeySubOrganizationId;
        yield turnkeyRecoveryHandler.verifyRecoveryCode(options.oneTimeCode, organizationId);
        const sessionSettings = {
            createdAt: new Date().getTime(),
            emailCode: options.oneTimeCode,
            userId: turnkeyRecoveryHandler.recoveryUserId,
        };
        StorageService.setItem(EMBEDDED_WALLET_SESSION_SETTINGS, sessionSettings);
        return SESSION_CREATED;
    }), [
        createRootElement,
        user,
        hasRecoveryEmail,
        primaryWallet,
        (_c = (_b = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _b === void 0 ? void 0 : _b.embeddedWallets) === null || _c === void 0 ? void 0 : _c.sessionKeyDuration,
        userHasEmbeddedWallet,
        wallet === null || wallet === void 0 ? void 0 : wallet.connector,
    ]);
    /**
     * Creates a new passkey both for an existing wallet or a wallet to be created
     * @param options - optional parameter to inform a one-time code to create a session,
     * @returns Promise<WebAuthnAttestation>
     */
    const createPasskey = useCallback((options) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _s, _t;
        if (!user) {
            throw new DynamicError(USER_NOT_LOGGED_IN);
        }
        validateTurnkeyProviderEnabled(projectSettings);
        const turnkeyWallet = findTurnkeyWalletByPrimaryChain(walletConnectorOptions, (_s = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _s === void 0 ? void 0 : _s.chainConfigurations, user.verifiedCredentials);
        if (!(turnkeyWallet === null || turnkeyWallet === void 0 ? void 0 : turnkeyWallet.walletConnector)) {
            throw new DynamicError('Wallet connector not found', INVALID_WALLET_DATA);
        }
        const walletConnector = turnkeyWallet.walletConnector;
        walletConnector.setEmail(user === null || user === void 0 ? void 0 : user.email);
        if (user && !(user === null || user === void 0 ? void 0 : user.email)) {
            addPasskeyIdentifierToWalletConnector(walletConnector, user);
        }
        const hasEmailVC = getUserVerifiedCredentialType(user, JwtVerifiedCredentialFormatEnum.Email);
        // return a new passkey if the user doesn't have a wallet yet or
        // none of the requirements to add a passkey to an existing wallet are met
        if (!('id' in turnkeyWallet) || !hasEmailVC) {
            return walletConnector.getWebAuthnAttestation();
        }
        const turnkeySubOrganizationId = (_t = turnkeyWallet === null || turnkeyWallet === void 0 ? void 0 : turnkeyWallet.walletProperties) === null || _t === void 0 ? void 0 : _t.turnkeySubOrganizationId;
        if (!turnkeySubOrganizationId) {
            throw new DynamicError('No sub organization id found for the wallet', INVALID_WALLET_DATA);
        }
        const turnkAuthenticatorHandler = getEmbeddedWalletAuthHandler(walletConnector);
        // add new passkey to the wallet through an active session
        yield createOrRestoreSession(options);
        const { attestation, challenge, displayName } = yield walletConnector.getWebAuthnAttestation();
        yield turnkAuthenticatorHandler.addPasskeyAuthenticator({
            attestation,
            challenge,
            turnkeySubOrganizationId,
        });
        const updatedUser = yield completePasskeyRecovery$1({
            attestation: attestation,
            challenge,
            environmentId,
            walletId: turnkeyWallet === null || turnkeyWallet === void 0 ? void 0 : turnkeyWallet.id,
        });
        if (!updatedUser) {
            throw new DynamicError('Error completing passkey recovery');
        }
        return { attestation, challenge, displayName };
    }), [
        createOrRestoreSession,
        environmentId,
        projectSettings,
        user,
        walletConnectorOptions,
    ]);
    /**
     * Gets all passkeys for the user
     * @returns Promise<Passkey[]>
     */
    const getPasskeys = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!user) {
            throw new DynamicError(USER_NOT_LOGGED_IN);
        }
        const data = yield getUserPasskeys({
            environmentId: environmentId,
        });
        return data.passkeys;
    }), [user, environmentId]);
    const isEmailAuthSessionActive = useMemo(() => {
        var _a;
        const eoaConnector = wallet === null || wallet === void 0 ? void 0 : wallet.connector;
        if (!eoaConnector || !('getAuthenticatorHandler' in eoaConnector))
            return false;
        return (_a = getEmbeddedWalletAuthHandler(eoaConnector)) === null || _a === void 0 ? void 0 : _a.isSessionActive();
    }, [wallet === null || wallet === void 0 ? void 0 : wallet.connector]);
    const isSessionKeySessionAAActive = useMemo(() => isConnectorSessionKeyActive(wallet === null || wallet === void 0 ? void 0 : wallet.connector), [wallet === null || wallet === void 0 ? void 0 : wallet.connector]);
    const isSessionKeySessionActive = useMemo(() => isConnectorSessionKeyActive(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector), [primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector]);
    /**
     * Checks if the embedded wallet session is active
     */
    const isSessionActive = isEmailAuthSessionActive ||
        isSessionKeySessionActive ||
        isSessionKeySessionAAActive;
    /**
     * export the recovery phrase or private key of the embedded wallet
     * @param options - optional parameter object containing the type of key to reveal 'recoveryPhrase' | 'privateKey'
     * and the html container id to render the iframe into
     * @returns Promise<string> - returns the embedded wallet recovery phrase or private key
     */
    const revealEmbeddedWalletKey = useCallback((_u) => __awaiter$1(void 0, [_u], void 0, function* ({ type, htmlContainerId, }) {
        var _v, _w, _x, _y, _z, _0;
        if (!user) {
            throw new DynamicError(USER_NOT_LOGGED_IN);
        }
        yield cleanupExport({
            wallet: wallet,
        });
        const turnkeyWallet = findTurnkeyWalletByPrimaryChain(walletConnectorOptions, (_v = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _v === void 0 ? void 0 : _v.chainConfigurations, user === null || user === void 0 ? void 0 : user.verifiedCredentials);
        const turnkeyHDWalletId = (_w = turnkeyWallet === null || turnkeyWallet === void 0 ? void 0 : turnkeyWallet.walletProperties) === null || _w === void 0 ? void 0 : _w.turnkeyHDWalletId;
        if (type === 'recoveryPhrase' && !turnkeyHDWalletId) {
            type = 'privateKey';
        }
        const iframeContainerElement = createRootElement(revealIframeElementId, htmlContainerId || revealIframeContainerId);
        // hide the iframe container until the export is done
        // since it will show unrelated turnkey content
        iframeContainerElement.current.style.display = 'none';
        if (isSessionKeyCompatibleWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector)) {
            yield ((_x = wallet === null || wallet === void 0 ? void 0 : wallet.connector) === null || _x === void 0 ? void 0 : _x.createOrRestoreSession());
        }
        yield initExport({
            iframeContainer: iframeContainerElement.current,
            iframeElementId: revealIframeElementId,
            wallet: wallet,
        });
        try {
            yield exportCredential({
                address: type === 'privateKey' ? wallet === null || wallet === void 0 ? void 0 : wallet.address : undefined,
                environmentId,
                user,
                wallet: wallet,
            });
        }
        catch (_1) {
            if (isSessionKeyCompatibleWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector) &&
                ((_y = wallet === null || wallet === void 0 ? void 0 : wallet.connector) === null || _y === void 0 ? void 0 : _y.removeSessionKeys)) {
                yield ((_z = wallet === null || wallet === void 0 ? void 0 : wallet.connector) === null || _z === void 0 ? void 0 : _z.removeSessionKeys());
                yield ((_0 = wallet === null || wallet === void 0 ? void 0 : wallet.connector) === null || _0 === void 0 ? void 0 : _0.createOrRestoreSession({
                    ignoreRestore: true,
                }));
            }
            yield exportCredential({
                address: type === 'privateKey' ? wallet === null || wallet === void 0 ? void 0 : wallet.address : undefined,
                environmentId,
                user,
                wallet: wallet,
            });
        }
        // show the iframe container after the export is done
        // to show the exported content only
        iframeContainerElement.current.style.display = 'block';
        return true;
    }), [
        createRootElement,
        environmentId,
        wallet,
        (_e = (_d = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _d === void 0 ? void 0 : _d.embeddedWallets) === null || _e === void 0 ? void 0 : _e.chainConfigurations,
        user,
        walletConnectorOptions,
    ]);
    /**
     * Sends a one-time code to the user so they can create a session or add a new passkey
     * @returns Promise<'code_sent'>
     */
    const sendOneTimeCode = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        var _2, _3;
        if (!user) {
            throw new DynamicError(USER_NOT_LOGGED_IN);
        }
        const targetTurnkeyWallet = findTurnkeyWalletByPrimaryChain(walletConnectorOptions, (_2 = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _2 === void 0 ? void 0 : _2.chainConfigurations, user.verifiedCredentials);
        if (!targetTurnkeyWallet || !('id' in targetTurnkeyWallet)) {
            throw new DynamicError('User does not have a valid secure enclave wallet', INVALID_WALLET_DATA);
        }
        const turnkeyAuthenticatorHandler = getEmbeddedWalletAuthHandler(targetTurnkeyWallet === null || targetTurnkeyWallet === void 0 ? void 0 : targetTurnkeyWallet.walletConnector);
        const targetTurnkeyWalletId = targetTurnkeyWallet.id;
        const isSessionActive = turnkeyAuthenticatorHandler.isSessionActive();
        if (isSessionActive) {
            throw new DynamicError('Session is active. No need to create a new one', ACTIVE_SESSION);
        }
        const turnkeyAuthIframeContainerRef = createRootElement(iframeContainerId$2);
        const publicKey = yield turnkeyAuthenticatorHandler.initRecovery('email', turnkeyAuthIframeContainerRef.current, iframeElementId$2, getEmbeddedWalletSessionExpiration((_3 = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _3 === void 0 ? void 0 : _3.sessionKeyDuration));
        if (!publicKey) {
            throw new DynamicError(ERROR_SENDING_CODE);
        }
        const response = yield initEmbeddedWalletSession$1({
            authenticatorType: 'email',
            environmentId,
            publicKey,
            walletId: targetTurnkeyWalletId,
        });
        turnkeyAuthenticatorHandler.recoveryUserId = response.turnkeyUserId;
        return CODE_SENT;
    }), [
        createRootElement,
        user,
        environmentId,
        projectSettings,
        walletConnectorOptions,
    ]);
    return useMemo(() => ({
        createEmbeddedWallet,
        createEmbeddedWalletAccount: createEmbeddedWalletAccount$1,
        createOrRestoreSession,
        createPasskey,
        getPasskeys,
        getWalletVersion,
        isLoadingEmbeddedWallet,
        isSessionActive,
        revealEmbeddedWalletKey,
        sendOneTimeCode,
        userHasEmbeddedWallet,
    }), [
        createEmbeddedWallet,
        createEmbeddedWalletAccount$1,
        createOrRestoreSession,
        createPasskey,
        getPasskeys,
        getWalletVersion,
        isLoadingEmbeddedWallet,
        isSessionActive,
        revealEmbeddedWalletKey,
        sendOneTimeCode,
        userHasEmbeddedWallet,
    ]);
};

// Hook exposed to customers and used internally to trigger embedded wallet creation
/**
 * @returns {
 *  createEmbeddedWallet, - creates Dynamic embedded wallet according to the settings
 *  createOrRestoreSession, - creates or restores session for the embedded wallet
 *  createPasskey, - creates passkey for the embedded wallet
 *  getPasskeys, - gets passkeys for the embedded wallet
 *  isLoadingEmbeddedWallet, - loading state of the embedded wallet
 *  isSessionActive, - checks if the session is active for the embedded wallet
 *  revealWalletKey, - reveals the private key or recovery phrase for the embedded wallet
 *  sendOneTimeCode, - sends one time code for the embedded wallet
 *  userHasEmbeddedWallet, - checks if the user has an embedded wallet
 * }
 */
const useEmbeddedWallet = () => {
    const { user, projectSettings } = useInternalDynamicContext();
    const { isTurnkeyWallet } = useIsTurnkeyWallet();
    const { createEmbeddedWallet: createTurnkeyEmbeddedWallet, createEmbeddedWalletAccount, createOrRestoreSession, createPasskey, revealEmbeddedWalletKey: revealTurnkeyEmbeddedWalletKey, getPasskeys, isSessionActive, sendOneTimeCode, getWalletVersion: getTurnkeyWalletVersion, } = useSecureEnclaveEmbeddedWallet();
    const { isLoadingEmbeddedWallet } = useWalletContext();
    const userHasEmbeddedWallet = useCallback(() => hasEmbeddedWallet(user), [user]);
    const getWalletVersion = useCallback(() => {
        if (!user) {
            throw new DynamicError(USER_NOT_LOGGED_IN);
        }
        if (!userHasEmbeddedWallet()) {
            throw new DynamicError('Embedded wallet not found');
        }
        if (isTurnkeyWallet) {
            return getTurnkeyWalletVersion();
        }
        return undefined;
    }, [getTurnkeyWalletVersion, isTurnkeyWallet, user, userHasEmbeddedWallet]);
    /**
     * Creates Dynamic embedded wallet according to the settings
     * @param chains - array of chains to create the wallet for
     * @param options - options for the wallet creation
     * @returns Promise<Wallet | undefined> - created wallet object
     */
    const createEmbeddedWallet = useCallback((chains, options) => __awaiter$1(void 0, void 0, void 0, function* () {
        const wallet = yield createTurnkeyEmbeddedWallet(chains, options);
        return wallet;
    }), [createTurnkeyEmbeddedWallet]);
    /**
     * Reveals the private key or recovery phrase for the embedded wallet
     * @param options - options for revealing the wallet key
     * @returns Promise<boolean> - true if the key was revealed successfully
     */
    const revealWalletKey = (options) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!user) {
            throw new DynamicError(USER_NOT_LOGGED_IN);
        }
        if (!userHasEmbeddedWallet()) {
            throw new DynamicError('Embedded wallet not found');
        }
        return revealTurnkeyEmbeddedWalletKey(options);
    });
    const shouldPromptForKeyExport = useCallback(() => { var _a; return Boolean((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _a === void 0 ? void 0 : _a.promptForKeyExport); }, [projectSettings]);
    const shouldAutoCreateEmbeddedWallet = useCallback((verifiedUser) => {
        var _a, _b, _c, _d, _e;
        const hasEmbeddedWalletProviderEnabled = isTurnkeyEnabled(projectSettings);
        const hasPrimaryWallet = getPrimaryWalletId();
        if (!hasEmbeddedWalletProviderEnabled || hasPrimaryWallet) {
            return false;
        }
        // Turnkey specific rules
        if (verifiedUser) {
            const primaryEmbeddedChain = findPrimaryEmbeddedChain(projectSettings);
            const embeddedWalletVerifiedCredentialId = (_a = findEmbeddedWalletFromVerifiedCredentials(verifiedUser, [
                primaryEmbeddedChain,
            ])) === null || _a === void 0 ? void 0 : _a.id;
            const AAWalletCredentialId = (_c = (_b = verifiedUser.verifiedCredentials) === null || _b === void 0 ? void 0 : _b.find((vc) => vc.walletProvider === WalletProviderEnum.SmartContractWallet)) === null || _c === void 0 ? void 0 : _c.id;
            const targetPrimaryWalletId = AAWalletCredentialId
                ? AAWalletCredentialId
                : embeddedWalletVerifiedCredentialId;
            if (targetPrimaryWalletId) {
                updatePrimaryWalletId(targetPrimaryWalletId);
                return false;
            }
        }
        if (isTurnkeyEnabled(projectSettings) &&
            !((_e = (_d = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _d === void 0 ? void 0 : _d.embeddedWallets) === null || _e === void 0 ? void 0 : _e.automaticEmbeddedWalletCreation)) {
            return false;
        }
        return true;
    }, [projectSettings]);
    return {
        createEmbeddedWallet,
        createEmbeddedWalletAccount,
        createOrRestoreSession,
        createPasskey,
        getPasskeys,
        getWalletVersion,
        isLoadingEmbeddedWallet,
        isSessionActive,
        revealWalletKey,
        sendOneTimeCode,
        shouldAutoCreateEmbeddedWallet,
        shouldPromptForKeyExport,
        userHasEmbeddedWallet,
    };
};

const PasskeyContext = createContext(undefined);
const PasskeyContextProviderWithBrowser = ({ children, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { userHasEmbeddedWallet } = useEmbeddedWallet();
    const { isSessionKeyCompatible, isTurnkeyWalletWithoutAuthenticator } = useIsTurnkeyWallet();
    const { environmentId, projectSettings, user } = useInternalDynamicContext();
    // state for when passkey list needs to re-render
    const [passkeyEdited, setPasskeyEdited] = useState(false);
    // states to pass into rename passkey popup
    const [passkey, setPasskey] = useState(undefined);
    const [passkeyIcon, setPasskeyIcon] = useState(undefined);
    const [_showSecureAccountBanner, setShowSecureAccountBanner] = useLocalStorage(EMBEDDED_WALLET_SECURE_BANNER, true);
    const showSecureAccountBanner = useMemo(() => {
        var _a, _b, _c, _d;
        const isPasskeyEnabled = Boolean((_d = (_c = (_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _a === void 0 ? void 0 : _a.embeddedWallets) === null || _b === void 0 ? void 0 : _b.supportedSecurityMethods) === null || _c === void 0 ? void 0 : _c.passkey) === null || _d === void 0 ? void 0 : _d.isEnabled);
        return (_showSecureAccountBanner !== false &&
            isTurnkeyWalletWithoutAuthenticator &&
            isPasskeyEnabled);
    }, [
        isTurnkeyWalletWithoutAuthenticator,
        _showSecureAccountBanner,
        (_d = (_c = (_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _a === void 0 ? void 0 : _a.embeddedWallets) === null || _b === void 0 ? void 0 : _b.supportedSecurityMethods) === null || _c === void 0 ? void 0 : _c.passkey) === null || _d === void 0 ? void 0 : _d.isEnabled,
    ]);
    const showAlert = useCallback(() => {
        var _a, _b, _c, _d;
        const isPasskeyEnabled = Boolean((_d = (_c = (_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _a === void 0 ? void 0 : _a.embeddedWallets) === null || _b === void 0 ? void 0 : _b.supportedSecurityMethods) === null || _c === void 0 ? void 0 : _c.passkey) === null || _d === void 0 ? void 0 : _d.isEnabled);
        const isPregeneratedWalletsWithPasskeyRequired = !showSecureAccountBanner &&
            isTurnkeyWalletWithoutAuthenticator &&
            isPasskeyEnabled;
        return !isSessionKeyCompatible && isPregeneratedWalletsWithPasskeyRequired;
    }, [
        (_h = (_g = (_f = (_e = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _e === void 0 ? void 0 : _e.embeddedWallets) === null || _f === void 0 ? void 0 : _f.supportedSecurityMethods) === null || _g === void 0 ? void 0 : _g.passkey) === null || _h === void 0 ? void 0 : _h.isEnabled,
        showSecureAccountBanner,
        isSessionKeyCompatible,
        isTurnkeyWalletWithoutAuthenticator,
    ]);
    // It fetches user passkeys if user has embedded wallet
    const getUserPasskeysResult = usePromise(() => __awaiter$1(void 0, void 0, void 0, function* () {
        const data = yield getUserPasskeys({
            environmentId: environmentId,
        });
        return data.passkeys;
    }), {
        deps: [environmentId, user, userHasEmbeddedWallet(), passkeyEdited],
        enabled: Boolean(environmentId && user && userHasEmbeddedWallet()),
    });
    // Returns true if user has passkeys for current origin
    const userHasPasskeysForCurrentOrigin = useMemo(() => {
        if (typeof window === 'undefined') {
            return false;
        }
        const hostname = PlatformService.getHostname();
        if (!getUserPasskeysResult.data)
            return false;
        return getUserPasskeysResult.data.some((passkey) => {
            if (!passkey.origin)
                return false;
            try {
                const passkeyHostname = new URL(passkey.origin).hostname;
                return passkeyHostname === getTLD() || passkeyHostname === hostname;
            }
            catch (e) {
                logger$1.error(e);
                return false;
            }
        });
    }, [getUserPasskeysResult.data]);
    // user has passkey configured, but not for current origin
    const userNeedsCrossDomainPasskey = !isTurnkeyWalletWithoutAuthenticator && !userHasPasskeysForCurrentOrigin;
    const value = useMemo(() => {
        var _a;
        return ({
            passkey,
            passkeyEdited,
            passkeyIcon,
            setPasskey,
            setPasskeyEdited,
            setPasskeyIcon,
            setShowSecureAccountBanner,
            showAlert,
            showSecureAccountBanner,
            userHasPasskeysForCurrentOrigin,
            userNeedsCrossDomainPasskey,
            userPasskeys: (_a = getUserPasskeysResult.data) !== null && _a !== void 0 ? _a : [],
            userPasskeysLoading: getUserPasskeysResult.isLoading,
        });
    }, [
        passkey,
        passkeyEdited,
        passkeyIcon,
        userHasPasskeysForCurrentOrigin,
        getUserPasskeysResult.data,
        getUserPasskeysResult.isLoading,
        userNeedsCrossDomainPasskey,
        showAlert,
        setShowSecureAccountBanner,
        showSecureAccountBanner,
    ]);
    return (jsxRuntimeExports.jsx(PasskeyContext.Provider, { value: value, children: children }));
};
// We need to export the context this way so it works with SSR (next.js)
const PasskeyContextProvider = ({ children, }) => (jsxRuntimeExports.jsx(PasskeyContextProviderWithBrowser, { children: children }));
const usePasskeyContext = () => {
    const context = useContext(PasskeyContext);
    if (context === undefined) {
        throw new Error('usage of PasskeyContext not wrapped in `PasskeyContextProvider`.');
    }
    return context;
};

const useOnlyConnectedMode = () => {
    const { authMode, user } = useInternalDynamicContext();
    return authMode === 'connect-only' && !user;
};

/* eslint-disable max-len */
/**
 * A custom React hook that checks if KYC fields are enabled in the project settings or defined in the user profile.
 *
 * @returns {boolean} - A boolean value indicating whether the KYC fields are enabled in the project settings or defined in the user profile.
 */
const useKYCFlag = () => {
    const isOnlyConnectedMode = useOnlyConnectedMode();
    const { projectSettings, user } = useInternalDynamicContext();
    if (isOnlyConnectedMode)
        return false;
    const hasAnyKYCFields = getUserProfileFields({
        customFields: projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.customFields,
        projectSettingsKyc: projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.kyc,
        user,
    });
    return hasAnyKYCFields.length > 0 || isSocialKycEnabled(projectSettings);
};

const useViewController = (initialView) => {
    const [_view, setView] = useState(null);
    const goToInitialView = () => setView(null);
    return {
        goToInitialView,
        setView: setView,
        view: _view || initialView,
    };
};

const DynamicWidgetContext = createContext(undefined);
const DynamicWidgetContextProvider = ({ children, }) => {
    const widgetRef = useRef(null);
    const inlineControlsRef = useRef(null);
    const availableWalletsContainerRef = useRef(null);
    const { setShowDynamicUserProfile, showDynamicUserProfile, multiWallet } = useInternalDynamicContext();
    const isKYCEnabled = useKYCFlag();
    const { view: dynamicWidgetView, setView, goToInitialView: goToInitialDynamicWidgetView, } = useViewController(isKYCEnabled && !multiWallet ? 'profile' : 'wallets');
    const [headerAlert, _setHeaderAlert] = useState(null);
    const headerAlertTimeoutRef = useRef(null);
    const clearHeaderAlert = useCallback(() => {
        _setHeaderAlert(null);
        if (headerAlertTimeoutRef.current) {
            clearTimeout(headerAlertTimeoutRef.current);
            headerAlertTimeoutRef.current = null;
        }
    }, []);
    const setHeaderAlert = useCallback((alert) => {
        var _a;
        const timeout = (_a = alert === null || alert === void 0 ? void 0 : alert.timeout) !== null && _a !== void 0 ? _a : 10000;
        _setHeaderAlert(alert);
        headerAlertTimeoutRef.current = setTimeout(clearHeaderAlert, timeout);
    }, [clearHeaderAlert]);
    const [viewProps, setViewProps] = useState({});
    const setDynamicWidgetView = useCallback((view, props) => {
        setView(view);
        setViewProps(props || {});
        clearHeaderAlert();
    }, [clearHeaderAlert, setView]);
    const goToProfileView = useCallback(() => {
        if (isKYCEnabled)
            return setDynamicWidgetView('profile');
        setDynamicWidgetView('wallets');
    }, [isKYCEnabled, setDynamicWidgetView]);
    const overridenWidgetView = useMemo(() => {
        if (dynamicWidgetView === 'manage-passkeys' ||
            dynamicWidgetView === 'manage-mfa')
            return 'settings';
        if (!isKYCEnabled &&
            !multiWallet &&
            dynamicWidgetView !== 'settings' &&
            dynamicWidgetView !== 'profile')
            return 'wallets';
        if (dynamicWidgetView === 'edit-profile')
            return 'profile';
        if (dynamicWidgetView === 'global-wallet')
            return 'wallets';
        return dynamicWidgetView;
    }, [dynamicWidgetView, isKYCEnabled, multiWallet]);
    useInternalDynamicEvents('logout', () => goToInitialDynamicWidgetView());
    const value = useMemo(() => ({
        availableWalletsContainerRef,
        dynamicWidgetView,
        goToInitialDynamicWidgetView,
        goToProfileView,
        headerAlert,
        inlineControlsRef,
        isOpen: showDynamicUserProfile,
        overridenWidgetView,
        setDynamicWidgetView,
        setHeaderAlert,
        setIsOpen: setShowDynamicUserProfile,
        viewProps,
        widgetRef,
    }), [
        dynamicWidgetView,
        goToInitialDynamicWidgetView,
        goToProfileView,
        showDynamicUserProfile,
        setDynamicWidgetView,
        setShowDynamicUserProfile,
        overridenWidgetView,
        viewProps,
        headerAlert,
        setHeaderAlert,
    ]);
    return (jsxRuntimeExports.jsx(DynamicWidgetContext.Provider, { value: value, children: children }));
};
const useWidgetContext = () => {
    const context = useContext(DynamicWidgetContext);
    if (context === undefined) {
        throw new Error('usage of useWidgetContext not wrapped in `DynamicWidgetContextProvider`.');
    }
    return context;
};

var _path$19;
var _excluded$1i = ["title", "titleId"];
function _extends$1i() { return _extends$1i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1i.apply(null, arguments); }
function _objectWithoutProperties$1i(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1i(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1i(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgAdd = function SvgAdd(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1i(_ref, _excluded$1i);
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$19 || (_path$19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2c.368 0 .667.298.667.667v4.666h4.666a.667.667 0 1 1 0 1.334H8.667v4.666a.667.667 0 1 1-1.334 0V8.667H2.667a.667.667 0 0 1 0-1.334h4.666V2.667C7.333 2.298 7.632 2 8 2Z",
    fill: "currentColor",
    fillOpacity: 0.4
  })));
};

var _path$18;
var _excluded$1h = ["title", "titleId"];
function _extends$1h() { return _extends$1h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1h.apply(null, arguments); }
function _objectWithoutProperties$1h(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1h(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1h(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgLink = function SvgLink(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1h(_ref, _excluded$1h);
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$18 || (_path$18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.833 4.667H9.167V6h2.666c1.1 0 2 .9 2 2s-.9 2-2 2H9.167v1.333h2.666a3.335 3.335 0 0 0 0-6.666Zm-4 5.333H5.167c-1.1 0-2-.9-2-2s.9-2 2-2h2.666V4.667H5.167a3.335 3.335 0 0 0 0 6.666h2.666V10Zm-2-2.667h5.334v1.334H5.833V7.333Z",
    fill: "currentColor"
  })));
};

const getActiveOauthCredential = (user) => {
    var _a;
    return (_a = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.find((credentials) => credentials.format === 'oauth' &&
        credentials.id === user.lastVerifiedCredentialId);
};

// To see which iso2 maps to which country, see
// https://github.com/goveo/react-international-phone/blob/master/src/data/countryData.ts
const getCustomCountries = (supportedCountriesForVerification) => {
    const customCountries = R.map(M).map((country) => {
        if (country.iso2 === 'br')
            country.format = '(..) .....-....';
        if (country.iso2 === 'fr')
            country.format = '(.) .. .. .. ..';
        return Se(country);
    });
    if (supportedCountriesForVerification) {
        return customCountries.filter(([, iso2]) => supportedCountriesForVerification.includes(iso2));
    }
    return customCountries;
};

/**
 * This takes a phone number (with country code, doesn't work otherwise)
 * and returns the same phone number, but formatted to its corresponding country
 */
const formatPhone = (phone) => {
    var _a;
    const { country } = X({
        // Enables using custom formatting
        countries: getCustomCountries(),
        phone,
    });
    if (!country)
        return phone;
    const strippedPhone = de({ dialCode: country.dialCode, phone });
    const mask = Q({ country, phone });
    const regex = /\./g;
    // Must be an exact match of the expected digit count and the actual digit count
    if (((_a = mask.match(regex)) !== null && _a !== void 0 ? _a : []).length !== removeNonDigits(strippedPhone).length)
        return phone;
    let i = 0;
    const formattedPhone = mask.replace(regex, () => strippedPhone[i++]);
    return `+${country.dialCode} ${formattedPhone}`;
};
const removeNonDigits = (text) => text.replace(/\D+/g, '');

/**
 * This will return a string which we can present to the user as his identifier, such as
 * his email address or phone number.
 */
const getUserIdentifier = (user) => {
    const oauthCredential = getActiveOauthCredential(user);
    if (oauthCredential === null || oauthCredential === void 0 ? void 0 : oauthCredential.publicIdentifier) {
        return oauthCredential.publicIdentifier;
    }
    if (user === null || user === void 0 ? void 0 : user.email)
        return shortenEmail(user.email);
    if (user === null || user === void 0 ? void 0 : user.phoneNumber)
        return formatPhone(user.phoneNumber);
    return 'My Profile';
};

const UserAvatar = ({ user, containerClassName, renderWithFallback = true, }) => {
    const getConnectedSocialAccountAvatarUrl = () => {
        var _a, _b, _c;
        const avatarUrl = (_c = (_b = (_a = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.find((credential) => {
            var _a;
            return user.lastVerifiedCredentialId === credential.id &&
                ((_a = credential.oauthAccountPhotos) === null || _a === void 0 ? void 0 : _a.length);
        })) === null || _b === void 0 ? void 0 : _b.oauthAccountPhotos) === null || _c === void 0 ? void 0 : _c[0];
        return avatarUrl;
    };
    const source = getConnectedSocialAccountAvatarUrl();
    if (!source && !renderWithFallback)
        return null;
    return (jsxRuntimeExports.jsx("div", { className: classNames('user-profile-social-account__connected-avatar', containerClassName), children: jsxRuntimeExports.jsx(Image$1, { className: 'user-profile-social-account__image', src: source, alt: 'User avatar', dataTestId: 'user-avatar', fallback: jsxRuntimeExports.jsx(UserProfileIcon, {}) }) }));
};

const SecureEmbeddedWalletCard = ({ className }) => {
    const { t } = useTranslation();
    const { primaryWallet } = useInternalDynamicContext();
    const { initPasskeyRecoveryProcess } = usePasskeyRecovery();
    const { showSecureAccountBanner, setShowSecureAccountBanner } = usePasskeyContext();
    const { getEOAWallet } = useSmartWallets();
    const eoaWallet = primaryWallet && getEOAWallet(primaryWallet);
    const isSessionKeyCompatible = (primaryWallet && isSessionKeyCompatibleWallet(primaryWallet)) ||
        (eoaWallet && isSessionKeyCompatibleWallet(eoaWallet));
    if (!showSecureAccountBanner || isSessionKeyCompatible)
        return null;
    return (jsxRuntimeExports.jsxs("div", { className: classNames('secure-embedded-wallet-card', className), children: [jsxRuntimeExports.jsxs("div", { className: 'secure-embedded-wallet-card__text-content', "data-testid": 'secure-wallet-button', onClick: () => initPasskeyRecoveryProcess(), children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'primary', copykey: 'dyn_secure_pregenerated_wallet.description', children: t('dyn_secure_pregenerated_wallet.description') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'bold', color: 'brand-primary', copykey: 'dyn_secure_pregenerated_wallet.action', className: 'secure-embedded-wallet-card__link', children: t('dyn_secure_pregenerated_wallet.action') })] }), jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(IconButton, { color: 'text-secondary', onClick: () => setShowSecureAccountBanner(false), children: jsxRuntimeExports.jsx(SvgClose, { width: 16, height: 16 }) }) })] }));
};

/**
 * Allows showing a modal for the user to confirm or cancel.
 *
 * The open method accepts a callback which receives a (resolve, reject) pair to be called if the user
 * confirms or cancels the operation, and must return the ReactNode for the modal to be displayed.
 *
 * @param {string} elementId The id of the modal root, to which the modal will be portalled
 * @returns {ConfirmationModalHookResult} An object with a method to open a modal and a reference to the modal itself.
 */
const useConfirmationModal = ({ elementId, }) => {
    const { createRootElement } = useElementById();
    const modalRootElementRef = createRootElement(elementId);
    const [node, setNode] = useState(null);
    const open = useCallback((builder) => __awaiter$1(void 0, void 0, void 0, function* () {
        const promise = new Promise((resolve, reject) => {
            try {
                setNode(builder(resolve, reject));
            }
            catch (err) {
                reject(err);
            }
        });
        return promise.finally(() => {
            setNode(undefined);
        });
    }), [setNode]);
    return {
        modal: node ? (jsxRuntimeExports.jsx("div", { children: createPortal(node, modalRootElementRef.current) })) : undefined,
        open,
    };
};

const Modal = ({ children, className, isShown = true, transitionProps, }) => (jsxRuntimeExports.jsx("div", { className: classNames('modal', className), children: jsxRuntimeExports.jsx(OpacityTransition, Object.assign({}, transitionProps, { isShown: isShown, children: jsxRuntimeExports.jsx("div", { className: 'modal__items', children: children }) })) }));

const ModalCard = ({ children, borderRadius = 'default', border = false, sharpBottomRadiusOnMobile = true, dataTestId = 'modal-card', }) => (jsxRuntimeExports.jsx("div", { "data-testid": dataTestId, className: classNames('modal-card', {
        'modal-card--sharp-mobile-bottom-radius': sharpBottomRadiusOnMobile,
        'modal-card--with-border': border,
    }, `modal-card--radius-${borderRadius}`), children: children }));

const useKeyboardEventListener = ({ disabled, inputKey, onKeyPressed, }) => {
    useEffect(() => {
        const handleKeydown = (evt) => {
            if (disabled || evt.key !== inputKey)
                return;
            onKeyPressed(evt);
        };
        document.addEventListener('keydown', handleKeydown);
        return () => {
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [disabled, inputKey, onKeyPressed]);
};

const ModalComponent = ({ children, handleClose, withBackdrop = true, zIndex, whiteList, }) => {
    const { view } = useViewContext();
    const shouldCloseOnBackdropClick = (view === null || view === void 0 ? void 0 : view.type) &&
        view.type !== 'collect-user-data' &&
        view.type !== 'login-with-email-verification' &&
        view.type !== 'login-with-sms-verification' &&
        view.type !== 'verify-sms' &&
        view.type !== 'verify-email' &&
        view.type !== 'mfa-verification' &&
        view.type !== 'mfa-display-backup-codes';
    const onBackdropClick = (e) => {
        if (!shouldCloseOnBackdropClick)
            return;
        e.stopPropagation();
        handleClose(e);
    };
    useKeyboardEventListener({
        disabled: !shouldCloseOnBackdropClick,
        inputKey: 'Escape',
        onKeyPressed: handleClose,
    });
    return (jsxRuntimeExports.jsxs(FocusLockCombination, { className: 'portal__container', whiteList: whiteList, children: [withBackdrop && (jsxRuntimeExports.jsx("div", { "data-testid": 'portal-backdrop', role: 'button', onClick: (e) => {
                    onBackdropClick(e);
                }, tabIndex: 0, "aria-label": 'Close modal', 
                // z-index - 2 to ensure that the backdrop is always behind the content
                style: { zIndex: zIndex ? zIndex - 2 : undefined }, className: 'portal__backdrop' })), jsxRuntimeExports.jsx("div", { style: { zIndex }, children: children })] }));
};
const Portal = ({ children, isShown, handleClose, withBackdrop, zIndex, transitionEvents, elementId = 'dynamic-modal', }) => {
    const { createRootElement } = useElementById();
    const modalRootElementRef = createRootElement(elementId);
    const whiteList = useCallback((node) => modalRootElementRef.current.contains(node), [modalRootElementRef]);
    return createPortal(jsxRuntimeExports.jsx(ShadowDOM, { zIndex: zIndex, dataTestId: 'dynamic-modal-shadow', children: jsxRuntimeExports.jsx(OpacityTransition, Object.assign({ isShown: isShown }, transitionEvents, { children: jsxRuntimeExports.jsx(ModalComponent, { handleClose: handleClose, withBackdrop: withBackdrop, whiteList: whiteList, children: children }) })) }), modalRootElementRef.current);
};

const ChainIcon = ({ chain, chainName }) => {
    const ChainIconComponent = getChainIcon(chainName);
    return (jsxRuntimeExports.jsx(Icon, { size: 'small', children: (chain === null || chain === void 0 ? void 0 : chain.icon) ? (jsxRuntimeExports.jsx("img", { src: chain.icon, alt: `${chain.name} icon` })) : (jsxRuntimeExports.jsx(ChainIconComponent, {})) }));
};

const getOrdinalNumber = (number) => {
    if (number < 1) {
        return '';
    }
    if (number % 10 === 1 && number % 100 !== 11) {
        return `${number}st`;
    }
    else if (number % 10 === 2 && number % 100 !== 12) {
        return `${number}nd`;
    }
    else if (number % 10 === 3 && number % 100 !== 13) {
        return `${number}rd`;
    }
    return `${number}th`;
};

const FormFieldLabel = ({ children, htmlFor, className, divider, }) => (jsxRuntimeExports.jsx("label", { className: classNames('form-field-label', { 'form-field-label__with-divider': divider }, className), htmlFor: htmlFor, children: children }));

var _path$17;
var _excluded$1g = ["title", "titleId"];
function _extends$1g() { return _extends$1g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1g.apply(null, arguments); }
function _objectWithoutProperties$1g(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1g(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1g(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgStroke = function SvgStroke(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1g(_ref, _excluded$1g);
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$17 || (_path$17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.293 19.707a1 1 0 0 1 0-1.414L14.586 12 8.293 5.707a1 1 0 0 1 1.414-1.414l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0Z",
    fill: "currentColor"
  })));
};

/* eslint-disable max-len */
const erc20Abi = [
    {
        constant: true,
        inputs: [],
        name: 'name',
        outputs: [
            {
                name: '',
                type: 'string',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            {
                name: '_spender',
                type: 'address',
            },
            {
                name: '_value',
                type: 'uint256',
            },
        ],
        name: 'approve',
        outputs: [
            {
                name: '',
                type: 'bool',
            },
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'totalSupply',
        outputs: [
            {
                name: '',
                type: 'uint256',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            {
                name: '_from',
                type: 'address',
            },
            {
                name: '_to',
                type: 'address',
            },
            {
                name: '_value',
                type: 'uint256',
            },
        ],
        name: 'transferFrom',
        outputs: [
            {
                name: '',
                type: 'bool',
            },
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'decimals',
        outputs: [
            {
                name: '',
                type: 'uint8',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            {
                name: '_owner',
                type: 'address',
            },
        ],
        name: 'balanceOf',
        outputs: [
            {
                name: 'balance',
                type: 'uint256',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: true,
        inputs: [],
        name: 'symbol',
        outputs: [
            {
                name: '',
                type: 'string',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        constant: false,
        inputs: [
            {
                name: '_to',
                type: 'address',
            },
            {
                name: '_value',
                type: 'uint256',
            },
        ],
        name: 'transfer',
        outputs: [
            {
                name: '',
                type: 'bool',
            },
        ],
        payable: false,
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        constant: true,
        inputs: [
            {
                name: '_owner',
                type: 'address',
            },
            {
                name: '_spender',
                type: 'address',
            },
        ],
        name: 'allowance',
        outputs: [
            {
                name: '',
                type: 'uint256',
            },
        ],
        payable: false,
        stateMutability: 'view',
        type: 'function',
    },
    {
        payable: true,
        stateMutability: 'payable',
        type: 'fallback',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                name: 'spender',
                type: 'address',
            },
            {
                indexed: false,
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
];

const MenuList = ({ isOpen, onClickClose, popperProps, dropdownClassName, dropdownStyle, overlayCardClassName, overlayCardStyle, className, style, children, mobileTitle, }) => {
    if (isMobile())
        return (jsxRuntimeExports.jsxs(OverlayCard, { isOpen: isOpen, onClose: onClickClose, className: classNames(overlayCardClassName, className), style: Object.assign(Object.assign({}, style), overlayCardStyle), children: [jsxRuntimeExports.jsx(OverlayCard.Header, { children: mobileTitle }), jsxRuntimeExports.jsx(OverlayCard.Content, { removePadding: true, children: jsxRuntimeExports.jsx("div", { className: 'menu-list__overlay-card__container', children: children }) })] }));
    return (jsxRuntimeExports.jsx(Dropdown, Object.assign({ isOpen: isOpen, onClickOutside: onClickClose, onScroll: onClickClose, className: classNames(dropdownClassName, className), style: Object.assign(Object.assign({}, style), dropdownStyle) }, popperProps, { children: children })));
};

const TokensBalanceDropdown = ({ tokenBalances, currentToken, setCurrentToken, isLoading, setFieldValue, setErrors, }) => {
    const { t } = useTranslation();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const filteredTokenBalances = (tokenBalances === null || tokenBalances === void 0 ? void 0 : tokenBalances.filter((token) => token.name)) || [];
    const { primaryWallet } = useInternalDynamicContext();
    const anchorRef = useRef(null);
    const fetchTokenData = (selectedToken) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!primaryWallet ||
            !('getPublicClient' in primaryWallet) ||
            typeof primaryWallet.getPublicClient !== 'function') {
            return;
        }
        const publicClient = yield primaryWallet.getPublicClient();
        if (!publicClient)
            return;
        const erc20Contract = {
            abi: erc20Abi,
            address: selectedToken.address,
        };
        const results = yield publicClient.multicall({
            contracts: [
                Object.assign(Object.assign({}, erc20Contract), { args: [primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address], functionName: 'balanceOf' }),
                Object.assign(Object.assign({}, erc20Contract), { functionName: 'decimals' }),
            ],
        });
        const [balance, decimals] = results.map((v) => Number(v.result));
        if (balance && decimals) {
            selectedToken.balance = balance / Math.pow(10, decimals);
            selectedToken.rawBalance = balance;
            if (tokenBalances) {
                const index = tokenBalances.findIndex((t) => t.name === selectedToken.name);
                tokenBalances[index] = selectedToken;
            }
            selectedToken.decimals = decimals;
        }
    });
    const handleTokenClick = (selectedTokenName) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a, _b;
        const selectedToken = (_a = tokenBalances === null || tokenBalances === void 0 ? void 0 : tokenBalances.find((t) => t.name === selectedTokenName)) !== null && _a !== void 0 ? _a : undefined;
        // we dont need to refetch solana balances because we simulate before sending
        if ((selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.address) && (selectedToken === null || selectedToken === void 0 ? void 0 : selectedToken.address.startsWith('0x'))) {
            fetchTokenData(selectedToken);
        }
        if (selectedToken) {
            if (tokenBalances && ((_b = tokenBalances[0]) === null || _b === void 0 ? void 0 : _b.price))
                setSendBalanceVariable('nativePrice', tokenBalances[0].price);
            setCurrentToken(selectedToken);
            setFieldValue('amount', '');
            setSendBalanceVariable('amount', 0);
            setErrors({});
        }
        setIsDropdownOpen(!isDropdownOpen);
    });
    if (isLoading) {
        return jsxRuntimeExports.jsx(Skeleton, {});
    }
    const tokenLogo = (token, size) => (token === null || token === void 0 ? void 0 : token.logoURI) ? (jsxRuntimeExports.jsx("img", { src: token.logoURI, alt: token === null || token === void 0 ? void 0 : token.name, width: size, height: size })) : (jsxRuntimeExports.jsx("div", { className: 'token-balance-item__skeleton-icon', "data-testid": 'token-balance-item__skeleton-icon' }));
    return (jsxRuntimeExports.jsxs("div", { className: 'tokens-balance-dropdown', ref: anchorRef, onClick: () => setIsDropdownOpen(!isDropdownOpen), "data-testid": 'tokens-balance-dropdown', children: [!isLoading && (jsxRuntimeExports.jsxs("div", { className: 'tokens-balance-dropdown__selected', children: [tokenLogo(currentToken, '20'), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', children: currentToken === null || currentToken === void 0 ? void 0 : currentToken.name }), jsxRuntimeExports.jsx(Icon, { color: 'text-primary', size: 'small', className: classNames('evm-network-control__arrow-icon', {
                            'evm-network-control__arrow-icon--active': isDropdownOpen,
                        }), children: jsxRuntimeExports.jsx(SvgStroke, {}) })] })), jsxRuntimeExports.jsx(MenuList, { className: 'tokens-balance-dropdown__menu_list', isOpen: isDropdownOpen, popperProps: {
                    anchorOrigin: 'bottom-left',
                    anchorRef,
                }, mobileTitle: 'Select token', children: filteredTokenBalances.length > 0 ? (filteredTokenBalances.map((t) => (jsxRuntimeExports.jsxs("button", { className: 'tokens-balance-dropdown__menu_list_item', onClick: () => handleTokenClick(t.name), children: [jsxRuntimeExports.jsxs("div", { className: 'tokens-balance-dropdown__menu_list_item__name', children: [tokenLogo(t, '16'), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'primary', children: t.name })] }), jsxRuntimeExports.jsxs("div", { className: 'tokens-balance-dropdown__menu_list_item__balance', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', children: t.symbol }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'primary', children: roundToNthDecimal(t.balance, 6) })] })] }, t.address)))) : (jsxRuntimeExports.jsx("div", { className: 'token-balance-list__empty', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', children: t('dyn_wallet_information.multi_asset.empty_state') }) })) })] }));
};

const sendBalanceFormInitialValues = {
    amount: '',
    recipient: '',
};
const getDisplayErrorMessage$1 = (errors, t, field, decimals) => {
    const mapFieldAndErrorToMessage = {
        amount: {
            invalidDecimals: t('dyn_send_transaction.validation.amount.invalid_decimals', { decimals }),
            invalidFormat: t('dyn_send_transaction.validation.amount.invalid_decimals', { decimals }),
            overBalance: t('dyn_send_transaction.validation.amount.over_balance'),
            required: t('dyn_send_transaction.validation.amount.required'),
        },
        recipient: {
            invalidFormat: t('dyn_send_transaction.validation.recipient.invalid_format'),
            required: t('dyn_send_transaction.validation.recipient.required'),
        },
    };
    const errorType = errors[field];
    if (errorType) {
        const errorMessage = mapFieldAndErrorToMessage[field][errorType];
        return errorMessage.replace('{decimals}', getOrdinalNumber(decimals !== null && decimals !== void 0 ? decimals : 0));
    }
    return '';
};
const SendBalanceForm = ({ initialValues, onSubmit, decimals = 18, validateAddress = () => true, validateAmount = () => true, currentToken, transaction, tokenBalances, setCurrentToken, isLoading, }) => {
    const { t } = useTranslation();
    const { showFiat } = useInternalDynamicContext();
    const floatingValueRef = useRef(null);
    const [leftSymbolPadding, setLeftSymbolPadding] = useState(0);
    const { amount } = useSendBalanceState();
    useEffect(() => {
        if (floatingValueRef.current) {
            const floatingDivWidth = floatingValueRef.current.offsetWidth;
            setLeftSymbolPadding(floatingDivWidth + 15);
        }
    }, [currentToken]);
    const sendBalanceFormValidationSchema = useMemo(() => {
        const decimalsRegex = new RegExp(`^\\d*(\\.\\d{1,${decimals}})?$`);
        return create$1().shape({
            amount: create$2()
                .required('required')
                .matches(/^\d*(\.\d+)?$/, 'invalidFormat')
                .matches(decimalsRegex, 'invalidDecimals')
                .test({
                message: 'overBalance',
                test: (value) => validateAmount(value),
            }),
            recipient: create$2()
                .required('required')
                .test({
                message: 'invalidFormat',
                test: (value) => validateAddress(value),
            }),
        });
    }, [decimals, validateAddress, validateAmount]);
    return (jsxRuntimeExports.jsx(Formik, { initialValues: initialValues || sendBalanceFormInitialValues, validationSchema: sendBalanceFormValidationSchema, onSubmit: (values) => onSubmit(values), validateOnChange: false, validateOnBlur: false, children: ({ errors, touched, values, handleChange, setFieldValue, setErrors, handleBlur, setFieldTouched, validateField, }) => {
            var _a;
            return (jsxRuntimeExports.jsxs(Form, { className: 'send-balance-form', children: [jsxRuntimeExports.jsxs("div", { className: 'send-balance-page-layout__balance-container', children: [jsxRuntimeExports.jsx(FormFieldLabel, { children: "Select any token" }), jsxRuntimeExports.jsx(TokensBalanceDropdown, { tokenBalances: tokenBalances !== null && tokenBalances !== void 0 ? tokenBalances : (currentToken && [currentToken]), currentToken: currentToken, setCurrentToken: setCurrentToken, isLoading: isLoading, setFieldValue: setFieldValue, setErrors: setErrors })] }), jsxRuntimeExports.jsxs("div", { className: 'send-balance-form__amount-container', children: [jsxRuntimeExports.jsx(Field, { variant: 'regular', className: `send-balance-form__amount-container__field ${showFiat ? 'fiat' : ''}`, name: 'amount', id: 'amount', onChange: (e) => {
                                    const newValue = e.target.value;
                                    // Matching 123, 123.45, .45, 123.
                                    if (newValue !== '' && !/^(?:\d+|\d*\.\d*|)$/.test(newValue)) {
                                        return;
                                    }
                                    setErrors({});
                                    handleChange(e);
                                    if (!newValue || Number.isNaN(newValue)) {
                                        setSendBalanceVariable('amount', 0);
                                        return;
                                    }
                                    setSendBalanceVariable('amount', (currentToken === null || currentToken === void 0 ? void 0 : currentToken.price) ? Number(newValue) : undefined);
                                }, onBlur: (e) => {
                                    handleBlur(e);
                                    setFieldTouched('amount', true);
                                    validateField('amount');
                                }, placeholder: t('dyn_send_transaction.data.amount.placeholder'), as: Input, error: errors['amount'], copykey: 'dyn_send_transaction.data.amount.label', message: touched['amount'] &&
                                    getDisplayErrorMessage$1(errors, t, 'amount', decimals), style: {
                                    paddingLeft: `${leftSymbolPadding}px`,
                                } }), jsxRuntimeExports.jsx("div", { className: 'send-balance-form__amount-container__floating_value', ref: floatingValueRef, children: jsxRuntimeExports.jsx(Typography, { variant: 'title', weight: 'regular', color: 'secondary', children: currentToken === null || currentToken === void 0 ? void 0 : currentToken.symbol }) }), jsxRuntimeExports.jsx("div", { className: 'send-balance-form__amount-container__balance', children: showFiat && !Number.isNaN(amount) && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_mini', weight: 'bold', color: 'secondary', children: "$" }), jsxRuntimeExports.jsx(Typography, { variant: 'body_mini', weight: 'regular', color: 'secondary', children: getDisplayFiatPrice(amount, currentToken) })] })) })] }), jsxRuntimeExports.jsx(Typography, { className: 'send-balance-form__amount_available', variant: 'body_small', weight: 'regular', color: 'secondary', as: 'div', children: jsxRuntimeExports.jsxs("div", { style: { display: 'flex', gap: '0.225rem' }, children: [jsxRuntimeExports.jsx(Typography, { className: 'send-balance-form__amount_available__line', variant: 'body_small', weight: 'bold', color: 'primary', as: 'div', children: (_a = roundToNthDecimal(currentToken === null || currentToken === void 0 ? void 0 : currentToken.balance, 6)) !== null && _a !== void 0 ? _a : 0 }), `${currentToken === null || currentToken === void 0 ? void 0 : currentToken.symbol} Available`] }) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'regular', color: 'secondary', children: "Recipient Address" }), jsxRuntimeExports.jsx(Field, { className: 'send-balance-form__field', placeholder: t('dyn_send_transaction.data.recipient.placeholder'), label: t('dyn_send_transaction.data.recipient.label'), id: 'recipient', name: 'recipient', as: Input, error: errors['recipient'], copykey: 'dyn_send_transaction.data.recipient.label', message: touched['recipient'] &&
                            getDisplayErrorMessage$1(errors, t, 'recipient') }), jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'sendBalanceFormSubmitButton', expanded: true, type: 'submit', buttonVariant: 'primary', buttonPadding: 'small', buttonClassName: 'send-balance-form__button', copykey: 'dyn_send_transaction.preview_transaction', children: t('dyn_send_transaction.preview_transaction') })] }));
        } }));
};

const zeroAddress$1 = '0x0000000000000000000000000000000000000000';
const nativeSolanaAddress$1 = '11111111111111111111111111111111';

const SendBalancePageLayout = ({ error, onClickClose, onClickBack, onSubmit, displayPoweredByDynamicFooter = false, transaction, networkCurrencyDecimals, tokenBalances, currentToken, setCurrentToken, isLoading, isNativeToken, }) => {
    var _a;
    const { t } = useTranslation();
    const { primaryWallet, projectSettings, overrides } = useInternalDynamicContext();
    const networkInfo = useNetworkConfigurationsFromProjectSettings({
        evmNetworksOverrides: overrides === null || overrides === void 0 ? void 0 : overrides.evmNetworks,
        projectSettings,
    });
    const walletConnector = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector;
    const { chain } = useFetchChain(walletConnector);
    const closeButton = onClickClose && (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: onClickClose, "data-testid": 'close-button', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    const backButton = onClickBack && (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: onClickBack, "data-testid": 'back-button', children: jsxRuntimeExports.jsx(SvgArrowLeft, {}) }));
    const { data: balance } = usePromise(() => transaction.getBalance(), {
        deps: [transaction],
    });
    useEffect(() => {
        const getNativeTokenAndFetchBalance = () => __awaiter$1(void 0, void 0, void 0, function* () {
            const nativeTokenInfo = getNetworkInfoEntry(chain, networkInfo);
            if (!nativeTokenInfo) {
                logger$1.error('Token info not found. Please make sure you are on a supported chain and it is enabled. See https://docs.dynamic.xyz/chains/enabling-chains');
                return;
            }
            const token = {
                address: (chain === null || chain === void 0 ? void 0 : chain.name) === 'Solana' ? nativeSolanaAddress$1 : zeroAddress$1,
                balance: 0,
                decimals: nativeTokenInfo.nativeCurrency.decimals,
                logoURI: nativeTokenInfo.nativeCurrency.iconUrl || nativeTokenInfo.iconUrls[0],
                name: nativeTokenInfo.name,
                rawBalance: 0,
                symbol: nativeTokenInfo.nativeCurrency.symbol,
            };
            const tokenBalance = yield (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.getBalance());
            if (tokenBalance) {
                token.balance = Number(tokenBalance);
                token.rawBalance = Number(tokenBalance) / Math.pow(10, token.decimals);
            }
            setCurrentToken(token);
        });
        const updateTokenBalances = () => __awaiter$1(void 0, void 0, void 0, function* () {
            if (isLoading)
                return;
            if (tokenBalances === undefined ||
                (Array.isArray(tokenBalances) && tokenBalances.length === 0)) {
                yield getNativeTokenAndFetchBalance();
            }
            else if (!currentToken) {
                setCurrentToken(tokenBalances[0]);
            }
        });
        updateTokenBalances();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tokenBalances, chain]);
    const getAmount = () => {
        if (isNativeToken) {
            return transaction.value ? transaction.format(transaction.value) : '';
        }
        // Non-native token
        return (transaction === null || transaction === void 0 ? void 0 : transaction.formatNonNativeToken) &&
            (transaction === null || transaction === void 0 ? void 0 : transaction.nonNativeValue) &&
            (transaction === null || transaction === void 0 ? void 0 : transaction.nonNativeDecimal)
            ? transaction.formatNonNativeToken(transaction.nonNativeValue, transaction.nonNativeDecimal)
            : '';
    };
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(ModalHeader, { leading: backButton, trailing: closeButton, alignContent: 'bottom', children: jsxRuntimeExports.jsx("div", { className: 'send-balance-page-layout__header-content', children: jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', copykey: 'dyn_send_transaction.data.send', children: t('dyn_send_transaction.data.send') }) }) }), jsxRuntimeExports.jsxs("div", { className: 'send-balance-page-layout__body', children: [jsxRuntimeExports.jsx(AnimatePresence, { animationComponent: jsxRuntimeExports.jsx(VerticalDrawerTransition, {}), children: error && (jsxRuntimeExports.jsx("div", { className: 'send-balance-page-layout__error', children: jsxRuntimeExports.jsx(Alert, { icon: 'error', variant: 'error', children: error }) })) }), jsxRuntimeExports.jsx(SendBalanceForm, { tokenBalances: tokenBalances, setCurrentToken: setCurrentToken, isLoading: isLoading, onSubmit: ({ amount, recipient }) => {
                            if (isNativeToken) {
                                transaction.value = transaction.parse(amount);
                            }
                            else if (transaction.parseNonNativeToken) {
                                transaction.nonNativeValue = transaction.parseNonNativeToken(amount, (currentToken === null || currentToken === void 0 ? void 0 : currentToken.decimals) || 18);
                                transaction.value = BigInt(0);
                                transaction.nonNativeAddress = currentToken === null || currentToken === void 0 ? void 0 : currentToken.address;
                                transaction.nonNativeDecimal = currentToken === null || currentToken === void 0 ? void 0 : currentToken.decimals;
                            }
                            transaction.to = recipient;
                            onSubmit();
                        }, initialValues: {
                            amount: getAmount(),
                            recipient: (_a = transaction.to) !== null && _a !== void 0 ? _a : '',
                        }, decimals: isNativeToken ? networkCurrencyDecimals : currentToken === null || currentToken === void 0 ? void 0 : currentToken.decimals, validateAddress: (value) => {
                            if (!value)
                                return true;
                            return transaction.validateAddressFormat(value);
                        }, validateAmount: (amountText) => {
                            if (!amountText)
                                return false;
                            if (isNativeToken) {
                                if (!balance)
                                    return false;
                                const amount = transaction.parse(amountText);
                                return amount <= balance;
                            }
                            // Non Native
                            if (!(currentToken === null || currentToken === void 0 ? void 0 : currentToken.rawBalance) || !transaction.parseNonNativeToken)
                                return false;
                            const amount = Number(transaction.parseNonNativeToken(amountText, (currentToken === null || currentToken === void 0 ? void 0 : currentToken.decimals) || 18));
                            return amount <= currentToken.rawBalance;
                        }, currentToken: currentToken, transaction: transaction }), displayPoweredByDynamicFooter && (jsxRuntimeExports.jsx(PoweredByDynamic, { classNameRoot: 'send-balance-page-layout__footer' }))] })] }));
};

var _path$16;
var _excluded$1f = ["title", "titleId"];
function _extends$1f() { return _extends$1f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1f.apply(null, arguments); }
function _objectWithoutProperties$1f(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1f(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1f(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgCheckBlue = function SvgCheckBlue(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1f(_ref, _excluded$1f);
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$16 || (_path$16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 64c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32C14.827 0 .5 14.327.5 32c0 17.673 14.327 32 32 32Zm12.845-39.155a1.667 1.667 0 1 0-2.357-2.357L27.5 37.976l-5.488-5.488a1.667 1.667 0 1 0-2.357 2.357l6.666 6.667c.651.65 1.707.65 2.357 0l16.667-16.667Z",
    fill: "#4779FF"
  })));
};

const TransactionStatusLayout = ({ destinationAddress, transactionValue, networkCurrency, onDone, displayPoweredByDynamicFooter = true, onClickClose, transaction, currentToken, isNativeToken, }) => {
    const { t } = useTranslation();
    const { showFiat } = useInternalDynamicContext();
    const { nativePrice } = useSendBalanceState();
    const closeButton = onClickClose && (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: onClickClose, "data-testid": 'close', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    const totalFiatCost = getTotalFiatCost(currentToken, transaction, nativePrice, transactionValue);
    return (jsxRuntimeExports.jsxs("div", { className: 'transaction-status-layout', children: [jsxRuntimeExports.jsx(ModalHeader, { trailing: closeButton, alignContent: 'bottom', children: jsxRuntimeExports.jsx(Icon, { size: 'large', className: 'transaction-status-layout__status-icon', children: jsxRuntimeExports.jsx(SvgCheckBlue, {}) }) }), jsxRuntimeExports.jsxs("div", { className: 'transaction-status-layout__body', children: [jsxRuntimeExports.jsxs("div", { className: 'transaction-status-layout__sent_to', children: [jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', color: 'secondary', className: 'transaction-status-layout__title', copykey: 'dyn_send_transaction.succeeded.title', children: [t('dyn_send_transaction.succeeded.title'), ' '] }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'primary', className: 'transaction-status-layout__title', copykey: 'dyn_send_transaction.succeeded.title', children: shortenWalletAddress(destinationAddress, 3, 3) })] }), jsxRuntimeExports.jsx("div", { className: 'transaction-status-layout__content', children: jsxRuntimeExports.jsx("div", { className: 'transaction-status-layout__rows', children: jsxRuntimeExports.jsxs(Typography, { variant: 'title', color: 'primary', className: 'transaction-status-layout__title', copykey: 'dyn_send_transaction.succeeded.title', children: [`${getValueRounded(isNativeToken, transaction)} ${networkCurrency} `, showFiat &&
                                        (currentToken === null || currentToken === void 0 ? void 0 : currentToken.price) &&
                                        `($${Number(totalFiatCost) <= 0.01 ? '<0.01' : totalFiatCost})`] }) }) }), jsxRuntimeExports.jsx(AnimatePresence, { animationComponent: jsxRuntimeExports.jsx(VerticalDrawerTransition, {}), children: jsxRuntimeExports.jsx("div", { className: 'transaction-confirmation__warning', children: jsxRuntimeExports.jsx(Alert, { variant: 'info', copykey: 'dyn_send_transaction.info_message.refresh_balance_time', children: t('dyn_send_transaction.info_message.refresh_balance_time') }) }) }), jsxRuntimeExports.jsx("div", { className: 'transaction-status-layout__actions', children: jsxRuntimeExports.jsx(TypographyButton, { buttonVariant: 'brand-primary', buttonPadding: 'small', expanded: true, onClick: onDone, loading: false, copykey: 'dyn_send_transaction.succeeded.continue_button', dataTestId: 'transaction-done-continue', children: t('dyn_send_transaction.succeeded.continue_button') }) }), displayPoweredByDynamicFooter && (jsxRuntimeExports.jsx(PoweredByDynamic, { classNameRoot: 'transaction-status-layout__footer' }))] })] }));
};

const useNetworkDataFromWallet = (wallet) => {
    var _a, _b;
    const { data: network } = usePromise(() => wallet === null || wallet === void 0 ? void 0 : wallet.connector.getNetwork(), {
        enabled: Boolean(wallet),
    });
    const { networkConfigurations } = useInternalDynamicContext();
    if (!wallet || !network)
        return undefined;
    if (wallet.chain === 'SOL') {
        return (_a = networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations.solana) === null || _a === void 0 ? void 0 : _a[0];
    }
    return (_b = networkConfigurations === null || networkConfigurations === void 0 ? void 0 : networkConfigurations[wallet.connector.connectedChain.toLowerCase()]) === null || _b === void 0 ? void 0 : _b.find((_network) => _network.chainId === network);
};

const zeroAddress = '0x0000000000000000000000000000000000000000';
const nativeSolanaAddress = '11111111111111111111111111111111';
const usingNative = (token) => token.address === zeroAddress || token.address === nativeSolanaAddress;
const getTransactionValue = (transaction, isNativeToken) => {
    if (isNativeToken)
        return transaction.value
            ? transaction.format(transaction.value, { precision: 6 })
            : '0';
    return transaction.nonNativeValue && transaction.formatNonNativeToken
        ? transaction.formatNonNativeToken(transaction.nonNativeValue, transaction.nonNativeDecimal || 18)
        : '0';
};
const SendBalanceView = ({ initialRecipientAddress = '', initialValue, onClickBack, onClickClose, onError, onSuccess, onDone, displayPoweredByDynamicFooter = false, }) => {
    const [stage, setStage] = useState('form');
    const { primaryWallet, walletUiUtils } = useInternalDynamicContext();
    const { t } = useTranslation();
    const [isNativeToken, setIsNativeToken] = useState(false);
    const [currentToken, setCurrentToken] = useState(undefined);
    const [tokenBalances, setTokenBalances] = useState(undefined);
    const { showFiat } = useInternalDynamicContext();
    const walletConnector = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector;
    const { chain } = useFetchChain(walletConnector);
    const { tokenBalances: unorderedTokenBalances, isLoading } = useTokenBalances({
        chainName: (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain) === 'SOL'
            ? ChainEnum.Sol
            : ChainEnum.Evm,
        includeFiat: showFiat,
        includeNativeBalance: true,
    });
    if (!primaryWallet) {
        throw new DynamicError('Primary wallet is not available, send balance cannot be displayed');
    }
    const moveNativeTokenToFirstPosition = (tokenBalances) => {
        const filteredArray = tokenBalances.filter((t) => t.address !== zeroAddress && t.address !== nativeSolanaAddress);
        const nativeToken = tokenBalances.find((t) => usingNative(t));
        return nativeToken ? [nativeToken].concat(filteredArray) : filteredArray;
    };
    if (walletConnector && !isSendBalanceWalletConnector(walletConnector)) {
        throw new DynamicError('Primary wallet is not eligible for this operation. It must implement ISendBalanceWalletConnector');
    }
    const [transaction, setTransaction] = useState(null);
    useEffect(() => {
        const evmChain = (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain) !== 'SOL'
            ? getEvmChainName(Number(chain === null || chain === void 0 ? void 0 : chain.chainId))
            : undefined;
        setSendBalanceVariable('chainName', evmChain || (chain === null || chain === void 0 ? void 0 : chain.name) || (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain));
        return () => {
            resetSendBalanceState();
        };
    }, [chain === null || chain === void 0 ? void 0 : chain.name, walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain]);
    useEffect(() => {
        if (unorderedTokenBalances)
            setTokenBalances(moveNativeTokenToFirstPosition(unorderedTokenBalances));
    }, [unorderedTokenBalances]);
    useEffect(() => {
        if (!walletConnector)
            return;
        // If address is zero or 1 address it's native token, otherwise non-native token
        if (currentToken)
            setIsNativeToken(usingNative(currentToken));
        walletConnector
            .createUiTransaction(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address)
            .then((transaction) => {
            if (initialRecipientAddress)
                transaction.to = initialRecipientAddress;
            if (initialValue)
                transaction.value = initialValue;
            if (currentToken && !usingNative(currentToken)) {
                transaction.nonNativeAddress = currentToken === null || currentToken === void 0 ? void 0 : currentToken.address;
                transaction.nonNativeValue = BigInt(0);
                transaction.nonNativeDecimal = currentToken === null || currentToken === void 0 ? void 0 : currentToken.decimals;
            }
            setTransaction(transaction);
        })
            .catch((error) => {
            logger$1.debug('[SendBalanceView] Error creating transaction', error);
            if (error instanceof DynamicError && error.code === '0') {
                // means user cancelled the request for sync'ing the wallet
                onDone === null || onDone === void 0 ? void 0 : onDone();
                return;
            }
            onError === null || onError === void 0 ? void 0 : onError(error);
        });
    }, [currentToken]);
    const networkData = useNetworkDataFromWallet(primaryWallet);
    if (!transaction || !networkData) {
        return (jsxRuntimeExports.jsx("div", { className: 'send-balance-widget-view__spinner', "data-testid": 'send-balance-spinner', children: jsxRuntimeExports.jsx(Spinner$1, {}) }));
    }
    const handleSuccessToRefreshBalance = (txHash) => __awaiter$1(void 0, void 0, void 0, function* () {
        // SOL
        if ((walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain) === 'SOL') {
            // Just to make absolutely sure the block has been validated
            // and confirmed on the Solana blockchain
            setTimeout(() => dynamicEvents.emit('tokenBalancesChanged'), 5000);
        }
        // EVM
        if (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.confirmTransactionStatus) {
            yield (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.confirmTransactionStatus(txHash));
            dynamicEvents.emit('tokenBalancesChanged');
        }
    });
    const networkCurrency = (currentToken === null || currentToken === void 0 ? void 0 : currentToken.symbol) || networkData.nativeCurrency.symbol;
    const currencyIcon = (chain === null || chain === void 0 ? void 0 : chain.name) && (jsxRuntimeExports.jsx(ChainIcon, { chain: chain, chainName: chain.name }));
    const buildFormStage = () => (jsxRuntimeExports.jsx(SendBalancePageLayout, { transaction: transaction, onClickBack: onClickBack, networkName: networkData.vanityName || networkData.name, networkIcon: currencyIcon, networkCurrencyDecimals: networkData.nativeCurrency.symbol === 'SOL'
            ? 9
            : networkData.nativeCurrency.decimals, walletAddress: shortenWalletAddress(currentToken === null || currentToken === void 0 ? void 0 : currentToken.address, 3, 3), walletKey: primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector.key, onClickClose: onClickClose, displayPoweredByDynamicFooter: displayPoweredByDynamicFooter, onSubmit: () => setStage('confirmation'), tokenBalances: tokenBalances !== null && tokenBalances !== void 0 ? tokenBalances : (currentToken && [currentToken]), currentToken: currentToken, setCurrentToken: setCurrentToken, isLoading: isLoading, isNativeToken: isNativeToken }));
    const buildTransactionStage = () => (jsxRuntimeExports.jsx(TransactionConfirmationView, { walletConnector: primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector, transaction: transaction, mutation: () => {
            walletUiUtils.disabledConfirmationOnce();
            return transaction.submit();
        }, copykey: 'dyn_send_transaction.confirmation.title', title: t('dyn_send_transaction.confirmation.title'), onClickBack: () => setStage('form'), onError: onError, displayPoweredByDynamicFooter: displayPoweredByDynamicFooter, onSuccess: (txHash) => __awaiter$1(void 0, void 0, void 0, function* () {
            if (!txHash)
                return;
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(txHash);
            setStage('success');
            handleSuccessToRefreshBalance(txHash);
        }), currentToken: currentToken, isNativeToken: isNativeToken, transactionValue: getTransactionValue(transaction, isNativeToken), sendBalanceTransaction: true }));
    const buildSuccessState = () => {
        var _a;
        return (jsxRuntimeExports.jsx(TransactionStatusLayout, { transactionValue: getTransactionValue(transaction, isNativeToken), destinationAddress: (_a = transaction.to) !== null && _a !== void 0 ? _a : '', networkCurrency: networkCurrency, networkName: networkData.name || '', NetworkIcon: currencyIcon, onClickClose: onClickClose, onDone: () => onDone === null || onDone === void 0 ? void 0 : onDone(), displayPoweredByDynamicFooter: displayPoweredByDynamicFooter, transaction: transaction, currentToken: currentToken, isNativeToken: isNativeToken }));
    };
    const getCurrentView = () => {
        switch (stage) {
            case 'form':
                return buildFormStage();
            case 'confirmation':
                return buildTransactionStage();
            case 'success':
                return buildSuccessState();
        }
    };
    return getCurrentView();
};

const SendBalanceModal = ({ initialRecipientAddress, initialValue, onReject, onSuccess, }) => {
    usePreventPageScroll(true);
    const [show, setShow] = useState(true);
    const errorRef = useRef(null);
    const receiptRef = useRef(null);
    const handleOnModalUnmount = useCallback(() => {
        if (receiptRef.current) {
            onSuccess(receiptRef.current);
            return;
        }
        onReject(errorRef.current || new UserRejectedTransactionError());
    }, [onReject, onSuccess]);
    const closeModal = () => {
        setShow(false);
    };
    return (jsxRuntimeExports.jsx(Portal, { handleClose: closeModal, isShown: show, zIndex: authModalZIndex, withBackdrop: true, elementId: 'dynamic-send-balance', transitionEvents: {
            onUnmount: handleOnModalUnmount,
        }, children: jsxRuntimeExports.jsx(Modal, { children: jsxRuntimeExports.jsx(ModalCard, { children: jsxRuntimeExports.jsx(VerticalDrawerTransition, { isShown: true, children: jsxRuntimeExports.jsx(PopperProvider, { children: jsxRuntimeExports.jsx(SendBalanceView, { initialRecipientAddress: initialRecipientAddress, initialValue: initialValue, onError: (error) => (errorRef.current = error), onClickClose: closeModal, onDone: closeModal, displayPoweredByDynamicFooter: true, onSuccess: (receipt) => {
                                errorRef.current = null;
                                receiptRef.current = receipt;
                            } }) }) }) }) }) }));
};

const noWalletError = new DynamicError('No wallet connected');
const invalidWalletTypeError = new DynamicError('Primary wallet must use embedded wallet');

const SendBalanceContext = createContext(undefined);
const SendBalanceContextProvider = ({ children, }) => {
    const { primaryWallet } = useInternalDynamicContext();
    const { open, modal } = useConfirmationModal({
        elementId: 'dynamic-send-balance',
    });
    const openSendBalanceModal = useCallback((props) => __awaiter$1(void 0, void 0, void 0, function* () {
        return open((resolve, reject) => {
            if (!primaryWallet) {
                throw noWalletError;
            }
            if (!isSendBalanceWalletConnector(primaryWallet.connector)) {
                throw invalidWalletTypeError;
            }
            return (jsxRuntimeExports.jsx(SendBalanceModal, { onReject: reject, onSuccess: resolve, initialRecipientAddress: props === null || props === void 0 ? void 0 : props.recipientAddress, initialValue: props === null || props === void 0 ? void 0 : props.value }));
        });
    }), [open, primaryWallet]);
    return (jsxRuntimeExports.jsxs(SendBalanceContext.Provider, { value: { open: openSendBalanceModal }, children: [modal, children] }));
};
const useSendBalance = () => {
    const context = useContext(SendBalanceContext);
    if (context === undefined) {
        throw new Error('usage of useSendBalance not wrapped in `SendBalanceContextProvider`.');
    }
    const passkeyContext = useContext(PasskeyContext);
    if (passkeyContext === undefined) {
        throw new Error('usage of useSendBalance not wrapped in `PasskeyContextProvider`.');
    }
    return context;
};

var _path$15, _path2$5;
var _excluded$1e = ["title", "titleId"];
function _extends$1e() { return _extends$1e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1e.apply(null, arguments); }
function _objectWithoutProperties$1e(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1e(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1e(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgCopy = function SvgCopy(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1e(_ref, _excluded$1e);
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$15 || (_path$15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.333 1.667a2.5 2.5 0 0 0-2.5 2.5v1.666H7.5V4.167c0-.46.373-.834.833-.834h7.5c.46 0 .833.373.833.834v7.5c0 .46-.373.833-.833.833h-1.667v1.667h1.667a2.5 2.5 0 0 0 2.5-2.5v-7.5a2.5 2.5 0 0 0-2.5-2.5h-7.5Z",
    fill: "currentColor"
  })), _path2$5 || (_path2$5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.667 8.333a2.5 2.5 0 0 1 2.5-2.5h7.5a2.5 2.5 0 0 1 2.5 2.5v7.5a2.5 2.5 0 0 1-2.5 2.5h-7.5a2.5 2.5 0 0 1-2.5-2.5v-7.5Zm2.5-.833a.833.833 0 0 0-.833.833v7.5c0 .46.373.834.833.834h7.5c.46 0 .833-.373.833-.834v-7.5a.833.833 0 0 0-.833-.833h-7.5Z",
    fill: "currentColor"
  })));
};

var _path$14;
var _excluded$1d = ["title", "titleId"];
function _extends$1d() { return _extends$1d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1d.apply(null, arguments); }
function _objectWithoutProperties$1d(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1d(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1d(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgEyeOutline = function SvgEyeOutline(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1d(_ref, _excluded$1d);
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$14 || (_path$14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.512 12a9.004 9.004 0 0 0 16.977 0 9.004 9.004 0 0 0-16.977 0Zm-2.008-.3C2.906 7.238 7.074 4 12 4c4.927 0 9.095 3.238 10.497 7.7a1 1 0 0 1 0 .6C21.095 16.762 16.927 20 12 20c-4.927 0-9.095-3.238-10.497-7.7a1 1 0 0 1 0-.6ZM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "#ABACB2"
  })));
};

var _path$13;
var _excluded$1c = ["title", "titleId"];
function _extends$1c() { return _extends$1c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1c.apply(null, arguments); }
function _objectWithoutProperties$1c(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1c(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1c(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgKey = function SvgKey(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1c(_ref, _excluded$1c);
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$13 || (_path$13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 3a3.751 3.751 0 0 0-3.59 4.84.743.743 0 0 1-.187.746L3 13.062V15h1.5v-.75a.75.75 0 0 1 .75-.75H6v-.75a.75.75 0 0 1 .75-.75h1.188l1.476-1.473a.743.743 0 0 1 .746-.187A3.751 3.751 0 1 0 11.25 3ZM6 15v.75a.75.75 0 0 1-.75.75H3A1.5 1.5 0 0 1 1.5 15v-1.938c0-.398.156-.78.438-1.062l4.171-4.172A5.251 5.251 0 0 1 11.25 1.5a5.251 5.251 0 0 1 5.251 5.25 5.251 5.251 0 0 1-6.328 5.14l-1.39 1.391a.75.75 0 0 1-.532.219H7.5v.75a.75.75 0 0 1-.75.75Zm4.5-9.75a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25.75.75 0 0 1-1.5 0 .75.75 0 0 0-.75-.75.75.75 0 0 1-.75-.75Zm0 0",
    fill: "currentColor"
  })));
};

var _path$12;
var _excluded$1b = ["title", "titleId"];
function _extends$1b() { return _extends$1b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1b.apply(null, arguments); }
function _objectWithoutProperties$1b(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1b(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1b(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgWalletV2 = function SvgWalletV2(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1b(_ref, _excluded$1b);
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$12 || (_path$12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 4a1 1 0 0 0 0 2h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3h-14a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h12a1 1 0 1 1 0 2h-12Zm-1 3.83V19a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-14c-.35 0-.687-.06-1-.17Zm11 6.17a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
    fill: "#ABACB2"
  })));
};

var _path$11;
var _excluded$1a = ["title", "titleId"];
function _extends$1a() { return _extends$1a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1a.apply(null, arguments); }
function _objectWithoutProperties$1a(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1a(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1a(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgEmbeddedWalletIcon = function SvgEmbeddedWalletIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1a(_ref, _excluded$1a);
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$11 || (_path$11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32Zm8.334-45.333a3.333 3.333 0 0 0-3.333-3.334h-15a6.669 6.669 0 0 0-6.56 5.473 6.649 6.649 0 0 1 4.893-2.14h20ZM42 22a6.667 6.667 0 0 1 6.667 6.667V42A6.667 6.667 0 0 1 42 48.667H22A6.667 6.667 0 0 1 15.334 42V28.667A6.667 6.667 0 0 1 22 22h20Z",
    fill: "#4779FF",
    "data-testid": "wallet-icon-embedded"
  })));
};

var _path$10, _path2$4;
var _excluded$19 = ["title", "titleId"];
function _extends$19() { return _extends$19 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$19.apply(null, arguments); }
function _objectWithoutProperties$19(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$19(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$19(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSmartWallet = function SvgSmartWallet(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$19(_ref, _excluded$19);
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$10 || (_path$10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm4.667-23.467c0-1.03-.836-1.866-1.867-1.866h-8.4A3.734 3.734 0 0 0 6.727 9.73a3.723 3.723 0 0 1 2.74-1.198h11.2ZM21.6 10.4a3.733 3.733 0 0 1 3.733 3.733V21.6a3.733 3.733 0 0 1-3.733 3.733H10.4A3.733 3.733 0 0 1 6.667 21.6v-7.467A3.733 3.733 0 0 1 10.4 10.4h11.2Z",
    fill: "#4779FF"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.455 12.667c.2 0 .38.123.452.31l.572 1.486c.145.379.191.488.254.576a.97.97 0 0 0 .228.228c.088.063.197.109.576.255l1.486.57a.485.485 0 0 1 0 .906l-1.486.571c-.379.146-.488.192-.576.255a.97.97 0 0 0-.228.228c-.063.088-.109.197-.254.576l-.572 1.485a.485.485 0 0 1-.905 0l-.571-1.485c-.146-.379-.192-.488-.254-.576a.97.97 0 0 0-.229-.229c-.088-.062-.197-.108-.576-.254l-1.485-.571a.485.485 0 0 1 0-.905l1.485-.572c.38-.145.488-.191.576-.254a.97.97 0 0 0 .229-.228c.062-.088.108-.197.254-.576l.571-1.486a.485.485 0 0 1 .453-.31ZM13.333 18c.184 0 .352.104.434.268l.38.76c.137.275.18.353.23.42.05.065.11.124.176.175.066.051.144.093.418.23l.761.38a.485.485 0 0 1 0 .867l-.76.38c-.274.138-.353.18-.42.23a.968.968 0 0 0-.175.176c-.05.066-.093.145-.23.419l-.38.76a.485.485 0 0 1-.867 0l-.38-.76c-.138-.274-.18-.353-.23-.419a.968.968 0 0 0-.176-.176c-.066-.05-.145-.092-.419-.23l-.76-.38a.485.485 0 0 1 0-.867l.76-.38c.274-.137.353-.179.419-.23a.968.968 0 0 0 .176-.176c.05-.066.092-.144.23-.418l.38-.761a.485.485 0 0 1 .433-.268Z",
    fill: "#4779FF"
  })));
};

// This hook is based on https://usehooks-ts.com/react-hook/use-media-query
const useMediaQuery = (query) => {
    const getMatches = (query) => {
        // Prevents SSR issues
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    };
    const [matches, setMatches] = useState(getMatches(query));
    const handleChange = () => setMatches(getMatches(query));
    useEffect(() => {
        const matchMedia = window.matchMedia(query);
        // Triggered at the first client-side load and if query changes
        handleChange();
        matchMedia.addEventListener('change', handleChange);
        return () => {
            matchMedia.removeEventListener('change', handleChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);
    return matches;
};

const useColorSchemePreference = () => {
    const isDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
    return isDarkMode ? 'dark' : 'light';
};

const useIconThemeVariant = () => {
    const { theme: { theme: { name }, }, } = useThemeContext();
    const preference = useColorSchemePreference();
    const variant = name === 'auto' ? preference : name;
    return variant;
};

const useFindSocialIcon = () => {
    const variant = useIconThemeVariant();
    return useCallback((provider) => findSocialIcon(provider, variant), [variant]);
};

const WalletIconWithNetwork = ({ iconSize = 24, chainName, Icon, showNetwork = true, walletKey, iconUrl, }) => {
    const ChainIcon = chainName ? getChainIcon(chainName) : undefined;
    return (jsxRuntimeExports.jsxs("div", { className: 'wallet-icon-with-network__container', children: [Icon ? (jsxRuntimeExports.jsx(Icon, { style: {
                    height: pixelToRem(iconSize),
                    width: pixelToRem(iconSize),
                } })) : (jsxRuntimeExports.jsx(WalletIcon, { icon: iconUrl, walletKey: walletKey, style: {
                    height: pixelToRem(iconSize),
                    width: pixelToRem(iconSize),
                } })), ChainIcon && showNetwork && (jsxRuntimeExports.jsx("div", { "data-testid": 'network-container', className: classNames('wallet-icon-with-network__network-container'), children: jsxRuntimeExports.jsx(ChainIcon, {}) }))] }));
};

const getWalletIcon = ({ findSocialIcon, wallet, user, }) => {
    if (isEmailOTPWalletConnector(wallet.connector)) {
        return SignInWithEmailIcon;
    }
    if (isSocialWalletConnector(wallet.connector)) {
        const socialAccountDataForWallet = getReferencedAccount(user, wallet.id);
        if (!socialAccountDataForWallet ||
            !socialAccountDataForWallet.oauthProvider) {
            return SignInWithEmailIcon;
        }
        const { oauthProvider } = socialAccountDataForWallet;
        try {
            const MagicSocialWalletIcon = findSocialIcon(oauthProvider);
            return MagicSocialWalletIcon;
        }
        catch (err) {
            logger$1.error(err);
        }
    }
    if (isAccountAbstractionConnector(wallet.connector)) {
        return SvgSmartWallet;
    }
    if (isEmbeddedConnector(wallet.connector)) {
        return SvgEmbeddedWalletIcon;
    }
    return null;
};
const AuthProviderIcon = ({ iconSize = 64, showNetworkIcon = false, wallet, }) => {
    const { primaryWallet, selectedWalletConnector, user, userWithMissingInfo } = useInternalDynamicContext();
    const { deniedOauthProvider, deniedAddress } = useAccessDeniedContext();
    const { isLoadingEmbeddedWallet } = useWalletContext();
    const findSocialIcon = useFindSocialIcon();
    if (deniedOauthProvider) {
        const MagicSocialWalletIcon = findSocialIcon(deniedOauthProvider);
        if (!MagicSocialWalletIcon) {
            return null;
        }
        return (jsxRuntimeExports.jsx(MagicSocialWalletIcon, { style: {
                height: pixelToRem(iconSize),
                width: pixelToRem(iconSize),
            } }));
    }
    // it means that user tried to login with actual wallet and no magic social and failed to go through the access list
    if (deniedAddress) {
        return (jsxRuntimeExports.jsx(WalletIcon, { walletKey: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.key, icon: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.metadata.icon, style: { height: pixelToRem(iconSize), width: pixelToRem(iconSize) } }));
    }
    const walletForIcon = wallet ? wallet : primaryWallet;
    if (!walletForIcon) {
        if (isLoadingEmbeddedWallet) {
            return (jsxRuntimeExports.jsx(WalletIconWithNetwork, { iconSize: iconSize, Icon: SvgEmbeddedWalletIcon, chainName: 'EVM', showNetwork: false }));
        }
        return null;
    }
    const Icon = getWalletIcon({
        findSocialIcon,
        user: user !== null && user !== void 0 ? user : userWithMissingInfo,
        wallet: walletForIcon,
    });
    return (jsxRuntimeExports.jsx(WalletIconWithNetwork, { iconSize: iconSize, Icon: Icon !== null && Icon !== void 0 ? Icon : null, chainName: walletForIcon.chain, showNetwork: showNetworkIcon, walletKey: walletForIcon.key, iconUrl: walletForIcon.connector.metadata.icon }));
};

const replaceAll = (text, char, replace) => {
    const re = new RegExp(char, 'g');
    return text.replace(re, replace);
};
const copyToClipboard = (textToCopy) => {
    navigator.clipboard.writeText(textToCopy);
};
/** Applies Math.floor, but takes into account edge cases, like how 2.99999 should be 3 */
// First apply ceil with very high accuracy, to account for floating point inaccuracies
// const smartFloor = (value: number) => Math.floor(value);
const smartFloor = (value) => Math.floor(ceil(value, 13));
const WITHOUT_DECIMAL_VALUE = 1000;
const MAX_BALANCE_VALUE = 1000000;
const PRECISION_FLOOR_DIVIDER = 10000;
const roundBalance = (balanceString, decimals = 4) => {
    const clearedBalance = parseFloat(replaceAll(balanceString, '"', ''));
    if (clearedBalance > MAX_BALANCE_VALUE) {
        const dividedValue = Math.floor(clearedBalance);
        const roundedBalance = Math.floor((dividedValue / MAX_BALANCE_VALUE) * PRECISION_FLOOR_DIVIDER) /
            PRECISION_FLOOR_DIVIDER;
        return `${roundedBalance}M`;
    }
    if (clearedBalance > WITHOUT_DECIMAL_VALUE) {
        return String(Math.floor(clearedBalance));
    }
    const decimalsPrecision = Math.pow(10, decimals);
    const minBalanceValue = 1 / decimalsPrecision;
    if (clearedBalance < minBalanceValue && clearedBalance > 0)
        return `< ${minBalanceValue}`;
    const roundedBalance = smartFloor(clearedBalance * decimalsPrecision) / decimalsPrecision;
    if (roundedBalance === 0)
        return '0.0';
    return String(roundedBalance);
};
const capitalize$2 = (text) => text.charAt(0).toUpperCase() + text.slice(1);
const getExportKeysOption = (connector, providerSettings) => {
    var _a;
    if (!connector || !(providerSettings === null || providerSettings === void 0 ? void 0 : providerSettings.length) || !isMagicConnector(connector)) {
        return;
    }
    const keyExportUrl = (_a = providerSettings.find((provider) => provider.provider === ProviderEnum.MagicLink)) === null || _a === void 0 ? void 0 : _a.keyExportUrl;
    if (!keyExportUrl) {
        return;
    }
    return () => {
        window.open(keyExportUrl, '_blank');
    };
};

const NetworkControlSkeleton = ({ className, }) => (jsxRuntimeExports.jsxs("div", { className: classNames('network-control-skeleton', className), "data-testid": 'network-control-loading', children: [jsxRuntimeExports.jsx("div", { className: 'network-control-skeleton__icon' }), jsxRuntimeExports.jsx(Skeleton, { className: 'network-control-skeleton__skeleton' })] }));

const UnsupportedNetwork = ({ showMsg }) => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Icon, { size: 'small', children: jsxRuntimeExports.jsx(SvgError, {}) }), showMsg && (jsxRuntimeExports.jsx(Typography, { className: 'evm-network-control__network-name', as: 'span', color: 'error-1', variant: 'body_small', copykey: 'dyn_network_not_supported.button', children: t('dyn_network_not_supported.button') }))] }));
};

const NetworkSwitchControl = ({ enabledNetworks, className = '', activeClassName = '', network, walletConnector, isOpen, setIsOpen, showNetworkName = false, }) => {
    var _a, _b;
    const currentNetwork = enabledNetworks.find((element) => network && element.chainId === parseChainId(network));
    if (!enabledNetworks.length) {
        return (jsxRuntimeExports.jsx("div", { "data-testid": 'NetworkSwitchControl', className: classNames('network-switch-control__container network-switch-control__container--error', className), children: jsxRuntimeExports.jsx(UnsupportedNetwork, { showMsg: showNetworkName }) }));
    }
    if (!network) {
        // If this connector is not available, just show the chain name and icon
        // since it will never be able to load a network
        if (!walletConnector.isAvailable) {
            const FallbackChainIcon = getChainIcon(walletConnector.connectedChain);
            const fallbackChainName = (_a = getChainInfo(walletConnector.connectedChain)) === null || _a === void 0 ? void 0 : _a.displayName;
            return (jsxRuntimeExports.jsxs("div", { "data-testid": 'NetworkSwitchControl', className: classNames(className, 'network-switch-control__container'), children: [jsxRuntimeExports.jsx(Icon, { size: 'small', children: jsxRuntimeExports.jsx(FallbackChainIcon, {}) }), showNetworkName && (jsxRuntimeExports.jsx(Typography, { className: 'network-switch-control__network-name', as: 'span', variant: 'body_small', children: fallbackChainName }))] }));
        }
        return (jsxRuntimeExports.jsx("div", { "data-testid": 'NetworkSwitchControl', className: classNames('network-switch-control__container', className), children: jsxRuntimeExports.jsx(NetworkControlSkeleton, {}) }));
    }
    if (enabledNetworks.length === 1) {
        const unsupportedNetworkClassName = classNames(className, 'network-switch-control__container', 'network-switch-control__container--error', {
            [activeClassName]: isOpen,
        });
        if (!currentNetwork) {
            return (jsxRuntimeExports.jsxs("button", { "data-testid": 'NetworkSwitchControl', type: 'button', onClick: () => setIsOpen(!isOpen), className: unsupportedNetworkClassName, children: [jsxRuntimeExports.jsx(UnsupportedNetwork, { showMsg: showNetworkName }), jsxRuntimeExports.jsx(Icon, { color: 'text-primary', size: 'small', className: classNames('network-switch-control__arrow-icon', {
                            'network-switch-control__arrow-icon--active': isOpen,
                        }), children: jsxRuntimeExports.jsx(SvgStroke, {}) })] }));
        }
        return (jsxRuntimeExports.jsxs("div", { "data-testid": 'NetworkSwitchControl', onClick: () => network && setIsOpen(!isOpen), className: classNames('network-switch-control__container', {
                [activeClassName]: isOpen,
            }, className), children: [currentNetwork.iconUrls.length > 0 && (jsxRuntimeExports.jsx(Icon, { size: 'small', children: jsxRuntimeExports.jsx("img", { src: currentNetwork.iconUrls[0], alt: `${currentNetwork.name} icon` }) })), showNetworkName && (jsxRuntimeExports.jsx(Typography, { className: 'network-switch-control__network-name', as: 'span', variant: 'body_small', children: currentNetwork.vanityName || currentNetwork.name }))] }));
    }
    return (jsxRuntimeExports.jsxs("button", { "data-testid": 'NetworkSwitchControl', type: 'button', onClick: (e) => {
            e.stopPropagation();
            network && setIsOpen(!isOpen);
        }, className: classNames(className, 'network-switch-control__container', {
            [activeClassName]: isOpen,
            'network-switch-control__container--error': !(currentNetwork === null || currentNetwork === void 0 ? void 0 : currentNetwork.name),
        }), children: [(currentNetwork === null || currentNetwork === void 0 ? void 0 : currentNetwork.name) ? (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [((_b = currentNetwork === null || currentNetwork === void 0 ? void 0 : currentNetwork.iconUrls) === null || _b === void 0 ? void 0 : _b[0]) && (jsxRuntimeExports.jsx(Icon, { size: 'small', children: jsxRuntimeExports.jsx("img", { src: currentNetwork.iconUrls[0], alt: `${currentNetwork.name} icon` }) })), showNetworkName && (jsxRuntimeExports.jsx(Typography, { className: 'network-switch-control__network-name', as: 'span', variant: 'body_small', children: currentNetwork.vanityName || currentNetwork.name }))] })) : (jsxRuntimeExports.jsx(UnsupportedNetwork, { showMsg: showNetworkName })), enabledNetworks.length > 1 && (jsxRuntimeExports.jsx(Icon, { color: 'text-primary', size: 'small', className: classNames('network-switch-control__arrow-icon', {
                    'network-switch-control__arrow-icon--active': isOpen,
                }), children: jsxRuntimeExports.jsx(SvgStroke, {}) }))] }));
};

const capitalize$1 = (value) => { var _a; return ((_a = value[0]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) + value.slice(1).toLowerCase(); };

const NonNetworkSwitchingSupportedControl = ({ walletConnector, className, showNetworkName = false, }) => {
    const { chain, isLoading } = useFetchChain(walletConnector);
    const chainName = (chain === null || chain === void 0 ? void 0 : chain.name) || '';
    const ChainIcon = getChainIcon(walletConnector.connectedChain || '');
    if (isLoading) {
        return jsxRuntimeExports.jsx(NetworkControlSkeleton, { className: className });
    }
    return (jsxRuntimeExports.jsxs("div", { "data-testid": 'NonNetworkSwitchingSupportedControl', className: classNames('non-network-switching-supported-control', className), children: [jsxRuntimeExports.jsx(Icon, { size: 'small', children: (chain === null || chain === void 0 ? void 0 : chain.icon) ? (jsxRuntimeExports.jsx("img", { src: chain.icon, alt: `${chain.name} icon` })) : (jsxRuntimeExports.jsx(ChainIcon, {})) }), showNetworkName && (jsxRuntimeExports.jsx(Typography, { className: classNames('non-network-switching-supported-control__network-name'), as: 'span', variant: 'body_small', children: capitalize$1(chainName) }))] }));
};

const NetworkControl = ({ loading, walletConnector, buttonClassName, network, activeClassName, isOpen, setIsOpen, showNetworkName, }) => {
    const enabledNetworks = walletConnector.getEnabledNetworks();
    // Checks when switching to EVM if the network is still loading.
    // if network is a string the user is switching chains
    // this prevents the network control from flickering
    const chainSwitchLoading = walletConnector.connectedChain === ChainEnum.Evm &&
        typeof network === 'string';
    if (loading || chainSwitchLoading) {
        return jsxRuntimeExports.jsx(NetworkControlSkeleton, { className: buttonClassName });
    }
    if (!walletConnector.supportsNetworkSwitching()) {
        return (jsxRuntimeExports.jsx(NonNetworkSwitchingSupportedControl, { className: buttonClassName, showNetworkName: showNetworkName, walletConnector: walletConnector }));
    }
    return (jsxRuntimeExports.jsx(NetworkSwitchControl, { showNetworkName: showNetworkName, enabledNetworks: enabledNetworks, activeClassName: activeClassName, className: buttonClassName, network: network, loading: loading, isOpen: isOpen, walletConnector: walletConnector, setIsOpen: setIsOpen }));
};

var _path$$;
var _excluded$18 = ["title", "titleId"];
function _extends$18() { return _extends$18 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$18.apply(null, arguments); }
function _objectWithoutProperties$18(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$18(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$18(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgCheck = function SvgCheck(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$18(_ref, _excluded$18);
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$$ || (_path$$ = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.496 3.67a.583.583 0 0 1 0 .826l-5.834 5.833a.583.583 0 0 1-.824 0L2.504 7.996a.583.583 0 1 1 .825-.825L5.25 9.09l5.42-5.42a.583.583 0 0 1 .826 0Z",
    fill: "currentColor"
  })));
};

const defaultCustomColor = '#4779FF';
const Spinner = ({ className = '', size = 16, customSpinnerColor = '', }) => {
    const { theme } = useThemeContext();
    const color = customSpinnerColor || theme.customColor || defaultCustomColor;
    return (jsxRuntimeExports.jsxs("svg", { style: {
            height: pixelToRem(size),
            width: pixelToRem(size),
        }, viewBox: '0 0 42 42', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', className: className, "data-testid": 'spinner', children: [jsxRuntimeExports.jsx("mask", { id: 'path-1-inside-1_1433_60360', fill: 'white', children: jsxRuntimeExports.jsx("path", { d: 'M40.53 42C41.3419 42 42.0027 41.3416 41.9743 40.5303C41.7987 35.5162 40.726 30.5699 38.8029 25.9273C36.6922 20.8316 33.5985 16.2016 29.6985 12.3015C25.7984 8.40145 21.1684 5.30776 16.0727 3.19706C11.4301 1.27403 6.48384 0.201284 1.46972 0.0257219C0.658363 -0.00268681 0 0.658141 0 1.47C0 2.28186 0.658382 2.93711 1.46967 2.96766C6.09758 3.1419 10.6617 4.138 14.9476 5.91326C19.6866 7.87621 23.9925 10.7534 27.6196 14.3804C31.2467 18.0075 34.1238 22.3134 36.0867 27.0524C37.862 31.3383 38.8581 35.9024 39.0323 40.5303C39.0629 41.3416 39.7181 42 40.53 42Z' }) }), jsxRuntimeExports.jsx("path", { d: 'M40.53 42C41.3419 42 42.0027 41.3416 41.9743 40.5303C41.7987 35.5162 40.726 30.5699 38.8029 25.9273C36.6922 20.8316 33.5985 16.2016 29.6985 12.3015C25.7984 8.40145 21.1684 5.30776 16.0727 3.19706C11.4301 1.27403 6.48384 0.201284 1.46972 0.0257219C0.658363 -0.00268681 0 0.658141 0 1.47C0 2.28186 0.658382 2.93711 1.46967 2.96766C6.09758 3.1419 10.6617 4.138 14.9476 5.91326C19.6866 7.87621 23.9925 10.7534 27.6196 14.3804C31.2467 18.0075 34.1238 22.3134 36.0867 27.0524C37.862 31.3383 38.8581 35.9024 39.0323 40.5303C39.0629 41.3416 39.7181 42 40.53 42Z', stroke: 'url(#paint0_linear_1433_60360)', strokeWidth: '4', mask: 'url(#path-1-inside-1_1433_60360)' }), jsxRuntimeExports.jsx("defs", { children: jsxRuntimeExports.jsxs("linearGradient", { id: 'paint0_linear_1433_60360', x1: '41', y1: '42', x2: '1.5', y2: '-1.82007e-07', gradientUnits: 'userSpaceOnUse', children: [jsxRuntimeExports.jsx("stop", { stopColor: color }), jsxRuntimeExports.jsx("stop", { offset: '1', stopColor: color, stopOpacity: '0' })] }) })] }));
};

const Network = ({ iconUrl, isActive, networkName, className, checkboxClassName = '', isChanging, notSupported = false, }) => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsxs("div", { className: classNames('network', className, {
            'network--not-supported': notSupported,
        }), children: [jsxRuntimeExports.jsxs("div", { className: 'network__container', children: [iconUrl ? (jsxRuntimeExports.jsx("img", { src: iconUrl, className: 'network__title-icon', alt: `${networkName} icon` })) : (jsxRuntimeExports.jsx(SvgError, {})), jsxRuntimeExports.jsxs("div", { className: 'network__title-container', children: [jsxRuntimeExports.jsx(Typography, { variant: 'button_primary', className: 'network__title-copy', as: 'span', weight: 'medium', color: notSupported ? 'secondary' : 'primary', children: networkName }), notSupported && (jsxRuntimeExports.jsx(Typography, { variant: 'body_mini', className: 'network__title-copy', as: 'span', weight: 'medium', color: notSupported ? 'secondary' : 'primary', "data-testid": 'network-not-supported', children: t('dyn_network_not_supported.wallet') }))] })] }), jsxRuntimeExports.jsxs("div", { className: classNames('network__status-container', {
                    'network__status-container--active': isActive,
                }, checkboxClassName), "data-testid": 'single-network-checkbox', children: [isActive && jsxRuntimeExports.jsx(SvgCheck, { className: 'network__status-icon' }), isChanging && (jsxRuntimeExports.jsx(Spinner, { className: 'network__status-spinner-icon', size: 12 }))] })] }));
};

const NetworkAction = ({ iconUrl, networkId, network, onClick, networkName, checkboxClassName = '', newNetworkId, notSupported, }) => (jsxRuntimeExports.jsx("div", { className: classNames('network-action', {
        'network--not-supported': notSupported,
    }), onClick: () => {
        !notSupported && onClick(networkId);
    }, "data-testid": 'network-action', children: jsxRuntimeExports.jsx(Network, { iconUrl: iconUrl, isActive: networkId === network, networkName: networkName, checkboxClassName: checkboxClassName, isChanging: newNetworkId === networkId, notSupported: notSupported }) }));

// Network is not supported if:
//   - its undefined
//   - its not in supportedNetworks
const isNetworkUnsupported = (network, supportedNetworks) => !(supportedNetworks === null || supportedNetworks === void 0 ? void 0 : supportedNetworks.find((supportedNetwork) => { var _a; return network && ((_a = supportedNetwork.chainId) === null || _a === void 0 ? void 0 : _a.toString()) === network.toString(); }));

const NetworkDropdown = ({ anchorRef, connector, customCallbackOnSuccess, setIsNetworkPickerOpen, isNetworkPickerOpen, currentNetwork, className, checkboxClassName, }) => {
    const [newNetworkId, setNewNetworkId] = useState(undefined);
    const { data: wcSupportedWalletNetworks } = usePromise(() => isWalletConnectConnector(connector)
        ? connector === null || connector === void 0 ? void 0 : connector.getSupportedNetworks()
        : Promise.resolve(undefined), {
        deps: [connector, isNetworkPickerOpen],
        enabled: connector.isWalletConnect,
        initialData: undefined,
    });
    if (!connector) {
        return null;
    }
    const enabledNetworks = connector.getEnabledNetworks();
    const shouldAllowOpenDropdown = isNetworkUnsupported(currentNetwork, enabledNetworks) ||
        enabledNetworks.length > 1;
    if (!shouldAllowOpenDropdown) {
        return null;
    }
    const handleNetworkChange = (networkId) => __awaiter$1(void 0, void 0, void 0, function* () {
        setNewNetworkId(networkId);
        try {
            yield connector.switchNetwork({
                networkChainId: networkId,
            });
            customCallbackOnSuccess === null || customCallbackOnSuccess === void 0 ? void 0 : customCallbackOnSuccess();
        }
        catch (error) {
            /* istanbul ignore next */
            logger$1.debug(error);
        }
        finally {
            setNewNetworkId(undefined);
            setIsNetworkPickerOpen(false);
        }
    });
    return (jsxRuntimeExports.jsx(MenuList, { className: className, isOpen: isNetworkPickerOpen, onClickClose: () => setIsNetworkPickerOpen(false), popperProps: {
            anchorOrigin: 'bottom-left',
            anchorRef,
        }, mobileTitle: 'Select network', children: enabledNetworks.map(({ name, networkId, vanityName, iconUrls }) => (jsxRuntimeExports.jsx(NetworkAction, { iconUrl: iconUrls === null || iconUrls === void 0 ? void 0 : iconUrls[0], networkId: networkId, networkName: vanityName || name, network: currentNetwork, onClick: handleNetworkChange, checkboxClassName: checkboxClassName, newNetworkId: newNetworkId, notSupported: wcSupportedWalletNetworks &&
                !wcSupportedWalletNetworks.includes(`${networkId}`) }, networkId))) }));
};

const NetworkPicker = ({ activeClassName = '', buttonClassName = '', checkboxClassName = '', connector, listClassName = '', mainClassName = '', showNetworkName, customCallbackOnSuccess, currentNetwork, isLoading = false, }) => {
    const [isNetworkPickerOpen, setIsNetworkPickerOpen] = useState(false);
    const pickerRef = useRef(null);
    const { loadingNetwork } = useInternalDynamicContext();
    // Ref to anchor popper to
    const anchorRef = useRef(null);
    if (!connector) {
        return null;
    }
    return (jsxRuntimeExports.jsxs("div", { className: classNames('non-widget-network-picker', mainClassName), ref: pickerRef, "data-testid": 'network-picker', children: [jsxRuntimeExports.jsxs("div", { className: 'network-picker-network-control', children: [jsxRuntimeExports.jsx(NetworkControl, { activeClassName: activeClassName, network: currentNetwork, loading: loadingNetwork || isLoading, isOpen: isNetworkPickerOpen, setIsOpen: setIsNetworkPickerOpen, walletConnector: connector, showNetworkName: showNetworkName, buttonClassName: buttonClassName }), jsxRuntimeExports.jsx("div", { ref: anchorRef, className: 'network-picker-network-control__anchor' })] }), jsxRuntimeExports.jsx(NetworkDropdown, { anchorRef: anchorRef, customCallbackOnSuccess: customCallbackOnSuccess, connector: connector, className: listClassName, checkboxClassName: checkboxClassName, isNetworkPickerOpen: isNetworkPickerOpen, setIsNetworkPickerOpen: setIsNetworkPickerOpen, currentNetwork: currentNetwork })] }));
};

const useFetchNameService = (address) => {
    const { getNameService, network } = useInternalDynamicContext();
    const { data: nameService } = usePromise(() => getNameService(address), {
        deps: [address, network, getNameService],
    });
    return nameService;
};

const StatusDot = ({ variant, containerClassName }) => (jsxRuntimeExports.jsx("div", { "data-testid": 'status-dot-container', className: classNames('status-dot__container', containerClassName || ''), children: jsxRuntimeExports.jsx("div", { "data-testid": 'status-dot', className: classNames('status-dot', `status-dot--${variant}`) }) }));

const Balance = ({ wallet, network, className }) => {
    const { currency, isLoading: isLoadingCurrency } = useFetchCurrency(wallet.connector, network);
    const { balance, isLoading: isLoadingBalance } = useFetchBalance({
        chain: currency === null || currency === void 0 ? void 0 : currency.symbol,
        network,
        wallet,
    });
    if (!balance)
        return null;
    return (jsxRuntimeExports.jsxs(Typography, { className: className, variant: 'body_normal', color: 'primary', children: [isLoadingBalance ? (jsxRuntimeExports.jsx(Skeleton, { className: 'balance-skeleton' })) : (roundBalance(balance)), ' ', !isLoadingCurrency && (jsxRuntimeExports.jsx(Typography, { as: 'span', variant: 'body_normal', color: 'secondary', children: currency === null || currency === void 0 ? void 0 : currency.symbol }))] }));
};

const MULTI_ASSET_SUPPORTED_NETWORKS = Object.values(GetAccountBalancesNetworkIdEnum);

const isMultiAssetSupportedNetwork = (walletConnector, network) => {
    const isNetworkMultiAssetSupported = (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain) === ChainEnum.Sol ||
        ((walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain) === ChainEnum.Evm &&
            typeof network === 'number' &&
            MULTI_ASSET_SUPPORTED_NETWORKS.includes(network));
    return Boolean(isNetworkMultiAssetSupported);
};

const CopyButton = ({ children, className = '', textToCopy, onClick, variant = 'text', copykey, buttonPadding = 'small', buttonVariant = 'primary', buttonClassName = '', startSlot, disabled, }) => {
    const [copied, setCopied] = useState(false);
    const [buttonRef, setButtonRef] = useState(null);
    const copyToClipboard = () => {
        navigator.clipboard.writeText(textToCopy);
        setCopied(true);
        onClick === null || onClick === void 0 ? void 0 : onClick();
        setTimeout(() => {
            setCopied(false);
        }, 5000);
    };
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [variant === 'text' ? (jsxRuntimeExports.jsx(TextButton, { className: classNames('copy-button__container', className), onClick: () => copyToClipboard(), onMouseLeave: () => setCopied(false), copykey: copykey, disabled: disabled, children: children })) : (jsxRuntimeExports.jsx(TypographyButton, { buttonRef: setButtonRef, expanded: true, buttonPadding: buttonPadding, buttonVariant: buttonVariant, buttonClassName: buttonClassName, onClick: () => copyToClipboard(), copykey: copykey, startSlot: startSlot, disabled: disabled, children: children })), jsxRuntimeExports.jsx(Tooltip, { className: 'copy-button__tooltip', content: copied ? 'Copied' : 'Copy', targetRef: buttonRef })] }));
};

/** Component for wallet detail overlays */
const WalletDetailsCard = ({ address, open, onClose, }) => {
    const { t } = useTranslation();
    const copyIcon = (jsxRuntimeExports.jsx(Icon, { size: 'small', color: 'text-secondary', children: jsxRuntimeExports.jsx(SvgCopy, {}) }));
    return (jsxRuntimeExports.jsxs(OverlayCard, { isOpen: open, onClose: onClose, children: [jsxRuntimeExports.jsx(OverlayCard.Header, { children: t('dyn_wallet_details_card.header') }), jsxRuntimeExports.jsxs(OverlayCard.Content, { className: 'wallet-details-card__body', children: [jsxRuntimeExports.jsx(Typography, { className: 'wallet-details-card__text', color: 'primary', weight: 'bold', variant: 'body_small', children: t('dyn_wallet_details_card.address') }), jsxRuntimeExports.jsx(Typography, { className: 'wallet-details-card__text', color: 'secondary', weight: 'regular', variant: 'body_small', children: address }), jsxRuntimeExports.jsx(CopyButton, { textToCopy: address, variant: 'button', startSlot: copyIcon, children: t('dyn_wallet_details_card.copy') })] })] }));
};

const ActiveBitcoinWalletAddresses = ({ menuOption, wallet }) => {
    var _a, _b;
    const { t } = useTranslation();
    const ordinalsAddress = (_a = getWalletAdditionalAddressByType(WalletAddressType.Ordinals, wallet)) !== null && _a !== void 0 ? _a : wallet === null || wallet === void 0 ? void 0 : wallet.address;
    const paymenyAddress = (_b = getWalletAdditionalAddressByType(WalletAddressType.Payment, wallet)) !== null && _b !== void 0 ? _b : wallet === null || wallet === void 0 ? void 0 : wallet.address;
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("div", { className: 'active-wallet-information__address-container', children: [jsxRuntimeExports.jsxs("div", { children: [jsxRuntimeExports.jsx(Typography, { className: 'active-wallet-information__address', weight: 'regular', variant: 'body_small', color: 'secondary', children: t('dyn_active_wallet_info.ordinals_address') }), jsxRuntimeExports.jsx(Typography, { className: 'active-wallet-information__address', weight: 'medium', variant: 'body_normal', color: 'primary', children: shortenWalletAddress(ordinalsAddress, 4, 4) })] }), jsxRuntimeExports.jsx(DotsMenu, { "data-testid": 'dots-menu', options: menuOption, buttonClassName: 'active-wallet-information__dots-menu', buttonClassNameWithOpenMenu: 'active-wallet-information__dots-menu' })] }), jsxRuntimeExports.jsxs("div", { className: 'active-wallet-information__address-container', children: [jsxRuntimeExports.jsxs("div", { children: [jsxRuntimeExports.jsx(Typography, { className: 'active-wallet-information__address', weight: 'regular', variant: 'body_small', color: 'secondary', children: t('dyn_active_wallet_info.payment_address') }), jsxRuntimeExports.jsx(Typography, { className: 'active-wallet-information__address', weight: 'regular', variant: 'body_small', color: 'primary', children: shortenWalletAddress(paymenyAddress, 4, 4) })] }), jsxRuntimeExports.jsx(CopyButton, { textToCopy: paymenyAddress !== null && paymenyAddress !== void 0 ? paymenyAddress : '', children: jsxRuntimeExports.jsx(Icon, { size: 'xsmall', children: jsxRuntimeExports.jsx(SvgCopy, {}) }) })] })] }));
};

var _path$_;
var _excluded$17 = ["title", "titleId"];
function _extends$17() { return _extends$17 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$17.apply(null, arguments); }
function _objectWithoutProperties$17(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$17(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$17(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgGear = function SvgGear(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$17(_ref, _excluded$17);
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$_ || (_path$_ = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.353 4.081c.674-2.775 4.62-2.775 5.294 0a.724.724 0 0 0 1.08.448c2.44-1.486 5.23 1.305 3.744 3.744a.724.724 0 0 0 .448 1.08c2.775.674 2.775 4.62 0 5.294a.724.724 0 0 0-.448 1.08c1.486 2.44-1.305 5.23-3.744 3.744a.724.724 0 0 0-1.08.448c-.674 2.775-4.62 2.775-5.294 0a.724.724 0 0 0-1.08-.448c-2.44 1.486-5.23-1.305-3.744-3.744a.724.724 0 0 0-.448-1.08c-2.775-.674-2.775-4.62 0-5.294a.724.724 0 0 0 .448-1.08c-1.486-2.44 1.305-5.23 3.744-3.744a.724.724 0 0 0 1.08-.448Zm3.35.472c-.178-.737-1.227-.737-1.407 0a2.724 2.724 0 0 1-4.064 1.684c-.648-.395-1.39.347-.995.995.96 1.575.109 3.63-1.684 4.064-.737.18-.737 1.229 0 1.408a2.724 2.724 0 0 1 1.684 4.064c-.395.648.347 1.39.995.995a2.724 2.724 0 0 1 4.064 1.684c.18.737 1.229.737 1.408 0a2.724 2.724 0 0 1 4.064-1.684c.648.395 1.39-.347.995-.995a2.724 2.724 0 0 1 1.684-4.064c.737-.18.737-1.229 0-1.408a2.724 2.724 0 0 1-1.684-4.064c.395-.648-.347-1.39-.995-.995-1.575.96-3.63.109-4.064-1.684ZM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "#ABACB2"
  })));
};

const IconWithStatus = ({ Icon, InnerIcon, containerClassName, iconSize = 16, variant = 'green', }) => (jsxRuntimeExports.jsxs("div", { className: classNames('icon-with-status__container', containerClassName || ''), children: [typeof Icon === 'string' ? (jsxRuntimeExports.jsx("img", { style: {
                height: pixelToRem(iconSize),
                width: pixelToRem(iconSize),
            }, src: Icon, alt: '', className: 'icon' })) : (jsxRuntimeExports.jsx(Icon, { style: {
                height: pixelToRem(iconSize),
                width: pixelToRem(iconSize),
            } })), InnerIcon ? (jsxRuntimeExports.jsx("div", { className: 'inner-icon__container', children: jsxRuntimeExports.jsx("div", { className: classNames('inner-icon', `inner-icon--${variant}`), children: jsxRuntimeExports.jsx(InnerIcon, {}) }) })) : (jsxRuntimeExports.jsx(StatusDot, { variant: variant, containerClassName: 'icon-with-status__status-dot' }))] }));

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Hook for handling events from a WalletConnector or an array of WalletConnectors.
 * This hook allows you to specify an event to listen to and a handler function that will be called
 * whenever the event is emitted. The handler will receive the event arguments followed by the instance
 * of the WalletConnector that emitted the event.
 *
 * @template Event - The type of the event to listen for, which should be a key of WalletConnectorEventTypes.
 *
 * @param eventEmitters - The WalletConnector instance(s) to attach the event listener to.
 * If an array is provided, the event listener is attached to all provided connectors.
 * @param eventName - The name of the event to listen for.
 * @param handler - The callback function to execute when the event is emitted.
 * The arguments to the callback are the arguments emitted with the event, followed by the WalletConnector instance
 * that emitted the event.
 *
 * @returns {void} This hook does not return anything.
 *
 * @example
 * // Example usage of useWalletConnectorEvent
 * const { primaryWallet } = useDynamicContext();
 *
 * useWalletConnectorEvent(
 *   primaryWallet?.connector,
 *   'accountChange',
 *   ({ accounts }, connector) => {
 *     console.group('accountChange');
 *     console.log('accounts', accounts);
 *     console.log('connector that emitted', connector);
 *     console.groupEnd();
 *   },
 * );
 */
const useWalletConnectorEvent = (eventEmitters, eventName, handler) => {
    const callbackRef = useRef(handler);
    callbackRef.current = handler;
    useEffect(() => {
        if (!eventEmitters)
            return;
        const eventEmittersArray = Array.isArray(eventEmitters)
            ? eventEmitters
            : [eventEmitters];
        /**
         * Initialize the event listeners for the wallet connectors
         * to ensure they were initialized before listening to events
         */
        eventEmittersArray.forEach((connector) => connector.initEventListener());
        const uniqueEventEmitters = Array.from(new Set(eventEmittersArray));
        const unsubscribeCallbacks = uniqueEventEmitters.map((emitter) => {
            const callback = (...args) => {
                callbackRef.current(...args, emitter);
            };
            emitter.on(eventName, callback);
            return () => emitter.off(eventName, callback);
        });
        return () => unsubscribeCallbacks.forEach((unsubscribe) => unsubscribe());
    }, [eventEmitters, eventName]);
};

/**
 * Sync wallet connector network.
 *
 * @param walletConnector - The WalletConnector instance to be used.
 *
 * @returns {{ network: string | number | undefined }} An object containing the current network state.
 *
 * @example
 * // Example of using the useWalletConnectorNetwork hook
 * const { network } = useWalletConnectorNetwork(walletConnector);
 *
 * // You can then use the 'network' state in your component
 * return <div>Current Network: {network}</div>;
 */
const useWalletConnectorNetwork = (walletConnector, { onChange } = { onChange: () => { } }) => {
    const [network, setNetwork] = useState();
    const { isLoading } = usePromise(() => walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.getNetwork(), {
        deps: [walletConnector],
        onResolve: (network) => {
            setNetwork(network);
        },
    });
    useWalletConnectorEvent(walletConnector || undefined, 'chainChange', ({ chain }) => {
        const parsedChain = (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain) === 'STARK' ? chain : parseInt(chain);
        setNetwork(parsedChain);
        onChange === null || onChange === void 0 ? void 0 : onChange(parsedChain);
    });
    /**
     * Listen to disconnect event and update the network because ArgentX
     * emits a disconnect event when the user switches network.
     */
    useWalletConnectorEvent(walletConnector || undefined, 'disconnect', () => __awaiter$1(void 0, void 0, void 0, function* () {
        if ((walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.key) !== 'argentx')
            return;
        const chain = yield walletConnector.getNetwork();
        setNetwork(chain);
        onChange === null || onChange === void 0 ? void 0 : onChange(chain);
    }));
    return { isLoading, network };
};

/**
 * If the wallet has no icon, returns its key, nicely formatted.
 */
const getNameIfNoIcon = (wallet) => {
    if (!wallet)
        return undefined;
    const noIcon = !wallet.connector.metadata.icon ||
        wallet.connector.metadata.icon.includes('unknown-wallet');
    return noIcon
        ? wallet.key
            .replace(/[-_]/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase())
        : undefined;
};
const ActiveWalletAddress = ({ wallet, nameServiceName, menuOption, fullWidth = false, isLoading = false, }) => {
    const { showAlert } = usePasskeyContext();
    const header = nameServiceName || getNameIfNoIcon(wallet);
    const { network } = useWalletConnectorNetwork(wallet === null || wallet === void 0 ? void 0 : wallet.connector);
    const { data: address } = usePromise(() => {
        // COSMOS wallet address changes based on which network is selected
        if ((wallet === null || wallet === void 0 ? void 0 : wallet.connector.connectedChain) === 'COSMOS') {
            return wallet === null || wallet === void 0 ? void 0 : wallet.connector.getAddress();
        }
        return wallet === null || wallet === void 0 ? void 0 : wallet.address;
    }, {
        deps: [wallet, network],
        enabled: Boolean(wallet),
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'active-wallet-information__address-container', children: [jsxRuntimeExports.jsxs("div", { children: [jsxRuntimeExports.jsx(Typography, { className: fullWidth
                            ? 'active-wallet-information__handle--full-width'
                            : 'active-wallet-information__handle', color: 'primary', variant: 'body_normal', "data-testid": 'header-text', children: header }), jsxRuntimeExports.jsx(Typography, { className: 'active-wallet-information__address', weight: header ? 'regular' : 'medium', variant: header ? 'body_small' : 'body_normal', color: header ? 'secondary' : 'primary', children: isLoading ? (jsxRuntimeExports.jsx(Skeleton, { className: 'active-wallet-information__address-skeleton' })) : (shortenWalletAddress(address, 4, 4)) })] }), jsxRuntimeExports.jsx(DotsMenu, { "data-testid": 'dots-menu', options: menuOption, buttonClassName: 'active-wallet-information__dots-menu', buttonClassNameWithOpenMenu: 'active-wallet-information__dots-menu', iconOverride: showAlert() ? (jsxRuntimeExports.jsx(IconWithStatus, { Icon: () => jsxRuntimeExports.jsx(SvgGear, { width: 16, height: 16 }), variant: 'yellow' })) : (jsxRuntimeExports.jsx(SvgGear, { width: 16, height: 16 })) })] }));
};

const Divider = ({ text, className, style, fullWidth = false, children, }) => (jsxRuntimeExports.jsxs("div", { className: classNames('divider', className, {
        'divider__full-width': fullWidth,
        'divider__no-gap': text === undefined && children === undefined,
    }), style: style, children: [jsxRuntimeExports.jsx("div", { className: 'divider__dash' }), Boolean(text) && (jsxRuntimeExports.jsx(Typography, { className: 'divider__text', variant: 'body_small', color: 'secondary', children: text })), children && jsxRuntimeExports.jsx("div", { children: children }), jsxRuntimeExports.jsx("div", { className: 'divider__dash' })] }));

const currencyFormatter = new Intl.NumberFormat('en-US', {
    currency: 'USD',
    style: 'currency',
});
const TokenBalanceItem = ({ tokenBalance, }) => {
    const { showFiat } = useInternalDynamicContext();
    const roundToSixDecimal = (value) => {
        const rounded = Math.round(value * 1e6) / 1e6; // 10^6 is 1000000
        return rounded === 0 ? '<0.000001' : rounded;
    };
    const formattedFiatValue = () => {
        var _a;
        if (tokenBalance.marketValue !== 0 && !tokenBalance.marketValue) {
            return '$-';
        }
        return tokenBalance.marketValue >= 0.01
            ? currencyFormatter.format(parseFloat((_a = tokenBalance.marketValue) === null || _a === void 0 ? void 0 : _a.toFixed(2)))
            : '<$0.01';
    };
    return (jsxRuntimeExports.jsxs("div", { className: 'token-balance-item', children: [jsxRuntimeExports.jsxs("div", { className: 'token-balance-item__name', children: [tokenBalance.logoURI ? (jsxRuntimeExports.jsx(Image$1, { src: tokenBalance.logoURI, alt: tokenBalance.symbol, className: 'token-balance-item__icon', dataTestId: 'token-balance-item-icon' })) : (jsxRuntimeExports.jsx("div", { className: 'token-balance-item__skeleton-icon', "data-testid": 'token-balance-item__skeleton-icon' })), jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', className: 'token-balance-item__title', color: 'primary', children: tokenBalance.name }) })] }), jsxRuntimeExports.jsxs("div", { className: 'flex', children: [showFiat ? (jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'bold', color: 'primary', style: { textAlign: 'right' }, children: formattedFiatValue() })) : null, jsxRuntimeExports.jsx("div", { className: 'token-balance-item__value', children: jsxRuntimeExports.jsxs("div", { className: 'token-balance-item__value__balance', "data-testid": 'token-balance-item-balance', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', style: { marginRight: '2px' }, children: roundToSixDecimal(tokenBalance.balance) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', children: tokenBalance.symbol })] }) })] })] }, tokenBalance.address));
};

const TokenBalanceList = ({ tokenBalances }) => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsx("ul", { className: 'token-balance-list', children: (tokenBalances === null || tokenBalances === void 0 ? void 0 : tokenBalances.length) === 0 ? (jsxRuntimeExports.jsx("div", { className: 'token-balance-list__empty', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', children: t('dyn_wallet_information.multi_asset.empty_state') }) })) : (tokenBalances === null || tokenBalances === void 0 ? void 0 : tokenBalances.map((tokenBalance, idx) => (jsxRuntimeExports.jsxs(React__default.Fragment, { children: [jsxRuntimeExports.jsx(TokenBalanceItem, { tokenBalance: tokenBalance }), tokenBalances.length !== idx + 1 ? (jsxRuntimeExports.jsx(Divider, { className: 'token-balance-list__divider' })) : null] }, idx)))) }));
};

const ICON_SIZE = 32;
const DROPDOWN_ICON_SIZE = 16;
const ActiveWalletInformation = ({ isLoading = false, }) => {
    var _a, _b, _c, _d;
    const { t } = useTranslation();
    const [balanceIsExpanded, setBalanceIsExpanded] = useState(false);
    const [hasShadow, setHasShadow] = useState(false);
    const [detailsCardOpen, setDetailsCardOpen] = useState(false);
    const contentRef = useRef(null);
    const { primaryWallet, network, projectSettings, user, authMode, showFiat, multiAsset, } = useInternalDynamicContext();
    const { setDynamicWidgetView, headerAlert } = useWidgetContext();
    const { isTurnkeyWalletWithoutAuthenticator } = useIsTurnkeyWallet();
    const { isLoading: isLoadingTokenBalances, tokenBalances, error: errorTokenBalances, } = useTokenBalances({
        chainName: primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector.connectedChain,
        includeFiat: showFiat,
        includeNativeBalance: true,
    });
    const primaryConnector = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector;
    const filteredTokenBalances = (tokenBalances === null || tokenBalances === void 0 ? void 0 : tokenBalances.filter((token) => token.name)) || [];
    const address = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address;
    const nameService = useFetchNameService(address);
    const { getEOAWallet } = useSmartWallets();
    const { data: testnet } = usePromise(() => __awaiter$1(void 0, void 0, void 0, function* () { return Boolean(yield (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector.isTestnet())); }), { deps: [network], initialData: false });
    const exportKeysOption = getExportKeysOption(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector, projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers);
    const { showAlert } = usePasskeyContext();
    const wallet = (_a = (primaryWallet && getEOAWallet(primaryWallet))) !== null && _a !== void 0 ? _a : primaryWallet;
    const isBitcoin = primaryWallet && isBitcoinConnector(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector);
    const isEmbeddedWallet = Boolean(wallet && ((_c = (_b = wallet === null || wallet === void 0 ? void 0 : wallet.connector) === null || _b === void 0 ? void 0 : _b.key) === null || _c === void 0 ? void 0 : _c.startsWith('turnkey')));
    const openDetailsCard = useCallback(() => {
        setTimeout(() => setDetailsCardOpen(true), 0);
    }, []);
    const options = [
        {
            Icon: jsxRuntimeExports.jsx(SvgCopy, { width: DROPDOWN_ICON_SIZE, height: DROPDOWN_ICON_SIZE }),
            callback: () => (nameService === null || nameService === void 0 ? void 0 : nameService.name) && navigator.clipboard.writeText(nameService === null || nameService === void 0 ? void 0 : nameService.name),
            hide: !(nameService === null || nameService === void 0 ? void 0 : nameService.name),
            text: t('dyn_active_wallet_info.options.copy_ens'),
        },
        {
            Icon: (jsxRuntimeExports.jsx(SvgEyeOutline, { width: DROPDOWN_ICON_SIZE, height: DROPDOWN_ICON_SIZE })),
            callback: openDetailsCard,
            hide: !address,
            text: t('dyn_active_wallet_info.options.view_address'),
        },
        {
            Icon: (jsxRuntimeExports.jsx(SvgWalletV2, { width: DROPDOWN_ICON_SIZE, height: DROPDOWN_ICON_SIZE })),
            callback: () => setDynamicWidgetView('settings'),
            endSlot: showAlert() ? jsxRuntimeExports.jsx(StatusDot, { variant: 'yellow' }) : undefined,
            hide: !isEmbeddedWallet,
            text: t('dyn_active_wallet_info.options.settings'),
        },
        {
            Icon: (jsxRuntimeExports.jsx(SvgKey, { width: DROPDOWN_ICON_SIZE, height: DROPDOWN_ICON_SIZE })),
            callback: exportKeysOption ||
                (() => logger$1.info('No option to export private keys')),
            hide: !exportKeysOption,
            text: t('dyn_active_wallet_info.options.export'),
        },
    ];
    const showTestnetAlert = testnet && !isTurnkeyWalletWithoutAuthenticator;
    const shouldHideNetwork = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.hideNetworkInDynamicWidget;
    const activeWalletAddress = () => {
        if (isBitcoin) {
            return (jsxRuntimeExports.jsx(ActiveBitcoinWalletAddresses, { wallet: primaryWallet, menuOption: options }));
        }
        else {
            return (jsxRuntimeExports.jsx(ActiveWalletAddress, { wallet: primaryWallet, nameServiceName: (nameService === null || nameService === void 0 ? void 0 : nameService.name) || (user === null || user === void 0 ? void 0 : user.email), menuOption: options, isLoading: isLoading, fullWidth: shouldHideNetwork }));
        }
    };
    const enableMultiAsset = (authMode === 'connect-and-sign' ||
        (authMode === 'connect-only' &&
            ((_d = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.featureFlags) === null || _d === void 0 ? void 0 : _d.connectOnlyMultiAsset))) &&
        multiAsset;
    const isNetworkMultiAssetSupported = isMultiAssetSupportedNetwork(primaryConnector, network);
    const isTooManyRequests = errorTokenBalances === 'Too many requests fetching balances';
    const showMultiAsset = !isTooManyRequests && isNetworkMultiAssetSupported && enableMultiAsset;
    filteredTokenBalances.sort((a, b) => ((b === null || b === void 0 ? void 0 : b.marketValue) || 0) - ((a === null || a === void 0 ? void 0 : a.marketValue) || 0));
    const totalValue = filteredTokenBalances.reduce((acc, token) => acc + ((token === null || token === void 0 ? void 0 : token.marketValue) || 0), 0);
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        currency: 'USD',
        style: 'currency',
    });
    const primaryWalletNativeBalance = () => primaryWallet ? (jsxRuntimeExports.jsx(Balance, { className: 'balance-header__balance', wallet: primaryWallet, network: network })) : (jsxRuntimeExports.jsx(Skeleton, { className: 'balance-header__skeleton' }));
    const handleScroll = () => {
        if (contentRef.current) {
            setHasShadow(contentRef.current.scrollTop > 0);
        }
    };
    const multiAssetHeader = () => (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("div", { className: `${hasShadow ? 'shadow' : ''}`, children: jsxRuntimeExports.jsxs("button", { onClick: () => {
                        if (!isLoadingTokenBalances) {
                            setBalanceIsExpanded(!balanceIsExpanded);
                        }
                    }, className: 'balance-header', children: [jsxRuntimeExports.jsxs("div", { className: 'balance-header__title', children: [jsxRuntimeExports.jsxs(Typography, { color: 'secondary', variant: 'body_small', style: { marginRight: '8px' }, children: [t('dyn_active_wallet_info.balance'), ":"] }), showFiat ? (jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', children: totalValue === 0 || totalValue >= 0.01
                                        ? currencyFormatter.format(parseFloat(totalValue.toFixed(2)))
                                        : '<$0.01' })) : (primaryWalletNativeBalance())] }), jsxRuntimeExports.jsx("div", { className: balanceIsExpanded ? 'balance-header__chevron' : '', children: jsxRuntimeExports.jsx(SvgChevronDown, {}) })] }) }), jsxRuntimeExports.jsx(AccordionItem, { isOpen: balanceIsExpanded, className: `multi-asset-balance-container__accordion ${'multi-asset-balance-container__accordion' +
                    (balanceIsExpanded ? '--expanded' : '--collapsed')}`, handleScroll: handleScroll, ref: contentRef, children: jsxRuntimeExports.jsx(TokenBalanceList, { tokenBalances: filteredTokenBalances }) })] }));
    if (isLoading) {
        return jsxRuntimeExports.jsx(Skeleton, {});
    }
    return (jsxRuntimeExports.jsxs("div", { className: 'active-wallet-information-container', "data-testid": 'active-wallet-information', children: [jsxRuntimeExports.jsxs("div", { className: 'active-wallet-information', children: [jsxRuntimeExports.jsxs("div", { className: 'active-wallet-information__header', children: [jsxRuntimeExports.jsx("div", { className: 'active-wallet-information__avatar', children: (nameService === null || nameService === void 0 ? void 0 : nameService.avatar) ? (jsxRuntimeExports.jsx("div", { className: 'active-wallet-information__avatar__name-service', children: jsxRuntimeExports.jsx("img", { src: nameService === null || nameService === void 0 ? void 0 : nameService.avatar, alt: '' }) })) : (jsxRuntimeExports.jsx("div", { className: 'active-wallet-information__wallet-img', children: jsxRuntimeExports.jsx(AuthProviderIcon, { iconSize: ICON_SIZE }) })) }), jsxRuntimeExports.jsxs("div", { className: 'active-wallet-information__details', children: [jsxRuntimeExports.jsx("div", { className: classNames('active-wallet-information__addresses-container', {
                                            'active-wallet-information__addresses-container--centered': !(nameService === null || nameService === void 0 ? void 0 : nameService.name),
                                        }), children: activeWalletAddress() }), address && (jsxRuntimeExports.jsx(WalletDetailsCard, { open: detailsCardOpen, address: address, onClose: () => setDetailsCardOpen(false) })), !shouldHideNetwork && (jsxRuntimeExports.jsx(NetworkPicker, { currentNetwork: network, connector: primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector, mainClassName: 'active-wallet-information__network-picker', buttonClassName: 'active-wallet-information__network-picker-button', showNetworkName: true, isLoading: isLoading }))] })] }), headerAlert && (jsxRuntimeExports.jsx(Alert, { variant: headerAlert.variant, children: headerAlert.content })), showTestnetAlert && (jsxRuntimeExports.jsx(Alert, { variant: 'warning', copykey: 'dyn_active_wallet_info.testnet_warning', children: t('dyn_active_wallet_info.testnet_warning') }))] }), showMultiAsset ? (jsxRuntimeExports.jsx("div", { className: 'multi-asset-balance-container', children: multiAssetHeader() })) : (jsxRuntimeExports.jsxs("div", { className: 'balance-container', children: [jsxRuntimeExports.jsx(Typography, { color: 'secondary', variant: 'body_small', children: t('dyn_active_wallet_info.balance') }), primaryWalletNativeBalance()] }))] }));
};

const LinkButton = React__default.memo(({ connector }) => {
    const { setDynamicWidgetView } = useWidgetContext();
    const handleOnClickLink = () => {
        setDynamicWidgetView('global-wallet');
    };
    if (!connector.globalWallet)
        return null;
    return (jsxRuntimeExports.jsx(TypographyButton, { expanded: true, dataTestId: 'link-button', buttonPadding: 'small', buttonVariant: 'primary', onClick: handleOnClickLink, startSlot: jsxRuntimeExports.jsx(Icon, { size: 'small', color: 'text-secondary', children: jsxRuntimeExports.jsx(SvgLink, {}) }), children: "Connect" }));
});
LinkButton.displayName = 'LinkButton';
const DynamicWidgetWalletHeader = ({ variant, }) => {
    const { primaryWallet, user } = useInternalDynamicContext();
    const { open: openSendBalanceModal } = useSendBalance();
    const { setDynamicWidgetView, setIsOpen } = useWidgetContext();
    const { isLoadingEmbeddedWallet } = useWalletContext();
    const { t } = useTranslation();
    const isSendBalanceEnabled = useMemo(() => {
        const connector = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector;
        if (!connector)
            return false;
        return isSendBalanceWalletConnector(connector);
    }, [primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector]);
    const handleOnClickSend = () => {
        if (variant === 'dropdown') {
            setIsOpen(false);
            openSendBalanceModal().catch((err) => logger$1.error(err));
        }
        else {
            setDynamicWidgetView('send-balance');
        }
    };
    const renderWalletHeader = () => {
        if (primaryWallet || isLoadingEmbeddedWallet) {
            return jsxRuntimeExports.jsx(ActiveWalletInformation, { isLoading: isLoadingEmbeddedWallet });
        }
        else {
            return (jsxRuntimeExports.jsx("div", { className: 'dynamic-widget-wallet-header__icon-container', children: jsxRuntimeExports.jsx(UserAvatar, { user: user }) }));
        }
    };
    return (jsxRuntimeExports.jsxs("div", { className: 'dynamic-widget-wallet-header', "data-testid": 'dynamic-widget-wallet-header', children: [renderWalletHeader(), isLoadingEmbeddedWallet && (jsxRuntimeExports.jsx("div", { className: 'dynamic-widget-wallet-header__wallet-info', children: jsxRuntimeExports.jsx("div", { className: 'dynamic-widget-wallet-header__wallet-loading', children: jsxRuntimeExports.jsx(Alert, { variant: 'info', icon: jsxRuntimeExports.jsx(Spinner$1, { className: 'button__spinner' }), children: t('dyn_creating_wallet.loading_message') }) }) })), primaryWallet ? (jsxRuntimeExports.jsxs("div", { "data-testid": 'primaryWalletStatus', className: 'dynamic-widget-wallet-header__wallet-info', children: [jsxRuntimeExports.jsx(SecureEmbeddedWalletCard, { className: 'dynamic-widget-wallet-header__wallet-info__secure-wallet' }), jsxRuntimeExports.jsxs("div", { className: 'dynamic-widget-wallet-header__wallet-actions', children: [jsxRuntimeExports.jsx(TypographyButton, { expanded: true, dataTestId: 'buy-crypto-button', buttonPadding: 'small', buttonVariant: 'primary', onClick: () => setDynamicWidgetView('choose-wallet-funding-method'), startSlot: jsxRuntimeExports.jsx(Icon, { size: 'small', color: 'text-secondary', children: jsxRuntimeExports.jsx(SvgAdd, {}) }), children: t('dyn_widget_header.buttons.deposit_funds') }), isSendBalanceEnabled && (jsxRuntimeExports.jsx(TypographyButton, { expanded: true, dataTestId: 'send-balance-button', buttonPadding: 'small', buttonVariant: 'primary', onClick: handleOnClickSend, startSlot: jsxRuntimeExports.jsx(Icon, { size: 'small', color: 'text-secondary', children: jsxRuntimeExports.jsx(SvgSend, {}) }), children: t('dyn_widget_header.buttons.send_funds') })), jsxRuntimeExports.jsx(LinkButton, { connector: primaryWallet.connector })] })] })) : (jsxRuntimeExports.jsx(Typography, { className: 'dynamic-widget-wallet-header__email', variant: 'body_normal', weight: 'regular', children: !isLoadingEmbeddedWallet && getUserIdentifier(user) }))] }));
};
React__default.memo(DynamicWidgetWalletHeader);

const DynamicWidgetHeader = ({ variant, }) => {
    const { overridenWidgetView } = useWidgetContext();
    const { multiWallet } = useInternalDynamicContext();
    return (jsxRuntimeExports.jsxs("div", { className: 'dynamic-widget-header', children: [jsxRuntimeExports.jsx(PasskeyCreatedSuccessBanner, { className: 'dynamic-widget-header__passkey-success' }), (overridenWidgetView === 'wallets' ||
                (overridenWidgetView === 'profile' && !multiWallet)) && (jsxRuntimeExports.jsx(DynamicWidgetWalletHeader, { variant: variant }))] }));
};
const MemoizedDynamicWidgetHeader = React__default.memo(DynamicWidgetHeader);

const DynamicBridgeWalletCard = ({ className, networkIcon, networkName, children }) => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsxs("div", { className: classNames('dynamic-bridge-wallet-card', className), children: [jsxRuntimeExports.jsxs("div", { className: 'dynamic-bridge-wallet-card__network', children: [networkIcon &&
                        React__default.cloneElement(networkIcon, {
                            className: 'dynamic-bridge-wallet-card__network-icon',
                        }), networkName && (jsxRuntimeExports.jsx(Typography, { className: 'dynamic-bridge-wallet-card__network-name', variant: 'body_small', color: 'primary', weight: 'medium', as: 'span', copykey: 'dyn_bridge.widget.wallet_network', children: t('dyn_bridge.widget.wallet_network', {
                            networkName,
                        }) }))] }), children] }));
};

const WalletInformationCard = ({ address, ens, balance, icon, network, menu, }) => {
    const { t } = useTranslation();
    const details = useMemo(() => {
        const shortenAddress = shortenWalletAddress(address);
        if (ens) {
            return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Typography, { color: 'primary', variant: 'body_normal', truncate: true, children: ens }), jsxRuntimeExports.jsx(Typography, { weight: 'regular', variant: 'body_small', color: 'secondary', children: shortenAddress })] }));
        }
        return (jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'body_normal', color: 'primary', children: shortenAddress }));
    }, [ens, address]);
    return (jsxRuntimeExports.jsxs("div", { className: 'wallet-information-card', children: [jsxRuntimeExports.jsxs("div", { className: 'wallet-information-card__header', children: [jsxRuntimeExports.jsxs("div", { className: 'wallet-information-card__details-container', children: [icon && (jsxRuntimeExports.jsx(Icon, { className: 'wallet-information-card__icon', children: icon })), jsxRuntimeExports.jsx("div", { className: 'wallet-information-card__details', children: details }), jsxRuntimeExports.jsx("div", { className: 'wallet-information-card__menu', children: menu })] }), network] }), jsxRuntimeExports.jsxs("div", { className: 'wallet-information-card__balance-container', children: [jsxRuntimeExports.jsx(Typography, { color: 'secondary', variant: 'body_small', copykey: 'dyn_wallet_information.balance', children: t('dyn_wallet_information.balance') }), balance] })] }));
};

const DynamicBridgeWalletCardBody = ({ walletAddress, walletBalance, walletKey, onDisconnectClick }) => {
    const { t } = useTranslation();
    const nameService = useFetchNameService(walletAddress);
    const options = [
        {
            Icon: null,
            callback: () => (nameService === null || nameService === void 0 ? void 0 : nameService.name) && navigator.clipboard.writeText(nameService === null || nameService === void 0 ? void 0 : nameService.name),
            hide: !(nameService === null || nameService === void 0 ? void 0 : nameService.name),
            text: t('dyn_bridge.widget.copy.ens'),
        },
        {
            Icon: null,
            callback: () => walletAddress && navigator.clipboard.writeText(walletAddress),
            hide: !walletAddress,
            text: t('dyn_bridge.widget.copy.address'),
        },
        {
            Icon: null,
            callback: () => onDisconnectClick === null || onDisconnectClick === void 0 ? void 0 : onDisconnectClick(),
            hide: !onDisconnectClick,
            text: t('dyn_bridge.widget.disconnect'),
        },
    ];
    return (jsxRuntimeExports.jsx(WalletInformationCard, { ens: nameService === null || nameService === void 0 ? void 0 : nameService.name, address: walletAddress, icon: jsxRuntimeExports.jsx(WalletIcon, { walletKey: walletKey }), balance: walletBalance, menu: jsxRuntimeExports.jsx(DotsMenu, { options: options }), copykey: 'dyn_bridge.widget' }));
};

const DynamicBridgeWidgetEmptyCard = ({ chain }) => {
    const { t } = useTranslation();
    const { bridgeChainsToConnect, setShowAuthFlow, setShowBridgeWidget } = useInternalDynamicContext();
    if (!(bridgeChainsToConnect === null || bridgeChainsToConnect === void 0 ? void 0 : bridgeChainsToConnect.length) || !chain) {
        return null;
    }
    const chainInfo = getChainInfoWithOverrides(chain);
    const ChainIcon = getChainIcon(chain);
    return (jsxRuntimeExports.jsxs("div", { role: 'button', className: 'dynamic-bridge-widget-empty-card', onClick: () => {
            setShowBridgeWidget(false);
            setShowAuthFlow(true);
        }, children: [jsxRuntimeExports.jsx(ChainIcon, { className: 'dynamic-bridge-widget-empty-card__icon' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'medium', as: 'span', color: 'primary', className: 'dynamic-bridge-widget-empty-card__text', copykey: 'dyn_bridge.widget.connect_with_network', children: t('dyn_bridge.widget.connect_with_network', {
                    blockchainName: chainInfo === null || chainInfo === void 0 ? void 0 : chainInfo.blockchainName,
                }) })] }));
};

const SecondaryWallets = ({ hideUnlinkAction = false }) => {
    const { disconnectWallet, bridgeChains, connectedWallets, primaryWalletId } = useInternalDynamicContext();
    const secondaryWallet = connectedWallets.find((wallet) => wallet.id !== primaryWalletId);
    const NetworkIcon = secondaryWallet && getChainIcon(secondaryWallet === null || secondaryWallet === void 0 ? void 0 : secondaryWallet.chain);
    const networkInfo = secondaryWallet && getChainInfoWithOverrides(secondaryWallet === null || secondaryWallet === void 0 ? void 0 : secondaryWallet.chain);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [!secondaryWallet && (jsxRuntimeExports.jsx(DynamicBridgeWidgetEmptyCard, { chain: bridgeChains === null || bridgeChains === void 0 ? void 0 : bridgeChains[1].chain })), secondaryWallet && NetworkIcon && (jsxRuntimeExports.jsx(DynamicBridgeWalletCard, { networkIcon: jsxRuntimeExports.jsx(NetworkIcon, {}), networkName: networkInfo === null || networkInfo === void 0 ? void 0 : networkInfo.displayName, children: jsxRuntimeExports.jsx(DynamicBridgeWalletCardBody, { walletKey: secondaryWallet.connector.key, walletAddress: secondaryWallet.address, walletBalance: 
                    // eslint-disable-next-line react/jsx-wrap-multilines
                    jsxRuntimeExports.jsx(Balance, { wallet: secondaryWallet, network: secondaryWallet.chain }), onDisconnectClick: !hideUnlinkAction
                        ? () => disconnectWallet(secondaryWallet.id)
                        : undefined }, secondaryWallet.id) }))] }));
};
const MemoSecondaryWallets = React__default.memo(SecondaryWallets);

const useHandleWalletsToConnect = () => {
    const { bridgeChains, bridgeChainsToConnect, setShowAuthFlow, bridgeOnboardingCompleted, setBridgeOnboardingCompleted, } = useInternalDynamicContext();
    const { pushView, clearStackAndPushInitialView } = useViewContext();
    const handleWalletsToConnect = ({ walletConnector, }) => {
        if (!bridgeChains) {
            setShowAuthFlow(false);
            return;
        }
        if (!bridgeChainsToConnect) {
            setBridgeOnboardingCompleted(true);
            setShowAuthFlow(false);
            return;
        }
        // Avoid showing wallet-list when wallet updates network to the correct one in run time (bridge mode)
        if (bridgeChainsToConnect.length === 0) {
            setShowAuthFlow(false);
            return clearStackAndPushInitialView();
        }
        if (!walletConnector || !walletConnector.connectedChain) {
            setShowAuthFlow(false);
            return clearStackAndPushInitialView();
        }
        const restOfWallets = bridgeChainsToConnect.filter((wallet) => wallet.chain !== (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.connectedChain));
        const allWalletsConnected = restOfWallets.length === 0;
        if (allWalletsConnected) {
            if (!bridgeOnboardingCompleted) {
                setBridgeOnboardingCompleted(true);
                pushView('bridge-summary');
            }
            else {
                setShowAuthFlow(false);
                clearStackAndPushInitialView();
            }
            return;
        }
        pushView('bridge-next-wallet-connection');
    };
    return { handleWalletsToConnect };
};

const specialCareWallets = ['bloctoevm', 'perawallet', 'metamaskstarknet'];
const showPendingConnectView = (walletConnector, pushView) => __awaiter$1(void 0, void 0, void 0, function* () {
    const walletProvider = getWalletProvider(walletConnector);
    // We don't want to show the pending connect view for qrCode and walletConnect
    // They have their own view with qrCode so we don't need to show the pending connect view
    if (walletProvider === 'walletConnect' || walletProvider === 'qrCode') {
        return;
    }
    specialCareWallets.forEach((wallet) => {
        if (walletConnector.key === wallet) {
            // bloctoevm and some other wallets works different as Justin mentioned in this commit:
            // https://github.com/dynamic-labs/DynamicAuth/commit/57233d3620611bc91439f3d4587b8516f8d16f99
            // It needs to show the connect view before getting connected accounts
            pushView('pending-connect');
        }
    });
    const connectedAccounts = yield walletConnector.getConnectedAccounts();
    /* istanbul ignore else */
    if (connectedAccounts.length === 0) {
        pushView('pending-connect');
    }
});

const isConnectOnly = (user, authMode) => {
    // we need to check for user because of connect-only (authenticated)
    // and linking a new wallet in mutliwallet
    const linking = user !== undefined;
    const connectOnly = authMode === 'connect-only' && !linking;
    return connectOnly;
};

const useConnectAndSign = ({ shouldUpdateWallets = true, shouldCallCallback = true, } = {}) => {
    const { pushView, clearStackAndPushInitialView, replaceView } = useViewContext();
    const { engageCaptcha, getCaptchaToken } = useCaptchaContext();
    const { setErrorMessage } = useErrorContext();
    const { authMode, connectWallet, displaySiweStatement, environmentId, projectSettings, networkValidationMode, setIsSingleWalletAccount, user, walletUiUtils, } = useInternalDynamicContext();
    const { handleWalletsToConnect } = useHandleWalletsToConnect();
    const verifyWallet = useVerifyWallet({
        displaySiweStatement,
        environmentId,
        projectSettings,
        setIsSingleWalletAccount,
    });
    const handleWalletVerify = (walletConnector, publicWalletAddress, captchaToken) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!isEmailWalletConnector(walletConnector) ||
            isBloctoConnector(walletConnector)) {
            replaceView('pending-signature');
        }
        else {
            walletUiUtils.disabledConfirmationOnce();
        }
        yield verifyWallet({
            captchaToken,
            publicWalletAddress,
            walletConnector,
        });
    });
    const handleWalletVerifyError = (err) => {
        var _a;
        const userCancelled = (err === null || err === void 0 ? void 0 : err.code) === 'user-cancelled';
        if (!userCancelled)
            logger$1.debug(err);
        setErrorMessage((_a = err === null || err === void 0 ? void 0 : err.code) === null || _a === void 0 ? void 0 : _a.toString());
        clearStackAndPushInitialView();
    };
    return (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ walletConnector, getAddressOpts = undefined, }) {
        var _b;
        try {
            yield showPendingConnectView(walletConnector, pushView);
            if (isEmailWalletConnector(walletConnector)) {
                if (isEmailOTPWalletConnector(walletConnector)) {
                    pushView('email-wallet-otp-verification-view');
                }
                else if (!isBloctoConnector(walletConnector)) {
                    pushView('wait-for-email-confirmation-view');
                }
            }
            const connectionResult = yield connectWallet(walletConnector, getAddressOpts, {
                applyHandleConnectedWallet: shouldCallCallback,
            });
            if (!(connectionResult === null || connectionResult === void 0 ? void 0 : connectionResult.address)) {
                return;
            }
            const { address } = connectionResult;
            const walletNetwork = yield walletConnector.getNetwork();
            const usesSupportedNetwork = isSupportedNetwork({
                network: walletNetwork,
                walletConnector,
            });
            const isNetworkValidationEnabledForSignIn = networkValidationMode === 'always' ||
                networkValidationMode === 'sign-in';
            if (!usesSupportedNetwork && isNetworkValidationEnabledForSignIn) {
                if (!isProgrammableNetworkSwitchSupported(walletConnector)) {
                    return pushView('network-not-supported-manual');
                }
                return pushView('network-not-supported');
            }
            if (isConnectOnly(user, authMode)) {
                StorageService.setItem(LAST_USED_WALLET, walletConnector.key);
                if (shouldUpdateWallets) {
                    handleWalletsToConnect({ walletConnector });
                }
                return;
            }
            if ((_b = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.security.hCaptcha) === null || _b === void 0 ? void 0 : _b.enabled) {
                engageCaptcha({
                    authMethod: 'wallet',
                    onCaptchaSuccess: (captchaToken) => __awaiter$1(void 0, void 0, void 0, function* () {
                        try {
                            yield handleWalletVerify(walletConnector, address, captchaToken);
                        }
                        catch (e) {
                            handleWalletVerifyError(e);
                        }
                    }),
                });
                return;
            }
            yield handleWalletVerify(walletConnector, address, getCaptchaToken());
        }
        catch (err) {
            handleWalletVerifyError(err);
        }
    });
};

const useConnectAndSignSplitSteps = () => {
    const { pushView, clearStackAndPushInitialView } = useViewContext();
    const { setErrorMessage } = useErrorContext();
    const { getCaptchaToken, engageCaptcha } = useCaptchaContext();
    const { connectWallet, displaySiweStatement, projectSettings, environmentId, networkValidationMode, setIsSingleWalletAccount, setShowAuthFlow, user, authMode, } = useInternalDynamicContext();
    const { handleWalletsToConnect } = useHandleWalletsToConnect();
    const verifyWallet = useVerifyWallet({
        displaySiweStatement,
        environmentId,
        projectSettings,
        setIsSingleWalletAccount,
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onErrorHandler = (err) => {
        var _a;
        logger$1.debug(err);
        /**
         * On mobile, when the user is redirected to the wallet mobile app, this error is thrown.
         * We want to stay in whichever view we currently are, most likely mobile-wallet-redirect-view
         */
        if (err instanceof MissingPublicAddressError && isMobile())
            return;
        clearStackAndPushInitialView();
        setErrorMessage((_a = err.code) !== null && _a !== void 0 ? _a : err.toString());
    };
    // This method is similar to useConnectAndSign, but it skips signing for now
    // It's used when we want to connect and sign in two separate steps
    // For example on mobile when we want to sign on button click
    // or in Dapper
    const onlyConnectUser = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ walletConnector, getAddressOpts = undefined, shouldShowPendingConnectView = true, }) {
        var _b;
        if (shouldShowPendingConnectView)
            yield showPendingConnectView(walletConnector, pushView);
        try {
            yield connectWallet(walletConnector, getAddressOpts);
            if (isConnectOnly(user, authMode)) {
                StorageService.setItem(LAST_USED_WALLET, walletConnector.key);
                handleWalletsToConnect({ walletConnector });
                return;
            }
            if ((_b = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.security.hCaptcha) === null || _b === void 0 ? void 0 : _b.enabled) {
                engageCaptcha({
                    authMethod: 'wallet',
                    onCaptchaSuccess: (_captchaToken) => __awaiter$1(void 0, void 0, void 0, function* () {
                        setShowAuthFlow(true);
                        pushView('pending-signature');
                    }),
                });
                return;
            }
            setShowAuthFlow(true);
            pushView('pending-signature');
        }
        catch (err) {
            onErrorHandler(err);
            return;
        }
    });
    // This method is similar to useConnectAndSign, but it does not call showPendingConnectView
    // This is because we already called it in onlyConnectUser and now we just want to sign
    const signAlreadyConnectedUser = (_c) => __awaiter$1(void 0, [_c], void 0, function* ({ walletConnector, getAddressOpts = undefined, }) {
        try {
            const connectionResult = yield connectWallet(walletConnector, getAddressOpts);
            if (!(connectionResult === null || connectionResult === void 0 ? void 0 : connectionResult.address)) {
                return;
            }
            const walletNetwork = yield walletConnector.getNetwork();
            const usesSupportedNetwork = isSupportedNetwork({
                network: walletNetwork,
                walletConnector,
            });
            const isNetworkValidationEnabledForSignIn = networkValidationMode === 'always' ||
                networkValidationMode === 'sign-in';
            if (!usesSupportedNetwork && isNetworkValidationEnabledForSignIn) {
                if (!isProgrammableNetworkSwitchSupported(walletConnector)) {
                    return pushView('network-not-supported-manual');
                }
                return pushView('network-not-supported');
            }
            yield verifyWallet({
                captchaToken: getCaptchaToken(),
                publicWalletAddress: connectionResult.address,
                walletConnector,
            });
        }
        catch (err) {
            onErrorHandler(err);
            return;
        }
    });
    return {
        onlyConnectUser,
        signAlreadyConnectedUser,
    };
};

const useWalletItemActions = () => {
    const { setMultiWalletWidgetState, authMode } = useInternalDynamicContext();
    const { onlyConnectUser } = useConnectAndSignSplitSteps();
    const connectAndSignWallet = useConnectAndSign();
    const { pushView } = useViewContext();
    const handleExtensionAndCustodial = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ requiresTwoStepAuthentication, walletConnector, }) {
        if (requiresTwoStepAuthentication || authMode === 'connect-only') {
            pushView('pending-connect');
            yield onlyConnectUser({ walletConnector });
        }
        else {
            // See useVerifyOnAwaitingSignature's useEffect for more context.
            setMultiWalletWidgetState('awaiting_signature', undefined, 'linking_new_wallet');
        }
    });
    return useHandleWalletItem({
        allowAlreadyConnectedWallet: false,
        onConnectOnly: onlyConnectUser,
        onCustodialWallet: handleExtensionAndCustodial,
        onInstalledExtension: handleExtensionAndCustodial,
        onQrCodeConnect: connectAndSignWallet,
    });
};

const WalletGroupContext = React__default.createContext(undefined);
const useWalletGroupContext = () => {
    const context = React__default.useContext(WalletGroupContext);
    if (context === undefined) {
        throw new Error('usage of useWalletGroupContext not wrapped in `WalletGroupContextProvider`.');
    }
    return context;
};
const WalletGroupContextProvider = ({ children, }) => {
    const [selectedWalletGroup, setSelectedWalletGroup] = React__default.useState();
    const { pushView } = useViewContext();
    const { handleWalletItemClick } = useWalletItemActions();
    const navigateToWalletGroup = React__default.useCallback((walletGroup, { onSelectWallet } = {}) => {
        setSelectedWalletGroup(walletGroup);
        const walletGroupType = getWalletGroupType(walletGroup);
        const mapGroupTypeToView = {
            'multi-chain': 'wallet-group',
            'multi-wallet': 'select-wallet-in-wallet-group',
        };
        const view = walletGroupType
            ? mapGroupTypeToView[walletGroupType]
            : mapGroupTypeToView['multi-chain'];
        pushView(view, {
            onSelectWallet: onSelectWallet !== null && onSelectWallet !== void 0 ? onSelectWallet : handleWalletItemClick,
        });
    }, [handleWalletItemClick, pushView]);
    const contextValue = {
        navigateToWalletGroup,
        selectedWalletGroup,
    };
    return (jsxRuntimeExports.jsx(WalletGroupContext.Provider, { value: contextValue, children: children }));
};

var SubdomainCheckResponseError;
(function (SubdomainCheckResponseError) {
    SubdomainCheckResponseError[SubdomainCheckResponseError["CHECK_FAILED"] = 0] = "CHECK_FAILED";
})(SubdomainCheckResponseError || (SubdomainCheckResponseError = {}));
/** Hook to check if a subdomain is available */
const useSubdomainCheck = () => {
    const { environmentId } = useInternalDynamicContext();
    const checkSubdomain = useCallback((_a) => __awaiter$1(void 0, [_a], void 0, function* ({ subdomain, }) {
        var _b;
        const response = yield getUserFieldsCheck({
            environmentId,
            filter: {
                field: UserFieldsCheckEnum.NameServiceSubdomainHandle,
                value: subdomain,
            },
        });
        if (!response) {
            return {
                available: false,
                error: SubdomainCheckResponseError.CHECK_FAILED,
            };
        }
        return {
            available: (_b = response === null || response === void 0 ? void 0 : response.available) !== null && _b !== void 0 ? _b : false,
            error: undefined,
        };
    }), [environmentId]);
    return checkSubdomain;
};

var PasskeySuccessEnum;
(function (PasskeySuccessEnum) {
    PasskeySuccessEnum[PasskeySuccessEnum["CREATED"] = 0] = "CREATED";
    PasskeySuccessEnum[PasskeySuccessEnum["EDITED"] = 1] = "EDITED";
})(PasskeySuccessEnum || (PasskeySuccessEnum = {}));
const PasskeyCreatedSuccessBanner = ({ className }) => {
    const { passkeySuccessPopup } = useInternalDynamicContext();
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsxs(AnimatePresence, { animationComponent: jsxRuntimeExports.jsx(OpacityTransition, {}), children: [passkeySuccessPopup === PasskeySuccessEnum.EDITED && (jsxRuntimeExports.jsx(ErrorContainer, { variant: 'success', className: className, copykey: 'dyn_passkey_success.edited', children: t('dyn_passkey_success.edited') })), passkeySuccessPopup === PasskeySuccessEnum.CREATED && (jsxRuntimeExports.jsx(ErrorContainer, { variant: 'success', className: className, copykey: 'dyn_passkey_success.created', children: t('dyn_passkey_success.created') }))] }));
};

const AnimatePresence = ({ children, animationComponent, }) => {
    const [isShown, setIsShown] = useState(true);
    const forceRerender = useForceUpdate();
    const childrenRef = useRef(null);
    const isChildrenPresent = useMemo(() => Boolean(children), [children]);
    const prevIsChildrenPresent = usePrevious(isChildrenPresent);
    const onUnmount = useCallback(() => {
        childrenRef.current = null;
        forceRerender();
    }, [forceRerender]);
    useEffect(() => {
        if (isValidElement(children)) {
            childrenRef.current = Children.map(children, (child) => cloneElement(child));
        }
    }, [children]);
    useEffect(() => {
        if (isChildrenPresent && !prevIsChildrenPresent) {
            setIsShown(true);
        }
        if (prevIsChildrenPresent && !isChildrenPresent) {
            setIsShown(false);
        }
    }, [isChildrenPresent, prevIsChildrenPresent]);
    return cloneElement(animationComponent, {
        children: children || childrenRef.current,
        isShown,
        onUnmount,
    });
};

const OverlayCardBase = ({ isOpen, children, onClickOverlay, style, className, }) => {
    const target = useOverlayCardTarget(isOpen);
    // Only prevent scroll if using body as portal
    usePreventPageScroll(isOpen && !target);
    const contentRef = useRef(null);
    useOnClickOutside(contentRef, () => onClickOverlay === null || onClickOverlay === void 0 ? void 0 : onClickOverlay());
    const opacityTransition = (jsxRuntimeExports.jsx(OpacityTransition, { className: 'overlay-card-base__animation', duration: DURATION_DEFAULT }));
    const slideTransition = (jsxRuntimeExports.jsx(SlideInUpTransition, { className: 'overlay-card-base__animation', duration: DURATION_DEFAULT }));
    const content = (jsxRuntimeExports.jsx("div", { className: classNames('overlay-card-base', {
            'overlay-card-base--disabled': !isOpen,
        }), style: { position: target === undefined ? 'fixed' : 'absolute' }, children: isOpen && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(AnimatePresence, { animationComponent: opacityTransition, children: jsxRuntimeExports.jsx("div", { onClick: onClickOverlay, className: 'overlay-card-base__overlay' }) }), jsxRuntimeExports.jsx("div", { className: 'overlay-card-base__content-wrapper', children: jsxRuntimeExports.jsx(AnimatePresence, { animationComponent: slideTransition, children: jsxRuntimeExports.jsx("div", { ref: contentRef, className: classNames('overlay-card-base__content', className), style: style, children: children }) }) })] })) }));
    if (target)
        return createPortal(content, target);
    return createPortal(jsxRuntimeExports.jsx(ShadowDOM, { children: content }), document.body);
};

const CloseContext = createContext(undefined);
/** Default header component with close icon */
const Header$1 = ({ children, closeDisabled, }) => {
    const onClose = useContext(CloseContext);
    const closeButton = (jsxRuntimeExports.jsx(IconButton, { onClick: onClose, type: 'button', id: 'close-button', disabled: closeDisabled, "data-testid": 'close-button', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    return (jsxRuntimeExports.jsx(ModalHeader, { trailing: closeButton, children: jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'title', color: 'primary', children: children }) }));
};
/** Styled content section */
const Content = ({ children, className, removePadding, }) => (jsxRuntimeExports.jsx("div", { className: classNames('overlay-card__content', { 'overlay-card__content-p0': removePadding }, className), "data-testid": 'overlay-content', children: children }));
const OverlayCard = ({ children, isOpen, onClose, className, style, }) => (jsxRuntimeExports.jsx(CloseContext.Provider, { value: onClose, children: jsxRuntimeExports.jsx(OverlayCardBase, { isOpen: isOpen, onClickOverlay: onClose, className: className, style: style, children: children }) }));
OverlayCard.Header = Header$1;
OverlayCard.Content = Content;

var css_248z$1 = "@layer shadow-reset{.dynamic-shadow-dom-content{all:initial}}@layer preflight{a,hr{color:inherit}progress,sub,sup{vertical-align:baseline}blockquote,body,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,menu,ol,p,pre,ul{margin:0}fieldset,legend,menu,ol,ul{padding:0}*,:after,:before{border:0 solid;box-sizing:border-box}html{-webkit-text-size-adjust:100%;-moz-text-size-adjust:100%;text-size-adjust:100%;font-feature-settings:normal;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;line-height:1.5;-moz-tab-size:4;-o-tab-size:4;tab-size:4}body{line-height:inherit}hr{border-top-width:1px;height:0}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,pre,samp{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{border-collapse:collapse;border-color:inherit;text-indent:0}button,input,optgroup,select,textarea{color:inherit;font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;margin:0;padding:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button;-moz-appearance:button;appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none;appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;appearance:button;font:inherit}summary{display:list-item}menu,ol,ul{list-style:none}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{color:#9ca3af;opacity:1}input::placeholder,textarea::placeholder{color:#9ca3af;opacity:1}[role=button],button{cursor:pointer}:disabled{cursor:default}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}img,video{height:auto;max-width:100%}[hidden]{display:none}}.accordion-item{overflow:hidden;position:relative;transition-duration:.15s;transition-property:max-height;transition-timing-function:ease-out}.accordion-item--full-height{height:100vh}.accordion-item__curtain{background-color:var(--dynamic-overlay);left:0;opacity:0;position:absolute;right:0;top:0;transition:opacity 50ms ease-in;z-index:1}.accordion-item__curtain--dimmed{bottom:0;opacity:1}.vertical-accordion__container{display:flex;flex-direction:column}.alert{align-items:center;border-radius:calc(var(--dynamic-border-radius)/3);display:flex;gap:.75rem;justify-content:center;padding:.75rem}.alert--with-icon{justify-content:flex-start}.alert--error{background-color:var(--dynamic-error-2);color:var(--dynamic-error-1)}.alert--warning{background-color:var(--dynamic-alert-2);color:var(--dynamic-alert-1)}.alert--info{background-color:var(--dynamic-brand-secondary-color);color:var(--dynamic-brand-primary-color)}.alert--success{background-color:var(--dynamic-success-2);color:var(--dynamic-success-1)}.alert__icon{flex-shrink:0}.badge__container{align-items:center;border-radius:9999px;display:flex;font-size:.625rem;font-weight:500;gap:.25rem;padding:.25rem .5rem;position:relative;transition:color .3s,background-color .3s;white-space:nowrap}.badge__container__primary{background-color:var(--dynamic-badge-primary-background);color:var(--dynamic-badge-primary-color)}.badge__container__secondary{background-color:var(--dynamic-badge-background);color:var(--dynamic-badge-color)}.badge__dot{background-color:var(--dynamic-badge-dot-background);border-radius:9999px;height:.375rem;transition:color .3s,background-color .3s;width:.375rem}.button{align-items:center;cursor:pointer;display:flex;gap:.375rem;justify-content:center;position:relative;transition:all .2s ease}.button:disabled:not(.button--loading){background-color:var(--dynamic-base-3);cursor:default}.button--expanded{align-self:stretch;flex:1;width:100%}.button--brand-primary{background:var(--dynamic-brand-primary-color);border:var(--dynamic-button-primary-border);box-shadow:var(--dynamic-shadow-down-1);color:#fff;padding:var(--dynamic-button-primary-padding)}.button--brand-primary:hover:enabled{box-shadow:var(--dynamic-button-shadow)}.button--brand-primary:active:enabled,.button--primary{box-shadow:var(--dynamic-shadow-down-1)}.button--primary{background:var(--dynamic-button-primary-background);border:var(--dynamic-button-primary-border);padding:var(--dynamic-button-primary-padding)}.button--primary:hover:enabled{box-shadow:var(--dynamic-button-shadow)}.button--primary:active:enabled,.button--secondary{box-shadow:var(--dynamic-shadow-down-1)}.button--secondary{background:var(--dynamic-button-secondary-background);border:var(--dynamic-button-secondary-border);padding:var(--dynamic-button-secondary-padding)}.button--secondary:hover:enabled{background:var(--dynamic-hover)}.button--secondary:active:enabled{background:var(--dynamic-base-3)}.button--tertiary,.button--tertiary .typography{color:var(--dynamic-text-secondary)}.button--tertiary:hover:enabled,.button--tertiary:hover:enabled .typography{color:var(--dynamic-text-primary)}.button--card{background:var(--dynamic-button-primary-background);box-shadow:0 .0625rem .125rem 0 rgba(24,39,75,.04);padding:var(--dynamic-button-primary-padding)}.button--card:hover:enabled{box-shadow:0 .75rem 1.25rem -.375rem rgba(24,39,75,.02),0 1rem 1.625rem -.25rem rgba(24,39,75,.04)}.button--padding-default{padding:.625rem 1rem}.button--padding-default,.button--padding-large{border-radius:calc(var(--dynamic-border-radius)/2)}.button--padding-large{padding:.875rem 1.25rem}.button--padding-medium{border-radius:calc(var(--dynamic-border-radius)/3);padding:.625rem 1rem}.button--padding-small{border-radius:calc(var(--dynamic-border-radius)/4);padding:.5rem .75rem}.button--padding-none{padding:0}.button--padding-login-screen-height{border-radius:calc(var(--dynamic-border-radius)/2);min-height:2.5rem;padding:0 1rem}.button__spinner{margin-left:auto;margin-right:auto}.button__end-slot,.button__start-slot{display:inline-flex}.button__spinner-container{align-items:center;bottom:0;color:var(--dynamic-text-primary);display:flex;justify-content:center;left:0;position:absolute;right:0;top:0}.button--loading>:not(.button__spinner-container){opacity:0}.checkbox--hidden{cursor:pointer;display:block;height:1rem;opacity:0;position:absolute;width:1rem;z-index:10}.checkbox--hidden:checked+.checkbox--visible{background:var(--dynamic-brand-primary-color);border-style:none}.checkbox--hidden:checked+.checkbox--visible>.checkbox__icon{opacity:1}.checkbox--hidden:disabled{pointer-events:none}.checkbox--visible{align-items:center;background:var(--dynamic-base-3);border:.0625rem solid var(--dynamic-base-4);border-radius:calc(var(--dynamic-border-radius)/4);display:flex;height:1rem;justify-content:center;position:absolute;transition-duration:.2s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);width:1rem;z-index:0}.checkbox__container{height:1rem;position:relative;width:1rem}.checkbox__icon{color:#fff;height:.75rem;opacity:0;transition-duration:.2s;transition-property:opacity;width:.75rem}.connect-button{background:var(--dynamic-connect-button-background);border:var(--dynamic-connect-button-border);border-radius:calc(var(--dynamic-connect-button-radius, var(--dynamic-border-radius))/2);box-shadow:var(--dynamic-connect-button-shadow)}.connect-button:hover:enabled{background:var(--dynamic-connect-button-background-hover);border:var(--dynamic-connect-button-border-hover);box-shadow:var(--dynamic-connect-button-shadow-hover)}.connect-button:hover:enabled .typography{color:var(--dynamic-connect-button-color-hover)}.connect-button .typography{color:var(--dynamic-connect-button-color)}.copy-button__container{position:relative}.copy-button__tooltip{background-color:var(--dynamic-text-primary);color:var(--dynamic-base-2);font-size:.75rem}@keyframes enter-tile{0%{opacity:0;transform:translateY(.5rem)}to{opacity:1;transform:translateY(0)}}.enter-list-tile-animation{animation-duration:.2s;animation-fill-mode:both;animation-iteration-count:1;animation-name:enter-tile;animation-timing-function:ease-out}.error-container{align-items:center;display:flex;justify-content:center;margin-bottom:.5rem;padding:.5rem .75rem}.error-container img,.error-container svg{height:1.25rem;width:1.25rem}.error-container--error{background:var(--dynamic-error-2);color:var(--dynamic-error-1)}.error-container--info{background:var(--dynamic-base-3);color:var(--dynamic-text-primary)}.error-container--success{background:var(--dynamic-success-2);color:var(--dynamic-success-1)}.error-container--multi-wallet{margin-bottom:.75rem}.error--with-icon{margin-left:.875rem}.icon--color-brand-primary{color:var(--dynamic-brand-primary-color)}.icon--color-text-primary{color:var(--dynamic-text-primary)}.icon--color-text-secondary{color:var(--dynamic-text-secondary)}.icon--color-text-tertiary{color:var(--dynamic-text-tertiary)}.icon--color-text-error{color:var(--dynamic-error-1)}.icon--color-success-1{color:var(--dynamic-success-1)}.icon--size-xsmall{height:.75rem;width:.75rem}.icon--size-small{height:1rem;width:1rem}.icon--size-mini{height:1.25rem;width:1.25rem}.icon--size-medium{height:1.5rem;width:1.5rem}.icon--size-mlarge{height:1.875rem;width:1.875rem}.icon--size-large{height:2.375rem;width:2.375rem}.icon-button{align-items:center;border-radius:100%;color:var(--dynamic-text-tertiary);display:flex;justify-content:center}.icon-button svg:hover{color:var(--dynamic-text-secondary)}.icon-button svg:active{color:var(--dynamic-text-primary)}.indicator__container{align-items:center;background:var(--dynamic-base-1);border-radius:100%;bottom:0;display:flex;justify-content:center;position:absolute;right:0}.indicator__icon{background:var(--dynamic-success-1);border-radius:100%}.indicator__wallet-connect{background:#4084ed;bottom:0;color:#fff;position:absolute;right:-.125rem}.icon-with-spinner__container,.indicator__wallet-connect{align-items:center;border-radius:9999px;display:flex;justify-content:center}.icon-with-spinner__container{position:relative}.icon-with-spinner__container img{height:100%;width:100%}.icon-with-spinner__icon-container{align-items:center;display:flex;justify-content:center;position:relative}.icon-with-spinner__spinner-container{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));grid-template-rows:repeat(2,minmax(0,1fr));position:absolute;right:0;top:0}.icon-with-spinner__spinner{grid-column-start:2;grid-row-start:1;height:100%;width:100%}.icon-with-spinner__animation{animation:spin 1.4s linear infinite}.icon-with-status__container{margin-bottom:12px;max-width:-moz-fit-content;max-width:fit-content;position:relative}.icon-with-status__container .icon{border-radius:100%}.icon-with-status__status-dot{bottom:-.125rem;position:absolute;right:-.25rem}.icon-with-status__container .inner-icon__container{background:var(--dynamic-base-1);border-radius:100%;bottom:-.125rem;padding:.1875rem;position:absolute;right:-.1875rem}.icon-with-status__container .inner-icon{border-radius:100%}.icon-with-status__container .inner-icon svg{height:1rem;width:1rem}.icon-with-status__container .inner-icon--green{background:var(--dynamic-success-1)}.icon-with-status__container .inner-icon--red{background:var(--dynamic-error-1)}.icon-with-status__container .inner-icon path{fill:var(--dynamic-base-1)}.icon-with-status__container .status-dot__container{align-items:center;background:var(--dynamic-base-1);border-radius:100%;bottom:-.125rem;display:flex;height:.625rem;justify-content:center;position:absolute;right:-.25rem;width:.625rem}.icon-with-status__container .status-dot{border-radius:100%;height:.375rem;width:.375rem}.icon-with-status__container .status-dot--green{background:var(--dynamic-success-1)}.icon-with-status__container .status-dot--red{background:var(--dynamic-error-1)}.info-item__container{color:var(--dynamic-text-tertiary);display:flex}.info-item__container a{text-decoration:underline}.info-item__container .info-item__icon-container{border-radius:calc(var(--dynamic-border-radius)/3);color:var(--dynamic-text-tertiary);display:flex;margin-right:1.125rem}.info-item__container .info-item__icon-container svg{height:1.5rem;width:1.5rem}.info-item__container .info-item__secondary-text{margin-top:.25rem}.phone-number-field{display:flex;flex-direction:column}.phone-number-field__fields{align-items:stretch;display:flex;position:relative;width:100%}.phone-number-field__fields__country-code{align-items:center;background-color:var(--dynamic-base-2);border:.0625rem solid var(--dynamic-base-3);border-radius:calc(var(--dynamic-border-radius)*.4) 0 0 calc(var(--dynamic-border-radius)*.4);border-right:none;cursor:pointer;display:flex;padding-left:.75rem;position:relative;transition:all .2s ease;width:6.25rem}.phone-number-field__fields__country-code--disabled{background-color:var(--dynamic-base-3);pointer-events:none}.phone-number-field__fields__country-code__flag{margin-right:.5rem}.phone-number-field__fields__country-code__plus{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}.phone-number-field__fields__country-code__container{align-items:center;display:flex;flex:1;pointer-events:none}.phone-number-field__fields__country-code .phone-number-field__fields__country-code__container .phone-number-field__fields__country-code__container__input{border:none;flex:1;padding:0;width:100%}.phone-number-field__fields__country-code__chevron{cursor:pointer;position:absolute;right:.5rem;width:1rem}.phone-number-field__fields__phone-number{align-items:center;display:flex;flex:1;position:relative}.phone-number-field__fields .phone-number-field__fields__phone-number .phone-number-field__fields__phone-number__input{border-radius:0 calc(var(--dynamic-border-radius)*.4) calc(var(--dynamic-border-radius)*.4) 0;padding-left:.75rem}.phone-number-field__fields__placeholder{align-self:center;color:var(--dynamic-text-secondary);left:7.0625rem;pointer-events:none;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.phone-number-field__fields__inline-submit{align-self:center;position:absolute;right:.75rem}.phone-number-field__dropdown{width:calc(var(--dynamic-modal-width) - 3rem)}.phone-number-field__dropdown__items{display:flex;flex-direction:column}.phone-number-field__dropdown__items__country{align-items:center;cursor:pointer;display:flex;gap:.375rem;padding:.375rem .75rem}.phone-number-field__dropdown__items__country__flag{width:1.5rem}.phone-number-field__dropdown__items__country__name{font-size:var(--dynamic-text-size-body-small)}.phone-number-field__dropdown__items__country__code{color:var(--dynamic-text-secondary);font-size:var(--dynamic-text-size-body-small)}.phone-number-field__dropdown__items__country:hover{background-color:var(--dynamic-base-4)}.phone-number-field__dropdown__items__country--selected{background-color:var(--dynamic-base-3)}.phone-number-field__error-message{color:var(--dynamic-error-1);padding:.5rem 0}.phone-number-field input::-webkit-inner-spin-button,.phone-number-field input::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}.phone-number-field input[type=number]{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}.inline-submit-button{--icon-arrow:var(--dynamic-text-tertiary);--icon-background:var(--dynamic-base-3);transition:all .2s}.inline-submit-button path,.inline-submit-button rect{transition:all .2s}.inline-submit-button--active,.inline-submit-button:hover{--icon-arrow:var(--dynamic-text-secondary);--icon-background:var(--dynamic-hover)}.inline-submit-button--ready,.inline-submit-button--ready:hover{--icon-arrow:var(--dynamic-base-2);--icon-background:var(--dynamic-brand-primary-color)}.input__container{position:relative}.input__container .input__suffix{position:absolute;right:1rem;top:1rem}.input__container .input{background:var(--dynamic-base-2);border-color:var(--dynamic-base-3);border-radius:calc(var(--dynamic-border-radius)*.4);border-width:.0625rem;color:var(--dynamic-text-primary);font-size:.9375rem;font-weight:400;margin:0;outline:none;transition:all .2s ease;width:100%}.input__container .input:disabled{background:var(--dynamic-base-3);border-color:var(--dynamic-base-4)}.input__container .input:disabled .input__label{color:var(--dynamic-text-tertiary)}.input__container .input__label{color:var(--dynamic-text-secondary);cursor:text;font-size:.625rem;pointer-events:none}.input__container .input:not(.input__error,.input__success):focus,.input__container .input:not(.input__error,.input__success):hover{background:var(--dynamic-base-2);border-color:var(--dynamic-base-4)}.input__container .input__error{background:var(--dynamic-error-2);border-color:var(--dynamic-error-1)}.input__container .input__error~.input__label,.input__container .input__error~.input__trailing{color:var(--dynamic-error-1)}.input__container .input__success{border-color:var(--dynamic-success-1)}.input__container .input__success~.input__label,.input__container .input__success~.input__trailing{color:var(--dynamic-success-1)}.input__container .input__has_trailing{padding-right:4rem}.input__container .input__trailing{color:var(--dynamic-text-secondary);font-size:.75rem;font-weight:500;position:absolute;right:.75rem;top:50%;transform:translateY(-50%)}.input__container--dense .input{padding:1.125rem .75rem .375rem}.input__container--dense .input::-moz-placeholder{color:transparent}.input__container--dense .input::placeholder{color:transparent}.input__container--dense .input--no-label{padding-block:.75rem}.input__container--dense .input__label{left:.75rem;position:absolute;top:.4375rem;transition:all .2s ease;-webkit-user-select:none;-moz-user-select:none;user-select:none}.input__container--dense .input:-moz-placeholder-shown~.input__label{font-size:.9375rem;top:.75rem}.input__container--dense .input:placeholder-shown~.input__label{font-size:.9375rem;top:.75rem}.input__container--dense .input:focus~.input__label{font-size:.625rem;top:.4375rem}.input__container--regular{display:flex;flex-direction:column}.input__container--regular .input{padding:.75rem}.input__container--regular .input__label{align-items:center;display:inline-flex;font-size:.75rem;line-height:1rem;margin-bottom:.5rem;order:-1}.input__container--regular .input__label:after{background:var(--dynamic-base-4);content:\"\";flex:1;height:1px;margin-left:.75rem;right:0}.input__container--regular .input__suffix{top:2.375rem}.input__message{color:var(--dynamic-text-primary);padding:.5rem 0}.input__message__error{color:var(--dynamic-error-1)}.input__message__success{color:var(--dynamic-success-1)}.list-tile{align-items:center;background-color:var(--dynamic-wallet-list-tile-background);border:var(--dynamic-wallet-list-tile-border);border-radius:calc(var(--dynamic-border-radius)/2);box-shadow:var(--dynamic-wallet-list-tile-shadow);color:var(--dynamic-text-primary);display:flex;gap:.625rem;padding:var(--dynamic-wallet-list-tile-padding);transition-duration:var(--dynamic-wallet-list-tile-animation-duration);transition-property:all;transition-timing-function:ease-out;width:100%}.list-tile:not(:disabled):active{transform:scale(.95)}.list-tile:not(:disabled):hover{background-color:var(--dynamic-wallet-list-tile-background-hover);border:var(--dynamic-wallet-list-tile-border-hover);box-shadow:var(--dynamic-wallet-list-tile-shadow-hover)}.list-tile__children{flex-grow:1;text-align:left}.modal-header{align-items:center;background:var(--dynamic-header-background);display:flex;flex-direction:column;justify-content:center;padding:var(--dynamic-header-padding);width:100%}.modal-header--border{border-bottom:var(--dynamic-header-border-bottom)}.modal-header--empty{padding-bottom:0}.modal-header__content{align-items:center;display:flex;justify-content:center;width:100%}.modal-header__content--align-content-bottom{align-items:start}.modal-header__content__leading,.modal-header__content__trailing{align-items:center;display:flex;flex:1;gap:.25rem;height:1.5rem}.modal-header__content__leading--empty,.modal-header__content__trailing--empty{height:0}.modal-header__content__leading{justify-content:flex-start;margin-right:auto}.modal-header__content__trailing{justify-content:flex-end;margin-left:auto}.hardware-wallet-toggle__toggle{pointer-events:none}.network-switch-control__container{align-items:center;background:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)/2);bottom:0;color:var(--dynamic-text-primary);display:flex;gap:.375rem;max-width:100%;padding:.25rem;position:absolute;right:0;transform:translateX(50%)}.network-switch-control__container--error{border:1px solid var(--dynamic-error-1);color:var(--dynamic-error-1);cursor:auto}.network-switch-control__network-name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.network-switch-control__arrow-icon{min-width:1rem;transform:rotate(90deg);transition:transform .15s linear}.network-switch-control__arrow-icon--active{transform:rotate(-90deg)}@keyframes spinner-animation{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.network{color:var(--dynamic-text-primary);display:flex;justify-content:space-between;width:100%}.network .network__container{align-items:flex-start;display:flex}.network .network__title-icon{height:1rem;margin-right:.5rem;margin-top:.0625rem;width:1rem}.network .network__title-container{display:flex;flex-direction:column;gap:.25rem}.network .network__title-copy{white-space:nowrap}.network .network__status-container{align-items:center;border-radius:100%;display:flex;height:1rem;justify-content:center;width:1rem}.network .network__status-container .network__status-icon{color:#fff;height:.75rem;width:.75rem}.network .network__status-container .network__status-icon svg path{fill:currentcolor}.network .network__status-container .network__status-spinner-icon{animation:spinner-animation 2s linear infinite;height:.75rem;margin-right:-.9375rem;margin-top:-.75rem;transform-origin:0 100%;width:.75rem}.network .network__status-container--active{background-color:var(--dynamic-brand-primary-color)}.network-action{align-items:center;display:flex;padding:.5rem 1rem}@media (pointer:coarse){.network-action{padding:.5rem 1.5rem}}.network-action:not(.network--not-supported){cursor:pointer}.network-action:not(.network--not-supported):hover{background-color:var(--dynamic-hover)}.network-control-skeleton{align-items:center;border-radius:calc(var(--dynamic-border-radius)/2);display:flex;gap:.375rem;justify-content:center;padding:.1875rem .25rem}.network-control-skeleton__icon{background-color:var(--dynamic-base-3);border:1px solid var(--dynamic-base-4);border-radius:100%;height:1.125rem;width:1.125rem}.network-control-skeleton__skeleton{width:1.875rem}.non-network-switching-supported-control{align-items:center;background:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)/2);bottom:0;color:var(--dynamic-text-primary);display:flex;gap:.375rem;justify-content:center;padding:.25rem;position:absolute;right:0;transform:translateX(50%)}.non-network-switching-supported-control--error{background-color:var(--dynamic-error-2);cursor:auto}.non-network-switching-supported-control__network-name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.network-picker-network-control{display:flex;flex-direction:column}.network-picker-network-control__anchor{padding-top:.125rem;position:relative}.linear-gradient-frame{align-items:center;display:flex;flex-direction:column;justify-content:center;position:relative}.linear-gradient-frame__icon{position:absolute}.pin-field__container{display:flex;flex:1;flex-grow:0;gap:2.5%;justify-content:space-between;margin-top:1rem;max-width:19.5rem;width:100%}.pin-input__input{background:var(--dynamic-base-2);border:.0625rem solid var(--dynamic-base-4);border-radius:.75rem;color:var(--dynamic-text-primary);font-size:1rem;height:2.75rem;max-width:2.75rem;outline:.125rem solid transparent;outline-offset:.125rem;text-align:center;width:100%}.pin-input__input:last-child{margin-right:0}.pin-input__input:disabled{cursor:not-allowed;opacity:.5}.pin-input__input--error{background:var(--dynamic-error-2);border-color:var(--dynamic-error-1);color:var(--dynamic-error-1)}.pin-input__input--success{background:var(--dynamic-success-2);border-color:var(--dynamic-success-1);color:var(--dynamic-success-1)}.portal__container{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.portal__backdrop{-webkit-backdrop-filter:var(--dynamic-modal-backdrop-filter);backdrop-filter:var(--dynamic-modal-backdrop-filter);background:var(--dynamic-modal-backdrop-background);cursor:default;height:100%;left:0;position:fixed;top:0;width:100%}.search__container{align-items:center;background:var(--dynamic-search-bar-background);border:var(--dynamic-search-bar-border);border-radius:calc(var(--dynamic-border-radius)/1.5);cursor:text;display:flex;gap:.625rem;height:2.625rem;justify-content:space-between;min-height:2.25rem;padding-left:.75rem;padding-right:.75rem}.search__container,.search__container svg{color:var(--dynamic-text-tertiary)}.search__container:hover:not(.search__container--active,.search__container:focus-within){background:var(--dynamic-search-bar-background-hover);border:var(--dynamic-search-bar-border-hover);color:var(--dynamic-text-secondary)}.search__container:hover:not(.search__container--active,.search__container:focus-within) svg{color:var(--dynamic-text-secondary)}.search__container--active,.search__container:focus-within{background:var(--dynamic-search-bar-background-focus);border:var(--dynamic-search-bar-border-focus);color:var(--dynamic-text-primary)}.search__container--active svg,.search__container:focus-within svg{color:var(--dynamic-text-secondary)}.search-icon__container{align-items:center;color:var(--dynamic-text-tertiary);display:flex;height:1rem;justify-content:center;width:1rem}.search__input{background:none;border:0;color:var(--dynamic-text-primary);display:flex;flex-grow:1;font-size:var(--dynamic-text-size-body-small);font-weight:500;line-height:1rem;margin:0;outline:none;padding-bottom:.25rem;padding-top:.25rem}.search__input::-moz-placeholder{color:var(--dynamic-text-tertiary)}.search__input::placeholder{color:var(--dynamic-text-tertiary)}.search__input:hover::-moz-placeholder{color:var(--dynamic-text-secondary)}.search__input:hover::placeholder{color:var(--dynamic-text-secondary)}.search__input:focus::-moz-placeholder{color:transparent}.search__input:focus::placeholder{color:transparent}.search__button--clear{color:var(--dynamic-text-secondary);font-size:var(--dynamic-text-size-body-mini)}.search__button--clear:hover{color:var(--dynamic-text-primary)}.select__container{cursor:pointer;position:relative}.select__container .select{-webkit-appearance:none;-moz-appearance:none;appearance:none;bottom:0;left:0;opacity:0;outline:none;position:absolute;right:0;top:0}.select__container .select::-moz-placeholder{color:transparent}.select__container .select::placeholder{color:transparent}.select__container .select__body{background:var(--dynamic-base-2);border-color:var(--dynamic-base-4);border-radius:calc(var(--dynamic-border-radius)*.4);border-width:.0625rem;display:block;margin:0;padding:1.125rem .75rem .375rem;position:relative;transition:all .2s ease;width:100%}.select__container .select__value{color:var(--dynamic-text-primary);font-size:.9375rem;font-weight:400}.select__container .select__label{color:var(--dynamic-text-secondary);font-size:.9375rem;left:.75rem;pointer-events:none;position:absolute;top:.75rem;transition:all .2s ease}.select__container .select__control_icon{align-items:center;bottom:0;color:var(--dynamic-text-secondary);display:flex;position:absolute;right:.75rem;top:0}.select__container .select__has_value .select__label{font-size:.625rem;top:.4375rem}.select__container .select:has(.select__error)~.select__body{background:var(--dynamic-error-2);border-color:var(--dynamic-error-1)}.select__container .select__error{background:var(--dynamic-error-2);border-color:var(--dynamic-error-1)}.select__container .select__error .select__control_icon,.select__container .select__error .select__label{color:var(--dynamic-error-1)}.select__message{color:var(--dynamic-text-primary);padding-top:.5rem}.select__message__error{color:var(--dynamic-error-1)}.separator{border-top:.0625rem solid var(--dynamic-base-3)}@keyframes shimmer{to{transform:translateX(100%)}}.skeleton{background:var(--dynamic-base-3);border-radius:calc(var(--dynamic-border-radius)/6);display:inline-flex;line-height:1;min-width:100%;overflow:hidden;position:relative;z-index:0}.skeleton:after{animation:shimmer 2s infinite;background-image:var(--dynamic-loading-animation-gradient);bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;transform:translateX(-100%)}.spinner{animation:spin 1s linear infinite}.spinner path{stroke:var(--dynamic-brand-primary-color)}@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.status-dot__container{align-items:center;background:var(--dynamic-base-1);border-radius:100%;display:flex;height:.625rem;justify-content:center;width:.625rem}.status-dot{border-radius:100%;height:.375rem;width:.375rem}.status-dot--green{background:var(--dynamic-success-1)}.status-dot--red{background:var(--dynamic-error-1)}.status-dot--yellow{background:var(--dynamic-alert-1)}.switch__container{display:flex}.switch__container.disabled{opacity:.2;pointer-events:none}.switch__container .button{background:var(--dynamic-base-2);border-radius:0;box-shadow:var(--dynamic-shadow-down-1);color:var(--dynamic-text-primary);font-size:var(--dynamic-text-size-button-primary);font-weight:400;margin:0;padding:.75rem 0;width:100%}.switch__container .button:first-child{border-bottom-left-radius:calc(var(--dynamic-border-radius)/3);border-right:0;border-top-left-radius:calc(var(--dynamic-border-radius)/3)}.switch__container .button:last-child{border-bottom-right-radius:calc(var(--dynamic-border-radius)/3);border-top-right-radius:calc(var(--dynamic-border-radius)/3)}.switch__container .button.active{background:var(--dynamic-brand-primary-color);color:#fff}.text-button{align-items:center;border-radius:calc(var(--dynamic-border-radius)/6);color:var(--dynamic-text-secondary);cursor:pointer;display:flex;font-size:.75rem;font-weight:500;gap:.375rem;padding:.125rem .375rem}.text-button:hover{background-color:var(--dynamic-hover)}.auth-mode-switch__container{align-items:center;color:#fff;display:flex;font-size:1rem;gap:.25rem;margin-bottom:.25rem}.auth-mode-switch__container label{cursor:pointer}.toolkit__container{background:var(--dynamic-base-1);border-bottom-right-radius:calc(var(--dynamic-border-radius)/1.5);border-top-right-radius:calc(var(--dynamic-border-radius)/1.5);display:flex;flex-direction:column;gap:1rem;left:0;padding:1.875rem 3.5rem;position:fixed;top:50%;transform:translateY(-50%);width:18.125rem}@media (pointer:coarse){.toolkit__container{display:none}}.switcher__copy{color:var(--dynamic-text-primary);margin-bottom:.25rem}.tos-and-pp__text{color:var(--dynamic-text-secondary);font-size:var(--dynamic-text-size-body-small);margin:0 auto;text-align:center}.tos-and-pp__text .tos-and-pp__link{color:var(--dynamic-text-link);text-decoration:none}.zoom-transition__root{transform-origin:50% 50%}.vertical-drawer-animation{overflow:hidden;transition-property:max-height;transition-timing-function:ease-out}.typography{font-family:var(--dynamic-font-family-primary);font-weight:400;line-height:normal}.typography--title{font-size:var(--dynamic-text-size-title)}.typography--body-normal{font-size:var(--dynamic-text-size-body-normal)}.typography--body-small{font-size:var(--dynamic-text-size-body-small)}.typography--body-mini{font-size:var(--dynamic-text-size-body-mini)}.typography--button-primary{font-size:var(--dynamic-text-size-button-primary);font-weight:700}.typography--button-secondary{font-size:var(--dynamic-text-size-button-secondary);font-weight:700}.typography--button-tertiary{font-size:var(--dynamic-text-size-button-secondary);font-weight:400}.typography--numbers-big{font-family:var(--dynamic-font-family-numbers);font-size:var(--dynamic-text-size-numbers-big)}.typography--numbers-medium{font-family:var(--dynamic-font-family-numbers);font-size:var(--dynamic-text-size-numbers-medium)}.typography--bold{font-weight:700}.typography--medium{font-weight:500}.typography--regular{font-weight:400}.typography--link{color:var(--dynamic-text-link)}.typography--brand-primary{color:var(--dynamic-brand-primary-color)}.typography--primary{color:var(--dynamic-text-primary)}.typography--secondary{color:var(--dynamic-text-secondary)}.typography--tertiary{color:var(--dynamic-text-tertiary)}.typography--uppercase{text-transform:uppercase}.typography--dynamic-error-1{color:var(--dynamic-error-1)}.typography--errror-2{color:var(--dynamic-error-2)}.typography--connection-green-1{color:var(--dynamic-success-1)}.typography--tooltip{color:var(--dynamic-tooltip-text-color)}.typography--inherit{color:inherit}.typography--white{color:#fff}.typography--current-color{color:currentcolor}.typography--truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.typography-button__content{align-items:center;display:flex;flex-direction:column}.typography-button__content--with-description{align-items:flex-start;flex:1;text-align:left}.powered-by-dynamic{align-items:center;color:var(--dynamic-text-tertiary);display:flex;text-decoration:none;width:100%}.powered-by-dynamic--center{justify-content:center}.powered-by-dynamic--right{justify-content:end}.powered-by-dynamic__logo,.powered-by-dynamic__text{display:inline-block}.powered-by-dynamic__text{margin-right:.25rem}.powered-by-dynamic__logo{display:inline-block;margin-top:.0625rem;max-width:3.6875rem;width:3.6875rem}.dynamic-footer{background:var(--dynamic-footer-background);padding:var(--dynamic-footer-padding);width:100%}.dynamic-footer:not(.dynamic-footer__top-border){padding-top:0}.dynamic-footer__top-border{border-top:var(--dynamic-footer-border-top)}.user-address,.user-address__container{align-items:center;display:flex;justify-content:center}.user-address__container{margin-top:.375rem}.user-address__status-dot{margin-right:.375rem}.user-address__seperator{background-color:var(--dynamic-base-4);height:.5rem;margin:0 .5rem;width:.0625rem}.app-origin-tile{align-items:center;display:flex;flex-direction:column;gap:.125rem}.app-origin-tile__title{align-items:center;display:flex;gap:.25rem}.app-origin-tile__logo{height:1rem;width:auto}.options-switcher{background-color:var(--dynamic-base-4);display:flex;min-height:2rem;position:relative}.options-switcher,.options-switcher__active-rail,.options-switcher__button{border-radius:calc(var(--dynamic-border-radius)/3)}.options-switcher__button{color:var(--dynamic-text-secondary);flex:1;font-size:var(--dynamic-text-size-button-secondary);font-weight:500;position:relative}.options-switcher__button--active{color:var(--dynamic-text-primary)}.options-switcher__active-rail{background-color:var(--dynamic-base-2);box-shadow:var(--dynamic-shadow-down-1);height:100%;position:absolute;transition:left .1s ease-in-out}.dynamic-verified-icon{color:var(--dynamic-success-1)}.user-profile-field__value{align-items:center;display:flex;min-height:.9375rem;overflow:auto}.user-profile-field__verify-icon{margin-left:.25rem}.user-profile-section{margin:0 0 .75rem}.user-profile-section__title{margin-bottom:.5rem}.user-profile-section__header{display:flex;flex-direction:row;justify-content:space-between}.user-profile-section__action{display:flex;margin:0 0 .5rem}.user-profile-social-account__connected-avatar{border-radius:100%;height:100%;overflow:hidden;position:relative;width:100%}.user-profile-social-account__connected-provider-icon{background-color:#fff;border-radius:100%;bottom:-.1875rem;height:.875rem;padding:.09375rem;position:absolute;right:-.3125rem;width:.875rem}.user-profile-social-account__image{-o-object-fit:cover;object-fit:cover}.user-profile-social-account{align-items:center;background-color:var(--dynamic-wallet-list-tile-background);border:var(--dynamic-wallet-list-tile-border);border-radius:calc(var(--dynamic-border-radius)/2);box-shadow:var(--dynamic-wallet-list-tile-shadow);color:var(--dynamic-text-primary);display:flex;gap:.625rem;padding:var(--dynamic-wallet-list-tile-padding);width:100%}.user-profile-social-account__icon{flex-shrink:0;height:1.5rem;position:relative;width:1.5rem}.user-profile-social-account__label{flex-grow:1;text-align:left}.user-profile-social-account__button{box-shadow:none;flex-shrink:0;padding:.1875rem .28125rem}.user-profile-social-account__button .button__spinner-container{left:auto}.user-profile__fields{background-color:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)/2);padding:.75rem}.user-profile__fields,.user-profile__social-accounts{display:flex;flex-direction:column;gap:.5rem}.divider{align-items:center;display:flex;gap:.75rem;justify-content:space-between;padding:1rem 0}.divider__dash{background:var(--dynamic-base-4);height:.0625rem;width:100%}.divider__text{white-space:nowrap}.divider__full-width{width:100%}.divider__no-gap{gap:0}.dynamic-tooltip{background-color:var(--dynamic-tooltip-color);border-radius:calc(var(--dynamic-border-radius)/4);opacity:0;padding:.125rem .5rem;pointer-events:none;position:absolute;transform:translate(-50%,-100%);transform-origin:50% 50%;-webkit-user-select:none;-moz-user-select:none;user-select:none;white-space:nowrap;z-index:-1}.dynamic-tooltip__arrow{bottom:-.1875rem;color:var(--dynamic-tooltip-color);height:.25rem;left:50%;position:absolute;transform:translateX(-50%);width:.375rem}.dynamic-tooltip--visible{opacity:1;pointer-events:unset;-webkit-user-select:unset;-moz-user-select:unset;user-select:unset;z-index:1}.modal-header-banner{padding:.5rem .75rem;text-align:center}.modal-header-banner__error{background-color:var(--dynamic-error-2)}.modal-header-banner__success{background-color:var(--dynamic-success-2)}.modal-header-banner__notice{background-color:var(--dynamic-brand-secondary-color)}.otp-verification-view{align-items:center;display:flex;flex-direction:column;padding:var(--dynamic-layout-content-padding);text-align:center}.otp-verification-view__icon-with-spinner{margin:0 auto .75rem}.otp-verification-view--message{padding:var(--dynamic-layout-content-error-padding)}.otp-verification-view__status-header{align-items:center;display:flex;justify-content:center}.otp-verification-view__footer{display:flex;flex-direction:column;gap:1rem}.otp-verification-view__destination-container{align-items:center;display:flex;gap:.25rem;justify-content:center}.otp-verification-view__retry-container{margin:1rem auto 0}.overlay-card__content{display:flex;flex-direction:column;padding:.25rem 1.5rem 1.5rem}.overlay-card__content-p0{padding:0}.overlay-card-base{bottom:0;height:100%;left:0;max-height:100%;overflow:hidden;position:absolute;right:0}.overlay-card-base--disabled{pointer-events:none}.overlay-card-base__animation{bottom:0;height:100%;left:0;max-height:100%;position:absolute;right:0;top:0}.overlay-card-base__overlay{background-color:var(--dynamic-overlay);bottom:0;left:0;position:absolute;right:0;top:0}.overlay-card-base__content-wrapper{bottom:0;left:0;max-height:80%;position:absolute;right:0;top:20%}.overlay-card-base__content{background-color:var(--dynamic-base-1);border-radius:calc(var(--dynamic-border-radius)/1.5);border-top:.0625rem solid var(--dynamic-base-4);bottom:0;display:flex;flex-direction:column;left:0;max-height:100%;overflow-y:auto;position:absolute;right:0}@media (pointer:coarse){.overlay-card-base__content{border-bottom-left-radius:0;border-bottom-right-radius:0}}.overlay-card-target{bottom:0;height:100%;left:0;max-height:100%;overflow:auto;position:absolute;right:0}.icon-list-tile{padding-left:0;padding-right:0}.icon-list-tile--children{align-items:center;display:flex;justify-content:center}.popper-content{display:flex;position:absolute;z-index:100}.popper-content__transform-origin-bottom-left{transform:translateY(-100%)}.popper-content__transform-origin-bottom-right{transform:translate(-100%,-100%)}.popper-content__transform-origin-top-left{transform:translate(0)}.popper-content__transform-origin-top-right{transform:translate(-100%)}.dropdown{align-items:stretch;background-color:var(--dynamic-base-2);border:.0625rem solid var(--dynamic-base-4);border-radius:calc(var(--dynamic-border-radius)/3);box-shadow:0 .5rem .75rem -.375rem rgba(24,39,75,.06),0 .5rem .75rem -.1875rem rgba(24,39,75,.06);display:flex;flex-direction:column;max-height:var(--max-height);min-width:10rem;overflow-y:auto;padding-block:.1875rem}.dropdown--entering{animation-fill-mode:both;animation-iteration-count:1;animation-name:desktop-dropdown-entering-animation;animation-timing-function:ease-out}.dropdown--exiting{animation-fill-mode:both;animation-iteration-count:1;animation-name:desktop-dropdown-exiting-animation;animation-timing-function:ease-out}.menu-list__overlay-card__container{align-items:stretch;display:flex;flex-direction:column;overflow-y:auto;padding-bottom:1.25rem}.transaction-confirmation.dynamic-tooltip{word-wrap:break-word;color:var(--dynamic-base-1);font-size:12px;line-height:1.4;max-width:145px;white-space:normal;width:-moz-max-content;width:max-content}.transaction-confirmation__banner{margin:-8px auto 0;padding-bottom:16px;text-align:center;width:75%}.transaction-confirmation__actions{align-items:center;display:flex;flex-direction:row;gap:.375rem;padding:16px 0;width:100%}.transaction-confirmation__actions .button--brand-primary .icon--color-text-secondary,.transaction-confirmation__actions .button--brand-primary .typography--primary{color:#fff}.transaction-confirmation__body{align-items:stretch;display:flex;flex:1;flex-direction:column;overflow:hidden;padding:0 1.5rem 1.5rem}.transaction-confirmation__app-origin-tile{padding:.75rem}.transaction-confirmation__content{display:flex;flex:1;flex-direction:column;justify-content:flex-start;margin-top:.25rem;overflow:auto;width:100%}.transaction-confirmation__rows{max-height:14.375rem;padding:.5rem .75rem;width:100%}.transaction-confirmation__rows .flex{display:flex;justify-content:space-between}.transaction-confirmation__rows .flex-row{flex-direction:row;gap:.5rem}.transaction-confirmation__rows .row{padding:.5rem 0}.transaction-confirmation__rows .gap{gap:.3rem}.transaction-confirmation__secure-wallet{margin-bottom:0;margin-top:1rem}.transaction-confirmation__info{text-align:right}.transaction-confirmation__error{padding-top:.75rem}.transaction-confirmation__warning{padding-top:12px}.transaction-card-container{display:flex;flex-direction:column;gap:.75rem}.transaction-card{background-color:var(--dynamic-base-2);border-radius:.75rem;display:flex;flex-direction:column;padding:.5rem}.transaction-card__icon{align-items:center;display:flex;margin-left:auto}.transaction-card__icon__container{align-items:center;display:flex;justify-content:center;position:relative}.transaction-card__icon__container__main{border-radius:50%;height:2rem;width:2rem}.transaction-card__icon__container__network{background-color:var(--dynamic-base-1);border:1px solid var(--dynamic-base-1);border-radius:50%;bottom:-3px;height:1rem;position:absolute;right:-3px;width:1rem}.transaction-card__total p .typography{gap:.3rem}.transaction-card__info{align-items:center;display:flex;flex-direction:row;gap:.25rem}.transaction-card__assets-container{display:flex;flex-direction:column}.transaction-card__in,.transaction-card__out{padding:.25rem 0;width:100%}.transaction-card__info-container{align-items:center;display:flex;justify-content:space-between;padding:.5rem;width:100%}.transaction-card__amount-symbol{align-items:center;display:flex;gap:.75rem}.transaction-card__token-info{align-items:flex-end;display:flex;flex-direction:column;gap:.125rem}.transaction-card__token-row{align-items:center;display:flex;gap:.5rem}.transaction-card__arrow{color:var(--dynamic-text-secondary);font-size:1.25rem;margin-left:.5rem}.transaction-card__destination{align-items:center;display:flex;gap:.5rem;margin:0}.transaction-card .row{border-top:1px solid var(--dynamic-base-3);display:flex;justify-content:space-between;padding:.6rem 0}.transaction-card .flex-row{display:flex;flex-direction:row;gap:.1rem}.transaction-card .gap-native{gap:.3rem}.transaction-card__divider{border-top:1px solid var(--dynamic-base-3);margin:0 .75rem}.transaction-card__details{display:flex;flex-direction:column}.transaction-card__row{align-items:center;display:flex;justify-content:space-between;padding:.5rem}.transaction-card__value{align-items:flex-end;display:flex;flex-direction:column;gap:.125rem}.transaction-card__network-info{align-items:center;display:flex;gap:.5rem}.transaction-card__network-icon{border-radius:50%}.transaction-card__fee-info{align-items:center;display:flex;gap:.5rem}.transaction-card__fee-info .fee-tooltip{margin-right:.25rem}.transaction-card__label-with-tooltip{align-items:center;display:flex;gap:.25rem}.transaction-card__label-with-tooltip .fee-tooltip{align-items:center;display:flex}.transaction-status-layout{display:flex;flex:1;flex-direction:column;overflow:hidden}.transaction-status-layout .modal-header{padding:3rem .3125rem .625rem}.transaction-status-layout__status-icon{color:var(--dynamic-brand-primary-color);height:4rem;width:4rem}.transaction-status-layout__title{text-align:center}.transaction-status-layout__body{align-items:stretch;display:flex;flex:1;flex-direction:column;padding:.25rem 1.5rem 1.5rem}.transaction-status-layout__sent_to{text-align:center}.transaction-status-layout__sent_to p{display:inline}.transaction-status-layout__content{align-items:center;display:flex;flex-direction:column;justify-content:center;margin-top:.375rem;width:100%}.transaction-status-layout__rows{max-height:14.375rem;overflow-y:auto;padding:.375rem .75rem;width:100%}.transaction-status-layout__rows p{font-size:1.5rem}.transaction-status-layout__rows>.transaction-row:not(:first-child){border-top:1px solid var(--dynamic-base-4)}.transaction-status-layout__actions{margin-top:auto;padding-top:1rem}.transaction-status-layout__actions .button--brand-primary .typography--primary{color:var(--dynamic-base-2)}.transaction-status-layout__footer{padding-top:1rem}.tokens-balance-dropdown{background-color:var(--dynamic-base-2);border:1px solid var(--dynamic-base-4);border-radius:calc(var(--dynamic-border-radius)/2);cursor:pointer;padding:.875rem .75rem}.tokens-balance-dropdown,.tokens-balance-dropdown__selected{align-items:center;display:flex;gap:.5rem;justify-content:space-between}.tokens-balance-dropdown__selected .evm-network-control__arrow-icon{position:absolute;right:2.625rem}.tokens-balance-dropdown__menu_list{border-radius:calc(var(--dynamic-border-radius)/2);padding:.5rem 1rem;width:19.375rem}@media (max-width:640px){.tokens-balance-dropdown__menu_list{margin:0 auto;width:100%}.tokens-balance-dropdown__menu_list .modal-header{padding:1rem 0 1rem 1.25rem}}.tokens-balance-dropdown__menu_list .modal-header__leading{flex:none}.tokens-balance-dropdown__menu_list_item{align-items:center;display:flex;gap:.625rem;justify-content:space-between;padding:.5rem 0;text-align:left}.tokens-balance-dropdown__menu_list_item__name{display:flex;gap:.3125rem;min-width:9.375rem}.tokens-balance-dropdown__menu_list_item__balance{display:flex;gap:.3125rem}.tokens-balance-dropdown__chain{align-items:center;display:flex;gap:.375rem}.tokens-balance-dropdown__chain__icon{height:1rem;width:1rem}.tokens-balance-dropdown__balance-container{align-items:center;display:flex;gap:.25rem}.tokens-balance-dropdown__balance{align-items:center;display:flex;gap:.125rem}.send-balance-page-layout__header-content{align-items:center;display:flex;gap:.5rem}.send-balance-page-layout__body{display:flex;flex:1;flex-direction:column;overflow:auto;padding:.25rem 1.5rem 1.5rem}.send-balance-page-layout__balance-container{display:flex;flex-direction:column;gap:.5rem;padding-bottom:.5rem}.send-balance-page-layout__error{padding-bottom:1rem}.send-balance-page-layout__footer{padding-top:1.5rem}.send-balance-page-layout__network-container{display:flex;justify-content:center;padding-bottom:.5rem}.send-balance-form{display:flex;flex:1;flex-direction:column;gap:.5rem}.send-balance-form__button{flex:unset;margin-top:auto}.send-balance-form__secure-wallet{margin:0}.send-balance-form__field.fiat{padding-left:1.5625rem}.send-balance-form__amount-container{position:relative}.send-balance-form__amount-container__fiat_sign{left:.625rem;position:absolute;top:.6875rem}.send-balance-form__amount-container__double_arrow{position:absolute;right:.625rem;top:.875rem}.send-balance-form__amount-container__balance{display:flex;gap:.25rem;position:absolute;right:.75rem;top:1.4375rem}.send-balance-form__amount-container__field.input{padding-left:3.125rem;transition:none}.send-balance-form__amount-container__floating_value{color:#000;font-size:1rem;left:10px;pointer-events:none;position:absolute;top:1.1875rem;white-space:nowrap}.send-balance-form__amount_available{border-bottom:1px solid var(--dynamic-base-3);padding-bottom:.75rem}.send-balance-form .input__container--regular .input__label:after{content:\"\";height:0}.select-network-button__icon{display:inline;margin:0 6px 3px;max-height:16px;max-width:16px;vertical-align:middle}.chip{align-items:center;background:var(--dynamic-base-2);border-radius:.75rem;color:var(--dynamic-text-primary);display:inline-flex;gap:.1875rem;height:1.5rem;justify-content:center;padding:.125rem .25rem}.chip__with-icon{padding:.125rem .25rem .125rem .125rem}.chip--icon{border-radius:50%;height:1.25rem;justify-content:center;overflow:hidden;width:1.25rem}.chip--icon,.form-field-label{align-items:center;display:flex}.form-field-label{color:var(--dynamic-text-secondary);cursor:text;font-size:.75rem}.form-field-label__with-divider:after{background:var(--dynamic-base-4);content:\"\";flex:1;height:1px;margin-left:.75rem;right:0}.step{counter-increment:step;gap:.5rem}.step,.step__icon{align-items:center;display:flex}.step__icon{flex-shrink:0;height:1.25rem;justify-content:center;width:1.25rem}.step__icon--done{background-color:var(--dynamic-success-1);border-radius:50%}.step__icon__check-mark{color:var(--dynamic-base-1);height:1rem;width:1rem}.step__index{align-items:center;border:1px solid var(--dynamic-base-4);border-radius:.625rem;display:flex;height:1.25rem;justify-content:center;min-width:1.25rem;padding:0 .25rem}.step__index-label:before{content:counter(step)}.step__leading{max-width:-moz-fit-content;max-width:fit-content;position:relative}.stepper{counter-reset:step;display:flex;gap:1rem;width:100%}.stepper__divider{flex-grow:1}.modal{left:50%;margin:auto;position:fixed;top:50%;transform:translate(-50%,-50%);width:var(--dynamic-modal-width)}@media (max-width:640px){.modal{bottom:0;max-width:37.5rem;top:auto;transform:translate(-50%);width:100%}}.modal__items{display:flex;flex-direction:column;gap:.75rem}.modal-card{background:var(--dynamic-base-1);border-radius:var(--dynamic-border-radius);box-shadow:var(--dynamic-shadow-down-3);overflow:hidden;width:100%}.modal-card--radius-small{border-radius:calc(var(--dynamic-border-radius)*.75)}.modal-card--with-border{border:1px solid var(--dynamic-base-4)}@media (max-width:640px){.modal-card{bottom:0;max-width:37.5rem;top:auto;transform:translateY(0);width:100%}.modal-card--sharp-mobile-bottom-radius:last-child{border-radius:var(--dynamic-border-radius) var(--dynamic-border-radius) 0 0}}.inline-widget-button{align-items:center;background-color:var(--dynamic-base-1);display:flex;gap:.5rem;min-height:100%;padding:.5rem .75rem;width:-moz-fit-content;width:fit-content}.inline-widget-button:hover{background-color:var(--dynamic-hover)}.inline-widget-button__icon{height:1.25rem;width:1.25rem}.inline-widget-button__vertical-divider{background-color:var(--dynamic-base-3);content:\"\";height:1rem;width:.0625rem}.inline-widget{align-items:center;background-color:var(--dynamic-base-1);border-radius:calc(var(--dynamic-border-radius)/3);display:flex;justify-content:center;overflow:hidden;width:-moz-fit-content;width:fit-content}.inline-widget>*{border-right:1px solid var(--dynamic-base-3)}.inline-widget>:last-child{border-right:none}.wallet-information-card{background:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)/2);display:flex;flex-direction:column}.wallet-information-card__header{border-bottom:1px solid var(--dynamic-base-3);display:flex;gap:.5rem;justify-content:space-between;padding:.75rem}.wallet-information-card__details-container{align-items:center;display:flex;gap:.75rem;justify-content:space-between;min-width:0}.wallet-information-card__menu{flex-shrink:0}.wallet-information-card__icon{height:1.75rem;width:1.75rem}.wallet-information-card__details{display:flex;flex-direction:column;overflow:hidden}.wallet-information-card__balance-container{align-items:center;display:flex;gap:.5rem;justify-content:space-between;padding:.75rem}.social-sign-in{display:flex;flex-wrap:wrap;gap:.375rem;justify-content:space-between}.social-sign-in--tile{flex:1;height:2.5rem}.social-sign-in--tile__full-width{flex:1 0 100%}.social-sign-in--card{display:flex;flex-direction:column;min-height:11.5625rem}.social-sign-in--card--body{display:grid;gap:.375rem;grid-template-columns:auto auto auto auto}.social-sign-in--card--tile{height:2.5rem}.sign-typed-data-preview--attribute-row{display:flex;gap:.5rem}.sign-typed-data-preview--fields-list,.sign-typed-data-preview--type-container{display:flex;flex-direction:column;gap:.25rem}.sign-typed-data-preview--type-container{padding-left:1rem}.need-help-section{align-items:center;display:flex;flex-direction:column;gap:.125rem;margin-bottom:.5rem}.need-help-section__links{display:flex;gap:.5rem}.need-help-section__links>*+*{padding-left:.5rem;position:relative}.need-help-section__links>*+:after{border-left:1px solid var(--dynamic-text-secondary);bottom:15%;content:\"\";left:0;position:absolute;top:15%;width:50%}.need-help-section__helper-link{color:var(--dynamic-text-link)}.textarea__container{position:relative}.textarea__container .textarea__suffix{position:absolute;right:1rem;top:1rem}.textarea__container .textarea{background:var(--dynamic-base-2);border-color:var(--dynamic-base-3);border-radius:calc(var(--dynamic-border-radius)*.4);border-width:.0625rem;color:var(--dynamic-text-primary);font-size:.9375rem;font-weight:400;margin:0;outline:none;resize:none;transition:all .2s ease;width:100%}.textarea__container .textarea:disabled{background:var(--dynamic-base-3);border-color:var(--dynamic-base-4)}.textarea__container .textarea:disabled .textarea__label{color:var(--dynamic-text-tertiary)}.textarea__container .textarea__label{color:var(--dynamic-text-secondary);cursor:text;font-size:.625rem}.textarea__container .textarea:not(.textarea__error):focus,.textarea__container .textarea:not(.textarea__error):hover{background:var(--dynamic-base-2);border-color:var(--dynamic-base-4)}.textarea__container .textarea__error{background:var(--dynamic-error-2);border-color:var(--dynamic-error-1)}.textarea__container .textarea__error~.textarea__label,.textarea__container .textarea__error~.textarea__trailing{color:var(--dynamic-error-1)}.textarea__container .textarea__valid{background:var(--dynamic-success-2);border-color:var(--dynamic-success-1)}.textarea__container .textarea__valid~.textarea__label,.textarea__container .textarea__valid~.textarea__trailing{color:var(--dynamic-success-1)}.textarea__container .textarea__has_trailing{padding-right:4rem}.textarea__container .textarea__trailing{color:var(--dynamic-text-secondary);font-size:.75rem;font-weight:500;position:absolute;right:.75rem;top:50%;transform:translateY(-50%)}.textarea__container--dense .textarea{padding:1.125rem .75rem .375rem}.textarea__container--dense .textarea::-moz-placeholder{color:transparent}.textarea__container--dense .textarea::placeholder{color:transparent}.textarea__container--dense .textarea__label{left:.75rem;position:absolute;top:.4375rem;transition:all .2s ease;-webkit-user-select:none;-moz-user-select:none;user-select:none}.textarea__container--dense .textarea:-moz-placeholder-shown~.textarea__label{font-size:.9375rem;top:.75rem}.textarea__container--dense .textarea:placeholder-shown~.textarea__label{font-size:.9375rem;top:.75rem}.textarea__container--dense .textarea:focus~.textarea__label{font-size:.625rem;top:.4375rem}.textarea__container--regular{display:flex;flex-direction:column}.textarea__container--regular .textarea{padding:.75rem}.textarea__container--regular .textarea__label{align-items:center;display:inline-flex;font-size:.75rem;line-height:1rem;margin-bottom:.5rem;order:-1}.textarea__container--regular .textarea__label:after{background:var(--dynamic-base-4);content:\"\";flex:1;height:1px;margin-left:.75rem;right:0}.textarea__container--regular .textarea__suffix{top:2.375rem}.textarea__message{color:var(--dynamic-text-primary);padding:.5rem 0}.textarea__message__error{color:var(--dynamic-error-1)}input:-webkit-autofill,input:-webkit-autofill:active,input:-webkit-autofill:focus,input:-webkit-autofill:hover,select:-webkit-autofill,select:-webkit-autofill:focus,select:-webkit-autofill:hover,textarea:-webkit-autofill,textarea:-webkit-autofill:focus,textarea:-webkit-autofill:hover{-webkit-text-fill-color:var(--dynamic-text-primary)!important;background:var(--dynamic-base-2);border-color:var(--dynamic-base-4);border-radius:calc(var(--dynamic-border-radius)*.4);border-width:.0625rem;color:var(--dynamic-text-primary)!important;-webkit-transition:background-color 5000s ease-in-out 0s;transition:background-color 5000s ease-in-out 0s}.secure-embedded-wallet-card{background:var(--dynamic-brand-secondary-color);border:var(--dynamic-wallet-list-tile-border);border-radius:calc(var(--dynamic-border-radius)/2);color:var(--dynamic-text-primary);display:flex;gap:.625rem;padding:.75rem;transition-duration:var(--dynamic-wallet-list-tile-animation-duration);transition-property:all;transition-timing-function:ease-out;width:100%}.secure-embedded-wallet-card__text-content{align-items:flex-start;cursor:pointer;display:flex;flex-direction:column;flex-grow:1;padding:0;text-align:left}.secure-embedded-wallet-card__text-content,.secure-embedded-wallet-card__text-content:hover{background-color:transparent;box-shadow:none}.secure-embedded-wallet-card__link{line-height:20px;text-decoration:underline}.toggle{-webkit-tap-highlight-color:transparent;cursor:pointer;display:inline-block}.toggle--input{display:none}.toggle--input:checked+.toggle--content__variant-primary{background-color:var(--dynamic-brand-primary-color);color:var(--dynamic-brand-primary-color)}.toggle--input:checked+.toggle--content .toggle--knob{left:1.09375rem}.toggle--input:checked+.toggle--content .toggle--knob>*{opacity:1}.toggle--content{background-color:var(--dynamic-base-3);border-radius:.625rem;height:1.25rem;position:relative;transition:background-color .2s ease;width:2.25rem}.toggle--knob{align-items:center;background-color:#fff;border-radius:100%;display:flex;height:1.0625rem;justify-content:center;left:.09375rem;position:absolute;top:.09375rem;transition:left .2s ease;width:1.0625rem}.toggle--knob>*{opacity:0;transition:opacity .2s ease}.list-tile-animated-trailing{position:relative}.list-tile-animated-trailing__child{position:absolute;right:0;transform:translateY(-50%);transition-duration:.2s;transition-property:opacity,transform;transition-timing-function:ease-in}.list-tile-animated-trailing__hover-element{opacity:0;position:absolute;right:0;transform:translate(-.625rem,-50%);transition-duration:.3s}.list-tile:hover .list-tile-animated-trailing__hover-element{opacity:1;transform:translateY(-50%)}.list-tile:hover .list-tile-animated-trailing__child{opacity:0;transform:translate(-.625rem,-50%)}.wallet-group-view-layout__container{padding:var(--dynamic-layout-content-padding)}.wallet-group-view-layout__icon{height:4rem;margin:0 auto .75rem;width:4rem}.wallet-group-view-layout__list{display:flex;flex-direction:column;gap:.5rem}.wallet-group-view-layout__title{padding-bottom:1rem;text-align:center}.retry-send-verification-code-section{align-items:center;display:flex;flex-direction:column}.retry-send-verification-code-section__confirmation{color:var(--dynamic-success-1);display:flex;gap:.3125rem;padding:.125rem .375rem}.retry-send-verification-code-section__not-received{text-align:center}.toggle-visibility-button__container{position:relative}.toggle-visibility-button__tooltip{background-color:var(--dynamic-text-primary);color:var(--dynamic-base-2);font-size:.75rem}.qrcode{--background:var(--dynamic-base-1);color:var(--dynamic-text-primary);position:relative}.qrcode__container{align-items:center;border-radius:calc(var(--dynamic-border-radius)/1.5);display:flex;height:18.125rem;justify-content:center;margin:auto;width:18.125rem}.qrcode__icon{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.qrcode-container__container{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:var(--dynamic-layout-content-padding)}.qrcode-container__container--message{padding:var(--dynamic-layout-content-error-padding)}.qrcode-container__container .button__content{display:flex;gap:.375rem}.qrcode-container__top{align-items:center;background-color:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)*.6);display:flex;flex-direction:column;gap:.625rem;margin-bottom:1.25rem;padding:.75rem}.qrcode-container__top .button-container{align-items:center;display:flex;gap:.5rem;width:100%}.qrcode-container__top .button-container svg path{fill-opacity:100%}.qrcode-container__top .button-container .qr-code-button{height:2.375rem}.qrcode-container__content{max-width:20rem;text-align:center}.qrcode-container__tos{margin-top:1rem;max-width:17.5rem;text-align:center}.qrcode-container__tos .tos__link{color:var(--dynamic-text-link)}.qrcode-container__tos .tos__link:hover{text-decoration:underline}.qr-code-wrapper__scan-issue-message{align-items:center;background:var(--dynamic-base-2);border-bottom:var(--dynamic-button-primary-border);border-radius:0;border-top:var(--dynamic-button-primary-border);color:var(--dynamic-text-primary);display:flex;justify-content:center;padding:.5rem .75rem;text-align:center;width:100%}.qr-code-wrapper__scan-issue-button{color:var(--dynamic-text-link);font-size:.75rem;text-decoration:underline}.radio-button{align-items:center;background-color:var(--dynamic-wallet-list-tile-background);border:var(--dynamic-wallet-list-tile-border);border-radius:calc(var(--dynamic-border-radius)/2);box-shadow:var(--dynamic-wallet-list-tile-shadow);color:var(--dynamic-text-primary);display:flex;gap:.5rem;padding:.75rem;width:100%}.radio-button input{height:1.5rem;width:1.5rem}.mfa-device-skeleton{align-items:center;background-color:var(--dynamic-wallet-list-tile-background);border:var(--dynamic-wallet-list-tile-border);border-radius:calc(var(--dynamic-border-radius)/2);box-shadow:var(--dynamic-wallet-list-tile-shadow);color:var(--dynamic-text-primary);display:flex;flex-direction:row;gap:.625rem;margin-bottom:.625rem;padding:.625rem;width:auto}.mfa-device-skeleton__details{display:flex;flex-direction:column;flex-grow:1;justify-content:space-between;padding-right:.625rem}.phantom-ledger-icon{position:absolute}.phantom-ledger-icon__container{align-items:center;display:flex;height:100%;position:relative}.account-exists__container{align-items:center;background:var(--dynamic-base-1);display:flex;flex-direction:column;padding:.3125rem}.account-exists__main{padding:var(--dynamic-modal-padding)}.account-exists__social-icon{margin:auto}.account-exists__image{padding:.3125rem;width:4.375rem}.account-exists__content{text-align:center}.account-exists__content--primary{margin-bottom:.375rem}.account-exists__content--secondary{margin-bottom:1rem}.account-exists__button--primary{background:var(--dynamic-base-2);border:1px solid var(--dynamic-base-4);box-shadow:var(--dynamic-shadow-down-1);margin:0}.user-data-form__form{display:flex;flex-direction:column}.user-data-form__error{margin-bottom:.625rem}.user-field__checkbox-container{background:var(--dynamic-base-2);border:.0625rem solid var(--dynamic-base-4);border-radius:calc(var(--dynamic-border-radius)/2);display:flex;flex-direction:column;padding:.625rem}.user-field__checkbox-container--error{background:var(--dynamic-error-2);border-color:var(--dynamic-error-1)}.user-field__consent-checkbox{display:flex;margin-bottom:.5rem}.user-field__consent-checkbox a{color:var(--dynamic-text-link)}.user-field__consent-checkbox:last-child{margin-bottom:0}.user-field__checkbox-label{padding-left:.75rem}.user-field__error-message{color:var(--dynamic-error-1);padding:.25rem}.user-phone-field__optional-label{color:var(--dynamic-text-secondary);font-size:.75rem;font-weight:500;pointer-events:none;position:absolute;right:.75rem;top:50%;transform:translateY(-50%)}.user-data-fields__fields-column{display:flex;flex-direction:column;gap:.375rem;margin-bottom:.5rem;overflow:auto}.user-data-fields__tooltip{background-color:var(--dynamic-text-primary);color:var(--dynamic-base-2);font-size:.75rem}.collect-user-data::-webkit-scrollbar,.collect-user-data::-webkit-scrollbar-thumb,.collect-user-data::-webkit-scrollbar-track{display:none}.collect-user-data__main-img{width:100%}.collect-user-data__form{padding:var(--dynamic-layout-content-padding)}.collect-user-data__form--error{padding:var(--dynamic-layout-content-error-padding)}.collect-user-data__img-container{align-items:center;display:flex;justify-content:center}.collect-user-data__img{height:1.75rem;width:1.75rem}.collect-user-data__img--rounded{border-radius:9999px}.collect-user-data__wallet-address{margin-left:.5rem}.collect-user-data__success-icon{align-items:center;display:flex;justify-content:center}.collect-user-data__success-icon svg{height:4rem;width:4rem}.collect-user-data__welcome-container{margin:1rem 0;text-align:center}.collect-user-data__welcome-title{margin-bottom:.25rem}.collect-user-data__log-out{margin:.75rem auto 0}.collect-user-data__error--not-supported{align-items:center;border-radius:0;display:flex;justify-content:center;margin:0;width:100%}.collect-user-data__network-picker{margin:auto 0;max-width:-moz-fit-content;max-width:fit-content}.collect-user-data__network-picker-button{border:1px solid var(--dynamic-base-4);position:static;transform:translateX(0)}.collect-user-data__network-picker-button:hover{background:var(--dynamic-hover)}.collect-user-data__network-container{border:var(--dynamic-header-border-bottom);display:flex;justify-content:space-between;padding:var(--dynamic-header-padding);position:relative}.collect-user-data-login-no-wallet::-webkit-scrollbar,.collect-user-data-login-no-wallet::-webkit-scrollbar-thumb,.collect-user-data-login-no-wallet::-webkit-scrollbar-track{display:none}.collect-user-data-login-no-wallet__main-img{width:100%}.collect-user-data-login-no-wallet__user-info-container{align-items:center;border:var(--dynamic-header-border-bottom);display:flex;justify-content:center;padding:var(--dynamic-header-padding)}.collect-user-data-login-no-wallet__user-identification{margin-left:.5rem}.collect-user-data-login-no-wallet__icon-container{height:1.5rem;width:1.5rem}.collect-user-data-login-no-wallet__icon-container .user-profile-social-account__connected-avatar{margin-top:.125rem}.collect-user-data-login-no-wallet__form{padding:var(--dynamic-layout-content-padding)}.collect-user-data-login-no-wallet__success-icon{align-items:center;display:flex;justify-content:center}.collect-user-data-login-no-wallet__success-icon svg{height:4rem;width:4rem}.collect-user-data-login-no-wallet__welcome-container{margin:1rem 0;text-align:center}.collect-user-data-login-no-wallet__welcome-title{margin-bottom:.375rem}.collect-user-data-login-no-wallet__log-out{margin:.75rem auto 0}.email-verification__retry-container{margin:1rem auto 0}.email-verification__container{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:var(--dynamic-layout-content-padding)}.email-verification__container--error{padding:var(--dynamic-layout-content-error-padding)}.email-verification__icon-with-spinner{margin:0 auto .75rem}.email-verification__error-message{margin:0}.email-verification__error-message,.email-verification__transfer-message{align-items:center;border-radius:0;display:flex;justify-content:center;width:100%}.email-verification__transfer-message{background:var(--dynamic-success-2);color:var(--dynamic-success-1);margin-bottom:.5rem;padding:.5rem .75rem;text-align:center}.email-verification__icon--verified{margin:0 auto 1rem}.email-verification__title{margin-top:.5rem;text-align:center}.email-verification__retry-copy{margin-top:1rem}.email-verification__copy-text-container{margin:0;text-align:center}.email-verification__text-button{color:var(--dynamic-text-link)}.email-verification__text-button:disabled{color:var(--dynamic-text-tertiary);cursor:not-allowed}.email-verification__log-out{margin:.75rem auto 0}.no-qr-code-installed__container{align-items:center;color:var(--dynamic-text-primary);flex-direction:column;margin:-2.25rem 0 0;padding:var(--dynamic-modal-padding);padding-top:0;width:100%}.no-qr-code-installed__container:first-child,.no-qr-code-installed__container:last-child{margin-right:0}.no-qr-code-installed__img{display:flex;height:auto;justify-content:center;margin:auto;text-align:center}.no-qr-code-installed__typography{text-align:center}.no-qr-code-installed__typography--title{margin:1rem 0 .375rem;text-align:center}.no-qr-code-installed__links-section{flex-direction:column;margin:1rem 0}.wallet-help-link__anchor{align-items:center;background:var(--dynamic-base-2);border:.0625rem solid var(--dynamic-base-4);border-radius:calc(var(--dynamic-border-radius)/2);box-shadow:var(--dynamic-shadow-down-1);color:var(--dynamic-text-primary);display:flex;gap:.625rem;margin-bottom:.5rem;padding:.75rem;position:relative;width:100%}.pending-connect__container{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:var(--dynamic-layout-content-padding)}.pending-connect__copy-text{color:var(--dynamic-text-secondary);max-width:20rem;text-align:center}.pending-connect__icon-with-spinner{margin:0 auto .75rem}.pending-signature__container{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:var(--dynamic-layout-content-padding)}.pending-signature__container .pending-signature__icon-with-spinner{margin:0 auto .75rem}.pending-signature__container .pending-signature__copy{color:var(--dynamic-text-secondary);line-height:1.25rem;max-width:20rem;text-align:center}.pending-signature__container .pending-signature__copy--mini{line-height:1rem;margin-top:.25rem}.pending-signature__container .pending-signature__button{box-shadow:var(--dynamic-shadow-down-1);margin-top:.75rem}.social-wrong-account-view__container{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:0 var(--dynamic-modal-padding) 1.125rem}.social-wrong-account-view__container .social-wrong-account-view__title{color:var(--dynamic-text-primary);line-height:1.5rem}.social-wrong-account-view__container .social-wrong-account-view__copy{color:var(--dynamic-text-secondary);line-height:1.25rem;margin-top:.375rem;max-width:20rem;text-align:center}.social-wrong-account-view__container .social-wrong-account-view__button{box-shadow:var(--dynamic-shadow-down-1);margin-top:.75rem}.social-redirect-view__container{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:2rem var(--dynamic-modal-padding)}.social-redirect-view__container .social-redirect-view__title{color:var(--dynamic-text-primary);line-height:2.25rem}.sms-verification__text-button{color:var(--dynamic-text-link)}.sms-verification__text-button:disabled{color:var(--dynamic-text-tertiary);cursor:not-allowed}.sms-verification__log-out{margin:.75rem auto 0}.search-instead__container{font-size:.75rem;line-height:1rem;margin-top:2.5rem;padding-bottom:1rem;text-align:center;transition-duration:.3s;transition-property:background-color,border-color,color,fill,stroke;width:100%}.search-instead__container__image{display:flex;justify-content:center;margin:.5rem auto}.wallet-list-item__tile{border-radius:calc(var(--dynamic-border-radius)/2)}.wallet-list-grid-tabs{border-bottom:1px solid var(--dynamic-base-4);border-top:1px solid var(--dynamic-base-4);display:flex;width:100%}.wallet-list-grid-tabs__button{align-items:center;border-left:1px solid var(--dynamic-base-4);display:flex;flex-basis:50%;gap:.25rem;justify-content:center;outline:none;padding:.5rem .625rem}.wallet-list-grid-tabs__button:first-child{border-left:none}.wallet-list-grid-tabs__button--selected{background-color:var(--dynamic-wallet-list-tile-background)}.wallet-list-grid-tabs__button--text{flex-basis:100%}.wallet-list-grid-tabs__icon--selected{filter:grayscale(100%)}.wallet-list__error-container{margin:0}.wallet-list__search-container{padding:var(--dynamic-search-padding)}.wallet-list__tabs-container{margin-bottom:.5rem}.wallet-list__scroll-container{display:flex;flex-direction:column;gap:var(--dynamic-wallet-list-tile-gap);max-height:var(--dynamic-wallet-list-max-height);overflow:auto;padding:var(--dynamic-initial-view-content-padding)}.wallet-list__scroll-container--error{padding:var(--dynamic-layout-content-error-padding)}.wallet-list__scroll-container::-webkit-scrollbar,.wallet-list__scroll-container::-webkit-scrollbar-track{display:none}.wallet-list__scroll-container::-webkit-scrollbar-thumb{display:none}.wallet-list__scroll-container:empty{display:flex}.wallet-list__scroll-container--fixed-height{height:var(--dynamic-wallet-list-max-height)}.wallet-list__search-skeleton{height:2.625rem}.wallet-list__search-skeleton,.wallet-list__tile-skeleton{border-radius:calc(var(--dynamic-border-radius)/2);margin-bottom:.5rem}.wallet-list__tile-skeleton{height:3rem;padding:.75rem}.wallet-list__tiny-footer{background:var(--dynamic-base-1);border-top:.0625rem solid var(--dynamic-base-4);box-shadow:var(--dynamic-shadow-up-1);height:var(--dynamic-border-radius);opacity:1;text-align:center;transition:opacity .15s,visibility .15s;visibility:visible}.wallet-list__tiny-footer--hidden{opacity:0;transition:opacity .15s,visibility .15s;visibility:hidden}.wallet-no-access__container{background:var(--dynamic-base-1)}.wallet-no-access__main{padding:var(--dynamic-modal-padding)}.wallet-no-access__social-info-container{align-items:center;display:flex;justify-content:center;margin-top:1.5rem}.wallet-no-access__waitlist-link{align-items:center;display:flex;gap:8px;justify-content:center}.wallet-no-access__social-icon{margin:auto}.wallet-no-access__image{width:100%}.wallet-no-access__user-info-container{align-items:center;display:flex;flex-direction:column;margin-bottom:1rem}.wallet-no-access__content{text-align:center}.wallet-no-access__content--primary{margin-bottom:.375rem}.wallet-no-access__content--secondary{margin-bottom:1rem}.wallet-no-access__wallet-address{margin-left:.375rem}.wallet-no-access__wallet-address-container{align-items:center;display:flex;justify-content:center}.wallet-no-access__button--primary{background:var(--dynamic-base-2);border:1px solid var(--dynamic-base-4);box-shadow:var(--dynamic-shadow-down-1);margin:0}.wallet-no-access__icon--verified{margin:0 auto 1rem}.wallet-sign-spinner__container{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:var(--dynamic-layout-content-padding)}.wallet-sign-spinner__copy{color:var(--dynamic-text-secondary);margin:0;text-align:center}.wallet-sign-spinner__button{box-shadow:var(--dynamic-shadow-down-1);margin:.75rem 0 0}.wallet-used-view__container{display:flex;flex-direction:column;padding:var(--dynamic-layout-content-padding);text-align:center}.wallet-used-view__icon{display:flex;justify-content:center;margin:0 0 .5rem}.wallet-used-view__icon svg{margin:0 auto}.wallet-used-view__shorten-wallet-address{margin:0 0 1rem}.wallet-used-view__copy{margin:0 0 .75rem}.wallet-used-view__accept-button,.wallet-used-view__footer{margin:0 0 .5rem}.wallet-used-view__logout{background:none;border:none;box-shadow:none;margin:auto}.wallet-used-view__checkbox-label{align-items:center;background-color:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)/2);cursor:pointer;display:flex;gap:.5rem;justify-content:center;margin:1rem auto .5rem;padding:.75rem;text-align:left}.wallet-used-view__checkbox-container{flex-shrink:0}.network-not-supported__content-container{padding:var(--dynamic-layout-content-padding)}.network-not-supported__content-container--error{padding:var(--dynamic-layout-content-error-padding)}.network-not-supported__main-img{width:100%}.network-not-supported__img-container{align-items:center;display:flex;justify-content:center}.network-not-supported__img{border-radius:100%;height:4rem;width:4rem}.network-not-supported__welcome-container{margin:1rem 0;text-align:center}.network-not-supported__welcome-title{margin-bottom:.375rem}.network-not-supported__continue{margin-top:1rem}.network-not-supported__log-out{margin:.75rem auto 0}.network-not-supported__error--not-supported{align-items:center;border-radius:0;display:flex;justify-content:center;margin:0;width:100%}.network-not-supported__network-container{margin-top:.5rem;position:relative}.network-not-supported__network-picker{margin:auto;max-width:-moz-fit-content;max-width:fit-content}.network-not-supported__network-picker-button{position:static;transform:translateX(0)}.email-confirmation-waiting-view{align-items:center;display:flex;flex-direction:column;padding-bottom:1.625rem;text-align:center}.email-confirmation-waiting-view__title{padding-bottom:.375rem}.email-confirmation-waiting-view__email-container{align-items:center;display:flex;gap:.25rem;justify-content:center}.email-confirmation-waiting-view__edit-icon-button{display:inline-flex}.email-confirmation-waiting-view__header-icon{display:flex;justify-content:center;margin-top:-2rem}.email-confirmation-waiting-view__note{max-width:16.25rem;padding-top:1rem;text-align:center}.email-confirmation-waiting-view__powered_by_dynamic_footer{padding-top:1rem;width:100%}.login-with-email-form{display:flex;flex-direction:column;gap:.375rem}.login-with-email-form .input__suffix{top:.6875rem}.login-with-email-form .input__suffix .icon-button{--icon-arrow:var(--dynamic-text-tertiary);--icon-background:var(--dynamic-base-3);transition:all .2s}.login-with-email-form .input__suffix .icon-button path,.login-with-email-form .input__suffix .icon-button rect{transition:all .2s}.login-with-email-form .input__suffix .icon-button--active,.login-with-email-form .input__suffix .icon-button:hover{--icon-arrow:var(--dynamic-text-secondary);--icon-background:var(--dynamic-hover)}.login-with-email-form .input__suffix .icon-button--has-content,.login-with-email-form .input__suffix .icon-button--has-content:hover{--icon-arrow:var(--dynamic-base-2);--icon-background:var(--dynamic-brand-primary-color)}.list-item-button{background:none;box-shadow:none}.list-item-button__trailing{position:relative}.list-item-button__trailing-child{position:absolute;right:0;transition-property:opacity,transform;transition-timing-function:ease-in}.list-item-button__trailing-label{transform:translateY(-50%);transition-duration:.2s}.list-item-button__trailing-icon{transition-duration:.3s}.list-item-button:hover .list-item-button__trailing-label,.list-item-button__trailing-icon{opacity:0;transform:translate(-.625rem,-50%)}.list-item-button:hover .list-item-button__trailing-icon{opacity:1;transform:translateY(-50%)}.login-with-email-wallet-list__skeleton{border-radius:calc(var(--dynamic-border-radius)/2);height:2.625rem;margin-bottom:.5rem}.login-with-email-wallet-list__container{display:flex;flex-direction:column;gap:.375rem}.connect-with-wallet-button{height:2.5rem}.toggleable-section{align-items:stretch;display:flex;flex-direction:column;gap:.75rem}.toggleable-section__toggle-prompt{align-items:center;display:flex;justify-content:space-between}.toggleable-section__toggle-prompt__button{cursor:pointer;margin:-.75rem 0 0 -.75rem;outline:none;padding:.75rem 0 0 .75rem}.toggleable-section__toggle-prompt__button__text{outline:none;transition:all .2s}.toggleable-section__toggle-prompt__button:focus .toggleable-section__toggle-prompt__button__text,.toggleable-section__toggle-prompt__button:focus-visible .toggleable-section__toggle-prompt__button__text,.toggleable-section__toggle-prompt__button:hover .toggleable-section__toggle-prompt__button__text{background-color:var(--dynamic-brand-secondary-color)}.login-with-phone-number-form{display:flex;flex-direction:column;gap:.375rem}.login-with-phone-number-form__fields{align-items:stretch;display:flex;position:relative;width:100%}.login-with-phone-number-form__fields__country-code{align-items:center;background-color:var(--dynamic-base-2);border:.0625rem solid var(--dynamic-base-3);border-radius:calc(var(--dynamic-border-radius)*.4) 0 0 calc(var(--dynamic-border-radius)*.4);border-right:none;cursor:pointer;display:flex;padding-left:.75rem;position:relative;transition:all .2s ease;width:6.25rem}.login-with-phone-number-form__fields__country-code--disabled{background-color:var(--dynamic-base-3);pointer-events:none}.login-with-phone-number-form__fields__country-code__flag{margin-right:.5rem}.login-with-phone-number-form__fields__country-code__plus{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}.login-with-phone-number-form__fields__country-code__container{align-items:center;display:flex;flex:1;pointer-events:none}.login-with-phone-number-form__fields__country-code__container .login-with-phone-number-form__fields__country-code__container__input{border:none;flex:1;padding:0;width:100%}.login-with-phone-number-form__fields__country-code__chevron{cursor:pointer;position:absolute;right:.5rem;width:1rem}.login-with-phone-number-form__fields__phone-number{align-items:center;display:flex;flex:1;position:relative}.login-with-phone-number-form__fields__phone-number .login-with-phone-number-form__fields__phone-number__input{border-radius:0 calc(var(--dynamic-border-radius)*.4) calc(var(--dynamic-border-radius)*.4) 0;padding-left:.75rem}.login-with-phone-number-form__fields__placeholder{align-self:center;color:var(--dynamic-text-secondary);left:7.0625rem;pointer-events:none;position:absolute;-webkit-user-select:none;-moz-user-select:none;user-select:none}.login-with-phone-number-form__fields__inline-submit{align-self:center;position:absolute;right:.75rem}.login-with-phone-number-form__dropdown{width:calc(var(--dynamic-modal-width) - 3rem)}.login-with-phone-number-form__dropdown__items{display:flex;flex-direction:column}.login-with-phone-number-form__dropdown__items__country{align-items:center;cursor:pointer;display:flex;gap:.375rem;padding:.375rem .75rem}.login-with-phone-number-form__dropdown__items__country__flag{width:1.5rem}.login-with-phone-number-form__dropdown__items__country__name{font-size:var(--dynamic-text-size-body-small)}.login-with-phone-number-form__dropdown__items__country__code{color:var(--dynamic-text-secondary);font-size:var(--dynamic-text-size-body-small)}.login-with-phone-number-form__dropdown__items__country:hover{background-color:var(--dynamic-base-4)}.login-with-phone-number-form__dropdown__items__country--selected{background-color:var(--dynamic-base-3)}.login-with-phone-number-form__error-message{color:var(--dynamic-error-1);padding:.5rem 0}.login-with-phone-number-form input::-webkit-inner-spin-button,.login-with-phone-number-form input::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none;margin:0}.login-with-phone-number-form input[type=number]{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}.login-view__text{padding:.5rem 0}.login-view__error-container{margin:0}.login-view__container{padding:var(--dynamic-initial-view-content-padding)}.login-view__container--error{padding:var(--dynamic-layout-content-error-padding)}@media (pointer:coarse){.login-view__container{padding:.75rem}}.login-view__scroll{align-items:stretch;gap:.375rem;height:100%;max-height:36.25rem;overflow:auto}.login-view__scroll,.login-view__scroll__section{display:flex;flex-direction:column}.login-view__scroll__section--emailAndPhone+.login-view__scroll__section--social{margin-top:1rem}.login-view__scroll::-webkit-scrollbar,.login-view__scroll::-webkit-scrollbar-track{display:none}.login-view__scroll::-webkit-scrollbar-thumb{display:none}.login-view__scroll:empty{display:flex}.login-view__scroll--full-height{height:100vh}.login-view__scroll--email-first{flex-direction:column-reverse}.login-view__scroll__web2{display:flex;flex-direction:column;gap:.75rem}.mobile-wallet-redirect{align-items:stretch;display:flex;flex-direction:column;gap:1.5rem;justify-content:center;padding:var(--dynamic-layout-content-padding)}.mobile-wallet-redirect__icon-with-spinner{align-self:center}.mobile-wallet-redirect__copy-text{align-self:center;max-width:20rem;text-align:center}.mobile-wallet-redirect__alert{text-align:center}.mobile-wallet-redirect__wallet-app{align-items:center;background-color:var(--dynamic-base-2);border-radius:.75rem;box-shadow:0 1px 2px 0 rgba(24,39,75,.04);display:flex;flex-wrap:wrap;gap:.875rem;justify-content:space-between;padding:.625rem .75rem}.mobile-wallet-redirect__wallet-app__group{align-items:center;display:flex;gap:.5rem}.mobile-wallet-redirect__wallet-app__group__app-store{text-align:right}.captcha-verify-user__container{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:0 1.5rem 1.5rem;text-align:center}.captcha-verify-user__icon{height:4rem;margin-bottom:1rem;width:4rem}.captcha-verify-user__title{margin-bottom:.375rem}.captcha-verify-user__subtitle{margin-bottom:1rem}.captcha-verify-user__dynamic-logo{margin-top:1rem}.network-not-supported-switch-manual{margin-top:-1.5rem;padding:0 1.5rem 1.5rem}.network-not-supported-switch-manual__img-container{align-items:center;display:flex;justify-content:center;margin-bottom:1rem}.network-not-supported-switch-manual__img{border-radius:100%;height:4rem;width:4rem}.network-not-supported-switch-manual__network-container{position:relative}.network-not-supported-switch-manual__content{text-align:center}.network-not-supported-switch-manual__title{margin:0 0 .375rem}.wallet-group__list{display:flex;flex-direction:column}.wallet-locked-view__error-container{align-items:center;display:flex;justify-content:center}.wallet-locked-view__button-header{margin:.75rem}.wallet-locked-view__button{margin:.75rem auto auto}.wallet-locked-view__icon{margin:auto}.wallet-locked-view__content{padding:0 var(--dynamic-modal-padding) 2.1875rem;text-align:center}@media (pointer:coarse){.wallet-locked-view__content{padding:0 .75rem}}.wallet-locked-view__title{margin-top:.75rem}.wallet-locked-view__log-out{margin:.75rem auto 0}.merge-user-accounts__error{margin-bottom:.75rem;padding:.75rem 1.5rem}.merge-user-accounts__container{display:flex;flex-direction:column;gap:1.5rem;padding:0 1.5rem 1.5rem}@media (pointer:coarse){.merge-user-accounts__container{padding:0 .75rem}}.merge-user-accounts-conflicts__error{margin-bottom:.75rem;padding:.75rem 1.5rem}.merge-user-accounts-conflicts__container{display:flex;flex-direction:column}@media (pointer:coarse){.merge-user-accounts-conflicts__container{padding:0 .75rem}}.merge-user-accounts-conflicts__description{padding:0 1.5rem .75rem}.merge-user-accounts-conflicts__fields{display:flex;flex-direction:column;gap:1rem;max-height:22.5rem;overflow-y:auto;padding:.75rem 1.5rem}.merge-user-accounts-conflicts__fields__item{display:flex;flex-direction:column;gap:.5rem}.merge-user-accounts-conflicts__fields__item__button{padding:.5rem .75rem}.merge-user-accounts-conflicts__buttons{background:var(--dynamic-base-1);box-shadow:0 -8px 48px -8px rgba(109,121,165,.16);display:flex;flex-direction:column;gap:.5rem;padding:.75rem 1.5rem}.merge-user-accounts-with-same-email__container{padding:0 1.5rem 1.5rem}@media (pointer:coarse){.merge-user-accounts-with-same-email__container{padding:0 .75rem}}.merge-user-accounts-with-same-email__accounts{align-items:center;display:flex;justify-content:space-between;margin:-1.5rem auto 1.5rem;max-width:270px;width:100%}.merge-user-accounts-with-same-email__accounts__item{align-items:center;display:flex;flex-direction:column;gap:.625rem;justify-content:center;width:100%}.merge-user-accounts-with-same-email__accounts__item__icon{height:3.5rem;width:3.5rem}.merge-user-accounts-with-same-email__accounts__divider{height:16px;margin-top:-1.5rem;width:16px}.merge-user-accounts-with-same-email__accounts__divider__icon>path{fill:var(--dynamic-text-secondary)}.merge-user-accounts-with-same-email__text{text-align:center}.merge-user-accounts-with-same-email__text__header{color:var(--dynamic-text-primary);margin-bottom:.5rem}.merge-user-accounts-with-same-email__text__body{color:var(--dynamic-text-secondary);margin-bottom:1rem}.merge-user-accounts-with-same-email__text--bold{font-weight:700}.merge-user-accounts-with-same-email__buttons{display:flex;flex-direction:column;gap:.5rem}.merge-user-accounts-with-same-email__buttons__button{width:100%}.wallet-cannot-be-transferred-view__container{padding:var(--dynamic-modal-padding);text-align:center}.wallet-cannot-be-transferred-view__icon{display:flex;justify-content:center;margin:0 0 .5rem}.wallet-cannot-be-transferred-view__icon svg{margin:0 auto}.wallet-cannot-be-transferred-view__shorten-wallet-address{margin:0 0 1rem}.wallet-cannot-be-transferred-view__title{margin:0 0 .375rem}.wallet-cannot-be-transferred-view__copy{margin:0 0 .75rem}.wallet-cannot-be-transferred-view__transfer-alt-wallet-button{margin:0 0 1rem}.wallet-cannot-be-transferred-view__footer{margin:0 0 .5rem}.wallet-cannot-be-transferred-view__cancel{background:none;border:none;box-shadow:none;margin:auto}.user-field-editor__header{align-items:center;display:flex;flex-direction:column;gap:1.25rem;text-align:center}.user-field-editor__header__icon{align-items:center;background-color:var(--dynamic-base-2);border-radius:50%;display:flex;height:4rem;justify-content:center;width:4rem}.user-field-editor__body{align-items:center;display:flex;flex-direction:column;gap:.5rem;margin:0 1.5rem 1.5rem;text-align:center}.user-field-editor__body__subtitle{margin-block:-.375rem .5rem}.user-field-editor__body__form{width:100%}.passkey-intro-view{align-items:center;display:flex;flex-direction:column;gap:1rem;padding-bottom:1.5rem;padding-left:1.5rem;padding-right:1.5rem;text-align:center}.passkey-intro-view__header{display:flex;width:100%}.passkey-intro-view__actions{display:flex;flex-direction:column;gap:.625rem;width:100%}.passkey-intro-view__inline-button{align-items:center;display:inline-flex;gap:.5rem;text-align:left}.passkey-intro-view__inline-button svg path{fill:var(--dynamic-base-2)!important}.passkey-intro-view__log-out{font-size:.875rem;justify-content:center;line-height:20px}.passkey-intro-view__log-out:hover{background-color:transparent}.passkey-intro-view__skip{color:var(--dynamic-text-secondary);font-size:.875rem;justify-content:center;line-height:1rem}.passkey-intro-view__skip:hover{background-color:transparent}.passkey-recovery-view{align-items:center;display:flex;flex-direction:column;gap:1rem;padding-bottom:1.5rem;padding-left:1.5rem;padding-right:1.5rem;text-align:center}.passkey-recovery-view__header{align-items:center;display:flex;justify-content:center;margin-bottom:-5rem;width:12.875rem}.passkey-recovery-view__actions{display:flex;flex-direction:column;gap:.625rem;width:100%}.passkey-recovery-view__input-valid{background:var(--dynamic-success-2)!important;border-color:var(--dynamic-success-1)!important}.passkey-recovery-view__input-valid,.passkey-recovery-view__input-valid~.input__label{color:var(--dynamic-success-1)!important}.passkey-recovery-view__form{display:flex;flex-direction:column;width:100%}.passkey-recovery-view__skip{justify-content:center;margin-top:1.5rem}.passkey-recovery-view__inline-button{align-items:center;display:inline-flex;gap:.5rem;text-align:left}.passkey-recovery-view__inline-button svg path{fill:var(--dynamic-base-2)!important}.passkey-recovery-view__resend-code{align-items:center;display:flex;flex-direction:column}.passkey-recovery-view button.text-button:not(.passkey-recovery-view__skip){color:inherit}.edit-passkeys-widget-view,.edit-passkeys-widget-view__body{display:flex;flex-direction:column}.edit-passkeys-widget-view__body{flex:1;gap:.25rem;justify-content:space-between;margin-top:20px;padding:0 1.5rem 1.5rem}.edit-passkeys-widget-view__icon{height:100px;margin-left:auto;margin-right:auto;margin-top:-40px;width:100px}.edit-passkeys-widget-view__title{margin-left:auto;margin-right:auto;margin-top:20px}.passkey-new-domain-detected{align-items:center;display:flex;flex-direction:column;gap:1rem;padding-bottom:1.5rem;padding-left:1.5rem;padding-right:1.5rem;text-align:center}.passkey-new-domain-detected__header{align-items:center;display:flex;justify-content:center}.passkey-new-domain-detected__actions{display:flex;flex-direction:column;gap:.625rem;width:100%}.passkey-new-domain-detected__inline-button{align-items:center;display:inline-flex;gap:.5rem;text-align:left}.passkey-new-domain-detected__inline-button svg path{fill:var(--dynamic-base-2)!important}.passkey-new-domain-detected__log-out{font-size:.875rem;justify-content:center;line-height:20px}.passkey-new-domain-detected__log-out:hover{background-color:transparent}.embedded-delete-view{display:flex;flex-direction:column;gap:.5rem;height:100%;overflow:auto}.embedded-delete-view__header{align-items:center;display:flex;justify-content:center}.embedded-delete-view__body{display:flex;flex:1;flex-direction:column;gap:.75rem;justify-content:space-between;padding:.75rem}.embedded-delete-view__body__description{display:flex;justify-content:center;text-align:center}.embedded-delete-view__body__badge{font-size:.75rem}.embedded-delete-view__body__card{background:var(--dynamic-base-2);border:1px solid var(--dynamic-base-4);border-radius:.75rem;box-shadow:0 1px 2px 0 rgba(24,39,75,.04);display:flex;flex:1;flex-direction:column;margin-left:1.5rem;margin-right:1.5rem;max-height:21.875rem;overflow:auto;padding:.75rem}.embedded-delete-view__body__card__statement{display:flex;gap:.5rem;letter-spacing:-.15px}.embedded-delete-view__body__card__acknowledgement{display:flex;gap:.5rem;text-align:left}.embedded-delete-view__body__card__icon{color:var(--dynamic-text-tertiary);height:1.5rem;min-width:1.5rem;width:1.5rem}.embedded-delete-view__body__card__skeleton{border-radius:.75rem;height:3.75rem}.embedded-delete-view__body__confirm_card{background:var(--dynamic-base-2);border:1px solid var(--dynamic-base-4);border-radius:.75rem;box-shadow:0 1px 2px 0 rgba(24,39,75,.04);display:flex;flex:1;flex-direction:column;gap:.75rem;letter-spacing:-.15px;margin-bottom:.75rem;margin-left:1.5rem;margin-right:1.5rem;max-height:21.875rem;overflow:auto;padding:.625rem}.embedded-delete-view__body__button{height:3rem;width:9.4375rem}.embedded-delete-view__body__cta_button_wrapper{display:flex;flex-direction:row;justify-content:space-between;margin-bottom:1.5rem;margin-left:1.5rem;margin-right:1.5rem}.embedded-reveal-view{display:flex;flex-direction:column;gap:var(--dynamic-wallet-list-tile-gap);height:100%;overflow:auto}.embedded-reveal-view__header,.embedded-reveal-view__header__hero{align-items:center;display:flex;justify-content:center}.embedded-reveal-view__header__hero{width:13.75rem}.embedded-reveal-view__zerodev-warning{background-color:var(--dynamic-error-1);border-radius:.5rem;margin-bottom:1rem;padding:1.25rem}.embedded-reveal-view__zerodev-warning__title-row{align-items:center;display:flex;margin-bottom:.5rem}.embedded-reveal-view__zerodev-warning__icon{flex-shrink:0;height:1.25rem;margin-right:.5rem;width:1.25rem}.embedded-reveal-view__zerodev-warning__link-button{background:none;border:none;cursor:pointer;display:inline;font:inherit;margin-left:.25rem;padding:0}.embedded-reveal-view__zerodev-warning .typography{color:inherit}.embedded-reveal-view__zerodev-warning .typography.underline{text-decoration:underline}.embedded-reveal-view__coinbase{background:var(--dynamic-base-2);border:1px solid var(--dynamic-base-4);border-radius:.75rem;box-shadow:0 1px 2px 0 rgba(24,39,75,.04);color:var(--dynamic-text-secondary);display:flex;flex:1;flex-direction:column;gap:.625rem;max-height:21.875rem;overflow:auto;overflow-wrap:break-word;padding:.75rem}.embedded-reveal-view__body{display:flex;flex:1;flex-direction:column;gap:.75rem;justify-content:space-between;padding:0 1.5rem 1.5rem}.embedded-reveal-view__body__description{display:flex;flex-direction:column;gap:1rem;justify-content:center;text-align:center}.embedded-reveal-view__body__badge,.embedded-reveal-view__body__badge-container{display:flex;justify-content:center}.embedded-reveal-view__body__badge{font-size:.75rem}.embedded-reveal-view__body__card{background:var(--dynamic-base-2);border:1px solid var(--dynamic-base-4);border-radius:.75rem;box-shadow:0 1px 2px 0 rgba(24,39,75,.04);display:flex;flex:1;flex-direction:column;gap:.625rem;max-height:21.875rem;overflow:auto;padding:.75rem}.embedded-reveal-view__body__card__statement{display:flex;gap:.5rem;letter-spacing:-.15px}.embedded-reveal-view__body__card__statement__text{display:flex;gap:.25rem}.embedded-reveal-view__body__card__acknowledgement{display:flex;gap:.5rem;text-align:left}.embedded-reveal-view__body__card__icon{color:var(--dynamic-text-tertiary);height:1rem;min-width:1rem;width:1rem}.embedded-reveal-view__body__card__skeleton{border-radius:.75rem;height:3.75rem}.embedded-reveal-view__body__confirm_card{background:var(--dynamic-base-2);border:1px solid var(--dynamic-base-4);border-radius:.75rem;box-shadow:0 1px 2px 0 rgba(24,39,75,.04);display:flex;flex:1;flex-direction:column;gap:.75rem;letter-spacing:-.15px;max-height:21.875rem;overflow:auto;padding:1rem}.embedded-reveal-view__body__button_section{display:flex;width:100%}.embedded-reveal-view__body__button{margin-right:.5rem}.embedded-reveal-view__body__unlink_button{text-decoration:underline}#dyn-turnkey-export-container-id{background:var(--dynamic-base-2);border:1px solid var(--dynamic-base-4);border-radius:.75rem;overflow:auto;padding:.75rem}#dyn-turnkey-export-element-id{word-wrap:break-word;max-height:-moz-min-content;max-height:min-content;width:100%}.embedded-auth-choice{align-items:center;display:flex;flex-direction:column;gap:1rem;padding-bottom:1.5rem;padding-left:1.5rem;padding-right:1.5rem;text-align:center}.embedded-auth-choice__header{align-items:center;display:flex;justify-content:center;width:100%}.embedded-auth-choice__support-links{display:flex;flex-direction:column;gap:.25rem;width:100%}.embedded-auth-choice__skip-button{margin-top:-.25rem}.action-card{background-color:var(--dynamic-base-2);border-radius:.75rem;box-shadow:var(--dynamic-shadow-down-1);display:flex;padding:1rem;text-align:left;transition:all .2s ease}.action-card:hover{box-shadow:var(--dynamic-button-shadow)}.action-card__icon{height:1.75rem;min-width:1.75rem;width:1.75rem}.action-card__icon,.action-card__icon path{fill:var(--dynamic-text-tertiary)}.action-card__action-icon{margin-left:auto;min-width:1rem;transform:rotate(180deg);width:1rem}.action-card__content{display:flex;flex-direction:column;gap:.25rem;margin-left:8px}.action-card__content__row{align-items:flex-start;display:flex;gap:.375rem}.action-card__content__row__badge--primary{background:var(--dynamic-brand-primary-color);color:var(--dynamic-base-2)}.embedded-auth-choice-cards{display:flex;flex-direction:column;gap:.625rem;width:100%}.auth-choice-info{align-items:flex-start;align-self:stretch;background:var(--default-base-2,#fff);border:1px solid var(--default-base-4,#e7e8ed);border-radius:12px;display:flex;flex-direction:column;gap:12px;justify-content:center;padding:16px 12px 12px}.auth-choice-info__container-item{display:flex;flex-direction:row;gap:.5rem;text-align:start}.select-hardware-wallet-view__container{align-items:stretch;display:flex;flex-direction:column;padding:var(--dynamic-layout-content-padding)}.select-hardware-wallet-view__icon{height:6rem;margin:0 auto .75rem;width:4rem}.select-hardware-wallet-view__text{padding-bottom:1rem;text-align:center}.wallet-redirect-view__container{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:var(--dynamic-modal-padding)}.wallet-redirect-view__container .wallet-redirect-view__title{color:var(--dynamic-text-primary);line-height:2.25rem}.wallet-redirect-view__container .powered-by-dynamic{margin-top:1.5rem}.mfa-choose-device-view__body{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:var(--dynamic-layout-content-padding)}.mfa-choose-device-view__copy{color:var(--dynamic-text-secondary);line-height:1.25rem;text-align:center;width:75%}.mfa-choose-device-view__button{box-shadow:var(--dynamic-shadow-down-1);display:flex;flex-direction:column;gap:.25rem;margin-top:.75rem;text-align:left}.mfa-choose-device-view__button__header{align-items:center;display:flex;justify-content:space-between;width:100%}.mfa-choose-device-view__button__description.mfa-choose-device-view__button__description{font-size:var(--dynamic-text-size-body-small)}.mfa-choose-device-view__icon--rotate{color:var(--dynamic-text-tertiary);height:1rem;justify-content:end;transform:rotate(180deg);width:1rem}.mfa-choose-device-view__logout{margin-top:1.125rem}.mfa-secure-device-view__body{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:var(--dynamic-layout-content-padding)}.mfa-secure-device-view__copy{color:var(--dynamic-text-secondary);line-height:1.25rem;text-align:center;width:75%}.mfa-secure-device-view__button,.mfa-secure-device-view__logout-button{box-shadow:var(--dynamic-shadow-down-1);margin-top:.75rem}.mfa-secure-device-view__loading-spinner{height:394px}.mfa-secure-device-view__qrcode{align-items:center;background-color:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)*.6);display:flex;flex-direction:column;gap:.625rem;margin:1rem 0;padding:.75rem}.mfa-secure-device-view__qrcode .button-container{display:flex;gap:.5rem;justify-content:center;width:100%}.mfa-secure-device-view__qrcode .button-container svg path{fill-opacity:100%}.mfa-secure-device-view__qrcode .button-container .qr-code-button{height:2.375rem}.mfa-display-backup-codes-view__body{align-items:center;display:flex;flex-direction:column;gap:1rem;justify-content:center;padding:var(--dynamic-layout-content-padding);text-align:center}.mfa-display-backup-codes-view__warning{border-radius:var(--dynamic-border-radius);padding:.25rem .5rem}.mfa-display-backup-codes-view__loading-spinner{height:19.5rem}.mfa-display-backup-codes-view__codes{display:flex;flex-wrap:wrap;gap:.5rem;justify-content:center}.mfa-display-backup-codes-view__code{background-color:var(--dynamic-wallet-list-tile-background);border:var(--dynamic-button-primary-border);border-radius:var(--dynamic-border-radius);color:var(--dynamic-text-secondary);padding:.75rem 1.125rem;text-align:center;width:8.75rem}.mfa-display-backup-codes-view__actions{display:flex;gap:.5rem;width:100%}.mfa-display-backup-codes-view__actions button{border-radius:calc(var(--dynamic-border-radius)/3)}.mfa-display-backup-codes-view__complete{display:flex;flex-direction:column;gap:.5rem;width:100%}.mfa-display-backup-codes-view__acknowledgement{border-radius:calc(var(--dynamic-border-radius)/3);justify-content:left}.mfa-display-backup-codes-view__acknowledgement .typography{font-size:var(--dynamic-text-size-button-secondary);font-weight:500}.mfa-recovery-view{align-items:center;display:flex;flex-direction:column;gap:1rem;padding-bottom:1.5rem;padding-left:1.5rem;padding-right:1.5rem;text-align:center}.mfa-recovery-view__body{padding:.3125rem,0}.mfa-recovery-view__actions{display:flex;flex-direction:column;gap:.625rem;width:100%}.mfa-recovery-view__get-help{padding:.3125rem,0}.mfa-verification-view__choose-another-method{display:flex;justify-content:center;margin-bottom:1.5rem;width:100%}.mfa-verification-view__choose-another-method-button{color:var(--dynamic-text-link)}.access-blocked__container{align-items:center;background:var(--dynamic-base-1);display:flex;flex-direction:column;padding:.3125rem}.access-blocked__icon{margin-bottom:.3125rem}.access-blocked__content{margin:.9375rem 0;padding:0 .625rem .625rem;text-align:center}.switch-wallet{white-space:pre-line}.switch-wallet__body{background:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)/2);margin-top:.625rem;padding:1rem 0;width:100%}.switch-wallet__body__divider{gap:0;padding:.75rem 0}.switch-wallet__body__divider svg{transform:rotate(90deg)}.switch-wallet__body__expected-address__prompt{margin-bottom:.5rem;margin-top:1rem}.switch-wallet__body__expected-address__address{font-size:1.5rem;line-height:1.25rem}.sync-wallet-view .qr-code-wrapper{padding-top:.5rem}.sync-wallet-view .prompt-modal-portal,.sync-wallet-view .prompt-modal-portal__container{position:relative}.mfa-qrcode-help-content__container{color:var(--dynamic-text-secondary);padding:1.5rem}.mfa-qrcode-help-content__vertical-container{background-color:#fff;border-radius:calc(var(--dynamic-border-radius)/2);display:flex;flex-direction:column}.mfa-qrcode-help-content__setup-container{font-family:Arial,sans-serif;margin:0 auto;max-width:400px;width:100%}.mfa-qrcode-help-content__step{align-items:center;background-color:#fff;border-radius:calc(var(--dynamic-border-radius)/2);color:gray;display:flex;flex-direction:row;height:100%;justify-content:flex-start;margin-bottom:.625rem;max-width:100%;padding:1rem}.mfa-qrcode-help-content__step__title{margin-bottom:.3125rem}.mfa-qrcode-help-content__step__number{align-items:center;align-self:flex-start;background-color:#e3ebff;border-radius:50%;color:#4779ff;display:flex;height:1.5rem;justify-content:center;margin-right:.625rem;min-width:1.5rem;width:1.5rem}.mfa-qrcode-help-content__step__nocopy-box{align-items:center;border:.0625rem solid #e0e0e0;border-radius:.3125rem;display:flex;justify-content:space-between;padding:.625rem}.mfa-qrcode-help-content__step__nocopy-text{word-break:break-all}.mfa-qrcode-help-content__copy-button{background-color:transparent;border:none;cursor:pointer}.sandbox-threshold__main{align-items:center;background:var(--dynamic-base-1);display:flex;flex-direction:column;justify-content:center;padding:0 var(--dynamic-modal-padding) 1.125rem}.sandbox-threshold__title{color:var(--dynamic-text-primary);line-height:1.5rem;text-align:center}.sandbox-threshold__description{color:var(--dynamic-text-secondary);line-height:1.25rem;margin-bottom:1.5rem;margin-top:.75rem;text-align:center}.sandbox-threshold__button{box-shadow:var(--dynamic-shadow-down-1)}.global-wallet-confirm .popup-content .wallet-connection-view{align-items:center;display:flex;flex-direction:column;padding:24px}.global-wallet-confirm .popup-content .wallet-connection-view .dapp-icon{height:64px;margin-bottom:16px;width:64px}.global-wallet-confirm .popup-content .wallet-connection-view .connection-title{color:var(--dynamic-text-primary);margin-bottom:16px;text-align:center}.global-wallet-confirm .popup-content .wallet-connection-view .dapp-url{color:var(--dynamic-text-secondary);margin-bottom:24px;text-align:center}.global-wallet-confirm .popup-content .wallet-connection-view .button-group{display:flex;gap:16px;width:100%}.global-wallet-confirm .popup-content .wallet-connection-view .button-group button{cursor:pointer;flex:1}.global-wallet-confirm .popup-content .wallet-connection-view .button-group button.cancel-button{background-color:var(--dynamic-base-2)}.global-wallet-confirm .popup-content .wallet-connection-view .button-group button.connect-global-button{background-color:#3b82f6;color:#fff}.info-card .wrapper{background:var(--dynamic-base-2);border:1px solid var(--dynamic-border-2);border-radius:16px;display:flex;flex-direction:column;gap:.75rem;padding:1.5rem;text-align:left}.inline-icon-text{display:inline}.inline-icon-text svg{display:inline-block;height:1em;margin:0 .25em;vertical-align:middle;width:1em}.nowrap{align-items:center;display:inline-flex;white-space:nowrap}.learn-more-link{align-items:center;display:flex;justify-content:center;padding:4px;pointer-events:auto;text-decoration:none}.learn-more-link svg{cursor:pointer;height:.5rem;margin-left:.25rem;width:.5rem}.malicious-site-view .popup-content .wallet-connection-view{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:24px;text-align:center}.malicious-site-view .popup-content .wallet-connection-view .header{align-items:center;display:flex;justify-content:center;margin-bottom:16px;width:100%}.malicious-site-view .popup-content .wallet-connection-view .header .back-button{background:none;border:none;cursor:pointer;left:24px;padding:8px;position:absolute}.malicious-site-view .popup-content .wallet-connection-view .header h1{color:var(--dynamic-text-primary);margin:0}.malicious-site-view .popup-content .wallet-connection-view .warning-card{align-items:center;border-radius:8px;display:flex;flex-direction:column;justify-content:center;margin-bottom:16px;padding:16px;width:100%}.malicious-site-view .popup-content .wallet-connection-view .warning-card .warning-icon{height:48px;margin-bottom:8px;width:48px}.malicious-site-view .popup-content .wallet-connection-view .connection-title{margin-top:16px}.malicious-site-view .popup-content .wallet-connection-view .site-info{color:var(--dynamic-text-secondary);padding:16px}.malicious-site-view .popup-content .wallet-connection-view .subtitle-container{border-radius:12px;display:flex;flex-direction:column;margin-top:16px;padding:16px;position:relative}.malicious-site-view .popup-content .wallet-connection-view .subtitle-container.definitely-malicious{background-color:var(--dynamic-error-2)}.malicious-site-view .popup-content .wallet-connection-view .subtitle-container.unknown{background-color:#f4d09a}.malicious-site-view .popup-content .wallet-connection-view .subtitle-container .subtitle-header-container{align-items:flex-start;display:flex;margin-bottom:4px}.malicious-site-view .popup-content .wallet-connection-view .subtitle-container .subtitle-header-container .caution-icon{height:24px;left:16px;position:absolute;top:16px;width:24px}.malicious-site-view .popup-content .wallet-connection-view .subtitle-container .subtitle-header-container .subtitle-header{flex:1;margin-bottom:0;margin-left:32px;text-align:left}.malicious-site-view .popup-content .wallet-connection-view .subtitle-container .subtitle{margin-top:0;padding-left:32px;text-align:left}.malicious-site-view .popup-content .wallet-connection-view .button-group{display:flex;gap:16px;margin-top:16px;width:100%}.malicious-site-view .popup-content .wallet-connection-view .button-group button{cursor:pointer;flex:1}.malicious-site-view .popup-content .wallet-connection-view .button-group button.cancel-button{background-color:var(--dynamic-base-2)}.malicious-site-view .popup-content .wallet-connection-view .button-group button.proceed-button{background-color:inherit;box-shadow:none}.add-network-view{display:flex;flex-direction:column}.add-network-view__description,.add-network-view__title{text-align:center}.add-network-view__text-container{display:flex;flex-direction:column;gap:.25rem}.add-network-view__body{align-items:center;display:flex;flex-direction:column;gap:1rem;padding:var(--dynamic-layout-content-padding);text-align:center}.add-network-view__network-icon{height:4rem;width:4rem}.add-network-view__actions{display:flex;gap:.25rem;width:100%}.subdomain-field__container{align-items:flex-start;display:flex;flex-direction:row;gap:.25rem}.subdomain-field__container span{margin-top:.875rem}.subdomain-field__details{margin-top:.5rem}.wallet-already-exists-view__container{align-items:center;display:flex;flex-direction:column;padding-bottom:24px;padding-left:24px;padding-right:24px;text-align:center}.wallet-already-exists-view__icon{align-items:center;display:flex;height:64px;justify-content:center;margin-bottom:8px;width:64px}.wallet-already-exists-view__shorten-wallet-address{margin-bottom:8px}.wallet-already-exists-view__copy{max-width:320px}.sign-message-confirmation__actions{align-items:center;display:flex;flex-direction:row;gap:.375rem;padding-bottom:1rem;width:100%}.sign-message-confirmation__body{align-items:stretch;display:flex;flex-direction:column;padding:.5rem 1.5rem 1.5rem}.sign-message-confirmation__message-container{align-items:center;background-color:var(--dynamic-base-2);border:1px solid var(--dynamic-base-4);border-radius:.75rem;box-shadow:var(--dynamic-shadow-down-1);margin-bottom:.5rem;margin-top:.75rem;max-height:18.75rem;overflow-y:scroll;padding:.75rem;width:100%}.sign-message-confirmation__secure-wallet{margin-block:.5rem}.sign-message-confirmation__message{overflow-wrap:break-word;padding-top:.75rem}.sign-message-confirmation__title{text-align:center}.sign-message-confirmation__error{padding-top:.75rem}.bridge-welcome-layout{display:flex;flex-direction:column;gap:.75rem}.bridge-welcome-layout__body{display:flex;flex-direction:column;gap:1.5rem;padding:0 1.5rem 1.5rem}.bridge-welcome-layout__message-container{display:flex;flex-direction:column;gap:.25rem;text-align:center}.bridge-welcome-layout__chain-icon-group{align-items:center;display:flex;flex-direction:row-reverse;padding-top:.875rem}.bridge-welcome-layout__chain-icon{background-color:var(--dynamic-base-1);border-radius:50%;height:4rem;margin-left:-1.375rem;outline:.25rem solid var(--dynamic-base-1);overflow:hidden;width:4rem}.bridge-welcome-layout__chain-icon:last-child{margin-left:0}.select-wallet-list-layout{display:flex;flex-direction:column;min-height:320px}.select-wallet-list-layout__wallet-list{display:flex;flex-direction:column;flex-grow:1;gap:var(--dynamic-wallet-list-tile-gap);max-height:var(--dynamic-wallet-list-max-height);overflow-y:auto;padding:.25rem 1.5rem 1.5rem}.connected-wallets-list-layout{display:flex;flex-direction:column}.connected-wallets-list-layout__body{display:flex;flex-direction:column;gap:1rem;padding:.25rem 1.5rem 1.5rem}.connected-wallets-list-layout__body__text{text-align:center}.bridge-next-wallet-to-connect-layout__chain-icon{height:4rem;margin:1rem 1rem 0;width:4rem}.bridge-next-wallet-to-connect-layout__body{align-items:center;display:flex;flex-direction:column;gap:1.5rem;padding:1rem 1.5rem 1.5rem;text-align:center}.account-control__name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.account-control__icon{min-width:1rem}.account-control__social_icon{height:1rem;width:1rem}.account-control__container{align-items:center;border-radius:calc(var(--dynamic-border-radius)/3);color:var(--dynamic-text-primary);display:flex;gap:.375rem;min-height:100%;padding:.75rem;z-index:10}.account-control__container--multiwallet-disabled{border-bottom-left-radius:0;border-top-left-radius:0}.account-control__container--active,.account-control__container:hover{background-color:var(--dynamic-hover)}.dynamic-widget-inline-controls{background-color:var(--dynamic-base-1);border-radius:calc(var(--dynamic-border-radius)/3);display:flex;font-size:var(--dynamic-text-size-body-small);max-height:2.5rem;min-width:100%;position:relative}.dynamic-widget-inline-controls__network-picker-main{min-width:60px}.dynamic-widget-inline-controls__account-control{max-width:100%;min-width:max(100%,45px)}.dynamic-widget-inline-controls__account-control .account-control__icon{margin-left:auto}.dynamic-widget-inline-controls__account-control-container{min-width:60px;overflow:hidden}.dynamic-widget-inline-controls__network-picker{background:unset;border-bottom-left-radius:calc(var(--dynamic-border-radius)/3);border-bottom-right-radius:unset;border-top-left-radius:calc(var(--dynamic-border-radius)/3);border-top-right-radius:unset;min-width:100%;padding:.75rem;position:unset;transform:unset}.dynamic-widget-inline-controls__network-picker--active,.dynamic-widget-inline-controls__network-picker:hover{background:var(--dynamic-hover)}.dynamic-widget-inline-controls__network-picker-checkbox{margin:0 0 0 .5rem}.dynamic-widget-inline-controls__network-picker-list{top:2.5rem}@media (pointer:coarse){.dynamic-widget-inline-controls__network-picker-list{top:unset}}.dynamic-widget-dropdown{position:absolute;right:0;top:3.0625rem}.dynamic-widget-dropdown__root{min-width:22.5rem}.dynamic-widget-modal{left:50%;margin:0 auto;position:fixed;top:50%;transform:translate(-50%,-50%);width:min(100%,22.5rem)}@media (pointer:coarse){.dynamic-widget-modal{bottom:0;top:unset;transform:translate(-50%);width:100%}}.dynamic-widget-card{background-color:var(--dynamic-base-1);border:.0625rem solid var(--dynamic-base-4);border-radius:var(--dynamic-border-radius);box-shadow:var(--dynamic-shadow-down-3);height:100%;position:relative;transition:max-height .1s linear}@media (pointer:coarse){.dynamic-widget-card{border-bottom-left-radius:0;border-bottom-right-radius:0}}.dynamic-widget-header{padding:1.5rem 1.5rem 0;position:relative}.dynamic-widget-header__switcher{margin:0 0 1rem}.dynamic-widget-header__passkey-success{margin-inline:-1.5rem}.dynamic-widget-wallet-header{position:relative}.dynamic-widget-wallet-header__email{color:var(--dynamic-text-primary);margin:.5rem 0;text-align:center}.dynamic-widget-wallet-header__icon-container{height:4rem;margin:auto;position:relative;width:4rem}.dynamic-widget-wallet-header__icon-container img,.dynamic-widget-wallet-header__icon-container svg{height:100%;width:100%}.dynamic-widget-wallet-header__wallet-info{align-items:center;display:flex;flex-direction:column;justify-content:center;margin:0 0 1rem}.dynamic-widget-wallet-header__wallet-info .text-button{padding:0}.dynamic-widget-wallet-header__wallet-info__secure-wallet{margin-bottom:0;margin-top:1rem}.dynamic-widget-wallet-header__wallet-address{align-items:center;display:flex;justify-content:center}.dynamic-widget-wallet-header__balance{margin-bottom:.0625rem}.dynamic-widget-wallet-header__seperator{background-color:var(--dynamic-base-4);height:.5rem;margin:0 .5rem;width:.0625rem}.dynamic-widget-wallet-header__status-dot{margin-right:.375rem}.dynamic-widget-wallet-header__ens-name{max-width:12.5rem}.dynamic-widget-wallet-header__network-picker.evm-network-control__container{height:1.5rem}.dynamic-widget-wallet-header__network-picker.non-network-switching-supported-control{height:1.5rem;width:1.5rem}.dynamic-widget-wallet-header__network-picker.network-control-skeleton{bottom:0;height:1.5rem;position:absolute;right:0;width:1.5rem}.dynamic-widget-wallet-header__network-picker .evm-network-control__network-name,.dynamic-widget-wallet-header__network-picker .non-network-switching-supported-control__network-name{display:none}.dynamic-widget-wallet-header__wallet-avatar{border-radius:100%;overflow:hidden}.dynamic-widget-wallet-header__wallet-avatar img{height:4rem;width:4rem}.dynamic-widget-wallet-header__wallet-actions{align-items:center;display:flex;flex-wrap:wrap;gap:.5rem;justify-content:stretch;margin-top:.5rem;width:100%}.dynamic-widget-wallet-header__wallet-loading{margin-bottom:.5rem;margin-top:.5rem;width:100%}.empty-wallet__container{align-items:center;background:var(--dynamic-base-2);border:1px solid var(--dynamic-base-3);border-radius:calc(var(--dynamic-border-radius)/2);box-shadow:var(--dynamic-shadow-down-1);display:flex;flex-direction:column;gap:.75rem;justify-content:center;padding:.5rem;text-align:center;width:100%}.empty-wallet__container--big{margin:0 0 1rem;padding:.75rem}.empty-wallet__icon{height:1.5rem;width:1.5rem}.empty-wallet__icon--big{height:3rem;width:3rem}.empty-wallet__icon>path{fill:var(--dynamic-text-tertiary)}.empty-wallet__text-container{max-width:10rem}.wallet__container{background:var(--dynamic-base-2);border:1px solid var(--dynamic-base-3);border-radius:calc(var(--dynamic-border-radius)/2);display:flex;flex-direction:row;padding:.75rem}.wallet__container:not(:last-child){border-bottom-left-radius:0;border-bottom-right-radius:0;margin-bottom:-.75rem;padding-bottom:1.5rem}.wallet__container:hover .wallet__menu{opacity:1}.wallet__menu{color:var(--dynamic-text-tertiary)}.wallet__row{align-items:center;display:flex;flex:1}.wallet__row--clickable{cursor:pointer}.wallet__row__separator{background-color:var(--dynamic-base-4);height:.5rem;margin:0 .5rem;width:.0625rem}.wallet__row__menu__separator{height:auto}.wallet__icon-container{margin-right:.375rem}.wallet__ens-name{max-width:9.375rem}.wallet__actions{max-height:0;overflow:hidden;transition:max-height .3s ease-in-out}.wallet__actions__expanded{max-height:6.25rem}.wallet__actions__inner{padding-top:.75rem}.wallet-details-card__body{gap:.5rem}.wallet-details-card__text{word-wrap:break-word}.dynamic-widget-footer{border-bottom-left-radius:var(--dynamic-border-radius);border-bottom-right-radius:var(--dynamic-border-radius);border-top:.0625rem solid var(--dynamic-base-4);color:var(--dynamic-text-primary);display:flex;gap:.5rem;margin-top:auto;padding:1rem 1.5rem}.dynamic-widget-footer__button:hover:enabled svg{color:var(--dynamic-text-secondary)}.dynamic-widget-footer__button svg{color:var(--dynamic-text-tertiary)}.dynamic-widget-footer__button-align-right{margin-left:auto}@media (pointer:coarse){.dynamic-widget-footer{border-bottom-left-radius:unset;border-bottom-right-radius:unset}}.wallet-icon-with-network__container{position:relative}.wallet-icon-with-network__network-container{align-items:center;background-color:var(--dynamic-base-1);border-radius:100%;bottom:-.1875rem;display:flex;height:.75rem;justify-content:center;position:absolute;right:-.1875rem;width:.75rem}.dots-menu-dropdown__container{padding:.375rem 0}.dots-menu-dropdown__item{align-items:center;cursor:pointer;display:flex;font-size:var(--dynamic-text-size-body-small);gap:.5rem;padding:.5rem .75rem;width:100%}.dots-menu-dropdown__item .typography{white-space:nowrap}.dots-menu-dropdown__item__end-slot{position:absolute;right:.75rem}.dots-menu-dropdown__item:hover{background-color:var(--dynamic-hover)}.dots-menu-dropdown__item:hover .typography{color:var(--dynamic-text-primary)}@media (pointer:coarse){.dots-menu-dropdown__item{font-size:var(--dynamic-text-size-body-normal)}}.dots-menu-dropdown__item-text{align-items:center;display:flex;gap:.5rem}@keyframes desktop-dropdown-entering-animation{0%{opacity:0;transform:scale(.8) translateY(0)}70%{transform:scale(1) translateY(0)}to{opacity:1;transform:scale(1) translateY(0)}}@keyframes desktop-dropdown-exiting-animation{0%{opacity:1;transform:scale(1) translateY(0)}25%{opacity:1}50%{transform:scale(1.01) translateY(0)}to{opacity:0;transform:scale(1.02) translateY(1.875rem)}}@keyframes mobile-dropdown-entering-animation{0%{opacity:0;transform:translateY(100%)}to{opacity:1;transform:translateY(0)}}@keyframes mobile-dropdown-exiting-animation{0%{transform:translateY(0)}50%{transform:translateY(0)}to{transform:translateY(200%)}}.dots-menu-wrapper{position:relative}.dots-menu-wrapper__container--entering{animation-fill-mode:both;animation-iteration-count:1;animation-name:desktop-dropdown-entering-animation;animation-timing-function:ease-out}@media (pointer:coarse){.dots-menu-wrapper__container--entering{animation-fill-mode:both;animation-iteration-count:1;animation-name:mobile-dropdown-entering-animation;animation-timing-function:ease-out}}.dots-menu-wrapper__container--exiting{animation-fill-mode:both;animation-iteration-count:1;animation-name:desktop-dropdown-exiting-animation;animation-timing-function:ease-out}@media (pointer:coarse){.dots-menu-wrapper__container--exiting{animation-fill-mode:both;animation-iteration-count:1;animation-name:mobile-dropdown-exiting-animation;animation-timing-function:ease-out}}.dots-menu-wrapper__container{background-color:var(--dynamic-base-2);border:.0625rem solid var(--dynamic-base-4);border-radius:calc(var(--dynamic-border-radius)/3);box-shadow:0 .5rem .75rem -.375rem rgba(24,39,75,.06),0 .5rem .75rem -.1875rem rgba(24,39,75,.06);margin-top:.5rem;position:absolute;right:0;z-index:2147483647}.dots-menu-wrapper__container__alignment__top{bottom:1.375rem}.dots-menu-wrapper__container__alignment__bottom{top:1.375rem}@media (min-width:768px){.dots-menu-wrapper__container{min-width:9.375rem}}@media (pointer:coarse){.dots-menu-wrapper__container{border:none;border-radius:var(--dynamic-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0;bottom:0;left:calc(50% - 18.75rem);margin:auto;max-width:37.5rem;padding-bottom:2rem;padding-top:0;position:fixed;right:calc(50% - 18.75rem);top:unset;width:100%}}.dots-menu-wrapper__header{display:none;padding:.75rem 1.5rem .25rem}@media (pointer:coarse){.dots-menu-wrapper__header{align-items:center;display:flex;justify-content:space-between}}.dots-menu-wrapper__header__icon{min-height:1.5rem;min-width:1.5rem}.dots-menu-wrapper__backdrop{cursor:default;display:none;height:100%;left:0;position:fixed;top:0;width:100%;z-index:10}@media (pointer:coarse){.dots-menu-wrapper__backdrop{background-color:var(--dynamic-overlay);display:block}}.dynamic-widget-wallets-header{display:flex;flex-direction:row;justify-content:space-between;margin:0 1.5rem}.dynamic-widget-wallets-header__title{margin:0 0 .5rem}.dynamic-widget-wallets-header__add_wallet{display:flex;margin:0 0 .5rem}.dynamic-widget-wallets{margin:0 1.5rem;overflow:auto}.dynamic-widget-wallets__body{display:flex;flex-direction:column;gap:1rem}.dynamic-widget-wallets__body__wallet-list{max-height:13rem}.widget-portal{background-color:var(--dynamic-overlay);top:0;z-index:50}.widget-portal,.widget-portal__container{border-radius:calc(var(--dynamic-border-radius)/1.5);bottom:0;left:0;position:absolute;right:0}.widget-portal__container{background-color:var(--dynamic-base-1);border-top:.0625rem solid var(--dynamic-base-4);padding:1.5rem}@media (pointer:coarse){.widget-portal__container{border-bottom-left-radius:0;border-bottom-right-radius:0}}.widget-portal__container--no-padding{padding:0}.widget-portal__container__header{position:relative}.widget-portal__container__close-button{position:absolute;right:0}.single-wallet-buttons{display:flex;gap:.625rem;padding:0 1.5rem 1.5rem}.single-wallet-buttons--center{align-items:center;display:flex;justify-content:center}.single-wallet-buttons__copied{align-items:center;display:flex;gap:8px}.single-wallet-buttons__copied svg{color:var(--dynamic-success-1)}.email-connector-pending-sign-modal-content{align-items:center;display:flex;flex-direction:column;text-align:center;width:100%}.email-connector-pending-sign-modal-content__body{align-items:center;display:flex;flex-direction:column;gap:.5rem}.active-wallet-information{border-bottom:1px solid var(--dynamic-base-3);display:flex;flex-flow:column;gap:.5rem;padding:.75rem}.active-wallet-information__header{display:flex;gap:.5rem}.active-wallet-information__handle{max-width:80px;overflow:hidden;text-overflow:ellipsis}.active-wallet-information__handle--full-width{max-width:230px;overflow:hidden;text-overflow:ellipsis}.active-wallet-information__dots-menu{color:var(--dynamic-text-tertiary);margin-left:.375rem}.active-wallet-information__dots-menu .icon-with-status__container{margin-bottom:0}.active-wallet-information__dots-menu .icon-with-status__container .status-dot__container{right:-.05rem;top:-.05rem}.active-wallet-information-container{background:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)/2)}.active-wallet-information__details{display:flex;flex:1;gap:.5rem;justify-content:space-between;overflow:hidden}.active-wallet-information__avatar img{height:2rem;min-height:2rem;min-width:2rem;width:2rem}.active-wallet-information__avatar__name-service{align-items:center;border-radius:100%;display:flex;overflow:hidden}.active-wallet-information__addresses-container{display:flex;flex-direction:column;gap:.5rem}.active-wallet-information__addresses-container--centered{justify-content:center}.active-wallet-information__address-container{display:flex}.active-wallet-information__address{align-items:center;display:flex}.active-wallet-information__address-skeleton{width:60px}.active-wallet-information__network-picker{overflow:hidden}.active-wallet-information__network-picker-button{border:1px solid var(--dynamic-base-4);height:100%;position:relative;transform:translateX(0)}.active-wallet-information__network-picker-button:hover{background:var(--dynamic-hover)}.balance-header{justify-content:space-between;padding:1rem .75rem;width:100%}.balance-header,.balance-header__title{align-items:center;display:flex}.balance-header__chevron{rotate:180deg}.balance-header__skeleton{display:table-cell;width:2.5rem}.balance-container{align-items:center;display:flex;justify-content:space-between;padding:1rem .75rem;position:relative}.balance-container__skeleton{display:table-cell;width:2.5rem}.multi-asset-balance-container{align-items:center;position:relative}.multi-asset-balance-container .shadow{border-bottom:1px solid var(--dynamic-base-3)}.multi-asset-balance-container__accordion{overflow-y:auto}.multi-asset-balance-container__accordion--collapsed{max-height:0!important}.multi-asset-balance-container__accordion--expanded{height:100%!important;max-height:11.25rem!important}.prompt-modal{padding:1.5rem}.prompt-modal__header{position:relative;width:100%}.prompt-modal__close-button{position:absolute;right:1rem;top:1rem}.balance-skeleton{display:table-cell;width:1.875rem}.token-balance-item{justify-content:space-between;padding:8px 0;width:100%}.token-balance-item,.token-balance-item__name{align-items:center;display:flex}.token-balance-item__title{max-width:8.4375rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.token-balance-item__icon,.token-balance-item__skeleton-icon{border-radius:100%;height:20px;margin-right:6px;overflow:hidden;width:20px}.token-balance-item__skeleton-icon{background-color:var(--dynamic-base-3)}.token-balance-item__value,.token-balance-item__value__balance{display:flex}.token-balance-list{padding:0 .75rem .75rem}.token-balance-list__empty{align-items:center;display:flex;justify-content:center;padding:.625rem}.token-balance-list__divider{padding:0}.footer-options-switcher__container{background-color:var(--dynamic-base-2);border-bottom-left-radius:var(--dynamic-border-radius);border-bottom-right-radius:var(--dynamic-border-radius);display:flex;justify-content:space-around;margin-top:auto;padding:.75rem 0}.footer-options-switcher__label{font-size:12px;margin-top:.25rem}.footer-options-switcher__tab{align-items:center;color:var(--dynamic-text-secondary);cursor:pointer;display:flex;flex-direction:column;text-align:center}.footer-options-switcher__tab--active{color:var(--dynamic-text-primary)}.dynamic-widget-index-view__email-container{display:flex;flex-direction:column;gap:1rem;text-align:center}.dynamic-widget-index-view__footer{display:flex;justify-content:space-between;width:100%}.dynamic-widget-index-view__user-profile{margin:0 0 1rem;padding:0 1.5rem}.dynamic-widget-index-view__user-profile-title{border-bottom:.0625rem solid var(--dynamic-base-4);margin:0 1.5rem .75rem;padding-bottom:.375rem}.profile-view{flex:1;overflow:auto;padding:0 1.5rem 1.5rem}.profile-view__footer{display:flex;justify-content:space-between;width:100%}.dynamic-widget-edit-profile-view{display:flex;flex:1;flex-direction:column;overflow:hidden}.dynamic-widget-edit-profile-view__fields{flex:1;overflow:auto;padding:0 1.5rem 1rem}.dynamic-widget-edit-profile-view__profile-title{border-bottom:.0625rem solid var(--dynamic-base-4);margin:0 1.5rem .75rem;padding-bottom:.375rem}.send-balance-widget-view{display:flex;flex:1;flex-direction:column;max-width:22.5rem;overflow:auto}.send-balance-widget-view__spinner{align-items:center;display:flex;flex:1;justify-content:center}.passkey-card{background:var(--dynamic-base-2);border:1px solid var(--dynamic-base-4);border-radius:.75rem;box-shadow:0 1px 2px 0 rgba(24,39,75,.04);padding:.75rem;width:100%}.passkey-card__body{display:flex;flex-direction:row;justify-content:space-between}.passkey-card__left{align-items:center;display:flex;gap:.5rem}.passkey-card__info{align-items:center;border-bottom:1px solid var(--dynamic-base-4);gap:.5rem;padding-bottom:.5rem}.passkey-card__info__icon{justify-self:start;width:1.5rem}.passkey-card__info__tooltip{display:none}@media (hover:none),(pointer:coarse){.passkey-card__info__tooltip{background-color:#555;border:1px solid;border-radius:6px;color:#fff;display:block;font-size:12px;opacity:0;padding:3px;position:absolute;transition:opacity .5s;visibility:hidden;width:-moz-fit-content;width:fit-content}.passkey-card__info__tooltip--visible{opacity:1;transition:opacity .3s;visibility:visible}}.passkey-card__date{padding-top:.5rem}.manage-passkeys-widget-view,.manage-passkeys-widget-view__body{display:flex;flex:1;flex-direction:column}.manage-passkeys-widget-view__body{gap:1rem;justify-content:space-between;padding:0 1.5rem 1.5rem}.manage-passkeys-widget-view__body__cards{display:flex;flex:1;flex-direction:column;gap:.5rem;max-height:23.75rem;overflow:auto}.manage-passkeys-widget-view__body__cards__skeleton{border-radius:.75rem;height:3.75rem}.manage-passkeys-widget-view__reveal{display:flex;flex:1;flex-direction:column;gap:.5rem}.manage-passkeys-widget-view__reveal-helper-text{color:var(--dynamic-text-secondary);font-size:.9375rem;line-height:1.25rem}.manage-passkeys-widget-view__reveal-button{border-radius:calc(var(--dynamic-border-radius)/2);justify-content:space-between}.manage-passkeys-widget-view__reveal-button__start-slot{align-items:center;display:flex;font-size:.9375rem}.manage-passkeys-widget-view__reveal-button__icon{color:var(--dynamic-text-tertiary);height:1.75rem;margin-right:.5rem}.manage-passkeys-widget-view__reveal-button__icon--rotate{color:var(--dynamic-text-tertiary);height:1rem;justify-content:end;transform:rotate(180deg)}.empty-screen{align-items:center;display:none;flex:1;flex-direction:column;gap:2.25rem;justify-content:center}.empty-screen:only-child{display:flex}.settings-view{display:flex;flex:1;flex-direction:column;overflow:hidden;padding:1.5rem}.settings-view__logout-button-container{bottom:60px;color:var(--dynamic-text-secondary);width:100%}.settings-view__logout-button-container__button{width:100%}.settings-view__header{align-items:center;display:flex;gap:.5rem}.settings-view__body{display:flex;flex-direction:column;gap:1rem;height:100%;margin-bottom:1.5rem;overflow-y:auto}.settings-view__body__section{display:flex;flex-direction:column;gap:.75rem}.settings-view__body__section__title{color:var(--dynamic-text-secondary);font-size:.9375rem;line-height:1.25rem}.settings-view__body__section__title__info-icon{align-items:center;display:flex;gap:5px}.settings-view__body__section__title__info-icon svg path{fill:var(--dynamic-alert-1)}.settings-view__body__section__button{border-radius:calc(var(--dynamic-border-radius)/2);justify-content:space-between}.settings-view__body__section__button__start-slot{align-items:center;display:flex;font-size:.9375rem}.settings-view__body__section__button__badge .badge__container.badge__container__secondary{margin-left:.625rem}.settings-view__body__section__button__icon{color:var(--dynamic-text-tertiary);height:1.75rem!important;margin-right:.625rem;width:1.75rem!important}.settings-view__body__section__button__icon.email{color:transparent}.settings-view__body__section__button__icon__stroke{stroke:var(--dynamic-text-tertiary);height:1.75rem;margin-right:.625rem;width:1.75rem}.settings-view__body__section__button__icon-secondary{color:var(--dynamic-text-tertiary);height:1rem;justify-content:end;width:1rem}.settings-view__body__section__button__icon-secondary--success{color:var(--dynamic-success-1);height:1rem;justify-content:end;width:1rem}.settings-view__body__section__button__icon-secondary--rotate{color:var(--dynamic-text-tertiary);height:1rem;justify-content:end;transform:rotate(180deg);width:1rem}.manage-mfa-widget-view{display:flex;flex:1;flex-direction:column;overflow:hidden}.manage-mfa-widget-view__description-container{background:var(--dynamic-base-4)}.manage-mfa-widget-view__description-container__text{margin:.625rem}.manage-mfa-widget-view__add-mfa-button-container{bottom:60px;padding:.625rem 1.5rem 1.5rem;width:100%}.manage-mfa-widget-view__add-mfa-button-container__button{width:100%}.manage-mfa-widget-view__no-devices{align-items:center;display:flex;flex-direction:column;gap:1rem;height:100%;justify-content:center;padding:1rem}.manage-mfa-widget-view__scroll-container{flex:1;overflow-y:auto;padding:.625rem 1.5rem 1.5rem}.manage-mfa-widget-view__list-tile{align-items:center;background-color:var(--dynamic-wallet-list-tile-background);border:var(--dynamic-wallet-list-tile-border);border-radius:calc(var(--dynamic-border-radius)/2);box-shadow:var(--dynamic-wallet-list-tile-shadow);color:var(--dynamic-text-primary);display:flex;flex-direction:row;gap:.625rem;margin-bottom:.625rem;padding:.625rem;width:auto}.manage-mfa-widget-view__list-tile__icon{height:1.5rem;position:relative;width:1.5rem}.manage-mfa-widget-view__list-tile__details{display:flex;flex-direction:column;flex-grow:1;justify-content:space-between;padding-right:.625rem}.manage-mfa-widget-view__list-tile__details__title{display:flex;flex-direction:row;gap:.25rem}.manage-mfa-widget-view__list-tile__dots-menu{color:var(--dynamic-text-tertiary);margin-left:.375rem}.connect-dapps-view{max-width:400px;padding:1.5rem;position:relative}.connect-dapps-view .header{align-items:center;display:flex;justify-content:space-between;margin-bottom:1rem;position:relative}.connect-dapps-view .header h1{flex-grow:1;margin:0 auto;text-align:center}.connect-dapps-view .header button{background:none;border:none;cursor:pointer;padding:.5rem;position:absolute;top:50%;transform:translateY(-50%)}.connect-dapps-view .header button:first-child{left:0}.connect-dapps-view .header button:last-child{right:0}.connect-dapps-view .scanner-wrapper{aspect-ratio:1/1;height:200px;margin-left:-24px;margin-right:-24px;overflow:hidden;position:relative;width:calc(100% + 48px)}.connect-dapps-view .scanner-wrapper video{height:100%;-o-object-fit:cover;object-fit:cover;width:100%}.connect-dapps-view .scanner-overlay{align-items:center;bottom:0;display:flex;justify-content:center;left:0;pointer-events:none;position:absolute;right:0;top:0}.connect-dapps-view .scanner-frame{border-radius:12px;height:80%;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:60%}.connect-dapps-view .corner{border:4px solid #fff;height:16px;position:absolute;width:16px}.connect-dapps-view .top-left{border-bottom:none;border-right:none;border-top-left-radius:8px;left:-3px;top:-3px}.connect-dapps-view .top-right{border-bottom:none;border-left:none;border-top-right-radius:8px;right:-3px;top:-3px}.connect-dapps-view .bottom-left{border-bottom-left-radius:8px;border-right:none;border-top:none;bottom:-3px;left:-3px}.connect-dapps-view .bottom-right{border-bottom-right-radius:8px;border-left:none;border-top:none;bottom:-3px;right:-3px}.connect-dapps-view .scanner-overlay-content{align-items:center;border-radius:8px;display:flex;flex-direction:column;padding:16px;z-index:1}.connect-dapps-view .scanner-icon{height:20px;margin-bottom:2px;-o-object-fit:contain;object-fit:contain;width:20px}.connect-dapps-view .info-card,.connect-dapps-view .wallet-connect-card{margin-bottom:1rem;position:relative}.connect-dapps-view .wallet-connect-card{align-items:center;display:flex;flex-direction:column}.connect-dapps-view .wallet-connect-card h2{align-self:flex-start;margin-bottom:.5rem;width:100%}.connect-dapps-view .input-group{width:100%}.connect-dapps-view .input-suffix{transform:translateY(-20%)}.connect-dapps-view .banner{border-radius:8px;margin-top:.5rem;padding:6px;text-align:center;width:100%}.connect-dapps-view .banner.success{background-color:var(--dynamic-success-2)}.connect-dapps-view .banner.error{background-color:var(--dynamic-error-2)}.connect-dapps-view .info-card .wrapper{background:var(--dynamic-base-2);border:1px solid var(--dynamic-border-2);border-radius:16px;display:flex;flex-direction:column;padding:1.5rem;text-align:left}.connect-dapps-view .info-card .learn-more-link{align-items:center;display:flex;justify-content:center;padding:4px;pointer-events:auto;text-decoration:none}.connect-dapps-view .info-card .learn-more-link svg{cursor:pointer;height:.5rem;margin-left:.25rem;width:.5rem}.connect-dapps-view .inline-logo-text{align-items:center;display:flex;flex-wrap:nowrap}.connect-dapps-view .inline-logo-text .inline-logo{flex-shrink:0;margin:0 4px}.connected-apps-view{display:flex;flex-direction:column;gap:1rem;padding:1.5rem;position:relative}.connected-apps-view .header{align-items:center;display:flex;justify-content:space-between;padding-bottom:.25rem;position:relative}.connected-apps-view .header .title{flex-grow:1;text-align:center}.connected-apps-view .header .arrow-left-icon{transform:rotate(90deg)}.connected-apps-view .subheader{align-items:center;display:flex;flex-grow:1;justify-content:space-between;padding-bottom:.25rem;position:relative;text-align:center}.connected-apps-view .connected-apps-list{display:flex;flex-direction:column;gap:.75rem;list-style-type:none;margin:0;padding:0}.connected-apps-view .connected-app-item{align-items:center;background-color:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)/2);display:flex;padding:.75rem}.connected-apps-view .connected-app-item .app-icon{border-radius:50%;height:2rem;margin-right:.75rem;width:2rem}.connected-apps-view .connected-app-item .app-info{display:flex;flex:1;flex-direction:column}.connected-apps-view .connected-app-item .app-actions{display:flex;gap:.5rem;margin-left:10px}.connected-apps-view .success-message{align-items:center;background-color:var(--dynamic-success-2);border:1px solid var(--dynamic-border-1);border-radius:.5rem;display:flex;padding:.75rem;text-align:left}.connected-apps-view .success-message svg{color:#30a67b;flex-shrink:0;height:1.5rem;margin-right:.75rem;width:1.5rem}.token-option{align-items:center;background:var(--dynamic-base-2);border:1.5px solid transparent;border-radius:calc(var(--dynamic-border-radius)/2);box-shadow:0 1px 2px 0 rgba(24,39,75,.04);cursor:pointer;display:flex;gap:.625rem;padding:.625rem .75rem;transition:all .2s ease-in-out}.token-option:hover{box-shadow:0 12px 20px -6px rgba(24,39,75,.02),0 16px 26px -4px rgba(24,39,75,.04)}.token-option--selected{background:var(--dynamic-brand-secondary-color);border-color:var(--dynamic-brand-primary-color)}.token-option__icon{background-color:var(--dynamic-base-1);border-radius:50%;height:1.75rem;overflow:hidden;width:1.75rem}.token-option__name{flex:1}.token-option__balance-container{align-items:flex-end;display:flex;flex-direction:column}.token-option__balance-container__balance-value-container{align-items:center;display:flex;gap:.25rem}.token-select{align-items:stretch;display:flex;flex-direction:column}.token-select__no-assets{flex-direction:column;gap:2.25rem;margin-top:2.75rem}.token-select__no-assets,.token-select__search{align-items:center;display:flex;margin-inline:1.5rem}.token-select__search{background:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)*2);gap:.5rem;margin-bottom:1rem;padding:.625rem .75rem}.token-select__search__input{background:transparent;border:none;color:var(--dynamic-text-primary);flex:1;font-size:.9375rem;font-weight:400;line-height:1.25rem;outline:none}.token-select__search__input::-moz-placeholder{color:var(--dynamic-text-secondary)}.token-select__search__input::placeholder{color:var(--dynamic-text-secondary)}.token-select__tokens{-ms-overflow-style:none;align-items:stretch;display:flex;flex:1;flex-direction:column;gap:.5rem;margin-inline:1.5rem;margin-bottom:1.5rem;overflow-y:auto;scrollbar-width:none}.token-select__tokens::-webkit-scrollbar{display:none}.formatted-input{--size:calc(500px/(var(--char-count) + 8));align-items:center;color:var(--dynamic-text-primary);display:flex;font-size:var(--size);gap:.1875rem;overflow:hidden}.formatted-input__leading,.formatted-input__trailing{-webkit-user-select:none;-moz-user-select:none;user-select:none}.formatted-input__trailing{margin-left:.625rem}.formatted-input__leading--secondary,.formatted-input__trailing{color:var(--dynamic-text-secondary)}.formatted-input__input-container{position:relative}.formatted-input__input-container__ghost-text,.formatted-input__input-container__input{align-items:center;background:transparent;border:none;display:flex;justify-content:center;min-height:3.25rem;outline:none;overflow:hidden;text-align:center}.formatted-input__input-container__input{bottom:0;color:var(--dynamic-text-primary);height:100%;left:0;position:absolute;resize:none;right:0;top:0;width:100%}.formatted-input__input-container__input::-moz-placeholder{color:var(--dynamic-text-secondary)}.formatted-input__input-container__input::placeholder{color:var(--dynamic-text-secondary)}.formatted-input__input-container__input:-moz-placeholder-shown{text-align:left}.formatted-input__input-container__input:placeholder-shown{text-align:left}.formatted-input__input-container__ghost-text{color:transparent;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.formatted-input__input-container__ghost-text--visible{color:var(--dynamic-text-primary);pointer-events:unset;-webkit-user-select:unset;-moz-user-select:unset;user-select:unset}.fund-from-wallet{height:100%;overflow:auto;position:relative;width:100%}.fund-from-wallet,.fund-from-wallet__content{align-items:stretch;display:flex;flex:1;flex-direction:column}.fund-from-wallet__content{gap:1rem;justify-content:center;padding:0 1.5rem 1.5rem}.fund-from-wallet__content__token-icon{background-color:var(--dynamic-base-1);border-radius:50%;height:1rem;overflow:hidden;width:1rem}.fund-from-wallet__content__wallet-card{align-items:center;background:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)/2);box-shadow:0 .0625rem .125rem 0 rgba(24,39,75,.04);display:flex;gap:.5rem;justify-content:space-between;padding:.625rem .75rem}.fund-from-wallet__content__wallet-card--invisible{opacity:0;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.fund-from-wallet__content__wallet-card--has-minimum-error{margin-bottom:1.5rem}.fund-from-wallet__content__wallet-card__wallet-details{align-items:center;display:flex;gap:.625rem}.fund-from-wallet__content__wallet-card__wallet-details__rows{display:flex;flex-direction:column}.fund-from-wallet__content__wallet-card__wallet-details__icon{height:1.75rem;width:1.75rem}.fund-from-wallet__content__wallet-card__balance{align-items:center;cursor:pointer;display:flex;gap:.625rem}.fund-from-wallet__content__wallet-card__balance--disable-select{cursor:default}.fund-from-wallet__content__wallet-card__balance__rows{align-items:flex-end;display:flex;flex-direction:column}.fund-from-wallet__content__wallet-card__balance-skeleton{align-items:stretch;align-self:stretch;display:flex;width:5.3125rem}.fund-from-wallet__content__amount-container{align-items:center;display:flex;flex:1;flex-direction:column;gap:1rem;justify-content:center;overflow:hidden}.fund-from-wallet__content__amount-container__amount{max-width:100%}.fund-from-wallet__content__amount-container__secondary-amount-container{align-items:center;display:flex;gap:.375rem}.fund-from-wallet__content__amount-container__secondary-amount-container__amount--grayed-out{color:var(--dynamic-text-tertiary)}.fund-from-wallet__content__amount-container__secondary-amount-container__switch{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}.fund-from-wallet__content__amount-container__skeleton{align-items:stretch;display:flex;height:3.25rem;max-width:9.375rem;width:100%}.fund-from-wallet__content__amount-container__quick-suggestions{align-items:center;display:flex;gap:.75rem;justify-content:center}.fund-from-wallet__content__amount-container__quick-suggestions>*{align-items:center;background:var(--dynamic-base-3);border-radius:calc(var(--dynamic-border-radius)*1.25);cursor:pointer;display:flex;justify-content:center;padding:.25rem .5rem;text-align:center}.fund-from-wallet__content__amount-container__secondary-missing{align-items:center;display:flex;gap:.5rem}.fund-from-wallet__content__amount-container__secondary-missing__tooltip{color:var(--dynamic-base-2);font-size:.8125rem;font-weight:400}.fund-from-wallet__content__amount-container__balance-error,.fund-from-wallet__content__amount-container__minimum-error{max-height:0;opacity:0;transition:all .2s ease-in-out}.fund-from-wallet__content__amount-container__balance-error--visible,.fund-from-wallet__content__amount-container__minimum-error--visible{max-height:1.5625rem;opacity:1}.fund-from-wallet__content__amount-container__balance-error{margin-top:-1rem}.fund-from-wallet__content__amount-container__balance-error--visible{margin-top:0}.fund-from-wallet__content__amount-container__minimum-error{margin-bottom:-1rem}.fund-from-wallet__content__amount-container__minimum-error--visible{margin-bottom:0}.fund-from-wallet__confirm-button{margin:1.5rem}.fund-from-wallet__token-select{background:var(--dynamic-base-1);height:100%;left:0;opacity:0;padding-top:-6.25rem;pointer-events:none;position:absolute;top:0;transition:all .2s ease-in-out;width:100%;z-index:1000}.fund-from-wallet__token-select:before{content:\"\";display:block;margin-bottom:-6.25rem;transition:all .2s ease-in-out}.fund-from-wallet__token-select--open{opacity:1;padding-top:0;pointer-events:all}.fund-from-wallet__token-select--open:before{margin-bottom:0}.choose-wallet-funding-method__header-description{margin-top:1rem;text-align:center}.choose-wallet-funding-method__options{display:flex;flex-direction:column;gap:.5rem;padding:0 1.5rem 1.5rem}.choose-wallet-funding-method__options__option{gap:.625rem;justify-content:start;padding-inline:.75rem}.choose-wallet-funding-method__options__option__icon{height:1.75rem;width:1.75rem}.choose-wallet-funding-method__options__option__trailing{align-items:center;display:flex;gap:.5rem;margin-left:auto}.choose-wallet-funding-method__options__option__trailing__preview-icons{align-items:center;display:flex}@media (max-width:500px){.choose-wallet-funding-method__options__option__trailing__preview-icons{display:none}}.choose-wallet-funding-method__options__option__trailing__preview-icons>*{height:1rem;width:1rem;z-index:var(--z-index,0)}.choose-wallet-funding-method__options__option__trailing__preview-icons>:not(:first-child){margin-left:-.3125rem}.choose-wallet-funding-method__options__option__trailing__preview-icons__onramp-icon,.choose-wallet-funding-method__options__option__trailing__preview-icons__plus-icon,.choose-wallet-funding-method__options__option__trailing__preview-icons__wallet-icon{align-items:center;border-radius:50%;display:flex;justify-content:center}.choose-wallet-funding-method__options__option__trailing__preview-icons__onramp-icon{background-color:#121730}.choose-wallet-funding-method__options__option__trailing__preview-icons__onramp-icon>*{height:100%;width:100%}.choose-wallet-funding-method__options__option__trailing__preview-icons__wallet-icon{background-color:var(--dynamic-base-2)}.choose-wallet-funding-method__options__option__trailing__preview-icons__wallet-icon>*{height:100%;width:100%}.choose-wallet-funding-method__options__option__trailing__preview-icons__plus-icon{background-color:var(--dynamic-base-1)}.deposit-view__content{align-items:center;display:flex;flex-direction:column;gap:2rem;margin-top:1rem}.deposit-view__content__qr-code{height:13.4375rem;width:13.4375rem}.deposit-view__content__address{align-items:center;display:flex;flex-direction:column;gap:.5rem}.deposit-view__content__address__ens{font-size:1.125rem;font-weight:700;text-align:center}.deposit-view__content__address__wrapper{align-items:center;display:flex;flex-direction:row;gap:.5rem}.deposit-view__content__address__wrapper__text{color:var(--dynamic-text-secondary);font-size:1.125rem;font-weight:500}.deposit-view__content__address__wrapper__copy{color:var(--dynamic-text-secondary);cursor:pointer;padding:0}.deposit-view__content__network{color:var(--dynamic-text-secondary);font-size:.875rem;font-weight:500;line-height:1rem;text-align:center}.choose-onramp-provider__header-description{margin-top:1rem;text-align:center}.choose-onramp-provider__options{display:flex;flex-direction:column;gap:.5rem;padding:0 1.5rem 1.5rem}.choose-onramp-provider__options__option{gap:.625rem;justify-content:start;padding-inline:.75rem}.choose-onramp-provider__options__option__icon{height:1.75rem;width:1.75rem}.default-prompt-modal{align-items:center;display:flex;flex-direction:column;text-align:center}.default-prompt-modal__icon-with-spinner{margin:0 auto .75rem}.default-prompt-modal__content{flex-direction:column;width:100%}.default-prompt-modal__button .typography,.default-prompt-modal__content{align-items:center;display:flex;gap:.375rem;justify-content:center}.detected-new-wallet-modal__content{align-items:center;display:flex;flex-direction:column;gap:.75rem;text-align:center}.detected-new-wallet-modal__top-section{align-items:center;display:flex;flex-direction:column;gap:1.125rem;text-align:center}.no-qr-code-not-installed-modal-view{align-items:center;display:flex;flex-direction:column;gap:1rem}.no-qr-code-not-installed-modal-view__links-section{width:100%}.qr-code-modal-view{display:flex;flex-direction:column;gap:.5rem}.qr-code-modal-view__title{text-align:center}.qr-code-modal-view .qrcode__container{height:10.9375rem;width:10.9375rem}.qr-code-modal-view__container{align-items:center;display:flex;justify-content:center}.qr-code-modal-view__wrapper{background:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)*3/4);padding:.5rem}.qr-code-modal-view .info-item{margin-bottom:.75rem}.qr-code-modal-view .info-item__text{font-size:var(--dynamic-text-size-body-small)}.qr-code-modal-view .info-item svg path{fill:var(--dynamic-text-secondary)}.qr-code-modal-view .button__container{flex-direction:column}.qr-code-modal-view .button__container,.qr-code-modal-view .button__container span{align-items:center;display:flex;gap:.375rem}.unlink-wallet-popup__container{align-items:center;display:flex;flex-direction:column;width:100%}.unlink-wallet-popup__button,.unlink-wallet-popup__label,.unlink-wallet-popup__title{text-align:center}.unlink-wallet-popup__title{padding-bottom:.5rem}.unlink-wallet-popup__label{padding-bottom:.5rem;padding-top:.5rem}.unlink-wallet-popup__button{margin-top:.5rem}.unlink-wallet-popup__button--shadow{box-shadow:var(--dynamic-shadow-down-1)}.dynamic-widget__container{z-index:2147483646}.onramp-widget__backdrop{-webkit-backdrop-filter:blur(4px);backdrop-filter:blur(4px);background-color:rgba(0,0,0,.25);inset:0;position:fixed;z-index:2147483645}.onramp-widget__modal{align-items:center;display:flex;inset:0;justify-content:center;overflow-y:auto;padding:1rem;position:fixed;z-index:2147483646}@media (pointer:coarse){.onramp-widget__modal{padding:0}}.onramp-widget__modal iframe{border:none;border-radius:1.5rem;height:635px;margin:auto;max-width:470px;overflow:hidden;width:100%;z-index:2147483647}@media (pointer:coarse){.onramp-widget__modal iframe{border-bottom-left-radius:0;border-bottom-right-radius:0;margin:initial;margin-top:auto}}.embedded-widget{max-width:100%;width:var(--dynamic-modal-width)}.embedded-widget--background-default,.embedded-widget--background-none{background:none}.dynamic-bridge-user-profile__switcher{margin:0 0 1rem;padding:1.5rem 1.5rem 0}.dynamic-bridge-wallet-card__network{margin:0 0 .5rem}.dynamic-bridge-wallet-card__network,.dynamic-bridge-wallet-card__network-icon,.dynamic-bridge-wallet-card__network-name{display:inline-block;vertical-align:middle}.dynamic-bridge-wallet-card__network-icon{height:1rem;margin-right:.375rem;width:1rem}.dynamic-bridge-widget-empty-card{background-color:var(--dynamic-base-2);border-radius:calc(var(--dynamic-border-radius)/2);box-shadow:var(--dynamic-shadow-down-1);padding:.75rem;transition:transform .1s linear}.dynamic-bridge-widget-empty-card:active{transform:scale(.98)}.dynamic-bridge-widget-empty-card__icon{display:inline-flex;height:1.75rem;margin-right:.63rem;vertical-align:middle;width:1.75rem}.dynamic-bridge-widget-empty-card__text{overflow:hidden;text-overflow:ellipsis;vertical-align:middle;white-space:nowrap}.dynamic-bridge-widget-wallets-view{display:flex;flex-direction:column;gap:1rem;padding:1.5rem}.dynamic-bridge-widget-wallets-view__logout-button{margin:0 auto}.dynamic-bridge-widget-wallets-view__unlink-button{color:var(--dynamic-text-secondary);margin:auto 0 0 auto}.dynamic-bridge-widget__skeleton{height:1.25rem;width:5rem}.dynamic-bridge-widget__skeleton-button{cursor:default}.dynamic-bridge-widget__skeleton-button:hover{background-color:initial}.footer-buttons-item{align-items:center;background:var(--dynamic-base-2);border:0;border-radius:calc(var(--dynamic-border-radius)/2);box-shadow:var(--dynamic-shadow-down-1);cursor:pointer;display:flex;padding:.75rem;transition:all .3s;width:100%}.footer-buttons-item__icon--left{margin-right:.625rem}.footer-buttons-item__icon--left img,.footer-buttons-item__icon--left svg{height:1.25rem;width:1.25rem}.new-to-web3-buttons__container{margin-top:1rem}.new-to-web3-buttons__container button{background:var(--dynamic-brand-primary-color);border-radius:calc(var(--dynamic-border-radius)/2);box-shadow:var(--dynamic-shadow-down-1);color:#fff;padding:.75rem;width:100%}.walletlist-help-content__container{color:var(--dynamic-text-secondary);padding:1.5rem}.walletlist-help-content__icon{align-items:center;display:flex;height:3.5rem;justify-content:center;margin:0 auto;width:3.5rem}.walletlist-help-content__typography-wrapper{color:var(--dynamic-text-primary);margin:1rem 0;text-align:center}.walletlist-help-content__typography-wrapper .walletlist-help-content__typography--label{margin-top:.375rem}.walletlist-help-content__buttons-wrapper{display:flex;flex-direction:column;gap:.375rem;margin-top:1rem}.walletlist-help-content__buttons-wrapper button{text-align:left;width:100%}.walletlist-help-content__custodial-wallet-area--title{margin:.75rem 0;text-align:center}.footer-more-info-content__wrapper{display:flex;flex-direction:column;gap:.75rem;padding:1.5rem}.footer-more-info-content__item--phantom-ledger{font-size:.6875rem;margin-bottom:.5rem}.footer-more-info-content__item--phantom-ledger p{margin-bottom:.5rem}.footer-more-info-content__item--phantom-ledger p:last-child,.footer-more-info-content__item:last-child{margin-bottom:0}.back-button{rotate:-90deg}.help-header{border-bottom:1px solid var(--dynamic-base-4)}.passkey-info-help-content__container{color:var(--dynamic-text-secondary);padding:1.5rem}.passkey-info-help-content__typography-wrapper{color:var(--dynamic-text-primary);display:flex;flex-direction:column;gap:1rem;text-align:left}.passkey-info-help-content__wrapper{flex:1}.passkey-info-help-content__details{display:flex;flex-direction:row;gap:1rem}.layout-header{align-items:stretch;background:var(--dynamic-header-background);display:flex;flex-direction:column;width:100%}.layout-header__skeleton{width:7.5rem}.layout-header__typography{margin:0;text-align:center}.layout-header__typography img,.layout-header__typography svg{display:inline-block}.layout-header__tooltip{background-color:var(--dynamic-text-primary);color:var(--dynamic-base-2);font-size:.75rem}.layout-header__icon svg{height:1.5rem;width:1.5rem}.layout-header__description{margin-top:1rem;padding-inline:1.5rem;text-align:center}.tos-and-pp__footer{background:var(--dynamic-footer-background);border-top:var(--dynamic-footer-border-top);bottom:0;padding:var(--dynamic-footer-padding);position:relative;width:100%}.default-footer__footer{background:var(--dynamic-base-1);border-top:.0625rem solid var(--dynamic-base-4);box-shadow:var(--dynamic-shadow-up-1);height:var(--dynamic-border-radius);min-height:1.5rem;opacity:1;text-align:center;transition:opacity .15s,visibility .15s;visibility:visible;width:100%}.default-footer__footer--hidden{opacity:0;transition:opacity .15s,visibility .15s;visibility:hidden}.wallet-progress-stepper{padding:.5rem 1rem}.dynamic-user-profile-layout{display:flex;flex-direction:column;height:33.125rem;overflow:hidden}.dynamic-user-profile-layout--unset-max-height{height:unset}input:-webkit-autofill,input:-webkit-autofill:active,input:-webkit-autofill:focus,input:-webkit-autofill:hover{box-shadow:unset!important}.dynamic-modal{display:flex;flex-direction:column-reverse;left:50%;letter-spacing:0;position:absolute}.dynamic-shadow-dom-content{font-family:var(--dynamic-font-family-primary)}";

const LegacySafariCssOverrides = () => (jsxRuntimeExports.jsx("link", { rel: 'stylesheet', href: 'https://app.dynamic.xyz/assets/legacySafari/styles.css' }));

const isShadowDOMFlagEnabled = () => {
    if (isSSR())
        return false;
    const flag = 'shadowDOM.enabled';
    const searchParams = new URLSearchParams(window.location.search);
    // by default, enable the widget
    if (!searchParams.has(flag)) {
        return true;
    }
    return searchParams.get(flag) === 'true';
};

const ShadowDOMContext = React__default.createContext({});
const ShadowDOMStyle = () => jsxRuntimeExports.jsx("style", { children: css_248z$1 });
const ShadowDOM = ({ mode = 'open', id, className, children, dataTestId, zIndex, }) => {
    const { shadowDOMEnabled: shadowDOMSetting, cssOverrides } = useInternalDynamicContext();
    const shadowDOMFlag = isShadowDOMFlagEnabled();
    const shadowDOMEnabled = shadowDOMFlag && shadowDOMSetting;
    const [nodeRef, setNodeRef] = useState(null);
    const [shadowRoot, setShadowRoot] = useState();
    const CssOverridesElement = useMemo(() => {
        if (cssOverrides && typeof cssOverrides !== 'string') {
            return () => cssOverrides;
        }
        else if (cssOverrides && typeof cssOverrides === 'string') {
            const StyleElement = () => jsxRuntimeExports.jsx("style", { children: cssOverrides });
            return StyleElement;
        }
        return null;
    }, [cssOverrides]);
    useLayoutEffect(() => {
        if (nodeRef && shadowDOMEnabled) {
            try {
                const root = nodeRef.attachShadow({
                    mode,
                });
                setShadowRoot(root);
            }
            catch (e) {
                // do nothing
            }
        }
    }, [shadowDOMEnabled, nodeRef, mode]);
    const shouldRenderStyles = Boolean(Object.keys(css_248z$1).length);
    if (!shadowDOMEnabled) {
        return (jsxRuntimeExports.jsx(IsBrowser, { children: jsxRuntimeExports.jsxs("div", { "data-testid": dataTestId, ref: setNodeRef, id: id, className: classNames('dynamic-shadow-dom', className), style: { zIndex }, children: [children, shouldRenderStyles && jsxRuntimeExports.jsx(ShadowDOMStyle, {}), isLegacySafari() && jsxRuntimeExports.jsx(LegacySafariCssOverrides, {}), CssOverridesElement && jsxRuntimeExports.jsx(CssOverridesElement, {})] }) }));
    }
    return (jsxRuntimeExports.jsx(IsBrowser, { children: jsxRuntimeExports.jsx(ShadowDOMContext.Provider, { value: { shadowRoot }, children: jsxRuntimeExports.jsx("div", { "data-testid": dataTestId, ref: setNodeRef, id: id, className: classNames('dynamic-shadow-dom', className), style: { zIndex }, children: shadowRoot &&
                    createPortal(jsxRuntimeExports.jsxs("div", { className: 'dynamic-shadow-dom-content', children: [children, shouldRenderStyles && jsxRuntimeExports.jsx(ShadowDOMStyle, {}), isLegacySafari() && jsxRuntimeExports.jsx(LegacySafariCssOverrides, {}), CssOverridesElement && jsxRuntimeExports.jsx(CssOverridesElement, {})] }), shadowRoot) }) }) }));
};

// Hook that returns the prepared data to work with the formik
// In order to update or display user information
const useUserDataForm = ({ onSubmit, onError, userProfile, shouldEnforcePolicies = true, fields, }) => {
    var _a;
    const { mockedSDK } = useMockContext();
    const [fetch, setFetch] = useState(false);
    const { fieldsConfig } = useFields();
    const enforcePolicies = shouldEnforcePolicies &&
        ((_a = fields.find((setting) => setting.name === 'policiesConsent')) === null || _a === void 0 ? void 0 : _a.enabled);
    const requiredTitleCase = (name) => `${name.charAt(0).toUpperCase() + name.slice(1)} is required`;
    const formikValidationSchema = useMemo(() => create$1().shape(Object.fromEntries(fields.map(({ name, required, type, validationType, validationRules }) => {
        let schema = type === KycFieldType.Custom
            ? getValueByKey(customFieldValidationMap, validationType)
            : getValueByKey(fieldsConfig, name).validation;
        if (type === KycFieldType.Custom &&
            validationRules &&
            (validationType === CustomFieldType.Select ||
                validationType === CustomFieldType.Text)) {
            schema = schema;
            if (validationRules.validOptions) {
                schema = schema.oneOf(validationRules.validOptions.map((option) => option.label), 'Select a valid option');
            }
            else if (validationRules.regex) {
                schema = schema.matches(new RegExp(validationRules.regex), 'Invalid field format');
            }
        }
        return [
            name,
            required ? schema.required(requiredTitleCase(name)) : schema,
        ];
    }))), [fields]);
    const formikInitialValues = useMemo(() => Object.fromEntries(fields.map(({ name, type, validationRules, validationType }) => {
        var _a, _b, _c, _d;
        const info = (userProfile !== null && userProfile !== void 0 ? userProfile : {});
        if (type === KycFieldType.Custom) {
            let defaultValue = '';
            if (validationType === CustomFieldType.Select &&
                (validationRules === null || validationRules === void 0 ? void 0 : validationRules.validOptions))
                defaultValue = (_a = validationRules.validOptions[0].label) !== null && _a !== void 0 ? _a : '';
            return [
                name,
                (() => {
                    var _a;
                    const value = info.metadata
                        ? getValueByKey(info.metadata, name)
                        : undefined;
                    return Array.isArray(value)
                        ? value
                        : (_a = value === null || value === void 0 ? void 0 : value.toString()) !== null && _a !== void 0 ? _a : defaultValue;
                })(),
            ];
        }
        const mapNameToDefaultValue = {
            country: countryCodes[0].code,
            policiesConsent: false,
            tShirtSize: tShirtSizes[0],
            team: teamNames[0],
        };
        const defaultValue = (_b = mapNameToDefaultValue[name]) !== null && _b !== void 0 ? _b : '';
        return [name, (_d = (_c = getValueByKey(info, name)) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : defaultValue];
    })) || {}, [fields, userProfile]);
    const onFormSubmit = useCallback((values, formikHelper) => __awaiter$1(void 0, void 0, void 0, function* () {
        const metadata = {};
        const uniqueMetadata = {};
        if (mockedSDK)
            return;
        try {
            if (!(userProfile === null || userProfile === void 0 ? void 0 : userProfile.environmentId))
                throw new DynamicError('Invalid environment ID');
            setFetch(true);
            let updatedUserFields = values;
            // all kyc fields including custom are in the object, move custom fields to the object.metadata
            Object.entries(updatedUserFields).forEach(([fieldName, fieldValue]) => {
                const field = fields.find((f) => f.name === fieldName && f.type === KycFieldType.Custom);
                if (field) {
                    metadata[fieldName] = fieldValue;
                    delete updatedUserFields[fieldName];
                    if (field.unique)
                        uniqueMetadata[fieldName] = fieldValue;
                }
            });
            if (Object.keys(metadata).length > 0)
                updatedUserFields.metadata = metadata;
            if (enforcePolicies) {
                updatedUserFields = Object.assign(Object.assign({}, updatedUserFields), { policiesConsent: true });
                delete updatedUserFields.policiesConsentArray;
            }
            yield (onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(updatedUserFields));
        }
        catch (e) {
            logger$1.error(e);
            onError === null || onError === void 0 ? void 0 : onError(e);
            if (e instanceof EmailAlreadyExistsError) {
                formikHelper.setErrors({ email: 'Email already exists' });
            }
            else if (e instanceof CustomFieldNotUniqueError) {
                // clear all non error fields because user has to edit them anyways for the validation to pass, not sure why
                formikHelper.setFormikState((state) => (Object.assign(Object.assign({}, state), { errors: Object.fromEntries(Object.entries(uniqueMetadata).map(([customFieldName]) => [
                        customFieldName,
                        Object.entries(uniqueMetadata).length > 1
                            ? 'One or more fields are already tied to another user'
                            : `${customFieldName} is already tied to another user`,
                    ])), touched: Object.fromEntries(Object.entries(uniqueMetadata).map(([fieldName]) => [
                        fieldName,
                        true,
                    ])), values: Object.assign(Object.assign({}, formikInitialValues), uniqueMetadata) })));
            }
            else if (e instanceof TooManyEmailVerificationsError) {
                formikHelper.setErrors({
                    email: 'Too many email verification attempts.',
                });
            }
            else if (e instanceof UsernameAlreadyExistsError) {
                formikHelper.setErrors({ username: 'Username already exists' });
            }
            else if (e instanceof InvalidPhoneNumberError) {
                formikHelper.setErrors({ phoneNumber: e.message });
            }
            else {
                formikHelper.setErrors({
                    api: 'Something went wrong. Please try again.',
                });
            }
        }
        finally {
            setFetch(false);
        }
    }), [
        mockedSDK,
        userProfile === null || userProfile === void 0 ? void 0 : userProfile.environmentId,
        enforcePolicies,
        onSubmit,
        fields,
        onError,
        formikInitialValues,
    ]);
    return {
        enforcePolicies,
        fetch,
        formikInitialValues,
        formikValidationSchema,
        onFormSubmit,
    };
};

const getProviderByType = (providers, providerType) => providers.find((p) => p.provider === providerType);

const getSupportedCountriesForVerificationFromProjectSettings = (projectSettings) => {
    var _a, _b;
    const smsProvider = getProviderByType((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers) !== null && _a !== void 0 ? _a : [], ProviderEnum.Sms);
    return ((_b = smsProvider === null || smsProvider === void 0 ? void 0 : smsProvider.enabledCountries) !== null && _b !== void 0 ? _b : []).map((country) => country.isoCountryCode.toLowerCase());
};

const defaultCountries = ['us', 'ca'];
/**
 * Returns the default countries if the provided countries array is empty.
 *
 * @param countries - An array of country ISO2 codes.
 * @returns An array of country ISO2 codes.
 */
const getDefaultCountriesIfEmpty = (countries) => (countries.length ? countries : defaultCountries);

/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * useThrottle hook to throttle a callback function.
 *
 * @param callback - The callback function to be throttled. It must return void.
 * @param delay - The time in milliseconds to wait before the next call.
 * @returns A throttled version of the callback function.
 */
const useThrottle = (callback, delay) => {
    const isThrottled = useRef(false);
    const savedCallback = useRef(callback);
    // Remember the latest callback if it changes.
    savedCallback.current = callback;
    return useCallback((...args) => {
        if (!isThrottled.current) {
            savedCallback.current(...args);
            isThrottled.current = true;
            // Set the throttle off after the delay
            setTimeout(() => (isThrottled.current = false), delay);
        }
    }, [delay]);
};

/** Performs the true mathematical operation of "number mod target" */
const modulo = (number, target) => ((number % target) + target) % target;

const parseDefaultCountry = ({ defaultIso2, countries, initialPhone, }) => {
    // Return the country inferred from the phone number if possible
    if (initialPhone) {
        const { country } = X({
            countries,
            phone: initialPhone,
        });
        if (country) {
            return country;
        }
    }
    const parsedCountries = countries.map(M);
    // If the user has previously selected a country, use that as the default
    const lastUsedCountryIso2 = StorageService.getItem(PHONE_INPUT_DEFAULT_COUNTRY);
    const lastUsedCountry = parsedCountries.find(({ iso2 }) => iso2 === lastUsedCountryIso2);
    if (lastUsedCountry) {
        return lastUsedCountry;
    }
    // Use default country setting if found in enabled countries
    const defaultCountry = parsedCountries.find(({ iso2 }) => iso2 === defaultIso2);
    if (defaultCountry) {
        return defaultCountry;
    }
    // Return US if it is enabled
    const countryUS = parsedCountries.find(({ iso2 }) => iso2 === 'us');
    if (countryUS) {
        return countryUS;
    }
    // Return the first country in the list as a last resort
    if (parsedCountries[0]) {
        return parsedCountries[0];
    }
    throw new Error('No country list was provided');
};

const MENU_DISPLAY_THROTTLE = 50;
const COUNTRY_INPUT_SCROLL_DELAY = 20;
const usePhoneInputLogic = ({ countryInputRef, setCountryDropdownOpen, setInvalidNumberMessage, onUpdate, initialPhone, countries, defaultIso2, }) => {
    const onUpdateRef = useRef(onUpdate);
    onUpdateRef.current = onUpdate;
    const defaultCountry = useMemo(() => parseDefaultCountry({
        countries,
        defaultIso2,
        initialPhone,
    }), [countries, defaultIso2, initialPhone]);
    const { inputValue: formattedPhone, phone, country: currentCountry, setCountry: setSelectedCountry, handlePhoneValueChange: handlePhoneInput, inputRef, } = ee({
        countries,
        defaultCountry: defaultCountry.iso2,
        disableDialCodeAndPrefix: true,
        value: initialPhone,
    });
    /** What is currently displayed on the country input */
    const [countryInput, setCountryInput] = useState(defaultCountry.dialCode);
    /**
     * This is the same value as phone, except for the following scenario:
     * Since the phone number field hides the "+" char and the country code, when the field
     * looks empty, it actually still has these values in there. But we want the user to be able to
     * set the phone value to the actual empty ("") string.
     * So when the phone has nothing but the "+" char and the country code, this value will be empty.
     */
    const phoneOrEmptyString = useMemo(() => phone.length === ('+' + currentCountry.dialCode).length ? '' : phone, [currentCountry.dialCode, phone]);
    // Justification for effect:
    // Since the library controls the states, we can't call this callback inside the setters.
    // We could wrap setCountry and handlePhoneInput, but that only accounts for
    // country and phone, not formattedPhone.
    useEffect(() => {
        var _a;
        (_a = onUpdateRef.current) === null || _a === void 0 ? void 0 : _a.call(onUpdateRef, {
            country: currentCountry,
            formattedPhone,
            phone: phoneOrEmptyString,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCountry.iso2, formattedPhone, phoneOrEmptyString]);
    // =================================================================
    // DROPDOWN
    // =================================================================
    /** String to filter the countries with */
    // Even though this value is similar to countryInput, it needs to differ for a specific scenario:
    // The user inputs a value (say 55) and then starts cycling with the arrow keys.
    // If we were using the countryInput to filter the list, that filter would change with each new country.
    const [filterQuery, setFilterQuery] = useState('');
    /** List of countries, but filtered by the current input */
    const filteredCountries = useMemo(() => {
        if (!filterQuery)
            return countries;
        // If input is a country name
        if (isNaN(parseInt(filterQuery)))
            return countries.filter((countryData) => {
                const { name, iso2 } = M(countryData);
                return (name.toLowerCase().includes(filterQuery.toLowerCase()) ||
                    iso2 === filterQuery.toLowerCase() ||
                    currentCountry.iso2 === iso2);
            });
        return countries.filter((countryData) => {
            const { dialCode, iso2 } = M(countryData);
            return dialCode.includes(filterQuery) || currentCountry.iso2 === iso2;
        });
    }, [countries, currentCountry.iso2, filterQuery]);
    const openDropdown = () => {
        // Don't filter on open, wait for input
        setFilterQuery('');
        setCountryDropdownOpen(true);
    };
    const closeDropdown = useCallback(() => {
        setCountryDropdownOpen(false);
    }, [setCountryDropdownOpen]);
    // =================================================================
    // COUNTRY INPUT
    // =================================================================
    /** The last inputted value for country that was valid */
    const lastValidCountry = useRef(defaultCountry);
    const handleCountryInput = ({ target, }) => {
        const value = target.value.slice(0, 4);
        setCountryInput(value);
        // Start filtering as soon as there is any input
        setFilterQuery(value);
        // Check which country this dial code corresponds to
        const { country: guessedCountry } = X({
            countries,
            currentCountryIso2: currentCountry.iso2,
            phone: value,
        });
        if (!guessedCountry)
            return;
        lastValidCountry.current = guessedCountry;
        setSelectedCountry(guessedCountry.iso2);
        StorageService.setItem(PHONE_INPUT_DEFAULT_COUNTRY, guessedCountry.iso2);
        setTimeout(() => scrollCountryIntoView(guessedCountry.iso2), COUNTRY_INPUT_SCROLL_DELAY);
    };
    const resetToLastValidCountry = () => {
        if (!lastValidCountry.current ||
            countryInput === lastValidCountry.current.dialCode)
            return;
        setSelectedCountry(lastValidCountry.current.iso2);
        StorageService.setItem(PHONE_INPUT_DEFAULT_COUNTRY, lastValidCountry.current.iso2);
        setCountryInput(lastValidCountry.current.dialCode);
        // Changing country resets the phone number, so we must also reset any errors
        setInvalidNumberMessage(undefined);
    };
    /** Handles up and down arrow input */
    const handleArrowInput = useCallback((event) => {
        event.preventDefault();
        const currentIndex = filteredCountries.findIndex((countryData) => M(countryData).iso2 === currentCountry.iso2);
        const direction = event.key === 'ArrowUp' ? -1 : 1;
        const newCountry = M(filteredCountries[modulo(currentIndex + direction, filteredCountries.length)]);
        scrollCountryIntoView(newCountry.iso2);
        // We don't set filterQuery here because we don't want to change
        // the filter while the user is cycling through the list
        setCountryInput(newCountry.dialCode);
        setSelectedCountry(newCountry.iso2);
        lastValidCountry.current = newCountry;
        StorageService.setItem(PHONE_INPUT_DEFAULT_COUNTRY, newCountry.iso2);
        // Changing country resets the phone number, so we must also reset any errors
        setInvalidNumberMessage(undefined);
    }, [
        currentCountry.iso2,
        filteredCountries,
        setInvalidNumberMessage,
        setSelectedCountry,
    ]);
    const handleEnterInput = useCallback(() => {
        var _a;
        closeDropdown();
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
    }, [closeDropdown, inputRef]);
    const handleCountryKeyDown = useCallback((event) => {
        // When navigating away, close dropdown but don't prevent navigation
        if (event.key === 'Tab')
            return closeDropdown();
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown')
            return handleArrowInput(event);
        if (event.key === 'Enter')
            return handleEnterInput(event);
    }, [closeDropdown, handleArrowInput, handleEnterInput]);
    // =================================================================
    // UTILITIES
    // =================================================================
    // Due to the way react-international-phone works, numberInput always has a value (the dial code),
    // even if it's not visible in the input itself.
    /** Tells whether the phone input has any characters typed into it */
    const hasInput = useMemo(() => de({
        charAfterDialCode: '+',
        dialCode: currentCountry.dialCode,
        phone,
    }).length > 0, [currentCountry.dialCode, phone]);
    /** Ref of the entire form */
    const countriesContainer = useRef(null);
    const scrollCountryIntoView = (iso2) => {
        var _a;
        const selectedItem = (_a = countriesContainer.current) === null || _a === void 0 ? void 0 : _a.querySelector('#' + iso2);
        selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.scrollIntoView({
            behavior: 'instant',
            block: 'center',
            inline: 'center',
        });
    };
    // We pass this as a ref to the countries dropdown. React fires it multiple times, so we throttle
    const onMenuDisplayToggle = useThrottle((menu) => {
        var _a;
        const wasOpen = Boolean(countriesContainer.current);
        const isOpen = Boolean(menu);
        countriesContainer.current = menu;
        // If we receive null that means the menu was closed
        // The rest on the code should only execute when going from hidden to shown
        if (wasOpen || !isOpen)
            return;
        (_a = countryInputRef.current) === null || _a === void 0 ? void 0 : _a.select();
        scrollCountryIntoView(currentCountry.iso2);
    }, MENU_DISPLAY_THROTTLE);
    /** Sets all the state related to country */
    const setCountry = (newCountry) => {
        setCountryInput(newCountry.dialCode);
        setSelectedCountry(newCountry.iso2);
        StorageService.setItem(PHONE_INPUT_DEFAULT_COUNTRY, newCountry.iso2);
        lastValidCountry.current = newCountry;
        // Changing country resets the phone number, so we must also reset any errors
        setInvalidNumberMessage(undefined);
    };
    /** Override fontsize of country code for larger inputs */
    const countryFontSize = useMemo(() => {
        if (countryInput.length > 3)
            return 'var(--dynamic-text-size-body-mini)';
        if (countryInput.length > 2)
            return 'var(--dynamic-text-size-body-small)';
        return 'var(--dynamic-text-size-body-normal)';
    }, [countryInput.length]);
    return {
        closeDropdown,
        countryFontSize,
        countryInput,
        currentCountry,
        filteredCountries,
        formattedPhone,
        handleCountryInput,
        handleCountryKeyDown,
        handlePhoneInput,
        hasInput,
        inputRef,
        onBlurCountry: resetToLastValidCountry,
        onFocusCountry: openDropdown,
        onMenuDisplayToggle,
        openDropdown,
        setCountry,
    };
};

const PhoneNumberField = ({ isLoading, disabled, error, label, onUpdate, appendRight, setIsFocused, setIsHovered, initialPhone, onBlur, countries, }) => {
    const { t } = useTranslation();
    const countryInputRef = useRef(null);
    const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
    const anchorRef = useRef(null);
    const { defaultPhoneInputIso2 } = useInternalDynamicContext();
    const [invalidNumberMessage, setInvalidNumberMessage] = useState(undefined);
    const { formattedPhone, currentCountry, handleCountryInput, handlePhoneInput, hasInput, inputRef, countryInput, onBlurCountry, filteredCountries, openDropdown, handleCountryKeyDown, closeDropdown, setCountry, onMenuDisplayToggle, onFocusCountry, countryFontSize, } = usePhoneInputLogic({
        countries,
        countryInputRef,
        defaultIso2: defaultPhoneInputIso2,
        initialPhone,
        onUpdate,
        setCountryDropdownOpen,
        setInvalidNumberMessage,
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'phone-number-field', children: [jsxRuntimeExports.jsxs("div", { className: 'phone-number-field__fields', onPointerEnter: () => setIsHovered === null || setIsHovered === void 0 ? void 0 : setIsHovered(true), onPointerLeave: () => setIsHovered === null || setIsHovered === void 0 ? void 0 : setIsHovered(false), onFocus: () => setIsFocused === null || setIsFocused === void 0 ? void 0 : setIsFocused(true), onBlur: (event) => {
                    setIsFocused === null || setIsFocused === void 0 ? void 0 : setIsFocused(false);
                    onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
                }, ref: anchorRef, children: [jsxRuntimeExports.jsxs("div", { className: classNames('phone-number-field__fields__country-code', {
                            'phone-number-field__fields__country-code--disabled': isLoading || disabled,
                        }), onClick: openDropdown, "data-testid": 'country-code', children: [jsxRuntimeExports.jsx(q, { iso2: currentCountry.iso2, size: '24px', className: 'phone-number-field__fields__country-code__flag' }), jsxRuntimeExports.jsx(Typography, { className: 'phone-number-field__fields__country-code__plus', variant: 'body_normal', weight: 'regular', style: { fontSize: countryFontSize }, color: 'primary', children: "+" }), jsxRuntimeExports.jsx(Input, { label: '', id: 'country_code_field', value: countryInput, onChange: handleCountryInput, disabled: isLoading || disabled, containerClassName: 'phone-number-field__fields__country-code__container', className: 'phone-number-field__fields__country-code__container__input', onBlur: onBlurCountry, ref: countryInputRef, onKeyDown: handleCountryKeyDown, onFocus: onFocusCountry, style: { fontSize: countryFontSize }, "data-testid": 'country-code-input', inputMode: 'numeric', autoComplete: 'tel-country-code' }), jsxRuntimeExports.jsx(Icon, { className: 'phone-number-field__fields__country-code__chevron', children: jsxRuntimeExports.jsx(SvgChevronDown, {}) })] }), jsxRuntimeExports.jsx(Input, { label: '', id: 'phoneNumber', value: formattedPhone, onChange: handlePhoneInput, disabled: isLoading || disabled, containerClassName: 'phone-number-field__fields__phone-number', className: 'phone-number-field__fields__phone-number__input', ref: inputRef, error: Boolean(invalidNumberMessage || error), inputMode: 'numeric', "data-testid": 'phone_number_input', autoComplete: 'tel-national' }), !hasInput && (jsxRuntimeExports.jsx(Typography, { className: 'phone-number-field__fields__placeholder', variant: 'body_normal', weight: 'regular', copykey: 'dyn_collect_user_data.fields.phone_number.label', children: label !== null && label !== void 0 ? label : t('dyn_collect_user_data.fields.phone_number.label') })), appendRight] }), jsxRuntimeExports.jsx(MenuList, { isOpen: countryDropdownOpen, onClickClose: closeDropdown, popperProps: {
                    anchorOrigin: 'bottom-left',
                    anchorRef,
                }, mobileTitle: 'Select country', dropdownClassName: 'phone-number-field__dropdown', children: jsxRuntimeExports.jsx("div", { className: 'phone-number-field__dropdown__items', ref: onMenuDisplayToggle, children: filteredCountries.map((countryData) => {
                        const country = M(countryData);
                        const { iso2, name, dialCode } = country;
                        const isSelected = iso2 === currentCountry.iso2;
                        return (jsxRuntimeExports.jsxs("div", { className: classNames('phone-number-field__dropdown__items__country', {
                                'phone-number-field__dropdown__items__country--selected': isSelected,
                            }), onClick: () => {
                                setCountry(country);
                                closeDropdown();
                            }, id: iso2, children: [jsxRuntimeExports.jsx(q, { iso2: iso2, size: '24px' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'primary', children: name }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', children: dialCode })] }, iso2));
                    }) }) }), Boolean(invalidNumberMessage || error) && (jsxRuntimeExports.jsx(Typography, { variant: 'body_mini', className: 'phone-number-field__error-message', children: error !== null && error !== void 0 ? error : invalidNumberMessage }))] }));
};

const UserPhoneField = ({ onChange, value: phone, onBlur, disabled, label, required, error, name, verify, }) => {
    const { selectedPhoneCountry } = useFieldsState();
    const { projectSettings } = useInternalDynamicContext();
    const handleUpdate = ({ country, phone: newPhone }) => {
        selectedPhoneCountry.current = country;
        if (newPhone !== phone)
            onChange({
                target: { name, value: newPhone },
            });
    };
    const countries = useMemo(() => {
        const enabledCountries = getSupportedCountriesForVerificationFromProjectSettings(projectSettings);
        return getCustomCountries(verify ? getDefaultCountriesIfEmpty(enabledCountries) : undefined);
    }, [verify, projectSettings]);
    return (jsxRuntimeExports.jsx(PhoneNumberField, { countries: countries, initialPhone: phone, disabled: disabled, onUpdate: handleUpdate, onBlur: onBlur, label: label, appendRight: !disabled && !required ? (jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', className: 'user-phone-field__optional-label', children: "Optional" })) : undefined, error: error }));
};

const getDisplayErrorMessage = (fieldName, error) => {
    var _a;
    if (!error)
        return;
    const mapErrorToTemplate = {
        required: (fieldName) => `${fieldName} is required`,
    };
    return ((_a = mapErrorToTemplate[error]) === null || _a === void 0 ? void 0 : _a.call(mapErrorToTemplate, fieldName)) || error;
};

const Checkbox = ({ ariaLabel, checked, className = '', defaultChecked, disabled, id, name, onChange, value, }) => (jsxRuntimeExports.jsxs("div", { className: classNames('checkbox__container', className), children: [jsxRuntimeExports.jsx("input", { type: 'checkbox', id: id, "aria-label": ariaLabel, "aria-checked": checked, className: 'checkbox--hidden', value: value, checked: checked, name: name, disabled: disabled, defaultChecked: defaultChecked, onChange: (e) => Boolean(onChange) && (onChange === null || onChange === void 0 ? void 0 : onChange(e, e.currentTarget.value)), "data-testid": 'input-checkbox' }), jsxRuntimeExports.jsx("div", { className: 'checkbox--visible', children: jsxRuntimeExports.jsx(SvgCheck, { className: 'checkbox__icon' }) })] }));

var _path$Z;
var _excluded$16 = ["title", "titleId"];
function _extends$16() { return _extends$16 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$16.apply(null, arguments); }
function _objectWithoutProperties$16(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$16(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$16(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgArrowDown = function SvgArrowDown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$16(_ref, _excluded$16);
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$Z || (_path$Z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.862 9.529c.26-.26.682-.26.943 0L12 13.724l4.195-4.195a.667.667 0 1 1 .943.942l-4.667 4.667a.667.667 0 0 1-.942 0l-4.667-4.667a.667.667 0 0 1 0-.942Z",
    fill: "currentColor"
  })));
};

const getDisplayValue = (element) => {
    if (!element)
        return;
    const { selectedIndex } = element;
    if (selectedIndex === undefined)
        return;
    const option = element.options[selectedIndex];
    if (!option.hasAttribute('value'))
        return;
    return option.text;
};

const Select = (_a) => {
    var { children, className = '', id, label, value, error = false, selectDataTestId, message } = _a, selectProps = __rest(_a, ["children", "className", "id", "label", "value", "error", "selectDataTestId", "message"]);
    const selectRef = useRef(null);
    const [displayValue, setDisplayValue] = useState();
    useLayoutEffect(() => {
        if (!value)
            return;
        const selectElement = selectRef.current;
        setDisplayValue(getDisplayValue(selectElement));
    }, [value, setDisplayValue]);
    return (jsxRuntimeExports.jsxs("div", { className: 'select__field', children: [jsxRuntimeExports.jsxs("div", { className: classNames(className, 'select__container'), children: [jsxRuntimeExports.jsxs("label", { className: classNames('select__body', {
                            select__error: error,
                            select__has_value: Boolean(displayValue),
                        }), htmlFor: id, children: [jsxRuntimeExports.jsx("span", { className: 'select__value', children: displayValue || jsxRuntimeExports.jsx("span", { children: "\u00A0" }) }), jsxRuntimeExports.jsx("span", { className: 'select__label', children: label }), jsxRuntimeExports.jsx("div", { className: 'select__control_icon', children: jsxRuntimeExports.jsx(Icon, { size: 'medium', children: jsxRuntimeExports.jsx(SvgArrowDown, {}) }) })] }), jsxRuntimeExports.jsx("select", Object.assign({}, selectProps, { "data-testid": selectDataTestId, ref: selectRef, id: id, value: value, placeholder: label, className: 'select', children: children }))] }), message && (jsxRuntimeExports.jsx(Typography, { className: classNames('select__message', {
                    select__message__error: error,
                }), variant: 'body_mini', children: message }))] }));
};

const renderSelectField = ({ key, name, label, type, options, disabled, dataTestId }, { errors, touched }) => (jsxRuntimeExports.jsx(Field, { copykey: key, as: Select, type: type, id: name, name: name, label: label, error: Boolean(errors[name] && touched[name]), selectDataTestId: dataTestId, message: touched[name] && getDisplayErrorMessage(label, errors[name]), disabled: disabled, children: options.map((option) => typeof option === 'string' ? (jsxRuntimeExports.jsx("option", { value: option, children: option }, option)) : (jsxRuntimeExports.jsx("option", { value: option.value, children: option.label }, option.value))) }, name));
const renderCheckboxGroup = (key, name, label, validationRules, errors, touched, disabled) => (jsxRuntimeExports.jsxs("div", { children: [jsxRuntimeExports.jsx("div", { role: 'group', "aria-labelledby": 'checkbox-group', className: `user-field__checkbox-container ${errors[name] && touched[name]
                ? 'user-field__checkbox-container--error'
                : ''}`, children: (validationRules === null || validationRules === void 0 ? void 0 : validationRules.checkboxText) && (jsxRuntimeExports.jsxs("div", { className: 'user-field__consent-checkbox', children: [jsxRuntimeExports.jsx(Field, { as: Checkbox, id: key, name: name, type: 'checkbox', value: '0', disabled: disabled, selectDataTestId: 'customFieldCheckbox' }, key), jsxRuntimeExports.jsx("label", { htmlFor: key, className: 'user-field__checkbox-label', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', children: validationRules.checkboxText }) })] }, key)) }, 'customConsentGroup'), touched[name] && getDisplayErrorMessage(label, errors[name]) && (jsxRuntimeExports.jsx(Typography, { variant: 'body_mini', className: 'user-field__error-message', children: `${name.charAt(0).toUpperCase() + name.slice(1)} is required` }))] }));
const renderPoliciesConsentGroup = (key, policiesConsentInnerComponentArray, disabled) => (jsxRuntimeExports.jsx("div", { role: 'group', "aria-labelledby": 'checkbox-group', className: 'user-field__checkbox-container', children: policiesConsentInnerComponentArray === null || policiesConsentInnerComponentArray === void 0 ? void 0 : policiesConsentInnerComponentArray.map((component, index) => (jsxRuntimeExports.jsxs("div", { className: 'user-field__consent-checkbox', children: [jsxRuntimeExports.jsx(Field, { copykey: key, as: Checkbox, id: `policiesConsent_${index}`, name: 'policiesConsentArray', type: 'checkbox', value: `${index}`, disabled: disabled }, `policiesConsent_${index}`), jsxRuntimeExports.jsx("label", { htmlFor: `policiesConsent_${index}`, className: 'user-field__checkbox-label', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', children: component }) })] }, `policiesConsent_${index}`))) }, 'policiesConsentGroup'));
const UserField = ({ fieldData: { validationRules, isCustom, key, label: defaultLabel, type, autoComplete, }, fieldSettings: { enabled, name, required, verify, label = defaultLabel }, errors, touched, disabled, policiesConsentInnerComponentArray, }) => {
    if (isCustom) {
        if (type === CustomFieldType.Select && (validationRules === null || validationRules === void 0 ? void 0 : validationRules.validOptions)) {
            const options = validationRules.validOptions.map((opt) => opt.label);
            return renderSelectField({
                dataTestId: 'customFieldSelect',
                disabled,
                key,
                label,
                name,
                options,
                type,
            }, { errors, touched });
        }
        else if (type === CustomFieldType.Checkbox) {
            return renderCheckboxGroup(key, name, label, validationRules, errors, touched, disabled);
        }
    }
    switch (name) {
        case 'tShirtSize':
            return renderSelectField({
                dataTestId: 'tShirtSizeSelect',
                disabled,
                key,
                label,
                name,
                options: tShirtSizes,
                type,
            }, { errors, touched });
        case 'team':
            return renderSelectField({
                dataTestId: 'teamSelect',
                disabled,
                key,
                label,
                name,
                options: teamNames,
                type,
            }, { errors, touched });
        case 'country':
            return renderSelectField({
                dataTestId: 'countrySelect',
                disabled,
                key,
                label,
                name,
                options: countryCodes.map((countryCode) => ({
                    label: countryCode.name,
                    value: countryCode.code,
                })),
                type,
            }, { errors, touched });
        case 'policiesConsent':
            return renderPoliciesConsentGroup(key, policiesConsentInnerComponentArray, disabled);
        case 'phoneNumber':
            return (jsxRuntimeExports.jsx(Field, { name: name, as: UserPhoneField, disabled: disabled, label: label, required: required, error: touched[name] && errors[name]
                    ? getDisplayErrorMessage(label, errors[name])
                    : undefined, verify: verify, autoComplete: autoComplete }, name));
        default:
            return (jsxRuntimeExports.jsx(Field, { copykey: key, disabled: disabled, as: Input, type: type, id: name, name: name, label: label, optional: enabled && !required, error: errors[name] && touched[name], message: touched[name] && getDisplayErrorMessage(label, errors[name]), autoComplete: autoComplete }, name));
    }
};

/**
 * Gets the message to display in a tooltip for this field
 */
const getTooltipMessageKeyForField = ({ enabled, name, lockForVerification, }) => {
    if (name === 'email' && !enabled)
        return 'dyn_collect_user_data.update_email_tooltip';
    if (name === 'phoneNumber' && !enabled)
        return 'dyn_collect_user_data.update_phone_number_tooltip';
    if (lockForVerification)
        return 'dyn_collect_user_data.lock_editing_multiple_verified_fields';
    return undefined;
};
const UserDataFields = ({ errors, policiesConsentInnerComponentArray, fields, touched, currentValues, disableEditingMultipleFieldsWithVerification, initialValues, }) => {
    const { fieldsConfig } = useFields();
    const { t } = useTranslation();
    /** Array of names of fields with verification enabled that the user has changed */
    const changedFieldsWithVerification = useMemo(() => initialValues && currentValues && fields
        ? fields
            .filter((field) => field.verify &&
            initialValues[field.name] !== currentValues[field.name])
            .map((field) => field.name)
        : [], [currentValues, fields, initialValues]);
    return (jsxRuntimeExports.jsx("div", { className: 'user-data-fields__fields-column', children: fields === null || fields === void 0 ? void 0 : fields.map((fieldSettings) => {
            const { enabled, name, verify } = fieldSettings;
            // Do not render name service field in the user fields section
            if (name === NAME_SERVICE_FIELD_NAME) {
                return undefined;
            }
            /**
             * Whether this field is disabled because we only want one field with verification
             * to be editable at once
             */
            const lockForVerification = disableEditingMultipleFieldsWithVerification &&
                verify &&
                changedFieldsWithVerification.length > 0 &&
                !changedFieldsWithVerification.includes(name);
            const disabled = !enabled || lockForVerification;
            const tooltipCopyKey = getTooltipMessageKeyForField({
                enabled,
                lockForVerification,
                name,
            });
            let fieldConfig;
            if (fieldSettings.type !== KycFieldType.Custom) {
                fieldConfig = fieldsConfig[name];
            }
            else {
                fieldConfig = {
                    isCustom: true,
                    key: fieldSettings.name,
                    label: fieldSettings.name,
                    type: fieldSettings.validationType,
                    validation: customFieldValidationMap[fieldSettings.validationType],
                    validationRules: fieldSettings.validationRules,
                };
            }
            const userField = (jsxRuntimeExports.jsx(UserField, { disabled: Boolean(disabled), errors: errors, fieldData: fieldConfig, fieldSettings: fieldSettings, touched: touched, policiesConsentInnerComponentArray: policiesConsentInnerComponentArray }, fieldConfig.key));
            if (tooltipCopyKey)
                return (jsxRuntimeExports.jsx(Tooltip, { content: t(tooltipCopyKey), className: 'user-data-fields__tooltip', copykey: tooltipCopyKey, children: userField }, fieldConfig.key + '__tooltip'));
            return userField;
        }) }));
};

const useDebounce = (callback, timeout) => {
    const timeoutId = useRef(null);
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    return useCallback(((...params) => {
        if (timeoutId.current) {
            clearTimeout(timeoutId.current);
        }
        timeoutId.current = window.setTimeout(() => {
            callbackRef.current(...params);
        }, timeout);
    }), [timeout]);
};

const SubdomainField = ({ showDetails = false, }) => {
    const { t } = useTranslation();
    const { values, setFieldValue, initialValues } = useFormikContext();
    const checkSubdomain = useSubdomainCheck();
    const { projectSettings } = useInternalDynamicContext();
    const [checkResponse, setCheckResponse] = useState(undefined);
    // When the subdomain is saved, the value is stored in a metadata object
    // instead, so we need to default to the initial value to prevent the
    // value from disappearing
    const subDomainValue = useMemo(() => values['name-service-subdomain-handle'] === undefined
        ? initialValues['name-service-subdomain-handle'] || ''
        : values['name-service-subdomain-handle'], [values, initialValues]);
    const ensDomain = useMemo(() => {
        var _a;
        const domain = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.nameService) === null || _a === void 0 ? void 0 : _a.evm.domain;
        if (!domain) {
            return undefined;
        }
        return `.${domain}`;
    }, [projectSettings]);
    const runCheckSubdomain = useCallback((value) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (value !== '' &&
            value !== initialValues['name-service-subdomain-handle']) {
            const checkReponse = yield checkSubdomain({
                subdomain: value,
            });
            setCheckResponse(checkReponse);
        }
        else {
            setCheckResponse(undefined);
        }
    }), [checkSubdomain, initialValues]);
    const debouncedCheckSubdomain = useDebounce(runCheckSubdomain, 500);
    const onChange = (e) => __awaiter$1(void 0, void 0, void 0, function* () {
        setFieldValue('name-service-subdomain-handle', e.target.value);
        debouncedCheckSubdomain(e.target.value);
    });
    const message = useMemo(() => {
        if (!checkResponse) {
            return undefined;
        }
        if (checkResponse === null || checkResponse === void 0 ? void 0 : checkResponse.error) {
            return t('dyn_subdomain_field.error');
        }
        if (!(checkResponse === null || checkResponse === void 0 ? void 0 : checkResponse.available)) {
            return t('dyn_subdomain_field.not_available');
        }
        return t('dyn_subdomain_field.available');
    }, [checkResponse, t]);
    if (!ensDomain) {
        logger$1.error('Failed to get ENS domain from settings.sdk.nameService');
        return null;
    }
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("div", { className: 'subdomain-field__container', children: [jsxRuntimeExports.jsx(Input, { id: 'subdomain-field', className: 'input__container--available', value: subDomainValue, onChange: onChange, label: t('dyn_subdomain_field.label'), error: message && !(checkResponse === null || checkResponse === void 0 ? void 0 : checkResponse.available) ? true : false, success: checkResponse === null || checkResponse === void 0 ? void 0 : checkResponse.available, message: message }), jsxRuntimeExports.jsx(Typography, { as: 'span', color: 'secondary', variant: 'body_normal', children: ensDomain })] }), showDetails && (jsxRuntimeExports.jsx(Typography, { as: 'p', color: 'secondary', variant: 'body_small', className: 'subdomain-field__details', children: t('dyn_subdomain_field.details') })), jsxRuntimeExports.jsx(Divider, {})] }));
};

const UserProfileForm = ({ filterFields, formClassName, fieldsContainerStyle, onEditProfileSubmit, onEditProfileCancel, options = {
    buttonsAsFooter: true,
    cancelText: 'Cancel',
    shouldEnforcePolicies: false,
    submitText: 'Save',
}, }) => {
    const { projectSettings, user } = useInternalDynamicContext();
    const targetFields = useMemo(() => {
        const allUserFields = getUserProfileFields({
            customFields: projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.customFields,
            projectSettingsKyc: projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.kyc,
            user,
        });
        if (!filterFields)
            return allUserFields;
        return allUserFields.filter(({ name }) => filterFields.includes(name));
    }, [filterFields, projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.customFields, projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.kyc, user]);
    const { fetch, formikInitialValues, formikValidationSchema, onFormSubmit } = useUserDataForm({
        fields: targetFields,
        onSubmit: onEditProfileSubmit,
        shouldEnforcePolicies: options.shouldEnforcePolicies,
        userProfile: user,
    });
    const showNameServiceField = useMemo(() => targetFields.some((field) => field.name === NAME_SERVICE_FIELD_NAME), [targetFields]);
    const makeButtonsContent = (isSubmitting, isValid, dirty) => (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [!options.hideCancelButton && (jsxRuntimeExports.jsx(TypographyButton, Object.assign({ disabled: fetch, expanded: true, buttonPadding: 'medium', buttonVariant: 'secondary', type: 'button', typographyProps: { variant: 'button_secondary' }, onClick: onEditProfileCancel, dataTestId: 'cancel-button' }, options.cancelButtonProps, { children: options.cancelText }))), jsxRuntimeExports.jsx(TypographyButton, Object.assign({ buttonClassName: 'dynamic-widget-footer__button', disabled: fetch || !isValid || !dirty, expanded: true, type: 'submit', buttonPadding: 'medium', typographyProps: { variant: 'button_secondary' }, loading: isSubmitting, startSlot: jsxRuntimeExports.jsx(SvgCheck, {}), dataTestId: 'submit-button' }, options.submitButtonProps, { children: options.submitText }))] }));
    return (jsxRuntimeExports.jsx(Formik, { onSubmit: onFormSubmit, initialValues: formikInitialValues, validationSchema: formikValidationSchema, validateOnChange: true, children: ({ errors, touched, isSubmitting, isValid, dirty, values }) => (jsxRuntimeExports.jsxs(Form, { className: classNames('dynamic-widget-edit-profile-view', formClassName), "data-testid": 'editUserProfileForm', children: [jsxRuntimeExports.jsxs("div", { className: 'dynamic-widget-edit-profile-view__fields', style: fieldsContainerStyle, children: [showNameServiceField && jsxRuntimeExports.jsx(SubdomainField, {}), jsxRuntimeExports.jsx(UserDataFields, { errors: errors, fields: targetFields, touched: touched, currentValues: values, initialValues: formikInitialValues, disableEditingMultipleFieldsWithVerification: true })] }), options.buttonsAsFooter ? (jsxRuntimeExports.jsx(DynamicWidgetFooter, { children: makeButtonsContent(isSubmitting, isValid, dirty) })) : (makeButtonsContent(isSubmitting, isValid, dirty))] })) }));
};

// Source: https://stackoverflow.com/questions/18379254/regex-to-split-camel-case
const splitCamelCase = (text) => text.replace(/([a-z])([A-Z])/g, '$1 $2');

/** This function assigns the default values for the modal's text components */
const useAssignDefaultValues = (texts, fields) => {
    const { appName, user } = useInternalDynamicContext();
    const appDisplay = appName ? `${appName} ` : '';
    // This is fixed
    if (!texts.submitText)
        texts.submitText = 'Update';
    // Others depend on the fields
    if (fields.length !== 1) {
        if (!texts.title)
            texts.title = 'Update your info';
        if (!texts.subtitle)
            texts.subtitle = `Fill out your info for your ${appDisplay}account`;
        return texts;
    }
    const [field] = fields;
    const fieldDisplay = splitCamelCase(field).toLowerCase();
    // If the field already has some value, use the word "update"
    const titleAction = (user === null || user === void 0 ? void 0 : user[field]) ? 'Update' : 'Enter';
    if (!texts.title)
        texts.title = `${titleAction} your ${fieldDisplay}`;
    if (!texts.subtitle)
        texts.subtitle = `Add your ${fieldDisplay} to your ${appDisplay}account`;
    return texts;
};

var _path$Y;
var _excluded$15 = ["title", "titleId"];
function _extends$15() { return _extends$15 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$15.apply(null, arguments); }
function _objectWithoutProperties$15(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$15(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$15(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgAt = function SvgAt(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$15(_ref, _excluded$15);
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$Y || (_path$Y = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a8 8 0 1 0 4 14.928 1 1 0 1 1 1 1.732A9.96 9.96 0 0 1 11.942 22C6.446 21.968 2 17.503 2 12 2 6.477 6.477 2 12 2s10 4.477 10 10v1.5a3.5 3.5 0 0 1-6.396 1.966A5 5 0 1 1 17 12v1.5a1.5 1.5 0 0 0 3 0V12a8 8 0 0 0-8-8Zm3 8a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z",
    fill: "currentColor"
  })));
};

var _path$X;
var _excluded$14 = ["title", "titleId"];
function _extends$14() { return _extends$14 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$14.apply(null, arguments); }
function _objectWithoutProperties$14(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$14(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$14(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgJustifiedText = function SvgJustifiedText(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$14(_ref, _excluded$14);
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$X || (_path$X = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h16a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Zm0 6a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  })));
};

var _path$W;
var _excluded$13 = ["title", "titleId"];
function _extends$13() { return _extends$13 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$13.apply(null, arguments); }
function _objectWithoutProperties$13(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$13(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$13(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgLocation = function SvgLocation(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$13(_ref, _excluded$13);
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$W || (_path$W = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6 8.067a9.333 9.333 0 0 0-13.2 13.2l5.658 5.657c.52.52 1.363.52 1.884 0l5.658-5.658a9.333 9.333 0 0 0 0-13.199ZM7.515 6.181c4.686-4.686 12.284-4.686 16.97 0 4.687 4.687 4.687 12.285 0 16.97l-4.67 4.67c-.041.042.019-.018-.023.024l-.964.964a3.998 3.998 0 0 1-5.655 0l-5.658-5.657c-4.687-4.686-4.687-12.284 0-16.97ZM16 12a2.667 2.667 0 1 0 0 5.333A2.667 2.667 0 0 0 16 12Zm-5.333 2.667a5.333 5.333 0 1 1 10.666 0 5.333 5.333 0 0 1-10.666 0Z",
    fill: "currentColor"
  })));
};

var _path$V;
var _excluded$12 = ["title", "titleId"];
function _extends$12() { return _extends$12 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$12.apply(null, arguments); }
function _objectWithoutProperties$12(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$12(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$12(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgMail = function SvgMail(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$12(_ref, _excluded$12);
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$V || (_path$V = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm2 2.869V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9.869l-6.336 4.223a3 3 0 0 1-3.328 0L4 9.87Zm16-2.404-7.445 4.963a1 1 0 0 1-1.11 0L4 7.465V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v.465Z",
    fill: "currentColor"
  })));
};

var _path$U;
var _excluded$11 = ["title", "titleId"];
function _extends$11() { return _extends$11 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$11.apply(null, arguments); }
function _objectWithoutProperties$11(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$11(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$11(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgPhone = function SvgPhone(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$11(_ref, _excluded$11);
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$U || (_path$U = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H8a3 3 0 0 1-3-3V5Zm3-1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H8Zm3 14a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  })));
};

var _path$T;
var _excluded$10 = ["title", "titleId"];
function _extends$10() { return _extends$10 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$10.apply(null, arguments); }
function _objectWithoutProperties$10(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$10(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$10(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSizeLabels = function SvgSizeLabels(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$10(_ref, _excluded$10);
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$T || (_path$T = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5a3 3 0 0 1 3-3h4a3 3 0 0 1 3 2.93 3 3 0 0 1 4.192.05l2.829 2.828A3 3 0 0 1 19.069 12 3 3 0 0 1 22 15v4a3 3 0 0 1-3 3H7a5 5 0 0 1-5-5V5Zm9.071 15H19a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1.929l-6 6Zm4.878-7.707h.001l1.657-1.657a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 0 0-1.414 0L12 7.757v8.486l3.95-3.95ZM9.123 19.12A2.99 2.99 0 0 0 10 17V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a3 3 0 0 0 5.123 2.12ZM6 17a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  })));
};

var _path$S;
var _excluded$$ = ["title", "titleId"];
function _extends$$() { return _extends$$ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$$.apply(null, arguments); }
function _objectWithoutProperties$$(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$$(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$$(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgUserCard = function SvgUserCard(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$$(_ref, _excluded$$);
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$S || (_path$S = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5a3 3 0 1 1 6 0h4a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h4Zm.17 2H5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-4.17a3.001 3.001 0 0 1-5.66 0ZM12 4a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0V5a1 1 0 0 0-1-1Zm-3 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm2.4 2.8a3 3 0 1 0-4.8 0 4.01 4.01 0 0 0-1.372 1.867 1 1 0 1 0 1.885.666 2.001 2.001 0 0 1 3.773 0 1 1 0 1 0 1.886-.666A4.01 4.01 0 0 0 11.4 13.8ZM14 11a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Zm0 4a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  })));
};

var _path$R;
var _excluded$_ = ["title", "titleId"];
function _extends$_() { return _extends$_ = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$_.apply(null, arguments); }
function _objectWithoutProperties$_(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$_(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$_(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgUser = function SvgUser(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$_(_ref, _excluded$_);
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$R || (_path$R = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a8 8 0 0 0-6.598 12.526A14.943 14.943 0 0 1 12 15c2.366 0 4.606.548 6.598 1.526A8 8 0 0 0 12 4Zm7.654 14.436A9.96 9.96 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.96 9.96 0 0 0 2.37 6.464A9.978 9.978 0 0 0 12 22a9.978 9.978 0 0 0 7.654-3.564ZM17.2 18.08A12.954 12.954 0 0 0 12 17c-1.85 0-3.607.386-5.199 1.08A7.968 7.968 0 0 0 12 20c1.985 0 3.8-.723 5.199-1.92ZM12 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "currentColor"
  })));
};

var _path$Q;
var _excluded$Z = ["title", "titleId"];
function _extends$Z() { return _extends$Z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$Z.apply(null, arguments); }
function _objectWithoutProperties$Z(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$Z(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$Z(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgWorkSuitcase = function SvgWorkSuitcase(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$Z(_ref, _excluded$Z);
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$Q || (_path$Q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1h2a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h2V4ZM5 7a1 1 0 0 0-1 1v4.57A22.95 22.95 0 0 0 12 14c2.815 0 5.51-.505 8-1.43V8a1 1 0 0 0-1-1H5Zm10-2H9V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1Zm5 9.692A24.971 24.971 0 0 1 12 16c-2.796 0-5.487-.46-8-1.308V18a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3.308ZM11 12a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H12a1 1 0 0 1-1-1Z",
    fill: "currentColor"
  })));
};

/** Maps fields names to Icon components */
const mapFieldToIcon = {
    alias: SvgUser,
    country: SvgLocation,
    email: SvgMail,
    firstName: SvgUserCard,
    jobTitle: SvgWorkSuitcase,
    lastName: SvgUserCard,
    phoneNumber: SvgPhone,
    tShirtSize: SvgSizeLabels,
    username: SvgAt,
};
const UserFieldsToIcon = ({ fields, className, }) => {
    // When there are more than 1 fields, we use a generic icon
    const Icon = fields.length === 1 ? mapFieldToIcon[fields[0]] : undefined;
    if (!Icon)
        return jsxRuntimeExports.jsx(SvgJustifiedText, { className: className });
    return jsxRuntimeExports.jsx(Icon, { className: className });
};

const UserFieldEditorView = ({ onClickClose, onSubmit, fields, submitText, subtitle, title, }) => {
    // Treat undefined props
    ({ submitText, subtitle, title } = useAssignDefaultValues({ submitText, subtitle, title }, fields));
    const closeButton = onClickClose && (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: onClickClose, "data-testid": 'close-button', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(ModalHeader, { alignContent: 'bottom', trailing: closeButton, children: jsxRuntimeExports.jsxs("div", { className: 'user-field-editor__header', children: [jsxRuntimeExports.jsx("div", { className: 'user-field-editor__header__icon', children: jsxRuntimeExports.jsx(Icon, { color: 'brand-primary', size: 'large', children: jsxRuntimeExports.jsx(UserFieldsToIcon, { fields: fields }) }) }), title && (jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', children: title }))] }) }), jsxRuntimeExports.jsxs("div", { className: 'user-field-editor__body', children: [subtitle && (jsxRuntimeExports.jsx(Typography, { className: 'user-field-editor__body__subtitle', variant: 'body_normal', color: 'secondary', children: subtitle })), jsxRuntimeExports.jsx(UserProfileForm, { filterFields: fields, onEditProfileSubmit: onSubmit, formClassName: 'user-field-editor__body__form', fieldsContainerStyle: { padding: 0 }, options: {
                            buttonsAsFooter: false,
                            hideCancelButton: true,
                            submitButtonProps: {
                                buttonPadding: 'large',
                                startSlot: undefined,
                                typographyProps: { variant: 'button_primary' },
                            },
                            submitText,
                        } })] }), jsxRuntimeExports.jsx(PoweredByDynamic, { asFooter: true })] }));
};

const UserFieldEditorModal = (_a) => {
    var { onCancel, onSubmit, fields } = _a, textOptions = __rest(_a, ["onCancel", "onSubmit", "fields"]);
    const [show, setShow] = useState(true);
    /** Whether onCancel or onSubmit has been called */
    const alreadyResolved = useRef(false);
    const handleOnModalUnmount = useCallback(() => {
        if (!alreadyResolved.current)
            onCancel('User cancelled');
        alreadyResolved.current = true;
    }, [onCancel]);
    const onAccept = (newValues) => __awaiter$1(void 0, void 0, void 0, function* () {
        return onSubmit(newValues).then(() => {
            // Close modal but prevent onCancel from being called
            alreadyResolved.current = true;
            setShow(false);
        });
    });
    const cancelAndClose = () => setShow(false);
    return (jsxRuntimeExports.jsx(Portal, { handleClose: cancelAndClose, isShown: show, zIndex: authModalZIndex, withBackdrop: true, elementId: 'dynamic-edit-user-field', transitionEvents: {
            onUnmount: handleOnModalUnmount,
        }, children: jsxRuntimeExports.jsx(Modal, { children: jsxRuntimeExports.jsx(ModalCard, { children: jsxRuntimeExports.jsx(UserFieldEditorView, Object.assign({ onSubmit: onAccept, onClickClose: cancelAndClose, fields: fields }, textOptions)) }) }) }));
};

const DynamicBaseWidget = ({ children, shadowDOMProps }) => (jsxRuntimeExports.jsx(ShadowDOM, Object.assign({}, shadowDOMProps, { children: jsxRuntimeExports.jsx(PopperProvider, { children: children }) })));

const UserFieldEditorContext = createContext(undefined);
const UserFieldEditorContextProvider = ({ children, }) => {
    const { modal, open } = useConfirmationModal({
        elementId: 'dynamic-edit-user-field',
    });
    /** Links the modal's actions to "open"'s resolve and reject */
    const openUserFieldEditor = useCallback((modalProps, applyChanges) => __awaiter$1(void 0, void 0, void 0, function* () {
        return open((resolve, reject) => {
            const onSubmit = (fields) => applyChanges(fields).then((result) => resolve({ fields, updateUserResult: result }));
            return (jsxRuntimeExports.jsx(DynamicBaseWidget, { children: jsxRuntimeExports.jsx(UserFieldEditorModal, { fields: modalProps.fields, submitText: modalProps.submitText, title: modalProps.title, subtitle: modalProps.subtitle, onCancel: reject, onSubmit: onSubmit }) }));
        });
    }), [open]);
    const value = useMemo(() => ({ open: openUserFieldEditor }), [openUserFieldEditor]);
    return (jsxRuntimeExports.jsxs(UserFieldEditorContext.Provider, { value: value, children: [modal, children] }));
};

const VerticalAccordion = ({ children, className, style, }) => (jsxRuntimeExports.jsx("div", { className: classNames(className, 'vertical-accordion__container'), style: style, children: children }));

const isUserLinkingWallet = (user, view, isMockedSDK) => (user === null || user === void 0 ? void 0 : user.verifiedCredentials) !== undefined &&
    view === 'multi-wallet-wallet-list' &&
    // Mocked SDK is used in the dashboard and the user is
    // the actual user that the user logged in to the dashboard
    !isMockedSDK;

const useDynamicLayoutData = ({ view, authMode, }) => {
    const { t } = useTranslation();
    const { isTurnkeyWalletWithoutAuthenticator } = useIsTurnkeyWallet();
    const { selectedWalletConnector } = useInternalDynamicContext();
    const helpHeaderMap = useMemo(() => ({
        'login-with-email-or-wallet-full-wallet-list': {
            copykey: 'dyn_login.helper.all_wallet_list',
            heading: t('dyn_login.helper.all_wallet_list'),
        },
        'login-with-wallet-only': {
            copykey: 'dyn_login.helper.wallet_only',
            heading: t('dyn_login.helper.wallet_only'),
        },
        'passkey-intro': {
            copykey: 'dyn_passkey_intro.helper.title',
            heading: t('dyn_passkey_intro.helper.title'),
        },
        'pending-connect': {
            copykey: 'dyn_login.helper.pending_connect.title',
            heading: t('dyn_login.helper.pending_connect.title'),
        },
        'pending-signature': {
            copykey: 'dyn_login.helper.pending_signature.title',
            heading: t('dyn_login.helper.pending_signature.title'),
        },
        'pending-signature-without-back-button': {
            copykey: 'dyn_login.helper.pending_signature_without_back_button.title',
            heading: t('dyn_login.helper.pending_signature_without_back_button.title'),
        },
        'qr-code': {
            copykey: 'dyn_login.helper.qr_code.title',
            heading: t('dyn_login.helper.qr_code.title'),
        },
        'wallet-connect-mobile-wallets-list': {
            copykey: 'dyn_wallet_conect.mobile.wallet_list.helper',
            heading: t('dyn_wallet_conect.mobile.wallet_list.helper'),
        },
        'wallet-list': {
            copykey: 'dyn_wallet_list.helper',
            heading: t('dyn_wallet_list.helper'),
        },
    }), [t]);
    const headerMap = useMemo(() => {
        var _a;
        return ({
            'account-exists': {
                copykey: 'dyn_account_exists.title',
                heading: t('dyn_account_exists.title'),
            },
            'chainalysis-blocked-wallet': {
                copykey: 'dyn_chainalysis_blocked_wallet.title',
                heading: t('dyn_chainalysis_blocked_wallet.title'),
            },
            'deposit-view': {
                copykey: 'dyn_deposit.title',
                heading: t('dyn_deposit.title'),
            },
            'embedded-delete-view': {
                copykey: 'dyn_embedded_delete.title',
                heading: t('dyn_embedded_delete.title'),
            },
            'embedded-wallet-exists': {
                copykey: 'dyn_wallet_link.already_exists.title',
                heading: t('dyn_wallet_link.already_exists.title'),
            },
            'external-funding-wallet-list': {
                copykey: 'dyn_wallet_funding.from_external_wallet.wallet_list.title',
                heading: t('dyn_wallet_funding.from_external_wallet.wallet_list.title'),
            },
            'farcaster-connect-view': {
                copykey: 'dyn_login.qr_code.title',
                heading: t('dyn_login.qr_code.title'),
            },
            'login-with-email-or-wallet': {
                copykey: 'dyn_login.title.all',
                heading: t('dyn_login.title.all'),
            },
            'login-with-email-or-wallet-full-wallet-list': {
                copykey: 'dyn_login.title.all_wallet_list',
                heading: t('dyn_login.title.all_wallet_list'),
            },
            'login-with-email-verification': {
                copykey: 'dyn_otp_verification.confirm_code',
                heading: t('dyn_otp_verification.confirm_code'),
            },
            'login-with-sms-verification': {
                copykey: 'dyn_otp_verification.confirm_code',
                heading: t('dyn_otp_verification.confirm_code'),
            },
            'login-with-wallet-only': {
                copykey: 'dyn_login.title.wallet_only',
                heading: t('dyn_login.title.wallet_only'),
            },
            'merge-user-accounts': {
                copykey: 'dyn_merge_user_accounts.wallet.title',
                heading: t('dyn_merge_user_accounts.wallet.title'),
            },
            'merge-user-accounts-conflicts': {
                copykey: 'dyn_merge_user_accounts_conflicts.title',
                heading: t('dyn_merge_user_accounts_conflicts.title'),
            },
            'mfa-choose-device': {
                copykey: 'dyn_mfa.choose_device_view.title',
                heading: t('dyn_mfa.choose_device_view.title'),
            },
            'mfa-display-backup-codes': {
                copykey: 'dyn_mfa.display_backup_codes_view.title',
                heading: t('dyn_mfa.display_backup_codes_view.title'),
            },
            'mfa-recovery': {
                copykey: 'dyn_mfa.recovery_view.title',
                heading: t('dyn_mfa.recovery_view.title'),
            },
            'mfa-secure-device': {
                copykey: 'dyn_mfa.secure_device_view.title',
                heading: t('dyn_mfa.secure_device_view.title'),
            },
            'mfa-secure-device-help': {
                copykey: 'dyn_mfa.secure_device_view.helper.title',
                heading: t('dyn_mfa.secure_device_view.helper.title'),
            },
            'mfa-verification': {
                copykey: 'dyn_mfa.otp_verification_view.title',
                heading: t('dyn_mfa.otp_verification_view.title'),
            },
            'mobile-wallet-redirect-view': {
                copykey: 'dyn_login.mobile_wallet_redirect.backup_title',
                heading: (_a = selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.name) !== null && _a !== void 0 ? _a : t('dyn_login.mobile_wallet_redirect.backup_title'),
            },
            'multi-wallet-wallet-list': {
                copykey: authMode === 'connect-only'
                    ? 'dyn_wallet_list.title.connect'
                    : 'dyn_wallet_list.title.link',
                heading: authMode === 'connect-only'
                    ? t('dyn_wallet_list.title.connect')
                    : t('dyn_wallet_list.title.link'),
            },
            'network-not-supported': {
                copykey: 'dyn_network_not_supported.title',
                heading: t('dyn_network_not_supported.title'),
            },
            'passkey-recovery-complete': {
                copykey: isTurnkeyWalletWithoutAuthenticator
                    ? 'dyn_passkey_secure_modal.complete.title'
                    : 'dyn_passkey_recovery.complete.title',
                heading: isTurnkeyWalletWithoutAuthenticator
                    ? t('dyn_passkey_secure_modal.complete.title')
                    : t('dyn_passkey_recovery.complete.title'),
            },
            'passkey-recovery-start': {
                copykey: isTurnkeyWalletWithoutAuthenticator
                    ? 'dyn_passkey_secure_modal.start.title'
                    : 'dyn_passkey_recovery.start.title',
                heading: isTurnkeyWalletWithoutAuthenticator
                    ? t('dyn_passkey_secure_modal.start.title')
                    : t('dyn_passkey_recovery.start.title'),
            },
            'pending-connect': {
                copykey: 'dyn_login.connect_wallet.title',
                heading: t('dyn_login.connect_wallet.title'),
            },
            'pending-signature': {
                copykey: 'dyn_login.sign_wallet.title',
                heading: t('dyn_login.sign_wallet.title'),
            },
            'qr-code': {
                copykey: 'dyn_login.qr_code.title',
                heading: t('dyn_login.qr_code.title'),
            },
            'select-hardware-wallet': {
                copykey: 'dyn_select_hardware_wallet.title',
                heading: t('dyn_select_hardware_wallet.title'),
            },
            'select-wallet-in-wallet-group': {
                copykey: 'dyn_login.select_wallet_in_wallet_group.title',
                heading: t('dyn_login.select_wallet_in_wallet_group.title'),
            },
            'verify-email': {
                copykey: 'dyn_otp_verification.confirm_code',
                heading: t('dyn_otp_verification.confirm_code'),
            },
            'verify-sms': {
                copykey: 'dyn_otp_verification.confirm_code',
                heading: t('dyn_otp_verification.confirm_code'),
            },
            'wallet-connect-mobile-wallets-list': {
                copykey: 'dyn_wallet_conect.mobile.wallet_list.title',
                heading: (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(WalletConnectIcon, { style: { height: '1.5rem', width: '1.5rem' } }), ' ', t('dyn_wallet_conect.mobile.wallet_list.title')] })),
            },
            'wallet-group': {
                copykey: 'dyn_login.wallet_group.title',
                heading: t('dyn_login.wallet_group.title'),
            },
            'wallet-list': {
                copykey: 'dyn_wallet_list.title.select',
                heading: t('dyn_wallet_list.title.select'),
            },
            'wallet-sign': {
                copykey: 'dyn_wallet_transfer.sign.title',
                heading: t('dyn_wallet_transfer.sign.title'),
            },
            'wallet-used': {
                copykey: 'dyn_wallet_link.title',
                heading: t('dyn_wallet_link.title'),
            },
        });
    }, [
        authMode,
        isTurnkeyWalletWithoutAuthenticator,
        selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.name,
        t,
    ]);
    const descriptionMap = useMemo(() => ({}), []);
    if (view === 'no-access') {
        const headerData = {
            copykey: 'dyn_no_access.title',
            heading: t('dyn_no_access.title'),
        };
        return { headerData };
    }
    if (view === 'access-blocked') {
        const headerData = {
            copykey: 'dyn_access_blocked.title',
            heading: t('dyn_access_blocked.title'),
        };
        return { headerData };
    }
    const helpHeaderData = helpHeaderMap[view];
    const headerData = headerMap[view];
    const descriptionData = descriptionMap[view];
    return {
        descriptionData,
        headerData,
        helpHeaderData,
    };
};

const useAuthLayoutChecks = () => {
    var _a;
    const { view } = useViewContext();
    const { user, customPrivacyPolicy, customTermsOfServices, privacyPolicyUrl, termsOfServiceUrl, isBridgeFlow, authMode, projectSettings, } = useInternalDynamicContext();
    const { isFooterExpanded } = useFooterAnimationContext();
    const { mockedSDK } = useMockContext();
    const { helpHeaderData } = useDynamicLayoutData({
        authMode,
        view: view.type,
    });
    const displayBorderBelowHeader = (view.type !== 'wallet-list' &&
        view.type !== 'login-with-email-or-wallet-full-wallet-list' &&
        view.type !== 'multi-wallet-wallet-list' &&
        view.type !== 'login-with-wallet-only') ||
        isFooterExpanded;
    const isWalletListTypeView = view.type === 'wallet-connect-mobile-wallets-list' ||
        view.type === 'wallet-list' ||
        view.type === 'login-with-email-or-wallet-full-wallet-list' ||
        view.type === 'login-with-wallet-only';
    const showHelpContent = Boolean(helpHeaderData &&
        // Notice the negation here
        !(view.type === 'qr-code' ||
            view.type === 'no-qr-not-installed' ||
            view.type === 'wallet-used' ||
            view.type === 'chainalysis-blocked-wallet' ||
            view.type === 'wallet-sign' ||
            view.type === 'collect-user-data' ||
            view.type === 'passkey-new-domain-detected' ||
            isUserLinkingWallet(user, view.type, mockedSDK)));
    const showHeader = view.type !== 'collect-user-data' &&
        view.type !== 'no-access' &&
        view.type !== 'chainalysis-blocked-wallet' &&
        view.type !== 'wallet-locked-view' &&
        view.type !== 'gate-blocked-wallet' &&
        view.type !== 'email-wallet-otp-verification-view' &&
        view.type !== 'bridge-welcome' &&
        view.type !== 'bridge-summary' &&
        view.type !== 'bridge-next-wallet-connection' &&
        view.type !== 'passkey-intro' &&
        view.type !== 'passkey-new-domain-detected' &&
        view.type !== 'social-redirect-view' &&
        view.type !== 'collect-user-data-login-no-wallet' &&
        view.type !== 'passkey-recovery-bundle' &&
        view.type !== 'passkey-recovery-start' &&
        view.type !== 'embedded-reveal-view' &&
        view.type !== 'embedded-reveal-account-view' &&
        view.type !== 'rename-passkey' &&
        view.type !== 'embedded-wallet-auth-choice' &&
        view.type !== 'passkey-recovery-add-email' &&
        view.type !== 'global-wallet-confirm' &&
        view.type !== 'global-wallet-malicious' &&
        view.type !== 'global-wallet-info' &&
        view.type !== 'mfa-choose-device' &&
        view.type !== 'mfa-verification';
    const showConnectedWalletProgress = isBridgeFlow &&
        (view.type === 'wallet-list' ||
            view.type === 'qr-code' ||
            view.type === 'wallet-connect-mobile-wallets-list' ||
            view.type === 'pending-connect' ||
            view.type === 'pending-signature' ||
            view.type === 'pending-signature-without-back-button' ||
            view.type === 'bridge-next-wallet-connection' ||
            view.type === 'bridge-summary');
    const showToSFooter = Boolean(!isUserLinkingWallet(user, view.type, mockedSDK) &&
        (view.type === 'wallet-list' ||
            view.type === 'wallet-connect-mobile-wallets-list' ||
            // Don't show empty footer during the login
            ((view.type === 'login-with-email-or-wallet' ||
                view.type === 'login-with-email-or-wallet-full-wallet-list' ||
                view.type === 'login-with-wallet-only' ||
                view.type === 'multi-wallet-wallet-list') &&
                (termsOfServiceUrl ||
                    privacyPolicyUrl ||
                    customPrivacyPolicy ||
                    customTermsOfServices))));
    const showDynamicFooter = Boolean((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _a === void 0 ? void 0 : _a.displayDynamicMessaging) &&
        (view.type === 'login-with-email-or-wallet' ||
            view.type === 'login-with-email-or-wallet-full-wallet-list' ||
            view.type === 'login-with-wallet-only' ||
            view.type === 'login-with-email-verification' ||
            view.type === 'login-with-sms-verification' ||
            view.type === 'verify-email' ||
            view.type === 'verify-sms' ||
            view.type === 'pending-connect' ||
            view.type === 'wallet-group' ||
            view.type === 'select-wallet-in-wallet-group' ||
            view.type === 'select-hardware-wallet' ||
            view.type === 'pending-signature' ||
            view.type === 'qr-code' ||
            view.type === 'wallet-used' ||
            view.type === 'email-wallet-otp-verification-view' ||
            view.type === 'farcaster-connect-view' ||
            view.type === 'merge-user-accounts' ||
            view.type === 'merge-user-accounts-conflicts' ||
            view.type === 'mfa-verification' ||
            view.type === 'mfa-display-backup-codes' ||
            view.type === 'mfa-recovery');
    const showCloseButton = view.type !== 'login-with-email-or-wallet-full-wallet-list' &&
        view.type !== 'login-with-email-verification' &&
        view.type !== 'login-with-sms-verification' &&
        view.type !== 'network-not-supported' &&
        view.type !== 'passkey-recovery-complete' &&
        view.type !== 'passkey-recovery-start' &&
        view.type !== 'passkey-recovery-bundle' &&
        view.type !== 'rename-passkey' &&
        view.type !== 'mobile-wallet-redirect-view' &&
        view.type !== 'qr-code' &&
        view.type !== 'mfa-verification' &&
        view.type !== 'mfa-display-backup-codes' &&
        view.type !== 'mfa-recovery';
    const showDefaultFooter = !showConnectedWalletProgress && !showDynamicFooter && !showToSFooter;
    const shouldHideDynamicFooterSeparator = showDynamicFooter && showToSFooter;
    return {
        displayBorderBelowHeader,
        isWalletListTypeView,
        shouldHideDynamicFooterSeparator,
        showCloseButton,
        showConnectedWalletProgress,
        showDefaultFooter,
        showDynamicFooter,
        showHeader,
        showHelpContent,
        showToSFooter,
    };
};

const DynamicFooter = () => {
    const { shouldHideDynamicFooterSeparator } = useAuthLayoutChecks();
    return (jsxRuntimeExports.jsx("div", { "data-testid": 'dynamic-footer', className: classNames('dynamic-footer', {
            'dynamic-footer__top-border': !shouldHideDynamicFooterSeparator,
        }), children: jsxRuntimeExports.jsx(PoweredByDynamic, {}) }));
};

var _path$P, _path2$3;
var _excluded$Y = ["title", "titleId"];
function _extends$Y() { return _extends$Y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$Y.apply(null, arguments); }
function _objectWithoutProperties$Y(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$Y(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$Y(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgQuestionMark = function SvgQuestionMark(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$Y(_ref, _excluded$Y);
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$P || (_path$P = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.25a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM1.667 10a8.333 8.333 0 1 1 16.666 0 8.333 8.333 0 0 1-16.666 0Z",
    fill: "currentcolor"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.31 7.044a1.784 1.784 0 0 0-1.133.192 1.513 1.513 0 0 0-.699.783.792.792 0 0 1-1.481-.559c.26-.689.768-1.257 1.42-1.613a3.368 3.368 0 0 1 2.144-.367 3.262 3.262 0 0 1 1.908 1.023c.496.55.775 1.254.774 1.99 0 1.201-.948 1.972-1.587 2.369a6.63 6.63 0 0 1-1.354.635l-.028.01-.008.002h-.003l-.002.001-.235-.756.235.756A.792.792 0 0 1 9.789 10h.001m0 0 .014-.005.06-.021a5.054 5.054 0 0 0 .956-.456c.575-.357.84-.717.84-1.024 0-.332-.125-.66-.367-.928a1.68 1.68 0 0 0-.982-.521M9.265 13.77c0-.438.355-.792.792-.792h.01a.792.792 0 1 1 0 1.584h-.01a.792.792 0 0 1-.792-.792Z",
    fill: "currentcolor"
  })));
};

const Header = ({ onClose: handleClose, heading, projectSettings, copykey, description, descriptionCopykey, }) => {
    const { setError } = useErrorContext();
    const { isFooterExpanded, setIsFooterExpanded } = useFooterAnimationContext();
    const { view, canGoBack, goBack } = useViewContext();
    const { showCloseButton, showHelpContent, isWalletListTypeView, displayBorderBelowHeader, } = useAuthLayoutChecks();
    const { setExistentAccountData } = useAccountExistsContext();
    const handleBackClick = useCallback(() => {
        var _a, _b;
        (_b = (_a = view.events) === null || _a === void 0 ? void 0 : _a.onBackClick) === null || _b === void 0 ? void 0 : _b.call(_a);
        goBack();
        setExistentAccountData(undefined);
        setError(undefined);
    }, [view.events, goBack, setExistentAccountData, setError]);
    const closeButton = showCloseButton && handleClose && (jsxRuntimeExports.jsx(IconButton, { onClick: handleClose, type: 'button', id: 'close-button', "data-testid": 'close-button', className: 'layout-header__icon', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    const infoButton = showHelpContent && (jsxRuntimeExports.jsx(Tooltip, { content: 'Need some help?', className: 'layout-header__tooltip', children: jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: () => setIsFooterExpanded(!isFooterExpanded), "data-testid": 'info-button', className: 'layout-header__icon', children: isWalletListTypeView ? jsxRuntimeExports.jsx(SvgQuestionMark, {}) : jsxRuntimeExports.jsx(SvgFooterInfoIcon, {}) }) }, 'info-button'));
    const leadingButtons = [];
    if (canGoBack) {
        leadingButtons.push(jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: handleBackClick, "data-testid": 'back-button', className: 'layout-header__icon', children: jsxRuntimeExports.jsx(SvgArrowLeft, {}) }, 'back-button'));
    }
    // if has close button and info button, info button should be on the right
    if (closeButton && infoButton) {
        leadingButtons.push(infoButton);
    }
    return (jsxRuntimeExports.jsx("div", { className: 'layout-header', children: jsxRuntimeExports.jsx(ModalHeader, { leading: leadingButtons, trailing: closeButton || infoButton, displayBorder: displayBorderBelowHeader, alignContent: 'bottom', description: description && (jsxRuntimeExports.jsx(Typography, { as: 'p', variant: 'body_mini', color: 'secondary', copykey: descriptionCopykey, className: 'layout-header__description', children: description })), children: (!projectSettings || heading) && (jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'title', color: 'primary', "data-testid": 'dynamic-auth-modal-heading', className: 'layout-header__typography', copykey: copykey, children: !projectSettings ? (jsxRuntimeExports.jsx(Skeleton, { className: 'layout-header__skeleton' })) : (heading) })) }) }));
};

/* istanbul ignore next */
const EmptyHelpContent = () => jsxRuntimeExports.jsx("div", { "data-testid": 'empty-help-content' });

var _path$O;
var _excluded$X = ["title", "titleId"];
function _extends$X() { return _extends$X = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$X.apply(null, arguments); }
function _objectWithoutProperties$X(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$X(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$X(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgFooterEyeIcon = function SvgFooterEyeIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$X(_ref, _excluded$X);
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$O || (_path$O = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.995 4.167c3.965 0 6.643 2.655 7.937 4.675a2.14 2.14 0 0 1 0 2.316c-1.294 2.02-3.972 4.675-7.937 4.675-3.965 0-6.643-2.655-7.937-4.675a2.14 2.14 0 0 1 0-2.316c1.294-2.02 3.972-4.675 7.937-4.675ZM14.16 10a4.167 4.167 0 1 1-8.333 0 4.167 4.167 0 0 1 8.333 0Zm-4.12 2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
    fill: "currentColor"
  })));
};

var _path$N;
var _excluded$W = ["title", "titleId"];
function _extends$W() { return _extends$W = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$W.apply(null, arguments); }
function _objectWithoutProperties$W(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$W(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$W(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgFooterGasIcon = function SvgFooterGasIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$W(_ref, _excluded$W);
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$N || (_path$N = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.667 18.333a2 2 0 0 0 2-2V3.667a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v12.666a2 2 0 0 0 2 2h6ZM9 8.333a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H4.333a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1H9ZM17.5 5.833c.46 0 .833.373.833.834v7.5H17.5h.833V14.186a1.201 1.201 0 0 1-.005.113 2.881 2.881 0 0 1-.29 1.075c-.155.307-.398.64-.779.893-.386.258-.863.4-1.426.4-.562 0-1.04-.142-1.425-.4a2.295 2.295 0 0 1-.778-.893 2.878 2.878 0 0 1-.296-1.16v-.045l.833-.001h-.834V9.185l-.001-.011a.2.2 0 0 0-.015-.051v-.001s.005.008.016.02V7.5c.354 0 .675.091.944.27.264.176.43.404.53.607A1.856 1.856 0 0 1 15 9.13v.035c0 .001 0 .002-.832.002H15v4.992l.001.02a1.228 1.228 0 0 0 .12.448c.054.11.123.194.211.253.083.055.23.12.501.12s.419-.065.502-.12a.633.633 0 0 0 .211-.253 1.218 1.218 0 0 0 .12-.468V6.667c0-.46.374-.834.834-.834ZM13.378 9.17h.002-.002Z",
    fill: "currentColor"
  })));
};

var _path$M;
var _excluded$V = ["title", "titleId"];
function _extends$V() { return _extends$V = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$V.apply(null, arguments); }
function _objectWithoutProperties$V(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$V(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$V(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgFooterKeyIcon = function SvgFooterKeyIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$V(_ref, _excluded$V);
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$M || (_path$M = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.125 6.875a5 5 0 1 0-10 0 5 5 0 0 0 10 0Zm-2.5 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Zm-7.809 3.243a6.258 6.258 0 0 0 1.671 1.865L7.13 14.34l1.752 1.753-1.768 1.767-1.752-1.752-1.718 1.718-1.768-1.767 5.941-5.942Z",
    fill: "currentColor"
  })));
};

const isHardwareWalletEnabled = (walletConnector) => walletConnector !== undefined &&
    walletConnector !== null &&
    isHardwareWalletConnector(walletConnector) &&
    walletConnector.isHardwareWalletEnabled;

const EnterTileAnimation = ({ children, className = '', delay = 0, dataTestId, }) => {
    const style = useMemo(() => ({
        animationDelay: delay,
    }), [delay]);
    return (jsxRuntimeExports.jsx("div", { "data-testid": dataTestId, className: classNames(className, 'enter-list-tile-animation'), style: style, children: children }));
};

const InfoItem = ({ title, content, Icon, className = '', iconClassName = '', textClassName = '', }) => (jsxRuntimeExports.jsxs("div", { className: classNames('info-item__container', className), children: [jsxRuntimeExports.jsx("div", { className: classNames('info-item__icon-container', iconClassName, {
                'icon-container--has-content': Boolean(content),
            }), children: jsxRuntimeExports.jsx(Icon, {}) }), jsxRuntimeExports.jsxs("div", { children: [jsxRuntimeExports.jsx(Typography, { as: 'h2', className: textClassName, variant: 'body_normal', color: 'primary', weight: 'medium', children: title }), content && (jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', weight: 'regular', className: 'info-item__secondary-text', children: content }))] })] }));

const WalletMoreInfoContent = ({ variant, wallet, }) => {
    const defaultSignContent = {
        info: [
            {
                content: 'Signing proves you have access to your wallet. It’s a bit like verifying your email by clicking an email confirmation link in your inbox during signup. This does not approve a transaction.',
                icon: SvgFooterKeyIcon,
                title: 'Confirms you own your wallet',
            },
            {
                icon: SvgFooterGasIcon,
                title: 'There are no associated gas costs',
            },
        ],
    };
    const signInfoMessage = isHardwareWalletEnabled(wallet)
        ? {
            info: [
                {
                    content: 'By connecting a wallet to a website, you are allowing the site to read the contents of your wallet. This does not approve a transaction.',
                    icon: SvgFooterEyeIcon,
                    title: 'Allows read access',
                },
                {
                    content: (jsxRuntimeExports.jsxs("div", { className: 'footer-more-info-content__item--phantom-ledger', children: [jsxRuntimeExports.jsx(Typography, { as: 'p', variant: 'body_small', weight: 'regular', children: "Ledger does not support message signing functionality, commonly used to log in to sites. Instead, we sign a transaction as a proxy to prove ownership of the wallet." }), jsxRuntimeExports.jsxs(Typography, { as: 'p', variant: 'body_small', weight: 'regular', children: [jsxRuntimeExports.jsx("strong", { children: "Important" }), ": we do not", ' ', jsxRuntimeExports.jsx("strong", { children: "broadcast" }), " this transaction, meaning Ledger based login will still be gasless."] }), jsxRuntimeExports.jsx(Typography, { as: 'p', variant: 'body_small', weight: 'regular', children: "Phantom in turn shows that a fee may apply as part of the \u201Ctransaction\u201D." }), jsxRuntimeExports.jsx(Typography, { as: 'p', variant: 'body_small', weight: 'regular', children: "As always, please be cautious of the extensions and websites you use to prevent unwanted transactions from being broadcasted to the network." })] })),
                    icon: SvgFooterGasIcon,
                    title: 'Why do I see a fee when using ledger',
                },
            ],
        }
        : defaultSignContent;
    const copys = {
        connect: {
            info: [
                {
                    content: 'By connecting a wallet to a website, you are allowing the site to read the contents of your wallet. This does not approve a transaction.',
                    icon: SvgFooterEyeIcon,
                    title: 'Allows read access',
                },
                {
                    icon: SvgFooterGasIcon,
                    title: 'There are no associated gas costs',
                },
            ],
        },
        sign: signInfoMessage,
    };
    return (jsxRuntimeExports.jsx("div", { className: 'footer-more-info-content__wrapper', children: copys[variant].info.map((item, index) => (jsxRuntimeExports.jsx("div", { className: 'footer-more-info-content__item', children: jsxRuntimeExports.jsx(EnterTileAnimation, { delay: `${0.3 + index * 0.2}s`, children: jsxRuntimeExports.jsx(InfoItem, { Icon: item.icon, title: item.title, content: item.content }) }) }, index))) }));
};

var _path$L;
var _excluded$U = ["title", "titleId"];
function _extends$U() { return _extends$U = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$U.apply(null, arguments); }
function _objectWithoutProperties$U(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$U(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$U(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgPuzzle = function SvgPuzzle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$U(_ref, _excluded$U);
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$L || (_path$L = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.044 20.998a.693.693 0 0 0 .7-.68V16.59c.239-2.01 1.121-1.413 2.16-.791 2.51 1.502 4.177-2.45 2.148-3.67-1.592-.956-2.281.689-3.448.52-.45-.067-.763-.54-.862-1.261V8.693a.692.692 0 0 0-.7-.68h-3.21c-2.65-.327-.297-1.755-.297-3.083.001-1.066-.99-1.93-2.214-1.93-1.222 0-2.344.864-2.344 1.93 0 1.253 2.435 2.756-.253 3.083H3.7a.692.692 0 0 0-.699.68v2.688c.205 1.146 1.001 1.411 2.021.655.344-.256.924-.554 1.344-.554 1.094 0 1.982.965 1.982 2.154 0 1.19-.887 2.416-1.982 2.416-.39 0-.755-.123-1.063-.338 0 .091-1.913-1.674-2.302.486v4.121c0 .375.315.68.699.68L10.16 21c.085-.393-.191-.844-.45-1.234-2.04-3.075 5.895-3.382 3.855.095-.1.172-.2.338-.277.5-.098.202-.162.45-.149.639l2.905-.002Z",
    fill: "currentColor"
  })));
};

const parseWalletLinks = (links) => {
    const isIOS = isIPhone() || isIPad();
    const userBrowser = detectBrowserName() || 'chrome';
    let currentDesktopUrl;
    switch (userBrowser) {
        case 'edge':
            currentDesktopUrl = links.edge;
            break;
        case 'firefox':
            currentDesktopUrl = links.firefox;
            break;
        case 'chrome':
        default:
            currentDesktopUrl = links.chrome;
            break;
    }
    const canShowAndroidAppButton = !isIOS && Boolean(links.android);
    const canShowIosAppButton = (isIOS || !isMobile()) && Boolean(links.ios);
    return {
        canShowAndroidAppButton,
        canShowIosAppButton,
        currentDesktopUrl,
        hasMobileAppUrl: canShowAndroidAppButton || canShowIosAppButton,
        userBrowser,
    };
};

const getLastUsedWalletKey = () => StorageService.getItem(LAST_USED_WALLET);
const getWalletGroupLabel = (walletGroup, recommendedWallets) => {
    const nestedRecommendedWalletSetting = recommendedWallets === null || recommendedWallets === void 0 ? void 0 : recommendedWallets.find((recommendedWallet) => walletGroup.groupedWallets.some((walletOption) => recommendedWallet.walletKey === walletOption.walletConnector.key));
    if (nestedRecommendedWalletSetting) {
        return {
            isRecommended: true,
            label: nestedRecommendedWalletSetting.label || 'Recommended',
        };
    }
    const lastUsedWalletKey = getLastUsedWalletKey();
    const hasNestedLastUsedWallet = walletGroup.groupedWallets.some((walletOption) => walletOption.walletConnector.key === lastUsedWalletKey);
    if (hasNestedLastUsedWallet) {
        return { label: 'Last used' };
    }
    const hasNestedInstalledWallets = walletGroup.groupedWallets.some((walletOption) => walletOption.isInstalledOnBrowser);
    if (hasNestedInstalledWallets) {
        return { label: 'Installed' };
    }
    if (getWalletGroupType(walletGroup) === 'multi-chain') {
        return { label: 'Multichain' };
    }
    return undefined;
};
const getWalletLabel = (walletOption, recommendedWallets) => {
    const lastUsedWalletKey = getLastUsedWalletKey();
    const { key: walletKey } = walletOption.walletConnector;
    const recommendedWalletSetting = recommendedWallets === null || recommendedWallets === void 0 ? void 0 : recommendedWallets.find((wallet) => wallet.walletKey === walletKey);
    if (recommendedWalletSetting)
        return {
            isRecommended: true,
            label: recommendedWalletSetting.label || 'Recommended',
        };
    const isLastUsedWallet = walletKey === lastUsedWalletKey;
    if (isLastUsedWallet)
        return { label: 'Last used' };
    if (walletOption.isInstalledOnBrowser)
        return { label: 'Installed' };
    return undefined;
};
const getWalletListItemLabel = ({ wallet, recommendedWallets, }) => {
    if (isWalletGroup(wallet)) {
        return getWalletGroupLabel(wallet, recommendedWallets);
    }
    return getWalletLabel(wallet, recommendedWallets);
};

const ListTileAnimatedTrailing = ({ hoverElement, children }) => (jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsxs("div", { className: 'list-tile-animated-trailing', children: [jsxRuntimeExports.jsx("div", { className: 'list-tile-animated-trailing__child', children: children }), jsxRuntimeExports.jsx("div", { className: 'list-tile-animated-trailing__hover-element', children: hoverElement })] }) }));

const ListTile = ({ children, onClick, leading, disabled = false, trailing, style, className = '', dataTestId, copykey, }) => (jsxRuntimeExports.jsxs("button", { "data-testid": dataTestId, type: 'button', className: classNames(className, 'list-tile'), onClick: onClick, style: style, disabled: disabled, children: [leading, jsxRuntimeExports.jsx("div", { className: 'list-tile__children', children: jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'body_normal', color: 'primary', as: 'span', copykey: copykey, children: children }) }), trailing] }));

const DefaultTile = ({ leading, name, onClick, trailing, }) => (jsxRuntimeExports.jsx(ListTile, { leading: leading, trailing: trailing, onClick: onClick, className: 'wallet-list-item__tile', dataTestId: 'ListTile', children: name }));
const WalletListItem = ({ disabled = false, wallet, onResetSearchValue, recommendedWallets, tile = DefaultTile, onSelectWallet, }) => {
    var _a, _b, _c, _d, _e;
    const { navigateToWalletGroup } = useWalletGroupContext();
    const { pushView } = useViewContext();
    const _isWalletGroup = isWalletGroup(wallet);
    const walletGroups = useWalletGroups();
    const labelSettings = getWalletListItemLabel({
        recommendedWallets,
        wallet,
    });
    const Tile = tile;
    const handleClick = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (disabled) {
            return;
        }
        onResetSearchValue === null || onResetSearchValue === void 0 ? void 0 : onResetSearchValue('');
        if (_isWalletGroup) {
            return navigateToWalletGroup(wallet, { onSelectWallet });
        }
        if (isHardwareWalletConnector(wallet.walletConnector) &&
            wallet.walletConnector.canConnectWithHardwareWallet()) {
            pushView('select-hardware-wallet', { onSelectWallet, wallet });
            return;
        }
        onSelectWallet(wallet);
    });
    const name = _isWalletGroup
        ? (_a = walletGroups[wallet.key]) === null || _a === void 0 ? void 0 : _a.name
        : wallet.walletConnector.metadata.name;
    const icon = (_c = (_b = wallet.walletConnector) === null || _b === void 0 ? void 0 : _b.metadata.icon) !== null && _c !== void 0 ? _c : (_e = (_d = walletGroups[wallet.key]) === null || _d === void 0 ? void 0 : _d.brand) === null || _e === void 0 ? void 0 : _e.icon;
    const leading = (jsxRuntimeExports.jsx(WalletIcon, { className: 'wallet-list-item__leading', icon: icon, walletKey: wallet.key, style: { height: pixelToRem(28), width: pixelToRem(28) }, isGroup: _isWalletGroup }));
    const trailing = (jsxRuntimeExports.jsx(ListTileAnimatedTrailing, { hoverElement: 
        // eslint-disable-next-line react/jsx-wrap-multilines
        jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', size: 'mini', children: jsxRuntimeExports.jsx(SvgStroke, {}) }), children: labelSettings && (jsxRuntimeExports.jsx(Badge, { dot: !labelSettings.isRecommended, variant: labelSettings.isRecommended ? 'primary' : 'secondary', text: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', children: labelSettings.label }) })) }));
    return (jsxRuntimeExports.jsx(Tile, { leading: leading, trailing: trailing, name: name, onClick: handleClick }));
};

const NewToWeb3WalletItem = ({ children, style, wallet, }) => {
    const { handleWalletItemClick } = useWalletItemActions();
    return (jsxRuntimeExports.jsx(WalletListItem, { wallet: wallet, onSelectWallet: handleWalletItemClick, tile: children
            ? ({ onClick }) => (jsxRuntimeExports.jsx("button", { className: 'new-to-web3--button', style: style, onClick: onClick, children: children }))
            : undefined }));
};

const Item = ({ heading, StartIcon, EndIcon, message, url, }) => (jsxRuntimeExports.jsxs("a", { className: 'footer-buttons-item', href: url, rel: 'noopener noreferrer', target: '_blank', children: [jsxRuntimeExports.jsx("div", { className: 'footer-buttons-item__icon--left', children: jsxRuntimeExports.jsx(StartIcon, {}) }), jsxRuntimeExports.jsxs("div", { className: 'footer-buttons-item__typography', children: [jsxRuntimeExports.jsx(Typography, { as: 'h2', weight: 'regular', color: 'primary', variant: 'body_normal', children: heading }), message && (jsxRuntimeExports.jsx(Typography, { as: 'p', weight: 'regular', color: 'secondary', children: message }))] }), EndIcon && jsxRuntimeExports.jsx(EndIcon, { style: { height: '1.5rem', width: '1.5rem' } })] }));

const WalletExtensionOrAppContinueButton = ({ wallet, selectedUrl, }) => {
    const showRefreshOnceInstalledWalletButton = Boolean(selectedUrl.length) && !(wallet === null || wallet === void 0 ? void 0 : wallet.isInstalledOnBrowser);
    const walletConnectionAfterPageReloadHandler = () => {
        if (!(wallet === null || wallet === void 0 ? void 0 : wallet.key)) {
            return;
        }
        StorageService.setItem(NEWTOWEB3_WALLET_EXTENSION_FLAG_KEY, wallet.key);
        window.location.reload();
    };
    return (jsxRuntimeExports.jsxs("div", { className: 'new-to-web3-buttons__container', children: [!isMobile() && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [(wallet === null || wallet === void 0 ? void 0 : wallet.isInstalledOnBrowser) && (jsxRuntimeExports.jsx(NewToWeb3WalletItem, { wallet: wallet, children: jsxRuntimeExports.jsx(Typography, { as: 'p', "data-testid": 'desktop-interactive-wallet-item', variant: 'body_normal', weight: 'bold', children: "Continue" }) })), showRefreshOnceInstalledWalletButton && (jsxRuntimeExports.jsx("button", { onClick: walletConnectionAfterPageReloadHandler, children: jsxRuntimeExports.jsx(Typography, { as: 'p', "data-testid": 'refresh-once-installed-button', variant: 'body_normal', weight: 'bold', children: "Continue once installed" }) }))] })), wallet && isMobile() && (jsxRuntimeExports.jsx(NewToWeb3WalletItem, { wallet: wallet, children: jsxRuntimeExports.jsx("p", { "data-testid": 'mobile-interactive-wallet-item', children: "Continue once installed" }) }))] }));
};

const WalletListHelpContent = ({ chains, newToWeb3WalletChainMap, }) => {
    var _a;
    const { walletConnectorOptions } = useInternalDynamicContext();
    const { walletBook } = useWalletBookContext();
    const [selectedUrl, setSelectedUrl] = useState('');
    const chainName = ((_a = chains === null || chains === void 0 ? void 0 : chains.filter((chain) => Boolean(chain.enabled)).find((enabledChain) => enabledChain.name === newToWeb3WalletChainMap.primary_chain)) === null || _a === void 0 ? void 0 : _a.name) || 'evm';
    const walletKey = getValueByKey(newToWeb3WalletChainMap === null || newToWeb3WalletChainMap === void 0 ? void 0 : newToWeb3WalletChainMap.wallets, chainName);
    const newToWeb3Wallet = walletConnectorOptions.find((wallet) => wallet.key === walletKey);
    const isCustodialServiceWallet = newToWeb3Wallet === null || newToWeb3Wallet === void 0 ? void 0 : newToWeb3Wallet.walletConnector.canConnectViaCustodialService;
    const metadata = newToWeb3Wallet === null || newToWeb3Wallet === void 0 ? void 0 : newToWeb3Wallet.walletConnector.metadata;
    const links = getWalletLinks(metadata === null || metadata === void 0 ? void 0 : metadata.downloadLinks);
    const { currentDesktopUrl, canShowAndroidAppButton, canShowIosAppButton } = parseWalletLinks(links);
    const walletLinksElements = [
        {
            content: 'Install Desktop extension',
            icon: SvgPuzzle,
            isEnabled: Boolean(currentDesktopUrl === null || currentDesktopUrl === void 0 ? void 0 : currentDesktopUrl.length) && !isMobile(),
            url: currentDesktopUrl,
        },
        {
            content: 'Install iOS app',
            icon: AppleIcon,
            isEnabled: canShowIosAppButton,
            url: links.ios,
        },
        {
            content: 'Install Android app',
            icon: AndroidIcon,
            isEnabled: canShowAndroidAppButton,
            url: links.android,
        },
    ];
    if (!isWalletBookPopulated(walletBook)) {
        return jsxRuntimeExports.jsx(Skeleton, { className: 'walletlist-footer-content__container' });
    }
    return (jsxRuntimeExports.jsx("div", { className: 'walletlist-help-content__container', children: jsxRuntimeExports.jsxs(EnterTileAnimation, { delay: '300ms', children: [jsxRuntimeExports.jsx("div", { className: 'walletlist-help-content__icon', children: jsxRuntimeExports.jsx(WalletIcon, { icon: metadata === null || metadata === void 0 ? void 0 : metadata.icon, walletKey: walletKey, style: { height: pixelToRem(56), width: pixelToRem(56) } }) }), jsxRuntimeExports.jsxs("div", { className: 'walletlist-help-content__typography-wrapper', children: [jsxRuntimeExports.jsxs(Typography, { as: 'p', variant: 'title', weight: 'medium', children: ["We recommend installing ", metadata === null || metadata === void 0 ? void 0 : metadata.name] }), jsxRuntimeExports.jsx(Typography, { as: 'label', variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'walletlist-help-content__typography--label', children: "Select your preferred option below:" })] }), jsxRuntimeExports.jsx("div", { className: 'walletlist-help-content__buttons-wrapper', children: walletLinksElements.map((element, i) => element.isEnabled ? (jsxRuntimeExports.jsx("button", { onClick: () => setSelectedUrl(element.url), children: jsxRuntimeExports.jsx(Item, { StartIcon: element.icon, heading: element.content, url: element.url }) }, i)) : undefined) }), isCustodialServiceWallet && (jsxRuntimeExports.jsxs("div", { className: 'walletlist-help-content__custodial-wallet-area', children: [jsxRuntimeExports.jsx(Typography, { className: 'walletlist-help-content__custodial-wallet-area--title', as: 'p', color: 'secondary', variant: 'body_normal', weight: 'regular', children: "If you don't want to install a wallet, then use:" }), jsxRuntimeExports.jsx(NewToWeb3WalletItem, { wallet: newToWeb3Wallet })] })), jsxRuntimeExports.jsx(WalletExtensionOrAppContinueButton, { selectedUrl: selectedUrl, wallet: newToWeb3Wallet })] }) }));
};

var _path$K;
var _excluded$T = ["title", "titleId"];
function _extends$T() { return _extends$T = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$T.apply(null, arguments); }
function _objectWithoutProperties$T(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$T(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$T(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgChevronLeft = function SvgChevronLeft(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$T(_ref, _excluded$T);
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$K || (_path$K = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.09 3.577a.833.833 0 0 1 0 1.179L7.844 10l5.244 5.244a.833.833 0 0 1-1.178 1.179l-5.834-5.834a.833.833 0 0 1 0-1.178l5.834-5.834a.833.833 0 0 1 1.178 0Z",
    fill: "currentcolor"
  })));
};

const HelpHeader = () => {
    const { authMode } = useInternalDynamicContext();
    const { setIsFooterExpanded } = useFooterAnimationContext();
    const { view } = useViewContext();
    const { helpHeaderData } = useDynamicLayoutData({
        authMode,
        view: view.type,
    });
    const { displayBorderBelowHeader } = useAuthLayoutChecks();
    const backButton = (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: () => setIsFooterExpanded(false), "data-testid": 'back-button', className: 'header__icon', children: jsxRuntimeExports.jsx(SvgChevronLeft, { className: 'back-button ' }) }));
    return (jsxRuntimeExports.jsx("div", { className: 'help-header', children: jsxRuntimeExports.jsx(ModalHeader, { trailing: backButton, displayLeading: false, displayBorder: displayBorderBelowHeader, children: jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'title', color: 'primary', "data-testid": 'dynamic-auth-help-heading', className: 'header__typography', copykey: helpHeaderData === null || helpHeaderData === void 0 ? void 0 : helpHeaderData.copykey, children: helpHeaderData === null || helpHeaderData === void 0 ? void 0 : helpHeaderData.heading }) }) }));
};

var _path$J;
var _excluded$S = ["title", "titleId"];
function _extends$S() { return _extends$S = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$S.apply(null, arguments); }
function _objectWithoutProperties$S(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$S(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$S(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgUserAccount2 = function SvgUserAccount2(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$S(_ref, _excluded$S);
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    width: 60,
    height: 50,
    viewBox: "0 0 60 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$J || (_path$J = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.931 49.48A29.223 29.223 0 0 0 59.333 30C59.333 13.8 46.2.667 30 .667S.667 13.8.667 30A29.224 29.224 0 0 0 8.07 49.483c5.52-6.63 16.005-9.007 22.387-9.007 6.383 0 15.962 1.903 21.473 9.004ZM19 22.667c0-6.076 4.925-11 11-11s11 4.924 11 11c0 6.075-4.925 11-11 11s-11-4.925-11-11Z",
    fill: "#4779FF"
  })));
};

const PasskeyInfoHelper = () => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsx("div", { className: 'passkey-info-help-content__container', children: jsxRuntimeExports.jsx(EnterTileAnimation, { delay: '300ms', children: jsxRuntimeExports.jsxs("div", { className: 'passkey-info-help-content__typography-wrapper', children: [jsxRuntimeExports.jsxs("div", { className: 'passkey-info-help-content__details', children: [jsxRuntimeExports.jsx(Icon, { size: 'medium', color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgUserAccount2, {}) }), jsxRuntimeExports.jsxs("div", { className: 'passkey-info-help-content__wrapper', children: [jsxRuntimeExports.jsx(Typography, { variant: 'title', weight: 'medium', copykey: 'dyn_passkey_intro.helper.section_1.title', children: t('dyn_passkey_intro.helper.section_1.title') }), jsxRuntimeExports.jsx(Typography, { as: 'p', variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'passkey-info-help-content__typography--label', copykey: 'dyn_passkey_intro.helper.section_1.description', children: t('dyn_passkey_intro.helper.section_1.description') })] })] }), jsxRuntimeExports.jsxs("div", { className: 'passkey-info-help-content__details', children: [jsxRuntimeExports.jsx(Icon, { size: 'medium', color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgFooterKeyIcon, {}) }), jsxRuntimeExports.jsxs("div", { className: 'passkey-info-help-content__wrapper', children: [jsxRuntimeExports.jsx(Typography, { variant: 'title', weight: 'medium', copykey: 'dyn_passkey_intro.helper.section_2.title', children: t('dyn_passkey_intro.helper.section_2.title') }), jsxRuntimeExports.jsx(Typography, { as: 'p', variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'passkey-info-help-content__typography--label', copykey: 'dyn_passkey_intro.helper.section_2.description', children: t('dyn_passkey_intro.helper.section_2.description') })] })] })] }) }) }));
};

const HelpContent = () => (jsxRuntimeExports.jsxs("div", { children: [jsxRuntimeExports.jsx(HelpHeader, {}), jsxRuntimeExports.jsx(HelpContentSwitch, {})] }));
const HelpContentSwitch = () => {
    const { view } = useViewContext();
    const { projectSettings, newToWeb3WalletChainMap, selectedWalletConnector } = useInternalDynamicContext();
    const isWalletListTypeView = useMemo(() => view.type === 'wallet-connect-mobile-wallets-list' ||
        view.type === 'wallet-list' ||
        view.type === 'login-with-email-or-wallet-full-wallet-list' ||
        view.type === 'login-with-wallet-only', [view]);
    const isPendingSignatureTypeView = useMemo(() => view.type === 'pending-signature-without-back-button' ||
        view.type === 'pending-signature', [view]);
    const isPendingConnectTypeView = useMemo(() => view.type === 'pending-connect' || view.type === 'qr-code', [view]);
    const isPasskeyIntroView = useMemo(() => view.type === 'passkey-intro', [view]);
    if (isWalletListTypeView) {
        return (jsxRuntimeExports.jsx(WalletListHelpContent, { chains: projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.chains, newToWeb3WalletChainMap: newToWeb3WalletChainMap }));
    }
    if (isPendingSignatureTypeView) {
        return (jsxRuntimeExports.jsx(WalletMoreInfoContent, { variant: 'sign', wallet: selectedWalletConnector || undefined }));
    }
    if (isPendingConnectTypeView) {
        return jsxRuntimeExports.jsx(WalletMoreInfoContent, { variant: 'connect' });
    }
    if (isPasskeyIntroView) {
        return jsxRuntimeExports.jsx(PasskeyInfoHelper, {});
    }
    return jsxRuntimeExports.jsx(EmptyHelpContent, {});
};

const TosAndPp = () => {
    const { user, authMode, customPrivacyPolicy, customTermsOfServices, privacyPolicyUrl, termsOfServiceUrl, } = useInternalDynamicContext();
    const connectionType = isConnectOnly(user, authMode)
        ? 'connecting'
        : 'logging in';
    const renderTermsOfServices = () => {
        if (!termsOfServiceUrl) {
            return;
        }
        return (jsxRuntimeExports.jsx("a", { className: 'tos-and-pp__link', href: termsOfServiceUrl, target: '_blank', rel: 'noreferrer', children: "Terms of Service" }));
    };
    const renderPrivacyPolicy = () => {
        if (!privacyPolicyUrl) {
            return;
        }
        return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [termsOfServiceUrl && jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: "\u00A0&\u00A0" }), jsxRuntimeExports.jsx("a", { className: 'tos-and-pp__link', href: privacyPolicyUrl, target: '_blank', rel: 'noreferrer', children: "Privacy Policy" })] }));
    };
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [(privacyPolicyUrl || termsOfServiceUrl) && (jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', weight: 'regular', className: 'tos-and-pp__text', children: ["By ", connectionType, ", you agree to", jsxRuntimeExports.jsx("br", {}), "our\u00A0", renderTermsOfServices(), renderPrivacyPolicy(), "."] })), customTermsOfServices, customPrivacyPolicy] }));
};

const ToSFooter = () => (jsxRuntimeExports.jsx("div", { className: 'tos-and-pp__footer', children: jsxRuntimeExports.jsx(TosAndPp, {}) }));

// Derive step state from remaining wallets
const getChainStepState = (chain, chainsLeftToConnect) => {
    const isCurrentStep = chain === chainsLeftToConnect[0];
    const isStepComplete = !chainsLeftToConnect.includes(chain);
    if (isCurrentStep) {
        return 'current';
    }
    if (isStepComplete) {
        return 'done';
    }
    return 'upcoming';
};

const typographyOpacityMap = {
    current: '1',
    default: '1',
    done: '0.4',
    upcoming: '0.15',
};
const Step = ({ children, className, icon, state = 'default', }) => {
    // Reduce opacity of icon if upcoming
    const style = useMemo(() => ({ opacity: state === 'upcoming' ? 0.5 : 1 }), [state]);
    const ComputedIcon = useMemo(() => {
        // If done use checkmark icon
        if (state === 'done')
            return (jsxRuntimeExports.jsx("div", { className: 'step__icon step__icon--done', children: jsxRuntimeExports.jsx(Icon, { className: 'step__icon__check-mark', children: jsxRuntimeExports.jsx(SvgCheck, { style: style }) }) }));
        // Use provided icon if available
        else if (icon)
            return (jsxRuntimeExports.jsx(Icon, { className: 'step__icon', children: jsxRuntimeExports.jsx("div", { style: style, children: icon }) }));
        // Otherwise use step index as icon
        else
            return (jsxRuntimeExports.jsx("div", { className: 'step__index', children: jsxRuntimeExports.jsx(Typography, { color: 'primary', variant: 'body_small', style: style, children: jsxRuntimeExports.jsx("span", { className: 'step__index-label' }) }) }));
    }, [icon, state, style]);
    return (jsxRuntimeExports.jsxs("div", { className: classNames('step', className), children: [ComputedIcon, jsxRuntimeExports.jsx(Typography, { color: 'primary', variant: 'body_small', style: { opacity: typographyOpacityMap[state] }, children: children })] }));
};

const Stepper = ({ children }) => (jsxRuntimeExports.jsx("div", { className: 'stepper', children: Children.map(children, (step, index) => {
        const divider = index === 0 ? undefined : jsxRuntimeExports.jsx(Divider, { className: 'stepper__divider' });
        return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [divider, step] }));
    }) }));

const WalletProgressStepper = () => {
    const { bridgeChainsToConnect = [], bridgeChains = [] } = useInternalDynamicContext();
    const allChains = bridgeChains.map(({ chain }) => chain);
    const chainsLeftToConnect = [...bridgeChainsToConnect].map(({ chain }) => chain);
    return (jsxRuntimeExports.jsx("div", { className: 'wallet-progress-stepper', "data-testid": 'wallet-progress-stepper', children: jsxRuntimeExports.jsx(Stepper, { children: allChains.map((chain, index) => {
                var _a;
                const chainInfo = getChainInfoWithOverrides(chain);
                const PrimaryWalletChainIcon = getChainIcon(chain);
                return (jsxRuntimeExports.jsx(Step, { state: getChainStepState(chain, chainsLeftToConnect), icon: jsxRuntimeExports.jsx(PrimaryWalletChainIcon, {}), children: (_a = chainInfo === null || chainInfo === void 0 ? void 0 : chainInfo.blockchainName) !== null && _a !== void 0 ? _a : chainInfo === null || chainInfo === void 0 ? void 0 : chainInfo.displayName }, chain));
            }) }) }));
};

const DynamicAuthLayout = ({ children, className, style, onClose, projectSettings, hideBridgeProgressSteppers, }) => {
    const { view } = useViewContext();
    const { authMode } = useInternalDynamicContext();
    const { isFooterExpanded } = useFooterAnimationContext();
    const { headerData, helpHeaderData, descriptionData } = useDynamicLayoutData({
        authMode,
        view: view.type,
    });
    const { showConnectedWalletProgress, showHeader, showHelpContent, showToSFooter, showDynamicFooter, } = useAuthLayoutChecks();
    return (jsxRuntimeExports.jsx(OverlayCardTarget, { children: jsxRuntimeExports.jsxs(VerticalAccordion, { style: style, className: className, children: [jsxRuntimeExports.jsxs(AccordionItem, { isOpen: !isFooterExpanded, dimOnHide: true, children: [showConnectedWalletProgress && !hideBridgeProgressSteppers && (jsxRuntimeExports.jsx(WalletProgressStepper, {})), showHeader && (jsxRuntimeExports.jsx(Header, { onClose: onClose, heading: (headerData === null || headerData === void 0 ? void 0 : headerData.heading) || '', projectSettings: projectSettings, copykey: headerData === null || headerData === void 0 ? void 0 : headerData.copykey, description: descriptionData === null || descriptionData === void 0 ? void 0 : descriptionData.text, descriptionCopykey: descriptionData === null || descriptionData === void 0 ? void 0 : descriptionData.copykey })), children, showToSFooter && jsxRuntimeExports.jsx(ToSFooter, {}), showDynamicFooter && jsxRuntimeExports.jsx(DynamicFooter, {})] }), helpHeaderData && showHelpContent && (jsxRuntimeExports.jsx(AccordionItem, { isOpen: isFooterExpanded, children: jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(HelpContent, {}) }, isFooterExpanded.toString()) }))] }) }));
};

// It adds an indicator to the top of the children if the environment is sandbox
const SandboxIndicatorWrapper = ({ children, }) => {
    const { projectSettings } = useInternalDynamicContext();
    const indicatorRef = useRef(null);
    const [indicatorHeight, setIndicatorHeight] = useState(undefined);
    const isSandBox = (projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.environmentName) === EnvironmentEnum.Sandbox;
    // The use effect is needed to update the location after all transitions are done
    useEffect(() => {
        var _a;
        const clientHeight = (_a = indicatorRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight;
        setIndicatorHeight(clientHeight);
    }, [indicatorRef, setIndicatorHeight]);
    if (!isSandBox)
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: children });
    return (jsxRuntimeExports.jsxs("div", { style: { position: 'relative' }, children: [jsxRuntimeExports.jsx("div", { ref: indicatorRef, 
                // Its using inline styles so users cannot override it easily
                style: {
                    background: 'var(--dynamic-alert-1)',
                    borderTopLeftRadius: '4px',
                    borderTopRightRadius: '4px',
                    color: 'white',
                    left: 'calc( var(--dynamic-border-radius) + 8px)',
                    padding: '2px 8px 4px',
                    position: 'absolute',
                    top: -(indicatorHeight || 0),
                }, "data-testid": 'sandbox-indicator', children: capitalize$1((projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.environmentName) || '') }), children] }));
};

const DynamicAuthModal = ({ children, onClose, transitionProps, projectSettings, className, }) => {
    const { showConnectedWalletProgress } = useAuthLayoutChecks();
    return (jsxRuntimeExports.jsxs(Modal, { isShown: Boolean(transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.isShown), children: [showConnectedWalletProgress && (jsxRuntimeExports.jsx(ModalCard, { borderRadius: 'small', children: jsxRuntimeExports.jsx(WalletProgressStepper, {}) })), jsxRuntimeExports.jsx(SandboxIndicatorWrapper, { children: jsxRuntimeExports.jsx(ModalCard, { dataTestId: 'dynamic-auth-modal', children: jsxRuntimeExports.jsx(DynamicAuthLayout, { className: className, projectSettings: projectSettings, onClose: onClose, hideBridgeProgressSteppers: true, children: children }) }) })] }));
};

const MockContext = createContext(undefined);
const useMockContext = () => {
    const context = useContext(MockContext);
    if (context === undefined) {
        return { mockedSDK: false };
    }
    return context;
};

const LoadingContext = createContext(undefined);
const LoadingContextProvider = ({ children, }) => {
    const [loading, setLoading] = useState(false);
    useInternalDynamicEvents('logout', () => setLoading(false));
    useInternalDynamicEvents('embeddedWalletCreated', () => setLoading(false));
    const value = useMemo(() => ({
        loading,
        setLoading,
    }), [loading]);
    return (jsxRuntimeExports.jsx(LoadingContext.Provider, { value: value, children: children }));
};
const useLoadingContext = () => {
    const context = useContext(LoadingContext);
    if (context === undefined) {
        throw new Error('usage of useLoadingContext not wrapped in `LoadingContextProvider`.');
    }
    return context;
};

const useHandleAuthenticatedUser = () => {
    const { handlers } = useInternalDynamicContext();
    const { handleAuthenticatedUser } = handlers !== null && handlers !== void 0 ? handlers : {};
    const handleAuthenticatedUserRef = useRef(handleAuthenticatedUser);
    handleAuthenticatedUserRef.current = handleAuthenticatedUser;
    return useCallback((user) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!handleAuthenticatedUserRef.current)
            return;
        yield runSafe(() => { var _a; return (_a = handleAuthenticatedUserRef.current) === null || _a === void 0 ? void 0 : _a.call(handleAuthenticatedUserRef, { user }); });
    }), []);
};

const sleepToShowSuccessMessage = () => sleep(1500);
const useUserAuth = ({ authMethod, }) => {
    const { handleLogOut, setShowAuthFlow, setCallback, setMultiWalletWidgetState, walletConnectorOptions, } = useInternalDynamicContext();
    const { setDeniedOauthUsername, setDeniedOauthProvider } = useAccessDeniedContext();
    const { view, pushView, clearStackAndPushInitialView } = useViewContext();
    const { setLoading } = useLoadingContext();
    const { setErrorMessage, setError } = useErrorContext();
    const { setExistentAccountData } = useAccountExistsContext();
    const handleAuthenticatedUser = useHandleAuthenticatedUser();
    const { shouldAutoCreateEmbeddedWallet, shouldPromptForKeyExport } = useEmbeddedWallet();
    const isVerifyResponse = (response) => response.user;
    const initAuth = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ isSignIn = true, verifyFunction, onVerifySuccess, onSettled, onError, showSuccessMessage = false, skipDefaultErrorHandling = false, }) {
        var _b;
        logger$1.debug('initAuth', { authMethod, isSignIn });
        try {
            // TODO: change this logic to const verifiedUser = await verifyFunction();
            // once all verify functions are updated to return UserProfile instead of VerifyResponse
            const verifyResponse = yield verifyFunction();
            if (!verifyResponse) {
                yield cancelAuth();
                throw new DynamicError('No user returned from verify function');
            }
            let verifiedUser;
            if (isVerifyResponse(verifyResponse)) {
                verifiedUser = storeAuthTokenAndUser(verifyResponse);
            }
            else {
                verifiedUser = verifyResponse;
            }
            onVerifySuccess === null || onVerifySuccess === void 0 ? void 0 : onVerifySuccess(verifiedUser);
            walletConnectorOptions.forEach((walletOption) => {
                walletOption.walletConnector.setVerifiedCredentials(verifiedUser.verifiedCredentials);
            });
            if (hasPendingMfaAction(verifiedUser)) {
                // handled in SyncAuthFlow
                return;
            }
            if (isSignIn && ((_b = verifiedUser.missingFields) === null || _b === void 0 ? void 0 : _b.length)) {
                //onboarding will be handled in the onboarding flow
                return;
            }
            setMultiWalletWidgetState('idle');
            yield handleAuthenticatedUser(verifiedUser);
            // we should only close auth flow if no wallet is going to be created or there is no key export
            // otherwise there will be a glitch with auth flow closing and then reopening for passkeys or export
            const shouldCreateWallet = shouldAutoCreateEmbeddedWallet(verifiedUser);
            const shouldPromptExport = shouldPromptForKeyExport();
            if (showSuccessMessage) {
                // this timeout is set to make sure that the user will see success message
                yield sleepToShowSuccessMessage();
            }
            if (isSignIn) {
                setCallback('authSuccess');
            }
            if (!shouldCreateWallet && !shouldPromptExport) {
                setShowAuthFlow(false);
            }
            onSettled === null || onSettled === void 0 ? void 0 : onSettled();
        }
        catch (error) {
            logger$1.debug(error);
            if (skipDefaultErrorHandling) {
                onError === null || onError === void 0 ? void 0 : onError(error);
                return;
            }
            handleAuthError(error, { onError });
        }
        finally {
            setLoading(false);
            onSettled === null || onSettled === void 0 ? void 0 : onSettled();
        }
    });
    const handleAuthError = (error, { options = {}, onError, }) => {
        var _a;
        if (error instanceof MfaInvalidOtpError ||
            error instanceof MfaRateLimitedError) {
            throw error;
        }
        // these get caught in onboarding form and handled there
        if (error instanceof EmailAlreadyExistsError ||
            error instanceof CustomFieldNotUniqueError ||
            error instanceof UsernameAlreadyExistsError ||
            error instanceof TooManyEmailVerificationsError ||
            error instanceof InvalidPhoneNumberError)
            throw error;
        if (error instanceof NoAccessError) {
            setDeniedOauthProvider(error === null || error === void 0 ? void 0 : error.socialProvider);
            setDeniedOauthUsername((_a = error === null || error === void 0 ? void 0 : error.socialUsername) !== null && _a !== void 0 ? _a : '');
            pushView('no-access');
            return;
        }
        if (error instanceof AccountExistsError) {
            setExistentAccountData(error.errorPayload);
            pushView('account-exists');
            return;
        }
        if (error instanceof SandboxMaximumThresholdReachedError) {
            pushView('sandbox-maximum-threshold-reached');
            return;
        }
        // Handle the case where the user has already an account with the email
        if (error instanceof UserHasAccountWithEmailError) {
            pushView('merge-user-accounts-with-same-email', {
                returnToView: 'isEmailRecoveryFlow' in options && options.isEmailRecoveryFlow
                    ? 'passkey-recovery-add-email'
                    : undefined,
            });
            return;
        }
        if (onError) {
            onError === null || onError === void 0 ? void 0 : onError(error);
            return;
        }
        if (error.code) {
            setErrorMessage(error.code);
        }
        else {
            setError(error.message);
        }
    };
    const handleVerifyMissingFields = (_c) => __awaiter$1(void 0, [_c], void 0, function* ({ missingFields, isEmailVerificationRequired, isSmsVerificationRequired, }) {
        if (isEmailVerificationRequired &&
            missingFields.find((field) => field.name === 'email')) {
            pushView('verify-email');
            return;
        }
        if (isSmsVerificationRequired &&
            missingFields.find((field) => field.name === 'phoneNumber')) {
            pushView('verify-sms');
            return;
        }
        pushView(view.type);
    });
    const completeAuth = (_d) => __awaiter$1(void 0, [_d], void 0, function* ({ completeSignInFlow, updateJwtFunction, onValidUpdatedJwt, options = {}, }) {
        logger$1.debug('completeAuth', { authMethod });
        try {
            const { updateUserProfileResponse, isSmsVerificationRequired, isEmailVerificationRequired, missingFields, } = yield updateJwtFunction();
            onValidUpdatedJwt === null || onValidUpdatedJwt === void 0 ? void 0 : onValidUpdatedJwt();
            const updatedUser = storeAuthTokenAndUser({
                expiresAt: updateUserProfileResponse.expiresAt,
                jwt: updateUserProfileResponse.jwt,
                minifiedJwt: updateUserProfileResponse.minifiedJwt,
                user: updateUserProfileResponse.user,
            });
            if (missingFields.length > 0) {
                yield handleVerifyMissingFields({
                    isEmailVerificationRequired,
                    isSmsVerificationRequired,
                    missingFields,
                });
                return;
            }
            yield handleAuthenticatedUser(updatedUser);
            setCallback('authSuccess');
            if (completeSignInFlow) {
                const shouldReturn = yield completeSignInFlow(updateUserProfileResponse);
                if (shouldReturn) {
                    return;
                }
            }
            // we should only close auth flow if no wallet is going to be created,
            // otherwise there will be a glitch with auth flow closing and then reopening for passkeys
            const shouldCreateWallet = shouldAutoCreateEmbeddedWallet();
            if (!shouldCreateWallet &&
                updatedUser.mfaBackupCodeAcknowledgement !==
                    MfaBackupCodeAcknowledgement.Pending) {
                setShowAuthFlow(false);
            }
        }
        catch (error) {
            logger$1.debug(error);
            handleAuthError(error, { options });
        }
        finally {
            setLoading(false);
        }
    });
    const cancelAuth = () => __awaiter$1(void 0, void 0, void 0, function* () {
        logger$1.debug('cancelAuth', { authMethod });
        yield handleLogOut();
        clearStackAndPushInitialView();
    });
    return {
        cancelAuth,
        completeAuth,
        handleAuthError,
        initAuth,
    };
};

// This logic is used to both verify or link a wallet
// Since we are re-using the different screens to authenticate or link the wallet.
// This logic is the best place to determine whether we should verify or verify and link.
const useVerifyWallet = ({ displaySiweStatement, environmentId, projectSettings, setIsSingleWalletAccount, }) => {
    const { setExistentAccountData } = useAccountExistsContext();
    const { setDeniedAddress, setDeniedOauthProvider } = useAccessDeniedContext();
    const { pushView, clearStackAndPushInitialView } = useViewContext();
    const { setErrorMessage, setError } = useErrorContext();
    const { multiWalletWidgetState, debugError, multiWallet: multiWalletEnabled, appName, primaryWalletId, setShowAuthFlow, siweStatement, connectedWallets, authMode, user, setAuthMode, removeConnectedWalletsInfo, events, primaryWallet, enableConnectOnlyFallback, selectedWalletConnector, } = useInternalDynamicContext();
    const { addedWalletsIds } = useInternalUserWallets();
    const { initAuth } = useUserAuth({ authMethod: 'wallet' });
    const { generateSessionKey, shouldRegisterSessionKeysOnSignin } = useEmbeddedWalletSessionKeys({
        environmentId,
        projectSettings,
    });
    // If the user is not already logged it means that we only need to verify
    // We need this boolean to distinguish between logic for verify or linking.
    const verifyOnly = !user;
    const shouldFallbackToConnectOnly = enableConnectOnlyFallback && (verifyOnly || !multiWalletEnabled);
    const generateJWT = (walletConnector, walletProvider, getAddressOpts, publicWalletAddress, captchaToken, oauth, signedMessageOverride, messageToSignOverride) => __awaiter$1(void 0, void 0, void 0, function* () {
        const verifyArgs = yield getVerifyArgs({
            displaySiweStatement,
            environmentId,
            getAddressOpts,
            messageToSignOverride,
            publicWalletAddress,
            signedMessageOverride,
            siweStatement: getSiweStatement({ appName, siweStatement }),
            walletConnector,
            walletProvider,
        });
        if (shouldRegisterSessionKeysOnSignin()) {
            const keypair = yield generateSessionKey();
            verifyArgs.sessionPublicKey = keypair.publicKey;
        }
        let verifyResponse;
        if (!user || !multiWalletEnabled) {
            verifyResponse = verifyWallet(environmentId, Object.assign(Object.assign({}, verifyArgs), { captchaToken,
                oauth }));
        }
        else {
            verifyResponse = linkWallet(environmentId, verifyArgs);
        }
        return { verifyArgs, verifyFunction: () => verifyResponse };
    });
    // Overrides the stored primary wallet id when the
    // user logs in for the first time.
    // Or when the user is linking an additional
    // account on the same wallet as the primary wallet.
    const updatePrimaryWallet = ({ walletConnector, verifiedCredentials, lastVerifiedCredentialId, }) => {
        const newSelectedCredentialWallet = verifiedCredentials.find((cred) => cred.id === lastVerifiedCredentialId && cred.format === 'blockchain');
        if (newSelectedCredentialWallet) {
            const currentPrimaryWallet = verifiedCredentials.find((a) => a.id === primaryWalletId);
            if (verifyOnly ||
                !primaryWallet ||
                (multiWalletWidgetState === 'awaiting_signature' &&
                    newSelectedCredentialWallet.walletName ===
                        (currentPrimaryWallet === null || currentPrimaryWallet === void 0 ? void 0 : currentPrimaryWallet.walletName)) ||
                ((currentPrimaryWallet === null || currentPrimaryWallet === void 0 ? void 0 : currentPrimaryWallet.chain) === 'flow' &&
                    walletConnector.connectedChain === 'FLOW')) {
                updatePrimaryWalletId(newSelectedCredentialWallet.id);
            }
        }
    };
    const handleWalletUsedError = (e) => {
        var _a;
        // This is a special case where the user is trying to link a wallet
        // and the wallet is already linked and we don't want to kill the session.
        setShowAuthFlow(true);
        pushView('wallet-used');
        setIsSingleWalletAccount(false);
        if (e.code === 'reassign_wallet_error') {
            if ((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _a === void 0 ? void 0 : _a.preventOrphanedAccounts) {
                pushView('wallet-cannot-be-transferred');
            }
            setIsSingleWalletAccount(true);
        }
    };
    const handleDisconnectWallet = ({ walletConnector, endSession = true, }) => {
        removeConnectedWalletsInfo();
        if (endSession)
            walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.endSession();
    };
    const handleError = (e, walletConnector, address, oauth) => {
        var _a;
        // see: PhantomRedirect#signMessage
        if (e.message === 'ignore') {
            return;
        }
        // Emit failure if this wallet connector was currently selected for auth
        if (selectedWalletConnector &&
            selectedWalletConnector.key === walletConnector.key)
            dynamicEvents.emit('authFailure', {
                address,
                connectorName: walletConnector.name,
                option: walletConnector.name,
                type: 'wallet',
            }, { error: e });
        if (e instanceof EmbeddedWalletExistsError) {
            pushView('embedded-wallet-exists');
            setShowAuthFlow(true);
            return;
        }
        if (e instanceof WalletUsedError) {
            handleDisconnectWallet({ endSession: false, walletConnector });
            return handleWalletUsedError(e);
        }
        if (e instanceof MergeAccountsConfirmationError) {
            pushView('merge-user-accounts', Object.assign({}, e));
            setShowAuthFlow(true);
            return;
        }
        if (e instanceof ChainalysisError) {
            handleDisconnectWallet({ walletConnector });
            setDeniedAddress(address);
            pushView('chainalysis-blocked-wallet');
            return;
        }
        if (e instanceof GateBlockedError) {
            handleDisconnectWallet({ walletConnector });
            setDeniedAddress(address);
            pushView('gate-blocked-wallet');
            return;
        }
        if (e instanceof SandboxMaximumThresholdReachedError) {
            pushView('sandbox-maximum-threshold-reached');
            return;
        }
        if (e instanceof NoAccessError) {
            handleDisconnectWallet({ walletConnector });
            setDeniedAddress(address);
            // we need to set this value if it's magic in order to set proper icon
            if (isSocialWalletConnector(walletConnector)) {
                setDeniedOauthProvider(oauth === null || oauth === void 0 ? void 0 : oauth.provider);
            }
            pushView('no-access');
            return;
        }
        if (e instanceof AccountExistsError) {
            handleDisconnectWallet({ walletConnector });
            setExistentAccountData(e.errorPayload);
            pushView('account-exists');
            return;
        }
        if (connectedWallets.length && authMode === 'connect-only') {
            throw new DynamicError(e.message);
        }
        const userRejectedRequestError = (_a = e === null || e === void 0 ? void 0 : e.message) === null || _a === void 0 ? void 0 : _a.includes('User rejected the request');
        const fallbackToConnectOnly = shouldFallbackToConnectOnly && !userRejectedRequestError;
        if (fallbackToConnectOnly) {
            logger$1.warn('Verification failed, changing to connect-only');
            // verification failed for unknown reason, set authmode to connect-only and show wallet list
            setAuthMode('connect-only');
            pushView('wallet-list');
            return;
        }
        else {
            handleDisconnectWallet({ walletConnector });
            clearStackAndPushInitialView();
        }
        logger$1.error(e);
        if (debugError) {
            setError(`${e.message}\n ${e.stack}`);
        }
        else {
            setErrorMessage(e.code);
        }
    };
    return (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ walletConnector, getAddressOpts, publicWalletAddress, captchaToken, oauth, signedMessageOverride, messageToSignOverride, }) {
        const walletProvider = getWalletProvider(walletConnector);
        dynamicEvents.emit('authInit', {
            address: publicWalletAddress,
            connectorName: walletConnector.name,
            option: walletConnector.name,
            type: 'wallet',
        });
        try {
            const { verifyFunction, verifyArgs } = yield generateJWT(walletConnector, walletProvider, getAddressOpts, publicWalletAddress, captchaToken, oauth, signedMessageOverride, messageToSignOverride);
            yield initAuth({
                isSignIn: verifyOnly,
                onError: (e) => {
                    handleError(e, walletConnector, publicWalletAddress, oauth);
                },
                onVerifySuccess: (user) => {
                    var _a;
                    if (!user) {
                        throw new DynamicError(USER_NOT_LOGGED_IN);
                    }
                    try {
                        (_a = events === null || events === void 0 ? void 0 : events.onSignedMessage) === null || _a === void 0 ? void 0 : _a.call(events, {
                            messageToSign: verifyArgs.messageToSign,
                            signedMessage: verifyArgs.signedMessage,
                        });
                    }
                    catch (_b) {
                        logger$1.warn('Error calling onSignedMessage callback');
                    }
                    StorageService.setItem(LAST_USED_WALLET, walletConnector.key);
                    setAuthMode('connect-and-sign');
                    updatePrimaryWallet({
                        lastVerifiedCredentialId: user.lastVerifiedCredentialId,
                        verifiedCredentials: user.verifiedCredentials,
                        walletConnector,
                    });
                    const walletId = user.lastVerifiedCredentialId;
                    if (walletId) {
                        addedWalletsIds.current.push(walletId);
                    }
                },
                options: {
                    address: publicWalletAddress,
                    connectorName: walletConnector.name,
                },
                skipDefaultErrorHandling: true,
                verifyFunction,
            });
        }
        catch (e) {
            handleError(e, walletConnector, publicWalletAddress, oauth);
        }
    });
};

/**
 * Hook that runs an effect only once based on a condition.
 *
 * @param {Function} effect - The effect callback function to run.
 * @param {boolean} condition - The condition that determines whether the effect should run.
 */
const useEffectOnceCondition = (effect, condition) => {
    const hasRun = useRef(false);
    const effectRef = useRef(effect);
    effectRef.current = effect;
    useEffect(() => {
        if (condition && !hasRun.current) {
            effectRef.current();
            hasRun.current = true;
        }
    }, [condition]);
};

const SOCIAL_STORAGE_KEY = 'dynamic_social_storage';
const searchSocialStorageByState = (targetState) => {
    var _a;
    const socialStorage = StorageService.getItem(SOCIAL_STORAGE_KEY);
    if (!socialStorage)
        return undefined;
    const storageEntries = Object.entries(socialStorage);
    const [provider] = (_a = storageEntries.find(([, { state }]) => state === targetState)) !== null && _a !== void 0 ? _a : [];
    if (!provider)
        return undefined;
    return socialStorage[provider];
};
const setSocialStorageFor = (provider, socialStorageItem) => {
    var _a;
    const socialStorage = (_a = StorageService.getItem(SOCIAL_STORAGE_KEY)) !== null && _a !== void 0 ? _a : {};
    socialStorage[provider] = Object.assign({ provider }, socialStorageItem);
    StorageService.setItem(SOCIAL_STORAGE_KEY, socialStorage);
};
const deleteSocialStorage = (provider) => {
    var _a;
    const socialStorage = (_a = StorageService.getItem(SOCIAL_STORAGE_KEY)) !== null && _a !== void 0 ? _a : {};
    delete socialStorage[provider];
    StorageService.setItem(SOCIAL_STORAGE_KEY, socialStorage);
};

const getSocialSignInProviderForProviderEnum = (provider) => {
    if (!provider)
        return;
    const values = Object.values(SocialSignInProviderEnum);
    for (const value of values) {
        if (value === provider) {
            return value;
        }
    }
    return undefined;
};

const digestSHA256 = (str) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    return window.crypto.subtle.digest('SHA-256', data);
};

const encodeBase64URL = (str) => {
    const numberArray = [];
    new Uint8Array(str).forEach((item) => numberArray.push(item));
    return btoa(String.fromCharCode.apply(null, numberArray))
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
};

const stringifyURIQuery = (obj) => {
    const str = [];
    for (const prop in obj) {
        str.push(encodeURIComponent(prop) + '=' + encodeURIComponent(obj[prop]));
    }
    return str.join('&');
};

const APPLE_LOGIN_DATA = {
    customMobileUrl: true,
    response_mode: 'form_post',
    response_type: ['code', 'id_token'],
};
const getMobileOauthUrl = (provider, loginData) => {
    if (!(loginData === null || loginData === void 0 ? void 0 : loginData.customMobileUrl) || !isMobile() || !provider.redirectUrl) {
        return;
    }
    return provider.redirectUrl.replace('redirect', 'authorizeHtml');
};
const getOauthLoginUrl = (providers, providerType) => {
    var _a, _b, _c;
    const provider = getProviderByType(providers, providerType);
    if (!(provider === null || provider === void 0 ? void 0 : provider.clientId)) {
        return '';
    }
    let loginData;
    if (providerType === ProviderEnum.Apple) {
        loginData = APPLE_LOGIN_DATA;
    }
    let loginBaseUrl;
    if (providerType === ProviderEnum.Telegram) {
        loginBaseUrl = (_a = provider.authorizationUrl) !== null && _a !== void 0 ? _a : '';
    }
    else if (provider.baseAuthUrl) {
        if (providerType === ProviderEnum.Shopify) {
            loginBaseUrl = provider.baseAuthUrl.replace('{{shopifyStore}}', (_b = provider.shopifyStore) !== null && _b !== void 0 ? _b : '');
        }
        else {
            loginBaseUrl = provider.baseAuthUrl;
        }
    }
    else {
        return '';
    }
    const mobileUrl = getMobileOauthUrl(provider, loginData);
    const baseProps = {
        client_id: provider.clientId,
        redirect_uri: (_c = provider.redirectUrl) !== null && _c !== void 0 ? _c : '',
        response_type: 'code',
    };
    if (providerType === ProviderEnum.Tiktok) {
        delete baseProps.client_id;
        baseProps.client_key = provider.clientId;
    }
    if (provider.scopes) {
        baseProps.scope = provider.scopes;
    }
    if (loginData === null || loginData === void 0 ? void 0 : loginData.prompt) {
        baseProps.prompt = loginData.prompt.join(' ');
    }
    if (loginData === null || loginData === void 0 ? void 0 : loginData.response_mode) {
        baseProps.response_mode = loginData.response_mode;
    }
    if (loginData === null || loginData === void 0 ? void 0 : loginData.response_type) {
        baseProps.response_type = loginData.response_type.join(' ');
    }
    const params = stringifyURIQuery(baseProps);
    return `${mobileUrl !== null && mobileUrl !== void 0 ? mobileUrl : loginBaseUrl}?${params}`;
};

const randomString = (length) => {
    const CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
    let result = '';
    for (let i = length; i > 0; --i) {
        result += CHARS[Math.floor(Math.random() * CHARS.length)];
    }
    return result;
};

const initAuth = (environmentId, providerType, oauthInitAuthRequest) => __awaiter$1(void 0, void 0, void 0, function* () {
    try {
        yield sdkApi().initAuth({
            environmentId,
            oauthInitAuthRequest,
            providerType,
        });
    }
    catch (err) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let data;
        try {
            data = yield err.json();
            logger$1.error(data);
        }
        catch (_a) {
            logger$1.error(err);
            throw err;
        }
        throw new Error(data.error);
    }
});
const verifyOAuth = (environmentId_1, providerType_1, _b) => __awaiter$1(void 0, [environmentId_1, providerType_1, _b], void 0, function* (environmentId, providerType, { code, codeVerifier, state }) {
    const oauthRequest = {
        code,
        codeVerifier,
        state,
    };
    try {
        const response = yield sdkApi().oauthVerify({
            environmentId,
            oauthRequest,
            providerType,
        });
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        return handleVerifyError(e);
    }
});
const unlinkOAuth = (_c) => __awaiter$1(void 0, [_c], void 0, function* ({ environmentId, primaryWalletId, verifiedCrentialId, }) {
    try {
        const response = yield sdkApi().verifyUnlink({
            environmentId,
            verifyUnlinkRequest: {
                primaryWalletId,
                verifiedCrentialId,
            },
        });
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        return undefined;
    }
});
const signInOAuth = (environmentId_2, providerType_2, _d) => __awaiter$1(void 0, [environmentId_2, providerType_2, _d], void 0, function* (environmentId, providerType, { code, codeVerifier, state, captchaToken, sessionPublicKey }) {
    const oauthRequest = {
        captchaToken,
        code,
        codeVerifier,
        sessionPublicKey,
        state,
    };
    try {
        const response = yield sdkApi().oauthSignIn({
            environmentId,
            oauthRequest,
            providerType,
        });
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        return handleSignInError(e);
    }
});
const getOAuthResult = (environmentId_3, providerType_3, _e) => __awaiter$1(void 0, [environmentId_3, providerType_3, _e], void 0, function* (environmentId, providerType, { state }) {
    const oauthResultRequest = {
        state,
    };
    try {
        const result = yield sdkApi().oauthResult({
            environmentId,
            oauthResultRequest,
            providerType,
        });
        return result;
    }
    catch (e) {
        yield logResponseError(e, 'error getting oauth result');
        return undefined;
    }
});
const farcasterSignIn = (environmentId, farcasterSignInRequest) => __awaiter$1(void 0, void 0, void 0, function* () {
    try {
        const response = yield sdkApi().farcasterSignIn({
            environmentId,
            farcasterSignInRequest,
        });
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        return handleSignInError(e);
    }
});
const farcasterVerify = (farcasterVerifyRequest) => __awaiter$1(void 0, void 0, void 0, function* () {
    try {
        const response = yield sdkApi().farcasterVerify(farcasterVerifyRequest);
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        return handleVerifyError(e);
    }
});
const telegramSignIn = (environmentId, oauthResultRequest) => __awaiter$1(void 0, void 0, void 0, function* () {
    const telegramSignInRequest = {
        environmentId,
        oauthResultRequest,
    };
    try {
        const response = yield sdkApi().telegramSignIn(telegramSignInRequest);
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        return handleSignInError(e);
    }
});
const telegramVerify = (environmentId, oauthResultRequest) => __awaiter$1(void 0, void 0, void 0, function* () {
    const telegramVerifyRequest = {
        environmentId,
        oauthResultRequest,
    };
    try {
        const response = yield sdkApi().telegramVerify(telegramVerifyRequest);
        const user = storeAuthTokenAndUser(response);
        return user;
    }
    catch (e) {
        return handleVerifyError(e);
    }
});
const handleVerifyError = (e) => __awaiter$1(void 0, void 0, void 0, function* () {
    const data = yield logResponseError(e, 'error verifying social');
    if (data.code === 'social_account_already_exists') {
        throw new SocialAccountAlreadyExistsError();
    }
    if (data.error.code === 'sandbox_maximum_threshold_reached') {
        throw new SandboxMaximumThresholdReachedError(data.error.message);
    }
    return undefined;
});
const handleSignInError = (e) => __awaiter$1(void 0, void 0, void 0, function* () {
    var _f, _g, _h;
    const data = yield logResponseError(e, 'error signin social');
    if (data.error.code === 'gate_blocked') {
        throw new GateBlockedError(data.payload.walletPublicKey);
    }
    if (data.error.code === 'missing_from_list') {
        throw new NoAccessError({
            socialProvider: (_f = data === null || data === void 0 ? void 0 : data.payload) === null || _f === void 0 ? void 0 : _f.socialProvider,
            socialUsername: (_g = data === null || data === void 0 ? void 0 : data.payload) === null || _g === void 0 ? void 0 : _g.socialUsername,
            walletPublicKey: (_h = data === null || data === void 0 ? void 0 : data.payload) === null || _h === void 0 ? void 0 : _h.walletPublicKey,
        });
    }
    if (data.code === 'email_associated_with_different_provider') {
        throw new AccountExistsError(data.error, data.payload);
    }
    if (data.error.code === 'sandbox_maximum_threshold_reached') {
        throw new SandboxMaximumThresholdReachedError(data.error.message);
    }
    return undefined;
});

const CONNECT_URL = 'https://relay.farcaster.xyz/v1/channel';
const STATUS_URL = 'https://relay.farcaster.xyz/v1/channel/status';
const STATUS_TIMEOUT = 300000;
const STATUS_INTERVAL = 1000;
const connect = (connectRequest) => __awaiter$1(void 0, void 0, void 0, function* () {
    try {
        const response = yield FetchService.fetch(CONNECT_URL, {
            body: JSON.stringify(connectRequest),
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'POST',
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return yield response.json();
    }
    catch (error) {
        logger$1.error('Error connecting with farcaster:', error);
        return;
    }
});
const status = (connectStatusRequest) => __awaiter$1(void 0, void 0, void 0, function* () {
    try {
        const response = yield FetchService.fetch(STATUS_URL, {
            headers: {
                Authorization: `Bearer ${connectStatusRequest.channelToken}`,
                'Content-Type': 'application/json',
            },
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return yield response.json();
    }
    catch (error) {
        logger$1.error('Error fetching farcaster connect status:', error);
        return;
    }
});
const watchStatus = (connectStatusRequest_1, ...args_1) => __awaiter$1(void 0, [connectStatusRequest_1, ...args_1], void 0, function* (connectStatusRequest, { timeout = STATUS_TIMEOUT, interval = STATUS_INTERVAL } = {}) {
    const deadline = Date.now() + timeout;
    let shouldPoll = true;
    let storedResolve = undefined;
    // When we cancel, immediately resolve the current timeout promise and abort status watch
    dynamicEvents.on('farcasterConnectCancelled', () => {
        shouldPoll = false;
        storedResolve === null || storedResolve === void 0 ? void 0 : storedResolve();
        storedResolve = undefined;
    });
    // Declaring the promise callback outside of loop to avoid unnecessary garbage generation
    const timeoutCallback = (resolve) => {
        storedResolve = resolve;
        setTimeout(resolve, interval);
    };
    while (shouldPoll && Date.now() < deadline) {
        const response = yield status(connectStatusRequest);
        if (!response) {
            return 'rejected';
        }
        if (response.state === 'completed') {
            return response;
        }
        yield new Promise(timeoutCallback);
    }
    if (!shouldPoll) {
        return 'cancelled';
    }
    logger$1.error(`Polling farcaster connect status timed out after ${STATUS_TIMEOUT}ms`);
    return 'timeout';
});

const socialProviders = [
    'apple',
    'coinbasesocial',
    'discord',
    'epicgames',
    'facebook',
    'farcaster',
    'github',
    'google',
    'instagram',
    'line',
    'shopify',
    'spotify',
    'tiktok',
    'telegram',
    'twitch',
    'twitter',
];
// pkce params are only required for twitter and break if added for other providers, like google
// so we should only add provider that support pkce to this list
const providersRequiringPkce = ['twitter', 'github'];
// Hook to handle common social auth logic (for social linking and social sign in)
const useSocialAuth = ({ onSettled, onError, onFarcasterUrl, }) => {
    const { environmentId, setShowAuthFlow, socialSettings, projectSettings, redirectUrl: defaultRedirectUrl, } = useInternalDynamicContext();
    /**
     * Represents if the SDK will use a popup or redirect for social auth
     */
    const strategy = useMemo(() => (socialSettings === null || socialSettings === void 0 ? void 0 : socialSettings.strategy) || 'redirect', [socialSettings]);
    const { setErrorMessage, setError: setContextError } = useErrorContext();
    const { initAuth: initAuth$1 } = useUserAuth({
        authMethod: 'social',
    });
    const { generateSessionKey, shouldRegisterSessionKeysOnSignin } = useEmbeddedWalletSessionKeys({
        environmentId,
        projectSettings,
    });
    const [isProcessing, setIsProcessing] = useState(false);
    const [error, setError] = useState();
    const clearError = useCallback(() => {
        setError(undefined);
        setContextError(undefined);
    }, [setContextError]);
    const onFailed = useCallback((provider, reason, options) => {
        setIsProcessing(false);
        onError === null || onError === void 0 ? void 0 : onError();
        onSettled === null || onSettled === void 0 ? void 0 : onSettled();
        if (provider && (options === null || options === void 0 ? void 0 : options.raiseAuthFailure))
            dynamicEvents.emit('authFailure', {
                option: provider,
                provider,
                type: 'social',
            }, reason);
    }, [onError, onSettled]);
    const handleError = useCallback((provider, code, message, options) => {
        const error = { code, message };
        logger$1.error(message);
        setError(error);
        setErrorMessage(code);
        onFailed(provider, { error }, options);
    }, [onFailed, setErrorMessage]);
    const checkValidProvider = useCallback((provider, authMode) => {
        if (!provider) {
            handleError(provider, SocialOAuthErrorCode.NO_PROVIDER, 'Provider is required', { raiseAuthFailure: authMode === 'signin' });
            return false;
        }
        if (!socialProviders.includes(provider)) {
            handleError(provider, SocialOAuthErrorCode.INVALID_PROVIDER, `Invalid social provider. Valid providers are: ${socialProviders.join(', ')}`, { raiseAuthFailure: authMode === 'signin' });
            return false;
        }
        return true;
    }, [handleError]);
    const linkAccount = useCallback((provider, apiCall) => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            const response = yield apiCall();
            if (!response) {
                handleError(provider, SocialOAuthErrorCode.VERIFICATION_ERROR, `Failed to link social account: ${provider}`, { raiseAuthFailure: false });
                return;
            }
            onSettled === null || onSettled === void 0 ? void 0 : onSettled();
        }
        catch (error) {
            if (error instanceof SocialAccountAlreadyExistsError) {
                handleError(provider, SocialOAuthErrorCode.ACCOUNT_ALREADY_LINKED_TO_DIFFERENT_PROFILE, `Social account already linked to a different profile: ${provider}`, { raiseAuthFailure: false });
            }
        }
    }), [handleError, onSettled]);
    const signInAccount = useCallback((provider, apiCall) => __awaiter$1(void 0, void 0, void 0, function* () {
        yield initAuth$1({
            onError: () => handleError(provider, SocialOAuthErrorCode.SIGNIN_ERROR, `Failed to sign-in with social account: ${provider}`, { raiseAuthFailure: true }),
            onSettled,
            options: { provider },
            verifyFunction: () => apiCall(),
        });
    }), [handleError, initAuth$1, onSettled]);
    const completeConnection = useCallback((_a) => __awaiter$1(void 0, [_a], void 0, function* ({ authMode, provider, state, authCode, captchaToken, verifier, telegramAuthToken, forceCreateUser = false, }) {
        try {
            let sessionPublicKey = undefined;
            if (shouldRegisterSessionKeysOnSignin()) {
                const keypair = yield generateSessionKey();
                sessionPublicKey = keypair.publicKey;
            }
            if (authMode === 'signin') {
                if (provider === ProviderEnum.Telegram && telegramAuthToken) {
                    const apiCall = () => telegramSignIn(environmentId, {
                        forceCreateUser,
                        sessionPublicKey,
                        telegramAuthToken,
                    });
                    return yield signInAccount(provider, apiCall);
                }
                else if (provider === ProviderEnum.Telegram) {
                    const apiCall = () => telegramSignIn(environmentId, {
                        code: authCode,
                        sessionPublicKey,
                        state,
                    });
                    yield signInAccount(provider, apiCall);
                }
                else {
                    const apiCall = () => signInOAuth(environmentId, provider, {
                        captchaToken,
                        code: authCode,
                        codeVerifier: verifier,
                        sessionPublicKey,
                        state,
                    });
                    yield signInAccount(provider, apiCall);
                }
            }
            else {
                if (provider === ProviderEnum.Telegram) {
                    const apiCall = () => telegramVerify(environmentId, {
                        code: authCode,
                        state,
                    });
                    yield linkAccount(provider, apiCall);
                }
                else {
                    const apiCall = () => verifyOAuth(environmentId, provider, {
                        code: authCode,
                        codeVerifier: verifier,
                        state,
                    });
                    yield linkAccount(provider, apiCall);
                }
            }
        }
        catch (error) {
            logger$1.error('Social connection failed with unexpected error:', error);
            onFailed(provider, { error }, { raiseAuthFailure: authMode === 'signin' });
        }
    }), [
        environmentId,
        generateSessionKey,
        linkAccount,
        onFailed,
        shouldRegisterSessionKeysOnSignin,
        signInAccount,
    ]);
    const connectWithFarcaster = useCallback((authMode_1, _b) => __awaiter$1(void 0, [authMode_1, _b], void 0, function* (authMode, { captchaToken, redirectUrl }) {
        let dynamicNonce;
        try {
            dynamicNonce = consumeNonce();
        }
        catch (error) {
            handleError(ProviderEnum.Farcaster, SocialOAuthErrorCode.GENERAL_ERROR, 'Missing nonce', { raiseAuthFailure: authMode === 'signin' });
            return;
        }
        const domain = PlatformService.getHost();
        const data = yield connect({
            domain,
            nonce: dynamicNonce,
            redirectUrl: redirectUrl || defaultRedirectUrl,
            siweUri: PlatformService.getOrigin(),
        });
        if (!(data === null || data === void 0 ? void 0 : data.url) || !(data === null || data === void 0 ? void 0 : data.channelToken)) {
            handleError(ProviderEnum.Farcaster, SocialOAuthErrorCode.GENERAL_ERROR, "Farcaster didn't return a valid url.", { raiseAuthFailure: authMode === 'signin' });
            return;
        }
        // If on mobile, we want to redirect to the Warpcast app.
        if (isMobile()) {
            yield PlatformService.openURL(data.url);
        }
        else {
            setShowAuthFlow(true);
            onFarcasterUrl === null || onFarcasterUrl === void 0 ? void 0 : onFarcasterUrl(data.url);
        }
        const status = yield watchStatus({
            channelToken: data.channelToken,
        });
        if (status === 'cancelled') {
            setIsProcessing(false);
            return;
        }
        // Error
        if (status === 'timeout' ||
            status === 'rejected' ||
            !(status === null || status === void 0 ? void 0 : status.message) ||
            !(status === null || status === void 0 ? void 0 : status.custody) ||
            !(status === null || status === void 0 ? void 0 : status.signature) ||
            !(status === null || status === void 0 ? void 0 : status.nonce)) {
            handleError(ProviderEnum.Farcaster, SocialOAuthErrorCode.GENERAL_ERROR, "Farcaster didn't return valid data.", { raiseAuthFailure: authMode === 'signin' });
            return;
        }
        const { custody: address, message, signature, nonce } = status;
        if (authMode === 'signin') {
            let sessionPublicKey = undefined;
            if (shouldRegisterSessionKeysOnSignin()) {
                const keypair = yield generateSessionKey();
                sessionPublicKey = keypair.publicKey;
            }
            const apiCall = () => farcasterSignIn(environmentId, {
                address,
                captchaToken,
                domain,
                message,
                nonce,
                sessionPublicKey,
                signature,
            });
            yield signInAccount(ProviderEnum.Farcaster, apiCall);
        }
        else {
            const apiCall = () => farcasterVerify({
                environmentId,
                farcasterSignInRequest: {
                    address,
                    captchaToken,
                    domain,
                    message,
                    nonce,
                    signature,
                },
            });
            yield linkAccount(ProviderEnum.Farcaster, apiCall);
            setShowAuthFlow(false, { clearErrors: false });
        }
        setIsProcessing(false);
    }), [
        defaultRedirectUrl,
        environmentId,
        generateSessionKey,
        handleError,
        linkAccount,
        onFarcasterUrl,
        setShowAuthFlow,
        shouldRegisterSessionKeysOnSignin,
        signInAccount,
    ]);
    const connectSocialAccount = useCallback((_c) => __awaiter$1(void 0, [_c], void 0, function* ({ authMode, provider, validator, captchaToken, redirectUrl, telegramAuthToken, }) {
        var _d, _e;
        clearError();
        setIsProcessing(true);
        if (!authMode) {
            logger$1.error('Auth mode is required. Please use either "link" or "signin"');
            return;
        }
        if (!checkValidProvider(provider, authMode)) {
            return;
        }
        // invalid connect request
        if (validator && !validator(provider)) {
            return;
        }
        dynamicEvents.emit('authInit', {
            option: provider,
            provider,
            type: 'social',
        });
        if (provider === ProviderEnum.Farcaster) {
            return connectWithFarcaster(authMode, {
                captchaToken,
                redirectUrl,
            });
        }
        const state = randomString(32);
        const verifier = randomString(43);
        // Whether we will use PKCE (code verifier/challenge) for this provider
        const usingPkce = providersRequiringPkce.includes(provider);
        setSocialStorageFor(provider, {
            captchaToken,
            codeVerifier: usingPkce ? verifier : undefined,
            mode: authMode,
            state,
        });
        const loginUrlString = getOauthLoginUrl((_d = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers) !== null && _d !== void 0 ? _d : [], provider);
        if (!loginUrlString) {
            handleError(provider, SocialOAuthErrorCode.NO_OAUTH_URL, `Failed to get login url to connect social account: ${provider}`, { raiseAuthFailure: authMode === 'signin' });
            return;
        }
        const oauthLoginUrl = new URL(loginUrlString);
        oauthLoginUrl.searchParams.set('state', state);
        // only add pkce params for providers that support/require it
        if (usingPkce) {
            const digest = yield digestSHA256(verifier);
            oauthLoginUrl.searchParams.set('code_challenge', encodeBase64URL(digest));
            oauthLoginUrl.searchParams.set('code_challenge_method', 'S256');
        }
        const isMobile$1 = isMobile();
        try {
            const authCode = yield Oauth2Service.getOauthCode({
                apiProvider: getProviderByType((_e = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers) !== null && _e !== void 0 ? _e : [], provider),
                getOAuthResultFromApi: () => getOAuthResult(environmentId, provider, {
                    state,
                }),
                initWebAuth: ({ redirectUrl } = {}) => initAuth(environmentId, provider, {
                    redirectUrl: redirectUrl
                        ? removeDynamicOauthParamsFromUrl(redirectUrl)
                        : undefined,
                    state,
                }),
                isMobile: isMobile$1,
                oauthLoginUrl,
                onSettled,
                provider,
                redirectUrl: redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : defaultRedirectUrl,
                setIsProcessing,
                state,
                strategy,
            });
            yield completeConnection({
                authCode,
                authMode,
                captchaToken,
                provider,
                state,
                telegramAuthToken,
                verifier,
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }
        catch (error) {
            if (Oauth2Service.isGetOauthCodeError(error)) {
                handleError(provider, error.code, error.message, {
                    raiseAuthFailure: authMode === 'signin',
                });
                return;
            }
            // Log message individually so the Expo console can display it (it fails to display objects)
            logger$1.error('Social connection failed with unexpected error:', error.message, error);
            onFailed(provider, { error }, { raiseAuthFailure: authMode === 'signin' });
        }
    }), [
        checkValidProvider,
        clearError,
        completeConnection,
        connectWithFarcaster,
        defaultRedirectUrl,
        environmentId,
        handleError,
        onFailed,
        onSettled,
        projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers,
        strategy,
    ]);
    return useMemo(() => ({
        checkValidProvider,
        completeConnection,
        connectSocialAccount,
        error,
        handleError,
        isProcessing,
        setError,
        setIsProcessing,
    }), [
        checkValidProvider,
        completeConnection,
        connectSocialAccount,
        error,
        handleError,
        isProcessing,
    ]);
};
const removeDynamicOauthParamsFromUrl = (url) => {
    const urlObject = new URL(url);
    urlObject.searchParams.delete('dynamicOauthState');
    urlObject.searchParams.delete('dynamicOauthCode');
    return urlObject.toString();
};

const useRedirectSocialHandler = ({ setSocialProvider, }) => {
    const { clearStackAndPush } = useViewContext();
    const { setDynamicWidgetView } = useWidgetContext();
    const [socialStorageItem, setSocialStorageItem] = useState(null);
    const { sdkHasLoaded, setShowAuthFlow, isRenderingEmbeddedAuthFlow, setShowDynamicUserProfile, redirectUrl, } = useInternalDynamicContext();
    const { completeConnection } = useSocialAuth({});
    const updateInterfaceStateForSignIn = useCallback((socialStorageItem) => {
        const socialSignInProvider = getSocialSignInProviderForProviderEnum(socialStorageItem.provider);
        setSocialProvider(socialSignInProvider);
        clearStackAndPush('social-redirect-view');
        // Only open the auth flow when the embedded widget is not rendered
        if (!isRenderingEmbeddedAuthFlow.current) {
            setShowAuthFlow(true);
        }
    }, [
        setSocialProvider,
        clearStackAndPush,
        isRenderingEmbeddedAuthFlow,
        setShowAuthFlow,
    ]);
    const updateInterfaceStateForLink = useCallback(() => {
        setDynamicWidgetView('profile');
        setShowDynamicUserProfile(true);
    }, [setDynamicWidgetView, setShowDynamicUserProfile]);
    useEffectOnce(() => {
        // Do not run on server side
        if (isSSR())
            return;
        const url = new URL(redirectUrl !== null && redirectUrl !== void 0 ? redirectUrl : window.location.href);
        const dynamicOauthState = url.searchParams.get('dynamicOauthState');
        const dynamicOauthCode = url.searchParams.get('dynamicOauthCode');
        if (!dynamicOauthState || !dynamicOauthCode) {
            return;
        }
        const socialStorageItem = searchSocialStorageByState(dynamicOauthState);
        if (!socialStorageItem)
            return;
        // we got back the dynamicOauthCode from the oauth provider, set it here so we can use it to sign in
        socialStorageItem.code = dynamicOauthCode;
        setSocialStorageItem(socialStorageItem);
        // Clear the state from local storage
        deleteSocialStorage(socialStorageItem.provider);
    });
    useEffectOnceCondition(() => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!socialStorageItem)
            return;
        // Update UI to reflect the original state
        if (socialStorageItem.mode === 'signin') {
            if (getUser()) {
                logger$1.error(new DynamicError('User is already logged in'));
                return;
            }
            updateInterfaceStateForSignIn(socialStorageItem);
        }
        else if (socialStorageItem.mode === 'link') {
            if (!getUser()) {
                logger$1.error(new DynamicError('User not logged in'));
                return;
            }
            updateInterfaceStateForLink();
        }
        yield completeConnection({
            authCode: socialStorageItem.code,
            authMode: socialStorageItem.mode,
            captchaToken: socialStorageItem.captchaToken,
            provider: socialStorageItem.provider,
            state: socialStorageItem.state,
            verifier: socialStorageItem.codeVerifier,
        });
    }), Boolean(socialStorageItem) && sdkHasLoaded);
};

const SocialRedirectContext = createContext(undefined);
const SocialRedirectContextProvider = ({ children, }) => {
    var _a, _b, _c, _d;
    const { setShowAuthFlow, walletConnectorOptions, setSelectedWalletConnectorKey, walletUiUtils, displaySiweStatement, environmentId, projectSettings, setIsSingleWalletAccount, setShowDynamicUserProfile, secondaryWallets, sdkHasLoaded, user, connectWallet, primaryWallet, socialProvidersFilter = (providers) => providers, } = useInternalDynamicContext();
    const { setErrorMessage } = useErrorContext();
    const { clearStackAndPush, pushView } = useViewContext();
    const { getCaptchaToken } = useCaptchaContext();
    const verifyWallet = useVerifyWallet({
        displaySiweStatement,
        environmentId,
        projectSettings,
        setIsSingleWalletAccount,
    });
    const signInProvider = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.socialSignIn) === null || _a === void 0 ? void 0 : _a.signInProvider;
    const enabledSocialProvidersInDb = (_c = (_b = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.socialSignIn) === null || _b === void 0 ? void 0 : _b.providers) !== null && _c !== void 0 ? _c : [];
    const enabledSocialProviders = (_d = socialProvidersFilter(enabledSocialProvidersInDb
        .filter((provider) => provider.enabled)
        .map((provider) => provider.provider))) !== null && _d !== void 0 ? _d : [];
    const socialWalletConnector = walletConnectorOptions
        .map(({ walletConnector }) => walletConnector)
        .find(isSocialWalletConnector);
    const [redirectStatus, setRedirectStatus] = useState('idle');
    const [socialProvider, setSocialProvider] = useState();
    const userWallets = primaryWallet
        ? [primaryWallet, ...secondaryWallets]
        : secondaryWallets;
    const wallet = userWallets.find((wallet) => wallet.connector.key === (socialWalletConnector === null || socialWalletConnector === void 0 ? void 0 : socialWalletConnector.key));
    const socialAccount = useMemo(() => (wallet ? getReferencedAccount(user, wallet.id) : undefined), [user, wallet]);
    // added to make sure to reset the social provider on logout
    useInternalDynamicEvents('logout', () => setSocialProvider(undefined));
    const handleError = useCallback((message) => {
        logger$1.error(message);
        if (user) {
            setShowAuthFlow(false, { emitCancelAuth: true });
            setShowDynamicUserProfile(true);
        }
        else {
            setShowAuthFlow(true);
            clearStackAndPush('wallet-list');
            setErrorMessage('-1');
        }
    }, [
        user,
        setErrorMessage,
        setShowAuthFlow,
        setShowDynamicUserProfile,
        clearStackAndPush,
    ]);
    useEffect(() => {
        var _a, _b;
        if (!projectSettings || !socialWalletConnector || !sdkHasLoaded) {
            const params = new URLSearchParams(window.location.search);
            if (params.has('magic_oauth_request_id')) {
                clearStackAndPush('social-redirect-view');
                setShowAuthFlow(true);
            }
            return;
        }
        const params = new URLSearchParams(window.location.search);
        if (params.has('error') && params.has('provider')) {
            const errorDescription = params.get('error_description');
            handleError(errorDescription !== null && errorDescription !== void 0 ? errorDescription : 'Unknown error');
            // calling this to clear the relevant query params
            (_a = socialWalletConnector.getSession) === null || _a === void 0 ? void 0 : _a.call(socialWalletConnector);
            return;
        }
        if (params.has('magic_oauth_request_id')) {
            const providerFromParams = params.get('provider');
            setSocialProvider(providerFromParams);
            setRedirectStatus('loading');
            clearStackAndPush('social-redirect-view');
            setShowAuthFlow(true);
            if (!user) {
                setSelectedWalletConnectorKey(socialWalletConnector.key);
            }
            (_b = socialWalletConnector
                .getSession) === null || _b === void 0 ? void 0 : _b.call(socialWalletConnector).then((session) => __awaiter$1(void 0, void 0, void 0, function* () {
                /**
                 * If the user is already authenticated, that means that they are in the process
                 * of setting their social wallet as their primary wallet. At this point, they
                 * have successfully re-authenticated with the social provider. We can now finish
                 * the setPrimaryWallet flow
                 */
                if (user) {
                    if (!socialAccount) {
                        throw new Error('Social account not found');
                    }
                    /**
                     * consider google: a user may have multiple google accounts.
                     * we need to make sure they connected with the same google account
                     * that they originally used to authenticate
                     *
                     * there are two known scenarios that we enter this branch:
                     * 1. the user is reconnected a social wallet:
                     *   a. the user signed in with social
                     *   b. the user then linked another wallet (for ex: metamask)
                     *   c. the user signed out
                     *   d. the user signed in with metamask
                     *   e. the user selects their social wallet as their primary wallet
                     *   f. we need to reconnect the social wallet and put the user in the social oauth redirect flow
                     *
                     * 2. for an unknown reason, the magic search params get put back into the url and this component rerenders,
                     *    causing us to think the user is reconnecting.
                     *    see: https://dynamiclabsgroup.slack.com/archives/C0473MNEP0T/p1697503460754999
                     */
                    if (socialAccount.oauthAccountId === session.oauthId) {
                        if ((wallet === null || wallet === void 0 ? void 0 : wallet.id) !== (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.id)) {
                            // justification: socialAccount is defined if and only if wallet is also defined
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            updatePrimaryWalletId(wallet.id);
                            setShowAuthFlow(false);
                            setShowDynamicUserProfile(true);
                        }
                    }
                    else {
                        yield socialWalletConnector.endSession();
                        pushView('social-wrong-account');
                    }
                }
                else {
                    yield connectWallet(socialWalletConnector);
                    const address = yield socialWalletConnector.getAddress();
                    walletUiUtils.disabledConfirmationOnce();
                    yield verifyWallet({
                        captchaToken: getCaptchaToken(),
                        oauth: {
                            accessToken: session.accessToken,
                            didToken: session.didToken,
                            provider: providerFromParams,
                        },
                        /**
                         * justification: if the user just successfully authenticated their social,
                         * then the social connector must return an address
                         */
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        publicWalletAddress: address,
                        walletConnector: socialWalletConnector,
                    });
                }
                setSocialProvider(undefined);
                setRedirectStatus('success');
            })).catch((error) => {
                setSocialProvider(undefined);
                setRedirectStatus('error');
                handleError(error);
            });
        }
    }, [
        socialAccount,
        user,
        projectSettings,
        sdkHasLoaded,
        secondaryWallets,
        setSelectedWalletConnectorKey,
        setShowAuthFlow,
        setShowDynamicUserProfile,
        pushView,
        socialWalletConnector,
        verifyWallet,
        walletUiUtils,
        wallet,
        handleError,
        connectWallet,
        primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.id,
        getCaptchaToken,
        clearStackAndPush,
    ]);
    useRedirectSocialHandler({
        setSocialProvider,
    });
    return (jsxRuntimeExports.jsx(SocialRedirectContext.Provider, { value: {
            enabledSocialProviders,
            redirectStatus,
            setSocialProvider,
            signInProvider,
            socialAccount,
            socialProvider,
            socialWalletConnector,
        }, children: children }));
};
const useSocialRedirectContext = () => {
    const context = useContext(SocialRedirectContext);
    if (context === undefined) {
        throw new Error('useSocialRedirectContext must be used within a SocialRedirectContextProvider');
    }
    return context;
};

const { getProjectSettings: getProjectSettingsRaw, setProjectSettings, useProjectSettings: useProjectSettingsRaw, resetProjectSettings, } = createStoreState('projectSettings');
const getProjectSettings = () => getProjectSettingsRaw().settings;
const getProjectSettingsExpireAt = () => getProjectSettingsRaw().expiresAt;
const useProjectSettings = () => useProjectSettingsRaw().settings;
const useFetchProjectSettings = ({ retries = 2, } = {}) => {
    const originalProjectSettings = getProjectSettings();
    const expiresAt = getProjectSettingsExpireAt();
    const isProjectSettingsPresent = Boolean(originalProjectSettings);
    const didProjectSettingsExpire = expiresAt ? expiresAt < Date.now() : false;
    const hasUser = getUser() !== undefined;
    const hasConnectedWallet = (StorageService.getItem(CONNECTED_WALLETS_INFO) || []).length > 0;
    const enableProjectSettingsFetch = !isProjectSettingsPresent ||
        didProjectSettingsExpire ||
        (hasUser === false && hasConnectedWallet === false);
    const environmentId = useEnvironmentId();
    const { retrigger } = usePromise(() => __awaiter$1(void 0, void 0, void 0, function* () {
        const settings = yield fetchProjectSettings(environmentId);
        if (!settings)
            throw new DynamicError('Settings are not defined');
        return settings;
    }), {
        deps: [environmentId],
        enabled: enableProjectSettingsFetch,
        onResolve: (projectSettings) => {
            const expiry = new Date().getTime() + 60000 * 5;
            setProjectSettings({
                expiresAt: expiry,
                settings: projectSettings,
            });
        },
        retries,
    });
    useDynamicEvents('logout', retrigger);
    return { refetchProjectSettings: retrigger };
};

const { getNonce: getNonceRaw, setNonce, useNonce: useNonceRaw, } = createStoreState('nonce');
const getNonce = () => getNonceRaw().nonce;
const useNonce = () => useNonceRaw().nonce;
const storeNewNonce = (newNonce) => {
    const expiry = new Date().getTime() + 60000 * 60 * 24;
    setNonce({
        expiresAt: expiry,
        nonce: newNonce,
    });
};
const useFetchNonce = ({ shouldFetch = true, retries = 2, } = {}) => {
    const nonce = useNonce();
    const environmentId = useEnvironmentId();
    const { retrigger } = usePromise(() => __awaiter$1(void 0, void 0, void 0, function* () { return getNonce$1(environmentId); }), {
        deps: [environmentId],
        enabled: shouldFetch && !nonce,
        onResolve: (newNonce) => {
            storeNewNonce(newNonce);
        },
        retries,
    });
    useDynamicEvents('logout', retrigger);
    return nonce;
};
const consumeNonce = () => {
    const nonce = getNonce();
    if (!nonce) {
        throw new DynamicError('Nonce is not defined');
    }
    setNonce({
        expiresAt: undefined,
        nonce: undefined,
    });
    return nonce;
};

const AccordionItem = forwardRef(({ children, className = '', isOpen, dataTestId, dimOnHide = false, handleScroll = () => { }, }, ref) => {
    const childRef = useRef(null);
    const lastValidChildHeight = useRef();
    const [childEntry] = useResizeObserver(childRef);
    const maxHeight = useMemo(() => {
        if (!isOpen)
            return 0;
        if (!childEntry)
            return lastValidChildHeight.current;
        return childEntry.height;
    }, [isOpen, childEntry]);
    useEffect(() => {
        const childHeight = childEntry === null || childEntry === void 0 ? void 0 : childEntry.height;
        if (childHeight) {
            lastValidChildHeight.current = childHeight;
        }
    }, [childEntry]);
    return (jsxRuntimeExports.jsxs("div", { "data-testid": dataTestId, style: { maxHeight }, className: classNames(className, 'accordion-item', {
            'accordion-item--full-height': Boolean(maxHeight),
        }), onScroll: handleScroll, ref: ref, children: [dimOnHide && (jsxRuntimeExports.jsx("div", { "data-testid": 'accordion-item-curtain', className: classNames('accordion-item__curtain', {
                    'accordion-item__curtain--dimmed': !isOpen,
                }) })), jsxRuntimeExports.jsx("div", { ref: childRef, children: children })] }));
});
AccordionItem.displayName = 'AccordionItem';

var _g$9, _defs$8;
var _excluded$R = ["title", "titleId"];
function _extends$R() { return _extends$R = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$R.apply(null, arguments); }
function _objectWithoutProperties$R(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$R(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$R(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgAccessBlocked = function SvgAccessBlocked(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$R(_ref, _excluded$R);
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    width: 327,
    height: 112,
    viewBox: "0 0 327 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$9 || (_g$9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#access-blocked_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 114,
    r: 114,
    fill: "url(#access-blocked_svg__b)",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.352,
    cy: 29.265,
    r: 15.729,
    transform: "rotate(15 220.352 29.265)",
    fill: "#4779FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.594 23.62a1.573 1.573 0 1 0-3.038-.815l-1.629 6.078a1.573 1.573 0 1 0 3.039.814l1.628-6.077ZM219.225 33.848a1.573 1.573 0 0 0-.814 3.039l.015.004a1.574 1.574 0 0 0 .814-3.039l-.015-.004Z",
    fill: "#F9F9FB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#access-blocked_svg__c)",
    fill: "#4779FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.972 36.04a8 8 0 0 1 9.798 5.657l-2.897.777a5 5 0 0 0-9.66 2.588l-2.897.776a8 8 0 0 1 5.656-9.797ZM118.498 47.487a5.333 5.333 0 0 0-6.532-3.772l-14.81 3.969a5.333 5.333 0 0 0-3.772 6.532l1.898 7.084a5.333 5.333 0 0 0 6.532 3.77l14.811-3.968a5.334 5.334 0 0 0 3.771-6.532l-1.898-7.083Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.943 32.064a6.216 6.216 0 0 0-1.779 0c-.681.098-1.313.337-1.816.527l-.135.05-16.68 6.256-.407.152c-1.922.718-3.61 1.348-4.909 2.493a9.336 9.336 0 0 0-2.553 3.683c-.616 1.62-.613 3.421-.61 5.473V66.01c0 8.793 4.783 16.125 9.953 21.51 5.204 5.422 11.159 9.252 14.307 11.089l.128.075c.574.337 1.32.775 2.307.987a6.619 6.619 0 0 0 2.609 0c.987-.212 1.733-.65 2.307-.987l.128-.075c3.148-1.837 9.103-5.667 14.307-11.088 5.17-5.386 9.953-12.718 9.953-21.511V50.698c.003-2.052.006-3.854-.611-5.473a9.333 9.333 0 0 0-2.552-3.683c-1.3-1.145-2.987-1.775-4.909-2.493l-.407-.152-16.68-6.255-.135-.05c-.503-.19-1.136-.43-1.816-.528Zm-3.344 46.703c-1.172-2.936-2.026-7.051-2.236-11.797h9.298c-.21 4.746-1.064 8.861-2.236 11.797-.683 1.709-1.393 2.816-1.971 3.428-.198.21-.346.328-.442.393a2.703 2.703 0 0 1-.442-.392c-.578-.613-1.288-1.72-1.971-3.429Zm0-28.13c-1.208 3.025-2.078 7.301-2.253 12.228h9.332c-.175-4.927-1.045-9.203-2.253-12.227-.683-1.709-1.393-2.816-1.971-3.429a2.703 2.703 0 0 0-.442-.392 2.703 2.703 0 0 0-.442.392c-.578.613-1.288 1.72-1.971 3.429Zm-15.106 12.228h8.746c.21-6.38 1.506-11.989 3.423-15.668-6.57 2.184-11.466 8.283-12.169 15.668Zm.046 4.105h8.716c.253 6.201 1.533 11.642 3.407 15.238-6.442-2.141-11.274-8.046-12.123-15.238Zm34.946 0h-8.716c-.253 6.201-1.533 11.642-3.407 15.238 6.442-2.141 11.275-8.046 12.123-15.238Zm.133-2.267v.065-.131.066Zm-8.833-1.838h8.746c-.703-7.385-5.599-13.484-12.169-15.668 1.917 3.68 3.213 9.289 3.423 15.668Zm-8.909 19.795c0-.001.007-.004.023-.008a.077.077 0 0 1-.023.008Zm.25-.008a.064.064 0 0 1 .022.008s-.007-.001-.022-.008Zm.022-35.907c0 .001-.007.004-.023.008a.077.077 0 0 1 .023-.008Zm-.249.008c-.016-.004-.023-.007-.023-.008 0 0 .007.001.023.008Z",
    fill: "#4779FF"
  }))), _defs$8 || (_defs$8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "access-blocked_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 327,
    height: 112,
    rx: 12,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "access-blocked_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-15 188.268 -307.493)",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "access-blocked_svg__b",
    x1: 164,
    y1: 0,
    x2: 164,
    y2: 93.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4779FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779FF",
    stopOpacity: 0
  })))));
};

const AccessBlockedView = () => {
    const [country, setCountry] = useState();
    const { t } = useTranslation();
    const { getIpConfiguration } = useIpConfigurationContext();
    usePromise(getIpConfiguration, {
        deps: [getIpConfiguration, country],
        onResolve: (config) => setCountry(config === null || config === void 0 ? void 0 : config.country),
        retries: 2,
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'access-blocked__container', children: [jsxRuntimeExports.jsx("div", { className: 'access-blocked__icon', children: jsxRuntimeExports.jsx(SvgAccessBlocked, {}) }), jsxRuntimeExports.jsx("div", { className: 'access-blocked__content', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', children: t('dyn_access_blocked.content', { jurisdiction: country }) }) })] }));
};

var _path$I;
var _excluded$Q = ["title", "titleId"];
function _extends$Q() { return _extends$Q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$Q.apply(null, arguments); }
function _objectWithoutProperties$Q(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$Q(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$Q(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgWalletConnectLogo = function SvgWalletConnectLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$Q(_ref, _excluded$Q);
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$I || (_path$I = /*#__PURE__*/React.createElement("path", {
    d: "M3.84 2.345c2.573-3.127 6.747-3.127 9.32 0l.31.376a.463.463 0 0 1 0 .566l-1.06 1.287a.145.145 0 0 1-.232 0l-.427-.518c-1.795-2.18-4.707-2.18-6.502 0l-.457.555a.145.145 0 0 1-.233 0L3.5 3.324a.463.463 0 0 1 0-.566l.34-.413Zm11.512 2.661.943 1.146a.463.463 0 0 1 0 .566l-4.252 5.165a.29.29 0 0 1-.466 0L8.558 8.217a.073.073 0 0 0-.116 0l-3.018 3.666a.29.29 0 0 1-.466 0L.705 6.718a.463.463 0 0 1 0-.566l.943-1.146a.29.29 0 0 1 .466 0l3.018 3.666c.032.04.085.04.117 0l3.018-3.666a.29.29 0 0 1 .466 0l3.018 3.666c.033.04.085.04.117 0l3.018-3.666a.29.29 0 0 1 .466 0Z",
    fill: "currentColor"
  })));
};

const Indicator = ({ indicator, iconSize }) => {
    const walletConnectSizes = {
        container: (iconSize * 4) / 15,
        icon: (iconSize * 3) / 15,
    };
    const connectedSizes = {
        container: iconSize / 6,
        icon: iconSize / 9,
    };
    if (indicator === 'walletConnect') {
        return (jsxRuntimeExports.jsx("div", { className: 'indicator__wallet-connect', style: {
                height: pixelToRem(walletConnectSizes.container),
                width: pixelToRem(walletConnectSizes.container),
            }, children: jsxRuntimeExports.jsx(SvgWalletConnectLogo, { style: {
                    height: pixelToRem(walletConnectSizes.icon),
                    width: pixelToRem(walletConnectSizes.icon),
                } }) }));
    }
    return (jsxRuntimeExports.jsx("div", { className: 'indicator__container indicator__container--connected', style: {
            height: pixelToRem(connectedSizes.container),
            width: pixelToRem(connectedSizes.container),
        }, "data-testid": 'connected-indicator', children: jsxRuntimeExports.jsx("div", { className: 'indicator__icon', style: {
                height: pixelToRem(connectedSizes.icon),
                width: pixelToRem(connectedSizes.icon),
            } }) }));
};

const iconRatio = 7 / 11;
const IconWithSpinner = ({ iconSize = 24, Icon, isSpinning = false, className = '', indicator, customSpinnerColor, treatAsFunctionComponent, }) => {
    const realIconSize = iconSize * iconRatio;
    const spinnerIconSize = iconSize / 2;
    const effectiveContainerClassName = classNames('icon-with-spinner__container', className);
    const IconAsFC = Icon;
    return (jsxRuntimeExports.jsxs("div", { className: effectiveContainerClassName, style: {
            height: pixelToRem(iconSize),
            width: pixelToRem(iconSize),
        }, children: [Icon && (jsxRuntimeExports.jsxs("div", { style: {
                    height: pixelToRem(realIconSize),
                    width: pixelToRem(realIconSize),
                }, className: 'icon-with-spinner__icon-container', children: [treatAsFunctionComponent || typeof Icon === 'function' ? (jsxRuntimeExports.jsx(IconAsFC, { height: realIconSize, width: realIconSize })) : (Icon), indicator && jsxRuntimeExports.jsx(Indicator, { indicator: indicator, iconSize: iconSize })] })), isSpinning && !isLegacySafari() && (jsxRuntimeExports.jsx("div", { className: 'icon-with-spinner__spinner-container icon-with-spinner__animation', "data-chromatic": 'ignore', style: {
                    height: pixelToRem(iconSize),
                    width: pixelToRem(iconSize),
                }, children: jsxRuntimeExports.jsx(Spinner, { className: 'icon-with-spinner__spinner', customSpinnerColor: customSpinnerColor, size: spinnerIconSize }) }))] }));
};

const isEmailProviderEnabled = (providers) => providers !== undefined &&
    (isProviderEnabled(providers, ProviderEnum.Dynamic) ||
        isProviderEnabled(providers, ProviderEnum.Blocto) ||
        isProviderEnabled(providers, ProviderEnum.MagicLink));

const findEmailOtpWalletConnector = (wallets) => {
    const walletConnector = wallets
        .map(({ walletConnector }) => walletConnector)
        .find((walletConnector) => isEmailWalletConnector(walletConnector) &&
        // additional check to make sure the wallet connector actually implements its own otp workflow
        // if a walletConnector only uses Dynamic's OTP, then requiresNonDynamicEmailOtp should be false
        walletConnector.requiresNonDynamicEmailOtp);
    return walletConnector;
};

const useConnectWithOtp = ({ emailProvider: defaultProvider, } = {}) => {
    const context = useContext(ConnectWithOtpContext);
    if (!context) {
        throw new Error('useConnectWithOtp must be used within a DynamicContextProvider');
    }
    return {
        connectWithEmail: (email, options = {}) => context.connectWithEmail(email, Object.assign({ provider: defaultProvider }, options)),
        connectWithSms: context.connectWithSms,
        retryOneTimePassword: context.retryOneTimePassword,
        verifyOneTimePassword: context.verifyOneTimePassword,
    };
};

/** Hook used to connect with email on login */
const useEmailProvider = () => {
    const { projectSettings, walletConnectorOptions } = useInternalDynamicContext();
    const { connectWithEmail } = useConnectWithOtp();
    const { engageCaptcha } = useCaptchaContext();
    const emailWalletConnector = findEmailOtpWalletConnector(walletConnectorOptions);
    /** Connects with email, engaging the captcha if needed */
    const connectWithEmailFlow = useCallback((emailInput, onSuccess) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a;
        dynamicEvents.emit('authInit', {
            email: emailInput,
            option: emailInput,
            type: 'email',
        });
        try {
            if (((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.security.hCaptcha) === null || _a === void 0 ? void 0 : _a.enabled) &&
                (emailWalletConnector === null || emailWalletConnector === void 0 ? void 0 : emailWalletConnector.key) !== 'magicemailotp') {
                engageCaptcha({
                    authMethod: 'email',
                    onCaptchaSuccess: (captchaToken) => __awaiter$1(void 0, void 0, void 0, function* () {
                        yield connectWithEmail(emailInput, { captchaToken });
                        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                    }),
                });
            }
            else {
                yield connectWithEmail(emailInput);
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            }
        }
        catch (error) {
            dynamicEvents.emit('authFailure', {
                email: emailInput,
                option: emailInput,
                type: 'email',
            }, { error });
            throw error;
        }
    }), [
        connectWithEmail,
        engageCaptcha,
        projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.security.hCaptcha,
        emailWalletConnector,
    ]);
    return {
        connectWithEmail: connectWithEmailFlow,
    };
};

const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
const isEmailValid = (email) => EMAIL_REGEX.test(email);

var _rect$3, _path$H;
var _excluded$P = ["title", "titleId"];
function _extends$P() { return _extends$P = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$P.apply(null, arguments); }
function _objectWithoutProperties$P(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$P(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$P(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgArrowRightBackground = function SvgArrowRightBackground(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$P(_ref, _excluded$P);
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect$3 || (_rect$3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "var(--icon-background, var(--dynamic-hover))"
  })), _path$H || (_path$H = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.22 7.47a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 1 1-1.06-1.06l2.47-2.47H7.5a.75.75 0 0 1 0-1.5h8.19l-2.47-2.47a.75.75 0 0 1 0-1.06Z",
    fill: "var(--icon-arrow, var(--dynamic-text-secondary))"
  })));
};

const InlineSubmitButton = ({ disabled, highlighted, isFocused, isHovered, className, style, emailSubmitButtonInsideInput = false, }) => {
    if (!emailSubmitButtonInsideInput)
        return null;
    return (jsxRuntimeExports.jsx(IconButton, { "data-testid": 'in_line_submit_button', type: 'submit', className: classNames('inline-submit-button', className, {
            'inline-submit-button--active': isFocused || isHovered,
            'inline-submit-button--ready': highlighted,
        }), disabled: disabled, style: style, children: jsxRuntimeExports.jsx(SvgArrowRightBackground, {}) }));
};

const EmailForm = ({ isLoading, onSubmit, isEmailInvalid = false, currentEmail, emailSubmitButtonInsideInput = false, buttonCopyKey = 'dyn_login.email_form.submit_button.label', isDisabled = false, className, style, }) => {
    const { t } = useTranslation();
    const [emailInput, setEmailInput] = useState(currentEmail !== null && currentEmail !== void 0 ? currentEmail : '');
    /** Indicates the state of the input relative to the user's interaction */
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const handleEmailOnChangeEvent = (event) => {
        const { value } = event.currentTarget;
        setEmailInput(value);
    };
    const handleSubmit = (e) => __awaiter$1(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (!isEmailValid(emailInput)) {
            return;
        }
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(emailInput);
    });
    return (jsxRuntimeExports.jsxs("form", { className: classNames('login-with-email-form', className), style: style, "data-testid": 'email-form', onSubmit: (e) => handleSubmit(e), children: [jsxRuntimeExports.jsx(Input, { id: 'email_field', value: emailInput, onChange: handleEmailOnChangeEvent, copykey: 'dyn_login.email_form.email_field.label', label: t('dyn_login.email_form.email_field.label'), error: isEmailInvalid, message: isEmailInvalid && t('dyn_login.helper.email_form.invalid_email'), suffix: jsxRuntimeExports.jsx(InlineSubmitButton, { disabled: isLoading || isDisabled, highlighted: emailInput.length > 0, isFocused: isFocused, isHovered: isHovered, emailSubmitButtonInsideInput: emailSubmitButtonInsideInput }), disabled: isLoading || isDisabled, type: 'email', onPointerEnter: () => setIsHovered(true), onPointerLeave: () => setIsHovered(false), onFocus: () => setIsFocused(true), onBlur: () => setIsFocused(false), autoComplete: 'email' }), !emailSubmitButtonInsideInput && (jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'submit_button', buttonClassName: 'login-with-email-form__button', type: 'submit', loading: isLoading, disabled: isLoading || emailInput.length < 3 || isDisabled, buttonVariant: 'brand-primary', buttonPadding: 'login-screen-height', expanded: true, copykey: buttonCopyKey, typographyProps: {
                    color: 'inherit',
                }, children: t(buttonCopyKey) }))] }));
};

const LoginEmailForm = ({ isLoading, onSubmit, onSubmitError, currentEmail, className, style, }) => {
    var _a;
    const { projectSettings } = useInternalDynamicContext();
    const { view, pushView } = useViewContext();
    const { setVerificationUUID, setDisplayedDestination } = useVerification();
    const { setErrorMessage } = useErrorContext();
    const [invalidEmail, setInvalidEmail] = useState(false);
    const { connectWithEmail } = useEmailProvider();
    const handleEmailSubmitError = useCallback((error) => {
        if (error.message === 'Email is not valid') {
            setInvalidEmail(true);
        }
        else {
            setErrorMessage(error.message);
        }
        logger$1.debug(error);
        onSubmitError === null || onSubmitError === void 0 ? void 0 : onSubmitError();
    }, [setErrorMessage, onSubmitError]);
    /** Handles the user submit event */
    const handleSubmit = useCallback((emailInput) => __awaiter$1(void 0, void 0, void 0, function* () {
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        try {
            yield connectWithEmail(emailInput, () => {
                // Pass verification info to [EmailVerification]
                setVerificationUUID(undefined);
                setDisplayedDestination(emailInput);
                pushView('login-with-email-verification');
            });
        }
        catch (error) {
            handleEmailSubmitError(error);
            pushView(view.type);
        }
    }), [
        connectWithEmail,
        onSubmit,
        handleEmailSubmitError,
        pushView,
        view,
        setVerificationUUID,
        setDisplayedDestination,
    ]);
    if (!isEmailProviderEnabled(projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers)) {
        logger$1.error('Failed to render EmailSignInSection - no sign in provider enabled');
        return null;
    }
    return (jsxRuntimeExports.jsx(EmailForm, { onSubmit: handleSubmit, isLoading: isLoading, currentEmail: currentEmail, emailSubmitButtonInsideInput: (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.design.modal) === null || _a === void 0 ? void 0 : _a.emailSubmitButtonInsideInput, isEmailInvalid: invalidEmail, className: className, style: style }));
};

const IconListTile = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (jsxRuntimeExports.jsx(ListTile, Object.assign({}, props, { className: classNames(className, 'icon-list-tile'), children: jsxRuntimeExports.jsx("div", { className: 'icon-list-tile--children', children: children }) })));
};

const AccountExistsView = () => {
    const { existentAccountData } = useAccountExistsContext();
    const { t } = useTranslation();
    const { email, embeddedSocialSigninProvider } = existentAccountData || {};
    const existingSocialSignInProvider = getSocialSignInProviderForProviderEnum(embeddedSocialSigninProvider);
    const { socialProvider, setSocialProvider, socialWalletConnector } = useSocialRedirectContext();
    const findSocialIcon = useFindSocialIcon();
    const { mutate: handleNewLoging } = useMutation(() => __awaiter$1(void 0, void 0, void 0, function* () {
        setSocialProvider(existingSocialSignInProvider);
        yield (socialWalletConnector === null || socialWalletConnector === void 0 ? void 0 : socialWalletConnector.endSession());
        return socialWalletConnector === null || socialWalletConnector === void 0 ? void 0 : socialWalletConnector.connect(embeddedSocialSigninProvider);
    }));
    const renderFullMessage = () => {
        const messageTrail = embeddedSocialSigninProvider ? (t('dyn_account_exists.description_social')) : (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [t('dyn_account_exists.description_email'), " ", jsxRuntimeExports.jsx("strong", { children: email }), ' ', t('dyn_account_exists.trail_message_email')] }));
        return messageTrail;
    };
    return (jsxRuntimeExports.jsxs("div", { className: 'account-exists__container', children: [jsxRuntimeExports.jsx(UserProfileIcon, { className: 'account-exists__image' }), jsxRuntimeExports.jsxs("div", { className: 'account-exists__main', children: [jsxRuntimeExports.jsx("div", { className: 'account-exists__content', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'account-exists__content--secondary', copykey: 'dyn_account_exists', children: renderFullMessage() }) }), embeddedSocialSigninProvider ? (jsxRuntimeExports.jsxs(IconListTile, { dataTestId: `inline-${embeddedSocialSigninProvider}`, onClick: () => handleNewLoging(), className: 'social-sign-in--tile', children: [jsxRuntimeExports.jsx(IconWithSpinner, { Icon: findSocialIcon(embeddedSocialSigninProvider), isSpinning: socialProvider === existingSocialSignInProvider, iconSize: 32 }), jsxRuntimeExports.jsx(Typography, { variant: 'button_primary', copykey: 'dyn_account_exists.connect', children: t('dyn_account_exists.connect', {
                                    socialOauth: capitalize$1(embeddedSocialSigninProvider === null || embeddedSocialSigninProvider === void 0 ? void 0 : embeddedSocialSigninProvider.toString()),
                                }) })] }, embeddedSocialSigninProvider)) : (jsxRuntimeExports.jsx(LoginEmailForm, { isLoading: false, currentEmail: email }))] })] }));
};

const BridgeNextWalletToConnectLayout = ({ chainName, chainIcon, onClickAction, onClickClose }) => {
    const closeButton = onClickClose && (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: onClickClose, "data-testid": 'close-button', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    return (jsxRuntimeExports.jsxs("div", { className: 'bridge-next-wallet-to-connect-layout', children: [jsxRuntimeExports.jsx(ModalHeader, { trailing: closeButton, alignContent: 'bottom', children: chainIcon && (jsxRuntimeExports.jsx("div", { className: 'bridge-next-wallet-to-connect-layout__chain-icon', children: chainIcon })) }), jsxRuntimeExports.jsxs("div", { className: 'bridge-next-wallet-to-connect-layout__body', children: [jsxRuntimeExports.jsxs(Typography, { color: 'primary', variant: 'title', children: ["Nice! Now let\u2019s connect your ", chainName, " wallet"] }), jsxRuntimeExports.jsx(TypographyButton, { expanded: true, buttonPadding: 'large', onClick: onClickAction, children: `Connect ${chainName} wallet` })] })] }));
};

const BridgeNextWalletConnectionView = () => {
    const { setShowAuthFlow, bridgeChainsToConnect } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    if (!(bridgeChainsToConnect === null || bridgeChainsToConnect === void 0 ? void 0 : bridgeChainsToConnect.length)) {
        throw new DynamicError('No wallets to connect');
    }
    const [nextWalletToConnect] = bridgeChainsToConnect;
    const { chain } = nextWalletToConnect;
    const chainInfo = getChainInfoWithOverrides(chain);
    const ChainIcon = getChainIcon(chain);
    if (!chainInfo) {
        throw new DynamicError('No chain info found for chain', chain);
    }
    return (jsxRuntimeExports.jsx(BridgeNextWalletToConnectLayout, { chainName: chainInfo.blockchainName, chainIcon: jsxRuntimeExports.jsx(ChainIcon, {}), onClickAction: () => pushView('wallet-list'), onClickClose: () => setShowAuthFlow(false, { emitCancelAuth: true }) }));
};

const ConnectedWalletsListLayout = ({ title, body, onClickBack, onClickClose, onClickAction, actionButtonText = 'Continue', children, copykey, }) => {
    const closeButton = onClickClose && (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: onClickClose, "data-testid": 'close-button', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    const backButton = onClickBack && (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: onClickBack, "data-testid": 'back-button', children: jsxRuntimeExports.jsx(SvgChevronLeft, {}) }));
    return (jsxRuntimeExports.jsxs("div", { className: 'connected-wallets-list-layout', children: [jsxRuntimeExports.jsx(ModalHeader, { leading: backButton, trailing: closeButton, children: jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', copykey: copykey, children: title }) }), jsxRuntimeExports.jsxs("div", { className: 'connected-wallets-list-layout__body', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', className: 'connected-wallets-list-layout__body__text', children: body }), children, jsxRuntimeExports.jsx(TypographyButton, { buttonPadding: 'large', buttonVariant: 'primary', onClick: onClickAction, children: actionButtonText })] })] }));
};

const BridgeSummaryView = () => {
    const { primaryWallet, setShowAuthFlow, appName, bridgeChains = [], } = useInternalDynamicContext();
    const { t } = useTranslation();
    const onClickClose = () => setShowAuthFlow(false, { emitCancelAuth: true });
    const body = useMemo(() => {
        const blockchainNames = bridgeChains.map(({ chain }) => { var _a; return (_a = getChainInfoWithOverrides(chain)) === null || _a === void 0 ? void 0 : _a.blockchainName; });
        const [firstBlockchainName, secondBlockchainName] = blockchainNames;
        return t('dyn_bridge.summary_view.connection_succeed', {
            firstBlockchainName,
            secondBlockchainName,
        });
    }, [bridgeChains, t]);
    const createPrimaryWalletCard = (wallet) => {
        const PrimaryWalletChainIcon = getChainIcon(wallet.chain);
        const primaryWalletChainInfo = getChainInfoWithOverrides(wallet.chain);
        return (jsxRuntimeExports.jsx(DynamicBridgeWalletCard, { networkIcon: jsxRuntimeExports.jsx(PrimaryWalletChainIcon, {}), networkName: primaryWalletChainInfo === null || primaryWalletChainInfo === void 0 ? void 0 : primaryWalletChainInfo.displayName, children: jsxRuntimeExports.jsx(DynamicBridgeWalletCardBody, { walletKey: wallet.connector.key, walletAddress: wallet.address, walletBalance: 
                // eslint-disable-next-line react/jsx-wrap-multilines
                jsxRuntimeExports.jsx(Balance, { wallet: wallet, network: wallet.chain }) }) }));
    };
    return (jsxRuntimeExports.jsxs(ConnectedWalletsListLayout, { onClickClose: onClickClose, onClickAction: onClickClose, copykey: 'dyn_bridge.summary_view.title', title: t('dyn_bridge.summary_view.title', { appName }), body: body, children: [primaryWallet && createPrimaryWalletCard(primaryWallet), jsxRuntimeExports.jsx(MemoSecondaryWallets, { hideUnlinkAction: true })] }));
};

const BridgeWelcomeLayout = ({ body, chains = [], onClickAction, onClickClose, title, actionButtonText, copykey, }) => {
    const closeButton = onClickClose && (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: onClickClose, "data-testid": 'close-button', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    return (jsxRuntimeExports.jsxs("div", { className: 'bridge-welcome-layout', children: [jsxRuntimeExports.jsx(ModalHeader, { trailing: closeButton, alignContent: 'bottom', children: jsxRuntimeExports.jsx("div", { className: 'bridge-welcome-layout__chain-icon-group', children: [...chains].reverse().map((chain, index) => (jsxRuntimeExports.jsx("div", { className: 'bridge-welcome-layout__chain-icon', style: { zIndex: index }, children: chain.icon }, chain.id))) }) }), jsxRuntimeExports.jsxs("div", { className: 'bridge-welcome-layout__body', children: [jsxRuntimeExports.jsxs("div", { className: 'bridge-welcome-layout__message-container', children: [jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', copykey: copykey, children: title }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', children: body })] }), jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(Stepper, { children: chains.map((chain) => (jsxRuntimeExports.jsx(Step, { children: chain.name }, chain.id))) }) }), jsxRuntimeExports.jsx(TypographyButton, { buttonVariant: 'primary', buttonPadding: 'large', onClick: onClickAction, children: actionButtonText })] })] }));
};

const isChainInfoDefined = (chainInfo) => chainInfo !== undefined;
const BridgeWelcomeView = () => {
    const { appName, bridgeChains = [], setShowAuthFlow, } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const { t } = useTranslation();
    const body = useMemo(() => {
        const blockchainNames = bridgeChains.map(({ chain }) => { var _a; return (_a = getChainInfoWithOverrides(chain)) === null || _a === void 0 ? void 0 : _a.blockchainName; });
        const [firstBlockchainName, secondBlockchainName] = blockchainNames;
        return t('dyn_bridge.welcome_view.description', {
            firstBlockchainName,
            secondBlockchainName,
        });
    }, [bridgeChains, t]);
    const chains = useMemo(() => bridgeChains
        .map(({ chain }, index) => {
        const chainInfo = getChainInfoWithOverrides(chain);
        const ChainIcon = getChainIcon(chain);
        if (chainInfo && ChainIcon) {
            return {
                icon: jsxRuntimeExports.jsx(ChainIcon, {}),
                id: index,
                name: chainInfo.blockchainName,
            };
        }
        return undefined;
    })
        .filter(isChainInfoDefined), [bridgeChains]);
    return (jsxRuntimeExports.jsx(BridgeWelcomeLayout, { onClickClose: () => setShowAuthFlow(false, { emitCancelAuth: true }), title: t('dyn_bridge.welcome_view.title', { appName }), copykey: 'dyn_bridge.welcome_view.title', body: body, chains: chains, actionButtonText: t('dyn_bridge.welcome_view.button'), onClickAction: () => pushView('wallet-list') }));
};

const Captcha = ({ handleSuccess }) => {
    var _a;
    const { projectSettings } = useInternalDynamicContext();
    if (!((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.security.hCaptcha) === null || _a === void 0 ? void 0 : _a.siteKey))
        return null;
    return (jsxRuntimeExports.jsx("form", { "data-testid": 'captcha-form', children: jsxRuntimeExports.jsx(HCaptcha, { sitekey: projectSettings.security.hCaptcha.siteKey, onVerify: (token) => handleSuccess(token), theme: document.body.dataset.dynamicTheme }) }));
};

const CaptchaVerifyUser = () => {
    const { t } = useTranslation();
    const { captchaAuthState, setCaptchaToken } = useCaptchaContext();
    const handleSuccess = (captchaToken) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a;
        setCaptchaToken(captchaToken);
        yield ((_a = captchaAuthState === null || captchaAuthState === void 0 ? void 0 : captchaAuthState.onCaptchaSuccess) === null || _a === void 0 ? void 0 : _a.call(captchaAuthState, captchaToken));
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'captcha-verify-user__container', children: [jsxRuntimeExports.jsx(CaptchaWaveIcon, { className: 'captcha-verify-user__icon' }), jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'title', color: 'primary', className: 'captcha-verify-user__title', copykey: 'dyn_captcha.verify_user_title', children: t('dyn_captcha.verify_user_title') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'captcha-verify-user__subtitle', copykey: 'dyn_captcha.verify_user_subtitle', children: t('dyn_captcha.verify_user_subtitle') }), jsxRuntimeExports.jsx(Captcha, { handleSuccess: handleSuccess }), jsxRuntimeExports.jsx(PoweredByDynamic, { classNameRoot: 'captcha-verify-user__dynamic-logo' })] }));
};

var _path$G;
var _excluded$O = ["title", "titleId"];
function _extends$O() { return _extends$O = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$O.apply(null, arguments); }
function _objectWithoutProperties$O(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$O(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$O(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgCheckConnection = function SvgCheckConnection(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$O(_ref, _excluded$O);
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$G || (_path$G = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 64c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32C14.827 0 .5 14.327.5 32c0 17.673 14.327 32 32 32Zm12.845-39.155a1.667 1.667 0 1 0-2.357-2.357L27.5 37.976l-5.488-5.488a1.667 1.667 0 1 0-2.357 2.357l6.666 6.667c.651.65 1.707.65 2.357 0l16.667-16.667Z",
    fill: "#4779FF"
  })));
};

const getEmailProvider = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ email, environmentId, }) {
    try {
        const res = yield sdkApi().getEmailProvider({
            email,
            environmentId,
        });
        return res;
    }
    catch (e) {
        const data = yield logResponseError(e, 'Error getting email provider');
        throw new EmailProviderError(data.code);
    }
});
const createEmailVerification = (_b) => __awaiter$1(void 0, [_b], void 0, function* ({ email, environmentId, captchaToken, }) {
    try {
        const res = yield sdkApi().createEmailVerification({
            emailVerificationCreateRequest: {
                captchaToken,
                email,
            },
            environmentId,
        });
        return res;
    }
    catch (e) {
        const data = yield logResponseError(e, 'Error creating email verification');
        throw new EmailVerificationError(data.code);
    }
});
const signInWithEmailVerification = (_c) => __awaiter$1(void 0, [_c], void 0, function* ({ verificationToken, verificationUUID, environmentId, captchaToken, sessionPublicKey, }) {
    try {
        const res = yield sdkApi().signInWithEmailVerification({
            emailVerificationVerifyRequest: {
                captchaToken,
                sessionPublicKey,
                verificationToken,
                verificationUUID,
            },
            environmentId,
        });
        return res;
    }
    catch (e) {
        const data = yield logResponseError(e, 'Error email signin');
        if (data.error.code === 'missing_from_list') {
            throw new NoAccessError({ email: data.payload.email });
        }
        if (data.code === 'email_associated_with_different_provider') {
            throw new AccountExistsError(data.error, data.payload);
        }
        if (data.error.code === 'sandbox_maximum_threshold_reached') {
            throw new SandboxMaximumThresholdReachedError(data.error.message);
        }
        throw new EmailVerificationError(data.code);
    }
});
const retryEmailVerification = (_d) => __awaiter$1(void 0, [_d], void 0, function* ({ email, environmentId, verificationUUID, }) {
    try {
        const res = yield sdkApi().retryEmailVerification({
            emailVerificationRetryRequest: {
                email,
                verificationUUID,
            },
            environmentId,
        });
        return res;
    }
    catch (e) {
        const data = yield logResponseError(e, 'Error retrying email verification');
        throw new EmailVerificationError(data.code);
    }
});
const verifyEmail = (_e) => __awaiter$1(void 0, [_e], void 0, function* ({ verificationToken, verificationUUID, environmentId, }) {
    try {
        const res = yield sdkApi().verifyEmailVerification({
            emailVerificationVerifyRequest: {
                verificationToken,
                verificationUUID,
            },
            environmentId,
        });
        return res;
    }
    catch (e) {
        const data = yield logResponseError(e, 'Error linking email');
        if (data.code === UnprocessableEntityErrorCode.UserHasAlreadyAccountWithEmail) {
            throw new UserHasAccountWithEmailError(data.error);
        }
        if (data.error.code === 'sandbox_maximum_threshold_reached') {
            throw new SandboxMaximumThresholdReachedError(data.error.message);
        }
        throw new EmailVerificationError(data.code);
    }
});

const createSmsVerification = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ isoCountryCode, phoneNumber, phoneCountryCode, environmentId, captchaToken, }) {
    try {
        return yield sdkApi().createSmsVerification({
            environmentId,
            smsVerificationCreateRequest: {
                captchaToken,
                isoCountryCode,
                phoneCountryCode,
                phoneNumber,
            },
        });
    }
    catch (e) {
        const data = yield logResponseError(e, 'Error creating phone number verification');
        throw new SmsVerificationError(data.error, data.code);
    }
});
const signInWithSmsVerification = (_b) => __awaiter$1(void 0, [_b], void 0, function* ({ verificationToken, verificationUUID, environmentId, captchaToken, sessionPublicKey, }) {
    var _c;
    try {
        return yield sdkApi().signInWithSmsVerification({
            environmentId,
            smsVerificationVerifyRequest: {
                captchaToken,
                sessionPublicKey,
                verificationToken,
                verificationUUID,
            },
        });
    }
    catch (e) {
        const data = yield logResponseError(e, 'Error signin phone number');
        if (((_c = data.error) === null || _c === void 0 ? void 0 : _c.code) === 'missing_from_list') {
            throw new NoAccessError({ phoneNumber: data.payload.phoneNumber });
        }
        if (data.code === 'wrong_sms_verification_token') {
            throw new SmsVerificationError(Locale.getInstance().t('dyn_login.helper.phone_number_form.invalid_sms_verification'), data.code);
        }
        if (data.error.code === 'sandbox_maximum_threshold_reached') {
            throw new SandboxMaximumThresholdReachedError(data.error.message);
        }
        throw new SmsVerificationError(data.error, data.code);
    }
});
const retrySmsVerification = (_d) => __awaiter$1(void 0, [_d], void 0, function* ({ isoCountryCode, phoneCountryCode, phoneNumber, environmentId, verificationUUID, }) {
    try {
        return yield sdkApi().retrySmsVerification({
            environmentId,
            smsVerificationRetryRequest: {
                isoCountryCode,
                phoneCountryCode,
                phoneNumber,
                verificationUUID,
            },
        });
    }
    catch (e) {
        const data = yield logResponseError(e, 'Error retrying phone number verification');
        throw new SmsVerificationError(data.error, data.code);
    }
});
const verifySms = (_e) => __awaiter$1(void 0, [_e], void 0, function* ({ verificationToken, verificationUUID, environmentId, }) {
    try {
        return yield sdkApi().verifySmsVerification({
            environmentId,
            smsVerificationVerifyRequest: {
                verificationToken,
                verificationUUID,
            },
        });
    }
    catch (e) {
        const data = yield logResponseError(e, 'Error verifying phone number');
        logger$1.error(data.error);
        if (data.error.code === 'sandbox_maximum_threshold_reached') {
            throw new SandboxMaximumThresholdReachedError(data.error.message);
        }
        throw new SmsVerificationError(data.error, data.code);
    }
});

/**
 * Same as useOtpVerificationRequest, but requires you to pass it a handleVerificationRequired method as param.
 * This is to avoid a circular logic issue, as handleVerificationRequired needs to use the logic in this file as well.
 */
const useOtpVerificationRequestRaw = () => {
    const { environmentId, user, userWithMissingInfo } = useInternalDynamicContext();
    const { verificationUUID: contextVerificationUUID } = useVerification();
    const verifyOtp = useCallback((handleVerificationRequired, verificationToken, destination, localVerificationUUID) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a;
        if (!user && !userWithMissingInfo)
            throw new DynamicError(USER_NOT_LOGGED_IN);
        // VerificationUUID is saved in the context in case the view changes
        // after a profile update (changing the view from edit profile to verify email)
        if (!localVerificationUUID && !contextVerificationUUID)
            throw new DynamicError('No verification UUID is available');
        const verificationUUID = (localVerificationUUID !== null && localVerificationUUID !== void 0 ? localVerificationUUID : contextVerificationUUID);
        const verify = destination === 'email' ? verifyEmail : verifySms;
        const updateSelfResponse = yield verify({
            environmentId,
            verificationToken,
            verificationUUID,
        });
        const updatedUser = updateSelfResponse.user;
        const missingFields = (_a = updatedUser === null || updatedUser === void 0 ? void 0 : updatedUser.missingFields) !== null && _a !== void 0 ? _a : [];
        const requiredVerificationDestination = getVerificationDestinationFromNextView(updateSelfResponse.nextView);
        // If verification is not needed then we can update the user profile immediately.
        storeAuthTokenAndUser(updateSelfResponse);
        if (requiredVerificationDestination)
            return handleVerificationRequired({
                destination: requiredVerificationDestination,
                missingFields,
                updateUserProfileResponse: updateSelfResponse,
            });
        return {
            isEmailVerificationRequired: false,
            isSmsVerificationRequired: false,
            missingFields,
            updateUserProfileResponse: updateSelfResponse,
        };
    }), [contextVerificationUUID, environmentId, user, userWithMissingInfo]);
    return { verifyOtp };
};
/**
 * Hook to make verifications and already handle nuances like handling additional verifications
 * and setting the user jwt on success
 */
// ATTENTION: THIS IS EXPOSED TO THE PUBLIC!
const useOtpVerificationRequest = () => {
    const handleVerificationRequired = useHandleVerificationRequired();
    const { verifyOtp } = useOtpVerificationRequestRaw();
    return useMemo(() => ({
        verifyOtp: (token, destination, verificationUUID) => verifyOtp(handleVerificationRequired, token, destination, verificationUUID),
    }), [handleVerificationRequired, verifyOtp]);
};

const getResponseInfo = (response, destination) => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (destination === 'email')
        return {
            displayDestination: (_a = response.emailVerification) === null || _a === void 0 ? void 0 : _a.email,
            verificationUUID: (_b = response.emailVerification) === null || _b === void 0 ? void 0 : _b.verificationUUID,
        };
    return {
        displayDestination: formatPhone('+' +
            ((_d = (_c = response.smsVerification) === null || _c === void 0 ? void 0 : _c.phoneCountryCode) !== null && _d !== void 0 ? _d : '') +
            ((_f = (_e = response.smsVerification) === null || _e === void 0 ? void 0 : _e.phoneNumber) !== null && _f !== void 0 ? _f : '')),
        verificationUUID: (_g = response.smsVerification) === null || _g === void 0 ? void 0 : _g.verificationUUID,
    };
};
const useHandleVerificationRequired = () => {
    const { setVerificationUUID, setDisplayedDestination } = useVerification();
    const { environmentId } = useInternalDynamicContext();
    const { verifyOtp } = useOtpVerificationRequestRaw();
    const collectNecessaryVerificationData = useCallback((destination, updateUserProfileResponse) => __awaiter$1(void 0, void 0, void 0, function* () {
        // We just need to make sure we have the emailVerification/smsVerification data
        // If it's already present, use it as is
        if ((destination === 'email' &&
            updateUserProfileResponse.emailVerification) ||
            (destination === 'sms' && updateUserProfileResponse.smsVerification))
            return updateUserProfileResponse;
        const userField = destination === 'email' ? 'email' : 'phoneNumber';
        // If verification is required but we don't have the userField's verification data,
        // make another call to the api to get it
        if (!updateUserProfileResponse.user[userField])
            throw new VerificationDataCollectionError(`missing ${userField} field to perform update`);
        const validatedUserFields = yield userFieldsSchema.validate({
            [userField]: updateUserProfileResponse.user[userField],
        });
        const { emailVerification, smsVerification } = yield updateUserProfileFields(environmentId, validatedUserFields);
        if ((destination === 'email' && !emailVerification) ||
            (destination === 'sms' && !smsVerification))
            throw new VerificationDataCollectionError(`could not get ${destination} verification data from api`);
        return Object.assign(Object.assign({}, updateUserProfileResponse), { emailVerification,
            smsVerification });
    }), [environmentId]);
    const handleVerificationRequired = useCallback((_a) => __awaiter$1(void 0, [_a], void 0, function* ({ updateUserProfileResponse: updateUserProfileResponseRaw, missingFields, destination, }) {
        const updateUserProfileResponse = yield collectNecessaryVerificationData(destination, updateUserProfileResponseRaw);
        // Use this information in the Verification view
        const { displayDestination, verificationUUID } = getResponseInfo(updateUserProfileResponse, destination);
        setDisplayedDestination(displayDestination);
        setVerificationUUID(verificationUUID);
        const scopedVerify = (verificationToken) => __awaiter$1(void 0, void 0, void 0, function* () {
            return verifyOtp(handleVerificationRequired, verificationToken, destination, verificationUUID);
        });
        if (destination === 'email')
            return {
                isEmailVerificationRequired: true,
                isSmsVerificationRequired: false,
                missingFields,
                updateUserProfileResponse,
                verifyOtp: scopedVerify,
            };
        return {
            isEmailVerificationRequired: false,
            isSmsVerificationRequired: true,
            missingFields,
            updateUserProfileResponse,
            verifyOtp: scopedVerify,
        };
    }), [
        collectNecessaryVerificationData,
        setDisplayedDestination,
        setVerificationUUID,
        verifyOtp,
    ]);
    return handleVerificationRequired;
};

const useUpdateUser = (validationSchemaStripUnknown) => {
    const { environmentId, userWithMissingInfo } = useInternalDynamicContext();
    const { setRetryData } = useVerification();
    const { selectedPhoneCountry } = useFieldsState();
    const handleVerificationRequired = useHandleVerificationRequired();
    const updateUser = useCallback((userFields, options) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a, _b;
        // `stripUnknown: true` will automatically strip out any values in the metadata object
        // so we need to pull out the metadata object here and then re-add it after stripping unknown fields
        let { metadata } = userFields;
        // when a user has already logged in but a custom field was added to env, in order to not clear the old fields
        metadata = metadata
            ? Object.assign(Object.assign({}, userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.metadata), metadata) : userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.metadata;
        // we dont add user.metadata from edit profile because it is already in the metadata request for updateUser
        const validatedUserFields = yield userFieldsSchema.validate(userFields, {
            stripUnknown: validationSchemaStripUnknown,
        });
        // If there is a phone number, store it in the retry verification data
        // in case we need to perform sms verification
        if (validatedUserFields.phoneNumber &&
            validatedUserFields.phoneNumber.length > 0 &&
            selectedPhoneCountry.current)
            setRetryData({
                dialCode: selectedPhoneCountry.current.dialCode,
                iso2: selectedPhoneCountry.current.iso2,
                phone: validatedUserFields.phoneNumber,
            });
        const updateUserProfileResponse = yield updateUserProfileFields((_a = options === null || options === void 0 ? void 0 : options.userEnvironmentId) !== null && _a !== void 0 ? _a : environmentId, Object.assign(Object.assign({}, validatedUserFields), { metadata }));
        // check if decoded JWT still somehow has missing fields, we can't proceed if it does
        const missingFields = (_b = updateUserProfileResponse.user.missingFields) !== null && _b !== void 0 ? _b : [];
        const requiredVerificationDestination = getVerificationDestinationFromNextView(updateUserProfileResponse.nextView);
        if (requiredVerificationDestination)
            return handleVerificationRequired({
                destination: requiredVerificationDestination,
                missingFields,
                updateUserProfileResponse,
            });
        return {
            isEmailVerificationRequired: false,
            isSmsVerificationRequired: false,
            missingFields,
            updateUserProfileResponse,
        };
    }), [
        userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.metadata,
        validationSchemaStripUnknown,
        selectedPhoneCountry,
        setRetryData,
        environmentId,
        handleVerificationRequired,
    ]);
    return updateUser;
};

// eslint-disable-next-line multiline-comment-style
/** This function is used to verify that an update request with modal is valid
 * @returns empty string if request is valid, a string with the error message otherwise
 */
const validateUpdateRequest = (fields, user, projectSettings) => {
    // Catch no fields
    if (!fields.length)
        return 'At least one field must be provided for editing';
    // Catch no user
    if (!user)
        return 'No signed-in user';
    // Catch field not set in dashboard
    const allUserFields = getUserProfileFields({
        customFields: projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.customFields,
        projectSettingsKyc: projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.kyc,
        user,
    });
    for (const field of fields) {
        // i.e. If any of the provided fields is not found in the project settings fields
        if (!allUserFields.find(({ name }) => name === field))
            return `Please ensure field "${field}" is enabled under "Configurations > Onboarding > Information capture" in your app's dashboard before using it with updateUserWithModal`;
    }
    return '';
};

/** Saves the values updated by the user */
const saveUserValues = (_a, setShowAuthFlow_1, pushView_1, resolve_1, reject_1) => __awaiter$1(void 0, [_a, setShowAuthFlow_1, pushView_1, resolve_1, reject_1], void 0, function* ({ fields: newValues, updateUserResult: { isEmailVerificationRequired, isSmsVerificationRequired, }, }, setShowAuthFlow, pushView, resolve, reject) {
    // If no verification is needed, we are done
    if (!isEmailVerificationRequired && !isSmsVerificationRequired) {
        resolve(newValues);
        return;
    }
    // Show verification view
    setShowAuthFlow(true, {
        ignoreIfIsEmbeddedWidget: false,
        performMultiWalletChecks: false,
    });
    if (isEmailVerificationRequired) {
        pushView('verify-email');
        // Subscribe to email verification result
        dynamicEvents.once('emailVerificationResult', (wasSuccessful, newEmail) => {
            // Make sure we're using the correct, updated email. User might have changed it mid-OTP
            newValues.email = newEmail;
            wasSuccessful
                ? resolve(newValues)
                : reject('Failed to verify email, no fields were updated');
        });
        return;
    }
    pushView('verify-sms');
    // Subscribe to sms verification result
    dynamicEvents.once('smsVerificationResult', (wasSuccessful, { phone: newPhone }) => {
        // Make sure we're using the correct, updated phone number. User might have changed it mid-OTP
        newValues.phoneNumber = newPhone;
        wasSuccessful
            ? resolve(newValues)
            : reject('Failed to verify phone number, no fields were updated');
    });
});
// eslint-disable-next-line multiline-comment-style
/** This hook allows to open the widget modal and expose any fields for editing.
 * The fields must have been previously enabled in the dashboard
 */
const useUpdateUserWithModal = (updateUser) => {
    const { user, projectSettings, setShowAuthFlow } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const editorContext = useContext(UserFieldEditorContext);
    if (!editorContext)
        throw new DynamicError('useUserUpdateRequest can only be used inside the context of DynamicContextProvider');
    const { open: promptUserForValues } = editorContext;
    const updateUserWithModal = useCallback((fields, options) => new Promise((resolve, reject) => {
        // Catch invalid requests
        const errorResponse = validateUpdateRequest(fields, user, projectSettings);
        if (errorResponse) {
            reject(errorResponse);
            return;
        }
        // Get user values
        promptUserForValues({
            fields,
            submitText: options === null || options === void 0 ? void 0 : options.submitText,
            subtitle: options === null || options === void 0 ? void 0 : options.subtitle,
            title: options === null || options === void 0 ? void 0 : options.title,
        }, updateUser)
            .then((updateValues) => saveUserValues(updateValues, setShowAuthFlow, pushView, resolve, reject))
            .catch((error) => {
            if (/email already exists/gi.test(error))
                throw error;
            reject(error);
        });
    }), [
        user,
        projectSettings,
        promptUserForValues,
        updateUser,
        setShowAuthFlow,
        pushView,
    ]);
    return updateUserWithModal;
};

// Hook only available internally
const useUserUpdateRequestInternal = ({ validationSchemaStripUnknown, }) => {
    const updateUser = useUpdateUser(validationSchemaStripUnknown);
    const updateUserWithModal = useUpdateUserWithModal(updateUser);
    return { updateUser, updateUserWithModal };
};

const OnboardingUserDataForm = ({ children, userProfile, disableSubmit, }) => {
    const { policiesConsentInnerComponent, userWithMissingInfo } = useInternalDynamicContext();
    const { error } = useErrorContext();
    const { completeAuth } = useUserAuth({});
    const { updateUser } = useUserUpdateRequestInternal({
        validationSchemaStripUnknown: false,
    });
    const onSubmit = useCallback((formValues) => __awaiter$1(void 0, void 0, void 0, function* () {
        yield completeAuth({
            updateJwtFunction: () => __awaiter$1(void 0, void 0, void 0, function* () { return updateUser(formValues); }),
        });
    }), [completeAuth, updateUser]);
    const showNameServiceField = useMemo(() => {
        var _a;
        return (_a = userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.missingFields) === null || _a === void 0 ? void 0 : _a.some((field) => field.name === NAME_SERVICE_FIELD_NAME);
    }, [userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.missingFields]);
    const { fetch: loading, formikInitialValues, formikValidationSchema, enforcePolicies, onFormSubmit, } = useUserDataForm({
        fields: (userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.missingFields) || [],
        onSubmit,
        userProfile,
    });
    const policiesConsentInnerComponentArray = [
        policiesConsentInnerComponent,
    ].flat();
    return (jsxRuntimeExports.jsx(Formik, { onSubmit: onFormSubmit, initialValues: formikInitialValues, validationSchema: formikValidationSchema, children: ({ errors, touched, values }) => {
            var _a;
            const isSubmitBtnDisabled = disableSubmit ||
                (enforcePolicies &&
                    (policiesConsentInnerComponentArray === null || policiesConsentInnerComponentArray === void 0 ? void 0 : policiesConsentInnerComponentArray.length) !==
                        ((_a = values.policiesConsentArray) === null || _a === void 0 ? void 0 : _a.length));
            return (jsxRuntimeExports.jsx(Form, { className: 'user-data-form__form', children: jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [children, showNameServiceField && jsxRuntimeExports.jsx(SubdomainField, { showDetails: true }), error && (jsxRuntimeExports.jsx(Alert, { icon: 'error', variant: 'error', className: 'user-data-form__error', children: error })), jsxRuntimeExports.jsx(UserDataFields, { fields: userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.missingFields, errors: errors, touched: touched, policiesConsentInnerComponentArray: policiesConsentInnerComponentArray }), jsxRuntimeExports.jsx(TypographyButton, { type: 'submit', loading: loading, disabled: isSubmitBtnDisabled, buttonVariant: 'primary', expanded: true, buttonPadding: 'login-screen-height', children: "Continue" })] }) }));
        } }));
};

const CollectUserDataView = () => {
    var _a;
    const { appName, projectSettings, network, selectedWalletConnector: walletConnector, handleLogOut, onboardingImageUrl, userWithMissingInfo, } = useInternalDynamicContext();
    const nameService = useFetchNameService();
    const { t } = useTranslation();
    if (!userWithMissingInfo) {
        return null;
    }
    const _isSupportedNetwork = !network || isSupportedNetwork({ network, walletConnector });
    const shouldDisplayWrongNetworkState = !_isSupportedNetwork && Boolean(walletConnector);
    const walletAddress = (_a = userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.verifiedCredentials.find((verifiedCredential) => verifiedCredential.id === userWithMissingInfo.lastVerifiedCredentialId)) === null || _a === void 0 ? void 0 : _a.address;
    return (jsxRuntimeExports.jsxs("div", { className: 'collect-user-data', "data-testid": 'collect-user-data-view', children: [jsxRuntimeExports.jsxs("div", { className: 'collect-user-data__network-container', children: [jsxRuntimeExports.jsxs("div", { className: 'collect-user-data__img-container', children: [(nameService === null || nameService === void 0 ? void 0 : nameService.avatar) ? (jsxRuntimeExports.jsx("img", { src: nameService.avatar, alt: '', className: 'collect-user-data__img collect-user-data__img--rounded' })) : (jsxRuntimeExports.jsx(AuthProviderIcon, { iconSize: 28 })), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', weight: 'medium', className: 'collect-user-data__wallet-address', children: (nameService === null || nameService === void 0 ? void 0 : nameService.name) || shortenWalletAddress(walletAddress, 3, 3) })] }), walletConnector && (jsxRuntimeExports.jsx(NetworkPicker, { currentNetwork: network, connector: walletConnector, showNetworkName: true, buttonClassName: 'collect-user-data__network-picker-button', mainClassName: 'collect-user-data__network-picker' }))] }), onboardingImageUrl && (jsxRuntimeExports.jsx("img", { className: 'collect-user-data__main-img', src: onboardingImageUrl, alt: 'onboarding' })), shouldDisplayWrongNetworkState && (jsxRuntimeExports.jsx(ErrorContainer, { withIcon: false, className: 'collect-user-data__error--not-supported', copykey: 'dyn_collect_user_data.not_supported_network.error_message', children: t('dyn_collect_user_data.not_supported_network.error_message') })), jsxRuntimeExports.jsxs("div", { className: classNames('collect-user-data__form', {
                    'collect-user-data__form--error': shouldDisplayWrongNetworkState,
                }), children: [jsxRuntimeExports.jsx("div", { className: 'collect-user-data__success-icon', children: jsxRuntimeExports.jsx(Icon, { color: 'text-primary', size: 'large', children: jsxRuntimeExports.jsx(SvgCheckConnection, {}) }) }), jsxRuntimeExports.jsx(OnboardingUserDataForm, { disableSubmit: shouldDisplayWrongNetworkState, userProfile: userWithMissingInfo, children: shouldDisplayWrongNetworkState ? (jsxRuntimeExports.jsxs("div", { className: 'collect-user-data__welcome-container', children: [jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', className: 'collect-user-data__welcome-title', copykey: 'dyn_collect_user_data.not_supported_network.title', children: t('dyn_collect_user_data.not_supported_network.title') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', copykey: 'dyn_collect_user_data.not_supported_network.description', children: t('dyn_collect_user_data.not_supported_network.description') })] })) : (jsxRuntimeExports.jsxs("div", { className: 'collect-user-data__welcome-container', children: [jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', className: 'collect-user-data__welcome-title', copykey: 'dyn_collect_user_data.greeting', children: (projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.general.collectUserDataWelcomeHeader) ||
                                        t('dyn_collect_user_data.greeting', { appName }) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', copykey: 'dyn_collect_user_data.description', children: (projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.general.collectUserDataWelcomeMessage) ||
                                        t('dyn_collect_user_data.description') })] })) }), jsxRuntimeExports.jsx(TextButton, { className: 'collect-user-data__log-out', onClick: handleLogOut, copykey: 'dyn_collect_user_data.log_out_button', children: t('dyn_collect_user_data.log_out_button') })] })] }));
};

const CollectUserDataViewNoWallet = ({ userIdentification, userIdentificationOverride }) => {
    var _a;
    const { appName, handleLogOut, projectSettings, onboardingImageUrl, userWithMissingInfo, } = useInternalDynamicContext();
    const { t } = useTranslation();
    if (!userWithMissingInfo) {
        return null;
    }
    return (jsxRuntimeExports.jsxs("div", { className: 'collect-user-data-login-no-wallet', "data-testid": 'collect-user-data-login-no-wallet', children: [onboardingImageUrl && (jsxRuntimeExports.jsx("img", { className: 'collect-user-data-login-no-wallet__main-img', src: onboardingImageUrl, alt: 'onboarding' })), jsxRuntimeExports.jsxs("div", { className: 'collect-user-data-login-no-wallet__user-info-container', children: [jsxRuntimeExports.jsx("div", { className: 'collect-user-data-login-no-wallet__icon-container', children: jsxRuntimeExports.jsx(UserAvatar, { user: userWithMissingInfo }) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', weight: 'medium', className: 'collect-user-data-login-no-wallet__user-identification', children: (_a = userIdentificationOverride !== null && userIdentificationOverride !== void 0 ? userIdentificationOverride : userWithMissingInfo[userIdentification]) !== null && _a !== void 0 ? _a : getUserIdentifier(userWithMissingInfo) })] }), jsxRuntimeExports.jsxs("div", { className: 'collect-user-data-login-no-wallet__form', children: [jsxRuntimeExports.jsx("div", { className: 'collect-user-data-login-no-wallet__success-icon', children: jsxRuntimeExports.jsx(Icon, { color: 'text-primary', size: 'large', children: jsxRuntimeExports.jsx(SvgCheckConnection, {}) }) }), jsxRuntimeExports.jsx(OnboardingUserDataForm, { userProfile: userWithMissingInfo, children: jsxRuntimeExports.jsxs("div", { className: 'collect-user-data-login-no-wallet__welcome-container', children: [jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', className: 'collect-user-data-login-no-wallet__welcome-title', copykey: 'dyn_collect_user_data.greeting', children: (projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.general.collectUserDataWelcomeHeader) ||
                                        t('dyn_collect_user_data.greeting', { appName }) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', copykey: 'dyn_collect_user_data.description', children: (projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.general.collectUserDataWelcomeMessage) ||
                                        t('dyn_collect_user_data.description') })] }) }), jsxRuntimeExports.jsx(TextButton, { className: 'collect-user-data-login-no-wallet__log-out', onClick: handleLogOut, copykey: 'dyn_collect_user_data.log_out_button', children: t('dyn_collect_user_data.log_out_button') })] })] }));
};

var _path$F;
var _excluded$N = ["title", "titleId"];
function _extends$N() { return _extends$N = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$N.apply(null, arguments); }
function _objectWithoutProperties$N(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$N(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$N(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgPencilAltIcon = function SvgPencilAltIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$N(_ref, _excluded$N);
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$F || (_path$F = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.638 2.862a.667.667 0 0 0-.943 0L7.167 8.391v.943h.942l5.53-5.53a.667.667 0 0 0 0-.942Zm-1.886-.943a2 2 0 1 1 2.829 2.829l-5.724 5.724a.667.667 0 0 1-.471.195H6.5A.667.667 0 0 1 5.833 10V8.115c0-.177.07-.347.196-.472l5.723-5.724ZM4.5 4a.667.667 0 0 0-.667.667V12c0 .368.299.667.667.667h7.333A.667.667 0 0 0 12.5 12V8.667a.667.667 0 0 1 1.333 0V12a2 2 0 0 1-2 2H4.5a2 2 0 0 1-2-2V4.667a2 2 0 0 1 2-2h3.333a.667.667 0 0 1 0 1.333H4.5Z",
    fill: "currentColor"
  })));
};

const EmailConfirmationWaitingView = () => {
    const { pushView } = useViewContext();
    const { clearStatesOnBackClick, selectedWalletConnector: walletConnector } = useInternalDynamicContext();
    const { t } = useTranslation();
    if (walletConnector && !isEmailWalletConnector(walletConnector)) {
        throw new Error('Wallet connector is not email provider');
    }
    const emailConnector = walletConnector;
    const onClickResetEmail = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        yield (emailConnector === null || emailConnector === void 0 ? void 0 : emailConnector.endSession());
        pushView('login-with-email-or-wallet');
        clearStatesOnBackClick();
    }), [pushView, emailConnector, clearStatesOnBackClick]);
    return (jsxRuntimeExports.jsxs("div", { className: 'email-confirmation-waiting-view', children: [jsxRuntimeExports.jsx("div", { className: 'email-confirmation-waiting-view__header-icon', children: jsxRuntimeExports.jsx(IconWithSpinner, { Icon: SignInWithEmailIcon, iconSize: 80, isSpinning: true }) }), jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'title', color: 'primary', className: 'email-confirmation-waiting-view__title', copykey: 'dyn_email_confirmation.title', children: t('dyn_email_confirmation.title') }), jsxRuntimeExports.jsx(Typography, { weight: 'regular', variant: 'body_normal', color: 'secondary', copykey: 'dyn_email_confirmation.description', children: t('dyn_email_confirmation.description') }), jsxRuntimeExports.jsxs("div", { className: 'email-confirmation-waiting-view__email-container', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', weight: 'medium', as: 'span', children: emailConnector === null || emailConnector === void 0 ? void 0 : emailConnector.email }), jsxRuntimeExports.jsx(IconButton, { onClick: onClickResetEmail, className: 'email-confirmation-waiting-view__edit-icon-button', "data-testid": 'email-confirmation-waiting-view__edit-button', children: jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgPencilAltIcon, {}) }) })] }), jsxRuntimeExports.jsx("div", { className: 'email-confirmation-waiting-view__note', children: jsxRuntimeExports.jsx(Typography, { weight: 'regular', variant: 'body_small', color: 'secondary', copykey: 'dyn_email_confirmation.note', children: t('dyn_email_confirmation.note') }) }), jsxRuntimeExports.jsx(PoweredByDynamic, { classNameRoot: 'email-confirmation-waiting-view__powered_by_dynamic_footer' })] }));
};

var _circle$6, _path$E, _path2$2;
var _excluded$M = ["title", "titleId"];
function _extends$M() { return _extends$M = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$M.apply(null, arguments); }
function _objectWithoutProperties$M(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$M(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$M(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSignInWithEmail = function SvgSignInWithEmail(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$M(_ref, _excluded$M);
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle$6 || (_circle$6 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "currentColor"
  })), _path$E || (_path$E = /*#__PURE__*/React.createElement("path", {
    d: "M51 29.333a1.333 1.333 0 0 0-1.333 0l-17.334 9.8L15 29.333a1.333 1.333 0 0 0-2 1.16V42a4 4 0 0 0 4 4h30.667a4 4 0 0 0 4-4V30.5A1.333 1.333 0 0 0 51 29.333Z",
    fill: "#fff"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.667 18H17a4 4 0 0 0-4 4v2.5a1.334 1.334 0 0 0 .667 1.16l18 10.167a1.333 1.333 0 0 0 1.333 0L51 25.66a1.334 1.334 0 0 0 .667-1.16V22a4 4 0 0 0-4-4Z",
    fill: "#fff"
  })));
};

/** Min ms that need to pass before the component is able to call the callback on unmount */
const MIN_EVENT_TIME = 10;
const useOnUnmount = (callback) => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    useEffect(() => {
        const mountedAt = new Date();
        return () => {
            // Avoid calling callback as cause of a React Strict Mode rerender
            if (new Date().getTime() - mountedAt.getTime() < MIN_EVENT_TIME)
                return;
            callbackRef.current();
        };
    }, []);
};

const normalizeNewValue = (currentValue, updatedValue) => {
    if (!currentValue) {
        return updatedValue.split('');
    }
    if (updatedValue.length > 2) {
        return updatedValue.split('');
    }
    if (updatedValue === '') {
        return [];
    }
    if (currentValue[0] === updatedValue[0]) {
        return [updatedValue[1]];
    }
    return [updatedValue[0]];
};
const PinInput = ({ autoFocus, disabled, inputIndex, inputMode, isValidated, name, onChange, pattern, type, value, values, hasError, }) => {
    const inputRef = useRef(null);
    const handleChange = (e) => {
        const currentValue = values[inputIndex];
        const updatedValue = e.target.value.replace(/\s+/g, '');
        const newValues = [...values];
        const normalizedValues = normalizeNewValue(currentValue, updatedValue).slice(0, newValues.length - inputIndex);
        const setValues = (normalizedValue, index) => (newValues[inputIndex + index] = normalizedValue);
        const regex = type === 'number' ? /(^$)|(\d+)/ : /.*/;
        const shouldChange = normalizedValues.every((normalizedValue) => regex.test(normalizedValue));
        let inputElement = inputRef.current;
        if (!shouldChange) {
            return;
        }
        if (normalizedValues.length) {
            normalizedValues.forEach(setValues);
        }
        else {
            newValues[inputIndex] = '';
        }
        onChange(newValues);
        // in order to maintain focus after copy/paste action
        // of 1 or many characters, we need to loop through values
        // and set current element to be the next sibling
        for (let i = 0; i < normalizedValues.length; i++) {
            inputElement = inputElement === null || inputElement === void 0 ? void 0 : inputElement.nextElementSibling;
        }
        // if current element is of input type, we can safely focus it
        if (normalizedValues && inputElement instanceof HTMLInputElement) {
            inputElement.focus();
        }
    };
    const handleKeyDown = ({ key, }) => {
        var _a;
        if (key === 'Backspace' && values[inputIndex] === '' && inputIndex > 0) {
            const prevInput = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.previousElementSibling;
            /* istanbul ignore next */
            if (prevInput instanceof HTMLInputElement) {
                prevInput.focus();
            }
        }
    };
    useEffect(() => {
        var _a;
        if (autoFocus && inputIndex === 0) {
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [autoFocus, inputIndex]);
    return (jsxRuntimeExports.jsx("input", { ref: inputRef, className: classNames('pin-input__input', {
            'pin-input__input--error': Boolean(hasError),
            'pin-input__input--success': Boolean(isValidated),
        }), disabled: disabled, name: name, value: value, onChange: handleChange, onKeyDown: handleKeyDown, "data-testid": inputIndex, pattern: pattern, inputMode: inputMode, tabIndex: 0 }));
};

const isComplete = (values) => values.every((value) => value);
const PinField = ({ handleComplete, initialValue, inputMode, isLoading, isValidated, pattern, type = 'number', hasError, onChange, disabled, }) => {
    const containerRef = useRef(null);
    const [values, setValues] = useState(initialValue);
    const handleOnChange = (values) => {
        const value = values.join('');
        setValues(values);
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
        if (isComplete(values)) {
            handleComplete(value);
        }
    };
    // Required to listen for errors and refocus on the first element
    useEffect(() => {
        var _a, _b;
        if (hasError) {
            setValues(initialValue);
            (_b = (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('input').item(0)) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [hasError, initialValue, containerRef]);
    return (jsxRuntimeExports.jsx("div", { className: 'pin-field__container', ref: containerRef, children: values.map((value, index) => (jsxRuntimeExports.jsx(PinInput, { values: values, inputIndex: index, value: value, onChange: handleOnChange, disabled: isLoading || disabled, inputMode: inputMode, isValidated: isValidated, pattern: pattern, type: type, autoFocus: true, hasError: hasError }, `pin_input_${index}`))) }));
};

var _path$D;
var _excluded$L = ["title", "titleId"];
function _extends$L() { return _extends$L = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$L.apply(null, arguments); }
function _objectWithoutProperties$L(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$L(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$L(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgCheckCircle = function SvgCheckCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$L(_ref, _excluded$L);
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$D || (_path$D = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.666a5.333 5.333 0 1 0 0 10.667A5.333 5.333 0 0 0 8 2.666ZM1.333 8a6.667 6.667 0 1 1 13.333 0A6.667 6.667 0 0 1 1.333 8Zm9.138-1.805c.26.26.26.682 0 .943L7.804 9.804a.667.667 0 0 1-.942 0L5.528 8.471a.667.667 0 1 1 .943-.943l.862.862 2.195-2.195c.26-.26.683-.26.943 0Z",
    fill: "currentColor"
  })));
};

const useCountdown = ({ callback, seconds }) => {
    const [remainingSeconds, setRemainingSeconds] = useState(seconds);
    const timeoutRef = useRef();
    const startCountdown = () => {
        if (timeoutRef.current) {
            return setRemainingSeconds(seconds);
        }
        runCountdown();
    };
    const stopCountdown = () => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
    };
    const runCountdown = () => {
        timeoutRef.current = setTimeout(() => {
            setRemainingSeconds((prevSeconds) => prevSeconds - 1);
        }, 1000);
    };
    useEffect(() => {
        if (!timeoutRef.current)
            return;
        if (remainingSeconds <= 0) {
            if (callback)
                callback();
            return;
        }
        runCountdown();
        return () => clearTimeout(timeoutRef.current);
    }, [remainingSeconds, callback]);
    return { remainingSeconds, startCountdown, stopCountdown };
};

const RetrySendVerificationCodeSection = ({ retryHandler, secondsToRetry = 15, disabled = false, className }) => {
    const { t } = useTranslation();
    const [retried, setRetried] = useState(false);
    const { remainingSeconds, startCountdown } = useCountdown({
        callback: () => setRetried(false),
        seconds: secondsToRetry,
    });
    const { isLoading, mutate: retry } = useMutation(retryHandler, {
        onSuccess: () => {
            setRetried(true);
            startCountdown();
        },
    });
    const containerClassName = classNames('retry-send-verification-code-section', className);
    if (retried) {
        return (jsxRuntimeExports.jsxs("div", { className: containerClassName, children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', copykey: 'dyn_otp_verification.resend_code_in', children: t('dyn_otp_verification.resend_code_in', { remainingSeconds }) }), jsxRuntimeExports.jsxs("span", { className: 'retry-send-verification-code-section__confirmation', children: [jsxRuntimeExports.jsx(Icon, { color: 'success-1', children: jsxRuntimeExports.jsx(SvgCheckCircle, {}) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'medium', color: 'primary', copykey: 'dyn_otp_verification.code_sent', children: t('dyn_otp_verification.code_sent') })] })] }));
    }
    return (jsxRuntimeExports.jsxs("div", { className: containerClassName, children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'medium', color: 'secondary', copykey: 'dyn_otp_verification.code_not_received', className: 'retry-send-verification-code-section__not-received', children: t('dyn_otp_verification.code_not_received') }), jsxRuntimeExports.jsx(TextButton, { className: 'email-verification__text-button', disabled: isLoading || disabled, onClick: () => retry(), copykey: 'dyn_otp_verification.resend_code', children: t('dyn_otp_verification.resend_code') })] }));
};

const SECONDS_TO_RETRY = 15;
const EmailVerification = ({ isEmailRecoveryFlow = false, showRetryButton: _showRetryButton = true, showTransferMessage: _showTransferMessage = false, }) => {
    var _a, _b, _c, _d;
    const { environmentId, handleLogOut, setShowAuthFlow, projectSettings, user, userWithMissingInfo, walletConnectorOptions, primaryWallet, } = useInternalDynamicContext();
    const { pushView, clearStackAndPushInitialView } = useViewContext();
    const { error, setError, setErrorMessage } = useErrorContext();
    const { loading, setLoading } = useLoadingContext();
    const [showRetryButton, setShowRetryButton] = useState(_showRetryButton);
    const [showTransferMessage, setShowTransferMessage] = useState(_showTransferMessage);
    const { getEOAWallet } = useSmartWallets();
    // Use a state to ensure UI is updated, but also a ref to access in effect cleanup
    const [isValidated, _setIsValidated] = useState(false);
    const isValidatedRef = useRef(isValidated);
    const setIsValidated = (value) => {
        _setIsValidated(value);
        isValidatedRef.current = value;
    };
    const { displayedDestination: email, verificationUUID, setVerificationUUID, } = useVerification();
    const { t } = useTranslation();
    const { addRecoveryEmail } = usePasskeyRecovery();
    const { isTurnkeyWallet, hasTurnkeyVerifiedCredentialAuthenticator, hasRecoveryEmail, } = useIsTurnkeyWallet();
    const isTurnkeyProviderEnabled = isTurnkeyEnabled(projectSettings);
    const { initAuth, completeAuth, cancelAuth } = useUserAuth({
        authMethod: 'email',
    });
    const { verifyOneTimePassword, retryOneTimePassword } = useConnectWithOtp();
    const { generateSessionKey, shouldRegisterSessionKeysOnSignin } = useEmbeddedWalletSessionKeys({
        environmentId,
        projectSettings,
    });
    // When true, causes the component to call emailVerificationX callback on unmount
    const callCallbackOnUnmount = useRef(true);
    useOnUnmount(() => {
        if (!callCallbackOnUnmount.current)
            return;
        const emailString = email !== null && email !== void 0 ? email : '';
        dynamicEvents.emit('emailVerificationResult', isValidatedRef.current, emailString);
        if (!isValidatedRef.current)
            dynamicEvents.emit('authFailure', { email: emailString, option: emailString, type: 'email' }, 'user-cancelled');
        if (!email)
            logger$1.warn("WARNING: emitted emailVerificationResult with incomplete params because useVerification's displayedDestination was undefined");
    });
    const { verifyOtp } = useOtpVerificationRequest();
    const completeSignInFlow = useCallback((updateUserProfileResponse) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _e, _f, _g, _h, _j, _k;
        if (updateUserProfileResponse.nextView === 'verified-and-transferred') {
            setShowTransferMessage === null || setShowTransferMessage === void 0 ? void 0 : setShowTransferMessage(true);
        }
        if (isEmailRecoveryFlow) {
            pushView('passkey-recovery-add-email', {
                canSkipAddingEmail: false,
                isFromEmailVerification: true,
            });
            return true;
        }
        if (!isTurnkeyWallet) {
            return false;
        }
        // If the user has a turnkey embedded wallet and no recovery email, add the email as a recovery email
        // This logic should run even if the turnkey provider is not enabled anymore
        // (e.g. user created the wallet and then the settings were disalbed)
        if (hasTurnkeyVerifiedCredentialAuthenticator &&
            !hasRecoveryEmail &&
            ((_e = updateUserProfileResponse === null || updateUserProfileResponse === void 0 ? void 0 : updateUserProfileResponse.user) === null || _e === void 0 ? void 0 : _e.email)) {
            storeAuthTokenAndUser(updateUserProfileResponse);
            yield addRecoveryEmail(updateUserProfileResponse.user.email);
            setShowAuthFlow(false);
            return true;
        }
        // The logic below is needed when we capture an email after a user
        // authenticated with Sms/Twitter etc And we need to capture and email.
        if (isTurnkeyProviderEnabled) {
            const isAutomaticWalletCreation = (_g = (_f = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _f === void 0 ? void 0 : _f.embeddedWallets) === null || _g === void 0 ? void 0 : _g.automaticEmbeddedWalletCreation;
            const eoaWallet = primaryWallet && getEOAWallet(primaryWallet);
            const isSessionKeyCompatible = (primaryWallet && isSessionKeyCompatibleWallet(primaryWallet)) ||
                (eoaWallet && isSessionKeyCompatibleWallet(eoaWallet));
            const isUsingPregeneratedWallets = Boolean(isAutomaticWalletCreation &&
                (!((_j = (_h = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _h === void 0 ? void 0 : _h.embeddedWallets) === null || _j === void 0 ? void 0 : _j.forceAuthenticatorAtSignup) ||
                    isSessionKeyCompatible));
            if (isUsingPregeneratedWallets) {
                const primaryChain = findPrimaryEmbeddedChain(projectSettings);
                // Pregenerated wallet was created during an
                // additional email validation step as part of onboarding
                // cannot rely on newUser JWT field here due to session being counted twice
                // when authentication happens followed by a separate email kyc step
                const embeddedWalletVerifiedCredential = findEmbeddedWalletFromVerifiedCredentials(createUserProfileFromSdkUser(updateUserProfileResponse.user), [primaryChain]);
                if (!embeddedWalletVerifiedCredential) {
                    throw new Error('Could not find an embedded wallet');
                }
                const walletOption = walletConnectorOptions === null || walletConnectorOptions === void 0 ? void 0 : walletConnectorOptions.find((option) => option.key === embeddedWalletVerifiedCredential.walletName);
                if (!(walletOption === null || walletOption === void 0 ? void 0 : walletOption.walletConnector)) {
                    throw new Error('Could not find connector for embedded wallet');
                }
                const wallet = walletOption.walletConnector.createWallet({
                    address: embeddedWalletVerifiedCredential.address || '',
                    chain: walletOption.walletConnector.connectedChain,
                    connector: walletOption.walletConnector,
                    id: embeddedWalletVerifiedCredential.id,
                    isAuthenticated: false,
                    key: (_k = embeddedWalletVerifiedCredential.walletName) !== null && _k !== void 0 ? _k : '',
                });
                updatePrimaryWalletId(embeddedWalletVerifiedCredential.id);
                dynamicEvents.emit('embeddedWalletCreated', wallet, embeddedWalletVerifiedCredential, user);
            }
            if (isUsingPregeneratedWallets || !isAutomaticWalletCreation) {
                setShowAuthFlow(false);
                return true;
            }
        }
        return false;
    }), [
        isEmailRecoveryFlow,
        isTurnkeyWallet,
        hasTurnkeyVerifiedCredentialAuthenticator,
        hasRecoveryEmail,
        isTurnkeyProviderEnabled,
        pushView,
        addRecoveryEmail,
        setShowAuthFlow,
        (_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _a === void 0 ? void 0 : _a.embeddedWallets) === null || _b === void 0 ? void 0 : _b.automaticEmbeddedWalletCreation,
        (_d = (_c = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _c === void 0 ? void 0 : _c.embeddedWallets) === null || _d === void 0 ? void 0 : _d.forceAuthenticatorAtSignup,
        primaryWallet,
        getEOAWallet,
        walletConnectorOptions,
        user,
    ]);
    const handleEmailVerification = useCallback((verificationToken) => __awaiter$1(void 0, void 0, void 0, function* () {
        setError(undefined);
        setLoading(true);
        // Sign in flow
        if (!user && !userWithMissingInfo) {
            return initAuth({
                onVerifySuccess: () => setIsValidated(true),
                options: { email },
                showSuccessMessage: true,
                verifyFunction: () => __awaiter$1(void 0, void 0, void 0, function* () {
                    if (!verificationUUID) {
                        // Try the new headless login flow that doesn't require a verificationUUID
                        return verifyOneTimePassword(verificationToken, {
                            // Skip setting the user auth token because it can trigger view re-renders
                            skipSetUserAndAuthToken: true,
                        });
                    }
                    let sessionPublicKey = undefined;
                    if (shouldRegisterSessionKeysOnSignin()) {
                        const keypair = yield generateSessionKey();
                        sessionPublicKey = keypair.publicKey;
                    }
                    return signInWithEmailVerification({
                        environmentId,
                        sessionPublicKey,
                        verificationToken,
                        verificationUUID,
                    });
                }),
            });
        }
        // Verify flow (still depends on verificationUUID)
        if (!verificationUUID) {
            return cancelAuth();
        }
        return completeAuth({
            completeSignInFlow: (updateUserResponse) => __awaiter$1(void 0, void 0, void 0, function* () { return completeSignInFlow(updateUserResponse); }),
            onValidUpdatedJwt: () => {
                // This causes emaiLVerificationSuccess to be raised, so it should be set as soon
                // as verification doesn't fail. Don't move it below
                setIsValidated(true);
            },
            options: { email, isEmailRecoveryFlow },
            updateJwtFunction: () => __awaiter$1(void 0, void 0, void 0, function* () { return verifyOtp(verificationToken, 'email', verificationUUID); }),
        });
    }), [
        setError,
        setLoading,
        verificationUUID,
        user,
        userWithMissingInfo,
        completeAuth,
        email,
        isEmailRecoveryFlow,
        cancelAuth,
        initAuth,
        environmentId,
        completeSignInFlow,
        verifyOtp,
        verifyOneTimePassword,
        generateSessionKey,
        shouldRegisterSessionKeysOnSignin,
    ]);
    const handleRetry = () => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            // Try the new headless login flow that doesn't need useVerification()
            if (!verificationUUID || !email) {
                yield retryOneTimePassword();
                setVerificationUUID(undefined);
                setError(undefined);
                return;
            }
            const { verificationUUID: newVerificationUUID } = yield retryEmailVerification({
                email,
                environmentId,
                verificationUUID,
            });
            setVerificationUUID(newVerificationUUID);
            setError(undefined);
        }
        catch (error) {
            logger$1.debug(error);
            setErrorMessage(error.code);
            if (error.code === 'too_many_email_verification_attempts') {
                setShowRetryButton(false);
            }
            if (error.code === 'invalid_email_verification') {
                clearStackAndPushInitialView();
            }
        }
        finally {
            setLoading(false);
        }
    });
    const EmailIcon = useMemo(() => {
        const EmailIcon = (props) => (jsxRuntimeExports.jsx(Icon, { color: 'brand-primary', children: jsxRuntimeExports.jsx(SvgSignInWithEmail, Object.assign({}, props)) }));
        return EmailIcon;
    }, []);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [error && (jsxRuntimeExports.jsx(ErrorContainer, { withIcon: false, className: 'email-verification__error-message', children: error })), jsxRuntimeExports.jsxs("div", { className: classNames('email-verification__container', {
                    'email-verification__container--error': Boolean(error),
                }), children: [showTransferMessage && (jsxRuntimeExports.jsx("div", { className: 'email-verification__transfer-message', copykey: 'dyn_otp_verification.email.complete', children: t('dyn_otp_verification.email.complete') })), isValidated ? (jsxRuntimeExports.jsx("div", { className: 'email-verification__icon-container', children: jsxRuntimeExports.jsx(IconWithStatus, { containerClassName: 'email-verification__icon--verified', Icon: EmailIcon, iconSize: 64, InnerIcon: SvgCheck }) })) : (jsxRuntimeExports.jsx(IconWithSpinner, { Icon: EmailIcon, iconSize: 96, isSpinning: true, className: 'email-verification__icon-with-spinner' })), jsxRuntimeExports.jsxs("div", { className: 'email-verification__copy-text-container', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', copykey: 'dyn_otp_verification.description', children: t('dyn_otp_verification.description') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'bold', color: 'secondary', children: shortenEmail(email) })] }), jsxRuntimeExports.jsx(PinField, { initialValue: Array(6).fill(''), isLoading: loading, handleComplete: handleEmailVerification, isValidated: isValidated, inputMode: 'numeric', pattern: '[0-9]*', hasError: Boolean(error), onChange: () => setError(undefined) }), showRetryButton && (jsxRuntimeExports.jsx(RetrySendVerificationCodeSection, { className: 'email-verification__retry-container', retryHandler: handleRetry, secondsToRetry: SECONDS_TO_RETRY })), (user || userWithMissingInfo) && !isEmailRecoveryFlow && (jsxRuntimeExports.jsx(TextButton, { className: 'email-verification__log-out', onClick: handleLogOut, copykey: 'dyn_otp_verification.log_out_button', children: t('dyn_otp_verification.log_out_button') }))] })] }));
};

const typographyColor = {
    error: 'error-1',
    notice: 'brand-primary',
    success: 'green-1',
};
const ModalHeaderBanner = ({ messageKey, type = 'error', disableTruncate = false, }) => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsx(AnimatePresence, { animationComponent: jsxRuntimeExports.jsx(VerticalDrawerTransition, { style: { width: '100%' } }), children: Boolean(messageKey) && (jsxRuntimeExports.jsx("div", { className: classNames('modal-header-banner', {
                'modal-header-banner__error': type === 'error',
                'modal-header-banner__notice': type === 'notice',
                'modal-header-banner__success': type === 'success',
            }), children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: typographyColor[type], truncate: disableTruncate === false, copykey: messageKey, children: t(messageKey || '') }) })) }));
};

const OTPVerificationView = ({ onClickBack, onClickEditDestination, isLoading, disabled, displayedDestination, description, onPinComplete, isValid, error, retryHandler, onPinChange, successBannerTextKey, MainIcon, hideHeader, appendAboveOTPInput, appendToEnd, }) => {
    const { t } = useTranslation();
    const backButton = onClickBack && (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: onClickBack, "data-testid": 'back-button', children: jsxRuntimeExports.jsx(SvgArrowLeft, {}) }));
    const titleCopyKey = useMemo(() => isValid
        ? 'dyn_otp_verification.verification_succeeded'
        : 'dyn_otp_verification.confirm_code', [isValid]);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [!hideHeader && (jsxRuntimeExports.jsx(ModalHeader, { alignContent: 'bottom', leading: onClickBack && backButton, children: jsxRuntimeExports.jsx("div", { className: 'otp-verification-view__status-header', children: jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'title', color: 'primary', className: 'otp-verification-view__title', copykey: titleCopyKey, children: t(titleCopyKey) }) }) })), successBannerTextKey && (jsxRuntimeExports.jsx(ModalHeaderBanner, { type: 'notice', messageKey: successBannerTextKey, disableTruncate: true })), jsxRuntimeExports.jsx(ModalHeaderBanner, { type: 'error', messageKey: error === null || error === void 0 ? void 0 : error.message }), jsxRuntimeExports.jsxs("div", { className: classNames('otp-verification-view', {
                    'otp-verification-view--message': Boolean(successBannerTextKey || error),
                }), children: [isValid && (jsxRuntimeExports.jsx(IconWithStatus, { Icon: MainIcon, iconSize: 64, InnerIcon: SvgCheck })), !isValid && (jsxRuntimeExports.jsx(IconWithSpinner, { Icon: MainIcon, iconSize: 96, isSpinning: isLoading, className: 'otp-verification-view__icon-with-spinner', treatAsFunctionComponent: true })), jsxRuntimeExports.jsxs("div", { className: 'otp-verification-view__body', children: [isValid && (jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', copykey: 'dyn_otp_verification.hang_tight', children: t('dyn_otp_verification.hang_tight') })), !isValid &&
                                (description ? (jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', copykey: 'dyn_otp_verification.description', children: description })) : (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', copykey: 'dyn_otp_verification.description', children: t('dyn_otp_verification.description') }), jsxRuntimeExports.jsxs("div", { className: 'otp-verification-view__destination-container', children: [displayedDestination && (jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'bold', color: 'secondary', children: displayedDestination })), onClickEditDestination && (jsxRuntimeExports.jsx(IconButton, { onClick: onClickEditDestination, "data-testid": 'otp-verification-view__edit-button', children: jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgPencilAltIcon, {}) }) }))] })] })))] }), appendAboveOTPInput, jsxRuntimeExports.jsx(PinField, { initialValue: Array(6).join('.').split('.'), isLoading: isLoading, handleComplete: onPinComplete, isValidated: isValid, inputMode: 'numeric', pattern: '[0-9]*', hasError: Boolean(error), onChange: onPinChange, disabled: disabled }), retryHandler && (jsxRuntimeExports.jsx(RetrySendVerificationCodeSection, { className: 'otp-verification-view__retry-container', retryHandler: retryHandler })), appendToEnd] })] }));
};

const EmailIcon = (props) => (jsxRuntimeExports.jsx(Icon, { color: 'brand-primary', children: jsxRuntimeExports.jsx(SvgSignInWithEmail, Object.assign({}, props, { "data-testid": 'sign-in-with-email-icon' })) }));

const EmailWalletOTPVerificationView = () => {
    const { pushView } = useViewContext();
    const [error, setError] = useState();
    const { selectedWalletConnector: emailWalletConnector, clearStatesOnBackClick, } = useInternalDynamicContext();
    if (!emailWalletConnector ||
        !isEmailOTPWalletConnector(emailWalletConnector)) {
        throw new Error('Current wallet is not EmailWalletConnector');
    }
    const { email } = emailWalletConnector;
    if (!email) {
        throw new Error('EmailWalletOtpVerificationView requires a email');
    }
    const handleBackClick = () => {
        emailWalletConnector.clearEmail();
        clearStatesOnBackClick();
        pushView('login-with-email-or-wallet');
        dynamicEvents.emit('authFailure', {
            email,
            option: email,
            type: 'email',
        }, 'user-cancelled');
    };
    const { data: isValid, isLoading, mutate: onSubmit, } = useMutation((otp) => emailWalletConnector.verifyOneTimePassword(otp), {
        onFailure: (error) => {
            setError(error);
            dynamicEvents.emit('emailVerificationResult', false, email);
        },
        onSuccess: () => {
            dynamicEvents.emit('emailVerificationResult', true, email);
        },
    });
    return (jsxRuntimeExports.jsx(OTPVerificationView, { MainIcon: EmailIcon, displayedDestination: shortenEmail(email), error: error, onClickBack: handleBackClick, isLoading: isLoading, onPinComplete: onSubmit, isValid: isValid === true, retryHandler: emailWalletConnector.retryOneTimePassword.bind(emailWalletConnector), onPinChange: () => setError(undefined), onClickEditDestination: handleBackClick, successBannerTextKey: 'dyn_magic_verification.banner_text' }));
};

var _circle$5, _path$C;
var _excluded$K = ["title", "titleId"];
function _extends$K() { return _extends$K = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$K.apply(null, arguments); }
function _objectWithoutProperties$K(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$K(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$K(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgDeleteEmbeddedHero = function SvgDeleteEmbeddedHero(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$K(_ref, _excluded$K);
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle$5 || (_circle$5 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FF4646"
  })), _path$C || (_path$C = /*#__PURE__*/React.createElement("path", {
    d: "M35.4 19.2a3.2 3.2 0 0 0-6.4 0V32a3.2 3.2 0 0 0 6.4 0V19.2ZM32.2 41.6a3.2 3.2 0 0 0 0 6.4h.032a3.2 3.2 0 0 0 0-6.4H32.2Z",
    fill: "#F9F9FB"
  })));
};

const TurnkeyErrorMap = {
    0: 'Operation was canceled.',
    16: 'Invalid Passkey signature. Select the passkey for this account and device.',
    3: 'You reached the limit of passkeys for this account.',
    5: 'Invalid Passkey signature. Select the passkey for this account and device.',
    7: 'The code is invalid or expired.',
};
const reactNativePasskeyErrors = {
    RequestFailed: 'Request failed. Please try again.',
    UserCancelled: TurnkeyErrorMap[0],
};
const DOMExceptionErrorMap = {
    NotAllowedError: 'Request Cancelled. Select a device or password manager to set up a passkey.',
};
const getProperErrorMessage = (originalError) => {
    var _a;
    if (typeof originalError === 'string') {
        return originalError;
    }
    if ('reason' in originalError) {
        return originalError.reason;
    }
    if (originalError instanceof DOMException) {
        return DOMExceptionErrorMap[originalError.name] || 'Something went wrong';
    }
    if ('cause' in originalError) {
        if (((_a = originalError === null || originalError === void 0 ? void 0 : originalError.cause) === null || _a === void 0 ? void 0 : _a.code) !== undefined) {
            if (originalError.cause.code === ACCESS_BLOCKED_ERROR_CODE) {
                throw new AccessBlockedError();
            }
            return TurnkeyErrorMap[originalError.cause.code];
        }
        if (originalError.cause &&
            'error' in originalError.cause &&
            typeof originalError.cause.error === 'string' &&
            reactNativePasskeyErrors[originalError.cause.error]) {
            return reactNativePasskeyErrors[originalError.cause.error];
        }
    }
    if ('code' in originalError && originalError.code) {
        if (originalError.code === ACCESS_BLOCKED_ERROR_CODE) {
            throw new AccessBlockedError();
        }
        return TurnkeyErrorMap[originalError.code];
    }
    if ('error' in originalError &&
        typeof originalError.error === 'string' &&
        reactNativePasskeyErrors[originalError.error]) {
        return reactNativePasskeyErrors[originalError.error];
    }
    return 'Something went wrong';
};

const EmbeddedDeleteView = () => {
    const { primaryWallet, setShowAuthFlow, environmentId, handleLogOut } = useInternalDynamicContext();
    const [isAcknowledgementChecked, setIsAcknowledgementChecked] = useState(false);
    const [error, setError] = useState(undefined);
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const { isSmartWallet, getEOAWallet } = useSmartWallets();
    const errorText = useMemo(() => {
        if (!error) {
            return undefined;
        }
        if (error instanceof DynamicError) {
            return error.message;
        }
        try {
            return getProperErrorMessage(error);
        }
        catch (e) {
            return 'An unexpected error occured while deleting your embedded wallets.';
        }
    }, [error]);
    const handleDeleteEmbeddedWallets = () => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a;
        if (!primaryWallet) {
            return;
        }
        setIsLoading(true);
        try {
            const deleteEmbeddedWalletsRawPayload = yield getDeleteEmbeddedWalletsRequest({
                environmentId,
            });
            const connector = isSmartWallet(primaryWallet)
                ? (_a = getEOAWallet(primaryWallet)) === null || _a === void 0 ? void 0 : _a.connector
                : primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector;
            const signedDeleteWalletsRequest = yield connector.stampDeleteSubOrganizationRequest({
                request: deleteEmbeddedWalletsRawPayload,
            });
            yield deleteEmbeddedWallets({
                deleteEmbeddedWalletsRequest: signedDeleteWalletsRequest,
                environmentId,
            });
            handleLogOut();
        }
        catch (error) {
            setError(error);
        }
        finally {
            setIsLoading(false);
        }
    });
    const contentHeader = (jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx("div", { className: 'embedded-delete-view__body__description', children: jsxRuntimeExports.jsx("div", { className: 'embedded-delete-view__header', children: jsxRuntimeExports.jsx(SvgDeleteEmbeddedHero, {}) }) }) }));
    return (jsxRuntimeExports.jsxs("div", { className: 'embedded-delete-view', children: [jsxRuntimeExports.jsx("div", { className: 'embedded-delete-view__body', children: contentHeader }), errorText && jsxRuntimeExports.jsx(ErrorContainer, { children: errorText }), jsxRuntimeExports.jsxs("div", { className: 'embedded-delete-view__body__card', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', style: { letterSpacing: '-0.15px' }, copykey: 'dyn_embedded_delete.description_1', children: t('dyn_embedded_delete.description_1') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', style: { fontWeight: 'bold', letterSpacing: '-0.15px' }, copykey: 'dyn_embedded_delete.description_2', children: t('dyn_embedded_delete.description_2') })] }), jsxRuntimeExports.jsx("div", { className: 'embedded-delete-view__body__confirm_card', children: jsxRuntimeExports.jsxs("button", { className: 'embedded-delete-view__body__card__acknowledgement', "data-testid": 'embedded-delete-checkbox', onClick: () => setIsAcknowledgementChecked(!isAcknowledgementChecked), children: [jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(Checkbox, { checked: isAcknowledgementChecked, className: 'embedded-delete-view__body__card__statement__checkbox', id: 'embedded-reveal-checkbox-1' }) }), jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'primary', style: { letterSpacing: '-0.15px' }, copykey: 'dyn_embedded_delete.acknowledgement', children: t('dyn_embedded_delete.acknowledgement') }) })] }) }), jsxRuntimeExports.jsxs("div", { className: 'embedded-delete-view__body__cta_button_wrapper', children: [jsxRuntimeExports.jsx(TypographyButton, { buttonPadding: 'large', buttonVariant: 'primary', typographyProps: {
                            color: 'inherit',
                        }, onClick: () => setShowAuthFlow(false), disabled: false, loading: false, dataTestId: 'embedded-delete-cancel-button', copykey: 'dyn_embedded_delete.cancel_button', buttonClassName: 'embedded-delete-view__body__button', children: t('dyn_embedded_delete.cancel_button') }), jsxRuntimeExports.jsx(TypographyButton, { buttonPadding: 'large', buttonVariant: 'brand-primary', typographyProps: {
                            color: 'inherit',
                            style: {
                                fontSize: '13px',
                            },
                        }, onClick: handleDeleteEmbeddedWallets, disabled: isLoading || !isAcknowledgementChecked, loading: isLoading, dataTestId: 'embedded-delete-action-button', copykey: 'dyn_embedded_delete.action_button', buttonClassName: 'embedded-delete-view__body__button', children: t('dyn_embedded_delete.action_button') })] })] }));
};

var _g$8, _defs$7;
var _excluded$J = ["title", "titleId"];
function _extends$J() { return _extends$J = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$J.apply(null, arguments); }
function _objectWithoutProperties$J(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$J(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$J(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgExportEmbeddedHero = function SvgExportEmbeddedHero(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$J(_ref, _excluded$J);
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    width: 329,
    height: 88,
    viewBox: "0 0 329 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$8 || (_g$8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#export-embedded-hero_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 164.5,
    cy: 114,
    r: 114,
    fill: "url(#export-embedded-hero_svg__b)",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195 23a4 4 0 0 1 4-4h40a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-40a4 4 0 0 1-4-4v-8Zm13.585 4c0 1.473-1.217 2.667-2.717 2.667-1.501 0-2.717-1.194-2.717-2.667 0-1.473 1.216-2.667 2.717-2.667 1.5 0 2.717 1.194 2.717 2.667Zm6.34 2.667c1.5 0 2.717-1.194 2.717-2.667 0-1.473-1.217-2.667-2.717-2.667-1.501 0-2.717 1.194-2.717 2.667 0 1.473 1.216 2.667 2.717 2.667ZM226.698 27c0 1.473-1.216 2.667-2.717 2.667-1.5 0-2.717-1.194-2.717-2.667 0-1.473 1.217-2.667 2.717-2.667 1.501 0 2.717 1.194 2.717 2.667Zm8.057 0c0 .903-.751 1.667-1.717 1.667-.966 0-1.717-.764-1.717-1.667s.751-1.667 1.717-1.667c.966 0 1.717.764 1.717 1.667Zm1 0c0 1.473-1.217 2.667-2.717 2.667-1.501 0-2.717-1.194-2.717-2.667 0-1.473 1.216-2.667 2.717-2.667 1.5 0 2.717 1.194 2.717 2.667ZM110.237 57.018c8.535-2.287 13.601-11.06 11.314-19.596-2.287-8.535-11.061-13.6-19.596-11.313-8.536 2.287-13.601 11.06-11.314 19.596 2.287 8.535 11.061 13.6 19.596 11.313Zm-8.712-17.797-.522-1.949a4.037 4.037 0 0 1 7.798-2.09l.522 1.95a6.727 6.727 0 1 1-7.798 2.09Zm4.573-2.535-.195-.727a1.036 1.036 0 1 0-2.002.537l.194.726a6.81 6.81 0 0 1 2.003-.536Zm1.567 6.87a1.749 1.749 0 0 0-1.586-3.023 1.75 1.75 0 0 0 .137 3.412l.368 1.37a.75.75 0 1 0 1.448-.388l-.367-1.37Z",
    fill: "#4779FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.501 40.667a4.666 4.666 0 0 1 4.667 4.666h-28a9.306 9.306 0 0 0-6.85 2.995c.788-4.357 4.6-7.661 9.183-7.661h21ZM187.834 59.333A9.334 9.334 0 0 0 178.5 50h-28a9.333 9.333 0 0 0-9.333 9.333V78a9.333 9.333 0 0 0 9.333 9.333h28A9.334 9.334 0 0 0 187.834 78V59.333Z",
    fill: "#4779FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.25 65.25a6 6 0 1 0-12 0 6 6 0 0 0 12 0Zm-3 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0Zm-9.37 3.892a7.497 7.497 0 0 0 2.005 2.237l-2.831 2.83 2.103 2.103-2.121 2.122-2.103-2.103-2.062 2.062-2.121-2.121 7.13-7.13Z",
    fill: "#fff"
  }))), _defs$7 || (_defs$7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "export-embedded-hero_svg__b",
    x1: 164.5,
    y1: 0,
    x2: 164.5,
    y2: 93.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4779FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "export-embedded-hero_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 328,
    height: 88,
    rx: 12,
    fill: "#fff"
  })))));
};

var _path$B;
var _excluded$I = ["title", "titleId"];
function _extends$I() { return _extends$I = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$I.apply(null, arguments); }
function _objectWithoutProperties$I(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$I(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$I(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgEyeOffIcon = function SvgEyeOffIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$I(_ref, _excluded$I);
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$B || (_path$B = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.793 2.293a1 1 0 0 1 1.414 0l3.04 3.04A10.955 10.955 0 0 1 12.5 4c4.927 0 9.095 3.238 10.497 7.7a1 1 0 0 1 0 .6 11.014 11.014 0 0 1-3.552 5.231l2.762 2.762a1 1 0 0 1-1.414 1.414l-18-18a1 1 0 0 1 0-1.414Zm5.943 4.53 1.732 1.731a4 4 0 0 1 5.478 5.478l2.076 2.076A9.022 9.022 0 0 0 20.989 12 9.004 9.004 0 0 0 8.736 6.822Zm5.696 5.695a2 2 0 0 0-2.45-2.45l2.45 2.45ZM5.125 8.174a1 1 0 0 1 .194 1.4A8.975 8.975 0 0 0 4.012 12a9.004 9.004 0 0 0 10.177 5.842 1 1 0 0 1 .372 1.965c-.668.127-1.357.193-2.06.193-4.927 0-9.095-3.238-10.497-7.7a1 1 0 0 1 0-.6 10.97 10.97 0 0 1 1.72-3.332 1 1 0 0 1 1.4-.194Z",
    fill: "#ABACB2"
  })));
};

var _path$A;
var _excluded$H = ["title", "titleId"];
function _extends$H() { return _extends$H = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$H.apply(null, arguments); }
function _objectWithoutProperties$H(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$H(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$H(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgInfo = function SvgInfo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$H(_ref, _excluded$H);
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$A || (_path$A = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 9 2.333ZM.667 9a8.333 8.333 0 1 1 16.666 0A8.333 8.333 0 0 1 .667 9Zm7.5-3.333c0-.46.373-.834.833-.834h.008a.833.833 0 0 1 0 1.667H9a.833.833 0 0 1-.833-.833ZM7.333 9c0-.46.373-.833.834-.833H9c.46 0 .833.373.833.833v2.5a.833.833 0 1 1 0 1.667H9a.833.833 0 0 1-.833-.834v-2.5A.833.833 0 0 1 7.333 9Z",
    fill: "#383C48"
  })));
};

const iframeContainerId = 'dyn-turnkey-export-container-id';
const iframeElementId = 'dyn-turnkey-export-element-id';

// Hook exposed to customers and used internally to trigger embedded reveal
const useEmbeddedReveal = () => {
    const { primaryWallet, projectSettings, user, setShowAuthFlow } = useInternalDynamicContext();
    const { userHasEmbeddedWallet } = useEmbeddedWallet();
    const { pushView } = useViewContext();
    const { isTurnkeyWallet } = useIsTurnkeyWallet();
    const turnkeyChecks = ({ user, recoveryPhrase, }) => {
        var _a, _b;
        if (!isTurnkeyEnabled(projectSettings)) {
            throw new Error('Dynamic embedded wallet is not enabled. Go to the dashboard and make sure to have both Dynamic Embedded wallet and at least one EVM network enabled. Also, check if EthereumWalletConnectors is in the  DynamicContextProvider > settings > walletConnectors.');
        }
        if (!userHasEmbeddedWallet()) {
            throw new Error('Dynamic embedded wallet not found');
        }
        const walletProperties = (_b = (_a = user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.find(({ walletName }) => walletName === null || walletName === void 0 ? void 0 : walletName.startsWith('turnkey'))) === null || _b === void 0 ? void 0 : _b.walletProperties;
        const turnkeyHDWalletId = walletProperties === null || walletProperties === void 0 ? void 0 : walletProperties.turnkeyHDWalletId;
        if (recoveryPhrase && !turnkeyHDWalletId) {
            throw new Error('Wallet is non-HD and does not have a recovery phrase');
        }
    };
    const initExportProcess = useCallback((...args_1) => __awaiter$1(void 0, [...args_1], void 0, function* (recoveryPhrase = false, isPromptForExport = false) {
        if (!primaryWallet) {
            throw new Error('No primary wallet');
        }
        if (!user) {
            throw new Error(USER_NOT_LOGGED_IN);
        }
        if (isTurnkeyWallet) {
            turnkeyChecks({ recoveryPhrase, user });
        }
        if (!userHasEmbeddedWallet()) {
            throw new Error('Dynamic embedded wallet not found');
        }
        setShowAuthFlow(true, {
            ignoreIfIsEmbeddedWidget: false,
            performMultiWalletChecks: false,
        });
        pushView('embedded-reveal-view', {
            exportPrivateKey: !recoveryPhrase,
            isPromptForExport,
        });
        return new Promise((resolve, reject) => {
            dynamicEvents.once('embeddedWalletRevealCompleted', (wallet) => resolve(wallet));
            dynamicEvents.once('embeddedWalletRevealFailed', (error) => reject(error));
        });
    }), [primaryWallet, isTurnkeyWallet, setShowAuthFlow, pushView, user]);
    return {
        initExportProcess,
    };
};

let acknowledgedExportPrompt = false;
const useSyncEmbeddedWalletFlow = () => {
    const { projectSettings, user, primaryWalletId, walletConnectorOptions, primaryWallet, setShowAuthFlow, } = useInternalDynamicContext();
    const { isLoadingEmbeddedWallet } = useWalletContext();
    const { loading: globalLoading } = useLoadingContext();
    const { initExportProcess } = useEmbeddedReveal();
    const [wasShownExportPrompt, setWasShownExportPrompt] = useLocalStorage(`dynamic_export_prompt-${user === null || user === void 0 ? void 0 : user.userId}`, false, (data) => Boolean(data));
    const { createEmbeddedWallet, shouldAutoCreateEmbeddedWallet, shouldPromptForKeyExport, } = useEmbeddedWallet();
    const triggeredCreate = useRef(false);
    const handleAcknowledgeExportPrompt = useCallback((value = true) => {
        acknowledgedExportPrompt = value;
        setWasShownExportPrompt(value);
    }, [setWasShownExportPrompt]);
    useInternalDynamicEvents('logout', () => {
        triggeredCreate.current = false;
        acknowledgedExportPrompt = false;
    });
    // this is used to trigger createEmbeddedWallet
    // when user didn't create a passkey after login,
    // we force them to created it before they can use the app
    // ** It must be an useEffect because some of the dependencies are async
    useEffect(() => {
        const syncEmbeddedWallet = () => __awaiter$1(void 0, void 0, void 0, function* () {
            const isNewUser = user === null || user === void 0 ? void 0 : user.newUser;
            if (shouldSyncCreateWallet) {
                triggeredCreate.current = true;
                try {
                    yield createEmbeddedWallet();
                }
                catch (error) {
                    if (error instanceof EmbeddedWalletException) {
                        logger$1.debug('Error creating embedded wallet', error);
                    }
                    else {
                        logger$1.error('Error creating embedded wallet', error);
                    }
                    setShowAuthFlow(false);
                }
            }
            if (shouldSyncPromptKeyExport &&
                isNewUser &&
                findEmbeddedWalletFromVerifiedCredentials(user) &&
                primaryWallet) {
                try {
                    setShowAuthFlow(true);
                    yield initExportProcess(true, true);
                }
                catch (error) {
                    logger$1.error('Error initializing embedded wallet export', error);
                    setShowAuthFlow(false);
                }
            }
        });
        const shouldCreateWallet = shouldAutoCreateEmbeddedWallet();
        const shouldSyncCreateWallet = shouldCreateWallet && !triggeredCreate.current;
        if (wasShownExportPrompt && !acknowledgedExportPrompt)
            acknowledgedExportPrompt = true;
        const shouldPromptKeyExport = shouldPromptForKeyExport();
        const shouldSyncPromptKeyExport = shouldPromptKeyExport && !acknowledgedExportPrompt;
        const shouldSyncEmbeddedWallet = shouldSyncCreateWallet || shouldSyncPromptKeyExport;
        if (!shouldSyncEmbeddedWallet ||
            !user ||
            !projectSettings ||
            !walletConnectorOptions.length || // no connectors to use for the embedded wallet
            isLoadingEmbeddedWallet || // already has a wallet
            globalLoading // this will be true if auth is in progress
        ) {
            return;
        }
        syncEmbeddedWallet();
    }, [
        user,
        projectSettings,
        primaryWalletId,
        createEmbeddedWallet,
        isLoadingEmbeddedWallet,
        walletConnectorOptions,
        globalLoading,
        shouldAutoCreateEmbeddedWallet,
        setShowAuthFlow,
        initExportProcess,
        primaryWallet,
        shouldPromptForKeyExport,
        setWasShownExportPrompt,
        handleAcknowledgeExportPrompt,
        wasShownExportPrompt,
    ]);
    return {
        acknowledgedExportPrompt,
        handleAcknowledgeExportPrompt,
    };
};

const EmbeddedRevealView = ({ exportPrivateKey, isPromptForExport = false, }) => {
    var _a, _b, _c;
    const { primaryWallet, user, setShowAuthFlow, environmentId } = useInternalDynamicContext();
    const { handleAcknowledgeExportPrompt } = useSyncEmbeddedWalletFlow();
    const { isTurnkeyWallet } = useIsTurnkeyWallet();
    const { setDynamicWidgetView } = useWidgetContext();
    const { pushView } = useViewContext();
    const { getEOAWallet, isSmartWallet } = useSmartWallets();
    const [acknowledgement1, setAcknowledgement1] = useState(false);
    const iframeContainerRef = useRef(null);
    const walletProperties = (_b = (_a = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.find(({ walletName }) => walletName === null || walletName === void 0 ? void 0 : walletName.startsWith('turnkey'))) === null || _b === void 0 ? void 0 : _b.walletProperties;
    const isTurnkeyHDWallet = walletProperties === null || walletProperties === void 0 ? void 0 : walletProperties.turnkeyHDWalletId;
    const wallet = (_c = (primaryWallet && getEOAWallet(primaryWallet))) !== null && _c !== void 0 ? _c : primaryWallet;
    // eslint-disable-next-line arrow-body-style
    useEffect(() => {
        return () => {
            if (isTurnkeyWallet) {
                cleanupExport({
                    wallet: wallet,
                });
            }
        };
        // only run once on unmount
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { isLoading: exportLoading } = usePromise(() => __awaiter$1(void 0, void 0, void 0, function* () {
        var _d, _e;
        const iframeContainerElement = iframeContainerRef.current;
        if (!iframeContainerElement ||
            ((_d = iframeContainerElement === null || iframeContainerElement === void 0 ? void 0 : iframeContainerElement.children) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            return;
        }
        if (isSessionKeyCompatibleWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector)) {
            yield ((_e = wallet === null || wallet === void 0 ? void 0 : wallet.connector) === null || _e === void 0 ? void 0 : _e.createOrRestoreSession());
        }
        return initExport({
            iframeContainer: iframeContainerElement,
            iframeElementId,
            wallet: wallet,
        });
    }));
    const { mutate: handleExportWallet, isLoading, error, data, } = useMutation(() => __awaiter$1(void 0, void 0, void 0, function* () {
        var _f, _g, _h;
        handleAcknowledgeExportPrompt();
        if (isTurnkeyWallet) {
            try {
                return yield exportCredential({
                    address: exportPrivateKey ? wallet === null || wallet === void 0 ? void 0 : wallet.address : undefined,
                    environmentId,
                    user,
                    wallet: wallet,
                });
            }
            catch (_j) {
                if (isSessionKeyCompatibleWalletConnector(wallet === null || wallet === void 0 ? void 0 : wallet.connector) &&
                    ((_f = wallet === null || wallet === void 0 ? void 0 : wallet.connector) === null || _f === void 0 ? void 0 : _f.removeSessionKeys)) {
                    yield ((_g = wallet === null || wallet === void 0 ? void 0 : wallet.connector) === null || _g === void 0 ? void 0 : _g.removeSessionKeys());
                    yield ((_h = wallet === null || wallet === void 0 ? void 0 : wallet.connector) === null || _h === void 0 ? void 0 : _h.createOrRestoreSession({
                        ignoreRestore: true,
                    }));
                }
                return exportCredential({
                    address: exportPrivateKey ? wallet === null || wallet === void 0 ? void 0 : wallet.address : undefined,
                    environmentId,
                    user,
                    wallet: wallet,
                });
            }
        }
        return undefined;
    }), {
        onFailure: (err) => {
            logger$1.error('Failed to export', err);
            dynamicEvents.emit('embeddedWalletRevealFailed', err);
        },
    });
    const errorText = useMemo(() => {
        if (!error) {
            return undefined;
        }
        if (error instanceof DynamicError) {
            return error.message;
        }
        try {
            return getProperErrorMessage(error);
        }
        catch (e) {
            if (e instanceof AccessBlockedError) {
                pushView('access-blocked');
            }
            return;
        }
    }, [error, pushView]);
    const { t } = useTranslation();
    const contentHeader = (jsxRuntimeExports.jsxs("div", { children: [primaryWallet &&
                isSmartWallet(primaryWallet) &&
                !isLoading &&
                data &&
                !error && (jsxRuntimeExports.jsxs("div", { className: 'embedded-reveal-view__zerodev-warning', children: [jsxRuntimeExports.jsxs("div", { className: 'embedded-reveal-view__zerodev-warning__title-row', children: [jsxRuntimeExports.jsx(SvgInfo, { className: 'embedded-reveal-view__zerodev-warning__icon' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'bold', copykey: 'dyn_embedded_reveal.aa_warning.title', children: t('dyn_embedded_reveal.aa_warning.title') })] }), jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', weight: 'regular', copykey: 'dyn_embedded_reveal.aa_warning.subtitle', children: [t('dyn_embedded_reveal.aa_warning.subtitle'), jsxRuntimeExports.jsx("button", { onClick: () => {
                                    setShowAuthFlow(false);
                                    setDynamicWidgetView('send-balance');
                                }, className: 'embedded-reveal-view__zerodev-warning__link-button', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'primary', className: 'underline', copykey: 'dyn_embedded_reveal.aa_warning.button', children: t('dyn_embedded_reveal.aa_warning.button') }) })] })] })), jsxRuntimeExports.jsx("div", { className: 'embedded-reveal-view__body__description', children: !isLoading && data && !error ? (jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', weight: 'regular', children: t('dyn_embedded_reveal.reveal_description') })) : (jsxRuntimeExports.jsx("div", { className: 'embedded-reveal-view__header', children: jsxRuntimeExports.jsx("div", { className: 'embedded-reveal-view__header__hero', children: jsxRuntimeExports.jsx(SvgExportEmbeddedHero, {}) }) })) })] }));
    useEffect(() => {
        var _a;
        if (((_a = iframeContainerRef === null || iframeContainerRef === void 0 ? void 0 : iframeContainerRef.current) === null || _a === void 0 ? void 0 : _a.children) && data) {
            // eslint-disable-next-line prefer-destructuring
            const iframeElement = iframeContainerRef.current.children[0];
            iframeElement === null || iframeElement === void 0 ? void 0 : iframeElement.setAttribute('style', !isTurnkeyHDWallet || exportPrivateKey
                ? 'height: 60px'
                : 'height: 100px');
        }
    }, [iframeContainerRef, data, isTurnkeyHDWallet, exportPrivateKey]);
    const closeButton = (jsxRuntimeExports.jsx(IconButton, { onClick: () => setShowAuthFlow(false), type: 'button', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    const hasInjectedCredential = !isLoading && data && !error;
    const credentialTitle = !isTurnkeyHDWallet || exportPrivateKey
        ? t('dyn_embedded_reveal.private_key_title')
        : t('dyn_embedded_reveal.recovery_phrase_title');
    const getTitle = () => {
        if (hasInjectedCredential) {
            return credentialTitle;
        }
        if (isPromptForExport) {
            return t('dyn_embedded_reveal.prompt_for_export_title');
        }
        return t('dyn_embedded_reveal.agreement_title');
    };
    const title = getTitle();
    const handleClickUnlink = () => {
        pushView('embedded-delete-view');
    };
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(ModalHeader, { trailing: isPromptForExport ? null : closeButton, children: jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'title', color: 'primary', "data-testid": 'dynamic-auth-modal-heading', className: 'header__typography', children: title }) }), jsxRuntimeExports.jsx("div", { className: 'embedded-reveal-view', children: jsxRuntimeExports.jsxs("div", { className: 'embedded-reveal-view__body', children: [contentHeader, isTurnkeyWallet ? (jsxRuntimeExports.jsx("div", { id: iframeContainerId, style: { display: data ? 'block' : 'none' }, ref: iframeContainerRef })) : null, hasInjectedCredential ? (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(TypographyButton, { buttonPadding: 'large', buttonVariant: 'brand-primary', onClick: () => setShowAuthFlow(false), loading: isLoading, copykey: 'dyn_embedded_reveal.done_button_label', typographyProps: {
                                        color: 'inherit',
                                    }, children: t('dyn_embedded_reveal.done_button_label') }), !exportPrivateKey && (jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'embedded-reveal-view__body__unlink_button', buttonVariant: 'tertiary', buttonPadding: 'none', copykey: 'dyn_embedded_reveal.unlink', onClick: handleClickUnlink, typographyProps: {
                                        color: 'secondary',
                                        variant: 'button_tertiary',
                                    }, children: t('dyn_embedded_reveal.unlink') }))] })) : (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("div", { className: 'embedded-reveal-view__body__description', children: [jsxRuntimeExports.jsx("div", { className: 'embedded-reveal-view__body__badge-container', children: jsxRuntimeExports.jsx(Badge, { text: t('dyn_embedded_reveal.badge_label'), className: 'embedded-reveal-view__body__badge' }) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', weight: 'regular', copykey: 'dyn_embedded_reveal.prompt_for_export_description', children: t('dyn_embedded_reveal.prompt_for_export_description') })] }), errorText && jsxRuntimeExports.jsx(ErrorContainer, { children: errorText }), jsxRuntimeExports.jsxs("div", { className: 'embedded-reveal-view__body__card', children: [jsxRuntimeExports.jsxs("div", { className: 'embedded-reveal-view__body__card__statement', children: [jsxRuntimeExports.jsx("div", { className: 'embedded-reveal-view__body__card__icon', children: jsxRuntimeExports.jsx(SvgWalletV2, { height: 16, width: 16 }) }), jsxRuntimeExports.jsxs("div", { className: 'embedded-reveal-view__body__card__statement__text', children: [jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', color: 'primary', copykey: 'dyn_embedded_reveal.statement_1.title', children: [t('dyn_embedded_reveal.statement_1.title'), ":"] }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'primary', copykey: 'dyn_embedded_reveal.statement_1.description', children: t('dyn_embedded_reveal.statement_1.description') })] })] }), jsxRuntimeExports.jsxs("div", { className: 'embedded-reveal-view__body__card__statement', children: [jsxRuntimeExports.jsx("div", { className: 'embedded-reveal-view__body__card__icon', children: jsxRuntimeExports.jsx(SvgEyeOffIcon, { height: 16, width: 16 }) }), jsxRuntimeExports.jsx("div", { className: 'embedded-reveal-view__body__card__statement__text', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'primary', copykey: 'dyn_embedded_reveal.statement_2.title', children: t('dyn_embedded_reveal.statement_2.title') }) })] })] }), jsxRuntimeExports.jsx("div", { className: 'embedded-reveal-view__body__confirm_card', children: jsxRuntimeExports.jsxs("button", { className: 'embedded-reveal-view__body__card__acknowledgement', onClick: () => setAcknowledgement1(!acknowledgement1), children: [jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(Checkbox, { checked: acknowledgement1, onChange: () => setAcknowledgement1(!acknowledgement1), className: 'embedded-reveal-view__body__card__statement__checkbox', id: 'embedded-reveal-checkbox-1' }) }), jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'primary', style: { letterSpacing: '-0.15px' }, copykey: 'dyn_embedded_reveal.checkbox_label', children: t('dyn_embedded_reveal.checkbox_label') }) })] }) }), jsxRuntimeExports.jsx(NeedHelpSection, { isExport: true }), jsxRuntimeExports.jsxs("div", { className: 'embedded-reveal-view__body__button_section', children: [isPromptForExport && (jsxRuntimeExports.jsx(TypographyButton, { buttonPadding: 'large', buttonVariant: 'primary', onClick: () => {
                                                handleAcknowledgeExportPrompt();
                                                setShowAuthFlow(false);
                                            }, dataTestId: 'embedded-reveal-button', copykey: 'dyn_embedded_reveal.skip_button_label', expanded: true, buttonClassName: 'embedded-reveal-view__body__button', children: t('dyn_embedded_reveal.skip_button_label') })), jsxRuntimeExports.jsx(TypographyButton, { buttonPadding: 'large', buttonVariant: 'brand-primary', typographyProps: {
                                                color: 'inherit',
                                            }, onClick: () => handleExportWallet(), disabled: !acknowledgement1 || exportLoading, loading: isLoading, dataTestId: 'embedded-reveal-button', copykey: 'dyn_embedded_reveal.reveal_button_label', style: { width: '100%' }, className: 'embedded-reveal-view__body__button', expanded: true, children: isPromptForExport
                                                ? t('dyn_embedded_reveal.backup_button_label')
                                                : t('dyn_embedded_reveal.reveal_button_label') })] })] }))] }) })] }));
};

// https://usehooks-ts.com/react-hook/use-timeout
const useTimeout = (callback, delay) => {
    const savedCallback = useRef(callback);
    // Remember the latest callback if it changes.
    useIsomorphicLayoutEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the timeout.
    useEffect(() => {
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) {
            return;
        }
        const id = setTimeout(() => savedCallback.current(), delay);
        return () => clearTimeout(id);
    }, [delay]);
};

var _path$z;
var _excluded$G = ["title", "titleId"];
function _extends$G() { return _extends$G = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$G.apply(null, arguments); }
function _objectWithoutProperties$G(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$G(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$G(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgExternalLink = function SvgExternalLink(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$G(_ref, _excluded$G);
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.333 1.333a.667.667 0 1 1 0-1.333h4c.368 0 .667.298.667.667v4a.667.667 0 0 1-1.333 0v-2.39L5.138 7.804a.667.667 0 1 1-.943-.943l5.529-5.529h-2.39ZM2 2.667a.667.667 0 0 0-.667.666V10c0 .368.299.667.667.667h6.667A.667.667 0 0 0 9.333 10V7.333a.667.667 0 0 1 1.334 0V10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3.333a2 2 0 0 1 2-2h2.667a.667.667 0 0 1 0 1.334H2Z",
    fill: "currentColor"
  })));
};

const browserIconMap = {
    brave: BraveIcon,
    chrome: ChromeIcon,
    edge: EdgeIcon,
    firefox: FirefoxIcon,
    safari: SafariIcon,
};
const getBrowserIcon = (name) => browserIconMap[name];

const useWalletDownloadLinks = (walletConnector) => {
    if (!(walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.metadata.downloadLinks)) {
        return [];
    }
    const walletLinks = getWalletLinks(walletConnector.metadata.downloadLinks);
    const { currentDesktopUrl, userBrowser } = parseWalletLinks(walletLinks);
    if (currentDesktopUrl) {
        return [
            {
                Icon: getBrowserIcon(userBrowser),
                key: userBrowser,
                link: currentDesktopUrl,
                name: userBrowser,
            },
        ];
    }
    return Object.entries(walletLinks)
        .filter(([, link]) => link !== '')
        .filter(([name]) => name !== 'ios' && name !== 'android')
        .map(([name, link]) => ({
        Icon: getBrowserIcon(name),
        key: name,
        link: link,
        name: name,
    }));
};

const generateMatrix = (value, errorCorrectionLevel) => {
    const arr = Array.prototype.slice.call(QRCodeUtil.create(value, { errorCorrectionLevel }).modules.data, 0);
    const sqrt = Math.sqrt(arr.length);
    return arr.reduce((rows, key, index) => (index % sqrt === 0
        ? rows.push([key])
        : rows[rows.length - 1].push(key)) && rows, []);
};
const QRCode = ({ ecl = 'M', Icon, logoMargin = 0, logoSize = 40, size = 250, value, accentColor = 'currentColor', walletKey = undefined, showQrCodeImage, className, style, }) => {
    const { data } = usePromise(() => QRCodeUtil.toDataURL(value));
    const dots = useMemo(() => {
        const dots = [];
        const matrix = generateMatrix(value || 'QR Code value', ecl);
        const cellSize = size / matrix.length;
        const qrList = [
            { x: 0, y: 0 },
            { x: 1, y: 0 },
            { x: 0, y: 1 },
        ];
        qrList.forEach(({ x, y }) => {
            const x1 = (matrix.length - 7) * cellSize * x;
            const y1 = (matrix.length - 7) * cellSize * y;
            for (let i = 0; i < 3; i++) {
                dots.push(jsxRuntimeExports.jsx("rect", { "data-key": `corner-square-${x}-${y}-${i}`, fill: i % 2 !== 0 ? 'var(--background)' : accentColor, height: cellSize * (7 - i * 2), rx: i === 0 ? 10 : i === 1 ? 7 : 20, ry: i === 0 ? 10 : i === 1 ? 7 : 20, width: cellSize * (7 - i * 2), x: x1 + cellSize * i, y: y1 + cellSize * i }, `corner-square-${x}-${y}-${i}`));
            }
        });
        const clearArenaSize = Math.floor((logoSize * 1.5) / cellSize);
        const matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2;
        const matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 1;
        for (let row = 0; row < matrix.length; row++) {
            for (let col = 0; col < matrix[row].length; col++) {
                if (matrix[row][col]) {
                    if (
                    // 7 is the length of each corner square, and we don't want to put
                    // dots in the corner squares
                    !((row < 7 && col < 7) ||
                        (row > matrix.length - 8 && col < 7) ||
                        (row < 7 && col > matrix.length - 8))) {
                        if (!(row > matrixMiddleStart &&
                            row < matrixMiddleEnd &&
                            col > matrixMiddleStart &&
                            col < matrixMiddleEnd)) {
                            dots.push(jsxRuntimeExports.jsx("circle", { className: 'qrcode__dot-circle', cx: row * cellSize + cellSize / 2, cy: col * cellSize + cellSize / 2, fill: Math.random() > 0.9 ? accentColor : 'currentColor', r: cellSize / 2.25 }, `dot-${row}-${col}`));
                        }
                    }
                }
            }
        }
        return dots;
    }, [ecl, logoSize, size, value, accentColor]);
    const logoPosition = size / 2 - logoSize / 2 - logoMargin;
    const walletsWithoutIndicator = ['coinbase', 'walletconnect'];
    const indicator = !walletKey || walletsWithoutIndicator.includes(walletKey)
        ? undefined
        : 'walletConnect';
    return (jsxRuntimeExports.jsx("div", { className: classNames('qrcode__container', className), style: style, children: jsxRuntimeExports.jsx("div", { className: 'qrcode', children: showQrCodeImage ? (jsxRuntimeExports.jsx("img", { "data-testid": 'qr-code-image', src: data, alt: '' })) : (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("svg", { height: '100%', width: '100%', viewBox: `0 0 ${size} ${size}`, "data-testid": 'qr-code', children: [jsxRuntimeExports.jsx("defs", { children: jsxRuntimeExports.jsx("clipPath", { id: 'clip-logo', children: jsxRuntimeExports.jsx("rect", { height: logoSize, width: logoSize, x: logoPosition, y: logoPosition, rx: 7, ry: 7 }) }) }), jsxRuntimeExports.jsx("rect", { fill: 'none', height: size, width: size }), dots] }), jsxRuntimeExports.jsx(IconWithSpinner, { Icon: Icon, iconSize: logoSize, isSpinning: true, className: 'qrcode__icon', indicator: indicator })] })) }) }));
};

const LoadingQrCode = ({ Icon, logoSize }) => (jsxRuntimeExports.jsx("div", { className: 'qrcode__container qrcode', "data-testid": 'loading-qrcode', children: jsxRuntimeExports.jsx(IconWithSpinner, { Icon: Icon, iconSize: logoSize, isSpinning: true, className: 'qrcode__icon' }) }));

const QrCodeContainer = ({ accentColor, walletConnector, qrcodeValue, Icon: MainIcon, showCopyToClipboardButton = false, desktopUri, showQrCodeMessage, showQrCodeImage, }) => {
    const { t } = useTranslation();
    const { pushView } = useViewContext();
    const downloadLinks = useWalletDownloadLinks(walletConnector);
    const renderAppOrExtensionButton = () => {
        if (desktopUri) {
            return (jsxRuntimeExports.jsx(TypographyButton, { expanded: true, dataTestId: 'get-extension-button', buttonPadding: 'small', buttonVariant: 'primary', buttonClassName: 'qr-code-button', onClick: () => window.open(desktopUri), copykey: 'dyn_qr_code.open_button', typographyProps: { variant: 'button_secondary' }, startSlot: 
                // eslint-disable-next-line react/jsx-wrap-multilines
                jsxRuntimeExports.jsx(Icon, { size: 'xsmall', color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgExternalLink, {}) }), children: t('dyn_qr_code.open_button') }));
        }
        if (downloadLinks === null || downloadLinks === void 0 ? void 0 : downloadLinks.length) {
            return (jsxRuntimeExports.jsx(TypographyButton, { expanded: true, dataTestId: 'get-extension-button', buttonPadding: 'small', buttonVariant: 'primary', buttonClassName: 'qr-code-button', onClick: () => pushView('no-qr-not-installed'), copykey: 'dyn_qr_code.get_extension_button', typographyProps: { variant: 'button_secondary' }, startSlot: 
                // eslint-disable-next-line react/jsx-wrap-multilines
                jsxRuntimeExports.jsx(Icon, { size: 'xsmall', color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgExternalLink, {}) }), children: t('dyn_qr_code.get_extension_button') }));
        }
        return null;
    };
    return (jsxRuntimeExports.jsxs("div", { className: classNames('qrcode-container__container', {
            'qrcode-container__container--message': showQrCodeMessage,
        }), children: [jsxRuntimeExports.jsxs("div", { className: 'qrcode-container__top', children: [qrcodeValue.length ? (jsxRuntimeExports.jsx(QRCode, { Icon: MainIcon, accentColor: accentColor, value: qrcodeValue, logoSize: 50, walletKey: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.key, showQrCodeImage: showQrCodeImage })) : (jsxRuntimeExports.jsx(LoadingQrCode, { Icon: MainIcon, logoSize: 50 })), jsxRuntimeExports.jsxs("div", { className: 'button-container', children: [showCopyToClipboardButton && (jsxRuntimeExports.jsx(CopyButton, { variant: 'button', textToCopy: qrcodeValue, disabled: !qrcodeValue.length, buttonClassName: 'qr-code-button', copykey: 'dyn_qr_code.copy_button', startSlot: 
                                // eslint-disable-next-line react/jsx-wrap-multilines
                                jsxRuntimeExports.jsx(Icon, { size: 'mini', color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgLink, {}) }), children: t('dyn_qr_code.copy_button') })), renderAppOrExtensionButton()] })] }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', weight: 'regular', className: 'qrcode-container__content', copykey: 'dyn_qr_code.scan_title', children: t('dyn_qr_code.scan_title', {
                    app: walletConnector ? 'wallet' : 'app',
                }) })] }));
};

const QrCodeWrapper = ({ uri, desktopUri, icon, accentColor, showCopyToClipboardButton, walletConnector, }) => {
    const [showQrCodeMessage, setShowQrCodeMessage] = useState(false);
    const [showQrCodeImage, setShowQrCodeImage] = useState(false);
    /**
     * Show the QR code message after 5 seconds
     * disabled if url is empty
     */
    useTimeout(() => setShowQrCodeMessage(true), uri.length ? 5000 : null);
    return (jsxRuntimeExports.jsxs("div", { "data-testid": 'qr-code-wrapper', className: 'qr-code-wrapper', children: [jsxRuntimeExports.jsx(AnimatePresence, { animationComponent: jsxRuntimeExports.jsx(VerticalDrawerTransition, { style: { width: '100%' } }), children: showQrCodeMessage && !showQrCodeImage && (jsxRuntimeExports.jsxs("div", { className: 'qr-code-wrapper__scan-issue-message', children: [jsxRuntimeExports.jsx(Typography, { color: 'primary', variant: 'body_small', children: "If you're having issues scanning, click\u00A0" }), jsxRuntimeExports.jsx("button", { "data-testid": 'qr-code-wrapper__scan-issue-button', className: 'qr-code-wrapper__scan-issue-button', onClick: () => setShowQrCodeImage(true), children: "here" })] })) }), jsxRuntimeExports.jsx(QrCodeContainer, { showQrCodeMessage: showQrCodeMessage, desktopUri: desktopUri, accentColor: accentColor, walletConnector: walletConnector, qrcodeValue: uri, Icon: icon, showCopyToClipboardButton: showCopyToClipboardButton, showQrCodeImage: showQrCodeImage })] }));
};

const FarcasterConnectView = ({ url }) => {
    const { theme: { theme }, } = useThemeContext();
    const iconThemeVariant = useIconThemeVariant();
    const icon = jsxRuntimeExports.jsx(SocialIcon, { name: 'farcaster', variant: iconThemeVariant });
    return (jsxRuntimeExports.jsx(QrCodeWrapper, { uri: url, accentColor: iconThemeVariant === 'dark' ? theme.colors.textPrimary : '#7b65c0', icon: icon, showCopyToClipboardButton: true }));
};

const GlobalWalletConfirmView = ({ pairingInfo, onConfirm, onCancel }) => {
    const { t } = useTranslation();
    const [imageError, setImageError] = useState(false);
    const handleImageError = () => {
        setImageError(true);
    };
    return (jsxRuntimeExports.jsx("div", { className: 'global-wallet-confirm', children: jsxRuntimeExports.jsx("div", { className: 'popup-content', children: jsxRuntimeExports.jsxs("div", { className: 'wallet-connection-view', children: [!imageError && (jsxRuntimeExports.jsx("img", { src: pairingInfo.icons[0], alt: `${pairingInfo.name} icon`, className: 'dapp-icon', onError: handleImageError })), jsxRuntimeExports.jsx(Typography, { className: 'connection-title', variant: 'title', font: 'bold', children: t('global_wallet.confirm.description', { name: pairingInfo.name }) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', className: 'dapp-url', children: pairingInfo.url }), jsxRuntimeExports.jsxs("div", { className: 'button-group', children: [jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'cancel-button', onClick: onCancel, type: 'submit', buttonPadding: 'large', children: t('global_wallet.confirm.cancel_button') }), jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'connect-global-button', onClick: onConfirm, type: 'submit', buttonPadding: 'large', typographyProps: {
                                    color: 'white',
                                }, children: t('global_wallet.confirm.connect_button') })] })] }) }) }));
};

var _g$7, _defs$6;
var _excluded$F = ["title", "titleId"];
function _extends$F() { return _extends$F = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$F.apply(null, arguments); }
function _objectWithoutProperties$F(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$F(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$F(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgBlueWalletconnect = function SvgBlueWalletconnect(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$F(_ref, _excluded$F);
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$7 || (_g$7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#blue-walletconnect_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12Z",
    fill: "#4084ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.343 4.286a3.761 3.761 0 0 1 5.314 0l.176.176a.186.186 0 0 1 0 .265l-.603.603a.096.096 0 0 1-.133 0l-.243-.244a2.624 2.624 0 0 0-3.708 0l-.26.26a.096.096 0 0 1-.132 0l-.606-.6a.186.186 0 0 1 0-.266l.195-.194Zm6.563 1.248.538.537a.185.185 0 0 1 0 .265L8.018 8.757a.187.187 0 0 1-.264 0L6.034 7.04a.047.047 0 0 0-.068 0l-1.72 1.718a.187.187 0 0 1-.264 0l-2.426-2.42a.186.186 0 0 1 0-.266l.538-.537a.187.187 0 0 1 .265 0l1.72 1.718a.047.047 0 0 0 .067 0l1.72-1.718a.187.187 0 0 1 .265 0l1.72 1.718a.047.047 0 0 0 .068 0l1.72-1.718a.19.19 0 0 1 .267 0Z",
    fill: "#fff"
  }))), _defs$6 || (_defs$6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "blue-walletconnect_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};

const InlineIconTypography = ({ children }) => (jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'regular', color: 'secondary', children: jsxRuntimeExports.jsx("span", { className: 'inline-icon-text', children: children }) }));
const GlobalWalletInfoView = () => {
    const { t } = useTranslation();
    // we cannot translate some of this as we have icons inline with text
    return (jsxRuntimeExports.jsx("div", { className: 'info-card', children: jsxRuntimeExports.jsxs("div", { className: 'wrapper', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'bold', color: 'primary', as: 'h2', children: "How do I find the URI or QR code?" }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'regular', color: 'secondary', children: t('global_wallet.help.step.1') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'regular', color: 'secondary', children: t('global_wallet.help.step.2') }), jsxRuntimeExports.jsxs(InlineIconTypography, { children: ["3. Open", ' ', jsxRuntimeExports.jsxs("span", { className: 'nowrap', children: ["WalletConnect ", jsxRuntimeExports.jsx(SvgBlueWalletconnect, {})] }), "from the list, this should show a QR code to scan"] }), jsxRuntimeExports.jsxs(InlineIconTypography, { children: ["4. If you are not using the QR code, locate and click", jsxRuntimeExports.jsxs("span", { className: 'nowrap', children: [jsxRuntimeExports.jsx(SvgCopy, {}), " to copy"] }), ' ', "the URI code"] })] }) }));
};

var _path$y;
var _excluded$E = ["title", "titleId"];
function _extends$E() { return _extends$E = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$E.apply(null, arguments); }
function _objectWithoutProperties$E(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$E(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$E(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgCautionTriangle = function SvgCautionTriangle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$E(_ref, _excluded$E);
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.335 1.917c.962-1.667 3.368-1.667 4.33 0l5.774 10c.962 1.666-.241 3.75-2.166 3.75H2.726c-1.924 0-3.127-2.084-2.165-3.75l5.774-10Zm2.887.833a.833.833 0 0 0-1.444 0l-5.773 10A.833.833 0 0 0 2.726 14h11.547a.833.833 0 0 0 .722-1.25l-5.773-10ZM8.5 5.667c.46 0 .833.373.833.833v1.667a.833.833 0 0 1-1.666 0V6.5c0-.46.373-.833.833-.833ZM7.667 11.5c0-.46.373-.833.833-.833h.008a.833.833 0 1 1 0 1.666H8.5a.833.833 0 0 1-.833-.833Z",
    fill: "#DD8500"
  })));
};

var _path$x;
var _excluded$D = ["title", "titleId"];
function _extends$D() { return _extends$D = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$D.apply(null, arguments); }
function _objectWithoutProperties$D(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$D(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$D(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgExclamationCircle = function SvgExclamationCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$D(_ref, _excluded$D);
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 2.333a6.667 6.667 0 1 0 0 13.334 6.667 6.667 0 0 0 0-13.334ZM.167 9a8.333 8.333 0 1 1 16.666 0A8.333 8.333 0 0 1 .167 9ZM8.5 4.833c.46 0 .833.373.833.834V9a.833.833 0 1 1-1.667 0V5.667c0-.46.374-.834.834-.834Zm-.833 7.5c0-.46.373-.833.833-.833h.008a.833.833 0 0 1 0 1.667H8.5a.833.833 0 0 1-.833-.834Z",
    fill: "#FF4646"
  })));
};

var _path$w;
var _excluded$C = ["title", "titleId"];
function _extends$C() { return _extends$C = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$C.apply(null, arguments); }
function _objectWithoutProperties$C(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$C(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$C(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgExclamation = function SvgExclamation(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$C(_ref, _excluded$C);
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    width: 7,
    height: 32,
    viewBox: "0 0 7 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 3.2a3.2 3.2 0 0 0-6.4 0V16a3.2 3.2 0 0 0 6.4 0V3.2ZM3.2 25.6a3.2 3.2 0 0 0 0 6.4h.032a3.2 3.2 0 0 0 0-6.4H3.2Z",
    fill: "#F9F9FB"
  })));
};

var _circle$4;
var _excluded$B = ["title", "titleId"];
function _extends$B() { return _extends$B = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$B.apply(null, arguments); }
function _objectWithoutProperties$B(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$B(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$B(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgWarningOrange = function SvgWarningOrange(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$B(_ref, _excluded$B);
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle$4 || (_circle$4 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#DD8500"
  })));
};

var _circle$3;
var _excluded$A = ["title", "titleId"];
function _extends$A() { return _extends$A = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$A.apply(null, arguments); }
function _objectWithoutProperties$A(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$A(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$A(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgWarningRed = function SvgWarningRed(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$A(_ref, _excluded$A);
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle$3 || (_circle$3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FF4646"
  })));
};

const GlobalWalletMaliciousView = ({ maliciousSiteInfo }) => {
    const { t } = useTranslation();
    const { setDynamicWidgetView } = useWidgetContext();
    const { setShowAuthFlow } = useInternalDynamicContext();
    const handleBack = () => {
        setDynamicWidgetView('global-wallet');
        setShowAuthFlow(false, {
            ignoreIfIsEmbeddedWidget: false,
            performMultiWalletChecks: false,
        });
    };
    const handleProceed = () => {
        var _a;
        (_a = maliciousSiteInfo.proceedFlow) === null || _a === void 0 ? void 0 : _a.call(maliciousSiteInfo);
    };
    return (jsxRuntimeExports.jsx("div", { className: 'malicious-site-view', children: jsxRuntimeExports.jsx("div", { className: 'popup-content', children: jsxRuntimeExports.jsxs("div", { className: 'wallet-connection-view', children: [jsxRuntimeExports.jsxs("div", { className: 'warning-icon-container', style: { position: 'relative' }, children: [maliciousSiteInfo.isDefinitelyMalicious ? (jsxRuntimeExports.jsx(SvgWarningRed, { className: 'warning-icon' })) : (jsxRuntimeExports.jsx(SvgWarningOrange, { className: 'warning-icon' })), jsxRuntimeExports.jsx(SvgExclamation, { className: 'exclamation-icon', style: {
                                    left: '50%',
                                    position: 'absolute',
                                    top: '50%',
                                    transform: 'translate(-50%, -50%)',
                                } })] }), jsxRuntimeExports.jsx(Typography, { className: 'connection-title', variant: 'title', font: 'bold', color: 'primary', children: maliciousSiteInfo.isDefinitelyMalicious
                            ? t('global_wallet.malicious_site.certain.title')
                            : t('global_wallet.malicious_site.unknown.title') }), jsxRuntimeExports.jsxs("div", { className: `subtitle-container ${maliciousSiteInfo.isDefinitelyMalicious
                            ? 'definitely-malicious'
                            : 'unknown'}`, children: [jsxRuntimeExports.jsxs("div", { className: 'subtitle-header-container', children: [maliciousSiteInfo.isDefinitelyMalicious ? (jsxRuntimeExports.jsx(SvgExclamationCircle, { className: 'caution-icon' })) : (jsxRuntimeExports.jsx(SvgCautionTriangle, { className: 'caution-icon' })), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', className: 'subtitle-header', color: 'primary', children: maliciousSiteInfo.isDefinitelyMalicious
                                            ? t('global_wallet.malicious_site.certain.subtitle_header')
                                            : t('global_wallet.malicious_site.unknown.subtitle_header') })] }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', className: 'subtitle', color: 'secondary', children: maliciousSiteInfo.isDefinitelyMalicious
                                    ? t('global_wallet.malicious_site.certain.subtitle_text')
                                    : t('global_wallet.malicious_site.unknown.subtitle_text') })] }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', className: 'site-info', color: 'secondary', children: maliciousSiteInfo.url }), jsxRuntimeExports.jsxs("div", { className: 'button-group', children: [jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'cancel-button', buttonVariant: 'primary', type: 'submit', buttonPadding: 'large', onClick: handleBack, copykey: 'global_wallet.malicious_site.go_back', children: maliciousSiteInfo.isDefinitelyMalicious
                                    ? t('global_wallet.malicious_site.certain.go_back')
                                    : t('global_wallet.malicious_site.unknown.go_back') }), jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'proceed-button', buttonVariant: 'secondary', type: 'submit', buttonPadding: 'large', onClick: handleProceed, copykey: 'global_wallet.malicious_site.proceed', typographyProps: {
                                    color: 'error-1',
                                }, children: maliciousSiteInfo.isDefinitelyMalicious
                                    ? t('global_wallet.malicious_site.certain.proceed')
                                    : t('global_wallet.malicious_site.unknown.proceed') })] })] }) }) }));
};

const DefaultFooter = ({ hideBorder }) => (jsxRuntimeExports.jsx("div", { className: classNames('default-footer__footer', {
        'default-footer__footer--hidden': hideBorder,
    }), "data-testid": 'default-footer' }));

/**
 * This view is used to display the QR code for the farcaster connection.
 * It is only used in the login view when Farcaster is the only available login method.
 */
const FarcasterQrCodeView = () => {
    const { setError } = useErrorContext();
    const [url, setUrl] = useState(undefined);
    // this is used to prevent the connectSocialAccount from being more than once
    const triggeredConnect = useRef(false);
    const nonce = useNonce();
    const { connectSocialAccount } = useSocialAuth({
        onError: () => setError('Something went wrong'),
        onFarcasterUrl: (url) => setUrl(url),
    });
    useEffect(() => {
        // wait until the nonce is fetched
        if (triggeredConnect.current || !nonce)
            return;
        triggeredConnect.current = true;
        connectSocialAccount({
            authMode: 'signin',
            provider: ProviderEnum.Farcaster,
        });
    }, [connectSocialAccount, nonce]);
    return jsxRuntimeExports.jsx(FarcasterConnectView, { url: url !== null && url !== void 0 ? url : '' });
};

var _path$v, _rect$2, _rect2, _rect3;
var _excluded$z = ["title", "titleId"];
function _extends$z() { return _extends$z = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$z.apply(null, arguments); }
function _objectWithoutProperties$z(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$z(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$z(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgNoWalletFound = function SvgNoWalletFound(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$z(_ref, _excluded$z);
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    width: 121,
    height: 81,
    viewBox: "0 0 121 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.064 34.016c-6.654 0-12.048 5.394-12.048 12.048 0 6.653 5.394 12.047 12.048 12.047 6.653 0 12.047-5.394 12.047-12.047 0-6.654-5.394-12.048-12.047-12.048ZM83 46.064C83 37.192 90.192 30 99.064 30c8.871 0 16.063 7.192 16.063 16.064 0 3.712-1.259 7.13-3.373 9.85l8.658 8.658a2.008 2.008 0 0 1-2.84 2.84l-8.658-8.658a15.994 15.994 0 0 1-9.85 3.373C90.192 62.127 83 54.935 83 46.064Z",
    fill: "currentColor",
    fillOpacity: 0.35
  })), _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 121,
    height: 16,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 30,
    width: 75,
    height: 16,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 52,
    width: 75,
    height: 16,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.3
  })));
};

const Search = ({ className = '', id, label, type, onChange, onBlur, name, value, onClickClear, copykey, }) => (jsxRuntimeExports.jsxs("label", { htmlFor: id, className: classNames('search__container', value ? 'search__container--active' : undefined), children: [jsxRuntimeExports.jsx("div", { className: 'search-icon__container', children: jsxRuntimeExports.jsx(SvgSearch, {}) }), jsxRuntimeExports.jsx("input", { name: name, value: value, onChange: onChange, onBlur: onBlur, type: type, id: id, placeholder: label, className: classNames('search__input', className), "data-testid": 'Search', copykey: copykey }), value.length > 0 && (jsxRuntimeExports.jsx("button", { type: 'button', onClick: onClickClear, className: 'search__button--clear', "data-testid": 'search-clear-button', children: "Clear" }))] }));

const findLastPriorityIndex = (walletNames, priorityList) => priorityList.reduce((lastIndex, walletName) => {
    const walletIndex = walletNames.indexOf(walletName.toLowerCase());
    if (walletIndex > lastIndex)
        return walletIndex;
    return lastIndex;
}, -1);

const getCalculatedOffset = ({ hasWalletFilter, defaultOffset, list, priorityList, }) => {
    const lastPriorityIndex = findLastPriorityIndex(list, priorityList);
    if (defaultOffset === DEFAULT_NUMBER_OF_WALLETS_TO_SHOW &&
        !hasWalletFilter &&
        list.length > defaultOffset &&
        lastPriorityIndex !== -1) {
        return lastPriorityIndex + 1;
    }
    else {
        return defaultOffset;
    }
};

/**
 * Used to filter out wallets that are already connected
 * This is useful for connect-only multi-wallet, where we want users to only connect new wallets,
 * not additional accounts from the same wallet
 */
const filterConnectedWallets = ({ walletOptions, userWallets, }) => {
    const connectedWalletKeys = new Set(userWallets.map((connectedWallet) => connectedWallet.connector.key));
    /**
     * Phantom and Phantom Ledger are the same wallet, so we have to filter both of them
     * if one is present, because the next connection will not work, it will just connect the
     * same wallet again with a different walletName.
     * This will be fixed by combining both Phantom and PhantomLedger to the same connector here QNTM-885
     */
    if (connectedWalletKeys.has('phantom') ||
        connectedWalletKeys.has('phantomledger')) {
        connectedWalletKeys.add('phantom');
        connectedWalletKeys.add('phantomledger');
    }
    return walletOptions.filter((wallet) => !connectedWalletKeys.has(wallet.walletConnector.key));
};

const getPlatformForConnector = (connector) => isMobile() || connector.isWalletConnect ? 'mobile' : 'desktop';

/**
 * This function is a helper to filter out wallets that should not appear in the wallet list
 * if they are already linked to the user profile.
 */
const staticWalletFilter = (linkedWallets, walletOptions) => walletOptions.filter((walletOption) => {
    if (walletOption.walletConnector &&
        isConnectorEventSupported(walletOption.walletConnector, 'accountChanged', getPlatformForConnector(walletOption.walletConnector))) {
        return true;
    }
    if (linkedWallets.some((wallet) => wallet.connector.key === walletOption.key)) {
        return false;
    }
    return true;
});

/**
 * Used to filter out WalletConnect wallets if user has already a WalletConnect wallet connected/linked
 * This is useful for multi-wallet on mobile, since WalletConnect doesn't work very well with multiwallet
 */
const createWalletConnectWalletsFilter = (userWallets) => {
    const hasWCWallet = userWallets.some((wallet) => wallet.connector.isWalletConnect);
    // If user doesn't have WC wallet, keep all wallets (return true)
    if (!hasWCWallet) {
        return () => true;
    }
    // If user has WC wallet, filter out other WC wallets
    return (walletOption) => !walletOption.walletConnector.isWalletConnect;
};

const metaMaskConnectorKey = 'metamask';
/**
 * Creates a filter for MetaMask Mobile wallets
 * If user has MetaMask Mobile wallet, filter out all other wallets
 * because MetaMask Mobile doesn't support multiwallet
 */
const createMetaMaskMobileFilter = (userWallets) => {
    if (!isMobile()) {
        return () => true;
    }
    const hasMetaMaskWallet = userWallets.some((wallet) => wallet.key === metaMaskConnectorKey);
    if (!hasMetaMaskWallet) {
        return () => true;
    }
    return (walletOption) => walletOption.walletConnector.key !== metaMaskConnectorKey;
};

const applyMultiWalletFilters = ({ authMode, userWallets, walletOptions, }) => {
    const walletList = walletOptions
        .filter(createWalletConnectWalletsFilter(userWallets))
        .filter(createMetaMaskMobileFilter(userWallets));
    if (authMode === 'connect-only') {
        return filterConnectedWallets({
            userWallets,
            walletOptions: walletList,
        });
    }
    return staticWalletFilter(userWallets, walletList);
};

const PRIORITY_WALLET_LIST = [
    'metamask',
    'coinbase',
    'walletconnect',
    'phantom',
    'argentx',
    'blocto',
    'solflare',
    'braavos',
    'trust',
    'rainbow',
    'dapper',
    'glow',
    'flowwalletflow',
];
const sortedInputList = (inputList, recommendedWalletKeys) => {
    // Input is the unordered list of wallets we support
    const unsortedRecommendedWallets = [];
    const unsortedPriorityWallets = [];
    const unsortedOtherWallets = [];
    inputList.forEach((wallet) => {
        const isRecommendedWallet = recommendedWalletKeys.includes(wallet.key);
        if (isRecommendedWallet) {
            unsortedRecommendedWallets.push(wallet);
        }
        else if (PRIORITY_WALLET_LIST.includes(wallet.key) &&
            !isRecommendedWallet) {
            unsortedPriorityWallets.push(wallet);
        }
        else {
            unsortedOtherWallets.push(wallet);
        }
    });
    const sortedPriorityWallets = unsortedPriorityWallets
        .slice()
        .sort((a, b) => PRIORITY_WALLET_LIST.indexOf(a.key) -
        PRIORITY_WALLET_LIST.indexOf(b.key));
    const sortedRecommendedWallets = unsortedRecommendedWallets
        .slice()
        .sort((a, b) => recommendedWalletKeys.indexOf(a.key) -
        recommendedWalletKeys.indexOf(b.key));
    return [
        ...sortedRecommendedWallets,
        ...sortedPriorityWallets,
        ...unsortedOtherWallets,
    ];
};
const walletListBuilder = ({ authMode, userWallets, multiWallet, numberOfWalletsToShow, inputList, isWalletConnectList, lastUsedWalletKey, searchFilter, walletsFilter, loginWithEmail, groupWallets, walletGroups, showMoreWalletsWithFilter, recommendedWallets, }) => {
    let walletList = inputList;
    if (isWalletConnectList) {
        walletList = inputList.filter((wallet) => wallet.walletConnector.isWalletConnect &&
            wallet.key !== 'walletconnect');
    }
    if (multiWallet) {
        walletList = applyMultiWalletFilters({
            authMode,
            userWallets,
            walletOptions: walletList,
        });
    }
    let lastUsedWallet;
    const hasWalletFilter = Boolean(walletsFilter);
    const recommendedWalletsList = [];
    const installedWallets = [];
    const otherWallets = [];
    const recommendedWalletKeys = Array.from(new Set((recommendedWallets || []).map((w) => w.walletKey)));
    const orderedInputList = orderAndFilterList(walletList, walletsFilter, isWalletConnectList, recommendedWalletKeys);
    orderedInputList.forEach((wallet) => {
        if (isEmbeddedConnector(wallet.walletConnector) ||
            !wallet.walletConnector.isAvailable)
            return;
        if (recommendedWalletKeys === null || recommendedWalletKeys === void 0 ? void 0 : recommendedWalletKeys.includes(wallet.key)) {
            recommendedWalletsList.push(wallet);
        }
        else if (lastUsedWalletKey === wallet.key) {
            lastUsedWallet = wallet;
        }
        else if (wallet.isInstalledOnBrowser) {
            installedWallets.push(wallet);
        }
        else {
            otherWallets.push(wallet);
        }
    });
    const firstPriorityWallets = [...(lastUsedWallet ? [lastUsedWallet] : [])];
    const walletsList = [
        ...recommendedWalletsList,
        ...firstPriorityWallets,
        ...installedWallets,
        ...otherWallets,
    ];
    const finalizedWalletList = groupWalletOptions(walletGroups, walletsList)
        ;
    // If a filter has been applied we want to add an offset to the number of wallets
    // to include the installed and last used wallets
    const updatedNumberOfWalletsToShow = showMoreWalletsWithFilter && hasWalletFilter
        ? calculateWalletOffsetBasedOnInstalledAndLastUsedWallets(orderedInputList, firstPriorityWallets.concat(installedWallets), numberOfWalletsToShow)
        : numberOfWalletsToShow;
    return {
        numberOfWallets: walletsList.length,
        walletsList: listToDisplay(finalizedWalletList, searchFilter, isWalletConnectList, updatedNumberOfWalletsToShow, hasWalletFilter, loginWithEmail),
    };
};
// We want to show the full list of wallets when we render the wallet connect list even
// if a filter was applied to the main page
const orderAndFilterList = (walletList, walletsFilter, isWalletConnectList, recommendedWalletKeys) => {
    const sortedWalletList = sortedInputList(walletList, recommendedWalletKeys);
    if (!isWalletConnectList && walletsFilter) {
        return walletsFilter(sortedWalletList);
    }
    else {
        return sortedWalletList;
    }
};
const KEEP_WALLETS_NAME_LIST = ['walletconnect', 'bitcoin.com wallet'];
const applySearchFilterToWalletOptionList = (rawSearchFilter, walletOptionList) => {
    const searchFilter = rawSearchFilter.trim().toLowerCase();
    const cleanName = (name) => {
        const trimmedLowerName = name.trim().toLowerCase();
        if (KEEP_WALLETS_NAME_LIST.includes(trimmedLowerName)) {
            return trimmedLowerName;
        }
        else {
            return trimmedLowerName
                .replace('wallet', '')
                .replace('evm', '')
                .replace('starknet', '')
                .replace('solana', '')
                .replace('flow', '')
                .replace('bitcoin', '');
        }
    };
    return walletOptionList.filter((walletOption) => {
        var _a;
        return cleanName(walletOption.name).includes(searchFilter) ||
            (
            // Validate nested wallets
            (_a = walletOption.groupedWallets) === null || _a === void 0 ? void 0 : _a.some((nestedWalletOption) => cleanName(nestedWalletOption.name).includes(searchFilter)));
    });
};
const listToDisplay = (finalizedList, searchFilter, isWalletConnectList, numberOfWalletsToShow, hasWalletFilter, loginWithEmail) => {
    if (searchFilter) {
        return applySearchFilterToWalletOptionList(searchFilter, finalizedList);
    }
    else if (isWalletConnectList) {
        return finalizedList;
    }
    else if (loginWithEmail) {
        return finalizedList.slice(0, numberOfWalletsToShow);
    }
    else {
        const list = finalizedList.map((wallet) => wallet.name.toLowerCase());
        const offset = getCalculatedOffset({
            defaultOffset: numberOfWalletsToShow,
            hasWalletFilter,
            list,
            priorityList: PRIORITY_WALLET_LIST,
        });
        return finalizedList.slice(0, offset);
    }
};
/**
 * This calculation adds an offset to numberOfWalletsToShow so we will show the
 * intended wallets + installed and last used.
 * We should would only apply the additonal offset if the installed wallets was not in the original list.
 *
 * For example:
 * we want to show 4 wallets: ['metamask', 'rainbow', 'walletconnect', 'coinbase']
 * and someone is using brave with installed phantom he should see
 * [ 'brave injected', phantom ,'metamask', 'rainbow', 'walletconnect', 'coinbase',]
 * And when someone is using metamask and coinbase they should see
 * [ 'metamask', 'coinbase', 'rainbow', 'walletconnect']
 */
const calculateWalletOffsetBasedOnInstalledAndLastUsedWallets = (allWalletsOrdered, installedOrUsedWallets, numberOfWalletsToShow) => {
    const filteredWallets = allWalletsOrdered.slice(0, numberOfWalletsToShow);
    const offset = installedOrUsedWallets.filter((wallet) => !filteredWallets.includes(wallet)).length;
    return numberOfWalletsToShow + offset;
};

const getEffectiveRecommendedWallets = (selectedTabSettings, recommendedWallets) => {
    if (selectedTabSettings && (selectedTabSettings === null || selectedTabSettings === void 0 ? void 0 : selectedTabSettings.recommendedWallets)) {
        return selectedTabSettings.recommendedWallets;
    }
    return recommendedWallets;
};

const getEffectiveWalletFilter = (selectedTabSettings, walletsFilter) => {
    if (selectedTabSettings && (selectedTabSettings === null || selectedTabSettings === void 0 ? void 0 : selectedTabSettings.walletsFilter)) {
        return selectedTabSettings.walletsFilter;
    }
    return walletsFilter;
};

const useWalletList = ({ isWalletConnectList = false, viewWalletsFilter, searchFilter, lastUsedWalletKey, }) => {
    const { walletsFilter, walletConnectorOptions, defaultNumberOfWalletsToShow, bridgeChainsToConnect, authMode, multiWallet, recommendedWallets, selectedTabSettings, } = useInternalDynamicContext();
    const userWallets = useUserWallets();
    const walletGroups = useWalletGroups();
    const getFilteredBridgeChains = (bridgeChainsToConnect === null || bridgeChainsToConnect === void 0 ? void 0 : bridgeChainsToConnect.length) &&
        FilterBridgeChainsName(bridgeChainsToConnect[0].chain);
    const filteredBridgeChains = getFilteredBridgeChains && getFilteredBridgeChains(walletConnectorOptions);
    const effectiveRecommendedWallets = getEffectiveRecommendedWallets(selectedTabSettings, recommendedWallets);
    const effectiveWalletsFilter = getEffectiveWalletFilter(selectedTabSettings, walletsFilter);
    const { numberOfWallets, walletsList } = walletListBuilder({
        authMode,
        groupWallets: true,
        inputList: filteredBridgeChains || walletConnectorOptions,
        isWalletConnectList,
        lastUsedWalletKey,
        multiWallet,
        numberOfWalletsToShow: defaultNumberOfWalletsToShow,
        recommendedWallets: effectiveRecommendedWallets,
        searchFilter,
        showMoreWalletsWithFilter: true,
        userWallets,
        walletGroups,
        // use both filters if available, else use the viewWalletsFilter or effectiveWalletsFilter
        walletsFilter: viewWalletsFilter && effectiveWalletsFilter
            ? pipe(viewWalletsFilter).pipe(effectiveWalletsFilter)
            : viewWalletsFilter || effectiveWalletsFilter,
    });
    return {
        numberOfWallets,
        recommendedWallets: effectiveRecommendedWallets,
        walletsList,
    };
};

const SearchNotFoundMessage = ({ title, subtitle, image, }) => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsxs("div", { className: 'search-instead__container', children: [image && (jsxRuntimeExports.jsx(Icon, { className: 'search-instead__container__image', color: 'text-tertiary', children: image })), jsxRuntimeExports.jsx(Typography, { color: 'secondary', variant: 'body_small', weight: 'regular', copykey: 'dyn_wallet_list.wallet_missing.title', children: title || t('dyn_wallet_list.wallet_missing.title') }), jsxRuntimeExports.jsx(Typography, { color: 'primary', variant: 'button_primary', weight: 'regular', copykey: 'dyn_wallet_list.wallet_missing.description', children: subtitle || t('dyn_wallet_list.wallet_missing.description') })] }));
};

const WalletListGridTabs = ({ items, onSelect, value, }) => (jsxRuntimeExports.jsx("div", { className: 'wallet-list-grid-tabs', children: items.map((item, index) => {
        const selected = value === index;
        const { icon, text } = item.label;
        const key = `${text}-${icon}-${items.indexOf(item)}`;
        const TabIcon = typeof icon === 'string' ? jsxRuntimeExports.jsx("img", { src: icon, alt: text }) : icon;
        return (jsxRuntimeExports.jsxs("button", { type: 'button', className: classNames('wallet-list-grid-tabs__button', {
                'wallet-list-grid-tabs__button--selected': selected,
                'wallet-list-grid-tabs__button--text': Boolean(text),
            }), tabIndex: -1, "aria-label": text, onClick: () => onSelect(index), children: [TabIcon && (jsxRuntimeExports.jsx(Icon, { size: 'small', className: classNames({
                        'wallet-list-grid-tabs__icon--selected': !selected,
                    }), children: TabIcon })), text && (jsxRuntimeExports.jsx(Typography, { as: 'span', variant: 'body_small', weight: selected ? 'bold' : 'medium', color: selected ? 'primary' : 'secondary', children: text }))] }, key));
    }) }));

const WalletList = ({ isWalletConnectList = false, onSelectWallet, viewWalletsFilter, showDefaultFooter, scrollContainerClassName, }) => {
    var _a, _b;
    /**
     * Clear search key on unmount
     */
    useEffectOnce(() => () => StorageService === null || StorageService === void 0 ? void 0 : StorageService.setItem(WALLET_PICKER_SEARCH_KEY, ''));
    const { walletConnectorOptions, projectSettings, defaultNumberOfWalletsToShow, selectedTabIndex, setSelectedTabIndex, tabsItems, } = useInternalDynamicContext();
    const { error } = useErrorContext();
    const [footerBorderIsVisible, setFooterBorderIsVisible] = useState(true);
    const { t } = useTranslation();
    const [filterValue, setFilterValue] = useState((_a = StorageService.getItem(WALLET_PICKER_SEARCH_KEY)) !== null && _a !== void 0 ? _a : '');
    const { numberOfWallets, walletsList, recommendedWallets: effectiveRecommendedWallets, } = useWalletList({
        isWalletConnectList,
        lastUsedWalletKey: (_b = StorageService.getItem(LAST_USED_WALLET)) !== null && _b !== void 0 ? _b : undefined,
        searchFilter: filterValue,
        viewWalletsFilter,
    });
    const isSearchEnabled = Boolean(filterValue) ||
        (numberOfWallets > defaultNumberOfWalletsToShow &&
            walletsList.length !== numberOfWallets);
    const isTabsEnabled = Boolean(tabsItems === null || tabsItems === void 0 ? void 0 : tabsItems.length);
    const walletListScrollRef = useRef(null);
    /* istanbul ignore next */
    const handleScroll = () => {
        const element = walletListScrollRef.current;
        if (!element) {
            return;
        }
        if ((element === null || element === void 0 ? void 0 : element.scrollTop) > (element === null || element === void 0 ? void 0 : element.clientHeight) * 1.25) {
            setFooterBorderIsVisible(false);
        }
        else {
            setFooterBorderIsVisible(true);
        }
    };
    const handleFilterValueChange = (value) => {
        StorageService.setItem(WALLET_PICKER_SEARCH_KEY, value);
        setFilterValue(value);
    };
    const searchContainer = !projectSettings ? (jsxRuntimeExports.jsx(Skeleton, { className: 'wallet-list__search-skeleton' })) : (isSearchEnabled && (jsxRuntimeExports.jsx("div", { className: classNames('wallet-list__search-container', {
            'wallet-list__search-container--scroll': !error,
        }), children: jsxRuntimeExports.jsx(Search, { copykey: 'dyn_wallet_list.search.label', label: t('dyn_wallet_list.search.label', { numberOfWallets }), value: filterValue, onChange: ({ target: { value } }) => handleFilterValueChange(value), onClickClear: () => handleFilterValueChange('') }) })));
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [isTabsEnabled && (jsxRuntimeExports.jsx("div", { className: 'wallet-list__tabs-container', children: jsxRuntimeExports.jsx(WalletListGridTabs
                // The tabsItems nullable assertion is safe here because isTabsEnabled is true
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                , { 
                    // The tabsItems nullable assertion is safe here because isTabsEnabled is true
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    items: tabsItems, value: selectedTabIndex || 0, onSelect: setSelectedTabIndex }) })), searchContainer, Boolean(error) && (jsxRuntimeExports.jsx(ErrorContainer, { className: 'wallet-list__error-container', withIcon: false, children: error })), jsxRuntimeExports.jsxs("div", { className: classNames('wallet-list__scroll-container', scrollContainerClassName, {
                    'wallet-list__scroll-container--error': Boolean(error),
                    'wallet-list__scroll-container--fixed-height': isTabsEnabled,
                }), "data-testid": 'wallet-list-scroll-container', ref: walletListScrollRef, onScroll: handleScroll, children: [!projectSettings ? (jsxRuntimeExports.jsx(Skeleton, { count: 10, className: 'wallet-list__tile-skeleton' })) : (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [walletConnectorOptions.length === 0 && (jsxRuntimeExports.jsx(ErrorContainer, { copykey: 'dyn_wallet_list.configuration_mismatch', children: t('dyn_wallet_list.configuration_mismatch') })), walletConnectorOptions.length && walletsList.length === 0 ? (jsxRuntimeExports.jsx(SearchNotFoundMessage, { title: t('dyn_wallet_list.search.not_found.title'), subtitle: t('dyn_wallet_list.search.not_found.description'), image: jsxRuntimeExports.jsx(SvgNoWalletFound, {}) })) : (walletsList.map((wallet, index) => (jsxRuntimeExports.jsx(WalletListItem, { wallet: wallet, onResetSearchValue: () => handleFilterValueChange(''), recommendedWallets: effectiveRecommendedWallets, onSelectWallet: onSelectWallet }, `${wallet.key}_${index}`))))] })), isSearchEnabled && !filterValue && projectSettings && (jsxRuntimeExports.jsx(SearchNotFoundMessage, {}))] }), showDefaultFooter && (jsxRuntimeExports.jsx(DefaultFooter, { hideBorder: !footerBorderIsVisible }))] }));
};

const isPhoneNumberProviderEnabled = (providers) => Boolean(providers && isProviderEnabled(providers, ProviderEnum.Sms));

const useSubmitPhoneNumber = ({ onSubmit, onSubmitError, country, phone, setInvalidNumberMessage, }) => {
    const { engageCaptcha } = useCaptchaContext();
    const { view, pushView } = useViewContext();
    const { environmentId, projectSettings } = useInternalDynamicContext();
    const { setDisplayedDestination, setVerificationUUID, setRetryData } = useVerification();
    const { fieldsConfig } = useFields();
    const { t } = useTranslation();
    const submitPhoneNumber = (captchaToken) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!country)
            return;
        try {
            const phoneNumber = de({
                dialCode: country.dialCode,
                phone,
            });
            const { verificationUUID } = yield createSmsVerification({
                captchaToken,
                environmentId,
                isoCountryCode: country.iso2,
                phoneCountryCode: country.dialCode,
                phoneNumber,
            });
            setRetryData({
                dialCode: country.dialCode,
                iso2: country.iso2,
                phone: phoneNumber,
            });
            // we can safely assume phone number always requires verification here
            // because this hook is only used for SMS sign in.
            pushView('login-with-sms-verification');
            setDisplayedDestination(formatPhone(phone));
            setVerificationUUID(verificationUUID);
            const phoneData = {
                dialCode: country.dialCode,
                iso2: country.iso2,
                phone: phoneNumber,
            };
            dynamicEvents.emit('authInit', {
                option: phoneData,
                phone: phoneData,
                type: 'sms',
            });
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
        }
        catch (error) {
            pushView(view.type);
            if (error instanceof SmsVerificationError) {
                let message = t('dyn_login.helper.phone_number_form.invalid_phone');
                if (error.code === 'too_many_sms_verification_attempts') {
                    message = t('dyn_login.helper.phone_number_form.too_many_sms_verification_attempts');
                }
                // Use the code from error message if a translation for it exists
                if (error.code &&
                    error.code in translation.dyn_login.helper.phone_number_form)
                    message = t('dyn_login.helper.phone_number_form.' + error.code);
                setInvalidNumberMessage(message);
            }
            else if (typeof error === 'string')
                setInvalidNumberMessage(error);
            onSubmitError === null || onSubmitError === void 0 ? void 0 : onSubmitError();
        }
    });
    return (event) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a;
        if (!country)
            return;
        event.preventDefault();
        try {
            fieldsConfig.phoneNumber.validation.validateSync(phone);
        }
        catch (error) {
            const { message } = error;
            setInvalidNumberMessage(message);
            onSubmitError === null || onSubmitError === void 0 ? void 0 : onSubmitError();
            return;
        }
        if ((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.security.hCaptcha) === null || _a === void 0 ? void 0 : _a.enabled) {
            engageCaptcha({
                authMethod: 'phone',
                onCaptchaSuccess: submitPhoneNumber,
            });
            return;
        }
        submitPhoneNumber();
    });
};

const PhoneNumberSignInSection = ({ isLoading, onSubmit, onSubmitError, }) => {
    var _a, _b;
    const { projectSettings } = useInternalDynamicContext();
    const countriesWithVerification = useMemo(() => {
        const enabledCountries = getSupportedCountriesForVerificationFromProjectSettings(projectSettings);
        // For login, we always want to use only countries with verification supported
        return getCustomCountries(getDefaultCountriesIfEmpty(enabledCountries));
    }, [projectSettings]);
    const [invalidNumberMessage, setInvalidNumberMessage] = useState(undefined);
    const [isInputComplete, setIsInputComplete] = useState(false);
    const [phoneData, setPhoneData] = useState({
        country: undefined,
        phone: '',
    });
    const handleUpdate = useCallback((phoneData) => {
        setPhoneData(phoneData);
        setIsInputComplete(validatePhoneLength(phoneData.phone, phoneData.country));
    }, []);
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const handleSubmit = useSubmitPhoneNumber({
        country: phoneData.country,
        onSubmit,
        onSubmitError,
        phone: phoneData.phone,
        setInvalidNumberMessage,
    });
    if (!isPhoneNumberProviderEnabled((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers) !== null && _a !== void 0 ? _a : [])) {
        logger$1.error('Failed to render PhoneNumberSignInSection - no sign in provider enabled');
        return null;
    }
    const showBigSubmitButton = !((_b = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.design.modal) === null || _b === void 0 ? void 0 : _b.emailSubmitButtonInsideInput);
    return (jsxRuntimeExports.jsxs("form", { className: 'login-with-phone-number-form', onSubmit: (e) => handleSubmit(e), children: [jsxRuntimeExports.jsx(PhoneNumberField, { countries: countriesWithVerification, onUpdate: handleUpdate, error: invalidNumberMessage, setIsHovered: setIsHovered, setIsFocused: setIsFocused, appendRight: jsxRuntimeExports.jsx(InlineSubmitButton, { disabled: isLoading || !isInputComplete, highlighted: isInputComplete, isFocused: isFocused, isHovered: isHovered, className: 'login-with-phone-number-form__fields__inline-submit', emailSubmitButtonInsideInput: !showBigSubmitButton }) }), showBigSubmitButton && (jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'big-submit-button', buttonClassName: 'login-with-phone-number-form__button', type: 'submit', loading: isLoading, disabled: isLoading || !isInputComplete, buttonVariant: 'brand-primary', buttonPadding: 'login-screen-height', expanded: true, typographyProps: {
                    color: 'inherit',
                }, children: "Continue" }))] }));
};

const getSocialSignInProviderFromString = (provider) => {
    if (!provider)
        return;
    const values = Object.values(SocialSignInProviderEnum);
    for (const value of values) {
        if (value === provider) {
            return value;
        }
    }
    return undefined;
};

var _path$u;
var _excluded$y = ["title", "titleId"];
function _extends$y() { return _extends$y = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$y.apply(null, arguments); }
function _objectWithoutProperties$y(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$y(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$y(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgDotsHorizontal = function SvgDotsHorizontal(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$y(_ref, _excluded$y);
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7 10a1.667 1.667 0 1 1 3.333 0A1.667 1.667 0 0 1 2.7 10Zm5.833 0a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm5.834 0a1.667 1.667 0 1 1 3.333 0 1.667 1.667 0 0 1-3.333 0Z",
    fill: "currentColor",
    fillOpacity: 0.4
  })));
};

const providerLabel = (provider) => {
    if (!provider) {
        return undefined;
    }
    if (provider === SocialSignInProviderEnum.Twitter) {
        return 'X';
    }
    if (provider === SocialSignInProviderEnum.Coinbasesocial) {
        return 'Coinbase';
    }
    return capitalize$1(provider);
};

const INTERNAL_MAX_INLINE_ITEMS = 5;
const SocialSignIn = ({ providers, onSelectProvider, isLoading, selectedProvider, testId, defaultProvider, numOfItemsToDisplay: externalMaxInlineItems = 5, collapsedLayout, }) => {
    const { t } = useTranslation();
    const iconThemeVariant = useIconThemeVariant();
    // ====================================
    // INLINE VS DEFAULT PROVIDERS
    // ====================================
    // Set default provider as the first available provider if default provider isn't within the providers
    if (defaultProvider && !providers.includes(defaultProvider)) {
        [defaultProvider] = providers;
    }
    /** All enabled providers except the default one */
    const inlineProviders = providers.filter((provider) => provider !== defaultProvider);
    // ====================================
    // ALL PROVIDERS VIEW
    // ====================================
    /** Number of items set in prop, with a max limit of INTERNAL_MAX_INLINE_ITEMS */
    const maxInlineItems = Math.min(externalMaxInlineItems, INTERNAL_MAX_INLINE_ITEMS);
    // Show card button if there are more inline providers than the max
    const showAllProvidersButton = inlineProviders.length > maxInlineItems;
    /** The inline providers that we will show */
    const cappedInlineProviders = showAllProvidersButton
        ? inlineProviders.slice(0, maxInlineItems - 1)
        : inlineProviders.slice(0, maxInlineItems);
    const [showAllProvidersCard, setShowAllProvidersCard] = useState(false);
    const closeAllProvidersCard = () => !isLoading && setShowAllProvidersCard(false);
    // ====================================
    // REACT DISPLAY
    // ====================================
    // Display all with full width if there's only one, or
    // there's no wallet list and 3 social items or less
    const showAllFullWidth = providers.length === 1 || (!collapsedLayout && providers.length < 4);
    const getProviderAsString = (provider) => provider;
    const renderProviderItem = (provider, fullWidth = false, insideCard = false) => (jsxRuntimeExports.jsxs(IconListTile, { dataTestId: insideCard ? `card-${provider}` : `inline-${provider}`, onClick: () => onSelectProvider(provider), disabled: Boolean(selectedProvider), className: classNames({
            'social-sign-in--card--tile': insideCard,
            'social-sign-in--tile': !insideCard,
            'social-sign-in--tile__full-width': fullWidth,
        }), children: [jsxRuntimeExports.jsx(IconWithSpinner, { Icon: 
                // eslint-disable-next-line react/jsx-wrap-multilines
                jsxRuntimeExports.jsx(SocialIcon, { name: getProviderAsString(provider), variant: iconThemeVariant }), isSpinning: selectedProvider === provider, iconSize: 32 }), !insideCard && fullWidth && (jsxRuntimeExports.jsx(Typography, { variant: 'button_primary', copykey: 'dyn_login.social.button_label', children: t('dyn_login.social.button_label', {
                    provider: providerLabel(provider),
                }) }))] }, getProviderAsString(provider)));
    if (!providers.length) {
        logger$1.error('Failed to render SocialSignInSection - no social providers enabled');
        return null;
    }
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("div", { className: 'social-sign-in', "data-testid": testId, children: [defaultProvider && renderProviderItem(defaultProvider, true), cappedInlineProviders.map((provider) => renderProviderItem(provider, showAllFullWidth)), showAllProvidersButton && (jsxRuntimeExports.jsx(IconListTile, { dataTestId: 'show-more-options', onClick: () => setShowAllProvidersCard(true), className: 'social-sign-in--tile', children: jsxRuntimeExports.jsx(Icon, { color: 'text-primary', children: jsxRuntimeExports.jsx(SvgDotsHorizontal, {}) }) }, 'show-more-options'))] }), jsxRuntimeExports.jsxs(OverlayCard, { isOpen: showAllProvidersCard, onClose: closeAllProvidersCard, children: [jsxRuntimeExports.jsx(OverlayCard.Header, { closeDisabled: isLoading, children: t('dyn_login.social.overlay_title') }), jsxRuntimeExports.jsx(OverlayCard.Content, { className: 'social-sign-in--card--body', children: providers.map((provider) => renderProviderItem(provider, false, true)) })] })] }));
};

const MagicSocialSignIn = ({ defaultProvider, numOfItemsToDisplay, collapsedLayout, }) => {
    const { projectSettings } = useInternalDynamicContext();
    const { socialProvider, setSocialProvider, socialWalletConnector, enabledSocialProviders, } = useSocialRedirectContext();
    const { engageCaptcha } = useCaptchaContext();
    const { mutate: onClickProvider, isLoading } = useMutation((provider) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a;
        if ((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.security.hCaptcha) === null || _a === void 0 ? void 0 : _a.enabled) {
            engageCaptcha({
                authMethod: 'social',
                onCaptchaSuccess: (captchaToken) => __awaiter$1(void 0, void 0, void 0, function* () {
                    setSocialProvider(provider);
                    yield (socialWalletConnector === null || socialWalletConnector === void 0 ? void 0 : socialWalletConnector.endSession());
                    return socialWalletConnector === null || socialWalletConnector === void 0 ? void 0 : socialWalletConnector.connect(provider);
                }),
            });
            return;
        }
        setSocialProvider(provider);
        yield (socialWalletConnector === null || socialWalletConnector === void 0 ? void 0 : socialWalletConnector.endSession());
        return socialWalletConnector === null || socialWalletConnector === void 0 ? void 0 : socialWalletConnector.connect(provider);
    }));
    return (jsxRuntimeExports.jsx(SocialSignIn, { onSelectProvider: onClickProvider, providers: enabledSocialProviders, selectedProvider: socialProvider, isLoading: isLoading, testId: 'magic-social-sign-in', defaultProvider: defaultProvider, numOfItemsToDisplay: numOfItemsToDisplay, collapsedLayout: collapsedLayout }));
};

const getProviderEnumForSocialSignInProvider = (provider) => {
    if (!provider)
        return null;
    const values = Object.values(ProviderEnum);
    for (const value of values) {
        if (value === provider) {
            return value;
        }
    }
    return null;
};

const DynamicSocialSignIn = ({ defaultProvider, numOfItemsToDisplay, collapsedLayout, }) => {
    const { setShowAuthFlow, projectSettings } = useInternalDynamicContext();
    const { setSocialProvider, socialProvider, enabledSocialProviders } = useSocialRedirectContext();
    const { pushView, clearStackAndPushInitialView } = useViewContext();
    const { engageCaptcha } = useCaptchaContext();
    const { isProcessing, connectSocialAccount } = useSocialAuth({
        onError: () => {
            clearStackAndPushInitialView();
        },
        onFarcasterUrl: (url) => pushView('farcaster-connect-view', { url }, {
            onBackClick: () => {
                setSocialProvider(undefined);
                dynamicEvents.emit('farcasterConnectCancelled');
                dynamicEvents.emit('authFailure', {
                    option: ProviderEnum.Farcaster,
                    provider: ProviderEnum.Farcaster,
                    type: 'social',
                }, 'user-cancelled');
                // Navigate back to the initial login view.
                clearStackAndPushInitialView();
            },
        }),
        onSettled: () => {
            setSocialProvider(undefined);
        },
    });
    const onSelectProvider = (provider) => {
        var _a;
        const providerEnum = getProviderEnumForSocialSignInProvider(provider);
        setSocialProvider(provider);
        // Captcha Enabled
        if ((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.security.hCaptcha) === null || _a === void 0 ? void 0 : _a.enabled) {
            engageCaptcha({
                authMethod: 'social',
                onCaptchaSuccess: (captchaToken) => __awaiter$1(void 0, void 0, void 0, function* () {
                    pushView('social-redirect-view');
                    setShowAuthFlow(true);
                    connectSocialAccount({
                        authMode: 'signin',
                        captchaToken,
                        provider: providerEnum,
                    });
                }),
            });
            return;
        }
        // No Captcha enabled
        pushView('social-redirect-view');
        setShowAuthFlow(true);
        connectSocialAccount({
            authMode: 'signin',
            provider: providerEnum,
        });
    };
    return (jsxRuntimeExports.jsx(SocialSignIn, { onSelectProvider: onSelectProvider, providers: enabledSocialProviders, selectedProvider: socialProvider, isLoading: isProcessing, testId: 'dynamic-social-sign-in', defaultProvider: defaultProvider, numOfItemsToDisplay: numOfItemsToDisplay, collapsedLayout: collapsedLayout }));
};

const SocialSignInSection = ({ sectionData, collapsedLayout, }) => {
    var _a, _b, _c;
    const { projectSettings } = useInternalDynamicContext();
    const providers = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers) !== null && _a !== void 0 ? _a : [];
    const componentProps = {
        collapsedLayout,
        defaultProvider: getSocialSignInProviderFromString(sectionData.defaultItem),
        numOfItemsToDisplay: sectionData.numOfItemsToDisplay,
    };
    const isMagicEnabled = isProviderEnabled(providers, ProviderEnum.MagicLink);
    if (isMagicEnabled &&
        ((_b = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.socialSignIn) === null || _b === void 0 ? void 0 : _b.signInProvider) ===
            SignInProviderEnum.MagicLink) {
        return jsxRuntimeExports.jsx(MagicSocialSignIn, Object.assign({}, componentProps));
    }
    if (((_c = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.socialSignIn) === null || _c === void 0 ? void 0 : _c.signInProvider) ===
        SignInProviderEnum.Dynamic) {
        return jsxRuntimeExports.jsx(DynamicSocialSignIn, Object.assign({}, componentProps));
    }
    logger$1.error('Failed to render SocialSignInSection - no sign in provider enabled');
    return null;
};

const ToggleableSection = ({ sections }) => {
    /** When true, shows first section. When false, shows second */
    const [showFirst, setShowFirst] = useState(true);
    const section = showFirst ? sections[0] : sections[1];
    return (jsxRuntimeExports.jsxs("div", { className: 'toggleable-section', children: [section.component, jsxRuntimeExports.jsxs("div", { className: 'toggleable-section__toggle-prompt', children: [jsxRuntimeExports.jsx(Typography, { color: 'secondary', variant: 'body_small', copykey: section.labelCopyKey, children: section.label }), jsxRuntimeExports.jsx("button", { className: 'toggleable-section__toggle-prompt__button', onClick: () => setShowFirst(!showFirst), children: jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'body_small', color: 'brand-primary', className: 'toggleable-section__toggle-prompt__button__text', copykey: section.buttonCopyKey, children: section.button }) })] })] }));
};

const ListItemButton = ({ text, onClick, numberOfWallets, disabled = false, copykey, }) => {
    const numberOfWalletsText = useMemo(() => {
        if (numberOfWallets <= 10) {
            return numberOfWallets;
        }
        return `${Math.floor(numberOfWallets / 10) * 10}+`;
    }, [numberOfWallets]);
    const trailing = (jsxRuntimeExports.jsxs("div", { className: 'list-item-button__trailing', children: [jsxRuntimeExports.jsx("div", { className: classNames('list-item-button__trailing-child', 'list-item-button__trailing-label'), children: jsxRuntimeExports.jsx(Badge, { text: `${numberOfWalletsText} available` }) }), jsxRuntimeExports.jsx("div", { className: classNames('list-item-button__trailing-child', 'list-item-button__trailing-icon'), children: jsxRuntimeExports.jsx(Icon, { color: 'text-primary', size: 'small', children: jsxRuntimeExports.jsx(SvgStroke, {}) }) })] }));
    return (jsxRuntimeExports.jsx(ListTile, { trailing: trailing, onClick: onClick, className: 'list-item-button', disabled: disabled, copykey: copykey, children: text }));
};

const WalletSimpleSignIn = ({ previewWalletsNumber, disabled = false, onshowAllWallets, }) => {
    var _a;
    const { t } = useTranslation();
    const { walletConnectorOptions, projectSettings, walletsFilter, authMode, multiWallet, recommendedWallets, } = useInternalDynamicContext();
    const userWallets = useUserWallets();
    const walletGroups = useWalletGroups();
    const { handleWalletItemClick } = useWalletItemActions();
    const { numberOfWallets, walletsList } = walletListBuilder({
        authMode,
        groupWallets: true,
        inputList: walletConnectorOptions,
        isWalletConnectList: false,
        lastUsedWalletKey: (_a = StorageService.getItem(LAST_USED_WALLET)) !== null && _a !== void 0 ? _a : undefined,
        loginWithEmail: true,
        multiWallet,
        numberOfWalletsToShow: previewWalletsNumber,
        recommendedWallets,
        searchFilter: undefined,
        userWallets,
        walletGroups,
        walletsFilter,
    });
    return !projectSettings ? (jsxRuntimeExports.jsx(Skeleton, { count: previewWalletsNumber + 1, className: 'login-with-email-wallet-list__skeleton' })) : (jsxRuntimeExports.jsxs("div", { className: 'login-with-email-wallet-list__container', "data-testid": 'top-wallets-list', children: [walletsList.map((wallet, index) => (jsxRuntimeExports.jsx(WalletListItem, { wallet: wallet, disabled: disabled, onSelectWallet: handleWalletItemClick, recommendedWallets: recommendedWallets }, `${wallet.key}_${index}`))), jsxRuntimeExports.jsx(ListItemButton, { copykey: 'dyn_wallet_list.view_all', text: t('dyn_wallet_list.view_all'), onClick: onshowAllWallets, numberOfWallets: numberOfWallets, disabled: disabled })] }));
};

const WalletSignInSection = ({ numberOfItemsToShow, isLoading, onSubmit, }) => {
    const { t } = useTranslation();
    return numberOfItemsToShow > 0 ? (jsxRuntimeExports.jsx(WalletSimpleSignIn, { previewWalletsNumber: numberOfItemsToShow, onshowAllWallets: () => onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(), disabled: isLoading })) : (jsxRuntimeExports.jsx(IconListTile, { onClick: () => onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(), disabled: isLoading, className: 'connect-with-wallet-button', children: jsxRuntimeExports.jsx(Typography, { variant: 'button_primary', copykey: 'dyn_login.wallet_list.button_only', children: t('dyn_login.wallet_list.button_only') }) }));
};

const LoginViewSection = ({ viewSection, index, walletCount, gotToWalletList, }) => {
    const { loading } = useLoadingContext();
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(loading);
    switch (viewSection.type) {
        case SdkViewSectionType.Separator:
            return jsxRuntimeExports.jsx(Divider, { text: viewSection.label });
        case SdkViewSectionType.Email:
            return (jsxRuntimeExports.jsx(LoginEmailForm, { onSubmit: () => setIsLoading(true), onSubmitError: () => setIsLoading(false), isLoading: isLoading }));
        case SdkViewSectionType.Phone:
            return (jsxRuntimeExports.jsx(PhoneNumberSignInSection, { onSubmit: () => setIsLoading(true), onSubmitError: () => setIsLoading(false), isLoading: isLoading }));
        case SdkViewSectionType.EmailAndPhone:
            // eslint-disable-next-line no-case-declarations
            const sections = [
                {
                    button: t('dyn_login.email_or_phone.use_phone'),
                    buttonCopyKey: 'dyn_login.email_or_phone.use_phone',
                    component: (jsxRuntimeExports.jsx(LoginEmailForm, { onSubmit: () => setIsLoading(true), onSubmitError: () => setIsLoading(false), isLoading: isLoading })),
                    label: t('dyn_login.email_or_phone.prefer_phone'),
                    labelCopyKey: 'dyn_login.email_or_phone.prefer_phone',
                },
                {
                    button: t('dyn_login.email_or_phone.use_email'),
                    buttonCopyKey: 'dyn_login.email_or_phone.use_email',
                    component: (jsxRuntimeExports.jsx(PhoneNumberSignInSection, { onSubmit: () => setIsLoading(true), onSubmitError: () => setIsLoading(false), isLoading: isLoading })),
                    label: t('dyn_login.email_or_phone.prefer_email'),
                    labelCopyKey: 'dyn_login.email_or_phone.prefer_email',
                },
            ];
            if (viewSection.defaultItem === 'phone')
                sections.reverse();
            return jsxRuntimeExports.jsx(ToggleableSection, { sections: sections });
        case SdkViewSectionType.Wallet:
            return (jsxRuntimeExports.jsx(WalletSignInSection, { numberOfItemsToShow: viewSection.numOfItemsToDisplay || 0, onSubmit: gotToWalletList, isLoading: isLoading }));
        case SdkViewSectionType.Social:
            return (jsxRuntimeExports.jsx(SocialSignInSection, { collapsedLayout: walletCount > 1, sectionData: viewSection }));
        case SdkViewSectionType.Text:
            return viewSection.label ? (jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', align: viewSection.alignment, className: 'login-view__text', "data-testid": 'login-view-section__text', children: viewSection.label })) : null;
    }
};

const getWalletsSection = (numOfWalletsToDisplay) => ({
    numOfItemsToDisplay: numOfWalletsToDisplay,
    type: SdkViewSectionType.Wallet,
});
const getSocialsSection = (numOfSocialsToDisplay, defaultItem) => ({
    defaultItem,
    numOfItemsToDisplay: numOfSocialsToDisplay,
    type: SdkViewSectionType.Social,
});
const getSimpleSection = (type) => ({ type });
/**
 * Defines in which order each section shows, and under which conditions
 */
const getLoginViewStructure = ({ socialAboveEmail, showWallets, web3Layout, numOfWalletsToDisplay, showEmail, showPhone, showSocial, splitEmailAndSocial, defaultSocialItem, }) => {
    const joinEmailAndSocial = !splitEmailAndSocial && (showEmail || showPhone);
    const defaultSocial = splitEmailAndSocial ? defaultSocialItem : undefined;
    return [
        // Web 3 layout wallets
        {
            condition: showWallets && web3Layout,
            section: getWalletsSection(numOfWalletsToDisplay),
        },
        // Social before email
        {
            condition: showSocial && socialAboveEmail,
            hideSeparator: joinEmailAndSocial ? 'below' : undefined,
            section: getSocialsSection(5, defaultSocial),
        },
        // Email and/or phone
        {
            condition: showEmail && !showPhone,
            section: getSimpleSection(SdkViewSectionType.Email),
        },
        {
            condition: !showEmail && showPhone,
            section: getSimpleSection(SdkViewSectionType.Phone),
        },
        {
            condition: showEmail && showPhone,
            section: getSimpleSection(SdkViewSectionType.EmailAndPhone),
        },
        // Social after email
        {
            condition: showSocial && !socialAboveEmail,
            hideSeparator: joinEmailAndSocial ? 'above' : undefined,
            section: getSocialsSection(5, defaultSocial),
        },
        // Web 2 layout wallets
        {
            condition: showWallets && !web3Layout,
            section: getWalletsSection(numOfWalletsToDisplay),
        },
    ];
};

const useViewSettings = (viewType) => {
    var _a, _b, _c;
    const { projectSettings, overrides } = useInternalDynamicContext();
    const apiViewSettings = (_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _a === void 0 ? void 0 : _a.views) === null || _b === void 0 ? void 0 : _b.find((view) => view.type === viewType);
    const overrideViewSettings = (_c = overrides === null || overrides === void 0 ? void 0 : overrides.views) === null || _c === void 0 ? void 0 : _c.find((view) => view.type === viewType);
    return (overrideViewSettings || apiViewSettings);
};

/* eslint-disable multiline-comment-style */
const NUMBER_OF_WALLETS = 3;
const useLoginView = () => {
    const loginView = useViewSettings(SdkViewType.Login);
    const { projectSettings, authorizationViewDisplayOrder, loginWithEmail, walletConnectorOptions, walletsFilter, } = useInternalDynamicContext();
    const { t } = useTranslation();
    const { enabledSocialProviders } = useSocialRedirectContext();
    const hasSocialProvidersEnabled = Boolean(enabledSocialProviders === null || enabledSocialProviders === void 0 ? void 0 : enabledSocialProviders.length);
    const hasEmailProviderEnabled = isEmailProviderEnabled(projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers);
    const hasPhoneProviderEnabled = isPhoneNumberProviderEnabled(projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers);
    /** Takes from wallets only those that can be selected in the wallet list by the user.
     * Should filter out embedded wallets
     * WHY: when we decide whether to show wallets or not, we need to know how many wallets
     * will actually be rendered. It would be especially bad to only have for ex "turnkey" in
     * wallets and then display an empty wallet list (since turnkey doesn't render)
     */
    const selectableWallets = (walletsFilter
        ? walletsFilter(walletConnectorOptions)
        : walletConnectorOptions).filter(({ key }) => key !== 'turnkey');
    const isWalletOnly = useMemo(() => {
        var _a;
        if (!projectSettings) {
            return false;
        }
        // When no other methods are enabled we can safely assume it's wallet only
        if (!loginWithEmail &&
            !hasPhoneProviderEnabled &&
            !hasSocialProvidersEnabled) {
            return true;
        }
        // backwards compatibility for those that didn't set up login view sections
        if (!((_a = loginView === null || loginView === void 0 ? void 0 : loginView.sections) === null || _a === void 0 ? void 0 : _a.length)) {
            return (!hasEmailProviderEnabled &&
                !hasPhoneProviderEnabled &&
                !hasSocialProvidersEnabled);
        }
        return (loginView.sections.length === 1 && loginView.sections[0].type === 'wallet');
    }, [
        loginView === null || loginView === void 0 ? void 0 : loginView.sections,
        projectSettings,
        loginWithEmail,
        hasSocialProvidersEnabled,
        hasPhoneProviderEnabled,
        hasEmailProviderEnabled,
    ]);
    // TODO: https://linear.app/dynamic-labs/issue/GVTY-212/rethink-or-implement-toolkit-template-for-email-wallet-order
    /**
     * remove wallet view section from projectSettings?.sdk?.views if no wallet defined
     * @param sections
     * @returns
     */
    const filterLoginViewSections = useCallback((sections) => {
        var _a;
        const hasEnabledNetwork = (chain) => { var _a; return (_a = chain.networks) === null || _a === void 0 ? void 0 : _a.some((network) => network.enabled); };
        const hasEnabledChain = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.chains) === null || _a === void 0 ? void 0 : _a.some((chain) => chain.enabled && hasEnabledNetwork(chain));
        if (!hasEnabledChain &&
            sections.find((section) => section.type === 'wallet')) {
            logger$1.error('Failed to render WalletSignInSection - no chains enabled');
        }
        if (selectableWallets === null || selectableWallets === void 0 ? void 0 : selectableWallets.length) {
            return sections;
        }
        return sections.filter((section) => section.type !== 'wallet');
    }, [selectableWallets === null || selectableWallets === void 0 ? void 0 : selectableWallets.length, projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.chains]);
    /**
     * returns the login view sections to be displayed in order from projectSettings?.sdk?.views
     * and has backwards compatibility with project settings design.modal props
     */
    const loginViewSections = useMemo(() => {
        var _a, _b, _c, _d, _e, _f;
        // If client provides the sections explicitly, we use their definitions
        if ((_a = loginView === null || loginView === void 0 ? void 0 : loginView.sections) === null || _a === void 0 ? void 0 : _a.length) {
            return filterLoginViewSections(loginView === null || loginView === void 0 ? void 0 : loginView.sections);
        }
        // If not, we build it using the default structure
        const { splitEmailAndSocial = false, socialAboveEmail = false } = (_b = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.design.modal) !== null && _b !== void 0 ? _b : {};
        const sections = [];
        const sectionRecipes = getLoginViewStructure({
            defaultSocialItem: enabledSocialProviders[0],
            numOfWalletsToDisplay: ((_d = (_c = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.design) === null || _c === void 0 ? void 0 : _c.modal) === null || _d === void 0 ? void 0 : _d.showWalletsButton)
                ? 0
                : NUMBER_OF_WALLETS,
            showEmail: hasEmailProviderEnabled,
            showPhone: hasPhoneProviderEnabled,
            showSocial: Boolean(enabledSocialProviders === null || enabledSocialProviders === void 0 ? void 0 : enabledSocialProviders.length),
            // is email only is set in the project settings when the "Email (Web2) only" is toggled on in the dashboard
            showWallets: Boolean(selectableWallets === null || selectableWallets === void 0 ? void 0 : selectableWallets.length) &&
                !((_f = (_e = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.design) === null || _e === void 0 ? void 0 : _e.modal) === null || _f === void 0 ? void 0 : _f.emailOnly),
            socialAboveEmail,
            splitEmailAndSocial,
            web3Layout: authorizationViewDisplayOrder === 'web3',
        });
        const separator = {
            label: t('dyn_login.separators.default'),
            type: SdkViewSectionType.Separator,
        };
        let skipSeparator = false;
        for (const recipe of sectionRecipes) {
            if (!recipe.condition)
                continue;
            // First we add the separator
            if (sections.length > 0 &&
                !skipSeparator &&
                recipe.hideSeparator !== 'above')
                sections.push(separator);
            sections.push(recipe.section);
            skipSeparator = recipe.hideSeparator === 'below';
        }
        return sections;
    }, [
        authorizationViewDisplayOrder,
        enabledSocialProviders,
        filterLoginViewSections,
        hasEmailProviderEnabled,
        hasPhoneProviderEnabled,
        loginView === null || loginView === void 0 ? void 0 : loginView.sections,
        projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.design.modal,
        selectableWallets === null || selectableWallets === void 0 ? void 0 : selectableWallets.length,
        t,
    ]);
    return {
        isWalletOnly,
        loginViewSections,
    };
};

const showFarcasterQrCodeView = (loginViewSections, enabledSocialProviders) => loginViewSections.length === 1 &&
    loginViewSections[0].type === SdkViewSectionType.Social &&
    enabledSocialProviders.length === 1 &&
    enabledSocialProviders.includes(SocialSignInProviderEnum.Farcaster) &&
    !isMobile();

const LoginView = () => {
    var _a;
    const { error } = useErrorContext();
    const { pushView } = useViewContext();
    const { isWalletOnly, loginViewSections } = useLoginView();
    const { enabledSocialProviders } = useSocialRedirectContext();
    const { showDefaultFooter } = useAuthLayoutChecks();
    const { handleWalletItemClick } = useWalletItemActions();
    const numOfWallets = ((_a = loginViewSections.find((section) => section.type === SdkViewSectionType.Wallet)) === null || _a === void 0 ? void 0 : _a.numOfItemsToDisplay) || 0;
    const renderViewSections = useMemo(() => loginViewSections.map((viewSection, index) => (jsxRuntimeExports.jsx("div", { className: classNames('login-view__scroll__section', `login-view__scroll__section--${viewSection.type}`), children: jsxRuntimeExports.jsx(LoginViewSection, { gotToWalletList: () => pushView('login-with-email-or-wallet-full-wallet-list'), index: index, viewSection: viewSection, walletCount: numOfWallets }) }, `${viewSection.type}__${index}`))), [loginViewSections, numOfWallets]);
    const errorElement = error && (jsxRuntimeExports.jsx(ErrorContainer, { className: 'login-view__error-container', withIcon: false, children: error }));
    if (showFarcasterQrCodeView(loginViewSections, enabledSocialProviders)) {
        return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [errorElement, jsxRuntimeExports.jsx(FarcasterQrCodeView, {})] }));
    }
    if (isWalletOnly) {
        return (jsxRuntimeExports.jsx(WalletList, { onSelectWallet: handleWalletItemClick, showDefaultFooter: showDefaultFooter }));
    }
    const shouldShowFooter = isMobile() && showDefaultFooter;
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [errorElement, jsxRuntimeExports.jsx("div", { className: classNames('login-view__container', {
                    'login-view__container--error': Boolean(error),
                }), children: jsxRuntimeExports.jsx("div", { className: 'login-view__scroll', "data-testid": 'login-view-scroll', children: renderViewSections }) }), shouldShowFooter && jsxRuntimeExports.jsx(DefaultFooter, { hideBorder: true })] }));
};

const useMergeUserAccounts = () => {
    const { environmentId, setShowAuthFlow, selectedWalletConnector } = useInternalDynamicContext();
    const { addedWalletsIds } = useInternalUserWallets();
    const mergeUserAccounts = (mergeConflictResolutions) => __awaiter$1(void 0, void 0, void 0, function* () {
        const user = yield verifyMergeUsers(environmentId, mergeConflictResolutions);
        const walletId = user.lastVerifiedCredentialId;
        if (walletId) {
            addedWalletsIds.current.push(walletId);
        }
        const accounts = yield (selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.getConnectedAccounts());
        if (accounts === null || accounts === void 0 ? void 0 : accounts.length) {
            dynamicEvents.emit('triggerComputePrimaryWalletMultiWalletStateFromAccounts', { accounts });
        }
        setShowAuthFlow(false);
    });
    return {
        mergeUserAccounts,
    };
};

const RadioButton = ({ children, checked, value, name, disabled = false, className = '', onChange, }) => {
    const radioId = `${name}_${value}`;
    return (jsxRuntimeExports.jsxs("div", { className: classNames('radio-button', className), children: [jsxRuntimeExports.jsx("input", { type: 'radio', id: radioId, name: name, value: value, disabled: disabled, defaultChecked: checked, onChange: onChange }), jsxRuntimeExports.jsx("label", { htmlFor: radioId, children: children })] }));
};

const MergeUserAccountsConflictsView = ({ mergeConflicts }) => {
    const { mergeUserAccounts } = useMergeUserAccounts();
    const { t } = useTranslation();
    const [error, setError] = useState('');
    const mergeResolutions = useRef(
    // defaults to current user field values
    Object.fromEntries(mergeConflicts.map(({ field, currentUser }) => [
        `${field.name}_${field.type}`,
        {
            fieldKey: field.name,
            type: field.type || KycFieldType.Standard,
            userId: currentUser.userId,
        },
    ])));
    const handleMergeConfirm = () => __awaiter$1(void 0, void 0, void 0, function* () {
        const parsedMergeResolutions = Object.values(mergeResolutions.current).map(({ fieldKey, type, userId }) => ({
            fieldKey,
            type,
            userId,
        }));
        try {
            yield mergeUserAccounts(parsedMergeResolutions);
        }
        catch (error) {
            logger$1.error('Error merging user accounts', error);
            setError(t('dyn_merge_user_accounts_conflicts.errors.merge_error'));
        }
    });
    if (!(mergeConflicts === null || mergeConflicts === void 0 ? void 0 : mergeConflicts.length)) {
        return null;
    }
    const handleOptionChange = (fieldKey, fieldType, userId, isSelected) => {
        setError('');
        if (!isSelected) {
            return;
        }
        mergeResolutions.current[`${fieldKey}_${fieldType}`] = {
            fieldKey,
            type: fieldType || KycFieldType.Standard,
            userId,
        };
    };
    return (jsxRuntimeExports.jsxs("div", { className: 'merge-user-accounts-conflicts__container', children: [error && (jsxRuntimeExports.jsx(Alert, { icon: 'error', variant: 'error', className: 'merge-user-accounts-conflicts__error', children: error })), jsxRuntimeExports.jsx("div", { className: 'merge-user-accounts-conflicts__description', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', copykey: 'dyn_merge_user_accounts_conflicts.description', children: t('dyn_merge_user_accounts_conflicts.description') }) }), jsxRuntimeExports.jsx("div", { className: 'merge-user-accounts-conflicts__fields', children: mergeConflicts.map(({ field, currentUser, fromUser }) => {
                    var _a;
                    return (jsxRuntimeExports.jsxs("div", { className: 'merge-user-accounts-conflicts__fields__item', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'merge-user-accounts-conflicts__fields__item__name', children: (_a = field.label) !== null && _a !== void 0 ? _a : capitalize$1(field.name) }), jsxRuntimeExports.jsx(RadioButton, { name: field.name, value: currentUser.value, checked: true, className: 'merge-user-accounts-conflicts__fields__item__button', onChange: (e) => handleOptionChange(field.name, field.type, currentUser.userId, e.target.checked), children: currentUser.value }), jsxRuntimeExports.jsx(RadioButton, { name: field.name, value: fromUser.value, className: 'merge-user-accounts-conflicts__fields__item__button', onChange: (e) => handleOptionChange(field.name, field.type, fromUser.userId, e.target.checked), children: fromUser.value })] }, field.name));
                }) }), jsxRuntimeExports.jsx("div", { className: 'merge-user-accounts-conflicts__buttons', children: jsxRuntimeExports.jsx(TypographyButton, { className: 'merge-user-accounts-conflicts__buttons__button', onClick: handleMergeConfirm, buttonVariant: 'primary', buttonPadding: 'large', expanded: true, copykey: 'dyn_merge_user_accounts_conflicts.confirm_button', children: t('dyn_merge_user_accounts_conflicts.confirm_button') }) })] }));
};

const MergeUserAccountsView = (props) => {
    const { pushView } = useViewContext();
    const { mergeUserAccounts } = useMergeUserAccounts();
    const { t } = useTranslation();
    const [error, setError] = useState('');
    const { mergeConflicts } = props;
    const goToConflictsResolutionView = () => {
        // back button on conflicts resolution view should go back to this view
        const onConflictsResolutionBackClick = () => {
            pushView('merge-user-accounts', props);
        };
        pushView('merge-user-accounts-conflicts', { mergeConflicts: (mergeConflicts === null || mergeConflicts === void 0 ? void 0 : mergeConflicts.conflicts) || [] }, {
            onBackClick: onConflictsResolutionBackClick,
        });
    };
    const handleMergeConfirm = () => __awaiter$1(void 0, void 0, void 0, function* () {
        // if there are conflicts, show the conflicts resolution view, otherwise merge
        if (mergeConflicts === null || mergeConflicts === void 0 ? void 0 : mergeConflicts.conflicts.length) {
            goToConflictsResolutionView();
            return;
        }
        try {
            yield mergeUserAccounts([]);
        }
        catch (error) {
            logger$1.error('Error merging user accounts', error);
            setError(t('dyn_merge_user_accounts.errors.merge_error'));
        }
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'merge-user-accounts', children: [error && (jsxRuntimeExports.jsx(Alert, { icon: 'error', variant: 'error', className: 'merge-user-accounts__error', children: error })), jsxRuntimeExports.jsxs("div", { className: 'merge-user-accounts__container', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'merge-user-accounts__title', copykey: 'dyn_merge_user_accounts.wallet.content', children: t('dyn_merge_user_accounts.wallet.content') }), jsxRuntimeExports.jsx(TypographyButton, { onClick: handleMergeConfirm, buttonClassName: 'merge-user-accounts__button', buttonVariant: 'brand-primary', buttonPadding: 'large', typographyProps: {
                            color: 'inherit',
                        }, expanded: true, copykey: 'dyn_merge_user_accounts.confirm_button', children: t('dyn_merge_user_accounts.confirm_button') })] })] }));
};

var _path$t;
var _excluded$x = ["title", "titleId"];
function _extends$x() { return _extends$x = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$x.apply(null, arguments); }
function _objectWithoutProperties$x(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$x(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$x(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgDoubleArrowRight = function SvgDoubleArrowRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$x(_ref, _excluded$x);
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.862 2.862c.26-.26.682-.26.943 0L8.47 7.529a.667.667 0 0 1 0 .942l-4.666 4.667a.667.667 0 0 1-.943-.943L7.057 8 2.862 3.805a.667.667 0 0 1 0-.943Zm5.333 0c.26-.26.683-.26.943 0l4.667 4.667c.26.26.26.682 0 .942l-4.667 4.667a.667.667 0 0 1-.943-.943L12.39 8 8.195 3.805a.667.667 0 0 1 0-.943Z",
    fill: "currentColor"
  })));
};

const MergeUserAccountsWithSameEmailView = ({ returnToView }) => {
    const { environmentId, setShowAuthFlow, setCallback, primaryWallet, user } = useInternalDynamicContext();
    const handleAuthenticatedUser = useHandleAuthenticatedUser();
    const { t } = useTranslation();
    const { setError } = useErrorContext();
    const { pushView, clearStackAndPushInitialView } = useViewContext();
    const { displayedDestination: email } = useVerification();
    const handleMergeUserAccounts = () => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            const userProfile = yield mergeUserAccounts(environmentId);
            if (!userProfile) {
                throw new DynamicError('Something went wrong, please try again.');
            }
            yield handleAuthenticatedUser(userProfile);
            setShowAuthFlow(false);
            setCallback('authSuccess');
        }
        catch (e) {
            setError(t('dyn_merge_user_accounts_with_same_email.errors.merge_error'));
            if (user) {
                setShowAuthFlow(false, { emitCancelAuth: true });
                return;
            }
            clearStackAndPushInitialView();
        }
    });
    const handleUseDifferentEmail = () => {
        setError(undefined);
        if (returnToView) {
            pushView(returnToView);
            return;
        }
        if (user) {
            setShowAuthFlow(false);
            return;
        }
        pushView('collect-user-data');
    };
    return (jsxRuntimeExports.jsxs("div", { className: 'merge-user-accounts-with-same-email__container', children: [jsxRuntimeExports.jsxs("div", { className: 'merge-user-accounts-with-same-email__accounts', children: [jsxRuntimeExports.jsxs("div", { className: 'merge-user-accounts-with-same-email__accounts__item', children: [jsxRuntimeExports.jsx(WalletIcon, { icon: primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector.metadata.icon, walletKey: primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector.key, className: 'merge-user-accounts-with-same-email__accounts__item__icon' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'medium', color: 'secondary', className: 'merge-user-accounts-with-same-email__accounts__item__text', children: shortenWalletAddress(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address, 3, 3) })] }), jsxRuntimeExports.jsx("div", { className: 'merge-user-accounts-with-same-email__accounts__divider', children: jsxRuntimeExports.jsx(Icon, { color: 'text-secondary', size: 'small', children: jsxRuntimeExports.jsx(SvgDoubleArrowRight, {}) }) }), jsxRuntimeExports.jsxs("div", { className: 'merge-user-accounts-with-same-email__accounts__item', children: [jsxRuntimeExports.jsx(UserProfileIcon, { className: 'merge-user-accounts-with-same-email__accounts__item__icon' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'medium', color: 'secondary', className: 'merge-user-accounts-with-same-email__accounts__item__text', children: shortenEmail(email, {
                                    breakpoint: 4,
                                    cutEnd: 1,
                                    cutStart: 2,
                                }) })] })] }), jsxRuntimeExports.jsx(Typography, { weight: 'regular', variant: 'title', className: 'merge-user-accounts-with-same-email__text merge-user-accounts-with-same-email__text__header', copykey: 'dyn_merge_user_accounts_with_same_email.title', children: t('dyn_merge_user_accounts_with_same_email.title') }), jsxRuntimeExports.jsxs(Typography, { weight: 'medium', variant: 'body_normal', className: 'merge-user-accounts-with-same-email__text merge-user-accounts-with-same-email__text__body', copykey: 'dyn_merge_user_accounts_with_same_email.existing_account', children: [t('dyn_merge_user_accounts_with_same_email.existing_account'), ' ', jsxRuntimeExports.jsx("span", { className: 'merge-user-accounts-with-same-email__text--bold', children: shortenEmail(email, {
                            breakpoint: 14,
                        }) }), ' ', t('dyn_merge_user_accounts_with_same_email.existing_account_trail')] }), jsxRuntimeExports.jsxs("div", { className: 'merge-user-accounts-with-same-email__buttons', children: [jsxRuntimeExports.jsx(TypographyButton, { className: 'merge-user-accounts-with-same-email__buttons__button', onClick: handleMergeUserAccounts, buttonVariant: 'primary', buttonPadding: 'large', copykey: 'dyn_merge_user_accounts_with_same_email.confirm_button', children: t('dyn_merge_user_accounts_with_same_email.confirm_button') }), jsxRuntimeExports.jsx(TypographyButton, { className: 'merge-user-accounts-with-same-email__buttons__button', onClick: handleUseDifferentEmail, buttonVariant: 'secondary', buttonPadding: 'large', copykey: 'dyn_merge_user_accounts_with_same_email.cancel_button', children: t('dyn_merge_user_accounts_with_same_email.cancel_button') })] })] }));
};

var _path$s, _path2$1, _path3$1, _path4, _g$6, _path5, _defs$5;
var _excluded$w = ["title", "titleId"];
function _extends$w() { return _extends$w = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$w.apply(null, arguments); }
function _objectWithoutProperties$w(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$w(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$w(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSecureAccount = function SvgSecureAccount(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$w(_ref, _excluded$w);
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    width: 327,
    height: 112,
    viewBox: "0 0 327 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "secure-account_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 327,
    height: 112
  }, _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    d: "M315 0H12C5.373 0 0 5.373 0 12v88c0 6.627 5.373 12 12 12h303c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#secure-account_svg__a)"
  }, _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M164 228c62.96 0 114-51.04 114-114S226.96 0 164 0 50 51.04 50 114s51.04 114 114 114Z",
    fill: "url(#secure-account_svg__b)",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("mask", {
    id: "secure-account_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 86,
    y: 29,
    width: 40,
    height: 40
  }, _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M116.91 29 86 37.282l8.282 30.91 30.91-8.282L116.91 29Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#secure-account_svg__c)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "secure-account_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 33,
    width: 31,
    height: 31
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.763 44.8c-2.097-7.825-10.139-12.468-17.963-10.371-7.824 2.096-12.468 10.138-10.371 17.962 2.096 7.825 10.139 12.468 17.963 10.371 7.824-2.096 12.467-10.138 10.371-17.962Z",
    fill: "#fff"
  }))), _g$6 || (_g$6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#secure-account_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.709 55.166a14.617 14.617 0 0 0 1.054-10.366c-2.097-7.824-10.139-12.467-17.963-10.37-7.825 2.096-12.468 10.138-10.371 17.962a14.612 14.612 0 0 0 6.097 8.451c1.808-3.916 6.565-6.42 9.647-7.247 3.083-.826 7.955-1.146 11.536 1.57Zm-19.375-8.688a5.5 5.5 0 1 1 10.625-2.847 5.5 5.5 0 0 1-10.625 2.847Z",
    fill: "#4779FF"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m207.67 19.875-.767 2.862a9.86 9.86 0 0 0-5.861 6.61c-1.412 5.268 1.715 10.684 6.984 12.096 5.268 1.412 10.684-1.715 12.096-6.984a9.862 9.862 0 0 0-1.771-8.655l.767-2.861a5.926 5.926 0 0 0-11.448-3.068Zm9.321 2.498-.444 1.655a9.844 9.844 0 0 0-3.409-1.665 9.847 9.847 0 0 0-3.785-.262l.444-1.656a3.723 3.723 0 1 1 7.194 1.928Zm-3.445 8.52a2.57 2.57 0 0 1-2.019 1.862l-.539 2.011a1.1 1.1 0 1 1-2.127-.57l.539-2.01a2.569 2.569 0 1 1 4.146-1.294ZM164.943 32.064a6.216 6.216 0 0 0-1.779 0c-.681.098-1.313.337-1.816.527l-.135.05-16.68 6.256-.407.152c-1.922.718-3.61 1.348-4.909 2.493a9.336 9.336 0 0 0-2.553 3.683c-.616 1.62-.613 3.421-.61 5.473V66.01c0 8.793 4.783 16.125 9.953 21.51 5.204 5.422 11.159 9.252 14.307 11.089l.128.075c.574.337 1.32.775 2.307.987a6.619 6.619 0 0 0 2.609 0c.987-.212 1.733-.65 2.307-.987l.128-.075c3.148-1.837 9.103-5.667 14.307-11.088 5.17-5.386 9.953-12.718 9.953-21.511V50.698c.003-2.052.006-3.854-.611-5.473a9.333 9.333 0 0 0-2.552-3.683c-1.3-1.145-2.987-1.775-4.909-2.493l-.407-.152-16.68-6.255-.135-.05c-.503-.19-1.136-.43-1.816-.528Zm7.008 18.695c0-1.726-1.4-3.126-3.127-3.126h-14.069a6.253 6.253 0 0 0-6.153 5.133 6.234 6.234 0 0 1 4.589-2.007h18.76Zm1.562 3.127c3.454 0 6.253 2.8 6.253 6.253v12.506a6.253 6.253 0 0 1-6.253 6.254h-18.759a6.253 6.253 0 0 1-6.253-6.254V60.14a6.253 6.253 0 0 1 6.253-6.253h18.759Z",
    fill: "#4779FF"
  }))), _defs$5 || (_defs$5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "secure-account_svg__b",
    x1: 164,
    y1: 0,
    x2: 164,
    y2: 93.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4779FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779FF",
    stopOpacity: 0
  })))));
};

const useIsLoggedIn = () => {
    var _a, _b, _c;
    const { user, primaryWallet, authMode, projectSettings } = useInternalDynamicContext();
    const { getEOAWallet } = useSmartWallets();
    const eoaWallet = primaryWallet && getEOAWallet(primaryWallet);
    const isSessionKeyCompatible = (primaryWallet && isSessionKeyCompatibleWallet(primaryWallet)) ||
        (eoaWallet && isSessionKeyCompatibleWallet(eoaWallet));
    const isTurnkeyProviderEnabled = isTurnkeyEnabled(projectSettings);
    // a user is set even when on connect-only mode if signing in with social,
    // but it won't have a primaryWallet in this case
    const isLoggedIn = Boolean(user) || (authMode === 'connect-only' && Boolean(primaryWallet));
    const userWalletsCredentials = (_a = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.filter(({ walletProvider }) => walletProvider);
    const hasEmbeddedWalletVerifiedCredential = Boolean(userWalletsCredentials === null || userWalletsCredentials === void 0 ? void 0 : userWalletsCredentials.find(({ walletProvider }) => walletProvider === 'embeddedWallet'));
    const isTurnkeyPregen = isTurnkeyProviderEnabled &&
        ((_c = (_b = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _b === void 0 ? void 0 : _b.embeddedWallets) === null || _c === void 0 ? void 0 : _c.automaticEmbeddedWalletCreation) &&
        (!(projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets.forceAuthenticatorAtSignup) ||
            isSessionKeyCompatible);
    const shouldHaveTurnkeyWallet = isTurnkeyPregen &&
        // if user doesn't have a branded wallet only
        (!(userWalletsCredentials === null || userWalletsCredentials === void 0 ? void 0 : userWalletsCredentials.length) || hasEmbeddedWalletVerifiedCredential);
    logger$1.logVerboseTroubleshootingMessage('useIsLoggedIn', {
        authMode,
        eoaWallet,
        isSessionKeyCompatible,
        isTurnkeyProviderEnabled,
        primaryWallet,
        projectSettings,
        user,
    });
    // if turnkey is enabled we need to check if the user that is logged/connected
    // has a primaryWallet to not show the widget without secure
    if (shouldHaveTurnkeyWallet) {
        return Boolean(primaryWallet && isLoggedIn);
    }
    return isLoggedIn;
};

const useOverrides = (dynamicContext) => {
    const context = useRef(dynamicContext);
    const isLoggedIn = useIsLoggedIn();
    context.current = dynamicContext;
    return useMemo(() => ({
        setAuthMode: (value) => {
            const { setAuthMode } = context.current;
            // If there's a connected wallet, log an error and ignore
            if (isLoggedIn) {
                logger$1.error("Calling DynamicContext's setAuthMode method when the user already has a wallet is a noop");
                return;
            }
            return setAuthMode(value);
        },
    }), [isLoggedIn]);
};

// This is external context hook which is exposed to customers
const useDynamicContext = () => {
    const context = useContext(DynamicContext);
    if (context === undefined) {
        throw new Error('useDynamicContext must be used within a DynamicContextProvider');
    }
    const { accountSwitchState, authMode, awaitingSignatureState, getNameService, handleLogOut, handleUnlinkWallet, loadingNetwork, locale, loginWithEmail, multiWalletWidgetState, network, networkConfigurations, qrcodeUri, refetchProjectSettings, sdkHasLoaded, setLogInWithEmail, setMultiWalletWidgetState, setShowAuthFlow, setShowDynamicUserProfile, setShowQrcodeModal, shadowDOMEnabled, showAuthFlow, showQrcodeModal, user, userWithMissingInfo, bridgeChains, bridgeChainsToConnect, primaryWallet, setShowBridgeWidget, sendWagmiSettings, showDynamicUserProfile, selectedTabIndex, setSelectedTabIndex, } = context;
    const { setAuthMode } = useOverrides(context);
    const externalSetShowAuthFlow = useCallback((value) => {
        setShowAuthFlow(value, {
            clearErrors: true,
            emitCancelAuth: true,
            ignoreIfIsEmbeddedWidget: true,
            initializeWalletConnect: true,
            performMultiWalletChecks: true,
        });
    }, [setShowAuthFlow]);
    return {
        accountSwitchState,
        authMode,
        awaitingSignatureState,
        bridgeChains,
        bridgeChainsToConnect,
        getNameService,
        handleLogOut,
        handleUnlinkWallet,
        loadingNetwork,
        locale,
        loginWithEmail,
        multiWalletWidgetState,
        network,
        networkConfigurations,
        primaryWallet,
        qrcodeUri,
        refetchProjectSettings,
        sdkHasLoaded,
        selectedTabIndex,
        sendWagmiSettings,
        setAuthMode,
        setLogInWithEmail,
        setMultiWalletWidgetState,
        setSelectedTabIndex,
        setShowAuthFlow: externalSetShowAuthFlow,
        setShowBridgeWidget,
        setShowDynamicUserProfile,
        setShowQrcodeModal,
        shadowDOMEnabled,
        showAuthFlow,
        showDynamicUserProfile,
        showQrcodeModal,
        user,
        userWithMissingInfo,
    };
};

const getMfaOptions = (isInitialSetup) => {
    const mfaOptions = [
        {
            Icon: undefined,
            descriptionKey: 'dyn_mfa.choose_device_view.authenticator_app_description',
            labelKey: 'dyn_mfa.choose_device_view.authenticator_app',
            type: MFADeviceType.Totp,
        },
    ];
    if (!isInitialSetup) {
        const backupCodeOption = {
            Icon: undefined,
            descriptionKey: 'dyn_mfa.choose_device_view.backup_code_description',
            labelKey: 'dyn_mfa.choose_device_view.backup_code',
            type: 'backupCode',
        };
        mfaOptions.push(backupCodeOption);
    }
    return mfaOptions;
};

const MfaChooseDeviceView = ({ isInitialSetup = true, }) => {
    const { handleLogOut } = useDynamicContext();
    const { t } = useTranslation();
    const { pushView } = useViewContext();
    const mfaOptions = getMfaOptions(isInitialSetup);
    const handleClick = (option) => {
        if (option.type === 'backupCode') {
            pushView('mfa-recovery');
            return;
        }
        if (isInitialSetup) {
            pushView('mfa-secure-device', { isInitialSetup, type: option.type });
            return;
        }
        pushView('mfa-verification', {
            isInitialSetup,
            showBackButton: true,
            type: option.type,
        });
    };
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(ModalHeader, { alignContent: 'bottom', children: jsxRuntimeExports.jsx("div", { className: 'otp-verification-view__status-header', children: jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'title', color: 'primary', className: 'otp-verification-view__title', children: isInitialSetup
                            ? t('dyn_mfa.choose_device_view.title')
                            : t('dyn_mfa.choose_device_view.choose_another_method') }) }) }), jsxRuntimeExports.jsxs("div", { className: 'mfa-choose-device-view__body', "data-testid": 'mfa-choose-device-view', children: [jsxRuntimeExports.jsx(SvgSecureAccount, {}), jsxRuntimeExports.jsx(Typography, { className: 'mfa-choose-device-view__copy', variant: 'body_normal', weight: 'regular', color: 'secondary', children: isInitialSetup
                            ? t('dyn_mfa.choose_device_view.select_options')
                            : t('dyn_mfa.choose_device_view.choose_another_method_description') }), mfaOptions.map((option) => (jsxRuntimeExports.jsxs(Button$1, { buttonClassName: 'mfa-choose-device-view__button', expanded: true, onClick: () => handleClick(option), children: [jsxRuntimeExports.jsxs("div", { className: 'mfa-choose-device-view__button__header', children: [jsxRuntimeExports.jsx(Typography, { copykey: option.labelKey, color: 'primary', children: t(option.labelKey) }), jsxRuntimeExports.jsx(SvgChevronLeft, { className: 'mfa-choose-device-view__icon--rotate' })] }), jsxRuntimeExports.jsx(Typography, { className: 'mfa-choose-device-view__button__description', color: 'secondary', copykey: option.descriptionKey, children: t(option.descriptionKey) })] }, option.type))), jsxRuntimeExports.jsx(TextButton, { className: 'mfa-choose-device-view__logout', onClick: handleLogOut, copykey: 'dyn_mfa.choose_device_view.logout', children: t('dyn_mfa.choose_device_view.logout') })] })] }));
};

var _path$r;
var _excluded$v = ["title", "titleId"];
function _extends$v() { return _extends$v = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$v.apply(null, arguments); }
function _objectWithoutProperties$v(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$v(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$v(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgDownload = function SvgDownload(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$v(_ref, _excluded$v);
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.417 14.167c0 .92.746 1.666 1.666 1.666h8.334c.92 0 1.666-.746 1.666-1.666v-.834a.833.833 0 0 1 1.667 0v.834a3.333 3.333 0 0 1-3.333 3.333H6.083a3.333 3.333 0 0 1-3.333-3.333v-.834a.833.833 0 0 1 1.667 0v.834Zm1.91-4.756a.833.833 0 0 1 1.179 0l1.91 1.91V3.333a.833.833 0 0 1 1.667 0v7.989l1.911-1.911a.833.833 0 1 1 1.179 1.178l-3.334 3.334a.833.833 0 0 1-1.178 0l-3.334-3.334a.833.833 0 0 1 0-1.178Z",
    fill: "#ABACB2"
  })));
};

const downloadFile = (fileName, content) => {
    const element = document.createElement('a');
    const file = new Blob([content], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = fileName;
    document.body.appendChild(element);
    element.click();
};

const getUserMfaDevices = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ environmentId, }) {
    try {
        const { devices } = yield sdkApi().getUserMfaDevices({
            environmentId,
        });
        return devices;
    }
    catch (e) {
        yield logResponseError(e, 'Error getting mfa devices');
        return [];
    }
});
const addMfaDevice = (_b) => __awaiter$1(void 0, [_b], void 0, function* ({ environmentId, type, }) {
    try {
        if (type === MFADeviceType.Totp) {
            const response = yield sdkApi().registerTotpMfaDevice({
                environmentId,
            });
            return response;
        }
        throw new Error('Unsupported MFA device type');
    }
    catch (e) {
        const responseError = yield logResponseError(e, 'Error adding mfa device');
        const message = e instanceof Error ? e.message : responseError.error;
        throw new Error(message);
    }
});
const updateUserMfaDevice = (_c) => __awaiter$1(void 0, [_c], void 0, function* ({ environmentId, mfaDeviceId, }) {
    try {
        yield sdkApi().updateUserMfaDevice({
            environmentId,
            mfaDeviceId,
        });
    }
    catch (e) {
        yield logResponseError(e, 'Error updating mfa device');
    }
});
const deleteMfaDevice = (_d) => __awaiter$1(void 0, [_d], void 0, function* ({ environmentId, mfaDeviceId, mfaAuthToken, }) {
    try {
        yield sdkApi().deleteMfaDevice({
            environmentId,
            mfaDeviceId,
            xMfaAuthToken: mfaAuthToken,
        });
    }
    catch (e) {
        yield logResponseError(e, 'Error delete mfa device');
    }
});
// used when verifying a device added after the user is already logged in
// no jwt update needed
const verifyMfaDevice = (_e) => __awaiter$1(void 0, [_e], void 0, function* ({ environmentId, type, code, }) {
    try {
        if (type === MFADeviceType.Totp) {
            const request = {
                code,
                type,
            };
            const device = yield sdkApi().registerTotpMfaDeviceVerify({
                environmentId,
                mFARegisterTotpDevicePostRequest: request,
            });
            return device;
        }
        throw new Error('Unsupported MFA device type');
    }
    catch (e) {
        yield logResponseError(e, 'Error verify mfa device');
        return undefined;
    }
});
// used when verifying a device when user is logging in
// jwt update needed
const authMfaDevice = (_f) => __awaiter$1(void 0, [_f], void 0, function* ({ deviceId, environmentId, type, code, createMfaToken, }) {
    try {
        if (type === MFADeviceType.Totp) {
            const request = {
                code,
                createMfaToken,
                id: deviceId || undefined,
            };
            const response = yield sdkApi().authMfaTotpDevice({
                environmentId,
                mFAAuthTotpDevicePostRequest: request,
            });
            return response;
        }
        throw new Error('Unsupported MFA device type');
    }
    catch (error) {
        const responseError = yield logResponseError(error, 'Error auth mfa devices');
        if (error instanceof Response) {
            if (responseError.code === 'mfa_invalid_code') {
                throw new MfaInvalidOtpError();
            }
            if (responseError.code === 'mfa_rate_limited') {
                throw new MfaRateLimitedError();
            }
        }
        throw error;
    }
});
const getRecoveryCodes = (_g) => __awaiter$1(void 0, [_g], void 0, function* ({ environmentId, }) {
    try {
        const { recoveryCodes } = yield sdkApi().getRecoveryCodes({
            environmentId,
        });
        return recoveryCodes;
    }
    catch (e) {
        yield logResponseError(e, 'Error get mfa recovery codes');
        return [];
    }
});
const createNewRecoveryCodes = (_h) => __awaiter$1(void 0, [_h], void 0, function* ({ environmentId, }) {
    try {
        const { recoveryCodes } = yield sdkApi().createNewRecoveryCodes({
            environmentId,
        });
        return recoveryCodes;
    }
    catch (e) {
        yield logResponseError(e, 'Error create mfa recovery codes');
        return [];
    }
});
// used when verifying a device when user is logging in with recovery code
// jwt update needed
const authMfaRecovery = (_j) => __awaiter$1(void 0, [_j], void 0, function* ({ environmentId, code, }) {
    try {
        const request = {
            code,
        };
        const response = yield sdkApi().authMfaRecovery({
            environmentId,
            mFAAuthRecoveryDevicePostRequest: request,
        });
        return response;
    }
    catch (error) {
        const responseError = yield logResponseError(error, 'Error mfa recovery');
        if (error instanceof Response) {
            if (responseError.code === 'mfa_invalid_code') {
                throw new MfaInvalidOtpError();
            }
        }
        throw error;
    }
});

const useMfa = () => {
    const { completeAuth } = useUserAuth({});
    const checkUserIsVerifiedAndGetEnvironmentId = useCallback(() => {
        const verifiedUser = getUser();
        if (!verifiedUser) {
            throw new Error(USER_NOT_LOGGED_IN);
        }
        const environmentId = getEnvironmentId();
        return environmentId;
    }, []);
    const getUserDevices = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        const environmentId = checkUserIsVerifiedAndGetEnvironmentId();
        const devices = yield getUserMfaDevices({ environmentId });
        return devices;
    }), [checkUserIsVerifiedAndGetEnvironmentId]);
    const updateUserDevice = useCallback((deviceId) => __awaiter$1(void 0, void 0, void 0, function* () {
        const environmentId = checkUserIsVerifiedAndGetEnvironmentId();
        yield updateUserMfaDevice({
            environmentId,
            mfaDeviceId: deviceId,
        });
    }), [checkUserIsVerifiedAndGetEnvironmentId]);
    const deleteUserDevice = useCallback((deviceId, mfaAuthToken) => __awaiter$1(void 0, void 0, void 0, function* () {
        const environmentId = checkUserIsVerifiedAndGetEnvironmentId();
        yield deleteMfaDevice({
            environmentId,
            mfaAuthToken,
            mfaDeviceId: deviceId,
        });
        // Refresh the user JWT to get the updated MFA acknowledgement
        // since if it is completed we won't show the QR code again
        yield refreshUserJwt({ environmentId });
    }), [checkUserIsVerifiedAndGetEnvironmentId]);
    const addDevice = useCallback((...args_1) => __awaiter$1(void 0, [...args_1], void 0, function* (type = MFADeviceType.Totp) {
        const environmentId = checkUserIsVerifiedAndGetEnvironmentId();
        const { id, secret, uri } = yield addMfaDevice({
            environmentId,
            type,
        });
        return { id, secret, uri };
    }), [checkUserIsVerifiedAndGetEnvironmentId]);
    const authDevice = useCallback((code_1, ...args_2) => __awaiter$1(void 0, [code_1, ...args_2], void 0, function* (code, type = MFADeviceType.Totp, deviceId) {
        try {
            const environmentId = checkUserIsVerifiedAndGetEnvironmentId();
            let isValid = false;
            yield completeAuth({
                onValidUpdatedJwt: () => __awaiter$1(void 0, void 0, void 0, function* () {
                    isValid = true;
                }),
                updateJwtFunction: () => __awaiter$1(void 0, void 0, void 0, function* () {
                    const response = yield authMfaDevice({
                        code,
                        createMfaToken: {
                            singleUse: true,
                        },
                        deviceId,
                        environmentId,
                        type,
                    });
                    dynamicEvents.emit('mfaCompletionSuccess', {
                        mfaToken: response.mfaToken,
                    });
                    return {
                        isEmailVerificationRequired: false,
                        isSmsVerificationRequired: false,
                        missingFields: [],
                        // in the mfa flow, we only care about the user in the response
                        updateUserProfileResponse: response,
                    };
                }),
            });
            return isValid;
        }
        catch (error) {
            dynamicEvents.emit('mfaCompletionFailure', { error });
            throw error;
        }
    }), [checkUserIsVerifiedAndGetEnvironmentId, completeAuth]);
    const authRecoveryCode = useCallback((code) => __awaiter$1(void 0, void 0, void 0, function* () {
        const environmentId = checkUserIsVerifiedAndGetEnvironmentId();
        let isValid = false;
        yield completeAuth({
            onValidUpdatedJwt: () => __awaiter$1(void 0, void 0, void 0, function* () {
                isValid = true;
            }),
            updateJwtFunction: () => __awaiter$1(void 0, void 0, void 0, function* () {
                const response = yield authMfaRecovery({
                    code,
                    environmentId,
                });
                if (!response) {
                    throw new Error('Failed to authenticate recovey code');
                }
                return {
                    isEmailVerificationRequired: false,
                    isSmsVerificationRequired: false,
                    missingFields: [],
                    // in the mfa flow, we only care about the user in the response
                    updateUserProfileResponse: response,
                };
            }),
        });
        return isValid;
    }), [checkUserIsVerifiedAndGetEnvironmentId, completeAuth]);
    const verifyDevice = useCallback((code_2, ...args_3) => __awaiter$1(void 0, [code_2, ...args_3], void 0, function* (code, type = MFADeviceType.Totp) {
        const environmentId = checkUserIsVerifiedAndGetEnvironmentId();
        const device = yield verifyMfaDevice({
            code,
            environmentId,
            type,
        });
        if (!device) {
            throw new Error('Failed to verify device');
        }
        return device;
    }), [checkUserIsVerifiedAndGetEnvironmentId]);
    const getRecoveryCodes$1 = useCallback((...args_4) => __awaiter$1(void 0, [...args_4], void 0, function* (generateNewCodes = false) {
        const environmentId = checkUserIsVerifiedAndGetEnvironmentId();
        const getRecoveryCodesFunc = generateNewCodes
            ? createNewRecoveryCodes
            : getRecoveryCodes;
        const recoveryCodes = yield getRecoveryCodesFunc({
            environmentId,
        });
        if (!recoveryCodes) {
            throw new Error('Recovery codes not found');
        }
        return recoveryCodes;
    }), [checkUserIsVerifiedAndGetEnvironmentId]);
    const { updateUser } = useUserUpdateRequestInternal({
        validationSchemaStripUnknown: false,
    });
    const completeAcknowledgement = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        yield updateUser({
            mfaBackupCodeAcknowledgement: MfaBackupCodeAcknowledgement.Complete,
        });
    }), [updateUser]);
    return {
        addDevice,
        authDevice,
        authRecoveryCode,
        completeAcknowledgement,
        deleteUserDevice,
        getRecoveryCodes: getRecoveryCodes$1,
        getUserDevices,
        updateUserDevice,
        verifyDevice,
    };
};

const MfaDisplayBackupCodesView = ({ regenerateCodes = false, }) => {
    const { setShowAuthFlow } = useInternalDynamicContext();
    const [acknowledgement, setAcknowledgement] = useState(false);
    const { t } = useTranslation();
    const { getRecoveryCodes, completeAcknowledgement } = useMfa();
    const { data: codes, isLoading } = usePromise(() => getRecoveryCodes(regenerateCodes));
    const codesAsString = (codes || []).join('\n');
    const handleCompleteAcknowledgement = () => __awaiter$1(void 0, void 0, void 0, function* () {
        setShowAuthFlow(false);
        yield completeAcknowledgement();
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'mfa-display-backup-codes-view__body', "data-testid": 'mfa-display-backup-codes-view', children: [jsxRuntimeExports.jsx(Typography, { className: 'mfa-display-backup-codes-view__copy', variant: 'body_normal', weight: 'regular', color: 'secondary', children: t('dyn_mfa.display_backup_codes_view.body') }), jsxRuntimeExports.jsx(Alert, { variant: 'warning', copykey: 'dyn_mfa.display_backup_codes_view.warning', className: 'mfa-display-backup-codes-view__warning', children: t('dyn_mfa.display_backup_codes_view.warning') }), isLoading ? (jsxRuntimeExports.jsx(Spinner$1, { className: 'mfa-display-backup-codes-view__loading-spinner' })) : (jsxRuntimeExports.jsxs("div", { className: 'mfa-display-backup-codes-view__codes', children: [codes === null || codes === void 0 ? void 0 : codes.map((code, index) => (jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'mfa-display-backup-codes-view__code', children: code }, index))), jsxRuntimeExports.jsxs("div", { className: 'mfa-display-backup-codes-view__actions', children: [jsxRuntimeExports.jsx(CopyButton, { variant: 'button', textToCopy: codesAsString, copykey: 'dyn_mfa.display_backup_codes_view.copy_all', startSlot: 
                                // eslint-disable-next-line react/jsx-wrap-multilines
                                jsxRuntimeExports.jsx(Icon, { size: 'mini', color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgCopy, {}) }), children: t('dyn_mfa.display_backup_codes_view.copy_all') }), jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'download-button', buttonPadding: 'small', buttonVariant: 'primary', onClick: (e) => {
                                    e.preventDefault();
                                    downloadFile('mfa-backup-codes.txt', codesAsString);
                                }, startSlot: jsxRuntimeExports.jsx(SvgDownload, {}), expanded: true, copykey: 'dyn_mfa.display_backup_codes_view.download', children: t('dyn_mfa.display_backup_codes_view.download') })] })] })), jsxRuntimeExports.jsxs("div", { className: 'mfa-display-backup-codes-view__complete', children: [jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'mfa-display-backup-codes-view__acknowledgement', dataTestId: 'ack-button', buttonPadding: 'small', buttonVariant: 'primary', onClick: () => setAcknowledgement(!acknowledgement), startSlot: 
                        // eslint-disable-next-line react/jsx-wrap-multilines
                        jsxRuntimeExports.jsx(Checkbox, { checked: acknowledgement, onChange: () => {
                                setAcknowledgement(!acknowledgement);
                            }, className: 'mfa-display-backup-codes-view__acknowledgement__checkbox' }), expanded: true, typographyProps: {
                            color: 'secondary',
                        }, copykey: 'dyn_mfa.display_backup_codes_view.checkbox', children: t('dyn_mfa.display_backup_codes_view.checkbox') }), jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'complete-button', buttonPadding: 'large', buttonVariant: 'brand-primary', typographyProps: {
                            color: 'inherit',
                        }, disabled: !acknowledgement, expanded: true, copykey: 'dyn_mfa.display_backup_codes_view.complete', onClick: handleCompleteAcknowledgement, children: t('dyn_mfa.display_backup_codes_view.complete') })] })] }));
};

const isValidMfaRecoveryCode = (text) => {
    const regex = /^[a-zA-Z0-9]{10}$/;
    return regex.test(text);
};

var _path$q;
var _excluded$u = ["title", "titleId"];
function _extends$u() { return _extends$u = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$u.apply(null, arguments); }
function _objectWithoutProperties$u(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$u(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$u(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgMfaRecoveryIcon = function SvgMfaRecoveryIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$u(_ref, _excluded$u);
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 64c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32C14.827 0 .5 14.327.5 32c0 17.673 14.327 32 32 32Zm-9.322-18.117a1.828 1.828 0 1 0 3.613.568l1.152-7.457h7.144l-1.1 6.89a1.828 1.828 0 1 0 3.612.567l1.153-7.457h3.504a1.691 1.691 0 0 0 0-3.383h-2.948l1.16-7.222h3.597a1.691 1.691 0 0 0 0-3.383h-3.087l1.1-6.89a1.829 1.829 0 1 0-3.612-.567l-1.153 7.457H30.17l1.1-6.89a1.828 1.828 0 1 0-3.613-.567l-1.152 7.457h-3.458a1.691 1.691 0 0 0 0 3.383h2.901l-1.16 7.222h-3.597a1.691 1.691 0 0 0 0 3.383h3.087l-1.1 6.89Zm12.42-10.272H28.5l1.16-7.222h7.097l-1.16 7.222Z",
    fill: "#4779FF"
  })));
};

const MfaRecoveryScreenIcon = (props) => (jsxRuntimeExports.jsx(Icon, { color: 'brand-primary', children: jsxRuntimeExports.jsx(SvgMfaRecoveryIcon, Object.assign({}, props, { "data-testid": 'mfa-recovery-icon' })) }));

const MfaRecoveryView = () => {
    var _a;
    const { t } = useTranslation();
    const { projectSettings } = useInternalDynamicContext();
    const { authRecoveryCode } = useMfa();
    const [code, setCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const supportEmail = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.general) === null || _a === void 0 ? void 0 : _a.supportEmail;
    const handleRecovery = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!code) {
            return;
        }
        try {
            setIsLoading(true);
            yield authRecoveryCode(code);
        }
        catch (e) {
            setError(e.message || 'Something went wrong');
        }
        finally {
            setIsLoading(false);
        }
    });
    const handleCodeChanged = (event) => {
        const inputCode = event.target.value;
        setCode(inputCode);
        setError('');
    };
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [error && jsxRuntimeExports.jsx(ErrorContainer, { children: error }), jsxRuntimeExports.jsxs("div", { className: 'mfa-recovery-view', children: [jsxRuntimeExports.jsx(IconWithSpinner, { Icon: MfaRecoveryScreenIcon, isSpinning: isLoading, iconSize: 96 }), jsxRuntimeExports.jsx("div", { className: 'mfa-recovery-view__body', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', children: t('dyn_mfa.recovery_view.body') }) }), jsxRuntimeExports.jsxs("div", { className: 'mfa-recovery-view__actions', children: [jsxRuntimeExports.jsx(Input, { id: 'mfa-recovery-input', "data-testid": 'mfa-recovery-input', label: t('dyn_mfa.recovery_view.input_label'), onChange: handleCodeChanged, value: code }), jsxRuntimeExports.jsx(Button$1, { expanded: true, buttonVariant: 'brand-primary', disabled: isLoading || !isValidMfaRecoveryCode(code), onClick: handleRecovery, dataTestId: 'mfa-recovery-submit', children: jsxRuntimeExports.jsx(Typography, { children: t('dyn_mfa.recovery_view.button_label') }) })] }), supportEmail && (jsxRuntimeExports.jsxs("div", { className: 'mfa-recovery-view__get-help', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', children: t('dyn_mfa.recovery_view.get_help.description') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'link', children: jsxRuntimeExports.jsx("a", { href: `mailto:${supportEmail}`, children: t('dyn_mfa.recovery_view.get_help.button_label') }) })] }))] })] }));
};

const MfaSecureDeviceHelper = ({ uri, secret, }) => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsx("div", { className: 'mfa-qrcode-help-content__container', children: jsxRuntimeExports.jsx(EnterTileAnimation, { delay: '300ms', children: jsxRuntimeExports.jsxs("div", { className: 'mfa-qrcode-help-content__setup-container', children: [jsxRuntimeExports.jsxs("div", { className: 'mfa-qrcode-help-content__step', children: [jsxRuntimeExports.jsx("div", { className: 'mfa-qrcode-help-content__step__number', children: "1" }), jsxRuntimeExports.jsxs("div", { className: 'mfa-qrcode-help-content__step__instructions', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', className: 'mfa-qrcode-help-content__step__title', children: t('dyn_mfa.secure_device_view.helper.step1.title') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', className: 'mfa-qrcode-help-content__step__subtext', children: t('dyn_mfa.secure_device_view.helper.step1.description') })] })] }), jsxRuntimeExports.jsxs("div", { className: 'mfa-qrcode-help-content__vertical-container', children: [jsxRuntimeExports.jsxs("div", { className: 'mfa-qrcode-help-content__step', children: [jsxRuntimeExports.jsx("div", { className: 'mfa-qrcode-help-content__step__number', children: "2" }), jsxRuntimeExports.jsxs("div", { className: 'mfa-qrcode-help-content__step__instructions', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', className: 'mfa-qrcode-help-content__step__title', children: t('dyn_mfa.secure_device_view.helper.step2.title') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', className: 'mfa-qrcode-help-content__step__subtext', children: t('dyn_mfa.secure_device_view.helper.step2.description') })] })] }), jsxRuntimeExports.jsxs("div", { className: 'mfa-qrcode-help-content__step__nocopy-box', children: [jsxRuntimeExports.jsx(Typography, { className: 'mfa-qrcode-help-content__step__nocopy-text', variant: 'body_small', children: secret }), jsxRuntimeExports.jsx(CopyButton, { textToCopy: secret, children: jsxRuntimeExports.jsx(SvgCopy, { "data-testid": 'copy-secret', onClick: (e) => {
                                                e.preventDefault();
                                            } }) })] })] }), jsxRuntimeExports.jsx(Divider, { text: 'OR' }), jsxRuntimeExports.jsxs("div", { className: 'mfa-qrcode-help-content__vertical-container', children: [jsxRuntimeExports.jsx("div", { className: 'mfa-qrcode-help-content__step', children: jsxRuntimeExports.jsxs("div", { className: 'uri-section', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', className: 'mfa-qrcode-help-content__step__title', children: t('dyn_mfa.secure_device_view.helper.uri.title') }), jsxRuntimeExports.jsx(Typography, { className: 'uri-subtext', variant: 'body_small', children: t('dyn_mfa.secure_device_view.helper.uri.description') })] }) }), jsxRuntimeExports.jsxs("div", { className: 'mfa-qrcode-help-content__step__nocopy-box', children: [jsxRuntimeExports.jsx(Typography, { className: 'mfa-qrcode-help-content__step__nocopy-text', variant: 'body_small', children: uri }), jsxRuntimeExports.jsx(CopyButton, { textToCopy: uri, children: jsxRuntimeExports.jsx(SvgCopy, { "data-testid": 'copy-uri', onClick: (e) => {
                                                e.preventDefault();
                                            } }) })] })] })] }) }) }));
};

var _path$p;
var _excluded$t = ["title", "titleId"];
function _extends$t() { return _extends$t = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$t.apply(null, arguments); }
function _objectWithoutProperties$t(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$t(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$t(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgPasswordHero = function SvgPasswordHero(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$t(_ref, _excluded$t);
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 64c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32C14.827 0 .5 14.327.5 32c0 17.673 14.327 32 32 32Zm-7.618-38.89v-4.037a8.074 8.074 0 0 1 16.147 0v4.036a13.436 13.436 0 0 1 5.383 10.766c0 7.431-6.025 13.456-13.456 13.456-7.432 0-13.456-6.025-13.456-13.456 0-4.402 2.114-8.31 5.382-10.765Zm13.147-1.702v-2.335a5.074 5.074 0 0 0-10.147 0v2.336a13.416 13.416 0 0 1 5.074-.99c1.795 0 3.507.352 5.073.99ZM34.5 36.663a3.5 3.5 0 1 0-3 0V39.5a1.5 1.5 0 0 0 3 0v-2.837Z",
    fill: "#4779FF"
  })));
};

const MfaSecureDeviceView = ({ type, isInitialSetup = false, }) => {
    const { t } = useTranslation();
    const { handleLogOut } = useDynamicContext();
    const { pushView } = useViewContext();
    const { addDevice } = useMfa();
    const { data, isLoading } = usePromise(() => addDevice(type));
    const onContinue = () => {
        pushView('mfa-verification', {
            deviceId: data === null || data === void 0 ? void 0 : data.id,
            isInitialSetup,
            showBackButton: true,
            type,
        });
    };
    const onHelpClick = ({ secret, uri }) => {
        const onMfaSecureDeviceHelpBackClick = () => {
            pushView('mfa-secure-device', { isInitialSetup, type });
        };
        pushView('mfa-secure-device-help', {
            secret,
            uri,
        }, { onBackClick: onMfaSecureDeviceHelpBackClick });
    };
    return (jsxRuntimeExports.jsxs("div", { className: 'mfa-secure-device-view__body', "data-testid": 'mfa-secure-device-view', children: [jsxRuntimeExports.jsx(Typography, { className: 'mfa-secure-device-view__copy', variant: 'body_normal', weight: 'regular', color: 'secondary', children: t('dyn_mfa.secure_device_view.body') }), isLoading && (jsxRuntimeExports.jsx(Spinner$1, { className: 'mfa-secure-device-view__loading-spinner' })), data && (jsxRuntimeExports.jsxs("div", { className: 'mfa-secure-device-view__qrcode', children: [jsxRuntimeExports.jsx(QRCode, { Icon: jsxRuntimeExports.jsx(SvgPasswordHero, {}), value: data.uri, logoSize: 50 }), jsxRuntimeExports.jsx("div", { className: 'button-container', children: jsxRuntimeExports.jsx("button", { onClick: () => onHelpClick({ secret: data.secret, uri: data.uri }), children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'medium', color: 'secondary', children: t('dyn_mfa.secure_device_view.helper.button') }) }) })] })), jsxRuntimeExports.jsx(TypographyButton, { className: 'mfa-secure-device-view__button', expanded: true, onClick: onContinue, children: t('dyn_mfa.secure_device_view.continue') }), jsxRuntimeExports.jsx(TextButton, { className: 'mfa-secure-device-view__logout-button', onClick: handleLogOut, copykey: 'dyn_mfa.choose_device_view.logout', children: t('dyn_mfa.secure_device_view.logout') })] }));
};

const MfaVerificationView = ({ type, isInitialSetup = false, showBackButton = false, deviceId, }) => {
    const { t } = useTranslation();
    const { pushView } = useViewContext();
    const { authDevice } = useMfa();
    const [code, setCode] = useState('');
    const [error, setError] = useState();
    const [isRateLimited, setIsRateLimited] = useState(false);
    const { data: isValid, isLoading } = usePromise(() => authDevice(code, type, deviceId), {
        deps: [code],
        enabled: (code === null || code === void 0 ? void 0 : code.length) === 6,
        initialData: false,
        onReject: (err) => {
            if (err instanceof MfaRateLimitedError) {
                setIsRateLimited(true);
                setError(new DynamicError(t('dyn_mfa.otp_verification_view.rate_limit_error')));
            }
            else {
                setError(new DynamicError(t('dyn_mfa.otp_verification_view.error')));
            }
        },
        onResolve: () => __awaiter$1(void 0, void 0, void 0, function* () {
            const user = getUser();
            if ((user === null || user === void 0 ? void 0 : user.mfaBackupCodeAcknowledgement) !==
                MfaBackupCodeAcknowledgement.Complete) {
                pushView('mfa-display-backup-codes');
            }
        }),
    });
    const onCodeChange = (code) => {
        setError(undefined);
        setCode(code);
    };
    const onSubmit = (code) => {
        setCode(code);
    };
    const onClickBack = () => {
        if (!isInitialSetup) {
            pushView('mfa-choose-device', { isInitialSetup });
            return;
        }
        pushView('mfa-secure-device', { isInitialSetup, type });
    };
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(OTPVerificationView, { MainIcon: SvgPasswordHero, error: error, isLoading: isLoading, onPinComplete: onSubmit, isValid: Boolean(isValid), onPinChange: onCodeChange, description: t('dyn_mfa.otp_verification_view.body'), onClickBack: showBackButton ? onClickBack : undefined, disabled: isRateLimited }), !isInitialSetup && (jsxRuntimeExports.jsx("div", { className: 'mfa-verification-view__choose-another-method', children: jsxRuntimeExports.jsx(TextButton, { className: 'mfa-verification-view__choose-another-method-button', onClick: () => pushView('mfa-choose-device', { isInitialSetup }), copykey: 'dyn_mfa.otp_verification_view.choose_another_method', children: t('dyn_mfa.otp_verification_view.choose_another_method') }) }))] }));
};

const MobileWalletRedirectView = ({ onRetry, }) => {
    const { selectedWalletConnector } = useInternalDynamicContext();
    const { t } = useTranslation();
    const { storeName, walletLink } = useMemo(() => {
        const walletLinks = getWalletLinks(selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.metadata.downloadLinks);
        if (walletLinks && isIOS())
            return {
                storeName: 'App Store',
                walletLink: walletLinks === null || walletLinks === void 0 ? void 0 : walletLinks.ios,
            };
        if (walletLinks && (isAndroid() || isSamsungBrowser()))
            return {
                storeName: 'Play Store',
                walletLink: walletLinks === null || walletLinks === void 0 ? void 0 : walletLinks.android,
            };
        return {
            storeName: undefined,
            walletLink: undefined,
        };
    }, [selectedWalletConnector]);
    const openWalletApp = () => walletLink && window.open(walletLink, '_blank', 'noopener,noreferrer');
    const makeIcon = (size) => (jsxRuntimeExports.jsx(WalletIcon, { icon: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.metadata.icon, walletKey: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.key, style: {
            height: pixelToRem(size),
            width: pixelToRem(size),
        } }));
    return (jsxRuntimeExports.jsxs("div", { className: 'mobile-wallet-redirect', children: [jsxRuntimeExports.jsx(IconWithSpinner, { Icon: makeIcon(94 * iconRatio), iconSize: 94, isSpinning: true, className: 'mobile-wallet-redirect__icon-with-spinner' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', className: 'mobile-wallet-redirect__copy-text', copykey: 'dyn_login.mobile_wallet_redirect.prompt', children: t('dyn_login.mobile_wallet_redirect.prompt') }), jsxRuntimeExports.jsxs(TypographyButton, { buttonVariant: 'brand-primary', typographyProps: { color: 'white', variant: 'button_secondary' }, onClick: onRetry, buttonPadding: 'small', children: [t('dyn_login.mobile_wallet_redirect.open_prompt'), ' ', selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.name] }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', className: 'mobile-wallet-redirect__alert', children: t('dyn_login.mobile_wallet_redirect.redirect_fail_message', {
                    walletName: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.name,
                }) }), storeName && (jsxRuntimeExports.jsxs("div", { className: 'mobile-wallet-redirect__wallet-app', onClick: openWalletApp, children: [jsxRuntimeExports.jsxs("div", { className: 'mobile-wallet-redirect__wallet-app__group', children: [makeIcon(26), jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', weight: 'bold', children: [t('dyn_login.mobile_wallet_redirect.get_app_prompt'), ' ', selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.name] })] }), jsxRuntimeExports.jsxs("div", { className: 'mobile-wallet-redirect__wallet-app__group', children: [jsxRuntimeExports.jsx(Typography, { className: 'mobile-wallet-redirect__wallet-app__group__app-store', variant: 'body_small', weight: 'bold', color: 'secondary', children: storeName }), jsxRuntimeExports.jsx(Icon, { color: 'text-secondary', size: 'small', children: jsxRuntimeExports.jsx(SvgExternalLink, {}) })] })] }))] }));
};

const UserAddress = ({ userProfile, walletConnector }) => {
    var _a;
    const walletAddress = (_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.verifiedCredentials.find((verifiedCredential) => verifiedCredential.id === userProfile.lastVerifiedCredentialId)) === null || _a === void 0 ? void 0 : _a.address;
    const nameService = useFetchNameService(walletAddress);
    const { data: walletConnectorAddress } = usePromise(() => walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.getAddress(), {
        enabled: !userProfile && Boolean(walletConnector),
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'user-address__container', children: [jsxRuntimeExports.jsx(StatusDot, { variant: 'green', containerClassName: 'user-address__status-dot' }), (nameService === null || nameService === void 0 ? void 0 : nameService.name) ? (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Typography, { variant: 'numbers_big', color: 'primary', className: 'user-address', children: nameService.name }), jsxRuntimeExports.jsx("div", { className: 'dynamic-widget-wallet-header__seperator' }), jsxRuntimeExports.jsx(Typography, { variant: 'numbers_medium', color: 'secondary', className: 'user-address', children: shortenWalletAddress(walletAddress, 3, 3) })] })) : (jsxRuntimeExports.jsx(Typography, { variant: 'numbers_big', color: 'primary', className: 'user-address', children: shortenWalletAddress(walletAddress || walletConnectorAddress, 4, 4) }))] }));
};

const SelectNetworkButton = ({ networkId, networkName, networkIconUrl, onClick, }) => {
    const networkImage = (jsxRuntimeExports.jsx("img", { alt: networkName, className: 'select-network-button__icon', src: networkIconUrl }));
    return (jsxRuntimeExports.jsxs(TypographyButton, { dataTestId: 'SelectNetworkButton', onClick: () => onClick(networkId), expanded: true, className: 'select-network-button', children: ["Select", networkImage, networkName, " network"] }));
};

const useNetworkNotSupported = () => {
    const { selectedWalletConnector: walletConnector, setShowAuthFlow, bridgeChainsToConnect, bridgeOnboardingCompleted, isBridgeFlow, user, authMode, } = useInternalDynamicContext();
    const finishConnectAndSign = useConnectAndSign({
        shouldCallCallback: false,
        shouldUpdateWallets: Boolean(bridgeChainsToConnect === null || bridgeChainsToConnect === void 0 ? void 0 : bridgeChainsToConnect.length),
    });
    const { network: walletConnectorNetwork } = useWalletConnectorNetwork(walletConnector, {
        onChange: (walletConnectorNetwork) => {
            if (!walletConnector ||
                !isSupportedNetwork({
                    network: walletConnectorNetwork,
                    walletConnector,
                })) {
                return;
            }
            finishConnectAndSign({
                walletConnector,
            }).then(() => {
                // if user still has to do onboarding, we should not hide the auth flow
                if (!user && authMode === 'connect-and-sign') {
                    return;
                }
                // we're checking for bridgeChainsToConnect because in some scenarios,
                // bridgeOnboardingCompleted might have not been set yet
                if (!isBridgeFlow ||
                    bridgeOnboardingCompleted ||
                    !(bridgeChainsToConnect === null || bridgeChainsToConnect === void 0 ? void 0 : bridgeChainsToConnect.length)) {
                    setShowAuthFlow(false);
                }
            });
        },
    });
    return { currentNetwork: walletConnectorNetwork };
};

const NetworkNotSupported = () => {
    const { onboardingImageUrl, selectedWalletConnector: walletConnector } = useInternalDynamicContext();
    const { t } = useTranslation();
    const { currentNetwork } = useNetworkNotSupported();
    if (!walletConnector) {
        return null;
    }
    const onSelectNetworkButtonClick = (networkId) => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            yield walletConnector.switchNetwork({
                networkChainId: networkId,
            });
        }
        catch (e) {
            logger$1.debug(e);
        }
    });
    const enabledNetworks = walletConnector.getEnabledNetworks();
    const _isSupportedNetwork = isSupportedNetwork({
        network: currentNetwork,
        walletConnector,
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'network-not-supported', "data-testid": 'network-not-supported', children: [onboardingImageUrl && (jsxRuntimeExports.jsx("img", { className: 'network-not-supported__main-img', src: onboardingImageUrl, alt: 'onboarding' })), !_isSupportedNetwork && (jsxRuntimeExports.jsx(ErrorContainer, { variant: 'info', withIcon: false, className: 'network-not-supported__error--not-supported', copykey: 'dyn_network_not_supported.warning_message', children: t('dyn_network_not_supported.warning_message') })), jsxRuntimeExports.jsxs("div", { className: classNames('network-not-supported__content-container', {
                    'network-not-supported__content-container--error': !_isSupportedNetwork,
                }), children: [jsxRuntimeExports.jsx("div", { className: 'network-not-supported__img-container', children: jsxRuntimeExports.jsx(WalletIcon, { style: { height: 64, width: 64 }, icon: walletConnector.metadata.icon, walletKey: walletConnector.key }) }), jsxRuntimeExports.jsx(UserAddress, { walletConnector: walletConnector }), jsxRuntimeExports.jsx("div", { className: 'network-not-supported__network-container', children: enabledNetworks.length > 1 && (jsxRuntimeExports.jsx(NetworkPicker, { currentNetwork: currentNetwork, connector: walletConnector, showNetworkName: true, buttonClassName: 'network-not-supported__network-picker-button', mainClassName: 'network-not-supported__network-picker' })) }), jsxRuntimeExports.jsx("div", { className: 'network-not-supported__welcome-container', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', copykey: 'dyn_network_not_supported.subtitle', children: t('dyn_network_not_supported.subtitle') }) }), enabledNetworks.length === 1 && (jsxRuntimeExports.jsx(SelectNetworkButton, { onClick: onSelectNetworkButtonClick, networkId: enabledNetworks[0].networkId, networkName: enabledNetworks[0].vanityName || enabledNetworks[0].name, networkIconUrl: enabledNetworks[0].iconUrls[0] }))] })] }));
};

//   The component notifies the user about the required manual network change,
//   as the wallet does not support programmatic network change.
const NetworkNotSupportedSwitchManual = () => {
    const { selectedWalletConnector: walletConnector } = useInternalDynamicContext();
    useNetworkNotSupported();
    const { t } = useTranslation();
    const iconSize = 80;
    const icon = (jsxRuntimeExports.jsx(WalletIcon, { icon: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.metadata.icon, walletKey: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.key, style: {
            height: pixelToRem(iconSize * iconRatio),
            width: pixelToRem(iconSize * iconRatio),
        } }));
    const walletConnectorNetworks = getWalletConnectorNetworks(walletConnector);
    const getSubtitleCopyKey = () => {
        if ((walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.key) === 'metamaskstarknet') {
            return 'dyn_network_not_supported_manual_switch.subtitle_network_defined_metamaskstarknet';
        }
        return walletConnectorNetworks.length
            ? 'dyn_network_not_supported_manual_switch.subtitle_network_defined'
            : 'dyn_network_not_supported_manual_switch.subtitle_no_network_defined';
    };
    const getSubtitle = () => {
        if ((walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.key) === 'metamaskstarknet') {
            return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [t('dyn_network_not_supported_manual_switch.subtitle_network_defined_metamaskstarknet', {
                        network: walletConnectorNetworks[0].name,
                    }), jsxRuntimeExports.jsxs("a", { href: 'https://snaps.consensys.io/starknet', target: '_blank', rel: 'noreferrer', children: [' ', t('dyn_network_not_supported_manual_switch.subtitle_network_defined_metamaskstarknet_companion_app'), ' ', jsxRuntimeExports.jsx(SvgExternalLink, { style: { display: 'inline-block' } })] })] }));
        }
        return walletConnectorNetworks.length
            ? t('dyn_network_not_supported_manual_switch.subtitle_network_defined', {
                network: walletConnectorNetworks[0].name,
            })
            : t('dyn_network_not_supported_manual_switch.subtitle_no_network_defined');
    };
    return (jsxRuntimeExports.jsxs("div", { "data-testid": 'network-not-supported', className: 'network-not-supported-switch-manual', children: [jsxRuntimeExports.jsx("div", { className: 'network-not-supported-switch-manual__img-container', children: jsxRuntimeExports.jsx("div", { className: 'network-not-supported-switch-manual__network-container', children: jsxRuntimeExports.jsx(IconWithSpinner, { Icon: icon, iconSize: iconSize, isSpinning: true }) }) }), jsxRuntimeExports.jsxs("div", { className: 'network-not-supported-switch-manual__content', children: [jsxRuntimeExports.jsx(Typography, { className: 'network-not-supported-switch-manual__title', weight: 'medium', variant: 'title', color: 'primary', copykey: 'dyn_network_not_supported_manual_switch.title', children: t('dyn_network_not_supported_manual_switch.title') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', copykey: getSubtitleCopyKey(), children: getSubtitle() })] })] }));
};

const socialNetworkIconMap = {
    discord: DiscordIcon,
    helpdesk: HelpdeskIcon,
    slack: SlackIcon,
    twitter: TwitterIcon,
};
const getSocialNetworkIcon = (name) => socialNetworkIconMap[name];

const useNoAccessText = () => {
    const { socialMediaLinkText, socialMediaUrl, accessDeniedMessagePrimary, accessDeniedMessageSecondary, } = useInternalDynamicContext();
    const { view } = useViewContext();
    const { t } = useTranslation();
    const isChainalysisView = view.type === 'chainalysis-blocked-wallet';
    const isGateBlockedView = view.type === 'gate-blocked-wallet';
    const isAccessListView = view.type === 'no-access';
    const getSocialMediaLinkText = () => {
        if (isChainalysisView) {
            return t(textData.chainalysis._socialMediaLinkText);
        }
        if (isGateBlockedView) {
            return undefined;
        }
        return socialMediaLinkText;
    };
    const getSocialMediaUrl = () => {
        if (isChainalysisView) {
            return t(textData.chainalysis._socialMediaUrl);
        }
        if (isGateBlockedView) {
            return undefined;
        }
        return socialMediaUrl;
    };
    const getTitle = () => {
        if (isChainalysisView) {
            return t(textData.chainalysis.title);
        }
        if (isGateBlockedView) {
            return t(textData.gate.title);
        }
        return accessDeniedMessagePrimary || t(textData.default.title);
    };
    const getSubtitle = () => {
        if (isChainalysisView) {
            return t(textData.chainalysis.subtitle);
        }
        if (isGateBlockedView) {
            return t(textData.gate.subtitle);
        }
        return accessDeniedMessageSecondary || t(textData.default.subtitle);
    };
    const getButtonTitle = () => {
        if (isChainalysisView) {
            return t(textData.chainalysis.buttonTitle);
        }
        if (isGateBlockedView) {
            return t(textData.gate.buttonTitle);
        }
        return t(textData.default.buttonTitle);
    };
    return {
        _socialMediaLinkText: getSocialMediaLinkText(),
        _socialMediaUrl: getSocialMediaUrl(),
        buttonTitle: getButtonTitle(),
        isAccessListView,
        isChainalysisView,
        isGateBlockedView,
        subtitle: getSubtitle(),
        title: getTitle(),
    };
};
const textData = {
    chainalysis: {
        _socialMediaLinkText: 'dyn_no_access.chainalysis.social_media_link_text',
        _socialMediaUrl: 'dyn_no_access.chainalysis.social_media_link_url',
        buttonTitle: 'dyn_no_access.chainalysis.button_text',
        subtitle: 'dyn_no_access.chainalysis.description',
        title: 'dyn_no_access.chainalysis.title',
    },
    default: {
        buttonTitle: 'dyn_no_access.default.button_text',
        subtitle: 'dyn_no_access.default.description',
        title: 'dyn_no_access.default.title',
    },
    gate: {
        buttonTitle: 'dyn_no_access.gate.button_text',
        subtitle: 'dyn_no_access.gate.description',
        title: 'dyn_no_access.gate.title',
    },
};

const NoAccess = () => {
    const { deniedAddress, setDeniedAddress, setDeniedOauthProvider, deniedOauthProvider, deniedOauthUsername, } = useAccessDeniedContext();
    const { t } = useTranslation();
    // deniedOauthProvider can be undefined
    const accessIcon = deniedOauthProvider
        ? findSocialIcon(deniedOauthProvider)
        : undefined;
    const { selectedWalletConnector: walletConnector, socialMediaIconUrl, notInTheListImageUrl, accessDeniedButton, } = useInternalDynamicContext();
    const { displayedDestination: email } = useVerification();
    const { clearStackAndPushInitialView } = useViewContext();
    const { _socialMediaLinkText, _socialMediaUrl, isAccessListView, isGateBlockedView, subtitle, title, buttonTitle: _buttonTitle, } = useNoAccessText();
    const handleChangeWallet = () => {
        clearStackAndPushInitialView();
        setDeniedAddress('');
        setDeniedOauthProvider(undefined);
        walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.endSession();
    };
    const SocialMediaIcon = !socialMediaIconUrl || typeof socialMediaIconUrl === 'string'
        ? null
        : getSocialNetworkIcon(Object.keys(socialMediaIconUrl)[0]);
    const Icon = useMemo(() => {
        if (walletConnector) {
            return jsxRuntimeExports.jsx(AuthProviderIcon, {});
        }
        return (jsxRuntimeExports.jsx(IconWithStatus, { containerClassName: 'wallet-no-access__icon--verified', Icon: accessIcon !== null && accessIcon !== void 0 ? accessIcon : SignInWithEmailIcon, iconSize: 50, InnerIcon: SvgError, variant: 'red' }));
    }, [accessIcon, walletConnector]);
    const formattedAddress = shortenWalletAddress(deniedAddress, 6, 4);
    const buttonTitle = (accessDeniedButton === null || accessDeniedButton === void 0 ? void 0 : accessDeniedButton.title) || _buttonTitle;
    const buttonAction = (accessDeniedButton === null || accessDeniedButton === void 0 ? void 0 : accessDeniedButton.action) || handleChangeWallet;
    const emailOrAddress = email !== null && email !== void 0 ? email : formattedAddress;
    const correctDisplay = deniedOauthProvider === undefined ? emailOrAddress : deniedOauthUsername;
    const showNoInTheListImage = Boolean(notInTheListImageUrl) && (isAccessListView || isGateBlockedView);
    const showSocialMediaIcon = SocialMediaIcon && (isAccessListView || isGateBlockedView);
    return (jsxRuntimeExports.jsxs("div", { className: 'wallet-no-access__container', children: [showNoInTheListImage && (jsxRuntimeExports.jsx("img", { src: notInTheListImageUrl, alt: t('dyn_no_access.not_in_the_list_image_alt'), className: 'wallet-no-access__image', copykey: 'dyn_no_access.not_in_the_list_image_alt' })), jsxRuntimeExports.jsxs("div", { className: 'wallet-no-access__main', children: [jsxRuntimeExports.jsxs("div", { className: 'wallet-no-access__user-info-container', children: [Icon, jsxRuntimeExports.jsxs("div", { "data-testid": 'walletAddress', className: 'wallet-no-access__wallet-address-container', children: [walletConnector && (jsxRuntimeExports.jsx(StatusDot, { variant: 'red', containerClassName: 'user-info__status-dot' })), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', weight: 'medium', className: 'wallet-no-access__wallet-address', children: correctDisplay })] })] }), jsxRuntimeExports.jsxs("div", { className: 'wallet-no-access__content', children: [jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', className: 'wallet-no-access__content--primary', children: title }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'wallet-no-access__content--secondary', children: subtitle })] }), jsxRuntimeExports.jsx(TypographyButton, { onClick: buttonAction, className: 'wallet-no-access__button--primary', expanded: true, buttonPadding: 'large', children: buttonTitle }), _socialMediaUrl && _socialMediaLinkText && (jsxRuntimeExports.jsxs("div", { className: 'wallet-no-access__social-info-container', children: [jsxRuntimeExports.jsxs("a", { href: _socialMediaUrl, className: 'wallet-no-access__waitlist-link', children: [jsxRuntimeExports.jsx(Typography, { variant: 'button_primary', color: 'primary', children: _socialMediaLinkText }), showSocialMediaIcon && (jsxRuntimeExports.jsx(SocialMediaIcon, { className: 'wallet-no-access__social-icon', style: {
                                            height: pixelToRem(24),
                                            width: pixelToRem(24),
                                        } }))] }), typeof socialMediaIconUrl === 'string' && (jsxRuntimeExports.jsx("img", { alt: 'social media', src: socialMediaIconUrl, style: {
                                    height: '1.5rem',
                                    width: '1.5rem',
                                } }))] }))] })] }));
};

const capitalize = (value) => value[0].toUpperCase() + value.slice(1);
const WalletHelpLink = ({ name, link, Icon }) => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsx("div", { className: 'wallet-help-link', children: jsxRuntimeExports.jsxs("a", { className: 'wallet-help-link__anchor', href: link, target: '_blank', rel: 'noreferrer', children: [jsxRuntimeExports.jsx(Icon, { style: {
                        height: '1.5rem',
                        width: '1.5rem',
                    } }), jsxRuntimeExports.jsx(Typography, { variant: 'button_primary', weight: 'medium', copykey: 'dyn_qr_code.wallet_not_installed.browser_install', children: t('dyn_qr_code.wallet_not_installed.browser_install', {
                        browser: capitalize(name),
                    }) })] }) }));
};

const NoQrNotInstalledView = () => {
    const { selectedWalletConnector } = useInternalDynamicContext();
    const { t } = useTranslation();
    if (!selectedWalletConnector) {
        return null;
    }
    const { metadata } = selectedWalletConnector;
    const downloadLinks = Object.entries(getWalletLinks(metadata.downloadLinks))
        .filter(([, link]) => link !== '')
        .filter(([name]) => name !== 'ios' && name !== 'android')
        .map(([name, link]) => (jsxRuntimeExports.jsx(WalletHelpLink, { name: name, link: link, 
        // justification: we're looping over the keys of walletLinks.desktop
        Icon: getBrowserIcon(name) }, name)));
    return (jsxRuntimeExports.jsxs("div", { className: 'no-qr-code-installed__container', "data-testid": 'no-qr-code-installed', children: [jsxRuntimeExports.jsx("div", { className: 'no-qr-code-installed__img', children: jsxRuntimeExports.jsx(WalletIcon, { icon: metadata.icon, walletKey: selectedWalletConnector.key, style: { height: pixelToRem(64), width: pixelToRem(64) } }) }), jsxRuntimeExports.jsx(Typography, { className: 'no-qr-code-installed__typography--title', variant: 'title', copykey: 'dyn_qr_code.wallet_not_installed.install', children: t('dyn_qr_code.wallet_not_installed.install', {
                    wallet: metadata.name,
                }) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', className: 'no-qr-code-installed__typography', color: 'secondary', copykey: 'dyn_qr_code.wallet_not_installed.select', children: t('dyn_qr_code.wallet_not_installed.select') }), jsxRuntimeExports.jsx("div", { className: 'no-qr-code-installed__links-section', children: downloadLinks }), jsxRuntimeExports.jsx(Typography, { variant: 'body_mini', className: 'no-qr-code-installed__typography', weight: 'medium', color: 'secondary', copykey: 'dyn_qr_code.wallet_not_installed.refresh', children: t('dyn_qr_code.wallet_not_installed.refresh') })] }));
};

var _g$5, _defs$4;
var _excluded$s = ["title", "titleId"];
function _extends$s() { return _extends$s = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$s.apply(null, arguments); }
function _objectWithoutProperties$s(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$s(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$s(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgPasskeyIntro2 = function SvgPasskeyIntro2(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$s(_ref, _excluded$s);
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    width: 327,
    height: 112,
    viewBox: "0 0 327 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$5 || (_g$5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#passkey-intro2_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 114,
    r: 114,
    fill: "url(#passkey-intro2_svg__b)",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#passkey-intro2_svg__c)",
    fill: "#4779FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.009 34.681a2.666 2.666 0 0 1 3.266 1.886l-15.454 4.141a5.319 5.319 0 0 0-3.339 2.666 5.335 5.335 0 0 1 3.936-5.587l11.591-3.106ZM117.785 42.57a5.333 5.333 0 0 0-6.532-3.772l-15.455 4.141a5.333 5.333 0 0 0-3.771 6.532l2.76 10.303a5.333 5.333 0 0 0 6.533 3.771l15.454-4.14a5.333 5.333 0 0 0 3.772-6.533l-2.761-10.303Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m207.67 19.875-.767 2.862a9.86 9.86 0 0 0-5.861 6.61c-1.412 5.269 1.715 10.684 6.984 12.096 5.268 1.412 10.684-1.715 12.096-6.984a9.862 9.862 0 0 0-1.771-8.655l.767-2.861a5.926 5.926 0 0 0-11.448-3.068Zm9.321 2.498-.444 1.655a9.844 9.844 0 0 0-3.409-1.665 9.847 9.847 0 0 0-3.785-.262l.444-1.656a3.723 3.723 0 1 1 7.194 1.928Zm-3.445 8.52a2.57 2.57 0 0 1-2.019 1.862l-.539 2.011a1.1 1.1 0 1 1-2.127-.57l.539-2.01a2.569 2.569 0 1 1 4.146-1.294ZM164.943 32.064a6.216 6.216 0 0 0-1.779 0c-.681.098-1.314.337-1.816.527l-.135.05-16.68 6.256-.407.152c-1.922.718-3.61 1.348-4.909 2.493a9.325 9.325 0 0 0-2.553 3.683c-.616 1.62-.613 3.421-.61 5.473V66.01c0 8.793 4.783 16.125 9.953 21.51 5.204 5.422 11.159 9.252 14.307 11.089l.128.075c.574.337 1.32.775 2.307.987a6.619 6.619 0 0 0 2.609 0c.987-.212 1.732-.65 2.307-.987l.128-.075c3.148-1.837 9.103-5.667 14.307-11.088 5.17-5.386 9.953-12.718 9.953-21.511V50.698c.003-2.052.006-3.854-.611-5.473a9.333 9.333 0 0 0-2.552-3.683c-1.3-1.145-2.987-1.775-4.909-2.493l-.407-.152-16.68-6.255-.135-.05c-.503-.19-1.136-.43-1.816-.528Zm-1.34 14.592a15.89 15.89 0 0 0-7.978 2.135 1.772 1.772 0 0 0 1.775 3.069 12.347 12.347 0 0 1 6.203-1.66c6.853 0 12.408 5.556 12.408 12.409a44.34 44.34 0 0 1-1.688 12.156 1.772 1.772 0 1 0 3.41.97 47.883 47.883 0 0 0 1.823-13.126c0-8.81-7.142-15.953-15.953-15.953Zm-10.749 9.75a1.772 1.772 0 1 0-3.069-1.775 15.891 15.891 0 0 0-2.135 7.978c0 2.499-.573 4.86-1.594 6.96a1.772 1.772 0 1 0 3.189 1.55 19.43 19.43 0 0 0 1.95-8.51c0-2.263.604-4.38 1.659-6.203Zm10.749-2.66a8.863 8.863 0 0 0-8.863 8.863c0 4.516-1.29 8.704-3.518 12.246l1.5.944-1.5-.944-.121.196a1.774 1.774 0 0 0 3.049 1.81 26.434 26.434 0 0 0 4.135-14.253 5.318 5.318 0 0 1 10.636 0c0 1.723-.118 3.418-.345 5.078a1.773 1.773 0 0 0 3.513.48 41.12 41.12 0 0 0 .377-5.557 8.863 8.863 0 0 0-8.863-8.863Zm1.772 8.863a1.772 1.772 0 1 0-3.545 0c0 5.89-1.688 11.381-4.607 16.021a1.773 1.773 0 0 0 3.001 1.888 33.528 33.528 0 0 0 5.151-17.91Zm5.554 11.117a1.773 1.773 0 0 0-3.411-.965 37.01 37.01 0 0 1-2.523 6.502 1.771 1.771 0 1 0 3.169 1.588 40.517 40.517 0 0 0 2.765-7.124Z",
    fill: "#4779FF"
  }))), _defs$4 || (_defs$4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "passkey-intro2_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 327,
    height: 112,
    rx: 12,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "passkey-intro2_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-15 184.593 -307.976)",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "passkey-intro2_svg__b",
    x1: 164,
    y1: 0,
    x2: 164,
    y2: 93.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4779FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779FF",
    stopOpacity: 0
  })))));
};

var _path$o, _path2, _path3;
var _excluded$r = ["title", "titleId"];
function _extends$r() { return _extends$r = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$r.apply(null, arguments); }
function _objectWithoutProperties$r(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$r(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$r(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgAndroidFaceId = function SvgAndroidFaceId(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$r(_ref, _excluded$r);
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 57.887c14.297 0 25.887-11.59 25.887-25.887S46.297 6.113 32 6.113 6.113 17.703 6.113 32 17.703 57.887 32 57.887ZM32 60c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32s12.536 28 28 28Z",
    fill: "#1A73E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.752 46.831c.27.582.018 1.274-.565 1.544-2.69 1.25-5.356 1.479-7.54.476-2.215-1.017-3.66-3.173-4.134-6.099l2.295-.372c.383 2.364 1.466 3.742 2.809 4.359 1.374.63 3.299.592 5.591-.472a1.162 1.162 0 0 1 1.544.564ZM33.585 35.17v-4.755h2.113v6.868h-5.811V35.17h3.698Z",
    fill: "#1A73E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.792 25.132a2.113 2.113 0 1 1-4.226 0 2.113 2.113 0 0 1 4.226 0ZM21.434 25.132a2.113 2.113 0 1 1-4.227 0 2.113 2.113 0 0 1 4.227 0Z",
    fill: "#1A73E8"
  })));
};

var _path$n;
var _excluded$q = ["title", "titleId"];
function _extends$q() { return _extends$q = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$q.apply(null, arguments); }
function _objectWithoutProperties$q(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$q(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$q(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgAndroidTouchId = function SvgAndroidTouchId(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$q(_ref, _excluded$q);
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    d: "M47.493 11.92c-.213 0-.426-.053-.613-.16C41.76 9.12 37.333 8 32.027 8c-5.28 0-10.294 1.253-14.854 3.76-.64.347-1.44.107-1.813-.533a1.35 1.35 0 0 1 .533-1.814c4.96-2.693 10.4-4.08 16.134-4.08 5.68 0 10.64 1.254 16.08 4.054.666.346.906 1.146.56 1.786-.24.48-.694.747-1.174.747Zm-38.16 14a1.33 1.33 0 0 1-1.093-2.107c2.64-3.733 6-6.666 10-8.72 8.373-4.32 19.093-4.346 27.493-.026 4 2.053 7.36 4.96 10 8.666.427.587.294 1.44-.32 1.867a1.33 1.33 0 0 1-1.866-.32c-2.4-3.36-5.44-6-9.04-7.84-7.654-3.92-17.44-3.92-25.067.027-3.627 1.866-6.667 4.533-9.067 7.893-.213.373-.613.56-1.04.56ZM26 58.107c-.347 0-.693-.134-.933-.4-2.32-2.32-3.574-3.814-5.36-7.04-1.84-3.28-2.8-7.28-2.8-11.574 0-7.92 6.773-14.373 15.093-14.373s15.093 6.453 15.093 14.373a1.32 1.32 0 0 1-1.333 1.334 1.32 1.32 0 0 1-1.333-1.334c0-6.453-5.574-11.706-12.427-11.706S19.573 32.64 19.573 39.093c0 3.84.854 7.387 2.48 10.267 1.707 3.067 2.88 4.373 4.934 6.453a1.37 1.37 0 0 1 0 1.894c-.294.266-.64.4-.987.4Zm19.12-4.934c-3.173 0-5.973-.8-8.267-2.373-3.973-2.693-6.346-7.067-6.346-11.707a1.32 1.32 0 0 1 1.333-1.333 1.32 1.32 0 0 1 1.333 1.333c0 3.76 1.92 7.307 5.174 9.494 1.893 1.28 4.106 1.893 6.773 1.893.64 0 1.707-.08 2.773-.267a1.33 1.33 0 0 1 1.547 1.094 1.33 1.33 0 0 1-1.093 1.546c-1.52.294-2.854.32-3.227.32Zm-5.36 5.494a1.56 1.56 0 0 1-.347-.054c-4.24-1.173-7.013-2.746-9.92-5.6-3.733-3.706-5.786-8.64-5.786-13.92 0-4.32 3.68-7.84 8.213-7.84 4.533 0 8.213 3.52 8.213 7.84 0 2.854 2.48 5.174 5.547 5.174 3.067 0 5.547-2.32 5.547-5.174 0-10.053-8.667-18.213-19.334-18.213-7.573 0-14.506 4.213-17.626 10.747-1.04 2.16-1.574 4.693-1.574 7.466 0 2.08.187 5.36 1.787 9.627a1.301 1.301 0 0 1-.773 1.707A1.323 1.323 0 0 1 12 49.653c-1.307-3.493-1.947-6.96-1.947-10.56 0-3.2.614-6.106 1.814-8.64 3.546-7.44 11.413-12.266 20.026-12.266 12.134 0 22 9.36 22 20.88 0 4.32-3.68 7.84-8.213 7.84-4.533 0-8.213-3.52-8.213-7.84 0-2.854-2.48-5.174-5.547-5.174-3.067 0-5.547 2.32-5.547 5.174 0 4.56 1.76 8.826 4.987 12.026 2.533 2.507 4.96 3.894 8.72 4.934.72.186 1.12.933.933 1.626a1.301 1.301 0 0 1-1.253 1.014Z",
    fill: "#1A73E8"
  })));
};

var _path$m;
var _excluded$p = ["title", "titleId"];
function _extends$p() { return _extends$p = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$p.apply(null, arguments); }
function _objectWithoutProperties$p(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$p(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$p(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgFaceId = function SvgFaceId(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$p(_ref, _excluded$p);
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.055 2.4A3.548 3.548 0 0 1 21.6 5.945v2.013a1.095 1.095 0 0 1-2.19 0V5.945c0-.747-.608-1.355-1.355-1.355h-2.012a1.095 1.095 0 1 1 0-2.19h2.012Zm-10.098 0a1.095 1.095 0 0 1 0 2.19H5.945c-.747 0-1.355.608-1.355 1.355v2.013a1.095 1.095 0 0 1-2.19 0V5.945A3.548 3.548 0 0 1 5.945 2.4h2.012Zm7.692 5.083c.6 0 1.086.486 1.086 1.086v1.347a1.086 1.086 0 1 1-2.172 0V8.57c0-.6.486-1.086 1.086-1.086Zm-4.121 0c.614 0 1.112.498 1.112 1.112v2.982h.008a1.113 1.113 0 0 1 0 2.226h-.386a1.849 1.849 0 0 1-1.847-1.848v-3.36c0-.614.498-1.112 1.113-1.112Zm-3.282 0c.6 0 1.086.486 1.086 1.086v1.347a1.086 1.086 0 0 1-2.172 0V8.57c0-.6.486-1.086 1.086-1.086Zm12.259 7.465c.605 0 1.095.49 1.095 1.095v2.012a3.548 3.548 0 0 1-3.545 3.545h-2.012a1.095 1.095 0 1 1 0-2.19h2.012c.747 0 1.355-.608 1.355-1.355v-2.012c0-.605.49-1.095 1.095-1.095Zm-17.01 0c.605 0 1.095.49 1.095 1.095v2.012c0 .747.608 1.355 1.355 1.355h2.012a1.095 1.095 0 0 1 0 2.19H5.945A3.548 3.548 0 0 1 2.4 18.055v-2.012c0-.605.49-1.095 1.095-1.095Zm5.365 1.337a.473.473 0 0 0 0 0l-.434.47a1.113 1.113 0 0 1 1.51-1.634c.563.52 1.296.806 2.064.806s1.5-.286 2.065-.807a1.113 1.113 0 0 1 1.51 1.634A5.255 5.255 0 0 1 12 18.153a5.255 5.255 0 0 1-3.574-1.397l.434-.47a4.615 4.615 0 0 1 0 0Zm5.947.28a4.694 4.694 0 0 1 0 0Z",
    fill: "#ABACB2"
  })));
};

var _g$4, _defs$3;
var _excluded$o = ["title", "titleId"];
function _extends$o() { return _extends$o = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$o.apply(null, arguments); }
function _objectWithoutProperties$o(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$o(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$o(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgIphoneTouchId = function SvgIphoneTouchId(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$o(_ref, _excluded$o);
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iphone-touch-id_svg__a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.635.943c-4.483-1.118-9.2-1.278-13.79-.287a.657.657 0 0 0 .277 1.285c4.396-.95 8.924-.793 13.232.287 10.3 2.582 18.875 10.327 22.14 20.444 1.264 3.912 1.8 8.078 1.908 12.445a.657.657 0 0 0 1.313-.033c-.108-4.426-.651-8.7-1.945-12.74C58.378 11.75 49.417 3.632 38.635.943ZM21.51 2.932a.657.657 0 1 0-.35-1.267c-4.801 1.324-11.554 5.9-15.728 12.014a.754.754 0 0 0-.004.007C1.763 19.208-.534 26.148.108 32.883l.001.019c.154 1.23.412 2.457.67 3.686.544 2.588 1.09 5.183.665 7.818a.657.657 0 1 0 1.297.21c.445-2.755-.107-5.443-.66-8.13-.254-1.244-.51-2.487-.666-3.737-.604-6.364 1.57-13.002 5.105-18.333 4.015-5.879 10.516-10.25 14.99-11.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.133 4.4c8.25-.504 16.499 2.863 22.039 9.314a.657.657 0 1 1-.997.856c-5.268-6.134-13.118-9.339-20.966-8.858H30.2c-9.925.48-19.22 7.214-22.638 16.648a.657.657 0 1 1-1.236-.447C9.928 11.973 19.688 4.907 30.133 4.4ZM54.174 16.585a.657.657 0 0 0-1.091.733c3.07 4.572 4.34 9.548 4.843 15.454a.657.657 0 0 0 1.31-.112c-.514-6.034-1.823-11.252-5.062-16.075ZM58.796 35.45a.657.657 0 0 1 .697.615c.247 3.963.25 8.446-.189 11.76a.657.657 0 1 1-1.303-.173c.423-3.193.425-7.582.18-11.505a.657.657 0 0 1 .615-.697ZM6.57 25.543a.657.657 0 1 0-1.278-.308 26.58 26.58 0 0 0-.743 6.104c-.01 2.117.385 4.184.78 6.25.323 1.692.646 3.384.747 5.104.134 2.26-.341 4.523-1.163 6.677a.657.657 0 1 0 1.228.469c.868-2.277 1.395-4.73 1.247-7.223-.1-1.709-.424-3.39-.747-5.072-.394-2.051-.788-4.102-.778-6.199.01-1.952.248-3.902.706-5.802Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.813 10.94a.657.657 0 0 1-.365.855c-6.813 2.736-11.93 8.91-12.973 16.19-.436 3.042.035 6.055.506 9.067.265 1.696.53 3.392.634 5.093.223 3.688-.197 7.739-2.597 11.425a.657.657 0 0 1-1.101-.718c2.186-3.358 2.6-7.088 2.386-10.627-.105-1.726-.368-3.442-.632-5.156-.472-3.077-.944-6.15-.497-9.27 1.115-7.774 6.563-14.324 13.784-17.224a.657.657 0 0 1 .855.365ZM46.882 14.681c-5.374-5.034-13.164-6.79-20.244-5.238a.657.657 0 1 0 .282 1.284c6.704-1.47 14.039.207 19.064 4.914 4.235 3.967 6.695 9.739 7.339 16.037a.657.657 0 0 0 1.307-.134c-.668-6.54-3.232-12.633-7.748-16.863ZM54.493 34.674a.657.657 0 0 1 .72.586c.625 6.077.356 12.64-.587 18.99a.657.657 0 0 1-1.3-.193c.93-6.261 1.191-12.713.58-18.662a.657.657 0 0 1 .587-.721Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.582 13.355c-10.07 0-18.252 8.034-18.252 17.967 0 1.06.094 2.1.274 3.111a.657.657 0 0 0 1.294-.23 16.469 16.469 0 0 1-.254-2.881c0-9.187 7.574-16.652 16.938-16.652 4.232 0 8.098 1.525 11.066 4.045a.657.657 0 0 0 .85-1.002 18.353 18.353 0 0 0-11.916-4.358ZM44.971 20.163a.657.657 0 0 1 .93.02c2.9 3.024 3.828 7.777 4.442 11.766.692 4.494.798 8.877.798 10.91a.657.657 0 0 1-1.315 0c0-2-.104-6.31-.782-10.71-.57-3.703-1.392-8.24-4.092-11.056a.657.657 0 0 1 .02-.93ZM50.974 46.622a.657.657 0 0 0-1.31-.105c-.323 4.048-.745 8.092-1.6 11.827a.657.657 0 1 0 1.28.293c.879-3.833 1.306-7.956 1.63-12.015ZM14.662 36.852a.657.657 0 0 1 .771.518c1.39 7.056.43 13.466-3.25 19.08a.657.657 0 0 1-1.099-.72c3.462-5.283 4.394-11.331 3.06-18.106a.657.657 0 0 1 .518-.772Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.582 17.631c-6.537 0-12.95 5.06-13.604 11.42-.287 2.784.116 5.526.519 8.27.351 2.395.703 4.791.596 7.217-.244 5.552-1.873 10.135-4.672 13.91a.657.657 0 1 0 1.056.782c2.968-4.003 4.674-8.844 4.93-14.634.106-2.415-.247-4.804-.6-7.19-.403-2.73-.806-5.459-.521-8.221.574-5.587 6.325-10.24 12.296-10.24 2.785 0 9.991 1.508 12.283 8.976 1.437 4.679 1.828 11.012 1.48 17.164-.347 6.151-1.43 12.035-2.885 15.808a.657.657 0 0 0 1.227.473c1.522-3.947 2.619-9.98 2.97-16.207.353-6.226-.034-12.734-1.535-17.624-2.545-8.289-10.52-9.904-13.54-9.904Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.47 56.451c.303.198.389.606.19.91-.407.624-.765 1.278-1.124 1.932-.359.654-.717 1.307-1.125 1.932a.657.657 0 1 1-1.1-.718c.407-.624.765-1.278 1.124-1.932.359-.654.717-1.308 1.125-1.932a.657.657 0 0 1 .91-.192ZM27.096 24.453a.657.657 0 1 0-.73-1.093c-2.603 1.74-4.2 4.134-4.2 7.64 0 2.088.37 3.795.75 5.545.567 2.62.953 5.233.883 7.923-.084 3.267-.723 6.252-1.952 9.096a.657.657 0 1 0 1.207.521c1.299-3.007 1.971-6.158 2.06-9.583.071-2.796-.325-5.513-.913-8.235-.38-1.758-.72-3.328-.72-5.267 0-3.004 1.321-5.013 3.615-6.547ZM29.66 22.144c2.728-.556 5.662.13 7.822 1.879 3.858 3.122 4.371 8.817 4.787 13.432l.021.235c.538 5.949-.077 11.726-1.316 17.529a.657.657 0 1 1-1.286-.275c1.22-5.715 1.815-11.355 1.293-17.136l-.052-.582v-.002c-.37-4.17-.832-9.394-4.274-12.18-1.846-1.494-4.379-2.092-6.732-1.613a.657.657 0 1 1-.262-1.287ZM40.045 58.489a.657.657 0 1 0-1.274-.325 15.88 15.88 0 0 1-1.785 4.266.657.657 0 1 0 1.127.675 17.188 17.188 0 0 0 1.932-4.616ZM36.831 48.952c.36.043.618.37.576.73-.62 5.245-2.022 9.922-4.27 13.98a.657.657 0 0 1-1.15-.638c2.152-3.882 3.51-8.39 4.115-13.496a.657.657 0 0 1 .73-.576Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.696 30.656c-.456-2.435-2.545-4.297-5.081-4.297-3.435 0-5.845 3.462-4.996 6.683 1.437 5.686 1.673 11.166.7 16.444v.003c-.845 4.739-2.465 9.002-4.677 12.614a.657.657 0 0 0 1.121.686c2.302-3.76 3.978-8.178 4.85-13.067 1.01-5.482.759-11.154-.72-17.005l-.002-.007c-.637-2.41 1.138-5.037 3.724-5.037 1.865 0 3.44 1.373 3.788 3.22.957 5.548 1.455 10.693 1.1 15.123a.657.657 0 1 0 1.31.105c.368-4.592-.151-9.863-1.115-15.456l-.002-.01ZM29.654 59.117c.323.166.45.562.284.885l-1.741 3.389a.657.657 0 1 1-1.17-.601L28.77 59.4a.657.657 0 0 1 .885-.284Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.103 31.29a.657.657 0 1 0-1.28.3c2.217 9.433 1.913 17.717-.787 24.773a.657.657 0 1 0 1.228.47c2.814-7.358 3.1-15.919.84-25.544Z"
  }))), _defs$3 || (_defs$3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iphone-touch-id_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
};

const PasskeyDeviceIcon = ({ defaultIcon, className, size = 'small', }) => {
    let IdIcon = defaultIcon ? defaultIcon : null;
    if (isIPhone()) {
        if (isIPhone8OrEarlier()) {
            IdIcon = jsxRuntimeExports.jsx(SvgIphoneTouchId, { "data-testid": 'iphone-8-icon' });
        }
        else {
            IdIcon = jsxRuntimeExports.jsx(SvgFaceId, { "data-testid": 'iphone-icon' });
        }
    }
    if (isAndroid()) {
        const androidVersion = getAndroidVersion();
        if (androidVersion && androidVersion >= 9) {
            IdIcon = jsxRuntimeExports.jsx(SvgAndroidTouchId, { "data-testid": 'android-9-icon' });
        }
        else {
            IdIcon = jsxRuntimeExports.jsx(SvgAndroidFaceId, { "data-testid": 'android-icon' });
        }
    }
    if (!IdIcon) {
        return jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
    }
    return (jsxRuntimeExports.jsx(Icon, { className: className, size: size, children: IdIcon }));
};

const AuthChoiceInfo = ({ choice, variant = 'default', }) => {
    const { t } = useTranslation();
    const authChoiceInfoMap = {
        passkey: {
            default: [
                {
                    description: 'dyn_embedded_authenticator.passkey.auth_info.convinience.description',
                    title: 'dyn_embedded_authenticator.passkey.auth_info.convinience.title',
                },
                {
                    description: 'dyn_embedded_authenticator.passkey.auth_info.security.description',
                    title: 'dyn_embedded_authenticator.passkey.auth_info.security.title',
                },
            ],
            noEmailSignup: [
                {
                    description: 'dyn_embedded_authenticator.passkey.no_email_auth_info.convinience.description',
                    title: 'dyn_embedded_authenticator.passkey.no_email_auth_info.convinience.title',
                },
                {
                    description: 'dyn_embedded_authenticator.passkey.no_email_auth_info.security.description',
                    title: 'dyn_embedded_authenticator.passkey.no_email_auth_info.security.title',
                },
            ],
        },
    };
    return (jsxRuntimeExports.jsx("div", { className: 'auth-choice-info', children: authChoiceInfoMap[choice][variant].map((info, index) => (jsxRuntimeExports.jsxs("div", { className: 'auth-choice-info__container-item', children: [jsxRuntimeExports.jsx("div", { className: 'auth-choice-info__container-icon', children: jsxRuntimeExports.jsx(Icon, { size: 'medium', className: 'auth-choice-info__icon', children: jsxRuntimeExports.jsx(SvgAdd, {}) }) }), jsxRuntimeExports.jsxs("div", { className: 'action-card__item-title', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', copykey: info.title, children: t(info.title) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'regular', color: 'secondary', copykey: info.description, children: t(info.description) })] })] }, `authChoiceInfo_${index}`))) }));
};

const PasskeyIntroView = ({ chains }) => {
    var _a;
    const { walletConnectorOptions, environmentId, handleLogOut, user, userWithMissingInfo, } = useInternalDynamicContext();
    const isEmailRecoveryFlow = ((_a = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.length) === 1 &&
        !getUserVerifiedCredentialType(user, JwtVerifiedCredentialFormatEnum.Email);
    const { t } = useTranslation();
    // TODO(GVTY-1137): send a metric when we detect passkeys are not enabled by the browser/device
    // we removed enforcing this check since we were getting false negatives
    // const { data: passkeyEnabled } = usePromise(isPasskeyEnabled);
    const [createWalletWithAuthenticator, setCreateWalletWithAuthenticator] = useState(false);
    // if passkey is not yet setup, but user logged in with email in a passkey env
    // it should be null to force user to setup passkey even after the a refresh
    useEffect(() => StorageService.removeItem(LAST_USED_WALLET), []);
    const { createDynamicEmbeddedWalletMutation, isLoading, error } = useCreateDynamicEmbeddedWalletMutation();
    const handleCreateEmbeddedWallet = (withAuthenticator) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!user && !userWithMissingInfo) {
            throw new Error('User is not logged in');
        }
        setCreateWalletWithAuthenticator(withAuthenticator);
        yield createDynamicEmbeddedWalletMutation({
            chains,
            environmentId,
            walletConnectorOptions,
            withAuthenticator,
        });
    });
    const errorText = useMemo(() => {
        if (!error) {
            return undefined;
        }
        if (error instanceof DynamicError) {
            return error.message;
        }
        return getProperErrorMessage(error);
    }, [error]);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(ModalHeader, { children: jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'title', color: 'primary', "data-testid": 'dynamic-auth-modal-heading', className: 'header__typography', copykey: 'dyn_passkey_intro.title', children: t('dyn_passkey_intro.title') }) }), jsxRuntimeExports.jsxs("div", { className: 'passkey-intro-view', children: [jsxRuntimeExports.jsx("div", { className: 'passkey-intro-view__header', children: jsxRuntimeExports.jsx(SvgPasskeyIntro2, {}) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'passkey-intro-view__subtitle', copykey: 'dyn_passkey_intro.subtitle', children: t('dyn_passkey_intro.subtitle') }), errorText && jsxRuntimeExports.jsx(ErrorContainer, { children: errorText }), jsxRuntimeExports.jsx(AuthChoiceInfo, { choice: 'passkey', variant: isEmailRecoveryFlow ? 'noEmailSignup' : 'default' }), jsxRuntimeExports.jsxs("div", { className: 'passkey-intro-view__actions', children: [jsxRuntimeExports.jsx(TypographyButton, { buttonVariant: 'brand-primary', buttonPadding: 'large', onClick: () => handleCreateEmbeddedWallet(true), dataTestId: 'setup-passkey-button', loading: isLoading && createWalletWithAuthenticator, disabled: isLoading, typographyProps: {
                                    color: 'inherit',
                                }, children: jsxRuntimeExports.jsxs("div", { className: 'passkey-intro-view__inline-button', children: [jsxRuntimeExports.jsx(PasskeyDeviceIcon, { size: 'small' }), jsxRuntimeExports.jsx(Typography, { copykey: 'dyn_passkey_intro.button', children: t('dyn_passkey_intro.button') })] }) }), jsxRuntimeExports.jsx(TextButton, { "data-testid": 'setup-passkey-logout-button', className: 'passkey-intro-view__log-out', onClick: handleLogOut, copykey: 'dyn_passkey_intro.button_logout', children: t('dyn_passkey_intro.button_logout') })] })] })] }));
};

var _circle$2, _path$l, _g$3, _defs$2;
var _excluded$n = ["title", "titleId"];
function _extends$n() { return _extends$n = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$n.apply(null, arguments); }
function _objectWithoutProperties$n(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$n(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$n(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgPasskeyIntroIcon = function SvgPasskeyIntroIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$n(_ref, _excluded$n);
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    width: 206,
    height: 206,
    viewBox: "0 0 206 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle$2 || (_circle$2 = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 103,
    r: 103,
    fill: "url(#passkey-intro-icon_svg__a)",
    fillOpacity: 0.12
  })), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.59 42.066a6.37 6.37 0 0 1 1.822 0c.696.1 1.343.345 1.858.54l.138.051 17.072 6.402.416.156c1.967.734 3.695 1.38 5.025 2.551a9.553 9.553 0 0 1 2.612 3.77c.631 1.657.628 3.501.625 5.6v15.672c0 9-4.895 16.504-10.187 22.016-5.326 5.55-11.421 9.469-14.643 11.349l-.131.077c-.588.345-1.351.793-2.361 1.01a6.78 6.78 0 0 1-2.67 0c-1.01-.217-1.774-.665-2.362-1.01l-.13-.077c-3.223-1.88-9.317-5.799-14.644-11.349-5.291-5.512-10.186-13.015-10.186-22.016V61.137c-.003-2.1-.006-3.944.625-5.601a9.553 9.553 0 0 1 2.612-3.77c1.33-1.172 3.058-1.817 5.025-2.551l.416-.156 17.072-6.402.138-.052c.514-.194 1.162-.439 1.858-.54ZM94.382 69.11v-4.037a8.073 8.073 0 1 1 16.147 0v4.036a13.434 13.434 0 0 1 5.383 10.766c0 7.431-6.024 13.456-13.456 13.456C95.025 93.33 89 87.306 89 79.875c0-4.402 2.114-8.31 5.382-10.765Zm13.147-1.702v-2.335a5.073 5.073 0 1 0-10.147 0v2.336a13.414 13.414 0 0 1 5.074-.99c1.795 0 3.508.352 5.073.99ZM106 77.5a3.5 3.5 0 0 1-2 3.163V83.5a1.5 1.5 0 1 1-3 0v-2.837a3.5 3.5 0 1 1 5-3.163ZM126 22a4 4 0 0 1 4-4h45a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4h-45a4 4 0 0 1-4-4V22Zm15 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm7 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm13-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm9 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm1 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
    fill: "#4779FF"
  })), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#passkey-intro-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#passkey-intro-icon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.731 54.983a15.068 15.068 0 0 0 1.087-10.69C58.656 36.226 50.362 31.438 42.294 33.6c-8.069 2.162-12.857 10.455-10.695 18.524a15.068 15.068 0 0 0 6.288 8.715c1.864-4.039 6.77-6.622 9.948-7.473 3.179-.852 8.204-1.183 11.896 1.618Zm-19.98-8.96a5.672 5.672 0 1 1 10.957-2.935 5.672 5.672 0 0 1-10.957 2.936Z",
    fill: "#4779FF"
  })))), _defs$2 || (_defs$2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "passkey-intro-icon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-15 151.778 -80.474)",
    d: "M0 0h33v33H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "passkey-intro-icon_svg__c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.684,
    y: 37.513,
    width: 30.25,
    height: 30.25,
    rx: 15.125,
    transform: "rotate(-15 27.684 37.513)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "passkey-intro-icon_svg__a",
    x1: 103,
    y1: 0,
    x2: 103,
    y2: 105.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4779FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779FF",
    stopOpacity: 0
  })))));
};

const AddRecoveryEmail = ({ canSkipAddingEmail = true, shouldInitRecovery = false, authenticatorType, currentAction, isFromEmailVerification = false, }) => {
    const { user, setShowAuthFlow } = useInternalDynamicContext();
    const { t } = useTranslation();
    const { addRecoveryEmail, initPasskeyRecoveryProcess } = usePasskeyRecovery();
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [error, setError] = useState(undefined);
    useEffectOnce(() => {
        dynamicEvents.once('embeddedWalletRecoveryEmailCompleted', () => __awaiter$1(void 0, void 0, void 0, function* () {
            setShowSuccessMessage(true);
            setError(undefined);
            if (!shouldInitRecovery) {
                setTimeout(() => {
                    setShowAuthFlow(false, {
                        ignoreIfIsEmbeddedWidget: false,
                        performMultiWalletChecks: false,
                    });
                }, 5000);
                return;
            }
            return initPasskeyRecoveryProcess(authenticatorType, currentAction);
        }));
        dynamicEvents.once('embeddedWalletRecoveryEmailFailed', (error) => __awaiter$1(void 0, void 0, void 0, function* () {
            setError(error);
        }));
    });
    const { mutate: handleEmailSubmit, isLoading } = useMutation((emailInput) => __awaiter$1(void 0, void 0, void 0, function* () {
        yield addRecoveryEmail(emailInput);
    }));
    const handleSkip = () => {
        setShowAuthFlow(false);
    };
    const handleEmailSubmitError = () => {
        if (!error) {
            return undefined;
        }
        if (error instanceof DynamicError) {
            return error.message;
        }
        return getProperErrorMessage(error);
    };
    const closeButton = canSkipAddingEmail && (jsxRuntimeExports.jsx(IconButton, { onClick: handleSkip, type: 'button', "data-testid": 'add-recovery-email-close-button', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(ModalHeader, { trailing: closeButton, children: jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'title', color: 'primary', "data-testid": 'passkey-recovery-heading', className: 'header__typography', copykey: 'dyn_passkey_recovery.add_email.title', children: t('dyn_passkey_recovery.add_email.title') }) }), jsxRuntimeExports.jsxs("div", { className: 'passkey-recovery-view', children: [jsxRuntimeExports.jsx("div", { className: 'passkey-recovery-view__header', children: jsxRuntimeExports.jsx(SvgPasskeyIntroIcon, {}) }), showSuccessMessage && (jsxRuntimeExports.jsx(ErrorContainer, { variant: 'success', copykey: 'dyn_passkey_recovery.add_email.success_message', children: t('dyn_passkey_recovery.add_email.success_message') })), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'passkey-recovery-view__subtitle', copykey: 'dyn_passkey_recovery.add_email.description', children: t('dyn_passkey_recovery.add_email.description') }), error !== undefined && (jsxRuntimeExports.jsx(ErrorContainer, { children: handleEmailSubmitError() })), jsxRuntimeExports.jsx("div", { className: 'passkey-recovery-view__form', children: jsxRuntimeExports.jsx(EmailForm, { onSubmit: handleEmailSubmit, currentEmail: user === null || user === void 0 ? void 0 : user.email, isLoading: (isLoading || isFromEmailVerification) && !error, buttonCopyKey: 'dyn_passkey_recovery.add_email.confirm_button', isDisabled: isFromEmailVerification && !error && !showSuccessMessage }) })] })] }));
};

// eslint-disable-next-line no-useless-escape
const bundleRegex = new RegExp(/^([A-Za-z0-9\s_+@\.-]+)$/);
const PasskeyBundleRecovery = ({ authenticatorType, currentAction, }) => {
    const { primaryWallet, environmentId, user, setShowAuthFlow } = useInternalDynamicContext();
    const { isTurnkeyWalletWithoutAuthenticator } = useIsTurnkeyWallet();
    const { getEOAWallet } = useSmartWallets();
    const [bundleInput, setBundleInput] = useState('');
    const [resendingCode, setResendingCode] = useState(false);
    const [isValid, setIsValid] = useState(false);
    const { t } = useTranslation();
    const { pushView } = useViewContext();
    const { mutate, isLoading, error } = useMutation((bundleInput) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a;
        const wallet = (_a = (primaryWallet && getEOAWallet(primaryWallet))) !== null && _a !== void 0 ? _a : primaryWallet;
        yield passkeyRecoveryBundleValidation({
            bundleInput,
            user,
            wallet: wallet,
        });
        setIsValid(true);
        // For passkey it will be called after adding a passkey in passkey-recovery-complete view
        authenticatorType === 'email' &&
            dynamicEvents.emit('passkeyRecoveryCompleted', primaryWallet);
        setTimeout(() => {
            const goBack = () => {
                var _a, _b, _c;
                ((_a = currentAction === null || currentAction === void 0 ? void 0 : currentAction.settings) === null || _a === void 0 ? void 0 : _a.goBack)
                    ? (_c = (_b = currentAction === null || currentAction === void 0 ? void 0 : currentAction.settings) === null || _b === void 0 ? void 0 : _b.goBack) === null || _c === void 0 ? void 0 : _c.call(_b)
                    : setShowAuthFlow(false);
            };
            if (authenticatorType === 'passkey') {
                return pushView('passkey-recovery-complete', { goBack });
            }
            if ((currentAction === null || currentAction === void 0 ? void 0 : currentAction.type) === 'reveal') {
                return;
            }
            goBack();
        }, 2000);
    }));
    /**
     *
     * Validates an authenticator label according to Turnkey's validation rules:
     * https://github.com/tkhq/demo-passkey-wallet/blob/main/frontend/utils/validation.ts
     */
    const isValidBundle = (bundle) => {
        if (!(bundle === null || bundle === void 0 ? void 0 : bundle.length)) {
            return false;
        }
        if (bundle.length < 100 || bundle.length >= 256) {
            return false;
        }
        if (!bundleRegex.test(bundle)) {
            return false;
        }
        return true;
    };
    const handleBundleChanged = (event) => {
        var _a;
        const bundle = (_a = event.target.value) === null || _a === void 0 ? void 0 : _a.trim();
        setBundleInput(bundle);
        if (!isValidBundle(bundle)) {
            return;
        }
        mutate(bundle);
    };
    const handleResentEmail = () => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            setResendingCode(true);
            yield resentRecoveryEmail({
                authenticatorType,
                environmentId,
                user,
                wallet: primaryWallet,
            });
        }
        catch (err) {
            logger$1.error('Failed to complete passkey recovery', err);
        }
        finally {
            setResendingCode(false);
        }
    });
    const errorText = useMemo(() => {
        if (!error) {
            return undefined;
        }
        if (error instanceof DynamicError) {
            return error.message;
        }
        return getProperErrorMessage(error);
    }, [error]);
    const emailIcon = (jsxRuntimeExports.jsx(Icon, { color: 'brand-primary', children: jsxRuntimeExports.jsx(SignInWithEmailIcon, {}) }));
    const translationKey = isTurnkeyWalletWithoutAuthenticator
        ? 'dyn_passkey_secure_modal'
        : 'dyn_passkey_recovery';
    const closeButton = (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: () => {
            setShowAuthFlow(false, { emitCancelAuth: true });
            dynamicEvents.emit('passkeyRecoveryFailed', new DynamicError('Validation request cancelled'));
        }, "data-testid": 'close-button', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(ModalHeader, { trailing: closeButton, children: jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'title', color: 'primary', "data-testid": 'dynamic-auth-modal-heading', className: 'header__typography', copykey: `${translationKey}.code.title`, children: t(`${translationKey}.code.title`) }) }), jsxRuntimeExports.jsxs("div", { className: 'passkey-recovery-view', children: [!error && !isValid ? (jsxRuntimeExports.jsx(IconWithSpinner, { Icon: emailIcon, isSpinning: !error && !isValid, iconSize: 96 })) : (jsxRuntimeExports.jsx(IconWithStatus, { Icon: SignInWithEmailIcon, iconSize: 64, variant: error ? 'red' : 'green', InnerIcon: error ? SvgError : SvgCheck })), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'passkey-recovery-view__subtitle', copykey: `${translationKey}.code.description`, children: t(`${translationKey}.code.description`, { email: user === null || user === void 0 ? void 0 : user.email }) }), jsxRuntimeExports.jsx("div", { className: 'passkey-recovery-view__actions', children: jsxRuntimeExports.jsx(Input, { id: 'passkey-recovery-bundle', "data-testid": 'passkey-recovery-bundle-input', value: bundleInput, onChange: handleBundleChanged, label: t(`${translationKey}.code.input_label`), disabled: isLoading || resendingCode, error: Boolean(error), className: isValid ? 'passkey-recovery-view__input-valid' : '', autoFocus: true, message: errorText }) }), jsxRuntimeExports.jsxs("div", { className: 'passkey-recovery-view__resend-code', children: [jsxRuntimeExports.jsx(Typography, { color: 'secondary', variant: 'body_small', copykey: `${translationKey}.code.resend.text`, children: t(`${translationKey}.code.resend.text`) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'link', copykey: `${translationKey}.code.resend.button`, children: jsxRuntimeExports.jsx(TextButton, { "data-testid": 'resend-email-button', onClick: handleResentEmail, disabled: resendingCode || isLoading || (bundleInput.length > 0 && !error), children: t(`${translationKey}.code.resend.button`) }) })] })] })] }));
};

const PasskeyCompleteRecovery = ({ goBack, }) => {
    const { primaryWallet, environmentId, user, setPasskeySuccessPopup } = useInternalDynamicContext();
    const { isTurnkeyWalletWithoutAuthenticator } = useIsTurnkeyWallet();
    const { getEOAWallet } = useSmartWallets();
    const { t } = useTranslation();
    const { mutate: completeRecovery, isLoading, error, } = useMutation(() => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a;
        const wallet = (_a = (primaryWallet && getEOAWallet(primaryWallet))) !== null && _a !== void 0 ? _a : primaryWallet;
        const updatedUser = yield completePasskeyRecovery({
            environmentId,
            user,
            wallet,
        });
        if (!updatedUser) {
            throw new DynamicError('Error completing passkey recovery');
        }
        dynamicEvents.emit('passkeyRecoveryCompleted', primaryWallet);
        goBack();
        setPasskeySuccessPopup(PasskeySuccessEnum.CREATED);
    }), {
        onFailure: (err) => {
            logger$1.error('Failed to init passkey recovery', err);
            dynamicEvents.emit('passkeyRecoveryFailed', err);
        },
    });
    const errorText = useMemo(() => {
        if (!error) {
            return undefined;
        }
        if (error instanceof DynamicError) {
            return error.message;
        }
        return getProperErrorMessage(error);
    }, [error]);
    const translationKey = isTurnkeyWalletWithoutAuthenticator
        ? 'dyn_passkey_secure_modal'
        : 'dyn_passkey_recovery';
    return (jsxRuntimeExports.jsxs("div", { className: 'passkey-recovery-view', children: [jsxRuntimeExports.jsx("div", { className: 'passkey-recovery-view__header', children: jsxRuntimeExports.jsx(SvgPasskeyIntroIcon, {}) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'passkey-recovery-view__subtitle', children: t(`${translationKey}.complete.description`) }), errorText && jsxRuntimeExports.jsx(ErrorContainer, { children: errorText }), jsxRuntimeExports.jsx("div", { className: 'passkey-recovery-view__actions', children: jsxRuntimeExports.jsx(TypographyButton, { buttonVariant: 'brand-primary', buttonPadding: 'large', dataTestId: 'passkey-recovery-complete-button', onClick: () => completeRecovery(), disabled: isLoading, showInternalLoading: false, typographyProps: {
                        color: 'inherit',
                    }, children: jsxRuntimeExports.jsxs("div", { className: 'passkey-recovery-view__inline-button', children: [jsxRuntimeExports.jsx(PasskeyDeviceIcon, { size: 'small' }), jsxRuntimeExports.jsx(Typography, { children: t(`${translationKey}.complete.complete_button`) })] }) }) }), jsxRuntimeExports.jsx(NeedHelpSection, { isRecoveryFlow: true })] }));
};

const PasskeyInitRecovery = ({ authenticatorType, }) => {
    const { setShowAuthFlow } = useInternalDynamicContext();
    const { isTurnkeyWalletWithoutAuthenticator } = useIsTurnkeyWallet();
    const { initAuthMethod, isLoading, error } = useInitEmbeddedWalletAuthMethod();
    const { createRootElement } = useElementById();
    const iframeContainerRef = createRootElement(iframeContainerId$1);
    const { t } = useTranslation();
    const errorText = useMemo(() => {
        if (!error) {
            return undefined;
        }
        if (error instanceof DynamicError) {
            return error.message;
        }
        return 'Something went wrong.';
    }, [error]);
    const EmailIcon = (jsxRuntimeExports.jsx(Icon, { color: 'brand-primary', children: jsxRuntimeExports.jsx(SvgSignInWithEmail, {}) }));
    const translationKey = isTurnkeyWalletWithoutAuthenticator
        ? 'dyn_passkey_secure_modal'
        : 'dyn_passkey_recovery';
    const closeButton = (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: () => setShowAuthFlow(false, { emitCancelAuth: true }), "data-testid": 'close-button', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(ModalHeader, { trailing: closeButton, children: jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'title', color: 'primary', "data-testid": 'dynamic-auth-modal-heading', className: 'header__typography', children: t(`${translationKey}.start.title`) }) }), jsxRuntimeExports.jsxs("div", { className: 'passkey-recovery-view', children: [jsxRuntimeExports.jsx(IconWithSpinner, { Icon: EmailIcon, isSpinning: isLoading, iconSize: 96 }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'passkey-recovery-view__subtitle', children: t(`${translationKey}.start.description`) }), errorText && jsxRuntimeExports.jsx(ErrorContainer, { children: errorText }), jsxRuntimeExports.jsx("div", { className: 'passkey-recovery-view__actions', children: jsxRuntimeExports.jsx(TypographyButton, { buttonPadding: 'large', dataTestId: 'passkey-recovery-button', onClick: () => initAuthMethod({
                                authenticatorType,
                                iframeContainer: iframeContainerRef.current,
                            }), disabled: isLoading, showInternalLoading: false, children: jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsx(Typography, { children: t(`${translationKey}.start.start_button`) }) }) }) }), jsxRuntimeExports.jsx(NeedHelpSection, { isRecoveryFlow: true })] })] }));
};

const RenamePasskeyView = () => {
    var _a;
    const { passkey, setPasskey, passkeyIcon, passkeyEdited, setPasskeyEdited } = usePasskeyContext();
    const { t } = useTranslation();
    const { environmentId, setShowAuthFlow, setPasskeySuccessPopup } = useInternalDynamicContext();
    const [error, setError] = useState(false);
    const handleUpdatePasskey = (alias) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (alias && (passkey === null || passkey === void 0 ? void 0 : passkey.id)) {
            const newPasskey = yield updateUserPasskey({
                alias: alias.trim(),
                environmentId,
                id: passkey.id,
            });
            if (newPasskey) {
                setPasskey(newPasskey);
                setPasskeyEdited(!passkeyEdited);
                setShowAuthFlow(false);
                setPasskeySuccessPopup(PasskeySuccessEnum.EDITED);
            }
            else
                setError(true);
        }
        else
            setError(true);
    });
    const backButton = (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: () => {
            setShowAuthFlow(false);
        }, "data-testid": 'back-button', children: jsxRuntimeExports.jsx(SvgChevronLeft, {}) }));
    const closeButton = (jsxRuntimeExports.jsx(IconButton, { onClick: () => setShowAuthFlow(false), type: 'button', id: 'close-button', "data-testid": 'close-button', children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    if (passkey) {
        return (jsxRuntimeExports.jsxs("div", { className: 'edit-passkeys-widget-view', children: [jsxRuntimeExports.jsx(ModalHeader, { leading: backButton, trailing: closeButton }), jsxRuntimeExports.jsx("div", { className: 'edit-passkeys-widget-view__icon', children: passkeyIcon }), jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'title', color: 'primary', className: 'edit-passkeys-widget-view__title', copykey: 'dyn_rename_passkeys.title', children: t('dyn_rename_passkeys.title') }), jsxRuntimeExports.jsx(Formik, { initialValues: { alias: (_a = passkey.alias) !== null && _a !== void 0 ? _a : '' }, onSubmit: (values) => {
                        handleUpdatePasskey(values.alias);
                    }, children: ({ values }) => (jsxRuntimeExports.jsxs(Form, { className: 'edit-passkeys-widget-view__body', children: [jsxRuntimeExports.jsx(Field, { "data-testid": 'input-field', name: 'alias', type: 'text', label: t('dyn_rename_passkeys.input_label'), copykey: 'dyn_rename_passkeys.input_label', className: 'edit-passkeys-widget-view__input', as: Input, error: error, maxLength: 32 }), jsxRuntimeExports.jsx(TypographyButton, { type: 'submit', className: 'edit-passkeys-widget-view__body', buttonPadding: 'large', disabled: !values.alias, copykey: 'dyn_rename_passkeys.save', children: t('dyn_rename_passkeys.save') }), error && (jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'body_small', color: 'error-1', copykey: 'dyn_rename_passkeys.error', children: t('dyn_rename_passkeys.error') }))] })) })] }));
    }
    return (jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'title', color: 'primary', className: 'edit-passkeys-widget-view__title', children: t('dyn_rename_passkeys.not_found') }));
};

var _g$2, _defs$1;
var _excluded$m = ["title", "titleId"];
function _extends$m() { return _extends$m = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$m.apply(null, arguments); }
function _objectWithoutProperties$m(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$m(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$m(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgMultipleAccountSecurity = function SvgMultipleAccountSecurity(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$m(_ref, _excluded$m);
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    width: 327,
    height: 112,
    viewBox: "0 0 327 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#multiple-account-security_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 114,
    r: 114,
    fill: "url(#multiple-account-security_svg__b)",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#multiple-account-security_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#multiple-account-security_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.709 55.166a14.617 14.617 0 0 0 1.054-10.366c-2.097-7.824-10.139-12.467-17.963-10.371-7.824 2.096-12.468 10.139-10.371 17.963a14.612 14.612 0 0 0 6.097 8.451c1.808-3.916 6.565-6.42 9.647-7.247 3.083-.826 7.955-1.146 11.536 1.57Zm-19.375-8.688a5.5 5.5 0 1 1 10.625-2.848 5.5 5.5 0 0 1-10.625 2.848Z",
    fill: "#4779FF"
  }))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m207.67 19.875-.767 2.862a9.86 9.86 0 0 0-5.861 6.61c-1.412 5.269 1.715 10.684 6.984 12.096 5.268 1.412 10.684-1.715 12.096-6.984a9.862 9.862 0 0 0-1.771-8.655l.767-2.861a5.926 5.926 0 0 0-11.448-3.068Zm9.321 2.498-.444 1.655a9.844 9.844 0 0 0-3.409-1.665 9.847 9.847 0 0 0-3.785-.262l.444-1.656a3.723 3.723 0 1 1 7.194 1.928Zm-3.445 8.52a2.57 2.57 0 0 1-2.019 1.862l-.539 2.011a1.1 1.1 0 1 1-2.127-.57l.539-2.01a2.569 2.569 0 1 1 4.146-1.294ZM164.943 32.064a6.216 6.216 0 0 0-1.779 0c-.681.098-1.313.337-1.816.527l-.135.05-16.68 6.256-.407.152c-1.922.718-3.61 1.348-4.909 2.493a9.336 9.336 0 0 0-2.553 3.683c-.616 1.62-.613 3.421-.61 5.473V66.01c0 8.793 4.783 16.125 9.953 21.51 5.204 5.422 11.159 9.252 14.307 11.089l.128.075c.574.337 1.32.775 2.307.987a6.619 6.619 0 0 0 2.609 0c.987-.212 1.733-.65 2.307-.987l.128-.075c3.148-1.837 9.103-5.667 14.307-11.088 5.17-5.386 9.953-12.718 9.953-21.511V50.698c.003-2.052.006-3.854-.611-5.473a9.333 9.333 0 0 0-2.552-3.683c-1.3-1.145-2.987-1.775-4.909-2.493l-.407-.152-16.68-6.255-.135-.05c-.503-.19-1.136-.43-1.816-.528Zm7.008 18.695c0-1.726-1.4-3.126-3.127-3.126h-14.069a6.253 6.253 0 0 0-6.153 5.133 6.234 6.234 0 0 1 4.589-2.007h18.76Zm1.562 3.127c3.454 0 6.253 2.8 6.253 6.253v12.506a6.253 6.253 0 0 1-6.253 6.254h-18.759a6.253 6.253 0 0 1-6.253-6.254V60.14a6.253 6.253 0 0 1 6.253-6.253h18.759Z",
    fill: "#4779FF"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "multiple-account-security_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 327,
    height: 112,
    rx: 12,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "multiple-account-security_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-15 184.593 -307.976)",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "multiple-account-security_svg__d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.633,
    y: 38.225,
    width: 29.333,
    height: 29.333,
    rx: 14.667,
    transform: "rotate(-15 87.633 38.225)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "multiple-account-security_svg__b",
    x1: 164,
    y1: 0,
    x2: 164,
    y2: 93.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4779FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779FF",
    stopOpacity: 0
  })))));
};

var _g$1, _defs;
var _excluded$l = ["title", "titleId"];
function _extends$l() { return _extends$l = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$l.apply(null, arguments); }
function _objectWithoutProperties$l(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$l(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$l(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgPasskeyAccountSecurity = function SvgPasskeyAccountSecurity(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$l(_ref, _excluded$l);
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    width: 327,
    height: 112,
    viewBox: "0 0 327 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#passkey-account-security_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 114,
    r: 114,
    fill: "url(#passkey-account-security_svg__b)",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#passkey-account-security_svg__c)",
    fill: "#4779FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.009 34.681a2.666 2.666 0 0 1 3.266 1.886l-15.454 4.141a5.319 5.319 0 0 0-3.339 2.666 5.335 5.335 0 0 1 3.936-5.587l11.591-3.105ZM117.785 42.57a5.333 5.333 0 0 0-6.532-3.772l-15.455 4.141a5.333 5.333 0 0 0-3.771 6.532l2.76 10.303a5.334 5.334 0 0 0 6.533 3.771l15.454-4.14a5.333 5.333 0 0 0 3.772-6.533l-2.761-10.303Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m207.67 19.875-.767 2.862a9.86 9.86 0 0 0-5.861 6.61c-1.412 5.268 1.715 10.684 6.984 12.096 5.268 1.412 10.684-1.715 12.096-6.984a9.862 9.862 0 0 0-1.771-8.655l.767-2.861a5.926 5.926 0 0 0-11.448-3.068Zm9.321 2.498-.444 1.655a9.846 9.846 0 0 0-3.409-1.665 9.849 9.849 0 0 0-3.785-.262l.444-1.656a3.723 3.723 0 1 1 7.194 1.928Zm-3.445 8.52a2.57 2.57 0 0 1-2.019 1.862l-.539 2.011a1.1 1.1 0 1 1-2.127-.57l.539-2.01a2.569 2.569 0 1 1 4.146-1.294ZM164.943 32.064a6.216 6.216 0 0 0-1.779 0c-.681.098-1.313.337-1.816.527l-.135.05-16.68 6.256-.407.152c-1.922.718-3.61 1.348-4.909 2.493a9.336 9.336 0 0 0-2.553 3.683c-.616 1.62-.613 3.421-.61 5.473V66.01c0 8.793 4.783 16.125 9.953 21.51 5.204 5.422 11.159 9.252 14.307 11.089l.128.075c.574.337 1.32.775 2.307.987a6.619 6.619 0 0 0 2.609 0c.987-.212 1.733-.65 2.307-.987l.128-.075c3.148-1.837 9.103-5.667 14.307-11.088 5.17-5.386 9.953-12.718 9.953-21.511V50.698c.003-2.052.006-3.854-.611-5.473a9.333 9.333 0 0 0-2.552-3.683c-1.3-1.145-2.987-1.775-4.909-2.493l-.407-.152-16.68-6.255-.135-.05c-.503-.19-1.136-.43-1.816-.528Zm-1.34 14.592a15.89 15.89 0 0 0-7.978 2.135 1.772 1.772 0 1 0 1.776 3.069 12.34 12.34 0 0 1 6.202-1.66c6.853 0 12.408 5.556 12.408 12.409a44.34 44.34 0 0 1-1.688 12.156 1.772 1.772 0 1 0 3.41.97 47.883 47.883 0 0 0 1.823-13.126c0-8.81-7.142-15.953-15.953-15.953Zm-10.749 9.75a1.772 1.772 0 1 0-3.068-1.775 15.882 15.882 0 0 0-2.136 7.978c0 2.499-.573 4.86-1.594 6.96a1.772 1.772 0 1 0 3.189 1.55 19.43 19.43 0 0 0 1.95-8.51c0-2.263.605-4.38 1.659-6.203Zm10.749-2.66a8.863 8.863 0 0 0-8.863 8.863c0 4.516-1.29 8.704-3.518 12.246l1.5.944-1.5-.944a8.75 8.75 0 0 0-.12.196 1.773 1.773 0 1 0 3.048 1.81c.023-.04.048-.079.072-.118a26.434 26.434 0 0 0 4.063-14.134 5.318 5.318 0 0 1 10.636 0c0 1.722-.118 3.417-.344 5.077a1.772 1.772 0 1 0 3.512.48 41.12 41.12 0 0 0 .377-5.557 8.863 8.863 0 0 0-8.863-8.863Zm1.772 8.863a1.772 1.772 0 1 0-3.545 0c0 5.89-1.688 11.381-4.607 16.021a1.773 1.773 0 0 0 3.001 1.888 33.528 33.528 0 0 0 5.151-17.91Zm5.554 11.117a1.773 1.773 0 0 0-3.411-.965 37.01 37.01 0 0 1-2.523 6.502 1.771 1.771 0 1 0 3.169 1.588 40.517 40.517 0 0 0 2.765-7.124Z",
    fill: "#4779FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "passkey-account-security_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 327,
    height: 112,
    rx: 12,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "passkey-account-security_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-15 184.593 -307.976)",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "passkey-account-security_svg__b",
    x1: 164,
    y1: 0,
    x2: 164,
    y2: 93.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4779FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4779FF",
    stopOpacity: 0
  })))));
};

const ActionCard = ({ titleKey, descriptionKey, description, LeadingIcon, action, badgeVariant, badgeKey, isLoading, dataTestId, }) => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsxs("button", { className: 'action-card', onClick: action, "data-testid": dataTestId, children: [jsxRuntimeExports.jsx(Icon, { className: 'action-card__icon', children: LeadingIcon }), jsxRuntimeExports.jsxs("div", { className: 'action-card__content', children: [jsxRuntimeExports.jsxs("div", { className: 'action-card__content__row', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'medium', copykey: titleKey, children: t(titleKey) }), jsxRuntimeExports.jsx(Badge, { text: t(badgeKey), className: classNames('action-card__content__row__badge', {
                                    'action-card__content__row__badge--primary': badgeVariant === 'primary',
                                }, {
                                    'action-card__content__row__badge--secondary': badgeVariant === 'secondary',
                                }), copykey: badgeKey })] }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', copykey: descriptionKey, children: description })] }), jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', className: 'action-card__action-icon', children: isLoading ? jsxRuntimeExports.jsx(Spinner$1, {}) : jsxRuntimeExports.jsx(SvgChevronLeft, {}) })] }));
};

const EmbeddedAuthChoiceCards = ({ currentAction, supportedAuthenticators, }) => {
    var _a, _b;
    const [selectedAuthType, setSelectedAuthType] = useState();
    const { projectSettings } = useInternalDynamicContext();
    const { t } = useTranslation();
    const { initAuthMethod, isLoading } = useInitEmbeddedWalletAuthMethod();
    const { createRootElement } = useElementById();
    const iframeContainerRef = createRootElement(iframeContainerId$1);
    const supportedAuthenticatorsMap = {
        email: {
            badgeKey: 'dyn_embedded_authenticator.email.badge',
            description: t('dyn_embedded_authenticator.email.description', {
                expiration: (_b = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _a === void 0 ? void 0 : _a.sessionKeyDuration) === null || _b === void 0 ? void 0 : _b.amount,
            }),
            descriptionKey: 'dyn_embedded_authenticator.email.description',
            icon: (jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', size: 'small', children: jsxRuntimeExports.jsx(SvgMail, {}) }, 'one-time-code-icon')),
            titleKey: 'dyn_embedded_authenticator.email.title',
        },
        passkey: {
            badgeKey: 'dyn_embedded_authenticator.passkey.badge',
            description: t('dyn_embedded_authenticator.passkey.description'),
            descriptionKey: 'dyn_embedded_authenticator.passkey.description',
            icon: (jsxRuntimeExports.jsx(PasskeyDeviceIcon, { defaultIcon: jsxRuntimeExports.jsx(SvgAndroidTouchId, { "data-testid": 'default-icon' }) })),
            titleKey: (currentAction === null || currentAction === void 0 ? void 0 : currentAction.type) === 'reveal'
                ? 'dyn_embedded_authenticator.passkey.reveal_title'
                : 'dyn_embedded_authenticator.passkey.title',
        },
    };
    const handleSelection = (authenticatorType) => () => __awaiter$1(void 0, void 0, void 0, function* () {
        setSelectedAuthType(authenticatorType);
        yield initAuthMethod({
            authenticatorType: authenticatorType,
            currentAction,
            iframeContainer: iframeContainerRef.current,
        });
    });
    return (jsxRuntimeExports.jsx("div", { className: 'embedded-auth-choice-cards', children: supportedAuthenticators &&
            supportedAuthenticators.map((authenticatorType) => (jsxRuntimeExports.jsx(ActionCard, { LeadingIcon: supportedAuthenticatorsMap[authenticatorType]
                    .icon, action: handleSelection(authenticatorType), badgeKey: supportedAuthenticatorsMap[authenticatorType]
                    .badgeKey, badgeVariant: authenticatorType === 'passkey' ? 'primary' : 'secondary', descriptionKey: supportedAuthenticatorsMap[authenticatorType]
                    .descriptionKey, description: supportedAuthenticatorsMap[authenticatorType]
                    .description, titleKey: supportedAuthenticatorsMap[authenticatorType]
                    .titleKey, isLoading: isLoading && authenticatorType === selectedAuthType, dataTestId: `embedded-auth-choice__item-${authenticatorType}` }, authenticatorType))) }));
};

const titleDescriptionMap = {
    helpSession: {
        description: 'dyn_embedded_authenticator.need_help_description',
        title: 'dyn_embedded_authenticator.need_help_title',
    },
    reveal: {
        description: 'dyn_embedded_authenticator.reveal_description',
        title: 'dyn_embedded_authenticator.reveal_title',
    },
    sendTransaction: {
        description: 'dyn_embedded_authenticator.description',
        title: 'dyn_embedded_authenticator.title',
    },
    signMessage: {
        description: 'dyn_embedded_authenticator.description',
        title: 'dyn_embedded_authenticator.title',
    },
    signTransaction: {
        description: 'dyn_embedded_authenticator.description',
        title: 'dyn_embedded_authenticator.title',
    },
};
const EmbeddedAuthChoice = ({ currentAction, }) => {
    var _a, _b, _c;
    const { t } = useTranslation();
    const { primaryWallet, projectSettings, setShowAuthFlow } = useInternalDynamicContext();
    const { getEOAWallet } = useSmartWallets();
    const wallet = (_a = (primaryWallet && getEOAWallet(primaryWallet))) !== null && _a !== void 0 ? _a : primaryWallet;
    const { initPasskeyRecoveryProcess } = usePasskeyRecovery();
    const { isTurnkeyWallet } = useIsTurnkeyWallet();
    const supportedAuthenticators = useMemo(() => {
        var _a;
        const supportedAuths = getEnabledEmbeddedWalletsAuthenticators((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _a === void 0 ? void 0 : _a.supportedSecurityMethods);
        const supportedMethods = Object.keys(supportedAuths);
        if (!currentAction ||
            !['helpSession', 'reveal'].includes(currentAction.type)) {
            return supportedMethods.filter((auth) => auth !== 'email');
        }
        return supportedMethods;
    }, [projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets]);
    const isEmailAuthSessionActive = () => {
        if (!wallet || !isTurnkeyWallet) {
            return false;
        }
        const turnkeyAuthenticatorHandler = wallet.connector.getAuthenticatorHandler();
        return turnkeyAuthenticatorHandler.isSessionActive();
    };
    const renderIcon = () => supportedAuthenticators.length > 1 ? (jsxRuntimeExports.jsx(SvgMultipleAccountSecurity, {})) : (jsxRuntimeExports.jsx(SvgPasskeyAccountSecurity, {}));
    const buttonCopyKey = isEmailAuthSessionActive()
        ? 'dyn_embedded_authenticator.passkey.auth_info.start_button'
        : 'dyn_embedded_authenticator.passkey.auth_info.add_button';
    const { title, description } = titleDescriptionMap[(currentAction === null || currentAction === void 0 ? void 0 : currentAction.type) || 'signMessage'];
    const supportUrls = (_b = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.general) === null || _b === void 0 ? void 0 : _b.supportUrls;
    const supportEmail = (_c = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.general) === null || _c === void 0 ? void 0 : _c.supportEmail;
    if (!(supportedAuthenticators === null || supportedAuthenticators === void 0 ? void 0 : supportedAuthenticators.length)) {
        return null;
    }
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(ModalHeader, { children: jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'title', color: 'primary', "data-testid": 'dynamic-auth-modal-heading', className: 'header__typography', copykey: title, children: t(title) }) }), jsxRuntimeExports.jsxs("div", { className: 'embedded-auth-choice', children: [jsxRuntimeExports.jsx("div", { className: 'embedded-auth-choice__header', children: renderIcon() }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'embedded-auth-choice__subtitle', copykey: description, children: t(description) }), supportedAuthenticators.length > 1 ? (jsxRuntimeExports.jsx(EmbeddedAuthChoiceCards, { currentAction: currentAction, supportedAuthenticators: supportedAuthenticators })) : (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(AuthChoiceInfo, { choice: 'passkey' }), jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'passkey-only-choice-button', buttonVariant: 'brand-primary', expanded: true, onClick: () => initPasskeyRecoveryProcess('passkey'), copykey: buttonCopyKey, typographyProps: {
                                    color: 'inherit',
                                }, children: t(buttonCopyKey) })] })), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.type) !== 'reveal' && (jsxRuntimeExports.jsx(TypographyButton, { buttonVariant: 'primary', buttonClassName: 'embedded-auth-choice__skip-button', expanded: true, onClick: () => {
                            var _a, _b, _c;
                            ((_a = currentAction === null || currentAction === void 0 ? void 0 : currentAction.settings) === null || _a === void 0 ? void 0 : _a.goBack)
                                ? (_c = (_b = currentAction === null || currentAction === void 0 ? void 0 : currentAction.settings) === null || _b === void 0 ? void 0 : _b.goBack) === null || _c === void 0 ? void 0 : _c.call(_b)
                                : setShowAuthFlow(false);
                        }, copykey: 'dyn_embedded_authenticator.skip', children: t('dyn_embedded_authenticator.skip') })), (currentAction === null || currentAction === void 0 ? void 0 : currentAction.type) === 'helpSession' &&
                        (supportUrls || supportEmail) && (jsxRuntimeExports.jsx("div", { className: 'embedded-auth-choice__support-links', children: jsxRuntimeExports.jsx(SupportLinks, { supportEmail: supportEmail, supportUrls: supportUrls }) }))] })] }));
};

const PendingSignatureView = () => {
    const [loading, setLoading] = useState(false);
    const { selectedWalletConnector: walletConnector } = useInternalDynamicContext();
    const { signAlreadyConnectedUser } = useConnectAndSignSplitSteps();
    const { t } = useTranslation();
    const iconSize = 96;
    /**
     * The following check on Phantom+Ledger will be fixed in a future ticket.
     */
    const isHardwareWallet = isHardwareWalletEnabled(walletConnector);
    if (!walletConnector) {
        return null;
    }
    const handleClick = () => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            yield signAlreadyConnectedUser({ walletConnector });
        }
        catch (e) {
            logger$1.error(e);
        }
        finally {
            setLoading(false);
        }
    });
    const icon = (jsxRuntimeExports.jsx(WalletIcon, { icon: walletConnector.metadata.icon, walletKey: walletConnector.key, style: {
            height: pixelToRem(iconSize * iconRatio),
            width: pixelToRem(iconSize * iconRatio),
        } }));
    const typographyBodyCopy = isHardwareWallet
        ? t('dyn_pending_signature.phantom_ledger_sign')
        : t('dyn_pending_signature.regular_sign_description');
    return (jsxRuntimeExports.jsxs("div", { className: 'pending-signature__container', "data-testid": 'pending-signature-view', children: [jsxRuntimeExports.jsx(IconWithSpinner, { Icon: icon, iconSize: iconSize, isSpinning: true, indicator: 'connected', className: 'pending-signature__icon-with-spinner' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', className: classNames('pending-signature__copy'), copykey: isHardwareWallet
                    ? 'dyn_pending_signature.phantom_ledger_sign'
                    : 'dyn_pending_signature.regular_sign_description', children: typographyBodyCopy }), isHardwareWallet && (jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', weight: 'regular', className: classNames('pending-signature__copy', 'pending-signature__copy--mini'), copykey: 'dyn_pending_signature.phantom_ledger_warning', children: [jsxRuntimeExports.jsx("strong", { children: t('dyn_pending_signature.note') }), t('dyn_pending_signature.phantom_ledger_warning')] })), requiresTwoStepAuthentication(walletConnector) && (jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'pending-signature__button', onClick: handleClick, loading: loading, buttonVariant: 'primary', buttonPadding: 'large', expanded: true, typographyProps: {
                    variant: 'button_primary',
                    weight: 'medium',
                }, copykey: 'dyn_pending_signature.click_to_sign', children: t('dyn_pending_signature.click_to_sign') }))] }));
};

const QrCodeView = () => {
    var _a;
    const { theme: { theme }, } = useThemeContext();
    const { name } = theme;
    const { qrcodeUri, desktopUri, selectedWalletConnector: walletConnector, } = useInternalDynamicContext();
    if (!walletConnector) {
        return null;
    }
    const icon = (jsxRuntimeExports.jsx(WalletIcon, { icon: walletConnector.metadata.icon, walletKey: walletConnector.key, style: { height: pixelToRem(32), width: pixelToRem(32) } }));
    return (jsxRuntimeExports.jsx(QrCodeWrapper, { uri: qrcodeUri, desktopUri: desktopUri, accentColor: 
        /* istanbul ignore next */
        name === 'dark'
            ? theme.colors.textPrimary
            : (_a = walletConnector.metadata.brandColor) !== null && _a !== void 0 ? _a : '', icon: icon, showCopyToClipboardButton: walletConnector.isWalletConnect, walletConnector: walletConnector }));
};

const PendingConnectView = () => {
    const { selectedWalletConnector: walletConnector } = useInternalDynamicContext();
    const { t } = useTranslation();
    const iconSize = 94;
    const icon = (jsxRuntimeExports.jsx(WalletIcon, { icon: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.metadata.icon, walletKey: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.key, style: {
            height: pixelToRem(iconSize * iconRatio),
            width: pixelToRem(iconSize * iconRatio),
        } }));
    return (jsxRuntimeExports.jsxs("div", { className: 'pending-connect__container', children: [jsxRuntimeExports.jsx(IconWithSpinner, { Icon: icon, iconSize: iconSize, isSpinning: true, className: 'pending-connect__icon-with-spinner' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', className: 'pending-connect__copy-text', copykey: isMobile()
                    ? 'dyn_pending_connection.mobile'
                    : 'dyn_pending_connection.computer', children: isMobile()
                    ? t('dyn_pending_connection.mobile')
                    : t('dyn_pending_connection.computer') })] }));
};

const SandboxMaximumThresholdReached = () => {
    const { t } = useTranslation();
    const { clearStackAndPushInitialView } = useViewContext();
    const handleGoBack = () => {
        clearStackAndPushInitialView();
    };
    return (jsxRuntimeExports.jsxs("div", { className: 'sandbox-threshold__main', children: [jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', className: 'sandbox-threshold__title', children: t('dyn_sandbox_maximum_threshold.title') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', className: 'sandbox-threshold__description', children: t('dyn_sandbox_maximum_threshold.description') }), jsxRuntimeExports.jsx(TypographyButton, { onClick: handleGoBack, className: 'sandbox-threshold__button', expanded: true, buttonPadding: 'large', children: t('dyn_sandbox_maximum_threshold.button') })] }));
};

const Toggle = ({ icon, variant = 'primary', value, onChange, dataTestId, className, style, }) => (jsxRuntimeExports.jsxs("label", { className: classNames('toggle', className), style: style, children: [jsxRuntimeExports.jsx("input", { type: 'checkbox', className: 'toggle--input', "data-testid": dataTestId, checked: value, onChange: () => onChange === null || onChange === void 0 ? void 0 : onChange(!value) }), jsxRuntimeExports.jsx("div", { className: classNames('toggle--content', `toggle--content__variant-${variant}`), children: jsxRuntimeExports.jsx("div", { className: 'toggle--knob', children: icon }) })] }));

const HardwareWalletToggle = ({ connectors, label, copykey, }) => {
    const [isEnabled, _setEnabled] = useState(connectors.some((connector) => connector.isHardwareWalletEnabled));
    const setEnabled = useCallback((enabled) => {
        _setEnabled(enabled);
        connectors.forEach((connector) => {
            connector.isHardwareWalletEnabled = enabled;
        });
    }, [connectors]);
    const toggle = (jsxRuntimeExports.jsx(Toggle, { value: isEnabled, dataTestId: 'hardware-wallet-toggle', icon: jsxRuntimeExports.jsx(Icon, { size: 'small', children: jsxRuntimeExports.jsx(SvgCheck, {}) }), className: 'hardware-wallet-toggle__toggle' }));
    return (jsxRuntimeExports.jsx(ListTile, { onClick: () => setEnabled(!isEnabled), trailing: toggle, children: jsxRuntimeExports.jsx("span", { copykey, children: label }) }));
};

const SelectHardwareWalletView = ({ wallet, onSelectWallet, }) => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsx("div", { className: 'select-hardware-wallet-view', children: jsxRuntimeExports.jsxs("div", { className: 'select-hardware-wallet-view__container', children: [jsxRuntimeExports.jsx(Icon, { className: 'select-hardware-wallet-view__icon', children: jsxRuntimeExports.jsx(WalletIcon, { icon: wallet.walletConnector.metadata.icon, walletKey: wallet.key }) }), jsxRuntimeExports.jsx(Typography, { className: 'select-hardware-wallet-view__text', as: 'p', color: 'secondary', variant: 'body_normal', copykey: 'dyn_select_hardware_wallet.description', children: t('dyn_select_hardware_wallet.description') }), isHardwareWalletConnector(wallet.walletConnector) && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(HardwareWalletToggle, { connectors: [wallet.walletConnector], copykey: 'dyn_select_chain.using_hardware_wallet_toggle_label', label: t('dyn_select_chain.using_hardware_wallet_toggle_label') }), jsxRuntimeExports.jsx(Divider, {})] })), jsxRuntimeExports.jsx(TypographyButton, { buttonVariant: 'primary', onClick: () => onSelectWallet === null || onSelectWallet === void 0 ? void 0 : onSelectWallet(wallet), copykey: 'dyn_select_hardware_wallet.button', dataTestId: 'select-hardware-wallet-connect-button', children: t('dyn_select_hardware_wallet.button') })] }) }));
};

const WalletGroupViewLayout = ({ icon, title, titleCopyKey, children }) => (jsxRuntimeExports.jsxs("div", { className: 'wallet-group-view-layout__container', children: [jsxRuntimeExports.jsx(IconWithSpinner, { className: 'wallet-group-view-layout__icon', Icon: icon, iconSize: 96 }), jsxRuntimeExports.jsxs("div", { className: 'wallet-group-view-layout__body', children: [jsxRuntimeExports.jsx(Typography, { className: 'wallet-group-view-layout__title', as: 'p', color: 'secondary', variant: 'body_normal', copykey: titleCopyKey, children: title }), jsxRuntimeExports.jsx("div", { className: 'wallet-group-view-layout__list', children: children })] })] }));

const WalletGroupItem$1 = ({ groupKey, wallet, onClick, }) => {
    const { recommendedWallets } = useInternalDynamicContext();
    const { walletBook } = useWalletBookContext();
    const walletOverride = findWalletGroupOverride(walletBook, groupKey, wallet.key);
    const walletData = findWalletBookWallet(walletBook, wallet.key);
    const brand = (walletOverride === null || walletOverride === void 0 ? void 0 : walletOverride.brand) || (walletData === null || walletData === void 0 ? void 0 : walletData.brand);
    const name = (walletOverride === null || walletOverride === void 0 ? void 0 : walletOverride.name) || (walletData === null || walletData === void 0 ? void 0 : walletData.name);
    const icon = brand ? (jsxRuntimeExports.jsx(BrandIcon, { brand: brand, walletKey: wallet.key, style: { height: pixelToRem(28), width: pixelToRem(28) } })) : null;
    const labelSettings = getWalletListItemLabel({
        recommendedWallets,
        wallet,
    });
    const trailing = (jsxRuntimeExports.jsx(ListTileAnimatedTrailing, { hoverElement: 
        // eslint-disable-next-line react/jsx-wrap-multilines
        jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', size: 'mini', children: jsxRuntimeExports.jsx(SvgStroke, {}) }), children: labelSettings && (jsxRuntimeExports.jsx(Badge, { dot: !labelSettings.isRecommended, variant: labelSettings.isRecommended ? 'primary' : 'secondary', text: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', children: labelSettings.label }) })) }));
    return (jsxRuntimeExports.jsx(ListTile, { onClick: onClick, leading: icon, trailing: trailing, children: name }));
};

const SelectWalletInWalletGroupView = ({ onSelectWallet }) => {
    var _a;
    const { selectedWalletGroup } = useWalletGroupContext();
    const walletGroups = useWalletGroups();
    const { t } = useTranslation();
    if (!selectedWalletGroup)
        throw new Error('Could not access WalletGroup view without selected group');
    const walletGroupData = walletGroups[selectedWalletGroup.key];
    if (!walletGroupData)
        throw new Error('Could not access WalletGroup view without group data');
    return (jsxRuntimeExports.jsx(WalletGroupViewLayout, { icon: 
        // eslint-disable-next-line react/jsx-wrap-multilines
        jsxRuntimeExports.jsx(WalletIcon, { walletKey: walletGroupData.key, isGroup: true, icon: (_a = walletGroupData.brand) === null || _a === void 0 ? void 0 : _a.icon }), title: t('dyn_select_wallet.description', {
            walletName: walletGroupData.name,
        }), titleCopyKey: 'dyn_select_wallet.description', children: selectedWalletGroup.groupedWallets.map((wallet, index) => (jsxRuntimeExports.jsx(WalletGroupItem$1, { groupKey: selectedWalletGroup.key, wallet: wallet, onClick: () => onSelectWallet(wallet) }, `${wallet.key}_${index}`))) }));
};

var _path$k;
var _excluded$k = ["title", "titleId"];
function _extends$k() { return _extends$k = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$k.apply(null, arguments); }
function _objectWithoutProperties$k(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$k(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$k(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSignInWithPhone = function SvgSignInWithPhone(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$k(_ref, _excluded$k);
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32Zm-7.91-50h14.892a4.092 4.092 0 0 1 4.09 4.09v27.82a4.092 4.092 0 0 1-4.09 4.09H24.09A4.092 4.092 0 0 1 20 45.91V18.09A4.092 4.092 0 0 1 24.09 14Zm4.992 31.91a2.451 2.451 0 0 0 2.454 2.454 2.451 2.451 0 0 0 2.455-2.455 2.451 2.451 0 0 0-2.455-2.454 2.451 2.451 0 0 0-2.454 2.454Zm-5.81-4.092H39.8V18.91H23.273v22.91Z",
    fill: "#4779FF"
  })));
};

const PhoneIcon = (props) => (jsxRuntimeExports.jsx(Icon, { color: 'brand-primary', children: jsxRuntimeExports.jsx(SvgSignInWithPhone, Object.assign({}, props, { "data-testid": 'sign-in-with-sms-icon' })) }));

const useSmsVerification = (type) => {
    const { verificationUUID, displayedDestination: formattedPhone, retryData, } = useVerification();
    const { environmentId, user, userWithMissingInfo, projectSettings } = useInternalDynamicContext();
    const [error, setError] = useState();
    const { verifyOtp } = useOtpVerificationRequest();
    const { generateSessionKey, shouldRegisterSessionKeysOnSignin } = useEmbeddedWalletSessionKeys({
        environmentId,
        projectSettings,
    });
    const { initAuth, completeAuth, cancelAuth } = useUserAuth({
        authMethod: 'sms',
    });
    /** Whether verification was successfully performed */
    const isValidatedRef = useRef(false);
    useOnUnmount(() => {
        const phone = retryData !== null && retryData !== void 0 ? retryData : {
            dialCode: '',
            iso2: '',
            phone: '',
        };
        if (!retryData)
            logger$1.warn('WARNING: emitted smsVerificationResult with incomplete params because retryData was undefined');
        dynamicEvents.emit('smsVerificationResult', isValidatedRef.current, phone);
        if (!isValidatedRef.current)
            dynamicEvents.emit('authFailure', { option: phone, phone, type: 'sms' }, 'user-cancelled');
    });
    const retryOneTimePassword = () => __awaiter$1(void 0, void 0, void 0, function* () {
        setError(undefined);
        if (!verificationUUID || !retryData) {
            yield cancelAuth();
            return;
        }
        retrySmsVerification({
            environmentId,
            isoCountryCode: retryData.iso2,
            phoneCountryCode: retryData.dialCode,
            phoneNumber: de({
                dialCode: retryData.dialCode,
                phone: retryData.phone,
            }),
            verificationUUID,
        });
    });
    const submitOtpForVerification = useCallback((verificationToken) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!verificationUUID || (!user && !userWithMissingInfo)) {
            yield cancelAuth();
            return;
        }
        yield completeAuth({
            onValidUpdatedJwt: () => (isValidatedRef.current = true),
            updateJwtFunction: () => __awaiter$1(void 0, void 0, void 0, function* () { return verifyOtp(verificationToken, 'sms', verificationUUID); }),
        });
    }), [
        cancelAuth,
        completeAuth,
        user,
        userWithMissingInfo,
        verificationUUID,
        verifyOtp,
    ]);
    const submitOtpForLogin = useCallback((verificationToken) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!verificationUUID) {
            yield cancelAuth();
            return;
        }
        yield initAuth({
            onError: (error) => setError(error),
            onVerifySuccess: () => {
                isValidatedRef.current = true;
            },
            options: { phone: retryData },
            showSuccessMessage: true,
            verifyFunction: () => __awaiter$1(void 0, void 0, void 0, function* () {
                let sessionPublicKey = undefined;
                if (shouldRegisterSessionKeysOnSignin()) {
                    const keypair = yield generateSessionKey();
                    sessionPublicKey = keypair.publicKey;
                }
                return signInWithSmsVerification({
                    environmentId,
                    sessionPublicKey,
                    verificationToken,
                    verificationUUID,
                });
            }),
        });
    }), [
        verificationUUID,
        initAuth,
        retryData,
        cancelAuth,
        environmentId,
        generateSessionKey,
        shouldRegisterSessionKeysOnSignin,
    ]);
    const { isLoading, mutate: onSubmit } = useMutation(type === 'login' ? submitOtpForLogin : submitOtpForVerification, {
        onFailure: (error) => {
            setError(error);
        },
    });
    return {
        error,
        formattedPhone: formattedPhone !== null && formattedPhone !== void 0 ? formattedPhone : '',
        isLoading,
        isValid: isValidatedRef.current,
        onSubmit,
        retryOneTimePassword,
        setError,
    };
};

const SmsVerification = () => {
    const { view } = useViewContext();
    const { handleLogOut } = useInternalDynamicContext();
    const { t } = useTranslation();
    const isLoginView = view.type === 'login-with-sms-verification';
    const { error, formattedPhone, isLoading, isValid, onSubmit, retryOneTimePassword, setError, } = useSmsVerification(isLoginView ? 'login' : 'verify-only');
    const LogoutButton = !isLoginView ? (jsxRuntimeExports.jsx(TextButton, { className: 'sms-verification__log-out', onClick: handleLogOut, copykey: 'dyn_otp_verification.log_out_button', children: t('dyn_otp_verification.log_out_button') })) : undefined;
    return (jsxRuntimeExports.jsx(OTPVerificationView, { MainIcon: PhoneIcon, displayedDestination: formattedPhone, error: error, hideHeader: true, isLoading: isLoading, onPinComplete: onSubmit, isValid: isValid, retryHandler: retryOneTimePassword, onPinChange: () => setError(undefined), appendToEnd: LogoutButton }));
};

const SocialRedirectView = () => {
    const { socialProvider, signInProvider } = useSocialRedirectContext();
    const findSocialIcon = useFindSocialIcon();
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("div", { className: classNames('social-redirect-view__container'), children: [socialProvider && (jsxRuntimeExports.jsx(IconWithSpinner, { iconSize: 64, Icon: findSocialIcon(socialProvider), isSpinning: true })), jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'title', className: classNames('social-redirect-view__title'), copykey: 'dyn_social_redirect.logging_in', children: t('dyn_social_redirect.logging_in') })] }), signInProvider !== SignInProviderEnum.MagicLink && jsxRuntimeExports.jsx(DynamicFooter, {})] }));
};

const SocialWrongAccountView = () => {
    const [tryAgainClicked, setTryAgainClicked] = useState(false);
    const { socialWalletConnector, socialAccount } = useSocialRedirectContext();
    const { t } = useTranslation();
    const findSocialIcon = useFindSocialIcon();
    if (!socialAccount || !socialWalletConnector)
        return null;
    return (jsxRuntimeExports.jsxs("div", { className: classNames('social-wrong-account-view__container'), children: [jsxRuntimeExports.jsx(IconWithSpinner, { Icon: findSocialIcon(socialAccount.oauthProvider), isSpinning: tryAgainClicked, iconSize: 64 }), jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'title', className: classNames('social-wrong-account-view__title'), copykey: 'dyn_login.wrong_social_account.title', children: t('dyn_login.wrong_social_account.title') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', className: classNames('social-wrong-account-view__copy'), copykey: 'dyn_login.wrong_social_account.subtitle', children: t('dyn_login.wrong_social_account.subtitle') }), jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', weight: 'regular', className: classNames('social-wrong-account-view__copy'), copykey: 'dyn_login.wrong_social_account.retry_title', children: [t('dyn_login.wrong_social_account.retry_title'), jsxRuntimeExports.jsx("b", { children: socialAccount.oauthUsername })] }), jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'social-wrong-account-view__button', buttonVariant: 'primary', buttonPadding: 'large', expanded: true, typographyProps: {
                    variant: 'button_primary',
                    weight: 'medium',
                }, disabled: tryAgainClicked, onClick: () => {
                    setTryAgainClicked(true);
                    socialWalletConnector.connect(socialAccount.oauthProvider);
                }, copykey: 'dyn_login.wrong_social_account.retry_button', children: t('dyn_login.wrong_social_account.retry_button') })] }));
};

const WalletAlreadyExistsView = () => {
    const { selectedWalletConnector: walletConnector } = useInternalDynamicContext();
    const { t } = useTranslation();
    const { data: walletAddress } = usePromise(() => __awaiter$1(void 0, void 0, void 0, function* () {
        const accounts = yield (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.getConnectedAccounts());
        return accounts === null || accounts === void 0 ? void 0 : accounts[0];
    }), {
        deps: [walletConnector],
    });
    const shortenedWalletAddress = shortenWalletAddress(walletAddress);
    return (jsxRuntimeExports.jsxs("div", { className: 'wallet-already-exists-view__container', children: [jsxRuntimeExports.jsx("div", { className: 'wallet-already-exists-view__icon', children: jsxRuntimeExports.jsx(WalletIcon, { icon: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.metadata.icon, walletKey: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.key, width: 64, height: 64 }) }), jsxRuntimeExports.jsx(Typography, { className: 'wallet-already-exists-view__shorten-wallet-address', variant: 'body_normal', weight: 'medium', color: 'primary', children: shortenedWalletAddress }), jsxRuntimeExports.jsx(Typography, { className: 'wallet-already-exists-view__copy', variant: 'body_normal', color: 'secondary', weight: 'regular', children: t('dyn_wallet_link.already_exists.description') })] }));
};

const WalletCannotBeTransferredView = () => {
    const { clearStackAndPushInitialView } = useViewContext();
    const { selectedWalletConnector: walletConnector } = useInternalDynamicContext();
    const { t } = useTranslation();
    const { data: walletAddress } = usePromise(() => __awaiter$1(void 0, void 0, void 0, function* () {
        const accounts = yield (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.getConnectedAccounts());
        return shortenWalletAddress(accounts === null || accounts === void 0 ? void 0 : accounts[0]);
    }), {
        deps: [walletConnector],
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'wallet-cannot-be-transferred-view__container', children: [jsxRuntimeExports.jsx(Typography, { className: 'wallet-cannot-be-transferred-view__title', as: 'h6', variant: 'title', color: 'primary', weight: 'medium', copykey: 'dyn_wallet_link.cannot_link.title', children: t('dyn_wallet_link.cannot_link.title') }), jsxRuntimeExports.jsx("div", { className: 'wallet-cannot-be-transferred-view__icon', children: jsxRuntimeExports.jsx(WalletIcon, { icon: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.metadata.icon, walletKey: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.key, width: 64, height: 64 }) }), jsxRuntimeExports.jsx(Typography, { className: 'wallet-cannot-be-transferred-view__shorten-wallet-address', variant: 'body_normal', weight: 'regular', color: 'primary', children: walletAddress }), jsxRuntimeExports.jsx(Typography, { className: 'wallet-cannot-be-transferred-view__copy', variant: 'body_normal', color: 'secondary', weight: 'regular', copykey: 'dyn_wallet_link.cannot_link.description', children: t('dyn_wallet_link.cannot_link.description') }), jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'wallet-cannot-be-transferred-view__transfer-alt-wallet-button', buttonVariant: 'primary', expanded: true, buttonPadding: 'large', onClick: clearStackAndPushInitialView, dataTestId: 'wallet-cannot-be-transferred-view-transfer-alt-wallet', copykey: 'dyn_wallet_link.cannot_link.link_other_button', children: t('dyn_wallet_link.cannot_link.link_other_button') }), jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'wallet-cannot-be-transferred-view-cancel', buttonPadding: 'small', buttonClassName: 'wallet-cannot-be-transferred-view__cancel', onClick: clearStackAndPushInitialView, copykey: 'dyn_wallet_link.cannot_link.cancel_button', children: t('dyn_wallet_link.cannot_link.cancel_button') })] }));
};

const WalletGroupItem = ({ wallet, onClick, }) => {
    const [supportedChain] = wallet.walletConnector.supportedChains;
    const chainInfo = getChainInfoWithOverrides(supportedChain);
    const labelSettings = getWalletListItemLabel({
        wallet,
    });
    const trailing = (jsxRuntimeExports.jsx(ListTileAnimatedTrailing, { hoverElement: 
        // eslint-disable-next-line react/jsx-wrap-multilines
        jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', size: 'mini', children: jsxRuntimeExports.jsx(SvgStroke, {}) }), children: labelSettings && (jsxRuntimeExports.jsx(Badge, { dot: !labelSettings.isRecommended, variant: labelSettings.isRecommended ? 'primary' : 'secondary', text: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', children: labelSettings.label }) })) }));
    const renderChainIcon = useMemo(() => {
        const iconStyle = { height: pixelToRem(28), width: pixelToRem(28) };
        const ChainIcon = getChainIcon(supportedChain);
        return jsxRuntimeExports.jsx(ChainIcon, { style: iconStyle });
    }, [supportedChain]);
    const renderChainName = (chainInfo === null || chainInfo === void 0 ? void 0 : chainInfo.displayName) || wallet.name;
    return (jsxRuntimeExports.jsx(ListTile, { className: 'chain-card', onClick: onClick, leading: renderChainIcon, trailing: trailing, children: renderChainName }, wallet.key));
};

const WalletGroupView = ({ onSelectWallet, }) => {
    var _a;
    const { selectedWalletGroup } = useWalletGroupContext();
    const walletGroups = useWalletGroups();
    const { t } = useTranslation();
    if (!selectedWalletGroup)
        throw new Error('Could not access WalletGroup view without selected group');
    const walletGroupData = walletGroups[selectedWalletGroup.key];
    if (!walletGroupData)
        throw new Error('Could not find group');
    const hardwareWalletConnectors = selectedWalletGroup.groupedWallets
        .map(({ walletConnector }) => walletConnector)
        .filter((connector) => isHardwareWalletConnector(connector) &&
        connector.canConnectWithHardwareWallet());
    return (jsxRuntimeExports.jsx(WalletGroupViewLayout, { icon: 
        // eslint-disable-next-line react/jsx-wrap-multilines
        jsxRuntimeExports.jsx(WalletIcon, { walletKey: walletGroupData.key, isGroup: true, icon: (_a = walletGroupData.brand) === null || _a === void 0 ? void 0 : _a.icon }), title: t('dyn_select_chain.description'), titleCopyKey: 'dyn_select_chain.description', children: jsxRuntimeExports.jsxs("div", { className: 'wallet-group__list', children: [Boolean(hardwareWalletConnectors.length) && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(HardwareWalletToggle, { connectors: hardwareWalletConnectors, copykey: 'dyn_select_chain.using_hardware_wallet_toggle_label', label: t('dyn_select_chain.using_hardware_wallet_toggle_label') }), jsxRuntimeExports.jsx(Divider, {})] })), jsxRuntimeExports.jsx("div", { className: 'wallet-group-view-layout__list', children: selectedWalletGroup.groupedWallets.map((wallet, index) => (jsxRuntimeExports.jsx(WalletGroupItem, { wallet: wallet, onClick: () => onSelectWallet(wallet) }, `${wallet.key}_${index}`))) })] }) }));
};

const WalletListForDefaultConnection = ({ isWalletConnectList }) => {
    const { handleWalletItemClick } = useWalletItemActions();
    const { showDefaultFooter } = useAuthLayoutChecks();
    return (jsxRuntimeExports.jsx(WalletList, { onSelectWallet: handleWalletItemClick, isWalletConnectList: isWalletConnectList, showDefaultFooter: showDefaultFooter }));
};

const iconSize = 64;
const WalletLockedView = () => {
    const { handleLogOut, primaryWallet, setShowAuthFlow, appName } = useInternalDynamicContext();
    const { t } = useTranslation();
    if (!primaryWallet) {
        return null;
    }
    const handleConnectWallet = () => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            yield primaryWallet.connector.connect();
            setShowAuthFlow(false);
        }
        catch (_a) {
            logger$1.info('could not connect wallet');
        }
    });
    const icon = (jsxRuntimeExports.jsx(WalletIcon, { icon: primaryWallet.connector.metadata.icon, walletKey: primaryWallet.connector.key, style: {
            height: pixelToRem(iconSize * iconRatio),
            width: pixelToRem(iconSize * iconRatio),
        } }));
    return (jsxRuntimeExports.jsxs("div", { "data-testid": 'wallet-locked-view', children: [jsxRuntimeExports.jsx(ErrorContainer, { withIcon: false, variant: 'success', className: 'wallet-locked-view__error-container', copykey: 'dyn_wallet_locked.connect_continue', children: t('dyn_wallet_locked.connect_continue') }), jsxRuntimeExports.jsxs("div", { className: 'wallet-locked-view__content', children: [jsxRuntimeExports.jsx(IconWithSpinner, { Icon: icon, iconSize: iconSize, className: 'wallet-locked-view__icon', isSpinning: true }), jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', weight: 'medium', className: 'wallet-locked-view__title', copykey: 'dyn_wallet_locked.title', children: t('dyn_wallet_locked.title') }), jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', color: 'secondary', weight: 'regular', copykey: 'dyn_wallet_locked.subtitle', children: [t('dyn_wallet_locked.subtitle'), appName, "."] }), jsxRuntimeExports.jsx(TypographyButton, { onClick: () => handleConnectWallet(), buttonClassName: 'wallet-locked-view__button', copykey: 'dyn_wallet_locked.connect', children: t('dyn_wallet_locked.connect') }), jsxRuntimeExports.jsx(Divider, { text: 'Or' }), jsxRuntimeExports.jsx(TextButton, { className: 'wallet-locked-view__log-out', onClick: handleLogOut, copykey: 'dyn_wallet_locked.logout', children: t('dyn_wallet_locked.logout') })] })] }));
};

const WalletRedirectView = () => {
    const { t } = useTranslation();
    const { selectedWalletConnector } = useInternalDynamicContext();
    return (jsxRuntimeExports.jsxs("div", { className: classNames('wallet-redirect-view__container'), children: [selectedWalletConnector && (jsxRuntimeExports.jsx(IconWithSpinner, { iconSize: 64, Icon: 
                // eslint-disable-next-line react/jsx-wrap-multilines
                jsxRuntimeExports.jsx(WalletIcon, { icon: selectedWalletConnector.metadata.icon, walletKey: selectedWalletConnector.key }), isSpinning: true })), jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'title', className: classNames('wallet-redirect-view__title'), copykey: 'dyn_wallet_redirect.loading', children: t('dyn_wallet_redirect.loading') }), jsxRuntimeExports.jsx(PoweredByDynamic, { classNameRoot: 'powered-by-dynamic' })] }));
};

const WalletSignSpinnerView = () => {
    const { clearStackAndPushInitialView } = useViewContext();
    const { t } = useTranslation();
    const { setMultiWalletWidgetState, setSelectedWalletConnectorKey, selectedWalletConnector: walletConnector, } = useInternalDynamicContext();
    if (!walletConnector) {
        return null;
    }
    const { key, metadata } = walletConnector;
    const iconSize = 96;
    const handleClose = () => __awaiter$1(void 0, void 0, void 0, function* () {
        clearStackAndPushInitialView();
        setMultiWalletWidgetState('idle');
        setSelectedWalletConnectorKey(null);
        yield (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.endSession());
    });
    const icon = (jsxRuntimeExports.jsx(WalletIcon, { icon: metadata.icon, walletKey: key, style: {
            height: pixelToRem(iconSize * iconRatio),
            width: pixelToRem(iconSize * iconRatio),
        } }));
    return (jsxRuntimeExports.jsxs("div", { className: 'wallet-sign-spinner__container', "data-testid": 'wallet-sign-spinner-view', children: [jsxRuntimeExports.jsx(IconWithSpinner, { Icon: icon, iconSize: iconSize, isSpinning: true }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', className: classNames('wallet-sign-spinner__copy'), copykey: 'dyn_wallet_transfer.sign.spinner.confirm_transfer', children: t('dyn_wallet_transfer.sign.spinner.confirm_transfer') }), jsxRuntimeExports.jsx(TypographyButton, { expanded: true, buttonPadding: 'large', buttonVariant: 'primary', buttonClassName: 'wallet-sign-spinner__button', onClick: () => handleClose(), typographyProps: {
                    variant: 'button_primary',
                    weight: 'medium',
                }, copykey: 'dyn_wallet_transfer.sign.spinner.cancel', children: t('dyn_wallet_transfer.sign.spinner.cancel') })] }));
};

const useTransferWallet = () => {
    const { displaySiweStatement, environmentId, user, primaryWallet } = useInternalDynamicContext();
    const { addedWalletsIds } = useInternalUserWallets();
    const updatePrimaryWallet = useCallback((walletConnector, user) => {
        const newWalletKey = walletConnector.key;
        if (user.lastVerifiedCredentialId) {
            if (!primaryWallet) {
                updatePrimaryWalletId(user.lastVerifiedCredentialId);
                return;
            }
            const currentPrimaryWalletKey = primaryWallet.connector.key;
            if (newWalletKey === currentPrimaryWalletKey) {
                updatePrimaryWalletId(user.lastVerifiedCredentialId);
            }
            // if both wallets are flow wallets, set the last verified wallet as primary
            // this is a limitation of flow as all wallets use the same flow connector
            if (primaryWallet.connector.connectedChain === 'FLOW' &&
                walletConnector.connectedChain === 'FLOW') {
                updatePrimaryWalletId(user.lastVerifiedCredentialId);
            }
        }
    }, [primaryWallet]);
    return useCallback((props) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!user)
            throw new DynamicError(USER_NOT_LOGGED_IN);
        const { overrideSiweStatement, walletConnector } = props;
        const args = Object.assign(Object.assign({}, props), { displaySiweStatement,
            environmentId, siweStatement: overrideSiweStatement, walletProvider: getWalletProvider(walletConnector) });
        const verifyArgs = yield getVerifyArgs(args);
        const userProfile = yield transferWallet(environmentId, verifyArgs);
        if (!userProfile) {
            throw new DynamicError('Error transferring wallet.');
        }
        updatePrimaryWallet(walletConnector, userProfile);
        const walletId = userProfile.lastVerifiedCredentialId;
        if (walletId) {
            addedWalletsIds.current.push(walletId);
        }
    }), [
        addedWalletsIds,
        displaySiweStatement,
        environmentId,
        updatePrimaryWallet,
        user,
    ]);
};

const WalletUsedView = () => {
    const [isChecked, setIsChecked] = useState(false);
    const { t } = useTranslation();
    const { loading, setLoading } = useLoadingContext();
    const { pushView } = useViewContext();
    const { setShowAuthFlow, appName, siweStatement, setMultiWalletWidgetState, connectWallet, selectedWalletConnector: walletConnector, isSingleWalletAccount, handleLogOut, } = useInternalDynamicContext();
    const { data: walletAddress } = usePromise(() => __awaiter$1(void 0, void 0, void 0, function* () {
        const accounts = yield (walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.getConnectedAccounts());
        return accounts === null || accounts === void 0 ? void 0 : accounts[0];
    }), {
        deps: [walletConnector],
    });
    const shortenedWalletAddress = shortenWalletAddress(walletAddress);
    const completeWalletTransfer = useTransferWallet();
    const handleWalletTransfer = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!walletConnector)
            return;
        setMultiWalletWidgetState('awaiting_signature', undefined, 'transferring_wallet');
        setLoading(true);
        pushView('wallet-sign');
        const siweStatementToUse = getSiweStatement({ appName, siweStatement });
        // TODO refactor this block
        try {
            const connectionResult = yield connectWallet(walletConnector);
            if (!(connectionResult === null || connectionResult === void 0 ? void 0 : connectionResult.address)) {
                return;
            }
            // We need to set to LS when about to transfer phantom wallet on mobile
            // because the deeplink interrupts this code execution and then redirects back on a new tab.
            // This resets all state (except for LS obviously). When we receive the phantom signature in this new tab,
            // we can't tell whether it's supposed to be used to sign a message, verify a wallet sign in/link,
            // or conclude the transfer, which is why we need this LS variable: it will indicate whether it
            // is a signature, authentication or transfer.
            // Check method handleUserResponse in file useResponseHandlers, case 'signMessage'.
            if (walletConnector.key === 'phantom' && isMobile()) {
                StorageService.setItem(PHANTOM_SIGNATURE_STATE, {
                    loseOriginalAccountOnTransfer: isChecked,
                    submittedAtTimestamp: new Date().toString(),
                    verificationType: 'awaiting_transfer',
                });
            }
            yield completeWalletTransfer({
                overrideSiweStatement: siweStatementToUse,
                publicWalletAddress: connectionResult.address,
                skipEmptyAccountCheck: isChecked,
                walletConnector,
            });
            setShowAuthFlow(false);
        }
        catch (error) {
            logger$1.error(error);
            setShowAuthFlow(false, { emitCancelAuth: true });
        }
        finally {
            setLoading(false);
            setMultiWalletWidgetState('idle');
        }
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'wallet-used-view__container', children: [jsxRuntimeExports.jsx("div", { className: 'wallet-used-view__icon', children: jsxRuntimeExports.jsx(WalletIcon, { icon: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.metadata.icon, walletKey: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.key, width: 64, height: 64 }) }), jsxRuntimeExports.jsx(Typography, { className: 'wallet-used-view__shorten-wallet-address', variant: 'body_normal', weight: 'medium', color: 'primary', children: shortenedWalletAddress }), jsxRuntimeExports.jsx(Typography, { className: 'wallet-used-view__copy', variant: 'body_normal', color: 'secondary', weight: 'regular', copykey: 'dyn_wallet_link.existent_account.warning', children: t('dyn_wallet_link.existent_account.warning') }), isSingleWalletAccount && (jsxRuntimeExports.jsxs("label", { htmlFor: 'skipEmptyAccountCheck', className: 'wallet-used-view__checkbox-label', children: [jsxRuntimeExports.jsx(Checkbox, { id: 'skipEmptyAccountCheck', className: 'wallet-used-view__checkbox-container', defaultChecked: isChecked, onChange: () => setIsChecked(!isChecked), ariaLabel: 'skip empty account check' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', copykey: 'dyn_wallet_link.existent_account.acceptance', children: t('dyn_wallet_link.existent_account.acceptance') })] })), jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'wallet-used-view__accept-button', buttonVariant: 'primary', expanded: true, buttonPadding: 'large', onClick: () => handleWalletTransfer(), disabled: (!isChecked && isSingleWalletAccount) || loading, dataTestId: 'wallet-used-view-transfer-wallet', copykey: 'dyn_wallet_link.confirm_button', children: t('dyn_wallet_link.confirm_button') }), jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'wallet-used-view-log-out', buttonPadding: 'small', buttonClassName: 'wallet-used-view__logout', onClick: handleLogOut, copykey: 'dyn_wallet_link.log_out_button', children: t('dyn_wallet_link.log_out_button') })] }));
};

var _path$j;
var _excluded$j = ["title", "titleId"];
function _extends$j() { return _extends$j = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$j.apply(null, arguments); }
function _objectWithoutProperties$j(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$j(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$j(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgDomain = function SvgDomain(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$j(_ref, _excluded$j);
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 64c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32C14.827 0 .5 14.327.5 32c0 17.673 14.327 32 32 32Zm-4.928-29.305h9.717c-.207 4.908-1.087 9.168-2.3 12.206-.7 1.756-1.433 2.9-2.036 3.54-.245.26-.42.387-.523.448-.102-.06-.277-.189-.522-.449-.603-.638-1.336-1.783-2.037-3.539-1.213-3.038-2.092-7.298-2.3-12.206Zm2.3-16.655c-1.242 3.108-2.134 7.497-2.314 12.55h9.744c-.18-5.053-1.071-9.442-2.313-12.55-.7-1.756-1.433-2.9-2.036-3.54-.245-.26-.42-.388-.523-.449-.102.061-.277.19-.522.45-.603.638-1.336 1.783-2.037 3.539ZM14.5 30.59h8.951c.216-6.53 1.541-12.27 3.503-16.036C20.23 16.789 15.22 23.03 14.5 30.59Zm.036 4.105h8.928c.25 6.387 1.563 11.993 3.49 15.692-6.622-2.201-11.582-8.288-12.418-15.692Zm35.789 0h-8.928c-.25 6.387-1.563 11.993-3.49 15.692 6.621-2.201 11.581-8.288 12.418-15.692Zm.125-2.224v.066-.133.066Zm-9.04-1.88h8.95c-.719-7.56-5.73-13.802-12.454-16.037 1.962 3.766 3.288 9.507 3.503 16.036Zm-9.09 20.35c0-.001.008-.004.023-.007-.015.006-.023.008-.023.007Zm.198-.007a.072.072 0 0 1 .023.007s-.008-.001-.023-.007ZM32.541 14s-.008.004-.023.007c.015-.006.023-.008.023-.007Zm-.198.007A.068.068 0 0 1 32.32 14s.008.001.023.007Z",
    fill: "#4779FF"
  })));
};

const PasskeyNewDomainDetectedView = () => {
    const { t } = useTranslation();
    const { projectSettings } = useInternalDynamicContext();
    const supportedAuthenticators = useMemo(() => {
        var _a;
        const supportedAuths = getEnabledEmbeddedWalletsAuthenticators((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _a === void 0 ? void 0 : _a.supportedSecurityMethods);
        return Object.keys(supportedAuths).filter((auth) => auth !== 'email');
    }, [projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets]);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(ModalHeader, { children: jsxRuntimeExports.jsx(Typography, { as: 'h1', variant: 'title', color: 'primary', "data-testid": 'dynamic-auth-modal-heading', className: 'header__typography', copykey: 'dyn_passkey_new_domain_detected.title', children: t('dyn_passkey_new_domain_detected.title') }) }), jsxRuntimeExports.jsxs("div", { className: 'passkey-new-domain-detected', children: [jsxRuntimeExports.jsx(SvgDomain, { className: 'passkey-new-domain-detected__header' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', weight: 'regular', color: 'secondary', children: t('dyn_passkey_new_domain_detected.description') }), jsxRuntimeExports.jsx(EmbeddedAuthChoiceCards, { supportedAuthenticators: supportedAuthenticators }), jsxRuntimeExports.jsx(NeedHelpSection, { isRecoveryFlow: true })] })] }));
};

const viewToComponentMap = {
    'access-blocked': AccessBlockedView,
    'account-exists': AccountExistsView,
    'bridge-next-wallet-connection': BridgeNextWalletConnectionView,
    'bridge-summary': BridgeSummaryView,
    'bridge-welcome': BridgeWelcomeView,
    captcha: CaptchaVerifyUser,
    'chainalysis-blocked-wallet': NoAccess,
    'collect-user-data': CollectUserDataView,
    'collect-user-data-login-no-wallet': CollectUserDataViewNoWallet,
    'email-wallet-otp-verification-view': EmailWalletOTPVerificationView,
    'embedded-delete-view': EmbeddedDeleteView,
    'embedded-reveal-account-view': EmbeddedRevealView,
    'embedded-reveal-view': EmbeddedRevealView,
    'embedded-wallet-auth-choice': EmbeddedAuthChoice,
    'embedded-wallet-exists': WalletAlreadyExistsView,
    'external-funding-wallet-list': WalletList,
    'farcaster-connect-view': FarcasterConnectView,
    'gate-blocked-wallet': NoAccess,
    'global-wallet-confirm': GlobalWalletConfirmView,
    'global-wallet-info': GlobalWalletInfoView,
    'global-wallet-malicious': GlobalWalletMaliciousView,
    'login-with-email-or-wallet': LoginView,
    'login-with-email-or-wallet-full-wallet-list': WalletListForDefaultConnection,
    'login-with-email-verification': EmailVerification,
    'login-with-sms-verification': SmsVerification,
    'login-with-wallet-only': LoginView,
    'merge-user-accounts': MergeUserAccountsView,
    'merge-user-accounts-conflicts': MergeUserAccountsConflictsView,
    'merge-user-accounts-with-same-email': MergeUserAccountsWithSameEmailView,
    'mfa-choose-device': MfaChooseDeviceView,
    'mfa-display-backup-codes': MfaDisplayBackupCodesView,
    'mfa-recovery': MfaRecoveryView,
    'mfa-secure-device': MfaSecureDeviceView,
    'mfa-secure-device-help': MfaSecureDeviceHelper,
    'mfa-verification': MfaVerificationView,
    'mobile-wallet-redirect-view': MobileWalletRedirectView,
    'multi-wallet-wallet-list': WalletListForDefaultConnection,
    'network-not-supported': NetworkNotSupported,
    'network-not-supported-manual': NetworkNotSupportedSwitchManual,
    'no-access': NoAccess,
    'no-qr-not-installed': NoQrNotInstalledView,
    'passkey-intro': PasskeyIntroView,
    'passkey-new-domain-detected': PasskeyNewDomainDetectedView,
    'passkey-recovery-add-email': AddRecoveryEmail,
    'passkey-recovery-bundle': PasskeyBundleRecovery,
    'passkey-recovery-complete': PasskeyCompleteRecovery,
    'passkey-recovery-start': PasskeyInitRecovery,
    'pending-connect': PendingConnectView,
    'pending-signature': PendingSignatureView,
    'pending-signature-without-back-button': PendingSignatureView,
    'qr-code': QrCodeView,
    'rename-passkey': RenamePasskeyView,
    'sandbox-maximum-threshold-reached': SandboxMaximumThresholdReached,
    'select-hardware-wallet': SelectHardwareWalletView,
    'select-wallet-in-wallet-group': SelectWalletInWalletGroupView,
    'social-redirect-view': SocialRedirectView,
    'social-wrong-account': SocialWrongAccountView,
    'verify-email': EmailVerification,
    'verify-sms': SmsVerification,
    'wait-for-email-confirmation-view': EmailConfirmationWaitingView,
    'wallet-cannot-be-transferred': WalletCannotBeTransferredView,
    'wallet-connect-mobile-wallets-list': () => (jsxRuntimeExports.jsx(WalletListForDefaultConnection, { isWalletConnectList: true })),
    'wallet-group': WalletGroupView,
    'wallet-list': WalletListForDefaultConnection,
    'wallet-locked-view': WalletLockedView,
    'wallet-redirect-view': WalletRedirectView,
    'wallet-sign': WalletSignSpinnerView,
    'wallet-used': WalletUsedView,
};

const RenderView = () => {
    const { view } = useViewContext();
    const Component = viewToComponentMap[view.type];
    return jsxRuntimeExports.jsx(Component, Object.assign({}, (view.props || {})));
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "@layer dynamic-sdk-styles{#argent-mobile-modal-overlay,iframe[src*=\"wallet-dev.blocto.app\"],iframe[src*=\"wallet-staging.blocto.app\"],iframe[src*=\"wallet-testnet.blocto.app\"],iframe[src*=\"wallet.blocto.app\"]{z-index:2147483647!important}iframe[id*=dyn-passkey-recovery-element-id],iframe[id*=dyn-secure-enclave-element-id]{display:none!important}#pera-wallet-connect-modal-wrapper{position:relative;z-index:2147483647!important}@font-face{font-display:swap;font-family:DM Sans;font-style:normal;font-weight:400;src:url(https://cdn.jsdelivr.net/npm/@fontsource/dm-sans/files/dm-sans-latin-400-normal.woff2) format(\"woff2\"),url(https://cdn.jsdelivr.net/npm/@fontsource/dm-sans/files/dm-sans-latin-400-normal.woff) format(\"woff\")}@font-face{font-display:swap;font-family:DM Sans;font-style:italic;font-weight:400;src:url(https://cdn.jsdelivr.net/npm/@fontsource/dm-sans/files/dm-sans-latin-400-italic.woff2) format(\"woff2\"),url(https://cdn.jsdelivr.net/npm/@fontsource/dm-sans/files/dm-sans-latin-400-italic.woff) format(\"woff\")}@font-face{font-display:swap;font-family:DM Sans;font-style:normal;font-weight:500;src:url(https://cdn.jsdelivr.net/npm/@fontsource/dm-sans/files/dm-sans-latin-500-normal.woff2) format(\"woff2\"),url(https://cdn.jsdelivr.net/npm/@fontsource/dm-sans/files/dm-sans-latin-500-normal.woff) format(\"woff\")}@font-face{font-display:swap;font-family:DM Sans;font-style:italic;font-weight:500;src:url(https://cdn.jsdelivr.net/npm/@fontsource/dm-sans/files/dm-sans-latin-500-italic.woff2) format(\"woff2\"),url(https://cdn.jsdelivr.net/npm/@fontsource/dm-sans/files/dm-sans-latin-500-italic.woff) format(\"woff\")}@font-face{font-display:swap;font-family:DM Sans;font-style:normal;font-weight:700;src:url(https://cdn.jsdelivr.net/npm/@fontsource/dm-sans/files/dm-sans-latin-700-normal.woff2) format(\"woff2\"),url(https://cdn.jsdelivr.net/npm/@fontsource/dm-sans/files/dm-sans-latin-700-normal.woff) format(\"woff\")}@font-face{font-display:swap;font-family:DM Sans;font-style:italic;font-weight:700;src:url(https://cdn.jsdelivr.net/npm/@fontsource/dm-sans/files/dm-sans-latin-700-italic.woff2) format(\"woff2\"),url(https://cdn.jsdelivr.net/npm/@fontsource/dm-sans/files/dm-sans-latin-700-italic.woff) format(\"woff\")}@layer light-theme-default{:root{--dynamic-font-family-primary:\"DM Sans\",sans-serif;--dynamic-font-family-numbers:\"Roboto Mono\",monospace,sans-serif;--dynamic-base-1:#f7f7f9;--dynamic-base-2:#fff;--dynamic-base-3:#eeeef1;--dynamic-base-4:#e7e8ed;--dynamic-brand-hover-color:linear-gradient(0deg,rgba(0,0,0,.08),rgba(0,0,0,.08)),#4779ff;--dynamic-brand-primary-color:#4779ff;--dynamic-brand-secondary-color:rgba(71,121,255,.15);--dynamic-success-1:#30a67b;--dynamic-success-2:#e3f7ef;--dynamic-border-radius:1.5rem;--dynamic-hover:rgba(22,37,77,.03);--dynamic-info-2:rgba(71,121,255,.1);--dynamic-error-1:#ff4646;--dynamic-error-2:rgba(255,70,70,.1);--dynamic-alert-1:#dd8500;--dynamic-alert-2:#faedd9;--dynamic-footer-background-color:#fff;--dynamic-footer-text-color:#383c48;--dynamic-footer-icon-color:#4779ff;--dynamic-loading-animation-gradient:linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.2) 20%,hsla(0,0%,100%,.5) 60%,hsla(0,0%,100%,0));--dynamic-overlay:rgba(24,27,34,.15);--dynamic-shadow-down-1:0 0.0625rem 0.125rem rgba(24,39,75,.04);--dynamic-shadow-down-2:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-shadow-down-3:0 1.5rem 2rem -1.5rem rgba(0,0,0,.24);--dynamic-shadow-up-1:0 -0.5rem 3rem -0.5rem rgba(109,121,165,.16);--dynamic-text-link:#0047ff;--dynamic-text-primary:#383c48;--dynamic-text-secondary:#7b7d86;--dynamic-text-size-body-mini:0.6875rem;--dynamic-text-size-body-normal:0.9375rem;--dynamic-text-size-body-small:0.75rem;--dynamic-text-size-button-primary:0.875rem;--dynamic-text-size-button-secondary:0.75rem;--dynamic-text-size-numbers-big:0.875rem;--dynamic-text-size-numbers-medium:0.75rem;--dynamic-text-size-title:1.125rem;--dynamic-text-tertiary:#abacb2;--dynamic-badge-background:#eeeef1;--dynamic-badge-color:#7b7d86;--dynamic-badge-primary-background:#e3f7ef;--dynamic-badge-primary-color:#30a67b;--dynamic-badge-dot-background:#4779ff;--dynamic-search-bar-background:#fff;--dynamic-search-bar-background-hover:#fff;--dynamic-search-bar-background-focus:#fff;--dynamic-search-bar-border:0.0625rem solid #eeeef1;--dynamic-search-bar-border-hover:0.0625rem solid #e7e8ed;--dynamic-search-bar-border-focus:0.0625rem solid #e7e8ed;--dynamic-modal-border: ;--dynamic-modal-width:22.5rem;--dynamic-modal-padding:1.5rem;--dynamic-modal-backdrop-background:rgba(0,0,0,.25);--dynamic-modal-backdrop-filter:blur(4px);--dynamic-wallet-list-tile-padding:0.75rem;--dynamic-wallet-list-tile-gap:0.375rem;--dynamic-wallet-list-max-height:16.25rem;--dynamic-wallet-list-tile-background:#fff;--dynamic-wallet-list-tile-border: ;--dynamic-wallet-list-tile-shadow:0 0.0625rem 0.125rem rgba(24,39,75,.04);--dynamic-wallet-list-tile-background-hover:#fff;--dynamic-wallet-list-tile-border-hover: ;--dynamic-wallet-list-tile-shadow-hover:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-wallet-list-tile-animation-duration:150ms;--dynamic-tooltip-color:#383c48;--dynamic-tooltip-text-color:#fff;--dynamic-initial-view-content-padding:0rem 1.5rem 1.5rem;--dynamic-button-primary-hover:#fff;--dynamic-button-primary-background:#fff;--dynamic-button-primary-font-size:0.875rem;--dynamic-button-primary-padding:0;--dynamic-button-primary-border:0.0625rem solid #e7e8ed;--dynamic-button-shadow:0px 2px 3px 0px rgba(24,39,75,.08);--dynamic-button-secondary-hover:#f7f8fa;--dynamic-button-secondary-background:transparent;--dynamic-button-secondary-font-size:0.75rem;--dynamic-button-secondary-padding:0;--dynamic-button-secondary-border:0.0625rem solid transparent;--dynamic-connect-button-background:#fff;--dynamic-connect-button-background-hover:#fff;--dynamic-connect-button-color:#383c48;--dynamic-connect-button-border:0.0625rem solid #e7e8ed;--dynamic-connect-button-shadow:0px 2px 3px 0px rgba(24,39,75,.08);--dynamic-connect-button-color-hover:#383c48;--dynamic-connect-button-border-hover:0.0625rem solid #e7e8ed;--dynamic-connect-button-shadow-hover:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-search-padding:0 1.5rem 0.5rem;--dynamic-layout-content-padding:0 1.5rem 1.5rem;--dynamic-layout-content-error-padding:1.5rem 1.5rem 1.5rem;--dynamic-footer-border-top:0.0625rem solid #e7e8ed;--dynamic-footer-padding:0.75rem 1.5rem 0.75rem;--dynamic-footer-background:transparent;--dynamic-header-border-bottom:1px solid transparent;--dynamic-header-padding:1.5rem 1.5rem 1.25rem;--dynamic-header-background:transparent}:root [data-dynamic-theme-brand=bold],:root[data-dynamic-theme-brand=bold]{--dynamic-footer-text-color:#fff;--dynamic-footer-icon-color:rgba(247,247,249,.75);--dynamic-footer-arrow-color:rgba(247,247,249,.75)}:root [data-dynamic-theme-brand=subtle],:root[data-dynamic-theme-brand=subtle]{--dynamic-footer-arrow-color:#abacb2}@media (prefers-color-scheme:light){:root [data-dynamic-theme=auto]{--dynamic-font-family-primary:\"DM Sans\",sans-serif;--dynamic-font-family-numbers:\"Roboto Mono\",monospace,sans-serif;--dynamic-base-1:#f7f7f9;--dynamic-base-2:#fff;--dynamic-base-3:#eeeef1;--dynamic-base-4:#e7e8ed;--dynamic-brand-hover-color:linear-gradient(0deg,rgba(0,0,0,.08),rgba(0,0,0,.08)),#4779ff;--dynamic-brand-primary-color:#4779ff;--dynamic-brand-secondary-color:rgba(71,121,255,.15);--dynamic-success-1:#30a67b;--dynamic-success-2:#e3f7ef;--dynamic-border-radius:1.5rem;--dynamic-hover:rgba(22,37,77,.03);--dynamic-info-2:rgba(71,121,255,.1);--dynamic-error-1:#ff4646;--dynamic-error-2:rgba(255,70,70,.1);--dynamic-alert-1:#dd8500;--dynamic-alert-2:#faedd9;--dynamic-footer-background-color:#fff;--dynamic-footer-text-color:#383c48;--dynamic-footer-icon-color:#4779ff;--dynamic-loading-animation-gradient:linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.2) 20%,hsla(0,0%,100%,.5) 60%,hsla(0,0%,100%,0));--dynamic-overlay:rgba(24,27,34,.15);--dynamic-shadow-down-1:0 0.0625rem 0.125rem rgba(24,39,75,.04);--dynamic-shadow-down-2:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-shadow-down-3:0 1.5rem 2rem -1.5rem rgba(0,0,0,.24);--dynamic-shadow-up-1:0 -0.5rem 3rem -0.5rem rgba(109,121,165,.16);--dynamic-text-link:#0047ff;--dynamic-text-primary:#383c48;--dynamic-text-secondary:#7b7d86;--dynamic-text-size-body-mini:0.6875rem;--dynamic-text-size-body-normal:0.9375rem;--dynamic-text-size-body-small:0.75rem;--dynamic-text-size-button-primary:0.875rem;--dynamic-text-size-button-secondary:0.75rem;--dynamic-text-size-numbers-big:0.875rem;--dynamic-text-size-numbers-medium:0.75rem;--dynamic-text-size-title:1.125rem;--dynamic-text-tertiary:#abacb2;--dynamic-badge-background:#eeeef1;--dynamic-badge-color:#7b7d86;--dynamic-badge-primary-background:#e3f7ef;--dynamic-badge-primary-color:#30a67b;--dynamic-badge-dot-background:#4779ff;--dynamic-search-bar-background:#fff;--dynamic-search-bar-background-hover:#fff;--dynamic-search-bar-background-focus:#fff;--dynamic-search-bar-border:0.0625rem solid #eeeef1;--dynamic-search-bar-border-hover:0.0625rem solid #e7e8ed;--dynamic-search-bar-border-focus:0.0625rem solid #e7e8ed;--dynamic-modal-border: ;--dynamic-modal-width:22.5rem;--dynamic-modal-padding:1.5rem;--dynamic-modal-backdrop-background:rgba(0,0,0,.25);--dynamic-modal-backdrop-filter:blur(4px);--dynamic-wallet-list-tile-padding:0.75rem;--dynamic-wallet-list-tile-gap:0.375rem;--dynamic-wallet-list-max-height:16.25rem;--dynamic-wallet-list-tile-background:#fff;--dynamic-wallet-list-tile-border: ;--dynamic-wallet-list-tile-shadow:0 0.0625rem 0.125rem rgba(24,39,75,.04);--dynamic-wallet-list-tile-background-hover:#fff;--dynamic-wallet-list-tile-border-hover: ;--dynamic-wallet-list-tile-shadow-hover:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-wallet-list-tile-animation-duration:150ms;--dynamic-tooltip-color:#383c48;--dynamic-tooltip-text-color:#fff;--dynamic-initial-view-content-padding:0rem 1.5rem 1.5rem;--dynamic-button-primary-hover:#fff;--dynamic-button-primary-background:#fff;--dynamic-button-primary-font-size:0.875rem;--dynamic-button-primary-padding:0;--dynamic-button-primary-border:0.0625rem solid #e7e8ed;--dynamic-button-shadow:0px 2px 3px 0px rgba(24,39,75,.08);--dynamic-button-secondary-hover:#f7f8fa;--dynamic-button-secondary-background:transparent;--dynamic-button-secondary-font-size:0.75rem;--dynamic-button-secondary-padding:0;--dynamic-button-secondary-border:0.0625rem solid transparent;--dynamic-connect-button-background:#fff;--dynamic-connect-button-background-hover:#fff;--dynamic-connect-button-color:#383c48;--dynamic-connect-button-border:0.0625rem solid #e7e8ed;--dynamic-connect-button-shadow:0px 2px 3px 0px rgba(24,39,75,.08);--dynamic-connect-button-color-hover:#383c48;--dynamic-connect-button-border-hover:0.0625rem solid #e7e8ed;--dynamic-connect-button-shadow-hover:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-search-padding:0 1.5rem 0.5rem;--dynamic-layout-content-padding:0 1.5rem 1.5rem;--dynamic-layout-content-error-padding:1.5rem 1.5rem 1.5rem;--dynamic-footer-border-top:0.0625rem solid #e7e8ed;--dynamic-footer-padding:0.75rem 1.5rem 0.75rem;--dynamic-footer-background:transparent;--dynamic-header-border-bottom:1px solid transparent;--dynamic-header-padding:1.5rem 1.5rem 1.25rem;--dynamic-header-background:transparent}:root [data-dynamic-theme=auto] [data-dynamic-theme-brand=bold],:root [data-dynamic-theme=auto][data-dynamic-theme-brand=bold]{--dynamic-footer-text-color:#fff;--dynamic-footer-icon-color:rgba(247,247,249,.75);--dynamic-footer-arrow-color:rgba(247,247,249,.75)}:root [data-dynamic-theme=auto] [data-dynamic-theme-brand=subtle],:root [data-dynamic-theme=auto][data-dynamic-theme-brand=subtle]{--dynamic-footer-arrow-color:#abacb2}}:root [data-dynamic-theme=light]{--dynamic-font-family-primary:\"DM Sans\",sans-serif;--dynamic-font-family-numbers:\"Roboto Mono\",monospace,sans-serif;--dynamic-base-1:#f7f7f9;--dynamic-base-2:#fff;--dynamic-base-3:#eeeef1;--dynamic-base-4:#e7e8ed;--dynamic-brand-hover-color:linear-gradient(0deg,rgba(0,0,0,.08),rgba(0,0,0,.08)),#4779ff;--dynamic-brand-primary-color:#4779ff;--dynamic-brand-secondary-color:rgba(71,121,255,.15);--dynamic-success-1:#30a67b;--dynamic-success-2:#e3f7ef;--dynamic-border-radius:1.5rem;--dynamic-hover:rgba(22,37,77,.03);--dynamic-info-2:rgba(71,121,255,.1);--dynamic-error-1:#ff4646;--dynamic-error-2:rgba(255,70,70,.1);--dynamic-alert-1:#dd8500;--dynamic-alert-2:#faedd9;--dynamic-footer-background-color:#fff;--dynamic-footer-text-color:#383c48;--dynamic-footer-icon-color:#4779ff;--dynamic-loading-animation-gradient:linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.2) 20%,hsla(0,0%,100%,.5) 60%,hsla(0,0%,100%,0));--dynamic-overlay:rgba(24,27,34,.15);--dynamic-shadow-down-1:0 0.0625rem 0.125rem rgba(24,39,75,.04);--dynamic-shadow-down-2:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-shadow-down-3:0 1.5rem 2rem -1.5rem rgba(0,0,0,.24);--dynamic-shadow-up-1:0 -0.5rem 3rem -0.5rem rgba(109,121,165,.16);--dynamic-text-link:#0047ff;--dynamic-text-primary:#383c48;--dynamic-text-secondary:#7b7d86;--dynamic-text-size-body-mini:0.6875rem;--dynamic-text-size-body-normal:0.9375rem;--dynamic-text-size-body-small:0.75rem;--dynamic-text-size-button-primary:0.875rem;--dynamic-text-size-button-secondary:0.75rem;--dynamic-text-size-numbers-big:0.875rem;--dynamic-text-size-numbers-medium:0.75rem;--dynamic-text-size-title:1.125rem;--dynamic-text-tertiary:#abacb2;--dynamic-badge-background:#eeeef1;--dynamic-badge-color:#7b7d86;--dynamic-badge-primary-background:#e3f7ef;--dynamic-badge-primary-color:#30a67b;--dynamic-badge-dot-background:#4779ff;--dynamic-search-bar-background:#fff;--dynamic-search-bar-background-hover:#fff;--dynamic-search-bar-background-focus:#fff;--dynamic-search-bar-border:0.0625rem solid #eeeef1;--dynamic-search-bar-border-hover:0.0625rem solid #e7e8ed;--dynamic-search-bar-border-focus:0.0625rem solid #e7e8ed;--dynamic-modal-border: ;--dynamic-modal-width:22.5rem;--dynamic-modal-padding:1.5rem;--dynamic-modal-backdrop-background:rgba(0,0,0,.25);--dynamic-modal-backdrop-filter:blur(4px);--dynamic-wallet-list-tile-padding:0.75rem;--dynamic-wallet-list-tile-gap:0.375rem;--dynamic-wallet-list-max-height:16.25rem;--dynamic-wallet-list-tile-background:#fff;--dynamic-wallet-list-tile-border: ;--dynamic-wallet-list-tile-shadow:0 0.0625rem 0.125rem rgba(24,39,75,.04);--dynamic-wallet-list-tile-background-hover:#fff;--dynamic-wallet-list-tile-border-hover: ;--dynamic-wallet-list-tile-shadow-hover:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-wallet-list-tile-animation-duration:150ms;--dynamic-tooltip-color:#383c48;--dynamic-tooltip-text-color:#fff;--dynamic-initial-view-content-padding:0rem 1.5rem 1.5rem;--dynamic-button-primary-hover:#fff;--dynamic-button-primary-background:#fff;--dynamic-button-primary-font-size:0.875rem;--dynamic-button-primary-padding:0;--dynamic-button-primary-border:0.0625rem solid #e7e8ed;--dynamic-button-shadow:0px 2px 3px 0px rgba(24,39,75,.08);--dynamic-button-secondary-hover:#f7f8fa;--dynamic-button-secondary-background:transparent;--dynamic-button-secondary-font-size:0.75rem;--dynamic-button-secondary-padding:0;--dynamic-button-secondary-border:0.0625rem solid transparent;--dynamic-connect-button-background:#fff;--dynamic-connect-button-background-hover:#fff;--dynamic-connect-button-color:#383c48;--dynamic-connect-button-border:0.0625rem solid #e7e8ed;--dynamic-connect-button-shadow:0px 2px 3px 0px rgba(24,39,75,.08);--dynamic-connect-button-color-hover:#383c48;--dynamic-connect-button-border-hover:0.0625rem solid #e7e8ed;--dynamic-connect-button-shadow-hover:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-search-padding:0 1.5rem 0.5rem;--dynamic-layout-content-padding:0 1.5rem 1.5rem;--dynamic-layout-content-error-padding:1.5rem 1.5rem 1.5rem;--dynamic-footer-border-top:0.0625rem solid #e7e8ed;--dynamic-footer-padding:0.75rem 1.5rem 0.75rem;--dynamic-footer-background:transparent;--dynamic-header-border-bottom:1px solid transparent;--dynamic-header-padding:1.5rem 1.5rem 1.25rem;--dynamic-header-background:transparent}:root [data-dynamic-theme=light] [data-dynamic-theme-brand=bold],:root [data-dynamic-theme=light][data-dynamic-theme-brand=bold]{--dynamic-footer-text-color:#fff;--dynamic-footer-icon-color:rgba(247,247,249,.75);--dynamic-footer-arrow-color:rgba(247,247,249,.75)}:root [data-dynamic-theme=light] [data-dynamic-theme-brand=subtle],:root [data-dynamic-theme=light][data-dynamic-theme-brand=subtle]{--dynamic-footer-arrow-color:#abacb2}}@layer dark-theme-default{@media (prefers-color-scheme:dark){:root [data-dynamic-theme=auto]{--dynamic-font-family-primary:\"DM Sans\",sans-serif;--dynamic-font-family-numbers:\"Roboto Mono\",monospace,sans-serif;--dynamic-base-1:#0c0e13;--dynamic-base-2:#1b1d22;--dynamic-base-3:#24272e;--dynamic-base-4:#282b33;--dynamic-brand-hover-color:linear-gradient(0deg,rgba(0,0,0,.08),rgba(0,0,0,.08)),#4779ff;--dynamic-brand-primary-color:#4779ff;--dynamic-brand-secondary-color:rgba(71,121,255,.15);--dynamic-success-1:#79ffcf;--dynamic-success-2:#192d2c;--dynamic-border-radius:1.5rem;--dynamic-hover:hsla(0,0%,100%,.1);--dynamic-error-1:#ff6a6a;--dynamic-error-2:hsla(0,100%,71%,.2);--dynamic-alert-1:#e2a140;--dynamic-alert-2:#2b2621;--dynamic-footer-background-color:#0c0e13;--dynamic-footer-text-color:#fbfcff;--dynamic-footer-icon-color:#4779ff;--dynamic-loading-animation-gradient:linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.01) 20%,hsla(0,0%,100%,.05) 60%,hsla(0,0%,100%,0));--dynamic-overlay:rgba(0,0,0,.25);--dynamic-shadow-down-1:0 0.0625rem 0.125rem rgba(24,39,75,.04);--dynamic-shadow-down-2:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-shadow-down-3:0 1.5rem 2rem -1.5rem rgba(0,0,0,.24);--dynamic-shadow-up-1:0 -0.5rem 3rem -0.5rem rgba(109,121,165,.16);--dynamic-text-link:#69a5ff;--dynamic-text-primary:#fbfcff;--dynamic-text-secondary:#a8aab0;--dynamic-text-size-body-mini:0.6875rem;--dynamic-text-size-body-normal:0.9375rem;--dynamic-text-size-body-small:0.75rem;--dynamic-text-size-button-primary:0.875rem;--dynamic-text-size-button-secondary:0.75rem;--dynamic-text-size-numbers-big:0.875rem;--dynamic-text-size-numbers-medium:0.75rem;--dynamic-text-size-title:1.125rem;--dynamic-text-tertiary:#6f7177;--dynamic-badge-background:#24272e;--dynamic-badge-color:#a8aab0;--dynamic-badge-dot-background:#4779ff;--dynamic-search-bar-background:#1b1d22;--dynamic-search-bar-background-hover:#1b1d22;--dynamic-search-bar-background-focus:#1b1d22;--dynamic-search-bar-border:0.0625rem solid #24272e;--dynamic-search-bar-border-hover:0.0625rem solid #282b33;--dynamic-search-bar-border-focus:0.0625rem solid #282b33;--dynamic-modal-border: ;--dynamic-modal-width:22.5rem;--dynamic-modal-padding:1.5rem;--dynamic-modal-backdrop-background:rgba(0,0,0,.25);--dynamic-modal-backdrop-filter:blur(4px);--dynamic-wallet-list-tile-padding:0.75rem;--dynamic-wallet-list-tile-gap:0.375rem;--dynamic-wallet-list-max-height:16.25rem;--dynamic-wallet-list-tile-background:#24272e;--dynamic-wallet-list-tile-border: ;--dynamic-wallet-list-tile-shadow:0 0.0625rem 0.125rem rgba(24,39,75,.04);--dynamic-wallet-list-tile-background-hover:#282b33;--dynamic-wallet-list-tile-border-hover: ;--dynamic-wallet-list-tile-shadow-hover:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-wallet-list-tile-animation-duration:150ms;--dynamic-tooltip-color:#fbfcff;--dynamic-tooltip-text-color:#0c0e13;--dynamic-initial-view-content-padding:0rem 1.5rem 1.5rem;--dynamic-button-primary-hover:#1b1d22;--dynamic-button-primary-background:#1b1d22;--dynamic-button-primary-font-size:0.875rem;--dynamic-button-primary-padding:0;--dynamic-button-primary-border:0.0625rem solid #282b33;--dynamic-button-shadow:0px 2px 3px 0px rgba(24,39,75,.08);--dynamic-button-secondary-hover:#1a1c21;--dynamic-button-secondary-background:transparent;--dynamic-button-secondary-font-size:0.75rem;--dynamic-button-secondary-padding:0;--dynamic-button-secondary-border:0.0625rem solid transparent;--dynamic-connect-button-background:#1b1d22;--dynamic-connect-button-background-hover:#1b1d22;--dynamic-connect-button-color:#fbfcff;--dynamic-connect-button-border:0.0625rem solid #282b33;--dynamic-connect-button-shadow:0px 2px 3px 0px rgba(24,39,75,.08);--dynamic-connect-button-color-hover:#fbfcff;--dynamic-connect-button-border-hover:0.0625rem solid #282b33;--dynamic-connect-button-shadow-hover:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-search-padding:0 1.5rem 0.5rem;--dynamic-layout-content-padding:0 1.5rem 1.5rem;--dynamic-layout-content-error-padding:1.5rem 1.5rem 1.5rem;--dynamic-footer-border-top:0.0625rem solid #282b33;--dynamic-footer-padding:0.75rem 1.5rem 0.75rem;--dynamic-footer-background:transparent;--dynamic-header-border-bottom:1px solid transparent;--dynamic-header-padding:1.5rem 1.5rem 1.25rem;--dynamic-header-background:transparent}:root [data-dynamic-theme=auto] [data-dynamic-theme-brand=bold],:root [data-dynamic-theme=auto][data-dynamic-theme-brand=bold]{--dynamic-footer-text-color:#fbfcff;--dynamic-footer-icon-color:rgba(247,247,249,.75);--dynamic-footer-arrow-color:rgba(247,247,249,.75)}:root [data-dynamic-theme=auto] [data-dynamic-theme-brand=subtle],:root [data-dynamic-theme=auto][data-dynamic-theme-brand=subtle]{--dynamic-footer-arrow-color:#6f7177;--dynamic-footer-icon-color:#6f7177}}:root [data-dynamic-theme=dark]{--dynamic-font-family-primary:\"DM Sans\",sans-serif;--dynamic-font-family-numbers:\"Roboto Mono\",monospace,sans-serif;--dynamic-base-1:#0c0e13;--dynamic-base-2:#1b1d22;--dynamic-base-3:#24272e;--dynamic-base-4:#282b33;--dynamic-brand-hover-color:linear-gradient(0deg,rgba(0,0,0,.08),rgba(0,0,0,.08)),#4779ff;--dynamic-brand-primary-color:#4779ff;--dynamic-brand-secondary-color:rgba(71,121,255,.15);--dynamic-success-1:#79ffcf;--dynamic-success-2:#192d2c;--dynamic-border-radius:1.5rem;--dynamic-hover:hsla(0,0%,100%,.1);--dynamic-error-1:#ff6a6a;--dynamic-error-2:hsla(0,100%,71%,.2);--dynamic-alert-1:#e2a140;--dynamic-alert-2:#2b2621;--dynamic-footer-background-color:#0c0e13;--dynamic-footer-text-color:#fbfcff;--dynamic-footer-icon-color:#4779ff;--dynamic-loading-animation-gradient:linear-gradient(90deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.01) 20%,hsla(0,0%,100%,.05) 60%,hsla(0,0%,100%,0));--dynamic-overlay:rgba(0,0,0,.25);--dynamic-shadow-down-1:0 0.0625rem 0.125rem rgba(24,39,75,.04);--dynamic-shadow-down-2:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-shadow-down-3:0 1.5rem 2rem -1.5rem rgba(0,0,0,.24);--dynamic-shadow-up-1:0 -0.5rem 3rem -0.5rem rgba(109,121,165,.16);--dynamic-text-link:#69a5ff;--dynamic-text-primary:#fbfcff;--dynamic-text-secondary:#a8aab0;--dynamic-text-size-body-mini:0.6875rem;--dynamic-text-size-body-normal:0.9375rem;--dynamic-text-size-body-small:0.75rem;--dynamic-text-size-button-primary:0.875rem;--dynamic-text-size-button-secondary:0.75rem;--dynamic-text-size-numbers-big:0.875rem;--dynamic-text-size-numbers-medium:0.75rem;--dynamic-text-size-title:1.125rem;--dynamic-text-tertiary:#6f7177;--dynamic-badge-background:#24272e;--dynamic-badge-color:#a8aab0;--dynamic-badge-dot-background:#4779ff;--dynamic-search-bar-background:#1b1d22;--dynamic-search-bar-background-hover:#1b1d22;--dynamic-search-bar-background-focus:#1b1d22;--dynamic-search-bar-border:0.0625rem solid #24272e;--dynamic-search-bar-border-hover:0.0625rem solid #282b33;--dynamic-search-bar-border-focus:0.0625rem solid #282b33;--dynamic-modal-border: ;--dynamic-modal-width:22.5rem;--dynamic-modal-padding:1.5rem;--dynamic-modal-backdrop-background:rgba(0,0,0,.25);--dynamic-modal-backdrop-filter:blur(4px);--dynamic-wallet-list-tile-padding:0.75rem;--dynamic-wallet-list-tile-gap:0.375rem;--dynamic-wallet-list-max-height:16.25rem;--dynamic-wallet-list-tile-background:#24272e;--dynamic-wallet-list-tile-border: ;--dynamic-wallet-list-tile-shadow:0 0.0625rem 0.125rem rgba(24,39,75,.04);--dynamic-wallet-list-tile-background-hover:#282b33;--dynamic-wallet-list-tile-border-hover: ;--dynamic-wallet-list-tile-shadow-hover:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-wallet-list-tile-animation-duration:150ms;--dynamic-tooltip-color:#fbfcff;--dynamic-tooltip-text-color:#0c0e13;--dynamic-initial-view-content-padding:0rem 1.5rem 1.5rem;--dynamic-button-primary-hover:#1b1d22;--dynamic-button-primary-background:#1b1d22;--dynamic-button-primary-font-size:0.875rem;--dynamic-button-primary-padding:0;--dynamic-button-primary-border:0.0625rem solid #282b33;--dynamic-button-shadow:0px 2px 3px 0px rgba(24,39,75,.08);--dynamic-button-secondary-hover:#1a1c21;--dynamic-button-secondary-background:transparent;--dynamic-button-secondary-font-size:0.75rem;--dynamic-button-secondary-padding:0;--dynamic-button-secondary-border:0.0625rem solid transparent;--dynamic-connect-button-background:#1b1d22;--dynamic-connect-button-background-hover:#1b1d22;--dynamic-connect-button-color:#fbfcff;--dynamic-connect-button-border:0.0625rem solid #282b33;--dynamic-connect-button-shadow:0px 2px 3px 0px rgba(24,39,75,.08);--dynamic-connect-button-color-hover:#fbfcff;--dynamic-connect-button-border-hover:0.0625rem solid #282b33;--dynamic-connect-button-shadow-hover:0 0.75rem 1.25rem -0.375rem rgba(24,39,75,.02),0 1rem 1.625rem -0.25rem rgba(24,39,75,.04);--dynamic-search-padding:0 1.5rem 0.5rem;--dynamic-layout-content-padding:0 1.5rem 1.5rem;--dynamic-layout-content-error-padding:1.5rem 1.5rem 1.5rem;--dynamic-footer-border-top:0.0625rem solid #282b33;--dynamic-footer-padding:0.75rem 1.5rem 0.75rem;--dynamic-footer-background:transparent;--dynamic-header-border-bottom:1px solid transparent;--dynamic-header-padding:1.5rem 1.5rem 1.25rem;--dynamic-header-background:transparent}:root [data-dynamic-theme=dark] [data-dynamic-theme-brand=bold],:root [data-dynamic-theme=dark][data-dynamic-theme-brand=bold]{--dynamic-footer-text-color:#fbfcff;--dynamic-footer-icon-color:rgba(247,247,249,.75);--dynamic-footer-arrow-color:rgba(247,247,249,.75)}:root [data-dynamic-theme=dark] [data-dynamic-theme-brand=subtle],:root [data-dynamic-theme=dark][data-dynamic-theme-brand=subtle]{--dynamic-footer-arrow-color:#6f7177;--dynamic-footer-icon-color:#6f7177}}.dynamic-shadow-dom{position:relative}#dynamic-tooltips{left:0;position:absolute;top:0}@supports (overflow:clip){.dynamic-no-scroll{overflow:clip}}@supports not (overflow:clip){.dynamic-no-scroll{overflow:hidden}}}";
styleInject(css_248z);

const useVerifyOnAwaitingSignature = () => {
    const { awaitingSignatureState, multiWalletWidgetState, setMultiWalletWidgetState, legacyIsVerifying, setLegacyIsVerifying, selectedWalletConnector, } = useInternalDynamicContext();
    const triggerConnectAndSign = useConnectAndSign();
    // this is to prevent calling runConnectAndSign multiple times
    // due to changes in legacyIsVerifying
    const isVerifying = useRef(false);
    const runConnectAndSign = useCallback((walletConnector) => __awaiter$1(void 0, void 0, void 0, function* () {
        logger$1.debug('runConnectAndSign', {
            selectedWalletConnector,
            walletConnector,
        });
        const connector = walletConnector !== null && walletConnector !== void 0 ? walletConnector : selectedWalletConnector;
        if (!connector) {
            return;
        }
        isVerifying.current = true;
        setLegacyIsVerifying(true);
        try {
            yield triggerConnectAndSign({
                walletConnector: connector,
            });
        }
        catch (e) {
            logger$1.error(e);
        }
        setMultiWalletWidgetState('idle');
        setLegacyIsVerifying(false);
        isVerifying.current = false;
    }), [
        selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.key,
        setLegacyIsVerifying,
        setMultiWalletWidgetState,
        triggerConnectAndSign,
    ]);
    // This is the effect that triggers the connect and sign flow
    // when the multi wallet widget is in the awaiting_signature state
    // with linking_new_wallet signature sub state.
    // This is a very, very bad pattern and should be refactored if possible,
    // though that would be a lot of work and this works for now.
    useEffect(() => {
        if (!legacyIsVerifying &&
            !isVerifying.current &&
            multiWalletWidgetState === 'awaiting_signature' &&
            selectedWalletConnector &&
            awaitingSignatureState === 'linking_new_wallet' &&
            !requiresTwoStepAuthentication(selectedWalletConnector)) {
            runConnectAndSign();
        }
    }, [
        runConnectAndSign,
        awaitingSignatureState,
        legacyIsVerifying,
        multiWalletWidgetState,
        selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.key,
        setLegacyIsVerifying,
        setMultiWalletWidgetState,
    ]);
    useInternalDynamicEvents('triggerConnectAndSign', runConnectAndSign);
};

const viewsToDisableCloseOnOverlayClick = [
    'email-wallet-otp-verification-view',
    'social-redirect-view',
    'passkey-intro',
];
const Main = () => {
    const { selectedWalletConnector, linkedWallets, projectSettings, setShowAuthFlow, showAuthFlow, walletConnectorOptions, clearStatesOnBackClick, user, disconnectWallet, authMode, connectedWallets, handleLogOut, } = useInternalDynamicContext();
    const { view, clearStackAndPushInitialView } = useViewContext();
    const { setDeniedAddress, setDeniedOauthProvider } = useAccessDeniedContext();
    const { setExistentAccountData } = useAccountExistsContext();
    const { setSocialProvider } = useSocialRedirectContext();
    usePreventPageScroll(showAuthFlow);
    const userWallets = useUserWallets();
    const handleClose = () => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a;
        if (viewsToDisableCloseOnOverlayClick.includes(view.type))
            return;
        if ((_a = view.events) === null || _a === void 0 ? void 0 : _a.onClose) {
            view.events.onClose();
            return;
        }
        if ((view.type === 'network-not-supported' ||
            view.type === 'network-not-supported-manual') &&
            userWallets.length === 1) {
            yield handleLogOut();
        }
        if (view.type === 'farcaster-connect-view') {
            setSocialProvider(undefined);
            dynamicEvents.emit('farcasterConnectCancelled');
        }
        setShowAuthFlow(false, { emitCancelAuth: true });
        setDeniedAddress('');
        setDeniedOauthProvider(undefined);
        setExistentAccountData(undefined);
        clearStatesOnBackClick();
    });
    const handleOnPortalExiting = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        // In the connect only mode (default and bridge)
        // We want to disconnect wallet when users closes `network not supported` view
        // without updating network in wallet
        // We use onExiting instead onUnmount to avoid jump effect in inline widget
        const viewsToDisconnectWalletOnClose = [
            'network-not-supported',
            'network-not-supported-manual',
        ];
        if (!isConnectOnly(user, authMode) ||
            !viewsToDisconnectWalletOnClose.includes(view.type) ||
            !selectedWalletConnector)
            return;
        const walletByConnectorKey = connectedWallets.find((connectedWallet) => connectedWallet.connector.key === selectedWalletConnector.key);
        if (!walletByConnectorKey) {
            return;
        }
        // Validate the network
        if (!isSupportedNetwork({
            network: yield walletByConnectorKey.connector.getNetwork(),
            walletConnector: walletByConnectorKey.connector,
        })) {
            disconnectWallet(walletByConnectorKey.id);
        }
    }), [
        selectedWalletConnector,
        authMode,
        connectedWallets,
        disconnectWallet,
        user,
        view,
    ]);
    const handleOnPortalUnmount = useCallback(() => {
        // IMPORTANT: we need to reset the view because we reset state that the view depends on
        // so if the previous view renders when the user reopens the widget, it will crash
        clearStackAndPushInitialView();
    }, [clearStackAndPushInitialView]);
    useVerifyOnAwaitingSignature();
    const { handleAlreadyConnectedWallet, handleCustodialWalletClick, handleInstalledExtensionClick, handleMobileWalletClick, handleUninstalledClick, } = useWalletItemActions();
    /* istanbul ignore next */
    const handleNewToWeb3WalletIntent = (walletConnector) => __awaiter$1(void 0, void 0, void 0, function* () {
        setShowAuthFlow(true);
        if (isSelectedWalletAlreadyConnected(linkedWallets, walletConnector, user)) {
            // wallet is already connected
            handleAlreadyConnectedWallet(walletConnector);
        }
        else if (walletConnector.canConnectViaCustodialService) {
            // providers like blocto and dapper
            handleCustodialWalletClick(walletConnector);
        }
        else if (isMobile()) {
            // mobile wallets
            handleMobileWalletClick(walletConnector);
        }
        else if (walletConnector.isInstalledOnBrowser()) {
            // browser extensions or injected wallets
            handleInstalledExtensionClick(walletConnector);
        }
        else {
            // wallet requiring a qr code (wallet connect/coinbase wallet)
            handleUninstalledClick(walletConnector);
        }
    });
    useEffect(() => {
        const newToWeb3WalletKey = StorageService.getItem(NEWTOWEB3_WALLET_EXTENSION_FLAG_KEY);
        if ((walletConnectorOptions === null || walletConnectorOptions === void 0 ? void 0 : walletConnectorOptions.length) && newToWeb3WalletKey) {
            const wallet = walletConnectorOptions.find((wallet) => wallet.key === newToWeb3WalletKey);
            if (wallet === null || wallet === void 0 ? void 0 : wallet.walletConnector) {
                handleNewToWeb3WalletIntent(wallet.walletConnector);
            }
            StorageService.removeItem(NEWTOWEB3_WALLET_EXTENSION_FLAG_KEY);
        }
    }, [walletConnectorOptions]);
    const showDynamicAuth = showAuthFlow && Boolean(projectSettings);
    return (jsxRuntimeExports.jsx(FooterAnimationContextProvider, { children: jsxRuntimeExports.jsx(Portal, { zIndex: authModalZIndex, isShown: showDynamicAuth, handleClose: handleClose, withBackdrop: true, transitionEvents: {
                onExiting: handleOnPortalExiting,
                onUnmount: handleOnPortalUnmount,
            }, children: jsxRuntimeExports.jsx(PopperProvider, { children: jsxRuntimeExports.jsx(DynamicAuthModal, { transitionProps: {
                        isShown: showDynamicAuth,
                    }, onClose: handleClose, projectSettings: projectSettings, children: jsxRuntimeExports.jsx(RenderView, {}) }) }) }) }));
};

const DynamicAuthFlow = () => (jsxRuntimeExports.jsx(IsBrowser, { children: jsxRuntimeExports.jsx(Main, {}) }));

/**
 * Prefetches a resource
 * Adds a link element to the head of the document with the provided attributes
 * when the element is not already present
 * @param {PrefetchProps} prefetchProps
 * @returns {void}
 *
 * @example
 * usePrefetch({
 *  href: 'https://example.com/image.jpg',
 *  as: 'image',
 *  type: 'image/jpeg',
 *  id: 'image-prefetch',
 * });
 */
const usePrefetch = ({ as, href, id, type }) => {
    // Do not run on server side
    if (isSSR())
        return;
    const predefinedElement = document.head.querySelector(`#${id}`);
    // Do not add the element if it already exists
    if (predefinedElement)
        return;
    const element = document.createElement('link');
    element.setAttribute('id', id);
    element.setAttribute('rel', 'prefetch');
    element.setAttribute('href', href);
    element.setAttribute('as', as);
    element.setAttribute('type', type);
    document.head.insertAdjacentElement('beforeend', element);
};

const useSetWalletConnectorVerifiedCredentials = (user, walletOptions) => {
    if (!user || !(walletOptions === null || walletOptions === void 0 ? void 0 : walletOptions.length))
        return;
    walletOptions.forEach((walletOption) => {
        walletOption.walletConnector.setVerifiedCredentials(user.verifiedCredentials);
    });
};

/**
 * Detects envId mismtach with store.
 * @returns true if there is no mismatch.
 */
const handleStoreAndEnvironmentMismatch = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ environmentId, logout, }) {
    const storeEnvId = getEnvironmentId();
    if (!storeEnvId || environmentId === storeEnvId) {
        return true;
    }
    yield logout('store and environment are out of sync', {
        currentEnvId: environmentId,
        storedEnvId: storeEnvId,
    });
    setEnvironmentId(environmentId);
    return false;
});

/**
 * Detects mismatch between user and auth token.
 * @returns true if there is no mismatch.
 */
const handleUserDataOutOfSync = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ environmentId, logout, projectSettings, }) {
    const cookieEnabled = isCookieEnabled(projectSettings);
    const authToken = getAuthToken();
    const user = getUser();
    if (authToken || !user) {
        return true;
    }
    if (user && !authToken && cookieEnabled) {
        try {
            yield getAuthenticatedUser({ environmentId });
        }
        catch (e) {
            if (e instanceof CookieInvalidError) {
                yield logout('user auth cookie invalid', {
                    authToken,
                    user,
                });
                return false;
            }
        }
        return true;
    }
    yield logout('user data out of sync', {
        authToken,
        user,
    });
    return false;
});

let didStoreVersionChangedValue = false;
const getDidStoreVersionChangedValue = () => didStoreVersionChangedValue;
const setDidStoreVersionChangedValue = (value) => {
    didStoreVersionChangedValue = value;
};

const handleStoreVersionChanged = ({ logout, }) => {
    if (getDidStoreVersionChangedValue()) {
        setDidStoreVersionChangedValue(false);
        logout('dynamic SDK version changed', {});
    }
};

const useValidateSession = ({ environmentId, handleLogOut }) => {
    const didRunRef = useRef(false);
    const projectSettings = useProjectSettings();
    const logout = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (reason, params) => __awaiter$1(void 0, void 0, void 0, function* () {
        logger$1.info(`Logging out due to invalid session - Reason: ${reason}`, Object.assign({}, params));
        return handleLogOut();
    }), [handleLogOut]);
    const validateSession = useCallback((projectSettings) => __awaiter$1(void 0, void 0, void 0, function* () {
        const params = {
            environmentId,
            logout,
            projectSettings,
        };
        yield Promise.all([
            handleStoreAndEnvironmentMismatch(params),
            handleUserDataOutOfSync(params),
            handleStoreVersionChanged(params),
        ]);
        // Regardless of whether we logged out or not, session validation is now complete
        setLoadingAndLifecycle({ sessionValidation: true });
    }), [logout, environmentId]);
    useEffect(() => {
        if (didRunRef.current || !projectSettings)
            return;
        didRunRef.current = true;
        validateSession(projectSettings);
    }, [validateSession, projectSettings]);
    useInternalDynamicEvents('triggerSessionValidation', () => {
        if (!projectSettings)
            return;
        validateSession(projectSettings);
    });
};

const serializeWalletConnectors = (walletConnectors) => {
    try {
        if (!walletConnectors)
            return undefined;
        return walletConnectors.map((connector) => connector.name);
    }
    catch (error) {
        logger$1.error('error serializing walletConnectors', error);
        return undefined;
    }
};

class ConnectorSetupError extends DynamicError {
    constructor(providerName, connectorName) {
        super(`${providerName} is enabled but ${connectorName} is not in your walletConnectors list. See https://docs.dynamic.xyz/react-sdk/wallet-connectors for more information.`);
    }
}

const magicEmailOtpWalletConnectorKey = 'magicemailotp';
const magicSocialWalletConnectorKey = 'magicsocial';
const verifyMagicIsSetup = (projectSettings, walletConnectors) => {
    var _a;
    const isMagicEnabled = isProviderEnabled((_a = projectSettings.providers) !== null && _a !== void 0 ? _a : [], ProviderEnum.MagicLink);
    const isMagicWalletConnectorPresent = walletConnectors.some(({ key }) => [magicEmailOtpWalletConnectorKey, magicSocialWalletConnectorKey].includes(key));
    if (isMagicEnabled && !isMagicWalletConnectorPresent) {
        throw new ConnectorSetupError('Magic', 'MagicWalletConnectors');
    }
};

const zeroDevWalletConnectorKey = 'zerodev';
const verifyZeroDevIsSetup = (projectSettings, walletConnectors) => {
    var _a;
    const isZeroDevEnabled = isProviderEnabled((_a = projectSettings.providers) !== null && _a !== void 0 ? _a : [], ProviderEnum.Zerodev);
    const isZeroDevWalletConnectorPresent = walletConnectors.some(({ key }) => key === zeroDevWalletConnectorKey);
    if (isZeroDevEnabled && !isZeroDevWalletConnectorPresent) {
        throw new ConnectorSetupError('ZeroDev', 'ZeroDevSmartWalletConnectors');
    }
};

const verifyRequiredConnectorsAreSetup = (projectSettings, walletConnectors) => {
    verifyMagicIsSetup(projectSettings, walletConnectors);
    verifyZeroDevIsSetup(projectSettings, walletConnectors);
};

const useCreateWalletConnectorOptions = (_a) => {
    var { projectSettings, networkConfigurations, walletBook, walletConnectorsProp, walletConnectorExtensions } = _a, props = __rest(_a, ["projectSettings", "networkConfigurations", "walletBook", "walletConnectorsProp", "walletConnectorExtensions"]);
    const walletConnectorsKey = useMemo(() => { var _a; return (_a = serializeWalletConnectors(walletConnectorsProp)) === null || _a === void 0 ? void 0 : _a.join(','); }, [walletConnectorsProp]);
    const isWalletBookLoaded = useMemo(() => isWalletBookPopulated(walletBook), [walletBook]);
    const walletConnectorOptions = useMemo(() => {
        if (!projectSettings || !isWalletBookLoaded || !networkConfigurations)
            return [];
        return getWallets({
            getSupportedWalletOpts: Object.assign({ networkConfigurations, settings: projectSettings, skipMemo: true, walletBook, walletConnectorsProp: walletConnectorsProp !== null && walletConnectorsProp !== void 0 ? walletConnectorsProp : [] }, props),
            walletConnectorExtensions,
        });
        // Cannot include walletUiUtils in the dependency array because it will cause an infinite loop
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        projectSettings,
        walletConnectorsKey,
        isWalletBookLoaded,
        networkConfigurations,
    ]);
    useEffect(() => {
        if (!projectSettings || walletConnectorOptions.length === 0)
            return;
        verifyRequiredConnectorsAreSetup(projectSettings, walletConnectorOptions.map(({ walletConnector }) => walletConnector));
        mergeWalletConnectorOptions(walletConnectorOptions);
    }, [walletConnectorOptions, projectSettings]);
    return { walletConnectorOptions };
};

const createWalletGroupFromWalletOption = (walletOption) => {
    const { metadata } = walletOption.walletConnector;
    const { name } = metadata;
    const key = sanitizeName(name);
    return {
        brand: {
            icon: metadata.icon,
            primaryColor: metadata.brandColor,
        },
        key,
        name,
    };
};

const useCreateWalletGroups = ({ walletConnectorOptions, }) => {
    // Dynamically populate groups based on wallet options
    useEffect(() => {
        if (!walletConnectorOptions.length)
            return;
        const groups = {};
        walletConnectorOptions.forEach((option) => {
            const group = createWalletGroupFromWalletOption(option);
            // we don't need to override the group if it already exists
            // and it will particularly cause issues with MM, because the starknet snap icon
            // is different group than the default MM icon
            if (!groups[group.key]) {
                groups[group.key] = group;
            }
            option.chainGroup = group.key;
            option.group = group.key;
        });
        logger$1.logVerboseTroubleshootingMessage('[DynamicContext] mergeWalletGroups', {
            groups,
        });
        mergeWalletGroups(groups);
    }, [walletConnectorOptions]);
};

const shouldManuallyReconnectOnRefresh = (connector) => connector.connectedChain === 'STARK' || connector.connectedChain === 'FLOW';

const convertLegacyPhantomLedgerConnector = (account) => (Object.assign(Object.assign({}, account), { walletName: 'phantom', walletProperties: {
        hardwareWallet: HardwareWalletEnum.Ledger,
    } }));

const createLinkedWalletsFromWalletOptions = ({ user, walletConnectorOptions, primaryWalletId, separateSmartWalletAndSigner, }) => {
    // wallet state should be null while loading all the wallets or when there is no user
    if (!walletConnectorOptions || !user) {
        return [];
    }
    return user.verifiedCredentials
        .map(convertLegacyPhantomLedger)
        .map((account) => {
        var _a, _b;
        const wallet = findWalletOptionFor(account, walletConnectorOptions);
        // this probably shouldn't happen. this would mean that the user has an account linked
        // with wallet W, but the customer has toggled off wallet W or the chain that
        // supports wallet W
        /* istanbul ignore next */
        if (!wallet)
            return null;
        if (account.id === primaryWalletId &&
            shouldManuallyReconnectOnRefresh(wallet.walletConnector)) {
            wallet.walletConnector.connect();
        }
        // only checking for ledger hardware wallets since we only specify ledger as a hardware wallet
        if (((_a = account.walletProperties) === null || _a === void 0 ? void 0 : _a.hardwareWallet) ===
            HardwareWalletEnum.Ledger &&
            isHardwareWalletConnector(wallet.walletConnector)) {
            wallet.walletConnector.isHardwareWalletEnabled = true;
        }
        // this account is the owner of a smart wallet, and should not be surfaced
        if (!separateSmartWalletAndSigner &&
            isOwnerOfASmartWallet(account, user.verifiedCredentials)) {
            return null;
        }
        if (account.address && account.chain) {
            if (account.walletProvider === WalletProviderEnum.SmartContractWallet) {
                initializeSmartWallet({
                    account,
                    primaryWalletId,
                    verifiedCredentials: user.verifiedCredentials,
                    walletConnectorOptions,
                });
            }
            return wallet.walletConnector.createWallet({
                additionalAddresses: account.walletAdditionalAddresses,
                address: account.address,
                chain: wallet.walletConnector.connectedChain,
                connector: wallet.walletConnector,
                id: account.id,
                isAuthenticated: true,
                key: (_b = account.walletName) !== null && _b !== void 0 ? _b : wallet.walletConnector.key,
            });
        }
        return null;
    })
        .filter((wc) => wc !== null);
};
const convertLegacyPhantomLedger = (account) => {
    if (account.walletName === 'phantomledger') {
        return convertLegacyPhantomLedgerConnector(account);
    }
    return account;
};

/**
 * This takes a userWallets and linkedWallets array, and returns a new userWallets array
 * updated to match the linkedWallets array.
 * It will add any missing wallets, update properties that don't match, and remove wallets that aren't
 * in the linkedWallets.
 */
const updateUserWalletsFromLinkedWallets = (userWallets, authenticatedWallets) => {
    const userWalletsCopy = [...userWallets];
    /** We will use this to find wallets addresses that were removed */
    const newWalletsAddresses = new Set();
    const newWalletsChains = new Set();
    // First pass: add missing wallets and update changed properties
    for (const authenticatedWallet of authenticatedWallets) {
        newWalletsAddresses.add(authenticatedWallet.address);
        newWalletsChains.add(authenticatedWallet.chain);
        const respectiveIndex = userWalletsCopy.findIndex((wallet) => wallet.address === authenticatedWallet.address &&
            wallet.chain === authenticatedWallet.chain);
        // Catch new wallets
        if (respectiveIndex === -1) {
            userWalletsCopy.push(authenticatedWallet);
            continue;
        }
        // If already present, just update to match the new state
        userWalletsCopy[respectiveIndex] = authenticatedWallet;
        // NOTE: this will actually update the wallet's ID if it changed, which happens when a wallet is signed
        // It initially has a id in the format "connected-wallet-X", and after being signed it changes to a hash
    }
    // This filter is to remove a wallet that was previously added to userWallets but is not present
    // among the verified credentials wallets anymore
    return userWalletsCopy.filter((userWallet) => newWalletsAddresses.has(userWallet.address) &&
        newWalletsChains.has(userWallet.chain));
};

const useWalletConnectors = ({ authMode, connectedWallets, walletConnectorOptions, setMultiWalletWidgetState, primaryWalletId, user, canHaveMultipleWalletsConnected, separateSmartWalletAndSigner = false, }) => {
    const [showQrcodeModal, setShowQrcodeModal] = useState(false);
    // keeps track of the last primary wallet id to avoid emitting the same event multiple times
    const lastPrimaryWalletId = useRef(primaryWalletId);
    const linkedWallets = useMemo(() => {
        if (!user) {
            return [];
        }
        return createLinkedWalletsFromWalletOptions({
            primaryWalletId,
            separateSmartWalletAndSigner,
            user,
            walletConnectorOptions,
        });
    }, [
        user,
        primaryWalletId,
        walletConnectorOptions,
        separateSmartWalletAndSigner,
    ]);
    logger$1.logVerboseTroubleshootingMessage('linkedWallets', linkedWallets);
    const wallets = useMemo(() => {
        // Before signing the first message we are using connected wallets list
        // This is because we want the first connected wallet to have events applied by useWalletEventListeners
        // In connect-and-sign mode, events are only applied after the message is signed.
        // This change ensures that events will be applied even before the signature.
        // After signing the message user could be undefined in scenarios like OTP
        if (authMode === 'connect-and-sign' && user) {
            return linkedWallets;
        }
        /**
         * This is to handle users in connect-only who are signing in with social/email
         * with an embedded wallet
         */
        if (authMode === 'connect-only' &&
            linkedWallets.find((wallet) => isEmbeddedConnector(wallet.connector))) {
            return linkedWallets;
        }
        return connectedWallets !== null && connectedWallets !== void 0 ? connectedWallets : [];
    }, [authMode, connectedWallets, linkedWallets, user]);
    logger$1.logVerboseTroubleshootingMessage('wallets', wallets);
    /**
     * This useEffect is temporary.
     * While the wallet connectors don't use the event emitter, we need to manually
     * initialize the bridge between the old event listeners and the new event emitter.
     * When the wallet connectors are migrated to the new event emitter, there will be no
     * need to initialize or teardown event listeners, then we can remove this useEffect.
     */
    useEffect(() => wallets.forEach((wallet) => {
        wallet.connector.initEventListener();
    }), [wallets]);
    const { setUserWallets } = useInternalUserWallets();
    // Keep userWallets in sync whenever linkedWallets changes
    useEffect(() => {
        logger$1.logVerboseTroubleshootingMessage('[useWalletConnectors] will call setUserWallets', wallets);
        setUserWallets((userWallets) => updateUserWalletsFromLinkedWallets(userWallets, wallets));
    }, [setUserWallets, wallets]);
    const primaryWallet = useMemo(() => { var _a; return (_a = wallets.find((wallet) => wallet.id === primaryWalletId)) !== null && _a !== void 0 ? _a : null; }, [primaryWalletId, wallets]);
    // emit primaryWalletChanged event if the primary wallet changes
    useEffect(() => {
        if (primaryWallet && primaryWallet.id !== lastPrimaryWalletId.current) {
            lastPrimaryWalletId.current = primaryWallet.id;
            dynamicEvents.emit('primaryWalletChanged', primaryWallet);
        }
    }, [primaryWallet]);
    const secondaryWallets = useMemo(() => canHaveMultipleWalletsConnected
        ? wallets.filter((wallet) => wallet.id !== primaryWalletId)
        : [], [primaryWalletId, wallets, canHaveMultipleWalletsConnected]);
    const getSelectedWallet = useCallback((walletId) => __awaiter$1(void 0, void 0, void 0, function* () {
        const newWallet = wallets.find(({ id }) => id === walletId);
        if (!newWallet) {
            throw new DynamicError(`Wallet with id: ${walletId} not found`);
        }
        return newWallet;
    }), [wallets]);
    const setPrimaryWallet = useCallback((walletId) => __awaiter$1(void 0, void 0, void 0, function* () {
        const newPrimaryWallet = yield getSelectedWallet(walletId);
        if (!primaryWalletId) {
            yield newPrimaryWallet.connector.connect();
            updatePrimaryWalletId(walletId);
            return;
        }
        if (primaryWalletId === walletId)
            return;
        if (isEmailWalletConnector(newPrimaryWallet.connector)) {
            const emailConnector = newPrimaryWallet.connector;
            const email = localStorage.getItem('magic-link-email');
            if (email) {
                emailConnector.setEmail(email);
            }
        }
        updatePrimaryWalletId(walletId);
        setMultiWalletWidgetState('idle');
    }), [getSelectedWallet, primaryWalletId, setMultiWalletWidgetState]);
    return {
        primaryWallet,
        secondaryWallets,
        setPrimaryWallet,
        setShowQrcodeModal,
        showQrcodeModal,
        wallets,
    };
};

const AppOriginTile = ({ appLogoUrl, appName, appOrigin, }) => {
    const ref = useRef(null);
    const [showAppName, setShowAppName] = useState(false);
    useLayoutEffect(() => {
        if (ref.current) {
            const { width, height } = ref.current.getBoundingClientRect();
            if (width < height * 2) {
                setShowAppName(true);
            }
            else {
                setShowAppName(false);
            }
        }
    }, [ref, setShowAppName]);
    return (jsxRuntimeExports.jsxs("div", { className: 'app-origin-tile', children: [Boolean(appName) && (jsxRuntimeExports.jsx("div", { className: 'app-origin-tile__title', children: appLogoUrl ? (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("img", { alt: 'app_logo', src: appLogoUrl, className: 'app-origin-tile__logo', ref: ref }), showAppName && (jsxRuntimeExports.jsx(Typography, { color: 'primary', variant: 'body_normal', children: appName }))] })) : (jsxRuntimeExports.jsx(Typography, { "data-testid": 'app-name', color: 'primary', variant: 'body_normal', children: appName })) })), appOrigin && (jsxRuntimeExports.jsx(Typography, { color: 'secondary', variant: 'body_normal', weight: 'regular', children: appOrigin }))] }));
};

var _circle$1, _path$i;
var _excluded$i = ["title", "titleId"];
function _extends$i() { return _extends$i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$i.apply(null, arguments); }
function _objectWithoutProperties$i(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$i(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$i(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSignCircle = function SvgSignCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$i(_ref, _excluded$i);
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle$1 || (_circle$1 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "currentColor"
  })), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    d: "M34.048 17.611a5.5 5.5 0 1 1 7.779 7.779l-.611.61.193.193a4.5 4.5 0 0 1 0 6.364l-3.238 3.239a1.125 1.125 0 0 1-1.592-1.591l3.239-3.239a2.25 2.25 0 0 0 0-3.182l-.193-.193-12.704 12.705a1.123 1.123 0 0 1-.523.296l-9 2.25a1.125 1.125 0 0 1-1.34-1.447l2.812-8.438c.055-.166.148-.316.272-.44l14.906-14.906Zm6.188 1.591a3.25 3.25 0 0 0-4.597 0L20.921 33.92l-2.08 6.242 6.709-1.678 14.686-14.686a3.25 3.25 0 0 0 0-4.596ZM24.925 47.375c-2.779 0-4.967-1.275-6.424-2.49l2.89-.723c1.003.562 2.19.963 3.534.963.912 0 1.853-.369 2.856-1.028 1.005-.66 1.976-1.546 2.956-2.465l.255-.24c.865-.812 1.764-1.658 2.624-2.242.918-.624 2.135-1.191 3.413-.7.844.325 1.393.925 1.78 1.658.362.687.612 1.548.855 2.485.111.427.3.841.515 1.12.105.137.196.214.26.253.055.034.08.034.086.034.274 0 .745-.185 1.417-.643.417-.284.774-.568 1.13-.852.221-.177.443-.354.679-.53.628-.47 1.171-.785 1.57-.986a6.86 6.86 0 0 1 .625-.28l.045-.016.016-.006.006-.002h.003s.002-.002.359 1.065l-.357-1.067a1.125 1.125 0 0 1 .721 2.132l-.008.003a4.59 4.59 0 0 0-.394.178 8.472 8.472 0 0 0-1.238.78c-.132.098-.304.235-.5.391-.409.324-.921.73-1.39 1.05-.7.476-1.67 1.033-2.684 1.033-.98 0-1.69-.595-2.127-1.162-.447-.578-.746-1.29-.912-1.93-.247-.95-.442-1.573-.667-2-.201-.38-.383-.525-.598-.608-.184-.07-.552-.075-1.34.46-.704.48-1.472 1.2-2.38 2.053l-.225.211c-.97.91-2.071 1.922-3.26 2.703-1.19.783-2.566 1.398-4.091 1.398Z",
    fill: "#fff"
  })));
};

const isSignTypedData = (data) => {
    if (typeof data !== 'object' || data === null) {
        return false;
    }
    const { types, message, primaryType } = data;
    return (typeof types === 'object' &&
        types !== null &&
        typeof message === 'object' &&
        message !== null &&
        typeof primaryType === 'string');
};

const isRawMessage = (data) => {
    if (typeof data !== 'object' || data === null) {
        return false;
    }
    return typeof data.raw === 'string';
};

const SignTypedDataPreview = ({ currentType, types, showTypeName = false, data }) => {
    const fields = types[currentType].map((field) => {
        var _a;
        const type = field.type.replace('[]', '');
        const isCollection = field.type.endsWith('[]');
        const isKnownType = type in types;
        if (isCollection && isKnownType) {
            return (jsxRuntimeExports.jsx(TypeSection, { title: capitalize$1(field.name), children: (_a = data === null || data === void 0 ? void 0 : data[field.name]) === null || _a === void 0 ? void 0 : _a.map((item, index) => (jsxRuntimeExports.jsx(TypeSection, { title: index.toString(), children: jsxRuntimeExports.jsx(SignTypedDataPreview, { currentType: type, types: types, data: item }) }, index))) }, field.name));
        }
        if (isKnownType) {
            return (jsxRuntimeExports.jsx(TypeSection, { title: capitalize$1(field.name), children: jsxRuntimeExports.jsx(SignTypedDataPreview, { currentType: type, types: types, data: data === null || data === void 0 ? void 0 : data[field.name] }) }, field.name));
        }
        const fieldData = data === null || data === void 0 ? void 0 : data[field.name];
        const fieldType = field.type;
        return (jsxRuntimeExports.jsx(FieldRow, { name: capitalize$1(field.name), data: fieldData, displayValue: fieldType === 'address'
                ? shortenWalletAddress(fieldData, 4, 4)
                : fieldData }, field.name));
    });
    if (showTypeName) {
        return jsxRuntimeExports.jsx(TypeSection, { title: currentType, children: fields });
    }
    return jsxRuntimeExports.jsx("div", { className: 'sign-typed-data-preview--fields-list', children: fields });
};
// Components
const TypeTitle = ({ children }) => (jsxRuntimeExports.jsx(Typography, { color: 'secondary', weight: 'medium', children: children }));
const AttributeName = TypeTitle;
const AttributeValue = ({ children, title, }) => (jsxRuntimeExports.jsx(Typography, { as: 'span', weight: 'regular', color: 'primary', title: title, children: children }));
const PaddedContent = ({ children }) => (jsxRuntimeExports.jsx("div", { className: 'sign-typed-data-preview--type-container', children: children }));
const TypeSection = ({ title, children, }) => (jsxRuntimeExports.jsxs("div", { children: [jsxRuntimeExports.jsx(TypeTitle, { children: title }), jsxRuntimeExports.jsx(PaddedContent, { children: children })] }));
const FieldRow = ({ name, displayValue, data, }) => (jsxRuntimeExports.jsxs("div", { className: 'sign-typed-data-preview--attribute-row', children: [jsxRuntimeExports.jsxs(AttributeName, { children: [capitalize$1(name), ": "] }), jsxRuntimeExports.jsx(AttributeValue, { title: data, children: displayValue })] }));

const containsSpecialCharacters = (value) => {
    // This regex checks for any characters outside the standard ASCII printable range and common control characters
    const regex = /[^ -~\s]/;
    return regex.test(value);
};

const safeJsonParse = (message) => {
    try {
        // First attempt a direct parse
        return JSON.parse(message);
    }
    catch (e) {
        if (message.includes('raw')) {
            // If that fails, attempt to fix newlines, then parse
            const fixed = message.replace(/\n/g, '\\n');
            return JSON.parse(fixed);
        }
        throw e;
    }
};

const SignMessagePreview = ({ message, }) => {
    const jsonMessage = useMemo(() => {
        try {
            const json = safeJsonParse(message);
            return json;
        }
        catch (e) {
            return undefined;
        }
    }, [message]);
    const messageText = useMemo(() => {
        const text = isRawMessage(jsonMessage) ? jsonMessage.raw : message;
        const readableText = isHex$1(text) ? hexToString(text) : text;
        return !containsSpecialCharacters(readableText) ? readableText : text;
    }, [jsonMessage, message]);
    if (isSignTypedData(jsonMessage)) {
        return (jsxRuntimeExports.jsx(SignTypedDataPreview, { currentType: jsonMessage.primaryType, types: jsonMessage.types, showTypeName: true, data: jsonMessage.message }));
    }
    return (jsxRuntimeExports.jsx(Typography, { color: 'primary', variant: 'body_normal', children: jsxRuntimeExports.jsx("span", { style: { whiteSpace: 'pre-line' }, children: messageText }) }));
};

const SignMessageConfirmationModal = ({ appLogoUrl, appName, message, handler, onReject, onSignMessage, hideModal, }) => {
    usePreventPageScroll(true);
    const didConfirmRef = useRef(false);
    const [show, setShow] = useState(true);
    const { initPasskeyRecoveryProcess, shouldInitRecovery } = usePasskeyRecovery();
    const { isTurnkeyWallet } = useIsTurnkeyWallet();
    const { setShowAuthFlow, primaryWallet } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const { userNeedsCrossDomainPasskey } = usePasskeyContext();
    const { t } = useTranslation();
    const { getEOAWallet } = useSmartWallets();
    const eoaWallet = primaryWallet && getEOAWallet(primaryWallet);
    const handleOnReject = useCallback(() => {
        didConfirmRef.current = false;
        setShow(false);
    }, [setShow]);
    const { isLoading, mutate: confirm, data: signedMessage, error: signMessageError, } = useMutation(() => handler(message), {
        onSuccess: () => {
            didConfirmRef.current = true;
            setShow(false);
        },
    });
    const errorText = useMemo(() => {
        if (!signMessageError) {
            return undefined;
        }
        if (signMessageError instanceof DynamicError) {
            return signMessageError.message;
        }
        try {
            return getProperErrorMessage(signMessageError);
        }
        catch (e) {
            if (e instanceof AccessBlockedError) {
                pushView('access-blocked');
            }
            return;
        }
    }, [signMessageError, pushView]);
    const handleOnModalUnmount = useCallback(() => {
        if (signedMessage) {
            return onSignMessage(signedMessage);
        }
        onReject(signMessageError || new UserRejectedRequestError());
    }, [signedMessage, onSignMessage, onReject, signMessageError]);
    const handleMessageSign = (signWithoutModal) => __awaiter$1(void 0, void 0, void 0, function* () {
        const isSessionKeyCompatible = (primaryWallet && isSessionKeyCompatibleWallet(primaryWallet)) ||
            (eoaWallet && isSessionKeyCompatibleWallet(eoaWallet));
        if ((yield shouldInitRecovery()) && !isSessionKeyCompatible) {
            yield initPasskeyRecoveryProcess('email', {
                type: 'signMessage',
            });
        }
        if (signWithoutModal === true) {
            onSignMessage('callHandlerOutsideModal');
            return;
        }
        if (isSessionKeyCompatible) {
            confirm();
            return;
        }
        if (isTurnkeyWallet && userNeedsCrossDomainPasskey) {
            pushView('passkey-new-domain-detected');
            setShowAuthFlow(true, {
                ignoreIfIsEmbeddedWidget: false,
                performMultiWalletChecks: false,
            });
            dynamicEvents.once('passkeyRecoveryCompleted', () => {
                confirm();
            });
            return;
        }
        confirm();
    });
    useEffectOnce(() => {
        if (hideModal) {
            handleMessageSign(true);
        }
    });
    const closeButton = (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: handleOnReject, "data-testid": 'close', disabled: isLoading, children: jsxRuntimeExports.jsx(SvgClose, {}) }));
    return hideModal ? null : (jsxRuntimeExports.jsx(Portal, { handleClose: handleOnReject, isShown: show, zIndex: authModalZIndex, withBackdrop: true, elementId: 'dynamic-sign-message', transitionEvents: {
            onUnmount: handleOnModalUnmount,
        }, children: jsxRuntimeExports.jsx(Modal, { children: jsxRuntimeExports.jsxs(ModalCard, { children: [jsxRuntimeExports.jsx(ModalHeader, { trailing: closeButton, alignContent: 'bottom', children: jsxRuntimeExports.jsx(IconWithSpinner, { Icon: (props) => (jsxRuntimeExports.jsx(Icon, { color: 'brand-primary', children: jsxRuntimeExports.jsx(SvgSignCircle, Object.assign({}, props)) })), iconSize: 64, isSpinning: true }) }), jsxRuntimeExports.jsx(PasskeyCreatedSuccessBanner, {}), jsxRuntimeExports.jsxs("div", { className: 'sign-message-confirmation__body', children: [jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', className: 'sign-message-confirmation__title', copykey: 'dyn_sign_message.title', children: t('dyn_sign_message.title') }), jsxRuntimeExports.jsx(AnimatePresence, { animationComponent: jsxRuntimeExports.jsx(VerticalDrawerTransition, {}), children: signMessageError && (jsxRuntimeExports.jsx("div", { className: 'sign-message-confirmation__error', children: jsxRuntimeExports.jsx(ErrorContainer, { children: errorText }) })) }), jsxRuntimeExports.jsxs("div", { className: 'sign-message-confirmation__message-container', children: [jsxRuntimeExports.jsx(AppOriginTile, { appLogoUrl: appLogoUrl, appName: appName, appOrigin: PlatformService.getDisplayOrigin() }), jsxRuntimeExports.jsx("div", { className: 'sign-message-confirmation__message', children: jsxRuntimeExports.jsx(SignMessagePreview
                                        // strip if entire message is a quote and replace escaped newlines
                                        , { 
                                            // strip if entire message is a quote and replace escaped newlines
                                            message: message
                                                .toString()
                                                .replace(/^"(.*)"$/, '$1')
                                                .replace(/\\n/g, '\n') }) })] }), jsxRuntimeExports.jsxs("div", { className: 'sign-message-confirmation__actions', children: [jsxRuntimeExports.jsx(TypographyButton, { buttonVariant: 'secondary', onClick: handleOnReject, expanded: true, buttonPadding: 'large', disabled: isLoading, copykey: 'dyn_sign_message.cancel_button', children: t('dyn_sign_message.cancel_button') }), jsxRuntimeExports.jsx(TypographyButton, { buttonVariant: 'primary', buttonPadding: 'large', onClick: handleMessageSign, expanded: true, loading: isLoading, copykey: 'dyn_sign_message.sign_button', dataTestId: 'sign-button', children: t('dyn_sign_message.sign_button') })] }), jsxRuntimeExports.jsx(NeedHelpSection, {}), jsxRuntimeExports.jsx(PoweredByDynamic, {})] })] }) }) }));
};

const ConfirmationModal = ({ modalId, closeModal, show, zIndex, handleOnModalUnmount, children, }) => (jsxRuntimeExports.jsx(Portal, { elementId: modalId, handleClose: closeModal, isShown: show, zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : authModalZIndex + 1, withBackdrop: true, transitionEvents: {
        onUnmount: handleOnModalUnmount,
    }, children: jsxRuntimeExports.jsx(Modal, { children: jsxRuntimeExports.jsx(ModalCard, { children: children }) }) }));

const useConfirmationPortal = ({ onResolve, onReject, defaultErrorMessage, }) => {
    usePreventPageScroll(true);
    const [show, setShow] = useState(true);
    const errorRef = useRef(null);
    const successResponseRef = useRef(null);
    const closeModal = useCallback(() => {
        setShow(false);
    }, [setShow]);
    const handleOnModalUnmount = useCallback(() => {
        if (successResponseRef.current) {
            return onResolve(successResponseRef.current);
        }
        const error = errorRef.current ||
            new DynamicError(defaultErrorMessage);
        return onReject(error);
    }, [onResolve, onReject, defaultErrorMessage]);
    const onSuccess = (response, closePortal = true) => {
        errorRef.current = null;
        successResponseRef.current = response;
        if (closePortal) {
            closeModal();
        }
    };
    const onError = (error, closePortal = false) => {
        successResponseRef.current = null;
        errorRef.current = error;
        if (closePortal) {
            closeModal();
        }
    };
    return {
        closeModal,
        handleOnModalUnmount,
        onError,
        onSuccess,
        show,
    };
};

const WidgetPortal = ({ children, onClose, disablePadding, portalClassName, portalContainerClassName, }) => (jsxRuntimeExports.jsx("div", { className: classNames(portalClassName, 'widget-portal'), onClick: onClose, "data-testid": 'backdrop', children: jsxRuntimeExports.jsxs("div", { className: classNames(portalContainerClassName, 'widget-portal__container', {
            'widget-portal__container--no-padding': disablePadding,
        }), onClick: (e) => e.stopPropagation(), children: [onClose && (jsxRuntimeExports.jsx("div", { className: 'widget-portal__container__header', children: jsxRuntimeExports.jsx(IconButton, { className: 'widget-portal__container__close-button', onClick: (e) => onClose(e), type: 'button', "data-testid": 'close-button', children: jsxRuntimeExports.jsx(SvgClose, {}) }) })), children] }) }));

const DefaultPromptLayout = ({ children, className = '', dataTestId = '', icon, showSpinnerInIcon = true, title, }) => (jsxRuntimeExports.jsxs("div", { className: classNames('default-prompt-modal', className), "data-testid": dataTestId, children: [icon && (jsxRuntimeExports.jsx(IconWithSpinner, { Icon: icon, iconSize: 96, isSpinning: showSpinnerInIcon, className: 'default-prompt-modal__icon-with-spinner' })), jsxRuntimeExports.jsxs("div", { className: 'default-prompt-modal__content', children: [title && (jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', "data-testid": 'title', children: title })), children] })] }));
const DefaultPromptModal = (props) => (jsxRuntimeExports.jsx(WidgetPortal, { onClose: props.onClose, portalClassName: 'prompt-modal-portal', portalContainerClassName: 'prompt-modal-portal__container', children: jsxRuntimeExports.jsx(DefaultPromptLayout, Object.assign({}, props)) }));

var _path$h;
var _excluded$h = ["title", "titleId"];
function _extends$h() { return _extends$h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$h.apply(null, arguments); }
function _objectWithoutProperties$h(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$h(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$h(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgArrowCircleRight = function SvgArrowCircleRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$h(_ref, _excluded$h);
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm10.293-3.707a1 1 0 0 1 1.414 0l3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 0 1-1.414-1.414L13.586 13H8a1 1 0 1 1 0-2h5.586l-1.293-1.293a1 1 0 0 1 0-1.414Z",
    fill: "#ABACB2"
  })));
};

const SwitchWalletView = ({ onCancel, connector, expectedAddress, activeAddress, }) => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsx(DefaultPromptModal, { dataTestId: 'switch-wallet', className: 'switch-wallet', icon: jsxRuntimeExports.jsx(WalletIcon, { icon: connector.metadata.icon, walletKey: connector.key }), title: t('dyn_sync_wallet.switch_wallet.title'), onClose: onCancel, children: jsxRuntimeExports.jsxs("div", { className: 'switch-wallet__body', children: [activeAddress && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_mini', color: 'secondary', weight: 'regular', copykey: 'dyn_sync_wallet.switch_wallet.active_address.heading', children: t('dyn_sync_wallet.switch_wallet.active_address.heading') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', weight: 'regular', children: shortenWalletAddress(activeAddress, 3, 3) }), jsxRuntimeExports.jsx(Divider, { className: 'switch-wallet__body__divider', children: jsxRuntimeExports.jsx(SvgArrowCircleRight, {}) })] })), jsxRuntimeExports.jsx(Typography, { variant: 'body_mini', color: 'secondary', weight: 'regular', copykey: 'dyn_sync_wallet.switch_wallet.expected_address.heading', children: t('dyn_sync_wallet.switch_wallet.expected_address.heading') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', weight: 'regular', copykey: 'dyn_sync_wallet.switch_wallet.expected_address.prompt', className: 'switch-wallet__body__expected-address__prompt', children: t('dyn_sync_wallet.switch_wallet.expected_address.prompt') }), jsxRuntimeExports.jsx(Typography, { color: 'green-1', weight: 'bold', className: 'switch-wallet__body__expected-address__address', children: shortenWalletAddress(expectedAddress, 3, 3) })] }) }));
};

const ReconnectWithQrCodeView = ({ onCancel, onSuccess, connector, expectedAddress, }) => {
    var _a;
    const { t } = useTranslation();
    const { theme: { theme }, } = useThemeContext();
    const { name: themeName } = theme;
    const [qrcodeUri, setQrcodeUri] = useState();
    const [desktopUri, setDesktopUri] = useState();
    usePromise(() => __awaiter$1(void 0, void 0, void 0, function* () {
        const publicAddress = yield connector.getAddress({
            onDesktopUri: (uri) => __awaiter$1(void 0, void 0, void 0, function* () {
                setDesktopUri(uri);
            }),
            onDisplayUri: (uri) => __awaiter$1(void 0, void 0, void 0, function* () {
                setQrcodeUri(uri);
            }),
        });
        if (publicAddress &&
            isSameAddress(publicAddress, expectedAddress, connector.connectedChain)) {
            onSuccess();
            return;
        }
        connector.endSession();
        onCancel();
    }), { deps: [connector], retries: 3 });
    return (jsxRuntimeExports.jsx(DefaultPromptModal, { dataTestId: 'reconnect-qr-code', title: t('dyn_sync_wallet.reconnect_with_qr_code.title'), onClose: onCancel, children: qrcodeUri && (jsxRuntimeExports.jsx(QrCodeWrapper, { uri: qrcodeUri, desktopUri: desktopUri, accentColor: 
            /* istanbul ignore next */
            themeName === 'dark'
                ? theme.colors.textPrimary
                : (_a = connector.metadata.brandColor) !== null && _a !== void 0 ? _a : '', icon: 
            // eslint-disable-next-line react/jsx-wrap-multilines
            jsxRuntimeExports.jsx(WalletIcon, { icon: connector.metadata.icon, walletKey: connector.key }), showCopyToClipboardButton: true, walletConnector: connector })) }));
};

/**
 * This function will use a referenced account to kick off the social wallet
 * authentication. This is useful in the multiwallet scenario where the user
 * wants to set their disconnected social wallet as their primary wallet, in
 * which case the wallet needs to be reconnected
 */
const reconnectSocialWallet = (user, connector, walletAddress, walletChain) => __awaiter$1(void 0, void 0, void 0, function* () {
    if (!isSocialWalletConnector(connector)) {
        return;
    }
    const socialAccountDataForWallet = user === null || user === void 0 ? void 0 : user.verifiedCredentials.find((account) => account.format === JwtVerifiedCredentialFormatEnum.Oauth &&
        account.address &&
        isSameAddress(account.address, walletAddress, walletChain));
    if (!socialAccountDataForWallet ||
        !socialAccountDataForWallet.oauthProvider) {
        return;
    }
    yield connector.connect(socialAccountDataForWallet.oauthProvider);
});

const AutoReconnectingView = ({ onCancel, onSuccess, connector, expectedAddress, }) => {
    const { t } = useTranslation();
    const { user } = useInternalDynamicContext();
    usePromise(() => __awaiter$1(void 0, void 0, void 0, function* () {
        if (isSocialWalletConnector(connector)) {
            yield reconnectSocialWallet(user, connector, expectedAddress, connector.connectedChain);
            onSuccess();
        }
    }), { deps: [connector] });
    return (jsxRuntimeExports.jsx(DefaultPromptModal, { dataTestId: 'auto-reconnecting', icon: jsxRuntimeExports.jsx(WalletIcon, { icon: connector.metadata.icon, walletKey: connector.key }), title: t('dyn_sync_wallet.reconnecting.title'), onClose: onCancel, children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', weight: 'regular', children: t('dyn_sync_wallet.reconnecting.description', {
                walletAddress: shortenWalletAddress(expectedAddress, 3, 3),
            }) }) }));
};

const SyncWalletView = ({ onSuccess, onError, expectedAddress, activeAddress, connector, }) => {
    const showQrCodeModal = connector.canConnectViaQrCode &&
        !connector.isInstalledOnBrowser() &&
        !connector.canConnectViaCustodialService;
    logger$1.logVerboseTroubleshootingMessage('[SyncWallet]', {
        canConnectViaCustodialService: connector.canConnectViaCustodialService,
        canConnectViaQrCode: connector.canConnectViaQrCode,
        isEmbeddedWallet: connector.isEmbeddedWallet,
        isInstalledOnBrowser: connector.isInstalledOnBrowser(),
    });
    useWalletConnectorEvent(connector, 'accountChange', ({ accounts }) => {
        logger$1.logVerboseTroubleshootingMessage('[SyncWallet] accountChange', {
            accounts,
            expectedAddress,
        });
        const [selectedAccountAddress] = accounts;
        if (isSameAddress(selectedAccountAddress, expectedAddress, connector.connectedChain)) {
            onSuccess(true);
        }
    });
    useInternalDynamicEvents('logout', () => onError(new Error('user logged out'), true));
    const handleTryToReconnect = () => __awaiter$1(void 0, void 0, void 0, function* () {
        const reconnectAddress = yield connector.getAddress();
        if (reconnectAddress &&
            isSameAddress(reconnectAddress, expectedAddress, connector.connectedChain)) {
            onSuccess(true);
        }
    });
    const handleCancel = () => {
        logger$1.logVerboseTroubleshootingMessage('[SyncWallet] handleCancel called');
        onError(new DynamicError('User cancelled', '0'), true);
    };
    if (connector.isEmbeddedWallet) {
        return (jsxRuntimeExports.jsx("div", { className: 'sync-wallet-view', "data-testid": 'sync-wallet', children: jsxRuntimeExports.jsx(AutoReconnectingView, { connector: connector, expectedAddress: expectedAddress, onCancel: handleCancel, onSuccess: () => onSuccess(true) }) }));
    }
    if (showQrCodeModal) {
        return (jsxRuntimeExports.jsx("div", { className: 'sync-wallet-view', "data-testid": 'sync-wallet', children: jsxRuntimeExports.jsx(ReconnectWithQrCodeView, { connector: connector, expectedAddress: expectedAddress, onCancel: handleCancel, onSuccess: () => onSuccess(true) }) }));
    }
    return (jsxRuntimeExports.jsx("div", { className: 'sync-wallet-view', "data-testid": 'sync-wallet', children: jsxRuntimeExports.jsx(SwitchWalletView, { connector: connector, expectedAddress: expectedAddress, activeAddress: activeAddress, onCancel: handleCancel, onTryToReconnect: handleTryToReconnect }) }));
};

const SyncWalletPromptModal = ({ expectedAddress, connector, onResolve, onReject, activeAddress, }) => {
    const { onSuccess, onError, show, handleOnModalUnmount } = useConfirmationPortal({
        defaultErrorMessage: 'User canceled',
        onReject,
        onResolve,
    });
    return (jsxRuntimeExports.jsx(ConfirmationModal, { modalId: 'sync-wallet-modal', show: show, closeModal: () => { }, handleOnModalUnmount: handleOnModalUnmount, children: jsxRuntimeExports.jsx(SyncWalletView, { onSuccess: onSuccess, onError: onError, expectedAddress: expectedAddress, connector: connector, activeAddress: activeAddress }) }));
};

const TransactionConfirmationModal = ({ title, onReject, onTransactionResponseSuccess, transaction, copykey, walletConnector, hideModal, isNativeToken, currentToken, }) => {
    usePreventPageScroll(true);
    const [show, setShow] = useState(true);
    const errorRef = useRef(null);
    const transactionResponseRef = useRef(null);
    const closeModal = useCallback(() => {
        setShow(false);
    }, [setShow]);
    const handleOnModalUnmount = useCallback(() => {
        if (transactionResponseRef.current) {
            return onTransactionResponseSuccess(transactionResponseRef.current);
        }
        return onReject(errorRef.current || new UserRejectedTransactionError());
    }, [onTransactionResponseSuccess, onReject]);
    return (jsxRuntimeExports.jsx(Portal, { handleClose: closeModal, isShown: show, zIndex: authModalZIndex, withBackdrop: true, elementId: 'dynamic-send-transaction', transitionEvents: {
            onUnmount: handleOnModalUnmount,
        }, children: jsxRuntimeExports.jsx(Modal, { children: jsxRuntimeExports.jsx(ModalCard, { children: jsxRuntimeExports.jsx(TransactionConfirmationView, { transaction: transaction, title: title, copykey: copykey, hideModal: hideModal, mutation: () => transaction.submit(), onClickClose: closeModal, onError: (error) => (errorRef.current = error), displayPoweredByDynamicFooter: true, walletConnector: walletConnector, onSuccess: (transactionResponse) => {
                        errorRef.current = null;
                        transactionResponseRef.current = transactionResponse;
                        closeModal();
                    }, isNativeToken: isNativeToken, currentToken: currentToken, isModal: true }) }) }) }));
};

const AddNetworkView = ({ walletConnector, network, addNetworkMutation, onCancel, onNetworkAdded, }) => {
    const { t } = useTranslation();
    const { iconUrls, name } = network;
    const [iconUrl] = iconUrls;
    const { mutate: addNetwork } = useMutation(addNetworkMutation, {
        onSuccess: onNetworkAdded,
    });
    const NetworkIcon = (props) => (jsxRuntimeExports.jsx("img", Object.assign({}, props, { src: iconUrl, className: 'add-network-view__network-icon', alt: `${name} icon` })));
    return (jsxRuntimeExports.jsxs("div", { "data-testid": 'add-network-view', className: 'add-network-view', children: [jsxRuntimeExports.jsx(ModalHeader, { alignContent: 'bottom' }), jsxRuntimeExports.jsxs("div", { className: 'add-network-view__body', children: [jsxRuntimeExports.jsx(IconWithStatus, { Icon: NetworkIcon, iconSize: 64, InnerIcon: SvgError, variant: 'red' }), jsxRuntimeExports.jsxs("div", { className: 'add-network-view__text-container', children: [jsxRuntimeExports.jsx(Typography, { weight: 'bold', variant: 'body_normal', color: 'primary', copykey: 'dyn_add_network_view.title', className: 'add-network-view__title', children: t('dyn_add_network_view.title') }), jsxRuntimeExports.jsx(Typography, { weight: 'regular', variant: 'body_small', color: 'secondary', copykey: 'dyn_add_network_view.description', className: 'add-network-view__description', children: t('dyn_add_network_view.description', {
                                    name: walletConnector.metadata.name,
                                }) })] }), jsxRuntimeExports.jsxs("div", { className: 'add-network-view__actions', children: [jsxRuntimeExports.jsx(Button$1, { expanded: true, buttonVariant: 'primary', onClick: () => onCancel(), dataTestId: 'add-network-view__cancel-button', children: jsxRuntimeExports.jsx(Typography, { copykey: 'dyn_add_network_view.cancel_button.title', children: t('dyn_add_network_view.cancel_button.title') }) }), jsxRuntimeExports.jsx(Button$1, { expanded: true, buttonVariant: 'brand-primary', onClick: () => addNetwork(), children: jsxRuntimeExports.jsx(Typography, { copykey: 'dyn_add_network_view.add_button.title', children: t('dyn_add_network_view.add_button.title') }) })] })] })] }));
};

const AddNetworkModal = ({ walletConnector, network, onCancel, onNetworkAdded, addNetworkMutation, }) => {
    const { onSuccess, show, handleOnModalUnmount, closeModal } = useConfirmationPortal({
        defaultErrorMessage: 'User canceled',
        onReject: onCancel,
        onResolve: onNetworkAdded,
    });
    return (jsxRuntimeExports.jsx(ConfirmationModal, { modalId: 'prompt-to-add-network', show: show, 
        // Disables the closing by clicking outside the modal
        closeModal: () => { }, handleOnModalUnmount: handleOnModalUnmount, children: jsxRuntimeExports.jsx(AddNetworkView, { walletConnector: walletConnector, addNetworkMutation: addNetworkMutation, network: network, onCancel: closeModal, onNetworkAdded: onSuccess }) }));
};

const useWalletUiUtils = ({ appLogoUrl, appName, hideEmbeddedWalletTransactionUIs = false, }) => {
    const confirmationStateRef = useRef('enabled');
    const { t } = useTranslation();
    const { modal: sendTransactionModal, open: openSendTransaction } = useConfirmationModal({
        elementId: 'dynamic-send-transaction',
    });
    const { modal: signMessageModal, open: openSignMessage } = useConfirmationModal({
        elementId: 'dynamic-sign-message',
    });
    const { modal: syncWalletPromptModal, open: openSyncWalletPrompt } = useConfirmationModal({
        elementId: 'dynamic-sync-wallet',
    });
    const { modal: addNetworkModal, open: openAddNetwork } = useConfirmationModal({
        elementId: 'dynamic-prompt-to-add-network',
    });
    const shouldConfirmAction = useCallback(() => {
        if (confirmationStateRef.current === 'disabled') {
            confirmationStateRef.current = 'enabled';
            return false;
        }
        return true;
    }, [confirmationStateRef]);
    const signMessage = useCallback((_a) => __awaiter$1(void 0, [_a], void 0, function* ({ walletConnector, message, handler }) {
        // prevent the modal from opening itself again
        if (!shouldConfirmAction())
            return handler();
        return openSignMessage((resolve, reject) => (jsxRuntimeExports.jsx(SignMessageConfirmationModal, { appLogoUrl: appLogoUrl, appName: appName, message: message, handler: handler, onSignMessage: resolve, onReject: reject, hideModal: hideEmbeddedWalletTransactionUIs &&
                !(walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.isGlobalTransaction) }))).then((signedMessage) => __awaiter$1(void 0, void 0, void 0, function* () {
            if (signedMessage === 'callHandlerOutsideModal')
                return handler();
            else
                return signedMessage;
        }));
    }), [
        appLogoUrl,
        appName,
        hideEmbeddedWalletTransactionUIs,
        openSignMessage,
        shouldConfirmAction,
    ]);
    const sendTransaction = useCallback((walletConnector, transaction) => __awaiter$1(void 0, void 0, void 0, function* () {
        // prevent the modal from opening itself again
        if (!shouldConfirmAction())
            return transaction.submit();
        return openSendTransaction((resolve, reject) => (jsxRuntimeExports.jsx(TransactionConfirmationModal, { copykey: 'dyn_send_transaction.confirmation.title', title: t('dyn_send_transaction.confirmation.title'), transaction: transaction, onTransactionResponseSuccess: resolve, onReject: reject, walletConnector: walletConnector, hideModal: hideEmbeddedWalletTransactionUIs &&
                !(walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.isGlobalTransaction) }))).then((signedTransaction) => __awaiter$1(void 0, void 0, void 0, function* () {
            if (signedTransaction === 'callHandlerOutsideModal')
                return transaction.submit();
            else
                return signedTransaction;
        }));
    }), [
        hideEmbeddedWalletTransactionUIs,
        openSendTransaction,
        shouldConfirmAction,
        t,
    ]);
    // Solana only
    const signTransaction = useCallback((walletConnector, transaction) => __awaiter$1(void 0, void 0, void 0, function* () {
        // prevent the modal from opening itself again
        if (!shouldConfirmAction())
            return transaction.submit();
        return openSendTransaction((resolve, reject) => (jsxRuntimeExports.jsx(TransactionConfirmationModal, { copykey: 'dyn_send_transaction.confirmation.title', title: t('dyn_send_transaction.confirmation.title'), transaction: transaction, onTransactionResponseSuccess: resolve, onReject: reject, walletConnector: walletConnector, hideModal: hideEmbeddedWalletTransactionUIs &&
                !(walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.isGlobalTransaction) }))).then((signedTransaction) => __awaiter$1(void 0, void 0, void 0, function* () {
            if (signedTransaction === 'callHandlerOutsideModal')
                return transaction.submit();
            else
                return signedTransaction;
        }));
    }), [
        hideEmbeddedWalletTransactionUIs,
        openSendTransaction,
        shouldConfirmAction,
        t,
    ]);
    const syncWallet = useCallback((_b) => __awaiter$1(void 0, [_b], void 0, function* ({ walletConnector, activeAddress, expectedAddress }) {
        yield openSyncWalletPrompt((resolve, reject) => (jsxRuntimeExports.jsx(SyncWalletPromptModal, { onResolve: resolve, onReject: reject, connector: walletConnector, expectedAddress: expectedAddress, activeAddress: activeAddress })));
    }), [openSyncWalletPrompt]);
    const addNetwork = useCallback((_c) => __awaiter$1(void 0, [_c], void 0, function* ({ handler, network, walletConnector }) {
        yield openAddNetwork((resolve) => (jsxRuntimeExports.jsx(AddNetworkModal, { network: network, walletConnector: walletConnector, onCancel: resolve, onNetworkAdded: resolve, addNetworkMutation: handler })));
    }), [openAddNetwork]);
    const disabledConfirmationOnce = useCallback(() => {
        confirmationStateRef.current = 'disabled';
    }, []);
    const walletUiUtils = useMemo(() => ({
        addNetwork,
        disabledConfirmationOnce,
        sendTransaction,
        signMessage,
        signTransaction,
        syncWallet,
    }), [
        signMessage,
        signTransaction,
        disabledConfirmationOnce,
        sendTransaction,
        syncWallet,
        addNetwork,
    ]);
    return useMemo(() => [
        signMessageModal ||
            sendTransactionModal ||
            syncWalletPromptModal ||
            addNetworkModal,
        walletUiUtils,
    ], [
        signMessageModal,
        sendTransactionModal,
        syncWalletPromptModal,
        addNetworkModal,
        walletUiUtils,
    ]);
};

const useSetWalletConnectorFetchers = (walletOptions, environmentId, projectSettings) => {
    const { registerEmbeddedWalletSessionKey, removeSessionKey } = useEmbeddedWalletSessionKeys({ environmentId, projectSettings });
    if (!(walletOptions === null || walletOptions === void 0 ? void 0 : walletOptions.length))
        return;
    walletOptions.forEach((walletOption) => {
        var _a, _b;
        if (isSessionKeyCompatibleWalletConnector(walletOption.walletConnector)) {
            (_a = walletOption.walletConnector) === null || _a === void 0 ? void 0 : _a.setSessionKeyFetcher(registerEmbeddedWalletSessionKey);
            (_b = walletOption.walletConnector) === null || _b === void 0 ? void 0 : _b.setSessionKeyRemoveFunction(() => removeSessionKey());
        }
    });
};

const useSendDynamicProps = ({ settings, environmentId, }) => {
    useEffectOnce(() => {
        // we ReactNode components are not being serialized properly
        // remove them for now and deal with them later
        // context: https://linear.app/dynamic-labs/issue/GVTY-328/[starknet]-sdk-api-is-not-serializing-react-components
        // future work: https://linear.app/dynamic-labs/issue/GVTY-330/bug-figure-out-why-react-components-are-not
        const updatedDynamicProps = {
            settings: Object.assign(Object.assign({}, settings), { customPrivacyPolicy: Boolean(settings.customPrivacyPolicy), customTermsOfServices: Boolean(settings.customTermsOfServices), policiesConsentInnerComponent: Boolean(settings.policiesConsentInnerComponent) }),
        };
        const serializedEventsCallbacks = serializeEventsCallbacks(settings.events);
        const serializedWalletConnectors = serializeWalletConnectors(settings.walletConnectors);
        const serializedDynamicContextProps = Object.assign(Object.assign({}, updatedDynamicProps), { settings: Object.assign(Object.assign({}, updatedDynamicProps.settings), { events: serializedEventsCallbacks, walletConnectors: serializedWalletConnectors }) });
        sendDynamicProps(environmentId, {
            dynamicContextProps: serializedDynamicContextProps,
            frameworkSettings: getFrameworkSettings(),
        });
    });
};
const serializeEventsCallbacks = (events) => {
    try {
        if (!events)
            return undefined;
        const eventsCallbackValues = Object.values(events);
        const eventsKeys = Object.keys(events);
        return eventsKeys.filter((key, index) => {
            if (eventsCallbackValues[index] === undefined) {
                return false;
            }
            return key;
        });
    }
    catch (error) {
        logger$1.error('error serializing events', error);
        return undefined;
    }
};
const getFrameworkSettings = () => {
    var _a;
    return ({
        nextJs: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            version: (_a = window.next) === null || _a === void 0 ? void 0 : _a.version,
        },
        react: {
            version: version$j,
        },
    });
};

const useResetCookieLocalStorage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const didRefreshUserRef = useRef(false);
    const user = getUser();
    const environmentId = useEnvironmentId();
    const projectSettings = useProjectSettings();
    /**
     * As an extra layer of safety, we must explicitly prevent the refresh from being called
     * after a logout
     */
    const hasLoggedOut = useRef(false);
    useInternalDynamicEvents('logout', () => (hasLoggedOut.current = true));
    /**
     * run this effect every time the user or project settings change
     * but not when the process was already done.
     */
    useEffect(() => {
        /**
         * this method is called on refresh of DynamicContext and attempts to refresh local storage
         * when cookies are enabled for the environment.
         * the use case here is when an end user logs in to sub1.example.com and navigates to sub2.example.com.
         * if they are signed in to sub1.example.com with a cookie for `.example.com`, but the LS is specific
         * to sub1, then navigating to sub2 will mean they are not automatically signed in.
         * this method attempts to fetch the user from the backend using the cookie (if aavailable), and if successful,
         * this will ensure local storage is properly set with the user.
         *
         * this will also attempt to set the primaryWalletId, if the last verified credential is a wallet
         * the user might have signed in with a wallet in the other subdomain, but the primary wallet
         * in local storage does not carry over to other subdomains (LS is subdomain-specific),
         * so attempt to set it here.
         */
        const maybeInitUserRefresh = () => __awaiter$1(void 0, void 0, void 0, function* () {
            if (!user &&
                projectSettings &&
                isCookieEnabled(projectSettings) &&
                !hasLoggedOut.current) {
                // Disable all next calls to this method
                didRefreshUserRef.current = true;
                try {
                    const user = yield refreshUserJwt({ environmentId });
                    /**
                     * attempt to set primary wallet in this subdomain because LS does not
                     * carry over between different subdomains, even if the cookie does
                     */
                    const lastVerifiedWallet = user === null || user === void 0 ? void 0 : user.verifiedCredentials.find((vc) => vc.format === JwtVerifiedCredentialFormatEnum.Blockchain &&
                        vc.id === user.lastVerifiedCredentialId);
                    if (lastVerifiedWallet) {
                        updatePrimaryWalletId(lastVerifiedWallet.id);
                    }
                }
                catch (e) {
                    logger$1.debug('Ignore failed refreshUserJwt in useResetCookieLocalStorage');
                }
            }
            if (projectSettings) {
                // only set to false if projectSettings are available,
                // otherwise isCookieEnabled might be a false negative
                setIsLoading(false);
            }
        });
        // Ensure this effect only runs once projectSettings is available
        if (didRefreshUserRef.current || !projectSettings)
            return;
        maybeInitUserRefresh();
    }, [user, projectSettings, environmentId]);
    return { isLoading };
};

let didLog = false;
const useEndUserWarning = ({ suppress = false, projectSettings, }) => {
    useEffect(() => {
        var _a;
        if (!suppress &&
            !didLog &&
            (projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.environmentName) === EnvironmentEnum.Live) {
            didLog = true;
            logger$1.info('%cWarning!', 'color: red; font-size: 32px;');
            logger$1.info('%cThis is a browser feature intended for developers. You are reading this message because you opened the browser console, a developer tool.\n\n%c1. Never share your tokens or sensitive information with anyone.\n2. Do not paste any code you do not fully understand.\n3. If someone instructed you to do this, it is likely a scam.\n\n%cInjecting code into your browser could result in loss of tokens or control of your account that cannot be recovered or protected.', 'font-size: 16px;', 'font-size: 12px;', 'color: red; font-size: 12px;');
            if (((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.general) === null || _a === void 0 ? void 0 : _a.supportUrls) &&
                Object.values(projectSettings.general.supportUrls).length > 0) {
                logger$1.info(`%cFor more information, visit ${Object.values(projectSettings.general.supportUrls)[0]}`, 'font-size: 12px;');
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.environmentName, suppress]);
};

const useDeviceFingerprint = () => {
    const [lsFingerprint, setLsFingerprint] = useLocalStorage(DEVICE_FINGERPRINT, undefined);
    const fingerprintExists = lsFingerprint !== '' && lsFingerprint !== undefined ? true : false;
    usePromise(() => __awaiter$1(void 0, void 0, void 0, function* () {
        if (typeof window === 'undefined' || typeof document === 'undefined')
            return undefined;
        return import('./thumbmark.esm-BwyWW-om.js')
            .then((thumbmark) => thumbmark.getFingerprint())
            .catch(() => undefined);
    }), {
        deps: [fingerprintExists],
        enabled: !fingerprintExists,
        initialData: undefined,
        onResolve: setLsFingerprint,
        retries: 2,
    });
    const consumeDeviceFingerprint = useCallback(() => {
        const deviceFingerprint = lsFingerprint;
        return deviceFingerprint;
    }, [lsFingerprint]);
    return {
        consumeDeviceFingerprint: () => consumeDeviceFingerprint(),
    };
};

const useAggregateWalletEvents = () => {
    const { userWallets } = useInternalUserWallets();
    const findPrimaryWallet = (wallets) => wallets.find((wallet) => wallet.id === getPrimaryWalletId());
    useInternalDynamicEvents('walletAdded', (wallet, userWallets) => {
        dynamicEvents.emit('userWalletsChanged', {
            addedWallet: wallet,
            primaryWallet: findPrimaryWallet(userWallets),
            updateType: 'walletAdded',
            userWallets,
        });
    });
    useInternalDynamicEvents('walletRemoved', (wallet, userWallets) => {
        dynamicEvents.emit('userWalletsChanged', {
            primaryWallet: findPrimaryWallet(userWallets),
            removedWallet: wallet,
            updateType: 'walletRemoved',
            userWallets,
        });
    });
    useInternalDynamicEvents('primaryWalletChanged', (newPrimaryWallet) => {
        dynamicEvents.emit('userWalletsChanged', {
            primaryWallet: newPrimaryWallet,
            updateType: 'primaryWalletChanged',
            userWallets,
        });
    });
    useInternalDynamicEvents('primaryWalletNetworkChanged', (newNetwork) => {
        dynamicEvents.emit('userWalletsChanged', {
            newNetwork,
            primaryWallet: findPrimaryWallet(userWallets),
            updateType: 'primaryWalletNetworkChanged',
            userWallets,
        });
    });
    useInternalDynamicEvents('nonPrimaryWalletNetworkChanged', (newNetwork, connector) => {
        const affectedWallets = userWallets.filter((wallet) => wallet.connector.key === connector.key);
        dynamicEvents.emit('userWalletsChanged', {
            affectedWallets,
            newNetwork,
            primaryWallet: findPrimaryWallet(userWallets),
            updateType: 'nonPrimaryWalletNetworkChanged',
            userWallets,
        });
    });
};

const createEmailHandler = (environmentId, { shouldRegisterSessionKeysOnSignin, generateSessionKey, }) => (email, captchaToken) => __awaiter$1(void 0, void 0, void 0, function* () {
    const createEmailVerificationResponse = yield createEmailVerification({
        captchaToken,
        email,
        environmentId,
    });
    let { verificationUUID } = createEmailVerificationResponse;
    return {
        retry: () => __awaiter$1(void 0, void 0, void 0, function* () {
            const retryEmailVerificationResponse = yield retryEmailVerification({
                email,
                environmentId,
                verificationUUID,
            });
            // eslint-disable-next-line prefer-destructuring
            verificationUUID = retryEmailVerificationResponse.verificationUUID;
        }),
        type: 'email',
        verify: (oneTimePassword, options) => __awaiter$1(void 0, void 0, void 0, function* () {
            let sessionPublicKey = undefined;
            if (shouldRegisterSessionKeysOnSignin()) {
                const keypair = yield generateSessionKey();
                sessionPublicKey = keypair.publicKey;
            }
            const response = yield signInWithEmailVerification({
                captchaToken,
                environmentId,
                sessionPublicKey,
                verificationToken: oneTimePassword,
                verificationUUID,
            });
            // Skip setting the user auth token and only return the VerifyResponse
            // if needed because setUser can trigger view re-renders.
            if (!(options === null || options === void 0 ? void 0 : options.skipSetUserAndAuthToken)) {
                storeAuthTokenAndUser(response);
            }
            return {
                destination: email,
                response: response,
                verified: true,
            };
        }),
    };
});

const createSmsHandler = (environmentId, { shouldRegisterSessionKeysOnSignin, generateSessionKey, }) => (phone, captchaToken) => __awaiter$1(void 0, void 0, void 0, function* () {
    const { verificationUUID } = yield createSmsVerification({
        captchaToken,
        environmentId,
        isoCountryCode: phone.iso2,
        phoneCountryCode: phone.dialCode,
        phoneNumber: phone.phone,
    });
    return {
        type: 'sms',
        verify: (oneTimePassword, options) => __awaiter$1(void 0, void 0, void 0, function* () {
            let sessionPublicKey = undefined;
            if (shouldRegisterSessionKeysOnSignin()) {
                const keypair = yield generateSessionKey();
                sessionPublicKey = keypair.publicKey;
            }
            const response = yield signInWithSmsVerification({
                captchaToken,
                environmentId,
                sessionPublicKey,
                verificationToken: oneTimePassword,
                verificationUUID,
            });
            // Skip setting the user auth token and only return the VerifyResponse
            // if needed because setUser can trigger view re-renders.
            if (!(options === null || options === void 0 ? void 0 : options.skipSetUserAndAuthToken)) {
                storeAuthTokenAndUser(response);
            }
            return {
                destination: phone,
                response: response,
                verified: true,
            };
        }),
    };
});

const findEmailProvider = (environmentId, email) => __awaiter$1(void 0, void 0, void 0, function* () {
    const { emailProvider } = yield getEmailProvider({
        email,
        environmentId,
    });
    if (!allSupportedProviders.includes(emailProvider)) {
        throw new Error('Email provider is not supported');
    }
    return emailProvider;
});

const { Provider } = ConnectWithOtpContext;
const ConnectWithOtpProvider = ({ children }) => {
    const { environmentId, projectSettings, setCallback } = useInternalDynamicContext();
    const embeddedWalletSessionKeys = useEmbeddedWalletSessionKeys({
        environmentId,
        projectSettings,
    });
    const lastVerificationHandlerRef = useRef(null);
    const providers = (projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers) || [];
    const mapProvider = {
        [ProviderEnum.Dynamic]: {
            enabled: isProviderEnabled(providers, ProviderEnum.Dynamic),
            handler: createEmailHandler(environmentId, embeddedWalletSessionKeys),
        },
    };
    const connectWithEmail = (email, options) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!isEmailValid(email)) {
            throw new Error('Email is not valid');
        }
        const effectiveEmailProvider = (options === null || options === void 0 ? void 0 : options.provider) || (yield findEmailProvider(environmentId, email));
        if (!mapProvider[effectiveEmailProvider].enabled) {
            throw new Error('Email provider is not enabled');
        }
        const verificationHandler = yield mapProvider[effectiveEmailProvider].handler(email, options === null || options === void 0 ? void 0 : options.captchaToken);
        lastVerificationHandlerRef.current = verificationHandler;
    });
    const connectWithSms = (phone, options) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!isProviderEnabled(providers, ProviderEnum.Sms)) {
            throw new Error('SMS provider is not enabled');
        }
        const handler = createSmsHandler(environmentId, embeddedWalletSessionKeys);
        const verificationHandler = yield handler(phone, options === null || options === void 0 ? void 0 : options.captchaToken);
        lastVerificationHandlerRef.current = verificationHandler;
    });
    const verifyOneTimePassword = (oneTimePassword, options) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!lastVerificationHandlerRef.current) {
            throw new Error('Verification has not started, use connectWithEmail or connectWithSms before verifying');
        }
        const { type, verify } = lastVerificationHandlerRef.current;
        const { destination, response, verified } = yield verify(oneTimePassword, options);
        if (type === 'sms') {
            dynamicEvents.emit('smsVerificationResult', verified, destination);
        }
        else {
            //EMAIL
            dynamicEvents.emit('emailVerificationResult', verified, destination);
        }
        // Avoid calling authSuccess if we're only verifying
        if (!(options === null || options === void 0 ? void 0 : options.skipSetUserAndAuthToken)) {
            setCallback('authSuccess');
        }
        return response;
    });
    const retryOneTimePassword = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!lastVerificationHandlerRef.current) {
            throw new Error('Verification has not started, use connectWithEmail or connectWithSms before verifying');
        }
        if (!lastVerificationHandlerRef.current.retry) {
            throw new Error('Re-send is not supported');
        }
        return lastVerificationHandlerRef.current.retry();
    });
    return (jsxRuntimeExports.jsx(Provider, { value: {
            connectWithEmail,
            connectWithSms,
            retryOneTimePassword,
            verifyOneTimePassword,
        }, children: children }));
};

const useSyncOnboardingFlow = ({ handler: headlessHandler, } = {}) => {
    const { setShowAuthFlow, userWithMissingInfo, sdkHasLoaded, setSelectedWalletConnectorKey, } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const { updateUser } = useUserUpdateRequestInternal({
        validationSchemaStripUnknown: false,
    });
    const { completeAuth, handleAuthError } = useUserAuth({});
    const { displayedDestination: formattedPhone } = useVerification();
    const triggeredOnboarding = useRef(false);
    useInternalDynamicEvents('logout', () => {
        triggeredOnboarding.current = false;
    });
    // this is used to trigger onboarding flow
    // either by headless or dynamic widget
    // it will be triggered when user has missing fields
    // either on login or refreshing the page
    useEffect(() => {
        var _a;
        const handleHeadlessOnboarding = () => __awaiter$1(void 0, void 0, void 0, function* () {
            var _b;
            if (!headlessHandler || !((_b = userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.missingFields) === null || _b === void 0 ? void 0 : _b.length)) {
                return;
            }
            triggeredOnboarding.current = true;
            try {
                const missingFieldsRequestInput = userWithMissingInfo.missingFields.map((field) => ({
                    isCustom: field.type === 'custom',
                    key: field.name,
                    label: field.label,
                    required: field.required,
                }));
                const onboardingResponse = yield headlessHandler(missingFieldsRequestInput);
                const userFields = {};
                const customFields = Object.assign({}, userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.metadata);
                onboardingResponse.forEach((field) => {
                    if (field.isCustom) {
                        customFields[field.key] = field.value;
                    }
                    else {
                        userFields[field.key] = field.value;
                    }
                });
                yield completeAuth({
                    updateJwtFunction: () => __awaiter$1(void 0, void 0, void 0, function* () { return updateUser(Object.assign(Object.assign({}, userFields), { metadata: customFields })); }),
                });
            }
            catch (error) {
                logger$1.error('Error handling user onboarding', error);
                handleAuthError(error, {});
            }
        });
        const handleOnboarding = () => __awaiter$1(void 0, void 0, void 0, function* () {
            triggeredOnboarding.current = true;
            setShowAuthFlow(true);
            const lastVerifiedCredential = userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.verifiedCredentials.find((vc) => vc.id === (userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.lastVerifiedCredentialId));
            if (lastVerifiedCredential === null || lastVerifiedCredential === void 0 ? void 0 : lastVerifiedCredential.walletName) {
                setSelectedWalletConnectorKey(lastVerifiedCredential === null || lastVerifiedCredential === void 0 ? void 0 : lastVerifiedCredential.walletName);
            }
            switch (lastVerifiedCredential === null || lastVerifiedCredential === void 0 ? void 0 : lastVerifiedCredential.format) {
                case JwtVerifiedCredentialFormatEnum.Email:
                case JwtVerifiedCredentialFormatEnum.Oauth:
                    pushView('collect-user-data-login-no-wallet', {
                        userIdentification: 'email',
                    });
                    break;
                case JwtVerifiedCredentialFormatEnum.PhoneNumber:
                    pushView('collect-user-data-login-no-wallet', {
                        userIdentification: 'phoneNumber',
                        userIdentificationOverride: formattedPhone,
                    });
                    break;
                default:
                    pushView('collect-user-data');
            }
        });
        if (!sdkHasLoaded ||
            triggeredOnboarding.current ||
            !((_a = userWithMissingInfo === null || userWithMissingInfo === void 0 ? void 0 : userWithMissingInfo.missingFields) === null || _a === void 0 ? void 0 : _a.length) ||
            hasPendingMfaAction(userWithMissingInfo)) {
            return;
        }
        if (headlessHandler) {
            handleHeadlessOnboarding();
            return;
        }
        handleOnboarding();
        return;
    }, [
        sdkHasLoaded,
        userWithMissingInfo,
        headlessHandler,
        completeAuth,
        updateUser,
        setShowAuthFlow,
        pushView,
        formattedPhone,
        handleAuthError,
        setSelectedWalletConnectorKey,
    ]);
};

/**
 * This hook is used to ensure we show the correct MFA view on page refresh
 */
const useSyncMfaFlow = ({ handler: headlessHandler, } = {}) => {
    const { setShowAuthFlow, userWithMissingInfo, sdkHasLoaded } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const { getUserDevices } = useMfa();
    // this is used to make sure we only trigger the effect once
    const triggered = useRef(false);
    useInternalDynamicEvents('logout', () => {
        triggered.current = false;
    });
    useEffect(() => {
        var _a;
        // boilterplate: we don't want to run the sync logic if the sdk hasn't finished loading,
        // or if the effect has already been triggered
        if (!sdkHasLoaded || triggered.current) {
            return;
        }
        // this is the case when the user has fully logged in and completed all mfa steps if needed,
        // like accepting their backup codes after enrolling
        if (!userWithMissingInfo || !hasPendingMfaAction(userWithMissingInfo)) {
            return;
        }
        triggered.current = true;
        // if a handler is provided, we assume "headless mode"
        if (headlessHandler) {
            setShowAuthFlow(false);
            headlessHandler();
            return;
        }
        /**
         * There are two scenarios:
         *   1. The user has not yet completed mfa
         *   2. The user has completed mfa, but has not yet acknowledged their backup codes
         *
         * In scenario 1, the user scope will contain 'requiresAdditionalAuth'. In this case, we need
         * to show the enrollment view or verification view, depending on whether the user has devices
         *
         * In scenario 2, the user scope will not contain 'requiresAdditionalAuth', and the user
         * mfaBackupCodeAcknowledgement field will be 'pending'. In this case, we need to show the
         * backup codes view
         */
        setShowAuthFlow(true);
        if ((_a = userWithMissingInfo.scope) === null || _a === void 0 ? void 0 : _a.includes('requiresAdditionalAuth')) {
            getUserDevices().then((devices) => {
                if (devices.length === 0) {
                    pushView('mfa-choose-device');
                }
                else {
                    pushView('mfa-verification');
                }
            });
        }
        else {
            pushView('mfa-display-backup-codes');
        }
    }, [
        getUserDevices,
        sdkHasLoaded,
        setShowAuthFlow,
        pushView,
        userWithMissingInfo,
        headlessHandler,
    ]);
};

const SyncAuthFlow = () => {
    useSyncOnboardingFlow();
    useSyncEmbeddedWalletFlow();
    useSyncMfaFlow();
    return null;
};

const Switch = ({ disabled = false, firstButton, secondButton, thirdButton, }) => (jsxRuntimeExports.jsxs("div", { className: classNames('switch__container', { disabled: disabled }), children: [jsxRuntimeExports.jsx("button", { disabled: disabled, className: classNames('button', { active: firstButton.active }), onClick: firstButton.handleButtonClick, children: firstButton.name }), jsxRuntimeExports.jsx("button", { disabled: disabled, className: classNames('button', { active: secondButton.active }), onClick: secondButton.handleButtonClick, children: secondButton.name }), thirdButton && (jsxRuntimeExports.jsx("button", { disabled: disabled, className: classNames('button', { active: thirdButton.active }), onClick: thirdButton.handleButtonClick, children: thirdButton.name }))] }));

const ThemeSwitch = () => {
    const { changeTheme, theme } = useThemeContext();
    return (jsxRuntimeExports.jsx(Switch, { firstButton: {
            active: theme.theme.name === 'light',
            handleButtonClick: () => changeTheme('light'),
            name: 'Light',
        }, secondButton: {
            active: theme.theme.name === 'dark',
            handleButtonClick: () => changeTheme('dark'),
            name: 'Dark',
        }, thirdButton: {
            active: theme.theme.name === 'auto',
            handleButtonClick: () => changeTheme('auto'),
            name: 'Auto',
        } }));
};

const PrimaryColorInput = () => {
    const { changePrimaryColor, theme } = useThemeContext();
    const [color, setColor] = useState(theme.customColor);
    return (jsxRuntimeExports.jsx(Input, { id: 'primary-color', label: 'Primary color', value: color, onChange: (e) => setColor(e.target.value), onBlur: (e) => {
            const newColor = color || theme.customColor;
            setColor(newColor);
            changePrimaryColor(newColor);
        } }));
};

const AuthModeSwitch = ({ authMode, setAuthMode, }) => (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("div", { className: 'auth-mode-switch__container', children: [jsxRuntimeExports.jsx(Checkbox, { checked: authMode === 'connect-and-sign', onChange: () => setAuthMode('connect-and-sign'), id: 'connect-and-sign' }), jsxRuntimeExports.jsx("label", { htmlFor: 'connect-and-sign', children: jsxRuntimeExports.jsx(Typography, { color: 'primary', weight: 'regular', children: "Connect and sign" }) })] }), jsxRuntimeExports.jsxs("div", { className: 'auth-mode-switch__container', children: [jsxRuntimeExports.jsx(Checkbox, { checked: authMode === 'connect-only', onChange: () => setAuthMode('connect-only'), id: 'connect-only' }), jsxRuntimeExports.jsx("label", { htmlFor: 'connect-only', children: jsxRuntimeExports.jsx(Typography, { color: 'primary', weight: 'regular', children: "Connect only" }) })] })] }));

const LoginWithEmailSwitch = () => {
    const { loginWithEmail, setLogInWithEmail } = useInternalDynamicContext();
    return (jsxRuntimeExports.jsx(Switch, { firstButton: {
            active: loginWithEmail,
            handleButtonClick: () => setLogInWithEmail(true),
            name: 'True',
        }, secondButton: {
            active: !loginWithEmail,
            handleButtonClick: () => setLogInWithEmail(false),
            name: 'False',
        } }));
};

const LoginWithEmailViewDisplayPriorityOrderSwitch = () => {
    const { authorizationViewDisplayOrder, setAuthorizationViewDisplayOrder, loginWithEmail, } = useInternalDynamicContext();
    return (jsxRuntimeExports.jsx(Switch, { disabled: !loginWithEmail, firstButton: {
            active: authorizationViewDisplayOrder === 'web2',
            handleButtonClick: () => setAuthorizationViewDisplayOrder('web2'),
            name: 'Email',
        }, secondButton: {
            active: authorizationViewDisplayOrder === 'web3',
            handleButtonClick: () => setAuthorizationViewDisplayOrder('web3'),
            name: 'Wallet',
        } }));
};

const TemplateSelect = () => {
    const { theme, changeTemplate } = useThemeContext();
    const handleChange = (e) => {
        changeTemplate(e.target.value);
    };
    return (jsxRuntimeExports.jsxs(Select, { label: 'template', value: theme.template, onChange: handleChange, selectDataTestId: 'template-select', children: [jsxRuntimeExports.jsx("option", { value: 'default', children: "Default" }), jsxRuntimeExports.jsx("option", { value: 'matrix', children: "Matrix" }), jsxRuntimeExports.jsx("option", { value: 'minimal', children: "Minimal" }), jsxRuntimeExports.jsx("option", { value: 'rounded', children: "Rounded" }), jsxRuntimeExports.jsx("option", { value: 'trinity', children: "Trinity" })] }));
};

const Toolkit = () => {
    const { projectSettings, user, showAuthFlow, showDynamicUserProfile, toolkitEnabled, authMode, setAuthMode, } = useInternalDynamicContext();
    const isToolkitVisible = useMemo(() => {
        if (!toolkitEnabled)
            return false;
        return showDynamicUserProfile || showAuthFlow;
    }, [showAuthFlow, showDynamicUserProfile, toolkitEnabled]);
    if (!isToolkitVisible)
        return null;
    return (jsxRuntimeExports.jsx(ShadowDOM, { dataTestId: 'toolkit-shadowdom', className: 'toolkit-shadowdom', zIndex: toolkitZIndex, children: jsxRuntimeExports.jsxs("div", { className: 'toolkit__container', children: [jsxRuntimeExports.jsxs("div", { className: 'toolkit__switcher', children: [jsxRuntimeExports.jsx(Typography, { className: 'switcher__copy', as: 'h2', variant: 'body_normal', children: "Theme" }), jsxRuntimeExports.jsx(ThemeSwitch, {})] }), jsxRuntimeExports.jsxs("div", { className: 'toolkit__switcher', children: [jsxRuntimeExports.jsx(Typography, { className: 'switcher__copy', as: 'h2', variant: 'body_normal', children: "Template" }), jsxRuntimeExports.jsx(TemplateSelect, {})] }), jsxRuntimeExports.jsxs("div", { className: 'toolkit__switcher', children: [jsxRuntimeExports.jsx(Typography, { className: 'switcher__copy', as: 'h2', variant: 'body_normal', children: "Primary Color" }), jsxRuntimeExports.jsx(PrimaryColorInput, {})] }), !user && (jsxRuntimeExports.jsxs("div", { className: 'toolkit__switcher', children: [jsxRuntimeExports.jsx(Typography, { className: 'switcher__copy', as: 'h2', variant: 'body_normal', children: "Auth mode" }), jsxRuntimeExports.jsx(AuthModeSwitch, { authMode: authMode, setAuthMode: setAuthMode })] })), isEmailProviderEnabled((projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers) || []) && !user && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("div", { className: 'toolkit__switcher', children: [jsxRuntimeExports.jsx(Typography, { className: 'switcher__copy', as: 'h2', variant: 'body_normal', children: "Log in with Email" }), jsxRuntimeExports.jsx(LoginWithEmailSwitch, {})] }), jsxRuntimeExports.jsxs("div", { className: 'toolkit__switcher', children: [jsxRuntimeExports.jsx(Typography, { className: 'switcher__copy', as: 'h2', variant: 'body_normal', children: "Email vs Wallet priority" }), jsxRuntimeExports.jsx(LoginWithEmailViewDisplayPriorityOrderSwitch, {})] })] }))] }) }));
};

const WalletConnectorEvents = ({ connectorProps, }) => {
    const { walletConnectorOptions, primaryWallet } = useInternalDynamicContext();
    const { handleWalletItemClick } = useWalletItemActions();
    const walletConnectorConstructorOptions = useMemo(() => {
        var _a, _b;
        if (!connectorProps.projectSettings ||
            !connectorProps.networkConfigurations ||
            !isWalletBookPopulated(connectorProps.walletBook)) {
            return;
        }
        return getWalletConnectorConstructorOptions(Object.assign(Object.assign({}, connectorProps), { chainRpcProviders: ChainRpcProviders, settings: connectorProps.projectSettings, walletConnectProjectId: (_b = (_a = connectorProps.projectSettings) === null || _a === void 0 ? void 0 : _a.sdk.walletConnect) === null || _b === void 0 ? void 0 : _b.projectId }));
    }, [connectorProps]);
    // add listener for providerInjected event
    useEffect(() => {
        const handleProviderInjected = ({ injectedConnectorConstructor, }) => {
            if (!walletConnectorConstructorOptions)
                return;
            const injectedConnector = new injectedConnectorConstructor(walletConnectorConstructorOptions);
            logger$1.debug('[WalletConnectorEvents] handleProviderInjected', {
                injectedConnector,
            });
            walletConnectorEvents.emit('providerReady', {
                connector: injectedConnector,
            });
        };
        walletConnectorEvents.on('providerInjected', handleProviderInjected);
        return () => {
            walletConnectorEvents.off('providerInjected', handleProviderInjected);
        };
    }, [walletConnectorConstructorOptions]);
    // add listener for providerReady event
    useEffect(() => {
        const handleProviderReady = ({ connector, }) => {
            logger$1.debug('[WalletConnectorEvents] handleProviderReady', {
                connector,
            });
            let foundWallet = false;
            const updatedConnectors = walletConnectorOptions.map((walletOption) => {
                if (walletOption.key === connector.key) {
                    foundWallet = true;
                    return Object.assign(Object.assign({}, walletOption), { isInstalledOnBrowser: connector.isInstalledOnBrowser(), walletConnector: connector });
                }
                return walletOption;
            });
            logger$1.debug('[WalletConnectorEvents] handleProviderReady', {
                foundWallet,
            });
            if (!foundWallet) {
                const newWalletOption = createWallet(connectorProps.walletBook, connector);
                updatedConnectors.push(newWalletOption);
            }
            mergeWalletConnectorOptions(updatedConnectors);
        };
        if (!isWalletBookPopulated(connectorProps.walletBook)) {
            return;
        }
        walletConnectorEvents.on('providerReady', handleProviderReady);
        return () => {
            walletConnectorEvents.off('providerReady', handleProviderReady);
        };
    }, [connectorProps.walletBook, walletConnectorOptions]);
    // add listener for autoConnect event
    useEffect(() => {
        const handleAutoConnect = ({ connector, }) => {
            logger$1.debug('[WalletConnectorEvents] handleAutoConnect', { connector });
            const walletOption = walletConnectorOptions.find((wallet) => wallet.walletConnector.key === connector.key);
            logger$1.debug('[WalletConnectorEvents] handleAutoConnect - found walletOption', Boolean(walletOption));
            if (!walletOption)
                return;
            handleWalletItemClick(walletOption);
        };
        // if there's a connected wallet, we should not auto connect another wallet
        if (primaryWallet) {
            return;
        }
        walletConnectorEvents.on('autoConnect', handleAutoConnect);
        return () => {
            walletConnectorEvents.off('autoConnect', handleAutoConnect);
        };
    }, [handleWalletItemClick, walletConnectorOptions, primaryWallet]);
    return null;
};

const shouldFetchNonce = ({ authMode }) => authMode === 'connect-and-sign' || isMobile();

const getMissingChains = (arr1, arr2) => {
    if (!arr1 || !arr2) {
        return;
    }
    // create a Set of all 'chain' values from the second array
    const chainSet = new Set(arr2.map((obj) => obj.walletChain));
    // filter out objects from the first array that have 'chain' present in the set
    const uniqueChains = arr1.filter((obj) => !chainSet.has(obj.chain));
    return uniqueChains;
};

const themeModes = ['light', 'dark', 'auto'];
const isThemeSetting = (theme) => themeModes.includes(theme);

const parseTheme = (theme, projectSettingsDesignModal) => isThemeSetting(theme)
    ? getThemeConfig(projectSettingsDesignModal, theme)
    : theme;

const validTransitions$2 = {
    idle: ['linking_new_wallet', 'primary_not_connected', 'switching_primary'],
    linking_new_wallet: ['idle'],
    primary_not_connected: ['idle'],
    switching_primary: ['idle'],
};
const validateStateTransition$2 = ({ from, to, }) => {
    if (from !== to && !validTransitions$2[from].includes(to)) {
        throw new Error(`Invalid AccountSwitch state transition from ${from} to ${to}`);
    }
    return true;
};
const validateMultiWalletWidgetState$1 = (multiWalletWidgetState) => {
    if (multiWalletWidgetState !== 'awaiting_account_switch') {
        throw new Error(`Invalid MultiWalletWidget state while trying to set AccountSwitch state: ${multiWalletWidgetState}` +
            '\nExpected: awaiting_account_switch');
    }
};
const useAwaitingAccountSwitch = () => {
    const [accountSwitchState, setInternalAccountSwitchState] = useState('idle');
    const resetState = useCallback(() => {
        setInternalAccountSwitchState('idle');
    }, [setInternalAccountSwitchState]);
    const setAccountSwitchState = useCallback((newAccountSwitchState, widgetState) => {
        validateMultiWalletWidgetState$1(widgetState);
        validateStateTransition$2({
            from: accountSwitchState,
            to: newAccountSwitchState,
        });
        setInternalAccountSwitchState(newAccountSwitchState);
    }, [accountSwitchState]);
    return [accountSwitchState, setAccountSwitchState, resetState];
};

const validTransitions$1 = {
    idle: ['linking_new_wallet', 'transferring_wallet'],
    linking_new_wallet: ['idle'],
    transferring_wallet: ['idle'],
};
const validateStateTransition$1 = ({ from, to, }) => {
    if (from !== to && !validTransitions$1[from].includes(to)) {
        throw new Error(`Invalid AwaitingSignature state transition from ${from} to ${to}`);
    }
    return true;
};
const validateMultiWalletWidgetState = (multiWalletWidgetState) => {
    if (multiWalletWidgetState !== 'awaiting_signature') {
        throw new Error(`Invalid MultiWalletWidget state while trying to set AwaitingSignature state: ${multiWalletWidgetState}` +
            '\nExpected: awaiting_signature');
    }
};
const useAwaitingSignature = () => {
    const [awaitingSignatureState, setInternalAwaitingSignatureState] = useState('idle');
    const resetState = useCallback(() => {
        setInternalAwaitingSignatureState('idle');
    }, [setInternalAwaitingSignatureState]);
    const setAwaitingSignatureState = useCallback((newAwaitingSignatureState, widgetState) => {
        validateMultiWalletWidgetState(widgetState);
        validateStateTransition$1({
            from: awaitingSignatureState,
            to: newAwaitingSignatureState,
        });
        setInternalAwaitingSignatureState(newAwaitingSignatureState);
    }, [awaitingSignatureState]);
    return [
        awaitingSignatureState,
        setAwaitingSignatureState,
        resetState,
    ];
};

const validTransitions = {
    awaiting_account_switch: ['awaiting_signature', 'idle'],
    awaiting_connection: ['idle'],
    awaiting_signature: ['idle'],
    detected_new_wallet: ['awaiting_signature', 'idle'],
    idle: [
        'awaiting_account_switch',
        'awaiting_connection',
        'awaiting_signature',
        'detected_new_wallet',
    ],
};
const validateStateTransition = ({ from, to, }) => {
    if (from !== to && !validTransitions[from].includes(to)) {
        throw new Error(`Invalid MultiWalletWidget state transition from ${from} to ${to}`);
    }
    return true;
};
const useMultiWalletWidgetState = () => {
    const [multiWalletWidgetState, setCoreMultiWalletWidgetState] = useState('idle');
    const [accountSwitchState, setAccountSwitchState, resetAccountSwitchState] = useAwaitingAccountSwitch();
    const [awaitingSignatureState, setAwaitingSignatureState, resetAwaitingSignatureState,] = useAwaitingSignature();
    const resetSubStates = useCallback(() => {
        resetAccountSwitchState();
        resetAwaitingSignatureState();
    }, [resetAccountSwitchState, resetAwaitingSignatureState]);
    const setMultiWalletWidgetState = useCallback((newWidgetState, newAccountSwitchState, newAwaitingSignatureState) => {
        validateStateTransition({
            from: multiWalletWidgetState,
            to: newWidgetState,
        });
        setCoreMultiWalletWidgetState(newWidgetState);
        resetSubStates();
        if (newAccountSwitchState) {
            setAccountSwitchState(newAccountSwitchState, newWidgetState);
        }
        if (newAwaitingSignatureState) {
            setAwaitingSignatureState(newAwaitingSignatureState, newWidgetState);
        }
    }, [
        multiWalletWidgetState,
        resetSubStates,
        setAccountSwitchState,
        setAwaitingSignatureState,
    ]);
    return [
        multiWalletWidgetState,
        setMultiWalletWidgetState,
        {
            awaiting_account_switch: [accountSwitchState, setAccountSwitchState],
            awaiting_signature: [awaitingSignatureState, setAwaitingSignatureState],
        },
    ];
};

const useClearWalletConnectSessions = ({ connectors }) => {
    const clearAllWalletConnectSessions = useCallback(() => {
        if (typeof window === 'undefined')
            return;
        for (const key of StorageService.getKeys()) {
            if (key.startsWith('walletconnect') ||
                key.startsWith('walletlink') ||
                key.startsWith('wc@2')) {
                localStorage.removeItem(key);
            }
        }
        // remove embedded wallet session iframe
        connectors === null || connectors === void 0 ? void 0 : connectors.forEach((connector) => {
            var _a, _b, _c;
            if ((_b = (_a = connector === null || connector === void 0 ? void 0 : connector.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.startsWith('turnkey')) {
                (_c = connector
                    .getAuthenticatorHandler()) === null || _c === void 0 ? void 0 : _c.clear();
                StorageService.removeItem(EMBEDDED_WALLET_SESSION_SETTINGS);
                StorageService.removeItem(EMBEDDED_WALLET_SECURE_BANNER);
            }
        });
    }, [connectors]);
    // Clears orphaned wallet connect sessions
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        if (connectors.length === 0)
            return;
        const keys = new Set(connectors.map((connector) => connector.key));
        for (const key of StorageService.getKeys()) {
            if (key.startsWith('walletconnect') &&
                !keys.has(key.replace('walletconnect-', ''))) {
                localStorage.removeItem(key);
            }
        }
    }, [connectors]);
    return { clearAllWalletConnectSessions };
};

/**
 * Generates a unique id for a wallet, based on the address,
 * connector key, and chain.
 * This is used to identify a wallet no matter if it's connected only or linked.
 */
const getWalletUniqueId = ({ address, connectorKey, chain, }) => `${connectorKey}-${address}-${chain}`;

const revokeSession = (_a) => __awaiter$1(void 0, [_a], void 0, function* ({ environmentId, sessionId, }) {
    try {
        yield sdkApi().revokeSession({
            environmentId,
        });
    }
    catch (error) {
        yield logResponseError(error, 'Error revoking session');
    }
});
const mapChainToChainEnum = (chain) => {
    const foundChain = Object.values(ChainEnum).find((value) => value === chain);
    if (!foundChain) {
        throw new DynamicError(`Invalid chain ${chain}`);
    }
    return foundChain;
};
const mapProviderToProviderEnum = (provider) => {
    const foundProvider = Object.values(WalletProviderEnum).find((value) => value === provider);
    if (!foundProvider) {
        throw new DynamicError(`Invalid provider ${provider}`);
    }
    return foundProvider;
};
const mapAuthModeToEnum = (authMode) => {
    const found = Object.values(AuthModeEnum).find((value) => value === authMode);
    if (!found) {
        throw new DynamicError(`Invalid authMode ${authMode}`);
    }
    return found;
};
const createVisit = (_b) => __awaiter$1(void 0, [_b], void 0, function* ({ authMode, chain, environmentId, walletProvider, publicWalletAddress, walletName, }) {
    try {
        const connectRequest = {
            address: publicWalletAddress,
            authMode: mapAuthModeToEnum(authMode),
            chain: mapChainToChainEnum(chain),
            provider: mapProviderToProviderEnum(walletProvider),
            walletName,
        };
        yield sdkApi().createVisit({
            connectRequest,
            environmentId,
        });
    }
    catch (error) {
        yield logResponseError(error, 'Error creating visit');
    }
});

const getWalletConnectorForWallet = (wallet) => {
    var _a, _b;
    if (!wallet) {
        return undefined;
    }
    const walletConnectorOptions = getWalletConnectorOptions();
    const { key: walletKey, chain } = wallet;
    const walletConnector = (_a = walletConnectorOptions.find((wallet) => walletKey === wallet.key &&
        wallet.walletConnector.connectedChain === chain)) === null || _a === void 0 ? void 0 : _a.walletConnector;
    if (walletConnector) {
        return walletConnector;
    }
    const fallbackConnector = (_b = walletConnectorOptions.find((wallet) => wallet.key === 'fallbackconnector')) === null || _b === void 0 ? void 0 : _b.walletConnector;
    return fallbackConnector;
};

/**
 * This takes a userWallets and connectedWallets array, and returns a new userWallets array
 * updated to match the connectedWallets array.
 * It will add any missing wallets, update properties that don't match, and remove wallets that aren't
 * in the connectedWallets and is not linked to the user.
 */
const updateUserWalletsFromConnectedWallets = (userWallets, connectedWallets) => {
    const userWalletsCopy = [...userWallets];
    /** We will use this to find wallets addresses that were removed */
    const newWalletsAddresses = new Set();
    const newWalletsChains = new Set();
    // First pass: add missing wallets and update changed properties
    for (const connectedWallet of connectedWallets) {
        newWalletsAddresses.add(connectedWallet.address);
        newWalletsChains.add(connectedWallet.chain);
        const userWallet = userWalletsCopy.find((wallet) => wallet.address === connectedWallet.address &&
            wallet.chain === connectedWallet.chain);
        // Catch new wallets
        if (!userWallet) {
            userWalletsCopy.push(connectedWallet);
        }
    }
    // This filter is to remove a wallet that was previously added to userWallets but is not present
    // among the connected wallets (it should not be removed if it's authenticated to the user tho)
    return userWalletsCopy.filter((userWallet) => 
    // Keep wallets that are still in the new list
    (newWalletsAddresses.has(userWallet.address) &&
        newWalletsChains.has(userWallet.chain)) ||
        // Or are linked to the current user
        userWallet.isAuthenticated);
};

const useConnectWallet = ({ authMode, enableVisitTrackingOnConnectOnly, environmentId, primaryWalletId, walletConnectorOptions, handleConnectedWallet, setShowAuthFlow, isBridgeFlow, user, }) => {
    const [connectedWalletsInfo, setConnectedWalletsInfo, removeConnectedWalletsInfo,] = useLocalStorage(CONNECTED_WALLETS_INFO, []);
    const [connectedWallets, _setConnectedWallets] = useState([]);
    const { setUserWallets, addedWalletsIds, removedWalletsIds } = useInternalUserWallets();
    /** This wrapper is to ensure userWallets is always properly updated alongside connectedWallets */
    const setConnectedWallets = useCallback((newWallets) => {
        _setConnectedWallets(newWallets);
        setUserWallets((userWallets) => updateUserWalletsFromConnectedWallets(userWallets, newWallets));
    }, [setUserWallets]);
    const disconnectWallet = useCallback((walletId) => __awaiter$1(void 0, void 0, void 0, function* () {
        const walletToDisconnect = connectedWallets.find((wallet) => wallet.id === walletId);
        yield (walletToDisconnect === null || walletToDisconnect === void 0 ? void 0 : walletToDisconnect.connector.endSession());
        const updatedConnectedWalletsInfo = connectedWalletsInfo.filter((wallet) => wallet.id !== walletId);
        setConnectedWalletsInfo(updatedConnectedWalletsInfo);
        removedWalletsIds.current.push(walletId);
        if (walletId !== primaryWalletId) {
            return;
        }
        const hasConnectedWallet = updatedConnectedWalletsInfo.length > 0;
        if (isBridgeFlow || !hasConnectedWallet) {
            resetPrimaryWalletId();
        }
        else {
            updatePrimaryWalletId(updatedConnectedWalletsInfo[0].id);
        }
    }), [
        connectedWallets,
        connectedWalletsInfo,
        isBridgeFlow,
        primaryWalletId,
        removedWalletsIds,
        setConnectedWalletsInfo,
    ]);
    // The function to update and define the connectedWallets list.
    // It should be called on the first render, when connectedWalletsInfo updates and when walletConnectorOptions updates.
    // To avoid unnecessary updates that are causing issues with connectors added asynchronously,
    // we're debouncing this function
    const updateConnectedWalletsList = useDebounce(() => __awaiter$1(void 0, void 0, void 0, function* () {
        const walletConnectors = walletConnectorOptions.map((wallet) => wallet.walletConnector);
        if (!walletConnectors.length) {
            return;
        }
        const updatedConnectedWallets = (yield Promise.all(connectedWalletsInfo.map((storedConnectedWalletInfo) => __awaiter$1(void 0, void 0, void 0, function* () {
            const walletConnector = getWalletConnectorByKey(walletConnectors, storedConnectedWalletInfo.walletConnectorKey);
            if (!walletConnector) {
                logger$8.error('Could not find walletConnector: ' +
                    storedConnectedWalletInfo.walletConnectorKey);
                yield disconnectWallet(storedConnectedWalletInfo.id);
                return null;
            }
            if (isHardwareWalletConnector(walletConnector) &&
                storedConnectedWalletInfo.hardwareWallet ===
                    HardwareWalletEnum.Ledger) {
                walletConnector.isHardwareWalletEnabled = true;
            }
            const [walletAddress] = yield walletConnector.getConnectedAccounts();
            if (!walletAddress) {
                yield disconnectWallet(storedConnectedWalletInfo.id);
                return null;
            }
            const additionalAddresses = yield walletConnector.getAdditionalAddresses(walletAddress);
            const walletChain = walletConnector.connectedChain;
            const walletObject = walletConnector.createWallet({
                additionalAddresses,
                address: walletAddress,
                chain: walletChain,
                connector: walletConnector,
                id: storedConnectedWalletInfo.id,
                isAuthenticated: false,
                key: walletConnector.key,
            });
            return walletObject;
        })))).filter((wallet) => Boolean(wallet));
        setConnectedWallets(updatedConnectedWallets);
    }), 300);
    // Generate the connectedWallets list when connectedWalletsInfo (localStorage) or memoized wallet connector updates
    useEffect(() => {
        updateConnectedWalletsList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectedWalletsInfo, walletConnectorOptions]);
    const updateConnectedWalletById = useCallback((walletId, walletObject) => {
        var _a;
        const clonedConnectedWalletsList = [...connectedWallets];
        const connectedWalletIndex = clonedConnectedWalletsList.findIndex((connectedWallet) => connectedWallet.id === walletId);
        if (connectedWalletIndex < 0) {
            return;
        }
        clonedConnectedWalletsList[connectedWalletIndex] =
            clonedConnectedWalletsList[connectedWalletIndex].connector.createWallet(Object.assign(Object.assign({}, clonedConnectedWalletsList[connectedWalletIndex]), { address: (_a = walletObject.address) !== null && _a !== void 0 ? _a : clonedConnectedWalletsList[connectedWalletIndex].address, connector: getWalletConnectorForWallet(clonedConnectedWalletsList[connectedWalletIndex]) }));
        setConnectedWallets(clonedConnectedWalletsList);
    }, [connectedWallets, setConnectedWallets]);
    // Keeps connected wallet data inside localStorage
    const applyConnectedWalletToStore = useCallback(({ walletId, walletConnectorKey, walletChain, provider, }) => {
        const updatedConnectedWalletsInfo = [...connectedWalletsInfo];
        const walletConnectors = walletConnectorOptions.map((wallet) => wallet.walletConnector);
        const walletConnector = getWalletConnectorByKey(walletConnectors, walletConnectorKey);
        const hardwareWallet = walletConnector &&
            isHardwareWalletConnector(walletConnector) &&
            walletConnector.isHardwareWalletEnabled
            ? HardwareWalletEnum.Ledger
            : undefined;
        updatedConnectedWalletsInfo.push({
            hardwareWallet,
            id: walletId,
            provider,
            walletChain,
            walletConnectorKey,
        });
        setConnectedWalletsInfo(updatedConnectedWalletsInfo);
    }, [connectedWalletsInfo, setConnectedWalletsInfo, walletConnectorOptions]);
    // Updates connected wallet (network and address) and verifies connected wallet connection
    const refreshConnectedWallet = (walletId, walletConnector) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (shouldManuallyReconnectOnRefresh(walletConnector)) {
            yield walletConnector.connect();
        }
        const currentWalletConnectorAddress = yield walletConnector.getAddress();
        if (currentWalletConnectorAddress && handleConnectedWallet) {
            const shouldProceedWithConnection = yield handleConnectedWallet({
                address: currentWalletConnectorAddress,
                chain: walletConnector.connectedChain,
                connector: walletConnector,
            });
            if (!shouldProceedWithConnection) {
                logger$8.info('Connection was not established because handleConnectedWallet returned false');
                disconnectWallet(walletId);
                setShowAuthFlow(false, { emitCancelAuth: true });
                return;
            }
        }
        updateConnectedWalletById(walletId, {
            address: currentWalletConnectorAddress,
        });
    });
    const connectWallet = useCallback((walletConnector, getAddressOpts, options) => __awaiter$1(void 0, void 0, void 0, function* () {
        const { applyHandleConnectedWallet = true } = options !== null && options !== void 0 ? options : {};
        const walletAddress = yield walletConnector.getAddress(getAddressOpts);
        if (!walletAddress) {
            throw new MissingPublicAddressError();
        }
        if (handleConnectedWallet && applyHandleConnectedWallet) {
            const shouldProceedWithConnection = yield handleConnectedWallet({
                address: walletAddress,
                chain: walletConnector.connectedChain,
                connector: walletConnector,
            });
            if (!shouldProceedWithConnection) {
                logger$8.info('Connection was not established because handleConnectedWallet returned false');
                setShowAuthFlow(false);
                return;
            }
        }
        const isWalletStored = connectedWalletsInfo.some(({ walletConnectorKey: storedWalletConnectorKey }) => storedWalletConnectorKey === walletConnector.key);
        const walletChain = walletConnector.connectedChain;
        const shouldCreateVisit = !isWalletStored &&
            (authMode !== 'connect-only' || enableVisitTrackingOnConnectOnly);
        if (shouldCreateVisit) {
            // send information to backend to kick off background jobs
            // so verify/sign on the next step could go by more quickly
            // this is async work, but DO NOT AWAIT
            createVisit({
                authMode,
                chain: walletChain || '',
                environmentId,
                publicWalletAddress: walletAddress,
                walletName: walletConnector.key,
                walletProvider: getWalletProvider(walletConnector),
            });
        }
        // On connect and sign, we don't want to add this wallet to userWallets
        // until it has been signed. Therefore, we don't add it to
        // the connectedWallets array because userWallets draws from it.
        // In this scenario we only need the wallet address, since the id will come from somewhere else.
        // In fact, there is a refactor planned to never use the connect-wallet-X ids anymore:
        // https://linear.app/dynamic-labs/issue/QNTM-784/rework-the-way-we-compute-wallet-ids
        if (!isConnectOnly(user, authMode))
            return { address: walletAddress, id: '' };
        const walletId = getWalletUniqueId({
            address: walletAddress,
            chain: walletConnector.connectedChain,
            connectorKey: walletConnector.key,
        });
        if (!primaryWalletId) {
            updatePrimaryWalletId(walletId);
        }
        addedWalletsIds.current.push(walletId);
        if (isWalletStored) {
            yield updateConnectedWalletsList();
        }
        else {
            applyConnectedWalletToStore({
                provider: getWalletProvider(walletConnector),
                walletAddress: walletAddress,
                walletChain,
                walletConnectorKey: walletConnector.key,
                walletId,
            });
        }
        return { address: walletAddress, id: walletId };
    }), [
        addedWalletsIds,
        applyConnectedWalletToStore,
        authMode,
        connectedWalletsInfo,
        enableVisitTrackingOnConnectOnly,
        environmentId,
        handleConnectedWallet,
        primaryWalletId,
        setShowAuthFlow,
        updateConnectedWalletsList,
        user,
    ]);
    const getConnectedWalletById = useCallback((walletId) => connectedWallets.find((wallet) => wallet.id === walletId), [connectedWallets]);
    return {
        connectWallet,
        connectedWallets,
        connectedWalletsInfo,
        disconnectWallet,
        getConnectedWalletById,
        refreshConnectedWallet,
        removeConnectedWalletsInfo,
    };
};

const useFetchWalletsForChainsMap = (propsWalletsChainsMap) => {
    const walletsForChainsMap = useMemo(() => {
        if (!propsWalletsChainsMap) {
            return defaultWalletsForChains;
        }
        return Object.assign(Object.assign({}, defaultWalletsForChains), { primary_chain: propsWalletsChainsMap.primary_chain, wallets: Object.assign(Object.assign({}, defaultWalletsForChains.wallets), (Boolean(propsWalletsChainsMap.wallets) &&
                propsWalletsChainsMap.wallets)) });
    }, [propsWalletsChainsMap]);
    return { walletsForChainsMap };
};

const useHandleUnlinkWallet = ({ verifiedCredentials, environmentId, primaryWalletId, secondaryWallets, }) => {
    const { removedWalletsIds } = useInternalUserWallets();
    const callback = useCallback((walletId) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a;
        // when we call handleUnlinkWallet on the same execution stack as setPrimaryWallet, the value of
        // primaryWalletId coming from the DynamicContext will be the old one in  this callback function
        // so we need to get the latest value from LS
        // e.g. primary wallet id is 1234, and we have a function like this:
        // async function setPrimaryWalletAndUnlink() {
        //  await setPrimaryWallet('5678');
        //  handleUnlinkWallet('1234');
        // }
        // without fetching from LS, primaryWalletId would still be 1234 when handleUnlinkWallet runs in the example above
        const currentPrimaryWalletId = (_a = getPrimaryWalletId()) !== null && _a !== void 0 ? _a : primaryWalletId;
        if (walletId === currentPrimaryWalletId)
            return;
        yield unlinkWallet({
            environmentId,
            onSuccess: () => {
                removedWalletsIds.current.push(walletId);
            },
            primaryWalletId: currentPrimaryWalletId,
            walletId,
        });
        const wallet = secondaryWallets.find((w) => w.id === walletId);
        const numberOfLinkedWallets = verifiedCredentials.filter((account) => account.walletName === ((wallet === null || wallet === void 0 ? void 0 : wallet.connector.key) || '')).length;
        // If there's only 1, it's the one being removed and we can kill the session
        if (numberOfLinkedWallets === 1) {
            yield (wallet === null || wallet === void 0 ? void 0 : wallet.connector.endSession());
        }
    }), [
        primaryWalletId,
        environmentId,
        secondaryWallets,
        verifiedCredentials,
        removedWalletsIds,
    ]);
    return callback;
};

const useWalletEventListeners = ({ disconnectWallet, handleLogOut, multiWallet, multiWalletWidgetState, primaryWallet, secondaryWallets, selectedWalletConnector, selectedWalletWithAction, setSelectedWalletConnectorKey, setSelectedWalletWithAction, setMultiWalletWidgetState, user, authMode, refreshConnectedWallet, detectNewWalletsForLinking, }) => {
    const handleAccountChangeWhenAwaitingAccountSwitch = useCallback((isPrimaryWallet, newAddress) => {
        logger$1.debug('handleAccountChangeWhenAwaitingAccountSwitch', {
            isPrimaryWallet,
            newAddress,
        });
        const linkedSecondaryWallet = secondaryWallets.find((wallet) => isSameAddress(wallet.address, newAddress, wallet.chain));
        logger$1.logVerboseTroubleshootingMessage('[handleAccountChangeWhenAwaitingAccountSwitch]', { linkedSecondaryWallet });
        // this means the user is linking a new account, so we need proof of ownership...
        if (!linkedSecondaryWallet) {
            setMultiWalletWidgetState('awaiting_signature', undefined, 'linking_new_wallet');
            if (isPrimaryWallet && primaryWallet) {
                setSelectedWalletConnectorKey(primaryWallet.connector.key);
            }
            return;
        }
        if (!linkedSecondaryWallet.connector.isAvailable) {
            //prompt the user to connect and sign with the wallet
            dynamicEvents.emit('triggerConnectAndSign');
            return;
        }
        // ...otherwise, the user is switching primary accounts betweeen the same wallet
        setSelectedWalletWithAction(null);
        updatePrimaryWalletId(linkedSecondaryWallet.id);
        setMultiWalletWidgetState('idle');
    }, [
        setMultiWalletWidgetState,
        primaryWallet,
        secondaryWallets,
        setSelectedWalletConnectorKey,
        setSelectedWalletWithAction,
    ]);
    const calculatePrimaryWalletMultiWalletStateFromAccounts = useCallback(({ accounts }) => {
        logger$1.debug('calculatePrimaryWalletMultiWalletStateFromAccounts', {
            accounts,
            authMode,
            multiWallet,
            multiWalletWidgetState,
            primaryWallet,
        });
        // change the api here
        if (!primaryWallet)
            return;
        const [newAddress] = accounts;
        const changedAddress = !isSameAddress(newAddress, primaryWallet.address, primaryWallet.chain);
        if (!changedAddress) {
            setMultiWalletWidgetState('idle');
            return;
        }
        if (authMode === 'connect-only') {
            refreshConnectedWallet(primaryWallet.id, primaryWallet.connector);
            return;
        }
        if (!multiWallet) {
            return;
        }
        if (multiWalletWidgetState === 'awaiting_account_switch') {
            handleAccountChangeWhenAwaitingAccountSwitch(true, newAddress);
            return;
        }
        if (multiWalletWidgetState !== 'idle') {
            logger$1.error(`Unexpected multiWalletWidgetState (${multiWalletWidgetState}) and onAccountChange combination. Resetting state to idle.`);
            setMultiWalletWidgetState('idle');
        }
        const newWallet = secondaryWallets.find((wallet) => isSameAddress(wallet.address, newAddress, wallet.chain));
        if (newWallet) {
            updatePrimaryWalletId(newWallet.id);
            return;
        }
        if (user && detectNewWalletsForLinking) {
            setMultiWalletWidgetState('detected_new_wallet');
            setSelectedWalletConnectorKey(primaryWallet.connector.key);
        }
    }, [
        authMode,
        detectNewWalletsForLinking,
        handleAccountChangeWhenAwaitingAccountSwitch,
        multiWallet,
        multiWalletWidgetState,
        primaryWallet,
        refreshConnectedWallet,
        secondaryWallets,
        setMultiWalletWidgetState,
        setSelectedWalletConnectorKey,
        user,
    ]);
    useInternalDynamicEvents('triggerComputePrimaryWalletMultiWalletStateFromAccounts', calculatePrimaryWalletMultiWalletStateFromAccounts);
    useWalletConnectorEvent(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector, 'accountChange', ({ accounts }) => {
        logger$1.debug('primary wallet account change', {
            accounts,
        });
        calculatePrimaryWalletMultiWalletStateFromAccounts({ accounts });
    });
    const uniqueNonPrimaryWallets = useMemo(() => {
        const primaryConnector = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector;
        const secondaryConnectors = secondaryWallets.map(({ connector }) => connector);
        const allWalletConnectors = new Set([
            ...secondaryConnectors,
            primaryConnector,
            selectedWalletConnector,
        ].filter((connector) => Boolean(connector)));
        if (primaryConnector) {
            allWalletConnectors.delete(primaryConnector);
        }
        return Array.from(allWalletConnectors);
    }, [secondaryWallets, selectedWalletConnector, primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector]);
    useWalletConnectorEvent(uniqueNonPrimaryWallets, 'accountChange', (_, changedConnector) => __awaiter$1(void 0, void 0, void 0, function* () {
        logger$1.debug('secondary wallet account change');
        if (authMode === 'connect-only' && secondaryWallets.length) {
            const affectedWallets = secondaryWallets.filter(({ connector }) => connector.key === changedConnector.key);
            for (const wallet of affectedWallets)
                refreshConnectedWallet(wallet.id, wallet.connector);
            return;
        }
        if (multiWalletWidgetState === 'awaiting_account_switch') {
            handleAccountChangeWhenAwaitingAccountSwitch(false, (selectedWalletWithAction === null || selectedWalletWithAction === void 0 ? void 0 : selectedWalletWithAction.wallet.address) || '');
        }
    }));
    useWalletConnectorEvent(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector, 'disconnect', () => {
        logger$1.debug('primary wallet disconnect');
        if (authMode === 'connect-only') {
            handleLogOut();
        }
    });
    useWalletConnectorEvent(uniqueNonPrimaryWallets, 'disconnect', (affectedConnector) => {
        logger$1.debug('secondary wallet disconnect');
        if (authMode === 'connect-only') {
            // Get all wallets with this connector
            const affectedWallets = secondaryWallets.filter(({ connector }) => connector.key === affectedConnector.key);
            for (const wallet of affectedWallets) {
                disconnectWallet(wallet.id);
            }
        }
    });
    useWalletConnectorEvent(uniqueNonPrimaryWallets, 'chainChange', ({ chain }, connector) => {
        dynamicEvents.emit('nonPrimaryWalletNetworkChanged', chain, connector);
    });
};

const useTabState = ({ settingsOverrides, }) => {
    var _a, _b, _c;
    const walletListViewSettings = (_a = settingsOverrides === null || settingsOverrides === void 0 ? void 0 : settingsOverrides.views) === null || _a === void 0 ? void 0 : _a.find((view) => view.type === 'wallet-list');
    const [selectedTabIndex, setSelectedTabIndex] = useState(0);
    const selectedTabSettings = selectedTabIndex === null
        ? undefined
        : (_b = walletListViewSettings === null || walletListViewSettings === void 0 ? void 0 : walletListViewSettings.tabs) === null || _b === void 0 ? void 0 : _b.items[selectedTabIndex];
    return {
        selectedTabIndex,
        selectedTabSettings,
        setSelectedTabIndex,
        tabsItems: (_c = walletListViewSettings === null || walletListViewSettings === void 0 ? void 0 : walletListViewSettings.tabs) === null || _c === void 0 ? void 0 : _c.items,
    };
};

const DynamicBridgeWidgetContext = React__default.createContext(undefined);
const initialView = 'wallets';
const DynamicBridgeWidgetContextProvider = ({ children, }) => {
    const widgetRef = useRef(null);
    const inlineControlsRef = useRef(null);
    const [bridgeWidgetView, setBridgeWidgetView] = useState(initialView);
    const onDynamicBridgeWidgetClose = useCallback(() => {
        setBridgeWidgetView(initialView);
    }, []);
    const goToProfileView = useCallback(() => {
        setBridgeWidgetView('profile');
    }, []);
    const bridgeWidgetRootContextValue = {
        bridgeWidgetView,
        events: {
            onDynamicBridgeWidgetClose,
        },
        goToProfileView,
        inlineControlsRef,
        setBridgeWidgetView,
        widgetRef,
    };
    return (jsxRuntimeExports.jsx(DynamicBridgeWidgetContext.Provider, { value: bridgeWidgetRootContextValue, children: children }));
};

const DynamicWidgetCard = forwardRef(({ children }, ref) => (jsxRuntimeExports.jsx("div", { ref: ref, className: 'dynamic-widget-card', children: children })));
DynamicWidgetCard.displayName = 'DynamicWidgetCard';

const widgetRegistryContext = createContext(null);
const WidgetRegistryContextProvider = ({ children, }) => {
    const [registry, setRegistry] = useState({});
    const registerId = useCallback((widgetId, widgetType) => {
        setRegistry((prevRegistry) => (Object.assign(Object.assign({}, prevRegistry), { [widgetId]: {
                type: widgetType,
            } })));
    }, [setRegistry]);
    const removeId = useCallback((widgetId) => {
        setRegistry((prevRegistry) => {
            const newRegistry = Object.assign({}, prevRegistry);
            delete newRegistry[widgetId];
            return newRegistry;
        });
    }, [setRegistry]);
    const checkWidgetPresence = useCallback((widgetType) => Object.values(registry).some((widget) => widget.type === widgetType), [registry]);
    return (jsxRuntimeExports.jsx(widgetRegistryContext.Provider, { value: { checkWidgetPresence, registerId, removeId }, children: children }));
};
const useWidgetRegistry = () => {
    const context = useContext(widgetRegistryContext);
    if (context === null) {
        throw new Error('usage of useWidgetRegistry not wrapped in `WidgetRegistryContextProvider`.');
    }
    return context;
};
const useRegisterWidget = (widgetType, enabled = true) => {
    const idRef = useRef(randomString(8));
    const { registerId, removeId } = useWidgetRegistry();
    useEffect(() => {
        if (enabled === false) {
            return;
        }
        registerId(idRef.current, widgetType);
        return () => {
            // This is disabled because eslint think we are using state value
            // but this is fine because it is a ref
            // eslint-disable-next-line react-hooks/exhaustive-deps
            removeId(idRef.current);
        };
    }, [widgetType, enabled, registerId, removeId]);
};

const OnrampWidget = () => {
    const { showOnramp, selectedOnramp, onrampEnabled, setShowOnramp } = useOnrampContext();
    const [onrampRef, setOnrampRef] = useState(null);
    useOnClickOutside(onrampRef, () => setShowOnramp(false));
    if (!onrampEnabled || !(selectedOnramp === null || selectedOnramp === void 0 ? void 0 : selectedOnramp.iframeUrl)) {
        return null;
    }
    return (jsxRuntimeExports.jsx(ShadowDOM, { children: jsxRuntimeExports.jsxs(OpacityTransition, { isShown: showOnramp, children: [jsxRuntimeExports.jsx("div", { className: 'onramp-widget__backdrop', "aria-hidden": 'true', "data-testid": 'onramp-widget-backdrop' }), jsxRuntimeExports.jsx("div", { className: 'onramp-widget__modal', children: jsxRuntimeExports.jsx("iframe", { id: 'onramp-iframe', src: selectedOnramp.iframeUrl, allow: 'camera *;geolocation *', title: 'Crypto Onramp', ref: setOnrampRef, "data-testid": 'onramp-widget-modal' }) })] }) }));
};

/* eslint-disable prefer-arrow/prefer-arrow-functions */
const ERROR_BOUNDARY_CONTEXT_NOT_FOUND = 'ERROR_BOUNDARY_CONTEXT_NOT_FOUND';
const ErrorBoundaryContext = createContext(null);
function assertErrorBoundaryContext(value) {
    if (value === null ||
        typeof value.hasError !== 'boolean' ||
        typeof value.error !== 'object' ||
        typeof value.isDynamicSdkError !== 'boolean') {
        const error = new Error('ErrorBoundaryContext not found');
        error.cause = ERROR_BOUNDARY_CONTEXT_NOT_FOUND;
        throw error;
    }
}

class ErrorBoundaryBase extends Component {
    static getDerivedStateFromError(error) {
        return { error, hasError: true };
    }
    renderOrError(children, { isDynamicSdkError }) {
        try {
            assertErrorBoundaryContext(this.context);
            this.context.isDynamicSdkError = isDynamicSdkError;
        }
        catch (e) {
            logger$1.error(e);
            return createElement(ErrorContainer, null, 'ErrorBoundary must be used within ErrorBoundaryContext');
        }
        return children;
    }
}
ErrorBoundaryBase.contextType = ErrorBoundaryContext;

class ErrorBoundaryReporter extends ErrorBoundaryBase {
    constructor(props) {
        super(props);
        this.state = { error: null, hasError: false };
    }
    componentDidCatch(error, info) {
        var _a;
        const { onError } = this.props;
        if ((_a = this.context) === null || _a === void 0 ? void 0 : _a.isDynamicSdkError) {
            onError === null || onError === void 0 ? void 0 : onError(error, info);
            logger$1.error(error, {
                error: {
                    bundleStack: error.stack,
                    message: error,
                    stack: info.componentStack,
                },
            });
        }
        throw error;
    }
    render() {
        const { children } = this.props;
        const { hasError, error } = this.state;
        if (hasError) {
            assertErrorBoundaryContext(this.context);
            this.context.error = error;
            this.context.hasError = hasError;
            return null;
        }
        return children;
    }
}
const ErrorBoundary = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (jsxRuntimeExports.jsx(ErrorBoundaryContext.Provider, { value: {
            error: null,
            hasError: false,
            isDynamicSdkError: true,
        }, children: jsxRuntimeExports.jsx(ErrorBoundaryReporter, Object.assign({}, props, { children: children })) }));
};

class ErrorBoundaryExclude extends ErrorBoundaryBase {
    render() {
        const { children } = this.props;
        return this.renderOrError(children, {
            isDynamicSdkError: false,
        });
    }
}

const getPromptAmountParams = ({ externalWallet, }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const walletChain = externalWallet.connector.connectedChain;
    const chainSettings = (_e = (_d = (_c = (_b = (_a = getProjectSettings()) === null || _a === void 0 ? void 0 : _a.sdk.funding) === null || _b === void 0 ? void 0 : _b.externalWallets) === null || _c === void 0 ? void 0 : _c.defaultSettings) === null || _d === void 0 ? void 0 : _d.chainSettings) === null || _e === void 0 ? void 0 : _e.find(({ chain }) => chain === walletChain);
    // This is always supposed to be present, otherwise there's some backend error
    if (!((_f = chainSettings === null || chainSettings === void 0 ? void 0 : chainSettings.token) === null || _f === void 0 ? void 0 : _f.value) || !((_g = chainSettings === null || chainSettings === void 0 ? void 0 : chainSettings.token) === null || _g === void 0 ? void 0 : _g.rule))
        throw new DynamicError(`No external wallet funding chain settings found for chain ${walletChain}`);
    return {
        externalWallet,
        token: {
            rule: chainSettings.token.rule,
            value: chainSettings.token.value,
        },
    };
};

const useResponseHandlers = () => {
    const { walletConnectorOptions, displaySiweStatement, environmentId, projectSettings, setIsSingleWalletAccount, connectWallet, setShowAuthFlow, setSelectedWalletConnectorKey, siweStatement, appName, user, } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const { setErrorMessage } = useErrorContext();
    const { getCaptchaToken } = useCaptchaContext();
    const { promptAmountAndFund } = useFundWithWallet();
    const verifyWallet = useVerifyWallet({
        displaySiweStatement,
        environmentId,
        projectSettings,
        setIsSingleWalletAccount,
    });
    const phantomRedirectConnector = walletConnectorOptions
        .map(({ walletConnector }) => walletConnector)
        .find(isPhantomRedirectConnector);
    const handleConnectResponse = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!phantomRedirectConnector) {
            return;
        }
        // this completes the connection step
        yield phantomRedirectConnector.getSession();
        const connectResult = yield connectWallet(phantomRedirectConnector);
        // Check if we have a connection type
        const connectionType = StorageService.getItem(PHANTOM_REDIRECT_CONNECTION_TYPE_KEY);
        // If this is an external wallet funding connection, then we need to
        // complete the wallet transfer.
        // If connectorConsumed is false that means that the connector has not yet
        // verified this connection type and we should ignore it.
        if ((connectionType === null || connectionType === void 0 ? void 0 : connectionType.connectorConsumed) &&
            connectionType.type === 'external-wallet-funding') {
            if (!connectResult)
                return;
            const wallet = phantomRedirectConnector.createWallet({
                address: connectResult.address,
                chain: phantomRedirectConnector.connectedChain,
                connector: phantomRedirectConnector,
                id: 'external-funding-wallet',
                isAuthenticated: false,
                key: phantomRedirectConnector.key,
            });
            const props = getPromptAmountParams({ externalWallet: wallet });
            promptAmountAndFund(props);
            return;
        }
        // Default behavior is to link a wallet
        setShowAuthFlow(true, { ignoreIfIsEmbeddedWidget: true });
        pushView('pending-signature');
        setSelectedWalletConnectorKey('phantom');
    }), [
        phantomRedirectConnector,
        connectWallet,
        setShowAuthFlow,
        pushView,
        setSelectedWalletConnectorKey,
        promptAmountAndFund,
    ]);
    const completeWalletTransfer = useTransferWallet();
    const handleUserResponse = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!phantomRedirectConnector) {
            return;
        }
        setSelectedWalletConnectorKey('phantom');
        const [address] = yield phantomRedirectConnector.getConnectedAccounts();
        const method = phantomRedirectConnector.consumeMethod();
        switch (method) {
            case 'signAndSendTransaction': {
                const { signature } = phantomRedirectConnector.extractSignature();
                phantomRedirectConnector.emit('signAndSendTransaction', {
                    signature,
                });
                break;
            }
            case 'signAllTransactions':
                phantomRedirectConnector.emit('signAllTransactions', {
                    transactions: phantomRedirectConnector.extractTransactions(),
                });
                break;
            case 'signTransaction':
                phantomRedirectConnector.emit('signTransaction', {
                    transaction: phantomRedirectConnector.extractTransaction(),
                });
                break;
            case 'signMessage': {
                const { signature, message } = phantomRedirectConnector.extractSignature();
                const signatureState = StorageService.getItem(PHANTOM_SIGNATURE_STATE);
                StorageService.removeItem(PHANTOM_SIGNATURE_STATE);
                if ((signatureState === null || signatureState === void 0 ? void 0 : signatureState.verificationType) === 'awaiting_transfer') {
                    const siweStatementToUse = getSiweStatement({
                        appName,
                        siweStatement,
                    });
                    yield completeWalletTransfer({
                        messageToSignOverride: message,
                        overrideSiweStatement: siweStatementToUse,
                        publicWalletAddress: address,
                        signedMessageOverride: signature,
                        skipEmptyAccountCheck: signatureState.loseOriginalAccountOnTransfer,
                        walletConnector: phantomRedirectConnector,
                    });
                }
                else if ((signatureState === null || signatureState === void 0 ? void 0 : signatureState.verificationType) === 'awaiting_verification' ||
                    !user) {
                    pushView('wallet-redirect-view');
                    yield verifyWallet({
                        captchaToken: getCaptchaToken(),
                        messageToSignOverride: message,
                        publicWalletAddress: address,
                        signedMessageOverride: signature,
                        walletConnector: phantomRedirectConnector,
                    });
                }
                else {
                    phantomRedirectConnector.emit('signMessage', {
                        signature,
                    });
                }
                break;
            }
        }
    }), [
        phantomRedirectConnector,
        setSelectedWalletConnectorKey,
        user,
        appName,
        siweStatement,
        completeWalletTransfer,
        pushView,
        verifyWallet,
        getCaptchaToken,
    ]);
    const handleErrorResponse = useCallback((params) => {
        var _a;
        if (!phantomRedirectConnector)
            return;
        const errorCode = params.get('errorCode');
        const errorMessage = (_a = params.get('errorMessage')) !== null && _a !== void 0 ? _a : undefined;
        if (!errorCode)
            return;
        setErrorMessage(errorCode);
        params.delete('errorCode');
        params.delete('errorMessage');
        // eslint-disable-next-line no-restricted-globals
        history.replaceState(null, '', `${window.location.origin}${window.location.pathname}?${params.toString()}`);
        const method = phantomRedirectConnector.consumeMethod();
        switch (method) {
            case 'signAndSendTransaction':
                phantomRedirectConnector.emit('signAndSendTransaction', {
                    errorCode,
                    errorMessage,
                });
                break;
            case 'signAllTransactions':
                phantomRedirectConnector.emit('signAllTransactions', {
                    errorCode,
                    errorMessage,
                });
                break;
            case 'signTransaction':
                phantomRedirectConnector.emit('signTransaction', {
                    errorCode,
                    errorMessage,
                });
                break;
            case 'signMessage':
                phantomRedirectConnector.emit('signMessage', {
                    errorCode,
                    errorMessage,
                });
                break;
        }
    }, [phantomRedirectConnector, setErrorMessage]);
    return {
        handleConnectResponse,
        handleErrorResponse,
        handleUserResponse,
        phantomRedirectConnector,
    };
};

const PhantomRedirectContext = createContext(undefined);
const PhantomRedirectContextProvider = ({ children, }) => {
    const { sdkHasLoaded } = useInternalDynamicContext();
    const { phantomRedirectConnector, handleConnectResponse, handleUserResponse, handleErrorResponse, } = useResponseHandlers();
    useEffect(() => {
        if (!phantomRedirectConnector || !isMobile() || !sdkHasLoaded) {
            return;
        }
        const params = new URLSearchParams(window.location.search);
        if (params.has('errorCode')) {
            handleErrorResponse(params);
            return;
        }
        // handle response of connect method
        if (params.has('phantom_encryption_public_key')) {
            handleConnectResponse();
            return;
        }
        // handle response of the following methods:
        // signMessage, signTransaction, signAndSendTransaction or signAllTransactions
        if (params.has('data')) {
            handleUserResponse();
            return;
        }
    }, [
        handleConnectResponse,
        handleUserResponse,
        handleErrorResponse,
        phantomRedirectConnector,
        sdkHasLoaded,
    ]);
    return (jsxRuntimeExports.jsx(PhantomRedirectContext.Provider, { value: {
            phantomRedirectConnector,
        }, children: children }));
};

const reinitializeContext = createContext(undefined);
/**
 * Provider that provides a reinitialize function to its children.
 * @param children The children to render.
 * @param onReinitialize A callback that is called when reinitialize is called.
 */
const ReinitializeContextProvider = ({ children, onReinitialize }) => {
    // Initial key is undefined to not interfere on react strick mode
    const [key, setKey] = useState();
    const onReinitializeCallbackRef = useRef(onReinitialize);
    onReinitializeCallbackRef.current = onReinitialize;
    const reinitialize = useCallback(() => {
        var _a;
        const newKey = randomString(8);
        (_a = onReinitializeCallbackRef.current) === null || _a === void 0 ? void 0 : _a.call(onReinitializeCallbackRef, newKey);
        setKey(newKey);
    }, []);
    return (jsxRuntimeExports.jsx(reinitializeContext.Provider, { value: { key, reinitialize }, children: cloneElement(children, { key }) }));
};

const useConnectedWalletsNetworkValidation = () => {
    const { connectedWallets, selectedWalletConnector, setSelectedWalletConnectorKey, setShowAuthFlow, bridgeChainsToConnect, sdkHasLoaded, } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const isLoggedIn = useIsLoggedIn();
    const getConnectedWalletsWithInvalidNetwork = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        const connectedWalletsWithInvalidNetwork = [];
        for (const connectedWallet of connectedWallets) {
            const isChainInWalletsToConnect = bridgeChainsToConnect === null || bridgeChainsToConnect === void 0 ? void 0 : bridgeChainsToConnect.some((walletToConnectByChain) => walletToConnectByChain.chain === connectedWallet.chain);
            const network = yield connectedWallet.connector.getNetwork();
            const isSupported = isSupportedNetwork({
                network,
                walletConnector: connectedWallet.connector,
            });
            if (!isChainInWalletsToConnect && !isSupported) {
                connectedWalletsWithInvalidNetwork.push(connectedWallet);
            }
        }
        return connectedWalletsWithInvalidNetwork;
    }), [bridgeChainsToConnect, connectedWallets]);
    const validateNetwork = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        const connectedWalletsWithInvalidNetwork = yield getConnectedWalletsWithInvalidNetwork();
        if (!connectedWalletsWithInvalidNetwork.length) {
            return;
        }
        // If we found wallets that require a change of network
        // then, one by one, in the first one we require a change of network.
        const [connectedWalletWithInvalidNetwork] = connectedWalletsWithInvalidNetwork;
        // Keeps the first wallet connectedWallet in setSelectedWalletConnectorKey
        // This is required because NetworkNotSupported uses walletConnector to display wallet icon, address etc.
        if (connectedWalletWithInvalidNetwork.connector.key !==
            (selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.key)) {
            setSelectedWalletConnectorKey(connectedWalletWithInvalidNetwork.connector.key);
        }
        const networkNotSupportedView = isProgrammableNetworkSwitchSupported(connectedWalletWithInvalidNetwork.connector)
            ? 'network-not-supported'
            : 'network-not-supported-manual';
        // Doesn't rerender if it's already true
        setShowAuthFlow(true);
        pushView(networkNotSupportedView);
    }), [
        getConnectedWalletsWithInvalidNetwork,
        selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.key,
        setSelectedWalletConnectorKey,
        setShowAuthFlow,
        pushView,
    ]);
    const uniqueConnectors = useMemo(() => {
        const connectors = connectedWallets.map(({ connector }) => connector);
        const allWalletConnectors = new Set([...connectors].filter((connector) => Boolean(connector)));
        return Array.from(allWalletConnectors);
    }, [connectedWallets]);
    useWalletConnectorEvent(uniqueConnectors, 'chainChange', ({ chain }) => {
        validateNetwork();
    });
    useEffect(() => {
        /**
         * This check was added to prevent the "wrong network" modal from appearing
         * after logging out. It seems like on log out, there is a render where the
         * connectedWallets hasn't been cleared out yet, so the logic in this hook
         * runs and ends up showing the "wrong network" modal if the connected wallet
         * is on an unsupported network. by checking sdkHasLoaded, we prevent this
         * extra popup because handleLogOut flips sdkHasLoaded to false, so on the
         * next render it will already be false.
         */
        if (!sdkHasLoaded || !isLoggedIn) {
            return;
        }
        validateNetwork();
    }, [sdkHasLoaded, isLoggedIn, validateNetwork]);
};

const UseNetworkValidation = () => {
    useConnectedWalletsNetworkValidation();
    return null;
};

const lastAuthenticatedAccount = (dynamicJwtOrUser) => dynamicJwtOrUser.verifiedCredentials.find((account) => account.id === dynamicJwtOrUser.lastVerifiedCredentialId);

const useGlobalLoading = ({ authMode, connectedInfo, connectedWallets, projectSettings, primaryWalletId, primaryWallet, user, isLoadingUserFromCookie, walletBook, enableInstrumentation, appName, environmentId, nonce, }) => {
    var _a;
    // Once we declare the SDK as loaded, we do not ever want to flip back to false
    const hasLoaded = useRef(false);
    const loadingStart = useRef(new Date().getTime());
    const { sessionValidation } = useLoadingAndLifecycle();
    const isFetchingNonce = useMemo(() => shouldFetchNonce({
        authMode,
    }) && !nonce, [authMode, nonce]);
    const finishLoading = () => {
        if (hasLoaded.current)
            return;
        hasLoaded.current = true;
        logger$1.debug('[useGlobalLoading] SDK finished loading', {
            authMode,
            enableInstrumentation,
            primaryWallet,
            user,
        });
        // Calculate how long loading took and emit log
        if (enableInstrumentation) {
            const loadingTime = new Date().getTime() - loadingStart.current;
            // Pass as default arg and as an object. The object value will be injected
            // in the log later on, keeping its format as a number for calculation purposes
            logger$1.instrument(`SDK loaded in (ms) ${loadingTime}`, {
                appName,
                environmentId,
                key: 'sdkHasLoaded',
                primaryWalletId,
                time: loadingTime,
                userId: user === null || user === void 0 ? void 0 : user.userId,
            });
        }
    };
    if (hasLoaded.current)
        return true;
    const isWalletBookLoading = !isWalletBookPopulated(walletBook);
    const isProjectSettingsLoading = !projectSettings;
    const isUserLoading = isLoadingUserFromCookie;
    const shouldHavePrimaryWallet = primaryWalletId ||
        (user && ((_a = lastAuthenticatedAccount(user)) === null || _a === void 0 ? void 0 : _a.format) === 'blockchain');
    const isPrimaryWalletLoading = Boolean(shouldHavePrimaryWallet && !primaryWallet);
    const isConnectOnlyWalletsLoading = authMode === 'connect-only' &&
        connectedInfo &&
        connectedWallets.length === 0;
    const isValidatingSession = !sessionValidation;
    logger$1.logVerboseTroubleshootingMessage('[useGlobalLoading] SDK loading', {
        isConnectOnlyWalletsLoading,
        isFetchingNonce,
        isPrimaryWalletLoading,
        isProjectSettingsLoading,
        isUserLoading,
        isValidatingSession,
        isWalletBookLoading,
    });
    if (!isWalletBookLoading &&
        !isProjectSettingsLoading &&
        !isUserLoading &&
        !isPrimaryWalletLoading &&
        !isConnectOnlyWalletsLoading &&
        !isValidatingSession &&
        !isFetchingNonce) {
        finishLoading();
    }
    return hasLoaded.current;
};

const onReinitialize = () => {
    removeStoreInstance();
    StorageService.clearRegistry();
};

const isDisplayOrderPriorityForWeb3 = (displayOrder) => {
    if (displayOrder.length !== 2)
        return false;
    const [firstPriority, secondPriority] = displayOrder;
    return firstPriority === 'wallet' && secondPriority === 'email';
};

const useDisplayOrderState = (projectSettings) => {
    const [selectedDisplayOrder, setSelectedDisplayOrder] = useState(null);
    const defaultDisplayOrder = useMemo(() => {
        var _a;
        const displayOrderFromApi = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.design.modal) === null || _a === void 0 ? void 0 : _a.displayOrder;
        if (!displayOrderFromApi)
            return 'web3';
        return isDisplayOrderPriorityForWeb3(displayOrderFromApi) ? 'web3' : 'web2';
    }, [projectSettings]);
    return [selectedDisplayOrder || defaultDisplayOrder, setSelectedDisplayOrder];
};

const useEmailLoginState = (providers, user) => {
    const [loginWithEmail, _setLoginWithEmail] = useState(null);
    const reset = () => {
        _setLoginWithEmail(null);
    };
    const setLoginWithEmail = useCallback((value) => {
        _setLoginWithEmail(value);
    }, [_setLoginWithEmail]);
    const defaultLoginWithEmail = useMemo(() => (user ? false : isEmailProviderEnabled(providers)), [providers, user]);
    return [loginWithEmail !== null && loginWithEmail !== void 0 ? loginWithEmail : defaultLoginWithEmail, setLoginWithEmail, reset];
};

const useHandleLogout = (params) => {
    const paramsRef = useRef(params);
    paramsRef.current = params;
    const logout = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        const p = paramsRef.current;
        p.setSelectedWalletConnectorKey(null);
        p.clearAllWalletConnectSessions();
        p.setShowDynamicUserProfile(false);
        p.setShowBridgeWidget(false);
        p.resetLoginWithEmail();
        if (p.user) {
            // this deletes the auth cookie, if it exists
            // if the cookie doesn't exist, this sets a new cookie which would expire immediately
            document.cookie = `${DYNAMIC_AUTH_COOKIE_NAME}=; Max-Age=-99999999; path=/; SameSite=Lax`;
            // do not await this async call - just fire and forget
            revokeSession({
                environmentId: p.environmentId,
                sessionId: p.user.sessionId,
            });
        }
        p.setLegacyIsVerifying(false);
        // Clear storage
        StorageService.removeItem(AUTH_TOKEN, {
            priority: ['secureStorage', 'localStorage'],
        });
        StorageService.removeItem(AUTH_MIN_TOKEN, {
            priority: ['secureStorage', 'localStorage'],
        });
        StorageService.removeItem(WALLET_PICKER_SEARCH_KEY);
        StorageService.removeItem(PHANTOM_SIGNATURE_STATE);
        StorageService.removeItem(AUTH_EXPIRES_AT);
        p.setAuthMode(p.initialAuthenticationMode);
        p.setShowAuthFlow(false, {
            emitCancelAuth: false,
            ignoreIfIsEmbeddedWidget: false,
            initializeWalletConnect: false,
            performMultiWalletChecks: false,
        });
        p.setMultiWalletWidgetState('idle');
        p.removeConnectedWalletsInfo();
        p.removeBridgeOnboardingCompleted();
        resetPrimaryWalletId();
        p.removeConnectedNameService();
        p.removeSessionStorageSessionKeys();
        dynamicEvents.emit('logout');
        setUser(undefined);
        yield Promise.all(p.walletConnectors.map((connector) => connector.endSession()));
        yield Promise.all(p.connectedWallets.map((connectedWallet) => connectedWallet.connector.endSession()));
    }), []);
    /** Trigger a logout when the SDK failed to load data from storage */
    useEffect(() => {
        StorageService.events.on('parseFailure', logout);
        return () => {
            StorageService.events.off('parseFailure', logout);
        };
    }, [logout]);
    /** Allows triggering a logout from anywhere in the code */
    useInternalDynamicEvents('triggerLogout', () => logout());
    return logout;
};

const getWalletVerifiedCredential = (walletAddress, verifiedCredentials, walletChain) => verifiedCredentials === null || verifiedCredentials === void 0 ? void 0 : verifiedCredentials.find(({ address }) => isSameAddress(address || '', walletAddress || '', walletChain));

const useNameService = ({ currentWallet, user }) => {
    const [connectedNameService, setConnectedNameService, removeConnectedNameService,] = useLocalStorage(CONNECTED_WALLET_NAME_SERVICE, null);
    const lastFetchedNameServiceAddress = useRef();
    const lastFetchedNameServiceNetwork = useRef();
    const fetchNameServiceFromBlockchain = useCallback((wallet) => __awaiter$1(void 0, void 0, void 0, function* () {
        const { address, connector } = wallet;
        const network = yield connector.getNetwork();
        if (address === lastFetchedNameServiceAddress.current &&
            network === lastFetchedNameServiceNetwork.current) {
            return;
        }
        setConnectedNameService(null);
        // store last address used to fetch name service so we can check for it when promise resolves
        // to avoid race conditions
        lastFetchedNameServiceAddress.current = address;
        lastFetchedNameServiceNetwork.current = network;
        let ns;
        try {
            ns = yield wallet.getNameService();
        }
        catch (e) {
            // do nothing
        }
        // only sets name service if the address used to fetch it is the last one used for fetching
        // this avoid issues with promises not resolving in the correct order
        if (lastFetchedNameServiceAddress.current === address &&
            lastFetchedNameServiceNetwork.current === network) {
            setConnectedNameService({
                address,
                avatar: ns === null || ns === void 0 ? void 0 : ns.avatar,
                name: ns === null || ns === void 0 ? void 0 : ns.name,
                network,
            });
            return ns;
        }
        return undefined;
    }), [setConnectedNameService]);
    const getNameService = useCallback((address) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a;
        if (!currentWallet) {
            return;
        }
        const network = yield currentWallet.connector.getNetwork();
        const verifiedCredentials = user === null || user === void 0 ? void 0 : user.verifiedCredentials;
        //if there are verified credentials, check if there is a name service for the current wallet
        if (verifiedCredentials) {
            const verifiedCredential = getWalletVerifiedCredential(currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.address, verifiedCredentials, currentWallet.chain);
            if (verifiedCredential && ((_a = verifiedCredential.nameService) === null || _a === void 0 ? void 0 : _a.name)) {
                return verifiedCredential.nameService;
            }
        }
        // don't look for name service in blockchain if provided address doesn't match current wallet
        if (address && (currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.address) !== address) {
            return;
        }
        // if finds name service info in local storage and its related address matches the connected wallet address,
        // return it
        if (connectedNameService &&
            connectedNameService.address === (currentWallet === null || currentWallet === void 0 ? void 0 : currentWallet.address) &&
            connectedNameService.network === network) {
            return {
                avatar: connectedNameService.avatar,
                name: connectedNameService.name,
            };
        }
        // if doesn't find correct name service in verified credentials or local storage, fetch it from blockchain
        return fetchNameServiceFromBlockchain(currentWallet);
    }), [
        currentWallet,
        user === null || user === void 0 ? void 0 : user.verifiedCredentials,
        connectedNameService,
        fetchNameServiceFromBlockchain,
    ]);
    return { getNameService, removeConnectedNameService };
};

const useSelectedWalletConnector = ({ walletConnectorOptions, }) => {
    const [selectedWalletConnectorKey, setSelectedWalletConnectorKey] = useState(null);
    // Instead of storing the selected connector directly, we derive it from the wallets
    // This way if wallets change, the selected connector will be updated too
    const selectedWalletConnector = useMemo(() => {
        var _a, _b;
        if (!selectedWalletConnectorKey)
            return null;
        return ((_b = (_a = walletConnectorOptions.find(({ walletConnector }) => walletConnector.key === selectedWalletConnectorKey)) === null || _a === void 0 ? void 0 : _a.walletConnector) !== null && _b !== void 0 ? _b : null);
    }, [selectedWalletConnectorKey, walletConnectorOptions]);
    return { selectedWalletConnector, setSelectedWalletConnectorKey };
};

/**
 * There are a multitude of scenarios where we want to ignore or insert functionality to calls
 * to setShowAuthFlow. This hook wraps it with an options parameter to allow encapsulating these
 * different scenarios and makes it especially easy to customize exactly which version of this method
 * is being passed to useDynamicContext.
 */
const useShowAuthFlow = ({ isAuthenticated, isRenderingEmbeddedAuthFlow, isMultiWalletEnabled, setShowDynamicUserProfile, }) => {
    const [showAuthFlow, _setShowAuthFlow] = useState(false);
    const { setError } = useErrorContext();
    const setShowAuthFlow = useCallback((value, options = {}) => {
        const { emitCancelAuth, ignoreIfIsEmbeddedWidget, initializeWalletConnect, performMultiWalletChecks, clearErrors, } = Object.assign({ clearErrors: true, emitCancelAuth: false, ignoreIfIsEmbeddedWidget: true, initializeWalletConnect: true, performMultiWalletChecks: false }, options);
        logger$1.logVerboseTroubleshootingMessage('setShowAuthFlow', {
            clearErrors,
            emitCancelAuth,
            ignoreIfIsEmbeddedWidget,
            initializeWalletConnect,
            performMultiWalletChecks,
        });
        if (!showAuthFlow && value) {
            dynamicEvents.emit('authFlowOpen');
        }
        else if (showAuthFlow && !value) {
            dynamicEvents.emit('authFlowClose');
        }
        if (value) {
            if (ignoreIfIsEmbeddedWidget && isRenderingEmbeddedAuthFlow.current)
                return;
            if (performMultiWalletChecks && isAuthenticated) {
                if (!isMultiWalletEnabled) {
                    return setShowDynamicUserProfile(true);
                }
                logger$1.warn('Use setShowLinkNewWalletModal to render the wallet list instead. For more information, see: https://docs.dynamic.xyz/react-sdk/hooks/usedynamiccontext');
                return;
            }
        }
        else if (emitCancelAuth && showAuthFlow)
            dynamicEvents.emit('authFlowCancelled');
        if (clearErrors)
            setError(undefined);
        _setShowAuthFlow(value);
    }, [
        isAuthenticated,
        isMultiWalletEnabled,
        isRenderingEmbeddedAuthFlow,
        setError,
        setShowDynamicUserProfile,
        showAuthFlow,
    ]);
    return [showAuthFlow, setShowAuthFlow];
};

const usePasskeySuccessPopup = () => {
    const [passkeySuccessPopup, _setPasskeySuccessPopup] = useState(undefined);
    // Show the success message for 2 seconds then hide it
    // The logic is here to not have to duplicate it in multiple views
    const setPasskeySuccessPopup = useCallback((key) => {
        _setPasskeySuccessPopup(key);
        setTimeout(() => {
            _setPasskeySuccessPopup(undefined);
        }, 2000);
    }, [_setPasskeySuccessPopup]);
    return {
        passkeySuccessPopup,
        setPasskeySuccessPopup,
    };
};

/** Ties the customer callbacks to our events, such that our events will also trigger the callbacks */
const useTieCallbacksToEvents = ({ clientCallbacks, user, }) => {
    useInternalDynamicEvents('emailVerificationResult', (result, email) => {
        var _a;
        return (_a = clientCallbacks === null || clientCallbacks === void 0 ? void 0 : clientCallbacks.onOtpVerificationResult) === null || _a === void 0 ? void 0 : _a.call(clientCallbacks, result, {
            type: 'email',
            value: email,
        });
    });
    useInternalDynamicEvents('smsVerificationResult', (result, phoneData) => {
        var _a;
        return (_a = clientCallbacks === null || clientCallbacks === void 0 ? void 0 : clientCallbacks.onOtpVerificationResult) === null || _a === void 0 ? void 0 : _a.call(clientCallbacks, result, {
            type: 'sms',
            value: phoneData,
        });
    });
    useInternalDynamicEvents('authFlowCancelled', () => { var _a; return (_a = clientCallbacks === null || clientCallbacks === void 0 ? void 0 : clientCallbacks.onAuthFlowCancel) === null || _a === void 0 ? void 0 : _a.call(clientCallbacks); });
    useInternalDynamicEvents('authFlowOpen', () => {
        var _a;
        (_a = clientCallbacks === null || clientCallbacks === void 0 ? void 0 : clientCallbacks.onAuthFlowOpen) === null || _a === void 0 ? void 0 : _a.call(clientCallbacks);
    });
    useInternalDynamicEvents('authFlowClose', () => {
        var _a;
        (_a = clientCallbacks === null || clientCallbacks === void 0 ? void 0 : clientCallbacks.onAuthFlowClose) === null || _a === void 0 ? void 0 : _a.call(clientCallbacks);
    });
    useInternalDynamicEvents('walletAdded', (wallet, userWallets) => {
        var _a;
        dynamicEvents.emit('triggerSessionValidation');
        logger$1.debug('[walletAdded]', { userWallets, wallet });
        (_a = clientCallbacks === null || clientCallbacks === void 0 ? void 0 : clientCallbacks.onWalletAdded) === null || _a === void 0 ? void 0 : _a.call(clientCallbacks, { userWallets, wallet });
    });
    useInternalDynamicEvents('walletRemoved', (wallet, userWallets) => {
        var _a;
        logger$1.debug('[walletRemoved]', { userWallets, wallet });
        (_a = clientCallbacks === null || clientCallbacks === void 0 ? void 0 : clientCallbacks.onWalletRemoved) === null || _a === void 0 ? void 0 : _a.call(clientCallbacks, { userWallets, wallet });
    });
    useInternalDynamicEvents('embeddedWalletCreated', (_wallet, jwtVerifiedCredential, user) => {
        var _a;
        logger$1.debug('[embeddedWalletCreated]', {
            _wallet,
            jwtVerifiedCredential,
            user,
        });
        (_a = clientCallbacks === null || clientCallbacks === void 0 ? void 0 : clientCallbacks.onEmbeddedWalletCreated) === null || _a === void 0 ? void 0 : _a.call(clientCallbacks, jwtVerifiedCredential, user);
    });
    useInternalDynamicEvents('logout', () => {
        var _a;
        (_a = clientCallbacks === null || clientCallbacks === void 0 ? void 0 : clientCallbacks.onLogout) === null || _a === void 0 ? void 0 : _a.call(clientCallbacks, user);
    });
    useInternalDynamicEvents('authFailure', (data, reason) => {
        var _a;
        logger$1.debug('[authFailure]', { data, reason });
        (_a = clientCallbacks === null || clientCallbacks === void 0 ? void 0 : clientCallbacks.onAuthFailure) === null || _a === void 0 ? void 0 : _a.call(clientCallbacks, data, reason);
    });
    useInternalDynamicEvents('authInit', (data) => {
        var _a;
        logger$1.debug('[authInit]', { data });
        (_a = clientCallbacks === null || clientCallbacks === void 0 ? void 0 : clientCallbacks.onAuthInit) === null || _a === void 0 ? void 0 : _a.call(clientCallbacks, data);
    });
    useInternalDynamicEvents('userProfileUpdated', (user) => {
        var _a;
        (_a = clientCallbacks === null || clientCallbacks === void 0 ? void 0 : clientCallbacks.onUserProfileUpdate) === null || _a === void 0 ? void 0 : _a.call(clientCallbacks, user);
    });
};

const useMultiWallet = ({ isBridgeFlow, multiWalletOverride, multiWalletSettings, }) => {
    var _a;
    // Use settings override
    if (multiWalletOverride !== undefined) {
        return multiWalletOverride;
    }
    // Use settings value
    return (_a = (multiWalletSettings || isBridgeFlow)) !== null && _a !== void 0 ? _a : false;
};

const useMultiAsset = ({ multiAssetOverride, multiAssetSettings, }) => {
    // Use settings override
    if (multiAssetOverride !== undefined) {
        return multiAssetOverride;
    }
    // Use settings value
    return multiAssetSettings !== null && multiAssetSettings !== void 0 ? multiAssetSettings : true;
};

const useParentDynamicContextGuard = () => {
    const context = useContext(DynamicContext);
    if (context) {
        throw new Error('DynamicContextProvider should not be nested. Please wrap your application in a single DynamicContextProvider.');
    }
};

/**
 * Registers the storage service for the SDK.
 * When on server side rendering, the storage service is not available, so we need to register a dummy storage service.
 * @param storagePostfix - The postfix for the storage services.
 */
const useRegisterStorageService = ({ storagePostfix, }) => {
    const lastPostfix = useRef(storagePostfix);
    if (!isSSR() && PlatformService.isNativeMobile)
        return;
    const storageForSSR = {
        clear: () => undefined,
        getItem: () => null,
        key: () => null,
        length: 0,
        removeItem: () => undefined,
        setItem: () => null,
    };
    const localStorage = isSSR() ? storageForSSR : window.localStorage;
    const sessionStorage = isSSR() ? storageForSSR : window.sessionStorage;
    if (lastPostfix.current !== storagePostfix) {
        lastPostfix.current = storagePostfix;
        StorageService.clearRegistry();
    }
    if (!StorageService.getSourceStorage('localStorage')) {
        StorageService.registerSourceStorage('localStorage', applyPostfixToStorageService({
            postfix: storagePostfix,
            storage: createStorageService({
                storage: localStorage,
            }),
        }));
    }
    if (!StorageService.getSourceStorage('sessionStorage')) {
        StorageService.registerSourceStorage('sessionStorage', applyPostfixToStorageService({
            postfix: storagePostfix,
            storage: createStorageService({
                storage: sessionStorage,
            }),
        }));
    }
};

const useShowEmbeddedWalletActionsUI = (transactionConfirmationSettings, projectSettings) => {
    var _a, _b;
    if (transactionConfirmationSettings === null || transactionConfirmationSettings === void 0 ? void 0 : transactionConfirmationSettings.required) {
        return true;
    }
    if (projectSettings) {
        return ((_b = (_a = projectSettings.sdk.embeddedWallets) === null || _a === void 0 ? void 0 : _a.showEmbeddedWalletActionsUI) !== null && _b !== void 0 ? _b : false);
    }
    return false;
};

const useShowFiat = ({ showFiatOverride, showFiatSettings, }) => {
    // Use settings override
    if (showFiatOverride !== undefined) {
        return showFiatOverride;
    }
    // Use settings value
    return showFiatSettings !== null && showFiatSettings !== void 0 ? showFiatSettings : true;
};

const isAuthenticatedWithAWallet = (user) => {
    const lastVerifiedCredential = user.verifiedCredentials.find((vc) => vc.id === user.lastVerifiedCredentialId);
    return ((lastVerifiedCredential === null || lastVerifiedCredential === void 0 ? void 0 : lastVerifiedCredential.format) ===
        JwtVerifiedCredentialFormatEnum.Blockchain);
};

const useCustomerCallbacks = ({ callbacks: { onAuthSuccess, onUserProfileUpdate }, handleLogOut, primaryWallet, user, isAuthenticated, }) => {
    const [callbackQueue, setCallbackQueue] = useState([]);
    const handleNextCallback = useCallback((next, user) => {
        if ((next === null || next === void 0 ? void 0 : next.callback) !== 'authSuccess')
            return;
        try {
            onAuthSuccess === null || onAuthSuccess === void 0 ? void 0 : onAuthSuccess({
                handleLogOut,
                isAuthenticated,
                primaryWallet,
                user,
            });
            dynamicEvents.emit('triggerSessionValidation');
        }
        catch (e) {
            logger$1.error('Error calling onAuthSuccess: ', e);
        }
    }, [handleLogOut, isAuthenticated, onAuthSuccess, primaryWallet]);
    useEffect(() => {
        if (!callbackQueue.length || !user)
            return;
        // checks if user logged in with a wallet, so we need to wait
        // for the primary wallet state to be set
        // if user logged in with email without embedded wallet, then
        // there is no wallet so we can go ahead and run the callback
        if (isAuthenticatedWithAWallet(user) && !primaryWallet) {
            return;
        }
        handleNextCallback(callbackQueue[0], user);
        setCallbackQueue((prev) => {
            const [resolvedCallback, ...updatedQueue] = prev;
            if (resolvedCallback) {
                logger$1.debug('Resolved callback: ', resolvedCallback.callback);
                logger$1.debug('Callbacks in queue: ', updatedQueue.map((c) => c.callback));
            }
            return updatedQueue;
        });
    }, [callbackQueue, handleNextCallback, primaryWallet, user]);
    const setCallback = useCallback((callback, params) => {
        setCallbackQueue((prev) => [...prev, { callback, params }]);
    }, []);
    return { setCallback };
};

const PUBLIC_PROJECT_LIVE_ENVIRONMENT_ID = '2762a57b-faa4-41ce-9f16-abff9300e2c9';
const DynamicContext = createContext(undefined);
/** The context provider itself we only use internally */
const InnerDynamicContextProvider = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const { children, theme, settings, locale, enableInstrumentation = false, } = props;
    const { accessDeniedMessagePrimary, accessDeniedMessageSecondary, accessDeniedButton, defaultPhoneInputIso2, apiBaseUrl, coinbaseWalletPreference, detectNewWalletsForLinking = defaultDynamicSettings.detectNewWalletsForLinking, enableConnectOnlyFallback = defaultDynamicSettings.enableConnectOnlyFallback, deepLinkPreference: deepLinkPreferenceProp = defaultDynamicSettings.deepLinkPreference, bridgeChains, cssOverrides, defaultNumberOfWalletsToShow = DEFAULT_NUMBER_OF_WALLETS_TO_SHOW, flowNetwork, initialAuthenticationMode = defaultDynamicSettings.initialAuthenticationMode, debugError = defaultDynamicSettings.debugError, displaySiweStatement = defaultDynamicSettings.displaySiweStatement, newToWeb3WalletChainMap, enableVisitTrackingOnConnectOnly = defaultDynamicSettings.enableVisitTrackingOnConnectOnly, environmentId, walletsFilter, logLevel = defaultDynamicSettings.logLevel, mobileExperience, notInTheListImageUrl, onboardingImageUrl, policiesConsentInnerComponent, customPrivacyPolicy, privacyPolicyUrl, socialMediaLinkText, socialMediaIconUrl, socialMediaUrl, customTermsOfServices, termsOfServiceUrl, toolkitEnabled, siweStatement, shadowDOMEnabled = defaultDynamicSettings.shadowDOMEnabled, walletConnectors: walletConnectorsProp, socialProvidersFilter, showLockedWalletView = defaultDynamicSettings.showLockedWalletView, walletConnectPreferredChains, walletConnectorExtensions, recommendedWallets, handlers, suppressEndUserConsoleWarning, transactionConfirmation: transactionConfirmationSettings, } = settings;
    let { appLogoUrl = defaultDynamicSettings.appLogoUrl, appName = defaultDynamicSettings.appName, } = settings;
    /**
     * initialize Storage
     */
    useRegisterStorageService({
        storagePostfix: settings.localStorageSuffix,
    });
    /**
     * initialize global store
     */
    initializeStore(Object.assign(Object.assign({}, props), { onPersistedVersionChanged: () => setDidStoreVersionChangedValue(true) }));
    useSyncDynamicContextProps(props);
    /**
     * Sets the chain info overrides if they are present
     */
    setChainInfoOverrides((_a = settings.overrides) === null || _a === void 0 ? void 0 : _a.chainDisplayValues);
    const networkValidationMode = resolveNetworkValidationMode({
        bridgeChains: settings.bridgeChains,
        networkValidationMode: settings.networkValidationMode,
    });
    if (!environmentId) {
        throw new MissingEnvironmentIdError();
    }
    logger$1.setLogLevel(logLevel);
    logger$8.setLogLevel(logLevel);
    if (environmentId === PUBLIC_PROJECT_LIVE_ENVIRONMENT_ID) {
        logger$1.warn(`WARNING: DYNAMIC is using a test environment ID ${environmentId}. Please sign up on https://app.dynamic.xyz/ to get your production environment ID.`);
    }
    const apiBaseUrlOverride = getEnvVarWithFallback('DYNAMIC_API_BASE_URL', apiBaseUrl || '');
    ApiEndpoint.setBaseUrl(apiBaseUrlOverride);
    const i18nSDKInstance = Locale.setup(locale);
    const isBridgeFlow = Boolean(bridgeChains);
    const deepLinkPreference = getDeepLinkPreference(deepLinkPreferenceProp, isBridgeFlow);
    const { selectedTabIndex, setSelectedTabIndex, selectedTabSettings, tabsItems, } = useTabState({ settingsOverrides: settings.overrides });
    // state to track the full connectivity status of the individual's wallets.
    // Set to true once the predetermined number of wallets is connected.
    const [bridgeOnboardingCompleted, setBridgeOnboardingCompleted, removeBridgeOnboardingCompleted,] = useLocalStorage(BRIDGE_ONBOARDING_COMPLETED, false);
    // Allows clients to control widget flow without need to click on AccountControl
    const [showDynamicUserProfile, setShowDynamicUserProfile] = useState(false);
    // Alows clients to control the Bridget Widget flow without need to click on Bridge Widget
    const [showBridgeWidget, setShowBridgeWidget] = useState(false);
    const [isSingleWalletAccount, setIsSingleWalletAccount] = useState(false);
    const { user, userWithMissingInfo } = useUser();
    // Calculates and stores a device fingerprint
    useDeviceFingerprint();
    const isAuthenticated = Boolean(user);
    const [qrcodeUri, setQrcodeUri] = useState('');
    const [desktopUri, setDesktopUri] = useState('');
    const [multiWalletWidgetState, setMultiWalletWidgetState, { awaiting_account_switch: [accountSwitchState], awaiting_signature: [awaitingSignatureState], },] = useMultiWalletWidgetState();
    const projectSettings = useProjectSettings();
    const serverNetworkConfigurations = useNetworkConfigurationsFromProjectSettings({
        cosmosNetworkOverrides: (_b = settings.overrides) === null || _b === void 0 ? void 0 : _b.cosmosNetworks,
        evmNetworksOverrides: (_c = settings.overrides) === null || _c === void 0 ? void 0 : _c.evmNetworks,
        projectSettings,
    });
    useSendDynamicProps({ environmentId, settings });
    // Console warning for end user safety
    useEndUserWarning({
        projectSettings,
        suppress: suppressEndUserConsoleWarning,
    });
    const multiWallet = useMultiWallet({
        isBridgeFlow,
        multiWalletOverride: (_d = settings.overrides) === null || _d === void 0 ? void 0 : _d.multiWallet,
        multiWalletSettings: (_e = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _e === void 0 ? void 0 : _e.multiWallet,
    });
    const multiAsset = useMultiAsset({
        multiAssetOverride: (_f = settings.overrides) === null || _f === void 0 ? void 0 : _f.multiAsset,
        multiAssetSettings: (_g = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _g === void 0 ? void 0 : _g.enableMultiAsset,
    });
    const showFiat = useShowFiat({
        showFiatOverride: (_h = settings.overrides) === null || _h === void 0 ? void 0 : _h.showFiat,
        showFiatSettings: (_j = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _j === void 0 ? void 0 : _j.showFiat,
    });
    // Used inside useVerifyOnAwaitingSignature. Is legacy and should be removed asap
    const [legacyIsVerifying, setLegacyIsVerifying] = useState(false);
    const walletBook = useWalletBookCdn();
    const { imageUserInAccessList, imageUserNotInAccessList, displayName, appLogo, } = (projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.general) || {};
    appLogoUrl = appLogo || appLogoUrl;
    appName = displayName || appName;
    const [loginWithEmail, setLogInWithEmail, resetLoginWithEmail] = useEmailLoginState((projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers) || [], user);
    const [authorizationViewDisplayOrder, setAuthorizationViewDisplayOrder] = useDisplayOrderState(projectSettings);
    const showEmbeddedWalletActionsUI = useShowEmbeddedWalletActionsUI(transactionConfirmationSettings, projectSettings);
    const [confirmationModal, walletUiUtils] = useWalletUiUtils({
        appLogoUrl,
        appName,
        hideEmbeddedWalletTransactionUIs: !showEmbeddedWalletActionsUI,
    });
    const [authMode, setAuthMode] = useState(initialAuthenticationMode);
    const connectorProps = useMemo(() => ({
        appLogoUrl,
        appName,
        authMode,
        coinbaseWalletPreference,
        deepLinkPreference,
        flowNetwork,
        mobileExperience,
        networkConfigurations: serverNetworkConfigurations,
        projectSettings,
        walletBook,
        walletConnectPreferredChains,
        walletConnectorExtensions,
        walletConnectorsProp,
        walletUiUtils,
    }), [
        appLogoUrl,
        appName,
        authMode,
        coinbaseWalletPreference,
        deepLinkPreference,
        flowNetwork,
        mobileExperience,
        serverNetworkConfigurations,
        projectSettings,
        walletBook,
        walletConnectPreferredChains,
        walletConnectorExtensions,
        walletConnectorsProp,
        walletUiUtils,
    ]);
    useCreateWalletConnectorOptions(connectorProps);
    const walletConnectorOptions = useWalletConnectorOptions();
    useCreateWalletGroups({ walletConnectorOptions });
    const primaryWalletId = usePrimaryWalletId();
    // this is a state because it's set based on primaryWallet and bridgeChainsToConnect,
    // which are only available further down and have would have circular dependencies
    const [requiredWalletsConnected, setRequiredWalletsConnected] = useState(false);
    const isUserAuthenticated = Boolean(authMode === 'connect-and-sign' ? user : requiredWalletsConnected);
    const isRenderingEmbeddedAuthFlow = useRef(false);
    const [showAuthFlow, setShowAuthFlow] = useShowAuthFlow({
        isAuthenticated: isUserAuthenticated,
        isMultiWalletEnabled: multiWallet,
        isRenderingEmbeddedAuthFlow,
        setShowDynamicUserProfile,
    });
    const { connectWallet, removeConnectedWalletsInfo, connectedWalletsInfo, getConnectedWalletById, connectedWallets, disconnectWallet, refreshConnectedWallet, } = useConnectWallet({
        authMode,
        enableVisitTrackingOnConnectOnly,
        environmentId,
        handleConnectedWallet: handlers === null || handlers === void 0 ? void 0 : handlers.handleConnectedWallet,
        isBridgeFlow,
        primaryWalletId,
        setShowAuthFlow,
        user,
        walletConnectorOptions,
    });
    const bridgeChainsToConnect = useMemo(() => getMissingChains(bridgeChains, connectedWalletsInfo), [bridgeChains, connectedWalletsInfo]);
    const { selectedWalletConnector, setSelectedWalletConnectorKey } = useSelectedWalletConnector({ walletConnectorOptions });
    //selected wallet to perform an action (become primary, unlink, etc)
    const [selectedWalletWithAction, setSelectedWalletWithAction] = useState(null);
    useSetWalletConnectorVerifiedCredentials(user !== null && user !== void 0 ? user : userWithMissingInfo, walletConnectorOptions);
    useSetWalletConnectorFetchers(walletConnectorOptions, environmentId, projectSettings);
    const { primaryWallet, showQrcodeModal, secondaryWallets, setPrimaryWallet, setShowQrcodeModal, wallets: linkedOrConnectedWallets, } = useWalletConnectors({
        authMode,
        canHaveMultipleWalletsConnected: multiWallet,
        connectedWallets,
        primaryWalletId,
        separateSmartWalletAndSigner: (_l = (_k = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _k === void 0 ? void 0 : _k.accountAbstraction) === null || _l === void 0 ? void 0 : _l.separateSmartWalletAndSigner,
        setMultiWalletWidgetState,
        user: user || userWithMissingInfo,
        walletConnectorOptions,
    });
    useEffect(() => {
        setRequiredWalletsConnected(!(bridgeChainsToConnect === null || bridgeChainsToConnect === void 0 ? void 0 : bridgeChainsToConnect.length) && Boolean(primaryWallet));
    }, [bridgeChainsToConnect, primaryWallet]);
    const walletConnectors = useMemo(() => linkedOrConnectedWallets.map((wallet) => wallet.connector), [linkedOrConnectedWallets]);
    const { refetchProjectSettings } = useFetchProjectSettings();
    useFetchNonce({
        shouldFetch: shouldFetchNonce({ authMode }),
    });
    const { getNameService, removeConnectedNameService } = useNameService({
        currentWallet: primaryWallet !== null && primaryWallet !== void 0 ? primaryWallet : connectedWallets[0],
        user,
    });
    const { clearAllWalletConnectSessions } = useClearWalletConnectSessions({
        connectors: walletConnectors,
    });
    const removeSessionStorageSessionKeys = () => {
        StorageService.removeItem(SECURE_ENCLAVE_WALLET_SESSION_KEYS, SECURE_ENCLAVE_WALLET_SESSION_KEYS_STORAGE_OPTIONS);
        walletConnectors.forEach((connector) => {
            if (isSessionKeyCompatibleWalletConnector(connector) &&
                typeof (connector === null || connector === void 0 ? void 0 : connector.removeSessionKeys) === 'function') {
                connector === null || connector === void 0 ? void 0 : connector.removeSessionKeys();
            }
        });
    };
    const handleLogOut = useHandleLogout({
        bridgeChains,
        clearAllWalletConnectSessions,
        connectedWallets,
        environmentId,
        events: settings.events,
        initialAuthenticationMode,
        removeBridgeOnboardingCompleted,
        removeConnectedNameService,
        removeConnectedWalletsInfo,
        removeSessionStorageSessionKeys,
        resetLoginWithEmail,
        setAuthMode,
        setLegacyIsVerifying,
        setMultiWalletWidgetState,
        setSelectedWalletConnectorKey,
        setShowAuthFlow,
        setShowBridgeWidget,
        setShowDynamicUserProfile,
        user,
        walletConnectors,
    });
    useValidateSession({
        environmentId,
        handleLogOut,
    });
    const { isLoading: isLoadingUserFromCookie } = useResetCookieLocalStorage();
    // For some reason, calling useNonce in useGlobalLoading causes errors
    const nonce = useNonce();
    const sdkHasLoaded = useGlobalLoading({
        appName,
        authMode,
        connectedInfo: connectedWalletsInfo[0],
        connectedWallets,
        enableInstrumentation,
        environmentId,
        isLoadingUserFromCookie,
        nonce,
        primaryWallet,
        primaryWalletId,
        projectSettings,
        user: user !== null && user !== void 0 ? user : userWithMissingInfo,
        walletBook,
    });
    // Ties all client callbacks to dynamic's events, such that
    // when our events are triggered, so are the client callbacks
    useTieCallbacksToEvents({
        clientCallbacks: settings.events,
        user,
    });
    const verifiedCredentials = useMemo(() => (user === null || user === void 0 ? void 0 : user.verifiedCredentials) || [], [user]);
    const handleUnlinkWallet = useHandleUnlinkWallet({
        environmentId,
        primaryWalletId,
        secondaryWallets,
        verifiedCredentials,
    });
    const { isLoading: loadingNetwork, network } = useWalletConnectorNetwork(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector, {
        onChange: (newNetwork) => {
            if (newNetwork) {
                dynamicEvents.emit('primaryWalletNetworkChanged', newNetwork);
            }
        },
    });
    useAggregateWalletEvents();
    useWalletEventListeners({
        authMode,
        detectNewWalletsForLinking,
        disconnectWallet,
        handleLogOut,
        multiWallet,
        multiWalletWidgetState,
        primaryWallet,
        refreshConnectedWallet,
        secondaryWallets,
        selectedWalletConnector,
        selectedWalletWithAction,
        setMultiWalletWidgetState,
        setSelectedWalletConnectorKey,
        setSelectedWalletWithAction,
        user,
    });
    const { walletsForChainsMap } = useFetchWalletsForChainsMap(newToWeb3WalletChainMap);
    useEffect(() => {
        initExpirationTime(handleLogOut);
    }, [handleLogOut, isAuthenticated]);
    const { setCallback } = useCustomerCallbacks({
        callbacks: {
            onAuthSuccess: (_m = settings.events) === null || _m === void 0 ? void 0 : _m.onAuthSuccess,
            onUserProfileUpdate: (_o = settings.events) === null || _o === void 0 ? void 0 : _o.onUserProfileUpdate,
        },
        handleLogOut,
        isAuthenticated,
        primaryWallet,
        user,
    });
    const sendWagmiSettings = useCallback(() => (settings) => {
        const { dynamicWagmiSettings } = settings;
        if (dynamicWagmiSettings) {
            sendDynamicProps(environmentId, {
                dynamicWagmiSettings: { dynamicWagmiSettings },
            });
        }
    }, [environmentId]);
    const clearStatesOnBackClick = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        setDesktopUri('');
        setLegacyIsVerifying(false);
        if (!user) {
            clearAllWalletConnectSessions();
        }
        setMultiWalletWidgetState('idle');
        if (authMode !== 'connect-only') {
            removeConnectedWalletsInfo();
        }
        if (StorageService.getItem(WALLET_PICKER_SEARCH_KEY)) {
            StorageService.removeItem(WALLET_PICKER_SEARCH_KEY);
        }
        StorageService.removeItem(PHANTOM_SIGNATURE_STATE);
        if (selectedWalletConnector &&
            (!primaryWallet ||
                primaryWallet.connector.key !== selectedWalletConnector.key)) {
            yield (selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.endSession());
        }
    }), [
        user,
        setMultiWalletWidgetState,
        authMode,
        selectedWalletConnector,
        primaryWallet,
        clearAllWalletConnectSessions,
        removeConnectedWalletsInfo,
    ]);
    const { passkeySuccessPopup, setPasskeySuccessPopup } = usePasskeySuccessPopup();
    const memoizedLocale = useMemo(() => ({
        changeLanguage: Locale.getInstance().changeLanguage,
    }), []);
    const linkedWallets = useMemo(() => authMode === 'connect-only' || !user ? [] : linkedOrConnectedWallets, [authMode, linkedOrConnectedWallets, user]);
    const value = useMemo(() => {
        var _a;
        return ({
            accessDeniedButton,
            accessDeniedMessagePrimary,
            accessDeniedMessageSecondary,
            accountSwitchState,
            appLogoUrl,
            appName,
            authMode,
            authorizationViewDisplayOrder,
            awaitingSignatureState,
            bridgeChains,
            bridgeChainsToConnect,
            bridgeOnboardingCompleted,
            clearStatesOnBackClick,
            connectWallet,
            connectedWallets,
            cssOverrides,
            customPrivacyPolicy,
            customTermsOfServices,
            debugError,
            defaultNumberOfWalletsToShow,
            defaultPhoneInputIso2,
            desktopUri,
            detectNewWalletsForLinking,
            disconnectWallet,
            displaySiweStatement,
            enableConnectOnlyFallback,
            environmentId,
            events: settings.events,
            getConnectedWalletById,
            getNameService,
            handleLogOut,
            handleUnlinkWallet: authMode === 'connect-only' ? disconnectWallet : handleUnlinkWallet,
            handlers,
            i18nSDKInstance,
            isBridgeFlow,
            isRenderingEmbeddedAuthFlow,
            isSingleWalletAccount,
            legacyIsVerifying,
            linkedWallets,
            loadingNetwork,
            locale: memoizedLocale,
            loginWithEmail,
            multiAsset,
            multiWallet,
            multiWalletWidgetState,
            network,
            networkConfigurations: serverNetworkConfigurations,
            networkValidationMode,
            newToWeb3WalletChainMap: walletsForChainsMap,
            notInTheListImageUrl: imageUserNotInAccessList || notInTheListImageUrl,
            onboardingImageUrl: imageUserInAccessList || onboardingImageUrl,
            overrides: settings.overrides,
            passkeySuccessPopup,
            policiesConsentInnerComponent,
            primaryWallet,
            primaryWalletId,
            privacyPolicyUrl,
            projectSettings,
            qrcodeUri,
            recommendedWallets,
            redirectUrl: settings.redirectUrl,
            refetchProjectSettings,
            removeBridgeOnboardingCompleted,
            removeConnectedWalletsInfo,
            sdkHasLoaded,
            secondaryWallets,
            selectedTabIndex,
            selectedTabSettings,
            selectedWalletConnector,
            selectedWalletWithAction,
            sendWagmiSettings,
            setAuthMode,
            setAuthorizationViewDisplayOrder,
            setBridgeOnboardingCompleted,
            setCallback,
            setDesktopUri,
            setIsSingleWalletAccount,
            setLegacyIsVerifying,
            setLogInWithEmail,
            setMultiWalletWidgetState,
            setPasskeySuccessPopup,
            setPrimaryWallet,
            setQrcodeUri,
            setSelectedTabIndex,
            setSelectedWalletConnectorKey,
            setSelectedWalletWithAction,
            setShowAuthFlow,
            setShowBridgeWidget,
            setShowDynamicUserProfile,
            setShowQrcodeModal,
            shadowDOMEnabled,
            showAuthFlow,
            showBridgeWidget,
            showDynamicUserProfile,
            showFiat,
            showLockedWalletView,
            showQrcodeModal,
            siweStatement,
            socialMediaIconUrl: ((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.general) === null || _a === void 0 ? void 0 : _a.supportUrls) || socialMediaIconUrl,
            socialMediaLinkText,
            socialMediaUrl,
            socialProvidersFilter,
            socialSettings: settings.social,
            tabsItems,
            termsOfServiceUrl,
            theme,
            toolkitEnabled,
            user,
            userWithMissingInfo,
            walletConnectorOptions,
            walletUiUtils,
            walletsFilter,
        });
    }, [
        accessDeniedButton,
        accessDeniedMessagePrimary,
        accessDeniedMessageSecondary,
        accountSwitchState,
        appLogoUrl,
        appName,
        authMode,
        authorizationViewDisplayOrder,
        awaitingSignatureState,
        bridgeChains,
        bridgeChainsToConnect,
        bridgeOnboardingCompleted,
        clearStatesOnBackClick,
        connectWallet,
        connectedWallets,
        cssOverrides,
        customPrivacyPolicy,
        customTermsOfServices,
        debugError,
        defaultNumberOfWalletsToShow,
        defaultPhoneInputIso2,
        desktopUri,
        detectNewWalletsForLinking,
        disconnectWallet,
        displaySiweStatement,
        enableConnectOnlyFallback,
        environmentId,
        settings.events,
        settings.overrides,
        settings.redirectUrl,
        settings.social,
        getConnectedWalletById,
        getNameService,
        handleLogOut,
        handleUnlinkWallet,
        handlers,
        i18nSDKInstance,
        isBridgeFlow,
        isSingleWalletAccount,
        legacyIsVerifying,
        linkedWallets,
        loadingNetwork,
        memoizedLocale,
        loginWithEmail,
        multiAsset,
        multiWallet,
        multiWalletWidgetState,
        network,
        serverNetworkConfigurations,
        networkValidationMode,
        walletsForChainsMap,
        imageUserNotInAccessList,
        notInTheListImageUrl,
        imageUserInAccessList,
        onboardingImageUrl,
        passkeySuccessPopup,
        policiesConsentInnerComponent,
        primaryWallet,
        primaryWalletId,
        privacyPolicyUrl,
        projectSettings,
        qrcodeUri,
        recommendedWallets,
        refetchProjectSettings,
        removeBridgeOnboardingCompleted,
        removeConnectedWalletsInfo,
        sdkHasLoaded,
        secondaryWallets,
        selectedTabIndex,
        selectedTabSettings,
        selectedWalletConnector,
        selectedWalletWithAction,
        sendWagmiSettings,
        setAuthorizationViewDisplayOrder,
        setBridgeOnboardingCompleted,
        setCallback,
        setLogInWithEmail,
        setMultiWalletWidgetState,
        setPasskeySuccessPopup,
        setPrimaryWallet,
        setSelectedTabIndex,
        setSelectedWalletConnectorKey,
        setShowAuthFlow,
        setShowQrcodeModal,
        shadowDOMEnabled,
        showAuthFlow,
        showBridgeWidget,
        showDynamicUserProfile,
        showFiat,
        showLockedWalletView,
        showQrcodeModal,
        siweStatement,
        socialMediaIconUrl,
        socialMediaLinkText,
        socialMediaUrl,
        socialProvidersFilter,
        tabsItems,
        termsOfServiceUrl,
        theme,
        toolkitEnabled,
        user,
        userWithMissingInfo,
        walletConnectorOptions,
        walletUiUtils,
        walletsFilter,
    ]);
    usePrefetch({
        as: 'image',
        href: getIconicSpriteUrl(),
        id: 'sprite',
        type: 'image/svg+xml',
    });
    usePrefetch({
        as: 'fetch',
        href: getWalletBookCdnUrl(),
        id: 'wallet-book',
        type: 'application/json',
    });
    usePrefetch({
        as: 'fetch',
        href: `${ApiEndpoint.getBaseUrl()}/sdk/${environmentId}/settings?sdkVersion=${encodeURIComponent(`WalletKit/${VERSION}`)}`,
        id: `project-settings-${environmentId}`,
        type: 'application/json',
    });
    return (jsxRuntimeExports.jsx(I18nextProvider, { i18n: i18nSDKInstance, children: jsxRuntimeExports.jsx(DynamicContext.Provider, { value: value, children: jsxRuntimeExports.jsx(WalletBookContextProvider, { walletBook: walletBook, children: jsxRuntimeExports.jsx(ThemeContextProvider, { customerTheme: parseTheme(theme, ((_p = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.design) === null || _p === void 0 ? void 0 : _p.modal) || undefined), designSettings: projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.design, children: jsxRuntimeExports.jsx(LoadingContextProvider, { children: jsxRuntimeExports.jsxs(ViewContextProvider, { initialViewType: getInitialViewType({
                                bridgeOnboardingCompleted,
                                connectedWallets,
                                isAuthenticated: isAuthenticated || Boolean(primaryWallet),
                                isBridgeFlow,
                                isMultiWalletEnabled: multiWallet,
                            }), children: [networkValidationMode === 'always' && jsxRuntimeExports.jsx(UseNetworkValidation, {}), jsxRuntimeExports.jsx(CaptchaContextProvider, { children: jsxRuntimeExports.jsx(AccountExistsContextProvider, { children: jsxRuntimeExports.jsx(WalletContextProvider, { children: jsxRuntimeExports.jsx(VerificationProvider, { children: jsxRuntimeExports.jsx(PasskeyContextProvider, { children: jsxRuntimeExports.jsx(DynamicWidgetContextProvider, { children: jsxRuntimeExports.jsx(DynamicBridgeWidgetContextProvider, { children: jsxRuntimeExports.jsx(OnrampContextProvider, { children: jsxRuntimeExports.jsx(AccessDeniedContextProvider, { children: jsxRuntimeExports.jsx(SendBalanceContextProvider, { children: jsxRuntimeExports.jsx(WalletGroupContextProvider, { children: jsxRuntimeExports.jsx(UserFieldEditorContextProvider, { children: jsxRuntimeExports.jsx(ConnectWithOtpProvider, { children: jsxRuntimeExports.jsx(PhantomRedirectContextProvider, { children: jsxRuntimeExports.jsxs(SocialRedirectContextProvider, { children: [jsxRuntimeExports.jsx(DynamicAuthFlow, {}), jsxRuntimeExports.jsx(Toolkit, {}), jsxRuntimeExports.jsx(OnrampWidget, {}), jsxRuntimeExports.jsx(SyncAuthFlow, {}), jsxRuntimeExports.jsx(WalletConnectorEvents, { connectorProps: connectorProps }), confirmationModal, jsxRuntimeExports.jsx(ErrorBoundaryExclude, { children: children })] }) }) }) }) }) }) }) }) }) }) }) }) }) }) })] }) }) }) }) }) }));
};
/** The context provider you need to have access too all of Dynamic's hooks */
const DynamicContextProvider = (props) => {
    Logger$1.setEnvironmentId(props.settings.environmentId);
    Logger$1.setEmitErrors(props.emitErrors);
    useParentDynamicContextGuard();
    return (jsxRuntimeExports.jsx(ReinitializeContextProvider, { onReinitialize: onReinitialize, children: jsxRuntimeExports.jsx(ErrorBoundary, { children: jsxRuntimeExports.jsx(ErrorContextProvider, { children: jsxRuntimeExports.jsx(UserWalletsProvider, { children: jsxRuntimeExports.jsx(FieldsStateProvider, { children: jsxRuntimeExports.jsx(IpConfigurationContextProvider, { children: jsxRuntimeExports.jsx(WidgetRegistryContextProvider, { children: jsxRuntimeExports.jsx(InnerDynamicContextProvider, Object.assign({}, props)) }) }) }) }) }) }) }));
};

var _path$g;
var _excluded$g = ["title", "titleId"];
function _extends$g() { return _extends$g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$g.apply(null, arguments); }
function _objectWithoutProperties$g(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$g(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$g(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgLogout = function SvgLogout(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$g(_ref, _excluded$g);
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1.333c-.736 0-1.333.597-1.333 1.334v6.666c0 .737.597 1.334 1.333 1.334h2.667C6.403 10.667 7 10.07 7 9.333v-.666a.667.667 0 0 1 1.333 0v.666A2.667 2.667 0 0 1 5.667 12H3A2.667 2.667 0 0 1 .333 9.333V2.667A2.667 2.667 0 0 1 3 0h2.667a2.667 2.667 0 0 1 2.666 2.667v.666a.667.667 0 1 1-1.333 0v-.666c0-.737-.597-1.334-1.333-1.334H3Zm6.862 1.529c.26-.26.682-.26.943 0l2.666 2.667c.26.26.26.682 0 .942l-2.666 2.667a.667.667 0 0 1-.943-.943l1.529-1.528H3.667a.667.667 0 0 1 0-1.334h7.724L9.862 3.805a.667.667 0 0 1 0-.943Z"
  })));
};

var _path$f;
var _excluded$f = ["title", "titleId"];
function _extends$f() { return _extends$f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$f.apply(null, arguments); }
function _objectWithoutProperties$f(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$f(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$f(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgPencil = function SvgPencil(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$f(_ref, _excluded$f);
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.04 1.96a1 1 0 0 0-1.414 0l-.528.528 1.414 1.414.529-.528a1 1 0 0 0 0-1.414Zm-1.47 2.885L9.154 3.431l-7.488 7.488v1.438h1.39l7.512-7.512Zm-.886-3.828a2.333 2.333 0 0 1 3.3 3.3l-9.18 9.178a.666.666 0 0 1-.47.195H1a.667.667 0 0 1-.667-.666v-2.381c0-.177.07-.347.196-.472l9.155-9.154Z",
    fill: "currentColor",
    fillOpacity: 0.65
  })));
};

/**
 * Will override the rpcUrl of the networks in the first param with the urls specified in the second param.
 *
 * @example
 * const DynamicSettings = {
 *    overrides: {
 *        evmNetworks: (networks) => overrideNetworkRpcUrl(networks, {
 *            "1": ["https://eth.customrpc.com", "https://eth.customrpc2.com"],
 *            "137": ["https://polygon.customrpc.com"],
 *        }),
 *    }
 * }
 */
const overrideNetworkRpcUrl = (networks, rpcUrlOverrides) => {
    const updatedNetworks = [];
    networks.forEach((network) => {
        if (rpcUrlOverrides[network.chainId]) {
            updatedNetworks.push(Object.assign(Object.assign({}, network), { privateCustomerRpcUrls: rpcUrlOverrides[network.chainId] }));
        }
        else {
            updatedNetworks.push(network);
        }
    });
    return updatedNetworks;
};

const getEnabledOAuthProviders = (providers) => {
    var _a;
    return (_a = providers === null || providers === void 0 ? void 0 : providers.filter(({ enabledAt, authorizationUrl, redirectUrl }) => Boolean(enabledAt) && Boolean(authorizationUrl) && Boolean(redirectUrl))) !== null && _a !== void 0 ? _a : [];
};

const getEnabledSocialSignInProvidersAsProviderEnum = (providers) => {
    if (!providers)
        return [];
    const enabledProviders = [];
    for (const provider of providers) {
        const matchingProviderEnum = getProviderEnumForSocialSignInProvider(provider.provider);
        if (matchingProviderEnum && provider.enabled) {
            enabledProviders.push(matchingProviderEnum);
        }
    }
    return enabledProviders;
};

// Hook exposed to customers and used internally to handle social account linking
const useSocialAccounts = () => {
    var _a;
    const { environmentId, user, projectSettings } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const { setSocialProvider } = useSocialRedirectContext();
    const { handleError, setError, setIsProcessing, checkValidProvider, error, isProcessing, connectSocialAccount, } = useSocialAuth({
        onFarcasterUrl: (url) => pushView('farcaster-connect-view', { url }, {
            onBackClick: () => {
                setSocialProvider(undefined);
                dynamicEvents.emit('farcasterConnectCancelled');
                dynamicEvents.emit('authFailure', {
                    option: ProviderEnum.Farcaster,
                    provider: ProviderEnum.Farcaster,
                    type: 'social',
                }, 'user-cancelled');
            },
        }),
    });
    const verifiedOAuthCredentialsMap = useMemo(() => {
        var _a, _b;
        const verifiedOAuthCredential = (_b = (_a = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.filter((credential) => credential.format === 'oauth')) !== null && _b !== void 0 ? _b : [];
        const credentialMap = new Map();
        verifiedOAuthCredential.forEach((credential) => {
            var _a, _b;
            const key = (_a = credential.oauthProvider) !== null && _a !== void 0 ? _a : credential.id;
            const existing = (_b = credentialMap.get(key)) !== null && _b !== void 0 ? _b : [];
            credentialMap.set(key, [...existing, credential]);
        });
        return Object.fromEntries(credentialMap);
    }, [user === null || user === void 0 ? void 0 : user.verifiedCredentials]);
    const checkValidOAuthLinking = useCallback((provider) => {
        if (!isSocialKycEnabled(projectSettings)) {
            handleError(provider, SocialOAuthErrorCode.SOCIAL_LINKING_NOT_ENABLED, 'Social linking is not enabled in Information Capture on the dashboard', { raiseAuthFailure: false });
            return false;
        }
        const oauthProviders = getEnabledOAuthProviders(projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers);
        const oauthProvider = oauthProviders === null || oauthProviders === void 0 ? void 0 : oauthProviders.find((p) => p.provider === provider);
        if (!oauthProvider) {
            handleError(provider, SocialOAuthErrorCode.PROVIDER_NOT_ENABLED, `Social linking provider is not enabled in Information Capture on the dashboard: ${provider}`, { raiseAuthFailure: false });
            return false;
        }
        return true;
    }, [handleError, projectSettings]);
    const linkSocialAccount = useCallback((provider_1, ...args_1) => __awaiter$1(void 0, [provider_1, ...args_1], void 0, function* (provider, { redirectUrl } = { redirectUrl: undefined }) {
        connectSocialAccount({
            authMode: 'link',
            provider,
            redirectUrl,
            validator: checkValidOAuthLinking,
        });
    }), [checkValidOAuthLinking, connectSocialAccount]);
    const findVerifiedCredentialById = (provider, verifiedCredentialId) => {
        var _a;
        const verifiedCredentials = (_a = verifiedOAuthCredentialsMap[provider]) !== null && _a !== void 0 ? _a : [];
        const verifiedCredential = verifiedCredentialId
            ? verifiedCredentials.find((cred) => cred.id === verifiedCredentialId)
            : verifiedCredentials[0];
        return verifiedCredential;
    };
    const unlinkSocialAccount = useCallback((provider, verifiedCredentialId) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _b;
        setError(undefined);
        setIsProcessing(true);
        if (!checkValidProvider(provider, 'unlink')) {
            return;
        }
        const verifiedCredential = findVerifiedCredentialById(provider, verifiedCredentialId);
        if (!verifiedCredential) {
            handleError(provider, SocialOAuthErrorCode.NO_ACCOUNT_LINKED, `No account linked for provider: ${provider}`, { raiseAuthFailure: false });
            return;
        }
        try {
            const primaryWalletId = getPrimaryWalletId();
            const response = yield unlinkOAuth({
                environmentId,
                primaryWalletId,
                verifiedCrentialId: (_b = verifiedCredential.id) !== null && _b !== void 0 ? _b : '',
            });
            if (!response) {
                handleError(provider, SocialOAuthErrorCode.UNLINK_ERROR, `Failed to unlink social account: ${provider} | ${verifiedCredential.id}`, { raiseAuthFailure: false });
                return;
            }
            setIsProcessing(false);
        }
        catch (err) {
            handleError(provider, SocialOAuthErrorCode.GENERAL_ERROR, `Failed to unlink social account: ${provider} | ${verifiedCredential.id}`, { raiseAuthFailure: false });
        }
    }), [
        checkValidProvider,
        environmentId,
        handleError,
        setError,
        setIsProcessing,
        verifiedOAuthCredentialsMap,
    ]);
    const isLinked = useCallback((provider) => { var _a; return Boolean((_a = verifiedOAuthCredentialsMap[provider]) === null || _a === void 0 ? void 0 : _a.length); }, [verifiedOAuthCredentialsMap]);
    const getAccountInformation = (verifiedCredential) => {
        const { id, oauthAccountId, oauthAccountPhotos, oauthDisplayName, oauthEmails, oauthProvider, oauthUsername, publicIdentifier, } = verifiedCredential;
        return {
            accountId: oauthAccountId !== null && oauthAccountId !== void 0 ? oauthAccountId : undefined,
            avatar: oauthAccountPhotos === null || oauthAccountPhotos === void 0 ? void 0 : oauthAccountPhotos[0],
            displayName: oauthDisplayName !== null && oauthDisplayName !== void 0 ? oauthDisplayName : undefined,
            email: oauthEmails === null || oauthEmails === void 0 ? void 0 : oauthEmails[0],
            id,
            provider: oauthProvider,
            publicIdentifier,
            username: oauthUsername,
        };
    };
    const getLinkedAccountInformation = useCallback((provider, verifiedCredentialId) => {
        const verifiedCredential = findVerifiedCredentialById(provider, verifiedCredentialId);
        if (!verifiedCredential) {
            return;
        }
        return getAccountInformation(verifiedCredential);
    }, [verifiedOAuthCredentialsMap]);
    const getLinkedAccounts = useCallback((provider) => {
        var _a;
        const verifiedCredentials = (_a = verifiedOAuthCredentialsMap[provider]) !== null && _a !== void 0 ? _a : [];
        return verifiedCredentials.map((credential) => getAccountInformation(credential));
    }, [verifiedOAuthCredentialsMap]);
    const checkValidOAuthSignIn = useCallback((provider) => {
        var _a;
        const oauthProvider = getEnabledSocialSignInProvidersAsProviderEnum((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.socialSignIn) === null || _a === void 0 ? void 0 : _a.providers).find((socialProvider) => socialProvider === provider);
        if (!oauthProvider) {
            handleError(provider, SocialOAuthErrorCode.PROVIDER_NOT_ENABLED, `Provider is not enabled for sign-in on the dashboard: ${provider}`, { raiseAuthFailure: true });
            return false;
        }
        return true;
    }, [handleError, (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.socialSignIn) === null || _a === void 0 ? void 0 : _a.providers]);
    const signInWithSocialAccount = useCallback((provider_2, ...args_2) => __awaiter$1(void 0, [provider_2, ...args_2], void 0, function* (provider, { redirectUrl } = { redirectUrl: undefined }) {
        return connectSocialAccount({
            authMode: 'signin',
            provider,
            redirectUrl,
            validator: checkValidOAuthSignIn,
        });
    }), [checkValidOAuthSignIn, connectSocialAccount]);
    return useMemo(() => ({
        error,
        getLinkedAccountInformation,
        getLinkedAccounts,
        isLinked,
        isProcessing,
        linkSocialAccount,
        signInWithSocialAccount,
        unlinkSocialAccount,
    }), [
        error,
        getLinkedAccountInformation,
        getLinkedAccounts,
        isLinked,
        isProcessing,
        linkSocialAccount,
        signInWithSocialAccount,
        unlinkSocialAccount,
    ]);
};

const useMultiWalletPromptState = () => {
    const { accountSwitchState, multiWalletWidgetState, multiWallet, selectedWalletWithAction, } = useInternalDynamicContext();
    if ((selectedWalletWithAction === null || selectedWalletWithAction === void 0 ? void 0 : selectedWalletWithAction.action) === 'unlink') {
        return 'unlink_wallet';
    }
    if (multiWalletWidgetState === 'awaiting_signature') {
        return 'pending_sign';
    }
    if (multiWalletWidgetState === 'awaiting_account_switch') {
        if (accountSwitchState === 'linking_new_wallet') {
            return 'linking_new_wallet';
        }
        if (accountSwitchState === 'primary_not_connected') {
            if (multiWallet) {
                return 'primary_not_connected';
            }
            else {
                return 'pending_account_switch';
            }
        }
        if (accountSwitchState === 'switching_primary') {
            return 'pending_account_switch';
        }
    }
    if (multiWalletWidgetState === 'awaiting_connection') {
        return 'awaiting_connection';
    }
    if (multiWalletWidgetState === 'detected_new_wallet') {
        return 'detected_new_wallet';
    }
    return 'idle';
};

/**
 * Switch wallet
 *
 * @returns Function to switch wallet
 *
 * @example
 * ```tsx
 * const App = () => {
 *   const userWallets = useUserWallets();
 *   const switchWallet = useSwitchWallet();
 *
 *   return (
 *     <div>
 *       {userWallets.map((wallet) => (
 *         <button
 *           key={wallet.address}
 *           onClick={() => switchWallet(wallet.id)}
 *         >
 *           {wallet.address}
 *         </button>
 *       ))}
 *    </div>
 *  );
 * }
 */
const useSwitchWallet = () => {
    const { setPrimaryWallet, user, primaryWallet } = useInternalDynamicContext();
    const { getEOAWallet } = useSmartWallets();
    const userWallets = useUserWallets();
    return useCallback((walletId) => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const wallet = userWallets.find((wallet) => wallet.id === walletId);
        if (!wallet) {
            throw new Error(`Wallet with id ${walletId} not found`);
        }
        if (!wallet.connector.isAvailable) {
            throw new Error("Cannot make this wallet active, since this wallet doesn't have a compatible connector on this device.");
        }
        const eoaWallet = getEOAWallet(wallet);
        if (eoaWallet && isTurnkeyWalletConnector(eoaWallet.connector)) {
            const sortedVcs = (_b = (_a = eoaWallet.connector) === null || _a === void 0 ? void 0 : _a.verifiedCredentials) === null || _b === void 0 ? void 0 : _b.reduce((acc, vc) => {
                if (vc.address === eoaWallet.address) {
                    return [vc, ...acc];
                }
                return [...acc, vc];
            }, []);
            if (sortedVcs) {
                eoaWallet.connector.setVerifiedCredentials(sortedVcs);
            }
        }
        const { connector } = wallet;
        const email = (_c = user === null || user === void 0 ? void 0 : user.verifiedCredentials.find((verifiedCredential) => verifiedCredential.format === 'email')) === null || _c === void 0 ? void 0 : _c.email;
        if (isEmailWalletConnector(connector) && email) {
            connector.setEmail(email);
        }
        if ((primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain) === 'flow' &&
            connector.connectedChain === 'FLOW') {
            yield connector.endSession();
        }
        setPrimaryWallet(walletId);
    }), [
        getEOAWallet,
        primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain,
        setPrimaryWallet,
        user === null || user === void 0 ? void 0 : user.verifiedCredentials,
        userWallets,
    ]);
};

const useEmbeddedWalletAuthenticator = () => {
    const { initPasskeyRecoveryProcess, shouldInitRecovery } = usePasskeyRecovery();
    const { setShowAuthFlow } = useInternalDynamicContext();
    const { pushView } = useViewContext();
    const createOrRefreshAuthenticatorSession = (authenticatorType) => __awaiter$1(void 0, void 0, void 0, function* () {
        // user has passkey authenticator set up OR active session
        // there is no need to create or refresh the authenticator
        if (authenticatorType !== 'passkey' && !(yield shouldInitRecovery())) {
            return;
        }
        return initPasskeyRecoveryProcess(authenticatorType);
    });
    const addEmbeddedWalletRecoveryEmail = () => __awaiter$1(void 0, void 0, void 0, function* () {
        pushView('passkey-recovery-add-email');
        setShowAuthFlow(true);
    });
    return {
        addEmbeddedWalletRecoveryEmail,
        createOrRefreshAuthenticatorSession,
    };
};

const getEnabledEmbeddedWalletProviders = (projectSettings) => {
    var _a;
    const providers = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers) !== null && _a !== void 0 ? _a : [];
    const embeddedWalletProviders = [
        ProviderEnum.Turnkey,
        ProviderEnum.CoinbaseWaas,
        ProviderEnum.MagicLink,
        ProviderEnum.Blocto,
    ];
    return embeddedWalletProviders.filter((provider) => isProviderEnabled(providers, provider));
};

const isAllowedToLinkWallet = (projectSettings, verifiedCredentials, multiWallet) => {
    if (multiWallet)
        return true;
    if (!projectSettings || !(verifiedCredentials === null || verifiedCredentials === void 0 ? void 0 : verifiedCredentials.length))
        return false;
    // no embedded wallet providers are enabled and user doesn't have any wallet linked
    const canLinkOnSingleWallet = !getEnabledEmbeddedWalletProviders(projectSettings).length &&
        !verifiedCredentials.some((vc) => vc.walletProvider);
    return canLinkOnSingleWallet;
};

const useMfaModals = () => {
    var _a;
    const { setShowAuthFlow, projectSettings, setShowDynamicUserProfile } = useInternalDynamicContext();
    const { setDynamicWidgetView } = useWidgetContext();
    const { clearStackAndPush } = useViewContext();
    const isMfaEnabled = (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.security.mfa) === null || _a === void 0 ? void 0 : _a.enabled;
    const setShowMFAManage = useCallback((value) => {
        if (value) {
            if (!isMfaEnabled) {
                return;
            }
            setDynamicWidgetView('manage-mfa-no-footer');
        }
        setShowDynamicUserProfile(value);
    }, [isMfaEnabled, setShowDynamicUserProfile, setDynamicWidgetView]);
    const setShowMfaChooseType = useCallback((value) => {
        if (value) {
            if (!isMfaEnabled)
                return;
            clearStackAndPush('mfa-choose-device');
        }
        setShowAuthFlow(value, { emitCancelAuth: true });
    }, [isMfaEnabled, setShowAuthFlow, clearStackAndPush]);
    const setShowMfaQRCode = useCallback((value) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (value) {
            if (!isMfaEnabled)
                return;
            const user = getUser();
            // Already have MFA configured
            if (user === null || user === void 0 ? void 0 : user.mfaBackupCodeAcknowledgement) {
                setShowMFAManage(true);
                return;
            }
            clearStackAndPush('mfa-secure-device', { isInitialSetup: true });
        }
        setShowAuthFlow(value, { emitCancelAuth: true });
    }), [isMfaEnabled, setShowAuthFlow, clearStackAndPush, setShowMFAManage]);
    const setShowOTPVerification = useCallback((value) => {
        if (value) {
            if (!isMfaEnabled)
                return;
            clearStackAndPush('mfa-verification');
        }
        setShowAuthFlow(value, { emitCancelAuth: true });
    }, [isMfaEnabled, setShowAuthFlow, clearStackAndPush]);
    const setShowMfaViewBackupCodes = useCallback((value) => {
        if (value) {
            if (!isMfaEnabled)
                return;
            clearStackAndPush('mfa-display-backup-codes');
        }
        setShowAuthFlow(value, { emitCancelAuth: true });
    }, [isMfaEnabled, setShowAuthFlow, clearStackAndPush]);
    const setShowMfaEnterBackupCodes = useCallback((value) => {
        if (value) {
            if (!isMfaEnabled)
                return;
            clearStackAndPush('mfa-recovery');
        }
        setShowAuthFlow(value, { emitCancelAuth: true });
    }, [isMfaEnabled, setShowAuthFlow, clearStackAndPush]);
    return {
        setShowMFAManage,
        setShowMfaChooseType,
        setShowMfaEnterBackupCodes,
        setShowMfaQRCode,
        setShowMfaViewBackupCodes,
        setShowOTPVerification,
    };
};

/**
 * this hook wraps `setShowAuthFlow`. WalletConnect requires initialization
 * before we can connect a wallet. The goal here is that when a user clicks
 * on the "Log in or sign up" button, the SDK starts initializing WalletConnect
 * and will prime it for connection. This way, when the user clicks on the
 * "Connect" button in the WalletConnect modal, there is a uri ready to go
 * to immediately trigger the deep link on mobile
 */
const useDynamicModals = () => {
    const { projectSettings, user, multiWallet, setShowAuthFlow } = useInternalDynamicContext();
    const isLoggedIn = useIsLoggedIn();
    const { clearStackAndPush } = useViewContext();
    const canLink = isAllowedToLinkWallet(projectSettings, user === null || user === void 0 ? void 0 : user.verifiedCredentials, multiWallet);
    const { setShowMfaChooseType, setShowMfaEnterBackupCodes, setShowMfaQRCode, setShowMfaViewBackupCodes, setShowOTPVerification, setShowMFAManage, } = useMfaModals();
    const setSetShowLinkNewWalletModalWithInit = useCallback((value) => {
        if (value) {
            // Do not change state if the user is already signed in and multi-wallet is not enabled
            if (!isLoggedIn) {
                logger$1.warn('setShowLinkNewWalletModal was called while the user was not logged in. This results in a no-op. To log the user in, use setShowAuthFlow. For more information, see: https://docs.dynamic.xyz/react-sdk/hooks/usedynamiccontext');
                return;
            }
            if (!canLink) {
                logger$1.warn('setShowLinkNewWalletModal was called but the user is not allowed to link a wallet. This results in a no-op. Please double check that multi-wallet is enabled in the dashboard. For more information, see: https://docs.dynamic.xyz/branded-wallets/multi-wallet');
                return;
            }
            clearStackAndPush('multi-wallet-wallet-list');
        }
        setShowAuthFlow(value, {
            emitCancelAuth: true,
            ignoreIfIsEmbeddedWidget: true,
            initializeWalletConnect: true,
            performMultiWalletChecks: false,
        });
    }, [canLink, isLoggedIn, setShowAuthFlow, clearStackAndPush]);
    return {
        setShowLinkNewWalletModal: setSetShowLinkNewWalletModalWithInit,
        setShowMFAManage,
        setShowMfaChooseType,
        setShowMfaEnterBackupCodes,
        setShowMfaQRCode,
        setShowMfaViewBackupCodes,
        setShowOTPVerification,
    };
};

const DynamicWidgetDropdown = ({ zIndex, isShown, onClose, children, className, contentClassName, }) => (jsxRuntimeExports.jsx(ZoomTransition, { outDuration: 200, className: classNames('dynamic-widget-dropdown', className), isShown: isShown, children: jsxRuntimeExports.jsx("div", { "data-testid": 'DynamicWidgetDropdown', style: { zIndex }, className: classNames('dynamic-widget-dropdown__root', contentClassName), children: jsxRuntimeExports.jsx(PopperProvider, { children: children }) }) }));

const DynamicWidgetModal = ({ children, isShown, onClose, zIndex, className, transitionEvents = {}, }) => {
    usePreventPageScroll(Boolean(isShown));
    return (jsxRuntimeExports.jsx(Portal, Object.assign({ zIndex: zIndex, handleClose: () => onClose === null || onClose === void 0 ? void 0 : onClose(), isShown: isShown, withBackdrop: true }, transitionEvents, { children: jsxRuntimeExports.jsx("div", { className: classNames('dynamic-widget-modal', className), "data-testid": 'modal-card', children: jsxRuntimeExports.jsx(PopperProvider, { children: children }) }) })));
};

const mapDynamicWidgetVariantToComponent = {
    dropdown: DynamicWidgetDropdown,
    modal: DynamicWidgetModal,
};
const DynamicWidgetVariants = ({ zIndex, variant, children, isOpen, setIsOpen, transitionEvents }) => {
    const DynamicVariantComponent = mapDynamicWidgetVariantToComponent[variant || 'modal'];
    const { goToInitialDynamicWidgetView } = useWidgetContext();
    const handleClose = () => {
        setIsOpen(false);
        // Go to initial view after animation finishes
        setTimeout(() => {
            goToInitialDynamicWidgetView();
        }, 300);
    };
    return (jsxRuntimeExports.jsx(DynamicVariantComponent, { transitionEvents: transitionEvents, zIndex: zIndex, isShown: isOpen, onClose: handleClose, children: children }));
};

var _path$e;
var _excluded$e = ["title", "titleId"];
function _extends$e() { return _extends$e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$e.apply(null, arguments); }
function _objectWithoutProperties$e(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$e(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$e(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSwitchHorizontal = function SvgSwitchHorizontal(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$e(_ref, _excluded$e);
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.256 5.244a.833.833 0 0 1 0 1.179l-3.333 3.333a.833.833 0 0 1-1.179-1.179l1.91-1.91H6.668a.833.833 0 0 1 0-1.667h7.988l-1.91-1.91a.833.833 0 1 1 1.178-1.18l3.333 3.334Zm-11.91 8.09h7.987a.833.833 0 1 1 0 1.666H5.345l1.91 1.91a.833.833 0 1 1-1.178 1.18l-3.333-3.334a.833.833 0 0 1 0-1.179l3.333-3.333a.833.833 0 1 1 1.179 1.179l-1.91 1.91Z",
    fill: "currentColor"
  })));
};

var _path$d;
var _excluded$d = ["title", "titleId"];
function _extends$d() { return _extends$d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$d.apply(null, arguments); }
function _objectWithoutProperties$d(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$d(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$d(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgUnlink = function SvgUnlink(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$d(_ref, _excluded$d);
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.935 4.066a2.5 2.5 0 0 0-3.536 0l-.916.916a.833.833 0 0 1-1.179-1.179l.917-.916a4.167 4.167 0 0 1 5.892 5.893l-1.81 1.81-1.178-1.18 1.81-1.809a2.5 2.5 0 0 0 0-3.535Zm-10.06 6.523L4.698 9.411l-1.81 1.81a4.167 4.167 0 1 0 5.893 5.892l.918-.918a.833.833 0 0 0-1.179-1.178l-.918.917A2.5 2.5 0 0 1 4.066 12.4l1.81-1.81Zm-.488-6.38A.833.833 0 1 0 4.21 5.387l10.017 10.017a.833.833 0 1 0 1.179-1.178L5.387 4.209Z",
    fill: "currentColor"
  })));
};

const Wallet = ({ wallet, ens, clickable }) => {
    var _a;
    const { connector, address } = wallet;
    const switchWallet = useSwitchWallet();
    const { setSelectedWalletWithAction, projectSettings, authMode } = useInternalDynamicContext();
    const handleSwitchWallet = useCallback(() => {
        switchWallet(wallet.id);
    }, [switchWallet, wallet.id]);
    const iconSize = 20;
    const options = [
        {
            Icon: jsxRuntimeExports.jsx(SvgSwitchHorizontal, {}),
            callback: handleSwitchWallet,
            hide: !((_a = wallet.connector) === null || _a === void 0 ? void 0 : _a.isAvailable),
            text: 'Select wallet',
        },
    ];
    if (ens === null || ens === void 0 ? void 0 : ens.name) {
        options.push({
            Icon: jsxRuntimeExports.jsx(SvgCopy, {}),
            callback: () => copyToClipboard(ens.name),
            text: 'Copy ENS',
        });
    }
    options.push({
        Icon: jsxRuntimeExports.jsx(SvgCopy, {}),
        callback: () => copyToClipboard(address || ''),
        text: 'Copy address',
    });
    if (!isEmbeddedConnector(connector) &&
        !(projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.multiWalletUnlinkDisabled)) {
        options.push({
            Icon: jsxRuntimeExports.jsx(SvgUnlink, {}),
            callback: () => setSelectedWalletWithAction({ action: 'unlink', wallet }),
            text: `${authMode === 'connect-only' ? 'Disconnect' : 'Unlink'} from my account`,
        });
    }
    const exportKeysOption = getExportKeysOption(connector, projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers);
    if (exportKeysOption) {
        options.push({
            Icon: jsxRuntimeExports.jsx(SvgKey, {}),
            callback: exportKeysOption,
            text: 'Export private keys',
        });
    }
    return (jsxRuntimeExports.jsxs("div", { className: 'wallet__container', "data-testid": 'wallet', children: [jsxRuntimeExports.jsxs("div", { className: classNames('wallet__row', {
                    'wallet__row--clickable': clickable,
                }), onClick: clickable ? handleSwitchWallet : undefined, children: [jsxRuntimeExports.jsx("div", { className: 'wallet__icon-container', children: jsxRuntimeExports.jsx(AuthProviderIcon, { iconSize: iconSize, wallet: wallet, showNetworkIcon: true }) }), (ens === null || ens === void 0 ? void 0 : ens.name) ? (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Typography, { className: 'wallet__ens-name', variant: 'body_small', color: 'primary', truncate: true, children: ens === null || ens === void 0 ? void 0 : ens.name }), jsxRuntimeExports.jsx("div", { className: 'wallet__row__separator' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_mini', color: 'secondary', children: shortenWalletAddress(address, 3, 3) })] })) : (jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'primary', children: shortenWalletAddress(address, 4, 4) }))] }), jsxRuntimeExports.jsx("div", { className: 'wallet__row__separator wallet__row__menu__separator ' }), jsxRuntimeExports.jsx(DotsMenu, { "data-testid": 'dots-menu', options: options, buttonClassName: 'wallet__menu', direction: 'left' })] }));
};

const VerifiedFieldTooltip = (content) => (jsxRuntimeExports.jsx(Typography, { variant: 'numbers_medium', color: 'tooltip', children: content }));
const VerifiedUserFieldIcon = ({ className, overwriteTooltipProps, tooltipContent, copykey, }) => (jsxRuntimeExports.jsx(Tooltip, Object.assign({ content: VerifiedFieldTooltip(tooltipContent) }, overwriteTooltipProps, { copykey: copykey, children: jsxRuntimeExports.jsx(SvgCheckCircle, { className: classNames('dynamic-verified-icon', className) }) })));

const UserProfileField = ({ name, label, value, copykey, autoComplete, }) => {
    var _a, _b;
    const { user } = useInternalDynamicContext();
    const { t } = useTranslation();
    const isEmpty = value === '';
    const isPhoneNumber = name === 'phoneNumber' && typeof value === 'string';
    const isVerifiedEmail = name === 'email' &&
        (user === null || user === void 0 ? void 0 : user.email) &&
        ((_a = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _a === void 0 ? void 0 : _a.some((cred) => cred.email === value));
    const isVerifiedPhoneNumber = isPhoneNumber &&
        (user === null || user === void 0 ? void 0 : user.phoneNumber) &&
        ((_b = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _b === void 0 ? void 0 : _b.some((cred) => `+${cred.phoneCountryCode}${cred.phoneNumber}` === value));
    const toolTipContent = isVerifiedEmail
        ? t('dyn_user_profile.tooltips.verified_email')
        : t('dyn_user_profile.tooltips.verified_phone');
    return (jsxRuntimeExports.jsxs("div", { className: 'user-profile-field', children: [label && (jsxRuntimeExports.jsx(Typography, { as: 'h6', color: 'secondary', weight: 'regular', variant: 'body_small', copykey: copykey, children: label })), jsxRuntimeExports.jsxs("div", { className: 'user-profile-field__value', children: [jsxRuntimeExports.jsx(Typography, { color: isEmpty ? 'tertiary' : 'primary', as: 'p', weight: 'regular', variant: 'body_normal', children: isPhoneNumber ? formatPhone(value) : value }), (isVerifiedEmail || isVerifiedPhoneNumber) && (jsxRuntimeExports.jsx(VerifiedUserFieldIcon, { className: 'user-profile-field__verify-icon', overwriteTooltipProps: { as: 'div' }, tooltipContent: toolTipContent, copykey: 'dyn_user_profile.tooltips' }))] })] }));
};

const UserProfileSection = ({ title, children, action, }) => (jsxRuntimeExports.jsxs("div", { className: 'user-profile-section', children: [jsxRuntimeExports.jsx("div", { className: 'user-profile-section__header', children: title && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Typography, { color: 'secondary', weight: 'regular', variant: 'body_normal', className: 'user-profile-section__title', children: title }), action && (jsxRuntimeExports.jsx("div", { className: 'user-profile-section__action', children: action }))] })) }), children] }));

const ConnectedAccountAvatar = ({ provider, avatarUrl, iconThemeVariant, }) => (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx("div", { className: 'user-profile-social-account__connected-avatar', children: jsxRuntimeExports.jsx(Image$1, { className: 'user-profile-social-account__image', src: avatarUrl, alt: 'User avatar', dataTestId: 'user-avatar', fallback: jsxRuntimeExports.jsx(UserProfileIcon, {}) }) }), jsxRuntimeExports.jsx("div", { className: 'user-profile-social-account__connected-provider-icon', children: jsxRuntimeExports.jsx(SocialIcon, { name: provider, variant: iconThemeVariant }) })] }));

const UserProfileSocialAccount = ({ provider, }) => {
    var _a;
    const { user, primaryWallet } = useInternalDynamicContext();
    const { linkSocialAccount, unlinkSocialAccount, isProcessing, isLinked, getLinkedAccountInformation, } = useSocialAccounts();
    const isProviderLinked = isLinked(provider);
    const connectedAccountInfo = getLinkedAccountInformation(provider);
    const iconThemeVariant = useIconThemeVariant();
    const isActiveCredential = !primaryWallet &&
        connectedAccountInfo &&
        (connectedAccountInfo === null || connectedAccountInfo === void 0 ? void 0 : connectedAccountInfo.id) === (user === null || user === void 0 ? void 0 : user.lastVerifiedCredentialId);
    const renderButton = () => (jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'user-profile-social-account__button', buttonVariant: 'secondary', buttonPadding: 'none', onClick: () => isProviderLinked
            ? unlinkSocialAccount(provider)
            : linkSocialAccount(provider), loading: isProcessing, dataTestId: `social-account-${isProviderLinked ? 'disconnect' : 'connect'}-button`, typographyProps: {
            color: 'secondary',
            variant: 'button_tertiary',
        }, startSlot: 
        // eslint-disable-next-line react/jsx-wrap-multilines
        jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', size: 'small', children: isProviderLinked ? jsxRuntimeExports.jsx(SvgUnlink, {}) : jsxRuntimeExports.jsx(SvgAdd, {}) }), children: isProviderLinked ? null : 'Connect' }));
    return (jsxRuntimeExports.jsxs("div", { className: 'user-profile-social-account', "data-testid": `social-account-${provider}`, children: [jsxRuntimeExports.jsx("div", { className: 'user-profile-social-account__icon', children: isProviderLinked ? (jsxRuntimeExports.jsx(ConnectedAccountAvatar, { provider: provider, avatarUrl: connectedAccountInfo === null || connectedAccountInfo === void 0 ? void 0 : connectedAccountInfo.avatar })) : (jsxRuntimeExports.jsx(SocialIcon, { name: provider, variant: iconThemeVariant })) }), jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'body_normal', color: 'primary', truncate: true, className: 'user-profile-social-account__label', children: (_a = connectedAccountInfo === null || connectedAccountInfo === void 0 ? void 0 : connectedAccountInfo.publicIdentifier) !== null && _a !== void 0 ? _a : providerLabel(getSocialSignInProviderForProviderEnum(provider)) }), !isActiveCredential ? renderButton() : null] }));
};

const EditProfileButton = () => {
    var _a, _b;
    const { t } = useTranslation();
    const { projectSettings } = useInternalDynamicContext();
    const { setDynamicWidgetView } = useWidgetContext();
    // Allow to navigate to edit profile view when there are fields what can be edited
    const editableUserFields = getEditableUserProfileFields([
        ...((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.kyc) !== null && _a !== void 0 ? _a : []),
        ...((_b = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.customFields) !== null && _b !== void 0 ? _b : []),
    ]);
    if (!(editableUserFields === null || editableUserFields === void 0 ? void 0 : editableUserFields.length))
        return null;
    return (jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'dynamic-widget-footer__button', buttonVariant: 'tertiary', buttonPadding: 'none', typographyProps: {
            color: 'secondary',
            variant: 'button_tertiary',
        }, copykey: 'dyn_user_profile.edit_profile_button', onClick: () => setDynamicWidgetView('edit-profile'), startSlot: jsxRuntimeExports.jsx(SvgPencil, {}), children: t('dyn_user_profile.edit_profile_button') }));
};

const UserProfile = ({ rootClassName }) => {
    var _a;
    const { projectSettings, user, setSelectedWalletConnectorKey, multiWallet, primaryWallet, } = useInternalDynamicContext();
    const { error } = useErrorContext();
    const { setShowLinkNewWalletModal } = useDynamicModals();
    const { userWallets } = useInternalUserWallets();
    const { t } = useTranslation();
    const { fieldsConfig } = useFields();
    const containerRef = useRef(null);
    useEffect(() => {
        if (error && containerRef.current) {
            containerRef.current.scrollTop = 0;
        }
    }, [error]);
    const allUserFields = getUserProfileFields({
        customFields: projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.customFields,
        projectSettingsKyc: projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.kyc,
        user,
    });
    const ensDomain = useMemo(() => { var _a; return (_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.nameService) === null || _a === void 0 ? void 0 : _a.evm.domain; }, [projectSettings]);
    const providers = isSocialKycEnabled(projectSettings)
        ? getEnabledOAuthProviders(projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.providers)
        : [];
    const canLink = isAllowedToLinkWallet(projectSettings, user === null || user === void 0 ? void 0 : user.verifiedCredentials, multiWallet);
    const addNewWallet = () => {
        setShowLinkNewWalletModal(true);
        setSelectedWalletConnectorKey(null);
    };
    const mapFieldKeyToValue = (fieldKey) => user === null || user === void 0 ? void 0 : user[fieldKey];
    if (!user)
        return null;
    // if it's multiwallet, the wallet should appear in the wallets tab
    // if there's a primary wallet, it will be displayed in the header
    const wallet = !multiWallet && !primaryWallet && userWallets[0];
    return (jsxRuntimeExports.jsxs("div", { "data-testid": 'userProfile', className: classNames('user-profile', rootClassName), ref: containerRef, children: [error && jsxRuntimeExports.jsx(ErrorContainer, { children: error }), wallet && (jsxRuntimeExports.jsx(UserProfileSection, { title: t('dyn_user_profile.my_wallet.title'), children: jsxRuntimeExports.jsx(Wallet, { ens: (_a = getWalletVerifiedCredential(wallet.address, user === null || user === void 0 ? void 0 : user.verifiedCredentials, wallet.chain)) === null || _a === void 0 ? void 0 : _a.nameService, wallet: wallet }, wallet.id) })), (allUserFields === null || allUserFields === void 0 ? void 0 : allUserFields.length) > 0 && (jsxRuntimeExports.jsx(UserProfileSection, { title: t('dyn_user_profile.my_information.title'), action: jsxRuntimeExports.jsx(EditProfileButton, {}), children: jsxRuntimeExports.jsx("div", { className: 'user-profile__fields', children: allUserFields.map(({ name, validationType, type, label }) => {
                        var _a, _b;
                        if (type === KycFieldType.Custom) {
                            const value = (_b = (_a = user.metadata) === null || _a === void 0 ? void 0 : _a[name]) !== null && _b !== void 0 ? _b : '';
                            let fieldValue = value;
                            if (validationType === CustomFieldType.Checkbox)
                                fieldValue = value.length > 0 ? 'Checked' : 'Unchecked';
                            // Use name instead of label here because the back-end doesn't set label
                            let fieldLabel = name;
                            if (name === NAME_SERVICE_FIELD_NAME) {
                                // Field should not render if ENS domain is not set
                                if (!ensDomain) {
                                    return null;
                                }
                                fieldLabel = t('dyn_subdomain_field.label');
                                if (fieldValue !== '') {
                                    fieldValue = `${fieldValue}.${ensDomain}`;
                                }
                                else {
                                    fieldValue = '';
                                }
                            }
                            return (jsxRuntimeExports.jsx(UserProfileField, { name: name, label: fieldLabel, value: fieldValue }, name));
                        }
                        const { label: defaultLabel, key } = getValueByKey(fieldsConfig, name);
                        label !== null && label !== void 0 ? label : (label = defaultLabel);
                        const value = mapFieldKeyToValue(name);
                        return (jsxRuntimeExports.jsx(UserProfileField, { copykey: key, name: name, label: label, value: value }, name));
                    }) }) })), canLink && !multiWallet && (jsxRuntimeExports.jsx(UserProfileSection, { title: t('dyn_user_profile.wallets.title'), children: jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'link-wallet-button', onClick: addNewWallet, startSlot: jsxRuntimeExports.jsx(SvgAdd, {}), showInternalLoading: false, children: jsxRuntimeExports.jsx(Typography, { color: 'primary', weight: 'medium', copykey: 'dyn_user_profile.wallets.link_wallet_button', children: t('dyn_user_profile.wallets.link_wallet_button') }) }) })), (providers === null || providers === void 0 ? void 0 : providers.length) > 0 && (jsxRuntimeExports.jsx(UserProfileSection, { title: t('dyn_user_profile.social_accounts.title'), children: jsxRuntimeExports.jsx("div", { className: 'user-profile__social-accounts', children: providers.map(({ provider }) => (jsxRuntimeExports.jsx(UserProfileSocialAccount, { provider: provider }, provider))) }) }))] }));
};

const LogoutButton = ({ buttonClassName = '', isTextButton = false, }) => {
    const [loading, setLoading] = useState(false);
    const { handleLogOut } = useInternalDynamicContext();
    const onLogOutClick = () => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            yield handleLogOut();
        }
        catch (e) {
            logger$1.error(e);
        }
        finally {
            setLoading(false);
        }
    });
    return (jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: buttonClassName, buttonVariant: 'tertiary', buttonPadding: isTextButton ? 'none' : 'medium', loading: loading, disabled: loading, onClick: onLogOutClick, typographyProps: isTextButton
            ? { color: 'secondary', variant: 'button_tertiary' }
            : { color: 'primary', variant: 'button_secondary' }, dataTestId: 'logout-button', startSlot: isTextButton ? jsxRuntimeExports.jsx(SvgLogout, {}) : undefined, expanded: !isTextButton, type: 'button', children: "Log out" }));
};

var _path$c;
var _excluded$c = ["title", "titleId"];
function _extends$c() { return _extends$c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$c.apply(null, arguments); }
function _objectWithoutProperties$c(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$c(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$c(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgProfileOutline = function SvgProfileOutline(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$c(_ref, _excluded$c);
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4a8 8 0 0 0-6.598 12.526A14.943 14.943 0 0 1 12.5 15c2.366 0 4.606.548 6.598 1.526A8 8 0 0 0 12.5 4Zm7.654 14.436A9.96 9.96 0 0 0 22.5 12c0-5.523-4.477-10-10-10s-10 4.477-10 10a9.96 9.96 0 0 0 2.37 6.464A9.978 9.978 0 0 0 12.5 22a9.978 9.978 0 0 0 7.654-3.564ZM17.7 18.08A12.954 12.954 0 0 0 12.5 17c-1.85 0-3.607.386-5.199 1.08A7.968 7.968 0 0 0 12.5 20c1.985 0 3.8-.723 5.199-1.92ZM12.5 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "currentColor"
  })));
};

var _path$b;
var _excluded$b = ["title", "titleId"];
function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$b.apply(null, arguments); }
function _objectWithoutProperties$b(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$b(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$b(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgSettingsOutline = function SvgSettingsOutline(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$b(_ref, _excluded$b);
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.853 4.081c.674-2.775 4.62-2.775 5.294 0a.724.724 0 0 0 1.08.448c2.44-1.486 5.23 1.305 3.744 3.744a.724.724 0 0 0 .448 1.08c2.775.674 2.775 4.62 0 5.294a.724.724 0 0 0-.448 1.08c1.486 2.44-1.305 5.23-3.744 3.744a.724.724 0 0 0-1.08.448c-.674 2.775-4.62 2.775-5.294 0a.724.724 0 0 0-1.08-.448c-2.44 1.486-5.23-1.305-3.744-3.744a.724.724 0 0 0-.448-1.08c-2.775-.674-2.775-4.62 0-5.294a.724.724 0 0 0 .448-1.08c-1.486-2.44 1.305-5.23 3.744-3.744a.724.724 0 0 0 1.08-.448Zm3.35.472c-.178-.737-1.227-.737-1.407 0a2.724 2.724 0 0 1-4.064 1.684c-.648-.395-1.39.347-.995.995.96 1.575.109 3.63-1.684 4.064-.737.18-.737 1.229 0 1.408a2.724 2.724 0 0 1 1.684 4.064c-.395.648.347 1.39.995.995a2.724 2.724 0 0 1 4.064 1.684c.18.737 1.229.737 1.408 0a2.724 2.724 0 0 1 4.064-1.684c.648.395 1.39-.347.995-.995a2.724 2.724 0 0 1 1.684-4.064c.737-.18.737-1.229 0-1.408a2.724 2.724 0 0 1-1.684-4.064c.395-.648-.347-1.39-.995-.995-1.575.96-3.63.109-4.064-1.684ZM12.5 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0Z",
    fill: "currentColor"
  })));
};

var _path$a;
var _excluded$a = ["title", "titleId"];
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$a.apply(null, arguments); }
function _objectWithoutProperties$a(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$a(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$a(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgWalletOutlineV2 = function SvgWalletOutlineV2(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$a(_ref, _excluded$a);
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 2a2 2 0 0 1 2 2h-12a3.99 3.99 0 0 0-2.935 1.283A4.005 4.005 0 0 1 6.5 2h9ZM6.5 6A4 4 0 0 0 2.5 10v8a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-8a4 4 0 0 0-4-4H6.5ZM20.5 10a2 2 0 0 0-2-2h-12a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8Z",
    fill: "currentColor"
  })));
};

const BottomNavBar = ({ value, onChange, options }) => {
    const isActive = (_value) => _value === value;
    return (jsxRuntimeExports.jsx("div", { className: 'footer-options-switcher__container', "data-testid": 'OptionsSwitcher', children: options.map((option) => (jsxRuntimeExports.jsxs("div", { className: classNames('footer-options-switcher__tab', {
                'footer-options-switcher__tab--active': isActive(option.value),
            }), onClick: () => onChange(option.value), children: [option.icon, jsxRuntimeExports.jsx(Typography, { variant: 'body_small', className: 'footer-options-switcher__label', children: option.label })] }, option.value))) }));
};

const useCloseMultiWalletPrompt = () => {
    const { setMultiWalletWidgetState, setSelectedWalletWithAction, setShowQrcodeModal, setDesktopUri, setSelectedWalletConnectorKey, } = useInternalDynamicContext();
    return (e) => {
        e.stopPropagation();
        setSelectedWalletWithAction(null);
        setMultiWalletWidgetState('idle');
        setShowQrcodeModal(false);
        setDesktopUri('');
        setSelectedWalletConnectorKey(null);
    };
};

const DetectedNewWalletContent = () => {
    const { t } = useTranslation();
    const { setMultiWalletWidgetState, primaryWallet } = useInternalDynamicContext();
    const handleClick = () => {
        setMultiWalletWidgetState('awaiting_signature', undefined, 'linking_new_wallet');
    };
    const walletConnector = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector;
    return (jsxRuntimeExports.jsx(DefaultPromptLayout, { dataTestId: 'detected-new-wallet-modal', icon: 
        // eslint-disable-next-line react/jsx-wrap-multilines
        jsxRuntimeExports.jsx(WalletIcon, { icon: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.metadata.icon, walletKey: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.key }), title: t('dyn_detected_new_wallet.title'), children: jsxRuntimeExports.jsxs("div", { className: 'detected-new-wallet-modal__top-section', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', weight: 'regular', "data-testid": 'content', children: t('dyn_detected_new_wallet.description', {
                        walletName: walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.name,
                    }) }), walletConnector &&
                    isHardwareWalletConnector(walletConnector) &&
                    walletConnector.canConnectWithHardwareWallet() && (jsxRuntimeExports.jsx(HardwareWalletToggle, { connectors: [walletConnector], copykey: 'dyn_select_chain.using_hardware_wallet_toggle_label', label: t('dyn_select_chain.using_hardware_wallet_toggle_label') })), jsxRuntimeExports.jsx(TypographyButton, { expanded: true, onClick: handleClick, typographyProps: {
                        variant: 'button_secondary',
                    }, children: t('dyn_detected_new_wallet.confirm_button') })] }) }));
};
const DetectedNewWalletWidgetPortal = () => (jsxRuntimeExports.jsx(WidgetPortal, { onClose: useCloseMultiWalletPrompt(), children: jsxRuntimeExports.jsx(DetectedNewWalletContent, {}) }));

const useConnectedAccountWallet = (connector, secondaryWallets) => usePromise(() => {
    if (!connector) {
        return;
    }
    return connector
        .getConnectedAccounts()
        .then((connectedAccounts) => secondaryWallets.find((secondaryWallet) => {
        var _a;
        return secondaryWallet.address.toLowerCase() ===
            ((_a = connectedAccounts[0]) === null || _a === void 0 ? void 0 : _a.toLowerCase());
    }));
}, { deps: [connector, secondaryWallets] });

const SwitchAccountView = ({ selectedWalletToSwitchTo }) => (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', color: 'secondary', weight: 'regular', "data-testid": 'content', children: ["Switch to wallet", ' ', jsxRuntimeExports.jsx(Typography, { as: 'span', weight: 'medium', color: 'primary', children: shortenWalletAddress(selectedWalletToSwitchTo === null || selectedWalletToSwitchTo === void 0 ? void 0 : selectedWalletToSwitchTo.address, 3, 3) }), ' ', "in ", selectedWalletToSwitchTo === null || selectedWalletToSwitchTo === void 0 ? void 0 : selectedWalletToSwitchTo.connector.name, " to make it active."] }), jsxRuntimeExports.jsx(Divider, { fullWidth: true, text: 'Or' }), jsxRuntimeExports.jsx(LogoutButton, { isTextButton: false, buttonClassName: 'primary-not-connected__log-out-button' })] }));

const SwitchOrUseActiveAccountView = ({ connectedWallet, selectedWalletToSwitchTo, }) => {
    const { setSelectedWalletWithAction, setSelectedWalletConnectorKey, setPrimaryWallet, } = useInternalDynamicContext();
    const onUseActiveWalletClick = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!connectedWallet) {
            return;
        }
        if (connectedWallet.connector.connectedChain === 'FLOW') {
            (_b = (_a = connectedWallet.connector).endSession) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
        setSelectedWalletWithAction({ action: 'select', wallet: connectedWallet });
        setPrimaryWallet(connectedWallet === null || connectedWallet === void 0 ? void 0 : connectedWallet.id);
        setSelectedWalletConnectorKey(connectedWallet === null || connectedWallet === void 0 ? void 0 : connectedWallet.connector.key);
    }), [
        connectedWallet,
        setSelectedWalletWithAction,
        setPrimaryWallet,
        setSelectedWalletConnectorKey,
    ]);
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', color: 'secondary', weight: 'regular', "data-testid": 'content', children: ["Wallet", ' ', jsxRuntimeExports.jsx(Typography, { as: 'span', weight: 'medium', color: 'primary', children: shortenWalletAddress(selectedWalletToSwitchTo === null || selectedWalletToSwitchTo === void 0 ? void 0 : selectedWalletToSwitchTo.address, 3, 3) }), ' ', "is not active in ", selectedWalletToSwitchTo === null || selectedWalletToSwitchTo === void 0 ? void 0 : selectedWalletToSwitchTo.connector.name, ". To make active, open your ", selectedWalletToSwitchTo === null || selectedWalletToSwitchTo === void 0 ? void 0 : selectedWalletToSwitchTo.connector.name, " wallet and switch to this account."] }), jsxRuntimeExports.jsx(Divider, { fullWidth: true, text: 'Or' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', children: "Use your active wallet" }), jsxRuntimeExports.jsxs(TypographyButton, { buttonClassName: 'default-prompt-modal__button', expanded: true, type: 'button', buttonPadding: 'medium', typographyProps: { variant: 'button_secondary' }, onClick: onUseActiveWalletClick, dataTestId: 'use-active-wallet-button', children: ["Select", ' ', jsxRuntimeExports.jsx(Icon, { size: 'xsmall', children: jsxRuntimeExports.jsx(WalletIcon, { icon: selectedWalletToSwitchTo === null || selectedWalletToSwitchTo === void 0 ? void 0 : selectedWalletToSwitchTo.connector.metadata.icon, walletKey: selectedWalletToSwitchTo === null || selectedWalletToSwitchTo === void 0 ? void 0 : selectedWalletToSwitchTo.connector.key }) }), ' ', shortenWalletAddress(connectedWallet === null || connectedWallet === void 0 ? void 0 : connectedWallet.address, 3, 3)] })] }));
};

const PendingAccountSwitchContent = () => {
    var _a, _b, _c, _d;
    const { selectedWalletWithAction, primaryWallet, secondaryWallets } = useInternalDynamicContext();
    const selectedConnector = (_a = selectedWalletWithAction === null || selectedWalletWithAction === void 0 ? void 0 : selectedWalletWithAction.wallet) === null || _a === void 0 ? void 0 : _a.connector;
    const isSameWallet = (selectedConnector === null || selectedConnector === void 0 ? void 0 : selectedConnector.key) === (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector.key);
    const { data: connectedWallet } = useConnectedAccountWallet((_b = selectedWalletWithAction === null || selectedWalletWithAction === void 0 ? void 0 : selectedWalletWithAction.wallet) === null || _b === void 0 ? void 0 : _b.connector, secondaryWallets);
    const selectedWalletToSwitchTo = (_d = (_c = selectedWalletWithAction === null || selectedWalletWithAction === void 0 ? void 0 : selectedWalletWithAction.wallet) !== null && _c !== void 0 ? _c : primaryWallet) !== null && _d !== void 0 ? _d : undefined;
    return (jsxRuntimeExports.jsx(DefaultPromptLayout, { dataTestId: 'pending-account-switch', icon: jsxRuntimeExports.jsx(WalletIcon, { icon: selectedConnector === null || selectedConnector === void 0 ? void 0 : selectedConnector.metadata.icon, walletKey: selectedConnector === null || selectedConnector === void 0 ? void 0 : selectedConnector.key }), title: `Switch wallet in ${selectedWalletToSwitchTo === null || selectedWalletToSwitchTo === void 0 ? void 0 : selectedWalletToSwitchTo.connector.name}`, children: isSameWallet || !connectedWallet ? (jsxRuntimeExports.jsx(SwitchAccountView, { selectedWalletToSwitchTo: selectedWalletToSwitchTo })) : (jsxRuntimeExports.jsx(SwitchOrUseActiveAccountView, { connectedWallet: connectedWallet, selectedWalletToSwitchTo: selectedWalletToSwitchTo })) }));
};
const PendingAccountSwitchWidgetPortal = () => (jsxRuntimeExports.jsx(WidgetPortal, { children: jsxRuntimeExports.jsx(PendingAccountSwitchContent, {}) }));

const PendingAccountSwitchToLinkContent = () => {
    const { selectedWalletConnector } = useInternalDynamicContext();
    return (jsxRuntimeExports.jsx(DefaultPromptLayout, { dataTestId: 'pending-account-switch', icon: jsxRuntimeExports.jsx(WalletIcon, { icon: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.metadata.icon, walletKey: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.key }), title: `Wallet is already linked, switch wallet in ${selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.name}`, children: jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', color: 'secondary', weight: 'regular', "data-testid": 'content', children: ["To link a new wallet, open", ' ', jsxRuntimeExports.jsx(Typography, { as: 'span', weight: 'medium', color: 'primary', children: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.name }), ' ', "and switch to the account you want to link."] }) }));
};
const PendingAccountSwitchToLinkWidgetPortal = () => (jsxRuntimeExports.jsx(WidgetPortal, { onClose: useCloseMultiWalletPrompt(), children: jsxRuntimeExports.jsx(PendingAccountSwitchToLinkContent, {}) }));

const UnlinkWalletPopUpContent = ({ onClickCancel, }) => {
    var _a;
    const { handleUnlinkWallet, setSelectedWalletWithAction, authMode, selectedWalletWithAction, } = useInternalDynamicContext();
    const { t } = useTranslation();
    const { loading, setLoading } = useLoadingContext();
    const walletId = (_a = selectedWalletWithAction === null || selectedWalletWithAction === void 0 ? void 0 : selectedWalletWithAction.wallet) === null || _a === void 0 ? void 0 : _a.id;
    if (!walletId) {
        throw new Error('Wallet id is not defined');
    }
    const onConfirmClick = () => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            setLoading(true);
            yield handleUnlinkWallet(walletId);
            setSelectedWalletWithAction(null);
        }
        catch (error) {
            logger$1.error(error);
        }
        finally {
            setLoading(false);
        }
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'unlink-wallet-popup__container', children: [jsxRuntimeExports.jsx(Typography, { color: 'primary', className: 'unlink-wallet-popup__title', variant: 'body_normal', as: 'h6', children: authMode === 'connect-only'
                    ? t('dyn_unlink_wallet_pop_up.disconnect_title')
                    : t('dyn_unlink_wallet_pop_up.unlink_title') }), jsxRuntimeExports.jsx(Typography, { className: 'unlink-wallet-popup__label', variant: 'body_small', color: 'secondary', children: authMode === 'connect-only'
                    ? t('dyn_unlink_wallet_pop_up.disconnect_description')
                    : t('dyn_unlink_wallet_pop_up.unlink_description') }), jsxRuntimeExports.jsx(TypographyButton, { buttonPadding: 'small', onClick: onConfirmClick, disabled: loading, buttonClassName: 'unlink-wallet-popup__button unlink-wallet-popup__button--shadow', buttonVariant: 'primary', expanded: true, typographyProps: {
                    variant: 'button_secondary',
                    weight: 'medium',
                }, dataTestId: 'unlink-wallet-popup-yes-button', children: authMode === 'connect-only'
                    ? t('dyn_unlink_wallet_pop_up.disconnect_button')
                    : t('dyn_unlink_wallet_pop_up.unlink_button') }), jsxRuntimeExports.jsx(TypographyButton, { expanded: true, buttonPadding: 'small', onClick: onClickCancel, buttonVariant: 'secondary', buttonClassName: 'unlink-wallet-popup__button', typographyProps: {
                    variant: 'button_secondary',
                    weight: 'medium',
                }, children: t('dyn_unlink_wallet_pop_up.cancel_button') })] }));
};
const UnlinkWalletPopUpWidgetPortal = () => (jsxRuntimeExports.jsx(WidgetPortal, { onClose: useCloseMultiWalletPrompt(), children: jsxRuntimeExports.jsx(UnlinkWalletPopUpContent, { onClickCancel: useCloseMultiWalletPrompt() }) }));

const NoQrNotInstalledModalView = () => {
    const { selectedWalletConnector } = useInternalDynamicContext();
    const downloadLinks = useWalletDownloadLinks(selectedWalletConnector);
    if (!selectedWalletConnector) {
        return null;
    }
    const { name, icon } = selectedWalletConnector.metadata;
    return (jsxRuntimeExports.jsxs("div", { className: 'no-qr-code-not-installed-modal-view', "data-testid": 'no-qr-code-not-installed', children: [jsxRuntimeExports.jsx(WalletIcon, { icon: icon, walletKey: selectedWalletConnector.key, style: { height: pixelToRem(64), width: pixelToRem(64) } }), jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', color: 'primary', children: ["We can\u2019t detect ", name, " extension"] }), downloadLinks.length > 0 && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', children: "Select from your preferred options below:" }), jsxRuntimeExports.jsx("div", { className: 'no-qr-code-not-installed-modal-view__links-section', children: downloadLinks.map(({ key, name, link, Icon }) => (jsxRuntimeExports.jsx(WalletHelpLink, { name: name, link: link, Icon: Icon }, key))) })] })), jsxRuntimeExports.jsx(Typography, { variant: 'body_mini', color: 'secondary', children: "Refresh the page once installed" })] }));
};

const PendingConnectionContent = () => {
    var _a;
    const { selectedWalletConnector, user, selectedWalletWithAction } = useInternalDynamicContext();
    let title;
    let description;
    if (selectedWalletWithAction &&
        isSocialWalletConnector(selectedWalletWithAction.wallet.connector)) {
        const account = getReferencedAccount(user, selectedWalletWithAction.wallet.id);
        title = `Reconnecting ${capitalize$2((_a = account === null || account === void 0 ? void 0 : account.oauthProvider) !== null && _a !== void 0 ? _a : '')}`;
    }
    else {
        title = `Connect ${selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.name} wallet`;
        description = (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: ["Connect your", ' ', jsxRuntimeExports.jsx(Typography, { as: 'span', weight: 'medium', color: 'primary', children: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.name }), ' ', "wallet to make active."] }));
    }
    return (jsxRuntimeExports.jsx(DefaultPromptLayout, { dataTestId: 'pending-connection-modal', icon: jsxRuntimeExports.jsx(AuthProviderIcon // eslint-disable-line
        , { wallet: selectedWalletWithAction === null || selectedWalletWithAction === void 0 ? void 0 : selectedWalletWithAction.wallet }), title: title, children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', weight: 'regular', "data-testid": 'content', children: description }) }));
};
const PendingConnectionWidgetPortal = () => (jsxRuntimeExports.jsx(WidgetPortal, { onClose: useCloseMultiWalletPrompt(), children: jsxRuntimeExports.jsx(PendingConnectionContent, {}) }));

const EmailConnectorPendingSignModalContent = ({ emailWalletConnector }) => (jsxRuntimeExports.jsxs("div", { className: 'email-connector-pending-sign-modal-content', children: [jsxRuntimeExports.jsx(IconWithSpinner, { Icon: SignInWithEmailIcon, iconSize: 80, isSpinning: true }), jsxRuntimeExports.jsxs("div", { className: 'email-connector-pending-sign-modal-content__body', children: [jsxRuntimeExports.jsx(Typography, { weight: 'medium', variant: 'title', color: 'primary', className: 'email-connector-pending-sign-modal-content__title', children: "Confirm your email" }), jsxRuntimeExports.jsxs(Typography, { weight: 'regular', variant: 'body_normal', color: 'secondary', children: ["We\u2019ve sent a verification email to", ' ', jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', weight: 'medium', as: 'span', children: emailWalletConnector.email })] }), jsxRuntimeExports.jsx(Typography, { weight: 'regular', variant: 'body_small', color: 'secondary', children: "Note: it might take a few seconds to proceed after clicking the link in your email" })] })] }));

const EmailOTPConnectorPendingSignModalContent = ({ walletConnector }) => {
    const { setSelectedWalletWithAction, selectedWalletWithAction, setMultiWalletWidgetState, } = useInternalDynamicContext();
    const [error, setError] = useState();
    const { email } = walletConnector;
    if (!email) {
        throw new Error('EmailOTPConnectorPendingSignModalContent requires a email');
    }
    const { data: isValid, isLoading, mutate: onSubmit, } = useMutation((otp) => walletConnector.verifyOneTimePassword(otp), {
        onFailure: (error) => {
            setError(error);
            dynamicEvents.emit('emailVerificationResult', false, email);
        },
        onSuccess: () => __awaiter$1(void 0, void 0, void 0, function* () {
            if (!selectedWalletWithAction) {
                return;
            }
            setMultiWalletWidgetState('idle');
            setSelectedWalletWithAction(null);
            updatePrimaryWalletId(selectedWalletWithAction.wallet.id);
            dynamicEvents.emit('emailVerificationResult', true, email);
        }),
    });
    return (jsxRuntimeExports.jsx(OTPVerificationView, { MainIcon: EmailIcon, displayedDestination: shortenEmail(email), error: error, isLoading: isLoading, onPinComplete: onSubmit, retryHandler: walletConnector.retryOneTimePassword.bind(walletConnector), isValid: isValid === true, onPinChange: () => setError(undefined) }));
};

const DefaultPendingSignModalContent = () => {
    const { selectedWalletConnector, setMultiWalletWidgetState } = useInternalDynamicContext();
    const { signAlreadyConnectedUser } = useConnectAndSignSplitSteps();
    const onClickToSign = () => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            if (selectedWalletConnector) {
                yield signAlreadyConnectedUser({
                    walletConnector: selectedWalletConnector,
                });
            }
        }
        catch (e) {
            logger$8.error(e);
        }
        finally {
            setMultiWalletWidgetState('idle');
        }
    });
    return (jsxRuntimeExports.jsxs(DefaultPromptModal, { onClose: useCloseMultiWalletPrompt(), dataTestId: 'pending-account-switch', icon: jsxRuntimeExports.jsx(WalletIcon, { icon: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.metadata.icon, walletKey: selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.key }), children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'secondary', weight: 'regular', "data-testid": 'content', children: "Sign the message in your wallet to approve linking this wallet to your account" }), isMobile() &&
                !(selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.canConnectViaCustodialService) && (jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'default-prompt-modal__button', expanded: true, type: 'button', buttonPadding: 'medium', typographyProps: { variant: 'button_secondary' }, onClick: onClickToSign, dataTestId: 'click-to-sign-button', children: "Click to Sign" }))] }));
};

const PendingSignContent = () => {
    const { selectedWalletConnector } = useInternalDynamicContext();
    if (selectedWalletConnector !== null) {
        if (isEmailOTPWalletConnector(selectedWalletConnector)) {
            return (jsxRuntimeExports.jsx(EmailOTPConnectorPendingSignModalContent, { walletConnector: selectedWalletConnector }));
        }
        if (isEmailWalletConnector(selectedWalletConnector)) {
            return (jsxRuntimeExports.jsx(EmailConnectorPendingSignModalContent, { emailWalletConnector: selectedWalletConnector }));
        }
    }
    return jsxRuntimeExports.jsx(DefaultPendingSignModalContent, {});
};
const PendingSignWidgetPortal = () => (jsxRuntimeExports.jsx(WidgetPortal, { onClose: useCloseMultiWalletPrompt(), children: jsxRuntimeExports.jsx(PendingSignContent, {}) }));

const QrCodeModalView = ({ walletId }) => {
    var _a, _b, _c;
    const { secondaryWallets, qrcodeUri, desktopUri } = useInternalDynamicContext();
    const newPrimaryWallet = secondaryWallets.find(({ id }) => id === walletId);
    const walletKey = ((_a = newPrimaryWallet === null || newPrimaryWallet === void 0 ? void 0 : newPrimaryWallet.connector) === null || _a === void 0 ? void 0 : _a.key) || '';
    const walletName = ((_b = newPrimaryWallet === null || newPrimaryWallet === void 0 ? void 0 : newPrimaryWallet.connector) === null || _b === void 0 ? void 0 : _b.name) || '';
    const walletMetadata = (_c = newPrimaryWallet === null || newPrimaryWallet === void 0 ? void 0 : newPrimaryWallet.connector) === null || _c === void 0 ? void 0 : _c.metadata;
    const { theme } = useThemeContext();
    const qrCodeColorsByTheme = {
        dark: {
            accentColor: 'var(--dynamic-text-primary)',
        },
        light: {
            accentColor: (walletMetadata === null || walletMetadata === void 0 ? void 0 : walletMetadata.brandColor) || 'var(--dynamic-text-primary)',
        },
    };
    // can't use theme because it's string instead of 'light' | 'dark'
    const typedTheme = theme.theme.name === 'light' ? 'light' : 'dark';
    const icon = (jsxRuntimeExports.jsx(WalletIcon, { icon: walletMetadata === null || walletMetadata === void 0 ? void 0 : walletMetadata.icon, walletKey: walletKey, style: { height: pixelToRem(24), width: pixelToRem(24) } }));
    return (jsxRuntimeExports.jsxs("div", { className: 'qr-code-modal-view', children: [jsxRuntimeExports.jsxs(Typography, { variant: 'button_primary', color: 'primary', className: 'qr-code-modal-view__title', children: ["Connect with ", walletName] }), jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', color: 'secondary', className: 'qr-code-modal-view__title', children: ["Connect wallet", ' ', jsxRuntimeExports.jsx(Typography, { as: 'span', weight: 'medium', color: 'primary', children: shortenWalletAddress(newPrimaryWallet === null || newPrimaryWallet === void 0 ? void 0 : newPrimaryWallet.address, 4, 4) }), ' ', "to switch active account."] }), jsxRuntimeExports.jsx("div", { className: 'qr-code-modal-view__container', children: jsxRuntimeExports.jsx("div", { className: 'qr-code-modal-view__wrapper', children: qrcodeUri ? (jsxRuntimeExports.jsx(QRCode, { Icon: icon, accentColor: qrCodeColorsByTheme[typedTheme].accentColor, value: qrcodeUri, size: 175, logoSize: 40, walletKey: walletKey })) : (
                    // this div exists to give the parent a child, so that the parent
                    // takes on its given width and height. the result is stable
                    // rendering of this component, without this there is a brief flash
                    jsxRuntimeExports.jsx("div", { "data-testid": 'no-qrcode' })) }) }), jsxRuntimeExports.jsxs("div", { className: 'button__container', children: [(newPrimaryWallet === null || newPrimaryWallet === void 0 ? void 0 : newPrimaryWallet.connector.isWalletConnect) && qrcodeUri && (jsxRuntimeExports.jsxs(CopyButton, { textToCopy: qrcodeUri, children: [jsxRuntimeExports.jsx(Icon, { size: 'small', color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgLink, {}) }), "Copy QR URI"] })), desktopUri && (jsxRuntimeExports.jsxs(TextButton, { className: 'button--open-app', onClick: () => window.open(desktopUri), children: [jsxRuntimeExports.jsx(Icon, { size: 'xsmall', color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgExternalLink, {}) }), "Open ", walletName, " App"] }))] })] }));
};

const AwaitingConnectionContent = ({ PendingSign, PendingConnection, }) => {
    var _a, _b;
    const { selectedWalletConnector, showQrcodeModal, selectedWalletWithAction } = useInternalDynamicContext();
    const Pending = useMemo(() => {
        if (selectedWalletConnector &&
            (isEmailOTPWalletConnector(selectedWalletConnector) ||
                isEmailWalletConnector(selectedWalletConnector))) {
            return PendingSign;
        }
        return PendingConnection;
    }, [selectedWalletConnector]);
    if (showQrcodeModal) {
        if (selectedWalletConnector === null || selectedWalletConnector === void 0 ? void 0 : selectedWalletConnector.canConnectViaQrCode) {
            return (jsxRuntimeExports.jsx(QrCodeModalView, { walletId: (_b = (_a = selectedWalletWithAction === null || selectedWalletWithAction === void 0 ? void 0 : selectedWalletWithAction.wallet) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '' }));
        }
        return jsxRuntimeExports.jsx(NoQrNotInstalledModalView, {});
    }
    return jsxRuntimeExports.jsx(Pending, {});
};
const AwaitingConnectionWidgetPortal = () => (jsxRuntimeExports.jsx(WidgetPortal, { onClose: useCloseMultiWalletPrompt(), children: jsxRuntimeExports.jsx(AwaitingConnectionContent, { PendingSign: PendingSignWidgetPortal, PendingConnection: PendingConnectionWidgetPortal }) }));

const PrimaryNotConnectedContent = () => {
    var _a;
    const { primaryWallet } = useInternalDynamicContext();
    return (jsxRuntimeExports.jsxs(DefaultPromptLayout, { dataTestId: 'wallet-not-connected', icon: jsxRuntimeExports.jsx(WalletIcon, { icon: primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector.metadata.icon, walletKey: (_a = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector) === null || _a === void 0 ? void 0 : _a.key }), title: `Switch wallet in ${primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector.name}`, children: [jsxRuntimeExports.jsxs(Typography, { variant: 'body_normal', color: 'secondary', weight: 'regular', "data-testid": 'content', children: ["Your active wallet in", ' ', jsxRuntimeExports.jsx(Typography, { as: 'span', weight: 'medium', color: 'primary', children: primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector.name }), ' ', "is not linked. Please switch to wallet", ' ', jsxRuntimeExports.jsx(Typography, { as: 'span', weight: 'medium', color: 'primary', children: shortenWalletAddress(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address, 3, 3) }), "."] }), jsxRuntimeExports.jsx(Divider, { fullWidth: true, text: 'Or' }), jsxRuntimeExports.jsx(LogoutButton, { isTextButton: false, buttonClassName: 'primary-not-connected__log-out-button' })] }));
};
const PrimaryNotConnectedWidgetPortal = () => (jsxRuntimeExports.jsx(WidgetPortal, { children: jsxRuntimeExports.jsx(PrimaryNotConnectedContent, {}) }));

const DynamicWidgetPrompts = () => {
    const multiWalletPromptState = useMultiWalletPromptState();
    const mapMultiWalletPromptStateToPromptComponent = {
        awaiting_connection: AwaitingConnectionWidgetPortal,
        detected_new_wallet: DetectedNewWalletWidgetPortal,
        linking_new_wallet: PendingAccountSwitchToLinkWidgetPortal,
        pending_account_switch: PendingAccountSwitchWidgetPortal,
        pending_sign: PendingSignWidgetPortal,
        primary_not_connected: PrimaryNotConnectedWidgetPortal,
        unlink_wallet: UnlinkWalletPopUpWidgetPortal,
    };
    if (multiWalletPromptState === 'idle')
        return null;
    const PromptComponent = mapMultiWalletPromptStateToPromptComponent[multiWalletPromptState];
    return jsxRuntimeExports.jsx(PromptComponent, {});
};

const EmptyWallets = ({ text, copykey }) => {
    const { isTurnkeyWalletWithoutAuthenticator } = useIsTurnkeyWallet();
    return (jsxRuntimeExports.jsxs("div", { className: classNames('empty-wallet__container', {
            'empty-wallet__container--big': !isTurnkeyWalletWithoutAuthenticator,
        }), children: [jsxRuntimeExports.jsx(Icon, { className: 'empty-wallet__icon', size: 'medium', children: jsxRuntimeExports.jsx(SvgEmbeddedWalletIcon, {}) }), jsxRuntimeExports.jsx("div", { className: classNames({
                    'empty-wallet__text-container': !isTurnkeyWalletWithoutAuthenticator,
                }), children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', copykey: copykey, children: text }) })] }));
};

const DynamicWidgetWallets = () => {
    const { t } = useTranslation();
    const { secondaryWallets, user, authMode, setSelectedWalletConnectorKey } = useInternalDynamicContext();
    const { setShowLinkNewWalletModal } = useDynamicModals();
    const { availableWalletsContainerRef } = useWidgetContext();
    const isEmpty = secondaryWallets.length === 0;
    const addNewWallet = () => {
        setShowLinkNewWalletModal(true);
        setSelectedWalletConnectorKey(null);
    };
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("div", { className: 'dynamic-widget-wallets-header', children: [jsxRuntimeExports.jsx(Typography, { weight: 'regular', variant: 'body_normal', color: 'secondary', className: 'dynamic-widget-wallets-header__title', copykey: 'dyn_widget.other_wallets', children: t('dyn_widget.other_wallets') }), jsxRuntimeExports.jsxs(TypographyButton, { buttonClassName: 'dynamic-widget-wallets-header__add_wallet', buttonVariant: 'tertiary', buttonPadding: 'none', onClick: addNewWallet, typographyProps: {
                            color: 'secondary',
                            variant: 'button_tertiary',
                        }, startSlot: jsxRuntimeExports.jsx(SvgAdd, {}), children: [authMode === 'connect-only' ? 'Connect' : 'Link', " a new wallet"] })] }), jsxRuntimeExports.jsx("div", { ref: availableWalletsContainerRef, className: 'dynamic-widget-wallets', "data-testid": 'dynamicWidgetWallets', children: jsxRuntimeExports.jsx("div", { className: classNames('dynamic-widget-wallets__body', {
                        'dynamic-widget-wallets__body--apply-height': !isEmpty,
                    }), children: isEmpty ? (jsxRuntimeExports.jsx(EmptyWallets, { copykey: 'dyn_widget.empty_wallets', text: t('dyn_widget.empty_wallets', {
                            action: authMode === 'connect-and-sign'
                                ? t('dyn_widget.empty_wallets_action_link')
                                : t('dyn_widget.empty_wallets_action_connect'),
                        }) })) : (jsxRuntimeExports.jsx("div", { className: 'dynamic-widget-wallets__body__wallet-list', children: secondaryWallets.map((wallet, index) => {
                            var _a;
                            return (jsxRuntimeExports.jsx(Wallet, { ens: (_a = getWalletVerifiedCredential(wallet.address, user === null || user === void 0 ? void 0 : user.verifiedCredentials, wallet.chain)) === null || _a === void 0 ? void 0 : _a.nameService, wallet: wallet, clickable: true }, wallet.id));
                        }) })) }) })] }));
};

const SingleWalletButtons = () => {
    var _a;
    const { primaryWallet, handleLogOut, user } = useInternalDynamicContext();
    const unknownWallet = user === null || user === void 0 ? void 0 : user.verifiedCredentials.find((credential) => credential.walletName === 'unknown');
    const address = (_a = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address) !== null && _a !== void 0 ? _a : unknownWallet === null || unknownWallet === void 0 ? void 0 : unknownWallet.address;
    return (jsxRuntimeExports.jsxs("div", { className: 'single-wallet-buttons', children: [address && (jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'Copy address', expanded: true, buttonPadding: 'medium', typographyProps: {
                    className: 'single-wallet-buttons--center',
                    variant: 'button_primary',
                }, onClick: () => copyToClipboard(address), feedback: 
                // eslint-disable-next-line react/jsx-wrap-multilines
                jsxRuntimeExports.jsxs("div", { className: 'single-wallet-buttons__copied', children: [jsxRuntimeExports.jsx(SvgCheckCircle, {}), " Copied!"] }), children: "Copy address" })), jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'Disconnect', expanded: true, buttonPadding: 'medium', typographyProps: {
                    className: 'single-wallet-buttons--center',
                    variant: 'button_primary',
                }, onClick: handleLogOut, children: "Disconnect" })] }));
};

const WalletsView = () => {
    const { user, multiWallet } = useInternalDynamicContext();
    const isKYCEnabled = useKYCFlag();
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [!multiWallet && !isKYCEnabled && (jsxRuntimeExports.jsxs("div", { className: 'dynamic-widget-index-view__email-container', children: [jsxRuntimeExports.jsx(Typography, { children: user === null || user === void 0 ? void 0 : user.email }), jsxRuntimeExports.jsx(SingleWalletButtons, {})] })), multiWallet && jsxRuntimeExports.jsx(DynamicWidgetWallets, {})] }));
};

const ProfileView = () => (jsxRuntimeExports.jsx(UserProfile, { rootClassName: 'profile-view' }));

const EditProfileView = ({ rootClassName, }) => {
    const { pushView } = useViewContext();
    const { setShowAuthFlow, multiWallet, user } = useInternalDynamicContext();
    const { goToProfileView } = useWidgetContext();
    const { updateUser } = useUserUpdateRequestInternal({
        validationSchemaStripUnknown: true,
    });
    const onEditProfileFormSubmit = useCallback((formValues) => __awaiter$1(void 0, void 0, void 0, function* () {
        const { isEmailVerificationRequired, isSmsVerificationRequired } = yield updateUser(Object.assign(Object.assign({}, formValues), { metadata: Object.assign(Object.assign({}, user === null || user === void 0 ? void 0 : user.metadata), formValues.metadata) })); // leave existing custom fields that arent edited untouched
        goToProfileView();
        if (isEmailVerificationRequired || isSmsVerificationRequired) {
            setShowAuthFlow(true, {
                ignoreIfIsEmbeddedWidget: false,
                initializeWalletConnect: false,
                performMultiWalletChecks: false,
            });
            pushView(isEmailVerificationRequired ? 'verify-email' : 'verify-sms');
        }
    }), [goToProfileView, setShowAuthFlow, pushView, updateUser]);
    const isKYCEnabled = useKYCFlag();
    return (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [!multiWallet && isKYCEnabled && (jsxRuntimeExports.jsx(Typography, { weight: 'regular', color: 'secondary', variant: 'body_normal', className: 'dynamic-widget-edit-profile-view__profile-title', children: "My information" })), jsxRuntimeExports.jsx(UserProfileForm, { formClassName: rootClassName, onEditProfileSubmit: onEditProfileFormSubmit, onEditProfileCancel: goToProfileView })] }));
};

const SendBalanceWidgetView = () => {
    const { goToInitialDynamicWidgetView } = useWidgetContext();
    return (jsxRuntimeExports.jsx("div", { className: 'send-balance-widget-view', children: jsxRuntimeExports.jsx(SendBalanceView, { onClickBack: goToInitialDynamicWidgetView, onDone: goToInitialDynamicWidgetView }) }));
};

const ManagePasskeysWidgetView = () => {
    var _a;
    const { setDynamicWidgetView } = useWidgetContext();
    const { userPasskeys, userPasskeysLoading: isLoading } = usePasskeyContext();
    const { projectSettings } = useInternalDynamicContext();
    const { initPasskeyRecoveryProcess } = usePasskeyRecovery();
    const { t } = useTranslation();
    const isRecoveryEnabled = Boolean((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk.embeddedWallets) === null || _a === void 0 ? void 0 : _a.emailRecoveryEnabled);
    const backButton = (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: () => setDynamicWidgetView('settings'), "data-testid": 'back-button', children: jsxRuntimeExports.jsx(SvgChevronLeft, {}) }));
    return (jsxRuntimeExports.jsxs("div", { className: 'manage-passkeys-widget-view', children: [jsxRuntimeExports.jsx(ModalHeader, { leading: backButton, children: jsxRuntimeExports.jsx("div", { className: 'send-balance-page-layout__header-content', children: jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', copykey: 'dyn_manage_passkeys.title', children: t('dyn_manage_passkeys.title') }) }) }), jsxRuntimeExports.jsx(PasskeyCreatedSuccessBanner, {}), jsxRuntimeExports.jsxs("div", { className: 'manage-passkeys-widget-view__body', children: [jsxRuntimeExports.jsx("div", { className: 'manage-passkeys-widget-view__body__cards', children: isLoading ? (jsxRuntimeExports.jsx(Skeleton, { count: 1, className: 'manage-passkeys-widget-view__body__cards__skeleton' })) : (userPasskeys.map((passkey) => (jsxRuntimeExports.jsx(PasskeyCard, { passkey: passkey }, passkey.id)))) }), isRecoveryEnabled && (jsxRuntimeExports.jsx(TypographyButton, { buttonPadding: 'large', buttonClassName: 'manage-passkeys-widget-view__body__recovery-button', onClick: () => initPasskeyRecoveryProcess('passkey'), showInternalLoading: false, startSlot: jsxRuntimeExports.jsx(SvgAdd, {}), copykey: 'dyn_manage_passkeys.recovery_button', children: t('dyn_manage_passkeys.recovery_button') }))] })] }));
};

var _rect$1, _path$9, _circle;
var _excluded$9 = ["title", "titleId"];
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$9.apply(null, arguments); }
function _objectWithoutProperties$9(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$9(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$9(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgConnectedApps = function SvgConnectedApps(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$9(_ref, _excluded$9);
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#4779FF"
  })), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.334 5.667a2 2 0 0 0-2 2v3.891a6.667 6.667 0 0 1 7.743 10.775h3.59a2 2 0 0 0 2-2V7.667a2 2 0 0 0-2-2H9.333Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.666,
    cy: 17.334,
    fill: "#fff",
    r: 5
  })));
};

var _path$8;
var _excluded$8 = ["title", "titleId"];
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$8.apply(null, arguments); }
function _objectWithoutProperties$8(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$8(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$8(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgExportPrivateKey = function SvgExportPrivateKey(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$8(_ref, _excluded$8);
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.834 4.667a2.333 2.333 0 0 0-2.333-2.334H7a4.668 4.668 0 0 0-4.592 3.83 4.654 4.654 0 0 1 3.425-1.496h14ZM21 7a4.667 4.667 0 0 1 4.667 4.667V21A4.667 4.667 0 0 1 21 25.667H7A4.667 4.667 0 0 1 2.333 21v-9.333A4.667 4.667 0 0 1 7 7h14Zm-4.915 3.792a3.649 3.649 0 1 1 0 7.297 3.649 3.649 0 0 1 0-7.297Zm0 1.824a1.824 1.824 0 1 1 0 3.649 1.824 1.824 0 0 1 0-3.649Zm-3.16 5.115a4.565 4.565 0 0 1-.714-.924l-4.336 4.336 1.29 1.29 1.254-1.253 1.279 1.278 1.29-1.29-1.279-1.278 1.721-1.722a4.598 4.598 0 0 1-.505-.437Z",
    fill: "#383C48",
    fillOpacity: 0.4
  })));
};

var _path$7;
var _excluded$7 = ["title", "titleId"];
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$7.apply(null, arguments); }
function _objectWithoutProperties$7(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$7(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$7(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgExportRecoveryPhrase = function SvgExportRecoveryPhrase(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$7(_ref, _excluded$7);
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 2.333a2.333 2.333 0 0 1 2.334 2.334h-14A4.654 4.654 0 0 0 2.41 6.164 4.668 4.668 0 0 1 7 2.334h10.5Zm8.167 9.334A4.667 4.667 0 0 0 21 7H7a4.667 4.667 0 0 0-4.667 4.667V21A4.667 4.667 0 0 0 7 25.667h14A4.667 4.667 0 0 0 25.667 21v-9.333Zm-16.8.933A.933.933 0 1 1 7 12.6a.933.933 0 0 1 1.867 0Zm2.426-.933a.933.933 0 1 0 0 1.866h8.214a.933.933 0 1 0 0-1.866h-8.214Zm-2.426 4.666a.933.933 0 1 1-1.867 0 .933.933 0 0 1 1.867 0Zm2.426-.933a.933.933 0 1 0 0 1.867h8.214a.933.933 0 0 0 0-1.867h-8.214Zm-2.426 4.667a.933.933 0 1 1-1.867 0 .933.933 0 0 1 1.867 0Zm2.24-.934a.933.933 0 0 0 0 1.867h8.213a.933.933 0 1 0 0-1.867h-8.213Z",
    fill: "#383C48",
    fillOpacity: 0.4
  })));
};

var _rect, _path$6;
var _excluded$6 = ["title", "titleId"];
function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$6.apply(null, arguments); }
function _objectWithoutProperties$6(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$6(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$6(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgShield = function SvgShield(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$6(_ref, _excluded$6);
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#4779FF"
  })), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.444 5.88a.833.833 0 0 1 1.112 0A9.13 9.13 0 0 0 21.14 8.2c.395-.02.75.24.848.624.226.87.345 1.782.345 2.721 0 5.05-3.453 9.29-8.125 10.492a.833.833 0 0 1-.416 0c-4.672-1.202-8.125-5.443-8.125-10.492 0-.939.12-1.85.345-2.722a.833.833 0 0 1 .849-.623 9.13 9.13 0 0 0 6.584-2.322Zm-5.96 3.999c-.099.54-.15 1.097-.15 1.667A9.171 9.171 0 0 0 14 20.368a9.171 9.171 0 0 0 6.516-10.49A10.788 10.788 0 0 1 14 7.587a10.788 10.788 0 0 1-6.515 2.293Zm9.605 1.912a.833.833 0 0 1 0 1.178l-3.333 3.333a.833.833 0 0 1-1.178 0l-1.667-1.666a.834.834 0 0 1 1.178-1.179l1.078 1.078 2.744-2.745a.833.833 0 0 1 1.178 0Z",
    fill: "#fff"
  })));
};

var _g, _path$5;
var _excluded$5 = ["title", "titleId"];
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$5.apply(null, arguments); }
function _objectWithoutProperties$5(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$5(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$5(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgWalletWithSunglasses = function SvgWalletWithSunglasses(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$5(_ref, _excluded$5);
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4779FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.002 5.333a5.333 5.333 0 0 1 5.333 5.334h-32c-3.094 0-5.88 1.317-7.83 3.422.901-4.98 5.258-8.756 10.497-8.756h24ZM58.667 26.667C58.667 20.776 53.891 16 48 16H16c-5.89 0-10.666 4.776-10.666 10.667V48c0 5.891 4.775 10.667 10.666 10.667h32c5.891 0 10.667-4.776 10.667-10.667V26.667Z"
  }))), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.928 37.787a7.431 7.431 0 1 0 14.862 0 7.431 7.431 0 0 0-14.862 0Zm-22.88 0a7.43 7.43 0 1 0 14.861 0 7.43 7.43 0 0 0-14.862 0Zm30.311-9.037a9.035 9.035 0 0 1 7.566 4.103h1.522a.803.803 0 0 1 0 1.606h-.688a8.98 8.98 0 0 1 .638 3.328c0 4.984-4.054 9.038-9.038 9.038-4.983 0-9.037-4.054-9.037-9.038 0-1.114.204-2.18.575-3.166a3.718 3.718 0 0 0-3.276-1.926 3.748 3.748 0 0 0-2.903 1.383 8.983 8.983 0 0 1 .798 3.71c0 4.983-4.054 9.037-9.038 9.037-4.983 0-9.037-4.054-9.037-9.038a8.98 8.98 0 0 1 .637-3.328h-.525a.803.803 0 1 1 0-1.606h1.36a9.035 9.035 0 0 1 7.565-4.103 9.03 9.03 0 0 1 7.404 3.864 5.354 5.354 0 0 1 3.74-1.526c1.628 0 3.102.72 4.09 1.893a9.036 9.036 0 0 1 7.647-4.231Z",
    fill: "var(--dynamic-base-2)",
    stroke: "var(--dynamic-base-2)",
    strokeWidth: 0.5
  })));
};

const EmptyScreen = () => {
    const { t } = useTranslation();
    return (jsxRuntimeExports.jsxs("div", { className: 'empty-screen', children: [jsxRuntimeExports.jsx(LinearGradientFrame, { Icon: jsxRuntimeExports.jsx(SvgWalletWithSunglasses, {}) }), jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'secondary', className: 'empty-screen__title', children: t('dyn_settings.empty_screen.title') })] }));
};

const SettingsView = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const { projectSettings, primaryWallet, user, handleLogOut } = useInternalDynamicContext();
    const { globalWallet } = 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_a = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector) !== null && _a !== void 0 ? _a : {};
    const { setDynamicWidgetView } = useWidgetContext();
    const { addEmbeddedWalletRecoveryEmail } = useEmbeddedWalletAuthenticator();
    const { initExportProcess } = useEmbeddedReveal();
    const { isTurnkeyWallet, isTurnkeyWalletWithoutAuthenticator, hasRecoveryEmail, } = useIsTurnkeyWallet();
    const { theme } = useThemeContext();
    const { t } = useTranslation();
    const { initPasskeyRecoveryProcess, shouldInitRecovery } = usePasskeyRecovery();
    const [isLoading, setIsLoading] = useState(false);
    const { getEOAWallet } = useSmartWallets();
    const turnkeyWalletProperties = (_c = (_b = user === null || user === void 0 ? void 0 : user.verifiedCredentials) === null || _b === void 0 ? void 0 : _b.find(({ walletName }) => walletName === null || walletName === void 0 ? void 0 : walletName.startsWith('turnkey'))) === null || _c === void 0 ? void 0 : _c.walletProperties;
    const isTurnkeyHDWallet = turnkeyWalletProperties === null || turnkeyWalletProperties === void 0 ? void 0 : turnkeyWalletProperties.turnkeyHDWalletId;
    const isPasskeyEnabled = Boolean((_g = (_f = (_e = (_d = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.sdk) === null || _d === void 0 ? void 0 : _d.embeddedWallets) === null || _e === void 0 ? void 0 : _e.supportedSecurityMethods) === null || _f === void 0 ? void 0 : _f.passkey) === null || _g === void 0 ? void 0 : _g.isEnabled);
    const isTurnkeyWalletWithAuthenticator = isTurnkeyWallet && !isTurnkeyWalletWithoutAuthenticator;
    const eoaWallet = primaryWallet && getEOAWallet(primaryWallet);
    const wallet = eoaWallet !== null && eoaWallet !== void 0 ? eoaWallet : primaryWallet;
    const isSessionKeyCompatible = (primaryWallet && isSessionKeyCompatibleWallet(primaryWallet)) ||
        (eoaWallet && isSessionKeyCompatibleWallet(eoaWallet));
    const handleConnectedAppsClick = () => {
        setDynamicWidgetView('connected-apps');
    };
    const handlePasskeyClick = () => __awaiter$1(void 0, void 0, void 0, function* () {
        if (isTurnkeyWalletWithAuthenticator) {
            return setDynamicWidgetView('manage-passkeys');
        }
        setIsLoading(true);
        try {
            yield initPasskeyRecoveryProcess('passkey');
        }
        finally {
            setIsLoading(false);
        }
    });
    const handleExportClick = (recoveryPhrase) => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!isSessionKeyCompatible) {
            if (yield shouldInitRecovery()) {
                yield initPasskeyRecoveryProcess(undefined, {
                    type: 'reveal',
                });
            }
        }
        return initExportProcess(recoveryPhrase);
    });
    const renderPasskeysButtonEndSlot = () => {
        if (isTurnkeyWalletWithAuthenticator)
            return (jsxRuntimeExports.jsx(SvgCheckCircle, { className: 'settings-view__body__section__button__icon-secondary--success' }));
        if (isLoading)
            return jsxRuntimeExports.jsx(Spinner$1, {});
        return jsxRuntimeExports.jsx(SvgAdd, {});
    };
    const renderEmailButtonEndSlot = () => {
        if (hasRecoveryEmail)
            return (jsxRuntimeExports.jsx(SvgCheckCircle, { className: 'settings-view__body__section__button__icon-secondary--success' }));
        if (isLoading)
            return jsxRuntimeExports.jsx(Spinner$1, {});
        return jsxRuntimeExports.jsx(SvgAdd, { "data-testid": 'email-add-icon' });
    };
    const isEmbeddedWallet = Boolean(wallet && ((_j = (_h = wallet === null || wallet === void 0 ? void 0 : wallet.connector) === null || _h === void 0 ? void 0 : _h.key) === null || _j === void 0 ? void 0 : _j.startsWith('turnkey')));
    const isMfaEnabled = Boolean((_l = (_k = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.security) === null || _k === void 0 ? void 0 : _k.mfa) === null || _l === void 0 ? void 0 : _l.enabled);
    const shouldShowPasskeyMFA = isPasskeyEnabled && isTurnkeyWallet && !isSessionKeyCompatible;
    const shouldShowSecuritySection = isMfaEnabled || shouldShowPasskeyMFA;
    return (jsxRuntimeExports.jsxs("div", { className: 'settings-view', children: [jsxRuntimeExports.jsxs("div", { className: 'settings-view__body', children: [globalWallet && (jsxRuntimeExports.jsxs("div", { className: 'settings-view__body__section', children: [jsxRuntimeExports.jsx("div", { className: 'settings-view__body__section__title', children: t('dyn_settings.global_connectivity_section.title') }), jsxRuntimeExports.jsx(TypographyButton, { onClick: () => handleConnectedAppsClick(), dataTestId: 'connected-apps-button', buttonClassName: 'settings-view__body__section__button', startSlot: 
                                // eslint-disable-next-line react/jsx-wrap-multilines
                                jsxRuntimeExports.jsxs("div", { className: 'settings-view__body__section__button__start-slot', children: [jsxRuntimeExports.jsx(SvgConnectedApps, { className: 'settings-view__body__section__button__icon' }), jsxRuntimeExports.jsx(Typography, { color: 'primary', weight: 'medium', copykey: 'dyn_settings.global_connectivity_section.connected_apps_button', children: t('dyn_settings.global_connectivity_section.connected_apps_button') })] }), endSlot: jsxRuntimeExports.jsx(SvgChevronLeft, { className: 'settings-view__body__section__button__icon-secondary--rotate' }), showInternalLoading: false })] })), shouldShowSecuritySection && (jsxRuntimeExports.jsxs("div", { className: 'settings-view__body__section', children: [jsxRuntimeExports.jsx("div", { className: classNames('settings-view__body__section__title', {
                                    'settings-view__body__section__title__info-icon': !isTurnkeyWalletWithAuthenticator,
                                }), children: t('dyn_settings.security_section.title') }), shouldShowPasskeyMFA && (jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'manage-passkeys-button', onClick: () => handlePasskeyClick(), buttonClassName: classNames('settings-view__body__section__button', {
                                    'settings-view__body__section__button__badge': !isTurnkeyWalletWithAuthenticator,
                                }), startSlot: 
                                // eslint-disable-next-line react/jsx-wrap-multilines
                                jsxRuntimeExports.jsxs("div", { className: 'settings-view__body__section__button__start-slot', children: [jsxRuntimeExports.jsx(PasskeyDeviceIcon, { className: 'settings-view__body__section__button__icon', defaultIcon: jsxRuntimeExports.jsx(SvgAndroidTouchId, { "data-testid": 'default-icon' }) }), jsxRuntimeExports.jsx(Typography, { color: 'primary', weight: 'medium', copykey: 'dyn_settings.security_section.passkey_button', children: t('dyn_settings.security_section.passkey_button') }), !isTurnkeyWalletWithAuthenticator && (jsxRuntimeExports.jsx(Badge, { text: t('dyn_settings.tags.recommended'), copykey: 'dyn_settings.tags.recommended', variant: 'secondary' }))] }), endSlot: renderPasskeysButtonEndSlot(), disabled: isLoading, showInternalLoading: false })), isMfaEnabled && (jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'manage-mfa-button', onClick: () => setDynamicWidgetView('manage-mfa'), buttonClassName: 'settings-view__body__section__button', startSlot: 
                                // eslint-disable-next-line react/jsx-wrap-multilines
                                jsxRuntimeExports.jsxs("div", { className: 'settings-view__body__section__button__start-slot', children: [jsxRuntimeExports.jsx(SvgShield, { className: 'settings-view__body__section__button__icon' }), jsxRuntimeExports.jsx(Typography, { color: 'primary', weight: 'medium', copykey: 'dyn_settings.security_section.mfa_button', children: t('dyn_settings.security_section.mfa_button') })] }), endSlot: jsxRuntimeExports.jsx(SvgChevronLeft, { className: 'settings-view__body__section__button__icon-secondary--rotate' }), disabled: isLoading, showInternalLoading: false }))] })), isEmbeddedWallet && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [isTurnkeyWallet &&
                                !hasRecoveryEmail &&
                                !isSessionKeyCompatible && (jsxRuntimeExports.jsxs("div", { className: 'settings-view__body__section', children: [jsxRuntimeExports.jsxs("div", { className: classNames('settings-view__body__section__title', 'settings-view__body__section__title__info-icon'), children: [t('dyn_settings.identity_section.title'), jsxRuntimeExports.jsx(Icon, { size: 'small', children: jsxRuntimeExports.jsx(SvgFooterInfoIcon, { className: 'settings-view__body__section__title__info-icon', "data-testid": 'email-info-icon-title' }) })] }), jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'manage-email-recovery-button', onClick: addEmbeddedWalletRecoveryEmail, buttonClassName: classNames('settings-view__body__section__button', 'settings-view__body__section__button__badge'), startSlot: 
                                        // eslint-disable-next-line react/jsx-wrap-multilines
                                        jsxRuntimeExports.jsxs("div", { className: 'settings-view__body__section__button__start-slot', children: [jsxRuntimeExports.jsx(SvgSignInWithEmail, { className: 'settings-view__body__section__button__icon email' }), jsxRuntimeExports.jsx(Typography, { color: 'primary', weight: 'medium', copykey: 'dyn_settings.identity_section.add_email_button', children: t('dyn_settings.identity_section.add_email_button') }), jsxRuntimeExports.jsx(Badge, { text: t('dyn_settings.tags.recommended'), copykey: 'dyn_settings.tags.recommended', variant: 'secondary' })] }), endSlot: renderEmailButtonEndSlot(), disabled: isLoading || hasRecoveryEmail, showInternalLoading: false })] })), jsxRuntimeExports.jsxs("div", { className: 'settings-view__body__section', children: [jsxRuntimeExports.jsx("div", { className: 'settings-view__body__section__title', children: t('dyn_settings.export_section.title') }), jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'embedded-reveal-account-button', onClick: () => handleExportClick(), buttonClassName: 'settings-view__body__section__button', startSlot: 
                                        // eslint-disable-next-line react/jsx-wrap-multilines
                                        jsxRuntimeExports.jsxs("div", { className: 'settings-view__body__section__button__start-slot', children: [jsxRuntimeExports.jsx(SvgExportPrivateKey, { className: `settings-view__body__section__button__icon${theme.theme.name === 'dark' ? '__stroke' : ''}` }), jsxRuntimeExports.jsx(Typography, { color: 'primary', weight: 'medium', copykey: 'dyn_settings.export_section.private_key_button', children: t('dyn_settings.export_section.private_key_button') })] }), endSlot: jsxRuntimeExports.jsx(SvgChevronLeft, { className: 'settings-view__body__section__button__icon-secondary--rotate' }), showInternalLoading: false }), isTurnkeyHDWallet && (jsxRuntimeExports.jsx(TypographyButton, { dataTestId: 'embedded-reveal-button', onClick: () => handleExportClick(true), buttonClassName: 'settings-view__body__section__button', startSlot: 
                                        // eslint-disable-next-line react/jsx-wrap-multilines
                                        jsxRuntimeExports.jsxs("div", { className: 'settings-view__body__section__button__start-slot', children: [jsxRuntimeExports.jsx(SvgExportRecoveryPhrase, { className: `settings-view__body__section__button__icon${theme.theme.name === 'dark' ? '__stroke' : ''}` }), jsxRuntimeExports.jsx(Typography, { color: 'primary', weight: 'medium', copykey: 'dyn_settings.export_section.srp_button', children: t('dyn_settings.export_section.srp_button') })] }), endSlot: jsxRuntimeExports.jsx(SvgChevronLeft, { className: 'settings-view__body__section__button__icon-secondary--rotate' }), showInternalLoading: false }))] })] })), jsxRuntimeExports.jsx(EmptyScreen, {})] }), jsxRuntimeExports.jsx("div", { className: 'settings-view__logout-button-container', children: jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'settings-view__logout-button-container__button', onClick: handleLogOut, dataTestId: 'logout-button', copykey: 'dyn_settings.buttonLogout', children: t('dyn_settings.button_logout') }) })] }));
};

const ChooseOnrampProviderView = () => {
    const { t } = useTranslation();
    const { setDynamicWidgetView } = useWidgetContext();
    const { enabledOnrampProviders } = useOnrampContext();
    const { primaryWallet } = useInternalDynamicContext();
    const onrampOptions = useMemo(() => enabledOnrampProviders.filter(({ isPaymentMethod }) => !isPaymentMethod), [enabledOnrampProviders]);
    const backButton = (jsxRuntimeExports.jsx(IconButton, { type: 'button', id: 'back-button', "data-testid": 'back-button', onClick: () => setDynamicWidgetView('choose-wallet-funding-method'), children: jsxRuntimeExports.jsx(SvgArrowLeft, {}) }));
    return (jsxRuntimeExports.jsxs("div", { className: 'deposit-view', children: [jsxRuntimeExports.jsx(ModalHeader, { leading: backButton, description: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'secondary', className: 'choose-onramp-provider__header-description', children: t('dyn_wallet_funding.onramp_provider_selection.description') }), children: jsxRuntimeExports.jsx(Typography, { variant: 'title', children: t('dyn_wallet_funding.onramp_provider_selection.title') }) }), jsxRuntimeExports.jsx("div", { className: 'choose-wallet-funding-method__options', children: primaryWallet &&
                    onrampOptions.map((option) => (jsxRuntimeExports.jsx(TypographyButton, { onClick: () => option.onClick({ wallet: primaryWallet }), leading: jsxRuntimeExports.jsx(Icon, { className: 'choose-onramp-provider__options__option__icon', children: jsxRuntimeExports.jsx("img", { src: option.iconUrl, alt: option.displayName }) }), typographyProps: { variant: 'body_normal', weight: 'medium' }, buttonVariant: 'card', className: 'choose-wallet-funding-method__options__option', description: option.description, children: option.displayName }, option.id))) })] }));
};

var _path$4;
var _excluded$4 = ["title", "titleId"];
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$4.apply(null, arguments); }
function _objectWithoutProperties$4(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$4(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$4(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgChevronRight = function SvgChevronRight(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$4(_ref, _excluded$4);
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.529 13.138a.667.667 0 0 1 0-.943L9.724 8 5.529 3.805a.667.667 0 1 1 .943-.943l4.666 4.667c.26.26.26.682 0 .942l-4.666 4.667a.667.667 0 0 1-.943 0Z",
    fill: "currentColor"
  })));
};

const MakeTrailing = ({ showChevron, previewIcons, }) => {
    if (!showChevron && !previewIcons.length) {
        return null;
    }
    return (jsxRuntimeExports.jsxs("div", { className: 'choose-wallet-funding-method__options__option__trailing', children: [previewIcons.length > 0 && (jsxRuntimeExports.jsx("div", { "data-testid": 'preview-icons', className: 'choose-wallet-funding-method__options__option__trailing__preview-icons', children: previewIcons.map((icon) => icon) })), showChevron && (jsxRuntimeExports.jsx(Icon, { size: 'small', color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgChevronRight, { "data-testid": 'chevron-icon' }) }))] }));
};

var _path$3;
var _excluded$3 = ["title", "titleId"];
function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$3.apply(null, arguments); }
function _objectWithoutProperties$3(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$3(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$3(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgAddThick = function SvgAddThick(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$3(_ref, _excluded$3);
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.333c.368 0 .667.299.667.667v3.333H12a.667.667 0 0 1 0 1.334H8.667V12a.667.667 0 1 1-1.333 0V8.667H4a.667.667 0 1 1 0-1.334h3.333V4c0-.368.299-.667.667-.667Z",
    fill: "#ABACB2"
  })));
};

var _path$2;
var _excluded$2 = ["title", "titleId"];
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$2.apply(null, arguments); }
function _objectWithoutProperties$2(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$2(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$2(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgGlobe = function SvgGlobe(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$2(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.738 12.84h4.616c.09-2.54.47-4.854 1.064-6.634.114-.342.238-.671.373-.984a9.352 9.352 0 0 0-6.053 7.617ZM14 2.332C7.55 2.333 2.334 7.563 2.334 14c0 6.437 5.217 11.667 11.666 11.667 6.45 0 11.667-5.23 11.667-11.667C25.667 7.563 20.45 2.333 14 2.333Zm0 2.322s.007 0 .016.003a.343.343 0 0 1 .077.037c.08.05.202.151.351.34.304.387.63 1.018.924 1.901.502 1.51.855 3.568.944 5.903h-4.623c.089-2.335.441-4.394.944-5.903.294-.883.619-1.514.923-1.9.15-.19.271-.291.352-.34a.343.343 0 0 1 .076-.038L14 4.655ZM9.354 15.161H4.738a9.352 9.352 0 0 0 6.052 7.616 12.295 12.295 0 0 1-.372-.983c-.593-1.78-.974-4.095-1.064-6.633ZM14 23.345s-.006 0-.016-.003a.34.34 0 0 1-.076-.037c-.081-.05-.202-.151-.352-.341-.304-.386-.629-1.017-.923-1.9-.503-1.51-.855-3.568-.944-5.903h4.623c-.09 2.335-.442 4.394-.944 5.902-.295.884-.48 1.3-.784 1.687-.15.19-.41.505-.491.555a.34.34 0 0 1-.077.037l-.016.003c1.127 0 2.209-.2 3.21-.568a9.351 9.351 0 0 0 6.052-7.616h-4.616c-.09 2.539-.47 4.853-1.064 6.633-.113.342-.238.671-.372.983m1.436-9.938c-.09-2.539-.47-4.853-1.064-6.633a12.305 12.305 0 0 0-.372-.984 9.351 9.351 0 0 1 6.052 7.617h-4.616Z",
    fill: "currentColor"
  })));
};

var _path$1;
var _excluded$1 = ["title", "titleId"];
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends$1.apply(null, arguments); }
function _objectWithoutProperties$1(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose$1(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose$1(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgQrCode = function SvgQrCode(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties$1(_ref, _excluded$1);
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 5.833A2.333 2.333 0 0 1 5.833 3.5h2.334A2.333 2.333 0 0 1 10.5 5.833v2.334A2.333 2.333 0 0 1 8.167 10.5H5.833A2.333 2.333 0 0 1 3.5 8.167V5.833Zm4.667 0H5.833v2.334h2.334V5.833ZM14 3.5c.644 0 1.167.522 1.167 1.167v1.166a1.167 1.167 0 0 1-2.334 0V4.667c0-.645.523-1.167 1.167-1.167Zm3.5 2.333A2.333 2.333 0 0 1 19.833 3.5h2.334A2.333 2.333 0 0 1 24.5 5.833v2.334a2.333 2.333 0 0 1-2.333 2.333h-2.334A2.333 2.333 0 0 1 17.5 8.167V5.833Zm4.667 0h-2.334v2.334h2.334V5.833ZM14 9.333c.644 0 1.167.523 1.167 1.167v2.333h3.511a1.167 1.167 0 0 1 0 2.334H14A1.167 1.167 0 0 1 12.833 14v-3.5c0-.644.523-1.167 1.167-1.167ZM3.5 14c0-.644.522-1.167 1.167-1.167h4.666a1.167 1.167 0 0 1 0 2.334H4.667A1.167 1.167 0 0 1 3.5 14Zm18.667 0c0-.644.522-1.167 1.166-1.167h.012a1.167 1.167 0 0 1 0 2.334h-.012A1.167 1.167 0 0 1 22.167 14ZM3.5 19.833A2.333 2.333 0 0 1 5.833 17.5h2.334a2.333 2.333 0 0 1 2.333 2.333v2.334A2.333 2.333 0 0 1 8.167 24.5H5.833A2.333 2.333 0 0 1 3.5 22.167v-2.334Zm4.667 0H5.833v2.334h2.334v-2.334Zm4.666-1.166c0-.645.523-1.167 1.167-1.167h2.333a1.167 1.167 0 1 1 0 2.333h-1.166v3.5a1.167 1.167 0 0 1-2.334 0v-4.666Zm7 0c0-.645.523-1.167 1.167-1.167h2.333a1.167 1.167 0 1 1 0 2.333H21a1.167 1.167 0 0 1-1.167-1.166ZM17.5 23.333c0-.644.522-1.166 1.167-1.166h4.666a1.167 1.167 0 1 1 0 2.333h-4.666a1.167 1.167 0 0 1-1.167-1.167Z",
    fill: "currentColor"
  })));
};

const useStartExternalWalletFunding = () => {
    const { connectWalletForFunding, promptAmountAndFund } = useFundWithWallet();
    return useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            const externalWallet = yield connectWalletForFunding();
            const props = getPromptAmountParams({ externalWallet });
            promptAmountAndFund(props);
        }
        catch (_a) {
            /* empty */
        }
    }), [connectWalletForFunding, promptAmountAndFund]);
};

const slicePreviewIcons = (icons) => {
    if (icons.length > MAX_PREVIEW_ICONS)
        return icons.slice(0, MAX_PREVIEW_ICONS).concat(jsxRuntimeExports.jsx("div", { className: 'choose-wallet-funding-method__options__option__trailing__preview-icons__plus-icon', children: jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', children: jsxRuntimeExports.jsx(SvgAddThick, {}) }) }, 'plus-icon'));
    return icons;
};
const MAX_PREVIEW_ICONS = 3;
const useFundingMethods = () => {
    const { t } = useTranslation();
    const { setDynamicWidgetView } = useWidgetContext();
    const { externalWalletFundingEnabled } = useFundWithWallet();
    const { enabledOnrampProviders } = useOnrampContext();
    const { primaryWallet } = useInternalDynamicContext();
    const viewWalletsFilter = useMemo(() => (primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain)
        ? FilterChain(primaryWallet.chain)
        : undefined, [primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.chain]);
    const { walletsList } = useWalletList({
        viewWalletsFilter,
    });
    const walletGroups = useWalletGroups();
    const startExternalWalletFunding = useStartExternalWalletFunding();
    const onrampOptions = useMemo(() => enabledOnrampProviders.filter(({ isPaymentMethod }) => !isPaymentMethod), [enabledOnrampProviders]);
    const paymentMethods = useMemo(() => enabledOnrampProviders.filter(({ isPaymentMethod }) => isPaymentMethod), [enabledOnrampProviders]);
    const handleQrClick = useCallback(() => setDynamicWidgetView('deposit-view'), [setDynamicWidgetView]);
    const handleBuyCryptoClick = useCallback(() => {
        if (!primaryWallet) {
            return;
        }
        onrampOptions.length > 1
            ? setDynamicWidgetView('choose-onramp-provider')
            : onrampOptions[0].onClick({ wallet: primaryWallet });
    }, [onrampOptions, setDynamicWidgetView, primaryWallet]);
    const previewWalletIcons = useMemo(() => {
        if (!externalWalletFundingEnabled)
            return [];
        return slicePreviewIcons(walletsList.map(({ key, walletConnector }, index) => {
            var _a, _b, _c;
            return (jsxRuntimeExports.jsx("div", { className: 'choose-wallet-funding-method__options__option__trailing__preview-icons__wallet-icon', style: { '--z-index': MAX_PREVIEW_ICONS - index }, children: jsxRuntimeExports.jsx(WalletIcon, { icon: (_a = walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.metadata.icon) !== null && _a !== void 0 ? _a : (_c = (_b = walletGroups[key]) === null || _b === void 0 ? void 0 : _b.brand) === null || _c === void 0 ? void 0 : _c.icon, walletKey: key, isGroup: false }) }, key));
        }));
    }, [externalWalletFundingEnabled, walletsList, walletGroups]);
    const previewOnrampIcons = useMemo(() => {
        if (!onrampOptions.length)
            return [];
        return slicePreviewIcons(onrampOptions.map(({ iconUrl, id }) => (jsxRuntimeExports.jsx("div", { className: 'choose-wallet-funding-method__options__option__trailing__preview-icons__onramp-icon', children: jsxRuntimeExports.jsx("img", { src: iconUrl, alt: `${id}-icon` }) }, id))));
    }, [onrampOptions]);
    return useMemo(() => {
        const methods = [
            {
                icon: jsxRuntimeExports.jsx(SvgQrCode, {}),
                key: 'qr',
                label: t('dyn_wallet_funding.funding_method_selection.qr_option'),
                onClick: handleQrClick,
                showChevron: true,
            },
        ];
        if (primaryWallet) {
            paymentMethods.forEach(({ id, iconUrl, displayName, onClick }) => {
                methods.push({
                    icon: jsxRuntimeExports.jsx("img", { src: iconUrl, alt: displayName }),
                    key: id,
                    label: displayName,
                    onClick: () => onClick({ wallet: primaryWallet }),
                    showChevron: false,
                });
            });
        }
        if (onrampOptions.length) {
            methods.push({
                icon: jsxRuntimeExports.jsx(SvgGlobe, {}),
                key: 'buy',
                label: t('dyn_wallet_funding.funding_method_selection.buy_option'),
                onClick: handleBuyCryptoClick,
                previewIcons: previewOnrampIcons,
                showChevron: onrampOptions.length > 1,
            });
        }
        if (externalWalletFundingEnabled) {
            methods.push({
                icon: jsxRuntimeExports.jsx(SvgWalletOutlineV2, {}),
                key: 'external-wallet',
                label: t('dyn_wallet_funding.funding_method_selection.external_wallet_option'),
                onClick: startExternalWalletFunding,
                previewIcons: previewWalletIcons,
                showChevron: true,
            });
        }
        return methods;
    }, [
        t,
        handleQrClick,
        paymentMethods,
        onrampOptions.length,
        handleBuyCryptoClick,
        previewOnrampIcons,
        externalWalletFundingEnabled,
        startExternalWalletFunding,
        previewWalletIcons,
        primaryWallet,
    ]);
};

const ChooseWalletFundingMethod = () => {
    const { goToInitialDynamicWidgetView } = useWidgetContext();
    const { t } = useTranslation();
    const backButton = (jsxRuntimeExports.jsx(IconButton, { type: 'button', id: 'back-button', "data-testid": 'back-button', onClick: goToInitialDynamicWidgetView, children: jsxRuntimeExports.jsx(SvgArrowLeft, {}) }));
    const methods = useFundingMethods();
    return (jsxRuntimeExports.jsxs("div", { className: 'choose-wallet-funding-method', children: [jsxRuntimeExports.jsx(ModalHeader, { leading: backButton, children: jsxRuntimeExports.jsx(Typography, { variant: 'title', children: t('dyn_wallet_funding.funding_method_selection.title') }) }), jsxRuntimeExports.jsx("div", { className: 'choose-wallet-funding-method__options', children: methods.map((method) => {
                    var _a;
                    return (jsxRuntimeExports.jsx(TypographyButton, { onClick: method.onClick, description: method.description, leading: jsxRuntimeExports.jsx(Icon, { color: 'text-tertiary', className: 'choose-wallet-funding-method__options__option__icon', children: method.icon }), trailing: jsxRuntimeExports.jsx(MakeTrailing, { previewIcons: (_a = method.previewIcons) !== null && _a !== void 0 ? _a : [], showChevron: Boolean(method.showChevron) }), typographyProps: { variant: 'body_normal', weight: 'medium' }, buttonVariant: 'card', className: 'choose-wallet-funding-method__options__option', children: method.label }, method.key));
                }) })] }));
};

const ConnectedAppsView = ({ name }) => {
    var _a;
    const { t } = useTranslation();
    const { setDynamicWidgetView } = useWidgetContext();
    const { primaryWallet } = useDynamicContext();
    const [connectedApps, setConnectedApps] = useState([]);
    const [refreshing, setRefreshing] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const { globalWallet } = (_a = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector) !== null && _a !== void 0 ? _a : {};
    useEffect(() => {
        const fetchConnectedApps = () => __awaiter$1(void 0, void 0, void 0, function* () {
            try {
                // poll for 3 seconds for the global wallet to load
                const pollForSessions = () => __awaiter$1(void 0, void 0, void 0, function* () {
                    const startTime = Date.now();
                    while (Date.now() - startTime < 3000) {
                        try {
                            const sessions = yield globalWallet.getConnectedWCSessions();
                            if (sessions !== undefined) {
                                return sessions;
                            }
                        }
                        catch (error) {
                            // ignore polling error waiting for global wallet to load
                        }
                        yield new Promise((resolve) => setTimeout(resolve, 100));
                    }
                    logger$1.warn('Timeout waiting for sessions');
                    return undefined;
                });
                const sessions = yield pollForSessions();
                // when a user logs out on dapp side, refresh the connected apps
                globalWallet.getWeb3Wallet().on('session_delete', () => setRefreshing(!refreshing));
                if (sessions) {
                    const apps = Object.values(sessions).map((session) => ({
                        icon: session.peer.metadata.icons[0] || '',
                        name: session.peer.metadata.name,
                        topic: session.topic,
                        url: session.peer.metadata.url,
                    }));
                    setConnectedApps(apps);
                }
            }
            catch (error) {
                logger$1.warn('Error fetching connected apps', error);
            }
        });
        fetchConnectedApps();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [primaryWallet, refreshing]);
    useEffect(() => {
        if (name) {
            setShowSuccessMessage(true);
            const timer = setTimeout(() => {
                setShowSuccessMessage(false);
            }, 3000);
            return () => clearTimeout(timer);
        }
        else
            return;
    }, [name]);
    const handleDisconnect = (topic) => __awaiter$1(void 0, void 0, void 0, function* () {
        try {
            yield globalWallet.disconnectWCSession(topic);
            setRefreshing(!refreshing);
        }
        catch (error) {
            logger$1.warn('Error disconnecting app', error);
        }
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'connected-apps-view', children: [jsxRuntimeExports.jsxs("div", { className: 'header', children: [jsxRuntimeExports.jsx(IconButton, { onClick: () => setDynamicWidgetView('settings'), "data-testid": 'back-button', className: 'back-button', type: 'button', children: jsxRuntimeExports.jsx(SvgArrowLeft, { className: 'arrow-left-icon' }) }), jsxRuntimeExports.jsx(Typography, { variant: 'title', weight: 'medium', color: 'primary', className: 'title', children: t('global_wallet.connected_apps.title') })] }), jsxRuntimeExports.jsx("div", { className: 'subheader', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'medium', color: 'primary', className: 'title', children: t('global_wallet.connected_apps.subtitle') }) }), connectedApps.length > 0 && (jsxRuntimeExports.jsx("ul", { className: 'connected-apps-list', children: connectedApps.map((app) => (jsxRuntimeExports.jsxs("li", { className: 'connected-app-item', children: [jsxRuntimeExports.jsx("img", { src: app.icon, alt: app.name, className: 'app-icon' }), jsxRuntimeExports.jsx("div", { className: 'app-info', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', children: app.url }) }), jsxRuntimeExports.jsxs("div", { className: 'app-actions', children: [jsxRuntimeExports.jsx(TypographyButton, { onClick: () => window.open(app.url, '_blank'), buttonVariant: 'tertiary', buttonPadding: 'none', startSlot: jsxRuntimeExports.jsx(SvgExternalLink, {}), typographyProps: {
                                        color: 'secondary',
                                        variant: 'button_secondary',
                                    } }), jsxRuntimeExports.jsx(TypographyButton, { onClick: () => handleDisconnect(app.topic), buttonVariant: 'tertiary', buttonPadding: 'none', startSlot: jsxRuntimeExports.jsx(SvgUnlink, {}), typographyProps: {
                                        color: 'secondary',
                                        variant: 'button_secondary',
                                    } })] })] }, app.url))) })), showSuccessMessage && (jsxRuntimeExports.jsxs("div", { className: 'success-message', children: [jsxRuntimeExports.jsx(SvgCheck, {}), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', color: 'primary', children: t('global_wallet.connected_apps.success', { name }) })] }))] }));
};

const DepositView = () => {
    var _a;
    const { t } = useTranslation();
    const { primaryWallet, getNameService } = useInternalDynamicContext();
    const walletConnector = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector;
    const { chain } = useFetchChain(walletConnector);
    const { setDynamicWidgetView } = useWidgetContext();
    const { data: ens } = usePromise(() => getNameService(primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address), { deps: [primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.address], initialData: undefined });
    const ensName = (_a = ens === null || ens === void 0 ? void 0 : ens.name) !== null && _a !== void 0 ? _a : null;
    if (!primaryWallet) {
        return null;
    }
    const backButton = (jsxRuntimeExports.jsx(IconButton, { type: 'button', id: 'back-button', "data-testid": 'back-button', onClick: () => setDynamicWidgetView('choose-wallet-funding-method'), children: jsxRuntimeExports.jsx(SvgArrowLeft, {}) }));
    return (jsxRuntimeExports.jsxs("div", { className: 'deposit-view', children: [jsxRuntimeExports.jsx(ModalHeader, { leading: backButton, children: jsxRuntimeExports.jsx(Typography, { variant: 'title', children: t('dyn_deposit.title') }) }), jsxRuntimeExports.jsxs("div", { className: 'deposit-view__content', children: [jsxRuntimeExports.jsx(QRCode, { className: 'deposit-view__content__qr-code', value: primaryWallet.address, Icon: jsxRuntimeExports.jsx(SvgEmbeddedWalletIcon, {}), logoSize: 40, logoMargin: 64, size: 215 }), jsxRuntimeExports.jsxs("div", { className: 'deposit-view__content__address', children: [ensName && (jsxRuntimeExports.jsx(Typography, { className: 'deposit-view__content__address__ens', variant: 'title', children: ensName })), jsxRuntimeExports.jsxs("div", { className: 'deposit-view__content__address__wrapper', children: [jsxRuntimeExports.jsx(Typography, { "data-testid": 'deposit-view-address', variant: 'title', weight: 'medium', className: 'deposit-view__content__address__wrapper__text', children: shortenWalletAddress(primaryWallet.address, 3, 3) }), jsxRuntimeExports.jsx(CopyButton, { variant: 'text', textToCopy: primaryWallet.address, className: 'deposit-view__content__address__wrapper__copy', children: jsxRuntimeExports.jsx(SvgCopy, { "data-testid": 'copy-address' }) })] })] }), jsxRuntimeExports.jsxs(Typography, { className: 'deposit-view__content__network', variant: 'body_small', color: 'secondary', children: [t('dyn_deposit.receive_funds_on'), chain === null || chain === void 0 ? void 0 : chain.name] })] })] }));
};

const GlobalWalletScanner = ({ onScan, jsQR, }) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    useEffect(() => {
        const video = videoRef.current;
        const canvas = canvasRef.current;
        if (!video || !canvas)
            return;
        const ctx = canvas.getContext('2d');
        if (!ctx)
            return;
        const constraints = {
            video: { facingMode: 'environment' },
        };
        navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
            video.srcObject = stream;
            video.setAttribute('playsinline', 'true'); // required to tell iOS safari we don't want fullscreen
            video.play();
            requestAnimationFrame(tick);
        });
        const tick = () => {
            if (video.readyState === video.HAVE_ENOUGH_DATA) {
                canvas.height = video.videoHeight;
                canvas.width = video.videoWidth;
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height, {
                    inversionAttempts: 'dontInvert',
                });
                if (code) {
                    onScan(code.data);
                }
            }
            requestAnimationFrame(tick);
        };
        return () => {
            const stream = video.srcObject;
            const tracks = stream === null || stream === void 0 ? void 0 : stream.getTracks();
            tracks === null || tracks === void 0 ? void 0 : tracks.forEach((track) => track.stop());
        };
    }, [onScan]);
    return (jsxRuntimeExports.jsx("div", { children: jsxRuntimeExports.jsxs("div", { className: 'videoWrapper', children: [jsxRuntimeExports.jsx("video", { ref: videoRef, className: 'qrVideo' }), jsxRuntimeExports.jsx("canvas", { ref: canvasRef, style: { display: 'none' } })] }) }));
};

const GlobalWalletView = () => {
    var _a;
    const { t } = useTranslation();
    const { setDynamicWidgetView, goToInitialDynamicWidgetView } = useWidgetContext();
    const { pushView } = useViewContext();
    const { setShowAuthFlow } = useInternalDynamicContext();
    const { primaryWallet } = useDynamicContext();
    const [walletConnectUri, setWalletConnectUri] = useState('');
    const { environmentId } = useInternalDynamicContext();
    const [bannerMessage, setBannerMessage] = useState(null);
    const [isScanned, setIsScanned] = useState(false);
    const { globalWallet } = 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (_a = primaryWallet === null || primaryWallet === void 0 ? void 0 : primaryWallet.connector) !== null && _a !== void 0 ? _a : {};
    if (!globalWallet)
        throw new Error('Global Wallet not found');
    const showBanner = useCallback((message, type) => {
        setBannerMessage({ message, type });
        const timeout = type === 'success' ? 0 : 3000;
        setTimeout(() => {
            setBannerMessage(null);
        }, timeout);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const handleConfirmView = (pairingInfo) => {
        pushView('global-wallet-confirm', {
            onCancel: () => {
                setDynamicWidgetView('global-wallet');
                setShowAuthFlow(false, {
                    ignoreIfIsEmbeddedWidget: false,
                    performMultiWalletChecks: false,
                });
                setWalletConnectUri('');
            },
            onConfirm: () => __awaiter$1(void 0, void 0, void 0, function* () {
                var _a;
                try {
                    yield globalWallet.confirmPairing(true);
                    setDynamicWidgetView('global-wallet');
                    setShowAuthFlow(false, {
                        ignoreIfIsEmbeddedWidget: false,
                        performMultiWalletChecks: false,
                    });
                    setDynamicWidgetView('connected-apps', { name: pairingInfo.name });
                }
                catch (error) {
                    showBanner(t('global_wallet.banner.warning', {
                        name: (_a = pairingInfo.name) !== null && _a !== void 0 ? _a : t('global_wallet.the_dapp'),
                    }), 'error');
                }
            }),
            pairingInfo,
        });
        setShowAuthFlow(true, {
            ignoreIfIsEmbeddedWidget: false,
            performMultiWalletChecks: false,
        });
    };
    const popupConfirmView = () => __awaiter$1(void 0, void 0, void 0, function* () {
        const pendingPairing = globalWallet.getPendingPairing();
        if (!pendingPairing)
            throw new Error('No pending pairing');
        const { name, url, icons } = pendingPairing.params.proposer.metadata;
        const pairingInfo = { icons, name, url };
        const isDefinitelyMalicious = yield isMaliciousUrl({ environmentId, url });
        if (isDefinitelyMalicious || isDefinitelyMalicious === undefined) {
            pushView('global-wallet-malicious', {
                maliciousSiteInfo: {
                    isDefinitelyMalicious: isDefinitelyMalicious !== null && isDefinitelyMalicious !== void 0 ? isDefinitelyMalicious : false,
                    proceedFlow: () => handleConfirmView(pairingInfo),
                    url,
                },
            });
            setShowAuthFlow(true, {
                ignoreIfIsEmbeddedWidget: false,
                performMultiWalletChecks: false,
            });
        }
        else {
            handleConfirmView(pairingInfo);
        }
    });
    const handlePairing = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        if (!walletConnectUri.startsWith('wc:')) {
            showBanner(t('global_wallet.banner.bad_input'), 'error');
            return;
        }
        try {
            yield globalWallet.pairWithWC(walletConnectUri);
            globalWallet.getWeb3Wallet().on('session_proposal', popupConfirmView);
        }
        catch (error) {
            const errorMessage = String(error);
            if (errorMessage.includes('expired')) {
                showBanner(t('global_wallet.banner.expired'), 'error');
            }
            else if (errorMessage.includes('exists')) {
                showBanner(t('global_wallet.banner.already_connected', {
                    name: t('global_wallet.this_app'),
                }), 'success');
            }
            else {
                showBanner(t('global_wallet.banner.warning', {
                    name: t('global_wallet.the_dapp'),
                }), 'error');
            }
        }
    }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [walletConnectUri]);
    const handleScan = useCallback((result) => {
        if (result) {
            setIsScanned(true);
            setWalletConnectUri(result);
        }
    }, []);
    useEffect(() => {
        if (walletConnectUri.startsWith('wc:')) {
            handlePairing();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [walletConnectUri]);
    const renderHeader = () => (jsxRuntimeExports.jsxs("div", { className: 'header', children: [jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: goToInitialDynamicWidgetView, "data-testid": 'back-button', children: jsxRuntimeExports.jsx(SvgArrowLeft, {}) }), jsxRuntimeExports.jsx(Typography, { variant: 'title', weight: 'medium', color: 'primary', as: 'h1', copykey: 'global_wallet.connect_to_apps', children: t('global_wallet.connect_to_apps') }), isMobile() && (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: () => {
                    pushView('global-wallet-info');
                    setShowAuthFlow(true, {
                        ignoreIfIsEmbeddedWidget: false,
                        performMultiWalletChecks: false,
                    });
                }, "data-testid": 'info-button', children: jsxRuntimeExports.jsx(SvgQuestionMark, {}) }))] }));
    const renderScanner = () => isMobile() && (jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [jsxRuntimeExports.jsxs("div", { className: 'scanner-wrapper', children: [jsxRuntimeExports.jsx(GlobalWalletScanner, { onScan: handleScan, jsQR: globalWallet.qrScanner }), jsxRuntimeExports.jsxs("div", { className: 'scanner-overlay', children: [jsxRuntimeExports.jsxs("div", { className: 'scanner-frame', children: [jsxRuntimeExports.jsx("div", { className: 'corner top-left' }), jsxRuntimeExports.jsx("div", { className: 'corner top-right' }), jsxRuntimeExports.jsx("div", { className: 'corner bottom-left' }), jsxRuntimeExports.jsx("div", { className: 'corner bottom-right' })] }), jsxRuntimeExports.jsxs("div", { className: 'scanner-overlay-content', children: [jsxRuntimeExports.jsx(SvgBlueWalletconnect, { className: 'scanner-icon' }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'regular', color: 'white', copykey: 'global_wallet.scan_qr_code', children: t('global_wallet.scan_qr_code') })] })] })] }), jsxRuntimeExports.jsx(Divider, { text: t('global_wallet.or') })] }));
    const renderInput = () => (jsxRuntimeExports.jsxs("div", { className: 'wallet-connect-card', children: [jsxRuntimeExports.jsx("div", { className: 'input-group', children: jsxRuntimeExports.jsx(Input, { copykey: 'global_wallet.walletconnect_uri', id: 'walletconnect-uri', label: t('global_wallet.walletconnect_uri'), placeholder: 'wc:...', value: isScanned ? '' : walletConnectUri, onChange: (e) => {
                        setWalletConnectUri(e.target.value);
                        setIsScanned(false);
                    }, variant: 'dense' }) }), bannerMessage && (jsxRuntimeExports.jsx("div", { className: `banner ${bannerMessage.type}`, children: jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'regular', color: 'primary', children: bannerMessage.message }) }))] }));
    const renderInfoCard = () => !isMobile() && (jsxRuntimeExports.jsx("div", { className: 'info-card', children: jsxRuntimeExports.jsxs("div", { className: 'wrapper', children: [jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'bold', color: 'primary', as: 'h2', children: t('global_wallet.help.title') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'regular', color: 'secondary', children: t('global_wallet.help.step.1') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'regular', color: 'secondary', children: t('global_wallet.help.step.2') }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'regular', color: 'secondary', children: jsxRuntimeExports.jsxs("span", { className: 'inline-logo-text', children: ["3. Open WalletConnect", jsxRuntimeExports.jsx(SvgBlueWalletconnect, { className: 'inline-logo' }), " from the list"] }) }), jsxRuntimeExports.jsx(Typography, { variant: 'body_small', weight: 'regular', color: 'secondary', children: jsxRuntimeExports.jsxs("span", { className: 'inline-logo-text', children: ["4. Locate and click ", jsxRuntimeExports.jsx(SvgCopy, { className: 'inline-logo' }), " to copy the URI code"] }) })] }) }));
    return (jsxRuntimeExports.jsxs("div", { className: 'connect-dapps-view', children: [renderHeader(), renderScanner(), renderInput(), renderInfoCard()] }));
};

const MfaDeviceTileSkeleton = () => (jsxRuntimeExports.jsx("div", { className: 'mfa-device-skeleton', "data-testid": 'mfa-device-loading', children: jsxRuntimeExports.jsxs("div", { className: 'mfa-device-skeleton__details', children: [jsxRuntimeExports.jsx(Skeleton, {}), jsxRuntimeExports.jsx(Skeleton, {})] }) }));

var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SvgAuthenticator = function SvgAuthenticator(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 8.25a6 6 0 1 0-12 0 6 6 0 0 0 12 0Zm-3 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0Zm-9.37 3.892a7.512 7.512 0 0 0 2.005 2.237l-2.83 2.83 2.102 2.104-2.121 2.12-2.103-2.102-2.062 2.062L2.25 19.27l7.13-7.13Z",
    fill: "#ABACB2"
  })));
};

const UserDeviceTile = ({ userDevice, deleteDevice, isMfaRequired, }) => {
    const optionsMenu = [
        {
            Icon: null,
            callback: () => deleteDevice(userDevice.id),
            text: 'Delete',
        },
    ];
    const timeSinceCreated = userDevice.verifiedAt && getTimeSince(new Date(userDevice.verifiedAt));
    return (jsxRuntimeExports.jsxs("div", { className: 'manage-mfa-widget-view__list-tile', children: [jsxRuntimeExports.jsx(SvgAuthenticator, { className: 'manage-mfa-widget-view__list-tile__icon' }), jsxRuntimeExports.jsxs("div", { className: 'manage-mfa-widget-view__list-tile__details', children: [jsxRuntimeExports.jsx("div", { className: 'manage-mfa-widget-view__list-tile__details__title', children: jsxRuntimeExports.jsx(Typography, { variant: 'body_normal', color: 'primary', children: userDevice.alias || 'Authenticator App' }) }), timeSinceCreated && (jsxRuntimeExports.jsxs(Typography, { variant: 'body_small', color: 'secondary', children: ["Created ", timeSinceCreated.value, " ", timeSinceCreated.unit, " ago"] }))] }), isMfaRequired || (jsxRuntimeExports.jsx("div", { style: {
                    cursor: 'pointer',
                    display: 'flex',
                }, children: jsxRuntimeExports.jsx(DotsMenu, { direction: 'left', "data-testid": 'dots-menu', options: optionsMenu, buttonClassName: 'manage-mfa-widget-view__list-tile__dots-menu', buttonClassNameWithOpenMenu: 'manage-mfa-widget-view__list-tile__dots-menu' }) }))] }, userDevice.id));
};

const sortDevices = (devices) => { var _a; return (_a = devices === null || devices === void 0 ? void 0 : devices.sort(sortDevicesByVerifiedDateDesc).sort(sortDevicesByDefault)) !== null && _a !== void 0 ? _a : []; };
const sortDevicesByVerifiedDateDesc = (a, b) => {
    // doing null check for createdAt to avoid runtime error even though it should never be null/undefined
    const dateA = a.verifiedAt ? new Date(a.verifiedAt).getTime() : 0;
    const dateB = b.verifiedAt ? new Date(b.verifiedAt).getTime() : 0;
    return dateA - dateB;
};
const sortDevicesByDefault = (a, b) => a._default === b._default ? 0 : a._default ? -1 : 1;

const ManageMfaWidgetView = () => {
    var _a;
    const [userDevices, setUserDevices] = useState([]);
    const [mfaMethod, setMfaMethod] = useState();
    const [loading, setLoading] = useState(false);
    const { setDynamicWidgetView, dynamicWidgetView } = useWidgetContext();
    const { setShowMfaQRCode, setShowOTPVerification } = useDynamicModals();
    const { pushView } = useViewContext();
    const { getUserDevices, deleteUserDevice } = useMfa();
    const { t } = useTranslation();
    const { projectSettings, setShowAuthFlow } = useInternalDynamicContext();
    const isMfaRequired = Boolean((_a = projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.security.mfa) === null || _a === void 0 ? void 0 : _a.required);
    const getDevices = useCallback(() => __awaiter$1(void 0, void 0, void 0, function* () {
        setLoading(true);
        const devices = yield getUserDevices();
        // set the user devices with the default device first
        setUserDevices(sortDevices(devices));
        setLoading(false);
    }), [getUserDevices]);
    // re-fetch devices when a new device is added
    useDynamicEvents('mfaCompletionSuccess', (_b) => __awaiter$1(void 0, [_b], void 0, function* ({ mfaToken }) {
        if (mfaToken) {
            // we now require an MFA token to delete a device which is an async operation
            if ((mfaMethod === null || mfaMethod === void 0 ? void 0 : mfaMethod.action) === 'remove') {
                yield deleteUserDevice(mfaMethod.params.deviceId, mfaToken);
                setMfaMethod(undefined);
            }
        }
        getDevices();
    }));
    // delete device and then re-fetch devices
    const deleteDevice = (id) => __awaiter$1(void 0, void 0, void 0, function* () {
        setMfaMethod({ action: 'remove', params: { deviceId: id } });
        setShowOTPVerification(true);
    });
    // load devices on initial page load
    useEffectOnce(() => {
        getDevices();
    });
    const backButton = dynamicWidgetView === 'manage-mfa' ? (jsxRuntimeExports.jsx(IconButton, { type: 'button', onClick: () => setDynamicWidgetView('settings'), "data-testid": 'back-button', children: jsxRuntimeExports.jsx(SvgChevronLeft, {}) })) : undefined;
    const handleGenerateBackupCodes = () => __awaiter$1(void 0, void 0, void 0, function* () {
        setShowAuthFlow(true);
        pushView('mfa-display-backup-codes', { regenerateCodes: true });
    });
    return (jsxRuntimeExports.jsxs("div", { className: 'manage-mfa-widget-view', children: [jsxRuntimeExports.jsx(ModalHeader, { leading: backButton, children: jsxRuntimeExports.jsx("div", { className: 'send-balance-page-layout__header-content', children: jsxRuntimeExports.jsx(Typography, { variant: 'title', color: 'primary', copykey: 'dyn_manage_mfa.title', children: t('dyn_manage_mfa.title') }) }) }), jsxRuntimeExports.jsxs("div", { className: 'manage-mfa-widget-view__scroll-container', children: [loading && jsxRuntimeExports.jsx(MfaDeviceTileSkeleton, {}), !loading && userDevices.length === 0 && (jsxRuntimeExports.jsx(Typography, { className: 'manage-mfa-widget-view__no-devices', variant: 'body_normal', color: 'secondary', copykey: 'dyn_manage_mfa.no_devices', children: t('dyn_manage_mfa.no_devices') })), userDevices.map((device, index) => (jsxRuntimeExports.jsx(UserDeviceTile, { isMfaRequired: isMfaRequired, userDevice: device, index: index, deleteDevice: deleteDevice }, device.id)))] }), jsxRuntimeExports.jsx("div", { className: 'manage-mfa-widget-view__add-mfa-button-container', children: userDevices.length > 0 ? (jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'manage-mfa-widget-view__add-mfa-button-container__button', onClick: handleGenerateBackupCodes, copykey: 'dyn_manage_mfa.generate_backup_codes_button', children: t('dyn_manage_mfa.generate_backup_codes_button') })) : (jsxRuntimeExports.jsx(TypographyButton, { buttonClassName: 'manage-mfa-widget-view__add-mfa-button-container__button', onClick: () => setShowMfaQRCode(true), copykey: 'dyn_manage_mfa.add_mfa_button', startSlot: jsxRuntimeExports.jsx(SvgAdd, {}), children: t('dyn_manage_mfa.add_mfa_button') })) })] }));
};

const mapViewToComponent = {
    'choose-onramp-provider': ChooseOnrampProviderView,
    'choose-wallet-funding-method': ChooseWalletFundingMethod,
    'connected-apps': ConnectedAppsView,
    'deposit-view': DepositView,
    'edit-profile': EditProfileView,
    'global-wallet': GlobalWalletView,
    'manage-mfa': ManageMfaWidgetView,
    'manage-mfa-no-footer': ManageMfaWidgetView,
    'manage-passkeys': ManagePasskeysWidgetView,
    profile: ProfileView,
    'receive-external-wallet-funds': ReceiveExternalWalletFunds,
    'send-balance': SendBalanceWidgetView,
    settings: SettingsView,
    wallets: WalletsView,
};

const DynamicWidgetViews = () => {
    const { dynamicWidgetView, viewProps } = useWidgetContext();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ViewComponent = mapViewToComponent[dynamicWidgetView] || mapViewToComponent.wallets;
    return jsxRuntimeExports.jsx(ViewComponent, Object.assign({}, viewProps));
};

const DynamicSettingsViews = ['settings'];
const DynamicGlobalWalletViews = [
    'global-wallet',
    'connected-apps',
];
const DynamicPasskeyWidgetViews = ['manage-passkeys'];
const DynamicMfaWidgetViews = [
    'manage-mfa',
    'manage-mfa-no-footer',
];
const DynamicTransactionsWidgetViews = ['send-balance'];

const shouldNotRenderHeaderViews = [
    ...DynamicPasskeyWidgetViews,
    ...DynamicTransactionsWidgetViews,
    ...DynamicMfaWidgetViews,
    ...DynamicSettingsViews,
    ...DynamicGlobalWalletViews,
    'receive-external-wallet-funds',
    'choose-wallet-funding-method',
    'deposit-view',
    'choose-onramp-provider',
];
/**
 * Which views should not render the bottom navbar options
 */
const shouldNotRenderBottomNavBarOptions = [
    'receive-external-wallet-funds',
    'choose-wallet-funding-method',
    'deposit-view',
    'choose-onramp-provider',
    'manage-mfa-no-footer',
];
const DynamicUserProfileLayout = ({ variant, className, style, }) => {
    const { multiWallet } = useInternalDynamicContext();
    const isKYCEnabled = useKYCFlag();
    const { dynamicWidgetView, setDynamicWidgetView, overridenWidgetView } = useWidgetContext();
    const getNavBarOptions = () => {
        const options = [];
        if (multiWallet) {
            options.push({
                icon: jsxRuntimeExports.jsx(SvgWalletOutlineV2, {}),
                label: 'Wallets',
                value: 'wallets',
            });
        }
        if (isKYCEnabled) {
            options.push({
                icon: jsxRuntimeExports.jsx(SvgProfileOutline, {}),
                label: 'Profile',
                value: 'profile',
            });
        }
        options.push({
            icon: jsxRuntimeExports.jsx(SvgSettingsOutline, {}),
            label: 'Settings',
            value: 'settings',
        });
        return options;
    };
    // It should render header only if the view is not send-balance or one of passkey widgets view
    const shouldRenderHeader = !shouldNotRenderHeaderViews.includes(dynamicWidgetView);
    const shouldRenderOptionsSwitcher = (multiWallet || isKYCEnabled) &&
        !shouldNotRenderBottomNavBarOptions.includes(dynamicWidgetView);
    return (jsxRuntimeExports.jsx(OverlayCardTarget, { children: jsxRuntimeExports.jsxs("div", { className: classNames(className, 'dynamic-user-profile-layout'), style: style, children: [shouldRenderHeader && jsxRuntimeExports.jsx(MemoizedDynamicWidgetHeader, { variant: variant }), jsxRuntimeExports.jsx(DynamicWidgetViews, {}), jsxRuntimeExports.jsx(DynamicWidgetPrompts, {}), shouldRenderOptionsSwitcher && (jsxRuntimeExports.jsx(BottomNavBar, { value: overridenWidgetView, onChange: (view) => setDynamicWidgetView(view), options: getNavBarOptions() }))] }) }));
};

const DynamicUserProfile = ({ variant, }) => {
    const { projectSettings, setShowDynamicUserProfile, showAuthFlow } = useInternalDynamicContext();
    const { setIsOpen, isOpen, widgetRef, inlineControlsRef } = useWidgetContext();
    const _variant = useMemo(() => {
        if (isMobile()) {
            return 'modal';
        }
        return variant;
    }, [variant]);
    // Use the same method to close the widget on outside click as in DynamicWidget
    const closeOnOutsideClick = useCallback((e) => {
        var _a;
        const target = e.composedPath().shift();
        if ((_a = inlineControlsRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))
            return;
        if (variant === 'dropdown' && !showAuthFlow) {
            setShowDynamicUserProfile(false);
        }
    }, [inlineControlsRef, variant, showAuthFlow, setShowDynamicUserProfile]);
    useOnClickOutside(widgetRef, closeOnOutsideClick);
    const shouldRenderUserProfile = Boolean(projectSettings);
    useRegisterWidget('user-profile', shouldRenderUserProfile);
    if (!shouldRenderUserProfile)
        return null;
    return (jsxRuntimeExports.jsx(IsBrowser, { children: jsxRuntimeExports.jsx(PopperProvider, { children: jsxRuntimeExports.jsx(DynamicWidgetVariants, { isOpen: isOpen, setIsOpen: setIsOpen, variant: _variant, zIndex: widgetModalZIndex, children: jsxRuntimeExports.jsx(SandboxIndicatorWrapper, { children: jsxRuntimeExports.jsx(DynamicWidgetCard, { ref: widgetRef, children: jsxRuntimeExports.jsx(DynamicUserProfileLayout, { variant: variant }) }) }) }) }) }));
};
const ShadowedDynamicUserProfile = ({ variant, }) => (jsxRuntimeExports.jsx(ShadowDOM, { zIndex: widgetModalZIndex, children: jsxRuntimeExports.jsx(DynamicUserProfile, { variant: variant }) }));

assertPackageVersion('@dynamic-labs/sdk-react-core', version$4);

const Strings = {
    SignIn: {
        en: 'Sign in',
        ja: 'サインイン',
    },
    PleaseConnectWallet: {
        en: 'Connect your wallet',
        ja: 'ウォレットにも接続してください',
    },
    SwitchChain: {
        en: ([chain]) => `Switch to
    ${chain === '137'
            ? 'Polygon'
            : chain === '1'
                ? 'Ethereum'
                : `Chain#${chain}`}`,
        ja: ([chain]) => `
    ${chain === '137'
            ? 'Polygon'
            : chain === '1'
                ? 'Ethereum'
                : `Chain#${chain}`} に切り替えください`,
    },
};

var NetworkError = ({ chainId }) => {
    const i18nBase = useMemo(() => i18nFactory(Strings), [Strings]);
    const i18n = useMemo(() => i18nBase(window.navigator.languages), [typeof window !== 'undefined' && window.navigator.languages]);
    return (jsxRuntimeExports.jsxs("span", { className: "bg-dp-red-400 absolute top-[100%] -mt-1 flex w-full items-center justify-center gap-2 rounded-b-lg p-1 pt-2 text-center text-xs text-white", children: [jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "h-4 w-4", children: jsxRuntimeExports.jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" }) }), i18n('SwitchChain', [String(chainId)])] }));
};

function _isPlaceholder(a) {
  return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}

/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */
function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
          return fn(a, _b);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}

function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}

function _includesWith(pred, x, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}

function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}

function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function _objectIs(a, b) {
  // SameValue algorithm
  if (a === b) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
}
var _objectIs$1 = typeof Object.is === 'function' ? Object.is : _objectIs;

var toString = Object.prototype.toString;
var _isArguments = /*#__PURE__*/function () {
  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return _has('callee', x);
  };
}();

// cover IE < 9 keys issues
var hasEnumBug = ! /*#__PURE__*/{
  toString: null
}.propertyIsEnumerable('toString');
var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
// Safari bug
var hasArgsEnumBug = /*#__PURE__*/function () {

  return arguments.propertyIsEnumerable('length');
}();
var contains = function contains(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};

/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */
var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? /*#__PURE__*/_curry1(function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/_curry1(function keys(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
  for (prop in obj) {
    if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
      ks[ks.length] = prop;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop = nonEnumerableProps[nIdx];
      if (_has(prop, obj) && !contains(ks, prop)) {
        ks[ks.length] = prop;
      }
      nIdx -= 1;
    }
  }
  return ks;
});

/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig * -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(async () => {}); //=> "AsyncFunction"
 *      R.type(undefined); //=> "Undefined"
 *      R.type(BigInt(123)); //=> "BigInt"
 */
var type = /*#__PURE__*/_curry1(function type(val) {
  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});

/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparison of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */

function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a = _arrayFromIterator(aIterator);
  var b = _arrayFromIterator(bIterator);
  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  }

  // if *a* array contains any element that is not included in *b*
  return !_includesWith(function (b, aItem) {
    return !_includesWith(eq, aItem, b);
  }, b, a);
}
function _equals(a, b, stackA, stackB) {
  if (_objectIs$1(a, b)) {
    return true;
  }
  var typeA = type(a);
  if (typeA !== type(b)) {
    return false;
  }
  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }
  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
  }
  switch (typeA) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
        return a === b;
      }
      break;
    case 'Boolean':
    case 'Number':
    case 'String':
      if (!(typeof a === typeof b && _objectIs$1(a.valueOf(), b.valueOf()))) {
        return false;
      }
      break;
    case 'Date':
      if (!_objectIs$1(a.valueOf(), b.valueOf())) {
        return false;
      }
      break;
    case 'Error':
      return a.name === b.name && a.message === b.message;
    case 'RegExp':
      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
        return false;
      }
      break;
  }
  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }
    idx -= 1;
  }
  switch (typeA) {
    case 'Map':
      if (a.size !== b.size) {
        return false;
      }
      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
    case 'Set':
      if (a.size !== b.size) {
        return false;
      }
      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
    case 'Arguments':
    case 'Array':
    case 'Object':
    case 'Boolean':
    case 'Number':
    case 'String':
    case 'Date':
    case 'Error':
    case 'RegExp':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'ArrayBuffer':
      break;
    default:
      // Values of other types are only equal if identical.
      return false;
  }
  var keysA = keys(a);
  if (keysA.length !== keys(b).length) {
    return false;
  }
  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b]);
  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}

/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */
var equals = /*#__PURE__*/_curry2(function equals(a, b) {
  return _equals(a, b, [], []);
});

var version = "4.6.1";

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Gets the Web3 provider of an ethereum wallet.
 *
 * If the wallet is NOT an Ethereum wallet, this will reject.
 */
const getWeb3Provider = (wallet) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if (!isEthereumWallet(wallet)) {
        throw new Error(`getWeb3Provider must be called with an Ethereum wallet, but wallet was of chain ${wallet.chain}`);
    }
    const publicClient = yield wallet.getPublicClient();
    const walletClient = yield wallet.getWalletClient();
    if (!publicClient || !walletClient) {
        throw new Error('Wallet is not connected, cannot create ethers provider');
    }
    const { chain } = publicClient;
    const network = {
        chainId: chain === null || chain === void 0 ? void 0 : chain.id,
        ensAddress: (_b = (_a = chain === null || chain === void 0 ? void 0 : chain.contracts) === null || _a === void 0 ? void 0 : _a.ensRegistry) === null || _b === void 0 ? void 0 : _b.address,
        name: chain === null || chain === void 0 ? void 0 : chain.name,
    };
    return new BrowserProvider(walletClient.transport, network);
});

/**
 * Gets a signer for an ethereum wallet.
 *
 * If the wallet is NOT an Ethereum wallet, this will reject.
 */
const getSigner = (wallet) => __awaiter(void 0, void 0, void 0, function* () {
    if (!isEthereumWallet(wallet))
        throw new Error(`getSigner must be called with an Ethereum wallet, but wallet was of chain ${wallet.chain}`);
    const provider = yield getWeb3Provider(wallet);
    return provider.getSigner(wallet.address);
});

assertPackageVersion('@dynamic-labs/ethers-v6', version);

/* eslint-disable functional/prefer-immutable-types */
var Clubs = ({ size = 6 }) => (jsxRuntimeExports.jsxs("svg", { width: "132", height: "132", viewBox: "0 0 132 132", fill: "none", className: `w-${size} h-${size}`, xmlns: "http://www.w3.org/2000/svg", children: [jsxRuntimeExports.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M0 95.3301C0 83.1801 9.85 73.3301 22 73.3301H36.67C48.82 73.3301 58.67 83.1801 58.67 95.3301V110C58.67 122.15 48.82 132 36.67 132H22C9.85 132 0 122.15 0 110V95.3301ZM22 88.0001C17.95 88.0001 14.67 91.2801 14.67 95.3301V110C14.67 114.05 17.95 117.33 22 117.33H36.67C40.72 117.33 44 114.05 44 110V95.3301C44 91.2801 40.72 88.0001 36.67 88.0001H22Z", fill: "#5B8BF5" }), jsxRuntimeExports.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M102.67 73.3301C106.72 73.3301 110 76.6101 110 80.6601V95.3301H124.67C128.72 95.3301 132 98.6101 132 102.66C132 106.71 128.72 109.99 124.67 109.99H110V124.66C110 128.71 106.72 131.99 102.67 131.99C98.62 131.99 95.34 128.71 95.34 124.66V110H80.67C76.62 110 73.34 106.72 73.34 102.67C73.34 98.6201 76.62 95.3401 80.67 95.3401H95.34V80.6701C95.33 76.6201 98.62 73.3301 102.67 73.3301Z", fill: "#FF3815" }), jsxRuntimeExports.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M73.33 22C73.33 9.85 83.18 0 95.33 0H110C122.15 0 132 9.85 132 22V36.67C132 48.82 122.15 58.67 110 58.67H95.33C83.18 58.67 73.33 48.82 73.33 36.67V22ZM95.33 14.67C91.28 14.67 88 17.95 88 22V36.67C88 40.72 91.28 44 95.33 44H110C114.05 44 117.33 40.72 117.33 36.67V22C117.33 17.95 114.05 14.67 110 14.67H95.33Z", fill: "#00D0FD" }), jsxRuntimeExports.jsx("g", { filter: "url(#filter0_i_524_3)", children: jsxRuntimeExports.jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M0 22C0 9.85 9.85 0 22 0H36.67C48.82 0 58.67 9.85 58.67 22V36.67C58.67 48.82 48.82 58.67 36.67 58.67H22C9.85 58.67 0 48.82 0 36.67V22ZM22 14.67C17.95 14.67 14.67 17.95 14.67 22V36.67C14.67 40.72 17.95 44 22 44H36.67C40.72 44 44 40.72 44 36.67V22C44 17.95 40.72 14.67 36.67 14.67H22Z", fill: "#D500E6" }) }), jsxRuntimeExports.jsx("defs", { children: jsxRuntimeExports.jsxs("filter", { id: "filter0_i_524_3", x: "0", y: "0", width: "58.67", height: "58.6699", filterUnits: "userSpaceOnUse", "color-interpolation-filters": "sRGB", children: [jsxRuntimeExports.jsx("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }), jsxRuntimeExports.jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), jsxRuntimeExports.jsx("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), jsxRuntimeExports.jsx("feOffset", { dx: "2", dy: "2" }), jsxRuntimeExports.jsx("feComposite", { in2: "hardAlpha", operator: "arithmetic", k2: "-1", k3: "1" }), jsxRuntimeExports.jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.835294 0 0 0 0 0 0 0 0 0 0.901961 0 0 0 1 0" }), jsxRuntimeExports.jsx("feBlend", { mode: "normal", in2: "shape", result: "effect1_innerShadow_524_3" })] }) })] }));

function isFunction(value) {
    return typeof value === 'function';
}

function createErrorClass(createImpl) {
    var _super = function (instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

var UnsubscriptionError = createErrorClass(function (_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors
            ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ')
            : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

var Subscription = (function () {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function () {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) {
                    try {
                        for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
                            var parent_1 = _parentage_1_1.value;
                            parent_1.remove(this);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                else {
                    _parentage.remove(this);
                }
            }
            var initialFinalizer = this.initialTeardown;
            if (isFunction(initialFinalizer)) {
                try {
                    initialFinalizer();
                }
                catch (e) {
                    errors = e instanceof UnsubscriptionError ? e.errors : [e];
                }
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
                        var finalizer = _finalizers_1_1.value;
                        try {
                            execFinalizer(finalizer);
                        }
                        catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof UnsubscriptionError) {
                                errors = __spreadArray(__spreadArray([], __read(errors)), __read(err.errors));
                            }
                            else {
                                errors.push(err);
                            }
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            if (errors) {
                throw new UnsubscriptionError(errors);
            }
        }
    };
    Subscription.prototype.add = function (teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) {
                execFinalizer(teardown);
            }
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) {
                        return;
                    }
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function (parent) {
        var _parentage = this._parentage;
        return _parentage === parent || (Array.isArray(_parentage) && _parentage.includes(parent));
    };
    Subscription.prototype._addParent = function (parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
    };
    Subscription.prototype._removeParent = function (parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) {
            this._parentage = null;
        }
        else if (Array.isArray(_parentage)) {
            arrRemove(_parentage, parent);
        }
    };
    Subscription.prototype.remove = function (teardown) {
        var _finalizers = this._finalizers;
        _finalizers && arrRemove(_finalizers, teardown);
        if (teardown instanceof Subscription) {
            teardown._removeParent(this);
        }
    };
    Subscription.EMPTY = (function () {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    })();
    return Subscription;
}());
Subscription.EMPTY;
function isSubscription(value) {
    return (value instanceof Subscription ||
        (value && 'closed' in value && isFunction(value.remove) && isFunction(value.add) && isFunction(value.unsubscribe)));
}
function execFinalizer(finalizer) {
    if (isFunction(finalizer)) {
        finalizer();
    }
    else {
        finalizer.unsubscribe();
    }
}

var timeoutProvider = {
    setTimeout: function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        return setTimeout.apply(void 0, __spreadArray([handler, timeout], __read(args)));
    },
    clearTimeout: function (handle) {
        return (clearTimeout)(handle);
    },
    delegate: undefined,
};

function reportUnhandledError(err) {
    timeoutProvider.setTimeout(function () {
        {
            throw err;
        }
    });
}

function noop() { }

var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if (isSubscription(destination)) {
                destination.add(_this);
            }
        }
        else {
            _this.destination = EMPTY_OBSERVER;
        }
        return _this;
    }
    Subscriber.create = function (next, error, complete) {
        return new SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function (value) {
        if (this.isStopped) ;
        else {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (this.isStopped) ;
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (this.isStopped) ;
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        try {
            this.destination.error(err);
        }
        finally {
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function () {
        try {
            this.destination.complete();
        }
        finally {
            this.unsubscribe();
        }
    };
    return Subscriber;
}(Subscription));
var ConsumerObserver = (function () {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function (value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) {
            try {
                partialObserver.next(value);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    ConsumerObserver.prototype.error = function (err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) {
            try {
                partialObserver.error(err);
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
        else {
            handleUnhandledError(err);
        }
    };
    ConsumerObserver.prototype.complete = function () {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) {
            try {
                partialObserver.complete();
            }
            catch (error) {
                handleUnhandledError(error);
            }
        }
    };
    return ConsumerObserver;
}());
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if (isFunction(observerOrNext) || !observerOrNext) {
            partialObserver = {
                next: (observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined),
                error: error !== null && error !== void 0 ? error : undefined,
                complete: complete !== null && complete !== void 0 ? complete : undefined,
            };
        }
        else {
            {
                partialObserver = observerOrNext;
            }
        }
        _this.destination = new ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}(Subscriber));
function handleUnhandledError(error) {
    {
        reportUnhandledError(error);
    }
}
function defaultErrorHandler(err) {
    throw err;
}
var EMPTY_OBSERVER = {
    closed: true,
    next: noop,
    error: defaultErrorHandler,
    complete: noop,
};

function hasLift(source) {
    return isFunction(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
    return function (source) {
        if (hasLift(source)) {
            return source.lift(function (liftedSource) {
                try {
                    return init(liftedSource, this);
                }
                catch (err) {
                    this.error(err);
                }
            });
        }
        throw new TypeError('Unable to lift unknown Observable type');
    };
}

function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = (function (_super) {
    __extends(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext
            ? function (value) {
                try {
                    onNext(value);
                }
                catch (err) {
                    destination.error(err);
                }
            }
            : _super.prototype._next;
        _this._error = onError
            ? function (err) {
                try {
                    onError(err);
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._error;
        _this._complete = onComplete
            ? function () {
                try {
                    onComplete();
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function () {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
        }
    };
    return OperatorSubscriber;
}(Subscriber));

function scanInternals(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function (source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe(createOperatorSubscriber(subscriber, function (value) {
            var i = index++;
            state = hasState
                ?
                    accumulator(state, value, i)
                :
                    ((hasState = true), value);
            subscriber.next(state);
        }, emitBeforeComplete));
    };
}

function scan(accumulator, seed) {
    return operate(scanInternals(accumulator, seed, arguments.length >= 2, true));
}

const CALLED = '_CALLED_SIGNAL_SUBSCRIBE_';
var Button = ({ chainId, overrideClass, buttonClassName, }) => {
    const dynamic = useDynamicContext();
    const [signer, setSigner] = useState();
    const [connection, setConnection] = useState();
    const [walletName, setWalletName] = useState();
    const [isWalletNeeded, setIsWalletNeeded] = useState(false);
    const [isUnexpectedNetwork, setUnexpectedNetwork] = useState(false);
    const [profile, setProfile] = useState();
    const { openWallet } = useWalletItemActions();
    const i18nBase = useMemo(() => i18nFactory(Strings), [Strings]);
    const i18n = useMemo(() => i18nBase(window.navigator.languages), [typeof window !== 'undefined' && window.navigator.languages]);
    console.log({ dynamic });
    const loggedIn = useMemo(() => dynamic?.user !== undefined, [dynamic?.user]);
    useEffect(() => {
        import('@devprotocol/clubs-core/connection').then((it) => {
            setConnection(it.connection());
        });
    }, []);
    useEffect(() => {
        const cryptoWallet = dynamic.user?.verifiedCredentials.find((c) => c.format === 'blockchain' && Boolean(c.embeddedWalletId));
        if (cryptoWallet) {
            /**
             * If a user initially logged in using their wallet and later connected a social account,
             * Dynamic will not function as a wallet for subsequent logins using the social account as the first step.
             * Therefore, in that case, users need to connect their wallet after the social account.
             */
            setIsWalletNeeded(Boolean(!dynamic.primaryWallet));
            setWalletName(cryptoWallet.walletName);
        }
        if (dynamic.primaryWallet) {
            getSigner(dynamic.primaryWallet).then((_signer) => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-expect-error
                const same = equals(_signer, signer);
                // console.log('Called here', same)
                // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                !same && setSigner(_signer);
            });
        }
        else {
            setSigner(undefined);
        }
    }, [dynamic.primaryWallet, dynamic.user]);
    useEffect(() => {
        if (dynamic.network === undefined)
            return;
        const connectedChain = Number(dynamic.network);
        setUnexpectedNetwork(typeof chainId === 'number' && connectedChain !== chainId);
        whenDefinedAll([connection], ([_connection]) => _connection.chain.next(Number(dynamic.network)));
    }, [dynamic.network, connection]);
    useEffect(() => {
        const emailCredential = dynamic.user?.verifiedCredentials?.find((c) => c.format === 'email');
        console.log('**', { emailCredential });
        whenDefinedAll([connection], ([_connection]) => _connection.identifiers.next(whenDefined(emailCredential?.publicIdentifier, (email) => ({
            email,
        }))));
    }, [dynamic.user, connection]);
    useEffect(() => {
        const eoa = dynamic?.primaryWallet?.address;
        if (eoa) {
            fetch(`https://clubs.place/api/profile/${eoa}`)
                .then((res) => res.json())
                .then(setProfile);
        }
        else {
            setProfile(undefined);
        }
    }, [dynamic?.primaryWallet?.address]);
    useEffect(() => {
        whenDefinedAll([connection], ([_connection]) => {
            // console.log('Called here', signer)
            _connection.signer.next(signer);
        });
    }, [signer, connection]);
    useEffect(() => {
        whenDefinedAll([connection], ([_connection]) => {
            // console.log('$$$ Called here', signer)
            // signal
            _connection.signal
                .pipe(scan((total, n) => (n === CALLED ? total + 1 : total), 0))
                .subscribe((calledCount) => {
                // Subscribe only once globally
                if (calledCount === 0) {
                    _connection.signal.next(CALLED);
                    _connection.signal.subscribe((signal) => {
                        if (signal === Signal.SignInRequest) {
                            dynamic.setShowAuthFlow(true);
                        }
                        if (signal === Signal.SignOutRequest) {
                            dynamic.handleLogOut();
                        }
                    });
                    // sub.unsubscribe()
                }
            });
        });
    }, [connection]);
    return (jsxRuntimeExports.jsxs("span", { className: "group/awesome-onboarding relative block", children: [loggedIn && isUnexpectedNetwork && (jsxRuntimeExports.jsx(NetworkError, { chainId: chainId ?? 137 })), dynamic?.primaryWallet?.address && (jsxRuntimeExports.jsx("span", { className: "absolute bottom-0 left-1/2 block w-full -translate-x-1/2 opacity-0 transition-all delay-300 group-hover/awesome-onboarding:-bottom-1/2 group-hover/awesome-onboarding:opacity-100", children: jsxRuntimeExports.jsxs("a", { className: "hs-button is-small is-fullwidth is-filled flex gap-2 pt-4 text-xs", href: `https://clubs.place/passport/${dynamic.primaryWallet.address}`, target: "_blank", rel: "noreferrer noopener", children: [jsxRuntimeExports.jsx(Clubs, { size: 4 }), "Passport"] }) })), jsxRuntimeExports.jsx("button", { className: `${overrideClass
                    ? overrideClass
                    : 'hs-button is-filled is-large is-fullwidth relative data-[is-loading=true]:animate-pulse'} ${loggedIn && isUnexpectedNetwork ? 'is-error' : ''} ${buttonClassName}`, onClick: () => loggedIn
                    ? isWalletNeeded && walletName
                        ? openWallet(walletName)
                        : dynamic.setShowDynamicUserProfile(true)
                    : dynamic.setShowAuthFlow(true), children: loggedIn && profile ? (jsxRuntimeExports.jsxs("span", { className: "flex items-center gap-2", children: [jsxRuntimeExports.jsx("img", { src: profile.avatar, className: "h-6 w-6 rounded-full object-cover" }), jsxRuntimeExports.jsx("span", { className: "font-bold text-inherit", children: profile.username })] })) : loggedIn && isWalletNeeded ? (i18n('PleaseConnectWallet')) : loggedIn ? (jsxRuntimeExports.jsx("span", { title: "Loading the profile...", className: "h-6 w-full min-w-24 animate-pulse rounded-xl bg-gray-500/60" })) : (i18n('SignIn')) }), jsxRuntimeExports.jsx(ShadowedDynamicUserProfile, {})] }));
    /* Using <DynamicWidget /> */
    // return (
    // 	<div className="relative grid grid-flow-col items-center gap-1">
    // 		{loggedIn && isUnexpectedNetwork && <NetworkError chainId={chainId} />}
    // 		<DynamicWidget
    // 			buttonClassName={buttonClassName}
    // 			buttonContainerClassName={buttonContainerClassName}
    // 		/>
    // 		{loggedIn && isWalletNeeded && walletName && (
    // 			<button
    // 				onClick={() => openWallet(walletName)}
    // 				className="hs-button is-small is-filled"
    // 			>
    // 				{i18n('PleaseConnectWallet')}
    // 			</button>
    // 		)}
    // 	</div>
    // )
};

// The English translation is here: node_modules/@dynamic-labs/sdk-react-core/src/lib/locale/en/translation.js.
var en = {
    /**
   * @description copy keys for account exists view
   * @default
   * {
        connect: 'Connect with {{socialOauth}}',
        description: 'It looks like an account already exists using',
        title: 'Account already exists',
        trail_message_email: '. Please log in with your email.',
        trail_message_social: 'through {{socialOauth}}',
      }
   */
    dyn_sandbox_maximum_threshold: {
        title: 'Max User Limit Reached',
        description: 'Your sandbox environment has reached your 100 MAU limit. To test with new users, delete existing users.',
        button: 'Back',
    },
    dyn_account_exists: {
        connect: 'Connect with {{socialOauth}}',
        description_email: 'It looks like an account already exists using',
        description_social: 'To restore your account to the right place, we need you to log in again.',
        title: 'Re-Authentication Required',
        trail_message_email: '. Please log in with your email.',
        trail_message_social: 'through {{socialOauth}}',
    },
    /**
   * @description copy keys for active wallet information (address, network, etc)
   * @default
   * {
        testnet_warning: 'A testnet network has been selected. Please only use testnet funds or they will be lost.',
        ordinals_address: 'Ordinals address',
        payment_address: 'Payment address',
        balance: 'Balance',
        options: {
          copy_ens: 'Copy ENS',
          view_address: 'View address',
          settings: 'Wallet settings',
          export: 'Export private keys',
        },
      }
   */
    dyn_active_wallet_info: {
        testnet_warning: 'A testnet network has been selected. Please only use testnet funds or they will be lost.',
        ordinals_address: 'Ordinals address',
        payment_address: 'Payment address',
        balance: 'Balance',
        options: {
            copy_ens: 'Copy ENS',
            view_address: 'View address',
            settings: 'Wallet settings',
            export: 'Export private keys',
        },
    },
    /**
   * @description copy keys for wallet details card
   * @default
   * {
        header: 'Wallet Details',
        address: 'Address',
        copy: 'Copy',
        copied: 'Copied!',
     }
   */
    dyn_wallet_details_card: {
        header: 'Wallet Details',
        address: 'Address',
        copy: 'Copy',
        copied: 'Copied!',
    },
    /**
   * @description copy keys for add network view
   * @default
   * {
      title: 'Add {{name}} network to your wallet',
      add_button: {
        title: 'Add network',
      },
      cancel_button: {
        title: 'Cancel',
      },
    }
   */
    dyn_add_network_view: {
        title: 'Network unavailable',
        description: 'This network is not supported in your {{name}} wallet.',
        add_button: {
            title: 'Add Network',
        },
        cancel_button: {
            title: 'Cancel',
        },
    },
    /**
   * @description copy keys for bridge view
   * @default
   * {
        summary_view: {
          connection_succeed: 'Congratulations on connecting both your {{firstBlockchainName}} and {{secondBlockchainName}} wallets',
          title: 'Welcome to {{appName}}',
        },
        welcome_view: {
          button: 'Get started',
          description: 'You’ll need to connect both your {{firstBlockchainName}} and {{secondBlockchainName}} wallets to get started',
          title: 'Connect to {{appName}}',
        },
        widget: {
          address: 'Copy wallet address',
          connect: 'Connect wallet',
          connect_with_network: 'Connect {{blockchainName}} wallet',
          copy: {
            address: 'Copy wallet address',
            ens: 'Copy ENS',
          },
          disconnect: 'Disconnect',
          edit_profile: 'Edit profile',
          wallet_network: '{{networkName}} wallet',
        },
      }
   */
    dyn_bridge: {
        summary_view: {
            connection_succeed: 'Congratulations on connecting both your {{firstBlockchainName}} and {{secondBlockchainName}} wallets',
            title: 'Welcome to {{appName}}',
        },
        welcome_view: {
            button: 'Get started',
            description: 'You’ll need to connect both your {{firstBlockchainName}} and {{secondBlockchainName}} wallets to get started',
            title: 'Connect to {{appName}}',
        },
        widget: {
            address: 'Copy wallet address',
            connect: 'Connect wallet',
            connect_with_network: 'Connect {{blockchainName}} wallet',
            copy: {
                address: 'Copy wallet address',
                ens: 'Copy ENS',
            },
            disconnect: 'Disconnect',
            edit_profile: 'Edit profile',
            wallet_network: '{{networkName}} wallet',
        },
    },
    /**
   * @description copy keys for Dynamic Captcha
   * @default
   * {
      verify_user_subtitle: 'We need to quickly verify you’re human before we proceed.',
      verify_user_title: "Let's verify you're human",
    }
   */
    dyn_captcha: {
        verify_user_subtitle: 'We need to quickly verify you’re human before we proceed.',
        verify_user_title: "Let's verify you're human",
    },
    /**
     * @description copy keys for sanctioned access blocked view
     * @default
     * {
     *  title: 'Access Blocked',
     *  content: 'Logging in is not available to persons in {{jurisdiction}} as you are in a sanctioned jurisdiction.',
     * }
     */
    dyn_access_blocked: {
        title: 'Access Blocked',
        content: 'Logging in is not available to persons in {{jurisdiction}} as you are in a sanctioned jurisdiction.',
    },
    /**
   * @description copy keys for chainalysis blocked wallet view
   * @default
   * {
       title: 'Access denied',
     }
   */
    dyn_chainalysis_blocked_wallet: {
        title: 'Access denied',
    },
    /**
   * @description copy keys for collecting user data
   * @default
   * {
      description: 'We need a bit of information to get started',
      fields: {
        alias: {
          label: 'Alias',
        },
        country: {
          label: 'Country',
        },
        email: {
          label: 'Email',
          validation: 'Email is not valid',
        },
        first_name: {
          label: 'First Name',
        },
        job_title: {
          label: 'Job Title',
        },
        last_name: {
          label: 'Last Name',
        },
        phone_number: {
          label: 'Phone number',
          validation: 'Phone number is not valid',
          too_short: 'Phone number is too short',
        },
        policies_consent: {
          label: 'Policies Consent',
        },
        t_shirt_size: {
          label: 'T-Shirt Size',
        },
        team: {
          label: 'Team',
        },
        username: {
          label: 'Username',
          validation: 'Username is not valid',
        },
      },
      greeting: 'Welcome to {{appName}}',
      log_out_button: 'Log out',
      not_supported_network: {
        description: 'Your wallet is not connected to a supported network. Please update before continuing.',
        error_message: 'This network is not available, please update.',
        title: 'Update Network',
      },
      update_email_tooltip:
      'This email is tied to your wallet so cannot be updated',
      update_phone_number_tooltip:
      'This phone number is tied to your wallet so cannot be updated',
      lock_editing_multiple_verified_fields:
      'You can only edit 1 field at a time that requires verification',
    }
   */
    dyn_collect_user_data: {
        description: 'We need a bit of information to get started',
        fields: {
            alias: {
                label: 'Alias',
            },
            country: {
                label: 'Country',
            },
            email: {
                label: 'Email',
                validation: 'Email is not valid',
            },
            first_name: {
                label: 'First Name',
            },
            job_title: {
                label: 'Job Title',
            },
            last_name: {
                label: 'Last Name',
            },
            phone_number: {
                label: 'Phone number',
                validation: 'Phone number is not valid',
                too_short: 'Phone number is too short',
            },
            policies_consent: {
                label: 'Policies Consent',
            },
            t_shirt_size: {
                label: 'T-Shirt Size',
            },
            team: {
                label: 'Team',
            },
            username: {
                label: 'Username',
                validation: 'Username is not valid',
            },
        },
        greeting: 'Welcome to {{appName}}',
        log_out_button: 'Log out',
        not_supported_network: {
            description: 'Your wallet is not connected to a supported network. Please update before continuing.',
            error_message: 'This network is not available, please update.',
            title: 'Update Network',
        },
        update_email_tooltip: 'This email is tied to your wallet so cannot be updated',
        update_phone_number_tooltip: 'This phone number is tied to your wallet so cannot be updated',
        lock_editing_multiple_verified_fields: 'You can only edit 1 field at a time that requires verification',
    },
    /**
   * @description copy keys for create password view
   * @default
   * {
      continue: 'Continue',
      create_input: {
        label: 'Create passcode',
        placeholder: 'Create passcode',
      },
      confirm_input: {
        label: 'Confirm passcode',
        placeholder: 'Confirm passcode',
      },
      current_password_input: {
        label: 'Current passcode',
        placeholder: 'Current passcode',
      },
      description:
        "Choose a strong, unique passcode to ensure your account's security and privacy.",
      errors: {
        invalid_current_password: 'Invalid current passcode',
        error_changing_password: 'Error changing passcode',
        new_password_same_as_old: 'New passcode cannot be the same as the old passcode',
        password_mismatch: 'Passcodes do not match',
        user_closed_view: 'User closed the view',
      },
      intro: {
        continue: 'Set up a passcode',
        description: {
          title: 'Add a passcode to protect your account',
          additional_protection: {
            title: 'Passcode Security',
            description:
              'Add a secure passcode to further prevent un-authrized access to your account.',
          },
          restore_access: {
            title: 'Restore Access',
            description:
              'You will be asked to enter it when signing on to a new device.',
          },
        },
        title: 'Add a Passcode',
      },
      logout: 'Log out',
      title: {
        create: 'Create passcode',
        update: 'Create new passcode',
      },
      update_input: {
        label: 'New passcode',
        placeholder: 'New passcode',
      },
    }
   */
    dyn_create_password: {
        continue: 'Continue',
        create_input: {
            label: 'Create passcode',
            placeholder: 'Create passcode',
        },
        confirm_input: {
            label: 'Confirm passcode',
            placeholder: 'Confirm passcode',
        },
        current_password_input: {
            label: 'Current passcode',
            placeholder: 'Current passcode',
        },
        description: "Choose a strong, unique passcode to ensure your account's security and privacy.",
        errors: {
            invalid_current_password: 'Invalid current passcode',
            error_changing_password: 'Error changing passcode',
            new_password_same_as_old: 'New passcode cannot be the same as the old passcode',
            password_mismatch: 'Passcodes do not match',
            user_closed_view: 'User closed the view',
        },
        intro: {
            continue: 'Set up a passcode',
            description: {
                title: 'Add a passcode to protect your account',
                additional_protection: {
                    title: 'Passcode Security',
                    description: 'Add a secure passcode to further prevent un-authrized access to your account.',
                },
                restore_access: {
                    title: 'Restore Access',
                    description: 'You will be asked to enter it when signing on to a new device.',
                },
            },
            title: 'Add a Passcode',
        },
        logout: 'Log out',
        title: {
            create: 'Create passcode',
            update: 'Create new passcode',
        },
        update_input: {
            label: 'New passcode',
            placeholder: 'New passcode',
        },
    },
    /**
   * @description copy keys for creating wallet wallet message
   * @default
   * {
      loading_message: 'Your wallet is being created...',
    }
   */
    dyn_creating_wallet: {
        loading_message: 'Your wallet is being created...',
    },
    /**
   * @description copy keys for email verification view after email logging in with magiclink
   * @default
   * {
      description: 'We’ve sent a verification email to',
      note: 'Note: it might take a few seconds to proceed after clicking the link in your email',
      title: 'Confirm your email',
    }
   */
    dyn_email_confirmation: {
        description: 'We’ve sent a verification email to',
        note: 'Note: it might take a few seconds to proceed after clicking the link in your email',
        title: 'Confirm your email',
    },
    /**
   * @description copy keys for email update view
   * @default
   * {
      current_email: 'Your current email address is',
      label: 'Email address',
      send_verification: 'Send Verification Code',
      title: 'Update email',
    }
  */
    dyn_email_update: {
        current_email: 'Your current email address is',
        label: 'Email address',
        send_verification: 'Send Verification Code',
        title: 'Update email',
    },
    /**
   * @description copy keys for one-time password verification view after logging in with dynamic email or phone number provider or after kyc verification
   * @default
   * {
      code_not_received: 'Did not receive a code? Check spam or',
      code_sent: 'Code sent',
      description: 'We’ve sent a verification code to',
      log_out_button: 'Log out',
      resend_code: 'Re-send code',
      resend_code_in: 'Re-send code in {{remainingSeconds}}',
      confirm_code: 'Confirm verification code',
      verification_succeeded: 'Verification code confirmed',
      hang_tight: 'Hang tight while we get things ready for you',

      email: {
        title: 'Confirm your email',
        complete:
          'Verification complete, the email is now verified to this account.',
      },
      phone_number: {
        title: 'Confirm your phone number',
        edit: 'Edit phone number',
        complete:
          'Verification complete, the phone number is now verified to this account.',
      },
    },
   */
    dyn_otp_verification: {
        code_not_received: 'Did not receive a code? Check spam or',
        code_sent: 'Code sent',
        description: 'We’ve sent a verification code to',
        log_out_button: 'Log out',
        resend_code: 'Re-send code',
        resend_code_in: 'Re-send code in {{remainingSeconds}}',
        confirm_code: 'Confirm verification code',
        verification_succeeded: 'Verification code confirmed',
        hang_tight: 'Hang tight while we get things ready for you',
        email: {
            title: 'Confirm your email',
            complete: 'Verification complete, the email is now verified to this account.',
        },
        phone_number: {
            title: 'Confirm your phone number',
            edit: 'Edit phone number',
            complete: 'Verification complete, the phone number is now verified to this account.',
        },
    },
    /**
   * @description copy keys for deposit view
   * @default
   * {
      title: 'Deposit',
    }
   */
    dyn_deposit: {
        title: 'Deposit',
        receive_funds_on: 'You can receive tokens on ',
    },
    /**
   * @description copy keys for embedded wallet authenticator choice view
   * @default
   * {
      description:
        'Protect your account and simplify your transaction experience.',
      email: {
        badge: 'Fastest',
        description: ' You will need to renew after {{expiration}} minutes ',
        title: 'Use a one-time code',
      },
      passkey: {
        auth_info: {
          convinience: {
            title: 'Convenient and Fast',
            description:
              'Use Face ID or Touch ID to complete transactions quickly.',
          },
          security: {
            title: 'Increased Security',
            description:
              'Passkeys are encrypted end-to-end on your device or password manager to prevent phishing attempts.',
          },
          add_button: 'Add a passkey',
          start_button: 'Add a passkey',
        },
        no_email_auth_info: {
          convinience: {
            title: 'Simple and Fast',
            description:
              'Works across devices and syncs between devices and browsers.',
          },
          security: {
            title: 'Secured with a bio-metric',
            description: 'Phishing resistant and encrypted.',
          },
          add_button: 'Add passkey',
          start_button: 'Add passkey',
        },
        badge: 'Recommended',
        description:
          'Works across devices & secured with biometric to prevent phishing attempts ',
        title: 'Create new passkey',
        reveal_title: 'Add a passkey',
      },
      skip: 'Not now',
      title: 'Account security',
      need_help_title: 'Problem Signing?',
      need_help_description: 'Select from an option below to complete',
      reveal_title: 'Verification Required',
      reveal_description: 'Choose a verification method.',
    }
   */
    dyn_embedded_authenticator: {
        description: 'Protect your account and simplify your transaction experience.',
        email: {
            badge: 'Fastest',
            description: ' You will need to renew after {{expiration}} minutes ',
            title: 'Use a one-time code',
        },
        passkey: {
            auth_info: {
                convinience: {
                    title: 'Convenient and Fast',
                    description: 'Use Face ID or Touch ID to complete transactions quickly.',
                },
                security: {
                    title: 'Increased Security',
                    description: 'Passkeys are encrypted end-to-end on your device or password manager to prevent phishing attempts.',
                },
                add_button: 'Add a passkey',
                start_button: 'Add a passkey',
            },
            no_email_auth_info: {
                convinience: {
                    title: 'Simple and Fast',
                    description: 'Works across devices and syncs between devices and browsers.',
                },
                security: {
                    title: 'Secured with a bio-metric',
                    description: 'Phishing resistant and encrypted.',
                },
                add_button: 'Add passkey',
                start_button: 'Add passkey',
            },
            badge: 'Recommended',
            description: 'Works across devices & secured with biometric to prevent phishing attempts ',
            title: 'Create new passkey',
            reveal_title: 'Add a passkey',
        },
        skip: 'Not now',
        title: 'Account security',
        need_help_title: 'Problem Signing?',
        need_help_description: 'Select from an option below to complete',
        reveal_title: 'Verification Required',
        reveal_description: 'Choose a verification method.',
    },
    /**
     * @description copy keys for enter password view
     * @default
     * {
        continue_button_label: 'Continue',
        description: 'Please enter your passcode below to continue.',
        error: {
          invalid_password: 'Invalid passcode',
        },
        input: {
          label: 'Passcode',
          placeholder: 'Passcode',
        },
        title: 'Enter passcode',
      }
     */
    dyn_enter_password: {
        continue_button_label: 'Continue',
        description: 'Please enter your passcode below to continue.',
        error: {
            invalid_password: 'Invalid passcode',
        },
        input: {
            label: 'Passcode',
            placeholder: 'Passcode',
        },
        title: 'Enter passcode',
    },
    /**
     * @description copy keys for Dynamic Farcaster connect view
     * @default
     * {
        copy_button: 'Copy QR URI',
        scan_title: "Scan this QR code from your mobile app or phone's camera to connect.",
      }
     */
    dyn_farcaster_connect_view: {
        copy_button: 'Copy QR URI',
        scan_title: "Scan this QR code from your mobile app or phone's camera to connect.",
    },
    /**
   * @description copy keys for log in view
   * @default
   * dyn_login: {
    connect_wallet: {
      title: 'Connect',
    },
    email_form: {
      email_field: {
        label: 'Enter your email',
      },
      submit_button: {
        label: 'Continue',
      },
    },
    email_or_phone: {
      use_email: 'Use email',
      use_phone: 'Use phone',
      prefer_email: 'Prefer email sign up?',
      prefer_phone: 'Prefer phone number sign up?',
    },
    helper: {
      all_wallet_list: 'Get your first wallet',
      email_form: {
        invalid_email: 'Invalid or incorrect email. Did you mistype it?',
      },
      pending_connect: {
        title: 'Connecting a wallet',
      },
      pending_signature: {
        title: 'Signing a wallet',
      },
      pending_signature_without_back_button: {
        title: 'Signing a wallet',
      },
      phone_number_form: {
        invalid_phone: 'Invalid or incorrect number. Did you mistype it?',
        invalid_sms_verification:
          'The code you entered is incorrect. Please try again.',
        too_many_sms_verification_attempts:
          'Too many verification attempts, please try again later.',
      },
      qr_code: {
        title: 'Connecting a wallet',
      },
      wallet_only: 'Get your first wallet',
    },
    qr_code: {
      title: 'Connect',
    },
    separators: {
      default: 'OR',
    },
    sign_wallet: {
      title: 'Sign',
    },
    select_wallet_in_wallet_group: {
      title: 'Select',
    },
    social: {
      button_label: 'Continue with {{provider}}',
      overlay_title: 'Choose a social account',
    },
    title: {
      all: 'Log in or sign up',
      all_wallet_list: 'Select your wallet',
      wallet_only: 'Select your wallet',
    },
    wallet_group: {
      title: 'Select Chain',
    },
    wallet_list: {
      button_only: 'Continue with a wallet',
    },
    mobile_wallet_redirect: {
      backup_title: 'Connect mobile app',
      prompt: "Tap 'Open' to continue",
      get_app_prompt: 'Get',
      open_prompt: 'Open',
      redirect_fail_message:
        "If the app doesn't open, you might need to download the {{walletName}} Wallet app.",
      app_store: 'App Store',
      play_store: 'Play Store',
    },
    wrong_social_account: {
      retry_button: 'Try again',
      retry_title: 'Please connect with: ',
      subtitle:
        'You must connect with the same account you originally signed in with.',
      title: 'Whoops. Wrong Account',
    },
  },
   */
    dyn_login: {
        connect_wallet: {
            title: 'Connect',
        },
        email_form: {
            email_field: {
                label: 'Enter your email',
            },
            submit_button: {
                label: 'Continue',
            },
        },
        email_or_phone: {
            use_email: 'Use email',
            use_phone: 'Use phone',
            prefer_email: 'Prefer email sign up?',
            prefer_phone: 'Prefer phone number sign up?',
        },
        helper: {
            all_wallet_list: 'Get your first wallet',
            email_form: {
                invalid_email: 'Invalid or incorrect email. Did you mistype it?',
            },
            pending_connect: {
                title: 'Connecting a wallet',
            },
            pending_signature: {
                title: 'Signing a wallet',
            },
            pending_signature_without_back_button: {
                title: 'Signing a wallet',
            },
            phone_number_form: {
                invalid_phone: 'Invalid or incorrect number. Did you mistype it?',
                invalid_sms_verification: 'The code you entered is incorrect. Please try again.',
                too_many_sms_verification_attempts: 'Too many verification attempts, please try again later.',
            },
            qr_code: {
                title: 'Connecting a wallet',
            },
            wallet_only: 'Get your first wallet',
        },
        qr_code: {
            title: 'Connect',
        },
        separators: {
            default: 'OR',
        },
        sign_wallet: {
            title: 'Sign',
        },
        select_wallet_in_wallet_group: {
            title: 'Select',
        },
        social: {
            button_label: 'Continue with {{provider}}',
            overlay_title: 'Choose a social account',
        },
        title: {
            all: 'Log in or sign up',
            all_wallet_list: 'Select your wallet',
            wallet_only: 'Select your wallet',
        },
        wallet_group: {
            title: 'Select Chain',
        },
        wallet_list: {
            button_only: 'Continue with a wallet',
        },
        mobile_wallet_redirect: {
            backup_title: 'Connect mobile app',
            prompt: "Tap 'Open' to continue",
            get_app_prompt: 'Get',
            open_prompt: 'Open',
            redirect_fail_message: "If the app doesn't open, you might need to download the {{walletName}} Wallet app.",
            app_store: 'App Store',
            play_store: 'Play Store',
        },
        wrong_social_account: {
            retry_button: 'Try again',
            retry_title: 'Please connect with: ',
            subtitle: 'You must connect with the same account you originally signed in with.',
            title: 'Whoops. Wrong Account',
        },
    },
    /**
   * @description copy keys for Dynamic manage passkeys view which are used inside dynamic widget
   * @default
   * {
      title: 'My passkeys',
      passkey_from: 'from',
      passkey_providers: {
        android: 'Android Phone',
        brave: 'Brave Browser',
        chrome: 'Google Chrome',
        edge: 'Microsoft Edge',
        firefox: 'Firefox',
        iPhone: 'iPhone',
        opera: 'Opera Browser',
        safari: 'Safari Browser',
      },
      recovery_button: 'Set up new passkey',
    }
   */
    dyn_manage_passkeys: {
        title: 'Manage passkeys',
        passkey_from: 'from',
        passkey_providers: {
            android: 'Android Phone',
            brave: 'Brave Browser',
            chrome: 'Google Chrome',
            edge: 'Microsoft Edge',
            firefox: 'Firefox',
            iPhone: 'iPhone',
            opera: 'Opera Browser',
            safari: 'Safari Browser',
        },
        recovery_button: 'Set up new passkey',
    },
    /**
   * @description copy keys for Dynamic rename passkey view
   * @default
   * {
    error: Whoops! There was an error updating your passkey
    input_label: 'Passkey name',
    save: 'Save',
    title: 'Rename your passkey',
    not_found: 'No passkeys found',
   }
   */
    dyn_rename_passkeys: {
        error: 'Whoops! There was an error updating your passkey',
        input_label: 'Passkey name',
        save: 'Save',
        title: 'Rename your passkey',
        not_found: 'No passkeys found',
    },
    /**
   * @description export keys for Dynamic embedded reveal view
   * @default
   * {
      title: 'Export wallet',
      agreement_title: 'Agree to continue',
      private_key_title: 'Private key',
      recovery_phrase_title: 'Secret recovery phrase',
      description:
        'Your wallet is non-custodial, meaning you are always in control of it.',
      statement_1: {
        title: 'Do not publicly share your {{keyType}}',
        description: 'Your {{keyType}} controls your account and assets.',
      },
      checkbox_label:
        'I am responsible for safeguarding and using my wallet key information.',
      reveal_description: 'Make sure to safely back up this information',
      reveal_button_label: 'Reveal',
      copy_button_label: 'Copy to clipboard',
      done_button_label: "I'm Done",
      aa_warning: {
         title: 'Your assets are not in this wallet.',
         subtitle:
         'This is a smart-contract wallet. You will not see your balance if you import this to an external service. Please send your assets to your preferred external wallet first to access your funds:',
         button: 'here',
      },
      unlink: 'Unlink wallet info',
    },
   */
    dyn_embedded_reveal: {
        title: 'Export wallet',
        agreement_title: 'Agree to continue',
        prompt_for_export_title: 'Back up wallet key',
        private_key_title: 'Private key',
        recovery_phrase_title: 'Secret recovery phrase',
        badge_label: 'Sensitive information',
        prompt_for_export_description: 'Your wallet is ready. Back up your key to protect your assets.',
        statement_1: {
            title: 'Non-custodial wallet',
            description: "You're always in control",
        },
        statement_2: {
            title: 'Keep your key private. It controls your account and assets.',
        },
        checkbox_label: 'I am responsible for safeguarding and using my wallet key information.',
        reveal_description: 'Make sure to safely back up this information',
        skip_button_label: 'Skip for now',
        reveal_button_label: 'Reveal',
        backup_button_label: 'Back up now',
        copy_button_label: 'Copy to clipboard',
        done_button_label: "I'm Done",
        aa_warning: {
            title: 'Your assets are not in this wallet.',
            subtitle: 'This is a smart-contract wallet. You will not see your balance if you import this to an external service. Please send your assets to your preferred external wallet first to access your funds:',
            button: 'here',
        },
        unlink: 'Unlink wallet info',
    },
    /**
     * @description export keys for Dynamic embedded delete view
     * @default
     *
     */
    dyn_embedded_delete: {
        title: 'Unlink from app',
        description_1: 'By continuing you acknowledge that if you return to the application, you will receive a new wallet address.',
        description_2: 'Once unlinked, you cannot recover any wallet information through this application including any associated smart contract wallets.',
        acknowledgement: 'I have safely backed up my wallet seed phrase information. If I return to this application, a new wallet will be created for me.',
        cancel_button: 'Cancel',
        action_button: 'Unlink & Log out',
    },
    /**
   * @description Settings for Dynamic settings view which are used inside dynamic widget
   * @default
   * {
    global_connectivity_section: {
      title: 'Global Connectivity',
      connected_apps_button: 'Connected Apps',
    },
    export_section: {
      private_key_button: 'Private key',
      srp_button: 'Recovery phrase',
      title: 'Export & Backup',
    },
    identity_section: {
      title: 'Recovery',
      add_email_button: 'Add an email',
    },
    tags: { recommended: 'Recommended' },
    security_section: {
      email_auth_button: 'One time code',
      passkey_button: 'Passkeys',
      password_button: 'Passcode',
      mfa_button: 'Authenticator App',
      title: '2 factor authentication',
    },
    title: 'Settings',
    button_logout: 'Log out',
    empty_screen: {
      title: 'Nothing to see here yet!',
    },
  }
   */
    dyn_settings: {
        global_connectivity_section: {
            title: 'Global Connectivity',
            connected_apps_button: 'Connected Apps',
        },
        export_section: {
            private_key_button: 'Private key',
            srp_button: 'Recovery phrase',
            title: 'Export & Backup',
        },
        identity_section: {
            title: 'Recovery',
            add_email_button: 'Add an email',
        },
        tags: { recommended: 'Recommended' },
        security_section: {
            email_auth_button: 'One time code',
            passkey_button: 'Passkeys',
            password_button: 'Passcode',
            mfa_button: 'Authenticator App',
            title: '2 factor authentication',
        },
        title: 'Settings',
        button_logout: 'Log out',
        empty_screen: {
            title: 'Nothing to see here yet!',
        },
    },
    /**
   * @description copy keys for global wallet view
   * @default
   *  {
    connect_to_apps: 'Connect to apps',
    scan_qr_code: 'Scan QR Code',
    or: 'OR',
    walletconnect_uri: 'WalletConnect URI',
    the_dapp: 'the dApp',
    this_app: 'this app',
    confirm: {
      title: 'Confirm Connection',
      description: 'Are you sure you want to connect to {{name}}?',
      cancel_button: 'Cancel',
      connect_button: 'Connect',
    },
    banner: {
      warning: 'There was an error connecting to {{name}}.',
      success: 'Successfully connected to {{name}}.',
      already_connected: 'You are already connected to {{name}}.',
      expired:
        'The link you entered expired, please get a new URI from the app.',
      bad_input:
        'Invalid URI. Please check below for how to find the valid URI.',
    },
    help: {
      title: 'How do I find the URI code?',
      step: {
        1: '1. Go to the website you want to connect to',
        2: '2. Locate the "Connect" or "Login" button',
        3: '3. Open WalletConnect from the list',
      },
      learn_more: 'Learn more about global wallets',
    },
    malicious_site: {
      certain: {
        title: 'Malicious app detected!',
        subtitle_header: 'Risk of losing funds',
        subtitle_text:
          'The site is known to exploit and or take assets from connected wallets.',
        go_back: 'Cancel',
        proceed: 'Proceed',
      },
      unknown: {
        title: 'Site verification did not run.',
        subtitle_header: 'Double check the app',
        subtitle_text:
          'We were unable to verify the vailidity of the app at this time.',
        go_back: 'Cancel',
        proceed: 'Proceed',
      },
    },
     connected_apps: {
      title: 'Connected Apps',
      no_connections: 'No connected apps',
    },
  },
   */
    global_wallet: {
        connect_to_apps: 'Connect to apps',
        scan_qr_code: 'Scan QR Code',
        or: 'OR',
        walletconnect_uri: 'WalletConnect URI',
        the_dapp: 'the dApp',
        this_app: 'this app',
        confirm: {
            title: 'Confirm Connection',
            description: 'Are you sure you want to connect to {{name}}?',
            cancel_button: 'Cancel',
            connect_button: 'Connect',
        },
        banner: {
            warning: 'There was an error connecting to {{name}}.',
            success: 'Successfully connected to {{name}}.',
            already_connected: 'You are already connected to {{name}}.',
            expired: 'The link you entered expired, please get a new URI from the app.',
            bad_input: 'Invalid URI. Please check below for how to find the valid URI.',
        },
        help: {
            title: 'How do I find the URI code?',
            step: {
                1: '1. Go to the website you want to connect to',
                2: '2. Locate the "Connect" or "Login" button',
                3: '3. Open WalletConnect from the list',
            },
            learn_more: 'Learn more about global wallets',
        },
        malicious_site: {
            certain: {
                title: 'Malicious app detected!',
                subtitle_header: 'Risk of losing funds',
                subtitle_text: 'The site is known to exploit and or take assets from connected wallets.',
                go_back: 'Cancel',
                proceed: 'Proceed',
            },
            unknown: {
                title: 'Site verification did not run.',
                subtitle_header: 'Double check the app',
                subtitle_text: 'We were unable to verify the vailidity of the app at this time.',
                go_back: 'Cancel',
                proceed: 'Proceed',
            },
        },
        connected_apps: {
            title: 'Connected Apps',
            subtitle: 'Connected apps allow you to interact with your wallet on other platforms.',
            success: 'Successfully connected to {{name}}.',
        },
    },
    /**
   * @description copy keys for mfa management view
   * @default
   *  {
        title: 'Authenticator App',
        add_mfa_button: 'Authenticator App',
        no_devices: 'No authenticator apps configured',
        generate_backup_codes_button: 'Get new backup codes',
      },
   */
    dyn_manage_mfa: {
        title: 'Authenticator App',
        add_mfa_button: 'Authenticator App',
        no_devices: 'No authenticator apps configured',
        generate_backup_codes_button: 'Get new backup codes',
    },
    /**
   * @description copy keys for mfa views
   * @default
   * {
      choose_device_view: {
        title: 'Secure your account',
        select_options: 'Protect your account by adding multi-factor authentication',
        authenticator_app: 'Authenticator app',
        authenticator_app_description:
          'Use your preferred authenticator app such as Authy, Google Authenticator, etc.',
        backup_code: 'Backup code',
        backup_code_description:
          'Enter one of your saved backup codes to authenticate.',
        choose_another_method:  'Choose another method',
        choose_another_method_description: 'Use one of the methods below:',
      logout: 'Log out',
      },
      display_backup_codes_view: {
        title: 'Back up your codes',
        body: 'Backup codes help recover your account if you lose access to your device. Each code can be used only 1 time.',
        warning: 'You won’t be able to see these again',
        copy_all: 'Copy all',
        download: 'Download',
        checkbox: 'I have safely stored a copy of my backup codes',
        complete: 'Complete',
      },
      otp_verification_view: {
        title: 'Confirm verification code',
        body: 'Enter the verification code generated by your authenticator app',
        error: 'Invalid code. Please try again.',
        rate_limit_error: 'Too many attempts, please try again later.',
        choose_another_method: 'Sign in another way',
      },
      secure_device_view: {
        title: 'Secure your account',
        body: 'Setup a new sign-in method in your authenticator app',
        continue: 'Continue',
        helper: {
          button: "Can't scan QR Code?",
          title: 'Troubles with scanning?',
          step1: {
            title: 'Open your Authenticator App',
            description: 'You will set up a new sign-in method',
          },
          step2: {
            title: 'Enter the key provided below',
            description: 'Make sure time-based or one-time password is enabled.',
          },
          uri: {
            title: 'Copy the full URI',
            description:
              'This only works if your authenticator app supports TOTP URIs',
          },
        },
        logout: 'Log out',
      },
    },
   */
    dyn_mfa: {
        choose_device_view: {
            title: 'Secure your account',
            select_options: 'Protect your account by adding multi-factor authentication',
            authenticator_app: 'Authenticator app',
            authenticator_app_description: 'Use your preferred authenticator app such as Authy, Google Authenticator, etc.',
            backup_code: 'Backup code',
            backup_code_description: 'Enter one of your saved backup codes to authenticate.',
            choose_another_method: 'Choose another method',
            choose_another_method_description: 'Use one of the methods below:',
            logout: 'Log out',
        },
        display_backup_codes_view: {
            title: 'Back up your codes',
            body: 'Backup codes help recover your account if you lose access to your device. Each code can be used only 1 time.',
            warning: 'You won’t be able to see these again',
            copy_all: 'Copy all',
            download: 'Download',
            checkbox: "I've safely stored a copy of my backup codes",
            complete: 'Complete',
        },
        otp_verification_view: {
            title: 'Confirm verification code',
            body: 'Enter the verification code generated by your authenticator app',
            error: 'Invalid code. Please try again.',
            rate_limit_error: 'Too many attempts, please try again later.',
            choose_another_method: 'Sign in another way',
        },
        secure_device_view: {
            title: 'Secure your account',
            body: 'Setup a new sign-in method in your authenticator app',
            continue: 'Continue',
            helper: {
                button: "Can't scan QR Code?",
                title: 'Troubles with scanning?',
                step1: {
                    title: 'Open your Authenticator App',
                    description: 'You will set up a new sign-in method',
                },
                step2: {
                    title: 'Enter the key provided below',
                    description: 'Make sure time-based or one-time password is enabled.',
                },
                uri: {
                    title: 'Copy the full URI',
                    description: 'This only works if your authenticator app supports TOTP URIs',
                },
            },
            logout: 'Log out',
        },
        recovery_view: {
            title: 'Enter your backup code',
            body: 'Your backup code is one of the 10 codes you received when you first enrolled in multi-factor authentication',
            input_label: 'Enter back up code',
            button_label: 'Continue',
            get_help: {
                description: 'Missing your back up codes?',
                button_label: 'Get Help',
            },
            helper: {
                title: 'Mfa Recovery Help',
            },
        },
    },
    /**
   * @description copy keys for merge user accounts view
   * @default
   * {
      confirm_button: 'Merge accounts',
      errors: {
        merge_error: 'Something went wrong, please try again.',
      },
      wallet: {
        content: 'This wallet is associated to another account. Would you like to merge accounts?',
        title: 'Wallet already in use',
      },
    }
   */
    dyn_merge_user_accounts: {
        confirm_button: 'Merge accounts',
        errors: {
            merge_error: 'Something went wrong, please try again.',
        },
        wallet: {
            content: 'This wallet is associated to another account. Would you like to merge accounts?',
            title: 'Wallet already in use',
        },
    },
    /**
   * @description copy keys for merge user accounts conflicts view
   * @default
   * {
      confirm_button: 'Confirm & Merge',
      description:
        'You have some conflicting information. Please select your preferences',
      errors: {
        merge_error: 'Something went wrong, please try again.',
      },
      title: 'Confirm your preferences',
    }
   */
    dyn_merge_user_accounts_conflicts: {
        confirm_button: 'Confirm & Merge',
        description: 'You have some conflicting information. Please select your preferences',
        errors: {
            merge_error: 'Something went wrong, please try again.',
        },
        title: 'Confirm your preferences',
    },
    /**
   * @description copy keys for merge user accounts view when using email associated to a different account
   * @default
   * {
      cancel_button: "No, I'll use a different email",
      confirm_button: 'Yes, link to existing account',
      errors: {
        merge_error: 'Something went wrong, please try again.',
      },
      existing_account: 'An account already exists that uses',
      existing_account_trail: 'email.',
      title: 'Would you like to link this wallet to this existing account?',
    }
   */
    dyn_merge_user_accounts_with_same_email: {
        cancel_button: "No, I'll use a different email",
        confirm_button: 'Yes, link to existing account',
        errors: {
            merge_error: 'Something went wrong, please try again.',
        },
        existing_account: 'An account already exists that uses',
        existing_account_trail: 'email.',
        title: 'Would you like to link this wallet to this existing account?',
    },
    /**
   * @description copy key for Dynamic need help footer section
   * @default
   * {
      info: 'Problem Signing?',
      contact_support: 'Contact support',
      divider: 'or',
      help_button: 'go here.',
    }
   */
    dyn_need_help_section: {
        info: 'Need Help?',
        contact_support: 'Contact support',
        divider: 'or',
        help_button: 'Go here for support',
        visit_platform: 'Visit {{platform}}',
    },
    /**
   * @description copy keys for network not supported view
   * @default
   * {
      button: 'Switch Network',
      subtitle: 'Your wallet is not connected to a supported network. Please update before continuing.',
      title: 'Update Network',
      warning_message: 'This network is not available, please update.',
    }
   */
    dyn_network_not_supported: {
        button: 'Switch Network',
        subtitle: 'Your wallet is not connected to a supported network. Please update before continuing.',
        title: 'Update Network',
        warning_message: 'This network is not available, please update.',
        wallet: 'Not Supported',
    },
    /**
   * @description copy keys for network not supported view for manual switch
   * @default
   * {
      subtitle_network_defined_metamaskstarknet:
        'To continue, please update the network in your wallet to {{network}} by visiting the Starknet Snap companion app',
      subtitle_network_defined_metamaskstarknet_companion_app: 'companion app',
      subtitle_network_defined: 'To continue, please update the network in your wallet to {{network}}',
      subtitle_no_network_defined: 'Your wallet does not support switching networks from this app. Switch networks directly in your wallet.',
      title: 'Update your Network',
      warning_message: 'This network is not available, please update.',
    }
   */
    dyn_network_not_supported_manual_switch: {
        subtitle_network_defined_metamaskstarknet: 'To continue, please update the network in your wallet to {{network}} by visiting the Starknet Snap',
        subtitle_network_defined_metamaskstarknet_companion_app: 'companion app',
        subtitle_network_defined: 'To continue, please update the network in your wallet to {{network}}',
        subtitle_no_network_defined: 'Your wallet does not support switching networks from this app. Switch networks directly in your wallet.',
        title: 'Update your Network',
        warning_message: 'This network is not available, please update.',
    },
    /**
   * @description copy keys for no access view
   * @default
   * {
      chainalysis: {
        button_text: 'Try another method',
        description: 'This wallet has been correlated to illicit activity and cannot access this site.',
        social_media_link_text: 'Why am I seeing this message?',
        social_media_link_url: 'https://docs.dynamic.xyz/docs',
        title: 'This address seems corrupted.',
      },
      default: {
        button_text: 'Try another method',
        description: "You are not currently on the allow list.",
        title: 'Access denied',
      },
      gate: {
        button_text: 'Try a different wallet',
        description: 'A NFT or a token is required to access this site.',
        title: 'You cannot access the site',
      },
      not_in_the_list_image_alt: 'user is not in the list',
      title: "You don't have access",
    }
   */
    dyn_no_access: {
        chainalysis: {
            button_text: 'Try another method',
            description: 'This wallet has been correlated to illicit activity and cannot access this site.',
            social_media_link_text: 'Why am I seeing this message?',
            social_media_link_url: 'https://docs.dynamic.xyz/docs',
            title: 'This address seems corrupted.',
        },
        default: {
            button_text: 'Try another method',
            description: 'You are not currently on the allow list.',
            title: 'Access denied',
        },
        gate: {
            button_text: 'Try a different wallet',
            description: 'A NFT or a token is required to access this site.',
            title: 'You cannot access the site',
        },
        not_in_the_list_image_alt: 'user is not in the list',
        title: "You don't have access",
    },
    /**
   * @description copy keys for email OTP verification for magiclink
   * @default
   * {
      banner_text: 'Sign in to access your email based wallet',
    }
   */
    dyn_magic_verification: {
        banner_text: 'Sign in to access your email based wallet',
    },
    /**
   * @description copy key for passkey created success banner
   * @default
   * {
      text: 'A new passkey has been created',
    }
   */
    dyn_passkey_success: {
        created: 'A new passkey has been created',
        edited: 'Your passkey has been edited',
    },
    /**
   * @description copy keys for passkey intro view
   * @default
   * {
      button: 'Set up a passkey',
      button_logout: 'Log out',
      button_skip: 'Skip for now',
      disabled: 'Passkeys are not available on this device or browser. Please open on Chrome, Safari, or Brave to continue',
      helper: {
        section_1: {
          description: 'Passkeys are a standard built by Apple, Google and others, and eliminates the use of passwords.',
          title: 'Built by Apple and Google',
        },
        section_2: {
          description: 'Passkeys are stored on your phone and are not shared with anyone.',
          title: 'Secure and Private',
        },
        title: "What's Passkey",
        tooltip: 'Need some help?',
      },
      sms_auth: {
        title: 'Finish set up',
        description:
          'Add a security method to finish your profile and complete transactions',
      },
      subtitle: 'Passkeys are stored natively to your device with a biometric and can only be accessed by you.',
      title: 'Secure your wallet',
    }
   */
    dyn_passkey_intro: {
        button: 'Set up a passkey',
        button_logout: 'Log out',
        button_skip: 'Skip for now',
        disabled: 'Passkeys are not available on this device or browser. Please open on Chrome, Safari, or Brave to continue',
        helper: {
            section_1: {
                description: 'Passkeys are a standard built by Apple, Google and others, and eliminates the use of passwords.',
                title: 'Built by Apple and Google',
            },
            section_2: {
                description: 'Passkeys are stored on your phone and are not shared with anyone.',
                title: 'Secure and Private',
            },
            title: "What's Passkey",
            tooltip: 'Need some help?',
        },
        sms_auth: {
            title: 'Finish set up',
            description: 'Add a security method to finish your profile and complete transactions',
        },
        subtitle: 'Passkeys are stored natively to your device with a biometric and can only be accessed by you.',
        title: 'Secure your wallet',
    },
    /**
   * @description copy keys for passkey new domain detected modal
   * @default
   * {
   title: 'New domain detected',
   description: 'To complete your transaction select a signing method',
   actions: {
   passkey: {
   title: 'Add new passkey',
   subtitle: 'Does not expire. Works across devices & secured with biometric.',
   },
   emailAuth: {
   title: 'Use a one-time code',
   subtitle: 'Allows you to transact for 30 min',
   },
   badges: {
   recommended: 'Recommended',
   fastest: 'Fastest',
   },
   },
   }
   */
    dyn_passkey_new_domain_detected: {
        title: 'New domain detected',
        description: 'To complete your transaction select a signing method',
        actions: {
            passkey: {
                title: 'Add new passkey',
                subtitle: 'Does not expire. Works across devices & secured with biometric.',
            },
            emailAuth: {
                title: 'Use a one-time code',
                subtitle: 'Allows you to transact for 30 min',
            },
            badges: {
                recommended: 'Recommended',
                fastest: 'Fastest',
            },
        },
    },
    /**
   * @description copy keys for passkeys recovery flow
   * @default
   * {
      add_email: {
        description:
          'Don’t get locked out if you delete your passkey or lose your device.',
        input_label: 'Enter your email',
        title: 'Add a recovery email',
        confirm_button: 'Confirm with a passkey',
        skip_button: 'Skip for now',
        success_message: 'Recovery email added!',
      },
      code: {
          description: 'A verification code has been sent to {{email}}',
          input_label: 'Enter your code here...',
          title: 'Verification code sent',
        resend: {
            button: 'Resend code',
            text: "Didn't receive a code?",
        },
      },
      complete: {
        complete_button: 'Create a passkey',
        description: 'Secure your wallet by adding a new passkey.',
        title: 'Create a new passkey',
      },
      start: {
        description:
          'To complete this process, ensure you are using the same device/browser.',
        start_button: 'Send me an email',
        title: 'Initiate Request',
      },
    }
   */
    dyn_passkey_recovery: {
        add_email: {
            description: 'Don’t get locked out if you delete your passkey or lose your device.',
            input_label: 'Enter your email',
            title: 'Add a recovery email',
            confirm_button: 'Confirm with a passkey',
            skip_button: 'Skip for now',
            success_message: 'Recovery email added!',
        },
        code: {
            description: 'A verification code has been sent to {{email}}',
            input_label: 'Enter your code here...',
            title: 'Verification code sent',
            resend: {
                button: 'Resend code',
                text: "Didn't receive a code?",
            },
        },
        complete: {
            complete_button: 'Create a passkey',
            description: 'Secure your wallet by adding a new passkey.',
            title: 'Create a new passkey',
        },
        start: {
            description: 'To complete this process, ensure you are using the same device/browser.',
            start_button: 'Send me an email',
            title: 'Initiate Request',
        },
    },
    /**
   * @description copy keys for Dynamic pending wallet connection
   * @default
   * {
      mobile: 'Click connect in your mobile wallet',
      computer: 'Click connect in your wallet popup',
    }
   */
    dyn_pending_connection: {
        title: 'Connect',
        mobile: 'Click connect in your mobile wallet',
        computer: 'Click connect in your wallet popup',
    },
    /**
     * @description copy keys for Dynamic pending signature, we have overrides for phantom ledger which does not support message signing.
     * @default
     * {
        click_to_sign: 'Click to Sign',
        note: 'Note: ',
        phantom_ledger_sign: "Click sign in your wallet to confirm you own this wallet (this doesn't cost gas).",
        phantom_ledger_warning: "Ledger with Phantom doesn't support message signing. When logging in, a small fee (which should not apply) may appear. See below to learn more.",
        regular_sign_description: 'Click sign-in in your wallet to confirm you own this wallet.',
  }
     */
    dyn_pending_signature: {
        click_to_sign: 'Click to Sign',
        note: 'Note: ',
        phantom_ledger_sign: "Click sign in your wallet to confirm you own this wallet (this doesn't cost gas).",
        phantom_ledger_warning: "Ledger doesn't support message signing. When logging in, a small fee (which should not apply) may appear. See below to learn more.",
        regular_sign_description: 'Click sign-in in your wallet to confirm you own this wallet.',
    },
    /**
     * @description copy keys for Dynamic QR code Wallet Connection Pop-Up
     * @default
     * {
        copy_button: 'Copy QR URI',
        get_extension_button: 'Get extension',
        open_button: 'Open App',
        scan_title: "Scan this QR code from your mobile {{app}} or phone's camera to connect.",
        wallet_not_installed: {
          browser_install: 'Install {{browser}} extension',
          install: 'Install {{wallet}} extension to connect',
          refresh: 'Refresh the page once installed',
          select: 'Select from your preferred options below:',
        },
      }
     */
    dyn_qr_code: {
        copy_button: 'Copy QR URI',
        get_extension_button: 'Get Extension',
        open_button: 'Open App',
        scan_title: "Scan this QR code from your mobile {{app}} or phone's camera to connect.",
        wallet_not_installed: {
            browser_install: 'Install {{browser}} extension',
            install: 'Install {{wallet}} extension to connect',
            refresh: 'Refresh the page once installed',
            select: 'Select from your preferred options below:',
        },
    },
    /**
     * @description copy keys for Dynamic wallet locked/disconnected
     * @default
     * {
        connect_continue: 'Connect your wallet to continue',
        title: 'Welcome back',
        subtitle: "We couldn't connect to your wallet. Click connect to retry the connection ",
        connect: 'Connect wallet',
        logout: 'Log out',
      }
     */
    dyn_wallet_locked: {
        connect_continue: 'Connect your wallet to continue',
        title: 'Welcome back',
        subtitle: "We couldn't connect to your wallet. Click connect to retry the connection ",
        connect: 'Connect wallet',
        logout: 'Log out',
    },
    /**
   * @description copy keys for passkeys creation flow for existent embedded wallets
   * @default
   * {
      code: {
        action_based_description: 'To {{action}} verify account.',
        description: 'A secure code has been sent to {{email}}.',
        input_label: 'Enter your code here...',
        title: 'Verification code sent',
        resend: {
          button: 'Resend code',
          text: "Didn't receive a code?",
        },
        complete_transaction_action: 'complete transaction',
        sign_message_action: 'sign this message',
      },
      complete: {
        complete_button: 'Create a passkey',
        description:
          'Passkeys are stored natively to your device with a biometric and can only be accessed by you.',
        title: 'Secure your account',
      },
      start: {
        description:
          'A one-time security code will be sent to the email on file. It will expire in 15 minutes.',
        start_button: 'Send me an email',
        title: 'Send Email Code',
      },
    }
   */
    dyn_passkey_secure_modal: {
        code: {
            action_based_description: 'To {{action}} verify account.',
            description: 'A secure code has been sent to {{email}}.',
            input_label: 'Enter your code here...',
            title: 'Verification code sent',
            resend: {
                button: 'Resend code',
                text: "Didn't receive a code?",
            },
            complete_transaction_action: 'complete transaction',
            sign_message_action: 'sign this message',
        },
        complete: {
            complete_button: 'Create a passkey',
            description: 'Passkeys are stored natively to your device with a biometric and can only be accessed by you.',
            title: 'Secure your account',
        },
        start: {
            description: 'A one-time security code will be sent to the email on file. It will expire in 15 minutes.',
            start_button: 'Send me an email',
            title: 'Send Email Code',
        },
    },
    /**
   * @description copy keys for save password view
   * @default
   * {
      badge_text: 'Important!',
      checkbox_label: 'I have safely stored a copy of my passcode.',
      continue: 'Continue',
      copy_button: {
        copy: 'Copy',
        copied: 'Copied',
      },
      description: 'You must retain a copy of this passcode.',
      download_button: 'Download',
      logout: 'Log out',
      password_input: {
        label: 'Passcode',
        placeholder: 'Passcode',
      },
      title: 'Save passcode',
      warning:
        'If you lose your passcode, you cannot recover access to your account.',
    }
   */
    dyn_save_password: {
        badge_text: 'Important!',
        checkbox_label: 'I have safely stored a copy of my passcode.',
        continue: 'Continue',
        copy_button: {
            copy: 'Copy',
            copied: 'Copied',
        },
        description: 'You must retain a copy of this passcode.',
        download_button: 'Download',
        logout: 'Log out',
        password_input: {
            label: 'Passcode',
            placeholder: 'Passcode',
        },
        title: 'Save passcode',
        warning: 'If you lose your passcode, you cannot recover access to your account.',
    },
    /**
   * @description copy keys for secure pregenerated embedded wallet
   * @default
   * {
      description: 'Make transactions simpler and more secure.',
      action: 'Get started'
   }
   */
    dyn_secure_pregenerated_wallet: {
        description: 'Make transactions simpler and more secure.',
        action: 'Get started',
    },
    /**
   * @description copy keys for send transaction flow views
   * @default
   * {
      confirmation: {
        cancel_button: 'Cancel',
        confirm_button: 'Confirm',
        data: {
          amount: 'Amount',
          from: 'From (You)',
          gas: 'Gas',
          gas_estimate: 'Network Fee',
          to: 'To',
          total: 'Total',
        },
        not_applied: 'N/A',
        title: 'Confirm transaction',
      },
      data: {
        amount: {
          label: 'Amount',
          placeholder: 'Select amount',
        },
        balance: {
          label: 'Balance:',
        },
        from: 'Send from',
        recipient: {
          label: 'Recipient',
          placeholder: 'Enter wallet address...',
        },
      },
      multiple_recipients: 'Multiple',
      send_button: 'Send now',
      succeeded: {
        continue_button: 'Continue',
        network: {
          label: 'Network',
        },
        recipient: {
          label: 'Recipient',
        },
        title: 'Transaction successfully sent',
        total_amount: {
          label: 'Total amount',
        },
      },
      validation: {
        amount: {
          invalid_decimals: 'Please enter a value up to the {{decimals}}th decimal place.',
          invalid_format: 'The amount is in invalid format',
          over_balance: 'Insufficient funds to send this amount.',
          required: 'The amount field is required',
        },
        recipient: {
          invalid_format: 'The address is in invalid format',
          required: 'The recipient is required',
        },
      },
      warning_message: {
        insufficient_funds: 'Insufficient funds due to gas price increase from estimate. Please add {{amountLeft}} {{currencySymbol}} to continue.',
      },
      error_message: {
        gas_not_sponsored: 'The gas fee has increased. Confirm if you still want to complete this transaction.',
      },
    }
   */
    dyn_send_transaction: {
        confirmation: {
            cancel_button: 'Cancel',
            confirm_button: 'Confirm',
            send: 'Confirm',
            data: {
                amount: 'Amount',
                from: 'From (You)',
                gas: 'Gas',
                gas_estimate: 'Network Fee',
                to: 'To',
                total: 'Total',
                wallet_used: 'Wallet used',
                network: 'Network',
                recipient: 'Recipient',
                destination: 'Interacting with',
                gas_tooltip: 'Gas fees are charged by the network and can change quickly based on usage.',
                sending: 'Sending',
                receiving: 'Receiving',
                transfer: {
                    send: 'Send',
                    receive: 'Receive',
                },
            },
            not_applied: 'N/A',
            title: 'Confirm transaction',
        },
        data: {
            amount: {
                label: 'Amount',
                placeholder: 'Enter amount',
            },
            balance: {
                label: 'Balance:',
            },
            from: 'Send from',
            send: 'Send',
            send_preview: 'Send Preview',
            confirmation_tx: 'Confirm Transaction',
            banner: "You're nearly done! Confirm transaction to proceed.",
            recipient: {
                label: 'Address',
                placeholder: 'Enter wallet address...',
            },
        },
        multiple_recipients: 'Multiple',
        preview_transaction: 'Preview transaction',
        send_button: 'Send now',
        succeeded: {
            continue_button: 'Done',
            network: {
                label: 'Network',
            },
            recipient: {
                label: 'Recipient',
            },
            title: 'Transaction successfully sent to',
            total_amount: {
                label: 'Total amount',
            },
        },
        validation: {
            amount: {
                invalid_decimals: 'Please enter a value up to the {{decimals}}th decimal place.',
                invalid_format: 'The amount is in invalid format',
                over_balance: 'Insufficient funds to send this amount.',
                required: 'The amount field is required',
            },
            recipient: {
                invalid_format: 'The address is in invalid format',
                required: 'The recipient is required',
            },
        },
        info_message: {
            refresh_balance_time: 'Your balance may take up to 30s to refresh.',
        },
        warning_message: {
            insufficient_funds: {
                title: 'Insufficient funds',
                description: 'Insufficient funds for transaction. Please add {{amountLeft}} {{currencySymbol}} to continue.',
            },
            insufficient_gas_funds: {
                title: 'Insufficient gas funds',
                description: 'Please add {{amountLeft}} {{currencySymbol}} to continue.',
            },
            failed_simulation: {
                title: 'Transaction expected to fail',
                description: 'Something went wrong. Check your balances and try again.',
            },
        },
        error_message: {
            gas_not_sponsored: 'The gas fee has increased. Confirm if you still want to complete this transaction.',
        },
    },
    /**
   * @description copy keys for Select Chain view
   * @default
   * {
      description: "This wallet supports multiple chains. Select which chain you'd like to connect to",
      using_hardware_wallet_toggle_label: 'Using Ledger',
    }
   */
    dyn_select_chain: {
        description: "This wallet supports multiple chains. Select which chain you'd like to connect to",
        using_hardware_wallet_toggle_label: 'Using Ledger',
    },
    /**
   * @description copy keys for Select Wallet view
   * @default
   * {
      description: "This wallet supports multiple chains. Select which chain you'd like to connect to",
      using_hardware_wallet_toggle_label: 'Using Ledger with {{chainName}}',
    }
   */
    dyn_select_wallet: {
        description: 'Select your preferred {{walletName}} wallet?',
    },
    /**
   * @description copy keys for Select Chain view
   * @default
   * {
      title: "Connect",
      description:
        "This wallet supports using ledger. Toggle on ledger to enable it.",
      using_hardware_wallet_toggle_label: "Using Ledger with {{chainName}}",
      button: "Connect",
    }
   */
    dyn_select_hardware_wallet: {
        title: 'Connect',
        description: 'This wallet supports using ledger. Toggle on ledger to enable it.',
        using_hardware_wallet_toggle_label: 'Using Ledger with {{chainName}}',
        button: 'Connect',
    },
    /**
   * @description copy keys for sign message flow views
   * @default
   * {
      cancel_button: 'Cancel',
      sign_button: 'Sign',
      title: 'Requesting Signature',
    }
   */
    dyn_sign_message: {
        cancel_button: 'Cancel',
        sign_button: 'Sign',
        title: 'Requesting Signature',
    },
    /**
   * @description copy keys for social redirect view
   * @default
   * {
      logging_in: 'Logging you in',
    }
   */
    dyn_social_redirect: {
        logging_in: 'Logging you in',
    },
    /**
   * @description copy keys for wallet redirect view
   * @default
   * {
      loading: 'Loading...',
    }
   */
    dyn_wallet_redirect: {
        loading: 'Loading...',
    },
    /**
   * @description copy keys for messages related to time since a date
   * @default
   * {
      second: 'second',
      seconds: 'seconds',
      minute: 'minute',
      minutes: 'minutes',
      hour: 'hour',
      hours: 'hours',
      day: 'day',
      days: 'days',
      month: 'month',
      months: 'months',
      year: 'year',
      years: 'years',
      ago: 'ago',
      created: 'Created',
   }
   */
    dyn_time_since: {
        second: 'second',
        seconds: 'seconds',
        minute: 'minute',
        minutes: 'minutes',
        hour: 'hour',
        hours: 'hours',
        day: 'day',
        days: 'days',
        month: 'month',
        months: 'months',
        year: 'year',
        years: 'years',
        ago: 'ago',
        created: 'Created',
    },
    /**
   * @description copy keys for connecting wallets view
   * @default
   * {
      mobile: {
        wallet_list: {
          helper: 'Get your first wallet',
          title: 'WalletConnect wallets',
        },
      },
    }
   */
    dyn_wallet_conect: {
        mobile: {
            wallet_list: {
                helper: 'Get your first wallet',
                title: 'WalletConnect wallets',
            },
        },
    },
    /**
   * @description copy keys for linking wallets to profile view
   * @default
   * {
      cannot_link: {
        cancel_button: 'Cancel',
        description: 'This wallet is the only wallet in your other account. You cannot transfer it, since then you will lose access to that account.',
        link_other_button: 'Link a different wallet',
        title: 'Cannot link this wallet to a new account',
      },
      confirm_button: 'Link wallet to current account',
      existent_account: {
        acceptance: 'I understand that linking this wallet means that I will lose access to the other account.',
        warning: 'Linking your wallet to this account will unlink it from its previously associated account',
      },
      log_out_button: 'Log out',
      title: 'Transfer this wallet?'
    }
   */
    dyn_wallet_link: {
        cannot_link: {
            cancel_button: 'Cancel',
            description: 'This wallet is the only wallet in your other account. You cannot transfer it, since then you will lose access to that account.',
            link_other_button: 'Link a different wallet',
            title: 'Cannot link this wallet to a new account',
        },
        confirm_button: 'Link wallet to current account',
        existent_account: {
            acceptance: 'I understand that linking this wallet means that I will lose access to the other account.',
            warning: 'Linking your wallet to this account will unlink it from its previously associated account',
        },
        log_out_button: 'Log out',
        title: 'Transfer this wallet?',
        already_exists: {
            title: 'Wallet Already Linked',
            description: 'This wallet is already used as an embedded wallet. You cannot link it unless you delete the existing embedded wallet.',
        },
    },
    /**
   * @description copy keys for connecting wallets list view
   * @default
   * {
      configuration_mismatch: 'Oops, no login methods have been configured.',
      helper: 'Get your first wallet',
      search: {
        label: 'Search through {{numberOfWallets}} wallets...',
        not_found: {
          description: 'The wallet you’re looking for may not be available, or linking more than one of these wallets might not be possible.',
          title: 'Wallet not available',
        },
      },
      title: {
        connect: 'Connect a new wallet',
        link: 'Link a new wallet',
        select: 'Select your wallet',
      },
      view_all: 'View all wallets',
      wallet_missing: {
        description: 'Try search instead',
        title: "Don't see your wallet?",
      },
    }
   */
    dyn_wallet_list: {
        configuration_mismatch: 'Oops, no login methods have been configured.',
        helper: 'Get your first wallet',
        search: {
            label: 'Search through {{numberOfWallets}} wallets...',
            not_found: {
                description: 'The wallet you’re looking for may not be available, or linking more than one of these wallets might not be possible.',
                title: 'Wallet not available',
            },
        },
        title: {
            connect: 'Connect a new wallet',
            link: 'Link a new wallet',
            select: 'Select your wallet',
        },
        view_all: 'View all wallets',
        wallet_missing: {
            description: 'Try search instead',
            title: "Don't see your wallet?",
        },
    },
    /**
   * @description copy keys for transferring wallets between accounts view
   * @default
   * {
      sign: {
        spinner: {
          cancel: 'Cancel',
          confirm_transfer:
          'Sign the message to confirm transferring this wallet to this account.',
        },
        title: 'Sign to confirm transfer',
      },
    }
   */
    dyn_wallet_transfer: {
        sign: {
            spinner: {
                cancel: 'Cancel',
                confirm_transfer: 'Sign the message to confirm transferring this wallet to this account.',
            },
            title: 'Sign to confirm transfer',
        },
    },
    /**
   * @description copy keys for Dynamic widget
   * @default
   * {
      connect: 'Log in or sign up',
      empty_wallets: '{{action}} additional wallets to see them here.',
      other_wallets: 'My other wallets',
    }
   */
    dyn_widget: {
        connect: 'Log in or sign up',
        empty_wallets: '{{action}} additional wallets to see them here.',
        other_wallets: 'My other wallets',
        empty_wallets_action_link: 'Link',
        empty_wallets_action_connect: 'Connect',
    },
    /**
   * @description copy keys for Dynamic wallet information card
   * @default
   * {
      balance: 'Balance'
    }
   */
    dyn_wallet_information: {
        balance: 'Balance',
        multi_asset: {
            empty_state: 'No assets in this wallet',
        },
    },
    /**
   * @description copy keys for Unlink wallet prompt
   * @default
   * {
      disconnect_title: 'Disconnect your wallet?',
      unlink_title: 'Unlink your wallet?',
      disconnect_description: 'Are you sure you want to disconnect your wallet?',
      unlink_description: 'Are you sure you want to unlink your wallet?',
      disconnect_button: 'Yes, disconnect',
      unlink_button: 'Yes, unlink',
      cancel_button: 'No',
    }
   */
    dyn_unlink_wallet_pop_up: {
        disconnect_title: 'Disconnect your wallet?',
        unlink_title: 'Unlink your wallet?',
        disconnect_description: 'Are you sure you want to disconnect your wallet?',
        unlink_description: 'Are you sure you want to unlink your wallet?',
        disconnect_button: 'Yes, disconnect',
        unlink_button: 'Yes, unlink',
        cancel_button: 'No',
    },
    /**
   * @description copy keys for the user profile widget
   * @default
   * {
      my_information: {
        title: 'My information',
      },
      my_wallet: {
        title: 'My wallet',
      },
      social_accounts: {
        title: 'Social accounts',
      },
      tooltips: {
        verified_email: 'This email is verified',
        verified_phone: 'This phone number is verified',
      },
      wallets: {
        link_wallet_button: 'Link wallet',
        title: 'Wallets',
      },
    }
   */
    dyn_user_profile: {
        my_information: {
            title: 'My information',
        },
        my_wallet: {
            title: 'My wallet',
        },
        social_accounts: {
            title: 'Social accounts',
        },
        tooltips: {
            verified_email: 'This email is verified',
            verified_phone: 'This phone number is verified',
        },
        wallets: {
            link_wallet_button: 'Link wallet',
            title: 'Want to add a wallet?',
        },
        edit_profile_button: 'Edit Profile',
    },
    /**
   * @description copy keys for Dynamic subdomain field
   * @default
   * {
      label: 'Subdomain Handle',
      available: 'Subdomain is available',
      not_available: 'Subdomain is not available',
      error: 'Subdomain check failed',
      details:
        'A subdomain handle will create a unique ENS subdomain for your wallet, helping you easily share and identify it.',
    }
   */
    dyn_subdomain_field: {
        label: 'Subdomain Handle',
        available: 'Subdomain is available',
        not_available: 'Subdomain is not available',
        error: 'Subdomain check failed',
        details: 'A subdomain handle will create a unique ENS subdomain for your wallet, helping you easily share and identify it.',
    },
    /**
   * @description copy keys for Detected new wallet prompt
   * @default
   * {
      title: 'Account Change Detected',
      description: 'Your active account in {{walletName}} has changed. This account is not currently linked to this app. Do you want to add it?',
      confirm_button: 'Yes, link this wallet',
    }
   */
    dyn_detected_new_wallet: {
        title: 'Account Change Detected',
        description: 'Your active account in {{walletName}} has changed. This account is not currently linked to this app. Do you want to add it?',
        confirm_button: 'Yes, link this wallet',
    },
    /**
     * @description copy keys for sync wallet view
     * @default
     * {
        switch_wallet: {
          title: 'Your wallets are mismatched. \nSwitch to continue.',
          active_address: {
            heading: 'Currently active in wallet',
          },
          expected_address: {
            heading: 'Currently active on website',
            prompt: 'Manually switch to this wallet',
          },
        },
        reconnecting: {
          title: 'This wallet is not connected',
          description: 'Reconnecting wallet {{walletAddress}} to make it active...',
        },
        reconnect_with_qr_code: {
          title: 'This wallet is not connected',
        },
        cancel_button: 'Cancel',
        retry_button: 'Retry',
      }
    */
    dyn_sync_wallet: {
        switch_wallet: {
            title: 'Your wallets are mismatched. \nSwitch to continue.',
            active_address: {
                heading: 'Currently active in wallet',
            },
            expected_address: {
                heading: 'Currently active on website',
                prompt: 'Manually switch to this wallet',
            },
        },
        reconnecting: {
            title: 'This wallet is not connected',
            description: 'Reconnecting wallet {{walletAddress}} to make it active...',
        },
        reconnect_with_qr_code: {
            title: 'This wallet is not connected',
        },
        cancel_button: 'Cancel',
        retry_button: 'Retry',
    },
    /**
   * @description copy keys for the wallet funding flow
   * @default
   * {
      success: 'Transaction processing',
      success_txn_link: 'View transaction',

      funding_method_selection: {
        title: 'Deposit',
        qr_option: 'Receive by QR',
        buy_option: 'Buy Crypto',
        external_wallet_option: 'From External Wallets',
      },
      onramp_provider_selection: {
        title: 'Select provider',
        description: 'Select from a list of available onramp providers.',
      },
      from_external_wallet: {
        wallet_list: {
          title: 'Fund from Wallet',
        },
        funding_view: {
          title: 'Fund from Wallet',
          wallet_detail_from: 'From',
          confirm_button: 'Confirm Transaction',
          pricing_unavailable:
            'Pricing unavailable.',
          minimum_error: 'Minimum {{minimum}}',
          balance_error: 'Insufficient funds',
        },
        token_select: {
          title: 'Select a Token',
          search_placeholder: 'Search for a token',
          no_assets_title: 'No Supported Assets',
          no_assets_description: 'This wallet does not support any assets',
        },
      },
    }
   */
    dyn_wallet_funding: {
        success: 'Transaction processing',
        success_txn_link: 'View transaction',
        funding_method_selection: {
            title: 'Deposit',
            qr_option: 'Receive by QR',
            buy_option: 'Buy Crypto',
            external_wallet_option: 'From External Wallets',
        },
        onramp_provider_selection: {
            title: 'Select provider',
            description: 'Select from a list of available onramp providers.',
        },
        from_external_wallet: {
            wallet_list: {
                title: 'Fund from External Wallet',
            },
            funding_view: {
                title: 'Fund from External Wallet',
                wallet_detail_from: 'From',
                confirm_button: 'Confirm Transaction',
                pricing_unavailable: 'Pricing unavailable.',
                minimum_error: 'Minimum {{minimum}}',
                balance_error: 'Insufficient funds',
            },
            token_select: {
                title: 'Select a Token',
                search_placeholder: 'Search for a token',
                no_assets_title: 'No Supported Assets',
                no_assets_description: 'No supported assets in this wallet',
            },
        },
    },
    /**
   * @description copy keys for Dynamic widget header
   * @default
   * {
      buttons: {
        deposit_funds: 'Deposit',
        send_funds: 'Send',
        more: 'More',
      },
    }
   */
    dyn_widget_header: {
        buttons: {
            deposit_funds: 'Deposit',
            send_funds: 'Send',
            more: 'More',
        },
    },
};

// The English translation is here: node_modules/@dynamic-labs/sdk-react-core/src/lib/locale/en/translation.js.
var ja = {
    /**
   * @description copy keys for account exists view
   * @default
   * {
        connect: 'Connect with {{socialOauth}}',
        description: 'It looks like an account already exists using',
        title: 'Account already exists',
        trail_message_email: '. Please log in with your email.',
        trail_message_social: 'through {{socialOauth}}',
      }
   */
    dyn_sandbox_maximum_threshold: {
        title: 'Max User Limit Reached',
        description: 'Your sandbox environment has reached your 100 MAU limit. To test with new users, delete existing users.',
        button: 'Back',
    },
    dyn_account_exists: {
        connect: 'Connect with {{socialOauth}}',
        description_email: 'It looks like an account already exists using',
        description_social: 'To restore your account to the right place, we need you to log in again.',
        title: 'Re-Authentication Required',
        trail_message_email: '. Please log in with your email.',
        trail_message_social: 'through {{socialOauth}}',
    },
    /**
   * @description copy keys for active wallet information (address, network, etc)
   * @default
   * {
        testnet_warning: 'A testnet network has been selected. Please only use testnet funds or they will be lost.',
        ordinals_address: 'Ordinals address',
        payment_address: 'Payment address',
        balance: 'Balance',
        options: {
          copy_ens: 'Copy ENS',
          view_address: 'View address',
          settings: 'Wallet settings',
          export: 'Export private keys',
        },
      }
   */
    dyn_active_wallet_info: {
        testnet_warning: 'A testnet network has been selected. Please only use testnet funds or they will be lost.',
        ordinals_address: 'Ordinals address',
        payment_address: 'Payment address',
        balance: 'Balance',
        options: {
            copy_ens: 'Copy ENS',
            view_address: 'View address',
            settings: 'Wallet settings',
            export: 'Export private keys',
        },
    },
    /**
   * @description copy keys for wallet details card
   * @default
   * {
        header: 'Wallet Details',
        address: 'Address',
        copy: 'Copy',
        copied: 'Copied!',
     }
   */
    dyn_wallet_details_card: {
        header: 'Wallet Details',
        address: 'Address',
        copy: 'Copy',
        copied: 'Copied!',
    },
    /**
   * @description copy keys for add network view
   * @default
   * {
      title: 'Add {{name}} network to your wallet',
      add_button: {
        title: 'Add network',
      },
      cancel_button: {
        title: 'Cancel',
      },
    }
   */
    dyn_add_network_view: {
        title: 'Network unavailable',
        description: 'This network is not supported in your {{name}} wallet.',
        add_button: {
            title: 'Add Network',
        },
        cancel_button: {
            title: 'Cancel',
        },
    },
    /**
   * @description copy keys for bridge view
   * @default
   * {
        summary_view: {
          connection_succeed: 'Congratulations on connecting both your {{firstBlockchainName}} and {{secondBlockchainName}} wallets',
          title: 'Welcome to {{appName}}',
        },
        welcome_view: {
          button: 'Get started',
          description: 'You’ll need to connect both your {{firstBlockchainName}} and {{secondBlockchainName}} wallets to get started',
          title: 'Connect to {{appName}}',
        },
        widget: {
          address: 'Copy wallet address',
          connect: 'Connect wallet',
          connect_with_network: 'Connect {{blockchainName}} wallet',
          copy: {
            address: 'Copy wallet address',
            ens: 'Copy ENS',
          },
          disconnect: 'Disconnect',
          edit_profile: 'Edit profile',
          wallet_network: '{{networkName}} wallet',
        },
      }
   */
    dyn_bridge: {
        summary_view: {
            connection_succeed: 'Congratulations on connecting both your {{firstBlockchainName}} and {{secondBlockchainName}} wallets',
            title: 'Welcome to {{appName}}',
        },
        welcome_view: {
            button: 'Get started',
            description: 'You’ll need to connect both your {{firstBlockchainName}} and {{secondBlockchainName}} wallets to get started',
            title: 'Connect to {{appName}}',
        },
        widget: {
            address: 'Copy wallet address',
            connect: 'Connect wallet',
            connect_with_network: 'Connect {{blockchainName}} wallet',
            copy: {
                address: 'Copy wallet address',
                ens: 'Copy ENS',
            },
            disconnect: 'Disconnect',
            edit_profile: 'Edit profile',
            wallet_network: '{{networkName}} wallet',
        },
    },
    /**
   * @description copy keys for Dynamic Captcha
   * @default
   * {
      verify_user_subtitle: 'We need to quickly verify you’re human before we proceed.',
      verify_user_title: "Let's verify you're human",
    }
   */
    dyn_captcha: {
        verify_user_subtitle: 'We need to quickly verify you’re human before we proceed.',
        verify_user_title: "Let's verify you're human",
    },
    /**
     * @description copy keys for sanctioned access blocked view
     * @default
     * {
     *  title: 'Access Blocked',
     *  content: 'Logging in is not available to persons in {{jurisdiction}} as you are in a sanctioned jurisdiction.',
     * }
     */
    dyn_access_blocked: {
        title: 'Access Blocked',
        content: 'Logging in is not available to persons in {{jurisdiction}} as you are in a sanctioned jurisdiction.',
    },
    /**
   * @description copy keys for chainalysis blocked wallet view
   * @default
   * {
       title: 'Access denied',
     }
   */
    dyn_chainalysis_blocked_wallet: {
        title: 'Access denied',
    },
    /**
   * @description copy keys for collecting user data
   * @default
   * {
      description: 'We need a bit of information to get started',
      fields: {
        alias: {
          label: 'Alias',
        },
        country: {
          label: 'Country',
        },
        email: {
          label: 'Email',
          validation: 'Email is not valid',
        },
        first_name: {
          label: 'First Name',
        },
        job_title: {
          label: 'Job Title',
        },
        last_name: {
          label: 'Last Name',
        },
        phone_number: {
          label: 'Phone number',
          validation: 'Phone number is not valid',
          too_short: 'Phone number is too short',
        },
        policies_consent: {
          label: 'Policies Consent',
        },
        t_shirt_size: {
          label: 'T-Shirt Size',
        },
        team: {
          label: 'Team',
        },
        username: {
          label: 'Username',
          validation: 'Username is not valid',
        },
      },
      greeting: 'Welcome to {{appName}}',
      log_out_button: 'Log out',
      not_supported_network: {
        description: 'Your wallet is not connected to a supported network. Please update before continuing.',
        error_message: 'This network is not available, please update.',
        title: 'Update Network',
      },
      update_email_tooltip:
      'This email is tied to your wallet so cannot be updated',
      update_phone_number_tooltip:
      'This phone number is tied to your wallet so cannot be updated',
      lock_editing_multiple_verified_fields:
      'You can only edit 1 field at a time that requires verification',
    }
   */
    dyn_collect_user_data: {
        description: 'We need a bit of information to get started',
        fields: {
            alias: {
                label: 'Alias',
            },
            country: {
                label: 'Country',
            },
            email: {
                label: 'メールアドレス',
                validation: 'このメールアドレスは無効です',
            },
            first_name: {
                label: 'First Name',
            },
            job_title: {
                label: 'Job Title',
            },
            last_name: {
                label: 'Last Name',
            },
            phone_number: {
                label: 'Phone number',
                validation: 'Phone number is not valid',
                too_short: 'Phone number is too short',
            },
            policies_consent: {
                label: 'Policies Consent',
            },
            t_shirt_size: {
                label: 'T-Shirt Size',
            },
            team: {
                label: 'Team',
            },
            username: {
                label: 'Username',
                validation: 'Username is not valid',
            },
        },
        greeting: '{{appName}}へようこそ',
        log_out_button: 'ログアウト',
        not_supported_network: {
            description: 'Your wallet is not connected to a supported network. Please update before continuing.',
            error_message: 'This network is not available, please update.',
            title: 'Update Network',
        },
        update_email_tooltip: 'This email is tied to your wallet so cannot be updated',
        update_phone_number_tooltip: 'This phone number is tied to your wallet so cannot be updated',
        lock_editing_multiple_verified_fields: 'You can only edit 1 field at a time that requires verification',
    },
    /**
   * @description copy keys for create password view
   * @default
   * {
      continue: 'Continue',
      create_input: {
        label: 'Create passcode',
        placeholder: 'Create passcode',
      },
      confirm_input: {
        label: 'Confirm passcode',
        placeholder: 'Confirm passcode',
      },
      current_password_input: {
        label: 'Current passcode',
        placeholder: 'Current passcode',
      },
      description:
        "Choose a strong, unique passcode to ensure your account's security and privacy.",
      errors: {
        invalid_current_password: 'Invalid current passcode',
        error_changing_password: 'Error changing passcode',
        new_password_same_as_old: 'New passcode cannot be the same as the old passcode',
        password_mismatch: 'Passcodes do not match',
        user_closed_view: 'User closed the view',
      },
      intro: {
        continue: 'Set up a passcode',
        description: {
          title: 'Add a passcode to protect your account',
          additional_protection: {
            title: 'Passcode Security',
            description:
              'Add a secure passcode to further prevent un-authrized access to your account.',
          },
          restore_access: {
            title: 'Restore Access',
            description:
              'You will be asked to enter it when signing on to a new device.',
          },
        },
        title: 'Add a Passcode',
      },
      logout: 'Log out',
      title: {
        create: 'Create passcode',
        update: 'Create new passcode',
      },
      update_input: {
        label: 'New passcode',
        placeholder: 'New passcode',
      },
    }
   */
    dyn_create_password: {
        continue: 'Continue',
        create_input: {
            label: 'Create passcode',
            placeholder: 'Create passcode',
        },
        confirm_input: {
            label: 'Confirm passcode',
            placeholder: 'Confirm passcode',
        },
        current_password_input: {
            label: 'Current passcode',
            placeholder: 'Current passcode',
        },
        description: "Choose a strong, unique passcode to ensure your account's security and privacy.",
        errors: {
            invalid_current_password: 'Invalid current passcode',
            error_changing_password: 'Error changing passcode',
            new_password_same_as_old: 'New passcode cannot be the same as the old passcode',
            password_mismatch: 'Passcodes do not match',
            user_closed_view: 'User closed the view',
        },
        intro: {
            continue: 'Set up a passcode',
            description: {
                title: 'Add a passcode to protect your account',
                additional_protection: {
                    title: 'Passcode Security',
                    description: 'Add a secure passcode to further prevent un-authrized access to your account.',
                },
                restore_access: {
                    title: 'Restore Access',
                    description: 'You will be asked to enter it when signing on to a new device.',
                },
            },
            title: 'Add a Passcode',
        },
        logout: 'ログアウト',
        title: {
            create: 'Create passcode',
            update: 'Create new passcode',
        },
        update_input: {
            label: 'New passcode',
            placeholder: 'New passcode',
        },
    },
    /**
   * @description copy keys for creating wallet wallet message
   * @default
   * {
      loading_message: 'Your wallet is being created...',
    }
   */
    dyn_creating_wallet: {
        loading_message: 'Your wallet is being created...',
    },
    /**
   * @description copy keys for email verification view after email logging in with magiclink
   * @default
   * {
      description: 'We’ve sent a verification email to',
      note: 'Note: it might take a few seconds to proceed after clicking the link in your email',
      title: 'Confirm your email',
    }
   */
    dyn_email_confirmation: {
        description: 'We’ve sent a verification email to',
        note: 'Note: it might take a few seconds to proceed after clicking the link in your email',
        title: 'Confirm your email',
    },
    /**
   * @description copy keys for email update view
   * @default
   * {
      current_email: 'Your current email address is',
      label: 'Email address',
      send_verification: 'Send Verification Code',
      title: 'Update email',
    }
  */
    dyn_email_update: {
        current_email: 'Your current email address is',
        label: 'Email address',
        send_verification: 'Send Verification Code',
        title: 'Update email',
    },
    /**
   * @description copy keys for one-time password verification view after logging in with dynamic email or phone number provider or after kyc verification
   * @default
   * {
      code_not_received: 'Did not receive a code? Check spam or',
      code_sent: 'Code sent',
      description: 'We’ve sent a verification code to',
      log_out_button: 'Log out',
      resend_code: 'Re-send code',
      resend_code_in: 'Re-send code in {{remainingSeconds}}',
      confirm_code: 'Confirm verification code',
      verification_succeeded: 'Verification code confirmed',
      hang_tight: 'Hang tight while we get things ready for you',

      email: {
        title: 'Confirm your email',
        complete:
          'Verification complete, the email is now verified to this account.',
      },
      phone_number: {
        title: 'Confirm your phone number',
        edit: 'Edit phone number',
        complete:
          'Verification complete, the phone number is now verified to this account.',
      },
    },
   */
    dyn_otp_verification: {
        code_not_received: 'Did not receive a code? Check spam or',
        code_sent: 'Code sent',
        description: 'We’ve sent a verification code to',
        log_out_button: 'Log out',
        resend_code: 'Re-send code',
        resend_code_in: 'Re-send code in {{remainingSeconds}}',
        confirm_code: 'Confirm verification code',
        verification_succeeded: 'Verification code confirmed',
        hang_tight: 'Hang tight while we get things ready for you',
        email: {
            title: 'Confirm your email',
            complete: 'Verification complete, the email is now verified to this account.',
        },
        phone_number: {
            title: 'Confirm your phone number',
            edit: 'Edit phone number',
            complete: 'Verification complete, the phone number is now verified to this account.',
        },
    },
    /**
   * @description copy keys for deposit view
   * @default
   * {
      title: 'Deposit',
    }
   */
    dyn_deposit: {
        title: 'Deposit',
        receive_funds_on: 'You can receive tokens on ',
    },
    /**
   * @description copy keys for embedded wallet authenticator choice view
   * @default
   * {
      description:
        'Protect your account and simplify your transaction experience.',
      email: {
        badge: 'Fastest',
        description: ' You will need to renew after {{expiration}} minutes ',
        title: 'Use a one-time code',
      },
      passkey: {
        auth_info: {
          convinience: {
            title: 'Convenient and Fast',
            description:
              'Use Face ID or Touch ID to complete transactions quickly.',
          },
          security: {
            title: 'Increased Security',
            description:
              'Passkeys are encrypted end-to-end on your device or password manager to prevent phishing attempts.',
          },
          add_button: 'Add a passkey',
          start_button: 'Add a passkey',
        },
        no_email_auth_info: {
          convinience: {
            title: 'Simple and Fast',
            description:
              'Works across devices and syncs between devices and browsers.',
          },
          security: {
            title: 'Secured with a bio-metric',
            description: 'Phishing resistant and encrypted.',
          },
          add_button: 'Add passkey',
          start_button: 'Add passkey',
        },
        badge: 'Recommended',
        description:
          'Works across devices & secured with biometric to prevent phishing attempts ',
        title: 'Create new passkey',
        reveal_title: 'Add a passkey',
      },
      skip: 'Not now',
      title: 'Account security',
      need_help_title: 'Problem Signing?',
      need_help_description: 'Select from an option below to complete',
      reveal_title: 'Verification Required',
      reveal_description: 'Choose a verification method.',
    }
   */
    dyn_embedded_authenticator: {
        description: 'Protect your account and simplify your transaction experience.',
        email: {
            badge: 'Fastest',
            description: ' You will need to renew after {{expiration}} minutes ',
            title: 'Use a one-time code',
        },
        passkey: {
            auth_info: {
                convinience: {
                    title: 'Convenient and Fast',
                    description: 'Use Face ID or Touch ID to complete transactions quickly.',
                },
                security: {
                    title: 'Increased Security',
                    description: 'Passkeys are encrypted end-to-end on your device or password manager to prevent phishing attempts.',
                },
                add_button: 'Add a passkey',
                start_button: 'Add a passkey',
            },
            no_email_auth_info: {
                convinience: {
                    title: 'Simple and Fast',
                    description: 'Works across devices and syncs between devices and browsers.',
                },
                security: {
                    title: 'Secured with a bio-metric',
                    description: 'Phishing resistant and encrypted.',
                },
                add_button: 'Add passkey',
                start_button: 'Add passkey',
            },
            badge: 'Recommended',
            description: 'Works across devices & secured with biometric to prevent phishing attempts ',
            title: 'Create new passkey',
            reveal_title: 'Add a passkey',
        },
        skip: 'Not now',
        title: 'Account security',
        need_help_title: 'Problem Signing?',
        need_help_description: 'Select from an option below to complete',
        reveal_title: 'Verification Required',
        reveal_description: 'Choose a verification method.',
    },
    /**
     * @description copy keys for enter password view
     * @default
     * {
        continue_button_label: 'Continue',
        description: 'Please enter your passcode below to continue.',
        error: {
          invalid_password: 'Invalid passcode',
        },
        input: {
          label: 'Passcode',
          placeholder: 'Passcode',
        },
        title: 'Enter passcode',
      }
     */
    dyn_enter_password: {
        continue_button_label: 'Continue',
        description: 'Please enter your passcode below to continue.',
        error: {
            invalid_password: 'Invalid passcode',
        },
        input: {
            label: 'Passcode',
            placeholder: 'Passcode',
        },
        title: 'Enter passcode',
    },
    /**
     * @description copy keys for Dynamic Farcaster connect view
     * @default
     * {
        copy_button: 'Copy QR URI',
        scan_title: "Scan this QR code from your mobile app or phone's camera to connect.",
      }
     */
    dyn_farcaster_connect_view: {
        copy_button: 'Copy QR URI',
        scan_title: "Scan this QR code from your mobile app or phone's camera to connect.",
    },
    /**
   * @description copy keys for log in view
   * @default
   * dyn_login: {
    connect_wallet: {
      title: 'Connect',
    },
    email_form: {
      email_field: {
        label: 'Enter your email',
      },
      submit_button: {
        label: 'Continue',
      },
    },
    email_or_phone: {
      use_email: 'Use email',
      use_phone: 'Use phone',
      prefer_email: 'Prefer email sign up?',
      prefer_phone: 'Prefer phone number sign up?',
    },
    helper: {
      all_wallet_list: 'Get your first wallet',
      email_form: {
        invalid_email: 'Invalid or incorrect email. Did you mistype it?',
      },
      pending_connect: {
        title: 'Connecting a wallet',
      },
      pending_signature: {
        title: 'Signing a wallet',
      },
      pending_signature_without_back_button: {
        title: 'Signing a wallet',
      },
      phone_number_form: {
        invalid_phone: 'Invalid or incorrect number. Did you mistype it?',
        invalid_sms_verification:
          'The code you entered is incorrect. Please try again.',
        too_many_sms_verification_attempts:
          'Too many verification attempts, please try again later.',
      },
      qr_code: {
        title: 'Connecting a wallet',
      },
      wallet_only: 'Get your first wallet',
    },
    qr_code: {
      title: 'Connect',
    },
    separators: {
      default: 'OR',
    },
    sign_wallet: {
      title: 'Sign',
    },
    select_wallet_in_wallet_group: {
      title: 'Select',
    },
    social: {
      button_label: 'Continue with {{provider}}',
      overlay_title: 'Choose a social account',
    },
    title: {
      all: 'Log in or sign up',
      all_wallet_list: 'Select your wallet',
      wallet_only: 'Select your wallet',
    },
    wallet_group: {
      title: 'Select Chain',
    },
    wallet_list: {
      button_only: 'Continue with a wallet',
    },
    mobile_wallet_redirect: {
      backup_title: 'Connect mobile app',
      prompt: "Tap 'Open' to continue",
      get_app_prompt: 'Get',
      open_prompt: 'Open',
      redirect_fail_message:
        "If the app doesn't open, you might need to download the {{walletName}} Wallet app.",
      app_store: 'App Store',
      play_store: 'Play Store',
    },
    wrong_social_account: {
      retry_button: 'Try again',
      retry_title: 'Please connect with: ',
      subtitle:
        'You must connect with the same account you originally signed in with.',
      title: 'Whoops. Wrong Account',
    },
  },
   */
    dyn_login: {
        connect_wallet: {
            title: '接続',
        },
        email_form: {
            email_field: {
                label: 'Eメールを入力',
            },
            submit_button: {
                label: '続ける',
            },
        },
        email_or_phone: {
            use_email: 'Use email',
            use_phone: 'Use phone',
            prefer_email: 'Prefer email sign up?',
            prefer_phone: 'Prefer phone number sign up?',
        },
        helper: {
            all_wallet_list: 'Get your first wallet',
            email_form: {
                invalid_email: 'Invalid or incorrect email. Did you mistype it?',
            },
            pending_connect: {
                title: 'Connecting a wallet',
            },
            pending_signature: {
                title: 'Signing a wallet',
            },
            pending_signature_without_back_button: {
                title: 'Signing a wallet',
            },
            phone_number_form: {
                invalid_phone: 'Invalid or incorrect number. Did you mistype it?',
                invalid_sms_verification: 'The code you entered is incorrect. Please try again.',
                too_many_sms_verification_attempts: 'Too many verification attempts, please try again later.',
            },
            qr_code: {
                title: 'Connecting a wallet',
            },
            wallet_only: 'Get your first wallet',
        },
        qr_code: {
            title: 'Connect',
        },
        separators: {
            default: 'OR',
        },
        sign_wallet: {
            title: 'Sign',
        },
        select_wallet_in_wallet_group: {
            title: 'Select',
        },
        social: {
            button_label: '{{provider}}を使う',
            overlay_title: 'ソーシャルアカウントを選ぶ',
        },
        title: {
            all: 'サインイン/会員登録',
            all_wallet_list: 'Select your wallet',
            wallet_only: 'Select your wallet',
        },
        wallet_group: {
            title: 'Select Chain',
        },
        wallet_list: {
            button_only: 'ウォレットを使う',
        },
        mobile_wallet_redirect: {
            backup_title: 'Connect mobile app',
            prompt: "Tap 'Open' to continue",
            get_app_prompt: 'Get',
            open_prompt: 'Open',
            redirect_fail_message: "If the app doesn't open, you might need to download the {{walletName}} Wallet app.",
            app_store: 'App Store',
            play_store: 'Play Store',
        },
        wrong_social_account: {
            retry_button: 'Try again',
            retry_title: 'Please connect with: ',
            subtitle: 'You must connect with the same account you originally signed in with.',
            title: 'Whoops. Wrong Account',
        },
    },
    /**
   * @description copy keys for Dynamic manage passkeys view which are used inside dynamic widget
   * @default
   * {
      title: 'My passkeys',
      passkey_from: 'from',
      passkey_providers: {
        android: 'Android Phone',
        brave: 'Brave Browser',
        chrome: 'Google Chrome',
        edge: 'Microsoft Edge',
        firefox: 'Firefox',
        iPhone: 'iPhone',
        opera: 'Opera Browser',
        safari: 'Safari Browser',
      },
      recovery_button: 'Set up new passkey',
    }
   */
    dyn_manage_passkeys: {
        title: 'パスキー管理',
        passkey_from: 'from',
        passkey_providers: {
            android: 'Android Phone',
            brave: 'Brave Browser',
            chrome: 'Google Chrome',
            edge: 'Microsoft Edge',
            firefox: 'Firefox',
            iPhone: 'iPhone',
            opera: 'Opera Browser',
            safari: 'Safari Browser',
        },
        recovery_button: '新しいパスキーをセットアップ',
    },
    /**
   * @description copy keys for Dynamic rename passkey view
   * @default
   * {
    error: Whoops! There was an error updating your passkey
    input_label: 'Passkey name',
    save: 'Save',
    title: 'Rename your passkey',
    not_found: 'No passkeys found',
   }
   */
    dyn_rename_passkeys: {
        error: 'Whoops! There was an error updating your passkey',
        input_label: 'Passkey name',
        save: 'Save',
        title: 'Rename your passkey',
        not_found: 'No passkeys found',
    },
    /**
   * @description export keys for Dynamic embedded reveal view
   * @default
   * {
      title: 'Export wallet',
      agreement_title: 'Agree to continue',
      private_key_title: 'Private key',
      recovery_phrase_title: 'Secret recovery phrase',
      description:
        'Your wallet is non-custodial, meaning you are always in control of it.',
      statement_1: {
        title: 'Do not publicly share your {{keyType}}',
        description: 'Your {{keyType}} controls your account and assets.',
      },
      checkbox_label:
        'I am responsible for safeguarding and using my wallet key information.',
      reveal_description: 'Make sure to safely back up this information',
      reveal_button_label: 'Reveal',
      copy_button_label: 'Copy to clipboard',
      done_button_label: "I'm Done",
      aa_warning: {
         title: 'Your assets are not in this wallet.',
         subtitle:
         'This is a smart-contract wallet. You will not see your balance if you import this to an external service. Please send your assets to your preferred external wallet first to access your funds:',
         button: 'here',
      },
      unlink: 'Unlink wallet info',
    },
   */
    dyn_embedded_reveal: {
        title: 'Export wallet',
        agreement_title: '同意して続ける',
        prompt_for_export_title: 'Back up wallet key',
        private_key_title: 'Private key',
        recovery_phrase_title: 'Secret recovery phrase',
        badge_label: '機密性の高い情報',
        prompt_for_export_description: 'あなたのアカウント(ウォレット)はエクスポートの準備ができています。アセットやアイテムを保護するためにキーをバックアップします。',
        statement_1: {
            title: 'ノンカストディアル・ウォレット',
            description: '自分自身ですべてを管理します。',
        },
        statement_2: {
            title: 'アカウントとアセットを管理するためにキーをプライベートに保ってください。',
        },
        checkbox_label: '私は自分のアカウント(ウォレット)のキー情報を保護し、使用する責任を負います。',
        reveal_description: 'Make sure to safely back up this information',
        skip_button_label: 'Skip for now',
        reveal_button_label: 'Reveal',
        backup_button_label: 'Back up now',
        copy_button_label: 'Copy to clipboard',
        done_button_label: "I'm Done",
        aa_warning: {
            title: 'Your assets are not in this wallet.',
            subtitle: 'This is a smart-contract wallet. You will not see your balance if you import this to an external service. Please send your assets to your preferred external wallet first to access your funds:',
            button: 'here',
        },
        unlink: 'Unlink wallet info',
    },
    /**
     * @description export keys for Dynamic embedded delete view
     * @default
     *
     */
    dyn_embedded_delete: {
        title: 'Unlink from app',
        description_1: 'By continuing you acknowledge that if you return to the application, you will receive a new wallet address.',
        description_2: 'Once unlinked, you cannot recover any wallet information through this application including any associated smart contract wallets.',
        acknowledgement: 'I have safely backed up my wallet seed phrase information. If I return to this application, a new wallet will be created for me.',
        cancel_button: 'Cancel',
        action_button: 'Unlink & Log out',
    },
    /**
   * @description Settings for Dynamic settings view which are used inside dynamic widget
   * @default
   * {
    global_connectivity_section: {
      title: 'Global Connectivity',
      connected_apps_button: 'Connected Apps',
    },
    export_section: {
      private_key_button: 'Private key',
      srp_button: 'Recovery phrase',
      title: 'Export & Backup',
    },
    identity_section: {
      title: 'Recovery',
      add_email_button: 'Add an email',
    },
    tags: { recommended: 'Recommended' },
    security_section: {
      email_auth_button: 'One time code',
      passkey_button: 'Passkeys',
      password_button: 'Passcode',
      mfa_button: 'Authenticator App',
      title: '2 factor authentication',
    },
    title: 'Settings',
    button_logout: 'Log out',
    empty_screen: {
      title: 'Nothing to see here yet!',
    },
  }
   */
    dyn_settings: {
        global_connectivity_section: {
            title: 'Global Connectivity',
            connected_apps_button: 'Connected Apps',
        },
        export_section: {
            private_key_button: 'プライベートキー',
            srp_button: 'リカバリーフレーズ',
            title: 'エクスポートとバックアップ',
        },
        identity_section: {
            title: 'Recovery',
            add_email_button: 'Add an email',
        },
        tags: { recommended: 'Recommended' },
        security_section: {
            email_auth_button: 'One time code',
            passkey_button: 'パスキー',
            password_button: 'Passcode',
            mfa_button: 'Authenticator App',
            title: '2 段階認証',
        },
        title: '設定',
        button_logout: 'ログアウト',
        empty_screen: {
            title: 'Nothing to see here yet!',
        },
    },
    /**
   * @description copy keys for global wallet view
   * @default
   *  {
    connect_to_apps: 'Connect to apps',
    scan_qr_code: 'Scan QR Code',
    or: 'OR',
    walletconnect_uri: 'WalletConnect URI',
    the_dapp: 'the dApp',
    this_app: 'this app',
    confirm: {
      title: 'Confirm Connection',
      description: 'Are you sure you want to connect to {{name}}?',
      cancel_button: 'Cancel',
      connect_button: 'Connect',
    },
    banner: {
      warning: 'There was an error connecting to {{name}}.',
      success: 'Successfully connected to {{name}}.',
      already_connected: 'You are already connected to {{name}}.',
      expired:
        'The link you entered expired, please get a new URI from the app.',
      bad_input:
        'Invalid URI. Please check below for how to find the valid URI.',
    },
    help: {
      title: 'How do I find the URI code?',
      step: {
        1: '1. Go to the website you want to connect to',
        2: '2. Locate the "Connect" or "Login" button',
        3: '3. Open WalletConnect from the list',
      },
      learn_more: 'Learn more about global wallets',
    },
    malicious_site: {
      certain: {
        title: 'Malicious app detected!',
        subtitle_header: 'Risk of losing funds',
        subtitle_text:
          'The site is known to exploit and or take assets from connected wallets.',
        go_back: 'Cancel',
        proceed: 'Proceed',
      },
      unknown: {
        title: 'Site verification did not run.',
        subtitle_header: 'Double check the app',
        subtitle_text:
          'We were unable to verify the vailidity of the app at this time.',
        go_back: 'Cancel',
        proceed: 'Proceed',
      },
    },
     connected_apps: {
      title: 'Connected Apps',
      no_connections: 'No connected apps',
    },
  },
   */
    global_wallet: {
        connect_to_apps: 'Connect to apps',
        scan_qr_code: 'Scan QR Code',
        or: 'OR',
        walletconnect_uri: 'WalletConnect URI',
        the_dapp: 'the dApp',
        this_app: 'this app',
        confirm: {
            title: 'Confirm Connection',
            description: 'Are you sure you want to connect to {{name}}?',
            cancel_button: 'Cancel',
            connect_button: 'Connect',
        },
        banner: {
            warning: 'There was an error connecting to {{name}}.',
            success: 'Successfully connected to {{name}}.',
            already_connected: 'You are already connected to {{name}}.',
            expired: 'The link you entered expired, please get a new URI from the app.',
            bad_input: 'Invalid URI. Please check below for how to find the valid URI.',
        },
        help: {
            title: 'How do I find the URI code?',
            step: {
                1: '1. Go to the website you want to connect to',
                2: '2. Locate the "Connect" or "Login" button',
                3: '3. Open WalletConnect from the list',
            },
            learn_more: 'Learn more about global wallets',
        },
        malicious_site: {
            certain: {
                title: 'Malicious app detected!',
                subtitle_header: 'Risk of losing funds',
                subtitle_text: 'The site is known to exploit and or take assets from connected wallets.',
                go_back: 'Cancel',
                proceed: 'Proceed',
            },
            unknown: {
                title: 'Site verification did not run.',
                subtitle_header: 'Double check the app',
                subtitle_text: 'We were unable to verify the vailidity of the app at this time.',
                go_back: 'Cancel',
                proceed: 'Proceed',
            },
        },
        connected_apps: {
            title: 'Connected Apps',
            subtitle: 'Connected apps allow you to interact with your wallet on other platforms.',
            success: 'Successfully connected to {{name}}.',
        },
    },
    /**
   * @description copy keys for mfa management view
   * @default
   *  {
        title: 'Authenticator App',
        add_mfa_button: 'Authenticator App',
        no_devices: 'No authenticator apps configured',
        generate_backup_codes_button: 'Get new backup codes',
      },
   */
    dyn_manage_mfa: {
        title: 'Authenticator App',
        add_mfa_button: 'Authenticator App',
        no_devices: 'No authenticator apps configured',
        generate_backup_codes_button: 'Get new backup codes',
    },
    /**
   * @description copy keys for mfa views
   * @default
   * {
      choose_device_view: {
        title: 'Secure your account',
        select_options: 'Protect your account by adding multi-factor authentication',
        authenticator_app: 'Authenticator app',
        authenticator_app_description:
          'Use your preferred authenticator app such as Authy, Google Authenticator, etc.',
        backup_code: 'Backup code',
        backup_code_description:
          'Enter one of your saved backup codes to authenticate.',
        choose_another_method:  'Choose another method',
        choose_another_method_description: 'Use one of the methods below:',
      logout: 'Log out',
      },
      display_backup_codes_view: {
        title: 'Back up your codes',
        body: 'Backup codes help recover your account if you lose access to your device. Each code can be used only 1 time.',
        warning: 'You won’t be able to see these again',
        copy_all: 'Copy all',
        download: 'Download',
        checkbox: 'I have safely stored a copy of my backup codes',
        complete: 'Complete',
      },
      otp_verification_view: {
        title: 'Confirm verification code',
        body: 'Enter the verification code generated by your authenticator app',
        error: 'Invalid code. Please try again.',
        rate_limit_error: 'Too many attempts, please try again later.',
        choose_another_method: 'Sign in another way',
      },
      secure_device_view: {
        title: 'Secure your account',
        body: 'Setup a new sign-in method in your authenticator app',
        continue: 'Continue',
        helper: {
          button: "Can't scan QR Code?",
          title: 'Troubles with scanning?',
          step1: {
            title: 'Open your Authenticator App',
            description: 'You will set up a new sign-in method',
          },
          step2: {
            title: 'Enter the key provided below',
            description: 'Make sure time-based or one-time password is enabled.',
          },
          uri: {
            title: 'Copy the full URI',
            description:
              'This only works if your authenticator app supports TOTP URIs',
          },
        },
        logout: 'Log out',
      },
    },
   */
    dyn_mfa: {
        choose_device_view: {
            title: 'Secure your account',
            select_options: 'Protect your account by adding multi-factor authentication',
            authenticator_app: 'Authenticator app',
            authenticator_app_description: 'Use your preferred authenticator app such as Authy, Google Authenticator, etc.',
            backup_code: 'Backup code',
            backup_code_description: 'Enter one of your saved backup codes to authenticate.',
            choose_another_method: 'Choose another method',
            choose_another_method_description: 'Use one of the methods below:',
            logout: 'Log out',
        },
        display_backup_codes_view: {
            title: 'Back up your codes',
            body: 'Backup codes help recover your account if you lose access to your device. Each code can be used only 1 time.',
            warning: 'You won’t be able to see these again',
            copy_all: 'Copy all',
            download: 'Download',
            checkbox: "I've safely stored a copy of my backup codes",
            complete: 'Complete',
        },
        otp_verification_view: {
            title: 'Confirm verification code',
            body: 'Enter the verification code generated by your authenticator app',
            error: 'Invalid code. Please try again.',
            rate_limit_error: 'Too many attempts, please try again later.',
            choose_another_method: 'Sign in another way',
        },
        secure_device_view: {
            title: 'Secure your account',
            body: 'Setup a new sign-in method in your authenticator app',
            continue: 'Continue',
            helper: {
                button: "Can't scan QR Code?",
                title: 'Troubles with scanning?',
                step1: {
                    title: 'Open your Authenticator App',
                    description: 'You will set up a new sign-in method',
                },
                step2: {
                    title: 'Enter the key provided below',
                    description: 'Make sure time-based or one-time password is enabled.',
                },
                uri: {
                    title: 'Copy the full URI',
                    description: 'This only works if your authenticator app supports TOTP URIs',
                },
            },
            logout: 'Log out',
        },
        recovery_view: {
            title: 'Enter your backup code',
            body: 'Your backup code is one of the 10 codes you received when you first enrolled in multi-factor authentication',
            input_label: 'Enter back up code',
            button_label: 'Continue',
            get_help: {
                description: 'Missing your back up codes?',
                button_label: 'Get Help',
            },
            helper: {
                title: 'Mfa Recovery Help',
            },
        },
    },
    /**
   * @description copy keys for merge user accounts view
   * @default
   * {
      confirm_button: 'Merge accounts',
      errors: {
        merge_error: 'Something went wrong, please try again.',
      },
      wallet: {
        content: 'This wallet is associated to another account. Would you like to merge accounts?',
        title: 'Wallet already in use',
      },
    }
   */
    dyn_merge_user_accounts: {
        confirm_button: 'Merge accounts',
        errors: {
            merge_error: 'Something went wrong, please try again.',
        },
        wallet: {
            content: 'This wallet is associated to another account. Would you like to merge accounts?',
            title: 'Wallet already in use',
        },
    },
    /**
   * @description copy keys for merge user accounts conflicts view
   * @default
   * {
      confirm_button: 'Confirm & Merge',
      description:
        'You have some conflicting information. Please select your preferences',
      errors: {
        merge_error: 'Something went wrong, please try again.',
      },
      title: 'Confirm your preferences',
    }
   */
    dyn_merge_user_accounts_conflicts: {
        confirm_button: 'Confirm & Merge',
        description: 'You have some conflicting information. Please select your preferences',
        errors: {
            merge_error: 'Something went wrong, please try again.',
        },
        title: 'Confirm your preferences',
    },
    /**
   * @description copy keys for merge user accounts view when using email associated to a different account
   * @default
   * {
      cancel_button: "No, I'll use a different email",
      confirm_button: 'Yes, link to existing account',
      errors: {
        merge_error: 'Something went wrong, please try again.',
      },
      existing_account: 'An account already exists that uses',
      existing_account_trail: 'email.',
      title: 'Would you like to link this wallet to this existing account?',
    }
   */
    dyn_merge_user_accounts_with_same_email: {
        cancel_button: "No, I'll use a different email",
        confirm_button: 'Yes, link to existing account',
        errors: {
            merge_error: 'Something went wrong, please try again.',
        },
        existing_account: 'An account already exists that uses',
        existing_account_trail: 'email.',
        title: 'Would you like to link this wallet to this existing account?',
    },
    /**
   * @description copy key for Dynamic need help footer section
   * @default
   * {
      info: 'Problem Signing?',
      contact_support: 'Contact support',
      divider: 'or',
      help_button: 'go here.',
    }
   */
    dyn_need_help_section: {
        info: 'Need Help?',
        contact_support: 'Contact support',
        divider: 'or',
        help_button: 'Go here for support',
        visit_platform: 'Visit {{platform}}',
    },
    /**
   * @description copy keys for network not supported view
   * @default
   * {
      button: 'Switch Network',
      subtitle: 'Your wallet is not connected to a supported network. Please update before continuing.',
      title: 'Update Network',
      warning_message: 'This network is not available, please update.',
    }
   */
    dyn_network_not_supported: {
        button: 'Switch Network',
        subtitle: 'Your wallet is not connected to a supported network. Please update before continuing.',
        title: 'Update Network',
        warning_message: 'This network is not available, please update.',
        wallet: 'Not Supported',
    },
    /**
   * @description copy keys for network not supported view for manual switch
   * @default
   * {
      subtitle_network_defined_metamaskstarknet:
        'To continue, please update the network in your wallet to {{network}} by visiting the Starknet Snap companion app',
      subtitle_network_defined_metamaskstarknet_companion_app: 'companion app',
      subtitle_network_defined: 'To continue, please update the network in your wallet to {{network}}',
      subtitle_no_network_defined: 'Your wallet does not support switching networks from this app. Switch networks directly in your wallet.',
      title: 'Update your Network',
      warning_message: 'This network is not available, please update.',
    }
   */
    dyn_network_not_supported_manual_switch: {
        subtitle_network_defined_metamaskstarknet: 'To continue, please update the network in your wallet to {{network}} by visiting the Starknet Snap',
        subtitle_network_defined_metamaskstarknet_companion_app: 'companion app',
        subtitle_network_defined: 'To continue, please update the network in your wallet to {{network}}',
        subtitle_no_network_defined: 'Your wallet does not support switching networks from this app. Switch networks directly in your wallet.',
        title: 'Update your Network',
        warning_message: 'This network is not available, please update.',
    },
    /**
   * @description copy keys for no access view
   * @default
   * {
      chainalysis: {
        button_text: 'Try another method',
        description: 'This wallet has been correlated to illicit activity and cannot access this site.',
        social_media_link_text: 'Why am I seeing this message?',
        social_media_link_url: 'https://docs.dynamic.xyz/docs',
        title: 'This address seems corrupted.',
      },
      default: {
        button_text: 'Try another method',
        description: "You are not currently on the allow list.",
        title: 'Access denied',
      },
      gate: {
        button_text: 'Try a different wallet',
        description: 'A NFT or a token is required to access this site.',
        title: 'You cannot access the site',
      },
      not_in_the_list_image_alt: 'user is not in the list',
      title: "You don't have access",
    }
   */
    dyn_no_access: {
        chainalysis: {
            button_text: 'Try another method',
            description: 'This wallet has been correlated to illicit activity and cannot access this site.',
            social_media_link_text: 'Why am I seeing this message?',
            social_media_link_url: 'https://docs.dynamic.xyz/docs',
            title: 'This address seems corrupted.',
        },
        default: {
            button_text: 'Try another method',
            description: 'You are not currently on the allow list.',
            title: 'Access denied',
        },
        gate: {
            button_text: 'Try a different wallet',
            description: 'A NFT or a token is required to access this site.',
            title: 'You cannot access the site',
        },
        not_in_the_list_image_alt: 'user is not in the list',
        title: "You don't have access",
    },
    /**
   * @description copy keys for email OTP verification for magiclink
   * @default
   * {
      banner_text: 'Sign in to access your email based wallet',
    }
   */
    dyn_magic_verification: {
        banner_text: 'Sign in to access your email based wallet',
    },
    /**
   * @description copy key for passkey created success banner
   * @default
   * {
      text: 'A new passkey has been created',
    }
   */
    dyn_passkey_success: {
        created: 'A new passkey has been created',
        edited: 'Your passkey has been edited',
    },
    /**
   * @description copy keys for passkey intro view
   * @default
   * {
      button: 'Set up a passkey',
      button_logout: 'Log out',
      button_skip: 'Skip for now',
      disabled: 'Passkeys are not available on this device or browser. Please open on Chrome, Safari, or Brave to continue',
      helper: {
        section_1: {
          description: 'Passkeys are a standard built by Apple, Google and others, and eliminates the use of passwords.',
          title: 'Built by Apple and Google',
        },
        section_2: {
          description: 'Passkeys are stored on your phone and are not shared with anyone.',
          title: 'Secure and Private',
        },
        title: "What's Passkey",
        tooltip: 'Need some help?',
      },
      sms_auth: {
        title: 'Finish set up',
        description:
          'Add a security method to finish your profile and complete transactions',
      },
      subtitle: 'Passkeys are stored natively to your device with a biometric and can only be accessed by you.',
      title: 'Secure your wallet',
    }
   */
    dyn_passkey_intro: {
        button: 'Set up a passkey',
        button_logout: 'Log out',
        button_skip: 'Skip for now',
        disabled: 'Passkeys are not available on this device or browser. Please open on Chrome, Safari, or Brave to continue',
        helper: {
            section_1: {
                description: 'Passkeys are a standard built by Apple, Google and others, and eliminates the use of passwords.',
                title: 'Built by Apple and Google',
            },
            section_2: {
                description: 'Passkeys are stored on your phone and are not shared with anyone.',
                title: 'Secure and Private',
            },
            title: "What's Passkey",
            tooltip: 'Need some help?',
        },
        sms_auth: {
            title: 'Finish set up',
            description: 'Add a security method to finish your profile and complete transactions',
        },
        subtitle: 'Passkeys are stored natively to your device with a biometric and can only be accessed by you.',
        title: 'Secure your wallet',
    },
    /**
   * @description copy keys for passkey new domain detected modal
   * @default
   * {
   title: 'New domain detected',
   description: 'To complete your transaction select a signing method',
   actions: {
   passkey: {
   title: 'Add new passkey',
   subtitle: 'Does not expire. Works across devices & secured with biometric.',
   },
   emailAuth: {
   title: 'Use a one-time code',
   subtitle: 'Allows you to transact for 30 min',
   },
   badges: {
   recommended: 'Recommended',
   fastest: 'Fastest',
   },
   },
   }
   */
    dyn_passkey_new_domain_detected: {
        title: 'New domain detected',
        description: 'To complete your transaction select a signing method',
        actions: {
            passkey: {
                title: 'Add new passkey',
                subtitle: 'Does not expire. Works across devices & secured with biometric.',
            },
            emailAuth: {
                title: 'Use a one-time code',
                subtitle: 'Allows you to transact for 30 min',
            },
            badges: {
                recommended: 'Recommended',
                fastest: 'Fastest',
            },
        },
    },
    /**
   * @description copy keys for passkeys recovery flow
   * @default
   * {
      add_email: {
        description:
          'Don’t get locked out if you delete your passkey or lose your device.',
        input_label: 'Enter your email',
        title: 'Add a recovery email',
        confirm_button: 'Confirm with a passkey',
        skip_button: 'Skip for now',
        success_message: 'Recovery email added!',
      },
      code: {
          description: 'A verification code has been sent to {{email}}',
          input_label: 'Enter your code here...',
          title: 'Verification code sent',
        resend: {
            button: 'Resend code',
            text: "Didn't receive a code?",
        },
      },
      complete: {
        complete_button: 'Create a passkey',
        description: 'Secure your wallet by adding a new passkey.',
        title: 'Create a new passkey',
      },
      start: {
        description:
          'To complete this process, ensure you are using the same device/browser.',
        start_button: 'Send me an email',
        title: 'Initiate Request',
      },
    }
   */
    dyn_passkey_recovery: {
        add_email: {
            description: 'Don’t get locked out if you delete your passkey or lose your device.',
            input_label: 'Enter your email',
            title: 'Add a recovery email',
            confirm_button: 'Confirm with a passkey',
            skip_button: 'Skip for now',
            success_message: 'Recovery email added!',
        },
        code: {
            description: 'A verification code has been sent to {{email}}',
            input_label: 'Enter your code here...',
            title: 'Verification code sent',
            resend: {
                button: 'Resend code',
                text: "Didn't receive a code?",
            },
        },
        complete: {
            complete_button: 'Create a passkey',
            description: 'Secure your wallet by adding a new passkey.',
            title: 'Create a new passkey',
        },
        start: {
            description: 'To complete this process, ensure you are using the same device/browser.',
            start_button: 'Send me an email',
            title: 'Initiate Request',
        },
    },
    /**
   * @description copy keys for Dynamic pending wallet connection
   * @default
   * {
      mobile: 'Click connect in your mobile wallet',
      computer: 'Click connect in your wallet popup',
    }
   */
    dyn_pending_connection: {
        title: 'Connect',
        mobile: 'Click connect in your mobile wallet',
        computer: 'Click connect in your wallet popup',
    },
    /**
     * @description copy keys for Dynamic pending signature, we have overrides for phantom ledger which does not support message signing.
     * @default
     * {
        click_to_sign: 'Click to Sign',
        note: 'Note: ',
        phantom_ledger_sign: "Click sign in your wallet to confirm you own this wallet (this doesn't cost gas).",
        phantom_ledger_warning: "Ledger with Phantom doesn't support message signing. When logging in, a small fee (which should not apply) may appear. See below to learn more.",
        regular_sign_description: 'Click sign-in in your wallet to confirm you own this wallet.',
  }
     */
    dyn_pending_signature: {
        click_to_sign: 'Click to Sign',
        note: 'Note: ',
        phantom_ledger_sign: "Click sign in your wallet to confirm you own this wallet (this doesn't cost gas).",
        phantom_ledger_warning: "Ledger doesn't support message signing. When logging in, a small fee (which should not apply) may appear. See below to learn more.",
        regular_sign_description: 'Click sign-in in your wallet to confirm you own this wallet.',
    },
    /**
     * @description copy keys for Dynamic QR code Wallet Connection Pop-Up
     * @default
     * {
        copy_button: 'Copy QR URI',
        get_extension_button: 'Get extension',
        open_button: 'Open App',
        scan_title: "Scan this QR code from your mobile {{app}} or phone's camera to connect.",
        wallet_not_installed: {
          browser_install: 'Install {{browser}} extension',
          install: 'Install {{wallet}} extension to connect',
          refresh: 'Refresh the page once installed',
          select: 'Select from your preferred options below:',
        },
      }
     */
    dyn_qr_code: {
        copy_button: 'Copy QR URI',
        get_extension_button: 'Get Extension',
        open_button: 'Open App',
        scan_title: "Scan this QR code from your mobile {{app}} or phone's camera to connect.",
        wallet_not_installed: {
            browser_install: 'Install {{browser}} extension',
            install: 'Install {{wallet}} extension to connect',
            refresh: 'Refresh the page once installed',
            select: 'Select from your preferred options below:',
        },
    },
    /**
     * @description copy keys for Dynamic wallet locked/disconnected
     * @default
     * {
        connect_continue: 'Connect your wallet to continue',
        title: 'Welcome back',
        subtitle: "We couldn't connect to your wallet. Click connect to retry the connection ",
        connect: 'Connect wallet',
        logout: 'Log out',
      }
     */
    dyn_wallet_locked: {
        connect_continue: 'Connect your wallet to continue',
        title: 'Welcome back',
        subtitle: "We couldn't connect to your wallet. Click connect to retry the connection ",
        connect: 'Connect wallet',
        logout: 'Log out',
    },
    /**
   * @description copy keys for passkeys creation flow for existent embedded wallets
   * @default
   * {
      code: {
        action_based_description: 'To {{action}} verify account.',
        description: 'A secure code has been sent to {{email}}.',
        input_label: 'Enter your code here...',
        title: 'Verification code sent',
        resend: {
          button: 'Resend code',
          text: "Didn't receive a code?",
        },
        complete_transaction_action: 'complete transaction',
        sign_message_action: 'sign this message',
      },
      complete: {
        complete_button: 'Create a passkey',
        description:
          'Passkeys are stored natively to your device with a biometric and can only be accessed by you.',
        title: 'Secure your account',
      },
      start: {
        description:
          'A one-time security code will be sent to the email on file. It will expire in 15 minutes.',
        start_button: 'Send me an email',
        title: 'Send Email Code',
      },
    }
   */
    dyn_passkey_secure_modal: {
        code: {
            action_based_description: 'To {{action}} verify account.',
            description: 'A secure code has been sent to {{email}}.',
            input_label: 'Enter your code here...',
            title: 'Verification code sent',
            resend: {
                button: 'Resend code',
                text: "Didn't receive a code?",
            },
            complete_transaction_action: 'complete transaction',
            sign_message_action: 'sign this message',
        },
        complete: {
            complete_button: 'Create a passkey',
            description: 'Passkeys are stored natively to your device with a biometric and can only be accessed by you.',
            title: 'Secure your account',
        },
        start: {
            description: 'A one-time security code will be sent to the email on file. It will expire in 15 minutes.',
            start_button: 'Send me an email',
            title: 'Send Email Code',
        },
    },
    /**
   * @description copy keys for save password view
   * @default
   * {
      badge_text: 'Important!',
      checkbox_label: 'I have safely stored a copy of my passcode.',
      continue: 'Continue',
      copy_button: {
        copy: 'Copy',
        copied: 'Copied',
      },
      description: 'You must retain a copy of this passcode.',
      download_button: 'Download',
      logout: 'Log out',
      password_input: {
        label: 'Passcode',
        placeholder: 'Passcode',
      },
      title: 'Save passcode',
      warning:
        'If you lose your passcode, you cannot recover access to your account.',
    }
   */
    dyn_save_password: {
        badge_text: 'Important!',
        checkbox_label: 'I have safely stored a copy of my passcode.',
        continue: 'Continue',
        copy_button: {
            copy: 'Copy',
            copied: 'Copied',
        },
        description: 'You must retain a copy of this passcode.',
        download_button: 'Download',
        logout: 'Log out',
        password_input: {
            label: 'Passcode',
            placeholder: 'Passcode',
        },
        title: 'Save passcode',
        warning: 'If you lose your passcode, you cannot recover access to your account.',
    },
    /**
   * @description copy keys for secure pregenerated embedded wallet
   * @default
   * {
      description: 'Make transactions simpler and more secure.',
      action: 'Get started'
   }
   */
    dyn_secure_pregenerated_wallet: {
        description: 'Make transactions simpler and more secure.',
        action: 'Get started',
    },
    /**
   * @description copy keys for send transaction flow views
   * @default
   * {
      confirmation: {
        cancel_button: 'Cancel',
        confirm_button: 'Confirm',
        data: {
          amount: 'Amount',
          from: 'From (You)',
          gas: 'Gas',
          gas_estimate: 'Network Fee',
          to: 'To',
          total: 'Total',
        },
        not_applied: 'N/A',
        title: 'Confirm transaction',
      },
      data: {
        amount: {
          label: 'Amount',
          placeholder: 'Select amount',
        },
        balance: {
          label: 'Balance:',
        },
        from: 'Send from',
        recipient: {
          label: 'Recipient',
          placeholder: 'Enter wallet address...',
        },
      },
      multiple_recipients: 'Multiple',
      send_button: 'Send now',
      succeeded: {
        continue_button: 'Continue',
        network: {
          label: 'Network',
        },
        recipient: {
          label: 'Recipient',
        },
        title: 'Transaction successfully sent',
        total_amount: {
          label: 'Total amount',
        },
      },
      validation: {
        amount: {
          invalid_decimals: 'Please enter a value up to the {{decimals}}th decimal place.',
          invalid_format: 'The amount is in invalid format',
          over_balance: 'Insufficient funds to send this amount.',
          required: 'The amount field is required',
        },
        recipient: {
          invalid_format: 'The address is in invalid format',
          required: 'The recipient is required',
        },
      },
      warning_message: {
        insufficient_funds: 'Insufficient funds due to gas price increase from estimate. Please add {{amountLeft}} {{currencySymbol}} to continue.',
      },
      error_message: {
        gas_not_sponsored: 'The gas fee has increased. Confirm if you still want to complete this transaction.',
      },
    }
   */
    dyn_send_transaction: {
        confirmation: {
            cancel_button: 'Cancel',
            confirm_button: 'Confirm',
            send: 'Confirm',
            data: {
                amount: 'Amount',
                from: 'From (You)',
                gas: 'Gas',
                gas_estimate: 'Network Fee',
                to: 'To',
                total: 'Total',
                wallet_used: 'Wallet used',
                network: 'Network',
                recipient: 'Recipient',
                destination: 'Interacting with',
                gas_tooltip: 'Gas fees are charged by the network and can change quickly based on usage.',
                sending: 'Sending',
                receiving: 'Receiving',
                transfer: {
                    send: 'Send',
                    receive: 'Receive',
                },
            },
            not_applied: 'N/A',
            title: 'Confirm transaction',
        },
        data: {
            amount: {
                label: 'Amount',
                placeholder: 'Enter amount',
            },
            balance: {
                label: 'Balance:',
            },
            from: 'Send from',
            send: 'Send',
            send_preview: 'Send Preview',
            confirmation_tx: 'Confirm Transaction',
            banner: "You're nearly done! Confirm transaction to proceed.",
            recipient: {
                label: 'Address',
                placeholder: 'Enter wallet address...',
            },
        },
        multiple_recipients: 'Multiple',
        preview_transaction: 'Preview transaction',
        send_button: 'Send now',
        succeeded: {
            continue_button: 'Done',
            network: {
                label: 'Network',
            },
            recipient: {
                label: 'Recipient',
            },
            title: 'Transaction successfully sent to',
            total_amount: {
                label: 'Total amount',
            },
        },
        validation: {
            amount: {
                invalid_decimals: 'Please enter a value up to the {{decimals}}th decimal place.',
                invalid_format: 'The amount is in invalid format',
                over_balance: 'Insufficient funds to send this amount.',
                required: 'The amount field is required',
            },
            recipient: {
                invalid_format: 'The address is in invalid format',
                required: 'The recipient is required',
            },
        },
        info_message: {
            refresh_balance_time: 'Your balance may take up to 30s to refresh.',
        },
        warning_message: {
            insufficient_funds: {
                title: 'Insufficient funds',
                description: 'Insufficient funds for transaction. Please add {{amountLeft}} {{currencySymbol}} to continue.',
            },
            insufficient_gas_funds: {
                title: 'Insufficient gas funds',
                description: 'Please add {{amountLeft}} {{currencySymbol}} to continue.',
            },
            failed_simulation: {
                title: 'Transaction expected to fail',
                description: 'Something went wrong. Check your balances and try again.',
            },
        },
        error_message: {
            gas_not_sponsored: 'The gas fee has increased. Confirm if you still want to complete this transaction.',
        },
    },
    /**
   * @description copy keys for Select Chain view
   * @default
   * {
      description: "This wallet supports multiple chains. Select which chain you'd like to connect to",
      using_hardware_wallet_toggle_label: 'Using Ledger',
    }
   */
    dyn_select_chain: {
        description: "This wallet supports multiple chains. Select which chain you'd like to connect to",
        using_hardware_wallet_toggle_label: 'Using Ledger',
    },
    /**
   * @description copy keys for Select Wallet view
   * @default
   * {
      description: "This wallet supports multiple chains. Select which chain you'd like to connect to",
      using_hardware_wallet_toggle_label: 'Using Ledger with {{chainName}}',
    }
   */
    dyn_select_wallet: {
        description: 'Select your preferred {{walletName}} wallet?',
    },
    /**
   * @description copy keys for Select Chain view
   * @default
   * {
      title: "Connect",
      description:
        "This wallet supports using ledger. Toggle on ledger to enable it.",
      using_hardware_wallet_toggle_label: "Using Ledger with {{chainName}}",
      button: "Connect",
    }
   */
    dyn_select_hardware_wallet: {
        title: 'Connect',
        description: 'This wallet supports using ledger. Toggle on ledger to enable it.',
        using_hardware_wallet_toggle_label: 'Using Ledger with {{chainName}}',
        button: 'Connect',
    },
    /**
   * @description copy keys for sign message flow views
   * @default
   * {
      cancel_button: 'Cancel',
      sign_button: 'Sign',
      title: 'Requesting Signature',
    }
   */
    dyn_sign_message: {
        cancel_button: 'Cancel',
        sign_button: 'Sign',
        title: 'パスポートを作成するために、保存ボタンをクリックしてください',
    },
    /**
   * @description copy keys for social redirect view
   * @default
   * {
      logging_in: 'Logging you in',
    }
   */
    dyn_social_redirect: {
        logging_in: 'Logging you in',
    },
    /**
   * @description copy keys for wallet redirect view
   * @default
   * {
      loading: 'Loading...',
    }
   */
    dyn_wallet_redirect: {
        loading: 'Loading...',
    },
    /**
   * @description copy keys for messages related to time since a date
   * @default
   * {
      second: 'second',
      seconds: 'seconds',
      minute: 'minute',
      minutes: 'minutes',
      hour: 'hour',
      hours: 'hours',
      day: 'day',
      days: 'days',
      month: 'month',
      months: 'months',
      year: 'year',
      years: 'years',
      ago: 'ago',
      created: 'Created',
   }
   */
    dyn_time_since: {
        second: 'second',
        seconds: 'seconds',
        minute: 'minute',
        minutes: 'minutes',
        hour: 'hour',
        hours: 'hours',
        day: 'day',
        days: 'days',
        month: 'month',
        months: 'months',
        year: 'year',
        years: 'years',
        ago: 'ago',
        created: 'Created',
    },
    /**
   * @description copy keys for connecting wallets view
   * @default
   * {
      mobile: {
        wallet_list: {
          helper: 'Get your first wallet',
          title: 'WalletConnect wallets',
        },
      },
    }
   */
    dyn_wallet_conect: {
        mobile: {
            wallet_list: {
                helper: 'Get your first wallet',
                title: 'WalletConnect wallets',
            },
        },
    },
    /**
   * @description copy keys for linking wallets to profile view
   * @default
   * {
      cannot_link: {
        cancel_button: 'Cancel',
        description: 'This wallet is the only wallet in your other account. You cannot transfer it, since then you will lose access to that account.',
        link_other_button: 'Link a different wallet',
        title: 'Cannot link this wallet to a new account',
      },
      confirm_button: 'Link wallet to current account',
      existent_account: {
        acceptance: 'I understand that linking this wallet means that I will lose access to the other account.',
        warning: 'Linking your wallet to this account will unlink it from its previously associated account',
      },
      log_out_button: 'Log out',
      title: 'Transfer this wallet?'
    }
   */
    dyn_wallet_link: {
        cannot_link: {
            cancel_button: 'Cancel',
            description: 'This wallet is the only wallet in your other account. You cannot transfer it, since then you will lose access to that account.',
            link_other_button: 'Link a different wallet',
            title: 'Cannot link this wallet to a new account',
        },
        confirm_button: 'Link wallet to current account',
        existent_account: {
            acceptance: 'I understand that linking this wallet means that I will lose access to the other account.',
            warning: 'Linking your wallet to this account will unlink it from its previously associated account',
        },
        log_out_button: 'Log out',
        title: 'Transfer this wallet?',
        already_exists: {
            title: 'Wallet Already Linked',
            description: 'This wallet is already used as an embedded wallet. You cannot link it unless you delete the existing embedded wallet.',
        },
    },
    /**
   * @description copy keys for connecting wallets list view
   * @default
   * {
      configuration_mismatch: 'Oops, no login methods have been configured.',
      helper: 'Get your first wallet',
      search: {
        label: 'Search through {{numberOfWallets}} wallets...',
        not_found: {
          description: 'The wallet you’re looking for may not be available, or linking more than one of these wallets might not be possible.',
          title: 'Wallet not available',
        },
      },
      title: {
        connect: 'Connect a new wallet',
        link: 'Link a new wallet',
        select: 'Select your wallet',
      },
      view_all: 'View all wallets',
      wallet_missing: {
        description: 'Try search instead',
        title: "Don't see your wallet?",
      },
    }
   */
    dyn_wallet_list: {
        configuration_mismatch: 'Oops, no login methods have been configured.',
        helper: 'Get your first wallet',
        search: {
            label: 'Search through {{numberOfWallets}} wallets...',
            not_found: {
                description: 'The wallet you’re looking for may not be available, or linking more than one of these wallets might not be possible.',
                title: 'Wallet not available',
            },
        },
        title: {
            connect: 'Connect a new wallet',
            link: 'Link a new wallet',
            select: 'Select your wallet',
        },
        view_all: 'View all wallets',
        wallet_missing: {
            description: 'Try search instead',
            title: "Don't see your wallet?",
        },
    },
    /**
   * @description copy keys for transferring wallets between accounts view
   * @default
   * {
      sign: {
        spinner: {
          cancel: 'Cancel',
          confirm_transfer:
          'Sign the message to confirm transferring this wallet to this account.',
        },
        title: 'Sign to confirm transfer',
      },
    }
   */
    dyn_wallet_transfer: {
        sign: {
            spinner: {
                cancel: 'Cancel',
                confirm_transfer: 'Sign the message to confirm transferring this wallet to this account.',
            },
            title: 'Sign to confirm transfer',
        },
    },
    /**
   * @description copy keys for Dynamic widget
   * @default
   * {
      connect: 'Log in or sign up',
      empty_wallets: '{{action}} additional wallets to see them here.',
      other_wallets: 'My other wallets',
    }
   */
    dyn_widget: {
        connect: 'サインイン/会員登録',
        empty_wallets: '{{action}} additional wallets to see them here.',
        other_wallets: 'My other wallets',
        empty_wallets_action_link: 'Link',
        empty_wallets_action_connect: 'Connect',
    },
    /**
   * @description copy keys for Dynamic wallet information card
   * @default
   * {
      balance: 'Balance'
    }
   */
    dyn_wallet_information: {
        balance: 'Balance',
        multi_asset: {
            empty_state: 'No assets in this wallet',
        },
    },
    /**
   * @description copy keys for Unlink wallet prompt
   * @default
   * {
      disconnect_title: 'Disconnect your wallet?',
      unlink_title: 'Unlink your wallet?',
      disconnect_description: 'Are you sure you want to disconnect your wallet?',
      unlink_description: 'Are you sure you want to unlink your wallet?',
      disconnect_button: 'Yes, disconnect',
      unlink_button: 'Yes, unlink',
      cancel_button: 'No',
    }
   */
    dyn_unlink_wallet_pop_up: {
        disconnect_title: 'Disconnect your wallet?',
        unlink_title: 'Unlink your wallet?',
        disconnect_description: 'Are you sure you want to disconnect your wallet?',
        unlink_description: 'Are you sure you want to unlink your wallet?',
        disconnect_button: 'Yes, disconnect',
        unlink_button: 'Yes, unlink',
        cancel_button: 'No',
    },
    /**
   * @description copy keys for the user profile widget
   * @default
   * {
      my_information: {
        title: 'My information',
      },
      my_wallet: {
        title: 'My wallet',
      },
      social_accounts: {
        title: 'Social accounts',
      },
      tooltips: {
        verified_email: 'This email is verified',
        verified_phone: 'This phone number is verified',
      },
      wallets: {
        link_wallet_button: 'Link wallet',
        title: 'Wallets',
      },
    }
   */
    dyn_user_profile: {
        my_information: {
            title: 'アカウント情報',
        },
        my_wallet: {
            title: 'ウォレット',
        },
        social_accounts: {
            title: 'ソーシャルアカウント',
        },
        tooltips: {
            verified_email: 'This email is verified',
            verified_phone: 'This phone number is verified',
        },
        wallets: {
            link_wallet_button: 'Link wallet',
            title: 'Want to add a wallet?',
        },
        edit_profile_button: 'Edit Profile',
    },
    /**
   * @description copy keys for Dynamic subdomain field
   * @default
   * {
      label: 'Subdomain Handle',
      available: 'Subdomain is available',
      not_available: 'Subdomain is not available',
      error: 'Subdomain check failed',
      details:
        'A subdomain handle will create a unique ENS subdomain for your wallet, helping you easily share and identify it.',
    }
   */
    dyn_subdomain_field: {
        label: 'Subdomain Handle',
        available: 'Subdomain is available',
        not_available: 'Subdomain is not available',
        error: 'Subdomain check failed',
        details: 'A subdomain handle will create a unique ENS subdomain for your wallet, helping you easily share and identify it.',
    },
    /**
   * @description copy keys for Detected new wallet prompt
   * @default
   * {
      title: 'Account Change Detected',
      description: 'Your active account in {{walletName}} has changed. This account is not currently linked to this app. Do you want to add it?',
      confirm_button: 'Yes, link this wallet',
    }
   */
    dyn_detected_new_wallet: {
        title: 'Account Change Detected',
        description: 'Your active account in {{walletName}} has changed. This account is not currently linked to this app. Do you want to add it?',
        confirm_button: 'Yes, link this wallet',
    },
    /**
     * @description copy keys for sync wallet view
     * @default
     * {
        switch_wallet: {
          title: 'Your wallets are mismatched. \nSwitch to continue.',
          active_address: {
            heading: 'Currently active in wallet',
          },
          expected_address: {
            heading: 'Currently active on website',
            prompt: 'Manually switch to this wallet',
          },
        },
        reconnecting: {
          title: 'This wallet is not connected',
          description: 'Reconnecting wallet {{walletAddress}} to make it active...',
        },
        reconnect_with_qr_code: {
          title: 'This wallet is not connected',
        },
        cancel_button: 'Cancel',
        retry_button: 'Retry',
      }
    */
    dyn_sync_wallet: {
        switch_wallet: {
            title: 'Your wallets are mismatched. \nSwitch to continue.',
            active_address: {
                heading: 'Currently active in wallet',
            },
            expected_address: {
                heading: 'Currently active on website',
                prompt: 'Manually switch to this wallet',
            },
        },
        reconnecting: {
            title: 'This wallet is not connected',
            description: 'Reconnecting wallet {{walletAddress}} to make it active...',
        },
        reconnect_with_qr_code: {
            title: 'This wallet is not connected',
        },
        cancel_button: 'Cancel',
        retry_button: 'Retry',
    },
    /**
   * @description copy keys for the wallet funding flow
   * @default
   * {
      success: 'Transaction processing',
      success_txn_link: 'View transaction',

      funding_method_selection: {
        title: 'Deposit',
        qr_option: 'Receive by QR',
        buy_option: 'Buy Crypto',
        external_wallet_option: 'From External Wallets',
      },
      onramp_provider_selection: {
        title: 'Select provider',
        description: 'Select from a list of available onramp providers.',
      },
      from_external_wallet: {
        wallet_list: {
          title: 'Fund from Wallet',
        },
        funding_view: {
          title: 'Fund from Wallet',
          wallet_detail_from: 'From',
          confirm_button: 'Confirm Transaction',
          pricing_unavailable:
            'Pricing unavailable.',
          minimum_error: 'Minimum {{minimum}}',
          balance_error: 'Insufficient funds',
        },
        token_select: {
          title: 'Select a Token',
          search_placeholder: 'Search for a token',
          no_assets_title: 'No Supported Assets',
          no_assets_description: 'This wallet does not support any assets',
        },
      },
    }
   */
    dyn_wallet_funding: {
        success: 'Transaction processing',
        success_txn_link: 'View transaction',
        funding_method_selection: {
            title: 'Deposit',
            qr_option: 'Receive by QR',
            buy_option: 'Buy Crypto',
            external_wallet_option: 'From External Wallets',
        },
        onramp_provider_selection: {
            title: 'Select provider',
            description: 'Select from a list of available onramp providers.',
        },
        from_external_wallet: {
            wallet_list: {
                title: 'Fund from External Wallet',
            },
            funding_view: {
                title: 'Fund from External Wallet',
                wallet_detail_from: 'From',
                confirm_button: 'Confirm Transaction',
                pricing_unavailable: 'Pricing unavailable.',
                minimum_error: 'Minimum {{minimum}}',
                balance_error: 'Insufficient funds',
            },
            token_select: {
                title: 'Select a Token',
                search_placeholder: 'Search for a token',
                no_assets_title: 'No Supported Assets',
                no_assets_description: 'No supported assets in this wallet',
            },
        },
    },
    /**
   * @description copy keys for Dynamic widget header
   * @default
   * {
      buttons: {
        deposit_funds: 'Deposit',
        send_funds: 'Send',
        more: 'More',
      },
    }
   */
    dyn_widget_header: {
        buttons: {
            deposit_funds: 'Deposit',
            send_funds: 'Send',
            more: 'More',
        },
    },
};

const English = {
    en: en,
};
const Japanese = {
    /**
     * Dynamic says...
     * > We just support “en” for now, so that will be the only valid key for the LocaleResource object.
     * > https://docs.dynamic.xyz/guides/customizing-copy
     * So, it needs to assign Japanese translation as English.
     */
    en: ja,
};

const one = `.dynamic-widget-modal .popper-content .dots-menu-dropdown__container .dots-menu-dropdown__item:first-child .typography`;
const two = `.dynamic-widget-modal .popper-content .dots-menu-dropdown__container .dots-menu-dropdown__item:last-child .typography`;
const xxx = `.balance-container > .typography:first-child`;
var cssOverrides = (lang) => `
.dynamic-widget-header .dynamic-widget-wallet-header .dynamic-widget-wallet-header__wallet-actions {
  display: none;
}

${one} {
  visibility: hidden;
  width: ${lang === 'ja' ? '18ch' : '12ch'};
  overflow: clip;
}
${lang === 'ja'
    ? `
    ${one}::before {
      content: 'ユーザーIDをコピー';
      visibility: visible;
    }
      `
    : `
      ${one}::before {
        content: 'Copy user ID';
        visibility: visible;
      }
    `}

${two} {
  visibility: hidden;
  width: ${lang === 'ja' ? '16ch' : '17ch'};
  overflow: clip;
}
${lang === 'ja'
    ? `
    ${two}::before {
      content: 'セキュリティ設定';
      visibility: visible;
    }
      `
    : `
      ${two}::before {
        content: 'Security settings';
        visibility: visible;
      }
    `}

${xxx} {
  visibility: hidden;
  width: ${lang === 'ja' ? '6ch' : '4ch'};
  overflow: clip;
  text-wrap: nowrap;
}
${lang === 'ja'
    ? `
    ${xxx}::before {
      content: 'コイン';
      visibility: visible;
    }
      `
    : `
      ${xxx}::before {
        content: 'Coin';
        visibility: visible;
      }
    `}
 `;

const langs = ['en', 'ja'];
var ConnectButton = ({ chainId, environmentId, dynamicSettings, ...props }) => {
    const [locale, setLocale] = useState(null);
    useEffect(() => {
        // eslint-disable-next-line functional/no-conditional-statements
        if (typeof window !== 'undefined') {
            const loc = window.navigator.languages.find((l) => langs.includes(l));
            setLocale(loc === 'ja'
                ? { lang: 'ja', dic: Japanese }
                : { lang: 'en', dic: English });
        }
    }, []);
    const polygonUrl = useMemo(() => dynamicSettings?.rpcUrl?.find((x) => x.chain === 137), [dynamicSettings?.rpcUrl]);
    return locale !== null ? (jsxRuntimeExports.jsx(DynamicContextProvider, { settings: {
            environmentId,
            walletConnectPreferredChains: [`eip155:${chainId ?? 137}`],
            walletConnectors: [EthereumWalletConnectors],
            cssOverrides: cssOverrides(locale?.lang),
            social: dynamicSettings?.social ?? { strategy: 'redirect' },
            overrides: whenDefined(polygonUrl, (pol) => ({
                evmNetworks: (networks) => overrideNetworkRpcUrl(networks, { '137': [pol.url] }),
            })),
        }, locale: locale?.dic, children: jsxRuntimeExports.jsx(Button, { chainId: chainId, ...props }) })) : (jsxRuntimeExports.jsx("div", { className: "min-h-10 min-w-32 animate-pulse rounded-xl bg-black/10" }));
};

const BrowserConnectButton = (props) => {
    return jsxRuntimeExports.jsx(ConnectButton, { ...props });
};

export { BaseError$1 as B, DEFAULT_JWK_MEMBER_BYTE_LENGTH as D, Field$1 as F, HttpRequestError as H, uint8ArrayFromHexString as a, createHash as b, createCurve as c, stringify$1 as d, decodeErrorResult as e, call as f, getUrl as g, hexStringToBase64url as h, isAddressEqual as i, concat$1 as j, encodeAbiParameters as k, isHex$2 as l, requireDijkstra as m, getDefaultExportFromCjs as n, BrowserConnectButton as o, requireEncodeUtf8 as r, sha256$2 as s, uint8ArrayToHexString as u };
